/* Rova, progressive enhancement. Forms work without JS; this makes like and
   follow instant via fetch. CSP is script-src 'self', so no inline handlers. */
/* THE PAGE IS LIVE: CSS transitions on (2026-09-30, load stability). rova.css holds every transition at
   `none` until html.rova-live, because WebKit started load-time transitions on the header's and the media
   ring's margins (style resolved once before the sheet applied -> the margins "grew" over .55s after first
   paint: Rob's "small bounce as the elements load in"). Two frames from here a style pass has certainly run
   with the sheet, so turning transitions on changes no value and starts nothing. Its own statement, ahead
   of the main IIFE, so no throw anywhere below can leave the site without transitions. */
(function () {
  var d = document.documentElement;
  function live() { d.classList.add('rova-live'); }
  try { requestAnimationFrame(function () { requestAnimationFrame(live); }); } catch (e) { live(); }
})();
/* THE MEDIA RING'S SIDEWAYS SCROLL IS ITS OWN (2026-10-12, Rob on a Mac, Safari + Magic Mouse: "scrolling the media ring
   left/right isn't smooth and stutters a little", worst swiping BACK toward Go Live). Measured: every scroll event of the
   ring's track (.mring-track, overflow-x) also reached the page's CAPTURE-phase scroll listeners, which are about the
   page moving vertically -- html.tl-scroll flipped on/off per swipe (a whole-document style pass each way), and the
   card autoplay + recycle pass and the grid pager's bottom check ran a rAF per frame, all for a scroll that moves no
   card. __rovaRingScroll(e) is the one test those listeners use to step aside (an event whose target is inside the
   ring's track: its scroll, or a touchmove on a circle). While the track moves, `.mring-moving` on the row holds the
   ring's own infinite animations (the Go Live pulse, the live rings, the live dot; rova.css) so no animated layer is
   re-rastered under a moving scroller, and __rovaRingScrollAt lets the live-thumbnail refresh wait for the rest
   instead of decoding + swapping a frame mid-swipe. One self-checking timer per swipe, nothing per frame. */
(function () {
  function inRing(t) { return !!(t && t.nodeType === 1 && t.closest && t.closest('.mring-track')); }
  window.__rovaRingScroll = function (e) { return !!(e && inRing(e.target)); };
  var row = null, tm = null;
  function rest() {
    var left = 250 - (Date.now() - window.__rovaRingScrollAt);
    if (left > 8) { tm = setTimeout(rest, left); return; }
    tm = null;
    if (row) { row.classList.remove('mring-moving'); row = null; }
  }
  window.__rovaRingScrollAt = 0;
  window.addEventListener('scroll', function (e) {
    var t = e.target;
    if (!t || t.nodeType !== 1 || !t.classList || !t.classList.contains('mring-track')) return;
    window.__rovaRingScrollAt = Date.now();
    if (!row) { row = t.parentNode; if (row && row.classList) row.classList.add('mring-moving'); }
    if (!tm) tm = setTimeout(rest, 250);
  }, { passive: true, capture: true });
})();
/* THEME-COLOR FOLLOWS THE SITE THEME, NOT THE OS (2026-10-03, Rob, desktop Safari light: lines under the
   tab bar). lib/view.php ships two <meta name="theme-color"> keyed on prefers-color-scheme -- the OS
   setting -- but the site theme is the rova_theme cookie (THEME_BOOT; default dark), so an OS-light Mac
   on the dark site, or an OS-dark Mac on the light site, got Safari's tab bar tinted for the WRONG theme.
   The head stays byte-constant (edge cache), so the fix is here: write this theme's --theme-color
   (rova.css, per theme block) into BOTH metas -- whichever one the OS media query selects then carries
   the right colour. Runs once now and again from setTheme() on every toggle. Safari re-reads the meta
   live. Its own statement, like the one above, so nothing in the main IIFE can stop it. */
(function () {
  function sync() {
    try {
      var d = document.documentElement;
      var c = (getComputedStyle(d).getPropertyValue('--theme-color') || '').trim();
      if (!c) c = d.getAttribute('data-theme') === 'light' ? '#f4f3ef' : '#0d0c09';
      var ms = document.querySelectorAll('meta[name="theme-color"]');
      for (var i = 0; i < ms.length; i++) if (ms[i].getAttribute('content') !== c) ms[i].setAttribute('content', c);
    } catch (e) {}
  }
  window.__rovaSyncThemeColor = sync;
  sync();
})();
/* ---- SIGNED VIDEO LINKS: WEB RENEWAL (2026-10-15) ---------------------------------------------------------------------------
   Cloudflare Stream URLs on this site may carry a per-viewer token in place of the video/input uid
   (https://customer-x.cloudflarestream.com/<JWT>/manifest/video.m3u8). Once Cloudflare enforces signatures, an EXPIRED token is
   refused with 401 (Cloudflare's code; 403 treated the same). The players used to read their URL once, so this module keeps them
   fed, all in one place (window.__rovaCf):
     note(url)        remember the freshest token per uid (+ per downloadable kind: an MP4 needs a downloadable token)
     fresh(url)       the same URL carrying the freshest token we hold
     reg(uid, fn)     who can re-read a uid: the live watch poll, or GET /media/renew?p=<post> for a replay (renewer returns a Promise)
     renew(uid)       ask it (deduped, >= 10 s apart)
   hls.js (every instance on every page): Hls.DefaultConfig gets an xhrSetup that re-tokens EVERY playlist/segment request with
   fresh(url) -- position is never touched -- and a loader that, on a 401/403, renews once and retries the same request.
   <video src> (progressive MP4, Safari's native HLS): a 20 s sweep swaps the source to the fresh token ~90 s before expiry (keeping
   the position: replays) and on a media error once. The live watch page does its own native-HLS swap at the live edge (liveWatch).
   Cookie rova_rn=1 tells the server this browser renews (Live::signedLane: the web renewal lane, only where k/v allows it).
   Nothing here does anything for a plain (unsigned) URL. */
(function () {
  var RX = /^(https:\/\/customer-[a-z0-9]+\.cloudflarestream\.com\/)([^\/?#]+)(.*)$/;
  var toks = {}, renewers = {}, inflight = {}, lastAsk = {};
  function b64d(s) { s = String(s).replace(/-/g, '+').replace(/_/g, '/'); while (s.length % 4) s += '='; return atob(s); }
  function claims(seg) {
    var p = String(seg || '').split('.'); if (p.length !== 3) return null;
    try { var c = JSON.parse(b64d(p[1])); return c && c.sub ? c : null; } catch (e) { return null; }
  }
  function parse(url) { var m = RX.exec(url || ''); if (!m) return null; var c = claims(m[2]); return { m: m, c: c, uid: c ? c.sub : (/^[0-9a-f]{32}$/.test(m[2]) ? m[2] : '') }; }
  function note(url) {
    var p = parse(url); if (!p || !p.c || !p.c.exp) return null;
    var k = p.c.sub + (p.c.downloadable ? ':d' : ''), exp = p.c.exp * 1000;
    if (!toks[k] || toks[k].exp < exp) toks[k] = { t: p.m[2], exp: exp };
    return { uid: p.c.sub, exp: exp };
  }
  function fresh(url) {
    var p = parse(url); if (!p || !p.c) return url;
    var f = toks[p.c.sub + (p.c.downloadable ? ':d' : '')];
    return f && f.t !== p.m[2] && f.exp > (p.c.exp || 0) * 1000 ? p.m[1] + f.t + p.m[3] : url;
  }
  function expOf(url) { var p = parse(url); return p && p.c && p.c.exp ? p.c.exp * 1000 : 0; }
  function reg(uid, fn) { if (uid && typeof fn === 'function') renewers[uid] = fn; }
  function renew(uid) {
    if (!uid || !renewers[uid]) return Promise.reject(new Error('no renewer'));
    if (inflight[uid]) return inflight[uid];
    var now = Date.now();
    if (lastAsk[uid] && now - lastAsk[uid] < 10000) return Promise.resolve();
    lastAsk[uid] = now;
    var pr;
    try { pr = Promise.resolve(renewers[uid]()); } catch (e) { pr = Promise.reject(e); }
    inflight[uid] = pr.then(function (x) { inflight[uid] = null; return x; }, function (e) { inflight[uid] = null; throw e; });
    return inflight[uid];
  }
  var cf = window.__rovaCf = { note: note, fresh: fresh, reg: reg, renew: renew, expOf: expOf, uidOf: function (u) { var p = parse(u); return p ? p.uid : ''; },
                               dbg: { swaps: 0, retries: 0, renews: 0, rewrites: 0 } };
  try { document.cookie = 'rova_rn=1; path=/; max-age=31536000; samesite=lax' + (location.protocol === 'https:' ? '; secure' : ''); } catch (e) {}

  /* ---- hls.js: re-token every request, retry a 401/403 once after a renew ---- */
  function patchHls(H) {
    try {
      if (!H || H.__rvCf || !H.DefaultConfig || typeof Reflect === 'undefined' || !Reflect.construct) return;
      H.__rvCf = 1;
      var prev = H.DefaultConfig.xhrSetup;
      H.DefaultConfig.xhrSetup = function (xhr, url) {
        var u = fresh(url);
        if (u !== url) { cf.dbg.rewrites++; xhr.open('GET', u, true); }
        if (prev) return prev(xhr, u);
      };
      var Base = H.DefaultConfig.loader;
      if (typeof Base !== 'function') return;
      var Rv = function (cfg) { var o = Reflect.construct(Base, [cfg], Rv); o.__rvCfg = cfg; return o; };
      Rv.prototype = Object.create(Base.prototype); Rv.prototype.constructor = Rv;
      Rv.prototype.load = function (ctx, lcfg, cbs) {
        var self = this, onErr = cbs.onError, wrapped = {};
        for (var k in cbs) wrapped[k] = cbs[k];
        wrapped.onError = function (err, c, nd, st) {
          var code = err && err.code, p = parse(ctx && ctx.url);
          if ((code === 401 || code === 403) && p && p.uid && renewers[p.uid] && !ctx.__rvRetry && !self.__rvGone) {
            ctx.__rvRetry = 1; cf.dbg.retries++;
            renew(p.uid).then(function () {
              if (self.__rvGone) return;
              ctx.url = fresh(ctx.url);
              var l2 = Reflect.construct(Base, [self.__rvCfg], Base); self.__rvL2 = l2;
              l2.load(ctx, lcfg, cbs);
            }, function () { if (!self.__rvGone) onErr(err, c, nd, st); });
            return;
          }
          /* a VOD segment named by Cloudflare's own token (no uid to re-token): find this loader's player, renew its uid and
             re-load its manifest at the same position (hlsReload); the old load is dropped by loadSource's stopLoad. */
          if ((code === 401 || code === 403) && p && !p.uid && !ctx.__rvRetry && !self.__rvGone) {
            var vs = document.querySelectorAll('video'), pv = null;
            for (var i = 0; i < vs.length; i++) { if (vs[i]._hls && vs[i]._hls.config === self.__rvCfg) { pv = vs[i]; break; } }
            var pu = pv ? cf.uidOf(pv._hls.url || '') : '';
            if (pv && pu && renewers[pu]) {
              ctx.__rvRetry = 1; cf.dbg.retries++;
              renew(pu).then(function () { if (!hlsReload(pv)) onErr(err, c, nd, st); }, function () { onErr(err, c, nd, st); });
              return;
            }
          }
          onErr(err, c, nd, st);
        };
        return Base.prototype.load.call(this, ctx, lcfg, wrapped);
      };
      Rv.prototype.abort = function () { if (this.__rvL2) { try { this.__rvL2.abort(); } catch (e) {} } return Base.prototype.abort.call(this); };
      Rv.prototype.destroy = function () { this.__rvGone = 1; if (this.__rvL2) { try { this.__rvL2.destroy(); } catch (e) {} } return Base.prototype.destroy.call(this); };
      H.DefaultConfig.loader = Rv;
    } catch (e) {}
  }
  try {
    if (window.Hls) { patchHls(window.Hls); }
    else {
      var hv;
      Object.defineProperty(window, 'Hls', { configurable: true, enumerable: true,
        get: function () { return hv; }, set: function (v) { hv = v; patchHls(v); } });
    }
  } catch (e) {}

  /* ---- replays: who renews a uid (GET /media/renew?p=<post>), and the <video src> sweep ---- */
  function postRenewer(pid) {
    return function () {
      cf.dbg.renews++;
      return fetch('/media/renew?p=' + pid, { credentials: 'same-origin', headers: { 'Accept': 'application/json' }, cache: 'no-store' })
        .then(function (r) { if (!r.ok) throw new Error('renew ' + r.status); return r.json(); })
        .then(function (j) { (j && j.media || []).forEach(function (m) { note(m.src); note(m.hls); }); return j; });
    };
  }
  var ATTRS = ['src', 'data-hls', 'data-hls-lo', 'data-remote', 'data-src-full'];
  function scan(v) {
    var art = v.closest ? v.closest('article[data-view], [data-renew-post]') : null;
    var pid = art ? (+art.getAttribute('data-view') || +art.getAttribute('data-renew-post') || 0) : 0;
    var uid = '';
    for (var i = 0; i < ATTRS.length; i++) {
      var a = v.getAttribute(ATTRS[i]); if (!a || a.indexOf('cloudflarestream.com/') < 0) continue;
      var n = note(a); if (n) { uid = n.uid; if (pid && !renewers[uid]) reg(uid, postRenewer(pid)); }
    }
    return uid;
  }
  function refreshAttrs(v) {
    for (var i = 0; i < ATTRS.length; i++) {
      if (ATTRS[i] === 'src') continue;
      var a = v.getAttribute(ATTRS[i]); if (!a || a.indexOf('cloudflarestream.com/') < 0) continue;
      var f = fresh(a); if (f !== a) v.setAttribute(ATTRS[i], f);
    }
  }
  function swapSrc(v) {   // a <video> playing a token URL directly (MP4 / native HLS): same position, same play state
    var cur = v.getAttribute('src') || ''; var f = fresh(cur);
    refreshAttrs(v);
    if (!cur || f === cur || v.__rvLive) return false;
    var t = 0, playing = !v.paused; try { t = v.currentTime || 0; } catch (e) {}
    cf.dbg.swaps++;
    v.setAttribute('src', f);
    try { v.load(); } catch (e) {}
    if (t > 0.1) { v.addEventListener('loadedmetadata', function () { try { v.currentTime = t; } catch (e) {} }, { once: true }); }
    if (playing) { var pp = v.play(); if (pp && pp.catch) pp.catch(function () {}); }
    return true;
  }
  /* hls.js on a REPLAY (VOD): Cloudflare's variant playlists name their segments with ITS OWN short tokens derived from ours, and a
     VOD playlist is read once, so re-tokening requests is not enough: before our token expires the manifest is re-loaded with the
     fresh one, resuming at the same position (one short re-buffer per token lifetime). */
  function hlsReload(v) {
    var h = v._hls; if (!h || !h.url || !window.Hls || v.__rvLive) return false;
    var f = fresh(h.url); if (f === h.url) return false;
    var t = 0, playing = !v.paused; try { t = v.currentTime || 0; } catch (e) {}
    cf.dbg.reloads = (cf.dbg.reloads || 0) + 1;
    var auto = !(h.config && h.config.autoStartLoad === false);
    try { h.config.startPosition = t; } catch (e) {}
    try {
      h.once(Hls.Events.MANIFEST_PARSED, function () {
        if (!auto) { try { h.startLoad(t); } catch (e) {} }
        if (playing) { var pp = v.play(); if (pp && pp.catch) pp.catch(function () {}); }
      });
      h.loadSource(f);
    } catch (e) { return false; }
    return true;
  }
  function sweep() {
    if (document.hidden) return;
    var vs = document.querySelectorAll('video'), now = Date.now();
    for (var i = 0; i < vs.length; i++) {
      var v = vs[i]; if (v.__rvLive) continue;
      var uid = scan(v); if (!uid) continue;
      var src = v.getAttribute('src') || '', direct = src.indexOf('cloudflarestream.com/') >= 0;
      var exp = expOf(direct ? src : (v._hls && v._hls.url) || v.getAttribute('data-hls') || '');
      if (exp && exp - now < 90000) {
        (function (v, uid, direct) {
          renew(uid).then(function () { if (direct) { swapSrc(v); } else { refreshAttrs(v); hlsReload(v); } }, function () {});
        })(v, uid, direct);
      }
    }
  }
  /* a <video> that errors on a token URL: renew once and re-source in place (Cloudflare's 401 shows up as a media error) */
  document.addEventListener('error', function (e) {
    var v = e.target; if (!v || v.tagName !== 'VIDEO' || v.__rvLive || v.__rvErrTried) return;
    var src = v.getAttribute('src') || ''; if (src.indexOf('cloudflarestream.com/') < 0) return;
    var uid = scan(v); if (!uid || !renewers[uid]) return;
    v.__rvErrTried = 1;
    renew(uid).then(function () { swapSrc(v); }, function () {});
  }, true);
  setInterval(sweep, 20000);
})();
(function () {
  'use strict';

  /* ---- INIT CRASH BEACON -- must be the first thing in the file ------------------------------
     This file is ONE ~17,000-line top-level IIFE. An uncaught throw at its top level aborts the
     whole SCRIPT: every statement below the throw is skipped, and so are the two IIFEs that follow
     it (the immersive pfeed viewer and the trace overlay). Subsystems therefore delete each other
     silently -- there is no error dialog, no server request, nothing in the IIS log, and the page
     just quietly comes up missing whatever was registered after the throw.

     assets/bugreport.js does listen for window errors, but it is a SEPARATE <script defer> that the
     browser runs AFTER this one, so anything that throws while this file is still initialising
     happens before that listener exists -- and even then it is only buffered, and only sent if the
     member happens to file a bug report by hand. The entire init-crash class was invisible, which
     is why a report like "loaded without subheader and sidebar" arrives with no evidence attached.

     So: install a listener as statement #1 and actually SEND it. Reuses the existing
     /compose-trace sink (lib/ctrace.php -- bounded jsonl, size-capped, session-authed,
     kill-switched via the 'ctrace_on' k/v). Capped per page so a throw inside a rAF or scroll loop
     can't flood it. Read via C:\ProgramData\Rova\compose-trace.jsonl, grep ev=js:error. */
  var _beaconsSent = 0;
  function beacon(ev, d) {
    try {
      if (_beaconsSent >= 4) return;
      _beaconsSent++;
      if (document.querySelector('meta[name="rova-guest"]')) return;   // no session to attribute to
      var tok = (document.querySelector('meta[name="csrf-token"]') || {}).content || '';
      if (!tok) return;                                                // edge-cached render: no token
      var body = '_csrf=' + encodeURIComponent(tok) + '&ev=' + encodeURIComponent(ev)
               + '&d=' + encodeURIComponent(JSON.stringify(d || {}));
      if (navigator.sendBeacon) {
        var blob = new Blob([body], { type: 'application/x-www-form-urlencoded' });
        if (navigator.sendBeacon('/compose-trace', blob)) return;
      }
      fetch('/compose-trace', {
        method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body, keepalive: true, credentials: 'same-origin'
      }).catch(function () {});
    } catch (e) {}
  }
  window.__rovaBeacon = beacon;
  window.addEventListener('error', function (e) {
    beacon('js:error', {
      m: String((e && e.message) || 'error').slice(0, 160),
      f: String((e && e.filename) || '').slice(-46),
      l: (e && e.lineno) || 0,
      rs: document.readyState,
      u: location.pathname
    });
  });
  window.addEventListener('unhandledrejection', function (e) {
    var r = e && e.reason;
    beacon('js:reject', { m: String((r && r.message) || r || 'reject').slice(0, 160), u: location.pathname });
  });

  /* ---- VSEAL: THE VERIFIED SEAL, the ONE client-side copy of lib/view.php verified_tick() ----------
     Owner 2026-09-28: every verified badge becomes the app's seal (iOS build 514). #1d9bf0 seal, #141418
     check, the SAME colours in both themes; path strings are the app's, verbatim, and identical to
     verified_seal_paths() in lib/view.php -- change one, change both. Every JS-drawn badge calls
     vsealTick() (hoisted, so any code in this IIFE can use it) and the later IIFEs read
     window.RovaVSealTick: a throw in THIS IIFE aborts the whole script, so whenever they run, it exists.
     Inline it is the seal alone at 1em (base .vtick rule); on an avatar corner (.vav > .vtick) rova.css
     paints the dark disc behind the same markup. */
  function vsealTick() {
    return '<svg class="vtick" viewBox="0 0 24 24" role="img" aria-label="Verified" focusable="false">'
      + '<path fill="#1d9bf0" d="M12 1L12.71 1.13L13.38 1.49L13.98 2.02L14.52 2.60L15.02 3.11L15.55 3.44L16.15 3.58L16.87 3.57L17.65 3.54L18.45 3.59L19.18 3.81L19.78 4.22L20.19 4.82L20.41 5.55L20.46 6.35L20.43 7.13L20.42 7.85L20.56 8.45L20.89 8.98L21.40 9.48L21.98 10.02L22.51 10.62L22.87 11.29L23 12L22.87 12.71L22.51 13.38L21.98 13.98L21.40 14.52L20.89 15.02L20.56 15.55L20.42 16.15L20.43 16.87L20.46 17.65L20.41 18.45L20.19 19.18L19.78 19.78L19.18 20.19L18.45 20.41L17.65 20.46L16.87 20.43L16.15 20.42L15.55 20.56L15.02 20.89L14.52 21.40L13.98 21.98L13.38 22.51L12.71 22.87L12 23L11.29 22.87L10.62 22.51L10.02 21.98L9.48 21.40L8.98 20.89L8.45 20.56L7.85 20.42L7.13 20.43L6.35 20.46L5.55 20.41L4.82 20.19L4.22 19.78L3.81 19.18L3.59 18.45L3.54 17.65L3.57 16.87L3.58 16.15L3.44 15.55L3.11 15.02L2.60 14.52L2.02 13.98L1.49 13.38L1.13 12.71L1 12L1.13 11.29L1.49 10.62L2.02 10.02L2.60 9.48L3.11 8.98L3.44 8.45L3.58 7.85L3.57 7.13L3.54 6.35L3.59 5.55L3.81 4.82L4.22 4.22L4.82 3.81L5.55 3.59L6.35 3.54L7.13 3.57L7.85 3.58L8.45 3.44L8.98 3.11L9.48 2.60L10.02 2.02L10.62 1.49L11.29 1.13Z"/>'
      + '<path d="M8.43 12.73L10.92 15.67L15.47 8.68" fill="none" stroke="#141418" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"/>'
      + '</svg>';
  }
  window.RovaVSealTick = vsealTick;

  /* ---- CDN-MISS FAILSAFE: never leave a broken image on the page -----------------------------
     media.rovasocial.com is a PUSH-ONLY mirror. Every /uploads write best-efforts an R2::put, and
     a put that fails leaves a file that exists perfectly well on this box but 404s at the edge --
     and Cloudflare NEGATIVE-CACHES that 404 with max-age=14400. So one missed put is a FOUR-HOUR
     broken image, on every PoP that saw it, and we hold no purge token to cut it short.

     That risk was tolerable while only post media rode the CDN. As of 2026-08-06 avatars do too
     (see avatar_src() in lib/view.php), which puts the failure mode on the most-repeated element
     on the site: a member whose avatar missed the mirror would be a broken box in every feed row,
     every comment, every notification, for four hours, with no way to hurry it.

     The origin is the source of truth and has always had the file, so on the FIRST failure we
     re-point the element at the same path on this host. That is media_origin() in lib/view.php
     expressed on the client, and it mirrors src/mediaFallback.js in the native app, which has done
     exactly this for post cards, DM bubbles and video avatars since #399.

     BOUNDED, deliberately: one retry per element, latched on the element itself, and only for a
     URL on our own media host -- so a genuinely missing file degrades to the same broken box it is
     today instead of looping. It is also purely additive: nothing here runs unless an element has
     already failed to load.

     The sweep exists because this file is `defer`, so the parser has had a head start on every
     <img> above it and their error events fired before any listener of ours existed. A complete
     image with naturalWidth 0 is precisely one that failed. */
  var MEDIA_CDN_RE = /^https:\/\/media\.rovasocial\.com\//i;
  function cdnOriginOf(u) {
    return (typeof u === 'string' && MEDIA_CDN_RE.test(u))
      ? location.origin + '/' + u.replace(MEDIA_CDN_RE, '')
      : '';
  }
  function cdnRetryOnOrigin(el) {
    if (!el || el.__cdnRetried) return false;
    var tag = el.tagName;
    if (tag !== 'IMG' && tag !== 'VIDEO') return false;
    // an <img srcset> (the media ring's small pictures, 2026-10-12) failed on the candidate it CHOSE, and a new `src`
    // is ignored while a srcset stands: retry that candidate on the origin and drop the srcset
    var set = tag === 'IMG' && el.hasAttribute('srcset');
    var cur = (set && el.currentSrc) || el.getAttribute('src') || el.currentSrc || '';
    var alt = cdnOriginOf(cur);
    if (!alt) return false;
    el.__cdnRetried = 1;
    beacon('media:cdnmiss', { u: cur.slice(-70), t: tag, p: location.pathname });
    if (set) { el.removeAttribute('srcset'); el.removeAttribute('sizes'); }
    el.setAttribute('src', alt);
    if (tag === 'VIDEO') { try { el.load(); } catch (e) {} }
    return true;
  }
  window.__rovaCdnRetry = cdnRetryOnOrigin;   // exported so the test harness can drive it
  // Capture phase: `error` on a media element does not bubble, so a listener on the document only
  // ever sees it on the way DOWN. This one listener covers every avatar on every surface, including
  // the ones app.js itself builds later (jsAvatar, the typeahead, map pins, DM rows) -- there is no
  // per-element wiring to forget on a new surface.
  /* A FINALLY-FAILED AVATAR BECOMES ITS MONOGRAM, never a broken-image box (2026-09-26, Rob on
     desktop Safari: "Why is val herrera's profile photo a ? here"). The case: a comment row's
     avatar_path named a file that was gone from BOTH the edge and the origin, so the retry above
     had nothing to recover and Safari drew its "?" glyph. Every <img class="avatar"> -- avatar_img()
     server-side, jsAvatar() here -- now degrades to the same gold letter the no-photo branch draws
     (data-ini carries it; the alt handle is the fallback). Runs ONLY after the origin retry has
     been spent (or there was none to try), so a recoverable CDN miss still loads the photo. The
     media ring keeps its own avGone() (its letter sits UNDER the <img>). */
  function avatarGiveUp(t) {
    if (!t || t.tagName !== 'IMG' || !t.classList || !t.classList.contains('avatar')) return false;
    if (t.classList.contains('mring-av-img') || !t.parentNode || !t.getAttribute('src')) return false;
    var ini = t.getAttribute('data-ini');
    if (ini == null) {
      var a = String(t.getAttribute('alt') || '').replace(/^@/, '');
      ini = nameInitial(a, '');   // code point, never charAt(0): an emoji's surrogate pair stays whole
    }
    var s = document.createElement('span');
    s.className = String(t.className || '').replace(/\b(av-defer|nsfw-cell)\b/g, '').replace(/\s+/g, ' ').trim();
    s.setAttribute('style', (t.getAttribute('style') || '') + ';display:inline-flex;align-items:center;justify-content:center;'
      + 'overflow:hidden;background:var(--accent-grad, var(--gold-grad));color:var(--accent-ink, #1a1306);font-weight:800');
    s.setAttribute('aria-label', t.getAttribute('alt') || '');
    s.textContent = ini;
    t.parentNode.replaceChild(s, t);
    beacon('media:avgone', { u: String(t.getAttribute('src') || '').slice(-70), p: location.pathname });
    return true;
  }
  window.__rovaAvatarGiveUp = avatarGiveUp;   // exported so the test harness can drive it
  /* img[data-fallback-src]: a small rendition with the original as its fallback (group logos:
     Upload::avatarSmallPath first, the full logo when that variant was never made). Replaces the
     inline onerror="this.src=..." those <img>s used to carry, which the CSP never ran. Runs only
     once the CDN->origin retry of the FIRST url is spent; the fallback url then gets its own retry. */
  function imgFallback(t) {
    if (!t || t.tagName !== 'IMG' || !t.hasAttribute('data-fallback-src')) return false;
    var fb = t.getAttribute('data-fallback-src') || '';
    t.removeAttribute('data-fallback-src');
    if (!fb || fb === t.getAttribute('src')) return false;
    t.__cdnRetried = 0;
    t.setAttribute('src', fb);
    return true;
  }
  document.addEventListener('error', function (e) {
    var t = e && e.target;
    if (!t || t.nodeType !== 1) { return; }
    if (!cdnRetryOnOrigin(t)) { if (!imgFallback(t)) { avatarGiveUp(t); } return; }
    // WE ARE IN THE CAPTURE PHASE, so this runs BEFORE the element's own onerror -- and several
    // of those treat one failure as final: the grid's poster jpg does removeAttribute('src')
    // (never show a broken image) and the gallery reveal fires on error as well as on load.
    // Left to propagate, they would undo the retry in the same tick and we would have swapped a
    // recoverable image for a permanently blank one. So the FIRST failure is consumed here.
    // If the origin copy fails too, the second error is not retried (the latch is set), nothing
    // is stopped, and every existing handler runs exactly as it does today -- one round trip
    // later. No handler is skipped, only deferred, and only when there is something to try.
    if (e.stopPropagation) { e.stopPropagation(); }
  }, true);
  function cdnSweepBroken() {
    try {
      // A snapshot, not the live document.images: avatarGiveUp() replaces nodes mid-walk.
      var im = Array.prototype.slice.call(document.images);
      for (var i = 0; i < im.length; i++) {
        if (im[i].complete && im[i].naturalWidth === 0 && im[i].getAttribute('src') && !cdnRetryOnOrigin(im[i]) && !imgFallback(im[i])) { avatarGiveUp(im[i]); }
      }
    } catch (e) {}
  }
  if (document.readyState === 'complete') { cdnSweepBroken(); }
  else { window.addEventListener('load', cdnSweepBroken); }

  // Canonical-host guard. The whole app assumes ONE origin (CSP default-src/connect-src 'self',
  // every background call is a same-origin fetch). If a page ends up on a www/alias host, the
  // server 301s each fetch to the apex -- which is CROSS-origin, so Safari blocks it ("Fetch API
  // cannot load ... due to access control checks") and the live feed silently stops polling.
  // The server already 301s navigations to the apex; this snaps any page that slipped through so
  // its fetches stay same-origin. Scoped to the production domain (a leading-dot match), so the
  // apex itself, localhost, and preview/staging hosts are never touched. location.replace = no
  // history entry and, since the apex won't match, no redirect loop.
  try {
    var _h = location.hostname;
    if (/^(www|ww2)\.rovasocial\.com$/i.test(_h) && location.protocol === 'https:') {
      location.replace('https://rovasocial.com' + location.pathname + location.search + location.hash);
      return;
    }
  } catch (e) {}

  var csrf = (document.querySelector('meta[name="csrf-token"]') || {}).content || '';
  var isAdmin = !!document.querySelector('meta[name="rova-admin"]');   // comment moderation UI
  /* Signed-out? lib/view.php stamps <meta name="rova-guest"> for exactly this. Memoised because
     the comment renderers ask once per ROW and a long thread rebuilds hundreds of them; the tag is
     written at render time and a session change is a full page load, so it cannot go stale. */
  var _guest = null;
  function isGuest() {
    if (_guest === null) { _guest = !!document.querySelector('meta[name="rova-guest"]'); }
    return _guest;
  }
  /* App-opened GUEST (?app=1 renders <body class="app-embed">, plus the guest meta): no sign-up
     door anywhere, log-in only (App Store 3.1.1, 2026-09-30). joinHref() is what a guest-only
     "send them to sign up" path uses; the APP-OPENED GUEST block (next to the guest browse gate)
     rewrites links that arrive later. Server twin: View::appGuestDoors() in lib/view.php. */
  function appGuest() { return isGuest() && !!(document.body && document.body.classList.contains('app-embed')); }
  function joinHref() { return appGuest() ? '/login?app=1' : '/signup'; }

  /* ---- presence decay: let the green dot expire itself ----------------------------------------
     Owner 2026-08-05, on a 47-minute-old feed card: "their green dot says they're online but they
     are not, this is stale and should be updated in real time."

     It was never updated at all. Users::isOnline() is evaluated once, while the HTML is being
     built, and NOTHING on any web surface re-evaluates it: /engage-live carries like/comment/repost
     counts and no user fields, /poll-counts carries nav badges, and /post-cards only ever renders
     posts the reader has not seen yet. So a dot is frozen at the value it had when its card was
     built, for as long as that card stays on screen -- which on a feed somebody sits on is hours.
     The server threshold is NOT the fault here: Users::ONLINE_WINDOW is 240s, which is tight.

     THIS COSTS NO NETWORK TRAFFIC. Every dot the server draws carries data-t (the moment that HTML
     was rendered) and data-ttl (the window). Once data-t + data-ttl is in the past the dot cannot
     still be true no matter what the server would say, so we drop it locally. That is the whole
     of the "stale while I sit here" half of the report, and it adds no request at any frequency --
     which matters on an origin already CPU-bound near 150 req/s with several polls running.

     PRIVACY. Both attributes are page constants, not member data: every dot in one response
     carries the identical pair, so they reveal when the HTML was built (already public in the
     Cloudflare Date/Age headers) and a compile-time number. The payload still says only "active
     within the window" and never when within it, so this is strictly no wider than the boolean it
     replaces. `invisible` is unaffected -- it is enforced inside isOnline(), server-side, so an
     invisible member never gets a dot to decay in the first place. This code can only ever REMOVE
     a dot; there is no path here that creates one.

     WE ONLY EVER SHORTEN THE LIE, NEVER TELL A NEW ONE. The worst case is a dot drawn from a
     last_active that was already 240s old, held for another 240s: a 8-minute ceiling, against the
     unbounded staleness there is today. Tightening further would mean shipping how far through the
     window the member actually is, and that is a per-member fact -- see the note in avatar_img().

     Removing the <i> and NOT unwrapping .av-on is deliberate. .av-on carries real layout on the
     profile header (margin-top:-58px, and the --pf-on-x/-y placement measured against it), so
     unwrapping would shift the avatar at the moment the dot expires. Dropping the dot alone leaves
     every box exactly where it was. */
  var PRESENCE_TTL = 240;    // fallback only; each dot carries the server's own Users::ONLINE_WINDOW
  function presenceSweep() {
    var dots = document.querySelectorAll('.online-dot[data-t]');
    if (!dots.length) return;
    var now = Date.now() / 1000;
    for (var i = 0; i < dots.length; i++) {
      var d = dots[i];
      var t = +d.getAttribute('data-t') || 0;
      var ttl = +d.getAttribute('data-ttl') || PRESENCE_TTL;
      // A clock skewed into the future would expire nothing; one skewed backwards would expire
      // everything instantly. Trust the stamp only when it is sane relative to this browser, and
      // fall back to expiring on the reader's own clock from first sight otherwise.
      if (t <= 0 || t > now + 300) { t = d.__seen || (d.__seen = now); }
      if (now - t >= ttl) { d.parentNode && d.parentNode.removeChild(d); }
    }
  }
  // 20s is far finer than the 240s window and costs one querySelectorAll of a class that is rare
  // by construction (3 of 8,580 members were online when this was measured), so the common sweep
  // exits on the length check having touched nothing. No network, no layout read, no rAF.
  // Hidden tabs are skipped and swept on return instead: a backgrounded tab has nothing to correct,
  // and the visibilitychange pass means the reader never SEES a dot that should already be gone.
  setInterval(function () { if (!document.hidden) presenceSweep(); }, 20000);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) presenceSweep(); });
  document.addEventListener('DOMContentLoaded', presenceSweep);
  presenceSweep();

  /* ---- presence attestation: only a PERSON keeps the green dot lit ------------------------------
     Owner 2026-08-05: "No idle open tabs should count as online."

     The web's presence heartbeat (Users::touchActive, index.php:103) used to fire on EVERY
     authenticated request, and this page never stops making them: /dm-poll every 4s, /poll-counts
     every 15s, /engage-live every 8-30s. A tab left open on a desk therefore reported its owner
     online forever. The opposite cure -- simply not counting the pollers -- is just as wrong:
     somebody reading a long post or watching a clip makes no request for minutes and would read as
     OFFLINE while they are looking straight at the screen.

     So the CLIENT decides, because only the client can see a person. While a human has touched this
     page recently AND the tab is in the foreground we keep the `rova_act` cookie alive; the server
     stamps last_active only on requests that carry it, plus real top-level navigations, which are a
     human act by construction. Nothing on an abandoned tab renews it. presence_bearing() in
     index.php is the whole server half, and it is consulted in exactly one place.

     A COOKIE, NOT A HEADER, AND NOT A NEW REQUEST. It rides requests this page already makes, so it
     adds no traffic to an origin that is CPU-bound near 150 req/s; the BROWSER's own Max-Age expiry
     IS the idle timer, so there is no timer here to drift or be throttled in a background tab; and
     it needs no edit at any of the dozens of fetch() call sites in this file, one of which would
     certainly have been forgotten by the next one added.

     IDLE_MS = 2 MINUTES, and the arithmetic that chose it. A stamp can land up to IDLE_MS after the
     last real input, and Users::ONLINE_WINDOW (240s) then keeps the dot lit that much longer, so
     "online" now means A HUMAN TOUCHED THE PAGE WITHIN THE LAST 6 MINUTES -- and an abandoned tab
     is dark 6 minutes after its owner walks away, 4 if they merely switched tabs (below). Six
     minutes comfortably covers reading a long post and watching a clip through; it never covers a
     room with nobody in it. Raising this raises that ceiling one-for-one.

     WHAT COUNTS AS INPUT, and one deliberate omission: 'scroll' is NOT in the list. Element scrolls
     reach a document listener in the CAPTURE phase, and this file scrolls elements on
     forever-running timers (the suggestion carousel every 3.2s, the idle shuffle every 1.5s), so
     listening for scroll would have renewed presence in an empty room -- the exact bug. Every human
     scroll arrives as a wheel, a touchmove or a key anyway, so nothing is lost.

     HIDDEN = GONE, IMMEDIATELY. document.hidden covers a backgrounded tab, a minimised window and a
     phone whose screen locked. None of those is a person looking at the site, so the cookie is
     dropped outright rather than left to age out. That is also what the app does, since a
     backgrounded app stops making requests at all.

     A LIAR CAN ONLY VOUCH FOR THEMSELVES. The cookie is a bare flag and is never read as an
     identity: index.php stamps $user['id'] off the session. The worst a forged rova_act can do is
     keep its OWN account online, which is precisely what the bug above already did for everybody.
     `invisible` is enforced inside Users::isOnline() ahead of last_active, so it cannot be bypassed
     from here either. */
  (function () {
    if (document.querySelector('meta[name="rova-guest"]')) return;   // a guest has no presence to report
    var IDLE_MS  = 120000;   // how long one touch vouches for the person; see the arithmetic above
    var WRITE_MS = 15000;    // at most one cookie write per 15s, however hard the mouse is moving
    var secure   = location.protocol === 'https:' ? '; Secure' : '';
    var lastAt   = 0;
    function put(maxAge) {
      try { document.cookie = 'rova_act=1; Path=/; Max-Age=' + maxAge + '; SameSite=Lax' + secure; } catch (e) {}
    }
    function touch() {
      if (document.hidden) return;
      var t = Date.now();
      if (t - lastAt < WRITE_MS) return;
      lastAt = t;
      put(IDLE_MS / 1000);
    }
    // passive: this must never be able to hold up a scroll. The handler is a clock read and an
    // integer compare, which is why pointermove can afford to be on the list at all.
    var opts = { passive: true };
    ['pointerdown', 'pointermove', 'keydown', 'touchstart', 'touchmove', 'wheel']
      .forEach(function (ev) { document.addEventListener(ev, touch, opts); });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { lastAt = 0; put(0); }   // drop it now; do not let it age out
      else { lastAt = 0; touch(); }                  // came back to the tab: that IS a person
    });
    // No touch on load, on purpose. A page load is already credited by presence_bearing() as a
    // navigation; crediting it a second time here would hand every freshly opened tab an extra
    // IDLE_MS of presence it did nothing to earn.
  })();

  /* ---- slow-link plumbing (2026-07-29): deadlines, honest failures, reconnect --------------------------
     Everything in this block exists because a phone on congested LTE does not fail cleanly, and this file
     had no path for it. Two failure shapes, reproduced against the live site (Playwright, 1.5Mbps /
     300ms RTT / 4x CPU):

       * the SOCKET drops   -> fetch() rejects, .catch runs, the surface re-arms. This already worked:
         the grid recovered 153 -> 324 tiles across a dropped-socket outage.
       * the origin ANSWERS 5xx -> fetch() RESOLVES. Every reader in this file treated "resolved" as "the
         server spoke", so a Cloudflare error page was parsed as feed content: zero posts came out of it,
         and the pagers read zero posts as "there is nothing left" and LATCHED. Three 502s froze the grid
         at 153 tiles; full connectivity plus six screens of scrolling never loaded another one. A
         congested link in front of an origin already near its ~150 req/s ceiling produces 5xx, not clean
         disconnects, so this is the common case on exactly the network we're fixing.

     rfetch() collapses the two: a non-2xx REJECTS, so it travels down the same .catch a dropped socket
     takes and stays retryable. That leaves exactly one thing allowed to latch a terminal state -- a
     successful response that genuinely contained no more content.

     It also gives a read a DEADLINE. There were 87 fetch() calls here and zero timeouts; an in-flight
     flag cleared only inside .then/.catch stays pinned for however long the platform takes to give up on
     a half-open socket (60-120s on iOS Safari), and for that entire window the surface is FROZEN, not
     slow -- which is precisely what "unusable" means. AbortController rather than AbortSignal.timeout:
     the latter only exists from iOS 16.4, and the phones that need this most are the old ones.

     8s is the default for the small HTML/JSON reads (grid partial measured 11.2KB, /post-cards 5.9KB,
     origin p95 440ms). Congested LTE delivers 11KB in ~60ms; a whole trip is ~0.8s, ~1.1s on slow 3G,
     ~3s even if the origin is running 5x slow under load. 8s is ~7-10x the realistic worst case, so it
     cannot fire on a link that is merely bad -- only on one that has stopped answering. */
  function rfetch(url, opts, ms) {
    var o = {}, k;
    for (k in (opts || {})) { if (Object.prototype.hasOwnProperty.call(opts, k)) o[k] = opts[k]; }
    var ctl = null, timer = null;
    if (window.AbortController && !o.signal) {
      try {
        ctl = new AbortController();
        o.signal = ctl.signal;
        timer = setTimeout(function () { try { ctl.abort(); } catch (e) {} }, ms || 8000);
      } catch (e) { ctl = null; }
    }
    var clear = function () { if (timer) { clearTimeout(timer); timer = null; } };
    return fetch(url, o).then(function (r) {
      // A 5xx/404 is NOT content. Reject so the caller's existing .catch owns it -- the whole point is
      // that "the request failed" and "the server said there is no more" stop being the same event.
      if (!r.ok) { clear(); var err = new Error('http ' + r.status); err.status = r.status; throw err; }
      /* THE MEDIA RING'S FRESHNESS SIGNAL (2026-09-18) rides the responses this page already asks for: handle_feed
         and /engage-live stamp a member's fragments with X-Rova-Ring-Rev (lib/mediaring.php, FRESHNESS). Lifted
         HERE, once, for every caller -- no fetch site has to know, and no request is ever made just to learn it.
         The ring module compares it against its own data-rev and re-reads only when it moved. */
      try { var rr = r.headers.get('x-rova-ring-rev'); if (rr) document.dispatchEvent(new CustomEvent('rova:ringrev', { detail: { rev: rr } })); } catch (e) {}
      // KEEP THE DEADLINE ARMED THROUGH THE BODY. fetch() resolves as soon as the HEADERS land, so
      // clearing the timer here would leave a stalled body -- a TCP window that closes mid-response,
      // which is what a congested cell actually does -- outside the timeout entirely, and the caller's
      // in-flight flag pinned exactly as before. Shadow text()/json() on this instance so the deadline
      // is released when the body is genuinely consumed, and aborts the read if it isn't.
      // (If the caller never reads the body the timer just fires against a finished request: a no-op.)
      var rt = r.text, rj = r.json;
      r.text = function () { return rt.call(r).then(function (v) { clear(); return v; }, function (e) { clear(); throw e; }); };
      r.json = function () { return rj.call(r).then(function (v) { clear(); return v; }, function (e) { clear(); throw e; }); };
      return r;
    }, function (e) {
      clear();
      throw e;
    });
  }
  // PUBLISHED: this file is THREE separate top-level IIFEs -- the immersive pfeed viewer is its own and
  // shares nothing with this one but `window`. It aliases this back in (see the top of that IIFE).
  window.__rovaFetch = rfetch;

  /* ---- ENGAGEMENT HOLDS (owner: "when I'm IN a post, stop loading things under me") --------------
     A named-hold registry, the same idiom as the native app's holdChrome/chromeHeld
     (rova-app/src/activity.js): while ANY hold is live every AUTOMATIC feed load suspends -- the live
     poll, the reveal prepend, the ambient roll, the card feed's infinite append, the grid append and the
     grid's idle shuffle. Manual actions (the orb, the bottom pull-up, the Live/Paused toggle) are
     deliberate and stay ungated.

     What counts is DELIBERATE ENTRY into a post: a video the reader TAPPED to play, a third-party embed
     they started, comments open, share/repost/a link out. Like, double-tap-to-like and the reaction
     picker are NOT engagement and are left exactly as they were. Muted autoplay-on-scroll is not
     engagement either -- holding on that would suspend the feed permanently for every scrolling reader.

     Every hold carries a CEILING, and one tied to a node carries that node: an expired hold, or one whose
     element has left the DOM, is dropped on the next read. There is no path to a feed that is permanently
     stuck not loading -- that is the one failure mode this must not have. Scrolling by itself never
     clears a hold (owner's rule: the resume comes when the ENGAGEMENT ends, not on the next scroll). */
  var ENG_LONG = 15 * 60 * 1000;   // watching / listening / reading ceiling (backstop only; real end signals below)
  var ENG_FIRE = 4000;             // fire-and-forget: a copied link, a repost, a tab opening elsewhere
  var engHolds = Object.create(null);   // key -> { exp, el }
  var engSeq = 0;
  // A hold suspends things the reader can SEE suspended, so the transition has to be announceable --
  // see the HELD rendering on the tab strip's transport button. Fires on a real change only. Note it
  // must sit behind engKeys() too: a hold that lapses on its own is swept lazily, on the next read.
  var engSaid = false;
  function engSay() {
    var on = (function () { for (var k in engHolds) { return true; } return false; })();
    if (on === engSaid) return;
    engSaid = on;
    try { document.dispatchEvent(new CustomEvent('rova:enghold', { detail: { on: on } })); } catch (e) {}
  }
  function engHold(key, on, ms, el) {
    if (!key) return key;
    if (on) engHolds[key] = { exp: Date.now() + (ms || ENG_LONG), el: el || null };
    else delete engHolds[key];
    engSay();
    return key;
  }
  function engKeys() {
    var now = Date.now(), out = [], k, h, swept = false;
    for (k in engHolds) {
      h = engHolds[k];
      if (!h || h.exp <= now || (h.el && h.el.isConnected === false)) { delete engHolds[k]; swept = true; continue; }
      out.push(k);
    }
    if (swept) engSay();
    return out;
  }
  function engaged() { return engKeys().length > 0; }
  // A video the reader TAPPED holds the feed while it runs. Wired lazily FROM THE TAP HANDLERS only, so
  // an autoplaying clip never registers. Ends on pause, ended, or scrolled fully out of the viewport --
  // all three also clear _userPlayed, so feedBusy() stops counting it at the same instant.
  function engVideo(v) {
    if (!v) return;
    v._userPlayed = true;
    /* ...and if this clip is one slide of a GALLERY, the gallery now knows the difference between a
       reader passing it and a reader WATCHING it. That single stamp is what switches a multi-video
       post from the unengaged 4.2s preview ("show me a couple of seconds of each") to a playlist
       ("play this clip out, then start the next one") -- see the CYCLE block in initCarousel.
       Deliberately stamped HERE rather than from a new listener: engVideo is already the one place
       every deliberate start funnels through (the transport play button, a tap on the clip, and a
       tap for sound), and its own contract is "wired lazily FROM THE TAP HANDLERS only, so an
       autoplaying clip never registers" -- which is exactly the test the owner's spec needs. */
    var _cyc = v.closest && v.closest('.media.carousel');
    if (_cyc) { _cyc.__cycEng = Date.now(); if (_cyc.__cycArm) { try { _cyc.__cycArm(); } catch (e) {} } }
    if (!v._engKey) {
      v._engKey = 'video#' + (++engSeq);
      var key = v._engKey;
      var off = function (e) {
        if (e && e.type === 'pause' && v._hidHeld) return;   // the hidden-tab hold (resHide), not the reader: the hold survives a tab switch
        v._userPlayed = false; engHold(key, false);
      };
      v._engOff = off;   // the audible-hold tracker below ends a tapped clip at the end of its play (loop wrap)
      v.addEventListener('pause', off);
      v.addEventListener('ended', off);
      if ('IntersectionObserver' in window) {
        try {
          new IntersectionObserver(function (ents) {
            for (var i = 0; i < ents.length; i++) { if (!ents[i].isIntersecting) off(); }
          }, { threshold: 0 }).observe(v);
        } catch (e) {}
      }
    }
    engHold(v._engKey, true, ENG_LONG, v);
    sndMarkHand(v);      // a tap on the clip is the reader's own: an EXPLICIT hold (see THE AUDIBLE CLIP'S HOLD HAS A LENGTH)
  }
  /* ---- THE AUDIBLE CLIP'S HOLD HAS A LENGTH (Rob 2026-09-29, iOS build 533) ------------------------------
     "only 'hold' until the video is over or either 5 seconds max then keep going unless the user intervenes
      ... not held indefinitely preventing the roll". Two kinds of audible clip, and only the reader makes
     the second:
       AUTOMATIC -- audible only because sound follows the playing card (rova_sound on; promoteSound /
         applySound unmuted the tlSlot holder). It holds the fold and the roll (feedBusy's video loop) for
         at most SND_AUTO_MS from the moment it became audible, or until the play it is on reaches its end
         if that is sooner -- a LOOPING clip (every feed clip) is over at the end of that play. Then the
         feed behaves as if the clip were not there.
       EXPLICIT (`_sndHand`, and engVideo's `_userPlayed`) -- the member tapped / clicked the clip or its
         speaker themselves (#571: "if I tap it to hear it ... pause until I'm done"). No cap: it holds
         until the clip is over (ended, or its loop wraps), is muted, is paused by the reader, or is
         paused scrolled away. Its end counts as the reader's last act (rova:sndhold {hand:true}), so the
         fold comes FOLD_IDLE_MS after it, and it releases the attention hold the speaker tap armed and
         the sound engHold -- the same levers a mute pulls ("MUTING IS 'I AM DONE'").
     Before this, `window.__rovaHandSound` was SESSION-wide: one speaker tap made every later auto-followed
     card take a 15-minute engHold and renew the 120 s attention hold for as long as it played -- at the top
     of the feed that is forever, i.e. no fold and no roll. The viewer (.pfeed) is untouched: it is its own
     hold (feedBusy's `.pfeed.show`) and none of these ends apply inside it.
     Per-element stamps from ONE set of document-level capture listeners (media events do not bubble). */
  var SND_AUTO_MS = 5000;
  var sndHandEndAt = 0;
  function sndMarkHand(v) {
    if (!v) return;
    v._sndHand = true;
    v._sndHandT = v.currentTime || 0;
  }
  window.__rovaSndHand = sndMarkHand;
  function sndSay(v, hand) {
    try { document.dispatchEvent(new CustomEvent('rova:sndhold', { detail: { hand: !!hand, v: v } })); } catch (e) {}
  }
  function sndInPf(v) { return !!(v.closest && v.closest('.pfeed')); }
  function sndHandEnd(v, why) {
    if (!v || !(v._sndHand || v._userPlayed) || sndInPf(v)) return;
    v._sndHand = false;
    v._sndHandWhy = why;
    if (v._userPlayed && v._engOff) { try { v._engOff(); } catch (e) {} }
    if (v._sndSync) { try { v._sndSync(); } catch (e2) {} }   // buildControls' derived sound engHold re-asks
    try { engAttnClear(); } catch (e3) {}
    sndHandEndAt = Date.now();
    sndSay(v, true);
  }
  // ms of AUTOMATIC hold this clip still has (0 = none). Only asked of an unmuted, playing clip.
  function sndAutoLeft(v) {
    if (!v._audAt) sndStamp(v);                          // a clip that was audible before any event reached us
    if (v._audOver) return 0;
    return Math.max(0, v._audAt + SND_AUTO_MS - Date.now());
  }
  function sndStamp(v) { v._audAt = Date.now(); v._audOver = false; v._audT = v.currentTime || 0; }
  // the loop wrapped (or a play ended) since `last`: judged near the END, so a reader's seek back is not one
  function sndWrapped(v, last) {
    var t = v.currentTime || 0, d = v.duration;
    return t < last - 0.25 && (!isFinite(d) || !d || last >= d - 1.0);
  }
  ['volumechange', 'play', 'playing', 'pause', 'ended', 'emptied', 'timeupdate'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      var v = e.target;
      if (!v || v.tagName !== 'VIDEO') return;
      var aud = !v.muted && !v.paused && !v.ended;
      if (ev === 'timeupdate') {
        if (aud && v._audAt && !v._audOver && sndWrapped(v, v._audT)) { v._audOver = true; sndSay(v, false); }
        if (v._audAt) v._audT = v.currentTime || 0;
        if ((v._sndHand || v._userPlayed) && !v.paused && sndWrapped(v, v._sndHandT == null ? 0 : v._sndHandT)) { sndHandEnd(v, 'over'); }
        if (v._sndHand || v._userPlayed) v._sndHandT = v.currentTime || 0;
        return;
      }
      if (aud) { if (!v._audAt) sndStamp(v); }
      else if (v._audAt) { v._audAt = 0; v._audOver = false; }
      if (!v._sndHand && !v._userPlayed) return;
      if (ev === 'ended' || ev === 'emptied') { sndHandEnd(v, ev); return; }
      if (ev === 'volumechange' && v.muted) { sndHandEnd(v, 'muted'); return; }
      if (ev === 'pause') {
        // the reader's own pause, or one because it left the screen. NOT WebKit's silent pause of a clip
        // unmuted out of the muted-autoplay allowance (soundRepair resumes that one, in view).
        var r = v.getBoundingClientRect();
        var off = !(r.bottom > 0 && r.top < (window.innerHeight || 800));
        if (v._userPaused || off) sndHandEnd(v, v._userPaused ? 'paused' : 'away');
      }
    }, true);
  });
  // An embed is OPAQUE -- a cross-origin frame tells us nothing about its playback -- so viewport-exit
  // (or the node being removed) is the honest end signal, exactly as initEmbeds already uses to stop one.
  // Same shape serves anything else whose end we can only see geometrically (the photo slideshow).
  function engEmbed(el, kind) {
    if (!el) return;
    if (!el._engKey) {
      el._engKey = (kind || 'embed') + '#' + (++engSeq);
      var key = el._engKey;
      if ('IntersectionObserver' in window) {
        try {
          new IntersectionObserver(function (ents) {
            for (var i = 0; i < ents.length; i++) { if (!ents[i].isIntersecting) engHold(key, false); }
          }, { threshold: 0 }).observe(el);
        } catch (e) {}
      }
    }
    engHold(el._engKey, true, ENG_LONG, el);
    /* ...and starting a PLAYER is a declaration of intent to STAY ON THIS POST, so it arms the
       ATTENTION hold too (see the ATTENTION block below). engHold alone only suspends the LOADERS;
       the things that MOVE the post out from under the reader -- the chrome collapse, the ambient
       roll, a card's gallery auto-swiping itself -- read engAttn(), and no embed path armed it.
       engEmbed is the single funnel every deliberate embed start goes through (the frame-focus
       tell, the container tap, the YouTube facade), which is why the arm belongs here.
       NOT for the photo SLIDESHOW, which borrows this function only for its geometric end signal.
       Its step() parks itself on engAttnUntil() unless __cycEng says a clip is being watched, so
       arming here would freeze the very show the reader just pressed play on -- the exact trap
       already written up above step(): "a reader who pressed play has asked for the next clip, not
       for stillness". */
    if ((kind || 'embed') === 'embed') engAttnArm(ENG_QUIET);
  }
  // Clicking INSIDE a cross-origin frame is invisible to us but for one tell: the frame takes focus, so
  // the window blurs with document.activeElement pointing at it. That is the play tap on Spotify /
  // SoundCloud / Apple's own iframe / YouTube's own button.
  window.addEventListener('blur', function () {
    setTimeout(function () {
      var a = document.activeElement;
      if (!a || a.tagName !== 'IFRAME' || !a.closest) return;
      var box = a.closest('.embed');
      if (box) engEmbed(box);
    }, 0);
  });
  // ...and a pointer landing on the player's own chrome. Only for FRAMED embeds: events inside a
  // cross-origin frame never reach us, so this can only be the container itself, which is a real tap --
  // never a scroll gesture. The facade and the Apple card have exact signals of their own (below).
  document.addEventListener('pointerdown', function (e) {
    var box = e.target && e.target.closest ? e.target.closest('.embed') : null;
    if (box && box.querySelector('iframe')) engEmbed(box);
  }, true);
  // Tapping a link OUT of a post is engagement, but it is fire-and-forget (a new tab, or an app handoff):
  // nothing ever reports back, so it gets a short bounded window rather than a permanent hold.
  document.addEventListener('click', function (e) {
    // ...unless it is a WAKE TAP being re-targeted onto an invisible link. See PF_WAKE_SEL in the
    // immersive viewer: this listener is document-level CAPTURE, so it runs BEFORE the guard on
    // .pfeed can stop the event, and it has to ask the same question itself or a tap that never
    // navigates anywhere would still arm a hold. (The link card is the reachable case.)
    if (window.__rovaWakeRetarget && window.__rovaWakeRetarget(e)) return;
    var a = e.target && e.target.closest ? e.target.closest('.post a[href], .embed a[href]') : null;
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (!href || href.charAt(0) === '#') return;
    var out = a.target === '_blank';
    if (!out) { try { out = new URL(a.href, location.href).host !== location.host; } catch (er) { out = false; } }
    if (out) engHold('linkout', true, ENG_FIRE);
  }, true);
  /* ---- ATTENTION: interacting with a post is a declaration of intent to STAY ON IT ----------------
     Owner 2026-08-05: "If I tap a heart or start engaging with the feed don't auto hide it and start
     moving it around -- that means I'm looking at it and don't want it to move."

     THIS IS DELIBERATELY NOT ONE OF THE engHolds ABOVE, and the difference is the whole design. Those
     suspend every AUTOMATIC LOAD, the infinite append included -- and an append fills the page BELOW
     the fold: it moves nothing and hides nothing. Holding it for two minutes after a like would starve
     the scroll, a new bug wearing the fix's clothes. The attention hold is read ONLY by the things
     that MOVE or HIDE content out from under the reader:
       feedBusy()          the chrome collapse (via trulyIdle) + the live reveal prepend
       maybeRoll()         the ambient roll
       the grid idle shuffle
       autoTick()          a feed card's gallery auto-swiping itself
       the carousel step() the sit-back slideshow, feed and pfeed alike
       hands-free          its own block, via the rova:attention event (it already pauses on engage;
                           this is what decides when it may come BACK)
     The APPEND paths (autoOK, the grid append) still read engaged() alone and are untouched.

     WHAT COUNTS: any deliberate interaction with a POST or its controls -- the heart and the rest of
     the .act row (comment, repost, share, hide), the ... menu, the comment roller and its panel, the
     reaction summary, the video transport (play / scrub / sound), carousel arrows and dots, and typing
     in any field inside a post surface. NOT the page chrome, NOT the tab strip, and NOT hands-free's
     own handle -- pausing the reel because the reader reached for the pause button is circular.

     WHEN IT ENDS -- ENG_QUIET, and the shape is lifted from [[presence-heartbeat-api-chokepoint]]:
     real human input keeps it alive and it decays only after a couple of minutes with NO input at all.
     Two minutes, the same number, for the same reason. The asymmetry that makes it safe: an engagement
     ARMS the hold, but plain human input only RENEWS one that is already live. So scrolling past a
     post you never touched still gets watch mode at the usual 4.5s, while scrolling AFTER you liked
     something keeps everything still until you genuinely put the phone down.
     'scroll' IS NOT IN THE RENEWAL SET, on purpose, and for the same reason the presence cookie leaves
     it out: this file scrolls elements on forever-running timers (suggestion carousel 3.2s, idle
     shuffle 1.5s) and hands-free sets scrollTop itself -- a scroll listener would renew the hold in an
     empty room and, worse, would let hands-free hold ITSELF paused forever. Human scrolling arrives as
     wheel / touchstart / a key anyway. */
  var ENG_QUIET = 120000;
  var engAttnExp = 0;                    // 0 = nothing held; else the ms timestamp the hold lapses at
  var engAttnT = null, engAttnSaid = false;
  function engAttnUntil() { return engAttnExp > Date.now() ? engAttnExp : 0; }
  function engAttn() { return engAttnUntil() > 0; }
  // The one broadcast, on a real CHANGE only, so a control can repaint itself instead of polling.
  function engAttnSay() {
    var on = engAttn();
    if (on === engAttnSaid) return;
    engAttnSaid = on;
    try { document.dispatchEvent(new CustomEvent('rova:attention', { detail: { on: on } })); } catch (e) {}
  }
  /* WHEN THE HOLD WAS LAST ARMED -- by an engagement, never by a renewal (engAttnRenew passes `renew`).
     The immersive viewer reads it through engAttnViewer() below: see the block there for why. */
  var engAttnArmAt = 0;
  function engAttnArm(ms, renew) {
    ms = ms || ENG_QUIET;
    if (!renew) engAttnArmAt = Date.now();
    engAttnExp = Date.now() + ms;
    if (engAttnT) clearTimeout(engAttnT);
    // ONE timer, re-armed on each renewal, landing just past the expiry: nothing polls, and the lapse
    // is announced at the instant it happens rather than whenever something next happens to ask.
    engAttnT = setTimeout(function () { engAttnT = null; engAttnSay(); }, ms + 60);
    engAttnSay();
  }
  function engAttnClear() {
    engAttnExp = 0;
    if (engAttnT) { clearTimeout(engAttnT); engAttnT = null; }
    engAttnSay();
  }
  // RENEW ONLY -- never arms. A reader who has touched no post is not engaged with anything, and the
  // 5s freshness test keeps a 120-events-per-second fling from churning a timer on every frame.
  function engAttnRenew() {
    if (!engAttn()) return;
    if (engAttnExp - Date.now() > ENG_QUIET - 5000) return;
    engAttnArm(ENG_QUIET, true);
  }
  /* THE VIEWER HONOURS ONLY A HOLD ARMED INSIDE IT, SINCE IT OPENED (Rob 2026-10-17, iPhone Safari, @touchmoneybrodie's
     replay /p/57241 at 1:45: "Chrome isn't auto dismissing on web" -- top bar, rail, caption, scrubber and the whole
     bottom row up, the clip PAUSED).
     MEASURED FROM HIS OWN REQUESTS (IIS, 2026-10-16 UTC): /feed?tab=new from 23:38:55 with the replay playing as a
     feed card; POST /like at 23:39:07 = a heart on a DIFFERENT post (57240, likes row 23:39:08); the viewer opened
     from the feed at 23:40:13 (more-from + vflight); the 120000 window fetched at 23:40:41 = his 1:45. So the 120 s
     ATTENTION hold the feed heart armed was still live when the viewer opened, and every touch he made in the
     viewer (engAttnRenew) put it back to a full 120 s: goIdle and the bar's hideT re-polled forever, and the tap he
     made to get rid of the chrome landed on an awake viewer, i.e. it PAUSED the clip (the single-tap play/pause) --
     his play glyph, and the HELD play disc in the hands-free rail. Reproduced exactly (scratchpad chromeidle2
     fsflow.cjs ARM=): hold armed on the card, .vc-fs open -> .pfeed-idle never lands; a wake tap pauses the clip.
     Not replay-specific: ANY viewer opened within two minutes of a feed engagement, renewed by the reader's own
     hand. The hold is the FEED'S ("don't move what I'm engaging with"); the viewer is a different surface whose
     whole design is that its chrome fades, and the post the reader engaged with is usually not even in it. So the
     viewer's two chrome-fade clocks ask engAttnViewer(): a hold armed (not merely renewed) at or after the open
     time the viewer stamps in pfArmIdle. A heart / comment / share / menu INSIDE the viewer still holds (owner rule
     2026-08-05), and the feed keeps its own hold untouched for when the reader comes back. */
  function engAttnViewer() {
    return engAttn() && engAttnArmAt >= (window.__rovaPfOpenAt || 0);
  }
  window.__rovaAttentionViewer = engAttnViewer;
  var ENG_ATTN_SEL = '.act, .croller, .croller-panel, .comment-panel, .pmenu, ' +
                     '.js-react, .js-repost, .js-share, .js-comments, .js-hide, .rx-modal, ' +
                     '.vctrl, .vc-btn, .vc-seek, .vc-sound, .cnav, .cdot, .pf-act, .emoji-pop, .gif-pop, ' +
                     // A third-party player is the video transport of a post we did not build: the
                     // Spotify / SoundCloud / YouTube frame, our own Apple Music card and the
                     // YouTube facade. Reaching for one is the same declaration as reaching for
                     // .vctrl, and none of them was listed. (Taps that land INSIDE the frame never
                     // reach this document at all -- that gap is handled structurally, in the feed's
                     // liveEmbedOnScreen().)
                     // .lc-em is the permalink's official-platform embed facade (2026-08-15): tapping
                     // it starts somebody else's player, which is the same declaration as .yt-facade.
                     '.embed, .am-card, .am-play, .yt-facade, .lc-em';
  var ENG_ATTN_NOT = '#feed-chrome, #feed-tabs, .feed-gear, .feed-settings, .live-toggle, ' +
                     // .pf-hf-rep is hands-free's own control, exactly like the dock and the rate pill
                     // beside it: choosing WHAT the reel plays is not engagement with a post.
                     // (the '.pf-hf' invite layer is gone with the offer -- 2026-08-08)
                     '.pf-hf-dock, .pf-hf-rate, .pf-hf-speeds, .pf-hf-rep, .pfeed-bar, ' +
                     /* THE FULLSCREEN CONTROL IS A HAND-OFF, NOT ENGAGEMENT (owner 2026-08-17:
                        "Chrome doesn't dismiss after opening full screen on web app").

                        MEASURED, both open routes, 390x844, real CDP touch:
                          grid tap (.pcell, not in ENG_ATTN_SEL) -> no hold -> chrome faded at 4.2s
                          .vc-fs tap (.vc-btn IS in ENG_ATTN_SEL) -> 120s hold -> chrome NEVER faded
                        ...and "never" is not "for two minutes". engAttnRenew is bound page-wide to
                        pointerdown/touchstart/wheel/keydown and renews a LIVE hold back to a full
                        120s, so every swipe the reader makes INSIDE the viewer re-arms the hold that
                        the opening tap created. Over four swipe cycles the hold never fell below
                        112s and .pfeed-idle never landed once. Clearing the hold by hand
                        (__rovaAttentionClear) dropped the chrome within 1000ms, which is the whole
                        causal chain in one step: the hold, and nothing else, was holding it up.

                        WHY THE EXCLUSION AND NOT A CHANGE TO goIdle. Deferring the fade while the
                        reader is engaged is correct and is exactly what the owner asked for on
                        2026-08-05 ("if I tap a heart... don't auto hide it"); the renewal is correct
                        too. The one wrong link is ARMING: pressing fullscreen says "show me this
                        bigger", i.e. get out of the way -- it is the opposite declaration from
                        reaching for a heart, and it is the only control whose job is to hand the
                        reader to a surface whose entire design is that its chrome fades. So it
                        joins the two exclusions already here on the same argument .pfeed-bar joins
                        on: operating the chrome that FRAMES content is not engaging with content.
                        Only .vc-fs is named GLOBALLY. The rest of .vctrl keeps its hold in the FEED,
                        because a reader who just pressed play or dragged the seek bar genuinely does
                        need the grid to stop shuffling under them -- that is the hold doing its job. */
                     '.vc-fs, ' +
                     /* THE VIEWER'S ONE-TAP TRANSPORT TOGGLES ARE THE SAME HAND-OFF, SCOPED (owner
                        2026-08-21, of the /p/<id> permalink viewer: "after pressing the speaker
                        button to unmute the chrome and stuff supposed to fade away after a while
                        but it doesn't").

                        MEASURED on /p/45575, both 390x844 real CDP touch and 1440x900 mouse, before
                        this exclusion: the pointerdown under the speaker tap armed the 120s hold,
                        and -- because the unmute also sets __rovaHandSound -- the timeupdate renewal
                        in buildControls then re-armed it to a full 120s every ~5s for as long as the
                        clip stayed audible (msLeft sawtoothed 119.9s -> 115.6s -> 119.9s, forever).
                        goIdle polls __rovaAttention().on, so .pfeed-idle never landed once in 20s;
                        the bar's own hide (showBar's hideT) polls engAttn() and was pinned by the
                        same hold. Chrome up PERMANENTLY off one tap whose whole meaning was "let me
                        hear the video I am watching" -- the .vc-fs argument verbatim: sound on/off,
                        fill/letterbox, PiP and play/pause operate the chrome that frames the
                        content, they are not engagement with a post. (The renewal loop's other half
                        is fixed at its source: that timeupdate renewal now stands down inside the
                        viewer -- see syncSndHold's block in buildControls.)
                        SCOPED to .pfeed on purpose, unlike .vc-fs: in the FEED the .vc-sound press
                        edge is load-bearing (owner 2026-08-10 -- it parks the carousel auto-swipe
                        and the movers while he listens), and the feed's chrome collapse is the
                        thing the hold is FOR there. Inside the viewer none of those movers run
                        (autoTick is `!c.closest('.pfeed')`), so the hold's only readers are the two
                        chrome-fade clocks -- which is exactly the complaint.
                        NOT in PF_WAKE_SEL terms: the wake-tap retarget guard is unrelated -- these
                        are real presses on visible controls; they wake the chrome (wake() runs on
                        the same press) and the 3200ms dwell then fades it like any other tap. */
                     '.pfeed .vc-sound, .pfeed .vc-fit, .pfeed .vc-pip, .pfeed .vc-play, ' +
                     /* ...AND THE SEEK BAR + THE LIVE-REPLAY CONTROLS, SAME ARGUMENT, SAME SCOPE (Rob 2026-10-15,
                        iPhone Safari, a 19:39 live replay playing at 5:32: "Chrome isn't auto dismissing on web").
                        MEASURED, /p/57085 (replay) + /p/57093 (plain clip), 390x844 real touch in Chromium AND
                        WebKit, + 1280x800 mouse: a tap on the clip, play, sound, the hands-free discs -> .pfeed-idle
                        at 2.8-3.3 s; a tap on .vc-seek, the replay's chat toggle (.lrp-ctog, a .vc-btn) or its
                        chapter prev/next (.lrp-chb, .vc-btn) -> attention ON 120 s, NEVER idle, and engAttnRenew
                        puts it back to a full 120 s on every later touch, so a reader who keeps handling the
                        phone never sees the chrome leave. .vc-seek used to be kept armed here on purpose ("a
                        scrub is a hand on the transport"); that job has been done since 2026-09-29 by
                        __rovaScrubLive (goIdle re-polls while a drag is open, held still or not) and the release's
                        __rovaPfWake, which restarts the 3.2 s dwell from the lift -- the hold only kept the bar up
                        for two minutes AFTER the reader had found their place, i.e. while they watched. The
                        replay toggles operate the overlay that frames the clip, exactly like sound / fit. In the
                        FEED all three keep their hold (scoped .pfeed), as the transport there does. */
                     '.pfeed .vc-seek, .pfeed .lrp-ctog, .pfeed .lrp-chb, ' +
                     // the CLEAN VIEW eye + its corner twin (batch item 23) hide / show the chrome: not engagement
                     '.pfeed .vc-eye, .pf-eye-back';
  function engAttendFrom(t) {
    if (!t || !t.closest) return;
    if (t.closest(ENG_ATTN_NOT)) return;
    var hit = t.closest(ENG_ATTN_SEL);
    if (!hit) return;
    /* The viewer's control bar ITSELF (bare bar, the time readout -- nothing that is a control) is not engagement
       either: only a real control inside it (.pf-act heart row, .vc-btn ...) is the closer match and still arms. */
    if (hit.classList && hit.classList.contains('vctrl') && hit.closest('.pfeed')) return;
    engAttnArm(ENG_QUIET);
    // A card's own gallery auto-swipe was already written to respect a manual page (__autoPause, which
    // never SHORTENS an existing hold). Hand it the same hold rather than teaching it a second concept.
    var card = t.closest('.post, .pfeed');
    if (card) {
      Array.prototype.forEach.call(card.querySelectorAll('.carousel'), function (c) {
        if (c.__autoPause) { try { c.__autoPause(ENG_QUIET); } catch (e) {} }
      });
    }
  }
  document.addEventListener('pointerdown', function (e) { engAttendFrom(e.target); }, true);
  /* A WAKE TAP IS NOT ENGAGEMENT. In the immersive viewer a tap meant only to bring the chrome
     back can have its CLICK re-targeted onto a control that was invisible when the finger went
     down (see PF_WAKE_SEL / pfWakeRetarget there for the full mechanism). That click is dropped
     on .pfeed -- but this listener is document-level CAPTURE, so it runs FIRST and would arm the
     120s hold anyway, and the chrome would then refuse to re-idle for two minutes off a tap that
     did nothing. Measured before the guard: every bottom-row control flipped attnOn false->true.
     The POINTERDOWN line above needs no such test: at press time the control is not hit-testable,
     so its target is the media behind and engAttendFrom already declines it. */
  document.addEventListener('click', function (e) {
    if (window.__rovaWakeRetarget && window.__rovaWakeRetarget(e)) return;
    engAttendFrom(e.target);
  }, true);
  // Typing a comment is engagement for as long as it takes to write it. The composer is excluded: it
  // has its own, longer keepChromeUntil grace and is page chrome, not a post.
  document.addEventListener('keydown', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (!/^(INPUT|TEXTAREA)$/.test(t.tagName || '') && !t.isContentEditable) return;
    if (t.closest('#feed-chrome')) return;
    if (t.closest('.post, .pfeed, .comment-panel, .croller-panel')) engAttnArm(ENG_QUIET);
  }, true);
  ['pointerdown', 'keydown', 'touchstart', 'wheel'].forEach(function (ev) {
    document.addEventListener(ev, engAttnRenew, { passive: true, capture: true });
  });
  // Observability, same shape as __rovaHF: which holds are live and how long each has left.
  window.__rovaAttention = function () {
    return { on: engAttn(), msLeft: Math.max(0, engAttnExp - Date.now()), quietMs: ENG_QUIET, armedAt: engAttnArmAt, viewer: engAttnViewer() };
  };
  window.__rovaAttentionClear = engAttnClear;
  window.__rovaAttentionArm = function (ms) { engAttnArm(ms || ENG_QUIET); };
  window.__rovaEngage  = function (key, on, ms) { engHold(key, on, ms); };
  window.__rovaEngaged = function () {
    var now = Date.now();
    return engKeys().map(function (k) { return { key: k, ms: Math.max(0, engHolds[k].exp - now) }; });
  };

  /* ---- THE ENGAGEMENT GRIP: "a hand is on this post RIGHT NOW" --------------------------------
     Owner 2026-08-16: "When tapping to hold a like and the heart animation happens, the auto
     timeline feed should pause until the user is done interacting with posts so it doesn't move
     out of their view while they're engaging."

     WHY A THIRD TERM AND NOT ONE OF THE TWO ABOVE. The engHolds answer "should automatic LOADING
     stand down" and are measured in minutes (a 15-minute listening ceiling). The attention hold
     answers "is the reader still in the room" and decays over 120 seconds. Neither can answer
     "is a finger down on this post at this instant", and that is the only question hands-free
     needs in order not to pull a post out from under a press-and-hold. Answering it with the
     attention hold instead would mean the reel stays parked for two minutes after every heart --
     which is the CURRENT behaviour, and is the half of the complaint that is not about the burst
     at all.

     IT EXTENDS THE FAMILY RATHER THAN COMPETING WITH IT, and keeps all three of its disciplines:
     a CEILING on every entry (the law the engHolds block states in full -- "there is no path to a
     feed that is permanently stuck ... that is the one failure mode this must not have"), a LAZY
     SWEEP on read so an abandoned gesture cannot outlive its budget, and idempotence in both
     directions so no caller can corrupt it by pairing badly.

     ...AND IT ARMS THE ATTENTION HOLD AS IT GOES, which is the main reason it belongs in this
     block rather than in hands-free's. Holding a heart IS engagement, so the reader gets all
     EIGHT hide/move mechanisms standing still for it -- the chrome collapse, the ambient roll,
     the grid shuffle, both carousel auto-swipes, the live prepend -- with no new wiring anywhere.
     The grip is only the extra PRECISION that hands-free needs on top of that: attention says
     "for the next two minutes", grip says "until this finger lifts".

     ONE CONSUMER, READ BY POLL, NO EVENT. Hands-free already re-asks on a short timer while it is
     holding (the hfMusicHold shape), so a reader is all it needs and a broadcast would be a
     second mechanism to keep in sync for no gain. Kept as a window export for the same reason
     __rovaAttention is one: it is across an IIFE boundary, and it is the test seam. */
  var ENG_GRIP_CAP = 12000;        // ceiling: no gesture is longer (the love hold auto-pops at 2.4s)
  var engGrips = Object.create(null);
  function engGripped() {
    var now = Date.now(), k, any = false;
    for (k in engGrips) {
      if (engGrips[k] <= now) { delete engGrips[k]; continue; }   // lazy sweep, as engKeys does
      any = true;
    }
    return any || !!engHandWhy();
  }
  /* ---- THE HAND: the grip widened to EVERY hand on the page, plus a 1.5 s tail (Rob 2026-10-22, batch item 46,
     iOS parity: "Auto feed must not move while engaging (super like, finger on screen, scroll, tap)").
     The grip above only knew the love burst. Hands-free still moved under a finger resting on a photo, a mouse held
     down / dragging, a reaction picker being chosen, an open share or comment sheet, a focused comment field, and it
     could move the instant any of those let go. So engGripped() now also answers true for:
       'down'   a pointer or finger is on the page (pointer ids + touch count; a mouse with no buttons is up)
       'type'   a visible text field / contenteditable has focus (the comment composer, DMs, search)
       'sheet'  a sheet / menu / comment panel / picker is open, or the share / comment-sheet engHold is live
       'tail'   HAND_TAIL_MS after ANY of the above ended, and after a wheel or a key press
     NOT an arm of the attention hold: a bare touch is not engagement (the asymmetry in the ATTENTION block), so this
     never arms engAttn and never pauses anything -- readers just keep asking (hands-free re-asks every HF_GRIP_MS,
     the gallery slideshow every 250 ms, the feed roll on its next beat) and the item gets its FULL dwell after.
     'scroll' is not a listener here for the reason the ATTENTION block gives (our own timers scroll); a human scroll
     arrives as touch / wheel / key, and the viewer's own scroll tail is hands-free's HF_NAV_TAIL_MS.
     LAW (engHolds): no path to a permanently stuck reel -- a 'down' with no pointer/touch event for HAND_CAP_MS is
     dropped, and a hidden tab / window blur clears every pointer. Receipt: window.__rovaHand(). */
  var HAND_TAIL_MS = 1500, HAND_CAP_MS = 30000;
  var HAND_SHEET_SEL = '.comment-panel.open, .pmenu-panel.show, .menu-panel.show, .rx-modal.show, .emoji-pop.show, ' +
                       '.gif-pop.show, .lightbox.show, .gal.show, #auth-modal.show, .cropper';
  var handPtrs = Object.create(null), handTouches = 0, handEvAt = 0, handAt = 0, handSeen = '';
  function handClear() { handPtrs = Object.create(null); handTouches = 0; }
  function handDown() {
    var n = handTouches; for (var k in handPtrs) { n++; break; }
    if (!n) return false;
    if (Date.now() - handEvAt > HAND_CAP_MS) { handClear(); handAt = Date.now(); return false; }
    return true;
  }
  function handTyping() {
    var a = document.activeElement;
    if (!a || a === document.body) return false;
    var tag = a.tagName || '';
    var txt = tag === 'TEXTAREA' || a.isContentEditable ||
              (tag === 'INPUT' && /^(text|search|email|url|tel|password|)$/i.test(a.getAttribute('type') || ''));
    return !!(txt && a.getClientRects && a.getClientRects().length);
  }
  function handSheet() {
    if (document.body && document.body.classList.contains('modal-open')) return true;
    var now = Date.now(), h = engHolds.share || engHolds.comments;
    if (h && h.exp > now) return true;
    return !!document.querySelector(HAND_SHEET_SEL);
  }
  function engHandWhy() {
    var why = handDown() ? 'down' : handTyping() ? 'type' : handSheet() ? 'sheet' : '';
    if (why) { handSeen = why; handAt = Date.now(); return why; }
    if (handSeen) { handSeen = ''; handAt = Date.now(); }   // first look after it ended: the tail runs from here
    return (Date.now() - handAt < HAND_TAIL_MS) ? 'tail' : '';
  }
  document.addEventListener('pointerdown', function (e) { handPtrs[e.pointerId] = e.pointerType || 'mouse'; handEvAt = handAt = Date.now(); }, { capture: true, passive: true });
  ['pointerup', 'pointercancel'].forEach(function (ev) {
    document.addEventListener(ev, function (e) { delete handPtrs[e.pointerId]; handEvAt = handAt = Date.now(); }, { capture: true, passive: true });
  });
  document.addEventListener('pointermove', function (e) {
    if (!handPtrs[e.pointerId]) return;
    handEvAt = Date.now();
    if (e.pointerType === 'mouse' && !e.buttons) { delete handPtrs[e.pointerId]; handAt = handEvAt; }   // its pointerup went elsewhere
  }, { capture: true, passive: true });
  function handTouch(e) {
    handTouches = (e.touches && e.touches.length) || 0; handEvAt = handAt = Date.now();
    // the last finger is up: a touch pointer whose pointerup never came (a long-press the reaction picker owned) goes with it
    if (!handTouches && (e.type === 'touchend' || e.type === 'touchcancel')) { for (var k in handPtrs) { if (handPtrs[k] === 'touch') delete handPtrs[k]; } }
  }
  ['touchstart', 'touchmove', 'touchend', 'touchcancel'].forEach(function (ev) {
    document.addEventListener(ev, handTouch, { capture: true, passive: true });
  });
  /* A touch's end is dispatched to the element it STARTED on. If that element leaves the DOM mid-press (the reaction
     picker re-renders the heart, the deck recycles a card) the touchend never reaches document and the hand would read
     'down' until HAND_CAP_MS -- measured 1 run in 3 on a heart long-press. So the start target hears its own end too. */
  document.addEventListener('touchstart', function (e) {
    var t = e.target; if (!t || !t.addEventListener) return;
    t.addEventListener('touchend', handTouch, { once: true, passive: true });
    t.addEventListener('touchcancel', handTouch, { once: true, passive: true });
  }, { capture: true, passive: true });
  ['wheel', 'keydown', 'focusout'].forEach(function (ev) {
    document.addEventListener(ev, function () { handAt = Date.now(); }, { capture: true, passive: true });
  });
  window.addEventListener('blur', function () { handClear(); handAt = Date.now(); });
  document.addEventListener('visibilitychange', function () { if (document.hidden) { handClear(); } });
  window.__rovaHandHeld = engHandWhy;
  window.__rovaHand = function () {
    var ids = []; for (var k in handPtrs) ids.push(k);
    return { why: engHandWhy(), ptrs: ids, touches: handTouches, sinceMs: Date.now() - handAt, tailMs: HAND_TAIL_MS };
  };
  function engGrip(key, on, ms) {
    if (!key) return;
    if (on) {
      engGrips[key] = Date.now() + Math.min(ms || ENG_GRIP_CAP, ENG_GRIP_CAP);
      engAttnArm(ENG_QUIET);       // a grip is engagement: everything that MOVES or HIDES stands down
    } else {
      delete engGrips[key];
      handAt = Date.now();         // the hand's 1.5 s tail runs from a grip's release too
    }
  }
  window.__rovaGrip = engGrip;
  window.__rovaGripped = engGripped;
  // Observability, same shape as __rovaAttention: what is gripping and how long each has left.
  window.__rovaGrips = function () {
    var now = Date.now(), out = [], k;
    engGripped();                  // sweep first so a lapsed grip is never reported as live
    for (k in engGrips) out.push({ key: k, ms: Math.max(0, engGrips[k] - now) });
    return out;
  };

  /* Surfaces that a drop can leave dead register a re-arm here. There is no online/offline listener
     anywhere in assets/ today, and the cost of that was measured: offline mid-scroll produced 115 failed
     requests, and after coming back online and sitting idle 12s the grid had repainted 2 more tiles
     (85 -> 87) with only 17 of 114 failed URLs ever re-requested. A cell that stays on screen through an
     outage stays blank forever -- the grid's release/restore window (below) only repaints on RE-ENTRY.
     Deliberately cheap: no polling, no timers, nothing runs unless the OS says the link came back, and
     the handlers are STAGGERED so a reconnect isn't a burst of parallel requests into a radio that has
     only just re-associated. */
  var _rearm = [];
  function onReconnect(fn) { _rearm.push(fn); }
  window.addEventListener('online', function () {
    // `online` fires the moment the interface is up, which is a beat before it can actually carry
    // anything. Give the radio a moment, then walk the list one handler at a time.
    _rearm.forEach(function (fn, i) {
      setTimeout(function () { try { fn(); } catch (e) {} }, 600 + i * 150);
    });
  });

  /* Re-kick images that are on (or near) screen and did NOT paint. A failed <img> is terminal in every
     browser: the element keeps its src, complete goes true, naturalWidth stays 0, and nothing ever asks
     again. Removing and re-setting the same src in a later task re-runs resource selection, and since the
     failed response was never cached the bytes come fresh. Bounded to ~a screen either side and capped at
     12 so a reconnect can't stampede the origin. */
  var _reblank = false;
  function retryBlankMedia() {
    if (_reblank) return 0;                                     // one sweep at a time
    var vh = window.innerHeight || 800, todo = [];
    var imgs = document.querySelectorAll('.pcell img, .post .media img, .pfeed img');
    for (var i = 0; i < imgs.length; i++) {
      var im = imgs[i], r;
      try { r = im.getBoundingClientRect(); } catch (e) { continue; }
      if (!r.width || r.bottom < -vh || r.top > vh * 2) continue;   // ~a screen either side of the fold
      if (im.naturalWidth > 2) continue;                            // it painted: leave it alone
      var s = im.getAttribute('src') || im.getAttribute('data-gsrc') || (im.dataset && im.dataset.pfSrc) || '';
      if (!s) continue;
      if (!im.complete && im.getAttribute('src')) continue;         // still legitimately in flight
      todo.push([im, s]);
    }
    if (!todo.length) return 0;
    // FOUR AT A TIME, chained. A reconnect can find 30+ blank cells around the fold; firing them all at
    // once is a burst into a radio that has only just re-associated (and into an origin whose ceiling is
    // ~150 req/s). Draining a small window instead recovers the whole visible band without a stampede.
    var total = todo.length, active = 0, done = 0;
    _reblank = true;
    var pumpImgs = function () {
      while (active < 4 && todo.length) {
        var job = todo.shift(), el = job[0], u = job[1];
        active++;
        var fin = function () { active--; done++; if (done >= total) { _reblank = false; } pumpImgs(); };
        el.addEventListener('load', fin, { once: true });
        el.addEventListener('error', fin, { once: true });
        el.removeAttribute('src');
        // Next task, not this one: re-assigning the same src synchronously can be coalesced away, and
        // the removal has to be observed before the set re-runs resource selection.
        (function (e2, u2) { setTimeout(function () { e2.setAttribute('src', u2); }, 0); })(el, u);
      }
    };
    pumpImgs();
    setTimeout(function () { _reblank = false; }, 30000);       // never latch, whatever the events do
    return total;
  }
  onReconnect(retryBlankMedia);

  /* ---- BACKGROUND RETRY: capped, jittered, visibility-aware (2026-08-04) ------------------------
     Owner, screenshot of the feed on one bar of 5G with the gold ring spinning at the top of it:
     "After a while it should just say offline mode and keep trying in the background without a
     constant spinning circle."

     The 2026-07-29 pass above gave every read a deadline and made a failure retryable, but it
     stopped at THREE tries (gridCycle.armRetry) and it gave the reader no state to look at. On a
     link that stays bad -- connected, one bar, too weak to carry a request -- that is an indicator
     that resolves into nothing, forever, and then silence.

     This is the ONE scheduler the retrying surfaces share. Every rule in it is a load rule first:

       * NEVER STACK. One timer, one attempt in flight. A retrier that is already trying does not
         arm a second, and two callers asking at once get one request.
       * CAP THE BACKOFF AT 60s AND JITTER IT +/-20%. The origin is CPU-bound at ~150 req/s, and the
         congestion that produces these failures is the same congestion that produces its 5xx -- so
         an indefinite loop at a fixed short interval, across every stalled client at once, is a
         self-inflicted outage on top of the one we are recovering from. At 60s a stalled client
         costs 1 req/min against a ~35 req/min baseline. The jitter is not decoration: without it
         everyone who failed in the same second comes back in the same second when the outage lifts,
         which is precisely the spike that re-breaks it.
       * PAUSE WHILE THE TAB IS HIDDEN. A backgrounded tab has no reader to recover for, and a phone
         holding twenty parked tabs must not poll from all of them. Nothing is scheduled while
         hidden; if the tab comes back owing a try it goes out immediately (one settle beat), because
         that is the moment somebody is actually looking at it.
       * A REAL RECONNECT BEATS THE BACKOFF. Callers wire now() to onReconnect so a link that comes
         back does not sit out a 60s step.
       * NOTHING MAY LATCH. If a caller's run() never settles, a 45s watchdog releases the slot so
         there is no path to a surface that is permanently stuck not retrying.

     Steps are 2s, 4s, 8s, 15s, 30s, then 60s forever. The first three are exactly what armRetry
     already did, so the fast burst that recovers a brief blip is unchanged; the tail is the new
     part, and the tail is the whole point. */
  var RETRY_STEPS = [2000, 4000, 8000, 15000, 30000, 60000];
  function makeRetrier(run) {
    var step = 0, timer = null, live = false, owed = false, lastTry = 0, guard = null, nextFire = 0;
    function jitter(ms) { return Math.round(ms * (0.8 + Math.random() * 0.4)); }
    function release() { if (guard) { clearTimeout(guard); guard = null; } live = false; }
    function fire() {
      timer = null;
      if (live) return;                                   // an attempt is already out: never stack
      if (document.hidden) { owed = true; return; }        // paused; visibilitychange re-arms
      owed = false; live = true; lastTry = Date.now();
      var settled = false;
      // Watchdog: run() is supposed to settle (every caller goes through rfetch, which has its own
      // deadline), but a slot that could latch would be the one failure mode this must not have.
      guard = setTimeout(function () { guard = null; if (live && !settled) { settled = true; live = false; arm(); } }, 45000);
      try {
        run(function (ok) {
          if (settled) return;
          settled = true; release();
          if (ok) { step = 0; } else { arm(); }
        });
      } catch (e) { settled = true; release(); arm(); }
    }
    function arm() {
      if (timer || live) return;
      if (document.hidden) { owed = true; return; }
      var base = RETRY_STEPS[Math.min(step, RETRY_STEPS.length - 1)];
      step++;
      var d = jitter(base);
      nextFire = Date.now() + d;           // published so a caller can hold OTHER askers off to the same instant
      timer = setTimeout(fire, d);
    }
    function now() {
      if (timer) { clearTimeout(timer); timer = null; }
      if (live) return;                                   // already trying: leave it alone
      if (Date.now() - lastTry < 1000) { arm(); return; }  // a tab flip / event storm must not be a hammer
      fire();
    }
    function stop() { if (timer) { clearTimeout(timer); timer = null; } owed = false; step = 0; nextFire = 0; }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        if (timer) { clearTimeout(timer); timer = null; owed = true; }   // pause, and remember we owed one
        return;
      }
      if (owed) { owed = false; setTimeout(now, 400); }                  // back on screen -> try straight away
    });
    return {
      arm: arm, now: now, stop: stop,
      busy: function () { return live; },
      tries: function () { return step; },
      nextAt: function () { return timer ? nextFire : 0; }
    };
  }
  // PUBLISHED for exactly the reason rfetch is: this file is several separate top-level IIFEs that
  // share nothing but `window`, and a cross-boundary reference works unminified and breaks only in
  // the minified bundle. Both current users live in THIS IIFE; the alias is for the next one.
  window.__rovaRetrier = makeRetrier;

  /* ---- compose-flow trace (temporary diagnostic) --------------------------
     A stuck "Posting…" spinner is invisible server-side when the upload never
     leaves the device. This fires an ordered, per-attempt breadcrumb to
     POST /compose-trace (form-encoded so `_csrf` rides in the body, like
     /scroll-perf) so we can see EXACTLY where a member's post stalls: on-device
     compression, the stage/chunk requests, the submit, or the /compose reply.
     Best-effort and swallowed — it must never affect the post itself. */
  var ctraceId = '';
  function ctraceNew() { try { ctraceId = Math.random().toString(36).slice(2, 8); } catch (e) { ctraceId = 'x'; } return ctraceId; }
  function ctrace(ev, data) {
    try {
      if (document.querySelector('meta[name="rova-guest"]')) return;   // guests have no session to attribute to
      var d = data || {}; d.a = ctraceId;
      var body = '_csrf=' + encodeURIComponent(csrf) + '&ev=' + encodeURIComponent(ev) + '&d=' + encodeURIComponent(JSON.stringify(d));
      if (navigator.sendBeacon) {
        var blob = new Blob([body], { type: 'application/x-www-form-urlencoded' });
        if (navigator.sendBeacon('/compose-trace', blob)) return;
      }
      fetch('/compose-trace', { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: body, keepalive: true, credentials: 'same-origin' }).catch(function () {});
    } catch (e) {}
  }

  // Fill in a CSRF token that couldn't be rendered server-side because the page was served from
  // the edge cache with no session (see lib/edgecache.php + Security::csrfField). Resolves
  // immediately for normal server-rendered forms, so it's safe to await unconditionally.
  function ensureFormCsrf(form) {
    var f = form && form.querySelector('input[name="_csrf"][data-csrf-lazy]');
    if (!f) return Promise.resolve();
    return fetch('/session-token', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (j && j.t) {
          f.value = j.t;
          f.removeAttribute('data-csrf-lazy');
          csrf = j.t;              // keep header-based callers on this page in sync
        }
      })
      .catch(function () { /* submit anyway: a 419 surfaces in the form's own error box */ });
  }

  /* ---- TRANSPARENT CSRF RECOVERY -------------------------------------------------------------
     A page that has been open a while starts 419ing EVERY action, permanently, until the member
     reloads. Owner hit it four times deleting one post; 83 419s in a day, 72% of them beacons.

     THE CAUSE IS NOT WHAT IT LOOKS LIKE, and the difference decides the fix. It is NOT that
     Auth::startSession()'s ~30-minute session_regenerate_id(true) mints a new token: rotation
     COPIES $_SESSION, so `_csrf` comes through byte-identical (measured: token unchanged across a
     forced rotation, and a POST holding the "old" token still returned 200). What rotation does is
     DESTROY the old session id. Any request that still carries that id -- an in-flight keepalive
     beacon, a navigation whose Set-Cookie never landed, a second tab a moment behind -- lands on no
     session at all, so csrfCheck() sees an empty `_csrf` and 419s. PHP (session.use_strict_mode=1)
     then hands that request a BRAND NEW session, and Auth::viaRemember() signs the member straight
     back into it -- with a DIFFERENT `_csrf`. The tab is now authenticated, healthy, and holding a
     token that can never match again. Measured: 419, then 419, 419, 419, 419 for every subsequent
     POST, while GET /settings on the same cookie rendered 200 as the member.

     WHY RETRYING IS SAFE, INCLUDING FOR CREATES AND DELETES. Security::requireCsrf() is the global
     gate at index.php:240 and it exit()s BEFORE the dispatcher reaches any handler, so a 419'd
     request provably had no effect. PROVED live rather than assumed: a 419'd POST /comment left the
     comments table at 0 rows and the replay produced exactly 1; a 419'd POST /post/delete left the
     post intact. So the usual idempotency question -- end-state vs blind toggle, see
     [[intent-not-inversion]] -- does not arise here: there is no first effect to double.
     THAT IS WHY THIS FIRES ON 419 AND NOTHING ELSE. A 5xx or a dropped socket may well have
     reached the handler, and replaying those WOULD double-fire.

     NEVER A STORM, and this is the load-bearing constraint -- a refresh stampede against a genuinely
     dead session is worse than the bug it fixes:
       * ONE /session-token in flight ever (csrfRefreshing single-flights it), so the 54 beacons that
         419'd in 90 seconds on 2026-08-07 would have produced exactly one token fetch between them;
       * each request retries AT MOST once;
       * two hard stops, both latching: a refresh that returns the SAME token, and a retry that 419s
         again. After either, this page never asks again.

     AND NEVER ON A GUEST PAGE. An edge-cached render carries no token by design, so `csrf` is ''.
     Hydrating one there mints a session per guest, whose rova_sess cookie makes every later page
     ineligible for the edge cache and dumps the traffic on an origin that tops out ~150 req/s -- the
     explicitly rejected fix in [[csrf-beacon-on-edge-cached-page]]. An empty token is therefore a
     REFUSAL to refresh, not a reason to. */
  var csrfRefreshing = null;   // the single in-flight /session-token promise, or null
  var csrfDead = false;        // latched: refreshing cannot help this page any more
  var CSRF_STALE_MSG = 'This page has been open a while and lost its connection to your account, '
    + 'so that didn’t go through. Nothing was changed. Reload the page and try it again.';

  // Put a fresh token everywhere the page holds one. The <meta> matters as much as the variable:
  // several callers (the vflight sampler, the founders bonus-card dismiss, gallery.js in its own
  // bundle) read the meta at call time rather than caching it, so updating it heals them for the
  // rest of the page's life without a single edit at those sites.
  function csrfApply(t) {
    csrf = t;
    var m = document.querySelector('meta[name="csrf-token"]');
    if (m) { m.setAttribute('content', t); }
    var ins = document.querySelectorAll('input[name="_csrf"]');
    for (var i = 0; i < ins.length; i++) {
      ins[i].value = t;
      ins[i].removeAttribute('data-csrf-lazy');
    }
    try { document.dispatchEvent(new CustomEvent('rova:csrf', { detail: { token: t } })); } catch (e) {}
  }

  /* SETTLE BEFORE ASKING, and this delay is the whole difference between a refresh that sticks and
     one that is stale on arrival. Every request that reaches PHP holding a destroyed session id
     gets a BRAND NEW session (session.use_strict_mode=1) which Auth::viaRemember() then signs the
     member back into -- so N requests already in flight when the id died mint N different sessions,
     and the browser keeps whichever Set-Cookie lands last. Ask for a token in the middle of that and
     you get one belonging to a session that is about to be orphaned; the retry then 419s for a
     brand-new reason and the member is told the lie that nothing can be done.
     OBSERVED, not theorised: with the feed's /engage-live, /suggest-people and /feed?partial=posts
     polls in flight, the retry landed on a THIRD session whose token was neither the page's nor the
     one /session-token had just handed back. The first 419's own response is what puts a good
     session cookie in place, so waiting a beat after it lets the stragglers land first and asks
     once the cookie has stopped moving. Cheap: it only ever runs on a recovery, the action was
     already painted optimistically, and it costs no extra request. */
  var CSRF_SETTLE_MS = 400;

  /* `force` is the BACK-BUTTON path, and the two callers want genuinely different things.
     The retry path asks "is there a token I have not already tried?", so an unchanged answer means
     there is nothing left to do and it must stop (that is the csrfDead latch). The bfcache-restore
     path asks "put the session's CURRENT token into this restored page", and there the token being
     unchanged is the NORMAL case: what went stale is the token baked into the restored FORM, not
     the one this script is holding. Running the restore through the retry rule made it bail before
     applying anything -- WebKit came back from bfcache with `deadbeef...` still in the form and was
     refused a second time, while Chromium passed only because it re-fetched the page instead of
     using bfcache. So a forced refresh applies whatever comes back and never latches. */
  function csrfRefresh(force) {
    if (csrfDead && !force) { return Promise.resolve(''); }
    if (!csrf) { return Promise.resolve(''); }                                   // guest page: see above
    if (document.querySelector('meta[name="rova-guest"]')) { return Promise.resolve(''); }
    if (csrfRefreshing) { return csrfRefreshing; }                               // everyone shares the one fetch
    var had = csrf;
    csrfRefreshing = new Promise(function (go) { setTimeout(go, force ? 0 : CSRF_SETTLE_MS); })
      .then(function () { return fetch('/session-token', { credentials: 'same-origin', cache: 'no-store' }); })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var t = (j && j.t) || '';
        if (!t) { if (!force) { csrfDead = true; } return ''; }
        if (t === had && !force) { csrfDead = true; return ''; }   // nothing new to try: stop, for good
        csrfApply(t);
        return t;
      })
      .catch(function () { return ''; })
      .then(function (t) { csrfRefreshing = null; return t; });
    return csrfRefreshing;
  }

  /* Run a request that carries the CSRF token, healing one stale token transparently.
     `send(token)` must build and fire the request fresh each call -- it is invoked at most twice,
     and the second call must not reuse a consumed body. Resolves with the Response either way;
     a still-419 response is flagged so the caller can say something true instead of "invalid
     request". Never rejects on its own account. */
  function csrfSend(send) {
    return send(csrf).then(function (r) {
      if (!r || r.status !== 419) { return r; }
      return csrfRefresh().then(function (t) {
        if (!t) { try { r.csrfStale = true; } catch (e) {} return r; }
        return send(t).then(function (r2) {
          if (r2 && r2.status === 419) {
            csrfDead = true;                       // a token minted seconds ago was refused: stop
            try { r2.csrfStale = true; } catch (e) {}
          }
          return r2;
        });
      });
    });
  }

  /* THE BACK-BUTTON HALF, and without it the server's advice would be a loop.
     A NATIVE form post (no js- handler: /settings carries the bio, the links and the display name)
     that gets refused lands on Security::csrfRefusedPage(), which says "go back and try again".
     Back does restore what the member typed -- measured in both Chromium and WebKit -- but it
     restores the STALE token baked into that same form, so the second attempt would be refused for
     exactly the same reason. Security::markCsrfStale() leaves a one-shot COOKIE; we read it here
     and put a live token into every _csrf input on the restored page, which is what turns "try
     again" into something that actually works with their text intact.
     A COOKIE and not sessionStorage: the refusal page cannot run script at all under the site's
     `script-src 'self'` (no 'unsafe-inline'), so the first version of this never fired -- WebKit
     came back from bfcache still holding the dead token and was refused a second time.
     pageshow, not DOMContentLoaded: a bfcache restore does NOT re-run this file, and bfcache is the
     common case for Back. Cleared on first read, so this costs exactly one extra request per
     refusal and nothing at all on an ordinary Back. csrfRefresh() keeps its own guards, so a guest
     page still never fetches a token. */
  window.addEventListener('pageshow', function () {
    if (document.cookie.indexOf('rova_csrf_stale=1') === -1) { return; }
    document.cookie = 'rova_csrf_stale=; Max-Age=0; path=/' + (location.protocol === 'https:' ? '; Secure' : '');
    csrfRefresh(true);        // forced: see csrfRefresh -- an unchanged token is the normal case here
  });

  /* The terminal message, and the ONLY thing a member is ever shown about any of this.
     Deliberately a persistent bar and not a toast: a toast lasts 1.8s, and the composer work of
     2026-08-07 established that a thumb over the button means it is gone before the eyes get there
     (see stageBlockNote). It says what is true -- the request was refused by the CSRF gate BEFORE
     any handler ran, so nothing was changed -- and gives the one action that fixes it. No error
     code, no "invalid request": the member did nothing invalid.
     Shown at most once; styles are inline so this cannot depend on a rova.css build landing too. */
  function csrfStaleNotice() {
    if (document.getElementById('csrf-stale-bar')) { return; }
    var bar = document.createElement('div');
    bar.id = 'csrf-stale-bar';
    bar.setAttribute('role', 'alert');
    bar.style.cssText = 'position:fixed;left:50%;transform:translateX(-50%);bottom:calc(16px + env(safe-area-inset-bottom));'
      + 'z-index:2147483000;max-width:min(560px,calc(100vw - 24px));display:flex;gap:12px;align-items:center;'
      + 'padding:12px 14px;border-radius:14px;background:#16161a;color:#f2f2f4;border:1px solid rgba(255,255,255,.14);'
      + 'box-shadow:0 10px 34px rgba(0,0,0,.45);font:500 14px/1.45 system-ui,-apple-system,"Segoe UI",sans-serif;';
    var msg = document.createElement('span');
    msg.textContent = CSRF_STALE_MSG;
    msg.style.cssText = 'flex:1 1 auto;min-width:0;';
    var go = document.createElement('button');
    go.type = 'button';
    go.textContent = 'Reload';
    go.style.cssText = 'flex:0 0 auto;cursor:pointer;padding:8px 14px;border-radius:999px;border:0;'
      + 'background:#f5c518;color:#101014;font:600 14px/1 system-ui,-apple-system,"Segoe UI",sans-serif;';
    go.addEventListener('click', function () { window.location.reload(); });
    bar.appendChild(msg);
    bar.appendChild(go);
    (document.body || document.documentElement).appendChild(bar);
  }

  // PUBLISHED for the same reason rfetch and makeRetrier are: this file is several independent
  // top-level IIFEs sharing nothing but `window`, and only this one closes over `csrf`.
  window.__rovaCsrf = {
    token: function () { return csrf; },
    apply: csrfApply,
    refresh: csrfRefresh,
    send: csrfSend,
    notice: csrfStaleNotice,
    message: CSRF_STALE_MSG,
    dead: function () { return csrfDead; }
  };

  // Referral attribution for edge-cached guest pages. The HTML for a profile/permalink is served
  // from Cloudflare and never re-runs Referrals::touch(), so the credit that used to be written
  // during render is reported here instead. Without this, signups from a founder's link would be
  // attributed to nobody -- silently. Fire-and-forget; a failure costs one click, never the page.
  (function () {
    var m = document.querySelector('meta[name="rova-ref"]');
    if (!m || !m.content) return;
    var parts = String(m.content).split(':');
    var author = parseInt(parts[0], 10);
    if (!(author > 0)) return;
    var src = parts[1] || 'profile';
    try {
      // credentials: the whole point is to establish/carry the session that holds ref_by.
      fetch('/r/touch?a=' + author + '&s=' + encodeURIComponent(src), {
        method: 'GET', credentials: 'same-origin', cache: 'no-store', keepalive: true
      }).catch(function () {});
    } catch (e) {}
  })();

  // ENTRY CREDIT (2026-10-17): a cached BARE /@handle or /live/{id} carries <meta name="rova-entry"> naming the
  // owner / host. Only an ARRIVAL from outside counts (document.referrer empty or another site); browsing from
  // inside Rova does not, so e=0 is sent for that and the server credits nothing (Referrals::touchEntry).
  (function () {
    var m = document.querySelector('meta[name="rova-entry"]');
    if (!m || !m.content) return;
    var parts = String(m.content).split(':');
    var owner = parseInt(parts[0], 10);
    if (!(owner > 0)) return;
    var ext = 1;
    try {
      var r = document.referrer || '';
      if (r) { var rh = new URL(r).hostname.replace(/^www\./, ''); if (rh === location.hostname.replace(/^www\./, '')) ext = 0; }
    } catch (e) { ext = 1; }
    try {
      fetch('/r/touch?a=' + owner + '&s=entry&k=' + (parts[1] === 'live' ? 'live' : 'profile') + '&e=' + ext, {
        method: 'GET', credentials: 'same-origin', cache: 'no-store', keepalive: true
      }).catch(function () {});
    } catch (e) {}
  })();

  // web#22: /?code=X promo links land on the EDGE-CACHED guest homepage, whose
  // render is session-free — the old $_SESSION['promo_code'] write never happened
  // and the signup field stayed empty. Same cure as the referral credit above:
  // report the code on an uncached beacon that DOES carry the session, plus a
  // localStorage copy so the signup form prefills even if the beacon lost.
  (function () {
    var m = /[?&]code=([A-Za-z0-9_-]{3,40})/.exec(location.search);
    var code = m ? m[1].toUpperCase() : '';
    if (code) {
      try { localStorage.setItem('rova_promo', code); } catch (e) {}
      try {
        fetch('/r/touch?promo=' + encodeURIComponent(code), {
          method: 'GET', credentials: 'same-origin', cache: 'no-store', keepalive: true
        }).catch(function () {});
      } catch (e) {}
    }
    var saved = code;
    if (!saved) { try { saved = localStorage.getItem('rova_promo') || ''; } catch (e) {} }
    if (saved) {
      // BOTH promo fields: the /signup page's #promo AND the guest auth modal's
      // (the modal ships inside the cached page, so only this client-side fill
      // can ever prefill it — the owner's screenshot was the modal, empty)
      //
      // AND OPEN THE DISCLOSURE THE FIELD NOW LIVES IN (2026-08-25). Both promo
      // inputs sit inside a collapsed <details class="promo-dis">, so a prefill
      // that only wrote .value would put a code somebody followed a link for into
      // a box they cannot see — the exact "hunt for the hidden field" this whole
      // change was supposed to avoid. views/signup.php renders `open` server-side
      // when it knows the code at render time; THIS path is the one the server
      // cannot see (edge-cached HTML, code recovered from localStorage), so the
      // reveal has to happen here.
      [document.getElementById('promo'), document.querySelector('#auth-modal input[name="promo"]')]
        .forEach(function (f) {
          if (!f || f.value) return;
          f.value = saved;
          var d = f.closest ? f.closest('details') : null;
          // [data-promo-held]: while the Founder offer is open the promo field is NEVER shown (Rob
          // 2026-10-11: "Remove promo code until founders is full"). The server now renders it as a
          // type=hidden input (no <details>, so d is null); a stale cached body may still carry the
          // 10-10 `<details hidden data-promo-held>` -- leave that hidden and closed. The value is
          // still written above, so the linked code is POSTed silently.
          if (d && !d.hasAttribute('data-promo-held')) d.open = true;
        });
    }
  })();

  /* THE ONE COUNT RULE (owner, 2026-09-17: "I rather see the actual number 132 or so and if it
     gets to 999+ just do 1.0k"). 0..999 exact; then ALWAYS one decimal + lower-case k/m/b:
     1,000 -> "1.0k", 1,049 -> "1.0k", 1,050 -> "1.1k", 9,999 -> "10.0k", 999,949 -> "999.9k",
     999,950 -> "1.0m" (a value that rounds to 1000.0 of a unit PROMOTES, never "1000.0k").
     Round half up in INTEGER arithmetic -- floor((n + 50) / 100) is the count in tenths of a
     thousand -- so this and fmt_count() in lib/view.php cannot disagree through a float. Mirrors
     fmt_count() exactly (its docblock is the spec; tools/count-format-check.php asserts the two
     agree on every boundary). approxCount() below is its inverse and reads "1.0k" fine. */
  function fmtCount(n) {
    n = Math.max(0, Math.floor(+n || 0));
    if (n < 1000) return String(n);
    var units = [[100, 'k'], [100000, 'm'], [100000000, 'b']];   // tenths-divisor, suffix
    for (var i = 0; i < units.length; i++) {
      var t = Math.floor((n + units[i][0] / 2) / units[i][0]);   // tenths of the unit, rounded half up
      if (t >= 10000 && units[i][1] !== 'b') continue;           // 1000.0 of this unit -> next unit
      return Math.floor(t / 10) + '.' + (t % 10) + units[i][1];
    }
    return String(n);
  }
  window.__rovaFmtCount = fmtCount;   // the ONE formatter, for IIFEs outside this one (the media ring's like-milestone chip, 2026-10-12)

  // Publish the real header height on EVERY page (sticky offsets depend on it).
  // The feed module also sets this, but only on the feed; pages like /people
  // were falling back to 60px and sticking flush against a ~74px header.
  // #508/#509: this write is not free. Setting a custom property on :root
  // invalidates the computed style of EVERY element in the document, and doing
  // it unconditionally at init cost the map a second full-document recalc
  // (188ms across ~1,380 elements) landing between the first paint and FCP.
  // rova.css now declares the real value (:root{--topbar-h:65px}, 0px under
  // .app-embed), so the common case needs no write at all -- we only publish
  // when the header genuinely measures something else, which is the case the
  // resize handler existed for. Read the computed value off <body>, not <html>:
  // .app-embed sets it on the body, so the root's value is not what the sticky
  // offsets are actually resolving against.
  // 2026-08-06: THIS IS NOW THE ONLY IMPLEMENTATION. The feed module used to carry a
  // byte-identical second copy (setTopbarH + its own resize listener); it now just calls
  // window.__rovaSetTopbarH. Two writers of one custom property is a bug waiting to be
  // written, not a redundancy.
  //
  // AND A `resize` LISTENER CANNOT SEE THE HEADER CHANGE SHAPE. The header can change
  // height with the window standing perfectly still -- a late font, an avatar that lands
  // with different intrinsic metrics, a control row that wraps, a banner appearing inside
  // it -- and none of that fires `resize`. Measured on the live feed in WebKit at 390px:
  // force the topbar 65px -> 93px with no resize and --topbar-h stayed 65px, so the sticky
  // sub-header pinned at top:64 with 29px of itself tucked BEHIND a 93px header; only a
  // window resize healed it. That is the same shape as the carousel's pinned inline width
  // (see the memory note): a measured value with no revalidation path except "the reader
  // happens to resize the window". A ResizeObserver on the header closes it.
  //
  // PERF, do not regress: the write itself is the expensive part (#508/#509 above), so it
  // stays CONDITIONAL. The observer cannot write per frame -- it only fires when the border
  // box actually changes, the `last` cache short-circuits a repeat before getComputedStyle
  // is even called, and writing --topbar-h cannot resize .topbar (nothing in the header
  // reads it), so there is no feedback loop.
  //
  // 2026-09-05: THE VALUE IS THE STACK BOTTOM, NOT THE HEADER'S HEIGHT. With the "get the
  // app" bar up (body.has-appbar, rova.css) the topbar is sticky at top:56px, so the header
  // ends at 56 + 65 = 121 while this used to publish 65 -- and #feed-tabs (top: --topbar-h
  // - 1px) pinned 57px UNDER the header (owner: "Sub header isn't sticking on web"). The
  // topbar's computed `top` is the used value in px for a positioned element in both
  // engines ("56px" with the bar, "0px" without, "0px" for the display:none .app-webview
  // case where offsetHeight is 0 too), so `top + offsetHeight` is exactly where the header
  // stack ends, in every state. rova.css declares the same 121 on <html> via :has() so the
  // common case still needs no write; the bar's dismiss handler calls this because the
  // ResizeObserver below cannot see `top` change (the header keeps its height and only
  // moves up by 56px).
  (function () {
    var tb = document.querySelector('.topbar');
    var last = '';
    function set() {
      if (!tb) { tb = document.querySelector('.topbar'); if (!tb) return; }
      var v = ((parseFloat(getComputedStyle(tb).top) || 0) + tb.offsetHeight) + 'px';
      if (v === last) return;                       // nothing moved: no root write
      var el = document.body || document.documentElement;
      last = v;
      if (getComputedStyle(el).getPropertyValue('--topbar-h').trim() === v) { return; }
      document.documentElement.style.setProperty('--topbar-h', v);
    }
    window.__rovaSetTopbarH = set;
    set();
    window.addEventListener('resize', set);
    if (tb && typeof ResizeObserver === 'function') {
      try { new ResizeObserver(set).observe(tb, { box: 'border-box' }); } catch (e) {}
    }
  })();

  // CHROME PAINT GUARANTEE (owner: "never catch it missing again").
  //
  // THE FAULT CLASS: a compositor-promoted box can rasterize BLANK and keep serving that stale
  // texture. Layout is correct -- the element still occupies its space -- but nothing is drawn in
  // it, so the page reads as "that piece of the UI didn't load". A display flush re-runs LAYOUT and
  // repaints; a window RESIZE invalidates every layer outright, which is why resizing was for a
  // long time the only known cure. Anything with the signature "it's blank until I resize the
  // window" is this, and nothing else.
  //
  // WHICH ELEMENTS: the two pieces of feed chrome that ever get their own layer.
  //   #feed-aside  -- position:sticky at >=900px (rova.css). Its overflow was moved to an inner
  //                   .aside-scroll so it is never sticky AND scrollable at once, but STICKY ALONE
  //                   is enough for WebKit to promote it, so the guarantee still has to cover it.
  //   #feed-tabs   -- position:relative at rest, but `#feed-wrap.chrome-idle #feed-tabs` makes it
  //                   position:sticky + full-bleed + opaque. That is a layer created MINUTES-late,
  //                   long after first paint (see setCollapsed, below) -- see WHEN.
  //
  // WHEN (this is the part that was missing, 2026-07-29): the old version of this block ran only on
  // the ways a PAGE surfaces -- parse, rAF, load, aside images, bfcache, tab re-foreground. Every
  // one of those has already fired by ~2s. But the feed collapses into watch mode on an idle timer
  // ~5.4s after load (IDLE_MS 4500 + a 900ms poll settle), and THAT is when #feed-tabs is promoted
  // and the aside's sticky geometry shifts under it. So the one moment most likely to hand back a
  // blank raster was the one moment nothing re-ran the flush. Reported as: "site just loaded
  // without subheader and sidebar in view, fixed by resizing the window". setCollapsed() now calls
  // window.__rovaChromeRepaint on both transitions.
  //
  // The flush itself is deliberately paranoid: restore in a FINALLY (an element left at
  // display:none by a throw between the two writes is the exact bug this guards against, and a
  // resize would NOT recover from that), and put scroll back if removing an element from flow made
  // the browser clamp it.
  (function () {
    var IDS = ['feed-aside', 'feed-tabs'];
    function flush(el) {
      if (!el) return;
      // only when it's meant to be visible (the aside is display:none <900px by design)
      var cs; try { cs = getComputedStyle(el); } catch (e) { return; }
      if (cs.display === 'none' || cs.visibility === 'hidden') return;
      var prev = el.style.display;
      try {
        el.style.display = 'none';
        void el.offsetHeight;            // force a layout with the element removed
      } finally {
        el.style.display = prev || '';   // ALWAYS restore -> re-lays-out AND repaints
      }
    }
    function repaintChrome() {
      // Taking #feed-tabs out of flow shortens the document; if the reader is near the bottom the
      // browser clamps scrollTop and would NOT put it back on its own. Same task, no paint between,
      // so restoring here is invisible.
      var sx = window.scrollX || 0, sy = window.scrollY || 0;
      for (var i = 0; i < IDS.length; i++) {
        try { flush(document.getElementById(IDS[i])); } catch (e) {}
      }
      if ((window.scrollX || 0) !== sx || (window.scrollY || 0) !== sy) {
        try { window.scrollTo(sx, sy); } catch (e) {}
      }
    }
    // Published so the feed module can re-run it at the exact moment it re-composites the chrome.
    window.__rovaChromeRepaint = repaintChrome;

    repaintChrome();
    if (document.readyState !== 'complete') window.addEventListener('load', repaintChrome, { once: true });
    // pageshow fires on bfcache restore too (persisted === true): the exact case
    // where the browser brings back a page with the sticky layer un-painted.
    window.addEventListener('pageshow', function (e) { if (e.persisted) repaintChrome(); });
    // late images inside the aside (the reach avatar + Discover-people thumbs)
    // load AFTER first paint and grow the sticky box -- re-raster once they land.
    window.addEventListener('load', function () {
      var el = document.getElementById('feed-aside');
      if (!el) return;
      Array.prototype.forEach.call(el.querySelectorAll('img'), function (img) {
        if (!img.complete) img.addEventListener('load', repaintChrome, { once: true });
      });
    });
    // returning to a backgrounded tab can also surface an un-rastered layer
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') repaintChrome();
    });
    // a couple of settle frames catch a paint that raced webfont/image layout
    if (typeof requestAnimationFrame === 'function') {
      requestAnimationFrame(function () { requestAnimationFrame(repaintChrome); });
    }

    // ---- LATE MUTATIONS OF THE ASIDE (2026-07-30) ---------------------------------------------
    // SECOND RECURRENCE, and it came from /@handle, not the feed. Two things make a profile page
    // different, and both of them point the same way:
    //
    //   1. A profile page has NO #feed-wrap, so setCollapsed() -- the ONLY thing that re-ran this
    //      flush after first paint -- never fires there at all. Everything else above has fired by
    //      ~2s. So after two seconds a profile page had no guarantee left.
    //   2. The profile aside is the busiest one on the site. The Growth card is REPLACED wholesale
    //      by its own 30s poll (~:16367) and Discover-people swaps a row every 15-25s (~:14916),
    //      both INSIDE the sticky, compositor-promoted #feed-aside. And the Growth card carries
    //      .gc-halo / .gc-dot, which run INFINITE transform+opacity animations (rova.css ~:5101):
    //      every swap therefore builds a fresh composited layer inside the promoted sticky box,
    //      minutes after load. That is the trigger this whole block exists for, and it was the one
    //      moment nothing re-ran the flush -- same lesson as 2026-07-29, one surface later.
    //
    // GENERIC ON PURPOSE. This has now been reported from three different mutation sites; a third
    // one-off call would be invisible to the next thing that touches the aside. Watch the element.
    // The mechanism is the easy part -- the guards are what keep it honest:
    //   * childList + subtree ONLY. No attributes (so our own display flush cannot retrigger us --
    //     that would be an infinite loop) and no characterData.
    //   * ELEMENT adds/removes only. Every text-only writer in the aside -- reachRefresh()'s
    //     <strong>s (~:2197), the .js-countup tween that rewrites a number every frame, the growth
    //     headline -- replaces a TEXT node, and we ignore those. A digit changing inside a fixed
    //     box re-composites nothing, and flushing once per countup frame is precisely the
    //     always-running cost that got stripped out of this file.
    //   * coalesced onto one rAF and rate-limited to one flush per MIN_MS, with the trailing edge
    //     kept so a burst still ENDS painted. There is no interval here: zero cost while the aside
    //     is quiet. Steady state on a profile page is ~4 flushes per MINUTE, only on real change
    //     (the growth poll now skips an unchanged card outright rather than re-inserting it).
    //   * flush() already no-ops when the aside is display:none, i.e. below 900px, so phones pay
    //     one getComputedStyle per burst and nothing else.
    (function () {
      if (typeof MutationObserver !== 'function') return;
      var aside = document.getElementById('feed-aside');
      if (!aside) return;
      var MIN_MS = 800, last = 0, pending = false;
      function fire() { pending = false; last = Date.now(); repaintChrome(); }
      function schedule() {
        if (pending) return;                              // already coalescing this burst
        pending = true;
        setTimeout(function () {
          if (typeof requestAnimationFrame === 'function') requestAnimationFrame(fire);
          else fire();
        }, Math.max(0, MIN_MS - (Date.now() - last)));    // 0 when we're past the rate limit
      }
      function hasElement(nodes) {
        for (var j = 0; j < nodes.length; j++) { if (nodes[j].nodeType === 1) return true; }
        return false;
      }
      new MutationObserver(function (recs) {
        for (var i = 0; i < recs.length; i++) {
          if (hasElement(recs[i].addedNodes) || hasElement(recs[i].removedNodes)) { schedule(); return; }
        }
      }).observe(aside, { childList: true, subtree: true });
    })();

    // ---- RECURRENCE SIGNAL -------------------------------------------------------------------
    // This bug is unreproducible on demand and leaves nothing in any server log: the HTML was
    // correct, the CSS was correct, the JS didn't throw -- a raster simply didn't happen. The one
    // thing that IS observable is the reader's reaction, because the only cure anyone ever finds is
    // to resize the window. So report the FIRST resize of each page load, once, with the chrome's
    // geometry and how long ago the feed collapsed. A record with `sinceCollapse` in the low
    // seconds is this bug; a record from someone who just dragged their window is the control
    // group. Members only (guests have no session to attribute to), one row per page load, into
    // the existing bounded/kill-switched compose-trace sink.
    /* WIDENED 2026-08-02, after the FOURTH report produced no record at all.
     *
     * Two gaps, and between them they guaranteed the one occurrence we most wanted was invisible:
     *
     *   1. ONE report per page load. A reader who had already nudged their window for any other
     *      reason had spent it, so the resize that actually cured the blank chrome went unheard.
     *      Now the first few, a second apart. Three is still nothing next to the volume this sink
     *      already carries.
     *   2. It returned silently when NEITHER element was in the DOM -- and "was the aside even
     *      rendered?" is exactly the question that separates a paint skip (element present, space
     *      reserved, nothing drawn) from a breakpoint miss (element absent by design). Learning
     *      nothing in that case threw away the discriminator. It now always reports, and geo()
     *      already yields '-' for an element that is not there.
     *
     * dpr + outerW exist for the breakpoint case the CSS note above describes: a hi-DPI window at
     * 150% zoom falls under the 900px query, which hides the aside BY DESIGN and is indistinguishable
     * from the bug from the reader's chair. innerW vs outerW tells those two apart in one glance.
     * path is here because this has now been reported from the feed AND from /@handle, which have
     * different chrome and different mutation patterns. */
    /* WHAT THE FIFTH REPORT ACTUALLY PROVED (2026-08-03). Read this before touching the flush.
     *
     * This time the sink DID produce rows. Desktop Safari 18.6, owner's account, /feed:
     *
     *   11:24:31Z n=1 sinceLoad=4989 w=686  outerW=1186 dpr=2 aside="0x0@0 none/static"
     *   11:24:35Z n=2 sinceLoad=9067 w=1186 outerW=1186 dpr=2 aside="322x629@79 block/sticky"
     *
     * At the sampled instant the aside was IN the DOM and computed display:none, because
     * innerWidth was 686 CSS px, under the 900px query. Hidden BY DESIGN. Not a paint skip.
     * That is a breakpoint miss, and the CSS note above already predicted this exact shape.
     *
     * But look at what else is true. outerWidth was 1186 at BOTH samples, and scroll-log has the
     * same session at vw=1186 continuously all day, immediately before and immediately after.
     * The WINDOW never changed size; something inside it ate 500 CSS px of viewport. And the DOM
     * the owner pasted from the broken load carried style="" on both #feed-aside and #feed-tabs,
     * which the server never emits (views/_feed_aside.php has no style attribute), so it can only
     * have come from flush() restoring el.style.display. flush() RETURNS EARLY on display:none,
     * so it must have run while the aside was display:block, i.e. the page loaded at >=900 CSS px
     * and only went narrow afterwards.
     *
     * So the record and the report are about two different moments, and the honest conclusion is
     * that THIS INSTRUMENT CANNOT ANSWER THE QUESTION. It fires only on resize, so it samples the
     * page during the cure, never during the fault. Everything below fixes that, and nothing below
     * changes the flush: a sixth call site was already falsified by that style="" fossil.
     *
     *   w0     innerWidth AT PARSE, before a pinch, a docked Web Inspector or a window drag can
     *          move it. If w0 is under 900 the sidebar was never going to show and there is no
     *          bug; if w0 is 1186 and w is 686 the viewport shrank after load. One field, whole
     *          question. This is the field whose absence cost us this occurrence.
     *   wmin   the narrowest innerWidth seen since parse, so a dip that has already recovered by
     *          the time anything reports still leaves a mark.
     *   zoom   MEASURED page zoom, and it is the field that names the culprit. CSS `resolution`
     *          is device pixels per CSS pixel and DOES include page zoom; WebKit's
     *          window.devicePixelRatio is the raw device scale and does NOT, which is why every
     *          record above reads dpr:2 no matter how zoomed the page was. Their ratio is the zoom
     *          factor. zoom>1 means the reader zoomed (a macOS trackpad pinch does this, and it is
     *          continuous, which fits 1186/686=1.73 and the earlier 1186/946=1.25 far better than
     *          any stepped Cmd+ level). zoom==1 with outerW>>innerW means something took the width
     *          instead, and a Web Inspector docked to the right of the window is the obvious
     *          candidate for a person who has been asked five times to paste us the DOM. */
    var t0 = Date.now(), sent = 0, lastSent = 0;
    var w0 = window.innerWidth, wmin = w0;

    function chromeGeo(id) {
      var el = document.getElementById(id);
      if (!el) return '-';
      var r = el.getBoundingClientRect(), c = getComputedStyle(el);
      return Math.round(r.width) + 'x' + Math.round(r.height) + '@' + Math.round(r.top)
           + ' ' + c.display + '/' + c.position;
    }

    // Binary search because there is no way to read the zoom factor directly. ~22 matchMedia
    // calls, and only on a path that is already about to POST, so it is never on a hot path.
    function zoomFactor() {
      try {
        if (typeof matchMedia !== 'function') return 0;
        var q = matchMedia('(min-resolution: 1dppx)').media !== 'not all'
          ? function (v) { return '(min-resolution: ' + v + 'dppx)'; }
          : function (v) { return '(-webkit-min-device-pixel-ratio: ' + v + ')'; };
        var lo = 0.2, hi = 12, mid;
        for (var i = 0; i < 22; i++) {
          mid = (lo + hi) / 2;
          if (matchMedia(q(mid)).matches) lo = mid; else hi = mid;
        }
        return Math.round(((lo + hi) / 2) / (window.devicePixelRatio || 1) * 100) / 100;
      } catch (e) { return 0; }
    }

    // the two surfaces that render an aside. /@handle only, not /@handle/following: those
    // sub-pages have no aside by design and would otherwise report 'absent' on every load.
    function chromeSurface() {
      var p = location.pathname;
      return p === '/' || p === '/feed' || (p.charAt(1) === '@' && p.indexOf('/', 1) === -1);
    }

    window.addEventListener('resize', function () {
      var now = Date.now(), iw = window.innerWidth;
      if (iw < wmin) wmin = iw;                       // tracked on EVERY resize, not just reported ones
      if (sent >= 3 || (now - lastSent) < 1000) return;
      // keep unrelated pages out of the sink, but never gate on the element EXISTING
      var p = location.pathname;
      if (!document.getElementById('feed-tabs') && !document.getElementById('feed-aside')
          && !(p === '/' || p === '/feed' || p.charAt(1) === '@')) { return; }
      sent++; lastSent = now;
      try {
        (window.__rovaBeacon || function () {})('chrome:resize', {
          n: sent,
          sinceLoad: now - t0,
          sinceCollapse: window.__rovaCollapsedAt ? (now - window.__rovaCollapsedAt) : -1,
          collapsed: document.documentElement.classList.contains('feed-collapsed') ? 1 : 0,
          w: iw, w0: w0, wmin: wmin, outerW: window.outerWidth || 0,
          dpr: Math.round((window.devicePixelRatio || 1) * 100) / 100,
          zoom: zoomFactor(),
          y: Math.round(window.scrollY || 0),
          path: p.slice(0, 40),
          tabs: chromeGeo('feed-tabs'), aside: chromeGeo('feed-aside'), chrome: chromeGeo('feed-chrome')
        });
      } catch (e) {}
    }, { passive: true });

    /* ---- STEADY-STATE RECORD, the one the resize signal could never give us -------------------
     * Sampled at a FIXED moment instead of waiting for the reader to react, so the next report is
     * settled by what is in the log rather than by what we can talk ourselves into. Twice: once
     * early, once after the ~5.4s watch-mode collapse that promotes #feed-tabs.
     *
     * It reports ONLY an anomaly, which is what keeps it free. A normal desktop load with the
     * sidebar in place says nothing; a phone says nothing and neither does a genuinely small
     * desktop window, because outerWidth < 900 returns before anything else runs and a sidebar
     * missing from a 700px window is not a mystery to the person who made the window 700px.
     * What it does catch:
     *
     *   narrow      the aside is hidden while the WINDOW is wide and the VIEWPORT is not. That is
     *               the only breakpoint miss a reader cannot see the cause of, and it is exactly
     *               the state the 11:24 rows caught by accident. zoom names which kind it is.
     *   absent      the server did not render the aside at all.
     *   degenerate  present and displayed, but laid out at nothing.
     *
     * AND ITS SILENCE IS EVIDENCE. If the owner reports a missing sidebar and this fires nothing
     * for that load, then the aside was present, display:block, correctly sized, in a full-width
     * viewport, at both 1.2s and 7s. Layout was right and nothing was drawn. That is the paint
     * skip, proved by elimination, and only THEN is the flush above the thing to go after. Note
     * beacon() caps a page at 4 records total, so this one costs the resize signal nothing it was
     * going to use: it spends the first slot and leaves three. */
    (function () {
      var told = false;
      function check() {
        if (told || !chromeSurface()) return;
        var iw = window.innerWidth, ow = window.outerWidth || 0;
        // A window too small to hold the aside is never a mystery to the person who sized it,
        // and this one test is what keeps every phone in the fleet out of the sink.
        if (ow < 900) return;
        var why = '', el = document.getElementById('feed-aside');
        if (!el) {
          why = 'absent';
        } else {
          var c = getComputedStyle(el), r = el.getBoundingClientRect();
          if (c.display === 'none' || c.visibility === 'hidden') {
            if ((ow - iw) >= 100) why = 'narrow';
          } else if (r.width < 40 || r.height < 40) {
            why = 'degenerate';
          }
        }
        if (!why) return;
        told = true;
        try {
          (window.__rovaBeacon || function () {})('chrome:hidden', {
            why: why,
            sinceLoad: Date.now() - t0,
            collapsed: document.documentElement.classList.contains('feed-collapsed') ? 1 : 0,
            w: iw, w0: w0, wmin: wmin, outerW: ow,
            dpr: Math.round((window.devicePixelRatio || 1) * 100) / 100,
            zoom: zoomFactor(),
            path: location.pathname.slice(0, 40),
            aside: chromeGeo('feed-aside'), tabs: chromeGeo('feed-tabs')
          });
        } catch (e) {}
      }
      setTimeout(check, 1200);
      setTimeout(check, 7000);
    })();
  })();

  // tell the server the viewer's timezone (for local-time prompts/timestamps)
  try {
    var tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (tz) document.cookie = 'rova_tz=' + encodeURIComponent(tz) + ';path=/;max-age=31536000;samesite=Lax';
  } catch (e) {}

  var SVG0 = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">';
  var ICO = {
    follow:    SVG0 + '<path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><line x1="19" y1="8" x2="19" y2="14"/><line x1="22" y1="11" x2="16" y2="11"/></svg>',
    following: SVG0 + '<path d="M20 6.5 9 17.5l-5-5"/></svg>',
    mute:      SVG0 + '<path d="M11 5 6 9H2v6h4l5 4V5z"/><line x1="23" y1="9" x2="17" y2="15"/><line x1="17" y1="9" x2="23" y2="15"/></svg>',
    unmute:    SVG0 + '<path d="M11 5 6 9H2v6h4l5 4V5z"/><path d="M15.5 8.5a5 5 0 0 1 0 7"/><path d="M19 5a9 9 0 0 1 0 14"/></svg>',
    /* the MUTED state of the profile's mute button -- a person with an X, the twin of icon('mute-user')
       in lib/view.php. `unmute` above (a speaker with sound coming OUT) used to be painted for it, which
       reads as "not muted" on a button that carried no other state signal at all. */
    muteUser:  SVG0 + '<path d="M15.5 21v-2a4 4 0 0 0-4-4H5.5a4 4 0 0 0-4 4v2"/><circle cx="8.5" cy="7" r="4"/><line x1="16.5" y1="8" x2="22.5" y2="14"/><line x1="22.5" y1="8" x2="16.5" y2="14"/></svg>',
    bell:      SVG0 + '<path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>',
    bellOn:    SVG0 + '<path fill="currentColor" stroke="none" d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/><path class="bell-wave" d="M20.4 4.2a8.9 8.9 0 0 1 1.8 3.6"/><path class="bell-wave" d="M3.6 4.2a8.9 8.9 0 0 0-1.8 3.6"/></svg>'
  };

  /* device-local feed preferences (gear next to Live); all default ON */
  function feedPref(key, def) {
    try { var v = localStorage.getItem('rova_' + key); return v === null ? def : v === '1'; }
    catch (e) { return def; }
  }
  function setFeedPref(key, on) {
    try { localStorage.setItem('rova_' + key, on ? '1' : '0'); } catch (e) {}
    document.dispatchEvent(new CustomEvent('rova:feedpref', { detail: { key: key, on: on } }));
  }

  function escHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---- the no-photo monogram letter, client side ------------------------
   * A MIRROR OF NameText::initial() (lib/nametext.php): display_name, then username, then '?'.
   *
   * WHY IT HAS TO BE A MIRROR. The server reconciled its three monogram surfaces onto that rule
   * (avatar_img(), the embed card, the notification email). app.js draws three MORE monograms in
   * the browser and they kept cutting `username`, so the two halves of the same page disagreed --
   * and one of those three is the OPTIMISTIC COMMENT ROW, which lands in the same list as the
   * server-rendered comments. Post a comment and the chip showed one letter; refresh and the very
   * same comment showed a different one. On this box 3,034 of the 6,735 photo-less members have a
   * display name whose first letter differs from their handle's, so that was not a rare shape.
   *
   * THE JS TRAP IS NOT THE PHP ONE. PHP's bug was substr() cutting BYTES. JS strings are UTF-16,
   * so `s[0]` / charAt(0) cuts a SURROGATE PAIR in half and paints a lone unpaired surrogate --
   * the replacement box, not a letter. Array.from() iterates by CODE POINT, which is exactly what
   * mb_substr($s, 0, 1) does. Two photo-less members here are 4-byte cases (@Iambabypross opens
   * with U+1F49E, @kaxmya1124 with U+1D440 MATHEMATICAL SCRIPT CAPITAL M) and charAt(0) breaks
   * both; five more are 2- and 3-byte (Arabic, Limbu, a curly quote, a Latin S-acute).
   *
   * THE STRIP mirrors NameText::plain(): C0/C1 controls to a space, then the zero-width / soft
   * hyphen / BOM / bidi embed-override-isolate controls to nothing, then trim. Not cosmetic --
   * plain() exists because a name that OPENS with U+202A would otherwise make "the first
   * character" an invisible control and leave the chip reading blank. Invalid UTF-8 needs no
   * counterpart: this string arrived as JSON and is already a decoded JS string.
   *
   * toUpperCase() and NOT toLocaleUpperCase(). The locale-aware form is the one that breaks
   * parity: under a Turkish locale it maps i -> U+0130, while PHP's mb_strtoupper() is
   * locale-independent and yields I. The server cannot know the reader's locale, so the only
   * letter that can agree with it is the locale-invariant one.
   *
   * The SECOND cut after uppercasing is not redundant, for the same reason NameText spells out:
   * uppercasing is not length-preserving (sharp s -> SS, the fi ligature -> FI) and two letters
   * on a 22px chip is a different design.
   */
  var NAME_CTRL = /[\u0000-\u001F\u007F-\u009F]+/g;
  var NAME_ZERO = /[\u00AD\u200B-\u200F\u2028\u2029\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF]+/g;
  function nameInitial(display, username) {
    var cand = [display, username];
    for (var i = 0; i < cand.length; i++) {
      var s = String(cand[i] == null ? '' : cand[i]).replace(NAME_CTRL, ' ').replace(NAME_ZERO, '').trim();
      if (s === '') { continue; }
      return Array.from(Array.from(s)[0].toUpperCase())[0];
    }
    return '?';
  }

  // Append our explicit AJAX flag, survives IIS/proxies that strip Accept/X-Requested-With.
  function ajaxUrl(u) { return u + (u.indexOf('?') === -1 ? '?' : '&') + 'ajax=1'; }

  // Serialize a FormData / URLSearchParams to a urlencoded string. Done manually
  // because `new URLSearchParams(new FormData(...))` THROWS in Safari, and because
  // multipart/form-data isn't reliably parsed into PHP's $_POST on IIS.
  function encodeForm(fd) {
    var pairs = [];
    fd.forEach(function (v, k) { pairs.push(encodeURIComponent(k) + '=' + encodeURIComponent(v)); });
    return pairs.join('&');
  }

  /* Drop any _csrf pair out of an encoded body so the CURRENT token can be put back at send time.
     THE HEADER IS NOT ENOUGH, and this is the trap that would have made the whole refresh useless
     for half the app: Security::requireCsrf() reads `$_POST['_csrf'] ?? $_SERVER['HTTP_X_CSRF_TOKEN']`
     -- the BODY WINS. Every postForm() caller serialises a server-rendered <form>, and every one of
     those forms carries Security::csrfField(), so the baked token overrides whatever the header
     says. Refreshing the meta and the header while a stale `_csrf=` rode along in the body would
     have produced a retry that 419'd for exactly the same reason as the first attempt. */
  function bodyWithoutCsrf(body) {
    if (!body) { return ''; }
    return String(body).split('&').filter(function (p) { return p.slice(0, 6) !== '_csrf='; }).join('&');
  }

  // Shared AJAX POST: urlencoded body + ajax flag, with reauth + non-JSON handling.
  // `data` may be a FormData, URLSearchParams, or a plain {key:value} object.
  //
  // THE ONE FUNNEL. Roughly sixty-five call sites reach the server through here -- /like, /repost,
  // /follow, /comment, /bookmark, /pin, /block, /post/delete, /post/edit, the grid reorder, the
  // admin tools -- so routing it through csrfSend is what makes a stale token self-heal everywhere
  // at once rather than one endpoint at a time. `body` is a serialised STRING, so the single
  // permitted retry re-sends identical bytes; nothing here is a consumable stream. The one field
  // that must NOT be identical is `_csrf` -- see bodyWithoutCsrf above for why the body, not the
  // header, is the token the server actually reads.
  // `ms` (optional): a hard deadline for THIS post. On a dead cell a plain fetch holds a half-open
  // socket for 60-120s; every handler that restores state in .catch was therefore leaving the
  // member staring at nothing for a minute-plus. With a deadline the abort rejects the promise and
  // the handler's NORMAL failure path runs (restore the text, say "check your connection") at a
  // human timescale instead. Omitted = the old unbounded behaviour, so no existing caller changes.
  function postJson(url, data, ms) {
    var body;
    if (data && typeof data.forEach === 'function') {
      body = encodeForm(data);                 // FormData / URLSearchParams
    } else {
      var fd = new FormData();
      Object.keys(data || {}).forEach(function (k) { fd.append(k, data[k]); });
      body = encodeForm(fd);
    }
    var bare = bodyWithoutCsrf(body);
    return csrfSend(function (token) {
      var opts = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-CSRF-Token': token,
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json'
        },
        // token in the body AND the header: the body is what requireCsrf() prefers, the header is
        // what a body-less call (a plain {} payload) has to rely on.
        body: (bare ? bare + '&' : '') + '_csrf=' + encodeURIComponent(token),
        credentials: 'same-origin'
      };
      var tid = 0;
      if (ms && typeof AbortController === 'function') {
        var ctl = new AbortController();
        opts.signal = ctl.signal;
        // Per send() call on purpose: csrfSend may fire twice (419 heal), and a fresh deadline per
        // attempt is the honest one. Cleared once headers land -- the body read stays unbounded,
        // same as every other caller of fetch here.
        tid = setTimeout(function () { try { ctl.abort(); } catch (e) {} }, ms);
      }
      var p = fetch(ajaxUrl(url), opts);
      if (tid) { p.then(function () { clearTimeout(tid); }, function () { clearTimeout(tid); }); }
      return p;
    }).then(function (r) {
      // 419 SURVIVING csrfSend means the refresh could not help: the token came back unchanged, or
      // a token minted seconds ago was refused too. That is terminal, and it is the ONLY case a
      // member should ever be told about -- an ordinary stale token is now invisible to them.
      // Still thrown as 'reauth' because ~25 call sites read that sentinel to mean "say nothing and
      // do not roll back, the page is being put right"; the difference is that the page is no
      // longer yanked out from under them without a word.
      if (r.status === 419) { csrfStaleNotice(); throw new Error('reauth'); }
      if (r.status === 401) { window.location.reload(); throw new Error('reauth'); }
      var ct = r.headers.get('content-type') || '';
      if (ct.indexOf('application/json') === -1) {
        return r.text().then(function (t) {
          throw new Error('HTTP ' + r.status + ', ' +
            (t.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 140) || 'non-JSON response'));
        });
      }
      return r.json();
    });
  }

  // NB: getAttribute('action'), a form control named "action" (the follow form has
  // one) shadows form.action, returning the input element instead of the URL string.
  function postForm(form) {
    return postJson(form.getAttribute('action') || '/', new FormData(form));
  }

  /* ---- in-flight button state, the SHARED mechanism (2026-08-21) ----------------------------
     Owner, from a real dead-cell moment: he tapped the comment send and NOTHING moved, so he kept
     tapping. Two rules, applied to every control whose UI only changes when the server answers:
       1. the tap paints NOW -- .btn-busy (rova.css: gold ring spinner over a dimmed glyph,
          reduced-motion gets a static dim) the same tick the finger lands;
       2. a second tap during flight is a NO-OP -- busyIs() at the top of the handler, BEFORE any
          optimistic clearing, so the text a member typed mid-flight is never swallowed.
     Controls that are already optimistic (like, repost, comment-like, follow's instant flip...)
     are deliberately NOT wrapped: their instant state change IS the feedback and a spinner would
     make them feel slower.
       busyStart(btn[, ms])  paint busy now; returns the finisher (idempotent), or null if already
                             busy / no btn. The `ms` watchdog (default 20s) un-sticks the button if
                             a caller ever forgets a settle path -- the REQUEST deadline is the
                             separate postJson `ms` arg, which drives the handler's normal failure
                             path at ~15s, so the watchdog here is only the backstop behind it.
       busyUntil(btn, p)     busyStart tied to a promise: released on EITHER settle. Returns p.
       busyIs(btn)           the dedupe test.
     Exported on window because this file is several IIFEs: the later ones (pfeed viewer, trace
     overlay) reach these through window.__rovaBusy. */
  function busyIs(btn) {
    return !!(btn && btn.getAttribute && btn.getAttribute('data-rv-busy') === '1');
  }
  function busyStart(btn, ms) {
    if (!btn || !btn.setAttribute || busyIs(btn)) { return null; }
    btn.setAttribute('data-rv-busy', '1');
    btn.setAttribute('aria-busy', 'true');
    btn.classList.add('btn-busy');
    var wasDisabled = btn.disabled === true;
    if ('disabled' in btn) { btn.disabled = true; }   // belt: pointer-events:none is the braces
    var done = false, timer = setTimeout(fin, ms || 20000);
    function fin() {
      if (done) { return; }
      done = true;
      clearTimeout(timer);
      btn.removeAttribute('data-rv-busy');
      btn.removeAttribute('aria-busy');
      btn.classList.remove('btn-busy');
      if ('disabled' in btn && !wasDisabled) { btn.disabled = false; }
    }
    return fin;
  }
  function busyUntil(btn, p, ms) {
    var fin = busyStart(btn, ms);
    if (fin && p && typeof p.then === 'function') { p.then(fin, fin); }
    else if (fin) { fin(); }
    return p;
  }
  window.__rovaBusy = { is: busyIs, start: busyStart, until: busyUntil };

  /* NATIVE form posts (group join, channel subscribe, the whole /settings page, login/signup...)
     get the same treatment in ONE place. On a slow link the browser's own progress cue is a few
     grey pixels in a corner the thumb never looks at, and the submit button just sits there -- so
     people tap it again and the server sees two POSTs. WINDOW, not document, and bubble phase: a
     submit event reaches window after every document-level handler has run, so e.defaultPrevented
     is authoritative here -- any form a JS handler intercepted (js-comment, js-compose, the auth
     modal...) is skipped and keeps owning its own feedback.
     The button is NOT disabled: a disabled control drops out of the form data set, and several of
     these buttons carry a name/value the server branches on. The .btn-busy class kills its
     pointer-events (re-tap on the button) and the form-level flag eats Enter-key resubmits.
     The 15s re-arm is for a navigation that never comes; a bfcache Back is caught by pageshow. */
  window.addEventListener('submit', function (e) {
    var f = e.target;
    if (e.defaultPrevented || !f || !f.getAttribute) { return; }
    if (f.getAttribute('data-rv-busy') === '1') { e.preventDefault(); return; }
    f.setAttribute('data-rv-busy', '1');
    var btn = e.submitter || f.querySelector('button[type="submit"], input[type="submit"], button:not([type])');
    if (btn && btn.classList) { btn.classList.add('btn-busy'); btn.setAttribute('aria-busy', 'true'); }
    setTimeout(function () {
      f.removeAttribute('data-rv-busy');
      if (btn && btn.classList) { btn.classList.remove('btn-busy'); btn.removeAttribute('aria-busy'); }
    }, 15000);
  });
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) { return; }               // bfcache restore: clear any spinner frozen mid-flight
    Array.prototype.forEach.call(document.querySelectorAll('.btn-busy'), function (b) {
      b.classList.remove('btn-busy'); b.removeAttribute('aria-busy'); b.removeAttribute('data-rv-busy');
      if ('disabled' in b) { b.disabled = false; }
    });
    Array.prototype.forEach.call(document.querySelectorAll('form[data-rv-busy]'), function (f) {
      f.removeAttribute('data-rv-busy');
    });
  });

  /* ---- sticky sound preference -------------------------------------------
     Unmuting ONE video means "I want to hear videos" everywhere (feed, gallery,
     next page load); muting one means silence again. Stored, not per-session. */
  // Arriving from an embed's "Continue on Rova" (?sound=1): the viewer was watching WITH sound, so turn the
  // sticky sound pref ON before anything reads it -> the auto-opened post video comes up unmuted (as unmuted as
  // the browser's autoplay policy allows; the pref also means the very first tap unmutes).
  try { if (/[?&]sound=1(&|$)/.test(location.search)) { localStorage.setItem('rova_sound', '1'); } } catch (e) {}
  /* SOUND IS ON UNLESS THE READER SAID OFF (Rob 2026-09-26: "Videos should play automatically unmuted on
     the web app ... only way I should see muted stuff on the web app in feeds is if the person pressed
     mute"). Three stored states, and only one of them is a choice: '0' is the reader pressing mute (the
     declared-mute rule in the volumechange handler is the one writer), '1' is them unmuting, and ABSENT
     -- every reader who never touched a speaker -- now means ON, the same reading onboarding-comment.js
     and amSndMuted() already gave it. The browser still decides WHEN sound may start: nothing here
     unmutes before the first activation (see promoteSound / sndUnlocked in the sound closure). */
  function sndPref() {
    try { return localStorage.getItem('rova_sound') !== '0'; } catch (e) { return true; }
  }
  function sndRemember(on) {
    try { localStorage.setItem('rova_sound', on ? '1' : '0'); } catch (e) { /* private mode */ }
  }

  /* ---- like toggle ----------------------------------------------------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;

    if (form.classList.contains('js-react')) {
      e.preventDefault();
      var rxInput = form.querySelector('input[name="reaction"]');
      submitReact(form, (rxInput && rxInput.value) || 'heart');
      return;
    }

    /* ---- repost toggle ------------------------------------------------- */
    if (form.classList.contains('js-repost')) {
      e.preventDefault();
      // Membership first, ahead of the engage-hold and the optimistic flip below -- a refused
      // repost must not arm a 6s attention hold or paint a count it is going to take back.
      if (membershipStop()) { return; }
      engHold('repost', true, ENG_FIRE);   // engage-hold: reposting is engagement -- bounded, nothing reports back
      var rbtn = form.querySelector('.act');
      var rpost = form.closest('.post');
      var paintRepost = function (on, count) {
        engTouch(rpost || rbtn);   // optimistic paint AND the server's answer both land here
        if (rbtn) {
          rbtn.classList.toggle('on', on);
          rbtn.setAttribute('aria-pressed', on ? 'true' : 'false');
          rbtn.setAttribute('data-optcount', String(count));
          var rc = rbtn.querySelector('.cnt'); if (rc) { rc.textContent = fmtCount(count); rc.hidden = !count; }
        }
        /* The .rp-cluster repost tally in the old .react-summary row is GONE with that row (nothing
           renders either, server or client -- its only stylesheet rule is scoped INSIDE
           .react-summary), so this repainted nothing. The count the reader sees is the .cnt inside
           the repost button, painted above. (Removed 2026-08-10.) */
      };
      var wasOn = !!(rbtn && rbtn.classList.contains('on'));
      var wasCount = rbtn ? optCount(rbtn) : 0;
      /* INTENT, NOT INVERSION (2026-08-05). `state` is the END STATE this reader wants, so a tab
         whose button is stale -- they reposted from the phone after this page rendered -- can no
         longer UN-repost by clicking Repost. Written as a hidden field rather than passed as an
         argument because postForm() serialises the <form> itself; `rbtn` is the only thing that
         knows the current belief, and a button-less form (there is no such repost form today, but
         the guard costs nothing) simply omits it and gets the historic toggle. */
      if (rbtn) {
        var rst = form.querySelector('input[name="state"]');
        if (!rst) {
          rst = document.createElement('input');
          rst.type = 'hidden';
          rst.name = 'state';
          form.appendChild(rst);
        }
        rst.value = wasOn ? 'off' : 'on';
      }
      // instant flip; the response reconciles, a dead request rolls back
      paintRepost(!wasOn, Math.max(0, wasCount + (wasOn ? -1 : 1)));
      var q = form._rxq = (form._rxq || 0) + 1;
      // HOLD the repost badge until the write commits, so a /engage-live batch that left after the
      // flip above but read the database before it cannot tick the count back down. Released off
      // the request promise by engBadgeSettle, which covers the reauth branch below that returns
      // without repainting. (engBadgeArm/engBadgeSettle are declared beside engTouch further down
      // this same IIFE; function declarations hoist, and this handler runs long after.)
      var repSettle = engBadgeArm('repost', rpost || rbtn || form);
      engBadgeSettle(postForm(form), repSettle).then(function (res) {
        if (form._rxq !== q) return;
        if (!res || res.error) {
          paintRepost(wasOn, wasCount);
          if (res && res.error) toast(res.error);
          return;
        }
        paintRepost(!!res.reposted, +res.count || 0);
      }).catch(function (err) {
        if (!err || err.message === 'reauth') return;
        if (form._rxq === q) { paintRepost(wasOn, wasCount); toast('Couldn’t repost, check your connection'); }
      });
      return;
    }

    /* ---- follow-request actions (approve / deny / block / approve-all) ---- */
    if (form.classList.contains('js-req')) {
      e.preventDefault();
      var reqAction = (form.querySelector('input[name="action"]') || {}).value || '';
      var reqBtn = form.querySelector('button'); if (reqBtn) reqBtn.disabled = true;
      postForm(form).then(function (res) {
        if (!res || !res.ok) { if (reqBtn) reqBtn.disabled = false; return; }
        if (reqAction === 'approve-all') { location.reload(); return; }
        var row = form.closest('.req-row'); if (row) row.remove();
        if (!document.querySelector('.req-row')) location.reload();   // fall back to the empty state
      }).catch(function () { if (reqBtn) reqBtn.disabled = false; });
      return;
    }

    /* ---- remove a follower (from your own followers list) --------------- */
    if (form.classList.contains('js-remove-follower')) {
      e.preventDefault();
      if (!window.confirm('Remove this follower? They will stop seeing your posts.')) { return; }
      var rmBtn = form.querySelector('button'); if (rmBtn) rmBtn.disabled = true;
      postForm(form).then(function (res) {
        if (!res) { if (rmBtn) rmBtn.disabled = false; return; }
        var row = form.closest('.person'); if (row) row.remove();
      }).catch(function () { if (rmBtn) rmBtn.disabled = false; });
      return;
    }

    /* ---- follow toggle ------------------------------------------------- */
    if (form.classList.contains('js-follow')) {
      e.preventDefault();
      var btn2 = form.querySelector('button');
      var actionInput = form.querySelector('input[name="action"]');
      if (btn2.disabled) return;                  // request already in flight
      // UNFOLLOW asks first via the glassy confirm (owner #166). On your own
      // followers list the sheet also offers "Remove follower" (data-can-remove).
      if (actionInput && actionInput.value === 'unfollow' && !form.dataset.confirmed) {
        var acts = [{ label: 'Unfollow', value: 'unfollow', style: 'primary' }];
        if (form.dataset.canRemove) acts.push({ label: 'Remove follower', value: 'remove', style: 'ghost' });
        glassConfirm({
          title: 'Unfollow ' + (form.dataset.name || 'this member') + '?',
          body: form.dataset.canRemove
            ? 'Removing them instead also stops them from seeing your posts.'
            : 'You can follow them again anytime.',
          actions: acts,
        }).then(function (choice) {
          if (!choice) return;
          if (choice === 'remove') {
            actionInput.value = 'remove-follower';
            postForm(form).then(function (res) {
              actionInput.value = 'unfollow';
              if (!res) return;
              var row = form.closest('.person'); if (row) row.remove();
            }).catch(function () { actionInput.value = 'unfollow'; });
            return;
          }
          form.dataset.confirmed = '1';           // re-dispatch past this gate
          form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
          delete form.dataset.confirmed;
        });
        return;
      }
      delete form.dataset.confirmed;
      // decide icon-vs-text NOW, before any repaint wipes the button's contents,
      // otherwise querySelector('svg') later always misses and the round profile
      // button (a .cbtn) wrongly gets text ("Unfollow" spilling out of the circle)
      var isIconBtn = btn2.classList.contains('cbtn') || !!btn2.querySelector('svg');
      function paintFollow(active, requested, nowFollowing) {
        if (isIconBtn) {                            // icon button (profile)
          btn2.innerHTML = requested ? (ICO.requested || ICO.following) : (nowFollowing ? ICO.following : ICO.follow);
          btn2.classList.toggle('gold', !active);
          btn2.classList.toggle('on', active);
          // aria-pressed says the same thing .on says, for a reader who never sees the fill
          btn2.setAttribute('aria-pressed', active ? 'true' : 'false');
          btn2.title = requested ? 'Requested, tap to withdraw' : (nowFollowing ? 'Following, tap to unfollow' : 'Follow');
        } else {                                    // text button (lists)
          if (requested) {
            btn2.textContent = 'Requested';         // waiting on the private account's approval
            btn2.title = 'Requested to follow';
            btn2.setAttribute('aria-label', 'Requested');
          } else if (nowFollowing) {
            btn2.textContent = 'Unfollow';          // plain label, no empty-oval icon
            btn2.title = 'Unfollow';
            btn2.setAttribute('aria-label', 'Unfollow');
          } else {
            btn2.textContent = 'Follow';
            btn2.title = '';
            btn2.removeAttribute('aria-label');
          }
          btn2.classList.toggle('primary', !active);
          btn2.classList.toggle('gold-ghost', active);
        }
      }
      // OPTIMISTIC (owner 2026-07-24): flip to the expected state now -- no
      // spinner, no wait. The server's answer reconciles (a private account
      // comes back "requested"); a dead request rolls the button back.
      if (form._busy) return;                       // one flight at a time
      form._busy = true;
      var wantFollow = !actionInput || actionInput.value !== 'unfollow';
      var payload = new FormData(form);             // capture BEFORE flipping the action input
      var prevSnap = { html: btn2.innerHTML, cls: btn2.className, title: btn2.title, aria: btn2.getAttribute('aria-label'), pressed: btn2.getAttribute('aria-pressed') };
      paintFollow(wantFollow, false, wantFollow);
      if (actionInput) actionInput.value = wantFollow ? 'unfollow' : 'follow';
      function revertFollow() {
        btn2.className = prevSnap.cls;
        btn2.innerHTML = prevSnap.html;
        btn2.title = prevSnap.title || '';
        if (prevSnap.aria == null) btn2.removeAttribute('aria-label'); else btn2.setAttribute('aria-label', prevSnap.aria);
        if (prevSnap.pressed == null) btn2.removeAttribute('aria-pressed'); else btn2.setAttribute('aria-pressed', prevSnap.pressed);
        if (actionInput) actionInput.value = wantFollow ? 'follow' : 'unfollow';
      }
      postJson(form.getAttribute('action') || '/', payload).then(function (res) {
        form._busy = false;
        if (!res) { revertFollow(); return; }
        if (window.__rovaReachRefresh) window.__rovaReachRefresh();   // sidebar counts follow the action
        if (res.notice) toast(res.notice, res.noticeAction ? 6000 : undefined, res.noticeAction);   // e.g. verify-email, or the nudity-filter heads-up with a Settings link
        var nowFollowing = !!res.following;
        var requested = !!res.requested;            // pending approval on a private account
        var active = nowFollowing || requested;
        if (actionInput) actionInput.value = active ? 'unfollow' : 'follow';
        paintFollow(active, requested, nowFollowing);   // reconcile (usually a no-op repaint)
        // w23: flip every OTHER control for this member on the page (card ⋯ menus, list rows)
        var fuid = (form.querySelector('input[name="user_id"]') || {}).value;
        if (fuid && !requested) syncFollowUi(fuid, nowFollowing, form.dataset.name || '');
        if (isIconBtn) {                            // icon button (profile)
          // the post bell rides the follow: pop it in on follow, retire it on unfollow
          // (the server already cleared the subscription with the unfollow)
          var uidInput = form.querySelector('input[name="user_id"]');
          var bellBtn = uidInput ? document.querySelector('.js-alerts[data-id="' + uidInput.value + '"]') : null;
          if (bellBtn) {
            if (nowFollowing) {
              if (bellBtn.hidden) {
                bellBtn.hidden = false;
                bellBtn.classList.remove('bell-pop'); void bellBtn.offsetWidth; bellBtn.classList.add('bell-pop');
              }
            } else {
              bellBtn.hidden = true;
              bellBtn.setAttribute('data-on', '0');
              bellBtn.setAttribute('aria-pressed', 'false');
              bellBtn.classList.remove('bell-on');
              bellBtn.innerHTML = ICO.bell;
            }
          }
          if (!requested) {                         // only a REAL follow moves the follower count
            var fs = document.querySelector('.stat[href$="/followers"] strong');
            if (fs) {
              var fc = parseInt((fs.textContent || '').replace(/[^0-9]/g, ''), 10) || 0;
              fs.textContent = nowFollowing ? (fc + 1) : Math.max(0, fc - 1);
            }
            // the profile Follow button IS this profile's owner -> move the growth card live too, then refresh
            if (window.__rovaGrowthBump) window.__rovaGrowthBump(nowFollowing ? 1 : -1);
            if (window.__rovaGrowthPoll) window.__rovaGrowthPoll();
          }
        }
        updateOnboarding(res.count);
        // in "Discover people" (aside) or the feed's "Suggested for you" carousel, following
        // consumes the card: fade it + load another in
        var asideRow = form.closest('.aside-person') || form.closest('.sugg-slide');
        if (asideRow && nowFollowing) {
          document.dispatchEvent(new CustomEvent('rova:suggestion-followed', { detail: { row: asideRow } }));
        }
        // ONBOARDING (owner 2026-07-24): a follow that COUNTS retires its row —
        // fade, close the gap, gone (the list is a to-do, not a ledger).
        // Requested/private rows stay: they don't advance the 3-count.
        var onbRow = form.closest('#people .person');
        if (onbRow && nowFollowing && !requested) {
          onbRow.classList.add('bye');
          setTimeout(function () {
            onbRow.style.height = onbRow.offsetHeight + 'px';
            onbRow.style.overflow = 'hidden';
            void onbRow.offsetHeight;   // commit the explicit height as the transition start
            onbRow.style.transition = 'height .24s ease, margin .24s ease, padding .24s ease, border-width .24s ease';
            onbRow.style.height = '0px';
            onbRow.style.marginTop = '0'; onbRow.style.marginBottom = '0';
            onbRow.style.paddingTop = '0'; onbRow.style.paddingBottom = '0';
            onbRow.style.borderWidth = '0';
            setTimeout(function () { onbRow.remove(); }, 260);
          }, 320);
        }
      }).catch(function (err) {
        form._busy = false;
        revertFollow();                          // put the button back the way it was
        if (!err || err.message === 'reauth') return;
        toast('Couldn\'t follow. Please try again');
      });
    }
  });

  /* ---- onboarding "follow 3" progress ----------------------------------
     THE PAINTER, split out from updateOnboarding() on 2026-09-14 so a SECOND caller can repaint
     this count without inheriting the two things only a follow-button press should do: the
     "follow step complete" announcement, and un-ticking the row.

     $mayUntick is the whole reason for the split. The follow BUTTON must be able to take the tick
     back off (they unfollowed down to two). Anything else must not, because #chk-follow is also
     ticked for the member who took the quiet "I'll find people later" skip -- their row is done
     with a count of 0, and repainting it from a raw count would silently lock them out of
     Continue. Additive-only is therefore the safe default for every caller that is not the button.
     One copy of the strings, because two copies of onboarding copy is how this checklist has
     drifted before. */
  function onbPaintFollowCount(count, mayUntick) {
    var done3 = count >= 3;
    var prog = document.getElementById('onb-progress');
    if (prog) prog.textContent = 'Following ' + count + ' / 3';

    // live-tick the setup checklist
    var fRow = document.getElementById('chk-follow');
    var fSub = document.getElementById('chk-follow-sub');
    if (fSub) fSub.textContent = Math.min(count, 3) + ' of 3' + (done3 ? '' : ', pick from the list below');
    // the "People to follow" intro line follows along — and never says "0 more"
    var fMore = document.getElementById('onb-follow-more');
    if (fMore) {
      fMore.innerHTML = done3
        ? 'You’re all set, hit Continue below.'
        : 'Follow <span class="gold">' + (3 - count) + ' more</span> to continue.';
    }
    if (fRow && (done3 || mayUntick)) {
      fRow.classList.toggle('done', done3);
      var chk = fRow.querySelector('.setup-check');
      if (chk) chk.textContent = done3 ? '✓' : '';
      // same gap as the server render (views/onboarding.php): this row's cta is '↓', not '›', so
      // it was never included in the other three rows' done -> '✓' swap and just sat there
      // pointing at the list forever, even once the step was long finished.
      var cta = fRow.querySelector('.setup-cta');
      if (cta) cta.textContent = done3 ? '✓' : '↓';
    }
    onbMaybeUnlockContinue();
    refreshSetupCount();
    return done3;
  }
  function updateOnboarding(count) {
    if (typeof count !== 'number') return;
    // Was the follow step already met before this follow landed? Read it before the row is
    // toggled below, so the 4th and 5th follow are not treated as finishing the step again.
    var _fRowPre = document.getElementById('chk-follow');
    var followWasDone = !!(_fRowPre && _fRowPre.classList.contains('done'));
    var done3 = onbPaintFollowCount(count, true);
    // step 2 (follow 3) just landed -> name whatever is next and glide there on dismissal.
    // Only on the follow that actually MET the quota, never on the ones after it.
    if (done3 && !followWasDone) { onbAnnounce('follow'); }
  }
  /* The onboarding COMMENT step's hook. Sending the first comment also follows the post's author
     (owner 2026-09-14), so the count on this page moves without the follow button being touched
     and would otherwise sit stale until a reload. Additive only, and NO announcement: the comment
     step runs its own hand-off through __rovaOnbAnnounce('comment') one line later, and firing the
     follow step's announcement underneath it would put two sheets on screen at once. */
  window.__rovaOnbFollowCount = function (count) {
    if (typeof count === 'number' && count >= 0) { onbPaintFollowCount(count, false); }
  };
  // Glide to the follow list. Target the HEADER card ("People to follow" + search) with
  // block:'start', NOT #people with block:'center' -- the list (12 rows + media strips) is
  // far taller than a phone viewport, and centering a taller-than-viewport element lands the
  // user mid-list, scrolled right past the pinned inviter and the search box. scroll-margin-top
  // in rova.css keeps the card clear of the sticky topbar. The nudge stays on the list itself.
  /* ONE SCROLL RULE FOR THE WHOLE CHECKLIST (2026-08-04). This is scrollPanelIntoView from
     assets/onboarding-comment.js, moved here so every step lands in the same place: top-aligned,
     held clear of the sticky header by the live --topbar-h, not centred. Centring is what used to
     put a taller-than-viewport panel's own instructions above the top of the screen.
     #onb-people-head used to get there via scroll-margin-top (topbar + 8px) and scrollIntoView,
     which was 4px off the comment panel for no reason anybody chose; they agree now.
     prefers-reduced-motion drops the smooth behaviour, which scrollIntoView never did here. */
  function onbScrollTo(el) {
    if (!el) { return; }
    var smooth = 'smooth';
    try {
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) { smooth = 'auto'; }
    } catch (e) {}
    try {
      var hv = getComputedStyle(document.documentElement).getPropertyValue('--topbar-h');
      var head = parseInt(hv, 10);
      // 65 == :root{--topbar-h} in rova.css. Was 70, a fourth different "header height"
      // in a codebase that already had 56/60/70 as CSS fallbacks; they are all 65 now.
      if (!isFinite(head) || head <= 0) { head = 65; }
      var top = el.getBoundingClientRect().top
              + (window.pageYOffset || document.documentElement.scrollTop || 0);
      window.scrollTo({ top: Math.max(0, top - head - 12), behavior: smooth });
    } catch (e) {
      try { el.scrollIntoView({ behavior: smooth, block: 'start' }); } catch (e2) {}
    }
  }
  function onbGoPeople() {
    var head = document.getElementById('onb-people-head');
    var people = document.getElementById('people');
    var target = head || people;
    if (!target) return;
    onbScrollTo(target);
    if (people) {
      people.classList.add('nudge');
      setTimeout(function () { people.classList.remove('nudge'); }, 1600);
    }
  }
  /* ---- ONBOARDING: WHICH REQUIRED STEP IS STILL MISSING -------------------
     Owner 2026-08-03, "make all 4 steps are required". ONE function answers that question for the
     whole page, and it answers it from the state the server rendered plus whatever has ticked live
     since. The server's verdict rides in on .setup-list:
        data-photo / data-post / data-comment  = done?      (live-updated as each step lands)
        data-req-post / data-req-comment       = required?  (Onboarding::requiredMap, never guessed)
     The follow step's done-ness is the #chk-follow row's .done class, because that is what the
     quiet "I'll find people later" skip ticks -- a follow COUNT would be wrong for those members.
     Returns '' when they are free to go. Same order as Onboarding::firstMissing() in PHP. */
  /* IS THE ONBOARDING CHECKLIST ON THIS PAGE AT ALL? (2026-08-04)
     A separate question from "which step is missing", and it has to be asked first, because
     onbFirstMissing() answers '' to BOTH "this member has finished every step" and "there is no
     checklist here to read" -- and '' is the answer that renders the FINISHED sheet. That
     collapse is what put the FINISHED sheet (then headed "Now bring your people") in front of
     established members every time they followed anyone anywhere on the site: off /onboarding the
     elements it reads are simply absent, and absence was being scored as "not done yet".
     Rather than widen onbFirstMissing's return type (its two other callers both key off truthy =
     a step name), the page question gets its own name and its own function, and the announcer
     asks it before anything else.
     .setup-list is the test because it is the SERVER'S rendering of this member's onboarding
     state -- it carries data-photo / data-req-post / data-req-comment straight from
     Onboarding::requiredMap() -- and views/onboarding.php is the only view in the codebase that
     emits it (verified by grep, 2026-08-04). assets/app.js already uses exactly this test for
     the avatar-upload status copy, so there is one page test here, not two. */
  function onbOnChecklistPage() {
    try { return !!document.querySelector('.setup-list'); } catch (e) { return false; }
  }
  /* `assumePhoto` (2026-09-14) answers ONE question: "which step should I walk them to next, if
     the photo counts as done?" -- asked only by the optimistic advance, which fires while the
     upload is still on the wire. It is a parameter rather than a second function because the
     ORDER of these branches is the thing that must never be duplicated (it mirrors
     Onboarding::firstMissing in PHP), and every existing caller passes nothing and is unchanged.
     IT MUST NEVER REACH THE GATE. onbMaybeUnlockContinue() calls this with no argument, so
     data-photo -- written only on a SAVED avatar -- still decides whether the feed opens. An
     in-flight upload changes where we send the member, never what they are allowed to do. */
  function onbFirstMissing(assumePhoto) {
    var list = document.querySelector('.setup-list');
    if (!list) return '';   // NOT on the checklist page. See onbOnChecklistPage() above: callers
                            // that can act on this answer must gate on the page FIRST.
    var fRow = document.getElementById('chk-follow');
    if (!assumePhoto && list.getAttribute('data-photo') !== '1') return 'photo';
    if (!(fRow && fRow.classList.contains('done'))) return 'follow';
    if (list.getAttribute('data-req-post') === '1' && list.getAttribute('data-post') !== '1') return 'post';
    if (list.getAttribute('data-req-comment') === '1' && list.getAttribute('data-comment') !== '1') return 'comment';
    return '';
  }
  // Mirrors Onboarding::WHY / Onboarding::LABEL (lib/onboarding.php). Kept short and in both
  // places on purpose: the server renders the first copy into #onb-continue-why so it is right
  // before any JS runs, and this updates it as steps tick without a round trip. Change both.
  var ONB_WHY = {
    photo:   'Add a profile photo first, it is the step at the top.',
    follow:  'Follow 3 people first, the list is just below.',
    post:    'Share your first post first, the box is in the checklist above.',
    comment: 'Leave your first comment first, pick a post in the checklist above.'
  };
  var ONB_LABEL = {
    photo: 'Add a profile photo', follow: 'Follow 3 people',
    post: 'Share your first post', comment: 'Leave your first comment'
  };
  /* WHY CONTINUE IS BLOCKED, and "the photo is still uploading" is not the same answer as "you
     have not added a photo" (2026-09-14). Since the optimistic advance, a member on a slow line
     can finish every other step while their photo is still on the wire; telling them then to "Add
     a profile photo first, it is the step at the top" -- seconds after a sheet said "Photo saved"
     -- reads as the page having lost it. The in-flight sentence is server-rendered on .setup-list
     so it is translated; ONB_WHY stays the answer for everything else, including a photo step that
     genuinely has not been started. */
  function onbWhy(miss) {
    if (miss === 'photo' && onbPhotoFlight) {
      var list = document.querySelector('.setup-list');
      var s = list && list.getAttribute('data-why-uploading');
      if (s) { return s; }
      return 'Still finishing your photo upload.';
    }
    return ONB_WHY[miss] || '';
  }
  // "Continue to your feed" mirrors the server route gate (index.php -> Users::needsOnboarding ->
  // Onboarding::firstMissing), or tapping it just 302s straight back to /onboarding. BLOCKED IS NOT
  // DEAD: while something is missing the button stays clickable and the line under it names the
  // step. (It used to be pointer-events:none with no explanation, which is the worst version of a
  // gate -- nothing happens and nothing is said.)
  /* A PHOTO ON THE WIRE IS "DONE" FOR WHERE WE SEND THEM, NEVER FOR WHETHER THE FEED OPENS
     (Rob 2026-10-02, iPhone: "It told me to add a profile photo again because it was still
     uploading after I finished step two"). onbFirstMissing() with no argument stays the GATE's
     answer -- data-photo is written only on a saved avatar. This is the ROUTING answer: every
     "what is next / where do I send them / what does the why-line name" question asks it, so an
     in-flight photo is skipped over exactly like a finished one, and only a FAILED upload
     (onbPhotoFlight back to false, onbPhotoRetract) ever points a member back at the photo row. */
  function onbRouteMissing() {
    return onbFirstMissing(onbPhotoFlight);
  }
  function onbMaybeUnlockContinue() {
    var cont = document.getElementById('onb-continue');
    if (!cont) return;
    var miss = onbFirstMissing();
    var route = onbRouteMissing();
    var why = document.getElementById('onb-continue-why');
    cont.setAttribute('data-missing', miss);
    if (miss) {
      // NOT aria-disabled: that makes the control genuinely unactivatable to anything that
      // honours it, and this one exists to be tapped and answer "why can't I continue?".
      // See the note on the button in views/onboarding.php.
      cont.setAttribute('aria-describedby', 'onb-continue-why');
      // Only photo outstanding and it is saving: the button is one tap from working (a tap now
      // waits for the save and then goes -- see onbContinueWait), so it does not look dead.
      cont.style.opacity = route ? '.55' : '';
      cont.style.pointerEvents = '';        // must stay tappable so we can SAY why
      if (route) { cont.classList.remove('primary'); } else { cont.classList.add('primary'); }
      if (why) { why.textContent = onbWhy(route || miss); why.hidden = false; }
    } else {
      cont.removeAttribute('aria-disabled');
      cont.removeAttribute('aria-describedby');
      cont.style.opacity = '';
      cont.style.pointerEvents = '';
      cont.classList.add('primary');
      if (why) { why.hidden = true; }
    }
    // the "N to go" line at the top of the card follows along
    var top = document.getElementById('onb-all-req');
    var list = document.querySelector('.setup-list');
    if (top && list) {
      var steps = parseInt(list.getAttribute('data-steps'), 10) || 3;
      var left = 0, fRow = document.getElementById('chk-follow');
      // a saving photo is not "to go": the member has done their part of it
      if (list.getAttribute('data-photo') !== '1' && !onbPhotoFlight) left++;
      if (!(fRow && fRow.classList.contains('done'))) left++;
      if (list.getAttribute('data-req-post') === '1' && list.getAttribute('data-post') !== '1') left++;
      if (list.getAttribute('data-req-comment') === '1' && list.getAttribute('data-comment') !== '1') left++;
      if (left > 1) {
        top.textContent = 'All ' + steps + ' steps are needed before your feed opens. ' + left + ' to go, in any order.';
      } else if (miss && !route) {
        top.textContent = onbWhy('photo');   // only the save itself is left
      } else if (miss) {
        top.textContent = 'One step to go: ' + (ONB_LABEL[route || miss] || '') + '.';
      } else {
        top.textContent = 'All done, hit Continue below.';
      }
    }
  }
  // Take them TO the missing step rather than just refusing. Never synthesizes a click on the
  // photo row: that row is a <label> over a real file input and a programmatic .click() is
  // blocked on iOS (see the note on the input itself).
  function onbNudgeStep(key) {
    if (key === 'follow') { onbGoPeople(); return; }
    var row = document.querySelector('.setup-item[data-step="' + key + '"]');
    if (!row) return;
    var panel = key === 'post' ? document.getElementById('onb-post')
              : key === 'comment' ? document.getElementById('onb-cmt') : null;
    if (panel && panel.hidden && !row.classList.contains('locked') && key !== 'photo') {
      row.click();                       // each panel's own handler expands it and scrolls to it
    } else {
      row.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    row.classList.add('nudge');
    setTimeout(function () { row.classList.remove('nudge'); }, 1700);
  }
  // Tapping a blocked Continue: say which step, and go there.
  document.addEventListener('click', function (e) {
    var cont = e.target.closest ? e.target.closest('#onb-continue') : null;
    if (!cont) return;
    var miss = onbFirstMissing();
    if (!miss) return;                   // genuinely done: let the link through
    e.preventDefault();
    /* THE PHOTO IS SAVING (2026-10-02). Never send them back up to the photo row for it: name
       the next REAL step if there is one, and if the save is all that is left, accept the tap
       and go the moment it lands. Navigating now would abort the upload in this very page. */
    if (miss === 'photo' && onbPhotoFlight) {
      var route = onbRouteMissing();
      if (route) {
        toast(onbWhy(route) || 'One step left before your feed opens.');
        onbNudgeStep(route);
      } else {
        onbContinueWait(cont);
      }
      return;
    }
    toast(onbWhy(miss) || 'One step left before your feed opens.');
    onbNudgeStep(miss);
  });
  /* CONTINUE, PRESSED WHILE THE PHOTO IS STILL SAVING. The tap is held, not refused: the button
     shows it is working, the why-line says what it is waiting on, and rova:media-saved presses it
     for real once data-photo is '1' (the route gate on the server then agrees). A failed save
     releases it and onbPhotoRetract() takes over with the "did not upload, Try again" state. */
  var onbContWaiting = false;
  function onbContinueWait(cont) {
    if (!cont) { return; }
    if (!onbContWaiting) {
      onbContWaiting = true;
      cont.setAttribute('aria-busy', 'true');
      cont.classList.add('onb-waiting');
      if (!cont.querySelector('.onb-spin')) {
        var sp = document.createElement('span');
        sp.className = 'onb-spin';
        sp.setAttribute('aria-hidden', 'true');
        cont.insertBefore(sp, cont.firstChild);
      }
    }
    var why = document.getElementById('onb-continue-why');
    if (why) { why.textContent = onbWhy('photo'); why.hidden = false; }
    // the second sentence has no catalog entry, so it only rides along on an English page
    var en = /^en/i.test(String(document.documentElement.getAttribute('lang') || 'en'));
    try { toast(onbWhy('photo') + (en ? ' Your feed opens as soon as it lands.' : ''), 4000); } catch (er) {}
  }
  function onbContinueRelease() {
    onbContWaiting = false;
    var cont = document.getElementById('onb-continue');
    if (!cont) { return; }
    cont.removeAttribute('aria-busy');
    cont.classList.remove('onb-waiting');
    var sp = cont.querySelector('.onb-spin');
    if (sp && sp.parentNode) { sp.parentNode.removeChild(sp); }
  }
  // assets/onboarding-comment.js (per-page, not in this bundle) calls this after a comment lands.
  window.__rovaOnbSync = onbMaybeUnlockContinue;
  /* The two late steps ship .locked until the photo + follow-3 pair is behind them. Clearing that
     is all this does now; deciding WHERE to send the member afterwards moved to onbGoToStep, and
     announcing it moved to onbAnnounce (2026-08-04).
     onbUnlockPost() used to do all three at once behind an onbPostRevealed latch. It is gone
     rather than left dangling: it scrolled, every one of its callers is now an onbAnnounce call,
     and a spare scroll-somewhere function sitting next to a deliberately once-only announcer is
     exactly the thing that gets re-wired by accident and double-scrolls the page. The comments in
     views/onboarding.php and assets/onboarding-comment.js still name it; they describe the
     unlocking behaviour, which is what onbClearLocks does. */
  function onbClearLocks() {
    document.querySelectorAll('.setup-item.locked').forEach(function (l) { l.classList.remove('locked'); });
  }

  /* ======================================================================
     THE PHOTO UPLOAD RUNS ALONGSIDE THE OTHER STEPS, NOT IN FRONT OF THEM
     (owner 2026-08-15: "Photo upload super slow -- let them continue while it's uploading.")

     assets/onb-boot.js owns the transport for BOTH entry paths -- it uploads directly when this
     bundle has not arrived, and bgUpload() below hands it the cropper's output when it has -- so
     it is also the only place that knows an upload is happening. It says so with
     `rova:avatar-upload`, and this is the bundle's half of that: two facts, no second uploader.

     WHY THE ROW-TAP GUARD NEEDS THIS AT ALL. onb-boot already strips `.locked` off the later
     rows when the bytes leave, but the checklist click handler further down re-derives its own
     verdict from `photoDone` (the row's .done class) and bounces a tap on the first-post step
     with "Add a profile photo first to unlock this". Stripping the class alone would therefore
     produce the worst of both: a row that LOOKS open and answers a tap with a refusal. The two
     have to agree, so both read "in flight counts as the photo leg".

     WHAT THIS DELIBERATELY DOES NOT TOUCH: onbFirstMissing(). That reads data-photo, which is
     only ever written on a SAVED avatar, and it is what gates "Continue to your feed". The feed
     still opens on four COMPLETED steps -- the owner's photo-first rule is unchanged. All that
     moved is where the waiting happens.
     ====================================================================== */
  var onbPhotoFlight = false;   // an avatar upload is on the wire right now
  var onbMovedOn = false;       // ...and the member has since gone and done something else
  // assets/onboarding-comment.js asks this before nudging a locked row's tap at the photo step
  window.__rovaOnbPhotoSaving = function () { return onbPhotoFlight; };
  document.addEventListener('rova:avatar-upload', function (e) {
    var st = e && e.detail && e.detail.state;
    if (st === 'start') {
      onbPhotoFlight = true; onbMovedOn = false;
      try { onbPhotoAdvance(e.detail.file); } catch (er) {}
      return;
    }
    if (st === 'fail')  {
      onbPhotoFlight = false;
      try { onbContinueRelease(); } catch (er) {}   // a held Continue tap must not fire later
      try { onbPhotoRetract(); } catch (er) {}
      return;
    }
    if (st === 'done')  {
      onbPhotoFlight = false;
      try { onbHoldAnchor(); onbPhotoAlert(false); onbUnpinRow(); } catch (er) {}
    }
  });

  /* ---- THE LANDING MUST NOT MOVE THE PAGE UNDER THEM -----------------------------------
     MEASURED on the rig (C:\tools\pw\onbphoto-probe.js, WebKit 390x844, a 6s stubbed upload):
     when the photo finally landed while the member was down on the follow list, everything above
     them collapsed by 54px and the list jumped up under their thumb.

     It is not the avatar -- that slot is pre-filled by the optimistic preview precisely so the
     swap is like-for-like. It is the STATUS LINE. "Uploading your photo, 123 KB. Carry on with
     the steps below." wraps to three lines on a phone, and success replaces it with nothing and
     rewrites the subtitle to "Nice, people will recognize you". The photo row simply gets
     shorter, and every pixel of that comes out from above the viewport.

     No engine will do this for us: scroll anchoring is Chrome-only, WebKit has no
     overflow-anchor, and this is the device the whole change is for. So it is measured and
     compensated by hand, and ONLY when the row is entirely off the top of the screen -- if they
     can still see the photo row then the row changing IS the feedback, and holding the scroll
     still would be moving the thing they are actually looking at.

     The double rAF is what makes one call enough: the height change is written by two different
     files (onb-boot.js clears the status, this bundle rewrites the subtitle and ticks the row)
     in an order nothing here controls, so it measures after everything synchronous has flushed
     and layout has settled rather than trying to bracket each writer. Idempotent, because both
     'done' and rova:media-saved call it and only the first one arms. */
  var onbAnchorArmed = false;
  function onbHoldAnchor() {
    if (onbAnchorArmed) { return; }
    var row = document.querySelector('.setup-item[data-step="photo"]');
    var anchor = document.getElementById('onb-people-head') || document.getElementById('people')
              || document.querySelector('.setup-list');
    if (!row || !anchor) { return; }
    var r;
    try { r = row.getBoundingClientRect(); } catch (e) { return; }
    if (r.bottom > 0) { return; }             // still on screen: let them watch it change
    var before;
    try { before = anchor.getBoundingClientRect().top; } catch (e) { return; }
    onbAnchorArmed = true;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        onbAnchorArmed = false;
        var d;
        try { d = Math.round(anchor.getBoundingClientRect().top - before); } catch (e) { return; }
        // 0 is the normal answer. A huge number means something other than this row moved, and
        // guessing at that would be a second scroller of exactly the kind this codebase keeps
        // having to remove.
        if (!d || Math.abs(d) > 400) { return; }
        try { window.scrollBy({ top: d, behavior: 'auto' }); }
        catch (e) { try { window.scrollBy(0, d); } catch (e2) {} }
      });
    });
  }

  /* ======================================================================
     THE ADVANCE HAPPENS WHEN THE BYTES LEAVE, NOT WHEN THE SERVER ANSWERS
     (owner 2026-09-14: "During onboarding I want to see this popup 'Photo saved. Next: follow 3
     people ...' before the photo is done uploading, should just happen in the background without
     having to wait then show this".)

     2026-08-15 already let them CONTINUE during the upload -- it opened the later rows the moment
     the request went out. What it did not do was TELL them, so the member sat looking at
     "Uploading your photo, 35 KB" with nothing inviting them onward. This closes that: the sheet
     that used to wait for a 200 now fires on 'start'.

     WHAT "START" IS, AND WHY IT IS THE RIGHT MOMENT. assets/onb-boot.js emits it from inside
     upload(), i.e. after the file exists, after the 25 MB client check, after shrink() has
     decoded it, and -- on the bundle path -- after the member has confirmed the cropper. So it is
     a REAL, VALIDATED selection, never the file dialog merely opening, and never a file we have
     already decided to reject. It is also the same event on both transports, so this needed no
     second uploader and no change to how anything is sent.

     WHAT IT DELIBERATELY DOES NOT DO: tick the step. `data-photo` is written ONLY by the
     rova:media-saved handler further down, on a genuinely saved avatar, and it is what
     onbFirstMissing() -- and therefore "Continue to your feed" -- reads. So the sheet may say
     "Photo saved." optimistically while the GATE stays honest. That split is the whole design:
     an optimistic claim is allowed to move somebody, never to let them out.

     AND THE CLAIM IS RETRACTABLE. onbPhotoRetract() below is as loud as the sheet was.
     ====================================================================== */
  var onbPhotoPreviewed = false;   // we put the member's own picture in the row's empty slot
  function onbPhotoAdvance(file) {
    if (!onbOnChecklistPage()) { return; }
    var row = document.querySelector('.setup-item[data-step="photo"]');
    if (!row || row.classList.contains('done')) { return; }   // changing an existing avatar: no advance
    onbPhotoAlert(false);                                      // a retry clears the last retraction
    /* THE PREVIEW IS WHY THE AVATAR LANDS LATER WITHOUT A JOLT. #avatar-current ships EMPTY and
       hidden, so the saved avatar arriving would otherwise INSERT a large element into a row the
       member has already scrolled past, moving everything under them. Filling it now, from the
       File already in their hand, means the success path's rovaSwapSelfAvatar() replaces a node
       with an identical-size node showing identical pixels: no shift, no flash, nothing to see.
       Only this slot -- the HEADER avatar is the site-wide identity claim and is left alone until
       the server has really saved it. */
    if (file) {
      try { if (rovaSwapSelfAvatar(file, '')) { onbPhotoPreviewed = true; } } catch (er) {}
    }
    /* PIN THE ROW'S HEIGHT FOR THE DURATION, which is the real cure for the landing jolt.
       MEASURED before this existed (C:\tools\pw\onbphoto-probe.js, WebKit 390x844, 6s stubbed
       upload): when the photo landed while the member was down on the follow list, everything
       above them collapsed 54px and the list jumped under their thumb. The avatar is not the
       cause -- the preview above pre-fills that slot so the swap is like-for-like. The STATUS
       LINE is: "Uploading your photo, 123 KB. Carry on with the steps below." wraps to three
       lines on a phone, and success removes it and shortens the subtitle. The row simply gets
       smaller, and every pixel comes out from above the viewport.
       Compensating the scroll afterwards was tried first and only recovered 37 of the 54, because
       the row shrinks in two stages written by two different files. A row that never changes size
       has nothing to compensate. Measured after two frames because assets/onb-boot.js paints that
       status line AFTER it emits 'start' (it calls status() below xhr.send). onbHoldAnchor stays
       as the backstop for whatever this does not cover. */
    var pinRow = row;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        try {
          var h = pinRow.offsetHeight;
          if (h > 0) { pinRow.style.minHeight = h + 'px'; }
        } catch (er) {}
      });
    });
    /* NO NEXT STEP MEANS NOTHING TO ADVANCE TO, AND THE EARLY SHEET IS SKIPPED.
       Found by the rig (scenario `gate`, a member whose photo is the last thing outstanding): with
       the photo assumed done there is nothing left, so the announcer produced the FINISHED sheet
       -- "Photo saved. You are all set 🎉" with a Continue button -- while the bytes were still
       going. That button now presses #onb-continue for real, and #onb-continue is gated on
       data-photo, which is still 0 because the upload has not landed. So the member would be
       handed a door that refuses to open, seconds after being told they were all set.
       The early sheet exists to delete the wait BEFORE THE NEXT STEP. Where there is no next step
       there is no wait worth deleting, so this says nothing now and lets the real rova:media-saved
       path announce it when the photo has genuinely landed -- at which point "You are all set" is
       true and Continue works. onbAnnounced.photo is deliberately NOT burned here for the same
       reason: that later announcement must still be allowed to happen. */
    /* Repaint the blocked-Continue line NOW that onbPhotoFlight is true, so it reads "Still
       finishing your photo upload." instead of "Add a profile photo first". Nothing else on the
       page would ask for it: the why line is written by the server at render and only rewritten
       when a step ticks, and an upload starting is not a step ticking. */
    try { onbMaybeUnlockContinue(); } catch (er) {}
    var next = '';
    try { next = onbFirstMissing(true); } catch (er) { next = ''; }
    if (!next) { return; }
    /* assumePhoto: compose the sheet as though the photo were done, so it reads "Photo saved.
       Next: follow 3 people" -- owner's words, and already exactly what ONB_PREFIX.photo plus
       ONB_NEXT.follow produce. onbAnnounced.photo is burned by this call, so the real 200 landing
       later cannot fire a second sheet on top of whatever they are doing by then. */
    onbAnnounce('photo', true);
  }

  /* The retraction. It has to be as findable as the claim, because by now the member is somewhere
     else on the page and the gate will not let them leave until a photo really exists -- a silent
     failure here strands somebody behind a wall with a checklist that looks finished.
     THREE SURFACES, because they may be looking at any of them: the persistent banner at the top
     of the checklist card (server-rendered and translated, see views/onboarding.php), a toast
     where they actually are, and -- untouched, already correct -- assets/onb-boot.js's own error
     line and Try again tray on the photo row itself.
     NOTHING HERE TOUCHES data-photo, because nothing ever set it. The checklist, the gate and the
     server already agree that the step is not done; this is only about saying so out loud. */
  function onbPhotoRetract() {
    if (!onbOnChecklistPage()) { return; }
    /* Take the picture back out. Leaving their face in the slot after a failed upload is exactly
       the "believing you have a photo when you do not" this whole block exists to prevent -- and
       it re-appears the moment they press Try again, because that re-enters onbPhotoAdvance. */
    if (onbPhotoPreviewed) {
      var cur = document.getElementById('avatar-current');
      if (cur) {
        while (cur.firstChild) { cur.removeChild(cur.firstChild); }
        cur.hidden = true; cur.style.display = '';
      }
      onbPhotoPreviewed = false;
    }
    /* WHICH RECOVERY TO OFFER IS ONB-BOOT'S DECISION, NOT A SECOND OPINION. It has just chosen
       between Try again (worth re-sending), Confirm your email (403) and Reload (session gone) --
       and for a 400 or a 413 it deliberately offers NONE of them, because re-sending bytes the
       server has already refused in plain words cannot change the answer; the only move is a
       different photo. So the banner mirrors that: its Try again appears only when the row's real
       Try again is showing, and "Choose another photo" is always there because it is always true.
       Read from computed style rather than .hidden -- see the [hidden] trap in the inline <style>
       of views/onboarding.php. */
    var realRetry = document.getElementById('onb-photo-retry');
    var canRetry = false;
    try {
      canRetry = !!(realRetry && getComputedStyle(realRetry).display !== 'none');
    } catch (er) {}
    var aRetry = document.getElementById('onb-photo-alert-retry');
    if (aRetry) { aRetry.hidden = !canRetry; }
    onbPhotoAlert(true);
    onbUnpinRow();
    var list = document.querySelector('.setup-list');
    var msg = list && list.getAttribute('data-photo-failed-toast');
    try { toast(msg || 'Your photo did not upload. Tap Try again on the photo step.', 5000); } catch (er) {}
    /* Scroll them to it -- UNLESS they are mid-sentence. Moving the page under someone who is
       typing is the interruption the 2026-08-15 note above forbids, and it forbids it for an
       ANNOUNCEMENT; a failure that holds the gate shut is not decoration, so the default here is
       to go. The banner is at the top of the card either way, and the toast reaches them where
       they are, so declining to scroll costs them nothing. */
    var ae = null;
    try { ae = document.activeElement; } catch (er) {}
    var typing = !!(ae && (ae.tagName === 'TEXTAREA' || ae.tagName === 'INPUT' || ae.isContentEditable));
    if (!typing) { onbScrollTo(document.getElementById('onb-photo-alert')); }
    onbMaybeUnlockContinue();
  }
  function onbPhotoAlert(show) {
    var el = document.getElementById('onb-photo-alert');
    if (el) { el.hidden = !show; }
  }
  /* Let the pinned row go once the member can actually SEE it: a row that is on screen may shrink
     in front of them without anything jumping, and leaving a few pixels of reserved space under a
     finished step forever is untidy. While it is still off the top of the screen the pin stays --
     that is the whole point of it. */
  function onbUnpinRow() {
    var row = document.querySelector('.setup-item[data-step="photo"]');
    if (!row || !row.style.minHeight) { return; }
    try { if (row.getBoundingClientRect().bottom <= 0) { return; } } catch (e) { return; }
    row.style.minHeight = '';
  }
  /* The banner's two buttons. Try again ACTIVATES THE REAL RETRY -- assets/onb-boot.js owns the
     one uploader and still holds the file, so this presses its button rather than starting a
     second attempt of its own. "Choose another photo" only scrolls and nudges: that row IS a file
     input and a synthesised click on one is blocked on iOS (see the note on the input itself). */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) { return; }
    if (e.target.closest('#onb-photo-alert-retry')) {
      e.preventDefault();
      var r = document.getElementById('onb-photo-retry');
      if (r) { r.click(); } else { onbPhotoAlert(false); }
      return;
    }
    if (e.target.closest('#onb-photo-alert-pick')) {
      e.preventDefault();
      var row = document.querySelector('.setup-item[data-step="photo"]');
      if (row) {
        onbScrollTo(row);
        row.classList.add('nudge');
        setTimeout(function () { row.classList.remove('nudge'); }, 1700);
      }
    }
  });
  /* "Moved on" is recorded from the member's own actions while the upload is in flight, never
     from a timer: the question the success handler has to answer is not "was it slow?" but "is
     this member still looking at the photo row?", and only they can answer that. Capture phase
     so a handler that stops propagation (the follow buttons do) cannot hide the fact from us. */
  document.addEventListener('click', function (e) {
    if (!onbPhotoFlight || !e.target || !e.target.closest) { return; }
    if (e.target.closest('.setup-item[data-step="photo"]')) { return; }   // still on the photo row
    if (e.target.closest('#people, #onb-post, #onb-cmt, .setup-item, #onb-continue')) { onbMovedOn = true; }
  }, true);
  document.addEventListener('focusin', function (e) {
    if (!onbPhotoFlight || !e.target || !e.target.closest) { return; }
    if (e.target.closest('#onb-post, #onb-cmt, #onb-search')) { onbMovedOn = true; }
  });

  /* ======================================================================
     NAME THE NEXT STEP BEFORE SCROLLING TO IT (owner 2026-08-04:
     "After adding profile photo it's unclear they have to follow 3 people, the screen just
      scrolls to the People to follow panel, it should at least present a modal telling them
      each next step before it auto scrolls to it.")

     Finishing a step used to scroll somewhere new and say nothing, so the member arrived
     somewhere they did not ask to be with no idea what had happened or what was wanted. Every
     transition now goes through here: a one-button sheet naming what was done, what is next and
     what that next thing gets them, and the scroll happens when they dismiss it.

     ONLY ON A REAL TRANSITION. Each caller passes the step that just flipped, and each caller
     checks the row's own .done state BEFORE it ticks it, so a re-upload of an existing photo, a
     fourth follow, or a page that simply renders with steps already done announces nothing. That
     matters more than the sheet itself: this page is a hard gate that bounces members back to it
     constantly, and a modal on every load would be an infuriating product.

     THE NEXT STEP IS COMPUTED, NEVER ASSUMED. onbFirstMissing() is the same order the server's
     Onboarding::firstMissing() uses, read off the attributes the server rendered. So a member who
     does the steps out of order is told the truth, and a step the server has switched off is
     never announced: onb_cmt_na (nothing safe to comment on) makes the server render
     data-req-comment="0", and onbFirstMissing therefore skips straight past 'comment' to ''.

     NEVER A TRAP, NEVER A BLOCKER. Escape, a veil tap and the button all dismiss, and all three
     land on the same scroll. The whole thing is wrapped so that if ANY of it throws, the scroll
     still runs: the failure mode is exactly the behaviour that shipped yesterday, never a member
     stuck looking at a step they cannot leave. There is no timer: a sheet that closes itself
     recreates the original bug for anyone who glanced away.
     ====================================================================== */

  /* What just happened, and what is next. Composed from two small tables rather than written out
     per (done, next) pair, so any order of completion produces an accurate sentence. */
  /* THE "WHAT YOU JUST DID" PREFIX IS PER TRANSITION, AND ONLY THE PHOTO HAS ONE (owner
     2026-08-04, after seeing the sheets in use). Following three people and writing a post are
     self-evident the moment they happen, so restating them is noise in front of the thing the
     member actually needs to read. The photo is different and the difference is the whole reason
     this work started: it is the one step that can fail silently on a bad connection, so
     confirming it landed is doing real work, not decorating.
     A table rather than a flag, so the next step that earns a confirmation gets one by adding a
     line here, and every other transition stays quiet by default. */
  var ONB_PREFIX = {
    photo: 'Photo saved. '
  };
  var ONB_NEXT = {
    /* THE MISSING ONE, and it was reachable. onbAnnounce asks onbFirstMissing() what is next, and
       'photo' is a perfectly ordinary answer: a member who follows three people BEFORE adding a
       photo lands here. Without this entry `spec` was undefined, so that member was handed the
       FINISHED sheet ("Your feed is ready") while still owing the step that gates everything, and
       onbGoToStep sent them to the invite card. Found by checking every pairing that can actually
       occur rather than the three the table happened to list. */
    photo: {
      title: 'add a profile photo',
      body:  'A photo is what turns you from a stranger into someone worth following back. It is the row at the top of the list.',
      cta:   'Take me to it'
    },
    follow: {
      title: 'follow 3 people',
      body:  'Rova is chronological, so your feed is simply the people you follow. Pick any 3 and it starts filling up.',
      cta:   'Show me who to follow'
    },
    post: {
      title: 'share your first post',
      body:  'Say hi so the people you followed can find you back. A line or two is plenty.',
      cta:   'Write my first post'
    },
    comment: {
      title: 'leave one comment',
      body:  'Comment on someone else’s post and they will see you. It is the quickest way to get your first followers.',
      cta:   'Pick a post to comment on'
    }
  };

  /* Where each step lives. Kept separate from the copy so the scroll target and the words cannot
     drift apart. Every path ends in onbScrollTo, so all four land identically.
     `viaCta` is true only when the member pressed the sheet's button, false when they escaped or
     tapped the veil. It decides one thing: whether to put the caret in the box. Pressing "Write
     my first post" and getting a keyboard is what was asked for; dismissing a sheet and getting a
     keyboard thrown up at you is not. */
  /* FOCUS WITHOUT UNDOING THE SCROLL. Calling .focus() scrolls the element into view, and both
     controls we focus sit well down inside a panel that is taller than a phone: focusing the
     invite card's share button dragged the page 640px past the landing onbScrollTo had just
     computed, dumping the member mid-card with the heading off the top of the screen. That is the
     exact fault scrollPanelIntoView was written to fix, reintroduced through the back door.
     preventScroll keeps the caret placement without the side effect; the bare call is kept as a
     fallback for anything that ignores the option, where a scrolled-past card still beats no
     focus at all. */
  function onbFocusNoScroll(el) {
    if (!el) { return; }
    try { el.focus({ preventScroll: true }); }
    catch (e) { try { el.focus(); } catch (e2) {} }
  }
  /* ======================================================================
     THE FIRST-POST COMPOSER OPENS AND TAKES THE CARET IN THE SAME TASK AS THE TAP
     (owner 2026-09-14, iPhone Safari: "After tapping write my first post during onboarding it
     should automatically focus the text field and present the keyboard".)

     iOS Safari raises the software keyboard for a programmatic .focus() ONLY while the user
     activation from the tap is still live -- i.e. in the SAME task as the click handler. Both
     ways into this composer had put a timer in between, so both focused correctly and neither
     produced a keyboard, silently:

        onbGoToStep      setTimeout(function () { onbFocusNoScroll(pin); }, 260);
        the row handler  if (pin) setTimeout(function () { pin.focus(); }, 200);

     document.activeElement was the textarea in both cases, which is why this never looked like a
     bug in any log -- the member simply had to tap the box a second time to get a keyboard.

     THE RULE: nothing may sit between the tap and the .focus(). No timer, no rAF, no
     transitionend, no await, no fetch, and no promise callback -- the announce sheet resolves a
     Promise, so its .then() is already too late (see the onAction hook in glassConfirm). The
     panel is unhidden and focused in one tick; the SCROLL may stay asynchronous and smooth,
     because it is only the focus that the keyboard keys off.
     ====================================================================== */
  function onbOpenPost(wantFocus) {
    onbClearLocks();                        // unconditional, as it was before this was a function
    var pc = document.getElementById('onb-post');
    if (!pc) { return null; }
    var wasOpen = !pc.hidden;
    pc.hidden = false;                      // unhide FIRST: a hidden field cannot take focus
    if (!wantFocus) { return pc; }
    var pin = document.getElementById('onb-post-input');
    if (!pin) { return pc; }
    // Already theirs -> leave it (and leave its keyboard watcher alone; it is already armed).
    if (document.activeElement === pin) { return pc; }
    // Already open with words in it -> that is a member mid-thought, not an empty step. Taking
    // the caret would move it to the end of what they wrote for no reason they asked for.
    if (wasOpen && String(pin.value || '').replace(/\s+/g, '') !== '') { return pc; }
    /* Same measured reserve as the comment composer (see syncFieldReserve in
       assets/onboarding-comment.js for why this is measured rather than a constant): tell the
       ENGINE's own focus reveal to bring "Post it" with the textarea, so its single animated
       scroll lands somewhere onbKeepFieldInView has nothing to correct. */
    try {
      var snd = document.getElementById('onb-post-send');
      if (snd) {
        var need = Math.round(snd.getBoundingClientRect().bottom - pin.getBoundingClientRect().bottom) + 12;
        if (need > 0 && need < 400) { pin.style.scrollMarginBottom = need + 'px'; }
      }
    } catch (er) {}
    onbFocusNoScroll(pin);                  // SYNCHRONOUS. See the block comment above.
    onbKeepFieldInView(pin, document.getElementById('onb-post-send'));
    return pc;
  }
  /* ...and the box must not end up UNDER the keyboard it just raised, with "Post it" under it.
     iOS shrinks only the VISUAL viewport for a keyboard (Android shrinks the layout one), so
     window.innerHeight is not an honest test and window.visualViewport is.

     THE RULE IS MINIMUM-MOVE-TO-VISIBLE, NEVER A RE-PIN, and assets/onboarding-comment.js's
     keyboardKeepsMediaVisible() states the same rule for the same reason (owner 2026-09-14, the
     other half of this fix): a handler that repositions a field which is ALREADY on screen moves
     a page the member placed themselves, and moving it is what they report as the bug. So this
     measures, and scrolls only by the shortfall.

     ONE SHOT PER FOCUS. The comment step needs a live handler because a keyboard can come and go
     across a long comment; this panel is opened, typed into and sent, so re-arming would only add
     a way to jitter. It also stays silent on desktop, where nothing resizes and the field is
     already on screen. `tail` is the control that must come with it (the send button), not a
     decoration: reserving it here is what keeps it tappable. */
  var ONB_KB_RESERVE = 64;   // where we LAND it: bigger than any accessory/suggestion strip
  var ONB_KB_EDGE = 8;       // how covered it must be before we move the page at all
  function onbKeepFieldInView(el, tail) {
    if (!el) { return; }
    var vv = null;
    try { vv = window.visualViewport || null; } catch (e) { vv = null; }
    var timer = null, armed = 0, dead = false;
    function stop() {
      dead = true;
      if (timer) { clearTimeout(timer); timer = null; }
      if (vv) { try { vv.removeEventListener('resize', arm); } catch (e) {} }
    }
    function arm() {
      if (dead || armed >= 6) { return; }      // ~2.5s cap; a keyboard settles long before
      armed++;
      if (timer) { clearTimeout(timer); }
      timer = setTimeout(run, 420);            // debounced: the keyboard ANIMATES in
    }
    function run() {
      timer = null;
      if (document.activeElement !== el) { stop(); return; }
      stop();
      onbScrollIntoBand(el, tail);
    }
    if (vv) { try { vv.addEventListener('resize', arm); } catch (e) {} }
    arm();
  }
  /* The measurement both composers share. Returns the pixels it scrolled (0 = it was already
     fine), which is the only honest way to assert "this did not move the page". */
  function onbScrollIntoBand(el, tail) {
    var r, top, bottom;
    try {
      r = el.getBoundingClientRect();
      var vv = window.visualViewport || null;
      top = vv ? (vv.offsetTop || 0) : 0;
      bottom = top + (vv ? vv.height : (window.innerHeight || 0));
    } catch (e) { return 0; }
    if (!r.height) { return 0; }
    // The send control rides with the field whenever the pair fits; when it does not, the field
    // alone wins -- a caret nobody can see is worse than a button they have to scroll to.
    var wantBottom = r.bottom;
    if (tail) {
      try {
        var t = tail.getBoundingClientRect();
        if (t.height && (t.bottom - r.top) + ONB_KB_RESERVE <= (bottom - top)) { wantBottom = t.bottom; }
      } catch (e2) {}
    }
    /* THE TRIGGER AND THE LANDING ARE DIFFERENT NUMBERS. assets/onboarding-comment.js carries the
       long version (2026-09-14, round two): with one number, anything resting within RESERVE of
       the keyboard was moved -- and the ENGINE'S own focus reveal lands a field a few pixels clear
       of the keyboard by design, so it always landed inside the trigger and we always added a
       second scroll on top of it. Two movements is what the owner sees as a jitter. ONB_KB_EDGE is
       "actually covered"; ONB_KB_RESERVE is only where we put it once we have decided to move. */
    var by = 0;
    if (wantBottom > bottom - ONB_KB_EDGE) { by = wantBottom - (bottom - ONB_KB_RESERVE); }
    if (r.top - by < top) { by = r.top - (top + 12); }        // the caret is at the TOP: it wins
    if (Math.abs(by) < 3) { return 0; }                       // already inside: DO NOT MOVE THE PAGE
    try { window.scrollBy({ top: by, behavior: 'auto' }); }
    catch (e3) { try { window.scrollBy(0, by); } catch (e4) {} }
    return by;
  }
  function onbGoToStep(next, viaCta) {
    if (next === 'photo') {
      /* Scroll and nudge only. The row IS the file input (views/onboarding.php stretches a real
         transparent <input type="file"> over it), and a synthesised .click() on a file input is
         blocked on iOS, so the tap has to stay the member's. */
      var phRow = document.querySelector('.setup-item[data-step="photo"]');
      onbScrollTo(phRow);
      if (phRow) { phRow.classList.add('nudge'); setTimeout(function () { phRow.classList.remove('nudge'); }, 1700); }
      return;
    }
    if (next === 'follow') { onbGoPeople(); return; }
    if (next === 'post') {
      var pr = document.querySelector('.setup-item[data-step="post"]');
      /* OPEN AND FOCUS FIRST, SCROLL SECOND. onbOpenPost unhides the composer and takes the caret
         in this same task (see the gesture block above it); the scroll may stay smooth because
         only the focus has to be inside the tap. onbOpenPost is a no-op on a field that already
         has focus, which is the normal case here: the announce sheet has already focused it from
         inside its own button handler, which is the one place iOS will honour it. */
      var pc = onbOpenPost(viaCta === true);
      onbScrollTo(pc || pr);
      if (pr) { pr.classList.add('nudge'); setTimeout(function () { pr.classList.remove('nudge'); }, 1700); }
      return;
    }
    if (next === 'comment') {
      onbClearLocks();
      var cRow = document.querySelector('.setup-item[data-step="comment"]');
      var cPanel = document.getElementById('onb-cmt');
      // the row's own listener (assets/onboarding-comment.js) opens the panel AND scrolls it into
      // place; clicking an already-open panel would collapse it, so only click when it is shut
      if (cRow && cPanel && cPanel.hidden) { cRow.click(); }
      else if (cPanel) { onbScrollTo(cPanel); }
      else if (cRow) { onbScrollTo(cRow); }
      if (cRow) { cRow.classList.add('nudge'); setTimeout(function () { cRow.classList.remove('nudge'); }, 1700); }
      return;
    }
    /* NOTHING REQUIRED LEFT -> the door, #onb-continue -- AND THE BUTTON NOW OPENS IT.
       Owner 2026-09-14: "Instead of take me to continue which brings it down to the take me to my
       feed button we can eliminate a whole waste of time by making the first button take them to
       the feed and make it say just say 'Continue' which takes them to the feed." Two taps, one of
       which was a scroll to another button, become one.

       IT ACTIVATES THE REAL CONTROL. `cont.click()` runs #onb-continue's own default action and
       every handler registered on it, so "finished via the sheet" and "finished by pressing the
       button" are the same code path BY CONSTRUCTION rather than by two places agreeing. Today
       that control is a plain <a href="/feed?tab=grid"> and completion is derived server-side
       (index.php -> Users::needsOnboarding -> Onboarding::firstMissing), so there is nothing extra
       to record -- but writing `location = '/feed?tab=grid'` here would have been a second copy of
       the destination that silently stops matching the day anything is added on the way: a
       recorded completion, a chosen landing tab, a beacon. It would also step straight past the
       blocked-step guard higher up this file, which is the one thing that must never be skipped.
       That guard is also the belt here: it re-asks onbFirstMissing() at click time, so even if a
       required step somehow ticked back between the sheet opening and the tap, the click is
       refused and the member is told which step, exactly as if they had pressed the button.

       WHY THE SHEET CANNOT BE SHOWING THIS BRANCH TO SOMEONE WHO IS NOT FINISHED: the FINISHED
       sheet is rendered only when ONB_NEXT[next] is undefined, and `next` is onbFirstMissing(),
       which returns one of photo/follow/post/comment -- all of which ARE in ONB_NEXT -- or ''.
       So the finished sheet means "no REQUIRED step outstanding", which is exactly the condition
       the route gate uses. Optional steps outstanding are fine and are what the copy refers to.

       DISMISSAL STILL DOES NOT NAVIGATE. Escape and a veil tap fall through to the scroll below:
       the member may be sitting on an optional first post or first comment and shipping them out
       unasked would take that away. Only the button travels.
       `bring` is still read for the scroll fallback so a member holding a CACHED page that still
       has the removed invite card is taken somewhere real; it resolves to null on every fresh
       render, and it deliberately does NOT divert the button -- a sheet that says "Continue" must
       continue. */
    var bring = document.getElementById('onb-bring');
    var cont = document.getElementById('onb-continue');
    if (viaCta && cont) { try { cont.click(); return; } catch (e) {} }
    var land = bring || cont;
    onbScrollTo(land);
    if (land) {
      land.classList.add('nudge');
      setTimeout(function () { land.classList.remove('nudge'); }, 1900);
    }
  }
  /* The finished sheet's words, translated by the server and stamped on #onb-continue (see the
     long note beside it in views/onboarding.php). This bundle has no catalog of its own, so the
     English literal passed in is the fallback -- and it is what a cached bundle meeting older
     markup, or an older bundle meeting today's markup, will use. Byte-identical to the t() keys. */
  function onbDoneCopy(part, fallback) {
    try {
      var cont = document.getElementById('onb-continue');
      var v = cont && cont.getAttribute('data-done-' + part);
      if (v) { return v; }
    } catch (e) {}
    return fallback;
  }

  var onbSheetOpen = false;
  var onbAnnounced = {};
  /* `assumePhoto` is forwarded straight to onbFirstMissing -- see the note there. It is set only
     by the optimistic photo advance, which announces "Photo saved." while the bytes are still
     going, and without it the sheet would read "Next: add a profile photo" to somebody who has
     just added one. */
  function onbAnnounce(justDone, assumePhoto) {
    /* THIS SHEET EXISTS ONLY FOR THE ONBOARDING CHECKLIST, so it may only ever open on the page
       that has one. ONE guard here rather than four at the four call sites (follow, photo, post,
       comment), because a fifth caller added later would otherwise reintroduce the same bug: the
       global follow handler is site-wide and its updateOnboarding() call reached this function
       from the feed, profiles, Discover People, the suggested carousel and hovercards.
       Before the once-only latch, so a call from off-page cannot burn a step's announcement and
       leave a member who later lands on /onboarding silently un-announced. */
    if (!onbOnChecklistPage()) { return; }
    // one sheet at a time, and one per step: two follows landing together, or a step announced
    // and then re-ticked, must not stack sheets or scroll twice
    if (onbAnnounced[justDone]) { return; }
    onbAnnounced[justDone] = true;
    var next;
    /* `|| onbPhotoFlight` (2026-10-02, Rob's bug): the FOLLOW step finishing while the photo was
       still saving asked onbFirstMissing() bare, got 'photo', and threw up "Next: add a profile
       photo / Take me to it" -- scrolling a member who HAD added one back to the photo row. An
       in-flight photo is skipped for routing exactly like a saved one; see onbRouteMissing(). */
    try { next = onbFirstMissing(assumePhoto || onbPhotoFlight); } catch (e) { next = ''; }
    // Unlock the later rows NOW, not on dismissal: the checklist is visible behind the veil and
    // a row that reads "locked" while the sheet points at it is a contradiction.
    if (next === 'post' || next === 'comment') { try { onbClearLocks(); } catch (e) {} }
    var go = function (viaCta) {
      onbSheetOpen = false;
      try { onbGoToStep(next, viaCta === true); } catch (e) {}
    };
    if (onbSheetOpen) { go(); return; }   // never leave them unscrolled
    // Empty for every transition but the photo. See ONB_PREFIX.
    var pre = ONB_PREFIX[justDone] || '';
    var spec = ONB_NEXT[next];
    try {
      if (typeof window.glassConfirm !== 'function') { go(); return; }
      onbSheetOpen = true;
      window.glassConfirm({
        /* THE FINISHED SHEET points at the door. It applies to WHICHEVER transition completes the
           set, not only the comment: the four steps can be done in any order, so tying it to the
           comment would send two members in identical states to different places for a reason
           neither of them can perceive.
           IT USED TO PITCH INVITES (owner 2026-08-04), and that pitch is gone with the card it
           pointed at (owner 2026-09-14: "People don't want to invite their friends until they
           like the app."). Asking a member who has just finished setting up to go and recruit
           their friends is exactly the ask he removed, so the sheet now says the one true thing
           left -- they are done.
           THE FINISHED BUTTON NOW GOES, rather than pointing at another button (owner, same day:
           "we can eliminate a whole waste of time"). It reads "Continue" and it activates
           #onb-continue itself -- see onbGoToStep's finished branch for why it presses the real
           control instead of navigating. The BODY changed with it: it used to describe the second
           hop ("Continue to your feed sits just below whenever you want it"), which is now a
           description of something that no longer happens. What survives is the part that is still
           true, because an optional first post or first comment may still be open below.
           A STEP sheet still navigates nowhere, and neither does a DISMISSAL. */
        title: spec ? (pre + 'Next: ' + spec.title) : (pre + onbDoneCopy('title', 'You are all set 🎉')),
        body: spec ? spec.body
          : onbDoneCopy('body', 'That is everything done. Your feed is ready.'),
        noCancel: true,
        actions: [{
          label: spec ? spec.cta : onbDoneCopy('cta', 'Continue'),
          value: 'go', style: 'primary'
        }],
        /* THE KEYBOARD LEG, AND IT HAS TO BE HERE. onAction runs inside the sheet button's own
           click handler (glassConfirm calls it synchronously); the .then() below is a microtask
           and is already too late for iOS to raise a keyboard. So "Write my first post" opens the
           composer and takes the caret HERE, and onbGoToStep still does the scroll and the nudge
           on the promise, where being a frame late costs nothing. Only the post step, only the
           button: dismissing a sheet must never throw a keyboard at anyone. */
        onAction: function (v) {
          if (v === 'go' && next === 'post') { try { onbOpenPost(true); } catch (e) {} }
        }
      }).then(function (v) {
        /* v decides whether this was an ANSWER or a DISMISSAL, and that is the only thing that
           may navigate: on the finished sheet the button presses #onb-continue and leaves, while
           Escape and a veil tap scroll to it and stay. On a STEP sheet neither navigates. Both
           always proceed -- nobody is ever left where the sheet found them. */
        go(v === 'go');
      }).catch(function () { go(false); });
    } catch (e) { go(false); }
  }
  // assets/onboarding-comment.js owns step four and lives in its own file, so it reaches the
  // announcer the same way it already reaches onbMaybeUnlockContinue: through window.
  window.__rovaOnbAnnounce = onbAnnounce;
  function refreshSetupCount() {
    var list = document.querySelector('.setup-list');
    var cnt = document.getElementById('chk-count');
    if (!list || !cnt) return;
    var fRow = document.getElementById('chk-follow');
    // data-steps (3, or 4 once the optional first-COMMENT step is on the list) and data-comment are
    // rendered by views/onboarding.php. assets/onboarding-comment.js recomputes this identically, so
    // whichever of the two writes #chk-count last, both agree. Older markup without the attributes
    // falls back to the original "N of 3".
    var steps = parseInt(list.getAttribute('data-steps'), 10) || 3;
    var total = ((fRow && fRow.classList.contains('done')) ? 1 : 0)
      + (list.getAttribute('data-photo') === '1' ? 1 : 0)
      + (list.getAttribute('data-post') === '1' ? 1 : 0)
      + (list.getAttribute('data-comment') === '1' ? 1 : 0);
    cnt.textContent = total + ' of ' + steps + ' done';
  }

  /* ---- onboarding checklist: tapping a step guides you to the right place - */
  document.addEventListener('click', function (e) {
    // never swallow the file input's own click, or preventDefault would cancel
    // the native picker (and re-entering would recurse)
    if (e.target && e.target.id === 'avatar-file') return;
    var item = e.target.closest ? e.target.closest('.js-setup') : null;
    if (!item) return;
    var step = item.getAttribute('data-step');
    var pRow = document.querySelector('.setup-item[data-step="photo"]');
    /* IN FLIGHT COUNTS. This is the tap-side twin of openLaterSteps() in assets/onb-boot.js and
       the two must agree exactly, or a row that onb-boot has visually unlocked answers a tap
       with "Add a profile photo first" -- which is a worse experience than the lock it replaced.
       See the long note beside onbPhotoFlight above for why this does not reach the feed gate. */
    var photoDone = (pRow && pRow.classList.contains('done')) || onbPhotoFlight;
    var fRow = document.getElementById('chk-follow');
    var followsDone = fRow && fRow.classList.contains('done');
    // The server's own verdict on the REQUIRED pair (views/onboarding.php data-required). It is
    // true for a member who took the quiet follow skip, whose follow row never ticks -- without
    // this they were bounced off their own unlocked rows with "Follow 3 people to unlock this".
    var sList = document.querySelector('.setup-list');
    var reqDone = !!(sList && sList.getAttribute('data-required') === '1');

    // Follow step -> scroll to the people list.
    if (step === 'follow') {
      e.preventDefault();
      onbGoPeople();
      return;
    }
    // Post step while still locked -> nudge to whichever setup step is still missing: photo (step 1) first,
    // then follow-3 (step 2).
    if (step === 'post' && !reqDone && !(photoDone && followsDone)) {
      e.preventDefault();
      if (!photoDone) {
        if (pRow) { pRow.scrollIntoView({ behavior: 'smooth', block: 'center' }); pRow.classList.add('nudge'); setTimeout(function () { pRow.classList.remove('nudge'); }, 1600); }
        toast('Add a profile photo first to unlock this');
      } else {
        onbGoPeople();
        toast('Follow 3 people to unlock this');
      }
      return;
    }
    // Photo step (always available) -> the row is a native <label for="avatar-file">,
    // so we let the browser open the picker itself. Do NOT preventDefault (that
    // cancels the label) and do NOT synthesize a .click() (blocked on iOS).
    if (step === 'photo') return;
    // Unlocked post step -> expand the inline composer (never leave onboarding).
    if (step === 'post') {
      e.preventDefault();
      /* A FINISHED ROW DOES NOT REOPEN (2026-08-05). Tapping the ticked "Posted! 🎉" row used to
         toggle #onb-post back open with a live "Post it" button under it. That composer still
         sends onboarding=1, and Onboarding::firstPostExempt() is FALSE once postDone() is true,
         so an unverified new member got a verify_email 403 from a button that looked ready.
         assets/onboarding-comment.js has always returned early on .done for the first-comment
         row; the two steps differ for no reason. `item` is the closest .js-setup, which for
         data-step="post" is the row itself, and it carries .done from BOTH entry paths:
         views/onboarding.php stamps it at render for a returning member, and markPostDone()
         adds it right after a successful post in the same session. */
      if (item.classList.contains('done')) { return; }
      var pc = document.getElementById('onb-post');
      if (!pc) { return; }
      if (!pc.hidden) { pc.hidden = true; return; }      // the row still toggles it shut
      /* OPEN AND FOCUS IN THIS SAME TASK. This was `pc.hidden = !pc.hidden` followed by
         `setTimeout(function () { pin.focus(); }, 200)`, and that timer is the whole of the
         owner's 2026-09-14 bug: the caret landed, iOS raised no keyboard, and the member had to
         tap the box a second time. See the block by onbOpenPost.
         The scroll moved to onbScrollTo (top-aligned under the header) from
         scrollIntoView({block:'center'}), which is both the checklist's documented one scroll
         rule and the only one that survives a keyboard: centring in the LAYOUT viewport puts the
         panel's lower half -- the textarea and Post it -- behind the keys. Measured on the rig at
         390x844: with the old centring, "Post it" was under the keyboard. */
      onbOpenPost(true);
      onbScrollTo(pc);
    }
  });

  /* ---- onboarding: inline first-post composer (prompts + AJAX post) ------- */
  (function () {
    var pc = document.getElementById('onb-post');
    if (!pc) return;
    var input = document.getElementById('onb-post-input');
    var errEl = document.getElementById('onb-post-err');
    var send = document.getElementById('onb-post-send');
    /* THE STARTER CHIPS SEED AN OPENER THEY KEEP (2026-08-05). This block used to erase the
       starter on the first keystroke so that no two first posts opened with the same "Something
       I'm really into lately:" boilerplate. The owner overruled that on the COMMENT step, in the
       same words the error message below already used ("the prompt is just a starter"), and this
       step is changed with it deliberately: it shows the identical chips, performs the identical
       erase and prints the IDENTICAL sentence when it refuses, so leaving the two opposite would
       mean one onboarding page teaching two contradictory lessons about the same control one row
       apart. assets/onboarding-comment.js carries the long-form reasoning; the three decisions are
       the same here.

         - nothing rewrites the box while they type (the whole `input` listener is gone, so an
           edited or deleted starter simply stays edited or deleted);
         - no capitalisation of their first character: their words follow the starter mid-line now;
         - a second chip swaps the opener and KEEPS their words rather than being ignored.

       The requirement that they add words of their own is untouched: onbOwnWords() below and
       Onboarding::starterOnly() on the server both strip the starters and count the residue, which
       is a test on what is left over, not on what the box opens with. */
    function onbWithoutStarter(v) {
      var lv = String(v || '').toLowerCase(), best = -1;
      onbPrompts.forEach(function (p) {            // trimmed chip phrases, built below
        if (p && lv.indexOf(p.toLowerCase()) === 0 && p.length > best) best = p.length;
      });
      if (best < 0) return String(v || '');
      return String(v).slice(best).replace(/^\s+/, '');   // the chip re-adds the join space
    }
    pc.addEventListener('click', function (e) {
      var chip = e.target.closest ? e.target.closest('.onb-sug') : null;
      if (!chip || !input) return;
      var fill = chip.getAttribute('data-fill') || '';     // ships WITH its trailing space
      var rest = onbWithoutStarter(input.value);           // their words, whichever starter was on
      var joined = fill;
      if (rest) joined += (/\s$/.test(fill) ? '' : ' ') + rest;   // exactly one gap at the join
      input.value = joined;
      input.focus();
      var caret = fill.length;                             // end of the starter: where the next word goes
      try { input.setSelectionRange(caret, caret); } catch (er) {}
      if (errEl) errEl.hidden = true;
    });
    function markPostDone() {
      var row = document.querySelector('.setup-item[data-step="post"]');
      var list = document.querySelector('.setup-list');
      var wasDone = !!(row && row.classList.contains('done'));
      if (list) list.setAttribute('data-post', '1');
      if (row) {
        row.classList.add('done');
        var chk = row.querySelector('.setup-check'); if (chk) chk.textContent = '✓';
        var cta = row.querySelector('.setup-cta'); if (cta) cta.textContent = '✓';
      }
      var sub = document.getElementById('onb-post-sub'); if (sub) sub.textContent = 'Posted! 🎉';
      pc.hidden = true;
      if (typeof refreshSetupCount === 'function') refreshSetupCount();
      // the first post is a REQUIRED step now, so Continue may have just come unblocked
      if (typeof onbMaybeUnlockContinue === 'function') onbMaybeUnlockContinue();
      /* THE HAND-OFF, now through the announcer (2026-08-04). This used to pick its own next
         target: the comment step when it was open, otherwise the invite card, each with a toast.
         onbAnnounce asks onbFirstMissing() the same question and gets the same two answers, so
         the routing is unchanged; what is new is that the member is told which one they are being
         sent to, and the toast is gone because a sheet they have to dismiss says it properly.
         The old code scrolled after a 60ms settle so the collapsing composer could not move the
         measurement under it. The sheet is a far longer wait than 60ms, and onbGoToStep measures
         at dismissal, so that settle is inherent now rather than timed. */
      if (!wasDone) { onbAnnounce('post'); }
    }
    // the starter chips only pre-fill a prompt - a post that's JUST the prompt(s) with
    // nothing of their own isn't a real first post, so require some actual words.
    var onbPrompts = Array.prototype.map.call(pc.querySelectorAll('.onb-sug'), function (c) {
      return (c.getAttribute('data-fill') || '').trim();
    }).filter(Boolean);
    /* THIS RENDER'S STARTER DRAW + the filler copy (2026-08-05). The chips are dealt fresh from a
       24 phrase pool on every page load, so the server cannot re-run the draw at submit time: it
       needs the seed back (posted as starter_seed, re-derived by Onboarding::postStarterVerdict).
       data-filler carries Onboarding::FILLER_MSG so this button and the server refuse filler in
       the same words from one const. Both are stamped on #onb-post by views/onboarding.php. */
    var onbSeed = pc.getAttribute('data-seed') || '';
    var onbFillerMsg = pc.getAttribute('data-filler')
      || 'That looks like filler. Write a few real words, even a short line is perfect. 🙂';
    var ONB_LETTER;
    try { ONB_LETTER = new RegExp('[\\p{L}\\p{N}]', 'gu'); }
    catch (er) { ONB_LETTER = /[0-9A-Za-zÀ-ɏͰ-῿぀-￿]/g; }
    var ONB_FILLER_MIN = 4;                          // Onboarding::FILLER_MIN
    /* THE TWIN OF Onboarding::ownWords(). Strip every starter we offered, then measure the residue
       two ways: n = their own letters/digits, d = how many DISTINCT ones. n < 2 is "nothing but the
       prompt"; n >= 4 with d < 2 is "hhhh". Short real posts are fine either way - the bar is not
       length, it is that a real word is never one character wearing a longer coat. */
    function onbOwnWords(text) {
      var t = String(text || '');
      onbPrompts.forEach(function (p) {              // remove every starter phrase we offered
        if (!p) return;
        var lp = p.toLowerCase(), idx;
        while ((idx = t.toLowerCase().indexOf(lp)) !== -1) { t = t.slice(0, idx) + t.slice(idx + p.length); }
      });
      var m = t.toLowerCase().match(ONB_LETTER) || [], seen = {}, d = 0;
      for (var i = 0; i < m.length; i++) {
        if (!Object.prototype.hasOwnProperty.call(seen, m[i])) { seen[m[i]] = 1; d++; }
      }
      return { n: m.length, d: d };
    }
    if (send) send.addEventListener('click', function () {
      var body = ((input && input.value) || '').trim();
      if (errEl) errEl.hidden = true;
      /* THREE OUTCOMES, THREE SENTENCES, and the server reaches the same three
         (Onboarding::postStarterVerdict). 'filler' says something different on purpose: telling
         somebody who typed "hhhh" that the prompt is just a starter names a fault they do not have. */
      var onbW = onbOwnWords(body);
      if (!body || onbW.n < 2) {
        if (input) input.focus();
        if (errEl) {
          errEl.textContent = body
            ? 'Add a few of your own words, the prompt is just a starter. 🙂'
            : 'Write a line first, a suggestion above is a great start.';
          errEl.hidden = false;
        }
        return;
      }
      if (onbW.n >= ONB_FILLER_MIN && onbW.d < 2) {
        if (input) input.focus();
        if (errEl) { errEl.textContent = onbFillerMsg; errEl.hidden = false; }
        return;
      }
      send.disabled = true; send.textContent = 'Posting…';
      var fd = new FormData(); fd.append('body', body); fd.append('onboarding', '1');
      // the draw this page was rendered with, so the server strips what was actually shown
      if (onbSeed) fd.append('starter_seed', onbSeed);
      fetch('/compose?ajax=1', {
        method: 'POST',
        headers: { 'X-CSRF-Token': csrf, 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
        body: fd, credentials: 'same-origin'
      }).then(function (r) { return r.json().catch(function () { return {}; }); })
        .then(function (res) {
          send.disabled = false; send.textContent = 'Post it';   // ALWAYS reset (never leave it stuck)
          // treat any 2xx-ish response as success: the post is created early in the
          // handler, so ok:true, an id, or even a body-less {} all mean it went through
          if (!res || res.error) {
            if (errEl) { errEl.textContent = (res && res.error) || 'Could not post. Please try again.'; errEl.hidden = false; }
            return;
          }
          try { markPostDone(); } catch (e) { if (pc) pc.hidden = true; }
        })
        .catch(function () {
          send.disabled = false; send.textContent = 'Post it';
          if (errEl) { errEl.textContent = 'Network error. Please try again.'; errEl.hidden = false; }
        });
    });
  })();

  /* ---- onboarding people list: a tap ANYWHERE on the row follows the person
     (most have no bio, so the old tap-to-peek preview was useless) ---------- */
  document.addEventListener('click', function (e) {
    var person = e.target.closest ? e.target.closest('#people .person[data-uid]') : null;
    if (!person) return;
    if (e.target.closest('.js-follow')) return;   // the Follow button submits its own form
    var form = person.querySelector('.js-follow'), btn = form && form.querySelector('button');
    if (form && btn && !btn.disabled) {
      if (typeof form.requestSubmit === 'function') form.requestSubmit(btn); else btn.click();
    }
  });

  /* ---- onboarding: search for someone to follow --------------------------
     Swaps the #people rows via GET /onboarding-people (server-rendered, same
     markup as first paint, so the delegated follow/tap handlers just work).
     Clearing the box restores the default suggestions (empty q = suggestions). */
  (function () {
    var inp = document.getElementById('onb-search');
    var list = document.getElementById('people');
    if (!inp || !list) return;
    var timer = null, ctrl = null, last = '';
    function run() {
      var q = inp.value.trim();
      if (q.length === 1) return;               // wait for 2 chars ('' restores suggestions)
      if (q === last) return;
      last = q;
      if (ctrl) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      fetch('/onboarding-people?q=' + encodeURIComponent(q), {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        credentials: 'same-origin',
        signal: ctrl ? ctrl.signal : undefined
      }).then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) { if (html !== null) list.innerHTML = html; })
        .catch(function () { /* aborted or offline: keep whatever is showing */ });
    }
    inp.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 250); });
    inp.addEventListener('search', run);        // the native clear (x) on type=search
  })();

  /* == SELF-AVATAR LIVE SWAP (twin: assets/app.js <-> assets/onb-boot.js) ==================
     THE MEMBER'S OWN PICTURE, EVERYWHERE IT IS ON THE PAGE, THE MOMENT IT IS SAVED.
     (owner 2026-08-21: "During onboarding it should update the user's picture immediately
     without a full page reload.")

     WHAT WAS ACTUALLY STALE. /onboarding already previewed the picked file into the checklist
     row and already ticked the step, so the row looked right. The two header avatars did not:
     lib/view.php renders them server-side (avatar_img($u,'sm',false) inside #menu-trigger and
     .menu-head, in BOTH the mid-onboarding branch and the full-chrome one), so the member sat
     under their own gold monogram until they navigated. Proved headlessly before the fix:
     #avatar-current became a blob <img> while #menu-trigger .avatar stayed the letter "F".
     And with the big bundle absent -- the slow-network case assets/onb-boot.js exists for --
     NOTHING on the page showed the picture at all, not even the row.

     WHY THE LOCAL BLOB AND NOT A URL. The file is already in the member's hand: it is exactly
     the image, it costs no request, and it cannot be wrong. A URL cannot promise either of
     those. Avatars resolve through a size-aware variant ladder plus a CDN, a PNG upload is
     transcoded to JPEG so a derived filename is a guaranteed 404, and the CDN negative-caches
     a miss for hours -- so a freshly-uploaded URL is the one URL you must not depend on being
     fetchable yet. `path` is the server's OWN string used verbatim (never assembled here) and
     is only the fallback for a dispatcher that has no File to give.

     WHY THIS BLOCK IS DUPLICATED, BYTE FOR BYTE, IN TWO FILES. There are two dispatchers of
     rova:media-saved and either can be the only code on the page: assets/onb-boot.js is the
     few-KB safety net that owns the upload when the 537 KB bundle has not arrived, and
     assets/app.js owns it everywhere onb-boot.js is not loaded (/settings). Whichever runs
     first claims the listener via window.__rovaSelfAvBound, so it fires exactly once. The
     copies are held identical by tools/self-avatar-swap-check.js, which diffs the text between
     these two markers and fails the moment they drift -- the same reason tickPhotoStep() is
     allowed to shadow the checklist tick in app.js. */
  var ROVA_SELF_AV_SEL = '#menu-trigger .avatar, .menu-head .avatar, #avatar-current .avatar, .js-self-av';
  function rovaSwapSelfAvatar(file, path) {
    var url = '', isVid = false;
    try {
      if (file && window.URL && URL.createObjectURL) {
        url = URL.createObjectURL(file);
        isVid = String(file.type || '').indexOf('video') === 0;
      }
    } catch (e) { url = ''; }
    if (!url && path) { url = String(path); isVid = /\.(mp4|webm|mov)(\?|$)/i.test(url); }
    if (!url) { return 0; }
    /* Same two shapes avatar_img() emits, so the swapped node is the node the stylesheet already
       knows: an <img class="avatar SIZE"> for a photo, and for a 3-second profile video the
       .av-vid WRAPPER (Safari ignores object-fit on <video>, which is why the crop is done by the
       box and not by the element). No gate class is carried over -- a member looking at the photo
       they just chose is not a moderation surface, and avatars are never blocked here. */
    function build(size) {
      var el;
      if (isVid) {
        el = document.createElement('span');
        el.className = 'avatar ' + size + ' av-vid';
        var v = document.createElement('video');
        v.src = url; v.muted = true; v.loop = true; v.autoplay = true;
        v.setAttribute('playsinline', ''); v.setAttribute('muted', '');
        v.setAttribute('disablepictureinpicture', ''); v.preload = 'metadata';
        el.appendChild(v);
      } else {
        el = document.createElement('img');
        el.className = 'avatar ' + size;
        el.src = url; el.alt = ''; el.setAttribute('decoding', 'async');
      }
      return el;
    }
    var nodes = document.querySelectorAll(ROVA_SELF_AV_SEL);
    var n = 0, i;
    for (i = 0; i < nodes.length; i++) {
      var old = nodes[i];
      /* KEEP THE SIZE THE SLOT ASKED FOR. sm in the header, lg on the settings page; a hardcoded
         size here would resize the header on the way past. Default sm, which is what every
         avatar_img() call without an explicit size renders. */
      var m = (old.getAttribute('class') || '').match(/(^|\s)(xs|sm|md|lg|xl)(\s|$)/);
      var next = build(m ? m[2] : 'sm');
      if (old.parentNode) { old.parentNode.replaceChild(next, old); n++; }
    }
    /* #avatar-current is a CONTAINER, and on /onboarding it ships EMPTY and hidden, so there is
       nothing for the loop above to replace -- the picture has to be put into it. Do not "fix"
       this by rendering an avatar into it server-side: empty is what tells the row that this
       member has no photo yet. [hidden] is only display:none at UA-stylesheet strength (see the
       inline <style> in views/onboarding.php, which fights exactly this), so the computed value
       is checked rather than trusted. */
    var cur = document.getElementById('avatar-current');
    if (cur && !cur.querySelector('.avatar')) {
      while (cur.firstChild) { cur.removeChild(cur.firstChild); }
      cur.appendChild(build('lg'));
      cur.hidden = false;
      try {
        if (window.getComputedStyle(cur).display === 'none') { cur.style.display = 'inline-block'; }
      } catch (e) {}
      n++;
    }
    return n;
  }
  if (!window.__rovaSelfAvBound) {
    window.__rovaSelfAvBound = 1;
    document.addEventListener('rova:media-saved', function (e) {
      var d = e && e.detail;
      if (!d || d.type !== 'avatar') { return; }
      try { rovaSwapSelfAvatar(d.file, d.path); } catch (er) {}
    });
  }
  /* == END SELF-AVATAR LIVE SWAP ========================================================== */

  /* ---- onboarding: inline avatar upload ticks the photo step -------------- */
  document.addEventListener('rova:media-saved', function (e) {
    if (!e.detail || e.detail.type !== 'avatar') return;
    var row = document.querySelector('.setup-item[data-step="photo"]');
    if (!row) return;                                    // not on onboarding
    /* Before a single write below, because this measures the row's height and everything under
       this line changes it. Idempotent with the 'done' event's own call -- whichever arrives
       first arms it. See onbHoldAnchor. */
    try { onbHoldAnchor(); } catch (er) {}
    // BEFORE the tick below, because that is the only moment the two states can be told apart.
    // Changing an avatar you already had is not finishing the photo step, and must not announce.
    var wasDone = row.classList.contains('done');
    var list = document.querySelector('.setup-list');
    if (list) list.setAttribute('data-photo', '1');
    row.classList.add('done');
    var chk = row.querySelector('.setup-check'); if (chk) chk.textContent = '✓';
    var cta = row.querySelector('.setup-cta'); if (cta) cta.textContent = '✓';
    var sub = document.getElementById('onb-photo-sub'); if (sub) sub.textContent = 'Nice, people will recognize you';
    // photo (step 1) done -> name whatever is next and scroll there when they dismiss it.
    // onbAnnounce works out what "next" actually is, so this no longer has to know whether the
    // follow step is already behind them.
    /* UNLESS THEY TOOK US UP ON IT (2026-08-15). The whole change above invites the member to go
       and do another step while the photo uploads. onbAnnounce() then answers that invitation by
       throwing a full-screen sheet over them and, on dismissal, SCROLLING the page somewhere
       else -- mid-sentence in the first-post box, or mid-list in the people picker. A modal that
       lands on someone who is typing is exactly the interruption this work exists to remove, and
       it would land seconds AFTER the thing it is announcing, so it reads as an error.
       So: when they stayed with the photo row, nothing changes and they get the sheet that
       walks them to the next step. When they moved on, the row simply ticks under them, a toast
       says so once, and the page does not move. onbAnnounced.photo is burned either way, so a
       later transition cannot come back and fire the photo sheet retrospectively. */
    if (!wasDone && onbMovedOn) {
      onbAnnounced.photo = true;
      var nx = '';
      try { nx = onbFirstMissing(); } catch (er) { nx = ''; }
      if (nx === 'post' || nx === 'comment') { try { onbClearLocks(); } catch (er) {} }
      try { toast('Photo saved.'); } catch (er) {}
    } else if (!wasDone) {
      onbAnnounce('photo');
    }
    // pull the fresh photo (or a frame from the profile video) into the share card right away, so
    // it already has their face on it. NOT on /onboarding any more -- the invite card was removed
    // from that page on 2026-09-14 and invite.js is no longer loaded there, so __rovaInviteReload
    // is simply undefined and this is a no-op. It still matters on /invite and /founders, where
    // an avatar change and the share card share a page.
    if (e.detail.path && window.__rovaInviteReload) window.__rovaInviteReload(e.detail.path);
    onbMaybeUnlockContinue();
    refreshSetupCount();
    /* They pressed Continue while this was saving (onbContinueWait). Now it has landed, press it
       for real: the same element, the same guard, the same link -- if anything were somehow still
       owed, the guard names it instead of letting them through. */
    if (onbContWaiting) {
      onbContinueRelease();
      var contBtn = document.getElementById('onb-continue');
      if (contBtn && !onbFirstMissing()) { try { contBtn.click(); } catch (er) {} }
    }
  });

  /* ---- header avatar dropdown menu ------------------------------------- */
  /* AVATAR MENU v2 (2026-09-30; markup lib/view.php menuRow/menuTail, styles rova.css "AVATAR MENU v2").
     Keyboard: Enter/Space/ArrowDown on the avatar opens with the FIRST row focused, ArrowUp with the
     last; inside, ArrowUp/Down walk every menuitem (header card, rows, the two theme segments, Log out)
     with wrap-around, Home/End jump, Tab/Shift+Tab are TRAPPED (they cycle), Esc closes and hands focus
     back to the avatar. A pointer open focuses the panel itself (tabindex=-1, no ring), so the trap and
     the arrows work straight away without painting a focus ring on a mouse/touch open.
     Placement: the panel keeps 12px from both viewport edges and never runs below the fold (its
     max-height is re-measured at each open -- landscape phones scroll inside it). */
  var menuTrigger = document.getElementById('menu-trigger');
  var menuPanel = document.getElementById('menu-panel');
  if (menuTrigger && menuPanel) {
    /* #661: tell the stylesheet the JS menu wiring is LIVE. rova.css carries a no-JS
       fallback (html:not(.js-on) .menu:focus-within shows the panel, and a Presto-era
       static layout for Opera Mini) so logout stays reachable when this file never
       runs. The class scopes that fallback OFF for everyone here: with it set, the
       menu behaves byte-for-byte as it always has. */
    try { document.documentElement.classList.add('js-on'); } catch (e) {}
    var menuItems = function () {
      return Array.prototype.filter.call(menuPanel.querySelectorAll('[role="menuitem"],[role="menuitemradio"]'), function (el) {
        return !el.disabled && el.offsetParent !== null;
      });
    };
    var menuPlace = function () {
      // reset, measure the natural spot, then nudge so 12px stays clear on both sides
      menuPanel.style.right = ''; menuPanel.style.maxHeight = '';
      var vw = document.documentElement.clientWidth || window.innerWidth;
      var host = menuPanel.offsetParent || menuPanel.parentNode;
      var hr = host.getBoundingClientRect();
      var w = menuPanel.offsetWidth;
      var right = hr.right;                       // the panel's right edge sits on its host's right edge (right:0)
      var shift = 0;
      if (right > vw - 12) shift = right - (vw - 12);             // too close to the right edge: pull left
      else if (right - w < 12) shift = (right - w) - 12;          // would cross the left edge: push right
      if (shift) menuPanel.style.right = shift + 'px';
      var top = menuTrigger.getBoundingClientRect().bottom + 10;
      menuPanel.style.maxHeight = Math.max(160, window.innerHeight - top - 12) + 'px';
    };
    var themeSync = function () {
      var cur = document.documentElement.getAttribute('data-theme') === 'light' ? 'light' : 'dark';
      Array.prototype.forEach.call(menuPanel.querySelectorAll('[data-theme-set]'), function (b) {
        b.setAttribute('aria-checked', b.getAttribute('data-theme-set') === cur ? 'true' : 'false');
      });
    };
    /* THE GOLD ROW's balance chip (2026-10-02, lib/view.php "GOLD"): rendered EMPTY, filled from /me/wallet the first
       time the menu opens or the pointer heads for the avatar -- so no page load pays for a wallet read, and only the
       accounts that see the row (gifting testers today) ever make one. Short Gold rounded DOWN, the tray's gshort. */
    var goldChip = function () {
      var c = menuPanel.querySelector('.am-gold[data-wallet]');
      if (!c || !window.fetch) return;
      var src = c.getAttribute('data-wallet'); c.removeAttribute('data-wallet');
      fetch(src, { credentials: 'same-origin', cache: 'no-store', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          var g = j && j.wallet ? Math.max(0, Math.floor(+j.wallet.gold || 0)) : null, n = c.querySelector('.am-gold-n');
          if (g === null || !n) return;
          var t = Math.floor(g / 100), s = String(g);
          if (g >= 1000) { var u = 'k'; if (t >= 10000) { t = Math.floor(g / 100000); u = 'M'; } s = Math.floor(t / 10) + (t % 10 ? '.' + (t % 10) : '') + u; }
          n.textContent = s; c.title = g.toLocaleString('en-US') + ' Gold';
        }, function () {});
    };
    menuTrigger.addEventListener('pointerenter', goldChip);
    function setMenu(open, focusWhere) {
      var was = menuPanel.classList.contains('show');
      if (open && !was) { menuPlace(); themeSync(); goldChip(); }
      menuPanel.classList.toggle('show', open);
      menuTrigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        if (focusWhere === 'first' || focusWhere === 'last') {
          var its = menuItems();
          if (its.length) its[focusWhere === 'first' ? 0 : its.length - 1].focus();
        } else if (focusWhere === 'panel' && !menuPanel.contains(document.activeElement)) {
          try { menuPanel.focus({ preventScroll: true }); } catch (e) {}
        }
      } else if (was && focusWhere === 'trigger') {
        try { menuTrigger.focus(); } catch (e) {}
      } else if (was && menuPanel.contains(document.activeElement)) {
        try { document.activeElement.blur(); } catch (e) {}
      }
    }
    menuTrigger.addEventListener('click', function (e) {
      e.stopPropagation();
      // e.detail === 0: the click came from the keyboard (Enter/Space) -> focus the first row
      setMenu(!menuPanel.classList.contains('show'), e.detail === 0 ? 'first' : 'panel');
    });
    menuTrigger.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        setMenu(true, e.key === 'ArrowDown' ? 'first' : 'last');
      }
    });
    document.addEventListener('click', function (e) {
      if (menuPanel.classList.contains('show') && !menuPanel.contains(e.target) && !menuTrigger.contains(e.target)) {
        setMenu(false);
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menuPanel.classList.contains('show')) {
        setMenu(false, (menuPanel.contains(document.activeElement) || document.activeElement === menuTrigger) ? 'trigger' : '');
      }
    });
    menuPanel.addEventListener('keydown', function (e) {
      if (!menuPanel.classList.contains('show')) return;
      var its = menuItems(); if (!its.length) return;
      var i = its.indexOf(document.activeElement), n = its.length, to = -1;
      if (e.key === 'ArrowDown') to = i < 0 ? 0 : (i + 1) % n;
      else if (e.key === 'ArrowUp') to = i < 0 ? n - 1 : (i - 1 + n) % n;
      else if (e.key === 'Home') to = 0;
      else if (e.key === 'End') to = n - 1;
      else if (e.key === 'Tab') to = e.shiftKey ? (i <= 0 ? n - 1 : i - 1) : (i < 0 || i >= n - 1 ? 0 : i + 1);
      if (to < 0) return;
      e.preventDefault();
      its[to].focus();
    });
    window.addEventListener('resize', function () { if (menuPanel.classList.contains('show')) menuPlace(); });
    // theme: the v2 sun/moon segments SET a theme (not flip). On desktop the menu stays put so you
    // can compare; on phones the dropdown covers most of the page, so it closes a beat after the
    // pick (the segment's own slide is the confirmation) to show off the new theme.
    Array.prototype.forEach.call(menuPanel.querySelectorAll('[data-theme-set]'), function (b) {
      b.addEventListener('click', function (e) {
        e.stopPropagation();
        setTheme(b.getAttribute('data-theme-set'));
        themeSync();
        if (window.matchMedia && matchMedia('(max-width:700px)').matches) setTimeout(function () { setMenu(false); }, 220);
      });
    });
    /* THE MEMBER'S SERVER THEME (db/0267, 2026-10-11): lib/view.php menuTail() stamps data-theme-pref = the account's
       choice ('system'|'dark'|'light', '' = never chosen). A choice made in the app (or another browser) wins over this
       browser's cookie: apply it (setTheme(..., true) rewrites the cookie, so the NEXT first paint is already right).
       Never chosen + a cookie this browser set = adopt the cookie into the account, once. Guests have no menu: cookie only. */
    (function () {
      var pe = menuPanel.querySelector('[data-theme-pref]');
      if (!pe) return;
      var pref = pe.getAttribute('data-theme-pref') || '';
      var want = pref === 'system'
        ? ((window.matchMedia && matchMedia('(prefers-color-scheme: light)').matches) ? 'light' : 'dark')
        : pref;
      if (want === 'light' || want === 'dark') {
        if (document.documentElement.getAttribute('data-theme') !== want) setTheme(want, true);
      } else if (pref === '') {
        var cm = document.cookie.match(/(?:^|;\s*)rova_theme=(light|dark)(?:;|$)/);
        if (cm) { pe.setAttribute('data-theme-pref', cm[1]); postJson('/settings/theme', { theme: cm[1] }, 8000).catch(function () {}); }
      }
    })();
    themeSync();
    // legacy single toggle (only in a page rendered before v2 shipped): same close-on-phones rule
    var tt = document.getElementById('theme-toggle');
    if (tt && menuPanel.contains(tt)) tt.addEventListener('click', function (e) {
      e.stopPropagation();
      if (window.matchMedia && matchMedia('(max-width:700px)').matches) setMenu(false);
    });
    // clicking any link in the menu closes it, incl. the + (same-page /feed#compose) and the profile head
    menuPanel.addEventListener('click', function (e) {
      if (e.target.closest('a')) setMenu(false);
    });
  }

  /* ---- spin the header logo's R while a real page navigation is loading --
     beforeunload/pagehide fire only on genuine navigations (never on JS-handled
     clicks like the auth modal or feed tabs), so the spinner never gets stuck. On
     slow connections you see it during the fetch; on fast ones it's a quick flash. */
  (function () {
    var root = document.documentElement;
    var start = function () { root.classList.add('nav-loading'); };
    var stop  = function () { root.classList.remove('nav-loading'); };
    window.addEventListener('beforeunload', start);
    window.addEventListener('pagehide', start);
    window.addEventListener('pageshow', stop);   // fresh load + bfcache restore -> stop
    stop();
  })();

  /* ---- location beam --------------------------------------------------- */
  // settings: every location action (save / device / turn off) posts over
  // AJAX and updates the card in place, no page load. Plain form posts stay
  // as the no-JS fallback.
  (function () {
    var card = document.getElementById('location');
    if (!card) return;
    var row = document.getElementById('loc-now');
    // one painter for both states: on = live beam + "Turn off",
    // off = place kept + "Turn on" + the forget link
    function paintLoc(on, label) {
      if (!row) return;
      row.hidden = false;
      if (label != null) {
        var lbl = document.getElementById('loc-now-label');
        if (lbl) lbl.textContent = (label || '').trim() || 'Approximate area set';
      }
      var sub = document.getElementById('loc-now-sub');
      if (sub) sub.textContent = on ? 'Shown as a beam on your profile.' : 'Your beam is off, not shown anywhere.';
      var tf = document.getElementById('loc-toggle-form');
      var ta = document.getElementById('loc-toggle-action');
      var tb = document.getElementById('loc-toggle-btn');
      if (tf) tf.setAttribute('data-mode', on ? 'off' : 'on');
      if (ta) ta.value = on ? 'off' : 'on';
      if (tb) {
        tb.textContent = on ? 'Turn off' : 'Turn on';
        tb.classList.toggle('primary', !on);
        tb.classList.toggle('gold-ghost', on);
      }
      var ff = document.getElementById('loc-forget-form');
      if (ff) ff.hidden = on;
    }
    card.addEventListener('submit', function (e) {
      var form = e.target.closest ? e.target.closest('.js-loc-form') : null;
      if (!form) return;
      e.preventDefault();
      // in-flight paint + dedupe (the Set form geocodes server-side -- the slow one of the four)
      var sb = (e.submitter && e.submitter.type === 'submit') ? e.submitter
             : form.querySelector('button[type="submit"], button:not([type])');
      if (busyIs(sb)) return;
      var mode = form.getAttribute('data-mode');
      busyUntil(sb, postJson('/settings/location', new FormData(form), 15000).then(function (res) {
        if (!res || !res.ok) { toast((res && res.message) || 'Could not save that'); return; }
        if (mode === 'clear') {
          if (row) row.hidden = true;
          var ff = document.getElementById('loc-forget-form');
          if (ff) ff.hidden = true;
          toast('Location forgotten');
          return;
        }
        if (mode === 'off') { paintLoc(false, null); toast('Beam off'); return; }
        paintLoc(true, mode === 'on' ? (res.label || null) : (res.label || ''));   // on / set / device
        var q = document.getElementById('loc-q');
        if (q) q.value = '';
        toast('Your beam is live');
      }).catch(function (err) {
        if (err && err.message === 'reauth') return;
        toast(mode === 'set' ? 'Could not place that. Try "City, ST", like "Austin, TX"' : 'Could not save that');
      }).finally(function () {
        var lb = card.querySelector('.js-locate');
        if (lb) { lb.disabled = false; lb.textContent = 'Use my device location'; }
      }));
    });
    // back/forward cache serves a frozen copy of this page, which can show the
    // beam's OLD on/off state after a toggle; force a fresh render instead
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) window.location.reload();
    });
    // "Use my device location" -> browser geolocation -> the device form above.
    // The server rounds to ~7 miles before storing; we never keep the exact fix.
    var btn = card.querySelector('.js-locate');
    if (btn) btn.addEventListener('click', function () {
      if (!navigator.geolocation) { toast('Location is not available in this browser'); return; }
      btn.disabled = true; btn.textContent = 'Locating…';
      navigator.geolocation.getCurrentPosition(function (pos) {
        document.getElementById('loc-lat').value = pos.coords.latitude.toFixed(4);
        document.getElementById('loc-lng').value = pos.coords.longitude.toFixed(4);
        var f = document.getElementById('loc-device-form');
        if (f.requestSubmit) f.requestSubmit(); else f.submit();   // requestSubmit fires the AJAX path
      }, function () {
        btn.disabled = false; btn.textContent = 'Use my device location';
        toast('Could not get a location. You can type your city instead');
      }, { enableHighAccuracy: false, timeout: 8000, maximumAge: 600000 });
    });
  })();
  // quiet one-time capture: members with no location yet contribute only their
  // timezone (no permission prompt, no coordinates); maps to a regional centroid
  (function () {
    if (!document.getElementById('tzcap')) return;
    var tz = '';
    try { tz = Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (e) {}
    if (tz) postJson('/settings/location', { action: 'tz', tz: tz }).catch(function () {});
  })();

  /* ---- theme toggle (light / dark): avatar menu + footer ---------------- */
  // fromServer: true when APPLYING the account's stored choice (menu sync above), so nothing is posted back.
  function setTheme(next, fromServer) {
    if (next !== 'light' && next !== 'dark') return;
    document.documentElement.setAttribute('data-theme', next);
    document.cookie = 'rova_theme=' + next + ';path=/;max-age=31536000;samesite=Lax';
    if (window.__rovaSyncThemeColor) window.__rovaSyncThemeColor();   // Safari's tab-bar tint (top of file)
    // a signed-in member's pick is saved to the account (db/0267) so the app follows it; the members-only menu
    // carries [data-theme-pref], so its absence = guest = cookie only
    var pe = fromServer ? null : document.querySelector('.am-theme[data-theme-pref]');
    if (pe) { pe.setAttribute('data-theme-pref', next); postJson('/settings/theme', { theme: next }, 8000).catch(function () {}); }
  }
  function flipTheme() {
    var root = document.documentElement;
    var current = root.getAttribute('data-theme');
    if (!current) {
      // No explicit choice yet, flip away from the OS preference.
      var prefersLight = window.matchMedia('(prefers-color-scheme: light)').matches;
      current = prefersLight ? 'light' : 'dark';
    }
    setTheme(current === 'light' ? 'dark' : 'light');
  }
  ['theme-toggle', 'theme-toggle-foot'].forEach(function (id) {
    var t = document.getElementById(id);
    if (t) t.addEventListener('click', flipTheme);
  });
  // footer "back to top": smooth-scroll the reader up (mirrors the theme switch on the right)
  (function () {
    var st = document.getElementById('scrolltop-foot');
    if (st) st.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  })();

  /* ---- landing hero deck (slow auto-rotate + drag the front card) ------- */
  (function () {
    var deck = document.getElementById('hero-deck');
    if (!deck) return;
    var cards = Array.prototype.slice.call(deck.querySelectorAll('.deck-card'));
    if (!cards.length) return;
    var dotsWrap = document.getElementById('hero-dots');
    var VISIBLE = 5;                       // front + 4 peeking behind
    var order = cards.slice();             // front-first
    var timer = null, paused = false, moved = false;

    var dots = [];
    if (dotsWrap && cards.length > 1) {
      cards.forEach(function () {
        var d = document.createElement('span'); d.className = 'hdot';
        dotsWrap.appendChild(d); dots.push(d);
      });
    }
    function render() {
      order.forEach(function (card, k) {
        var tier = Math.ceil(k / 2);          // 0 = front, then 1,1, 2,2 …
        var dir = (k % 2 === 1) ? 1 : -1;     // odd cards fan right, even cards fan left
        card.style.zIndex = String(cards.length - k);
        card.style.opacity = k < VISIBLE ? String(Math.max(0, 1 - tier * 0.22)) : '0';
        // fan the deck out to the SIDES: spread + tilt, symmetric left/right
        card.style.transform = 'translate(calc(-50% + ' + (dir * tier * 32) + 'px), -50%) rotate(' + (dir * tier * 6) + 'deg) scale(' + (1 - tier * 0.08) + ')';
        card.style.pointerEvents = k === 0 ? 'auto' : 'none';
      });
      if (dots.length) {
        var fi = +order[0].getAttribute('data-i');
        dots.forEach(function (d, i) { d.classList.toggle('on', i === fi); });
      }
    }
    function advance() { order.push(order.shift()); render(); }
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function start() { stop(); if (cards.length > 1 && !reduceMotion) timer = setInterval(function () { if (!paused) advance(); }, 4200); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    render(); start();
    deck.addEventListener('mouseenter', function () { paused = true; });
    deck.addEventListener('mouseleave', function () { paused = false; });
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });

    // drag the front card left/right to advance; a vertical drag lets the page scroll
    var sx = 0, sy = 0, drag = false, decided = false, horiz = false, front = null, resumeT = null;
    function down(x, y) { if (cards.length < 2) return; clearTimeout(resumeT); front = order[0]; drag = true; decided = false; horiz = false; moved = false; sx = x; sy = y; paused = true; }
    function mv(x, y, e) {
      if (!drag || !front) return;
      var dx = x - sx, dy = y - sy;
      if (!decided) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        horiz = Math.abs(dx) > Math.abs(dy); decided = true;
        if (!horiz) { drag = false; return; }
      }
      if (e && e.cancelable) e.preventDefault();
      moved = true;
      front.style.transition = 'none';
      front.style.transform = 'translate(calc(-50% + ' + dx + 'px), -50%) rotate(' + (dx * 0.03) + 'deg)';
    }
    function up(x) {
      if (!drag || !front) { paused = false; return; }
      drag = false; var dx = x - sx; front.style.transition = '';
      if (horiz && Math.abs(dx) > 55) advance(); else render();
      front = null;
      // Don't snap back to auto-rotate the instant a swipe ends, give the user
      // a long beat to keep browsing. Each new swipe resets this (clearTimeout in
      // down), so the roll only resumes ~6s after they're actually done.
      clearTimeout(resumeT);
      resumeT = setTimeout(function () { paused = false; }, 6000);
    }
    deck.addEventListener('mousedown', function (e) { down(e.clientX, e.clientY); });
    window.addEventListener('mousemove', function (e) { mv(e.clientX, e.clientY, e); });
    window.addEventListener('mouseup', function (e) { up(e.clientX); });
    deck.addEventListener('touchstart', function (e) { var t = e.touches[0]; down(t.clientX, t.clientY); }, { passive: true });
    deck.addEventListener('touchmove', function (e) { var t = e.touches[0]; mv(t.clientX, t.clientY, e); }, { passive: false });
    deck.addEventListener('touchend', function (e) { var t = e.changedTouches[0]; up(t.clientX); }, { passive: true });
    deck.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true); // a drag shouldn't open the profile
  })();

  /* ---- shared scroll lock: modals must never scroll the page behind ----- */
  /* overflow:hidden alone does not stop iOS Safari, so the body is pinned
     with position:fixed at the current scroll and restored on release.
     Refcounted, so stacked overlays (gallery over feed, crop over settings)
     never fight over the lock.

     ═══ THE "WEBKIT DRIFT" FILED AGAINST THIS PAIR ON 2026-09-18 WAS NOT REAL. DO NOT RE-CHASE IT.
     The report: "open #change-email-modal on /feed with the composer open, close it, and the page
     ends up 200-500px down; lockY was captured as 0 and never restored." Both halves of that are
     measurement error, and the numbers reproduce EXACTLY under the correct reading:

       1. THE RIG MOVED THE PAGE AFTER ITS OWN "BEFORE" READING. Playwright's page.tap() runs an
          ACTIONABILITY SCROLL first -- the verify banner's Change-email button sits ~925px down
          with the composer open, so the tap scrolled the document to 520 and only then dispatched.
          lockScroll therefore captured 520, which is CORRECT, and pinned body{top:-520px}. The
          "composer rect 135 -> -464 while locked" in the report is that same correct pin:
          135 - 520 + 79, the 79 being the sticky .topbar leaving the flow (rova.css
          `body.scroll-locked .topbar{position:fixed}`, the deliberate 2026-09-12 fix). unlockScroll
          then restored 520 SYNCHRONOUSLY. Driving the same flow with a raw touch at the button's
          own coordinates -- no actionability scroll -- gives lockY == restored Y == 0 drift.
          (Rig note while you are here: Playwright WebKit's touchscreen.tap() does NOT synthesize a
          click on a feed <img>; measured 0 click events. Chromium's does.)
       2. THE REST WAS THE COMPOSER CLOSING ITSELF. An empty composer scrolled past
          COMPOSE_AWAY_PX self-collapses, and `body.scroll-locked` HOLDS that off while a modal is
          up -- so it fires just after the unlock, shortens the document by its own height and
          applies its place-keeping scrollTop correction. Measured 520 -> 219, i.e. exactly the
          310px box: the reader does not move (anchor-post visual delta 0). That is the 09-18
          auto-close working, not a lock failure.

     MEASURED 0 DRIFT (scrollY AND anchor-post rect) ACROSS: /feed composer open/closed/held-open,
     a profile, and the profile compose modal, each locked at 0 / 400 / the bottom of the document;
     the full-screen pfeed viewer opened from scrollY 0/2276/2715/3667; the media ring present;
     5 rapid lock/unlock cycles; a scroll attempted under the lock; a stray unlock before any lock;
     nested lock x2 / unlock x2 -- on BOTH WebKit 26.5 and Chromium. The ONE case that does move is
     unlocking after the document has been SHORTENED past lockY while locked (a heap prune under the
     viewer): scrollTo clamps to the new max. That is content that no longer exists, not a defect.
     scroll-behavior is `auto` on html AND body here, so the restore is never an animated scroll. */
  var lockN = 0, lockY = 0;
  function lockScroll() {
    if (++lockN > 1) return;
    lockY = window.scrollY || document.documentElement.scrollTop || 0;
    // Compensate the scrollbar width: `overflow:hidden` below removes the vertical scrollbar, which would
    // otherwise widen the page by ~15px and JERK the header + sidebar sideways as the viewer opens (owner's
    // "sidebar jerk"). Reserve that width as padding so nothing shifts.
    var cwBefore = document.documentElement.clientWidth;
    document.documentElement.classList.add('scroll-locked');
    document.body.classList.add('scroll-locked');
    document.body.style.top = (-lockY) + 'px';
    // Compensate ONLY the width actually gained by hiding the scrollbar. With
    // scrollbar-gutter:stable the gutter stays reserved, so this delta is 0 and we
    // don't double-pad; on browsers without gutter support it's the scrollbar width.
    var delta = document.documentElement.clientWidth - cwBefore;
    if (delta > 0) { document.body.style.paddingRight = delta + 'px'; }
  }
  function unlockScroll() {
    if (lockN === 0 || --lockN > 0) return;
    document.documentElement.classList.remove('scroll-locked');
    document.body.classList.remove('scroll-locked');
    document.body.style.top = '';
    document.body.style.paddingRight = '';
    window.scrollTo(0, lockY);
  }
  // shared with the immersive-feed viewer (a separate IIFE) so it can lock the page behind it
  window.__rovaLockScroll = lockScroll;
  window.__rovaUnlockScroll = unlockScroll;

  /* ---- shared gesture ownership for a scrollable overlay panel -----------------------------
     WHY THIS IS JS AND NOT `overscroll-behavior:contain`: that property DOES NOT EXIST IN WEBKIT.
     Measured on the reporting engine, not guessed -- CSS.supports('overscroll-behavior','contain')
     returns FALSE and getComputedStyle(el).overscrollBehaviorY is `undefined`, so every
     overscroll-behavior declaration in rova.css is dropped at PARSE TIME on Safari/iOS and has
     never done anything there. It works in Chromium, which is exactly why a Chromium test
     false-passes this class of bug. On WebKit a panel must own its gestures in JS or the scroll
     chains straight into the page behind it.

     Three things are needed, and all three matter:
       1. touchstart LATCH NUDGE. iOS picks the scroller for a touch gesture ONCE, when the gesture
          BEGINS. If the inner list is parked exactly on an edge at that moment, iOS assigns the
          whole gesture to the DOCUMENT and no later preventDefault can take it back -- those
          touchmoves arrive with cancelable:false, so `if (e.cancelable) e.preventDefault()`
          silently no-ops and the page scrolls under the finger. Nudging scrollTop 1px off the edge
          means the inner list always wins the latch. This is the timing-independent part.
       2. touchmove / wheel EDGE BLOCK for the gestures the list genuinely cannot consume: nothing
          scrollable under the finger (a head or compose row), a region that does not actually
          overflow, or a push past the end it is already sitting at.
       3. stopPropagation ALWAYS, so the page's own document-level gesture handlers never see a
          gesture that belongs to the panel.
     Precedent: the pfeed comment panel's guard (openFor's inPfeed branch), which had this exact
     problem and which CSS alone could not fix either -- generalised here so both callers share one
     implementation. `sel` lists the panel's scrollable regions.
     Returns the live gesture state, so a caller can run its own swipe-to-dismiss off the same
     touchstart without binding a second listener. */
  function guardPanelScroll(panel, sel, opts) {
    opts = opts || {};
    var st = { y: 0, x: 0, t: 0, atTop: true };
    // Nearest ancestor matching `sel` that can ACTUALLY scroll. A matching-but-not-overflowing
    // box must not shadow a scrollable one further up: #dm-panel's .hdrop-body.is-thread is
    // display:flex/overflow:hidden and never scrolls, the .hdrop-thread inside it does.
    function scrollerFor(node) {
      var n = node && node.closest ? node.closest(sel) : null;
      while (n) {
        if (n.scrollHeight > n.clientHeight + 1) return n;
        n = n.parentElement && n.parentElement.closest ? n.parentElement.closest(sel) : null;
      }
      return null;
    }
    panel.addEventListener('touchstart', function (e) {
      var t = e.touches[0]; if (!t) return;
      st.y = t.clientY; st.x = t.clientX; st.t = e.timeStamp || 0; st.ax = 0;
      var sc = scrollerFor(e.target);
      st.atTop = !sc || sc.scrollTop <= 0;      // read BEFORE the nudge (swipe-to-dismiss needs it)
      if (sc) {                                 // (1) never begin a gesture parked on an edge
        var max = sc.scrollHeight - sc.clientHeight;
        if (sc.scrollTop <= 0) { sc.scrollTop = 1; }
        else if (sc.scrollTop >= max) { sc.scrollTop = max - 1; }
      }
      /* (3) with ONE exemption (2026-08-18): a touch that begins on a LIKE control belongs to the
         reaction system, whose arm listener lives at the DOCUMENT (the .clike/.react-btn
         touchstart delegate that opens the emoji row on a hold) -- swallowing it here silently
         killed hold-to-react on every heart inside a guarded panel. The page-level handlers that
         must NOT see panel gestures (pull-to-refresh above all) are covered for these too: the
         PTR's own origin check refuses any touch born inside a comment surface. */
      if (!(e.target.closest && e.target.closest('.clike, .react-btn'))) e.stopPropagation();
    }, { passive: true });
    /* "Sitting on an edge" has to be judged with a 1px tolerance, because the nudge above parks the
       scroller exactly 1px off it. Without the tolerance the nudge would DEFEAT this block: a pull
       down from the top reads scrollTop===1, not 0, so nothing would be prevented and the only thing
       left holding the gesture in would be iOS's latch. Costs one pixel of travel at each end
       (invisible) and keeps belt and braces independent. */
    function atTop(sc) { return sc.scrollTop <= 1; }
    function atBot(sc) { return sc.scrollTop >= (sc.scrollHeight - sc.clientHeight) - 1; }
    /* SIDEWAYS ROWS INSIDE THE PANEL (2026-10-12, Rob: "Trying to use my Magic Mouse swipe left/right to
       move through recent searches should work"). Everything above is about the panel's VERTICAL list, and
       it used to judge every gesture by that axis alone: over the search sheet's Recent row (.shm-row,
       overflow-x:auto) a sideways swipe was preventDefault'd whenever the sheet itself could not scroll
       (`!sc`: ALL input eaten) and whenever the sheet sat on an edge and the swipe carried any vertical
       noise the "wrong" way (a Magic Mouse sideways swipe always does). A preventDefault'd wheel cancels
       BOTH axes, so the row never moved. Now a gesture whose intent is sideways, over a box that can
       really scroll sideways, is the row's: native, untouched, smooth. Intent is decided ONCE per gesture
       and held (a tail event that happens to read vertical must not flip it mid-swipe), released on 160 ms
       of quiet. The row's overscroll-behavior-x:contain keeps its end from chaining; on an engine without
       that, the end-of-row push is preventDefault'd so it cannot turn into a history swipe. */
    function xScrollerFor(node) {
      for (var n = node; n && n !== panel && n.nodeType === 1; n = n.parentElement) {
        if (n.scrollWidth > n.clientWidth + 1) {
          var ox = getComputedStyle(n).overflowX;
          if (ox === 'auto' || ox === 'scroll') return n;
        }
      }
      return null;
    }
    function canX(xs, d) { return d > 0 ? xs.scrollLeft < xs.scrollWidth - xs.clientWidth - 1 : d < 0 ? xs.scrollLeft > 1 : false; }
    function wpx(d, e) { return e.deltaMode === 1 ? d * 16 : e.deltaMode === 2 ? d * 400 : d; }
    var wg = null;   // the live WHEEL gesture: { ax: 'x'|'y'|'m', xs, t }
    panel.addEventListener('touchmove', function (e) {
      e.stopPropagation();
      var t = e.touches[0]; if (!t) return;
      /* the same rule for a finger: decided on the first move that has a direction, held to touchend */
      if (st.ax == null) st.ax = 0;
      if (st.ax === 0) {
        var adx = Math.abs(t.clientX - st.x), ady = Math.abs(t.clientY - st.y);
        if (adx + ady >= 3) st.ax = (adx > ady && xScrollerFor(e.target)) ? 'x' : 'y';
        else if (xScrollerFor(e.target)) return;   // undecided over a row: never cancel the pan before it has a direction
      }
      if (st.ax === 'x') return;                   // the row's own sideways pan: native
      var sc = scrollerFor(e.target);
      if (!sc) { if (e.cancelable) e.preventDefault(); return; }   // nothing to scroll here -> eat it
      var dy = t.clientY - st.y;                                   // at an edge: don't let it chain
      if ((dy > 0 && atTop(sc)) || (dy < 0 && atBot(sc))) {
        if (e.cancelable) e.preventDefault();
      }
    }, { passive: false });
    /* opts.wheel === false keeps the DELIBERATE desktop behaviour some panels chose (the timeline
       comment panel: "hitting the list's end hands the scroll back to the timeline instead of
       trapping the wheel inside the panel", rova.css) while still owning TOUCH, which is where
       the pull-to-refresh hazard lives. Default true: overlays own both. */
    if (opts.wheel !== false) {
      panel.addEventListener('wheel', function (e) {   // desktop / trackpad: same rule
        e.stopPropagation();
        var sc = scrollerFor(e.target);
        var now = e.timeStamp || Date.now();
        if (wg && now - wg.t > 160) wg = null;          // quiet = the gesture is over
        if (!wg) {
          var xs = e.ctrlKey ? null : xScrollerFor(e.target);
          var dx0 = wpx(e.deltaX, e), dy0 = wpx(e.deltaY, e);
          /* 'm' = a PLAIN mouse wheel over a row while the sheet has nothing to scroll: the wheel would
             otherwise do nothing, so it walks the row instead. "Plain wheel" = no sideways component and a
             notch-sized first step (line/page mode, >= 40px, or a whole wheelDelta tick); a trackpad's
             vertical swipe opens with small pixel steps and is left alone. */
          var plain = !dx0 && !e.shiftKey && (e.deltaMode !== 0 || Math.abs(dy0) >= 40
                      || (Math.abs(e.wheelDeltaY || 0) >= 120 && e.wheelDeltaY % 120 === 0));
          wg = { ax: !xs ? 'y' : Math.abs(dx0) > Math.abs(dy0) ? 'x' : (!sc && plain) ? 'm' : 'y', xs: xs, t: now };
        }
        wg.t = now;
        if (wg.ax === 'x') {
          if (e.cancelable && !canX(wg.xs, wpx(e.deltaX, e)) && Math.abs(e.deltaX) > Math.abs(e.deltaY)) e.preventDefault();
          return;
        }
        if (wg.ax === 'm') {
          var d = wpx(e.deltaY, e);
          if (e.cancelable) e.preventDefault();
          if (!canX(wg.xs, d)) return;
          var row = wg.xs;
          /* scroll-snap would pull a small programmatic step straight back to the chip it left, so snap
             is held off while the wheel drives the row and handed back when it goes quiet (proximity
             then settles on the nearest chip). A notch glides; trackpad-sized steps follow 1:1. */
          if (!row.__wsnap) { row.__wsnap = 1; row.style.scrollSnapType = 'none'; }
          clearTimeout(row.__wsnapT);
          row.__wsnapT = setTimeout(function () { row.__wsnap = 0; row.style.scrollSnapType = ''; }, 420);   // after a notch's glide
          var notch = e.deltaMode !== 0 || Math.abs(d) >= 50;
          try { row.scrollBy({ left: d, behavior: notch ? 'smooth' : 'auto' }); } catch (er) { row.scrollLeft += d; }
          return;
        }
        if (!sc || (e.deltaY < 0 && atTop(sc)) || (e.deltaY > 0 && atBot(sc))) {
          if (e.cancelable) e.preventDefault();
        }
      }, { passive: false });
    }
    return st;
  }

  /* THE PERMALINK THREAD (#comment-list.cl-scroll) is a server-rendered scroll region with no
     panel constructor to hook, so it is guarded here, idempotently: at boot when the page ships
     with >5 comments, and again from the comment composer the moment it promotes the list to
     .cl-scroll. Exposed on window because app.js is not one IIFE and the composer lives in
     another scope. */
  var _clThreadGuarded = false;
  window.__rovaGuardThread = function () {
    if (_clThreadGuarded) return;
    var cl = document.getElementById('comment-list');
    if (!cl || !cl.classList.contains('cl-scroll')) return;
    _clThreadGuarded = true;
    guardPanelScroll(cl, '#comment-list');
  };
  window.__rovaGuardThread();

  /* ---- AUTH FORM ERRORS: one message, two places ------------------------
     2026-08-12, reported: "the username is already taken pops up at the top of the window, but if
     a person zoomed in at the bottom of the window they don't see the message and they don't know
     what's going on -- so Start Free doesn't work and it may confuse the user."

     It was never only the username. EVERY rejection these forms can produce -- taken handle,
     registered email, short or missing password, malformed email, bad promo code, unticked
     confirm box, per-IP rate limit, blocked network, wrong credentials, locked account,
     suspended account, mismatched reset, and the two client-side ones (a constraint the browser
     refuses to submit on, and a dead network) -- rendered as ONE banner above the first field.
     At browser zoom, on a short viewport, or with a phone keyboard up, the banner and the button
     cannot both be on screen, so pressing the button appears to do nothing.

     THE RULE, two places and deliberately never three:
       1. the offending FIELD gets the full sentence, wired aria-invalid + aria-describedby;
       2. the SUMMARY directly above the submit button gets the same sentence plus a Fix it
          control that jumps to the field.
     The old top-of-form banner is gone -- it was the third copy and the one that could not be
     seen. An error belonging to no field (rate limit, blocked network, wrong credentials,
     offline) renders in the summary only, with no Fix it.

     ANNOUNCEMENT IS THE SUMMARY'S JOB ALONE. It carries role="alert"; field boxes deliberately
     do not, or every rejection would be spoken twice. Two consequences are handled below:
     unhide BEFORE writing the text (a role=alert that is `hidden` is not in the accessibility
     tree, so text written first is never announced), and on a full-page POST re-render -- where
     the alert is present at first paint and therefore silent -- move focus instead. */
  var FormErr = (function () {
    // Locale-stripped so /fr/signup and /es/signup are the same form as /signup. The old code
    // compared the action to the literal '/signup', which silently excluded both localized
    // funnels from every client-side behaviour attached to it.
    var AUTH = { '/signup': 1, '/login': 1, '/forgot': 1, '/reset': 1 };
    function actionPath(f) {
      var a = (f && f.getAttribute) ? (f.getAttribute('action') || '') : '';
      a = a.replace(/[?#].*$/, '');
      return a.replace(/^\/(?:fr|es)(?=\/|$)/, '') || '/';
    }
    function isAuth(f) { return !!f && !!AUTH[actionPath(f)]; }
    function formOf(el) { return (el && (el.form || (el.closest && el.closest('form')))) || null; }
    function summaryOf(f) { return f ? f.querySelector('.form-err') : null; }
    function wrapOf(el) { return (el && el.closest) ? el.closest('.field') : null; }
    /** A field may live inside a collapsed disclosure (the promo code field does, since
     *  2026-08-25). An error painted into a closed <details> is display:none -- the member
     *  sees the button do nothing and no message anywhere, which is precisely the failure
     *  the whole inline+summary error rule above exists to prevent. So before any rejection
     *  is painted at a field, or focus is moved to one, force every <details> above it open.
     *  Loops upward because nesting is allowed; closest() only ever finds the nearest. */
    function undisclose(el) {
      var d = (el && el.closest) ? el.closest('details') : null;
      while (d) {
        // Held promo door (Founder offer, 2026-10-11): never revealed. The server ignores an invalid code
        // while held, so no promo error is ever produced for it to show.
        if (!d.hasAttribute('data-promo-held')) d.open = true;
        d = (d.parentNode && d.parentNode.closest) ? d.parentNode.closest('details') : null;
      }
    }
    function inputOf(f, name) {
      if (!f || !name) return null;
      try { return f.querySelector('[name="' + String(name).replace(/"/g, '') + '"]'); }
      catch (e) { return null; }
    }
    // The markup ships every box; build one anyway if a template ever forgets, so a message can
    // never silently have nowhere to go. role=alert ONLY when the form has no summary to do the
    // announcing (e.g. /settings/account), otherwise the two would speak over each other.
    function boxOf(el, make) {
      var w = wrapOf(el); if (!w) return null;
      var b = w.querySelector('.field-err');
      if (!b && make) {
        if (!el.id) el.id = 'fe' + Math.random().toString(36).slice(2, 8);
        b = document.createElement('div');
        b.className = 'flash err field-err';
        b.id = el.id + '-err';
        if (!summaryOf(formOf(el))) b.setAttribute('role', 'alert');
        b.hidden = true;
        el.parentNode.insertBefore(b, el.nextSibling);
        var d = el.getAttribute('aria-describedby') || '';
        if (d.split(/\s+/).indexOf(b.id) < 0) el.setAttribute('aria-describedby', (b.id + ' ' + d).replace(/\s+$/, ''));
      }
      return b;
    }
    function clear(f) {
      if (!f) return;
      f.querySelectorAll('.field-err').forEach(function (b) { b.hidden = true; b.textContent = ''; });
      f.querySelectorAll('[aria-invalid]').forEach(function (el) { el.removeAttribute('aria-invalid'); });
      var s = summaryOf(f);
      if (s) {
        s.hidden = true;
        var t = s.querySelector('.form-err-t'); if (t) t.textContent = '';
        var j = s.querySelector('.form-err-jump'); if (j) { j.hidden = true; j.setAttribute('data-err-jump', ''); }
      }
    }
    function clearField(el) {
      var b = boxOf(el, false);
      if (b) { b.hidden = true; b.textContent = ''; }
      if (el) el.removeAttribute('aria-invalid');
      // The summary is about this field, so it goes too -- leaving it would leave a stale
      // sentence sitting on the button after the member has already fixed the thing.
      var f = formOf(el), s = summaryOf(f), j = s && s.querySelector('.form-err-jump');
      if (s && j && el && j.getAttribute('data-err-jump') === el.name) {
        s.hidden = true;
        var t = s.querySelector('.form-err-t'); if (t) t.textContent = '';
        j.hidden = true; j.setAttribute('data-err-jump', '');
      }
    }
    /** Paint one rejection. `field` is an input NAME, or falsy for a form-level error. */
    function show(f, msg, field) {
      if (!f) return null;
      clear(f);
      msg = String(msg || 'Something went wrong. Please try again.');
      var el = field ? inputOf(f, field) : null;
      if (el) {
        undisclose(el);                       // never paint a rejection into a closed <details>
        var b = boxOf(el, true);
        if (b) { b.hidden = false; b.textContent = msg; }
        el.setAttribute('aria-invalid', 'true');
      }
      var s = summaryOf(f);
      if (s) {
        // UNHIDE FIRST. A hidden role="alert" is outside the accessibility tree, so text written
        // into it before it is shown is never announced. Both statements are in one task, so
        // there is no paint between them and no flash of an empty plate.
        s.hidden = false;
        var t = s.querySelector('.form-err-t'); if (t) t.textContent = msg;
        var j = s.querySelector('.form-err-jump');
        if (j) {
          if (el) { j.setAttribute('data-err-jump', el.name || ''); j.hidden = false; }
          else { j.hidden = true; j.setAttribute('data-err-jump', ''); }
        }
      }
      return el;
    }
    function reveal(node) {
      if (!node) return;
      var rm = false;
      try { rm = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); } catch (e) {}
      try { node.scrollIntoView({ block: 'center', behavior: rm ? 'auto' : 'smooth' }); }
      catch (e) { try { node.scrollIntoView(); } catch (e2) {} }
    }
    /** Take the member to the problem instead of leaving them guessing. Focus first with
     *  preventScroll so the browser's own jump-to-top does not fight the centred scroll. */
    function focusFirst(f, field) {
      if (!f) return;
      var el = field ? inputOf(f, field) : null;
      if (!el) el = f.querySelector('[aria-invalid="true"]');
      var target = el || summaryOf(f);
      if (!target) return;
      // "Fix it" (and the on-load focus move after a server re-render) must be able to reach a
      // field inside a disclosure. focus() on a display:none input is a silent no-op, so this
      // has to happen BEFORE the focus, not after.
      undisclose(target);
      try { target.focus({ preventScroll: true }); } catch (e) { try { target.focus(); } catch (e2) {} }
      reveal(wrapOf(el) || target);
    }
    // "Fix it" -> the field the message is about.
    document.addEventListener('click', function (e) {
      var j = e.target.closest ? e.target.closest('.form-err-jump') : null;
      if (!j) return;
      e.preventDefault();
      focusFirst(formOf(j), j.getAttribute('data-err-jump') || '');
    });
    return {
      actionPath: actionPath, isAuth: isAuth, formOf: formOf, summaryOf: summaryOf,
      wrapOf: wrapOf, inputOf: inputOf, boxOf: boxOf,
      clear: clear, clearField: clearField, show: show, focusFirst: focusFirst, reveal: reveal
    };
  })();

  /* A full-page POST re-render lands with the summary already painted. role="alert" announces
     CHANGES, not content that was in the document at first paint, so nothing is spoken -- and the
     member who is zoomed in is looking at wherever the browser restored them to. Move focus onto
     the offending field (a screen reader then reads its label, "invalid", and the described-by
     message) or, for a form-level error, onto the summary itself. This is also what carries the
     zoomed-in member to the problem rather than leaving them to hunt for it. */
  (function () {
    var s = document.querySelector('.form-err:not([hidden])');
    if (!s) return;
    var f = FormErr.formOf(s);
    if (!f || f.closest('#auth-modal')) return;   // the modal's own summaries ship hidden
    var j = s.querySelector('.form-err-jump');
    var field = (j && !j.hidden) ? (j.getAttribute('data-err-jump') || '') : '';
    // after autofocus and after the first paint, so the centred scroll is not undone by it
    requestAnimationFrame(function () { FormErr.focusFirst(f, field); });
  })();

  /* ---- glassy login / signup modal (guests) ---------------------------- */
  (function () {
    var modal = document.getElementById('auth-modal');
    if (!modal) return;
    function paneInput() { var p = modal.querySelector('.auth-pane:not([hidden])'); return p && p.querySelector('input'); }
    function showPane(kind) {
      modal.querySelectorAll('.auth-pane').forEach(function (p) { p.hidden = (p.getAttribute('data-pane') !== kind); });
      modal.querySelectorAll('.js-auth-form').forEach(function (f) { FormErr.clear(f); });
    }
    /* OPEN GRACE (2026-10-10, Rob on iPhone: "I had to tap sign up a couple times to get this window"). On a
       420-430pt-wide phone the sheet's close X (.auth-x) lands EXACTLY under the header's Sign up button
       (measured in WebKit at 420x786, Rob's own RUM viewport: Sign up centre 371,88 = the X from the first
       frame of the open). So a second tap on Sign up -- an impatient double tap, or a tap queued while app.js
       was still busy -- hit the X and closed the sheet the instant it opened, and it took a third tap. A
       [data-auth-close] click inside OPEN_GRACE ms of the open is the opener's own finger, not a decision to
       close: ignore it. Escape and a later tap still close. */
    var OPEN_GRACE = 500, openedAt = 0;
    function open(kind) {
      openedAt = Date.now();
      showPane(kind || 'login');
      modal.hidden = false;
      lockScroll();
      requestAnimationFrame(function () { modal.classList.add('show'); });
      var f = paneInput(); if (f) setTimeout(function () { try { f.focus(); } catch (e) {} }, 80);
    }
    function close() {
      modal.classList.remove('show');
      unlockScroll();
      setTimeout(function () { modal.hidden = true; }, 200);
    }
    /* GUESTS ON LIVE (2026-09-30): a Log in / Sign up link carrying data-live-next="/live/<id>" (the live gate
       page, the guest live-tap sheet) hands the stream to the login as a hidden `live_next`, so the login lands
       back on that stream (handle_login_submit accepts ONLY /live/<digits>). Any other opener clears it, so a
       stale stream can never ride a later, unrelated login. */
    function liveNext(v) {
      var ok = /^\/live\/\d{1,12}$/.test(v || '');
      modal.querySelectorAll('.js-auth-form').forEach(function (f) {
        var h = f.querySelector('input[name="live_next"]');
        if (!ok) { if (h) h.parentNode.removeChild(h); return; }
        if (!h) { h = document.createElement('input'); h.type = 'hidden'; h.name = 'live_next'; f.appendChild(h); }
        h.value = v;
      });
    }
    /* THE CONTEXT LINE (2026-10-12, the guest's Go Live circle in the media ring: "Sign up to go live"). An opener carrying
       data-auth-ctx puts that sentence above the sign-up heading (.auth-ctx, textContent only); every other opener clears
       it, so it never rides a later, unrelated open. The heading and the Founders fork under it are the server's, untouched. */
    function authCtx(v) {
      var pane = modal.querySelector('.auth-pane[data-pane="signup"]');
      var el = pane && pane.querySelector('.auth-ctx');
      if (!v) { if (el) el.parentNode.removeChild(el); return; }
      if (!pane) return;
      if (!el) {
        el = document.createElement('p'); el.className = 'auth-ctx';
        var h = pane.querySelector('.auth-h');
        pane.insertBefore(el, h || pane.firstChild);
      }
      el.textContent = v;
    }
    // any Log in / Start free link opens the modal (the pages still work with JS off). data-auth-open="signup|login" makes
    // any other guest link a door too (its href is the no-JS fallback, e.g. the ring's Go Live: /signup?next=/live/go).
    document.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a[href="/login"], a[href="/signup"], a[data-auth-open]') : null;
      if (!a || a.closest('#auth-modal')) return;   // links inside the modal are handled below
      if (e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) { if (a.hasAttribute('data-auth-open')) return; }
      e.preventDefault();
      liveNext(a.getAttribute('data-live-next') || '');
      authCtx(a.getAttribute('data-auth-ctx') || '');
      var kind = a.getAttribute('data-auth-open') || (a.getAttribute('href') === '/signup' ? 'signup' : 'login');
      open(kind === 'signup' ? 'signup' : 'login');
    });
    modal.addEventListener('click', function (e) {
      var sw = e.target.closest('[data-auth-switch]');
      if (sw) { e.preventDefault(); showPane(sw.getAttribute('data-auth-switch')); var f = paneInput(); if (f) f.focus(); return; }
      if (e.target.closest('[data-auth-close]')) { e.preventDefault(); if (Date.now() - openedAt < OPEN_GRACE) return; close(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
    /* NO CONFIRM-AND-PROCEED ANY MORE. This modal used to grow a "Yes, use @handle as my public
       handle" tick-box on demand, because the server answered an email-shaped handle with 422
       confirm:'username' and expected the box back. That flow is gone on BOTH halves: since
       2026-08-18 handle_signup_submit() (index.php) REJECTS an email-shaped handle outright and
       answers ['error','field'] with no confirm member (see the comment above $emailHandleMsg,
       and "Same rejection, no confirm-and-proceed" further down that function), and neither
       views/signup.php nor View::authModal() renders a confirm checkbox. The builder and its
       res.confirm branch were removed here on 2026-08-22 -- they had been unreachable, and the
       builder carried a hardcoded English sentence that no locale could ever translate. If a
       confirm step is ever wanted again it has to be reintroduced server-side FIRST. */

    // AJAX submit -> the same two error surfaces the server-rendered pages use, redirect on success
    modal.addEventListener('submit', function (e) {
      var form = e.target.closest('.js-auth-form'); if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('button[type=submit]');
      var label = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Please wait…'; }
      FormErr.clear(form);
      // On an edge-cached page this form shipped without a token (there was no session to mint
      // one from). Hydrate it first, otherwise the POST comes back 419 and signup dies on exactly
      // the pages a promo blast lands on.
      ensureFormCsrf(form).then(function () {
        return fetch(form.getAttribute('action'), {
          method: 'POST', body: new FormData(form),
          headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
          credentials: 'same-origin'
        });
      }).then(function (r) { return r.json().catch(function () { return {}; }); })
        .then(function (res) {
          if (res && res.ok && res.redirect) { window.location = res.redirect; return; }
          if (btn) { btn.disabled = false; btn.textContent = label; }
          res = res || {};
          FormErr.show(form, res.error || 'Something went wrong. Please try again.', res.field);
          FormErr.focusFirst(form, res.field);
        })
        .catch(function () {
          if (btn) { btn.disabled = false; btn.textContent = label; }
          // No field: the network is what failed, nothing they typed. Summary only.
          FormErr.show(form, 'Network error. Please try again.', null);
          FormErr.focusFirst(form, null);
        });
    });
  })();

  /* ---- signup username: repair it as they type -------------------------
     A space (also a dot, dash or a pasted emoji) was the single biggest reason
     signup bounced people back to the form. They never learned *why*: the field
     kept what they typed, the red banner said "letters, numbers, underscore",
     and they retyped the same thing. Now the field fixes itself and the hint
     narrates the fix, then goes green with the handle they are about to get. */
  (function () {
    var DEFAULT = '3–30 chars: letters, numbers, underscore. This is your @handle.';

    // Separators become an underscore, everything else non-handle is dropped, and
    // runs of underscores collapse to ONE. That last rule has to be unconditional:
    // typing "PEAK _WINBUSH357" arrives a character at a time, so by the time the
    // typed "_" lands, the space is ALREADY an underscore and there is no separator
    // left to notice. The cost is that a handle cannot hold "__" (rare); the win is
    // that the exact reported value repairs correctly as it is typed.
    function clean(v) {
      var s = String(v);
      var lead = /^\s/.test(s);           // a leading space is a typo, not a bid for "_name"
      s = s.replace(/[\s.+\-]+/g, '_').replace(/[^A-Za-z0-9_]/g, '').replace(/_{2,}/g, '_');
      if (lead) s = s.replace(/^_+/, '');
      return s.slice(0, 30);
    }
    function why(was) {
      if (/\s/.test(was))     return 'Handles cannot contain spaces, so we used an underscore.';
      if (/[.+\-]/.test(was)) return 'That character is not allowed, so we used an underscore.';
      if (/__/.test(was))     return 'One underscore is enough.';
      return 'That character cannot go in a handle, so we removed it.';
    }
    // Locale-stripped. This compared the action to the literal '/signup', so a member on
    // /fr/signup or /es/signup got none of the live repair at all -- the exact two funnels
    // where a mistyped handle is hardest to recover from.
    function isUname(el) {
      if (!el || el.name !== 'username' || el.tagName !== 'INPUT') return false;
      var f = el.form || (el.closest && el.closest('form'));
      return !!f && FormErr.actionPath(f) === '/signup';
    }
    function hintOf(el) {
      var f = el.closest && el.closest('.field');
      return f && f.querySelector('.hint');
    }
    function paint(el, note) {
      var h = hintOf(el); if (!h) return;
      var v = el.value;
      h.classList.remove('good');
      if (note) { h.textContent = note; return; }
      if (!v) { h.textContent = DEFAULT; return; }
      if (v.length < 3) { h.textContent = 'A bit longer, handles are at least 3 characters.'; return; }
      h.textContent = 'Looks good, you will be @' + v;
      h.classList.add('good');
    }
    var noteTimer = null;
    document.addEventListener('input', function (e) {
      var el = e.target;
      if (!isUname(el)) return;
      var was = el.value, now = clean(was);
      if (now !== was) {
        // keep the caret where the typing was: the cleaned length of everything
        // before it is exactly where that character landed in the new value
        var at = el.selectionStart;
        el.value = now;
        if (at !== null && at !== undefined) {
          try { at = clean(was.slice(0, at)).length; el.setSelectionRange(at, at); } catch (err) {}
        }
        paint(el, why(was));
        clearTimeout(noteTimer);
        noteTimer = setTimeout(function () { paint(el); }, 1800);
        return;
      }
      clearTimeout(noteTimer);
      paint(el);
    });
    // autofill / paste-then-submit never fires input in some browsers
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || FormErr.actionPath(f) !== '/signup') return;
      var el = f.querySelector('input[name="username"]');
      if (el) el.value = clean(el.value);
    }, true);
  })();

  /* ---- new-password fields: state the rule, then show a REAL inline error ----
     2026-08-06, reported: someone typed a short password at registration and could
     not tell why the form would not go. Measured with Playwright against the live
     origin, NOT inferred: the browser refuses the POST on minlength=8, so the page
     never navigates and the server's "Password must be at least 8 characters."
     is UNREACHABLE -- nothing at all is rendered. The only feedback was the native
     constraint bubble, which is transient, unstyled, owned by the browser, and not
     drawn at all by Safari on iOS. And the rule itself lived only in a placeholder,
     which disappears the moment they start typing.

     Three parts, and the first is the actual fix:
       1. a persistent .hint states the rule (server-rendered, so it works with JS off);
       2. this narrates progress as they type, exactly the way the username hint above
          already does -- same .hint element, same .good class, no new pattern;
       3. the `invalid` event is cancelled so the bubble is replaced by the site's own
          .flash.err treatment sitting directly under the field, with aria-invalid and
          aria-describedby so a screen reader gets it too.
     Nothing here can lose what they typed: there is no round-trip at all. */
  /* WIDENED 2026-08-12 from new-password-only to EVERY field on these forms. The password box
     was fixed in isolation because that was the reported case; the identical dead end existed on
     a missing username, a malformed email and an unticked confirm box, and on all of them the
     browser blocks the POST, draws a bubble that iOS Safari does not draw at all, and the member
     is left pressing a button that does nothing. Same two surfaces as a server rejection now. */
  (function () {
    var MIN = 8;
    // Auth forms get the summary treatment; /settings/account has no summary and keeps the
    // field-level behaviour it already had (FormErr.boxOf gives that box role=alert precisely
    // because there is no summary there to do the announcing).
    function handled(f) { return !!f && (FormErr.isAuth(f) || FormErr.actionPath(f) === '/settings/account'); }
    function inScope(el) {
      if (!el || !el.name) return false;
      var tag = el.tagName;
      if (tag !== 'INPUT' && tag !== 'SELECT' && tag !== 'TEXTAREA') return false;
      if (el.type === 'hidden' || el.type === 'submit' || el.type === 'button') return false;
      return handled(FormErr.formOf(el));
    }
    // Only the NEW-password boxes carry minlength. A log-in box or a "current password"
    // box never does, so the hint narration can never start nagging about an existing password.
    function isNewPw(el) {
      return !!el && el.tagName === 'INPUT' && el.type === 'password'
          && el.hasAttribute('minlength') && handled(FormErr.formOf(el));
    }
    function hintOf(el) { var w = FormErr.wrapOf(el); return w && w.querySelector('.hint'); }
    function baseHint(h) {
      if (!h) return '';
      if (!h.hasAttribute('data-default')) h.setAttribute('data-default', h.textContent);
      return h.getAttribute('data-default') || '';
    }
    function paint(el) {
      var h = hintOf(el); if (!h) return;
      var base = baseHint(h), n = el.value.length;
      h.classList.remove('good');
      if (n === 0) { h.textContent = base; return; }
      if (n < MIN) {
        var left = MIN - n;
        h.textContent = left === 1 ? '1 more character to go.' : left + ' more characters to go.';
        return;
      }
      h.textContent = 'Long enough, that will work.';
      h.classList.add('good');
    }
    // The visible label, so a message can name the thing the member is looking at rather than
    // saying "this field" about something they cannot see.
    function labelOf(el) {
      var w = FormErr.wrapOf(el), l = w && w.querySelector('label');
      var s = l ? String(l.textContent || '') : '';
      return s.replace(/\(optional\)/ig, '').replace(/\s+/g, ' ').trim();
    }
    function msgFor(el) {
      var v = el.validity, nm = labelOf(el);
      if (v.valueMissing) {
        if (el.type === 'checkbox') return 'Please tick the box to confirm.';
        if (isNewPw(el)) return 'Please choose a password of at least ' + MIN + ' characters.';
        return nm ? 'Please fill in your ' + nm.toLowerCase() + '.' : 'Please fill this in.';
      }
      if (v.typeMismatch && el.type === 'email') {
        return 'That does not look like an email address. Check for a typo.';
      }
      if (v.tooShort) {
        var min = el.minLength > 0 ? el.minLength : MIN;
        if (isNewPw(el)) return 'Too short. Your password needs at least ' + min + ' characters, you have ' + el.value.length + '.';
        return 'Too short. ' + (nm || 'This') + ' needs at least ' + min + ' characters, you have ' + el.value.length + '.';
      }
      if (v.tooLong) return (nm || 'This') + ' is too long.';
      if (v.patternMismatch || v.stepMismatch || v.rangeOverflow || v.rangeUnderflow) {
        return el.validationMessage || 'Please check ' + (nm ? nm.toLowerCase() : 'this field') + '.';
      }
      return el.validationMessage || 'Please check this field.';
    }

    function onEdit(e) {
      var el = e.target;
      if (!inScope(el)) return;
      if (isNewPw(el)) paint(el);
      if (el.checkValidity()) FormErr.clearField(el);
    }
    document.addEventListener('input', onEdit);
    document.addEventListener('change', onEdit);   // password managers/autofill skip `input`

    /* `invalid` does NOT bubble, so capture. preventDefault() suppresses the native bubble only
       -- the submit was already blocked by the failed constraint, so nothing bad can get through.

       ONLY THE FIRST INVALID FIELD IS REPORTED, and that is deliberate: the summary above the
       button holds one sentence, and the server validates in an elseif chain and can only ever
       return one error too. Reporting field #3 in the summary while the browser is about to
       complain about field #1 would send the member to the wrong place. */
    document.addEventListener('invalid', function (e) {
      var el = e.target;
      if (!inScope(el)) return;
      e.preventDefault();
      var f = FormErr.formOf(el);
      if (!f || f.querySelector(':invalid') !== el) return;
      FormErr.show(f, msgFor(el), el.name);
      if (isNewPw(el)) paint(el);
      FormErr.focusFirst(f, el.name);
    }, true);
  })();

  /* ---- report-an-issue form (AJAX submit + capture referrer) ------------ */
  (function () {
    var card = document.getElementById('bug-card');
    if (!card) return;
    var form = card.querySelector('.js-bug-form');
    if (!form) return;
    var pu = document.getElementById('bug-page-url');
    if (pu && !pu.value) pu.value = document.referrer || location.href;   // where they came from
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var errBox = card.querySelector('.bug-err');
      var btn = form.querySelector('button[type=submit]');
      var label = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }
      if (errBox) errBox.hidden = true;
      fetch('/report-issue', {
        method: 'POST', body: new FormData(form),
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }, credentials: 'same-origin'
      }).then(function (r) { return r.json().catch(function () { return {}; }); })
        .then(function (res) {
          if (res && res.ok) {
            var fw = card.querySelector('.bug-form-wrap'); if (fw) fw.hidden = true;
            var sent = card.querySelector('.bug-sent'); if (sent) sent.hidden = false;
            window.scrollTo({ top: 0, behavior: 'smooth' });
            return;
          }
          if (btn) { btn.disabled = false; btn.textContent = label; }
          if (errBox) { errBox.textContent = (res && res.error) || 'Could not send. Please try again.'; errBox.hidden = false; }
        })
        .catch(function () {
          if (btn) { btn.disabled = false; btn.textContent = label; }
          if (errBox) { errBox.textContent = 'Network error. Please try again.'; errBox.hidden = false; }
        });
    });
  })();

  /* ---- change-email modal (unverified members, from the verify banner) ---
     Same glassy shell as the auth modal. A plain POST (not AJAX): the handler
     flashes success/error and redirects back, so there's nothing to wire here
     but open / close. Lets a mistyped-at-signup address get fixed on the spot. */
  (function () {
    var modal = document.getElementById('change-email-modal');
    if (!modal) return;
    function open() {
      modal.hidden = false;
      lockScroll();
      requestAnimationFrame(function () { modal.classList.add('show'); });
      var f = modal.querySelector('input[name="email"]');
      if (f) setTimeout(function () { try { f.focus(); } catch (e) {} }, 80);
    }
    function close() {
      modal.classList.remove('show');
      unlockScroll();
      setTimeout(function () { modal.hidden = true; }, 200);
    }
    document.addEventListener('click', function (e) {
      var op = e.target.closest ? e.target.closest('[data-open-modal="change-email-modal"]') : null;
      if (op) { e.preventDefault(); open(); }
    });
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-modal-close]')) { e.preventDefault(); close(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
  })();

  /* ---- people-to-follow page: realtime search + filters + load more ----- */
  (function () {
    var pagEl = document.getElementById('people-page');
    if (!pagEl) return;
    var results = document.getElementById('people-results');
    var qEl = document.getElementById('people-q');
    var sortEl = document.getElementById('people-sort');
    var photoEl = document.getElementById('people-photo');
    var moreWrap = document.getElementById('people-more');
    var moreBtn = moreWrap && moreWrap.querySelector('button');
    var endWrap = document.getElementById('people-end');
    var PAGE = 24, t = null, seq = 0;

    function qs(offset) {
      var p = 'partial=results&offset=' + offset + '&sort=' + encodeURIComponent(sortEl.value) + '&photo=' + (photoEl.checked ? '1' : '0');
      var q = qEl.value.trim(); if (q) p += '&q=' + encodeURIComponent(q);
      return p;
    }
    function pageUrl() {
      var u = '/people?sort=' + encodeURIComponent(sortEl.value) + '&photo=' + (photoEl.checked ? '1' : '0');
      var q = qEl.value.trim(); if (q) u += '&q=' + encodeURIComponent(q);
      return u;
    }
    function count() { return results.querySelectorAll('.aside-person').length; }
    // show the "keep inviting" card once there are some results but nothing more to load
    function syncEnd() { if (endWrap) endWrap.hidden = !(count() > 0 && moreWrap && moreWrap.hidden); }
    function fetchRows(offset) {
      // rfetch, not fetch: a non-2xx RESOLVES with an empty body, and both callers below read an
      // empty body as a legitimate result -- reload() rendered "No people match." over a 5xx and
      // the pager latched itself hidden. rfetch rejects it into the .catch instead, so only a
      // genuine 200 that contained nothing can ever say "no people match".
      return rfetch('/people?' + qs(offset), { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', cache: 'no-store' }, 8000)
        .then(function (r) { return r.text(); });
    }
    function reload() {
      var mine = ++seq;
      results.classList.add('loading');
      fetchRows(0).then(function (html) {
        if (mine !== seq) return;              // a newer keystroke already superseded this
        results.classList.remove('loading');
        html = (html || '').trim();
        results.innerHTML = html || '<div class="people-empty">No people match. Try a different search.</div>';
        if (moreWrap) moreWrap.hidden = count() < PAGE;
        syncEnd();
        try { history.replaceState(null, '', pageUrl()); } catch (e) {}
      }).catch(function () {
        if (mine !== seq) return;              // a newer keystroke owns the surface now
        results.classList.remove('loading');
        // Failure must not read as emptiness. The empty-state copy above is for a real empty
        // result and stays untouched; this says the request failed and offers the same tap-to-retry
        // the header flyout uses, so the page is never a dead end.
        results.innerHTML = '<div class="people-empty people-retry">Couldn\'t load. Tap to retry.</div>';
        if (moreWrap) moreWrap.hidden = true;
        syncEnd();
      });
    }
    results.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.people-retry')) reload();
    });
    qEl.addEventListener('input', function () { clearTimeout(t); t = setTimeout(reload, 260); });
    sortEl.addEventListener('change', reload);
    photoEl.addEventListener('change', reload);
    if (moreBtn) moreBtn.addEventListener('click', function () {
      var off = count();
      moreBtn.disabled = true;
      moreWrap.classList.add('loading');   // the orb's chevron gives way to the dots
      fetchRows(off).then(function (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = (html || '').trim();
        var added = tmp.querySelectorAll('.aside-person').length;
        while (tmp.firstChild) results.appendChild(tmp.firstChild);
        moreBtn.disabled = false;
        moreWrap.classList.remove('loading');
        if (added < PAGE) moreWrap.hidden = true;
        syncEnd();
      }).catch(function () { moreBtn.disabled = false; moreWrap.classList.remove('loading'); });
    });

    // Deepen the search bar's shadow once it sticks under the header, "fly" on scroll.
    var controls = pagEl.querySelector('.people-controls');
    if (controls) {
      var ticking = false;
      function checkStuck() {
        ticking = false;
        var stickyTop = parseFloat(getComputedStyle(controls).top) || 0;
        controls.classList.toggle('stuck', controls.getBoundingClientRect().top <= stickyTop + 1);
        // rows fade to TRANSPARENT just before the card's bottom edge and stay
        // invisible above it: a real mask on the list, so the controls card
        // keeps its glass (no opaque slabs needed behind it)
        if (results) {
          var line = controls.getBoundingClientRect().bottom - results.getBoundingClientRect().top;
          results.style.setProperty('--fade-top', (line > 0 ? Math.round(line) : -26) + 'px');
        }
      }
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(checkStuck); } }, { passive: true });
      window.addEventListener('resize', function () { if (!ticking) { ticking = true; requestAnimationFrame(checkStuck); } });
      checkStuck();
    }
  })();

  /* ---- SEARCH MEMORY: Recent + Suggested on an empty search (db/0191, 2026-09-29) ----------------
     Rob: "Can we enhance our search and add history like Instagram?" Focus a search box with nothing
     typed and this paints, for MEMBERS only (guests keep exactly today's behaviour):
       RECENT     a horizontal row of the profiles opened from search (72px, gold ring, name + seal as
                  a SIBLING after it, count-rule "39.2k followers", x to remove), then recent queries
                  (clock) and tags (#). "See all" = the full list, per-item x, "Clear all" + confirm.
       SUGGESTED  trending tags / popular queries / creators from lib/searchhistory.php; "Refresh"
                  walks the pool.
     Typing 2+ characters hands the box straight back to the live results (unchanged). The server is
     the only store (/search/history, /search/suggested; twins at /api/v1/search/*), so it syncs with
     the iOS app. RECORDED: a profile opened from search results / Recent / Suggested; a SUBMITTED
     query (Enter, "See all results", a Recent or Suggested query tap); a tag opened from search.
     Never a keystroke. Records ride sendBeacon, so one survives the navigation it precedes.
     Hosts: the typeahead dropdowns (header flyout #hdr-search, /feed #home-search -- see
     bindTypeahead below) and /search's inline #srch-memory (booted from data-boot). */
  var SHM = (function () {
    var hist = null, histAt = 0, histP = null;
    var sugg = null, suggN = 0, suggP = null;
    var hosts = [];
    var seq = 0;
    function member() { return !isGuest(); }
    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function tok() { return (document.querySelector('meta[name="csrf-token"]') || {}).content || csrf || ''; }
    function getJSON(url) {
      return fetch(url, { headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
                          credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { return r.ok ? r.json() : null; });
    }
    /* OPTIMISTIC queries/tags: a record() rides a beacon, so a re-read fired right after it (the
       /search page clears its box 240ms later; a navigation lands on a page booted before the
       beacon was processed) can come back without it. Anything recorded in the last 8s that the
       server copy does not carry yet is laid back on top, newest first, until the server has it. */
    var pend = [];
    function mergePend() {
      if (!hist) return;
      var now = Date.now();
      pend = pend.filter(function (p) { return now - p.t < 8000; });
      pend.forEach(function (p) {
        var k = p.kind === 'tag' ? 'tag' : 'q';
        var has = (hist.recent || []).some(function (a) { return a.kind === p.kind && String(a[k]).toLowerCase() === String(p.v).toLowerCase(); });
        if (has) return;
        var item = { kind: p.kind, at: new Date(p.t).toISOString() }; item[k] = p.v;
        hist.recent = [item].concat(hist.recent || []);
        var list = p.kind === 'tag' ? 'tags' : 'queries', li = {}; li[k] = p.v; li.at = item.at;
        hist[list] = [li].concat(hist[list] || []);
      });
    }
    /* stale: paint it now but re-read on the next show (the /search boot was rendered on the same
       request whose beacon may still be in flight). */
    function setHist(j, stale) { if (j && (j.ok || j.recent)) { hist = j; histAt = stale ? 0 : Date.now(); mergePend(); } }
    function loadHist(force) {
      if (!member()) return Promise.resolve(null);
      if (!force && hist && Date.now() - histAt < 30000) return Promise.resolve(hist);
      if (histP) return histP;
      histP = getJSON('/search/history').then(function (j) { histP = null; setHist(j); return hist; },
                                               function () { histP = null; return hist; });
      return histP;
    }
    function loadSugg(n) {
      if (!member()) return Promise.resolve(null);
      if (sugg && n === suggN) return Promise.resolve(sugg);
      if (suggP) return suggP;
      suggP = getJSON('/search/suggested?refresh=' + n).then(function (j) {
        suggP = null; if (j && j.ok) { sugg = j; suggN = n; } return sugg;
      }, function () { suggP = null; return sugg; });
      return suggP;
    }
    function repaint(except) { hosts.forEach(function (h) { if (h !== except && h.isConnected && h._shm && h._shm.visible()) h._shm.paint(true); }); }
    function post(url, data, beacon) {
      var fd = new FormData();
      Object.keys(data).forEach(function (k) { fd.append(k, data[k]); });
      fd.append('_csrf', tok());
      if (beacon && navigator.sendBeacon) { try { if (navigator.sendBeacon(url, fd)) return; } catch (e) {} }
      try {
        fetch(url, { method: 'POST', body: fd, credentials: 'same-origin', keepalive: !!beacon,
                     headers: { 'X-CSRF-Token': tok(), 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' } })
          .catch(function () {});
      } catch (e) {}
    }
    /* record(kind, {id|username|q|tag}): fire-and-forget; the cached list is marked stale so the
       next open re-reads the server's order (the same order the app sees). */
    function record(kind, data) {
      if (!member()) return;
      var d = { kind: kind };
      Object.keys(data || {}).forEach(function (k) { if (data[k] != null && data[k] !== '') d[k] = data[k]; });
      if (kind === 'query' && String(d.q || '').trim().length < 2) return;
      post('/search/history', d, true);
      histAt = 0;
      if (kind === 'query' || kind === 'tag') {
        var v = kind === 'tag' ? String(d.tag || '').replace(/^#/, '') : String(d.q).trim().replace(/\s+/g, ' ');
        if (v) {
          pend = pend.filter(function (p) { return !(p.kind === kind && p.v.toLowerCase() === v.toLowerCase()); });
          pend.push({ kind: kind, v: v, t: Date.now() });
          if (hist) {   // drop the older copy of the same entry, then lay the fresh one on top
            var k = kind === 'tag' ? 'tag' : 'q';
            hist.recent = (hist.recent || []).filter(function (a) { return !(a.kind === kind && String(a[k]).toLowerCase() === v.toLowerCase()); });
            hist[kind === 'tag' ? 'tags' : 'queries'] = (hist[kind === 'tag' ? 'tags' : 'queries'] || []).filter(function (a) { return String(a[k]).toLowerCase() !== v.toLowerCase(); });
            mergePend();
          }
        }
      }
    }
    function lc(s) { return String(s == null ? '' : s).toLowerCase(); }
    /* forget(): the data half of a removal (cache + server), no paint. A removal in a mounted panel is
       painted IN PLACE by that panel's drop() (2026-10-23, Rob: an x after scrolling the Recent row
       sideways rebuilt the panel and threw the row back to the front); every OTHER mounted panel
       repaints with its scroll kept (repaint(except)). */
    function forget(kind, key) {
      if (hist) {   // optimistic: the row leaves now, the server is told in the background
        hist.recent = (hist.recent || []).filter(function (a) {
          if (a.kind !== kind) return true;
          if (kind === 'user') return String(a.user.id) !== String(key);
          return lc(kind === 'tag' ? a.tag : a.q) !== lc(key);
        });
        hist.profiles = (hist.profiles || []).filter(function (p) { return !(kind === 'user' && String(p.id) === String(key)); });
        hist.queries = (hist.queries || []).filter(function (q) { return !(kind === 'query' && lc(q.q) === lc(key)); });
        hist.tags = (hist.tags || []).filter(function (t) { return !(kind === 'tag' && lc(t.tag) === lc(key)); });
      }
      var d = { kind: kind };
      d[kind === 'user' ? 'id' : (kind === 'tag' ? 'tag' : 'q')] = key;
      post('/search/history/remove', d, false);
    }
    function clearAll() {
      hist = { ok: true, profiles: [], queries: [], tags: [], recent: [] }; histAt = Date.now();
      post('/search/history/clear', {}, false);
      repaint();
    }

    var ICO_CLOCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2"/></svg>';
    var ICO_FIND = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="6.5"/><path d="m16 16 4 4"/></svg>';
    var ICO_X = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M7 7l10 10M17 7 7 17"/></svg>';
    var ICO_BACK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>';
    var ICO_NEXT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';

    function av(u, cls) {
      return u.avatar
        ? '<img class="' + cls + '" src="' + esc(u.avatar) + '" alt="" loading="lazy" decoding="async">'
        : '<span class="' + cls + ' shm-mono">' + esc(u.initial || '?') + '</span>';
    }
    // the name, then the seal as a SIBLING (never inside the ellipsised span, where it cannot paint)
    function nameRow(u, cls) {
      return '<span class="' + cls + '"><span class="shm-nm">' + esc(u.display_name || u.username) + '</span>'
        + (u.verified ? vsealTick() : '') + '</span>';
    }

    /* mount(host, opts): opts.input (the text box that owns the keyboard), opts.inline (true on
       /search: part of the page, not a dropdown), opts.onQuery(q) (run a query in place instead of
       navigating), opts.onPaint() (the dropdown re-fits its height). */
    function mount(host, opts) {
      if (host._shm) return host._shm;
      var id = 'shm' + (++seq);
      var view = 'main', confirmClear = false, active = -1;
      var input = opts.input;
      host.classList.add('shm-host');
      hosts.push(host);
      function options() { return Array.prototype.slice.call(host.querySelectorAll('.shm-opt')); }
      // noScroll: a removal hands the highlight on without moving the row (the next chip slides into view itself)
      function setActive(i, noScroll) {
        var os = options();
        os.forEach(function (o) { o.classList.remove('is-active'); o.setAttribute('aria-selected', 'false'); });
        active = (os.length && i >= 0) ? Math.min(i, os.length - 1) : -1;
        if (input) {
          if (active >= 0) input.setAttribute('aria-activedescendant', os[active].id);
          else input.removeAttribute('aria-activedescendant');
        }
        if (active >= 0) {
          os[active].classList.add('is-active'); os[active].setAttribute('aria-selected', 'true');
          if (!noScroll) { try { os[active].scrollIntoView({ block: 'nearest', inline: 'nearest' }); } catch (e) {} }
        }
      }
      function optAttrs(n, extra) {
        return ' role="option" id="' + id + '-o' + n + '" aria-selected="false"' + (extra || '');
      }
      function userRow(u, n, removable) {
        return '<div class="shm-item shm-opt" data-kind="user" data-id="' + u.id + '"' + optAttrs(n) + '>'
             + '<a class="shm-go" href="/@' + encodeURIComponent(u.username) + '" tabindex="-1">'
             + '<span class="shm-ring shm-ring-sm' + (u.media_24h ? ' shm-on' : '') + '">' + av(u, 'shm-av') + '</span>'
             + '<span class="shm-t">' + nameRow(u, 'shm-nmrow shm-left') + '<span class="shm-sub">@' + esc(u.username)
             + ' · ' + esc(u.followers_text) + '</span></span></a>'
             + (removable ? '<button type="button" class="shm-x" data-act="rm" tabindex="-1" aria-label="Remove '
               + esc(u.display_name) + ' from recent">' + ICO_X + '</button>' : '') + '</div>';
      }
      function termRow(kind, text, n, icon, sub, removable) {
        var isTag = kind === 'tag';
        var href = isTag ? '/tag/' + encodeURIComponent(text) : '/search?q=' + encodeURIComponent(text);
        var shown = isTag ? '#' + text : text;
        return '<div class="shm-item shm-opt" data-kind="' + kind + '" data-key="' + esc(text) + '"' + optAttrs(n) + '>'
             + '<a class="shm-go" href="' + href + '" tabindex="-1"><span class="shm-ic' + (isTag ? ' shm-hash' : '') + '">'
             + (isTag ? '#' : icon) + '</span><span class="shm-t"><span class="shm-tt">' + esc(shown) + '</span>'
             + (sub ? '<span class="shm-sub">' + esc(sub) + '</span>' : '') + '</span></a>'
             + (removable ? '<button type="button" class="shm-x" data-act="rm" tabindex="-1" aria-label="Remove '
               + esc(shown) + ' from recent">' + ICO_X + '</button>' : '') + '</div>';
      }
      function recentRow(a, n) {
        if (a.kind === 'user') return userRow(a.user, n, true);
        return termRow(a.kind, a.kind === 'tag' ? a.tag : a.q, n, ICO_CLOCK, '', true);
      }
      function chipHtml(u, n) {
        return '<div class="shm-chip shm-opt" data-kind="user" data-id="' + u.id + '"'
             + optAttrs(n, ' aria-label="' + esc(u.display_name) + (u.verified ? ', verified' : '') + ', ' + esc(u.followers_text) + '"') + '>'
             + '<a class="shm-go" href="/@' + encodeURIComponent(u.username) + '" tabindex="-1">'
             + '<span class="shm-ring' + (u.media_24h ? ' shm-on' : '') + '">' + av(u, 'shm-av') + '</span>'
             + nameRow(u, 'shm-nmrow') + '<span class="shm-sub">' + esc(u.followers_text) + '</span></a>'
             + '<button type="button" class="shm-x" data-act="rm" tabindex="-1" aria-label="Remove ' + esc(u.display_name) + ' from recent">' + ICO_X + '</button></div>';
      }
      /* paint(keep): keep = the same view re-painted for a DATA change (another panel's removal, Clear all,
         a removal that empties a section): the Recent row's scrollLeft and the panel's scrollTop are put
         back exactly, with snap held off for the write so proximity snapping cannot pull it elsewhere. */
      function paint(keep) {
        var kRow = keep ? host.querySelector('.shm-row') : null;
        var kView = host.querySelector('.shm') ? (host.querySelector('.shm').getAttribute('data-view') || '') : '';
        var kLeft = kRow ? kRow.scrollLeft : 0, kTop = host.scrollTop;
        paintNow();
        if (!keep || kView !== view) return;
        var nr = host.querySelector('.shm-row');
        if (nr && kLeft) { nr.style.scrollSnapType = 'none'; nr.scrollLeft = kLeft; void nr.offsetWidth; nr.style.scrollSnapType = ''; }
        if (host.scrollTop !== kTop) host.scrollTop = kTop;
        if (rnUpd) rnUpd();
      }
      function paintNow() {
        var h = hist || { profiles: [], queries: [], tags: [], recent: [] };
        var rec = h.recent || [];
        var n = 0, html = '';
        if (view === 'all') {
          html += '<div class="shm-hd"><button type="button" class="shm-back" data-act="back" aria-label="Back">' + ICO_BACK + '</button>'
               +  '<span class="shm-h" id="' + id + '-ha">Recent</span>'
               +  (rec.length ? '<button type="button" class="shm-lnk shm-danger" data-act="clear">Clear all</button>' : '') + '</div>';
          if (confirmClear) {
            html += '<div class="shm-confirm" role="alertdialog" aria-labelledby="' + id + '-cq">'
                 +  '<span id="' + id + '-cq">Clear all recent searches? This can’t be undone.</span>'
                 +  '<span class="shm-confirm-acts"><button type="button" class="btn sm" data-act="clear-no">Cancel</button>'
                 +  '<button type="button" class="btn sm primary" data-act="clear-yes">Clear all</button></span></div>';
          }
          html += '<div class="shm-list" role="group" aria-labelledby="' + id + '-ha">';
          rec.forEach(function (a) { html += recentRow(a, n++); });
          if (!rec.length) html += '<div class="shm-empty">No recent searches.</div>';
          html += '</div>';
        } else {
          var prof = (h.profiles || []).slice(0, 10);
          var terms = rec.filter(function (a) { return a.kind !== 'user'; }).slice(0, 5);
          /* .shm-rnav: desktop prev/next for the Recent row, the site's rail convention (.dx-railnav): shown
             only on a fine pointer, hidden while the row fits, each end disabled when there is nothing that way */
          html += '<div class="shm-hd"><span class="shm-h" id="' + id + '-hr">Recent</span>'
               +  (prof.length ? '<span class="shm-rnav is-idle"><button type="button" class="shm-navb" data-act="rprev" tabindex="-1" aria-label="Scroll recent profiles left" disabled>' + ICO_BACK + '</button>'
                  + '<button type="button" class="shm-navb" data-act="rnext" tabindex="-1" aria-label="Scroll recent profiles right">' + ICO_NEXT + '</button></span>' : '')
               +  (rec.length ? '<button type="button" class="shm-lnk" data-act="all">See all</button>' : '') + '</div>';
          if (prof.length) {
            html += '<div class="shm-row" role="group" aria-label="Recent profiles">';
            prof.forEach(function (u) { html += chipHtml(u, n++); });
            html += '</div>';
          }
          if (terms.length) {
            html += '<div class="shm-list" data-sec="terms" role="group" aria-label="Recent searches">';
            terms.forEach(function (a) { html += recentRow(a, n++); });
            html += '</div>';
          }
          if (!prof.length && !terms.length) html += '<div class="shm-empty">No recent searches.</div>';
          var s = sugg;
          if (s && ((s.queries || []).length || (s.creators || []).length)) {
            var q = (s.queries || []).slice(0, 4);
            var c = (s.creators || []).slice(0, Math.max(2, 6 - q.length));
            html += '<div class="shm-hd shm-hd-sugg"><span class="shm-h" id="' + id + '-hs">Suggested</span>'
                 +  '<button type="button" class="shm-lnk" data-act="refresh">Refresh</button></div>'
                 +  '<div class="shm-list" role="group" aria-labelledby="' + id + '-hs">';
            q.forEach(function (t) {
              var isTag = t.kind === 'tag';
              html += termRow(isTag ? 'tag' : 'query', isTag ? t.tag : t.q, n++, ICO_FIND,
                              t.reason === 'trending' ? 'Trending on Rova' : 'Popular search', false);
            });
            c.forEach(function (u) { html += userRow(u, n++, false); });
            html += '</div>';
          } else if (!s && suggP) {
            html += skelSugg();   // Recent answered first: Suggested keeps its placeholder rows until it lands
          }
        }
        host.innerHTML = '<div class="shm" id="' + id + '" role="listbox" aria-label="Recent and suggested searches" data-view="' + view + '">' + html + '</div>';
        active = -1;
        if (input) input.removeAttribute('aria-activedescendant');
        if (confirmClear) { var y = host.querySelector('[data-act="clear-yes"]'); if (y) { try { y.focus({ preventScroll: true }); } catch (e) {} } }
        bindRowNav();
        if (opts.onPaint) opts.onPaint();
      }
      /* SKELETON (2026-10-22): until the member's own list answers, the dropdown opens on the panel's
         real headings + placeholder rows in the panel's exact row geometry (44px rows, 72px chips), so
         the open frame is already laid out and the answer swaps rows in place. Not a .shm root, so
         visible()/repaint() never treat it as painted data. */
      function skelSugg() {
        var row = '<span class="shm-skr"><i class="shm-ska shm-ska-sm"></i><span><i></i><i></i></span></span>';
        return '<div class="shm-skel" aria-hidden="true"><div class="shm-hd shm-hd-sugg"><span class="shm-h">Suggested</span></div>'
             + '<div class="shm-sklist">' + row + row + row + row + '</div></div>';
      }
      function paintSkel() {
        var chip = '<span class="shm-skc"><i class="shm-ska"></i><i class="shm-skl"></i></span>';
        host.innerHTML = '<div class="shm-skel" aria-busy="true" aria-label="Loading recent and suggested searches">'
          + '<div class="shm-hd"><span class="shm-h">Recent</span></div>'
          + '<div class="shm-skrow">' + chip + chip + chip + chip + '</div>' + skelSugg() + '</div>';
        if (opts.onPaint) opts.onPaint();
      }
      /* the Recent row's arrows follow the row: scroll (rAF-throttled) + a ResizeObserver, because the
         panel is often painted while still display:none (every size reads 0 until it opens) */
      var rnRO = null, rnUpd = null;
      function bindRowNav() {
        if (rnRO) { rnRO.disconnect(); rnRO = null; }
        rnUpd = null;
        var row = host.querySelector('.shm-row'), nav = host.querySelector('.shm-rnav');
        if (!row || !nav) return;
        var bs = nav.querySelectorAll('.shm-navb'), raf = 0;
        rnUpd = upd;   // drop() calls it: a shorter row changes scrollWidth, which neither scroll nor resize reports
        function upd() {
          raf = 0;
          if (!row.isConnected) return;
          var max = row.scrollWidth - row.clientWidth;
          nav.classList.toggle('is-idle', max <= 1);
          bs[0].disabled = row.scrollLeft <= 2;
          bs[1].disabled = row.scrollLeft >= max - 2;
        }
        row.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(upd); }, { passive: true });
        if (window.ResizeObserver) { rnRO = new ResizeObserver(function () { if (!raf) raf = requestAnimationFrame(upd); }); rnRO.observe(row); }
        upd();
      }
      function keyOf(opt) { return opt.getAttribute('data-kind') === 'user' ? opt.getAttribute('data-id') : opt.getAttribute('data-key'); }
      // _shmQuiet: this focus is the panel handing focus BACK to its own box (after an x, See all, Back...);
      // bindTypeahead's focus wake must not take it for an open and rebuild the panel under the member
      function keepFocus() {
        if (input && !opts.inline) {
          input._shmQuiet = true;
          try { input.focus({ preventScroll: true }); } catch (e) {}
          input._shmQuiet = false;
        }
      }

      /* drop(opt, viaKey): REMOVE IN PLACE (2026-10-23, Rob: "when tapping x on some people after
         scrolling sideways it resets back to the front"). remove() used to repaint the whole panel, and
         the rebuilt .shm-row started at scrollLeft 0. Now only that entry leaves: it fades and folds to
         nothing while its neighbours slide over, the row's scrollLeft is never written (snap is held
         off for the fold so proximity snapping cannot pick a new chip; at the row's end the browser's
         own clamp lets the row end where it ends), and an entry that was past the 10-chip / 5-term cut
         joins at the END of its section. Only a section that empties (or the whole panel) repaints,
         with paint(true) keeping the scroll. The highlight (Shift+Delete) and DOM focus (an x that had
         it) move to the next entry in the same section, or the previous when it was the last. */
      var bseq = 0, folding = 0;
      function sameEntry(o, kind, key) {
        if (o.getAttribute('data-kind') !== kind) return false;
        return kind === 'user' ? String(keyOf(o)) === String(key) : lc(keyOf(o)) === lc(key);
      }
      function drop(o, viaKey) {
        var kind = o.getAttribute('data-kind'), key = keyOf(o);
        var os = options(), was = active >= 0 ? os[active] : null;
        var ae = document.activeElement, hadFocus = !!(ae && ae !== document.body && o.contains(ae));
        forget(kind, key);
        repaint(host);
        var gone = os.filter(function (x) { return sameEntry(x, kind, key) && x.querySelector('[data-act="rm"]'); });
        if (gone.indexOf(o) < 0) gone.push(o);
        // who inherits the highlight / focus: the next entry in o's own section, else the previous one
        function sib(dir) {
          var s = o;
          while ((s = dir > 0 ? s.nextElementSibling : s.previousElementSibling)) {
            if (s.classList.contains('shm-opt') && gone.indexOf(s) < 0) return s;
          }
          return null;
        }
        var h = hist || { profiles: [], recent: [] }, rec = h.recent || [];
        var row = host.querySelector('.shm-row'), tl = host.querySelector('.shm-list[data-sec="terms"]');
        var prof = (h.profiles || []).slice(0, 10);
        var terms = rec.filter(function (a) { return a.kind !== 'user'; }).slice(0, 5);
        var empties = !rec.length
          || (view === 'main' && ((row && !prof.length) || (tl && !terms.length)));
        if (empties) {
          var idx = was ? os.indexOf(was) : -1;
          paint(true);
          if (viaKey || (was && gone.indexOf(was) >= 0)) {
            var n = options().length;
            if (n && idx >= 0) setActive(Math.min(idx, n - 1), true);
          }
          if (hadFocus) keepFocus();
          return;
        }
        // snap off BEFORE the row changes: a chip appended at the end (backfill) is a layout change, and
        // Chrome re-snaps a row resting at its end onto the next snap point (+4px, then back) on it.
        // Each fold holds it too; it comes back on when the last hold is released.
        var held = row && gone.some(function (g) { return g.parentNode === row; }) ? row : null;
        if (held) snapHold(held);
        // backfill: entries the cut kept out (the 11th profile, the 6th term) join at the section's end
        if (view === 'main') {
          var fill = function (wrap, want, has, mk) {
            if (!wrap) return;
            want.forEach(function (a) { if (!has(a)) wrap.insertAdjacentHTML('beforeend', mk(a)); });
          };
          fill(row, prof, function (u) {
            return os.some(function (x) { return gone.indexOf(x) < 0 && x.parentNode === row && sameEntry(x, 'user', u.id); });
          }, function (u) { return chipHtml(u, 'b' + (++bseq)); });
          fill(tl, terms, function (a) {
            var k = a.kind === 'tag' ? a.tag : a.q;
            return os.some(function (x) { return gone.indexOf(x) < 0 && x.parentNode === tl && sameEntry(x, a.kind, k); });
          }, function (a) { return recentRow(a, 'b' + (++bseq)); });
        }
        var heir = sib(1) || sib(-1);   // after the backfill: the last chip's heir is the one that joined
        // hand on focus BEFORE the fold (a focused node that leaves the DOM drops focus to <body>)
        if (hadFocus) {
          var hx = heir && heir.querySelector('[data-act="rm"]');
          if (hx) { try { hx.focus({ preventScroll: true }); } catch (e) {} } else keepFocus();
        }
        gone.forEach(function (g) { fold(g); });
        if (held) snapRelease(held);
        // the highlight: kept on its entry, or handed to the heir when its own entry left
        var now = options();
        if (viaKey || (was && gone.indexOf(was) >= 0)) setActive(heir ? now.indexOf(heir) : -1, true);
        else if (was) active = now.indexOf(was);
        if (rnUpd) rnUpd();
      }
      /* the row's scroll-snap is held off while anything in it folds (a counter: quick taps on several x's
         overlap), then turned back on with scrollLeft re-asserted if the re-enable snapped it */
      function snapHold(row) { folding++; row.style.scrollSnapType = 'none'; }
      function snapRelease(row) {
        folding = Math.max(0, folding - 1);
        if (folding) return;
        var sl = row.scrollLeft;
        row.style.scrollSnapType = '';
        if (Math.abs(row.scrollLeft - sl) > 1) row.scrollLeft = sl;
      }
      function fold(el) {
        el.classList.remove('shm-opt', 'is-active');
        el.classList.add('shm-gone');
        el.removeAttribute('id'); el.removeAttribute('role');
        el.setAttribute('aria-hidden', 'true');
        try { el.inert = true; } catch (e) {}
        var row = el.parentNode && el.parentNode.classList && el.parentNode.classList.contains('shm-row') ? el.parentNode : null;
        var rm = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
        var done = false;
        function end() {
          if (done) return; done = true;
          if (el.parentNode) el.parentNode.removeChild(el);
          if (row) snapRelease(row);
          if (rnUpd) rnUpd();
          if (opts.onPaint && !row) opts.onPaint();   // a shorter list: the dropdown re-fits
        }
        if (row) snapHold(row);
        if (rm || !el.animate) { end(); return; }
        var r = el.getBoundingClientRect(), kf;
        if (row) {
          var gap = parseFloat(getComputedStyle(row).columnGap) || 0;
          kf = [{ flexBasis: r.width + 'px', width: r.width + 'px', marginRight: '0px', opacity: 1, transform: 'scale(1)' },
                { flexBasis: '0px', width: '0px', marginRight: (-gap) + 'px', opacity: 0, transform: 'scale(.6)' }];
        } else {
          kf = [{ height: r.height + 'px', opacity: 1, transform: 'translateX(0)' },
                { height: '0px', opacity: 0, transform: 'translateX(-12px)' }];
        }
        el.style.overflow = 'hidden'; el.style.minWidth = '0'; el.style.pointerEvents = 'none';
        try {
          var an = el.animate(kf, { duration: 220, easing: 'cubic-bezier(.3,.7,.2,1)', fill: 'forwards' });
          an.onfinish = end; an.oncancel = end;
        } catch (e) { end(); return; }
        setTimeout(end, 700);   // a hidden / throttled tab never misses the cleanup
      }

      // buttons never steal focus from the text box (so they never close the dropdown under it)
      host.addEventListener('mousedown', function (e) { if (e.target.closest && e.target.closest('button')) e.preventDefault(); });
      host.addEventListener('click', function (e) {
        var btn = e.target.closest ? e.target.closest('[data-act]') : null;
        if (btn && host.contains(btn)) {
          e.preventDefault(); e.stopPropagation();
          var act = btn.getAttribute('data-act');
          if (act === 'all') { view = 'all'; confirmClear = false; paint(); keepFocus(); }
          else if (act === 'back') { view = 'main'; confirmClear = false; paint(); keepFocus(); }
          else if (act === 'clear') { confirmClear = true; paint(); }
          else if (act === 'clear-no') { confirmClear = false; paint(); keepFocus(); }
          else if (act === 'clear-yes') { confirmClear = false; clearAll(); keepFocus(); }
          else if (act === 'refresh') { loadSugg(suggN + 1).then(function () { paint(); }); keepFocus(); }
          else if (act === 'rprev' || act === 'rnext') {
            var rw = host.querySelector('.shm-row');
            if (rw) {
              var rm = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
              rw.scrollBy({ left: (act === 'rnext' ? 1 : -1) * Math.max(90, rw.clientWidth * 0.8), behavior: rm ? 'auto' : 'smooth' });
            }
            keepFocus();
          }
          else if (act === 'rm') {
            var o = btn.closest('.shm-opt'), xf = document.activeElement === btn;
            if (o) drop(o, false);
            if (!xf) keepFocus();   // an x that HAD focus handed it to the next entry's x inside drop()
          }
          return;
        }
        var go = e.target.closest ? e.target.closest('a.shm-go') : null;
        if (!go || !host.contains(go)) return;
        e.stopPropagation();
        var opt = go.closest('.shm-opt'), kind = opt.getAttribute('data-kind');
        if (kind === 'user') { record('user', { id: opt.getAttribute('data-id') }); return; }   // the link navigates
        if (kind === 'tag') { record('tag', { tag: opt.getAttribute('data-key') }); return; }
        var q = opt.getAttribute('data-key');
        record('query', { q: q });
        if (opts.onQuery) { e.preventDefault(); opts.onQuery(q); }
      });
      var api = {
        visible: function () { return host.isConnected && !!host.querySelector('.shm'); },
        paint: paint,
        show: function () {
          if (!member()) return false;
          view = 'main'; confirmClear = false;
          if (hist) paint();
          else if (!opts.inline) paintSkel();   // first open on this page: a laid-out placeholder, never an empty/late box
          // Recent leads: nothing paints until the member's own list has answered (or failed), so the
          // row never pops in ABOVE a Suggested block that painted first and shoves it down.
          var histDone = false;
          // paint(true): an answer that lands after the member has swiped the row (or scrolled See all)
          // re-paints the data without throwing them back to the front
          loadHist(false).then(function () { histDone = true; if (api.wanted()) paint(true); });
          loadSugg(suggN).then(function () { if ((hist || histDone) && api.wanted()) paint(true); });
          return true;
        },
        wanted: function () { return !opts.wanted || opts.wanted(); },
        /* keyboard, from the owning input's keydown. Returns true when it consumed the key. */
        key: function (e) {
          var os = options();
          if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
            if (!os.length) return false;
            e.preventDefault();
            var i = active < 0 ? (e.key === 'ArrowDown' ? 0 : os.length - 1)
                               : (active + (e.key === 'ArrowDown' ? 1 : -1) + os.length) % os.length;
            setActive(i); return true;
          }
          if (e.key === 'Enter' && active >= 0 && os[active]) {
            e.preventDefault();
            var a = os[active].querySelector('a.shm-go'); if (a) a.click();
            return true;
          }
          // Shift+Delete removes the highlighted entry (the browser-omnibox convention; a bare Delete
          // is far too easy to press while clearing the box)
          if (e.key === 'Delete' && e.shiftKey && active >= 0 && os[active] && input && input.value === ''
              && os[active].querySelector('[data-act="rm"]')) {
            e.preventDefault();
            drop(os[active], true); return true;
          }
          return false;
        }
      };
      host._shm = api;
      return api;
    }
    /* warm(): the header search tap's pointerdown starts both reads ~50-100 ms before its click
       opens the box, so a first open usually paints real rows instead of the skeleton */
    function warm() { if (member()) { loadHist(false); loadSugg(suggN); } }
    return { mount: mount, record: record, member: member, boot: setHist, warm: warm };
  })();
  document.addEventListener('pointerdown', function (e) {
    if (e.target && e.target.closest && e.target.closest('#search-link')) { try { SHM.warm(); } catch (err) {} }
  }, { capture: true, passive: true });

  /* Arrow keys + Enter over the LIVE RESULTS rows (a.res) of a typeahead dropdown: the same listbox
     contract as the memory panel, so the keyboard works identically in both states. */
  function resNav(input, box, e) {
    var os = Array.prototype.slice.call(box.querySelectorAll('a.res'));
    if (!os.length) return false;
    var cur = -1;
    os.forEach(function (o, i) { if (o.classList.contains('is-active')) cur = i; });
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault();
      var i = cur < 0 ? (e.key === 'ArrowDown' ? 0 : os.length - 1) : (cur + (e.key === 'ArrowDown' ? 1 : -1) + os.length) % os.length;
      os.forEach(function (o) { o.classList.remove('is-active'); o.setAttribute('aria-selected', 'false'); });
      os[i].classList.add('is-active'); os[i].setAttribute('aria-selected', 'true');
      input.setAttribute('aria-activedescendant', os[i].id);
      try { os[i].scrollIntoView({ block: 'nearest' }); } catch (err) {}
      return true;
    }
    if (e.key === 'Enter' && cur >= 0) { e.preventDefault(); os[cur].click(); return true; }
    return false;
  }

  /* ---- search typeahead (hero bar, feed bar, header flyout) ------------- */
  /* 2026-09-29 (search history): an EMPTY box (focused, < 2 characters) now shows the member's
     Recent + Suggested panel (SHM above) in this same dropdown; 2+ characters swap to the live
     results exactly as before. The input is a combobox over a listbox in both states: arrow keys
     move an active option (aria-activedescendant), Enter opens it, Escape closes. */
  var taSeq = 0;
  function bindTypeahead(searchInput, searchBox) {
    if (!searchInput || !searchBox) return;
    var timer = null;
    var mem = null;
    if (!searchBox.id) searchBox.id = 'ta-box-' + (++taSeq);
    searchInput.setAttribute('role', 'combobox');
    searchInput.setAttribute('aria-autocomplete', 'list');
    searchInput.setAttribute('aria-controls', searchBox.id);
    searchInput.setAttribute('aria-expanded', 'false');

    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    // KEYBOARD-AWARE height: the CSS 60vh cap ignores the on-screen keyboard (mobile vh = the FULL
    // screen), so the dropdown ran under it and the bottom rows sat past the clip -- taps there hit
    // the page behind and just dismissed the box (owner). Cap to the VISUAL viewport instead so every
    // row is genuinely on screen and tappable.
    function fit() {
      try {
        var vv = window.visualViewport;
        var visH = vv ? vv.height : window.innerHeight;
        var topY = searchBox.getBoundingClientRect().top - (vv ? vv.offsetTop : 0);
        searchBox.style.maxHeight = Math.round(Math.max(160, Math.min(window.innerHeight * 0.6, visH - topY - 12))) + 'px';
      } catch (e) {}
    }
    function open(on) {
      searchBox.classList.toggle('show', on);
      searchInput.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (!on) searchInput.removeAttribute('aria-activedescendant');
    }
    function close() {
      searchBox.classList.remove('shm-mode');
      open(false);
    }
    /* The empty-box panel. MEMBERS only: SHM.member() is false for a guest and this returns false,
       which leaves the old "nothing typed = nothing shown" behaviour untouched for them. */
    function showMemory() {
      if (!SHM.member()) return false;
      if (!mem) {
        mem = SHM.mount(searchBox, {
          input: searchInput,
          wanted: function () { return searchBox.classList.contains('shm-mode') && searchInput.value.trim().length < 2; },
          onPaint: function () { open(true); fit(); }
        });
      }
      clearTimeout(timer);
      searchBox.classList.add('shm-mode');
      mem.show();
      return true;
    }

    function render(data) {
      var html = '';
      var n = 0;
      var oid = function () { return ' role="option" aria-selected="false" id="' + searchBox.id + '-r' + (n++) + '"'; };
      if (data.users && data.users.length) {
        html += '<div class="grp" role="presentation">People</div>';
        data.users.forEach(function (u) {
          // verified check right after the name, same badge as profiles/posts (server verified_tick svg)
          var tick = u.verified ? vsealTick() : '';
          // profile photo (image thumb) or a gold monogram fallback
          var av = u.avatar
                ? '<img class="res-av" src="' + esc(u.avatar) + '" alt="" loading="lazy">'
                : '<span class="res-av res-mono">' + esc(u.initial || '?') + '</span>';
          // Online dot, same markup the server emits (View::avatar_img presence branch): the
          // .av-on wrapper is what the dot positions against, so it has to be here too. Both
          // avatar shapes get it, since a monogram member can be online just as an avatared one can.
          // data-t/data-ttl too, so a typeahead row left open on screen decays on exactly the
          // terms a server-rendered one does. This answer was computed for THIS response, so the
          // stamp is now; the server's is its own render time. See presenceSweep() below.
          if (u.online) av = '<span class="av-on">' + av + '<i class="online-dot" title="Online"'
                + ' data-t="' + Math.floor(Date.now() / 1000) + '" data-ttl="' + PRESENCE_TTL + '"></i></span>';
          // SEARCH'S GOLD RING (2026-10-02): the media ring's rule for this viewer, server-decided
          if (u.media_24h) av = '<span class="res-m24">' + av + '</span>';
          // THE BLUE CHECK RIDES THE PHOTO (owner 2026-08-16), not the name. .tn is nowrap +
          // overflow:hidden + ellipsis, and this dropdown is the narrowest people row on the
          // site -- name and @handle share one line inside a panel that is ~300px on a phone --
          // so the tick was reliably left dangling after the "...". The old comment here was
          // right that a badge INSIDE .tn never paints; the answer is not "put it after the
          // ellipsis", it is "take it off the name line entirely".
          // .vav is the shared corner-badge wrapper in rova.css and it sizes the badge from the
          // avatar box (38%), so this 32px .res-av matches the 40px rows without a second
          // number. It goes OUTSIDE .av-on: the online dot has to keep positioning against its
          // own wrapper, and .vav:has(> .vtick) .online-dot then moves the dot inboard so the
          // two never touch -- exactly what the server-rendered rows do.
          html += '<a class="res" href="/@' + encodeURIComponent(u.username) + '" data-username="' + esc(u.username) + '"' + oid() + '>'
                + (tick ? '<span class="vav">' + av + tick + '</span>' : av)
                + '<span class="t"><span class="tn">' + esc(u.display_name) + '</span></span>'
                + '<span class="s">@' + esc(u.username) + '</span></a>';
        });
      }
      if (data.posts && data.posts.length) {
        html += '<div class="grp" role="presentation">Posts</div>';
        data.posts.forEach(function (p) {
          // link the POST result to the POST (/p/id), not the author's profile -- clicking a post result
          // "didn't take me to it" because it went to /@username (owner). Fall back to the profile if no id.
          var href = p.id ? '/p/' + encodeURIComponent(p.id) : '/@' + encodeURIComponent(p.username);
          html += '<a class="res" href="' + href + '"' + oid() + '>'
                + '<span class="s">' + esc(p.snippet) + ', @' + esc(p.username) + '</span></a>';
        });
      }
      // no empty-state row: the ever-present "See all results" is the whole story
      html += '<a class="res see-all" href="/search?q=' + encodeURIComponent(searchInput.value.trim()) + '"' + oid() + '>'
            + '<span class="t">See all results &rarr;</span></a>';
      searchBox.classList.remove('shm-mode');
      searchBox.innerHTML = html;
      searchInput.removeAttribute('aria-activedescendant');
      open(true);
      fit();
    }

    searchInput.addEventListener('input', function () {
      var q = searchInput.value.trim();
      clearTimeout(timer);
      if (q.length < 2) {
        if (!showMemory()) { close(); searchBox.innerHTML = ''; }
        return;
      }
      timer = setTimeout(function () {
        fetch('/search?q=' + encodeURIComponent(q), {
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          credentials: 'same-origin'
        }).then(function (r) { return r.json(); }).then(function (d) {
          // a late answer must not paint over the panel of a box that has since been emptied
          if (searchInput.value.trim().length < 2) return;
          render(d);
        }).catch(function () {});
      }, 180);
    });
    // the empty-box panel opens on focus (the header flyout focuses the box as it opens) and on a
    // tap into an already-focused box whose dropdown was dismissed
    // ...but a panel that is ALREADY open is left alone: show() rebuilds it on the main view, which threw a
    // swiped Recent row back to the front (and See all back to Recent) on a tap into the box, and when
    // focus came back to the box from inside the panel (an x that had focus) (2026-10-23). A real (re)open
    // still rebuilds: the dismissed box has no .show, and the flyout's own focus comes from outside it.
    function memOpen() { return !!(mem && mem.visible() && searchBox.classList.contains('show') && searchBox.classList.contains('shm-mode')); }
    var tapAt = 0;   // a tap / click ON the box itself (bringing the phone keyboard back) is not an open
    function wake(e) {
      if (searchInput.value.trim().length >= 2) return;
      if (memOpen()) {
        if (e.type === 'click' || searchInput._shmQuiet || Date.now() - tapAt < 1000) return;
        if (e.relatedTarget && searchBox.contains(e.relatedTarget)) return;
      }
      showMemory();
    }
    searchInput.addEventListener('pointerdown', function () { tapAt = Date.now(); }, { passive: true });
    searchInput.addEventListener('focus', wake);
    searchInput.addEventListener('click', wake);

    searchInput.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        // in the /feed phone SHEET one Escape closes the whole sheet (the feed's own Escape handler),
        // since the list is the sheet's body rather than a dropdown that can close on its own
        if (searchBox.classList.contains('show')) {
          if (!document.documentElement.classList.contains('fsrch-sheet')) e.stopPropagation();
          close();
        }
        return;
      }
      if (searchBox.classList.contains('show')) {
        if (searchBox.classList.contains('shm-mode') ? (mem && mem.key(e)) : resNav(searchInput, searchBox, e)) return;
      }
      if (e.key === 'Enter') {
        var q = searchInput.value.trim();
        if (q.length >= 2) {
          e.preventDefault();
          SHM.record('query', { q: q });   // a SUBMITTED query -- never a keystroke
          window.location = '/search?q=' + encodeURIComponent(q);
        }
      }
    });

    // record what was opened FROM the results: a person row, or "See all results" (a submitted query)
    searchBox.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a.res') : null;
      if (!a || !searchBox.contains(a)) return;
      if (a.classList.contains('see-all')) { SHM.record('query', { q: searchInput.value.trim() }); return; }
      var un = a.getAttribute('data-username');
      if (un) SHM.record('user', { username: un });
    });

    document.addEventListener('click', function (e) {
      // A node another handler already removed (the panel re-renders on x / See all / Refresh)
      // has no ancestors left and would read as a click OUTSIDE the box; it was not.
      if (!e.target.isConnected) return;
      // ...and a click that left the focus IN this box was aimed at it: the header search button
      // on /feed focuses #home-search inside its own click handler, before this one runs.
      if (document.activeElement === searchInput) return;
      if (!searchBox.contains(e.target) && e.target !== searchInput) {
        close();
      }
    });
  }
  bindTypeahead(document.getElementById('home-search'), document.getElementById('search-results'));
  bindTypeahead(document.getElementById('hdr-search'), document.getElementById('hdr-search-results'));

  /* ---- media: lightbox + double-tap to like ---------------------------- */

  // one shared lightbox element, gallery aware (swipe between a post's photos)
  var lb = null, lbItems = [], lbIdx = 0, lbMedia = null, lbLastTap = 0;
  var lbZoomed = null, lbZoomReset = null;   // set once the lightbox is built
  function lbBounce(dir) {
    var img = lb && lb.querySelector('img');
    if (!img) return;
    img.style.transition = 'transform .17s ease';
    img.style.transform = 'scale(1) translateX(' + (dir < 0 ? 22 : -22) + 'px)';
    setTimeout(function () {
      img.style.transform = 'scale(1) translateX(0)';
      setTimeout(function () { img.style.transition = ''; img.style.transform = ''; }, 190);
    }, 170);
  }
  function lbLike() {
    if (!lbMedia) return;
    likeFromMedia(lbMedia, null, null, true);   // posts the like, quiet: the visible heart is ours, below
    heartBurst(lb);           // the visible heart, exactly the same ♥ as the timeline
  }
  function lightbox() {
    if (lb) return lb;
    lb = document.createElement('div');
    lb.className = 'lightbox';
    lb.innerHTML =
      '<button class="lb-close" aria-label="Close">✕</button>' +
      '<button class="lb-nav prev" aria-label="Previous">‹</button>' +
      '<img alt="">' +
      '<button class="lb-nav next" aria-label="Next">›</button>' +
      '<span class="lb-count"></span>';
    document.body.appendChild(lb);
    // a GIF's fit is computed from the viewport (lbFitGif), so re-fit it on rotate / window resize --
    // only while the lightbox is actually up, and only for a GIF (lbFitGif no-ops on anything else).
    window.addEventListener('resize', function () {
      if (lb && lb.classList.contains('show')) { lbFitGif(lb.querySelector('img')); }
    });
    lb.addEventListener('click', function (e) {
      if (e.target === lb || e.target.classList.contains('lb-close')) { closeLightbox(); return; }
      // SINGLE-photo viewer (profile picture, DM photo -- one item, nothing to like): any click
      // dismisses, QuickLook-style. Multi-image galleries and like-able media keep their clicks
      // for nav + double-tap-to-like, and a zoomed image keeps them for panning.
      if (lbItems.length === 1 && !lbMedia && !(lbZoomed && lbZoomed()) && e.target.tagName === 'IMG') closeLightbox();
    });
    lb.querySelector('.lb-nav.prev').addEventListener('click', function (e) { e.stopPropagation(); lbGo(lbIdx - 1); });
    lb.querySelector('.lb-nav.next').addEventListener('click', function (e) { e.stopPropagation(); lbGo(lbIdx + 1); });
    lb.querySelector('img').addEventListener('dblclick', function (e) { e.preventDefault(); lbLike(); });  // desktop
    var x0 = null, y0 = null;
    lb.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    lb.addEventListener('touchend', function (e) {
      if (lbZoomed()) return;                                // zoomed: fingers pan/pinch, never swipe-nav
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0; x0 = null;
      if (Math.abs(dx) < 20 && Math.abs(dy) < 20) {          // a tap, check for double-tap to like
        var now = Date.now();
        if (now - lbLastTap < 300) { lbLastTap = 0; lbLike(); }
        else { lbLastTap = now; }
        return;
      }
      if (dy > 80 && Math.abs(dy) > Math.abs(dx)) { closeLightbox(); return; }   // swipe down to dismiss
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        var dir = dx < 0 ? 1 : -1, t = lbIdx + dir;
        if (t < 0 || t >= lbItems.length) lbBounce(dir);   // at an edge, rubber-band
        else lbGo(t);
      }
    }, { passive: true });
    // Swallow touch scrolling so it never chains through to the feed behind the
    // overlay (iOS ignores body{overflow:hidden} for touch). Our swipe gestures
    // read touchstart/touchend only, so blocking touchmove costs us nothing,
    // and it also keeps iOS from hijacking our pinch as a page zoom.
    lb.addEventListener('touchmove', function (e) { if (e.cancelable) e.preventDefault(); }, { passive: false });

    // ---- pinch to zoom + pan (touch), wheel zoom + drag pan (desktop) ----
    var img = lb.querySelector('img');
    var zs = 1, ztx = 0, zty = 0;        // scale + pan
    var pinch0 = null, panLast = null, mDrag = null;
    function zApply(anim) {
      img.style.transition = anim ? 'transform .18s ease' : 'none';
      img.style.transform = zs > 1 ? ('translate(' + ztx + 'px,' + zty + 'px) scale(' + zs + ')') : '';
      lb.classList.toggle('zoomed', zs > 1);
    }
    function zClamp() {                  // edges may reach the center, no further
      var r = img.getBoundingClientRect();
      var mx = Math.max(0, (zs - 1) * (r.width / zs) / 2);
      var my = Math.max(0, (zs - 1) * (r.height / zs) / 2);
      ztx = Math.max(-mx, Math.min(mx, ztx));
      zty = Math.max(-my, Math.min(my, zty));
    }
    function zZoomAt(cx, cy, next) {     // scale while pinning the point under (cx,cy)
      var r = img.getBoundingClientRect();
      var ox = cx - (r.left + r.width / 2), oy = cy - (r.top + r.height / 2);
      var k = next / zs;
      ztx = ox - k * (ox - ztx);
      zty = oy - k * (oy - zty);
      zs = next; zClamp(); zApply(false);
    }
    lbZoomed = function () { return zs > 1.02 || pinch0 !== null; };
    lbZoomReset = function (anim) { zs = 1; ztx = zty = 0; pinch0 = panLast = mDrag = null; zApply(anim); };
    lb.addEventListener('touchstart', function (e) {
      if (e.touches.length === 2) {
        var a = e.touches[0], b = e.touches[1];
        pinch0 = { d: Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY), s: zs };
        panLast = null;
      } else if (e.touches.length === 1 && zs > 1) {
        panLast = { x: e.touches[0].clientX, y: e.touches[0].clientY };
      }
    }, { passive: true });
    lb.addEventListener('touchmove', function (e) {
      if (e.touches.length === 2 && pinch0) {
        var a = e.touches[0], b = e.touches[1];
        var d = Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY);
        zZoomAt((a.clientX + b.clientX) / 2, (a.clientY + b.clientY) / 2,
                Math.max(1, Math.min(4, pinch0.s * (d / pinch0.d))));
      } else if (e.touches.length === 1 && panLast && zs > 1) {
        var t = e.touches[0];
        ztx += t.clientX - panLast.x; zty += t.clientY - panLast.y;
        panLast = { x: t.clientX, y: t.clientY };
        zClamp(); zApply(false);
      }
    }, { passive: true });
    lb.addEventListener('touchend', function (e) {
      if (pinch0 && e.touches.length < 2) { pinch0 = null; if (zs < 1.05) lbZoomReset(true); }
      if (e.touches.length === 0) panLast = null;
    }, { passive: true });
    // desktop: wheel zooms at the cursor, dragging pans while zoomed in
    lb.addEventListener('wheel', function (e) {
      e.preventDefault();
      var next = Math.max(1, Math.min(4, zs * (e.deltaY < 0 ? 1.14 : 1 / 1.14)));
      if (next === zs) return;
      if (next <= 1.02) lbZoomReset(false);
      else zZoomAt(e.clientX, e.clientY, next);
    }, { passive: false });
    img.addEventListener('mousedown', function (e) {
      if (zs > 1) { mDrag = { x: e.clientX, y: e.clientY }; e.preventDefault(); }
    });
    window.addEventListener('mousemove', function (e) {
      if (!mDrag) return;
      ztx += e.clientX - mDrag.x; zty += e.clientY - mDrag.y;
      mDrag = { x: e.clientX, y: e.clientY };
      zClamp(); zApply(false);
    });
    window.addEventListener('mouseup', function () { mDrag = null; });
    return lb;
  }
  /* GIFS ACTUALLY GO FULL SCREEN (web report #52, owner: "gif doesn't work in full screen").
     A Giphy pick is stored as the REMOTE giphy.gif URL -- there is no local file, no _thumb/_disp
     variant and no poster, which is exactly why a GIF is kept out of the immersive swipe deck
     (postIsGiphy: "a tiny gif blown up edge-to-edge looks broken") and out of every grid in SQL
     (Posts::gridMediaSql). So the shared lightbox IS the full-screen view for a GIF -- and it was
     showing it at NATURAL size: `.lightbox img` only CAPS at 94vw/90vh, it never scales anything up.
     A 310x176 meme therefore opened as a 310px island in the middle of a black screen: 26% of the
     width on the reporter's 1186x855 Mac. Measured, not guessed.
     Fit it to the viewport instead: CONTAIN, so the whole frame is visible and nothing is cropped
     (a contained fit crops nothing, so there is deliberately nothing to pan -- the existing
     pinch/wheel zoom still owns intentional magnification). The upscale is capped at 3x natural so
     a low-res GIF reads as full-screen without turning into a 4.5x blur, and only GIFs are touched:
     every other lightbox image keeps its exact previous 1:1-up-to-94vw behaviour. */
  var LB_GIF_MAX_UPSCALE = 3;
  function lbFitGif(img) {
    if (!img) { return; }
    var src = img.currentSrc || img.getAttribute('src') || '';
    if (!/giphy\.com/i.test(src)) { img.style.width = ''; img.style.height = ''; return; }
    var nw = img.naturalWidth, nh = img.naturalHeight;
    if (!nw || !nh) {                                  // dimensions arrive with the bytes
      img.addEventListener('load', function () { lbFitGif(img); }, { once: true });
      return;
    }
    var vw = document.documentElement.clientWidth || window.innerWidth || 360;
    var vh = document.documentElement.clientHeight || window.innerHeight || 640;
    // the same gutters .lightbox already reserves (24px padding + the close button's room)
    var s = Math.min((vw * 0.96 - 16) / nw, (vh * 0.92 - 16) / nh, LB_GIF_MAX_UPSCALE);
    if (!(s > 0)) { return; }
    img.style.width = Math.round(nw * s) + 'px';
    img.style.height = Math.round(nh * s) + 'px';
  }
  function lbRender() {
    var box = lightbox();
    var img = box.querySelector('img');
    img.style.width = ''; img.style.height = '';        // drop the previous item's fit before measuring
    img.src = lbItems[lbIdx] || '';
    lbFitGif(img);
    var prev = box.querySelector('.lb-nav.prev');
    var next = box.querySelector('.lb-nav.next');
    var count = box.querySelector('.lb-count');
    var multi = lbItems.length > 1;
    prev.style.display = next.style.display = multi ? '' : 'none';
    count.style.display = multi ? '' : 'none';
    if (multi) {
      prev.disabled = lbIdx === 0;
      next.disabled = lbIdx === lbItems.length - 1;
      count.textContent = (lbIdx + 1) + ' / ' + lbItems.length;
    }
  }
  function lbGo(i) {
    if (i < 0 || i >= lbItems.length) return;
    lbIdx = i;
    if (lbZoomReset) lbZoomReset(false);   // each photo starts at 1:1
    lbRender();
  }
  function openGallery(items, idx, media) {
    lbItems = items.slice();
    lbIdx = Math.max(0, Math.min(items.length - 1, idx || 0));
    lbMedia = media || null;
    var box = lightbox();
    if (lbZoomReset) lbZoomReset(false);
    lbRender();
    requestAnimationFrame(function () { box.classList.add('show'); });
    lockScroll();
  }
  function closeLightbox() {
    if (!lb) return;
    if (lbZoomReset) lbZoomReset(false);
    lb.classList.remove('show');
    unlockScroll();
  }
  document.addEventListener('keydown', function (e) {
    if (!lb || !lb.classList.contains('show')) return;
    if (e.key === 'Escape') closeLightbox();
    else if (e.key === ' ' || e.code === 'Space') { e.preventDefault(); closeLightbox(); }   // QuickLook parity
    else if (e.key === 'ArrowLeft') lbGo(lbIdx - 1);
    else if (e.key === 'ArrowRight') lbGo(lbIdx + 1);
  });

  /* tap a DM photo -> open it full size in the shared lightbox.
     SINGLE tap opens, DOUBLE tap is the reaction (a heart), TRIPLE tap is the emoji picker --
     the SAME contract the feed and the immersive viewer already have on `.post .media`, and
     deliberately not a third convention invented for DMs.
     ...WHICH MEANS THIS OPEN HAS TO WAIT. Both gestures are document-level click listeners and
     this one is registered FIRST, so on a double tap it used to fire on tap ONE and the photo
     went full-screen before the reaction had happened at all. Measured with real touch on the
     shipped build (headless WebKit-less Chromium, 390x844): the lightbox came up 25-36ms after
     the first finger lifted, the SECOND tap then landed on the lightbox's own veil -- which
     dismisses a single-photo lightbox, QuickLook-style -- so it never reached the message and
     /dm-react NEVER FIRED. The member got a 160ms flash of the photo and no reaction. Reacting
     to a photo in a DM was not awkward, it was impossible.
     THE FIX IS THE ONE THE FEED ALREADY USES, not a new one: defer the single-tap action past
     the double-tap window and let the second tap retire it (`singleTimer` + `_tdblAt` on
     `.post .media`, where the viewer open waits 240ms > its 220ms window and the photo zoom
     waits 330ms for the same reason -- see "ZOOM waits past the double-tap window").
     THE WAIT IS 400ms BECAUSE THE DM REACT WINDOW IS 380ms (`tapT` below), the same +20ms
     margin the feed keeps over its own window. Do not shorten it to feel snappier without
     shortening that window first, and do not shorten THAT: a real double tap measures 310-350ms
     click-to-click (see the DTAP note further down), so 380 already has only 30ms of headroom.
     WHAT IT COSTS: a lone tap on a RECEIVED DM photo now takes ~400ms instead of ~30ms to open.
     That tax is paid ONLY here -- `.msg.me` photos you sent yourself, every other lightbox
     caller (the profile picture, a post's photo gallery), and every non-DM tap open instantly,
     because none of them has a second gesture competing for the same rectangle.
     A genuine double tap pays NOTHING VISIBLE: __rovaDmTapClaim() below is called from the
     second finger DOWN (~140-230ms in, well before that tap's click), so the timer is already
     retired and the lightbox never starts opening. */
  var DM_LB_WAIT = 400;
  var dmLbT = null, dmLbAt = 0;
  /* The DM reaction gesture calling "mine" on this rectangle. Two jobs, in order of how much we
     want to need them: retire the pending open (the normal path, nothing ever paints), and --
     only if a main-thread stall let the 400ms timer fire BEFORE the second tap's click handler
     ran -- close a lightbox this path opened moments ago. The second is the safety net that
     turns a rare stall from "photo stuck open over your reaction" into a brief flash. */
  window.__rovaDmTapClaim = function () {
    if (dmLbT) { clearTimeout(dmLbT); dmLbT = null; }
    if (dmLbAt && Date.now() - dmLbAt < DM_LB_WAIT + 400 && lb && lb.classList.contains('show')) {
      dmLbAt = 0;
      closeLightbox();
    }
  };
  document.addEventListener('click', function (e) {
    var mi = e.target.closest ? e.target.closest('.msg-media img') : null;
    if (!mi) return;
    e.preventDefault();
    var src = mi.currentSrc || mi.src;
    // A RECEIVED message is the only thing the reaction gesture can claim (target() below is
    // `.msg.them[data-mid]`), so it is the only thing that has to wait.
    var them = mi.closest ? mi.closest('.msg.them[data-mid]') : null;
    if (!them || !(+them.getAttribute('data-mid') > 0)) { openGallery([src], 0); return; }
    if (dmLbT) { clearTimeout(dmLbT); }
    dmLbT = setTimeout(function () {
      dmLbT = null;
      dmLbAt = Date.now();
      openGallery([src], 0);
    }, DM_LB_WAIT);
  });

  // tap the big profile picture -> open it in the immersive pfeed (full-screen photo WITH its likes &
  // comments), backed by the hidden avatar post. Falls back to the plain lightbox if that post / the
  // viewer isn't available (guests still get the simple full-size view).
  // A profile photo is either an <img class="avatar"> OR a VIDEO avatar -- a <video> wrapped in
  // .av-vid (the boomerang loop). Both are backed by the SAME hidden avatar post (likes + comments),
  // so both must open. Owner report: on a video avatar the picture was dead to the touch while the
  // little comment badge still worked, because every step of this path selected 'img.avatar' only.
  // The <video> itself is pointer-events:none (rova.css), so the click always lands on .av-vid --
  // and we never touch the element, so the autoplay loop is left running untouched.
  // Monogram avatars (a letter, no media, no avatar post) still return false and stay inert.
  // `.av-vid img` is the same video avatar AFTER the autoplay-blocked fallback has swapped the clip
  // for its still (see the avatar play-guard near the av-defer observer). It is still a real photo
  // backed by the same hidden avatar post, so leaving it out here would make the profile picture dead
  // to the touch on exactly the phones the fallback exists for. It is deliberately NOT `img.avatar`:
  // the WRAPPER carries the .avatar class, so the branch below still finds no `img.avatar` and takes
  // the same path a live <video> takes -- the pfeed album, never the still lightbox.
  function avatarMedia(pfa) {
    return pfa && (pfa.querySelector('img.avatar') || pfa.querySelector('.av-vid video, .av-vid img, video.avatar'));
  }
  function openProfilePhoto(pfa, openComments) {
    if (!pfa) return false;
    if (!avatarMedia(pfa)) return false;         // monogram: nothing to open
    var img = pfa.querySelector('img.avatar');   // photo avatars (video avatars have no <img>)
    var photoPost = pfa.getAttribute('data-photo-post');
    if (photoPost && window.__rovaFeedView) {
      // the profile-photo ALBUM (current photo first, then older ones) -- a self-contained slideshow, so it
      // scrolls only their profile photos (each with its own likes/comments) and closing returns HERE.
      var album = (pfa.getAttribute('data-photo-album') || photoPost).split(',').filter(Boolean);
      // hero-zoom the avatar up into the viewer, the same as tapping a feed photo. IMAGE avatars only:
      // the flight animates a decoded still, and a video avatar has no bitmap to fly (the viewer just
      // fades in, which is what a video post in the feed does anyway).
      // heroExpand, NOT the older heroZoom (owner 2026-08-12: "tapping the picture from the grid...
      // clean zoom... the profile photo... currently just appears"). This call was never migrated when
      // heroExpand replaced heroZoom for grid/feed taps (see the "FULL grid parity" note where
      // __rovaHeroExpand is assigned) -- it kept calling the legacy global, which still exists
      // (window.__rovaHeroZoom = heroZoom, a few hundred lines down) but never received the later
      // quality passes heroExpand did (the predicted-landing-rect start, the live Ken Burns seed),
      // and evidently produces no visible flight at all on a real device for this path. Same
      // call shape the grid already uses: tileRect, src, no live video, srcImg for the Ken Burns
      // read (harmless no-op here -- avatar circles don't carry the gridPan/tlPan animation).
      /* A GATED PHOTO FLIES ONLY ITS SERVER BLUR (2026-10-02, Rob: the blurred avatar "briefly shows in
         the zoom without it being blurred out"). The flight clones the BITMAP, never the CSS, so an
         avatar blurred by CSS alone (.nsfw-cell without .av-sb -- an old cached page) must not fly at
         all. A current page draws a gated avatar as a pre-blurred still (.av-sb) and declares the
         landing as the viewer card's own blurred still (data-photo-src), so the flight is blur to blur. */
      var gatedCss = img && img.classList.contains('nsfw-cell') && !img.classList.contains('av-sb');
      if (img && window.__rovaHeroExpand && img.complete && img.naturalWidth > 0 && !img.closest('.nsfw-gate') && !gatedCss) {
        try {
          /* data-photo-dims (views/profile.php, 2026-08-29): the natural size of the file the viewer
             will PAINT for this avatar post -- the pre-crop original's display variant when one
             exists, the square crop otherwise. The tapped <img> here is always the SQUARE avatar
             variant, so predicting the landing box from ITS naturals flew the hero to a square rect
             and the flight then visibly re-aimed to the portrait one ("stuttery moves and small crop
             animations", owner on @Anita_fdez). Absent/malformed -> undefined -> heroExpand behaves
             exactly as before.
             data-photo-src (round 2, same day, same report: "the flicker shows it zooming into the
             640 then visibly correcting to the 810"): the landed file's URL, so the flight can carry
             the DESTINATION's pixels rather than the square crop's -- fixing the box alone left the
             content swap at handoff visible. Prewarmed on pointerdown below, so by click time it is
             usually already decoded and the hero shows the portrait from its very first frame. */
          var pd, pdm = (pfa.getAttribute('data-photo-dims') || '').match(/^(\d+)x(\d+)$/);
          if (pdm) {
            pd = { w: +pdm[1], h: +pdm[2] };
            var psrc = pfa.getAttribute('data-photo-src') || '';
            if (psrc) { pd.src = psrc; }
            // the shape-correct intermediate (2026-09-12): heroExpand flies it instead of the square
            // crop when it is the largest DECODED bitmap at tap time (see pfaWarmDest's slow-line arm)
            var pmid = pfa.getAttribute('data-photo-mid') || '';
            if (pmid) { pd.mid = pmid; }
          }
          window.__rovaHeroExpand(img.getBoundingClientRect(), img.currentSrc || img.src, null, img, pd);
        } catch (err) {}
      }
      window.__rovaFeedView(album, photoPost, 0, 0, true, !!openComments);   // feedless: no discover paging after the album
      return true;
    }
    if (!img) return false;   // video avatar with no avatar post / no viewer: the still lightbox can't play it
    // the plain lightbox shows the bitmap without the CSS blur: only a server-blurred still may open there
    if (img.classList.contains('nsfw-cell') && !img.classList.contains('av-sb')) return false;
    openGallery([img.currentSrc || img.src], 0);
    return true;
  }
  /* BYTE-WARM THE LANDED PHOTO ON POINTERDOWN (2026-08-29) -- the same trick the grid uses for its
     full-res destination. The avatar-post viewer paints the pre-crop original's display variant
     (data-photo-src), a file the profile page itself never loads, so at click time it is cold and
     the hero either flies stale square pixels or waits. pointerdown precedes click by the length of
     the tap (~80-150ms), which on this ~100KB file is usually the whole fetch+decode -- by the time
     openProfilePhoto() runs, heroExpand's decode-if-ready check finds it complete and flies the
     portrait from frame one. Fire-and-forget; a second pointerdown reuses the same warm object. */
  var pfaWarm = { src: '', img: null, mid: '', midImg: null };
  // heroExpand reads this to decide whether the destination file is DECODED yet -- decoded flies
  // directly, not-yet flies a stand-in and swaps in place. See the predDims block in heroExpand
  // (2026-08-29, the invisible-flight fix). `mid`/`midImg` = the shape-correct intermediate
  // (data-photo-mid, the 480-wide _t480 of the pre-crop original) warmed on a slow line instead.
  window.__rovaPfaWarm = pfaWarm;
  /* ...AND THE POINTERDOWN WARM WAS NOT EARLY ENOUGH (owner 2026-09-12, @societyofme: "clicking this
     profile photo on cold launch loaded in a weird resolution but then it fixed within a second").
     MEASURED (scratchpad/avcold/wk-av.js, fresh context, destination held 600ms as a phone on LTE
     with a CDN miss pays it, 390x844 at DPR 3): the flight flew the 480x480 `_thumb` cover-cropped
     into the 1080x1440 box for the WHOLE open -- 5.27 device px per bitmap px at the landing, on
     screen 650-670ms (Chromium, 39 of 39 sampled frames), the real bitmap arriving ~300ms AFTER the
     flight had landed. pointerdown buys only the tap's own duration (~0-150ms) against a fetch that
     costs 300-900ms on a phone, so the stand-in branch was the NORMAL cold path, not the exception.
     THE PAGE HAS EXACTLY ONE HERO PHOTO AND IT IS THE MOST LIKELY TAP ON IT, so warm it at idle after
     the page's own paint: fetch (priority low, so it queues behind anything the page still wants)
     and DECODE, so that by the time anyone taps, the "cold" open is the warm one. The profile grid
     arrives by XHR after this and its tiles are 3-20KB each, so one ~130KB (median; p90 226KB)
     image at low priority does not gate them -- measured, see the 2026-09-12 note in
     viewer-flight-geometry.md. On a slow line (__rovaNetSlow, the 09-11 gate) the idle warm takes
     the ~60KB shape-correct intermediate instead when the page declares one, and skips otherwise;
     the tap warm below still fetches the real file exactly as before.
     ONE OBJECT PER URL, FETCH + DECODE TOGETHER: pfDecoded() starts decode() once per element+URL and
     stamps the verdict on the element, which is precisely the test heroExpand's direct branch asks --
     so a warm that landed here is one the flight can fly from frame one, on WebKit too, where
     `complete` alone is a promise of bytes and not of a raster. */
  function pfaWarmOne(slot, url, low) {
    var k = slot === 'mid' ? 'mid' : 'src', ki = slot === 'mid' ? 'midImg' : 'img';
    if (!url) { return null; }
    if (pfaWarm[k] === url && pfaWarm[ki]) { return pfaWarm[ki]; }   // already warming/warm: reuse it
    var im = new Image();
    im.decoding = 'async';
    try { if (low && ('fetchPriority' in im)) { im.fetchPriority = 'low'; } } catch (e) {}
    pfaWarm[k] = url; pfaWarm[ki] = im;
    im.addEventListener('load', function () { try { pfDecoded(im); } catch (e) {} }, { once: true });
    // a failed warm must not claim the slot forever: the next intent re-tries instead of flying cold
    im.addEventListener('error', function () { if (pfaWarm[k] === url && pfaWarm[ki] === im) { pfaWarm[k] = ''; pfaWarm[ki] = null; } }, { once: true });
    im.src = url;
    return im;
  }
  function pfaWarmDest(pfa, idle) {
    var s = pfa.getAttribute('data-photo-src') || '', m = pfa.getAttribute('data-photo-mid') || '';
    if (idle) {
      var slow = false;
      try { slow = !!(window.__rovaNetSlow && window.__rovaNetSlow()); } catch (e) {}
      if (slow) { if (m) { pfaWarmOne('mid', m, true); } return; }   // slow line: the small shape-correct file, or nothing
      pfaWarmOne('src', s, true);
      return;
    }
    pfaWarmOne('src', s, false);
  }
  // intent: pointerdown (touch, the earliest signal a tap gives) AND pointerover (a mouse hovering the
  // photo before it clicks -- a head start of the whole approach, not just the press)
  var pfaIntent = function (e) {
    var pfa = e.target.closest ? e.target.closest('.pf-avatar') : null;
    if (!pfa) return;
    pfaWarmDest(pfa, false);
  };
  document.addEventListener('pointerdown', pfaIntent, { passive: true, capture: true });
  document.addEventListener('pointerover', pfaIntent, { passive: true, capture: true });
  // eager: the one hero photo on a profile page, at idle after the page has painted itself
  function pfaIdleWarm() {
    var go = function () {
      try {
        var pfa = document.querySelector('.pf-avatar[data-photo-src]');
        if (pfa && !pfa.closest('.nsfw-gate')) { pfaWarmDest(pfa, true); }
      } catch (e) {}
    };
    if (window.requestIdleCallback) { requestIdleCallback(go, { timeout: 2500 }); } else { setTimeout(go, 700); }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', pfaIdleWarm); } else { pfaIdleWarm(); }
  document.addEventListener('click', function (e) {
    var pfa = e.target.closest ? e.target.closest('.pf-avatar') : null;
    if (!pfa || !avatarMedia(pfa)) return;
    if (openProfilePhoto(pfa)) e.preventDefault();
  });
  // /founders?ref= referrer photo (views/founders_invite.php's .fi-by chip) -> the plain shared
  // lightbox, single-image, QuickLook-style close (owner report: people tap the photo expecting it
  // to enlarge and nothing happens). This is a guest landing page with no post/likes behind the
  // photo, so it takes the same no-`media` fallback openProfilePhoto() takes when there's no avatar
  // post to open into the immersive viewer -- not a new pattern. Only the real <img> is wired; the
  // single-letter monogram fallback (.fi-by-ph) has no photo to enlarge and stays inert.
  // data-full carries a bigger avatar variant than the 40px chip actually displays (same
  // small-thumb-carries-the-big-src convention the grid's own data-full warm already uses --
  // see the pcell data-full reads above) so the enlarged view isn't just the tiny chip blown up.
  document.addEventListener('click', function (e) {
    var fbImg = e.target.closest ? e.target.closest('.fi-by img') : null;
    if (!fbImg) return;
    e.preventDefault();
    openGallery([fbImg.getAttribute('data-full') || fbImg.currentSrc || fbImg.src], 0);
  });
  // The COMMENT badge on the profile photo opens the SAME immersive viewer as tapping the photo (owner
  // call): both land in the viewer, where the back chevron / edge-swipe returns to the profile photo.
  // The LIKE badge is deliberately EXCLUDED — it keeps its own one-tap behavior (members: optimistic inline
  // like via js-react, no navigation; guests: the signup link). Capture phase + stop-immediate so this beats
  // the comment link's navigation (js-comments). Only fires when there's a real avatar post AND the viewer
  // exists; otherwise (monogram avatar, or no avatar post) it bails and default behavior stands.
  // VIDEO avatars go through here too now, so the badge and the photo itself land in the same place.
  document.addEventListener('click', function (e) {
    var badge = e.target.closest && e.target.closest('.pf-photo-badges .pf-badge');
    if (!badge) return;
    // leave the LIKE badge alone (react-btn / inside a js-react form / guest "…to react" link)
    if (badge.classList.contains('react-btn') || badge.closest('.js-react')
        || /\breact\b/i.test(badge.getAttribute('title') || '')) return;
    var wrap = badge.closest('.pf-photo');
    var pfa = wrap && wrap.querySelector('.pf-avatar[data-photo-post]');
    if (!pfa || !avatarMedia(pfa) || !window.__rovaFeedView) return;   // no avatar post/viewer -> default
    e.preventDefault();
    e.stopImmediatePropagation();
    // the COMMENT badge (js-comments) lands in the viewer AND auto-opens its comment sheet; other badges
    // (currently none besides like, which bailed above) just open the photo.
    openProfilePhoto(pfa, badge.classList.contains('js-comments'));
  }, true);

  // Owner report #510: park the green online dot exactly where the cover banner's BOTTOM BORDER crosses the
  // profile avatar's ring outline (it used to sit on the photo's bottom-right corner, jammed against the
  // like/comment badges). Pure CSS can't do it: the header row is align-items:center, so how deep the avatar
  // hangs into the cover shifts with the name block's height (measured 17-27px across live profiles and
  // widths). So measure the real boxes and hand CSS the centre point as --pf-on-x / --pf-on-y.
  // The cover element always paints -- image OR the gold gradient fallback -- so the border, and this point,
  // exist on every profile, banner or not.
  (function () {
    var cover = document.querySelector('.profile-cover');
    var wrap = document.querySelector('.profile-card .pf-avatar .av-on');   // only exists when they're online
    if (!cover || !wrap) return;
    var RING = 4;   // .profile-card .pf-avatar .avatar box-shadow spread (the dark ring), outside the layout box
    function place() {
      var c = cover.getBoundingClientRect(), a = wrap.getBoundingClientRect();
      if (!a.width || !a.height) return;
      var cx = a.width / 2, cy = a.height / 2;
      var r = cx + RING;                                   // radius of the ring OUTLINE, not the photo
      var dy = (c.bottom - a.top) - cy;                    // the border's height, relative to the circle centre
      if (dy < -r) dy = -r; else if (dy > r) dy = r;       // border clear of the circle -> hug the nearest pole
      var dx = Math.sqrt(Math.max(0, r * r - dy * dy));    // right-hand intersection
      wrap.style.setProperty('--pf-on-x', (cx + dx).toFixed(2) + 'px');
      wrap.style.setProperty('--pf-on-y', (cy + dy).toFixed(2) + 'px');
    }
    place();
    // the name block reflows (font swap, long name wrapping, window resize) -> re-measure
    addEventListener('resize', place, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(place).catch(function () {});
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(place);
      ro.observe(wrap);
      var row = wrap.closest('.profile-card') && wrap.closest('.profile-card').firstElementChild;
      if (row) ro.observe(row);
    }
  })();

  // Profile-photo like/comment badges: the like itself is optimistic (js-react), but poll the hidden avatar
  // post's counts so the badges also tick up in near-realtime when OTHER people react. Light: one tiny JSON
  // GET every 12s (paused while the tab is hidden), plus an immediate refresh when the tab regains focus.
  (function () {
    var badges = document.querySelector('.pf-photo-badges[data-post]');
    if (!badges) return;
    var pid = badges.getAttribute('data-post');
    if (!pid) return;
    var cnts = badges.querySelectorAll('.cnt');
    var likeCnt = cnts[0], comCnt = cnts[1], likeBtn = badges.querySelector('.react-btn');
    function setCnt(el, n) {
      if (!el) return;
      n = +n || 0;
      el.textContent = fmtCount(n);
      if (n > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
    }
    var busy = false;
    function poll() {
      if (busy || document.hidden) return;
      busy = true;
      /* THE HAPPENS-BEFORE INSTANT, sampled immediately before the request leaves -- the same test
         engRefresh applies to every card, applied here for the first time. This poll used to paint
         whatever came back, unconditionally, which meant it was not merely late to a like made in the
         viewer: it could actively UNDO one. A batch that leaves after the optimistic paint and is
         answered from a read taken before the write committed carries the old number, and painting it
         ticks the reader's own like back off the chip. `badges.__engAt` is stamped by engBadgeArm on
         both beats (the paint and the settle) and the per-badge holds cover the round trip in
         between, so likes and comments are tested separately and one settling write never freezes the
         other. */
      var sentAt = Date.now();
      fetch('/photo-engage?id=' + encodeURIComponent(pid), { credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (!d || !d.ok) return;
          if (badges.__engAt && badges.__engAt > sentAt) return;   // a local write raced us: leave it alone
          if (!engBadgeHeld('like', pid)) {
            setCnt(likeCnt, d.likes);
            if (likeBtn) {
              likeBtn.setAttribute('data-optcount', String(Math.max(0, +d.likes || 0)));
              likeBtn.classList.toggle('on', !!d.liked);
              /* d.reaction, NOT `d.liked ? 'heart' : ''`. This poll runs every 12s and paints the
                 reader's own state, so while it could only say "heart" it did not merely fail to
                 show a Fire -- it actively walked one back, overwriting data-reaction 12 seconds
                 after the carousel set it and, now that the glyph follows, repainting the emoji as
                 a heart. handle_photo_engage() answers with the code (index.php); `|| ''` keeps a
                 worker still serving the previous index.php on the old, safe behaviour. */
              var pr = d.liked ? (d.reaction || 'heart') : '';
              likeBtn.setAttribute('data-reaction', pr);
              likeBtn.setAttribute('aria-pressed', d.liked ? 'true' : 'false');
              engPhotoGlyph(likeBtn, pr);
            }
          }
          if (!engBadgeHeld('comment', pid)) setCnt(comCnt, d.comments);
        })
        .catch(function () {})
        .then(function () { busy = false; });
    }
    setInterval(poll, 12000);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) poll(); });
  })();

  // burst pinned to the element's ON-SCREEN center via position:fixed -- for targets inside clipping
  // containers (the expanded comment roller's scroll list clips a row-anchored 52px heart to slivers)
  function heartBurstAt(el) {
    var r = el.getBoundingClientRect();
    var h = document.createElement('span');
    h.className = 'heart-pop heart-pop-fixed';
    h.textContent = '♥';
    h.style.left = (r.left + r.width / 2) + 'px';
    h.style.top  = (r.top + r.height / 2) + 'px';
    document.body.appendChild(h);
    h.addEventListener('animationend', function () { h.remove(); });
  }
  /* ---- live sidebar counts (round 163): the reach card refreshes right after the member follows,
     unfollows, posts, or deletes -- debounced so the write lands server-side first. No-op on pages
     (or viewports) without the desktop aside. */
  var _reachT = null;
  function reachRefresh() {
    var stats = document.querySelector('#feed-aside .reach-stats');
    if (!stats) return;
    fetch('/reach-stats', { headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || !d.ok) return;
        var els = stats.querySelectorAll('strong');   // followers, following, posts (markup order)
        var vals = [d.followers, d.following, d.posts];
        for (var i = 0; i < els.length && i < 3; i++) { els[i].textContent = Number(vals[i]).toLocaleString(); }
        var hero = document.querySelector('#feed-aside .reach-hero strong');
        if (hero && typeof d.new7d === 'number') { hero.textContent = Number(d.new7d).toLocaleString(); }
      }).catch(function () {});
  }
  window.__rovaReachRefresh = function () { clearTimeout(_reachT); _reachT = setTimeout(reachRefresh, 600); };

  function heartBurst(media) {
    var h = document.createElement('span');
    h.className = 'heart-pop';
    h.textContent = '♥';
    media.appendChild(h);
    h.addEventListener('animationend', function () { h.remove(); });
  }

  /* ---- Rova double-tap burst (owner 2026-08-28: "Checkout the Instagram double tap to like
     animation. Copy it to Rova but add our own unique animation.") ------------------------------
     The IG grammar, kept: a big heart springs in AT THE TAP POINT with a small random tilt, holds
     ~400ms, then shrinks and FLIES to the post's like disc as the disc lights up. The Rova
     signature, added: the heart wears the brand-gold coin radial (the super-love family, not IG's
     red/orange) and the pop throws off a ring of gold EMBERS that drift outward-and-up and fade.
     Timeline: pop 0-250ms (back-out overshoot ~1.15, tilt +/-8deg fresh per burst) -> hold to
     650ms -> flight 650-900ms (shrink to .25 while translating to the disc, measured AT 650ms
     because the action row sits at different places per surface) -> disc pulse 180ms on arrival.
     ~900ms total. Embers ride pure-CSS keyframes driven by per-particle custom props (--dx/--dy/
     --edelay/--sz), so beyond the two timeouts below there is ZERO per-frame JS and everything the
     compositor sees is transform+opacity. Replaces the old white .heart-pop for the DOUBLE-TAP
     paths only (likeFromMedia): the action-row tap celebration, the comment burst, the gallery and
     the lightbox keep heartBurst, and the hold-to-react lovBurst (lovFrame/lovCommit) is a
     separate, untouched system -- kinship in colour is intended, code entanglement is not.
     prefers-reduced-motion collapses the whole show to a plain fade-in/out heart: no embers, no
     flight (JS branches AND the stylesheet guards, so a missed branch still cannot move). */
  var DTL_MAX = 3, dtlLive = [], dtlSeq = 0;   // concurrency cap: mash-double-taps drop the OLDEST burst
  function dtlGoldHeart(uid) {
    // the gradient id must be unique PER BURST: bursts overlap in the document and url(#...)
    // resolves document-wide, so a shared id would re-bind mid-animation as layers are removed
    return '<svg viewBox="0 0 24 24" aria-hidden="true"><defs>' +
      '<radialGradient id="' + uid + '" cx="34%" cy="28%" r="82%">' +
      '<stop offset="0%" stop-color="#ffe89a"/><stop offset="46%" stop-color="#f5c518"/>' +
      '<stop offset="76%" stop-color="#dfa90f"/><stop offset="100%" stop-color="#b8860b"/>' +
      '</radialGradient></defs><path d="' + HP + '" fill="url(#' + uid + ')"/></svg>';
  }
  function dtlKill(b) {   // a burst is SELF-CONTAINED: element + its timers die together, no shared state
    for (var i = 0; i < b.t.length; i++) { clearTimeout(b.t[i]); }
    if (b.el && b.el.parentNode) { b.el.parentNode.removeChild(b.el); }
    var ix = dtlLive.indexOf(b); if (ix >= 0) { dtlLive.splice(ix, 1); }
  }
  function dtapBurst(media, x, y) {
    var r = null;
    try { r = media.getBoundingClientRect(); } catch (e0) {}
    // a hidden/degenerate source (the lightbox likes through likeFromMedia against media that is
    // covered or display:none) gets the old in-media burst, which is invisible there and harmless
    if (!r || r.width < 4 || r.height < 4) { heartBurst(media); return; }
    // land AT the tap point (the whole point of the IG gesture); clamp into the media box so a
    // rim tap doesn't hang the heart half off the photo. No coords (desktop dblclick edge, older
    // callers) -> media centre, the old behaviour.
    if (x == null || y == null) { x = r.left + r.width / 2; y = r.top + r.height / 2; }
    x = Math.max(r.left + 34, Math.min(r.right - 34, x));
    y = Math.max(r.top + 34, Math.min(r.bottom - 34, y));
    var rm = false;
    try { rm = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches); } catch (e1) {}
    var layer = document.createElement('div');
    layer.className = 'dtl-burst' + (rm ? ' dtl-rm' : '');
    layer.style.left = x + 'px'; layer.style.top = y + 'px';   // position:fixed -> viewport px, valid in the pfeed too
    var heart = document.createElement('span');
    heart.className = 'dtl-heart';
    heart.innerHTML = dtlGoldHeart('dtlg' + (++dtlSeq));
    heart.style.setProperty('--dtl-tilt', (Math.random() * 16 - 8).toFixed(1) + 'deg');   // +/-8deg, randomized per burst
    layer.appendChild(heart);
    if (!rm) {
      /* EMBERS: 8-12 gold sparks, 2-5px (every 4th a 7px tiny heart), bursting radially with an
         upward drift. Built ONCE here as absolutely-positioned children; from then on each is a
         single CSS animation reading its own custom props -- no layout, no per-frame JS. */
      var n = 8 + Math.floor(Math.random() * 5);
      for (var i = 0; i < n; i++) {
        var a = Math.random() * Math.PI * 2, d = 36 + Math.random() * 52;
        var isH = (i % 4) === 3, c = (i % 2) ? '#ffe89a' : '#f5c518';
        var em = document.createElement('i');
        em.className = 'dtl-ember' + (isH ? ' dtl-ember-h' : '');
        em.style.setProperty('--dx', (Math.cos(a) * d).toFixed(1) + 'px');
        // radial, squashed vertically, then pulled UP: outward-and-up, never a symmetric fountain
        em.style.setProperty('--dy', (Math.sin(a) * d * 0.7 - (26 + Math.random() * 34)).toFixed(1) + 'px');
        em.style.setProperty('--edelay', Math.floor(Math.random() * 120) + 'ms');
        em.style.setProperty('--sz', (isH ? 7 : 2 + Math.random() * 3).toFixed(1) + 'px');
        em.style.setProperty('--c', c);
        if (isH) { em.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + HP + '" fill="' + c + '"/></svg>'; }
        layer.appendChild(em);
      }
    }
    document.body.appendChild(layer);
    var b = { el: layer, t: [] };
    dtlLive.push(b);
    if (dtlLive.length > DTL_MAX) { dtlKill(dtlLive[0]); }
    if (rm) { b.t.push(setTimeout(function () { dtlKill(b); }, 950)); return; }   // fade handled by .dtl-rm CSS
    b.t.push(setTimeout(function () {
      /* EXIT, at 650ms (250 pop + 400 hold). The like disc is measured NOW, not at pop time: the
         action row sits at a different place per surface (feed card rail, pfeed vctrl, profile
         row) and the pfeed can be mid-scroll. Members: the .js-react disc. Guests: the /signup
         heart anchor -- same visual seat (the redirect usually wins the race, and that is fine:
         the burst never waits on anything). Chrome hidden or off-screen -> fall back to a
         shrink-and-fade in place with a small upward drift. */
      var post = media.closest ? media.closest('.post') : null;
      var disc = post ? post.querySelector('.js-react .react-btn') : null;
      if (!disc && post) { var gi = post.querySelector('a.act .react-ic'); disc = gi ? gi.closest('a.act') : null; }
      var dr = null, ok = false;
      if (disc) {
        try {
          dr = disc.getBoundingClientRect();
          var cs = getComputedStyle(disc);
          ok = dr.width > 8 && dr.bottom > 0 && dr.right > 0 && dr.top < (window.innerHeight || 0) &&
               dr.left < (window.innerWidth || 0) && cs.visibility !== 'hidden' && parseFloat(cs.opacity || '1') > 0.05;
        } catch (e2) { ok = false; }
      }
      // hand the transform from the pop ANIMATION to a TRANSITION: pin the resting frame (which is
      // also .dtl-heart's stylesheet base, so killing the animation cannot blink), commit it, THEN
      // arm the transition -- otherwise the flight starts from scale(0)
      heart.style.animation = 'none';
      heart.style.transform = 'translate(-50%,-50%) rotate(var(--dtl-tilt)) scale(1)';
      void heart.offsetWidth;
      heart.style.transition = 'transform .25s cubic-bezier(.5,.05,.85,.5), opacity .25s ease-in';
      if (ok) {
        var dx = (dr.left + dr.width / 2) - x, dy = (dr.top + dr.height / 2) - y;
        heart.style.transform = 'translate(calc(-50% + ' + dx.toFixed(1) + 'px), calc(-50% + ' + dy.toFixed(1) + 'px)) rotate(0deg) scale(.25)';
        heart.style.opacity = '.85';
        b.t.push(setTimeout(function () {
          // ARRIVAL: the disc pops (1 -> 1.18 -> 1, 180ms). The optimistic paint itself already
          // landed via submitReact -- this is the "your like arrived" punctuation on top of it.
          if (disc && disc.classList) {
            disc.classList.remove('dtl-disc-pop'); void disc.offsetWidth; disc.classList.add('dtl-disc-pop');
            setTimeout(function () { disc.classList.remove('dtl-disc-pop'); }, 260);
          }
          dtlKill(b);
        }, 255));
      } else {
        heart.style.transform = 'translate(-50%, calc(-50% - 30px)) rotate(0deg) scale(.3)';
        heart.style.opacity = '0';
        b.t.push(setTimeout(function () { dtlKill(b); }, 300));
      }
    }, 650));
    b.t.push(setTimeout(function () { dtlKill(b); }, 2000));   // absolute backstop: nothing outlives 2s
  }

  /* ---- comment engagement: reactions + replies -------------------------- */
  function cFan(fan, myr) {
    fan = fan || [];
    // same shape as the post fan: the viewer's own emoji centred, other emojis behind
    var others = fan.filter(function (c) { return c !== 'heart'; });
    if (myr && myr !== 'heart' && others.indexOf(myr) < 0) { others.unshift(myr); }
    if (myr && myr !== 'heart' && fan.indexOf('heart') >= 0) { others.push('heart'); }
    return buildFan(!!myr, others, myr);
  }
  function commentActsHtml(c, isReply, canReply) {
    var f = cFan(c.fan, c.my_reaction);
    // edit = author or admin; delete = author, admin, OR the owner of the post (c.del covers all)
    var mod = '';
    if (c.mine || isAdmin) { mod += '<button class="cmod js-cedit" type="button" data-comment="' + c.id + '">Edit</button>'; }
    if (c.del || c.mine || isAdmin) { mod += '<button class="cmod js-cdel" type="button" data-comment="' + c.id + '">Delete</button>'; }
    // Report: signed-in, never your own. The app has had this on CommentRow all along; the web
    // had no way to report a comment at all until 2026-08-09. Same .js-report handler and same
    // reason picker as the post/profile menus -- the server gate is Moderation::reportComment().
    if (c.id && !c.mine && !isGuest()) {
      mod += '<button class="cmod js-report" type="button" data-type="comment" data-id="' + c.id + '">Report</button>';
    }
    return '<div class="cacts">' +
      '<button class="clike' + (c.my_reaction ? ' on' : '') + '" type="button" data-comment="' + c.id + '"' +
      ' data-reaction="' + escHtml(c.my_reaction || '') + '" aria-label="React to this comment"' +
      ' aria-haspopup="true" aria-keyshortcuts="ArrowUp">' +
      '<span class="react-ic' + (f.n > 1 ? ' fan' : '') + '">' + f.html + '</span>' +
      '<span class="cnt"' + (c.like_count > 0 ? '' : ' hidden') + '>' + fmtCount(c.like_count || 0) + '</span></button>' +
      (canReply ? '<button class="creply" type="button" data-comment="' + c.id + '"' +   // #8: replies are replyable too (server flattens to root + pings this author)
        ' data-name="' + escHtml(c.display_name || c.username || '') + '">Reply</button>' : '') +
      mod +
      '</div>';
  }
  function applyCReact(btn, res) {
    if (!btn || !res) return;
    btn.classList.toggle('on', !!res.reaction);
    btn.setAttribute('data-reaction', res.reaction || '');
    var ic = btn.querySelector('.react-ic');
    if (ic) {
      var f = cFan(res.fan, res.reaction);
      ic.innerHTML = f.html;
      ic.classList.toggle('fan', f.n > 1);
    }
    var cnt = btn.querySelector('.cnt');
    // Every comment row badges at >0, roller rows included. Roller rows used to hide a lone
    // "1" (owner, 2026-07-31: "not sure why I did that, it's not optimal") -- the first like
    // is the one worth showing, and hiding it made a liked comment look unliked.
    if (cnt) { cnt.textContent = fmtCount(res.count); cnt.hidden = !(+res.count); }
    if (typeof res.count !== 'undefined') btn.setAttribute('data-optcount', String(+res.count || 0));
  }

  /* THE COMMENT HEART SURVIVES A REOPEN (2026-10-06, Rob's mom, iPhone Safari, the post's comment sheet: "I keep
     putting a heart on what Terrianne said... every time I click on the heart and then I go back it wasn't clicked";
     it took 4 tries). The SERVER had it from the first tap: her comment_likes row is 00:08:57Z and all five of her
     POST /comment-like answered 200 {reaction:"heart"} -- every later tap sent state=on, i.e. the heart she tapped
     was drawn UNLIT each time. What lost it was the sheet's THREAD CACHE (crThreads, v5): an open is seeded
     synchronously from the /comments JSON the card prefetched; a like never touched that JSON; the live poll answers
     {unchanged} for a like (likes do not move Comments::threadRev, by design) and only refreshed the stale entry's
     age; and crMergeRows never re-applied a kept row's reaction. So every reopen (a close, the 30s idle fold, a
     scroll-away) painted the pre-like heart for up to 10 minutes. Rig: scratchpad momc/heart.js (WebKit):
     like -> close -> reopen = unlit, re-tap = a state=on no-op -- her log, line for line.
     NOW: every reaction this page makes is noted here (comment id -> state, and when it SETTLED). Every /comments
     response is stamped with when its fetch STARTED; one that started before a reaction settled cannot speak for that
     comment and gets the noted state laid over it (cReactOverlay); every cached thread is patched the moment the
     reaction is made and again when it settles; and the sheet's merge reconciles each kept row's heart from that data
     (crSyncReact) unless a request for that heart is still in flight. A response that started AFTER the reaction
     settled is the server's truth (another device may have changed it since) and wins. */
  var cReactLocal = Object.create(null);
  var C_REACT_KEEP_MS = 3600000;   // a page's own taps; an hour outlives every cached thread (CR_SEED_MAX_AGE 10 min)
  function cReactNote(cid, st, settled) {
    if (!cid || !st) return;
    var now = Date.now();
    cReactLocal[String(cid)] = { reaction: st.reaction || null, count: Math.max(0, +st.count || 0),
      fan: (st.fan || []).slice(), settled: settled ? now : 0, at: now };
    for (var k in cReactLocal) { if (now - cReactLocal[k].at > C_REACT_KEEP_MS) delete cReactLocal[k]; }
    if (typeof window.__rovaCrThreadReact === 'function') { try { window.__rovaCrThreadReact(); } catch (e) {} }
  }
  // lay the page's own reactions over a /comments payload whose fetch started at t0 (0 = a cached thread: always)
  function cReactOverlay(comments, t0) {
    var any = false, k;
    for (k in cReactLocal) { any = true; break; }
    if (!any || !comments || !comments.length) return;
    (function walk(a) {
      for (var i = 0; i < a.length; i++) {
        var c = a[i], e = c ? cReactLocal[String(c.id)] : null;
        if (e && (!e.settled || !t0 || t0 < e.settled)) { c.my_reaction = e.reaction; c.like_count = e.count; c.fan = e.fan.slice(); }
        if (c && c.replies && c.replies.length) walk(c.replies);
      }
    })(comments);
  }

  // Optimistic comment reaction: paint the expected result instantly, then let
  // the server reconcile; roll back with a toast if the request dies. (Helpers
  // live next to submitReact -- function declarations hoist across this scope.)
  //
  // `how` names WHICH CONTROL was used, exactly as in submitReact:
  //   'button'  the .clike heart. Lit for ANY reaction, so a press means on/off and never
  //             "make it a heart" -- `state=on` keeps a deliberately chosen fire.
  //   'ensure'  the comment double-tap. Enthusiasm: it may only ever turn a reaction ON.
  //   'pick'    the reaction fan. Exactly the named emoji, or off if it is already showing.
  // INTENT, NOT INVERSION (2026-08-05): the END STATE goes on the wire, so a comment row rendered
  // before the reader reacted on another device can no longer un-react when tapped.
  function submitCReact(btn, reaction, how) {
    var prev = { reaction: btn.getAttribute('data-reaction') || null, count: optCount(btn), fan: fanOthersOf(btn) };
    var state = how === 'ensure' ? 'on'
      : how === 'button' ? (prev.reaction ? 'off' : 'on')
      : (prev.reaction === reaction ? 'off' : 'set');
    // paint what THAT branch will do: 'on' mirrors forceHeart (keeps a chosen emoji), 'set' and
    // 'off' mirror setReaction/clear. Same mapping submitReact uses, same nextReactState.
    var next = nextReactState(prev, reaction, state);
    var fan = prev.fan.filter(function (c) { return !(c === prev.reaction && next.reaction !== prev.reaction); });
    applyCReact(btn, { reaction: next.reaction, count: next.count, fan: fan });
    var q = btn._rxq = (btn._rxq || 0) + 1;
    var cid = btn.getAttribute('data-comment');
    btn._rxBusy = q;                                                          // a merge never repaints a heart in flight
    cReactNote(cid, { reaction: next.reaction, count: next.count, fan: fan }, false);   // cached threads see it now
    postJson('/comment-like', { comment_id: cid, reaction: reaction, state: state })
      .then(function (res) {
        if (btn._rxq !== q) return;
        btn._rxBusy = 0;
        if (res && res.ok) { applyCReact(btn, res); cReactNote(cid, res, true); return; }
        applyCReact(btn, { reaction: prev.reaction, count: prev.count, fan: prev.fan });   // server said no
        cReactNote(cid, prev, true);
        if (res && res.error) toast(res.error);
      })
      .catch(function (err) {
        if (!err || err.message === 'reauth') return;
        if (btn._rxq === q) {
          btn._rxBusy = 0;
          applyCReact(btn, { reaction: prev.reaction, count: prev.count, fan: prev.fan });
          cReactNote(cid, prev, true);
          toast('Couldn’t save that reaction, check your connection');
        }
      });
  }
  function replyFormFor(el) {
    var panel = el.closest('.comment-panel');
    if (panel) return panel.querySelector('.cpanel-form');
    var g = el.closest('.gal');
    if (g) return g.querySelector('.gal-cform');
    return document.querySelector('form.js-comment');
  }
  function setReplyState(form, parentId, name) {
    if (!form) return;
    var inp = form.querySelector('.js-parent');
    var chip = form.querySelector('.reply-chip');
    if (!inp || !chip) return;
    inp.value = parentId ? String(parentId) : '';
    /* "REPLYING TO" WHERE THE PHONE CANNOT HIDE IT (2026-10-06, Rob's mom: "I couldn't see where it said that I
       was replying to Terrianne. It's a nightmare because it's so tight"). Her phone shows 365x648 CSS px; with the
       keys and Safari 26's floating bars up the band left for the page is ~200px, and the chip -- 12.5px text riding
       ABOVE the field -- is the first thing that band cuts off (she started typing "@Terri..." into the comment to
       say who she meant). The one thing iOS ALWAYS keeps on screen is the focused field itself, so the field now
       says it too: its placeholder becomes "Reply to <name>…" (the original comes back on cancel / after a send).
       The chip stays, bigger and bolder, with a 44px x (rova.css "THE REPLY CHIP"). No @handle is prefilled: the
       app shows the same "Replying to <name> ✕" without one, and an @mention would ping the comment's author twice
       (the reply ping + the mention ping). */
    var field = form.querySelector('textarea, input[name="body"], .cpanel-input');
    if (field && !field.hasAttribute('data-ph0')) { field.setAttribute('data-ph0', field.getAttribute('placeholder') || ''); }
    if (parentId) {
      var txt = chip.querySelector('.reply-chip-txt');
      txt.textContent = 'Replying to ';
      var who = document.createElement('b');
      who.textContent = name || 'this comment';
      txt.appendChild(who);
      chip.hidden = false;
      chip.setAttribute('role', 'status');
      if (field) { field.setAttribute('placeholder', name ? 'Reply to ' + name + '…' : 'Write a reply…'); }
    } else {
      chip.hidden = true;
      if (field && field.hasAttribute('data-ph0')) { field.setAttribute('placeholder', field.getAttribute('data-ph0')); }
    }
    // The comment sheet animates to an EXPLICIT measured height -- the chip appearing/leaving grows/shrinks
    // the form AFTER that measurement, so the input row spilled past the sheet's bottom edge (its padding
    // "lost"). Re-measure whenever the chip toggles -- and (2026-10-06) BEFORE the focus, so the keyboard's
    // reveal measures the sheet with the chip already in it, not a box that grows under it a moment later.
    var cp = form.closest('.comment-panel, .croller-panel');
    if (cp && cp._size) { cp._size(); }
    if (parentId && field) { field.focus(); }
  }
  document.addEventListener('click', function (e) {
    var x = e.target.closest ? e.target.closest('.reply-chip-x') : null;
    if (x) { setReplyState(x.closest('form'), 0, ''); return; }
    var rep = e.target.closest ? e.target.closest('.creply') : null;
    if (rep) {
      setReplyState(replyFormFor(rep), rep.getAttribute('data-comment'), rep.getAttribute('data-name'));
      return;
    }
  });
  // comment moderation: delete / edit (author or admin; buttons only render for them)
  document.addEventListener('click', function (e) {
    var del = e.target.closest ? e.target.closest('.js-cdel') : null;
    if (del) {
      e.preventDefault();
      if (busyIs(del)) return;
      if (!window.confirm('Delete this comment?')) return;
      var cid = del.getAttribute('data-comment');
      var rollerRow = del.closest('.croller-panel .cx-row');   // expanded roller: its panel + count update
      var rollerPanel = del.closest('.croller-panel');
      // WHICH POST loses a comment, worked out BEFORE the request because the rows this reads from
      // are about to be removed. The delete button appears on four surfaces and only one of them
      // sits inside the post card: the roller sheet knows its post from the button that opened it,
      // the gallery lightbox from the marker renderPanel leaves on it, and the permalink's thread
      // is a sibling of the card rather than a child, so it falls back to the page's own post.
      var galRoot   = del.closest('.gal');
      var permaCard = del.closest('#comment-list, #comment-search-results')
        ? document.querySelector('.layout-main > .post, [data-pfeed-open] > .post') : null;
      var delPost = (rollerPanel && rollerPanel._btn && rollerPanel._btn.getAttribute('data-post'))
                 || (galRoot && galRoot.getAttribute('data-gal-post'))
                 || permaCard
                 || del.closest('.post');
      // busyUntil: the Delete word dims under a spinner for the flight (it read as dead on a slow
      // link), and the 15s deadline turns a dead cell into the catch's toast instead of silence.
      busyUntil(del, postJson('/comment/delete', { comment_id: cid }, 15000).then(function (res) {
        if (!res || !res.ok) { toast('Could not delete'); return; }
        // HOW MANY rows went. comments.parent_id is `ON DELETE CASCADE`, so deleting a top-level
        // comment took its replies with it -- a flat -1 would undercount and the next poll would
        // yank the badge back down. The endpoint returns no count, so the honest number is the one
        // the DOM can see: this comment plus the replies that came off screen with it.
        var gone = 0;
        var wrap = document.querySelector('.comment-replies[data-parent="' + cid + '"]');
        if (wrap) { gone += wrap.querySelectorAll('.comment[data-comment]').length; wrap.remove(); }
        var node = document.querySelector('.comment[data-comment="' + cid + '"]'); if (node) { gone++; node.remove(); }
        // The expanded roller row lives in the comment sheet, not a .comment node, and its replies
        // are FLAT siblings immediately after it (the same rule the optimistic insert uses). They
        // used to be left behind after the parent was cascade-deleted, so the sheet and the badge
        // disagreed until the panel was closed.
        var rgone = 0;
        Array.prototype.forEach.call(document.querySelectorAll('.croller-panel .cx-row[data-comment="' + cid + '"]'), function (r) {
          if (!r.classList.contains('cx-reply-row')) {
            var sib = r.nextElementSibling;
            while (sib && sib.classList.contains('cx-reply-row')) {
              var nx = sib.nextElementSibling; sib.remove(); rgone++; sib = nx;
            }
          }
          r.remove(); rgone++;
        });
        // the same comment can be on screen in both list styles at once, so take the larger of the
        // two counts rather than their sum; at minimum the server removed the one row we asked for
        gone = Math.max(gone, rgone, 1);
        // Server-confirmed, so paint and stamp without a hold. This moves every view at once --
        // the card badge on each copy, the permalink's "N Comments" header (which had no writer at
        // all on this path and stayed wrong until a reload) and the gallery summary.
        engCommentApplied(delPost, -gone);
        /* THE LIT COMMENT BUTTON comes down with it -- but only when the server says this was
           the caller's LAST comment on the post. /comment/delete answers viewer_commented (an
           EXISTS over the caller's own remaining rows, cascade-deleted replies included), so
           deleting one of several of your comments keeps the glow, and an admin/post-owner
           deleting somebody ELSE's comment leaves their own state exactly as it was. Guarded
           on presence: an older worker mid-deploy answers {ok:true} alone, and repainting
           nothing is the right way to be wrong (same rule engApply follows). */
        if (typeof res.viewer_commented !== 'undefined') engCommentedMark(delPost, !!res.viewer_commented);
        if (rollerPanel && rollerPanel._size) rollerPanel._size();   // re-fit the sheet height
        toast('Comment deleted');
      }).catch(function (err) {
        // was an empty catch: a failed delete looked exactly like a successful one minus the row
        // vanishing -- on a dead cell, indistinguishable from "tap did nothing".
        if (err && err.message === 'reauth') return;
        toast('Couldn’t delete, check your connection');
      }));
      return;
    }
    var ed = e.target.closest ? e.target.closest('.js-cedit') : null;
    if (ed) {
      e.preventDefault();
      var cid2 = ed.getAttribute('data-comment');
      // the row the button LIVES in first (works in the expanded roller's .cx-row markup too),
      // else the classic comment-list node
      var node2 = (ed.closest && ed.closest('.cx-row[data-comment="' + cid2 + '"]'))
               || document.querySelector('.comment[data-comment="' + cid2 + '"]');
      if (!node2 || node2.querySelector('.cedit-box')) return;
      var textEl = node2.querySelector('.ctext, .cr-text'); if (!textEl) return;
      var box = document.createElement('div'); box.className = 'cedit-box';
      box.innerHTML = '<textarea class="input cedit-input" maxlength="1000"></textarea>' +
        '<div class="cedit-btns"><button class="btn sm gold js-cedit-save" type="button">Save</button>' +
        '<button class="btn sm ghost js-cedit-cancel" type="button">Cancel</button></div>';
      textEl.style.display = 'none';
      textEl.parentNode.insertBefore(box, textEl.nextSibling);
      var ta = box.querySelector('textarea'); ta.value = textEl.textContent; ta.focus();
      function done() { box.remove(); textEl.style.display = ''; }
      box.querySelector('.js-cedit-cancel').addEventListener('click', done);
      box.querySelector('.js-cedit-save').addEventListener('click', function (ev) {
        var save = ev.currentTarget;
        if (busyIs(save)) return;
        var val = ta.value.trim(); if (!val) return;
        // Save spins for the flight; the textarea (and the member's edit) stays put either way.
        busyUntil(save, postJson('/comment/edit', { comment_id: cid2, body: val }, 15000).then(function (res) {
          if (res && res.ok) {
            /* THE GIF IS NOT IN `body`. Since migration 0098 a comment's Giphy URL lives in its own
               column, so /comment/edit answers with the TEXT in `body` and the image separately in
               `gif` (+ `gif_w`/`gif_h`, 0133). Painting `body` alone -- which is what this did until
               2026-08-08 -- silently DELETED the GIF from the DOM of a comment that still had one;
               the row was untouched in the database, so a reload brought it back and it read as a
               ghost. Rebuild the same string the server renders, through the same helper the panels
               use, so an edited comment and a reloaded one are byte-identical.
                 - res.gif absent  => emit no <img>. That is a comment that has no GIF, and (since
                   the innerHTML is replaced wholesale) it is also how a GIF that has GONE leaves.
                 - dimensions absent => emit NO width/height. Comments::edit nulls the pair the
                   moment the url changes, because a SWAP makes the stored numbers describe the old
                   image; gifImgHtml's both-or-neither rule turns that into the pre-0133 markup,
                   which is correct as soon as the bytes land rather than wrong forever. */
            var editedHtml = res.body || '';
            if (res.gif) { editedHtml += (editedHtml ? ' ' : '') + gifImgHtml(res.gif, res.gif_w, res.gif_h); }
            // the same comment can be on screen twice (permalink list + expanded roller): update every copy
            Array.prototype.forEach.call(document.querySelectorAll(
              '.comment[data-comment="' + cid2 + '"] .ctext, .cx-row[data-comment="' + cid2 + '"] .cr-text'
            ), function (t) { t.innerHTML = editedHtml; });
            if (res.edited) {
              // append the "Edited" label to every copy's timestamp, once (server applied the grace window)
              Array.prototype.forEach.call(document.querySelectorAll(
                '.comment[data-comment="' + cid2 + '"] .chead .meta, .cx-row[data-comment="' + cid2 + '"] .cr-time'
              ), function (meta) {
                if (meta.querySelector('.cmt-edited')) return;
                var tag = document.createElement('span');
                tag.className = 'cmt-edited';
                tag.textContent = 'Edited';
                meta.appendChild(document.createTextNode(' · '));
                meta.appendChild(tag);
              });
            }
            done(); toast('Comment updated');
          }
          else toast('Could not save');
        }).catch(function (err) {
          if (err && err.message === 'reauth') return;
          toast('Couldn’t save, check your connection');   // was silent; the edit box stays open with the text intact
        }));
      });
      return;
    }
  });

  // heart taps on a comment: tap toggles, a quick third tap opens the picker
  var cTaps = 0, cTimer = null, cBtnLast = null;
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('.clike') : null;
    if (!b) return;
    e.preventDefault();
    // a long press already committed this one (see the carousel's rxSwallowUntil)
    if (Date.now() < rxSwallowUntil) { rxSwallowUntil = 0; return; }
    if (rxS && rxS.open && rxS.sticky) { rxDisarm(); return; }
    if (cBtnLast !== b) { cTaps = 0; cBtnLast = b; }
    cTaps++;
    clearTimeout(cTimer);
    cTimer = setTimeout(function () { cTaps = 0; }, 450);
    if (cTaps >= 3) { cTaps = 0; if (rxArm(b, 0, 0, 'touch')) { rxOpen(true); } return; }
    if (cTaps > 1) return;   // taps 2+ just count toward the picker (no like/unlike flicker)
    var ic = b.querySelector('.react-ic');
    if (ic) { ic.classList.remove('pop'); void ic.offsetWidth; ic.classList.add('pop'); }
    submitCReact(b, 'heart', 'button');   // optimistic: paints now, server reconciles
  });

  // Double-tap a comment to like it (heart burst + ♥ toggle, only ever likes, like the feed's media) --
  // works on the expanded roller's rows AND on regular comment rows/text everywhere comments render
  // (timeline, permalink, gallery). Single taps do nothing -- comments show in full already.
  var cxTaps = 0, cxLast = null, cxTimer = null;
  document.addEventListener('click', function (e) {
    var row = e.target.closest ? e.target.closest('.croller-panel .cx-row, .comment') : null;
    // interactive bits handle themselves; never hijack taps on links, buttons, or an open edit box
    if (!row || (e.target.closest && e.target.closest('.clike, a, .creply, .cmod, .cedit-box, button, input, textarea'))) return;
    if (cxLast !== row) { cxTaps = 0; cxLast = row; }
    cxTaps++;
    clearTimeout(cxTimer);
    cxTimer = setTimeout(function () { cxTaps = 0; }, 320);
    if (cxTaps < 2) return;
    cxTaps = 0;                                   // second tap within the window = double-tap like
    heartBurstAt(row);                            // fixed-position: the roller's scroll list clips an in-row burst
    var clike = row.querySelector('.clike');   // comments never nest in the DOM (replies are siblings), so this is the row's own
    if (clike && !clike.classList.contains('on')) {
      var ic = clike.querySelector('.react-ic'); if (ic) { ic.classList.remove('pop'); void ic.offsetWidth; ic.classList.add('pop'); }
      // 'ensure': a double-tap is enthusiasm and must never un-react, even if the `.on` test
      // above was reading a stale row
      submitCReact(clike, 'heart', 'ensure');
    }
  });

  /* ---- profile @ tab: LIVE like + reply on comment rows -----------------
     The rows are DIVs with data-href (a form can't nest in an <a>); plain clicks
     navigate to the post, the like button and inline reply form act in place. */
  document.addEventListener('click', function (e) {
    var lb = e.target.closest ? e.target.closest('.at-clike') : null;
    if (lb) {
      e.preventDefault(); e.stopPropagation();
      var on = lb.classList.toggle('on');                       // optimistic flip
      var c = lb.querySelector('.cnt');
      var n = parseInt((c.textContent || '0').replace(/[^\d]/g, ''), 10) || 0;
      c.textContent = (on ? n + 1 : Math.max(0, n - 1)) || '';
      // INTENT, not inversion (2026-08-05). `on` is the state the class list was just flipped TO,
      // i.e. exactly the end state this reader asked for, so a stale row cannot un-react on a
      // click meant to react. 'on' rather than 'set' so a chosen emoji is kept, matching the
      // .clike heart -- this row draws a plain heart but the underlying reaction may be anything.
      postJson('/comment-like', { comment_id: lb.getAttribute('data-comment'), reaction: 'heart', state: on ? 'on' : 'off' })
        .then(function (r) {
          if (r && typeof r.count !== 'undefined') {
            c.textContent = r.count || ''; lb.classList.toggle('on', !!r.reaction);
            cReactNote(lb.getAttribute('data-comment'), r, true);   // a sheet opened later on this page agrees
          }
        }).catch(function (err) {
          if (!err || err.message === 'reauth') return;
          // dead request: put the flip back
          lb.classList.toggle('on', !on);
          c.textContent = n || '';
          toast('Couldn’t save that like, check your connection');
        });
      return;
    }
    var rb = e.target.closest ? e.target.closest('.at-replyb') : null;
    if (rb) {
      e.preventDefault(); e.stopPropagation();
      var card0 = rb.closest('.at-item');
      var f0 = card0 && card0.querySelector('.at-reply');
      if (f0) { f0.hidden = !f0.hidden; if (!f0.hidden) { var inp = f0.querySelector('input[name="body"]'); inp && inp.focus(); } }
      return;
    }
    if (e.target.closest && e.target.closest('.at-reply')) { e.stopPropagation(); return; }
    var card = e.target.closest ? e.target.closest('.at-item[data-href]') : null;
    if (card && !(e.target.closest && e.target.closest('a, button, form, input'))) {
      location.href = card.getAttribute('data-href');
    }
  });
  /* ---- admin "Back up now": fire the detached backup, stay responsive ---- */
  document.addEventListener('submit', function (e) {
    var f = e.target.closest ? e.target.closest('form.js-backup-now') : null;
    if (!f) return;
    e.preventDefault();
    var btn = f.querySelector('button[type="submit"]');
    if (btn && btn.disabled) return;
    if (btn) { btn.disabled = true; btn._t = btn.textContent; btn.textContent = 'Starting…'; }
    postJson('/admin/backup-now', {}).then(function (r) {
      if (r && r.ok) {
        if (btn) btn.textContent = 'Running…';                 // stays disabled: the row updates on next load
        toast(r.message || 'Backup started.');
        setTimeout(function () { if (btn) { btn.disabled = false; btn.textContent = btn._t || 'Back up now'; } }, 120000);
      } else {
        if (btn) { btn.disabled = false; btn.textContent = btn._t || 'Back up now'; }
        toast((r && r.error) || 'Could not start the backup.');
      }
    }).catch(function () {
      if (btn) { btn.disabled = false; btn.textContent = btn._t || 'Back up now'; }
      toast('Could not start the backup.');
    });
  });

  // ECHO the just-sent @ tab reply into its card (owner bug 2026-08-29: the POST landed -- DB row,
  // notification, permalink all fine -- but the card showed nothing, which reads as a silent drop).
  // Same builders the permalink echo uses (jsAvatar/escHtml/bodyWithGif, hoisted across this scope),
  // wrapped in the thread chrome the permalink uses for replies (.comment-replies indent + border).
  // The row is display-only on this surface -- no .cacts: those buttons' delegated handlers assume
  // permalink furniture (setReplyState's form.js-comment, the edit box) that this page doesn't have.
  // Since 2026-08-30 the server renders the same strip (Posts::atFeed -> Comments::directReplies,
  // drawn by views/_at_items.php with this exact wrapper + row markup), so a reload keeps the
  // thread; this echo covers the seconds before one, and the data-comment guard below keeps the
  // two renderers from ever double-drawing one reply.
  function atEchoReply(f, c) {
    if (!c || !c.id) { return; }
    var card = f.closest ? f.closest('.at-item') : null;
    if (!card) { return; }
    // a double-submit answers both sends with the SAME comment id (server de-dupes): render once
    if (card.querySelector('.comment[data-comment="' + c.id + '"]')) { return; }
    var wrap = card.querySelector('.at-reply-thread');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'comment-replies at-reply-thread';
      f.parentNode.insertBefore(wrap, f);          // under the acts row, above the (hidden) form
    }
    var node = document.createElement('div');
    node.className = 'comment fade-in';
    node.setAttribute('data-comment', c.id);
    node.innerHTML =
      '<a href="/@' + encodeURIComponent(c.username) + '">' + jsAvatar(c) + '</a>' +
      '<div class="cbody"><div class="chead">' +
        '<a class="name" href="/@' + encodeURIComponent(c.username) + '">' + escHtml(c.display_name) + '</a>' +
        '<span class="meta">@' + escHtml(c.username) + ' · ' + escHtml(c.ago) + '</span>' +
      '</div><div class="ctext">' + bodyWithGif(c.body, c.gif_w, c.gif_h) + '</div></div>';
    // above the "View all N replies" link when the server rendered one (null ref = plain append)
    wrap.insertBefore(node, wrap.querySelector('.at-replies-all'));
  }

  document.addEventListener('submit', function (e) {
    var f = e.target.closest ? e.target.closest('form.at-reply') : null;
    if (!f) return;
    e.preventDefault(); e.stopPropagation();
    var input = f.querySelector('input[name="body"]');
    var body = (input && input.value || '').trim();
    if (!body) return;
    // optimistic: clear + toast now; the text comes back if the send dies
    input.value = ''; f.hidden = true; toast('Reply posted 💬');
    var restoreReply = function (msg) {
      f.hidden = false;
      if (!input.value) input.value = body;
      toast(msg || 'Could not post that reply.');
    };
    // Same optimistic +1 as every other comment surface. Usually a no-op for the badge -- the
    // notifications page rarely has the post's card on it -- but it costs nothing and it is what
    // makes the at-reply behave like the rest wherever the card IS on screen.
    var settle = engCommentBump(f.getAttribute('data-post'), 1);
    postJson('/comment', { post_id: f.getAttribute('data-post'), parent_id: f.getAttribute('data-parent'), body: body })
      .then(function (r) {
        if (!r || r.error) { settle(false); restoreReply(r && r.error); }
        else { settle(true); atEchoReply(f, r.comment); }
      })
      .catch(function (err) {
        settle(false);   // always, including reauth: an unreleased hold would freeze the badge
        if (err && err.message === 'reauth') return;
        restoreReply('Couldn’t post that reply, check your connection');
      });
  });

  /* ---- "invite a friend = 7 free days" nudge: dismiss = snooze 10 days ------
     Rendered for eligible members (trial ending / lapsed); dismissing snoozes it for 10 days so the
     reminder can never turn into a nag.
     2026-09-30 (load stability, Rob: "a small bounce as the elements load in"): the SERVER decides
     visibility now (lib/view.php reads the rova_refnudge_until cookie), so the banner is in place
     from the first paint. It used to be rendered hidden and revealed HERE, after first paint, which
     pushed the ring, the tabs and every card down ~120px on each load. This block owns the tap (hide,
     and write the snooze to BOTH the cookie the server reads and the old localStorage key) plus a
     one-time migration: a snooze that only lives in localStorage (written before the cookie existed)
     is honoured by hiding now and copying it into the cookie, so the next load is right server-side. */
  (function () {
    var n = document.querySelector('.ref-nudge');
    if (!n) return;
    var KEY = 'rova_refnudge_until', until = 0;
    function snoozeCookie(t) {
      try {
        document.cookie = KEY + '=' + t + '; path=/; max-age=' + Math.max(0, Math.ceil((t - Date.now()) / 1000))
          + '; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : '');
      } catch (e) {}
    }
    try { until = parseInt(localStorage.getItem(KEY) || '0', 10) || 0; } catch (e) {}
    if (Date.now() < until) {                          // a legacy (localStorage-only) snooze: honour it once
      if (!n.hidden) { n.hidden = true; snoozeCookie(until); }
      return;
    }
    var x = n.querySelector('.js-refnudge-x');
    if (x) x.addEventListener('click', function () {
      n.hidden = true;
      var t = Date.now() + 10 * 86400000;
      try { localStorage.setItem(KEY, String(t)); } catch (e) {}
      snoozeCookie(t);
    });
  })();

  /* ---- "get the app" bar: dismiss (X) = snooze 7 days -------------------
     Same rova_refnudge_until convention as the invite nudge just above (own key, own window),
     but the SHOW side works the opposite way round: the bar is rendered VISIBLE by default (it
     reserves its own height on <body>, see .has-appbar / .appbar-getapp in rova.css) rather than
     hidden-then-revealed, so there is no layout shift for the common case of a visitor who has
     never dismissed it. The snoozed CASE is handled before this file even loads -- View::APPBAR_BOOT
     (lib/view.php), a second CSP-hashed inline script sitting right next to THEME_BOOT, stamps
     <html data-appbar-dismissed> synchronously before first paint whenever the snooze is still
     live -- and, since 2026-09-06, on every NON-iOS device (the bar is iOS-only; on the edge-cached
     guest pages it is printed for every UA and that script is the platform gate, removing the
     element and body.has-appbar at DOMContentLoaded, so this module finds no bar on Android and
     returns) -- and the CSS keys off that attribute to hide the bar and cancel the reserved space with
     zero flash in either direction. All this handler owns is the tap: hide it and set the same
     attribute (so the reservation collapses on THIS page view too, not only after a reload), then
     write the snooze. */
  (function () {
    var bar = document.getElementById('appbar-getapp');
    if (!bar) return;
    var x = bar.querySelector('.js-appbar-x');
    if (!x) return;
    var KEY = 'rova_appbar_until';
    x.addEventListener('click', function () {
      document.documentElement.setAttribute('data-appbar-dismissed', '1');
      try { localStorage.setItem(KEY, String(Date.now() + 7 * 86400000)); } catch (e) {}
      /* 2026-09-05: the header stack just got 56px shorter (the topbar's sticky `top`
         drops to 0 with the attribute), and --topbar-h is the STACK BOTTOM (see
         __rovaSetTopbarH near the top of this file). The attribute alone fixes the CSS
         side (rova.css keys the 121px on :has(body.has-appbar) minus this attribute), but
         an engine without :has() got its 121 from a JS write that must now be corrected,
         and the feed's dock band (dockSync, the feed block) was built from the old line --
         it listens for this event and rebuilds. Neither can see `top` move on its own:
         the topbar's ResizeObserver only fires on a HEIGHT change. */
      if (typeof window.__rovaSetTopbarH === 'function') { try { window.__rovaSetTopbarH(); } catch (e) {} }
      try { window.dispatchEvent(new Event('rova:appbar')); } catch (e) {}
    });
  })();

  /* ---- Founder payout banner: dismiss its BONUS CARD, per ACCOUNT --------
     UNLIKE the invite nudge above, nothing here is a localStorage snooze and nothing here reveals
     anything. The server decides what renders (lib/view.php + FounderPayout::due / bonusCardDue), so
     the banner arrives visible and needs no JS to appear at all. All this module owns is the card's
     Dismiss button -- the payout prompt itself has none, deliberately.

     THE DISMISSAL IS PER ACCOUNT, not per browser: it POSTs a receipt keyed on the user id, so
     closing the card on a phone also closes it on a laptop. A localStorage flag would have brought it
     straight back on every other device that member signs in from, which is indistinguishable from
     broken. Nothing returns it on a timer, and it never touches the same card on /founders.

     keepalive so the receipt still goes out if they hit Dismiss and close the tab in the same breath,
     and the card is put back on any failure -- half-hidden chrome that the next page load contradicts
     is worse than a button that visibly did nothing. */
  (function () {
    var b = document.querySelector('.fpay-banner');
    if (!b) return;
    var x = b.querySelector('.js-fpaybonus-x');
    if (!x) return;
    var card = x.closest('.bonus10');
    if (!card) return;
    x.addEventListener('click', function () {
      if (x.disabled) return;                          // one dismissal per click, never a double POST
      x.disabled = true;
      card.hidden = true;                              // optimistic: the tap must feel instant
      card.style.display = 'none';                     // .card.bonus10 sets display:flex, which beats [hidden]
      var tok = (document.querySelector('meta[name="csrf-token"]') || {}).content || '';
      fetch('/founders/bonus-card/dismiss', {
        method: 'POST',
        credentials: 'same-origin',
        keepalive: true,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' },
        body: '_csrf=' + encodeURIComponent(tok)
      }).then(function (r) {
        if (!r.ok) throw new Error('dismiss failed');
      }).catch(function () {
        card.hidden = false;                           // never leave it half-hidden
        card.style.display = '';
        x.disabled = false;
      });
    });
  })();

  /* ---- keep the keyboard from zooming the page on input focus ----------
     iOS zooms whenever a focused field could compute < 16px. Rather than chase every field's
     font-size, we lock the viewport scale WHILE any text field is focused, then restore it on
     blur -- so pinch-zoom on photos/videos keeps working everywhere else. */
  (function () {
    var vp = document.querySelector('meta[name="viewport"]');
    if (!vp) return;
    var base = vp.getAttribute('content') || 'width=device-width, initial-scale=1';
    var lock = base.replace(/,?\s*(maximum-scale|user-scalable)=[^,]*/g, '') + ', maximum-scale=1, user-scalable=no';
    function isField(el) {
      return el && el.matches && el.matches('input:not([type=button]):not([type=submit]):not([type=checkbox]):not([type=radio]):not([type=range]):not([type=file]), textarea, [contenteditable="true"]');
    }
    document.addEventListener('focusin', function (e) { if (isField(e.target)) vp.setAttribute('content', lock); });
    document.addEventListener('focusout', function (e) { if (isField(e.target)) setTimeout(function () { vp.setAttribute('content', base); }, 80); });
  })();

  /* ---- reactions ------------------------------------------------------- */
  // MUST stay in sync with Posts::REACTIONS (lib/posts.php) -- the server validates against its list.
  var EMOJI = { heart: '❤️', love: '😍', fire: '🔥', haha: '😂', wow: '😮', clap: '👏', sad: '😢', angry: '😡' };
  var Posts_REACTIONS = ['heart', 'love', 'fire', 'haha', 'wow', 'clap', 'sad', 'angry'];
  // The heart is drawn as an inline SVG, never the ❤️ emoji: system emoji fonts render it
  // wildly differently (Chrome = glossy 3D, Apple = flat), so an SVG is the only way to make
  // it identical in every browser. Other reactions keep their native emoji.
  var HP = 'M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z';
  var HEART_ON  = '<svg class="hic" viewBox="0 0 24 24" aria-hidden="true"><path d="' + HP + '" fill="#ff2b55"/></svg>';
  var HEART_OFF = '<svg class="hic hic-o" viewBox="0 0 24 24" aria-hidden="true"><path d="' + HP + '" fill="none" stroke="currentColor" stroke-width="2"/></svg>';
  function rxIc(code) { return code === 'heart' ? HEART_ON : (EMOJI[code] || HEART_ON); }

  /* Build the reaction fan: ONE icon front and dead-CENTER at full size, every other distinct emoji
     reaction fanned out symmetrically BEHIND it, each smaller but still legible, tuned so the whole hand
     nests inside the 38px gold action circle with only a whisker of overflow.

     WHICH ICON HOLDS THE CENTRE (owner, 2026-08-07, with the long-press carousel: "replace the heart with
     their selected emotion"). It is THE VIEWER'S OWN reaction whenever they have chosen one, so picking
     Fire turns the button into a fire. The original rule pinned the heart there forever ("a like on Rova
     IS the heart"), and under it the emoji that had just flown down to the button landed behind a red
     heart -- the exact opposite of the replacement he asked for. The heart still holds the centre in every
     other case: no reaction, other people's reactions only, or the viewer's own heart.
       heartFilled: the viewer holds SOME reaction (fills the centre heart when the heart is centred, so
                    an un-liked post never flashes a filled red heart for somebody else's like)
       others:      distinct emoji codes to fan behind, most-used first
       mine:        the viewer's own code, or null. A non-heart one takes the centre and is dropped from
                    the fan so it can never appear twice.
     MUST match react_fan_html() in lib/view.php, or the server's first paint and the live JS re-render
     disagree the moment anything touches the badge. */
  function buildFan(heartFilled, others, mine) {
    var mineIc = (mine && mine !== 'heart' && EMOJI[mine]) ? rxIc(mine) : null;
    var centreIc = mineIc || (heartFilled ? HEART_ON : HEART_OFF);
    others = (others || []).filter(function (c) { return c !== mine && (c === 'heart' || EMOJI[c]); }).slice(0, 3);
    if (!others.length) { return { html: centreIc, n: (heartFilled || mineIc) ? 1 : 0 }; }
    // Slot each extra around the centre, alternating right/left and widening: +1, -1, +2, -2, ... The
    // centre holds slot 0. Sorting by slot gives left-to-right DOM order with the centre in the middle.
    var items = [{ off: 0, ic: centreIc, mid: true }];
    for (var i = 0; i < others.length; i++) {
      var side = (i % 2 === 0) ? 1 : -1, ring = Math.floor(i / 2) + 1;
      items.push({ off: side * ring, ic: rxIc(others[i]), mid: false });
    }
    items.sort(function (a, b) { return a.off - b.off; });
    var html = items.map(function (it) {
      var tx = it.off * 7;                               // px the emoji is pushed out from the CENTERED icon
      var r = it.off * 11;                               // fan angle grows with distance from the centre
      var s = it.mid ? 1 : 0.72;                         // others noticeably smaller, still readable
      var z = it.mid ? 40 : 30 - Math.abs(it.off);       // the centre is ALWAYS on top; nearer emojis over farther ones
      return '<i class="rf" style="z-index:' + z + ';--tx:' + tx + 'px;--r:' + r + 'deg;--s:' + s + '">' + it.ic + '</i>';
    }).join('');
    return { html: html, n: items.length };
  }
  // the distinct reactions on a post: the viewer's own centred, the rest fanned behind
  function reactFan(breakdown, myr) {
    breakdown = breakdown || {};
    /* THE QUIET DISC (owner picked 2026-08-29; his 08-28 report on the old cluster: "when I
       haven't liked it yet it should look different, this looks kinda off"). NO reaction of the
       READER'S OWN -> the disc stays QUIET: outlined heart alone, no fan of other people's
       emojis -- so an un-engaged disc reads like the neutral share disc, and the gold fan
       remains the READER'S OWN state. THIS HALF HE KEPT. What changed on 08-30 is only WHERE
       the crowd goes: the .rxpill capsule beside the disc is deleted and the crowd's dominant
       reaction now rides inside the disc's own count badge (rxBadgePaint below). The
       comment-like fan (cFan) deliberately keeps the old behaviour: this redesign is the POST
       action row only. Server twin: the $rxQuiet branch in views/_post.php. Keep them in step. */
    if (!myr) return buildFan(false, [], null);
    var others = Object.keys(breakdown)
      .filter(function (k) { return k !== 'heart' && breakdown[k] > 0; })
      .sort(function (a, b) { return breakdown[b] - breakdown[a]; });
    // the viewer's own non-heart emoji rides in the fan immediately, before the breakdown round-trips
    if (myr && myr !== 'heart' && others.indexOf(myr) < 0) { others.unshift(myr); }
    // ...and when it takes the CENTRE, other people's hearts still deserve a fan slot
    if (myr && myr !== 'heart' && breakdown.heart > 0) { others.push('heart'); }
    return buildFan(!!myr, others, myr);
  }

  /* ---- the quiet state's crowd badge (.cnt.rxq > .rxd) ------------------
     REPLACES the .rxpill capsule, deleted 2026-08-30 (owner: "I'm not feeling this invention").
     The crowd's reaction now rides in the badge slot the disc ALREADY has -- the same slot the
     comment and repost discs put their numbers in -- so it costs the action row ZERO horizontal
     width, which was his second objection (the pill's width is what forced the whole shrink/wrap
     saga). See rova.css `.act .cnt .rxd` for the design note.

     NO DUPLICATE GLYPH, which was his first objection. The dominant reaction is drawn only when
     it is NOT the plain heart; when the crowd's top reaction IS the heart the badge shows the
     bare number, because the disc under it is already an outlined heart.

     rxBadgePaint is THE ONE WRITER of this badge, and every repaint path goes through it: the
     optimistic tap (applyReactLocal), the server's answer (applyReactToPost) and the
     /engage-live poll (engApply). That is deliberate and is the engApply-zeros lesson applied
     here -- the old split (caller writes .cnt.textContent, reconciler patches around it) meant a
     response with no breakdown in it wiped the glyph off a perfectly good badge, because
     assigning textContent destroys the child span. One writer, and a missing breakdown means
     "no news": the glyph already on screen is carried over verbatim. */
  var RX_ORDER = ['heart', 'love', 'fire', 'haha', 'wow', 'clap', 'sad', 'angry'];  // = Posts::REACTIONS
  /* The single highest-count distinct reaction. TIES ARE BROKEN BY RX_ORDER, never by object key
     order (which is insertion order and therefore whatever the server's JSON happened to say this
     round) -- otherwise a 12-12 tie would flicker between two glyphs from one poll to the next.
     Walking a fixed list with a STRICT > keeps the earliest listed code on a tie, and `heart` is
     first, so any tie involving the heart resolves to the heart, i.e. to no glyph at all.
     MUST match rx_dominant() in lib/view.php. */
  function rxDominant(bd) {
    var best = null, bn = 0;
    for (var i = 0; i < RX_ORDER.length; i++) {
      var v = +((bd && bd[RX_ORDER[i]]) || 0);
      if (v > bn) { bn = v; best = RX_ORDER[i]; }
    }
    return best;
  }
  function rxDomGlyph(bd) {
    var d = rxDominant(bd);
    // heart -> nothing: the disc is the heart. Unknown codes -> nothing, same rule the fan uses.
    return (!d || d === 'heart' || !EMOJI[d]) ? ''
      : '<span class="rxd" aria-hidden="true">' + EMOJI[d] + '</span>';
  }
  /* btn:       the like control (.react-btn, or a guest's plain .act link)
     count:     the post's total reactions, the server's number wherever there is one
     breakdown: the per-emoji tally, or null/undefined for "no news, keep what is drawn" */
  function rxBadgePaint(btn, count, breakdown) {
    if (!btn) return;
    var cnt = btn.querySelector('.cnt');
    if (!cnt) return;
    var n = Math.max(0, +count || 0);
    /* QUIET = the reader holds no reaction and the post has some.
       POST-BAR DISCS ONLY. The profile-photo chip is also a .react-btn inside a js-react form
       (applyReactToPost reaches it through the [form] fallback), but it deliberately shows no
       crowd at all -- "other people's reactions are not this chip's job" (engPhotoGlyph) -- so it
       is never quiet and always paints the plain number it painted before this redesign. */
    var quiet = n > 0 && !btn.classList.contains('on') && !btn.classList.contains('pf-badge');
    var glyph = '';
    if (quiet) {
      if (breakdown != null) glyph = rxDomGlyph(breakdown);
      else {                                   // no news: carry the rendered glyph over untouched
        var had = cnt.querySelector('.rxd');
        if (had) glyph = had.outerHTML;
      }
    }
    // fmtCount only ever returns [0-9.]+ with an optional k/m/b, so this is not an injection site
    cnt.innerHTML = glyph + fmtCount(n);
    cnt.hidden = !n;
    cnt.classList.toggle('rxq', !!glyph);
    /* A number alone is ambiguous the moment an emoji joins it, and the badge is inside the
       button, so it contributes to the button's own accessible name. Say the whole thing in words
       and hide the decorative glyph (aria-hidden on .rxd, above). Cleared again on every
       non-quiet paint so a liked disc never keeps a stale "N reactions" label. */
    if (quiet) { cnt.setAttribute('role', 'img'); cnt.setAttribute('aria-label', fmtCount(n) + (n === 1 ? ' reaction' : ' reactions')); }
    else { cnt.removeAttribute('role'); cnt.removeAttribute('aria-label'); }
  }

  /* NO GRID-TILE RECONCILER HERE, AND THAT IS A MEASURED DECISION, NOT AN OVERSIGHT (2026-08-05).
     The hover pill's heart is filled from the tile's data-me (views/_profile_posts.php,
     views/_feed_grid.php), and the obvious worry is that a like made after the page rendered leaves the
     tile claiming otherwise -- the same staleness data-lk has always had. It cannot happen: opening a
     tile is a real NAVIGATION to /p/<id>, so while the immersive viewer is up the grid is not in the
     document at all (measured: 0 matches for .pcell[data-id] with the viewer open), and coming back
     re-renders the profile from the server rather than restoring a stale DOM (measured: liked in the
     viewer, two history steps back, the tile came back carrying the NEW value). A reconciler written
     against a .pcell here would match nothing, ever. Do not add one without re-measuring those two
     facts -- if the viewer ever becomes an overlay instead of a navigation, they both change. */
  function applyReact(form, res) {
    if (!res) return;
    var srcPost = form.closest ? form.closest('.post') : null;
    // A post can be on screen in more than one place at once -- the immersive pfeed card AND the timeline
    // card behind it (and any reposts) share the same data-view. Apply the reaction to EVERY copy, so a
    // like in the pfeed shows on the feed the instant you return, no refresh. (This was the "liked posts
    // look unliked until refresh" bug: only the tapped copy updated.)
    var vid = srcPost && (srcPost.getAttribute('data-view') || srcPost.getAttribute('data-id'));
    // Standalone js-react form (profile-photo badge) with no .post host -> reconcile on the form itself.
    var posts = vid ? document.querySelectorAll('.post[data-view="' + vid + '"]') : (srcPost ? [srcPost] : [form]);
    Array.prototype.forEach.call(posts, function (post) { applyReactToPost(post, res); });
    // ...and the profile-photo chip, which is a view of this same count on an element that is not a
    // card. `res.reaction` is the server's answer about the READER, so the pressed state travels here.
    engPhotoReact(vid || engPhotoIdFor(form), res.count, res.reaction || null);
  }
  /* Keep the spoken state in step with the drawn one. The spark is a SHAPE set into the rim, which
     is worth nothing to a screen reader, so the persistent announcement rides aria-description --
     NOT aria-pressed, which belongs to the like's own on/off and must not be overloaded. The
     transient 'Loved' announcement at burst commit already exists; this is the standing half. */
  function slAria(btn) {
    if (!btn || !btn.classList) return;
    if (btn.classList.contains('sl')) btn.setAttribute('aria-description', 'You super-loved this');
    else btn.removeAttribute('aria-description');
  }
  function applyReactToPost(post, res) {
    engTouch(post);   // server-confirmed: the like is in the database as of now
    var btn = post.querySelector('.react-btn');
    if (btn) {
      var ic = btn.querySelector('.react-ic');
      if (res.reaction) {
        btn.classList.add('on'); btn.setAttribute('aria-pressed', 'true'); btn.setAttribute('data-reaction', res.reaction);
        /* THE SERVER'S ANSWER ABOUT THE READER'S OWN SUPER-LIKE (db/0152 love_tier).
           handle_like answers `love` on EVERY liked outcome, not just the ones a burst rode along,
           so switching emoji on an already-super-liked post keeps the spark instead of dropping it
           until reload. Read as a BOOLEAN -- 1, 2 and 3 all draw the same rim.
           Guarded on the key being PRESENT rather than truthy: during a deploy the browser can be
           holding new JS against an older handler that only spoke `love` on a burst, and a missing
           key must mean "no news", never "clear it". An absent reaction is different -- that is
           positive proof the likes row is gone, and the tier goes with it -- so the else branch
           below clears unconditionally. */
        if ('love' in res) btn.classList.toggle('sl', (+res.love || 0) > 0);
      } else {
        btn.classList.remove('on'); btn.setAttribute('aria-pressed', 'false'); btn.setAttribute('data-reaction', '');
        btn.classList.remove('sl');   // no reaction -> no likes row -> no tier
      }
      slAria(btn);
      if (ic) { var f = reactFan(res.breakdown, res.reaction); ic.innerHTML = f.html; ic.classList.toggle('fan', f.n > 1); }
      if (typeof res.count !== 'undefined') btn.setAttribute('data-optcount', String(+res.count || 0));
      /* The count badge, glyph and all, through its ONE writer -- never `cnt.textContent = ...`
         here, which would drop the crowd glyph on the floor. On an UNLIKE this brings the crowd's
         dominant reaction back into the badge; on a like it takes it away and leaves the plain
         total. `cnt` is resolved inside. */
      rxBadgePaint(btn, res.count, res.breakdown);
    }
    /* The reactions-summary row (.react-summary > .rx-cluster / .rp-cluster) that used to be
       repainted here is GONE: no template has emitted that markup for a long time, and nothing
       builds it client-side either, so the painter and syncSummary() were both no-ops. The
       per-reaction breakdown the reader actually sees is the fan inside .react-ic, painted
       above from the same res.breakdown. (Removed 2026-08-10.) */
  }

  /* ---- optimistic engagement -------------------------------------------
     A tap never waits on the network (owner 2026-07-24): paint the expected
     state instantly, let the server's answer reconcile it (the server stays
     the source of truth for counts + breakdowns), and roll the DOM back with
     a toast if the request dies. Each element carries a sequence number so a
     slow stale response can never clobber a newer tap. */
  /* Stamp every on-screen copy of a post with "a local engagement write just touched this".
     The live badge refresh (engRefresh, shared by the feed, the permalink and the profile) reads the stamp and skips
     any card whose stamp is NEWER than the moment its own request left the browser -- so a server
     read taken before the reader's own like/repost/comment landed can never flicker their tap back
     or double-count it. Stamped on BOTH beats: the instant optimistic paint AND the server's answer
     to it, because only the second one proves the write is in the database.
     (Declared here, next to the optimistic helpers it guards; hoisting carries it to the earlier
     repost handler in this same scope.) */
  function engTouch(node) {
    if (!node) return;
    var t = Date.now();
    node.__engAt = t;
    var vid = node.getAttribute ? node.getAttribute('data-view') : '';
    if (!vid) return;
    document.querySelectorAll('.post[data-view="' + vid + '"]').forEach(function (el) { el.__engAt = t; });
  }
  function approxCount(txt) {
    // reverse fmtCount ("1.2k" -> 1200) -- lossy above 1k, but the server's
    // response restores the exact number moments later
    txt = (txt || '').trim().toLowerCase();
    if (!txt) return 0;
    var m = txt.match(/^([0-9.]+)\s*([kmb])?$/);
    if (!m) return parseInt(txt.replace(/[^0-9]/g, ''), 10) || 0;
    return Math.round(parseFloat(m[1]) * (m[2] === 'b' ? 1e9 : m[2] === 'm' ? 1e6 : m[2] === 'k' ? 1e3 : 1));
  }
  function optCount(btn) {
    // exact once any server response has stamped it; a parse of the rendered
    // label before that
    var stamped = parseInt(btn.getAttribute('data-optcount') || '', 10);
    if (!isNaN(stamped)) return stamped;
    var cnt = btn.querySelector('.cnt');
    /* STRIP A LEADING GLYPH BEFORE THE PARSE. Since 2026-08-30 the like disc's badge can lead
       with the crowd's dominant emoji (.rxd), so textContent reads "🔥35" and
       approxCount's anchored ^[0-9.]+ pattern would fail it and answer 0 -- which would make the
       very first optimistic like on an un-reacted post paint "1" instead of "36". The number is
       always the tail. (views/_post.php also stamps data-optcount on first paint now, so this
       path is a second belt; keep both -- markup rendered by an older deploy still lands here.) */
    return cnt && !cnt.hidden ? approxCount((cnt.textContent || '').replace(/^[^0-9]+/, '')) : 0;
  }

  /* ---- the comment badge: one number, several views ----------------------
     Likes and reposts have painted optimistically since 2026-07-24; comments were the outlier and
     moved only when POST /comment answered -- on the permalink that meant a badge that was wrong
     for up to 30s, and a delete that left it wrong until a reload (owner 2026-08-05, "badges should
     be updating in realtime"). These helpers give comments the same shape as the other two.

     NEVER PAINT THE COUNT THE ADD ENDPOINT RETURNS. POST /comment answers with a raw
     SELECT COUNT(*) (handle_comment, index.php), but every other number this badge shows is
     shadow-phrase corrected: Posts::attachMedia and Posts::engagementMany each subtract the
     comments hidden from THIS viewer, and GET /comments + GET /post-json both ship the corrected
     $p['comment_count']. Painting the raw answer would make the badge jump on any thread holding a
     shadowed comment and then get yanked back down by the very next poll. A local +1 is right
     instead, and provably so: both corrections subtract only rows matching `user_id <> $viewerId`,
     so the reader's own comment is never one of the ones taken away. /comment/delete returns no
     count at all, so a local delta is the only number there either.

     ONE NUMBER, SEVERAL VIEWS. A post's comment count can be on screen several times at once: the
     card badge on every copy of the card (an original and a repost of it share one data-view), the
     permalink's "N Comments" section header, and the gallery lightbox summary. post_single.php
     renders the header and the badge from the SAME $p['comment_count'], so they are two views of
     one number and must never be written separately -- writing only the header is exactly how a
     delete used to leave the permalink permanently disagreeing with itself. Every writer, local or
     polled, goes through engCommentPaint(). */
  var C_BADGE = '.act[aria-label="Comments"]';   // the member badge and the guest badge both carry it

  // The card a comment write belongs to, from an element or a bare post id. Null is a normal
  // answer, not a failure: the notification at-reply form posts to a post with no card on the page.
  function engCardFor(ref) {
    if (!ref) return null;
    if (ref.nodeType === 1) return (ref.closest && ref.closest('.post')) || ref;
    var id = parseInt(ref, 10) || 0;
    return id ? document.querySelector('.post[data-view="' + id + '"]') : null;
  }
  function engIdFor(post) {
    if (!post || !post.getAttribute) return '';
    return post.getAttribute('data-view') || post.getAttribute('data-id') || '';
  }

  // The permalink's "<n> Comments" section title. Only the page's OWN post has one, so match on id
  // and leave every other card alone -- the immersive viewer can have several cards up at once.
  function engCommentHeader(post, n) {
    var cnt = document.getElementById('comment-count');
    if (!cnt) return;
    var card = document.querySelector('.layout-main > .post, [data-pfeed-open] > .post');
    if (!card || !engIdFor(post) || engIdFor(card) !== engIdFor(post)) return;
    cnt.textContent = fmtCount(n);
    // "1 Comment" / "2 Comments": the word is the text node right after the counter span
    var w = cnt.nextSibling;
    if (w && w.nodeType === 3 && w.nodeValue.indexOf('Comment') >= 0) w.nodeValue = n === 1 ? ' Comment' : ' Comments';
  }

  // The gallery lightbox summary, when the lightbox happens to be open on this post.
  function engCommentGal(post, n) {
    var id = engIdFor(post); if (!id) return;
    var el = document.querySelector('.gal[data-gal-post="' + id + '"] .gal-ccount');
    if (el) el.textContent = fmtCount(n);
  }

  /* ---- the profile photo's chips: a FOURTH view of these same two numbers ----
     A member's profile photo is likeable because it is backed by a HIDDEN post (posts.is_avatar = 1),
     so the heart and the comment bubble sitting on the avatar are that post's like and comment count
     -- the same two numbers a .post card shows, on an element that is not a card. Nothing above could
     reach them: every painter here selects `.post[data-view="<id>"]`, and .pf-photo-badges matches
     none of it. So a like made inside the immersive viewer (which is where tapping the photo lands)
     painted the viewer's card and left the chip underneath it stale, and dismissing the viewer
     revealed the stale chip -- the same class of miss the permalink's "N Comments" header had before
     engCommentHeader was written, which is why the cure has the same shape rather than a new one.
     These are counts only. Who liked a photo is owner-private (/reactions is gated to the author and
     admins) and nothing here goes near a name. */
  function engPhotoBadges(id) {
    id = String(id || '').replace(/[^0-9]/g, '');
    return id ? document.querySelector('.pf-photo-badges[data-post="' + id + '"]') : null;
  }
  // Member markup is a .react-btn in a js-react form + an <a class="js-comments">; the guest branch is
  // two plain /signup links carrying the same .pf-badge/.cnt. Both answer here.
  function engPhotoChip(badges, kind) {
    if (!badges) return null;
    if (kind === 'like') return badges.querySelector('.react-btn') || badges.querySelectorAll('.pf-badge')[0] || null;
    return badges.querySelector('.js-comments') || badges.querySelectorAll('.pf-badge')[1] || null;
  }
  // One chip's count. data-optcount is written alongside the label for the same reason every other
  // badge does it: optCount() reads it on the next tap, so a polled number must not leave the tap
  // counting up from a stale base.
  function engPhotoCount(chip, n) {
    if (!chip) return;
    n = Math.max(0, Math.round(+n || 0));
    chip.setAttribute('data-optcount', String(n));
    var c = chip.querySelector('.cnt');
    if (!c) return;
    c.textContent = fmtCount(n);
    c.hidden = !n;
  }
  // A LOCAL stamp for an element that is not a .post, so engTouch's card fan cannot carry one to it.
  // The /photo-engage poll below reads it exactly as engRefresh reads post.__engAt.
  function engPhotoTouch(id) {
    var b = engPhotoBadges(id);
    if (b) b.__engAt = Date.now();
  }
  /* THE CHIP'S GLYPH -- the reader's OWN reaction, or the heart when they hold none (2026-08-08).
     The badge on the avatar used to be a hardcoded heart_svg() on both sides: the server printed one
     and nothing here ever replaced it, so a member who long-pressed and picked Fire stored `fire` and
     went on being shown a heart.
     ONE RENDERER, NOT TWO. buildFan(true, [], code) is the SAME call views/profile.php makes as
     react_fan_html(true, [], code), with the same arguments, so first paint and every repaint below
     produce the same string by construction -- the symmetry the fan itself was given today, kept.
     Calling it with an EMPTY fan is exactly its CENTRE rule, which is the whole of what this chip
     needs: the reader's emoji when they picked a non-heart one, the heart otherwise. No fan on a 30px
     disc; other people's reactions are not this chip's business (and /reactions is owner-private).
     heartFilled is `true` unconditionally because this badge has ALWAYS drawn the solid heart and
     tints it from `color` instead (.pf-badge .hic path{fill:currentColor}) -- unlit = --text, lit =
     --danger. Passing the outline heart here would be a look change nobody asked for.
     The write is guarded so a repaint that changes nothing does not touch the DOM. */
  function engPhotoGlyph(chip, reaction) {
    var ic = chip && chip.querySelector ? chip.querySelector('.ic') : null;
    if (!ic) return;
    var html = buildFan(true, [], reaction || null).html;
    if (ic.innerHTML !== html) ic.innerHTML = html;
  }
  // The like chip. `reaction` is the READER'S OWN state and is only ever passed by a local write or by
  // the server's answer to one; the count-only callers (another person's like arriving on a poll) pass
  // undefined and the pressed state is left exactly as the reader left it.
  function engPhotoReact(id, n, reaction) {
    var chip = engPhotoChip(engPhotoBadges(id), 'like');
    if (!chip) return;
    engPhotoCount(chip, n);
    if (typeof reaction === 'undefined' || !chip.classList.contains('react-btn')) return;
    if (reaction) { chip.classList.add('on'); chip.setAttribute('aria-pressed', 'true'); chip.setAttribute('data-reaction', reaction); }
    else { chip.classList.remove('on'); chip.setAttribute('aria-pressed', 'false'); chip.setAttribute('data-reaction', ''); }
    engPhotoGlyph(chip, reaction);   // ...and the glyph, which is the state the reader actually reads
  }
  // The post id a react form belongs to, for forms that have no .post host: the profile-photo like
  // badge is a standalone js-react form inside .pf-photo-badges, which carries the id.
  function engPhotoIdFor(form) {
    var b = form && form.closest ? form.closest('.pf-photo-badges') : null;
    return b ? (b.getAttribute('data-post') || '') : '';
  }

  // Paint EVERY view of one post's comment count to an exact number.
  function engCommentPaint(post, n) {
    if (!post) return;
    n = Math.max(0, Math.round(+n || 0));
    var id = engIdFor(post);
    var cards = id ? document.querySelectorAll('.post[data-view="' + id + '"]') : [post];
    Array.prototype.forEach.call(cards, function (el) {
      var b = el.querySelector ? el.querySelector(C_BADGE) : null;
      if (!b) return;
      b.setAttribute('data-optcount', String(n));   // keeps optCount() exact past 1k, as likes/reposts do
      var c = b.querySelector('.cnt');
      if (c) { c.textContent = fmtCount(n); c.hidden = !n; }
    });
    engCommentHeader(post, n);
    engCommentGal(post, n);
    engPhotoCount(engPhotoChip(engPhotoBadges(id), 'comment'), n);   // the chip on the avatar, when this IS the avatar post
  }

  /* THE COMMENT BUTTON'S LIT STATE (owner 2026-08-20: "if I've left a comment the comment
     should light up like the like and repost buttons do"). The class is the same `on` the
     like/repost buttons wear, so the shared .act.on rule paints the same gold ring -- no new
     CSS on the card. Toggled on EVERY copy of the card (data-view fan, exactly as
     engCommentPaint above), and the immersive viewer needs nothing extra: pfMoveActs MOVES
     this same anchor into .vctrl, so the class rides along. `.js-comments` only -- the guest
     badge is a /signup link and a guest has no comments to light. Server truth is the
     rendered class (views/_post.php reads commented_by_me); these two helpers exist for the
     optimistic paint on submit and the server-confirmed answer on delete. */
  function engCommentedNow(ref) {
    var post = engCardFor(ref);
    var a = post && post.querySelector ? post.querySelector('.js-comments') : null;
    return !!(a && a.classList.contains('on'));
  }
  function engCommentedMark(ref, on) {
    var post = engCardFor(ref);
    if (!post) return;
    var id = engIdFor(post);
    var cards = id ? document.querySelectorAll('.post[data-view="' + id + '"]') : [post];
    Array.prototype.forEach.call(cards, function (el) {
      var a = el.querySelector ? el.querySelector('.js-comments') : null;
      if (a) a.classList.toggle('on', !!on);
    });
  }

  // What the badge says right now: data-optcount once any server answer or earlier bump has stamped
  // it, the rendered label otherwise, and the permalink header as a last resort.
  function engCommentNow(post) {
    var b = post && post.querySelector ? post.querySelector(C_BADGE) : null;
    if (b) return optCount(b);
    var h = document.getElementById('comment-count');
    return h ? approxCount(h.textContent) : 0;
  }

  /* IN-FLIGHT HOLD -- ONE implementation, all three badges. The happens-before stamp alone does NOT
     close the stale-poll race, and this is the part that breaks if it is rushed. engRefresh skips a
     card whose stamp is newer than the moment its own request left -- but a batch that LEAVES after
     the optimistic paint and comes back before the write has committed carries a snapshot with the
     reader's own action missing from it, and passes that test cleanly. The badge ticks up and then
     visibly ticks back down a few seconds later, which is worse than the bug being fixed. So the
     badge is also HELD for the length of the write, keyed by post id rather than by element (cards
     get re-rendered, the id does not), and re-stamped on release: any batch that leaves from the
     release onwards is reading a database that already has the write in it.

     PER BADGE, NOT PER CARD. The key is kind + post id, so a like still in flight holds the LIKE
     badge and nothing else: that same card keeps taking other people's comments and reposts from
     every batch that lands meanwhile. Comments were held first (2026-08-05); likes and reposts were
     left out only because that brief said so, and they carry the identical race. The window on
     /like and /repost is narrower -- those endpoints are quick and the feed polls every 8s -- but
     likes are the most-tapped interaction on the site, so a narrower window multiplied by far more
     taps is not obviously rarer in absolute terms. And three badges with two behaviours is a trap
     for whoever touches this next, which is its own cost.

     A HOLD MUST NEVER WEDGE. A badge that stops updating for the rest of the session would be a
     worse bug than the flicker, so release is guaranteed twice over rather than remembered:
       1. STRUCTURAL. engBadgeSettle() hangs the release off the request promise itself, as its own
          reaction, so it fires on success, on an HTTP failure, on a network failure and on the
          reauth path alike. reauth is the one that would otherwise stick: those handlers return
          early without touching the DOM, and a release written inside them would be skipped.
       2. BOUNDED EXPIRY. Every hold records when it was armed, and engBadgeHeld() treats anything
          older than ENG_HOLD_MAX_MS as absent (and sweeps it), so even a hold that somehow never
          gets released self-heals on the next poll instead of lasting the session.
     ENG_HOLD_MAX_MS is a backstop, not a policy: it is set far longer than any of these writes can
     legitimately run (they are sub-second, and the browser abandons the socket long before a
     minute) precisely so it can never expire underneath a write that is still going. */
  var ENG_HOLD_MAX_MS = 60000;   // backstop only: a hold older than this is a bug, not a slow write
  var engBadgeWrites = {};       // "kind|postid" -> { n: outstanding writes, at: armed-at ms }
  function engBadgeKey(kind, id) { return kind + '|' + String(id || ''); }
  function engBadgeHold(kind, id, on) {
    id = String(id || ''); if (!id) return;
    var k = engBadgeKey(kind, id), e = engBadgeWrites[k];
    if (e && Date.now() - e.at > ENG_HOLD_MAX_MS) { delete engBadgeWrites[k]; e = null; }   // stale: start clean
    var n = (e ? e.n : 0) + (on ? 1 : -1);
    if (n > 0) { engBadgeWrites[k] = { n: n, at: e ? e.at : Date.now() }; } else { delete engBadgeWrites[k]; }
  }
  function engBadgeHeld(kind, id) {
    var k = engBadgeKey(kind, id), e = engBadgeWrites[k];
    if (!e) return false;
    if (Date.now() - e.at > ENG_HOLD_MAX_MS) { delete engBadgeWrites[k]; return false; }   // self-heal
    return true;
  }

  // Arm a hold on ONE badge of ONE post for a local write that has not settled yet. Stamps the card
  // (beat one: the optimistic paint) and hands back a release that stamps it again (beat two: the
  // write is in the database as of now). The release is idempotent, so a double call cannot let go
  // of somebody else's hold.
  function engBadgeArm(kind, ref) {
    var post = engCardFor(ref);
    var id = post ? engIdFor(post) : String(parseInt(ref, 10) || '');
    engTouch(post);
    engPhotoTouch(id);   // .pf-photo-badges is not a .post, so engTouch's card fan cannot reach it
    // The viewer's cardCache holds this card's RENDERED HTML (lit classes, counts) for 2 minutes;
    // an own write makes that snapshot a lie, and a reopen inside the TTL re-materialized the
    // pre-write card ("took a page refresh to see it"). Forget it now, and again on release --
    // the second call throws away a prefetch batch that left before the write committed.
    if (window.__rovaPfCardDirty) window.__rovaPfCardDirty(id);
    engOwnNote(id);   // the viewer's own-state re-check (batch item 44): a local tap beats a server read that left before it
    engBadgeHold(kind, id, true);
    var done = false;
    return function release() {
      if (done) return; done = true;
      engBadgeHold(kind, id, false);
      engOwnNote(id);
      if (window.__rovaPfCardDirty) window.__rovaPfCardDirty(id);
      engTouch(post);
      engPhotoTouch(id);
    };
  }

  // Wire a release to the request itself and hand the SAME promise back, so callers keep chaining
  // exactly as they did. The release rides its own reaction on the original promise: nothing a
  // caller's own handler does -- an early return, a throw -- can skip it.
  function engBadgeSettle(p, release) {
    if (p && typeof p.then === 'function') p.then(release, release);
    else release();
    return p;
  }

  // A local comment write that has NOT settled yet. Paints the delta, arms the COMMENT hold, and
  // hands back a settle callback. The comment path settles by hand rather than through
  // engBadgeSettle because it alone needs the ok/failed distinction: settle(false) rolls the delta
  // back, so a dead send leaves no phantom. It must still be called on every exit path.
  function engCommentBump(ref, delta) {
    var post = engCardFor(ref);
    if (post) engCommentPaint(post, engCommentNow(post) + delta);
    /* every caller of this with delta > 0 is the reader's OWN comment leaving (the polls go
       through engApply/engCommentPaint, never here), so the button lights in the same frame
       as the badge. `wasOn` remembers the pre-send state -- on a post they had already
       commented on it is true and the rollback below is a visual no-op. */
    var wasOn = post ? engCommentedNow(post) : false;
    if (post && delta > 0) engCommentedMark(post, true);
    var release = engBadgeArm('comment', post || ref);   // stamp beat one + hold
    var done = false;
    return function settle(ok) {
      if (done) return; done = true;
      if (ok === false && post) {
        engCommentPaint(post, engCommentNow(post) - delta);
        if (delta > 0) engCommentedMark(post, wasOn);   // a dead send leaves no phantom glow
      }
      release();                     // hold off + stamp beat two
    };
  }

  // A comment write the server has ALREADY confirmed (a delete answers only once the row is gone):
  // paint and stamp, no hold needed. A batch still in flight from before is skipped by the stamp.
  function engCommentApplied(ref, delta) {
    var post = engCardFor(ref);
    if (!post) return;
    engCommentPaint(post, engCommentNow(post) + delta);
    // an own delete changes the rendered card too (count, possibly the lit state via the
    // viewer_commented answer) -- the viewer's cached copy of its HTML is stale now
    if (window.__rovaPfCardDirty) window.__rovaPfCardDirty(engIdFor(post));
    engTouch(post);
  }

  function fanOthersOf(btn) {
    // the distinct NON-heart emojis already in the fan, so an optimistic
    // repaint keeps other people's reactions on screen
    var out = [];
    var srcs = btn.querySelectorAll('.react-ic .rf');
    /* Quiet disc: the fan is empty by design. Since 2026-08-30 the only crowd information in the
       DOM is the ONE dominant glyph in the count badge, so read that instead of the old three-up
       pill -- the reader's tap then fans it behind the new heart on the SAME frame instead of
       waiting on the server's breakdown. When the dominant reaction is the heart there is no
       glyph at all and this correctly yields nothing: a crowd of hearts is already what the
       centre heart draws. The server's breakdown reconciles the rest a moment later either way. */
    if (!srcs.length) srcs = btn.querySelectorAll('.cnt .rxd');
    Array.prototype.forEach.call(srcs, function (el) {
      var t = (el.textContent || '').trim();
      for (var k in EMOJI) { if (EMOJI[k] === t) { if (out.indexOf(k) < 0) out.push(k); break; } }
    });
    return out;
  }
  // What the server will answer for this tap, computed locally. MUST mirror handle_like()'s
  // branches exactly or the heart flickers back on reconcile:
  //   'like'/'on' -> Posts::forceHeart   (sets, never unsets, never overwrites a chosen emoji)
  //   'set'       -> Posts::setReaction  (picker: exactly this emoji, idempotent)
  //   'off'       -> Posts::clearReaction(idempotent removal)
  //   'toggle'    -> Posts::toggleHeart  (any reaction -> cleared, none -> heart)
  //   ''/null     -> Posts::react        (legacy picker: same reaction again clears, else switches)
  // 'toggle' and ''/null are no longer SENT by anything here (see submitReact), but both stay:
  // a no-JS <form> submit still reaches Posts::react, and dropping branches a server still
  // honours is how the optimistic paint and the reconcile drift apart.
  function nextReactState(cur, reaction, mode) {
    if (mode === true || mode === 'like' || mode === 'on') {
      return cur.reaction ? cur : { reaction: 'heart', count: cur.count + 1 };
    }
    if (mode === 'off') return { reaction: null, count: Math.max(0, cur.count - (cur.reaction ? 1 : 0)) };
    if (mode === 'set') return { reaction: reaction, count: cur.count + (cur.reaction ? 0 : 1) };
    if (mode === 'toggle') {
      return cur.reaction
        ? { reaction: null, count: Math.max(0, cur.count - 1) }
        : { reaction: 'heart', count: cur.count + 1 };
    }
    if (cur.reaction === reaction) return { reaction: null, count: Math.max(0, cur.count - 1) };
    return { reaction: reaction, count: cur.count + (cur.reaction ? 0 : 1) };
  }
  function applyReactLocal(form, state, others) {
    var srcPost = form.closest ? form.closest('.post') : null;
    var bd = {};
    (others || []).forEach(function (c) { bd[c] = 1; });
    // A standalone js-react form with no .post host (the profile-photo badge) paints on the form itself.
    var vid = srcPost && (srcPost.getAttribute('data-view') || srcPost.getAttribute('data-id'));
    var posts = srcPost
      ? (vid ? document.querySelectorAll('.post[data-view="' + vid + '"]') : [srcPost])
      : [form];
    Array.prototype.forEach.call(posts, function (post) {
      engTouch(post);   // optimistic paint: hold the live refresh off this card until it settles
      var btn = post.querySelector('.react-btn');
      if (!btn) return;
      btn.setAttribute('data-optcount', String(state.count));
      if (state.reaction) {
        btn.classList.add('on'); btn.setAttribute('aria-pressed', 'true'); btn.setAttribute('data-reaction', state.reaction);
        /* THE OPTIMISTIC BEAT NEVER INVENTS A SUPER-LIKE, and never guesses one away either. A
           plain tap and a picker switch both leave the standing tier exactly as it was -- the tier
           is keyed on (user,post) and survives an emoji switch (db/0152, a MAX-write) -- so the
           class is left alone here and the server's `love` reconciles it a moment later. The one
           thing this beat DOES know for certain is the negative: dropping the reaction deletes the
           likes row, which takes the tier with it. A burst is the only path that can turn the spark
           ON, and it does that through lovStrike() at commit, not here. */
      } else {
        btn.classList.remove('on'); btn.setAttribute('aria-pressed', 'false'); btn.setAttribute('data-reaction', '');
        btn.classList.remove('sl');   // unliking is the sender's undo, and the only way down
      }
      slAria(btn);
      var ic = btn.querySelector('.react-ic');
      if (ic) { var f = reactFan(bd, state.reaction); ic.innerHTML = f.html; ic.classList.toggle('fan', f.n > 1); }
      /* Count + crowd glyph, through the badge's ONE writer. The optimistic beat's picture of the
         crowd is `bd` -- the fan codes it just painted with, each counted as 1 -- which is good
         enough to choose a dominant until the server's real breakdown reconciles moments later,
         and its all-ones tie resolves through RX_ORDER exactly like any other tie. On the LIKE
         direction the disc goes `on` above, so this simply drops the glyph on the same frame; on
         the UNLIKE direction it brings one back. */
      rxBadgePaint(btn, state.count, bd);
    });
    /* The optimistic beat for the profile-photo chip. When the tap happened ON the chip this is the
       same element the loop above just wrote and the second write is identical; when it happened on a
       CARD -- the immersive viewer opened from the avatar, which is the reader's actual route to
       liking a photo -- this is the only thing that moves the chip, and it moves it on this frame,
       before the request leaves. */
    engPhotoReact(vid || engPhotoIdFor(form), state.count, state.reaction || null);
  }

  // `mode` names WHICH CONTROL was used, not what to send:
  //   'like'   the media double-tap   |   'toggle'   the like button   |   omitted   the picker
  // (`true` is still accepted as a legacy spelling of 'like'.)
  //
  // INTENT, NOT INVERSION (2026-08-05). What goes on the WIRE is the END STATE this reader wants,
  // never "flip whatever you are holding". A toggle is only correct while the DOM's picture of the
  // reader's own reaction is right, and a tab left open goes stale the moment they act on another
  // device -- the owner liked a post on his phone, clicked the still-blank heart here, and the
  // toggle removed the like he already had. Every intent branch below is idempotent, so the worst a
  // stale tab can now do is agree with the server.
  //
  // THE TRANSLATION HAPPENS HERE, not at the call sites, because the belief being translated is
  // `prev.reaction` -- read off the button a few lines down, which is the only place that knows it.
  // One edit therefore covers every caller, and a caller that has no button to read (a js-react form
  // with no .react-btn) falls through to its historic mode, which is also the no-JS <form> path.
  /* `love` (optional, 0 = none) is the press-and-hold burst: where the sender's particle counter
     finished, sent ONCE on release alongside the ordinary end-state like. The server clamps it,
     turns it into a small 0-3 tier and throws the number away -- nothing persists how long anyone
     held, and the poster sees a gold heart in the (already author-private) likes sheet rather than
     a count. Omitted entirely for a plain tap, so an ordinary like sends byte-identically to what
     it always has. */
  function submitReact(form, reaction, mode, love) {
    /* MEMBERSHIP, BEFORE THE OPTIMISTIC PAINT. This is the one send every like path reaches -- the
       button (on/off), the media double-tap ('like'), the long-press picker (set/off) and the
       profile-photo badge -- which is why the check stands here and not in five click handlers.
       Same position as the app's PostCard: ahead of the store write, so the heart never fills and
       walks back. Placed before FormData so a blocked tap costs nothing at all. */
    if (membershipStop()) { return; }
    if (mode === true) mode = 'like';
    var data = new FormData(form);
    data.set('reaction', reaction);
    var post = form.closest ? form.closest('.post') : null;
    // Fall back to the form's own button when this react form isn't inside a .post (the profile-photo
    // like badge lives on the profile header) -- otherwise the optimistic paint below is skipped and the
    // heart only fills after the server round-trip.
    var btn = (post && post.querySelector('.react-btn')) || (form.querySelector ? form.querySelector('.react-btn') : null);
    var prev = btn ? { reaction: btn.getAttribute('data-reaction') || null, count: optCount(btn) } : null;
    /* toggle -> on/off: the button is lit for ANY reaction, so pressing a lit one means "off" and
       an unlit one means "on". 'on' is forceHeart, which KEEPS a deliberately chosen fire -- a
       press means "it should be on", never "make it a heart", and that is what stops a stale tab
       clobbering an emoji it did not know about.
       picker -> set/off: naming the emoji already showing means "off", anything else means "make
       it exactly this". 'set' rather than 'on' because picking heart while holding fire has to
       switch, and forceHeart would keep the fire.
       'like' (double-tap) is deliberately untouched: it is already forceHeart, already idempotent,
       and must stay the one control that can never remove anything. */
    var wire = mode;
    if (prev) {
      if (mode === 'toggle')  wire = prev.reaction ? 'off' : 'on';
      else if (!mode)         wire = prev.reaction === reaction ? 'off' : 'set';
    }
    if (wire) data.set('mode', wire); else data.delete('mode');
    // Only ever rides a completed hold, and a hold's wire is always 'on' or 'set' (2026-08-18 #2:
    // every emotion superlikes, and a burst commit is `set` + the emotion). Both are non-removing
    // -- 'on' is add-only, 'set' switches but never clears -- so there is no path on which a
    // burst count accompanies a request that could remove a like. handle_like applies `love`
    // whenever the RESULTING like is on, so this composes with either wire.
    if (love > 0 && (wire === 'on' || wire === 'set')) data.set('love', String(Math.round(love)));
    var others = null;
    if (btn) {
      others = fanOthersOf(btn);
      // computed off the WIRE mode, so the optimistic paint predicts exactly the branch the server
      // will take. Where the DOM's belief was right this is byte-identical to the old toggle paint;
      // where it was wrong the response reconciles it (applyReact below).
      var next = nextReactState(prev, reaction, wire);
      // dropping/switching my own emoji pulls it from the fan copy too (if
      // others also picked it, the server's reconcile puts it right back)
      var fan = others.filter(function (c) { return !(c === prev.reaction && next.reaction !== prev.reaction); });
      applyReactLocal(form, next, fan);
    }
    var q = form._rxq = (form._rxq || 0) + 1;
    // HOLD the like badge for the length of the write. Armed on the line that sends, which is what
    // keeps it honest across every control: the like button (now on/off), the media double-tap
    // ('like', which never unlikes) and the picker (now set/off) -- every one of them reaches this send,
    // and the paths that decide NOT to write -- likeFromMedia bailing on an already-hearted post --
    // return before submitReact is ever called, so they cannot arm a hold that nothing will
    // release. engBadgeSettle owns the release, so the reauth branch in the catch below returning
    // early cannot leave the badge stuck.
    /* The profile-photo like badge is a standalone js-react form with NO .post host, so `btn` carried
       no id and engBadgeArm hashed the hold under an empty string -- i.e. it armed nothing, and the
       12s /photo-engage poll could answer from a snapshot taken before the tap committed and walk the
       chip straight back down. Handing it the id off .pf-photo-badges is what makes the hold real. */
    var likeSettle = engBadgeArm('like', post || engPhotoIdFor(form) || btn || form);
    engBadgeSettle(postJson('/like', data), likeSettle).then(function (res) {
      if (form._rxq !== q) return;
      if (!res || res.error) {                    // server said no (rate limit, billing gate)
        if (prev) applyReactLocal(form, prev, others);
        if (res && res.error) toast(res.error);
        return;
      }
      applyReact(form, res);
    }).catch(function (err) {
      if (!err || err.message === 'reauth') return;
      if (form._rxq === q && prev) {
        applyReactLocal(form, prev, others);
        toast('Couldn’t save that reaction, check your connection');
      }
    });
  }

  /* ---- sensitive-content reveal ("I'm over 18" / "Show anyway") ----------
     A TEMPORARY bypass: it un-blurs everything on the page now and keeps gated media revealed for ~2
     hours, then the nudity filter re-engages on its own -- a one-tap 18+ confirm must never turn the
     filter off forever. Server reads the same cookie (with the same lifetime) to skip the gate. */
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('.js-nsfw-reveal') : null;
    if (!b) return;
    e.preventDefault();
    document.cookie = 'rova_adult_ok=1;path=/;max-age=7200;samesite=lax'   // ~2h, then it lapses
      + (location.protocol === 'https:' ? ';secure' : '');
    // .nsfw-locked (2026-09-30, blurred-preview-only): the server sent NO real media for these, only a
    // blurred still, so there is nothing to reveal -- they keep their veil and its sign-in/settings link
    document.querySelectorAll('.media.nsfw-gate:not(.nsfw-locked), .msg-gate.nsfw-gate').forEach(function (m) { m.classList.remove('nsfw-gate'); });   // feed cards + DM photos (db/0172)
    document.querySelectorAll('.nsfw-veil:not(.nsfw-veil-locked)').forEach(function (v) { v.remove(); });
    document.querySelectorAll('.pcell.nsfw-cell:not(.nsfw-locked)').forEach(function (c) { c.classList.remove('nsfw-cell'); });   // profile media grid
    document.querySelectorAll('.avatar.nsfw-cell').forEach(function (a) { a.classList.remove('nsfw-cell'); });  // sensitive profile photos
    document.querySelectorAll('.nsfw-gridbar').forEach(function (bar) { bar.remove(); });
  });

  /* THE OLD `.react-pop` REACTION POPOVER LIVED HERE, AND IS GONE (2026-08-08).
     The long-press carousel below (.rxc) replaced it outright: both of the popover's entry points
     -- the triple-tap on .react-btn and the triple-tap on .clike -- were rerouted to rxArm()+
     rxOpen(true), which left showReactFor() with no callers, buildReactPop() called only from
     showReactFor(), and therefore the element never created at all. hideReact()/scheduleHideReact()
     went with it: with reactPop permanently null every one of their four remaining call sites was a
     provable no-op (they only ever cleared a class on an element that no longer exists and nulled
     two variables nothing else read), so the calls were removed rather than left pointing at an
     empty function. Its CSS (.react-pop, .react-opt) is out of assets/rova.css too -- but NOT the
     `@keyframes react-pop` further down that file, which is the heart's tap animation and merely
     shares the name. */

  /* ═════════════════════════════════════════════════════════════════════════════════════════
     LONG-PRESS REACTION CAROUSEL                                          (owner, 2026-08-07)
     ═════════════════════════════════════════════════════════════════════════════════════════

     WHAT IT IS. Press and hold the heart -- finger or mouse -- and a carousel of reactions rises
     out of it. The emoji under the thumb becomes FOCUSED and plays its own emotion for as long as
     it is held (the laugh laughs, the fire flickers, the clap claps). Letting go COMMITS the
     focused one: it flies down to the like button, the heart shrinks away, and the chosen emoji
     lands in its place.

     THE ONE PLACE THE OWNER'S SPEC IS AMBIGUOUS, AND WHICH READING THIS TAKES. "when they swipe
     to and past the emoji ... it animates into the like button" can mean (a) merely passing OVER
     an emoji commits it, or (b) passing over FOCUSES it and the release commits. This is (b),
     because (a) makes the carousel impossible to browse -- you could not reach the 5th emoji
     without committing the first four on the way. Everything else he described is literal:
     the emotion animation, the tween down, the heart disappearing quickly, the replacement,
     both directions, desktop too. If he wants (a) it is one line: commit from rxFocus().

     CAROUSEL, NOT FAN, and DATA-DRIVEN. He picked the carousel explicitly so more emoji can be
     added later. The set comes from Posts_REACTIONS (which mirrors Posts::REACTIONS server-side);
     adding a code needs one RX_LABEL entry, one RX_EMO entry + its @keyframes, and NOTHING else --
     the strip already scrolls under the thumb when the content outgrows the pill.

     THE DATA MODEL IS THE ONE THAT ALREADY EXISTS. A reaction here is A LIKE THAT CARRIES A TYPE
     (`likes.reaction`), never a parallel engagement axis, so every count, gate, notification,
     ranking and insight path keeps working untouched. The write goes through submitReact()/
     submitCReact() -- the SAME primitives the plain tap uses -- so the block gate, suppression,
     the rate limiter and the notification rules are inherited rather than hand-copied, and the
     wire mode is the END STATE ('set' / 'off'), never a toggle. See handle_like() and
     Posts::setReaction(). Switching heart -> fire cannot re-notify: setReaction only reports
     notify=true when there was NO row before.

     WHAT IT COSTS WHEN NOBODY IS PRESSING: nothing. Three delegated document listeners (a passive
     touchstart, a mousedown, a keydown), no per-card listener, no MutationObserver, no rAF, and no
     DOM at all until the first long press builds the single shared pill. Everything else -- the
     touchmove/touchend pair, the mousemove/mouseup pair, the edge-scroll rAF -- is bound for the
     length of one gesture and torn down after it. Every animation is transform + opacity only.

     THE NON-PASSIVE TOUCHMOVE IS ON THE BUTTON, NEVER ON THE DOCUMENT. Touch events retarget to
     the element that received the touchstart for the whole gesture, so a listener on that one
     button sees every move of this press and nothing else. That is what lets the picker stop the
     page scrolling once it is open WITHOUT a document-wide non-passive handler.

     AND IT NEVER STEALS A SCROLL. The hold only arms; if the finger travels more than RX_SLOP
     before RX_HOLD elapses, that was a scroll, and the press is abandoned in silence -- with no
     preventDefault ever having been called on that branch, so the scroll is untouched. A plain
     tap never reaches any of this: it lifts before the timer, the timer is cleared, and the
     existing click handler does exactly what it did yesterday. */

  var RX_HOLD  = 400;    // ms of stillness before the carousel opens (spec: 350-450)
  var RX_SLOP  = 10;     // px of travel that reclassifies the press as a scroll
  /* ms of press after which sub-slop touchmoves are CONSUMED (owner 2026-08-18: "when I try to
     super like and swipe my finger to the emotion it scrolls the page instead"). iOS Safari
     decides ONCE per touch whether it may pan: any unprevented move can start one, and from then
     on every touchmove arrives cancelable:false and preventDefault is dead. A thumb "holding
     still" drifts a few px, so the drift during the 400ms hold was committing the touch to a pan
     BEFORE the row opened -- the row then presented over a gesture Safari already owned, and the
     slide to an emotion scrolled the page. A real scroll's FIRST move (fast flick or slow drag
     alike) lands within ~100ms of touchdown, so 120ms cleanly separates "this is a scroll
     starting" (unclaimed: the slop test disarms and the native pan is untouched) from "this is a
     press" (claimed: Safari can never start the pan that would strangle the row). */
  var RX_CLAIM_MS = 120;
  // The labels answer the owner's own words: LOL is 😂, "!!" is 😮, Fire is 🔥.
  var RX_LABEL = { heart: 'Like', love: 'Love', fire: 'Fire', haha: 'LOL',
                   wow: '!!', clap: 'Respect', sad: 'Sad', angry: 'Angry' };
  /* The reactors-sheet super pill's own words (owner, 2026-08-28: "This is a super laugh not a
     super love" -- a held 😂 was labelled "Super-loved" the same as a held ❤️). RX_LABEL above is
     the picker's short focus word (LOL, !!) and reads wrong stitched onto "Super-"; this is its
     own past-tense set for exactly this one sentence. Not reaction-BREAKDOWN vocabulary anywhere
     else -- the aggregate banner above the list stays the generic "N people super-loved this
     post" on purpose, because it counts every held reaction together regardless of which emoji,
     and "super-loved" is this feature's own name (superLiked, .sl) independent of the glyph. */
  var RX_SUPER = { heart: 'Super-loved', love: 'Super-loved', fire: 'Super-hyped', haha: 'Super-laughed',
                   wow: 'Super-wowed', clap: 'Super-clapped', sad: 'Super-sad', angry: 'Super-angry' };
  // ...and each one's ~1s emotion loop, played only while that emoji is the focused one.
  var RX_EMO   = { heart: 'rxHeart', love: 'rxLove', fire: 'rxFire', haha: 'rxHaha',
                   wow: 'rxWow', clap: 'rxClap', sad: 'rxSad', angry: 'rxAngry' };

  var rxc = null, rxTrack = null, rxLabel = null, rxOpts = null;
  var rxS = null;              // the entire gesture lives in this one object; null = nothing armed
  var rxSwallowUntil = 0;      // a long press must not also fire the click handler's plain like

  function rxReduced() {
    try { return window.matchMedia('(prefers-reduced-motion:reduce)').matches; } catch (e) { return false; }
  }

  /* ONE pill for the whole page, built on the FIRST long press and reused forever after. Not per
     card, not at render time -- a feed of 40 cards must not pay for a control most sessions never
     open. It is hidden (display:none) between uses, so it costs no compositing and no hit-testing. */
  function rxBuild() {
    if (rxc) return;
    rxc = document.createElement('div');
    rxc.className = 'rxc';
    rxc.hidden = true;
    rxLabel = document.createElement('span');
    rxLabel.className = 'rxc-label';
    rxLabel.setAttribute('aria-hidden', 'true');       // the radio's own aria-label is what AT reads
    var win = document.createElement('div');
    win.className = 'rxc-win';
    rxTrack = document.createElement('div');
    rxTrack.className = 'rxc-track';
    rxTrack.setAttribute('role', 'radiogroup');
    rxTrack.setAttribute('aria-label', 'Pick a reaction');
    Posts_REACTIONS.forEach(function (code) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'rxc-opt';
      b.setAttribute('data-reaction', code);
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', 'false');
      b.setAttribute('aria-label', RX_LABEL[code] || code);
      b.tabIndex = -1;                                  // roving: the focused radio takes 0
      b.style.setProperty('--emo', RX_EMO[code] || 'rxWow');
      var g = document.createElement('span');
      g.className = 'rxc-glyph';
      if (code === 'heart') { g.innerHTML = HEART_ON; } else { g.textContent = EMOJI[code] || '❤️'; }
      b.appendChild(g);
      rxTrack.appendChild(b);
    });
    win.appendChild(rxTrack);
    rxc.appendChild(win);
    rxc.appendChild(rxLabel);
    document.body.appendChild(rxc);
    rxOpts = rxTrack.children;
    // Commit by CLICK: the desktop pick, the keyboard's Enter/Space on a focused radio, and a tap
    // on an option while the picker is parked open (the triple-tap route).
    rxTrack.addEventListener('click', function (e) {
      var o = e.target.closest ? e.target.closest('.rxc-opt') : null;
      if (!o || !rxS) return;
      e.preventDefault();
      rxCommit(rxIdxOf(o));
    });
    // Desktop hover while the picker is parked open.
    rxTrack.addEventListener('mouseover', function (e) {
      var o = e.target.closest ? e.target.closest('.rxc-opt') : null;
      if (o && rxS && rxS.open && rxS.sticky) rxFocus(rxIdxOf(o));
    });
  }
  function rxIdxOf(el) { return Array.prototype.indexOf.call(rxOpts, el); }
  function rxIdxOfCode(code) {
    for (var i = 0; i < rxOpts.length; i++) {
      if (rxOpts[i].getAttribute('data-reaction') === code) return i;
    }
    return -1;
  }

  /* Which control did this press begin on? `.react-btn` is the post like button on every surface
     that renders views/_post.php (feed, permalink, immersive viewer, profile, explore, tag, saved,
     search, trend story) plus the profile-photo badge; `.clike` is the comment like button. A GUEST
     card has an <a href="/signup"> instead of either, so it matches nothing and nothing arms. */
  function rxTargetFrom(t) {
    if (!t || !t.closest) return null;
    var b = t.closest('.react-btn, .clike');
    return (b && !b.disabled) ? b : null;
  }

  /* WHICH CONTROLS ARM THE CAROUSEL ON A PRESS-AND-HOLD: both of them again (owner, 2026-08-18:
     "Optimize superlikes after presenting the emoji row first since it's interfering with the
     feature"). The love-burst round had split the gesture -- post buttons got the burst, the row
     was exiled to comment buttons / triple-tap -- because "both features want the same hold and
     only one can have it". The owner's answer is that they are ONE gesture, in sequence:

       hold a POST like button -> the emoji ROW rises first (RX_HOLD, exactly like a comment),
       and it rises CLEAN -> rest the finger on ANY ONE emotion in the row and THAT emotion's
       superlike ignites (LOVE_ROW_WAIT of stillness on it) and ramps tiers -> move to another
       emotion and the fuse restarts for it; move off and the burst stands down (no write) while
       the row behaves exactly as it always has.

     So `.react-btn` arms the carousel again, and the burst is DRIVEN BY this gesture (see
     lovRowStart / lovRowFocus in the lovb block) instead of running a competing pointer listener
     of its own -- one owner per hold, which is the whole fix. `.clike` is unchanged: comments
     have no love tier, so a comment hold is the row and nothing more. The triple-tap and the
     ArrowUp / ContextMenu keyboard path still open the PARKED picker (sticky), which never
     ignites a burst -- a burst needs a held finger. */
  function rxHoldTarget(t) {
    return rxTargetFrom(t);
  }

  function rxArm(btn, x, y, kind) {
    rxDisarm();
    var cbtn = (btn.classList && btn.classList.contains('clike')) ? btn : null;
    var form = cbtn ? null : (btn.closest ? btn.closest('form') : null);
    if (!cbtn && !form) return null;                     // no form = no way to write; leave it alone
    rxS = { btn: btn, cbtn: cbtn, form: form, kind: kind, x0: x, y0: y, t0: Date.now(),
            open: false, sticky: false, spent: false, idx: -1, tx: 0, txMin: 0, edge: 0,
            raf: 0, timer: 0, bound: null, rects: null, pill: null };
    return rxS;
  }

  function rxNoDefault(e) { if (e.cancelable) e.preventDefault(); }

  /* Tear the gesture down without committing anything. Safe to call at any point, including from
     inside rxCommit -- everything it needs is read into locals first. */
  function rxDisarm() {
    var s = rxS;
    rxS = null;
    if (!s) return;
    if (s.timer) clearTimeout(s.timer);
    if (s.raf) cancelAnimationFrame(s.raf);
    if (s.bound) {
      s.bound.removeEventListener('touchmove', rxTouchMove);
      s.bound.removeEventListener('touchend', rxTouchEnd);
      s.bound.removeEventListener('touchcancel', rxTouchCancel);
      s.bound.removeEventListener('contextmenu', rxNoDefault);
      s.bound.removeEventListener('dragstart', rxNoDefault);
    }
    document.removeEventListener('mousemove', rxMouseMove);
    document.removeEventListener('mouseup', rxMouseUp);
    window.removeEventListener('scroll', rxOnScroll, true);
    /* Any burst session opened for this gesture ends with it. A COMMITTED burst (lovS.done) is
       left alone -- its own teardown timer is running the fountain out. */
    lovRowEnd();
    if (s.open) { window.__rovaRxAt = Date.now(); rxHidePill(s); }
  }
  function rxHidePill(s) {
    if (s && s.btn) s.btn.removeAttribute('aria-expanded');
    if (!rxc) return;
    rxc.classList.remove('show', 'hot');
    for (var i = 0; i < rxOpts.length; i++) {
      rxOpts[i].classList.remove('pick', 'gone');
      rxOpts[i].setAttribute('aria-checked', 'false');
      rxOpts[i].tabIndex = -1;
    }
    rxLabel.classList.remove('on');
    rxTrack.style.transform = '';
    // let the exit transition run, then take it out of the layout/paint entirely
    clearTimeout(rxc._hideT);
    if (rxReduced()) { rxc.hidden = true; }
    else { rxc._hideT = setTimeout(function () { if (!rxS || !rxS.open) rxc.hidden = true; }, 200); }
  }

  /* Open the carousel over the pressed button. Everything the drag needs is measured HERE, once:
     the pill's box and each option's centre. Nothing reads layout again until the next open, which
     is what keeps the drag off the forced-synchronous-layout treadmill the feed is already on. */
  function rxOpen(sticky, focusIdx) {
    var s = rxS;
    if (!s || s.open) return;
    rxBuild();
    s.open = true;
    s.sticky = !!sticky;
    if (s.timer) { clearTimeout(s.timer); s.timer = 0; }
    // Origin token for the immersive viewer's pager and pull-to-dismiss: a gesture that begins on
    // the like button belongs to the like button, exactly as .vctrl already does (see pgSkip).
    window.__rovaRxAt = Date.now();

    var br = s.btn.getBoundingClientRect();
    rxc.hidden = false;
    rxc.style.left = '0px';
    rxc.style.top = '0px';
    var pw = rxc.offsetWidth, ph = rxc.offsetHeight;                       // one flush, once per open
    var vw = window.innerWidth || document.documentElement.clientWidth || 360;
    var vh = window.innerHeight || document.documentElement.clientHeight || 640;
    var cx = br.left + br.width / 2;
    var left = Math.round(Math.max(8, Math.min(cx - pw / 2, vw - pw - 8)));
    // 34px of daylight above the heart: room for the label pill that hangs under the carousel.
    var top = Math.round(br.top - ph - 34);
    var below = false;
    if (top < 8) { top = Math.round(Math.min(br.bottom + 14, vh - ph - 8)); below = true; }
    rxc.style.left = left + 'px';
    rxc.style.top = top + 'px';
    rxc.classList.toggle('below', below);
    // grow out of the heart itself, not out of the pill's middle
    rxc.style.transformOrigin = Math.round(Math.max(6, Math.min(cx - left, pw - 6))) + 'px ' + (below ? '0%' : '100%');

    /* MEASURE IN LAYOUT SPACE, NOT PAINTED SPACE. getBoundingClientRect() reports the TRANSFORMED
       box, and at this instant the pill is still at its entry transform (scale .84, +10px) because
       .show has not been added yet -- so every rect would come back 16% small and the hit test would
       land one emoji to the right of the thumb. offsetLeft/offsetWidth are untransformed layout
       values, and `left`/`top` are the untransformed position we just set, so these agree with the
       finger both during the entry animation and after it settles. */
    var winX = rxTrack.parentNode.offsetLeft || 0;
    s.pill = { left: left, right: left + pw, top: top, bottom: top + ph };
    s.rects = [];
    for (var i = 0; i < rxOpts.length; i++) {
      s.rects.push(winX + rxOpts[i].offsetLeft + rxOpts[i].offsetWidth / 2);
    }
    s.txMin = Math.min(0, rxTrack.clientWidth - rxTrack.scrollWidth);      // <0 only when it overflows
    s.tx = 0;
    s.btn.setAttribute('aria-expanded', 'true');
    void rxc.offsetWidth;                                                  // so the entry transition runs
    rxc.classList.add('show');
    /* A HELD hold on a POST like button also opens the burst's row-mode session (owner
       2026-08-18; see lovRowStart) -- BOOKKEEPING ONLY, nothing visible: the resting row is the
       clean emoji strip, and the burst draws its first pixel at IGNITION, which can only be
       reached by a finger parked on an emotion (lovRowFocus via rxPointAt). Parked pickers
       (sticky: triple-tap, keyboard) never open one -- a burst needs a held finger. Comments
       (s.cbtn) have no love tier and are untouched. */
    if (!s.sticky && s.form && !s.cbtn) lovRowStart(s, br);
    // Pre-focus, so a hold-and-release that never moved still means something: the reaction they
    // are already holding, else the heart. (Releasing on the one you already hold clears it --
    // the same "pick it again to remove it" rule the picker has always had, kept for every emoji
    // EXCEPT the held heart on a post, which is the superlike path and can never unlike.)
    var cur = s.btn.getAttribute('data-reaction') || '';
    rxFocus(typeof focusIdx === 'number' ? focusIdx : Math.max(0, rxIdxOfCode(cur)));
    if (s.sticky) window.addEventListener('scroll', rxOnScroll, { capture: true, passive: true });
  }
  // Only the PARKED picker dismisses on scroll. A drag holds the gesture (and prevents the scroll
  // outright), so a stray momentum event must not yank it out from under the finger.
  function rxOnScroll() { if (rxS && rxS.open && rxS.sticky) rxDisarm(); }

  /* Move the focus ring. Writes only on a real change, so a 120-events-per-second drag paints at
     most once per emoji crossed rather than once per event. */
  function rxFocus(i) {
    var s = rxS;
    if (!s || !s.open || s.idx === i) return;
    if (s.idx >= 0 && rxOpts[s.idx]) {
      rxOpts[s.idx].classList.remove('pick');
      rxOpts[s.idx].setAttribute('aria-checked', 'false');
      rxOpts[s.idx].tabIndex = -1;
    }
    s.idx = i;
    if (i >= 0 && rxOpts[i]) {
      var o = rxOpts[i];
      o.classList.add('pick');
      o.setAttribute('aria-checked', 'true');
      o.tabIndex = 0;
      rxLabel.textContent = RX_LABEL[o.getAttribute('data-reaction')] || '';
      rxLabel.style.setProperty('--lx', Math.round(s.rects[i] + s.tx) + 'px');
      rxLabel.classList.add('on');
      if (s.kind === 'touch' && navigator.vibrate) { try { navigator.vibrate(5); } catch (e) {} }
    } else {
      rxLabel.classList.remove('on');
    }
    rxc.classList.toggle('hot', i >= 0);
    /* NOTE the burst does NOT ride this function (owner 2026-08-18 refinement #3): rxFocus is
       also reached by the pre-focus at open and by the keyboard, and a superlike must ignite
       ONLY while the finger is actually parked on an emotion. The fuse lives in rxPointAt --
       the one caller that knows the focus came from a real pointer position. */
  }

  /* THE CAROUSEL PART. Push the thumb against either end and the strip scrolls under it, so a set
     that outgrows the pill stays reachable in both directions. The rAF exists ONLY while the finger
     is parked in an edge zone and stops itself the moment it leaves or hits the stop. */
  function rxEdge(dir) {
    var s = rxS;
    if (!s || s.edge === dir) return;
    s.edge = dir;
    if (!dir || s.raf) return;
    var step = function () {
      var st = rxS;
      if (!st || !st.open || !st.edge) { if (st) st.raf = 0; return; }
      st.tx = Math.max(st.txMin, Math.min(0, st.tx + st.edge * 7));
      rxTrack.style.transform = 'translate3d(' + st.tx + 'px,0,0)';
      if (st.idx >= 0) rxLabel.style.setProperty('--lx', Math.round(st.rects[st.idx] + st.tx) + 'px');
      if ((st.edge > 0 && st.tx >= 0) || (st.edge < 0 && st.tx <= st.txMin)) { st.edge = 0; st.raf = 0; return; }
      st.raf = requestAnimationFrame(step);
    };
    s.raf = requestAnimationFrame(step);
  }

  /* Where is the finger, and what does that mean? Pure arithmetic against the rects cached at open:
     no getBoundingClientRect, no layout read, nothing that can be forced-synchronous. */
  function rxPointAt(x, y) {
    var s = rxS;
    if (!s || !s.open) return;
    var p = s.pill;
    window.__rovaRxAt = Date.now();      // keep the viewer's pager standing down for the whole drag
    // Dragged clean off the carousel: no focus, and a release from here is a CANCEL, not a pick.
    if (y > p.bottom + 96 || y < p.top - 96 || x < p.left - 48 || x > p.right + 48) {
      rxEdge(0); rxFocus(-1); lovRowFocus(s.btn, -1); return;
    }
    rxEdge(x < p.left + 28 && s.tx < 0 ? 1 : (x > p.right - 28 && s.tx > s.txMin ? -1 : 0));
    var local = x - p.left - s.tx, best = -1, bd = 1e9;
    for (var i = 0; i < s.rects.length; i++) {
      var d = Math.abs(s.rects[i] - local);
      if (d < bd) { bd = d; best = i; }
    }
    rxFocus(best);
    /* THE FUSE, and only from here (owner 2026-08-18 refinement #3): this function is the one
       place focus provably comes from a FINGER PARKED ON AN EMOTION, so this is the only place
       a superlike may start counting down. Resting LOVE_ROW_WAIT on any one emoji ignites THAT
       emoji's superlike; moving to another restarts the fuse for the new one; the pre-focus at
       open and the keyboard path never reach this line and can never ignite. */
    lovRowFocus(s.btn, best);
  }

  /* COMMIT. The write goes first and the animation is pure decoration on top of it: the request is
     already on the wire and the button already optimistically painted before a single frame of the
     flight has rendered, so the feature adds no latency to the engagement itself. */
  function rxCommit(i) {
    var s = rxS;
    if (!s) return;
    var code = (i >= 0 && rxOpts[i]) ? rxOpts[i].getAttribute('data-reaction') : null;
    var btn = s.btn, form = s.form, cbtn = s.cbtn, held = !s.sticky;
    var from = code ? rxOpts[i].getBoundingClientRect() : null;
    if (code) rxOpts[i].classList.add('gone');           // the flier takes over from here
    rxDisarm();
    if (!code) return;
    // Straight through the SAME primitives the plain tap uses -- picker mode, so the wire carries
    // the end state ('set', or 'off' when they picked the one they were already holding).
    // EXCEPT the held HEART on a post: that is the superlike's on-ramp (a release just short of
    // ignition), and A HOLD CAN NEVER UNLIKE -- mode 'on' is add-only and idempotent, so holding
    // a post you already like re-states it instead of clearing it. The PARKED picker (sticky:
    // triple-tap, keyboard) keeps the old "pick it again to remove it" rule -- those are the
    // deliberate, accessible clear paths. [[intent-not-inversion]]
    if (cbtn) submitCReact(cbtn, code, 'pick');
    else if (form && code === 'heart' && held) submitReact(form, 'heart', 'on');
    else if (form) submitReact(form, code);
    engAttendFrom(btn);
    if (rxReduced()) return;                             // commit instantly, no flight
    rxFlight(from, btn, code);
  }

  /* The tween the owner described: the chosen emoji arcs down to the like button while the heart
     shrinks away, and lands as the button's new icon. Two transform/opacity animations and a clone
     that deletes itself -- no layout property is touched, and the optimistic repaint underneath
     happens while the icon is scaled to zero, so the swap is never visible. */
  function rxFlight(from, btn, code) {
    var ic = (btn && btn.querySelector) ? btn.querySelector('.react-ic') : null;
    var to = ic ? ic.getBoundingClientRect() : (btn ? btn.getBoundingClientRect() : null);
    if (!from || !to || !to.width) return;
    var fly = document.createElement('div');
    fly.className = 'rx-fly';
    fly.setAttribute('aria-hidden', 'true');
    if (code === 'heart') { fly.innerHTML = HEART_ON; } else { fly.textContent = EMOJI[code] || ''; }
    var fx = from.left + from.width / 2, fy = from.top + from.height / 2;
    fly.style.left = Math.round(fx) + 'px';
    fly.style.top = Math.round(fy) + 'px';
    fly.style.setProperty('--fdx', Math.round(to.left + to.width / 2 - fx) + 'px');
    fly.style.setProperty('--fdy', Math.round(to.top + to.height / 2 - fy) + 'px');
    document.body.appendChild(fly);
    if (ic) { ic.classList.remove('rx-in'); ic.classList.add('rx-out'); }
    var done = false, t = 0;
    var land = function () {
      if (done) return;
      done = true;
      clearTimeout(t);
      if (fly.parentNode) fly.parentNode.removeChild(fly);
      if (!ic) return;
      ic.classList.remove('rx-out');
      void ic.offsetWidth;
      ic.classList.add('rx-in');
      setTimeout(function () { ic.classList.remove('rx-in'); }, 420);
    };
    // animationend can be missed (a backgrounded tab, a mid-flight navigation) and .rx-out holds
    // the icon at scale 0 with `forwards` -- so the safety net is not optional here.
    t = setTimeout(land, 700);
    fly.addEventListener('animationend', land);
  }

  /* ---- touch -------------------------------------------------------------
     Passive, delegated, one listener for the whole document. It ARMS a timer and nothing else:
     no preventDefault, no DOM write, no layout read on the tap path. */
  document.addEventListener('touchstart', function (e) {
    if (e.touches.length > 1) { rxDisarm(); return; }
    var btn = rxHoldTarget(e.target);   // .react-btn or .clike; a post hold leads into the burst (lovRowStart)
    if (!btn) return;
    var t = e.touches[0];
    var s = rxArm(btn, t.clientX, t.clientY, 'touch');
    if (!s) return;
    s.timer = setTimeout(function () { rxOpen(false); }, RX_HOLD);
    // Per-GESTURE, on the button the touch will keep retargeting to. Torn down in rxDisarm, so
    // nothing survives the press and `document` never carries a non-passive touchmove.
    s.bound = btn;
    btn.addEventListener('touchmove', rxTouchMove, { passive: false });
    btn.addEventListener('touchend', rxTouchEnd, { passive: false });
    btn.addEventListener('touchcancel', rxTouchCancel);
    btn.addEventListener('contextmenu', rxNoDefault);    // no iOS callout / magnifier on a hold
    btn.addEventListener('dragstart', rxNoDefault);
  }, { passive: true });

  function rxTouchMove(e) {
    var s = rxS;
    if (!s) return;
    // SPENT: the pill is gone but the finger is still down from the auto-popped hold. Keep the
    // touch owned (no scroll starts mid-celebration) and track nothing.
    if (s.spent) { if (e.cancelable) e.preventDefault(); return; }
    if (e.touches.length > 1) { rxDisarm(); return; }    // a second finger is not this gesture
    var t = e.touches[0];
    if (!s.open) {
      /* THE SCROLL TEST. Travel before the hold elapses means the finger is scrolling the feed, so
         stand down completely. A move that lands here UNCLAIMED (first ~120ms) was never
         preventDefault-ed, so by the time we decide it was a scroll, the scroll has already been
         happening natively and is entirely unaffected -- the whole reason the feature cannot
         steal a real swipe. */
      if (Math.abs(t.clientX - s.x0) > RX_SLOP || Math.abs(t.clientY - s.y0) > RX_SLOP) { rxDisarm(); return; }
      /* THE CLAIM (see RX_CLAIM_MS): a press that has stood still past the claim window consumes
         its own sub-slop drift, so Safari can never commit this touch to a pan before the row
         opens. The one narrow cost: a finger that rests >120ms and THEN starts scrolling gets a
         dead gesture (the disarm above still runs, but a pan the browser was told to skip cannot
         start mid-touch) -- the opposite trade was the owner's bug, and a >120ms-still-then-drag
         touch reads as a press to the person making it too. */
      if (Date.now() - s.t0 >= RX_CLAIM_MS && e.cancelable) e.preventDefault();
      return;
    }
    /* OPEN: the picker owns the gesture -- unless Safari committed this touch to a pan off drift
       inside the pre-claim window (cancelable is false from then on). Half-owned is the worst
       state -- the page scrolling UNDER a live row -- so surrender cleanly: close the row and let
       the pan be a pan. */
    if (!e.cancelable) { rxDisarm(); return; }
    e.preventDefault();
    rxPointAt(t.clientX, t.clientY);
  }
  function rxTouchEnd(e) {
    var s = rxS;
    if (!s) return;
    // SPENT: the burst auto-popped earlier in this same hold (rxSpend). The write is long since
    // made -- this release only has to not become a tap.
    if (s.spent) { if (e.cancelable) e.preventDefault(); rxSwallowUntil = Date.now() + 700; rxDisarm(); return; }
    if (!s.open) { rxDisarm(); return; }                 // a plain tap: the click handler takes it
    if (e.cancelable) e.preventDefault();                // swallow the click this touch would synthesize
    rxSwallowUntil = Date.now() + 700;                   // ...and belt-and-braces for browsers that fire it anyway
    // A LIVE burst is the pick: release commits the superlike at the tier the ramp reached, and
    // the row closes with it. rxDisarm sees lovS.done and leaves the celebration to run out.
    if (lovRowLive()) { lovCommit(); rxDisarm(); return; }
    rxCommit(s.idx);
  }
  function rxTouchCancel() { rxDisarm(); }

  /* ---- mouse: click-and-hold, then drag ---------------------------------- */
  document.addEventListener('mousedown', function (e) {
    if (e.button !== 0) return;
    var btn = rxHoldTarget(e.target);   // .react-btn or .clike; a post hold leads into the burst (lovRowStart)
    if (!btn) return;
    var s = rxArm(btn, e.clientX, e.clientY, 'mouse');
    if (!s) return;
    s.timer = setTimeout(function () { rxOpen(false); }, RX_HOLD);
    s.bound = btn;
    btn.addEventListener('dragstart', rxNoDefault);
    document.addEventListener('mousemove', rxMouseMove);
    document.addEventListener('mouseup', rxMouseUp);
  });
  function rxMouseMove(e) {
    var s = rxS;
    if (!s) return;
    if (s.spent) return;                                 // see rxTouchMove
    if (!s.open) {
      if (Math.abs(e.clientX - s.x0) > RX_SLOP || Math.abs(e.clientY - s.y0) > RX_SLOP) rxDisarm();
      return;
    }
    rxPointAt(e.clientX, e.clientY);
  }
  function rxMouseUp() {
    var s = rxS;
    if (!s) return;
    // SPENT: see rxTouchEnd -- the auto-popped hold's release must not become a click-toggle.
    if (s.spent) { rxSwallowUntil = Date.now() + 700; rxDisarm(); return; }
    if (!s.open) { rxDisarm(); return; }
    rxSwallowUntil = Date.now() + 700;
    // same rule as rxTouchEnd: a live burst is the pick
    if (lovRowLive()) { lovCommit(); rxDisarm(); return; }
    rxCommit(s.idx);
  }

  /* ---- keyboard ----------------------------------------------------------
     The picker has to be reachable and selectable with no pointer at all. Enter and Space are left
     alone -- they are the plain like, and they must stay it. ArrowUp (the picker rises upward), the
     ContextMenu key and Alt+Enter open it; focus then moves into a real radio, so a screen reader
     announces "Pick a reaction, LOL, radio 4 of 8". Arrows move, Enter/Space commit, Escape cancels
     and hands focus back to the like button. */
  document.addEventListener('keydown', function (e) {
    if (e.altKey && e.key !== 'Enter') return;
    var s = rxS;
    if (!s || !s.open) {
      if (e.ctrlKey || e.metaKey) return;
      if (e.key !== 'ArrowUp' && e.key !== 'ContextMenu' && !(e.key === 'Enter' && e.altKey)) return;
      var btn = rxTargetFrom(document.activeElement);
      if (!btn) return;
      e.preventDefault();
      var st = rxArm(btn, 0, 0, 'key');
      if (!st) return;
      st.kbd = true;
      rxOpen(true);
      if (rxS && rxS.idx >= 0) rxOpts[rxS.idx].focus();
      return;
    }
    if (e.key === 'Escape' || e.key === 'Tab') {
      var back = s.btn;
      if (e.key === 'Escape') e.preventDefault();
      rxDisarm();
      if (back && back.focus) back.focus();
      return;
    }
    if (!s.kbd) return;                                  // a drag is in progress; keys are not its business
    if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
      e.preventDefault();
      var n = rxOpts.length;
      var next = ((s.idx < 0 ? 0 : s.idx) + (e.key === 'ArrowRight' ? 1 : -1) + n) % n;
      rxFocus(next);
      // keep the moved-to option inside the pill when the set has outgrown it
      var over = s.rects[next] + s.tx;
      if (over < 26) { s.tx = Math.min(0, 26 - s.rects[next]); }
      else if (over > (s.pill.right - s.pill.left) - 26) { s.tx = Math.max(s.txMin, (s.pill.right - s.pill.left) - 26 - s.rects[next]); }
      rxTrack.style.transform = 'translate3d(' + s.tx + 'px,0,0)';
      rxLabel.style.setProperty('--lx', Math.round(s.rects[next] + s.tx) + 'px');
      rxOpts[next].focus();
      return;
    }
    if (e.key === 'Home' || e.key === 'End') {
      e.preventDefault();
      rxFocus(e.key === 'Home' ? 0 : rxOpts.length - 1);
      rxOpts[rxS.idx].focus();
      return;
    }
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
      e.preventDefault();
      var bk = s.btn;
      rxSwallowUntil = Date.now() + 700;
      rxCommit(s.idx);
      if (bk && bk.focus) bk.focus();
    }
  });

  // A pointer press anywhere else closes a parked picker (the keyboard / triple-tap route).
  document.addEventListener('pointerdown', function (e) {
    if (!rxS || !rxS.open || !rxS.sticky) return;
    if (e.target.closest && (e.target.closest('.rxc') || e.target.closest('.react-btn, .clike'))) return;
    rxDisarm();
  }, true);

  // Heart taps: each tap TOGGLES (tap = like, tap again = unlike -- people need to undo a mistaken
  // like); the 3rd quick tap opens the full reaction set. Any other tap dismisses the picker
  // (choosing an emoji dismisses it too). No hover/long-press popover: it kept getting in the way
  /* ==== PRESS AND HOLD -> ROW, THEN LOVE BURST ("lovb") ========================================
     The web twin of the app's src/loveBurst.js + LoveBurstHost.js + reactPicker.js. Every constant
     below is duplicated from src/loveBurst.js on purpose and the two must be changed together --
     the alternative is a shared build step between a PHP site and an Expo app, which does not
     exist and is not worth inventing for eleven numbers.

     THE ARC (owner 2026-08-18, finalized the same day: the row presents FIRST and stays CLEAN;
     EVERY emotion superlikes; ignition needs the finger PARKED ON an emotion)
       0ms            finger down. Nothing committed; a scroll can still take this away.
       RX_HOLD 400    THE ROW RISES -- the same reaction carousel a comment hold gets, heart
                      pre-focused. This is the "hold looks different from a tap" moment, and it
                      is ALL that is visible: no ring, no counter shell, no overlay ("I shouldn't
                      see the empty little box ... if I'm not doing a super like yet").
       park + 300     IGNITE, only once the finger has RESTED LOVE_ROW_WAIT on one emotion IN the
                      row (rxPointAt is the fuse's only door -- the pre-focus and the keyboard
                      cannot ignite). THAT emotion's superlike starts: ring meter, fountain of
                      that emoji (hearts stay the rose->gold trio), counter, vibration ramp.
                      Moving to another emotion restarts the fuse for it; moving off stands the
                      burst down. No write on any of those paths.
       +RAMP 2400     HARD CAP -> AUTO-POP: the burst releases ITSELF, finger still down. There is
                      no reward for sitting on the button and the gesture always ends gracefully.
       release        ONE write: `set` + the emotion + the counter (super-fire is mode=set&
                      reaction=fire&love=N; the tier rides the like row whatever it carries) --
                      OR, un-ignited, the focused emoji through the picker's own commit. Never
                      both: a live burst IS the pick.

     ONE OWNER PER HOLD, WHICH IS THE WHOLE 2026-08-18 FIX. This block no longer runs pointer
     listeners of its own -- the old pointerdown/move/up quartet raced the carousel for the same
     gesture, which is exactly why the two features had been split across surfaces. The burst is
     now a SERVICE the carousel gesture drives: rxOpen -> lovRowStart, rxFocus -> lovRowFocus,
     rxTouchEnd/rxMouseUp -> lovCommit, rxDisarm -> lovRowEnd. The carousel's own scroll test,
     non-passive touchmove ownership and swallow timestamps therefore cover the burst for free.

     WHAT IT WILL NOT DO
       * It cannot unlike. A burst commit sends mode='set' + the emotion (idempotent when the like
         already carries it, a switch when it does not, never a removal), so super-liking a post
         you already like replays the celebration and re-states the end state. Only the plain tap
         below carries the toggle -- and a hold-release on the focused HEART (too short to
         ignite) is mode='on', never the picker's clear. [[intent-not-inversion]]
       * It cannot inflate a like count: one hold is one like, exactly like one tap.
       * It cannot fire by accident and stay fired: sliding off the heart stands it down with no
         write at all, and an ordinary unlike afterwards clears the tier server-side.

     PERFORMANCE, because scroll-perf is sacred here
       * Particles are a fixed pool of 26 nodes in ONE fixed-position layer, animated with the Web
         Animations API on transform + opacity only -- compositor-side, and no
         `remove -> void offsetWidth -> add` reflow per heart, which at ~21 hearts a second would
         have been 21 forced layouts a second.
       * The layer is created on the FIRST hold and reused for the life of the page. A feed of 40
         cards pays nothing for a gesture most sessions never make.
       * One rAF drives the whole hold and only WRITES (a transform, a dash offset, two opacities
         and a text node). It reads no geometry: the button's box arrives from rxOpen's one
         measured rect, and a tap on the like button now costs LESS than before -- the old
         pointerdown ran lovBuild() + getBoundingClientRect on every tap; rxArm reads nothing.
       * Everything is torn down on release, and a stranded animation cannot outlive its node --
         see [[stranded-recycled-standins-leak-animations]] for why that is stated explicitly. */
  var LOVE_CAP = 100, LOVE_ROW_WAIT = 300, LOVE_RAMP = 2400;
  var LOVE_HAPTIC_MAX = 3000, LOVE_POOL = 26;
  var LOVE_HUES = { rose: '#ff5a6a', roseDeep: '#e0344a', gold: '#f5c518', goldDeep: '#b8860b', white: '#fff6dc' };
  var lovLayer = null, lovPool = null, lovAnims = null, lovCursor = 0;
  var lovS = null;   // the whole gesture lives in this one object; null = nothing armed
  /* currentColor, NOT the #ff2b55 that HEART_ON bakes in: every heart here is tinted individually
     (the particle mix warms from rose to gold as the ramp climbs), and a baked fill cannot be. */
  var LOVE_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + HP + '" fill="currentColor"/></svg>';

  function lovBuild() {
    if (lovLayer) return;
    lovLayer = document.createElement('div');
    lovLayer.className = 'lovb';
    lovLayer.setAttribute('aria-hidden', 'true');
    lovLayer.innerHTML =
      '<svg class="lovb-ring" viewBox="0 0 68 68"><circle cx="34" cy="34" r="30"/></svg>' +
      '<div class="lovb-h"><span class="lovb-h1">' + LOVE_SVG + '</span>' +
        '<span class="lovb-h2">' + LOVE_SVG + '</span><span class="lovb-h3">' + LOVE_SVG + '</span></div>' +
      // the growing centre glyph for a NON-heart superlike: the emotion itself (2026-08-18 #2,
      // "each emoji should have a super like function"). The heart keeps its rose->gold trio.
      '<div class="lovb-e"><span></span></div>' +
      '<div class="lovb-n"><span></span></div>';
    lovPool = []; lovAnims = [];
    for (var i = 0; i < LOVE_POOL; i++) {
      var p = document.createElement('i');
      p.className = 'lovb-p';
      p.innerHTML = LOVE_SVG;
      lovLayer.appendChild(p);
      lovPool.push(p); lovAnims.push(null);
    }
    document.body.appendChild(lovLayer);
  }

  /* Which colour the NEXT heart should be. Rova is gold-and-dark, not a magenta ramp, so the
     escalation is a TEMPERATURE change: rose at the bottom, gold-hot at the top, with the metal
     arriving late enough to feel earned. */
  function lovHue(p, r) {
    if (p < 0.22) return r < 0.72 ? LOVE_HUES.rose : LOVE_HUES.roseDeep;
    if (p < 0.45) return r < 0.46 ? LOVE_HUES.rose : (r < 0.72 ? LOVE_HUES.roseDeep : LOVE_HUES.gold);
    if (p < 0.75) return r < 0.30 ? LOVE_HUES.rose : (r < 0.78 ? LOVE_HUES.gold : LOVE_HUES.goldDeep);
    return r < 0.20 ? LOVE_HUES.rose : (r < 0.82 ? LOVE_HUES.gold : LOVE_HUES.white);
  }

  /* One heart. Seven independent random axes -- drift, rise, rotation, scale, sway, lifetime and
     hue -- because "every heart is slightly different" is the most-credited detail in this whole
     feature class, and uniformity is exactly what makes a fountain look cheap. */
  function lovEmit(p) {
    var s = lovS; if (!s) return;
    var i = lovCursor % LOVE_POOL; lovCursor = i + 1;
    var el = lovPool[i];
    if (lovAnims[i]) { try { lovAnims[i].cancel(); } catch (e) {} lovAnims[i] = null; }
    /* THEMED PER EMOTION (2026-08-18 #2): a heart superlike keeps the tinted heart SVGs; any
       other emotion rains ITSELF. Pool nodes swap content lazily and remember what they hold,
       so a steady ramp swaps each node at most once. Emoji are full-colour glyphs -- no hue. */
    var want = s.code === 'heart' ? '' : (s.code || '');
    if (el._emo !== want) {
      el._emo = want;
      if (want) { el.textContent = EMOJI[want] || ''; el.classList.add('emo'); }
      else { el.innerHTML = LOVE_SVG; el.classList.remove('emo'); }
    }
    var spread = 26 + 34 * p;
    var dx = (Math.random() * 2 - 1) * spread;
    var rise = 120 + Math.random() * 90 + 60 * p;
    var rot = (Math.random() * 2 - 1) * 30;
    var sc = 0.38 + Math.random() * 0.42 + 0.18 * p;
    var sway = (Math.random() * 2 - 1) * (8 + 10 * p);
    var life = Math.round((1250 - 380 * p) * (0.85 + Math.random() * 0.3));
    var x0 = s.cx, y0 = s.cy - 12;
    if (!want) el.style.color = lovHue(p, Math.random());
    try {
      lovAnims[i] = el.animate([
        { transform: 'translate3d(' + x0 + 'px,' + y0 + 'px,0) scale(' + (sc * 0.55) + ') rotate(0deg)', opacity: 0 },
        { opacity: 1, offset: 0.1 },
        { transform: 'translate3d(' + (x0 + dx * 0.5 + sway) + 'px,' + (y0 - rise * 0.62) + 'px,0) scale(' + sc + ') rotate(' + (rot * 0.5) + 'deg)', opacity: 0.95, offset: 0.5 },
        { transform: 'translate3d(' + (x0 + dx) + 'px,' + (y0 - rise) + 'px,0) scale(' + (sc * 0.92) + ') rotate(' + rot + 'deg)', opacity: 0 }
      ], { duration: life, easing: 'cubic-bezier(.22,.7,.3,1)', fill: 'forwards' });
    } catch (e) { /* no WAAPI: the hold still works, it just has no fountain */ }
  }

  /* Vibration. Android Chrome honours it; iOS Safari has no Vibration API at all and this degrades
     to silence with no branch. Its own rising schedule rather than one buzz per count -- the
     counter passes 40/s at the top of the ramp -- and it stops dead at LOVE_HAPTIC_MAX even with
     the finger still down, because sustained vibration is a battery and annoyance cost. */
  function lovBuzz(p) {
    if (!navigator.vibrate) return;
    try { navigator.vibrate(p < 0.25 ? 7 : (p < 0.6 ? 12 : 20)); } catch (e) {}
  }

  /* The ramp, and ONLY the ramp (2026-08-18 refinement #1: "I shouldn't see the empty little box
     ... if I'm not doing a super like yet"). This rAF starts at IGNITION (lovIgniteAt) and there
     is no fuse rendering at all -- before ignition the resting row is the clean emoji strip, and
     the first burst pixel (ring, glyph, counter, fountain) appears in the same frame the
     fountain starts. The ring is purely the tier meter now. */
  function lovFrame(now) {
    var s = lovS; if (!s || s.done || !s.live) return;
    s.raf = requestAnimationFrame(lovFrame);

    var p = Math.min(1, (now - s.tIg) / LOVE_RAMP);
    s.p = p;
    s.ring.style.strokeDashoffset = String(188.5 * (1 - p));

    /* KEEP THE IMMERSIVE VIEWER'S PAGER AND PULL-TO-DISMISS STANDING DOWN. This is the documented
       house mechanism (the carousel stamps the same token on every drag frame): a gesture that
       began on the like button belongs to the like button. `.vctrl` already covers the viewer's
       control bar via pgSkip, but the token also covers the pull-to-dismiss, which pgSkip does not. */
    window.__rovaRxAt = Date.now();

    var at = 'translate3d(' + s.cx + 'px,' + s.cy + 'px,0)';
    if (!s.reduced) {
      /* 1.0 -> 3.5 (owner, 2026-08-27: "the emoji should keep growing while they are holding" --
         the old 2.2 cap with a 0.7 exponent front-loaded the growth and read as a plateau after
         the first second). The exponent moves to 0.9, near-linear, so the swelling is VISIBLY
         still happening in the back half of the ramp rather than done early. */
      s.glyph.style.transform = at + ' scale(' + (1 + 2.5 * Math.pow(p, 0.9)) + ')';
      // Monotonic: nothing in this feature oscillates in opacity. Flashing burst animations are
      // the genre's worst press -- they produced migraine and photosensitivity reports elsewhere.
      // The rose->gold->white shimmer belongs to the heart trio; an emoji is its own colour.
      if (s.code === 'heart') {
        s.g2.style.opacity = String(Math.max(0, Math.min(1, (p - 0.45) / 0.5)));
        s.g3.style.opacity = String(Math.max(0, Math.min(1, (p - 0.75) / 0.25)) * 0.85);
      }
      if (now >= s.nextEmit) { lovEmit(p); s.nextEmit = now + (120 - 74 * p); }
    } else {
      s.glyph.style.transform = at + ' scale(' + (1 + 0.35 * p) + ')';
    }

    var n = Math.max(1, Math.min(LOVE_CAP, Math.ceil(LOVE_CAP * Math.pow(p, 1.35))));
    if (n !== s.n) {
      s.n = n;
      s.num.textContent = String(n);
      lovLayer.classList.toggle('t2', n >= 40);
      lovLayer.classList.toggle('t3', n >= LOVE_CAP);
    }
    if (now - s.tIg < LOVE_HAPTIC_MAX && now >= s.nextBuzz) {
      lovBuzz(p); s.nextBuzz = now + (190 - 128 * p);
    }
    if (p >= 1) lovCommit();                       // AUTO-POP at the cap
  }

  /* THE STRIKE. One 620ms entry, on the one button that was held, at the moment the burst commits.
     It is the whole motion budget of the resting indicator: nothing animates at rest, on any card,
     ever, so a feed of 40 super-liked posts costs the same per frame as a feed of none.

     Fired from lovCommit rather than from lovTeardown, which runs ~1.4s later by design (the
     fountain has to finish before the feed is allowed to move) -- the strike has to land WITH the
     state, not a second and a half behind it.

     NOTHING CAN STRAND. The ring is a transient child created here and removed three ways, any one
     of which is sufficient: animationend, an 800ms timeout backstop (which also covers the case
     where a reduced-motion media query suppresses the animation so animationend never fires), and
     lovTeardown, which is session-pinned and runs exactly once for every ending. The .sl-strike
     class on the button is dropped by the same three. */
  function lovStrike(btn) {
    if (!btn || rxReduced()) return null;
    var ring;
    try {
      ring = document.createElement('i');
      ring.className = 'sl-ring';
      ring.setAttribute('aria-hidden', 'true');
      btn.appendChild(ring);
    } catch (e) { return null; }
    btn.classList.add('sl-strike');
    var done = function () {
      if (ring && ring.parentNode) ring.parentNode.removeChild(ring);
      if (btn.classList) btn.classList.remove('sl-strike');
    };
    try { ring.addEventListener('animationend', done, { once: true }); } catch (e) {}
    var t = setTimeout(done, 800);
    return { ring: ring, btn: btn, t: t, done: done };
  }
  function lovStrikeStop(st) {
    if (!st) return;
    clearTimeout(st.t);
    try { st.ring.getAnimations().forEach(function (a) { a.cancel(); }); } catch (e) {}
    st.done();
  }

  function lovTeardown(sess) {
    /* `sess` pins a DELAYED teardown to the session that scheduled it: a fresh hold can begin
       inside the 1400ms a celebration takes to run out, and the old timer must not be allowed to
       tear down the new session's live state. A direct call (no arg) still means "whatever is
       current". */
    var s = lovS; if (!s || (sess && sess !== s)) return;
    lovS = null;
    /* THE GRIP RELEASES HERE, and here only. Every ending reaches this function -- lovCommit and
       lovRowEnd both schedule it, and the `if (!s) return` above makes it exactly-once -- so the
       pairing is structural rather than something each exit path has to remember. Idempotent
       anyway (engGrip deletes a key that may already be gone), and ceilinged besides, so even a
       teardown that somehow never ran could not strand the reel.
       RELEASED AT TEARDOWN RATHER THAN AT COMMIT, which on a completed hold is ~1.4s later, on
       purpose: that is the length of the fountain, and the hearts finish their arc before the
       feed is allowed to think about moving. The full dwell hands-free then re-arms starts from
       this moment, so the reader still gets a whole window to look at what they just loved. */
    engGrip('love', false);
    if (s.raf) cancelAnimationFrame(s.raf);
    /* The strike is normally long finished by the time teardown runs (620ms against ~1.4s), so this
       is the backstop for the endings that do not wait: a teardown forced early, or a fresh hold
       that begins inside the celebration. Idempotent -- done() is safe to run twice. */
    if (s.slStrike) { lovStrikeStop(s.slStrike); s.slStrike = null; }
    if (s.btn) s.btn.classList.remove('lovb-src');
    if (lovLayer) lovLayer.classList.remove('on', 'live', 'fly', 't2', 't3');
    if (rxc) rxc.classList.remove('lovlive');
    /* Park everything off-screen and CANCEL the flight animation. Cancelling matters: a
       fill:'forwards' animation left standing would hold the heart at the top of its arc forever
       and the next hold would inherit it -- the stranded-animation failure this codebase has been
       bitten by before ([[stranded-recycled-standins-leak-animations]]). */
    if (s.heart) {
      try { s.heart.getAnimations().forEach(function (a) { a.cancel(); }); } catch (e) {}
      s.heart.style.transform = 'translate3d(-9999px,-9999px,0)';
    }
    if (s.emoEl) {
      try { s.emoEl.getAnimations().forEach(function (a) { a.cancel(); }); } catch (e) {}
      s.emoEl.style.transform = 'translate3d(-9999px,-9999px,0)';
    }
    if (s.ringEl) s.ringEl.style.transform = 'translate3d(-9999px,-9999px,0)';
    if (s.numEl) s.numEl.style.transform = 'translate3d(-9999px,-9999px,0)';
    if (s.g2) s.g2.style.opacity = '0';
    if (s.g3) s.g3.style.opacity = '0';
    if (s.num) s.num.textContent = '';
    try { if (navigator.vibrate) navigator.vibrate(0); } catch (e) {}
  }

  function lovCommit() {
    var s = lovS; if (!s || s.done || !s.code) return;
    s.done = true;
    /* max(1, ...): a release in the same beat as ignition can land before the first rAF has set
       s.n, and a live burst must never commit with love=0 -- the reader rested the full fuse on
       this emotion, which is tier-1 intent by definition (the old lovFrame's n floor, restored). */
    var n = Math.max(1, s.n), form = s.form, glyph = s.glyph, reduced = s.reduced;
    // The click this gesture is about to synthesize must NOT also fire the plain toggle. Same
    // timestamp guarantee the carousel uses, and the click handler below already reads it.
    rxSwallowUntil = Date.now() + 700;
    if (navigator.vibrate) { try { navigator.vibrate([0, 14, 40, 26]); } catch (e) {} }   // release crescendo
    /* THE WRITE, per-emotion (2026-08-18 #2): `set` makes the like exactly this emotion --
       idempotent when it already is, a switch when it is not, NEVER a removal -- and `love`
       upgrades the row's tier. handle_like applies the tier whenever the resulting like is ON
       (index.php:17360 gates on the RESULT's reaction, not the mode), and love_tier rides the
       (user,post) like row regardless of which emotion it carries (db/0152; MAX-write, survives
       a later switch), so super-fire and super-heart are the same one column and
       Posts::superLoveCount keeps counting both. */
    if (form) submitReact(form, s.code, 'set', n);
    /* THE RESTING STATE LANDS HERE, on the reader's own frame, and does not wait for the network:
       this gesture is the one thing that can turn `sl` on, and it has already been sent as `love`
       on a wire mode ('set') that cannot remove a like. The server's answer reconciles the exact
       tier a moment later through applyReactToPost -- and if the request dies, that same path and
       the optimistic rollback both clear it. Painted on EVERY on-screen copy of the post, so the
       immersive viewer and the feed card behind it cannot disagree.
       The strike itself plays only on the button actually held. */
    if (s.btn) {
      var slPost = s.btn.closest ? s.btn.closest('.post') : null;
      var slVid  = slPost && (slPost.getAttribute('data-view') || slPost.getAttribute('data-id'));
      var slAll  = slVid ? document.querySelectorAll('.post[data-view="' + slVid + '"] .react-btn') : [s.btn];
      Array.prototype.forEach.call(slAll, function (b) { b.classList.add('sl'); slAria(b); });
      s.slStrike = lovStrike(s.btn);
    }
    /* AUTO-POP with the finger still down: the pill closes now, but the rx gesture stays claimed
       (rxSpend) so the eventual release still swallows its own click however long the finger
       lingers -- a fixed 700ms stamp cannot cover an open-ended hold. On a release-commit the
       caller's rxDisarm follows immediately and this is a no-op on an already-hidden pill. */
    rxSpend();
    if (rxc) rxc.classList.remove('lovlive');

    if (reduced) { lovTeardown(); return; }
    // The big glyph -- heart trio or the emotion itself -- flies up and out of the frame. Fades
    // LATE so it is still solid while it is climbing and disappears as it leaves, not halfway up.
    lovLayer.classList.add('fly');
    var base = 'translate3d(' + s.cx + 'px,' + s.cy + 'px,0)';
    // MUST match lovFrame's live curve exactly, or the glyph snaps to a different
    // size on the frame the flight takes over from the ramp.
    var sc = 1 + 2.5 * Math.pow(s.p, 0.9);
    try {
      glyph.animate([
        { transform: base + ' scale(' + sc + ')', opacity: 1 },
        { opacity: 1, offset: 0.55 },
        { transform: 'translate3d(' + s.cx + 'px,' + (s.cy - window.innerHeight - 160) + 'px,0) scale(' + (sc * 1.9) + ')', opacity: 0 }
      ], { duration: 760, easing: 'cubic-bezier(.2,.7,.25,1)', fill: 'forwards' });
    } catch (e) {}
    // Outlive the LAST particle (lifetimes top out ~1250ms) or teardown would snap a screenful of
    // them out of existence mid-arc.
    lovS = { done: true, raf: 0, btn: s.btn, heart: s.heart, emoEl: s.emoEl, glyph: glyph,
             g2: s.g2, g3: s.g3, num: s.num, numEl: s.numEl, ring: s.ring, ringEl: s.ringEl };
    var holder = lovS;
    setTimeout(function () { lovTeardown(holder); }, 1400);
  }

  /* ---- the row-mode session API the carousel gesture drives ------------------------------------
     No pointer listeners of its own any more (2026-08-18): rxOpen/rxFocus/rxTouchEnd/rxMouseUp/
     rxDisarm are the only callers, so exactly one owner tracks the finger and the old
     280ms-vs-400ms race between the burst and the row is gone by construction. */

  /** Is a burst currently burning (release must commit the superlike, not an emoji pick)? */
  function lovRowLive() {
    return !!(lovS && lovS.live && !lovS.done);
  }

  /* Open a session for the held gesture that just presented the carousel over a POST like button.
     BOOKKEEPING ONLY (2026-08-18 refinement #1): nothing is drawn, positioned, or classed here --
     the `on` class, the anchor and the glyph choice all happen at IGNITION, so the resting row is
     the clean emoji strip with no empty counter shell, no ring, no overlay anywhere near it. The
     one non-visual side effect is the hands-free grip (owner 2026-08-16; derivation at engGrip):
     the reel must not advance out from under a reader browsing a carousel, burst or no burst.
     Released in lovTeardown, which every ending funnels through. */
  function lovRowStart(rx, br) {
    lovTeardown();                                 // a stranded session cannot survive a new open
    lovBuild();
    lovS = {
      btn: rx.btn, form: rx.form, rx: rx, t0: performance.now(), tIg: 0, p: 0, n: 0,
      cx: br.left + br.width / 2, cy: br.top + br.height / 2,   // fallback anchor; re-aimed at ignite
      fuse: 0, fuseIdx: -1, code: null, live: false, done: false,
      nextEmit: 0, nextBuzz: 0, raf: 0, reduced: rxReduced(),
      heart: lovLayer.querySelector('.lovb-h'),
      emoEl: lovLayer.querySelector('.lovb-e'),
      emoSpan: lovLayer.querySelector('.lovb-e span'),
      glyph: lovLayer.querySelector('.lovb-h'),
      g2: lovLayer.querySelector('.lovb-h2'),
      g3: lovLayer.querySelector('.lovb-h3'),
      num: lovLayer.querySelector('.lovb-n span'),
      numEl: lovLayer.querySelector('.lovb-n'),
      ringEl: lovLayer.querySelector('.lovb-ring'),
      ring: lovLayer.querySelector('.lovb-ring circle')
    };
    engGrip('love', true);
  }

  /* THE FUSE (2026-08-18 refinement #3, the finalized trigger rule): a superlike ignites ONLY
     while the finger rests on a specific emotion in the presented row. Called exclusively from
     rxPointAt with the pointer-derived focus index -- the pre-focus at open and the keyboard can
     never reach it. Every focus CHANGE restarts the fuse for the new emotion; leaving the row
     (idx -1) or changing emotion mid-ramp stands the burst down with no write. */
  function lovRowFocus(btn, i) {
    var s = lovS;
    if (!s || s.done || btn !== s.btn) return;
    if (i === s.fuseIdx) return;                   // same emotion: fuse keeps burning / ramp keeps ramping
    if (s.fuse) { clearTimeout(s.fuse); s.fuse = 0; }
    if (s.live) lovStandDown(s);                   // moved off mid-ramp: no write, ever, on this path
    s.fuseIdx = i;
    if (i < 0) return;
    var code = rxOpts[i] ? rxOpts[i].getAttribute('data-reaction') : null;
    if (!code) return;
    s.fuse = setTimeout(function () { lovIgniteAt(i, code); }, LOVE_ROW_WAIT);
  }

  /* IGNITION -- the first frame anything burst-related becomes visible. Anchored at the FOCUSED
     EMOTION (which rides 15px high under the finger), not at the like button: the fountain rises
     out of the emotion being super-liked, the counter sits in clear air above the row, and
     nothing covers the resting strip because nothing exists until this line runs. */
  function lovIgniteAt(i, code) {
    var s = lovS, rx = rxS;
    if (!s || s.done || s.live || rx !== s.rx || !rx.open || rx.idx !== i) return;
    s.fuse = 0;
    s.code = code;
    s.live = true;
    s.tIg = performance.now();
    s.p = 0; s.n = 0; s.nextEmit = 0; s.nextBuzz = 0;
    s.cx = rx.pill.left + rx.rects[i] + rx.tx;
    s.cy = (rx.pill.top + rx.pill.bottom) / 2 - 15;
    var at = 'translate3d(' + s.cx + 'px,' + s.cy + 'px,0)';
    // the growing centre glyph: the heart trio for the heart, the emotion itself for the rest
    if (code === 'heart') {
      s.glyph = s.heart;
      s.emoEl.style.transform = 'translate3d(-9999px,-9999px,0)';
    } else {
      s.glyph = s.emoEl;
      s.emoSpan.textContent = EMOJI[code] || '';
      s.heart.style.transform = 'translate3d(-9999px,-9999px,0)';
      s.g2.style.opacity = '0';
      s.g3.style.opacity = '0';
    }
    s.glyph.style.transform = at + ' scale(1)';
    s.ringEl.style.transform = at;
    s.numEl.style.transform = at;
    s.ring.style.strokeDashoffset = '188.5';
    lovLayer.classList.add('on', 'live');
    if (rxc) rxc.classList.add('lovlive');
    s.raf = requestAnimationFrame(lovFrame);
  }

  /* Put a burning burst away with NO write -- the row stays up and keeps working. */
  function lovStandDown(s) {
    s.live = false;
    s.code = null;
    s.n = 0;
    if (s.raf) { cancelAnimationFrame(s.raf); s.raf = 0; }
    if (s.num) s.num.textContent = '';
    lovLayer.classList.remove('on', 'live', 't2', 't3');
    if (rxc) rxc.classList.remove('lovlive');
    if (s.g2) s.g2.style.opacity = '0';
    if (s.g3) s.g3.style.opacity = '0';
    if (s.heart) s.heart.style.transform = 'translate3d(-9999px,-9999px,0)';
    if (s.emoEl) s.emoEl.style.transform = 'translate3d(-9999px,-9999px,0)';
    if (s.ringEl) s.ringEl.style.transform = 'translate3d(-9999px,-9999px,0)';
    if (s.numEl) s.numEl.style.transform = 'translate3d(-9999px,-9999px,0)';
    if (s.ring) s.ring.style.strokeDashoffset = '188.5';
    try { if (navigator.vibrate) navigator.vibrate(0); } catch (e) {}
  }

  /* rxDisarm's hook: the gesture ended without a commit (slide-off release, touchcancel, second
     finger, teardown of the pill for any reason). A COMMITTED session is mid-celebration and owns
     its own delayed teardown -- leave it to run out. */
  function lovRowEnd() {
    var s = lovS;
    if (!s || s.done) return;
    s.done = true;
    if (s.fuse) { clearTimeout(s.fuse); s.fuse = 0; }
    if (s.live) rxSwallowUntil = Date.now() + 400;   // a cancelled burst must not tap-toggle behind itself
    if (s.raf) { cancelAnimationFrame(s.raf); s.raf = 0; }
    if (lovLayer) lovLayer.classList.remove('on', 'live');
    if (rxc) rxc.classList.remove('lovlive');
    if (s.live) { setTimeout(function () { lovTeardown(s); }, 1400); }   // let in-flight hearts finish their arc
    else { lovTeardown(); }
  }

  /* The burst auto-popped with the finger still down: the pill closes now, but the rx gesture
     stays CLAIMED, so however long the finger lingers the eventual release still swallows its own
     click (rxTouchEnd/rxMouseUp read s.spent) instead of racing a 700ms stamp. */
  function rxSpend() {
    var s = rxS;
    if (!s) return;
    s.spent = true;
    if (s.open) { window.__rovaRxAt = Date.now(); rxHidePill(s); s.open = false; }
  }

  // of plain likes.
  var heartTaps = 0, heartTimer = null, heartForm = null;
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('.react-btn') : null;
    // (a tap anywhere else used to dismiss the old .react-pop popover; that popover is gone, and
    // the carousel dismisses itself through rxDisarm's own capture-phase handler above)
    if (!b) return;
    e.preventDefault();   // we drive the like ourselves (stops the form submit)
    /* A LONG PRESS ALREADY DECIDED THIS ONE. touchend/mouseup preventDefault the synthesized click,
       but not every browser honours that on every path, so the timestamp is the guarantee: the tap
       path is only ever reached by an actual tap. Nothing above this line costs the tap anything --
       it is one integer compare. */
    if (Date.now() < rxSwallowUntil) { rxSwallowUntil = 0; return; }
    if (rxS && rxS.open && rxS.sticky) { rxDisarm(); return; }   // pressing the heart closes a parked picker
    var form = b.closest('form');
    if (!form) return;
    if (heartForm !== form) { heartTaps = 0; heartForm = form; }
    heartTaps++;
    clearTimeout(heartTimer);
    if (heartTaps >= 3) {          // triple tap: the full reaction set
      heartTaps = 0;
      // Routed at the CAROUSEL, so a post has exactly ONE reaction picker however you reach it
      // (hold, triple-tap, ArrowUp). Parked open: pick with a tap or a click.
      if (rxArm(b, 0, 0, 'touch')) { rxOpen(true); }
      return;
    }
    heartTimer = setTimeout(function () { heartTaps = 0; }, 450);
    // Celebrate only when this tap ADDS a reaction. Firing the burst + pop while unliking read as
    // "it liked again", which is exactly the confusion this fix is about.
    var liking = !b.getAttribute('data-reaction');
    if (liking) {
      var ic = b.querySelector('.react-ic');
      if (ic) { ic.classList.remove('pop'); void ic.offsetWidth; ic.classList.add('pop'); }
      var post = b.closest('.post');
      var media = post ? post.querySelector('.media') : null;
      if (media) heartBurst(media);
    }
    submitReact(form, 'heart', 'toggle');   // optimistic: paints now, server reconciles
  });

  // tapX/tapY: viewport coords of the SECOND tap, so the burst pops where the finger landed
  // (owner: IG parity). quiet: post the like but draw nothing here -- the lightbox paints its own
  // heart on the overlay, and bursting on its hidden source too would double-draw.
  function likeFromMedia(media, tapX, tapY, quiet) {
    // PUT A VIDEO BACK THE WAY IT WAS. The single-tap play/pause below runs on a timer that is
    // deliberately SHORTER than the double-tap window (a lone tap must not feel laggy), so on a
    // slower double tap the clip has already toggled by the time the second tap resolves as a like.
    // A double tap is not a play/pause, so undo it: without this, one "like" gesture also stops the
    // clip, which is exactly how this read to the owner as "double tap to like doesn't work on
    // videos -- it just pauses". _vtapUndo is stamped by that timer and only by that timer.
    var undo = media && media._vtapUndo;
    if (undo && undo.v && Date.now() - undo.at < 900) {
      media._vtapUndo = null;
      try {
        if (undo.wasPaused) { undo.v._userPaused = true; undo.v.pause(); }
        else { undo.v._userPaused = false; var _up = undo.v.play(); if (_up && _up.catch) _up.catch(function () {}); }
      } catch (e0) {}
    }
    if (!quiet) { dtapBurst(media, tapX, tapY); }   // the gold pop+embers+flight (was the white heartBurst)
    var post = media.closest('.post');
    if (!post) return;
    var form = post.querySelector('.js-react');
    if (!form) { setTimeout(function () { if (window.__rovaWelcome && window.__rovaWelcome()) return; location.href = joinHref(); }, 220); return; } // logged-out: heart, then send them to sign up (log in, in the app); a pending import gets its setup sheet (welcome-feed.js)
    var btn = form.querySelector('.react-btn');
    if (btn && btn.getAttribute('data-reaction') === 'heart') return; // already hearted
    submitReact(form, 'heart', 'like');       // idempotent heart, never removes (mode=like/forceHeart)
  }

  // Is this element the one the IMMERSIVE VIEWER is showing? The viewer is a snap scroller with one post
  // per screen, so the post in view is always the one straddling the viewport centre. Used by the two
  // places a tap can start or unmute a clip, because the viewer positions its target card ASYNCHRONOUSLY
  // -- a fast tap can land on a card that is on its way out, and acting on it leaves a second clip
  // running that the reader is not looking at (and, for a card the hero handoff then swaps, cannot even
  // reach). Detached elements report a 0x0 rect, so this also catches those.
  function pfCentredEl(el) {
    if (!el || !el.isConnected) { return false; }
    var r = null;
    try { r = el.getBoundingClientRect(); } catch (e) { return false; }
    if (!r || r.width < 4 || r.height < 4) { return false; }
    var cy = (window.innerHeight || document.documentElement.clientHeight || 0) / 2;
    return r.top <= cy && r.bottom >= cy;
  }
  // single click (image) -> lightbox; double click/tap (image or video) -> like
  var lastEl = null, lastTime = 0, singleTimer = null;
  // Exposed so OTHER scopes (the pfeed's swipe-touchend handler) can wipe this single/double-tap latch after a
  // swipe -- they reference lastEl/singleTimer directly today, which is a ReferenceError from their scope
  // ("singleTimer is not defined" on every pfeed swipe), so the intended "a swipe clears the latch so the next
  // tap-to-zoom is clean" never ran. Call this instead.
  window.__rovaTapReset = function () { clearTimeout(singleTimer); singleTimer = null; lastEl = null; lastTime = 0; };
  document.addEventListener('click', function (e) {
    var img = e.target.closest ? e.target.closest('.post .media img') : null;
    var vid = e.target.closest ? e.target.closest('.post .media video') : null;
    var media = img ? img.closest('.media') : (vid ? vid.closest('.media') : null);
    if (!media) return;
    // inside a carousel the "unit" (what carries has-vctrl / pf-zoomable / the control bar) is the
    // individual slide, so a tap on a photo slide never controls the video slide next to it
    var unit = (img || vid) ? ((img || vid).closest('.cslide') || media) : media;
    // where the tap landed (viewport px), captured now so the pfeed photo zoom below can focus on that exact
    // point instead of the center (owner: "zoom in closest to the point of my click").
    var _tcx = (e.clientX != null) ? e.clientX : (e.touches && e.touches[0] ? e.touches[0].clientX : null);
    var _tcy = (e.clientY != null) ? e.clientY : (e.touches && e.touches[0] ? e.touches[0].clientY : null);

    // A double-tap-to-like (the touch handler below) stamps media._tdblAt. Ignore ANY click that lands
    // within 400ms of one -- a double-tap synthesizes leftover clicks whose timing can outrace the
    // singleTimer clear on some browsers, and this guarantees a double-tap never ALSO zooms, pauses,
    // unmutes, or opens the viewer, regardless of that race.
    if (media._tdblAt && Date.now() - media._tdblAt < 400) { e.preventDefault(); return; }

    // SOUND FIRST: while a pfeed clip is playing MUTED, a tap ANYWHERE on it turns sound on and keeps it
    // PLAYING -- it must never pause. Done RIGHT HERE, synchronously in the tap's gesture, because iOS only
    // allows unmuting a <video> from inside a real user gesture -- a setTimeout (the play/pause timer
    // below) is no longer "in a gesture", which is exactly why the "Tap for sound" pill and screen taps
    // weren't unmuting on iPhone and a tap felt like it just paused. A double-tap still LIKES: the touch
    // handler below swallows the second tap, and setting lastEl here lets a desktop double-click register.
    /* ...OR ONE THIS TAP HAS ALREADY BEEN SPENT ON. promoteSound() runs on the pointerup UNDER this
       click (see the sound closure) and can have unmuted this very clip a few milliseconds ago, which
       would leave `vid.muted` false here and drop the tap through to the play/pause branch below --
       turning a tap for sound into a tap that stops the video. The mark says "this gesture was
       already about sound", so the branch still owns it and still returns. */
    if (vid && (vid.muted || (vid._sndPromotedAt && Date.now() - vid._sndPromotedAt < 700))
        && media.closest('.pfeed')) {
      /* ...but only for the post the viewer is actually SHOWING. The immersive viewer positions the
         tapped card asynchronously, so a fast second tap (the owner's grid double tap) can land on a
         card that is about to be scrolled away -- and unmuting THAT one leaves it audible alongside the
         one that lands, because the engine's soundfollow sweep only runs for a genuine user
         volumechange and the landing clip is unmuted programmatically (__rovaSyncSound). The viewer is
         snap-scrolled one post per screen, so "in view" is exactly "straddles the viewport centre".
         Note this tests the ELEMENT's rect, not the tap point: a tap high or low on the post in view
         still turns its sound on, which is the behaviour this branch exists for. */
      if (!pfCentredEl(vid)) { return; }
      /* ...AND TAKE IT BACK IF THE VIEWER MOVES ON. Centred-at-this-instant is not the same as centred
         when the viewer comes to rest: an opening viewer scrolls its target card into place AFTER the
         first cards render, so the card under the finger during a grid double tap can be centred now and
         gone a moment later. Measured in WebKit with real touch: the second tap unmuted a card that was
         centred at that instant, the viewer then scrolled to the target, and BOTH clips were left
         audible. The unmute itself must stay synchronous (iOS only allows it inside the gesture), so we
         re-check afterwards instead of refusing: if this clip is no longer the one in view, mute it and
         hand the sound to whatever landed. A steady-state tap keeps its clip centred, so this is a no-op
         for every ordinary tap; the checks are staggered so a slow settle is still caught. */
      var _reclaim = function () {
        // applySound already knows the whole rule -- "the current post's clip is the only audible one" --
        // and it mutes every other `.post .media video` through engineMute (correctly stamped, so it can
        // never be mistaken for the user muting or clobber the stored preference). Asking it again once
        // the open has come to rest fixes BOTH directions of this race: the tap having unmuted a card the
        // viewer then scrolled past, and the hero handoff having unmuted whichever card happened to be
        // centred when it revealed. It is a no-op for an ordinary tap on a settled viewer.
        if (window.__rovaSyncSound) { try { window.__rovaSyncSound(); } catch (e4) {} }
      };
      e.preventDefault();
      if (vid.muted) { vid.muted = false; }              // volumechange -> soundOn=true, mutes the others
      if (window.__rovaSoundGranted) { try { window.__rovaSoundGranted(); } catch (e6) {} }
      engVideo(vid);                                     // engage-hold: a tap for sound IS a deliberate watch
      if (vid.paused) { var _pr = vid.play(); if (_pr && _pr.catch) _pr.catch(function () {}); }
      // ...and WebKit silently PAUSES a clip unmuted out of the muted-autoplay allowance, which is
      // the other half of "I heard it for a second". See soundRepair() in the sound closure.
      if (window.__rovaSoundRepair) { try { window.__rovaSoundRepair(vid); } catch (e5) {} }
      if (unit.__vcShow) unit.__vcShow();
      lastEl = media; lastTime = Date.now();             // a quick second tap still counts as a double (like)
      setTimeout(_reclaim, 600); setTimeout(_reclaim, 1600);
      return;
    }

    var now = Date.now();
    if (lastEl === media && now - lastTime < 220) {     // second click = double (window tightened so single-tap opens read snappy)
      clearTimeout(singleTimer); singleTimer = null;
      lastEl = null; lastTime = 0;
      e.preventDefault();
      // a desktop double-CLICK selects whatever's under the cursor (the image/
      // caption tints blue) before we ever see it — wipe that selection so the
      // like is clean (owner: "double tapping a photo highlights the image")
      try { var s = window.getSelection && window.getSelection(); if (s && s.removeAllRanges) s.removeAllRanges(); } catch (e2) {}
      likeFromMedia(media, _tcx, _tcy);   // burst at the SECOND click's point, per the owner's IG brief
    } else {                                            // maybe a single
      // A tap that lands JUST outside the 220ms double window (say 230ms) reaches this branch and used to
      // overwrite singleTimer while the FIRST tap's timer was still pending -- both then fired, so the
      // viewer opened (or the video toggled) twice off one gesture. Whatever the previous tap armed is
      // superseded by this one, so retire it before taking the slot.
      clearTimeout(singleTimer); singleTimer = null;
      lastEl = media; lastTime = now;
      if (vid && unit.classList.contains('has-vctrl')) {   // tap a video body -> play/pause (Twitter-style)
        // TWO double-tap detectors watch a video, with DIFFERENT windows, and this timer races both:
        // the click path below (220ms, click-to-click) and -- inside the pfeed only -- the raw-touch path
        // (DTAP, measured from the first finger UP to the second finger DOWN).
        //
        // THE WAIT IS NOT WHAT MAKES THE LIKE WORK ANY MORE, and it must not grow again. Widening this
        // to outlast the double-tap window is what a "double tap does nothing but pause" report tempts
        // you into, and it taxes EVERY lone tap: measured on the shipped build, one tap took 376-428ms
        // to pause the clip. The raw-touch handler now (a) retires this timer on the second finger DOWN,
        // before it can fire, and (b) stamps _vtapUndo so a double that resolves LATER still puts the
        // clip back (see likeFromMedia). Both are free; a longer timer is not.
        var _tapInPf = !!(media.closest && media.closest('.pfeed'));
        singleTimer = setTimeout(function () {
          singleTimer = null;
          /* RE-VALIDATE THE SUBJECT BEFORE ACTING ON IT (owner 2026-08-06: "double tapping media on the
             grid ... the audio plays twice and I can't stop the first/second playing sound in the
             background until I reload"). This timer captured `vid` up to 320ms ago, and in that window
             the viewer can have taken the element away underneath it:

               tap 1 opens the immersive viewer over the grid; tap 2 of the same double tap therefore
               lands on the viewer's freshly-rendered card <video> and arms THIS timer on it; the hero
               handoff then replaceChild()s that placeholder out of the card (heroExpand's reveal) and
               the timer fires .play() on an element that is no longer in the document.

             A detached <video> keeps playing AUDIO, and every stop path in this file works by querying
             the DOM -- close(), clearPfeedList, __rovaReleaseVideos, the grid's release() -- so nothing
             the user can touch can ever reach it again: only a reload silences it. Traced with real
             touch on the grid (Chromium + WebKit): two copies of the same clip audible, one of them
             DETACHED and unstoppable.
             The same window also lets the viewer settle on a DIFFERENT post than the one tapped (the
             open scrolls the target card into place asynchronously), and starting a clip the reader is
             no longer looking at is the same defect with the element still attached -- inside the
             snap-scrolled viewer the post in view is always the one straddling the centre, so require
             that too. Outside the viewer nothing moves under the finger, so the plain tap is untouched. */
          if (!vid.isConnected || vid._released) {
            if (window.__rovaStopOrphanMedia) { window.__rovaStopOrphanMedia(); }   // and silence it if it is already running
            return;
          }
          if (_tapInPf && !pfCentredEl(vid)) { return; }
          var wasPaused = vid.paused;
          if (vid.paused) { vid._userPaused = false; engVideo(vid); vid.play().catch(function () {}); }   // engage-hold: tapped = engaged, muted or not
          else { vid._userPaused = true; vid.pause(); }
          if (unit.__vcShow) unit.__vcShow();
          media._vtapUndo = { v: vid, wasPaused: wasPaused, at: Date.now() };   // a late double-tap reverts this
        }, _tapInPf ? 320 : 240);
      } else if (img && !media.closest('.pfeed')) {   // in the vertical feed the photo is already big; no nested viewer
        var postEl = media.closest('.post');
        var pid = postEl && postEl.getAttribute('data-view');
        singleTimer = setTimeout(function () {
          singleTimer = null;
          function openLbFallback() {
            var imgs = Array.prototype.slice.call(media.querySelectorAll('img'));
            openGallery(imgs.map(function (im) { return im.currentSrc || im.src; }), Math.max(0, imgs.indexOf(img)), media);
          }
          // a Giphy gif never opens the TikTok viewer (it's excluded from the swipe list); a tap
          // just gets the simple lightbox
          if (/giphy\.com/i.test(img.currentSrc || img.getAttribute('src') || '')) { openLbFallback(); return; }
          // tap media in the feed -> immersive TikTok viewer over ALL of the page's media,
          // landing on the tapped post. Back closes it, returning to the feed.
          if (pid && window.__rovaFeedView && window.__rovaPageMediaIds) {
            var fids = window.__rovaPageMediaIds();
            if (fids.indexOf(pid) >= 0) {
              // open the viewer on the exact slide tapped, so a photo next to a video opens the PHOTO
              var tSlide = img.closest('.cslide');
              var si = tSlide ? Array.prototype.indexOf.call(tSlide.parentNode.children, tSlide) : 0;
              // clip = where the tapped photo is ACTUALLY visible on screen (the hero grows FROM here). In a
              // slideshow a non-current slide sits off-center -- a peeking neighbour is mostly OFF-screen to the
              // side, so its own rect starts the hero off-screen and it sweeps in sideways (owner: "opening with
              // a left swipe"). Use the visible intersection of the tapped slide with the media window instead;
              // when only a thin sliver peeks, fall back to the whole media box so the photo zooms straight up
              // from the centred card (parity with a single photo), never a horizontal slide.
              var mediaRect = media.getBoundingClientRect();
              var slideRect = (tSlide || media).getBoundingClientRect();
              var vx = Math.max(slideRect.left, mediaRect.left), vr = Math.min(slideRect.right, mediaRect.right);
              var vy = Math.max(slideRect.top, mediaRect.top),  vb = Math.min(slideRect.bottom, mediaRect.bottom);
              var hzClip = (vr - vx) > mediaRect.width * 0.34 && vb > vy   // >~1/3 visible: grow from where it sits (2-up); a thin peek recentres
                ? { left: vx, top: vy, width: vr - vx, height: vb - vy, right: vr, bottom: vb }
                : mediaRect;
              // FULL grid parity (owner: "use the grid photo opening everywhere"): heroExpand is the
              // grid tile's composited crop-flight -- the exact mirror of the dismiss -- so a card
              // photo now lifts off the post identically to a grid cell, replacing the old heroZoom.
              // THE TAP IS CONFIRMED HERE (a single, not the first half of a double-tap like, which clears this
              // timer): pin the card's drift at this frame, immediately before the flight measures it.
              if (window.__rovaKbPinCard) { window.__rovaKbPinCard(img); }
              if (window.__rovaHeroExpand) { window.__rovaHeroExpand(hzClip, img.currentSrc || img.src, null, img); }
              else { heroZoom(img.getBoundingClientRect(), img.currentSrc || img.src, img.naturalWidth, img.naturalHeight, false, true, hzClip, null, null, img); }
              window.__rovaFeedView(fids, pid, si); return;
            }
          }
          // fallback: rich fullscreen viewer scoped to the AUTHOR's photos
          if (pid && window.__rovaGalleryOpen) {
            /* A GESTURE MAY NOT WAIT ON THE NETWORK (2026-08-09). This is a TAP, and until this read
               resolved the tap did NOTHING VISIBLE -- no lightbox, no spinner, no flight. It was on
               bare fetch() with no deadline, so on a half-open socket "nothing visible" lasted for
               however long the platform took to give up: 60-120s on iOS Safari. That is not a slow
               open, it is a tap the app appears to have ignored, and it is exactly the shape the
               owner described.

               1800ms, and a SHORT one on purpose: this is a gesture budget, not a background load,
               so it sits well under the 8s used for loads nobody is staring at. A whole trip is
               ~0.5s on congested LTE and ~1.2s at 900ms RTT, so it cannot fire on a link that is
               merely bad. What it buys is that the worst case DEGRADES instead of blocking --
               openLbFallback() opens the images already decoded inside the tapped post, needing no
               network whatsoever, so the reader always gets a viewer. Author-scoped rather than
               post-scoped is a smaller gallery; a dead tap is a broken app. */
            rfetch('/user-media?post=' + encodeURIComponent(pid),
                  { headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' }, 1800)
              .then(function (r) { return r.json(); })
              .then(function (d) {
                if (d && d.ids && d.ids.length) window.__rovaGalleryOpen(d.ids, d.start || 0);
                else openLbFallback();
              })
              .catch(openLbFallback);
            return;
          }
          openLbFallback();
        }, 240);   // > the 220ms double-tap window, so a double-tap-to-like clears this before it fires
        // (was 330/300: the dead wait before the open read as "sluggish" next to the grid's instant flight)
      } else if (img && media.closest('.pfeed') && unit.classList.contains('pf-zoomable')) {
        // Tap toggles zoom. On a WIDE / desktop viewport a PORTRAIT photo zoomed to fill the WIDTH gets its
        // top & bottom cropped, so "zoomed in" becomes a vertical PAN scroller (pf-vscroll) that reveals
        // them (centered first, then pan up/down; a fresh swipe at the edge advances the feed). Tapping
        // again shows the whole frame. On a phone, or for a landscape photo, there's nothing to pan to --
        // keep the plain whole<->cover toggle (round 23: portraits don't pan on a phone).
        singleTimer = setTimeout(function () {
          singleTimer = null;
          var im = unit.querySelector('img');
          // the tapped point as a % of the media box, so the zoom focuses THERE, not on the center
          var zr = unit.getBoundingClientRect();
          var ox = (_tcx != null && zr.width) ? Math.max(0, Math.min(100, (_tcx - zr.left) / zr.width * 100)) : 50;
          var oy = (_tcy != null && zr.height) ? Math.max(0, Math.min(100, (_tcy - zr.top) / zr.height * 100)) : 50;
          var wide = window.innerWidth > window.innerHeight;
          var portraitImg = im && im.naturalHeight > im.naturalWidth * 1.02;
          if (wide && portraitImg) {
            if (unit.classList.contains('pf-vscroll')) {          // zoomed -> back to the whole frame
              unit.classList.remove('pf-vscroll'); unit.classList.add('pf-uncrop');
              unit.style.removeProperty('--pf-pan');
            } else {                                              // whole -> zoom to fill width + pan to the tapped row
              unit.classList.add('pf-vscroll'); unit.classList.remove('pf-uncrop');
              requestAnimationFrame(function () {
                var ih = im.getBoundingClientRect().height, range = unit.clientHeight - ih;   // <= 0
                // put the tapped fraction of the image at the viewport middle, clamped to the scroll range
                var want = unit.clientHeight * 0.5 - ih * (oy / 100);
                unit.style.setProperty('--pf-pan', (range < 0 ? Math.max(range, Math.min(0, want)) : 0) + 'px');
              });
            }
          } else {
            var wasWhole = unit.classList.contains('pf-uncrop');   // whole now -> this tap zooms IN to cover
            unit.classList.toggle('pf-uncrop');
            // zoom IN -> anchor the cover-crop on the tapped point, but ONLY in the axis that actually
            // OVERFLOWS. A cover fit fills one axis EXACTLY (zero slack) and crops the other; panning the
            // exact-fit axis pulls the image off that edge and a gap opens ("zoom in doesn't fill the screen").
            // So keep the exact-fit axis centred (50%) and only shift the cropped axis toward the tap. Which
            // axis fits vs overflows = the img-aspect vs box-aspect compare. Zoom OUT (whole) -> reset to centre.
            if (im) {
              var oxc = ox, oyc = oy;
              if (im.naturalWidth && im.naturalHeight && zr.width && zr.height) {
                if ((im.naturalWidth / im.naturalHeight) > (zr.width / zr.height)) { oyc = 50; }   // wider than box: height fits -> centre Y, pan X
                else { oxc = 50; }                                                                  // taller than box: width fits -> centre X, pan Y
              }
              im.style.transformOrigin = wasWhole ? (oxc + '% ' + oyc + '%') : '';
            }
          }
          // #50: this tap just changed what is hidden -- zooming IN starts a crop that must become
          // pannable, zooming OUT (pf-uncrop / pf-vscroll) leaves nothing to pan. Re-mark the unit AFTER
          // the .4s zoom transition has settled, so the axis is measured from the resting geometry and
          // not from a half-animated frame. (Every gesture re-marks too, so this is only about not
          // leaving a stale pf-ypan/pf-hpan on a photo that is now whole.)
          setTimeout(function () { if (window.__rovaPhotoPan) { window.__rovaPhotoPan(unit); } }, 450);
        }, 330);   // ZOOM waits past the double-tap window so a double-tap-to-like never also zooms
      }
    }
  });

  // Double-tap-to-like from RAW TOUCHES (pfeed): the click path above only works once the scroll has
  // fully settled, because while the pfeed's snap animation is still decelerating the browser consumes
  // a tap to STOP the scroll and never synthesizes a click for it -- so an Instagram-reflex double-tap
  // in the last moments of a swipe just died. Touch events still fire during deceleration, so detect
  // the double-tap here and like immediately, without waiting for the media to be perfectly still.
  (function () {
    var tEl = null, tAt = 0, tX = 0, tY = 0, sX = 0, sY = 0, moved = true, downAt = 0;
    var TAPSEL = '.pfeed .media img, .pfeed .media video';
    /* HOW LONG A DOUBLE TAP MAY TAKE, measured from the first finger UP to the second finger DOWN.
       It used to be measured finger-up to finger-UP, which charged the gesture for how long the
       SECOND tap was held -- and that is not part of a double tap at all. Measured on the shipped
       build with real touch, a normal-speed double tap (about 90ms of contact, 140ms in the air)
       came out at 310-350ms up-to-up but only 180-226ms up-to-down: it missed the old 300ms bound
       every single time (0/10 on a video AND 0/10 on a photo) while a deliberately fast one passed
       10/10. So the gesture was not "broken on videos" so much as scored wrong for everybody -- the
       reason it READ as video-only is that on a photo the miss is silent, while on a video the miss
       is loud: the first tap's play/pause fires and the clip visibly stops.
       350 also matches the __rovaMediaTapAt window used elsewhere in this file. */
    var DTAP = 350;
    document.addEventListener('touchstart', function (e) {
      moved = e.touches.length > 1;                        // a pinch is never a tap
      sX = e.touches[0].clientX; sY = e.touches[0].clientY; downAt = Date.now();
      // SECOND FINGER DOWN INSIDE THE WINDOW, ON THE SAME MEDIA -> retire the first tap's pending
      // single action now, instead of letting it fire and be undone a few frames later. The undo in
      // likeFromMedia is the safety net for the paths that never reach here (a desktop double-click,
      // a very slow double tap); this is what keeps the clip from visibly stuttering under a gesture
      // that is about to resolve as a like. If this turns out to be a swipe rather than a tap, the
      // action we dropped was a play/pause on a slide the finger is already leaving.
      if (tEl && downAt > tAt && downAt - tAt < DTAP &&
          Math.abs(sX - tX) < 80 && Math.abs(sY - tY) < 80) {
        var h2 = e.target.closest ? e.target.closest(TAPSEL) : null;
        if (h2 && h2.closest('.media') === tEl) { clearTimeout(singleTimer); singleTimer = null; }
      }
    }, { passive: true, capture: true });
    document.addEventListener('touchmove', function (e) {
      var t = e.touches[0];
      if (Math.abs(t.clientX - sX) > 12 || Math.abs(t.clientY - sY) > 12) { moved = true; }   // a swipe, not a tap
    }, { passive: true, capture: true });
    // NOT passive: on a detected double-tap we preventDefault() to swallow the synthesized click, so
    // the click path's pending single-tap action (play/pause, zoom) can't fire on top of the like.
    document.addEventListener('touchend', function (e) {
      var t = e.changedTouches && e.changedTouches[0]; if (!t) { tEl = null; return; }
      var hit = e.target.closest ? e.target.closest(TAPSEL) : null;
      var media = hit ? hit.closest('.media') : null;
      var now = Date.now();
      // DOUBLE-TAP = LIKE, checked BEFORE the `moved` bail: a 2nd tap NEAR the 1st within the window counts
      // even if the finger DRIFTED a little (a reflexive Instagram double-tap is rarely pixel-still). Letting
      // that drift fall through to the `moved` bail used to hand the gesture to the pfeed's pull-to-dismiss,
      // which CLOSED the viewer instead of liking -- the owner's "double-tapping to like exits the pfeed".
      // __rovaMediaTapAt (stamped here AND on the first tap below) tells the pull-to-dismiss to stand down.
      // `downAt` is THIS tap's finger-down. `downAt > tAt` is load-bearing: a touchend that arrives
      // without its own touchstart (a second finger lifting) would otherwise score a negative, i.e.
      // in-window, interval and like the post off one contact. `now - downAt <= 500` keeps the second
      // contact a TAP -- a tap followed by a press-and-hold is not a double tap.
      if (media && tEl === media && downAt > tAt && downAt - tAt < DTAP && now - downAt <= 500 &&
          Math.abs(t.clientX - tX) < 80 && Math.abs(t.clientY - tY) < 80) {
        tEl = null; window.__rovaMediaTapAt = now;
        e.preventDefault();                                 // no synthesized click for this second tap
        clearTimeout(singleTimer); singleTimer = null;      // kill the first tap's pending single action
        lastEl = null; lastTime = 0;
        if (now - (media._tdblAt || 0) > 500) {             // dedupe vs the click-path double
          media._tdblAt = now;
          likeFromMedia(media, t.clientX, t.clientY);       // burst at the second FINGER's point (pfeed coords matter)
        }
        return;
      }
      if (moved) { tEl = null; return; }                    // a swipe (not a tap) never arms a double
      if (!media) { tEl = null; return; }
      // A LONG PRESS (> 500ms) is iOS's photo callout, not a tap: drop it + swallow its synthesized click,
      // or it pairs with the NEXT tap as a "double" and eats that tap's zoom (owner report).
      if (now - downAt > 500) { tEl = null; e.preventDefault(); return; }
      tEl = media; tAt = now; tX = t.clientX; tY = t.clientY; window.__rovaMediaTapAt = now;   // arm 1st-of-double
    }, { passive: false, capture: true });
  })();

  /* ---- share button ---------------------------------------------------- */
  /**
   * Glassy confirmation sheet (owner #166): a dark-glass card over a dimmed
   * veil, gold primary action, resolves with the chosen action's `value`
   * (null on cancel/veil-tap). All content is set via textContent — safe for
   * user-derived strings like @handles.
   *   glassConfirm({title, body, actions:[{label, value, style:'primary'|'ghost'}]})
   *
   * OPTIONS ADDED 2026-08-04 for the onboarding step interstitial, which needed a one-button
   * sheet rather than a yes/no question:
   *   noCancel     drop the trailing Cancel button. Escape and a veil tap still dismiss, so the
   *                sheet is never a trap; it just stops a "Cancel" appearing under a message
   *                whose only sensible answer is "ok".
   *   cancelLabel  rename that button when it is kept.
   *
   * ACCESSIBILITY LANDED IN THE SHARED HELPER, NOT IN ONE CALLER. This was a dialog with no
   * role, no label, no Escape and no focus handling: keyboard users could not close it and a
   * screen reader announced nothing, on every surface that uses it (unfollow, and two more).
   * Fixing it here fixes all of them, and it is why the onboarding sheet did not need to be a
   * second modal implementation. Escape resolves null, which is exactly what Cancel and a veil
   * tap already resolved, so no existing caller sees a new outcome.
   */
  var gconfirmSeq = 0;
  function glassConfirm(opts) {
    return new Promise(function (resolve) {
      var prevFocus = document.activeElement;
      var uid = 'gconfirm-' + (++gconfirmSeq);
      var veil = document.createElement('div');
      veil.className = 'gconfirm-veil';
      var card = document.createElement('div');
      card.className = 'gconfirm glass';
      card.setAttribute('role', 'dialog');
      card.setAttribute('aria-modal', 'true');
      card.setAttribute('aria-labelledby', uid + '-t');
      var h = document.createElement('div');
      h.className = 'gconfirm-title';
      h.id = uid + '-t';
      h.textContent = opts.title || 'Are you sure?';
      card.appendChild(h);
      if (opts.body) {
        var b = document.createElement('div');
        b.className = 'gconfirm-body';
        b.id = uid + '-b';
        b.textContent = opts.body;
        card.setAttribute('aria-describedby', uid + '-b');
        card.appendChild(b);
      }
      var row = document.createElement('div');
      row.className = 'gconfirm-acts';
      var settled = false;
      function done(v) {
        if (settled) { return; }
        settled = true;
        document.removeEventListener('keydown', onKey, true);
        veil.classList.remove('on');
        setTimeout(function () { veil.remove(); }, 180);
        // Put the caret back where the member left it. Never let a restore throw into the
        // resolve below: the whole point of this sheet is that dismissing it always continues.
        try { if (prevFocus && prevFocus.focus) { prevFocus.focus(); } } catch (e) {}
        resolve(v);
      }
      /* Escape closes, and Tab stays inside the sheet. Capture phase so a page-level keydown
         listener cannot eat the Escape first. */
      function onKey(ev) {
        if (ev.key === 'Escape') { ev.preventDefault(); done(null); return; }
        if (ev.key !== 'Tab') { return; }
        var f = card.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        if (!f.length) { return; }
        var first = f[0], last = f[f.length - 1];
        if (ev.shiftKey && document.activeElement === first) { ev.preventDefault(); last.focus(); }
        else if (!ev.shiftKey && document.activeElement === last) { ev.preventDefault(); first.focus(); }
      }
      (opts.actions || []).forEach(function (a) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'btn sm ' + (a.style === 'primary' ? 'primary' : (a.style === 'danger' ? 'primary is-danger' : 'gold-ghost'));
        btn.textContent = a.label;
        /* opts.onAction IS A SYNCHRONOUS ESCAPE HATCH, AND IT EXISTS FOR THE KEYBOARD (2026-09-14).
           This sheet answers through a Promise, and a .then() callback is a microtask -- already
           outside the task the tap ran in, which is all iOS Safari needs to refuse to raise the
           software keyboard for a programmatic .focus(). A caller that has to put the caret in a
           real text field therefore cannot do it from .then(); it does it here, in the button's
           own click handler, still holding the user activation.
           CALLED AFTER done() ON PURPOSE: done() restores focus to whatever held it before the
           sheet opened, so running first would simply have that restore take the caret back. */
        btn.addEventListener('click', function () {
          done(a.value);
          if (typeof opts.onAction === 'function') { try { opts.onAction(a.value); } catch (e) {} }
        });
        row.appendChild(btn);
      });
      if (!opts.noCancel) {
        var cancel = document.createElement('button');
        cancel.type = 'button';
        cancel.className = 'btn sm gconfirm-cancel';
        cancel.textContent = opts.cancelLabel || 'Cancel';
        cancel.addEventListener('click', function () { done(null); });
        row.appendChild(cancel);
      }
      card.appendChild(row);
      veil.appendChild(card);
      veil.addEventListener('click', function (ev) { if (ev.target === veil) done(null); });
      document.body.appendChild(veil);
      document.addEventListener('keydown', onKey, true);
      // Focus NOW, and again on the next frame. The rAF alone left a window of one or more
      // frames where the sheet was on screen with focus still on the page behind it, which
      // WebKit hit intermittently: Escape went to the page, not the dialog. Focusing twice is
      // free and closes the gap; the second call is what covers browsers that refuse to focus
      // an element in the same task it was appended.
      var firstBtn = card.querySelector('button');
      if (firstBtn) { try { firstBtn.focus(); } catch (e) {} }
      requestAnimationFrame(function () {
        veil.classList.add('on');
        if (firstBtn && !card.contains(document.activeElement)) { try { firstBtn.focus(); } catch (e) {} }
      });
    });
  }
  window.glassConfirm = glassConfirm;   // shared: any surface can ask glassily

  function toast(msg, ms, action) {
    var t = document.createElement('div');
    t.className = 'toast';
    t.textContent = msg;
    // optional tappable link (e.g. "Nudity settings" -> /settings). href/label are trusted (server
    // or code), never user content; keep the message itself as textContent for safety.
    if (action && action.href) {
      t.appendChild(document.createTextNode(' '));
      var a = document.createElement('a');
      a.className = 'toast-link';
      a.href = action.href;
      if (action.target) { a.target = action.target; a.rel = 'noopener'; }
      a.textContent = action.label || 'Open';
      t.appendChild(a);
      if (!ms) ms = 6000;            // give them time to read + tap
    }
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('show'); });
    setTimeout(function () {
      t.classList.remove('show');
      setTimeout(function () { t.remove(); }, 260);
    }, ms || 1800);
  }

  /* ---- MEMBERSHIP GATE -------------------------------------------------
     The web mirror of the native app's src/membership.js. The app has always PRE-EMPTED a blocked
     tap: PostCard's like and repost handlers open with
         if (!membershipActive) { onNeedMembership?.(); return; }
     BEFORE the optimistic store write, and ComposeScreen prints a standing note under its bar. The
     web did neither -- a lapsed member could type a whole post and only learn it was refused on
     submit, and a like animated, flew up, then silently walked itself back with a toast.

     THREE THINGS THIS IS NOT.
     1. It is not an entitlement. Nothing here decides anything: <body data-membership> is written
        from Billing::isActive(), the SAME predicate the server handlers gate on, so this can only
        ever pre-empt a refusal that was coming anyway. Every server gate is untouched. No attribute
        (JS off, a guest shell, an old cached page) means today's behaviour exactly -- the server
        402s and the existing per-action toast fires.
     2. It is not a copy of the message. The sentence and the call to action are handed over on the
        body, straight out of Billing::notice(), so the pre-emptive toast and the server's 402 can
        never tell a member two different stories -- which is precisely the bug that put three
        contradictory banners on one screen.
     3. It is not applied to an admin using "view as". isActive() carries the impersonation bypass,
        so the attribute is never written for them and every control stays live -- correct, because
        the server genuinely will let them act (owner rule, 2026-07-28).

     Read LAZILY, never cached into a variable: this file runs in one long IIFE and the read must
     not depend on where in it we are, nor on whether <body> existed when it was parsed. */
  function membershipBlocked() {
    var b = document.body;
    return !!(b && b.getAttribute('data-membership') === 'lapsed');
  }
  /* "If this member cannot do this, say why and stop." One call per action primitive, exactly the
     shape the app uses. Returns true when the caller should return. */
  function membershipStop() {
    if (!membershipBlocked()) { return false; }
    var b = document.body;
    var href = b.getAttribute('data-membership-cta');
    // A toast link cannot POST, and past_due's only route is a POST to the Stripe portal -- so that
    // member gets the sentence alone. They already have the red strip with its "Fix payment" button
    // pinned to the top of every page, which is the whole point of collapsing the stack.
    toast(b.getAttribute('data-membership-msg') || 'An active membership is needed for that.',
          6000,
          href ? { href: href, label: b.getAttribute('data-membership-cta-label') || 'Subscribe' } : null);
    return true;
  }

  /* ---- "hero zoom": fake the tapped media growing up to fill the screen while the pfeed loads behind it.
     A FLIP clone of the thumbnail (or a video's current frame) animates from its on-screen rect to the full
     viewport, then cross-fades out once the viewer has landed on the target (rova:pfeedready) -- or a hard
     fallback -- so the open reads as the media zooming into place, not a black overlay swapping in. ------ */
  function videoFrameSrc(v) {
    try {
      var vw = v.videoWidth || 0, vh = v.videoHeight || 0;
      if (!vw || !vh) throw 0;
      // BLACKNESS PROBE (the "sometimes the video hero is black" fix): grabbing a frame from a PLAYING <video>
      // onto a canvas frequently comes back ALL BLACK on Chrome (hardware-decode path, or a frame that hasn't
      // actually painted yet) -- and returning that black JPEG is the bug. Draw the frame TINY (32x32, cheap)
      // and scan EVERY pixel for the brightest channel; if the whole frame is essentially black (max < 24) the
      // grab failed, so return '' and let the caller fall back to the always-loaded poster (never a black hero).
      // Scanning the full downsample catches what the old 5-point sample slipped past. getImageData throws on a
      // cross-origin taint, which we also treat as "use the poster".
      var pc = document.createElement('canvas'); pc.width = 32; pc.height = 32;
      var pctx = pc.getContext('2d'); pctx.drawImage(v, 0, 0, 32, 32);
      var pd = pctx.getImageData(0, 0, 32, 32).data, mx = 0;
      for (var i = 0; i < pd.length; i += 4) {
        if (pd[i] > mx) { mx = pd[i]; } if (pd[i + 1] > mx) { mx = pd[i + 1]; } if (pd[i + 2] > mx) { mx = pd[i + 2]; }
        if (mx >= 24) { break; }   // a genuinely bright pixel -> a real painted frame, stop scanning
      }
      if (mx < 24) { return ''; }   // uniformly black -> poster fallback
      // Real frame: capture it downscaled (the hero is a brief flight image that cross-fades to the live video,
      // so a capped, lighter JPEG keeps the synchronous encode off the tap's critical path -- and never upscales).
      var CAP = 640, scale = Math.min(1, CAP / Math.max(vw, vh));   // lighter encode -> less stall at the tap; still sharp for a brief zoom
      var c = document.createElement('canvas');
      c.width = Math.max(1, Math.round(vw * scale));
      c.height = Math.max(1, Math.round(vh * scale));
      c.getContext('2d').drawImage(v, 0, 0, c.width, c.height);
      return c.toDataURL('image/jpeg', 0.82);   // sharp enough for a 460ms zoom; throws if cross-origin tainted
    } catch (e) { return ''; }
  }
  var heroHolds = 0;   // in-flight heroes holding html.hz-hold (pfeed Ken Burns paused while any fly)
  /* THE STILL-HERO CROSSFADE, IN SECONDS -- one number, three consumers.
     It is the length of the fade that hands a landed flight over to the viewer's own media,
     and since 2026-08-17 it is also the half-fade the landing dissolve rewinds a BOOMERANG
     master by, so the two surfaces align at the crossover instead of drifting across it (see
     reveal()'s dissolve block). A literal .22 in the transition string and a separate literal
     in that compensation would be the same bug in two places: change one and the crossover
     silently stops being the midpoint. The teardown timeout adds a frame of slack on top, so
     the element is never disposed mid-transition. */
  var HERO_FADE_S = 0.22;
  var HERO_FADE_MS = Math.round(HERO_FADE_S * 1000) + 20;
  /* ---- `complete` IS NOT `PAINTABLE`  (2026-09-09, owner: "opening media shows black flash") --------
     Both open flights withdraw the flown copy on a LOAD flag -- `img.complete && naturalWidth > 0` --
     and then start the HERO_FADE_S cross-fade. On WebKit that flag says the BYTES arrived; it says
     nothing about a raster. An <img> that has never been painted still has no decoded bitmap at that
     instant, and iOS Safari paints NOTHING for it (the same fact heroExpand already documents for the
     flown clone itself: "iOS Safari paints NOTHING for an <img> whose own content hasn't arrived").
     So the copy fades off over an empty box and the viewer shows its own black until the decode lands.
     THE SIGNATURE, measured off the owner's 09-09 recording frame by frame: a 220ms fade of the whole
     picture to black beginning ONE frame after the flight settles, then the pixel-identical picture
     back in a SINGLE frame 150ms later, with the box unchanged on every axis and the native iOS chrome
     (status bar 15.4, Safari toolbar 25.3) untouched throughout. Only a withdraw-before-paint makes
     that shape: nothing moved, nothing re-rendered, the cover just left early.
     THIS IS THE SAME CLASS AS THE TIMELINE-CARD FIX EARLIER THE SAME DAY (HTML's play() drops the
     native poster while the first decoded frame is hundreds of ms away). Same rule, second surface:
     A COVER MAY ONLY BE WITHDRAWN ON A GENUINELY PRESENTED FRAME, NEVER ON A PROMISE THAT ONE EXISTS.
     And the same reason every gate stayed green: Blink rasters early enough to hide it, WebKit does not.
     decode() is the witness the platform gives for exactly this. Already-decoded is a microtask
     (measured 1-2ms on a warm destination), so the warm path -- every open where the card behind the
     viewer already painted the same file -- pays nothing. Verdict is keyed on the URL so a REUSED
     element (carousel slide, recycled card) re-tests instead of inheriting the last file's answer, and
     a rejection counts as ready: a decode that cannot happen must never hold the flight, and holding
     the copy up is in any case the safe direction -- it is showing the picture.
     ...AND THE 900ms CAP WAS THE SAME BUG WEARING THIS FUNCTION'S CLOTHES (2026-09-13, owner: "this
     zoom animation to open the media is broken make it smooth just simple zoom without all this
     flickerings"). It was written as "a backstop for a decoder that neither resolves nor rejects",
     and what it actually did was answer YES to a cover-withdrawal gate 900ms into a decode that had
     not finished -- i.e. it restored, on a timer, the exact "withdraw on a promise" this function
     exists to forbid. On the owner's 2026-09-12 recording the destination reported `complete` ~200ms
     after the tap and did not present a raster until ~1580ms; the cap released the reveal at ~1100ms,
     the flown copy faded off over HERO_FADE_S (183 measured frames-wise) and the viewer showed 283ms
     of PURE BLACK before the picture snapped back in a single frame. REPRODUCED ON THE RIG, on the
     then-live app.c657e9c1c535 with the decode charged a phone-sized 1200ms: `slack = heroFadeStart -
     destinationDecoded` = **-97ms**, invariantHolds FALSE -- the 09-09 gate failing against its own
     build. THE CAP IS GONE. Every caller already bounds its own wait (heroZoom's MAXWAIT + its 1100/
     1700ms hard fallback, heroExpand's 15s never-blank cap, and since today heroExpand's hand-over,
     which holds a copy that IS SHOWING THE PICTURE -- the safe direction this header already names).
     A decoder that never answers now costs a held cover, never a black screen. */
  function pfDecoded(im) {
    if (!im || !im.decode) { return true; }                    // no decode() on this engine -> unchanged behaviour
    var key = im.currentSrc || im.src || '';
    if (im.__pfDecKey !== key) {
      im.__pfDecKey = key; im.__pfDecOk = 0;
      var settle = function () {
        if (im.__pfDecKey !== key) { return; }                 // src moved on: this answer is about a dead file
        im.__pfDecOk = 1;
        // wake the pump in the same task the verdict arrives, so the hold costs a microtask and not a frame
        try { document.dispatchEvent(new CustomEvent('rova:pfwake')); } catch (e) {}
      };
      try { im.decode().then(settle, settle); } catch (e) { im.__pfDecOk = 1; }
    }
    return !!im.__pfDecOk;
  }
  window.__rovaPfDecoded = pfDecoded;   // the black-frame gate asserts on this (scratchpad wk-open.js)
  /* ---- RETIRE A HANDED-OVER COPY ON A REAL RASTER, NEVER ON A FLAG OR A TIMER  (2026-09-13) -------
     The photo landing stopped being a cross-fade today (see reveal()'s hand-over block): the flown
     copy is re-classed out of `.pf-hero`, sunk into the card's own layer, and simply LEFT THERE as
     the picture while the hold lifts and the chrome reveals on time. This is the one thing still owed
     afterwards -- taking it away again, at a moment that cannot show a gap.
     THE RULE IT ENFORCES IS THE ONE pfDecoded'S HEADER STATES, and enforcing it here is what let the
     900ms cap go: there is no deadline to trade against, because the thing being held up is the
     PICTURE. A destination that never decodes costs a copy that stays on screen showing exactly what
     the reader came to see; the 15s bound is a memory hygiene backstop, not a visual one.
     TWO rAFs after the verdict, not zero: decode() resolving says a frame CAN be presented, and the
     copy must not leave in the same commit that first presents it. Two frames is 33ms of an already
     invisible swap and it removes the last ordering hazard in the class.
     Re-polls if the element's src moved between the ask and the answer (a carousel slide, a recycled
     card, a late quality upgrade) -- the same reason pfDecoded keys its verdict on the URL. */
  function pfHandOver(im, done) {
    var fired = false, born = Date.now();
    var go = function () {
      if (fired) { return; }
      fired = true;
      try { document.removeEventListener('touchstart', onPinch, true); document.removeEventListener('gesturestart', go, true); } catch (e) {}
      requestAnimationFrame(function () { requestAnimationFrame(done); });
    };
    /* A PINCH ENDS THE STAND-IN, WHATEVER THE DECODE SAYS. Everything the viewer does on its own --
       the Ken Burns pan, a swipe to the next post -- the poll below sees in the destination's rect.
       What it cannot see is `pf-zoomable`: a pinch scales the picture UNDERNEATH while its centre
       stays put, and a fixed copy pinned at the landing rect would sit over it, unmoving.
       DELIBERATELY NOT ANY TOUCH. A single tap moves nothing, so the copy sitting there is harmless --
       and retiring on it would put a tap-to-like inside the decode window straight back into the
       09-09 black frame, which is the whole thing this hand-over exists to make impossible. Two
       fingers (or WebKit's `gesturestart`) is the exact signal, and nothing else qualifies.
       Capture phase, so it fires before anything can stop the event reaching us. */
    var onPinch = function (e) { if (e && e.touches && e.touches.length > 1) { go(); } };
    try { document.addEventListener('touchstart', onPinch, true); document.addEventListener('gesturestart', go, true); } catch (e) {}
    (function poll() {
      if (fired) { return; }
      if (Date.now() - born > 15000) { go(); return; }          // memory hygiene, never a visual deadline
      if (!im || !im.isConnected) { go(); return; }             // destination gone: nothing left to hand to
      /* ...AND THE COPY IS position:fixed, SO IT MUST NEVER OUTLIVE THE THING IT STANDS IN FOR.
         Page the deck (or close the viewer) inside the retire window and a full-screen still would
         sit glued to the viewport over whatever the reader swiped to. The destination leaving the
         centre IS the signal: retire on the spot -- the copy has stopped being a stand-in for what
         is on screen, which is the only reason it was allowed to stay. */
      if (!document.querySelector('.pfeed.show')) { go(); return; }
      try {
        var r = im.getBoundingClientRect();
        if (!(r.width > 4) || Math.abs((r.top + r.bottom) / 2 - innerHeight / 2) > innerHeight * 0.4) { go(); return; }
      } catch (e) {}
      if (!(im.complete && im.naturalWidth > 0 && pfDecoded(im))) { setTimeout(poll, 60); return; }
      go();
    })();
  }
  // GENERATION guard (rapid open/close leak fix): every flight (heroZoom/heroExpand) captures `heroGen` at
  // birth. __rovaHeroReset bumps it, so a stale flight from a KILLED cycle self-cancels: its deferred
  // pump/reveal/fade closures bail on `myGen !== heroGen` instead of forcing opacity:1 on the NEXT viewer's
  // media (the "another photo loads behind the one zooming" ghost) or decrementing the shared hold counter
  // against a live flight. Without this the closures kept running (done stayed false) and re-queried the LIVE
  // .pfeed.show at fire time.
  var heroGen = 0;
  // Fully release a <video> clone (decoder + hls.js MSE buffers), not just detach it -- a bare removeChild
  // leaks a decoder per cycle on iOS. Used when reset drops an orphan video hero. Accepts either the <video>
  // itself or a flyCrop WRAPPER holding one.
  function heroReleaseVideo(el) {
    try {
      var v = (el && el.tagName === 'VIDEO') ? el : (el && el.querySelector ? el.querySelector('video') : null);
      if (v) {
        try { v.pause(); } catch (e) {}
        if (v._hls) { try { v._hls.destroy(); } catch (e) {} v._hls = null; }
        v.removeAttribute('src'); v.removeAttribute('poster');
        try { v.load(); } catch (e) {}
      }
    } catch (e) {}
  }
  window.__rovaHeroReleaseVideo = heroReleaseVideo;   // the pfeed IIFE (close()) is a separate scope -> reach it via window

  /* ---- COMPOSITED CROP-FLIGHT (owner: "in 2026 phones host Fortnite, these motions should be fast") ------
     The hero flights used to animate left/top/width/height so object-fit:cover would re-crop the media
     gradually as the box morphed aspect (square tile <-> portrait frame) -- the LOOK the owner approved, but
     every frame was a main-thread LAYOUT + re-raster (~30fps under load). This reproduces the exact same
     morph on the COMPOSITOR: a wrapper (the crop window, overflow:hidden) and the media inside it animate
     ONLY transforms, via JS-baked @keyframes where each step pre-computes what cover would have done for the
     interpolated box (eased timing baked into the steps, animation runs linear). 60fps even with the main
     thread pinned by the pfeed's open work.
     - park='to'|'from': the wrapper's REAL laid-out box. Park at the BIGGER rect so an <img>'s raster is
       laid out large and only ever sampled DOWN (parking small + scaling up starts blurry).
     - The media element is MOVED into the wrapper (a playing <video> keeps playing). Caller moves it back
       out (handoff) or disposes the whole wrapper. wrap._flightCss carries the injected keyframes tag. */
  function heroBez(x1, y1, x2, y2) {
    function A(a1, a2) { return 1 - 3 * a2 + 3 * a1; }
    function B(a1, a2) { return 3 * a2 - 6 * a1; }
    function C(a1) { return 3 * a1; }
    function calc(t, a1, a2) { return ((A(a1, a2) * t + B(a1, a2)) * t + C(a1)) * t; }
    function slope(t, a1, a2) { return 3 * A(a1, a2) * t * t + 2 * B(a1, a2) * t + C(a1); }
    return function (x) {
      if (x <= 0) return 0; if (x >= 1) return 1;
      var t = x;
      for (var i = 0; i < 5; i++) { var s = slope(t, x1, x2); if (s < 1e-6) break; t -= (calc(t, x1, x2) - x) / s; }
      return calc(t, y1, y2);
    };
  }
  var bezSwift = heroBez(0.4, 0, 0.2, 1);      // the dismiss/video-open ease (cubic-bezier(.4,0,.2,1))
  var bezGlide = heroBez(0.22, 0.61, 0.36, 1); // the photo-open ease (cubic-bezier(.22,.61,.36,1))
  var flightUid = 0;
  // Track the last mobile-URL-bar (visual viewport) shift, so the hero handoff can wait for it to
  // FINISH settling before measuring the landing rect -- catching the bar mid-collapse would correct
  // to a still-moving position and land slightly off (owner: "could be perfected a little more").
  var lastVVShift = 0;
  var vvSubs = [];   // live flights that want to know (see heroExpand's re-aim)
  if (window.visualViewport) {
    var vvH = window.visualViewport.height;
    window.visualViewport.addEventListener('resize', function () {
      if (Math.abs(window.visualViewport.height - vvH) > 4) { lastVVShift = Date.now(); vvH = window.visualViewport.height; }
      for (var i = vvSubs.length - 1; i >= 0; i--) { try { vvSubs[i](); } catch (e) {} }
    });
  }
  /* ---- THE SETTLED LANDING VIEWPORT (2026-08-17) --------------------------------------------------
     OWNER: "cold opening photos from the grid, images land low then nudge up after landing."
     MEASURED off his own 60fps recording (frames 103-125): the tween converged on a rect whose centre
     was 19.7 CSS px BELOW the final one, and a second 117ms motion then lifted it -- both edges moving
     UP with the height unchanged, i.e. a pure vertical offset of half a ~40px viewport delta, not an
     aspect/fit error. The bottom Safari toolbar in the same frames is the proof: MINIMISED (the little
     floating rovasocial.com pill, f50) at the tap and FULLY EXPANDED (back / URL / reload / more,
     f105) two frames later.

     WHY IT MOVES, AND WHY IT IS OUR OWN DOING: pfLock() pins the document (body position:fixed) so the
     page behind the viewer can't scroll -- and iOS Safari answers an unscrollable document by restoring
     its full-height bottom bar. The visual viewport therefore SHRINKS by the bar delta a beat AFTER the
     tap, so `window.innerHeight` read in the tap handler -- the number both landing predictions are
     centred in -- is stale by ~40px before the tween is a third done. Centring in a box 40px too tall
     puts the image 20px too low, which is exactly what the recording shows.

     THE SETTLED HEIGHT IS THE ONE TO PREDICT IN, and it is knowable without sniffing an engine: it is
     the height MEASURED the last time this device had the viewer open and still. Cached per width (a
     rotation invalidates it) and remembered across page loads, because a phone's chrome geometry does
     not change between visits -- so a cold first open predicts the settled box from the very first
     keyframe. Nothing here GUESSES: with no cached value the prediction is the old one and the flight's
     own re-aim (see heroExpand) corrects it inside the tween. `svh` is deliberately NOT used -- it
     would be right on WebKit and wrong on any engine that leaves its chrome hidden under a lock. */
  var pfSettledVh = 0, pfSettledFor = 0;
  try {
    var _ss = (window.localStorage && localStorage.getItem('rv_landvh') || '').split(':');
    if (_ss.length === 2) { pfSettledFor = parseInt(_ss[0], 10) || 0; pfSettledVh = parseInt(_ss[1], 10) || 0; }
  } catch (e) {}
  function pfVvH() {
    return (window.visualViewport && window.visualViewport.height)
        || window.innerHeight || document.documentElement.clientHeight || 0;
  }
  /* Record the height at ONE moment only: a hero LANDING (reveal(), which has already waited for the bar
     to stop moving). That is precisely the state a landing happens in, and it is the one state where no
     keyboard can be up -- which is why this is not wired to the visualViewport resize event, tempting as
     that is. A soft keyboard shrinks the visual viewport too, and a shrink small enough to pass the 0.8
     floor below (an accessory bar, a split keyboard) would have cached a keyboard height and then aimed
     every later flight tens of px high. The active-element test is the belt to that brace. */
  function pfNoteSettledVh() {
    // BOTH halves of the landing state, or nothing: the viewer up AND the document still pinned. On the
    // way OUT the lock is released first and the bar minimises again -- reading there would cache the
    // TALL height and quietly retire the whole correction (it would fail pfLandVh's `< vh` test forever).
    if (!document.documentElement.classList.contains('scroll-locked')) return;
    if (!document.querySelector('.pfeed.show')) return;
    try {
      var ae = document.activeElement;
      if (ae && (ae.tagName === 'INPUT' || ae.tagName === 'TEXTAREA' || ae.isContentEditable)) return;
    } catch (e) {}
    var h = Math.round(pfVvH()), w = window.innerWidth;
    if (!(h > 120) || !(w > 0)) return;
    if (pfSettledFor === w && pfSettledVh === h) return;
    pfSettledFor = w; pfSettledVh = h;
    try { if (window.localStorage) localStorage.setItem('rv_landvh', w + ':' + h); } catch (e) {}
  }
  /* The height the landing will ACTUALLY have. Never taller than what we can see right now (the bar only
     ever eats space on open), never trusted from another orientation, never below 80%.

     `pfLandLive` suspends the cache. A prediction made AT THE TAP is a guess about the next 400ms and the
     cached settled height is the best one available; a re-aim made DURING the flight is not a guess at
     all, and there the live viewport is simply the truth. Keeping the cache on for re-aims would make the
     flight defend its own guess: if the bar does NOT come back (a browser that leaves its chrome hidden
     under a scroll lock), every re-aim would recompute the same too-short box and the landing would sit
     20px HIGH -- the reported bug, mirrored, and measured exactly that way by tools/land-rect-check.js's
     control case before this existed. */
  var pfLandLive = 0;
  function pfLandVh() {
    /* PRIMED, WHENEVER THE PRIME IS IN FORCE (2026-08-17, round D). pfLandBoxPrime already takes
       this exact number at the top of heroExpand, before the clone/class writes, precisely so the
       tap-time prediction performs no layout reads -- and then startFlight asked for it AGAIN, four
       writes later, to stamp `landPredVh`. That second call is a full-document style+layout flush
       inside the tap's own task: measured at 44.8ms rolled up to pfVvH on a 4x-CPU open, and after
       round D moved the opener's tail out it was the single dearest read left in the gesture.
       THE VALUE CANNOT DIFFER, which is what makes this a hoist rather than a behaviour change: a
       prime lives for exactly one task (an rAF clears _lbArmed) and a viewport cannot change inside
       a task, so this returns the number the unhoisted call would have returned. Gated on
       pfLandLive for the same reason pfeedLandRect is -- a re-aim is a MEASUREMENT, not a guess,
       and must always consult the live viewport (see the header on pfLandLive). */
    if (_lbArmed && !pfLandLive) { return _lbVh; }
    var vh = pfVvH();
    if (!pfLandLive && pfSettledVh && pfSettledFor === window.innerWidth
        && pfSettledVh < vh && pfSettledVh > vh * 0.8) { return pfSettledVh; }
    return vh;
  }
  /* ---- "IS THE VIEWER UP / IS A CLONE IN THE AIR?" AS A CLASS, NOT AS A `body:has()`  (2026-08-17) ---
     MEASURED, and it is this round's whole result. rova.css keyed five rules on `body:has(.pfeed.show)`
     or `body:has(.pf-hero)`, and two of them ended in a bare `img`:
       :1555  body:has(.pfeed.show) .pgrid .pcell img:not(.pcell-video){animation-play-state:paused}
       :4479  body:has(.pf-hero) / body:has(.pfeed.show) .post .media img:not(.pfeed *){transform:none!important}
     A `:has()` whose SUBJECT is <body> marks <body> as affected-by-:has(), so Blink must re-evaluate it
     on every DOM mutation underneath -- and an open inserts an entire viewer. The devtools
     invalidationTracking trace counted 88 `ScheduleStyle on BODY` events per open, coalescing into ~12
     style passes; because <body>'s descendant invalidation set contained the bare tagName `img`, each of
     those passes invalidated EVERY <img> in the document. `img` is the largest tag bucket in this
     stylesheet -- 128 tag-keyed selectors, ~154 candidate selectors / 126 rules per element, against 32
     for a classless <div> -- so each of those images then paid the most expensive re-match the sheet can
     ask for. Per open: 526 and 390 `Invalidation set matched tagName on IMG` events, three of the six
     dearest style passes, ~32 elements recalculated per pass at ~0.5-0.9ms EACH.

     PROVEN BY DELETION BEFORE IT WAS WRITTEN. Serving the shipped stylesheet with only those rules
     removed (tools/vopen-perf.js --css, interleaved, ordering-balanced) took IMG invalidations from
     526/390 to 130/96, elements-per-pass from 32.0 [30.5-32.1] to 21.3 [21-23.4] and RecalcStyle from
     678ms [655-763] to 542ms [507-596] -- ranges non-overlapping. The class below keeps the behaviour
     and gives up the cost.

     A CLASS COSTS TWO INVALIDATIONS PER OPEN WHERE THE `:has()` COST TWELVE, AND THE OBVIOUS PREMISE
     WAS WRONG. `html.hz-hold` has the identical shape -- an <html> class whose descendant set contains
     `img` -- and the trace prices it at EIGHT milliseconds across the whole open, 2 events, 0
     subtree-scoped. So "a class on <html> with descendant rules invalidates style document-wide and is
     the thing to fix" is refuted on the record: what costs is how OFTEN the subject is re-evaluated,
     not where it sits. Same for the two other suspects measured in the same trace -- the flyCrop
     <style> insert (0 invalidation events; it shows up only as ~20 `@keyframes rule change` marks on the
     handful of animating elements) and pfLock's `body.style.top` (1 event). Neither is document-wide.

     LEVEL-TRIGGERED, THE PATTERN __rovaFlightHold's HEADER ARGUES FOR: this asks the DOM the same two
     questions the `:has()` asked, so it cannot drift the way a refcount can, a missed call site is
     self-healing at the next one, and calling it twice is free. `heroRelease` already treats
     `querySelector('.pf-hero...')` as the authority for "is a clone still live", so this is that gate's
     existing reading, published as a class.
     NOT A LAYOUT READ. querySelector matches against the DOM; it flushes neither style nor layout, so
     these calls add nothing to the forced-flush budget the last two rounds spent shrinking.
     TWO CLASSES, NOT ONE UNION, so the swap is behaviour-EXACT: :1555 fired on the viewer alone and
     :4479 on either, and a union would have paused the grid pan ~340ms early on every dismiss.
     `.pf-hero-collapse` clones carry `pf-hero` too (className = 'pf-hero pf-hero-collapse'), so the
     `.pfv-fly` query matches exactly the set `body:has(.pf-hero)` matched -- dismissals included.

     AND THE NAMES ARE `pfv-*` BECAUSE `pf-open` IS ALREADY TAKEN, WHICH WOULD HAVE QUIETLY UNDONE THE
     WHOLE ROUND. `pf-open` is the caption-expand class (rova.css:2427 `.pfeed .post .body.pf-open`,
     toggled per tap in clampBody's handler). Blink keys invalidation sets by class NAME, not by element,
     so reusing it would have put these three `img`-bearing descendant rules into the set of a class that
     is toggled on every caption tap -- re-introducing the document-wide <img> invalidation on a much
     more frequent trigger than the one just removed. A collision here is not a naming preference. */
  function pfStillSync() {
    try {
      var cl = document.documentElement.classList;
      cl.toggle('pfv-on', !!document.querySelector('.pfeed.show'));
      cl.toggle('pfv-fly', !!document.querySelector('.pf-hero'));
    } catch (e) {}
  }
  window.__rovaPfStillSync = pfStillSync;   // the pfeed IIFE (open/close) is a separate scope -> reach it via window
  function flyCrop(media, from, to, opts) {
    opts = opts || {};
    var ms = opts.ms || 340;
    var ease = opts.ease || bezSwift;
    var rF = opts.radiusFrom || 0, rT = opts.radiusTo || 0;
    /* radiusTo MAY BE A PERCENTAGE STRING ('50%' = the destination is a circle/ellipse, e.g. the
       profile avatar). Owner 2026-08-29 screenshot ("it's trying to crop it back to a circle but
       not quite"): callers used to read the destination's rounding via parseFloat(getComputedStyle
       (..).borderRadius), and parseFloat('50%') is 50 -- fifty PIXELS, not half the box. A fraction
       sidesteps the whole trap: the % keyframes below resolve against the wrapper's (constant) park
       box and ride the transform, so the VISUAL radius is always that fraction of the on-screen
       box -- no px counter-scaling, and 50% at landing is a true circle whatever the end scale is.
       (Numeric radii keep the existing px path, which already counter-scales per frame -- r/sx
       under scale(sx) paints r visual px -- so px tiles land exactly as before.) */
    var rTF = 0;
    if (typeof rT === 'string') { rTF = rT.indexOf('%') > -1 ? (parseFloat(rT) || 0) / 100 : 0; rT = rTF ? 0 : (parseFloat(rT) || 0); }
    var P = (opts.park === 'from') ? from : to;   // the wrapper's laid-out box (park at the bigger rect)
    /* ---- THE INTRINSIC SIZE IS THE MEDIA'S, AND A BOX IS NEVER AN INTRINSIC SIZE -----------------
       (2026-08-30, the owner's @trenchwurk tournament-flyer open: "opening photos on the web do not
       zoom and land optimally and is buggy".)

       This whole function is a COVER-MORPH: the media is laid out ONCE at the park box's cover extent
       (`coverW/coverH` below, an aspect-exact box drawn with object-fit:fill -- see the note there for
       why it is not object-fit:cover) and every keyframe re-derives the per-frame cover scale from
       `iw`/`ih`. So `iw`/`ih` are not a hint: they ARE the aspect the reader sees for the entire
       flight, and a wrong pair does not drift, it is wrong from frame 0 to the hand-off.

       The old chain ended `|| from.width` / `|| from.height` -- the TILE BOX. That is not an unknown
       aspect, it is a CONFIDENTLY WRONG one, and it was taken on EVERY photo open on every engine:
       heroExpand creates the hero <img>, sets .src and calls this IN THE SAME TASK, so the clone has
       not decoded and naturalWidth is 0, always. (It decodes a frame or two later, which is why a
       trace that samples on the next rAF reads the right number and sees nothing wrong -- the value
       that mattered was the one read here, one task earlier.) Verified by replaying the shipped
       2026-08-30 01:01 bundle in headless Chromium: the flown picture's size was a pure function of
       the TILE's aspect and the media's own 665x1440 never entered into it -- a square grid tile flew
       it 746px wide, a 3:4 tile 559.5px, the feed card 596.8px, where the truth is 344.5px.

       WHY IT SURFACED NOW AND ON THIS POST. The fallback is RIGHT whenever the tile happens to share
       the media's aspect, which is most of the corpus -- a landscape shot, a square, a near-square all
       sit in an unclamped card box and the wrong source coincidentally gives the right answer. The
       feed card's media aspect clamp is what breaks the coincidence: it holds a very tall photo at
       ~0.80, so a 0.462 flyer is the furthest any post can be from its own tile. Measured on the
       owner's 420x746 viewport: the picture was laid out 596.8x746 inside a 344.5x746 window -- 73%
       too wide, stretched by the object-fit:fill below, with "TOURNAMENT" and "$10 TICKETS" sliced off
       both edges for the whole 400ms, then "corrected" by the cross-fade to the viewer's own contained
       copy. That visible correction is the bug he reported; the LANDING BOX was right all along.

       So: ask the MEDIA (mediaIntrinsic already walks natural -> video -> the width/height ATTRIBUTES,
       which views/_post.php stamps on every card <img> and every clip, so an undecoded clone still
       answers correctly), and when even that is silent fall back to the PARK BOX `P` -- never to the
       far end of the flight. P is the box the fit verdict itself produced (the landing rect on an
       open, the painted rect on a dismiss), so `iw/ih = P` degenerates to "fill the window", which is
       exactly what the viewer paints at the endpoint the flight is parked on. An unknown aspect must
       land right and merely look plain on the way; it must not invent a crop. */
    var _mi = mediaIntrinsic(media);
    var iw = opts.iw || _mi.w || P.width;
    var ih = opts.ih || _mi.h || P.height;
    /* ---- THE CROP IS NOT ALWAYS CENTRED, AND IT IS NOT THE SAME AT BOTH ENDS  (2026-09-14) ------
       The inner is laid out at the park box's cover extent and CENTRED. A covering photo in the
       pfeed is NOT centred -- it carries --pf-pany, the PF_PANY_BIAS top-biased crop (see
       __rovaPfPanyBias) -- while a grid tile and a feed card ARE centred (both spell out
       object-position:50% 50%, since 2026-09-01). So the two ends of a flight genuinely disagree
       about where the crop window sits, and the flight has to INTERPOLATE, not pick one:
         `oyFrom` -- the bias, in SCREEN px, that the source is painting at the `from` box
         `oyTo`   -- the bias, in SCREEN px, that the destination will paint at the `to` box
       heroExpand passes (0, the landing bias); __rovaHeroCollapse passes (the live --pf-pany, 0).
       Both ends are then exact, which is the whole contract -- and it is why this is a keyframe
       track and not the static `top` offset the first cut of this fix used: a static offset is
       right at the park end and lands `oy * sy` out at the OTHER end, which for a 420->120px grid
       tile is 16px of crop the tile does not have. Correct at one landing, newly wrong at another,
       which is the disease and not the cure.
       THE UNITS: a translateY on the inner displaces it in WRAPPER-LOCAL px, and the wrapper is
       scaled by `sy` that frame, so screen offset = sy * T. Hence T = wanted / sy below. Omitted on
       both ends -> no track emitted at all and every existing flight is byte-identical. */
    var oyFrom = +opts.oyFrom || 0, oyTo = +opts.oyTo || 0;
    var oyOn = (oyFrom !== 0 || oyTo !== 0);
    /* `kbFull` (2026-09-30) -- the source is a photo MID-DRIFT (the viewer's Ken Burns): the WHOLE picture
       as drawn at the `from` end, bigger than and off-centre in the clipped `from` box. Solved from that
       rect rather than from the drift's own numbers, so it is exact whatever put the picture there (the
       drift, the --pf-pany crop window riding under it, a pan): frame 0 draws the inner at the picture's
       own size k0 and centre offset (kX0,kY0), and both unwind to the plain cover crop with the flight's
       ease (the Y track lands on oyTo exactly as before). Omitted -> nothing below changes. */
    var kbF = opts.kbFull || null, kOn = false, k0 = 1, kX0 = 0, kY0 = 0;
    if (kbF && kbF.width > 0 && kbF.height > 0) {
      var _kw0 = iw * Math.max(from.width / iw, from.height / ih);   // the inner's drawn width at frame 0
      k0 = kbF.width / _kw0;
      kX0 = (kbF.left + kbF.width / 2) - (from.left + from.width / 2);
      kY0 = (kbF.top + kbF.height / 2) - (from.top + from.height / 2);
      kOn = isFinite(k0) && k0 > 0.2 && k0 < 5 && (Math.abs(k0 - 1) > 1e-3 || Math.abs(kX0) > 0.25 || Math.abs(kY0) > 0.25);
    }
    /* `kbTo` (2026-10-01) -- THE SAME THING AT THE OTHER END: the picture as the DESTINATION draws it.
       Rob, desktop Safari, /p/54692: "it lands wrong but it fixes it". The landing BOX was exact (the
       card's .media, 0px on every edge) but the picture inside it was the plain centred cover crop,
       while the card underneath paints its photo mid-Ken-Burns (tlPan/tlPanAlt, gridPan on a tile:
       up to 1.15x and a few % off centre, via scale/translate). Measured on that post at 1440x900:
       the landed picture was 72x96px smaller and 21/62px off the card's, then the hand-off fade
       dissolved it into the card's frame -- the "fix". Solved from the drawn rect, exactly as kbFull
       is, so a contained (.ar-fit) or object-position'd destination lands right by the same line.
       The two ends interpolate on the flight's ease; with only one end present every keyframe is
       byte-identical to the one-ended formula it generalises (k1 = 1, kX1 = 0, kY1 = oyTo). */
    if (!kOn) { k0 = 1; kX0 = 0; kY0 = oyFrom; }                    // == the oyOn track's frame 0
    var kbT = opts.kbTo || null, k1 = 1, kX1 = 0, kY1 = oyTo;
    if (kbT && kbT.width > 0 && kbT.height > 0) {
      var _kw1 = iw * Math.max(to.width / iw, to.height / ih);       // the inner's drawn width at landing
      var _k1 = kbT.width / _kw1;
      var _x1 = (kbT.left + kbT.width / 2) - (to.left + to.width / 2);
      var _y1 = (kbT.top + kbT.height / 2) - (to.top + to.height / 2);
      if (isFinite(_k1) && _k1 > 0.2 && _k1 < 5 && (Math.abs(_k1 - 1) > 1e-3 || Math.abs(_x1) > 0.25 || Math.abs(_y1 - oyTo) > 0.25)) {
        k1 = _k1; kX1 = _x1; kY1 = _y1; kOn = true;
      }
    }
    // progress (0..1) at which the clone starts handing over to what is underneath; 0 = never
    var fo = (opts.fadeFrom > 0 && opts.fadeFrom < 1) ? opts.fadeFrom : 0;
    /* WHICH OF THE THREE ANSWERED, stamped on the wrapper below. Not a debug crumb: this class of bug
       is invisible precisely because a wrong aspect looks like a deliberate crop, so the ONE fact a
       regression gate needs is which source the flight believed. 'declared' = the caller (heroExpand's
       landRect, i.e. the same numbers the landing box was predicted from), 'media' = the element's own
       naturals/attributes, 'park' = the degenerate fallback.
       'park' IS PROVABLY SAFE, and the proof is one line: iw/ih = P makes sP = max(P.w/P.w, P.h/P.h) =
       1, so the inner lays out at exactly P and the picture is drawn at the landing box -- "fill the
       window", which is what the viewer paints at the endpoint this flight is parked on. It cannot
       invent a crop, which is the only failure that matters here. tools/flight-fit-check.js asserts
       that empirically in its `allzero` pass (every image reporting naturalWidth 0) rather than taking
       this comment's word for it. */
    var _flyWhy = opts.iw ? 'declared' : (_mi.w ? 'media' : 'park');
    /* WHY THIS STILL BAKES @keyframes INTO A <style> INSTEAD OF USING THE WEB ANIMATIONS API
       (2026-08-17). It was converted: same 41 sampled offsets, wrap.animate()/media.animate(), no
       stylesheet insertion (which invalidates style resolution document-wide, inside the tap's own
       task, and showed up in the 873ms of RecalcStyle this open was spending). The conversion was
       WITHDRAWN because it reproducibly broke land-rect-check assertion 2 -- a learned-cache open
       started taking TWO mid-flight re-aims where the CSS-animation build takes none (`a: 2` vs `a: 0`,
       with dy/dh/post all still 0, i.e. the landing itself stayed exact). Verified against the
       pre-change bundle via `LAND_CONTROL=` and with the list-phasing disabled via `LAND_NOPHASE=1`,
       so it is the animation delivery and not the list fill. The mechanism is not understood -- the
       drift `flyRetarget` measures is computed from the destination card's rect and the baked target,
       neither of which the delivery mechanism touches -- and assertion 2 exists precisely to stop a
       permanent extra transition shipping on every open. An unexplained regression against a guard the
       owner asked to keep is not worth the RecalcStyle, so this waits for its own round.
       If you pick it up: the drift test is a SUM of four absolute deltas against a 3px budget, so ~1px
       of rounding on each of left/top/width/height is enough to trip it. Prove whether that is what
       moved before changing anything else. */
    var uid = 'pfx' + (++flightUid);
    var N = 40, wk = [], ik = [];
    var sP = Math.max(P.width / iw, P.height / ih);   // cover scale at the park box
    /* WHERE THE HAND-OFF RAMP HAS TO BE OVER, SOLVED FROM THE EASE, NOT ASSUMED TO BE 100%
       (2026-09-14). The contract is "correct on the FIRST frame of the landing", and with an
       ease-out the picture ARRIVES well before the clock does: bezSwift puts the box within 1px of
       its destination at about 92% of the tween, so a ramp that reached 0 at 100% would still be
       ~25% opaque on the frame the reader sees it stop. Find the first keyframe whose box IS the
       destination (1px, the same budget flyRetarget calls "no drift") and end the ramp there. Self-
       tuning: change the ease or the travel and this follows. */
    var uEnd = 1;
    if (fo) {
      for (var q = 0; q <= N; q++) {
        var eq = ease(q / N);
        if (Math.abs((from.height + (to.height - from.height) * eq) - to.height) <= 1
         && Math.abs((from.top + (to.top - from.top) * eq) - to.top) <= 1) { uEnd = q / N; break; }
      }
      if (uEnd <= fo + 0.02) { uEnd = Math.min(1, fo + 0.05); }
    }
    for (var i = 0; i <= N; i++) {
      var u = i / N, e = ease(u), pct = (u * 100).toFixed(2);
      var bl = from.left + (to.left - from.left) * e, bt = from.top + (to.top - from.top) * e;
      var bw = from.width + (to.width - from.width) * e, bh = from.height + (to.height - from.height) * e;
      var sx = bw / P.width, sy = bh / P.height;                      // wrapper: park box -> interpolated box
      var sB = Math.max(bw / iw, bh / ih);                            // what cover WOULD scale to for this box
      var cx = (sB / sP) / sx, cy = (sB / sP) / sy;                   // inner counter-scale = per-frame cover, undistorted
      var r = rF + (rT - rF) * e;                                     // visual corner radius (counter-scaled below)
      // circle destination: ramp 0% -> the destination's own fraction, so the copy's square corners
      // visibly round off into the circle as it shrinks (see the rTF note above)
      var rad = rTF ? (rTF * e * 100).toFixed(2) + '%'
                    : (r / sx).toFixed(2) + 'px / ' + (r / sy).toFixed(2) + 'px';
      /* `fadeFrom` -- THE HAND-OFF AS A KEYFRAME, NOT AS A TIMER (2026-09-14). A dismissal onto a
         destination that is already painted underneath (the profile avatar) has to be fully handed
         over BY the landing frame, and a setTimeout cannot promise that: measured in Chromium, a
         fade armed for `ms - 100` actually finished 26ms AFTER the tween, because timers drift and
         the tween does not. Baked into the same keyframe list, opacity reaches 0 at exactly 100%,
         on the compositor, whatever the main thread is doing. Omitted -> no opacity track at all
         and every other flight is byte-identical. */
      var opk = fo ? (u <= fo ? 1 : Math.max(0, 1 - (u - fo) / (uEnd - fo))) : 0;
      wk.push(pct + '%{transform:translate(' + (bl - P.left).toFixed(2) + 'px,' + (bt - P.top).toFixed(2) + 'px) scale(' + sx.toFixed(5) + ',' + sy.toFixed(5) + ');border-radius:' + rad
        + (fo ? ';opacity:' + opk.toFixed(4) : '') + '}');
      var oyT = oyOn ? ((oyFrom + (oyTo - oyFrom) * e) / sy) : 0;     // see the oyFrom/oyTo header
      if (kOn) {                                                      // see the kbFull / kbTo headers
        var kr = 1 - e, kk = 1 + (k0 - 1) * kr + (k1 - 1) * e;
        ik.push(pct + '%{transform:translate(' + ((kX0 * kr + kX1 * e) / sx).toFixed(3) + 'px,' + ((kY0 * kr + kY1 * e) / sy).toFixed(3) + 'px) '
          + 'scale(' + (cx * kk).toFixed(5) + ',' + (cy * kk).toFixed(5) + ')}');
      } else {
      ik.push(pct + '%{transform:' + (oyOn ? 'translateY(' + oyT.toFixed(3) + 'px) ' : '')
        + 'scale(' + cx.toFixed(5) + ',' + cy.toFixed(5) + ')}');
      }
    }
    var css = document.createElement('style');
    css.textContent = '@keyframes ' + uid + 'w{' + wk.join('') + '}@keyframes ' + uid + 'i{' + ik.join('') + '}';
    document.head.appendChild(css);
    var wrap = document.createElement('div');
    wrap.className = opts.cls || 'pf-hero';
    try { wrap.setAttribute('data-fly-aspect', _flyWhy + ' ' + Math.round(iw) + 'x' + Math.round(ih)); } catch (e) {}
    // inline base = frame 0 of the keyframes, so even if the animation starts a frame late there's no flash
    var sx0 = from.width / P.width, sy0 = from.height / P.height;
    var sB0 = Math.max(from.width / iw, from.height / ih);
    wrap.style.cssText = 'position:fixed;left:' + P.left + 'px;top:' + P.top + 'px;width:' + P.width + 'px;height:' + P.height + 'px;'
      + 'overflow:hidden;margin:0;z-index:' + (opts.z || 220) + ';background:' + (opts.bg || '#000') + ';pointer-events:none;'
      + 'transform-origin:0 0;will-change:transform;'
      + '-webkit-backface-visibility:hidden;backface-visibility:hidden;'
      + 'transform:translate(' + (from.left - P.left) + 'px,' + (from.top - P.top) + 'px) scale(' + sx0 + ',' + sy0 + ');'
      + 'border-radius:' + (rF / sx0) + 'px / ' + (rF / sy0) + 'px;'
      + 'animation:' + uid + 'w ' + ms + 'ms linear forwards';
    // Size the inner to the EXACT park-box cover extent in pixels (aspect-exact box, centered) instead of
    // 100% + object-fit:cover -- WebKit/Safari ignores object-fit:cover on <video> (the reason pf-vfill
    // exists), which rendered the clip CONTAINED inside the wrapper = the "lands letterboxed in the tile then
    // flickers to fill" report. An aspect-exact box renders identically on every engine, no object-fit needed.
    /* ...EXCEPT WHEN THE MEDIA IS A STAND-IN OF A DIFFERENT SHAPE (2026-09-09). The box is aspect-exact
       for `iw`/`ih` -- the DESTINATION's intrinsic size -- and `fill` is right precisely because the
       bitmap is normally that shape. heroExpand's cold branch deliberately flies a substitute (the
       square avatar crop, while the landing was declared portrait) and marks it `_pfStandIn`; filling
       with that is a 0.5625 horizontal squeeze, which is the "lands stretched then fixes" report.
       `cover` centre-crops it into the identical box instead: never distorted, and byte-for-byte the
       same rendering as `fill` the moment the shapes agree -- which is why this is safe to leave in
       place for the swap (heroExpand flips it back to `fill` when the real bitmap lands) and why no
       other flight on any surface is affected. IMG only by construction: only that branch marks. */
    var coverW = iw * sP, coverH = ih * sP;
    var mcss = 'position:absolute;left:' + ((P.width - coverW) / 2).toFixed(2) + 'px;top:' + ((P.height - coverH) / 2).toFixed(2) + 'px;'
      + 'width:' + coverW.toFixed(2) + 'px;height:' + coverH.toFixed(2) + 'px;max-width:none;max-height:none;'
      + 'object-fit:' + (media._pfStandIn ? 'cover' : 'fill') + ';margin:0;opacity:1;'
      + 'transform-origin:50% 50%;will-change:transform;'
      // frame 0 of the inner track, crop offset included -- an animation that starts a frame late
      // must not show the centred crop for that frame (see the oyFrom/oyTo header)
      + 'transform:' + (kOn
        ? 'translate(' + (kX0 / sx0).toFixed(3) + 'px,' + (kY0 / sy0).toFixed(3) + 'px) '
          + 'scale(' + ((sB0 / sP) / sx0 * k0).toFixed(5) + ',' + ((sB0 / sP) / sy0 * k0).toFixed(5) + ');'
        : (oyOn ? 'translateY(' + (oyFrom / sy0).toFixed(3) + 'px) ' : '')
          + 'scale(' + ((sB0 / sP) / sx0).toFixed(5) + ',' + ((sB0 / sP) / sy0).toFixed(5) + ');')
      + 'animation:' + uid + 'i ' + ms + 'ms linear forwards';
    /* opts.host (2026-09-24): a flight may be BORN inside the viewer card instead of on <body> -- see
       heroExpand's startFlight, "THE FLIGHT FLIES UNDER THE CHROME". Default is unchanged. */
    // a LIVE clip already in the document is about to change parent: take its frame first (frameSnap)
    var _fsnap = (media.tagName === 'VIDEO' && media.isConnected) ? frameSnap(media) : null;
    /* opts.deferMove (2026-09-27, Rob's bug.mov -- see frameSnap): the clip does NOT move in this task.
       A cover added in the same task as the move is not on screen until the NEXT commit, and the close
       task is the heaviest the viewer has (the whole timeline repaints behind it): Rob's recording shows
       Safari holding the pre-close frame for ~250ms with the clip's layer already gone -- 12 frames of a
       black media box -- then jumping straight to the landed state. So the wrapper is born holding only
       the snapshot twin, the clip keeps playing where it is (under the wrapper, the same box), and it
       moves in only after two frames have been produced with the twin on screen. From then on any stall
       shows the twin, never a hole. */
    var defer = !!(opts.deferMove && media.tagName === 'VIDEO' && media.isConnected);
    (opts.host || document.body).appendChild(wrap);   // wrapper enters the document FIRST...
    if (!defer) {
      media.style.cssText = mcss;
      wrap.appendChild(media);                     // ...so the playing <video> moves document->document (never leaves, never pauses)
    }
    /* ...AND ITS PICTURE GOES WITH IT (2026-09-27, see frameSnap). The snapshot rides the flight as the
       media's twin: same inline box, same object-fit:fill, same keyframes -- added in the same task, so
       both animations start on the same frame and it sits exactly over the clip until the clip has
       presented a frame in the wrapper. Over the wrapper's #000, which is what a torn-down WebKit video
       layer otherwise shows. */
    if (_fsnap) {
      try {
        _fsnap.style.cssText = mcss + ';pointer-events:none;';
        wrap.appendChild(_fsnap);
        wrap._fsCover = _fsnap;
        flyTie(wrap, _fsnap, uid);                 // the twin runs on the WRAPPER's clock, exactly
        if (!defer) { frameCoverRelease(media, _fsnap); }
      } catch (e) {}
    }
    if (defer) {
      // no twin (the engine would not give us the frame): let the clip show THROUGH the wrapper where it
      // already is, rather than parking a black box over it for the two frames
      if (!wrap._fsCover) { wrap.style.background = 'transparent'; }
      wrap._deferMedia = media; wrap._mcss = mcss; wrap._onAdopt = opts.onAdopt || null; wrap._uid = uid;
      var adopt = function () { flyAdopt(wrap); };
      requestAnimationFrame(function () { requestAnimationFrame(adopt); });
      setTimeout(adopt, 90);                       // rAF is frozen in a background tab; flyAdopt is idempotent
    }
    pfStillSync();                                 // a .pf-hero just entered -> html.pfv-fly (was body:has(.pf-hero))
    wrap._flightCss = css;
    wrap._flightMedia = media;
    // `oyOn` (not the value): a late viewport shift changes the box the destination bias is computed
    // FROM, so flyRetarget re-solves `oyTo` rather than carrying a stale number. See there.
    wrap._flyGeom = { P: P, iw: iw, ih: ih, sP: sP, to: to, oyTo: oyTo, oyOn: oyOn };
    return wrap;
  }
  /* The deferred half of flyCrop (opts.deferMove): the clip joins its flight UNDER the twin, on the
     flight's own clock (startTime copied from the wrapper, so the inner counter-scale is the frame the
     wrapper is on), and the twin comes off once the clip has presented a frame in its new parent. */
  /* Pin an inner element's keyframe track to the wrapper's own start time (resolving when the wrapper's
     pending start does). Two animations created a frame apart -- or started on different commits -- would
     otherwise disagree about the crop by tens of px mid-flight (measured, before this: 42-102px). */
  function flyTie(wrap, el, uid) {
    try {
      var byName = function (x, n) { var l = x.getAnimations ? x.getAnimations() : []; for (var i = 0; i < l.length; i++) { if (l[i].animationName === n) { return l[i]; } } return null; };
      var wa = byName(wrap, uid + 'w'), ea = byName(el, uid + 'i');
      if (!wa || !ea) { return false; }
      var tie = function () { try { if (wa.startTime != null) { ea.startTime = wa.startTime; } } catch (e) {} };
      if (wa.startTime != null) { tie(); } else if (wa.ready && wa.ready.then) { wa.ready.then(tie, function () {}); }
      return true;
    } catch (e) { return false; }
  }
  function flyAdopt(wrap) {
    var m = wrap && wrap._deferMedia;
    if (!m) return;
    wrap._deferMedia = null;
    if (!wrap.parentNode) return;                  // disposed/landed first: the clip never left home
    try {
      if (wrap._onAdopt) { try { wrap._onAdopt(); } catch (e2) {} wrap._onAdopt = null; }
      m.style.cssText = wrap._mcss;
      wrap.insertBefore(m, wrap._fsCover && wrap._fsCover.parentNode === wrap ? wrap._fsCover : null);
      /* The flight's own clock may still be PENDING here (measured: startTime null two frames in -- a
         composited animation gets its start time when the compositor commits it, and this is the heavy
         part of the open/close). flyTie ties the clip to it the moment it resolves, never to a guess;
         by NAME, because the clip can carry other animations of its own. */
      if (!flyTie(wrap, m, wrap._uid) && wrap._flyGeom) {
        /* THE FLIGHT WAS RE-AIMED BEFORE THE CLIP JOINED IT (flyRetarget: the keyframes are gone and the
           wrapper is gliding to a re-measured box). The clip takes the retarget's own end state -- the
           same formula -- starting from where the twin is right now, on the wrapper's transition. */
        var g = wrap._flyGeom, to = g.to;
        var sx = to.width / g.P.width, sy = to.height / g.P.height, sB = Math.max(to.width / g.iw, to.height / g.ih);
        var fin = (g.oyOn && g.oyTo ? 'translateY(' + (g.oyTo / sy).toFixed(3) + 'px) ' : '') + 'scale(' + ((sB / g.sP) / sx).toFixed(5) + ',' + ((sB / g.sP) / sy).toFixed(5) + ')';
        var tw = (wrap._fsCover && wrap._fsCover.parentNode === wrap) ? wrap._fsCover : null;
        m.style.animation = 'none';
        m.style.transform = tw ? getComputedStyle(tw).transform : fin;
        void m.offsetWidth;
        if (wrap.style.transition) { m.style.transition = wrap.style.transition; }
        m.style.transform = fin;
      }
      if (wrap._fsCover && wrap._fsCover.parentNode === wrap) { frameCoverRelease(m, wrap._fsCover); }
    } catch (e) {}
  }
  // Late viewport shifts -- the mobile URL bar collapsing/expanding mid-flight -- leave the baked
  // keyframes landing at a rect measured before the shift (owner: "lands slightly off when the url
  // bar minimizes"). Glide the LANDED wrapper to the freshly-measured box: the filling animation is
  // removed first (an animation's fill beats inline styles), the current state pinned inline, then a
  // short transform transition corrects it. Returns the glide ms (0 = already on target / no geom).
  /* ---- A MOVED <video> TAKES ITS PICTURE WITH IT  (Rob 2026-09-27, desktop Safari) ----------------------
     "Going full screen then dismissing out of it on the web and I see black flashes when opening and
      closing it (closing it EVERYTIME ... only sometimes when opening it using the full screen button)
      audio plays smoothly throughout."
     The fullscreen open and the feed-card close both keep the SAME live <video> (that is what keeps the
     sound continuous and the clock exact): card -> flight wrapper -> viewer card, and back. Every one of
     those is a RE-PARENT, and WebKit tears a re-parented <video>'s compositing layer down and rebuilds
     it: until the rebuilt layer is handed its next decoded frame the element composites NOTHING, and
     what shows through is whatever is behind it -- the flight wrapper's #000, the card's `.media`
     #000, the video's own `background:#000`. Audio is not in the layer, which is exactly why the sound
     was seamless while the picture blinked. Chromium keeps the layer's last frame across a move, so no
     headless rig here can SEE it; the rule is WebKit's.
     THE RULE: before a live clip changes parent, copy its current frame into a <canvas> (drawImage --
     for display only, so a cross-origin clip is fine) and put that picture exactly over the clip in its
     new home; take it away only once the clip has PRESENTED a frame there (requestVideoFrameCallback,
     then two rAFs so the compositor has it; 'timeupdate' where rVFC is missing), bounded at 700ms so
     a stalled clip can never wear a frozen still for long. Three call sites: flyCrop (into the wrapper),
     heroExpand's adoption into the viewer card (replaceChild), close()'s landing in the timeline card. */
  function frameSnap(v) {
    try {
      if (!v || v.tagName !== 'VIDEO' || v.readyState < 2 || !(v.videoWidth > 0)) return null;
      var k = Math.min(1, 960 / Math.max(v.videoWidth, v.videoHeight));   // plenty for a frame or two
      var c = document.createElement('canvas');
      c.width = Math.max(1, Math.round(v.videoWidth * k)); c.height = Math.max(1, Math.round(v.videoHeight * k));
      var cx = c.getContext('2d'); if (!cx) return null;
      cx.drawImage(v, 0, 0, c.width, c.height);
      /* A snapshot that came back pure black is a failed read (an engine that cannot hand us this
         frame), not a picture -- covering with it would BE the flash. Checked where the canvas is
         readable (our clips carry crossorigin, so normally it is); unreadable = trust the draw. */
      try {
        var t = document.createElement('canvas'); t.width = 8; t.height = 8;
        var tx = t.getContext('2d'); tx.drawImage(c, 0, 0, 8, 8);
        var d = tx.getImageData(0, 0, 8, 8).data, mx = 0;
        for (var i = 0; i < d.length; i += 4) { mx = Math.max(mx, d[i], d[i + 1], d[i + 2]); }
        if (mx === 0) return null;
      } catch (e2) {}
      c.className = 'pf-frame-cover';
      c.setAttribute('aria-hidden', 'true');
      return c;
    } catch (e) { return null; }
  }
  function frameCoverRelease(v, c, maxMs) {
    var gone = false;
    function drop() { if (gone) { return; } gone = true; try { if (c.parentNode) { c.parentNode.removeChild(c); } } catch (e) {} }
    function presented() { requestAnimationFrame(function () { requestAnimationFrame(drop); }); }
    var armed = false;
    try { if (v.requestVideoFrameCallback) { v.requestVideoFrameCallback(presented); armed = true; } } catch (e) {}
    if (!armed) { var tu = function () { v.removeEventListener('timeupdate', tu); presented(); }; v.addEventListener('timeupdate', tu); }
    setTimeout(drop, maxMs || 700);
  }
  /* The card end of the rule: `snap` was taken BEFORE the move; place it over the clip's painted box
     in its new parent. The box is the element's transform-aware rect with the clip's own object-fit and
     object-position, so a contained, a covering and a pf-vfill (contain + scale) clip all match. One
     layout read, at the move, never per frame. */
  function frameCoverAt(v, snap) {
    if (!v || !snap || !v.parentNode) return null;
    try {
      var cs = getComputedStyle(v), r = v.getBoundingClientRect();
      if (!(r.width > 4 && r.height > 4)) return null;
      snap.style.cssText = 'position:absolute;left:0;top:0;width:1px;height:1px;margin:0;pointer-events:none;'
        + 'object-fit:' + (cs.objectFit || 'contain') + ';object-position:' + (cs.objectPosition || '50% 50%') + ';'
        + (cs.zIndex && cs.zIndex !== 'auto' ? 'z-index:' + cs.zIndex + ';' : '');
      v.parentNode.insertBefore(snap, v.nextSibling);           // later in order = painted over the clip
      var op = snap.offsetParent || document.body, pr = op.getBoundingClientRect();
      snap.style.left = (r.left - pr.left - op.clientLeft + op.scrollLeft).toFixed(2) + 'px';
      snap.style.top = (r.top - pr.top - op.clientTop + op.scrollTop).toFixed(2) + 'px';
      snap.style.width = r.width.toFixed(2) + 'px'; snap.style.height = r.height.toFixed(2) + 'px';
      frameCoverRelease(v, snap);
      return snap;
    } catch (e) { try { if (snap.parentNode) { snap.parentNode.removeChild(snap); } } catch (e2) {} return null; }
  }
  window.__rovaFrameSnap = frameSnap;              // close() lives in the pfeed IIFE
  window.__rovaFrameCoverAt = frameCoverAt;
  function flyRetarget(wrap, to, ms) {
    var g = wrap && wrap._flyGeom; if (!g || !to || to.width < 4) return 0;
    var drift = Math.abs(g.to.left - to.left) + Math.abs(g.to.top - to.top)
              + Math.abs(g.to.width - to.width) + Math.abs(g.to.height - to.height);
    if (drift < 3) return 0;
    var m = wrap._deferMedia ? null : wrap._flightMedia;   // a clip not yet adopted (deferMove) is still home: never restyle it there
    var sx = to.width / g.P.width, sy = to.height / g.P.height;
    var sB = Math.max(to.width / g.iw, to.height / g.ih);
    try {
      var wNow = getComputedStyle(wrap).transform, iNow = m ? getComputedStyle(m).transform : '';
      wrap.style.animation = 'none'; wrap.style.transform = wNow;
      if (m) { m.style.animation = 'none'; m.style.transform = iNow; }
      var fcv = (wrap._fsCover && wrap._fsCover.parentNode === wrap) ? wrap._fsCover : null;
      if (fcv) { fcv.style.animation = 'none'; fcv.style.transform = iNow; }
      void wrap.offsetWidth;   // commit the pinned state as the transition baseline
      wrap.style.transition = 'transform ' + ms + 'ms cubic-bezier(.4,0,.2,1)';
      wrap.style.transform = 'translate(' + (to.left - g.P.left).toFixed(2) + 'px,' + (to.top - g.P.top).toFixed(2)
        + 'px) scale(' + sx.toFixed(5) + ',' + sy.toFixed(5) + ')';
      if (m) {
        /* RE-SOLVE THE DESTINATION CROP BIAS FOR THE NEW BOX (2026-09-14). The bias is
           ch*(s-1)*0.35, so a viewport that shrinks by 40px does not just move the box -- it makes
           the correct bias ~14px LARGER, and carrying the old number would leave exactly the error
           this exists to remove, just smaller. It rides the same transform the retarget already
           transitions, so a re-aim is still ONE continuous motion, and it only fires on a flight
           that HAS a bias -- every grid/feed/video retarget is byte-identical. */
        var oyN = 0;
        if (g.oyOn && window.__rovaPfPanyBias) {
          oyN = window.__rovaPfPanyBias(g.iw, g.ih, to.width, to.height, true);
          if (!oyN && g.oyTo) { oyN = g.oyTo; }   // shape moved out of the biased band -> keep, don't jump
          g.oyTo = oyN;
        }
        m.style.transition = 'transform ' + ms + 'ms cubic-bezier(.4,0,.2,1)';
        m.style.transform = (oyN ? 'translateY(' + (oyN / sy).toFixed(3) + 'px) ' : '')
          + 'scale(' + ((sB / g.sP) / sx).toFixed(5) + ',' + ((sB / g.sP) / sy).toFixed(5) + ')';
        // a frame cover still riding the flight follows the clip's re-aim exactly (see frameSnap)
        if (fcv) { fcv.style.transition = m.style.transition; fcv.style.transform = m.style.transform; }
      }
      g.to = to;
    } catch (e) { return 0; }
    return ms;
  }
  function disposeFlight(wrap) {
    if (!wrap) return;
    /* A wrapper that still HOLDS a <video> is about to detach it, and a detached <video> keeps playing --
       audio included -- somewhere no DOM query can ever find it again (see __rovaStopOrphanMedia). Every
       call site that MEANS to keep the clip moves it out first, so a clip still in here is one nobody
       owns: the still-hero fallback below (a live video hero that found no handoff target) and the
       "its home vanished" borrow branch both land here. Releasing is the only safe reading of "dispose".
       Callers that already released explicitly are unaffected -- this is idempotent. */
    try {
      var lv = wrap.querySelector ? wrap.querySelector('video') : null;
      if (lv) { heroReleaseVideo(lv); if (window.__rovaRetireVideo) { window.__rovaRetireVideo(lv); } }
    } catch (e) {}
    try { if (wrap._flightCss && wrap._flightCss.parentNode) wrap._flightCss.parentNode.removeChild(wrap._flightCss); } catch (e) {}
    try { if (wrap.parentNode) wrap.parentNode.removeChild(wrap); } catch (e) {}
    pfStillSync();                                 // ...and one just left
  }
  /* ---- FLIGHT-SYNC TELEMETRY (admin-only; owner: "debug videos + their timecode
     synchronization during expand/collapse"). While a hero flight runs, sample the
     involved <video>'s clock / buffered-ahead / readyState every 100ms for ~1.4s,
     track rAF gaps (the animation's own smoothness) and droppedVideoFrames, and
     stamp lifecycle marks (pfeedready, target, tileReveal, drop...). The record
     POSTs to /vflight -> perf-log.jsonl as a {kind:'vflight',web:1} line.
     Reading one: ev=[{ms,t,buf,rs,pl}] wall-ms/clock/buffer-ahead-s/readyState/
     playing; jump = max |Δclock−Δwall| ms while playing (seek/hiccup mid-tween);
     stall = ms the clock froze while "playing"; bufMin = worst buffer-ahead;
     drops = decoder frames dropped in the window; rafWorst = worst animation
     frame gap ms (>17 = visibly dropped frames). Perfect flight: jump≈0, stall 0,
     bufMin>1, drops 0, rafWorst<20. ------------------------------------------ */
  // Log EVERY logged-in user's flights (owner: "let everyone's use be logged so we can get it working
  // smoothly for everyone"), not just admins. Guests are excluded on purpose: they have no session to
  // auth the POST (an unauthenticated write-to-disk endpoint is an abuse/disk-fill vector) and they're
  // already bandwidth-gated at 15 posts. A per-session cap keeps one heavy browser from dominating the
  // log or flooding the beacon.
  var vfLog = !document.querySelector('meta[name="rova-guest"]');
  var VF_SESS_MAX = 80, vfSessN = 0;   // 40 -> 80: opens are recorded now too, and they must not halve the close sample
  var vfCur = null;
  function vfBufAhead(v) {
    try {
      var b = v.buffered, t = v.currentTime;
      for (var i = 0; i < b.length; i++) { if (t >= b.start(i) - 0.1 && t <= b.end(i)) return Math.round((b.end(i) - t) * 100) / 100; }
      return 0;
    } catch (e) { return -1; }
  }
  function vfDrops(v) {
    try {
      if (v.getVideoPlaybackQuality) return v.getVideoPlaybackQuality().droppedVideoFrames;
      if (typeof v.webkitDroppedFrameCount === 'number') return v.webkitDroppedFrameCount;
    } catch (e) {}
    return -1;
  }
  // Attach a one-shot-per-element seek WATCHER to the sampled clip: the owner reports the rewind happens
  // AFTER the tile lands and is playing, so log EVERY seek the tile takes (a stale re-seek, a loop wrap, a
  // reverse-handoff) with its from/to time. `seeking` fires the instant currentTime is assigned, so `to` is
  // the target and rec.lastT (last sampled clock) is where it jumped FROM. to<from = a rewind, timestamped.
  function vfWatchSeeks(rec, v) {
    if (!v || v._vfSeekWatched) return;
    v._vfSeekWatched = 1;
    var onSeek = function () {
      if (rec.done) return;
      var to = -1; try { to = Math.round(v.currentTime * 100) / 100; } catch (e) {}
      rec.marks.push({ n: 'seek', ms: Math.round(performance.now() - rec.t0), from: rec.lastT, t: to });
    };
    v.addEventListener('seeking', onSeek);
    (rec.seekWatched || (rec.seekWatched = [])).push({ v: v, fn: onSeek });
  }
  function vfStart(dir, pid, video, key) {
    if (!vfLog || vfSessN >= VF_SESS_MAX) return;
    vfSessN++;
    if (vfCur) vfFinish(vfCur);
    var t0 = performance.now();
    // WHY this path was taken (set by the caller through __rovaVfWhy right before it stamps). The close
    // has three dismissal paths and the log could not tell them apart: 349 of 1,088 records turned out to
    // be the STILL-CLONE fallback, and nothing in the record said so. One-shot -- read and cleared here.
    var why = window.__rovaVfWhy || ''; window.__rovaVfWhy = '';
    /* THE LIFT RECEIPT (2026-08-17). Same one-shot convention as `why` directly above, and
       here for the same reason: the record cannot work out for itself which rendition the
       tile was on or what position it handed over, and those two numbers are the entire
       evidence for "it continued instead of restarting".
         g3  = the tile's master-time multiplier, 0 when it played a full-length rendition
               (so `g3` alone separates the new path from the old one in the corpus)
         at  = the position handed to the viewer, in MASTER seconds, already mapped
       A row with g3>0 and at>0 whose ev[] shows no backward step is a proven seamless
       continue; g3>0 with at:0 means the tile was not rolling at the tap, which is a
       different (and legitimate) story than a restart.

       THE BOOMERANG HALF (2026-08-17), present only on a `_grid6` open:
         g6  = 1, so the corpus can separate palindrome opens from straight `_grid3` ones
         p   = the RAW tile position, before the fold was applied
         d   = the tile file's duration, i.e. 2x its forward window
         r   = +1 if the tap came from the forward half, -1 from the reverse half
       WHY THE RAW POSITION IS KEPT ALONGSIDE THE MAPPED ONE. `at` is the mapped master time,
       and on its own it is unfalsifiable -- every value looks plausible. With p, d and r on
       the same row the mapping is CHECKABLE after the fact: `at` must equal p when r is +1
       and d - p when r is -1. That is what turns "the lift landed somewhere" into "the lift
       landed on the frame under his finger", and it is the only way a reverse-half mapping
       regression is legible in a log rather than only on a screen recording. */
    var _g3r = window.__rovaVfG3 || null; window.__rovaVfG3 = null;
    var rec = { dir: dir, pid: pid || 0, key: key ? String(key).split('/').pop().slice(-40) : '', why: why,
      g3: _g3r ? _g3r.s : 0, at: _g3r ? _g3r.t : -1,
      g6: (_g3r && _g3r.g6) ? 1 : 0,
      g6p: (_g3r && _g3r.g6) ? _g3r.p : -1,
      g6d: (_g3r && _g3r.g6) ? _g3r.d : -1,
      g6r: (_g3r && _g3r.g6) ? _g3r.r : 0,
      t0: t0, ev: [], marks: [], v: video || null, cloneV: video || null, lastT: -1,
      drops0: video ? vfDrops(video) : -1, raf: { last: t0, worst: 0, worstAt: 0, n: 0 }, done: false };
    var tick = function (now) {
      if (rec.done) return;
      var d = now - rec.raf.last; rec.raf.last = now; rec.raf.n++;
      if (d > rec.raf.worst) { rec.raf.worst = d; rec.raf.worstAt = Math.round(now - t0); }   // WHEN the stall hit (vs tween 0-340ms / rebuild after)
      requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
    var sample = function () {
      var v = rec.v, e = { ms: Math.round(performance.now() - t0), t: -1, buf: -1, rs: -1, pl: false };
      if (v) { try { e.t = Math.round(v.currentTime * 100) / 100; e.buf = vfBufAhead(v); e.rs = v.readyState; e.pl = !(v.paused || v.ended); rec.lastT = e.t; } catch (err) {} }
      rec.ev.push(e);
    };
    if (video) vfWatchSeeks(rec, video);
    sample();
    // window EXTENDED to 2.8s (was 1.4s): the owner reports the jump comes AFTER the tile lands and plays,
    // which is 400-500ms in -- keep sampling well past the handoff so a delayed re-seek/loop is captured.
    rec.iv = setInterval(function () { sample(); if (performance.now() - t0 >= 2800) vfFinish(rec); }, 100);
    vfCur = rec;
  }
  function vfMark(name, video) {
    if (!vfCur) return;
    var t = -1;
    try { var v = video || vfCur.v; if (v) t = Math.round(v.currentTime * 100) / 100; } catch (e) {}
    var atIdx = vfCur.ev.length;   // the sample index this mark sits at
    vfCur.marks.push({ n: name, ms: Math.round(performance.now() - vfCur.t0), t: t });
    // handoff: from here on, sample the surface that's actually on screen (e.g. the tile's rebuilt clip).
    // Record the boundary so the jump/stall math skips the sample straddling the surface swap -- crossing
    // from the flying clip's clock to the tile's freshly-seeked clock is NOT a real playback glitch.
    if (video) {
      vfCur.v = video;
      if (vfCur.drops0 < 0) vfCur.drops0 = vfDrops(video);
      (vfCur.breaks || (vfCur.breaks = [])).push(atIdx);
      vfWatchSeeks(vfCur, video);   // watch the tile's seeks for the whole post-landing window
    }
  }
  function vfFinish(rec) {
    if (rec.done) return; rec.done = true;
    clearInterval(rec.iv);
    if (vfCur === rec) vfCur = null;
    // detach the seek watchers (and clear the per-element guard so a future flight can re-watch the clip)
    if (rec.seekWatched) { rec.seekWatched.forEach(function (w) { try { w.v.removeEventListener('seeking', w.fn); w.v._vfSeekWatched = 0; } catch (e) {} }); }
    var ev = rec.ev, jump = 0, stall = 0, bufMin = Infinity, rewind = 0, rewindAt = -1, breaks = rec.breaks || [];
    for (var i = 1; i < ev.length; i++) {
      var dw = ev[i].ms - ev[i - 1].ms, dt = (ev[i].t - ev[i - 1].t) * 1000;
      // skip the sample that straddles a surface handoff (breaks[] = the swap indices): the clock
      // legitimately jumps from one clip's time to another's, which isn't a playback discontinuity.
      if (ev[i - 1].t >= 0 && ev[i].t >= 0 && breaks.indexOf(i) < 0) {
        var back = ev[i].t - ev[i - 1].t;   // negative = the clock moved BACKWARD = a visible rewind
        if (back < rewind) { rewind = back; rewindAt = ev[i].ms; }
        if (ev[i - 1].pl) {
          var off = Math.abs(dt - dw);
          if (off > jump) jump = off;
          if (dt < dw * 0.5) stall += dw;
        }
      }
      if (ev[i].buf >= 0 && ev[i].buf < bufMin) bufMin = ev[i].buf;
    }
    var drops = rec.v ? vfDrops(rec.v) : -1;
    // drops delta is only meaningful if we never switched surfaces (breaks): the tile's rebuilt clip has
    // its OWN, lower dropped-frame counter than the flying clip, so cross-surface deltas go negative and
    // are noise. Report -1 (n/a) in that case rather than a bogus negative.
    var dropDelta = (drops >= 0 && rec.drops0 >= 0 && !(rec.breaks && rec.breaks.length)) ? (drops - rec.drops0) : -1;
    var out = { kind: 'vflight', web: 1, dir: rec.dir, pid: rec.pid, key: rec.key, why: rec.why || '',
      ts: Math.round(Date.now() / 1000), ev: ev, marks: rec.marks,
      jump: Math.round(jump), stall: Math.round(stall),
      bufMin: bufMin === Infinity ? -1 : bufMin,
      rewind: Math.round(rewind * 100) / 100, rewindAt: rewindAt,   // most-negative clock step (s) + when (ms); 0 = clean
      drops: dropDelta, cross: rec.cross || null,
      rafWorst: Math.round(rec.raf.worst), rafWorstAt: rec.raf.worstAt, rafN: rec.raf.n };
    try {
      fetch('/vflight', { method: 'POST', credentials: 'same-origin', keepalive: true,
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest',
          'X-CSRF-Token': (document.querySelector('meta[name="csrf-token"]') || {}).content || '' },
        body: JSON.stringify({ samples: [out] }) }).catch(function () {});
    } catch (e) {}
  }
  // CROSSOVER capture (owner: "it still randomly rewinds — the timecode continuity changes after
  // collapsing"). The visible rewind is at the SWAP instant: the flying clone shows frame X, the tile
  // reveals showing frame Y. If Y < X the user sees a rewind. This reads BOTH clocks at that instant
  // (the flying clip stored as cloneV, the tile passed in) so `cross.delta` (tileT - cloneT) is the
  // exact visible discontinuity -- negative = rewind. Recorded once, at the reveal.
  function vfCross(tileVideo) {
    if (!vfCur || !tileVideo || vfCur.cross) return;
    var cloneT = -1, tileT = -1;
    try { if (vfCur.cloneV) cloneT = Math.round(vfCur.cloneV.currentTime * 100) / 100; } catch (e) {}
    try { tileT = Math.round(tileVideo.currentTime * 100) / 100; } catch (e) {}
    vfCur.cross = { cloneT: cloneT, tileT: tileT,
      delta: (cloneT >= 0 && tileT >= 0) ? Math.round((tileT - cloneT) * 100) / 100 : null,
      ms: Math.round(performance.now() - vfCur.t0) };
  }
  /* ---- LANDING RECEIPTS (2026-08-17) -------------------------------------------------------------
     A photo open records no vflight sample and correctly so -- there is no clock to sample. But the
     LANDING has two numbers worth keeping (predicted top vs painted top), and without them "it lands
     exactly now" is a claim about a screen recording rather than a fact in a log.

     VOLUME IS THE WHOLE DESIGN CONSTRAINT: a photo open is the single most common action on the site,
     so this must not become a POST per tap. An INEXACT landing (dy >= 1px, or any correction still owed
     after the tween) always reports -- that is the regression signal. Exact ones report only three
     times per page load, which is enough to prove the happy path is being exercised and not merely
     silent. Rides the existing /vflight sink (flight-log.jsonl), so nothing new to read or rotate; a
     live video record absorbs it as a mark instead, keeping one flight on one row. */
  var vfLandN = 0, VF_LAND_MAX = 3;
  function vfLandRecord(o) {
    // ALSO on the window, unconditionally: a guest never POSTs (vfLog is false for them, and the
    // endpoint is session-authed), and a harness or a console needs the two numbers without a
    // round-trip through the log. Last landing only -- this is a probe, not a buffer.
    try { window.__rovaLandLast = o; } catch (e) {}
    try {
      if (vfCur) { vfCur.marks.push({ n: 'land', ms: Math.round(performance.now() - vfCur.t0), t: -1, land: o }); return; }
      if (!vfLog) return;
      var bad = (o.dy >= 1) || (o.dh >= 1) || (o.post > 0);
      if (!bad) { if (vfLandN >= VF_LAND_MAX) return; vfLandN++; }
      fetch('/vflight', { method: 'POST', credentials: 'same-origin', keepalive: true,
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest',
          'X-CSRF-Token': (document.querySelector('meta[name="csrf-token"]') || {}).content || '' },
        body: JSON.stringify({ samples: [{ kind: 'vflight', web: 1, dir: 'open-land',
          ts: Math.round(Date.now() / 1000), land: o }] }) }).catch(function () {});
    } catch (e) {}
  }
  window.__rovaVfLand = vfLandRecord;
  window.__rovaVfStart = vfStart;   // other scopes (pfeed close, grid play) stamp through these
  window.__rovaVfMark = vfMark;
  window.__rovaVfCross = vfCross;
  document.addEventListener('rova:pfeedready', function () { vfMark('pfeedready'); });

  /* ---- FLIGHT BUSY GATE (2026-08-12) -------------------------------------------------------------
     THE MEASUREMENT: over 1,088 logged web closes the worst animation-frame gap was >60ms on 1,062 of
     them, clustered in TWO places -- 50-250ms (the first third of the 340ms collapse tween) and a sharp
     400-450ms spike (87 records) sitting exactly on the teardown/handoff/grid-rebuild collision. p50
     rafWorst over the last three days was 407ms: one frame held for four tenths of a second, mid-flight.
     That is not the animation (it runs on the compositor, transforms only) -- it is OTHER main-thread
     work landing on top of it.

     There is already a hold for the OPEN flight (html.hz-hold, heroHolds) but the COLLAPSE has none, so
     every 3s/4s poller, census and prefetcher in this file was free to fire mid-dismiss. This is the
     collapse's equivalent, and deliberately NOT a class on <html>: it steers JS work, not CSS, and the
     things it steers are all "nothing waits on this" background jobs. Same shape as the native side's
     "a flight is in progress" gate.

     LEVEL-TRIGGERED, never a flag anyone has to remember to clear: callers stamp a deadline, readers ask
     whether we are past it. A crashed or interrupted flight therefore un-gates itself within one window
     instead of freezing the pollers until reload. */
  var _flightUntil = 0;
  window.__rovaFlightHold = function (ms) {
    var u = Date.now() + (ms || 900);
    if (u > _flightUntil) { _flightUntil = u; }
  };
  window.__rovaFlightBusy = function () { return Date.now() < _flightUntil; };

  window.__rovaFlyCrop = flyCrop;                  // the pfeed IIFE's close() flies its dismissals through these
  /* A collapse DESTINATION's corner rounding, in the shape flyCrop understands (owner 2026-08-29
     screenshot: the avatar-photo dismiss landed as "a slightly-rounded rectangle... trying to crop
     it back to a circle but not quite"). Two traps this closes at every call site:
       (1) parseFloat(getComputedStyle(el).borderRadius) on a circular destination reads '50%' as
           50 -- treated as fifty PIXELS ever after;
       (2) a px radius >= half the box is CLAMPED by the engine into a circle/ellipse on the real
           element, so the flight must land as one too or the reveal pops.
     %-based (and effectively-circular px) rounding comes back as a '%' STRING -- flyCrop animates
     that as a fraction of the flying box, which is scale-proof -- and an honest px radius comes
     back as the number it always was, for the unchanged px path. */
  function destRadius(el) {
    try {
      // borderTopLeftRadius fallback: some engines serialize the computed SHORTHAND as '' when the
      // four corners differ; the longhand always answers, and one corner is all this needs.
      var cs = getComputedStyle(el);
      var v = String(cs.borderRadius || cs.borderTopLeftRadius || '').split(' ')[0] || '';
      var n = parseFloat(v) || 0;
      if (n <= 0) { return 0; }
      if (v.indexOf('%') > -1) { return Math.min(n, 50) + '%'; }
      var b = el.getBoundingClientRect(), half = Math.min(b.width, b.height) / 2;
      return (half > 0 && n >= half) ? '50%' : n;
    } catch (e) { return 0; }
  }
  window.__rovaDestRadius = destRadius;
  window.__rovaDisposeFlight = disposeFlight;
  window.__rovaFlyRetarget = flyRetarget;          // late-viewport drift correction (usable by the close too)
  window.__rovaPaintedRect = paintedRectOf;        // TRUE drawn extent (handles object-fit:contain letterboxing)
  // The slide a carousel is actually SHOWING (see centeredSlideOf). Exported because the pfeed IIFE's close()
  // needs the SAME answer: its live-video dismiss branch used to hand-copy the old querySelector('.cslide')
  // first-slide grab, so closing from slide 2/3 flew SLIDE 1's clip -- and slide 1 is translated a whole
  // viewport (or several) off to the LEFT, so it swept in horizontally instead of dropping down into the tile.
  // ONE definition, reached through window: a second copy is exactly what regressed this.
  window.__rovaCenteredSlide = centeredSlideOf;
  // One clamped, gated hold-release: never goes negative, and only lifts hz-hold once NO open-flight clone is
  // still on screen -- so a stale decrement can neither drive the counter below zero nor unfreeze a live flight.
  function heroRelease() {
    heroHolds = Math.max(0, heroHolds - 1);
    if (heroHolds === 0 && !document.querySelector('.pf-hero:not(.pf-hero-collapse)')) {
      try { document.documentElement.classList.remove('hz-hold'); } catch (e) {}
      /* SCRIM RELEASE (a), catch-all -- see .pfeed.pf-settling:not(.pf-hasmedia) in rova.css. Every
         open flight that reaches an actual hold-lift has painted its picture over the viewer, so the
         settling backdrop may be opaque from here even while the card's full-res still loads. The
         reveal() paths stamp earlier (at the landing, before their fade timers); this covers the
         branches that lift without passing them (adoption, the borrow return, heroFlip). Aborts do
         NOT come through here (__rovaHeroReset removes hz-hold directly), so a junked flight never
         darkens an empty shell -- that window keeps the dim scrim until the openers' 800ms backstop. */
      try { var shm = document.querySelector('.pfeed.pf-settling'); if (shm) shm.classList.add('pf-hasmedia'); } catch (e) {}
    }
    /* The shared release point of EVERY open flight, and every "remove the clone first, then release"
       branch calls it one statement after the removal -- so this is where the direct removals that
       bypass disposeFlight get their sync, without each of them having to remember. */
    pfStillSync();
  }
  // RECOVERY: opening + closing the viewer FAST can interrupt a hero mid-flight before its fade() releases
  // the hold -- leaving html.hz-hold ON (which pauses ALL media, so the site looks frozen) and an orphan
  // clone stuck on screen, until a page reload. close() calls this to force-clear that state. It clears only
  // the OPEN-flight clones (not the .pf-hero-collapse the dismiss is currently animating), resets the hold
  // counter, and drops the hold/flip classes. A normal close (nothing in flight) is a harmless no-op.
  window.__rovaHeroReset = function () {
    heroGen++;                    // invalidate every in-flight closure -> stale flights self-cancel + stop
    heroHolds = 0;
    try { document.documentElement.classList.remove('hz-hold', 'hz-flip'); } catch (e) {}
    try { var rmp0 = document.querySelector('.pfeed.pf-flight'); if (rmp0) rmp0.classList.remove('pf-flight'); } catch (e) {}
    /* ...AND THE BOOMERANG OVERLAY WITH THEM (2026-08-17). `.pf-dsv` is a landed flight wrapper that
       was deliberately re-classed OUT of `.pf-hero` so the hold could lift on time while its picture
       stayed up for the deferred dissolve (see boomArmRelease). That makes it invisible to the gate
       above and to this sweep -- which is exactly right for the hold and exactly wrong for the
       recovery, because the one thing that must never survive a reset is a full-screen opaque layer
       over the viewer. Its own timers are generation-guarded, but a reset is the path that exists for
       when a closure did NOT get to run. `boomDrop` first so the lift-off master is retired too. */
    try { boomDrop('reset'); } catch (e) {}
    Array.prototype.forEach.call(document.querySelectorAll('.pf-hero:not(.pf-hero-collapse), .pf-dsv'), function (el) {
      try {
        heroReleaseVideo(el);   // handles a bare <video> AND a flyCrop wrapper holding one
        if (el._flightCss && el._flightCss.parentNode) { el._flightCss.parentNode.removeChild(el._flightCss); }
        if (el.parentNode) el.parentNode.removeChild(el);
      } catch (e) {}
    });
    pfStillSync();   // the recovery path must leave html.pfv-fly off too, or the grid stays frozen till reload
  };
  // LIVE KEN BURNS READ (web parity fix, round: tap-to-open crop mismatch): a grid/timeline/carousel <img>
  // pans continuously (gridPan/tlPan/tlPanAlt/kenburns, rova.css) while idle, so the frame on screen the
  // instant before a tap is rarely the plain rest crop. Both hero clones below are brand-new elements sized
  // to the STABLE container box (see the KEN BURNS start note further down), not the live overscaled img
  // rect, and always started at that rest crop -- so if the pan was mid-cycle, the clone's very first frame
  // visibly re-crops/re-zooms the photo a beat before the intentional zoom-open motion takes over. Reading
  // the tapped <img>'s live computed scale/translate (the exact two properties every Ken Burns keyframe
  // animates) lets the clone be seeded from that SAME frame instead of always from rest.
  function liveKbRead(img) {
    if (!img) return null;
    try {
      var cs = getComputedStyle(img);
      var sc = cs.scale, tr = cs.translate;
      if ((!sc || sc === 'none' || sc === '1') && (!tr || tr === 'none')) return null;   // already at rest -- nothing to seed
      return { scale: sc, translate: tr };
    } catch (e) { return null; }
  }
  // Ease a freshly seeded clone's extra scale/translate off to rest over a short window, so the live-pan
  // frame it was born with settles away instead of persisting as a permanent offset. Must run AFTER the
  // clone is in the document -- the offsetWidth read commits the seeded frame as the transition's start
  // point (same pin-then-transition idiom flyRetarget uses above for a mid-flight correction). scale/
  // translate are independent CSS properties that compose UNDER whatever `transform` the flight itself
  // sets (heroZoom's own translate+scale, or flyCrop's later full cssText takeover), so this never fights
  // either one -- it just quietly stops mattering the moment either starts writing to the element.
  function liveKbSeed(el, kb) {
    if (!kb) return;
    void el.offsetWidth;
    el.style.transition = 'scale .18s ease-out, translate .18s ease-out';
    el.style.scale = '1';
    el.style.translate = '0 0';
  }
  function heroZoom(rect, src, nw, nh, holdResume, photo, clip, fullSrc, heroNode, srcImg) {
    // heroNode (optional): a LIVE grid <video> to fly AS the hero instead of a still clone. It's already
    // playing, so it NEVER shows black and keeps playing as it lifts (owner). fade() cross-fades it to the
    // pfeed's own copy once that's playable + positioned. Caller must NOT set the grid donor in this mode.
    if (!src || !rect || rect.width < 4 || rect.height < 4) return;
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;   // honour the setting
    // flight-sync telemetry: a live grid clip is flying up -- record its clock/buffer through the expand
    // (donor adoption moves this same element into the viewer, so the recorder follows it end-to-end)
    /* OPENS WERE NEVER BEING RECORDED (2026-08-12). The corpus held 1,176 web flights and not one
       dir:'open' -- because this line only fires for a heroNode, and a heroNode exists ONLY on the
       fullscreen-button path (16718). THE GRID TAP -- the main way media is opened at all -- flies a
       still <img> clone and hands the viewer the live clip through __rovaGridDonor instead, so it has a
       live <video> to sample the whole time and simply was not asked. Sample the donor in that case: it
       is the same element the adoption moves into the viewer, so the record follows it end-to-end
       exactly as the heroNode one does. Photo opens still record nothing, correctly -- no clock. */
    var _vfOpenV = (heroNode && heroNode.tagName === 'VIDEO') ? heroNode : null, _vfOpenId = 0;
    if (!_vfOpenV) {
      var _don = window.__rovaGridDonor;
      if (_don && _don.v && _don.v.tagName === 'VIDEO' && _don.v.readyState >= 2) { _vfOpenV = _don.v; _vfOpenId = _don.id || 0; }
    }
    if (_vfOpenV) {
      window.__rovaVfWhy = heroNode ? 'live-hero' : 'donor';
      vfStart('open', _vfOpenId, _vfOpenV, fullSrc || src);
    }
    if (window.__rovaFlightHold) { window.__rovaFlightHold(1100); }
    // FLIP-OPEN (?flipopen): animate the REAL pfeed media from the card rect instead of a separate zoom
    // clone. No clone => no size guess, no overshoot, no clone-vs-photo jump: the media lands on its OWN
    // natural full-screen spot (transform identity). Photos only for now; videos keep the donor-handoff
    // clone path below. Gated so it can't touch the normal open until we've confirmed it on-device.
    if (photo && !holdResume && /[?&]flipopen/.test(location.search)) {
      heroFlip((clip && clip.width > 4 && clip.height > 4) ? clip : rect);
      return;
    }
    var born = Date.now();   // for the level-triggered resume check below (the event can beat the landing)
    // KEN BURNS start (round: /p/1206 square-crop): the tapped grid <img> is mid-pan (gridPan/tlPan
    // scale+translate), so its OWN rect is the OVERSCALED panning extent, not the visible tile. Start
    // the clone from the CLIPPING box the caller passes (.pcell/.media/.cslide = the TRUE on-screen
    // tile/window) instead. The clone is object-fit:cover of the FULL photo, so covering that box shows
    // the whole photo aspect (a portrait bleeds slightly past a square grid tile top/bottom -- the full
    // uncropped image, which is what we want), and the composited transform alone grows it to the
    // landing box. NO clip-path: the old animated inset(...) that cropped the clone to the tile ran on
    // the MAIN thread (~30fps during the open) while the transform ran composited, so the photo looked
    // SQUARE-CROPPED and jittered until the inset opened (the user's "square cropped photo... screen
    // jitter" report). Dropping it keeps the entire flight on the compositor.
    var startRect = (clip && clip.width > 4 && clip.height > 4) ? clip : rect;
    // vh = the SETTLED viewport, not the one under the finger: the open pins the document and the phone's
    // bottom bar takes ~40px back a beat later (see pfLandVh). Centring in the pre-lock height landed the
    // photo 20px low and then corrected up after the tween -- the owner's 2026-08-17 report.
    var vw = window.innerWidth, vh = pfLandVh();
    // FINAL box = where the pfeed paints this media. The pfeed is FULL-SCREEN; a PORTRAIT photo on a WIDE
    // viewport (desktop) opens CONTAINED (letterboxed), so land on the contained rect there, else full-bleed.
    // We know the tapped media's natural aspect (nw x nh) to size that box.
    var gl = 0, gt = 0, gw = vw, gh = vh;
    // The pfeed opens COVER (full-bleed) only for PORTRAIT media on a PORTRAIT/square viewport (the phone
    // case); everything else -- portrait media on a WIDE/desktop viewport, OR any LANDSCAPE media -- opens
    // CONTAINED (letterboxed). Landing on the wrong one made a landscape / large image paint FULL-BLEED (cover
    // upscales + crops it huge) then shrink to the contained pfeed image = the "painting very large" bug on
    // desktop. Size the final box to whichever the pfeed will actually use.
    // PHOTOS open COVER-ZOOMED at every aspect (pf-zoomable: rendered contain + scaled by --pf-cover to fill
    // the screen edge-to-edge; tap = uncrop) EXCEPT a portrait photo on a WIDE viewport, which opens whole
    // (pf-uncrop). The old guess treated a LANDSCAPE photo as contained, so the hero landed small while the
    // real image zoomed 3.25x underneath, then stretched onto it -- the "cascading" open on /p/930. Videos
    // keep the original rule: cover only for portrait-clip-on-portrait-viewport.
    if (nw && nh) {
      // MIRROR THE PFEED FIT (round: /p/1205 grid-tap): the fit apply() decides its crop and sizes
      // --pf-cover against the pfeed LIST/SCROLLER boxes, not the raw viewport. The old guess used
      // vw > vh; in the band where the two disagree (scrollbar-wide near-square windows, or a fit that
      // ran before the viewer had layout) the media opened one way while the hero landed the other and
      // it ballooned out from under the cross-fade. Measure the SAME boxes apply() uses (they hold
      // layout even while the viewer is hidden; fall back to the scrollbarless document width before
      // the first build) and reproduce its exact decision, so the hero's final box IS where it paints.
      var pfl = document.querySelector('.pfeed .pfeed-list');
      var pfs = document.querySelector('.pfeed .pfeed-scroll');
      var lw = pfl && pfl.clientWidth, sh = pfs && pfs.clientHeight;
      // REJECT a STALE-WIDE read (round: /p/1206 grid-tap @1291x903). On the grid-tap path the hero
      // starts BEFORE __rovaProfileFeed adds .show, so the list/scroll can still carry a width from a
      // prior (wider) session or an unlaid empty state -- measured ~1394 at a 1291 viewport. The pfeed
      // is position:fixed inset:0, so its list/scroll can NEVER exceed the viewport; a larger value is
      // stale. Trusting it centered the predicted box in 1394 = 51.6px right of the real photo, and the
      // measured-landing net then glided the hero left at full opacity (the "lands right, slides left"
      // two-stage landing). When the read is bogus, fall back to documentElement.clientWidth -- the
      // scrollbar-less width apply() effectively fits into -- NOT innerWidth (that re-adds the scrollbar
      // and lands ~7px off). A live (<= viewport) value is still trusted exactly as before.
      var cw = (lw && lw <= vw) ? lw : (document.documentElement.clientWidth || vw);
      var ch = (sh && sh <= vh) ? sh : vh;
      // Do NOT add the list's bounding-left (round: /p/1206 grid-tap @1291-wide). The pfeed is a
      // position:fixed;inset:0 fullscreen viewer whose slide is centered in the CONTENT box from
      // origin 0. On the grid-tap path the hero is born mid-open, while the horizontal snap-scroller
      // list is still transiently offset (~51.6px here), so reading its live getBoundingClientRect().left
      // put the predicted box 51.6px right of where the media paints (list settles to left 0 by paint
      // time). Centering in cw from origin 0 matches the painted media exactly.
      // FIT DECISION mirrors apply() and differs between photo and video ONLY for LANDSCAPE media:
      //  - PHOTO (pf-zoomable): cover-zoom at every aspect EXCEPT a portrait photo on a WIDE viewport,
      //    which opens WHOLE (pf-uncrop = contain).
      //  - VIDEO: pf-vfill COVER whenever the clip and the screen SHARE orientation -- a portrait clip on a
      //    portrait/square viewport (cw <= ch) OR a landscape clip on a landscape/wide viewport. Cross-
      //    orientation (portrait clip on a wide viewport, landscape clip on a portrait phone) opens CONTAIN.
      //    This MUST match fitPfeedMedia's `pf-vfill = portrait === !wideView`, or the hero flies to a
      //    contained box while the video paints filled and the size gap reads as a fade instead of a zoom.
      // PHOTO: __rovaPhotoCovers IS fitPfeedMedia's pf-uncrop verdict -- the same function body, not a
      // mirror of it (search "THE ONE PHOTO FIT VERDICT"). It used to be re-derived here, which is how a
      // wide photo came to be predicted as cover while the real image painted letterboxed -- the
      // "cascading"/ballooning open. VIDEO keeps the orientation rule (pf-vfill) untouched.
      // FIT HINT: read off the SOURCE <img> this flight lifts off (the tapped feed card or the
      // permalink slide, both stamped data-fit by views/_post.php). The prediction has to see the
      // same hint the landed card will, or the hero flies to a cover-sized box and the real photo
      // then paints contained underneath it -- the ballooning open this shared body exists to stop.
      // VIDEO reads __rovaVideoCovers now, the shared clip body (see "THE ONE VIDEO FIT VERDICT")
      // -- same orientation rule as the line that was here, plus the per-media fit hint. The hint
      // can arrive on either node this flight holds: the live grid <video> being flown (heroNode,
      // stamped by ensureVideo) or the tile/card it lifted off (srcImg). __rovaFitHint takes both
      // and returns the first opinion, so a photo-only caller is unaffected.
      var cover = photo ? window.__rovaPhotoCovers(nw, nh, cw, ch, window.__rovaFitHint(srcImg))
                        : window.__rovaVideoCovers(nw, nh, cw, ch, window.__rovaFitHint(heroNode, srcImg));
      var fit = cover ? Math.max(cw / nw, ch / nh) : Math.min(cw / nw, ch / nh);
      var dw = nw * fit, dh = nh * fit;                    // painted extent, centered in the content box
      var dl = (cw - dw) / 2, dt = (ch - dh) / 2;
      gl = Math.max(dl, 0); gt = Math.max(dt, 0);          // the box crops the overflow (overflow:hidden)
      gw = Math.min(dl + dw, cw) - gl; gh = Math.min(dt + dh, ch) - gt;
    }
    var isVideoHero = !!(heroNode && heroNode.tagName === 'VIDEO');
    var el;
    if (isVideoHero) {
      el = heroNode;                                   // the LIVE grid <video> -- reparent it (below), keep it playing
      el.className = 'pf-hero'; el.removeAttribute('width'); el.removeAttribute('height');
      // drop the grid overlay's reveal-on-play listeners: they'd force inline opacity 1 mid-flight; fade() owns
      // this element's opacity now (so the hero can hold, then cross-fade cleanly).
      if (el._grReveal) { el.removeEventListener('loadeddata', el._grReveal); el.removeEventListener('playing', el._grReveal); el._grReveal = null; }
    } else {
      el = document.createElement('img');
      el.src = src; el.alt = ''; el.decoding = 'async'; el.className = 'pf-hero';
    }
    // Place the clone at its FINAL (landed) box with object-fit:cover, so the frame we END on is EXACTLY the
    // pfeed's crop -- a pixel-perfect landing. Then TRANSFORM it back onto the tapped cell and animate the
    // transform to identity. Animating `transform` (not left/top/width/height) keeps the whole zoom on the
    // COMPOSITOR thread, so it stays 60fps even while the pfeed's open work pins the MAIN thread. (Measured:
    // the main thread sits at ~30fps through the open -- exactly what dropped frames on the old layout-property
    // animation; a composited transform is immune to it.) Uniform scale -> no distortion.
    // Cover the START box (the true tile/window) with a UNIFORM scale, centered on it -- no distortion,
    // and the clone shows the full photo aspect bleeding past the box where their aspects differ.
    var sc = Math.max(startRect.width / gw, startRect.height / gh);
    var tx = (startRect.left + startRect.width / 2) - gw * sc / 2 - gl;
    var ty = (startRect.top + startRect.height / 2) - gh * sc / 2 - gt;
    var kb = !isVideoHero ? liveKbRead(srcImg) : null;
    /* THE LANDING CROP, not just the landing box (2026-09-14) -- the legacy opener's half of the same
       fix heroExpand got today. This element really is object-fit:cover, so the bias is spelled as an
       object-position percentage rather than as flyCrop's layout offset, but it comes from the same
       __rovaPfPanyBias body, so the permalink auto-open and a tap can no longer land on different
       crops of one photo. Centred hides O/2 above; biased hides O/2 - bias. `photo && cover` only --
       a clip's crop window is --pf-vpos and is untouched here. */
    /* ...AND IT RAMPS, because the SOURCE is centred. The page the reader is looking at paints this
       photo with object-position:50% 50% (the .post .media / .pcell rules both spell it out), so
       baking the landing crop in at frame 0 would trade a wrong landing for a wrong LIFT-OFF -- the
       same defect, mirrored, which is what the first cut of the flyCrop half of this fix did too.
       Set centred here and hand the target to the flight arm below, which adds object-position to
       the transition it already runs. */
    var hzPos = '', hzPosTo = '';
    if (!isVideoHero && nw > 0 && nh > 0 && window.__rovaPfPanyBias) {
      var hzB = window.__rovaPfPanyBias(nw, nh, gw, gh, true);
      if (hzB) {
        var hzO = nh * Math.max(gw / nw, gh / nh) - gh;
        if (hzO > 1) {
          hzPos = 'object-position:50% 50%;';
          hzPosTo = '50% ' + (((hzO / 2 - hzB) / hzO) * 100).toFixed(2) + '%';
        }
      }
    }
    el.style.cssText = 'position:fixed;margin:0;object-fit:cover;' + hzPos + 'z-index:210;background:#000;pointer-events:none;'
      + 'left:' + gl + 'px;top:' + gt + 'px;width:' + gw + 'px;height:' + gh + 'px;'
      + 'opacity:1;transition:none;transform-origin:0 0;will-change:transform,opacity;'
      + '-webkit-backface-visibility:hidden;backface-visibility:hidden;'   // stable GPU layer -> clean teardown, no iOS end-flicker
      + (kb ? 'scale:' + kb.scale + ';translate:' + kb.translate + ';' : '')
      + 'transform:translate(' + tx + 'px,' + ty + 'px) scale(' + sc + ')';
    document.body.appendChild(el);   // reparenting a playing <video> does NOT interrupt it
    pfStillSync();                   // bare .pf-hero clone (heroZoom) -> html.pfv-fly
    liveKbSeed(el, kb);
    if (isVideoHero) { el._progMuteAt = Date.now(); el.muted = true; el.loop = true; el.playsInline = true; var _hp = el.play && el.play(); if (_hp && _hp.catch) { _hp.catch(function () {}); } }
    // KEN BURNS landing (round 164): pfeed singles drift too (tlPan), so the measured landing rect never
    // went STABLE -- the glide was skipped and the hero faded misaligned ("sometimes doesn't land right").
    // html.hz-hold pauses every pfeed media animation while a hero is in flight (rova.css); the rect
    // freezes, the glide lands exactly, and the pan simply starts after the cross-fade. Counted, so
    // overlapping heroes can't strip each other's hold.
    document.documentElement.classList.add('hz-hold');
    heroHolds++;
    var myGen = heroGen;   // this flight's identity: a reset (rapid open/close) bumps heroGen -> we self-cancel
    var done = false, landed = false;
    // FULL-RES HERO (late-sharpen fix): a grid cell's thumb upscaled to the viewer box is soft, and
    // the sharp display image only appeared when the hero cross-faded away -- a visible late sharpen
    // right after landing. Decode the full/display source in the background (it was warmed into the
    // HTTP cache on pointerdown) and swap the CLONE's src in place mid-flight: same element, same
    // geometry, so the sharpen rides inside the zoom motion instead of popping at the reveal. The
    // photo fade below also waits for this swap (600ms cap) so the handoff is like-for-like.
    var upDone = !(photo && fullSrc && fullSrc !== src);
    if (!upDone) {
      var up = new Image();
      up.src = fullSrc;
      var upFin = function () { upDone = true; if (!done && el.parentNode) { el.src = fullSrc; } };
      var upSkip = function () { upDone = true; };
      if (up.decode) { up.decode().then(upFin, upSkip); }
      else if (up.complete) { upFin(); }
      else { up.onload = upFin; up.onerror = upSkip; }
    }
    function fade() {
      if (done) return; done = true;
      document.removeEventListener('rova:pfeedready', onReady);
      document.removeEventListener('rova:pfresumed', onResumed);
      // A newer open/close cycle owns the viewer now -> do NOT force opacity/handoff on ITS media (the ghost).
      // __rovaHeroReset already dropped this flight's clone + zeroed the hold, so just stop here.
      if (myGen !== heroGen) { return; }
      var pfRev = document.querySelector('.pfeed.show');
      // SCRIM RELEASE (a) -- see .pfeed.pf-settling:not(.pf-hasmedia) in rova.css: the flown copy is
      // painted over its landing rect from this frame, so the settling backdrop may return to opaque
      // NOW, without waiting for the card's full-res load (the pfeedready handler's ld gate).
      if (pfRev) { try { pfRev.classList.add('pf-hasmedia'); } catch (e) {} }
      // VIDEO HERO handoff: before revealing, make the pfeed's OWN clip land on the EXACT frame the live hero is
      // on, and make sure it's PLAYING behind first -- so the hero fades out onto an identical, moving frame and
      // the switch is invisible (owner: "the user noticing is nearly impossible").
      if (isVideoHero && pfRev) {
        var pv = pfRev.querySelector('.post .media:not(.carousel) > video');
        if (pv) {
          try { var t = el.currentTime || 0, dur = pv.duration || 0;
            if (t > 0.05 && dur && Math.abs((pv.currentTime || 0) - t) > 0.06) { pv.currentTime = Math.min(t, dur - 0.1); }
          } catch (e) {}
          var pp = pv.play && pv.play(); if (pp && pp.catch) { pp.catch(function () {}); }
        }
      }
      // Reveal the destination media (hidden during the flight by html.hz-hold, rova.css) NOW, so it
      // cross-fades in (inline opacity beats the hide rule) exactly as the clone fades out. Both sit on the
      // same pixel-exact rect (the pan is still frozen at 0% by hz-hold), so it reads as one image settling.
      // Solo media only -- IMG and VIDEO both.
      if (pfRev) Array.prototype.forEach.call(
        pfRev.querySelectorAll('.post .media:not(.carousel) > img, .post .media:not(.carousel) > video'),
        function (im) { im.style.opacity = '1'; });
      el.style.opacity = '0';
      setTimeout(function () {
        if (myGen !== heroGen) { return; }   // stale cycle: reset already cleaned up; don't touch the new viewer
        // REMOVE THE CLONE FIRST (it's fully transparent by now): heroRelease's no-live-clone gate would see
        // THIS clone still attached and refuse to lift hz-hold -- then the wasLast branch below cleared the
        // media's inline opacity under the still-active hold = every photo open went BLACK (owner /p/1483).
        if (el.parentNode) { el.parentNode.removeChild(el); }
        var wasLast = heroHolds <= 1;
        heroRelease();                        // clamped + gated: never negative, only lifts hz-hold with no live clone
        if (wasLast) {
          var pf = document.querySelector('.pfeed.show');
          if (pf) {
            // POST-LANDING LURCH FIX (round 166, from the owner's screen-recording): the pan started at
            // element creation, advanced a little before hz-hold paused it, and RESUMED WITH VELOCITY on
            // release -- so after the photo landed and held, it lurched ~60px (measured on the red shorts).
            // Restart it FRESH from 0% right here, now that hz-hold is off, so it begins from REST and eases
            // in imperceptibly instead of resuming mid-pan. transition:none during the swap stops the .4s
            // transform transition from animating a jump too. IMG only (videos have no Ken Burns pan).
            /* ...EXCEPT for a bounded pass already under way (__rovaKbMidPass). The lurch this fixes is a
               tlPan symptom: an INFINITE ease-in-out resumes with whatever velocity it had. pfSettle is a
               single decelerating pass from rest, so resuming it mid-way is imperceptible, while restarting
               it is a visible replay -- the opposite trade. */
            var kbs = pf.querySelectorAll('.post .media:not(.carousel) > img');
            var kbArm = Array.prototype.filter.call(kbs, function (im) { return !(window.__rovaKbMidPass && window.__rovaKbMidPass(im)); });
            Array.prototype.forEach.call(kbs, function (im) { im.style.transition = 'none'; });
            kbArm.forEach(function (im) { im.style.animation = 'none'; });
            if (kbArm.length) { void kbArm[0].offsetWidth; }             // flush the reset
            kbArm.forEach(function (im) { im.style.animation = ''; });   // fresh tlPan from 0%, running
            requestAnimationFrame(function () { Array.prototype.forEach.call(kbs, function (im) { im.style.transition = ''; }); });
            // clear the reveal's inline opacity now that the hide rule is off (opacity '' = 1), so a REUSED
            // slide element hides again on its next hero open instead of staying forced-visible. IMG + VIDEO.
            Array.prototype.forEach.call(
              pf.querySelectorAll('.post .media:not(.carousel) > img, .post .media:not(.carousel) > video'),
              function (im) { im.style.opacity = ''; });
          }
        }
      }, 220);
    }
    // The main zoom is a 300ms transition to transform:none (set below), so the still is visually
    // LANDED at born + 300. A VIDEO handoff must not reveal the clip until then: the adopted grid
    // donor is already PLAYING, so rova:pfresumed fires almost immediately (its 'playing' listener),
    // which used to fade() mid-zoom -- the full clip appeared behind the still while it was only ~half
    // grown (the /p/1174 report). Gate every holdResume reveal on the landing so the clip is unveiled
    // only once the still has arrived (still landed AND clip painting the resumed frame).
    var HERO_ZOOM_MS = 560;   // gentler grow (owner: it grew to full size too quickly)
    function fadeWhenLanded() {
      if (done || myGen !== heroGen) return;
      var wait = born + HERO_ZOOM_MS - Date.now();
      if (wait > 0) { setTimeout(function () { if (!done) fade(); }, wait); }
      else { fade(); }
    }
    function onResumed() { fadeWhenLanded(); }              // clip is painting the resumed spot; reveal once landed
    // The pfeed's ACTUAL painted media rect, crop-aware: the drawn-image extent (object-fit math on the
    // TRANSFORMED element rect -- getBoundingClientRect includes the --pf-cover scale) intersected with the
    // media box (which crops the overflow). Returns null while the image hasn't painted (0x0) yet.
    function landingRect() {
      var pf = document.querySelector('.pfeed.show'); if (!pf) return null;
      // while the viewer's own open transition runs (rova.css scales .pfeed from .92) EVERY rect
      // inside it is shrunk; a main-thread stall can freeze two samples mid-transition and pass the
      // stability check, gliding the hero onto a 0.92x box. Wait for the overlay to settle first.
      try { var ptf = getComputedStyle(pf).transform; if (ptf && ptf !== 'none') return null; } catch (e) {}
      var cx = window.innerWidth / 2, cy = window.innerHeight / 2;
      var ms = pf.querySelectorAll('.post .media'), pel = null, box = null;
      for (var i = 0; i < ms.length; i++) {
        var b = ms[i].getBoundingClientRect();
        if (b.width > 4 && b.height > 4 && cx >= b.left && cx <= b.right && cy >= b.top && cy <= b.bottom) { pel = ms[i].querySelector('img, video'); box = b; break; }
      }
      if (!pel || !box) return null;
      var r = pel.getBoundingClientRect(); if (r.width < 4 || r.height < 4) return null;
      // PHOTO fit gate: a pfeed photo can LAYOUT at its plain contained size (intrinsic dims arrive
      // before the load event) while the cover-zoom fit (--pf-cover / pf-uncrop, stamped _pfFitDone
      // by the fit apply() on load) and the Ken Burns start keyframe riding on it land a beat later.
      // Two landing samples could both fall in that pre-fit window, so the hero glided onto the
      // contained rect and the photo then snapped to its zoomed opening state under the cross-fade
      // (the /p/1205 report). Refuse to measure until the fit is committed; the KB start state is
      // already frozen into the rect by html.hz-hold while we fly.
      if (pel.tagName === 'IMG' && !pel._pfFitDone) return null;
      // A pfeed VIDEO is width/height:100% + object-fit:contain (rova.css), so the drawn extent needs its
      // natural size -- but the viewer's clip usually hasn't loaded METADATA yet when we measure (desktop:
      // the whole open beats the network). videoWidth=0 used to fall through to the full element rect =
      // full screen, so the hero glided to FULL-BLEED (way off to the left) then cross-faded back onto the
      // letterboxed clip: the "swipes left and back" bug. We KNOW the tapped media's aspect (nw x nh, the
      // grid cell's video) -- same clip, so use it as the fallback.
      var pnw = pel.naturalWidth || pel.videoWidth || nw || 0, pnh = pel.naturalHeight || pel.videoHeight || nh || 0;
      var of = 'cover'; try { of = getComputedStyle(pel).objectFit || 'cover'; } catch (e) {}
      var img = r;
      if (pnw && pnh && of === 'contain') {
        var s = Math.min(r.width / pnw, r.height / pnh), w = pnw * s, h = pnh * s;
        img = { left: r.left + (r.width - w) / 2, top: r.top + (r.height - h) / 2, width: w, height: h };
      }
      var L = Math.max(img.left, box.left), T = Math.max(img.top, box.top);
      var R = Math.min(img.left + img.width, box.left + box.width), B = Math.min(img.top + img.height, box.top + box.height);
      if (R - L < 4 || B - T < 4) return null;
      return { left: L, top: T, width: R - L, height: B - T };
    }
    function onReady() {
      if (done || landed || myGen !== heroGen) return; landed = true;
      // (Reverted a #D attempt that reparented the hero INTO the viewer at z8 -- the pfeed-list's own black
      // background then covered it and the whole zoom went BLACK mid-open. The hero stays a body child (z210)
      // over everything; putting the media BEHIND the in-list controls needs those controls lifted into a
      // separate top overlay, a bigger change deferred so the open never blacks out.)
      // VIDEO handoff, resume already confirmed (donor adoption makes it near-instant): the clip is playing
      // at the right spot, so the hero's work is done -- fade NOW instead of riding out the landing loop
      // with a stale still frame over a moving video. Otherwise listen EARLY (before the landing loop), so
      // a resume that fires mid-landing isn't missed (it used to attach after, missing it = 900ms fallback).
      if (holdResume) {
        if (window.__rovaPfResumedAt && window.__rovaPfResumedAt >= born) { fadeWhenLanded(); return; }
        document.addEventListener('rova:pfresumed', onResumed);
      }
      // MEASURED landing (round 127): the first-guess box can't know everything the pfeed does on phones --
      // the 100dvh media box vs window.innerHeight, contain + scale-to-cover transforms -- so measure the REAL
      // painted rect once the viewer lands and glide the clone onto it (composited transform, ~140ms). Retries
      // briefly while the pfeed image is still 0x0 (first paint), so the cross-fade never reveals a blank.
      var tries = 0, prev = null;
      (function land() {
        if (done || myGen !== heroGen) return;
        var r = landingRect();
        // Wait until the paint is STABLE (two consecutive samples equal): the pfeed applies its scale-to-cover
        // transform a beat AFTER first paint (once the image's natural size is known), so a single measurement
        // lands the clone on the PRE-scale rect and the media then grows out from under it (measured: hero
        // centered inside a rect exactly 2x the top-offset taller). Two matching samples = the fit has settled.
        // SOLO PHOTO exception: landingRect already refuses to return until _pfFitDone, AND hz-hold freezes
        // its Ken Burns, so the first non-null sample IS the settled rect. Skip the 2-sample wait for it so
        // any correction retargets the STILL-RUNNING main zoom (one continuous motion) instead of firing a
        // second glide after the zoom has arrived and held (the /p/1206 two-stage landing). Carousels (their
        // slideshow keeps drifting) and videos still need the stability wait.
        var soloPhoto = photo && !holdResume;
        var stable = r && (soloPhoto || (prev
          && Math.abs(r.left - prev.left) <= 1 && Math.abs(r.top - prev.top) <= 1
          && Math.abs(r.width - prev.width) <= 1 && Math.abs(r.height - prev.height) <= 1));
        prev = r;
        if (!stable && tries++ < 18) { setTimeout(land, 40); return; }   // poll fast so the measured rect is caught EARLY (mid-zoom), not after it lands
        // glide ONLY onto a STABLE rect. If the samples never settled, the media is MOVING (the carousel
        // slideshow's Ken Burns pan runs from the open) -- gliding onto a drifting rect stretched the hero
        // distorted mid-air (the /p/930 report). The initial guess is aspect-correct now, so just fade in place.
        if (stable && r && (Math.abs(r.left - gl) > 1 || Math.abs(r.top - gt) > 1 || Math.abs(r.width - gw) > 1 || Math.abs(r.height - gh) > 1)) {
          // Correct the guess to the REAL painted rect by RESIZING the clone's box (left/top/width/height) --
          // its object-fit:cover simply re-crops as the box changes, with NO image distortion. The old fix used
          // a NON-UNIFORM transform:scale(sx,sy), which SKEWED/STRETCHED the photo whenever the guess aspect was
          // off -- and it always is for a tall photo, because the grid THUMB is aspect-CAPPED (a 9:16 frame's
          // thumb is ~4:5), so the guess started wider than the real frame and scale(sx,sy) squashed it wide
          // then snapped tall (the owner's "stretched and skewed then fades to position"). The main flight's
          // transform still eases to none; the box eases to the real rect alongside it, one continuous motion.
          el.style.transition = 'left 220ms cubic-bezier(.22,.61,.36,1),top 220ms cubic-bezier(.22,.61,.36,1),'
                              + 'width 220ms cubic-bezier(.22,.61,.36,1),height 220ms cubic-bezier(.22,.61,.36,1),'
                              + 'transform 220ms cubic-bezier(.22,.61,.36,1),opacity .2s ease';
          el.style.left = r.left + 'px'; el.style.top = r.top + 'px';
          el.style.width = r.width + 'px'; el.style.height = r.height + 'px';
          el.style.transform = 'none';
        }
        // NEVER-BLANK HANDOFF (round 168, owner report): keep the HERO -- which is already showing the
        // loaded card image / video poster -- up until the pfeed's OWN media is genuinely READY (photo
        // decoded, or video buffered enough to PLAY). On flaky mobile signal the pfeed's own download can
        // stall for a long time; we must NEVER swap the picture the user is looking at for a blank frame or
        // an endless spinner ("looks fine hero-zooming in, then disappears / loading circle forever when
        // service drops"). So we hold the hero and poll (fires the instant it's ready), only giving up after
        // a long cap that still comfortably covers a slow reconnect -- and by then the hero has shown the
        // picture the whole time, never a blank.
        var fw0 = Date.now(), MAXWAIT = 15000;
        (function fw() {
          if (done || myGen !== heroGen) return;
          var tgt = null, pfx = document.querySelector('.pfeed.show');
          if (pfx) {
            var cx = window.innerWidth / 2, cy = window.innerHeight / 2, ms = pfx.querySelectorAll('.post .media');   // solo OR carousel
            for (var i = 0; i < ms.length; i++) { var b = ms[i].getBoundingClientRect(); if (b.width > 4 && cx >= b.left && cx <= b.right && cy >= b.top && cy <= b.bottom) { tgt = ms[i]; break; } }
          }
          var ready;
          if (holdResume) {
            var v = tgt && tgt.querySelector('video');
            var resumed = window.__rovaPfResumedAt && window.__rovaPfResumedAt >= born;
            if (v) {
              // Reveal once the clip's current frame is DECODED (readyState>=2 / donor resumed) AND POSITIONED
              // (_pfFitDone -- fitPfeedMedia stamps it after --pf-cover), so the "opens in the wrong position,
              // then snaps" jump stays hidden behind the still. Keep the fit-wait SHORT (400ms cap): waiting too
              // long left the still sitting on top of the player + comments after landing (owner's report) --
              // fit is normally committed within a frame or two of the frame decoding, so 400ms is plenty.
              var playable = resumed || v.readyState >= 2;
              ready = playable && (v._pfFitDone || (Date.now() - fw0) > 400);
            } else {
              ready = !!resumed;   // no <video> element found yet -> lean on the resume signal alone
            }
          } else {
            var im = tgt && tgt.querySelector('img');           // solo photo, or a carousel's slide image
            // NO img to wait on (carousel/edge) -> never block (was hanging the 15s cap on carousel posts ->
            // clone stuck full-screen). When there IS one it must be DECODED, not merely complete -- the
            // legacy path hands off the same way heroExpand does, so it carries the same hazard. See pfDecoded.
            ready = !im || (im.complete && im.naturalWidth > 0 && pfDecoded(im));
          }
          if ((!upDone || !ready) && Date.now() - fw0 < MAXWAIT) { setTimeout(fw, 80); return; }
          if (holdResume) fadeWhenLanded(); else setTimeout(fade, 60);
        })();
      })();
    }
    void el.offsetWidth;                  // commit the START transform before the transition, or it snaps to full screen
    // ZOOM DURATION 460ms (was 300): the accurate landing rect (landingRect) isn't ready until the pfeed
    // fits its media (~400ms on a phone), and the OLD 300ms zoom LANDED on the initial guess and HELD ~130ms
    // before the measurement arrived and glided it to the real rect -- a visible overshoot-then-shrink at
    // the end (owner's screen-recording: clone hit 590x786, the photo was 559x746, then it shrank down). A
    // longer zoom keeps the clone STILL MOVING when the measurement lands, so the correction folds into one
    // continuous motion (retarget, not a second glide) with no hold and no visible bounce.
    el.style.transition = 'transform 560ms cubic-bezier(.22,.61,.36,1),opacity .2s ease'
      // THE CROP RAMPS WITH THE BOX (2026-09-14): centred at the source (what the page paints), the
      // viewer's --pf-pany bias at the landing. object-position is a paint property, not a composited
      // one, so it is added ONLY on a flight that actually has a bias -- every other heroZoom keeps
      // the two-property transition it has always had. See the hzPos/hzPosTo block above.
      + (hzPosTo ? ',object-position 560ms cubic-bezier(.22,.61,.36,1)' : '');
    if (hzPosTo) { el.style.objectPosition = hzPosTo; }
    el.style.transform = 'none';          // -> animate (composited) to the final box, no clip-path in flight
    document.addEventListener('rova:pfeedready', onReady);   // land + cross-fade the instant the viewer reaches the target
    setTimeout(function () { if (!landed) fade(); }, holdResume ? 1700 : 1100);   // hard fallback so the mask can never stick
  }
  /* ---- FLIP open (round 167): zoom the REAL pfeed media, no clone ---------------------------------------
     Record the tapped card's on-screen rect (First). The pfeed opens with its media HIDDEN (html.hz-flip).
     On rova:pfeedready the media is laid out at its natural full-screen box (Last); we INVERT it back onto
     the card rect (transform), reveal it, then PLAY the transform to identity -- so the real photo grows
     from the card to exactly where the pfeed paints it. There is no second element, so nothing can overshoot
     or mismatch: the end state is the media's own layout. */
  function heroFlip(first) {
    if (!first || first.width < 4 || first.height < 4) return;
    var F = { l: first.left, t: first.top, w: first.width, h: first.height };
    var done = false, fb = null;
    document.documentElement.classList.add('hz-flip');   // hide pfeed media until we've parked it on the card
    function unflip() { document.documentElement.classList.remove('hz-flip'); }
    function centeredMediaEl() {
      var pf = document.querySelector('.pfeed.show'); if (!pf) return null;
      var cx = window.innerWidth / 2, cy = window.innerHeight / 2, ms = pf.querySelectorAll('.post .media:not(.carousel)');
      for (var i = 0; i < ms.length; i++) { var b = ms[i].getBoundingClientRect(); if (b.width > 4 && cx >= b.left && cx <= b.right && cy >= b.top && cy <= b.bottom) return ms[i]; }
      return null;
    }
    var startT = Date.now();
    function attempt() {
      if (done) return;
      var mediaEl = centeredMediaEl();
      // VIDEO support (owner: "the thumbnail video should BE the video that plays in the pfeed, lifted off").
      // The pfeed ADOPTS the grid's already-buffered, already-playing clip (donor handoff), so flipping the
      // REAL video element grows that live, moving clip from the tapped tile to full screen -- no captured
      // still, no black frame, no cross-fade. Prefer a video; fall back to a photo.
      var media = mediaEl && (mediaEl.querySelector('video') || mediaEl.querySelector('img'));
      var isVid = !!(media && media.tagName === 'VIDEO');
      var box = mediaEl && mediaEl.getBoundingClientRect();
      // The .media CONTAINER is full-screen, but a video paints object-fit:contain (letterboxed) INSIDE it,
      // while a cover-zoom photo fills it. Invert the DRAWN extent so a contained clip lands covering the tile
      // (like the grid preview did) instead of shrinking to a letterboxed patch smaller than the tile.
      var last = box;
      if (isVid && box && media.videoWidth > 0) {
        var vof = 'contain'; try { vof = getComputedStyle(media).objectFit || 'contain'; } catch (e) {}
        if (vof === 'contain') {
          var vs = Math.min(box.width / media.videoWidth, box.height / media.videoHeight);
          var vdw = media.videoWidth * vs, vdh = media.videoHeight * vs;
          last = { left: box.left + (box.width - vdw) / 2, top: box.top + (box.height - vdh) / 2, width: vdw, height: vdh };
        }
      }
      // WAIT until the pfeed media is laid out AND ready. The .media box is full-screen regardless, so the
      // FLIP GEOMETRY is always exact -- but if we flip before the pixels arrive (cold cache, first visit) the
      // box grows EMPTY and the media pops in. So we hold (media hidden by hz-flip) until it's ready, then flip
      // the real thing. For video that's the adopted donor being playable (readyState>=2); for a photo it's
      // loaded + decoded. Capped so a broken / never-loading source can't hang the open.
      var ready = isVid
        ? !!(mediaEl && last && last.width > 4 && media.readyState >= 2 && media.videoWidth > 0)
        // ...and "decoded" in the comment above has to be ASSERTED, not assumed: `complete` is the byte
        // flag, and an <img> that has never painted has no raster behind it on WebKit. See pfDecoded.
        : !!(mediaEl && last && last.width > 4 && media && media.complete && media.naturalWidth > 0 && pfDecoded(media));
      if (!ready) {
        if (Date.now() - startT < 3200) { setTimeout(attempt, 32); return; }
        done = true; if (fb) clearTimeout(fb); unflip(); return;   // give up -> reveal normally, never stick
      }
      done = true; if (fb) clearTimeout(fb);
      // INVERT: shrink the media's full-screen box down onto the card, centered, with a UNIFORM cover scale.
      // Uniform (not sx/sy separately) so the photo NEVER distorts mid-flight when the card aspect differs
      // from the screen -- it just grows, exactly like the old clone's object-fit:cover did. max() = cover the
      // card (the small overflow past the card sits under the fading-in viewer bg).
      var s = Math.max(F.w / last.width, F.h / last.height);
      var dx = (F.l + F.w / 2) - (last.left + last.width / 2);
      var dy = (F.t + F.h / 2) - (last.top + last.height / 2);
      mediaEl.style.transformOrigin = 'center center';
      mediaEl.style.transition = 'none';
      mediaEl.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(' + s + ')';
      mediaEl.style.willChange = 'transform';
      mediaEl.style.opacity = '1';                       // reveal now that it sits on the card (beats the hz-flip hide)
      // PLAY on the next frame: animate the transform to identity -> the media grows to its own layout box.
      requestAnimationFrame(function () { requestAnimationFrame(function () {
        mediaEl.style.transition = 'transform 440ms cubic-bezier(.22,.61,.36,1)';
        mediaEl.style.transform = 'none';
        var fin2 = false, safeT;
        function end() {
          if (fin2) return; fin2 = true;
          mediaEl.removeEventListener('transitionend', endT); clearTimeout(safeT);
          mediaEl.style.transition = ''; mediaEl.style.transform = ''; mediaEl.style.transformOrigin = ''; mediaEl.style.willChange = ''; mediaEl.style.opacity = '';
          unflip();
          // KB fresh from rest -- but never on top of a bounded pass in flight, which this would replay
          if (media && media.tagName === 'IMG' && !(window.__rovaKbMidPass && window.__rovaKbMidPass(media))) {
            media.style.animation = 'none'; void media.offsetWidth; media.style.animation = '';
          }
        }
        var endT = function (e) { if (e.target === mediaEl && e.propertyName === 'transform') end(); };
        mediaEl.addEventListener('transitionend', endT);
        safeT = setTimeout(end, 560);
      }); });
    }
    setTimeout(attempt, 16);   // poll for pfeed layout + decoded photo, then flip
    fb = setTimeout(function () { if (!done) { done = true; unflip(); } }, 3400);   // absolute never-stick backstop
  }

  // shared with the pfeed IIFE below: the permalink auto-open (/p/123) zooms the on-page photo
  // into the viewer with the SAME hero a tap on it gets, instead of the overlay just fading in.
  window.__rovaHeroZoom = heroZoom;

  // REVERSE HERO: dismissing the immersive viewer collapses the current slide back DOWN into the
  // grid tile it flew out of (or shrinks to center when there is no tile), the mirror of heroZoom.
  // The pfeed IIFE's close() calls this with the .pfeed element and the origin tile rect (or null);
  // it snapshots the centered slide into a clone, covers the fading viewer with it, and animates the
  // clone (composited transform ONLY, no clip-path -- same lesson as the open) from the painted rect
  // to the tile, fading as it lands. Returns true if a collapse was started (caller still closes).
  /* Intrinsic size of a media element, ATTRIBUTE-LAST. A pfeed <video> is object-fit:contain at
     100% x 100%, so without its real dimensions the "painted rect" collapses to the whole element
     box = full-bleed, and the collapse flies to the wrong shape. videoWidth is 0 on any clip that
     has not loaded -- which since 2026-08-08 is every server-emitted feed/pfeed video until app.js
     promotes it (views/_post.php ships preload="none" beside a poster + stamped width/height), and
     is permanently true on iOS Safari for a clip that never played. The stamped attributes are the
     same numbers, so fall back to them rather than to the element box. Mirrors the fallback the
     hero-open path already had via its (nw, nh) grid-cell hint. */
  function mediaIntrinsic(el) {
    return {
      w: el.naturalWidth || el.videoWidth || parseInt(el.getAttribute('width'), 10) || 0,
      h: el.naturalHeight || el.videoHeight || parseInt(el.getAttribute('height'), 10) || 0
    };
  }
  function paintedRectOf(pel, box) {
    var r = pel.getBoundingClientRect(); if (r.width < 4 || r.height < 4) return null;
    var _pi = mediaIntrinsic(pel);
    var pnw = _pi.w, pnh = _pi.h;
    var of = 'cover'; try { of = getComputedStyle(pel).objectFit || 'cover'; } catch (e) {}
    var img = { left: r.left, top: r.top, width: r.width, height: r.height };
    if (pnw && pnh && of === 'contain') {
      var s = Math.min(r.width / pnw, r.height / pnh), w = pnw * s, h = pnh * s;
      img = { left: r.left + (r.width - w) / 2, top: r.top + (r.height - h) / 2, width: w, height: h };
    }
    var bb = box.getBoundingClientRect();
    var L = Math.max(img.left, bb.left), T = Math.max(img.top, bb.top);
    var R = Math.min(img.left + img.width, bb.left + bb.width), B = Math.min(img.top + img.height, bb.top + bb.height);
    if (R - L < 4 || B - T < 4) return null;
    // `full`: the WHOLE drawn picture before the clip to the box (the viewer's photo drift reads it)
    return { left: L, top: T, width: R - L, height: B - T, full: img };
  }
  /* WHERE THE DESTINATION ACTUALLY DRAWS ITS PHOTO (2026-10-01) -- the dismiss lands on THIS, not on a
     centred cover crop of the destination's box (see flyCrop's kbTo note for Rob's /p/54692 report).
     `dest` is the landing element close() measured: a timeline card's .media (a carousel's slide on
     screen), or a grid .pcell. Returns the WHOLE picture rect -- before the clip to the window -- from
     the photo element's transformed box (getBoundingClientRect carries the Ken Burns scale/translate;
     the drift is a uniform scale + translate, so object-fit solves inside it exactly as it does
     untransformed) and its own object-fit/object-position. null whenever the destination is not a
     still photo we can read: a clip in the window, an NSFW veil, no intrinsic size -- and the flight
     then lands exactly as it always did. */
  function destPictureOf(dest) {
    if (!dest || !dest.querySelector) return null;
    try {
      if (dest.classList.contains('nsfw-gate')) return null;
      var host = dest.classList.contains('carousel') ? centeredSlideOf(dest) : dest;
      if (!host || host.querySelector('video')) return null;
      // the photo itself, never an overlay riding on it (the grid cascade's .gp-casc-ovi, a frame cover)
      var im = host.querySelector('img:not(.pcell-video):not(.nsfw-preview):not(.avatar):not(.pf-frame-cover):not(.gp-casc-ovi)');
      if (!im || !(im.currentSrc || im.getAttribute('src'))) return null;
      var mi = mediaIntrinsic(im);
      var r = im.getBoundingClientRect();
      if (!(mi.w > 0 && mi.h > 0) || r.width < 4 || r.height < 4) return null;
      var cs = getComputedStyle(im), of = cs.objectFit || 'fill';
      var s = Math.max(r.width / mi.w, r.height / mi.h);
      if (of === 'contain') { s = Math.min(r.width / mi.w, r.height / mi.h); }
      else if (of === 'scale-down') { s = Math.min(1, Math.min(r.width / mi.w, r.height / mi.h)); }
      else if (of === 'fill') { return { left: r.left, top: r.top, width: r.width, height: r.height, nw: r.width, nh: r.height }; }
      else if (of === 'none') { s = 1; }
      var dw = mi.w * s, dh = mi.h * s;
      var op = String(cs.objectPosition || '50% 50%').split(/\s+/);
      var at = function (v, free) {   // a computed object-position component: % of the free space, or px
        v = v || '50%';
        return v.indexOf('%') > -1 ? free * (parseFloat(v) || 0) / 100 : (parseFloat(v) || 0);
      };
      return { left: r.left + at(op[0], r.width - dw), top: r.top + at(op[1] || op[0], r.height - dh), width: dw, height: dh, nw: mi.w, nh: mi.h };
    } catch (e) { return null; }
  }
  // The slide the reader is actually LOOKING AT: the .media whose box sits under the viewport centre,
  // then (centeredSlideOf, NOT querySelector('.cslide') -- the old first-slide grab meant closing a
  // slideshow from slide 2/3 snapshotted + collapsed SLIDE 1's image, wrong picture flew home) the
  // slide under the centre within it. ONE implementation, shared by the collapse and the tile park
  // below: if those two ever answered differently, the tile would be parked on a different slide than
  // the one that flew home, which is precisely the media/stamp disagreement the park exists to prevent.
  function pfViewedSlide(pf) {
    if (!pf) return null;
    var cx = window.innerWidth / 2, cy = window.innerHeight / 2;
    var ms = pf.querySelectorAll('.post .media');
    for (var i = 0; i < ms.length; i++) {
      var b = ms[i].getBoundingClientRect();
      if (b.width > 4 && b.height > 4 && cx >= b.left && cx <= b.right && cy >= b.top && cy <= b.bottom) {
        var slide = centeredSlideOf(ms[i]);
        return { el: slide.querySelector('img, video'), box: slide };
      }
    }
    return null;
  }

  /* ---- GRID TILE PARK: "reopen on the slide you left" ---------------------------------------------
     ONE WRITER, ONE READER, ONE RULE: a tile may CLAIM to be parked on slide N (data-gr-slide) only
     while it is genuinely SHOWING slide N's media.

     The VIDEO dismiss satisfies that implicitly -- it REPARENTS slide N's live <video> into the cell,
     so the tile literally holds slide N. A PHOTO dismiss reparents nothing (the tile just reverts to
     its cover), so nothing ever recorded the slide and every reopen fell back to the cell's static
     #m<n> href: open post 15805 (10 photos), swipe to 3, minimize, reopen -> slide 0.

     Matched to the app, which is the reference here: ProfileScreen.js:2115 and FeedScreen.js:1835 both
     render `item.media[vSlides[item.id] ?? 0]`, i.e. the app's tile shows the DISMISSED SLIDE's
     thumbnail for photos exactly as for videos. So we do the same -- repoint the cell's cover <img> at
     slide N's image AND stamp N, from ONE derivation at ONE moment. Stamping N while the tile still
     showed the cover would be the other option, and it is the shape of the bug fixed on 2026-08-09:
     the tile claimed slide 0 while holding media N, and the opener flew media N into slide 0.

     PROOF THE FLIGHT CANNOT SUBSTITUTE MEDIA. The opener flies whatever the CELL holds
     (`heroExpand(rect, zImg.currentSrc || zImg.src)` for a photo, the live `zVid` for a clip) -- it
     never rebuilds a source from the index. So the stamp is only safe while the flown element IS the
     element the stamp was taken from. gridStampRead() below re-checks exactly that, at the point of
     use, against the very element the hero is flying: same NODE (a rebuild/release/re-render makes a
     new one) and, for an <img>, same src (a node can be re-pointed in place). Fail either test and the
     claim is void -- attribute dropped, cover restored, land on the href. There is no path that
     honours an index without having just proved the media under it. */
  function gridUnpark(tile, restore) {
    if (!tile) return;
    try { tile.removeAttribute('data-gr-slide'); } catch (e) {}
    var pk = tile._grPark;
    tile._grHold = null; tile._grPark = null;
    // Put the real cover back, but ONLY if our parked src is still literally the one on the element:
    // if something else re-pointed it (a /media-ready poster swap, the desktop fan-drag) that newer
    // picture is the truth and stomping it with our stale original would be its own substitution.
    if (restore && pk && pk.img && pk.img.isConnected && pk.orig
        && (pk.img.getAttribute('src') || '') === pk.src) {
      try { pk.img.setAttribute('src', pk.orig); } catch (e) {}
    }
  }
  function gridPark(tile, idx, src) {
    if (!tile || !(idx >= 0) || !src) return false;
    var im = tile.querySelector('img'); if (!im) return false;
    if (im.getAttribute('srcset')) return false;   // can't prove WHICH candidate paints -> never claim a slide we can't prove
    // EVERY bail-out is above this line: past here the cell is mutated, so a late refusal would leave
    // it holding a still with no claim on it.
    // A cell can still be holding a <video> -- its own cover clip, or one a video dismiss parked there.
    // It would keep painting OVER the still we are about to place, so the tile would show a clip while
    // claiming a photo slide. DROP it (the same pause/detach the grid's own release() does), which
    // reveals the cover <img> underneath -- the element we then re-point. Recoverable both ways: the
    // cover clip rebuilds from img.pcell-video[data-video-src] the moment ensureVideo is allowed to run
    // again, and gridUnpark puts the cover src back. Whether the clip is present here is pure TIMING
    // (the profile grid frees every preview on open and rebuilds ~380ms after close; the landing grid
    // was measured still holding one at dismiss), so declining instead would make "does a photo
    // dismissal remember the slide" depend on which grid you were on -- deterministic beats tidy.
    Array.prototype.forEach.call(tile.querySelectorAll('video'), function (v) {
      if (v._hls) { try { v._hls.destroy(); } catch (e) {} v._hls = null; v._hlsWired = 0; }
      try { v.pause(); v.removeAttribute('src'); v.load(); } catch (e) {}
      if (v.parentNode) { v.parentNode.removeChild(v); }
    });
    var orig = im.getAttribute('src') || '';
    if (im._grOrig == null) { im._grOrig = orig; }        // first park remembers the REAL cover, not a previous park
    im.setAttribute('src', src);
    tile._grPark = { img: im, src: src, orig: im._grOrig };
    tile._grHold = { el: im, src: src };
    tile.setAttribute('data-gr-slide', String(idx));
    return true;
  }
  // PHOTO dismiss -> park the tile on the slide the reader left. Called from the pfeed close for EVERY
  // dismissal, independent of reduced-motion and of whether the tile is on screen, because remembering
  // the slide is behaviour, not animation. Returns false for a video slide (the reparent path parks
  // those) and for a single-media post (no .cslide -> nothing to remember, so no stamp leaks onto it).
  window.__rovaGridStampPhoto = function (pf, tile) {
    if (!pf || !tile) return false;
    var vs = pfViewedSlide(pf);
    if (!vs || !vs.el || vs.el.tagName !== 'IMG') return false;
    var mb = vs.box;
    if (!mb || !mb.classList || !mb.classList.contains('cslide') || !mb.parentNode) return false;
    var idx = Array.prototype.indexOf.call(mb.parentNode.querySelectorAll('.cslide'), mb);
    // The viewer's own painted src -- already decoded and cached, so the tile repaints with no network
    // and the next open's hero flies the exact file the viewer will paint. NEVER hand-build a _thumb
    // variant from it: a PNG's thumb is a .jpg, so a built name 404s (see the PNG-variant note).
    return gridPark(tile, idx, vs.el.currentSrc || vs.el.getAttribute('src') || '');
  };
  // VIDEO dismiss -> the clip itself is the proof. Identity only, no src test: a <video> is never
  // re-pointed in place (ensureVideo always builds a NEW element), and a reparented pfeed clip may be
  // running off a blob/MSE source whose currentSrc is not a stable comparison key.
  window.__rovaGridParkVideo = function (tile, idx, v) {
    if (!tile || !(idx >= 0) || !v) return false;
    gridUnpark(tile, true);          // any photo park underneath has just stopped being the truth
    tile._grHold = { el: v, src: null };
    tile.setAttribute('data-gr-slide', String(idx));
    return true;
  };
  // THE AGREEMENT TEST, run by every opener against the element it is about to fly. -1 = no usable
  // claim, use the cell's static href.
  window.__rovaGridStampRead = function (tile, flightEl) {
    if (!tile) return -1;
    var raw = parseInt(tile.getAttribute('data-gr-slide') || '', 10);
    // >= 0, NOT > 0: slide 0 has to be representable. On the Photos/Videos tabs the cell's static href
    // is #m<first media matching the active tab> -- e.g. 15786 is #m1 on ?tab=videos -- so "no stamp"
    // does NOT mean "slide 0" there. A tile parked on slide 0 must be able to say so.
    if (!isFinite(raw) || raw < 0) { gridUnpark(tile, false); return -1; }
    var h = tile._grHold;
    if (!h || !flightEl || h.el !== flightEl || !flightEl.isConnected
        || (h.src !== null && (flightEl.getAttribute('src') || '') !== h.src)) {
      gridUnpark(tile, true); return -1;
    }
    return raw;
  };
  window.__rovaGridUnpark = gridUnpark;

  // originRadius: the destination's rounding as __rovaDestRadius returns it -- a px number, or a
  // '%' string for a circular destination (the profile avatar). Owner 2026-08-29 screenshot ("trying
  // to crop it back to a circle but not quite"): this collapse used to land every clone SQUARE.
  /* `originLive` (2026-09-14): the destination is an element that is ALREADY on screen, already
     decoded and does not move or rebuild -- the profile avatar. It changes ONE thing, the hand-off
     schedule; see the fade below for why that is the whole dismiss half of the owner's report. */
  /* `originEl` (2026-10-01): the element originRect was measured off (the card's .media / the grid
     .pcell), so the landing can be solved against the picture it DRAWS -- destPictureOf / kbTo. */
  /* onLand (2026-10-09, the media ring): called ONCE when an originLive flight has landed (its own
     animationend, or the 1200ms backstop) -- the ring holds its re-order until then. Not called when
     this returns false; the caller handles that itself. */
  window.__rovaHeroCollapse = function (pf, originRect, originRadius, originLive, originEl, onLand) {
    if (!pf) return false;
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return false;   // honour the setting
    // the currently-viewed slide -- shared helper, so the collapse and the tile park can never drift
    var _vs = pfViewedSlide(pf), pel = _vs && _vs.el, mbox = _vs && _vs.box;
    if (!pel || !mbox) return false;
    // the clone below is the bare bitmap: a card blurred only by its CSS veil (.nsfw-gate that is not a
    // server-blurred .nsfw-locked preview) must not fly home unblurred (2026-10-02, see heroExpand)
    try { if (pel.closest && pel.closest('.nsfw-gate:not(.nsfw-locked), .msg-gate')) return false; } catch (e) {}
    var P = paintedRectOf(pel, mbox); if (!P) return false;
    /* THE CROP THE READER IS LOOKING AT, READ OFF THE LIVE ELEMENT -- never re-derived (2026-09-14).
       paintedRectOf answers with the cover WINDOW, and a covering pfeed photo is drawn top-biased
       INSIDE that window by --pf-pany, so a clone started centred jerks the picture by the whole
       bias on the dismiss's very first frame (measured on the owner's recording: the face leaves
       the top of the screen between f200 and f201; the harness reads 91-100px). The computed value
       is the truthful source here because it also carries any pan the reader has made since the
       open (__rovaPhotoPan writes the same property), which no re-computation could know.
       Custom properties inherit, so reading it off the media element itself is the same value the
       unit carries. Zero (the normal case) leaves every other dismissal byte-identical. */
    var oyC = 0;
    try { oyC = parseFloat(getComputedStyle(pel).getPropertyValue('--pf-pany')) || 0; } catch (e) {}
    if (pel.tagName !== 'IMG') { oyC = 0; }   // video's crop window is --pf-vpos, a different mechanism
    /* ...AND THE DRIFT IT IS ON (2026-09-30). A photo mid-Ken-Burns (the viewer's drift, or a slideshow's
       kb-run) is drawn up to 15% bigger and off centre, via the individual scale/translate properties --
       which getBoundingClientRect includes but the clip to the box (P) and a centred cover crop do not.
       Started from P alone the flight jumped the picture back to the un-drifted crop on frame 1. close()
       has frozen the drift (kbFreeze), so hand flyCrop the WHOLE drawn picture and it starts from exactly
       that frame and unwinds the drift over the flight. Only when a drift is actually on: every other
       dismissal stays byte-identical. */
    var kbFull = null;
    if (pel.tagName === 'IMG' && P.full) {
      try {
        var _kcs = getComputedStyle(pel), _ksc = _kcs.scale, _ktr = _kcs.translate;
        if ((_ksc && _ksc !== 'none' && Math.abs(parseFloat(_ksc) - 1) > 1e-4) || (_ktr && _ktr !== 'none' && /[1-9]/.test(_ktr))) { kbFull = P.full; }
      } catch (e) { kbFull = null; }
    }
    /* ...AND THE ONE THE DESTINATION IS ON (2026-10-01, Rob /p/54692 desktop Safari: "it lands wrong but it
       fixes it"). The mirror of kbFull: the card/tile underneath paints its photo mid-drift (the page's
       tlPan/gridPan, held still for the whole flight by html.pfv-on then html.pfv-fly -- rova.css), so the
       flight must land on THAT picture, not on a centred cover crop of the box. Measured before: box exact,
       picture -72 x -96px and +21/+62px off on that post; the 380ms hand-off fade then dissolved it into the
       card's frame, which is the "fix" he saw. The avatar (originLive) keeps its own cross-fade landing. */
    var kbTo = null;
    if (originEl && !originLive && originRect && originRect.width > 4 && originRect.height > 4) { kbTo = destPictureOf(originEl); }
    /* Carried over as the destination's DRIFT, not as its bitmap: the card/tile may hold a different FILE of
       this photo (a _thumb, a GIF still) whose aspect is a hair off the one the flight draws (iw/ih), and
       sizing the copy to that file's rect would land it on the wrong shape. So: the factor the destination's
       picture is drawn at over its own plain cover of the window, and its centre, re-applied to the flight's
       own cover of the same window. Same aspect (the normal case) -> the identical rect. */
    if (kbTo) {
      var _fm = mediaIntrinsic(pel);
      var _dcw = kbTo.nw * Math.max(originRect.width / kbTo.nw, originRect.height / kbTo.nh);
      var _fcs = (_fm.w > 0 && _fm.h > 0) ? Math.max(originRect.width / _fm.w, originRect.height / _fm.h) : 0;
      if (_dcw > 0 && _fcs > 0) {
        var _rel = kbTo.width / _dcw, _kcx = kbTo.left + kbTo.width / 2, _kcy = kbTo.top + kbTo.height / 2;
        var _kw = _fm.w * _fcs * _rel, _kh = _fm.h * _fcs * _rel;
        kbTo = { left: _kcx - _kw / 2, top: _kcy - _kh / 2, width: _kw, height: _kh };
      } else { kbTo = null; }
    }
    var src = pel.tagName === 'VIDEO' ? (videoFrameSrc(pel) || pel.getAttribute('poster') || '')
                                      : (pel.currentSrc || pel.src || '');
    if (!src) return false;
    var el = document.createElement('img');
    el.src = src; el.alt = ''; el.decoding = 'async'; el.className = 'pf-hero pf-hero-collapse';
    // END box = cover the origin tile (shrink + translate into it), else shrink toward viewport centre.
    var vw = window.innerWidth, vh = window.innerHeight, sc, tx, ty, fadeTo, toTile = null;
    if (originRect && originRect.width > 4 && originRect.height > 4) {
      toTile = originRect;                             // shrink the BOX down to the exact (square) grid tile
      // Stay OPAQUE (the pfeed close seeks the tile's preview to the same frame via __rovaGridSeek, so the tile
      // behind is already on the matching frame when the clone is removed -- no old-frame peek).
      fadeTo = '1';
    } else {
      sc = 0.4;                                        // no tile: shrink toward centre and fade out
      tx = (vw / 2) - (P.left + P.width * sc / 2);
      ty = (vh / 2) - (P.top + P.height * sc / 2);
      fadeTo = '0';
    }
    // Transparent backing (not #000): this clone is a fresh <img> with decoding:async, so even a cached
    // src can take a frame to paint -- an opaque black backing showed as a "small black flash" the instant
    // the dismiss began. Transparent lets the still-shown pfeed media (the identical image) show through
    // for that one frame, so the collapse starts seamlessly.
    /* object-position, because THIS element is genuinely object-fit:cover -- the one place on this
       path where the crop window really is moved by a percentage rather than by a translate (the
       pfeed's own <img> is contain+scale, which is why IT needs --pf-pany; see the rova.css note).
       Expressed from the same bias so the two agree: centred hides O/2 above, and the biased crop
       hides O/2 - oy, i.e. 15% when oy is the 0.35 seed. Only the tile-less branch below actually
       paints this (flyCrop relays out the media for the tile branch and takes `oy` instead), but a
       clone that is briefly in the document must never be able to paint the wrong crop. */
    var _mic = mediaIntrinsic(pel), _oPos = '';
    if (oyC && _mic.w > 0 && _mic.h > 0) {
      var _oO = _mic.h * Math.max(P.width / _mic.w, P.height / _mic.h) - P.height;
      if (_oO > 1) { _oPos = 'object-position:50% ' + (((_oO / 2 - oyC) / _oO) * 100).toFixed(2) + '%;'; }
    }
    el.style.cssText = 'position:fixed;margin:0;object-fit:cover;' + _oPos + 'z-index:220;background:transparent;pointer-events:none;'
      + 'left:' + P.left + 'px;top:' + P.top + 'px;width:' + P.width + 'px;height:' + P.height + 'px;'
      + 'opacity:1;transition:none;transform-origin:0 0;will-change:left,top,width,height,transform,opacity;transform:none';
    /* NO TILE + MID-DRIFT: lay the clone out as the WHOLE drifted picture (aspect-exact, so `fill` is the
       picture) clipped back to the on-screen window P -- frame 1 is the frame the reader was looking at.
       The clip rides the transform, so the shrink below moves the SAME window to the same centred end box
       the plain branch uses (tx/ty re-solved for the bigger box). */
    var kbNT = null;
    if (kbFull && !toTile && kbFull.width > 4 && kbFull.height > 4) {
      var _kd = kbFull;
      el.style.left = _kd.left + 'px'; el.style.top = _kd.top + 'px';
      el.style.width = _kd.width + 'px'; el.style.height = _kd.height + 'px';
      el.style.objectFit = 'fill'; el.style.objectPosition = '50% 50%';
      var _ki = { t: P.top - _kd.top, l: P.left - _kd.left, r: (_kd.left + _kd.width) - (P.left + P.width), b: (_kd.top + _kd.height) - (P.top + P.height) };
      el.style.clipPath = 'inset(' + Math.max(0, _ki.t).toFixed(2) + 'px ' + Math.max(0, _ki.r).toFixed(2) + 'px ' + Math.max(0, _ki.b).toFixed(2) + 'px ' + Math.max(0, _ki.l).toFixed(2) + 'px)';
      kbNT = { tx: (vw / 2) - P.width * sc / 2 - _kd.left - sc * _ki.l, ty: (vh / 2) - P.height * sc / 2 - _kd.top - sc * _ki.t };
    }
    document.body.appendChild(el);
    pfStillSync();                                    // bare .pf-hero-collapse clone -> html.pfv-fly
    void el.offsetWidth;                              // commit the START box before the transition
    var isVid = pel.tagName === 'VIDEO';
    // flight-sync telemetry: the STILL-CLONE close (clip wasn't decode-ready) -- record the source
    // clip anyway; the grid play() reveal marks when/where the tile actually resumed
    if (isVid) { vfStart('close', 0, pel, pel.currentSrc || pel.src); }
    function runCollapse() {
      // VIDEO close: the underlying pfeed <video> is being paused + torn down behind this clone, and a
      // paused/opacity-faded <video> composites BLACK on many GPUs -- which showed through the clone's
      // transparent backing as a "black flash" the instant the dismiss began. Now that the still clone is
      // DECODED and covering it, hide the live video so the box-fade only ever animates the still, never a
      // going-black <video>. (Photos keep the transparent-shows-identical-image behaviour, no hide needed.)
      /* ...ONLY WHILE THE CLIP IS STILL IN THE SLIDE. This runs after el.decode() resolves, which is
         usually a few ms but is NOT bounded -- and the close now hands this same element to the grid tile
         at 356ms (the fallback land). A late decode writing opacity:0 would land on an element that has
         already gone home, blanking the tile over its poster. Test the containment, not the clock. */
      if (isVid) { try { if (mbox.contains(pel)) { pel.style.opacity = '0'; } mbox.style.visibility = 'hidden'; } catch (e) {} }   // hide the WHOLE slide: its poster backdrop otherwise shows as a second thumbnail behind the collapse
      if (toTile) {
        // COMPOSITED crop-flight to the tile: the same gradual portrait->square cover re-crop the box-resize
        // gave (owner: "cropping it slowly all the way"), now transforms-only via flyCrop -- no per-frame
        // main-thread layout. Park at the big painted rect so the raster stays crisp shrinking down.
        el.className = '';   // the WRAPPER carries pf-hero-collapse (never two matching elements)
        var wrapC = flyCrop(el, P, toTile, {
          ms: 340, cls: 'pf-hero pf-hero-collapse', z: 220, bg: 'transparent', park: 'from',
          // land with the DESTINATION's true rounding (owner 2026-08-29 screenshot: "trying to crop
          // it back to a circle but not quite"): '50%' morphs the copy into a circle over the profile
          // avatar as it shrinks; a px tile radius lands exactly as the tile draws it. This used to
          // be omitted entirely, so every landing painted square corners over the rounded tile.
          radiusTo: originRadius || 0,
          iw: _mic.w, ih: _mic.h,   // attribute-last: a never-promoted clip reports videoWidth 0
          // ...and the crop morphs from the one the reader is looking at (oyC) to the CENTRED one
          // every landing destination paints -- the grid tile and the feed card both spell out
          // object-position:50% 50%, and the avatar's square variant is its own centred framing.
          oyFrom: oyC, oyTo: 0,
          kbFull: kbFull,   // null unless the photo is mid-drift (see the kbFull note above)
          kbTo: kbTo,       // the destination's own drawn picture -- null = the centred cover crop, as before
          // ...and, onto a destination that is already painted, hand over INSIDE the tween (below)
          fadeFrom: originLive ? 0.62 : 0
        });
        /* ---- THE HAND-OFF HAS TO BE OVER BY THE TIME THE BOX LANDS  (2026-09-14) -----------------
           FADE the landed clone out instead of snapping it away: on a GRID landing the tile's rebuilt
           preview may still be a beat from revealing on the handoff frame (play() holds it hidden
           through the seek), so a hard removal flashed the poster/black beneath. That is why the fade
           exists and it is not going anywhere.

           WHEN it ran was the bug. 380ms into a 340ms tween, fading over 150: the clone sat FULLY
           OPAQUE for 40ms after the geometry had stopped and only finished resolving 190ms after it.
           On a grid tile that is invisible -- clone and tile are the same file, same crop, so there
           is nothing to resolve. On the PROFILE AVATAR they are two different framings of one
           picture and it is the whole dismiss complaint: the clone carries the pfeed's file
           (@L0v3ly: `_orig.jpg`, 412x1013) cover-cropped into a circle, which keeps the MIDSECTION,
           while the avatar paints the square variant Upload::avatarFitSquare() built by LETTERBOXING
           that same original on a sampled edge tone (aspect distance 2.46 >= AV_FIT_HARD). Measured
           on the owner's recording: the wrong picture is parked in the avatar from f216 to f220 and
           only then dissolves -- "the dismiss ... lands incorrectly before self healing".

           NO GEOMETRY CAN MAKE TWO DIFFERENT CROPS OF ONE FILE EQUAL, so the landing frame can only
           be right if the clone is already GONE by it -- and for a destination that is on screen,
           decoded and unmoving (`originLive`, the avatar) that is free: the pixels underneath are
           the settled ones from the first frame. So the fade ENDS where the tween ends, and the
           dissolve happens over the last 100ms of the flight, while the box is still closing the
           final ~2% of its travel onto the destination. That is not the correction hidden behind an
           animation: it is the morph between two framings finishing BEFORE the arrival instead of
           after it, which is the only thing "lands once" can mean when the two ends differ.
           A tile landing keeps the old +380/150 schedule exactly -- it needs the cover.

           AND ON THE AVATAR THE RAMP IS A KEYFRAME, NOT A TIMER (`fadeFrom` above). Armed as a
           setTimeout at ms-100 it measured 26ms LATE in Chromium -- the clone was still 8% opaque
           after the box had stopped, i.e. the defect again, smaller. Baked into the flight's own
           keyframes it reaches 0 at exactly 100% of the tween, so the assertion "the clone paints
           nothing on the landing frame" holds by construction rather than by luck. 0.72 puts the
           dissolve in the last ~95ms, by which point bezSwift has the box within ~5% of the avatar,
           so the two framings are near-co-located while they cross. */
        if (originLive) {
          /* AND THE REMOVAL RIDES THE ANIMATION TOO, for the same reason the ramp does. A bare
             setTimeout(360) fired while the tween was still at 93% on a throttled main thread
             (measured), which would have snapped away a clone that was still 0.245 opaque and
             still 2px off the avatar -- swapping one visible discontinuity for another. The
             timer stays, as a BACKSTOP only: an animation that never ends (a backgrounded tab
             that never fires animationend) must not strand a fixed-position clone over the page. */
          var _cDone = false;
          var _cKill = function () {
            if (_cDone) { return; } _cDone = true; disposeFlight(wrapC);
            if (typeof onLand === 'function') { try { onLand(); } catch (e) {} }
          };
          try { wrapC.addEventListener('animationend', _cKill, { once: true }); } catch (e) {}
          setTimeout(_cKill, 1200);
        } else {
          /* THE +40ms HOLD AND THE FADE COUNT FROM THE LANDING, NOT FROM THE CALL (2026-10-01). This was
             setTimeout(380) from here, i.e. "the tween is 340, plus 40" -- which is only true if the
             animation STARTS on the frame this task ends. It does not on a heavy close: a CSS animation
             starts pending and takes its start time on the first frame after close()'s teardown (the same
             fact pfOnFlightLanded is built on). Measured in WebKit at 1440x900: the flight's animationend
             at +479ms, so the fade had begun ~100ms before the landing (clone 0.40 opaque on the landing
             frame, the card's picture showing through a still-moving copy); at 1280x800@2 the 550ms
             disposal removed the clone before the flight had landed at all. Same 40ms hold and 150ms fade,
             anchored on the wrapper's own animationend; the backstop (an animation that never ends -- a
             hidden tab) is the pfOnFlightLanded one, ms + 480. */
          var _hDone = false;
          var _hOff = function () {
            if (_hDone) { return; } _hDone = true;
            setTimeout(function () {
              try { wrapC.style.transition = 'opacity 150ms ease'; wrapC.style.opacity = '0'; } catch (e) {}
              setTimeout(function () { disposeFlight(wrapC); }, 170);
            }, 40);
          };
          try { wrapC.addEventListener('animationend', function (ev) { if (ev.target === wrapC) { _hOff(); } }); } catch (e) {}
          setTimeout(_hOff, 340 + 480);
        }
      } else {
        if (kbNT) { tx = kbNT.tx; ty = kbNT.ty; }   // mid-drift clone: same end window, bigger box (above)
        el.style.transition = 'transform 320ms cubic-bezier(.4,0,.2,1),opacity 320ms ease';
        el.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + sc + ')';
        el.style.opacity = fadeTo;
        setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); pfStillSync(); }, 360);
      }
    }
    // For video, DECODE the still first so hiding the live clip never reveals an undrawn (black) clone; a
    // photo's src is the identical on-screen image, so it can start immediately as before.
    /* ...AND IT MUST BE RACED, because "not bounded" is not a figure of speech
       (2026-08-13). runCollapse is not a nicety on this path: it owns the slide
       hide, the flyCrop AND BOTH removal timers for a position:fixed z-index:220
       full-screen clone. A decode() promise that never settles therefore does
       not degrade the animation, it strands that clone over the page forever and
       the member's only way out is a reload. Every other deferred restore in
       this file already carries a fallback for exactly this reason -- finish()
       pairs transitionend with a 350ms timer, the borrow restore pairs
       timeupdate with setTimeout(_rev, 450) -- and this was the one that did
       not. One-shot guard, so the loser of the race is a no-op rather than a
       second collapse: 120ms is far longer than a decode of a still that is
       already on screen (the usual few ms) and far shorter than the 340ms tween
       it gates, so a healthy close is bit-for-bit unchanged and a wedged one
       still lands. */
    if (isVid && el.decode) {
      var _ranCollapse = false;
      var _collapseOnce = function () { if (_ranCollapse) return; _ranCollapse = true; runCollapse(); };
      setTimeout(_collapseOnce, 120);
      el.decode().then(_collapseOnce, _collapseOnce);
    } else { runCollapse(); }
    return true;
  };

  // the media's DRAWN rect inside a card box, from a KNOWN aspect (nw x nh) -- lets the open size its grow from
  // the LIVE clip's own dimensions instead of waiting on the placeholder clip's metadata. contain = letterboxed
  // drawn rect; cover / transform-scaled (pf-vfill) = fills the container.
  function cardDrawnRect(cardBox, nw, nh, cardEl) {
    var r = cardBox.getBoundingClientRect();
    var of = 'contain', scaled = false;
    /* ONE getComputedStyle, NOT TWO (2026-08-17). Each call resolves a fresh CSSStyleDeclaration, and
       `transform`'s resolved value is layout-dependent (percentages resolve against the box), so each
       one flushes style+layout in its own right. This function is called up to six times per open --
       pump's two branches, landTarget, reveal -- and the pair was measured at 182ms of forced
       style+layout over four events. The declaration is live, so reading two properties off one object
       is identical in behaviour and half the resolutions. The gBCR above deliberately stays FIRST: it
       is the read that flushes, and after it the style reads are answered from a clean tree. */
    try {
      var cs = getComputedStyle(cardEl || cardBox);
      of = cs.objectFit || 'contain';
      var tf = cs.transform; scaled = !!(tf && tf !== 'none');
    } catch (e) {}
    if (of === 'contain' && !scaled && nw && nh) {
      var s = Math.min(r.width / nw, r.height / nh), dw = nw * s, dh = nh * s;
      return { left: r.left + (r.width - dw) / 2, top: r.top + (r.height - dh) / 2, width: dw, height: dh };
    }
    return { left: r.left, top: r.top, width: r.width, height: r.height };
  }
  // the slide under the viewport centre -- same hit-test __rovaHeroCollapse uses.
  // The slide a carousel is actually SHOWING: nearest slide-centre to the viewport centre.
  // querySelector('.cslide') (the old way) always returned SLIDE 1, so opening/closing a
  // slideshow on slide 2/3 measured + revealed the wrong slide (owner: "second picture opens
  // incorrectly, third is broken").
  function centeredSlideOf(media) {
    var sl = media.querySelectorAll('.cslide');
    if (!sl.length) return media;
    var cx = window.innerWidth / 2, best = null, bestD = Infinity;
    for (var i = 0; i < sl.length; i++) {
      var r = sl[i].getBoundingClientRect();
      if (r.width < 4) continue;
      var d = Math.abs((r.left + r.right) / 2 - cx);
      if (d < bestD) { bestD = d; best = sl[i]; }
    }
    return best || sl[0];
  }
  function pfCenteredMedia(pf) {
    var cx = window.innerWidth / 2, cy = window.innerHeight / 2, ms = pf.querySelectorAll('.post .media');
    for (var i = 0; i < ms.length; i++) {
      var b = ms[i].getBoundingClientRect();
      if (b.width > 4 && b.height > 4 && cx >= b.left && cx <= b.right && cy >= b.top && cy <= b.bottom) {
        var sl = ms[i].querySelectorAll('.cslide'), slide;
        if (sl.length) {
          // during an OPEN the strip may not have translated to the target slide yet: hold out
          // (null -> the pump keeps polling) until the slide the viewer will land on is the one
          // actually under the viewport centre, so the grow target is never a mid-transit rect.
          var ti = (typeof window.__rovaPfTargetSlide === 'number') ? window.__rovaPfTargetSlide : -1;
          if (ti >= 0 && ti < sl.length) {
            var sr = sl[ti].getBoundingClientRect();
            if (!(sr.width > 4 && sr.left <= cx && sr.right >= cx)) { return null; }
            slide = sl[ti];
          } else {
            slide = centeredSlideOf(ms[i]);
          }
        } else { slide = ms[i]; }
        return { el: slide.querySelector('img, video'), box: slide };
      }
    }
    return null;
  }
  // OPEN as the exact MIRROR of the (owner-approved perfect) dismiss: fly a clone from the grid TILE and
  // box-RESIZE it (left/top/width/height) UP to the viewer's real PAINTED rect (paintedRectOf) -- object-fit:
  // cover crops the square tile out to the portrait frame GRADUALLY, with NO guess box, NO transform-scale and
  // NO stretch -- then cross-fade to the real media once it's ready. A live grid <video> passed as `liveVideo`
  // flies AS the hero (never black, keeps playing); otherwise a still `src` frame is used. hz-hold hides the
  // viewer's own media until the cross-fade so nothing doubles up.
  // Predict WHERE a clip will land in the open pfeed WITHOUT waiting for the (async) card to render -- so the
  // open can grow immediately, the exact reverse of the dismiss (which always knows its target tile up front).
  // Mirrors heroZoom's fit prediction + fitPfeedMedia's `pf-vfill = portrait === !wideView` cover decision, so
  // the grown box equals where the pfeed actually paints the media (no land-then-slide correction).
  // `hint` is the per-media fit hint (0144) read off the tile/card the flight lifts off; see
  // __rovaPhotoCovers. It applies to BOTH branches as of 2026-08-14 -- the clip verdict consults
  // it too now (__rovaVideoCovers, /p/43060), and a prediction that ignored it would grow a
  // cover-sized box for a hinted clip that then paints contained: the ballooning open this shared
  // body exists to stop, arriving via the one branch that had been left out of it.
  /* ---- THE LANDING BOX IS READ ONCE, BEFORE THE TAP TASK WRITES ANYTHING  (2026-08-17) -----------
     MEASURED, and it was the most expensive single forced flush of the whole open: `clientWidth` here,
     reached from heroExpand, cost ONE Blink.ForcedStyleAndLayout event of 181ms at 4x CPU (a second
     trace put it at 153ms). Nothing about the read is slow -- it was flushing style that heroExpand had
     just invalidated DOCUMENT-WIDE four statements earlier.

     THE ORDER IT INHERITED:
       1. el.style.cssText = ...            (the hero clone's fixed box)
       2. document.body.appendChild(el)
       3. liveKbSeed(el, kb)
       4. documentElement.classList.add('hz-hold')   <-- html.hz-hold has DESCENDANT rules (rova.css
          4354-4377: the viewer's media opacity, the Ken Burns play-state), so this invalidates style
          for the entire document
       5. pfeedLandRect(...) -> clientWidth           <-- pays for all of it, synchronously, inside the
          tap's own task
       6. flyCrop() then appends a <style> with the baked @keyframes, which invalidates document-wide
          AGAIN -- so the frame's own rendering update recalculated everything a SECOND time.
     Two full style passes over the grid + the viewer, one of them inside the gesture.

     THE FIX IS THE READ ORDER, NOT THE READ. Both numbers are properties of the pfeed OVERLAY, which
     is position:fixed and full-screen -- the same invariance pfViewport's header argues at length --
     so appending a fixed-position clone and toggling an opacity class provably cannot move them. Read
     them at the TOP of heroExpand, before step 1, and the flush lands on the tree as the previous
     frame left it (clean) while steps 4 and 6 are resolved together at the frame's own update.
     PRIMED VALUES ARE THEREFORE IDENTICAL TO UNHOISTED ONES, which is what keeps land-rect-check exact.

     AND NEVER FOR A RE-AIM. `pfLandLive` is already the flag that means "this is a measurement, not a
     guess" (see pfLandVh), and a re-aim must consult the LIVE box by definition. Gating on it is what
     stops the prime from outliving the one task it was taken for, and it is belt to the rAF's brace.

     THE PRIME COVERS THE FUNCTION'S WHOLE INPUT SET, NOT JUST THE OVERLAY'S BOX -- learned the hard
     way on the first attempt, which hoisted the two `.pfeed-*` reads and moved the 179ms flush four
     lines down instead of removing it. `window.innerWidth`, `window.visualViewport.height` (via
     pfLandVh) and `documentElement.clientWidth` all flush style+layout in Blink exactly as an element
     geometry getter does, and the LAST of those is the one a FIRST-EVER open actually reaches: with no
     overlay in the document `lw` is 0, so the `(lw && lw <= vw)` test falls through to
     `documentElement.clientWidth` every time. That is the open vopen-perf measures (one open per page
     load) and the open the owner notices. Prime all five and the tap-time prediction performs ZERO
     layout reads.  */
  var _lbW = 0, _lbH = 0, _lbVw = 0, _lbVh = 0, _lbDw = 0, _lbArmed = 0;
  function pfLandBoxPrime() {
    _lbArmed = 0;   // never let THIS prime's own pfLandVh() answer from the last one (see pfLandVh)
    var pfl = document.querySelector('.pfeed .pfeed-list');
    var pfs = document.querySelector('.pfeed .pfeed-scroll');
    _lbW = (pfl && pfl.clientWidth) || 0;
    _lbH = (pfs && pfs.clientHeight) || 0;
    /* A FIRST-EVER open has no overlay yet, so both are 0 and pfeedLandRect falls through to its
       documentElement/vh fallbacks exactly as it does today -- priming a zero changes nothing. */
    _lbVw = window.innerWidth;
    _lbDw = document.documentElement.clientWidth || 0;
    /* pfLandVh() consults `pfLandLive`, which is 0 here by construction -- a prime only ever happens at
       the tap, which is precisely the moment the CACHED settled height is the right answer. That is the
       same value the unhoisted call would have returned one task later. */
    _lbVh = pfLandVh();
    _lbArmed = 1;
    if (window.requestAnimationFrame) { requestAnimationFrame(function () { _lbArmed = 0; }); }
    else { setTimeout(function () { _lbArmed = 0; }, 24); }
  }
  function pfeedLandRect(nw, nh, photo, hint) {
    if (!nw || !nh) return null;
    // SETTLED height, not the live one -- pfLandVh's header carries the measurement. This is the number
    // the cover/contain verdict is decided in as well as the box it is centred in, so a stale 40px here
    // could flip the FIT, not just shift the rect.
    var primed = !!(_lbArmed && !pfLandLive);
    var vw, vh, lw, sh, dw;
    if (primed) { vw = _lbVw; vh = _lbVh; lw = _lbW; sh = _lbH; dw = _lbDw; }
    else {
      vw = window.innerWidth; vh = pfLandVh();
      var pfl = document.querySelector('.pfeed .pfeed-list');
      var pfs = document.querySelector('.pfeed .pfeed-scroll');
      lw = pfl && pfl.clientWidth; sh = pfs && pfs.clientHeight;
      dw = 0;   // read lazily below, and only when the fallback is actually taken
    }
    var cw = (lw && lw <= vw) ? lw
           : ((primed ? dw : (document.documentElement.clientWidth || 0)) || vw);   // reject a stale-wide read
    var ch = (sh && sh <= vh) ? sh : vh;
    /* PHOTO cover decision: __rovaPhotoCovers, the SAME BODY fitPfeedMedia paints from (search "THE
       ONE PHOTO FIT VERDICT") -- not the simpler `!(portrait && wide)` this line used to compute, and
       not a copy of the rule either. That shortcut only agreed with the real rule for a PORTRAIT
       image; for a LANDSCAPE one it predicted cover unconditionally, so a landscape photo far from
       the phone's aspect grew to a big cover-sized box first and then visibly corrected DOWN to the
       true, smaller contained box once flyRetarget measured it -- the "zooms into then zooms out"
       report. A shared body is what stops the next such divergence being possible at all. */
    var cover = photo ? window.__rovaPhotoCovers(nw, nh, cw, ch, hint)
                      : window.__rovaVideoCovers(nw, nh, cw, ch, hint);
    var fit = cover ? Math.max(cw / nw, ch / nh) : Math.min(cw / nw, ch / nh);
    var dw = nw * fit, dh = nh * fit;
    var dl = (cw - dw) / 2, dt = (ch - dh) / 2;
    var gl = Math.max(dl, 0), gt = Math.max(dt, 0);
    var gw = Math.min(dl + dw, cw) - gl, gh = Math.min(dt + dh, ch) - gt;
    if (gw < 4 || gh < 4) return null;
    /* `oy` -- THE CROP BIAS THE VIEWER WILL PAINT THIS BOX WITH, not a property of the box itself
       (2026-09-14). A covering photo is drawn top-biased by --pf-pany (see __rovaPfPanyBias), and
       the box is IDENTICAL either way: the picture moves INSIDE the cover window, so `left/top/
       width/height` cannot carry it and paintedRectOf cannot see it. It rides out here because
       this is the one function that already knows every input the bias needs and is already the
       single source of the landing -- the same reason flyIW/flyIH are stamped from landRect and
       not re-derived. Zero for a video, a contained photo, or a sideways crop. */
    return { left: gl, top: gt, width: gw, height: gh,
             oy: (photo && window.__rovaPfPanyBias) ? window.__rovaPfPanyBias(nw, nh, cw, ch, cover) : 0 };
  }

  /* WHICH FILE IS THIS ELEMENT ACTUALLY PLAYING? -- and never `.src` on its own. attachHls swaps src
     for a `blob:`, and retireVideo strips the attribute entirely (it stashes the URL in
     data-video-src precisely so identity survives that). _mp4src is wire()'s durable record of the
     plain mp4 for a post clip; dataset.grSrc is ensureVideo's for a grid preview. Empty means
     "unknown", and unknown is never a match: an adoption has to be PROVEN, not assumed. */
  function clipKey(v) {
    if (!v) { return ''; }
    var s = (v.dataset && v.dataset.grSrc) || '';
    if (!s) { s = v._mp4src || v.getAttribute('src') || v.getAttribute('data-video-src') || ''; }
    if (s.slice(0, 5) === 'blob:') { s = v._mp4src || v.getAttribute('data-video-src') || ''; }
    if (!s) { return ''; }
    try { return new URL(s, location.href).href; } catch (e) { return s; }
  }
  /* ═══ THE BOOMERANG LIFT-OFF: AUDIO AT THE FINGER, PICTURE ON THE CALM ══════════════════════════
     (2026-08-17. The owner's refined spec on this exact handoff, and his diagnosis is the design.)

     "The audio should begin at finger lift off after tapping a video. The video in the tile quality
      isn't that bad and the transition to the higher quality clip is a little noticeable and can be
      optimized a little more for a seamless transition, and honestly it should happen after 2-3
      seconds after the cpu has calmed or threads are available to do the switch in realtime with 0
      sync loss since doing this right at the beginning still hangs and looks un synced. It seems
      like the videos time codes are different because if they were the same I would truly not see
      the transition/fade etc."

     ═══ 1. WHY THE FADE WAS VISIBLE, AND IT IS NOT THE FADE ═══════════════════════════════════════

     He is right, and the last sentence is the root cause. The boom plays FORWARD THEN BACKWARD; the
     master only ever plays forward. A dissolve taken during the reverse phase crossfades a
     backward-running picture into a forward-running one, and no fade length hides two opposed
     motions -- the eye reads MOTION, not opacity. The previous answer here (the half-fade rewind,
     `seek = m + (dir-1)*F/2`) aligned the two CONTENT clocks at the crossover and measured a drift
     of 0.0000s while still looking like a cut, because it left the two DIRECTIONS opposed. Its own
     note called the direction flip "not removable -- the clip cannot play backwards". That was the
     mistake, and the artefact itself is what refutes it: `_grid6` is `[f0..fL]` followed by
     `[fL-1..f1]`, so EVERY frame of the reverse half has a pixel-identical twin in the forward half
     at m = D - p. Seeking the boom there changes NOTHING on screen and everything about direction.
     So the mirror (`__rovaG6Fwd`, unit-tested in `__rovaG6SelfTest`) is applied to the BOOM at
     lift-off, both surfaces then run FORWARD from the SAME content time at rate 1, and the
     compensation is DELETED rather than kept -- on a mirrored boom it would inject exactly -F of
     real error, because a compensation is only correct while the two surfaces oppose.

     THE FADE IS THEN INVISIBLE BY CONSTRUCTION, not by being short. Both layers show the same frame
     of the same content, so every intermediate blend is that same picture: there is no frame at
     which the two differ for an eye to catch. That is a stronger claim than "0.0000s of drift" and
     it is the one his sentence asks for.

     ═══ 2. AUDIO AT LIFT-OFF NEEDS AN ELEMENT THAT HAS AUDIO ══════════════════════════════════════

     The tile is playing `_grid6`, encoded `-an` -- there is no sound in the file, so no arrangement
     of the tile can make one. Only the master can, and at lift-off the master does not exist on the
     page (the card is still being fetched; that is the whole reason `soundArm` borrows the tile for
     the page-wide grant and hands it straight back muted). So the lift BUILDS the master, in the
     handler, at the last synchronous moment of the gesture: hidden at opacity 0, seeked to the
     mapped forward time, playing, and unmuted through the designated-voice arm so the reader's latch
     is still the authority and WebKit's activation is spent while it is still live.

     ONE ELEMENT, FROM THE TAP TO THE SETTLED VIEWER -- which is what makes this safe rather than a
     second voice. The element is registered as `__rovaGridDonor`, so the viewer ADOPTS it when the
     card lands (the same round-129 path a grid tile's own clip has always used) instead of rendering
     a second copy of the same file. The "CD skip" the owner reported in August was exactly two
     elements on one file ~0.3s apart; here there is only ever one, it starts once, and
     `soundVoiceArm` + `applySound`'s voice clause keep the open's hold from taking it back for a
     second beat. If the adoption does NOT happen (a slow line leaves it under readyState 2), the
     watchdog retires it and the open falls back to today's behaviour entirely -- a silent fallback
     is acceptable, two audible copies are not.

     ═══ 3. THE PICTURE WAITS FOR THE CALM -- AND FOR THE CLOCKS ═══════════════════════════════════

     Three conditions, all required, and the receipt says which one released it:
       (a) >= BOOM_CALM_MS since the landing (his "2-3 seconds"),
       (b) the main thread is genuinely idle -- `requestIdleCallback` with a timeout, never a bare
           timer, because a timer fires whether or not the thread it is competing with has calmed
           down and "the cpu has calmed" is the actual condition,
       (c) the master is really decoding (readyState >= 2, not paused) AND the two clocks agree to
           inside a frame (|masterT - mappedBoomT| <= BOOM_DRIFT_S).
     Only then does the boom fade out, over ~240ms, over a master that has been at opacity 1
     underneath it since the landing.

     ⚠ THE DEADLINE IS PHYSICAL AND IT IS NOT A TUNABLE. The boom's content is only [0, W]. Locked
     at m and running forward, it reaches W after W - m seconds and BOUNCES, and past that the master
     (still climbing) has no twin frame anywhere in the file -- so a content-exact handover is
     possible for W - m seconds and never again. `__rovaG6Runway` is that number. This therefore
     defers to the calm WITHIN the runway and otherwise fades AT the bounce, which is not a
     compromise but the most invisible instant available: the member is handed the master on the last
     forward frame and the reverse phase is never shown in fullscreen at all. Consequence, stated
     honestly: only a tap taken in the first ~1s of the loop can buy the full 2s defer; a later tap
     gets a shorter one. The alternative -- deferring anyway -- is the visible content jump he
     already reported.

     ⚠ AND ONE DELIBERATE DEVIATION FROM "IF THE DRIFT CHECK NEVER PASSES, DON'T FADE". It is
     honoured for the whole runway and then bounded: an overlay with no collapse is the shape this
     codebase has already paid for twice (a waiter whose subject was recycled never resolves, ~1
     infinite spin per swipe; and the app half's DISSOLVE_GUARD_MS exists for the same reason). A
     boom left up forever is not "no desync" -- it is a 3-second loop under running audio, which is a
     worse desync than the one being avoided. So the drift gate holds for the calm floor plus one
     whole loop of the boom (boomCapMs) and then hands over regardless, stamped `why:cap`, so the row
     says so -- and even that last attempt REALIGNS the master first (see boomTake), so a capped fade
     is an aligned fade rather than a blind one.

     ═══ 4. ZERO SYNC LOSS AT THE SEAM ═════════════════════════════════════════════════════════════

     The master is revealed at opacity 1 UNDER the boom at the landing and the boom is faded out on
     top of it, so at no instant is neither surface painting -- the app round's "split it and it
     flashes a frame of bounce" cannot occur here because there is no swap, only a withdrawal. The
     boom element is retired (decoder + buffers) in the same statement that disposes its wrapper, so
     the picture it was holding cannot come back. */
  var BOOM_CALM_MS  = 2000;    // (a) the owner's "2-3 seconds after the cpu has calmed" -- the floor
  var BOOM_IDLE_MS  = 700;     // (b) rIC timeout: idle is a PREFERENCE with a deadline, not a wait
  var BOOM_DRIFT_S  = 0.042;   // (c) "under a frame" -- one frame at 24fps, the slowest real cadence
  var BOOM_SLOP_S   = 0.15;    // never plan a fade onto the turning frame itself (close path's slop)
  var BOOM_ADOPT_MS = 3600;    // no adoption by here -> retire, rather than risk a second voice
  /* THE ANTI-HANG BOUND, AND IT IS DERIVED, NOT PICKED. The release waits for the boom's FORWARD
     phase, which comes round once per loop -- so the bound has to be "the calm floor plus one whole
     loop of the boom, plus a margin", or the cap would routinely fire on an open that was about to
     hand over cleanly a beat later. D is read from the media (never 3.0, never 6.0), so this scales
     with the clip's own frame rate exactly as W does. The floor keeps a degenerate duration honest. */
  var BOOM_CAP_MIN_MS = 4000;
  function boomCapMs(rec) {
    /* ...AND IT TIGHTENS ONCE THE HANDOFF IS PROVABLY IMPOSSIBLE. The full bound is sized for a release
       that might still arrive (the calm floor plus a whole loop, so a forward window has time to come
       round). Once `noWindow` is latched nothing can arrive, and holding the boom for another loop is
       waiting for a thing that cannot happen -- so the bound becomes twice the calm floor. That is long
       enough to honour "don't fade on a failed drift check" as a real behaviour rather than a gesture,
       and short enough that "never a hang" is also true. */
    if (rec && rec.noWindow) { return BOOM_CALM_MS * 2; }
    var d = (rec && rec.dur > 0) ? rec.dur * 1000 : 6000;
    return Math.max(BOOM_CAP_MIN_MS, BOOM_CALM_MS + d + 800);
  }
  var BOOM_FADE_MS  = 240;     // inside the 200-300ms band the owner asked for
  var boomLift = null;         // the ONE lift in flight; null between opens
  /* ═══ SINK THE LANDED OVERLAY INTO THE VIEWER'S OWN LAYER  (2026-09-01) ═══════════════════════════
     OWNER, screen recording of a grid-tap open of a boomerang video on /@Rob: "notice how opening the
     video it lands in front of the comment scroller and then properly fixes but I don't want to see
     that flicker AT ALL."

     WHAT HE WAS SEEING, frame by frame (58fps capture, open at 3.40s): the chrome faded in at 4.07s
     and the comment roller painted as a bar with a HOLE punched through its middle -- the hole exactly
     567px wide at his width, i.e. exactly the media column -- and the hole closed at 5.32-5.48s, on a
     240ms curve. 1.42s, ~83 frames, of a comment bar cut in half. Nothing moved and nothing reflowed:
     the media column's own pixels are identical across the whole window. The correction he calls
     "properly fixes" IS this module's dissolve (BOOM_FADE_MS = 240), and the thing that was "in front
     of" the roller was this module's own overlay.

     WHY. The flight wrapper is `position:fixed; z-index:210`, a child of <body>. The viewer is
     `.pfeed`, `position:fixed; z-index:205` -- a STACKING CONTEXT -- and every piece of viewer chrome
     (.body, .bar, .croller, .linkcard, .trip, .cnav) sits INSIDE it at z 2. So 210 vs 205 is decided
     at the body level and the chrome's z 2 never gets a say: for as long as the wrapper is attached it
     paints over ALL of it. That is right for a FLIGHT (it flies over the grid, outside the viewer, and
     the chrome is hidden by .pf-settling the whole time) and wrong the moment the flight becomes a
     2-3 second overlay: BOOM_CALM_MS alone is a 2000ms floor, and the reveal lands ~0.7-1.0s after the
     tap, so the overlap is not an edge case -- it is EVERY boomerang open on a machine that reveals
     faster than the calm floor.
     (It is invisible on a phone-width viewport for the WORST possible reason: there the media column is
     the whole screen, so the overlay hides the chrome COMPLETELY and it reads as "the chrome is late"
     rather than as a hole. Desktop is where the geometry makes it legible.)

     THE FIX IS A PAINT-ORDER CHANGE AND NOTHING ELSE. The overlay's job is to stand in for the MEDIA,
     so it belongs in the media's layer, not above the whole viewer. Re-parent it into the centred
     card's `.post-main` -- the media's own parent -- at `z-index:1`, which is the one free slot in
     this file's ladder: `.media` is z 0/auto (rova.css:2226, and :5200 for a carousel), every overlaid
     chrome child is z 2 (:2516 .body, :2573 .bar, :2611 .linkcard, :2643 .trip, :2922 .croller), the
     carousel bar is z 6 and .post-head is z 40. So 1 is above the picture it is standing in for and
     below everything drawn on top of it. `.post-main` is `position:absolute` with z-index auto, so it
     does NOT open a stacking context of its own -- the wrapper's 1 and the chrome's 2 are compared in
     `.pfeed`'s context, exactly as they must be.
     GEOMETRY IS UNCHANGED: the wrapper stays `position:fixed` and the current card is `.pf-cvon`
     (`content-visibility:visible`, rova.css:2157), so nothing in the new ancestry is a containing
     block or a clip for it. Measured before/after: the same 349,0 567x1008.

     TWO THINGS THE MOVE ITSELF WOULD BREAK IF THEY WERE NOT HANDLED HERE, both measured:
       1. RE-INSERTION RESTARTS CSS ANIMATIONS. The landed rect is held by flyCrop's filling
          `@keyframes` (`animation:pfxNw ... forwards`), not by inline geometry -- so the first cut of
          this moved the wrapper and the WHOLE FLIGHT REPLAYED, from the 218x218 tile rect back up to
          the landing over 380ms. The computed transform + radius are pinned inline and the animation
          dropped BEFORE the move, so the re-insert has nothing left to replay. (Same manoeuvre, for
          the same reason, as flyRetarget.)
       2. A <video> CHANGING PARENT. A move is a remove + insert; Chromium keeps decoding across it
          (verified: currentTime kept climbing, paused stayed false), WebKit has been known to pause.
          The boom IS the picture on screen for the next 2-3 seconds, so playback is re-asserted rather
          than trusted -- and only when it was actually playing before the move.
     If no viewer card can be found the wrapper is left where it is and the old behaviour stands: a
     visible overlay is strictly better than a lost one, and every other exit in this module already
     copes with a wrapper that is simply still at body level. */
  function boomSink(w) {
    if (!w) { return false; }
    var pf = document.querySelector('.pfeed.show');
    if (!pf) { return false; }
    /* THE CENTRED CARD, BY GEOMETRY. `.pf-cvon` is on the current card AND its two neighbours (see
       pfCvOn), so it cannot pick one, and `pf-settling` is still on at this point so no "current"
       bookkeeping has run yet. The card whose top is nearest 0 in a 100dvh snap scroller is the one
       the reader is looking at, and it is the one whose chrome is about to fade in. */
    var host = null, bd = 1e9;
    try {
      Array.prototype.forEach.call(pf.querySelectorAll('.post'), function (p) {
        var r = p.getBoundingClientRect();
        if (r.height < 2) { return; }
        var d = Math.abs(r.top);
        if (d < bd) { bd = d; host = p; }
      });
    } catch (e) { return false; }
    if (!host) { return false; }
    host = host.querySelector('.post-main') || host;
    /* ALREADY THERE is not "nothing to do" (2026-09-24): a wrapper that is already in the card arrives
       here still animating, and the pin below is what makes the landing the landing -- skipping it let a
       flight glide on for 200+ms after the hand-over. Only the MOVE is skipped. */
    var already = (host === w.parentNode);
    var m = w._flightMedia || (w.querySelector ? w.querySelector('img,video') : null);
    /* ...AND IT PINS THE LANDING, NOT THE CURRENT FRAME. `reveal()` fires when the flight has landed
       as far as the OPEN is concerned, which is not always the last keyframe: measured, one run in
       three arrives here with the wrapper at 564x1002 of its 567x1008 target, i.e. 99.4% through.
       Reading `getComputedStyle().transform` there and dropping the animation would freeze that 3px
       error for the whole two-second dissolve and then pop when the boom withdrew onto a master that
       is already at the full rect. Finishing the animations first commits their END values, so the
       pin is the landing and the two surfaces agree -- and what it costs is at most the last frame of
       a 340ms flight, snapped at the moment everything else about the open is snapping into place. */
    try {
      if (w.getAnimations) { w.getAnimations().forEach(function (a) { try { a.finish(); } catch (e) {} }); }
      if (m && m.getAnimations) { m.getAnimations().forEach(function (a) { try { a.finish(); } catch (e) {} }); }
    } catch (e) {}
    try {
      var cs = getComputedStyle(w);
      var wT = cs.transform, wR = cs.borderRadius;
      var mT = m ? getComputedStyle(m).transform : '';
      w.style.animation = 'none';
      if (wT && wT !== 'none') { w.style.transform = wT; }
      if (wR) { w.style.borderRadius = wR; }
      if (m) { m.style.animation = 'none'; if (mT && mT !== 'none') { m.style.transform = mT; } }
      void w.offsetWidth;   // commit the pinned state before the node moves
    } catch (e) {}
    if (already) { return true; }
    var wasPlaying = false;
    try { wasPlaying = !!(m && m.tagName === 'VIDEO' && !m.paused && !m.ended); } catch (e) {}
    try { w.style.zIndex = '1'; host.appendChild(w); } catch (e) { return false; }
    if (wasPlaying) {
      try { if (m.paused) { var pp = m.play(); if (pp && pp.catch) { pp.catch(function () {}); } } } catch (e) {}
    }
    return true;
  }
  /* A STANDALONE RECEIPT POST, not a vfMark alone. `vfStart`'s record closes 2800ms after the tap
     and a deferred fade can land after that, so the one row that proves WHICH condition released the
     dissolve would be the row most likely to be missing. Same sink, same shape, its own `dir` so the
     corpus can select it: `dsv{why|pos|mapped|drift|idleMs|faded}`, exactly the fields the owner
     asked to be able to read. vfMark is ALSO stamped when the window is still open, so an early
     release correlates against the flight it belongs to. */
  function boomReceipt(rec, why, drift, idleMs, faded) {
    var o = { why: why, pid: rec.pid,
      pos: Math.round((rec.pos || 0) * 1000) / 1000,        // raw tile position at the tap
      mapped: Math.round((rec.m || 0) * 1000) / 1000,       // the mirrored/forward = master time
      dir: rec.dir, mirrored: rec.mirrored ? 1 : 0, relock: rec.relocks || 0,
      dur: Math.round((rec.dur || 0) * 1000) / 1000,
      runway: Math.round((rec.runway || 0) * 1000) / 1000,
      locked: rec.locked ? 1 : 0,
      lockT: Math.round((rec.lockT || 0) * 1000) / 1000,          // content time the two agreed on
      lockMs: rec.lockAt ? (rec.lockAt - rec.liftAt) : -1,        // tap -> the master became playable
      drift: drift < 0 ? -1 : Math.round(drift * 1000) / 1000,
      idleMs: idleMs, faded: faded ? 1 : 0, wait: rec.waitWhy || '',
      /* THE DECODE STATE AT THE DECISION, not "around" it. A sampler outside this function reads the
         tick before or after, and the alignment + fade happen inside ONE tick -- so an external probe
         reported `decoding:false` on releases that had passed the decode gate to get here. The value
         belongs on the row that made the decision. */
      dec: boomDecoding(rec) ? 1 : 0, repump: rec.repumps || 0,
      voice: rec.voice ? 1 : 0, adopted: rec.adopted ? 1 : 0, sawMaster: rec.sawMaster ? 1 : 0,
      /* DID THE OVERLAY DROP INTO THE VIEWER'S LAYER (boomSink)? A 0 here is the one condition under
         which the owner's "in front of the comment scroller" can come back, and it is invisible from
         the outside -- the dissolve looks identical either way. On the record, per open. */
      sunk: rec.sunk == null ? -1 : rec.sunk,
      repumps: rec.repumps || 0 };
    try {
      if (window.__rovaVfMark) {
        window.__rovaVfMark('dsv|w' + why + '|p' + o.pos + '|m' + o.mapped
          + '|dr' + o.drift + '|id' + idleMs + '|f' + o.faded, null);
      }
    } catch (e) {}
    /* NO TOKEN, NO POST. /vflight is session-authed, so a GUEST's receipt can only ever be a 419 in
       the console and a request on the wire for nothing -- and a guest browsing the grid is the
       majority of this traffic. The mark and __rovaBoomLast still carry the verdict, which is what a
       harness and a console read anyway. */
    try {
      var _tk = (document.querySelector('meta[name="csrf-token"]') || {}).content || '';
      if (_tk) {
        fetch('/vflight', { method: 'POST', credentials: 'same-origin', keepalive: true,
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest',
            'X-CSRF-Token': _tk },
          body: JSON.stringify({ samples: [{ kind: 'vflight', web: 1, dir: 'boom-dsv',
            ts: Math.round(Date.now() / 1000), dsv: o }] }) }).catch(function () {});
      }
    } catch (e) {}
    try { window.__rovaBoomLast = o; } catch (e) {}   // the throttled harness reads the verdict here
  }
  /* ═══ THE LIFT OWNS THE MASTER UNTIL THE VIEWER CLAIMS IT, AND NOT ONE INSTANT LONGER ═══════════
     (2026-09-01, owner: "videos play on top of each other so I hear two audio tracks at times".)

     The master is a bare <video> on document.body at opacity 0, UNMUTED and playing since lift-off.
     It carries no class ON PURPOSE, so `SEL` (`.post .media video`) cannot see it and neither can
     applySound's single-audible sweep, close(), clearPfeedList, pruneFarPosts or any other stop path
     -- every one of them finds its subjects with a DOM query over the viewer's own markup. And it is
     ATTACHED, so `stopOrphans` cannot see it either: that guard's whole test is `!v.isConnected`.
     An unadopted master is therefore reachable by exactly one thing in this file: this rule.

     There were TWO exits from a lift and only ONE of them applied it. boomDrop (the abort paths --
     noadopt, stale, replaced) released the master; boomFade (the SUCCESS path) did not, because the
     design assumed a faded lift had been adopted by then. When it has not been, the fade nulls
     `boomLift`, which silently disarms the anti-double-voice watchdog as well -- that timer's test is
     `boomLift === rec` -- and the master is left playing, unmuted, invisible, forever.

     MEASURED on the live site in Chrome, 10 tiles of /@Rob?tab=grid, tap-to-open, no other input:
     every tile whose viewer card renders as a CAROUSEL left a second audible copy of the clip, 3 of 3
     (posts 48502, 48357, 47743); every non-carousel video tile adopted cleanly, 4 of 4. The adoption
     at loadMore selects `t.querySelector('.media:not(.carousel) video')`, so on a gallery post it
     finds nothing, `same` stays false, and the claim never happens. The ghosts SURVIVE closing the
     viewer and they ACCUMULATE -- three opens, three simultaneous unmuted tracks, still running on
     the profile page with no viewer open (boomDrop('replaced') cannot collect them either: it reads
     `boomLift`, which the previous fade already nulled). Only a reload silences them, which is the
     same sentence the owner wrote about the 2026-08-06 detached-clip bug. Same defect, new shape:
     that one was unreachable because it was DETACHED, this one because it is UNCLASSED.

     So the rule gets one owner and both exits call it. Releasing an unadopted master can never cost a
     picture (it is opacity 0 until the adoption clears its inline style) and can never cost the sound
     (the card's own clip is what applySound governs, and it is already the audible one -- that is
     precisely why there were two). */
  function boomReleaseMaster(rec) {
    if (!rec || rec.adopted || !rec.master) { return; }
    if (window.__rovaGridDonor && window.__rovaGridDonor.v === rec.master) { window.__rovaGridDonor = null; }
    try { rec.master._boomLift = null; } catch (e) {}
    try { heroReleaseVideo(rec.master); } catch (e) {}
    try { if (rec.master.parentNode) { rec.master.parentNode.removeChild(rec.master); } } catch (e) {}
  }
  /* Tear the lift down. It NEVER removes an ADOPTED master -- by then that element is the card's
     clip and the viewer owns it; only the un-adopted, still-body-level one is ours to retire. */
  function boomDrop(why) {
    var rec = boomLift; if (!rec) { return; }
    boomLift = null;
    try { clearTimeout(rec.adoptT); } catch (e) {}
    try { clearTimeout(rec.calmT); } catch (e) {}
    try { clearTimeout(rec.pumpT); } catch (e) {}
    if (rec.onGesture) { try { document.removeEventListener('touchstart', rec.onGesture, true); document.removeEventListener('wheel', rec.onGesture, true); document.removeEventListener('keydown', rec.onGesture, true); } catch (e) {} rec.onGesture = null; }
    if (rec.onTick) { try { rec.master.removeEventListener('timeupdate', rec.onTick); } catch (e) {} rec.onTick = null; }
    boomReleaseMaster(rec);
    /* ⚠ AND THE OVERLAY GOES WITH IT, ALWAYS. This is the single most dangerous thing in the round:
       once the dissolve is armed there is a full-screen OPAQUE layer above the viewer whose only
       scheduled removal is the fade. Every path that ends the lift early -- the anti-double-voice
       watchdog, a stale generation, a re-lift -- would otherwise leave that layer up for the life of
       the viewer, which is not a subtle bug: it is the previous post's picture pinned over the app.
       Disposed rather than faded, deliberately: a drop is an abort, and there is nothing to
       crossfade to a member who is not looking at this open any more. `.pf-dsv` is already out of
       `.pf-hero`, so heroRelease's gate has long since let go and nothing is waiting on this. */
    if (rec.wrap) {
      var dw = rec.wrap; rec.wrap = null;
      try { if (window.__rovaRetireVideo && rec.boom) { window.__rovaRetireVideo(rec.boom); } } catch (e) {}
      try { disposeFlight(dw); } catch (e) {}
    }
    /* STAMPED ON EVERY DROP, ARMED OR NOT. A lift that dies BEFORE the landing is the most
       interesting row there is -- it is the difference between "the dissolve chose to wait" and "there
       was never a dissolve to release" -- and gating the receipt on `armed` made exactly those rows
       read as absent. Same rule as the g6Dissolve mark it replaces: a mark that only appears on the
       happy path reads as "absent" on the rows that would prove a regression. */
    boomReceipt(rec, why || 'drop', -1, rec.landAt ? (Date.now() - rec.landAt) : -1, 0);
  }
  window.__rovaBoomDrop = boomDrop;   // close()/reset reach it from the pfeed IIFE
  /* THE LIFT, called from the grid tap handler at lift-off. Returns the record or null; a null is
     always "this open is not a boomerang lift", never an error, and the caller then behaves exactly
     as it did before this round. */
  function boomLiftStart(o) {
    boomDrop('replaced');
    try {
      var boom = o && o.boom, url = (o && o.master) || '', pos = +(o && o.pos), D = +(o && o.dur);
      if (!boom || !url || !isFinite(D) || D <= 0 || !isFinite(pos) || pos < 0) { return null; }
      if (typeof window.__rovaG6Fwd !== 'function') { return null; }
      var m = window.__rovaG6Fwd(pos, D);
      var dir = window.__rovaG6Dir(pos, D);
      var runway = window.__rovaG6Runway(pos, D, BOOM_SLOP_S);
      /* (1) THE MIRROR, and ONLY on the reverse half -- on the forward half the tile is already its
         own forward twin and a seek there would be a decode flush bought for nothing (the exact cost
         the `_grid3` open-restart gate was written to stop paying). Same frame either way, so
         nothing on screen moves; it happens under the tile's own picture, on a fully buffered
         ~556 KB file it has been looping, before the flight has visibly started. AFTER `soundArm`
         in the caller, for the same reason the old rewind was: the grant must land while WebKit
         still counts this as user activation. */
      var mirrored = 0;
      if (dir < 0) {
        try { if (Math.abs((boom.currentTime || 0) - m) > 0.02) { boom.currentTime = m; mirrored = 1; } } catch (e) {}
      }
      /* (2) THE MASTER. Muted AT LOAD TIME and unmuted in the gesture a few lines below: autoplay
         eligibility is checked against the state when the load algorithm runs, which is the src
         assignment, and ensureVideo's own note is the measurement behind that order. currentTime is
         assigned right after src ON PURPOSE -- at readyState 0 that sets the DEFAULT PLAYBACK START
         POSITION, so the element opens AT the mapped frame instead of decoding frame 0 and seeking
         off it, and the first frame it ever paints is already the right one. Re-applied on
         loadedmetadata as a belt, guarded so it is a no-op when the start position took. */
      var mv = document.createElement('video');
      mv.className = '';
      mv.playsInline = true; mv.setAttribute('playsinline', '');
      mv.loop = true;
      mv.preload = 'auto';
      mv.crossOrigin = 'anonymous';        // matches views/_post.php's own attribute exactly
      mv.muted = true; mv.defaultMuted = true; mv.setAttribute('muted', '');
      /* A REAL, FULL-VIEWPORT BOX AT OPACITY 0, not a 1x1 and not display:none. It has to DECODE
         through the whole defer -- condition (c) asks whether it is genuinely decoding -- and a
         zero-area or display:none element is exactly what an engine is entitled to stop decoding.
         opacity 0 + pointer-events none is inert to the reader and to hit-testing, it carries no
         class so no sweep (`SEL` is `.post .media video`) and no CSS can reach it, and it is
         adopted into the card within ~400ms anyway. z-index 1 keeps it under the backdrop (205) and
         the hero (210) so even a botched opacity could not cover the open. */
      mv.style.cssText = 'position:fixed;left:0;top:0;width:100%;height:100%;opacity:0;'
        + 'pointer-events:none;z-index:1;background:#000;object-fit:contain';
      mv.src = url;
      try { if (m > 0.02) { mv.currentTime = m; } } catch (e) {}
      document.body.appendChild(mv);
      var rec = { pid: String((o && o.pid) || ''), pos: pos, m: m, dir: dir, dur: D, w: D / 2,
        runway: runway, mirrored: mirrored, relocks: 0, liftAt: Date.now(),
        deadline: Date.now() + runway * 1000, master: mv, boom: boom, gen: heroGen,
        voice: false, adopted: false, armed: false, faded: false, landAt: 0,
        calmT: null, pumpT: null, adoptT: null, wrap: null };
      var reseek = function () {
        try { if (m > 0.02 && Math.abs((mv.currentTime || 0) - m) > 0.05) { mv.currentTime = m; } } catch (e) {}
      };
      try { mv.addEventListener('loadedmetadata', reseek, { once: true }); } catch (e) {}
      /* (3) THE VOICE, inside the gesture. A false answer is the reader's stored intent being MUTED
         (or soundfollow off), and then the master still has to PLAY -- it is the picture half of the
         handoff too, and a paused master can never satisfy condition (c). */
      if (window.__rovaSoundVoiceArm) { try { rec.voice = !!window.__rovaSoundVoiceArm(mv); } catch (e) {} }
      /* PLAY IT EITHER WAY, AND KEEP THE REJECTION. `soundVoiceArm` already called play() when it
         armed, but a rejection there is deliberately swallowed (an abort is not a refusal), so a
         genuine NotAllowedError would leave a paused master with no trace of why -- the "confidently
         silent" shape. A second play() on a running element is a no-op, and this one's rejection is
         recorded on the record where __rovaBoomProbe can report it. */
      var mp = null;
      try { mp = mv.play(); } catch (er) { rec.playErr = 'throw:' + ((er && er.name) || 'e'); }
      if (mp && mp.catch) { mp.catch(function (er) { rec.playErr = (er && er.name) || 'reject'; }); }
      mv._boomLift = rec;
      /* HAND IT TO THE VIEWER AS THE DONOR. The card's own <video> for this post is `preload="none"`
         whenever it has a poster + dimensions (the origin-saturation fix), so it never self-loads
         and the adoption below costs the wire NOTHING extra -- this element replaces that fetch
         rather than adding one. */
      window.__rovaGridDonor = { id: rec.pid, v: mv, at: Date.now() };
      /* THE ANTI-DOUBLE-VOICE WATCHDOG. If the adoption has not claimed this element by here (a slow
         line leaving it under readyState 2, a card that never rendered, a close) then retire it: a
         silent fallback to today's path is acceptable, two audible copies of one file are the exact
         defect this round must not reintroduce. */
      rec.adoptT = setTimeout(function () {
        if (boomLift === rec && !rec.adopted) { boomDrop('noadopt'); }
      }, BOOM_ADOPT_MS);
      boomLift = rec;
      return rec;
    } catch (e) { return null; }
  }
  window.__rovaBoomLift = boomLiftStart;   // the grid tap handler lives in its own closure
  /* Claimed by the viewer's donor adoption. Returns the record so the caller can also learn that it
     must NOT apply its resume seek: this element has been running on the master's timeline since the
     tap, which is a stronger answer than the tap-time snapshot that seek was computed from, and
     re-seeking it backwards would break both the audio and the lock in one statement. */
  window.__rovaBoomAdopted = function (v) {
    var rec = v && v._boomLift;
    if (!rec || rec !== boomLift) { return null; }
    rec.adopted = true;
    try { clearTimeout(rec.adoptT); } catch (e) {} rec.adoptT = null;
    return rec;
  };
  window.__rovaBoomIsMaster = function (v) { return !!(v && v._boomLift && v._boomLift === boomLift); };
  /* The two live surfaces, for a harness that has to instrument THEM and not "whatever video the DOM
     happens to hand back". Before the adoption the master is a body-level element that no viewer
     selector can name, which is exactly the window a check of the audio has to look at. */
  window.__rovaBoomEls = function () {
    var rec = boomLift; if (!rec) { return null; }
    return { master: rec.master, boom: rec.boom, wrap: rec.wrap };
  };
  /* Read the two clocks and the master's decode state. `mappedBoomT` is the boom's position folded
     back onto content time, which is what makes the comparison meaningful at all: comparing raw
     positions would read a perfect lock as a growing error through the reverse half. */
  function boomDrift(rec) {
    var mT = -1, bT = -1;
    try { mT = rec.master.currentTime || 0; } catch (e) {}
    try { bT = window.__rovaG6Fwd(rec.boom.currentTime || 0, rec.dur); } catch (e) {}
    if (!(mT >= 0) || !(bT >= 0)) { return { mT: -1, bT: -1, d: -1 }; }
    return { mT: mT, bT: bT, d: Math.abs(mT - bT) };
  }
  function boomDecoding(rec) {
    try {
      var v = rec.master;
      return !!(v && v.readyState >= 2 && !v.paused && !v.ended);
    } catch (e) { return false; }
  }
  /* THE FADE. One opacity transition on the boom's wrapper, over a master that has been opaque
     underneath it since the landing -- so this is a WITHDRAWAL, not a swap, and there is no instant
     at which neither surface is painting. The boom's decoder is released in the same statement that
     disposes the wrapper: a detached <video> keeps decoding where every DOM-querying stop path in
     this file can no longer see it. */
  function boomFade(rec, why, drift, idleMs) {
    if (!rec || rec.faded) { return; }
    rec.faded = true;
    try { clearTimeout(rec.calmT); } catch (e) {}
    try { clearTimeout(rec.pumpT); } catch (e) {}
    if (rec.onGesture) { try { document.removeEventListener('touchstart', rec.onGesture, true); document.removeEventListener('wheel', rec.onGesture, true); document.removeEventListener('keydown', rec.onGesture, true); } catch (e) {} rec.onGesture = null; }
    if (rec.onTick) { try { rec.master.removeEventListener('timeupdate', rec.onTick); } catch (e) {} rec.onTick = null; }
    var w = rec.wrap;
    boomReceipt(rec, why, drift, idleMs, 1);
    /* THE SUCCESS PATH ENDS THE LIFT TOO, so it owes the same release as every abort path -- see
       boomReleaseMaster. Both exits below, because this early one is reached whenever the boom's
       wrapper has already gone (a dismissed flight, a disposed overlay) and it nulls `boomLift`
       exactly like the timed one does. */
    if (!w || !w.parentNode) { boomReleaseMaster(rec); if (boomLift === rec) { boomLift = null; } return; }
    /* ONE FRAME BEFORE THE OPACITY MOVES. boomTake may have just seeked the boom by up to a frame of
       content to align it, and `currentTime` reports the new position before the decoder has PAINTED
       it. Committing the transition's start value this frame and the target on the next gives the
       seeked frame a frame to arrive, so the crossfade begins over the picture it was aligned to
       rather than over the one before it. Costs 16ms of a 240ms fade and removes the only instant at
       which the two layers could disagree. */
    try {
      var tr = w.style.transition || '';
      w.style.transition = (tr ? tr + ',' : '') + 'opacity ' + (BOOM_FADE_MS / 1000) + 's ease';
      w.style.opacity = '1';
    } catch (e) {}
    requestAnimationFrame(function () { try { w.style.opacity = '0'; } catch (e) {} });
    setTimeout(function () {
      try { if (window.__rovaRetireVideo && rec.boom) { window.__rovaRetireVideo(rec.boom); } } catch (e) {}
      try { disposeFlight(w); } catch (e) {}
      /* AFTER the boom is retired, not before: on the ordinary (adopted) open this is a no-op, and on
         the unadopted one the boom's picture has just been withdrawn, so the card's own clip is what
         the reader is looking at and hearing. Removing the ghost here takes nothing off the screen. */
      boomReleaseMaster(rec);
      if (boomLift === rec) { boomLift = null; }
    }, BOOM_FADE_MS + 20);
  }
  /* ═══ WAIT FOR THE MASTER TO BE PLAYABLE -- AND NEVER SEEK IT ══════════════════════════════════
     MEASURED, and this is the fact the first cut of this round got wrong (4x CPU, 390px, real touch,
     a 27 MB master on a warm CDN): the lift-off master reaches readyState 1 at ~1.9s and readyState 4
     at ~2.2s after the tap. Its clock therefore sits FROZEN at `m` for the first two seconds while
     the boom -- fully buffered, ~486 KB, already looping -- runs on. "Both surfaces start together at
     the same rate" is true only on a line fast enough to make it true.

     ⚠ THE FIRST FIX FOR THAT WAS TO SEEK THE MASTER ONTO THE BOOM HERE, AND IT WAS WRONG TWICE OVER.
     It looked free -- the master is covered and, before readyState 2, silent -- but:
       1. IT THROWS AWAY THE WINDOW. The handoff is possible only while the master's content time is
          somewhere the boom can show, i.e. inside [0, W]. `m` is by construction in the FIRST few
          seconds (it is a position in a 3s preview), so a master left at `m` has the whole rest of
          the window to climb through. Seeking it onto wherever the boom happens to be at readyState 2
          can put it at 2.8s of a 2.97s window -- and then there is no window left at all. Measured:
          masterT 7.31s against a 2.97s window, released by the cap on a 5.7s mismatch, on a run where
          the master had otherwise behaved perfectly.
       2. IT IS NOT NEEDED. The release aligns the BOOM to the master, and the boom is the surface that
          can be seeked instantly. So nothing downstream ever requires the master to be anywhere in
          particular -- only to be PLAYING, forward, from a time inside the window.
     What is left of the "lock", therefore, is a WAIT: the release conditions must not be evaluated
     against a frozen clock, because a drift reading taken against one is not a measurement of
     anything. Nothing is seeked here. `lockT` records where the master actually was when it came
     alive, which is the number that says how much window this open had to spend.
     AND THE BOOM IS NOT MIRRORED HERE EITHER: the release's own alignment lands it on a forward-phase
     position by construction (see boomTake), so a mirror here would be a second seek for nothing. */
  function boomLock(rec) {
    if (rec.locked) { return true; }
    if (!boomDecoding(rec)) { return false; }
    var dr = boomDrift(rec);
    if (dr.d < 0 || !(dr.mT >= 0)) { return false; }
    rec.locked = 1; rec.lockAt = Date.now(); rec.lockT = dr.mT;
    rec.runway = Math.max(0, rec.w - BOOM_SLOP_S - (BOOM_FADE_MS / 1000) - dr.mT);
    return true;
  }
  /* ═══ TAKE THE HANDOFF, OR SAY WHY NOT ═══════════════════════════════════════════════════════════
     Four conditions, checked in the order that makes each one cheap, and each failure recorded on the
     record so the receipt can name it. Returns true when the fade has been started.

     (i) THE BOOM MUST BE IN ITS FORWARD PHASE. This is the condition that makes the owner's sentence
         true and it cannot be substituted. Handing a forward-running master to a member who is
         watching a BACKWARD-running picture is a direction change at the seam even when the frame is
         identical -- motion is what an eye reads. Waiting for the forward half is free: the boom is a
         palindrome on `loop`, so a forward window comes round every D seconds and half of every loop
         is one. It also removes any need to mirror the boom at the fade, which would itself be a
         visible reversal exactly where the reader is looking.
     (ii) WITH ENOUGH FORWARD CONTENT LEFT TO COVER THE FADE. Both layers are visible for
         BOOM_FADE_MS; if the boom bounces inside that, the last frames of the crossfade show the two
         surfaces separating. So the fade is only started with more than its own length of forward
         window remaining, plus the turning-frame slop.
     (iii) THE FINAL ALIGNMENT IS DONE ON THE **BOOM**, and this is the correction the measurements
         forced. The first cut aligned the MASTER at release time -- seek it to the boom's content
         time, poll for `seeked`, then compare. That LIVELOCKS on a weak line, and the run that proved
         it is in the record: relock=4, drift walking up to 1.70s, released by the cap. The reason is
         structural, not a tuning miss. A master seek on a 27 MB progressive file costs a re-buffer, so
         while it lands the BOOM keeps moving; by the time the master reaches the target the target has
         gone, and each retry buys another re-buffer and makes the next comparison worse.
         ONLY ONE OF THE TWO SURFACES CAN BE SEEKED INSTANTLY, AND IT IS THE BOOM: ~486 KB, fully
         buffered, looping for the whole time the tile was on screen -- which is the same property that
         makes the lift-off mirror free. So the master's clock is taken as GIVEN at the release and the
         boom is brought to it, which converges in one step instead of chasing.
         THE BOOM'S SEEK IS AT MOST `drift` SECONDS OF PICTURE, and it is the RIGHT direction to move:
         a master that has fallen behind is a master whose AUDIO is behind the picture the member is
         watching, so pulling the picture back onto the audio fixes A/V sync rather than costing it.
         It is gated on the master's time being landable in the boom's forward window WITH fade runway
         -- which it is by construction on the normal path, because the release never waits past the
         bounce.
     (iv) AND THE MASTER MUST BE DECODING, with the two clocks inside a frame AFTER the alignment.
         The measurement comes after the correction -- never instead of it. */
  /* HOW LONG THE HANDOFF IS STILL POSSIBLE, in ms, read from the MASTER's clock and nothing else.
     The release aligns the boom TO the master, so the only question is whether the master's own
     content time is still somewhere the boom can show -- and since that time climbs at rate 1, the
     answer is a countdown. `-1` means the window has already gone. Computed fresh every tick rather
     than stored: a stored deadline from the lock is wrong the moment the master stalls, and the first
     cut's stored one is what let a run wait out the 2s calm floor and find the window gone (masterT
     7.31s against a 2.97s window -- released by the cap on a 5.7s mismatch). */
  function boomWindowLeftMs(rec, mT) {
    if (!(mT >= 0)) { return -1; }
    var left = rec.w - BOOM_SLOP_S - (BOOM_FADE_MS / 1000) - mT;
    return left > 0 ? left * 1000 : -1;
  }
  /* `mode` -- three strengths, and the middle one is the interesting one:
       undefined   STRICT. Every condition. The ordinary, calm, invisible release.
       'deadline'  THE LAST CONTENT-EXACT INSTANT. Skips the decode gate and the forward-phase wait,
                   keeps the ALIGNMENT. Rationale, and it is the owner's own ranking: at the deadline
                   the choice is between a content-exact handover that may briefly freeze while the
                   master buffers, and a handover onto the WRONG FRAME. "0 sync loss" decides it. A
                   freeze resolves itself; a content jump is the thing he can see.
       'force'     THE CAP. Everything skipped. Still aligns if it can (see the landable branch), so
                   even the last-resort collapse is as close as this open could get. */
  function boomTake(rec, why, idleMs, mode) {
    var force = (mode === 'force');
    var soft = force || (mode === 'deadline');
    var dr = boomDrift(rec);
    if (dr.d < 0) { rec.waitWhy = 'noclock'; return false; }
    /* DECODE IS CHECKED BEFORE THE SEEK, and the order is the whole difference between one alignment
       and eighty. It used to sit after: every poll aligned the boom, then failed on `nodecode`, then
       polled again -- measured 80 boom seeks in one open, which is ALSO why that run reported 79
       "backward steps" on the boom clock. Those were not the palindrome running in reverse; they were
       this function re-seeking it. Nothing may be moved on behalf of a fade that is not going to
       happen this tick. */
    if (!soft && !boomDecoding(rec)) { rec.waitWhy = 'nodecode'; return false; }         // (iv), first half
    var bdir = 1;
    try { bdir = window.__rovaG6Dir(rec.boom.currentTime || 0, rec.dur); } catch (e) {}
    /* ONE SEEK COVERS BOTH JOBS, and noticing that is what collapsed this function. Aligning the boom
       to `masterT` necessarily lands it on a FORWARD-phase position -- `masterT` is a master time and
       the boom's forward half IS master time -- so the alignment and the mirror are the same statement.
       The seek is therefore taken whenever EITHER the clocks disagree or the boom is running backwards,
       and (i) needs no separate wait at all. Skipped only when the boom is already forward AND already
       inside a frame, which is the fast path on a healthy line. */
    var needSeek = (dr.d > BOOM_DRIFT_S) || (bdir < 0);
    if (needSeek) {
      /* Is the master's own time showable on the boom, with room for the fade to finish inside the
         forward window? `__rovaG6Tile` is the documented inverse and answers -1 past the window, which
         is a refusal a caller must handle rather than approximate -- so a master that has genuinely
         run out of the boom's content waits (or, at the cap, hands over as-is) rather than being faked
         into range. */
      var landable = (typeof window.__rovaG6Tile === 'function')
        && window.__rovaG6Tile(dr.mT, rec.dur) >= 0
        && boomWindowLeftMs(rec, dr.mT) > 0;
      if (!landable) { rec.waitWhy = 'nowindow'; if (!force) { return false; } }
      else {
        try { rec.boom.currentTime = dr.mT; rec.relocks = (rec.relocks || 0) + 1; } catch (e) {}
        rec.lockT = dr.mT;
        dr = boomDrift(rec);          // the boom's clock reports the new position immediately
        rec.waitWhy = 'aligned';
      }
    } else if (!soft && boomWindowLeftMs(rec, dr.mT) <= 0) {
      // Already matched, but the fade would not finish inside the forward window: (ii). At the
      // deadline this is moot -- that IS the end of the window, and taking it is the whole point.
      rec.waitWhy = 'nearbounce'; return false;
    }
    if (!force && !(dr.d >= 0 && dr.d <= BOOM_DRIFT_S)) { rec.waitWhy = 'drift'; return false; }   // (iv), rest
    boomFade(rec, why, dr.d, idleMs);
    return true;
  }
  /* THE DECISION, re-entered on the lock poll, then on the calm timer, then on each idle callback. It
     never loops unbounded: every branch either fades, or re-arms exactly one timer, and the cap is
     absolute. */
  function boomDecide(rec, viaIdle) {
    if (!rec || rec !== boomLift || rec.faded) { return; }
    rec.decideN = (rec.decideN || 0) + 1;   /* how many times the controller has looked; a poll that is
                                              not running is invisible without it */
    if (rec.gen !== heroGen) { boomDrop('stale'); return; }          // a newer open/close owns the viewer
    var now = Date.now(), idleMs = now - rec.landAt;
    if (!rec.master || !rec.master.isConnected || !rec.boom || !rec.boom.isConnected) {
      boomFade(rec, 'gone', -1, idleMs); return;
    }
    var pastCap = idleMs >= boomCapMs(rec);
    /* ⚠ KEEP THE MASTER RUNNING. MEASURED, unthrottled, and it is the defect that made every earlier
       run unreadable: `playIO` pauses the lift's master at ~1080ms of the open (stack captured:
       IntersectionObserver -> `if (!v.paused) v.pause()`) because the card is momentarily out of view
       while the deck positions itself -- and nothing ever starts it again. Its clock then sits frozen at
       the lock position for the whole watch, so the audio stops, the drift gate can never pass, and the
       release falls through to the cap. Every symptom points at the dissolve and none of them was the
       dissolve.
       A PAUSE DURING AN OPEN IS NOT CONSENT, which is the same rule `soundRepair` already applies to
       the sound half of exactly this problem, so this is that rule for the picture half. Narrow on
       purpose: only the element THIS lift built, only while the lift is live (so it is bounded by the
       cap), and never against `_userPaused` -- a member who pressed pause has decided, and the dissolve
       is not entitled to overrule them; it simply waits and is collapsed by the cap.
       `repumps` rides on the receipt so a row shows how contested the element was. */
    try {
      if (rec.master.paused && !rec.master._userPaused && !rec.master.ended) {
        rec.repumps = (rec.repumps || 0) + 1;
        var rp = rec.master.play();
        if (rp && rp.catch) { rp.catch(function () {}); }
      }
    } catch (e) {}
    /* PHASE 1: NOT LOCKED YET. Poll fast (the lock's own window is the master's load, ~2s on a
       throttled phone) and do not even look at the release conditions -- a drift reading taken
       against a frozen master is not a measurement of anything. The cap is what bounds this: a
       master that never becomes playable ends the dissolve rather than holding the boom forever. */
    if (!rec.locked && !boomLock(rec)) {
      if (pastCap) { boomFade(rec, 'nolock', boomDrift(rec).d, idleMs); return; }
      rec.pumpT = setTimeout(function () { boomDecide(rec, null); }, 120);
      return;
    }
    var pastCalm = idleMs >= BOOM_CALM_MS;
    /* PHASE 2: TAKE THE HANDOFF WHEN IT CAN BE TAKEN CLEANLY.
       ⚠ THE ALIGNMENT IS MADE AT THE FADE, NOT MERELY WAITED FOR. Measured (4x CPU, 27 MB master):
       the lock takes, and then the MASTER falls behind -- it stalls under a throttled pipeline while
       the boom, a fully-buffered 486 KB file, runs on. Drift reached 0.336s and the drift gate
       (correctly) refused for the whole window, so the release fell through to the anti-hang cap and
       faded on a 0.336s mismatch: the exact defect, arrived at through the mechanism meant to prevent
       it. "Both started together at the same rate" is not a property a stalling network preserves.
       So the master is REALIGNED immediately before the crossfade instead. That seek is free where
       every earlier one was not: the boom is covering the master completely, so the seek and its own
       decode gap are invisible; and if the master had drifted, its audio was ALREADY out of step with
       the picture the member is watching, so pulling it onto the picture's content time is what fixes
       A/V sync rather than what costs it. This makes drift-at-the-fade zero by CONSTRUCTION, which is
       a stronger guarantee than any amount of waiting can give.
       See boomTake for the four conditions and why the forward phase is one of them. */
    if (pastCalm && viaIdle && boomTake(rec, viaIdle === 'timeout' ? 'idlecap' : 'idle', idleMs)) { return; }
    /* ⚠ THE BOUNCE OUTRANKS THE CALM FLOOR, and leaving it out cost a whole measurement round. The
       master's content time climbs at rate 1, so the window in which the boom can be aligned to it is
       a COUNTDOWN, not a state. On a healthy line the master reaches the end of the boom's forward
       window in (W - lockT) seconds -- often under the 2s calm floor -- and a controller that simply
       waited out the floor found the window gone and fell through to the cap: measured masterT 7.31s
       against a 2.97s window, a 5.7s mismatch, on the run where the master had behaved PERFECTLY.
       So the last content-exact instant is taken whether or not the thread has calmed. This is not a
       compromise on the owner's "2-3 seconds": it is the arithmetic behind the honest limit stated in
       the header, and it is the difference between a defer that is short and a handoff that is wrong. */
    var mNow = boomDrift(rec).mT;
    var winLeft = boomWindowLeftMs(rec, mNow);
    /* 260ms of margin, not 140, and 'deadline' strength rather than strict. The poll that has to catch
       this instant is competing with the busiest part of an open -- measured delivered at ~2s intervals
       under load before the lock went event-driven -- so a 140ms mouth was routinely missed and the
       window then closed for good (`why:nowindow`, drift 2.7-3.3s, i.e. the visible jump this whole
       round is about). A wider mouth costs at most 260ms of the defer; missing it costs the invisibility. */
    var dlMouth = Math.max(400, Math.min(1500, (rec.stepMax || 0) * 1.6));   // same margin as onTick
    if (winLeft > 0 && winLeft <= dlMouth && boomTake(rec, 'bounce', idleMs, 'deadline')) { return; }
    /* ═══ THE WINDOW HAS GONE: HOLD THE BOOM, DO NOT FADE ══════════════════════════════════════════
       The master's content time is past everything the boom contains, so no amount of further waiting
       can make this handoff content-exact. The owner's instruction for exactly this state is explicit:
       "If the drift check never passes, DON'T fade -- keep the boom and let the master keep playing
       audio (never a visible desync, never a hang)." So the boom keeps looping and the real clip keeps
       talking, which is a coherent thing to be looking at; a crossfade onto a frame 1.3s away is not.
       (An earlier cut faded here. It was the wrong call: it produced precisely the visible jump this
       round exists to remove, and it did so on the path that had already given up on avoiding it.)
       ⚠ AND IT IS LATCHED SO THE BOUND CAN TIGHTEN. "Never a hang" is the other half of his sentence,
       and once the window is provably gone the ordinary cap -- the calm floor plus a whole loop of the
       boom, sized for a release that might still arrive -- is waiting for something that cannot happen.
       So the latch shortens it, and the collapse at that bound is stamped `cap` (never `nowindow`), so
       a row still distinguishes "could not be made invisible" from "the thread never calmed".
       HOW OFTEN: 1 open in 4 at 4x CPU throttling on a 27 MB progressive master, 0 in 5 unthrottled.
       It is the weak-pipeline tail, not the normal path. */
    if (winLeft <= 0 && !rec.noWindow) {
      rec.noWindow = 1;
      rec.waitWhy = 'nowindow';
      boomReceipt(rec, 'nowindow-hold', boomDrift(rec).d, idleMs, 0);
    }
    /* THE CAP. Everything above is a preference; this is the bound. An overlay with no collapse is a
       worse desync than the one it is avoiding (see the deviation note in the header), so the last
       attempt is unconditional -- and it still realigns first, so even a capped fade is aligned. */
    if (pastCap) { if (!boomTake(rec, 'cap', idleMs, 'force')) { boomFade(rec, 'cap', boomDrift(rec).d, idleMs); } return; }
    /* RE-ARM. Idle with a timeout, never a bare timer: "the cpu has calmed" is the condition, and the
       timeout is only there so a permanently busy thread still resolves. Once past the calm floor the
       wait is zero and the rhythm is set by the idle callback alone, which is what makes a busy thread
       hold the boom and a quiet one release it. Before the floor the wait is clamped to whatever is
       left of the alignable window, so the bounce branch above is always reached in time. */
    var wait = pastCalm ? 0 : Math.max(0, BOOM_CALM_MS - idleMs);
    /* ⚠ AIM AT THE MIDDLE OF THE REMAINING WINDOW, NOT AT ITS EDGE. Scheduling the wake at
       `winLeft - 200` aims once and cannot recover: under load a 1.5s timer is delivered late, and
       late by anything at all means the window has closed (measured at 4x: lock with 1.764s of window,
       the wake missed it, `why:nowindow`, drift 3.07s -- the visible jump, arrived at by a timer that
       was 200ms optimistic). Halving instead converges -- 882, 441, 220 -- so each miss costs half the
       remaining time rather than all of it. Costs nothing on a healthy line, where the calm floor is the
       larger term and this clamp never binds.
       ⚠ AND IT IS STILL NOT THE GUARANTEE. Betting on it was this round's longest wrong turn: a timer
       measures the window in WALL time and is then delivered by a thread that is not keeping wall time
       (661ms delivered ~1.7s late at 4x CPU), so halving only slows the overshoot down. The deadline's
       real driver is the master's own `timeupdate` -- see the long note in boomArmRelease. This stays as
       the backstop for an engine that emits none. */
    var chase = false;
    if (winLeft > 0) {
      var half = Math.max(30, Math.floor(winLeft * 0.5));
      if (half < wait) { wait = half; chase = true; }
    }
    /* A DEADLINE WAKE DOES NOT GO THROUGH requestIdleCallback: rIC may take its whole timeout, so a
       772ms timer followed by a 700ms idle deadline is a 1.47s round trip -- longer than the window it
       was chasing. The idle gate is the calm PREFERENCE; the window is a CONSTRAINT, and the preference
       must not be allowed to spend it. (The real guarantee for the deadline is the master's own
       `timeupdate`, wired in boomArmRelease -- see the note there. This clamp and `chase` are the
       backstop for an engine that emits no timeupdate.) */
    var tmo = BOOM_IDLE_MS;
    rec.pumpT = setTimeout(function () {
      if (rec !== boomLift || rec.faded) { return; }
      if (chase) { boomDecide(rec, null); return; }
      if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(function (dl) {
          boomDecide(rec, (dl && dl.didTimeout) ? 'timeout' : 'idle');
        }, { timeout: tmo });
      } else {
        // No rIC (WebKit before 17.4): a rAF pair is the closest honest proxy for "the thread got
        // through a frame", and the cap below still bounds it. Marked `idlecap` in the receipt, so a
        // row never claims an idle verdict an engine could not give.
        requestAnimationFrame(function () { requestAnimationFrame(function () { boomDecide(rec, 'timeout'); }); });
      }
    }, wait);
  }
  /* ARM THE DEFERRED DISSOLVE, from reveal() at the landing. Returns true when it took ownership of
     the wrapper -- the caller must then NOT fade or dispose it. */
  function boomArmRelease(wrapEl, sawEl) {
    var rec = boomLift;
    /* A REFUSAL IS STAMPED, NOT SILENT, and this is the receipt the round could not do without. The
       arm has three ways to decline and they are three different stories: there is no lift at all (a
       plain open, or a close already dropped it), there is no flight wrapper (the 15s-cap still
       fallback flew no wrapper), or the lift is already armed (a re-entered reveal). Un-stamped, all
       three look identical from the outside -- "the dissolve just did not happen" -- and the first cut
       of this round spent a whole measurement cycle on exactly that ambiguity.

       ⚠ IT DOES NOT REQUIRE THE ADOPTION TO HAVE LANDED, AND THAT IS A MEASURED CORRECTION. The
       first cut armed only when the viewer's centred media WAS the lift's master, which reads as
       obviously right and is a race: `rova:pfeedready` is dispatched at the TOP of loadMore's
       positioned branch and the donor adoption sits ~40 lines BELOW it, so reveal() can run in the
       gap. Measured at 4x CPU: the refusal was stamped at 2553ms and the adoption completed inside
       the same 25ms sample. Requiring it here made the whole round depend on losing a race.
       So the arm trusts the LIFT's own identity (this module built the element and still owns it) and
       the adoption is checked where it actually matters -- if it never lands, the watchdog drops the
       lift, and a drop now collapses the overlay with it rather than stranding it. `sawMaster` keeps
       the answer on the record either way, so a row still says whether the viewer had settled. */
    if (!rec || !wrapEl || rec.armed) {
      if (rec && !rec.faded) {
        boomReceipt(rec, !wrapEl ? 'arm-nowrap' : 'arm-twice', -1, -1, 0);
      }
      return false;
    }
    rec.sawMaster = (sawEl === rec.master) ? 1 : 0;
    rec.armed = true;
    rec.landAt = Date.now();
    rec.wrap = wrapEl;
    /* HAND THE FLIGHT'S HOLD BACK NOW AND KEEP ONLY ITS PICTURE. `heroRelease`'s gate refuses to
       lift `hz-hold` while any `.pf-hero` is still attached, and `rova.css`'s `html.pfv-fly` rule
       (`body:has(.pf-hero)` until the invalidation-scope round -- see pfStillSync) freezes every feed
       Ken Burns pan -- both correct for a flight, both wrong for a 2-3s overlay. So the wrapper is
       RE-CLASSED here: the chrome reveal, the pan restart and the media opacity handback all happen on
       time (they are gated on the hold, not on this element), and what stays behind is a plain
       composited layer at z 210 with the boom still painting inside it.
       `__rovaHeroReset` sweeps `.pf-dsv` too, so a rapid close can never strand it.
       THE SYNC IS THE POINT OF THE RE-CLASS NOW, NOT A SIDE EFFECT OF IT: with the freeze driven by a
       class rather than by a live `:has()`, dropping `pf-hero` off this element no longer unfreezes the
       pan on its own -- the class has to be recomputed, or the re-class silently stops working and the
       feed stays frozen under the whole dissolve. */
    try { wrapEl.className = 'pf-dsv'; } catch (e) {}
    /* ...AND IT LEAVES THE FLIGHT'S PLANE IN THE SAME BREATH. The re-class above is what makes this a
       2-3s OVERLAY instead of a flight, and z 210 over the whole viewer is the one property of a
       flight that must not survive that change -- see boomSink's header for the owner's recording and
       the frame count. Sinking here, on the line that ends the flight, is the only place where the
       viewer card provably exists (reveal() found it) and the chrome has provably not been revealed
       yet (pf-settling comes off downstream of this call), so there is no frame in between. */
    rec.sunk = boomSink(wrapEl) ? 1 : 0;
    pfStillSync();
    /* WAKE ON THE MASTER'S OWN EVENTS, not only on the poll. Phase 1 waits for the element to become
       playable, and the landing is the busiest moment of the open -- MEASURED here, a 120ms poll was
       delivered at ~2s intervals under load, and every one of those lost seconds is window the master
       has climbed through and cannot get back. `canplay`/`playing` fire from the media pipeline the
       instant the state changes, so the lock is taken then and the poll is only the backstop. Both are
       one-shot; the poll's own `rec !== boomLift` guard makes a duplicate call harmless. */
    var wake = function () { if (rec === boomLift && !rec.faded && !rec.locked) { boomDecide(rec, null); } };
    try {
      rec.master.addEventListener('canplay', wake, { once: true });
      rec.master.addEventListener('playing', wake, { once: true });
      rec.master.addEventListener('loadeddata', wake, { once: true });
    } catch (e) {}
    /* ⚠ THE DEADLINE IS DRIVEN BY THE MASTER'S OWN CLOCK, NOT BY A TIMER, AND THIS IS THE ONE PIECE OF
       SCHEDULING IN THE ROUND THAT CANNOT BE DONE ANY OTHER WAY.
       WHAT IS BEING RACED. The handoff is content-exact only while the master's time is still inside the
       boom's [0, W]; that time climbs at rate 1, so the window is a COUNTDOWN and missing it is
       permanent -- the master never comes back.
       WHY EVERY TIMER LOST THE RACE, measured at 4x CPU on the landing (the busiest moment of the open):
       a 661ms setTimeout was delivered ~1.7s late, and `requestIdleCallback` may legitimately take its
       whole timeout on top. Three arrangements were tried and all three overshot -- aim once at
       `winLeft - 200`; halve the remaining window each wake (882/441/220); skip rIC for the deadline
       wake -- because all three measure the window in WALL time and then get scheduled in wall time by
       a thread that is not keeping wall time. The controller was simply never re-entered inside the
       window: `boom seeks=0`, `why:nowindow`, drift 2.1-4.4s, i.e. exactly the visible jump this round
       exists to remove, produced by the machinery meant to prevent it.
       `timeupdate` IS THE RIGHT INSTRUMENT because it is emitted BY the clock being raced. It cannot be
       late relative to that clock by more than its own cadence (~4/sec), so a 400ms mouth is always
       hit -- and when the pipeline stalls, the clock stalls with it and the deadline correctly stops
       approaching. It costs nothing: the handler is a subtraction, it only fires while the lift is
       armed, and it is removed with everything else at the fade.
       IT DOES NOT RELEASE ANYTHING BY ITSELF -- it calls the same boomDecide as every other path, so
       the alignment, the drift gate and the receipt are unchanged and there is one release path, not
       two. The timers stay as the backstop for an engine that emits no timeupdate. */
    /* THE MOUTH SELF-CALIBRATES TO THE CLOCK'S OWN STEP, and it has to. `timeupdate` is emitted ~4/sec
       on a healthy pipeline, so a 400ms mouth is comfortable -- but a STARVED one emits sparsely AND
       jumps: measured once at 4x, the clock went 1.219 -> 2.721 between two events, straight over a
       1.358s window, so the deadline branch was never reachable (`boom seeks=0`, `why:nowindow`,
       drift 1.56s). A fixed mouth cannot cover a step larger than itself.
       So the largest step this element has actually taken IS the margin, times a little. That is a
       measurement of the pipeline rather than a guess about it: a smooth clock keeps the full defer, and
       a lurching one hands over earlier -- which is the correct trade in the owner's own ranking, since
       he ranked "0 sync loss" above the length of the wait. Bounded at 1.5s so a single pathological
       step cannot collapse the defer to nothing for the rest of the open; past that the honest outcome
       is `nowindow`, and the receipt says so rather than pretending. */
    rec.onTick = function () {
      if (rec !== boomLift || rec.faded || !rec.locked) { return; }
      var mT = boomDrift(rec).mT;
      if (!(mT >= 0)) { return; }
      if (rec.lastMT >= 0) {
        var step = (mT - rec.lastMT) * 1000;
        if (step > (rec.stepMax || 0)) { rec.stepMax = step; }
      }
      rec.lastMT = mT;
      var margin = Math.max(400, Math.min(1500, (rec.stepMax || 0) * 1.6));
      var left = boomWindowLeftMs(rec, mT);
      if (left > 0 && left <= margin) { boomDecide(rec, null); }
    };
    rec.lastMT = -1;
    try { rec.master.addEventListener('timeupdate', rec.onTick); } catch (e) {}
    /* ⚠ A USER GESTURE ENDS THE DEFER, and it is deliberately not a scroll test.
       THE HAZARD IS REAL: for up to a few seconds there is a full-screen opaque layer above the viewer,
       and a member who swipes in that window would be looking at the PREVIOUS post's boomerang over the
       NEXT post's card. `pointer-events:none` keeps the swipe working, so the bug would be purely
       visual and would read as "the video didn't change" -- the class of report that costs a week.
       TWO LAYOUT TESTS WERE TRIED AND BOTH MISFIRED ON EVERY OPEN, which is why this one is a gesture:
         - "is the centred ELEMENT still my master": no, and legitimately so. reveal() can run BEFORE
           loadMore's donor adoption (the `rova:pfeedready` dispatch is at the TOP of that branch and
           the adoption ~40 lines below it), so the centred media is the card's own placeholder at the
           landing and the lift's master a moment later.
         - "is the centred POST still my post": also no. Measured seenPid 42651 against pid 43079,
           persistently, 2.5s after a landing that had adopted correctly and was never swiped -- the
           deck's geometry puts a neighbour's rect over the viewport centre on a normal open. A 220ms
           debounce did not help, because the condition was not transient.
       Both were inferring INTENT from LAYOUT. A TOUCH IS THE INTENT: the open's own scrollIntoView
       produces no touchstart, no wheel and no key, so this cannot fire on a settle; and a member who
       has actually started interacting gets the handoff now rather than an overlay they might swipe
       under. It goes through boomTake first, so an interrupted defer is still an ALIGNED handoff. */
    rec.onGesture = function () {
      if (rec.faded || rec !== boomLift) { return; }
      var since = Date.now() - rec.landAt;
      if (!boomTake(rec, 'gesture', since)) { boomFade(rec, 'gesture', boomDrift(rec).d, since); }
    };
    try {
      document.addEventListener('touchstart', rec.onGesture, { capture: true, passive: true });
      document.addEventListener('wheel', rec.onGesture, { capture: true, passive: true });
      document.addEventListener('keydown', rec.onGesture, true);
    } catch (e) {}
    boomDecide(rec, null);
    return true;
  }
  window.__rovaBoomArm = boomArmRelease;
  /* THE HARNESS SEAM. `__rovaBoomLast` carries the finished verdict; this carries the LIVE one, so
     a throttled run can assert "audio decoding before the fade" and "both clocks inside a frame at
     the fade instant" without racing the receipt POST. Read-only, allocation-cheap, and it answers
     null when no lift is up -- which is itself the assertion for a non-boomerang open. */
  window.__rovaBoomProbe = function () {
    var rec = boomLift; if (!rec) { return null; }
    var dr = boomDrift(rec);
    return { pid: rec.pid, pos: rec.pos, m: rec.m, dir: rec.dir, dur: rec.dur, w: rec.w,
      mirrored: rec.mirrored, relocks: rec.relocks, runway: rec.runway,
      liftAt: rec.liftAt, landAt: rec.landAt, deadline: rec.deadline,
      locked: rec.locked ? 1 : 0, lockAt: rec.lockAt || 0, lockT: rec.lockT || 0,
      decideN: rec.decideN || 0, repumps: rec.repumps || 0,
      waitWhy: rec.waitWhy || '', capMs: boomCapMs(rec),
      armed: rec.armed, adopted: rec.adopted, faded: rec.faded, voice: rec.voice,
      masterT: dr.mT, boomT: dr.bT, drift: dr.d, decoding: boomDecoding(rec),
      /* READINESS, NOT JUST THE CLOCK. A master whose clock is frozen is either buffering or
         broken, and those two are a different fix each -- readyState/networkState/error are the
         three fields that separate them, and without them "the picture never came" is unfalsifiable
         on a device nobody here has. Same reasoning as the vflight record's `rs`/`buf` columns. */
      rs: (function () { try { return rec.master.readyState; } catch (e) { return -1; } })(),
      ns: (function () { try { return rec.master.networkState; } catch (e) { return -1; } })(),
      err: (function () { try { return rec.master.error ? rec.master.error.code : 0; } catch (e) { return -1; } })(),
      playErr: rec.playErr || '',
      paused: (function () { try { return !!rec.master.paused; } catch (e) { return null; } })(),
      muted: (function () { try { return !!rec.master.muted; } catch (e) { return null; } })(),
      bytes: (function () { try { return rec.master.webkitAudioDecodedByteCount || 0; } catch (e) { return -1; } })(),
      wrapOp: (function () { try { return rec.wrap ? (rec.wrap.style.opacity || '1') : null; } catch (e) { return null; } })() };
  };

  /* `predDims` ({w,h}, optional): the LANDED image's natural dims, when the caller knows the viewer
     will paint a DIFFERENT file than the one being flown (owner, 2026-08-29, @Anita_fdez: "stuttery
     moves and small crop animations"). The profile avatar is the SQUARE crop (640x640) while the
     avatar post paints the pre-crop ORIGINAL's display variant (e.g. 810x1440 portrait) -- so a
     prediction from srcImg.naturalWidth/Height flies to a square box, and the flight then re-aims
     mid-tween to the portrait rect the moment the real image lays out (landTarget's paintedRectOf),
     which is exactly the visible stutter. With the destination's dims supplied, the SAME shared fit
     verdict + landing math produce the box the viewer will actually paint, first try, and the re-aim
     machinery finds nothing to correct (drift < 3px = flyRetarget no-op). Every existing caller
     passes nothing and is byte-identical in behaviour.
     `predDims.src` (optional): the landed FILE, so the flight carries the destination's pixels rather
     than the tapped bitmap's -- see the block in the <img> branch below.
     `predDims.video` / `predDims.el` (optional, 2026-08-30): the declaration's KIND and the node it
     came from. A declaration that carries the size but not the kind is only half a declaration -- the
     landing prediction picks __rovaPhotoCovers or __rovaVideoCovers off `video`, and reads the
     data-fit hint off `el`, so a still flown FOR a clip (the fullscreen button's paused branch) is
     predicted with the same rule the viewer will paint it with. */
  /* ---- THE TAPPED NODE DECLARES ITS OWN LANDING, AND THAT IS WHY THIS IS NOT ANOTHER PATCH -------
     (2026-08-30, the owner's grid recording: "works good from timeline but grid opens are buggy".)

     predDims above was added for ONE caller -- the profile-avatar tap -- as an argument that caller
     remembers to pass. Every other opener kept predicting from the bitmap it happened to be holding,
     which is right only while the tapped bitmap IS the picture the viewer will open. For an AVATAR
     POST it never was: both grids paint the 480px SQUARE crop while views/_post.php opens the
     pre-crop original, so a 719x1344 portrait flew as a 1:1 square and cover-filled the phone at
     2.17x -- a face magnified past the viewport for the whole 400ms, then corrected by the hand-off.
     The profile avatar was immune purely because it was the one site that had been told.

     So the declaration moves OFF the argument list and ONTO THE NODE. views/_feed_grid.php and
     views/_profile_posts.php stamp data-photo-dims/data-photo-src (the same pair views/profile.php
     has carried on .pf-avatar since 2026-08-29, resolved by the same Upload::landedPhoto() body)
     whenever the tile's bitmap is a different picture from the landing. heroExpand reads it here, so
     EVERY caller that hands over the tapped node -- the home mosaic, the profile grid, and any grid
     a later round adds, since they all render through those two views -- inherits the truth without
     knowing this exists. An explicit predDims still wins: a caller that knows more than the markup
     is not overruled by it.

     WHY THE NODE AND NOT A FETCH: this runs inside the tap gesture, before any layout write, and it
     must answer synchronously or the flight starts on a guess. An attribute is the only source that
     is already there. */
  function declaredLanding(el) {
    try {
      var n = (el && el.closest) ? (el.closest('[data-photo-dims]') || el) : el;
      if (!n || !n.getAttribute) { return undefined; }
      var m = (n.getAttribute('data-photo-dims') || '').match(/^(\d+)x(\d+)$/);
      if (!m) { return undefined; }
      var w = +m[1], h = +m[2];
      if (!(w > 0 && h > 0)) { return undefined; }
      var pd = { w: w, h: h };
      var s = n.getAttribute('data-photo-src') || '';
      if (s) { pd.src = s; }
      var mi = n.getAttribute('data-photo-mid') || '';   // shape-correct intermediate, when a surface declares one
      if (mi) { pd.mid = mi; }
      return pd;
    } catch (e) { return undefined; }
  }
  window.__rovaDeclaredLanding = declaredLanding;   // the gate reads this to prove a surface declares
  function heroExpand(tileRect, src, liveVideo, srcImg, predDims) {
    if (!tileRect || tileRect.width < 4 || tileRect.height < 4) return false;
    /* NEVER FLY PIXELS THAT ONLY CSS WAS BLURRING (2026-10-02). The clone below is a bare <img> of the
       bitmap: any blur that lived in a class (.nsfw-gate veil, a .nsfw-cell avatar/tile drawn from the
       real file) does not come with it, so the flight would show the picture unblurred for its whole
       length. Server-blurred stills (.av-sb avatars, .nsfw-locked previews) are safe to fly. */
    try {
      if (liveVideo && liveVideo.closest && liveVideo.closest('.nsfw-gate:not(.nsfw-locked), .nsfw-cell:not(.nsfw-locked)')) { return false; }
      if (srcImg && srcImg.closest && (srcImg.closest('.nsfw-gate:not(.nsfw-locked)')
          || (srcImg.closest('.nsfw-cell') && !srcImg.closest('.nsfw-cell.av-sb, .nsfw-locked')))) { return false; }
    } catch (e) {}
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
    // see declaredLanding above -- an explicit predDims always wins, the markup only fills a silence
    if (!predDims && srcImg) { predDims = declaredLanding(srcImg); }
    /* READ BEFORE WRITE, AND THIS IS THE FIRST STATEMENT FOR A REASON. Every layout number this
       function's PREDICTION needs is taken here, while the tree is still as the last frame left it;
       everything below writes. See pfLandBoxPrime for the 181ms this is worth and for why the values
       are provably the same ones an unhoisted read would return.
       IT IS NOT BEFORE THE SOUND GRANT: the in-gesture grant is claimed by the tap handler that CALLS
       this, so it is already spent by the time we get here -- this is the first thing in heroExpand,
       not the first thing in the gesture, and the grant's ordering is untouched. */
    pfLandBoxPrime();
    // the OPEN gets the same claim on the main thread the dismiss now takes (see __rovaFlightHold): the
    // open is longer -- the tween plus the viewer's own fetch, card render and donor adoption
    if (window.__rovaFlightHold) { window.__rovaFlightHold(1100); }
    var isVideoHero = !!(liveVideo && liveVideo.tagName === 'VIDEO');
    var el;
    if (isVideoHero) {
      el = liveVideo;
      /* THE LIFT-OFF IS DEFERRED TOO (2026-09-27, see flyCrop's deferMove): a timeline card's clip flown by
         the fullscreen button stays in its card, untouched, while its snapshot twin takes off; it joins the
         flight two frames later (flyAdopt runs onAdopt, which does what these lines used to). The tap task
         builds the whole viewer -- the stall a same-task move would show as a black card. */
      var _liftDefer = !!(window.__rovaFsBorrow && window.__rovaFsBorrow.video === el && el.videoWidth > 0
                          && el.isConnected && el.closest && el.closest('.post') && !el.closest('.pfeed'));
      if (!_liftDefer) { el.className = 'pf-hero'; el.removeAttribute('width'); el.removeAttribute('height'); }
      else { el._liftDeferred = 1; }
      if (el._grReveal) { el.removeEventListener('loadeddata', el._grReveal); el.removeEventListener('playing', el._grReveal); el._grReveal = null; }
    } else {
      if (!src) return false;
      el = document.createElement('img'); el.src = src; el.alt = ''; el.decoding = 'async'; el.className = 'pf-hero';
      /* FLY THE DESTINATION'S PIXELS when the caller supplied them (predDims.src -- the avatar tap,
         see the parameter note above). The box fix alone left the CONTENT wrong: the square crop
         cover-filled the portrait box as a 2.25x-magnified slice, and the swap to the real portrait
         at handoff read as a visible correction ("zooming into the 640 then correcting to the 810").
         The landed file is byte-warmed on pointerdown, so it is usually decoded before this line
         runs; while it is not, the SQUARE stays visible as a cover-sized CSS background on the same
         element -- the browser draws the background until the <img>'s own content arrives, so there
         is never a blank frame, and the moment the portrait decodes it replaces the square in place
         at the already-correct geometry. */
      if (predDims && predDims.src && predDims.src !== src) {
        var _pw = window.__rovaPfaWarm;
        var _warmImg = (_pw && _pw.src === predDims.src && _pw.img) ? _pw.img : null;
        /* DECODED, NOT MERELY LOADED (2026-09-12). `complete && naturalWidth` says the bytes are in;
           on WebKit that is not a raster, and an <img> handed a rasterless file paints NOTHING for
           its first frames -- the same class as pfDecoded's black flash, on the flight's first
           frame. pfDecoded() answers true only once decode() has resolved (the idle/intent warm in
           the profile block asks it the moment the bytes land, so a warm destination is already a
           yes here); otherwise it starts the decode and this open takes the stand-in branch, whose
           swap fires on that same decode -- nothing is lost, and no empty frame is ever flown. */
        if (_warmImg && _warmImg.complete && _warmImg.naturalWidth > 0 && pfDecoded(_warmImg)) {
          el.src = predDims.src;
          el._pfBgSquare = 'url("' + src.replace(/"/g, '%22') + '") center/cover no-repeat';
        } else {
          /* DESTINATION NOT DECODED YET (first-ever open / slow line). The old shape set el.src to
             the cold file regardless and leaned on the square as a CSS background for the gap --
             but iOS Safari paints NOTHING for an <img> whose own content hasn't arrived, background
             included, so the whole flight was invisible and the open read as a hard cut to the
             viewer shell's black + spinner (owner, 2026-08-29, the clarissabuggs28 recording:
             "the whole screen going black during opening a photo is horrible"). So fly the SQUARE
             -- it is the tile's own bitmap, already decoded and painted on the page, guaranteed
             pixels from frame one -- and swap the destination in AT THE SAME GEOMETRY the moment
             it decodes (usually mid-flight; the box was aimed with predDims, so only the content
             sharpens, nothing moves). el.src is already `src` from creation above.
             ...AND "ONLY THE CONTENT SHARPENS, NOTHING MOVES" WAS FALSE, WHICH IS THE WHOLE OF THE
             2026-09-09 REPORT ("cold opening a profile photo lands stretched out then it fixes; after
             subsequent opens it looks perfect"). The box was aimed with predDims -- the PORTRAIT -- while
             the bitmap in flight is the SQUARE avatar crop, and flyCrop draws the flown media
             object-fit:FILL into an aspect-exact box on the premise that the box aspect IS the bitmap's
             (read its intrinsic-size header). A stand-in of a different shape breaks that premise and is
             stretched from frame 0 to the hand-off. MEASURED, cold context, @potamusprime (480x480 crop,
             810x1440 declared landing): drawn box 451.8x803.3 holding a 1:1 bitmap = 0.5625 -- the picture
             squeezed to 56% of its width -- for the WHOLE flight, 325ms, while the warm second open of the
             same photo measured 0.9968. So the stand-in is marked, and flyCrop draws a MARKED media
             object-fit:cover: an undistorted centre-crop of the square into the same box. Cover and fill
             are identical once the aspects agree, so nothing else on any surface changes.
             SWAP ON decode(), NOT load. `load` says the bytes are in; assigning el.src to an image with no
             raster hands iOS Safari an <img> it paints NOTHING for -- mid-flight, that is the same black
             frame pfDecoded exists to stop, introduced by the very statement meant to fix the picture. */
          /* THE LARGEST DECODED BITMAP OF THE RIGHT SHAPE (2026-09-12). The square crop is a
             DIFFERENT PICTURE from the landing (a sub-window of the original, usually top-anchored --
             see avatar-list-variant.md 09-08), so cover-cropping it into the portrait box shows a
             different framing than the file that replaces it. When the page declared a shape-correct
             intermediate (data-photo-mid: the pre-crop original's 480-wide _t480, warmed at idle on
             a slow line) and it has DECODED, fly that instead: same picture, same framing, only the
             resolution sharpens at the swap. Same `cover` draw, and cover == fill once the shapes
             agree, so nothing else changes. Not decoded -> the square, exactly as before. */
          var _midImg = (_pw && predDims.mid && _pw.mid === predDims.mid && _pw.midImg) ? _pw.midImg : null;
          if (_midImg && _midImg.complete && _midImg.naturalWidth > 0 && pfDecoded(_midImg)) { el.src = predDims.mid; }
          el._pfStandIn = 1;
          var _dst = _warmImg || new Image();
          if (!_warmImg) { _dst.decoding = 'async'; _dst.src = predDims.src; }
          var _pfSwap = function () {
            if (!(_dst.naturalWidth > 0)) { return; }
            el.src = predDims.src;
            el._pfStandIn = 0;
            // the box was always the destination's shape: now that the bitmap agrees, fill it exactly
            try { el.style.objectFit = 'fill'; } catch (e) {}
          };
          var _pfArm = function () {
            if (!(_dst.naturalWidth > 0)) { return; }
            if (_dst.decode) { _dst.decode().then(_pfSwap, _pfSwap); } else { _pfSwap(); }
          };
          if (_dst.complete) { _pfArm(); }
          else { _dst.addEventListener('load', _pfArm, { once: true }); }
        }
      }
    }
    // A PHOTO hero flies transparent: the tile it lifts off is the SAME image, so a late decode shows the
    // identical grid tile through it, never a black box. A video hero keeps a black backing (a frame gap
    // should read black, not punch a hole to the page). This kills the "flashes to black" on a photo tap.
    /* THE VIDEO HERO'S '#000' WAS RE-EXAMINED ON 2026-08-30 AND DELIBERATELY KEPT, after the owner's
       second black-flash report ("swiping to a video on web and it flashes to black") put every black
       surface under suspicion. It is not one of them, and the reason is upstream of this line:
       `isVideoHero` is only true when the caller handed over a LIVE element, and the only caller that
       does (the grid tap's `liveHero` branch) requires `readyState >= 2 && videoWidth > 0 && !paused &&
       currentTime > 0.03` first -- i.e. the adopted <video> is already decoding and painting frames
       before it is ever flown. Every other video open passes a STILL (videoFrameSrc(zVid) || the
       poster) as `src` with liveVideo null, so isVideoHero is false and that flight is TRANSPARENT.
       So this black can only ever sit behind an element that is provably painting; there is no gap for
       it to show through, and the hole it guards -- a dropped frame punching through to the page
       underneath -- is real. Changing it would trade a hazard that cannot occur for one that can.
       If a future caller ever adopts a video WITHOUT that readyState gate, this line becomes a black
       flash and the gate to notice it is tools/video-black-check.js. Note the coupling immediately
       below, too: adopting the element strips its `_grReveal` decode gate, which is only safe for the
       same reason. */
    var kb = !isVideoHero ? liveKbRead(srcImg) : null;
    var liftFixed = function () {
    el.style.cssText = 'position:fixed;margin:0;object-fit:cover;z-index:210;background:' + (isVideoHero ? '#000' : (el._pfBgSquare || 'transparent')) + ';pointer-events:none;'
      + 'left:' + tileRect.left + 'px;top:' + tileRect.top + 'px;width:' + tileRect.width + 'px;height:' + tileRect.height + 'px;'
      + 'opacity:1;transition:none;will-change:left,top,width,height,opacity;'
      + '-webkit-backface-visibility:hidden;backface-visibility:hidden;'
      + (kb ? 'scale:' + kb.scale + ';translate:' + kb.translate + ';' : '');
    document.body.appendChild(el);
    pfStillSync();                   // bare .pf-hero clone (heroExpand) -> html.pfv-fly
    };
    if (!_liftDefer) { liftFixed(); }
    liveKbSeed(el, kb);
    /* THE FLOWN CLIP KEEPS ITS VOICE (Rob 2026-09-26, feed video -> fullscreen button: "there's parts in
       the zooming in and zooming out/closing where the audio is cut out for a second and I actually see
       the speaker icon unmute"). This line muted the live hero unconditionally, and the open's hold
       (pfVoiceHold) then kept everything silent until the viewer SETTLED -- measured 840ms of silence on
       the open, from the tap to the chrome reveal. For the fullscreen button the flown element IS the
       clip the reader was listening to and IS the element the viewer adopts (reveal's replaceChild), so
       there is nothing to wait for: it is designated the open's voice (soundVoiceArm, inside the tap's
       own click) and keeps playing unmuted through the flight. The designation is what keeps ONE VOICE:
       applySound hands the sound to it and mutes every other clip -- the viewer's placeholder for the
       same post included -- until pfVoiceReady releases it onto the very same element.
       soundVoiceArm refuses when the reader's intent is muted, and then this is the old mute, byte for
       byte. A GRID tile never reaches it (no __rovaFsBorrow; its tile plays the silent _grid480). */
    var _fsVoice = false;
    if (isVideoHero && window.__rovaFsBorrow && window.__rovaFsBorrow.video === el && window.__rovaSoundVoiceArm) {
      try { _fsVoice = !!window.__rovaSoundVoiceArm(el); } catch (e) { _fsVoice = false; }
    }
    if (isVideoHero) { if (!_fsVoice) { el._progMuteAt = Date.now(); el.muted = true; } el.loop = true; el.playsInline = true; var _hp = el.play && el.play(); if (_hp && _hp.catch) { _hp.catch(function () {}); } }
    document.documentElement.classList.add('hz-hold'); heroHolds++;
    var myGen = heroGen;   // rapid open/close: a reset bumps heroGen -> this flight's closures self-cancel
    var born = Date.now(), done = false, expanded = false, expandStart = 0;
    // OPEN = the exact REVERSE of the buttery dismiss (owner): for a LIVE-video hero, grow IMMEDIATELY from the
    // tile to the pfeed's PREDICTED landed rect (no waiting on the async card to render + measure), same
    // box-resize + easing + duration as close(). The pump below then only gates the handoff on the card existing.
    // COMPOSITED FLIGHT: wrap the media in a flyCrop crop-window and animate transforms only (the exact
    // cover-morph the box-resize gave, minus the per-frame main-thread layout). The wrapper carries the
    // .pf-hero class (reset/gates key off it); the media itself flies class-less inside it.
    var wrap = null;
    var flightMs = 0, landPred = null, landAims = 0, landPostFix = 0, landPredVh = 0;
    /* ---- ONE INTRINSIC SIZE PER FLIGHT, AND THE BOX CANNOT BE COMPUTED WITHOUT STAMPING IT --------
       (2026-08-30, the @trenchwurk flyer open.) A flight has TWO halves that must agree about the
       media's shape: WHERE it lands (pfeedLandRect, which takes nw/nh and the fit hint) and WHAT
       ASPECT IS DRAWN on the way (flyCrop's iw/ih -- see the long note at the top of that function
       for why those are not a hint but the picture itself). They used to come from two independent
       sources: this function fed pfeedLandRect the dims it had in hand, while flyCrop re-derived its
       own from the flown clone -- which has never decoded at that instant, because it is created and
       flown in the SAME task -- and so silently fell back to the TILE BOX on every open. On the post
       that produced the report the two answers were 73% apart.

       `landRect` is the only way out of this scope to a landing box, and it stamps flyIW/flyIH with
       the very numbers it predicted from. That is the fix being STRUCTURAL rather than one more
       argument passed in one more place: a future call site cannot obtain a box without also
       declaring the aspect the picture will be drawn at, because it is the same call. If it ever
       needs a third consumer, that consumer reads flyIW/flyIH too -- it does not re-derive.
       (Same shape as "THE ONE PHOTO FIT VERDICT" further down: not three places agreeing, one place.) */
    var flyIW = 0, flyIH = 0, flyOY = 0;
    function landRect(nw, nh, photo, hint) {
      if (nw > 0 && nh > 0) { flyIW = nw; flyIH = nh; }
      var r = pfeedLandRect(nw, nh, photo, hint);
      // ...AND THE CROP, for exactly the reason above (2026-09-14). A landing box obtained WITHOUT
      // the bias it will be painted with is the same class of half-declaration flyIW/flyIH fixed:
      // the flight would fly to the right window and draw the wrong part of the picture in it.
      flyOY = (r && r.oy) || 0;
      return r;
    }
    /* ---- THE DEPARTURE PAGE MAY NOT BLINK OFF MID-ZOOM  (2026-09-13) -----------------------------
       `.pfeed.pf-settling:not(.pf-hasmedia)` is the translucent scrim that keeps the page you came
       from visible, dimmed, while the picture grows (the 2026-08-29 "never a hard black screen"
       round). `pf-hasmedia` ends it -- and because `html.hz-hold .pfeed.show` carries
       `transition:none`, ending it is a ONE-FRAME cut. Measured on the owner's 2026-09-12 recording:
       at 1250ms the grid, the header and the App-Store banner are all on screen at 45% (= 1 - the
       scrim's .55, which is how the layer was identified); at 1267ms, the very next frame, the whole
       page is gone. Nothing moved and nothing faded; a third of the screen simply changed state.
       That is one of the "flickerings", and it is not an ordering bug -- the stamp is at the right
       MOMENT, it just has no duration.
       So the backdrop gets the flight's own duration and an ease-IN curve, which is the web
       statement of the rule PostScreen already follows natively: THE BACKDROP MAY NEVER DARKEN
       FASTER THAN THE MEDIA COVERS THE SCREEN. It starts on the scrim (one painted frame first, or
       a transition has nothing to run from) and reaches opaque exactly as the picture reaches its
       landing rect -- so the page dissolves UNDER a growing photo instead of being switched off
       behind it, and the later stamps (reveal, painted(), heroRelease, the 800ms backstop) all
       become the no-ops they were always meant to be on a flight that works. */
    function pfBackdropRamp(ms) {
      var tries = 0, armed = 0;
      (function apply() {
        if (done || myGen !== heroGen) { return; }
        var pfv = document.querySelector('.pfeed');
        if (!pfv) { if (++tries < 40) { requestAnimationFrame(apply); } return; }
        /* ARM THE TRANSITION FIRST, AND WITHOUT WAITING FOR ANYTHING (2026-09-13, measured twice).
           FOUR sites stamp pf-hasmedia -- this ramp, the pfeedready tick's painted(), reveal(), and
           heroRelease's catch-all -- and whichever wins, the element must ALREADY carry the
           transition or that stamp is the snap. The first cut of this function waited for `.show`
           before adding either class and then declined if pf-hasmedia had appeared in the meantime,
           which is a race it loses: WebKit rig, the backdrop measured a=0.792 at 169ms and a=1 with
           `transition-duration: 0s` at 354ms, `.pf-flight` never added, i.e. exactly the snap the
           function exists to remove. Arming is idempotent, costs one class, and is safe on a viewer
           that never opens (the timer below takes it off again). */
        if (!armed) {
          armed = 1;
          try {
            pfv.style.setProperty('--pf-fly-ms', Math.max(220, Math.round(ms)) + 'ms');
            pfv.classList.add('pf-flight');
            /* AND IT COMES OFF WHEN THE RAMP IS OVER, NOT WHEN THE HOLD LIFTS. While it is on it
               REPLACES .pfeed's transition list (background-color only), which is right for the ramp
               and wrong for the swipe-dismiss and the close fade that list also carries. */
            setTimeout(function () { try { pfv.classList.remove('pf-flight'); } catch (e) {} }, Math.round(ms) + 700);
          } catch (e) {}
        }
        /* ...AND THE STAMP STILL WAITS FOR `.show` TO HAVE PAINTED. The opener adds `pf-settling`
           synchronously and `.show` in its own rAF, AFTER this function, so "pf-settling is on" can
           be true while the viewer is still opacity:0/visibility:hidden -- and a transition on an
           element whose first painted frame is already the end state is not a transition. Measured
           without this wait: worst one-frame background drop 0.056 -> 0.235, the ramp making the snap
           three times worse. Two frames, then stamp. */
        if (pfv.classList.contains('show')) {
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              if (myGen !== heroGen) { return; }
              try { pfv.classList.add('pf-hasmedia'); } catch (e) {}
            });
          });
          return;
        }
        if (++tries < 40) { requestAnimationFrame(apply); }
      })();
    }
    function startFlight(target, ms, easeFn) {
      if (wrap || done) { return; }
      expanded = true; expandStart = Date.now(); flightMs = ms;
      pfBackdropRamp(ms);
      landPred = { left: target.left, top: target.top, width: target.width, height: target.height };
      // WHICH VIEWPORT FRAME this bake is centred in. When the cache is in force that is the SETTLED
      // (shorter) height, while the live viewport is still the tall one -- see landAimOn's bet gate.
      landPredVh = Math.round(pfLandVh());
      if (!_liftDefer) { el.className = ''; }
      var sinkHost = flightBox();
      wrap = flyCrop(el, tileRect, target, {
        deferMove: !!_liftDefer,
        onAdopt: _liftDefer ? function () { el._liftDeferred = 0; el.className = ''; el.removeAttribute('width'); el.removeAttribute('height'); } : null,
        ms: ms, ease: easeFn, cls: 'pf-hero', z: sinkHost ? 1 : 210, park: 'to',   // park at the big landed rect (crisp raster)
        host: sinkHost,
        bg: isVideoHero ? '#000' : 'transparent',
        // the dims THIS flight predicted its landing box from -- never the clone's own (undecoded on
        // iOS at this instant) and never the tile's. See landRect above.
        iw: flyIW, ih: flyIH,
        // ...and the crop that box will be PAINTED with (--pf-pany). Same declaration, same call.
        // From the CENTRED crop the tile/card is painting right now, to the viewer's biased one.
        oyFrom: 0, oyTo: flyOY
      });
      if (sinkHost && wrap) {
        /* THE GEOMETRY GUARD. `.pfeed` is position:fixed/inset:0 with no transform on an open, so it is
           not a containing block for the fixed wrapper -- but that is a claim about CSS (a swipe-dismiss
           can leave a transform behind until the opener clears it); this is the measurement. Frame 0 of
           a flight is the tile rect, exactly -- if the wrapper is anywhere else, the flight goes back to
           <body> at 210, the old path, before a single frame of the wrong one is painted. (Re-inserting
           restarts the keyframes; nothing has been drawn yet, so that is the same flight.) */
        var r0 = null;
        try { r0 = wrap.getBoundingClientRect(); } catch (e) { r0 = null; }
        var off = !r0 || Math.abs(r0.left - tileRect.left) > 2 || Math.abs(r0.top - tileRect.top) > 2
                || Math.abs(r0.width - tileRect.width) > 2 || Math.abs(r0.height - tileRect.height) > 2;
        if (off) {
          try { wrap.style.zIndex = '210'; document.body.appendChild(wrap); } catch (e) {}
        } else {
          wrap._flyT0 = Date.now(); wrap._flyMs = ms;   // read by the viewer's chrome reveal (pfChromeIn)
          try { document.dispatchEvent(new CustomEvent('rova:heroflight')); } catch (e) {}
        }
      }
      landAimOn();
    }
    /* ═══ THE FLIGHT FLIES UNDER THE CHROME  (2026-09-24, two rounds) ═══════════════════════════════
       Owner, with a desktop recording of a grid photo open: "the chrome needs to load faster so it
       lands with the media on top of it, this looks poorly coded (Loading the media full screen then
       taking a second to load the chrome doesn't look good)". Measured headless at 1710x1100: flight
       lands ~455ms, chrome appeared 660-740ms -- after the picture, as he saw.
       WHY THE CHROME WAITED FOR THE LANDING. The flight wrapper was a <body> child at z 210 and the
       viewer is `.pfeed` at z 205, a stacking context holding every piece of chrome -- so any chrome
       shown during the flight painted BEHIND the growing picture and jumped in FRONT of it at the landing
       (the 2026-08-09 music-card flicker). Hiding the chrome until the flight was over was the only
       order-safe answer while the flight lived above the whole viewer.
       ROUND 1 moved the flight into the target card MID-FLIGHT, once the card existed (~100-150ms after
       the tap). Owner, the same day: "Now it looks laggy on the zoom animation and the chrome still takes
       too long to load, it should be instantly attached with the media zooming loading behind it". A move
       is a remove + insert: the wrapper's layer is torn down and re-rastered and its CSS animations
       restart as PENDING -- a hitch in the middle of the zoom, on every open. And the chrome faded over
       the whole remaining flight, so it was fully up only as the picture landed.
       ROUND 2: THE FLIGHT IS BORN IN THE VIEWER AND NEVER MOVES IN THE AIR. `.pfeed` itself is the host
       -- it exists before the tap (pfPrebuild builds the shell at idle) and the opener's rAF shows it
       before the first frame after the tap is painted (hz-hold makes that `opacity:1` with no transition),
       so the wrapper is on screen from frame 0. At z 1 in `.pfeed`'s context it is above every card's
       background and media (z 0/auto) and below the chrome: the top bar (z 12) and the target card's
       overlays (z 2 -- the target is `.pf-cvon`, content-visibility:visible, so it opens no stacking
       context of its own; see the loader's pf-cvon stamp). The chrome is therefore revealed the moment
       the target card is laid out, in one short fade (pfChromeIn, pfeed IIFE), with the picture still
       zooming underneath. At the landing boomSink pins it and sinks it into the card, as it always has.
       No `.pfeed` yet (a tap that beat the idle prebuild) -> <body> at 210 and the old sequence. */
    function flightBox() {
      if (window.__rovaFlyBody) { return null; }   // A/B kill switch for a harness: the old <body> flight
      try { return document.querySelector('.pfeed') || null; } catch (e) { return null; }
    }
    /* ---- THE FLIGHT RE-AIMS ITSELF, MID-TWEEN (2026-08-17) ----------------------------------------
       OWNER'S RULE: the image lands ONCE, correctly. No post-landing correction, ever.

       reveal() has corrected a late viewport shift since the "lands slightly off when the url bar
       minimizes" round -- but it corrects at the HANDOFF, which for a photo is gated on `>= 380ms`,
       i.e. after a 400ms tween has visually finished. His recording is that gap: the tween settles at
       ~1.98s, a separate 117ms motion lifts the photo 20px at ~2.0-2.1s. Correct and visible is still
       a nudge.

       So the tween re-aims the moment the ground moves, with the time it has LEFT: the bar expands
       within ~2 frames of the tap, so a 400ms flight absorbs the whole 40px with 340ms still to run and
       the reader sees one continuous arrival. flyRetarget already does exactly this (it pins the current
       composited state and transitions on from there) -- it was only ever called too late. `landPostFix`
       records whether anything was still owed AFTER the tween: the receipt asserts it stays 0. */
    function landTarget() {
      var pf = document.querySelector('.pfeed.show');
      var mm = pf ? pfCenteredMedia(pf) : null;
      if (mm && mm.el && mm.box) {
        try {
          if (isVideoHero && el.videoWidth > 0) { return cardDrawnRect(mm.box, el.videoWidth, el.videoHeight, mm.el); }
          if (mm.el.tagName === 'VIDEO' && mm.el.videoWidth > 0) { return cardDrawnRect(mm.box, mm.el.videoWidth, mm.el.videoHeight, mm.el); }
          if (mm.el.complete && mm.el.naturalWidth > 0 && mm.el._pfFitDone) { return paintedRectOf(mm.el, mm.box); }
        } catch (e) {}
      }
      // No laid-out destination yet: re-run the PREDICTION against the LIVE viewport (pfLandLive -- see
      // pfLandVh: a re-aim is a measurement, not a guess, so it must never re-consult the cached guess).
      // Same body, same fit verdict; only the box it centres in has changed.
      pfLandLive++;
      try {
        if (isVideoHero && el.videoWidth > 0) { return landRect(el.videoWidth, el.videoHeight, false, window.__rovaFitHint(el, srcImg)); }
        // the caller-supplied LANDED dims outrank the flown thumb's -- see predDims at the top.
        // `predDims.video` says the still being flown is a CLIP's frame, so the prediction asks the
        // video verdict rather than the photo one -- see the note on the twin below.
        if (!isVideoHero && predDims && predDims.w > 0 && predDims.h > 0) {
          return landRect(predDims.w, predDims.h, !predDims.video, window.__rovaFitHint(predDims.el, srcImg));
        }
        if (!isVideoHero && srcImg && srcImg.naturalWidth > 0 && srcImg.naturalHeight > 0) {
          return landRect(srcImg.naturalWidth, srcImg.naturalHeight, true, window.__rovaFitHint(srcImg));
        }
      } catch (e) {} finally { pfLandLive--; }
      return null;
    }
    // TWICE per shift, on purpose: once in the resize task (fastest possible re-aim) and once on the
    // next frame, because an engine may fire visualViewport's resize BEFORE the dvh-sized destination
    // has been re-laid-out -- an aim taken there would chase the old box. flyRetarget is idempotent
    // (drift < 3px returns 0), so the second call costs nothing when the first was already right.
    var landAimNow = function () {
      if (done || myGen !== heroGen || !wrap) { return; }
      var t = landTarget(); if (!t) { return; }
      var over = Date.now() - expandStart, left = flightMs - over;
      // Inside the tween: spend what is LEFT of it (floor 90ms so a very late shift still eases rather
      // than snaps). Past it, the tween is over and this WOULD be the correction the rule forbids -- do
      // it anyway (wrong beats visibly wrong forever) but MARK it so a row proves it happened.
      // MARK ONLY WHAT MOVED: flyRetarget answers 0 when the drift is under 3px, and a viewport shift
      // that arrives late but needs no correction is not a nudge. Stamping `post` on the call rather
      // than on the applied change reported a violation on every exact landing that happened to be
      // followed by a settling bar (measured: open 2 of the two-open loop, dy 0 and post 25).
      if (flyRetarget(wrap, t, Math.max(90, Math.min(flightMs, left)))) {
        landAims++;
        if (over > flightMs) { landPostFix = Math.max(landPostFix, Math.round(over - flightMs)); }
      }
    };
    var landAim = function () { landAimNow(); requestAnimationFrame(landAimNow); };
    /* ONE SCHEDULED AIM, at ~35% of the tween, in ADDITION to the event-driven ones. The events cover a
       viewport that MOVES; this covers a prediction that was wrong about a viewport that DIDN'T. The
       cached settled height is a bet that the bar will come back on the lock -- true on WebKit, and the
       whole point of the cache -- but a browser that leaves its chrome hidden fires no resize at all, so
       nothing would ever tell the flight its target was 20px high. At 35% there is still 260ms of a 400ms
       tween to spend, and when the bet was right the drift is 0 and flyRetarget does nothing. */
    /* ...BUT NOT WHILE THE BET IS STILL PENDING (2026-08-17, measured). The bake is centred in the
       SETTLED height; until the bar actually comes back, the live viewport is still the TALL one, so a
       MEASURED destination is a rect in a DIFFERENT FRAME. "Correcting" to it drags the flight the whole
       bar delta DOWN, and the real shift then pushes it straight back UP. Measured on land-rect-check's
       second open (settled height already learned, so the bake was exactly right): aim #1 at +129ms took
       top 115 -> 135, aim #2 at +199ms put it back to 115. dy/dh/post are all 0, so the receipt calls
       that landing perfect -- `a:2` is the only thing that can see the 20px round trip, which is exactly
       why it is asserted. The shift resolves 181-199ms after flight start against this 140ms `due`; that
       ~50ms is the whole defect, and it only became reachable when the open got fast enough for the
       scheduled aim to run at all.

       Wait for the ground to arrive -- but NEVER past 75% of the tween, because a browser that leaves its
       chrome hidden never resolves the bet, and correcting THAT is this scheduled aim's entire reason to
       exist (assertion 4). At the 300ms cap of a 400ms tween there is still a 100ms retarget to spend.
       The test is deliberately DIRECTIONAL: the cache only ever bets the viewport will SHRINK, so an
       engine where the cache is not in force has landPredVh === pfVvH() and fires on the old timing. */
    function landAimOn()  {
      if (vvSubs.indexOf(landAim) < 0) { vvSubs.push(landAim); setTimeout(landAimOff, 16000); }
      var due = Math.max(60, Math.round(flightMs * 0.35));
      var betBy = Date.now() + Math.max(due, Math.round(flightMs * 0.75));
      var betCheck = function () {
        if (done || myGen !== heroGen || !wrap) { return; }
        if (landPredVh && pfVvH() > landPredVh + 1 && Date.now() < betBy) { setTimeout(betCheck, 40); return; }
        landAimNow();
      };
      setTimeout(betCheck, due);
    }
    function landAimOff() { var i = vvSubs.indexOf(landAim); if (i >= 0) { vvSubs.splice(i, 1); } }
    if (isVideoHero && el.videoWidth > 0) {
      // the clip's fit hint (0144) off whichever node this flight is holding -- the live grid
      // <video> (ensureVideo copies data-fit onto it) or the tile it lifted off. Without it a
      // hinted clip is predicted filled and then paints contained. Same fix as the photo branch.
      var T0 = landRect(el.videoWidth, el.videoHeight, false, window.__rovaFitHint(el, srcImg));
      if (T0) { startFlight(T0, 340, bezSwift); }
    }
    // no immediate flight after all: the deferred lift-off falls back to the old fixed hero on <body>
    if (_liftDefer && !wrap) { el._liftDeferred = 0; el.className = 'pf-hero'; el.removeAttribute('width'); el.removeAttribute('height'); liftFixed(); }
    // PHOTO, SAME IDEA (2026-08-12, measured): a live video hero above has ALWAYS started its flight
    // immediately against a PREDICTED landing rect (pfeedLandRect, mirroring fitPfeedMedia's own cover/
    // contain decision) rather than wait on the async card -- reveal()'s existing late-viewport glide
    // (flyRetarget) already corrects ANY drift between a prediction and the real painted rect, video or
    // photo, unconditionally. A photo hero never took this branch: pump() below waits for the CENTRED
    // slide's img to satisfy .complete + naturalWidth + _pfFitDone before it will even READ a landing
    // rect, let alone start the flight. Measured on the live site (grid vs. the vertical feed, both
    // running this same heroExpand): a grid open resolves that gate in ~0-100ms because a grid tap
    // separately warms the destination's full-res bytes into the HTTP cache on pointerdown, but a
    // vertical-feed open has no equivalent byte warm and the gate can sit for 200-500ms with NOTHING
    // moving on screen -- tap-to-first-visible-motion 460-780ms vs. the grid's 80-150ms for the exact
    // same flight. srcImg is the TAPPED image, already on screen and .complete by construction, so its
    // naturalWidth/naturalHeight are available synchronously with no wait at all. Start against the
    // predicted rect now; the pump loop is UNCHANGED below and still gates the actual reveal/handoff on
    // the real destination image, so nothing about correctness moves earlier, only the flight's first
    // visible frame.
    else if (!isVideoHero && ((predDims && predDims.w > 0 && predDims.h > 0) || (srcImg && srcImg.naturalWidth > 0 && srcImg.naturalHeight > 0))) {
      // srcImg is the tapped node -- a .pcell grid tile (views/_feed_grid.php / _profile_posts.php)
      // or a feed-card <img> (views/_post.php). All three stamp data-fit, so the predicted landing
      // box uses the same verdict the pfeed will paint with.
      // predDims first: the profile-avatar tap flies the SQUARE crop while the viewer paints the
      // pre-crop original, and only the caller knows the original's shape -- see the note on the
      // parameter above.
      /* ...AND `predDims.video` SAYS WHICH VERDICT TO ASK (2026-08-30). `photo` was hardcoded true
         here, which is right for every declaration that is genuinely a photo and wrong for the one
         that is not: the in-timeline FULLSCREEN button on a PAUSED clip flies a still frame, so
         isVideoHero is false and the prediction went through __rovaPhotoCovers instead of
         __rovaVideoCovers. The two rules disagree exactly where a clip's aspect is far from the
         screen's, which is why it showed up on a 720x900 (0.8) clip and not on the 9:16 majority:
         tools/flight-fit-check.js measured the flight aiming COVER at 675x844 while the viewer
         painted CONTAIN at 390x487.5 -- a 356px overshoot, the same visible correction the grid bug
         produced, on a different opener. A declaration that carries the SIZE but not the KIND is
         only half a declaration. `predDims.el` lets the same declaration carry the clip's data-fit
         hint too, so the prediction and the paint read the same attribute. */
      var T0p = (predDims && predDims.w > 0 && predDims.h > 0)
        ? landRect(predDims.w, predDims.h, !predDims.video, window.__rovaFitHint(predDims.el, srcImg))
        : landRect(srcImg.naturalWidth, srcImg.naturalHeight, true, window.__rovaFitHint(srcImg));
      if (T0p) { startFlight(T0p, 400, bezGlide); }
    }
    function reveal() {
      if (done) return; done = true;
      // A newer open/close cycle owns the viewer -> never replaceChild into ITS card or force opacity on ITS
      // media (the ghost/decoder-revive). reset already dropped this flight's clone + hold.
      if (myGen !== heroGen) { landAimOff(); return; }
      var pf = document.querySelector('.pfeed.show');
      var mm = pf ? pfCenteredMedia(pf) : null;
      /* SCRIM RELEASE (a) -- see .pfeed.pf-settling:not(.pf-hasmedia) in rova.css. This is the hero
         LANDING: the flown copy is parked over (or gliding within a few px of) its final rect, i.e.
         real pixels cover the media area, so the settling backdrop returns to opaque this frame --
         even though the card's own full-res is still loading (that gate, ready()'s ld, kept the
         bright grid glowing around the landed photo for seconds on a slow line, owner 2026-08-29).
         Stamped before the self-defer branches below on purpose: they hold the CLONE up, and the
         backdrop must already be dark behind it. hz-hold's transition:none makes this a same-frame
         snap, which is the point. Idempotent; a stale flight is stopped by the gen guard above. */
      if (pf) { try { pf.classList.add('pf-hasmedia'); } catch (e) {} }
      // LATE-VIEWPORT CORRECTION (owner: "lands slightly off when the mobile url bar minimizes"): opening
      // the viewer can collapse/expand the browser chrome MID-FLIGHT, so the rect the keyframes were baked
      // for is stale by the bar-height delta. Re-measure the real landing rect now and glide any drift off
      // BEFORE the handoff/fade, so the swap is pixel-exact in both bar states.
      // WAIT FOR THE BAR TO SETTLE first: if the visual viewport shifted within the last 120ms it's still
      // mid-collapse -- measuring now would correct to a moving target. Hold the reveal (capped ~360ms from
      // birth of this wait) until it's been still, so the final measure is against the settled layout.
      if (wrap && !reveal._corrected && lastVVShift && Date.now() - lastVVShift < 120
          && Date.now() - (reveal._waitStart || (reveal._waitStart = Date.now())) < 360) {
        done = false; setTimeout(reveal, 60); return;
      }
      pfNoteSettledVh();   // viewer up, bar still: THIS is the height the next open should predict in
      if (wrap && mm && mm.el && mm.box && !reveal._corrected) {
        var liveR = null;
        try {
          if (isVideoHero && el.videoWidth > 0) { liveR = cardDrawnRect(mm.box, el.videoWidth, el.videoHeight, mm.el); }
          else if (mm.el.tagName === 'VIDEO' && mm.el.videoWidth > 0) { liveR = cardDrawnRect(mm.box, mm.el.videoWidth, mm.el.videoHeight, mm.el); }
          else if (mm.el.complete && mm.el.naturalWidth > 0) { liveR = paintedRectOf(mm.el, mm.box); }
        } catch (e) {}
        /* THE LANDING RECEIPT (2026-08-17). Stamped here because this is the one moment both numbers
           exist: `p` = the rect the tween was BAKED for at the tap, `f` = the rect the viewer actually
           paints, measured. dy/dh are the only two that decide whether the reader saw a nudge, and
           `post` is the verdict: 0 = every correction finished inside the tween (the rule), >0 = ms the
           tween had already been over when the ground last moved. `a` counts mid-flight re-aims, so an
           exact landing that needed three of them is still legible as exact. Stamped BEFORE the glide
           below runs, so it describes the flight as flown, not as patched. */
        if (liveR && landPred) {
          vfLandRecord({ p: Math.round(landPred.top), f: Math.round(liveR.top),
            dy: Math.round(Math.abs(landPred.top - liveR.top)),
            dh: Math.round(Math.abs(landPred.height - liveR.height)),
            a: landAims, post: landPostFix, vh: Math.round(pfLandVh()), vv: Math.round(pfVvH()),
            kind2: isVideoHero ? 'clip' : 'photo' });
        }
        landAimOff();   // past this point a re-aim would BE the post-landing nudge
        var glide = liveR ? flyRetarget(wrap, liveR, 150) : 0;
        if (glide) { reveal._corrected = 1; done = false; setTimeout(reveal, glide + 20); return; }
      }
      landAimOff();
      // SINGLE-ELEMENT HANDOFF (live video): this element is ALREADY loaded + playing off the LOCAL buffer, so
      // instead of cross-fading to a SEPARATE viewer <video> (a second network load that stalls with wifi off,
      // and a cross-fade that flickered), MOVE it into the card in place of its placeholder clip. No reload, no
      // cross-fade -> no flicker; it's already at the painted rect so the swap is invisible. Mirrors loadMore's
      // grid-donor adoption. (owner: local data first; make the handoff EXACT.)
      if (isVideoHero && mm && mm.box) {
        var fv0 = mm.box.querySelector('video');
        // CAROUSEL RACE (owner: fullscreen from a slideshow's video slide "poofed" the video): at reveal
        // time the pfeed carousel can still sit on ANOTHER slide (positioning + __cgo land async), so the
        // CENTERED box has no <video>. The placeholder to replace lives somewhere in the CURRENT POST --
        // search the whole post before concluding there's no handoff target.
        if ((!fv0 || fv0 === el) && mm.box.closest) {
          var postEl = mm.box.closest('.post');
          if (postEl) {
            var cands = postEl.querySelectorAll('.media video');
            for (var fi = 0; fi < cands.length; fi++) { if (cands[fi] !== el) { fv0 = cands[fi]; break; } }
          }
        }
        /* ...BUT ONLY IF IT IS THE SAME FILE (owner 2026-08-15: "it seems to be only when clicking
           media from the grid the sound isn't working, whether I tap the speaker or not").

           IT NO LONGER IS, and nothing here noticed. A grid tile does not play the post's clip: it
           plays the GRID RENDITION, `HASH_w_grid480.mp4`, built by VideoJobs::gridVariant with
           `-an` -- audio deliberately stripped, "one fewer audio decoder to run" per the tile. PROVED
           on the owner's own post: ffprobe of 43603's `_w.mp4` reports h264 + aac stereo; its
           `_w_grid480.mp4` reports ONE stream, video only, 8.7MB against 108MB.

           So when the tapped tile happened to be PLAYING, this handoff moved that silent 480p element
           into the viewer AS the post's clip and retired the real one. Everything downstream then
           behaves perfectly on a file with no sound in it: applySound unmutes it, `muted` goes false,
           .vc-sound repaints itself "sound on", and the corner speaker toggles a track that does not
           exist -- which is exactly "whether I tap the speaker or not". Worse than silent, it is
           CONFIDENTLY silent: line above copies data-noaudio from fv0, and fv0 is the real clip, which
           has audio -- so videoNoAudio() says "this has sound" and even the "No audio" badge stays
           hidden. And it stays that way for the life of the card (`_instant` pins it to the local
           mp4), while swiping away and back rebuilds the card from markup and gets the real file --
           the owner's "swipe down, swipe back up and now it has sound".

           A tile that was NOT yet playing flies a still frame and the viewer uses its own clip, which
           is why only some opens were affected and why the report took a month to become legible.

           The sibling adoption path -- loadMore's grid-donor branch -- has enforced exactly this rule
           since it was written ("adopt ONLY when both point at the same mp4") and correctly refuses
           the same element for the same reason. This one was simply never given the test when the
           grid stopped serving the master. Same rule, one place each, both now stated.

           On a mismatch we do NOT adopt: control falls through to the still-hero cross-fade below,
           which seeks the viewer's OWN clip to the hero's frame and fades to it -- the tested path
           every not-yet-playing tile already takes. Costs one cross-fade; buys the actual audio. */
        /* FEED 720 (2026-10-06): a Cloudflare upload's FEED card plays its `_w_720.mp4` copy while the viewer card was
           pointed at the full file by pfFullSrc (which keeps the copy in data-src-feed). Same clip, same timeline: the
           live feed element is adopted exactly as before the copy existed (measured without this: the viewer's own
           cold default.mp4 seeked to the hero frame, stalled, fell to HLS and sat at readyState 0). Swiping on plays
           the full file. */
        var _fsf = '';
        try { _fsf = (fv0 && fv0.getAttribute && fv0.getAttribute('data-src-feed')) ? new URL(fv0.getAttribute('data-src-feed'), location.href).href : ''; } catch (e) { _fsf = ''; }
        var adopt = !!(fv0 && fv0 !== el && fv0.parentNode) && clipKey(el) !== ''
          && (clipKey(el) === clipKey(fv0) || (_fsf !== '' && clipKey(el) === _fsf));
        /* THE ADOPTION IS TWO-PHASE (2026-09-27, same rule as close()'s landing -- see flyCrop's deferMove).
           Phase 1: pin the clip's current frame over it in the wrapper and give that two frames on screen.
           Phase 2 (this function again): the move, with that same canvas carried into the card. */
        if (adopt && wrap && !reveal._pinned) {
          var _tw = frameSnap(el);
          if (_tw) {
            try {
              _tw.style.cssText = el.style.cssText + ';animation:none;transform:' + getComputedStyle(el).transform + ';pointer-events:none;';
              wrap.appendChild(_tw); reveal._pinned = _tw;
              done = false;
              requestAnimationFrame(function () { requestAnimationFrame(reveal); });
              setTimeout(reveal, 90);
              return;
            } catch (e) {}
          }
        }
        if (adopt) {
          el.className = fv0.className;                 // card styling (drops the hero overlay class)
          el.style.cssText = '';                        // clear the fixed/size hero styles -> the card CSS owns it
          // data-hls-lo rides along too (2026-07-29): same omission as loadMore's grid donor. This clip is
          // _instant so it stays on the local mp4 for now, but it re-enters warmIO/attachHls on the next
          // scroll-away, and without the twin it would attach the sharp master on a line that can't carry it.
          ['poster', 'width', 'height', 'data-hls', 'data-hls-lo', 'data-noaudio', 'controls'].forEach(function (a) { if (fv0.hasAttribute(a)) { el.setAttribute(a, fv0.getAttribute(a)); } });
          el.loop = true; el._instant = 1;              // _instant: keep it on the local mp4 (don't swap to HLS)
          /* THE LAST MOMENT THIS CLIP CAN REFUSE GECKO'S PiP TOGGLE. Firefox floats its own
             "Pop out this video" button over any <video> the pointer is over, it is UA-widget
             chrome so no style of ours reaches it, and in the immersive viewer -- where the clip
             fills the screen and the pointer is therefore always over it -- it just sits there
             through the idle fade. `disablepictureinpicture` suppresses it, but Gecko reads the
             attribute exactly ONCE, when the element is bound into the document: this
             replaceChild IS that bind for the post the reader opened on (the deck's other cards
             are handled before insertion by pfNoPip, in the pfeed block, where the measurement
             is written up). Gated on there being no PiP API to lose, so Blink is untouched, and
             scoped to a destination inside the viewer so a clip flying BACK to a feed/grid card
             keeps Firefox's toggle where that surface still offers one. */
          try {
            if (!(('pictureInPictureEnabled' in document) && document.pictureInPictureEnabled)
                && fv0.parentNode.closest && fv0.parentNode.closest('.pfeed')) {
              el.setAttribute('disablepictureinpicture', '');
            }
          } catch (e) {}
          var _snapA = reveal._pinned || frameSnap(el); // its picture, on screen BEFORE the re-parent (see frameSnap)
          fv0.parentNode.replaceChild(el, fv0);         // moves el OUT of the flight wrapper and into the card
          /* AND STOP THE CLIP WE JUST EVICTED. fv0 is now DETACHED -- and a detached <video> keeps
             playing, audio included, while every stop path in the app (close, clearPfeedList,
             __rovaReleaseVideos, applySound's sweep) looks it up through the DOM and can no longer see
             it. On a fast double tap the placeholder is already playing UNMUTED by the time we get
             here, so the swap left the SAME clip audible twice with no way to silence the second copy
             short of a reload -- the owner's 2026-08-06 report, traced with real touch on the grid.
             Retiring it also makes it unrevivable, which matters because the second tap's play/pause
             timer is holding a reference to exactly this element. */
          if (window.__rovaRetireVideo) { try { window.__rovaRetireVideo(fv0); } catch (e) {} }
          if (wrap) { disposeFlight(wrap); wrap = null; }   // the empty crop-window + its keyframes tag
          // Wire the ADOPTED clip's own controls: fv0's player + scrubber pointed at the now-detached
          // placeholder, and the like/comment/repost/share buttons were folded into fv0's vctrl -- rebuild
          // against `el` so the video controls work AND the engagement actions relocate onto it. Safe now
          // that buildControls rescues the .pf-act before tearing the old bar down.
          if (window.__rovaVCtrl) { try { window.__rovaVCtrl(el); } catch (e) {} }
          el.style.opacity = '1';                       // stay visible while we release hz-hold
          if (_snapA) { frameCoverAt(el, _snapA); }     // ...and its picture held over it until it presents here
          heroRelease();                                // wrapper (the .pf-hero) is gone -> hz-hold lifts
          var pph = el.play && el.play(); if (pph && pph.catch) { pph.catch(function () {}); }
          // hand the SOUND state to the adopted clip NOW (it flew in muted): if the user's pref/latch wants
          // sound, this unmutes it immediately instead of leaving a muted clip + "Tap for sound" pill.
          if (window.__rovaSyncSound) { try { window.__rovaSyncSound(); } catch (e) {} }
          /* A VOICE THAT OUTLIVED ITS OPEN ENDS AT ITS LANDING (2026-09-26). soundRelease keeps a flying
             voice (see there); if the open has already been released -- its hold expired, drop()'s cap
             fired -- nothing else is coming to release this one, so the adoption does, onto the element
             that is now the centred clip anyway. While the hold is still running, pfVoiceReady owns it. */
          if (_fsVoice && window.__rovaSoundRelease && !(window.__rovaSoundHeld && window.__rovaSoundHeld())) {
            try { window.__rovaSoundRelease(); } catch (e) {}
          }
          requestAnimationFrame(function () { el.style.opacity = ''; });   // hand opacity back to the card CSS
          return;                                       // el LIVES ON as the card video -- no cross-fade, no removal
        }
      }
      // A BORROWED live element (the timeline's own video, flown by the fullscreen button) must NEVER ride
      // the fallback below -- its fade timeout disposes the wrapper WITH the element inside, permanently
      // destroying the post's video (owner: "it just disappeared, poof"). No handoff target found -> RETURN
      // it home instead: restore its class/style into its slide, re-wire, keep playing. The viewer then uses
      // its own placeholder clip (resumed by pfResume), and close() skips the borrow (consumed here).
      if (isVideoHero && window.__rovaFsBorrow && window.__rovaFsBorrow.video === el) {
        var bw = window.__rovaFsBorrow; window.__rovaFsBorrow = null;
        if (bw.media && bw.media.isConnected && !bw.media.querySelector('video')) {
          el.className = bw.cls || '';
          if (bw.styleText) { el.setAttribute('style', bw.styleText); } else { el.removeAttribute('style'); }
          var _snapB = frameSnap(el);
          bw.media.insertBefore(el, bw.media.firstChild);
          bw.media.classList.remove('fs-away');          // home again: the box paints as a card media box
          if (window.__rovaVCtrl) { try { window.__rovaVCtrl(el); } catch (e) {} }
          if (_snapB) { frameCoverAt(el, _snapB); }
          var rp = el.play && el.play(); if (rp && rp.catch) { rp.catch(function () {}); }
        }
        if (wrap) { disposeFlight(wrap); wrap = null; }   // el is safely out (or its home vanished -- rare)
        else if (el.parentNode && !el.closest('.post')) { el.parentNode.removeChild(el); }
        heroRelease();
        return;
      }
      // STILL-hero fallback: cross-fade to the viewer's own media (seek a video to the hero's frame first).
      if (pf) {
        if (isVideoHero && mm && mm.el && mm.el.tagName === 'VIDEO') {
          /* ══ THE LANDING DISSOLVE ═════════════════════════════════════════════════════
             This IS the handoff the owner asked for -- "if you must handoff media to
             increase quality it should be done in a smooth dissolve transition that's
             unnoticeable ... after the video lands in full screen". It was already a
             crossfade (the flown preview fades out over HERO_FADE_S while the viewer's own
             master plays underneath, seeked to the hero's frame); what the boomerang adds is
             getting the SEEK TARGET right, which the old line could not do.

             THE BUG THIS FIXES, stated plainly because the old line looks correct: it used
             `el.currentTime` DIRECTLY as the master time. For a `_grid3` tile that is right,
             because that file runs straight and 1:1. For a `_grid6` tile it is right for the
             first half of every loop and wrong for the second, by up to the whole window --
             tap during the reverse phase at position 4.5s of a 5.93s file and the reader is
             looking at master time 1.43s while this line would seek the master to 4.50s.
             Both surfaces are live across the fade, so that is not a hidden seek: it is a
             visible jump to a different part of the clip, exactly under the reader's eye,
             on roughly half of all taps.

             THE HALF-FADE COMPENSATION. The master only ever plays FORWARD. On a tap taken
             mid-reverse the two surfaces therefore travel in OPPOSITE directions for the
             length of the crossfade, so matching them at its START guarantees they are
             ~2 x HERO_FADE_S of content apart by its end. Aligning them at the MIDPOINT
             instead -- where the two are equally visible and a mismatch is most legible --
             halves that worst case and costs one subtraction:
                 boom content at the midpoint  = m + dir * F/2
                 master content at the midpoint = seek + F/2
                 => seek = m + (dir - 1) * F/2      (i.e. m forward, m - F reverse)
             The direction flip itself is not removable -- the clip cannot play backwards --
             and the owner's rule 3 is what governs it: the dissolve is there to cover
             exactly this. Documented as accepted rather than silently smoothed.

             MEASURED: the compensation lands the two surfaces on the SAME content at the
             crossover, drift 0.0000s, at every position in both halves -- with one edge. In
             the last F seconds before the wrap the mapped master time is already under F, so
             `Math.max(0, ...)` clamps the seek to 0 and the crossover drifts by up to ~0.16s.
             That is unavoidable (the master cannot seek before 0), it is confined to ~4% of
             the loop, and it is still LESS than the 2F = 0.44s the uncompensated reverse half
             would drift everywhere. Left as the clamp rather than special-cased, because the
             alternative -- holding the boom until it wraps -- would delay the landing, and
             the owner ranked smoothness of the ARRIVAL above this much of a frame offset.

             ═══ AND THE COMPENSATION IS NOW DEAD CODE ON THE LIFT PATH (2026-08-17, 2nd pass) ══
             Owner, on the result: "It seems like the videos time codes are different because if
             they were the same I would truly not see the transition/fade etc."
             Everything above is arithmetically right and was answering the wrong question. It
             matched the two CONTENT clocks and left the two DIRECTIONS opposed, which is what a
             reader actually sees. The lift-off round mirrors the BOOM onto its own forward phase
             instead (`__rovaG6Fwd`, same frame, invisible seek, under its own picture, at the
             tap), so both surfaces run FORWARD from the same content time at rate 1 -- and then
             `(dir-1)*F/2` must NOT be applied, because on a mirrored boom it would inject
             exactly -F of real error. `_bl` below is that path; the block is kept intact for
             every open that is NOT a lift (no `data-master` on the tile, a latch-muted reader
             whose lift declined, a slow line that missed the adoption), and those keep today's
             behaviour to the character. */
          var _bl = (window.__rovaBoomIsMaster && window.__rovaBoomIsMaster(mm.el)) ? mm.el._boomLift : null;
          try {
            var t = el.currentTime || 0, dur = mm.el.duration || 0;
            var _bm = (el.getAttribute && el.getAttribute('data-g6') === '1'
                       && typeof window.__rovaG6Master === 'function'
                       && isFinite(el.duration) && el.duration > 0);
            var _bdir = 1, _braw = t;
            if (_bm) {
              _bdir = window.__rovaG6Dir(t, el.duration);
              t = window.__rovaG6Master(t, el.duration);
              // Land the master half a fade early when the tile is running backwards, so the
              // two agree at the crossover rather than drifting apart across it.
              // ...UNLESS THE BOOM WAS MIRRORED: see the second-pass note above. Both surfaces
              // are forward, so `m` IS the answer and the rewind would be the whole error.
              if (!_bl) { t = Math.max(0, t + (_bdir - 1) * (HERO_FADE_S / 2)); }
            }
            /* AND THE LIFT'S MASTER IS NEVER SEEKED HERE AT ALL. It has been running on the
               master's own timeline since the tap -- started at `m`, unmuted, audible -- so its
               position now is `m` plus the real elapsed time, which is exactly where it should
               be. `t` is the TAP-time snapshot; assigning it would rewind the clip by the whole
               length of the open, break the audio the member is already hearing, and destroy the
               forward lock in one statement. The clock that has been playing is the authority. */
            if (!_bl && t > 0.05 && dur && Math.abs((mm.el.currentTime || 0) - t) > 0.06) { mm.el.currentTime = Math.min(t, dur - 0.1); }
            /* THE RECEIPT, in this file's own grammar (a named mark on the vflight record,
               not the app's `fx{}` -- see vfMark's header). Stamped unconditionally for a
               boomerang open, INCLUDING when the mapping declined, because a mark that only
               appears on the happy path reads as "absent" on exactly the rows that would
               prove a regression. `p` is where the tile was, `m` where the master was sent,
               `r` the direction: three numbers that make the handoff auditable without a
               screen recording. */
            if (_bm && window.__rovaVfMark) {
              window.__rovaVfMark('g6Dissolve|p' + (Math.round(_braw * 100) / 100)
                                + '|m' + (Math.round(t * 100) / 100)
                                + '|r' + (_bdir > 0 ? 'f' : 'r'), mm.el);
            }
          } catch (e) {}
          var pp = mm.el.play && mm.el.play(); if (pp && pp.catch) { pp.catch(function () {}); }
        }
        Array.prototype.forEach.call(pf.querySelectorAll('.post .media:not(.carousel) > img, .post .media:not(.carousel) > video'), function (im) { im.style.opacity = '1'; });
        // CAROUSEL: hz-hold hides ALL slide media during the flight, and the querySelector above skips
        // carousels -- so reveal the centred slide's media explicitly, UNDER the still-opaque clone, so it's
        // already up when the clone fades off (no pop when hz-hold later releases).
        if (mm && mm.el && mm.box && mm.box.closest && mm.box.closest('.media.carousel')) { mm.el.style.opacity = '1'; }
      }
      var fadeEl = wrap || el;   // the flight wrapper if we flew, else the pre-flight clone (15s-cap fallback)
      /* ═══ THE DEFERRED PICTURE HANDOFF (2026-08-17) ══════════════════════════════════════════
         Owner: "it should happen after 2-3 seconds after the cpu has calmed or threads are
         available to do the switch in realtime with 0 sync loss since doing this right at the
         beginning still hangs and looks un synced."
         The landing is the busiest moment of the whole open -- the card render, the donor
         adoption, the chrome reveal and the tween's own teardown all land inside a few frames --
         and a crossfade started there competes with every one of them. So on a lift, the fade is
         handed to `boomArmRelease`, which holds the boom picture up (over a master that is
         already opaque and already audible underneath it) until the thread is genuinely idle AND
         both clocks agree to inside a frame. EVERYTHING ELSE ON THIS LANDING STILL HAPPENS NOW:
         the hold lifts, the chrome reveals, the pans restart, the media opacity goes back to the
         stylesheet. Only the top layer's withdrawal moves, which is the one thing the reader was
         seeing. A false answer means no lift is armed and the fade below runs exactly as it
         always has. */
      var dsvHold = !!(window.__rovaBoomArm && window.__rovaBoomArm(wrap || null, mm && mm.el));
      /* ═══ A PHOTO LANDING IS A HAND-OVER, NOT A CROSS-FADE  (2026-09-13) ═══════════════════════
         Owner, with a recording of a grid open: "This zoom animation to open the media is broken
         make it smooth just simple zoom without all this flickerings." Frame-measured off it, the
         420-wide iOS Safari open ran: zoom 833-1250ms, then a STATIC picture for 633ms, then a 183ms
         fade of that picture to black, then 283ms of pure black, then the picture back in ONE frame
         at 2400ms. Four visual states after the zoom had already finished.

         EVERY ONE OF THEM CAME FROM THE SAME PREMISE -- that the landing is a swap between TWO
         elements, so the copy has to leave and the destination has to be ready before it does. The
         633ms freeze is the reveal waiting for that readiness; the 183ms fade is HERO_FADE_S paying
         for a swap between two layers that are meant to be identical; the 283ms black is the swap
         happening anyway because pfDecoded's 900ms cap said "ready" and lied (see its header).

         THERE IS NO SECOND ELEMENT TO SWAP TO. The flown copy is the same picture, at the same rect,
         already decoded and already painting. So it is not withdrawn at all here: it is re-classed
         out of `.pf-hero` and SUNK into the card's own layer -- the manoeuvre boomArmRelease has used
         for the boomerang overlay since 2026-08-17, for the same reason (`.pf-dsv{z-index:1}` sits
         above the media plane and below the chrome's z 2). Everything the landing owes then happens
         AT THE LANDING and unconditionally: the hold lifts, the chrome reveals, the backdrop settles,
         the pans restart -- none of them gated on a decode any more. The copy is taken away later, in
         one frame, once the destination has genuinely rasterised (pfHandOver), which is a zero-pixel
         change between two pixel-aligned copies of one picture.

         WHAT THIS REMOVES, and it is removal rather than correction on purpose: the HERO_FADE_S
         cross-fade on every photo open, the 240ms teardown timer behind it, the destination-decode
         coupling in the pump's photo gate, and pfDecoded's 900ms escape. VIDEO IS UNTOUCHED -- a
         still-hero over a clip is a dissolve between genuinely different content (a frozen frame and
         a running master) and it keeps the fade it was written for. */
      var photoOver = !dsvHold && !isVideoHero && !!wrap && !!(mm && mm.el && mm.el.tagName === 'IMG');
      if (photoOver) {
        /* SUNK, NOT WITHDRAWN. Re-class first so heroRelease's `.pf-hero` gate passes (the same
           ordering boomArmRelease documents), then into the card's layer so the chrome this landing
           is about to reveal paints OVER the copy rather than under it.
           AND IF IT CANNOT BE SUNK, IT CANNOT BE A HAND-OVER. A wrapper left at body z 210 would hide
           the top bar, the caption and the action row for the whole retire window -- the exact hole
           boomSink was written for, and the one condition under which "keep the copy up" is worse than
           the fade it replaces. No host card (a viewer that has not laid one out yet) -> put the class
           back and take the tested cross-fade, unchanged. */
        try { wrap.className = 'pf-dsv'; } catch (e) {}
        var sunk = false;
        try { sunk = !!boomSink(wrap); } catch (e) { sunk = false; }
        if (!sunk) { try { wrap.className = 'pf-hero'; } catch (e) {} photoOver = false; }
        else { pfStillSync(); }
      }
      if (!dsvHold && !photoOver) {
        var tr = fadeEl.style.transition || '';
        fadeEl.style.transition = (tr ? tr + ',' : '') + 'opacity ' + HERO_FADE_S + 's ease';
        fadeEl.style.opacity = '0';
      }
      var kbPending = 0;
      function landRelease() {
        if (myGen !== heroGen) { return; }   // stale cycle: reset cleaned up; don't touch the new viewer
        // REMOVE THE CLONE FIRST: heroRelease's gate would see this still-attached .pf-hero and refuse to lift
        // hz-hold, then the wasLast branch re-hid the media under the hold = black photo (owner /p/1483).
        // ...EXCEPT ON A DEFERRED HANDOFF, where the wrapper stays and the gate is satisfied a
        // different way: boomArmRelease already re-classed it OUT of `.pf-hero` (to `.pf-dsv`), so
        // the hold lifts on this line as usual while the boom keeps painting above the viewer.
        // The wrapper AND the boom's decoder are disposed by the dissolve's own completion.
        // ...and the same is true of the PHOTO hand-over above: the copy stays up as the picture and
        // is retired by pfHandOver, which is also what re-arms the pans (see kbPending below).
        if (dsvHold || photoOver) { /* the deferred dissolve / the hand-over owns `wrap` and `el` now */ }
        else if (wrap) { disposeFlight(wrap); wrap = null; }
        else if (el.parentNode) { el.parentNode.removeChild(el); }
        /* A LIVE-VIDEO HERO REACHING THIS LINE WAS NOT ADOPTED, so the element the flight borrowed --
           a grid preview, or a clip whose file did not match the card's (see the adoption test above)
           -- has just been removed from the document while still playing. A detached <video> keeps
           decoding where every stop path in this file, all of which query the DOM, can no longer see
           it. The orphan sweep would collect it within 3s; retiring it here makes it immediate and
           makes the intent legible at the site that stranded it. The two paths that KEEP their
           element (the adoption above, the __rovaFsBorrow return home) have both returned by now. */
        // (NOT on a deferred handoff: `el` is the boom and it is still the picture on screen. It is
        // retired by boomFade, in the same statement that disposes the wrapper holding it.)
        if (!dsvHold && isVideoHero && window.__rovaRetireVideo) { try { window.__rovaRetireVideo(el); } catch (e) {} }
        var wasLast = heroHolds <= 1;
        heroRelease();
        /* THE PANS RESTART WHEN THE PICTURE UNDERNEATH BECOMES THE PICTURE, NOT BEFORE. On a
           hand-over the destination <img> is un-hidden but still covered by the copy, so arming its
           Ken Burns here would run the pan invisibly and then jump the crop by however long the
           destination took to rasterise. Deferred to the retire step, which is the frame it actually
           becomes visible. Everything else on this landing still happens now. */
        if (wasLast && photoOver) { kbPending = 1; return; }
        if (wasLast) { kbSettle(); }
      }
      function kbSettle() {
        {
          var pf2 = document.querySelector('.pfeed.show');
          if (pf2) {
            var kbs = pf2.querySelectorAll('.post .media:not(.carousel) > img');   // restart Ken Burns from rest (same as heroZoom)
            /* ...but SKIP any photo whose bounded pass is already under way. On touch the opened photo runs
               pfSettle, one 12s pass from rest, and the hero landing arrives partway through it -- re-arming
               there replays it from 0% and reads as the pan stopping and starting again (owner report).
               The re-arm still runs for the infinite desktop pan, which is what it was written for. The
               TRANSITION reset below stays on every image either way: that one is about not letting a
               transition animate the handoff, and it is unrelated to which pan is running. */
            var kbArm = Array.prototype.filter.call(kbs, function (im) { return !(window.__rovaKbMidPass && window.__rovaKbMidPass(im)); });
            Array.prototype.forEach.call(kbs, function (im) { im.style.transition = 'none'; });
            kbArm.forEach(function (im) { im.style.animation = 'none'; });
            if (kbArm.length) { void kbArm[0].offsetWidth; }
            kbArm.forEach(function (im) { im.style.animation = ''; });
            requestAnimationFrame(function () { Array.prototype.forEach.call(kbs, function (im) { im.style.transition = ''; }); });
            Array.prototype.forEach.call(pf2.querySelectorAll('.post .media:not(.carousel) > img, .post .media:not(.carousel) > video'), function (im) { im.style.opacity = ''; });
            if (mm && mm.el && mm.box && mm.box.closest && mm.box.closest('.media.carousel')) { mm.el.style.opacity = ''; }   // hand the carousel slide back to the stylesheet
          }
        }
      }
      if (photoOver) {
        // released in THIS task, so the reader sees the landing complete on the frame the tween ends
        var overWrap = wrap, overGen = myGen;
        landRelease();
        pfHandOver(mm.el, function () {
          if (overGen !== heroGen) { return; }           // a newer cycle already swept .pf-dsv
          disposeFlight(overWrap);
          if (wrap === overWrap) { wrap = null; }
          if (kbPending) { kbPending = 0; kbSettle(); }
        });
      } else {
        setTimeout(landRelease, HERO_FADE_MS);
      }
    }
    /* WHEN TO LOOK AGAIN (2026-08-05). The gates below are UNCHANGED -- this only decides how soon the
       pump gets to re-read them. It used to re-poll on a flat setTimeout(pump, 50), so between the
       moment the centred photo satisfied complete + naturalWidth + _pfFitDone and startFlight actually
       running, 13-60ms was measured doing nothing. Three racers now wake it, first one wins:

         rova:pfwake  dispatched at the two moments the pump is actually waiting for, in the SAME task
                      each becomes true: the openers right after box.classList.add('show'), and
                      fitPfeedMedia right after it stamps _pfFitDone. The .show one matters more than
                      it looks -- heroExpand runs BEFORE __rovaFeedView, so the pump's rAF is registered
                      FIRST and fires before the opener's rAF adds .show, and the pump used to miss the
                      viewer appearing by a whole frame (~64ms at CPU x4, not ~16). Both dispatch sites
                      live in other top-level IIFEs, so this has to be a document event: a direct call
                      works unminified and breaks in the minified bundle.
         rAF          frame-accurate for everything else (the video paths, a late box measure).
         setTimeout   50ms, and it is NOT redundant: rAF does not run in a backgrounded tab, and the
                      15s never-blank cap below is driven by whatever wakes the pump. Losing the timer
                      would mean a tab backgrounded mid-open never reveals at all.

       NOTHING VISIBLE MOVES EARLIER. The flight still starts only once the destination has its real
       fit, which is the whole point of the _pfFitDone gate; being told about it instead of finding out
       up to 50ms later cannot start a flight against anything that was not already ready. */
    var pumpTok = null;
    function schedulePump() {
      if (pumpTok) { return; }
      var t = { fired: false };
      pumpTok = t;
      var go = function () {
        if (t.fired || pumpTok !== t) { return; }
        t.fired = true; pumpTok = null;
        document.removeEventListener('rova:pfwake', go);
        pump();
      };
      document.addEventListener('rova:pfwake', go);
      if (window.requestAnimationFrame) { requestAnimationFrame(go); }
      setTimeout(go, 50);   // always armed: the rAF racer is dead in a background tab
    }
    function pump() {
      if (done || myGen !== heroGen) return;   // stale cycle -> stop polling (don't reveal onto the new viewer)
      /* ---- A WAKE THAT CANNOT DECIDE ANYTHING MEASURES NOTHING  (2026-08-17) ----------------------
         pfCenteredMedia() reads window.innerWidth/innerHeight and then getBoundingClientRect on every
         `.post .media` in the viewer, and this line ran it on EVERY wake. There are three racers
         (rova:pfwake, rAF, a 50ms timer) and `go` re-arms after each, so a single open pumped 5-17
         times -- and the pfwake racer fires from inside fitPfeedMedia's own task, immediately after its
         write burst, so each of those reads flushed style+layout for everything that pass had just
         dirtied. MEASURED: 134ms of forced style+layout over 5 events on one 4x-CPU open, plus a share
         of the unattributed remainder.

         EVERY ONE OF THOSE MEASUREMENTS WAS PROVABLY UNUSED. Both hero kinds now start their flight AT
         THE TAP against the predicted rect (the video branch since 2026-08-05, the photo branch since
         2026-08-12), so by the time the first wake arrives `expanded` is already true. Trace the old
         body with `expanded === true` and `elapsed < 380`: it computes `mm`, enters `if (mm && mm.el &&
         mm.box)`, skips the `!expanded` branch, fails the `>= 380` branch, and falls through to the
         15s never-blank cap. The rect is read and discarded, on every wake, for the whole first 380ms
         of the flight -- i.e. exactly the window the reader is watching.

         THIS IS A REORDERING, NOT A NEW GATE. The `>= 380` threshold, the never-blank cap and the
         `mm && mm.el && mm.box` guard on the reveal are all untouched below; a wake that CAN decide
         something still measures first and decides on the same numbers as before. In particular the
         video reveal still refuses to hand off until a centred media box exists, which is what keeps
         the local-first adoption (and with it one-voice audio and the g6 mirror) on its tested path. */
      if (expanded && !done && (Date.now() - expandStart) < 380) {
        if (Date.now() - born < 15000) { schedulePump(); return; }
        reveal(); return;                       // the cap, reached the same way it was before
      }
      var pf = document.querySelector('.pfeed.show');
      var mm = pf ? pfCenteredMedia(pf) : null;
      if (mm && mm.el && mm.box) {
        if (!expanded) {
          // start the grow once we know the true landing rect. VIDEO: size it from the FLYING clip's OWN
          // dimensions (el.videoWidth -- already local, already playing) via the card box, so we never wait on
          // the placeholder <video>'s metadata to come back from the server. PHOTO: wait for the real image FIT.
          var P = null;
          if (isVideoHero) {
            if (el.videoWidth > 0 && mm.box.getBoundingClientRect().width > 4) {
              P = cardDrawnRect(mm.box, el.videoWidth, el.videoHeight, mm.el);
            }
          } else if (mm.el.tagName === 'VIDEO') {
            // STILL hero over a pfeed VIDEO (e.g. the player's fullscreen button): the photo check below never
            // passes for a <video> (.complete is undefined), which FROZE the grow until the 15s cap. Size it
            // from the viewer clip's OWN metadata, same as the live-hero path.
            if (mm.el.videoWidth > 0 && mm.box.getBoundingClientRect().width > 4) {
              P = cardDrawnRect(mm.box, mm.el.videoWidth, mm.el.videoHeight, mm.el);
            }
          } else if (mm.el.complete && mm.el.naturalWidth > 0 && mm.el._pfFitDone) {
            P = paintedRectOf(mm.el, mm.box);
          }
          if (P && P.width > 4 && P.height > 4) {
            startFlight(P, 400, bezGlide);   // composited crop-flight (same 400ms photo ease as before)
          }
        }
        if (expanded && (Date.now() - expandStart) >= 380) {
          if (isVideoHero) {
            // LOCAL-FIRST: the flying clip is already loaded+playing, so hand it into the card as soon as the
            // grow finishes -- do NOT wait on the placeholder <video>'s playback buffer (that server-wait was
            // the owner's "waits for the server before it resorts to local"). The card only needs its metadata
            // (already read to size the grow) to exist; readyState of its buffer is irrelevant since we replace it.
            reveal(); return;
          }
          if (mm.el.tagName === 'VIDEO') { if (mm.el.readyState >= 2) { reveal(); return; } }   // still-over-video: reveal once it has a frame
          /* photo/still: the real image must be LOADED. IT NO LONGER HAS TO BE DECODED **WHEN THERE IS
             A WRAPPER** (2026-09-13): reveal() hands that flight over instead of withdrawing it, so
             the decode decides when the COPY LEAVES, not when the viewer lands -- and gating the
             landing on it was the owner's 633ms freeze between the zoom finishing and anything else
             happening. Without a wrapper (the 15s-cap fallback, which still cross-fades a bare clone)
             the 09-09 rule is unchanged and still the only thing between that clone and a black
             frame. One condition, two regimes, stated where it is read. */
          else if (mm.el.complete && mm.el.naturalWidth > 0 && (wrap || pfDecoded(mm.el))) { reveal(); return; }
        }
      }
      if (Date.now() - born < 15000) { schedulePump(); return; }   // never-blank cap
      reveal();
    }
    pump();
    return true;
  }
  window.__rovaHeroExpand = heroExpand;

  /* ---- THE SLIDE TERM ON A SHARED POST URL: /p/<id>?slide=3 ---------------
     Owner 2026-08-10: "If I tap the ... from this 3rd slide I want the copied link/embed or whatever
     to land on this slide instead of the first slide."

     WHY THE STAMP IS DONE HERE AND NOT SERVER-SIDE. views/_post.php prints data-url / data-embed once,
     when the card is rendered, and at that moment nobody has swiped anything -- the slide the reader
     ends up looking at is a purely client-side fact. So the server keeps stamping the SLIDE-1 URL it
     always has (which is also the compatibility guarantee: a card nobody swiped copies byte-identical
     bytes to today), and these two helpers add the live slide at the moment of the copy.

     ONE PATH FOR ALL THREE SURFACES. The feed card, the permalink and the immersive viewer are the
     same .post element -- pfMoveActs() MOVES the real .js-share button into the viewer's .vctrl row
     rather than building a second one, and the viewer's top-right menu clicks the post's own
     .pmenu-trigger. So closest('.post') resolves from every affordance in all three places, and there
     is exactly one place that knows how to spell the term.

     1-BASED IN THE URL, 0-BASED IN THE CODE, converted once, here -- the reader can see "3/6" on the
     slide and must never be handed a link that says 2. See lib/slidelink.php for the full argument
     (why a query param and not a fragment, why the name, and the clamping rules). */
  window.__rovaSlideOf = function (el) {
    var post = (el && el.closest) ? el.closest('.post') : null;
    if (!post) return 0;
    var car = post.querySelector('.media.carousel');
    if (!car || typeof car.__cidx !== 'function') return 0;   // single-media post: nothing to address
    var i = car.__cidx();
    return (typeof i === 'number' && i > 0) ? i : 0;
  };
  // Mirrors slide_url() in lib/slidelink.php: index 0 returns the URL untouched, already-stamped URLs
  // are left alone, and the term goes BEFORE any #fragment (an embed CTA carries #t=<seconds>).
  window.__rovaSlideUrl = function (url, i) {
    if (!url || !(i > 0)) return url;
    if (/[?&]slide=/i.test(url)) return url;
    var hash = '', h = url.indexOf('#');
    if (h !== -1) { hash = url.slice(h); url = url.slice(0, h); }
    return url + (url.indexOf('?') !== -1 ? '&' : '?') + 'slide=' + (i + 1) + hash;
  };
  /* Re-point a copied <iframe> snippet at the slide, AND re-size it.
     The size matters as much as the src: slide 3 of a carousel can be a portrait shot in a post whose
     slide 1 is landscape, and an iframe sized for the wrong one letterboxes or clips on somebody
     else's website -- the same complaint, one page further out.
     The height cannot be pre-baked per slide: PostEmbed::dims() costs a getimagesize() per slide and
     that button renders on every feed card. So the server hands us the non-media half of the sum
     (data-embed-chrome, pure arithmetic) and we add the media half from the slide's own pixels, using
     the SAME formula and the SAME constants as PostEmbed::mediaH() -- 550-32 inner width, clamped
     180..520. If the slide's dimensions aren't known yet (a lazy image that hasn't decoded) we leave
     the height exactly as the server sized it rather than guessing: a wrong src is a bug, a
     slide-1-shaped box around slide 3 is only untidy. */
  window.__rovaSlideEmbed = function (code, btn, i) {
    if (!code || !(i > 0)) return code;
    code = code.replace(/src="([^"]*\/embed\/p\/\d+)"/, function (all, u) {
      return 'src="' + u + (u.indexOf('?') !== -1 ? '&' : '?') + 'slide=' + (i + 1) + '"';
    });
    var chrome = parseInt(btn.getAttribute('data-embed-chrome') || '', 10);
    var post   = btn.closest ? btn.closest('.post') : null;
    var car    = post ? post.querySelector('.media.carousel') : null;
    var cs     = car ? car.querySelectorAll('.cslide') : null;
    var el     = (cs && cs[i]) ? cs[i].querySelector('img, video') : null;
    var w = 0, h = 0;
    if (el) {
      w = el.naturalWidth  || el.videoWidth  || parseInt(el.getAttribute('width')  || '', 10) || 0;
      h = el.naturalHeight || el.videoHeight || parseInt(el.getAttribute('height') || '', 10) || 0;
    }
    if (chrome > 0 && w > 0 && h > 0) {
      var mh = Math.max(180, Math.min(Math.round(518 * h / w), 520));
      code = code.replace(/ height="\d+"/, ' height="' + (chrome + mh) + '"');
    }
    return code;
  };

  /* THE SHARE SHEET loader (WS-H 2026-10-22): see the .js-share handler below. */
  var ssLoad = null;
  function ssMeta() { return document.querySelector('meta[name="rova-ss"]'); }
  function ssWants(btn, url) {
    if (!ssMeta() || !url) return false;
    var u; try { u = new URL(url, location.origin); } catch (e) { return false; }
    if (u.host.replace(/^www\./, '') !== location.host.replace(/^www\./, '')) return false;
    if (/^\/live\/\d+\/?$/.test(u.pathname)) return !(btn.closest && btn.closest('#live-watch'));
    return /^\/p\/\d+\/?$/.test(u.pathname) || /^\/@[A-Za-z0-9_.]+\/?$/.test(u.pathname)
      || /^\/family\/[a-z0-9][a-z0-9-]{1,63}\/?$/.test(u.pathname);   // 2026-10-23: the family page's Share (ShareSheet kind family)
  }
  function ssPlain(btn) {
    btn.__ssBypass = true;
    try { btn.click(); } finally { setTimeout(function () { btn.__ssBypass = false; }, 0); }
  }
  /* the module: script AND stylesheet (2026-10-23: it used to resolve on the script alone, so a first tap could open the sheet before
     its CSS had arrived, unstyled). A stylesheet that never answers is given 4 s, then the sheet opens anyway. */
  function ssModule() {
    var m = ssMeta();
    if (!ssLoad) {
      ssLoad = new Promise(function (res, rej) {
        var css = m.getAttribute('data-css'), cssP = Promise.resolve();
        if (css) {
          cssP = new Promise(function (ok, no) {
            var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = css;
            l.onload = function () { ok(); }; l.onerror = function () { no(new Error('css')); };
            setTimeout(ok, 4000);
            document.head.appendChild(l);
          });
        }
        var jsP = new Promise(function (ok, no) {
          var s = document.createElement('script'); s.src = m.content; s.async = true;
          s.onload = function () { window.RovaShareSheet ? ok(window.RovaShareSheet) : no(new Error('no sheet')); };
          s.onerror = function () { no(new Error('load')); };
          document.head.appendChild(s);
        });
        Promise.all([jsP, cssP]).then(function (r) { res(r[0]); }, rej);
      });
      ssLoad.catch(function () { ssLoad = null; });
    }
    return ssLoad;
  }
  function ssOpen(btn, url, text) {
    ssModule().then(function (S) {
      S.open({ url: url, text: text, btn: btn, plain: function () { ssPlain(btn); },
               hold: function (on) { engHold('share', on, ENG_LONG); } });
    }, function () { ssPlain(btn); });
  }
  /* SHARE SHEET PREFETCH (2026-10-23, Rob: "takes too long to load"): on INTENT (a pointer over / a finger down on / focus reaching
     a Share button) the module loads and the people list for that target is fetched, so the tap opens a full sheet; at IDLE after
     load, a page with a Share button warms the module and, at most once a minute per tab, the viewer's list. Members only. */
  function ssPrefetch(btn, idle) {
    if (!btn || isGuest() || !ssMeta()) return;
    var now = Date.now();
    if (!idle && btn.__ssPf && now - btn.__ssPf < 15000) return;
    var url; try { url = window.__rovaSlideUrl(btn.getAttribute('data-url'), window.__rovaSlideOf(btn)); } catch (e) { return; }
    if (!ssWants(btn, url)) return;
    if (!idle) btn.__ssPf = now;
    ssModule().then(function (S) { if (S.prefetch) S.prefetch(url, !!idle); }, function () {});
  }
  function ssIntent(e) { var b = e.target && e.target.closest ? e.target.closest('.js-share') : null; if (b && !b.__ssBypass) ssPrefetch(b, false); }
  document.addEventListener('pointerover', ssIntent, { passive: true });
  document.addEventListener('touchstart', ssIntent, { passive: true, capture: true });
  document.addEventListener('focusin', ssIntent);
  (function () {
    var go = function () { if (isGuest() || !ssMeta()) return; var b = document.querySelector('.js-share'); if (b) ssPrefetch(b, true); };
    var later = function () { if (window.requestIdleCallback) requestIdleCallback(go, { timeout: 4000 }); else setTimeout(go, 1500); };
    if (document.readyState === 'complete') later(); else window.addEventListener('load', later, { once: true });
  })();

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.js-share') : null;
    if (!btn) return;
    e.preventDefault();
    // Share is open to EVERYONE, guests included: sharing a post spreads Rova, so never gate it to
    // signup (unlike like/comment/repost). Guests get the native share sheet / copy-link.
    // replay the arrow's fly-out on every tap
    btn.classList.remove('sent'); void btn.offsetWidth; btn.classList.add('sent');
    setTimeout(function () { btn.classList.remove('sent'); }, 600);
    var url = window.__rovaSlideUrl(btn.getAttribute('data-url'), window.__rovaSlideOf(btn));
    var text = btn.getAttribute('data-text') || 'Check this out on Rova';
    /* THE SHARE SHEET (WS-H 2026-10-22, Rob: the post Share = the live's "share to people" menu): a MEMBER's Share on a post / reel /
       profile (or a live outside its own watch page) opens the people picker (assets/sharesheet.js, lazy from <meta name="rova-ss">);
       its "Share elsewhere" re-clicks this button with __ssBypass = the plain path below. Guests, ?ref-less unknown links, the live
       watch page's own sheet (__lshBypass) and a failed load all keep the plain path. */
    if (!btn.__ssBypass && !btn.__lshBypass && !isGuest() && ssWants(btn, url)) { ssOpen(btn, url, text); return; }
    // engage-hold: sharing suspends the auto-loads. The OS sheet reports back, so that hold ends when the sheet
    // is dismissed (the ceiling is only a backstop); a clipboard copy never reports anything, so it gets
    // the short fire-and-forget window instead of a hold nothing would ever release.
    /* LIVE CHAT SHARE ROWS (db/0293): `rova:shared` {via: 'system'|'copy', url, btn} when the OS sheet is OPENED (2026-10-16: on the
       tap, was on completion) or the link was copied; livechat.js turns it into POST /live/{id}/shared on a live page ("Mike S. shared the live"). */
    var shSaid = function (via) { try { document.dispatchEvent(new CustomEvent('rova:shared', { detail: { via: via, url: url, btn: btn } })); } catch (e2) {} };
    if (navigator.share) {
      engHold('share', true, ENG_LONG);
      var shDone = function () { engHold('share', false); };
      // 2026-10-16 (Rob: "If they press Share elsewhere it should also show in the chat"): said ON THE TAP, right after the sheet is
      // asked for (a cancel can't be told apart on every platform; the server keeps it to one row per 5 min).
      navigator.share({ title: 'Rova', text: text, url: url }).then(shDone, shDone);
      shSaid('system');
    } else if (navigator.clipboard && navigator.clipboard.writeText) {
      engHold('share', true, ENG_FIRE);
      navigator.clipboard.writeText(url)
        .then(function () { toast('Link copied'); shSaid('copy'); })
        .catch(function () { window.prompt('Copy this link:', url); shSaid('copy'); });
    } else {
      window.prompt('Copy this link:', url); shSaid('copy');
    }
  });

  /* ---- blog share row: copy link + reveal the native share sheet -------- */
  (function () {
    var native = document.querySelector('.js-blog-native');
    if (native && navigator.share) native.hidden = false;   // OS sheet where supported (mobile)
    document.addEventListener('click', function (e) {
      var copy = e.target.closest ? e.target.closest('.js-blog-copy') : null;
      if (copy) {
        var url = copy.getAttribute('data-url');
        var ok = function () {
          copy.classList.add('copied');
          toast('Link copied');
          setTimeout(function () { copy.classList.remove('copied'); }, 1400);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(ok).catch(function () { window.prompt('Copy this link:', url); });
        } else { window.prompt('Copy this link:', url); }
        return;
      }
      var nat = e.target.closest ? e.target.closest('.js-blog-native') : null;
      if (nat && navigator.share) {
        navigator.share({ title: nat.getAttribute('data-title') || 'Rova', url: nat.getAttribute('data-url') }).catch(function () {});
      }
    });
  })();

  /* live feed auto-scroll is now a pure CSS animation (see .livefeed-track),
     more reliable than JS scrollTop, which was flaky on iOS. */

  /* ---- APP-OPENED GUEST: log-in doors only (App Store 3.1.1, 2026-09-30) ----------------------
     Client twin of View::appGuestDoors() (lib/view.php). Under ?app=1 a guest must never get a
     /signup door or sign-up wording. The server rewrites every page it renders; this covers what
     arrives LATER -- XHR fragments (/feed?partial=posts, /post-cards ... carry no ?app=, so they come
     back with the web's /signup links) and cards app.js builds itself -- plus a capture-phase click
     catch as the last net for a synthetic <a href="/signup">.click(). Bare /login links gain ?app=1
     so the next page stays price-free. Members and the public web never run any of this. */
  (function () {
    if (!appGuest()) return;
    var LOGIN = '/login?app=1';
    var SIGNUP_RE = /^(?:\/(?:fr|es|de|pt|it|nl|ru|pl))?\/signup(?:[?#\/]|$)/;
    var LOGIN_RE = /^(?:\/(?:fr|es|de|pt|it|nl|ru|pl))?\/login(?:[?#]|$)/;
    var PHRASE = /^(?:new to rova\?\s*)?(?:sign up(?: free)?|join (?:rova|free|the map)|create (?:a|your) free account|start (?:free|your free trial))\b/i;
    function relabel(s) {
      var t = (s || '').trim();
      if (!t || !PHRASE.test(t)) return s;
      return s.replace(t, t.replace(PHRASE, 'Log in'));
    }
    function hrefOf(a) {
      var h = a.getAttribute('href') || '';
      if (/^https?:/i.test(h)) {
        try { var u = new URL(h); if (u.origin !== location.origin) return ''; h = u.pathname + u.search + u.hash; } catch (e) { return ''; }
      }
      return h;
    }
    function fix(a) {
      var h = hrefOf(a);
      if (!h) return;
      if (SIGNUP_RE.test(h)) {
        a.setAttribute('href', LOGIN);
        a.removeAttribute('data-auth-switch'); a.removeAttribute('data-live-next');
        ['title', 'aria-label'].forEach(function (k) { var v = a.getAttribute(k); if (v) a.setAttribute(k, relabel(v)); });
        var w = document.createTreeWalker(a, NodeFilter.SHOW_TEXT), n;
        while ((n = w.nextNode())) { var r = relabel(n.nodeValue); if (r !== n.nodeValue) n.nodeValue = r; }
      } else if (LOGIN_RE.test(h) && !/[?&]app=/.test(h)) {
        var i = h.indexOf('#'), frag = i >= 0 ? h.slice(i) : '', base = i >= 0 ? h.slice(0, i) : h;
        a.setAttribute('href', base + (base.indexOf('?') >= 0 ? '&' : '?') + 'app=1' + frag);
      }
    }
    var SEL = 'a[href*="/signup"], a[href*="/login"]';
    function sweep(root) {
      if (!root || root.nodeType !== 1) return;
      if (root.matches && root.matches(SEL)) fix(root);
      var list = root.querySelectorAll ? root.querySelectorAll(SEL) : [];
      for (var i = 0; i < list.length; i++) fix(list[i]);
    }
    sweep(document.body);
    try {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var add = muts[i].addedNodes;
          for (var j = 0; j < add.length; j++) sweep(add[j]);
        }
      }).observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
    // Last net: an anchor clicked before the observer's microtask (appendChild + .click() in one go).
    window.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (!a) return;
      var h = hrefOf(a);
      if (SIGNUP_RE.test(h)) { e.preventDefault(); e.stopImmediatePropagation(); location.href = LOGIN; }
      else if (LOGIN_RE.test(h)) { fix(a); }
    }, true);
  })();

  /* ---- THE WELCOME FEED (2026-10-10, routes/welcome_feed.php): a guest holding a pending-import setup link (the
     content-free rova_wpend flag cookie beside the HttpOnly token) gets assets/welcome-feed.js: the welcome pill and the
     setup sheet on every sign-up door. Nobody else downloads anything. URL from <meta name="rova-wf"> (versioned). */
  (function () {
    if (!isGuest() || appGuest() || !/(?:^|; *)rova_wpend=/.test(document.cookie)) return;
    var m = document.querySelector('meta[name="rova-wf"]');
    if (!m || !m.content) return;
    var s = document.createElement('script'); s.src = m.content; s.async = true; document.head.appendChild(s);
  })();

  /* ---- guest browse gate (owner) --------------------------------------
     A guest can explore the feed for a bit, then a signup wall freezes it so
     guests can't infinitely scroll media and eat bandwidth. Same idea as the
     embed's "Continue on Rova" gate (10s) but longer: fires after POST_CAP
     posts have scrolled into view (bandwidth ~ posts loaded) OR TIME_CAP ms,
     whichever first. Client-only, feed pages only, members exempt. */
  (function () {
    if (!document.querySelector('meta[name="rova-guest"]')) return;   // members/admins exempt
    var feed = document.getElementById('feed-posts');
    if (!feed) return;                                                // only where guests scroll media
    var POST_CAP = 15;        // posts a guest may view before the wall
    var TIME_CAP = 90000;     // ...or 90s of browsing, whichever first
    var seen = {}, count = 0, gated = false, t0 = Date.now();

    function gate() {
      if (gated) return; gated = true;
      var veil = document.createElement('div');
      veil.className = 'guest-gate';
      var card = document.createElement('div');
      card.className = 'guest-gate-card glass';
      card.innerHTML =
        '<img class="guest-gate-logo" src="/assets/rova-logo.png" alt="Rova" width="52" height="52">' +
        '<h2>Keep exploring Rova</h2>' +
        (appGuest()   // app-opened guest: log-in only, no sign-up door (App Store 3.1.1)
          ? '<p>Log in to keep browsing the feed.</p>' +
            '<div class="guest-gate-acts">' +
              '<a class="btn primary" href="/login?app=1">Log in</a>' +
            '</div>'
          : '<p>Create an account to keep browsing the feed.</p>' +
            '<div class="guest-gate-acts">' +
              '<a class="btn primary" href="/signup">Sign up</a>' +
              '<a class="btn gold-ghost" href="/login">Log in</a>' +
            '</div>');
      veil.appendChild(card);
      document.body.appendChild(veil);
      document.documentElement.classList.add('guest-gated');   // CSS locks scroll
      requestAnimationFrame(function () { veil.classList.add('on'); });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (ents) {
        ents.forEach(function (en) {
          if (!en.isIntersecting) return;
          var id = en.target.getAttribute('data-id') || en.target.getAttribute('data-view');
          if (!id || seen[id]) return;
          seen[id] = 1; count++; io.unobserve(en.target);
          if (count >= POST_CAP) gate();
        });
      }, { threshold: 0.4 });
      var scan = function () {
        var list = feed.querySelectorAll('.post[data-id], .pcell[data-id], .post[data-view], .pcell[data-view]');
        for (var i = 0; i < list.length; i++) { if (!list[i].__gg) { list[i].__gg = 1; io.observe(list[i]); } }
      };
      scan();
      // a grid slot that changed post in place (idle cascade) counts like a new cell: re-observe fires the initial entry
      (window.__rovaGridCellRewire = window.__rovaGridCellRewire || []).push(function (cell) { try { io.unobserve(cell); io.observe(cell); } catch (e) {} });
      try { new MutationObserver(scan).observe(feed, { childList: true, subtree: true }); } catch (e) {}
    }
    setInterval(function () { if (!gated && Date.now() - t0 >= TIME_CAP) gate(); }, 2500);
  })();

  /* ---- emoji picker (shared across composer / comments / DMs) ---------- */
  var EMOJIS = ('😀 😂 🤣 🥰 😍 😎 🤔 😉 😭 😅 🙌 👏 🔥 ✨ 💯 ❤️ 🧡 💛 💚 💙 💜 🖤 🤍 👍 👎 🙏 💪 🎉 🥳 📸 🎧 🎶 🍕 ☕ 🌅 🌙 ⭐ ⚡ 🌈 🌹 😴 😇 😜 🤝 👀 💀 🥺 🤩 😏 🤤 😤 💃 🕺 🏆 ✅ 💬 ↗️ 🫶 🤙').split(' ');
  var emojiPop = null, emojiTarget = null, emojiAnchor = null;
  function buildEmoji() {
    emojiPop = document.createElement('div');
    emojiPop.className = 'emoji-pop';
    EMOJIS.forEach(function (ch) {
      var b = document.createElement('button');
      b.type = 'button'; b.textContent = ch;
      b.addEventListener('click', function (e) { e.stopPropagation(); insertEmoji(ch); });
      emojiPop.appendChild(b);
    });
    document.body.appendChild(emojiPop);
  }
  function insertEmoji(ch) {
    var t = emojiTarget;
    if (!t) return;
    var s = (typeof t.selectionStart === 'number') ? t.selectionStart : t.value.length;
    var e2 = (typeof t.selectionEnd === 'number') ? t.selectionEnd : s;
    t.value = t.value.slice(0, s) + ch + t.value.slice(e2);
    t.focus();
    var pos = s + ch.length;
    try { t.setSelectionRange(pos, pos); } catch (err) {}
    t.dispatchEvent(new Event('input'));
  }
  function openEmoji(btn) {
    if (!emojiPop) buildEmoji();
    // Show FIRST so the panel is laid out and measurable, then place it with the shared
    // fitter. The old maths added window.scrollX/Y to a viewport rect and never checked the
    // panel FIT below the button: anchored to a DM composer -- which always sits at the very
    // bottom of the window -- it opened straight off the bottom edge, and under the phone
    // scroll lock (body is position:fixed, scrollY reads 0) it landed hundreds of px away.
    // .emoji-pop is position:fixed now, one coordinate space, same as .gif-pop.
    emojiPop.classList.add('show');         // display:none until shown -- measure it laid out
    emojiAnchor = btn;
    popFit(emojiPop, btn, 240, 120, 228);   // 228 = the picker's own max-height
  }
  // keep it fitted if the window changes underneath it (rotation, the mobile keyboard
  // shrinking the visual viewport) -- the .gif-pop twin of this lives next to gifFit
  window.addEventListener('resize', function () {
    if (emojiPop && emojiAnchor && emojiPop.classList.contains('show')) popFit(emojiPop, emojiAnchor, 240, 120, 228);
  });
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.emoji-btn') : null;
    if (btn) {
      e.preventDefault(); e.stopPropagation();
      // 'form, .hdrop-compose': the header flyout's inline DM bar is a <div>, see openGifFor.
      emojiTarget = cgifBody(btn.closest('form, .hdrop-compose'));
      if (emojiPop && emojiPop.classList.contains('show')) emojiPop.classList.remove('show');
      else openEmoji(btn);
      return;
    }
    if (emojiPop && emojiPop.classList.contains('show') && !emojiPop.contains(e.target)) {
      emojiPop.classList.remove('show');
    }
  });

  /* ---- polls: editor + voting ------------------------------------------ */
  /* co-author (co-post) input toggle, mirrors the poll editor */
  var collabBtn = document.getElementById('collab-btn');
  var collabEditor = document.getElementById('collab-editor');
  if (collabBtn && collabEditor) {
    collabBtn.addEventListener('click', function () {
      collabEditor.hidden = !collabEditor.hidden;
      collabBtn.classList.toggle('on', !collabEditor.hidden);
      if (!collabEditor.hidden) {
        var cw = document.getElementById('collab-with');
        if (cw) cw.focus();
      }
    });
  }

  /* thread / schedule editor toggle + "+ Add part" rows */
  var threadBtn = document.getElementById('thread-btn');
  var threadEditor = document.getElementById('thread-editor');
  if (threadBtn && threadEditor) {
    var threadPartsBox = document.getElementById('thread-parts');
    function addThreadPart() {
      if (!threadPartsBox) return;
      var n = threadPartsBox.querySelectorAll('.thread-part').length;
      if (n >= 11) { toast('Threads top out at 12 parts.'); return; }   // + part 1 above
      var row = document.createElement('div');
      row.className = 'thread-part-row';
      var ta = document.createElement('textarea');
      ta.className = 'input thread-part';
      ta.maxLength = 2000;
      ta.placeholder = 'Part ' + (n + 2);
      var x = document.createElement('button');
      x.type = 'button'; x.className = 'thread-part-x'; x.title = 'Remove this part';
      x.setAttribute('aria-label', 'Remove this part'); x.innerHTML = '&times;';
      x.addEventListener('click', function () {
        row.remove();
        // renumber the remaining placeholders so they always read top-down
        [].forEach.call(threadPartsBox.querySelectorAll('.thread-part'), function (t, i) {
          t.placeholder = 'Part ' + (i + 2);
        });
      });
      row.appendChild(ta); row.appendChild(x);
      threadPartsBox.appendChild(row);
      ta.focus();
    }
    threadBtn.addEventListener('click', function () {
      threadEditor.hidden = !threadEditor.hidden;
      threadBtn.classList.toggle('on', !threadEditor.hidden);
      if (!threadEditor.hidden && threadPartsBox && !threadPartsBox.querySelector('.thread-part')
          && document.getElementById('thread-add')) {
        addThreadPart();   // opening thread mode starts you at part 2
      }
    });
    var threadAdd = document.getElementById('thread-add');
    if (threadAdd) threadAdd.addEventListener('click', addThreadPart);
  }

  /* ---- SCHEDULE: the clock tool, its picker and its chip (2026-09-28, iOS parity) -------------
     The web half of the app's ScheduleSheet (src/components/InlineComposer.js). Markup and every
     sentence: views/_composer.php #sched-btn / #sched-pick / #sched-chip (t() -> data-s-*). Day, hour
     and date words come from the browser's Intl in the page language, so they need no catalogs.
     STATE IS THREE INTEGERS, NOT A DATE (the app's rule): day offset / hour / minute are independent
     choices composed into an instant only when needed, so no tap can ever build a "31 Feb".
     THE SENTENCE IS THE VALIDATION: every cell stays tappable and the line under the rows says what
     the combination means -- including "not allowed", with the rule -- and Set time is what refuses.
     The chosen instant lives in #sched-at as ISO-8601 UTC; the submit handler sends it as publish_at
     (to /compose for a post with any attachments, to /thread for a thread). The server owns the
     limits (Threads::schedule: 55 s to MAX_AHEAD_DAYS); the client floor is one minute, as in the app. */
  (function () {
    var sb = document.getElementById('sched-btn'), pk = document.getElementById('sched-pick');
    if (!sb || !pk) return;
    var chip = document.getElementById('sched-chip'), chipT = document.getElementById('sched-chip-t'),
        atIn = document.getElementById('sched-at');
    var form = sb.closest('form');
    var MAXD = parseInt(pk.getAttribute('data-max-days'), 10) || 30, MIN_MS = 60000, STEP = 5, SHEET = 560;
    var lang = document.documentElement.getAttribute('lang') || undefined;
    var chipsBox = pk.querySelector('.spick-chips'), whenEl = pk.querySelector('.spick-when'),
        goBtn = pk.querySelector('.spick-go'), clrBtn = pk.querySelector('.spick-clear'), xBtn = pk.querySelector('.mpick-x');
    var rows = {};
    [].forEach.call(pk.querySelectorAll('.spick-row'), function (r) { rows[r.getAttribute('data-k')] = r; });
    var day = 1, hour = 9, min = 0, open = false, scrim = null, trigger = null, raf = 0;
    function S(k) { return pk.getAttribute('data-s-' + k) || ''; }
    function fill(s, args) { var i = 0; return String(s).replace(/%[sd]/g, function () { var v = args[i++]; return v == null ? '' : String(v); }); }
    var rtf = null, rtfN = null;   // 'auto' for day names (Today / Tomorrow), 'always' for the distance ("in 1 day")
    try { rtf = new Intl.RelativeTimeFormat(lang, { numeric: 'auto' }); rtfN = new Intl.RelativeTimeFormat(lang, { numeric: 'always' }); } catch (e) { rtf = rtfN = null; }
    function cap(s) { s = String(s || ''); return s ? s.charAt(0).toUpperCase() + s.slice(1) : s; }
    function dayStart(n) { var d = new Date(); d.setHours(0, 0, 0, 0); d.setDate(d.getDate() + n); return d; }
    function dayLabel(n) {
      if (n <= 1 && rtf) return cap(rtf.format(n, 'day'));           // Today / Tomorrow, in the page language
      return dayStart(n).toLocaleDateString(lang, { weekday: 'short', day: 'numeric' });
    }
    function hourLabel(h) { return new Date(2000, 0, 1, h, 0).toLocaleTimeString(lang, { hour: 'numeric' }); }
    function minLabel(m) { return ':' + (m < 10 ? '0' : '') + m; }
    function dateLong(t) { return new Date(t).toLocaleDateString(lang, { weekday: 'long', month: 'short', day: 'numeric' }); }
    // the chip's date is month + day only: with the weekday the sentence overran a 390px phone's text column
    function dateShort(t) { return new Date(t).toLocaleDateString(lang, { month: 'short', day: 'numeric' }); }
    function timeShort(t) { return new Date(t).toLocaleTimeString(lang, { hour: 'numeric', minute: '2-digit' }); }
    function away(t) {
      if (!rtfN) return '';
      var m = Math.round((t - Date.now()) / 60000);
      if (m < 60) return rtfN.format(Math.max(1, m), 'minute');
      var h = Math.round(m / 60);
      if (h < 24) return rtfN.format(h, 'hour');
      return rtfN.format(Math.round(h / 24), 'day');
    }
    function at() { var d = dayStart(day); d.setHours(hour, min, 0, 0); return d.getTime(); }
    function verdict(t) {
      if (t < Date.now() + MIN_MS) return 'soon';
      if (t > Date.now() + MAXD * 86400000) return 'far';
      return '';
    }
    function current() { var v = atIn ? atIn.value : ''; var t = v ? Date.parse(v) : NaN; return isNaN(t) ? 0 : t; }
    // the quick picks set day/hour/minute, never a hidden instant, so a chip and a hand-built
    // combination are the same state and the rows below always show what the chip chose
    function quick() {
      return [
        { label: S('evening') || 'This evening', d: 0, h: 19, m: 0 },
        { label: dayLabel(1) + ' ' + hourLabel(9), d: 1, h: 9, m: 0 },
        { label: dayLabel(1) + ' ' + hourLabel(18), d: 1, h: 18, m: 0 },
        { label: rtf ? cap(rtf.format(3, 'day')) : '+3', d: 3, h: 9, m: 0 },
        { label: S('nextweek') || 'Next week', d: 7, h: 9, m: 0 }
      ];
    }
    function mk(cls, label, attrs) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = cls; b.textContent = label;
      for (var k in attrs) b.setAttribute(k, attrs[k]);
      return b;
    }
    // rebuilt on every open: "Today" and the weekday names move with the date
    function build() {
      chipsBox.innerHTML = '';
      quick().forEach(function (q) { chipsBox.appendChild(mk('spick-chip', q.label, { 'data-d': q.d, 'data-h': q.h, 'data-m': q.m })); });
      rows.day.innerHTML = ''; rows.hour.innerHTML = ''; rows.min.innerHTML = '';
      for (var n = 0; n <= MAXD; n++) rows.day.appendChild(mk('spick-cell', dayLabel(n), { 'data-v': n }));
      for (var h = 0; h < 24; h++) rows.hour.appendChild(mk('spick-cell', hourLabel(h), { 'data-v': h }));
      for (var m = 0; m < 60; m += STEP) rows.min.appendChild(mk('spick-cell', minLabel(m), { 'data-v': m }));
    }
    function lit(el, on) { el.classList.toggle('on', on); el.setAttribute('aria-pressed', on ? 'true' : 'false'); }
    function render(scrollToOn) {
      [].forEach.call(chipsBox.children, function (c) {
        lit(c, +c.getAttribute('data-d') === day && +c.getAttribute('data-h') === hour && +c.getAttribute('data-m') === min);
      });
      var want = { day: day, hour: hour, min: min };
      Object.keys(rows).forEach(function (k) {
        [].forEach.call(rows[k].children, function (c) {
          var on = +c.getAttribute('data-v') === want[k];
          lit(c, on);
          if (on && scrollToOn) {   // centre the chosen cell in its own row, never scrolling the page
            var r = rows[k], rr = r.getBoundingClientRect(), cr = c.getBoundingClientRect();
            r.scrollLeft = Math.max(0, r.scrollLeft + (cr.left - rr.left) - (r.clientWidth - cr.width) / 2);
          }
        });
      });
      var t = at(), v = verdict(t);
      whenEl.textContent = v === 'soon' ? S('soon') : v === 'far' ? S('far')
        : fill(S('when'), [dateLong(t), timeShort(t), away(t)]);
      whenEl.classList.toggle('is-bad', !!v);
      goBtn.disabled = !!v;
      clrBtn.textContent = current() ? S('postnow') : S('cancel');
    }
    function seed() {
      /* reopening on an existing choice lands on THAT choice (changing it by ten minutes is the
         commonest second visit); a fresh open defaults to TOMORROW MORNING, a time somebody would
         actually pick and one that is always valid */
      var t = current();
      if (t) {
        var d = new Date(t), base = new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
        day = Math.max(0, Math.min(MAXD, Math.round((base - dayStart(0).getTime()) / 86400000)));
        hour = d.getHours(); min = (Math.round(d.getMinutes() / STEP) * STEP) % 60;
        return;
      }
      day = 1; hour = 9; min = 0;
    }
    function paintChip() {
      var t = current();
      if (chip) chip.hidden = !t;
      if (t && chipT) chipT.textContent = fill(chipT.getAttribute('data-s-posts') || 'Posts %s at %s', [dateShort(t), timeShort(t)]);
      sb.classList.toggle('on', !!t);
      // the POST disc says what it will do: "Schedule" while a time is set
      var pb = form && form.querySelector('button[type="submit"]'), lab = form && form.querySelector('.post-cta-label');
      if (pb) {
        var word = t ? (pb.getAttribute('data-s-sched') || 'Schedule') : (pb.getAttribute('data-s-post') || 'Post');
        pb.setAttribute('aria-label', word); pb.setAttribute('title', word);
        if (lab) lab.textContent = word;
      }
    }
    function setAt(t) { if (atIn) atIn.value = t ? new Date(t).toISOString() : ''; paintChip(); }
    window.__rovaSchedClear = function () { setAt(0); };
    window.__rovaSchedAt = function () { return atIn ? atIn.value : ''; };

    function ensureScrim() {
      if (scrim) return;
      scrim = document.createElement('div');
      scrim.className = 'mpick-scrim'; scrim.hidden = true;
      document.body.appendChild(scrim);
      scrim.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); close(true); });
      scrim.addEventListener('touchmove', function (e) { e.preventDefault(); }, { passive: false });
    }
    function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }
    function place() {
      if (!open || !trigger) return;
      var vw = window.innerWidth, vh = window.innerHeight;
      pk.style.height = '';
      if (vw < SHEET) {
        pk.classList.add('is-sheet');
        pk.style.left = ''; pk.style.top = ''; pk.style.width = '';
        var vv = window.visualViewport;
        pk.style.bottom = (vv ? Math.max(0, Math.round(vh - vv.height - vv.offsetTop)) : 0) + 'px';
        pk.style.maxHeight = Math.round((vv ? vv.height : vh) * 0.88) + 'px';
        scrim.hidden = false;
        return;
      }
      pk.classList.remove('is-sheet');
      scrim.hidden = true;
      pk.style.bottom = '';
      var W = Math.min(420, vw - 16);
      pk.style.width = W + 'px';
      pk.style.maxHeight = (vh - 16) + 'px';
      var H = pk.offsetHeight, r = trigger.getBoundingClientRect();
      var top = (vh - r.bottom - 16 >= H) ? r.bottom + 8 : (r.top - 16 >= H ? r.top - 8 - H : (vh - H) / 2);
      pk.style.top = Math.round(clamp(top, 8, Math.max(8, vh - H - 8))) + 'px';
      pk.style.left = Math.round(clamp(r.left - 8, 8, vw - W - 8)) + 'px';
    }
    function placeSoon() { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; place(); }); }
    function openFor(b) {
      trigger = b;
      if (pk.parentNode !== document.body) document.body.appendChild(pk);   // escape the .glass containing block
      ensureScrim();
      build(); seed();
      open = true; pk.hidden = false;
      sb.setAttribute('aria-expanded', 'true');
      render(false); place(); render(true);   // centre the chosen cells once the box has its real width
      // a phone keeps its keyboard DOWN under the sheet (the sheet needs the lower half of the screen)
      var ae = document.activeElement;
      if (ae && ae.tagName === 'TEXTAREA' && window.matchMedia('(pointer:coarse)').matches) { try { ae.blur(); } catch (e) {} }
      try { (goBtn.disabled ? pk : goBtn).focus({ preventScroll: true }); } catch (e) {}
    }
    function close(ret) {
      if (!open) return;
      open = false;
      pk.hidden = true;
      if (scrim) scrim.hidden = true;
      sb.setAttribute('aria-expanded', 'false');
      if (ret && trigger) { try { trigger.focus({ preventScroll: true }); } catch (e) {} }
    }
    window.__rovaSchedPickOpen = function () { return open; };

    pk.setAttribute('tabindex', '-1');
    pk.addEventListener('click', function (e) {
      var c = e.target.closest ? e.target.closest('.spick-chip, .spick-cell') : null;
      if (!c) return;
      e.preventDefault();
      if (c.classList.contains('spick-chip')) {
        day = +c.getAttribute('data-d'); hour = +c.getAttribute('data-h'); min = +c.getAttribute('data-m');
        render(true);
      } else {
        var k = c.parentNode.getAttribute('data-k'), v = +c.getAttribute('data-v');
        if (k === 'day') day = v; else if (k === 'hour') hour = v; else min = v;
        render(false);
      }
    });
    goBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var t = at();
      if (verdict(t)) { render(false); return; }
      setAt(t);
      close(true);
    });
    clrBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (current()) setAt(0);   // "Post now instead"
      close(true);
    });
    xBtn.addEventListener('click', function (e) { e.preventDefault(); close(true); });
    pk.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); close(true); return; }
      if (e.key === 'Tab') {                  // keep focus inside the dialog
        var f = Array.prototype.filter.call(pk.querySelectorAll('button, a[href]'), function (x) { return !x.disabled && x.getClientRects().length; });
        if (!f.length) return;
        var a = document.activeElement;
        if (e.shiftKey && (a === f[0] || a === pk)) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && a === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }
    });
    pk.addEventListener('touchmove', function (e) {
      if (pk.classList.contains('is-sheet') && !(e.target.closest && e.target.closest('.spick-body'))) e.preventDefault();
    }, { passive: false });
    sb.addEventListener('click', function (e) {
      e.preventDefault();
      if (open) { close(true); return; }
      openFor(sb);
    });
    if (chip) chip.addEventListener('click', function (e) {
      if (e.target.closest('.sched-chip-x')) { e.preventDefault(); setAt(0); try { sb.focus({ preventScroll: true }); } catch (er) {} return; }
      if (e.target.closest('.sched-chip-edit')) { e.preventDefault(); openFor(sb); }
    });
    window.addEventListener('resize', placeSoon);
    if (window.visualViewport) window.visualViewport.addEventListener('resize', placeSoon);
    window.addEventListener('scroll', function () { if (open && !pk.classList.contains('is-sheet')) placeSoon(); }, { passive: true });
    // a stale time must never post silently: if the chosen moment passes while the composer sits
    // open, the chip re-reads it on the next paint and the submit refuses it with the rule
    paintChip();
  })();

  /* /scheduled "Change" (views/scheduled.php .js-sched-edit): the datetime field shows the reader's
     LOCAL time, filled from the row's UTC instant; on submit it is converted back to ISO UTC into the
     hidden publish_at -- a bare datetime-local value would be read in the server's zone. An untouched
     field sends no time, so saving a caption never trips the "at least a minute" rule on a post that is
     about to go out. */
  (function () {
    var forms = document.querySelectorAll('.js-sched-edit');
    if (!forms.length) return;
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    [].forEach.call(forms, function (f) {
      var dt = f.querySelector('input[type="datetime-local"]'), hid = f.querySelector('input[name="publish_at"]');
      if (!dt || !hid) return;
      var t = Date.parse(dt.getAttribute('data-utc') || '');
      if (!isNaN(t)) {
        var d = new Date(t);
        dt.value = d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) + 'T' + pad(d.getHours()) + ':' + pad(d.getMinutes());
      }
      var start = dt.value;
      f.addEventListener('submit', function () {
        hid.value = '';
        if (dt.value && dt.value !== start) {
          var nd = new Date(dt.value);   // datetime-local parses as LOCAL time
          if (!isNaN(nd.getTime())) hid.value = nd.toISOString();
        }
      });
    });
  })();

  /* ---- /search page: live results while typing --------------------------- */
  /* 2026-09-29 (search history): members get #srch-memory above the discovery panel -- Recent +
     Suggested, booted from its data-boot so the top of the page never jumps -- and it hides with
     the discovery panel while a query is typed. A submitted query (Enter / the search key), a
     person opened from the results, and a tag opened from here are recorded (SHM.record). */
  (function () {
    var input = document.getElementById('srch-q');
    var results = document.getElementById('srch-results');
    var discover = document.getElementById('srch-discover');
    var memHost = document.getElementById('srch-memory');
    var form = document.getElementById('srch-form');
    if (!input || !results) return;
    var timer = null, seq = 0, mem = null;
    function setDiscover(searching) {
      [discover, memHost].forEach(function (el) {
        if (!el) return;
        el.classList.toggle('off', searching);
        el.setAttribute('aria-hidden', searching ? 'true' : 'false');
      });
      if (mem) input.setAttribute('aria-expanded', searching ? 'false' : 'true');
    }
    function run() {
      var q = input.value.trim();
      setDiscover(q.length >= 2);
      try { history.replaceState(null, '', q ? '/search?q=' + encodeURIComponent(q) : '/search'); } catch (e) {}
      if (q.length < 2) { results.innerHTML = ''; results.classList.remove('loading'); if (mem) mem.show(); return; }
      var mine = ++seq;
      results.classList.add('loading');
      fetch('/search?partial=results&q=' + encodeURIComponent(q), {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', cache: 'no-store'
      }).then(function (r) { return r.text(); }).then(function (html) {
        if (mine !== seq) return;              // a newer keystroke superseded this
        results.classList.remove('loading');
        results.innerHTML = html;
      }).catch(function () { results.classList.remove('loading'); });
    }
    if (memHost && SHM.member()) {
      try { SHM.boot(JSON.parse(memHost.getAttribute('data-boot') || 'null'), true); } catch (e) {}   // painted now, re-read once
      memHost.removeAttribute('data-boot');
      mem = SHM.mount(memHost, {
        input: input, inline: true,
        wanted: function () { return input.value.trim().length < 2; },
        onQuery: function (q) { input.value = q; clearTimeout(timer); run(); }
      });
      input.setAttribute('role', 'combobox');
      input.setAttribute('aria-autocomplete', 'list');
      input.setAttribute('aria-controls', memHost.id);
      input.setAttribute('aria-expanded', 'true');
      mem.show();
      input.addEventListener('keydown', function (e) {
        if (input.value.trim().length < 2 && mem.key(e)) { e.stopPropagation(); }
      });
    }
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 240); });
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault(); clearTimeout(timer);
      SHM.record('query', { q: input.value.trim() });   // Enter / the search key = a SUBMITTED query
      run();
    });
    // opened FROM search: a person row in the results, the "#tag · browse the tag" row, a trending tag
    document.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a[href]') : null;
      if (!a) return;
      if (results.contains(a)) {
        var person = a.closest('.person[data-id]');
        if (person && a.classList.contains('l')) { SHM.record('user', { id: person.getAttribute('data-id') }); return; }
        if (a.classList.contains('search-tagrow')) {
          var m = /^\/tag\/([A-Za-z0-9_]{1,50})/.exec(a.getAttribute('href') || '');
          if (m) SHM.record('tag', { tag: m[1] });
        }
        return;
      }
      if (discover && discover.contains(a) && a.classList.contains('srch-tag')) {
        var t = /^\/tag\/([A-Za-z0-9_]{1,50})/.exec(a.getAttribute('href') || '');
        if (t) SHM.record('tag', { tag: t[1] });
      }
    });
    setDiscover(input.value.trim().length >= 2);
  })();

  /* ---- count-up numbers (the aside's "N people discovered you") ---------- */
  /* Server renders the real number (no-JS safe); this rewinds to 0 and rolls
     up with an ease-out so the stat lands with a little life. Skipped for
     reduced-motion folks, who get the final value untouched. */
  (function () {
    var els = document.querySelectorAll('.js-countup');
    if (!els.length) return;
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    Array.prototype.forEach.call(els, function (el) {
      var n = parseInt(el.getAttribute('data-count'), 10) || 0;
      if (n <= 0) return;
      var DUR = 900, t0 = null;
      el.textContent = '0';
      function tick(ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min(1, (ts - t0) / DUR);
        var eased = 1 - Math.pow(1 - p, 3);   // ease-out cubic
        el.textContent = Math.round(n * eased).toLocaleString('en-US');
        if (p < 1) requestAnimationFrame(tick);
      }
      setTimeout(function () { requestAnimationFrame(tick); }, 250);   // after first paint settles
    });
  })();

  /* ---- reach beacon: records which posts were genuinely SEEN ------------- */
  /* Half the card on screen for a second counts as a view. Ids batch up and
     flush every few seconds (keepalive on pagehide catches the tail). The
     server dedupes per viewer per post, so scroll-bys and replays are free.
     Guests count too (share links and the landing feed are real reach); the
     server runs the anti-bot gates, this side just refuses obvious automation. */
  (function () {
    if (!('IntersectionObserver' in window)) return;
    if (navigator.webdriver) return;   // headless/driven browsers never count
    var queued = [], sent = {}, timers = {}, flushT = null;
    function flush(tail) {
      if (!queued.length) return;
      var list = queued.splice(0, 50);
      try {
        fetch('/view-ping?ajax=1', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-CSRF-Token': csrf,
                     'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
          body: 'ids=' + encodeURIComponent(list.join(','))
              + '&q=' + encodeURIComponent(JSON.stringify(qOf(list))),
          credentials: 'same-origin',
          keepalive: !!tail
        }).catch(function () {});
      } catch (e) {}
    }
    /* `sent` dedupes the IMPRESSION -- one per post per session, as before. Evidence can arrive
       LATER than the impression (that is the normal case: the card is on screen for a second,
       then the reader stops and reads it), so a repeat call is allowed to re-queue purely to
       carry the upgrade. The server's stamp is monotonic -- GREATEST on dwell, OR on evidence,
       0->1 on qualified -- so a duplicate id in a later flush is free and can only ever add. */
    function queue(id, upgrade) {
      if (sent[id] && !upgrade) return;
      if (sent[id] && queued.indexOf(id) !== -1) return;
      sent[id] = 1;
      queued.push(id);
      if (queued.length >= 25) { flush(); return; }
      clearTimeout(flushT);
      flushT = setTimeout(flush, 4000);
    }
    /* ---- ROVA'S GENUINE-VIEW RULE, CLIENT HALF (owner 2026-08-30) ---------------------------
       "Seen should be really seen... to prevent fake stats." "The advertising industry isn't good
       for me... let's make ours better."

       The old rule here was "half the card on screen for 1 second", and MEASURED on the live
       ledger it was minting views for scrolling: 35.7% of all human view rows arrived in a beacon
       flush carrying ten or more ids, and 11,850 arrived in a flush of 24-25 -- one screenful of a
       3-up grid clearing the timer TOGETHER. That is simultaneous exposure, not attention.

       So the rule is built on SINGULAR ATTENTION instead of pixel-seconds:
         FOCUS      only ONE card accrues dwell at a time -- the one holding the largest visible
                    share of the viewport. This is the clause that kills the grid burst: nine
                    cells can be visible, but only one of them can be what you are looking at.
         SETTLED    the clock runs only while the page is NOT scrolling and the tab is visible.
         DWELL      >= DWELL_MS of that focused, settled time.
         INTENT     opening the post, expanding the caption, or engaging with it qualifies at
                    once, whatever the timer says -- those ARE attention, not proxies for it.
       Exposure alone still records an IMPRESSION (the id is still queued, so reach is unchanged
       and no creator's number moves); it simply no longer claims someone read it.

       The server never trusts any of this as a verdict -- it re-derives qualification from the
       evidence in lib/reach.php and caps the dwell. This half just reports what happened. */
    var DWELL_MS = 2000, EV_DWELL = 1, EV_OPENED = 4, EV_EXPANDED = 8, EV_ENGAGED = 16;
    var ev = {}, dwell = {}, focusId = null, focusSince = 0, ratios = {}, scrollUntil = 0;
    function idOf(el) { return el.getAttribute('data-view') || el.getAttribute('data-id'); }
    function settled() { return document.visibilityState === 'visible' && Date.now() >= scrollUntil; }
    function bank() {                                  // close the open focus interval, if any
      if (focusId && focusSince) {
        dwell[focusId] = (dwell[focusId] || 0) + (Date.now() - focusSince);
        if (dwell[focusId] >= DWELL_MS) { ev[focusId] = (ev[focusId] || 0) | EV_DWELL; queue(focusId, 1); }
      }
      focusSince = 0;
    }
    function refocus() {                               // whoever owns the most viewport wins
      var best = null, bestR = 0;
      for (var k in ratios) { if (ratios[k] > bestR) { bestR = ratios[k]; best = k; } }
      if (best !== focusId) { bank(); focusId = best; }
      focusSince = (focusId && bestR >= 0.5 && settled()) ? (focusSince || Date.now()) : 0;
    }
    addEventListener('scroll', function () { bank(); scrollUntil = Date.now() + 250; }, { passive: true });
    addEventListener('visibilitychange', function () { bank(); if (settled()) refocus(); });
    setInterval(function () { if (settled()) { bank(); refocus(); } else { bank(); } }, 500);
    /* INTENT, wherever it happens on a card. Delegated so it covers cards added later, and it
       marks the card the action happened INSIDE -- not whatever is currently focused. */
    document.addEventListener('click', function (e) {
      var el = e.target && e.target.closest && e.target.closest('.post[data-view], .post[data-id], .pcell[data-view], .pcell[data-id]');
      if (!el) return;
      var id = idOf(el); if (!id) return;
      var act = e.target.closest('.js-like, .js-repost, .js-save, .js-comment, .js-share');
      var cap = e.target.closest('.js-more, .post-body');
      ev[id] = (ev[id] || 0) | (act ? EV_ENGAGED : (cap ? EV_EXPANDED : EV_OPENED));
      queue(id, 1);
    }, true);
    function qOf(list) {                                // the per-id evidence this flush carries
      var q = {};
      for (var i = 0; i < list.length; i++) {
        var id = list[i];
        if (dwell[id] || ev[id]) { q[id] = [dwell[id] | 0, ev[id] | 0, 0, 0]; }
      }
      return q;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var el = en.target;
        var id = idOf(el);
        if (!id) return;
        ratios[id] = en.isIntersecting ? en.intersectionRatio : 0;
        if (!en.isIntersecting) { delete ratios[id]; }
        // the IMPRESSION is unchanged -- half the card for a second still records reach
        if (!sent[id] && en.isIntersecting && en.intersectionRatio >= 0.5) {
          if (!timers[id]) timers[id] = setTimeout(function () { queue(id); }, 1000);
        } else if (timers[id]) {
          clearTimeout(timers[id]);
          delete timers[id];
        }
      });
      refocus();
    }, { threshold: [0, 0.25, 0.5, 0.75, 1] });
    // .pcell = the media GRID's cells (home grid + its idle auto-cycle). They carry data-view/data-id too, so
    // a thumbnail seen for 1s counts as a genuine impression -- this is what lets the cycling grid spread views
    // across everyone over time. Server still dedupes per viewer per post, so a re-shown cell is free.
    var SEL = '.post[data-view], .post[data-id], .pcell[data-view], .pcell[data-id]';
    function watch(root) {
      var list = root.querySelectorAll ? root.querySelectorAll(SEL) : [];
      for (var i = 0; i < list.length; i++) io.observe(list[i]);
    }
    watch(document);
    // a grid SLOT that changed post in place (idle cascade, 2026-09-04): the outgoing id's focus / impression
    // timer are dropped and the element is re-observed, so the incoming post gets its own ratio + impression
    (window.__rovaGridCellRewire = window.__rovaGridCellRewire || []).push(function (cell, wasId) {
      if (wasId) { delete ratios[wasId]; if (timers[wasId]) { clearTimeout(timers[wasId]); delete timers[wasId]; } }
      try { io.unobserve(cell); io.observe(cell); } catch (e) {}
    });
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        [].forEach.call(m.addedNodes, function (n) {
          if (n.nodeType !== 1) return;
          if (n.matches && n.matches(SEL)) io.observe(n);
          else if (n.querySelectorAll) watch(n);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
    addEventListener('pagehide', function () { clearTimeout(flushT); flush(true); });
  })();

  /* ---- video PLAYS: count each completed loop in the immersive pfeed --------------------------
     A looping <video> never fires 'ended', so we detect the wrap: currentTime jumps back to ~0 after
     reaching the end. Each wrap = one completed play -> beacon /post/play. Guards against gaming:
     only in the pfeed, only while the tab is FOREGROUND and the clip is actually PLAYING, and throttled
     to 1/min/post on the client (the server re-throttles to 1/min/viewer/post and skips self-plays).
     The server keeps a running total (posts.plays), shown as the play count next to the reach chip. */
  (function () {
    if (navigator.webdriver) return;                 // driven browsers never count
    var last = new WeakMap();                         // video -> last observed currentTime
    var hit = {};                                     // postId -> last counted epoch (ms), client throttle
    function pidOf(v) {
      var p = v.closest && v.closest('.post'); if (!p) return '';
      return p.getAttribute('data-view') || p.getAttribute('data-id') || '';
    }
    function beacon(pid) {
      var now = Date.now();
      if (hit[pid] && now - hit[pid] < 60000) return; // at most 1/min/post from this client
      hit[pid] = now;
      try {
        fetch('/post/play', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-CSRF-Token': csrf,
                     'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
          body: 'id=' + encodeURIComponent(pid),
          credentials: 'same-origin', keepalive: true
        }).catch(function () {});
      } catch (e) {}
    }
    document.addEventListener('timeupdate', function (e) {
      var v = e.target;
      if (!v || v.tagName !== 'VIDEO' || !v.closest || !v.closest('.pfeed')) return;
      var t = v.currentTime || 0, prev = last.get(v);
      last.set(v, t);
      if (prev === undefined || !v.duration) return;
      // wrapped: was near the end, now back near the start -> one completed play
      if (prev - t > 1.2 && prev > v.duration - 1.5) {
        if (document.visibilityState === 'visible' && !v.paused) {
          var pid = pidOf(v); if (pid) beacon(pid);
        }
      }
    }, true);
  })();

  /* ---- ONE COMPLETE PASS of a clip (shared) ---------------------------------------------------
     "this clip has now been watched through once" is needed in two places -- the carousel slideshow's
     per-slide dwell, and the pfeed's hands-free auto-advance -- and it is NOT simply 'ended': wire()
     sets v.loop = true on every post video (views/_post.php emits the loop attribute too), so a feed
     or pfeed clip NEVER fires 'ended'. It WRAPS. Detect the wrap exactly the way the play counter
     above already does (currentTime jumps back to ~0 from near the end), keep 'ended' for the
     non-looping cases, and back the whole thing with a deadline derived from the clip's own remaining
     duration so a clip that never actually starts -- autoplay vetoed, decoder torn down by the
     recycler, HLS with an unknown/live duration -- can never strand the caller.
     Lives here rather than in either caller because writing this twice is how the two ends of a
     "play it out, don't cut it off" rule quietly drift apart. Returns a cancel(). */
  window.__rovaVideoOnePass = function (v, done, capMs) {
    if (!v || !done) { return function () {}; }
    var cap = capMs || 60000, fired = false, last = -1, t = null;
    function cleanup() {
      if (t) { clearTimeout(t); t = null; }
      try { v.removeEventListener('timeupdate', onTime); } catch (e) {}
      try { v.removeEventListener('loadedmetadata', rearm); } catch (e) {}
      try { v.removeEventListener('durationchange', rearm); } catch (e) {}
      try { v.removeEventListener('ended', fin); } catch (e) {}
    }
    function fin() { if (fired) return; fired = true; cleanup(); try { done(); } catch (e) {} }
    // The deadline is whatever is genuinely LEFT of this clip plus slack, re-derived as the duration
    // becomes known (a fresh <video> has NaN duration for the first beat) and re-pushed on every
    // timeupdate, so a clip that is playing normally always finishes by the wrap, not by the timer.
    function rearm() {
      if (fired) return;
      if (t) { clearTimeout(t); }
      var d = v.duration, rem = (d && isFinite(d)) ? Math.max(0, d - (v.currentTime || 0)) : 0;
      t = setTimeout(fin, Math.min(cap, rem ? (rem * 1000 + 3000) : cap));
    }
    function onTime() {
      var d = v.duration, c = v.currentTime || 0;
      /* W#58: while a finger owns the position (the seek bar stamps v._scrubbing on every
         pointerdown/move, and for a short grace after release so the async seek's own timeupdate
         is covered too), NOTHING it does counts as a pass -- a drag from the end back to the start
         is byte-identical to the wrap below, and a drag to the right edge of a non-loop clip is
         byte-identical to "ran out". Resync `last` to the scrubbed position so detection resumes
         honestly from wherever the finger left the clip; the stamp self-expires, so a genuine wrap
         a moment later still advances the slideshow / hands-free / carousel exactly as before. */
      if (v._scrubbing && Date.now() - v._scrubbing < 600) { last = c; rearm(); return; }
      if (last >= 0 && d && isFinite(d) && last - c > 1.2 && last > d - 1.5) { fin(); return; }   // wrapped = one full pass
      if (d && isFinite(d) && !v.loop && c >= d - 0.15) { fin(); return; }                        // ran out and stopped there
      last = c; rearm();
    }
    v.addEventListener('timeupdate', onTime);
    v.addEventListener('loadedmetadata', rearm);
    v.addEventListener('durationchange', rearm);
    v.addEventListener('ended', fin);
    rearm();
    return function () { fired = true; cleanup(); };
  };

  /* ---- PWA: register the worker + a gentle install nudge ----------------- */
  if ('serviceWorker' in navigator) {
    try { navigator.serviceWorker.register('/sw.js'); } catch (e) {}
  }
  (function () {
    var KEY = 'rova_a2hs_snooze';
    function snoozed() {
      try { return (Date.now() - (+localStorage.getItem(KEY) || 0)) < 14 * 86400000; }
      catch (e) { return true; }
    }
    function standalone() {
      return (window.matchMedia && matchMedia('(display-mode: standalone)').matches) || navigator.standalone === true;
    }
    if (standalone()) return;
    var deferred = null;
    window.addEventListener('beforeinstallprompt', function (e) {
      e.preventDefault();
      deferred = e;
      if (snoozed() || !document.getElementById('bell')) return;   // members only, respect the snooze
      if (document.getElementById('a2hs-pill')) return;
      var d = document.createElement('div');
      d.className = 'a2hs-pill glass';
      d.id = 'a2hs-pill';
      // NOTE: /assets/ is immutable 1y at the edge, so a re-rendered icon needs a NEW
      // filename here, never fresh bytes at the old URL. icon-192.png stays on disk.
      d.innerHTML = '<img src="/assets/rova-icon-v5-192.png" alt="" class="a2hs-ico">'
        + '<span class="a2hs-txt"><b>Install Rova</b><span>Full screen, straight from your home screen</span></span>'
        + '<button class="btn sm primary" id="a2hs-go" type="button">Install</button>'
        + '<button class="a2hs-x" id="a2hs-x" type="button" aria-label="Not now">&times;</button>';
      document.body.appendChild(d);
      requestAnimationFrame(function () { d.classList.add('show'); });
      document.getElementById('a2hs-x').addEventListener('click', function () {
        try { localStorage.setItem(KEY, String(Date.now())); } catch (e2) {}
        d.remove();
      });
      document.getElementById('a2hs-go').addEventListener('click', function () {
        if (!deferred) { d.remove(); return; }
        deferred.prompt();
        deferred.userChoice.then(function () {
          try { localStorage.setItem(KEY, String(Date.now())); } catch (e2) {}
          d.remove();
          deferred = null;
        });
      });
    });
  })();

  /* ---- web push (settings card) ----------------------------------------- */
  (function () {
    var row = document.getElementById('push-row');
    if (!row) return;
    var status = document.getElementById('push-status');
    var onBtn = document.getElementById('push-enable');
    var offBtn = document.getElementById('push-disable');
    var supported = 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
    function say(msg) { if (status) status.textContent = msg; }
    function show(btn, on) { if (btn) btn.hidden = !on; }
    // iOS Safari only exposes Web Push inside an installed (Home Screen) PWA. In a
    // normal Safari tab PushManager is absent, so guide instead of saying "unsupported".
    var iOS = ('standalone' in navigator) || /iP(hone|ad|od)/.test(navigator.userAgent)
              || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    var standaloneNow = navigator.standalone === true
              || (window.matchMedia && matchMedia('(display-mode: standalone)').matches);
    if (!supported) {
      say(iOS && !standaloneNow
        ? 'On iPhone or iPad: tap Share, then “Add to Home Screen,” and open Rova from there to turn on push.'
        : 'This browser does not support push notifications.');
      return;
    }

    function b64ToBytes(s) {
      var pad = '='.repeat((4 - (s.length % 4)) % 4);
      var raw = atob((s + pad).replace(/-/g, '+').replace(/_/g, '/'));
      var out = new Uint8Array(raw.length);
      for (var i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
      return out;
    }
    function paint(sub) {
      if (sub) {
        say('On for this device.');
        show(onBtn, false); show(offBtn, true);
      } else if (Notification.permission === 'denied') {
        say('Blocked in your browser settings for this site.');
        show(onBtn, false); show(offBtn, false);
      } else {
        say(row.getAttribute('data-devices') > '0' ? 'On elsewhere, off on this device.' : 'Off.');
        show(onBtn, true); show(offBtn, false);
      }
    }
    function current() {
      return navigator.serviceWorker.getRegistration('/sw.js').then(function (reg) {
        return reg ? reg.pushManager.getSubscription() : null;
      }).catch(function () { return null; });
    }
    current().then(paint);

    if (onBtn) onBtn.addEventListener('click', function () {
      onBtn.disabled = true;
      Notification.requestPermission().then(function (perm) {
        if (perm !== 'granted') { onBtn.disabled = false; paint(null); return; }
        fetch('/push/key', { headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }, credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (!res || !res.ok) throw new Error('nokey');
            return navigator.serviceWorker.register('/sw.js').then(function (reg) {
              return navigator.serviceWorker.ready.then(function () {
                return reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: b64ToBytes(res.key) });
              });
            });
          })
          .then(function (sub) {
            var j = sub.toJSON();
            return postJson('/push/subscribe', { endpoint: sub.endpoint, p256dh: j.keys.p256dh, auth: j.keys.auth })
              .then(function (r2) {
                onBtn.disabled = false;
                if (r2 && r2.ok) { paint(sub); toast('Push is on for this device 🎉'); }
                else { sub.unsubscribe(); paint(null); toast('Could not finish turning push on.'); }
              });
          })
          .catch(function () { onBtn.disabled = false; paint(null); toast('Could not turn push on.'); });
      });
    });

    if (offBtn) offBtn.addEventListener('click', function () {
      offBtn.disabled = true;
      current().then(function (sub) {
        if (!sub) { offBtn.disabled = false; paint(null); return; }
        var ep = sub.endpoint;
        sub.unsubscribe().then(function () {
          postJson('/push/unsubscribe', { endpoint: ep }).catch(function () {});
          offBtn.disabled = false;
          paint(null);
          toast('Push is off for this device.');
        }).catch(function () { offBtn.disabled = false; });
      });
    });
  })();

  /* UTC stamps -> the reader's local clock (scheduled page) */
  (function () {
    var els = document.querySelectorAll('.js-localtime[data-utc]');
    if (!els.length) return;
    els.forEach(function (el) {
      try {
        var d = new Date(el.getAttribute('data-utc'));
        if (!isNaN(d.getTime())) el.textContent = d.toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' });
      } catch (e) {}
    });
  })();

  /* ADMIN LOCAL TIMES (owner 2026-10-02, iPhone at 5:54 PM PDT: "The times are wrong it's 5:54 not
     0:54"). admin_time() (lib/view.php) prints <time class="js-lt" datetime="<UTC ISO>" data-lt="<PHP
     date() format>"> already rendered in the rova_tz cookie's zone, so for any admin who has loaded a
     page before, the server text IS final and this pass changes nothing (no layout shift). It only
     rewrites when the browser's own zone disagrees -- a first visit with no cookie, a trip -- and it
     follows rows that arrive later (lazy /admin panels, sorts, pagers, "Show more"). Same format
     letters as PHP's date(), English month/day names exactly like the server, so the two can never
     render the same instant differently. Also: every Founders scroll box (.fp-box) starts at its
     LEFT edge when it appears, so the member column is the first thing on a phone.
     MEMBER + GUEST PAGES TOO (2026-10-02): local_time_tag() and ago_html() (lib/view.php) emit the
     same <time class="js-lt">. A member render with a rova_tz cookie is already in their zone (ago_html
     then prints plain text, nothing to do); a SHARED render -- edge-cached guest HTML and the sessionless
     guest fragments behind it -- is UTC by rule (one viewer's zone must never be baked into bytes the
     edge hands everyone), and this pass localises it. So the observer is armed on admin and on an edge
     render (no csrf-token meta = EdgeCache::isActive(), lib/view.php), where later feed/profile pages
     arrive as sessionless fragments; a member page never pays for it. */
  (function () {
    var onAdmin = /^\/admin(\/|$)/.test(location.pathname);
    var onEdge = !onAdmin && !document.querySelector('meta[name="csrf-token"]');
    if (!onAdmin && !onEdge && !document.querySelector('time.js-lt')) return;
    var MS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var MF = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    var DS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    var DF = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    function p2(n) { return (n < 10 ? '0' : '') + n; }
    function fmt(d, f) {
      var o = '', h = d.getHours();
      for (var i = 0; i < f.length; i++) {
        var c = f.charAt(i);
        switch (c) {
          case '\\': i++; o += f.charAt(i); break;
          case 'M': o += MS[d.getMonth()]; break;
          case 'F': o += MF[d.getMonth()]; break;
          case 'n': o += (d.getMonth() + 1); break;
          case 'm': o += p2(d.getMonth() + 1); break;
          case 'j': o += d.getDate(); break;
          case 'd': o += p2(d.getDate()); break;
          case 'D': o += DS[d.getDay()]; break;
          case 'l': o += DF[d.getDay()]; break;
          case 'Y': o += d.getFullYear(); break;
          case 'y': o += p2(d.getFullYear() % 100); break;
          case 'H': o += p2(h); break;
          case 'G': o += h; break;
          case 'g': o += (h % 12 || 12); break;
          case 'h': o += p2(h % 12 || 12); break;
          case 'i': o += p2(d.getMinutes()); break;
          case 's': o += p2(d.getSeconds()); break;
          case 'A': o += h < 12 ? 'AM' : 'PM'; break;
          case 'a': o += h < 12 ? 'am' : 'pm'; break;
          default: o += c;
        }
      }
      return o;
    }
    function run(root) {
      var els = root.matches && root.matches('time.js-lt') ? [root] : root.querySelectorAll('time.js-lt[datetime]');
      for (var i = 0; i < els.length; i++) {
        var t = Date.parse(els[i].getAttribute('datetime') || '');
        if (isNaN(t)) continue;
        var s = fmt(new Date(t), els[i].getAttribute('data-lt') || 'M j, g:i A');
        if (els[i].textContent !== s) els[i].textContent = s;
      }
      if (!onAdmin) return;
      /* TITLE-ONLY instants (2026-10-02, the Members email chip): a title attribute cannot hold a <time>, so
         the element carries data-ltt (UTC ISO) + data-ltp (prefix) and the title is rebuilt here in the
         browser's zone, with its short zone name, in the same 'M j, Y g:i A' the server used. */
      var tt = root.matches && root.matches('[data-ltt]') ? [root] : root.querySelectorAll('[data-ltt]');
      if (tt.length) {
        var zf = null;
        try { zf = new Intl.DateTimeFormat('en-US', { timeZoneName: 'short' }); } catch (e) {}
        for (var q = 0; q < tt.length; q++) {
          var tv = Date.parse(tt[q].getAttribute('data-ltt') || '');
          if (isNaN(tv)) continue;
          var zn = '';   // the zone name AT that instant (PST in January, PDT in July), like PHP's 'T'
          try { var zp = zf ? zf.formatToParts(new Date(tv)) : []; for (var z = 0; z < zp.length; z++) { if (zp[z].type === 'timeZoneName') zn = ' ' + zp[z].value; } } catch (e) {}
          var ts = (tt[q].getAttribute('data-ltp') || '') + fmt(new Date(tv), 'M j, Y g:i A') + zn;
          if (tt[q].getAttribute('title') !== ts) tt[q].setAttribute('title', ts);
        }
      }
      var boxes = root.classList && root.classList.contains('fp-box') ? [root] : root.querySelectorAll('.fp-box');
      for (var j = 0; j < boxes.length; j++) { if (boxes[j].scrollLeft) boxes[j].scrollLeft = 0; }
    }
    try { run(document); } catch (e) {}
    if ((!onAdmin && !onEdge) || !window.MutationObserver) return;
    /* Only ELEMENT additions are looked at: rewriting a <time>'s text adds a text node, which is
       skipped, so this can never feed itself. */
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var add = muts[i].addedNodes;
        for (var k = 0; k < add.length; k++) {
          var n = add[k];
          if (n.nodeType !== 1) continue;
          // edge pages: a live-collection length check first, so the feed's own DOM churn costs ~nothing
          if (!onAdmin && n.tagName !== 'TIME' && !n.getElementsByClassName('js-lt').length) continue;
          try { run(n); } catch (e) {}
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  })();

  /* ---- TRIP EDITOR (db/0142) ---------------------------------------------
   * Two place pickers over GET /place-search. Everything here is explicit:
   * a place is set ONLY by choosing a suggestion or by leaving typed text in
   * the box, and there is no geolocation call anywhere in this block. That is
   * a deliberate omission, not an oversight -- see lib/trips.php.
   *
   * Suggestions are fetched on a 180 ms debounce, the in-flight request is
   * abandoned when a newer keystroke supersedes it, and results below two
   * characters are not requested at all. */
  (function tripEditor() {
    window.__rovaTripWire = wire;   // the post editor's Place panel uses this same picker
    var btn = document.getElementById('trip-btn');
    var ed  = document.getElementById('trip-editor');
    if (!btn || !ed) { return; }

    var toIn   = document.getElementById('trip-to');
    var frIn   = document.getElementById('trip-from');
    var toId   = document.getElementById('trip-to-id');
    var toText = document.getElementById('trip-to-text');
    var frId   = document.getElementById('trip-from-id');
    var kind   = document.getElementById('trip-kind');
    var rm     = document.getElementById('trip-remove');
    var fromRow = ed.querySelector('.trip-ed-from');

    function syncKind() {
      // An origin is meaningless on a check-in, and the server drops it anyway.
      var checkin = kind && kind.value === 'checkin';
      if (fromRow) { fromRow.hidden = !!checkin; }
      if (checkin && frIn) { frIn.value = ''; if (frId) { frId.value = ''; } }
      if (toIn) { toIn.placeholder = checkin ? 'Search a place' : 'Search a city or country'; }
    }
    if (kind) { kind.addEventListener('change', syncKind); }

    btn.addEventListener('click', function () {
      ed.hidden = !ed.hidden;
      btn.classList.toggle('on', !ed.hidden);
      if (!ed.hidden) { syncKind(); if (toIn) { toIn.focus(); } }
    });
    if (rm) {
      rm.addEventListener('click', function () {
        ed.hidden = true;
        btn.classList.remove('on');
        [toIn, frIn].forEach(function (el) { if (el) { el.value = ''; } });
        [toId, frId, toText].forEach(function (el) { if (el) { el.value = ''; } });
      });
    }

    function wire(input, listEl, hiddenId, textEl) {
      if (!input || !listEl) { return; }
      var t = null, ctrl = null, items = [], active = -1;

      function close() {
        listEl.hidden = true; listEl.innerHTML = ''; items = []; active = -1;
        input.setAttribute('aria-expanded', 'false');
      }
      function choose(p) {
        input.value = p.label;
        if (hiddenId) { hiddenId.value = String(p.id); }
        // Typed text is the fallback ONLY; a chosen place clears it so the
        // server can never see both and have to guess which the member meant.
        if (textEl) { textEl.value = ''; }
        close();
      }
      function paint() {
        listEl.innerHTML = '';
        items.forEach(function (p, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'trip-sugg-item' + (i === active ? ' on' : '');
          b.setAttribute('role', 'option');
          b.setAttribute('aria-selected', i === active ? 'true' : 'false');
          b.innerHTML = '<span class="trip-sugg-name"></span><span class="trip-sugg-cc"></span>';
          b.querySelector('.trip-sugg-name').textContent = p.label;
          b.querySelector('.trip-sugg-cc').textContent = p.kind === 'country' ? 'Country' : p.country;
          b.addEventListener('mousedown', function (e) { e.preventDefault(); choose(p); });
          listEl.appendChild(b);
        });
        listEl.hidden = items.length === 0;
        input.setAttribute('aria-expanded', items.length ? 'true' : 'false');
      }
      function fetchNow(q) {
        if (ctrl) { try { ctrl.abort(); } catch (e) {} }
        ctrl = (typeof AbortController !== 'undefined') ? new AbortController() : null;
        fetch('/place-search?q=' + encodeURIComponent(q), {
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          signal: ctrl ? ctrl.signal : undefined
        })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (j) {
            if (!j || !j.places) { return; }
            // A late reply for a query the member has already typed past must
            // not repaint the list under them.
            if (input.value.trim() !== q) { return; }
            items = j.places; active = -1; paint();
          })
          .catch(function () {});
      }

      input.addEventListener('input', function () {
        // Free text stands on its own until a suggestion is taken, so the id is
        // cleared the moment the box no longer matches what was chosen.
        if (hiddenId) { hiddenId.value = ''; }
        if (textEl) { textEl.value = input.value.trim(); }
        var q = input.value.trim();
        if (t) { clearTimeout(t); }
        if (q.length < 2) { close(); return; }
        t = setTimeout(function () { fetchNow(q); }, 180);
      });
      input.addEventListener('keydown', function (e) {
        if (listEl.hidden || !items.length) { return; }
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault();
          active = (active + (e.key === 'ArrowDown' ? 1 : items.length - 1)) % items.length;
          paint();
        } else if (e.key === 'Enter' && active >= 0) {
          e.preventDefault(); choose(items[active]);
        } else if (e.key === 'Escape') { close(); }
      });
      input.addEventListener('blur', function () { setTimeout(close, 120); });
    }

    wire(toIn, document.getElementById('trip-to-list'), toId, toText);
    wire(frIn, document.getElementById('trip-from-list'), frId, null);
    syncKind();
  })();

  var pollBtn = document.getElementById('poll-btn');
  var pollEditor = document.getElementById('poll-editor');
  if (pollBtn && pollEditor) {
    var pollForm = pollEditor.closest('form');
    var pollTa = pollForm ? pollForm.querySelector('textarea[name="body"]') : null;
    var pollPh = pollTa ? pollTa.getAttribute('placeholder') : null;   // remember the original prompt
    function pollPlaceholder(on) { if (pollTa) pollTa.placeholder = on ? 'Ask a question…' : (pollPh || ''); }
    pollBtn.addEventListener('click', function () { pollEditor.hidden = !pollEditor.hidden; pollBtn.classList.toggle('on', !pollEditor.hidden); pollPlaceholder(!pollEditor.hidden); });
    var pollAdd = document.getElementById('poll-add');
    if (pollAdd) {
      pollAdd.addEventListener('click', function () {
        var inputs = pollEditor.querySelectorAll('.poll-opt-input');
        if (inputs.length >= 4) { toast('Up to 4 options'); return; }
        var i = document.createElement('input');
        i.className = 'input poll-opt-input';
        i.name = 'poll_options[]';
        i.maxLength = 80;
        i.placeholder = 'Option ' + (inputs.length + 1);
        pollEditor.insertBefore(i, pollEditor.querySelector('.poll-editor-actions'));
      });
    }
    var pollRemove = document.getElementById('poll-remove');
    if (pollRemove) {
      pollRemove.addEventListener('click', function () {
        pollEditor.hidden = true;
        pollBtn.classList.remove('on');
        pollEditor.querySelectorAll('.poll-opt-input').forEach(function (el) { el.value = ''; });
        pollPlaceholder(false);
      });
    }
  }

  function renderPoll(pollEl, res) {
    var html = '';
    res.options.forEach(function (o) {
      var pct = res.total > 0 ? Math.round(o.votes * 100 / res.total) : 0;
      // data-opt + .poll-votes mirror the server markup so the live ticker can keep
      // retallying this poll after a vote re-rendered it
      html += '<div class="poll-opt result' + (res.my_vote === o.id ? ' mine' : '') + '" data-opt="' + o.id + '">' +
              '<span class="poll-bar" style="width:' + pct + '%"></span>' +
              '<span class="poll-text">' + escHtml(o.text) + '</span>' +
              '<span class="poll-pct">' + pct + '%</span></div>';
    });
    html += '<div class="poll-total"><span class="poll-votes">' + res.total +
            ' vote' + (res.total === 1 ? '' : 's') + '</span></div>';
    pollEl.innerHTML = html;
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('.js-vote') : null;
    if (!b) return;
    e.preventDefault();
    // Poll voting joined the blocked set on 2026-08-08 (Polls::vote). Ahead of the .picked paint
    // and the .voting lock, so a refused tap leaves the option exactly as it found it.
    if (membershipStop()) { return; }
    var pollEl = b.closest('.poll');
    // instant feedback: light the tapped option up right away (we can't fake the
    // percentages — only the server knows the other tallies — but the tap must
    // never feel ignored); the results render when the response lands.
    if (pollEl) {
      if (pollEl.classList.contains('voting')) return;   // one vote in flight
      pollEl.classList.add('voting');
    }
    b.classList.add('picked');
    postJson('/vote', { post_id: b.getAttribute('data-post'), option_id: b.getAttribute('data-opt') })
      .then(function (res) {
        if (pollEl) pollEl.classList.remove('voting');
        if (res && res.options) { renderPoll(pollEl, res); return; }
        b.classList.remove('picked');
        if (res && res.error) toast(res.error);
      }).catch(function (err) {
        if (pollEl) pollEl.classList.remove('voting');
        b.classList.remove('picked');
        if (!err || err.message === 'reauth') return;
        toast('Couldn’t record your vote, check your connection');
      });
  });

  /* ---- settings: bio character counter ----------------------------------
     The bio field stops accepting text at its ceiling and always did; what it never did
     was SAY so, so a long bio "saved" (success flash and all) and came back sheared
     mid-word. Reported 2026-07-31. maxlength still does the stopping, straight from
     Users::BIO_MAX; this only makes the stop visible before you hit it. */
  (function () {
    var ta = document.getElementById('bio'), box = document.getElementById('bio-count');
    if (!ta || !box) return;
    var max = parseInt(ta.getAttribute('maxlength'), 10) || 0;
    if (!max) return;
    function paint() {
      var left = max - ta.value.length;
      if (left > 120) { box.hidden = true; return; }   // stay out of the way until it matters
      box.hidden = false;
      box.textContent = left > 0
        ? left + ' character' + (left === 1 ? '' : 's') + ' left'
        : 'That is the full ' + max + ' characters. Anything more will not be saved.';
      box.style.color = left > 0 ? '' : 'var(--accent-text)';
    }
    ta.addEventListener('input', paint);
    paint();
  })();

  /* ---- live poll tallies ------------------------------------------------
     A poll is the one thing on a Rova page whose interesting number moves because of
     OTHER people, so a poll you are looking at retallies on a timer instead of sitting
     stale until a reload.

     Three rules keep it cheap enough to leave on for every visitor:
       1. Only polls in (or near) the viewport are asked about, and they go up in ONE
          batched request -- a long feed with six polls costs one round-trip, not six.
       2. It eases off 8s -> 60s while nothing moves and snaps back to 8s the moment a
          tally changes, the tab is refocused, or you vote.
       3. It goes quiet entirely while the tab is hidden.

     Deliberately a timer rather than SSE/WebSocket: a long-lived connection per open tab
     would pin a FastCGI worker for the length of the session, and this origin is CPU-bound
     at roughly 150 req/s -- held connections are the one thing it cannot spend.

     THE RULE THIS MUST NOT BREAK: someone who has not voted never sees percentages. Live
     counts refresh the public running total; they never reveal the split early. */
  (function () {
    var MIN = 8000, MAX = 60000, IDLE = 5000;
    var wait = MIN, timer = null, busy = false, sig = '', obs = null;

    function watch() {
      var polls = document.querySelectorAll('.poll[data-post]');
      if (!obs && window.IntersectionObserver) {
        obs = new IntersectionObserver(function (entries) {
          for (var i = 0; i < entries.length; i++) { entries[i].target.__pv = entries[i].isIntersecting; }
        }, { rootMargin: '250px 0px' });
      }
      for (var j = 0; j < polls.length; j++) {
        if (polls[j].__pw) continue;
        polls[j].__pw = 1;
        polls[j].__pv = true;            // assume on-screen until the observer corrects it
        if (obs) obs.observe(polls[j]);
      }
      return polls;
    }

    function onscreen() {
      var polls = watch(), ids = [], seen = {};
      for (var i = 0; i < polls.length; i++) {
        var el = polls[i];
        if (el.__pv === false) continue;                    // scrolled away
        if (el.classList.contains('voting')) continue;      // a vote is in flight: don't race it
        var id = el.getAttribute('data-post');
        if (!id || seen[id]) continue;
        seen[id] = 1; ids.push(id);
      }
      return ids;
    }

    function votesTxt(n) { return n + ' vote' + (n === 1 ? '' : 's'); }

    function paint(el, p) {
      var total = p.total | 0;
      var rows = el.querySelectorAll('.poll-opt.result');
      if (rows.length) {
        // already showing results: retally in place so the bars just slide to their new width
        for (var i = 0; i < p.options.length; i++) {
          var o = p.options[i];
          var row = el.querySelector('.poll-opt.result[data-opt="' + o.id + '"]') || rows[i];
          if (!row) continue;
          var pct = total > 0 ? Math.round(o.votes * 100 / total) : 0;
          var bar = row.querySelector('.poll-bar'), pc = row.querySelector('.poll-pct');
          if (bar) bar.style.width = pct + '%';
          if (pc && pc.textContent !== pct + '%') pc.textContent = pct + '%';
        }
      } else if (p.closed) {
        // It closed while they were looking at it. A reload would show the results now, so
        // show them -- otherwise a dead poll sits there inviting a tap that can't land.
        renderPoll(el, { options: p.options, total: total, my_vote: p.my_vote });
        var ft = el.querySelector('.poll-total');
        if (ft) {
          ft.innerHTML = '<span class="poll-voted">Poll closed</span> · final results · ' +
                         '<span class="poll-votes">' + votesTxt(total) + '</span>';
        }
        return;
      }
      var vt = el.querySelector('.poll-votes');
      if (vt && vt.textContent !== votesTxt(total)) vt.textContent = votesTxt(total);
    }

    function schedule(ms) { clearTimeout(timer); timer = setTimeout(tick, ms || wait); }
    function ease() { wait = Math.min(Math.round(wait * 1.5), MAX); }

    function tick() {
      if (document.hidden || busy) { schedule(IDLE); return; }
      var ids = onscreen();
      if (!ids.length) { schedule(IDLE); return; }   // nothing on screen: no request at all
      busy = true;
      fetch('/poll-live?ids=' + encodeURIComponent(ids.join(',')), {
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        credentials: 'same-origin'
      }).then(function (r) { return r.json(); })
        .then(function (d) {
          busy = false;
          var polls = d && d.polls;
          if (!polls) { ease(); schedule(); return; }
          var next = '';
          for (var i = 0; i < ids.length; i++) {
            var p = polls[ids[i]];
            if (!p || !p.options) continue;
            next += ids[i] + ':' + p.total + '|';
            // the same post can be on screen twice (feed card + an expanded view)
            var els = document.querySelectorAll('.poll[data-post="' + ids[i] + '"]');
            for (var j = 0; j < els.length; j++) {
              if (!els[j].classList.contains('voting')) paint(els[j], p);
            }
          }
          if (sig !== '' && next !== sig) { wait = MIN; } else { ease(); }
          sig = next;
          schedule();
        })
        .catch(function () { busy = false; ease(); schedule(); });
    }

    function hurry() { wait = MIN; schedule(400); }
    document.addEventListener('visibilitychange', function () { if (!document.hidden) hurry(); });
    // your own vote is the likeliest moment for other votes to be landing too
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('.js-vote')) hurry();
    }, true);
    window.__rovaPollRefresh = hurry;
    schedule(MIN);
  })();

  /* ---- compose: AJAX submit with progress overlay + no duplicate posts -- */
  function showPostOverlay() {
    var ov = document.createElement('div');
    ov.className = 'post-overlay';
    ov.innerHTML = '<div class="post-overlay-card">' +
      '<div class="post-spin"></div>' +
      '<svg class="post-check" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="11"/><path d="M7 12.4l3.3 3.3L17 8.6"/></svg>' +
      '<div class="post-overlay-txt">Posting…</div>' +
      '<div class="post-bar"><div class="post-bar-fill"></div></div></div>';
    document.body.appendChild(ov);
    requestAnimationFrame(function () { ov.classList.add('show'); });
    return ov;
  }
  // flip the overlay from "posting" spinner to a settled checkmark -- the beat before the fresh card
  // lands, so the whole thing reads as one motion instead of a spinner blinking out.
  function succeedPostOverlay(ov) {
    if (!ov) return;
    ov.classList.add('done');
    var t = ov.querySelector('.post-overlay-txt'); if (t) t.textContent = 'Posted';
  }
  function setPostProgress(ov, frac) {
    var fill = ov.querySelector('.post-bar-fill');
    if (fill) fill.style.width = Math.round(Math.max(0.06, Math.min(1, frac)) * 100) + '%';
    if (frac >= 1) { var t = ov.querySelector('.post-overlay-txt'); if (t) t.textContent = 'Almost there…'; }
  }
  function hidePostOverlay(ov) {
    if (!ov) return;
    ov.classList.remove('show');
    setTimeout(function () { if (ov.parentNode) ov.parentNode.removeChild(ov); }, 250);
  }
  // Empty the composer after a post that DIDN'T reload the page (live-insert path), so it's ready for
  // the next post: clear the text, media previews, any staged gif, and release the send lock.
  function resetComposer(form) {
    if (!form) return;
    var ta = form.querySelector('textarea[name="body"]');
    if (ta) { ta.value = ''; ta.style.height = ''; try { ta.dispatchEvent(new Event('input')); } catch (e) {} ta.blur(); }
    var prev = document.getElementById('compose-preview'); if (prev) { prev.innerHTML = ''; prev.hidden = true; }
    // the grid-hide row goes away with the media it belongs to, and un-checks itself: the next post is a
    // new decision, and an invisible checked box would silently keep posts off the grid (0119)
    // ...and the "made with AI" tick (0175) goes with it, for the identical reason: an invisible
    // checked box would silently mark the NEXT post as generated.
    ['compose-gridhide', 'compose-ai'].forEach(function (id) {
      var r = document.getElementById(id);
      if (r) { r.hidden = true; var c = r.querySelector('input[type="checkbox"]'); if (c) c.checked = false; }
    });
    var gif = form.querySelector('input[name="gif_url"]'); if (gif) gif.value = '';
    var file = form.querySelector('input[type="file"]'); if (file) file.value = '';
    // collapse the toggle editors and clear their button "on" glow (poll / thread / collab / trip)
    ['poll', 'thread', 'collab', 'trip'].forEach(function (k) {
      var ed = document.getElementById(k + '-editor'); if (ed) ed.hidden = true;
      var b = document.getElementById(k + '-btn'); if (b) b.classList.remove('on');
    });
    /* The trip's VALUES have to be cleared too, not just the panel hidden: the
       ids and the free-text fallback are hidden inputs, so a collapsed-but-full
       editor would silently attach the last post's destination to the next one. */
    ['trip-to', 'trip-from', 'trip-to-id', 'trip-from-id', 'trip-to-text'].forEach(function (id) {
      var el = document.getElementById(id); if (el) { el.value = ''; }
    });
    form.setAttribute('data-posting', '');
    // a scheduled time belongs to the post that just went; the next one starts as "post now"
    if (window.__rovaSchedClear) { try { window.__rovaSchedClear(); } catch (e) {} }
    // re-arm the Post button: the realtime feed-insert success path keeps this page
    // (never navigates), so the button we disabled on submit must be re-enabled here
    // or the composer stays locked until a manual refresh.
    var pbtn = form.querySelector('button[type="submit"]'); if (pbtn) pbtn.disabled = false;
    // Mint a FRESH idempotency token for the NEXT post. The one baked into the page HTML was consumed by the
    // post we just made and is now recorded server-side; without this the next post (same page, no reload)
    // reuses it, trips the server's duplicate guard, and is silently dropped -- the "second post in the same
    // session fails" bug. A per-post token (not per-submit) still lets the server dedupe a real double-submit.
    var tok = form.querySelector('input[name="post_token"]');
    if (tok) {
      tok.value = (window.crypto && crypto.randomUUID)
        ? crypto.randomUUID().replace(/-/g, '')
        : (Date.now().toString(36) + Math.random().toString(36).slice(2, 14));
    }
  }
  /* A SCHEDULED POST LANDED (2026-09-28): nothing was published, so no card is inserted and no
     "Posted" check is shown -- that would be a lie. The composer empties exactly as after a post
     (stageReset drops the staged list and the sessionStorage draft: the server now holds that media
     for the queue), the time clears, and one sentence says when it goes and where to cancel it. */
  function schedLanded(form, res) {
    try { stageReset(); } catch (e) {}
    resetComposer(form);
    var pk = document.getElementById('sched-pick');
    var tpl = (pk && pk.getAttribute('data-s-done')) || 'Scheduled for %s. You can cancel it under Scheduled posts.';
    var when = '';
    try { when = new Date(res.at).toLocaleString(document.documentElement.getAttribute('lang') || undefined, { dateStyle: 'medium', timeStyle: 'short' }); } catch (e) {}
    toast(tpl.replace('%s', when), 6000, { href: '/scheduled', label: (pk && pk.querySelector('.spick-queue') ? pk.querySelector('.spick-queue').textContent : 'Scheduled posts') });
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.classList || !form.classList.contains('js-compose')) return;
    e.preventDefault();
    // The composer already carries a standing note (views/_composer.php) for a member who cannot
    // post, exactly as ComposeScreen does in the app. This is the second half of that: the note
    // explains before they start, this answers if they press Post anyway. It also covers the
    // thread/schedule branch below, which posts to a different endpoint.
    if (membershipStop()) { return; }
    if (form.getAttribute('data-posting') === '1') return;   // already sending

    /* THE SCHEDULED TIME (2026-09-28): the clock tool's instant, ISO-8601 UTC in #sched-at. A thread
       with a time goes to /thread (text parts, as always); anything else rides the ordinary /compose
       path below with publish_at added, so a scheduled post carries every attachment a post can. */
    var schedEl = document.getElementById('sched-at');
    var schedIso = (schedEl && form.contains(schedEl)) ? (schedEl.value || '') : '';
    if (schedIso && Date.parse(schedIso) < Date.now() + 60000) {
      var pickEl = document.getElementById('sched-pick');
      toast((pickEl && pickEl.getAttribute('data-s-soon')) || 'Pick a time at least a minute from now.');
      return;
    }
    // thread mode: extra parts divert to /thread (with the clock's time, when one is set)
    var thEd = document.getElementById('thread-editor');
    if (thEd && !thEd.hidden && form.contains(thEd)) {
      var thParts = [].map.call(thEd.querySelectorAll('.thread-part'), function (t) { return t.value.trim(); })
        .filter(function (s) { return s !== ''; });
      var whenIso = schedIso;
      if (thParts.length) {
        var bodyEl = form.querySelector('textarea[name="body"]');
        var body1 = bodyEl ? bodyEl.value.trim() : '';
        if (!body1) { toast('Write part 1 first (the main box).'); return; }
        if (stageMedia.items.length) { toast('Threads are text-only for now, remove the media first.'); return; }
        form.setAttribute('data-posting', '1');
        var tbtn = form.querySelector('button[type="submit"]');
        var thUnbusy = busyStart(tbtn) || function () {};   // thread posts have no overlay: the button IS the feedback
        postJson('/thread', { parts_json: JSON.stringify([body1].concat(thParts)), publish_at: whenIso })
          .then(function (res) {
            form.setAttribute('data-posting', '');
            thUnbusy();
            if (!res || !res.ok) { toast((res && res.error) || 'Could not post the thread.'); return; }
            if (res.scheduled) {
              var pc = document.getElementById('thread-parts');
              if (pc) pc.innerHTML = '';
              schedLanded(form, res);
              return;
            }
            window.location = res.redirect || '/feed';
          })
          .catch(function () {
            form.setAttribute('data-posting', '');
            thUnbusy();
            toast('Could not post the thread.');
          });
        return;
      }
    }

    form.setAttribute('data-posting', '1');
    var btn = form.querySelector('button[type="submit"]');
    if (btn) btn.disabled = true;
    var ov = showPostOverlay();

    function fail(msg, action) {
      hidePostOverlay(ov);
      form.setAttribute('data-posting', '');
      if (btn) btn.disabled = false;
      toast(msg, action ? 6000 : undefined, action);   // action = optional {href,label} CTA (e.g. trial cap -> Start now)
    }
    // A staged upload hit a permanent wall (verify your email / trial ended). The raw-file
    // fallback below can't clear it either -- /compose rejects it the same way -- so don't
    // burn another minute uploading into a certain failure; show the real reason now.
    if (stageMedia.block) { ctrace('submit:blocked', { msg: String(stageMedia.block).slice(0, 100) }); fail(stageMedia.block); stageBlockFlash(); return; }
    // A chunked video that already failed. The raw-file fallback would push the
    // WHOLE file through /compose -- the same bytes again, over the same link that
    // just dropped, with the same silent ending. Offer the resume instead.
    if (stageMedia.items.some(function (it) { return it.fatal; })) {
      var why = '';
      stageMedia.items.forEach(function (it) { if (it.failMsg) why = it.failMsg; });   // the specific reason wins
      why = why || 'That video didn’t finish uploading, tap “Resume upload” to send just the parts that didn’t make it.';
      ctrace('submit:fatalpre', {});
      fail(why);
      stageFailNote(why, form);
      return;
    }
    // staged uploads (started when the files were picked): if they all made it,
    // Post is a featherweight token request; if they're mid-flight, the overlay
    // just rides out the remainder; if any failed, fall back to a raw upload.
    var useStaged = stageMedia.items.length > 0 && !stageFailed();
    var expectedMedia = 0;
    function sendNow() {
      var fd = new FormData(form);
      if (composePoster && composePoster.blob) fd.append('poster', composePoster.blob, 'poster.jpg');   // chosen video cover
      if (useStaged) {
        fd.delete('media[]');
        stageMedia.items.forEach(function (it) { if (it.token) { fd.append('staged[]', it.token); expectedMedia++; } });
      } else {
        expectedMedia = (composeFile && composeFile.files) ? composeFile.files.length : 0;
      }
      if (fd.get('gif_url')) expectedMedia++;
      if (schedIso) fd.append('publish_at', schedIso);   // the clock's instant: the server queues instead of posting
      ctrace('compose:send', { staged: useStaged ? 1 : 0, expected: expectedMedia, sched: schedIso ? 1 : 0 });
      var xhr = new XMLHttpRequest();
      xhr.open('POST', '/compose?ajax=1');
      xhr.setRequestHeader('X-CSRF-Token', csrf);
      xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      xhr.setRequestHeader('Accept', 'application/json');
      if (xhr.upload) xhr.upload.onprogress = function (ev) {
        if (!useStaged && ev.lengthComputable) setPostProgress(ov, ev.loaded / ev.total);
      };
      xhr.onload = function () {
        var res = null; try { res = JSON.parse(xhr.responseText); } catch (er) {}
        ctrace('compose:resp', { status: xhr.status, ok: (res && res.ok) ? 1 : 0, id: (res && res.id) || 0, err: (res && res.error) ? String(res.error).slice(0, 100) : '' });
        if (xhr.status === 200 && res && res.ok && res.scheduled) {
          hidePostOverlay(ov);
          schedLanded(form, res);
          return;
        }
        if (xhr.status === 200 && res && res.ok) {
          setPostProgress(ov, 1);
          // land the eyes on the fresh post: the feed boots collapsed after a post
          try { sessionStorage.setItem('rova_posted', '1'); } catch (er2) {}
          // just posted a VIDEO? kick the global "optimizing" bar so it shows even after they navigate off,
          // instead of the upload looking stuck. Checked BEFORE stageReset() clears the staged items.
          var hadVideo = stageMedia.items.some(function (it) { return it.type === 'video' || (it.file && it.file.type && it.file.type.indexOf('video') === 0); })
            || (composeFile && composeFile.files && Array.prototype.some.call(composeFile.files, function (f) { return f.type && f.type.indexOf('video') === 0; }));
          if (hadVideo && window.__rovaProcessingStarted) { window.__rovaProcessingStarted(); }
          var droppedN = (typeof res.dropped === 'number') ? res.dropped : 0;
          var lost = droppedN > 0 || (typeof res.attached === 'number' && expectedMedia > 0 && res.attached < expectedMedia);
          // The cap named here is the SERVER's own (`res.max`, Upload::MAX_FILES), falling back to
          // the same mediaMax() the picker used. It was a hard-coded "10-item limit" written into
          // this string, so after the cap moved this sentence would have been confidently wrong at
          // the worst possible moment -- explaining a lost attachment with the wrong number.
          var capN = (typeof res.max === 'number' && res.max > 0) ? res.max : mediaMax();
          var lostMsg = droppedN > 0
            ? (droppedN + ' attachment' + (droppedN === 1 ? '' : 's') + ' went over the ' + capN + '-item limit and weren’t added.')
            : ('Heads up: only ' + res.attached + ' of ' + expectedMedia + ' attachments made it onto that post.');
          var succ = form.getAttribute('data-success') || '/feed';
          // REALTIME: on the timeline, drop the fresh post straight in without a reload, so it appears
          // immediately while you're watching and you keep your tab + place. Scoped to the feed by the
          // presence of #feed-posts (a profile composer targets #profile-posts, so it still navigates).
          // We do this EVEN when an attachment was flagged lost -- the post still exists and MUST be
          // shown (the fallback lands on Following, which surfaces your just-posted post; a Discover
          // reload would hide it, since Discover filters out brand-new / low-engagement posts).
          if (res.id && window.__rovaInsertFresh && document.getElementById('feed-posts')) {
            stageReset();
            resetComposer(form);
            // B: keep the overlay UP (now showing a settled check) and hand it to __rovaInsertFresh, which
            // preloads the card's media and cross-fades the overlay out AS the card lands -- no black-box
            // flash, no spinner blinking out before the post appears.
            succeedPostOverlay(ov);
            if (lost) { toast(lostMsg); }
            window.__rovaInsertFresh(res.id, ov).then(function (ok) {
              // couldn't drop the card into THIS tab (e.g. the media grid) -> hold the "Posted" confirmation
              // a clear beat so it's obvious it went through, THEN land on Following where it shows.
              if (!ok) { succeedPostOverlay(ov); setTimeout(function () { hidePostOverlay(ov); window.location = '/feed?tab=following'; }, 950); }
            });
            return;
          }
          stageReset();
          // count check: a post must never quietly lose attachments
          if (lost) {
            hidePostOverlay(ov);
            toast(lostMsg);
            setTimeout(function () { window.location = succ; }, 1800);
            return;
          }
          // no live-insert on this surface (e.g. a profile composer) -> show the "Posted" confirmation for
          // a beat before the page navigates, so it's clear the post went through.
          succeedPostOverlay(ov);
          setTimeout(function () { window.location = succ; }, 850);
          return;
        }
        if (xhr.status === 419 || xhr.status === 401) { window.location.reload(); return; }
        // trial post cap: show the reason + a "Start now" link straight to the paid-plan CTA
        if (res && res.upgrade) { fail(res.error || 'That\'s your free trial\'s posts for today.', { href: res.upgrade, label: 'Start now →' }); return; }
        // permanent walls (verify email 403 / membership 402) on a TEXT-ONLY post: same persistent
        // in-composer notice as the staged-media path -- the toast alone read as a dead Post button.
        // Deliberately NOT set as stageMedia.block: the next tap still asks the server, so someone
        // who just verified in another tab posts straight through (success runs stageReset -> note gone).
        if ((xhr.status === 403 || xhr.status === 402) && res && res.error) {
          fail(res.error);
          stageBlockFlash(res.error, xhr.status, form);
          return;
        }
        // include the status when the server gave no reason, it names the culprit
        // (413 = size limit, 404 = stale deploy, 500 = server error) from the phone
        fail((res && res.error) || ('Couldn\'t post (HTTP ' + xhr.status + '). Please try again.'));
      };
      xhr.onerror = function () { ctrace('compose:neterr', {}); fail('Post failed. Check your connection and try again.'); };
      xhr.send(fd);
    }
    ctrace('submit', {
      items: stageMedia.items.length,
      useStaged: useStaged ? 1 : 0,
      settled: stageSettled() ? 1 : 0,
      failed: stageFailed() ? 1 : 0,
      block: stageMedia.block ? 1 : 0
    });
    if (useStaged && !stageSettled()) {
      ctrace('submit:wait', { progress: Math.round(stageProgress() * 100) });
      setPostProgress(ov, stageProgress());
      /* BOUNDING THE WAIT (2026-08-07). Sitting at 98% for six and a half minutes
         with the word "Posting…" and nothing else is a defect on its own, before
         any network error. But the bound must be on PROGRESS, never on the clock:
         a 4 GB clip on a phone legitimately takes an hour, and killing that would
         be a far worse bug than the one being fixed. So:
           - from 6s the overlay names the real percentage instead of "Posting…";
           - at 90s it says out loud that the connection is slow (informational);
           - only after SUP_STALL_MS with the byte counter refusing to move at all
             do we give up. It cannot end a working upload: every socket flush
             calls onprogress, which moves stageProgress().
         The member's own counter was frozen for 274s and then forever. */
      var SUP_SLOW_MS  = 90000;
      var SUP_STALL_MS = 180000;
      var otxt = ov.querySelector('.post-overlay-txt');
      function say(t) { if (otxt && otxt.textContent !== t) otxt.textContent = t; }
      // A staged upload that died: keep the composer, keep the caption, say what
      // happened, and offer the resume. NEVER the raw-file fallback for a chunked
      // stream -- that is the same 126 MB again over the line that just dropped.
      function failStagedUpload(reason) {
        // an item that knows exactly why it died outranks this generic line
        stageMedia.items.forEach(function (it) { if (it.failMsg) reason = it.failMsg; });
        var ta = form.querySelector('textarea[name="body"]');
        if (ta) { try { draftSaveBody(window.__rovaComposeFullBody ? window.__rovaComposeFullBody(ta) : ta.value); } catch (er) {} }
        fail(reason);
        stageFailNote(reason, form);
      }
      // bestP, not lastP: a retry rewinds the byte counter and re-climbs the same
      // ground, so "the number changed" would tick forever while the upload got
      // nowhere. Only NEW ground counts as progress.
      var waited = 0, bestP = -1, gainedAt = 0, saidSlow = false;
      var watch = setInterval(function () {
        waited += 120;
        var p = stageProgress();
        setPostProgress(ov, p);
        if (p > bestP) { bestP = p; gainedAt = waited; }
        if (stageMedia.block) { clearInterval(watch); fail(stageMedia.block); stageBlockFlash(); return; }   // permanent block appeared mid-upload
        if (stageFailed()) {
          clearInterval(watch);
          if (stageMedia.items.some(function (it) { return it.fatal; })) {
            var have = 0;
            stageMedia.items.forEach(function (it) { if (it.got) { for (var g in it.got) have++; } });
            ctrace('submit:fatal', { waitedMs: waited, have: have, progress: Math.round(p * 100) });
            failStagedUpload('Your video didn’t finish uploading. Your post is still here, tap “Resume upload” to send the rest.');
          } else {
            useStaged = false; ctrace('submit:fallback', { waitedMs: waited }); sendNow();   // transient hiccup: raw files still in the form
          }
          return;
        }
        if (stageSettled()) { clearInterval(watch); ctrace('submit:ready', { waitedMs: waited }); sendNow(); return; }
        if (waited - gainedAt >= SUP_STALL_MS) {
          clearInterval(watch);
          ctrace('submit:stalled', { waitedMs: waited, stalledMs: waited - gainedAt, progress: Math.round(p * 100) });
          // stop the dead sockets and mark the item so "Resume upload" appears
          stageMedia.items.forEach(function (it) {
            if (it.done || it.failed) return;
            if (it.xhrs) it.xhrs.forEach(function (x) { try { x.abort(); } catch (e) {} });
            if (it.xhr) { try { it.xhr.abort(); } catch (e) {} }
            it.failed = true; it.fatal = true; stagePaint(it);
          });
          failStagedUpload('Your upload stopped sending, your connection dropped partway. Your post is still here; tap “Resume upload” to carry on from where it stopped.');
          return;
        }
        if (waited >= 6000) {
          var pct = Math.round(p * 100);
          var parts = stagePartsLabel();
          if (!saidSlow && waited >= SUP_SLOW_MS) { saidSlow = true; ctrace('submit:slow', { progress: pct }); }
          say('Uploading ' + pct + '%' + (parts ? ', ' + parts : '')
              + (saidSlow ? ', slow connection, still going…' : '…'));
        }
        if (waited % 3000 === 0) { ctrace('submit:waiting', { waitedMs: waited, progress: Math.round(p * 100) }); }  // still waiting on staging — heartbeat
      }, 120);
    } else {
      sendNow();
    }
  });

  /* ---- global "optimizing your video" bar (survives navigation) ----------
     A member who posts a clip and moves on still sees it's working, not stuck. Polls /processing (the
     count of THEIR videos still transcoding) and slides the header bar in/out. Gated by a session flag so
     only members who recently posted a video ever poll -- and it keeps polling across page loads until the
     job finishes, so it "follows" them around the app. */
  (function () {
    var bar = document.getElementById('proc-bar');
    if (!bar) return;
    var labelN = bar.querySelector('.proc-bar-n');
    var timer = null, busy = false;
    function flagOn(v) { try { v ? sessionStorage.setItem('rova_processing', '1') : sessionStorage.removeItem('rova_processing'); } catch (e) {} }
    function flagged() { try { return sessionStorage.getItem('rova_processing') === '1'; } catch (e) { return false; } }
    function stop() { if (timer) { clearTimeout(timer); timer = null; } }
    function later(ms) { stop(); if (!document.hidden) timer = setTimeout(poll, ms); }
    function poll() {
      if (busy) return; busy = true;
      fetch('/processing', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          busy = false;
          var n = (d && typeof d.count === 'number') ? d.count : 0;
          if (n > 0) {
            bar.classList.add('show');
            if (labelN) labelN.textContent = n > 1 ? ' (' + n + ')' : '';
            flagOn(true); later(6000);
          } else {
            bar.classList.remove('show'); flagOn(false); stop();
          }
        })
        .catch(function () { busy = false; later(10000); });
    }
    // the compose success handler calls this the instant a video post goes through
    window.__rovaProcessingStarted = function () { flagOn(true); bar.classList.add('show'); poll(); };
    // start if a job might be running: the server primed the bar active on this load, OR one was running
    // when we last left a page (the session flag).
    if (bar.getAttribute('data-active') === '1' || flagged()) { flagOn(true); poll(); }
    document.addEventListener('visibilitychange', function () { if (!document.hidden && flagged()) poll(); });
  })();

  /* ---- compose modal: "Post" (own profile) or "Mention" (someone else) -- */
  (function () {
    var modal = document.getElementById('compose-modal');
    if (!modal) return;
    var opener = document.getElementById('compose-open');     // own profile: empty compose
    var mention = document.getElementById('compose-mention'); // other profile: pre-fill @handle
    if (!opener && !mention) return;
    var ta = modal.querySelector('textarea[name="body"]');
    function open(prefill) {
      lockScroll();
      modal.classList.add('show');
      if (ta) {
        if (typeof prefill === 'string' && prefill) {
          ta.value = prefill;
          ta.dispatchEvent(new Event('input'));   // keep the char counter in sync
        }
        setTimeout(function () {
          ta.focus();
          var n = ta.value.length;
          try { ta.setSelectionRange(n, n); } catch (e) {}   // caret after the @handle
        }, 80);
      }
    }
    function close() {
      modal.classList.remove('show');
      unlockScroll();
    }
    if (opener) opener.addEventListener('click', function () { open(''); });
    if (mention) mention.addEventListener('click', function () {
      open('@' + mention.getAttribute('data-handle') + ' ');
    });
    modal.addEventListener('click', function (e) { if (e.target.closest('[data-cclose]')) close(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('show')) close();
    });
  })();

  /* ---- composer character counter -------------------------------------- */
  var ccBox = document.getElementById('char-count');
  var ccArea = document.querySelector('.js-compose textarea[name="body"]');
  if (ccBox && ccArea) {
    /* The cap comes from the FIELD, which _composer.php renders from Posts::MAX_BODY -- so the
       counter cannot disagree with the thing that actually stops the typing, and neither can
       disagree with the server. It was a second hard-coded 2000 living three files away from the
       first. Guarded fallback for a field with no maxlength (there isn't one, but a counter that
       renders "NaN" is worse than one that assumes). */
    var ccMax = parseInt(ccArea.getAttribute('maxlength'), 10) || 2000;
    function ccUpdate() {
      // count the FULL body: a hidden embed URL still costs its characters against the cap
      var ccVal = window.__rovaComposeFullBody ? window.__rovaComposeFullBody(ccArea) : ccArea.value;
      var rem = ccMax - ccVal.length;
      ccBox.textContent = rem <= 280 ? rem : '';
      ccBox.classList.toggle('warn', rem <= 20);
    }
    ccArea.addEventListener('input', ccUpdate);
    ccUpdate();
  }

  /* ---- composer: "add music/video" hint + GIF placeholder -------------- */
  var ehBtn = document.getElementById('embed-hint-btn');
  var ehPop = document.getElementById('embed-hint');
  if (ehBtn && ehPop) {
    document.body.appendChild(ehPop); // escape the .glass containing block
    /* ONE BREAKPOINT, SHARED WITH THE STYLESHEET. Below it the how-to is a bottom sheet whose
       position is owned entirely by CSS (position:fixed, pinned left/right/bottom); above it, it is
       the anchored popover it has always been. The two must agree, because an inline top/left left
       over from a desktop-width open would fight the sheet's own pinning after a resize -- so the
       anchoring branch CLEARS them rather than simply not setting them. Keep in step with the
       @media (max-width:559px) / (min-width:560px) pair in rova.css. */
    var EH_SHEET = 560;
    function ehPlace() {
      if (window.innerWidth < EH_SHEET) { ehPop.style.top = ''; ehPop.style.left = ''; return; }
      var r = ehBtn.getBoundingClientRect();
      ehPop.style.top = (r.bottom + window.scrollY + 8) + 'px';
      // 340 is .embed-hint's max-width at this breakpoint (+8 for the gutter it must keep)
      ehPop.style.left = Math.max(8, Math.min(r.left + window.scrollX, window.innerWidth - 348)) + 'px';
    }
    function ehClose() { ehPop.classList.remove('show'); }
    ehBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      ehPlace();
      ehPop.classList.toggle('show');
    });
    document.addEventListener('click', function (e) {
      if (ehPop.classList.contains('show') && !ehPop.contains(e.target) && !ehBtn.contains(e.target)) {
        ehClose();
      }
    });
    /* Escape did NOT close this before -- measured on the shipped bundle at all three widths, the
       popup was still .show after a keydown. It was survivable while this was a 300px hint with an
       outside click a thumb away; it is not once the phone presentation is a sheet with a scrim over
       the page. The close button is the visible counterpart, and both return focus to the trigger so
       a keyboard user is not dropped at the top of the document. */
    var ehX = document.getElementById('embed-hint-x');
    if (ehX) ehX.addEventListener('click', function (e) {
      e.stopPropagation(); ehClose(); ehBtn.focus();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && ehPop.classList.contains('show')) { ehClose(); ehBtn.focus(); }
    });
    /* A resize can cross the breakpoint with the how-to open (a desktop rotate, a devtools dock).
       Re-place rather than close: closing would look like the page dismissing the user's own click. */
    window.addEventListener('resize', function () {
      if (ehPop.classList.contains('show')) ehPlace();
    });
  }
  /* ---- composer: the "ADD MUSIC" picker (2026-09-27, iOS parity) ----------------------------------------
     The web half of the app's in-app song sheet. Rob: Instagram-style music, and pasted links (Spotify...)
     must keep working. Markup + every string: views/_composer.php #music-pick (t() -> data-s-*).
       - empty box      -> Apple's Top Songs chart           (GET /music/top, proxied + cached server-side)
       - typing         -> Apple catalog search, debounced   (GET /music/search)
       - a Spotify / SoundCloud / YouTube / Apple Music URL typed or pasted into the box -> ONE row,
         "Add this <Provider> link", which passes the url through UNTOUCHED
       - each row: a 30s preview play/pause, and tapping the row picks the song
       - Apple down / slow -> "Music search is unavailable, paste a link instead"; the link row still works
     A PICK IS A PASTE: window.__rovaComposeAttachLink (the compose link-preview IIFE) puts the url in the
     body and runs the same /link-preview -> .am-card path a pasted link takes. The url is Apple's share
     shape, already normalised by the server (trackViewUrl minus every param but i=).
     ONE VOICE: previews play through ONE <audio> owned here. While the picker is OPEN it owns the page's
     sound -- window.__rovaMusicPickBusy() is read by the Apple-card block (__rovaAmPlaying, __rovaAmTl), so
     applySound (re-run via __rovaSyncSound on open and close) keeps every timeline clip muted and no
     timeline song starts under it; a card preview that was sounding is stopped (__rovaAmStop) on open.
     Anchored popover >= 560px, bottom sheet with a scrim below (the GIF picker's / how-to's breakpoint). */
  (function () {
    /* A member who cannot post (Billing::isActive false) gets .js-music-locked and no picker markup: the
       tap answers with the SAME red in-composer note a Post tap gets (stageBlockNote), toast as fallback.
       Nothing hidden, nothing disabled -- this composer's rule for lapsed members. */
    document.addEventListener('click', function (e) {
      var lb = e.target.closest ? e.target.closest('.js-music-locked') : null;
      if (!lb) return;
      e.preventDefault();
      var msg = lb.getAttribute('data-lock-msg') || '';
      if (!msg) return;
      var shown = null;
      try { shown = stageBlockNote(msg, 402, lb.closest('form')); } catch (er) {}
      if (!shown) toast(msg);
    });
    var pk = document.getElementById('music-pick');
    if (!pk || !document.querySelector('.js-music')) return;
    var qIn = pk.querySelector('.mpick-q'), list = pk.querySelector('.mpick-list'),
        status = pk.querySelector('.mpick-status'), label = pk.querySelector('.mpick-label'),
        body = pk.querySelector('.mpick-body'), xBtn = pk.querySelector('.mpick-x');
    var open = false, trigger = null, ta = null, rows = [], linkPick = null, seq = 0, ctrl = null, timer = null,
        topCache = null, audio = null, scrim = null, raf = 0;
    var SHEET = 560;
    window.__rovaMusicPickBusy = function () { return open; };
    window.__rovaMusicPickState = function () {   // debugging / rigs: what the picker thinks is sounding
      return { open: open, playing: !!(audio && !audio.paused), src: audio ? (audio.currentSrc || audio.src || '') : '', rows: rows.length,
        active: activeRow ? +activeRow.getAttribute('data-i') : -1, t: audio ? audio.currentTime : 0 };
    };
    function S(k) { return pk.getAttribute('data-s-' + k) || ''; }
    function fmt(s) {
      var a = Array.prototype.slice.call(arguments, 1), i = 0;
      return String(s).replace(/%s/g, function () { var v = a[i++]; return v == null ? '' : String(v); });
    }
    /* The member's REGION, the app's `cc`: the first navigator language that carries one (en-GB -> gb).
       None (plain "en") -> the server falls back to the visitor's country, then us. */
    function region() {
      var ls = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language || ''];
      for (var i = 0; i < ls.length; i++) {
        var m = /^[a-z]{2,3}[-_]([a-z]{2})(?:$|[-_])/i.exec(ls[i] || '');
        if (m) return m[1].toLowerCase();
      }
      return '';
    }
    /* The four providers Embed::fromText turns into a player (lib/embed.php). The label is the %s of
       "Add this %s link"; a link to anything else is "not a song". */
    var PROV = [
      [/(^|\.)spotify\.com$|^spotify\.link$/i, 'Spotify'],
      [/(^|\.)soundcloud\.com$|^snd\.sc$/i, 'SoundCloud'],
      [/(^|\.)youtube\.com$|^youtu\.be$|(^|\.)youtube-nocookie\.com$/i, 'YouTube'],
      [/^music\.apple\.com$/i, 'Apple Music']
    ];
    function linkOf(text) {
      var t = String(text || '').trim();
      var url = /^https?:\/\/\S+$/i.test(t) ? t : ((t.match(/https?:\/\/[^\s<]+/i) || [''])[0].replace(/[.,;:!?)\]]+$/, ''));
      if (!url) return null;
      var host = '';
      try { host = new URL(url).hostname; } catch (e) { return { url: url, prov: '' }; }
      for (var i = 0; i < PROV.length; i++) { if (PROV[i][0].test(host)) return { url: url, prov: PROV[i][1] }; }
      return { url: url, prov: '' };
    }
    var IC_PLAY = '<svg class="mp-ic mp-ic-play" viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5.5v13l10.5-6.5z" fill="currentColor"/></svg>';
    var IC_PAUSE = '<svg class="mp-ic mp-ic-pause" viewBox="0 0 24 24" aria-hidden="true"><path d="M7.5 5.5h3v13h-3zM13.5 5.5h3v13h-3z" fill="currentColor"/></svg>';
    /* THE PREVIEW RING (rebuilt 2026-09-27 after Rob's iPhone screenshots: "something is off there").
       It USED to be a conic-gradient BACKGROUND on a button that kept a 1px transparent border. The
       gradient is sized to the PADDING box but painted into the BORDER box with background-repeat's
       default, so a 1px wrapped copy of the OPPOSITE edge of the gradient rimmed the ring: a gold nick at
       6 o'clock while the arc was near 12, notches at 3 and 9, and an edge that read off-centre. At
       3x DPR that is a 3-device-px band. Reproduced identically in WebKit AND Chromium from the shipped
       CSS. On top of that it stepped at timeupdate's ~4Hz, and the buffering state was an opacity
       pulse layered on the SAME ring, so loading and progress drew over each other.
       NOW: two SVG strokes on ONE path -- an explicit circle drawn from 12 o'clock clockwise (two arcs,
       no rotate(), so no transform-origin for any engine to disagree about) -- so track and progress are
       concentric by construction. Progress = stroke-dashoffset against the path's EXACT length
       (2*PI*r), written per animation frame from audio.currentTime. The spinner is a separate SVG that
       only shows while buffering, and the progress bar is hidden while it spins. */
    var RING_R = 18.2, RING_C = 2 * Math.PI * RING_R;
    var RING_D = 'M20 1.8a18.2 18.2 0 1 1 0 36.4a18.2 18.2 0 1 1 0-36.4';
    var RING = '<svg class="mp-ring" viewBox="0 0 40 40" aria-hidden="true"><path class="mp-track" d="' + RING_D + '"/>'
      + '<path class="mp-bar" d="' + RING_D + '" stroke-dasharray="' + RING_C.toFixed(3) + ' ' + RING_C.toFixed(3) + '" stroke-dashoffset="' + RING_C.toFixed(3) + '"/></svg>'
      + '<svg class="mp-spin" viewBox="0 0 40 40" aria-hidden="true"><path d="' + RING_D + '" stroke-dasharray="30 200"/></svg>';
    var IC_LINK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10 13a5 5 0 0 0 7.5.5l3-3a5 5 0 0 0-7-7l-1.7 1.7"/><path d="M14 11a5 5 0 0 0-7.5-.5l-3 3a5 5 0 0 0 7 7l1.7-1.7"/></svg>';
    function rowHtml(s, i) {
      var art = s.artwork
        ? '<img class="mpick-art" src="' + escHtml(s.artwork) + '" alt="" loading="lazy" decoding="async">'
        : '<span class="mpick-art mpick-art-fb" aria-hidden="true">&#9835;</span>';
      var ex = s.explicit ? '<span class="mpick-e" title="' + escHtml(S('explicit')) + '">E</span>' : '';
      var play = s.preview
        ? '<button type="button" class="mpick-play" aria-pressed="false" aria-label="' + escHtml(fmt(S('play'), s.title)) + '">' + RING + IC_PLAY + IC_PAUSE + '</button>'
        : '<span class="mpick-play is-none" title="' + escHtml(S('nopreview')) + '" aria-hidden="true"></span>';
      return '<li class="mpick-row" data-i="' + i + '">'
        + '<button type="button" class="mpick-pick" aria-label="' + escHtml(fmt(S('pick'), s.title, s.artist)) + '">' + art
        + '<span class="mpick-txt"><span class="mpick-t"><span class="mpick-tt">' + escHtml(s.title) + '</span>' + ex + '</span>'
        + '<span class="mpick-a">' + escHtml(s.artist) + '</span></span></button>' + play + '</li>';
    }
    function linkRowHtml(L) {
      return '<li class="mpick-row mpick-linkrow" data-link="1"><button type="button" class="mpick-pick">'
        + '<span class="mpick-art mpick-art-link" aria-hidden="true">' + IC_LINK + '</span>'
        + '<span class="mpick-txt"><span class="mpick-t"><span class="mpick-tt">' + escHtml(fmt(S('add'), L.prov)) + '</span></span>'
        + '<span class="mpick-a">' + escHtml(L.url) + '</span></span></button></li>';
    }
    function setStatus(msg, kind) {
      status.textContent = msg || '';
      status.className = 'mpick-status' + (kind ? ' is-' + kind : '');
      status.hidden = !msg;
    }
    function setLabel(txt) { label.textContent = txt || ''; label.hidden = !txt; }

    /* ---- previews: ONE <audio>, one ACTIVE row at a time ----
       Row states (classes on the <li>): idle | buffering (.is-active.is-buffering.is-playing: spinner,
       pause glyph) | playing (.is-active.is-playing: progress ring, pause glyph) | paused (.is-active:
       the ring stays where it stopped, play glyph; a tap resumes from there). 'ended' / another row /
       close -> idle. Only activeRow can hold a ring. */
    var activeRow = null, ringRaf = 0;
    function ringPaint() {
      var bar = activeRow && activeRow.querySelector('.mp-bar');
      if (!bar || !audio) return;
      var d = audio.duration;
      if (!isFinite(d) || d <= 0) d = 30;                       // Apple previews are 30s; unknown until metadata
      var p = Math.max(0, Math.min(1, (audio.currentTime || 0) / d));
      bar.style.strokeDashoffset = (RING_C * (1 - p)).toFixed(3);
    }
    function ringLoop() {
      ringRaf = 0;
      ringPaint();
      if (activeRow && audio && !audio.paused) ringRaf = requestAnimationFrame(ringLoop);
    }
    function ringStart() { if (!ringRaf) ringRaf = requestAnimationFrame(ringLoop); }
    function ringStop() { if (ringRaf) { cancelAnimationFrame(ringRaf); ringRaf = 0; } }
    function rowState(li, st) {
      if (!li) return;
      var on = st !== 'idle', sounding = st === 'playing' || st === 'buffering';
      li.classList.toggle('is-active', on);
      li.classList.toggle('is-buffering', st === 'buffering');
      li.classList.toggle('is-playing', sounding);
      if (!on) { var bar = li.querySelector('.mp-bar'); if (bar) bar.style.strokeDashoffset = RING_C.toFixed(3); }
      var btn = li.querySelector('button.mpick-play'), s = rows[+li.getAttribute('data-i')];
      if (btn && s) {
        btn.setAttribute('aria-pressed', sounding ? 'true' : 'false');
        btn.setAttribute('aria-label', fmt(S(sounding ? 'pause' : 'play'), s.title));
      }
    }
    function resetActive() { var li = activeRow; activeRow = null; ringStop(); rowState(li, 'idle'); }
    function ensureAudio() {
      if (audio) return audio;
      audio = new Audio();
      audio.preload = 'none';
      audio.addEventListener('playing', function () { if (activeRow) { rowState(activeRow, 'playing'); ringStart(); } });
      audio.addEventListener('waiting', function () { if (activeRow && !audio.paused) rowState(activeRow, 'buffering'); });
      audio.addEventListener('pause', function () {
        if (!audio.paused || audio.ended || !activeRow) return;   // stale pause from a src swap / the end
        ringStop(); ringPaint(); rowState(activeRow, 'paused');
      });
      audio.addEventListener('ended', resetActive);
      audio.addEventListener('error', function () {
        var li = activeRow; if (!li) return;
        if (audio.error && audio.error.code === 1) return;      // MEDIA_ERR_ABORTED: our own src swap
        resetActive(); li.classList.add('is-failed');
      });
      return audio;
    }
    function stopPreview() {
      resetActive();
      if (audio) {
        try { audio.pause(); } catch (e) {}
        try { audio.removeAttribute('src'); audio.load(); } catch (e) {}
      }
    }
    function playFrom(li, fresh, src) {
      var p;
      if (fresh) { audio.src = src; try { audio.currentTime = 0; } catch (e) {} }
      try { p = audio.play(); } catch (e) { p = null; }
      if (p && p.catch) p.catch(function (err) {
        if (err && err.name === 'AbortError') return;          // we swapped tracks: not a failure
        if (activeRow === li) { resetActive(); li.classList.add('is-failed'); }
      });
    }
    function togglePreview(li) {
      var s = li && rows[+li.getAttribute('data-i')];
      if (!s || !s.preview) return;
      ensureAudio();
      if (window.__rovaAmStop) { try { window.__rovaAmStop(); } catch (e) {} }   // a song card elsewhere yields
      if (activeRow === li) {
        if (!audio.paused) { audio.pause(); return; }           // pause: the ring stays where it is
        rowState(li, 'playing'); ringStart();                   // resume from there ('waiting' spins if it must)
        playFrom(li, false);
        return;
      }
      resetActive();
      li.classList.remove('is-failed');
      activeRow = li; rowState(li, 'buffering');
      playFrom(li, true, s.preview);
    }

    /* ---- loading ---- */
    function render(songs, my) {
      if (my !== seq) return;
      stopPreview();
      pk.classList.remove('is-busy');
      rows = songs.slice(0, 40); linkPick = null;
      if (!rows.length) { list.innerHTML = ''; setStatus(S('empty'), 'empty'); return; }
      setStatus('', '');
      list.innerHTML = rows.map(rowHtml).join('');
      body.scrollTop = 0;
    }
    function fail(kind, my, msg) {
      if (my !== seq) return;
      stopPreview();
      pk.classList.remove('is-busy');
      rows = []; list.innerHTML = '';
      setStatus(kind === 'locked' ? msg : kind === 'rate' ? S('rate') : S('down'), 'err');
    }
    function abortLoad() { if (ctrl) { try { ctrl.abort(); } catch (e) {} ctrl = null; } }
    /* ---- THE CHART IS NEVER A LOADING SCREEN (Rob, 2026-09-27) ----
       The server embeds the member's chart in the page (#mpick-top, read from the durable store that the
       warmer fills -- /music/top never calls Apple either), so the chart paints on the picker's FIRST
       frame. It is then refreshed SILENTLY: a newer copy replaces the rows only if the member is still on
       the untouched chart (no query, nothing previewing, list at the top); otherwise it waits for the next
       open. The last good chart is mirrored to localStorage for a page that somehow arrives without one.
       A chart refresh that fails changes nothing on screen -- "unavailable" is reserved for a SEARCH that
       was never answered before while Apple is unreachable. Searches are remembered here too (the last
       40), so going back to a query is instant. */
    var TOP_KEY = 'rova_music_top_v1', topRefreshedAt = 0, SMEMO = [];
    (function () {
      var el = document.getElementById('mpick-top'), d = null;
      try { d = el ? JSON.parse(el.textContent || 'null') : null; } catch (e) { d = null; }
      if (!d || !Array.isArray(d.songs) || !d.songs.length) {
        try { d = JSON.parse(localStorage.getItem(TOP_KEY) || 'null'); } catch (e) { d = null; }
      }
      if (d && Array.isArray(d.songs) && d.songs.length) {
        topCache = { t: Date.now(), songs: d.songs, fetched: d.fetched_at || '', cc: d.requested_cc || d.cc || '' };
        try { localStorage.setItem(TOP_KEY, JSON.stringify({ songs: d.songs, fetched_at: d.fetched_at, cc: d.cc, requested_cc: d.requested_cc })); } catch (e) {}
      }
    })();
    // the storefront: the one the server chose for this member's chart (so chart + search agree)
    function ccParam() { var c = (topCache && topCache.cc) || region(); return c ? 'cc=' + encodeURIComponent(c) : ''; }
    function getJson(url, ms) {
      var c = window.AbortController ? new AbortController() : null;
      var to = setTimeout(function () { if (c) { try { c.abort(); } catch (e) {} } }, ms);
      return fetch(url, { headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', signal: c ? c.signal : undefined })
        .then(function (r) {
          clearTimeout(to);
          if (r.status === 429) return { rate: 1 };
          if (r.status === 402) return r.json().then(function (j) { return { locked: (j && j.error) || S('down') }; }, function () { return { unavailable: 1 }; });
          if (!r.ok) return { unavailable: 1 };
          return r.json();
        }, function (e) { clearTimeout(to); throw e; });
    }
    function refreshTop() {
      if (Date.now() - topRefreshedAt < 5 * 60 * 1000) return;
      topRefreshedAt = Date.now();
      getJson('/music/top' + (ccParam() ? '?' + ccParam() : ''), 12000).then(function (d) {
        if (!d || !Array.isArray(d.songs) || !d.songs.length) return;          // keep what we have
        var changed = !topCache || (d.fetched_at || '') !== topCache.fetched;
        topCache = { t: Date.now(), songs: d.songs, fetched: d.fetched_at || '', cc: d.requested_cc || d.cc || (topCache && topCache.cc) || '' };
        try { localStorage.setItem(TOP_KEY, JSON.stringify({ songs: d.songs, fetched_at: d.fetched_at, cc: d.cc, requested_cc: d.requested_cc })); } catch (e) {}
        if (changed && open && !qIn.value.trim() && !activeRow && body.scrollTop < 8 && !linkPick) render(d.songs, seq);
      }, function () { topRefreshedAt = 0; });                              // quietly try again next open
    }
    function memoGet(q) { for (var i = 0; i < SMEMO.length; i++) { if (SMEMO[i].q === q) return SMEMO[i].songs; } return null; }
    function memoPut(q, songs) { SMEMO = SMEMO.filter(function (m) { return m.q !== q; }); SMEMO.unshift({ q: q, songs: songs }); if (SMEMO.length > 40) SMEMO.pop(); }
    function load(q) {
      var my = ++seq, top = !q;
      abortLoad();
      setLabel(top ? S('top') : S('results'));
      if (top) {
        if (topCache && topCache.songs.length) { render(topCache.songs, my); refreshTop(); return; }
        // no embedded chart and nothing stored (should not happen): fetch it, and never call it "unavailable"
        pk.classList.add('is-busy');
        if (!rows.length) { list.innerHTML = ''; setStatus(S('loading'), 'loading'); }
        topRefreshedAt = 0;
        getJson('/music/top' + (ccParam() ? '?' + ccParam() : ''), 12000).then(function (d) {
          if (my !== seq) return;
          if (d && d.locked) { fail('locked', my, d.locked); return; }
          if (d && Array.isArray(d.songs) && d.songs.length) {
            topCache = { t: Date.now(), songs: d.songs, fetched: d.fetched_at || '', cc: d.requested_cc || d.cc || '' };
            try { localStorage.setItem(TOP_KEY, JSON.stringify(d)); } catch (e) {}
            render(d.songs, my); return;
          }
          pk.classList.remove('is-busy'); setStatus(S('empty'), 'empty');
        }, function () { if (my === seq) { pk.classList.remove('is-busy'); setStatus(S('empty'), 'empty'); } });
        return;
      }
      var hit = memoGet(q);
      if (hit) { render(hit, my); return; }
      pk.classList.add('is-busy');
      if (!rows.length) { list.innerHTML = ''; setStatus(S('loading'), 'loading'); }
      var cp = ccParam();
      getJson('/music/search?q=' + encodeURIComponent(q) + (cp ? '&' + cp : ''), 9000).then(function (d) {
        if (my !== seq) return;
        if (d && d.rate) { fail('rate', my); return; }
        if (d && d.locked) { fail('locked', my, d.locked); return; }
        if (!d || d.unavailable || !Array.isArray(d.songs)) { fail('down', my); return; }
        memoPut(q, d.songs);
        render(d.songs, my);
      }, function () { fail('down', my); });
    }
    function onInput() {
      clearTimeout(timer);
      var v = qIn.value, L = linkOf(v);
      if (L) {                                   // a pasted/typed link: no network, one passthrough row
        ++seq; abortLoad(); stopPreview();
        pk.classList.remove('is-busy');
        rows = []; setLabel('');
        if (L.prov) { linkPick = L; setStatus('', ''); list.innerHTML = linkRowHtml(L); }
        else { linkPick = null; list.innerHTML = ''; setStatus(S('notsong'), 'err'); }
        return;
      }
      linkPick = null;
      var t = v.replace(/\s+/g, ' ').trim();
      if (!t) { load(''); return; }
      timer = setTimeout(function () { load(t); }, 320);
    }

    /* ---- attach ---- */
    function pick(url, preview) {
      if (!url || !ta) return;
      /* iOS build 490 parity: the picked song plays in the composer's card once /link-preview draws it.
         That is after this tap, so the card element is unlocked HERE, inside the gesture (WebKit grants
         play() per element); the card block's own mute preference check (rova_sound='0') applies. */
      if (preview && window.__rovaAmUnlock) { try { window.__rovaAmUnlock(preview); } catch (e) {} }
      var ok = (ta.closest && ta.closest('.pe-form') && window.__rovaPeAttachLink)
        ? window.__rovaPeAttachLink(ta, url, ta._musicPick || '')
        : (window.__rovaComposeAttachLink ? window.__rovaComposeAttachLink(ta, url, ta._musicPick || '', true) : false);
      if (!ok) { toast(S('toolong')); return; }
      ta._musicPick = url;
      close(false);
      try { (coarsePointer() ? trigger : ta).focus({ preventScroll: true }); } catch (e) {}
    }

    /* ---- open / close / place ---- */
    function ensureScrim() {
      if (scrim) return;
      scrim = document.createElement('div');
      scrim.className = 'mpick-scrim'; scrim.hidden = true;
      document.body.appendChild(scrim);
      scrim.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); close(true); });
      scrim.addEventListener('touchmove', function (e) { e.preventDefault(); }, { passive: false });
    }
    function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }
    function fitSheet() {
      var vv = window.visualViewport, ih = window.innerHeight;
      var h = vv ? vv.height : ih;
      // the on-screen keyboard shrinks the VISUAL viewport only: sit on top of it, never under it
      var off = vv ? Math.max(0, Math.round(ih - vv.height - vv.offsetTop)) : 0;
      pk.style.bottom = off + 'px';
      pk.style.height = Math.round(Math.min(h - 16, ih * 0.82)) + 'px';
    }
    function place() {
      if (!open || !trigger) return;
      var vw = window.innerWidth, vh = window.innerHeight;
      if (vw < SHEET) {
        pk.classList.add('is-sheet');
        pk.style.left = ''; pk.style.top = ''; pk.style.width = '';
        fitSheet();
        scrim.hidden = false;
        return;
      }
      pk.classList.remove('is-sheet');
      scrim.hidden = true;
      pk.style.bottom = '';
      var r = trigger.getBoundingClientRect();
      var W = Math.min(392, vw - 16), H = Math.min(540, vh - 16);
      var below = vh - r.bottom - 16, above = r.top - 16, top;
      if (below >= H) top = r.bottom + 8;
      else if (above >= H) top = r.top - 8 - H;
      else if (Math.max(below, above) >= 340) { H = Math.max(below, above); top = below >= above ? r.bottom + 8 : r.top - 8 - H; }
      else top = (vh - H) / 2;
      pk.style.width = W + 'px'; pk.style.height = H + 'px';
      pk.style.top = Math.round(clamp(top, 8, vh - H - 8)) + 'px';
      pk.style.left = Math.round(clamp(r.left - 8, 8, vw - W - 8)) + 'px';
    }
    function placeSoon() { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; place(); }); }
    function openFor(b) {
      trigger = b;
      var form = b.closest('form');
      ta = form ? form.querySelector('textarea[name="body"]') : null;
      if (pk.parentNode !== document.body) document.body.appendChild(pk);   // escape the .glass containing block
      ensureScrim();
      open = true;
      pk.hidden = false;
      b.setAttribute('aria-expanded', 'true');
      place();
      // one voice: the picker owns the sound while it is up
      if (window.__rovaAmStop) { try { window.__rovaAmStop(); } catch (e) {} }
      if (window.__rovaSyncSound) { try { window.__rovaSyncSound(); } catch (e) {} }
      qIn.value = '';
      load('');
      /* Type-to-search on a desktop; on a phone, focus the dialog itself so the keyboard does not cover
         the chart the moment it opens (the GIF picker's rule). */
      try { if (coarsePointer()) { pk.focus({ preventScroll: true }); } else { qIn.focus({ preventScroll: true }); } } catch (e) {}
    }
    function close(ret) {
      if (!open) return;
      open = false;
      clearTimeout(timer); ++seq; abortLoad();
      stopPreview();
      pk.hidden = true;
      if (scrim) scrim.hidden = true;
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (window.__rovaSyncSound) { try { window.__rovaSyncSound(); } catch (e) {} }   // the playing card gets its voice back
      if (ret && trigger) { try { trigger.focus({ preventScroll: true }); } catch (e) {} }
    }

    /* ---- events ---- */
    pk.setAttribute('tabindex', '-1');
    qIn.addEventListener('input', onInput);
    xBtn.addEventListener('click', function (e) { e.preventDefault(); close(true); });
    list.addEventListener('click', function (e) {
      var pb = e.target.closest ? e.target.closest('button.mpick-play') : null;
      if (pb) { e.preventDefault(); togglePreview(pb.closest('.mpick-row')); return; }
      var pp = e.target.closest ? e.target.closest('.mpick-pick') : null;
      if (!pp) return;
      e.preventDefault();
      var li = pp.closest('.mpick-row');
      if (li.hasAttribute('data-link')) { if (linkPick) pick(linkPick.url); return; }
      var s = rows[+li.getAttribute('data-i')];
      if (s && s.url) pick(s.url, s.preview);
    });
    pk.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); close(true); return; }
      var a = document.activeElement;
      if (e.key === 'Enter' && a === qIn) {
        e.preventDefault(); clearTimeout(timer);
        var L = linkOf(qIn.value);
        if (L && L.prov) pick(L.url);
        else if (!L) load(qIn.value.replace(/\s+/g, ' ').trim());
        return;
      }
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        var picks = Array.prototype.slice.call(list.querySelectorAll('.mpick-pick'));
        if (!picks.length) return;
        if (a === qIn) { if (e.key === 'ArrowDown') { e.preventDefault(); picks[0].focus(); } return; }
        var li = a && a.closest ? a.closest('.mpick-row') : null;
        var i = li ? picks.indexOf(li.querySelector('.mpick-pick')) : -1;
        if (i < 0) return;
        e.preventDefault();
        if (e.key === 'ArrowDown') { if (i + 1 < picks.length) picks[i + 1].focus(); }
        else if (i > 0) { picks[i - 1].focus(); } else { qIn.focus(); }
        return;
      }
      if (e.key === 'Tab') {                  // keep focus inside the dialog
        var f = Array.prototype.filter.call(pk.querySelectorAll('button, input'), function (x) { return !x.disabled && x.getClientRects().length; });
        if (!f.length) return;
        if (e.shiftKey && (a === f[0] || a === pk)) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && a === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }
    });
    // a phone: the page must not scroll under the sheet; the list scrolls itself (overscroll contained)
    pk.addEventListener('touchmove', function (e) {
      if (pk.classList.contains('is-sheet') && !(e.target.closest && e.target.closest('.mpick-body'))) e.preventDefault();
    }, { passive: false });
    document.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('.js-music') : null;
      if (b) {
        e.preventDefault(); e.stopPropagation();
        if (open && trigger === b) { close(false); return; }
        if (open) close(false);
        openFor(b);
        return;
      }
      if (open && !pk.contains(e.target) && !(scrim && scrim.contains(e.target))) close(false);
    });
    window.addEventListener('resize', function () { if (open) placeSoon(); });
    window.addEventListener('scroll', function () { if (open && !pk.classList.contains('is-sheet')) placeSoon(); }, { passive: true });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', function () { if (open && pk.classList.contains('is-sheet')) fitSheet(); });
      window.visualViewport.addEventListener('scroll', function () { if (open && pk.classList.contains('is-sheet')) fitSheet(); });
    }
    document.addEventListener('visibilitychange', function () { if (document.hidden && audio && !audio.paused) audio.pause(); });
    window.addEventListener('pagehide', function () { if (open) close(false); });
  })();

  /* ---- GIF picker (Giphy, proxied; works in composer / comments / DMs) - */
  var gifPop = null, gifGrid = null, gifCols = null, gifSearch = null, gifTimer = null, gifForm = null, gifAnchor = null;
  function buildGifPop() {
    gifPop = document.createElement('div');
    gifPop.className = 'gif-pop';
    // GIPHY requires a visible "Powered by GIPHY" attribution on the GIF search window (kept OUTSIDE
    // the scrollable grid so it's a persistent footer). GIFs are sourced from the GIPHY API.
    // TWO nested elements, not one: .gif-grid is the SCROLLER and .gif-cols carries the 2-column masonry.
    // They used to be the same element, and a multi-column box with a constrained height is required to
    // fragment its overflow into MORE COLUMNS -- sideways -- so a full result set laid itself out off the
    // right edge of the panel and the extra columns were simply unreachable (measured: scrollWidth >
    // clientWidth on every viewport, which is a large part of "can't properly see the full giphy screen").
    // With the multicol on an inner box of AUTO height it lays out two full-length columns and the outer
    // box scrolls them vertically, which is what it always looked like it was doing.
    gifPop.innerHTML = '<input class="input gif-search" placeholder="Search GIFs…" autocomplete="off">' +
      '<div class="gif-grid"><div class="gif-cols"></div></div>' +
      '<div class="gif-credit">Powered by <b>GIPHY</b></div>';
    document.body.appendChild(gifPop);
    gifSearch = gifPop.querySelector('.gif-search');
    gifGrid = gifPop.querySelector('.gif-grid');
    gifCols = gifPop.querySelector('.gif-cols');
    gifSearch.addEventListener('input', function () {
      clearTimeout(gifTimer);
      var q = gifSearch.value.trim();
      gifTimer = setTimeout(function () { loadGifs(q); }, 320);
    });
    /* A TAP SELECTS ON THE TOUCH ITSELF, NOT ON THE CLICK THE BROWSER SYNTHESISES AFTERWARDS
       (owner, mobile Safari: "I had to tap the one I wanted twice, the first tap didn't do anything").
       The picker used to have ONE way in -- this click listener -- so every iOS mechanism that
       withholds the synthesised click from a first contact killed the pick outright and left the
       second tap to do the job. Measured on the shipped bundle with real touchstart/touchend and the
       click suppressed: 0/4 surfaces inserted; with the click allowed through, 4/4 did. That is the
       whole failure, and it is invisible to a mouse test -- page.mouse dispatches no touch events at
       all (see the carousel scrub bar, same lesson).
       The first tap is the one iOS is least willing to turn into a click: the picker had just focused
       .gif-search, so the on-screen keyboard was up and over the panel, and that first contact is
       spent dismissing it. openGifFor() no longer takes that focus on a touch device, and popFit()
       now measures the VISUAL viewport so a keyboard raised some other way cannot cover the tiles --
       but neither of those can be relied on to make the click arrive, so the touch is made
       authoritative here instead.
       OWNERSHIP IS DECIDED AT touchstart, FROM THE ORIGIN, never from movement: .gif-grid is a
       scroller, and a drag that begins on a tile is a scroll, not a pick. touchmove past a small
       slop drops the claim; touchend re-hit-tests under the finger so a tile that shifted (the
       masonry reflows as lazy previews land) can't be picked by accident. */
    var gtTile = null, gtX = 0, gtY = 0, gtAt = 0;
    gifGrid.addEventListener('touchstart', function (e) {
      var t = e.touches && e.touches[0];
      if (!t || e.touches.length > 1) { gtTile = null; return; }      // a pinch is never a tap
      gtTile = e.target && e.target.closest ? e.target.closest('.gif-tile') : null;
      gtX = t.clientX; gtY = t.clientY;
    }, { passive: true });
    gifGrid.addEventListener('touchmove', function (e) {
      if (!gtTile) return;
      var t = e.touches && e.touches[0]; if (!t) { gtTile = null; return; }
      if (Math.abs(t.clientX - gtX) > 10 || Math.abs(t.clientY - gtY) > 10) { gtTile = null; }   // scrolling
    }, { passive: true });
    gifGrid.addEventListener('touchcancel', function () { gtTile = null; }, { passive: true });
    // NOT passive: preventDefault() here is what stops the browser also synthesising a click that
    // would run the handler below a second time. gtAt covers the engines that fire it regardless.
    gifGrid.addEventListener('touchend', function (e) {
      var tile = gtTile; gtTile = null;
      if (!tile || (e.touches && e.touches.length)) return;
      var t = e.changedTouches && e.changedTouches[0];
      if (t) {
        var over = document.elementFromPoint(t.clientX, t.clientY);
        if (!over || !over.closest || over.closest('.gif-tile') !== tile) return;   // finger ended elsewhere
      }
      gtAt = Date.now();
      if (e.cancelable) e.preventDefault();
      selectGif(tile.getAttribute('data-url'), tile.getAttribute('data-preview'), gifTileDims(tile));
    }, { passive: false });
    // The mouse / pen / keyboard path, unchanged. The guard only rejects a click that belongs to a
    // touch we have already served, so a real pointer click is never swallowed.
    gifGrid.addEventListener('click', function (e) {
      if (Date.now() - gtAt < 700) return;
      var t = e.target.closest('.gif-tile');
      if (t) selectGif(t.getAttribute('data-url'), t.getAttribute('data-preview'), gifTileDims(t));
    });
  }
  /* {w, h} for a tile, or null. ONE reader for BOTH selection paths (touchend and click) --
     the two have already drifted once over which one serves a tap, and a dimension read that
     existed on only one of them would store a sized GIF from a mouse and an unsized one from a
     finger. Anything non-numeric or <= 0 is no answer at all: half a pair is not a ratio. */
  function gifTileDims(tile) {
    if (!tile) return null;
    var w = parseInt(tile.getAttribute('data-w'), 10), h = parseInt(tile.getAttribute('data-h'), 10);
    return (w > 0 && h > 0) ? { w: w, h: h } : null;
  }
  function loadGifs(q) {
    if (!gifCols) return;
    gifGrid.scrollTop = 0;
    gifCols.innerHTML = '<div class="gif-loading">Loading…</div>';
    fetch('/gif-search?q=' + encodeURIComponent(q), {
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin'
    }).then(function (r) { return r.json(); }).then(function (res) {
      var gifs = (res && res.gifs) || [];
      if (!gifs.length) { gifCols.innerHTML = '<div class="gif-loading">No GIFs found.</div>'; return; }
      gifCols.innerHTML = '';
      gifs.forEach(function (g) {
        var d = document.createElement('button');
        d.type = 'button'; d.className = 'gif-tile';
        d.setAttribute('data-url', g.url); d.setAttribute('data-preview', g.preview);
        /* The PICK'S OWN PIXEL SIZE (migration 0133). Giphy's API has always carried it on the
           rendition object and Giphy::search() used to read `.url` off that object and throw the
           rest away -- which is why a comment GIF had no dimensions anywhere on the server and
           every thread with one in it shifted as the image decoded. This is the ONLY moment the
           numbers are free: the picker already has the API response in hand. Absent (an older
           /gif-search response cached at the edge, a rendition that declares no size) simply
           means no attribute, and the pick is stored dimensionless exactly as before. */
        if (g.w && g.h) { d.setAttribute('data-w', g.w); d.setAttribute('data-h', g.h); }
        d.innerHTML = '<img src="' + escHtml(g.preview) + '" alt="" loading="lazy">';
        gifCols.appendChild(d);
      });
    }).catch(function () { gifCols.innerHTML = '<div class="gif-loading">Couldn’t load GIFs.</div>'; });
  }
  /* ANCHOR IN VIEWPORT COORDINATES (web report #52, owner: "gif doesn't work in full screen").
     The picker is a BODY child and was position:absolute, placed from the button's rect PLUS
     window.scrollX/scrollY. That holds only while the page is in normal flow. Open it from inside the
     immersive viewer (or the gallery) and BOTH halves break at once, because those overlays run the shared
     scroll lock: it pins `body` at `position:fixed; top:-<scrollY>px`. So (a) the body is now a POSITIONED
     ancestor whose box starts ~29,000px ABOVE the viewport, which is where an absolutely-positioned child
     gets measured from, and (b) window.scrollY reads 0, because the document isn't scrolled any more --
     the compensation that was supposed to cancel the offset is gone at exactly the moment an offset appears.
     Net: the picker opened, painted thousands of px off-screen, and threw nothing. "Tapping it does nothing",
     console_errors: []. It only ever reproduced on a deeply-scrolled page; at scrollY 0 the bug is invisible.
     position:fixed + the RAW rect is the same arithmetic in both contexts -- getBoundingClientRect() is
     always viewport-relative, and a fixed body child is viewport-anchored whether the body is pinned or not,
     so the in-flow composers (permalink, settings, DM thread) take the identical path with no branch.
     Clamped on all four sides, and flipped ABOVE the button when the space below can't hold the panel --
     the two comment-sheet buttons (.cpanel-form / .gal-cform) sit at the very bottom of a full-screen sheet,
     which is precisely where "just drop it underneath" runs off the screen. See also .gif-pop's z-index:
     130 sat UNDER .pfeed (205) and .gal (200), so even placed correctly it would have rendered behind them. */
  function openGifFor(btn) {
    // ".hdrop-compose" is the header flyout's INLINE DM bar. It is built by string
    // concatenation in JS and is a <div>, not a <form> (it sends through sendDM(), not a
    // POST), so closest('form') found nothing and the picker had no target. Everything
    // below this point is keyed off the ELEMENT, never off the tag, so widening the
    // lookup is all the inline bar needs -- no second implementation.
    gifForm = btn.closest('form, .hdrop-compose'); gifAnchor = btn;
    if (!gifPop) buildGifPop();
    gifPop.classList.add('show');                       // it's display:none until shown -- measure it laid out
    gifSearch.value = ''; loadGifs('');
    gifFit(btn);
    /* AUTOFOCUS THE SEARCH FIELD ONLY WHERE THERE IS A REAL POINTER. On a phone this one line
       raised the on-screen keyboard the instant the picker opened -- over the bottom of the panel
       it had just measured (popFit reads the LAYOUT viewport, which does not shrink for a keyboard)
       -- and put the member's first tap to work dismissing that keyboard instead of picking a GIF.
       It is the same shape as the search dropdown's fix above ("the dropdown ran under it and the
       bottom rows sat past the clip -- taps there hit the page behind"). On a desktop, type-to-search
       is worth having and there is no keyboard to raise, so nothing changes there. */
    if (!coarsePointer()) { gifSearch.focus(); }
  }
  /* Touch/pen-first device: no hover, no fine pointer. Used for the autofocus decision only --
     every code path below still works on both, so this can never gate correctness. */
  function coarsePointer() {
    try {
      if (!window.matchMedia) { return false; }
      return matchMedia('(pointer:coarse)').matches || matchMedia('(hover:none)').matches;
    } catch (e) { return false; }
  }
  /* PLACE **AND SIZE** THE PICKER SO THE WHOLE PANEL IS ON SCREEN (owner: "can't properly see the full
     giphy screen") -- a second, independent defect from the off-screen one above.
     The old placement clamped one axis and half-clamped the other: `left` was clamped, `top` was simply
     "8px under the button" with no check that the panel FITS there, and the panel itself had no height
     bound at all (width:324px / max-width:92vw, an unbounded grid). Anchored to a comment composer -- which
     always sits low in the window -- a full result set ran straight off the bottom, and off the right on a
     narrow window.
     Two things make it hold now:
       1. HEIGHT IS BOUNDED BEFORE THE RESULTS ARRIVE. loadGifs() is async, so at placement time the grid
          still reads "Loading…" and measures ~90px tall. Anything computed from the CURRENT height is
          measuring the wrong panel -- that is exactly how it "fitted" and then grew off the screen a beat
          later. So we size to the room AVAILABLE, cap the panel with max-height, and let .gif-grid scroll
          inside it. That also keeps the "Powered by GIPHY" credit -- a GIPHY attribution requirement, and
          why it sits OUTSIDE the scroller -- pinned and visible however many results come back.
       2. WE PIN THE EDGE THE PANEL GROWS AWAY FROM. Opening downward pins `top` under the button; opening
          upward pins `bottom` above it. Pinning `top` in both directions is what let the async growth
          escape the bottom of the window.
     One coordinate space throughout: the rect is viewport-relative and the panel is position:fixed, so
     these are all viewport pixels. The old code added scrollX to `left` and then clamped that DOCUMENT
     coordinate against window.innerWidth -- two different spaces the moment the page is scrolled. */
  /* popFit is gifFit generalised, because the EMOJI picker has exactly the same two defects
     (it opened "8px under the button" with no fit check and no vertical clamp) and the inline
     DM bar sits at the very bottom of a bottom sheet, which is precisely where that runs off
     the screen. `cap` bounds a panel that has its own design height (.emoji-pop: 228px);
     pass 0 for a panel that should use whatever room it can get (.gif-pop). */
  function gifFit(btn) { popFit(gifPop, btn, 300, 140, 0); }
  function popFit(pop, btn, WANT, MIN, cap) {
    var r = btn.getBoundingClientRect();
    var vw = document.documentElement.clientWidth || window.innerWidth || 360;
    var vh = document.documentElement.clientHeight || window.innerHeight || 640;
    var GAP = 8, EDGE = 8;   // WANT: enough room below to be worth opening downward
    // CLAMP THE ANCHOR TO THE VIEWPORT FIRST. A button can legitimately be off-screen when the picker is
    // opened -- the shared scroll lock pins the body, so a composer behind a full-screen overlay keeps its
    // original document position and reports a rect hundreds or thousands of px past the fold. Measuring
    // "room above/below" against that produces a perfectly self-consistent answer for a place nobody can
    // see. Clamped, an off-screen anchor collapses to the nearest edge and the panel simply opens against it.
    var aTop = Math.max(0, Math.min(vh, r.top));
    var aBot = Math.max(0, Math.min(vh, r.bottom));
    var aLeft = Math.max(0, Math.min(vw, r.left));
    /* MEASURE THE ROOM AGAINST THE **VISUAL** VIEWPORT. document.documentElement.clientHeight is the
       LAYOUT viewport, which on iOS does not shrink when the on-screen keyboard comes up -- so a panel
       fitted against it is fitted to a rectangle whose bottom the keyboard is sitting on, and taps
       down there hit the keyboard, not the tiles. (Exactly the defect already fixed for the search
       dropdown, which caps itself to visualViewport.height for the same reason.)
       Expressed as usable TOP/BOTTOM edges in layout coordinates, because .gif-pop is position:fixed
       and is laid out against the layout viewport whatever the keyboard is doing. With no keyboard up
       offsetTop is 0 and height === clientHeight, so vTop/vBot collapse to 0/vh and the arithmetic
       below is bit-for-bit what it was -- this cannot move the panel on a desktop. */
    var vv = window.visualViewport || null;
    var vTop = vv ? Math.max(0, Math.min(vh, vv.offsetTop)) : 0;
    var vBot = vv ? Math.max(vTop + MIN, Math.min(vh, vv.offsetTop + vv.height)) : vh;
    var below = vBot - aBot - GAP - EDGE;
    var above = aTop - vTop - GAP - EDGE;
    var down  = below >= WANT || below >= above;    // prefer under the button; flip up only when it's cramped
    var room  = down ? below : above;
    var maxH  = Math.min((vBot - vTop) - EDGE * 2, Math.max(MIN, room));
    if (cap) { maxH = Math.min(maxH, cap); }
    // clientWidth, not 92vw: vw units include the scrollbar, so on a narrow window with a classic scrollbar
    // a 92vw panel is genuinely wider than the space it has to fit into.
    pop.style.maxWidth  = Math.max(180, vw - EDGE * 2) + 'px';
    pop.style.maxHeight = Math.round(maxH) + 'px';
    if (room < maxH) {
      // Neither side can hold even MIN (a short window, or a button filling it). The anchor is unusable,
      // so stop pretending: centre the panel vertically, still fully on screen.
      pop.style.top = Math.round(Math.max(vTop + EDGE, vTop + ((vBot - vTop) - maxH) / 2)) + 'px'; pop.style.bottom = 'auto';
    } else if (down) {
      pop.style.top = Math.round(aBot + GAP) + 'px'; pop.style.bottom = 'auto';
    } else {
      pop.style.bottom = Math.round(vh - aTop + GAP) + 'px'; pop.style.top = 'auto';
    }
    var pw = pop.offsetWidth || 324;                // measured: max-width may have narrowed it
    pop.style.left = Math.round(Math.max(EDGE, Math.min(aLeft, vw - pw - EDGE))) + 'px';
  }
  // Keep it fitted if the window changes under an open picker (rotation, a resized window, the mobile
  // keyboard shrinking the visual viewport). Cheap: it only measures while the panel is actually up.
  function gifRefit() {
    if (gifPop && gifAnchor && gifPop.classList.contains('show')) gifFit(gifAnchor);
  }
  window.addEventListener('resize', gifRefit);
  // window resize is NOT how iOS reports a keyboard: the layout viewport does not change, only the
  // VISUAL one does. Without this listener the refit above never runs for the case popFit now measures.
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', gifRefit);
    window.visualViewport.addEventListener('scroll', gifRefit);
  }
  function closeGif() { if (gifPop) gifPop.classList.remove('show'); gifAnchor = null; }

  /* ---- per-form GIF pick: comment + DM composers -------------------------
     The POST composer owns a STATIC hidden gif_url plus the document-wide #gif-preview id.
     Comment forms can use NEITHER: a page holds many of them open at once (one per post panel,
     plus the gallery's and the permalink's), so an id cannot address "the form the picker was
     opened from". Everything below is therefore keyed off the FORM ELEMENT -- which the picker
     has already resolved for us (openGifFor: gifForm = btn.closest('form')). The chosen URL
     lives in a hidden field we CREATE inside that form, tagged data-cgif so selectGif's
     composer branch (which looks for a static gif_url) can never mistake it for one.

     WHERE THE URL TRAVELS differs by surface, and that is why DMs still carry it in the body:
       - comments: /comment reads $_POST['gif_url'] directly (index.php handle_comment) and
         Comments::add treats "empty body + a GIF" as a valid comment, so the pick rides its own
         field and the member's text is left alone.
       - DMs: messages have NO gif_url column -- views/messages_thread.php renders one by running
         extract_gif() over the BODY -- so the DM handler folds the URL back into the body it
         sends. Storage is unchanged; only the composer stops showing the raw URL.
     Either way the raw URL never sits in the visible input. */
  function cgifField(form, name) {
    return form && form.querySelector
      ? form.querySelector('input[name="' + (name || 'gif_url') + '"][data-cgif]') : null;
  }
  function cgifUrl(form) { var h = cgifField(form); return h ? (h.value || '') : ''; }
  /* The pick's dimensions (migration 0133), carried in two more hidden fields beside gif_url and
     posted to /comment as gif_w / gif_h. They ride the same data-cgif tag for the same reason the
     url does -- one page holds many comment forms open at once, so an id could never address "the
     form the picker was opened from" and the composer's STATIC gif_url must never be confused for
     one of these. DMs are untouched: messages have no gif columns, their GIF is sniffed back out
     of the body, and there is nowhere to put a size. */
  function cgifDims(form) {
    var w = parseInt((cgifField(form, 'gif_w') || {}).value, 10);
    var h = parseInt((cgifField(form, 'gif_h') || {}).value, 10);
    return (w > 0 && h > 0) ? { w: w, h: h } : null;
  }
  /* Write (or erase) one of those hidden fields. Erasing REMOVES the node rather than blanking
     it: an empty gif_w in the POST body is a field the server has to defend against, and there is
     no reason to send one. */
  function cgifSetHidden(form, name, val) {
    var h = cgifField(form, name);
    if (!val) { if (h && h.parentNode) h.parentNode.removeChild(h); return; }
    if (!h) {
      h = document.createElement('input');
      h.type = 'hidden'; h.name = name; h.setAttribute('data-cgif', '1');
      form.appendChild(h);
    }
    h.value = String(val);
  }
  /* The one place that answers "which field does this composer type into?".
     Server-rendered composers name their field `body`; the header flyout's inline DM bar is
     built in JS and sends through sendDM(), so its field carries no name at all -- only
     class="input". Ordered, not combined into one selector list: querySelector returns the
     first match in DOCUMENT order, so folding `input.input` into the list could hand a
     server-rendered form some OTHER .input that happens to sit above its body field. */
  function cgifBody(form) {
    if (!form || !form.querySelector) { return null; }
    return form.querySelector('textarea, input[name="body"]') || form.querySelector('input.input');
  }
  // The comment sheet animates to an EXPLICITLY measured height, so a preview appearing or
  // leaving changes the form's height AFTER that measurement -- the input row would spill past
  // the sheet's bottom edge. Re-measure exactly the way the reply chip already does.
  function cgifResize(form) {
    var cp = form && form.closest ? form.closest('.comment-panel, .croller-panel') : null;
    if (cp && cp._size) cp._size();
  }
  // post_single's comment textarea carries `required`. Native validation runs BEFORE the submit
  // event fires, so a GIF with no text would be blocked by the browser and never reach our
  // handler at all. Lift it while a GIF is attached, and put it back when the GIF is removed.
  function cgifRequired(form, want) {
    var f = form.querySelector('textarea[name="body"], input[name="body"], textarea');
    if (!f) return;
    if (!want && f.hasAttribute('required')) { f.setAttribute('data-cgif-req', '1'); f.removeAttribute('required'); }
    else if (want && f.getAttribute('data-cgif-req') === '1') { f.removeAttribute('data-cgif-req'); f.setAttribute('required', 'required'); }
  }
  function cgifSet(form, url, preview, dims) {
    if (!form) return;
    var h = cgifField(form);
    if (!h) {
      h = document.createElement('input');
      h.type = 'hidden'; h.name = 'gif_url'; h.setAttribute('data-cgif', '1');
      form.appendChild(h);
    }
    h.value = url;
    // Always written as a PAIR, and always overwritten -- a second pick into a form that already
    // held one must not leave the first GIF's size behind on the second GIF's url.
    cgifSetHidden(form, 'gif_w', dims && dims.w);
    cgifSetHidden(form, 'gif_h', dims && dims.h);
    var p = form.querySelector('.cgif-prev');
    if (!p) {
      p = document.createElement('div');
      // The DM bar is a single non-wrapping flex row, so its preview is a small square that sits
      // in the row like the photo attachment's (.dm-attach-prev). The comment forms are
      // flex-wrap:wrap, where a width:100% child takes its own line -- the same trick .reply-chip
      // uses -- so theirs is a full-width thumbnail above the input.
      var mini = !!(form.classList && (form.classList.contains('dm-compose')
                                    || form.classList.contains('hdrop-compose')));
      p.className = 'cgif-prev' + (mini ? ' mini' : '');
      var chip = form.querySelector('.reply-chip');
      if (mini) {
        var inp = cgifBody(form);
        form.insertBefore(p, inp || null);
      } else if (chip && chip.parentNode === form) {
        form.insertBefore(p, chip.nextSibling);   // under "Replying to …", above the input row
      } else {
        // no chip (or it's nested): fall in ahead of whichever direct child holds the submit
        var send = form.querySelector('button[type="submit"]'), anchor = send;
        while (anchor && anchor.parentNode !== form) anchor = anchor.parentNode;
        form.insertBefore(p, anchor || null);
      }
    }
    // TWO elements on purpose. .cgif-prev is the full-WIDTH flex line (so the input keeps its own
    // row); .cgif-thumb is the shrink-to-fit box the ✕ is anchored to. Capping .cgif-prev itself
    // instead would make it a ~200px flex item and the composer input would wrap up alongside it
    // and be crushed to a sliver.
    p.innerHTML = '<span class="cgif-thumb"><img src="' + escHtml(preview || url) + '" alt="Chosen GIF">' +
      '<button type="button" class="cgif-x" aria-label="Remove GIF">✕</button></span>';
    p.hidden = false;
    cgifRequired(form, false);
    cgifResize(form);
    var f = cgifBody(form);
    if (f) f.focus();
  }
  function cgifClear(form) {
    if (!form) return;
    var h = cgifField(form); if (h) h.value = '';
    cgifSetHidden(form, 'gif_w', 0); cgifSetHidden(form, 'gif_h', 0);   // the pair goes with the url
    var p = form.querySelector('.cgif-prev'); if (p) { p.hidden = true; p.innerHTML = ''; }
    cgifRequired(form, true);
    cgifResize(form);
  }
  /* Snapshot-and-clear for the OPTIMISTIC sends: every comment/DM handler wipes the composer
     the instant you hit send and puts the draft back if the request dies, so the GIF has to
     travel the same way -- otherwise a failed send loses the pick, or leaves a stale thumbnail
     sitting over the next comment. restore() is a no-op once a NEW gif has been picked. */
  function cgifTake(form) {
    var url = cgifUrl(form);
    // snapshot the dimensions BEFORE the clear, or a failed send restores a sized pick unsized
    var dims = cgifDims(form);
    var img = form ? form.querySelector('.cgif-prev img') : null;
    var prev = img ? img.getAttribute('src') : '';
    if (url) cgifClear(form);
    return {
      url: url,
      w: dims ? dims.w : 0,
      h: dims ? dims.h : 0,
      restore: function () { if (url && !cgifUrl(form)) cgifSet(form, url, prev, dims); }
    };
  }

  function selectGif(url, preview, dims) {
    // the post editor (.pe-form) turns a pick into an attachment tile itself -- see __rovaOnGif there
    if (gifForm && typeof gifForm.__rovaOnGif === 'function') { try { gifForm.__rovaOnGif(url, preview, dims); } catch (e) {} closeGif(); return; }
    if (gifForm) {
      // :not([data-cgif]) -- only the composer's STATIC field takes the post-media path
      var hidden = gifForm.querySelector('input[name="gif_url"]:not([data-cgif])');
      if (hidden) { // composer: gif becomes post media, with a preview
        hidden.value = url;
        var prev = document.getElementById('gif-preview');
        if (prev) {
          prev.innerHTML = '<img src="' + escHtml(preview) + '" alt=""><button type="button" class="gif-remove" aria-label="Remove GIF">✕</button>';
          prev.hidden = false;
        }
      } else { // comment / DM: attach it to THIS form, and show it instead of a raw URL
        cgifSet(gifForm, url, preview, dims);
      }
    }
    closeGif();
  }
  document.addEventListener('click', function (e) {
    var gb = e.target.closest ? e.target.closest('.js-gif') : null;
    if (gb) {
      e.preventDefault(); e.stopPropagation();
      if (gifPop && gifPop.classList.contains('show') && gifAnchor === gb) closeGif(); else openGifFor(gb);
      return;
    }
    if (gifPop && gifPop.classList.contains('show') && !gifPop.contains(e.target)) closeGif();
    var rm = e.target.closest ? e.target.closest('.gif-remove') : null;
    if (rm) {
      var h = document.getElementById('compose-gif'); if (h) h.value = '';
      var p = document.getElementById('gif-preview'); if (p) { p.hidden = true; p.innerHTML = ''; }
    }
    // the comment/DM twin of .gif-remove: scoped to its own form, never an id
    var crm = e.target.closest ? e.target.closest('.cgif-x') : null;
    if (crm) { e.preventDefault(); cgifClear(crm.closest('form, .hdrop-compose')); }
  });

  /* ---- who-reacted list (tap the reaction summary) --------------------- */
  var rxModal = null;
  function ensureRxModal() {
    if (rxModal) return rxModal;
    rxModal = document.createElement('div');
    rxModal.className = 'rx-modal';
    rxModal.innerHTML = '<div class="rx-card"><div class="rx-head"><span>Reactions</span>' +
      '<button class="rx-close" type="button" aria-label="Close">✕</button></div><div class="rx-list"></div></div>';
    document.body.appendChild(rxModal);
    rxModal.addEventListener('click', function (e) {
      if (e.target === rxModal || e.target.closest('.rx-close')) closeRx();
    });
    return rxModal;
  }
  function closeRx() { if (rxModal) { rxModal.classList.remove('show'); unlockScroll(); } }
  function openList(type, post) {
    var m = ensureRxModal();
    document.body.appendChild(m);   // stack above the insights sheet that opens it (same z-index, later in the DOM)
    m._vgen = (m._vgen || 0) + 1;    // abandon a "Seen by" pager still running in this shared sheet
    if (m._vio) { m._vio.disconnect(); m._vio = null; }
    m.querySelector('.rx-head span').textContent = type === 'reposters' ? 'Reposted by' : 'Reactions';
    var list = m.querySelector('.rx-list');
    list.innerHTML = '<div class="rx-loading">Loading…</div>';
    m.classList.add('show'); lockScroll();
    var endpoint = (type === 'reposters' ? '/reposters' : '/reactions') + '?post=' + encodeURIComponent(post);
    fetch(endpoint, {
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin'
    }).then(function (r) { return r.json(); }).then(function (res) {
      // who-liked names are private to the post's author; non-owners only get the counts
      if (res && res.private) { list.innerHTML = '<div class="rx-loading">Only the author can see who liked this post.</div>'; return; }
      var rs = (res && res.reactors) || [];
      if (!rs.length) { list.innerHTML = '<div class="rx-loading">Nobody yet.</div>'; return; }
      list.innerHTML = '';
      /* HOW MANY PEOPLE SUPER-LOVED IT (owner 2026-08-17). The aggregate, and the ONLY number the
         receiver is shown about the press-and-hold: it counts PEOPLE, never how long anybody held,
         so one person cannot move it by pressing harder and no liker can be ranked against another.
         Served by handle_reactions as `superloves`, computed over the whole post rather than summed
         from the rows below (which are capped at 200 and suppression-filtered), so it agrees with
         the count in the bell and in the insights panel -- all three are one server function.
         Reactions sheet only, and absent/0 renders nothing, so an older server is a no-op here. */
      var sl = (type !== 'reposters' && res && +res.superloves) || 0;
      if (sl > 0) {
        /* THE VERB (owner, 2026-08-29): "spotted an inconsistency" -- the banner said
           "super-loved" over a screen whose only super-lover's own pill read "Super-laughed".
           `superReaction` (Posts::superLoveReaction) names the one emoji to use here, or is
           null for the three cases the generic phrasing has to cover (mixed reactions among
           several supers, or a sad/angry hold, which RX_SUPER only has an ADJECTIVE for and
           this sentence needs a VERB). RX_SUPER is the exact map the per-row pill already
           uses -- lowercased here because the pill is a standalone chip and this is mid-sentence. */
        var srx = (type !== 'reposters' && res && res.superReaction) || null;
        var verb = (srx && RX_SUPER[srx]) ? RX_SUPER[srx].charAt(0).toLowerCase() + RX_SUPER[srx].slice(1) : 'super-loved';
        var sd = document.createElement('div');
        sd.className = 'rx-super';
        sd.innerHTML = '<span class="rx-super-ic">' + LOVE_SVG + '</span><span>' +
          (sl === 1 ? '1 person ' + verb + ' this post' : escHtml(String(sl)) + ' people ' + verb + ' this post') +
          '</span>';
        list.appendChild(sd);
      }
      rs.forEach(function (u) {
        // owner 2026-08-12: "verified badges should also show". Same .vtick markup every other
        // people row on the site uses, so it reads identically wherever a reader has met it.
        var tick = u.verified ? vsealTick() : '';
        var a = document.createElement('a');
        a.className = 'rx-row'; a.href = '/@' + encodeURIComponent(u.username);
        // THE BLUE CHECK RIDES THE PHOTO (owner 2026-08-16), not the name -- this sheet was the
        // last people row still drawing it inline, and the app half (PostCard.js, <VerifiedCorner
        // avatar={38} />) has been on the shared corner since that round, so the two sheets have
        // been showing the author two different badges for the same reactor.
        // The inline version was not clipped here -- `.rx-name .n` sets font-weight and nothing
        // else, so it never truncated and the tick did paint -- it just paints in the WRONG PLACE:
        // .n is a blockified item of a column flexbox, so a long display name WRAPS instead of
        // ellipsizing and carries the tick down onto a second line, and the row grows taller than
        // its 40px photo. Off the name line entirely is the fix on every other surface and it is
        // the fix here.
        // .vav is the shared corner-badge wrapper in rova.css (search ".vav" near the base .vtick
        // rule): 38% of the avatar box clamped 11-17px, a 2px --app-bg-base ring, height:fit-content
        // so a stretched wrapper cannot draw an oval. It sizes itself from the 40px .avatar.sm
        // jsAvatar() emits, so there is no second number to keep in step here. Nothing is
        // hand-copied; only the wrapper is added.
        // The wrapper goes OUTSIDE any presence wrapper and the tick INSIDE .vav, matching the
        // search-typeahead row above: jsAvatar() has no .av-on branch today (no /reactions payload
        // carries `online`), but shaped this way the shared `.vav:has(> .vtick) .online-dot` rule
        // moves the dot inboard for free the day one does, instead of the two badges colliding.
        a.innerHTML = (tick ? '<span class="vav">' + jsAvatar(u) + tick + '</span>' : jsAvatar(u)) +
          '<div class="rx-name"><span class="n">' + escHtml(u.display_name) + '</span>' +
          '<span class="h">@' + escHtml(u.username) + '</span>' +
          /* THE WORD, not just the icon (owner, 2026-08-27): an icon-only signal (the gold heart
             / the .rx-emoji.held glow below) was too easy to miss scanning a list of 30+ plain
             hearts -- the whole point of the super-love banner is "the poster should be able to
             tell WHO", and a colour difference on a small glyph does not deliver that reliably.
             Same word the banner already uses ("N people super-loved this post"), so the row and
             the aggregate never disagree on vocabulary. Every tier (1-3) reads as this one word:
             the banner counts them together and does not distinguish tiers either. */
          (u.love > 0 ? '<span class="rx-superlabel">' + escHtml(RX_SUPER[u.reaction] || 'Super-loved') + '</span>' : '') +
          '</div>' +
          /* THE RECEIVER SIDE OF THE PRESS-AND-HOLD BURST, AND ITS ONLY SURFACE ANYWHERE.
             `u.love` is a 0-3 tier, never a count. This list is already private to the post's
             author (handle_reactions gates it on Posts::insightsVisible), which is exactly why the
             upgraded signal lives here: the poster sees that someone loved it, and no other liker
             can see it, compare against it, or feel ranked by it. There is deliberately no number
             in the notification, no number in the feed, and no public count anywhere -- burst
             numbers shown to receivers are what made this feature class read as noisy and
             untrustworthy elsewhere. A plain tap renders exactly as it always has.
             A HELD REACTION THAT ISN'T THE PLAIN HEART GETS THE SAME SIGNAL (2026-08-27): before
             this, u.love > 0 with any reaction other than 'heart' fell straight to the plain-emoji
             branch below, so someone who held 😍 or 🔥 to the cap was invisible in a list whose own
             banner had just announced them. See the .rx-emoji.held rule in rova.css for why this
             is a glow and not a colour change. */
          (u.love > 0 && (!u.reaction || u.reaction === 'heart')
            ? '<span class="rx-emoji rx-love t' + Math.min(3, u.love) + '" title="Loved with a press and hold" aria-label="Loved">' + LOVE_SVG + '</span>'
            : u.love > 0
              ? '<span class="rx-emoji held t' + Math.min(3, u.love) + '" title="' + escHtml(RX_LABEL[u.reaction] || u.reaction) + ' — held" aria-label="' + escHtml(RX_LABEL[u.reaction] || u.reaction) + ', held">' + rxIc(u.reaction) + '</span>'
              : (u.reaction ? '<span class="rx-emoji">' + rxIc(u.reaction) + '</span>' : ''));
        list.appendChild(a);
      });
    }).catch(function () { list.innerHTML = '<div class="rx-loading">Couldn’t load.</div>'; });
  }
  /* ---- "SEEN BY": who saw the post (owner-only, 2026-10-12) ---------------------------------
     Rob: "People wanna see who Seen by also, so make them buttons so people can click it, just like
     the See who liked." GET /post-viewers (routes/post.php handle_post_viewers, filters in
     Reach::viewers: no seeds, suppressed, banned, blocked-either-way or the author). Newest first,
     keyset-paged by `next`, 30 a page, the next page loads when "Show more" scrolls into view.
     Page one carries `tally`, which reconciles the list with the tile it was opened from: the tile
     counts every view (members + guests) and is never deflated, the list names only the members
     who can be shown, so the head says how the number splits instead of quietly disagreeing.
     Guests are never listed; they close the list as "+N guests". */
  function rxCount(n, one, many) { n = +n || 0; return n.toLocaleString() + ' ' + (n === 1 ? one : many); }
  function viewerRow(u) {
    var tick = u.verified ? vsealTick() : '';
    var row = document.createElement('div');
    row.className = 'rx-row rx-prow';
    // NOT one <a> like the likers rows: a Follow form cannot live inside a link, so the link wraps
    // the person and the form sits beside it (the shared js-follow submit handler drives it).
    var html = '<a class="rx-plink" href="/@' + encodeURIComponent(u.username) + '">' +
      (tick ? '<span class="vav">' + jsAvatar(u) + tick + '</span>' : jsAvatar(u)) +
      '<span class="rx-name"><span class="n">' + escHtml(u.display_name) + '</span>' +
      '<span class="h">@' + escHtml(u.username) + '</span></span></a>';
    if (!u.self) {
      var on = !!(u.following || u.requested);
      var tok = (document.querySelector('meta[name="csrf-token"]') || {}).content || csrf || '';
      var label = u.requested ? 'Requested' : (u.following ? 'Unfollow' : 'Follow');
      html += '<form class="js-follow rx-follow" method="post" action="/follow" data-name="' + escHtml(u.display_name) + '">' +
        '<input type="hidden" name="_csrf" value="' + escHtml(tok) + '">' +
        '<input type="hidden" name="user_id" value="' + (+u.id || 0) + '">' +
        '<input type="hidden" name="action" value="' + (on ? 'unfollow' : 'follow') + '">' +
        '<input type="hidden" name="return" value="' + escHtml(location.pathname) + '">' +
        '<button class="btn sm ' + (on ? 'gold-ghost' : 'primary') + '" type="submit"' +
        (on ? ' title="' + label + '" aria-label="' + label + '"' : '') + '>' + label + '</button></form>';
    }
    row.innerHTML = html;
    return row;
  }
  function openViewers(post) {
    var m = ensureRxModal();
    document.body.appendChild(m);   // last in <body> = drawn above the insights sheet it is opened from (same z-index)
    m.querySelector('.rx-head span').textContent = 'Seen by';
    var list = m.querySelector('.rx-list');
    list.innerHTML = '<div class="rx-loading">Loading…</div>';
    m.classList.add('show'); lockScroll();
    if (m._vio) { m._vio.disconnect(); m._vio = null; }
    var gen = m._vgen = (m._vgen || 0) + 1;   // a reopen (or the likers list) abandons this pager
    var guests = 0, more = null, busy = false;
    function done() {
      if (m._vio) { m._vio.disconnect(); m._vio = null; }
      if (more) { more.remove(); more = null; }
      if (guests > 0) {
        var f = document.createElement('div');
        f.className = 'rx-foot';
        f.textContent = '+' + rxCount(guests, 'guest', 'guests');
        list.appendChild(f);
      }
    }
    function page(cursor) {
      if (busy) return;
      busy = true;
      if (more) { more.disabled = true; more.textContent = 'Loading…'; }
      fetch('/post-viewers?post=' + encodeURIComponent(post) + (cursor ? '&cursor=' + encodeURIComponent(cursor) : ''), {
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin'
      }).then(function (r) { return r.json(); }).then(function (res) {
        if (m._vgen !== gen || list.closest('.rx-modal') !== m) return;
        busy = false;
        if (!res || !res.ok) {
          if (!cursor) { list.innerHTML = '<div class="rx-loading">' + (res && res.private ? 'Only the author can see who viewed this post.' : 'Couldn’t load.') + '</div>'; }
          else if (more) { more.disabled = false; more.textContent = 'Couldn’t load, try again'; }
          return;
        }
        var vs = res.viewers || [];
        if (!cursor) {
          list.innerHTML = '';
          var t = res.tally || {};
          guests = +t.guests || 0;
          var parts = [rxCount(t.members, 'person', 'people')];
          if (guests > 0) parts.push(rxCount(guests, 'guest', 'guests'));
          if (+t.hidden > 0) parts.push('<span title="Blocked and restricted accounts aren’t listed">' + escHtml((+t.hidden).toLocaleString()) + ' not shown</span>');
          var sum = document.createElement('div');
          sum.className = 'rx-sum';
          sum.innerHTML = 'Seen by <b>' + escHtml((+t.total || 0).toLocaleString()) + '</b> · ' + parts.join(' · ');
          list.appendChild(sum);
          if (!vs.length) {
            var em = document.createElement('div');
            em.className = 'rx-loading';
            em.textContent = guests > 0 ? 'Only guests have seen this so far.' : 'Nobody yet.';
            list.appendChild(em);
          }
        }
        vs.forEach(function (u) { list.insertBefore(viewerRow(u), more); });
        if (!res.next) { done(); return; }
        if (!more) {
          more = document.createElement('button');
          more.type = 'button';
          more.className = 'rx-more';
          list.appendChild(more);
          if ('IntersectionObserver' in window) {
            m._vio = new IntersectionObserver(function (es) {
              if (es[0] && es[0].isIntersecting && more && !more.disabled) more.click();
            }, { root: list, rootMargin: '0px 0px 160px 0px' });
            m._vio.observe(more);
          }
        }
        var nx = res.next;
        more.disabled = false; more.textContent = 'Show more';
        more.onclick = function () { page(nx); };
      }).catch(function () {
        if (m._vgen !== gen) return;
        busy = false;
        if (!cursor) list.innerHTML = '<div class="rx-loading">Couldn’t load.</div>';
        else if (more) { more.disabled = false; more.textContent = 'Couldn’t load, try again'; }
      });
    }
    page('');
  }
  document.addEventListener('click', function (e) {
    var s = e.target.closest ? e.target.closest('.js-reactors') : null;
    if (s && s.getAttribute('data-post')) { openList('reactions', s.getAttribute('data-post')); return; }
    var rp = e.target.closest ? e.target.closest('.js-reposters') : null;
    if (rp && rp.getAttribute('data-post')) { openList('reposters', rp.getAttribute('data-post')); return; }
    var sv = e.target.closest ? e.target.closest('.js-viewers') : null;
    if (sv && sv.getAttribute('data-post')) openViewers(sv.getAttribute('data-post'));
  });

  /* ---- owner-only post INSIGHTS (reach / plays / likes / reposts / analytics) ---- */
  var insModal = null;
  /* Tiles + reaction chips use THE ONE COUNT RULE, fmtCount (1.0k, 1.5k, 1.0m). This panel had a
     private twin printing "1K"/"1.5K"/"1M" until 2026-10-12; do not bring one back. */
  var insFmt = fmtCount;
  function ensureInsModal() {
    if (insModal) return insModal;
    insModal = document.createElement('div');
    insModal.className = 'rx-modal ins-modal';
    insModal.innerHTML = '<div class="rx-card ins-card"><div class="rx-head"><span>Post insights</span>' +
      '<button class="rx-close" type="button" aria-label="Close">✕</button></div><div class="ins-body"></div></div>';
    document.body.appendChild(insModal);
    insModal.addEventListener('click', function (e) {
      if (e.target === insModal || e.target.closest('.rx-close')) { insModal.classList.remove('show'); unlockScroll(); }
    });
    return insModal;
  }
  function openInsights(post, trigger) {
    var m = ensureInsModal();
    m._trigger = trigger || null;   // the card it was opened from: the Comments tile opens THAT card's comments
    var body = m.querySelector('.ins-body');
    body.innerHTML = '<div class="rx-loading">Loading…</div>';
    m.classList.add('show'); lockScroll();
    fetch('/post-insights?post=' + encodeURIComponent(post), {
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin'
    }).then(function (r) { return r.json(); }).then(function (d) {
      if (!d || !d.ok) {
        body.innerHTML = '<div class="rx-loading">' + (d && d.private ? 'Only the author can see insights.' : 'Couldn’t load insights.') + '</div>';
        return;
      }
      /* TAPPABLE TILES (Rob 2026-10-12: "make them buttons so people can click it"). The third slot
         names the list a tile opens: Seen by -> who viewed (/post-viewers), Likes -> the likers sheet,
         Comments -> the post's own comments, Reposts -> who reposted. Plays and Saves stay plain
         numbers (a play is not a person, and saves are private by convention), as does Super hearts
         (its people are the top of the likers list). A tile at 0 has no list and stays a number. */
      var stats = [['Seen by', d.reach, 'js-viewers']];
      if (d.is_video) stats.push(['Plays', d.plays]);
      stats.push(['Likes', d.likes, 'js-reactors'], ['Comments', d.comments, 'js-ins-comments'],
                 ['Reposts', d.reposts, 'js-reposters'], ['Saves', d.saves]);
      /* SUPER HEARTS (owner 2026-08-17). Owner-private, like the rest of this panel, and shown
         only when there are any -- a hairline of zeros on every ordinary post would make the
         feature look dead rather than unused.
         IT IS A SUBSET OF `Likes`, NOT AN ADDITION TO IT. A super-heart is exactly one like and is
         already inside the Likes figure above; the server does not fold it into `likes` or into
         the engagement rate either (see handle_post_insights), so this tile answers "how many of
         those likes were held" and can never exceed the tile beside it. */
      if (+d.superloves > 0) stats.push(['Super hearts', d.superloves]);
      var pid = escHtml(String(post));
      var grid = '<div class="ins-grid">' + stats.map(function (s) {
        var inner = '<span class="ins-n">' + insFmt(s[1]) + '</span><span class="ins-l">' + s[0] + '</span>';
        if (s[2] && +s[1] > 0) {
          return '<button type="button" class="ins-stat ins-tap ' + s[2] + '" data-post="' + pid + '"' +
            ' aria-label="' + s[0] + ': ' + escHtml(String(+s[1])) + '. ' + (s[2] === 'js-ins-comments' ? 'Open comments' : 'See who') + '">' +
            inner + '<svg class="ins-chev" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M9 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';
        }
        return '<div class="ins-stat">' + inner + '</div>';
      }).join('') + '</div>';
      /* ENGAGEMENT RATE (2026-10-12) = UNIQUE people who liked, commented, reposted or saved, over
         people reached (Posts::insightsEngagement) -- a share of people, so it tops out at 100%. It
         was actions ÷ reach and read 300% on a 1-view post. Nobody reached yet -> "–", not "0%". */
      var reached = +d.reach || 0;
      var eng = '<div class="ins-eng"' + (reached > 0 && d.engaged != null
          ? ' title="' + escHtml(fmtCount(d.engaged) + ' of ' + fmtCount(reached) + ' people reached liked, commented, reposted or saved') + '"' : '') +
        '>Engagement rate <b>' + (reached > 0 ? (+d.engagement || 0) + '%' : '–') + '</b> <span class="muted">' +
        (reached > 0 ? 'of people reached engaged' : 'nobody reached yet') + '</span></div>';
      var rx = '';
      if (d.reactions && d.reactions.length) {
        rx = '<div class="ins-rx">' + d.reactions.map(function (x) {
          return '<span class="ins-rxi">' + rxIc(x.reaction) + ' <b>' + insFmt(x.c) + '</b></span>';
        }).join('') + '</div>';
      }
      var links = '<div class="ins-links">' +
        (d.reach > 0 ? '<button class="btn-slim js-viewers" type="button" data-post="' + pid + '">See who viewed</button>' : '') +
        (d.likes > 0 ? '<button class="btn-slim js-reactors" type="button" data-post="' + post + '">See who liked</button>' : '') +
        (d.reposts > 0 ? '<button class="btn-slim js-reposters" type="button" data-post="' + post + '">See who reposted</button>' : '') +
        '</div>';
      body.innerHTML = grid + eng + rx + links;
    }).catch(function () { body.innerHTML = '<div class="rx-loading">Couldn’t load insights.</div>'; });
  }
  /* The Comments tile: close insights and open the post's comments the way its own comment button
     would -- that card's sheet in the feed/viewer, a scroll on the permalink -- so it is the same
     sheet and the same engage-hold. Prefers the card insights was opened from; otherwise any
     visible card of the post; otherwise the permalink's comments. */
  function insOpenComments(post) {
    var t = insModal && insModal._trigger;
    if (insModal && insModal.classList.contains('show')) { insModal.classList.remove('show'); unlockScroll(); }
    var sel = '.js-comments[data-post="' + String(post).replace(/[^0-9]/g, '') + '"]';
    var card = t && t.isConnected && t.closest ? t.closest('.post') : null;
    var c = card ? (card.querySelector('.act' + sel) || card.querySelector(sel)) : null;
    if (!c) {
      var all = document.querySelectorAll('.act' + sel + ', ' + sel);
      for (var i = 0; i < all.length; i++) { if (all[i].getClientRects().length) { c = all[i]; break; } }
    }
    if (c) { c.click(); return; }
    location.href = '/p/' + encodeURIComponent(post) + '#comments';
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('.js-insights') : null;
    if (b && b.getAttribute('data-post')) { e.preventDefault(); openInsights(b.getAttribute('data-post'), b); return; }
    var ic = e.target.closest ? e.target.closest('.js-ins-comments') : null;
    if (ic && ic.getAttribute('data-post')) { e.preventDefault(); insOpenComments(ic.getAttribute('data-post')); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeRx(); });

  /* THE CLIENT'S comment_gif_img() (migration 0133). Every place JS builds a comment/DM GIF
     <img> goes through here, so the markup the member sees the instant they hit send is the same
     markup a reload gets from the server -- including the width/height pair that reserves the
     box. Two rules, both inherited from the PHP twin in lib/view.php:
       - BOTH OR NEITHER. A lone dimension is not a ratio, so a half-pair emits no attributes and
         the <img> is exactly what this file produced before 0133.
       - The attributes only work in company with `height:auto` on .msg-gif (assets/rova.css);
         without it the height attribute would win over the 220px width cap and stretch the GIF.
     DM bubbles pass nothing: `messages` has no dimension columns to pass. */
  function gifImgHtml(url, w, h) {
    w = parseInt(w, 10); h = parseInt(h, 10);
    var dim = (w > 0 && h > 0) ? ' width="' + w + '" height="' + h + '"' : '';
    return '<img class="msg-gif" src="' + escHtml(url) + '"' + dim + ' alt="">';
  }
  // render a comment/DM body that may contain a Giphy URL -> text + <img>
  function bodyWithGif(text, w, h) {
    var m = String(text == null ? '' : text).match(/https:\/\/\S*\.giphy\.com\/\S+/i);
    if (m) {
      var gif = m[0];
      var t = String(text).replace(gif, '').trim();
      return (t ? escHtml(t) + ' ' : '') + gifImgHtml(gif, w, h);
    }
    return escHtml(text);
  }
  // escape, then turn bare URLs into pretty clickable links (drop the scheme + a
  // lone trailing slash). DM-only: comment bodies arrive already server-linkified.
  function prettyLinks(text) {
    return escHtml(text).replace(/https?:\/\/[^\s<]+/gi, function (u) {
      var tail = '';
      while (u && '.,;:!?)'.indexOf(u.charAt(u.length - 1)) >= 0) { tail = u.charAt(u.length - 1) + tail; u = u.slice(0, -1); }
      var label = u.replace(/^https?:\/\//i, '').replace(/\/+$/, '');
      return '<a class="link" href="' + u + '" target="_blank" rel="nofollow noopener noreferrer">' + label + '</a>' + tail;
    });
  }
  // DM bubble text: pretty links + inline GIFs (the previewed link URL is already
  // stripped server-side, so this handles any remaining text / secondary links).
  // NOTE: named dmBodyHtml, NOT dmBody - the flyout module has a local `dmBody`
  // (its .hdrop-body <div>) that would shadow this and break every text bubble.
  function dmBodyHtml(text) {
    var s = String(text == null ? '' : text);
    var m = s.match(/https:\/\/\S*\.giphy\.com\/\S+/i);
    if (m) {
      var gif = m[0];
      var t = s.replace(gif, '').trim();
      // no dimensions: a DM's GIF is sniffed back out of the body (messages has no gif columns),
      // so there is nothing to reserve with and this stays byte-identical to its pre-0133 output
      // a GIF on its own gets no bubble around it (Rob 2026-10-22): msg-gif-solo lets rova.css strip the frame
      return t ? prettyLinks(t) + ' ' + gifImgHtml(gif) : gifImgHtml(gif).replace('class="msg-gif"', 'class="msg-gif msg-gif-solo"');
    }
    return prettyLinks(s);
  }

  /* ---- DM day/time separators (owner bug #589, 2026-08-01) -------------------------
     "Keep the entire dm flow really similar to the native iMessage design."
     iMessage prints the clock ONCE, centered, where the conversation actually paused,
     instead of an age under every bubble. These build that marker for messages that
     arrive after the page rendered; the server-rendered ones come from dm_sep() in
     lib/view.php and the app from src/dmRhythm.js. All three use the same 30 minutes
     and the same wording, so a thread reads identically wherever it is opened.
     Every .msg now carries data-ts (unix seconds) so the last one in the DOM can say
     whether the next arrival opens a new block. */
  var DM_SEP_GAP = 1800;
  function dmSepDay(d, now) {
    if (d.toDateString() === now.toDateString()) { return 'Today'; }
    if (d.toDateString() === new Date(now.getTime() - 86400000).toDateString()) { return 'Yesterday'; }
    if (now - d < 6 * 86400000) { return d.toLocaleDateString([], { weekday: 'short' }); }
    var o = { month: 'short', day: 'numeric' };
    if (d.getFullYear() !== now.getFullYear()) { o.year = 'numeric'; }
    return d.toLocaleDateString([], o);
  }
  /** The separator to draw above a message, or '' when it continues the current block. */
  function dmSepBetween(prevTs, ts) {
    ts = parseInt(ts, 10) || 0;
    prevTs = parseInt(prevTs, 10) || 0;
    if (!ts) { return ''; }
    var d = new Date(ts * 1000);
    if (prevTs && (ts - prevTs) <= DM_SEP_GAP && new Date(prevTs * 1000).toDateString() === d.toDateString()) {
      return '';
    }
    return '<div class="dm-sep"><b>' + escHtml(dmSepDay(d, new Date())) + '</b> '
         + escHtml(d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })) + '</div>';
  }
  /** Unix ts of the last real message sitting in a thread container (0 when empty). */
  function dmLastTs(container) {
    if (!container) { return 0; }
    var all = container.querySelectorAll('.msg[data-ts]');
    return all.length ? (parseInt(all[all.length - 1].getAttribute('data-ts'), 10) || 0) : 0;
  }
  /** Drop the separator an about-to-be-appended message needs into `container`. */
  function dmSepAppend(container, m, before) {
    var html = dmSepBetween(dmLastTs(container), m && m.ts);
    if (!html) { return; }
    var f = document.createElement('div');
    f.innerHTML = html;
    if (before && before.parentNode === container) { container.insertBefore(f.firstChild, before); }
    else { container.appendChild(f.firstChild); }
  }
  /** Full local time for a bubble's hover tooltip (the age used to say this). */
  function dmTitle(ts) {
    ts = parseInt(ts, 10) || 0;
    if (!ts) { return ''; }
    return new Date(ts * 1000).toLocaleString([], {
      month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit',
    });
  }

  // Click a YouTube facade -> swap in the real player. Delegated, so it works for facades
  // added later by the DM poll / new bubbles. Runs in the CAPTURE phase and stops the
  // event so a wrapping DM bubble/handler can't close the thread before we swap.
  // The player is started MUTED (autoplay=1&mute=1) - muted autoplay is allowed with no
  // gesture, so it plays on this single tap. We nudge playVideo() a couple times over the
  // postMessage channel in case a browser doesn't self-start the freshly-inserted frame.
  // We deliberately do NOT auto-unMute: unmuting a muted-autoplay cross-origin frame trips
  // the autoplay policy and PAUSES it (it starts, stops, then spins). The user unmutes with
  // YouTube's own speaker control - that's a toggle, not a 2nd play button. origin= lets
  // YouTube accept the commands.
  document.addEventListener('click', function (e) {
    var f = e.target && e.target.closest ? e.target.closest('.yt-facade') : null;
    if (!f) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    var id = (f.getAttribute('data-yt') || '').replace(/[^A-Za-z0-9_-]/g, '');
    if (!id) return;
    var wrap = document.createElement('div');
    wrap.className = 'embed embed-video';
    var ifr = document.createElement('iframe');
    var origin = '';
    try { origin = '&origin=' + encodeURIComponent(location.origin); } catch (er) {}
    ifr.src = 'https://www.youtube-nocookie.com/embed/' + id +
      '?autoplay=1&mute=1&playsinline=1&enablejsapi=1&rel=0' + origin;
    ifr.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; picture-in-picture; web-share');
    ifr.setAttribute('allowfullscreen', '');
    wrap.appendChild(ifr);
    f.replaceWith(wrap);
    engEmbed(wrap);   // engage-hold: the player is starting -- hold the feed until it scrolls away or is dropped
    function cmd(func, args) {
      try { ifr.contentWindow.postMessage(JSON.stringify({ event: 'command', func: func, args: args || [] }), '*'); } catch (er) {}
    }
    ifr.addEventListener('load', function () {
      cmd('playVideo');
      setTimeout(function () { cmd('playVideo'); }, 450);   // one safety nudge; no unMute (it would pause + spin)
    });
  }, true);

  /* ---- OFFICIAL PLATFORM EMBEDS: the click-to-load facade (2026-08-15, phase 2) ------------
     Owner, with an X embed and an Instagram embed beside a Rova card: "ours just looks like the
     og image -- is there something we're missing to embed major platforms like this?"

     WHERE THIS CAN EVEN FIRE. On a .lc-em wrapper, which lib/view.php emits ONLY from
     linkcard_facade_html(), which views/_post.php calls ONLY when $isPermalink is set, which
     views/post_single.php is the only file that sets. There is no .lc-em in a feed, a profile, a
     tag page, a group, a channel or a comment, so this listener is inert everywhere a member
     scrolls. That is the constraint the whole feature was built around and it is enforced by the
     markup not existing rather than by this handler declining.

     NO THIRD-PARTY SCRIPT IS LOADED HERE OR ANYWHERE. The documented way to do X and TikTok is
     their blockquote plus widgets.js / embed.js -- i.e. handing two third-party origins the right
     to execute in ours. Those scripts only create an iframe and size it from a postMessage, and we
     do both below, so script-src is untouched by this entire feature. All five providers were
     measured rendering this way from a real rovasocial.com origin with an empty parent page; see
     the table in lib/embedwidget.php.

     THE CARD IS HIDDEN, NEVER REMOVED. .lc-em-card keeps its markup and "Show the card again" puts
     it straight back, so a provider that is offline, region-blocked, CSP-blocked or serving its
     own "this post was removed" page always has the branded card sitting underneath. (A link we
     could not resolve at all never gets a facade in the first place -- the server only wraps a
     card that has a real downloaded picture, so the dead reel instagram.com/reel/DaXos_5lWTb keeps
     its provider-fallback card with no play control on it.) */
  var LC_EM_ORIGINS = {
    'https://www.instagram.com': 1, 'https://www.tiktok.com': 1,
    'https://platform.twitter.com': 1, 'https://player.vimeo.com': 1,
    'https://www.youtube-nocookie.com': 1,
  };
  var lcEmFrames = [];   // {win, box, origin} for frames WE created, so a message can be matched to one

  /* HEIGHT, FROM THE PROVIDER'S OWN MOUTH. Three of the five have no fixed aspect and all three
     volunteer their height unprompted -- captured verbatim on this box, 2026-08-15:
       x          {"twttr.embed":{"method":"twttr.private.resize","params":[{"height":604,...}]}}
       instagram  {"details":{"height":904},"type":"MEASURE"}
       tiktok     {"signalSource":"","height":725}
     Three gates before a number is believed, in this order: the ORIGIN is one we framed, the
     SOURCE WINDOW is a frame we created ourselves (so another frame on the page cannot resize its
     neighbour), and the value is a finite number clamped to 120..2400. A provider that stops
     sending these costs a scrollbar, never a broken page -- the server's initial height stands. */
  window.addEventListener('message', function (e) {
    if (!lcEmFrames.length || !LC_EM_ORIGINS[e.origin]) return;
    var hit = null;
    for (var i = 0; i < lcEmFrames.length; i++) {
      if (lcEmFrames[i].win === e.source && lcEmFrames[i].origin === e.origin) { hit = lcEmFrames[i]; break; }
    }
    if (!hit) return;
    var d = e.data;
    if (typeof d === 'string') { try { d = JSON.parse(d); } catch (er) { return; } }
    if (!d || typeof d !== 'object') return;
    var h = 0;
    try {
      if (d['twttr.embed'] && d['twttr.embed'].method === 'twttr.private.resize') {
        h = ((d['twttr.embed'].params || [])[0] || {}).height;         // x
      } else if (d.type === 'MEASURE' && d.details) {
        h = d.details.height;                                          // instagram
      } else if (typeof d.height === 'number') {
        h = d.height;                                                  // tiktok
      }
    } catch (er) { return; }
    h = Number(h);
    if (!isFinite(h) || h < 120) return;
    hit.box.style.height = Math.min(2400, Math.round(h)) + 'px';
  }, false);

  document.addEventListener('click', function (e) {
    var go = e.target && e.target.closest ? e.target.closest('[data-em-go]') : null;
    if (!go) return;
    var wrap = go.closest('.lc-em');
    if (!wrap || wrap.classList.contains('em-on')) return;
    /* THE ANCHOR IS THE FALLBACK, SO ONLY A PLAIN LEFT CLICK IS CLAIMED. Without this, a
       middle-click or ctrl/cmd-click -- the two gestures that mean "open the original in a new
       tab" -- would be swallowed by an in-page swap. Those keep the href, which is exactly what
       the no-JS case gets too. */
    if (e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    var src = wrap.getAttribute('data-em-src') || '';
    var origin = wrap.getAttribute('data-em-origin') || '';
    /* THE SRC IS RE-CHECKED AGAINST THE SAME ORIGIN WHITELIST THE SERVER USED. It was built from a
       literal in lib/embedwidget.php out of an id that passed validRef(), so this can only fail if
       the DOM was tampered with after render -- at which point refusing is the only right answer.
       Belt to the server's braces, and the reason the CSP frame-src list is a third, independent
       one: three places have to agree before a frame exists. */
    if (!LC_EM_ORIGINS[origin] || src.slice(0, origin.length + 1) !== origin + '/') return;
    e.preventDefault();

    var kind = wrap.getAttribute('data-em-kind') || '';
    var ar   = parseFloat(wrap.getAttribute('data-em-ar') || '0') || 0;
    var h0   = parseInt(wrap.getAttribute('data-em-h') || '0', 10) || 0;
    var maxw = parseInt(wrap.getAttribute('data-em-maxw') || '0', 10) || 0;
    var msg  = wrap.getAttribute('data-em-msg') === '1';

    if (wrap.getAttribute('data-em-theme') === '1') {
      /* X IS THE ONLY PROVIDER WITH A THEME PARAMETER, AND IT IS APPENDED HERE RATHER THAN BAKED
         SERVER-SIDE ON PURPOSE. The page's theme lives in a cookie and is applied by
         View::THEME_BOOT in the browser precisely so the served HTML stays byte-identical for
         every visitor and /p/<id> stays edge-cacheable at s-maxage=60 (Cloudflare keys on the url
         alone). Baking dark/light into data-em-src would put that variance right back into a
         shared cached body. Instagram, TikTok and Vimeo have no equivalent knob -- see the CSS for
         how the white Instagram card is made to look deliberate on a dark page. */
      src += '&theme=' + (document.documentElement.getAttribute('data-theme') === 'light' ? 'light' : 'dark');
    }

    var box = document.createElement('div');
    box.className = 'lc-em-frame lc-em-' + kind.replace(/[^a-z]/g, '');
    if (maxw) box.style.maxWidth = maxw + 'px';
    if (ar) { box.style.aspectRatio = String(ar); } else if (h0) { box.style.height = h0 + 'px'; }

    var ifr = document.createElement('iframe');
    ifr.src = src;
    ifr.title = go.textContent.trim().split('\n')[0] || 'Embedded post';
    ifr.setAttribute('loading', 'eager');
    ifr.setAttribute('scrolling', 'no');
    ifr.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
    ifr.setAttribute('allowfullscreen', '');
    // must mirror EmbedWidget::SANDBOX / ::ALLOW -- allow-same-origin keeps the frame on the
    // PROVIDER's origin (it never shares ours), which is what lets their player run while
    // top-navigation, downloads, forms and pointer lock stay denied
    ifr.setAttribute('sandbox', 'allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-presentation');
    ifr.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen');
    box.appendChild(ifr);

    var back = document.createElement('button');
    back.type = 'button';
    back.className = 'lc-em-back';
    back.textContent = 'Show the card again';

    wrap.classList.add('em-on');
    wrap.insertBefore(box, go);
    wrap.insertBefore(back, go);
    go.hidden = true;

    if (msg) { lcEmFrames.push({ win: ifr.contentWindow, box: box, origin: origin }); }
    engEmbed(box, 'lcembed');   // a live player holds the feed exactly as the YouTube one does

    /* THE ONLY FAILURE THIS CAN HONESTLY DETECT is "the frame never loaded at all" -- offline, a
       DNS failure, a region block that resets the connection, a CSP refusal. A cross-origin frame
       fires `load` for a provider ERROR PAGE just as it does for a good one, so this deliberately
       does NOT try to judge the CONTENT: when Instagram answers "this post may be removed", the
       member reads Instagram's own words in Instagram's own box, which is precisely what tapping
       the link would have shown them, with the card one tap away. 9s, because a cold provider
       frame on a slow phone is routinely 3-5s and a false restore would be worse than a wait. */
    var settled = false;
    ifr.addEventListener('load', function () { settled = true; box.classList.add('em-ok'); });
    setTimeout(function () { if (!settled) lcEmRestore(wrap, true); }, 9000);
  });

  function lcEmRestore(wrap, failed) {
    if (!wrap || !wrap.classList.contains('em-on')) return;
    var box = wrap.querySelector('.lc-em-frame');
    var back = wrap.querySelector('.lc-em-back');
    if (box) {
      var f = box.querySelector('iframe');
      if (f) { lcEmFrames = lcEmFrames.filter(function (r) { return r.win !== f.contentWindow; }); }
      box.remove();
    }
    if (back) back.remove();
    wrap.classList.remove('em-on');
    var go = wrap.querySelector('[data-em-go]');
    if (go) go.hidden = false;
    if (failed) wrap.classList.add('em-failed');   // the card is back; the note explains why
  }
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('.lc-em-back') : null;
    if (b) { e.preventDefault(); lcEmRestore(b.closest('.lc-em'), false); }
  });

  /* ---- Apple Music one-tap preview card (#363/#370) --------------------
     The server bakes the cached iTunes 30s preview m4a into .am-card
     [data-preview]; one click here = audio, through ONE shared <audio>
     element (starting a card silently pauses whichever other card was
     playing — the app's one-preview rule). The ↗ opens Apple Music. */
  var amAudio = null, amCard = null, amWatch = null, amArmed = 0;
  var amUser = false;   // the playing song was STARTED BY THE MEMBER (card / song-mode speaker tap): only that one holds the feed
  function amWatchStop() { if (amWatch) { clearInterval(amWatch); amWatch = null; } }
  function amStop() {
    amWatchStop();
    if (amAudio) { amAudio.loop = false; amAudio._amLastT = null; amAudio._amAway = 0; }   // THE SONG REPEATS (2026-10-03): a stop always ends the repeat
    amUser = false;
    if (!amCard) return;
    amCard.classList.remove('am-playing');
    var r = amCard.querySelector('.am-rail'); if (r) r.hidden = true;
    amCard = null;
    engHold('amplay', false);   // engage-hold: our own <audio>, so this end signal is real (no viewport guessing)
    amSpeakers();
  }
  /* A SILENT CLIP + SONG HAS A SPEAKER THAT IS THE SONG'S (Rob 2026-10-03). buildControls puts the clip's corner
     .vc-sound in song mode (vc-songsnd) instead of the "No audio" tag; its glyph is "is this post's song playing",
     so every start/stop here repaints those speakers (only those: one querySelectorAll, usually empty). */
  function amSpeakers() {
    var bs = document.querySelectorAll('.vc-sound.vc-songsnd');
    for (var i = 0; i < bs.length; i++) { if (bs[i]._sync) { try { bs[i]._sync(); } catch (e) {} } }
  }
  /* STOP FOR REAL -- amStop() only ever cleared the CARD (owner 2026-08-09: "when i exit this viewer or
     close the media the player should stop, currently it keeps playing").
     Every caller amStop() had was already going to silence the element for free: 'ended' (finished by
     itself), or the line right before `amAudio.src = ...` (assigning a new source stops the old one). So
     nothing ever paused it, and nothing needed to -- until a surface that can be TORN DOWN while a preview
     is mid-play. amAudio is a detached `new Audio()` that lives in this closure and is never in the DOM, so
     no teardown, no observer and no CSS anywhere can reach it: the viewer's close() paused every <video> in
     its box and the preview sailed straight through, still playing, with its card gone. Pause first, then
     clear: the 'pause' listener below only strips .am-playing, so the order leaves no half-state, and
     rewinding means a re-open starts the track from the top rather than 20s in. */
  function amHalt() {
    if (!amAudio) return;
    try { amAudio.pause(); } catch (e) {}
    try { amAudio.currentTime = 0; } catch (e) {}   // guarded: currentTime at HAVE_NOTHING throws in some WebKit builds
    amStop();
  }
  /* A dead tap and a dead preview used to look identical: the only failure path was
     .catch(amStop), which resets the card and says nothing. These three make it visible.
     amFail() routes through amStop() so the engHold('amplay') release stays paired exactly
     once on every path. */
  function amClearFail(card) {
    if (!card) return;
    card.classList.remove('am-failed');
    var m = card.querySelector('.am-err'); if (m) m.parentNode.removeChild(m);
  }
  function amFail(card) {
    if (!card) return;
    var meta = card.querySelector('.am-meta') || card;
    var m = card.querySelector('.am-err');
    if (!m) {
      m = document.createElement('span');
      m.className = 'am-err';
      m.setAttribute('role', 'status');
      meta.appendChild(m);
    }
    m.textContent = 'Preview unavailable';
    amStop();                       // clears .am-playing, hides the rail, releases the hold
    card.classList.add('am-failed');
  }
  /* An abort is US, not a broken preview: replacing .src for a different card, or pausing
     before the load finished, aborts the pending load. That surfaces as a play() rejection
     named AbortError and as an 'error' event with MEDIA_ERR_ABORTED (code 1). Treating those
     as failures put "Preview unavailable" on a card every time the one-preview rule swapped
     tracks. Only a real decode/network/source error is a failure. */
  function amAborted(err) { return !!err && err.name === 'AbortError'; }
  /* The failure that has no error event: play() resolves, the card shows as playing, and the
     media never actually decodes a frame. Watch for PROGRESS, not for a promise or a class.
     A user pause is not a failure, so the watchdog only counts ticks while we want playback. */
  function amWatchStart(card, silent) {
    amWatchStop();
    var t0 = amAudio.currentTime, ticks = 0;
    amWatch = setInterval(function () {
      if (!amCard || amCard !== card) { amWatchStop(); return; }
      if (amAudio.paused) { amWatchStop(); return; }
      if (amAudio.currentTime > t0 + 0.05) { amWatchStop(); return; }   // real progress: healthy
      // `silent` = WE started this, the reader did not (the viewer's auto-start). Same watchdog, but it
      // ends in silence instead of in "Preview unavailable": a message about a tap nobody made is noise,
      // and the card is left as the one-tap affordance it already was.
      if (++ticks >= 10) { amWatchStop(); if (silent) amHalt(); else amFail(card); amRecycle(); }   // ~5s, zero progress
    }, 500);
  }
  /* ---- A WEDGED ELEMENT MUST BE THROWN AWAY, NOT RE-USED (owner 2026-08-14) ---------------------
     "sometimes ALL the posts on the site lose volume and I can't get it back without force-closing
      Safari."  Force-closing is the tell. Nothing this page can do to localStorage survives a
     force-quit differently from a reload, so whatever the reader was clearing was NOT ours -- it was
     the process's AUDIO SESSION.

     ONE `new Audio()` served every preview for the life of the page, and that is fine right up until
     the element stops being able to make sound. On iOS an element whose start was refused or
     interrupted (a call, a Control-Centre pause, another app taking the session, a start attempted
     with no activation) can be left holding a suspended session: play() still RESOLVES, the card
     still shows as playing, and not one sample ever decodes -- and while it holds that session, the
     page's <video> elements do not get one either. Re-using it means every later tap, on every music
     card, on every page in that tab, inherits the same dead element. That is "I can't get it back".

     ZERO PROGRESS IS ALREADY THE SIGNAL, and the watchdog above has measured it for months -- it just
     ended the playback and kept the corpse. So end the ELEMENT too: release the media resource the
     way WebKit wants it released (empty src + load(), which is what actually drops the session, not
     pause()), drop every listener with it, and let amEnsure() build a fresh one on the next start.
     The next attempt then asks for a session of its own instead of inheriting a suspended one.

     Cheap and rare by construction: it can only run after 5 full seconds of a playing element making
     no progress, which has already cost the reader the preview. A healthy preview never reaches it. */
  function amRecycle() {
    var a = amAudio;
    if (!a) return;
    amAudio = null;          // amEnsure() builds a new one, with new listeners, on the next start
    amArmed = 0;             // the iOS unlock belonged to THAT element; the new one has not been unlocked
    amTlUnlocked = null; amUnlockListen(true);   // ...and so did the first-gesture unlock (amTlUnlock)
    try { a.pause(); } catch (e) {}
    try { a.removeAttribute('src'); a.src = ''; a.load(); } catch (e) {}   // release the session, not just the playback
  }
  /* ---- THE SONG REPEATS WHILE THE READER IS STILL THERE  (Rob 2026-10-03) ---------------------------------
     "Song should keep repeating the song if the user is still there." The ~30s preview used to play once and
     stop. Now a pass that reaches its end starts again, with the browser's own seamless loop (a.loop, set in
     the last AM_LOOP_LEAD seconds of each pass and re-asked on every timeupdate there), and only if:
       - the card is still the one playing, connected, inside a POST (the composer's picked-song preview keeps
         its one pass), the tab is visible, the reader has not muted the site (rova_sound='0'), and the
         composer's Add-music picker does not own the audio;
       - the post is still where the reader is: in the viewer, the open viewer (.pfeed.show) with the post on
         screen (a swipe away is __rovaAmLeave's halt anyway); on a timeline / permalink, the song card or the
         post's media box at least half on screen -- the playing card's own 50% unit (tlUnitOf);
       - no other voice has taken over: an unmuted, playing, non-silent <video> anywhere (data-noaudio clips and
         video avatars are pictures, not voices) -- the same element-level test as the wake governor's wlAudible;
       - the reader has shown a sign of life within AM_LOOP_IDLE (any trusted pointer/touch/key/wheel, or a return
         to the tab). A phone that auto-locks hides the page, which halts the song already; this bounds a desktop
         left alone, so nothing sings forever to an empty room.
     Everything that stops the song today is untouched: a pause never reaches the end, amHalt/amStop clear the
     flag, a hidden tab halts, the playing-card handover halts. The song keeps ITS OWN timeline: a shorter clip
     on the same post loops on its own clock, and nothing syncs the two (nothing ever did).
     The wake lock is not touched: it enumerates <video> only, and nothing here counts as a touch.
     WHO HOLDS THE FEED (same day, Rob: "it goes to 'Held' on the post for way too long" -- the app's build 683 rule):
       - a song holds the feed ONLY if the member started it (a tap on the song card or the clip's song-mode speaker:
         amUser). That song keeps engHold('amplay') while it plays, loops included, and hands-free's hfMusicHold asks
         __rovaAmUserSong(); the feed's liveEmbedOnScreen no longer counts a playing card at all;
       - an AUTOPLAYED song (the playing-card rule, the viewer's open, the permalink) plays and loops while its post is
         in view and holds NOTHING: auto-advance / hands-free / the fold and roll keep their normal schedule, and the
         song stops when the feed moves on;
       - SCROLLING AWAY PAUSES THE SONG, either kind: two timeupdates in a row (~0.5 s) with the post out of view
         (amInView: the playing card's own 50% unit) halt it. */
  var AM_LOOP_LEAD = 1.6;                    // s before the end: inside this, every timeupdate re-decides a.loop
  var AM_LOOP_IDLE = 10 * 60 * 1000;         // a sign of life within this keeps the song repeating
  var amLifeAt = Date.now();
  function amLife(e) { if (e && e.isTrusted === false) return; amLifeAt = Date.now(); }
  ['pointerdown', 'touchstart', 'keydown', 'wheel'].forEach(function (ev) {
    document.addEventListener(ev, amLife, { capture: true, passive: true });
  });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) amLifeAt = Date.now(); });
  function amHalfOn(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect(), vh = window.innerHeight || document.documentElement.clientHeight || 0;
    if (!(r.height > 0)) return false;
    var vis = Math.min(r.bottom, vh) - Math.max(r.top, 0);
    return vis >= r.height * 0.5;
  }
  function amLoopOk(a) {
    var card = amCard;
    if (!card || amAudio !== a || !card.isConnected) return false;   // not a.paused: the ended fallback asks after the end paused it
    if (document.hidden || amSndMuted() || amPickBusy()) return false;
    if (Date.now() - amLifeAt > (window.__rovaAmLoopIdleTest > 0 ? window.__rovaAmLoopIdleTest : AM_LOOP_IDLE)) return false;
    var post = card.closest ? card.closest('.post') : null;
    if (!post) return false;
    var vids = document.getElementsByTagName('video');
    for (var i = 0; i < vids.length; i++) {
      var v = vids[i];
      if (!v.isConnected || v.paused || v.ended || v.muted || !(v.volume > 0)) continue;
      if (v.hasAttribute('data-noaudio') || (v.closest && v.closest('.avatar'))) continue;
      return false;                                           // another voice has the floor
    }
    return amInView(card) !== false;
  }
  // is the song's POST where the reader is? true / false; null = not a post's card (the composer preview: no rule)
  function amInView(card) {
    var post = (card && card.closest) ? card.closest('.post') : null;
    if (!post || !card.isConnected) return null;
    var pf = card.closest('.pfeed');
    if (pf) {
      if (!pf.classList.contains('show')) return false;
      var pr = post.getBoundingClientRect(), vh = window.innerHeight || 0;
      return pr.height > 0 && Math.min(pr.bottom, vh) - Math.max(pr.top, 0) >= Math.min(pr.height, vh) * 0.5;
    }
    return amHalfOn(card) || amHalfOn(post.querySelector('.media'));
  }
  // a native loop wrapped (or the 'ended' fallback restarted): false = the reader left, the song was halted
  function amLoopWrap(a, fill) {
    if (!amLoopOk(a)) { amHalt(); return false; }
    a.loop = false;                                           // re-decided in the next pass's last stretch
    a._amLoops = (a._amLoops || 0) + 1;                       // rig receipt
    if (fill) {
      fill.style.transition = 'none';
      fill.style.width = '0%';
      void fill.offsetWidth;
      fill.style.transition = '';
    }
    return true;
  }
  /* ONE element, built once. This was inline in the click handler; it moved out because the viewer's
     auto-start needs the SAME element with the SAME listeners from a path that has no click. Byte for
     byte the same construction, in the same order -- moving it changes nothing about the tap. */
  function amEnsure() {
    if (amAudio) return;
    /* EVERY LISTENER BELOW TALKS TO `a`, NEVER TO `amAudio`, and that is load-bearing now that
       amRecycle() can retire an element mid-flight. These used to read the module-level `amAudio`,
       which is fine while there is exactly one element for the life of the page and a live hazard the
       moment there can be two: the retired element still fires (releasing it with an empty src fires
       its own 'error'), and the handler would then have been reading -- or worse, acting on -- the
       REPLACEMENT's state, or dereferencing a null. Bind to the element the listener belongs to, and
       have each one stand down the moment it is no longer the current element. */
    var a = new Audio();
    amAudio = a;
    a.preload = 'none';
    /* ONE VOICE (2026-09-26): the moment a preview starts or stops sounding, the video sound rule is
       re-asked -- a timeline clip yields to a song and gets the voice back when it ends. 'playing', not
       'play': a start that is then refused must not silence the feed for nothing. */
    ['playing', 'pause', 'ended'].forEach(function (ev) {
      a.addEventListener(ev, function () {
        if (amAudio !== a) return;
        if (window.__rovaSyncSound) { try { window.__rovaSyncSound(); } catch (e) {} }
        amSpeakers();   // a silent clip's corner speaker in song mode draws THIS (2026-10-03)
      });
    });
    // the error listener the element had none of: a mid-stream drop or a refused decode
    // left the card sitting in .am-playing forever with silence
    a.addEventListener('error', function () {
      if (amAudio !== a) return;                         // a retired element: its death throes are not news
      if (a.error && a.error.code === 1) return;         // MEDIA_ERR_ABORTED: our own src swap
      amFail(amCard);
      amRecycle();                                       // a decode/source failure can leave the session held too
    });
    // deliberately NOT listening for 'stalled': it fires on any 3s fetch gap, so on slow
    // mobile data it would cry failure on a preview that is merely buffering. The progress
    // watchdog above is the honest signal - it measures playback advancing, not wall clock.
    a.addEventListener('timeupdate', function () {
      if (amAudio !== a || !amCard) return;
      // SCROLLING AWAY PAUSES THE SONG (2026-10-03, the app's build 683 rule): two ticks in a row out of view
      if (!a.paused && amInView(amCard) === false) {
        a._amAway = (a._amAway || 0) + 1;
        if (a._amAway >= 2) { a._amAway = 0; amHalt(); return; }
      } else { a._amAway = 0; }
      var fill = amCard.querySelector('.am-fill');
      var dur = a.duration || parseInt(amCard.getAttribute('data-dur') || '30', 10) || 30;
      var t = a.currentTime;
      /* THE SONG REPEATS (2026-10-03). A native loop just wrapped: re-ask whether the reader is still on the
         post (the race between the last decision and the end), and snap the bar back to the start instead
         of letting its .25s width transition sweep it backwards across the card. */
      if (a.loop && a._amLastT != null && t + 1 < a._amLastT) {
        if (!amLoopWrap(a, fill)) return;
      }
      a._amLastT = t;
      if (fill) fill.style.width = Math.min(100, (t / dur) * 100) + '%';
      // decide the repeat in the last stretch of each pass, every timeupdate (~4Hz), so it reflects NOW
      var d = a.duration;
      if (d > 0 && isFinite(d) && t > d - AM_LOOP_LEAD) {
        var ok = amLoopOk(a);
        if (a.loop !== ok) a.loop = ok;
      }
    });
    a.addEventListener('ended', function () {
      if (amAudio !== a) return;
      /* A browser that ended anyway (the loop flag was never set: an unknown duration, a decision that came
         too late) gets the same answer by hand -- a tiny gap instead of a seamless wrap, never a different rule. */
      if (amCard && amLoopOk(a)) {
        var card = amCard;
        try { a.currentTime = 0; } catch (e) {}
        a._amLastT = null;
        amLoopWrap(a, card.querySelector('.am-fill'));
        var p = a.play();
        if (p && p.catch) p.catch(function () { if (amAudio === a && amCard === card) amStop(); });
        card.classList.add('am-playing');
        return;
      }
      amStop();
    });
    a.addEventListener('pause', function () {
      if (amAudio !== a) return;
      if (amCard && a.currentTime > 0 && !a.ended) amCard.classList.remove('am-playing');
    });
  }
  /* ---- OPENING A MUSIC POST'S LINK STARTS THE TRACK (owner 2026-08-14) -------------------------
     "SONG SHOULD START PLAYING WHEN CLICKING THIS LINK" -- a shared /p/<id> whose whole content is a
     song, opened cold in a new tab, sat there with a play button on it.

     THE PLATFORM DECIDES, NOT US. A direct navigation carries no user activation, and UNMUTED audio
     autoplay is refused in exactly that state by every engine that matters. Chrome grants it when the
     Media Engagement Index for this origin is high enough (a reader who plays media here regularly),
     and any arrival that DOES carry activation -- a same-origin click into the permalink, a reload
     from a page the reader had touched -- is simply allowed. So: ASK, every time. Where the browser
     says yes the song is playing before the page has finished settling, which is exactly what was
     asked for.

     WHERE IT SAYS NO, SPEND THE FIRST GESTURE -- ONE ARM, NOT A RETRY LOOP. This is pfTapPlay's
     shape, deliberately: "ANY tap inside the viewer is the gesture the browser was waiting for", and
     its own note records that detaching after exactly one refused attempt was WRONG, because the
     attempt that gets refused and the gesture that would have been accepted are not the same event.
     So the arm survives a refusal and is retired by the track actually SOUNDING (the play promise
     resolving), never by having been tried. It is bounded at AM_PEND_MAX so a genuinely dead preview
     cannot re-ask on every touch for the life of the page, and there is no timer anywhere in it --
     nothing here ever re-attempts on its own. That distinction is the whole of the soundRepair
     lesson: a self-driving retry is what manufactures the refusal-then-permanent-mute state; a
     reader's own gesture is the one input the policy is waiting for.

     WHY NOT navigator.userActivation: the sound closure measured it lying (a fresh /p/15076 reports
     hasBeenActive true with no input at all), which is why __rovaUserActivated exists. It is not
     consulted here at all -- we do not need to PREDICT the refusal, the promise TELLS us. */
  var amPend = null;          // the card whose auto-start was refused; the reader's next gesture starts it
  var amPendTries = 0;
  var AM_PEND_MAX = 3;        // ...and never more than this, so a dead preview cannot chase every touch
  var AM_PEND_EVT = ['pointerdown', 'keydown', 'click'];
  /* CLICK IS NOT REDUNDANT WITH POINTERDOWN, and iOS is why. WebKit does not grant activation on
     touch-DOWN -- it grants it at touchend/click -- so a pointerdown-only arm would spend the
     reader's first tap on an attempt the engine was always going to refuse. Chrome grants at
     pointerdown, so it starts the track a frame earlier there. Both listeners, one arm, and the
     tries counter is what keeps "both" from meaning "twice as many attempts" indefinitely. */
  function amPendClear() {
    var c = amPend;
    amPend = null;
    if (!c) return;
    AM_PEND_EVT.forEach(function (ev) { document.removeEventListener(ev, amPendFire, true); });
    if (c.classList) c.classList.remove('am-armed');
    var hn = c.querySelector ? c.querySelector('.am-hint') : null;
    if (hn && hn.parentNode) hn.parentNode.removeChild(hn);
  }
  /* rova_sound=0 IS THE READER SAYING NO, and sndPref() cannot answer this question: it folds
     "absent" and "0" into the same false, and absent is the overwhelming majority (most readers have
     never touched a mute button). Only an explicit 0 -- written by the mute button / the sound
     handoff -- blocks an auto-start. */
  function amSndMuted() {
    try { return localStorage.getItem('rova_sound') === '0'; } catch (e) { return false; }
  }
  function amPendArm(card) {
    if (!card || amSndMuted()) return;
    if (amPend === card) return;                 // already armed on this card: keep the listeners we have
    amPendClear();
    amPend = card;
    if (card.classList) card.classList.add('am-armed');
    /* "TAP FOR SOUND" ON THE WAITING CARD (Rob 2026-09-29, Mac Safari: @thesashagomez's silent clip + song
       "doesn't start when I scroll down her page"). A scroll is not an activation, so the browser refuses
       the track until the first click/tap/key; the pulsing disc alone did not say so. The words ride INSIDE
       the brand line ("APPLE MUSIC · TAP FOR SOUND"), so the card does not change height under a reader who
       is mid-scroll; amPendClear takes them away with the arm (the track sounded, or the card let go). */
    var brand = card.querySelector ? card.querySelector('.am-brand') : null;
    if (brand && !brand.querySelector('.am-hint')) {
      var hint = document.createElement('span');
      hint.className = 'am-hint';
      hint.innerHTML = '<span class="am-hint-sep"> · </span>Tap for sound';   // narrow cards drop the brand + dot (rova.css)
      brand.appendChild(hint);
    }
    AM_PEND_EVT.forEach(function (ev) { document.addEventListener(ev, amPendFire, true); });
  }
  function amPendFire(e) {
    var card = amPend;
    if (!card) return;
    if (e && e.target && e.target.closest && e.target.closest('.am-card')) {
      /* THE CARD'S OWN HANDLER OWNS A TAP THAT LANDS ON THE CARD. Firing here first would start the
         track, and the click handler two hundred lines down would then read `amCard === card &&
         !amAudio.paused` and PAUSE it -- a tap on play that pauses. Stand down and let the tap be
         the ordinary one-tap it has always been. */
      amPendClear();
      return;
    }
    if (e && e.type === 'keydown') {
      if (e.key === 'Escape' || e.key === 'Tab' || e.metaKey || e.ctrlKey || e.altKey) return;   // not activation
    }
    /* A TAP FOR SOUND IS NOT A TAP FOR MUSIC, and the arm has to be the one that yields. The gesture
       this is waiting for is "the reader touched the page", so it fires on a touch that was aimed at
       something else -- and when that something else is a CLIP or its sound control, starting a song
       on top of it is the collision, not the feature: on iOS the first element to sound takes the
       audio session, so the video the reader just asked to hear gets its unmuted play refused and
       falls back to silent. They asked for THAT audio. Stand down for good rather than spend a try:
       a reader reaching for a video's sound is not a reader waiting for this preview. */
    if (e && e.target && e.target.closest) {
      /* ...BUT A VIDEO AVATAR IS NOT A CLIP. Same carve-out amAutoLoad already makes and for the same
         reason: span.avatar.av-vid is a silent 2s loop -- a picture that moves -- and it sits on the
         byline of a large share of these very cards. Counting a tap on the author's face as "the
         reader reached for a video's sound" would retire the arm on the most ordinary tap there is. */
      var hitV = e.target.closest('video');
      /* ...AND NEITHER IS A SILENT CLIP (2026-09-26). The timeline's song now arms on exactly the post
         whose clip is server-marked silent (data-noaudio: a no-audio clip + song), so the tap most likely
         to be the first activation there is a tap on that very clip -- and it has no audio for the reader
         to be asking for. */
      if (hitV && !(hitV.closest && hitV.closest('.avatar')) && !hitV.hasAttribute('data-noaudio')) { amPendClear(); return; }
      if (e.target.closest('.vctrl, .vc-sound, .pf-sndpill, audio')) { amPendClear(); return; }
    }
    if (!card.isConnected) { amPendClear(); return; }
    if (amCard && amAudio && !amAudio.paused) { amPendClear(); return; }   // something is playing: never interrupt
    if (++amPendTries > AM_PEND_MAX) { amPendClear(); return; }
    amStartFresh(card, card.getAttribute('data-preview') || '', 'gesture');
  }
  // A refusal has ONE name across Chrome, Safari and Firefox. Anything else -- our own src swap
  // (AbortError), a broken source -- is not something a gesture can fix, so it must not arm.
  function amPolicyRefusal(err) { return !!err && err.name === 'NotAllowedError'; }
  /* ---- THE PAGE'S FIRST GESTURE UNLOCKS THE SONG ELEMENT TOO  (Rob 2026-09-29, Mac Safari) ------------
     "The song should play when viewing sasha gomez first post since it has no audio but the music doesn't
      start playing when i scroll down her page." Her top post (54366) is a SILENT clip (data-noaudio) + an
     Apple Music song, so the timeline's song rule (__rovaAmTl) starts it when it becomes the playing card.
     MEASURED under WebKit's media rule (scratchpad sasha/cold.js, EMU=1): a reader who had already clicked
     the page ONCE before scrolling to it still got NotAllowedError when the song's turn came, and needed a
     SECOND click. WebKit has no sticky activation for media: a play() outside a gesture is allowed only on
     an element that was once played INSIDE one (it lifts the restriction for that element's life). The
     page's first gesture went to promoteSound (a timeline clip), and amAudio -- the one element every
     preview plays through -- was never touched, so it stayed locked. Chromium's sticky activation hid it.
     So the first trusted gesture ALSO does amArm's trick on amAudio: play() + pause() in the same turn
     (nothing decodes, nothing sounds), which is what makes every later programmatic start on the timeline
     allowed. Gated like amArm, because on iOS a play() takes the audio session: sound not muted by the
     reader (rova_sound !== '0'), and a timeline song card within 3 screens of the reader -- a page without
     music near never touches the session. Not while a track is armed (amPendFire owns that gesture and
     starts it for real), not on a tap aimed at a card (its own handler starts it), not while the composer's
     picker owns the audio. Listens until it has been spent on the CURRENT element: amRecycle() throws the
     element (and its grant) away, so it listens again. */
  var amTlUnlocked = null;
  var AM_UNLOCK_EVT = ['pointerdown', 'touchend', 'click', 'keydown'];
  var amUnlockOn = false;
  function amUnlockListen(on) {
    if (on === amUnlockOn) return;
    amUnlockOn = on;
    AM_UNLOCK_EVT.forEach(function (ev) {
      if (on) document.addEventListener(ev, amTlUnlock, true);
      else document.removeEventListener(ev, amTlUnlock, true);
    });
  }
  function amTlUnlock(e) {
    if (!e || !e.isTrusted) return;
    if (amAudio && amTlUnlocked === amAudio) { amUnlockListen(false); return; }
    if (e.type === 'keydown' && (e.key === 'Escape' || e.key === 'Tab' || e.metaKey || e.ctrlKey || e.altKey)) return;
    var act = navigator.userActivation;
    if (act && !act.isActive) return;                   // a touch-DOWN is not an activation (WebKit grants at touchend)
    if (amPend || amSndMuted() || amPickBusy()) return;
    if (amAudio && amCard && !amAudio.paused) return;   // sounding: the start that got it there already unlocked it
    if (e.target && e.target.closest && e.target.closest('.am-card, .pfeed')) return;
    var vh = window.innerHeight || 800, near = null;
    var cards = document.querySelectorAll('.post .am-card[data-preview]');
    for (var i = 0; i < cards.length; i++) {
      if (cards[i].closest('.pfeed')) continue;
      var r = cards[i].getBoundingClientRect();
      if (r.height > 0 && r.bottom > -3 * vh && r.top < 4 * vh) { near = cards[i]; break; }
    }
    if (!near) return;                                  // no song near yet: keep listening
    amEnsure();
    amTlUnlocked = amAudio;
    amUnlockListen(false);
    try {
      amAudio.src = near.getAttribute('data-preview') || '';
      var p = amAudio.play();
      if (p && p.catch) p.catch(function () {});
      amAudio.pause();                                  // same turn: no data has arrived, so nothing sounds
    } catch (er) {}
  }
  amUnlockListen(true);
  /* START A CARD FROM SCRATCH: the one-preview rule, the src swap, the rail, the watchdog. Extracted so
     the tap and the viewer's auto-start share ONE start path instead of two that can drift apart.
     `auto` = we started it, the reader did not, and it changes exactly two things.
       NO engHold. engHold('amplay') is the 15-minute "the reader is deliberately listening" hold, and it
       defers the 3.2s chrome fade for the whole preview. On a tap that is the point. On an open it would
       quietly undo what the owner asked for on 2026-08-04 ("the music player should fade out like all the
       other stuff as well") -- the viewer would sit awake for 30s because we started a track nobody asked
       to be held for. The idle rules already state that a hidden card keeps playing, so the fade costs the
       music nothing.
       NO "Preview unavailable". A refused auto-start is autoplay POLICY far more often than a broken
       preview, and painting a failure on a card that plays perfectly on the next tap is a lie. It resets
       to the idle affordance, which is exactly the one-tap path it started as.
     `auto` IS NOW A WORD, NOT A FLAG, and every existing truthiness test above reads it unchanged:
       'load'    -- nobody has touched this document yet (a permalink open, the viewer's drop()). A
                    refusal here is the one a gesture can fix, so it ARMS.
       'gesture' -- the armed retry, running inside the reader's own touch. A refusal here re-arms
                    (WebKit can still refuse the first touch-down), bounded by AM_PEND_MAX.
       false     -- the reader tapped the card. Untouched: engHold, "Preview unavailable", all of it. */
  function amStartFresh(card, src, auto) {
    amEnsure();
    amStop();                                    // a different card was playing
    amCard = card;
    amAudio.src = src;
    // The reset stays (a replay of a finished card must start at 0), but it is guarded:
    // setting currentTime at HAVE_NOTHING throws InvalidStateError in some WebKit builds,
    // and it threw SYNCHRONOUSLY here - before play() was ever reached, so there was no
    // rejection for the .catch to see and the tap died in total silence.
    try { amAudio.currentTime = 0; } catch (er) {}
    /* THE PROMISE IS THE AUTHORITY ON BOTH ANSWERS, which is why this grew a fulfilled half. The
       arm is retired by the track actually SOUNDING, never by "we tried" -- see amPendFire. */
    var amEl = amAudio;
    amAudio.play().then(function () {
      amTlUnlocked = amEl;                       // it sounded, so this element is allowed from now on (WebKit)
      amPendTries = 0;                           // ...and a preview that plays is not the dead one AM_PEND_MAX bounds
      if (auto) amPendClear();                   // it is playing: whatever was armed has done its job
    }, function (err) {
      if (auto) {
        if (amPolicyRefusal(err)) { amPendArm(card); } else { amPendClear(); }
        if (amCard === card) amHalt();           // policy said no: back to the idle affordance, silently
        return;
      }
      if (!amAborted(err)) amFail(card);
    });
    card.classList.add('am-playing');
    amUser = !auto;
    if (!auto) engHold('amplay', true, ENG_LONG, card);
    var rail = card.querySelector('.am-rail'); if (rail) rail.hidden = false;
    amWatchStart(card, auto);
  }
  /* ---- the immersive viewer's three hooks (owner 2026-08-09) ------------------------------------
     UNLOCK INSIDE THE GESTURE, PLAY WHEN THE OPEN LANDS. The start the owner asked for ("when tapping a
     post with music the music should start playing") has to happen ~600ms after the tap -- when the hero
     flight lands and the chrome is revealed -- and by then the gesture is long gone. Chromium keeps
     STICKY activation for the whole document, so a deferred play() there is simply allowed. WebKit does
     not: it grants permission PER ELEMENT, at the moment a gesture calls play() on that element, and then
     keeps it for the element's life. Since there is exactly one <audio> here for the whole page, calling
     play() on it inside the opener -- which runs synchronously in the tap's own click handler -- is what
     buys the deferred start on iOS. The pause() is on the very next line, in the SAME turn, so the element
     cannot have decoded a sample: there is nothing to hear, and the aborted play() rejection is the
     AbortError amAborted() has always ignored.
     IT ARMS WITH THE REAL PREVIEW, NOT A SILENT CLIP, and only when the post being opened is the one
     that has the music. That gate is not tidiness: on iOS the first sounding element takes over the
     audio session, so arming on every open would duck or stop whatever the reader has playing in another
     app every time they opened ANY photo. No card = no arm = today's behaviour exactly. */
  function amArm(id) {
    if (amArmed) return;
    if (amCard && amAudio && !amAudio.paused) return;      // a preview is already running: it is already unlocked
    /* THE TAPPED POST'S OWN CARD, never "a card somewhere on the page". On the TIMELINE a music post can
       be sitting three cards below the photo the reader just tapped, and arming off that one would take
       over the audio session for a post whose music we are never going to play. The permalink and the
       timeline both carry the tapped post as .post[data-view=<id>], and a grid page carries no card at
       all -- so no id, or no card under it, means no arm and today's behaviour exactly. */
    if (!id || !/^\d+$/.test(String(id))) return;          // ids are numeric here; anything else is not ours to trust in a selector
    var c = document.querySelector('.post[data-view="' + id + '"] .am-card[data-preview]');
    if (!c) return;
    amEnsure();
    /* ONCE-ONLY, BUT ONLY IF IT COULD HAVE WORKED. The permalink OPENS THE VIEWER BY ITSELF on load, with
       no gesture anywhere, so this runs and is refused -- and burning the flag there would mean the
       reader's LATER, real tap back into the viewer never re-armed, leaving iOS locked for the rest of the
       page's life on the one page most likely to carry music. The promise cannot answer this: our own
       pause() on the next line rejects it with AbortError either way, which is indistinguishable from a
       policy refusal. Activation state can, and it is the exact question being asked. Where it is
       unreported, latch as before rather than re-attempting on every open. */
    var act = navigator.userActivation;
    amArmed = act ? (act.isActive ? 1 : 0) : 1;
    try {
      amAudio.src = c.getAttribute('data-preview') || '';
      var p = amAudio.play();
      if (p && p.catch) p.catch(function () {});
      amAudio.pause();                                     // same turn: no data has arrived, so nothing sounds
    } catch (e) {}
  }
  window.__rovaAmArm = amArm;
  window.__rovaAmStop = amHalt;
  /* ---- THE TIMELINE'S SONG FOLLOWS THE PLAYING CARD  (Rob 2026-09-26, iOS build-474 parity) ------------
     "...so content I'm scrolling already plays automatically when I scroll to it like Instagram including
      embedded music posts." The rule is decided in the sound closure with the playing card itself
     (tlSlotDecide): the holder's post has a song card, NO audible video (a silent clip + song, the
     @thesashagomez shape), the card is at least half on screen, and sound is on. This end only starts and
     stops, and it is careful about WHOSE track it stops:
       - it starts through amStartFresh(.., 'load') -- the viewer's auto-start path: no engHold, no
         "Preview unavailable", and a refusal (no activation yet) ARMS the reader's next gesture;
       - it never interrupts a track that is already sounding (the reader tapped one: theirs wins);
       - leaving -- a different holder, the card under 50%, sound off, the viewer opening -- stops ONLY the
         card this rule started (amTl), and only while it is still the one playing. A song the reader
         tapped keeps playing as the page scrolls, exactly as the pinned player always has. */
  var amTl = null;
  window.__rovaAmTl = function (post) {
    var card = (post && post.querySelector) ? post.querySelector('.am-card[data-preview]') : null;
    if (card === amTl) return;                               // no change (the steady state: one compare)
    if (amTl) {
      var was = amTl; amTl = null;
      if (amPend === was) amPendClear();
      if (amCard === was) amHalt();
    }
    if (!card || !card.isConnected) return;
    if (amCard && amAudio && !amAudio.paused) return;        // the reader's own track: never interrupt
    if (amPickBusy()) return;                                // the composer's music picker owns the audio while open
    amTl = card;
    amStartFresh(card, card.getAttribute('data-preview') || '', 'load');
  };
  // the sound closure's one-voice rule asks this (applySound: no timeline clip speaks over a preview)
  /* ...AND WHILE THE COMPOSER'S "ADD MUSIC" PICKER IS OPEN (2026-09-27). The picker plays its 30s previews
     through its OWN <audio> (window.__rovaMusicPickBusy is exported by the picker IIFE), and while it is up
     it owns the page's one voice: applySound reads this to keep every timeline clip muted, and __rovaAmTl
     above will not start a timeline song under it. Open, not just playing -- a feed clip regaining its
     sound between two previews, under the sheet, is the two-voices bug in slow motion. */
  function amPickBusy() { try { return !!(window.__rovaMusicPickBusy && window.__rovaMusicPickBusy()); } catch (e) { return false; } }
  window.__rovaAmPlaying = function () { return !!(amCard && amAudio && !amAudio.paused) || amPickBusy(); };
  /* THE READER'S OWN TRACK HANDS OVER TOO (2026-09-30, Rob + coordinator): a song the reader TAPPED is protected
     only while its post is still the playing card. The sound closure's tlSlotDecide asks this at a committed
     handover to another AUDIBLE card (same 140ms dwell mid-drag) and halts it via __rovaAmStop (amHalt -> amStop
     releases the engHold). The rule's own song (amTl) is __rovaAmTl's business, so it is not reported here. */
  window.__rovaAmReader = function () { return (amCard && amAudio && !amAudio.paused && amCard !== amTl && amCard.isConnected) ? amCard : null; };
  /* ---- THE COMPOSER'S PICKED SONG AUTOPLAYS (2026-09-27, iOS build 490 parity) -------------------------
     A song picked in the "Add music" picker starts playing in the composer's attached card as soon as
     /link-preview has drawn it, and stops when the composer closes, the card is cleared or the song is
     replaced. The card is drawn ~0.1-0.5s after the tap, so the gesture is gone by then; WebKit grants
     playback PER ELEMENT to a play() made inside a gesture and keeps it, so the picker calls
     __rovaAmUnlock(<the row's preview>) IN the tap -- amArm's trick: play() then pause() in the same turn,
     nothing decodes, nothing sounds -- and the deferred start below is then allowed. Chromium only needs
     the sticky activation it already has. A refusal anyway falls into amStartFresh's 'load' path (arms the
     reader's next gesture, never "Preview unavailable"). NOT when the reader has muted the site
     (rova_sound='0'). One voice is the card machinery's own: amAudio's playing/pause/ended re-run
     applySound, which silences the timeline while the song sounds and hands the voice back after. */
  window.__rovaAmUnlock = function (src) {
    if (!src || amSndMuted()) return;
    amEnsure();
    if (amCard && !amAudio.paused) return;               // something is sounding: the element is already live
    try {
      amAudio.src = src;
      var p = amAudio.play();
      if (p && p.catch) p.catch(function () {});
      amAudio.pause();
    } catch (e) {}
  };
  window.__rovaAmComposeAuto = function (card) {
    if (!card || !card.isConnected || amSndMuted()) return false;
    var src = card.getAttribute('data-preview') || '';
    if (!src) return false;
    amStartFresh(card, src, 'load');
    // "the composer closes": the feed's composer folds by adding .panel-idle to #feed-compose-box
    var box = card.closest ? card.closest('#feed-compose-box') : null;
    if (box && window.MutationObserver) {
      var mo = new MutationObserver(function () {
        if (amCard !== card) { mo.disconnect(); return; }
        if (box.classList.contains('panel-idle') || !card.isConnected) { mo.disconnect(); amHalt(); }
      });
      mo.observe(box, { attributes: true, attributeFilter: ['class'] });
    }
    return true;
  };
  // stop a card that is sounding INSIDE root (the composer preview being cleared or re-drawn)
  window.__rovaAmStopIn = function (root) {
    if (amCard && root && root.contains && root.contains(amCard)) amHalt();
    if (amPend && root && root.contains && root.contains(amPend)) amPendClear();
  };
  /* Start the post's music as the open comes to rest. Called from the ONE place that reveals the chrome
     (the rova:pfeedready handler's drop()), so the player fades in already playing rather than arriving on
     a schedule of its own -- and because drop() is idempotent and once-per-open, this is once per open
     too. Deliberately NOT wired to the viewer's post-to-post swipe: that is "scrolling past", and starting
     audio under a reader who is just paging is the hostile version of this feature. */
  window.__rovaAmAuto = function (root) {
    if (!root || !root.querySelector) return;
    var card = root.querySelector('.am-card[data-preview]');
    if (!card) return;
    if (amCard && amAudio && !amAudio.paused) return;   // something is already playing (this card or another): never interrupt the reader
    /* THE SOUND PREFERENCE APPLIES TO AN OPEN THE READER DID NOT MAKE, AND ONLY TO THAT. A viewer
       reached by a TAP is the 2026-08-09 behaviour and is left exactly as it shipped -- the reader
       asked for this post, in this document, with a finger. A viewer opened by a LINK (the permalink
       auto-open) is a document nobody has touched, and a reader who has explicitly muted this site
       must not be sung at by a URL. amLinkOpen() is that distinction and nothing else: __rovaUser-
       Activated is false for precisely as long as no input event has reached this document. */
    if (amLinkOpen() && amSndMuted()) return;
    amStartFresh(card, card.getAttribute('data-preview') || '', 'load');
  };
  function amLinkOpen() {
    try { return !(window.__rovaUserActivated && window.__rovaUserActivated()); } catch (e) { return false; }
  }
  /* THE CARD BELONGS TO ONE POST. Swipe the viewer to the next post and the card that is playing is off
     screen with no control the reader can reach -- the same "audio with no visible source" the close path
     fixes, one swipe instead of one dismissal. Only ever stops a card INSIDE the viewer: the timeline's
     pinned player (pctx-pinned) deliberately keeps playing as the page scrolls, and it is not ours to
     stop. Costs one property read per call while nothing is playing. */
  window.__rovaAmLeave = function (post) {
    /* A PENDING ARM BELONGS TO ONE POST TOO, and it is the same argument one step earlier: the card
       whose start is waiting on the reader's first gesture can be swiped off screen before that
       gesture ever lands, and the gesture would then start a song for a post nobody is looking at.
       This hook is already the one thing that knows which post has landed, so it answers here. */
    if (amPend && amPend.closest && amPend.closest('.pfeed')
        && !(post && post.contains && post.contains(amPend))) { amPendClear(); }
    if (!amCard || !amCard.closest || !amCard.closest('.pfeed')) return;
    if (post && post.contains && post.contains(amCard)) return;
    amHalt();
  };
  // bfcache: iOS restores a page (and its media) intact on a back-swipe, so a preview that was running
  // when the reader navigated away would come back playing under a page they have only just returned to.
  // The arm goes with it: a restored page's stale arm would start a track on the first touch back.
  window.addEventListener('pagehide', function () { amPendClear(); amHalt(); });
  // 2026-10-02: a hidden page plays nothing -- a song preview kept going in a background tab / under the lock screen
  // (an <audio> is not paused by iOS at lock the way a <video> is). The playing card re-decides on the way back.
  document.addEventListener('visibilitychange', function () { if (document.hidden && amAudio && !amAudio.paused) amHalt(); });
  /* ---- THE PERMALINK OF A SONG (owner 2026-08-14) ---------------------------------------------
     A post whose whole content is an Apple Music link has NO media, so the permalink does NOT open
     the immersive viewer (see the opener's `.media img, .media video` gate) -- which is why the
     viewer's drop() -> __rovaAmAuto, the only auto-start that existed, never ran for the exact post
     that prompted this. The page just sat there with a play button on it. This is the same start,
     for the same reason, on the page that keeps the reader.

     PRECEDENCE IS UNCHANGED, AND THAT IS WHAT THIS GATE IS FOR, not tidiness. Any post carrying real
     media goes full-screen and the viewer's own auto-start owns it: ONE authority, so a permalink
     can never start the track here AND again on the open. And any post with a <video> on the page at
     all is the video's audio to lose -- a music card riding alongside a clip keeps exactly the
     precedence it has today, which is that we do not start it from a cold load.

     #c<id> IS THE ONE URL SHAPE THAT SAYS "TAKE ME TO A COMMENT". The viewer opener already refuses
     it for the same reason -- the reader was sent here to read one comment, not to be played at. */
  function amAutoLoad() {
    if (!document.querySelector('[data-pfeed-open]')) return;         // permalink pages only
    if (/^#c\d+$/.test(location.hash || '')) return;
    var post = document.querySelector('[data-pfeed-open] > .post');   // the page's OWN card, never a thread part
    if (!post) return;
    if (post.querySelector('.media img, .media video')) return;       // real media: the viewer owns this post
    /* ...AND ANY OTHER CLIP ON THE CARD, EXCEPT THE ONE THAT IS NOT A CLIP. A VIDEO AVATAR is a
       silent 2s loop inside span.avatar.av-vid -- it is a picture that moves, it has no audio track,
       and it is on a large share of these cards (/p/2345 carries two: the byline and the
       post-context bar). Counting those as "a video is playing here" would suppress the song on
       posts that have no video at all, which is the opposite of keeping precedence. */
    var pvs = post.querySelectorAll('video');
    for (var pi = 0; pi < pvs.length; pi++) {
      if (!(pvs[pi].closest && pvs[pi].closest('.avatar'))) return;   // a real clip: its audio, not ours
    }
    if (amSndMuted()) return;                                         // the reader has said no to sound here
    var card = post.querySelector('.am-card[data-preview]');
    if (!card) return;
    if (amCard && amAudio && !amAudio.paused) return;
    amStartFresh(card, card.getAttribute('data-preview') || '', 'load');
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', amAutoLoad); }
  else { amAutoLoad(); }
  document.addEventListener('click', function (e) {
    var card = e.target && e.target.closest ? e.target.closest('.am-card') : null;
    if (!card) return;
    if (e.target.closest('.am-out, .am-ol')) return;   // the open-out link (disc, or the feed card's brand-line glyph) keeps its default
    /* A WAKE TAP MUST ONLY WAKE, and this listener owed that check like the two above it (see PF_WAKE_SEL
       in the viewer: .am-card is named in that list). MEASURED HOLE, not a precaution -- 390x844 on
       /p/13940, viewer left to idle for 5s so the card is at opacity 0 / visibility:hidden, then ONE tap
       where the card sits: the chrome woke AND the track started, from a card the reader could not see.
       PF_WAKE_SEL's own comment says every control in it computes pointer-events:none at rest and every
       one of them still actuated, because wake() undoes that on touchstart, before the click's hit test
       runs. The guard reads the POINTERDOWN, so a genuine press on a visible card is untouched.
       It is a stop, not a fall-through: without stopping the event this invisible card is still sitting
       over the carousel, and the tap would page the deck instead. */
    if (window.__rovaWakeRetarget && window.__rovaWakeRetarget(e)) {
      e.preventDefault(); e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    amTapCard(card);
  }, true);
  /* THE CARD'S ONE-TAP TOGGLE, callable from the clip's corner speaker too (Rob 2026-10-03: a silent clip +
     song says "No audio" -- it has sound, the song's). On such a post buildControls shows the speaker in song
     mode and its tap lands here: the same pause / resume / start a tap on the card makes. */
  function amTapCard(card) {
    var src = card.getAttribute('data-preview') || '';
    if (!src) { amFail(card); return; }   // no baked preview is still a failure, not a dead tap
    amClearFail(card);                    // a retry starts clean
    amEnsure();
    if (amCard === card && !amAudio.paused) {   // same card: toggle pause
      amWatchStop();                            // a deliberate pause is not a stall
      amAudio.pause();
      card.classList.remove('am-playing');
      engHold('amplay', false);
      return;
    }
    if (amCard === card && amAudio.paused && amAudio.currentTime > 0) {   // resume
      amAudio.play().catch(function (err) { if (!amAborted(err)) amFail(card); });   // was swallowed silently
      card.classList.add('am-playing');
      amUser = true;                       // a resume tap is the member's own start
      engHold('amplay', true, ENG_LONG, card);
      var rr = card.querySelector('.am-rail'); if (rr) rr.hidden = false;
      amWatchStart(card);
      return;
    }
    amStartFresh(card, src, false);   // a different card (or a finished one): the shared start path
  }
  window.__rovaAmTap = function (card) { if (card && card.isConnected) { amPendClear(); amTapCard(card); } };
  // the member-started song that is sounding right now (hands-free's hfMusicHold), else null
  window.__rovaAmUserSong = function () { return (amUser && amCard && amAudio && !amAudio.paused && amCard.isConnected) ? amCard : null; };
  window.__rovaAmSongOn = function (card) { return !!(card && amCard === card && amAudio && !amAudio.paused); };

  /* ---- file pickers: live preview + 3-sec avatar check ----------------- */
  function previewInto(container, file) {
    if (!container) return null;
    container.innerHTML = '';
    if (!file) { container.hidden = true; return null; }
    var url = URL.createObjectURL(file);
    var el;
    if (file.type.indexOf('video') === 0) {
      el = document.createElement('video');
      el.src = url; el.muted = true; el.loop = true; el.autoplay = true;
      el.setAttribute('playsinline', ''); el.setAttribute('muted', '');
    } else {
      el = document.createElement('img'); el.src = url; el.alt = '';
    }
    container.appendChild(el);
    container.hidden = false;
    return el;
  }

  /* ---- compose: background media staging ---------------------------------
     Media starts uploading to /upload-stage the moment it's picked, while the
     caption is still being typed (the Instagram trick). Post then submits
     lightweight tokens instantly, or just rides out the tail of the upload. */
  var stageMedia = { items: [], seq: 0, block: null, blockStatus: 0 };   // block: a permanent "you can't post" reason (verify email / trial ended)
  var composePoster = null;   // { blob, file } chosen video cover, appended to the compose POST

  /* HOW MANY PHOTOS OR VIDEOS ONE POST MAY CARRY. There is exactly one answer and the SERVER owns
     it (Upload::MAX_FILES), because the server is what actually refuses the eleventh file; a number
     the client invents can only ever agree with it by coincidence. views/_composer.php prints it as
     data-max on #compose-file, and every cap in this file asks here.

     WHY, at the cost of a DOM read: this composer shipped with TWO hard-coded numbers. The picker
     allowed MEDIA_MAX = 20 and drew a thumbnail for each, while stageStart() sliced the same list
     to a literal 10 -- so a pick of 11-20 files showed the member 20 thumbnails, uploaded ten, and
     posted ten, with no toast, no counter and no server complaint (the ten it sent were inside the
     cap, so `dropped` came back 0). PROVED 2026-08-07 on 12 files: 12 thumbnails, 10 /upload-stage
     requests, 10 staged[] tickets, response attached:10 dropped:0, and post 15164 held 10. At 25
     files it was worse than silent -- the picker said "keeping the first 20" and kept 10.

     The 10 was left behind when MEDIA_MAX went 10 -> 20 on 2026-08-02, which is what two constants
     that must agree by hand always eventually do.

     Fallback 10, not 20: if the attribute is missing the page is older than this code, and the
     cap it was rendered under was 10. Guessing high would re-create the same silent drop. */
  var mediaMaxCache = 0;
  function mediaMax() {
    if (mediaMaxCache) return mediaMaxCache;
    var el = document.getElementById('compose-file');
    var n = el ? parseInt(el.getAttribute('data-max'), 10) : 0;
    if (!(n > 0)) n = 10;
    mediaMaxCache = Math.max(1, Math.min(100, n));
    return mediaMaxCache;
  }

  /* A staging failure the server will NEVER accept on retry -- 403 (verify your email),
     402 (trial ended), 401 (session). Re-uploading the whole 6 MB piece three times and
     then shoving the raw file through /compose is pure waste: /compose rejects it the same
     way, so on a slow phone the member watched "Posting..." spin for minutes and time out.
     Stop instantly, remember why, and let the composer show the real reason instead. */
  function stageAuthBlock(status) { return status === 401 || status === 402 || status === 403; }

  /* 419 is its OWN class, and it is neither transient nor a permission wall: the
     CSRF token this page is holding no longer matches its session. Retrying the
     same 6 MB piece with the same dead token is the exact waste that
     [[upload-verify-wall-hang]] is about -- PROVED live on 2026-08-07, when the
     owner's upload took four 419s ~21s apart (the old ladder's 4 attempts, ~84s of
     uplink) and then died. It was not the network: the same tab's /compose-trace
     beacons kept 419ing for another SEVEN MINUTES, and site-wide 419s that day were
     the lowest of the week (67, vs 72-496 on 3-6 Aug), so nothing had broken -- one
     long-lived tab's token had gone stale under it.
     But it is recoverable exactly once: /session-token hands back the session's
     CURRENT token, so re-tokening and re-sending the piece ONE time can rescue an
     upload that is otherwise dead. Once only; after that it is terminal and we say
     something true. */
  function stageCsrfRefresh() {
    return fetch('/session-token', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      /* csrfApply, NOT `csrf = j.t`. The bare assignment healed this one closure variable
         and left the <meta>, every _csrf input and the callers that read the meta at call
         time (gallery.js in its own bundle, the vflight sampler, the founders dismiss)
         holding the dead token -- so an upload could rescue itself while the rest of the
         page stayed refused. One token goes stale at a time; heal it in one place. */
      .then(function (j) { if (j && j.t && j.t !== csrf) { csrfApply(j.t); return true; } return false; })
      .catch(function () { return false; });
  }
  /* CHUNK-PATH COPY IS NOW TYPE-AWARE (2026-09-19). Both of these sentences named "the video"
     because until today only video could reach the chunked transport; `mode` now routes anything
     over UP_CHUNK_AFTER, so a 9 MB photo would have been told its VIDEO could not be read. The
     resume promise is the load-bearing half and it is true for both -- the pieces are kept
     whatever they are pieces of. */
  function stageCsrfMsg(type) {
    var w = (type === 'video') ? 'video' : 'photo';
    return 'Your session expired while the ' + w + ' was uploading. Reload the page, then pick the same '
      + w + ' again, the parts that already uploaded are kept, so it carries on instead of starting over.';
  }
  function unreadableMsg(type) {
    var w = (type === 'video') ? 'video' : 'photo';
    return 'We can’t read that ' + w + ' any more. Your device may have moved, renamed or offloaded it '
      + 'since you picked it. Choose it again to upload. Nothing you typed is lost.';
  }
  /* The single-shot twin, and the difference in the copy is not decoration: a single POST
     /upload-stage keeps NOTHING when it is refused (resume lives only on the chunked path),
     so promising "the parts that already uploaded are kept" here would be a lie. Say what is
     true instead -- nothing was posted, nothing they typed is gone, and re-picking is the way
     on -- because a message a member can act on is the whole difference between this and the
     "Background upload hiccup" they used to get. */
  var STAGE_CSRF_SINGLE_MSG = 'Your session expired while that was uploading, so it wasn’t posted. Reload the page and pick it again, nothing you typed is lost.';

  /* A permanent block used to surface ONLY as a 1.8-second toast -- with a thumb over the Post
     button it's gone before the eyes get there, and the composer then just looks dead: red bar
     under the thumbnail, Post "does nothing" (compose-trace showed members re-tapping Post at a
     blocked composer for minutes). Paint the reason as a PERSISTENT notice inside the composer,
     with the fix (resend the verification link) right there, and re-flash it on every Post tap. */
  function stageBlockNote(blockMsg, blockStatus, form) {
    blockMsg = blockMsg || stageMedia.block;
    blockStatus = blockStatus || stageMedia.blockStatus;
    form = form || (composeFile && composeFile.closest('form'));
    if (!blockMsg || !form) return null;
    var note = form.querySelector('.compose-block-note');
    if (!note) {
      note = document.createElement('div');
      note.className = 'compose-block-note';
      form.insertBefore(note, form.querySelector('.actions') || null);
    }
    // views/_composer.php ships this same node as a calm STANDING note for an unverified member
    // (.is-standing, gold) since 2026-09-18; a Post tap escalates it in place to the red one.
    note.classList.remove('is-standing');
    note.textContent = '';
    var msg = document.createElement('span');
    msg.textContent = blockMsg;
    note.appendChild(msg);
    // verify-email wall: put the resend button in the notice itself. Submitted via a detached
    // form on <body> -- a <form> nested inside the composer form would be dropped by the parser
    // and the tap would submit the (blocked) compose form instead.
    if (blockStatus === 403 && csrf) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'btn sm gold-ghost';
      b.textContent = 'Resend link';
      b.addEventListener('click', resendVerifyLink);
      note.appendChild(b);
    }
    return note;
  }
  function resendVerifyLink() {
    if (!csrf) return;
    var f = document.createElement('form');
    f.method = 'post';
    f.action = '/verify-email/resend';
    f.hidden = true;
    f.innerHTML = '<input type="hidden" name="_csrf" value="' + escHtml(csrf) + '">'
      + '<input type="hidden" name="return" value="' + escHtml(location.pathname + location.search) + '">';
    document.body.appendChild(f);
    f.submit();
  }
  // the server-rendered standing note's own Resend button (views/_composer.php .js-compose-resend):
  // delegated, so it works on a composer that has never seen a Post tap
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('.js-compose-resend') : null;
    if (!b) return;
    e.preventDefault();
    resendVerifyLink();
  });
  function stageBlockFlash(blockMsg, blockStatus, form) {
    var note = stageBlockNote(blockMsg, blockStatus, form);
    if (!note) return;
    try { note.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) {}
    note.classList.remove('flash');
    void note.offsetWidth;   // restart the pulse even if it's already running
    note.classList.add('flash');
  }

  /* An upload that has genuinely run out of road.
     Until 2026-08-07 this surfaced as NOTHING. A member's 126 MB clip lost one
     piece of twenty-one, the failure went to /compose-trace as `chunk:neterr`,
     and that was the end of it: the spinner spun, no error, no retry, no way out
     but a reload that ate the draft. He watched 98% for six and a half minutes.
     So: same persistent in-composer notice a permanent block gets, in words a
     person can act on, and a button that RESUMES rather than restarting -- the
     server keeps every piece that landed (Upload::chunkState). Nothing here
     touches the caption or the draft; a failed post must never cost you what you
     typed. */
  /* The "some of it landed" sentence. Three situations, three sentences, and the
     numbers have to agree -- the first version of this said "send just the 32 that
     didn't" when ZERO had landed, which is both self-contradictory ("just" the whole
     file) and grammatically truncated. */
  function upFailWords(have, total) {
    var left = Math.max(1, total - have);
    var piece = function (n) { return n === 1 ? '1 part' : n + ' parts'; };
    if (have >= total * 0.8) {          // nearly there: lead with how little is left
      return 'Your video almost finished uploading, only ' + piece(left) + ' left to send. '
           + 'Nothing you typed is lost.';
    }
    return 'Your video stopped uploading, ' + have + ' of ' + total + ' parts are already saved. '
         + 'Tap “Resume upload” and we’ll send only the remaining ' + (left === 1 ? 'one' : left) + '. '
         + 'Nothing you typed is lost.';
  }
  /* "5.1 GB" / "840 MB". A refusal has to name a size the member recognises from
     their own file browser, and "5223 MB" is not that number. */
  function upSizeWords(bytes) {
    var gb = bytes / 1073741824;
    if (gb >= 1) { return (Math.round(gb * 10) / 10) + ' GB'; }
    return Math.round(bytes / 1048576) + ' MB';
  }
  function stageFailNote(msg, form) {
    form = form || (composeFile && composeFile.closest('form'));
    if (!form || !msg) return null;
    var note = form.querySelector('.compose-block-note');
    if (!note) {
      note = document.createElement('div');
      note.className = 'compose-block-note';
      form.insertBefore(note, form.querySelector('.actions') || null);
    }
    note.textContent = '';
    var span = document.createElement('span');
    span.textContent = msg;
    note.appendChild(span);
    // The verb must match the situation. "Resume" is only true when there is
    // something to resume; with nothing uploaded it is starting over, and with an
    // unreadable file the only thing that helps is picking it again.
    var kind = '';
    stageMedia.items.forEach(function (it) { if (it.failed && it.failKind) kind = it.failKind; });
    var canRetry = stageMedia.items.some(function (it) { return it.failed && typeof it.retry === 'function'; });
    if (kind === 'repick') {
      var pick = document.createElement('button');
      pick.type = 'button';
      pick.className = 'btn sm gold-ghost';
      pick.textContent = 'Choose the video again';
      pick.addEventListener('click', function () { if (composeFile) composeFile.click(); });
      note.appendChild(pick);
    } else if (canRetry) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'btn sm gold-ghost';
      b.textContent = (kind === 'restart') ? 'Start upload again' : 'Resume upload';
      b.addEventListener('click', function () { stageRetryFailed(); });
      note.appendChild(b);
    }
    try { note.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) {}
    note.classList.remove('flash');
    void note.offsetWidth;
    note.classList.add('flash');
    return note;
  }
  function stageRetryFailed() {
    var note = document.querySelector('.compose-block-note');
    if (note) note.remove();
    var any = false;
    stageMedia.items.forEach(function (it) {
      if (!it.failed || typeof it.retry !== 'function') return;
      any = true;
      var have = 0; if (it.got) { for (var g in it.got) have++; }
      ctrace('stage:userretry', { have: have });
      it.failed = false; it.fatal = false; it.tries = 0; it.trouble = 0; it.reTokened = false;
      it.failMsg = ''; it.failKind = '';
      stagePaint(it);
      it.retry();
    });
    if (any) toast('Picking up where it left off…');
  }

  /* ---- compose DRAFT: survive a mobile page reload / tab eviction ------------
     Phones discard + reload the tab under memory pressure -- and opening the
     camera / file picker is a classic trigger. That used to wipe the typed
     caption AND the in-memory staged media, so the owner "kept going in circles:
     upload the video then type the caption -> the video's gone; type the caption
     then upload -> the caption's gone." Now the caption is mirrored to
     sessionStorage as it's typed, and each staged upload carries a
     self-authenticating 2-hour token (an HMAC over user+file+expiry, NOT session
     state), so BOTH the text and the attachments are rebuilt after a reload.
     sessionStorage (not local) so a draft is per-tab and clears when the tab
     closes -- it only exists to bridge a reload, never to haunt the next visit. */
  var DRAFT_KEY = 'rova:draft:' + location.pathname;
  function draftRead() { try { return JSON.parse(sessionStorage.getItem(DRAFT_KEY) || '{}') || {}; } catch (e) { return {}; } }
  function draftWrite(o) { try { sessionStorage.setItem(DRAFT_KEY, JSON.stringify(o)); } catch (e) {} }
  function draftSaveBody(v) { var o = draftRead(); if (v && v.trim()) o.body = v; else delete o.body; draftWrite(o); }
  function draftSaveMedia() {
    var o = draftRead();
    var toks = stageMedia.items.filter(function (it) { return it.token && it.done && !it.failed; })
      .map(function (it) { return { token: it.token, type: it.type || 'image' }; });
    if (toks.length) o.media = toks; else delete o.media;
    draftWrite(o);
  }
  function draftClear() { try { sessionStorage.removeItem(DRAFT_KEY); } catch (e) {} }

  /* "IS THERE ANYTHING IN THIS COMPOSER THAT A SCROLL MUST NEVER THROW AWAY?" (2026-09-18)
     The feed IIFE's auto-close (an EMPTY composer folds itself away once the reader scrolls past it,
     so the header + is never a blind toggle) has to answer that question, and the four things that
     can say yes all live in THIS closure: the staged-media list, the chosen video cover, and the
     sessionStorage draft that [[composer-draft-persistence]] exists to keep -- plus any upload still
     on the wire. The panel's own fieldsHaveContent() sees the visible FIELDS; it cannot see a staged
     upload whose thumb is mid-build, a poster blob, or a draft that a reload has not yet restored.
     FAIL CLOSED: anything unexpected in here returns true, i.e. "there is work" -- the cost of a
     false positive is a composer that stays open (the pre-2026-09-18 behaviour, and the + button now
     brings it back on screen either way), while a false negative silently eats someone's draft. */
  window.__rovaComposerHasWork = function () {
    try {
      if (stageMedia.items.length) return true;                      // staged/att aching media, done or not
      if (composePoster) return true;                                // a chosen video cover
      if (window.__rovaUpBusy && window.__rovaUpBusy()) return true;  // bytes still on the wire
      var d = draftRead();
      if (d && (((d.body || '').trim() !== '') || (d.media && d.media.length))) return true;
      return false;
    } catch (e) { return true; }
  };
  // The stage token is base64url(userId|type|path|expiry|sig): decode it to recover the staged file's own
  // web path (it lives under /uploads/staged, served static) so a restored attachment shows its real preview.
  function draftDecodeToken(tok) {
    try {
      var b64 = String(tok).replace(/-/g, '+').replace(/_/g, '/');
      while (b64.length % 4) b64 += '=';
      var parts = atob(b64).split('|');   // userId | type | path | expiry | sig
      if (parts.length < 5 || parts[2].indexOf('/uploads/') !== 0) return null;
      return { type: parts[1], path: parts[2], exp: parseInt(parts[3], 10) || 0 };
    } catch (e) { return null; }
  }
  document.addEventListener('input', function (e) {
    var t = e.target;
    // fullValue, not t.value: once a resolved link's URL is hidden from view (the live-preview IIFE),
    // the visible text is SHORT of it. The draft has to hold the real body -- it is what a reload
    // restores from, and saving the shortened one would make a reload the thing that eats the link.
    if (t && t.matches && t.matches('.js-compose textarea[name="body"]')) {
      draftSaveBody(window.__rovaComposeFullBody ? window.__rovaComposeFullBody(t) : t.value);
    }
  });

  function stageReset() {
    draftClear();   // a stageReset only happens after a post lands -> the draft has served its purpose
    stageMedia.items.forEach(function (it) {
      if (it.vcCancel) { try { it.vcCancel(); } catch (e) {} }   // and any on-device encode still running
      if (it.done || it.failed) return;
      if (it.xhr) { try { it.xhr.abort(); } catch (e) {} }
      if (it.xhrs) { it.xhrs.forEach(function (x) { try { x.abort(); } catch (e) {} }); }  // parallel chunk workers
    });
    stageMedia.items = [];
    stageMedia.seq++;
    // fresh slate for the shared upload window (in-flight aborts settle themselves)
    upWin.pumps.length = 0; upWin.cwnd = 2; upWin.streak = 0;
    stageMedia.block = null;
    stageMedia.blockStatus = 0;
    var note = document.querySelector('.compose-block-note');
    if (note) note.remove();
    composePoster = null;
  }
  /* ONE bar for an attachment, covering compress-then-upload as a single operation.
     The owner does not want a panel announcing that we are shrinking anything
     ("no need to show the user shrinking the video so it uploads faster") -- but a
     bar frozen at 0% for the 24 seconds a 949 MB clip takes to encode is the
     "stuck on Posting..." bug this whole night started with. So compression is
     simply the FIRST STRETCH of the same bar.

     WEIGHTING, from measurement rather than taste. Real device, tonight:
     949 MB -> 58.7 MB in 24.5 s, 605 -> 37.7 in 15.9 s, 183 -> 12.6 in 4.9 s --
     about 38 MB of source per second, output ~6% of source. Uploading what comes
     out takes ~59 s at the ~1 MB/s a real mobile uplink manages here (successful
     /upload-chunk requests measured at 17-106 s per 6 MB piece), and ~12 s on
     wifi. So compression is genuinely 30-70% of the whole job depending only on
     the link, which we cannot know in advance. 0.35 sits at the low end
     deliberately: undershooting means the bar reaches the upload stretch early
     and keeps moving, whereas overshooting would park it while the upload runs.

     it.vcShare is 0 for anything that is not being compressed (images,
     passthrough videos, browsers with no WebCodecs), so their bar is pure upload
     exactly as before. */
  var VC_BAR_SHARE = 0.35;
  function itemFrac(it) {
    if (it.done) { return 1; }
    var share = it.vcShare || 0;
    var vc    = share > 0 ? Math.min(1, it.vcP || 0) : 0;
    var up    = it.size > 0 ? Math.min(1, it.sent / it.size) : 0;
    return share * vc + (1 - share) * up;
  }
  function stagePaint(it) {
    if (!it.thumb) return;
    /* MONOTONIC. The bar must never walk backwards: a chunk retry rewinds
       it.sent, and the compression-to-upload handover starts the upload term at
       zero. Both are real, both look like failure to a member watching a bar.
       NOTE the `|| 0` before the compare, not after: `f >= undefined` is FALSE
       for every f, so seeding the high-water mark lazily inside the comparison
       pins the bar at zero forever -- which is exactly what it did on the first
       run of this code, on the ordinary upload bar as well as the compression
       stretch. Caught by sampling the painted width, not by reading it. */
    var f = itemFrac(it), m = it.pmax || 0;
    if (f > m) { it.pmax = f; } else { f = m; }
    var fill = it.thumb.querySelector('.up-fill');
    if (fill) fill.style.width = Math.round(f * 100) + '%';
    it.thumb.classList.toggle('up-done', it.done);
    it.thumb.classList.toggle('up-fail', it.failed);
  }
  /* ---- video size bounds: THE CAP IS ON WHAT WE UPLOAD, NOT ON WHAT WAS PICKED --
     Owner, 2026-08-08: "I want chris cash to be able to upload whatever he wants
     and we just use our browser compression and optimize it as good as possible
     on our end". Until now the opposite happened. UP_POST_VID_MAX was tested
     against the PICKED file at the top of stageStart(), which runs BEFORE
     maybeCompressVideo() -- so a 5 GB export was refused with a toast before a
     single byte moved, and the compressor that exists precisely to rescue it
     (949 MB -> 58.7 MB measured; 218.9 MB -> 19.0 MB measured here) never got to
     run. The gate was in front of its own fix.

     So there are now TWO bounds, and they mean different things:

       UP_POST_VID_MAX  the TRANSPORT cap, applied to it.file AFTER compression --
                        the bytes that will actually be sent. Still 4 GB, still an
                        exact mirror of Upload::CHUNK_MAX_TOTAL, and deliberately
                        NOT raised: at the compressor's ~5.3 Mbps target, 4 GB is
                        ~107 minutes of video, so nothing we can produce comes
                        near it. Raising it would only admit RAW uploads, which is
                        the one thing the 5 GB readiness audit says not to do -- a
                        bigger number with no pipeline behind it is worse than a
                        clean refusal.

       UP_PICK_VID_MAX  the only thing still refused at pick time: a source so
                        large that compressing it is not a rescue but an ordeal.
                        16 GB is ~3x Chris's export and, at the measured encode
                        rate on this box (a 5.05 GB / 11:00 4K source compressed in
                        ~34 min of wall clock), it is over an hour and a half of
                        watching a bar. That refusal says what to do instead; it is
                        not the old "over the limit" dead end.

     IMAGES ARE UNCHANGED and still refused up front at UP_IMG_MAX. There is no
     image compressor on this path, so nothing downstream can rescue an oversized
     photo -- deferring that refusal would only delay the same answer. */
  var UP_POST_VID_MAX = 4 * 1024 * 1024 * 1024;    // mirror of Upload::CHUNK_MAX_TOTAL, applied POST-compression
  var UP_PICK_VID_MAX = 16 * 1024 * 1024 * 1024;   // refused at pick time: beyond what compressing can rescue
  var UP_CHUNK_BYTES  = 6 * 1024 * 1024;          // one piece: clears even a default post_max_size
  /* 24 MB until 2026-09-14, and the number had no relationship to the ceiling that kills a
     single-shot attempt. A single POST /upload-stage gets UP_ATTEMPT_MS (150s) of wall clock
     whatever its size, so 24 MB demands ~164 KB/s of sustained phone uplink or it dies with
     nothing kept -- and a failed single-shot restarts from byte 0, because resume lives only
     on the chunked path. Measured on uid 15009's 18.2 MB video: 14.3 MB had landed when the
     ceiling fired at 89%, and all of it was thrown away. At 8 MB the ceiling asks for ~55 KB/s,
     which congested LTE clears, and everything above it gets per-piece retries, a real resume
     and the 419 re-token branch chunkGo has always had.
     2026-09-19: AND IT APPLIES TO PHOTOS TOO. Until then `mode` also tested the media type, so a
     photo was a single shot at any size up to UP_IMG_MAX (25 MB) against the same 150s ceiling --
     the residue of the very bug this constant was lowered to fix. See `mode` below. */
  var UP_CHUNK_AFTER  = 8 * 1024 * 1024;          // ANY file bigger than this travels in pieces

  /* ---- upload liveness bounds ------------------------------------------------
     An upload XHR used to carry NO deadline of any kind. 2026-08-07, a member on
     a bad line: piece #0 of a 126 MB clip hung for 565 SECONDS, then finally fired
     onerror, and the composer -- which only ever learns anything from onload or
     onerror -- spun "Posting…" at 98% the entire time and after. 20 of the 21
     pieces were safely on the server's disk.

     `xhr.timeout` is the WRONG tool: it is wall-clock, and a genuinely slow phone
     legitimately needs minutes per piece (measured, IIS W3SVC158: successful
     /upload-chunk requests of 100,565 ms and 106,184 ms on 2026-08-05). Killing
     those would be a worse bug than the one being fixed. So gate on PROGRESS --
     bytes still moving means alive, however slowly (same rule as the transcode
     stall detector). Only the outer backstop is wall-clock, and it is set where
     it can never end a request that could still have succeeded:

       UP_STALL_MS  45s with ZERO upload bytes moved -> that attempt is dead.
                    onprogress fires per socket flush, so even a 40 KB/s link
                    ticks several times a second.
       UP_RESP_MS   90s after the last byte went out with no response -> dead.
                    The server's remaining work is one seek+write+bitmap flush.
       UP_ATTEMPT_MS 150s hard backstop. PROVED safe: /upload-chunk is killed
                    ABOVE us at ~125s -- four rows in the IIS log, 125,008 /
                    125,012 / 125,006 / 125,053 ms, every one sc=500 win32=64 --
                    while the slowest chunk that ever SUCCEEDED took 106,184 ms.
                    Nothing that can still finish is alive at 150s.
       UP_TRIES     5 attempts per piece (was 3). This member needed exactly one
                    more piece; three quick tries inside five seconds of a
                    flapping link is not a retry policy.
       UP_GIVEUP_MS 150s, measured from the FIRST failed attempt and reset by any
                    piece that lands. A tries-count alone is not a bound on TIME:
                    five attempts that each take 90s to die is seven and a half
                    minutes of "Posting…", which is the bug, not the fix. This
                    still leaves room for ~3 attempts, so a one-off hiccup is
                    absorbed silently, and an upload that is genuinely moving can
                    never reach it -- every landed piece clears the clock.  */
  var UP_STALL_MS   = 45000;
  var UP_RESP_MS    = 90000;
  var UP_ATTEMPT_MS = 150000;
  var UP_TRIES      = 5;
  var UP_GIVEUP_MS  = 150000;

  /* Watchdog for one upload attempt. Returns {move, stop}: feed it upload
     progress, and it aborts + reports the moment the attempt stops being alive.
     Aborting fires onabort (NOT onerror), so the caller's onDead is the only
     path out -- it must do the retry itself. */
  function uploadWatch(xhr, onDead) {
    var t0 = Date.now(), last = t0, sentAll = false, timer = null, kill = false;
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    timer = setInterval(function () {
      var now = Date.now(), why = '';
      if (now - t0 > UP_ATTEMPT_MS) why = 'ceiling';
      else if (sentAll) { if (now - last > UP_RESP_MS) why = 'noresp'; }
      else if (now - last > UP_STALL_MS) why = 'stall';
      if (!why) return;
      stop();
      kill = true;                         // our abort, not the caller's: onabort must not settle it
      try { xhr.abort(); } catch (e) {}
      onDead(why, Math.round((now - t0) / 1000));
    }, 1000);
    return {
      move: function (loaded, total) {
        last = Date.now();
        if (total && loaded >= total) sentAll = true;   // body's up; now we're waiting on PHP
      },
      killed: function () { return kill; },
      stop: stop
    };
  }

  /* ---- ONE congestion window for the WHOLE composer ------------------------
     The window used to live inside chunkGo, i.e. one per attachment. Two videos
     staging at once therefore got two independent windows and together put twice
     the cap on the wire. Measured live 2026-08-07 07:05:36 on the member's own
     traffic: two streams open at once (`total:10` at 07:05:36 and `total:32` at
     07:05:42) and an interval sweep of the IIS rows showed a true maximum of
     EIGHT concurrent /upload-chunk requests against a nominal cap of 3.
     The uplink is shared by everything on the page, so the window has to be too.

     2026-08-07, second pass: it also has to cover PLAIN staging. `stageStart` ->
     `attempt()` -- the single-shot /upload-stage path every photo and every small
     video takes -- never asked the window at all, so N picked files were N
     simultaneous XHRs, unbounded. That was survivable at a 10-item cap and stopped
     being survivable at 20: measured on 2.3 MB photos with a CDP-throttled uplink,
     10 files at 250 KB/s = 10 concurrent, 94 s per request, 10/10 landed; 20 files
     at 250 KB/s = 20 concurrent, 0/20 landed. The mechanism is the same bandwidth
     sharing the chunk window was built for, and it is ALL-OR-NOTHING: every attempt
     shares one uplink and every attempt carries the same UP_ATTEMPT_MS ceiling, so
     either the whole batch fits under it or the whole batch crosses it together.
     Cliff = totalBytes / 150s: 10 x 2.3 MB needs ~153 KB/s, 20 x 2.3 MB needs
     ~306 KB/s -- and congested LTE reporting effectiveType:'3g' sits in that band.
     Serialising costs ~15% wall time and converts 0/20 into 20/20. */
  var upWin = { cwnd: 2, inFlight: 0, streak: 0, pumps: [] };
  function upWinTake()    { upWin.inFlight++; }
  function upWinRelease() {
    upWin.inFlight = Math.max(0, upWin.inFlight - 1);
    /* ROUND-ROBIN, not registration order. A freed slot belongs to whichever stream
       can use it -- but `forEach` over a fixed order means the FIRST registered pump
       gets every slot it asks for, and a chunked video with 700 pieces always has one
       ready. Photos staged alongside it would then wait for the entire video before
       their first byte moved. Rotating by one per release makes the window fair
       between a 6 MB chunk and a 2.3 MB photo without needing to know which is which. */
    if (upWin.pumps.length > 1) { upWin.pumps.push(upWin.pumps.shift()); }
    upWinKick();
  }
  /* Re-ask every waiting stream, without freeing a slot. Used when something OTHER
     than a completed request changed the answer -- notably a permanent wall, where
     the queued remainder must abandon rather than wait for a slot they should never
     get (see stagePump). */
  function upWinKick() { upWin.pumps.slice().forEach(function (p) { try { p(); } catch (e) {} }); }
  function upWinWiden() {
    upWin.streak++;
    if (upWin.streak >= 2 && upWin.cwnd < 3) { upWin.cwnd++; upWin.streak = 0; ctrace('chunk:cwnd', { cwnd: upWin.cwnd, dir: 'up' }); }
  }
  function upWinNarrow() {
    upWin.streak = 0;
    var was = upWin.cwnd;
    upWin.cwnd = Math.max(1, Math.floor(upWin.cwnd / 2));
    if (upWin.cwnd !== was) ctrace('chunk:cwnd', { cwnd: upWin.cwnd, dir: 'down' });
  }

  /* Can we still READ this file? Safari invalidates the File behind an <input>
     when the underlying item moves, is renamed, or gets offloaded (iCloud, an
     external volume, a Photos-library asset). Every read then fails INSTANTLY with
     NotFoundError -- "The object can not be found here." -- which is indistinguishable
     from a dead network if you only look at the XHR, because xhr.send() of an
     unreadable Blob fires onerror with status 0 and no bytes sent.
     A one-byte read settles it, and it costs nothing. */
  function fileReadable(file) {
    return new Promise(function (resolve) {
      if (!file || !file.slice) { return resolve(true); }
      var fr = new FileReader();
      var done = false;
      var t = setTimeout(function () { if (!done) { done = true; try { fr.abort(); } catch (e) {} resolve(true); } }, 4000);
      fr.onload  = function () { if (!done) { done = true; clearTimeout(t); resolve(true); } };
      fr.onerror = function () { if (!done) { done = true; clearTimeout(t); resolve(false); } };
      try { fr.readAsArrayBuffer(file.slice(0, 1)); } catch (e) { done = true; clearTimeout(t); resolve(false); }
    });
  }

  /* A STABLE id for a chunk stream, so a retry -- or a re-pick of the same file
     after a reload -- lands on the same server-side stream and resumes instead of
     starting from zero. The chunk size is folded in because the stream's byte
     offsets are computed from it; change UP_CHUNK_BYTES and every id changes with
     it, which is exactly right. 32 hex chars, matching the server's
     /^[a-f0-9]{16,64}$/. Not a security boundary: the part file is namespaced by
     uid server-side, so a guessed id can only ever reach your own upload. */
  /* `salt` IS A CORRECTNESS FIX, NOT AN OPTION. Callers pass it.vcTag, which is
     stamped where a compressed result is adopted in stageStart().
     For a file that came off the COMPRESSOR, name/size/lastModified are NOT a
     safe identity: two encodes of one source land on the same byte COUNT (the
     rate control is bitrateMode:'constant') while the encoded bytes differ.
     Measured on this box, the same 218.9 MB 4K source compressed twice:
         run 1 and run 2 both 19,874,110 bytes exactly
         1,987,966 of those bytes differ -- 10% of the file, spread from offset
         1,658,602 all the way to 19,873,832
         md5 92d04462... vs 144a4232...
     Unsalted, both encodes hash to the SAME upId, so /upload-chunk-status would
     report run 1's pieces as already held and the client would send only the
     missing ones FROM RUN 2 -- assembling one file out of two different encodes.
     That is a silently corrupt video, which is worse than re-uploading. */
  function upStreamId(file, chunkBytes, salt) {
    var s = (file.name || 'v') + '|' + file.size + '|' + (file.lastModified || 0) + '|' + chunkBytes + '|' + (salt || '');
    var h = [0x811c9dc5, 0x01000193, 0x9e3779b9, 0x85ebca6b];
    for (var i = 0; i < s.length; i++) {
      for (var k = 0; k < 4; k++) {
        h[k] ^= s.charCodeAt(i) + k;
        h[k] = (h[k] * 16777619) >>> 0;
      }
    }
    return h.map(function (n) { return ('00000000' + n.toString(16)).slice(-8); }).join('');
  }
  /* ======================================================================
     THE UPLOAD ENGINE — ONE COPY, TWO CALLERS

     Everything below used to live inside stageStart()'s forEach, closed over the
     composer's own state, and was therefore reachable from exactly one surface.
     That is why the post editor shipped with a 190 MB refusal ("Post it on its
     own and it will upload in pieces"): the pieces existed, twenty lines away, in
     a scope it could not reach. The alternative — a second /upload-chunk client
     in the editor — is the failure this codebase repeats most (three aspect
     clamps, three NSFW blur markups, nine hand-copied API gates), and it would
     have duplicated the parts that are hardest to get right and cost the most to
     get wrong: the shared congestion window, the progress-not-wall-clock
     watchdogs, resume, and the instant 401/402/403 stop.

     So it is a function now, and it knows nothing about composers. Everything
     surface-specific arrives in `ctx`:

       alive(it)          is this item still part of a live picker session?
       paint(it)          repaint its progress (the caller owns its own markup)
       persist()          a token landed and is worth keeping (composer draft;
                          the editor holds its tickets until Save, so: no-op)
       adopted(it)        the compressor swapped it.file for smaller bytes
                          (the composer mirrors its raw FileList; the editor has
                          no raw fallback, so: no-op)
       blockMsg()         the permanent wall this session already hit, or falsy
       setBlock(msg, st)  remember one, paint the caller's notice, return the
                          effective sentence
       warnOnce(msg, ms)  tell the member ONCE per pick batch, not once per file
       note(msg, kind)    the persistent failure notice that carries Resume /
                          Choose-again — the half a toast cannot do

     WHAT STAYS SHARED AND MUST: upWin is module scope and is the ONE congestion
     window for the whole page. Two surfaces uploading at once share it exactly
     as two attachments in one composer do — which is the entire point of the
     2026-08-07 fix that found EIGHT concurrent /upload-chunk requests against a
     nominal cap of 3. A per-surface window would re-create that bug with a
     second name.

     THE THIRD CONSUMER IS NOT IN THIS FILE. /admin/create (views/admin_create.php)
     uploads 100-500 MB archive clips and needs exactly this engine and nothing
     else, so it reaches it through the one-line export below. It is a page-scoped
     inline script rather than more of app.js on purpose: it is admin-only, shares
     no components with anything here, and this file is a build target that several
     people edit in a day. The export is the whole interface -- the ctx contract
     above is unchanged, and admin_create.php answers all eight methods.
     ====================================================================== */
  function upDrive(it, ctx) {
    /* THE PICKED file. it.file is REPLACED when the compressor produces smaller
       bytes, so every "what did they choose" question below has to ask src, and
       every "what are we about to send" question has to ask it.file. Conflating
       the two is the bug the 2026-08-08 reorder fixed (a 5 GB export refused
       before the compressor that exists to rescue it ever ran). */
    var src = it.file;

    /* ---- single-shot staging, THROUGH the shared window --------------------
       `attempt()` is now the ENQUEUE half and stageSend() is the send half, so a
       picked file -- and every retry of it -- enters flight in exactly one place,
       under upWin.cwnd, exactly as a chunk piece does. Before this split, ten
       pickers were ten simultaneous XHRs and twenty were twenty; see the note on
       upWin. The queue is one boolean per item because a single-shot upload has
       exactly one outstanding request: there is no per-piece ordering to keep. */
    var sWant = false;                        // this item is waiting for a slot
    function attempt() {
      if (sWant) return;                      // already queued; the pump owns it
      sWant = true;
      stagePump();
    }
    function stagePump() {
      if (!sWant) return;
      if (!ctx.alive(it)) { sWant = false; stageUnreg(); return; }
      if (it.done || it.failed) { sWant = false; stageUnreg(); return; }
      /* A permanent wall (verify email / trial ended) is decided ONCE for the whole
         composer. Firing the queued remainder into it would be nineteen more certain
         403s on a link that is already the problem -- and 401/402/403 must stop
         instantly, not merely stop retrying. The item is marked failed so Post shows
         the block note rather than waiting on an upload that will never start. */
      if (ctx.blockMsg()) {
        sWant = false; stageUnreg();
        if (!it.done && !it.failed) { it.tries = 2; it.failed = true; ctx.paint(it); }
        return;
      }
      if (upWin.inFlight >= upWin.cwnd) { return; }   // upWinRelease() calls us back
      sWant = false;
      stageSend();
    }
    function stageReg()   { if (upWin.pumps.indexOf(stagePump) < 0) { upWin.pumps.push(stagePump); } }
    function stageUnreg() { var si = upWin.pumps.indexOf(stagePump); if (si >= 0) { upWin.pumps.splice(si, 1); } }
    function stageSend() {
      it.tries++;
      var fd = new FormData();
      fd.append('media', it.file);
      var xhr = new XMLHttpRequest();
      it.xhr = xhr;
      xhr.open('POST', '/upload-stage?ajax=1');
      xhr.setRequestHeader('X-CSRF-Token', csrf);
      xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      xhr.setRequestHeader('Accept', 'application/json');
      ctrace('stage:begin', { size: it.size, tries: it.tries, cwnd: upWin.cwnd });
      // Same liveness rule as the chunked path: a single-file stage XHR had no
      // deadline either, so a socket that goes quiet mid-body used to hang until
      // the browser felt like giving up (measured at 565s on a real member).
      var sSettled = false;
      /* ONE attempt, ONE outcome, ONE release. Every exit from this request --
         onload, onerror, onabort, and the watchdog's own abort -- funnels through
         here, so the slot can neither leak (window shrinks to nothing, uploads
         stop) nor be handed back twice (window inflates, which is the bug the
         chunk retries had). Symmetric with chunkGo's settle(). */
      function sSettle() { if (sSettled) return false; sSettled = true; sw.stop(); upWinRelease(); return true; }
      var sw = uploadWatch(xhr, function (why, secs) {
        if (!sSettle()) return;
        ctrace('stage:dead', { why: why, secs: secs });
        upWinNarrow();                        // the uplink just told us it is full
        failedNow('');
      });
      if (xhr.upload) xhr.upload.onprogress = function (ev) {
        if (!ctx.alive(it)) return;
        sw.move(ev.loaded, ev.total);
        if (!ev.lengthComputable) return;
        it.sent = ev.loaded;
        ctx.paint(it);
      };
      xhr.onabort = function () { if (sw.killed()) return; sSettle(); };
      function failedNow(msg) {
        if (!ctx.alive(it)) return;   // reset, or this item was deleted
        // one quiet retry (skip if deleted meanwhile). Back through attempt(), i.e.
        // back onto the QUEUE and never straight into flight -- a retry that
        // bypassed the window is how eleven concurrent chunk uploads happened.
        if (it.tries < 2) { it.sent = 0; setTimeout(function () { if (ctx.alive(it)) attempt(); }, 800); return; }
        it.failed = true;
        stageUnreg();
        ctx.paint(it);
        // once per pick batch, not once per file
        ctx.warnOnce(msg || 'Background upload hiccup. Posting will send it the classic way.');
      }
      xhr.onload = function () {
        if (!sSettle()) return;
        if (!ctx.alive(it)) return;   // reset or deleted
        var res = null; try { res = JSON.parse(xhr.responseText); } catch (e) {}
        if (xhr.status === 200 && res && res.ok) {
          it.token = res.token; it.done = true; it.sent = it.size;
          upWinWiden();                       // ground gained: the link can take a little more
          stageUnreg();
          ctx.paint(it); ctx.persist();   // persist so a reload can bring the attachment back
          ctrace('stage:done', {});
        } else if (stageAuthBlock(xhr.status)) {
          // permanent (verify email / trial ended): fail hard, no quiet retry, no raw fallback
          // setBlock REMEMBERS the wall for the whole picker session and paints the
          // caller's persistent notice; it hands back the effective sentence.
          var sBlk = ctx.setBlock((res && res.error) || '', xhr.status);
          ctrace('stage:block', { status: xhr.status, msg: String(sBlk).slice(0, 120) });
          it.tries = 2; failedNow(sBlk);
          upWinKick();        // and the items still queued behind it abandon now, not one 403 at a time
        } else if (xhr.status === 419) {
          /* THE SAME BUG, THE SAME FILE, THE OTHER CALL SITE. chunkGo has had this branch
             since 2026-08-07 (see stageCsrfRefresh above); stageSend -- the single-shot
             path every photo and every video under UP_CHUNK_AFTER takes -- never got it,
             so a 419 fell into the generic `else` below, told the member "Background
             upload hiccup", and then let submit() push the raw file through /compose
             carrying the SAME dead token. That is how uid 15009 lost an 18.2 MB video at
             18:58:30Z on 2026-09-14 after four and a half minutes of uplink: the bytes all
             arrived, the server refused the token, and nothing on this path knew what 419
             meant. A fixed bug at one of its two sites reads as a fixed bug and stops
             being looked for.
             The refusal is a PROVEN no-op (Security::requireCsrf exits before dispatch),
             so re-sending is safe -- and for a single shot it is a whole re-send, which is
             why it happens once and never loops. */
          ctrace('stage:csrf', { retried: it.reTokened ? 1 : 0 });
          if (it.reTokened) { it.tries = 2; it.fatal = true; failedNow(STAGE_CSRF_SINGLE_MSG); return; }
          it.reTokened = true;
          stageCsrfRefresh().then(function (fresh) {
            if (!ctx.alive(it) || it.done || it.failed) return;
            if (!fresh) { it.tries = 2; it.fatal = true; failedNow(STAGE_CSRF_SINGLE_MSG); return; }
            ctrace('stage:csrfok', {});
            /* Straight back onto the QUEUE, never into flight -- same rule as failedNow's
               retry. tries resets because this is not "another go at a flaky link", it is
               the first go with a token that can actually work. */
            it.tries = 0; it.sent = 0; ctx.paint(it); stageReg(); attempt();
          });
        } else {
          ctrace('stage:fail', { status: xhr.status });
          /* PREFER `message`. limit_refuse() (index.php:1133) answers a throttled upload with
             {error:'rate', message:'Too many uploads, take a breather.'} -- `error` there is the
             machine CODE, not a sentence -- so reading `error` first put the literal word "rate"
             on screen as the whole explanation. Observed 2026-08-07 while staging 12 photos
             against the 40/hour /upload-stage limit. Every other handler on this path puts a
             human sentence in `error` and sets no `message`, so preferring `message` changes
             nothing else. */
          failedNow((res && (res.message || res.error)) || 'Background upload failed (HTTP ' + xhr.status + ').');
        }
      };
      xhr.onerror = function () { if (!sSettle()) return; ctrace('stage:neterr', {}); upWinNarrow(); failedNow(''); };
      // The slot is taken HERE, immediately before the bytes start moving, and the
      // watchdog above was armed in the same breath -- so a file sitting in the
      // queue burns neither a slot nor a second of its UP_ATTEMPT_MS ceiling.
      upWinTake();
      try { xhr.send(fd); }
      catch (e) { if (sSettle()) { ctrace('stage:sendthrow', { err: String((e && e.name) || e).slice(0, 60) }); failedNow(''); } }
    }
    // big videos travel in ~6 MB pieces: each piece is small enough for any
    // server body limit, retries resume at the failed piece (not from zero),
    // and the final piece answers with the same claim token as /upload-stage
    function chunkGo() {
      var CH = UP_CHUNK_BYTES;
      var total = Math.max(1, Math.ceil(it.file.size / CH));
      /* STABLE ACROSS ATTEMPTS, and across a reload+re-pick for a file we did
         NOT re-encode -- so a retry RESUMES the server's existing stream. It
         used to be 16 random bytes per attempt, which made every retry a fresh
         126 MB.
         it.vcTag is empty for everything the compressor left alone (images,
         passthrough videos, unsupported browsers), so those keep the full
         cross-session resume exactly as before. It is set ONLY when this item's
         bytes came out of an encode, where a stable id is not merely useless
         but actively unsafe -- see upStreamId(). Within the session it.upId is
         cached on the item, so retries and the "Resume upload" button still
         resume a compressed upload; it is only a fresh pick, which re-encodes
         and therefore produces different bytes, that correctly starts over. */
      var upId = it.upId || (it.upId = upStreamId(it.file, CH, it.vcTag));
      it.got = it.got || {};             // idx -> true, pieces the server has confirmed
      /* ---- how many pieces may be in flight: a congestion window ------------
         The server writes each piece at its byte offset and finalizes once EVERY
         piece has landed, so pieces may travel and arrive in any order.

         This used to be a flat `CONC = 3`, and retries did not count against it:
         a failed piece decremented inFlight, pump() immediately started a fresh
         piece, and then the retry landed on top. Measured on the owner's own
         traffic (79 /upload-chunk requests, 2026-08-07) the real overlap reached
         ELEVEN, and the failure rate tracked it almost perfectly:

             in flight   requests   failed   median
                 1-2        33       12.1%   17.6-27.4s
                 3-5        22       54.5%   27.1-52.4s
                 6+         16      100.0%   93.9-125.0s

         The mechanism is mechanical, not incidental: parallel pieces share one
         uplink, each gets ~1/N of it, so each takes ~N times longer -- and at
         ~125s the request is dead (see UP_ATTEMPT_MS). Piling retries on top of a
         saturated uplink is the worst available response. So: additive increase,
         multiplicative decrease. Start at 2, earn a third after two clean pieces,
         halve on any failure, and route retries through the SAME queue as fresh
         pieces so the window is a real cap. (Observational, not a controlled
         experiment -- retries also raise concurrency -- but the monotonic duration
         curve is bandwidth sharing, which cannot be an effect of failure.) */
      var inFlight = 0, dead = false;    // this stream's share, for the "nothing left" check
      var queue = [];                    // {idx, tries, readyAt} -- fresh AND retrying pieces
      for (var qi = 0; qi < total; qi++) { queue.push({ idx: qi, tries: 0, readyAt: 0 }); }
      // nudgeT: the pending "nothing left to do" decision (see decideSoon). Never
      // more than one, and every condition is re-tested when it fires.
      var pumpTimer = null, finalNudged = false, nudgeT = null;
      var pumping = false;               // pump() must never re-enter -- see the note on it
      var partSent = {};                 // idx -> bytes up so far, summed for the bar
      it.xhrs = [];
      it.chunkTotal = total;
      ctrace('chunk:begin', { total: total, size: it.file.size, cwnd: upWin.cwnd });
      function bumpProgress() {
        var s = 0; for (var k in partSent) s += partSent[k];
        it.sent = Math.min(it.size, s);
        ctx.paint(it);
      }
      function haveCount() { var n = 0; for (var g in it.got) n++; it.chunkDone = n; return n; }
      function chunkFail(msg, kind) {
        if (dead || !ctx.alive(it)) return;
        dead = true;
        unregisterPump();
        if (nudgeT) { clearTimeout(nudgeT); nudgeT = null; }   // no decision to make on a dead stream
        it.xhrs.forEach(function (x) { try { x.abort(); } catch (e) {} });
        it.failed = true;
        it.fatal  = true;    // a chunked stream: never fall back to a raw re-upload of the whole file
        ctx.paint(it);
        var have = haveCount();
        ctrace('chunk:fail', { msg: String(msg || '').slice(0, 120), have: have, total: total });
        if (ctx.blockMsg()) return;    // a permanent wall paints its own (better) notice
        if (kind === 'repick') { say(unreadableMsg(it.type), 'repick'); return; }   // the file itself is gone
        if (msg) { say(msg, 'retry'); return; }   // a specific reason (stale token) outranks any count

        /* NOTHING got through. Before blaming the connection, ask whether we can
           still READ the file -- because an unreadable File fails every send
           INSTANTLY and looks exactly like a dead network. Live 2026-08-07: a
           197 MB clip failed 0-of-32 three times in a row, each time within a
           second, always straight after the compressor threw NotFoundError on the
           same file, while OTHER clips in the same composer uploaded fine. */
        if (have === 0) {
          fileReadable(it.file).then(function (ok) {
            ctrace('chunk:zero', { readable: ok ? 1 : 0, total: total });
            say(ok
              ? 'That upload couldn’t get started, nothing reached us. Nothing you typed is lost.'
              : unreadableMsg(it.type),
              ok ? 'restart' : 'repick');
          });
          return;
        }
        say(upFailWords(have, total), 'retry');
      }
      /* Record the reason on the item and paint it. `kind` decides the button,
         because the verb has to match the situation: there is nothing to "resume"
         when nothing landed. */
      function say(human, kind) {
        it.failMsg = human;
        it.failKind = kind;
        ctx.warnOnce(human, 6000);
        ctx.note(human, kind);
      }
      function sendPiece(idx, tries) {
        if (dead || it.done || it.got[idx] || !ctx.alive(it)) return;
        var start = idx * CH;
        /* Reading the file can THROW outright, not just fail the send: Safari
           invalidates the File behind an <input> when the item moves, is renamed
           or gets offloaded, and slice()/read then raises NotFoundError. Until
           this catch existed the exception escaped pump(), the stream died with
           no failure event at all, and the member waited out the 180s stall bound
           only to be told his connection had dropped. Retrying cannot help -- the
           handle is gone -- so this is terminal and asks for a re-pick. */
        var piece;
        try {
          piece = it.file.slice(start, Math.min(start + CH, it.file.size));
        } catch (e) {
          ctrace('chunk:unreadable', { idx: idx, err: String((e && e.name) || e).slice(0, 60) });
          chunkFail('', 'repick');
          return;
        }
        var fd = new FormData();
        fd.append('upload_id', upId);
        fd.append('idx', String(idx));
        fd.append('total', String(total));
        fd.append('offset', String(start));
        fd.append('fsize', String(it.file.size));
        fd.append('chunk', piece, it.file.name);
        var xhr = new XMLHttpRequest();
        it.xhrs.push(xhr);
        inFlight++; upWinTake();
        xhr.open('POST', '/upload-chunk?ajax=1');
        xhr.setRequestHeader('X-CSRF-Token', csrf);
        xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        xhr.setRequestHeader('Accept', 'application/json');
        // One attempt has exactly one outcome. Without this guard the watchdog's
        // abort() would double-count inFlight against the onabort handler.
        var settled = false;
        function settle() { if (settled) return false; settled = true; w.stop(); inFlight--; upWinRelease(); return true; }
        var w = uploadWatch(xhr, function (why, secs) {
          if (!settle()) return;
          ctrace('chunk:dead', { idx: idx, why: why, secs: secs });   // stall / noresp / ceiling
          retryOrFail('', true);
        });
        if (xhr.upload) xhr.upload.onprogress = function (ev) {
          if (!ctx.alive(it)) return;
          w.move(ev.loaded, ev.total);       // liveness, even when the length isn't computable
          if (!ev.lengthComputable) return;
          partSent[idx] = ev.loaded; bumpProgress();
        };
        function retryOrFail(msg, retriable) {
          if (dead || !ctx.alive(it)) return;
          partSent[idx] = 0;
          upWinNarrow();                                 // the uplink just told us it is full
          var n = (tries || 0) + 1;
          if (!it.trouble) it.trouble = Date.now();      // cleared by the next piece that lands
          if (retriable && n < UP_TRIES && Date.now() - it.trouble < UP_GIVEUP_MS) {
            // Exponential backoff with jitter. Three retries 900 ms apart is three
            // retries into the same instant of the same outage; a flapping mobile
            // link needs seconds, not milliseconds, to come back. Back onto the
            // QUEUE, never straight into flight -- a retry that bypassed the window
            // is how eleven concurrent uploads happened.
            var wait = Math.min(16000, 1000 * Math.pow(2, n - 1)) + Math.floor(Math.random() * 500);
            ctrace('chunk:backoff', { idx: idx, n: n, ms: wait, cwnd: upWin.cwnd });
            queue.unshift({ idx: idx, tries: n, readyAt: Date.now() + wait });
            pump();
          } else {
            chunkFail(msg);
          }
        }
        xhr.onabort = function () { if (w.killed()) return; settle(); };   // watchdog aborts settle themselves
        xhr.onload = function () {
          if (!settle()) return;
          if (dead || it.done || !ctx.alive(it)) return;
          var res = null; try { res = JSON.parse(xhr.responseText); } catch (e) {}
          if (xhr.status === 200 && res && res.ok) {
            partSent[idx] = piece.size;
            it.got[idx] = true;              // confirmed on the server: never re-send these bytes
            it.trouble = 0;                  // ground gained: the give-up clock starts over
            upWinWiden();
            haveCount();                     // refresh it.chunkDone for the honest progress line
            if (res.token) {                 // server assembled the whole file
              it.token = res.token; it.done = true; it.sent = it.size; ctx.paint(it); ctx.persist();
              unregisterPump();
              ctrace('chunk:done', { idx: idx });
              return;
            }
            bumpProgress();
            pump();
          } else if (stageAuthBlock(xhr.status)) {
            // permanent: don't retry the piece, don't let Post fall back to a raw upload
            var cBlk = ctx.setBlock((res && res.error) || '', xhr.status);
            ctrace('chunk:block', { status: xhr.status, msg: String(cBlk).slice(0, 120) });
            chunkFail(cBlk);    // sees ctx.blockMsg() set, so it paints no second reason
          } else if (xhr.status === 419) {
            // stale CSRF: re-token ONCE and re-send this piece, then give up for real
            ctrace('chunk:csrf', { idx: idx, retried: it.reTokened ? 1 : 0 });
            if (it.reTokened) { chunkFail(stageCsrfMsg(it.type)); return; }
            it.reTokened = true;
            stageCsrfRefresh().then(function (fresh) {
              if (dead || it.done || !ctx.alive(it)) return;
              if (!fresh) { chunkFail(stageCsrfMsg(it.type)); return; }
              ctrace('chunk:csrfok', { idx: idx });
              queue.unshift({ idx: idx, tries: tries || 0, readyAt: 0 });
              pump();
            });
          } else {
            ctrace('chunk:retry', { idx: idx, status: xhr.status });
            // 422 (the server rejected the piece itself) and 413 (too big) mean the
            // same answer next time; everything else -- 408, 429, 5xx, a dropped
            // socket -- is worth another go. 401/402/403/419 never reach here.
            // '' -> chunkFail writes the human "N of M parts made it" line. Only a
            // real server sentence ("Too many uploads, take a breather.") is worth
            // showing; "Background upload failed (HTTP 500)" tells a member nothing.
            retryOrFail(res && res.error ? res.error : '',
                        xhr.status !== 422 && xhr.status !== 413);
          }
        };
        xhr.onerror = function () { if (!settle()) return; ctrace('chunk:neterr', { idx: idx }); retryOrFail('', true); };
        xhr.send(fd);
      }
      /* The ONE place a piece may enter flight. Everything -- first sends, retries,
         resumed streams -- goes through this queue, so `cwnd` is a real cap on the
         uplink rather than a suggestion. */
      /* RE-ENTRANCY IS THE WHOLE POINT OF `pumping`. xhr.send() of an UNREADABLE
         Blob dispatches onerror SYNCHRONOUSLY, so sendPiece() could return having
         already run settle() -> retryOrFail() -> queue.unshift() -> pump(). That
         inner pump() ran while this loop was mid-walk: it mutated `queue` under the
         index we were holding and saw inFlight back at zero, so it launched again,
         and again. Measured live 2026-08-07 07:04:48 -- all 32 pieces of a 197 MB
         file burned their entire retry ladder inside ONE SECOND, and the member was
         told his connection had dropped. It had not; the file was unreadable. */
      function pump() {
        if (dead || it.done || !ctx.alive(it)) return;
        if (pumping) return;                 // an outer pump() is walking the queue
        pumping = true;
        try {
          if (pumpTimer) { clearTimeout(pumpTimer); pumpTimer = null; }
          var now = Date.now(), soonest = 0, i5 = 0;
          while (i5 < queue.length) {
            if (dead || it.done) break;
            var job = queue[i5];
            if (it.got[job.idx]) { queue.splice(i5, 1); continue; }    // landed while it waited
            if (job.readyAt > now) {                                   // still serving its backoff
              if (!soonest || job.readyAt < soonest) soonest = job.readyAt;
              i5++; continue;
            }
            if (upWin.inFlight >= upWin.cwnd) { i5++; continue; }
            queue.splice(i5, 1);
            sendPiece(job.idx, job.tries);   // may complete synchronously; queue may have changed
            i5 = 0; now = Date.now();        // so restart the walk rather than trusting the index
          }
          if (queue.length && soonest && upWin.inFlight < upWin.cwnd) {
            pumpTimer = setTimeout(pump, Math.max(60, soonest - Date.now()));
          }
          if (!inFlight && !queue.length && !it.done) { decideSoon(); }
        } finally { pumping = false; }
      }
      /* ---- "NOTHING LEFT TO DO" IS DECIDED ON A LATER TURN, NEVER HERE --------
         pump() is re-entered SYNCHRONOUSLY from inside a response handler:
         xhr.onload's very first statement is settle(), and settle() ->
         upWinRelease() -> upWinKick() -> pump(). At that instant the response we
         are standing inside has NOT been read yet -- `res.token` is inspected
         further down the same onload -- so `it.done` is still false even for the
         piece that just came back carrying the claim token, while inFlight has
         already been decremented and the queue is empty.

         Acting on that snapshot was wrong twice over:

           1. It re-sent the last piece of EVERY completed chunked upload.
              Measured 2026-08-09: a 256,783,763-byte video is 41 pieces at
              UP_CHUNK_BYTES, yet produced 42 /upload-chunk requests, with
              `chunk:finalnudge` in compose-trace.jsonl on 4 of 4 completed runs.
              6 MB and a round trip wasted per video, on both call sites.
           2. Worse, once finalNudged was set the nudge's OWN successful response
              walked back through the identical window -- inFlight 0, queue empty,
              it.done not yet true, finalNudged already true -- and fell into
              chunkFail(), which would mark a finished upload dead and abort it.

         THE BRANCH ITSELF IS LOAD-BEARING AND STAYS. A genuinely resumed stream
         whose last piece was ACKed to a previous attempt has every index marked
         landed and no response left that can ever carry a token; without the
         nudge that upload never finishes. What changes is only WHEN we are
         allowed to believe the snapshot.

         One turn of the event loop is enough: by then onload has read res.token
         and set it.done. And the fix is deliberately not "reorder the statements
         in onload" -- everything is RE-CHECKED after the wait, so it stays correct
         however upWinKick happens to re-enter pump in future. */
      function decideSoon() {
        if (nudgeT) return;                                 // one pending decision at a time
        nudgeT = setTimeout(function () {
          nudgeT = null;
          if (dead || it.done || !ctx.alive(it)) return;     // it finished after all: nothing to decide
          if (inFlight || queue.length) { pump(); return; }  // work turned up meanwhile: carry on
          if (finalNudged) { chunkFail(''); return; }        // already nudged and still nothing: out of road
          // Every index is marked landed but no claim token came back, so the
          // finalizing piece never ran here (a resumed stream whose last piece was
          // ACKed to a previous attempt). Re-send the last piece ONCE to collect it.
          finalNudged = true;
          ctrace('chunk:finalnudge', { total: total });
          delete it.got[total - 1];
          queue.push({ idx: total - 1, tries: 0, readyAt: 0 });
          pump();
        }, 0);
      }
      // A slot freed by ANOTHER attachment's stream belongs to whoever can use it.
      if (it.pumpReg) { var pi = upWin.pumps.indexOf(it.pumpReg); if (pi >= 0) upWin.pumps.splice(pi, 1); }
      it.pumpReg = pump;
      upWin.pumps.push(pump);
      function unregisterPump() {
        var i6 = upWin.pumps.indexOf(pump);
        if (i6 >= 0) upWin.pumps.splice(i6, 1);
        if (it.pumpReg === pump) it.pumpReg = null;
      }
      /* Ask the server what it already holds BEFORE sending a byte. That is what
         turns "your upload failed, start again" into "send the one piece that's
         missing" -- and it works after a reload too, because upId is derived from
         the file itself. One tiny GET, capped at 6s so a dead link can't hold the
         upload hostage; if it doesn't answer we simply start from what we know. */
      function beginWith(have) {
        if (dead || !ctx.alive(it)) return;
        for (var i2 = 0; i2 < have.length && i2 < total; i2++) {
          if (have.charAt(i2) === '1') {
            it.got[i2] = true;
            partSent[i2] = Math.min(CH, Math.max(0, it.file.size - i2 * CH));
          }
        }
        var have0 = haveCount();
        if (have0) { ctrace('chunk:resume', { have: have0, total: total }); bumpProgress(); }
        pump();
      }
      var probe = new XMLHttpRequest(), probed = false;
      function probeDone(have, tok) {
        if (probed) return; probed = true;
        if (!ctx.alive(it)) return;
        if (tok) {   // this exact file already finished on an earlier attempt: zero bytes to send
          it.token = tok; it.done = true; it.sent = it.size; ctx.paint(it); ctx.persist();
          unregisterPump();
          ctrace('chunk:already', { total: total });
          return;
        }
        beginWith(have || '');
      }
      setTimeout(function () { if (!probed) { try { probe.abort(); } catch (e) {} probeDone('', ''); } }, 6000);
      probe.open('GET', '/upload-chunk-status?upload_id=' + encodeURIComponent(upId) + '&total=' + total);
      probe.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      probe.setRequestHeader('Accept', 'application/json');
      probe.onload = function () {
        var r = null; try { r = JSON.parse(probe.responseText); } catch (e) {}
        probeDone((r && r.have) || '', (r && r.token) || '');
      };
      probe.onerror = function () { probeDone('', ''); };
      probe.send();
    }
    // Optionally shrink a big video on-device first, THEN upload. Unsupported
    // browsers (notably iOS Safari) and any hiccup resolve to the original file
    // instantly, so this never blocks or breaks an upload, only speeds it when it can.
    /* No indeterminate sweep any more: the item's own bar carries compression
       as its first stretch (itemFrac), so there is one determinate bar for the
       whole job rather than a sweep that hands over to a fill. */
    ctrace('pick', { i: it.ix, size: src.size, type: src.type || '' });
    var willCompress = src.type.indexOf('video') === 0 && src.size >= COMPRESS_MIN_BYTES;
    if (willCompress) ctrace('compress:enter', { size: src.size, wc: vcSupported() ? 1 : 0 });
    maybeCompressVideo(src, it).then(function (useFile) {
      if (willCompress) ctrace('compress:exit', { orig: src.size, out: (useFile && useFile.size) || src.size, changed: useFile && useFile !== src ? 1 : 0 });
      if (!ctx.alive(it)) { ctrace('stage:abandoned', { i: it.ix }); return; }   // reset or removed mid-compress
      if (useFile && useFile !== src) {
        it.file = useFile; it.size = useFile.size || 1;
        /* THIS ENCODE'S OWN IDENTITY. These bytes were produced just now and are
           not reproducible: re-encoding the same source yields the same byte
           count with ~10% of the bytes different (measured -- see upStreamId()).
           So the chunk stream is named after THIS encode, which keeps a resume
           from ever splicing two of them together. Set only here, so anything the
           compressor passed through keeps its stable, file-derived id. */
        it.vcTag = 'vc' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
        ctx.adopted(it);
      }
      /* ---- THE SIZE CAP, APPLIED HERE AND ONLY HERE ------------------------
         This is the whole point of the reorder: the number being tested is
         it.file.size -- the COMPRESSED bytes, the ones that are about to cross
         the wire -- and not file.size, the thing the member picked. A 5 GB
         master that compresses to ~300 MB passes this line without noticing it.

         It still catches the case that genuinely cannot be sent: compression
         FAILS OPEN (unsupported browser, undecodable codec, a source that went
         away, an output that came out no smaller), and when it does, it.file is
         still the original. A 5 GB original cannot go up a transport whose
         server-side ceiling is Upload::CHUNK_MAX_TOTAL, so it is refused -- but
         refused HERE, having actually tried, with copy that names the reason and
         says what to do rather than the old flat "over the 4 GB limit". */
      if (it.type === 'video' && it.file.size > UP_POST_VID_MAX) {
        var shrank = it.file !== src;
        ctrace('stage:toobig', { orig: src.size, out: it.file.size, shrank: shrank ? 1 : 0 });
        it.failed = true; it.tries = 2;
        /* `fatal` IS LOAD-BEARING, not decoration. Without it this item is merely
           `failed`, and a merely-failed item makes submit() set useStaged = false
           (:8315) and fall back to posting the RAW file inline through /compose --
           which for the case we are standing in means pushing multiple GB into a
           form POST that IIS refuses at 560 MB and PHP refuses at
           upload_max_filesize=200M. The fallback exists for a hiccup on a small
           file; for a file that is too big BY DEFINITION it is a guaranteed, slow,
           confusing failure. `fatal` is the flag :8303 reads to refuse the
           fallback and show the reason instead, and it is exactly what the chunked
           path sets for the same reason. */
        it.fatal = true;
        it.failMsg = shrank
          ? ('Even after shrinking, that video is ' + upSizeWords(it.file.size) + ', still too big to send. Try posting it in shorter pieces.')
          : ('That video is ' + upSizeWords(it.file.size) + ' and this browser couldn’t shrink it. Try again in Safari or Chrome, or export it at 1080p.');
        it.failKind = 'repick';
        ctx.paint(it);
        ctx.warnOnce(it.failMsg, 7000);
        /* Same two-part telling as the chunked path's say(): a toast the member
           may be looking away from, PLUS a note that stays in the composer and
           carries the "Choose the video again" button. `repick` is the right
           verb here -- there is nothing to resume, and no it.retry is ever
           attached to this item, so re-picking is genuinely the only way on. */
        ctx.note(it.failMsg, 'repick');
        return;
      }
      /* THE TEST IS THE SIZE, AND ONLY THE SIZE (2026-09-19).
         It used to also require `type.indexOf('video') === 0`, which left the 2026-09-14 ceiling
         fix half-applied: UP_CHUNK_AFTER exists because a single POST /upload-stage gets
         UP_ATTEMPT_MS (150s) of wall clock WHATEVER it carries, and a failed single shot restarts
         from byte 0 because resume lives only on the chunked path. None of that reasoning is about
         video. A photo may be up to UP_IMG_MAX (25 MB), so a 25 MB photo demanded ~170 KB/s of
         sustained phone uplink or it died with everything thrown away -- the exact failure the
         threshold was lowered 24 -> 8 MB to stop. Measured before this change: a 9.55 MB JPEG took
         /upload-stage, one shot, no resume.
         THE SERVER HAS ALWAYS BEEN READY FOR IT. Upload::finishChunked() sniffs the assembled file
         and takes the image branch (MAX_IMG, then finalizeStagedImage -- grid thumb, display
         variant, R2 mirror), and lib/upload.php's own comment there says the image branch was
         closed off "so that stays a fact about the client rather than something the server is
         relying on". This is the client catching up. */
      var mode = (it.file.size > UP_CHUNK_AFTER) ? 'chunk' : 'single';
      ctrace('route', { mode: mode, size: it.file.size, type: it.file.type || '' });
      // How to have another go at THIS item, kept on the item so the composer's
      // "Resume upload" button can reach it. For a chunked stream this is a real
      // resume: upId and it.got survive, so only the missing pieces travel.
      it.retry = (mode === 'chunk') ? chunkGo : function () { it.tries = 0; it.sent = 0; stageReg(); attempt(); };
      if (mode === 'chunk') { chunkGo(); } else { stageReg(); attempt(); }
    });
  }

  function stageStart(files, thumbs) {
    var mySeq = stageMedia.seq;
    var warned = false;
    ctraceNew();
    /* THIS IS A BACKSTOP, NOT THE CAP. The caller (the picker's change handler) is the one place
       that decides how many items fit, because it is the only place that also knows how many are
       already attached -- a cap applied here can only see the batch, so "five attached plus six
       new" is invisible to it. It stays because an uncapped stageStart is one careless future
       caller away from a 200-item upload, but it must never be able to disagree with the picker
       silently: it asks the SAME mediaMax() and, if it ever does have to cut, it SAYS SO. Before
       2026-08-07 this line read `slice.call(files, 0, 10)` against a picker that allowed 20, and
       the difference vanished without a word. If this toast is ever seen, the caller is broken. */
    var cap = mediaMax();
    var all = Array.prototype.slice.call(files);
    if (all.length > cap) {
      ctrace('stageStart:overcap', { got: all.length, cap: cap });
      toast('Only ' + cap + ' can go on one post, so the rest weren’t added.');
      all = all.slice(0, cap);
    }
    ctrace('stageStart', { files: all.length, cap: cap });
    /* ---- THE COMPOSER'S HALF OF THE ENGINE ---------------------------------
       upDrive() owns the transport and nothing else; this is every place the
       composer differs from the post editor, in one object rather than smeared
       through six hundred lines. `warned` is closed over deliberately: it is
       per pick BATCH, so twelve files that all fail say one sentence, not twelve.
       See peCtx (the post editor) for the counterpart -- if you are adding a hook
       here, that one needs an answer for it too. */
    var ctx = {
      alive: function (x) { return stageMedia.seq === mySeq && stageMedia.items.indexOf(x) >= 0; },
      paint: stagePaint,
      persist: draftSaveMedia,
      // keep the input's FileList mirroring the bytes we will actually send, so the
      // raw fallback posts what the thumbnails show
      adopted: function () { if (typeof syncInputFiles === 'function') { try { syncInputFiles(); } catch (e) {} } },
      blockMsg: function () { return stageMedia.block; },
      setBlock: function (msg, status) {
        stageMedia.block = msg || stageMedia.block || 'Please verify your email to post.';
        stageMedia.blockStatus = status;
        stageBlockNote();                    // persistent notice in the composer, not just the toast
        return stageMedia.block;
      },
      warnOnce: function (msg, ms) { if (warned) return; warned = true; toast(msg, ms); },
      note: function (msg) { stageFailNote(msg); }
    };
    all.forEach(function (file, i) {
      /* PICK-TIME REFUSAL, and it is now deliberately almost unreachable for video.
         A video only fails here if it is past UP_PICK_VID_MAX, i.e. bigger than
         compressing could sensibly rescue -- everything else goes to the compressor
         first and is judged on the bytes it PRODUCES, at the UP_POST_VID_MAX check
         at the end of the compress step below. Images keep the old immediate
         refusal because nothing downstream can shrink them.

         `fatal` here is a fix, not a copy of the old line: this branch has always
         pushed an item that was `failed` but not `fatal`, which means submit()
         (:8303 reads fatal, :8315 reads stageFailed) fell through to the inline
         raw-file fallback and tried to POST the whole rejected file through
         /compose. That was already wrong at the old 4 GB threshold; at 16 GB it
         would be a browser pushing sixteen gigabytes into a request IIS rejects at
         560 MB. Refusing a file and then uploading it anyway is not a fallback. */
      var isVid = file.type.indexOf('video') === 0;
      if (file.size > (isVid ? UP_PICK_VID_MAX : UP_IMG_MAX)) {
        if (thumbs[i]) thumbs[i].classList.add('up-fail');
        ctrace('pick:refused', { size: file.size, vid: isVid ? 1 : 0 });
        var refuseMsg = isVid
          ? (upSizeWords(file.size) + ' is more than we can process in the browser. Export it at a smaller size (1080p is plenty) and try again.')
          : (file.name + ' is ' + Math.round(file.size / 1048576) + ' MB, over the 25 MB photo limit.');
        toast(refuseMsg, 7000);
        stageMedia.items.push({ file: file, token: null, sent: 0, size: file.size || 1, done: false,
                                failed: true, fatal: true, failMsg: refuseMsg, failKind: 'repick',
                                tries: 2, thumb: thumbs[i] });
        return;
      }
      // ix: the pick index, carried on the item so the engine's trace events can name
      // which file they are about without closing over the loop variable.
      var it = { file: file, type: file.type.indexOf('video') === 0 ? 'video' : 'image', token: null, sent: 0, size: file.size || 1, done: false, failed: false, tries: 0, thumb: thumbs[i], ix: i };
      stageMedia.items.push(it);
      upDrive(it, ctx);
    });
  }

  /* The chunked upload engine, for surfaces that are not in this file.
     /admin/create is the only one today; see the note above upDrive(). Exported,
     not duplicated, so the shared congestion window (upWin) stays shared -- a
     second copy of this engine would be a second window, which is the exact bug
     the 2026-08-07 fix removed. */
  window.__rovaUpDrive = upDrive;

  /* Is any upload traffic in flight or still owed slots? Read by the
     stale-bundle self-refresh at the bottom of this file, which must never
     reload the page mid-upload. inFlight counts XHRs actually on the wire;
     pumps holds every registered stream still waiting for window slots
     (a chunked video between pieces, a staged photo batch), so the gap
     between two chunks does not read as "idle". Both empty out when the
     work lands or dies, so this can never wedge the refresh forever. */
  window.__rovaUpBusy = function () {
    return upWin.inFlight > 0 || upWin.pumps.length > 0;
  };

  /* ======================================================================
     ON-DEVICE VIDEO COMPRESSION (before upload)

     Modern phones shoot far more bitrate than a social feed needs: the owner's
     own sources measure 3840x2160 HEVC at ~61 Mbps, so 31 seconds is 225 MB and
     a longer clip is 900 MB+. Shrinking on-device means far fewer bytes cross
     the uplink AND the origin takes its cheap stream-copy path instead of a
     full re-encode (lib/videojobs.php isWebReady() -> remux()).

     TWO IMPLEMENTATIONS, in strict preference order:

     1. WEBCODECS (assets/vcompress.js, lazy). VideoDecoder -> scale -> H.264
        VideoEncoder, demuxed and muxed by mediabunny, in a Worker. Hardware
        backed, does not need playback, does not care whether the tab is
        foregrounded, and IS implemented in Safari -- which is the whole point.

     2. The old MediaRecorder path, below, kept ONLY for browsers with no
        WebCodecs. It could never run in iOS Safari at all: canCompressVideo()
        requires HTMLMediaElement.prototype.captureStream, which WebKit does not
        implement, so on the owner's own phone maybeCompressVideo() hit that
        guard and resolved the original in the same millisecond -- the
        same-second `compress:exit changed:0` on a 905 MB file in compose-trace.
        It is also playback-driven (~1x realtime at best), stalls when the tab is
        backgrounded, and emits WebM/VP9 in Chromium, which the server must then
        transcode anyway.

     Both fail OPEN: any unsupported browser, any error, or a result that is not
     clearly smaller resolves the ORIGINAL file. The difference from before is
     that every one of those outcomes now emits a trace event with a reason. A
     silent no-op is what hid this for weeks.
     ====================================================================== */
  var COMPRESS_MIN_BYTES = 40 * 1024 * 1024;   // only bother past ~40 MB

  /* ---- 1. WebCodecs ---------------------------------------------------- */
  /* Content hash, NOT a hand-picked number: /assets/* caches for a week, and
     tools/build-vcompress.mjs exits 3 if this token does not match the bytes it
     just wrote, so new code can never ship under a stale URL. */
  var VCOMPRESS_JS = '/assets/vcompress.js?v=2713758f1e';
  /* Liveness, not wall-clock. A 900 MB 4K source legitimately takes minutes, so
     a total deadline would kill work that was going to succeed. These bound
     SILENCE instead: how long we will wait for the first word, and how long a
     started encode may go without reporting progress. Either one expiring falls
     back to uploading the original -- never a frozen composer. */
  var VC_FIRST_MS = 60000;    // pick -> the worker's first word (demux + a moov parse on a 4 GB file)
  var VC_STALL_MS = 90000;    // 'plan' -> first progress (decoder/encoder setup)
  var VC_TICK_MS  = 45000;    // between progress ticks; they arrive ~4x/sec while alive.
                              /* 45s matches UP_STALL_MS above, for the same reason: it is
                                 far beyond any legitimate gap, and it is the only thing
                                 that recovers a worker killed by the OS for memory --
                                 that death is silent, with no 'error' event to catch. */
  /* ONE at a time. Two concurrent 4K decode+encode pipelines on a phone is the
     shortest path to an OOM, and they would only share the same silicon anyway. */
  var vcChain = Promise.resolve();

  function vcSupported() {
    return typeof VideoEncoder !== 'undefined' && typeof VideoDecoder !== 'undefined'
      && typeof WritableStream !== 'undefined' && typeof Blob !== 'undefined';
  }

  /* NO DEDICATED UI. Owner, 2026-08-07: "No need to show the user shrinking the
     video so it uploads faster panel." Compression is mechanism; the member cares
     that the post is going out. So there is no panel, no "optimising" copy, and
     no Skip button -- compression is just the first stretch of the ordinary
     upload bar (see VC_BAR_SHARE / itemFrac above), which keeps moving the whole
     time. What the panel used to carry is not lost, only relocated:
       - the Skip button  -> removing the attachment cancels the encode
                             (it.vcCancel, wired into the thumb X and stageReset)
       - the "why is this slow" answer -> the bar is moving, which is the answer
       - the diagnostics  -> the vc:* trace events, which are not UI and stay. */
  function vcProgress(it, p) {
    if (!it) { return; }
    it.vcP = p;
    stagePaint(it);
  }

  /* Main-thread fallback, used only if a Worker cannot be constructed. The
     bundle is built to run in either context and publishes window.RovaVCompress
     when it is loaded as a classic script. */
  function vcLoadScript(cb) {
    if (window.RovaVCompress) { cb(window.RovaVCompress); return; }
    if (vcLoadScript._q) { vcLoadScript._q.push(cb); return; }
    vcLoadScript._q = [cb];
    var s = document.createElement('script');
    s.src = VCOMPRESS_JS; s.async = true;
    s.onload  = function () { var q = vcLoadScript._q; vcLoadScript._q = null; q.forEach(function (f) { f(window.RovaVCompress || null); }); };
    s.onerror = function () { var q = vcLoadScript._q; vcLoadScript._q = null; q.forEach(function (f) { f(null); }); };
    document.head.appendChild(s);
  }

  function vcRun(file, it) {
    var start = function () {
      return new Promise(function (resolve) {
        /* The item may already be gone (removed while this job waited its turn in
           vcChain) -- don't start a 4K encode for a thumbnail that isn't there. */
        if (it && stageMedia.items.indexOf(it) < 0) { return resolve(file); }
        var settled = false, worker = null, timer = null, t0 = Date.now(), onMain = false, mainAbort = null, hi = false;

        function finish(useFile, why, extra) {
          if (settled) return;
          settled = true;
          clearTimeout(timer);
          /* terminate() is the cancel: it kills the decoder, the encoder and
             every VideoFrame they hold in one call, with no cooperation needed
             from a pipeline that may be deep inside a hardware codec. It is also
             the ONLY cancel now that the Skip button is gone, so it has to be
             reachable from the thumbnail X and from stageReset -- both call
             it.vcCancel, which is this. */
          if (worker) { try { worker.terminate(); } catch (e) {} worker = null; }
          if (mainAbort) { try { mainAbort.abort(); } catch (e) {} mainAbort = null; }
          if (it) {
            /* Freeze the bar credit already earned instead of dropping it: the
               upload term now has to fill the REST, so the bar can only go
               forwards. Crediting the full share for a job that skipped at 2%
               would be a lie; dropping it to zero would rewind the bar. */
            it.vcShare = (it.vcShare || 0) * (useFile ? 1 : Math.min(1, it.vcP || 0));
            it.vcP = 1;
            it.vcCancel = null;
            stagePaint(it);
          }
          var d = extra || {};
          d.why = why; d.ms = d.ms || (Date.now() - t0);
          ctrace(useFile ? 'vc:done' : 'vc:skip', d);
          resolve(useFile || file);
        }
        function arm(ms) { clearTimeout(timer); timer = setTimeout(function () { finish(null, 'silent-' + Math.round(ms / 1000) + 's'); }, ms); }

        function onMsg(m) {
          if (settled || !m) return;
          /* the member deleted the thumbnail (or reset the composer) while we
             were encoding: stop burning the battery on bytes nobody will send */
          if (it && stageMedia.items.indexOf(it) < 0 && m.t !== 'skip' && m.t !== 'done') { finish(null, 'removed'); return; }
          if (m.t === 'ready')    { hi = true; arm(VC_FIRST_MS); return; }
          if (m.t === 'plan') {
            arm(VC_STALL_MS);
            ctrace('vc:plan', m.info || {});
            /* Only NOW do we know this item is really being compressed, so only
               now does its bar get a compression stretch. Images, passthrough
               videos and unsupported browsers never reach here and keep a bar
               that is 100% upload, exactly as before. */
            if (it) { it.vcShare = VC_BAR_SHARE; }
            vcProgress(it, 0);
            return;
          }
          if (m.t === 'progress') { arm(VC_TICK_MS); vcProgress(it, m.p || 0); return; }
          if (m.t === 'skip') {
            /* The worker says this context has no WebCodecs but the WINDOW does.
               That combination is the one thing about Safari I could not test on
               this box (Playwright's headless WebKit ships NO WebCodecs at all,
               in either context, so it cannot answer the question). Rather than
               leave a whole browser silently uncompressed on an untested
               assumption, retry on the main thread -- slower and it does jank
               the composer, but a 900 MB upload is worse. */
            if (m.why === 'no-webcodecs' && !onMain && typeof VideoEncoder !== 'undefined') {
              onMain = true;
              if (worker) { try { worker.terminate(); } catch (e) {} worker = null; }
              ctrace('vc:mainthread', {});
              arm(VC_FIRST_MS);
              vcLoadScript(function (lib) {
                if (settled) return;
                if (!lib || !lib.go) { finish(null, 'no-lib'); return; }
                /* On the main thread there is no terminate(), so cancel has to be
                   cooperative or a skipped encode keeps running on the UI thread. */
                try { mainAbort = new AbortController(); } catch (e) { mainAbort = null; }
                try { lib.go(file, onMsg, mainAbort ? { signal: mainAbort.signal } : {}); }
                catch (e2) { finish(null, 'lib-throw'); }
              });
              return;
            }
            finish(null, m.why || 'skip', { orig: file.size, out: m.out || 0 });
            return;
          }
          if (m.t === 'done') {
            var name = (file.name || 'video').replace(/\.[^.]+$/, '') + '.mp4';
            var out = null;
            /* Carry the ORIGINAL's lastModified, never Date.now(): upStreamId()
               hashes name|size|lastModified, so a wall-clock stamp would give the
               same file a different stream id on every pick and silently destroy
               the resume-after-reload property the transport just gained. */
            try { out = new File([m.blob], name, { type: 'video/mp4', lastModified: file.lastModified || 0 }); }
            catch (e) { finish(null, 'file-ctor'); return; }
            finish(out, 'ok', { orig: file.size, out: m.out, enc: m.ms });
          }
        }

        /* The cancel handle. With the Skip button gone this is reached from the
           thumbnail's X and from stageReset -- removing the attachment (or the
           post landing) must stop a 4K encode immediately, or it keeps a decoder,
           an encoder and their VideoFrames alive for minutes on a phone. */
        if (it) { it.vcCancel = function () { finish(null, 'removed'); }; }
        arm(VC_FIRST_MS);
        try {
          worker = new Worker(VCOMPRESS_JS);
          worker.onmessage = function (ev) { onMsg(ev.data); };
          /* A worker whose SCRIPT failed to load fires an ErrorEvent with an empty
             message, which is indistinguishable from a runtime throw unless you
             remember whether it ever said hello. 'worker-load' means the bundle
             404'd / was blocked; 'worker-err' means it ran and then broke. */
          worker.onerror   = function (ev) {
            finish(null, (hi ? 'worker-err:' : 'worker-load:') + ((ev && ev.message) || '').slice(0, 60));
          };
          worker.postMessage({ cmd: 'go', file: file });
        } catch (e) {
          worker = null;
          vcLoadScript(function (lib) {
            if (settled) return;
            if (!lib || !lib.go) { finish(null, 'no-lib'); return; }
            arm(VC_FIRST_MS);
            try { lib.go(file, onMsg); } catch (e2) { finish(null, 'lib-throw'); }
          });
        }
      });
    };
    vcChain = vcChain.then(start, start);
    return vcChain;
  }

  function maybeCompressVideo(file, it) {
    if (!file || (file.type || '').indexOf('video') !== 0 || file.size < COMPRESS_MIN_BYTES) {
      return Promise.resolve(file);
    }
    if (vcSupported()) { return vcRun(file, it); }
    return legacyCompressVideo(file);
  }

  /* ---- 2. legacy MediaRecorder path (no WebCodecs only) ----------------- */
  function canCompressVideo() {
    return typeof MediaRecorder !== 'undefined'
      && !!HTMLCanvasElement.prototype.captureStream
      && !!HTMLMediaElement.prototype.captureStream
      && !!(window.AudioContext || window.webkitAudioContext);
  }
  // Compression trades real (roughly realtime) encode time for a smaller upload.
  // That's a clear win on slow links and a net LOSS on fast ones (the encode
  // costs more wall-clock than the bytes it saves). Use the Network Information
  // API to decide; where it's absent (Safari, Firefox) we keep the default and
  // compress, matching prior behavior.
  function connectionFavorsCompression() {
    var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (!c) return true;                       // no signal: keep default (compress)
    if (c.saveData) return true;               // Data Saver on: definitely compress
    var et = c.effectiveType || '4g';
    if (et !== '4g') return true;              // 3g / 2g / slow-2g: smaller upload clearly wins
    // '4g' spans mediocre LTE to gigabit wifi; only skip when genuinely fast
    if (typeof c.downlink === 'number' && c.downlink > 0 && c.downlink < 4) return true;
    return false;                              // fast connection: raw upload is quicker
  }
  function pickRecorderMime() {
    var want = ['video/mp4;codecs=h264,aac', 'video/mp4', 'video/webm;codecs=vp9,opus', 'video/webm;codecs=vp8,opus', 'video/webm'];
    for (var i = 0; i < want.length; i++) { try { if (MediaRecorder.isTypeSupported(want[i])) return want[i]; } catch (e) {} }
    return '';
  }
  function legacyCompressVideo(file) {
    return new Promise(function (resolve) {
      if (!file || (file.type || '').indexOf('video') !== 0 || file.size < COMPRESS_MIN_BYTES
          || !canCompressVideo() || !connectionFavorsCompression()) {
        return resolve(file);
      }
      var mime = pickRecorderMime();
      if (!mime) return resolve(file);
      var done = false, cleanup = function () {}, guard;
      function finish(result) {
        if (done) return; done = true;
        clearTimeout(guard);
        try { cleanup(); } catch (e) {}
        resolve(result || file);
      }
      var video = document.createElement('video');
      video.muted = false; video.preload = 'auto'; video.setAttribute('playsinline', '');
      var url = URL.createObjectURL(file);
      video.src = url;
      guard = setTimeout(function () { finish(file); }, 5000);   // until we know the duration
      video.onerror = function () { finish(file); };
      video.onloadedmetadata = function () {
        var vw = video.videoWidth, vh = video.videoHeight, dur = video.duration || 0;
        if (!vw || !vh || !dur || dur > 600) { return finish(file); }   // unknown / very long: leave it
        var scale = Math.min(1, 1280 / vw, 1280 / vh);
        if (scale >= 0.99 && (file.size / dur) < 1.2 * 1024 * 1024) { return finish(file); }   // already lean
        var tw = Math.max(2, Math.round(vw * scale / 2) * 2), th = Math.max(2, Math.round(vh * scale / 2) * 2);
        clearTimeout(guard);
        guard = setTimeout(function () { finish(file); }, dur * 1000 * 1.7 + 9000);   // realtime encode + slack
        var canvas = document.createElement('canvas'); canvas.width = tw; canvas.height = th;
        var ctx = canvas.getContext('2d', { alpha: false });
        var stream, ac, recorder, chunks = [], raf = 0;
        try {
          stream = canvas.captureStream(30);
          ac = new (window.AudioContext || window.webkitAudioContext)();
          var destNode = ac.createMediaStreamDestination();
          ac.createMediaElementSource(video).connect(destNode);   // capture audio, NOT to speakers
          var atrack = destNode.stream.getAudioTracks()[0];
          if (atrack) stream.addTrack(atrack);
          var kbps = Math.min(4500, Math.max(1500, Math.round((tw * th) / 300)));
          recorder = new MediaRecorder(stream, { mimeType: mime, videoBitsPerSecond: kbps * 1000, audioBitsPerSecond: 96000 });
        } catch (e) { return finish(file); }
        cleanup = function () {
          try { cancelAnimationFrame(raf); } catch (e) {}
          try { if (recorder && recorder.state !== 'inactive') recorder.stop(); } catch (e) {}
          try { video.pause(); } catch (e) {}
          try { if (ac && ac.state !== 'closed') ac.close(); } catch (e) {}
          try { URL.revokeObjectURL(url); } catch (e) {}
        };
        recorder.ondataavailable = function (ev) { if (ev.data && ev.data.size) chunks.push(ev.data); };
        recorder.onstop = function () {
          try {
            var out = new Blob(chunks, { type: mime.split(';')[0] });
            if (!out.size || out.size >= file.size * 0.9) { return finish(file); }   // not worth it
            var ext = mime.indexOf('mp4') >= 0 ? 'mp4' : 'webm';
            var name = (file.name || 'video').replace(/\.[^.]+$/, '') + '.' + ext;
            finish(new File([out], name, { type: out.type, lastModified: file.lastModified || 0 }));
          } catch (e) { finish(file); }
        };
        recorder.onerror = function () { finish(file); };
        function draw() { if (done) return; try { ctx.drawImage(video, 0, 0, tw, th); } catch (e) {} raf = requestAnimationFrame(draw); }
        video.onended = function () { try { cancelAnimationFrame(raf); } catch (e) {} setTimeout(function () { try { recorder.stop(); } catch (e) { finish(file); } }, 80); };
        try { recorder.start(1000); } catch (e) { return finish(file); }
        draw();
        var p = video.play();
        if (p && p.catch) p.catch(function () { finish(file); });   // autoplay blocked -> original
      };
    });
  }
  /* The composer-wide number behind the "Posting..." overlay. Weighted by BYTES,
     as before, but each item's share now comes from itemFrac(), so an item that
     is still being compressed on-device contributes real movement instead of a
     flat zero. Without this the overlay sits at 0% for the whole encode -- the
     exact frozen-spinner failure this pipeline has already been through once. */
  function stageProgress() {
    var total = 0, got = 0;
    stageMedia.items.forEach(function (it) { total += it.size; got += it.size * itemFrac(it); });
    return total > 0 ? Math.min(1, got / total) : 1;
  }
  /* Honest progress. "Uploading 1%" for an hour is not feedback; a big clip travels
     as a countable number of parts and the member should see them land. Returns
     e.g. "part 12 of 100" for a chunked item, '' when there is nothing to count. */
  function stagePartsLabel() {
    var it = null;
    stageMedia.items.forEach(function (x) { if (!it && x.chunkTotal > 1 && !x.done) it = x; });
    if (!it) return '';
    return 'part ' + Math.min(it.chunkTotal, (it.chunkDone || 0) + 1) + ' of ' + it.chunkTotal;
  }
  function stageSettled() { return stageMedia.items.every(function (it) { return it.done || it.failed; }); }
  function stageFailed() { return stageMedia.items.some(function (it) { return it.failed; }); }

  // Settings: live label for the per-category content-filter sliders (1 strict .. 6 Off).
  (function () {
    var NAMES = { '1': 'Very strict', '2': 'Strict', '3': 'Moderate', '4': 'Standard', '5': 'Lenient', '6': 'Off' };
    document.addEventListener('input', function (e) {
      var s = e.target;
      if (!s || !s.classList || !s.classList.contains('nsfw-slider')) return;
      var lbl = s.parentNode && s.parentNode.querySelector('.nsfw-lvl');
      if (lbl) { lbl.textContent = NAMES[s.value] || 'Off'; }
    });
  })();

  /* ---- settings: profile links editor (up to 5, Instagram-style, reorderable) ----
     ORDER IS THE STORED ORDER: the form posts parallel link_url[]/link_label[] arrays
     and Users::updateProfile writes them in that order, mirroring links[0] into
     users.website. So reordering is purely a DOM move of the .link-row element, which
     carries BOTH of its inputs with it -- a URL can never arrive under someone else's
     label. Nothing here saves; the settings form is one plain POST on Save and the
     order rides along with every other field. Do not add an immediate-save path for
     this one control: two save models on one form is its own bug.
     The move buttons are real <button>s on purpose. Drag was the obvious first idea and
     is the wrong only-path: it is unreachable by keyboard and, inside a long scrolling
     settings form on a phone, a drag fights the scroll. */
  (function () {
    var box = document.getElementById('link-rows');
    var add = document.getElementById('link-add');
    if (!box || !add) return;
    var max  = parseInt(add.getAttribute('data-max'), 10) || 5;
    var live = document.getElementById('link-live');
    function rows() { return Array.prototype.slice.call(box.querySelectorAll('.link-row')); }

    /* Renumber, rename and re-gate after every add / remove / move / typed URL. The
       "Main" tag rides the first row that actually HAS a url, so a blank row parked on
       top never claims to be the link the profile leads with (blank rows are dropped by
       Users::normalizeLinks on save). Returns that row's index, or -1. */
    function refresh() {
      var all = rows(), primary = -1;
      all.forEach(function (r, i) {
        var u = r.querySelector('.link-url');
        if (primary < 0 && u && u.value.trim() !== '') { primary = i; }
      });
      all.forEach(function (r, i) {
        var n   = i + 1;
        var pos = r.querySelector('.link-pos');
        var tag = r.querySelector('.link-main');
        var up  = r.querySelector('.link-move[data-dir="up"]');
        var dn  = r.querySelector('.link-move[data-dir="down"]');
        var x   = r.querySelector('.link-row-x');
        if (pos) { pos.textContent = 'Link ' + n; }
        if (tag) { tag.hidden = i !== primary; }
        if (up)  { up.disabled = i === 0;              up.setAttribute('aria-label', 'Move link ' + n + ' up'); }
        if (dn)  { dn.disabled = i === all.length - 1; dn.setAttribute('aria-label', 'Move link ' + n + ' down'); }
        if (x)   { x.setAttribute('aria-label', 'Remove link ' + n); }
      });
      add.hidden = all.length >= max;
      return primary;
    }

    add.addEventListener('click', function () {
      var all = rows();
      if (all.length >= max) return;
      var r = all[0].cloneNode(true);
      Array.prototype.forEach.call(r.querySelectorAll('input'), function (i) { i.value = ''; });
      box.appendChild(r);
      refresh();                                   // the clone carries row 1's numbering + gates
      var first = r.querySelector('input');
      if (first) first.focus();
    });

    box.addEventListener('click', function (e) {
      var mv = e.target.closest ? e.target.closest('.link-move') : null;
      if (mv) {
        if (mv.disabled) return;
        var row = mv.closest('.link-row');
        var up  = mv.getAttribute('data-dir') === 'up';
        var sib = up ? row.previousElementSibling : row.nextElementSibling;
        if (!sib) return;
        if (up) { box.insertBefore(row, sib); } else { box.insertBefore(sib, row); }
        var primary = refresh();
        // re-parenting the row drops focus. Put it back on the button that was pressed,
        // or on its partner when the move ran the row into an end of the list and
        // disabled it -- a disabled button cannot hold focus, and losing focus to the
        // document is exactly what makes a keyboard reorder unusable.
        var back = mv.disabled ? row.querySelector('.link-move:not([disabled])') : mv;
        if (back) back.focus();
        var all = rows(), at = all.indexOf(row) + 1;
        if (live) {
          live.textContent = 'Link ' + at + ' of ' + all.length + '.'
            + (primary === at - 1 ? ' This is now your main link.' : '');
        }
        return;
      }
      var x = e.target.closest ? e.target.closest('.link-row-x') : null;
      if (!x) return;
      var list = rows();
      if (list.length === 1) {   // last row stays as the empty "type here" row
        Array.prototype.forEach.call(list[0].querySelectorAll('input'), function (i) { i.value = ''; });
      } else {
        x.closest('.link-row').remove();
      }
      refresh();
    });

    // typing into (or clearing) a url can move which row is Main
    box.addEventListener('input', function (e) {
      var t = e.target;
      if (t && t.classList && t.classList.contains('link-url')) { refresh(); }
    });

    refresh();
  })();

  var composeFile = document.getElementById('compose-file');
  if (composeFile) {
    // keep the input's FileList mirroring everything attached, so the raw
    // fallback path always posts exactly what the thumbnails show
    var syncInputFiles = function () {
      try {
        var dt = new DataTransfer();
        stageMedia.items.forEach(function (it) { if (it.file) dt.items.add(it.file); });   // restored items have no File, only a token
        composeFile.files = dt.files;
      } catch (e) { /* ancient browsers: staging still holds the truth */ }
    };
    /* "Keep this off my profile grid" (migration 0119) rides the media preview: the profile grid is a
       media grid, so the option only means anything once something is attached. Reads the DOM rather
       than a captured variable so it can be called from any of the three places that open or close the
       preview strip (picker change, draft restore, last thumb removed). Unchecks itself on the way out
       so a cleared composer can't post a flag the member can no longer see. */
    function syncGridHideRow() {
      var pv  = document.getElementById('compose-preview');
      if (!pv) return;
      var on = !pv.hidden && !!pv.querySelector('.thumb');
      /* "made with AI" (db/0175) rides the media preview on exactly the same terms as the
         grid-hide row and for the same reason -- the mark rides a picture, so the question only
         means anything once something is attached, and a checked box the member can no longer see
         would silently put an AI ribbon on their next post. */
      ['compose-gridhide', 'compose-ai'].forEach(function (id) {
        var row = document.getElementById(id);
        if (!row) return;
        row.hidden = !on;
        if (!on) { var cb = row.querySelector('input[type="checkbox"]'); if (cb) cb.checked = false; }
      });
    }

    composeFile.addEventListener('change', function () {
      var box = document.getElementById('compose-preview');
      if (!box) return;
      box.classList.add('strip');
      // ADDITIVE: a second trip to the picker appends, never replaces
      var picked = Array.prototype.slice.call(composeFile.files || []);
      if (!picked.length) { syncInputFiles(); return; }        // picker canceled: keep what we had
      /* THE ONE PLACE THE CAP IS APPLIED, and it does not own the number -- mediaMax() reads it
         from the server that enforces it (Upload::MAX_FILES via data-max). This block used to
         declare `var MEDIA_MAX = 20` and assert that "the server never enforced 10", which was
         simply untrue: handle_compose (index.php:4230) and api_create_post (:7358) have always
         capped on Upload::MAX_FILES, which was still 10. The claim was written into the web
         composer AND both native composers on 2026-08-02 and nobody checked it. Raised to 20
         server-side on 2026-08-07, so the number the member is promised is now the number that
         actually posts.

         REFUSAL IS IMMEDIATE AND HONEST (the standing rule on this surface, see the verify-wall
         work): the member is told at PICK time, with the real count, before anything uploads.
         What must never happen again is the composer promising one number and delivering another
         -- at 25 files the old code said "keeping the first 20" and kept 10. */
      var MEDIA_MAX = mediaMax();
      var room = MEDIA_MAX - stageMedia.items.length;
      if (room <= 0) {
        toast('That post is full, ' + MEDIA_MAX + ' photos or videos is the max.');
        syncInputFiles();
        return;
      }
      if (picked.length > room) {
        toast(room === MEDIA_MAX
          ? ('A post holds ' + MEDIA_MAX + ' photos or videos. Adding the first ' + MEDIA_MAX + '.')
          : ('Only ' + room + ' more fit (' + MEDIA_MAX + ' max). Adding the first ' + room + '.'));
        picked = picked.slice(0, room);
      }
      /* Ignore re-picks of the same file. `it.file` MUST be guarded: a draft restored by
         restoreDraft() (:10107) carries `file: null` -- it owns a staged TOKEN, not a File, which is
         the whole point of the reload-survives-the-draft path. Without the guard this line threw
         "Cannot read properties of null (reading 'name')" on the FIRST re-pick after any reload that
         restored an attachment, and the throw killed the rest of this handler: no thumbnail, no
         stageStart(), no `pick` breadcrumb, nothing. From the member's side the photo button simply
         stopped working -- tap, choose a picture, and the composer sits there forever (owner,
         2026-08-07: "tapping the add photo button is freezing"). A restored item has no File to
         compare, so it can never BE a duplicate of a fresh pick: skipping it is also the correct
         answer, not just the safe one. syncInputFiles() (:9984) already had this guard. */
      picked = picked.filter(function (f) {
        return !stageMedia.items.some(function (it) {
          return it.file && it.file.name === f.name && it.file.size === f.size && it.file.lastModified === f.lastModified;
        });
      });
      if (!picked.length) { syncInputFiles(); return; }
      box.hidden = false;
      var thumbs = [];
      picked.forEach(function (file) {
        var t = document.createElement('div');
        t.className = 'thumb';
        var url = URL.createObjectURL(file), el;
        if (file.type.indexOf('video') === 0) {
          el = document.createElement('video');
          el.src = url; el.muted = true; el.loop = true; el.autoplay = true;
          el.setAttribute('playsinline', '');
        } else {
          el = document.createElement('img'); el.src = url; el.alt = '';
        }
        t.appendChild(el);
        var bar = document.createElement('i');
        bar.className = 'up-bar';
        bar.innerHTML = '<b class="up-fill"></b>';
        t.appendChild(bar);
        var x = document.createElement('button');
        x.type = 'button';
        x.className = 'thumb-x';
        x.setAttribute('aria-label', 'Remove ' + file.name);
        x.innerHTML = '&times;';
        t.appendChild(x);
        if (file.type.indexOf('video') === 0) {   // pick a cover frame (or upload one) for a video
          var cover = document.createElement('button');
          cover.type = 'button'; cover.className = 'thumb-cover'; cover.setAttribute('aria-label', 'Choose cover');
          cover.innerHTML = '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="4" width="18" height="16" rx="2"/><circle cx="8.5" cy="9.5" r="1.6"/><path d="m21 16-5-5L5 21"/></svg><span>Cover</span>';
          t.appendChild(cover);
        }
        box.appendChild(t);
        thumbs.push(t);
      });
      /* AFTER the append loop, never before it. syncGridHideRow() decides by asking the DOM
         "is there a .thumb in the preview yet", so calling it while the strip is still empty
         answered no and left the row hidden on the FIRST pick of every post. A second trip to
         the picker then showed it, because by then batch one was in the DOM: that is why this
         read as intermittent rather than broken. The draft-restore path below always called it
         last and was never affected. */
      stageStart(picked, thumbs);   // upload the NEW ones now; existing keep going
      syncGridHideRow();
      syncInputFiles();
    });

    // REHYDRATE a draft left behind by a reload/eviction: bring back the caption AND any staged media, so the
    // owner never loses one to reach for the other. Runs once on load, only into an untouched composer.
    (function restoreDraft() {
      var saved = draftRead();
      var form = composeFile.closest('form');
      var ta = form && form.querySelector('textarea[name="body"]');
      if (ta && !ta.value && saved.body) {
        ta.value = saved.body;
        try { ta.dispatchEvent(new Event('input')); } catch (e) {}   // fire char-count + autosize + link preview
      }
      var box = document.getElementById('compose-preview');
      if (!box || stageMedia.items.length || !saved.media || !saved.media.length) return;
      var now = Date.now() / 1000, added = 0;
      saved.media.forEach(function (m) {
        var d = draftDecodeToken(m.token);
        if (!d || (d.exp && d.exp < now + 30)) return;                 // gone / about to expire -> drop it
        var isVid = (m.type || d.type) === 'video';
        var t = document.createElement('div'); t.className = 'thumb up-done';
        var el;
        if (isVid) { el = document.createElement('video'); el.src = d.path; el.muted = true; el.loop = true; el.autoplay = true; el.setAttribute('playsinline', ''); }
        else { el = document.createElement('img'); el.src = d.path; el.alt = ''; }
        t.appendChild(el);
        var bar = document.createElement('i'); bar.className = 'up-bar'; bar.innerHTML = '<b class="up-fill" style="width:100%"></b>'; t.appendChild(bar);
        var x = document.createElement('button'); x.type = 'button'; x.className = 'thumb-x'; x.setAttribute('aria-label', 'Remove'); x.innerHTML = '&times;'; t.appendChild(x);
        box.appendChild(t);
        // file:null -> the post rides the staged-token path (useStaged), no re-upload; done:true keeps stageFailed() false
        stageMedia.items.push({ file: null, type: isVid ? 'video' : 'image', token: m.token, sent: 1, size: 1, done: true, failed: false, tries: 2, thumb: t });
        added++;
      });
      if (added) { box.hidden = false; syncGridHideRow(); draftSaveMedia(); }   // draftSaveMedia rewrites storage minus any dropped/expired tokens
      else if (!saved.body) { draftClear(); }
    })();

    // DRAG & DROP: drop photos/videos anywhere on the composer (incl. the text box) to attach them --
    // routed through the SAME file-input change pipeline (preview + staged upload + 10-item cap + dedup).
    var dropZone = composeFile.closest('.composer') || composeFile.closest('form');
    if (dropZone && window.DataTransfer) {
      var dragDepth = 0;
      // a drag that STARTED inside the composer (a thumb, staged media, selected text) is a reorder or
      // a stray, never new files -- accepting it would re-upload media that's already attached
      var internalDrag = false;
      dropZone.addEventListener('dragstart', function () { internalDrag = true; });
      dropZone.addEventListener('dragend', function () { internalDrag = false; });
      var hasFiles = function (e) { return !internalDrag && !!(e.dataTransfer && Array.prototype.indexOf.call(e.dataTransfer.types || [], 'Files') >= 0); };
      dropZone.addEventListener('dragenter', function (e) { if (!hasFiles(e)) return; e.preventDefault(); dragDepth++; dropZone.classList.add('drag-over'); });
      dropZone.addEventListener('dragover', function (e) { if (!hasFiles(e)) return; e.preventDefault(); try { e.dataTransfer.dropEffect = 'copy'; } catch (er) {} });
      dropZone.addEventListener('dragleave', function (e) { if (!hasFiles(e)) return; dragDepth = Math.max(0, dragDepth - 1); if (!dragDepth) dropZone.classList.remove('drag-over'); });
      dropZone.addEventListener('drop', function (e) {
        if (internalDrag) { internalDrag = false; return; }
        if (!hasFiles(e)) return;
        e.preventDefault(); dragDepth = 0; dropZone.classList.remove('drag-over');
        var files = Array.prototype.filter.call((e.dataTransfer && e.dataTransfer.files) || [], function (f) {
          return /^image\//.test(f.type) || /^video\//.test(f.type);
        });
        if (!files.length) { toast('Only photos and videos can be dropped onto a post.'); return; }
        try {
          var dt = new DataTransfer();
          files.forEach(function (f) { dt.items.add(f); });
          composeFile.files = dt.files;                    // hand them to the same path the picker uses
          composeFile.dispatchEvent(new Event('change'));
        } catch (er) {}
      });
    }

    // the little red x on a thumbnail: drop that file from the post. Kills its
    // in-flight staging upload, forgets its token, and rebuilds the input's
    // FileList so the raw-fallback path can't resend it either.
    var previewBox = document.getElementById('compose-preview');
    if (previewBox) previewBox.addEventListener('click', function (e) {
      // a just-finished reorder drag synthesizes a click -- don't let it open the preview
      if (previewBox._dragEnded && Date.now() - previewBox._dragEnded < 350) { previewBox._dragEnded = 0; return; }
      var cv = e.target.closest ? e.target.closest('.thumb-cover') : null;
      if (cv) {                                       // "Cover": open the frame/upload picker for this video
        var ct = cv.closest('.thumb');
        var cit = stageMedia.items.find(function (it) { return it.thumb === ct; });
        if (cit && cit.file) openCoverPicker(cit.file, ct);
        return;
      }
      // tap the photo/video itself (not the x / Cover buttons) -> full-size preview before posting
      var tt = e.target.closest ? e.target.closest('.thumb') : null;
      if (tt && !(e.target.closest && e.target.closest('.thumb-x'))) {
        var pi = stageMedia.items.findIndex(function (it) { return it.thumb === tt; });
        if (pi >= 0) { openComposePreview(pi); return; }
      }
      var x = e.target.closest ? e.target.closest('.thumb-x') : null;
      if (!x) return;
      var t = x.closest('.thumb');
      var idx = stageMedia.items.findIndex(function (it) { return it.thumb === t; });
      if (idx >= 0) {
        var it = stageMedia.items[idx];
        if (it.vcCancel) { try { it.vcCancel(); } catch (err) {} }   // stop an in-flight on-device encode NOW
        if (it.xhr && !it.done && !it.failed) { try { it.xhr.abort(); } catch (err) {} }
        // a LARGE video uploads in parallel chunks (it.xhrs), not a single it.xhr -- abort those too, or a
        // deleted video keeps uploading (and retrying) in the background. The chunk loop's guards below
        // (indexOf(it) < 0) then stop it from re-sending after the abort.
        if (it.xhrs) { it.xhrs.forEach(function (x) { try { x.abort(); } catch (e) {} }); }
        if (composePoster && composePoster.file === it.file) composePoster = null;   // its cover goes with it
        stageMedia.items.splice(idx, 1);     // orphaned staged files are pruned server-side
      }
      t.remove();
      syncInputFiles();
      draftSaveMedia();   // keep the reload-draft in sync with what's actually attached
      if (!stageMedia.items.length) {
        previewBox.hidden = true;
        syncGridHideRow();
        composeFile.value = '';
      }
    });

    /* ---- PREVIEW a staged attachment full-size before posting (owner request) ----------------------------
       Tap a composer thumbnail (not its x / Cover button) to open the real photo / video big, and flip
       through the rest with the arrows, keyboard, or a swipe -- so you can check what you're about to post
       without leaving the composer. Built from the staged files' own object URLs (revoked on close). */
    function openComposePreview(startIdx) {
      var items = stageMedia.items.slice();
      if (!items.length) return;
      var i = Math.max(0, Math.min(items.length - 1, startIdx || 0));
      var urls = items.map(function (it) {
        try { return URL.createObjectURL(it.file); }
        catch (e) { var m = it.thumb && it.thumb.querySelector('img,video'); return m ? m.src : ''; }
      });
      var lb = document.createElement('div');
      lb.className = 'cmp-lb';
      lb.innerHTML =
        '<button type="button" class="cmp-lb-x" aria-label="Close preview">&times;</button>'
        + '<button type="button" class="cmp-lb-nav prev" aria-label="Previous"><svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m15.5 5-7 7 7 7"/></svg></button>'
        + '<div class="cmp-lb-stage"></div>'
        + '<button type="button" class="cmp-lb-nav next" aria-label="Next"><svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m8.5 5 7 7-7 7"/></svg></button>'
        + '<span class="cmp-lb-count"></span>';
      var stage = lb.querySelector('.cmp-lb-stage');
      var counter = lb.querySelector('.cmp-lb-count');
      var prevB = lb.querySelector('.cmp-lb-nav.prev');
      var nextB = lb.querySelector('.cmp-lb-nav.next');
      if (items.length < 2) { prevB.style.display = nextB.style.display = counter.style.display = 'none'; }
      function render() {
        var it = items[i];
        var isVid = (it.file && it.file.type && it.file.type.indexOf('video') === 0) || it.type === 'video';
        stage.innerHTML = '';
        var el;
        if (isVid) {
          el = document.createElement('video');
          el.src = urls[i]; el.controls = true; el.autoplay = true; el.muted = false;
          el.setAttribute('playsinline', ''); el.playsInline = true;
        } else {
          el = document.createElement('img'); el.src = urls[i]; el.alt = '';
        }
        el.className = 'cmp-lb-media';
        stage.appendChild(el);
        if (counter) counter.textContent = (i + 1) + ' / ' + items.length;
        prevB.disabled = i === 0; nextB.disabled = i === items.length - 1;
      }
      function go(n) { i = Math.max(0, Math.min(items.length - 1, n)); render(); }
      function close() {
        document.removeEventListener('keydown', onKey, true);
        urls.forEach(function (u) { try { URL.revokeObjectURL(u); } catch (e) {} });
        lb.remove();
      }
      function onKey(e) {
        if (e.key === 'Escape') { e.preventDefault(); close(); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); go(i - 1); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); go(i + 1); }
      }
      prevB.addEventListener('click', function (e) { e.stopPropagation(); go(i - 1); });
      nextB.addEventListener('click', function (e) { e.stopPropagation(); go(i + 1); });
      lb.querySelector('.cmp-lb-x').addEventListener('click', function (e) { e.stopPropagation(); close(); });
      lb.addEventListener('click', function (e) { if (e.target === lb || e.target === stage) close(); });  // tap the backdrop to close
      var tx = 0, ty = 0, td = false;                                     // touch: swipe through the attachments
      stage.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; ty = e.touches[0].clientY; td = true; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (!td) return; td = false;
        var dx = e.changedTouches[0].clientX - tx, dy = e.changedTouches[0].clientY - ty;
        if (Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy)) go(i + (dx < 0 ? 1 : -1));
      }, { passive: true });
      document.addEventListener('keydown', onKey, true);
      document.body.appendChild(lb);
      render();
    }

    /* ---- REORDER media before posting (round 139, owner request) -----------------------------------------
       Drag a preview thumbnail to a new spot: mouse lifts on a 6px move, touch lifts on a ~220ms HOLD (so
       normal page scrolling that happens to start on a thumb stays free; while a drag is live a non-passive
       touchmove blocker keeps the page still). The VISUAL order is the truth: on drop, stageMedia.items is
       re-sorted to match the thumbs and syncInputFiles() rebuilds the raw FileList, so both the staged-token
       path and the classic multipart path post exactly what the strip shows. */
    (function () {
      var pv = document.getElementById('compose-preview');
      if (!pv) return;
      // Reordering is pointer-event driven; the browser's native HTML5 drag adds nothing and is
      // actively poisonous: Chrome packs a dragged <img> into dataTransfer as a FILE, so dropping a
      // thumb back onto the composer re-entered the drop-to-attach pipeline and DUPLICATED the media.
      pv.addEventListener('dragstart', function (e) { e.preventDefault(); }, true);
      var drag = null, holdT = null, activeId = null;
      pv.addEventListener('touchmove', function (e) { if (drag && e.cancelable) e.preventDefault(); }, { passive: false });
      function lift(t, pointerId) {
        drag = t; activeId = pointerId;
        t.classList.add('reordering');
      }
      function settle() {
        if (!drag) return;
        drag.classList.remove('reordering');
        drag = null; activeId = null;
        pv._dragEnded = Date.now();   // suppress the click this reorder drag synthesizes (else it opens the preview)
        var order = Array.prototype.slice.call(pv.querySelectorAll('.thumb'));
        stageMedia.items.sort(function (a, b) { return order.indexOf(a.thumb) - order.indexOf(b.thumb); });
        syncInputFiles();
        draftSaveMedia();   // persist the new order too
      }
      pv.addEventListener('pointerdown', function (e) {
        var t = e.target.closest ? e.target.closest('.thumb') : null;
        if (!t || (e.target.closest && e.target.closest('.thumb-x, .thumb-cover'))) return;
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        var sx = e.clientX, sy = e.clientY, pid = e.pointerId;
        clearTimeout(holdT);
        if (e.pointerType !== 'mouse') { holdT = setTimeout(function () { lift(t, pid); }, 220); }
        function onMove(ev) {
          if (ev.pointerId !== pid) return;
          if (!drag) {
            var moved = Math.abs(ev.clientX - sx) > 6 || Math.abs(ev.clientY - sy) > 6;
            if (!moved) return;
            if (ev.pointerType === 'mouse') { lift(t, pid); }
            else { clearTimeout(holdT); return cleanup(); }   // touch moved before the hold: it's a scroll
          }
          // insertion point: the first sibling whose row is below the pointer, or (same row) whose
          // horizontal midpoint is past it -- handles the strip wrapping onto multiple rows
          var before = null;
          var sibs = pv.querySelectorAll('.thumb');
          for (var i = 0; i < sibs.length; i++) {
            if (sibs[i] === drag) continue;
            var r = sibs[i].getBoundingClientRect();
            if (ev.clientY < r.top - 4 || (ev.clientY <= r.bottom + 4 && ev.clientX < r.left + r.width / 2)) { before = sibs[i]; break; }
          }
          if (before) { pv.insertBefore(drag, before); } else { pv.appendChild(drag); }
        }
        function onUp(ev) {
          if (ev.pointerId !== pid) return;
          clearTimeout(holdT);
          settle();
          cleanup();
        }
        function cleanup() {
          document.removeEventListener('pointermove', onMove);
          document.removeEventListener('pointerup', onUp);
          document.removeEventListener('pointercancel', onUp);
        }
        document.addEventListener('pointermove', onMove);
        document.addEventListener('pointerup', onUp);
        document.addEventListener('pointercancel', onUp);
      });
    })();

    // The cover picker: scrub the video to a frame and grab it, OR upload your own image.
    // The result is a small JPEG appended to the compose POST as `poster`.
    function setComposePoster(blob, forFile, thumb) {
      composePoster = { blob: blob, file: forFile };
      if (thumb) {
        thumb.classList.add('has-cover');
        try {
          var u = URL.createObjectURL(blob);
          thumb.style.setProperty('--cover', "url('" + u + "')");
        } catch (e) {}
        var b = thumb.querySelector('.thumb-cover'); if (b) b.classList.add('on');
      }
      toast('Cover set.');
    }
    function openCoverPicker(file, thumb) {
      if (!file) return;
      var ov = document.createElement('div');
      ov.className = 'cover-pick';
      ov.innerHTML =
        '<div class="cover-pick-card">'
        + '<div class="cover-pick-head"><strong>Choose a cover</strong>'
        +   '<button type="button" class="cover-pick-x" aria-label="Close">&times;</button></div>'
        + '<div class="cover-pick-stage"><video playsinline muted preload="metadata"></video></div>'
        + '<input type="range" class="cover-pick-scrub" min="0" max="1000" value="0" aria-label="Scrub to a frame">'
        + '<div class="cover-pick-actions">'
        +   '<button type="button" class="btn sm cover-pick-upload">Upload image</button>'
        +   '<button type="button" class="btn sm gold cover-pick-use">Use this frame</button></div>'
        + '<input type="file" class="cover-pick-file" accept="image/*" hidden></div>';
      document.body.appendChild(ov);
      lockScroll();
      var v = ov.querySelector('video'), scrub = ov.querySelector('.cover-pick-scrub');
      var url = URL.createObjectURL(file), dur = 0, seeking = false;
      v.src = url;
      v.addEventListener('loadedmetadata', function () { dur = v.duration || 0; try { v.currentTime = Math.min(0.1, dur); } catch (e) {} });
      scrub.addEventListener('input', function () {
        if (dur > 0 && !seeking) { seeking = true; try { v.currentTime = (scrub.value / 1000) * dur; } catch (e) {} }
      });
      v.addEventListener('seeked', function () { seeking = false; });
      function close() { try { URL.revokeObjectURL(url); } catch (e) {} if (ov.parentNode) ov.parentNode.removeChild(ov); unlockScroll(); }
      ov.addEventListener('click', function (e) { if (e.target === ov || e.target.closest('.cover-pick-x')) close(); });
      ov.querySelector('.cover-pick-use').addEventListener('click', function () {
        var cw = v.videoWidth, ch = v.videoHeight;
        if (!cw || !ch) { toast('Could not read that frame, try another spot.'); return; }
        var scale = Math.min(1, 1280 / Math.max(cw, ch));
        var cnv = document.createElement('canvas');
        cnv.width = Math.max(1, Math.round(cw * scale)); cnv.height = Math.max(1, Math.round(ch * scale));
        try { cnv.getContext('2d').drawImage(v, 0, 0, cnv.width, cnv.height); }
        catch (err) { toast('Could not capture that frame.'); return; }
        cnv.toBlob(function (blob) {
          if (!blob) { toast('Could not capture that frame.'); return; }
          setComposePoster(blob, file, thumb); close();
        }, 'image/jpeg', 0.85);
      });
      var cf = ov.querySelector('.cover-pick-file');
      ov.querySelector('.cover-pick-upload').addEventListener('click', function () { cf.click(); });
      cf.addEventListener('change', function () {
        var img = cf.files && cf.files[0]; if (!img) return;
        if ((img.type || '').indexOf('image') !== 0) { toast('Please pick an image.'); return; }
        setComposePoster(img, file, thumb); close();
      });
    }
  }

  /* ---- ONE resize listener for every carousel on the page -----------------------------------------
     Each carousel used to add its OWN window 'resize' listener in initCarousel(). That is a permanent,
     unremovable reference to the carousel element, and the card-feed virtualiser (stubCard/restoreCard)
     rebuilds a restored card from stashed outerHTML -- a BRAND NEW element, so `_inited` is false and it
     re-inits. Every stub/restore round-trip therefore added another window listener that pinned the
     previous, now-detached carousel and its slides in memory for the life of the page. On a long feed
     session that is an unbounded accumulation of listeners and detached DOM -- invisible to a short CPU
     profile, but exactly the shape of "the phone gets hot the longer I scroll".
     One shared listener now fans out to the live carousels and drops the dead ones.

     ...BUT THE SHARED REGISTRY WAS ITSELF THE LEAK (2026-08-10). Collapsing N window listeners into one
     array removed the listeners; it did NOT remove the strong reference. `_crsz.push({c: c, fn: fn})`
     pinned each carousel TWICE -- once as `.c`, and again through `.fn`, which is initCarousel's own
     `applyLayout` closure and so captures the entire carousel scope (track, slides, videos, __cplay).
     The array was compacted in exactly two places: on a real `resize`, and on a push once length > 40.
     A PHONE NEVER FIRES `resize` while you read, so in practice the only compaction was the >40 push --
     which means up to ~41 whole detached post subtrees (with their <video>s and native media-control
     shadow DOM) sat pinned to a GC root at all times, and every viewer open/close pushed more in.
     PROVED by heap snapshot, member session, 2x forced GC between samples: of 4,292 DOM nodes created
     by one pfeed open/close and still alive afterwards, 1,761 -- the single largest application-level
     holder, 3.7x the next -- retained on the path
        (GC roots) -> Window -> Context -> Array `_crsz` -> Object --property:c--> <div class="media carousel">
     Measured retention across three open/close cycles was +4,790 DOM nodes and ~+310 listeners EVERY
     cycle, with the live element count flat at 2,235 -- i.e. all of it detached.
     FIX: the registry holds a WeakRef and nothing else, and the callbacks live ON the element. Now the
     registry can only ever OBSERVE liveness, never confer it: the moment the pfeed drops a carousel it
     is collectable, whether or not a resize ever happens. Behaviour on resize is unchanged (same
     callbacks, same order, same 120ms debounce), which matters because applyLayout's pinned px width is
     revalidated ONLY here -- see the carousel pinned-width note. Falls back to the old strong-ref
     registry where WeakRef is missing (pre-14.5 iOS), so the worst case is today's behaviour. */
  var _crsz = [];
  var _crszWeak = (typeof WeakRef === 'function');
  function _crszEl(e) { return _crszWeak ? e.deref() : e.c; }          // null once collected
  function _crszLive(e) { var el = _crszEl(e); return !!(el && el.isConnected); }
  function onCarouselResize(c, fn) {
    if (_crsz.length > 40) { _crsz = _crsz.filter(_crszLive); }
    if (!_crszWeak) { _crsz.push({ c: c, fn: fn }); return; }
    // Callbacks hang off the element, so the ONLY thing the registry holds is a weak handle. A second
    // registration for the same element joins the existing entry rather than adding another (the
    // suggestion carousel and initCarousel both register, and a duplicate entry would double-run).
    if (c.__crszFns) { c.__crszFns.push(fn); return; }
    c.__crszFns = [fn];
    _crsz.push(new WeakRef(c));
  }
  (function () {
    var t = null;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var keep = [];
        for (var i = 0; i < _crsz.length; i++) {
          var el = _crszEl(_crsz[i]);
          if (!el || !el.isConnected) continue;            // collected or detached: let it go
          keep.push(_crsz[i]);
          var fns = _crszWeak ? (el.__crszFns || []) : [_crsz[i].fn];
          for (var j = 0; j < fns.length; j++) { try { fns[j](); } catch (e) {} }
        }
        _crsz = keep;
      }, 120);
    }, { passive: true });
  })();

  /* ---- ONE GALLERY MAY CYCLE A VIDEO AT A TIME -------------------------------------------------
     A COUNT BUDGET, for the reason [[grid-ken-burns-count-budget]] spells out: on a surface that
     arms every element as you scroll, bounding what each ELEMENT does bounds nothing -- you have to
     bound HOW MANY are doing it. A feed can hold several multi-video posts and two cards can easily
     be >=55% on screen at once on a phone, and an advance is not a cheap event on a video gallery:
     every step pauses one clip, promotes the next to preload=auto and calls play() on it, i.e. a
     decoder swap plus a fresh progressive fetch. Several of those interleaved is the exact failure
     [[pfeed-memory-and-slideshow]] exists for, and cycling decoders is the top of the list in
     [[phone-heat-energy-evidence]].
     ONE, which is also what the native app allows (its viewer gates both the dwell timer and the
     end-of-clip watcher on `i === restIdx && isFocused`, and its feed gives exactly one card the
     live decoder) -- so the two clients cycle the same way rather than each inventing a number.
     The slot goes to the gallery nearest the middle of the screen, which is the one being read; an
     engaged gallery mid-clip is never evicted, because taking the slot off someone who pressed play
     is the same defect as never advancing at all.
     PHOTO-ONLY galleries do NOT take part. Their auto-swipe is a transform on an already-decoded
     image, several at once was measured and approved, and narrowing it here would be a silent
     regression of behaviour nobody complained about. */
  var _cycOwner = null;
  function cycDist(c) {
    var r = c.getBoundingClientRect(), vh = window.innerHeight || 800;
    if (!r.width || !r.height) return Infinity;
    if (Math.min(r.bottom, vh) - Math.max(r.top, 0) < r.height * 0.55) return Infinity;   // not really on screen
    return Math.abs((r.top + r.bottom) / 2 - vh / 2);
  }
  function cycRelease(c) { if (_cycOwner === c) _cycOwner = null; }
  function cycClaim(c) {
    var mine = cycDist(c);
    if (mine === Infinity) { cycRelease(c); return false; }
    if (_cycOwner === c) return true;
    if (_cycOwner && _cycOwner.isConnected) {
      var od = cycDist(_cycOwner);
      // An owner that has left the screen is evictable whatever it thinks it is doing -- otherwise a
      // stale __cycPass on a scrolled-away card would hold the only slot and NOTHING would cycle.
      if (od !== Infinity && (_cycOwner.__cycPass || od <= mine)) return false;
    }
    _cycOwner = c;
    return true;
  }

  /* ---- multi-photo carousels ------------------------------------------- */
  function initCarousel(c) {
    if (c._inited) return;
    c._inited = true;
    var track = c.querySelector('.carousel-track');
    var slides = c.querySelectorAll('.cslide');
    var dots = c.querySelectorAll('.cdot');
    var prev = c.querySelector('.cnav.prev');
    var next = c.querySelector('.cnav.next');
    var counter = c.querySelector('.ccount');
    var count = slides.length, idx = 0, sw = 100, maxIdx = count - 1, pkFade = 100;   // pkFade: peek-mask fade start % (measure)
    // Does this gallery hold any video at all? Read ONCE: everything in the media-handoff block below
    // is a no-op for an all-photo carousel, which is most of them.
    var carHasVideo = !!c.querySelector('video');
    var carInPfeed = !!(c.closest && c.closest('.pfeed'));
    // PER-VIEW: how many slides the CSS shows at once -- 1 in portrait / the immersive viewer, 2 on a
    // landscape post card. Read it from the laid-out slide width so it tracks the CSS AND reacts to rotation.
    // sw = one slide's width in %; maxIdx = the furthest left-slide index that still fills the view.
    function measure() {
      var cw = c.getBoundingClientRect().width || 1;
      var s0 = slides[0] ? slides[0].getBoundingClientRect().width : cw;
      var gap = 0; try { gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0; } catch (e) {}
      var pv = Math.max(1, Math.min(count, Math.round(cw / (s0 || cw))));
      // sw = how far to translate per index step, in % of the container. When the slides TILE the container
      // exactly (pfeed 1-up) that's 100/pv. When a slide is deliberately NARROWER so the NEXT one PEEKS at the
      // right (the feed card), step by the real slide width PLUS the inter-slide gap, so paging lands each media
      // flush-left with its separated neighbour peeking rather than drifting out of alignment.
      var full = Math.abs((s0 || cw) * pv - cw) < 2 && gap < 1;
      sw = full ? (100 / pv) : (((s0 || cw) + gap) / cw) * 100;
      maxIdx = Math.max(0, count - pv);
      if (idx > maxIdx) idx = maxIdx;
      // PEEK MASK (owner: current slides FULLY solid; only the next slide's trimmed preview fades, solid at
      // its left edge -> transparent at the right). Fade ONLY when a peek is actually on screen: measured as
      // real leftover room after the whole slides + gaps. No room (slide fills the container) or nothing
      // left to show = NO fade -- a fixed cap here used to paint the fade onto slide 1 itself (owner shot).
      var used = (((s0 || cw) + gap) * pv);
      var peekRoom = cw - used;                                  // px the next slide's preview occupies
      pkFade = (count <= pv || peekRoom < 8) ? 100
             : Math.min(99, (used / cw * 100) + (peekRoom / cw * 100) * 0.35);
    }
    // WIDE GALLERY (owner: "use the blank space on the right on landscape for another slide, don't cram two
    // into one window"). On a roomy landscape/desktop viewport a multi-media FEED card breaks OUT of the narrow
    // post column to use the free space beside it: measure the card's natural left, stretch its own width
    // rightward to the open room (stopping short of any right sidebar), switch to a fixed slide width (.cwide),
    // and let measure() fit as many WHOLE slides as it can plus a peek. So a wide screen shows 2, 3, 4... proper
    // slides instead of two crops in the card. Cleared to the single-slide peek in portrait; never in the pfeed.
    function applyLayout() {
      // Portrait/narrow: ONE media per view (86%) + a peek of the next (see .cslide + the right-edge fade).
      // Roomy LANDSCAPE / DESKTOP: break OUT of the column and show SEVERAL separate slides -- each its own
      // media, gap-separated + rounded so they never look crammed -- up to 4 on a desktop (owner). app.js sizes
      // the card to exactly that many slide-widths (+gap) plus a sliver of peek; measure() reads it back.
      var isFeed = !c.closest('.pfeed');
      // Any screen >=760px wide gets the multi-slide layout (owner: an iPad or desktop should fit up to 4
      // slides per page, not 1). The old width>height clause also required LANDSCAPE, which knocked portrait
      // iPads (768-1024px wide) and tall desktop windows down to the single-slide layout -- the >=760 floor
      // already excludes portrait phones on its own, so orientation doesn't matter.
      var roomy = window.innerWidth >= 760;
      if (isFeed && count > 1 && roomy) {
        c.classList.remove('cwide'); c.style.width = ''; c.style.height = ''; c.style.removeProperty('--cw-slide');   // read the natural left
        // MEASUREMENT GUARD -- do not pin a width off a rect that does not exist.
        // The width below is written as an ABSOLUTE inline px value and nothing revalidates it. If this
        // rect is measured while the carousel has NO layout box (not attached yet, an ancestor still
        // display:none, or read mid-swap by the card virtualiser) getBoundingClientRect() returns all
        // zeros: left is 0, and the old code then fell back to the VIEWPORT for the right limit, so
        // "room" came out about twice the real card width, tripped the 4-up branch and pinned ~1200px
        // on a media box inside a 660px card. .post is overflow:visible, so that spilled off the page,
        // and with per-view 4 maxIdx became 0 so it could never advance (owner shot). A zero rect, or
        // no .post ancestor to bound against, means we simply have no trustworthy number: pin NOTHING,
        // leave the portrait single-slide layout in place, and let the ResizeObserver below re-run this
        // the moment the element actually gets a box. (measure/update are function declarations, so
        // they are hoisted and this early return is safe -- applyLayout already calls update() before
        // its textual declaration on the normal path.)
        var _r0 = c.getBoundingClientRect();
        // STAY INSIDE THE POST CARD (owner: "no overflow outside the post border; respect the inner
        // margin"): the carousel may use the card's full inner width but NEVER past its padding box.
        // No card ancestor = nothing to bound against. There is deliberately NO viewport fallback here:
        // measuring against window.innerWidth when there is no card is what manufactured the bug.
        var post = c.closest('.post');
        if (!_r0.width || !post) {
          c.style.webkitMaskImage = ''; c.style.maskImage = '';
          measure();
          update();
          return;
        }
        var left = _r0.left;
        var prc = post.getBoundingClientRect(), pcs = getComputedStyle(post);
        var rightLimit = prc.right - (parseFloat(pcs.paddingRight) || 0) - (parseFloat(pcs.borderRightWidth) || 0);
        var room = Math.max(300, rightLimit - left);
        var gap = 14;
        var base = Math.min(0.46 * window.innerHeight, 380);                        // the portrait slide baseline
        // BINARY layout (owner): EITHER one big slide + a faded preview of the 2nd, OR four at a time
        // (+ the faded preview when more remain). Never 2-up/3-up -- those threw the portrait crops off.
        var four = count >= 4 && (room - 3 * gap) / 4.15 >= 170;   // 4 whole + gaps + peek must fit readably
        var fitN = four ? 4 : 1;
        var peekFrac = count > fitN ? 0.15 : 0;
        var gaps = (fitN - 1) + (peekFrac ? 1 : 0);                                // between slides, + one before the peek
        var slideW = (room - gaps * gap) / (fitN + peekFrac);
        if (!four) { slideW = Math.min(slideW, base * 1.12); }                     // 1-up: keep the big slide portrait-ish
        var w = fitN * slideW + gaps * gap + peekFrac * slideW;
        c.classList.add('cwide');
        c.style.setProperty('--cw-slide', Math.round(slideW) + 'px');
        c.style.width = Math.round(Math.min(room, w)) + 'px';
        // height follows the slide width so 4-up slides keep a PORTRAIT crop instead of tall skinny strips
        c.style.height = Math.round(Math.min(Math.min(0.66 * window.innerHeight, 560), slideW * 1.6)) + 'px';
      } else {
        c.classList.remove('cwide');
        c.style.width = ''; c.style.height = ''; c.style.removeProperty('--cw-slide');
      }
      c.style.webkitMaskImage = ''; c.style.maskImage = '';
      measure();
      update();
    }
    applyLayout();
    function update() {
      track.style.transform = 'translateX(-' + (idx * sw) + '%)';
      // peek fade: computed by measure(); ON THE LAST slide there's nothing more to peek -> fully solid
      c.style.setProperty('--pk-fade', (idx >= maxIdx ? 100 : pkFade) + '%');
      for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('on', i === idx);
      // .cs-cur = the slide on screen. rova.css (touch) holds every OTHER slide's timeline Ken Burns where it
      // is, so an 18-photo card is 1 running pan, not 18 (2026-10-01, count budget; see the rova.css note).
      for (var si = 0; si < slides.length; si++) { if (slides[si].classList.contains('cs-cur') !== (si === idx)) { slides[si].classList.toggle('cs-cur', si === idx); } }
      if (counter) counter.textContent = (idx + 1) + '/' + count;
      if (prev) prev.disabled = idx === 0;
      if (next) next.disabled = idx >= maxIdx;
      if (c.__onslide) c.__onslide(idx, count);   // let a photo control bar track the position
    }
    /* NOT EVERY go() IS A FINGER. Two paths land a slide with nobody touching anything: the
       /p/123#m2 deep link, which runs at init, and __cgo, which the immersive viewer uses to open
       on the media that was tapped. Both must stay out of the ENG_QUIET arm below -- a carousel
       that armed a 120-second hold on page load would hold the entire feed still for two minutes
       off nobody's input, which is the exact failure the attention block's "renew, never arm"
       asymmetry exists to prevent. The 7s local courtesy above is unaffected, as it always was. */
    var _navSilent = 0;
    /* ---- EVERY CLIP THE GALLERY LANDS ON STARTS AT THE BEGINNING  (owner 2026-08-10) ---------
       "While watching a slideshow, when one video is done playing and it goes to the next one it
        should start from the beginning so I can see the whole video -- it's random and I'm having
        to rewind each one to see it from the beginning."

       NOTHING IN THIS FILE EVER REWOUND AN INCOMING SLIDE. Every start funnels through
       __rovaPlayNow / calmPlay / the drag-reveal, and all three play the element AS IT IS -- so a
       slide's clip resumes at whatever position it was last left at. On the FIRST lap of the
       immersive viewer's show that is 0 by construction (measured over three laps of /p/15223:
       every clip began at <= 0.067s), but a clip is not left at 0 by a lap:
         - the feed card's engaged cycle ends a clip AT its end (clipPass's endEarly fires at
           duration - 0.35), so the second lap starts that slide 0.35s from the end;
         - a slide the reader swiped away from mid-play keeps that position for as long as the
           card lives, so paging back to it resumes mid-clip;
         - a clip stopped by the recycler, the memory guard, or a tab going hidden is parked
           wherever it stopped.
       The native app has the same rule and a louder version of the same defect (its ±1 neighbour
       window plays the next slide muted while you watch this one, so it arrives at "however long
       the previous clip ran"), which is what makes the offset look RANDOM to a reader rather than
       merely late. One rule on both surfaces: an ADVANCE lands at 0.

       WHY IT IS HERE AND NOT IN slideMedia(). slideMedia() is not the nav -- it is also called by
       the visibility observer, by applyLayout and by the resize path, on the slide the reader is
       CURRENTLY WATCHING. A rewind there would yank a clip back to 0 every time the card crossed
       55% visibility. go() is the one funnel every real slide change goes through (swipe, arrow,
       dot, wheel, the 4.2s tick, the engaged cycle, the viewer's step(), __cgo), and gating on the
       index having actually MOVED is what makes it a nav and not a repaint.
       It never plays, never pauses, and never touches a clip the reader deliberately stopped
       (_userPaused) -- that position is theirs. 0.35s is the same "no gratuitous micro-seek" floor
       primeNext uses: a clip already parked at ~0.05 is at the beginning. */
    function rewindSlide(i) {
      var rv = slideVideoAt(i);
      if (!rv || rv._userPaused) return;
      try { if ((rv.currentTime || 0) > 0.35) { rv.currentTime = 0; } } catch (e) {}
    }
    function go(i) {
      var _was = idx;
      idx = Math.max(0, Math.min(maxIdx, i)); update();
      // KEN BURNS IN THE VIEWER FOLLOWS THE SLIDE (batch item 24): the drift is one Web Animation on the slide on
      // screen (THE VIEWER'S PHOTO DRIFT), so every real slide change re-syncs it -- the leaving slide parks, the
      // arriving one starts from rest after the usual 0.4 s hold.
      if (idx !== _was && window.__rovaPfKbSync && c.closest && c.closest('.pfeed')) { try { window.__rovaPfKbSync(); } catch (e) {} }
      // ...and the clip on the slide we just moved to starts at its beginning (see above). Before
      // slideMedia() below, which is what calls __rovaPlayNow on it: seek first, then play.
      if (idx !== _was) { rewindSlide(idx); }
      // KEN BURNS FOLLOWS THE SLIDE THAT IS ON SCREEN, not just the auto-advance. kenBurns() used to be
      // called ONLY from step() (and from __cplay for the slide we start on), so a slide the reader reached
      // any other way -- swipe, arrow, dot, #m2 deep link, the pfeed's targetSlide landing -- arrived with
      // NO drift, and kb-run stayed stranded on whatever slide the last AUTO advance left it on. Measured on
      // /p/12714: after paging by hand the photo sat perfectly still while it was the current slide.
      // Why this reads as "photos don't pan in a post WITH VIDEOS": in an all-photo show the next auto
      // advance is ~3.5s away and re-arms the drift almost immediately, so the gap is invisible. A show that
      // holds on a VIDEO slide has no advance at all until that clip has played out (8s, 30s, up to the 90s
      // cap), and a manual page adds a further 7s hold on top -- so the photo the reader deliberately swiped
      // back to is dead still for as long as they look at it. Re-arm it here and both cases behave the same.
      if (c.__cplaying) { kenBurns(true); }
      // a MANUAL nav (swipe / arrow / dot / wheel) silently HOLDS the auto-advance so it never yanks the slide
      // out from under the reader right after they moved it (owner: hold 5-10s). The auto-advancers stamp
      // __autoTicking (feed card) / __ssTicking (pfeed sit-back slideshow) so THEIR own advance isn't "manual".
      if (c.__autoPause && !c.__autoTicking) { c.__autoPause(7000); }                          // feed / permalink card
      if (c.__cplaying && !c.__ssTicking) { _ssPausedUntil = Math.max(_ssPausedUntil, Date.now() + 7000); }   // pfeed slideshow
      /* ...AND A MANUAL NAV IS ENGAGEMENT WITH THE POST, NOT JUST WITH THIS CAROUSEL (owner
         2026-08-10: "if I start swiping through photos here it should pause the auto loading as
         well until I'm idle again").

         The 7s above is a LOCAL courtesy -- it stops this one gallery yanking the slide back. What
         it never did is tell the rest of the feed anything, so the ambient roll, the live reveal,
         the chrome collapse and every other card's auto-swipe carried on underneath a reader who
         was plainly reading THIS post. The arrows and dots were already covered (.cnav/.cdot are in
         ENG_ATTN_SEL, so their pointerdown arms it) -- the FINGER SWIPE and the trackpad wheel were
         not, because they land on the media and engAttendFrom declines that on purpose.

         Deliberately the SAME hold the unmute takes, with the same quiet period, arriving through
         the same function: two engagement signals must be indistinguishable to the mechanism or
         "until I'm idle again" quietly means two different things depending on which one he used.
         And ENG_QUIET renews on any real input, so a reader working through a ten-slide gallery
         re-arms it with every swipe and the feed only starts moving again once they stop.
         AUTO advances are excluded by the same __autoTicking / __ssTicking stamps the line above
         uses -- a carousel arming a 120s hold on its OWN tick would hold the whole feed still
         forever, off nobody's finger. */
      if (!c.__autoTicking && !c.__ssTicking && !_navSilent) { try { engAttnArm(ENG_QUIET); } catch (e) {} }
      slideMedia();                                                                            // hand playback to the slide we just landed on
    }

    /* ---- MEDIA HANDOFF ON SLIDE CHANGE (owner 2026-08-07: "each clip slides in and starts
       playing is awesome, but it hangs for a second when swiping to the video before playing it").

       WHERE THE SECOND WENT, measured on /@grindhd post 15076 (five video slides, no HLS ladder
       on any of them, so every slide is a plain progressive mp4 of 7-53MB), WebKit-profile
       Chromium at 390x844 with a 2.5Mbps/70ms link, real CDP touch swipes:

         touchend -> playIO's IntersectionObserver callback   346ms .. 1745ms
         IO callback -> calmPlay's timer + scroll-calm gate     ~90ms .. 250ms
         play() -> first frame                                  starved, still readyState 0
                                                                five seconds later

       Three separate taxes, and NOT ONE of them is "we forgot to preload":
       1. NOBODY was driving playback from the gesture at all.  go() moved the track and stopped;
          the only thing that ever started the incoming clip was playIO noticing, asynchronously,
          that a rect had changed -- and its callback is delivered on a rendering update that is
          competing with five media downloads.  Then calmPlay adds a 90ms settle plus a re-poll
          against __rovaScrollAt, which the window-level `touchmove` listener stamps on every
          frame of the swipe, so the earliest possible play() is ~160ms after the finger lifts and
          the poll granularity rounds it to ~300ms.  That whole chain exists to stop a FLING
          spinning a decoder per post; a carousel page is one discrete, deliberate nav, so it can
          be driven directly and the clip starts under the finger.
       2. The outgoing clip kept playing and kept downloading until that same late callback paused
          it -- so for the whole stall the departed slide was still spending the radio.
       3. inView() was vertical-only (see its own note), so the canplay restart had started EVERY
          slide's clip; five open-ended `bytes=0-` fetches, 119MB of Content-Length, all racing.

       So this block is not "add prefetching", it is "spend the bytes on the slide the reader is
       looking at".  It is deliberately NARROW:
         - exactly ONE neighbour is promoted to preload=auto.  Not the gallery.  Several
           simultaneously-buffering clips is the documented way this surface runs a phone out of
           memory, and it is also precisely what was already happening by accident.
         - preload=auto, not a `load()` on a live clip and not muted-play-then-pause.  A paused
           element at preload=auto buffers a bounded head and then suspends (measured: 3.9s of
           media, then `stalled`), which is the cheapest thing that is actually play-ready on the
           engines that matter.  load() is reserved for a clip that has no metadata yet, because
           load() on a clip with a position silently rewinds it AND silently pauses it.
         - everything from +2 out is demoted to preload=none, which is the real bandwidth win.
         - NOTHING happens unless the card is at least 55% on screen (same threshold playIO uses),
           so a card scrolled away warms nothing, and nothing starts while the tab is hidden.
         - the neighbour warm stands down on a slow line.  __rovaNetSlow() is the measured signal
           (Safari has no navigator.connection at all, so Data Saver / effectiveType is a no-op for
           the entire iPhone population and can only ever be an EXTRA veto, never the test).  The
           owner was at 9% battery when he reported this; iOS Low Power Mode throttles media hard
           and is not visible to script, so the honest defence is to keep the extra work to one
           clip and let the current slide always win the pipe.
       The pfeed is deliberately untouched: it has its own drag-reveal + warm-ahead discipline. */
    function slideVideoAt(i) { var s = slides[i]; return s ? s.querySelector('video') : null; }
    function carOnScreen() {
      var r = c.getBoundingClientRect(), vh = window.innerHeight || 800;
      if (!r.width || !r.height) return false;
      return (Math.min(r.bottom, vh) - Math.max(r.top, 0)) >= r.height * 0.55;
    }
    function lineIsTight() {
      try { if (window.__rovaNetSlow && window.__rovaNetSlow()) return true; } catch (e) {}
      var n = navigator.connection;                              // absent on Safari: an extra veto, never the test
      if (n && (n.saveData || /^(slow-2g|2g|3g)$/.test(n.effectiveType || ''))) return true;
      return false;
    }
    /* ---- HANDING THE SOUND OVER MUST NOT STOP THE CLIP THE ADVANCE JUST STARTED ----------------
       (owner 2026-08-08, on /p/15076 in an in-app browser: "when the previous slide (video) was
        finished it auto slid to this next slide but it was paused" -- 2/5, control bar 0:00/0:21,
        play icon showing, watch mode running.)

       BOTH branches below start the landed clip with __rovaPlayNow -- which engine-MUTES it and
       calls play(), i.e. the clip runs under the browser's MUTED-autoplay allowance -- and then
       called __rovaSyncSound() on the very next line. applySound() then hands the sound to the clip
       it judges current, and in the viewer activeVideo()'s pfeed branch deliberately does NOT
       require a clip to be playing (it picks by nearest centre, precisely so a clip that is mid-
       start still gets the sound). So with sound on and a real gesture behind it -- tapping "Play
       the feed" is exactly that -- the landed clip was UNMUTED in the same turn as it was told to
       play, while its play() promise was still pending.

       ON WEBKIT, UNMUTING A CLIP THAT IS PLAYING UNDER THE MUTED-AUTOPLAY ALLOWANCE SILENTLY PAUSES
       IT: no promise rejection, no error, no event you can catch on the way in -- the clip simply
       stops, at 0:00, on the slide that has only just arrived. That is the reported state exactly,
       and the ordering is MINE: this handoff is what put a play() and an unmute in the same turn.
       Before it, the viewer's landed clip was started later and asynchronously by playIO, so the
       unmute never shared a turn with the play and the collision could not happen.

       The rule here is the same one the advance itself follows: THE ADVANCE'S PLAY IS THE AUTHORITY.
       So hand the sound over as its own step, and if that step stops the clip, put it back -- re-mute
       through the STAMPED engine path (an unstamped mute is read as the reader reaching for the mute
       button and flips soundOn plus the saved rova_sound preference for the whole site) and play it
       again. Deliberately a REPAIR rather than a refusal to unmute: whether a given engine and a
       given activation state allow unmuted playback is not something this code can know in advance,
       and guessing wrong in the other direction would cost the reader their sound. Watching for the
       stop is something we can always do correctly.
       Bounded: one listener, 600ms, one repair attempt, and it stands down the moment the reader
       pauses deliberately (_userPaused) or the clip stops being the current slide. */
    function handSound(v) {
      if (!window.__rovaSyncSound) return;
      var wasAsked = !!(v && !v._userPaused);
      try { window.__rovaSyncSound(); } catch (e) { return; }
      if (!wasAsked) return;
      var t = null;
      /* RESUME IT AS IT IS -- UNMUTED. The first cut of this repair re-muted before replaying, and
         that does not fix the collision, it ARMS IT AGAIN: the clip is muted, the next applySound
         pass unmutes it, and the engine stops it a second time. MEASURED under the emulated rule,
         with the repair in place: the trap fired TWICE per advance, 98ms apart, and the clip still
         ended up paused at 0:00. The unmute is not the problem to undo -- it is what the reader
         asked for, and by this point the session has a real gesture behind it (in the reported case
         the tap on "Play the feed" itself), which is exactly the condition under which an UNMUTED
         play() is granted. Replaying it unmuted also cannot re-trigger the rule: there is no
         muted->unmuted transition left to punish, and engineMute() skips no-op sets, so every later
         applySound pass is inert on this element.
         Only a REFUSAL mutes -- the same rule hfPlayCurrent() follows -- and then only through the
         STAMPED engine path, or the volumechange handler reads it as the reader reaching for the
         mute button and flips soundOn plus the saved rova_sound preference for the whole site. */
      var muteRetry = function () {
        if (window.__rovaEngineMute) { window.__rovaEngineMute(v, true); }
        else { v._engineSetAt = Date.now(); v.muted = true; }
        var p2 = v.play(); if (p2 && p2.catch) { p2.catch(function () {}); }
      };
      /* THE GUARD HOLDS FOR THE WHOLE TRANSITION, NOT FOR ONE STOP. A one-shot repair is not enough,
         and the trace says so plainly: the landed clip is stopped TWICE, ~90ms apart. My handoff is
         only the first collision. The second comes from playIO's drag-reveal branch, which mutes and
         re-plays any partially-visible current-slide clip -- during a sideways slide transition that
         is the clip that has just landed -- so it is muted again, the next applySound pass unmutes
         it, and the engine stops it a second time. Measured with the repair one-shot: play at +18ms,
         playing, then stopped again at +160ms and left at 0:00.
         So keep watching for the length of the transition rather than standing down after the first
         save. It converges rather than oscillates: each repair leaves the clip UNMUTED and playing,
         and engineMute() skips no-op sets, so once it settles unmuted there is no transition left to
         punish and the listener simply expires. Bounded by the window, and it stands down instantly
         for a deliberate pause (_userPaused) or once this clip is no longer the current slide -- the
         two cases where a stop is legitimate and must be respected. */
      var onStop = function () {
        if (v._userPaused || v !== slideVideoAt(idx)) { clear(); return; }  // reader stopped it, or it is not current
        if (!v.paused) return;
        var p;
        try { p = v.play(); } catch (e) { muteRetry(); return; }
        if (p && p.catch) { p.catch(muteRetry); }
      };
      function clear() { if (t) { clearTimeout(t); t = null; } try { v.removeEventListener('pause', onStop); } catch (e) {} }
      v.addEventListener('pause', onStop);
      t = setTimeout(clear, 900);
    }
    function slideMedia() {
      if (!carHasVideo || count < 2) return;
      /* ---- THE VIEWER GETS THE HANDOFF, BUT NOT THE WARM WINDOW ------------------------------
         The immersive viewer was excluded from this whole block because it has its own
         warm-ahead and drag-reveal discipline, and that is still right for the PRELOAD tiers --
         the pfeed warms by POST (warmIOPf, PF_LA), and a second per-slide preload policy layered
         on top would fight it. But tax #1 above is not about preloading, it is about nobody
         driving playback from the nav, and the viewer had exactly the same hole: go() moved the
         track and stopped, so every slide the show landed on arrived PAUSED and only started when
         playIO got round to it. MEASURED across 8 consecutive advances in the viewer: `arrive:
         paused:true` every single time, first frame ~1s later -- and because applySound runs off
         that same late callback, the sound handoff lagged the slide with it.
         So the viewer takes the two narrow things: hand the departed slide's decoder back, and
         start the landed one now. No preload tier is touched here. */
      if (carInPfeed) {
        for (var pj = 0; pj < slides.length; pj++) {
          var pvj = slideVideoAt(pj);
          if (pvj && pj !== idx && !pvj.paused) { try { pvj.pause(); } catch (e) {} }
        }
        var pcv = slideVideoAt(idx);
        if (!pcv || document.hidden || !carOnScreen()) return;
        if (window.__rovaPlayNow) { try { window.__rovaPlayNow(pcv); } catch (e) {} }
        handSound(pcv);                                   // ...and the sound follows, without stopping it (see above)
        return;
      }
      var on = carOnScreen(), tight = lineIsTight();
      /* ---- THE WINDOW FOLLOWS THE DIRECTION OF TRAVEL, IT IS NOT SYMMETRIC ---------------------
         This used to promote BOTH neighbours, |i - idx| === 1. But nothing here travels backwards
         on its own: the unengaged tick and the engaged cycle both go FORWARD and both WRAP
         (`idx >= maxIdx ? 0 : idx + 1`). So on the last slide the symmetric window warmed slide
         maxIdx-1, which nothing was about to show, and left slide 0 -- the actual next clip -- out.

         MEASURED on /@grindhd's 5-slide gallery, unengaged, reading the carousel's own index over
         three full laps:
           tier of the incoming clip at each ordinary forward advance   auto, auto, auto ... (13/13)
           tier of the incoming clip at each WRAP advance               metadata (3/3)
         So the mismatch is exactly real. What it is NOT is slow: the wrap reached a running media
         clock in 81ms against 80ms for a forward step. `metadata` keeps whatever a clip already
         holds, and by the time a looping gallery wraps, slide 0 has already been played once -- so
         the tier is wrong but the data is there anyway, and the reader never sees a difference.
         The fix is therefore NOT justified by latency, and claiming it would be would be inventing
         a result. It is justified by the BUDGET, which the same run shows was being broken:
           peak simultaneously LOADING <video>   4        (ceiling is 2)
           peak at preload=auto                  3        (current + two neighbours)
         Over-fetch is the documented failure mode on this surface -- five clips racing for the
         radio made everything slower -- so three growing buffers where two would do is the actual
         defect here, and aiming the one forward slot correctly costs nothing to fix it.

         THE BACKWARD NEIGHBOUR IS NOT DROPPED, it is frozen. It goes to `metadata`, never to
         `none`: metadata tells the engine to stop GROWING the buffer without discarding what is
         already there, so paging back to a slide the reader has just come from is still instant and
         still cannot blank. Only a slide that has never held data at all goes to `none`, exactly as
         before. Swipe-back responsiveness was a deliberate choice and it survives intact. */
      var fwd = (idx >= maxIdx) ? 0 : idx + 1;                          // the slide every advance here goes to
      for (var i = 0; i < slides.length; i++) {
        var v = slideVideoAt(i), d = Math.abs(i - idx);
        if (!v) continue;
        if (d !== 0 && !v.paused) { try { v.pause(); } catch (e) {} }   // off-slide: give the decoder AND the radio back now
        if (d === 0 && on) continue;                                    // the current slide, on screen: promoted below
        if (i === fwd && !tight && on) {
          /* START PATH 4 of 7 (slide, ambient): the forward neighbour's buffer fill. This IIFE cannot
             see the scheduler's scope, so it reaches it the way it already reaches __rovaPlayNow --
             through the single window choke point, guarded, so an older bundle order can never throw
             out of slideMedia. Only claim a slot when this actually starts something: the preload
             promotion on a clip that already holds its data is not a start. */
          if (v.preload !== 'auto') {
            if (window.__rovaVidStart && v.readyState < 3) { window.__rovaVidStart(v); }
            v.preload = 'auto';
          }
          if (v.readyState < 1 && v.getAttribute('src')) {
            if (window.__rovaVidStart) { window.__rovaVidStart(v); }
            try { v.load(); } catch (e) {}
          }
        } else if (d === 1) {
          // the BACKWARD neighbour: hold what it has, never grow it, never discard it (see above)
          if (v.preload !== 'metadata') { v.preload = 'metadata'; }
        } else {
          /* DEMOTE ON THE WAY OUT -- the half that makes "warm the neighbour" affordable.  A
             promotion with no matching demotion is not a +/-1 window, it is a ratchet: every slide
             the reader passes keeps preload=auto forever and keeps filling, so a 5-slide gallery
             ends up holding five auto-buffering clips, which is the memory failure this window
             exists to avoid.  Measured before adding this: at rest the five clips held
             12.5/11.9/8.1/3.9/0s of media; with it, only the current and its one neighbour grow.
             Two rungs down, not one: a clip that has NEVER loaded goes to `none` so it does not
             even fetch metadata, while one that already has data goes back to `metadata`, which
             tells the engine to stop growing the buffer without discarding what is there (so
             swiping back is still instant, and nothing blanks). */
          var want = (v.readyState < 1) ? 'none' : 'metadata';
          if (v.preload !== want) { v.preload = want; }
        }
      }
      var cv = slideVideoAt(idx);
      armCycle();                                                                    // re-decide the end-of-clip advance for the slide we just landed on
      if (!cv || !on || document.hidden) return;
      if (window.__rovaPlayNow) { try { window.__rovaPlayNow(cv); } catch (e) {} }   // preload=auto + silent mute + play()
      handSound(cv);                        // ...and the sound follows the slide, without stopping it (see above)
    }

    /* ---- ON CLIP END, PLAY THE NEXT ONE  (owner 2026-08-07) ---------------------------------
       "When pressing play on the video -- that's part of multiple videos in the same post --
        instead of repeating the same video it should start playing the next video in the post."

       ONE RULE WITH TWO CLOCKS, not two features. A multi-video gallery already auto-advanced
       every 4200ms (autoTick, below) and that IS the owner's unengaged case -- "if I don't engage
       it should still play a couple of seconds of the first clip then move to the next and loop".
       Measured on /@grindhd 15076 before this change: slides stepped 0->1->2->3->4->0 at exactly
       4.2s, one clip un-paused at a time, wrapping. That half already worked.

       What was missing is the OTHER half, and the two are exact complements. Every video carries
       loop=true (wire(), and views/_post.php emits the attribute), so a clip the reader deliberately
       started never ends -- it WRAPS, forever, and the 4.2s tick that would otherwise have moved on
       is deliberately suppressed while they are engaged (autoTick reads engAttnUntil(), and
       engAttendFrom hands the card __autoPause(ENG_QUIET) on any deliberate touch). So the exact
       state the owner described -- pressed play, gallery frozen, same clip repeating -- is the
       engagement hold working as designed with nothing on the other side of it. This block is that
       other side: while the hold is on, the CLIP's own end is the clock instead of the timer.

       HOW "ENGAGED" IS DETECTED: engVideo() -- the function whose entire contract is already
       "wired lazily FROM THE TAP HANDLERS only, so an autoplaying clip never registers" -- stamps
       __cycEng on the gallery. It is reached from the transport play button, a tap on the clip
       itself, and a tap for sound; it is NOT reached by autoplay, by scrolling, or by the 4.2s
       tick's own advance. So "engaged" means a finger deliberately started or unmuted THIS
       gallery's video. The stamp then decays on the site's existing ENG_QUIET clock (120s, the
       presence number, [[engagement-attention-hold]]) so this adds no ninth mechanism and no new
       constant -- except that WATCHING renews it: while the clip is genuinely advancing its own
       clock the stamp is re-taken, because a 164s clip (slide 3 of that very post) would otherwise
       lapse mid-watch and let the 4.2s tick yank the slide out from under the reader at t+120s.

       WHY IT CANNOT FIGHT THE READER:
         - a manual swipe/arrow/dot routes through go(), which re-runs slideMedia -> armCycle: the
           pass is torn down and re-armed for the slide they chose, and go()'s existing 7s hold
           still parks the 4.2s tick.  (7000ms is also the native app's manual-swipe hold.)
         - PAUSE never advances. __rovaVideoOnePass only completes on a wrap or a real 'ended', and
           the stall backstop below explicitly stands down while the clip is paused, so a reader who
           hits pause sits on that slide for as long as they like.
         - a scrub is a pause-and-seek to the element; no wrap is manufactured by seeking backwards.
         - the tab going hidden, or the card leaving the screen, disarms it.
       REDUCED MOTION: the unengaged auto-swipe stays switched off entirely (unchanged - it is
       motion nobody asked for). The engaged advance still happens, because "don't repeat the clip
       I started" is a playback rule and not decoration, but it lands the next slide with NO slide
       animation (__cgo), so the surface never animates for a reader who asked it not to. */
    var CYC_STALL_MS = 8000;             // clock frozen this long on a clip that should be playing = move on (native HF_STALL_MS)
    var _cycT = null;
    /* ---- ONE PASS OVER ONE CLIP, the version both auto-advancers on this element need --------
       There are TWO of them -- the feed card's engaged cycle below, and the immersive viewer's
       sit-back slideshow (`step()` further down) -- and they need identical answers to "has this
       clip finished?". `__rovaVideoOnePass` is the shared wrap detector and stays the source of
       truth for that, but on its own it gets two cases wrong, BOTH MEASURED:

       1. ITS DEADLINE IS WALL-CLOCK. It derives a `setTimeout` from the clip's remaining duration;
          pausing the clip does not pause that timer. Proved on 15076 slide 1: paused at 2.8s of a
          21.3s clip, sat still for 18s, then got advanced anyway at ~24s. Fighting the member.
       2. ITS CAP HAS TO BE GENEROUS, AND THEN NOTHING CATCHES A CLIP THAT NEVER STARTS. The
          viewer was passing 90000, which silently cut slide 1 of that post short at 90s of its
          102.3s and would have cut slide 3 at 90s of 164.4s. Raising the cap alone would let a
          vetoed or starved clip park the gallery for a quarter of an hour.

       So: rebuild the inner pass across pause/resume (a pause SUSPENDS, it never advances and
       never forgets), and back it with an 8s no-progress test -- the native app's HF_STALL_MS --
       which is both faster than any cap and cannot mis-fire on a long clip because it only ever
       looks at whether the clock is MOVING. Calls back exactly once. Returns a cancel().
       Writing this once is the point: two copies of "play it out, don't cut it off" is precisely
       how the two ends of that rule quietly drift apart. */
    function clipPass(v, onEnd, endEarly) {
      var done = false, inner = null, poll = null, lastT = -1, still = 0;
      function drop() { if (inner) { try { inner(); } catch (e) {} inner = null; } }
      function build() { if (!done && !inner) { inner = window.__rovaVideoOnePass(v, fire, 900000); } }
      var onPause = function () { drop(); };            // suspend: no clock runs while the clip is stopped
      var onPlay = function () { build(); };            // ...and rebuild from wherever they resumed
      /* ---- END THE PASS AT THE END OF THE CLIP, NOT AFTER IT HAS RESTARTED --------------------
         `__rovaVideoOnePass` detects a finished clip as a WRAP: it waits for a `timeupdate` whose
         currentTime has jumped BACK to ~0 from near the duration. That is correct but it is late by
         construction, because wire() sets loop=true on every post video -- so between "this clip is
         done" and "we noticed" the element has already RESTARTED, and the advance cannot fire until
         the restarted clip has produced a timeupdate of its own.

         MEASURED on /p/15396 (two clips, 89.9s + 76.2s), Chromium, timed from the last frame of the
         OUTGOING clip that the compositor actually presented:
           unthrottled          wrap -> `waiting` -> canplay 95ms later -> advance    -> 224ms gap
           1.5Mbps at handover  wrap -> `waiting` -> canplay 1422ms later -> advance   -> 1525ms gap
         The whole 1.4s is the OUTGOING clip re-buffering its own restart -- bytes fetched for a
         repeat nobody is going to watch, with the advance queued behind them. On a slow line that
         is the entire hang, and no amount of preloading the INCOMING clip can touch it, because the
         incoming clip was never what we were waiting for. (Its readyState was 4 with 15.5s buffered
         in both runs.)

         So end the pass when the clip REACHES its end. The wrap detector stays as the backstop --
         it is the only thing that works when the duration is unknown (HLS with a live/rolling
         playlist, a fresh element whose duration is still NaN), and it also catches a clip that
         jumps back early for any other reason.
         WHY 0.35s AND NOT 0.15s: `timeupdate` is delivered roughly every 250ms, so a window
         narrower than that granularity is not guaranteed to contain a sample at all -- the last
         sample before the end lands at d-0.26 and the next one is already past the wrap. 0.35s
         always contains at least one sample and is under two frames of a 60fps clip short of the
         end, which is not a perceptible truncation. Only ever applies to a clip that is genuinely
         PLAYING (never to a paused clip parked near its end by a scrub, which must keep sitting
         there -- pause suspends this pass, it never advances it) and only when the duration is
         real.

         OPT-IN, AND ONLY THE CAROUSEL CYCLE OPTS IN. The other caller of clipPass is the immersive
         viewer's sit-back slideshow, whose clips live inside .pfeed -- and the play-count beacon
         watches exactly those, counting a completed play by detecting the WRAP on a document-level
         timeupdate listener. Ending the pass before the clip wraps would mean the show pauses it
         first and that play is never counted. The engaged carousel cycle has no such exposure: it
         refuses to run inside the pfeed at all (armCycle bails on carInPfeed), so no clip it drives
         is ever a candidate for the beacon. Hence a flag rather than a change of behaviour for both. */
      var END_LEAD = 0.35;
      var onEdge = function () {
        if (done || v.paused || v._userPaused) return;
        var d = v.duration, t = v.currentTime || 0;
        if (d && isFinite(d) && d > 1.5 && t >= d - END_LEAD) { fire(); }
      };
      function teardown() {
        drop();
        if (poll) { clearInterval(poll); poll = null; }
        try { v.removeEventListener('pause', onPause); } catch (e) {}
        try { v.removeEventListener('play', onPlay); } catch (e) {}
        try { v.removeEventListener('timeupdate', onEdge); } catch (e) {}
      }
      function fire() { if (done) return; done = true; teardown(); try { onEnd(); } catch (e) {} }
      v.addEventListener('pause', onPause);
      v.addEventListener('play', onPlay);
      if (endEarly) { v.addEventListener('timeupdate', onEdge); }
      poll = setInterval(function () {
        if (done) return;
        if (!v.isConnected || !c.isConnected) { teardown(); return; }
        if (v.paused || v._userPaused) { still = 0; lastT = v.currentTime || 0; return; }   // stopped by the reader: hold here
        var t = v.currentTime || 0;
        if (t > lastT + 0.05) {
          lastT = t; still = 0;
          // WATCHING IS ENGAGEMENT. Without this a 164s clip would outlive the 120s stamp and the
          // 4.2s tick would yank the slide out from under someone mid-watch. Only ever RENEWS an
          // existing stamp -- the viewer's show also runs unengaged and must not manufacture one.
          if (c.__cycEng) { c.__cycEng = Date.now(); }
          return;
        }
        still += 1000;
        if (still >= CYC_STALL_MS) { fire(); }          // vetoed / starved / torn down: don't strand the gallery
      }, 1000);
      build();
      return function () { done = true; teardown(); };
    }
    function cycPhotoMs() {
      // A PHOTO slide inside a mixed gallery has no "end", so it gets a fixed dwell -- the same
      // rova_ss_ms the sit-back slideshow uses, default 3500ms, which is also the native app's
      // ssMs default. One number for a photo dwell on this site, not three.
      var ms = 0; try { ms = parseInt(localStorage.getItem('rova_ss_ms'), 10) || 0; } catch (e) {}
      return ms > 0 ? ms : 3500;
    }
    function cycEngaged() { return !!c.__cycEng && (Date.now() - c.__cycEng) < ENG_QUIET; }
    /* A PAUSE MUST SUSPEND THE CYCLE, NEVER FORGET IT -- MEASURED, this was the second real defect
       here, and it is now handled INSIDE clipPass rather than by a second teardown level. playIO
       pauses any clip under 55% visibility, and during the long track transition of the WRAP
       (slide 4 back to slide 0) the incoming clip dips under that for a beat and takes a transient
       pause. That pause is not the reader. An earlier cut tore the whole pass down on it, removing
       the very 'play' listener that would have re-armed a moment later, so the gallery went quiet
       at slide 0 and never moved again (proved: the cycle died after exactly one lap). clipPass now
       keeps its own listeners across a pause, so there is one teardown here again. */
    function cycClear() {
      if (_cycT) { try { _cycT(); } catch (e) {} _cycT = null; }
      c.__cycPass = false;
    }
    function cycAdvance() {
      cycClear();
      if (!c.isConnected) { cycRelease(c); return; }
      if (document.hidden) {                                  // never churn a backgrounded tab; look again shortly
        c.__cycPass = true;
        var ht = setTimeout(armCycle, 1500);
        _cycT = function () { clearTimeout(ht); };
        return;
      }
      if (!carOnScreen()) { cycRelease(c); return; }
      if (!cycEngaged()) return;                              // NOT a release: the 4.2s tick may legitimately still own the slot
      var nx = (idx >= maxIdx) ? 0 : idx + 1;                 // wrap at the last slide, same rule as autoTick
      var rm = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
      c.__autoTicking = true;                                 // an AUTO advance: go() must not treat it as a manual page
      if (rm && c.__cgo) { c.__cgo(nx); } else { go(nx); }     // go() -> slideMedia() -> armCycle() for the new slide
      c.__autoTicking = false;
    }
    /* ---- ...AND THE NEXT CLIP IS ALREADY RUNNING WHEN IT SLIDES IN  (owner 2026-08-08) ---------
       "When this video is done and the next one slides in it should be already playing."

       The slide-media block above already promotes exactly ONE neighbour to preload=auto, and that
       part is right and stays exactly as it is -- the documented failure mode on this surface is
       OVER-fetch, not under-fetch (five clips buffering at once, 119MB racing for the radio, which
       made everything slower). This is not more bytes. Measured at the handover on /p/15396 the
       incoming clip was ALREADY readyState 4 with 15.5s buffered, and still took 285ms (unthrottled)
       to present its first advancing frame, 1583ms with a 1.5Mbps line at the handover.

       BUFFERED IS NOT THE SAME AS READY TO RUN. A paused element at preload=auto has bytes; it has
       no instantiated decoder and it has never presented a frame. `play()` on it still has to spin
       the decoder up, decode from the first keyframe and get a frame to the compositor, and that
       cost lands entirely inside the slide transition the reader is watching. The only way to pay it
       in advance is to actually PLAY the element -- so play it, for the one frame it takes to prove
       the pipeline is live, then stop. What is left behind is an element with a warm decoder sitting
       on a decoded frame at the very start of the clip, which `__rovaPlayNow` can resume in one
       frame instead of rebuilding.

       STILL EXACTLY ONE CLIP AHEAD. primeNext() only ever touches slideVideoAt(idx + 1) -- the same
       single element the preload window already promotes, so the peak number of simultaneously
       loading <video> elements is unchanged (measured 2 before, 2 after, and 2 is the +/-1 window
       working as designed). It is a ONE-SHOT: `_cycPrimed` is sticky while the element still holds
       readyState >= 3, so a gallery looping round and round primes each clip once, not once a lap.

       AUDIO IS THE THING THAT MUST NOT LEAK. This starts a clip that is paged OFF SLIDE, and an
       off-slide clip becoming audible would be a far worse bug than the hang it fixes. Three
       independent guarantees, in order:
         1. it is engine-muted BEFORE play() is called -- muted through __rovaEngineMute so the
            volumechange handler reads it as the engine and not as the reader reaching for the mute
            button (an unstamped mute here would flip soundOn and the saved preference for the whole
            site, which is a defect this file has already been bitten by twice);
         2. applySound() cannot hand it the sound back, because activeVideo()'s timeline branch only
            considers clips that pass inView(), and inView() carries onCurrentSlide() -- a clip paged
            off to the side is not a candidate at all. Every applySound pass therefore actively
            re-mutes it;
         3. it is muted for the whole of its life as a primed clip -- it is never unmuted here, in
            either direction. The clip that lands on the slide is unmuted by the EXISTING handoff
            (__rovaSyncSound, called from slideMedia after __rovaPlayNow), which is untouched, so an
            unmuted predecessor still hands its sound forward exactly as it did before.
       And it declines to start anything the reader has deliberately stopped (_userPaused), anything
       already running, a released element, a card that is not on screen, a hidden tab, and a tight
       line -- the same vetoes the preload window uses, for the same reasons.

       IF THE READER SWIPES INTO IT MID-PRIME the primer must not touch it: settle() asks whether the
       element is now the CURRENT slide, and if it is, hands off without pausing -- it belongs to
       slideMedia/__rovaPlayNow from that moment, and stopping it there would be the primer stopping
       the video the reader just swiped to. */
    var CYC_PRIME_CAP = 2000;                 // a prime that has not produced a frame by now is not going to
    function primeNext() {
      if (carInPfeed || !carHasVideo || count < 2) return;   // the viewer has its own warm-ahead discipline
      if (document.hidden || !carOnScreen() || lineIsTight()) return;
      /* AUTOPLAY OFF MEANS OFF. __rovaPlayNow refuses to start the landed clip when the reader has
         turned autoplay off in the gear, so priming for an advance that is not going to autostart is
         both wasted bytes and a clip started against a setting that says not to. Read defensively:
         if feedPref is ever moved out of this scope the prime simply keeps its old behaviour rather
         than throwing out of armCycle. */
      var apOn = true;
      try { apOn = feedPref('autoplay', true); } catch (e) {}
      if (!apOn) return;
      var nx = (idx >= maxIdx) ? 0 : idx + 1;               // wrap at the last slide, same rule as cycAdvance
      var v = slideVideoAt(nx);
      if (!v || v === slideVideoAt(idx)) return;            // a photo slide, or a one-video gallery
      if (v._userPaused || v._released || !v.paused) return;
      if (v._cycPrimed && v.readyState >= 3) return;        // one shot per element, while it still holds its data
      /* START PATH 7 of 7 (700ms timer, ambient). A prime COUNTS and is never refused -- nothing here
         is -- but it is off-slide, so it is furthest from the viewport centre and is therefore the
         first slot surrendered when a visible clip wants one. That is the priority order the design
         asked for, and it is why a carousel cannot starve itself: its own prime is never the thing
         refused, only the thing given up. Claimed before the src re-attach below, which is the point
         at which bytes are first asked for. */
      if (window.__rovaVidStart) { window.__rovaVidStart(v); }
      if (!v.getAttribute('src') && v._mp4src) { try { v.setAttribute('src', v._mp4src); } catch (e) {} }
      if (!v.getAttribute('src')) return;                   // nothing attached yet: the preload tier still applies
      v._cycPrimed = 1;
      if (v.preload !== 'auto') { v.preload = 'auto'; }
      /* PRIME THE START OF THE CLIP, NOT WHEREVER IT WAS LEFT. On the wrap-around (last slide -> first)
         the clip being primed is the one the gallery has just finished, so it is parked near its END --
         and priming from there warms the decoder on bytes nobody is going to watch, then throws them
         away in the rewind below. MEASURED on /p/15396 at 1.5Mbps: the wrap-around prime played from
         89.68s, rewound, and spent 2.6s re-fetching the head it had skipped. Seek first and the one
         frame we decode is the first frame the reader will actually see. */
      try { if ((v.currentTime || 0) > 0.35) { v.currentTime = 0; } } catch (e) {}
      var fin = false, cap = null, primeAt = Date.now();
      if (window.__rovaEngineMute) { window.__rovaEngineMute(v, true); }   // SILENT, and stamped -- see above
      else { v._engineSetAt = Date.now(); v.muted = true; }
      function settle() {
        if (fin) return;
        fin = true;
        if (cap) { clearTimeout(cap); cap = null; }
        try { v.removeEventListener('timeupdate', look); } catch (e) {}
        try { v.removeEventListener('loadeddata', look); } catch (e) {}
        /* HANDS OFF ONLY IF THIS ELEMENT IS NOW THE CURRENT SLIDE -- then it is the clip the reader
           is looking at, it belongs to slideMedia/__rovaPlayNow, and pausing it here would be the
           primer stopping the video they just swiped to. The test has to be "is it the current
           slide", NOT "is the gallery still where it was": a reader who pages somewhere else
           entirely leaves this element neither current nor stopped, and a muted clip running off
           screen for the life of the card is exactly the leak the +/-1 window exists to prevent. */
        if (v === slideVideoAt(idx)) return;
        /* ...AND THE ADVANCE'S PLAY OUTRANKS THIS PAUSE OUTRIGHT. The slide test above is positional,
           so it is only ever as correct as `idx` is at this instant -- and there is more than one way
           to move a gallery (go(), the reduced-motion __cgo, the pfeed's step()). A stop this primer
           armed while the clip was still off-slide must never be able to land on a clip __rovaPlayNow
           has started since, whatever the slide bookkeeping says, so ask that directly: it stamps
           _playNowAt on every clip it starts. This is the difference between "probably not current"
           and "the advance has claimed it", and it is the guarantee that a primed clip can never be
           the paused-at-0:00 clip the reader is looking at. */
        if ((v._playNowAt || 0) > primeAt) return;
        try { v.pause(); } catch (e) {}
        // Rewind ONLY if the prime overran. A seek is not free and one left in flight at the moment
        // of the handover would cost more than the 2-3 frames it reclaims; a clip resuming from
        // ~0.05s is not a perceptible truncation, and the seek that IS worth doing is the one that
        // stops a long overrun accumulating each time the gallery comes round again.
        try { if ((v.currentTime || 0) > 0.35) { v.currentTime = 0; } } catch (e) {}
      }
      function look() { if (!fin && (v.currentTime || 0) > 0 && v.readyState >= 3) { settle(); } }
      v.addEventListener('timeupdate', look);
      v.addEventListener('loadeddata', look);
      // requestVideoFrameCallback is the exact signal -- "a frame has been handed to the compositor",
      // which is the whole point of priming -- but it is absent on Safari <15.4 and it does not fire
      // for an element the engine has decided not to composite, so the listeners above and the cap
      // below are the ones that actually have to be correct.
      if (v.requestVideoFrameCallback) { try { v.requestVideoFrameCallback(function () { settle(); }); } catch (e) {} }
      cap = setTimeout(settle, CYC_PRIME_CAP);
      try {
        var pr = v.play();
        if (pr && pr.catch) { pr.catch(function () { settle(); }); }   // autoplay vetoed: leave it exactly as it was
      } catch (e) { settle(); }
    }
    function armCycle() {
      cycClear();
      if (!carHasVideo || carInPfeed || count < 2) return;     // all-photo galleries keep the plain 4.2s tick
      if (!c.isConnected) { cycRelease(c); return; }
      /* NOT engaged is not a release. The slot is shared with the unengaged 4.2s tick, and every
         advance runs slideMedia -> armCycle; releasing here handed the slot back on every single
         tick, so it was permanently free and the budget bounded nothing (measured: two galleries
         both read owner:false while one was advancing). Only leaving the screen, or the card being
         torn down, gives the slot up. */
      if (!cycEngaged()) return;
      /* A BACKGROUNDED TAB DISARMS BUT DOES NOT FORGET. Bailing outright here left a measurable
         hole: the clip keeps running in a hidden tab, wraps unseen (proved: ct 18.3 -> 2.8 -> 14.8
         with the slide never moving, which is the behaviour we want) -- but nothing then re-armed
         when the reader came back, so the gallery sat engaged-and-idle until some unrelated event
         happened to call slideMedia again. Re-check instead of giving up. The timer is one per
         engaged gallery, browsers throttle it hard in a background tab, and it self-terminates
         either when the card goes (isConnected) or when the stamp lapses -- nothing renews
         __cycEng while hidden, because the stall poll that renews it is torn down here. */
      if (document.hidden) {
        c.__cycPass = true;
        var vt = setTimeout(armCycle, 1500);
        _cycT = function () { clearTimeout(vt); };
        return;
      }
      if (!carOnScreen()) { cycRelease(c); return; }
      if (!cycClaim(c)) return;                               // another gallery holds the one cycle slot
      var v = slideVideoAt(idx);
      c.__cycPass = true;
      if (!v) {                                               // photo slide: a fixed dwell, then move on
        var pt = setTimeout(cycAdvance, cycPhotoMs());
        _cycT = function () { clearTimeout(pt); };
        return;
      }
      _cycT = clipPass(v, cycAdvance, true);    // pause-aware + stall-backed + ends AT the end; see clipPass above
      /* ...and get the clip AFTER this one ready to run (primeNext, above) -- but A BEAT LATER, never
         in this same turn. armCycle() is called from slideMedia() BEFORE __rovaPlayNow() starts the
         clip that just landed, so priming synchronously would put the NEXT clip's first request ahead
         of the current one's in the queue, and the clip the reader is actually looking at must always
         win the pipe (that ordering is the whole reason the preload window is +/-1 and not the
         gallery). 700ms is long enough for the landed clip's own first frames to be in flight, and
         far shorter than any clip. Cancelled with the pass, so a slide the reader leaves primes
         nothing. */
      var _pt = setTimeout(primeNext, 700);
      var _pass = _cycT;
      _cycT = function () { clearTimeout(_pt); try { _pass(); } catch (e) {} };
    }
    c.__cycArm = armCycle;                                    // engVideo() calls this the moment a finger starts a clip
    c.__cycState = function () { return { eng: cycEngaged(), pass: !!c.__cycPass, owner: _cycOwner === c, idx: idx }; };
    // The FIRST swipe has to be ready too, so warm the neighbour as soon as the card is genuinely on
    // screen -- not only after a slide change. Self-terminating like the auto-advance observer below:
    // a card the virtualiser stubs takes its observer with it.
    if (carHasVideo && !carInPfeed && count > 1 && 'IntersectionObserver' in window) {
      var _mIO = new IntersectionObserver(function (ents) {
        if (!c.isConnected) { try { _mIO.disconnect(); } catch (e) {} return; }
        // BOTH directions. Only running this on the way IN was a one-way ratchet: a card scrolled
        // away kept its promoted neighbour at preload=auto and went on filling its buffer off
        // screen (measured: the five clips held 45s of media at rest, MORE than before the window
        // existed). On the way out `carOnScreen()` is false, so the loop below demotes everything,
        // including the slide that was current -- a card the reader has left warms nothing.
        for (var i = 0; i < ents.length; i++) { if (ents[i]) { slideMedia(); break; } }
      }, { threshold: [0, 0.55] });
      try { _mIO.observe(c); } catch (e) {}
    }
    // re-measure + snap on rotation / resize (portrait<->landscape flips per-view 1<->2).
    // Through the shared registry -- a per-carousel window listener leaks the element (see above).
    onCarouselResize(c, applyLayout);
    /* ...and re-run it when the CARD's geometry changes without the WINDOW changing. applyLayout pins an
       absolute px width; a window 'resize' was the only thing that ever recomputed it, so anything that
       narrows or widens the column on its own -- a sidebar folding in, the watch-mode layout, a virtualiser
       restore, a font/zoom reflow, a container query -- left a stale width pinned and the media hung out
       past the card border (.post is overflow:visible). Four things here are load-bearing:
         1. box:'border-box'. Same lesson as the tab-strip row observer below: a fold that trades padding
            or margin for width is INVISIBLE to a content-box observation.
         2. Observe c.parentElement, NEVER c. applyLayout writes c.style.width, so observing c itself is a
            straight feedback loop. (.post-main is min-width:0 inside the flex post-row, so pinning the
            carousel wide does not push its parent back out.)
         3. Gate on a real INLINE-size change. applyLayout also writes c.style.height, and a height-only
            change must not pump this.
         4. Disconnect on !c.isConnected. Unlike a window listener this holds no root reference, so when
            the feed virtualiser stubs the card the observer, this callback and the card all become
            garbage together -- keep it that way (see the shared-listener note above). */
    if (window.ResizeObserver && c.parentElement) {
      var _cwIS = -1;
      var _cwRO = new ResizeObserver(function (ents) {
        if (!c.isConnected) { _cwRO.disconnect(); return; }
        var e0 = ents && ents[0]; if (!e0) return;
        var bs = e0.borderBoxSize; if (bs && bs.length) bs = bs[0];
        var is = Math.round(bs ? bs.inlineSize : (e0.contentRect ? e0.contentRect.width : 0));
        if (is === _cwIS) return;                 // height-only churn: our own writes must not pump this
        _cwIS = is;
        try { applyLayout(); } catch (err) {}
      });
      try { _cwRO.observe(c.parentElement, { box: 'border-box' }); }
      catch (err) { try { _cwRO.observe(c.parentElement); } catch (e2) {} }
    }
    // permalink deep link: open this carousel on the slide the URL names.
    // (first carousel on the permalink page only, and only once)
    //   ?slide=3  1-BASED, the shareable term every copy/share/embed affordance now stamps
    //   #m2       0-BASED, the older profile-grid link. Both stay live and neither is rewritten in
    //             terms of the other: two bases with one name would be a permanent off-by-one trap.
    // No clamp here on purpose -- go() already clamps to [0, maxIdx], which is exactly the
    // "an index the author has since deleted lands on the nearest real slide" behaviour we want.
    if (!window._mHashUsed && location.pathname.indexOf('/p/') === 0) {
      var mh = (location.hash || '').match(/^#m(\d+)$/);
      var qs = (location.search || '').match(/[?&]slide=(\d+)/);
      var want = mh ? parseInt(mh[1], 10) : (qs ? parseInt(qs[1], 10) - 1 : -1);
      if (want >= 0) { window._mHashUsed = true; _navSilent++; try { go(want); } finally { _navSilent--; } }
    }
    if (prev) prev.addEventListener('click', function (e) { e.stopPropagation(); go(idx - 1); });
    if (next) next.addEventListener('click', function (e) { e.stopPropagation(); go(idx + 1); });
    for (var d = 0; d < dots.length; d++) {
      (function (i) { dots[i].addEventListener('click', function (e) { e.stopPropagation(); go(i); }); })(d);
    }
    // rubber-band nudge when swiping past the first / last slide
    /* A DEAD-END SWIPE IS STILL A SWIPE. bounce() is the rubber-band for a page past the first or
       last slide, and it is reached ONLY from the three manual gestures (touchend, the trackpad
       wheel, the mouse drag) -- never from an advance. It does not call go(), so without this the
       one moment the reader is MOST likely to be swiping hard (the owner's screenshot is 10/10)
       was the one moment the feed did not notice. Same hold, same quiet period, same function:
       "until I'm idle again" cannot depend on whether the gallery had anywhere left to go. */
    function bounce(dir) {
      try { engAttnArm(ENG_QUIET); } catch (e) {}
      var base = -(idx * sw), off = dir < 0 ? 24 : -24;   // dir<0 past start -> nudge right
      track.style.transition = 'transform .17s ease';
      track.style.transform = 'translateX(calc(' + base + '% + ' + off + 'px))';
      setTimeout(function () {
        track.style.transform = 'translateX(' + base + '%)';
        setTimeout(function () { track.style.transition = ''; }, 190);
      }, 170);
    }
    // Touch paging: DECIDE horizontal-vs-vertical early and LOCK a side swipe (preventDefault) so it can't
    // leak into the feed's vertical scroll -- the old handler was passive and only checked at touchend, so
    // any diagonal drag scrolled the page instead of paging the carousel. HORIZ_BIAS is the lever: a swipe
    // counts as horizontal when |dx| >= |dy| * HORIZ_BIAS. 1.0 = "leans horizontal at all"; lower it to make
    // side swipes even stickier, raise it to favour vertical scrolling.
    var HORIZ_BIAS = 1.0;
    // WHO OWNS THIS GESTURE IS DECIDED BY WHERE IT BEGAN, NOT BY WHICH WAY IT MOVES.
    // The decision below (|dx| >= |dy|) can only tell a swipe from a scroll -- it cannot tell a swipe
    // from a SCRUB, because dragging the video's progress bar is horizontal by definition. So a finger
    // put on .vc-seek and dragged used to arm this pager, cross the 8px threshold, preventDefault the
    // move (which also kills the seek's own pointer stream mid-drag, so the scrub stopped short) and
    // then flip the slide at touchend. Owner 2026-08-05: "using the progress bar is impossible because
    // it's passing touches through the video and slides to the next or previous medias in the post."
    // CONTROLS is the origin test. A gesture that STARTS on a player control belongs to that control
    // for its whole life, until the finger lifts -- nothing here may claim it partway through. This is
    // the same rule the mouse path below already applied ('.vctrl, button, a, input, .pf-act') and the
    // gallery lightbox stage applies ('.vctrl,.vc-sound,.vc-btn,.vc-seek'); only the TOUCH path was
    // missing it. Deliberately NOT the whole .vctrl container: the bar's empty space (.vc-row gaps,
    // the time readout) stays swipeable, so the swipe area does not shrink anywhere it matters. And
    // when the bar is hidden it is pointer-events:none (rova.css), so a swipe across the bottom of a
    // playing clip never even matches this -- it hits the video and pages exactly as before.
    var CONTROLS = '.vc-seek, .vc-btn, .vc-sound, .pf-act, button, a, input, select, textarea, label';
    var sx = 0, sy = 0, sActive = false, sDecided = false, sHoriz = false, tMoved = false;
    track.addEventListener('touchstart', function (e) {
      if (e.target && e.target.closest && e.target.closest(CONTROLS)) {
        sActive = false; sDecided = false; sHoriz = false; tMoved = false;   // the control owns it; stand down
        return;
      }
      sx = e.touches[0].clientX; sy = e.touches[0].clientY;
      sActive = true; sDecided = false; sHoriz = false; tMoved = false; track.style.transition = 'none';
    }, { passive: true });
    track.addEventListener('touchmove', function (e) {
      if (!sActive) return;
      var dx = e.touches[0].clientX - sx, dy = e.touches[0].clientY - sy;
      if (!sDecided) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;       // too small to tell yet
        sHoriz = Math.abs(dx) >= Math.abs(dy) * HORIZ_BIAS; sDecided = true;
        if (!sHoriz) { sActive = false; track.style.transition = ''; return; }   // vertical: let the feed scroll
      }
      if (sHoriz) {
        e.preventDefault();                                     // lock the side swipe: no vertical scroll
        tMoved = true;                                          // a real horizontal drag: suppress the trailing
        // synthesized click so a FAILED "barely swipe" can't leak a phantom tap into the pfeed zoom handler
        // (iOS still fires a click after a small preventDefault'd drag). Mirrors the mouse path's mMoved.
        var base = -(idx * sw);
        var pull = dx;
        if ((idx === 0 && dx > 0) || (idx >= maxIdx && dx < 0)) { pull = dx * 0.35; }   // resist past an edge
        track.style.transform = 'translateX(calc(' + base + '% + ' + pull + 'px))';
      }
    }, { passive: false });
    track.addEventListener('touchend', function (e) {
      if (!sActive) return; sActive = false; track.style.transition = '';
      if (!sHoriz) return;
      var dx = e.changedTouches[0].clientX - sx;
      var w = track.getBoundingClientRect().width || 1;
      var threshold = Math.min(64, w * 0.18);                   // travel needed to flip a slide
      if (Math.abs(dx) <= threshold) { update(); return; }      // not far enough: snap back to the current slide
      var dir = dx < 0 ? 1 : -1, target = idx + dir;
      if (target < 0 || target > maxIdx) { bounce(dir); }       // at an edge: rubber-band
      else { go(target); }
    }, { passive: true });
    // desktop trackpad / Magic Mouse: a two-finger HORIZONTAL swipe pages the slideshow (mouse wheels
    // only send deltaY, so they fall through to normal vertical scroll). ONE SLIDE PER GESTURE, and the
    // gesture's whole momentum tail is swallowed until the wheel stream goes QUIET.
    // WHY NO "RE-ACCELERATION" RELEASE (owner 2026-09-03, Magic Mouse: "I swiped left and it went all the
    // way to the last post when there's 3 whole slides to get through"). The previous lock released the
    // moment an event's magnitude climbed more than 8px above the one before it, on the theory that a
    // decaying tail is monotonic and only a fresh flick climbs. A Magic Mouse tail is NOT monotonic: the
    // OS emits it in bursts and the browser coalesces neighbours, so a single swipe's stream reads
    // 53, 51, 60, 44, 58 ... and every bump past +8 re-armed the pager -- reproduced with a synthetic
    // 25-event decaying burst landing on slide 4 of 9 for one swipe. There is no magnitude test that
    // tells a bump from a flick, so the lock got two release paths, both unambiguous  -- INCOMPLETE,
    // see the 2026-09-19 block below: on their own these two latch the carousel shut:
    //   1. the stream has been silent for WHEEL_QUIET_MS (the timer is the guaranteed release -- a gate
    //      that waits for an event that may never come is the "pause without a resume" hazard); or
    //   2. deltaX changes SIGN, which no tail does on its own -- the reader reversed.
    // The cost is deliberate: a second flick fired INSIDE the first one's tail waits for the tail to end.
    // preventDefault stops the browser's own back/forward history swipe. Touch has its own pager above
    // (ownership by origin) and keyboard / .cnav / dots call go() directly; none of them come through here.
    // WHY QUIET-OR-REVERSAL ALONE WAS NOT ENOUGH (owner 2026-09-19, Magic Mouse, a 4-photo post:
    // "my magic mouse only lets me swipe to the next photo here but there's 4 photos, holding the
    // mouse button down allows me to scroll to the rest of them"). The lock above releases on a
    // QUIET TIMER -- and every swallowed tail event CLEARED AND RE-ARMED that timer. So the quiet
    // the lock is waiting for is quiet the reader is not allowed to produce: swipe again inside the
    // tail and the second swipe's events, swallowed, push the release another 220 ms out. A reader
    // who keeps swiping keeps the lock alive forever. Measured on /p/53580 before this change:
    // four swipes 450 ms apart landed on slide 2 and stopped, and slide 3 needed a full 1.4 s of
    // doing nothing. The click-and-drag path has no such lock, which is exactly why it still worked.
    // A lock whose only release is a timer that its own swallowed input re-arms is not a lock, it is
    // a latch -- the same "pause without a resume" shape as [[web-open-hang-five-rounds]].
    // The two new release paths below are both statements about the TAIL, not about magnitude
    // re-acceleration (which was tried in 2026-09-03 and died on jitter: a bump cannot be told from
    // a flick). A tail has no holes, and a tail is spent after ~a second.
    var WHEEL_SLIDE_PX = 45;    // accumulated |deltaX| (px, deltaMode-normalised) that commits ONE slide
    var WHEEL_QUIET_MS = 220;   // silence on the wheel stream that ends a gesture and releases the lock
    var WHEEL_GAP_MS = 90;      // a HOLE this long in the stream is a gesture boundary (release path 3)
    var WHEEL_GAP_PX = 12;      // ...but only if what lands after the hole is real input, not tail dust
    var WHEEL_LOCK_MS = 800;    // no momentum tail still carries real energy this long after its commit
    var WHEEL_REARM_PX = 40;    // ...so past that, ONE event this big can only be a new gesture (path 4)
    var wAcc = 0, wLocked = false, wDir = 0, wSettle = null, wLast = 0, wLockAt = 0;
    // Firefox can report lines (deltaMode 1) or pages (2); normalise to px so the threshold means the
    // same thing on every engine (same idiom as setupTabPager's wDX).
    function wPx(d, e) { return e.deltaMode === 1 ? d * 16 : e.deltaMode === 2 ? d * (c.offsetWidth || 800) : d; }
    c.addEventListener('wheel', function (e) {
      var dx = wPx(e.deltaX, e), dy = wPx(e.deltaY, e);
      if (Math.abs(dx) <= Math.abs(dy)) return;               // vertical intent: let the feed scroll
      e.preventDefault();
      // e.timeStamp, NOT Date.now(): it is when the INPUT happened, so a main thread that delivers
      // five queued events in one go cannot fake a hole, and a coalesced event still reports the
      // real hardware gap. Every measurement below is on this clock.
      var now = e.timeStamp || Date.now();
      var gap = wLast ? (now - wLast) : 1e9;
      wLast = now;
      clearTimeout(wSettle);
      wSettle = setTimeout(function () { wSettle = null; wAcc = 0; wLocked = false; wDir = 0; wLast = 0; }, WHEEL_QUIET_MS);  // release path 1
      var sgn = dx > 0 ? 1 : -1, mag = Math.abs(dx);
      if (wLocked) {
        //   2. the reader REVERSED -- no tail changes sign on its own.
        //   3. the stream BROKE. Momentum runs at the display cadence and has no holes; a finger
        //      landing back on the mouse CANCELS the momentum outright, so a second swipe always
        //      follows a hole. 90 ms is ~5 frames: a tail cannot fake it unless the page is already
        //      rendering below ~11 fps, and WHEEL_GAP_PX keeps dying tail dust out of it.
        //   4. the tail is SPENT. Past WHEEL_LOCK_MS a tail is down to a couple of px per event, so
        //      a WHEEL_REARM_PX event cannot be one. This is the path that makes the lock's life
        //      BOUNDED, which is the actual defect -- without it a reader who keeps swiping keeps
        //      re-arming the quiet timer and never leaves slide 2.
        var fresh = (sgn !== wDir)
                 || (gap >= WHEEL_GAP_MS && mag >= WHEEL_GAP_PX)
                 || (now - wLockAt >= WHEEL_LOCK_MS && mag >= WHEEL_REARM_PX);
        if (!fresh) return;                                   // still this gesture's tail: swallow it
        wLocked = false; wAcc = 0;
      }
      wAcc += dx;
      if (Math.abs(wAcc) < WHEEL_SLIDE_PX) return;
      var dir = wAcc > 0 ? 1 : -1, target = idx + dir;        // deltaX>0 (swipe left) = next slide
      wAcc = 0; wLocked = true; wDir = dir; wLockAt = now;    // one page per gesture; the tail is swallowed
      if (target < 0 || target > maxIdx) bounce(dir);         // at an edge: nudge, don't page
      else go(target);
    }, { passive: false });
    // desktop MOUSE (and pen): click-and-drag left / right to page the slideshow, the gesture people expect
    // from a photo carousel. Touch is handled above and the trackpad two-finger swipe by the wheel handler,
    // so this path is mouse/pen only -- without it a plain-mouse desktop user had NO way to swipe a pfeed
    // slideshow but the arrow keys. Decide horizontal-vs-vertical early and only hijack a clearly SIDEWAYS
    // drag (a vertical mouse drag does nothing to the native scroll-snap feed anyway); preventDefault stops
    // the browser's ghost image-drag, and any real drag suppresses the click that follows so a swipe can't
    // also toggle sound / like the photo.
    var mDown = false, mDecided = false, mHoriz = false, mSX = 0, mSY = 0, mMoved = false, mPid = 0;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;                                       // touch uses the handler above
      if (e.button != null && e.button !== 0) return;                              // primary button only
      if (e.target.closest && e.target.closest('.vctrl, button, a, input, .pf-act')) return;  // don't fight controls
      mDown = true; mDecided = false; mHoriz = false; mMoved = false;
      mSX = e.clientX; mSY = e.clientY; mPid = e.pointerId; track.style.transition = 'none';
    });
    track.addEventListener('pointermove', function (e) {
      if (!mDown || e.pointerType === 'touch') return;
      var dx = e.clientX - mSX, dy = e.clientY - mSY;
      if (!mDecided) {
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;                          // too small to tell yet
        mHoriz = Math.abs(dx) >= Math.abs(dy); mDecided = true;
        if (!mHoriz) { mDown = false; track.style.transition = ''; return; }       // vertical: leave it be
        try { track.setPointerCapture(mPid); } catch (er) {}
      }
      mMoved = true; e.preventDefault();
      var base = -(idx * sw), pull = dx;
      if ((idx === 0 && dx > 0) || (idx >= maxIdx && dx < 0)) pull = dx * 0.35; // resist past an edge
      track.style.transform = 'translateX(calc(' + base + '% + ' + pull + 'px))';
    });
    function mEnd(e) {
      if (!mDown || e.pointerType === 'touch') return;
      mDown = false; track.style.transition = '';
      try { track.releasePointerCapture(mPid); } catch (er) {}
      if (!mHoriz) return;
      var dx = e.clientX - mSX, w = track.getBoundingClientRect().width || 1;
      var threshold = Math.min(64, w * 0.18);
      if (Math.abs(dx) <= threshold) { update(); return; }                         // not far enough: snap back
      var dir = dx < 0 ? 1 : -1, target = idx + dir;
      if (target < 0 || target > maxIdx) bounce(dir); else go(target);
    }
    track.addEventListener('pointerup', mEnd);
    track.addEventListener('pointercancel', function (e) { if (mDown && e.pointerType !== 'touch') { mDown = false; track.style.transition = ''; if (mHoriz) update(); } });
    c.addEventListener('click', function (e) { if (mMoved || tMoved) { e.preventDefault(); e.stopPropagation(); mMoved = false; tMoved = false; } }, true);  // a drag (mouse OR touch swipe) isn't a click
    // let outside callers page the carousel (e.g. the pfeed's Left/Right arrow keys)
    c.__cstep = function (dir) { go(idx + dir); };
    // jump straight to a slide with NO slide animation -- used when the immersive viewer opens on the
    // exact media you tapped, so the tapped photo shows instantly instead of the first slide sliding away
    c.__cgo = function (i) {
      var prev = track.style.transition;
      track.style.transition = 'none';
      _navSilent++;                        // a landing, not a finger -- see go()'s note
      try { go(i); } finally { _navSilent--; }
      void track.offsetWidth;              // commit the jump before transitions come back
      track.style.transition = prev || '';
    };
    // SLIDESHOW: "play" a multi-photo post -- auto-advance the slides, wrapping at the end so it repeats,
    // until stopped (pause button, or the post scrolls out of view). Drives the pfeed photo control bar.
    c.__cidx = function () { return idx; };
    c.__ccount = function () { return count; };
    c.__cplaying = false;
    /* THE SLIDESHOW CROSSFADES IN THE FULL-SCREEN VIEWER (Rob 2026-10-22, batch item 24: "smooth crossfade between slides").
       Only the AUTO advance (step(), which hands-free's once-mode show also runs): a swipe, an arrow or a dot still SLIDES, so
       no gesture changes. A ghost of the outgoing slide -- holding its drift frame exactly (computed scale / translate /
       transform / object-position copied inline) -- sits over the track, the track jumps to the target with no transition
       (__cgo), and the ghost fades out over XFADE_MS; the arriving photo starts its own drift from rest 0.4 s in. Photo to
       photo only (a clip cannot be ghosted), never under reduced motion, never outside .pfeed: false -> the caller slides. */
    var XFADE_MS = 650;
    function xfadeTo(t) {
      if (!c.closest || !c.closest('.pfeed') || t === idx || !c.__cgo) return false;
      try { if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return false; } catch (e) { return false; }
      var from = slides[idx], to = slides[t];
      if (!from || !to || from.querySelector('video') || to.querySelector('video')) return false;
      var fi = from.querySelector('img');
      if (!fi || !fi.complete || !fi.naturalWidth || !track.parentNode) return false;
      var g = from.cloneNode(true);
      g.classList.add('pf-xghost'); g.classList.remove('cs-cur');
      g.setAttribute('aria-hidden', 'true'); g.removeAttribute('id');
      Array.prototype.forEach.call(g.querySelectorAll('.vctrl, .pf-cbar, video'), function (n) { n.remove(); });
      Array.prototype.forEach.call(g.querySelectorAll('[id]'), function (n) { n.removeAttribute('id'); });
      var gi = g.querySelector('img');
      if (gi) {
        try {
          var cs = getComputedStyle(fi);
          gi.style.animation = 'none'; gi.style.transition = 'none';
          gi.style.scale = cs.scale; gi.style.translate = cs.translate; gi.style.transform = cs.transform; gi.style.objectPosition = cs.objectPosition;
        } catch (e) {}
      }
      track.parentNode.insertBefore(g, track.nextSibling);
      c.__cgo(t);
      var done = false;
      var kill = function () { if (done) return; done = true; if (g.parentNode) g.parentNode.removeChild(g); };
      try { var an = g.animate([{ opacity: 1 }, { opacity: 0 }], { duration: XFADE_MS, easing: 'ease-in-out', fill: 'forwards' }); an.onfinish = kill; } catch (e) { kill(); }
      setTimeout(kill, XFADE_MS + 400);
      return true;
    }
    var _ssT = null, _ssIO = null, _ssPausedUntil = 0, _kbMs = 3500;   // _ssPausedUntil: a manual swipe holds the auto-advance
    // ONCE mode (the pfeed's hands-free reel, __cplay(ms, {once:true, onend:fn})): play every slide by the
    // SAME rules but STOP at the last one and call back, instead of wrapping. That is the whole point of the
    // owner's "make sure you get to the end of them before swiping automatically to the next media post" --
    // the caller then advances to the next POST. Default (a reader tapping the slideshow button) is unchanged.
    // _ssPass: the in-flight one-pass watcher for a VIDEO slide; _ssPassAt: which slide index it belongs to.
    var _ssOnce = false, _ssEnd = null, _ssPass = null, _ssPassAt = -1;
    // Ken Burns: slowly pan + zoom the CURRENT slide's PHOTO during playback, restarting the drift on each
    // advance so every photo feels alive instead of snapping in static. Photos only (video slides have no
    // <img>). The CSS animates scale/translate (not `transform`), so it stacks on the pfeed cover-scale.
    function kenBurns(on) {
      for (var i = 0; i < slides.length; i++) {
        var im = slides[i].querySelector('img');
        if (!im) continue;
        im.classList.remove('kb-run');
        // text-heavy (owner 2026-09-20): .text-heavy is stamped server-side (views/_post.php)
        // straight from posts.text_cover -- same flag the timeline/grid/pfeed pans already skip.
        if (on && i === idx && !im.classList.contains('text-heavy')) {
          im.style.setProperty('--kb-dur', (_kbMs + 300) + 'ms');   // a touch longer than the dwell: always in motion
          // alt = (POST ID + slide index) odd -- the iOS rule (build 556): slides still alternate, and slide 0
          // matches kbStart's single-photo parity. No post id (0) -> plain i % 2, as before.
          var kbPost = c.closest && c.closest('.post[data-view]');
          im.classList.toggle('kb-alt', (((kbPost ? parseInt(kbPost.getAttribute('data-view'), 10) || 0 : 0) + i) % 2) === 1);
          void im.offsetWidth;                                      // reflow so the animation restarts from the top
          im.classList.add('kb-run');
        }
      }
    }
    c.__cplay = function (ms, opts) {
      if (c.__cplaying || count < 2) return;
      if (!ms) { try { ms = parseInt(localStorage.getItem('rova_ss_ms'), 10) || 0; } catch (e) {} ms = ms || 3500; }
      _kbMs = ms;
      _ssOnce = !!(opts && opts.once); _ssEnd = (opts && opts.onend) || null; _ssPassAt = -1;
      c.__ssOnce = _ssOnce;                                         // readable from outside (the pfeed reel checks it)
      c.__cplaying = true; c.classList.add('carousel-playing');
      kenBurns(true);                                               // drift the slide we're starting on
      // Advance via a self-scheduling step (not a flat interval) so a VIDEO slide isn't rudely skipped: we
      // DWELL on a clip while it's actually playing and only move on once it ends/pauses -- so a slideshow
      // that mixes photos and video still auto-plays end to end, panning the photos, playing the clips.
      var step = function () {
        if (!c.__cplaying) return;
        /* A BACKGROUNDED TAB NEVER ADVANCES. autoTick has always had this and step() never did --
           MEASURED on the viewer: hidden at 99.3s of a 102.3s clip, and it advanced to slide 2 six
           seconds later and carried on cycling behind a tab nobody was looking at, which is the
           decoder/heat pathology in [[phone-heat-energy-evidence]]. Held, not cancelled: an armed
           pass still completes and calls back here, and the advance simply waits for the reader to
           come back. Self-terminating -- __cstop clears _ssT, and the guard above ends it. */
        if (document.hidden) { _ssT = setTimeout(step, 1500); return; }
        // MANUAL SWIPE HOLD (owner): the reader just paged by hand -> don't auto-advance for the hold window,
        // then pick back up. Re-check just after it lapses instead of advancing now.
        // ...and an ATTENTION hold (a heart, a comment, the ... menu: see the ATTENTION block) holds it
        // by exactly the same route, so there is one concept here and not two.
        /* ...EXCEPT when the reader deliberately started THIS gallery's own clip (owner 2026-08-07,
           on the immersive viewer: "it's still repeating the video when it should play all the other
           media instead then loop it"). Pressing play arms BOTH stamps -- engAttn, because the
           transport is in ENG_ATTN_SEL, and __cycEng, because engVideo() runs -- and the attention
           hold then parked step() for the full 120s while the clip looped underneath. Proved on the
           viewer: after a real press-play, attn 119293ms, the clip wrapped (99.8s -> 21.8s) and the
           slide did not move for 25s with __cplaying true the whole time.
           The two stamps mean different things and only one of them is about MOVING content:
             engAttn   = "I am reading this post"  (a heart, a comment, the ... menu) -> hold, as before
             __cycEng  = "I am watching this clip" (play / tap the clip / tap for sound)
           A reader who pressed play has asked for the next clip, not for stillness, so their own
           gesture must not be read as a reason to freeze the gallery they started. A heart tap on
           its own still holds the show exactly as it did -- __cycEng is only ever set by engVideo(),
           which the engagement row never reaches. Same rule, same stamps, as the feed card. */
        var _ssHoldTo = Math.max(_ssPausedUntil, cycEngaged() ? 0 : engAttnUntil());
        if (Date.now() < _ssHoldTo) { _ssT = setTimeout(step, Math.max(250, _ssHoldTo - Date.now() + 40)); return; }
        // THE HAND (batch item 46): a finger / pointer on the page, a sheet, a focused field, or the 1.5 s after -- re-ask
        if (engHandWhy()) { _ssT = setTimeout(step, 250); return; }
        var cur = slides[idx];
        var v = cur ? cur.querySelector('video') : null;
        // VIDEO SLIDE: play it out, ONE complete pass, then move on. The old test was
        // `readyState>=2 && !v.paused && !v.ended` -> re-check in 600ms, which never terminates on a pfeed
        // clip: wire() sets loop=true on every post video, so `!v.ended` is permanently true and the show
        // parked on the first video slide forever (and a clip that hadn't STARTED yet failed the test the
        // other way and got skipped after one dwell). Keyed on the slide INDEX so a wrapping (non-once)
        // show re-plays the same clip on its next lap instead of skipping it.
        // Through clipPass, NOT __rovaVideoOnePass directly: this call site used to pass a 90000ms cap,
        // which silently cut slide 1 of 15076 short at 90s of its 102.3s (and would have cut slide 3 at
        // 90s of 164.4s) -- and it had no pause-awareness at all, so pausing in the viewer still
        // advanced on the wall clock. clipPass fixes both for this caller and the feed card at once.
        if (v && !_ssPass && _ssPassAt !== idx) {
          _ssPassAt = idx;
          _ssPass = clipPass(v, function () { _ssPass = null; if (c.__cplaying) step(); });
          return;
        }
        if (_ssPass) return;                                        // a clip is mid-pass; it will call back
        if (_ssOnce && idx >= maxIdx) {                             // last slide of a ONE-pass run: hand back, don't wrap
          var fn = _ssEnd; c.__cstop(); if (fn) { try { fn(); } catch (e) {} }
          return;
        }
        c.__ssTicking = true;   // flag: AUTO advance, not a manual swipe
        if (!xfadeTo(idx + 1 > maxIdx ? 0 : idx + 1)) { go(idx + 1 > maxIdx ? 0 : idx + 1); }   // the viewer crossfades (batch item 24)
        c.__ssTicking = false;
        // (go() re-arms the Ken Burns on the slide it lands on -- for EVERY nav, manual or auto -- so the
        // second kenBurns(true) that used to live here would only reflow the same image twice.)
        _ssT = setTimeout(step, _kbMs);
      };
      _ssT = setTimeout(step, _kbMs);
      if ('IntersectionObserver' in window) {
        if (!_ssIO) { _ssIO = new IntersectionObserver(function (ents) {
          ents.forEach(function (en) { if (!en.isIntersecting) c.__cstop(); });   // scrolled away -> stop
        }, { threshold: 0.5 }); }
        _ssIO.observe(c);
      }
      if (c.__onplaychange) c.__onplaychange(true);
    };
    // Change the dwell of a RUNNING show without restarting it (the pfeed's hands-free speed control).
    // Deliberately does NOT touch _ssT: the slide already on screen keeps the timer it was given, so
    // changing speed can neither cut the current slide short nor fire a second advance. Every slide
    // after this one uses the new rate.
    c.__cspeed = function (ms) { if (ms > 0) { _kbMs = ms; } };
    c.__cstop = function () {
      if (!c.__cplaying) return;
      c.__cplaying = false; c.classList.remove('carousel-playing');
      if (_ssT) { clearTimeout(_ssT); _ssT = null; }
      // drop the video-pass listeners too, or a stopped show still holds timeupdate handlers on a clip the
      // recycler is about to tear down (and would call step() back to life on a detached carousel)
      if (_ssPass) { try { _ssPass(); } catch (e) {} _ssPass = null; }
      _ssPassAt = -1; _ssOnce = false; _ssEnd = null; c.__ssOnce = false;
      if (_ssIO) { _ssIO.disconnect(); }
      kenBurns(false);                                              // clear the drift, back to the static cover framing
      if (c.__onplaychange) c.__onplaychange(false);
    };
    // TIMELINE AUTO-ADVANCE (owner: a multi-media FEED card should auto-swipe through the gallery). Feed +
    // permalink cards only, never the immersive pfeed (that one is reader-driven, and has its own sit-back
    // slideshow). Runs only while the card is actually on screen, pauses the moment the reader touches/hovers
    // it and resumes after a quiet beat, and steps with the same snappy .carousel-track transition a manual
    // swipe uses. Honours reduced-motion. Uses go()'s wrap so it loops back to the first slide at the end.
    if (!c.closest('.pfeed') && count > 1 && !(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)) {
      var _autoT = null, _autoInView = false, _autoPausedUntil = 0, AUTO_MS = 4200;
      /* HOVER IS A STATE, NOT A DEADLINE -- and encoding it as one was a real bug for as long as the
         hover hold has existed. autoPause() deliberately never SHORTENS an existing hold, so that a
         later small pause cannot override a longer swipe hold; that rule is load-bearing and stays.
         But mouseenter expressed "while hovered" as autoPause(9e6) -- a ~2.5 HOUR deadline -- and the
         matching mouseleave's autoPause(2500) was then discarded by the very Math.max that protects
         the swipe hold. Net effect: on desktop, the first time the pointer touched a multi-media card
         its gallery stopped auto-advancing for the rest of the session. The mouseleave line was
         plainly meant to release it and could not.
         Now the hover is its own boolean, read directly by autoTick, and leaving applies the ordinary
         2500ms timed hold on the way out. Nothing else changes: the timed holds keep their
         never-shorten semantics, and __cycEng (the engaged cycle) was already kept off this variable
         on purpose, so a hover can never suppress a clip the reader started. Touch devices never fire
         mouseenter here (verified: touch runs the touchstart branch, and a synthesised compatibility
         mouse event after a tap would now cost 2500ms rather than the session). */
      var _autoHover = false;
      var autoTick = function () {
        if (_autoHover) return;                                                                 // pointer is on the card
        if (!_autoInView || Date.now() < Math.max(_autoPausedUntil, engAttnUntil())) return;   // attention hold: see the ATTENTION block
        if (document.hidden) return;                                // don't churn a backgrounded tab
        if (window.__rovaOverlayOpen && window.__rovaOverlayOpen()) return;   // pfeed viewer covers the feed -> don't advance behind it
        // A clip the reader deliberately STARTED is playing itself out (the CYCLE block above owns the
        // advance until it wraps). Two clocks driving one gallery would cut that clip short at 4.2s --
        // which is the whole complaint. Exact complement: while __cycPass is up this tick stands down,
        // and while it is down the cycle is disarmed because nothing engaged it.
        if (c.__cycPass) return;
        // ...and a VIDEO gallery advancing costs a decoder swap plus a fresh fetch, so it takes the same
        // one-at-a-time slot the engaged cycle uses (see the COUNT BUDGET above). Photo-only galleries
        // are not bounded here: their advance is a transform on an already-decoded image.
        if (carHasVideo && !cycClaim(c)) return;
        c.__autoTicking = true; go(idx >= maxIdx ? 0 : idx + 1); c.__autoTicking = false;   // flag: this advance is NOT a manual nav
      };
      // never SHORTEN an existing pause (a later, smaller pause must not override a longer hover/swipe hold)
      var autoPause = function (ms) { _autoPausedUntil = Math.max(_autoPausedUntil, Date.now() + (ms || 6000)); };
      c.__autoPause = autoPause;                                    // let go() (manual nav) reach it
      /* ...and the ONE way back. autoPause deliberately never shortens, which is right for every
         caller it has -- but it left no way to say "he is done" either, and muting is exactly that
         (owner 2026-08-10). Without this, muting cleared the attention hold and the card still sat
         out the 120s __autoPause its own unmute tap had handed it, so the advance would not resume
         for two minutes and "muting puts it back" would have been a claim rather than a behaviour.
         Only the mute path calls it; nothing else may, or the courtesy hold stops being one. */
      c.__autoRelease = function () { _autoPausedUntil = 0; c.__cycEng = 0; if (c.__cycArm) { try { c.__cycArm(); } catch (e) {} } };
      /* SELF-TERMINATING (2026-07-29 per-frame audit). This interval and the observer below used to
         live for the whole page, with no way to stop them. The card-feed virtualiser rebuilds a
         restored card from stashed outerHTML -- a NEW element, so initCarousel runs again and made
         ANOTHER 4.2s interval plus ANOTHER observer, both pinning the detached predecessor. Every
         stub/restore round-trip added one, forever: a long feed session ends up waking dozens of
         timers a second on carousels that are not in the document, each holding its slides' decoded
         media alive. That is an always-on CPU tax that no amount of scroll-path tuning can reach.
         A detached carousel now shuts its own timer and observer down on the next tick. */
      var _autoIO = null;
      if (!_autoT) {
        _autoT = setInterval(function () {
          if (!c.isConnected) {                                     // recycled away: stop for good
            clearInterval(_autoT); _autoT = null;
            if (_autoIO) { try { _autoIO.disconnect(); } catch (e) {} _autoIO = null; }
            cycRelease(c);                                          // ...and never hold the one cycle slot from the grave
            return;
          }
          autoTick();
        }, AUTO_MS);
      }
      if ('IntersectionObserver' in window) {
        _autoIO = new IntersectionObserver(function (ents) {
          ents.forEach(function (en) { _autoInView = en.isIntersecting && en.intersectionRatio >= 0.55; });
        }, { threshold: [0, 0.55] });
        _autoIO.observe(c);
      } else { _autoInView = true; }
      ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) {
        c.addEventListener(ev, function () { autoPause(7000); }, { passive: true });
      });
      c.addEventListener('mouseenter', function () { _autoHover = true; }, { passive: true });                    // hold while hovered
      c.addEventListener('mouseleave', function () { _autoHover = false; autoPause(2500); }, { passive: true });  // ...and a short beat after
    }
    applyLayout();   // final pass once slides/controls are wired, so the wide-gallery width + per-view are set
  }
  // FAILURE ISOLATION (2026-07-29). This used to be a bare forEach(initCarousel) called bare at
  // load. Both of those were single points of failure for the WHOLE FILE: one malformed carousel
  // throws out of initCarousel, that throw escapes this top-level call, and because this file is a
  // classic script made of top-level IIFEs the rest of it -- the feed tab pager, load-more, the
  // chrome-idle watch-mode owner, and the entire immersive pfeed viewer, all registered BELOW this
  // line -- is never evaluated at all. Nothing logs it; the page just comes up missing pieces.
  // Per-element try/catch (matching what the __rovaHydrate path already did) means one bad post
  // can only cost its own carousel, and the beacon means we hear about it instead of guessing.
  function initCarousels(root) {
    (root || document).querySelectorAll('.carousel').forEach(function (c) {
      try { initCarousel(c); }
      catch (e) { beacon('init:carousel', { m: String((e && e.message) || e).slice(0, 160) }); }
    });
  }
  try { initCarousels(); }
  catch (e) { beacon('init:carousels', { m: String((e && e.message) || e).slice(0, 160) }); }

  /* ---- single-photo posts: a horizontal swipe rubber-bands (there is nothing to
     page to) instead of leaking to the feed tab-pager. The bounce tells the reader
     "it's just one photo", and vertical swipes still scroll the timeline. -------- */
  (function () {
    function wire(el) {
      if (el._solo) { return; } el._solo = true;
      // NEVER wire the timeline rubber-band on a pfeed photo: the immersive viewer owns its own zoom/pan, and
      // this handler's release used to pin an inline transform:translateX(0) on the <img>, which OVERRODE the
      // stylesheet's transform:scale() (pf-zoomable / pf-uncrop) -- so after a horizontal swipe the zoom button
      // and tap-to-zoom only flipped classes while the rendered scale stayed frozen ("left swipe broke the
      // zoom"). There's also no feed tab-pager to protect inside the pfeed, so the bounce serves no purpose here.
      if (el.closest && el.closest('.pfeed')) { return; }
      var img = el.querySelector('img');
      if (!img) { return; }
      var sx = 0, sy = 0, active = false, decided = false, horiz = false;
      /* A FINGER LANDING ON THE PHOTO CHANGES NOTHING ABOUT IT (2026-10-04, Rob: a swipe that starts on a Ken
         Burns photo "rapid zoom in/out"). touchstart used to write `img.style.transition = 'none'` on EVERY
         contact -- scroll, tap, long-press -- and a vertical swipe then bailed with it still set, so any transform
         change on that photo for the rest of the page snapped instead of easing (iOS's touch :hover zoom flicked
         in and out with no tween). It is only needed once the drag is CLAIMED as the horizontal rubber-band. */
      el.addEventListener('touchstart', function (e) {
        sx = e.touches[0].clientX; sy = e.touches[0].clientY;
        active = true; decided = false; horiz = false;
      }, { passive: true });
      el.addEventListener('touchmove', function (e) {
        if (!active) { return; }
        var dx = e.touches[0].clientX - sx, dy = e.touches[0].clientY - sy;
        if (!decided) {
          if (Math.abs(dx) < 8 && Math.abs(dy) < 8) { return; }
          horiz = Math.abs(dx) > Math.abs(dy) * 1.2; decided = true;
          if (!horiz) { active = false; return; }   // vertical: let the timeline scroll -- the photo was never touched
          img.style.transition = 'none';             // horizontal: the rubber-band owns the transform from here
        }
        if (horiz) {
          e.preventDefault();   // lock horizontal: no tab swipe, no vertical scroll
          var pull = (dx < 0 ? -1 : 1) * Math.min(Math.abs(dx) * 0.32, 46);   // resistance + cap
          img.style.transform = 'translateX(' + pull + 'px)';
        }
      }, { passive: false });
      function snap() {
        if (!active) { return; } active = false;
        // CLEAR the inline transform (was translateX(0)) so the stylesheet's own transform resumes -- pinning an
        // inline value masked any scale()/zoom the media relies on. In the plain timeline the base transform is
        // none, so it animates back identically; belt-and-suspenders alongside the pfeed skip above.
        if (horiz) { img.style.transition = 'transform .3s cubic-bezier(.2,.85,.25,1)'; img.style.transform = ''; }
      }
      el.addEventListener('touchend', snap, { passive: true });
      el.addEventListener('touchcancel', snap, { passive: true });
    }
    /* PIN THE CARD'S DRIFT ONLY ON A CONFIRMED TAP (2026-10-04, the iOS app's 09-30 rule): touchstart /
       pointerdown / a scroll / a long-press never touch a card photo's Ken Burns; the open path calls this from
       its single-tap timer -- after the double-tap window, i.e. a real tap -- right before the hero flight reads
       the drawn rect, so the flight lifts off the exact frame that stays under it. .kb-pin (rova.css) pauses the
       play-state at that frame (never animation:none, so no restart). It lifts once the viewer is fully gone:
       html.pfv-on / pfv-fly already pause card media for the whole open + dismiss, so the pin hands over to
       them and is released with them; if no viewer ever comes up (a lightbox fallback, a failed open) it lifts
       after 1.5s. */
    window.__rovaKbPinCard = function (img) {
      try {
        if (!img || !img.classList || (img.closest && img.closest('.pfeed'))) { return; }
        var de = document.documentElement, seen = false, t0 = Date.now(), mo = null, safety = 0;
        var viewerUp = function () { return de.classList.contains('pfv-on') || de.classList.contains('pfv-fly'); };
        var release = function () { if (mo) { mo.disconnect(); mo = null; } clearTimeout(safety); try { img.classList.remove('kb-pin'); } catch (e) {} if (img._kbPinOff === release) { img._kbPinOff = null; } };
        if (img._kbPinOff) { img._kbPinOff(); }
        img.classList.add('kb-pin');
        img._kbPinOff = release;
        var check = function () {
          if (viewerUp()) { seen = true; clearTimeout(safety); return; }
          if (seen) { release(); return; }
          if (Date.now() - t0 >= 1500) { release(); }
        };
        if ('MutationObserver' in window) { mo = new MutationObserver(check); mo.observe(de, { attributes: true, attributeFilter: ['class'] }); }
        safety = setTimeout(function () { if (!seen && !viewerUp()) { release(); } else if (!mo) { var iv = setInterval(function () { if (!viewerUp()) { clearInterval(iv); release(); } }, 250); } }, 1500);
      } catch (e) {}
    };
    function scan(root) { (root || document).querySelectorAll('.js-solo-media').forEach(wire); }
    scan(document);
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j]; if (n.nodeType !== 1) { continue; }
          if (n.matches && n.matches('.js-solo-media')) { wire(n); } else { scan(n); }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  })();

  /* ---- embedded players: stop audio/video when scrolled out of view ----- */
  // THE PERMALINK'S OWN EMBED IS EXEMPT (owner, /p/8455: "scrolling down to read the comments is
  // stopping the video and shouldn't" -- a music video, so it is the AUDIO he loses). That post is a
  // provider iframe, not an uploaded <video>, so the feed video observer never touched it; THIS is the
  // observer that was stopping it, by swapping in a src-less clone once the frame cleared the viewport
  // by 150px. On a feed that is right -- you scroll past ten posts and none of them may keep playing
  // behind you. On a post-detail page it is the same mistake the immersive viewer's drag-reveal branch
  // already documents: there is ONE post, the reader came for it, and its comments are printed directly
  // underneath, so pushing the frame off the top is "still reading this post", not "moved on".
  //
  // The exemption is NOT "keep it alive a bit longer": a taller margin would only move the cliff further
  // down the thread, and on a long thread the clip would still die mid-read. The permalink's own frame
  // stays alive for the life of the page. That is affordable precisely because the page is a leaf with
  // exactly one embed -- nothing can stack behind it, and navigating away destroys the iframe anyway.
  // The reader keeps every out already on the page: pause in the player, picture-in-picture (the iframe
  // carries the allow), or leave.
  //
  // Scoped by the server's own marker, not by URL sniffing: views/post_single.php is the only template
  // that emits data-pfeed-open, and only its own post card is a DIRECT child of that wrap (thread parts
  // render inside .thread-chain), so a quoted post, a thread part, the feed, the profile and the grid
  // all keep the stop-on-scroll-out behaviour untouched.
  function embedIsPermaPrimary(f) {
    try { return !!(f && f.closest && f.closest('[data-pfeed-open] > .post')); } catch (e) { return false; }
  }
  /* NOR IS A CARD WHOSE COMMENT SHEET IS OPEN (2026-09-25, owner on @kingrobgreen's profile, post 8455 --
     a YouTube music video: "makes super snappy erroneous scrolls ... I think it may have had something to
     do with the embedded YouTube"). Opening the sheet makes that card ~420px taller with the frame at its
     TOP, and focusing "Add a comment…" then scrolls the page twice (iOS's reveal, then the keyboard
     landing below) -- which carries the frame out past the 150px margin and back. MEASURED in the rig
     (chromeland/kbland.js, profile, the 8455 card): the frame was swapped for its parked clone mid-focus,
     and ~20ms later __rovaEmbedWarmIO (1200% margin) put the src straight back, so a "park" here is really
     a RELOAD: a fresh cross-origin YouTube document mounting directly above a focused field while the
     keyboard is still rising. A provider frame that finishes loading can take focus, and focus in a frame
     makes the browser jump the page to it (the yank guard in the feed IIFE exists for exactly that, and it
     only covers #feed-posts -- not the profile). Could not be proved on a real iPhone from this box; the
     reload itself is proved. A member with the sheet open is still reading THIS post, so its frame is
     left alone until the sheet closes, when closePanel() re-asks this observer (__rovaEmbedRecheck). */
  function embedHeldBySheet(f) {
    try { var p = f && f.closest && f.closest('.post'); return !!(p && p.querySelector('.comment-panel.open')); }
    catch (e) { return false; }
  }
  function initEmbeds(root) {
    if (!('IntersectionObserver' in window)) return;
    if (!window.__rovaEmbedIO) {
      window.__rovaEmbedIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var f = en.target;
          if (en.isIntersecting) {
            // a fresh iframe's first navigation REPLACES its initial blank
            // document, so restoring the player adds no history entry
            if (f.dataset.src) { f.src = f.dataset.src; f.removeAttribute('data-src'); }
          } else if (f.src && !f.dataset.src && !embedIsPermaPrimary(f) && !embedHeldBySheet(f)) {
            // stop playback by swapping in a src-less clone. Setting
            // f.src = 'about:blank' NAVIGATES the iframe, and iframe
            // navigations push entries onto the browser's back/forward list,
            // which made the Back button step through phantom blank pages.
            var n = f.cloneNode(false);
            n.removeAttribute('src');
            n.dataset.src = f.src;
            window.__rovaEmbedIO.unobserve(f);
            window.__rovaEmbedWarmIO.unobserve(f);
            f.parentNode.replaceChild(n, f);
            if (window.__rovaEmbedSeen) { window.__rovaEmbedSeen.add(n); }
            window.__rovaEmbedIO.observe(n);
            /* THE CLONE IS NOT HANDED BACK TO THE WARM OBSERVER (2026-09-25). It used to be, and the warm
               margin is 12 screens, so a clone parked 150px off screen was "intersecting" there at once and
               got its src straight back: MEASURED ~20ms from park to reload, i.e. a park was a fresh
               provider document, not a stopped one. Worse, whenever the warm restore landed BEFORE this
               observer's first report on the clone, that report ("not intersecting, has a src") parked it
               AGAIN -- a reload LOOP, measured at 68-102 swaps in 2.5s on the post-8455 card. The warm
               observer is one-shot by its own contract ("once loaded, the pause/resume observer above owns
               it"); a parked clone now waits for THIS observer's 150px margin to bring it back. */
          }
        });
      }, { rootMargin: '150px 0px', threshold: 0.01 });
    }
    // separate, far wider margin just to kick off the iframe's network load early --
    // 150px above is deliberately tight (for promptly pausing background audio/video
    // once you actually scroll away), which left almost no lead time for the load itself.
    // One-shot per element: once loaded, the pause/resume observer above owns it.
    if (!window.__rovaEmbedWarmIO) {
      window.__rovaEmbedWarmIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var f = en.target;
          if (f.dataset.src) { f.src = f.dataset.src; f.removeAttribute('data-src'); }
          window.__rovaEmbedWarmIO.unobserve(f);
        });
      }, { rootMargin: '1200% 0px 1200% 0px' });   // matches warmIO's video margin -- see its comment
    }
    /* "ALREADY OBSERVED" IS A PROPERTY OF THE NODE, NOT OF ITS MARKUP (2026-09-25). The data-obs attribute
       travels inside outerHTML, so a card the feed recycler stubbed (stubCard stashes p.outerHTML) came back
       from restoreCard with every frame marked observed and was never observed again. That was invisible
       while a parked clone got its src back within ~20ms (see the park branch above): the stashed frame was
       nearly always live. Now that a park really parks, a restored card would have kept a src-less, dead
       player -- so the test is node identity (a WeakSet), and a node rebuilt from HTML is a new node. */
    var seen = window.__rovaEmbedSeen || (window.__rovaEmbedSeen = (typeof WeakSet === 'function') ? new WeakSet() : null);
    (root || document).querySelectorAll('.embed iframe').forEach(function (f) {
      if (seen ? seen.has(f) : f.hasAttribute('data-obs')) { return; }
      if (seen) { seen.add(f); }
      f.setAttribute('data-obs', '1');
      window.__rovaEmbedIO.observe(f);
      window.__rovaEmbedWarmIO.observe(f);
    });
  }
  // Re-ask the park observer about a card's frames (an observer only reports CHANGES, so a frame the
  // sheet held while it scrolled away would otherwise stay live off screen). See embedHeldBySheet.
  window.__rovaEmbedRecheck = function (root) {
    var io = window.__rovaEmbedIO;
    if (!io || !root || !root.querySelectorAll) { return; }
    root.querySelectorAll('.embed iframe[src]').forEach(function (f) { io.unobserve(f); io.observe(f); });
  };
  // let overlays (the profile-feed viewer) hydrate freshly injected cards; videos +
  // carousels also self-wire via the document.body MutationObservers, so this covers
  // embeds/carousels explicitly and everything else follows.
  window.__rovaHydrate = function (root) {
    try { initCarousels(root); } catch (e) {}
    try { initEmbeds(root); } catch (e) {}
  };
  // LAZY, viewport-driven hydration for AJAX-swapped panels (the tab pager).
  // ROOT CAUSE of the tab-switch freeze (measured via tools/pw/tab-cpu-profile.js): initCarousel() calls
  // getBoundingClientRect() (applyLayout -> measure) on the carousel, and the carousel sits inside a
  // `content-visibility:auto` .media (rova.css) -- so measuring it FORCES the browser to render that
  // otherwise-skipped subtree. Hydrating every card's carousel up front (the old synchronous
  // `initCarousels(grid)`) force-rendered ALL of them, on-screen AND off, in one 200-280ms layout storm
  // that froze the switch. IntersectionObserver.observe() forces NO layout, so instead we observe each
  // carousel and hydrate it only as it nears the viewport: the 1-2 visible ones hydrate on the next IO
  // tick, the rest never cost anything until you scroll to them. Embeds stay lazy the same way (initEmbeds).
  function hydrateChunked(root) {
    if (!root) return;
    var cs;
    try { cs = Array.prototype.slice.call(root.querySelectorAll('.carousel')); } catch (e) { cs = []; }
    if (cs.length) {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (ents) {
          ents.forEach(function (en) {
            if (!en.isIntersecting) return;
            io.unobserve(en.target);
            try { initCarousel(en.target); } catch (e) {}   // one forced layout, but only for a carousel actually on screen
          });
        }, { rootMargin: '300px 0px' });                     // hydrate a touch before it scrolls in
        cs.forEach(function (c) { if (!c._inited) io.observe(c); });   // observe() does NOT flush layout
      } else {
        cs.forEach(function (c) { try { initCarousel(c); } catch (e) {} });
      }
    }
    try { initEmbeds(root); } catch (e) {}
  }
  // Same isolation as initCarousels above: this was the other bare top-level call whose throw
  // would silently delete every subsystem registered below it (and both following IIFEs).
  try { initEmbeds(); }
  catch (e) { beacon('init:embeds', { m: String((e && e.message) || e).slice(0, 160) }); }

  // upload limits mirror lib/upload.php (server downscales big photos anyway)
  var UP_IMG_MAX = 25 * 1024 * 1024, UP_AVATAR_VID_MAX = 12 * 1024 * 1024;
  function fmtSize(b) { return b >= 1048576 ? (b / 1048576).toFixed(1) + ' MB' : Math.max(1, Math.round(b / 1024)) + ' KB'; }

  // upload a chosen avatar/cover in the background so it's saved the moment it's picked
  /*
   * ONE TRANSPORT, NOT TWO (2026-08-04). assets/onb-boot.js publishes window.RovaUpload: the
   * same POST with real upload progress, a stall deadline, a Try again, and a DIFFERENT message
   * for slow / failed / blocked. It has to exist on its own because it is also what runs when
   * this 537 KB bundle has not arrived yet, and having it run the upload when the bundle IS here
   * is what stops the two copies drifting. The member still gets the cropper above; only the
   * bytes-on-the-wire part moves.
   *
   * The fetch below is the fallback for pages onb-boot.js is not loaded on (Settings). It is no
   * longer the version that shipped: that one called raw fetch() with NO deadline, never looked
   * at r.status, and went straight to r.json(). Three of this route's outcomes are not JSON --
   * 419 CSRF (plain text, lib/security.php:269), a 302 to /login followed into HTML, and any
   * IIS/Cloudflare error page -- and all three landed in .catch() telling the member to "check
   * your connection" when the connection was fine and their session had expired. And with no
   * AbortController it could sit on "Uploading..." for the platform's whole half-open socket
   * timeout, 60-120s on iOS Safari, which is indistinguishable from a dead button.
   */
  function bgUpload(file, type, statusEl, inputEl, origFile, cropRect) {
    if (typeof window.RovaUpload === 'function') {
      window.RovaUpload(file, type, statusEl, inputEl, origFile, cropRect);
      return;
    }
    if (statusEl) { statusEl.hidden = false; statusEl.className = 'hint'; statusEl.textContent = '⏳ Uploading ' + fmtSize(file.size) + '…'; }
    var ac = null, killed = false, reTokened = false, deadline = 0;
    try { ac = new AbortController(); } catch (e) {}
    function err(msg) { if (statusEl) { statusEl.className = 'hint err-text'; statusEl.textContent = msg; } }
    function arm() {
      deadline = setTimeout(function () {
        killed = true;
        try { if (ac) ac.abort(); } catch (e) {}
        err('That is taking too long. Please try again when you have better service.');
      }, 150000);
    }

    /* ONE ATTEMPT, BUILT FRESH. A FormData handed to fetch() is spent, so the 419 recovery below
       cannot reuse it -- the same contract csrfSend(send) states, and the same reason the token is
       stamped HERE rather than once at the top: every attempt carries the token that was live when
       IT went out. */
    function fire(tok) {
      var fd = new FormData();
      fd.append('file', file);
      // origFile: the pre-crop source, only ever set for an avatar photo whose shape genuinely differs
      // from square (see the avatar-file change handler below) -- lets Upload::storeAvatarOriginal
      // (lib/upload.php) keep it beside the crop for AvatarPost to show full-screen instead of the square.
      if (origFile) { fd.append('avatar_orig', origFile, 'avatar_orig.jpg'); }
      // cropRect: "x,y,w,h" of the ORIGINAL above, i.e. where the square was cut out of it (db/0177).
      // Only ever set alongside avatar_orig; Upload::avatarCropAccept() verifies it against the two
      // stored files before believing it, and stores nothing when it cannot.
      if (cropRect) { fd.append('avatar_crop', cropRect); }
      /* THE BODY, NOT JUST THE HEADER. Security::requireCsrf() reads
         `$_POST['_csrf'] ?? $_SERVER['HTTP_X_CSRF_TOKEN']` -- the BODY WINS (proved live: a valid
         header with a bogus body is 419; a bogus header with a valid body is accepted). A retry
         that refreshed only the header would carry the dead token in the field the server actually
         reads and be refused again, silently. */
      fd.append('_csrf', tok);
      var lastStatus = 0;
      arm();
      fetch('/settings/media?type=' + type + '&ajax=1', {
        method: 'POST',
        headers: { 'X-CSRF-Token': tok, 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
        body: fd, credentials: 'same-origin', signal: ac ? ac.signal : undefined
      }).then(function (r) {
        lastStatus = r.status;
        return r.text();
      }).then(function (txt) {
        clearTimeout(deadline);
        var res = null;
        try { res = JSON.parse(txt); } catch (e) {}
        /* 419 IS RECOVERABLE EXACTLY ONCE, and this is the surface where the silence hurt most.
           The gate exit()s before the dispatcher (Security::requireCsrf), so a refused upload
           provably wrote nothing and re-sending cannot double anything. But it stays ONE refresh
           and ONE re-send: a storm against a session that is genuinely gone is worse than the bug.
           stageCsrfRefresh() rather than csrfRefresh(): the latter's csrfDead latch is set by
           page-wide events, and an upload that has been on the wire for a minute must not inherit
           a verdict reached about something else. Same choice the staged/chunked paths make. */
        if (lastStatus === 419 && !reTokened) {
          reTokened = true;
          stageCsrfRefresh().then(function (fresh) {
            if (!fresh) { err('This page has been open a while. Reload it and try again.'); return; }
            fire(csrf);          // stageCsrfRefresh ran csrfApply, so `csrf` IS the new token
          });
          return;
        }
        // 403 on THIS route has exactly one cause, the email verify wall (index.php:136), so the
        // member gets that sentence and not a guess about their signal.
        if (lastStatus === 403) {
          err('Confirm your email first, then add your photo.');
          return;
        }
        // 419 is CSRF; a 200 with a body that is not JSON is the /login redirect being followed.
        // Both are the session, not the line.
        if (lastStatus === 401 || lastStatus === 419 || (lastStatus === 200 && !res)) {
          err('This page has been open a while. Reload it and try again.');
          return;
        }
        if (lastStatus >= 500) {
          err('Something went wrong on our end. Please try again.');
          return;
        }
        bgUploadDone(res, type, statusEl, inputEl, file);
      }).catch(function () {
        clearTimeout(deadline);
        if (killed) { return; }   // the deadline already said its piece
        err('That did not go through. Please try again.');
      });
    }
    /* READ AT SEND TIME, NEVER CACHED. `csrf` is this IIFE's live variable and csrfApply() rewrites
       it on every refresh, so reading it here (rather than into a closure at page load, which is
       what assets/onb-boot.js used to do and what cost a real member five silent 419s during
       onboarding) means this request always leaves with the token the page currently holds. */
    fire(csrf);
  }

  /* The success / server-error half of bgUpload, split out only so the status handling above
     stays readable. Same scope as bgUpload on purpose (this file is not one IIFE). */
  function bgUploadDone(res, type, statusEl, inputEl, file) {
    if (res && res.ok) {
      if (statusEl) {
        statusEl.className = 'hint';
        // A "no clear face" tip (server) is an encouraging nudge, NOT an error -- show it in place of
        // the generic saved message so a faceless-but-valid photo still reads as accepted.
        if (res.tip) {
          statusEl.textContent = '✓ ' + res.tip;
        } else {
          // Onboarding (the setup checklist is on the page): the photo is one step of a flow, so point
          // them onward. Settings: it's a standalone edit, so the "keep editing / leave" copy fits.
          var inOnboarding = !!document.querySelector('.setup-list');
          statusEl.textContent = (inOnboarding && type === 'avatar')
            ? '✓ Saved. Proceed to the next step below.'
            : '✓ Saved. You can keep editing or leave this page.';
        }
      }
      if (inputEl) inputEl.value = '';               // already saved; don't re-upload on Save
      /* `file` rides along so the listener can paint the member's own picture from the bytes
         already in their hand -- see SELF-AVATAR LIVE SWAP above for why a URL will not do.
         This path only runs when assets/onb-boot.js is NOT on the page (bgUpload hands the
         whole transport to window.RovaUpload when it is), which is /settings and a failed
         onb-boot.js on /onboarding. Either way it is the same detail shape. */
      document.dispatchEvent(new CustomEvent('rova:media-saved', { detail: { type: type, path: (res && res.path) || '', file: file } }));
    } else if (statusEl) {
      statusEl.className = 'hint err-text';
      statusEl.textContent = (res && res.error) || 'That did not go through. Please try again.';
    }
  }

  /* ---- image cropper (avatar square / cover wide) ---------------------- */
  var cropModal = null;
  function buildCropper() {
    if (cropModal) return cropModal;
    cropModal = document.createElement('div');
    cropModal.className = 'cropper';
    cropModal.innerHTML =
      '<div class="crop-box">' +
        '<div class="crop-title">Drag to reposition · scroll or pinch to zoom</div>' +
        '<div class="crop-stage"><img class="crop-img" alt=""><div class="crop-frame"></div></div>' +
        /* POST PHOTO CROP (2026-09-30): aspect presets + Reset, shown only when openCropper runs with
           opts.post (the Edit-post modal). Hidden for the avatar / banner flows, which never see them. */
        '<div class="crop-presets" role="radiogroup" aria-label="Crop shape" hidden></div>' +
        /* FIT vs FILL, as a control rather than as a hidden end of the slider. A slider that now
           travels further LEFT than it used to is not discoverable -- nobody drags past the place
           the handle has always stopped -- and "show me the whole thing" is the single most common
           thing someone with a logo wants. Hidden for a source where fit and fill are the same
           picture (a square) and in rect mode (the banner stores a rect, which cannot express a pad). */
        '<div class="crop-modes" hidden>' +
          '<button type="button" class="crop-mode" data-mode="fill" aria-pressed="true">Fill circle</button>' +
          '<button type="button" class="crop-mode" data-mode="fit" aria-pressed="false">Fit whole image</button>' +
        '</div>' +
        '<input type="range" class="crop-zoom" min="1" max="3" step="0.01" value="1" aria-label="Zoom">' +
        '<div class="crop-actions">' +
          '<button type="button" class="btn gold-ghost crop-reset" hidden>Reset</button>' +
          '<button type="button" class="btn gold-ghost crop-cancel">Cancel</button>' +
          '<button type="button" class="btn primary crop-save">Use photo</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(cropModal);
    return cropModal;
  }
  /* POST CROP presets: [key, label, pixel aspect w/h] -- 'orig' and 'free' are resolved per photo. */
  var CROP_PRESETS = [['orig', 'Original', 0], ['free', 'Free', 0], ['1:1', '1:1', 1], ['4:5', '4:5', 0.8],
                      ['16:9', '16:9', 16 / 9], ['9:16', '9:16', 9 / 16]];

  // NOTHING in here may refuse a profile photo. The old luminance-variance check (std < 8 =
  // "blank or all black") is gone with the server-side gate it mirrored: a member's avatar is
  // theirs to choose, logo, wordmark, artwork or face. See lib/users.php avatarFaceHint().
  function openCropper(file, opts) {
    var ov = buildCropper();
    var stage = ov.querySelector('.crop-stage');
    var img = ov.querySelector('.crop-img');
    var frame = ov.querySelector('.crop-frame');
    var zoomEl = ov.querySelector('.crop-zoom');
    var modesEl = ov.querySelector('.crop-modes');
    frame.classList.toggle('round', !!opts.round);
    /* ---- POST PHOTO CROP MODE (opts.post, 2026-09-30) ---------------------------------------------
       Everything below is gated on opts.post, so the avatar and banner flows are byte-for-byte what they
       were. The mode is rect mode (opts.rect) plus: aspect presets (Original / Free / 1:1 / 4:5 / 16:9 /
       9:16), resize HANDLES on the frame (8 in Free, the 4 corners aspect-locked otherwise), a Reset back
       to the whole original, a higher zoom ceiling (a small crop of a big photo needs more than 3x), and a
       z-index above the Edit-post modal. Pan = drag / one finger, zoom = wheel / pinch / the slider, all
       the existing gesture layer. After a handle drag the frame re-centres at full size and the picture
       zooms to keep exactly the chosen region (the iOS Photos idiom), so the frame never shrinks away. */
    var post = !!opts.post;
    ov.classList.toggle('crop-post', post);
    var presetsEl = ov.querySelector('.crop-presets');
    var resetEl = ov.querySelector('.crop-reset');
    var saveEl = ov.querySelector('.crop-save');
    if (saveEl) { saveEl.textContent = opts.saveLabel || 'Use photo'; }
    if (resetEl) { resetEl.hidden = !post; }
    if (presetsEl) { presetsEl.hidden = !post; presetsEl.innerHTML = ''; }
    Array.prototype.forEach.call(frame.querySelectorAll('.crop-h'), function (h) { h.remove(); });
    var preset = 'orig';
    function presetAr(k) {
      if (k === 'orig') { return s.natW / s.natH; }
      if (k === 'free') { return s.fw > 0 && s.fh > 0 ? s.fw / s.fh : s.natW / s.natH; }
      for (var i = 0; i < CROP_PRESETS.length; i++) { if (CROP_PRESETS[i][0] === k) { return CROP_PRESETS[i][2]; } }
      return s.natW / s.natH;
    }
    function paintPresets() {
      if (!presetsEl) { return; }
      Array.prototype.forEach.call(presetsEl.querySelectorAll('.crop-preset'), function (b) {
        var on = b.getAttribute('data-k') === preset;
        b.classList.toggle('on', on); b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      frame.classList.toggle('is-free', preset === 'free');
    }
    // the largest rect of pixel-aspect `a` inside the picture, centred on (cx, cy), clamped inside
    function fitRect(a, cx, cy) {
      var w = 1, h = 1;
      if (s.natW / s.natH > a) { h = 1; w = (a * s.natH) / s.natW; } else { w = 1; h = s.natW / (a * s.natH); }
      var x = Math.min(1 - w, Math.max(0, cx - w / 2)), y = Math.min(1 - h, Math.max(0, cy - h / 2));
      return [x, y, w, h];
    }
    function curRect() {
      var scale = s.base * s.zoom;
      return readRect(s.fl + s.fw / 2 - (s.natW * scale) / 2 + s.ox, s.ft + s.fh / 2 - (s.natH * scale) / 2 + s.oy, scale);
    }
    function setPreset(k, keepCentre) {
      var r = curRect(), cx = r[0] + r[2] / 2, cy = r[1] + r[3] / 2;
      preset = k;
      if (k !== 'free') { s.aspect = presetAr(k); }
      paintPresets();
      layout();
      s.zoom = 1; if (zoomEl) { zoomEl.value = 1; }
      applyRect(k === 'free' ? r : fitRect(s.aspect, keepCentre ? cx : 0.5, keepCentre ? cy : 0.5));
      drawHandles();
    }
    if (zoomEl) { zoomEl.max = post ? '12' : '3'; }
    // on load: pick the preset whose shape matches the stored crop (else Free), and arm the handles
    function postInit() {
      s.zmax = 12;
      var r = opts.initial, want = r ? (r[2] * s.natW) / (r[3] * s.natH) : s.natW / s.natH;
      preset = r ? 'free' : 'orig';
      if (r) {
        var cands = [['orig', s.natW / s.natH]].concat(CROP_PRESETS.filter(function (p) { return p[2] > 0; })
          .map(function (p) { return [p[0], p[2]]; }));
        for (var i = 0; i < cands.length; i++) { if (Math.abs(cands[i][1] / want - 1) < 0.01) { preset = cands[i][0]; break; } }
      }
      s.aspect = preset === 'free' ? want : presetAr(preset);
      paintPresets();
      drawHandles();
    }
    if (post && presetsEl) {
      CROP_PRESETS.forEach(function (p) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'crop-preset'; b.setAttribute('role', 'radio');
        b.setAttribute('data-k', p[0]); b.textContent = p[1];
        presetsEl.appendChild(b);
      });
      presetsEl.onclick = function (e) {
        var b = e.target && e.target.closest ? e.target.closest('.crop-preset') : null;
        if (b && s.natW) { setPreset(b.getAttribute('data-k'), b.getAttribute('data-k') !== 'orig'); }
      };
    }
    if (resetEl) {
      resetEl.onclick = function () { if (post && s.natW) { setPreset('orig', false); } };
    }
    // resize handles: corners always, edges only in Free (a fixed shape has no free edge)
    function drawHandles() {
      Array.prototype.forEach.call(frame.querySelectorAll('.crop-h'), function (h) { h.remove(); });
      if (!post) { return; }
      var hs = preset === 'free' ? ['nw', 'n', 'ne', 'e', 'se', 's', 'sw', 'w'] : ['nw', 'ne', 'se', 'sw'];
      hs.forEach(function (k) {
        var h = document.createElement('span');
        h.className = 'crop-h crop-h-' + k; h.setAttribute('data-h', k); h.setAttribute('aria-hidden', 'true');
        h.addEventListener('pointerdown', handleDown);
        frame.appendChild(h);
      });
    }
    var hd = null;
    function handleDown(e) {
      e.preventDefault(); e.stopPropagation();
      var scale = s.base * s.zoom, dw = s.natW * scale, dh = s.natH * scale;
      var il = s.fl + s.fw / 2 - dw / 2 + s.ox, it = s.ft + s.fh / 2 - dh / 2 + s.oy;
      var sw = stage.clientWidth, sh = stage.clientHeight;
      hd = { k: this.getAttribute('data-h'), id: e.pointerId, x0: e.clientX, y0: e.clientY,
             L: s.fl, T: s.ft, R: s.fl + s.fw, B: s.ft + s.fh, il: il, it: it, dw: dw, dh: dh, scale: scale,
             bl: Math.max(0, il), bt: Math.max(0, it), br: Math.min(sw, il + dw), bb: Math.min(sh, it + dh),
             min: Math.max(36, 64 * scale), a: s.fw / s.fh };
      document.addEventListener('pointermove', handleMove, true);
      document.addEventListener('pointerup', handleUp, true);
      document.addEventListener('pointercancel', handleUp, true);
    }
    function handleMove(e) {
      if (!hd || e.pointerId !== hd.id) { return; }
      e.preventDefault();
      var dx = e.clientX - hd.x0, dy = e.clientY - hd.y0, k = hd.k, m = hd.min;
      var L = hd.L, T = hd.T, R = hd.R, B = hd.B;
      if (preset === 'free') {
        if (k.indexOf('w') >= 0) { L = Math.min(R - m, Math.max(hd.bl, hd.L + dx)); }
        if (k.indexOf('e') >= 0) { R = Math.max(L + m, Math.min(hd.br, hd.R + dx)); }
        if (k.indexOf('n') >= 0) { T = Math.min(B - m, Math.max(hd.bt, hd.T + dy)); }
        if (k.indexOf('s') >= 0) { B = Math.max(T + m, Math.min(hd.bb, hd.B + dy)); }
      } else {
        // aspect-locked corner: the OPPOSITE corner is the anchor; width follows the pointer
        var a = hd.a, east = k.indexOf('e') >= 0, south = k.indexOf('s') >= 0;
        var ax = east ? hd.L : hd.R, ay = south ? hd.T : hd.B;
        var w = east ? (hd.R - hd.L) + dx : (hd.R - hd.L) - dx;
        var wv = (south ? (hd.B - hd.T) + dy : (hd.B - hd.T) - dy) * a;
        w = Math.max(w, wv);                                         // follow whichever axis moved further
        var maxW = Math.min(east ? hd.br - ax : ax - hd.bl, (south ? hd.bb - ay : ay - hd.bt) * a);
        w = Math.max(Math.max(m, m * a), Math.min(maxW, w));
        var h = w / a;
        L = east ? ax : ax - w; R = L + w; T = south ? ay : ay - h; B = T + h;
      }
      s.fl = L; s.ft = T; s.fw = R - L; s.fh = B - T;
      frame.style.left = L + 'px'; frame.style.top = T + 'px';
      frame.style.width = s.fw + 'px'; frame.style.height = s.fh + 'px';
      // the PICTURE stays exactly where it is; only the frame moved
      s.ox = hd.il - (s.fl + s.fw / 2 - hd.dw / 2);
      s.oy = hd.it - (s.ft + s.fh / 2 - hd.dh / 2);
      render();
    }
    function handleUp(e) {
      if (!hd || (e && e.pointerId !== hd.id)) { return; }
      document.removeEventListener('pointermove', handleMove, true);
      document.removeEventListener('pointerup', handleUp, true);
      document.removeEventListener('pointercancel', handleUp, true);
      var r = readRect(hd.il, hd.it, hd.scale);
      hd = null;
      if (preset === 'free') { s.aspect = (r[2] * s.natW) / (r[3] * s.natH); }
      layout();
      applyRect(r);
    }
    stage.style.background = '';        // a previous picture's pad tone must not leak into this one
    // The banner needs to say what the frame GUARANTEES, not just how to drag it: everything
    // inside it stays on screen, which is the promise the whole flow now keeps.
    var titleEl = ov.querySelector('.crop-title');
    if (titleEl) { titleEl.textContent = opts.title || 'Drag to reposition · scroll or pinch to zoom'; }
    ov.classList.add('show');
    lockScroll();

    /* zmin: the SMALLEST zoom allowed. It used to be a hardcoded 1, which is exactly "cover", so the
       frame could never show less than a full square of the picture and a wide image could only ever
       be cropped -- there was no gesture, slider position or button that reached the whole thing.
       Now 1 still means FILL (nothing about the familiar behaviour moves) and the slider is allowed
       to travel down to FIT, where the whole picture is inside the frame and the remainder is padded
       with padCss. Stays 1 in rect mode: the banner stores a normalized rect INSIDE its source, and
       a rect has no way to say "and pad the rest". */
    var s = { natW: 0, natH: 0, fw: 0, fh: 0, fl: 0, ft: 0, base: 1, zoom: 1, ox: 0, oy: 0, zmin: 1 };
    var padCss = '';                 // the sampled pad tone; '' until the picture has been read

    function render() {
      var scale = s.base * s.zoom, dw = s.natW * scale, dh = s.natH * scale;
      var mx = Math.max(0, (dw - s.fw) / 2), my = Math.max(0, (dh - s.fh) / 2);
      s.ox = Math.max(-mx, Math.min(mx, s.ox));
      s.oy = Math.max(-my, Math.min(my, s.oy));
      img.style.width = dw + 'px'; img.style.height = dh + 'px';
      img.style.left = (s.fl + s.fw / 2 - dw / 2 + s.ox) + 'px';
      img.style.top = (s.ft + s.fh / 2 - dh / 2 + s.oy) + 'px';
    }
    function layout() {
      var sw = stage.clientWidth, sh = stage.clientHeight, a = s.aspect || opts.aspect;   // s.aspect: post-crop presets
      var fw = sw * 0.86, fh = fw / a;
      if (fh > sh * 0.86) { fh = sh * 0.86; fw = fh * a; }
      s.fw = fw; s.fh = fh; s.fl = (sw - fw) / 2; s.ft = (sh - fh) / 2;
      frame.style.width = fw + 'px'; frame.style.height = fh + 'px';
      frame.style.left = s.fl + 'px'; frame.style.top = s.ft + 'px';
      s.base = Math.max(fw / s.natW, fh / s.natH);      // zoom 1 == FILL, exactly as before
      var fitScale = Math.min(fw / s.natW, fh / s.natH);
      s.zmin = opts.rect ? 1 : Math.min(1, fitScale / s.base);
      if (zoomEl) { zoomEl.min = s.zmin.toFixed(4); }
      render();
    }
    /* THE PAD TONE IS READ OFF THE PICTURE, NEVER ASSUMED. White-on-black and black-on-white both
       have to vanish into their own pad, and one hardcoded colour can only ever serve one of them.
       Twin of Upload::edgeTone() in lib/upload.php (same 64px ring, same median, same 24/85%
       flatness test, same transparent-border fallback) so the cropper and the no-JS/app server path
       reach the same answer for the same file. Returns the css colour plus the two facts the
       fit-or-fill default needs: is the border FLAT (a graphic on a background, where a pad is
       invisible) and does the image use ALPHA (where there is no background in the file at all). */
    function num(a, b) { return a - b; }
    function readTone(im) {
      var out = { css: 'rgb(0,0,0)', flat: false, alpha: false };
      var nw = im.naturalWidth, nh = im.naturalHeight;
      if (!nw || !nh) { return out; }
      var D = 64, sc = Math.min(1, D / Math.max(nw, nh));
      var dw = Math.max(3, Math.round(nw * sc)), dh = Math.max(3, Math.round(nh * sc));
      var c = document.createElement('canvas'); c.width = dw; c.height = dh;
      var ctx = c.getContext('2d'); if (!ctx) { return out; }
      var d;
      // Smoothing OFF: a smoothed downscale AVERAGES each block, and averaging a photograph's fine
      // texture down to 64px turns a noisy border into a smooth one -- which reads as "flat" and
      // would pad an ordinary photo. Nearest neighbour keeps real sample values. (Twin of the
      // imagecopyresized() note in Upload::edgeTone.)
      try { ctx.imageSmoothingEnabled = false; ctx.mozImageSmoothingEnabled = false; ctx.webkitImageSmoothingEnabled = false; } catch (e) {}
      try { ctx.drawImage(im, 0, 0, dw, dh); d = ctx.getImageData(0, 0, dw, dh).data; }
      catch (e) { return out; }
      var R = [], G = [], B = [], ring = 0, lum = 0, lit = 0, RG = 2;
      for (var y = 0; y < dh; y++) {
        for (var x = 0; x < dw; x++) {
          var i = (y * dw + x) * 4, a = d[i + 3];
          if (a < 250) { out.alpha = true; }
          if (a > 128) { lum += 0.2126 * d[i] + 0.7152 * d[i + 1] + 0.0722 * d[i + 2]; lit++; }
          if (!(x < RG || y < RG || x >= dw - RG || y >= dh - RG)) { continue; }
          ring++;
          if (a <= 128) { continue; }
          R.push(d[i]); G.push(d[i + 1]); B.push(d[i + 2]);
        }
      }
      var n = R.length;
      if (n > 0 && ring > 0 && n >= ring * 0.25) {
        // MEDIAN, not mean: a wordmark that bleeds to the frame edge drags a mean toward itself
        // and greys the pad, while the median holds the background as long as it is the majority.
        R.sort(num); G.sort(num); B.sort(num);
        var m = n >> 1, r = R[m], g = G[m], b = B[m], near = 0;
        for (var k = 0; k < n; k++) {
          if (Math.abs(R[k] - r) <= 24 && Math.abs(G[k] - g) <= 24 && Math.abs(B[k] - b) <= 24) { near++; }
        }
        out.flat = near >= n * 0.85;
        out.css = 'rgb(' + r + ',' + g + ',' + b + ')';
        return out;
      }
      // A transparent border has no tone to read, so pad by CONTRAST with the subject instead.
      var L = lit > 0 ? lum / lit : 128;
      out.css = L >= 140 ? 'rgb(11,11,13)' : 'rgb(242,242,243)';
      out.flat = true;
      return out;
    }
    /* Jump between the two ends. Re-centres, because arriving at "fit" still panned to where the
       member had dragged the fill would put the picture off-centre inside its own pad. */
    function setMode(mode) {
      s.ox = 0; s.oy = 0;
      setZoom(mode === 'fit' ? s.zmin : 1);
      if (!modesEl) { return; }
      Array.prototype.forEach.call(modesEl.querySelectorAll('.crop-mode'), function (b) {
        var on = b.getAttribute('data-mode') === mode;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.classList.toggle('on', on);
      });
    }
    /* RECT MODE (profile banner, migration 0131). Instead of re-encoding the picture into a
       cropped canvas, hand back WHERE the frame sits on the source, as four numbers in 0..1 of
       the source's own width/height. Normalized, so it survives every later downscale and every
       variant; and because the original file is what gets stored, the framing stays editable
       instead of being burned in once and lost. */
    function readRect(imgLeft, imgTop, scale) {
      var x = (s.fl - imgLeft) / scale / s.natW;
      var y = (s.ft - imgTop) / scale / s.natH;
      var w = s.fw / scale / s.natW;
      var h = s.fh / scale / s.natH;
      /* BACK OUT OF THE TRIM, SO THESE NUMBERS DESCRIBE THE FILE THE SERVER GETS (2026-09-19).
         trimLetterbox() re-encodes the source before the modal ever shows it, so everything above
         is normalized to the TRIMMED picture -- which is not what is uploaded (the upload is
         `file`, untrimmed). Until today the caller's only answer to that was to send no rect at
         all, and that cost 18 members their crop in two days: a phone SCREENSHOT with black
         status/nav bars trims on nearly every signup, so the "rare" case was ~9% of uploads.
         The composition is exact and it preserves the square invariant the server gates on --
         the window's side in ORIGINAL pixels is w*ow either way, so w*photo_w == h*photo_h
         survives untouched. Only ever set for the avatar: rect mode never trims. */
      if (trimGeom && trimGeom.nw > 0 && trimGeom.nh > 0) {
        x = (trimGeom.ox + x * trimGeom.ow) / trimGeom.nw;
        y = (trimGeom.oy + y * trimGeom.oh) / trimGeom.nh;
        w = (w * trimGeom.ow) / trimGeom.nw;
        h = (h * trimGeom.oh) / trimGeom.nh;
      }
      /* TWO CONTRACTS, AND CLAMPING BOTH TO 0..1 SILENTLY BROKE ONE (2026-09-15, @kayandg559).
         The banner (opts.rect, users.cover_crop / 0131) names a window INSIDE its picture, so
         clamping is right there and always was. The AVATAR does not: in FIT mode the cropper
         scales the whole picture inside the square frame and pads the remainder, so the window is
         genuinely larger than the photo on one axis and its origin is genuinely negative. Clamping
         that turned a real 367x553 fit rect of x=-0.253406, w=1.506812 into "0,0,1,1" -- which is
         not square in original pixels (367 vs 553), so Upload::avatarCropAccept() refused it and
         the member got no crop at all. db/0177 and Upload::avatarCropParse() were built to carry
         out-of-range values; this line was still throwing them away before they left the browser.
         100 members lost their rect this way in under two days.
         The avatar bound mirrors the server's Upload::AVATAR_CROP_MAX_SIDE (16) -- an outer
         sanity limit, never a reshaping clamp, so a real rect passes through untouched. */
      if (opts.rect) {
        w = Math.min(1, Math.max(0.0001, w)); h = Math.min(1, Math.max(0.0001, h));
        x = Math.min(1 - w, Math.max(0, x));      y = Math.min(1 - h, Math.max(0, y));
      } else {
        w = Math.min(16, Math.max(0.0001, w));  h = Math.min(16, Math.max(0.0001, h));
        x = Math.min(16, Math.max(-16, x));     y = Math.min(16, Math.max(-16, y));
      }
      function r6(v) { return Math.round(v * 1e6) / 1e6; }
      return [r6(x), r6(y), r6(w), r6(h)];
    }
    /* The inverse: reopen the cropper already showing the framing that is stored, so
       "Reposition" starts from what the member is looking at rather than snapping back
       to the middle. Derived from render()'s own geometry, so the two cannot drift. */
    function applyRect(rect) {
      if (!rect || rect.length !== 4 || !s.natW || !s.natH) { return; }
      var w = +rect[2]; if (!(w > 0)) { return; }
      var scale = s.fw / (w * s.natW);
      s.zoom = Math.min(s.zmax || 3, Math.max(1, s.base > 0 ? scale / s.base : 1));
      scale = s.base * s.zoom;                       // re-read after the clamp
      s.ox = (s.natW * scale) / 2 - s.fw / 2 - (+rect[0]) * s.natW * scale;
      s.oy = (s.natH * scale) / 2 - s.fh / 2 - (+rect[1]) * s.natH * scale;
      if (zoomEl) { zoomEl.value = s.zoom; }
      render();
    }
    // Trim solid letterbox / pillarbox black bars out of the SOURCE before cropping, so a
    // widescreen video still (or any photo with black edges) can't leave black space in the
    // circle. Runs once per open; the geometric clamp in render() then keeps the bar-free
    // image covering the frame no matter how it's panned or zoomed.
    function trimLetterbox(im) {
      var nw = im.naturalWidth, nh = im.naturalHeight;
      if (!nw || !nh) return null;
      var D = 140, sc = Math.min(1, D / Math.max(nw, nh));
      var dw = Math.max(1, Math.round(nw * sc)), dh = Math.max(1, Math.round(nh * sc));
      var c = document.createElement('canvas'); c.width = dw; c.height = dh;
      var ctx = c.getContext('2d'); if (!ctx) return null;
      var data;
      try { ctx.drawImage(im, 0, 0, dw, dh); data = ctx.getImageData(0, 0, dw, dh).data; }
      catch (e) { return null; }
      // TRANSPARENCY IS NOT A BLACK BAR. A canvas starts as rgba(0,0,0,0), so a PNG with a
      // transparent margin reads as pure black in r/g/b and this scanner would "trim" the
      // designer's own breathing room -- and then re-encode to JPEG, turning every remaining
      // transparent pixel black for good. There is nothing to gain here on a source with alpha
      // (the pad tone is sampled and the frame can now FIT), so leave it entirely alone.
      for (var ai = 3; ai < data.length; ai += 4) { if (data[ai] < 250) { return null; } }
      var TH = 22;   // per-channel "this pixel is black"
      function rowBlack(y) { for (var x = 0; x < dw; x++) { var i = (y * dw + x) * 4; if (data[i] > TH || data[i + 1] > TH || data[i + 2] > TH) return false; } return true; }
      function colBlack(x) { for (var y = 0; y < dh; y++) { var i = (y * dw + x) * 4; if (data[i] > TH || data[i + 1] > TH || data[i + 2] > TH) return false; } return true; }
      var t = 0, b = 0, l = 0, r = 0;
      while (t < dh && rowBlack(t)) t++;
      while (b < dh - t && rowBlack(dh - 1 - b)) b++;
      while (l < dw && colBlack(l)) l++;
      while (r < dw - l && colBlack(dw - 1 - r)) r++;
      if (t + b === 0 && l + r === 0) return null;                    // no bars
      // Two sanity rules, both learned from a black "ESSENCE" logo that opened as a
      // single giant letter (owner, #crop): trimming to the subject's bounding box
      // makes a wide strip, the strip COVERS the square frame at ~5x, and because the
      // zoom slider floors at cover (1x) there is no way to get back out of it.
      //  1. A letterbox is bars on ONE axis (top/bottom) and a pillarbox on the other.
      //     Bars on BOTH axes aren't bars at all -- that's a photo sitting on black
      //     (a logo, a night shot), and its "bars" are just background we must keep.
      //  2. A genuine bar is modest: 2.39:1 inside 16:9 is 25% of the height, a 4:3
      //     pillarbox 25% of the width. Past ~35% it's background, not a bar.
      var vert = (t + b) / dh, horz = (l + r) / dw;
      if (vert > 0.015 && horz > 0.015) return null;                  // subject bounding box
      if (vert > 0.35 || horz > 0.35) return null;                    // background, not a bar
      var ot = Math.round(t / sc), ob = Math.round(b / sc), ol = Math.round(l / sc), orr = Math.round(r / sc);
      if ((ot + ob) < nh * 0.015 && (ol + orr) < nw * 0.015) return null;   // negligible edge, not worth a recompress
      var cw = nw - ol - orr, ch = nh - ot - ob;
      if (cw < 16 || ch < 16) return null;
      var oc = document.createElement('canvas'); oc.width = cw; oc.height = ch;
      var octx = oc.getContext('2d'); if (!octx) return null;
      octx.drawImage(im, ol, ot, cw, ch, 0, 0, cw, ch);
      /* THE GEOMETRY RIDES OUT WITH THE PIXELS (2026-09-19). Returning only the data URL is what
         cost 18 members their rect over 09-17/18: the caller knew the source had been replaced but
         not BY WHAT, so the only honest thing left to do was send no rect at all. These four
         numbers are the whole relationship between the picture the cropper shows and the file the
         server receives, and they are free -- we have just computed them. See readRect(). */
      try {
        return { url: oc.toDataURL('image/jpeg', 0.95), ox: ol, oy: ot, ow: cw, oh: ch, nw: nw, nh: nh };
      } catch (e) { return null; }
    }
    var trimmedOnce = false;
    // trimmedOnce only says the trim was ATTEMPTED; this says it actually replaced the source, and
    // the two are not the same thing on any picture without black bars.
    var didTrim = false;
    /* WHERE THE TRIMMED PICTURE SITS IN THE FILE THAT IS UPLOADED, or null when nothing was
       trimmed. readRect() composes through this so the rect it returns is ALWAYS in the
       coordinates of the uploaded original, trimmed or not -- which is what makes a trimmed
       source sendable instead of silently rect-less. */
    var trimGeom = null;
    img.onload = function () {
      // NEVER trim in rect mode. The rect is measured against the file that gets UPLOADED, so
      // silently re-encoding the source here would make every stored number describe a picture
      // the server never receives. Trimming stays on for the avatar, where the canvas IS the
      // output (see the ESSENCE-logo sanity rules above).
      if (!trimmedOnce && !opts.rect) {            // first load: strip any black bars, then reload
        trimmedOnce = true;
        var trimmed = trimLetterbox(img);
        if (trimmed) { didTrim = true; trimGeom = trimmed; img.src = trimmed.url; return; }
      }
      s.natW = img.naturalWidth; s.natH = img.naturalHeight;
      s.zoom = 1; s.ox = 0; s.oy = 0; if (zoomEl) zoomEl.value = 1;
      if (post) { postInit(); }                         // post crop: preset + aspect before the frame is laid out
      layout();
      if (opts.initial) { applyRect(opts.initial); }   // reopen on the framing already stored
      if (opts.rect) { if (modesEl) { modesEl.hidden = true; } return; }

      /* THE DEFAULT, AND WHY IT IS NOT "ALWAYS FIT". Cropping a PHOTOGRAPH into a circle is the
         normal, wanted thing -- opening every 4:3 selfie letterboxed would make the common case
         worse to fix the rare one. So fill stays the default for anything photograph-shaped, and
         we open on FIT only where a square crop is genuinely destructive:
           - distance from square >= 2.0: at 2:1 and past it a square crop discards half the
             picture. Nobody frames anything expecting that.
           - a FLAT-EDGED source from 1.15: uniform edges mean a graphic on a background, i.e. a
             logo or a wordmark. The pad IS that background, so fitting costs nothing visible,
             while cropping a wordmark destroys the word.
           - any transparency: there is no background in the file, so the member cannot see what
             they are losing at the edges until it is already stored.
         Same three tests, same constants, as Upload::avatarFitSquare() on the server -- the two
         must agree or the picture would change shape depending on whether the bundle had loaded.
         And whichever way this lands, the member can now move it: that is what zmin buys. */
      var tone = readTone(img);
      padCss = tone.css;
      stage.style.background = padCss;      // the preview shows the real pad, not a guessed black
      var dist = Math.max(s.natW, s.natH) / Math.min(s.natW, s.natH);
      var wantFit = dist >= 2.0 || (tone.flat && dist >= 1.15) || tone.alpha;
      // Nothing to choose between when fit and fill are the SAME picture, i.e. a square source --
      // both buttons would do the identical thing, and an inert control is worse than no control.
      // (A square with transparency still gets the pad; that needs no choice from the member.)
      if (modesEl) { modesEl.hidden = s.zmin >= 0.999; }
      setMode(wantFit ? 'fit' : 'fill');
    };
    // A File when the member has just picked one; a URL when they are RE-framing the banner
    // that is already on file, which needs no upload at all.
    if (post) { img.removeAttribute('src'); }   // re-opening the SAME photo must still fire onload
    img.src = opts.src || URL.createObjectURL(file);

    // one pointer-events gesture layer: drag to pan, two fingers pinch, wheel
    // (or trackpad scroll) zooms at the cursor, and the slider stays as backup
    var pts = new Map(), pinch0 = 0, lx = 0, ly = 0;
    function setZoom(z, cx, cy) {            // zoom anchored at stage point (cx,cy)
      // s.zmin, not 1: the floor used to BE cover, which is why a wide picture could only ever be
      // cropped. Still 1 for a square source and in rect mode, so nothing familiar moves.
      z = Math.min(s.zmax || 3, Math.max(s.zmin || 1, z));
      var k = s.zoom > 0 ? z / s.zoom : 1;
      if (cx !== undefined) {
        var px = cx - (s.fl + s.fw / 2), py = cy - (s.ft + s.fh / 2);
        s.ox = px - k * (px - s.ox);
        s.oy = py - k * (py - s.oy);
      }
      s.zoom = z;
      if (zoomEl) zoomEl.value = z;
      if (modesEl && !modesEl.hidden) {      // pinching back out to fit must light the right button
        var atFit = z <= s.zmin + 0.001, atFill = Math.abs(z - 1) <= 0.001;
        Array.prototype.forEach.call(modesEl.querySelectorAll('.crop-mode'), function (b) {
          var on = b.getAttribute('data-mode') === 'fit' ? atFit : (atFill && !atFit);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
          b.classList.toggle('on', on);
        });
      }
      render();
    }
    stage.onpointerdown = function (e) {
      e.preventDefault();
      if (stage.setPointerCapture) { try { stage.setPointerCapture(e.pointerId); } catch (err) {} }
      pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
      if (pts.size === 1) { lx = e.clientX; ly = e.clientY; }
      if (pts.size === 2) {
        var p = Array.from(pts.values());
        pinch0 = Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y);
      }
    };
    stage.onpointermove = function (e) {
      if (!pts.has(e.pointerId)) return;
      pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
      var p = Array.from(pts.values());
      if (pts.size >= 2 && pinch0 > 0) {
        var d = Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y);
        var r = stage.getBoundingClientRect();
        setZoom(s.zoom * (d / pinch0),
                (p[0].x + p[1].x) / 2 - r.left, (p[0].y + p[1].y) / 2 - r.top);
        pinch0 = d;
      } else if (pts.size === 1) {
        s.ox += e.clientX - lx; s.oy += e.clientY - ly;
        lx = e.clientX; ly = e.clientY;
        render();
      }
    };
    stage.onpointerup = stage.onpointercancel = function (e) {
      pts.delete(e.pointerId);
      pinch0 = 0;
      var p = Array.from(pts.values());
      if (p.length === 1) { lx = p[0].x; ly = p[0].y; }   // pinch -> pan handoff
    };
    stage.onwheel = function (e) {
      e.preventDefault();
      var r = stage.getBoundingClientRect();
      setZoom(s.zoom - e.deltaY * 0.004, e.clientX - r.left, e.clientY - r.top);
    };
    if (zoomEl) zoomEl.oninput = function () { setZoom(parseFloat(zoomEl.value) || 1); };
    if (modesEl) {
      modesEl.onclick = function (e) {
        var b = e.target && e.target.closest ? e.target.closest('.crop-mode') : null;
        if (b) { setMode(b.getAttribute('data-mode')); }
      };
    }

    function cleanup() {
      ov.classList.remove('show'); unlockScroll();
      pts.clear(); pinch0 = 0;
    }
    ov.querySelector('.crop-cancel').onclick = function () { cleanup(); if (opts.onCancel) opts.onCancel(); };
    ov.querySelector('.crop-save').onclick = function () {
      var scale = s.base * s.zoom;
      var imgLeft = s.fl + s.fw / 2 - (s.natW * scale) / 2 + s.ox;
      var imgTop = s.ft + s.fh / 2 - (s.natH * scale) / 2 + s.oy;
      if (opts.rect) { cleanup(); if (opts.onDone) { opts.onDone(readRect(imgLeft, imgTop, scale)); } return; }
      var c = document.createElement('canvas');
      c.width = opts.outW; c.height = opts.outH;
      var cctx = c.getContext('2d');
      /* PAINT THE PAD FIRST. Two things need it, and both used to come out black: the frame can
         now hold more than the picture (fit), and a source with transparency has holes in it --
         a canvas starts as transparent black and the JPEG encoder drops alpha, so every one of
         those pixels landed as #000 no matter what the artwork wanted behind it. */
      cctx.fillStyle = padCss || '#000';
      cctx.fillRect(0, 0, opts.outW, opts.outH);
      /* Then draw the part of the frame the picture actually covers. The source rect is clipped
         to the image and the destination rect is clipped to match, rather than relying on
         drawImage's out-of-bounds behaviour -- the spec says the outside is transparent black,
         which would paint a black bar straight over the pad we just laid down on any engine that
         composites it rather than skipping it. */
      var sx = (s.fl - imgLeft) / scale, sy = (s.ft - imgTop) / scale;
      var sw = s.fw / scale, sh = s.fh / scale;
      var kx = opts.outW / sw, ky = opts.outH / sh;
      var x0 = Math.max(0, sx), y0 = Math.max(0, sy);
      var x1 = Math.min(s.natW, sx + sw), y1 = Math.min(s.natH, sy + sh);
      if (x1 > x0 && y1 > y0) {
        cctx.drawImage(img, x0, y0, x1 - x0, y1 - y0,
                       (x0 - sx) * kx, (y0 - sy) * ky, (x1 - x0) * kx, (y1 - y0) * ky);
      }
      /* s.natW/s.natH ride along as a second onDone argument (harmless for every caller that only
         takes the blob -- the cover flow returns above, in rect mode, before this line ever runs).
         The avatar picker below uses it to decide whether the SOURCE was worth preserving whole.

         AND NOW `rect` AND `trimmed` (db/0177, 2026-09-14). We are standing in the one place on
         this platform that has ever KNOWN where the square was cut, and until today it threw that
         away: the canvas above bakes the pixels, `file` is uploaded whole beside it, and nothing
         recorded the relationship. So the iOS flight from the ring to the full photo could only
         crop the middle, which is Rob's "it shows the wrong part of the picture and snaps on
         landing". readRect() is the SAME function the banner (0131) has used since August -- the
         frame's position on the source as four normalized floats -- so this is not new geometry,
         it is geometry that was already being computed and discarded.

         `trimmed` is the honesty flag and it is load-bearing. trimLetterbox() re-encodes the
         source before the modal ever shows it, so when it has run, s.natW/s.natH and every number
         readRect() derives describe a picture the SERVER NEVER RECEIVES (the upload is `file`, the
         untrimmed original). The caller declines to send a rect in that case rather than sending
         one that is quietly wrong -- and the server verifies whatever does arrive anyway
         (Upload::avatarCropAccept). */
      var savedRect = readRect(imgLeft, imgTop, scale);
      c.toBlob(function (blob) {
        cleanup();
        if (blob && opts.onDone) {
          opts.onDone(blob, { natW: s.natW, natH: s.natH, rect: savedRect, trimmed: didTrim });
        }
      }, 'image/jpeg', 0.9);
    };
  }

  // In-app video trimmer: pick a 3-second window and re-encode it (captureStream +
  // MediaRecorder), which fixes BOTH an over-length clip and an over-size file in one
  // step, then hands back a small blob. Falls back gracefully where unsupported.
  function trimSupported() {
    try {
      if (typeof MediaRecorder === 'undefined') return false;
      // The encoder records canvas.captureStream() -- so check THAT, not video.captureStream.
      // iOS Safari (15+) supports canvas.captureStream + MediaRecorder but NOT video.captureStream,
      // and the old check tested the wrong one, so iPhones fell through to the raw reject message.
      var c = document.createElement('canvas');
      return typeof c.captureStream === 'function';
    } catch (e) { return false; }
  }
  function openVideoTrimmer(file, opts) {
    opts = opts || {};
    var CLIP = 3, OUT = 480;               // a 3-second, 480x480 square avatar clip
    var url = URL.createObjectURL(file);
    var modal = document.createElement('div');
    modal.className = 'vtrim';
    modal.innerHTML =
      '<div class="vtrim-card">'
      + '<div class="vtrim-title">Trim &amp; crop your clip</div>'
      + '<div class="vtrim-sub">Drag to reposition, pinch or scroll to zoom. Slide to pick your 3 seconds.</div>'
      + '<div class="crop-stage vtrim-stage"><video class="vtrim-video" muted playsinline></video><div class="crop-frame round"></div></div>'
      + '<input type="range" class="vtrim-start" min="0" max="0" step="0.1" value="0">'
      + '<div class="vtrim-time">Start <span class="vtrim-cur">0.0s</span> · ends <span class="vtrim-end">3.0s</span></div>'
      + '<div class="vtrim-status" hidden>Preparing your clip…</div>'
      + '<div class="vtrim-actions">'
      +   '<button type="button" class="btn ghost vtrim-cancel">Cancel</button>'
      +   '<button type="button" class="btn primary vtrim-use">Use clip</button>'
      + '</div></div>';
    document.body.appendChild(modal);
    lockScroll();
    var stage = modal.querySelector('.vtrim-stage');
    var video = modal.querySelector('.vtrim-video');
    var frame = modal.querySelector('.crop-frame');
    var slider = modal.querySelector('.vtrim-start');
    var curEl = modal.querySelector('.vtrim-cur'), endEl = modal.querySelector('.vtrim-end');
    var useBtn = modal.querySelector('.vtrim-use'), cancelBtn = modal.querySelector('.vtrim-cancel');
    var statusEl = modal.querySelector('.vtrim-status');
    var start = 0, dur = 0, done = false;
    // pan/zoom crop state, same model as the image cropper: base = cover scale, zoom + (ox,oy) = pan
    var s = { vw: 0, vh: 0, fw: 0, fh: 0, fl: 0, ft: 0, base: 1, zoom: 1, ox: 0, oy: 0 };

    function cleanup() { try { URL.revokeObjectURL(url); } catch (e) {} modal.remove(); unlockScroll(); }
    function finish(cb, arg) { if (done) return; done = true; cleanup(); if (cb) cb(arg); }
    function render() {
      var scale = s.base * s.zoom, dw = s.vw * scale, dh = s.vh * scale;
      var mx = Math.max(0, (dw - s.fw) / 2), my = Math.max(0, (dh - s.fh) / 2);
      s.ox = Math.max(-mx, Math.min(mx, s.ox));         // clamp so the video always covers the square
      s.oy = Math.max(-my, Math.min(my, s.oy));
      video.style.width = dw + 'px'; video.style.height = dh + 'px';
      video.style.left = (s.fl + s.fw / 2 - dw / 2 + s.ox) + 'px';
      video.style.top = (s.ft + s.fh / 2 - dh / 2 + s.oy) + 'px';
    }
    function layout() {
      var sw = stage.clientWidth, sh = stage.clientHeight;
      var fw = Math.min(sw, sh) * 0.9;                  // a centered SQUARE crop frame
      s.fw = fw; s.fh = fw; s.fl = (sw - fw) / 2; s.ft = (sh - fw) / 2;
      frame.style.width = fw + 'px'; frame.style.height = fw + 'px';
      frame.style.left = s.fl + 'px'; frame.style.top = s.ft + 'px';
      s.base = Math.max(fw / s.vw, fw / s.vh);           // cover the square
      render();
    }
    function labels() {
      start = parseFloat(slider.value) || 0;
      curEl.textContent = start.toFixed(1) + 's';
      endEl.textContent = Math.min(dur || CLIP, start + CLIP).toFixed(1) + 's';
    }

    video.src = url; video.muted = true;
    video.onloadedmetadata = function () {
      dur = video.duration && isFinite(video.duration) ? video.duration : CLIP;
      s.vw = video.videoWidth || 480; s.vh = video.videoHeight || 480;
      slider.max = Math.max(0, dur - CLIP).toFixed(1);
      labels(); layout();
      try { video.currentTime = 0; } catch (e) {}
      video.play().catch(function () {});
    };
    video.ontimeupdate = function () {                   // loop the chosen 3s window as a live preview
      if (video.currentTime >= start + CLIP || video.currentTime < start - 0.05) {
        try { video.currentTime = start; } catch (e) {}
      }
    };
    slider.addEventListener('input', function () { labels(); try { video.currentTime = start; } catch (e) {} });

    // one gesture layer over the stage: drag to pan, two fingers pinch, wheel/trackpad zooms at the cursor
    var pts = new Map(), pinch0 = 0, lx = 0, ly = 0;
    function setZoom(z, cx, cy) {
      z = Math.min(4, Math.max(1, z));
      var k = s.zoom > 0 ? z / s.zoom : 1;
      if (cx !== undefined) {
        var px = cx - (s.fl + s.fw / 2), py = cy - (s.ft + s.fh / 2);
        s.ox = px - k * (px - s.ox); s.oy = py - k * (py - s.oy);
      }
      s.zoom = z; render();
    }
    stage.onpointerdown = function (e) {
      e.preventDefault();
      if (stage.setPointerCapture) { try { stage.setPointerCapture(e.pointerId); } catch (err) {} }
      pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
      if (pts.size === 1) { lx = e.clientX; ly = e.clientY; }
      if (pts.size === 2) { var p = Array.from(pts.values()); pinch0 = Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y); }
    };
    stage.onpointermove = function (e) {
      if (!pts.has(e.pointerId)) return;
      pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
      var p = Array.from(pts.values());
      if (pts.size >= 2 && pinch0 > 0) {
        var d = Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y);
        var r = stage.getBoundingClientRect();
        setZoom(s.zoom * (d / pinch0), (p[0].x + p[1].x) / 2 - r.left, (p[0].y + p[1].y) / 2 - r.top);
        pinch0 = d;
      } else if (pts.size === 1) {
        s.ox += e.clientX - lx; s.oy += e.clientY - ly; lx = e.clientX; ly = e.clientY; render();
      }
    };
    stage.onpointerup = stage.onpointercancel = function (e) {
      pts.delete(e.pointerId); pinch0 = 0;
      var p = Array.from(pts.values()); if (p.length === 1) { lx = p[0].x; ly = p[0].y; }
    };
    stage.onwheel = function (e) { e.preventDefault(); var r = stage.getBoundingClientRect(); setZoom(s.zoom - e.deltaY * 0.004, e.clientX - r.left, e.clientY - r.top); };

    cancelBtn.addEventListener('click', function () { finish(opts.onCancel); });
    useBtn.addEventListener('click', function () {
      useBtn.disabled = true; cancelBtn.disabled = true; if (statusEl) statusEl.hidden = false;
      // the SQUARE region of the source shown in the frame, in video pixels, fixed from the final pan/zoom
      var scale = s.base * s.zoom;
      var vLeft = s.fl + s.fw / 2 - (s.vw * scale) / 2 + s.ox;
      var vTop  = s.ft + s.fh / 2 - (s.vh * scale) / 2 + s.oy;
      var sSize = s.fw / scale;
      var sx = Math.max(0, Math.min(s.vw - sSize, (s.fl - vLeft) / scale));
      var sy = Math.max(0, Math.min(s.vh - sSize, (s.ft - vTop) / scale));
      // Re-encode the cropped window through a CANVAS at a constant 30fps (canvas.captureStream +
      // MediaRecorder). Drawing the crop rect to a square OUTxOUT canvas trims AND crops in one pass,
      // and the steady 30fps avoids the slow-motion timestamps a raw video.captureStream() produced.
      var canvas = document.createElement('canvas'); canvas.width = OUT; canvas.height = OUT;
      var ctx = canvas.getContext('2d', { alpha: false });
      var mime = ['video/mp4', 'video/webm;codecs=vp9', 'video/webm;codecs=vp8', 'video/webm']
        .filter(function (m) { try { return MediaRecorder.isTypeSupported(m); } catch (e) { return false; } })[0] || '';
      var stream, rec, raf = 0;
      try {
        stream = canvas.captureStream(30);
        rec = mime ? new MediaRecorder(stream, { mimeType: mime, videoBitsPerSecond: 2500000 }) : new MediaRecorder(stream);
      } catch (e) { finish(opts.onUnsupported); return; }
      var chunks = [];
      rec.ondataavailable = function (e) { if (e.data && e.data.size) chunks.push(e.data); };
      rec.onstop = function () {
        try { cancelAnimationFrame(raf); } catch (e) {}
        var type = (mime || 'video/webm').split(';')[0];
        var ext = type.indexOf('mp4') >= 0 ? 'mp4' : 'webm';
        var out = new File([new Blob(chunks, { type: type })], 'avatar.' + ext, { type: type });
        finish(opts.onDone, out);
      };
      function draw() { try { ctx.drawImage(video, sx, sy, sSize, sSize, 0, 0, OUT, OUT); } catch (e) {} raf = requestAnimationFrame(draw); }
      try { video.currentTime = start; } catch (e) {}
      video.play().catch(function () {});
      draw();
      rec.start();
      var stopAt = start + CLIP;
      var tick = setInterval(function () {
        if (video.currentTime >= stopAt || video.ended || rec.state !== 'recording') {
          clearInterval(tick);
          try { rec.stop(); } catch (e) {}
          try { video.pause(); } catch (e) {}
        }
      }, 40);
    });
  }

  var avatarFile = document.getElementById('avatar-file');
  if (avatarFile) {
    /* Retire the CSS-only "Still getting ready, one moment." line in views/onboarding.php.
       assets/onb-boot.js normally does this seconds earlier; this is the case where the small
       file failed and the big one did not, so the row is live either way. */
    try { document.documentElement.classList.add('onb-js'); } catch (e) {}
    var errEl = document.getElementById('avatar-error');
    var avStatus = document.getElementById('avatar-status');
    var cur = document.getElementById('avatar-current');
    var orig = cur ? cur.innerHTML : '';
    function showAvatar(file) {
      var el = previewInto(cur, file);
      if (el) el.className = 'avatar lg';
    }
    function avErr(msg) {
      if (errEl) { errEl.hidden = false; errEl.textContent = msg; }
      if (avStatus) avStatus.hidden = true;
      avatarFile.value = ''; if (cur) cur.innerHTML = orig;
    }
    function avUseVideo(file) { showAvatar(file); bgUpload(file, 'avatar', avStatus, avatarFile); }
    function avResetPick() { avatarFile.value = ''; if (cur) cur.innerHTML = orig; }
    // Over-length or over-size clip -> offer the in-app trimmer (which re-encodes a
    // 3s window down to a small file) instead of just rejecting it.
    function avOfferTrim(file, reason) {
      if (!trimSupported()) { avErr(reason); return; }
      openVideoTrimmer(file, {
        onDone: function (clip) {
          if (clip.size > UP_AVATAR_VID_MAX) {
            avErr('Even trimmed, that clip is ' + fmtSize(clip.size) + '. Try picking a shorter, calmer 3 seconds.');
            avResetPick(); return;
          }
          avUseVideo(clip);   // the original oversized file is discarded (never uploaded)
        },
        onCancel: avResetPick,
        onUnsupported: function () { avErr(reason); avResetPick(); }
      });
    }
    /* THE PRE-CROP ORIGINAL WAS GOING UP AT FULL SIZE (2026-10-02). Rob's own signup sent a
       4.35 MB body -- a 1260x2736 PNG screenshot riding beside a 640px crop -- and the server
       then shrinks it to a 2560px JPEG anyway (Upload::storeAvatarOriginal -> optimizeImage,
       IMG_MAX_DIM). So the extra megabytes bought nothing but uplink time on a phone. Do the
       same reduction here first: longest edge 2560, JPEG, flattened onto WHITE exactly like the
       server's PNG path. The crop rect is fractions of the picture, so it is unchanged by a
       uniform scale (aspect is kept to the rounding pixel; avatarCropAccept's square tolerance
       is far wider). The canvas draws the browser-ORIENTED pixels -- the same orientation the
       cropper measured natW/natH in -- and carries no EXIF, so the server has nothing to re-turn.
       Anything that cannot be decoded in time is sent untouched, never refused. */
    var AV_ORIG_EDGE = 2560, AV_ORIG_OVER = 1200 * 1024;
    function avShrinkOrig(file, cb) {
      var settled = false, url = '';
      function give(out) {
        if (settled) { return; }
        settled = true;
        try { if (url) { URL.revokeObjectURL(url); } } catch (e) {}
        cb(out);
      }
      if (!file || String(file.type || '').indexOf('image') !== 0 || /gif/i.test(file.type)
          || !window.URL || !URL.createObjectURL) { give(file); return; }
      try { url = URL.createObjectURL(file); } catch (e) { give(file); return; }
      var im = new Image();
      setTimeout(function () { give(file); }, 5000);
      im.onerror = function () { give(file); };
      im.onload = function () {
        try {
          var w = im.naturalWidth, h = im.naturalHeight;
          if (!w || !h) { give(file); return; }
          var big = Math.max(w, h) > AV_ORIG_EDGE;
          if (!big && file.size <= AV_ORIG_OVER) { give(file); return; }
          var sc = Math.min(1, AV_ORIG_EDGE / Math.max(w, h));
          var c = document.createElement('canvas');
          c.width = Math.max(1, Math.round(w * sc)); c.height = Math.max(1, Math.round(h * sc));
          var ctx = c.getContext('2d');
          if (!ctx || !c.toBlob) { give(file); return; }
          ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, c.width, c.height);
          ctx.drawImage(im, 0, 0, c.width, c.height);
          c.toBlob(function (b) {
            if (!b || b.size >= file.size) { give(file); return; }
            try { give(new File([b], 'avatar_orig.jpg', { type: 'image/jpeg' })); }
            catch (e) { give(b); }
          }, 'image/jpeg', 0.9);
        } catch (e) { give(file); }
      };
      im.src = url;
    }
    avatarFile.addEventListener('change', function () {
      if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
      var file = avatarFile.files[0];
      if (!file) { if (cur) cur.innerHTML = orig; return; }
      var isVideo = file.type.indexOf('video') === 0;
      if (isVideo) {
        var v = document.createElement('video');
        v.preload = 'metadata';
        v.onloadedmetadata = function () {
          try { URL.revokeObjectURL(v.src); } catch (e) {}
          var tooBig = file.size > UP_AVATAR_VID_MAX, tooLong = v.duration > 3.5;
          if (tooLong) {
            avOfferTrim(file, 'That clip is ' + v.duration.toFixed(1) + 's, and a profile video is 3 seconds.');
          } else if (tooBig) {
            avOfferTrim(file, 'That file is ' + fmtSize(file.size) + ', max ' + Math.floor(UP_AVATAR_VID_MAX / 1048576) + ' MB.');
          } else {
            avUseVideo(file);
          }
        };
        v.onerror = function () {   // can't read metadata: honor the hard size cap, else try it
          if (file.size > UP_AVATAR_VID_MAX) { avOfferTrim(file, 'That file is ' + fmtSize(file.size) + ', max ' + Math.floor(UP_AVATAR_VID_MAX / 1048576) + ' MB.'); }
          else { avUseVideo(file); }
        };
        v.src = URL.createObjectURL(file);
        return;
      }
      if (file.size > UP_IMG_MAX) {
        avErr('That photo is ' + fmtSize(file.size) + ', max ' + Math.floor(UP_IMG_MAX / 1048576) + ' MB. Please pick a smaller one.');
        return;
      }
      {
        openCropper(file, {
          aspect: 1, round: true, outW: 640, outH: 640,
          onDone: function (blob, meta) {
            var f = new File([blob], 'avatar.jpg', { type: 'image/jpeg' });
            var el = previewInto(cur, f); if (el) el.className = 'avatar lg';
            /* PRESERVE THE SOURCE for AvatarPost (owner 2026-08-24: "they shouldn't always be
               square ... if it was a portrait then it should still be so it fills the screen
               properly"). The canvas above is baked to a 640x640 SQUARE for the profile-photo
               slot -- right, and staying -- but it is also the ONLY thing that has ever reached
               the server: `file` never leaves the browser otherwise. The hidden avatar post
               (lib/avatarpost.php) is what the pfeed/full-screen viewer actually shows when a
               profile photo is opened, so it only ever had this same square to display, however
               far from square the member's real photo was. Send `file` alongside the crop, but
               ONLY when the source is not already close to square (a small tolerance for
               near-square/rounding) -- someone whose photo WAS square gains nothing from a
               second upload. Same shape test the server already runs on the crop itself
               (Upload::avatarFitSquare's `dist`), just a looser bar: this is "worth a second
               file", not "needs padding". */
            var origFile = null;
            if (meta && meta.natW > 0 && meta.natH > 0) {
              var dist = Math.max(meta.natW, meta.natH) / Math.min(meta.natW, meta.natH);
              if (dist > 1.05) { origFile = file; }
            }
            /* AND WHERE IN THAT SOURCE THE SQUARE CAME FROM (db/0177). Only meaningful when the
               original is actually going up beside it -- with no second file the ring and the
               viewer paint the same picture and there is nothing to place.

               `meta.trimmed` IS NO LONGER A REASON TO WITHHOLD IT (2026-09-19). It used to be:
               trimLetterbox() re-encodes the source before the modal shows it, so the rect
               described a picture the server never receives, and sending it would have been
               confidently wrong on every frame of the flight. But the cropper now composes the
               trim back out (see readRect), so meta.rect is in the uploaded original's
               coordinates whether or not anything was trimmed -- and withholding was never cheap:
               a phone SCREENSHOT has black status/nav bars, trims on nearly every signup, and
               accounted for 17 of the 18 members who arrived with no rect over 09-17/18. It is
               left on `meta` because it is still true and still worth knowing; it just no longer
               gates anything. The server verifies whatever arrives either way, and now LOGS the
               case where nothing does (Upload::avatarCropAccept). */
            var cropRect = null;
            if (origFile && meta && meta.rect && meta.rect.length === 4) {
              cropRect = meta.rect.join(',');
            }
            if (!origFile) { bgUpload(f, 'avatar', avStatus, avatarFile, null, null); return; }
            avShrinkOrig(origFile, function (o) { bgUpload(f, 'avatar', avStatus, avatarFile, o, cropRect); });
          },
          onCancel: function () { avatarFile.value = ''; if (cur) cur.innerHTML = orig; }
        });
      }
    });
  }

  /* ---- profile banner: pick it, frame it, and RE-frame it later -----------------------
     The banner is stored as the ORIGINAL photo plus a normalized rect (users.cover_crop,
     migration 0131), never as a baked crop. Three things follow from that, and all three
     were the bug: "Reposition" needs no re-upload, the web and the app draw the identical
     frame from the identical numbers, and the Ken Burns zoom gets a budget it can spend
     without eating into what the member framed.

     NOTHING HERE REFUSES A PHOTO FOR ITS SHAPE OR ITS SIZE. A wide banner, a square snap
     and a portrait all frame fine, and a file too big for the wire is downscaled here (the
     whole picture, never cropped -- the rect is normalized, so a uniform scale cannot
     invalidate it) before the server downscales again to its own ceiling. The old flow's
     only answer to a big file was to refuse it. */
  var coverFile = document.getElementById('cover-file');
  var coverPrev = document.getElementById('cover-preview');
  if (coverFile || coverPrev) {
    var coverErr = document.getElementById('cover-error');
    var coverStatus = document.getElementById('cover-status');
    var coverRepos = document.getElementById('cover-reposition');
    var COVER_AR = 3.2;
    var COVER_TITLE = 'Drag to reposition · pinch or scroll to zoom · everything inside the frame stays visible';

    function coverErrSet(msg) {
      if (!coverErr) return;
      coverErr.hidden = !msg; coverErr.textContent = msg || '';
    }
    function coverSay(msg, bad) {
      if (!coverStatus) return;
      coverStatus.hidden = false;
      coverStatus.className = bad ? 'hint err-text' : 'hint';
      coverStatus.textContent = msg;
    }
    /* Paint the preview from the three values the SERVER computed. The server is the one
       place that turns a rect into a background, so the preview cannot drift from the
       profile page -- that equivalence is the whole point of the control. */
    function coverPaint(frame) {
      if (!coverPrev || !frame) return;
      coverPrev.style.backgroundSize = frame.size;
      coverPrev.style.backgroundPosition = frame.posX + ' ' + frame.posY;
      coverPrev.style.backgroundRepeat = 'no-repeat';
      coverPrev.style.setProperty('--pf-kb', frame.kb);
      coverPrev.style.setProperty('--pf-kbt', frame.kbt + '%');
    }
    /* Optimistic twin of cover_frame() in lib/view.php, used ONLY to make the preview move
       under the member's finger; every response overwrites it with the server's answer, so
       the server stays authoritative and a drift here can never persist. */
    function coverFrameLocal(r) {
      var x = r[0], y = r[1], w = r[2], h = r[3];
      var f = Math.max(1, Math.min(1.19,
        1 + 2 * Math.min(x, 1 - x - w) / w,
        1 + 2 * Math.min(y, 1 - y - h) / h));
      var w2 = Math.min(1, w * f), h2 = Math.min(1, h * f);
      var x2 = Math.max(0, Math.min(1 - w2, x - (w2 - w) / 2));
      var y2 = Math.max(0, Math.min(1 - h2, y - (h2 - h) / 2));
      return {
        size: (100 / w2).toFixed(4) + '% ' + (100 / h2).toFixed(4) + '%',
        posX: w2 >= 0.999999 ? '50%' : (x2 / (1 - w2) * 100).toFixed(4) + '%',
        posY: h2 >= 0.999999 ? '50%' : (y2 / (1 - h2) * 100).toFixed(4) + '%',
        kb: f.toFixed(4), kbt: Math.min(1.6, 30 * (1 - 1 / f)).toFixed(4)
      };
    }
    /* Big files are welcomed and shrunk, not rejected. The WHOLE picture is kept (this is a
       resize, not a crop) so the normalized rect stays exactly as valid as it was. */
    function coverShrink(file, cb) {
      var CAP = 2560, BIG = 6 * 1024 * 1024;
      var im = new Image();
      im.onload = function () {
        var nw = im.naturalWidth, nh = im.naturalHeight;
        var k = Math.min(1, CAP / Math.max(nw || 1, nh || 1));
        if (k >= 1 && file.size <= BIG) { cb(file); return; }
        try {
          var c = document.createElement('canvas');
          c.width = Math.max(1, Math.round(nw * k)); c.height = Math.max(1, Math.round(nh * k));
          c.getContext('2d').drawImage(im, 0, 0, c.width, c.height);
          c.toBlob(function (b) {
            cb(b ? new File([b], 'cover.jpg', { type: 'image/jpeg' }) : file);
          }, 'image/jpeg', 0.9);
        } catch (e) { cb(file); }
      };
      im.onerror = function () { cb(file); };
      im.src = URL.createObjectURL(file);
    }
    function coverPost(url, body, done) {
      fetch(url, {
        method: 'POST',
        headers: { 'X-CSRF-Token': csrf, 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
        body: body, credentials: 'same-origin'
      }).then(function (r) { return r.text().then(function (t) { return { s: r.status, t: t }; }); })
        .then(function (res) {
          var j = null; try { j = JSON.parse(res.t); } catch (e) {}
          // 403 on these routes has exactly one cause, the email verify wall.
          if (res.s === 403) { done(null, 'Confirm your email first, then add your cover photo.'); return; }
          if (!j || !j.ok) { done(null, (j && j.error) || 'That did not go through. Please try again.'); return; }
          done(j, null);
        })
        .catch(function () { done(null, 'That did not go through. Please try again.'); });
    }

    if (coverFile) {
      coverFile.addEventListener('change', function () {
        coverErrSet('');
        var file = coverFile.files[0];
        if (!file) return;
        if (file.type.indexOf('image') !== 0) {
          coverErrSet('Please choose an image file.'); coverFile.value = ''; return;
        }
        if (file.size > UP_IMG_MAX) {
          coverErrSet('That photo is ' + fmtSize(file.size) + ', max ' + Math.floor(UP_IMG_MAX / 1048576) + ' MB. Please pick a smaller one.');
          coverFile.value = ''; return;
        }
        openCropper(file, {
          aspect: COVER_AR, rect: true, title: COVER_TITLE,
          onDone: function (rect) {
            if (coverPrev) {
              coverPrev.style.backgroundImage = "url('" + URL.createObjectURL(file) + "')";
              coverPaint(coverFrameLocal(rect));
            }
            coverSay('⏳ Uploading ' + fmtSize(file.size) + '…');
            coverShrink(file, function (send) {
              var fd = new FormData();
              fd.append('file', send);
              fd.append('crop', rect.join(','));
              fd.append('_csrf', csrf);
              coverPost('/settings/media?type=cover&ajax=1', fd, function (j, err) {
                if (err) { coverSay(err, true); return; }
                coverFile.value = '';                       // saved; don't re-upload on Save
                if (coverPrev && j.path) { coverPrev.style.backgroundImage = "url('" + j.path + "')"; }
                if (coverPrev) { coverPrev.setAttribute('data-src', j.path || ''); coverPrev.setAttribute('data-crop', j.crop || ''); }
                coverPaint(j.frame);
                if (coverRepos) { coverRepos.hidden = false; }
                coverSay('Cover saved.');
              });
            });
          },
          onCancel: function () { coverFile.value = ''; }
        });
      });
    }

    /* REPOSITION: re-frame the photo already on file. No picker, no upload, no re-encode --
       the member's original is never touched, which is exactly what makes this possible. */
    if (coverRepos) {
      coverRepos.addEventListener('click', function () {
        coverErrSet('');
        var src = coverPrev ? coverPrev.getAttribute('data-src') : '';
        if (!src) { return; }
        var cur = (coverPrev.getAttribute('data-crop') || '').split(',').map(Number);
        openCropper(null, {
          aspect: COVER_AR, rect: true, title: COVER_TITLE, src: src,
          initial: cur.length === 4 && cur[2] > 0 ? cur : null,
          onDone: function (rect) {
            coverPaint(coverFrameLocal(rect));
            coverSay('Saving…');
            var fd = new FormData();
            fd.append('crop', rect.join(','));
            fd.append('_csrf', csrf);
            coverPost('/settings/cover-crop', fd, function (j, err) {
              if (err) { coverSay(err, true); return; }
              if (coverPrev) { coverPrev.setAttribute('data-crop', j.crop || ''); }
              coverPaint(j.frame);
              coverSay('Cover repositioned.');
            });
          }
        });
      });
    }
  }

  /* ---- Share this group / this channel (db/0149) -------------------------
     ONE delegated listener for .grtop-share and .chtop-share, because the two buttons
     are the same button in two headers and a second copy would drift.

     NATIVE SHEET FIRST, CLIPBOARD SECOND. navigator.share is what a phone user means by
     "share" -- it reaches the apps the link is actually going to -- and it is absent on
     desktop, where copying is what they mean. The clipboard path is also the fallback for
     a share the user CANCELS, which rejects with AbortError: cancelling must leave the
     button alone, not silently copy, so that one rejection is swallowed rather than
     treated as a failure.

     THE CONFIRMATION IS A CLASS, NEVER textContent. Both labels ship stacked in one grid
     cell (.copy-swap in rova.css), so the swap costs zero layout; writing textContent
     would collapse the pair and let "Copied" widen the button mid-tap -- the reflow the
     referral pill and the two invite rows were all fixed for on 2026-08-15.

     WHAT IS NOT HERE: any decision about WHETHER this may be shared. A hidden group's page
     never renders the button at all (Groups::canShareGroup, views/group.php), because a
     privacy tier decided in JavaScript is not a privacy tier. */
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('.grtop-share, .chtop-share') : null;
    if (!b) return;
    e.preventDefault();
    var url = b.getAttribute('data-copy') || '';
    if (!url) return;
    var done = function () {
      b.classList.add('is-copied');
      setTimeout(function () { b.classList.remove('is-copied'); }, 1400);
    };
    var copyIt = function () {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done).catch(function () {});
      }
    };
    if (navigator.share) {
      navigator.share({ title: b.getAttribute('data-share-title') || '', url: url })
        .catch(function (err) {
          // A cancelled sheet is not a failure and must not fall through to a copy.
          if (err && err.name === 'AbortError') return;
          copyIt();
        });
      return;
    }
    copyIt();
  });

  /* ---- generic copy-to-clipboard buttons (e.g. admin promo codes) -------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('.js-copy-promo') : null;
    if (!b) return;
    var text = b.getAttribute('data-copy') || '';
    if (!text) return;
    function ok() { toast('Copied. Paste it anywhere to share.'); }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(ok).catch(function () { fallback(); });
    } else { fallback(); }
    function fallback() {
      var ta = document.createElement('textarea');
      ta.value = text; ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); ok(); } catch (err) {}
      ta.remove();
    }
  });

  /* ---- feed settings panel (gear next to Live) --------------------------- */
  (function () {
    var gear = document.getElementById('feed-gear');
    var panel = document.getElementById('feed-settings');
    if (!gear || !panel) return;
    function openState(on) { panel.hidden = !on; gear.classList.toggle('on', on); }
    gear.addEventListener('click', function (e) { e.stopPropagation(); openState(panel.hidden); });
    panel.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.js-fs-close')) openState(false);
    });
    document.addEventListener('click', function (e) {
      if (!panel.hidden && !panel.contains(e.target) && !gear.contains(e.target)) openState(false);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') openState(false); });

    // speed segment: shares rova_feed_speed with Settings -> Timeline, applies live
    var seg = document.getElementById('feed-speed-seg');
    if (seg) {
      var cur = 'normal';
      try { cur = localStorage.getItem('rova_feed_speed') || 'normal'; } catch (e) {}
      var opts = seg.querySelectorAll('.speed-opt');
      var paint = function () {
        Array.prototype.forEach.call(opts, function (b) { b.classList.toggle('on', b.getAttribute('data-speed') === cur); });
      };
      paint();
      seg.addEventListener('click', function (e) {
        var b = e.target.closest ? e.target.closest('.speed-opt') : null;
        if (!b) return;
        cur = b.getAttribute('data-speed');
        try { localStorage.setItem('rova_feed_speed', cur); } catch (e) {}
        paint();
        document.dispatchEvent(new CustomEvent('rova:speed', { detail: cur }));
      });
    }
    // slideshow speed: how fast a photo post's "play" advances the slides (device-local ms)
    var ssSeg = document.getElementById('feed-ss-seg');
    if (ssSeg) {
      var ssCur = '3500';
      try { ssCur = localStorage.getItem('rova_ss_ms') || '3500'; } catch (e) {}
      var ssOpts = ssSeg.querySelectorAll('.speed-opt');
      var ssPaint = function () { Array.prototype.forEach.call(ssOpts, function (b) { b.classList.toggle('on', b.getAttribute('data-ss') === ssCur); }); };
      ssPaint();
      ssSeg.addEventListener('click', function (e) {
        var b = e.target.closest ? e.target.closest('.speed-opt') : null;
        if (!b) return;
        ssCur = b.getAttribute('data-ss');
        try { localStorage.setItem('rova_ss_ms', ssCur); } catch (e) {}
        ssPaint();
        // apply live to any slideshow already running
        document.querySelectorAll('.carousel.carousel-playing').forEach(function (c) { if (c.__cstop && c.__cplay) { c.__cstop(); c.__cplay(); } });
      });
    }
    // toggles
    [['fs-autoplay', 'autoplay'], ['fs-soundfollow', 'soundfollow'], ['fs-autohide', 'autohide']].forEach(function (pair) {
      var el = document.getElementById(pair[0]);
      if (!el) return;
      el.checked = feedPref(pair[1], true);
      el.addEventListener('change', function () { setFeedPref(pair[1], el.checked); });
    });

    /* RE-ORDER THE TAB STRIP to match the new default, and slide the tabs there.
       The member's default tab is rendered FIRST (views/feed.php), so changing it changes
       the order of the row -- which used to happen only on the next page load, while the
       CONTENT swapped instantly. This closes that gap.
       The order written here is exactly what the server would render: the chosen tab, then
       the canonical order (data-ord, from $feedCanon) minus that tab. Anything else and a
       refresh would be a second visible reshuffle.
       FLIP, not a re-layout: read every tab's box, move the DOM, read again, put each tab
       back where it was DRAWN with a translateX, then transition that to zero. Transform
       only, so this never lands on the layout path -- the row lives in the sticky feed
       chrome of a scroll-perf-tuned page. */
    function reorderFeedTabs(tabKey) {
      var row = document.getElementById('feed-tabs');
      if (!row || !tabKey) return;
      var tabs = Array.prototype.filter.call(row.children, function (el) {
        return el.classList && el.classList.contains('tab');
      });
      if (tabs.length < 2) return;
      var want = tabs.slice().sort(function (a, b) {
        // chosen tab to the front, everything else in canonical order
        var ax = a.getAttribute('data-tab') === tabKey ? 0 : 1;
        var bx = b.getAttribute('data-tab') === tabKey ? 0 : 1;
        if (ax !== bx) return ax - bx;
        return (parseInt(a.getAttribute('data-ord'), 10) || 0) - (parseInt(b.getAttribute('data-ord'), 10) || 0);
      });
      var i, moved = false;
      for (i = 0; i < tabs.length; i++) { if (want[i] !== tabs[i]) { moved = true; break; } }
      if (!moved) return;                    // already in that order (an older build, or a re-pick)
      var calm = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

      // FIRST -- where each tab is drawn right now
      var from = [];
      for (i = 0; i < tabs.length; i++) { from[i] = tabs[i].getBoundingClientRect().left; }

      // MOVE -- in front of whatever follows the last tab (.feed-tools, then the settings
      // panel and the gold bar). The tabs are the row's leading flex children and stay so.
      var ref = tabs[tabs.length - 1].nextSibling;
      for (i = 0; i < want.length; i++) { row.insertBefore(want[i], ref); }
      if (row._rovaPager) row._rovaPager.resync();     // the swipe pager's neighbours moved

      /* The gold bar, BEFORE any transform exists: reorder() re-reads the row and parks the
         bar on the settled geometry, then holds off its own placement paths until the flight
         is over. One function computes this bar, and it is that one. */
      if (row._rovaSlider) row._rovaSlider.reorder(!calm);
      if (calm) { if (row._rovaSlider) row._rovaSlider.reorderEnd(); return; }   // reduced motion: land, don't fly

      // LAST + INVERT
      var dx = [], any = false;
      for (i = 0; i < tabs.length; i++) {
        dx[i] = from[i] - tabs[i].getBoundingClientRect().left;
        if (Math.abs(dx[i]) > 0.5) any = true;
      }
      if (!any || !tabs[0].animate) {   // nothing to fly (or no WAAPI): the order is already right
        if (row._rovaSlider) row._rovaSlider.reorderEnd();
        return;
      }
      /* PLAY -- Web Animations, NOT an inline transition.
         Setting the invert and then clearing it a frame later never animated: both writes
         land in the same style recalc, the browser sees one no-op change and no transition
         is ever started (the tabs snapped, and only a profiler's forced reflows made it
         LOOK like a glide). A keyframe animation cannot be coalesced away, it never touches
         inline style, and it finishes deterministically -- which is what tells the gold bar
         when the row is real again.
         .17s on the same curve as the bar and as the phone icon->word morph, so on a phone
         the two motions the row is making (the order change, carried here; the label
         growing, carried by CSS) land together. */
      var anims = [];
      for (i = 0; i < tabs.length; i++) {
        if (Math.abs(dx[i]) < 0.5) continue;
        try {
          anims.push(tabs[i].animate(
            [{ transform: 'translateX(' + dx[i] + 'px)' }, { transform: 'translateX(0px)' }],
            { duration: 170, easing: 'cubic-bezier(.2,.7,.2,1)', fill: 'none' }
          ));
        } catch (err) {}
      }
      // Hand the row back exactly once, with the effects CANCELLED first: cancel() drops the
      // transform out of the element's style there and then, so the bar's re-measure reads
      // layout pixels and not a frame of the flight.
      var handedBack = false;
      var handBack = function () {
        if (handedBack) return;
        handedBack = true;
        for (var a = 0; a < anims.length; a++) { try { anims[a].cancel(); } catch (err) {} }
        if (row._rovaSlider) row._rovaSlider.reorderEnd();
      };
      if (!anims.length) { handBack(); return; }
      var left = anims.length;
      for (i = 0; i < anims.length; i++) {
        anims[i].onfinish = anims[i].oncancel = function () { if (--left <= 0) handBack(); };
      }
      setTimeout(handBack, 420);   // safety net: a dropped finish event must not strand the bar
    }

    // Default feed tab: which tab a bare /feed opens on. MEMBERS: saved to the account (AJAX),
    // applied live, and the strip is re-ordered to where a reload would put it. GUESTS
    // (data-guest="1", views/feed.php): the picker is the guest-usable subset
    // (trending/discover/grid), saved on this device -- there is no account to save to and the
    // guest page is edge-cached, so the server renders no 'on' state and this paints it from
    // localStorage instead. No strip re-order for guests either: the edge-cached row is always
    // in canonical order, so hoisting it here would snap back on the next load.
    var defSeg = document.getElementById('fs-deftab');
    if (defSeg) {
      var defGuest = defSeg.getAttribute('data-guest') === '1';
      var DEF_KEY = 'rova_guest_deftab';
      var defStored = function () {
        var t = null;
        try { t = localStorage.getItem(DEF_KEY); } catch (e) {}
        return (t && defSeg.querySelector('.speed-opt[data-tab="' + t + '"]')) ? t : 'trending';
      };
      if (defGuest) {
        var gCur = defStored();
        Array.prototype.forEach.call(defSeg.querySelectorAll('.speed-opt'), function (o) {
          o.classList.toggle('on', o.getAttribute('data-tab') === gCur);
          o.setAttribute('aria-checked', o.getAttribute('data-tab') === gCur ? 'true' : 'false');   // WS-C 2026-10-22: radio list
        });
      }
      defSeg.addEventListener('click', function (e) {
        var b = e.target.closest ? e.target.closest('.speed-opt') : null;
        if (!b || b.classList.contains('on')) return;
        var tab = b.getAttribute('data-tab');
        Array.prototype.forEach.call(defSeg.querySelectorAll('.speed-opt'), function (o) {
          o.classList.toggle('on', o === b);
          o.setAttribute('aria-checked', o === b ? 'true' : 'false');   // WS-C 2026-10-22: radio list
        });
        if (defGuest) {
          try { localStorage.setItem(DEF_KEY, tab); } catch (err) {}         // persist on this device
        } else {
          postJson('/default-feed-tab', { tab: tab }).catch(function () {}); // persist to the account
        }
        // apply live: click the matching feed tab so the pager swaps content in place
        var link = document.querySelector('#feed-tabs .js-tab[href$="tab=' + tab + '"], #feed-tabs .js-tab[href$="/feed?tab=' + tab + '"]');
        if (link && !link.classList.contains('on')) { link.click(); }
        if (!defGuest) { try { reorderFeedTabs(tab); } catch (err) {} }   // additive: a throw here must not cost the swap or the toast
        toast('Default tab set to ' + ((((b.querySelector && b.querySelector('.fr-t')) || b).textContent) || tab));   // .fr-t: the radio row's label (WS-C 2026-10-22)
      });
      // GUESTS, BARE /feed ONLY: honour the device-local default. Members get theirs
      // server-rendered; a guest's server render is the shared edge-cached copy, so the
      // switch has to happen here. setTimeout(0): the tab pager's delegated listener is
      // registered by a later block of this same script -- by the time this fires it is
      // attached, so the click swaps content in place instead of hard-navigating. An
      // explicit ?tab= in the URL always wins (and is what this very click produces via
      // the pager's pushState, so a reload after it lands on the same tab natively).
      if (defGuest && location.pathname === '/feed' && !/[?&]tab=/.test(location.search)) {
        setTimeout(function () {
          var t = defStored();
          if (t === 'trending') return;   // the site default: already what rendered
          var link = document.querySelector('#feed-tabs .js-tab[data-tab="' + t + '"]');
          if (link && !link.classList.contains('on')) { link.click(); }
        }, 0);
      }
    }
  })();

  /* ---- Enter posts, Shift+Enter makes a new line (composer + comments) --- */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || e.shiftKey || e.isComposing) return;
    var ta = e.target;
    if (!ta || !ta.matches || !ta.matches('textarea')) return;
    var form = ta.closest('form');
    if (!form || !form.classList) return;
    if (!form.classList.contains('js-compose') && !form.classList.contains('js-comment')) return;
    e.preventDefault();
    if (ta.value.trim() === '') return;                       // nothing to post
    if (form.requestSubmit) form.requestSubmit(); else form.submit();
  });

  /* ---- collapsed feed bar: arm the under-bar fade only once scrolling ----
     At rest the first post sits crisp; after any real scroll the posts fade to
     transparent as they slide up beneath the Discover/Following/New bar. */
  /* ...and THE SUB-HEADER STICKS FROM HERE (2026-08-06 fix, owner: "the sub header
     fails to stick sometimes"). #feed-tabs used to be position:sticky ONLY under
     #feed-wrap.chrome-idle, i.e. only in watch mode -- and watch mode can only ever
     be ENTERED at the top of the page: armIdle()'s timer bails on `window.scrollY > 8`
     (and, unlike the inner pendingCollapse check, bails WITHOUT re-arming). So a
     reader who put a thumb on the screen inside the ~5.4s idle window never got a
     sticky sub-header again for the life of that page -- the tab row scrolled away
     and the first post card butted straight up under the topbar, which is exactly
     the screenshot. Nothing was mis-positioned; it was never sticky in the first
     place. Reproduced 3/3 in WebKit at 390px, 0/3 when parked at the top.
     `tabs-stuck` on #feed-wrap carries the sticky/opaque/full-bleed half of that
     CSS (rova.css, "tabs-stuck IS THE BUG FIX"); .chrome-idle keeps the watch-mode
     LAYOUT half (margin-top:0, the thicker bar, the desktop padding-top) so this
     class can never reflow the page mid-fling. Same element, same rAF-throttled
     read, same >12px threshold as `.scrolled` -- deliberately ONE scroll listener
     and ONE scrollY read, per the 2026-07-29 forced-layout note in the feed block. */
  /* ---- SHORT-LANDSCAPE TAB TUCK (2026-08-31) --------------------------------------------
     Owner: "rotating my phone to landscape in Safari hides the sub header tabs."

     The landscape block in rova.css ("@media (orientation:landscape) and (max-height:560px)")
     collapses #feed-tabs to max-height:0 to buy back vertical room on a ~390px-tall viewport.
     That intent is fine. What was wrong was the class it keyed off: `.chrome-idle`, which
     means "both chrome panels are collapsed" -- and both are force-collapsed on EVERY page
     load, and again by the short-landscape matchMedia listener in the feed block below. So on
     a landscape phone the strip was hidden from the first frame and stayed hidden for the life
     of the page. The one documented way out (pull down at the very top to re-expand the
     composer, which drops .chrome-idle) is invisible and undiscoverable, and rotating the
     device -- a deliberate act that re-lays out the whole page -- landed the reader straight
     back in it.

     So the hide now rides on its own class, `.tabs-tucked`, driven from HERE, by the plain
     hide-on-scroll-down / show-on-scroll-up idiom every mobile browser (Safari's own toolbar
     included) has trained readers on:
       - tuck   after TUCK_PX of continuous downward travel, below the FLOOR
       - untuck after TUCK_PX of continuous upward travel, or at the top of the page
       - untuck unconditionally on any orientation change (requirement: a rotation may never
         strand the reader in a state whose primary navigation is gone)
       - never tuck at all unless the short-landscape media query actually matches
     .chrome-idle is now purely the composer/search state it says it is, and cannot hide
     anything on its own -- so this cannot fight whatever collapses those panels (nothing
     sets .chrome-idle from a scroll handler any more; that was removed 2026-08-11).

     PERF: deliberately NO new scroll listener and NO second scrollY read. This IIFE already
     owns the one rAF-throttled read that drives .scrolled and .tabs-stuck; direction just
     falls out of it as a subtraction. See the 2026-07-29 forced-layout note in the feed
     block -- a second listener reading scrollY again is exactly what that note forbids. */
  (function () {
    var tabs = document.getElementById('feed-tabs');
    if (!tabs) return;
    var wrap = document.getElementById('feed-wrap');
    var ticking = false;
    // matchMedia, matching the sibling landscape hook in the feed block (and cheap to read:
    // .matches is a cached boolean, not a layout query, so it is safe inside the rAF sync).
    var shortLand = window.matchMedia('(orientation:landscape) and (max-height:560px)');
    var portraitMq = window.matchMedia('(orientation:portrait)');
    var TUCK_PX = 24;   // continuous travel needed to flip state -- past thumb jitter, under one flick
    var FLOOR = 48;     // never tuck this close to the top: at rest the strip is simply present
    var lastY = window.scrollY, travel = 0, tucked = false;
    function setTucked(on) {
      if (on === tucked) return;
      tucked = on;
      if (wrap) wrap.classList.toggle('tabs-tucked', on);
    }
    function sync() {
      ticking = false;
      var y = window.scrollY;                       // THE one read
      var on = y > 12;
      tabs.classList.toggle('scrolled', on);
      if (wrap) wrap.classList.toggle('tabs-stuck', on);
      var d = y - lastY;
      lastY = y;
      // Not a short landscape viewport: this whole feature is inert, and the class must not
      // be left behind on the wrap when a rotation or a window resize takes us out of range.
      if (!shortLand.matches || y <= FLOOR) { travel = 0; setTucked(false); return; }
      if (d > 0 && travel < 0) travel = 0;          // direction flipped: start the run over
      else if (d < 0 && travel > 0) travel = 0;
      travel += d;
      if (travel >= TUCK_PX) setTucked(true);
      else if (travel <= -TUCK_PX) setTucked(false);
    }
    // Baseline the run and show the strip. sync() right after re-reads scrollY once so
    // .scrolled/.tabs-stuck stay correct too; with lastY just set, its delta is 0, so it can
    // never re-tuck on the way through.
    function reset() {
      lastY = window.scrollY;
      travel = 0;
      setTucked(false);
      sync();
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(sync); }
    }, { passive: true });
    // ROTATION RESETS THE CHROME. Listening on the PORTRAIT query, not on `resize` or the
    // legacy `orientationchange`: it fires exactly once per rotation, in BOTH directions, and
    // it is the same primitive the rest of this file already leans on. A rotation re-lays out
    // the page under the reader, so whatever travel run was in flight is meaningless -- drop
    // it and show the strip, unconditionally, whatever .chrome-idle happens to be doing.
    function onRotate() {
      reset();
      // ...and again once the rotation's own relayout has settled. A rotation can move the
      // scroll position without the reader touching anything (the document reflows to a new
      // width), and on iOS the turn is animated -- so re-baseline lastY after the dust, or the
      // first real scroll afterwards measures its delta against a pre-rotation Y and can tuck
      // the strip away instantly. Untucking is always the safe direction, so a redundant
      // reset here costs nothing.
      if (typeof requestAnimationFrame === 'function') requestAnimationFrame(reset);
      setTimeout(reset, 350);
    }
    if (portraitMq.addEventListener) portraitMq.addEventListener('change', onRotate);
    else if (portraitMq.addListener) portraitMq.addListener(onRotate);

    /* ---- THE DOCK, NOT THE TWELFTH PIXEL (2026-09-01) --------------------------------------
       Owner: "the black shouldn't show when it's sitting there since it looks better on
       transparent, and when the user scrolls the posts should have some type of shadow
       underneath the subheader so the posts don't overlap it."

       THE COSMETIC STATE WAS BOUND TO THE WRONG EVENT. `.scrolled` / `.tabs-stuck` above land
       at y > 12. The bar does not actually reach its `top` and DOCK under the header until
       scrollY 150 at 1440x900 and 204 at 390x844 -- measured on the live feed, both. So a 12px
       nudge dressed the bar in its full opaque fill, hairline and scrim while it was still
       sitting in normal flow in the middle of the page with NOTHING passing under it to hide,
       and it wore that slab for the next 138-191px. That is the black he is describing.

       So arming and cosmetics are separated. The 12px threshold above KEEPS its job -- it arms
       position:sticky and it is the 2026-08-06 "the sub header fails to stick SOMETIMES" fix,
       do not move it -- and `tabs-docked` below carries the paint. rova.css requires BOTH
       classes ("THE BAR IS DRESSED AT THE DOCK").

       WHY AN OBSERVER AND NOT A SECOND THRESHOLD. 150 and 204 are not constants; they are the
       bar's flow position, which moves with the header height, the guest banner, the composer
       and search panels, watch mode's margin collapse and the viewport width. A number would be
       right today and wrong the next time any of those changed, silently. The observer is
       derived from the same dock line the CSS `top` declares (--topbar-h - 1px), so the two
       cannot drift apart.

       PERF: this adds NO scroll listener, NO scrollY read and NO layout read. IntersectionObserver
       is computed off the compositor's own frame data -- the sync() above stays the one and only
       per-frame reader, per the 2026-07-29 forced-layout note in the feed block.

       THE ROOT IS A BAND, NOT A THRESHOLD-1 RATIO, and this is not a stylistic choice. The
       obvious spelling of "is it stuck yet" is `threshold:[1]` with a negative top rootMargin,
       and it is BROKEN for this element: once .tabs-stuck lands the bar goes full-bleed to 100vw,
       which is WIDER than the root's client width whenever a classic scrollbar is present, so its
       intersectionRatio can never reach 1 again. Measured at 390px: ratio 1 at rest, 0.9615 the
       moment the bar went full-bleed, and then NOT ONE further callback for the rest of the page
       -- the state simply never fired. Clipping the root to [viewport top .. dock line] and asking
       threshold 0 "does the bar reach into this band" is immune to that: horizontal overflow
       cannot affect it, and the answer is exactly `bar top <= dock line`.

       LEAD: fire 40px BEFORE the line. The fill's cross-fade has to be finished by the time the
       bar is actually covering content, or a post's text bleeds through it for a fifth of a
       second; those 40px are spent while the bar is still in flow with only page background
       behind it, so the fade is invisible and complete on arrival. */
    var DOCK_LEAD = 40;
    var dockIO = null, ringIO = null;
    /* THE BAND IS CHECKED AGAINST THE ROOT THE OBSERVER REALLY USES (2026-09-25). Rob, iPhone Safari
       (iOS 26/27), screenshot after dismissing the keyboard over an open comment sheet: the sub-header
       stuck under the header but with NO FILL -- .tabs-stuck without .tabs-docked -- so the sheet's
       comment row and background showed straight through Trending / Following / Discover. `below` was
       derived from window.innerHeight, but the observer's band is cut from ITS root (the viewport the
       engine intersects against). Whenever those two disagree -- iOS's keyboard and floating toolbars
       change one without the other, and a rebuild can land mid-transition -- the band's bottom edge sits
       above the bar and "docked" can never become true again until the next rebuild. Reproduced in the
       rig by skewing innerHeight: bar stuck, transparent, sheet painted through it. Now every callback
       reads entry.rootBounds (the band the engine actually used) and, if its bottom is not the dock line,
       rebuilds ONCE with `below` measured from that root; and the visual viewport's resize (the keyboard
       on iOS, which fires no window resize there) also triggers a rebuild. */
    var dockRootH = 0;
    function dockSync() {
      if (!wrap) return;
      if (!window.IntersectionObserver) { wrap.classList.add('tabs-docked'); return; }
      if (dockIO) { dockIO.disconnect(); dockIO = null; }
      if (ringIO) { ringIO.disconnect(); ringIO = null; }
      var th = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--topbar-h')) || 65;
      var line = Math.max(0, Math.round(th - 1 + DOCK_LEAD));
      var rootH = dockRootH || (window.innerHeight || 0);
      dockRootH = 0;
      var below = rootH - line;
      // a viewport shorter than the header cannot express the band; fall back to the old
      // behaviour (dressed whenever armed) rather than to no chrome at all
      if (below <= 0) { wrap.classList.add('tabs-docked'); return; }
      var tabsIn = false, ringGone = true, rechecked = false;
      function apply() { wrap.classList.toggle('tabs-docked', tabsIn && ringGone); }
      dockIO = new IntersectionObserver(function (es) {
        var en = es[es.length - 1];
        var rb = en.rootBounds;
        if (rb && !rechecked && Math.abs(rb.bottom - line) > 2) {
          rechecked = true;
          var realH = Math.round(rb.bottom + below);                     // the root's own height
          if (realH > line && Math.abs(realH - rootH) > 2) { dockRootH = realH; setTimeout(dockSync, 0); return; }
        }
        tabsIn = en.isIntersecting;
        apply();
      }, { rootMargin: '0px 0px -' + below + 'px 0px', threshold: 0 });
      dockIO.observe(tabs);
      // THE MEDIA RING sits right above #feed-tabs with only a few px of margin, so the lead
      // band above fired the fill purely off #feed-tabs's own geometry -- it never asked
      // whether the ring was still on screen (owner, 2026-09-19: "turns colors too early...
      // not when the media ring is still in view"). A second observer, clipped to start at
      // the header's bottom edge, answers "is any part of the ring still visible below the
      // header"; docking now waits for that to go false too. No ring, or an empty/hidden
      // one (MediaRing::circles() fails open to [] -> the partial renders [hidden]), never
      // blocks -- ringGone starts true and nothing here flips it.
      var ring = document.getElementById('media-ring');
      if (ring && !ring.hidden) {
        ringGone = false;
        ringIO = new IntersectionObserver(function (es) {
          ringGone = !es[es.length - 1].isIntersecting;
          apply();
        }, { rootMargin: '-' + Math.round(th) + 'px 0px 0px 0px', threshold: 0 });
        ringIO.observe(ring);
      }
      apply();
    }
    dockSync();
    // the band is measured from --topbar-h and the viewport, so rebuild when either moves.
    // Debounced: a rebuild is one observer construction, not a per-frame cost, and `resize`
    // fires in bursts. The header can also change height with the window standing still (a
    // late font, a control row wrapping) -- __rovaSetTopbarH's own ResizeObserver republishes
    // --topbar-h for that case, so watch the same element and re-read it after.
    var dockT;
    function dockRebuild() { clearTimeout(dockT); dockT = setTimeout(dockSync, 150); }
    window.addEventListener('resize', dockRebuild);
    try { if (window.visualViewport) { window.visualViewport.addEventListener('resize', dockRebuild); } } catch (e) {}
    if (portraitMq.addEventListener) portraitMq.addEventListener('change', dockRebuild);
    // 2026-09-05: dismissing the "get the app" bar moves the dock line up 56px without a
    // resize and without the header changing height (--topbar-h is the stack bottom now,
    // see __rovaSetTopbarH); the bar's dismiss handler fires this so the band follows.
    window.addEventListener('rova:appbar', dockRebuild);
    var dockBar = document.querySelector('.topbar');
    if (dockBar && typeof ResizeObserver === 'function') {
      try { new ResizeObserver(dockRebuild).observe(dockBar, { box: 'border-box' }); } catch (e) {}
    }

    sync();
  })();

  /* ---- DM reactions: double-tap a received message to heart it, hold for more */
  var DM_EMO = { heart: '❤️', fire: '🔥', haha: '😂', wow: '😮', clap: '👏', sad: '😢' };
  /* iMESSAGE TAPBACKS (Rob 2026-10-15: "this is how ours should look also exactly ... hated that
     gold ring"). ONE grey circle PER PERSON, never a "❤️2" count: a DM is 1:1 and
     message_reactions is UNIQUE(message_id,user_id), so there are at most two, and two people
     picking the same heart is two hearts stacked, exactly as iMessage draws it. The circles sit
     on the bubble's BOTTOM INNER corner (rova.css "DM TAPBACKS"); .rx-on on the .msg reserves the
     room below the bubble they hang into. */
  function dmRxPill(rx) {
    if (!rx) return '';
    var html = '', n = 0, mineDone = false;
    for (var k in DM_EMO) {
      for (var c = Math.min(2, +rx[k] || 0); c > 0 && n < 2; c--, n++) {
        var mine = !mineDone && rx.mine === k; if (mine) mineDone = true;
        html += '<span class="rxt' + (mine ? ' mine' : '') + '">' + DM_EMO[k] + '</span>';
      }
    }
    if (!html) return '';
    return '<span class="msg-rx' + (rx.mine ? ' mine' : '') + '" role="img" aria-label="Reactions">' + html + '</span>';
  }
  function dmPaintRx(msg, rx) {
    // .rx-on adds 24px BELOW the bubble (the tapback hangs off its bottom inner corner), so a reaction
    // landing on the LAST message would push its own circle below the fold: re-pin a reader who was
    // already at the bottom, exactly as the open/poll paths pin with scrollTop = scrollHeight.
    var sc = msg.closest ? msg.closest('#hdrop-thread, .dm-thread') : null;
    var pinned = !!sc && (sc.scrollHeight - sc.scrollTop - sc.clientHeight < 70);
    var old = msg.querySelector('.msg-rx'); if (old) old.remove();
    var html = dmRxPill(rx);
    msg.classList.toggle('rx-on', !!html);
    // Append to .msg, NOT to .bubble. A message only HAS a .bubble when it has text: bubbleHTML()
    // above emits one on `txt ? ...`, so a photo-only DM (and a link/embed-only one) is .msg-media /
    // .msg-link with no bubble, and requiring a bubble left those pills unpainted until a reload --
    // the reaction was saved, only the paint was missing.
    // The end is a safe insertion point because .msg-rx is position:absolute on .msg's bottom corner
    // (rova.css "DM TAPBACKS"), so where it sits in the DOM changes nothing. That is also why this
    // can differ from bubbleHTML(), which prints it before .msg-time: both render identically.
    if (html) msg.insertAdjacentHTML('beforeend', html);
    if (pinned) sc.scrollTop = sc.scrollHeight;
  }
  (function () {
    var pop = null;
    function target(t) {   // received DM bubbles only (text or GIF alike)
      var m = t && t.closest ? t.closest('.msg.them[data-mid]') : null;
      return (m && +m.getAttribute('data-mid') > 0) ? m : null;
    }
    function closePop() { if (pop) { pop.remove(); pop = null; } }
    function send(msg, reaction) {
      var fd = new FormData();
      fd.append('message_id', msg.getAttribute('data-mid'));
      fd.append('reaction', reaction);
      fetch('/dm-react', {
        method: 'POST', body: fd, credentials: 'same-origin',
        headers: { 'X-CSRF-Token': csrf, 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }
      }).then(function (r) { return r.json(); })
        .then(function (d) { if (d && d.ok) dmPaintRx(msg, d.rx); })
        .catch(function () {});
    }
    function picker(msg) {
      closePop();
      pop = document.createElement('div');
      pop.className = 'rxpick';
      Object.keys(DM_EMO).forEach(function (k) {
        var b = document.createElement('button');
        b.type = 'button'; b.textContent = DM_EMO[k];
        b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); send(msg, k); closePop(); });
        pop.appendChild(b);
      });
      msg.appendChild(pop);
    }
    // Unified tap counting (clicks fire for taps too, and reliably on GIF images):
    // 2 quick taps = heart, 3 = the full picker. No press-and-hold. Tapping
    // anywhere else dismisses the picker and resets the count.
    var tapN = 0, tapT = null, tapEl = null;
    document.addEventListener('click', function (e) {
      if (pop && !pop.contains(e.target)) closePop();
      var msg = target(e.target);
      if (!msg) { tapN = 0; tapEl = null; return; }
      if (tapEl !== msg) { tapN = 0; tapEl = msg; }
      tapN++;
      clearTimeout(tapT);
      if (tapN >= 2) {
        // FROM THE SECOND TAP ON, THIS GESTURE OWNS THE RECTANGLE. Take the pending DM-photo
        // lightbox open off it (see __rovaDmTapClaim), and cancel this click's own default
        // action. That second part is what stops a LINK-ONLY message opening its card twice:
        // .linkcard is an <a target="_blank"> (lib/view.php linkcard_html), so before this a
        // double tap reacted AND spawned two tabs -- measured, 1 popup per tap.
        // The link card's FIRST tap is deliberately left alone and still navigates instantly.
        // It cannot be deferred the way the photo is: re-issuing a target="_blank" open from a
        // setTimeout is no longer inside the user gesture and gets popup-blocked, which would
        // trade a double-open for a link that sometimes does nothing at all.
        if (window.__rovaDmTapClaim) { window.__rovaDmTapClaim(); }
        if (e.cancelable) { e.preventDefault(); }
      }
      if (tapN >= 3) { tapN = 0; picker(msg); return; }   // triple tap: the extra emojis
      if (tapN === 2) send(msg, 'heart');                 // double tap: heart
      tapT = setTimeout(function () { tapN = 0; tapEl = null; }, 380);
    });
    /* THE SECOND FINGER GOING DOWN IS THE EARLIEST HONEST SIGNAL that this is a double tap:
       measured on this build it lands ~140-230ms after the first finger lifted, while that
       tap's click arrives at 310-350ms. Claiming here rather than waiting for the click is
       what keeps the 20ms margin between the 380ms react window and the 400ms photo-open timer
       from ever having to hold under a busy main thread -- the same reason the pfeed's raw-touch
       handler retires `singleTimer` on touchstart instead of letting it fire and undoing it.
       Only claims when a first tap is already armed ON THIS MESSAGE, so an ordinary first touch
       (tapN === 0) and a touch on any other message both fall straight through. If the contact
       turns out to be a scroll rather than a tap, what we dropped is a photo open on a message
       the finger is already leaving. */
    document.addEventListener('touchstart', function (e) {
      if (!tapN || !tapEl) return;
      if (target(e.target) === tapEl && window.__rovaDmTapClaim) { window.__rovaDmTapClaim(); }
    }, { passive: true, capture: true });
    document.addEventListener('dblclick', function (e) {  // stop text selection on fast taps
      if (target(e.target)) e.preventDefault();
    });
  })();

  /* ---- DM delete: press-and-hold a message to delete it. Users SOFT-delete (it just vanishes for
     them); admins HARD-delete (gone for both). Long-press is free here -- the reaction picker uses
     tap-counting, not hold -- so it works on the full thread AND the header-flyout mini thread. ---- */
  (function () {
    var pop = null, timer = null, sx = 0, sy = 0, held = false;
    function msgOf(t) {
      var m = t && t.closest ? t.closest('.msg[data-mid]') : null;
      return (m && m.closest('.dm-thread, #hdrop-thread') && +m.getAttribute('data-mid') > 0) ? m : null;
    }
    function close() { if (pop) { pop.remove(); pop = null; } }
    function cancel() { if (timer) { clearTimeout(timer); timer = null; } }
    function del(msg) {
      var fd = new FormData(); fd.append('id', msg.getAttribute('data-mid'));
      msg.classList.add('msg-removing');
      fetch('/dm-delete', { method: 'POST', body: fd, credentials: 'same-origin',
        headers: { 'X-CSRF-Token': csrf, 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (d && d.ok) { if (msg.parentNode) msg.parentNode.removeChild(msg); }
          else { msg.classList.remove('msg-removing'); toast('Could not delete'); }
        })
        .catch(function () { msg.classList.remove('msg-removing'); toast('Could not delete'); });
    }
    function menu(msg) {
      close();
      pop = document.createElement('div');
      pop.className = 'msg-delpop msg-actpop';
      /* WS-B (Rob item 9, "Dj Lexo can't copy/paste in DMs"): the hold / right-click menu now leads with COPY. The bubble is
         -webkit-touch-callout:none (holding a bubble must not open the iOS callout over this menu), so on a phone this button
         is the way to copy a message; on a desktop a drag-selection keeps the browser's own menu (see contextmenu below).
         TRANSLATE rides here too when the bubble offers it. */
      var bub = msg.querySelector('.bubble');
      var txt = bub ? String(bub.getAttribute('data-orig-text') || bub.innerText || bub.textContent || '').trim() : '';
      var addBtn = function (label, cls, fn) {
        var x = document.createElement('button');
        x.type = 'button'; x.className = cls; x.textContent = label;
        x.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); close(); fn(); });
        pop.appendChild(x);
      };
      if (txt && window.__rovaCopyText) addBtn('Copy', 'msg-actbtn', function () { window.__rovaCopyText(txt); });
      var trb = msg.querySelector('.msg-tr');
      if (trb) addBtn(trb.getAttribute('data-done') === '1' ? 'Show original' : 'Translate', 'msg-actbtn', function () { trb.click(); });
      addBtn(isAdmin ? 'Delete for everyone' : 'Delete', 'msg-delbtn', function () { del(msg); });
      msg.appendChild(pop);
    }
    document.addEventListener('pointerdown', function (e) {
      var msg = msgOf(e.target); if (!msg) return;
      sx = e.clientX; sy = e.clientY; held = false;
      cancel();
      timer = setTimeout(function () { timer = null; held = true; menu(msg); }, 500);
    }, { passive: true });
    document.addEventListener('pointermove', function (e) {
      if (timer && (Math.abs(e.clientX - sx) > 10 || Math.abs(e.clientY - sy) > 10)) cancel();  // a scroll, not a hold
    }, { passive: true });
    document.addEventListener('pointerup', cancel, { passive: true });
    document.addEventListener('pointercancel', cancel, { passive: true });
    // A click INSIDE the delete pop (the Delete button) must always work -- check that FIRST. Then
    // swallow the one click that fires when the finger lifts after a hold, so the reaction picker
    // (which counts taps) doesn't also register it. Any other outside click closes the menu.
    document.addEventListener('click', function (e) {
      if (pop && pop.contains(e.target)) return;
      if (held) { held = false; e.stopPropagation(); return; }
      if (pop) close();
    }, true);
    document.addEventListener('contextmenu', function (e) {
      var m = msgOf(e.target); if (!m) return;
      // WS-B: text SELECTED inside this message -> the browser's own menu (Copy, Look up, ...); otherwise ours (Copy / Translate / Delete)
      try { var sel = window.getSelection && window.getSelection(); if (sel && !sel.isCollapsed && String(sel).trim() && m.contains(sel.anchorNode)) { cancel(); return; } } catch (_) {}
      e.preventDefault(); menu(m);
    });

    // header "⋯" menu: toggle the little conversation-options pop (and close it on an outside click)
    document.addEventListener('click', function (e) {
      var mb = e.target.closest ? e.target.closest('.dm-menu-btn') : null;
      var openPop = document.querySelector('.dm-menu-pop:not([hidden])');
      if (mb) {
        e.preventDefault();
        var pp = mb.parentNode.querySelector('.dm-menu-pop');
        if (pp) { pp.hidden = !pp.hidden; if (openPop && openPop !== pp) openPop.hidden = true; }
        return;
      }
      if (openPop && !e.target.closest('.dm-menu-pop')) openPop.hidden = true;
    });

    // "Delete conversation" from the thread header menu: users clear it for themselves, admins nuke
    // it for both. Delegated so it also serves any dynamically-rendered header.
    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('.dm-del-thread') : null;
      if (!btn) return;
      e.preventDefault();
      var oid = btn.getAttribute('data-with');
      var hard = isAdmin;
      if (!confirm(hard ? 'Permanently delete this conversation for BOTH people? This cannot be undone.'
                        : 'Delete this conversation? It will be removed from your inbox (the other person keeps their copy).')) return;
      if (busyIs(btn)) return;
      var fd = new FormData(); fd.append('with', oid);
      busyUntil(btn, fetch('/dm-delete-thread', { method: 'POST', body: fd, credentials: 'same-origin',
        headers: { 'X-CSRF-Token': csrf, 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (d) { if (d && d.ok) { window.location = '/messages'; } else { toast('Could not delete'); } })
        .catch(function () { toast('Could not delete'); }));
    });
  })();

  /* ---- Instagram-style feed video: preload ahead, autoplay muted in view --
     Videos in post cards buffer before they arrive (a viewport and a half out),
     start playing MUTED once mostly visible, pause the instant they leave, and
     loop. Applies to streamed-in posts and tab swaps too via MutationObserver. */
  (function () {
    if (!('IntersectionObserver' in window)) return;
    var SEL = '.post .media video';   // post videos only (not gallery / DMs / avatars)

    // ADAPTIVE LOOKAHEAD: how many posts of live media (decoded photos + buffered clips) to hold each side of
    // the current pfeed post. +/-2 is the MOBILE ceiling: iOS's concurrent video-decoder cap runs as low as ~4
    // on older iPhones (5 live posts can already mean 5 decoders + the grid handoff), and decoded portrait
    // photos are ~6-8MB each (a 7-slide carousel inside the window holds all 7). History: a 9-post live window
    // locked phones up. A desktop with real RAM affords +/-3 (deviceMemory>=8; iOS Safari never exposes
    // deviceMemory, so iPhones land on 2 automatically). Warm margins + the recycle KEEP both derive from this
    // -- they MUST stay equal or warm<->unload churn returns.
    var PF_LA = window.__rovaPfLA = (navigator.deviceMemory >= 8) ? 3 : 2;

    // SOUND FOLLOWS THE FEED: once the user unmutes any video, sound "hands off"
    // to whichever playing video is top-most as they scroll, exactly one heard
    // at a time. Muting the active one turns sound mode back off. The choice
    // is remembered (sndPref), so a new page, or the gallery, starts as left.
    var soundOn = sndPref(), applying = false, pfLatch = false;   // pfLatch: user turned sound ON in THIS pfeed session -> keep it on across every swipe until dismiss
    /* ---- SOUND NEEDS A GESTURE, AND A REFUSED UNMUTE IS NOT SILENT -- IT IS A STOP ------------------
       (owner 2026-08-08: a shared /p/<id> opened from iMessage "loads up janky ... and paused".)
       Every unmute path here assumed the worst case of getting it wrong was "no sound". On WebKit it is
       not. A clip playing under the MUTED-autoplay allowance has no user activation behind it, so the
       instant script sets muted = false the allowance no longer covers it and the element is PAUSED --
       no promise to catch, no error, just a stopped video sitting at 0:00. Chrome does the same. That is
       the whole mechanism of "it settles paused": applySound() runs off playIO's crossing, reads a saved
       rova_sound=1 from some earlier session on some earlier page, and unmutes a clip that a DIRECT LOAD
       never earned the right to unmute.
       So don't unmute until a finger has actually touched THIS document.
       AND THAT MEANS OUR OWN LISTENERS, NOT navigator.userActivation. The obvious implementation is to
       ask the engine -- it has a `hasBeenActive` flag for exactly this and it ships in Chrome 72+ and
       Safari 16.4+. It was written that way first and MEASURED, and the measurement killed it: a freshly
       loaded /p/15076 with no input of any kind reports `hasBeenActive: true, isActive: true` from the
       first frame. An embedder can hand a brand-new document a sticky activation it did not earn, which
       is precisely the shape of the surface being complained about -- a web view opened by a tap in
       ANOTHER app. Trusting that flag would unmute on the strength of the reader's tap on an iMessage
       link, and the unmute is what stops the clip. A flag that can be true without a gesture is not
       usable as "there was a gesture", so this asks a question we can answer ourselves and answer
       conservatively: did an input event reach this document, in the capture phase, where nothing can
       hide it from us? Being wrong in this direction costs a muted clip and a pill; being wrong in the
       other costs the whole video.
       It takes sound away from nobody: the reader who wants it gets the "Tap for sound" pill
       (updateSoundPill), and that ONE tap sets the flag below, so from there sndPref/pfLatch behave
       exactly as they always have. Registered at parse time on `document`, so the only gesture it can
       miss is one landing before this bundle has executed -- and that reader's next touch grants it. */
    var hadGesture = false;
    ['pointerdown', 'touchstart', 'mousedown', 'keydown', 'click'].forEach(function (ev) {
      document.addEventListener(ev, function () { hadGesture = true; }, true);
    });
    function userActivated() { return hadGesture; }
    window.__rovaUserActivated = userActivated;   // pfSound() lives in the viewer's own IIFE and asks the same question
    /* ---- A GESTURE HAVING HAPPENED IS NOT PERMISSION TO MAKE SOUND (owner 2026-08-15) -----------
       "opening /p/43603 cold in Safari, the sound indicator says sound is ON but no audio plays.
        Swiping down to other posts, I hear those. Swiping back up, this one has sound. Confusing lol."

       hadGesture answers "has an input event reached this document", and that is the RIGHT question
       for the one thing it was written for: never attempt an unmute on a document nobody has touched.
       It is the WRONG question for "may this clip be audible", and the two were being used
       interchangeably.

       WebKit grants unmuted playback to the element a gesture is CURRENTLY running: the unmute has to
       happen inside the synchronous body of the handler. applySound() is driven by playIO crossings,
       the viewer's per-rAF sound sync and scroll ticks -- none of those is a gesture, so every unmute
       it performs is refused. MEASURED on the owner's exact sequence (cold open, swipe down x2, swipe
       back up) with a gesture-context column on every write to `muted`: 17 changes, ALL of them
       outside a gesture, every one of them applySound's engineMute. The DOM property still reads
       false afterwards -- that is what a refusal looks like from script -- so .vc-sound repainted
       itself "sound on" over a clip WebKit had left silent, and updateSoundPill took the affordance
       away because `v.muted` said there was nothing to offer. The reader is being shown the app's
       INTENTION dressed as the engine's ANSWER.

       His whole sequence falls out of it. The chrome fades after 3.2s, so the tap that REVEALS the
       sound indicator is the tap that makes it lie: it sets hadGesture, the next sweep unmutes
       outside a gesture, WebKit refuses, the glyph flips. Swiping eventually lands a genuine
       in-gesture unmute somewhere, WebKit lifts the restriction for the page, and from there every
       clip -- including the one he swipes back up to -- really does have sound.

       (Chromium keeps sticky per-document activation and allows those same writes, which is why this
       only ever showed on iOS, and why a mouse-driven test can never see it.)

       So the engine's permission gets a name of its own, separate from the reader's intent.
       sndUnlocked is false until an unmute has been performed inside a gesture AND that element's
       play() resolved with sound on it. Until then applySound leaves every clip MUTED and
       updateSoundPill offers "Tap for sound" -- which is the truth, and is a control that works.
       NOTHING HERE TOUCHES THE INTENT LATCH: soundOn, pfLatch and rova_sound mean exactly what they
       meant and are read exactly where they were read. Intent says what the reader wants; this says
       what the browser will currently allow. Conflating those two is the entire bug. */
    var sndUnlocked = false;
    function soundGranted() {
      if (sndUnlocked) { return; }
      sndUnlocked = true;
      // the first-activation promoter has done its one job for the life of the page (see promoteSound)
      try { PROMOTE_EVT.forEach(function (ev) { document.removeEventListener(ev, promoteSound, true); }); } catch (e) {}
    }
    window.__rovaSoundGranted = soundGranted;      // the in-gesture sound controls live in other closures
    window.__rovaSoundUnlocked = function () { return sndUnlocked; };

    /* ---- SPEND THE TAP THAT OPENS (owner 2026-08-15, second pass) -------------------------------
       "if I tap on a media in the safari browser it should start with sound on, just like the web on
        mobile and in the native app."

       He is right, and the honest-muted landing above was one step too cautious for a TAP. The
       reason the old auto-unmute failed on WebKit was never that a tap had not happened -- it was
       that applySound performed the unmute from an IntersectionObserver crossing or a rAF, long
       after the gesture had ended. The opening tap can carry the activation itself.

       The viewer's own <video> does not exist at tap time (its card is still being fetched), so the
       unlock is taken on an element that DOES exist: the grid tile's clip, or the timeline clip the
       reader tapped. That is exactly the shape amArm uses for the music preview -- spend the gesture
       on the element you have, synchronously in the handler, before any async boundary, because
       WebKit's activation does not survive a timeout or an await. WebKit lifts the page's audio
       restriction once a media element has played under a gesture, and the proof that the lift is
       page-wide rather than element-wide is the product itself: sound has FOLLOWED the feed on iOS
       for months, and every one of those handoffs unmutes a freshly created element from a scroll
       tick with no gesture anywhere near it.

       IT ENDS THE ELEMENT EXACTLY AS IT FOUND IT. The unmute and the play() are what lift the two
       restrictions; holding them afterwards is not required, so the clip is handed straight back
       muted through the STAMPED engine path. That matters most on a grid tile: its file is the
       _grid480 rendition, built with -an, so there is no sound to leak either way -- but a future
       rendition WITH audio must not start talking out of a thumbnail, and this way it cannot.

       AND IT RESPECTS THE LATCH. A reader who muted stays muted: no stored intent, no arm. */
    function soundArm(v) {
      if (sndUnlocked || !v) { return; }
      if (!feedPref('soundfollow', true)) { return; }
      if (!(soundOn || pfLatch)) { return; }
      var was = v.muted;
      if (was) { v.muted = false; }                 // in-gesture: lifts the AUDIO restriction
      var p = null;
      try { p = v.play(); } catch (er) { p = null; }   // ...and the PLAYBACK one, on this element
      if (was) { engineMute(v, true); }             // grant taken; give the element back untouched
      armSettle(v, p);
    }
    window.__rovaSoundArm = soundArm;               // the grid tap handler lives in its own closure

    /* ---- AN ABORT IS NOT A REFUSAL (owner 2026-08-15, third pass) --------------------------------
       The grant is read off the play() PROMISE and that is right: an attempt is not an answer, and a
       refusal must never be recorded as permission. But there are two ways that promise can reject
       and only one of them is the engine saying no.

       MEASURED on the full-screen-button open, live bundle, real touch: the arm's play() is issued at
       +68ms and the SAME handler pauses that clip at +136ms as it hands it to the viewer (fsB's
       still-hero branch does exactly that, deliberately). The promise therefore rejects with
       AbortError -- "interrupted by a call to pause()" -- which is OUR OWN teardown, not a policy
       decision, and the grant was silently thrown away: sndUnlocked stayed false, so the viewer
       landed muted with a pill on a reader whose stored intent was sound-on. That is the regression
       this pass is fixing, in reverse.

       Both engines lift the restriction SYNCHRONOUSLY inside play() while a gesture is being
       processed; nothing that happens afterwards puts it back. A genuine refusal is NotAllowedError
       (or, on WebKit, no rejection at all and a silently paused element) -- never AbortError. So an
       abort counts, and the honesty net downstream is what makes betting on that safe: if the unmute
       it enables turns out to make no audio, verifySound re-mutes and puts the pill back. */
    function armSettle(v, p, done) {
      function grant() { soundGranted(); if (done) { try { done(); } catch (e) {} } }
      if (p && p.then) {
        p.then(grant, function (er) {
          var n = er && (er.name || '');
          if (n === 'AbortError' || (er && er.code === 20)) { grant(); }   // our own pause/load, not a veto
        });
        return;
      }
      if (!v.paused) { grant(); }                   // no promise (old engines): playing is the answer
    }

    /* ---- THE OPEN'S DESIGNATED VOICE (2026-08-17) ------------------------------------------------
       "The audio should begin at finger lift off after tapping a video."

       WHY THIS IS NOT `soundArm` WITH THE MUTE REMOVED. soundArm spends the tap on whatever
       element happens to exist and hands it straight back MUTED, on purpose: the thing it wants is
       the page-wide grant, and the element it borrows (a grid tile, playing the `-an` preview) has
       nothing to hear anyway. This one is the opposite errand. The boomerang lift builds the MASTER
       at lift-off -- the only element in the open that has an audio track at all -- and that element
       is also the element the viewer will still be playing when it settles, proven at the tap by the
       grid-donor adoption. So the voice can be handed over ONCE, here, and never again.

       AND THE HOLD MUST NOT TAKE IT BACK, which is the whole reason this registers rather than just
       unmuting. `soundHold` exists because an open touches several elements for the same file and
       "the first element allowed to speak is the one the viewer has SETTLED on" -- three of them
       overlapped inside half a second and the owner heard the CD skip. A designated voice does not
       weaken that rule, it SATISFIES it early: the settled element is already known, so applySound
       can hand the sound to that one and mute every other clip on the page in the same pass, which
       is exactly what the hold was arranging to do 700ms later. What is removed is the second beat,
       not the exclusion.
       ONE-SHOT AND SHORT-LIVED: cleared by soundRelease (i.e. by pfVoiceReady, or by the hold's own
       expiry), after which activeVideo() is the authority again as it always was. A voice whose
       element has left the document, or that is older than the longest open, is ignored -- never
       trusted into the steady state.
       IT RESPECTS THE LATCH, in the same statement and for the same reason soundArm does: a reader
       who muted stays muted, and then this returns false and the lift simply starts a silent
       master. Intent is never inferred from a tap. */
    var sndVoice = null;
    function soundVoiceArm(v) {
      if (!v) { return false; }
      if (!feedPref('soundfollow', true)) { return false; }
      if (!(soundOn || pfLatch)) { return false; }
      v.muted = false;                              // in-gesture: lifts the AUDIO restriction...
      var p = null;
      try { p = v.play(); } catch (er) { p = null; }   // ...and the PLAYBACK one, on this element
      armSettle(v, p);                              // an abort is our own teardown, not a veto
      sndVoice = { el: v, at: Date.now() };
      return true;
    }
    window.__rovaSoundVoiceArm = soundVoiceArm;     // the hero IIFE builds the lift-off master
    /* The live designated voice, or null. `isConnected` is deliberately NOT required: for the first
       ~400ms of an open the lift-off master is a body-level element that has not been adopted into
       the card yet, and during exactly that window applySound must already know not to give the
       sound to anything else. It is not in SEL either, so the sweep below cannot reach it. */
    function soundVoiceEl() {
      if (!sndVoice) { return null; }
      if (Date.now() - sndVoice.at > 20000) { sndVoice = null; return null; }
      return sndVoice.el || null;
    }

    /* ---- ONE VOICE PER OPEN, AND ONLY WHEN IT IS THE VOICE THAT STAYS (owner 2026-08-15, 3rd pass)
       "now videos when I tap them into full screen I hear the audio loop twice (like a CD skip) at
        the beginning of all videos when tapping them from the grid/feed/full screen button before it
        plays smoothly."

       Nothing here is a second sound policy. It is a HOLD on the one that exists, for the length of
       an open -- because sound-on-open (above) removed the thing that had been covering an old
       defect. Until this morning the viewer landed MUTED and collected a tap, so the several elements
       one open touches were all silent no matter how they overlapped. They overlap a lot. MEASURED on
       the live bundle with real touch, per-element webkitAudioDecodedByteCount + currentTime sampled
       at 60ms (snd-double-trace.js):

         - FEED / FULL-SCREEN BUTTON. promoteSound unmutes the CARD's clip on the touchend edge --
           correctly, it is the active clip, it has audio, and that is how a tap earns sound. Then the
           viewer renders its OWN <video> for the SAME post, unmutes it at 0, plays it, and seeks it to
           the card's position: measured card unmuted at +59ms @9.54, viewer copy unmuted at +363ms
           @0, played at +464ms, seeked to 9.917 at +502ms. Two elements, one file, ~0.3s apart, both
           unmuted inside half a second. THAT IS THE SKIP -- the same audio twice, slightly offset,
           until the handoff finally settles on one of them.
         - GRID. The viewer's clip is unmuted and played at 0 while the resume seek to the tile's
           position is still in flight (unmute +730ms, seek issued +854ms, `seeked` +1503ms), so the
           opening of the clip plays underneath a hero that is showing frame 7.1, and then jumps.

       A rule about ORDER fixes both, and nothing else does: while an open is in flight NOTHING may be
       audible, and the first element allowed to speak is the one the viewer has actually SETTLED on,
       at the position it has actually settled AT. So the openers take a hold inside the gesture --
       which also, in the same statement, mutes (the stamped engine way) whatever that gesture's own
       promote had just unmuted on the surface being left behind -- and the viewer hands the voice
       over once, when it is settled and resumed. See pfVoiceHold/pfVoiceReady in the viewer.

       BOUNDED, because a mute nobody asked for is the worse failure: the hold carries its own expiry,
       so a viewer that never settles gets its voice back on a timer rather than staying silent.
       AND THE LATCH IS NOT INVOLVED. soundOn, pfLatch and rova_sound are untouched here: a hold is
       the engine being asked to wait, never the reader being told what they wanted. */
    var sndHoldUntil = 0, sndHoldT = null;
    function soundHeld() { return sndHoldUntil > 0 && Date.now() < sndHoldUntil; }
    function soundHold(ms) {
      var d = (ms > 0) ? ms : 2000;
      sndHoldUntil = Date.now() + d;
      if (sndHoldT) { clearTimeout(sndHoldT); }
      sndHoldT = setTimeout(soundRelease, d);
      applySound();          // the surface being left behind goes quiet in the same tick as the tap
    }
    function soundRelease() {
      /* DROP THE DESIGNATED VOICE FIRST, and unconditionally -- ahead of the `sndHoldUntil`
         early-return below. The voice is an OPEN-time override; the moment the open is over
         (pfVoiceReady settled + resumed, or the hold expiring) activeVideo() must be the authority
         again, or a member who swipes to the next post would keep hearing the one they opened on.
         Unconditional because pfVoiceReady may fire on an open that never needed a hold at all. */
      /* ...UNLESS IT IS STILL IN THE AIR (2026-09-26). Since the fullscreen open and the timeline close
         both fly an AUDIBLE clip, a release that lands mid-flight (the hold's own 2.2s expiry, drop()'s
         2.6s cap on a slow line) would hand the sound to the placeholder under the flight while the
         flight -- not in SEL, so no sweep can reach it -- is still speaking: two voices. A voice that is
         connected but not yet inside a .post is flying; it is kept, and whoever lands it releases it
         (heroExpand's adoption, the close's landing). The 20s ceiling in soundVoiceEl still bounds it. */
      var _vf = sndVoice && sndVoice.el;
      if (!(_vf && _vf.isConnected && !(_vf.closest && _vf.closest('.post')))) { sndVoice = null; }
      if (!sndHoldUntil) { return; }
      sndHoldUntil = 0;
      if (sndHoldT) { clearTimeout(sndHoldT); sndHoldT = null; }
      applySound();          // ...and the element that stayed gets the voice, through the usual rule
    }
    window.__rovaSoundHold = soundHold;             // the viewer's openers live in their own closure
    window.__rovaSoundRelease = soundRelease;
    window.__rovaSoundHeld = soundHeld;             // pfSound() asks before it unmutes

    /* ---- AND THEN PROVE IT, ONCE (the honesty half) ---------------------------------------------
       An arm is permission, not a result. If the engine still refuses -- an edge case no harness on
       this box can reach, since neither Firefox nor headless WebKit here has a media backend -- the
       clip ends up unmuted, silent, and the indicator is lying again, which is the one outcome this
       whole change exists to prevent. So an unmute is checked against the only witness the engine
       offers: webkitAudioDecodedByteCount, which advances ONLY while audio is actually being decoded
       (the same property the "Tap for sound" note calls useless for a MUTED clip -- which is exactly
       what makes it the right witness for an unmuted one).

       BOUNDED TO THE CASE, deliberately. A check that can re-mute a working clip is how "the sound
       randomly kicks off" comes back, so this one can fire at most once per page: it runs only while
       NOTHING here has been proven audible yet, and the first clip that decodes a single byte sets
       sndProven and retires it for the life of the page. It refuses to judge without evidence -- no
       counter, no verdict; a clip that never actually advanced, no verdict; a clip the server marked
       silent, no verdict. The revert is a STAMPED engine mute plus the pill, so it can never reach
       rova_sound, and what the reader is left with is a control that works. */
    var sndProven = false;
    function verifySound(v) {
      if (sndProven || !v || v.muted || videoNoAudio(v)) { return; }
      if (typeof v.webkitAudioDecodedByteCount !== 'number') { return; }
      var b0 = v.webkitAudioDecodedByteCount, t0 = v.currentTime;
      setTimeout(function () {
        if (sndProven || !v.isConnected || v.muted || v._userPaused || v.paused) { return; }
        var b1 = v.webkitAudioDecodedByteCount;
        if (typeof b1 !== 'number') { return; }
        if (b1 > b0) { sndProven = true; return; }               // audible -- and never asked again
        /* AND IT STANDS DOWN THE MOMENT THE ENGINE HAS SAID YES, which is not caution, it is a
           MEASURED correction. Written without this line the check re-muted a perfectly good clip on
           its first run: promoteSound unmutes inside the reader's gesture, the decoder has not
           emitted a byte yet, and 800ms later a flat counter read as "refused" -- the clip went back
           to muted with a pill over working audio. That is precisely the "videos stopped having
           sound randomly" failure this file has been bitten by before, and the doctrine in the
           volumechange handler is explicit about which way to be wrong: FAIL TOWARD SOUND.
           sndUnlocked means a play() has already resolved under a real gesture, so a flat counter
           after that is far more likely to be a decoder spinning up -- or an engine that simply does
           not populate the property -- than a refusal. The check therefore covers only its actual
           subject: an unmute that happened while the page had NO proven grant, i.e. the lying
           indicator itself. Being wrong there costs a pill the reader can tap; being wrong after the
           grant costs them the audio they are listening to. */
        if (sndUnlocked) { return; }
        if (v.currentTime - t0 < 1.2) { return; }                // it never really played: no verdict
        engineMute(v, true);                                     // refused: back to the truth
        var p = v.play(); if (p && p.catch) { p.catch(function () {}); }
        updateSoundPill();
      }, 1500);
    }
    function activeVideo() {
      // While the immersive viewer is open it OWNS the sound: only its own videos count (a timeline
      // video still playing BEHIND the overlay must never steal it).
      var pf = document.querySelector('.pfeed.show');
      var vids = (pf || document).querySelectorAll(SEL);
      if (pf) {
        // Full-screen SNAP feed: the audible clip is the one whose CENTER is nearest the viewport
        // center (the current/snapped video) -- even if it's momentarily PAUSED mid-swipe. playIO
        // plays the clip you swipe to a beat AFTER it enters; requiring "playing" here meant that in
        // that beat activeVideo found nothing and applySound muted everything, so the clip started
        // muted. Only skip clips that are fully OFF-screen (the neighbours above/below).
        var vh = window.innerHeight || 0, vw = window.innerWidth || 0, cy = vh / 2, bestC = null, bestD = Infinity;
        // ONLY the CURRENT post's own clip may carry sound. Without this, when the current post has
        // no eligible video (a PHOTO post, or a carousel with its video slide paged away), the
        // nearest-center pick fell through to the PEEKING NEIGHBOUR's drag-reveal clip -- so on
        // desktop you heard the NEXT post playing before swiping to it (owner). The current post =
        // the one whose box contains the viewport centre; if IT has no clip, everything stays muted.
        var curP = null;
        Array.prototype.forEach.call(pf.querySelectorAll('.post'), function (p) {
          if (curP) return;
          var pr = p.getBoundingClientRect();
          if (pr.width > 4 && pr.height > 4 && pr.top <= cy && pr.bottom >= cy) { curP = p; }
        });
        Array.prototype.forEach.call(vids, function (v) {
          if (curP && !(v.closest && v.closest('.post') === curP)) return;   // a peeking neighbour's clip stays silent
          var r = v.getBoundingClientRect();
          if (!r.width || !r.height) return;          // display:none / not laid out
          if (r.bottom <= 0 || r.top >= vh) return;   // an off-screen neighbour above/below, not the current clip
          // A carousel pages its slides HORIZONTALLY, so a video slide swiped off to the side (while a PHOTO
          // slide is the one in view) is still vertically centered -- excluding only vertical off-screen made
          // activeVideo grab that hidden clip: sound, the "Tap for sound" pill, buffering spinners and the
          // control bar all bled onto a photo. Skip anything paged off to the side.
          /* THE TEST HAS TO BE THE GALLERY'S BOX, NOT THE VIEWPORT'S EDGE -- and this is the pfeed
             twin of the tie-break defect already fixed in the TIMELINE branch below. Every slide of
             one carousel shares the same vertical centre, so `d` ties for all of them and the
             strict `<` hands the sound to whichever comes FIRST IN DOM ORDER. The old horizontal
             test only rejected a slide pushed clean past the viewport edge, so an outgoing slide
             still overlapping the screen by a pixel kept winning that tie. MEASURED on the viewer:
             landing on slide 5 of 5 left slide 4 unmuted for a beat (muteMap MMMSM with idx 4) on
             every lap, always at the same slide -- the geometry that makes it happen is the mask
             and the track's furthest translate, but the predicate was simply the wrong one.
             onCurrentSlide asks the only question that matters: is this the slide its gallery is
             showing? A clip outside a gallery answers yes and is unaffected. */
          if (!onCurrentSlide(v)) return;
          var d = Math.abs((r.top + r.bottom) / 2 - cy);
          if (d < bestD) { bestD = d; bestC = v; }
        });
        return bestC;
      }
      /* TIMELINE: THE PLAYING CARD SPEAKS (2026-09-26, iOS parity -- see tlSlotDecide below).
         This used to be "the topmost PLAYING clip that inView() accepts", and inView() accepts a clip
         that is 10% on screen: with the pre-roll starting cards on their way IN (2026-09-09), the card
         sliding in at the bottom could be playing while the one the reader was watching sat above it,
         and "topmost" is a tie-break, not a reading of what anybody is looking at. The answer is now a
         STATE, decided off IntersectionObserver crossings once the scroll has come to rest: the one
         media box holding the slot. Its current slide's clip is the voice -- even while momentarily
         paused (calmPlay's 90ms defer, a loop seam): unmuting a paused element costs nothing, and
         calmPlay re-hands the sound (applySound) the moment it starts. No slot, no voice. */
      if (!tlSlot || !tlSlot.isConnected) { return null; }
      var sv = tlSlot.querySelectorAll('video');
      for (var si = 0; si < sv.length; si++) {
        if (sv[si].closest && sv[si].closest('.avatar')) continue;
        if (onCurrentSlide(sv[si])) { return sv[si]; }   // a gallery's off-slide clips are not the card
      }
      return null;
    }
    /* ---- THE TIMELINE'S PLAYING CARD  (Rob 2026-09-26, parity with the iOS app's build 474) ----------
       "If I'm scrolling the feed or profile and unmute it should remain unmuted so content I'm scrolling
        already plays automatically when I scroll to it like Instagram including embedded music posts."

       ONE SLOT, ONE HOLDER, the iOS rule verbatim:
         - the holder is the timeline/profile MEDIA BOX (a card's .media, a gallery's .media.carousel)
           with the most media on screen -- visible HEIGHT, header excluded; cards share the column's
           width, so height is the pixel count -- and it must be at least TL_MIN (50%) of that box;
         - it KEEPS the slot until it drops under 50% or another box is TL_HYST (15px = the app's 15pt)
           more visible, so two half-visible cards cannot hand the sound back and forth;
         - and the slot never changes MID-FLING: a decision waits for __rovaScrollAt to be 160ms old
           (the calmPlay settle), so a fast fling past five cards is one handover, not five.
       The voice is still applySound's to hand out, with every existing condition (intent, the engine's
       permission, the open hold, PiP); this only answers "which card is the reader on".

       PERF, because this is on the scroll path: nothing here runs per frame. tlSlotIO is an
       IntersectionObserver (thresholds every 10%, off the main thread); its callback only records
       and schedules. The rect reads happen once per SETTLE, over the few boxes the observer says are
       intersecting -- the same cost calmPlay's own "still on screen?" check already pays per clip. */
    var TL_MIN = 0.5, TL_HYST = 15;
    var tlSlot = null, tlIn = [], tlSlotT = null, tlAmPost = null, tlPfWas = false;
    /* ---- THE HANDOVER HAPPENS UNDER THE FINGER  (Rob 2026-09-30, iPhone Safari) --------------------------
       "It doesn't start playing the next media in view until I lift off my finger ... and it doesn't stop the
        Apple Music player while there is clearly another video with audio scrolling into view."
       CAUSE: the no-mid-fling wait (here and in calmPlay) reads __rovaScrollAt, which the shared handler
       stamps on every scroll AND EVERY TOUCHMOVE -- so while a finger was on the glass the page was never "at
       rest", and the slot (and the muted start) waited for the lift, then for the momentum to die.
       The wait exists for the FLING: no finger, a card flown past in 100ms. A finger dragging the page is the
       reader choosing what to look at. So while the page moves UNDER THE READER'S CONTROL (tlLive: a finger
       down at a finger's speed, or a crawl), a challenger that wins the slot rule (>=50%, most visible,
       +15px) and keeps winning it for TL_DWELL of CONTINUOUS dominance takes the slot mid-drag, and
       applySound hands the voice over in the same task (the old clip is muted / the rule's song is halted:
       pausing needs no activation, so two voices never overlap). A free fling keeps the old wait.
       iOS: an unmute after the page's first in-gesture grant (sndUnlocked) is honoured from a timer, which is
       what the settle path has always done after the lift; the song is the ONE amAudio element, unlocked by
       amTlUnlock. So the same calls work under the finger.
       COST: tlGeo caches the candidates' rects from the last full decision; the scroll sampler (live only) is
       arithmetic against scrollY and runs the full, rect-reading decision only when its answer disagrees with
       the slot/pending challenger, at most every 60ms. Nothing reads layout per frame. */
    var TL_DWELL = 140, TL_DRAG_VMAX = 1.6, TL_CRAWL = 0.3;
    var tlFinger = 0, tlTouchAt = 0, tlPend = null, tlPendAt = 0, tlGeo = null, tlFullAt = 0;
    function tlTouch(e) { tlFinger = (e.touches && e.touches.length) || 0; tlTouchAt = Date.now(); }
    ['touchstart', 'touchmove', 'touchend', 'touchcancel'].forEach(function (t) {
      document.addEventListener(t, tlTouch, { passive: true, capture: true });
    });
    // the page is moving, but at the reader's hand: a finger on the glass (a stale flag lapses in 1.2s -- a
    // lost touchend must not make a later fling "live"), or a crawl (a trackpad drag, a fling's slow tail)
    function tlLive() {
      var vel = window.__rovaScrollVel || 0;
      if (tlFinger && Date.now() - tlTouchAt < 1200) { return vel < TL_DRAG_VMAX; }
      return vel < TL_CRAWL;
    }
    window.__rovaTlLive = tlLive;
    // the slot rule (see tlSlotDecide) evaluated on the cached rects shifted by the scroll since they were read
    function tlQuick() {
      var g = tlGeo, dy = (window.scrollY || 0) - g.y, best = null, bestPx = -1, cur = null;
      for (var i = 0; i < g.units.length; i++) {
        var u = g.units[i], px = 0, ok = false, p;
        if (!u.el.isConnected) continue;
        if (u.bH > 0) { p = Math.max(0, Math.min(u.bT - dy + u.bH, g.vh) - Math.max(u.bT - dy, g.top)); px = p; if (u.vid && p >= u.bH * TL_MIN) { ok = true; } }
        if (u.cH > 0) { p = Math.max(0, Math.min(u.cT - dy + u.cH, g.vh) - Math.max(u.cT - dy, g.top)); if (p > px) { px = p; } if (p >= u.cH * TL_MIN) { ok = true; } }
        if (tlSlot && u.post.contains(tlSlot)) { cur = { el: u.el, px: px, ok: ok }; }
        if (ok && px > bestPx) { bestPx = px; best = u.el; }
      }
      if (!tlSlot || !cur || !cur.ok) { return best; }
      if (best && best !== cur.el && bestPx >= cur.px + TL_HYST) { return best; }
      return cur.el;
    }
    window.addEventListener('scroll', function () {
      if (!tlGeo || !tlIn.length || Date.now() - tlFullAt < 60 || !tlLive()) return;
      if (tlQuick() === (tlPend || tlSlot)) return;          // nothing new: the dwell timer (if any) decides
      if (tlSlotT) { clearTimeout(tlSlotT); tlSlotT = null; }
      tlSlotDecide();
    }, { passive: true });
    var tlSlotIO = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        var b = en.target, i = tlIn.indexOf(b);
        if (en.isIntersecting) { if (i < 0) { tlIn.push(b); } }
        else {
          if (i >= 0) { tlIn.splice(i, 1); }
          if (!b.isConnected) { try { tlSlotIO.unobserve(b); } catch (e) {} b._tlObs = 0; }   // a recycled card: let it go
        }
      });
      tlSlotSoon();
    }, { threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1] });
    // wire() calls this for every post clip; the viewer's own clips have their own rule (activeVideo's pfeed branch)
    function tlObserve(v) {
      if (!v || !v.closest || v.closest('.pfeed') || v.closest('.avatar')) return;
      var box = v.closest('.media');
      if (!box || box._tlObs || !box.closest('.post')) return;
      box._tlObs = 1;
      tlSlotIO.observe(box);
      // ...and the post's song card (see tlObserveCard)
      tlObserveCard(box.closest('.post').querySelector('.am-card[data-preview]'));
    }
    /* A timeline song card is observed on its own too, because a PHOTO + song post has no clip to be
       wired through (2026-09-26, second pass -- see tlUnitOf). The sound IIFE's scan() finds every one. */
    function tlObserveCard(card) {
      if (!card || card._tlObs || !card.closest || card.closest('.pfeed') || !card.closest('.post')) return;
      card._tlObs = 1; card._tlAm = 1;
      tlSlotIO.observe(card);
    }
    function tlSlotSoon() {
      if (tlSlotT) return;
      tlSlotT = setTimeout(tlSlotDecide, 120);
    }
    /* ...AND ONCE AT EVERY SCROLL SETTLE. The observer's thresholds are the VIEWPORT's ratio and the rule
       is "header excluded", so a card can cross 50% of the part below the header without crossing any
       threshold at all -- measured: a holder left at 49.5%, a 55% card left without the voice, for as
       long as the reader stayed put. The shared scroll handler's 240ms settle (the same one that lifts
       html.tl-scroll) now asks too: one decision per rest, never per frame. */
    window.__rovaTlSlotSoon = tlSlotSoon;
    /* "Header excluded": the sticky .topbar, plus the feed tabs while they are docked under it. Read
       once per decision, never per frame. */
    function tlTopEdge() {
      var t = 0, hb = document.querySelector('.topbar');
      if (hb) { var r = hb.getBoundingClientRect(); if (r.top <= 1 && r.bottom > t) { t = r.bottom; } }
      var ft = document.getElementById('feed-tabs');
      if (ft) { var r2 = ft.getBoundingClientRect(); if (r2.height > 0 && r2.top <= t + 1 && r2.bottom > t) { t = r2.bottom; } }
      return t;
    }
    function tlVisOf(b, top, vh) {
      var r = b.getBoundingClientRect();
      if (!(r.height > 0) || !(r.width > 0)) return null;
      var vis = Math.min(r.bottom, vh) - Math.max(r.top, top);
      if (vis < 0) { vis = 0; }
      return { px: vis, ratio: vis / r.height, t: r.top, h: r.height };
    }
    function tlSlotDecide() {
      tlSlotT = null;
      if (document.querySelector('.pfeed.show')) { tlPend = null; return; }   // the viewer owns the voice; its close re-decides
      // never mid-FLING -- but a finger dragging the page (or a crawl) is not a fling (see THE HANDOVER HAPPENS UNDER THE FINGER)
      var moving = Date.now() - (window.__rovaScrollAt || 0) < 160, live = moving && tlLive();
      if (moving && !live) { tlPend = null; tlSlotT = setTimeout(tlSlotDecide, 140); return; }
      tlFullAt = Date.now();
      var vh = window.innerHeight || 0, top = tlTopEdge();
      var geo = { y: window.scrollY || 0, top: top, vh: vh, units: [] };
      /* ONE CANDIDATE PER POST (2026-09-26, second pass -- the iOS session's feedPlayable rule, Rob: a
         photo + song post on @thesashagomez "starts its song by itself when it scrolls in" on the app).
           - Any post with a clip is a candidate: its slot element is the clip's media box, eligible at
             50% of that box.
           - While sound is ON, a post whose ONLY sound is its song card (a PHOTO + song, or a silent clip
             + song) is a candidate too, eligible at 50% of the SONG CARD. A photo + song post's slot
             element is the card itself, so activeVideo() finds no clip there and no video speaks.
           - With sound OFF a song-only post without a clip is skipped entirely: it can never take the
             slot away from a nearby clip, which keeps its muted autoplay exactly as before.
         Ranking is the post's media on screen -- the larger of its media box and its song card, visible
         height below the header -- with the same 15px hysteresis and the same no-change-mid-fling wait. */
      var soundy = soundOn && feedPref('soundfollow', true);
      var best = null, bestPx = -1, bestU = null, cur = null, seen = [];
      for (var i = tlIn.length - 1; i >= 0; i--) {
        var b = tlIn[i];
        if (!b.isConnected) { tlIn.splice(i, 1); continue; }
        var bp = b.closest && b.closest('.post');
        if (!bp || seen.indexOf(bp) >= 0) continue;
        seen.push(bp);
        var u = tlUnitOf(bp, top, vh, soundy);
        if (!u) continue;
        geo.units.push({ post: bp, el: u.el, vid: u.vid, bT: u.mb ? u.mb.t : 0, bH: u.mb ? u.mb.h : 0, cT: u.mc ? u.mc.t : 0, cH: u.mc ? u.mc.h : 0 });
        if (tlSlot && bp.contains(tlSlot)) { cur = u; }
        if (u.ok && u.px > bestPx) { bestPx = u.px; best = u.el; bestU = u; }
      }
      tlGeo = geo;
      var next = tlSlot;
      if (!tlSlot || !tlSlot.isConnected || !cur || !cur.ok) { next = best; }
      else if (best && best !== cur.el && bestPx >= cur.px + TL_HYST) { next = best; }
      else { next = cur.el; }                                   // same post (its element may have changed with the sound state)
      /* MID-DRAG: a challenger must keep winning for TL_DWELL before it takes the slot (a card merely passing
         through under a quick drag never gets the voice); at rest it takes it at once, as before. A holder
         that fell under 50% with no challenger qualifying yet (next null) lets go at once: playIO is already
         pausing its clip, so holding the slot would only hold silence. */
      if (live && next && next !== tlSlot) {
        if (tlPend !== next) { tlPend = next; tlPendAt = Date.now(); }
        var left = TL_DWELL - (Date.now() - tlPendAt);
        if (left > 0) { tlSlotT = setTimeout(tlSlotDecide, left + 4); return; }
      }
      tlPend = null;
      var wasSlot = tlSlot, wasAm = tlAmPost;
      if (next !== tlSlot) {
        // bounded trace of every handover (tests read it; cheap -- it only runs on a CHANGE)
        var tr = window.__rovaTlTrace || (window.__rovaTlTrace = []);
        tr.push({ at: Date.now(), age: Date.now() - (window.__rovaScrollAt || 0), live: live, finger: tlFinger,
                  from: tlSlot && tlSlot.closest('.post') ? tlSlot.closest('.post').getAttribute('data-view') : null,
                  to: next && next.closest('.post') ? next.closest('.post').getAttribute('data-view') : null,
                  kind: next ? (next._tlAm ? 'song' : 'clip') : '',
                  px: next ? Math.round(bestPx) : 0, curPx: cur ? Math.round(cur.px) : -1 });
        if (tr.length > 40) { tr.shift(); }
      }
      tlSlot = next;
      /* THE MUSIC RULE, decided with the slot so the two can never disagree: the holder is a song-only
         post (no audible clip) whose song card is at least half on screen, and sound is on. Anything
         else is null, which stops a song this rule started and never touches one the reader tapped. */
      var hu = (tlSlot === (bestU && bestU.el)) ? bestU : cur;
      tlAmPost = (tlSlot && hu && hu.el === tlSlot && hu.songOk) ? hu.post : null;
      /* ...AND THE READER'S OWN TRACK IS PROTECTED ONLY WHILE ITS POST IS THE PLAYING CARD (2026-09-30, Rob:
         "it doesn't stop the Apple Music player while there is clearly another video with audio scrolling
         into view"). At a committed HANDOVER (so after the 140ms dwell mid-drag, and never on a small scroll
         within the same card) to a different post that will actually SPEAK -- its song will start (tlAmPost),
         or its current clip has audio and the page may sound -- a tapped song that is not in that post stops,
         so the one-voice rule below lets the new card speak in this same pass. A handover to nobody, or to a
         silent card, or with sound off, leaves it playing (as the pinned player always has). */
      if (tlSlot && tlSlot !== wasSlot && window.__rovaAmReader && soundOn && feedPref('soundfollow', true)) {
        var rc = null; try { rc = window.__rovaAmReader(); } catch (e) {}
        var sp = tlSlot.closest && tlSlot.closest('.post');
        if (rc && sp && !sp.contains(rc)) {
          var speaks = !!tlAmPost;
          if (!speaks && !tlSlot._tlAm && userActivated() && sndUnlocked) {
            var hv = tlSlot.querySelectorAll('video');
            for (var hi = 0; hi < hv.length; hi++) {
              if (hv[hi].closest && hv[hi].closest('.avatar')) continue;
              if (onCurrentSlide(hv[hi]) && !videoNoAudio(hv[hi])) { speaks = true; break; }
            }
          }
          if (speaks) {
            try { window.__rovaAmStop && window.__rovaAmStop(); } catch (e) {}
            var tr2 = window.__rovaTlTrace; if (tr2 && tr2.length) { tr2[tr2.length - 1].readerSongStopped = 1; }
          }
        }
      }
      if (live && tlSlot === wasSlot && tlAmPost === wasAm) return;   // mid-drag and nothing moved: no sweep
      applySound();
    }
    /* A post's candidacy for the playing card (see tlSlotDecide). Rect reads only, once per settle. */
    function tlUnitOf(post, top, vh, soundy) {
      var box = post.querySelector('.media');
      var hasVid = !!(box && box.querySelector('video'));       // no clip: a photo post, or its clip is away in the viewer (fs-away)
      var card = post.querySelector('.am-card[data-preview]');
      var songOnly = false;
      if (card && soundy) {
        songOnly = true;
        var clips = post.querySelectorAll('.media video');
        for (var k = 0; k < clips.length; k++) { if (!videoNoAudio(clips[k])) { songOnly = false; break; } }
      }
      if (!hasVid && !songOnly) return null;
      var mb = box ? tlVisOf(box, top, vh) : null;
      var mc = songOnly ? tlVisOf(card, top, vh) : null;
      var songOk = !!(mc && mc.ratio >= TL_MIN);
      return { post: post, el: hasVid ? box : card, songOk: songOk, vid: hasVid, mb: mb, mc: mc,
               ok: !!((hasVid && mb && mb.ratio >= TL_MIN) || songOk),
               px: Math.max(mb ? mb.px : 0, mc ? mc.px : 0) };
    }
    /* The reader's own hand outranks geometry: the speaker they tap (and the card a viewer closes onto)
       becomes the holder at once. The next settle re-checks it by the same 50%/15px rule, so a claim can
       never outlive the card being on screen. */
    function tlClaim(v) {
      var box = v && v.closest && !v.closest('.pfeed') && v.closest('.media');
      if (!box || !box.closest('.post')) return;
      tlObserve(v);
      if (tlAmPost && !tlAmPost.contains(box)) { tlAmPost = null; }   // a song belongs to its own post's slot
      tlSlot = box;
    }
    window.__rovaTlClaim = function (v) { tlClaim(v); applySound(); };
    /* ---- THE SPEAKER SHOWS THE READER'S CHOICE, NOT THE ENGINE'S BOOKKEEPING  (Rob 2026-09-26) -------
       "I actually see the speaker icon unmute as opposed to already be unmuted." The corner .vc-sound
       drew `v.muted`, and `v.muted` is true for a great many reasons the reader never chose: a clip
       waiting for the page's first activation, the neighbour card that is not the playing card, the
       viewer's placeholder while the flown clip is the voice, a flight's own transient writes. Each of
       those painted a crossed-out speaker over a site whose sound was ON -- the flip he saw.
       So the glyph now draws INTENT: sound on (soundOn, or the viewer's session latch) paints the
       speaker ON, and only the reader pressing mute paints it muted. Before the first activation that
       means "sound is on, the browser has not let it start yet" -- the next tap anywhere (promoteSound)
       or on this very speaker makes it true, so the icon is a promise the first touch keeps rather than
       a statement that they chose silence. The gear's manual-sound mode (soundfollow off) has no intent
       to show, so there it is the element's own state, exactly as before. */
    function soundIntent() {
      if (!feedPref('soundfollow', true)) { return false; }
      return !!(soundOn || (pfLatch && document.querySelector('.pfeed.show')));
    }
    window.__rovaSoundIntent = soundIntent;
    // an INTENT change repaints every speaker at once (a mute on one card changes what all of them mean)
    function speakersSync() {
      Array.prototype.forEach.call(document.querySelectorAll('.vc-sound'), function (b) { if (b._sync) { try { b._sync(); } catch (e) {} } });
    }
    window.__rovaTlSlot = function () { return tlSlot; };   // tests + the flight recorder: which card holds the voice
    // ENGINE-driven muted change: stamped so the volumechange handler can tell it from a USER toggle even
    // though the event delivers ASYNC (after the `applying` guard has released). Without the stamp, the
    // handoff's mute of the OUTGOING clip could land LAST in the event queue (it does when swiping BACK to
    // an earlier post -- DOM order) and read as "the user muted" -> soundOn=false + rova_sound=0 saved ->
    // everything silenced (owner: "play sound, swipe down then back up, the sound goes away"). Also skips
    // no-op sets so fewer events queue at all.
    function engineMute(v, m) {
      if (v.muted === m) return;
      v._engineSetAt = Date.now();
      /* AND IT CANNOT RIDE A STALE DECLARATION. The volumechange handler now only lets a mute move
         the site preference when the reader declared it (v._userMuteAt), and a declaration that was
         written but never consumed -- a user mute the engine turned into a no-op set, so no event
         ever came -- would be sitting there waiting for the next engine mute to spend it. An engine
         write is the proof that this element's next mute event is NOT the reader's. */
      v._userMuteAt = 0;
      v.muted = m;
    }
    /* THE READER'S OWN MUTE, DECLARED. The ONE control on this site that mutes on purpose (the
       corner .vc-sound button) says so here, and it is the only thing that may write rova_sound=0.
       Exported because that control lives in a different closure -- the same reason __rovaEngineMute
       is exported, and the same rule read from the other end. */
    window.__rovaUserMute = function (v) { if (v) { v._userMuteAt = Date.now(); } };
    /* ---- UNMUTING BY HAND MUST NOT STOP THE CLIP  (owner 2026-08-10) ---------------------------
       "I pressed unmute then I heard it for a second but it auto swiped to the next media and it
        was muted."

       TWO defects wear that one sentence, and this is the half that is invisible until you go
       looking for it -- because the advance is a perfectly good explanation for "it stopped", and
       it is not the only one.

       ON WEBKIT, UNMUTING A CLIP THAT IS PLAYING UNDER THE MUTED-AUTOPLAY ALLOWANCE SILENTLY
       PAUSES IT: no promise rejection, no error, no event on the way in -- the clip simply stops.
       That rule is already written up at length in initCarousel's handSound(), which repairs it
       for the one path that had been reported (the slideshow's own slide handoff). Every OTHER way
       a reader can unmute on this site -- the corner speaker, the "Tap for sound" pill, a tap on
       the clip body -- did a bare `v.muted = false` with nothing watching, so on iOS Safari a
       hand-unmute could stop the clip a beat after the sound arrived. A beat is exactly what "a
       second" feels like.

       Same repair, same reasoning, written ONCE for the paths that live outside a carousel -- two
       copies of "put it back if unmuting stopped it" is precisely how the two ends of a rule
       quietly drift apart:
         - resume it AS IT IS, UNMUTED. Re-muting first does not fix the collision, it ARMS IT
           AGAIN: the clip is muted, the next applySound pass unmutes it and the engine stops it a
           second time. That was MEASURED in the carousel copy -- the trap fired twice, 98ms apart,
           and the clip still ended up paused at 0:00.
         - only a REFUSAL mutes, and then only through the STAMPED engine path, or the volumechange
           handler reads it as the reader reaching for the mute button and flips soundOn plus the
           saved rova_sound preference for the whole site.
         - it stands down instantly for a deliberate pause (_userPaused), for a re-mute, and for an
           element that has left the document. One listener, 900ms -- the window the carousel copy
           measured as covering the whole transition. */
    function soundRepair(v) {
      if (!v || v.muted || v._userPaused) return;
      var t = null;
      var muteRetry = function () {
        engineMute(v, true);                                 // a REFUSAL: stamped, or the pref dies
        var p2 = v.play(); if (p2 && p2.catch) { p2.catch(function () {}); }
      };
      var onStop = function () {
        if (v._userPaused || v.muted || !v.isConnected) { clear(); return; }
        if (!v.paused) return;
        var p;
        try { p = v.play(); } catch (e) { muteRetry(); return; }
        if (p && p.catch) { p.catch(muteRetry); }
      };
      function clear() { if (t) { clearTimeout(t); t = null; } try { v.removeEventListener('pause', onStop); } catch (e) {} }
      v.addEventListener('pause', onStop);
      t = setTimeout(clear, 900);
    }
    window.__rovaSoundRepair = soundRepair;
    function applySound() {
      if (!feedPref('soundfollow', true)) { updateSoundPill(); return; }   // gear setting: manual sound only
      var pf = document.querySelector('.pfeed.show');
      if (!pf) { pfLatch = false; }                        // the session latch lives only while the viewer is open
      var pip = document.pictureInPictureElement;
      // Once the user unmutes in the pfeed, KEEP sound on for every clip they swipe to (pfLatch) -- even if a
      // freshly-wired clip's autoplay-mute momentarily clobbered soundOn. A popped-out PiP clip keeps its own sound.
      // ...but never before the document has been ACTIVATED: an unmute the browser has not been given a
      // gesture for does not fail quietly, it pauses the clip (see userActivated above). pfLatch can only
      // be set by a tap, so this narrows exactly one case: a page the reader has not touched yet, where
      // soundOn is a preference carried in from an earlier session.
      /* ...AND THE ENGINE MUST ALREADY HAVE SAID YES. userActivated() is a document-level fact and
         cannot tell you whether an unmute performed HERE -- from an IO crossing, a scroll tick or a
         rAF -- will be honoured; on WebKit it will not be. Unmuting anyway is what put "sound on"
         under a silent clip while hiding the one control that could have fixed it. See sndUnlocked
         and promoteSound above/below. A clip left muted here is a clip with a pill on it. */
      /* ...AND NOT WHILE AN OPEN IS STILL CHOOSING ITS ELEMENT. soundHeld() is the third condition of
         the same sentence: intent (soundOn/pfLatch), permission (sndUnlocked), and now TIMING. During
         a hold this call is still what does the work -- it mutes every clip, the stamped way, so the
         card the reader lifted off cannot keep talking under the viewer that is opening over it. */
      /* ...AND A DESIGNATED VOICE IS THE FOURTH CLAUSE, AND IT ONLY EVER LOOSENS THE TIMING ONE.
         (2026-08-17, the lift-off round -- see soundVoiceArm above.) A hold means "this open has not
         picked its element yet". A voice means "it has, and it did so inside the gesture", which is
         strictly more information, so the hold's timing veto no longer applies -- but nothing else
         moves: intent (soundOn/pfLatch), permission (sndUnlocked) and activation are all still
         required exactly as they were, and every OTHER clip on the page is still muted in the same
         pass. So the hold keeps doing the one job it was written for (the surface being left behind
         goes quiet in the same tick as the tap) while the voice the reader tapped for arrives once,
         at lift-off, instead of ~700ms later on a second element. */
      var voiceEl = soundVoiceEl();
      var wantSound = (soundOn || (pf && pfLatch)) && userActivated() && sndUnlocked && (!soundHeld() || !!voiceEl);
      var act = pip || (wantSound ? (voiceEl || activeVideo()) : null);
      /* The timeline's song follows the slot (tlSlotDecide decided whether the holder is a silent clip +
         a half-visible song card). Sound intent is the gate, not the engine's grant: the preview has its
         own element and its own refusal path (amStartFresh 'load' arms the reader's next gesture).
         DECIDED BEFORE THE CLIPS (2026-09-30): a slot moving song -> clip halts the rule's song HERE, so the
         one-voice test below already reads it stopped and the new card speaks in this same task (it used to
         wait for the <audio>'s async pause event to re-run this); clip -> song starts it here, so the
         outgoing clip is muted in this same task too. */
      if (window.__rovaAmTl) {
        try { window.__rovaAmTl((!pf && !pip && soundOn && feedPref('soundfollow', true)) ? tlAmPost : null); } catch (e) {}
      }
      /* ONE VOICE WITH THE MUSIC, TOO (2026-09-26). With sound on by default a song preview and the
         timeline's playing card are now both "on" at once far more often than when sound was opt-in, and
         nothing arbitrated between the <audio> and the <video>s. While a preview is sounding on the
         timeline, no clip there speaks; when it stops (its own play/pause events re-run this), the
         playing card gets the voice back. The viewer keeps its own precedence, untouched. */
      if (act && act !== pip && !pf && !voiceEl && window.__rovaAmPlaying && window.__rovaAmPlaying()) { act = null; }
      applying = true;
      Array.prototype.forEach.call(document.querySelectorAll(SEL), function (v) {
        if (v === pip) return;                             // never mute the PiP clip from scroll
        engineMute(v, v !== act);
      });
      applying = false;
      updateSoundPill();
      // (the timeline's song is decided above, before the clips -- see "DECIDED BEFORE THE CLIPS")
      // the viewer just closed: the page under it may have moved (scroll lock), so the slot is re-decided
      if (pf) { tlPfWas = true; } else if (tlPfWas) { tlPfWas = false; tlSlotSoon(); }
    }
    // The immersive viewer drives sound-follow on SCROLL too, not only on IntersectionObserver
    // crossings: mid-swipe the observer state can freeze with the wrong clip audible, so as the new
    // clip snaps to center this re-hands it the sound. Cheap + guarded, safe to call per rAF.
    window.__rovaSyncSound = applySound;
    /* Any code OUTSIDE this closure that has to mute a clip must mute it the ENGINE way -- stamped, so
       the volumechange handler cannot read it as the reader reaching for the mute button and flip
       soundOn (+ the saved rova_sound preference) for the whole site. The `applying` guard cannot help
       a different closure: volumechange delivers ASYNC, long after `applying` has released, which is
       exactly why the stamp exists. Exported for initCarousel's next-clip primer, which starts a clip
       that is still paged OFF SLIDE and so must be provably silent before it plays a single frame. */
    window.__rovaEngineMute = engineMute;
    // Tear down videos more than `keep` posts away from `curPost` (teardownVideo defined below in the
    // same scope). The pfeed calls this on a settled scroll so an endless feed can't accumulate live
    // HLS decoders + buffers. Never touches the current clip or its immediate neighbours.
    window.__rovaRecycleVideos = function (curPost, keep) {
      if (!curPost) return;
      var root = (curPost.closest && curPost.closest('.pfeed')) || document;
      var posts = root.querySelectorAll('.post');
      var ci = -1;
      for (var i = 0; i < posts.length; i++) { if (posts[i] === curPost) { ci = i; break; } }
      if (ci < 0) return;
      var k = keep || 3;
      Array.prototype.forEach.call(posts, function (p, i) {
        if (Math.abs(i - ci) <= k) return;
        Array.prototype.forEach.call(p.querySelectorAll('video'), teardownVideo);
      });
    };

    // FULL, PERMANENT release of a post being REMOVED from the DOM (the feed viewer's far-behind prune, and
    // the whole-list wipe on close/reopen). teardownVideo only frees the decoder but keeps the clip observed
    // so it can rebuild on a back-swipe -- correct for a RECYCLED (still-attached) post, but a REMOVED post is
    // gone for good and MUST be unobserved from playIO + warmIO too. Without this, the IntersectionObservers
    // pinned every removed <video> (+ its detached post subtree) forever -- a detached-DOM leak that also grew
    // the observers' per-frame work, so the home feed got laggier the deeper you swiped while profiles (which
    // never prune) stayed smooth. THE fix for that leak.
    // ONE clip's worth of that release, reachable on its own. Every whole-subtree caller below funnels
    // through it, and the hero handoff needs it for the single placeholder <video> it evicts -- that one
    // is NOT inside the node it is handed, so querySelectorAll('video') would never have found it.
    function retireVideo(v) {
      if (!v) return;
      tlHold(v);                                        // cover first (see teardownVideo)
      v._released = 1;
      // START SLOT: hand it back. The pause + load() below would fire the media events the scheduler
      // hooks anyway, but a 1MB head-start fetch has no event to fire -- so abort it explicitly. This
      // is the release point that covers __rovaReleaseVideos, pruneFarPosts, stubCard's recycle, the
      // hero handoff's evicted placeholder and stopOrphans, all of which funnel through here.
      try { if (v._vsFetch) { v._vsFetch.abort(); v._vsFetch = null; } vsDrop(v); } catch (e) {}
      try { playIO.unobserve(v); } catch (e) {}
      try { warmUnobserve(v); } catch (e) {}
      try { v.pause(); } catch (e) {}
      if (v._hls) { try { v._hls.destroy(); } catch (e) {} v._hls = null; }   // free hls.js MSE buffers + worker
      v._hlsWired = 0;
      /* STASH THE URLS AS ATTRIBUTES BEFORE STRIPPING THEM (2026-08-08). _mp4src and _posterStash are JS
         PROPERTIES, and a missing src is an ATTRIBUTE -- properties do not survive serialisation, the
         absence of an attribute does. The card feed's virtualiser folds a far-off card into a stub by
         stashing p.outerHTML (stubCard) and re-parses it on the way back (restoreCard), and it calls
         __rovaReleaseVideos(p) FIRST: measured on /feed, 27 of 27 snapshots serialised a <video> whose
         src this function had already removed. The restored card therefore holds a BRAND NEW element
         with no src attribute AND no properties at all -- which is why the broken clips report
         _released === false even though their predecessor was definitely released (proved by node
         identity: the element carries the retired one's data-vmark but a fresh JS id). wire() then read
         getAttribute('src') -> null and latched _mp4src = '', and all three re-attach sites are
         `if (!src && v._mp4src)`, so every one of them became a no-op: sourceless forever, even scrolled
         back into view. An attribute survives outerHTML / innerHTML / cloneNode, so recovery survives
         with it -- and because we stash the URL rather than keep the src, the release still frees
         exactly what it freed before and the stub markup still parses with ZERO media requests.
         NEVER stash a blob: or .m3u8 url: _mp4src is deliberately the plain mp4 from before attachHls
         swapped src, and a blob: URL is dead the moment the element that owned it is. */
      try {
        var _keep = v._mp4src || v.getAttribute('src') || '';
        if (_keep && _keep.slice(0, 5) !== 'blob:' && !/\.m3u8(\?|#|$)/i.test(_keep)) { v.setAttribute('data-video-src', _keep); }
        var _kp = v._posterStash || v.getAttribute('poster') || '';
        if (_kp) { v.setAttribute('data-vposter', _kp); }
      } catch (e) {}
      try { v.removeAttribute('src'); v.removeAttribute('poster'); v.load(); } catch (e) {}   // drop decoder + bitmap now
    }
    window.__rovaRetireVideo = retireVideo;   // hero + pfeed IIFEs are separate scopes -> reach it through window
    window.__rovaReleaseVideos = function (node) {
      if (!node || !node.querySelectorAll) return;
      Array.prototype.forEach.call(node.querySelectorAll('video'), retireVideo);
    };

    /* ---- ONE OWNER OF PLAYBACK: nothing stays audible once the UI can no longer reach it -------------
       (owner 2026-08-06: "double tapping media on the grid on web app safari browser the media audio
       plays twice and I can't stop the first/second playing sound in the background until I reload.")

       A <video> removed from the document KEEPS PLAYING, audio and all. Every stop path in this file --
       close(), clearPfeedList, __rovaReleaseVideos, pruneFarPosts, the grid's release(), applySound's
       sweep -- finds its subjects with a DOM query, so a detached clip is invisible to all of them and
       genuinely cannot be stopped by anything the user can touch. Only a reload silences it, which is
       exactly what the owner reported.

       The two paths that produced one are fixed at source (the hero handoff retires the placeholder it
       evicts; the deferred tap timer re-validates its subject), but the GUARANTEE lives here: every
       wired clip is tracked by WeakRef -- no strong reference, so this can never become the very
       detached-DOM leak the release helpers above exist to prevent -- and stopOrphans() retires any
       tracked clip that is no longer in the document. Called wherever the viewer changes phase, so any
       future path that strands a clip is silenced within one open/close/handoff instead of surviving
       until reload. Cheap: one array walk over a few dozen WeakRefs. */
    var _hasWeakRef = (typeof WeakRef === 'function');
    var mediaReg = [];
    function trackMedia(v) {
      if (!_hasWeakRef || !v || v._orphTracked) return;
      v._orphTracked = 1;
      mediaReg.push(new WeakRef(v));
      // Self-maintaining: a long feed scroll wires clip after clip and would otherwise grow this list
      // without ever passing through the viewer. The sweep both compacts it and does its real job, so
      // there is nothing to schedule and no timer to leak.
      if (mediaReg.length > 200) { stopOrphans(); }
    }
    function stopOrphans() {
      if (!_hasWeakRef) return 0;
      var stopped = 0, keep = [];
      for (var i = 0; i < mediaReg.length; i++) {
        var v = null;
        try { v = mediaReg[i].deref(); } catch (e) {}
        if (!v) continue;                       // collected: drop the ref, nothing to do
        if (v.isConnected) { keep.push(mediaReg[i]); continue; }
        // DETACHED. No control on screen points at it any more, so it must not be running -- and it must
        // not be revivable either (a captured reference in some other deferred closure).
        if (!v.paused) { stopped++; }
        retireVideo(v);
      }
      mediaReg = keep;
      return stopped;
    }
    window.__rovaStopOrphanMedia = stopOrphans;
    window.__rovaTrackMedia = trackMedia;
    window.__rovaOrphanStats = function () {   // owner-visible: how many clips are tracked right now
      var det = 0, run = 0;
      for (var i = 0; i < mediaReg.length; i++) {
        var v = null; try { v = mediaReg[i].deref(); } catch (e) {}
        if (!v) continue;
        if (!v.isConnected) { det++; if (!v.paused) run++; }
      }
      return { supported: _hasWeakRef, tracked: mediaReg.length, detached: det, detachedPlaying: run };
    };
    /* THE SWEEP NEEDS A HEARTBEAT, not just the viewer's phase changes. Elements are detached by paths
       that have nothing to do with the viewer -- the landing grid's cell rotation is the measured one: it
       swaps a `.pcell` out on its own timer, and a preview that was still running got benched detached and
       kept its decoder (found by this guard's own stats on a browser-back run). Muted, so nobody hears it,
       but it is the same defect and the same class of leak the rest of this block exists to prevent.
       The interval is what BOUNDS how long an orphan can live, so it is short: a walk over a few dozen
       WeakRefs is microseconds, and it does nothing at all while the tab is hidden or nothing is tracked.
       Measured at 8s the browser-back case still had an orphan running seconds later; at 3s no sample
       ever caught one. */
    setInterval(function () {
      if (document.hidden) { return; }
      /* THE CEILING ON A SCREEN LOCK OUTLIVING ITS CLIP (2026-09-03). No new timer: this sweep
         already exists, already runs at the cadence a leak has to be bounded at, and already
         does nothing at all while the tab is hidden. wlTick is a walk of the document's <video>
         elements that returns on the first one being watched, so on the common case (something
         is playing) it is a handful of property reads plus at most one rect. It is ABOVE the
         mediaReg early-return
         deliberately: a permalink page with one <video> that this engine never tracked must
         still be swept, and that page is exactly where the owner's report came from. */
      wlTick();
      /* THE CEILING ON A CLIP DECODING BEHIND THE VIEWER (2026-09-08). Same argument as wlTick's,
         and the same timer: __rovaBgHold used to be a ONE-SHOT sweep at open+1500ms, so any clip
         started after it ran for the whole open (measured: an avatar 1146px off screen decoding 35 of
         45 seconds). Re-applying the state here bounds EVERY start path -- including ones written
         later, in other modules -- at 3s, without a second timer, a second observer or a second
         owner. Costs a `getElementsByTagName` walk only while the viewer is actually open. */
      if (bgOn && bgViewerUp()) { bgApply(true); }
      if (!mediaReg.length) { return; }
      stopOrphans();
    }, 3000);

    /* ---- "Tap for sound" pill (pfeed) ------------------------------------
       Unmuted autoplay needs a real user gesture, so the pfeed's clips often start MUTED (the browser
       vetoes pfSound's unmuted open on a direct link, and sound stays off until the user asks for it).
       Surface that state the Instagram way: a translucent pill on the centered playing clip; ONE tap
       unmutes -- a genuine gesture, so the browser allows it, volumechange flips soundOn, and from
       there sound FOLLOWS every clip as you swipe. Hidden the instant sound is on (or the clip is
       paused), and never shown outside the immersive viewer -- inline feed videos already have the
       corner mute button. */
    var sndPill = null;
    // True only when we can POSITIVELY tell the clip has no audio, so "Tap for sound" would be a lie and
    // we hide it. The reliable signal is data-noaudio, stamped server-side by ffprobe (VideoJobs); we also
    // honor the browser's own hints where they exist. UNKNOWN => assume it might have sound (show the pill)
    // so we never hide real audio. (webkitAudioDecodedByteCount is useless here: a MUTED clip never decodes
    // audio, and the pill only shows while muted.)
    function videoNoAudio(v) {
      // Trust ONLY the server-side ffprobe marker (data-noaudio), which is backfilled for every transcoded
      // clip. The browser heuristics we used before -- v.audioTracks.length===0 and mozHasAudio -- FALSE-
      // POSITIVED on clips that DO have audio: our videos play via HLS/MSE (they carry data-hls), and there
      // the element's own audioTracks list stays EMPTY even when the stream has sound, so a bogus "No audio"
      // tag landed on posts with audio. The marker is authoritative and comprehensive, so it's the only
      // signal we act on now.
      return !!(v && v.dataset && typeof v.dataset.noaudio !== 'undefined');
    }
    function updateSoundPill() {
      // AN OPEN IN FLIGHT IS NOT "NO SOUND" (2026-08-15). Every clip is deliberately muted for the few
      // hundred ms a hold lasts, which is exactly the state that offers this pill -- so without this
      // the viewer flashes "Tap for sound" on its way in and takes it away again. Release calls
      // applySound, which calls this, so the honest pill still appears the moment it is the truth.
      /* ...AND IT IS TESTED FIRST NOW, WHICH IS PURE REORDERING AND WORTH 198ms (2026-08-17).
         activeVideo() is a full geometry pass -- window.innerWidth/innerHeight, then a
         getBoundingClientRect over every `.post` to find the current one, then one more per candidate
         clip plus two inside onCurrentSlide. This function used to run it and THEN discover, on the very
         next line, that a hold was in force and the answer had to be thrown away. That is the whole
         flight: `soundHeld()` is true for every wake of it.
         And it is called from a document-level CAPTURE listener on `play` and `pause` for every <video>
         on the page (see below), so an open -- ~16 grid previews pausing, ~6 viewer clips starting --
         fires it dozens of times. MEASURED: 17 forced style+layout events, 198ms, all inside the hold.
         Nothing about the pill's behaviour moves: both statements were unconditional, and the branch
         that wins here removed the pill and returned without ever consulting `v`. */
      if (soundHeld()) { if (sndPill) { sndPill.remove(); sndPill = null; } return; }
      var pf = document.querySelector('.pfeed.show');
      var v = pf ? activeVideo() : null;
      if (!v || !v.muted || v.paused || videoNoAudio(v)) { if (sndPill) { sndPill.remove(); sndPill = null; } return; }
      var post = v.closest('.post');
      var unit = (post && post.querySelector('.post-main')) || v.closest('.cslide') || v.closest('.media');
      if (!unit) { if (sndPill) { sndPill.remove(); sndPill = null; } return; }
      if (sndPill && sndPill._v === v && sndPill.parentNode === unit) return;   // already up on this clip
      if (sndPill) sndPill.remove();
      sndPill = document.createElement('button');
      sndPill.type = 'button';
      sndPill.className = 'pf-sndpill';
      sndPill.setAttribute('aria-label', 'Unmute');
      sndPill.innerHTML = VC.muted + '<span>Tap for sound</span>';
      sndPill._v = v;
      sndPill.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();            // never falls through to play/pause or zoom
        v.muted = false;                                    // real gesture: volumechange -> soundOn = true
        soundGranted();                                     // ...and a gesture is the one thing that unlocks the engine
        pfLatch = true;                                     // remember: sound stays on for the rest of this pfeed session
        var p = v.play(); if (p && p.catch) p.catch(function () {});
        soundRepair(v);                                     // WebKit stops a clip unmuted out of the muted-autoplay allowance
        updateSoundPill();
      });
      unit.appendChild(sndPill);
    }
    // keep the pill honest as clips start/stop under autoplay (media events don't bubble: capture phase)
    /* COALESCED TO ONE PASS PER FRAME, and ONLY on this route (2026-08-17). A single open delivers a
       burst of play/pause events -- every grid preview pausing behind the overlay, every viewer clip
       starting in front of it -- and each one used to run activeVideo()'s full geometry pass in its own
       task. The pill is a purely visual affordance whose input (which clip is audible and muted) cannot
       change more than once per frame, so one pass per frame is the same answer for strictly less work,
       and at worst the pill appears one frame later than it would have.
       THE DIRECT CALLERS ARE DELIBERATELY NOT ROUTED THROUGH THIS. applySound's release, the gear
       setting, the pill's own click handler and the volumechange sweep all call updateSoundPill()
       synchronously because they are acting on a gesture or a state change the reader just caused, and
       those must repaint in the same task they were decided in. */
    var _spQ = 0;
    function soundPillSoon() {
      if (_spQ) { return; }
      _spQ = 1;
      /* rAF FIRST, TIMER ALWAYS -- the convention the pump's own schedulePump states, and it is load
         bearing rather than belt-and-braces: rAF does not fire in a backgrounded tab, so a rAF-only
         coalescer would latch `_spQ` at 1 the first time a clip paused behind a hidden tab and the pill
         would never be recomputed again for the life of the page. First one wins, the loser is a no-op. */
      var run = function () { if (!_spQ) { return; } _spQ = 0; updateSoundPill(); };
      if (window.requestAnimationFrame) { requestAnimationFrame(run); }
      setTimeout(run, 60);
    }
    document.addEventListener('play',  function (e) { if (e.target && e.target.tagName === 'VIDEO') soundPillSoon(); }, true);
    document.addEventListener('pause', function (e) { if (e.target && e.target.tagName === 'VIDEO') soundPillSoon(); }, true);

    /* ==================================================================================
       THE SCREEN STAYS AWAKE WHILE A CLIP IS BEING WATCHED, AND ONLY THEN (owner 2026-09-03)
       ==================================================================================
       "While watching a clip on the web app my phone went into sleep mode and stopped
        playing in my headphones at the gym."

       ...AND THE PREMISE WAS CORRECTED THE SAME DAY, WHICH MOVED THE RULE (owner, later):
       "I don't think it was about the audio, I was genuinely watching a video and the
        screen sleep came on." He was LOOKING at it. The sound was incidental -- he turns it
       on for some clips and not others -- so the first cut of this governor, which held the
       lock only for an UNMUTED clip, left the reported defect standing for every muted one.
       The two decisions are now split, because they are two different questions:
         - THE DISPLAY (this wake lock) asks "is the reader watching?" -- mute is irrelevant.
         - THE AUDIO (the Media Session below) asks "is the reader listening?" -- a muted clip
           must never claim the lock screen or Control Center, so that half stays narrow.

       TWO wake locks already existed and NEITHER covered that sentence, which is why this
       replaces both rather than adding a third:
         - keepAwake() in the feed header IIFE held a screen lock for the whole session and
           re-took it on every pointerdown/scroll/mousemove. It never asked whether anything
           was playing, so it burned the screen on a static timeline -- and it is bound to the
           header, so a permalink read on /p/<id> was not necessarily covered at all.
         - pfWakeOn/pfWakeOff in the viewer keyed on "the overlay is open", so it held the
           screen up over a PHOTO and let it go the instant the reader dismissed a clip that
           was still audible.
       Both are now thin callers into this one governor. ONE SENTINEL, ONE OWNER, in the same
       closure that already decides which clip is audible (applySound/activeVideo) and already
       tracks every element (trackMedia/stopOrphans).

       THE POPULATION IS EVERY <video> IN THE DOCUMENT, NOT A CLASS SELECTOR. That is the
       lesson of the 2026-09-01 double-audio ghost: `applySound`'s `.post .media video` could
       not see an unclassed <video> parented straight to <body>, and `stopOrphans`' detachment
       test could not see it either, because it was attached. A guard that selects by CLASS and
       a guard that selects by DETACHMENT do not compose into "all videos". This one asks the
       document for its videos and reads `paused`/`muted`/`volume` off the elements directly,
       so an unclassed clip cannot hide from it in either direction -- it cannot make the lock
       be missed, and (the half that matters more) it cannot leave one held.

       AND THE LOCK MAY NEVER OUTLIVE PLAYBACK. A screen held awake is the most expensive thing
       a web page can do to a phone (phone-heat-energy-evidence: the pathology is work that
       never lets the device return to idle), so every exit is covered twice over: the media
       events below, and the 3s sweep that already runs for stopOrphans -- which bounds a lock
       that outlives its clip at three seconds even if some future path invents an exit that
       fires no event at all.

       WHICH IS WHY DROPPING THE MUTE TEST IS NOT "ANY PLAYING VIDEO". Before today the site
       held a lock from page load for the life of the page, and taking that away was the
       battery win; a muted grid boomerang or a muted feed autoplay preview holding the screen
       would be that same bug wearing a new hat. So the display half is fenced to a VIEWER
       SURFACE -- a place the reader deliberately opened to watch one post -- and the fence is
       the selector the rest of this file already uses for exactly that idea, not a new one:
         - the immersive viewer, `.pfeed` (and only while it is `.show`n -- a closed viewer is
           still laid out at `position:fixed;inset:0`, so a rect test alone would call a clip
           in a dismissed overlay "on screen"), and
         - the permalink's OWN card, `[data-pfeed-open] > .post`. views/post_single.php marks
           that wrap and nothing else does; thread parts render inside .thread-chain so they
           are not direct children. This is the same test playIO's permalink branch uses to
           decline to pause a clip the reader is still reading (see :21351), and the same one
           the post page's other consumers use (:17805, :38864, :44676). ONE definition.
       A grid cell, a feed card, an avatar video and any muted background tile match neither,
       so they can never hold the screen no matter what they are doing.

       AND IT MUST ACTUALLY BE ON SCREEN. `document.hidden` covers the tab; inView() -- the
       pool's own rect + current-slide test, defined below in this same closure and used by
       every other playback decision here -- covers a clip that has been scrolled away from.
       Deliberately NOT a second IntersectionObserver: a governor with its own idea of
       "visible" is how two guards stop composing (see the class-vs-detachment note above).

       WHAT THIS CAN AND CANNOT DO ON iOS -- state it plainly, because the ceiling is real:
       a Screen Wake Lock stops the *idle* auto-lock timer. It does not survive the user
       pressing the side button, and iOS Safari PAUSES a <video> when the screen locks. So the
       Media Session below is the other half of the answer, not a nicety: with metadata and
       action handlers registered, the paused clip appears on the lock screen / Control Center
       and ONE tap on play resumes it -- and audio then continues with the screen dark. That
       is the ceiling of what a web page can do; background audio with no lock-screen tap is a
       native capability (see the app's UIBackgroundModes work). */
    var wlSentinel = null, wlReason = '', wlAcquiredAt = 0, wlPending = 0, wlFailAt = 0;
    function wlSupported() { return !!(navigator.wakeLock && navigator.wakeLock.request); }
    /* ---- THE IDLE BOUND (2026-10-02, Rob: "now my device doesn't ever lock ... make sure it's only while the app is
       currently open and being watched"). "A clip is playing on a viewer surface" was the whole predicate, and every
       viewer clip LOOPS (wire() sets loop on every post video), so a phone set down on an open viewer, a /p/ permalink,
       a live, or the Gift Lab (whose `.live-stage` holds the studio loop `#gstage-video`, measured holding the lock for
       the life of the page) never let the screen sleep at all. Watching is something a PERSON does, so the hold now
       also needs a recent touch -- the native idle timer's own rule, with a grace on top of it:
         - a clip in the viewer / on its permalink: 3 min after the last touch, or one whole pass of a LONG clip
           (duration x 1.1, capped at 15 min) so a 6-minute video is never cut off mid-watch;
         - lean-back surfaces -- a live stream, hands-free advancing on its own: 10 min after the last touch. Hands-free
           does NOT count as a touch: an automatic advance is exactly what runs on a phone nobody is holding.
       A touch is any trusted pointerdown/touchstart/keydown/wheel, a return to the tab (unlocking the phone is looking
       at it), or a lock-screen play. Past the window the lock is released by the existing 3 s heartbeat (wlTick) and
       the platform's own Auto-Lock takes over; the next touch re-acquires at once. Playback itself is untouched.
       `window.__rovaWakeIdleTest = {base, lean}` (ms) shortens both for the verification rig only. */
    var WL_IDLE_MS = 3 * 60 * 1000, WL_LONG_CAP_MS = 15 * 60 * 1000, WL_LEAN_MS = 10 * 60 * 1000;
    var wlTouchAt = Date.now(), wlIdled = 0;
    function wlTest(k, d) { var t = window.__rovaWakeIdleTest; return (t && t[k] > 0) ? t[k] : d; }
    function wlWindow(v) {
      if (wlSurface(v) === 'live' || (window.__rovaHfRunning && window.__rovaHfRunning())) return wlTest('lean', WL_LEAN_MS);
      var base = wlTest('base', WL_IDLE_MS), d = v ? v.duration : 0;
      return (d > 0 && isFinite(d)) ? Math.max(base, Math.min(WL_LONG_CAP_MS, d * 1100)) : base;
    }
    function wlIdleLeft(v) { return wlTouchAt + wlWindow(v) - Date.now(); }
    function wlTouch(e) {
      if (e && e.isTrusted === false) return;
      wlTouchAt = Date.now();
      if (wlIdled) { wlIdled = 0; wlSync(); }
    }
    ['pointerdown', 'touchstart', 'keydown', 'wheel'].forEach(function (ev) {
      document.addEventListener(ev, wlTouch, { capture: true, passive: true });
    });
    /* THE AUDIBLE CLIP -- now the AUDIO half only (the Media Session). UNCHANGED on purpose:
       a muted clip must not claim the lock screen, and it deliberately spans every surface,
       because a clip that is genuinely making noise is worth a Control Center entry wherever
       it lives. Resolved from the elements themselves, deliberately NOT activeVideo():
       that answers "which clip SHOULD carry the sound" from geometry, and can name a clip that
       is momentarily paused mid-swipe -- a fine answer for the sound handoff and the wrong one
       for a power decision. The only question here is "is audio actually coming out right
       now", so it is asked of the element: connected, running, unmuted, and at a volume the
       reader can hear. `ended` is tested explicitly because a non-looping clip that has run
       out reports paused only after the browser gets around to it. */
    function wlAudible() {
      var vids = document.getElementsByTagName('video');
      for (var i = 0; i < vids.length; i++) {
        var v = vids[i];
        if (!v || !v.isConnected) continue;
        if (v.paused || v.ended) continue;
        if (v.muted || !(v.volume > 0)) continue;
        return v;
      }
      return null;
    }
    /* THE FENCE: '' unless this clip is on a surface the reader deliberately opened to watch a
       post. Both selectors are borrowed, not invented -- see the block comment above for why
       that matters. `.pfeed` must be `.show`n: the overlay is position:fixed;inset:0 even when
       dismissed, so its rect is the whole viewport and inView() alone would say yes. */
    function wlSurface(v) {
      if (!v || !v.closest) return '';
      var pf = v.closest('.pfeed');
      if (pf) { return pf.classList.contains('show') ? 'pfeed' : ''; }
      if (v.closest('[data-pfeed-open] > .post')) return 'page';
      /* THE LIVE WATCH PLAYER (2026-09-19). This used to read `.live-go.is-live` -- the Phase 2 WEB
         BROADCASTER's own preview -- and that module was retired on 2026-09-12 when Rob made the web
         watch-only (Cloudflare yields no HLS and no recording for a WHIP-ingested input). Nothing has
         carried that class since, so the branch was dead code guarding a real feature: a viewer on
         /live/{id} got NO lock and the phone slept on them mid-stream. `.live-stage` is the watch
         page's own stage (`views/live_watch.php`, `.live-stage > video#live-player`) and is rendered
         nowhere else. Mute is deliberately NOT consulted here, as on every other surface: the player
         autoplays MUTED and someone watching a silent stream is still watching -- that is the exact
         2026-09-03 correction. Release needs nothing new: wlTick already drops the lock the moment the
         player pauses, ends, is detached or the tab hides, and the capture-phase `playing` listener
         already drives wlSync, so there is no new timer and no new listener. */
      if (v.closest('.live-stage')) return v.closest('.is-ended') ? '' : 'live';   // an ENDED live (or lab room) is not being watched live
      return '';
    }
    /* THE CLIP THE READER IS WATCHING -- the DISPLAY half, and the answer to the corrected
       report. Same live enumeration as wlAudible (every <video> the document has, never a class
       selector), same connected/running tests, and then the two extra questions a power
       decision has to ask that an audio decision does not: is this a viewer surface, and is it
       actually on screen. Mute and volume are NOT asked: he was watching. */
    function wlWatched() {
      var vids = document.getElementsByTagName('video');
      for (var i = 0; i < vids.length; i++) {
        var v = vids[i];
        if (!v || !v.isConnected) continue;
        if (v.paused || v.ended) continue;
        if (!wlSurface(v)) continue;
        if (!inView(v)) continue;
        return v;
      }
      return null;
    }
    /* The debug handle still says WHICH surface (`pfeed:<id>` / `page:<id>`) and now also
       whether the clip holding the screen is silent -- `pfeed:48667:muted` is the shape of the
       case this whole change exists for, so it must be readable at a glance. */
    function wlWhere(v) {
      if (!v) return '';
      // `#live-watch[data-id]` is the live stream's id holder (views/live_watch.php) -- without it the
      // handle reads `live:?`, which says nothing about WHICH stream is holding the screen.
      var post = v.closest ? v.closest('.post, .pcell, #live-watch[data-id]') : null;
      var id = post && (post.getAttribute('data-view') || post.getAttribute('data-id')) || '?';
      return (wlSurface(v) || 'other') + ':' + id + ((v.muted || !(v.volume > 0)) ? ':muted' : '');
    }
    function wlRelease() {
      var s = wlSentinel;
      if (!s) return;
      wlSentinel = null; wlReason = ''; wlAcquiredAt = 0;
      try { var r = s.release(); if (r && r.catch) { r.catch(function () {}); } } catch (e) {}
    }
    /* NEVER THROWS, NEVER SPINS. request('screen') rejects for reasons that are all normal and
       none of which are worth a retry loop: low battery, a hidden document, a NotAllowedError
       from a browser that has the API but is refusing right now. A refusal is silent and the
       next `playing` simply asks again.
       THE BACK-OFF IS KEYED TO A REFUSAL, NOT TO TIME SINCE THE LAST ATTEMPT. A flat "one
       request per 700ms" would throttle the case that matters -- pause, then resume half a
       second later -- and leave the reader unlocked until some later event happened to fire.
       Only a browser that has just SAID NO is worth pausing for, and that back-off is exactly
       what stops a burst of media events turning an instant rejection into a request storm. */
    function wlAcquire(v) {
      if (wlSentinel || wlPending || document.hidden || !wlSupported()) return;
      if (wlFailAt && (Date.now() - wlFailAt) < 700) return;
      wlPending = 1;
      var p = null;
      try { p = navigator.wakeLock.request('screen'); } catch (e) { wlPending = 0; return; }
      if (!p || !p.then) { wlPending = 0; return; }
      p.then(function (s) {
        wlPending = 0;
        /* THE REQUEST IS ASYNC, SO THE WORLD MAY HAVE MOVED WHILE IT WAS IN FLIGHT. A reader
           who taps pause (or closes the viewer) inside that window would otherwise be handed a
           lock with nothing playing behind it and nothing left to fire an event that releases
           it -- the exact "outlives playback" failure, arriving by the one route the event
           listeners cannot cover. Re-ask, and hand it straight back if the answer changed. */
        var still = wlWatched();
        if (document.hidden || !still || wlIdleLeft(still) <= 0) { try { s.release(); } catch (e) {} return; }
        wlFailAt = 0;
        wlSentinel = s; wlAcquiredAt = Date.now(); wlReason = wlWhere(still);
        try {
          s.addEventListener('release', function () {
            if (wlSentinel === s) { wlSentinel = null; wlReason = ''; wlAcquiredAt = 0; }
            wlTick();   // an OS interruption dropped it: if the clip is still running, ask again
          });
        } catch (e) {}
      }, function () { wlPending = 0; wlFailAt = Date.now(); });
    }
    /* ---- MEDIA SESSION: the lock screen is the other half of the fix ---------------------
       Armed by the same audible-clip resolution, so there is exactly one definition of "the
       clip the reader is listening to" for both mechanisms. It deliberately OUTLIVES a pause:
       when iOS locks the screen it pauses the element, and if the metadata went with it the
       lock-screen controls would disappear at precisely the moment they are the only way back.
       It is cleared when the clip is muted, detached (viewer close, recycle, retire) or
       stopped -- see wlTick. */
    var msVideo = null, msKey = '', msWired = 0;
    function msOk() { return !!(navigator.mediaSession && window.MediaMetadata); }
    function msSet(name, fn) {
      // An unsupported action throws TypeError from setActionHandler; that is not an error here.
      try { navigator.mediaSession.setActionHandler(name, fn); } catch (e) {}
    }
    function msSeek(delta) {
      var v = msVideo; if (!v) return;
      try {
        var d = v.duration;
        var t = v.currentTime + delta;
        if (t < 0) t = 0;
        if (d > 0 && isFinite(d) && t > d) t = d;
        v.currentTime = t;
      } catch (e) {}
      msPos();
    }
    /* NEXT/PREV ROUTE THROUGH THE VIEWER'S OWN step(), NEVER a scrollTop write of our own.
       step() is the path that wakes the chrome, suspends scroll-snap for its tween, and hands
       updateFeedBar() the post at the geometric crossover -- the 2026-09-01 fix for the bar
       naming the incoming author while the outgoing post still filled the screen. A second
       way to change post would be a second identity schedule, which is the defect that fix
       exists to close. If no viewer is open there is nothing to advance to and the handler is
       simply a no-op (the OS then shows the button greyed or ignores the press). */
    function msStep(dir) {
      if (!window.__rovaPfStep) return;
      try { window.__rovaPfStep(dir); } catch (e) {}
    }
    function msPos() {
      var v = msVideo;
      if (!v || !navigator.mediaSession.setPositionState) return;
      try {
        var d = v.duration;
        if (!(d > 0) || !isFinite(d)) { navigator.mediaSession.setPositionState(); return; }
        var t = v.currentTime; if (!(t >= 0)) t = 0; if (t > d) t = d;
        navigator.mediaSession.setPositionState({ duration: d, playbackRate: v.playbackRate || 1, position: t });
      } catch (e) {}
    }
    function msWire() {
      if (msWired || !msOk() || !navigator.mediaSession.setActionHandler) return;
      msWired = 1;
      msSet('play', function () {
        var v = msVideo; if (!v) return;
        wlTouchAt = Date.now(); wlIdled = 0;   // a lock-screen play is a touch
        try { var p = v.play(); if (p && p.catch) { p.catch(function () {}); } } catch (e) {}
        try { navigator.mediaSession.playbackState = 'playing'; } catch (e) {}
        wlTick();
      });
      msSet('pause', function () {
        var v = msVideo; if (!v) return;
        try { v._userPaused = 1; v.pause(); } catch (e) {}
        try { navigator.mediaSession.playbackState = 'paused'; } catch (e) {}
        wlTick();
      });
      msSet('stop', function () {
        var v = msVideo;
        if (v) { try { v._userPaused = 1; v.pause(); } catch (e) {} }
        msClear(); wlRelease();
      });
      msSet('seekbackward', function (d) { msSeek(-((d && d.seekOffset) || 10)); });
      msSet('seekforward',  function (d) { msSeek(+((d && d.seekOffset) || 10)); });
      msSet('seekto', function (d) {
        var v = msVideo; if (!v || !d || typeof d.seekTime !== 'number') return;
        try { v.currentTime = d.seekTime; } catch (e) {}
        msPos();
      });
      msSet('nexttrack',     function () { msStep(1); });
      msSet('previoustrack', function () { msStep(-1); });
    }
    /* ARTWORK COMES ONLY FROM URLS THE DOM IS ALREADY HOLDING. Do NOT hand-build a variant
       suffix here: a PNG's derived variant is a .jpg, so a constructed `_thumb.$ext` 404s
       (png-variant-jpeg-transcode, and the same rule is written at __rovaGridStampPhoto).
       The poster the <video> carries is always real and, on a video post, already decoded; a
       grid tile for the same post -- when one is on the page -- adds a genuinely smaller
       second entry the OS can prefer. blob: is excluded: it dies with the element that owns it. */
    function msArtwork(v, post) {
      var out = [], seen = {};
      function add(u, w, h) {
        if (!u || seen[u] || u.slice(0, 5) === 'blob:') return;
        seen[u] = 1;
        out.push({ src: u, sizes: (w > 0 && h > 0) ? (w + 'x' + h) : '512x512',
                   type: /\.png(\?|#|$)/i.test(u) ? 'image/png' : 'image/jpeg' });
      }
      add(v.getAttribute('poster') || v._posterStash || v.getAttribute('data-vposter') || '',
          parseInt(v.getAttribute('width'), 10) || v.videoWidth || 0,
          parseInt(v.getAttribute('height'), 10) || v.videoHeight || 0);
      var id = post && (post.getAttribute('data-view') || post.getAttribute('data-id'));
      if (id) {
        var tile = document.querySelector('.pcell[data-id="' + id + '"] img');
        if (tile) { add(tile.currentSrc || tile.getAttribute('src') || '', 0, 0); }
      }
      return out;
    }
    function msMeta(v) {
      var post = (v.closest && v.closest('.post, .pcell')) || null;
      var cap = '', name = '', handle = '';
      if (post) {
        var b = post.querySelector('.body');
        if (b) { cap = (b.textContent || '').replace(/\s+/g, ' ').trim(); }
        var nm = post.querySelector('.post-head .name');
        if (nm) { name = (nm.textContent || '').trim(); }
        var av = post.querySelector('.post-av');
        var m = av && (av.getAttribute('href') || '').match(/\/@([^\/?#]+)/);
        if (m) { try { handle = decodeURIComponent(m[1]); } catch (e) { handle = m[1]; } }
      }
      if (cap.length > 120) { cap = cap.slice(0, 119).replace(/\s+\S*$/, '') + '…'; }
      return { title: cap || name || 'Rova',
               artist: handle ? ('@' + handle) : (name || 'Rova'),
               album: 'Rova',
               artwork: msArtwork(v, post) };
    }
    function msApply(v) {
      if (!msOk()) return;
      msWire();
      msVideo = v;
      // Re-write the metadata only when the POST changes: a swipe fires a burst of media events
      // and constructing a MediaMetadata per event would re-hand the OS the same artwork to fetch.
      var post = (v.closest && v.closest('.post, .pcell')) || null;
      var k = (post && (post.getAttribute('data-view') || post.getAttribute('data-id'))) || (v.currentSrc || v.src || '');
      if (k !== msKey) {
        msKey = k;
        try { navigator.mediaSession.metadata = new window.MediaMetadata(msMeta(v)); } catch (e) {}
      }
      try { navigator.mediaSession.playbackState = 'playing'; } catch (e) {}
      msPos();
    }
    function msClear() {
      msVideo = null; msKey = '';
      if (!msOk()) return;
      try { navigator.mediaSession.metadata = null; } catch (e) {}
      try { navigator.mediaSession.playbackState = 'none'; } catch (e) {}
      try { if (navigator.mediaSession.setPositionState) navigator.mediaSession.setPositionState(); } catch (e) {}
    }
    /* THE ONE DECISION POINT. Both mechanisms are still resolved HERE, in the same task, off
       the same live enumeration -- what changed is that they are now resolved by two different
       predicates instead of one, because "watching" and "listening" are two different states
       and conflating them is the bug this pass fixes. They cannot drift: there is still exactly
       one place either question is asked. */
    function wlTick() {
      var w = wlWatched();                                   // DISPLAY: mute-agnostic, viewer surfaces only
      if (w && !document.hidden && wlIdleLeft(w) > 0) { wlIdled = 0; wlAcquire(w); if (wlSentinel) { wlReason = wlWhere(w); } }
      else { if (w && !document.hidden) { wlIdled = 1; } wlRelease(); }   // wlIdled: the next touch re-acquires at once
      var v = wlAudible();                                   // AUDIO: unmuted + audible, unchanged
      if (v) { msApply(v); return; }
      if (!msVideo) return;
      /* NOT AUDIBLE, but the session survives a pause on purpose -- that pause is what iOS does
         when the screen locks, and the lock-screen play button is the way back from it. It is
         only torn down when the clip has genuinely stopped being the thing being listened to:
         muted by the reader, ended, or gone from the document (viewer close, recycle, retire). */
      if (!msVideo.isConnected || msVideo.muted || msVideo.ended) { msClear(); return; }
      try { navigator.mediaSession.playbackState = msVideo.paused ? 'paused' : 'playing'; } catch (e) {}
    }
    /* Coalesced to one pass per frame, for the same reason soundPillSoon is: one viewer open
       delivers dozens of play/pause/volumechange events and the answer cannot change more than
       once per frame. rAF first, timer ALWAYS -- rAF does not run in a hidden tab, and the
       hidden tab is precisely when a release must still happen. */
    var _wlQ = 0;
    function wlSync() {
      if (_wlQ) return;
      _wlQ = 1;
      var run = function () { if (!_wlQ) return; _wlQ = 0; wlTick(); };
      if (window.requestAnimationFrame) { requestAnimationFrame(run); }
      setTimeout(run, 60);
    }
    // Media events do NOT bubble -- capture phase on document is how the whole engine hears them.
    ['playing', 'play', 'pause', 'ended', 'emptied', 'volumechange', 'abort', 'loadstart'].forEach(function (ev) {
      document.addEventListener(ev, function (e) {
        if (e.target && e.target.tagName === 'VIDEO') wlSync();
      }, true);
    });
    /* HIDDEN RELEASES SYNCHRONOUSLY, never through the coalescer. The browser drops the lock on
       a hidden document anyway, but our sentinel must not be left pointing at a dead one or the
       re-acquire on the way back is a no-op (`if (wlSentinel) return`). Coming back visible
       re-acquires only if a clip is genuinely still running, in view, on a viewer surface. */
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) { wlTouchAt = Date.now(); wlIdled = 0; }   // coming back to the tab IS looking at it
      wlTick();
    });
    // pagehide: the page is going away (navigation, tab closed, app swiped off). Nothing of it may stay on the lock
    // screen either -- the media session is cleared, not just paused (2026-10-02).
    window.addEventListener('pagehide', function () { wlRelease(); msClear(); });
    window.__rovaWakeSync = wlSync;     // viewer/open/close/step live in other closures
    window.__rovaWakeTick = wlTick;
    /* ---- NEVER AN AUTOMATIC PICTURE-IN-PICTURE (2026-10-02). A PiP window keeps a clip playing system-wide after
       the reader has left, so it may only ever exist because they ASKED for one: our own .vc-pip button stamps
       __rovaPipAsk(), and a tap on the platform's own PiP control happens while the page is still on screen. What
       is refused is the entry that rides on LEAVING -- iOS starts PiP by itself when the app is swiped away from a
       native-fullscreen clip ("Start PiP Automatically"), Chromium can do the same for `autopictureinpicture`. Such a
       window is paused and closed: the clip resumes inline on the way back through the hidden-tab resume path. */
    var pipAskAt = 0, pipHidAt = 0;
    window.__rovaPipAsk = function () { pipAskAt = Date.now(); };
    document.addEventListener('visibilitychange', function () { if (document.hidden) pipHidAt = Date.now(); });
    function pipEntered(v) {
      if (Date.now() - pipAskAt < 4000) return;               // our own PiP button: the reader asked
      setTimeout(function () {
        if (!document.hidden && !(pipHidAt && Math.abs(Date.now() - pipHidAt) < 2500)) return;   // entered on screen = a tap
        try { v.pause(); } catch (e) {}
        try { if (document.pictureInPictureElement === v && document.exitPictureInPicture) { var x = document.exitPictureInPicture(); if (x && x.catch) x.catch(function () {}); } } catch (e) {}
        try { if (v.webkitPresentationMode === 'picture-in-picture' && v.webkitSetPresentationMode) v.webkitSetPresentationMode('inline'); } catch (e) {}
        window.__rovaPipRefusedAt = Date.now();
        wlTick();
      }, 700);
    }
    document.addEventListener('enterpictureinpicture', function (e) {
      var v = e.target; if (v && v.tagName === 'VIDEO') pipEntered(v);
    }, true);
    document.addEventListener('webkitpresentationmodechanged', function (e) {
      var v = e.target; if (v && v.tagName === 'VIDEO' && v.webkitPresentationMode === 'picture-in-picture') pipEntered(v);
    }, true);
    Object.defineProperty(window, '__rovaWakeLock', {
      configurable: true,
      get: function () {
        var w = wlWatched();
        return { held: !!wlSentinel, reason: wlReason, acquiredAt: wlAcquiredAt,
                 supported: wlSupported(), pending: !!wlPending,
                 idle: { touchAt: wlTouchAt, idled: !!wlIdled, leftMs: w ? Math.round(wlIdleLeft(w)) : null, windowMs: w ? Math.round(wlWindow(w)) : null },
                 ms: { armed: !!msVideo, key: msKey,
                       state: (msOk() && navigator.mediaSession.playbackState) || 'none' } };
      }
    });

    /* ---- THE FIRST GESTURE PROMOTES THE CLIP THE READER IS ACTUALLY ON --------------------------
       The other half of the same report ("swiping down to other posts, I hear those"). A reader whose
       stored intent is already sound-on must not have to go and find the pill: the gesture they were
       making anyway -- the swipe, the tap that wakes the chrome -- is the exact thing WebKit is
       waiting for, so spend it, on the clip in view, in the only moment it counts.

       ON THE UP EDGE, NEVER TOUCH-DOWN. WebKit grants activation at touchend/click; a pointerdown
       arm would spend the reader's gesture on an attempt the engine was always going to refuse. That
       is the same rule amPendFire records for the music preview, read from the other end.

       Capture phase, no preventDefault and no stopPropagation: whatever the reader actually touched
       still does its own job. Two carve-outs, both measured hazards rather than tidiness:
         - IT STANDS DOWN FOR THE CONTROLS THAT OWN SOUND. Promoting under .vc-sound would unmute on
           pointerup and hand that button's own click handler an already-unmuted clip, which takes the
           ELSE branch -- a tap on UNMUTE that mutes, and writes rova_sound=0 on the way out.
         - IT MARKS WHAT IT PROMOTED (_sndPromotedAt) so the pfeed's tap-for-sound branch still reads
           that tap as a tap for SOUND instead of falling through to play/pause. A tap for sound is
           not a tap for stop.
       And it is granted by the play() PROMISE, never by the attempt: a refusal leaves the clip muted,
       leaves the pill up, and the next gesture simply tries again. Nothing here is a timer and
       nothing here retries on its own -- a reader's own gesture is the one input the policy wants. */
    function promoteSound(e) {
      if (sndUnlocked) return;
      if (!feedPref('soundfollow', true)) return;               // gear setting: manual sound only
      var pf = document.querySelector('.pfeed.show');
      /* SCOPED TO AN ALREADY-OPEN VIEWER (owner, 2026-08-2x: "the site nor the app should take over
         [background music] when just opening the app or site unless one of the videos are clicked to
         unmute"). This listener is registered on `document` for pointerup/touchend/click -- EVERY tap
         anywhere on the page, not just on a video or its sound control -- and until this line the only
         gate on spending one was `soundOn`, the site-wide preference PERSISTED in localStorage from any
         earlier session, ever. So: a member who unmuted a clip once, days ago, opens the ordinary
         timeline today with Spotify already playing, taps a Like button (or a nav link, or anything),
         and that ordinary unrelated tap silently unmuted + played() whatever grid clip happened to be
         topmost -- claiming the shared audio output and interrupting the phone's own music, with no
         gesture anywhere near a video. That is the mechanism the report describes: the feature this
         function exists for ("sound follows the feed") was never scoped to the feed the reader is
         actually watching. activeVideo() proves the reach -- with no `.pfeed.show` in the document it
         falls through to its TIMELINE branch and hands back the topmost PLAYING clip on the ordinary
         page, viewer or no viewer.
         So: only spend an ambient gesture -- one that landed somewhere other than a video's own sound
         control -- to CONTINUE sound inside a viewer session the reader already explicitly entered by
         tapping a specific video open (`pf` true, i.e. `.pfeed.show` is in the document). That is the
         swipe-through-the-viewer feature this function was built for (owner 2026-08-15: "swiping down
         to other posts, I hear those") and it is UNCHANGED here. What is removed is the ability for a
         tap that never touched a video at all, on a page that never opened one, to claim the output.
         The tap-that-opens-with-sound feature (soundArm/soundVoiceArm, above) is a SEPARATE mechanism
         keyed to the specific element the reader tapped, not to this document-wide listener, and is
         untouched by this gate -- tapping a video to open it still starts it with sound exactly as
         before. */
      /* ...AND THAT GATE IS LIFTED FOR THE TIMELINE ON 2026-09-26, BY THE SAME OWNER, WHO NOW ASKS FOR
         THE OPPOSITE: "Videos should play automatically unmuted on the web app ... only way I should see
         muted stuff on the web app in feeds is if the person pressed mute." Sound is ON by default
         (sndPref), and a browser will not let a page make sound before its first activation -- so the
         first tap, click or key anywhere on the page is spent HERE, inside the gesture, on the timeline's
         playing card (tlSlot), which is the one write WebKit honours. Everything else in this function is
         unchanged and still applies: the grant is read off the play() promise, the sound controls keep
         their own taps, and it retires itself the moment the engine has said yes (sndUnlocked, and the
         listeners come off in soundGranted). A reader who pressed mute (rova_sound=0) is never touched:
         soundOn is false and the next line returns.
         The iOS app keeps one exception -- another app's audio playing at launch starts that session
         muted. A web page cannot see other apps' audio, so there is no web equivalent to honour. */
      if (!(soundOn || (pf && pfLatch))) return;                // no stored intent: the pill IS the right answer
      if (e && e.type === 'keydown' && (e.key === 'Escape' || e.key === 'Tab' || e.metaKey || e.ctrlKey || e.altKey)) return;   // not an activation
      if (e && e.target && e.target.closest
          && e.target.closest('.vc-sound, .pf-sndpill, .pf-tapplay')) return;
      /* A SILENT playing card is still an element the gesture can be spent on (2026-09-26): the unlock is
         page-wide, and the next card the reader scrolls to may well have audio. Unmuting a clip with no
         audio track makes no sound either way; its song, if it has one, is the music module's (amPend). */
      var v = activeVideo();
      /* NO PLAYING CARD YET IS NOT A REASON TO WASTE THE TAP (2026-09-26). The first tap on a profile
         usually lands while the header is still on screen and no clip is 50% visible -- MEASURED on
         /@riemoh: the tap spent on nothing, sndUnlocked stayed false, and every card the reader then
         scrolled to played silent until a SECOND tap. The unlock is page-wide, so it is taken on any
         timeline clip there is and the element is handed back exactly as found: muted the stamped way
         (the pref never hears of it), and paused again if it was paused (that pause's AbortError is our
         own, which armSettle counts as the grant). The playing card then gets its voice from
         applySound at the next settle, with no gesture needed. */
      if (!v && !pf) {
        var any = null, cands = document.querySelectorAll(SEL);
        for (var ci = 0; ci < cands.length && !any; ci++) { if (!(cands[ci].closest && cands[ci].closest('.pfeed'))) { any = cands[ci]; } }
        if (!any) return;
        var wasP = any.paused, pa = null;
        if (any.muted) { any.muted = false; }                   // in-gesture: lifts the AUDIO restriction
        try { pa = any.play(); } catch (er) { pa = null; }      // ...and the PLAYBACK one
        engineMute(any, true);
        if (wasP) { try { any.pause(); } catch (er) {} }
        armSettle(any, pa, applySound);
        return;
      }
      if (!v || (pf && videoNoAudio(v))) return;                // (the viewer's tap-for-sound reading stays as it was)
      if (!v.muted) { soundGranted(); applySound(); return; }   // already audible: just record that it is
      /* THE GRANT IS TAKEN ON EVERY EDGE; THE SOUND IS KEPT ONLY ON THE ONE THE OPENERS SHARE
         (owner 2026-08-15, third pass -- the "CD skip"). This runs in the CAPTURE phase on
         pointerup, touchend AND click, so on a tap that opens the viewer it fires on touchend first
         and unmutes the card the reader is lifting off -- and the opener does not run until the
         CLICK, tens of milliseconds later. MEASURED: the card's master clip audible from +59ms while
         the viewer rendered its own copy of the same file and started it at 0. Two voices, one file.
         So the earlier edges take the permission and hand the element straight back muted, exactly
         as soundArm does, and only the CLICK edge -- the same task any opener runs in, so a hold can
         mute it again with nothing rendered in between -- leaves the clip speaking. A tap that opens
         nothing is unchanged: its click edge is the one that lands. A SWIPE (which never produces a
         click) still buys the permission, and applySound's next pass -- the viewer syncs it per rAF
         -- turns the sound on a frame later without needing a gesture, because by then the page is
         unlocked. And during a hold nothing is kept at all. */
      // (a KEY is its own single edge -- there is no click behind it to wait for)
      var keep = !!(e && (e.type === 'click' || e.type === 'keydown')) && !soundHeld();
      if (v.paused && v._userPaused) return;                    // a clip the reader paused is not asked to start
      v._sndPromotedAt = Date.now();
      v.muted = false;                                          // INSIDE the gesture: the only write WebKit honours
      var p = null;
      try { p = v.play(); } catch (er) { p = null; }
      if (!keep) { engineMute(v, true); }                       // permission taken; the element handed back as found
      armSettle(v, p, applySound);                              // ...and an abort is not a refusal (see armSettle)
      if (keep) { soundRepair(v); }                             // WebKit STOPS a clip unmuted out of the muted-autoplay allowance
      /* AUTOMATIC vs EXPLICIT (Rob 2026-09-29, iOS build 533). A promotion is sound FOLLOWING THE PLAYING
         CARD -- an automatic unmute, whose fold/roll hold is capped at 5 s (see THE AUDIBLE CLIP'S HOLD HAS A
         LENGTH, next to engVideo) -- unless the gesture landed ON this clip's own media box: that is the
         member tapping the video to hear it, the explicit hold. A tap anywhere else stays automatic. */
      if (keep && e && e.target && e.target.closest && window.__rovaSndHand) {
        var pmb = v.closest && v.closest('.media');
        if (pmb && pmb.contains(e.target)) { try { window.__rovaSndHand(v); } catch (erh) {} }
      }
      updateSoundPill();
    }
    /* keydown joined 2026-09-26 (Rob: unmute at the first "tap, click or key"). The listeners come off
       in soundGranted once the engine has said yes -- one activation's worth, never a standing tax. */
    var PROMOTE_EVT = ['pointerup', 'touchend', 'click', 'keydown'];
    PROMOTE_EVT.forEach(function (ev) {
      document.addEventListener(ev, promoteSound, true);
    });

    /* ---- adaptive streaming: prefer the HLS ladder, fall back to the mp4 --
       A feed <video data-hls="...master.m3u8"> keeps its mp4 src + poster as the
       universal fallback. Safari/iOS play HLS natively (just swap the src);
       everyone else gets hls.js, lazy-loaded on first need so pages with no video
       never pay for it. If hls.js fails to load or errors, the mp4 src plays on,
       exactly like before. hls.js does the bitrate switching (capped to the
       element size, so small feed players pull the light rungs, saving data). */
    var HLS_JS = '/assets/hls.min.js';
    function loadHlsLib(cb) {
      if (window.Hls) { cb(); return; }
      if (loadHlsLib._q) { loadHlsLib._q.push(cb); return; }
      loadHlsLib._q = [cb];
      var s = document.createElement('script');
      s.src = HLS_JS; s.async = true;
      s.onload = function () { var q = loadHlsLib._q; loadHlsLib._q = null; q.forEach(function (f) { f(); }); };
      s.onerror = function () { loadHlsLib._q = null; };   // stay on the mp4 fallback
      document.head.appendChild(s);
    }
    /* IS THIS CLIP ACTUALLY ON SCREEN?  The test was VERTICAL-ONLY, and a multi-media post pages
       its slides SIDEWAYS inside an `overflow:hidden` `.media` box -- so every off-slide clip in a
       carousel sat dead-centre vertically and read as "in view" while being completely invisible.
       Measured on /@grindhd post 15076 (five video slides): the `canplay` restart in buildControls
       calls play() on anything inView(), so ALL FIVE clips were started and all five issued an
       open-ended `bytes=0-` progressive fetch at once -- 119MB of Content-Length in flight on one
       card, with the clip the reader is actually watching competing against its own siblings for
       the radio.  That starvation IS the "hangs for a second when swiping" the owner reported.
       The horizontal half is measured against the CAROUSEL's own clip box (not the viewport,
       which is what the pfeed branch of activeVideo() uses) because that is the box doing the
       clipping; 55% mirrors playIO's threshold so the two agree about which slide is current. */
    /* The HORIZONTAL half on its own: "is this clip the slide its gallery is currently showing?"
       Split out because the pfeed's drag-reveal needs exactly this test and must NOT apply the
       vertical one (a clip mid-vertical-swipe is legitimately half off screen -- that is the whole
       point of the drag-reveal). A clip that is not in a gallery has nothing to be paged past. */
    function onCurrentSlide(v) {
      var box = v.closest && v.closest('.media.carousel');
      if (!box) return true;
      var r = v.getBoundingClientRect();
      if (!r.width) return false;
      var br = box.getBoundingClientRect();
      return (Math.min(r.right, br.right) - Math.max(r.left, br.left)) >= r.width * 0.55;
    }
    function inView(v) {
      var r = v.getBoundingClientRect();
      if (!(r.top < innerHeight * 0.9 && r.bottom > innerHeight * 0.1)) return false;
      return onCurrentSlide(v);
    }
    // Safari's HLS engine (AVPlayer under the hood) makes its own internal call on how eagerly to
    // buffer a <video>, and largely ignores preload="auto" for adaptive-streaming sources regardless
    // of connection speed -- confirmed still showing a loading spinner on fast wifi even with the
    // margins above. A plain fetch() bypasses the <video> element entirely but still populates the
    // SAME shared HTTP cache it reads from, so by the time it actually asks for these URLs (at
    // playtime) they're already sitting there instead of triggering a fresh network round-trip.
    // Manifests only (master + every variant) -- small text files, cheap even if never played; the
    // actual segment bytes are NOT prefetched here, that would risk real wasted bandwidth.
    // Manifests are fetched with cache:'reload' (bypass the browser HTTP cache on the way IN, then
    // refresh it) so a manifest that was cached BEFORE the CDN's CORS header was fixed -- stored
    // immutable-for-a-year WITHOUT Access-Control-Allow-Origin, which a cross-origin fetch then reuses
    // and rejects ("blocked by CORS / no ACAO header") -- is replaced by a fresh, correct copy instead
    // of being replayed from cache forever. The playlists are tiny so re-fetching them costs nothing;
    // the big first SEGMENT below stays cache-friendly (default) to keep its instant-start warming.
    var MF = { credentials: 'same-origin', cache: 'reload' };
    var mfWarmed = {};                 // once per clip per session: re-warming on every pass was a fetch storm
    function prefetchHlsManifests(url) {
      // Dedupe (round 129): warmIO used to re-run this on EVERY approach of EVERY clip -- master + every
      // variant (cache:'reload' -> real network hits) + the first segment, so a rapid swipe burst fired
      // dozens of fetches that competed with the clip actually being watched. Once per URL is plenty: the
      // point is CORS-warming the HTTP cache for a stall->HLS recovery, and the cache keeps it.
      if (mfWarmed[url]) return;
      mfWarmed[url] = 1;
      // rfetch: a deadline + a REJECT on non-2xx. Without both, a manifest lost to a tunnel left
      // mfWarmed[url] claimed for the rest of the session (the dedupe above is "once per clip, ever"),
      // so one bad moment permanently un-warmed that clip -- the stall->HLS recovery this exists for
      // then paid the full manifest handshake at the exact moment the line was already struggling.
      rfetch(url, MF, 8000).then(function (r) { return r.text(); }).then(function (text) {
        if (!text) return;
        text.split('\n').forEach(function (line) {
          line = line.trim();
          if (!line || line.charAt(0) === '#') return;
          try { fetch(new URL(line, url).href, MF).catch(function () {}); } catch (e) {}
        });
        /* THE FIRST-SEGMENT WARM USED TO LIVE HERE, AND IT COULD NOT BE CONSUMED (removed 2026-08-09).
           It pulled the startup variant's opening .ts (measured on this corpus: 211KB at the 360p rung,
           646KB at 720p, 1.16MB at 1080p) to kill the opening spinner -- correct when attachHls() still
           ran as a clip came into view. It no longer does: _instant is re-stamped on EVERY become-current
           path (playIO's calmPlay, __rovaPlayNow, the grid/carousel donors), so attachHls()'s first guard
           short-circuits and the ONLY live caller left is wire()'s sustained-stall recovery.
           That makes the segment warm unconsumable TWICE OVER:
             (1) IT IS SPENT WHERE IT CANNOT BE USED. The warm is gated on !netIsSlow(), so it only fires
                 on a FAST line -- exactly the line on which the mp4 will not stall and HLS will therefore
                 never attach. On the slow line that does attach, the warm was skipped.
             (2) IT WARMED THE WRONG RUNG. The stall recovery sets v._stalled = 1 before calling attachHls,
                 which then picks the LOW-first master (data-hls-lo) whose startup variant is 360p. The warm
                 ran earlier, with _stalled still 0, so it fetched the SHARP master's startup variant (720p).
                 Different file; the cache entry was never read.
           Measured cost of keeping it: 1.87MB of .ts on one guest /feed scroll and 4.64MB across /p/15640
           plus five swipes -- none of it decoded, and it counted against the concurrent byte-bearing
           request budget (the /feed peak of 3 was mp4 + mp4 + an unused .ts).
           The PLAYLISTS above are kept: ~5KB of text per clip, they are what the stall recovery actually
           opens with, and a line can degrade between this warm and the stall. Bytes are not warmed for a
           path that only runs once the line has already proven it cannot carry bytes. */
      }).catch(function () { mfWarmed[url] = 0; });   // release the once-per-session claim: a failed warm must be retryable
    }
    // Measured recent download speed (bits/sec, 0 = unknown): median over the last ~45s of
    // real network transfers big enough to time honestly (>=40KB, not cache hits). The pfeed
    // constantly pulls posters/photos, so on any active session there are fresh samples. This
    // is the only bandwidth signal available on iOS Safari (no navigator.connection there),
    // and it's what decides sharp-start vs blurry-fast-start below.
    function netBps() {
      try {
        var es = performance.getEntriesByType('resource'), now = performance.now(), got = [];
        for (var i = es.length - 1; i >= 0 && got.length < 8; i--) {
          var en = es[i];
          if (now - en.responseEnd > 45000) break;                      // older entries are staler still
          if (!en.transferSize || en.transferSize < 40000) continue;    // cache hit / too small to time
          var dur = en.responseEnd - en.startTime;
          if (dur < 50) continue;
          got.push(en.transferSize * 8000 / dur);
        }
        if (!got.length) return 0;
        got.sort(function (a, b) { return a - b; });
        return got[Math.floor(got.length / 2)];
      } catch (e) { return 0; }
    }
    function netIsSlow() {
      var b = netBps();
      if (!b && navigator.connection && navigator.connection.downlink) b = navigator.connection.downlink * 1e6;
      return b > 0 && b < 1600000;   // under ~1.6Mbps even the 540p rung (1.65M peak) can't stream in real time
    }
    // PUBLISHED (2026-07-29). Every OTHER bandwidth guard in this file was written against
    // navigator.connection -- which Safari does not implement, so all of them are no-ops for the entire
    // iPhone population (scroll RUM: 14,617 of 19,655 samples, 1,396 uids, report no `conn` at all). The
    // timing fallback above is the only bandwidth signal iOS actually has and it was already measured
    // working here, so the rest of the file routes through it rather than re-deriving it. Note it needs
    // REAL SAMPLES: it answers 0/false until a >=40KB transfer has been timed, so callers must ask it per
    // job, at the moment the bytes would be spent -- never once at load time.
    // ...and it EXPIRES, which callers must not read as "the link got better". Measured on the live grid
    // at 1.5Mbps: of 51 resource-timing entries, exactly TWO clear the >=40KB floor -- app.js and
    // rova.css from the initial load (every grid thumbnail is 3-20KB on the wire since the variants
    // backfill). Those two age out of the 45s window and netBps() then returns 0, i.e. "unknown", which
    // netIsSlow() reports as false. So ~45s into a grid session the bandwidth signal silently vanishes
    // and every gate hanging off it stands down -- on the same link, with nothing having changed.
    // The published wrapper is therefore STICKY: a definite reading is remembered for 90s and reused when
    // there are no fresh samples. Absence of evidence isn't evidence of a fast line. 90s, not longer,
    // because the verdict has to be able to go stale: someone who walks from LTE onto wifi should not be
    // throttled by a reading from minutes ago.
    // Deliberately NOT applied to the local netIsSlow() above: that one picks the HLS ladder (attachHls),
    // it is carefully tuned, and this pass has no mandate to change which rung a clip opens on.
    //
    // BRANCH ORDER IS DELIBERATE (2026-09-11) -- do not "tidy" the navigator.connection test back above
    // the sticky reuse. It sat there until 2026-09-11, and that made the 90s memory UNREACHABLE on every
    // Chrome/Android client. MEASURED 2026-09-10 (scratchpad/connprobe.js, headless Chromium, /p/49652
    // held at 1.2Mbps/250ms via CDP, asked every 20s): navigator.connection.downlink reported 9.4Mbps
    // for the ENTIRE run on a line that was actually 1.2Mbps -- Chrome's estimate is the best throughput
    // it has recently observed, capped at 10, and a congested radio does not move it. With the estimate
    // asked before the memory, this wrapper answered true at 10/30/50s (fresh >=40KB samples) and then
    // FALSE at 70s and 90s the moment the last sample aged out of netBps()'s 45s window: every gate
    // hanging off it (pfBytesIO, lineIsTight, slowNow, calmWarm's neighbour tier) stood down ~45s into
    // a session on the same bad link. Re-measured after the reorder: true at 70s and 90s, and back to
    // false within the 90s memory once the throttle was lifted.
    // So the ranking is: (1) a fresh measurement; (2) a definite measurement from the last 90s;
    // (3) the browser's own estimate, as a last resort when nothing has been measured recently -- it is
    // an opinion about the recent BEST, not the current line, so it must never outrank a reading.
    // Safari has no navigator.connection at all, so (3) is a no-op there and nothing changed on iOS.
    var _slowSeen = 0, _slowVal = false;
    window.__rovaNetBps = netBps;
    window.__rovaNetSlow = function () {
      var b = netBps();
      if (b > 0) { _slowSeen = Date.now(); _slowVal = b < 1600000; return _slowVal; }   // (1) fresh measurement
      if (Date.now() - _slowSeen < 90000) { return _slowVal; }                          // (2) definite reading, <90s old: reuse
      if (navigator.connection && navigator.connection.downlink) {                       // (3) Chrome/Android estimate, last resort
        return navigator.connection.downlink * 1e6 < 1600000;
      }
      return false;                                                                       // nothing known: give up
    };
    /* Snapshot a clip's playback position across a SOURCE SWAP and put it back.
       Both HLS paths below replace the element's source, which resets currentTime to 0. On the
       stall-recovery path that rewinds a clip the member is actively watching, and it wipes any
       resume seek that deliberately put them mid-clip: the grid tap (__rovaGridSeek), the
       fullscreen hand-off, and an embed's "Continue on Rova" (#t=). Call it BEFORE the swap; call
       the returned function after, and it re-seeks once the new source reports metadata.
       A clip sitting at the very end is left to restart -- the same rule pfResume uses. */
    function keepPos(el) {
      var want = 0;
      try { want = el.currentTime || 0; } catch (e) {}
      if (!(want > 0.25) || !isFinite(want)) { return function () {}; }
      var dur = el.duration || 0;
      if (dur && isFinite(dur) && want >= dur - 0.3) { return function () {}; }
      return function () {
        // Wait for the NEW source to announce itself. Polling readyState was the trap: for a beat after
        // attachMedia() the element still reports the OLD source's readyState 4 and the OLD currentTime,
        // so the poll "succeeded" without seeking and hls.js then reset the clip to 0 anyway (measured:
        // a resumed clip landed back at 0 on a slow line). loadedmetadata on the new source is the only
        // honest signal that the swap has actually happened.
        var done = false;
        function seek() {
          if (done) { return; }
          done = true;
          try { el.removeEventListener('loadedmetadata', seek); } catch (e) {}
          try {
            var d = el.duration || 0;
            // only if the swap really lost the position -- never a gratuitous micro-seek
            if ((!d || !isFinite(d) || want < d - 0.3) && Math.abs((el.currentTime || 0) - want) > 0.5) {
              el.currentTime = want;
            }
          } catch (e) {}
        }
        try { el.addEventListener('loadedmetadata', seek); } catch (e) { return; }
        setTimeout(function () {                       // never leave a listener armed forever
          if (done) { return; }
          done = true;
          try { el.removeEventListener('loadedmetadata', seek); } catch (e) {}
        }, 20000);
      };
    }
    /* Restart a clip that a SOURCE SWAP just paused.
       Our clips carry no `autoplay` attribute (see views/_post.php: controls playsinline muted loop
       preload=metadata) -- playback is entirely JS-driven. So assigning a new .src pauses the element
       and it stays paused until something calls play() again. The hls.js branch already does that on
       MANIFEST_PARSED; the NATIVE branch did not, so a clip the member was watching went paused at
       readyState 0 and sat dark until some unrelated scroll happened to nudge it. Measured on a 3Mbps
       line: 14 seconds of dead player. That hits EVERY engine that takes the native path, iOS included.
       This is the missing half of that pair, and nothing more.
       It only ever calls play(). It never reverts the source, so a slow line (where the mp4 was already
       stalling, which is WHY we swapped to the ladder) can never be kicked back onto the heavier file
       by a timer. Bounded, one-shot, and it stops the moment the clip is moving again. */
    function resumeAfterSwap(v, wasPlaying) {
      if (!wasPlaying) { return; }
      var done = false, n = 0;
      function stop() {
        done = true;
        try { v.removeEventListener('loadedmetadata', attempt); } catch (e) {}
        try { v.removeEventListener('canplay', attempt); } catch (e) {}
      }
      function attempt() {
        if (done) { return; }
        if (v._released || v._userPaused || !feedPref('autoplay', true)) { stop(); return; }
        if (!v.paused) { stop(); return; }             // already moving again: nothing to do
        if (v.readyState < 1) { return; }              // new source has no metadata yet: keep waiting
        if (!inView(v)) { stop(); return; }            // scrolled off meanwhile: playIO owns it now
        var p = v.play();
        if (p && p.catch) {
          p.catch(function () {                        // unmuted autoplay vetoed -> muted retry, same as pfSound
            if (v.muted) { return; }
            applying = true; v._engineSetAt = Date.now(); v.muted = true; applying = false;
            var p2 = v.play(); if (p2 && p2.catch) { p2.catch(function () {}); }
          });
        }
        stop();
      }
      try { v.addEventListener('loadedmetadata', attempt); } catch (e) {}
      try { v.addEventListener('canplay', attempt); } catch (e) {}
      // bounded backstop for engines that swallow the events. ONLY this chain re-schedules, so an
      // event-driven attempt() can never fork a second timer.
      (function tick() {
        if (done) { return; }
        attempt();
        if (done) { return; }
        if (n++ < 200) { setTimeout(tick, 150); } else { stop(); }   // ~30s ceiling, then give up quietly
      })();
    }
    function attachHls(v) {
      /* _instant: the just-TAPPED clip is playing its plain mp4 for a grid-hover-fast open. Don't swap it to
         the HLS manifest -- that manifest+playlist+segment handshake (plus loading hls.js off Safari) is the
         ~second of "loading" that made the tapped clip open slower than its own instant hover preview.

         THIS FUNCTION IS REACHED ONLY FROM wire()'s SUSTAINED-STALL RECOVERY, AND THAT IS DELIBERATE
         (audited 2026-08-09 -- the note this replaces claimed the clip "upgrades to adaptive HLS the next
         time it re-enters view", which has been FALSE since the mp4-first round and sent an investigation
         hunting a broken attach that was never going to happen). playIO's calmPlay re-stamps _instant = 1
         on EVERY become-current, before playing, so the scroll-away clear at the pause branch is undone the
         moment the clip comes back; __rovaPlayNow and the grid/carousel donors stamp it too. Every
         pre-emptive call site was removed on purpose, so the guard below is what makes mp4-first true.

         WHY MP4-FIRST STAYS THE DEFAULT, IN BYTES, measured over all 391 laddered clips on this box:
         the rung ABR actually settles on is HEAVIER than the whole progressive mp4. Mean rung/mp4 size
         ratio 360p 0.52x, 540p 0.97x, 720p 1.66x, 1080p 2.06x -- and the 720p rung, which is the SAME
         720x1280 the mp4 already is, exceeds the entire mp4 on 241 of 363 clips (66%). It holds in every
         duration bucket (720p ratio 1.61x under 15s, 1.49x at 15-30s, 1.73x at 30-60s, 1.84x at 1-2m,
         2.09x at 2-5m), so there is no clip length at which switching becomes a byte win -- the ladder's
         top rungs are re-encodes above the source's own bitrate. Only the 360p rung is genuinely light,
         and the ONE case that wants it is a line too slow for the mp4: exactly what the stall recovery
         hands us, with _stalled = 1 selecting the low-first master below. (Origin load is NOT the reason:
         data-hls resolves through media_url() to media.rovasocial.com, i.e. R2 behind Cloudflare, and .ts
         there measures cf-cache-status MISS then HIT on refetch with a year-long immutable TTL. The PHP
         origin serves no HLS at all.) Re-run the numbers before making this pre-emptive. */
      if (v._hlsWired || v._instant || !v.dataset || !v.dataset.hls) return;
      // SLOW LINE (measured, or this clip's fast mp4 already stalled -> v._stalled): prefer the
      // low-first master twin. Safari/iOS native HLS opens on the FIRST listed variant with no
      // client knob, so on a weak signal the sharp-start master (720p first) means a megabyte-plus
      // black stall; the _lo twin starts on the ~370KB 360p rung -- blurry but PLAYING -- and the
      // native ABR sharpens it from there. Fast lines keep the sharp-start master exactly as before.
      var url = (v.dataset.hlsLo && (v._stalled || netIsSlow())) ? v.dataset.hlsLo : v.dataset.hls;
      var mp4src = v.getAttribute('src');                    // remember the fallback before anything swaps it
      // canPlayType is TRUSTWORTHY here: measured on Chromium 149 and WebKit, a browser that claims
      // the HLS MIME really does play master.m3u8 natively (Chromium has shipped a built-in HLS
      // demuxer). So the ordering below is unchanged -- iOS, where there is no MSE and native is the
      // ONLY option, keeps exactly the path it has always taken.
      var wasPlaying = !v.paused && !v.ended;                 // capture BEFORE the swap pauses it
      if (v.canPlayType('application/vnd.apple.mpegurl')) {   // Safari / iOS: native ABR, no library
        v._hlsWired = 1;
        var restoreNative = keepPos(v);
        // COVER FIRST. The comment used to say "poster stays" -- it does in Blink, and in WebKit the
        // load algorithm restores the show-poster flag so the card SNAPS BACK to frame 0 while the
        // manifest opens. Either way the reader loses the picture they were watching on a fully
        // visible card. Raise the cover and hold the clip: the swap now happens behind a still.
        tlHold(v);
        v.src = url;                                          // swap mp4 -> manifest (cover holds)
        restoreNative();
        resumeAfterSwap(v, wasPlaying);                       // the swap paused it; start it again
        v.addEventListener('error', function () {             // manifest hiccup: hard-fall-back to the mp4
          if (mp4src && v.getAttribute('src') !== mp4src) {
            var back = keepPos(v);
            tlHold(v);                                        // same swap, same cover
            v.src = mp4src; try { v.load(); } catch (e) {}
            back();
            resumeAfterSwap(v, wasPlaying);
          }
        });
        return;
      }
      v._hlsWired = 1;
      loadHlsLib(function () {
        if (!window.Hls || !Hls.isSupported() || v._hls) return;   // mp4 src remains the fallback
        // abrEwmaDefaultEstimate: the bandwidth hls.js ASSUMES before it has measured anything, which
        // is what picks the very first segment's quality. The library default (~500kbps) cold-started at
        // 360p (pixelated openings); 2.6Mbps got 540p. Raised to 5Mbps so a cold start opens at 720p
        // (peak ~3.1Mbps) on a decent line -- no low-quality opener on fast wifi -- then ABR still climbs
        // to 1080p from real measurements and, if the line is actually slow, drops on the first stall.
        // capLevelToPlayerSize keeps it from wasting bytes on a rung larger than the element.
        // Seed the pre-measurement estimate from what THIS session actually measured (netBps): on a
        // slow line the 5Mbps assumption cold-started at 720p and stalled exactly like Safari; a real
        // sample picks a rung the connection can carry. Unknown (no samples) keeps the fast default.
        var est = 5000000, mbps = netBps();
        if (mbps > 0) est = Math.max(400000, Math.min(5000000, Math.round(mbps * 0.8)));
        // maxMaxBufferLength is the REAL forward ceiling (see rmAttach): with only maxBufferLength set, hls.js
        // buffers max(maxBufferLength, 8 * maxBufferSize / bitrate) -- minutes at a low rung -- clamped only by
        // the 600 s default. backBufferLength defaults to Infinity in hls.js 1.5, so everything already played
        // also stayed in the SourceBuffer. Both bounded, as remoteHls does (2026-10-08 memory work).
        var h = new Hls({ capLevelToPlayerSize: true, maxBufferLength: 20, maxMaxBufferLength: 30,
                          backBufferLength: 30, startLevel: -1, abrEwmaDefaultEstimate: est });
        h.on(Hls.Events.ERROR, function (evt, data) {
          if (!data || !data.fatal) return;
          try { h.destroy(); } catch (e) {}
          v._hls = null;
          if (mp4src) {                                    // hls.js replaced src; restore the mp4
            var back = keepPos(v);
            tlHold(v);
            v.src = mp4src; try { v.load(); } catch (e) {}
            back();
            resumeAfterSwap(v, wasPlaying);                // this swap pauses it too
          }
        });
        h.on(Hls.Events.MANIFEST_PARSED, function () {
          if (v.paused && feedPref('autoplay', true) && inView(v)) {
            // mute SILENTLY (applying guard) -- an UNguarded mute here fired volumechange, which the
            // handler read as the USER muting -> soundOn=false -> applySound muted every clip. That's
            // what silenced playback as you swiped to freshly-loaded videos (their HLS parses late).
            applying = true; v._engineSetAt = Date.now(); v.muted = true; applying = false;
            var p = v.play(); if (p && p.catch) p.catch(function () {});
          }
        });
        // captured HERE, not at attachHls() entry: loadHlsLib is async, so the clip has kept playing
        // since then and the position that matters is the one at the moment of the hand-off.
        var restoreHls = keepPos(v);
        tlHold(v);                                       // attachMedia points src at a MediaSource
        h.loadSource(url);
        h.attachMedia(v);
        restoreHls();
        v._hls = h;
      });
    }

    /* ---- REMOTE CLIPS OPEN ON THE ADAPTIVE LADDER (2026-10-08) ------------------------------------------
       Rob: replays must "load perfectly every time". A REMOTE clip (Cloudflare Stream: every live replay, db/0209, and
       a Cloudflare-processed upload, db/0246 -- data-remote, or pfFullSrc's full-file swap in the viewer) carries
       Cloudflare's progressive downloads/default.mp4 as its src: ONE file at SOURCE resolution, 44-146 MB on the live
       replays, behind a 302, with a 0.45-1.2 MB moov in front of the first frame. A cold, paused one sat on its
       full-screen still for 8-10 s on a 5 Mbps line before anything moved (and on 1.5 Mbps it only ever started once
       wire()'s stall recovery had given up on the mp4 and handed it to the ladder anyway). Its data-hls is Cloudflare's
       adaptive manifest (240p..1080p, 3 s segments, ACAO:* on the manifest, playlists AND segments), whose 240p/360p
       opening segment is ~100-200 KB.
       So in the VIEWER and on the PERMALINK's own card, a remote clip that is not already warm opens on the ladder:
         Safari (navigator.vendor Apple, which is every iOS browser too): native HLS, adaptive by default -- swap the
           src to the manifest; nothing else is needed or possible.
         everyone else: hls.js (the same lazily-loaded /assets/hls.min.js the stall recovery uses; wire() asks for it
           early whenever a remote clip is wired, so it is normally already here by the time a viewer opens), started
           on a LOW rung and left to climb: autoStartLoad off, the start level picked from the manifest's own bitrates
           against what this session has measured (netBps), then startLoad(); capLevelToPlayerSize keeps the climb from
           buying more than the element can show. NO bitrate-test fragment (startLevel -1 would fetch and discard one).
       WHAT STAYS EXACTLY AS IT WAS:
         - the mp4 is still the element's fallback: _mp4src is never touched, retireVideo never stashes a blob:/.m3u8,
           and a fatal hls.js error (or a native 'error') puts default.mp4 back (rmFallback) and marks the element
           _rmMp4 so it is never offered the ladder again. Download/share never read the element's src.
         - a WARM clip keeps what it has: readyState >= 3, or already playing with a frame (an adopted, playing feed
           card; a grid donor) is never swapped -- swapping a playing clip is the rewind/black the flights exist to avoid.
         - the timeline is untouched (rmHlsCtx refuses it): its memory rules (tlwSweep, TLW_KEEP, replays metadata-only
           off screen, __rovaTlwStats) govern exactly what they governed. The viewer's KEEP recycler and every release
           point already destroy v._hls (teardownVideo / retireVideo / vsYield / the live-host hold / heroReleaseVideo),
           and the grid's own release points now do too (a viewer clip landed in a tile can carry one).
         - CORS / canvas: hls.js plays from a same-origin MediaSource, so the hero frame-capture can READ it (it fell back
           to the poster on the cross-origin mp4); Safari's native manifest load stays no-crossorigin exactly like the
           mp4 was, so its canvas behaviour is unchanged (tainted -> poster fallback, already handled).
       Bounded: hls.js holds <= 20 s ahead (6 s while it is only a warmed neighbour, raised on its first 'playing') and
       <= 30 s behind -- not the browser-chosen fill of a 146 MB progressive file. */
    var RM_APPLE = /Apple/.test(navigator.vendor || '');
    function rmHlsCtx(v) {
      if (!v || !v.closest || !v.dataset || !v.dataset.hls || v._rmMp4) return false;
      if (!tlwRemote(v)) return false;
      if (!v.closest('.post')) return false;                       // mid-flight in a hero wrapper: the flight owns it
      return !!v.closest('.pfeed, [data-pfeed-open] > .post');    // the viewer, or the permalink's own card
    }
    function rmHlsWant(v) {
      if (!rmHlsCtx(v) || v._hlsWired || v._hls) return false;
      if (v.readyState >= 3) return false;                         // warm mp4: keep it
      if (!v.paused && v.readyState >= 2) return false;            // playing with a frame: keep it
      return true;
    }
    function rmFallback(v, mp4src) {                               // the ladder failed: default.mp4, for good on this element
      if (v._hls) { try { v._hls.destroy(); } catch (e) {} v._hls = null; }
      v._rmMp4 = 1; v._hlsWired = 1;                               // and the stall recovery must not hand it the same ladder
      if (!mp4src || v._released || v._recycled) return;
      var wasPlaying = !v.paused || !!v._rmPlay;
      var back = keepPos(v);
      tlHold(v);
      try { v.src = mp4src; v.load(); } catch (e) {}
      back();
      resumeAfterSwap(v, wasPlaying);
    }
    function rmStartLevel(levels) {                                // highest rung whose PEAK fits the start budget
      var mbps = netBps(), cap = mbps > 0 ? Math.max(400000, Math.min(1400000, Math.round(mbps * 0.4))) : 900000;
      var best = -1, lo = -1;
      for (var i = 0; i < levels.length; i++) {
        var br = levels[i].bitrate || 0;
        if (lo < 0 || br < levels[lo].bitrate) lo = i;
        if (br <= cap && (best < 0 || br > levels[best].bitrate)) best = i;
      }
      return best >= 0 ? best : Math.max(0, lo);
    }
    function rmAttach(v, url, mp4src, warm, restore, want) {
      /* maxMaxBufferLength is the REAL ceiling: hls.js buffers max(maxBufferLength, 8 * maxBufferSize / bitrate) -- with
         the 60 MB default that is ~600 s at 360p -- clamped by maxMaxBufferLength (default 600). So both are set. */
      var BUF = warm ? 6 : 20;
      var h = new Hls({ autoStartLoad: false, capLevelToPlayerSize: true, maxBufferLength: BUF, maxMaxBufferLength: BUF,
                        backBufferLength: 30, startFragPrefetch: true });
      /* SEGMENTS ONLY FOR A CLIP SOMEONE CAN SEE. The permalink's own card is started by its calmPlay a beat before the
         auto-opened viewer covers it (and by the sound arm), and __rovaBgHold then pauses it -- but a paused hls.js
         element keeps filling to maxBufferLength, a second copy of the same opening segments competing with the
         viewer's clip on the same line. So: a clip that is paused AND buried under the viewer when its manifest lands
         does not start loading until it actually plays, and one buried later stops loading (hls.js resumes from
         where it was on the next play). The viewer's own clips are never buried (bgHost answers '' for .pfeed). */
      var parsed = false, loading = false, first = true;
      var begin = function () {
        if (loading || !parsed || v._hls !== h) return;
        loading = true;
        try {
          if (first) { h.startLevel = rmStartLevel(h.levels || []); }
          h.startLoad(first && want > 0.25 ? want : -1);         // a resumed clip opens where it was, not on a wasted 0 segment
        } catch (e) {}
        first = false;
      };
      h.on(Hls.Events.MANIFEST_PARSED, function () {
        parsed = true;
        if (!(v.paused && bgBuried(v))) { begin(); }
      });
      v.addEventListener('play', begin);
      v.addEventListener('pause', function () {
        if (loading && v._hls === h && bgBuried(v)) { loading = false; try { h.stopLoad(); } catch (e) {} }
      });
      h.on(Hls.Events.ERROR, function (evt, data) {
        if (!data || !data.fatal) return;
        rmFallback(v, mp4src);
      });
      if (warm) {
        v.addEventListener('playing', function () { try { if (v._hls === h) { h.config.maxBufferLength = 20; h.config.maxMaxBufferLength = 20; } } catch (e) {} }, { once: true });
      }
      h.loadSource(url);
      h.attachMedia(v);
      if (restore) { restore(); }
      v._hls = h;
    }
    /* Put a remote clip on its ladder. Returns true when it now IS on the ladder (or is being put there): the caller
       then skips its own mp4 re-attach / buffer fill. warm = a neighbour being buffered ahead, not a clip starting. */
    function remoteHls(v, warm) {
      if (v._rmPend && !v._hls && !v.getAttribute('src')) return true;   // already waiting for hls.js: never re-attach the mp4 meanwhile
      if (!rmHlsWant(v)) return false;
      var native = RM_APPLE && v.canPlayType && v.canPlayType('application/vnd.apple.mpegurl');
      if (!native && !(window.MediaSource || window.ManagedMediaSource)) return false;   // nothing here plays a ladder: the mp4 it is
      var url = v.dataset.hls, mp4src = v._mp4src || v.getAttribute('src') || '';
      v._hlsWired = 1;
      v._rmPlay = warm ? 0 : 1;
      var want = 0; try { want = v.currentTime || 0; } catch (e) {}
      var restore = keepPos(v);
      if (native) {
        tlHold(v);
        v.preload = 'auto';                                        // read at the src assignment, so first
        v.src = url;
        restore();
        v.addEventListener('error', function () { if (v.getAttribute('src') === url) { rmFallback(v, mp4src); } }, { once: true });
        return true;
      }
      if (window.Hls && Hls.isSupported()) { rmAttach(v, url, mp4src, warm, restore, want); return true; }
      /* hls.js is not here yet (wire() normally fetched it already): hold the element EMPTY -- not on the mp4, whose
         bytes would be thrown away -- until it lands, then attach and start. A library that never arrives (offline
         CDN, CSP, an engine without MSE after all) puts the mp4 back after 6 s. */
      tlHold(v);
      try { v.removeAttribute('src'); v.load(); } catch (e) {}
      var settled = false;
      v._rmPend = 1;
      var go = function () {
        if (settled) return; settled = true; v._rmPend = 0;
        if (v._hls || v._released || v.getAttribute('src')) return;   // released, or something else re-attached it
        if (v._recycled) { v._hlsWired = 0; return; }                // recycled meanwhile: it rebuilds on approach
        if (!window.Hls || !Hls.isSupported()) { rmFallback(v, mp4src); return; }
        rmAttach(v, url, mp4src, warm, restore, want);
        if (!warm && v.paused && !v._userPaused && feedPref('autoplay', true) && !bgBuried(v) && window.__rovaPlayNow) {
          try { window.__rovaPlayNow(v); } catch (e) {}
        }
      };
      loadHlsLib(go);
      setTimeout(go, 6000);
      return true;
    }
    window.__rovaRemoteHls = function (v) { return !!(v && (v._hls || /\.m3u8/i.test(v.getAttribute('src') || '')) && v._rmPlay != null); };   // harness: is this element on the remote ladder?

    /* ---- CONCURRENT VIDEO STARTS: A CEILING WAS ATTEMPTED HERE AND FAILED (2026-08-09) ------------
       Recorded because the next person will reach for the same shape, and it does not work.

       THE PROBLEM IS REAL. This surface has no stated limit; the limit is an ACCIDENT OF ARRIVAL.
       Cards reach 55% visibility together, calmPlay's scroll-calm gate holds them until the fling
       settles, and the rect re-check below then lets through only the one or two still on screen.
       Nothing anywhere says a number, so the number holds only while cards keep arriving as they
       always have. Chunking the load-more insert (see applyPage) changed that -- ten small batches
       instead of one, each taking its own start decision -- and peak concurrently-loading byte-bearing
       <video> went from 3/3 to 8/6 over 63 screens.

       WHAT WAS TRIED: a live census (networkState === NETWORK_LOADING on a .mp4/.ts/.m4s source,
       avatars excluded -- exactly what the acceptance test counts) gating calmPlay at 3, with
       deliberate starts (__rovaPlayNow, clipPass's forward prime) exempt but still counted.

       WHY IT FAILED, measured A/B over the same route:
         * IT STARVED THE FEED. Capped arm reached 14 screens and 40 posts; uncapped, 88-140 screens
           and 189-309 posts on identical gestures. Two faults, both mine: the census counts clips
           that are PARKED AND STILL BUFFERING, not just ones starting, so it sits at the ceiling
           indefinitely; and a refused clip re-armed every 220ms forever while it stayed on screen, so
           forty videos each re-took a whole-document census several times a second. The gate became a
           busy-loop that slowed the very thread the pager runs on.
         * IT MOVED TODAY'S BEHAVIOUR, which was the stated disqualifier: peak 5 -> 2/3.
         * THE BASELINE IS NOT A CONSTANT. The same uncapped bundle measured peak 3/3 in one session
           and 5/5 in another. "At or below 3" is therefore not a testable bar; the acceptance
           criterion needs a distribution (median and p95 across several runs), not a single peak.

       ================================================================================================
       THE DESIGN THAT SHOULD BE BUILT (specified 2026-08-09; NOT built -- nothing below is wired).
       Written out because the analysis cost more than the code will, and because the obvious shape is
       the wrong one. Do not start from "add a cap"; start from here.
       ================================================================================================

       (1) ADMISSION BY EVICTION, NOT BY REFUSAL. This is the whole correction. The attempt above
       refused a start when a census was at the ceiling, which is what produced both the starvation and
       the busy-loop. The right shape already exists IN THIS FILE and has been in production on the
       profile grid for months: `live[]` + `enforceCap()` + `release()` (see ensureVideo/play/release
       near the .pgrid module). A start is ALWAYS GRANTED; if granting it would exceed the cap, the
       WORST existing holder is released to make room -- worst = furthest from the viewport centre
       (centerDist), with the requester passed as `exempt` so a start can never evict itself.
       Consequences, each of which answers one of the three failures above:
         * nothing is ever refused, so nothing can starve and nothing needs to retry -> no timers, no
           re-polling, no busy-loop. Eviction happens synchronously inside the start that caused it.
         * a parked-but-buffering clip cannot pin the ceiling: it is not a gate, it is a victim. It is
           precisely what gets evicted first, because it is furthest from the centre.
         * the bound holds regardless of arrival pattern -- one batch of thirty, ten batches of three,
           a trickle of singles -- because the count is enforced at the moment of granting, not
           inferred from how the requests happened to be grouped.

       (2) THE PATHS IT MUST OWN. A scheduler two of seven paths bypass is the same bug with more code.
       Enumerated from a full sweep (surface / trigger / deliberate-or-ambient):
           calmPlay            14874 re-attach+load, 14883 play    FEED+PFEED+POST  scroll      AMBIENT
           playIO drag-reveal  14910 play                          PFEED            drag        AMBIENT
           calmWarm (warmIO)   15089 re-attach, 15093 preload=auto,
                               15115 load, 15081 1MB Range fetch   FEED+PFEED       scroll      AMBIENT
           slideMedia          11857 preload=auto, 11858 load
                               (forward neighbour)                 FEED/PROFILE     slide       AMBIENT
           primeNext           12130 src, 12133 preload=auto,
                               12183 muted play (off-slide)        FEED/PROFILE     700ms timer AMBIENT
       Already bounded, leave alone: the profile grid (its own enforceCap and playCap(), 5 touch / 12
       desktop since 2026-08-10 -- it was 3/6 when this was written) and the avatar loops (excluded
       from the metric entirely).
       Not counted by the acceptance metric but still real radio: 15081's 1MB Range fetch and
       14541/14546's .m3u8 reads are raw fetch(), not <video> state, so a <video>-based census cannot
       see them -- decide deliberately whether the scheduler owns them too. (The first-segment .ts warm
       was removed 2026-08-09; hls.js is reachable only from wire()'s sustained-stall recovery, and its
       blob: src is invisible to the metric.)

       (3) SLOT LIFECYCLE. A slot is taken by a START IN PROGRESS and released by the FIRST of:
           readyState >= 3 (HAVE_FUTURE_DATA -- it has what it needs; it is no longer starting),
           pause / teardownVideo / retireVideo / __rovaReleaseVideos / grid release / stubCard recycle,
           a hard ceiling (~8s) so a stalled clip can never hold a slot for the life of the session.
       Do NOT hold a slot for as long as networkState === NETWORK_LOADING -- that is exactly the
       mistake above. The release points already exist and are listed in the teardown sweep; they need
       hooking, not writing.

       (4) DELIBERATE NEVER WAITS. __rovaPlayNow (tap, viewer open, hero-flight land, donor adoption),
       the transport play button, seekPromote and pfResume are granted immediately AND marked exempt so
       they are never the eviction victim. Priming keeps the treatment reasoned out earlier: it is a
       legitimate holder and it COUNTS, but it is never refused -- and because it is off-slide it is
       naturally the furthest from centre, so it is the first thing evicted when a visible clip wants a
       slot. That is the correct priority order and it is why a carousel cannot starve itself: its own
       prime is never the thing being refused, only the thing given up.

       (5) ACCEPTANCE, and it is distributional. Phase 1, scheduler alone, must be INDISTINGUISHABLE
       from today on today's arrival pattern: median and p95 of concurrent byte-bearing <video> across
       >=3 runs per arm, AND -- the failure mode that actually matters -- the same SCREENS TRAVELLED
       and POSTS LOADED. The attempt above was caught by exactly that: 14 screens / 40 posts against
       88-140 / 189-309. Only once phase 1 is clean does phase 2 (re-land the chunked insert in
       applyPage) get measured, and the prize is worst-task / worst-frame / long-task count.
       Harnesses for all of this are written and were used for every number quoted here.

       ================================================================================================
       BUILT 2026-08-09, exactly as specified above. The scheduler is the ~60 lines directly below and
       it owns all five ambient start paths plus __rovaPlayNow. Notes on what the build settled that
       the specification left open:

       * THE CAP IS 5, NOT 3. The bar for phase 1 is "indistinguishable from today", and today's own
         uncapped peak is 3-5 depending on the session (that is the whole reason the acceptance test is
         distributional). A cap of 3 would CLIP today's behaviour, which is the disqualifier the last
         attempt was failed on. 5 sits at the top of today's range: it does not bind on today's
         arrival pattern, and it does bind on chunked arrival, which is the only thing it is for.
         It is one number, not a touch/desktop pair -- unlike the grid's PLAY_CAP this is a RADIO
         budget, not an iOS decoder-pipeline budget, and the line does not get faster on a desktop.

       * A SLOT AND THE METRIC ARE NOT THE SAME SET, deliberately. A slot is held while readyState < 3;
         the acceptance metric counts readyState < 4 && networkState === 2. So a clip that has reached
         HAVE_FUTURE_DATA and is still filling its buffer counts in the metric and holds NO slot. That
         is correct -- it is no longer STARTING -- and it means the metric can legitimately read above
         the cap. It also gives the design a property worth stating: because a holder always has
         readyState < 3, and a clip must generally reach 3 to play, EVICTION CAN NEVER INTERRUPT
         PLAYBACK. The only thing that can ever be evicted is a start that has not yet arrived.

       * EVICTION IS THE GRID'S RELEASE, MINUS THE POSTER DROP. vsYield() pauses, kills any hls
         instance, drops the src and load()s -- the same hard release teardownVideo does, which is what
         actually hands the bytes back (an element at preload=none with a src still holds player state)
         -- but it KEEPS the poster, so an evicted clip is visually identical to one that never
         started, and it re-arms warmObserve so the clip rebuilds by the ordinary route. Nothing is
         refused, so nothing is scheduled to retry: there is not one timer in this module.

       * THE HARD CEILING IS LAZY. It is checked in the filter at the top of vsEnforce, i.e. only when
         somebody else wants a slot. A stalled holder lingering past 8s with nobody asking costs
         nothing, and a per-clip timer would be exactly the churn the last attempt died of.

       * THE RAW fetch() DECISION (the one open question). SPLIT, and on whether the fetch is BULK:
         - calmWarm's 1MB Range head-start (below) DOES participate. It is a megabyte of media bytes
           per clip with no ceiling on how many clips a fling can arm, aimed at the same radio as the
           clip being watched -- the precise harm this whole effort exists to remove -- and a
           <video>-based census structurally cannot see it, so leaving it out would leave the largest
           uncounted competitor unbounded. It holds a slot through an AbortController, and because it
           only ever fires beyond 1.2 viewports it is furthest from centre by construction: always the
           first victim, never a gate. Aborting restores _headStart = 0, so the clip is head-started
           again by the ordinary route when it comes back.
         - prefetchHlsManifests' .m3u8 reads DO NOT. They are ~5KB of playlist text, one-shot per
           clip, and reachable only from wire()'s sustained-stall recovery -- i.e. they fire when a
           clip is ALREADY failing. Metering them would delay recovery from a stall to save five
           kilobytes, which is the wrong trade in both directions. They are noise on the radio, not
           contention.

       PHASE 1 RESULT -- it is indistinguishable from today, which is what it had to be. One bundle,
       both arms, the scheduler switched off at runtime by pre-defining window.__rovaVidStart with a
       swallowing setter (that is why every caller goes through the window property; see below). Three
       runs per arm, alternating, HTTP cache disabled, bundle identity 643807 bytes on both arms,
       1.6Mbps/300ms/CPU 4x, 63+ screens of flinging per run:
                            OFF (today)                 ON (scheduler)
           peak             4, 5, 5   med 5             5, 5, 5   med 5
           median           1, 1, 1   med 1             1, 1, 1   med 1
           p95              4, 4, 3   med 4             4, 4, 5   med 4
           screens          88, 88, 101  med 88         127, 113, 7   med 113
           posts            190, 190, 220  med 190      280, 250, 159 med 250
       Screens and posts are the ones that matter -- that is what caught the refusal-based attempt (14
       screens / 40 posts against 88-140) -- and the scheduler travels at least as far as today. The
       7-screen run in the ON column is an outlier of the harness, not of the arm: the OFF arm produced
       a 3-screen run of its own in an earlier session on this same route. Peak, median and p95 of
       concurrent byte-bearing <video> are the same distribution on both sides.

       AND IT IS CURRENTLY FREE BECAUSE IT NEVER BINDS. Over a 63-screen fling the module records 16-17
       GRANTS AND ZERO EVICTIONS, and the live-slot count peaks at 2 against a cap of 5. That is the
       honest state of it: on today's arrival pattern nothing ever reaches the ceiling, so phase 1 is
       clean by construction rather than by restraint. It is also why phase 2 (the chunked insert) went
       back -- a cap that never binds cannot be what bounded the chunked arm, whatever the peaks read.
       The census that says WHY it does not bind, and the two candidate fixes, are written out in full
       at applyPage. Read that before changing VS_CAP: lowering the number is not the fix, and the
       measurement there says so. */

    /* ---- THE SCHEDULER. Admission by eviction; see (1)-(4) above for why this shape. -------------- */
    var VS_CAP = 5;                                    // concurrent STARTS, arrival-independent
    var VS_MAX = 8000;                                 // hard ceiling on one slot (lazy, see above)
    // The sustained-jank governor (__rovaJank rungs 3/4) overrides the cap to 1 then 0 while it is
    // active; VS_CAP itself never moves. Read at each decision, like everything else in this module.
    function vsCap() { return (typeof window.__rovaVidCap === 'number') ? window.__rovaVidCap : VS_CAP; }
    var vsLive = [];                                   // clips with a start in progress
    var vsGrants = 0, vsEvicts = 0;                    // owner/harness visible; see __rovaVidStats
    /* RELEASE IS LAZY -- vsHolds() IS THE RELEASE, THERE ARE NO LISTENERS, AND THAT IS DELIBERATE.
       The obvious build hooks canplay/playing/pause/emptied/abort on each holder. It is WRONG here, and
       silently so: the grant is taken immediately BEFORE the setAttribute('src') / load() / play() it is
       for, and the media element load algorithm QUEUES pause, emptied and abort as tasks -- so those
       events arrive AFTER the grant, in a later task, and hand the slot straight back. The count then
       reads ~0 forever, the cap never binds, and the whole module passes its acceptance test by doing
       nothing. (This is not hypothetical: it is what the first build of this module did.)
       Every release condition in (3) is a QUESTION vsHolds can answer instead, and the answer is only
       ever needed at the one moment a decision is taken, so it is asked in the filter at the top of
       vsEnforce and nowhere else:
         readyState >= 3            -> asked directly
         pause                      -> a clip must reach readyState 3 to play, so a PLAYING clip holds
                                       no slot; __rovaBgHold and the autoplay-off sweep only ever pause
                                       playing clips, and therefore have nothing to release.
         teardownVideo / retireVideo / __rovaReleaseVideos / stubCard / grid release / vsYield
                                    -> all drop the src, which vsHolds asks for; teardownVideo and
                                       retireVideo ALSO call vsDrop explicitly, because the head-start
                                       fetch is the one holder with no <video> state to read.
         detached, pruned, stalled  -> isConnected, _released, and the 8s ceiling.
       Nothing but vsEnforce ever reads vsLive, so a holder that has quietly arrived sitting in the array
       between two decisions costs nothing and is filtered before it can affect one. No listeners, no
       timers, no polling -- the whole module runs only when somebody starts a video. */
    function vsDist(v, vh) {                           // worst = furthest from the viewport centre
      if (!v.isConnected) return 1e9;
      var r; try { r = v.getBoundingClientRect(); } catch (e) { return 1e9; }
      if (!r.height) return 1e9;                       // detached / display:none -> evict first
      return Math.abs((r.top + r.bottom) / 2 - vh / 2);
    }
    function vsHolds(v) {                              // is this still a START IN PROGRESS?
      if (!v || !v._vsAt || v._released || !v.isConnected) return false;
      if (Date.now() - v._vsAt > VS_MAX) return false;                 // (3) hard ceiling
      if (v._vsFetch) return true;                                     // 1MB head-start in flight
      if (v.readyState >= 3) return false;                             // (3) HAVE_FUTURE_DATA: arrived
      return !!v.getAttribute('src');                                  // torn down elsewhere: gone
    }
    function vsDrop(v) {                               // hand the slot back; NEVER touches playback
      if (!v || !v._vsAt) return;
      v._vsAt = 0; v._vsPri = 0;
      var i = vsLive.indexOf(v); if (i >= 0) { vsLive.splice(i, 1); }
    }
    function vsYield(v) {                              // the eviction ACTION: give the bytes back
      vsDrop(v);
      if (!v || v._released) return;
      try { clearTimeout(v._playT); } catch (e) {}     // and cancel any deferred calmPlay for it
      if (v._vsFetch) { try { v._vsFetch.abort(); } catch (e) {} v._vsFetch = null; v._headStart = 0; }
      try { if (!v.paused) v.pause(); } catch (e) {}
      if (v.readyState < 3 && v.getAttribute('src')) {
        if (v._hls) { try { v._hls.destroy(); } catch (e) {} v._hls = null; v._hlsWired = 0; }
        tlHold(v);                                                     // cover first (see teardownVideo)
        try { v.removeAttribute('src'); v.load(); } catch (e) {}       // grid-style: this is what frees bytes
        v.preload = 'none';
        v._recycled = 1;                               // agrees with teardownVideo's bookkeeping
        try { warmObserve(v); } catch (e) {}           // rebuilds by the ordinary route on return
      }
    }
    function vsEnforce(exempt) {
      vsLive = vsLive.filter(vsHolds);                 // sweep expired/arrived holders first
      /* THE VIEWPORT HEIGHT IS THE EVICTION LOOP'S, NOT THIS FUNCTION'S  (2026-08-17, measured).
         window.innerHeight brings the frame to layout-clean in Blink, and vsEnforce is called once per
         video START -- from vsStart, its only caller -- which during a viewer open means once per clip
         in a burst that is simultaneously WRITING: release() pauses, drops src, calls load() and removes
         the element for every grid tile while the pfeed's own clips start. Read after write, N times, so
         N full flushes -- and the loop below needs none of them. `vh` feeds vsDist, vsDist runs only
         inside the while, and the census above records that while as never executing on today's arrival
         pattern (16-17 grants, ZERO evictions, peak 2 live against a cap of 5). It was a forced
         style+layout whose value was then discarded.
         MEASURED with a V8 sampling profile (tools\vopen-perf.js --prof) on the post-landing task at
         390x844 / 4x CPU: 105.5ms of `get innerHeight` self-time, 112.9ms rolled up to vsEnforce, inside
         the single largest task of the whole open. Reading it where it is USED costs exactly as much on
         the day the cap finally binds, and nothing on any day before that.
         THIS IS A DELETION, NOT A RESCHEDULE, and that distinction is the whole reason it shipped while
         the round's bigger offender did not. lockScroll() reads window.scrollY with the document already
         invalidated by build() + clearPfeedList(), which cost 111-158ms of SYNCHRONOUS main thread inside
         the tap task -- larger than this. Removing those reads took lockScroll to 4-10ms and moved
         nothing: the flush simply relocated into the `void box.offsetWidth` that __rovaProfileFeed
         already keeps as its last statement, and over 12 paired ABBA runs per arm every owner-facing
         column stayed flat while tapToFirstPaint and tapToHeroLanded drifted the WRONG way on the median
         (738->810ms, 1219->1323ms, both with overlapping ranges). So that one was not shipped.
         Here nothing consumes the value, so no later pass inherits the flush. Its own effect was measured
         only inside that bundled arm and is NOT claimed as an owner-facing win. */
      var cap = vsCap();
      if (vsLive.length <= cap) return;
      var vh = window.innerHeight || 800, guard = 0;
      while (vsLive.length > cap && guard++ < 16) {
        var worst = null, worstD = -1;
        for (var i = 0; i < vsLive.length; i++) {
          var c = vsLive[i];
          if (c === exempt || c._vsPri) continue;      // (1) never evict the requester; (4) never a deliberate start
          var d = vsDist(c, vh);
          if (d > worstD) { worstD = d; worst = c; }
        }
        if (!worst) break;                             // everything left is exempt: grant anyway, over cap
        vsEvicts++;
        vsYield(worst);
      }
    }
    /* ALWAYS RETURNS TRUE. It is not a permission check -- callers do not branch on it -- it is the
       point at which the count is enforced. Call it immediately before the src/preload/load/play. */
    function vsStart(v, deliberate) {
      if (!v) return true;
      if (deliberate) { v._vsPri = 1; }
      if (v.readyState >= 3 && !v._vsFetch) return true;   // nothing is starting
      /* MEMBERSHIP IS THE ARRAY, NOT THE STAMP -- the same test the grid's ensureVideo uses, and for a
         reason found by measurement. Testing `!v._vsAt` instead looks equivalent and is not: vsEnforce
         releases a holder by FILTERING IT OUT of vsLive, which cannot clear a property on an element it
         has just stopped holding a reference to, so _vsAt stays set forever. A clip would then take one
         slot in its life and afterwards be invisible to the count -- measured over 88 screens: 11 grants
         and a peak of 2 live where the true figures are 500-odd and 5. A cap nothing reaches is not a
         cap; it just measures as one. */
      if (vsLive.indexOf(v) < 0) { vsLive.push(v); vsGrants++; }
      v._vsAt = Date.now();
      vsEnforce(v);
      return true;
    }
    /* ONE CHOKE POINT, AND EVERY CALLER GOES THROUGH IT -- including the ones in this very scope, which
       could call vsStart() directly. Two reasons, both worth the property lookup (a start is a rare
       event; this is not a per-frame path): the carousel's two paths live in a DIFFERENT IIFE and can
       only reach it here, so routing everything through the same door means there is exactly one list
       of owners to audit; and it makes the scheduler substitutable from outside, which is what lets the
       acceptance A/B run BOTH ARMS ON ONE BUNDLE (the harness defines this property with a swallowing
       setter before the module loads) instead of swapping bundle text and hoping nothing else moved. */
    window.__rovaVidStart = function (v, d) { try { return vsStart(v, d); } catch (e) { return true; } };
    // Only the raw-fetch holder needs this: a <video> announces its own arrival through the media
    // events hooked in vsStart, but a fetch() has no such event, so its settle hands the slot back here.
    window.__rovaVidDrop = function (v) { try { vsDrop(v); } catch (e) {} };
    /* A scheduler that released every slot the instant it took one would also measure "indistinguishable
       from today", so the acceptance run has to be able to prove the module is actually holding and
       actually evicting. grants/evicts are monotonic counters, live is the true count right now. */
    window.__rovaVidStats = function () { return { cap: vsCap(), base: VS_CAP, live: vsLive.filter(vsHolds).length, grants: vsGrants, evicts: vsEvicts }; };
    window.__rovaVidEnforce = function () { try { vsEnforce(null); } catch (e) {} };   // governor: apply a lowered cap now, not at the next start

    var playIO = new IntersectionObserver(function (ents) {
      // While a clip is in picture-in-picture, IT owns playback -- don't let scrolling autoplay (or
      // pause) any OTHER video, which would stack audio and burn data playing hidden in the background.
      var pip = document.pictureInPictureElement;
      ents.forEach(function (en) {
        var v = en.target;
        if (pip && v !== pip) return;                      // PiP active: leave every other clip alone
        // MID-FLIGHT (hero/dismiss crop wrapper, a body child -- not inside a .post): leave it ALONE. The
        // crop window clips the flying clip below the 55% ratio, so this observer PAUSED it mid-collapse --
        // a paused re-parented <video> composites BLACK = the owner's "dismiss zoom is paused, flashes
        // black, then continues". The flight owns the element until it lands back in a .post (or is released).
        if (v.closest && !v.closest('.post')) return;
        /* 0.5, not 0.55 (2026-09-26): the timeline's playing card holds the voice from 50% (tlSlotDecide),
           so it must be PLAYING from 50% too -- a holder paused at 52% by this line would be the voice of a
           frozen frame. The fling discipline is calmPlay's settle below, not this number. */
        if (en.isIntersecting && en.intersectionRatio >= 0.5) {
          if (!feedPref('autoplay', true) || v._userPaused) return;   // gear off, or they hit pause: leave it
          // GRID DISCIPLINE (round 129): don't spin the decoder until the swipe SETTLES. A rapid swipe burst
          // pushes EVERY post through >=55% visibility, and playing each one for a moment (network + decoder
          // spin-up, then pause) piled media resources up until iOS killed the tab ("A problem repeatedly
          // occurred"). The grid never chokes because it defers play past the fling (its 120/240ms calm) --
          // same here: a short settle, re-checked against __rovaScrollAt, and a pending play is CANCELLED the
          // moment the post scrolls back out (the pause branch below). The clip you LAND on starts right as
          // the snap settles; the ones you flew past never start at all.
          clearTimeout(v._playT);
          v._playT = setTimeout(function calmPlay() {
            if (v._released || v._userPaused || !feedPref('autoplay', true)) return;
            /* NOTHING STARTS UNDER THE VIEWER (2026-09-08). This defer only ever re-checked
               __rovaScrollAt, so a clip whose settle resolved after __rovaBgHold's arm started
               decoding behind a full-screen overlay and stayed there for the rest of the open
               (measured at +17.3s into a 45s open, y=79, fully covered). The grid's own calm loop has
               had the equivalent guard since round 129 -- "an overlay covering the grid means nobody
               can SEE these tiles, so starting them spends a decoder on picture no one is looking at".
               Marked as held rather than merely skipped, so the close resumes it on exactly the path
               that resumes everything else the hold took. The 3s sweep above is the backstop for every
               OTHER start path; this is the one that makes the common case cost nothing at all. */
            if (bgBuried(v)) { v._bgHeld = bgHost(v); return; }
            /* ...a FLING waits; a finger dragging the timeline does not (2026-09-30, Rob: "it doesn't start
               playing the next media in view until I lift off my finger"). __rovaScrollAt is stamped by every
               touchmove, so this used to hold every start until the lift + the momentum. Mid-drag (tlLive,
               timeline only -- the viewer keeps its own drag-reveal) the clip starts once it is still >= 50%
               on screen at this re-check, i.e. after >= 90ms of being so. */
            var moving = Date.now() - (window.__rovaScrollAt || 0) < 160;
            var dragOk = moving && !(v.closest && v.closest('.pfeed')) && window.__rovaTlLive && window.__rovaTlLive();
            if (moving && !dragOk) { v._playT = setTimeout(calmPlay, 140); return; }
            var r = v.getBoundingClientRect(), vh = window.innerHeight || 800;   // still the one on screen?
            if (r.top > vh * 0.9 || r.bottom < vh * 0.1) return;                 // flew past mid-defer
            if (dragOk && !(r.height > 0 && Math.min(r.bottom, vh) - Math.max(r.top, 0) >= r.height * 0.5)) {
              v._playT = setTimeout(calmPlay, 140); return;                      // mid-drag: not half on screen (yet)
            }
            // START PATH 1 of 7 (scroll, ambient). Claimed BEFORE the re-attach + load below, so the
            // eviction it may cause happens before this clip's own bytes are asked for -- and with this
            // clip exempt, so it can never evict itself.
            if (window.__rovaVidStart) { window.__rovaVidStart(v); }
            if (!remoteHls(v, false) && !v.getAttribute('src') && v._mp4src) {     // hard-released (grid-style teardown): re-attach (a remote clip: its ladder instead, see remoteHls)
              // COVER FIRST, and note the ORDER this fixes: the poster restore is the line BELOW,
              // so a released clip used to be re-loaded while visible with no poster attribute at
              // all -- a guaranteed frameless <video> on screen. The cover does not depend on the
              // attribute and is already up.
              tlHold(v);
              v.setAttribute('src', v._mp4src); try { v.load(); } catch (e) {}
            }
            if (v._posterStash && !v.getAttribute('poster')) { v.setAttribute('poster', v._posterStash); v._posterStash = null; }
            v._instant = 1;                                // play the pre-buffered mp4 NOW (instant, hover-parity);
                                                           // HLS only steps in if it stalls (wire()'s recovery)
            // mute SILENTLY (applying guard), else this programmatic mute fires volumechange and the
            // handler reads it as the user muting -> soundOn=false -> applySound() below mutes every
            // video. That's what silenced the sound the moment you swiped to another clip.
            applying = true; v._engineSetAt = Date.now(); v.muted = true; applying = false;
            var pr = v.play();
            if (pr && pr.catch) pr.catch(function () {});  // autoplay veto: just stay paused
            applySound();                                  // deferred start: re-hand the sound to this clip
          }, 90);
        } else {
          if (v === pip) return;                           // never pause the popped-out PiP clip
          // PFEED DRAG-REVEAL (owner: "I want to see the top of the next video already playing as the swipe
          // drags it up, not black-then-play"): a PARTIALLY-visible viewer clip is mid-drag -- entering or
          // leaving. Never pause it (the outgoing clip keeps playing to the last pixel), and START an entering
          // clip the instant its first pixels show -- muted, and ONLY if it's already buffered (readyState>=2,
          // the warm-ahead's job), so a fling past cold posts never spins decoders (what the calm settle is
          // for). calmPlay's own scroll-calm wait is exactly why clips used to start only AFTER the swipe.
          /* ...but a sideways-paged GALLERY SLIDE is not a drag-reveal, and calling it one was
             costing the viewer two extra decoders. The drag-reveal exists for the VERTICAL
             post-to-post swipe: a clip half off the TOP or BOTTOM is entering or leaving. A
             carousel's off-slide clips are clipped HORIZONTALLY and are not going anywhere, but
             they stay partially intersecting, so this branch started them and then never paused
             them. MEASURED on the viewer, and PRE-EXISTING (identical on the bundle before this
             work): paging the gallery ran a sliding window of THREE clips at once -- states
             RRRPP, PRRRP, PPRRR -- which is the decoder/heat failure [[pfeed-memory-and-slideshow]]
             and [[phone-heat-energy-evidence]] exist for. It only became continuous once the show
             started paging on every clip end, so it is bounded here rather than left to grow.
             Exactly the mistake inView() was fixed for, in the one place that did not use it.
             onCurrentSlide is the HORIZONTAL half only, so vertical drag-reveal is untouched. */
          if (en.isIntersecting && v.closest && v.closest('.pfeed') && onCurrentSlide(v)) {
            if (v.paused && !v._userPaused && v.readyState >= 2 && feedPref('autoplay', true)) {
              // START PATH 2 of 7 (drag, ambient). Cheap in practice: the readyState >= 2 gate above
              // means the warm-ahead already paid for this clip, so it is usually at 3 already and
              // takes no slot at all -- but it is a start, and a scheduler seven paths must own is not
              // allowed to have four.
              if (window.__rovaVidStart) { window.__rovaVidStart(v); }
              applying = true; v._engineSetAt = Date.now(); v.muted = true; applying = false;
              var pe = v.play(); if (pe && pe.catch) pe.catch(function () {});
            }
            return;                                        // partially visible: not "passed by" -- leave it playing
          }
          // PERMALINK (owner: "scrolling down to read the comments is stopping the video and shouldn't").
          // Same category of mistake as the pfeed branch above. On a post-detail page there is ONE post and
          // its comments live directly beneath it, so the clip sliding off the top of the viewport is not
          // "the reader scrolled past this video", it is "the reader is still on this post". Leave it
          // playing while ANY pixel of it is on screen; the fall-through below still pauses it the moment
          // it is fully out of view, so nothing keeps decoding for a reader who has genuinely moved on.
          // Deliberately NARROW: the server marks only views/post_single.php's wrap (data-pfeed-open) and
          // only its OWN post card is a direct child of that wrap -- thread parts render inside
          // .thread-chain, so they keep the 55% rule. The feed, the profile and the grid never carry the
          // attribute at all, so the burst discipline that the 55% threshold exists for (round 129: a
          // rapid swipe pushes every post through 55%, and a decoder per post killed the iOS tab) is
          // untouched everywhere it matters. Skipped entirely while the immersive viewer is open, so a
          // permalink that auto-opened into .pfeed behaves exactly as it does today.
          // Unlike the pfeed branch this only DECLINES TO PAUSE -- it never starts a paused clip. A clip
          // that is paused here was paused by the user or vetoed by autoplay, and creeping back into view
          // is not consent to start it.
          if (en.isIntersecting && v.closest && v.closest('[data-pfeed-open] > .post')
              && !document.querySelector('.pfeed.show')) {
            return;                                        // still reading this post: leave it playing
          }
          /* ENTERING THE TIMELINE FOLD (2026-09-09). Rob: "I don't want to see videos paused RIGHT
             before they come into my screen, they need to be playing."
             This branch used to PAUSE every clip under 55% visible -- so a card crossing the fold
             was explicitly STOPPED for the whole first half of its arrival and only started once
             more than half of it was on screen. The reader watches a still, then it starts. That is
             not a missing feature, it is an active pause, and it is what he is describing.
             The viewer has had the OPPOSITE rule since the drag-reveal round (owner then: "I want
             the top of the next video already playing as it drags up, not black-then-play"), and it
             is 20 lines above this one. This is that same rule for the timeline, reused rather than
             reinvented, with the same `readyState >= 2` gate -- the warm-ahead has already paid for
             a buffered clip, so a fling past COLD posts still spins no decoders, which is the whole
             point of the burst discipline (round 129) the 55% threshold exists for.
             THE DIRECTION TEST IS WHAT KEEPS THAT DISCIPLINE: only a clip whose leading edge is the
             one crossing the fold we are travelling TOWARDS is spared. Anything receding behind the
             reader still falls through and is paused, exactly as before -- a clip decoding where
             nobody is looking is the complaint this must not create. */
          if (en.isIntersecting && !v._userPaused && feedPref('autoplay', true) && !bgBuried(v)
              && tlEntering(v)) {
            if (v.paused && v.readyState >= 2) {
              // START PATH 5 of 7 (arrival). Never `deliberate`: an arriving clip must remain the
              // cheapest thing for the budget to give up if a closer one needs the slot.
              if (window.__rovaVidStart) { window.__rovaVidStart(v); }
              applying = true; v._engineSetAt = Date.now(); v.muted = true; applying = false;
              var pin = v.play(); if (pin && pin.catch) pin.catch(function () {});
            }
            return;                                        // on its way IN: never pause it at the fold
          }
          clearTimeout(v._playT);                          // a fling passed it by: cancel the pending play
          /* "SCROLLED AWAY" MEANS OFF SCREEN (2026-09-18). This branch also runs for a card that is still
             on screen at under 55%, and a card can get such a callback WITHOUT anyone scrolling: the
             immersive viewer's scroll lock hides the document scrollbar and pads <body> to compensate
             (lockScroll), so on desktop every card reflows under the overlay and IO re-reports it. Measured
             on Chromium 1280x900: a clip the reader had paused lost _userPaused at the open and was
             restarted by the pre-roll picker 190 ms after the close -- the one thing a close must never do.
             A manual pause is forgotten only once the card has actually LEFT the viewport. */
          if (!en.isIntersecting) { v._userPaused = false; } // scrolled away: a manual pause doesn't persist
          v._instant = 0;                                  // left the tapped clip; calmPlay re-stamps it on return,
                                                           // so this clears state, it does not schedule an HLS upgrade
          if (!v.paused) v.pause();
          // ...and a remote replay that has left stops GROWING its buffer (2026-10-08, see tlwSweep): what it
          // holds stays (scrolling back is still instant), the rest of a 44-146 MB file is not fetched for nobody.
          if (!en.isIntersecting && v.preload === 'auto' && tlwRemote(v) && !(v.closest && v.closest('.pfeed'))) { v.preload = 'metadata'; }
        }
      });
      applySound();                                        // hand the sound to the new top video
    }, { threshold: [0, 0.5] });

    // Kick ONE clip into playback right now, without waiting for playIO's async IntersectionObserver
    // to fire. The pfeed calls this on the just-tapped video the instant it lands, so the clip is
    // already playing as the open scale-in settles -- instead of dwelling on the cover-scaled poster
    // (which looks like a "zoomed thumbnail") through the animation and only starting after. Mirrors
    // playIO's become-current path exactly: wire HLS, mute silently (autoplay requires it), play.
    window.__rovaPlayNow = function (v) {
      if (!v || document.pictureInPictureElement || !feedPref('autoplay', true) || v._userPaused) return;
      /* ...AND NOT UNDER THE VIEWER (2026-09-08). Because every deliberate start funnels through here,
         this one line covers all of them -- and the one that was measured starting a clip nobody could
         see was `slideMedia`'s landed slide, reached from the feed CARD gallery's own IntersectionObserver
         while a full-screen viewer was up (+28.8s into an open, card at y=-127). bgBuried() answers '' for
         everything this function exists to serve on the viewer's side -- a clip inside `.pfeed`, a clip
         mid-flight on <body>, a `.pcell` donor -- so the open, the hero landing and the adoption are
         untouched; only page content behind the overlay is declined, and it is MARKED so the close
         resumes it on the same path as everything else the hold took. */
      if (bgBuried(v)) { v._bgHeld = bgHost(v); return; }
      /* DELIBERATE, SO IT NEVER WAITS AND IS NEVER THE VICTIM. Every deliberate start funnels through
         this one function -- the tap, the viewer open, the hero-flight landing, donor adoption, the
         transport play button, seekPromote, pfResume and slideMedia's landed slide -- so marking it
         here marks all of them. It still COUNTS: a cap that the reader's own clip is invisible to is
         not a cap. The `true` sets _vsPri, which vsEnforce skips when it picks a victim, and which
         vsDrop clears the moment the clip arrives so priority cannot outlive the start it was for. */
      if (window.__rovaVidStart) { window.__rovaVidStart(v, true); }
      // INSTANT OPEN: play the plain mp4 that's ALREADY this <video>'s src right now -- exactly what the grid
      // hover does, which is why hover feels instant. We deliberately do NOT attachHls() first: that HLS
      // handshake is the open latency we're removing. _instant tells warmIO/playIO to leave this clip on its
      // mp4 (grid-hover parity). It does NOT "upgrade on scroll away and back" -- calmPlay re-stamps
      // _instant before it plays, so the clip stays on the mp4 for good and only wire()'s sustained-stall
      // recovery can hand it to the ladder. That is the intended shape; see the byte numbers in attachHls.
      v._instant = 1;
      // a REMOTE clip in the viewer / on its permalink opens on its adaptive ladder, not the source-size mp4 (remoteHls)
      if (!remoteHls(v, false) && !v.getAttribute('src') && v._mp4src) { v.setAttribute('src', v._mp4src); }   // hard-released: re-attach
      if (v._posterStash && !v.getAttribute('poster')) { v.setAttribute('poster', v._posterStash); v._posterStash = null; }
      v.preload = 'auto';                                  // warmIO now skips the opener, so buffer it here
      /* ...EXCEPT THE DESIGNATED VOICE, ALREADY SPEAKING (2026-09-26). A viewer closing onto its timeline
         card flies the audible clip home and lands it through here; muting it "because autoplay needs it"
         was one half of the second of silence Rob heard on every close. A clip that is already playing
         unmuted needs no allowance -- and it is the voice, so applySound would only unmute it again. */
      if (!(v === soundVoiceEl() && !v.muted)) {
        applying = true; v._engineSetAt = Date.now(); v.muted = true; applying = false;   // silent mute, else volumechange mutes the feed
      }
      /* THE ADVANCE HAS CLAIMED THIS ELEMENT. Stamped so anything holding a deferred stop on it can
         tell that it has since become the clip the reader is looking at, WITHOUT having to re-derive
         that from slide indices -- the carousel's next-clip primer reads this to guarantee that a
         pause it armed while the clip was still off-slide can never land on a clip this function has
         started in the meantime. A timestamp rather than a flag because the primer needs to compare
         it against when its own pass began. */
      v._playNowAt = Date.now();
      var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
    };

    /* ---- SECOND DECODER BEHIND THE VIEWER (2026-08-09) ------------------------------------------
       On a permalink the post-page card's <video> kept PLAYING, in lockstep, underneath the immersive
       viewer. Measured on /p/15640: two elements on the same 13.4MB clip, both readyState 4, both
       unpaused, currentTime advancing together (7.50->9.46 and 7.55->9.53 over one 2s sample), both
       decoding (totalVideoFrames climbing ~30fps on each). After five pfeed swipes the buried one was
       still running at ct=25.09 with 754 frames decoded while the foreground clip it was duplicating
       had already been recycled. It is muted, so nothing is audible and nothing looks wrong -- it is
       purely a second decode pipeline and a second buffer for the life of the session.

       WHY playIO DOES NOT ALREADY CATCH IT. The permalink branch above is written correctly: it declines
       to pause a `[data-pfeed-open] > .post` card only while `!document.querySelector('.pfeed.show')`.
       But that branch lives on the NON-intersecting side of an IntersectionObserver callback, and the
       viewer is `position:fixed` over a body the pfeed then locks -- so the page behind never scrolls,
       the card's intersection never changes, playIO never fires for it at all, and neither the guard nor
       the `if (!v.paused) v.pause()` below it is ever reached. No amount of fixing the condition helps;
       the observer is not the thing that runs. So the pfeed tells us directly, at its own lock/unlock.

       PAUSE ONLY -- no src teardown, no load(), no mute change. Tearing the element down would collide
       with the hero flight, the deck swap and the data-video-src re-attach; pausing frees the decoder,
       which is the entire cost. `closest('.post')` skips a mid-flight clip that has been re-parented out
       to the body (same element playIO's own mid-flight guard protects), and the hold is applied on a
       delay by the caller so liftoff is long finished before anything is touched.
       Resume restores exactly what was paused and nothing else: it never starts a clip that was already
       paused, never overrides _userPaused, and never writes `muted` -- unmuting a clip running under the
       muted-autoplay allowance silently pauses it on WebKit, so mute state is left exactly as found. */
    /* ---- 2026-09-08: THE HOLD IS A STATE, NOT A ONE-SHOT SWEEP -- AND ITS POPULATION IS ENUMERATED --
       Written as a single sweep fired once at open+1500ms, this covered exactly the clips that were
       playing AT THAT INSTANT and nothing that started afterwards. Measured with
       `C:\tools\pw\bghold-probe.js` (member fixture, phone, the viewer held open 45s over a warm
       timeline, every <video> ever created tracked by WeakRef and HTMLMediaElement.play patched to
       record who called it), TWO later start paths fired and NEITHER was covered:
         +8.3s   an AVATAR 1146px ABOVE the viewport, started by the avatar module's own far-observer
                 resume (avNear) -- it then decoded for 35 of the 45 seconds, behind a full-screen
                 overlay, and off screen even if the overlay had not been there;
         +17.3s  a TIMELINE CARD clip at y=79 (behind the sticky header, fully covered by the viewer),
                 started by playIO's deferred calmPlay -- whose defer only ever re-checks
                 __rovaScrollAt and knows nothing about an overlay.
       Peak 2 simultaneous buried decoders in one open, `_bgHeld` false on both. The page behind a
       `position:fixed` overlay never changes its intersection, so playIO cannot correct this by
       itself; and the two guards that DID exist -- SEL (`.post .media video`) and the orphan sweep's
       `!isConnected` test -- compose into "post clips that are detached", which is not "everything the
       reader cannot see". Same shape, and the same lesson, as
       [[ghost-video-invisible-to-both-governors]]: a guard that selects by CLASS and a guard that
       selects by DETACHMENT do not compose into "all videos". So the population here is now the
       ENUMERATION -- `document.getElementsByTagName('video')` -- and a predicate decides, exactly the
       way the wake-lock governor a few hundred lines up already does it. The state is re-applied on
       the 3-second orphan sweep (no new timer), so ANY future start path is bounded at 3s rather than
       running for the life of the open, and calmPlay declines outright so the common one never starts.

       WHAT IS DELIBERATELY NOT HELD, and why each one:
         - a clip inside the open `.pfeed`: that IS what the reader is looking at;
         - a `.pcell` grid preview: the grid governor already RELEASES every one of them on
           `rova:pfeedready` (all but the donor, whose clip the flight is adopting) and defers its own
           calm-start on `__rovaOverlayOpen` -- measured buriedGrid 0 across the whole 45s. Holding
           them here would put two owners on one decoder and would fight the donor handoff;
         - a clip with NO host, i.e. re-parented to <body> mid-flight: pausing a flying clip
           composites BLACK, which is the bug the original `!v.closest('.post')` guard was written for.
       PAUSE ONLY, as before: no src change, no load(), no preload change, and above all no mute write.
       An AVATAR is handed back to ITS OWN governor rather than resumed blind -- the avatar module only
       ever restarts a clip carrying `__avFarPaused`, so one that is still outside its 150% band when
       the viewer closes keeps that mark and comes back when it is scrolled to, which is byte-for-byte
       the state avFar() would have left it in. */
    var bgOn = false;                                    // the hold is ON (re-applied by the 3s sweep)
    function bgViewerUp() { return !!document.querySelector('.pfeed.show'); }
    function bgHost(v) {                                 // '' = not ours to hold; see the block above
      if (!v || !v.closest) return '';
      if (v.closest('.pfeed')) return '';                // the viewer's own clip
      if (v.closest('.av-vid')) return 'avatar';         // a video avatar, anywhere on the page
      if (v.closest('.pcell')) return '';                // the grid governor owns these
      if (v.closest('.post')) return 'post';
      return '';                                         // mid-flight / unknown: never touched
    }
    // "is this clip buried under the open viewer right now?" -- the one predicate every start path asks.
    function bgBuried(v) { return !!((bgOn && bgHost(v) && bgViewerUp()) || (lhOn && v && !lhOwn(v))); }   // lhOn: the LIVE HOST HOLD below
    window.__rovaBgBuried = bgBuried;
    function bgApply(on) {
      var vids = document.getElementsByTagName('video');   // ENUMERATED, never class-selected
      for (var i = 0; i < vids.length; i++) {
        var v = vids[i], host = bgHost(v);
        if (on) {
          /* `_bgHeld` IS NOT AN EARLY-OUT, AND MAKING IT ONE PUT THE WHOLE BUG BACK. The first build of
             this skipped any element already marked, on the reasoning that it had been dealt with --
             but "already dealt with" is a claim about the past and `paused` is the claim about now.
             Measured on the served bundle: a card clip marked at the arm was re-started at +35s by a
             `play` handler on the element itself and then ran for the rest of the open, `_bgHeld`
             true the whole time, because every later sweep saw the mark and moved on. The only
             condition that may end this loop is the clip being STOPPED. */
          if (!host || v.paused) continue;
          if (!v._bgHeld) { v._bgHeld = host; }          // truthy, and remembers WHICH governor to hand back to
          clearTimeout(v._playT);                        // don't let a deferred calmPlay restart it underneath
          if (host === 'avatar') { v.__avFarPaused = 1; }
          try { v.pause(); } catch (e) {}
        } else {
          if (!v._bgHeld) continue;
          var was = v._bgHeld; v._bgHeld = 0;
          if (lhOn && !lhOwn(v)) { v._lhHeld = was; continue; }   // the live host hold still owns it: its release resumes it
          if (v._userPaused || !host) continue;
          if (was === 'post' && !feedPref('autoplay', true)) continue;
          var near;
          if (was === 'avatar') {
            // the avatar module's own band (farIO rootMargin 75% since 2026-09-18), so "near" means here what it
            // means there -- anything outside it keeps __avFarPaused and is that module's to restart
            var r = null; try { r = v.getBoundingClientRect(); } catch (e) {}
            near = !!(r && r.width > 0 && r.bottom > -innerHeight * 0.75 && r.top < innerHeight * 1.75);   // = farIO's 75% band (2026-09-18)
            if (near) { v.__avFarPaused = 0; }
          } else {
            near = inView(v);                            // scrolled off while the viewer was up: leave it
          }
          if (!near) continue;
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        }
      }
    }
    window.__rovaBgHold = function (on) { bgOn = !!on; bgApply(!!on); };
    // owner/harness visible: what the hold thinks it is holding, and whether anything slipped past it
    window.__rovaBgHoldStats = function () {
      var vids = document.getElementsByTagName('video'), held = 0, buried = 0, n = 0;
      for (var i = 0; i < vids.length; i++) {
        var v = vids[i]; if (!bgHost(v)) continue;
        n++; if (v._bgHeld) held++;
        if (bgOn && bgViewerUp() && !v.paused) buried++;
      }
      return { on: bgOn, viewerUp: bgViewerUp(), candidates: n, held: held, buriedPlaying: buried };
    };

    /* ---- THE LIVE HOST HOLD: NOTHING ELSE DECODES VIDEO WHILE THE BROWSER HOST BROADCASTS (2026-10-05) ----------------
       iOS live #801: a feed clip playing in a profile sheet over the live stalled the camera for ~7 s. On /live/browser the
       page's own WebCodecs encoder needs the decoder/GPU budget, so while it is on air (assets/livebrowser.js sets
       html.lb-onair and fires `rova:livehold`) EVERY <video> that is not the live's own is held, by the same means as
       __rovaBgHold above and for the same reason (enumerate, never class-select):
         - post / grid / viewer / DM / hovercard clips: paused, and bgBuried() answers true for them, so calmPlay, playIO
           and the avatar band decline to start them; a `play` that gets through anyway (any start path, any module) is
           paused in the capture phase; one restarted again and again (a watchdog fighting us) loses its source;
         - a VIDEO AVATAR (.av-vid) becomes its still (the poster view.php hands us, the same swap the autoplay-refused
           fallback does), before it decodes when it arrives during the hold;
         - an <img> carrying a clip (the chat / battle / gift rows get Api::avatarUrl, which is the `_av.mp4` for a video
           avatar, and WebKit DECODES an mp4 in an <img>) is re-pointed at the clip's `_ap.jpg` still.
       THE LIVE'S OWN media is never touched: anything fed a MediaStream (the camera, the call's remote cameras, probes),
       the battle opponent's player (.lbt-rv), a gift's stacked video (.gfx-vsrc; gifts.js skips those on air anyway).
       The release (end of the live) resumes only what this paused and only what is in view; stills stay stills. */
    var lhOn = false, lhMO = null, lhHeldN = 0, lhStillN = 0, lhImgN = 0, lhStripN = 0;
    var LH_CLIP = /(_av|_am)?\.(mp4|mov|webm|m4v)(?=[?#]|$)/i;
    function lhOwn(v) {
      if (!v) return true;
      if (v.srcObject) return true;
      var c = v.classList;
      return !!(c && (c.contains('lbt-rv') || c.contains('gfx-vsrc')));
    }
    function lhStillSrc(u) {   // a clip URL -> its still ('' when it isn't a clip): Upload::avatarPosterPath beside the stored file
      u = String(u || '');
      if (!LH_CLIP.test(u)) return '';
      return u.split(/[?#]/)[0].replace(LH_CLIP, '_ap.jpg');
    }
    window.__rovaStillSrc = function (u) { if (!lhOn) return u; var s = lhStillSrc(u); return s || u; };
    function lhImg(im) {   // asked of the CURRENT src every time: a row that re-points its <img> at a clip later is caught again
      var s = lhStillSrc(im.getAttribute('src'));
      if (!s) return;
      lhImgN++;
      if (!im._lhStill) {
        im._lhStill = 1;
        // the rare clip with no still on disk: an empty circle, never a broken-image glyph (an <img class="avatar"> has
        // avatarGiveUp's monogram already; the chat/battle/gift rows don't). Checked after the CDN-miss origin retry.
        im.addEventListener('error', function () {
          setTimeout(function () { if (im.complete && !im.naturalWidth && /_ap\.jpg/.test(im.getAttribute('src') || '')) im.style.visibility = 'hidden'; }, 1500);
        });
      }
      im.setAttribute('src', s);
    }
    function lhAvatar(v) {   // a video avatar -> its still, in the same .av-vid box (keeps the size class and any gate)
      var box = v.parentNode, src = v.getAttribute('poster') || v.getAttribute('data-poster') ||
                lhStillSrc(v.getAttribute('src') || v.getAttribute('data-src') || '');
      if (!box || !src) { try { v.pause(); } catch (e) {} v.__avFarPaused = 1; return; }
      v.__avStill = 1; lhStillN++;
      var im = document.createElement('img');
      im.alt = ''; im.decoding = 'async'; im.src = src;
      box.replaceChild(im, v);
      try { v.pause(); v.removeAttribute('src'); v.load(); } catch (e) {}   // release the decoder
    }
    function lhVid(v, played) {
      if (lhOwn(v) || v.__avStill) return;
      var av = v.parentNode && v.parentNode.classList && v.parentNode.classList.contains('av-vid');
      if (av) { lhAvatar(v); return; }
      if (played) {
        v._lhPlays = (v._lhPlays || 0) + 1;
        if (v._lhPlays > 3) {          // restarted over and over under the hold: a fight, so take the source away
          lhStripN++;
          try { v.pause(); if (v._hls) { v._hls.destroy(); v._hls = null; v._hlsWired = 0; } v.removeAttribute('src'); v.load(); } catch (e) {}
          v._lhHeld = 'stripped';
          return;
        }
      }
      if (v.paused) return;
      if (!v._lhHeld) { v._lhHeld = bgHost(v) || 'clip'; lhHeldN++; }
      clearTimeout(v._playT);
      try { v.pause(); } catch (e) {}
    }
    function lhScan(n) {
      if (!n || n.nodeType !== 1) return;
      var t = n.tagName, i, l;
      if (t === 'IMG') { lhImg(n); return; }
      if (t === 'VIDEO') { lhVid(n, false); return; }
      if (!n.getElementsByTagName) return;
      l = n.getElementsByTagName('img'); for (i = 0; i < l.length; i++) lhImg(l[i]);
      l = n.getElementsByTagName('video'); for (i = l.length - 1; i >= 0; i--) lhVid(l[i], false);   // backwards: an avatar swap removes it from the live list
    }
    function lhApply(on) {
      var vids = document.getElementsByTagName('video'), i, v;
      if (on) { lhScan(document.documentElement); return; }
      for (i = vids.length - 1; i >= 0; i--) {
        v = vids[i];
        if (!v._lhHeld) continue;
        var was = v._lhHeld; v._lhHeld = 0; v._lhPlays = 0;
        if (was === 'stripped' || v._userPaused) continue;
        if (bgBuried(v)) { v._bgHeld = bgHost(v); continue; }   // a viewer is up over it: the background hold owns it now
        if (was === 'post' && !feedPref('autoplay', true)) continue;
        if (!inView(v)) continue;
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      }
    }
    function lhSet(on) {
      on = !!on;
      if (on === lhOn) return;
      lhOn = on;
      if (on) {
        if (!lhMO && window.MutationObserver) {
          lhMO = new MutationObserver(function (recs) {
            for (var i = 0; i < recs.length; i++) {
              var r = recs[i];
              if (r.type === 'attributes') { lhScan(r.target); continue; }
              for (var j = 0; j < r.addedNodes.length; j++) lhScan(r.addedNodes[j]);
            }
          });
        }
        if (lhMO) lhMO.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'data-src'] });
      } else if (lhMO) {
        lhMO.disconnect();
      }
      lhApply(on);
    }
    document.addEventListener('play', function (e) {   // the net under every start path, in every module
      var v = e.target;
      if (lhOn && v && v.tagName === 'VIDEO') lhVid(v, true);
    }, true);
    document.addEventListener('rova:livehold', function (e) { lhSet(!!(e && e.detail && e.detail.on)); });
    if (document.documentElement.classList.contains('lb-onair')) lhSet(true);   // livebrowser.js ran first (this file is later in the page)
    window.__rovaLiveHold = lhSet;
    window.__rovaLiveHoldStats = function () {
      var vids = document.getElementsByTagName('video'), playing = 0, own = 0, n = 0;
      for (var i = 0; i < vids.length; i++) {
        var v = vids[i]; n++;
        if (lhOwn(v)) { own++; continue; }
        if (!v.paused) playing++;
      }
      return { on: lhOn, videos: n, own: own, othersPlaying: playing, held: lhHeldN, avatarStills: lhStillN, imgStills: lhImgN, stripped: lhStripN };
    };

    /* ---- COMING BACK FROM ANOTHER APP MUST NOT LAND ON A SPINNER (owner 2026-08-14) -------------
       "I swiped out of Safari and came back to it and it won't continue playing the video. Just
       spinning and loading." -- iOS Safari, immersive viewer, a clip frozen at 0:11 of 1:30 with the
       buffering ring turning over a dead frame. Battery 12%, which matters; see LOW POWER MODE below.

       WHAT WAS MISSING WAS EVERYTHING, not a broken handler. There is no visibility handling for post
       media anywhere in this file. __rovaBgHold above pauses and resumes the page BEHIND the viewer,
       but it hangs off pfLock/pfUnlock -- the viewer opening and closing -- and never sees an app
       switch. pfLandingAutoplay's pump runs once, at open, and is long expired. The avatar block has
       a visibilitychange sweep; the clips have none. So the only thing that ran on return was the
       buffering sampler in buildControls, which did its job perfectly and reported a genuinely stuck
       clock forever. THE RING WAS RIGHT. Nothing was listening for the return.

       THE ELEMENT COMES BACK IN ONE OF TWO STATES AND THEY NEED DIFFERENT MEDICINE:
         (a) PAUSED -- iOS stopped the media on the way out. play() is the whole fix.
         (b) UNPAUSED WITH A DEAD CLOCK -- the reported one, and the ring is the proof: bufSample()
             only ever paints while `!v.paused`, and a paused clip clears it within one 200ms tick,
             so a ring that SURVIVES the return means the element still believes it is playing.
             WebKit dropped the decode/HLS pipeline underneath it. play() is a no-op on a clip that
             is not paused, which is exactly why a naive resume-on-foreground would have changed
             nothing at all for him. The source has to be poked.

       THE LADDER, capped at TWO recovery rungs and then an honest surrender:
         0. play(), if it is paused -- and nothing else. No mute write, no engVideo(), no attention
            hold: coming back to the tab is not an act of engagement, and arming one here would
            freeze the timeline for two minutes on an app switch.
         1. clock still dead after RES_WATCH_MS -> SEEK IN PLACE (currentTime = currentTime). The
            cheapest thing that makes WebKit rebuild a pipeline: no bytes, no source change, and it
            re-arms the buffering sampler through `seeking` on its way past.
         2. still dead -> RE-ATTACH THE SOURCE at the saved position, through the exact keepPos() +
            resumeAfterSwap() pair attachHls's own manifest-error fallback uses. No URL is built
            here and none is chosen: it is the element's own src, or the mp4 wire() stashed in
            _mp4src for a clip the recycler hard-released.
         3. still dead, or play() was REFUSED at any rung -> stop spinning and say so.

       LOW POWER MODE IS WHY STEP 3 EXISTS. At 12% battery iOS has almost certainly offered Low Power
       Mode, and under LPM WebKit refuses a programmatic play() outright -- the same platform veto the
       video-avatar block gives up to rather than retrying, and the same one pfLandingAutoplay already
       reports with .pf-tapplay. A resume that only ever called play() would have failed silently for
       precisely the reader who filed this, leaving the ring he photographed exactly where it was.

       SO A REFUSAL IS HANDLED, NOT SWALLOWED, AND IT IS ONE CALL: v.pause(). buildControls already
       listens for `pause` on this element and that listener runs buffOff() + bufStop() -- THE RING
       COMES DOWN, because the clock is not advancing due to being PAUSED, not stalled -- and
       syncPlay() flips the transport glyph to Play and lands `vc-paused` on the host, which is what
       makes the bar reachable at all on a touch screen. Then wake the chrome through the __vcShow
       the bar publishes (showBar() deliberately leaves the bar OPEN while paused), and in the viewer
       raise the same "Tap to play" affordance the landing pump uses. Nothing here reaches into
       buildControls' closure and nothing duplicates its state.
       _userPaused is deliberately NOT set on the way out: the reader did not pause this clip, and
       marking it would tell playIO, the transport and pfTapPlayGo to stop asking.

       MUTE IS NEVER WRITTEN, IN EITHER DIRECTION. The clip resumes exactly as it went away -- a muted
       clip stays muted, and an unmuted one is NOT re-muted to buy a play(). That last half is the
       trap soundRepair() spells out ("Re-muting first does not fix the collision, it ARMS IT AGAIN"),
       and an unstamped mute here would additionally be read by the volumechange handler as the reader
       reaching for the speaker, flipping soundOn and the saved site-wide rova_sound preference. An
       unmuted resume the platform refuses lands on the affordance instead, where a real gesture makes
       unmuted playback legal anyway (pfTapPlayGo touches no mute, for the same reason).

       BELT AND BRACES ON THE EVENTS, because Safari is not Chromium here. `visibilitychange` is the
       one both agree on; `pagehide`/`pageshow` are the bfcache pair Safari leans on hardest and an
       app-switch return can arrive as a bfcache restore; `freeze`/`resume` are Chromium-only and
       cost nothing to bind; `focus` is the backstop for an engine that fires none of them on a
       window-level switch. All five funnel into the same two functions, both idempotent, and
       resShow() is free (no DOM query at all) unless a hide actually armed it. */
    var RES_WATCH_MS = 1000;    // clock must move within this after a rung, or take the next one
    var RES_LAST_MS  = 1400;    // ...longer after the re-attach: it has to fetch metadata and re-seek first
    var RES_RECENT_MS = 1500;   // "it was playing a moment ago" -- see resHide
    var _resArmed = 0;
    /* ONE listener for the whole document instead of one per clip. Media events do not bubble, but a
       non-bubbling event still propagates to ancestors in the CAPTURE phase -- the same trick the
       avatar block uses for loadedmetadata/canplay, and one listener beats a MutationObserver or a
       per-element binding in wire() on a feed that mutates constantly. */
    document.addEventListener('pause', function (e) {
      var t = e && e.target;
      if (t && t.tagName === 'VIDEO') { t._resPauseAt = Date.now(); }
    }, true);
    /* ---- THE POPULATION IS ENUMERATED, NOT CLASS-SELECTED (2026-09-19) ---------------------------
       This governor used to walk `SEL` ('.post .media video'), which is a statement about ONE surface
       and not about "every clip that could be decoding for nobody". The live watch page's player is
       `.live-stage > video#live-player` -- autoplay, muted, an HLS stream -- so it fell exactly into
       the gap [[ghost-video-invisible-to-both-governors]] is about and kept decoding a LIVE stream in
       a backgrounded tab (measured on the shipped bundle `app.d72c3a79c5cb`: paused === false and
       _hidHeld never set through a 30s hidden window). The memory's rule, applied: enumerate
       `document.getElementsByTagName('video')` and let a PREDICATE decide, so a clip with no class --
       or one a module written next month adds -- lands in a defined bucket instead of being invisible.

       THE DEFAULT IS "OURS", which is the opposite of bgHost()'s default, and deliberately so. bgHost
       is deciding whether to pause something possibly mid-flight over an open viewer, where the wrong
       answer composites black. The question HERE is "is this decoding in a tab with no reader", and an
       unrecognised <video> in that state is precisely the leak, not the risk. Only the two surfaces
       that already run their OWN hidden-tab handler are handed back -- two governors on one element is
       how an avatar ends up frozen for the rest of the page:
         .pcell    the grid governor's `_grHidHeld` pause/resume pair   (idle-cost audit, 2026-09-18)
         .av-vid   the avatar module's `__avHidPaused` + `__avFarPaused` pair (same audit)
       Everything else -- post cards, the viewer's own clips, the live player, a quoted clip, an admin
       preview, an embed -- is ours, and the existing rules below decide what actually happens to it
       (only a MUTED, playing, not-user-started clip is ever paused; the snapshot/resume is unchanged).
       `SEL` is left alone everywhere else on purpose: the feedpref handler below really is about the
       FEED's autoplay setting, and turning that off must not stop a live stream. */
    function resOwn(v) {
      if (!v || !v.closest) return false;
      if (v.closest('.pcell')) return false;    // grid governor owns it (_grHidHeld)
      if (v.closest('.av-vid')) return false;   // avatar governor owns it (__avHidPaused)
      return true;
    }
    function resVids() {
      var all = document.getElementsByTagName('video'), out = [], i;
      for (i = 0; i < all.length; i++) { if (resOwn(all[i])) { out.push(all[i]); } }
      return out;
    }
    window.__rovaResPop = function () {        // named for the verification harness: what this owns now
      return resVids().map(function (v) { return { id: v.id || '', cls: v.className || '', paused: v.paused, muted: v.muted, hidHeld: !!v._hidHeld }; });
    };
    function resHide() {
      _resArmed = 1;
      resVids().forEach(function (v) {
        if (v._userPaused || v.ended) { v._resWant = 0; return; }   // their call, or it is over
        if (v._bgHeld) { v._resWant = 0; return; }                  // __rovaBgHold owns this one; pfUnlock resumes it
        /* THE ORDER OF `pause` AND `visibilitychange` IS NOT GUARANTEED. iOS can stop the media
           BEFORE it tells us the page went away, and a snapshot that only asked `!v.paused` would
           then record "it was not playing" for the very clip this whole block exists to bring back.
           So a clip that paused a moment ago, without the reader asking, still counts. */
        var recent = (Date.now() - (v._resPauseAt || 0)) < RES_RECENT_MS;
        if (!v.paused || recent) {
          v._resWant = 1;
          try { v._resAt = v.currentTime || 0; } catch (er) { v._resAt = 0; }
        } else { v._resWant = 0; }
        /* ...AND STOP THE MUTED ONE OURSELVES (idle-cost audit, 2026-09-18). This snapshot used to be the
           whole of the hide path: it RECORDED what was playing and left the element running, on the
           theory that the platform pauses it (iOS does, at screen lock). Chromium and Firefox do not
           pause a muted clip in a backgrounded tab -- measured on the served bundle: a timeline clip
           decoded 60 frames/s for the whole of a 12 s hidden window, for nobody. A MUTED clip in a
           hidden tab has no viewer and no listener, so it is paused here, marked `_hidHeld` so
           resKick's autoplay-preference gate lets it back (a hold is not a preference), and the
           snapshot above (already taken: `_resWant` is 1) brings it back on the same path as an
           iOS-paused clip -- resShow -> resKick -> resRung(0) -> play() -> the clock check.
           (Until 2026-10-02 an UNMUTED clip and a hand-started (_userPlayed) one were left running here
           as a "background-tab listen" -- SUPERSEDED, see below. The engage-hold concern is kept: the
           `off` listener at the top of this file ignores a pause made while `_hidHeld` is set.) */
        /* 2026-10-02 (Rob: "something is leaving it on even when I background, close the app, or use the website in
           Safari"): THE UNMUTED AND THE TAPPED CLIP ARE PAUSED TOO. Every post clip loops, so an audible one left
           running in a background tab played forever, with the lock screen's Now Playing still saying "playing" --
           and the live player kept streaming to nobody. A hidden page is not being watched; it comes back on the
           same resume path as every other held clip (and the lock-screen play button still resumes it on purpose).
           Only a clip in a picture-in-picture window the reader opened is left alone: that window IS on screen.
           `_hidHeld` also tells engVideo's `pause` listener this is not the reader letting go of a tapped clip. */
        var pip = document.pictureInPictureElement === v || v.webkitPresentationMode === 'picture-in-picture';
        if (v._resWant && !v.paused && !pip) { v._hidHeld = 1; try { v.pause(); } catch (er) {} }
      });
      // the media session's state follows NOW (a hidden tab's timers may never run on iOS): 'paused', not 'playing'
      if (window.__rovaWakeTick) { try { window.__rovaWakeTick(); } catch (er) {} }
    }
    function resShow() {
      if (!_resArmed || document.hidden) return;
      _resArmed = 0;
      var seen = [];
      // The viewer's CURRENT clip first and by name: on a carousel post SEL matches every slide's
      // video, and only pfCurrentVideo() knows which one is actually paged into view.
      var pf = document.querySelector('.pfeed.show');
      var pv = (pf && window.__rovaPfCurrentVideo) ? window.__rovaPfCurrentVideo() : null;
      if (pv) { seen.push(pv); resKick(pv); }
      // ...and the same courtesy for every other clip this governor owns (see resOwn above): identical
      // primitive, and the inView() gate below means anything the reader cannot see declines on its own.
      resVids().forEach(function (v) {
        if (seen.indexOf(v) >= 0) return;
        resKick(v);
      });
    }
    function resKick(v) {
      if (!v || !v._resWant) return;
      v._resWant = 0;
      if (v._resBusy) return;
      if (v._userPaused || v._released || v._recycled || v._bgHeld || !v.isConnected) return;
      var hid = v._hidHeld; v._hidHeld = 0;                  // resHide's own pause: a hold, not a preference -- always let it back
      if (!hid && !feedPref('autoplay', true)) return;       // the gear setting still owns this
      if (document.pictureInPictureElement === v) return;    // popped out: it never stopped
      if (!inView(v)) return;                                // scrolled off before the switch: playIO owns it
      v._resBusy = 1;
      resRung(v, 0);
    }
    function resRung(v, n) {
      if (!v.isConnected || v._userPaused || v._released) { resDone(v); return; }
      var t0 = 0; try { t0 = v.currentTime || 0; } catch (e) {}
      if (n === 1) {
        try { v.currentTime = v.currentTime; } catch (e) {}   // seek in place: rebuild the pipeline, fetch nothing
      } else if (n === 2) {
        var src = v.getAttribute('src') || v._mp4src || '';
        /* hls.js owns the element through a MediaSource blob: reassigning THAT is not a reload, it is
           a teardown with no way back. iOS -- the surface this exists for -- never takes that path
           (native HLS, see attachHls), so the honest move is to stop climbing and offer the tap. */
        if (!src || v._hls) { resGiveUp(v); return; }
        var back = keepPos(v);
        try { v.src = src; v.load(); } catch (e) {}
        back();
        resumeAfterSwap(v, true);
      }
      if (v.paused) {
        var p = null, threw = false;
        try { p = v.play(); } catch (e) { threw = true; }
        if (threw) { resGiveUp(v); return; }
        // THE REJECTION IS THE LOW-POWER-MODE SIGNAL and it is authoritative: play() rejects with
        // NotAllowedError after running the internal pause steps, so the element is genuinely paused
        // by the time this fires and bufSample()'s `!v.paused` gate already refuses to paint a ring.
        if (p && p.catch) { p.catch(function () { resGiveUp(v); }); }
      }
      /* DID THE CLOCK ACTUALLY MOVE? `paused === false` is not playback -- it is the exact lie the
         reported clip was telling. Only the clock answers, which is the same rule bufSample lives by.
         Math.abs, not `>`: a looping clip resuming near its end wraps to 0 and that is still alive. */
      clearTimeout(v._resT);
      v._resT = setTimeout(function () {
        v._resT = null;
        if (!v.isConnected || v._userPaused || v._released) { resDone(v); return; }
        var ct = 0; try { ct = v.currentTime || 0; } catch (e) {}
        if (!v.paused && Math.abs(ct - t0) > 0.04) { resDone(v); return; }   // moving: done
        if (n >= 2) { resGiveUp(v); return; }                                // two rungs spent
        resRung(v, n + 1);
      }, n >= 2 ? RES_LAST_MS : RES_WATCH_MS);
    }
    function resDone(v) { clearTimeout(v._resT); v._resT = null; v._resBusy = 0; }
    function resGiveUp(v) {
      resDone(v);
      try { if (!v.paused) v.pause(); } catch (e) {}   // the one call that makes every readout honest (see above)
      /* INSURANCE ON THE ONE CLASS THAT MUST NOT SURVIVE. The `pause` above normally clears it
         through buildControls' own listener, but a sampler whose closure has been RETIRED (the host
         rewired to another clip) deliberately goes without unpainting -- so a ring can outlive its
         owner. We know for a fact this clip is paused, so removing it can never be wrong.
         `_bufOwner` is the host buildControls recorded for exactly this kind of question. */
      var own = v._bufOwner;
      if (own && own.classList) { own.classList.remove('vc-buffering'); }
      // WAKE THE CHROME so the true (paused) state is visible rather than merely correct. showBar()
      // leaves the bar open while paused, which is what we want here.
      var unit = v.closest ? (v.closest('.cslide') || v.closest('.media')) : null;
      var wake = (unit && unit.__vcShow) || (own && own.__vcShow);
      if (wake) { try { wake(); } catch (e) {} }
      // ...and in the viewer, offer the gesture the platform is holding out for -- the SAME affordance
      // pfLandingAutoplay raises for the same veto, so there is one "Tap to play" on this site and one
      // set of rules for dismissing it (it removes itself on a real `playing`, whatever started it).
      if (window.__rovaPfTapPlay && window.__rovaPfCurrentVideo && window.__rovaPfCurrentVideo() === v) {
        try { window.__rovaPfTapPlay(true); } catch (e) {}
      }
    }
    document.addEventListener('visibilitychange', function () { if (document.hidden) resHide(); else resShow(); });
    window.addEventListener('pagehide', resHide);   // ...targets the Window, so it is bound here
    window.addEventListener('pageshow', resShow);   // Safari's bfcache restore path, same
    // Page Lifecycle (Chromium only; Safari fires neither) dispatches these AT THE DOCUMENT and they
    // do NOT bubble, so a window listener would silently never fire.
    document.addEventListener('freeze', resHide);
    document.addEventListener('resume', resShow);
    window.addEventListener('focus', resShow);      // backstop: an engine that reports neither on a switch
    window.__rovaVidResume = resShow;               // named for the verification harness, and for a manual poke

    // flipping autoplay off silences the feed right away
    document.addEventListener('rova:feedpref', function (e) {
      if (e.detail && e.detail.key === 'autoplay' && !e.detail.on) {
        Array.prototype.forEach.call(document.querySelectorAll(SEL), function (v) {
          if (!v.paused) v.pause();
        });
      }
    });

    /* ---- THE 1MB HEAD START, as a function both warm tiers can reach (extracted 2026-09-10) ------
       It was written inline in calmWarm's far branch; the slow-line downgrade below needs the exact
       same thing, and a second copy of a fetch that claims a scheduler slot and owns an
       AbortController is precisely the kind of duplicate that drifts. Nothing about its behaviour
       changed in the extraction: same 1MB Range, same cors/credentials-omit shape so the cache entry
       is reusable by the media stack, same once-per-clip `_headStart` claim RELEASED on failure, and
       the same `_vsFetch` handle so vsYield can still abort it.
       No deadline, on purpose: 1MB legitimately takes ~6s on congested LTE and ~20s on 3G, and this
       fetch pins nothing but its own flag.
       START PATH 3a of 7 (scroll, ambient) -- and the one the acceptance metric CANNOT SEE. This is
       a megabyte of media bytes off the same radio as the clip being watched, so it is metered like
       any other start; the AbortController is what makes the eviction real rather than bookkeeping. */
    function warmHeadStart(v) {
      if (v._headStart) { return; }
      v._headStart = 1;
      var hu = v.getAttribute('src') || v._mp4src || '';
      if (!hu || /giphy\.com/i.test(hu)) { return; }
      /* REMOTE CLIPS (Cloudflare Stream: long replays db/0209, uploads db/0246) are never head-started. Their MP4 302s
         to a tokenised URL with no Access-Control-Allow-Origin, so this cors fetch can only fail -- and a failure
         releases the claim below, which made calmWarm re-fire it every 700 ms (a 302 + a console CORS error each time)
         while the clip sat in the far band (2026-10-06 web composer rig). The claim stays set: nothing to retry. */
      if (v.getAttribute('data-remote') || /\.cloudflarestream\.com\//i.test(hu)) { return; }
      var hac = null;
      try { hac = (typeof AbortController === 'function') ? new AbortController() : null; } catch (e) { hac = null; }
      v._vsFetch = hac;
      if (window.__rovaVidStart) { window.__rovaVidStart(v); }
      var hdone = function () { v._vsFetch = null; if (window.__rovaVidDrop) { window.__rovaVidDrop(v); } };
      try { fetch(hu, { headers: { Range: 'bytes=0-1048575' }, mode: 'cors', credentials: 'omit', priority: 'low', signal: hac ? hac.signal : undefined })
              .then(function (res) { hdone(); if (!res.ok) { v._headStart = 0; } })
              .catch(function () { hdone(); v._headStart = 0; }); } catch (e) { hdone(); v._headStart = 0; }
    }
    /* ---- WHICH "SLOW" THE HEAVIEST AMBIENT START ASKS ----------------------------------------------
       The PUBLISHED wrapper (__rovaNetSlow), not the local netIsSlow() the manifest prefetch further
       down uses, because the wrapper remembers a definite reading for 90s and this gate NEEDS that
       memory: netBps() only counts transfers >=40KB, and on a viewer page the neighbour buffer fill
       is most of what produces them -- so this gate working is what starves the signal that keeps it
       closed. A gate that switches itself off by working is an oscillator. Measured 2026-09-10: a
       build of this gate with NO memory stood down at t=58s of a 70s run on a 1.2Mbps line and
       immediately buffered 12 seconds of a post the reader never reached, in 2 of 3 runs.

       From 2026-09-10 to 2026-09-11 this function carried a private 90s latch on top of the wrapper,
       because the wrapper's own memory was unreachable on Chrome (its navigator.connection estimate
       was consulted BEFORE the sticky reuse -- see the comment at __rovaNetSlow). The wrapper was
       reordered 2026-09-11 so the memory comes first, and the latch here was removed: two stacked 90s
       memories would hold a reader who walked from LTE onto wifi for up to 180s, and the wrapper is
       shared with pfBytesIO, lineIsTight and slowNow, so one memory in one place is the honest shape.
       Re-measured with the latch gone (scratchpad/vsplit.js + vsagg.js, same 1.2Mbps line): 0
       speculative buffer on unreached posts, same as with the latch. */
    function warmLineSlow() {
      try { return window.__rovaNetSlow ? !!window.__rovaNetSlow() : netIsSlow(); } catch (e) { return netIsSlow(); }
    }

    var warmHandler = function (ents) {   // buffer ahead of arrival
      ents.forEach(function (en) {
        if (!en.isIntersecting) return;
        var v = en.target;
        if (v._instant) return;        // the just-tapped clip is already playing its mp4 -- warming it would
                                       // swap it to HLS and v.load() would reset it, killing the instant open
        if (v.closest && !v.closest('.post')) return;   // mid-flight in a hero wrapper: the flight owns it (same guard as playIO)
        v._recycled = 0;               // coming back into range: allow it to rebuild (see teardownVideo)
        if (v._posterStash && !v.getAttribute('poster')) { v.setAttribute('poster', v._posterStash); v._posterStash = null; }
        // Prefetch the POSTER frame into the HTTP cache so a clip you swipe to paints its first frame
        // INSTANTLY instead of showing a black box that fills up the screen before the video decodes.
        // That black-then-pop was the "choppy" swipe on iOS -- the old slow native scroll hid it only
        // because the media had ~1s to load during the deceleration; the fast landing outruns it, so we
        // have to actually have the poster ready. (Poster restore + warm stay IMMEDIATE -- they're one
        // <img> fetch, no decoder -- only the HEAVY buffering below is calm-deferred.)
        var ps = v.getAttribute('poster');
        if (ps && !v._posterWarmed) { v._posterWarmed = 1; var pim = new Image(); pim.src = ps; }
        /* ...AND PUT THAT POSTER ON SCREEN, not just in the HTTP cache (2026-08-30, the owner's
           "swiping to a video on web and it flashes to black"). Warming the bytes only helps if
           something paints them, and the pfeed's stand-in was never armed on approach -- see
           armPfPoster in the pfeed IIFE for the whole story. This is the EARLY arm: two posts of
           lead is enough for the stand-in's <img> to decode, so the card is covered before the
           reader gets to it rather than starting to cover itself once they arrive. Idempotent, and
           a no-op for a clip that already has a frame or has no poster to show. */
        if (ps && window.__rovaArmPfPoster && v.closest && v.closest('.pfeed')) {
          try { window.__rovaArmPfPoster(v.closest('.post')); } catch (e) {}
        }
        warmUnobserve(v);
        // GRID DISCIPLINE (round 129): don't BUFFER mid-fling either. A rapid swipe burst used to
        // preload=auto + load() every clip it passed (plus a manifest-prefetch fetch storm) -- with the
        // deferred plays above, that churn was the iOS tab kill. Wait for the swipe to calm, and if the
        // clip has meanwhile flown far past, skip the work entirely and re-arm the observer for its return.
        (function calmWarm() {
          if (v._released || v._instant || !v.paused) return;   // playing (playIO beat us): load() would reset it
          if (Date.now() - (window.__rovaScrollAt || 0) < 160) { setTimeout(calmWarm, 140); return; }
          if (!v.isConnected) return;                            // pruned mid-defer: nothing to warm
          var r = v.getBoundingClientRect(), vh = window.innerHeight || 800;
          // "flew past" must be judged BEYOND the warm margin (200% = 2 viewports), not inside it: with the
          // old vh*2 threshold, a clip becoming "+2 ahead" fired warmIO exactly AT the boundary, got bailed
          // as flown-past, re-observed, fired again -- a loop that NEVER buffered it. That's why the look-
          // ahead "worked at the beginning then stopped a few posts down" (owner). 2.5 viewports of slack.
          if (r.bottom < -(vh * (PF_LA + 0.5)) || r.top > vh * (PF_LA + 1.5)) { try { warmObserve(v); } catch (e) {} return; }   // genuinely flown past (beyond the warm margin + slack): no buffer
          // NEVER reset a clip the reader can still SEE: v.load() below blanks the element until the poster /
          // first frame re-decodes, and the .media backdrop showed through as a BLACK flash on the clip being
          // scrolled past (playIO pauses it at <55%, then this warm re-load()ed it still half on-screen --
          // owner: "some videos turn black when I'm scrolling past them"). Defer until it's fully off-screen;
          // every retry re-runs the full check chain (released / instant / resumed-playing all bail above).
          if (r.bottom > 0 && r.top < vh) { setTimeout(calmWarm, 400); return; }
          // HEAD START vs FULL BUFFER (owner: "do we have to download the whole video ahead, or just the
          // beginning?"): only the IMMEDIATE next/prev clip gets the element-level preload=auto buffer below
          // (genuinely play-ready for the drag-reveal). Farther clips inside the warm window get a capped
          // 1MB RANGE prefetch into the HTTP cache -- the faststart mp4's first ~1-3s -- so the moment they
          // BECOME the neighbor, preload=auto fills from disk instead of the network. Cuts the per-clip
          // prefetch from browser-chosen (often many MB) to 1MB without losing the instant start. The fetch
          // is cors/credentials-omit to match the <video crossorigin=anonymous> request, so the cache entry
          // is reusable by the media stack (Chrome serves media range requests from cached 206 prefixes;
          // on Safari it's a harmless no-op and the neighbor-tier auto-buffer still covers it).
          var pastEdge = Math.max(r.top - vh, -r.bottom);        // px beyond the viewport edge (0 = touching)
          if (pastEdge > vh * 1.2) {
            // _headStart is a once-per-clip claim, so it MUST be released when the range request fails
            // -- otherwise one tunnel means this clip is never head-started again this session and it
            // lands on the reader cold. warmHeadStart does that; see its note above. Because it is
            // only ever armed beyond 1.2 viewports FROM HERE, this is always the furthest holder from
            // centre -- the first thing the scheduler surrenders, never a gate.
            warmHeadStart(v);
            setTimeout(calmWarm, 700);                           // re-check: upgrade to the full buffer once it nears
            return;
          }
          /* ---- THE NEIGHBOUR TIER STANDS DOWN TO A HEAD START ON A SLOW LINE (2026-09-10) ---------
             The manifest prefetch fifteen lines below has been gated on netIsSlow() since 2026-07-29,
             with a measured justification -- and the HEAVIER of the two, the one the note below calls
             "the single heaviest ambient start on the surface", had no bandwidth check at all. That
             asymmetry was the bug: we were declining to spend 5KB of playlist text on a congested
             line while still handing the same line an unbounded, browser-chosen buffer fill for a
             clip nobody has opened.

             MEASURED on /p/49652 at 1.2Mbps / 250ms RTT, 70s, phone viewport, member fixture, one
             bundle per arm pinned so nothing else differs and the arms ALTERNATED within each batch
             (scratchpad vsplit.js / vsagg.js). Two interleaved batches, 6 runs per side, medians.
             The clip being WATCHED there is on the HLS ladder -- wire()'s sustained-stall recovery
             hands it over within ~5s on this line -- so its progress IS the arrival of its own
             playlist and first segment:
                                          ungated (today)   downgraded to a head start
               master_lo.m3u8 first byte        9.0 s                  5.4 s
               360p.m3u8      first byte       19.3 s                 13.3 s
               360p_000.ts    first byte       30.0 s                 25.7 s
               360p_000.ts    complete         44.7 s                 42.3 s
               speculative buffer built on
               posts never reached           8.5 s, 6 of 6 runs      0 s, 6 of 6 runs
             THE SPECULATIVE BUFFER IS THE FINDING; the handshake times are the consequence and they
             are noisier than they look (per-run master first byte spans 5.2-13.0s on the ungated
             side, and the gain is biggest at the front of the handshake, ~4-6s, and smallest at the
             end, ~2s). What does NOT vary is that the ungated arm buffered 3.2-16.3 seconds of clips
             the reader never reached in EVERY run, and the gated arm buffered none in ANY run.
             Note what is NOT claimed: how much the reader actually saw play is noise in every arm
             (0-22s), because a 57s 1280-wide mp4 does not stream at 1.2Mbps at all.

             AND SKIPPING OUTRIGHT WAS MEASURED TOO, as a third arm -- it is not better. Same rig,
             3 runs: skip 5.4 / 14.5 / 27.4 / 39.3 s against downgrade 5.4 / 12.5 / 24.9 / 42.4 s on
             the four rows above. Neither dominates and the differences are inside the run spread, so
             the extra megabyte buys back the warm neighbour for no measurable cost. That is why this
             is a downgrade and not a `return`.

             DOWNGRADED, NOT SKIPPED, and that distinction is the whole design. Skipping outright
             would leave the next card genuinely cold, and two things now depend on a warm neighbour:
             the 2026-09-09 pre-roll (it play()s the next card 320px before the fold and its own note
             says "the bytes are NOT this constant's job -- calmWarm already buffers"), and the
             drag-reveal in the viewer. The head start keeps both working from the HTTP cache at a
             bounded ~1MB (~3s of media) instead of an unbounded fill, which is the same treatment
             this clip would have had one viewport further out -- so on a slow line the two warm
             tiers simply collapse into one. A clip that already head-started while it was far away
             is a no-op here (`_headStart` is a once-per-clip claim), so the downgrade costs nothing
             at all for anything that approached through the outer band.

             RE-CHECKED, not dropped: warmUnobserve() has already run, so a bare return would strand
             this clip cold for the life of the page if the line recovered. 1200ms rather than the
             far tier's 700ms because the only thing this timer can discover is a change of LINE, not
             a change of distance.

             WHAT IT COSTS, stated as a number rather than buried. Eight alternating member runs per
             arm on /feed?tab=discover at 1.4Mbps/250ms (scratchpad tlb2.js + ttffpool.js), scoring
             only cards at least 90% on screen -- what the reader is actually looking at:
               nothing-paints-it       2739ms -> 1479ms   (BETTER: the 09-09 cover catches it)
               black-on-entry           6 of 24 -> 3 of 24 (BETTER)
               playing-on-entry         5 of 24 -> 4 of 24 (unchanged within the spread)
               time-to-first-frame  med 2325 -> 2442ms, p90 6917 -> 5147ms (mixed, no regression)
               showing a DECODED FRAME   47% -> 32% of on-screen video-time
               showing the POSTER COVER  47% -> 61%
             So the trade is real and it is the last two rows: on a 1.4Mbps line an on-screen card is
             a still for about fifteen points more of the time, and that is time it would otherwise
             have spent decoded off the neighbour fill. Nothing turns BLACK -- the 2026-09-09 cover
             absorbs it, which is what it is for, and by its own metrics the arrival is cleaner, not
             dirtier. On a fast line the gate never runs and all six rows are identical (measured:
             0 mechanism-black frames on WebKit in both arms, 4 runs each). */
          if (rmHlsWant(v)) {
            if (window.__rovaVidStart) { window.__rovaVidStart(v); }
            remoteHls(v, true);
            return;
          }
          if (warmLineSlow()) {
            warmHeadStart(v);
            setTimeout(calmWarm, 1200);
            return;
          }
          /* THE LOADED-CLIP WINDOW (2026-10-08, see tlwSweep): a timeline clip outside the nearest TLW_KEEP
             posts does not fill a buffer -- the sweep would only hand it straight back. Re-checked, never
             dropped: warmUnobserve() has run, so a bare return would strand it cold if the reader comes
             back towards it. */
          if (!tlwKeeps(v)) { setTimeout(calmWarm, 700); return; }
          // START PATH 3b of 7 (scroll, ambient): the NEIGHBOUR tier -- re-attach + preload=auto + load()
          // is a full buffer fill, the single heaviest ambient start on the surface. Claimed here, before
          // the src is set, for the same reason as calmPlay: the resource-selection algorithm runs off
          // whatever is true at the moment of assignment.
          if (window.__rovaVidStart) { window.__rovaVidStart(v); }
          if (!v.getAttribute('src') && v._mp4src) { v.setAttribute('src', v._mp4src); }   // hard-released: re-attach
          // preload MUST be bumped before attachHls() swaps src (native HLS on Safari/iOS) --
          // setting .src re-runs the resource-selection algorithm against whatever preload value
          // is current AT THAT MOMENT, so setting preload afterward was too late to make it buffer.
          /* A REMOTE REPLAY ON THE TIMELINE GETS ITS FIRST FRAME, NOT ITS FILE (2026-10-08). A Cloudflare replay
             is one progressive MP4 of 44-146 MB, and preload=auto on a paused neighbour lets Safari keep filling
             it for a card nobody has started. 'metadata' loads the moov + the opening frame (the faststart moov
             is 0.45-1.2 MB on the live replays) so the card still paints and starts promptly; calmPlay /
             __rovaPlayNow raise it to auto the moment it actually plays. The viewer keeps its drag-reveal
             contract (pfeed clips are untouched here). */
          v.preload = (tlwRemote(v) && !(v.closest && v.closest('.pfeed'))) ? 'metadata' : 'auto';
          // PRE-WARM ONLY WHAT THE LINE CAN AFFORD (2026-07-29). This is a NEIGHBOUR clip -- nobody has
          // opened it -- and prefetchHlsManifests pulls master + every variant playlist + the startup
          // variant's first segment, which was never bandwidth-gated. Measured at /p/9157 on congested
          // LTE: a neighbour's 720p_000.ts landed at t=11.6s while the clip actually being WATCHED did not
          // start its own 360p_000.ts until t=31.5s. ~20 seconds of the watched clip's bandwidth spent on
          // a clip nobody asked for -- on the exact link where the watched clip could least afford it.
          // Also: warm the master attachHls would ACTUALLY attach, not always the sharp one.
          // WHICH MASTER THAT IS IS NOW KNOWN IN ADVANCE (2026-08-09). The old expression mirrored
          // attachHls's own `(hlsLo && (_stalled || netIsSlow())) ? hlsLo : hls` -- but read _stalled HERE,
          // on approach, when it is still 0, so it always warmed the SHARP master. The only caller left
          // that can attach anything is wire()'s sustained-stall recovery, and that sets _stalled = 1
          // immediately BEFORE calling attachHls -- so the master that gets opened is always the _lo twin
          // whenever one exists (490 of 491 ladders on this box have one). Warm that. Same ~5KB of
          // playlist text either way; the difference is whether the stall recovery finds it cached.
          if (v.dataset && v.dataset.hls && !netIsSlow()) {
            prefetchHlsManifests(v.dataset.hlsLo || v.dataset.hls);
          }
          // NB: we deliberately do NOT attachHls() here anymore. The clip you swipe to should open on its
          // pre-buffered plain mp4 -- instant, exactly like the grid hover + the tapped opener -- instead of
          // waiting on the HLS manifest handshake. HLS steps in ONLY if the mp4 actually STALLS (wire()'s
          // 'waiting' recovery), so slow lines still get adaptive playback.
          try { v.load(); } catch (e) {}   // buffer the mp4 ahead (preload=auto) so it plays the instant you land
        })();
      });
    };   // ~2 posts of lead (owner: "the next 2 posts at LEAST should be cached, downloaded and ready" --
    // the top of the next post must drag up already painted).
    // This MUST sit inside the recycle keep window (KEEP=2 -> +/-2 posts) or warmIO would re-buffer a clip
    // the recycler just released -- and while you sit still that would push the live set back over the
    // 5-post cap. History: 1200% (12 posts) piled up buffers until the feed locked; 250% (~2.5 posts) was
    // "too little lead -> black on fast swipes"; 350% was the smooth sweet spot for the old 9-post window.
    var warmIO = new IntersectionObserver(warmHandler, { rootMargin: (PF_LA * 100) + '% 0px ' + (PF_LA * 100) + '% 0px' });
    // PFEED clips live inside the .pfeed-scroll OVERFLOW CLIP, and a viewport-rooted rootMargin does NOT
    // pierce intermediate clipping ancestors -- so the "warm 2 posts ahead" margin NEVER fired for anything
    // scrolled below the viewer's visible box (the lookahead "worked at the beginning then stopped": only the
    // pre-layout stack at open ever warmed). Root the pfeed variant AT THE SCROLLER (like the sentinel does).
    var warmIOPf = null;
    function warmObserve(v) {
      var pf = v.closest && v.closest('.pfeed');
      if (pf) {
        if (!warmIOPf) {
          var sc = pf.querySelector('.pfeed-scroll');
          if (sc) { warmIOPf = new IntersectionObserver(warmHandler, { root: sc, rootMargin: (PF_LA * 100) + '% 0px ' + (PF_LA * 100) + '% 0px' }); }
        }
        if (warmIOPf) { warmIOPf.observe(v); return; }
      }
      warmIO.observe(v);
    }
    function warmUnobserve(v) {
      try { warmIO.unobserve(v); } catch (e) {}
      try { if (warmIOPf) warmIOPf.unobserve(v); } catch (e) {}
    }
    // Round 91 deliberately shrank the window to 3, trading lookahead for memory -- so a fast multi-swipe
    // can flash a poster before the mp4 rolls (round-90 mp4-first softens it vs the old HLS-handshake black).

    /* ---- glassy custom control bar (Twitter-style), replaces native controls -- */
    // m:ss, and h:mm:ss from an hour up (a 62-minute replay reads "1:02:03", never "62:03")
    function fmtT(s) {
      s = Math.max(0, s | 0); var h = (s / 3600) | 0, m = ((s % 3600) / 60) | 0, ss = s % 60;
      return (h ? h + ':' + (m < 10 ? '0' : '') : '') + m + ':' + (ss < 10 ? '0' : '') + ss;
    }
    var VC = {
      // CLEAN VIEW (batch item 23): the eye that hides every panel and button -- app.js "CLEAN VIEW" owns the behaviour
      eye:   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12z"/><circle cx="12" cy="12" r="3"/></svg>',
      /* the play triangle was at x[8,19] -- centre 13.5, ONE AND A HALF UNITS RIGHT of the viewBox
         centre, because a triangle's mass sits left of its bounding box and the usual `M8 5...` is
         drawn to look right rather than to measure right. pause (below) is exact at x[6,18], so the
         two sat 1.5u apart on the SAME button and the glyph jumped sideways every time you toggled
         it. Same 1.5u correction the spec's section-10a table already applied to icon('play') in
         lib/view.php; this copy never got it. Now x[6.5,17.5], centred, and the pair agree. */
      play:  '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M6.5 5v14l11-7z"/></svg>',
      pause: '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><rect x="6" y="5" width="4" height="14" rx="1.1"/><rect x="14" y="5" width="4" height="14" rx="1.1"/></svg>',
      muted: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11 5 6 9H2v6h4l5 4z"/><line x1="22" y1="9" x2="16" y2="15"/><line x1="16" y1="9" x2="22" y2="15"/></svg>',
      sound: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11 5 6 9H2v6h4l5 4z"/><path d="M15.5 8.5a5 5 0 0 1 0 7"/><path d="M19 5a9 9 0 0 1 0 14"/></svg>',
      pip:   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="5" width="18" height="14" rx="2.4"/><rect x="11" y="11" width="8" height="5" rx="1.2" fill="currentColor" stroke="none"/></svg>',
      fs:    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M8 3H5a2 2 0 0 0-2 2v3M16 3h3a2 2 0 0 1 2 2v3M8 21H5a2 2 0 0 1-2-2v-3M16 21h3a2 2 0 0 0 2-2v-3"/></svg>',
      // two diagonal arrows OUTward = fill screen (edge-to-edge, crops a little); INward = letterbox
      fitOut: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="15 3 21 3 21 9"/><line x1="21" y1="3" x2="14" y2="10"/><polyline points="9 21 3 21 3 15"/><line x1="3" y1="21" x2="10" y2="14"/></svg>',
      fitIn:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 10 14 10 14 4"/><line x1="14" y1="10" x2="21" y2="3"/><polyline points="4 14 10 14 10 20"/><line x1="10" y1="14" x2="3" y2="21"/></svg>'
    };
    // Fold the post's action buttons (like / comment / repost / share) INTO a toolbar row, so the pfeed
    // shows ONE toolbar -- no separate floating action bar. It's a MOVE of the same elements (handlers +
    // state stay intact), so it can hop between rows as a carousel changes slide.
    function pfMoveActs(post, row) {
      if (!post || !row) return;
      var moved = post.querySelectorAll('.pf-act');
      if (moved.length) {                                  // already folded somewhere -> relocate to this row
        if (moved[0].parentNode === row) return;
        Array.prototype.forEach.call(moved, function (el) { row.appendChild(el); });
        return;
      }
      var acts = post.querySelector('.bar');
      if (!acts || acts._folded) return;
      acts._folded = 1;
      var hide = acts.querySelector('.js-hide'); if (hide) { hide.remove(); }   // no mute-the-person here
      /* INSIGHTS IS NOT AN ENGAGEMENT BUTTON, and this row has no space for it (owner 2026-08-08:
         "find another spot for the insight button it doesn't fit down there"). At 420px the folded row
         was carrying a timecode plus EIGHT controls -- like, comment, repost, insights, mute, play,
         fit, share -- with the pagination dots landing on top of them. Something had to leave, and
         insights is the one that is not about reacting to the post: it is an author/admin INSPECTION
         action, the same kind of thing as the rest of the ⋯ menu.
         It does not need a new home, because it ALREADY HAS ONE. views/_post.php prints "View insights"
         (and "View insights (admin)") as a .menu-item in the per-post ⋯ menu, and the viewer's top-right
         ⋯ opens exactly that menu -- .pfeed-menu clicks the current post's .pmenu-trigger. So the
         capability stays reachable in the viewer, one tap away, in the one piece of chrome that is not
         crowded, and NOTHING here shrinks to make room.
         Skipped, NOT removed: the .bar is display:none while folded, so leaving the button in place
         simply keeps it out of the viewer while the feed card and the permalink -- where the row is not
         cramped -- go on showing it exactly as before.
         THE GATE IS UNTOUCHED. Whether the button exists at all is decided server-side by
         Posts::insightsVisible (views/_post.php), and the menu item it defers to is behind that SAME
         condition, so this moves WHERE it appears and never WHO sees it. */
      Array.prototype.slice.call(acts.children).forEach(function (ch) {
        if (ch.classList && ch.classList.contains('ins-fab')) return;
        ch.classList.add('pf-act'); row.appendChild(ch);
      });
      acts.classList.add('pf-folded');
    }
    /* THE PINNED CONTROL LAYER of an immersive carousel. One per .media.carousel, created lazily, and a
       SIBLING of .carousel-track -- which is the whole point: the swipe animates a transform on the
       TRACK, so anything inside it moves and anything beside it does not. Every slide's toolbar renders
       into this one node, so the controls are literally the same elements from slide to slide and cannot
       drift by construction (there is no second copy to slide in behind them).
       Placed inside .media.carousel and not on .pfeed because the viewer is a VERTICAL list of posts:
       a viewer-level bar would have to be re-pointed at whichever post is centred, and would sit over
       the wrong post for the length of every vertical scroll. */
    function ensurePinnedBar(carousel) {
      if (!carousel) return null;
      if (carousel._cbar && carousel._cbar.parentNode === carousel) return carousel._cbar;
      var el = carousel.querySelector(':scope > .pf-cbar');
      if (!el) {
        el = document.createElement('div');
        el.className = 'pf-cbar';
        carousel.appendChild(el);   // after .carousel-track, so it is NOT transformed by the swipe
      }
      carousel._cbar = el;
      return el;
    }
    // Carousel: the action buttons live in the pinned toolbar. They used to be MOVED into whichever
    // slide's bar was current, which is exactly how the heart ended up half off the left edge mid-swipe;
    // with one pinned row there is nothing to move them between, so this now just claims them once.
    function ensureCarouselActs(carousel, post) {
      if (!carousel || !post) return;
      var moveToCurrent = function () {
        var pin = carousel._cbar || carousel.querySelector(':scope > .pf-cbar');
        var row = pin && pin.querySelector('.vctrl .vc-row');
        if (!row) {   // legacy per-slide bar (non-pfeed carousels never pin): fall back to the current slide
          var slides = carousel.querySelectorAll('.cslide');
          var i = carousel.__cidx ? carousel.__cidx() : 0;
          row = slides[i] && slides[i].querySelector('.vctrl .vc-row');
        }
        if (row) pfMoveActs(post, row);
      };
      if (!carousel._actsWired) {
        carousel._actsWired = 1;
        var prev = carousel.__onslide;
        carousel.__onslide = function (a, b) { if (prev) prev(a, b); moveToCurrent(); };
      }
      moveToCurrent();   // this slide's toolbar just built -- claim the actions if it's the current one
    }
    /* REBIND THE PINNED BAR TO THE SLIDE WE JUST MOVED TO.
       Driven from the carousel's own __onslide -- the signal update() fires SYNCHRONOUSLY as the index
       changes, at the START of the .35s transform. NOT from a scroll listener: a transform glide fires
       NO scroll events at all, so a scroll-driven update is stale for the entire animation (that is the
       159ms-of-wrong-author-name incident on this very pattern). Rebinding here means the timecode and
       the progress fill show the NEW clip's values from the first frame of the swipe, while the buttons
       around them never move.
       Idempotent both ways: buildControls early-returns when the host is already bound to this exact
       video, and the photo branch is guarded by the bar's own _pbSlide stamp. */
    function pinnedBarSync(carousel) {
      if (!carousel || !carousel.closest || !carousel.closest('.pfeed')) return;
      var pin = ensurePinnedBar(carousel); if (!pin) return;
      var slides = carousel.querySelectorAll('.cslide');
      var i = carousel.__cidx ? carousel.__cidx() : 0;
      var slide = slides[i]; if (!slide) return;
      var vid = slide.querySelector('video');
      if (vid) { buildControls(vid, pin, { unit: slide }); return; }
      buildPhotoBar(slide, pin);
    }
    function ensurePinnedBarWired(carousel) {
      if (!carousel || carousel._cbarWired) return;
      carousel._cbarWired = 1;
      var prev = carousel.__onslide;
      carousel.__onslide = function (a, b) { if (prev) prev(a, b); pinnedBarSync(carousel); };
    }
    function buildControls(v, host, opts) {
      opts = opts || {};
      // In a multi-media carousel the control host is the individual SLIDE, not the whole .media --
      // otherwise the video's bar (and has-vctrl / pf-vfeed) spans every slide, so a photo slide shows
      // a video toolbar and tapping it plays the video. Single-media posts still host on .media.
      var media = host || (v.closest ? (v.closest('.cslide') || v.closest('.media')) : null);
      if (!media) return;
      /* IMMERSIVE CAROUSEL: THE BAR IS PINNED, NOT PER-SLIDE (owner 2026-08-08: "as I swipe between
         media the play button to the mute button should be still... just like the @grindhd at the top
         stays still, only thing changing here should be the time and progress bar").
         Hosting on the .cslide put the ENTIRE toolbar inside .carousel-track, which is the element the
         swipe translates -- so all eight controls rode off the left edge with the outgoing clip while
         the incoming slide's own second copy of the bar slid in from the right (measured: the bar's x
         travelled the full 420px of the viewport, and five bars existed at once on a 5-item post).
         Redirect to ONE pinned host that is a SIBLING of the track, so the transform never touches it.
         This is the SAME portable-player host the media gallery already uses (setupGalVideoBar passes
         .gal-vbar); nothing new is invented here, the pfeed was simply the one surface not using it.
         `unit` stays the SLIDE, because the per-slide state -- the fill/letterbox classes, the pan
         classes -- belongs to the media, not to the bar. */
      var unit = opts.unit || media;
      if (!host && media.classList && media.classList.contains('cslide') && media.closest('.pfeed')) {
        var pinCar = media.closest('.carousel');
        /* ONLY THE CURRENT SLIDE MAY CLAIM THE SHARED BAR. Clips are wired in whatever order warmIO
           brings them into range -- not in slide order -- so without this a slide-4 video finishing its
           wire while the reader sits on slide 1 would tear slide 1's toolbar down and rebuild the shared
           host against a clip that is nowhere on screen. Non-current slides simply build no bar at all;
           there is one bar now, and __onslide (pinnedBarSync) hands it over when they become current. */
        var pinSlides = pinCar ? pinCar.querySelectorAll('.cslide') : [];
        var pinCur = (pinCar && pinCar.__cidx) ? pinCar.__cidx() : 0;
        if (pinCar && pinSlides[pinCur] && pinSlides[pinCur] !== media) { ensurePinnedBarWired(pinCar); return; }
        var pinned = pinCar && ensurePinnedBar(pinCar);
        if (pinned) { unit = media; media = pinned; }
      }
      if (media._vctrl === v) return;                 // this exact video is already wired
      // a reused host (the gallery swiping to a new video, OR the grid-donor handoff swapping the pfeed's
      // clip for the live grid one) tears the old bar down first. RESCUE the post actions (like / comment /
      // repost / share) that pfMoveActs folded INTO the old vctrl back to the .bar FIRST -- else removing the
      // vctrl deletes them, and pfMoveActs can't rebuild them (its _folded guard bails), so the rewired video
      // comes up with NO engagement buttons (owner report: a video opened from the grid had none). Moving
      // them to the (folded) bar keeps them alive; pfMoveActs relocates them into the new row a beat later.
      var _rescueBar = media.closest('.post') ? media.closest('.post').querySelector('.bar') : null;
      if (_rescueBar) { Array.prototype.forEach.call(media.querySelectorAll('.vctrl .pf-act'), function (a) { _rescueBar.appendChild(a); }); }
      Array.prototype.forEach.call(media.querySelectorAll('.vctrl,.vc-mini,.vc-sound,.vc-spin,.vc-pipmsg'),
        function (n) { n.remove(); });
      // ...and the gallery's ring does NOT live in the bar (see the spinner block below): it hangs on
      // .gal-stage, one level UP, so the sweep above cannot see it. Rewiring on every slide change
      // would otherwise stack a fresh ring per video slide, each one still gated on a bar that has
      // since been rebuilt -- a spinner nobody can turn off. Drop the stage's rings with the bar's.
      if (media.classList && media.classList.contains('gal-vbar')) {
        var _galStage = media.closest('.gal-stage');
        if (_galStage) Array.prototype.forEach.call(_galStage.querySelectorAll(':scope > .vc-spin'), function (n) { n.remove(); });
      }
      media._vctrl = v;
      v.removeAttribute('controls');
      // We ship a custom player and no AirPlay, so deny remote playback: stops Safari probing for
      // an AirPlay target and logging the harmless "airplay-placard failed to load" console noise.
      try { v.disableRemotePlayback = true; v.setAttribute('x-webkit-airplay', 'deny'); } catch (e) {}
      media.classList.add('has-vctrl', 'vc-paused');
      var bar = document.createElement('div');
      bar.className = 'vctrl';
      bar.innerHTML =
        /* THE TIME SITS ON THE ENDS OF THE PROGRESS BAR, not in the row (owner 2026-10-13, a 42-minute replay in the
           390 viewer: "0:06 / 42:10" wrapped onto two lines between the chat toggle and the folded actions). Elapsed
           over the bar's left end, total over its right end; the row keeps buttons only, so nothing in it can wrap. */
        '<div class="vc-tl"><span class="vc-tcur">0:00</span><span class="vc-tdur"></span></div>'
        + '<div class="vc-seek"><div class="vc-fill"></div><div class="vc-knob"></div></div>'
        // fullscreen leads the row; mute is NOT here - it lives permanently in the
        // bottom-right corner (.vc-sound) so it never moves or restyles when the bar opens
        + '<div class="vc-row">'
        // play LEADS the row (fullscreen + PiP are hidden inside the immersive pfeed anyway)
        + '<button class="vc-btn vc-play" type="button" aria-label="Play or pause">' + VC.play + '</button>'
        + (opts.noFs ? '' : '<button class="vc-btn vc-fs" type="button" aria-label="Fullscreen">' + VC.fs + '</button>')
        // fill/letterbox toggle -- only shown for videos in the immersive pfeed (CSS-gated)
        + '<button class="vc-btn vc-fit" type="button" aria-label="Fill or letterbox">' + VC.fitIn + '</button>'
        + '<button class="vc-btn vc-eye" type="button" aria-label="Hide everything" aria-pressed="false">' + VC.eye + '</button>'
        + (document.pictureInPictureEnabled ? '<button class="vc-btn vc-pip" type="button" aria-label="Picture in picture">' + VC.pip + '</button>' : '')
        + '<span class="vc-flex"></span>'
        + '</div>';
      media.appendChild(bar);
      // Twitter-style minimal readout: a small glassy time pill shown while the video
      // just autoplays; the full control bar only appears on hover / tap.
      var mini = document.createElement('div');
      mini.className = 'vc-mini';
      mini.textContent = '0:00';
      media.appendChild(mini);
      // minimal sound toggle (bottom-right) so you can unmute without opening the full bar
      var msound = document.createElement('button');
      msound.type = 'button';
      msound.className = 'vc-sound';
      msound.setAttribute('aria-label', 'Mute or unmute');
      media.appendChild(msound);
      // No-audio clips: there is nothing to toggle, so HIDE the mute/unmute speaker and show a small "No
      // audio" tag in its place -- the control never lies about sound that isn't there. videoNoAudio() is
      // positive for a clip the server ffprobed as silent (data-noaudio) or that the browser reports has no
      // audio track. Re-checked on loadedmetadata for the browser-hint (no data-noaudio) case.
      var naBadge = document.createElement('div');
      naBadge.className = 'vc-noaudio';
      naBadge.setAttribute('aria-hidden', 'true');
      naBadge.innerHTML = VC.muted + '<span>No audio</span>';
      naBadge.style.display = 'none';
      media.appendChild(naBadge);
      var naFadeT = null;
      /* A SILENT CLIP ON A POST WITH MUSIC IS NOT "NO AUDIO" (Rob 2026-10-03, @thesashagomez 54366 "sorry been
         MIA": a silent clip + an Apple Music song). The post HAS sound -- the song's -- so the tag is a lie
         there. Any music embed (.embed-music: Apple / Spotify / SoundCloud) drops the tag. An Apple card with a
         baked preview also gets the speaker back in SONG MODE (vc-songsnd): its glyph is "this post's song is
         playing" and its tap is the card's own toggle (__rovaAmTap). An iframe player (Spotify/SoundCloud) has
         audio we cannot drive, so there the speaker stays hidden -- no tag, no control. The card is looked up
         from the HOST's post (the clip itself may be mid-flight in a wrapper), never inside a quoted post the
         clip is not part of. API twin for the app: media[i].noaudio && post.embed.type !== 'music'. */
      function postMusic() {
        var p = (media.closest && media.closest('.post')) || (v.closest && v.closest('.post'));
        if (!p) return null;
        var q = media.closest ? media.closest('.quoted') : null;
        var cs = p.querySelectorAll('.embed-music');
        for (var i = 0; i < cs.length; i++) { if (cs[i].closest('.quoted') === q) return cs[i]; }
        return null;
      }
      function syncAudioAvail() {
        var na = videoNoAudio(v);
        var mus = na ? postMusic() : null;
        var song = (mus && mus.classList.contains('am-card') && mus.getAttribute('data-preview')) ? mus : null;
        media.classList.toggle('vc-silent', na);
        if (msound._song !== song) { msound._song = song; msound._m = null; }
        msound.classList.toggle('vc-songsnd', !!song);
        msound.style.display = (na && !song) ? 'none' : '';
        if (msound._sync) { msound._sync(); }
        if (mus) { na = false; }                 // the post has sound: no tag (the speaker, if any, is the song's)
        clearTimeout(naFadeT);
        if (na) {
          // show the tag briefly so the viewer registers "this clip is silent", then FADE it away so it
          // doesn't linger over the video (owner request). It re-appears if the clip is shown again.
          naBadge.style.display = '';
          naBadge.classList.remove('vc-noaudio-out');
          naFadeT = setTimeout(function () { naBadge.classList.add('vc-noaudio-out'); }, 3200);
        } else {
          naBadge.style.display = 'none';
          naBadge.classList.remove('vc-noaudio-out');
        }
      }
      v.addEventListener('loadedmetadata', syncAudioAvail);
      /* Buffering spinner while the stream stalls -- but NOT on the pinned carousel bar (owner
         2026-08-08: "I only need one loading circle animation on the screen lose the one at the
         very bottom"). .vc-spin is MEDIA feedback: `top:50%;left:50%` centres it on its HOST. Every
         host it has ever had was a media box, so it painted in the middle of the frame. The pinned
         bar is not a media box -- it is `bottom:0; height:0` (a rail for the controls, sibling of
         .carousel-track) -- so `top:50%` of ZERO height put the ring on the media's BOTTOM EDGE,
         dead centre horizontally, straight over the .cdots pagination row. Measured on /p/15076 at
         420x912: the ring painted at x=50% y=100% while .cdots sits at y=98.6%, i.e. exactly the
         second circle in the screenshot. It is not created for that host at all, so there is
         nothing to eat pointer events and nothing to re-show. Single-video posts (host = .media)
         and the timeline/grid players are untouched and keep their centred ring. */
      /* The GALLERY has the same shape and the same bug: setupGalVideoBar passes .gal-vbar, which is
         `bottom:0` and collapses to ZERO height (its .vctrl is absolutely positioned), so the ring
         painted at cy=100% -- the stage's bottom edge -- measured on the gallery at 1280x900 with the
         media spanning 21%-80%. Here the media box is reachable, so the ring is RELOCATED rather than
         dropped: .gal-stage is the positioned box the media is centred in (measured centre 35.4%/50%
         against the media's 34%/50.7%), and unlike .gal-mediabox it is never innerHTML-wiped. The
         `vc-buffering` class still lands on the BAR, so rova.css gates the ring off the stage's
         `:has(> .gal-vbar.vc-buffering)`. Teardown for this new home is in setupGalVideoBar and in
         the rewire sweep above -- a ring stranded on the stage would spin forever. */
      var spinHost = media.classList.contains('pf-cbar') ? null
                   : media.classList.contains('gal-vbar') ? media.closest('.gal-stage')
                   : media;
      if (spinHost) {
        var spin = document.createElement('div');
        spin.className = 'vc-spin';
        spin.setAttribute('aria-hidden', 'true');
        spinHost.appendChild(spin);
      }
      var $ = function (s) { return bar.querySelector(s); };
      var playB = $('.vc-play'), pipB = $('.vc-pip'), fsB = $('.vc-fs'), fitB = $('.vc-fit'),
          tCur = $('.vc-tcur'), tDur = $('.vc-tdur'), tCurS = '0:00', tDurS = '', seek = $('.vc-seek'), fill = $('.vc-fill'), knob = $('.vc-knob');
      function stop(e) { e.preventDefault(); e.stopPropagation(); }
      // Fill vs letterbox toggle (pfeed only): pf-vfill = edge-to-edge (contain + scale, crops a little),
      // pf-letterbox = whole frame with bars. Default is fill (portrait clips get pf-vfill on open); the
      // icon shows what a tap will DO -- "letterbox" (inward arrows) while filling, "fill" (outward) while
      // boxed. Landscape clips default to contain, so tapping fills them.
      if (fitB && media.closest && media.closest('.pfeed')) {
        var fitUnit = unit;    // .media (single) or .cslide (carousel) -- same node the pf-* classes ride on
        // ...which is NOT the bar's host once the carousel bar is pinned: fill/letterbox and the pan
        // classes describe THIS SLIDE's media, so toggling them on the shared bar would have applied one
        // slide's crop to all five (and left the pan helper reading a box with no media in it).
        var isFilling = function () {
          if (fitUnit.classList.contains('pf-letterbox')) { return false; }
          if (fitUnit.classList.contains('pf-vfill')) { return true; }
          return fitUnit.classList.contains('pf-portrait');   // portrait default = fill
        };
        var paintFit = function () {
          var f = isFilling();
          fitB.innerHTML = f ? VC.fitIn : VC.fitOut;
          fitB.setAttribute('aria-label', f ? 'Letterbox view' : 'Fill the screen');
        };
        fitB.addEventListener('click', function (e) {
          stop(e);
          if (isFilling()) { fitUnit.classList.remove('pf-vfill'); fitUnit.classList.add('pf-letterbox'); }
          else { fitUnit.classList.remove('pf-letterbox'); fitUnit.classList.add('pf-vfill'); }
          // #44: pannability follows the fill mode -- a letterboxed clip has no crop to pan, so this
          // clears pf-vpan (and any --pf-vpos left over from the filled state) on the way out, and
          // re-arms it on the way back in.
          if (window.__rovaVpan) { window.__rovaVpan(fitUnit); }
          paintFit();
        });
        paintFit();
      }
      function syncPlay() { playB.innerHTML = v.paused ? VC.play : VC.pause; media.classList.toggle('vc-paused', v.paused); }
      /* one mute, the corner button. The STATE is carried by the glyph -- speaker-with-X is muted,
         speaker-with-waves is not -- exactly as the play/pause transport does it (the circle-button
         spec, section 11: on a media transport the glyph IS the state). What was missing is the half
         a glyph cannot carry: the label never changed and there was no aria-pressed at all, so a
         screen reader was told "Mute or unmute" forever and could not find out which one it was. The
         spec (section 10) requires BOTH on a toggle disc, and the timeline transport already renders
         exactly this pair (renderLive). No `.on` disc rung here on purpose: nothing else in the
         immersive control row lights one (a liked heart's `.on` sits on the inner button, which that
         row flattens), so lighting the speaker would make it the odd one out again -- which is the
         report this change exists to fix. */
      function syncMute() {
        var m = v.muted && !soundIntent();   // intent, not bookkeeping -- see soundIntent() (2026-09-26)
        // SONG MODE (silent clip + song, see syncAudioAvail): the speaker draws the post's song, not the clip
        if (msound._song) { m = !(window.__rovaAmSongOn && window.__rovaAmSongOn(msound._song)); }
        if (msound._m === m) { return; }     // most volumechange events here are engine hand-offs: no repaint
        msound._m = m;
        msound.innerHTML = m ? VC.muted : VC.sound;
        msound.setAttribute('aria-pressed', m ? 'true' : 'false');
        msound.setAttribute('aria-label', m ? 'Muted. Turn sound on' : 'Mute sound');
      }
      v.addEventListener('play', syncPlay);   // autoplay stays minimal - just the time pill, no bar
      v.addEventListener('pause', syncPlay);
      /* ...and on the transitions that carry NO event.  The HTML media load algorithm (a `load()`
         call, or any `src` reassignment -- attachHls does both, teardownVideo does both, calmWarm
         calls load()) sets `paused` to true and explicitly does NOT fire `pause`.  So the transport
         glyph and the `vc-paused` class -- which is what makes the bar VISIBLE on touch, where
         there is no hover -- were left describing a state the element had silently left.  Measured
         live on the profile timeline: 3 of 28 observed transitions had the glyph disagreeing with
         `.paused`, every one of them immediately after a `loadstart`.  These four events cover
         every silent path (loadstart/emptied on the way out, canplay/playing on the way back) and
         they cost one class toggle each -- no polling.  Same category as the lazily-built photo bar
         that was born on the wrong glyph: a broadcast-on-CHANGE never repairs a state that changed
         without broadcasting. */
      ['loadstart', 'emptied', 'canplay', 'playing'].forEach(function (e) { v.addEventListener(e, syncPlay); });
      v.addEventListener('volumechange', syncMute);
      msound._sync = syncMute;               // speakersSync() repaints on an intent change that fires no event here
      /* ---- UNMUTING IS A DELIBERATE ACT OF ATTENTION  (owner 2026-08-10) -------------------------
         "I pressed unmute then I heard it for a second but it auto swiped to the next media and it
          was muted."  ...and, restated: "if I tap it to hear it, the auto timeline post loads should
          pause immediately until I'm done engaging with the content."

         `v.muted = !v.muted` was three things short, and every one of them is machinery this file
         already has. Nothing below is a new mechanism, a new constant or a ninth hold:

         1. IT PAUSES THE MOVERS, and that half needs NO code here -- which is worth writing down,
            because it is the part that looks missing. `.vc-sound` is already in ENG_ATTN_SEL, so
            the pointerdown UNDER this click runs engAttendFrom(): it arms the ENG_QUIET attention
            hold and hands every carousel in the card __autoPause(ENG_QUIET). autoTick() and the
            slideshow step() both park on engAttnUntil(). So the auto-swipe stops on the press edge,
            before this handler even runs.
            IN THE FEED ONLY (2026-08-21): inside the immersive viewer `.pfeed .vc-sound` is in
            ENG_ATTN_NOT, so no attention hold arms there -- none of these movers exist in the
            viewer and the hold was pinning the viewer's chrome fade forever instead. The renewal
            below stands down inside the viewer for the same reason.
            DELIBERATELY NOT engVideo(). That is the OTHER contract in this file -- it stamps
            __cycEng, which switches a gallery from the 4.2s preview tick to "play this clip out,
            THEN advance". That is a RE-TIMING, and the owner asked for a PAUSE ("until I'm done"),
            so the advance must not be handed a new clock. A tap for sound is not a tap for the
            next clip.
         2. IT PAUSES THE LOADERS. The attention hold deliberately does not touch those (holding the
            infinite append for two minutes starves the scroll) -- the engHolds do, and "the auto
            timeline post loads should pause" is exactly them: feedBusy(), maybeRoll(), the appends.
            So take one, keyed to this element, for as long as it is AUDIBLE. ENG_LONG is a ceiling,
            not the clock: the real end signals are the ones below.
         3. IT KEEPS ITSELF ALIVE WHILE HE IS LISTENING. ENG_QUIET is 120s and lapses on silence --
            correct for a like, wrong on its own for a 164s clip, which would lapse mid-listen and
            let the tick yank the slide away at t+120s (the same trap clipPass already solves for
            the engaged cycle by renewing __cycEng while the clock moves). AUDIO THE READER TURNED
            ON, ADVANCING, IS EVIDENCE OF A PERSON -- the presence rule this hold is lifted from --
            so it RENEWS, never arms, and only for a clip HAND-unmuted in this session (_handUnmuted).
            That gate matters: applySound() unmutes the current clip on its own from the saved
            rova_sound preference, and letting THAT renew would be the empty-room renewal the
            attention block warns about in as many words.
         And MUTING IS "I AM DONE": it drops the hold, releases the carousel's park, and clears the
         attention hold -- the same three levers, pulled the other way. Clearing site-wide is the
         precedent #live-toggle already sets ("tapping while held releases the hold"); without it the
         pointerdown under THIS very tap would re-arm 120s of stillness on the way to muting.

         THE WEBKIT STOP is separate and is the other half of "I heard it for a second": unmuting a
         clip that is playing under the muted-autoplay allowance silently pauses it on WebKit. See
         soundRepair() in the sound closure for the rule and why it resumes UNMUTED.

         THE SOUND ITSELF NEEDS NOTHING HERE, which is the half the owner asked for twice.
         applySound() already hands the sound to whichever clip is current and mutes every other
         one, and slideMedia() re-runs it on every slide change -- so the next slide of this
         carousel, swiped or advanced, arrives unmuted on its own, and an off-slide clip can never
         be the one holding it (activeVideo() -> inView() -> onCurrentSlide()). A second sound rule
         here would only give the two a chance to disagree. */
      function sndKey(el) {
        if (!el._sndKey) { window.__rovaSndSeq = (window.__rovaSndSeq || 0) + 1; el._sndKey = 'sound#' + window.__rovaSndSeq; }
        return el._sndKey;
      }
      /* THE HOLD IS DERIVED, NEVER TOGGLED, and that was a real defect the first cut shipped past
         its own test. Written as "take it on the unmute tap, drop it on a pause", the WebKit rule
         above breaks it in one move: the unmute silently PAUSES the clip, the pause listener drops
         the hold, soundRepair puts the clip back -- and nothing ever re-takes it. MEASURED under
         the emulated rule: attention on, sound audible, engHolds 0. So compute it from the state
         that actually matters -- "the reader asked for sound AND this element is making it" -- and
         let every event that can change that state just re-ask. */
      /* 2026-09-29 (Rob, iOS build 533): "the reader asked for sound" is now THIS ELEMENT's `_sndHand`, not the
         session flag -- see THE AUDIBLE CLIP'S HOLD HAS A LENGTH (next to engVideo). The session flag made every
         later auto-followed card hold the feed for as long as it played, i.e. forever at the top. The tracker
         there ends `_sndHand` when the clip is over / muted / paused by the reader / paused away, and re-asks
         this through `v._sndSync`. */
      function syncSndHold() {
        var want = !!v._sndHand && !v.muted && !v.paused;
        try { engHold(sndKey(v), want, ENG_LONG, v); } catch (er) {}
      }
      v._sndSync = syncSndHold;
      msound.addEventListener('click', function (e) {
        stop(e);
        // SONG MODE: the clip has no audio to toggle; the tap is the song card's own play/pause (2026-10-03)
        if (msound._song) {
          if (msound._song.isConnected && window.__rovaAmTap) { window.__rovaAmTap(msound._song); }
          syncMute();
          return;
        }
        var cyc = v.closest && v.closest('.media.carousel');
        if (v.muted) {
          v.muted = false;                                  // UNSTAMPED on purpose: this IS the reader
          // ...and a reader's own tap is the one gesture that unlocks the engine, so say so: from
          // here applySound() may hand the sound on as they swipe (see sndUnlocked in the sound closure).
          if (window.__rovaSoundGranted) { try { window.__rovaSoundGranted(); } catch (erg) {} }
          /* SESSION-level, not element-level, and that is the point. applySound() hands the sound
             to whichever clip is current, so by the time the reader has swiped one slide the
             element they actually tapped is no longer the one talking -- an element flag would stop
             renewing exactly when the listening continued. Same shape and same reason as pfLatch. */
          window.__rovaHandSound = 1;
          sndMarkHand(v);                                   // EXPLICIT: this clip holds until it is over (no 5 s cap)
          syncSndHold();
          if (window.__rovaSoundRepair) { try { window.__rovaSoundRepair(v); } catch (er2) {} }
          /* THE CARD THEY TAPPED IS THE CARD THEY HEAR (2026-09-26). With sound on by default this speaker
             can read "on" over a clip that is silent only because another card holds the timeline's
             voice; tapping it means "this one". It takes the slot (tlClaim), and a song preview sounding
             on the timeline yields -- the reader's latest choice is the one voice. */
          if (!(v.closest && v.closest('.pfeed'))) {
            if (window.__rovaAmPlaying && window.__rovaAmPlaying() && window.__rovaAmStop) { try { window.__rovaAmStop(); } catch (er6) {} }
            tlClaim(v);
          }
        } else {
          // DECLARED: this is the reader muting, the one mute allowed to write rova_sound=0.
          if (window.__rovaUserMute) { try { window.__rovaUserMute(v); } catch (er3) {} }
          v.muted = true;
          window.__rovaHandSound = 0;
          syncSndHold();
          if (cyc && cyc.__autoRelease) { try { cyc.__autoRelease(); } catch (er4) {} }
          try { engAttnClear(); } catch (er5) {}
        }
      });
      /* THE RENEWAL, and the END SIGNALS THAT ARE NOT A TAP. ENG_LONG is a 15-minute ceiling, not
         the clock: a clip that stops being audible for any other reason -- the reader pauses it,
         applySound hands the sound to the next slide, the element is recycled -- must not leave a
         hold behind, and one that starts again must get it back. And a clip that IS audible keeps
         the stillness alive, so a clip longer than ENG_QUIET cannot be swiped away at t+120s
         mid-listen. Renewal is gated on the session flag precisely so the engine's own unmutes
         (from the saved rova_sound preference) can never renew a hold in an empty room -- the trap
         the attention block spells out. */
      v.addEventListener('timeupdate', function () {
        if (!v._sndHand || v.muted || v.paused) return;   // this clip's own hand unmute (2026-09-29), not the session's
        /* ...BUT NEVER INSIDE THE IMMERSIVE VIEWER (owner 2026-08-21: unmuting on the /p/<id>
           permalink left the chrome up forever). "Audio the reader turned on is evidence of a
           person" is the FEED's argument: there the renewal keeps the movers parked so a slide
           cannot be yanked away mid-listen. Inside the viewer none of those movers run -- the
           only things reading the attention hold are goIdle (.pfeed-idle) and the bar's hideT,
           i.e. THE CHROME FADE ITSELF -- so here the renewal's sole effect was to re-arm a full
           120s every ~5s for as long as the clip stayed audible, and the chrome could never fade
           again for the rest of the session (measured: msLeft sawtoothing 119.9s->115.6s->119.9s).
           The immersive viewer's entire design is that its chrome gets out of the way of a
           playing clip; sound-on is the strongest signal the reader is WATCHING, not the reason
           to keep panels over the picture. closest() is asked per-event because the hero handoff
           re-parents elements between the feed and the viewer mid-session. */
        if (v.closest && v.closest('.pfeed')) return;
        try { engAttnRenew(); } catch (er6) {}              // RENEW ONLY -- it can never arm one
      });
      ['play', 'playing', 'pause', 'ended', 'volumechange', 'emptied'].forEach(function (ev) {
        v.addEventListener(ev, function () { if (v._sndKey || window.__rovaHandSound) syncSndHold(); });
      });
      /* THE BUFFERING RING IS DRIVEN BY THE CLOCK, NEVER BY EVENTS (owner 2026-08-12, one bar of
         cellular, a landscape clip playing perfectly with a ring sitting over the middle of it: "I
         don't want to keep seeing the loading circle on an already perfectly playing video every
         couple of seconds").
         `waiting` AND `stalled` ARE NOT STALL SIGNALS. `waiting` fires whenever readyState dips below
         HAVE_FUTURE_DATA, which on a thin line happens at ordinary HLS segment boundaries while the
         frames keep arriving; `stalled` is weaker still -- it means "no bytes off the NETWORK for 3s"
         and says nothing whatever about playback, so it fires with a full buffer in hand (the
         progressive uploader already refuses to trust it for exactly this reason: search
         "deliberately NOT listening for 'stalled'").
         The old rule painted the ring on either event and cleared it on the next `timeupdate`. That
         clear is not a fix, it is the SIZE of the flash: timeupdate lands roughly 4x a second, so
         every spurious event lit `display:block` (no fade, no delay -- .vc-spin, rova.css) for up to
         ~250ms. On one bar that is a ring blinking over an unbroken picture every couple of seconds,
         which is precisely the report. web#30's timeupdate clear made a STUCK ring transient; it
         could never stop the ring being wrong in the first place.
         The only honest question is "IS THE PICTURE STUCK": a clip that is meant to be playing whose
         currentTime has not moved. So sample the clock -- show only after it has been still for
         BUF_STALL_MS while unpaused, and hide it the instant it moves. Events may PROMPT a look (they
         arm the sampler, which is otherwise not even running); they may never paint.
         A PAUSED clip still never shows a ring -- that was the older "paused video shows a spinner"
         bug, iOS firing 'waiting' as it fetches behind a vetoed autoplay -- and it now falls out of
         the rule rather than needing its own guard. */
      var BUF_STALL_MS = 600;    // clock still this long while supposed to be playing = a REAL stall
      var BUF_SEEK_MS  = 300;    // ...shorter mid-seek: the picture is already gone, so say so sooner
      var BUF_SHOW_MS  = 250;    // ...and debounce the SHOW, so one dropped frame can never flash it
      var BUF_TICK_MS  = 200;
      var _bufT = -1, _bufMovedAt = 0, _bufIv = null, _bufShowT = null, _bufCalm = 0;
      /* ONE OWNER PER (HOST, CLIP). buildControls re-runs on the same host for a different clip (the
         gallery swiping to the next video slide, the pinned carousel bar handing over, the grid-donor
         handoff swapping the pfeed's element for the live tile's), and every run leaves ITS listeners
         behind on ITS element. Without an ownership test the previous run's sampler keeps toggling
         vc-buffering on a host that has moved on -- the stranded-stand-in shape: a waiter whose
         subject was recycled, still painting. `media._vctrl` is the stamp buildControls already keeps
         for exactly this question (and the teardowns already null it), so ask that rather than invent
         a second source of truth. A retired closure goes quietly: it may not paint, and equally it
         may NOT unpaint -- clearing the class on its way out would wipe the ring of whichever clip
         legitimately owns the host now. `_bufOwner` is recorded only so the next investigation can
         see which host a clip's ring belongs to. */
      v._bufOwner = media;
      function bufMine() { return media._vctrl === v; }
      function buffOn() { if (bufMine() && !v.paused && !v.ended) media.classList.add('vc-buffering'); }
      function buffOff() {
        if (_bufShowT) { clearTimeout(_bufShowT); _bufShowT = null; }
        media.classList.remove('vc-buffering');
      }
      function bufStop() { if (_bufIv) { clearInterval(_bufIv); _bufIv = null; } }
      function bufRun() { if (!_bufIv) { _bufIv = setInterval(bufSample, BUF_TICK_MS); } }
      // A PROMPT, not a paint. Only re-baselines the clock when the sampler was off, so a `waiting`
      // arriving DURING a genuine stall can't keep pushing the deadline out ahead of itself.
      function bufArm() {
        if (_bufIv || v.paused || v.ended) return;
        _bufCalm = 0; _bufT = v.currentTime; _bufMovedAt = Date.now();
        bufRun();
      }
      function bufSample() {
        // Retired: this closure no longer owns the host. Go without touching the class (see above).
        if (!bufMine()) { if (_bufShowT) { clearTimeout(_bufShowT); _bufShowT = null; } bufStop(); return; }
        // A clip the virtualiser recycled or pruned can never advance again; leaving the sampler (and
        // possibly a ring) on one is the stranded-stand-in shape, so it dies with the element.
        if (!v.isConnected || v._recycled || v._released || v.paused || v.ended) { buffOff(); bufStop(); return; }
        var now = Date.now(), t = v.currentTime;
        if (t > _bufT + 0.008 || t < _bufT) {          // the clock moved (or seeked): the picture is alive
          _bufT = t; _bufMovedAt = now; _bufCalm++;
          buffOff();
          // Steady for ~800ms with a full buffer and nothing pending: stop looking until some event
          // gives us a reason to look again. Costs nothing while a clip simply plays.
          if (_bufCalm >= 4 && !v.seeking && v.readyState >= 3) { bufStop(); }
          return;
        }
        _bufCalm = 0;
        if (now - _bufMovedAt >= (v.seeking ? BUF_SEEK_MS : BUF_STALL_MS)
            && !_bufShowT && !media.classList.contains('vc-buffering')) {
          _bufShowT = setTimeout(function () {
            _bufShowT = null;
            // re-ask AT THE MOMENT OF PAINT: anything that moved in between cancels the ring
            if (!v.paused && !v.ended && v.currentTime <= _bufT + 0.008) buffOn();
          }, BUF_SHOW_MS);
        }
      }
      /* The prompts. `play` covers the initial open and a resume -- play() clears `paused`
         SYNCHRONOUSLY, so a clip still fetching its first frame is already "supposed to be playing"
         and a genuine opening wait shows the ring on the same rule as any other stall. */
      ['play', 'playing', 'canplay', 'loadstart', 'seeking', 'waiting', 'stalled'].forEach(function (ev) {
        v.addEventListener(ev, bufArm);
      });
      // ...and the clock itself, which is free: same reads, and it hides the ring the moment a frame
      // lands even if the sampler happened to be off.
      v.addEventListener('timeupdate', function () { if (_bufIv || media.classList.contains('vc-buffering')) bufSample(); });
      ['pause', 'ended', 'emptied'].forEach(function (ev) {
        v.addEventListener(ev, function () { buffOff(); bufStop(); });
      });
      v.addEventListener('canplay', function () {
        buffOff();
        // iOS frequently vetoes or drops the FIRST autoplay before the clip is decodable, which left a
        // just-tapped video paused (and, before the fix above, spinning). When it can finally play, re-kick
        // it if it should be running -- in view, not user-paused, autoplay on. Muted fallback if an unmuted
        // play is vetoed (a tap re-adds sound via the pill). This is what makes the open reliably start.
        if (v.paused && !v._userPaused && feedPref('autoplay', true) && inView(v) && !document.pictureInPictureElement) {
          var p = v.play();
          if (p && p.catch) p.catch(function () {
            if (!v.muted) { applying = true; v._engineSetAt = Date.now(); v.muted = true; applying = false; var p2 = v.play(); if (p2 && p2.catch) p2.catch(function () {}); }
          });
        }
      });
      playB.addEventListener('click', function (e) { stop(e); if (v.paused) { v._userPaused = false; engVideo(v); v.play().catch(function () {}); } else { v._userPaused = true; v.pause(); } });   // engage-hold: the play control holds the feed
      if (pipB) pipB.addEventListener('click', function (e) { stop(e); if (window.__rovaPipAsk) window.__rovaPipAsk(); try { document.pictureInPictureElement ? document.exitPictureInPicture() : v.requestPictureInPicture(); } catch (er) {} });
      if (fsB) fsB.addEventListener('click', function (e) {
        stop(e);
        // in the FEED, fullscreen opens the immersive TikTok viewer (scroll all the feed's
        // media) rather than the native player; falls back to native elsewhere
        var postEl = media.closest && media.closest('.post');
        var pid = postEl && postEl.getAttribute('data-view');
        if (pid && !(media.closest && media.closest('.pfeed')) && window.__rovaFeedView && window.__rovaPageMediaIds) {
          var ids = window.__rovaPageMediaIds();
          if (ids.indexOf(pid) >= 0) {
            // in a carousel, land the viewer on THIS video's slide (host is the .cslide)
            var vSlide = unit.closest && (unit.closest('.cslide') || (media.closest && media.closest('.cslide')));
            var vsi = vSlide ? Array.prototype.indexOf.call(vSlide.parentNode.children, vSlide) : 0;
            // Stop the inline copy BEFORE the immersive viewer's own <video> starts -- otherwise both
            // played at once (audio doubled, and visibly if the open transition isn't fully opaque
            // yet) until something else happened to pause this one. The viewer resumes from the
            // exact time below, so this is a handoff, not a stop.
            var fsT = v.currentTime || 0;
            // SNAP OPEN exactly like a grid tap: if the clip is live-playing, FLY THE ACTUAL <video> (its
            // buffer, decoder and position hand straight into the viewer -- no re-download, no cross-fade, no
            // load-wait; that adopt is what makes the grid feel instant vs the choppy still-frame path). The
            // timeline can't rebuild a moved-out clip, so record how to RETURN this exact element on close.
            var liveHero = v.readyState >= 2 && v.videoWidth > 0 && !v.paused && v.currentTime > 0.03;
            if (liveHero && window.__rovaHeroExpand) {
              // capture what's needed to REBUILD a fresh inline clip on close (poster + mp4 + hls). Rebuilding
              // beats moving the live element back, which can render BLACK while audio keeps running (see close()).
              window.__rovaFsBorrow = { media: media, video: v, cls: v.className, styleText: v.getAttribute('style') || '',
                poster: v.getAttribute('poster') || v._posterStash || '',
                mp4: v._mp4src || v.getAttribute('data-video-src') || v.getAttribute('src') || '',
                hls: v.getAttribute('data-hls') || '' };
              window.__rovaGridDonor = null;                 // v IS the hero -> single-element handoff, no separate donor
              window.__rovaHeroExpand(v.getBoundingClientRect(), '', v);   // fly the live clip (keeps playing into the viewer)
              // the card's box is EMPTY until v comes home -- let it show the card, not a black box
              // (rova.css .fs-away; cleared by whichever statement puts v back)
              if (!media.contains(v) || v._liftDeferred) { media.classList.add('fs-away'); }
            } else {
              // paused / not-ready fallback: fly the current frame as a still and cross-fade (heroExpand handles
              // video-still now); leave the inline element in place.
              var _fsFrame = (typeof videoFrameSrc === 'function' ? videoFrameSrc(v) : '') || v.getAttribute('poster') || '';
              window.__rovaFsBorrow = null;
              /* DECLARE THE CLIP, NOT JUST HAND OVER A PICTURE OF IT (2026-08-30). This branch flew a
                 still with no aspect and no kind: heroExpand got neither predDims nor a decoded srcImg,
                 so no flight could start against a prediction at all, and flyCrop fell through to its
                 park-box fallback -- safe (it never invents a crop) but it draws "fill the window"
                 rather than the cover extent the viewer paints, so a covered clip still corrected by
                 the overflow at the hand-off. Measured by tools/flight-fit-check.js: 84px on the
                 park path, and 356px on a 720x900 clip once a prediction did happen, because
                 `photo: true` sent a CLIP through the photo cover/contain rule.
                 videoWidth first, then the width/height views/_post.php stamps from the poster -- the
                 same attribute-last ladder mediaIntrinsic uses, so a clip that has not loaded still
                 answers. `el: v` carries the clip's own data-fit hint into the same verdict the pfeed
                 will paint with. */
              var _fsW = v.videoWidth || parseInt(v.getAttribute('width'), 10) || 0;
              var _fsH = v.videoHeight || parseInt(v.getAttribute('height'), 10) || 0;
              var _fsPd = (_fsW > 0 && _fsH > 0) ? { w: _fsW, h: _fsH, video: true, el: v } : undefined;
              if (window.__rovaHeroExpand) { window.__rovaHeroExpand(v.getBoundingClientRect(), _fsFrame, null, null, _fsPd); }
              else { heroZoom(v.getBoundingClientRect(), _fsFrame, v.videoWidth, v.videoHeight, fsT > 0); }
              try { v.pause(); } catch (e) {}
            }
            // carry the inline clip's position so the immersive viewer RESUMES it (fullscreen = continue)
            window.__rovaFeedView(ids, pid, vsi, fsT); return;
          }
        }
        try { if (v.requestFullscreen) v.requestFullscreen(); else if (v.webkitEnterFullscreen) v.webkitEnterFullscreen(); else if (media.requestFullscreen) media.requestFullscreen(); } catch (er) {}
      });
      /* THE CLIP'S RUNNING TIME, with the SERVER'S answer as the fallback.
         v.duration is NaN until `loadedmetadata`, and since 2026-08-08 views/_post.php ships
         feed/carousel video with preload="none" whenever it has a poster AND server-stamped
         width/height (the origin-saturation fix). A preload="none" element never loads by itself, so
         that event may never fire at all -- and every readout below was dividing by NaN: the bar
         painted "0:00 / 0:00" with a 0% fill on a clip the server knew was 56.7s long, and stayed
         that way until something happened to promote the element. Under the old preload="metadata"
         the browser had answered this for us before the first paint.
         data-dur is the ffprobe duration stamped at transcode time (VideoJobs::markDuration ->
         <stem>_w.dur sidecar, the same convention as the .silent no-audio marker -> video_duration()
         -> views/_post.php). It costs zero bytes and promotes nothing.
         IT IS A FALLBACK, NEVER AN OVERRIDE. The instant the element reports a real duration that
         wins, so a stamp that disagrees with the media self-corrects on load rather than persisting
         as a wrong readout. No stamp and no metadata returns 0, which is byte-for-byte the old
         behaviour: "0:00 / 0:00" and an empty bar. */
      function vdur() {
        var d = v.duration;
        if (d && isFinite(d)) { return d; }
        d = parseFloat(v.getAttribute('data-dur') || '');
        return (d > 0 && isFinite(d)) ? d : 0;
      }
      // The fraction the finger is on while the clip still has no media data (-1 = not scrubbing).
      // See seekApply below: it is what lets the bar follow a drag the browser cannot yet honour.
      var seekPend = -1;
      function syncMini(atT) {
        var d = vdur(), c = (atT == null ? (v.currentTime || 0) : atT);
        mini.textContent = fmtT(d ? Math.max(0, d - c) : c);
      }
      v.addEventListener('loadedmetadata', function () { syncMini(); });   // the event object is NOT a time
      /* THE TWO THINGS THAT ARE ALLOWED TO CHANGE WHEN THE SLIDE CHANGES (owner: "only thing changing
         here should be the time and progress bar for each new media"). Named and called EAGERLY below,
         not just bound to timeupdate: a pinned carousel bar is rebuilt against the incoming clip the
         moment the slide index moves, and a clip whose metadata is already in hand -- the common case,
         since the neighbour was preloaded -- fires no timeupdate until it actually advances. Bound to
         timeupdate alone the readout sat at "0:00 / 0:00" with an empty progress bar for the length of
         the glide, which is the same class of bug as showing the PREVIOUS clip's numbers: the bar was
         describing something that wasn't on screen. */
      function paintTime() {
        var d = vdur(), c = v.currentTime || 0;
        // UNDER A FINGER THE BAR REPORTS THE FINGER (2026-09-10), never the element's clock: the
        // clock is whatever the last preview seek managed to land, which on a long mp4 is a keyframe
        // some way behind the drag. dragFrac is set on rAF from the pointer (see dragPaint below).
        if (dragging && dragFrac >= 0 && d) { c = dragFrac * d; }
        // Mid-scrub on a clip with no media data yet: the bar follows the FINGER, not the (still 0)
        // currentTime, so the drag is visible immediately instead of after the fetch seekPromote()
        // kicked off finally lands. seekPend clears the moment a real seek is applied.
        else if (seekPend >= 0 && d) { c = seekPend * d; }
        var pct = d ? (c / d * 100) : 0;
        // written only when the text changes (timeupdate fires ~4x a second; the seconds move once)
        var cs = fmtT(c), ds = d ? fmtT(d) : '';
        if (cs !== tCurS) { tCurS = cs; tCur.textContent = cs; }
        if (ds !== tDurS) { tDurS = ds; tDur.textContent = ds; }
        fill.style.width = pct + '%'; knob.style.left = pct + '%';
        syncMini(c);
      }
      v.addEventListener('loadedmetadata', paintTime);   // the element's OWN duration lands here
      v.addEventListener('timeupdate', function () {
        paintTime();
        // ...and re-ask the buffering rule rather than clearing it outright: timeupdate ALSO fires on
        // a seek and on a pause, neither of which is forward progress, so an unconditional buffOff()
        // here would wipe a ring that is telling the truth. bufSample() hides it only if the clock moved.
        if (media.classList.contains('vc-buffering')) bufSample();
      });
      /* PROMOTE THIS ONE CLIP, UNDER A DIRECT GESTURE, ONCE.
         data-dur fixes the DISPLAY; it cannot fix the INTERACTION. A stamped duration lets seekTo
         work out where 62% of the clip is, but the browser still has to have fetched media before it
         can put the playhead there -- on a preload="none" element it has fetched nothing, so a drag
         moved nothing at all.
         SAME SHAPE AND SAME REASON AS pfResume's one-time promotion (search __rovaPfResume): raise
         preload, and call load() ONLY when a fetch is not already open. v.load() runs the whole media
         load algorithm, which ABORTS whatever is in flight and starts again -- and play() starts a
         fetch WITHOUT touching preload, so "preload is still none" is not the same question as
         "nothing is downloading". networkState 2 (NETWORK_LOADING) is the engine's own answer; in
         that state the preload raise alone lets the buffer grow past metadata without disturbing the
         request.
         THIS DOES NOT RAISE THE CONCURRENCY CEILING. It is one element, promoted at most once, and
         only under a finger that is already down on that element's own seek bar -- nobody scrubs two
         clips at once, and no code path calls it. Measured on /p/15454#c1 with autoplay off: peak
         concurrent byte-bearing media requests 0 before the scrub, 1 during it. */
      function seekPromote() {
        // readyState 0 (HAVE_NOTHING), not `preload === 'none'`, is the honest precondition: the
        // question is "can this element seek yet", and the answer is no exactly while it has no
        // metadata. preload="none" is the common way to get there but not the only one -- warmIO
        // hands a not-yet-visible card preload="metadata" and the engine can still defer it, which
        // leaves the same dead bar and the same dead scrub. At readyState >= 1 the duration is
        // already in hand and there is nothing to promote. No src = a torn-down clip (teardownVideo
        // strips it); there is nothing to load.
        if (v._vcSeekKick || v.readyState >= 1 || !v.getAttribute('src')) { return; }
        v._vcSeekKick = 1;
        var loading = (v.networkState === 2);   // NETWORK_LOADING: a fetch is already open on this element
        if (v.preload !== 'auto') { v.preload = 'auto'; }
        if (!loading) { try { v.load(); } catch (er) {} }
      }
      /* With real media data this is the one-liner it always was. Without it, remember the FRACTION
         and paint the bar there off the stamped duration; the loadedmetadata handler below lands it
         as soon as seekPromote's fetch produces a seekable clip. Before this, seekTo just returned
         on a falsy v.duration and the whole gesture was silently discarded. */
      function seekApply(frac) {
        var d = v.duration;
        /* PAINT THE DRAG, DO NOT WAIT TO BE TOLD ABOUT IT (#655's web half).
           This branch used to set currentTime and return, leaving the fill, the knob and
           the 0:00/0:00 readout to whatever `timeupdate` chose to deliver. On a paused
           element under a finger that is nearly nothing: measured on /p/43079, dragging
           the bar from 60% to 25% moved v.currentTime live and exactly (120.9 -> 85.7 ->
           50.4) while .vc-fill stayed pinned at 60.4424% and .vc-time at "2:01 / 3:21"
           for the WHOLE gesture, both snapping only on release. The playhead was moving
           and the bar reporting it was frozen — the same sentence the owner filed about
           the app, on the surface where it is easiest to see.
           THE ELEMENT ALREADY KNOWS. Assigning currentTime updates the OFFICIAL playback
           position synchronously (only the media-data seek is async), so reading it back
           one line later is exact, including any clamp the engine applied — which is why
           this repaints from paintTime's own source rather than from `frac`, and cannot
           disagree with the timeupdate that follows.
           The no-duration path below already worked this way (that is what seekPend and
           its paintTime are for); this makes the ordinary path behave like the one that
           was written for the hard case. */
        if (d && isFinite(d)) { seekPend = -1; try { v.currentTime = frac * d; } catch (er) {} paintTime(); return; }
        seekPend = frac;
        paintTime();
      }
      v.addEventListener('loadedmetadata', function () {
        if (seekPend < 0) { return; }
        var f = seekPend; seekPend = -1;
        // Dropped if the element has meanwhile advanced under its own steam -- something else owns
        // the position now (a resume seek, a grid hand-off), and this must never yank it back.
        if ((v.currentTime || 0) <= 0.35) { try { v.currentTime = f * (v.duration || 0); } catch (er) {} }
        paintTime();
      });
      /* ---- THE SCRUB (rewritten 2026-09-10; owner on iPad Safari: "the playback scrubber isn't
         optimal and feels weird ... other apps are smooth and not jittery when I'm scrubbing").

         MEASURED on the old code (scratchpad/scrubrig.js, real CDP touch, /p/48869 = his 2:56 clip,
         390x844): a 1.5s drag issued 63 `currentTime=` (42/s, one per move), the engine fired 65
         `seeking` and ZERO `seeked` -- every seek aborted the one before it, readyState sat at 1 for
         the whole gesture and the clip presented 4 frames in 1.5s. The picture was frozen behind a
         moving thumb. And because the clip was still PLAYING under the finger, those 1.5s of
         `waiting` tripped wire()'s sustained-stall recovery: right after release the element read
         readyState 0 / currentTime 0 / paused for ~800ms and came back on the LOW-FIRST HLS ladder
         (360p) -- a scrub was being diagnosed as a slow line. That is the "weird".

         The standard the other apps set, and what this does now:
           - the thumb, fill and readout follow the FINGER, on rAF, from the pointer (dragFrac) --
             never from the clock while dragging (paintTime reads dragFrac first).
           - AT MOST ONE media-data seek in flight. A preview seek goes out only when the previous
             one has `seeked` (2s safety so a silent engine cannot freeze the preview); the
             newest position is remembered and sent when the engine is free, so seeks never queue
             behind each other. fastSeek() where the engine has it (Safari): nearest keyframe is a
             cheap preview, and it is a preview.
           - PAUSED while dragging (muted left as it was), resumed on release if it was playing.
             _userPaused is held true for the gesture so nothing auto-resumes it under the finger
             (the canplay re-kick below, soundRepair, the IO paths all defer to it) and restored
             on release; the engagement hold the transport play button takes is re-taken the same
             way (engVideo) so a scrub does not silently drop it.
           - release lands ONE precise `currentTime=` at the drop point (seekApply), which is also
             what the bar keeps painting, so nothing snaps back when playback resumes.
           - ONE layout read per gesture: the bar rect is cached on pointerdown (re-read only if
             the viewport size changes mid-drag). The move handler paints from the cached rect and
             touches only the fill, the knob and the two readouts; the seek waits for the frame. */
      var dragging = false, dragFrac = -1, dragX = 0, dragRect = null, dragRaf = 0;
      var wasPlaying = false, prevUserPaused, hadEng = false, scrubKind = '';
      var seekBusy = 0, seekWant = -1, seekSafeT = null;
      /* ---- THE PREVIEW SEEK, ROUND 2 (2026-09-29; Rob on desktop Safari, the viewer on @shanice's
         7.8s clip /p/807: "keeps resetting the browser and it doesn't follow the position when I'm
         moving it ... doesn't feel as smooth as it should be"). Both faults rode fastSeek(), which only
         WebKit has -- that is why Chromium never showed either:
           1. KEYFRAME-ONLY PREVIEWS. fastSeek() lands on the nearest KEYFRAME, and the web mp4s are x264
              at the default keyint (250 frames, 8.3s at 30fps: lib/videojobs.php's main encode sets no
              -g). /p/807 has exactly TWO keyframes, 0.0s and 5.0s (ffprobe -skip_frame nokey), so every
              preview in a whole drag was one of two pictures: the thumb moved, the picture did not.
           2. A SEEK STORM. A keyframe landing on a buffered clip completes inside a frame, so "one in
              flight, the next on `seeked`" became one seek EVERY animation frame -- ~60/s for as long as
              the button is down, nearly all re-landing on the same keyframe, each one a flush of the
              media pipeline. Twenty seconds of scrubbing is ~1,200 seeks. Nothing else in the gesture
              allocates (no source swap, no new element, no canvas, no hls.js -- measured), so that storm
              is the leading suspect for the WebContent crash ("This webpage was reloaded because a
              problem occurred").
         NOW: a PRECISE seek (currentTime) wherever the target is already BUFFERED -- the only preview
         that shows the frame under the pointer; fastSeek() only for an UNBUFFERED target, where a nearby
         keyframe is the honest cheap preview while the bytes arrive, or while the pointer is SWEEPING
         (SEEK_FAST_JUMP between previews -- QuickTime's own rule: keyframes while you fly, exact frames
         the moment you slow down). Still ONE seek in flight, plus a
         floor between issues (SEEK_GAP_MS) and no re-issue within SEEK_EPS of the last target sent -- a
         pointer that has not moved a frame's worth sends nothing. Worst case 25 seeks/s; in practice
         the engine's own decode rate. */
      var SEEK_GAP_MS = 40, SEEK_EPS = 0.02, SEEK_FAST_JUMP = 2, seekLastT = -1, seekLastAt = 0, seekGapT = null;
      function seekBuffered(t) {
        try { var b = v.buffered; for (var i = 0; i < b.length; i++) { if (t >= b.start(i) && t <= b.end(i)) { return true; } } } catch (er) {}
        return false;
      }
      function previewSeek(frac) {
        var d = v.duration;
        if (!(d && isFinite(d))) { seekPend = frac; return; }   // no media data yet: land it on loadedmetadata (below)
        if (seekBusy) { seekWant = frac; return; }              // one in flight: remember the newest, send it when free
        var t = frac * d;
        if (seekLastT >= 0 && Math.abs(t - seekLastT) < SEEK_EPS) { seekWant = -1; return; }   // not a frame's worth of change
        var wait = SEEK_GAP_MS - (performance.now() - seekLastAt);
        if (wait > 0) {                                         // too soon after the last one: hold the newest, send it then
          seekWant = frac;
          if (!seekGapT) {
            seekGapT = setTimeout(function () { seekGapT = null; if (dragging && seekWant >= 0) { var f = seekWant; seekWant = -1; previewSeek(f); } }, wait);
          }
          return;
        }
        // fastSeek only where a precise frame is not worth waiting for: bytes not here yet, or the pointer is
        // SWEEPING (more than SEEK_FAST_JUMP since the last preview -- a long clip crossed quickly, where a
        // mid-GOP decode per preview would lag the hand). Slow down and every preview is the exact frame.
        var fast = typeof v.fastSeek === 'function' && (!seekBuffered(t) || (seekLastT >= 0 && Math.abs(t - seekLastT) > SEEK_FAST_JUMP));
        seekWant = -1; seekBusy = 1; seekLastT = t; seekLastAt = performance.now();
        try { if (fast) { v.fastSeek(t); } else { v.currentTime = t; } }
        catch (er) { seekBusy = 0; return; }
        /* 2s, not shorter: on a card whose neighbours are still pulling their own clips a range fetch can
           take 400-1100ms (measured on /@trenchwurk), and a shorter safety aborted fetches that were about
           to land -- re-issuing is exactly the thrash this rule exists to stop. Release never waits on it. */
        clearTimeout(seekSafeT); seekSafeT = setTimeout(seekFree, 2000);
      }
      function seekFree() {
        clearTimeout(seekSafeT); seekSafeT = null; seekBusy = 0;
        if (dragging && seekWant >= 0) { var f = seekWant; seekWant = -1; previewSeek(f); }
      }
      v.addEventListener('seeked', seekFree);
      function dragFracAt(x) { return Math.max(0, Math.min(1, (x - dragRect.left) / dragRect.width)); }
      /* The PAINT is synchronous with the pointer (three style writes and two text nodes -- no layout
         is read, so nothing is forced; the engine renders once per frame regardless), which puts the
         thumb under the finger on the very frame the move arrives. Only the media-data SEEK waits for
         rAF: one preview request per frame at most, and previewSeek's one-in-flight rule on top. */
      function dragSeekTick() { dragRaf = 0; if (dragging && dragFrac >= 0) { previewSeek(dragFrac); } }
      function dragPaint() {
        if (!dragging || !dragRect || !dragRect.width) { return; }
        dragFrac = dragFracAt(dragX);
        paintTime();
        if (!dragRaf) { dragRaf = requestAnimationFrame(dragSeekTick); }
      }
      function dragMove(x) { dragX = x; dragRectFresh(); dragPaint(); }
      // Orientation / viewport change mid-drag: re-read the rect ONLY then. Checked on the move path
      // against the viewport size (no layout read) rather than through window listeners, because
      // buildControls runs per clip -- and per slide on the pinned carousel bar -- and a window
      // listener per call would never be released.
      var dragVW = 0, dragVH = 0;
      function dragRectFresh() {
        if (window.innerWidth !== dragVW || window.innerHeight !== dragVH) {
          dragVW = window.innerWidth; dragVH = window.innerHeight; dragRect = seek.getBoundingClientRect();
        }
      }
      /* ONE SCRUB SESSION, WHATEVER DRIVES IT (2026-09-29). The pointer drag, the two-finger trackpad
         scrub (media.__vcScrub, driven by the document wheel listener after buildControls) and nothing
         else open one; every rule above and below -- pause for the gesture, _userPaused held, the stall
         guard's v._scrubbing stamp, paint from the gesture, one seek in flight, ONE precise landing and
         the resume -- is the session's, so a new input cannot grow its own copy of half of them.
         scrubLive (outside buildControls) counts open sessions: the viewer's idle fade asks it, so the
         bar cannot fade out from under a drag held still or a trackpad scrub (which sends no pointermove). */
      function scrubBegin(kind) {
        if (dragging) { return false; }
        dragging = true; scrubKind = kind; scrubLive++; scrubLiveAt = Date.now();
        scrubbing(); seekPromote();
        wasPlaying = !v.paused && !v.ended;
        hadEng = !!v._userPlayed;
        prevUserPaused = v._userPaused;
        v._userPaused = true;                                    // held for the gesture only; dragEnd restores it
        if (wasPlaying) { try { v.pause(); } catch (er) {} }
        seekBusy = 0; seekWant = -1; seekLastT = -1; seekLastAt = 0;
        try { showBar(); } catch (er) {}
        if (window.__rovaPfWake && media.closest && media.closest('.pfeed')) { try { window.__rovaPfWake(); } catch (er) {} }
        return true;
      }
      // a position from anything that is not the pointer (the trackpad scrub): paint now, seek on the frame
      function scrubTo(frac) {
        if (!dragging) { return; }
        dragFrac = Math.max(0, Math.min(1, frac)); scrubbing(); scrubLiveAt = Date.now();
        paintTime();
        if (!dragRaf) { dragRaf = requestAnimationFrame(dragSeekTick); }
      }
      function dragEnd() {
        if (!dragging) { return; }
        dragging = false; scrubKind = ''; scrubLive = Math.max(0, scrubLive - 1); scrubbing();
        if (dragRaf) { cancelAnimationFrame(dragRaf); dragRaf = 0; }
        clearTimeout(seekSafeT); seekSafeT = null; seekBusy = 0; seekWant = -1;
        clearTimeout(seekGapT); seekGapT = null; seekLastT = -1;
        var f = dragFrac; dragFrac = -1; dragRect = null;
        v._userPaused = prevUserPaused;
        if (f >= 0) { seekApply(f); }                          // the one precise landing, exactly where the finger lifted
        if (wasPlaying) {
          wasPlaying = false;
          if (hadEng) { try { engVideo(v); } catch (er) {} }   // the hold the play button takes: a scrub must not drop it
          try { var p = v.play(); if (p && p.catch) { p.catch(function () {}); } } catch (er) {}
        }
        // the bar's own fade and the viewer's idle dwell both restart from the release, not from the press
        try { showBar(); } catch (er) {}
        if (window.__rovaPfWake && media.closest && media.closest('.pfeed')) { try { window.__rovaPfWake(); } catch (er) {} }
      }
      // A scrub in progress tells the pfeed's pull-to-dismiss to stand down, through the SAME hook the
      // double-tap-to-like already uses (window.__rovaMediaTapAt, read at assets/app.js's pfeed touchmove/
      // touchend). It is a timestamp with a 350ms window, so re-stamp it on every move: a long, slow drag
      // must keep the dismiss asleep for the whole gesture, not just its first third. Without this a scrub
      // that drifts downward while the viewer sits at the top of the list can hand the drag to the dismiss.
      /* W#58, the other half: a scrub is not a viewing. __rovaVideoOnePass detects "one complete
         pass" by the currentTime WRAP (near-end -> near-start) plus the non-loop "ran out" edge,
         and a finger dragging the bar to either edge reproduces both signatures exactly -- so a
         scrub was counterfeiting a completed pass and firing the slideshow / hands-free / carousel
         advance. Stamp the element while a scrub owns the position (a timestamp, not a flag,
         re-stamped on every move like __rovaMediaTapAt above: the pointer can be taken away
         without a pointerup, and the seek the finger asked for can land a beat AFTER release --
         a short self-expiring grace covers both without any listener to leak). onePass reads it. */
      var scrubbing = function () { window.__rovaMediaTapAt = Date.now(); v._scrubbing = Date.now(); };
      seek.addEventListener('pointerdown', function (e) {
        stop(e);
        if (dragging) { return; }                                // a second finger never restarts the gesture
        if (e.button != null && e.button > 0) { return; }        // right / middle button: not a scrub
        var r0 = seek.getBoundingClientRect();                  // the ONE layout read of the gesture
        if (!r0.width) { return; }
        if (!scrubBegin('pointer')) { return; }
        dragVW = window.innerWidth; dragVH = window.innerHeight; dragRect = r0;
        try { seek.setPointerCapture(e.pointerId); } catch (er) {}
        dragX = e.clientX; dragPaint();                          // the first frame lands under the finger at once
      });
      seek.addEventListener('pointermove', function (e) { if (dragging && scrubKind === 'pointer') { scrubbing(); scrubLiveAt = Date.now(); dragMove(e.clientX); } });
      seek.addEventListener('pointerup', function (e) {
        if (!dragging || scrubKind !== 'pointer') { return; }
        // the drop point is where the finger LIFTED, not the last frame it was painted at
        if (e && e.clientX != null && dragRect && dragRect.width) { dragFrac = dragFracAt(e.clientX); }
        dragEnd();
      });
      // pointercancel: the browser (or an ancestor's preventDefault) took the pointer away mid-drag.
      // Without this the flag stayed true, so the NEXT stray pointermove over the bar -- with no finger
      // down at all -- would seek the clip. It ends the gesture in full (landing + resume), never
      // just clears the flag: a clip paused for the drag must not be left paused by a cancel.
      seek.addEventListener('pointercancel', function () { if (scrubKind === 'pointer') { dragEnd(); } });
      // ...and LOSING THE CAPTURE any other way (2026-09-29): the bar torn down and rebuilt under the drag
      // (a carousel handover, the grid-donor swap), a capture released by the engine. pointerup always
      // arrives FIRST on a normal release, so this is a no-op then; without it the clip stayed paused
      // with _userPaused held true for the rest of the page.
      seek.addEventListener('lostpointercapture', function () { if (dragging && scrubKind === 'pointer') { dragEnd(); } });
      /* The handle the trackpad scrub and the viewer's arrow keys drive (see the wheel listener after
         buildControls). It hangs on the BAR HOST, which is the carousel's one pinned host on a gallery:
         the listener checks host._vctrl === api.v, so a host rebuilt for another slide (or handed to a
         photo bar, which nulls _vctrl) is never driven through a stale closure. Positions are SECONDS
         here, accumulated from the gesture's own start, so a delta can never be lost to a seek that has
         not landed yet. */
      var wheelT = 0;
      media.__vcScrub = {
        v: v,
        width: function () { return seek.getBoundingClientRect().width || 0; },
        start: function () { if (!scrubBegin('wheel')) { return false; } wheelT = v.currentTime || 0; return true; },
        by: function (dt) {
          if (!dragging || scrubKind !== 'wheel') { return; }
          var d = vdur(); if (!d) { return; }
          wheelT = Math.max(0, Math.min(d, wheelT + dt));
          scrubTo(wheelT / d);
        },
        end: function () { if (dragging && scrubKind === 'wheel') { dragEnd(); } },
        // the arrow keys: one precise seek, no pause (a key press is not a gesture that is held)
        nudge: function (dt) {
          if (dragging) { return; }
          var d = vdur(); if (!d) { return; }
          scrubbing(); seekApply(Math.max(0, Math.min(d, (v.currentTime || 0) + dt)) / d);
          try { showBar(); } catch (er) {}
        }
      };
      bar.addEventListener('click', function (e) {
        // folded action buttons (comment/share) live in this bar in the immersive feed --
        // let their clicks bubble to the delegated document handlers so, e.g., the comment
        // button opens the inline panel just like it does on a photo.
        if (e.target.closest && e.target.closest('.pf-act')) return;
        e.stopPropagation();                                                   // otherwise never open the viewer from the bar
      });
      var hideT;
      /* ATTENTION HOLD. In the immersive viewer this bar is not just a video transport: pfMoveActs /
         ensureCarouselActs fold the post's ENTIRE engagement row (.pf-act -- heart, comment, repost,
         share) into its .vc-row. So this 2.6s timer is one of the two things that literally takes the
         heart away from under the reader's finger seconds after they tapped it. Hold it open while an
         attention hold is live and re-check on a slow beat, rather than cancelling the fade outright --
         the bar must still get out of the way once they have genuinely stopped. */
      function showBar() {
        media.classList.add('vc-show');
        clearTimeout(hideT);
        if (v.paused) return;
        var hide = function () {
          // in the viewer only a hold armed since it opened counts (engAttnViewer, Rob 2026-10-17)
          if (media.closest && media.closest('.pfeed') ? engAttnViewer() : engAttn()) { hideT = setTimeout(hide, 1000); return; }
          media.classList.remove('vc-show');
        };
        hideT = setTimeout(hide, 2600);
      }
      media.addEventListener('pointermove', showBar);
      media.__vcShow = showBar;
      // ...and on the MEDIA itself when the bar is pinned elsewhere: the host is then a thin strip at the
      // bottom, so a pointer over the clip would no longer wake the controls (and slideMedia / the tap
      // handlers reach for unit.__vcShow, not the host's).
      if (unit !== media) { unit.addEventListener('pointermove', showBar); unit.__vcShow = showBar; }
      // Picture-in-picture: the browser paints its own unreadable placeholder text on
      // the emptied <video>. Cover it with our own clean message + a way back.
      var pipMsg = document.createElement('div');
      pipMsg.className = 'vc-pipmsg';
      pipMsg.innerHTML = VC.pip + '<span>Playing in picture-in-picture</span>'
        + '<button type="button" class="vc-pipback">Bring it back</button>';
      media.appendChild(pipMsg);
      pipMsg.addEventListener('click', function (e) { e.stopPropagation(); });
      pipMsg.querySelector('.vc-pipback').addEventListener('click', function (e) { stop(e); try { document.exitPictureInPicture(); } catch (er) {} });
      v.addEventListener('enterpictureinpicture', function () { media.classList.add('vc-inpip'); });
      v.addEventListener('leavepictureinpicture', function () { media.classList.remove('vc-inpip'); });
      // Immersive feed video: ONE control bar. Fold the post's action buttons into the player row (no
      // separate floating action bar). Single video -> fold here and park the volume mute at the row's
      // end. Carousel video slide -> the actions live in whichever slide is current (ensureCarouselActs);
      // the mute stays in its corner. Either way the mute-the-PERSON button is dropped (it's in the ⋯ menu).
      if (media.closest && media.closest('.pfeed')) {
        var pfPost = media.closest('.post');
        var pfRow  = bar.querySelector('.vc-row');
        var pfCar  = media.closest('.carousel');
        if (pfCar) {
          ensurePinnedBarWired(pfCar);   // re-point this one bar at each slide we land on
          if (pfPost) ensureCarouselActs(pfCar, pfPost);
          // The mute joins the row, exactly as it does for a single video. It used to be left in its
          // absolute bottom-right corner "so it never moves" -- but the corner was inside the SLIDE, so
          // it was the one control guaranteed to move. Pinned, the row is the still place.
          if (pfRow && media.classList.contains('pf-cbar')) { pfRow.appendChild(msound); msound.classList.add('pf-inrow'); }
        } else if (pfPost && pfRow) {
          media.classList.add('pf-vfeed');
          pfMoveActs(pfPost, pfRow);
          pfRow.appendChild(msound); msound.classList.add('pf-inrow');
        }
      }
      syncPlay(); syncMute(); syncAudioAvail(); paintTime();
    }
    // let other surfaces (the media gallery) reuse this exact glassy player
    window.__rovaVCtrl = buildControls;

    /* ---- TWO-FINGER TRACKPAD SCRUB IN THE VIEWER (owner 2026-09-29: "two finger drag on my trackpad
       should allow for smooth perfect scrubbing like quicktime on mac") ---------------------------------
       A horizontal two-finger swipe over a VIDEO in the open viewer drives the SAME scrub session as the
       seek bar (buildControls' media.__vcScrub): paused for the gesture, the bar painted from the
       gesture, one preview seek in flight, one precise landing ~WS_QUIET_MS after the last event, resumed
       if it was playing, the stall guard stamped throughout. Nothing here seeks by itself.
       GESTURES ARE SEGMENTED ON THE INPUT CLOCK (e.timeStamp): quiet WS_QUIET_MS ends one; a HOLE of
       WS_GAP_MS followed by the OTHER axis starts a new one. The AXIS IS DECIDED ONCE, on a gesture's first
       event, by the same test the vertical pager uses (|dy| > |dx| is vertical) -- a gesture that starts
       vertical belongs to the one-post-per-gesture pager for its whole life (we never look at it again,
       so its sideways wobble can never scrub), and one that starts horizontal over a clip is the scrub's
       for its whole life (its vertical wobble is swallowed, so it can never page). Every event of a scrub
       is preventDefault'ed -- Safari's two-finger history swipe and horizontal overscroll never fire -- and
       stopped at DOCUMENT CAPTURE, ahead of the pager's scroller-capture listener, the carousel's wheel
       lock and the cover-crop panners.
       CALIBRATION: seconds per px = duration / bar width (the width clamped to 600..1200 px so the feel
       does not change with the window), capped at WS_MAX_SPP so a long clip keeps a usable resolution:
       a full bar-width of deltaX is the whole of any clip up to ~5 minutes. DIRECTION: deltaX > 0 is
       FORWARD (WS_SIGN), the platform's own scroll sense and the gallery's (deltaX > 0 = next slide):
       deltaX already carries the reader's natural-scrolling preference, so the timeline moves the way
       every other horizontal surface on their Mac does. One constant flips it.
       MOMENTUM IS DAMPED, NOT HONOURED: once the stream has decayed for WS_COAST_N events in a row to
       under half its peak it is the post-lift glide, and it moves the playhead at WS_COAST of its size --
       a short settle instead of an overshoot (a scrub that coasts past the frame you let go on is the
       opposite of precise). A fresh rise (a finger back on the pad) restores full rate.
       GALLERIES: a photo slide is the carousel's, untouched. On a VIDEO slide the first WS_DECIDE_N events
       (or WS_DECIDE_MS) decide: WS_FLICK_PX of travel that fast is a flick and pages the gallery exactly
       once (its tail swallowed, the carousel's own one-slide rule); anything slower scrubs. */
    var scrubLive = 0, scrubLiveAt = 0;                  // open scrub sessions (buildControls' scrubBegin/dragEnd)
    window.__rovaScrubLive = function () { return scrubLive > 0 && Date.now() - scrubLiveAt < 30000; };
    (function () {
      var WS_QUIET_MS = 140, WS_GAP_MS = 90, WS_SIGN = 1, WS_MAX_SPP = 0.25, WS_REF_MIN = 600, WS_REF_MAX = 1200;
      var WS_COAST = 0.25, WS_COAST_N = 4, WS_FLICK_PX = 60, WS_DECIDE_MS = 60, WS_DECIDE_N = 3;
      var g = null;
      function px(d, e) { return e.deltaMode === 1 ? d * 16 : e.deltaMode === 2 ? d * (window.innerWidth || 800) : d; }
      function end() {
        if (!g) { return; }
        clearTimeout(g.qT);
        var was = g; g = null;
        if (was.axis === 'x' && was.api) { try { was.api.end(); } catch (er) {} }
      }
      function clipAt(t) {
        if (t.closest('.croller-panel, .pf-open, input, textarea, select, [contenteditable="true"]')) { return null; }
        var post = t.closest('.post'); if (!post) { return null; }
        var host = post.querySelector('.pf-cbar') || post.querySelector('.media.has-vctrl');
        var api = host && host.__vcScrub;
        if (!api || !api.v || host._vctrl !== api.v || !api.v.isConnected) { return null; }
        return { api: api, car: post.querySelector('.media.carousel') };
      }
      function startScrub(hit) {
        if (!hit.api.start()) { return false; }
        var v = hit.api.v, d = v.duration;
        if (!(d > 0 && isFinite(d))) { d = parseFloat(v.getAttribute('data-dur') || '') || 0; }
        var w = Math.max(WS_REF_MIN, Math.min(WS_REF_MAX, hit.api.width() || 800));
        g.spp = d > 0 ? Math.min(WS_MAX_SPP, d / w) : 0;
        g.axis = 'x'; g.api = hit.api;
        return true;
      }
      function feed(dx) {
        var mag = Math.abs(dx);
        if (g.prev > 0) { if (mag <= g.prev * 1.02) { g.dec++; } else if (mag > g.prev * 1.3) { g.dec = 0; } }
        if (mag > g.peak) { g.peak = mag; }
        g.prev = mag;
        var coast = g.peak >= 8 && g.dec >= WS_COAST_N && mag < g.peak * 0.5;
        if (g.spp && dx) { g.api.by(WS_SIGN * (coast ? dx * WS_COAST : dx) * g.spp); }
      }
      document.addEventListener('wheel', function (e) {
        if (e.ctrlKey) { return; }                                          // pinch-zoom is never ours
        var t = e.target, box = t && t.closest ? t.closest('.pfeed') : null;
        if (!box || !box.classList.contains('show')) { if (g) { end(); } return; }
        var now = e.timeStamp || performance.now();
        var dx = px(e.deltaX, e), dy = px(e.deltaY, e), horiz = Math.abs(dx) > Math.abs(dy);
        if (g && (dx || dy) && now - g.t >= WS_GAP_MS && horiz !== (g.axis !== 'v')) { end(); }   // a new gesture, other axis
        if (!g) {
          if (!dx && !dy) { return; }
          // v = vertical (the pager's) · o = sideways, not over a clip (carousel / panners, as before)
          // x = scrubbing · u = undecided on a gallery video slide · f = flicked the gallery, swallow the rest
          g = { axis: horiz ? 'o' : 'v', t: now, t0: now, api: null, hit: null, spp: 0, prev: 0, peak: 0, dec: 0, acc: 0, n: 0, qT: 0 };
          if (horiz) {
            var hit = clipAt(t);
            if (hit) {
              if (hit.car && hit.car.__cstep) { g.axis = 'u'; g.hit = hit; }
              else if (!startScrub(hit)) { g.axis = 'o'; }
            }
          }
        }
        g.t = now;
        clearTimeout(g.qT); g.qT = setTimeout(end, WS_QUIET_MS);
        if (g.axis === 'v' || g.axis === 'o') { return; }
        if (e.cancelable) { e.preventDefault(); }
        e.stopPropagation();
        if (g.axis === 'f') { return; }
        if (g.axis === 'u') {
          g.acc += dx; g.n++;
          if (Math.abs(g.acc) >= WS_FLICK_PX) { g.axis = 'f'; try { g.hit.car.__cstep(g.acc > 0 ? 1 : -1); } catch (er) {} return; }
          if (g.n < WS_DECIDE_N && now - g.t0 < WS_DECIDE_MS) { return; }
          if (!startScrub(g.hit)) { g.axis = 'f'; return; }
          feed(g.acc); return;
        }
        feed(dx);
      }, { capture: true, passive: false });
    })();

    // PHOTO control bar in the immersive viewer: mirrors the video bar's glassy look (fullscreen, fill/
    // letterbox, and -- for a multi-photo post -- a PLAY button that runs a looping slideshow), minus the
    // time / seek-scrub / PiP / sound that only make sense for a video. Play auto-advances the carousel,
    // repeating, until you pause it or scroll to the next post.
    function buildPhotoBar(unit, host) {
      if (!unit) return;
      if (!unit.closest || !unit.closest('.pfeed')) return;
      if (unit.querySelector('video')) return;          // a video slide already has the real player bar
      var img = unit.querySelector('img'); if (!img) return;
      var carousel = unit.closest('.carousel');
      /* Same pinning as the video bar: inside an immersive carousel a photo slide's toolbar renders into
         the carousel's one pinned host, never into the slide (which the swipe transforms). A mixed
         photo/video post therefore swaps ONE bar's contents rather than sliding a second bar in. */
      if (!host && carousel && unit.classList.contains('cslide')) {
        // same rule as the video bar: only the CURRENT slide claims the shared host (photo bars build
        // lazily as slides are fitted, which is not slide order either)
        var phSlides = carousel.querySelectorAll('.cslide');
        var phCur = carousel.__cidx ? carousel.__cidx() : 0;
        if (phSlides[phCur] && phSlides[phCur] !== unit) { ensurePinnedBarWired(carousel); return; }
        host = ensurePinnedBar(carousel);
      }
      var mount = host || unit;
      // the guard is per-MOUNT-and-slide, not a bare flag: one pinned host is rebuilt for each photo
      // slide it lands on, while an un-pinned unit still builds exactly once.
      if (mount._pbSlide === unit) return;
      if (host) {
        if (host._vctrl) { host._vctrl = null; }        // a video bar was here -- hand the host over
        var _rescueB = unit.closest('.post') ? unit.closest('.post').querySelector('.bar') : null;
        if (_rescueB) { Array.prototype.forEach.call(host.querySelectorAll('.vctrl .pf-act'), function (a) { _rescueB.appendChild(a); }); }
        Array.prototype.forEach.call(host.querySelectorAll('.vctrl,.vc-mini,.vc-sound,.vc-spin,.vc-noaudio,.vc-pipmsg'), function (n) { n.remove(); });
        host.classList.remove('vc-buffering', 'vc-inpip', 'vc-silent', 'pf-vfeed');
      }
      mount._pbSlide = unit;
      unit._pbar = 1;
      var multi = !!(carousel && carousel.querySelectorAll('.cslide').length > 1);
      mount.classList.add('has-vctrl', 'vc-paused', 'ph-ctrl');   // reuse the video bar's glassy CSS + always-shown look
      var bar = document.createElement('div');
      bar.className = 'vctrl ph-ctrl';
      bar.innerHTML =
        '<div class="vc-seek vc-seek-photo"><div class="vc-fill"></div></div>'
        + '<div class="vc-row">'
        + (multi ? '<button class="vc-btn vc-play" type="button" aria-label="Play slideshow">' + VC.play + '</button>' : '')
        + '<button class="vc-btn vc-fs" type="button" aria-label="Fullscreen">' + VC.fs + '</button>'
        + '<button class="vc-btn vc-fit" type="button" aria-label="Fill or letterbox">' + VC.fitIn + '</button>'
        + '<button class="vc-btn vc-eye" type="button" aria-label="Hide everything" aria-pressed="false">' + VC.eye + '</button>'
        + '<span class="vc-flex"></span>'
        + '</div>';
      mount.appendChild(bar);
      var $ = function (s) { return bar.querySelector(s); };
      function stop(e) { e.preventDefault(); e.stopPropagation(); }
      var fitB = $('.vc-fit'), fsB = $('.vc-fs'), playB = $('.vc-play'), fill = $('.vc-fill');
      // fill vs whole toggle (pf-uncrop = whole frame with dimmed sides; without it = cover/fill)
      function isFilling() { return !unit.classList.contains('pf-uncrop'); }
      function paintFit() { fitB.innerHTML = isFilling() ? VC.fitIn : VC.fitOut; fitB.setAttribute('aria-label', isFilling() ? 'Show the whole photo' : 'Fill the screen'); }
      fitB.addEventListener('click', function (e) { stop(e); unit.classList.remove('pf-vscroll'); unit.classList.toggle('pf-uncrop'); paintFit(); });
      paintFit();
      fsB.addEventListener('click', function (e) { stop(e); try { if (img.requestFullscreen) img.requestFullscreen(); else if (unit.requestFullscreen) unit.requestFullscreen(); } catch (er) {} });
      if (playB && carousel) {
        if (!carousel._phSync) {                          // wire the shared position + play-state sync once per carousel
          carousel._phSync = 1;
          /* CHAIN, NEVER ASSIGN. __onslide is a shared signal with THREE subscribers -- this progress
             fill, pinnedBarSync (which hands the pinned toolbar to the slide you land on) and
             ensureCarouselActs' moveToCurrent -- and every other one of them chains. A bare assignment
             here is order-dependent and the order is a RACE: bars build as their images are fitted,
             which is image-load order and not slide order, so a NON-current slide that reaches
             buildPhotoBar first calls ensurePinnedBarWired and sets _cbarWired, and then this line --
             running later, on the current slide -- threw pinnedBarSync away while line ~15535's
             ensurePinnedBarWired no-op'd on the flag that was already set. The bar then never re-points
             on a swipe, which on a MIXED post leaves a photo toolbar sitting over a video slide.
             Chaining is unconditional and cannot be raced. */
          var _phPrev = carousel.__onslide;
          carousel.__onslide = function (i, n) { if (_phPrev) _phPrev(i, n); Array.prototype.forEach.call(carousel.querySelectorAll('.vctrl.ph-ctrl .vc-fill'), function (f) { f.style.width = Math.round((i + 1) / Math.max(1, n) * 100) + '%'; }); };
          carousel.__onplaychange = function (on) { Array.prototype.forEach.call(carousel.querySelectorAll('.vctrl.ph-ctrl .vc-play'), function (b) { b.innerHTML = on ? VC.pause : VC.play; }); };
          carousel.__onslide(carousel.__cidx ? carousel.__cidx() : 0, carousel.__ccount ? carousel.__ccount() : 2);
        }
        // PAINT THE CURRENT STATE on creation: bars build LAZILY per slide, and __onplaychange only fires on
        // state CHANGES -- so a bar born while the slideshow was already running (slides 2/3/4, wired as they
        // come into view) sat on the PLAY icon while actively playing (owner report). Slide 1 only looked
        // right because its bar existed before playback started.
        if (carousel.__cplaying) { playB.innerHTML = VC.pause; }
        playB.addEventListener('click', function (e) {
          stop(e);
          if (!carousel.__cplay) return;
          // engage-hold: a running slideshow holds the feed the same way a tapped clip does (released on stop,
          // on scrolling it out of view, or by the ceiling)
          if (carousel.__cplaying) { carousel.__cstop(); if (carousel._engKey) engHold(carousel._engKey, false); }
          else { carousel.__cplay(); engEmbed(carousel, 'slideshow'); if (typeof toast === 'function') toast('Slideshow started'); }   // confirm the tap took: playback is silent otherwise
        });
      } else if (fill) {
        fill.style.width = '100%';                        // single photo: a static full bar to match the video look
      }
      bar.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.pf-act')) return; e.stopPropagation(); });
      // ONE toolbar: fold the post's action buttons in, exactly like a video. Single photo -> fold into this
      // row; carousel photo slide -> the actions ride with whichever slide is current.
      var post = unit.closest('.post'); var row = bar.querySelector('.vc-row');
      if (carousel) { ensurePinnedBarWired(carousel); if (post) ensureCarouselActs(carousel, post); }
      else if (post && row) { unit.classList.add('pf-vfeed'); pfMoveActs(post, row); }
    }
    window.__rovaPhotoBar = buildPhotoBar;

    // Tear a video's heavy resources back down once it's far from the viewport, so an endless pfeed
    // scroll doesn't pile up decoders + HLS buffers until the phone chokes (the "each swipe gets laggier
    // until unusable" bug). Kills the hls.js instance, drops all buffered media (restore mp4 src +
    // load()), and re-arms warmIO so the clip rebuilds when you scroll back toward it. Idempotent.
    function teardownVideo(v) {
      if (!v._auto || v._recycled || v._released) return;   // _released = permanently pruned, never re-observe it
      // THE COVER GOES UP BEFORE THE CLIP GOES AWAY, never after: an eviction that strips the src of
      // a clip the reader can still see must not be able to expose black even for one frame.
      tlHold(v);
      // START SLOT: a recycled clip is by definition no longer starting. Same reasoning as retireVideo --
      // the pause fires the hooked event, the head-start fetch has none, so abort it here.
      try { if (v._vsFetch) { v._vsFetch.abort(); v._vsFetch = null; v._headStart = 0; } vsDrop(v); } catch (e) {}
      try { v.pause(); } catch (e) {}
      v.preload = 'none';
      // drop the poster too (a ~960px frame is another decoded bitmap held per far clip); warmIO puts it
      // back before the clip returns to view, so a back-swipe still lands on the poster then the video.
      if (v.getAttribute('poster')) { v._posterStash = v.getAttribute('poster'); v.removeAttribute('poster'); }
      v._recycled = 1;
      try { warmObserve(v); } catch (e) {}   // rebuild it as it comes back into range
      // Defer the EXPENSIVE release -- hls.destroy() + <video>.load() drop the decoder + buffered bytes
      // SYNCHRONOUSLY, and doing that mid-swipe (the recycle now runs throughout a fling, not just on
      // settle) stuttered the animation. Run it on the next macrotask, off the frame's critical path. If
      // warmIO reclaims the clip before then (it came back into view -> _recycled reset to 0), skip the
      // release so we never tear down what's now on screen.
      setTimeout(function () {
        if (!v._recycled || v._released) return;   // released (pruned) mid-defer: don't restore its src, let it GC
        if (v._hls) { try { v._hls.destroy(); } catch (e) {} v._hls = null; }
        v._hlsWired = 0;
        // GRID-STYLE hard release (round 129): drop the src ENTIRELY, exactly like the grid's release() --
        // that's the discipline that lets the grid run a screen full of clips without iOS ever complaining.
        // A src'd element at preload=none still holds player state on iOS; src-less it's an empty shell.
        // The stashed poster keeps the frame; warmIO / playIO / __rovaPlayNow all re-attach _mp4src on return.
        try { v.removeAttribute('src'); v.load(); } catch (e) {}
      }, 0);
    }


    /* ---- THE TIMELINE'S LOADED-CLIP WINDOW (2026-10-08) ----------------------------------------------
       Rob, desktop Safari 26.6 on the home feed (Following, live-replay cards + the right sidebar): "notice
       the line at the top that says 'This webpage was reloaded because a problem occurred'. This happens a
       lot when scrolling the timeline and/or grids." That banner is WebKit throwing the tab's web content
       process away and reloading the URL -- on a scrolling media feed, almost always the process outgrowing
       what WebKit will let it hold.

       WHAT THE TIMELINE WAS HOLDING. The viewer has bounded its clips by POST since 2026-07 (KEEP, via
       __rovaRecycleVideos -> teardownVideo, below). The timeline never did: once a card's clip had been
       warmed (calmWarm's neighbour tier: src + preload=auto + load()) or played, it kept its source, its
       preload=auto and its decoded frame until the whole CARD was folded into a stub ~6 screens away
       (recycleTick) -- and on a PROFILE timeline (#profile-posts) nothing folds cards at all, so it kept
       them for the life of the page. In Safari every one of those is a live media player with its own
       buffer and decoded surfaces, and preload=auto is a licence to keep filling a paused buffer: the
       Cloudflare replays are 44-146 MB single MP4s (1080x1920 at ~2.5 Mbps; 1114 s at 720p = 146 MB).
       MEASURED (scratchpad wkmem/soak.js, Chromium -- WebKit on this box cannot decode video, no Media
       Foundation -- 1352x1076 (the owner's window), member rig, 5 min of reading-pace scrolling up and down,
       median/peak over the run, before -> after this window):
         /@kingrobgreen (profile timeline)  clips holding a decoded frame 33/33 -> 6/8, at preload=auto 24/26 -> 6/7,
                                            buffered media 697/755 s -> 95/165 s, decoded video 191/199 MB -> 24/35 MB,
                                            renderer private 1166/1305 MB -> 890/990 MB
         /feed?tab=new (home timeline)      decoded frames 6/10 -> 4/8 (incl. avatars), buffered 85/124 s -> 67/92 s
       The profile is the dramatic one because nothing there folds cards: EVERY clip the reader had passed was
       still a loaded, decoded player 5 minutes later. Chromium caps a paused
       preload=auto buffer at ~35 s; Safari's AVFoundation does not promise to.

       THE RULE: the reader's own posts may hold clips, nothing else. Posts that carry a governed clip are
       ranked by distance from the viewport (0 = on screen); the nearest TLW_KEEP of them, plus anything on
       or touching the screen, may hold bytes. Every other post's clip -- paused, not in PiP, not mid-flight
       to the viewer -- gives them back through teardownVideo: the same hard release (src dropped + load(),
       poster stashed) and the same rebuild the viewer has run on for months (warmIO re-armed; calmWarm,
       calmPlay and __rovaPlayNow all re-attach _mp4src on approach, and tlCover keeps a picture up while
       they do). calmWarm's neighbour tier asks tlwKeeps() before it fills a buffer, so the warm-ahead and
       this release agree on the SAME window and can never trade a clip back and forth.
       KEEP is a POST count, not a distance, because the window has to be the same size in content on a
       390 px phone and on the owner's 2560x1440 display (where +/-2 viewports was ten cards).
       NOT UNDER THE VIEWER: the open / close flights adopt and land timeline clips, so the sweep stands down
       while .pfeed is up (the background hold already pauses everything there). */
    var TLW_KEEP = (window.matchMedia && matchMedia('(hover:none)').matches) ? 3 : 4;
    var tlwT = 0, tlwReleased = 0, tlwSweeps = 0;
    function tlwRemote(v) {
      return !!(v && (v.getAttribute('data-remote') || /\.cloudflarestream\.com\//i.test(v.getAttribute('src') || v._mp4src || '')));
    }
    function tlwGoverned(v) {          // a timeline / profile / permalink card clip -- never the viewer, a grid tile or an avatar
      if (!v || !v._auto || v._released || !v.closest) return null;
      var p = v.closest('.post');
      if (!p || p.closest('.pfeed') || v.closest('.pcell, .av-vid')) return null;
      return p;
    }
    function tlwViewerUp() { return !!document.querySelector('.pfeed.show'); }
    // posts carrying a governed clip, nearest first. One rect per POST (not per clip), read in one pass.
    function tlwPlan() {
      var vids = document.getElementsByTagName('video'), vh = window.innerHeight || 800, out = [], idx = [], i;
      for (i = 0; i < vids.length; i++) {
        var v = vids[i], p = tlwGoverned(v);
        if (!p) continue;
        var k = idx.indexOf(p);
        if (k >= 0) { out[k].vids.push(v); continue; }
        var r = p.getBoundingClientRect();
        var d = !r.height ? 1e9 : (r.bottom < 0 ? -r.bottom : (r.top > vh ? r.top - vh : 0));
        idx.push(p); out.push({ p: p, d: d, vids: [v] });
      }
      out.sort(function (a, b) { return a.d - b.d; });
      return { posts: out, vh: vh };
    }
    function tlwKeeps(v) {             // may this clip fill a buffer right now?
      var p = tlwGoverned(v);
      if (!p) return true;             // not ours to govern
      var pl = tlwPlan();
      for (var i = 0; i < pl.posts.length; i++) {
        if (pl.posts[i].p === p) { return i < TLW_KEEP || pl.posts[i].d < pl.vh * 0.25; }
      }
      return true;
    }
    function tlwHolds(v) {             // is it holding (or fetching) media right now?
      if (!v.getAttribute('src') || v._recycled) return false;
      return v.readyState >= 1 || v.preload === 'auto' || v.networkState === 2;
    }
    function tlwSweep() {
      tlwT = 0;
      if (tlwViewerUp() || document.hidden) return;
      tlwSweeps++;
      var pl = tlwPlan(), pip = document.pictureInPictureElement;
      for (var i = TLW_KEEP; i < pl.posts.length; i++) {
        var e = pl.posts[i];
        if (e.d < pl.vh * 0.25) continue;                         // on or touching the screen: never strip what can be seen
        if (e.p.classList.contains('pf-origin')) continue;        // a flight's home card
        for (var j = 0; j < e.vids.length; j++) {
          var v = e.vids[j];
          if (v === pip || !v.paused || !tlwHolds(v)) continue;  // playing (or popped out): its owner decides
          teardownVideo(v);
          tlwReleased++;
        }
      }
    }
    // Scroll-driven only -- no idle timer. At most one sweep per 500 ms of scrolling, after the frame.
    window.addEventListener('scroll', function () {
      if (!tlwT) { tlwT = setTimeout(tlwSweep, 500); }
    }, { passive: true, capture: true });
    window.__rovaTlwStats = function () {   // owner/harness visible
      var pl = tlwPlan(), held = 0;
      for (var i = 0; i < pl.posts.length; i++) { for (var j = 0; j < pl.posts[i].vids.length; j++) { if (tlwHolds(pl.posts[i].vids[j])) held++; } }
      return { keep: TLW_KEEP, posts: pl.posts.length, holding: held, released: tlwReleased, sweeps: tlwSweeps };
    };

    /* ---- THE TIMELINE'S OWN COVER (2026-09-09) --------------------------------------------------
       Rob: "Scrolling here the videos fade to black before they start."  /feed?tab=new.

       A <video> paints its OWN background when it has no frame, and for a feed card that background
       is #000 (rova.css `.post .media video{...background:#000}`). So the only thing standing
       between the reader and a black rectangle is a picture -- and until now the timeline had
       exactly one candidate for it: the native `poster` attribute. That is not enough, because the
       HTML spec takes the poster away at the worst possible moment:

         play()'s internal steps: "if the show poster flag is true, set it to false".

       So the poster stops being drawn ON THE PLAY CALL, and the first decoded frame is hundreds of
       milliseconds later. MEASURED on both engines with the site's own clip and the card's own CSS
       (scratchpad wk-primitive.js, mean luminance of the media rect, 20ms cadence):
         WebKit 26.5  poster up (mean 100.5) -> play() -> mean 0.0 / variance 0.0 on the very next
                      sample and for every one of the following 68, i.e. PURE BLACK.
         Blink        the same sequence never leaves mean ~100: Blink keeps painting the poster.
       That asymmetry is why this shipped and why every headless gate on this box stayed green --
       including tools/video-black-check.js, whose surface probe counts "has a poster attribute" as
       a picture. It is true in Blink and false in WebKit, and the owner is on WebKit.

       THE FIX IS THE PATTERN THE GRID HAS HAD SINCE 2026-07 (ensureVideo, ~:29499): the card owns a
       picture of its own that no spec rule can take away, and the clip is only what the reader sees
       once it has genuinely PRESENTED a frame. Drawn here as a ::before on the media unit rather
       than a new <img>, for one reason: a dozen call sites in this file do querySelector('img,
       video') / querySelector('img') on a .media or .cslide to find "the media", and a real <img>
       would answer some of them (the pfeed's own stand-in had to be excluded from a fit loop by
       hand for exactly this -- see the :not(.pfv-img) in fitPfeedMedia). A pseudo-element cannot be
       selected, cannot be flown, cannot take a tap, and adds no node -- which also satisfies the
       cascade rule this codebase paid for twice: nothing is created or destroyed while the picture
       changes.

       IT SITS ON TOP OF THE CLIP, NOT UNDER IT, and that is deliberate. Under it, the clip has to
       be hidden for the cover to show, which throws away the native poster: the element would then
       have exactly one picture again. On top, the poster is left completely alone and keeps
       painting right up to the play() call, so the two mechanisms COMPOSE -- and every case the
       cover is raised for (the play() call, the HLS manifest swap, an eviction) is a case where the
       clip has nothing to draw, so covering it costs nothing and hiding it would buy nothing.

       ONE PROPERTY, ONE LAYER: only the cover's opacity moves, 1 while held and 0 once the clip has
       a frame, with a .18s dissolve ONTO the clip and an INSTANT raise back. The raise must be
       instant: a cover fading IN is a frameless (black) clip showing through a half-transparent
       still, which is the owner's sentence spelled out letter for letter. */
    function tlUnit(v) {
      if (!v || !v.closest) { return null; }
      // The viewer builds the same .post markup and has its OWN stand-in (pfPosterLayer): two covers
      // on one clip would fight over the same reveal.
      if (v.closest('.pfeed')) { return null; }
      return v.closest('.cslide') || v.closest('.media');
    }
    function tlPosterUrl(v) {
      return v.getAttribute('poster') || v._posterStash || v.getAttribute('data-vposter') || '';
    }
    function tlFramed(v) { return v.readyState >= 2 || v.currentTime > 0.01; }
    /* RAISE THE COVER. Refuses unless the cover genuinely holds a decoded picture (_tlArmed) -- an
       empty cover is the same black rectangle wearing a different hat -- and refuses while the
       element is not in its own unit, because a clip re-parented for a hero flight is owned by the
       flight and its card is not what the reader is looking at (see video-open-flip). */
    function tlHold(v) {
      if (!v || !v._tlArmed || !v._tlUnit) { return; }
      if (!v._tlUnit.isConnected || v.parentNode !== v._tlUnit) { return; }
      v._tlUnit.classList.add('tlv-hold');
    }
    function tlShow(v) {
      if (!v || !v._tlUnit) { return; }
      v._tlUnit.classList.remove('tlv-hold');
    }
    window.__rovaTlHold = function (v) { try { tlHold(v); } catch (e) {} };
    function tlArm(v) {
      if (v._tlWired) { return; }
      v._tlWired = 1;
      /* THE REVEAL IS A PRESENTED FRAME. Not a promise, not a timer.
         requestVideoFrameCallback fires when a frame has actually been handed to the compositor,
         which is the only signal that means "there is a picture there NOW". It is re-armed once per
         LOST picture (on `emptied`), never per frame: a per-frame callback on every card in a
         timeline is precisely the per-frame tax this file keeps deleting.
         IT IS NOT EVERYWHERE -- Playwright's WebKit 26.5 does not expose it and neither does Safari
         before 15.4 -- so the fallback is a real readiness EVENT, never a delay: readyState >= 2 is
         HAVE_CURRENT_DATA, i.e. the frame at the current position is decoded and will be drawn.
         timeupdate is the backstop for an engine where rVFC exists but never fires: the clock
         advancing IS frames being presented, and it costs ~4 events a second on a playing clip. */
      var rvfc = (typeof v.requestVideoFrameCallback === 'function'), pending = 0;
      var vf = function () {
        if (!rvfc || pending) { return; }
        pending = 1;
        try { v.requestVideoFrameCallback(function () { pending = 0; tlShow(v); }); }
        catch (e) { pending = 0; rvfc = false; }
      };
      var ready = function () {
        // rVFC covers a MOVING clip. A paused element presents no new frames, so a paused clip whose
        // current frame is decoded is revealed on the event -- that frame IS what it will draw.
        if (tlFramed(v) && (!rvfc || v.paused)) { tlShow(v); }
      };
      v.addEventListener('loadeddata', ready);
      v.addEventListener('canplay', ready);
      v.addEventListener('playing', ready);
      v.addEventListener('seeked', ready);
      v.addEventListener('timeupdate', function () { if (v.currentTime > 0.01) { tlShow(v); } });
      /* `emptied` IS FIRED BY THE MEDIA ELEMENT LOAD ALGORITHM, so this one line covers EVERY way
         this element can lose its picture -- attachHls's manifest swap, its mp4 fall-back, hls.js
         attaching a MediaSource, teardownVideo, vsYield's eviction, retireVideo, and anything
         written later by anyone. The explicit tlHold() calls at those five sites are the belt to
         this one's braces: the event is QUEUED as a task, so a frame can be painted between the
         write and the event, and one frame of black is still a frame of black. */
      v.addEventListener('emptied', function () { tlHold(v); vf(); });
      vf();
      ready();
    }
    function tlCover(v) {
      if (!v || v._tlCovDone) { return; }
      var u = tlUnit(v);
      if (!u) { return; }
      v._tlCovDone = 1;
      v._tlUnit = u;
      // A FRESH element in a unit that a previous one left held: never inherit somebody else's hold,
      // or a clip with no poster of its own stays invisible under a cover for the life of the page.
      u.classList.remove('tlv-hold');
      var pu = tlPosterUrl(v);
      if (!pu) {
        // No cover is available: leave the card exactly as it behaves today rather than half-arming it.
        u.classList.remove('tlv-armed');
        try { u.style.removeProperty('--tlv-cov'); } catch (e) {}
        return;
      }
      var css = 'url("' + pu.replace(/["\\]/g, '\\$&') + '")';
      /* THE COVER STARTS PAINTING AT ONCE; ONLY PERMISSION TO HIDE THE CLIP WAITS.
         Arming the ::before and hiding the clip in the SAME frame MEASURED 3 pure-black frames
         (~120ms, WebKit, first card of the run) whose state read "armed 1, hold 1, opacity 0" --
         the clip correctly hidden behind a box that had been handed a background one frame earlier
         and had not rastered it yet. A hole is a hole whichever element made it, and this is the
         exact mistake the grid cascade documents as "a view mounted at swap time misses a frame".
         The CSS background is a SEPARATE resource from the <img> decoded below (the style engine
         issues its own request even on a cache hit), so the class goes on IMMEDIATELY -- invisible,
         because the clip is still opaque on top of it, which is the whole point of raising a cover
         early -- and permission to hide the clip waits for that decode plus TWO PAINTED FRAMES. */
      try { u.style.setProperty('--tlv-cov', css); } catch (e) { return; }
      u.classList.add('tlv-armed');
      var arm = function () {
        if (!u.isConnected) { return; }
        requestAnimationFrame(function () { requestAnimationFrame(function () {
          if (!u.isConnected) { return; }
          v._tlArmed = 1;
          if (!tlFramed(v)) { tlHold(v); }
          tlArm(v);
        }); });
      };
      /* DECODE BEFORE THE HOLD. "the fetch finished" is not "it is ready" -- the whole lesson of
         the cascade port. Same URL the poster attribute already asked for, so this shares the HTTP
         cache entry and costs no extra request; on a card the virtualiser stubbed and re-parsed it
         is a straight cache hit and the wait is just the two frames above. */
      var im = new Image();
      im.decoding = 'async';
      im.onload = function () { if (im.decode) { im.decode().then(arm, arm); } else { arm(); } };
      im.src = pu;
      v._tlCovImg = im;
    }
    /* ---- PRE-ROLL: RUNNING BEFORE IT ARRIVES (2026-09-09) ---------------------------------------
       Rob, on the fix above: "Looks better but I don't want to see videos paused RIGHT before they
       come into my screen, they need to be playing."

       Two things were stopping that, and they are separate. The first is the ACTIVE PAUSE at the
       fold, fixed in playIO's else branch (see "ENTERING THE TIMELINE FOLD"). The second is that
       even started at the first visible pixel, a clip still owes its time-to-first-frame -- so it
       arrives as a still and begins a beat later. This module buys that beat: the NEXT card to
       enter, and only that one, starts muted while it is still off screen.

       IT IS A LUXURY, AND IT IS BUDGETED LIKE ONE. Every guard here exists because starting early
       spends a decoder, and this week's other reports are heat, choppiness and clips decoding where
       nobody can see them:
         - ONE clip at a time (PREROLL_MAX). The budget goes to the card about to arrive, never to
           a queue of them. Nearest-to-entry wins the slot; the next tick re-decides.
         - DIRECTION ONLY. A card receding behind the reader is never a candidate, whatever the
           band says.
         - NEVER `deliberate` through the start scheduler, so a pre-rolled clip is the FIRST thing
           vsEnforce evicts when a real, visible start needs the slot. It can never push a clip the
           reader is watching out of the budget -- vsDist orders by distance from the viewport
           centre and an off-screen clip is by construction the furthest.
         - THE SUSTAINED-JANK GOVERNOR OUTRANKS IT. At rungs 3 and 4 it sets __rovaVidCap to 1 then
           0; below 3 this module stands down completely and pauses anything it started. A pre-roll
           that ignored the governor would undo the 2026-09-07 fix.
         - NOTHING STARTS UNDER THE VIEWER: bgBuried() is asked here exactly as calmPlay and
           __rovaPlayNow ask it (2026-09-08), so the open viewer's hold still covers this path.
         - IT OWNS WHAT IT STARTS. A clip that leaves the band without ever arriving is paused by
           this module (playIO cannot: it never fires for an element that has not crossed a
           threshold, so an off-screen clip nobody started through the observer would otherwise run
           until the reader happened to scroll it into view).
       THE BAND WAS MEASURED DOWN, NOT GUESSED UP. At 500px it delivered a median lead of 2032ms
       before the card arrived -- far more than the job needs, since a warm clip's time to first
       frame is tens of milliseconds -- and the off-screen decode time a pre-roll spends is
       band / scroll-velocity, so that surplus is paid for in exactly the currency this week's other
       reports are about. 320px is ~0.38 of a phone viewport: about half a second of lead at an
       ordinary scroll, ~160ms on a hard fling, which is the right shape because a fling is when
       spending a decoder on a card being flown past is worst. If the lead is ever short, widen THIS
       before raising PREROLL_MAX: a longer band costs one clip more decode time, a bigger cap costs
       another whole decoder. The bytes are NOT this constant's job -- calmWarm already buffers at a
       200% rootMargin, five times further out. */
    var PREROLL_PX = 320;                                  // lead band ahead of the fold
    var PREROLL_MAX = 1;                                   // clips allowed to run off-screen at once
    var preBand = (typeof Set === 'function') ? new Set() : null;
    var preT = null;
    // Is this clip's leading edge the one crossing the fold we are travelling towards? Shared with
    // playIO's arrival branch so the two halves can never disagree about which way "in" is.
    function tlEntering(v) {
      var r = v.getBoundingClientRect(), vh = window.innerHeight || 800;
      if (!r.height) { return false; }
      return (window.__rovaScrollDir || 1) > 0 ? (r.top > vh * 0.45) : (r.bottom < vh * 0.55);
    }
    function preOnScreen(v) {
      var r = v.getBoundingClientRect(), vh = window.innerHeight || 800;
      return r.bottom > 8 && r.top < vh - 8;
    }
    function preStop(v) {
      if (!v || !v._preRoll) { return; }
      v._preRoll = 0;
      if (preOnScreen(v)) { return; }                      // it arrived: playIO owns it from here
      try { if (!v.paused) v.pause(); } catch (e) {}
    }
    function preSchedule() {
      if (preT) { return; }
      preT = setTimeout(function () { preT = null; preTick(); }, 120);
    }
    function preTick() {
      if (!preBand || !preBand.size) { return; }
      var cap = (typeof window.__rovaVidCap === 'number') ? window.__rovaVidCap : 99;
      var off = !feedPref('autoplay', true) || cap < 3 || document.pictureInPictureElement;
      var vh = window.innerHeight || 800, dir = (window.__rovaScrollDir || 1);
      var best = null, bd = 1e9;
      if (!off) {
        preBand.forEach(function (v) {
          if (!v.isConnected || v._userPaused || v._released) { return; }
          if (v.closest && !v.closest('.post')) { return; }        // mid-flight: the flight owns it
          if (v.closest && v.closest('.pfeed')) { return; }        // the viewer has its own machinery
          if (bgBuried(v)) { return; }
          var r = v.getBoundingClientRect();
          if (!r.height) { return; }
          var d;
          if (dir > 0) { if (r.top < vh) { return; } d = r.top - vh; }      // below the fold, coming up
          else { if (r.bottom > 0) { return; } d = -r.bottom; }             // above the fold, coming down
          if (d > PREROLL_PX) { return; }
          if (d < bd) { bd = d; best = v; }
        });
      }
      // Release everything this module owns except the one slot the winner is taking. PREROLL_MAX is
      // read here rather than hard-coded so raising it is a one-constant change.
      var keep = best && PREROLL_MAX > 0 ? best : null;
      preBand.forEach(function (v) { if (v !== keep) { preStop(v); } });
      if (!keep || !keep.paused) { return; }
      // START PATH 6 of 7 (pre-roll). Claimed through the same scheduler as every other start, and
      // NOT deliberate -- see the note above.
      if (window.__rovaVidStart) { window.__rovaVidStart(keep); }
      if (!keep.getAttribute('src') && keep._mp4src) {     // hard-released: re-attach, cover first
        tlHold(keep);
        keep.setAttribute('src', keep._mp4src); try { keep.load(); } catch (e) {}
      }
      if (keep._posterStash && !keep.getAttribute('poster')) { keep.setAttribute('poster', keep._posterStash); keep._posterStash = null; }
      keep._instant = 1;                                   // stay on the buffered mp4; no HLS handshake
      applying = true; keep._engineSetAt = Date.now(); keep.muted = true; applying = false;
      keep._preRoll = 1;
      var pp = keep.play(); if (pp && pp.catch) { pp.catch(function () {}); }
    }
    var preIO = (preBand && 'IntersectionObserver' in window) ? new IntersectionObserver(function (ents) {
      for (var i = 0; i < ents.length; i++) {
        var v = ents[i].target;
        if (ents[i].isIntersecting) { preBand.add(v); }
        else { preBand['delete'](v); preStop(v); }
      }
      preSchedule();
    }, { rootMargin: PREROLL_PX + 'px 0px ' + PREROLL_PX + 'px 0px', threshold: 0 }) : null;
    // The band alone is not enough: a reader who scrolls INSIDE the band changes which card is
    // nearest to entry without crossing anybody's threshold. Re-decide on the same scroll stamp the
    // rest of this module already uses -- one debounced tick, not a listener per clip.
    window.addEventListener('scroll', preSchedule, { passive: true });
    function preObserve(v) { if (preIO) { try { preIO.observe(v); } catch (e) {} } }
    window.__rovaPreRollStats = function () {
      var band = 0, rolling = 0;
      if (preBand) { preBand.forEach(function (v) { band++; if (v._preRoll) { rolling++; } }); }
      return { bandPx: PREROLL_PX, max: PREROLL_MAX, inBand: band, rolling: rolling,
               dir: window.__rovaScrollDir || 1, vidCap: window.__rovaVidCap };
    };

    function wire(v) {
      if (v._auto) return;
      v._auto = true;
      trackMedia(v);   // orphan guard: this is the one choke point EVERY post/pfeed/carousel clip passes through
      v._wiredAt = (window.performance && performance.now) ? performance.now() : Date.now();   // for the volumechange race-guard below
      /* the plain mp4, before HLS swaps src -- for teardown restore.
         ...AND the data-attribute fallback, which is the ONLY thing a restored card has. A card the feed
         virtualiser stubbed and brought back is re-parsed from markup serialised AFTER retireVideo stripped
         it, so this element has never had a src attribute and carries none of its predecessor's properties.
         Reading getAttribute('src') alone latched '' here -- permanently, because wire() runs once per
         element (_auto) -- and a '' _mp4src makes calmPlay / __rovaPlayNow / calmWarm's
         `if (!v.getAttribute('src') && v._mp4src)` re-attach a no-op at all three sites. retireVideo writes
         data-video-src + data-vposter before it strips precisely so this line can find them. Seeding
         _posterStash the same way lets the existing poster restore in those three sites work unchanged. */
      v._mp4src = v.getAttribute('src') || v.getAttribute('data-video-src') || '';
      if (!RM_APPLE && v.dataset && v.dataset.hls && tlwRemote(v) && !window.Hls) { loadHlsLib(function () {}); }   // remoteHls: have it ready
      if (!v._posterStash && !v.getAttribute('poster')) { v._posterStash = v.getAttribute('data-vposter') || null; }
      /* ...AND PUT IT BACK NOW, NOT WHEN AN OBSERVER GETS ROUND TO IT (2026-08-30, the second half of
         the owner's "flashes to black").

         A <video> with no frame and no poster paints its own background, and that background is #000
         (rova.css `.post .media video{...background:#000}`). teardownVideo strips the poster on purpose
         -- a ~960px decoded bitmap per far clip is real memory -- and leaves the restore to the three
         observer callbacks (calmPlay, __rovaPlayNow, calmWarm), which is fine for a clip that comes back
         the way it left. It is NOT fine for a card the feed virtualiser stubbed and re-parsed: that
         element is brand new, has never had a poster attribute, carries none of its predecessor's
         properties, and can be restored ALREADY ON SCREEN when the reader scrolls back up. Until an
         observer happens to fire it is a black rectangle in the middle of the timeline.
         Measured by tools/video-black-check.js on the live site under LTE: two timeline clips more than
         half on screen with no frame, no cover and no poster attribute -- 940ms and 1800ms.
         wire() runs once per element and only for a clip that is in or near the viewport, so this is the
         earliest honest moment and costs one cached bitmap the warm path was about to pay for anyway. */
      if (v._posterStash && !v.getAttribute('poster')) { v.setAttribute('poster', v._posterStash); v._posterStash = null; }
      // ...AND PUT A PICTURE UNDER IT THAT NO SPEC RULE CAN TAKE AWAY. The line above restores the
      // native poster, which stops being drawn the instant play() is called; this is the cover that
      // does not. See tlCover. wire() is the one choke point every .post .media video passes.
      tlCover(v);
      buildControls(v);
      // Muting is REQUIRED for autoplay, but do it under the `applying` guard so the volumechange
      // listener below doesn't mistake this programmatic mute for the USER hitting mute. Without the
      // guard, EVERY video wired mid-session -- and the pfeed wires a fresh one for each post it loads
      // as you swipe -- fired volumechange -> soundOn=false -> applySound() then muted the clip you were
      // actually watching. That was the "pfeed mutes videos as you swipe" bug. The guard also stops the
      // first-ever wire from clobbering the stored sound preference (sndPref) on page load.
      applying = true;
      // Fresh clips must start muted (autoplay policy) -- but NEVER silence a clip that is ALREADY PLAYING
      // UNMUTED: the grid->pfeed handoff swaps the live flown <video> into the card and syncs the sound, and
      // THEN this observer-driven wire() fired and re-muted it = "music starts then cuts off" (owner /p/1435).
      if (v.paused || v.muted) {
        v._engineSetAt = Date.now();
        v.muted = true; v.defaultMuted = true; v.setAttribute('muted', '');
      }
      applying = false;
      v.playsInline = true; v.setAttribute('playsinline', '');
      v.loop = true;
      if (!v.getAttribute('preload')) v.preload = 'metadata';
      // the user reaching for the mute control flips sound-follow mode on/off
      v.addEventListener('volumechange', function () {
        updateSoundPill();                    // any mute state change re-checks the "Tap for sound" pill
        // EVERY unmute passes through here -- the arm's, pfSound's, applySound's handoff, the reader's
        // own tap -- so this is the one chokepoint where "did it actually take?" can be asked without
        // being written five times. Bounded to once per page; see verifySound.
        if (!v.muted) { verifySound(v); }
        if (applying) return;                 // ignore our own programmatic toggles
        // A freshly-wired clip autoplays MUTED; on some browsers that volumechange fires ASYNC, after the
        // `applying` guard already released -- which got read as "the user muted" -> soundOn=false, so swiping
        // to the next pfeed clip dropped sound and re-showed "Tap for sound". Ignore any change in the first
        // beat after wiring so ONLY a real user toggle moves the preference. (THE fix for the pfeed re-mute.)
        var _tn = (window.performance && performance.now) ? performance.now() : Date.now();
        // ONLY skip while the clip is actually MUTED (2026-08-12, owner: "videos stopped having sound
        // randomly"). This guard exists to swallow the freshly-wired clip's OWN async autoplay-mute
        // event, not a real unmute -- but it used to fire unconditionally, so pfSoundSoon's open-with-
        // sound unmute (which lands well inside this window on a fast/cached load: wire() -> metadata
        // ready -> pfSound()'s v.muted=false, all within a couple hundred ms) got read as a no-op and
        // dropped. The clip kept playing audibly (the DOM write still took), but soundOn/pfLatch never
        // learned sound was on -- so the very next applySound() sweep (any scroll tick, any newly-wired
        // neighbour entering view) read wantSound=false and re-muted the clip the reader was actively
        // listening to. That is the whole shape of "randomly stopped having sound": no touch, no swipe,
        // just the next unrelated sweep. Same fix already applied below to the _progMuteAt guard for the
        // identical reason -- this one was missed.
        if (v.muted && _tn - (v._wiredAt || 0) < 300) return;
        // Hero flights + dismissals mute the clip PROGRAMMATICALLY (v._progMuteAt stamp) outside the
        // `applying` guard (different scope). Reading those as "the user muted" flipped soundOn=false +
        // SAVED rova_sound=0 -- so every dismiss killed the sound pref and the next open showed the pill
        // (owner: "hear the sound then it's muted, tap to unmute -- annoying" / "swiping mutes videos").
        // ONLY skip while the clip is actually MUTED: a genuine UNMUTE inside the window (pfSound's
        // open-with-sound on the adopted grid clip) must still register, or soundOn stays stale-false and
        // the next applySound re-silences it = "music starts then cuts off" (traced live on the owner's Mac).
        if (v.muted && Date.now() - (v._progMuteAt || 0) < 600) return;
        // ENGINE-driven change (applySound handoff / calmPlay / playNow / wire): never user intent. The
        // `applying` guard can't catch these -- volumechange delivers ASYNC, after it released (traced:
        // swiping BACK made the outgoing clip's engine-mute land last and flip soundOn+pref to muted).
        // Same "only while MUTED" carve-out as the two guards above, and for the same reason: this stamp
        // is also written by wire()'s own initial forced-mute, so an unmute landing soon after (pfSound's
        // open-with-sound, or a reader's genuine tap) was being swallowed here too.
        if (v.muted && Date.now() - (v._engineSetAt || 0) < 500) return;
        /* ---- A MUTE MUST BE DECLARED. AN UNMUTE NEED NOT BE. (owner 2026-08-14) -------------------
           "sometimes ALL the posts on the site lose volume and I can't get it back without
            force-closing Safari" / "I hear it start the sound in Chrome then it AUTO-MUTES."

           MEASURED, not theorised: on the live bundle, ONE unstamped programmatic `v.muted = true`
           landing 4397ms after the element's last engine stamp writes rova_sound=0 and the site is
           silent through every reload after it. The three guards above are the SAME guard written
           three times -- "was this engine write recent?" -- and a timestamp cannot answer that
           question, because the write it has to catch is the one that arrives LATE. Every one of the
           six previous repairs in this handler widened a window; the seventh would too.

           So stop inferring intent and require it to be DECLARED, in the ONE direction where being
           wrong is unrecoverable:

             MUTING is the dangerous direction. It writes rova_sound=0, which outlives the tab, and a
             reader who never touched anything then finds every clip on every page silent with no
             obvious way back. Only a mute the reader actually performed may move the preference --
             the corner .vc-sound control marks itself below, and nothing else on this site mutes on
             a reader's behalf. An UNDECLARED mute is engine work by definition: the handoff, the
             hero flight, a refused unmuted play falling back to muted, an outside-closure sweep, or
             a path nobody has written yet. It repaints the pill (above) and touches nothing else.

             UNMUTING is safe in both directions and is left EXACTLY as it shipped. It turns sound ON;
             an engine unmute persisting as "sound on" is the behaviour the pfSound / grid-handoff
             notes above deliberately asked for, and no engine unmute has ever cost anyone their
             audio. Do not add a declaration requirement here -- that is how "music starts then cuts
             off" came back twice.

           THE DECLARATION EXPIRES, and that asymmetry is the whole safety argument: if the mark goes
           stale the cost is one mute that failed to persist, and the reader's next tap fixes it. When
           the ENGINE-side window went stale the cost was the site. Fail toward sound. */
        if (v.muted && !(v._userMuteAt && Date.now() - v._userMuteAt < 1000)) return;
        v._userMuteAt = 0;                    // consumed: one declaration, one event
        var _was = soundIntent();
        soundOn = !v.muted;
        sndRemember(soundOn);                 // sticks across pages and the gallery
        if (document.querySelector('.pfeed.show')) { pfLatch = !v.muted; }   // user's explicit choice for this pfeed session
        if (_was !== soundIntent()) { speakersSync(); tlSlotSoon(); }   // every speaker draws intent now (see soundIntent); song-only posts join/leave the ranking
        if (soundOn && feedPref('soundfollow', true)) {   // the video they touched speaks now,
          applying = true;                                // scrolling hands it off from here
          Array.prototype.forEach.call(document.querySelectorAll(SEL), function (o) {
            if (o !== v && !o.muted) { o._engineSetAt = Date.now(); o.muted = true; }   // engine mute, never "user intent"
          });
          applying = false;
        }
      });
      // STALL RECOVERY: the pfeed plays the plain mp4 for an instant start (grid-hover parity). If that mp4
      // can't keep up on a slow line, hand it to the adaptive HLS ladder so it drops quality instead of
      // stalling out. Only fires on a SUSTAINED stall of a PLAYING clip that still has an HLS ladder -- a
      // brief start-up 'waiting' on a fast line clears itself (readyState climbs) before the timer, so fast
      // connections stay on the instant mp4 and never pay the HLS handshake.
      var _stallT = null;
      /* A SCRUB IS NOT A STALL (2026-09-10). A seek into the unbuffered part of a long mp4 fires
         `waiting` and holds readyState < 3 until the range fetch lands -- on the owner's 2:56 clip a
         drag tripped this exact timer and swapped a healthy clip onto the LOW-FIRST ladder (360p),
         measured as readyState 0 / currentTime 0 for ~800ms right after release. The transport
         stamps v._scrubbing on every move and on release; a wait that begins inside that window is
         the seek the reader asked for, not a bandwidth measurement, so it neither arms nor fires
         the swap. A line that is genuinely slow will `waiting` again once playback resumes. */
      var _scrubWait = function () { return !!(v._scrubbing && Date.now() - v._scrubbing < 2500); };
      v.addEventListener('waiting', function () {
        if (v._hlsWired || v.paused || !v.dataset || !v.dataset.hls || _scrubWait()) return;
        clearTimeout(_stallT);
        _stallT = setTimeout(function () {
          if (v.paused || v.readyState >= 3 || _scrubWait()) return;   // recovered on its own (or a scrub landing) -> stay on the fast mp4
          // The sustained stall IS the bandwidth measurement: mark the clip so attachHls picks the
          // low-first master (starts on the light rung) instead of the sharp-start one -- otherwise a
          // slow line escapes the stuck mp4 only to stall again on a 720p first segment.
          v._stalled = 1;
          v._instant = 0; attachHls(v);                // still stuck: switch to adaptive HLS
        }, 1500);
      });
      var _clearStall = function () { clearTimeout(_stallT); };
      v.addEventListener('playing', _clearStall);
      v.addEventListener('canplay', _clearStall);
      playIO.observe(v);
      warmObserve(v);
      tlObserve(v);   // ...and its card's media box joins the playing-card ranking (timeline only; see tlSlotDecide)
      // ...and the lead band, so this clip can be running before its card reaches the fold. The
      // pfeed's own clips are excluded inside preTick (the viewer has its own drag-reveal rule),
      // so observing every wired clip here costs one entry in a bounded set.
      preObserve(v);
    }
    /* ---- ...AND THE AVATAR VIDEOS IN THE SAME WALK (2026-08-08) ---------------------------------
       This observer is the only document-wide childList watcher that already sees every node this
       app injects, and the deferred-avatar module below needed exactly that and had nothing: it took
       a ONE-SHOT `document.querySelectorAll('.av-defer[data-src]')` at load and returned early when
       that came back empty -- so on /feed (which defers nothing server-side) the observer was never
       even CONSTRUCTED, and a deferred avatar arriving later could not be picked up by anything.
       That is why views/_founders_roster_block.php documents "never deferred: app.js's av-defer
       observer is armed once at load, so an AJAX-inserted deferred avatar would stay blank forever"
       -- a whole surface coded around this hole rather than hitting it.
       It is ALSO how the stub-restore avatar bug becomes fixable without an eager re-attach:
       __rovaAvatarDefer() puts a restored avatar BACK into the deferred state (data-src from the
       data-video-src retireVideo stashed) and observes it, so it loads WHEN IT SCROLLS IN, exactly
       like a fresh one -- the deliberate deferral survives instead of being overridden.
       NO NEW OBSERVER, and no second tree walk: the avatar selectors ride in the SAME
       querySelectorAll as SEL, so the added cost is one selector test per matched element on a
       callback that was already running. (Measured on a parked+scrolling deep /feed: no change.)
       The selector lists are disjoint by construction -- post clips live in `.post .media`,
       avatars in `.avatar.av-vid` -- so the `matches(SEL)` branch can never mis-route one. */
    var SEL_AV = '.av-vid video[data-video-src], .av-defer[data-src]';
    var SEL_AM = '.post .am-card[data-preview]';   // timeline song cards: a PHOTO + song post has no clip to wire (tlObserveCard)
    var SEL_ALL = SEL + ', ' + SEL_AV + ', ' + SEL_AM;
    function avDefer(el) { if (window.__rovaAvatarDefer) { try { window.__rovaAvatarDefer(el); } catch (e) {} } }
    function scan(root) {
      if (!root.querySelectorAll) return;
      if (root.matches && root.matches(SEL_AV)) avDefer(root);   // the added node may BE the avatar
      Array.prototype.forEach.call(root.querySelectorAll(SEL_ALL), function (el) {
        if (el.matches(SEL)) wire(el); else if (el.matches(SEL_AM)) tlObserveCard(el); else avDefer(el);
      });
    }
    scan(document);
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.matches && n.matches(SEL)) wire(n);
          else scan(n);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  })();

  /* ====================================================================================================
     "TAKE ME TO THE TOP", RE-ASSERTED  (2026-09-18) -- one shared scroll for the two header buttons that
     reveal a collapsed panel ABOVE the reader: + (the composer, focusComposer below) and the magnifier
     (the feed's own search box, in the flyout block right underneath this one).
     ====================================================================================================
     THE BUG THIS EXISTS FOR.  Both buttons expand their panel and ask for a SMOOTH scroll to the top in
     the SAME TASK -- and the panel then grows for 550ms (#feed-search-box / #feed-compose-box transition
     grid-template-rows .55s, rova.css) while html.feed-collapsed animates the header's bottom margin and
     the sticky tabs' padding.  WebKit CANCELS an in-flight ANIMATED scroll when a content-size change
     commits.  Measured synthetically (smooth scrollTo(0) from y=3000, a 300px growth committing dt after
     the request): dt=0 -> 3015, 16ms -> 2729, 50ms -> 1443, 100ms -> 673, 150ms -> 334, 200ms+ -> 0.
     With behavior:'auto' it is 0 at every delay.  The growth window here strictly contains the ~200ms
     animation, and on a real deep member timeline in headless WebKit the + tap missed the top in **11 of
     18** taps on a warm cache (landings 659-12104) and in **12 of 12** on a COLD one -- media still
     decoding commits height changes of its own, so a first visit to a media-heavy timeline, which is the
     ordinary case, failed every time.  Chromium landed 18/18 across the same runs and the touch path was
     already instant and already clean, so this is a FINE-POINTER (desktop Safari) fault.  It is then
     compounded by the 09-18 auto-close,
     which folds away the stranded, off-screen, empty composer -- end state: composer CLOSED, focus on
     BODY, i.e. the exact opposite of the invariant focusComposer() states.  The header search had the
     same shape and no instant branch at all, so TOUCH took the animated path too: 10 of 10 taps on a cold
     cache left the keyboard up for a field thousands of pixels off screen.

     THE FIX IS TO ASK AGAIN, NOT TO GIVE UP THE GLIDE.  Offset 0 is the top of the content however the
     chrome grows, so re-asserting an ABSOLUTE target is never wrong and is a no-op once landed: one
     smooth re-assert after the growth has committed (220ms) and one instant backstop (520ms).  A mouse
     therefore keeps EXACTLY the feel it has today -- the animation still runs, it just lands.

     THE GUARD IS THE LOAD-BEARING HALF.  If the reader deliberately took the page somewhere inside that
     window, the re-assert must STAND DOWN or it yanks them back.  "Is scrolling" cannot decide that: it is
     equally true of our OWN programmatic scroll.  So the trigger is USER-INTENT events only -- wheel,
     touchstart, keydown, pointerdown -- on four passive capture listeners shared by both callers, and the
     stand-down is ARMED only once the ask has been made, so the tap's own pointerdown (which always
     precedes the click that calls this) can never stand its own re-assert down.

     STANDING DOWN HAS TWO HALVES, AND MISSING THE SECOND ONE IS WHAT THE MEASUREMENT CAUGHT.  Dropping the
     PENDING re-asserts is not enough: one already IN FLIGHT is a smooth scroll, and WebKit does not cancel
     an animated scroll when the reader wheels -- so it carried them to the top anyway (6 of 10 trials with
     a deliberate wheel 300ms after the tap, with zero pending re-asserts left to fire).  So the first
     intent event also ENDS whatever animation is running, by asking for the offset the page is at right
     now: positionally a no-op, but it replaces the running animation, and the reader's own scroll then
     applies on top of it untouched. */
  (function () {
    var intentAt = 0, armed = null;
    ['wheel', 'touchstart', 'keydown', 'pointerdown'].forEach(function (ev) {
      window.addEventListener(ev, function () {
        intentAt = Date.now();
        if (armed) { var f = armed; armed = null; f(); }
      }, { passive: true, capture: true });
    });
    function to(behavior) {
      try { window.scrollTo({ top: 0, behavior: behavior }); } catch (e) { window.scrollTo(0, 0); }
    }
    /* Returns whether it went instantly, for callers that want to know (the composer's focus rule does).
       Instant on (pointer:coarse) / reduced motion: the keyboard is already rising and resizing the
       viewport there, and a .5s glide from deep in the feed fights it. */
    window.__rovaScrollToTop = function () {
      var instant = false;
      try { instant = window.matchMedia('(pointer:coarse)').matches || window.matchMedia('(prefers-reduced-motion:reduce)').matches; } catch (e) {}
      to(instant ? 'auto' : 'smooth');
      if (instant) return true;
      var t1, t2, t3;
      var standDown = function () {
        clearTimeout(t1); clearTimeout(t2); clearTimeout(t3);
        try { window.scrollTo({ top: window.pageYOffset, behavior: 'auto' }); } catch (e) {}
      };
      var mine = function () { return armed === standDown; };   // a later ask replaces us; the stale timers do nothing
      armed = standDown;
      t1 = setTimeout(function () { if (mine() && window.pageYOffset > 8) to('smooth'); }, 220);
      t2 = setTimeout(function () { if (mine() && window.pageYOffset > 8) to('auto'); }, 520);
      // disarm late, not at 520: the 220ms re-assert is itself an animation and may still be running then,
      // and an intent that arrives while it is must still be able to stop it. Past this everything has landed.
      t3 = setTimeout(function () { if (mine()) armed = null; }, 1100);
      return false;
    };
    window.__rovaScrollIntentAt = function () { return intentAt; };   // rig hook: the guard's own number
  })();

  /* ---- header flyouts: Messages + Notifications (AJAX, no page load) ---- */
  (function () {
    var drops = Array.prototype.slice.call(document.querySelectorAll('.hdrop'));
    if (!drops.length) return;
    // Must stay byte-identical to icon('send') in lib/view.php -- same glyph, two trees.
    // Centred on its ink at (12,12); the old <g transform="translate(-1.1 0)"> is gone. See
    // the 'send' entry in lib/view.php for the measurement and why NOT to re-add a transform.
    var SEND_SVG = SVG0 + '<path fill="currentColor" stroke="none" d="M19.442 2.62c1.1-.5 2.3.7 1.8 1.8l-7.2 16.3c-.5 1.1-2.1 1-2.5-.1l-1.8-5.3a1.6 1.6 0 0 0-.9-.9L3.542 11.92c-1.2-.4-1.2-2 0-2.5z"/><path fill="#000" opacity=".18" stroke="none" d="M20.642 3.22 9.342 13.52c.3.2.5.5.6.8l1.8 5.3c.2.6 1 .7 1.3.1z"/></svg>';
    var dmInboxHead = null;   // Messages flyout's default header markup, restored after a mini-thread

    // PORTAL the panels to <body>. The topbar's backdrop-filter makes it the
    // containing block for fixed/absolute descendants, so a panel left inside it
    // gets trapped in the header (the "stuck at the top" bug). As body children
    // they position against the real viewport; desktop anchoring is set inline.
    drops.forEach(function (drop) {
      var p = drop.querySelector('.hdrop-panel');
      if (p) { drop._hpanel = p; document.body.appendChild(p); }
    });

    /* Gestures that land on the panel must never move the page behind it. guardPanelScroll()
       carries the full reasoning (short version: overscroll-behavior does not exist in WebKit, so
       the CSS on .hdrop-panel/.hdrop-body is inert on the one platform this was reported from).
       What this replaced was missing three things:
         - a `wheel` handler, so on every viewport WIDER than 640px (iPad, landscape phone, iOS
           "Request Desktop Website", desktop) a scroll inside the panel moved the feed behind it,
           measured, in WebKit, in BOTH directions AND mid-list;
         - `.search-results` in the scrollable list. #search-panel has no .hdrop-body at all, so
           the old selector matched nothing there and the guard preventDefault'd EVERY touchmove
           in the typeahead -- the results list could not be finger-scrolled at all;
         - the touchstart latch nudge, without which a drag that reaches the list's end mid-gesture
           chains anyway (by then the touchmoves are cancelable:false).
       The state is now per-panel too; panTouchY & co. were shared across all three flyouts. */
    var HDROP_SCROLLERS = '.hdrop-thread, .hdrop-body, .search-results';
    drops.forEach(function (drop) {
      var p = drop._hpanel; if (!p) return;
      var g = guardPanelScroll(p, HDROP_SCROLLERS);
      // Swipe-down to dismiss, but ONLY intentionally: either the list was already at
      // the top and you pulled down clearly, or a genuinely hard/fast downward flick.
      // A normal scroll up to read older messages (list not at top) never closes it.
      p.addEventListener('touchend', function (e) {
        var ct = e.changedTouches && e.changedTouches[0]; if (!ct) return;
        var dy = ct.clientY - g.y, dx = ct.clientX - g.x;
        var dt = Math.max(1, (e.timeStamp || 0) - g.t);
        if (dy <= 0 || Math.abs(dx) > Math.abs(dy)) return;          // must be a downward, vertical gesture
        var pulledFromTop = g.atTop && dy > 100;
        var fastFlick = dy > 130 && (dy / dt) > 1.4;                 // deliberate hard throw
        if (pulledFromTop || fastFlick) closeAll(null);
      }, { passive: true });
      // Explicit X in the header, matching the Messages flyout's own close button (below).
      // Messages wires its own copy inline because its click handler also owns the
      // thread/back/attach buttons; every other flyout (just Notifications today) gets this
      // one shared handler instead of duplicating that machinery for a single button.
      if (drop.id !== 'dm-drop') {
        p.addEventListener('click', function (e) {
          if (e.target.closest('.hdrop-close')) { e.preventDefault(); e.stopPropagation(); closeAll(null); }
        });
      }
    });

    var mobileMq = window.matchMedia('(max-width:640px)');

    // Full-screen shield while a flyout is open: taps, double taps and swipes land
    // HERE instead of passing through to the feed behind. Tapping it just closes.
    var shield = document.createElement('div');
    shield.className = 'hdrop-backdrop';
    document.body.appendChild(shield);
    shield.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); closeAll(null); });
    shield.addEventListener('touchmove', function (e) { if (e.cancelable) e.preventDefault(); }, { passive: false });
    function isOpen(d) { return d.classList.contains('open'); }
    var shieldLocked = false;
    function syncShield() {
      var open = drops.some(isOpen);
      shield.classList.toggle('show', open);
      // phones: freeze the page behind the sheet (the panel body scrolls internally). Touch the SHARED
      // scroll-lock refcount only in BALANCED pairs (track our own state): the old unconditional
      // `else unlockScroll()` decremented the refcount even when this never locked, so a stray syncShield
      // (e.g. closeAll fired by the outside-click handler when you tap a feed-grid cell to OPEN the pfeed)
      // stole the pfeed's freshly-taken lock, un-pinning the body -> swipes leaked to the feed behind it.
      var want = open && mobileMq.matches;
      if (want && !shieldLocked) { shieldLocked = true; lockScroll(); }
      else if (!want && shieldLocked) { shieldLocked = false; unlockScroll(); }
    }

    function place(drop, panel) {
      if (mobileMq.matches) {   // sheets are positioned purely by the CSS media rules
        panel.style.top = ''; panel.style.right = ''; panel.style.bottom = ''; panel.style.left = '';
        return;
      }
      var r = drop.getBoundingClientRect();   // anchor under the icon, desktop style
      panel.style.left = 'auto'; panel.style.bottom = 'auto';
      panel.style.top = Math.round(r.bottom + 10) + 'px';
      var rt = Math.max(8, Math.round(window.innerWidth - r.right));
      // never let the panel run off the LEFT edge on narrow windows
      rt = Math.min(rt, Math.max(8, window.innerWidth - panel.offsetWidth - 8));
      panel.style.right = rt + 'px';
    }
    function closeAll(except) {
      // closeAll is the outside-click handler for the WHOLE page, so it runs on clicks that have
      // nothing to do with a flyout -- including the click that opens the post composer's own
      // emoji/GIF picker. Only a flyout that was actually OPEN may drag the pickers shut with it;
      // without this test the pickers were closed in the same tick they were opened.
      var wasOpen = drops.some(isOpen);
      drops.forEach(function (d) {
        if (d === except) return;
        d.classList.remove('open');
        if (d._hpanel) d._hpanel.classList.remove('open');
      });
      // The inline composer's two pickers are body children sitting ABOVE the sheet (z 240 vs 80),
      // so closing the flyout has to take them with it or they hang on screen over an empty page.
      if (wasOpen) {
        closeGif();
        if (emojiPop) emojiPop.classList.remove('show');
      }
      syncShield();
    }
    function load(drop) {
      var panel = drop._hpanel;
      if (!panel || !panel.getAttribute('data-src')) return;   // static panels (search) fetch nothing
      var body = panel.querySelector('.hdrop-body');
      if (!body) return;
      if (drop.id === 'dm-drop') resetDm(panel);
      body.innerHTML = '<div class="hdrop-spin"></div>';
      // rfetch, not fetch: fetch() RESOLVES on a 5xx/404, so a non-2xx with an empty body fell
      // straight through to the line below and rendered "Nothing here yet." -- a failed request
      // telling you your bell and your inbox are empty. rfetch rejects a non-2xx into the .catch
      // that already owns failure on this surface (the retry line, re-armed by the click handler
      // further down), so no third error path is needed. It also puts a deadline on the read, which
      // this had none of: a half-open socket left the spinner up for the platform's 60-120s.
      // WS-B: the DM inbox keeps its All / Unread chip across a thread and Back (INBOX CONTROLS stores it on the panel)
      var nxf = drop.id === 'dm-drop' ? (panel.getAttribute('data-nxf') || '') : '';
      rfetch(panel.getAttribute('data-src') + (nxf && nxf !== 'all' ? '&f=' + encodeURIComponent(nxf) : ''), { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', cache: 'no-store' }, 8000)
        .then(function (r) {
          /* AN EXPIRED SESSION IS NOT A CONNECTION PROBLEM (owner 2026-08-21, the app's twin
             of this bug). These partials sit behind require_login(), which answers a dead
             session with a 302 to /login -- and fetch FOLLOWS it into a 200, so the login
             page's full HTML landed in the .then below and was injected wholesale into this
             little flyout: a mangled login page inside the bell. (rfetch only rejects
             non-2xx, so the retry line never fired either.) r.redirected is the honest
             signal; the doctype sniff below is the belt for anything that hides the
             redirect, because a partial is a fragment and can never open with a doctype. */
          var signedOut = !!(r.redirected && /\/login(\?|$)/.test(r.url || ''));
          return r.text().then(function (html) { return { signedOut: signedOut, html: html }; });
        })
        .then(function (res) {
          var html = (res.html || '').trim();
          if (res.signedOut || /^<!doctype/i.test(html)) {
            // the RE-LOGIN flow, not a retry that can never succeed and not the network's fault
            body.innerHTML = '<div class="hdrop-empty">You’ve been signed out. '
              + '<a href="/login" style="color:var(--accent-text)">Log in</a> to pick up where you left off.</div>';
            return;
          }
          body.innerHTML = html || '<div class="hdrop-empty">Nothing here yet.</div>';
          if (window.__rovaNxHome) { try { window.__rovaNxHome(body); } catch (e) {} }   // the filter pills open at "All" (batch item 21)
          if (drop.id === 'bell-drop') { var b = document.getElementById('bell-badge'); if (b) b.hidden = true; } // marked read server-side
        })
        .catch(function () { body.innerHTML = '<div class="hdrop-empty hdrop-retry">Couldn\'t load. Tap to retry.</div>'; });
    }
    function resetDm(panel) {  // return the Messages flyout to its inbox-list view
      panel.classList.remove('threading');
      var body = panel.querySelector('.hdrop-body'); if (body) body.classList.remove('is-thread');
      var head = panel.querySelector('.hdrop-head'); if (head && dmInboxHead != null) head.innerHTML = dmInboxHead;
    }
    drops.forEach(function (drop) {
      var trigger = drop.querySelector('.iconbtn');
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        if (drop.id === 'search-drop') {
          // the feed (and /search) carry their own box: TOGGLE it (if collapsed) and put the
          // cursor there, rather than opening the flyout. EXISTENCE, not offsetParent: since
          // /feed's search box became independently collapsible (2026-08-11) a collapsed box is
          // 0-height with pointer-events:none but NOT display:none, so offsetParent stays
          // non-null even while it's fully hidden -- existence is the only reliable test now.
          var pageSearch = document.getElementById('home-search') || document.getElementById('srch-q');
          if (pageSearch) {
            closeAll(null);
            // /feed only; a no-op everywhere else (incl. /search, which has no collapse box).
            // Never touches the composer's panel state. Returns whether it ended up OPEN, so a
            // second tap on an already-open panel closes it again instead of just re-focusing a
            // box that's about to disappear under the cursor.
            var opened = window.__rovaExpandSearchPanel ? window.__rovaExpandSearchPanel() : true;
            if (opened) {
              /* PARITY WITH THE COMPOSER'S + (2026-09-18) -- see "TAKE ME TO THE TOP, RE-ASSERTED" above.
                 Three things were wrong here and all three are the composer's already-solved problems:
                 (1) FOCUS BEFORE THE SCROLL, synchronously inside the tap, so iOS raises the keyboard for
                     a focus() that runs in the gesture's own dispatch (the 09-14 rule; focusComposer does
                     the same, and preventScroll keeps the element's own scroll-into-view out of it).
                 (2) NO INSTANT BRANCH AT ALL meant TOUCH took the animated path, which the panel's own
                     550ms growth then cancelled -- 6 of 8 taps on a touch profile left the keyboard up for
                     a field thousands of pixels off screen. __rovaScrollToTop owns that branch now.
                 (3) THE TARGET WAS RELATIVE. scrollIntoView({block:'center'}) was computed against a box
                     that is 0px tall at call time, and only lands correctly today because #feed-search-box
                     is the FIRST element in the document so 'center' clamps to 0. Anything ever rendered
                     above #feed-chrome makes that a real, wrong number. On /feed the honest target is the
                     absolute one the composer uses: offset 0 is the top of the content however the chrome
                     grows. OFF the feed (/search's #srch-q, which has no collapsing panel and therefore
                     nothing growing over it) the relative scroll is not exposed to any of this and stays. */
              pageSearch.focus({ preventScroll: true });
              var inChrome = pageSearch.closest ? pageSearch.closest('#feed-chrome') : null;
              // the phone sheet (2026-10-22) is FIXED over the feed: nothing to scroll to, and the
              // reader keeps their place in the feed underneath it
              if (document.documentElement.classList.contains('fsrch-sheet')) { /* no scroll */ }
              else if (inChrome && window.__rovaScrollToTop) { window.__rovaScrollToTop(); }
              else { try { pageSearch.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (err) {} }
            }
            return;
          }
        }
        var m = document.getElementById('menu-panel'); if (m) m.classList.remove('show'); // don't stack with the avatar menu
        var opening = !drop.classList.contains('open');
        closeAll(null);
        drop.classList.toggle('open', opening);
        if (drop._hpanel) drop._hpanel.classList.toggle('open', opening);
        if (opening) {
          place(drop, drop._hpanel);
          load(drop);
          if (drop.id === 'search-drop') {
            var si = document.getElementById('hdr-search');
            if (si) setTimeout(function () { si.focus(); }, 60);   // after the open transition starts
          }
        }
        syncShield();
      });
      if (drop._hpanel) {   // "Tap to retry" after a failed load
        drop._hpanel.addEventListener('click', function (e) {
          if (e.target.closest && e.target.closest('.hdrop-retry')) load(drop);
        });
      }
    });
    document.addEventListener('click', function (e) {
      // A node that an EARLIER listener already removed from the document has no ancestors
      // left, so every closest() below returns null and a click that plainly happened inside
      // the panel reads as "outside" it. That is not hypothetical: the composer's remove-GIF
      // "x" lives inside the preview that cgifClear() wipes, and its document listener is
      // registered before this one, so removing a staged GIF closed the whole sheet. If the
      // target is gone, some handler owned this click; it was not a click on the page behind.
      if (!e.target.isConnected) return;
      // .gif-pop / .emoji-pop are body children (they must escape the panel's overflow:hidden),
      // so a tap inside either one reads as "outside the flyout" and used to close the whole
      // sheet -- taking the composer, and the pick, with it. They belong to the composer that
      // opened them; treat them as part of it.
      if (!e.target.closest('.hdrop') && !e.target.closest('.hdrop-panel')
          && !e.target.closest('.gif-pop') && !e.target.closest('.emoji-pop')) closeAll(null);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(null); });
    // rotation safety: close on WIDTH change only (the mobile keyboard fires
    // height-only resizes, which must not dismiss the sheet mid-typing)
    var lastVw = window.innerWidth;
    window.addEventListener('resize', function () {
      if (window.innerWidth !== lastVw) { lastVw = window.innerWidth; closeAll(null); }
    });

    /* ---- inline mini-messenger: open a conversation + reply inside the Messages flyout ---- */
    var dmDrop = document.getElementById('dm-drop');
    if (dmDrop && dmDrop._hpanel) {
      var dmPanel = dmDrop._hpanel;   // portaled to body above
      var dmHead = dmPanel.querySelector('.hdrop-head');
      var dmBody = dmPanel.querySelector('.hdrop-body');
      dmInboxHead = dmHead ? dmHead.innerHTML : '';
      var dmSending = false;
      // live mini-thread state (mirrors the full /m/ thread page)
      var miniWith = null, miniLastId = 0, miniTimer = null, miniTypingEl = null, miniLastPing = 0;
      // scroll-up history, the flyout's half of what the retired thread page used to do. The
      // ?partial=1 load only carries the last 40 messages, so without this a long conversation
      // simply had no earlier history anywhere on the site once /m/ stopped rendering a page.
      var miniPeer = null, miniOldestId = 0, miniHasOlder = false, miniLoadingOlder = false;

      /* ---- DM VIDEO (2026-09-30) ------------------------------------------------------------
         The server renders the bubble (routes/messages.php dm_video_html): a native <video
         class="msg-video"> with poster + preload="none" + controls, sized from the clip's own
         dims, or a `.msg-vid[data-dmv="processing"]` placeholder, or a failed card. This block
         owns what the markup cannot:
           SOUND   nothing autoplays, ever. A TAP plays it; it starts unmuted unless the reader
                   pressed mute on the site (rova_sound === '0', the one sound pref). While it plays
                   it takes the site's own sound HOLD, so the timeline behind the flyout goes quiet
                   (one voice), and releases it on pause/end. Never writes rova_sound itself.
           ONE     starting a DM clip pauses any other DM clip.
           OFF     a clip scrolled out of the thread (or a flyout closed/hidden) pauses.
           READY   processing bubbles ride the 4s /dm-poll as `pend=`; the reply's `upd` swaps
                   the finished (or failed) markup in place. */
      var DM_VID_MAX = 100 * 1024 * 1024, DM_IMG_MAX = 25 * 1024 * 1024;
      // Windows/Android pickers sometimes hand a .mov with an EMPTY type, so the name decides too
      function dmIsVideoFile(f) {
        return !!f && (/^video\//.test(f.type || '') || /\.(mp4|m4v|mov|webm|3gp)$/i.test(f.name || ''));
      }
      var dmVidIO = ('IntersectionObserver' in window) ? new IntersectionObserver(function (ents) {
        ents.forEach(function (en) {
          var v = en.target;
          if ((!en.isIntersecting || en.intersectionRatio < 0.25) && !v.paused) { try { v.pause(); } catch (_) {} }
        });
      }, { threshold: [0, 0.25] }) : null;
      var dmVidHoldT = null;
      function dmVidHold(on) {
        if (dmVidHoldT) { clearInterval(dmVidHoldT); dmVidHoldT = null; }
        if (on) {
          if (window.__rovaSoundHold) { window.__rovaSoundHold(3000); }
          // the hold carries its own expiry; renew it while the clip keeps speaking
          dmVidHoldT = setInterval(function () { if (window.__rovaSoundHold) window.__rovaSoundHold(3000); }, 2000);
        } else if (window.__rovaSoundRelease) { window.__rovaSoundRelease(); }
      }
      function dmPauseVideos(except) {
        Array.prototype.forEach.call(dmPanel.querySelectorAll('video.msg-video'), function (v) {
          if (v !== except && !v.paused) { try { v.pause(); } catch (_) {} }
        });
      }
      dmPanel.addEventListener('play', function (e) {
        var v = e.target;
        if (!v || !v.matches || !v.matches('video.msg-video')) return;
        dmPauseVideos(v);
        if (!v._dmWired) {
          v._dmWired = 1;
          // THE SITE SOUND RULE: rova_sound absent = ON, '0' = the reader pressed mute.
          var pref = null; try { pref = localStorage.getItem('rova_sound'); } catch (_) {}
          v.muted = (pref === '0') || v.getAttribute('data-noaudio') === '1';
          if (dmVidIO) dmVidIO.observe(v);
        }
        if (!v.muted) dmVidHold(true);
      }, true);
      dmPanel.addEventListener('volumechange', function (e) {
        var v = e.target;
        if (!v || !v.matches || !v.matches('video.msg-video') || v.paused) return;
        dmVidHold(!v.muted);
      }, true);
      ['pause', 'ended'].forEach(function (ev) {
        dmPanel.addEventListener(ev, function (e) {
          var v = e.target;
          if (!v || !v.matches || !v.matches('video.msg-video')) return;
          var anyOn = false;
          Array.prototype.forEach.call(dmPanel.querySelectorAll('video.msg-video'), function (o) { if (!o.paused && !o.muted) anyOn = true; });
          if (!anyOn) dmVidHold(false);
        }, true);
      });
      function dmPendIds() {
        var t = miniThreadEl(); if (!t) return '';
        var ids = [];
        Array.prototype.forEach.call(t.querySelectorAll('.msg-vid[data-dmv="processing"]'), function (el) {
          var msg = el.closest('.msg'); var id = msg ? (parseInt(msg.getAttribute('data-mid'), 10) || 0) : 0;
          if (id > 0 && ids.indexOf(id) < 0 && ids.length < 10) ids.push(id);
        });
        return ids.join(',');
      }
      function dmApplyUpd(upd) {
        var t = miniThreadEl(); if (!t || !upd) return;
        Object.keys(upd).forEach(function (id) {
          var msg = t.querySelector('.msg[data-mid="' + (parseInt(id, 10) || 0) + '"]'); if (!msg) return;
          var mm = msg.querySelector('.msg-media'); if (!mm) return;
          var stick = miniAtBottom();
          var lv = mm.querySelector('video');   // the sender's local preview may be playing: never cut it off
          if (lv && !lv.paused) { mm._dmPendingHtml = String(upd[id] || ''); lv.addEventListener('pause', function once() { lv.removeEventListener('pause', once); if (mm._dmPendingHtml) { mm.innerHTML = mm._dmPendingHtml; mm._dmPendingHtml = ''; } }); return; }
          mm.innerHTML = String(upd[id] || '');
          mm.classList.add('is-vid');
          if (stick) t.scrollTop = t.scrollHeight;
        });
      }
      /* THE DM ATTACH GLYPH = the post composer's media glyph (views/_composer.php, "PHOTO + PLAY
         BADGE", owner 2026-09-30): a photo frame with a play badge bottom-right, because this picker
         now takes photos AND videos. Same geometry as the composer's copy, at this row's 1.7 stroke
         like the emoji button beside it. */
      function dmAttachGlyph() {
        return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
          + '<path d="M10.68 16.85H5.6a2.5 2.5 0 0 1-2.5-2.5V7.15a2.5 2.5 0 0 1 2.5-2.5H15.9a2.5 2.5 0 0 1 2.5 2.5V9.13"/>'
          + '<path d="M3.1 15.3 10.3 9.9l1.68 1.68"/>'
          + '<circle cx="7.1" cy="8.6" r="1.5" fill="currentColor" stroke="none"/>'
          + '<path fill="currentColor" stroke="none" fill-rule="evenodd" d="M12.6 15.65a4.6 4.6 0 1 0 9.2 0 4.6 4.6 0 1 0-9.2 0zM15.95 13.55v4.2l3.6-2.1z"/></svg>';
      }

      function bubbleHTML(m) {
        var txt = (m.body == null ? '' : String(m.body)).trim();
        var link = m.embed || m.card || '';
        // data-ts drives the #589 day separators; title restores the exact time on hover
        // WS-B: TRANSLATE (on tap only). The server detects the other person's language (m.lang, null = mine / emoji / too short);
        // the control shows only when it differs from this reader's. assets/app.js "DM TRANSLATE + COPY" owns the tap.
        var trLang = (!m.mine && txt && m.lang && window.__rovaDmCanTranslate) ? window.__rovaDmCanTranslate(m.lang) : '';
        return '<div class="msg ' + (m.mine ? 'me' : 'them') + (dmRxPill(m.rx) ? ' rx-on' : '') + '" data-mid="' + (m.id || 0) + '"'
             + ' data-ts="' + (parseInt(m.ts, 10) || 0) + '" title="' + escHtml(dmTitle(m.ts)) + '"' + (trLang ? ' data-lang="' + escHtml(trLang) + '"' : '') + '>'
             + (txt ? '<div class="bubble">' + dmBodyHtml(m.body) + '</div>' : '')
             + (trLang ? '<button type="button" class="msg-tr">Translate</button>' : '')
             + (m.media ? '<div class="msg-media' + (/class="msg-vid/.test(String(m.media)) ? ' is-vid' : '') + '">' + m.media + '</div>' : '')
             + (link ? '<div class="msg-link">' + link + '</div>' : '')
             + dmRxPill(m.rx)
             + '<span class="msg-time">' + escHtml(m.ago) + '</span></div>';
      }
      function miniThreadEl() { return document.getElementById('hdrop-thread'); }
      function miniAtBottom() { var t = miniThreadEl(); return !!t && (t.scrollHeight - t.scrollTop - t.clientHeight < 70); }
      function miniStopPoll() {
        try { dmPauseVideos(null); } catch (_) {}   // leaving the thread / closing the flyout: no DM clip keeps talking
        if (miniTimer) { clearInterval(miniTimer); miniTimer = null; }
        if (miniResumeT) { clearTimeout(miniResumeT); miniResumeT = null; }   // ...and the pending return-to-visible refresh
        miniWith = null; miniTypingEl = null;
      }
      function miniShowTyping(on) {
        var t = miniThreadEl(); if (!t) return;
        if (on) {
          if (!miniTypingEl) {
            miniTypingEl = document.createElement('div');
            miniTypingEl.className = 'msg them';
            miniTypingEl.innerHTML = '<div class="bubble typing"><span></span><span></span><span></span></div>';
          }
          if (miniTypingEl.parentNode !== t) { t.appendChild(miniTypingEl); if (miniAtBottom()) t.scrollTop = t.scrollHeight; }
        } else if (miniTypingEl && miniTypingEl.parentNode) { miniTypingEl.parentNode.removeChild(miniTypingEl); }
      }
      /* SLOW-LINK (2026-08-10). Same treatment, same reasons, as the full thread's dmPoll further
         down: no in-flight flag and no deadline on a short fixed period. This one self-stops when
         the flyout closes, which bounds the damage but does nothing at all while it is OPEN -- and
         a reader with the flyout open on a dead cell is exactly the case that stacks requests.

         A HIDDEN TAB MUST NOT SEND A "SEEN" RECEIPT (2026-09-19). The note that stood here until
         today said `document.hidden` was "deliberately NOT checked ... already gated on a visible
         open flyout". That premise is false, and it is the only claim in this file whose cost is not
         CPU: AN OPEN FLYOUT IS NOT A VISIBLE ONE. The flyout survives a tab switch, so this kept
         polling every 4s in a backgrounded tab -- and `/dm-poll` calls `Messages::markRead()`
         (index.php handle_dm_poll), so every tick stamped `read_at` on messages nobody had looked
         at. MEASURED on the shipped bundle `app.d72c3a79c5cb`, reader fixture, 30s hidden:
         8 polls, and 3 messages that arrived while the reader was away came back `read`. That is a
         false statement to another member about a human's behaviour. The full-page twin (`dmPoll`,
         further down) has been gated since 2026-08-10; this was an inconsistency, not a choice.

         THE RESUME IS THE HARD HALF, because on this route the refresh IS the receipt -- there is no
         peek mode on /dm-poll -- so "when do we poll again" is really "when are we willing to say
         seen". Two deliberate choices:
           - THE PREDICATE IS `document.hidden`, NOT focus. A window sharing the screen with another
             app is `visible` and its reader can genuinely see the flyout; a window fully covered by
             another one is reported `hidden` by Chromium's occlusion tracking. Visibility is the
             closest the platform comes to "this person can see it", and demanding FOCUS as well
             would suppress an honest receipt on a side-by-side window -- under-reporting a real read
             is its own kind of lie.
           - THE RESUME DWELLS. A tab clicked THROUGH on the way to another one goes visible->hidden
             inside a few hundred ms; polling on the bare `visible` edge would let that flick alone
             mark a conversation read. So the return schedules one refresh MINI_RESUME_DWELL_MS out
             and re-checks visibility when it fires. It costs an honest reader nothing (the 4s tick
             is right behind it) and removes the whole class.
         Lifecycle is unchanged: miniStopPoll still owns it, and the interval keeps running while
         hidden and simply does nothing -- exactly what the full-page twin's does. */
      var miniBusy = false, miniResumeT = null;
      var MINI_RESUME_DWELL_MS = 500;
      function miniPoll() {
        if (!miniWith || miniBusy) return;
        if (!dmPanel.classList.contains('open')) { miniStopPoll(); return; }   // flyout closed: self-stop
        if (document.hidden) return;   // no reader behind this tab: never claim they saw anything
        miniBusy = true;
        var pend = dmPendIds();   // DM videos still processing: the reply's `upd` swaps them when done
        rfetch('/dm-poll?with=' + encodeURIComponent(miniWith) + '&after=' + miniLastId + (pend ? '&pend=' + pend : ''),
              { headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' }, 8000)
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (!res) return;
            var t = miniThreadEl(); if (!t) return;
            if (res.upd) dmApplyUpd(res.upd);
            var got = false;
            var incoming = false;
            if (res.messages && res.messages.length) {
              var stick = miniAtBottom();
              var em = t.querySelector('.empty'); if (em) em.remove();
              res.messages.forEach(function (m) {
                if (m.id <= miniLastId) return;
                var frag = document.createElement('div'); frag.innerHTML = bubbleHTML(m);
                var node = frag.firstChild;
                dmSepAppend(t, m, (miniTypingEl && miniTypingEl.parentNode) ? miniTypingEl : null);   // #589
                if (miniTypingEl && miniTypingEl.parentNode) t.insertBefore(node, miniTypingEl); else t.appendChild(node);
                miniLastId = Math.max(miniLastId, m.id); got = true;
                if (!m.mine) incoming = true;
              });
              if (stick) t.scrollTop = t.scrollHeight;
            }
            miniShowTyping(!!res.typing);
            if (incoming && window.__rovaChirp) window.__rovaChirp();   // a message just arrived
            if (got && window.__rovaRefreshCounts) window.__rovaRefreshCounts();   // reading clears the badge
          })
          .catch(function () {})
          .then(function () { miniBusy = false; });   // trailing, so a rejection releases it too
      }
      // ...and the return. See the dwell argument in the block above: this is the ONLY thing that
      // re-opens the receipt, so it re-reads document.hidden at FIRE time, not at schedule time.
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) { if (miniResumeT) { clearTimeout(miniResumeT); miniResumeT = null; } return; }
        if (!miniWith || miniResumeT) return;
        miniResumeT = setTimeout(function () {
          miniResumeT = null;
          if (document.hidden) return;   // flicked through on the way somewhere else: the tick owns it now
          miniPoll();                    // flyout still open / still threaded? miniPoll's own guards answer that
        }, MINI_RESUME_DWELL_MS);
      });
      function renderThread(d) {
        var msgs = d.messages || [], list = '', i, prevTs = 0;
        for (i = 0; i < msgs.length; i++) {
          list += dmSepBetween(prevTs, msgs[i] && msgs[i].ts);   // #589 block markers
          prevTs = (msgs[i] && parseInt(msgs[i].ts, 10)) || prevTs;
          try { list += bubbleHTML(msgs[i]); }
          catch (be) {                              // never drop a message: fall back to a plain bubble
            console.error('[dm] bubble render failed; plain fallback', msgs[i], be);
            var mm = msgs[i] || {};
            list += '<div class="msg ' + (mm.mine ? 'me' : 'them') + '" data-mid="' + (mm.id || 0) + '"'
                  + ' data-ts="' + (parseInt(mm.ts, 10) || 0) + '">'
                  + ((mm.body || '') ? '<div class="bubble">' + escHtml(mm.body) + '</div>' : '')
                  + ((mm.embed || mm.card || mm.media) ? '<div class="msg-link">' + (mm.embed || mm.card || mm.media) + '</div>' : '')
                  + '<span class="msg-time">' + escHtml(mm.ago || '') + '</span></div>';
          }
        }
        // 30, not the 40 that handle_dm_thread's array_slice suggests: the slice never bites,
        // because Messages::thread() has ALREADY capped the tail at 30 (lib/messages.php, the
        // $limit default) before it gets there. A full page means there is probably history
        // above it -- the same heuristic, and the same number, the thread page used.
        miniPeer = String(d.user.username || '');
        // Blue check on the thread header. RENDER THE SERVER'S ANSWER: handle_dm_thread ran
        // verified_is_on() over the peer row, so d.user.verified already applies the seed rule.
        // Never re-derive it from a billing field here -- 89 seed accounts hold a fake
        // sub_status='active', and @rosa (a seed an admin genuinely verified) is the proof that
        // only the server's answer gets this right. openThread() built the header before this
        // fetch resolved, so the tick lands here; the idempotent check keeps a re-render (a
        // reopened thread reuses the same header node) from stacking two of them.
        var lmBtn = dmHead ? dmHead.querySelector('.dm-live-mute') : null;   // WS-B: the live-invite mute reflects the server
        if (lmBtn) { var lmOn = !!(d.user && d.user.live_muted); lmBtn.setAttribute('data-on', lmOn ? '1' : '0'); lmBtn.textContent = lmOn ? 'Unmute live invites' : 'Mute live invites'; }
        var peerId = dmHead ? dmHead.querySelector('.hdrop-peer-id') : null;
        if (peerId) {
          var oldTick = peerId.querySelector('.vtick');
          if (oldTick) { oldTick.parentNode.removeChild(oldTick); }
          if (d.user && d.user.verified) {
            peerId.insertAdjacentHTML('beforeend', vsealTick());
          }
        }
        miniHasOlder = msgs.length >= 30;
        miniOldestId = msgs.length ? (parseInt(msgs[0].id, 10) || 0) : 0;
        miniLoadingOlder = false;
        dmBody.innerHTML =
          '<div class="hdrop-thread" id="hdrop-thread">'
          + (miniHasOlder ? '<div class="dm-older" id="hdrop-older">Loading earlier messages…</div>' : '')
          + (msgs.length ? list : '<div class="empty">Send a message to start the conversation 👋</div>') + '</div>'
          + '<div class="hdrop-compose" data-to="' + (parseInt(d.user.id, 10) || 0) + '">'
          // Emoji + GIF ride the SHARED document-level delegates (.emoji-btn / .js-gif), the same
          // two buttons the full-page .dm-compose carries and in the same order. Markup only --
          // both delegates now resolve their target by ELEMENT (closest('form, .hdrop-compose'))
          // instead of by <form>, which is the whole of what this bar needed from them.
          + '<button class="ctool emoji-btn" type="button" aria-label="Add emoji" title="Emoji"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M8 14s1.5 2 4 2 4-2 4-2"/><line x1="9" y1="9" x2="9.01" y2="9"/><line x1="15" y1="9" x2="15.01" y2="9"/></svg></button>'
          + '<button class="ctool js-gif" type="button" aria-label="Add a GIF" title="Add a GIF"><svg viewBox="0 0 24 24" fill="none"><rect x="1.5" y="6" width="21" height="12" rx="3.4" stroke="currentColor" stroke-width="1.5"/><text x="12" y="15.3" text-anchor="middle" font-size="9.6" font-weight="800" letter-spacing="-.4" fill="currentColor" font-family="-apple-system,BlinkMacSystemFont,Segoe UI,Arial,sans-serif">GIF</text></svg></button>'
          // attach: the post composer's MEDIA glyph (views/_composer.php, owner 2026-09-28 "update the dm
          // media attachment button also"), same three shapes, at this row's 1.7 stroke like emoji beside it.
          // photos AND videos since 2026-09-30 (DM video): the composer's photo + play-badge glyph
          + '<button class="ctool hdrop-attach" type="button" aria-label="Add photos or videos" title="Add photos or videos">' + dmAttachGlyph() + '</button>'
          + '<input type="file" class="hdrop-file" accept="image/*,video/*" hidden>'
          + '<div class="dm-attach-prev hdrop-attach-prev" hidden></div>'
          + '<input class="input" maxlength="2000" autocomplete="off" placeholder="Message ' + escHtml(d.user.name || ('@' + d.user.username)) + '…">'
          + '<button class="cbtn gold" type="button" aria-label="Send">' + SEND_SVG + '</button></div>';
        var t = document.getElementById('hdrop-thread');
        if (t) {
          // pin to the newest message. Do it now, next frame, and again after a beat,
          // and once more as each image/embed finishes loading (they shift the height).
          var toBottom = function () { t.scrollTop = t.scrollHeight; };
          toBottom();
          requestAnimationFrame(toBottom);
          setTimeout(toBottom, 120);
          Array.prototype.forEach.call(t.querySelectorAll('img'), function (im) {
            if (!im.complete) im.addEventListener('load', toBottom, { once: true });
          });
          // the thread element is replaced on every open, so the listener goes on with it
          t.addEventListener('scroll', function () { if (t.scrollTop < 60) miniLoadOlder(); });
        }
        var inp = dmBody.querySelector('.hdrop-compose input'); if (inp) inp.focus();
        // realtime: track newest id, (re)start polling for this peer, clear the badge now
        miniLastId = 0;
        for (i = 0; i < msgs.length; i++) { if ((msgs[i].id || 0) > miniLastId) miniLastId = msgs[i].id; }
        var puid = parseInt(d.user.id, 10) || 0;
        miniTypingEl = null;
        if (miniTimer) { clearInterval(miniTimer); miniTimer = null; }
        miniWith = puid ? String(puid) : null;
        if (miniWith) { miniTimer = setInterval(miniPoll, 4000); }
        if (window.__rovaRefreshCounts) window.__rovaRefreshCounts();
      }
      function openThread(uid, username, name, avHtml) {
        dmPanel.classList.add('threading');
        // Big tappable "Back" row on the left (whole left side returns to the inbox);
        // the peer's photo + name identify the chat and link to their profile.
        if (dmHead) dmHead.innerHTML =
          '<button type="button" class="hdrop-back" aria-label="Back to messages">'
          + '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m14 5-7 7 7 7"/></svg></button>'
          // THE NAME IS WRAPPED, and that wrapper is the whole point. .hdrop-peer-name carries
          // white-space:nowrap + overflow:hidden + text-overflow:ellipsis (rova.css), which is
          // exactly the shape that swallowed the settings mute row's badge: a tick placed INSIDE
          // it is laid out past the clip and never painted at all. So the name keeps its class and
          // its truncation, and .hdrop-peer-id is a flex line holding the name plus the tick as
          // SIBLINGS -- the name takes the slack, the tick is a flex item that cannot be clipped
          // at any width. Inline styles because this badge must not depend on a stylesheet edit.
          // The tick itself is filled in by renderThread(), which is the first thing here that
          // knows whether the peer is verified (the inbox row that opened this passes a name and
          // an avatar, nothing more).
          + '<a class="hdrop-peer" href="/@' + encodeURIComponent(username) + '">'
          +   '<span class="hdrop-peer-av">' + (avHtml || '') + '</span>'
          +   '<span class="hdrop-peer-id" style="display:flex;align-items:center;gap:4px;min-width:0;flex:1 1 auto">'
          +     '<span class="hdrop-peer-name">' + escHtml(name || ('@' + username)) + '</span></span></a>'
          // Conversation options. The retired thread page was the ONLY place "Delete
          // conversation" lived, so without this the flyout would have quietly taken the
          // feature away with the page. Markup only: the "..." toggle and the .dm-del-thread
          // action are both document-level delegates already (they were written "so it also
          // serves any dynamically-rendered header"), keyed off data-with.
          + '<div class="dm-menu">'
          +   '<button type="button" class="dm-menu-btn" aria-label="Conversation options" aria-haspopup="true">'
          +   '<svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true"><circle cx="5" cy="12" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="19" cy="12" r="2"/></svg></button>'
          +   '<div class="dm-menu-pop glass" hidden>'
          // WS-B (db/0320): mute THIS person's live shares + host invites (renderThread sets Mute / Unmute from d.user.live_muted)
          +     '<button type="button" class="dm-live-mute" data-with="' + (parseInt(uid, 10) || 0) + '" data-on="0" data-name="' + escHtml(name || ('@' + username)) + '">Mute live invites</button>'
          +     '<button type="button" class="dm-del-thread danger" data-with="' + (parseInt(uid, 10) || 0) + '">'
          +     (isAdmin ? 'Delete conversation (permanent)' : 'Delete conversation') + '</button></div></div>'
          + '<button type="button" class="hdrop-close" aria-label="Close messages">'
          + '<svg viewBox="0 0 24 24" width="19" height="19" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button>';
        dmBody.classList.add('is-thread');
        dmBody.innerHTML = '<div class="hdrop-spin"></div>';
        var dmFail = function (why, extra) {   // one place surfaces the REAL reason
          console.error('[dm] flyout load failed:', why, extra || '');
          dmBody.innerHTML = '<div class="hdrop-empty">Couldn\'t load (' + why + '). Tap Back and try again.'
            + '<br><a href="/m/' + encodeURIComponent(username) + '" style="color:var(--accent-text)">Open full conversation</a></div>';
        };
        /* The session died, which is a different sentence from every dmFail above: no amount
           of "try again" revives it, and it was never the network's fault. Before this, the
           302-to-/login that require_login answers a dead session with was FOLLOWED into the
           login page's HTML, JSON.parse choked on it, and the member got "Couldn't load
           (bad response 200)" — the same auth-failure-dressed-as-load-failure the bell panel
           had (see load() above, and the app's HeaderPanel twin fixed the same day). */
        var dmSignedOut = function () {
          dmBody.innerHTML = '<div class="hdrop-empty">You’ve been signed out. '
            + '<a href="/login" style="color:var(--accent-text)">Log in</a> to pick up where you left off.</div>';
        };
        fetch('/m/' + encodeURIComponent(username) + '?partial=1',
              { headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', cache: 'no-store' })
          .then(function (r) {
            var status = r.status;
            var signedOut = !!(r.redirected && /\/login(\?|$)/.test(r.url || ''));
            return r.text().then(function (raw) {
              var d = null;
              try { d = JSON.parse(raw); }
              catch (pe) {
                if (signedOut || /^<!doctype/i.test((raw || '').trim())) { dmSignedOut(); return; }
                dmFail('bad response ' + status, { parse: String(pe), bodyStart: raw.slice(0, 400) }); return;
              }
              if (!d) { dmFail('empty ' + status); return; }
              if (!d.ok) {
                if (d.error === 'not_allowed') { dmBody.innerHTML = '<div class="hdrop-empty">You can only message people you follow who follow you back.</div>'; return; }
                dmFail('server ' + status, d);   // includes d.detail when you're an admin
                return;
              }
              try { renderThread(d); }
              catch (re) { dmFail('render error', { error: String(re), stack: re && re.stack, data: d }); }
            });
          })
          .catch(function (ne) { dmFail('network', String(ne)); });
      }
      /* Scroll-up history for the inline thread. Straight port of the retired thread page's
         loadOlder(): same endpoint (?partial=older&before=<oldest>, oldest-first), same
         separator re-decision, same scroll-anchor arithmetic. The only difference is the URL,
         which the page took from location.pathname and this takes from the peer's handle. */
      function miniLoadOlder() {
        var t = miniThreadEl();
        if (miniLoadingOlder || !miniHasOlder || !miniOldestId || !miniPeer || !t) return;
        miniLoadingOlder = true;
        var older = document.getElementById('hdrop-older');
        fetch('/m/' + encodeURIComponent(miniPeer) + '?partial=older&before=' + miniOldestId,
              { headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
                credentials: 'same-origin', cache: 'no-store' })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            miniLoadingOlder = false;
            var msgs = (res && res.messages) || [];
            if (!msgs.length) { miniHasOlder = false; if (older) older.remove(); return; }
            var prevH = t.scrollHeight, prevTop = t.scrollTop;
            var anchor = older ? older.nextSibling : t.firstChild;
            // #589: the marker that used to OPEN the thread can become redundant once older
            // history is spliced in above it, so remember it and re-decide afterwards.
            var oldSep = (anchor && anchor.classList && anchor.classList.contains('dm-sep')) ? anchor : null;
            var firstMsg = t.querySelector('.msg[data-ts]');
            var oldFirstTs = firstMsg ? (parseInt(firstMsg.getAttribute('data-ts'), 10) || 0) : 0;
            var prevTs = 0;
            msgs.forEach(function (m) {
              var sep = dmSepBetween(prevTs, m.ts);
              if (sep) { var f = document.createElement('div'); f.innerHTML = sep; t.insertBefore(f.firstChild, anchor); }
              prevTs = parseInt(m.ts, 10) || prevTs;
              var g = document.createElement('div'); g.innerHTML = bubbleHTML(m);
              t.insertBefore(g.firstChild, anchor);
            });
            if (oldSep && !dmSepBetween(prevTs, oldFirstTs)) { oldSep.remove(); }
            miniOldestId = parseInt(msgs[0].id, 10) || miniOldestId;
            miniHasOlder = !!(res && res.more);
            if (!miniHasOlder && older) older.remove();
            t.scrollTop = prevTop + (t.scrollHeight - prevH);   // hold the reader's place
          })
          .catch(function () { miniLoadingOlder = false; });
      }
      function clearMiniPreview(wrap) {
        var fi = wrap.querySelector('.hdrop-file'); if (fi) fi.value = '';
        var pv = wrap.querySelector('.hdrop-attach-prev'); if (pv) { pv.hidden = true; pv.innerHTML = ''; }
      }
      function sendDM(input) {
        var wrap = input.closest('.hdrop-compose'); if (!wrap) return;
        var to = wrap.getAttribute('data-to'), val = (input.value || '').trim();
        var fi = wrap.querySelector('.hdrop-file');
        var file = fi && fi.files && fi.files[0];
        // Messages have NO gif_url column -- a DM's GIF is rendered by running extract_gif()
        // over the stored BODY (views/messages_thread.php / dmBodyHtml here). So the picked
        // URL has to be folded back into the text we send, exactly as the full-page .dm-compose
        // handler does; what lands in the DB is byte-for-byte the old behaviour.
        if (!to || (!val && !file && !cgifUrl(wrap))) return;
        // Hoisted ABOVE cgifTake: cgifTake CLEARS the pick, so a duplicate send dropped by the
        // in-flight guard would swallow the member's GIF and never send it.
        if (!file && dmSending) return;
        var pick = cgifTake(wrap);
        var sendBody = pick.url ? (val ? val + ' ' + pick.url : pick.url) : val;
        var t = document.getElementById('hdrop-thread');

        // With a photo: show it INSTANTLY from the local file + an uploading spinner,
        // and send in the background - so it feels as fast as a text send and the
        // upload is never a blank wait. (Text-only keeps the simple path below.)
        if (file) {
          var localUrl = URL.createObjectURL(file);
          var isVid = dmIsVideoFile(file);
          var node = document.createElement('div');
          node.className = 'msg me dm-optim';
          node.innerHTML =
            // dmBodyHtml already swaps a Giphy URL for an <img>, so the optimistic bubble shows
            // the GIF straight away -- the same shape a reload renders from the stored body.
            (sendBody ? '<div class="bubble">' + dmBodyHtml(sendBody) + '</div>' : '')
            // A VIDEO previews from the local file too (muted, first frame via preload=metadata);
            // once sent it stays playable for the sender while the server processes the clip.
            + (isVid
                ? '<div class="msg-media is-vid uploading"><div class="msg-vid" data-dmv="local"><video class="msg-video" src="' + localUrl + '" preload="metadata" playsinline muted></video></div><span class="up-spin" aria-label="Uploading"></span></div>'
                : '<div class="msg-media uploading"><img src="' + localUrl + '" alt=""><span class="up-spin" aria-label="Uploading"></span></div>')
            + '<span class="msg-time">Sending…</span>';
          if (t) {
            var em0 = t.querySelector('.empty'); if (em0) em0.remove();
            dmSepAppend(t, { ts: Math.floor(Date.now() / 1000) }, null);   // #589
            t.appendChild(node); t.scrollTop = t.scrollHeight;
          }
          if (isVid) {
            // A local file this browser cannot DECODE (an HEVC or MPEG-4 .mov on Chrome/Windows) loads
            // its metadata but paints nothing: black box. Show the quiet placeholder instead; the
            // server's transcoded player replaces it via the poll either way.
            var lvx = node.querySelector('.msg-vid video');
            var dmLocalFallback = function () {
              var w = lvx && lvx.parentNode; if (!w || w.classList.contains('is-processing')) return;
              w.classList.add('is-processing'); w.style.aspectRatio = '0.8';
              lvx.style.display = 'none';
              w.insertAdjacentHTML('beforeend', '<span class="msg-vid-note" role="status">Processing video…</span>');
            };
            if (lvx) {
              lvx.addEventListener('error', dmLocalFallback);
              lvx.addEventListener('loadedmetadata', function () { if (!lvx.videoWidth) dmLocalFallback(); });
            }
          }
          input.value = ''; clearMiniPreview(wrap); input.focus();
          if (window.__rovaClearComposePreview) window.__rovaClearComposePreview(input);
          var fdm = new FormData(); fdm.append('to', to); fdm.append('body', sendBody); fdm.append('media', file);
          // csrfSend: a stale token used to reload the page out from under a half-typed thread. The
          // 419 is refused by the global gate before handle_messages() runs, so the one replay
          // cannot post the message twice; fetch re-serialises a FormData per call, file included.
          csrfSend(function (token) {
            return fetch('/messages', { method: 'POST', headers: { 'X-CSRF-Token': token, 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }, body: fdm, credentials: 'same-origin' });
          })
            .then(function (r) { if (r.status === 419) { csrfStaleNotice(); throw new Error('reauth'); } if (r.status === 401) { window.location.reload(); throw new Error('reauth'); } return r.json(); })
            .then(function (res) {
              if (res && res.error) { node.classList.add('failed'); var te = node.querySelector('.msg-time'); if (te) te.textContent = 'Not sent'; toast(res.error); return; }
              if (res && res.message) {
                node.setAttribute('data-mid', res.message.id || 0);
                node.setAttribute('data-ts', parseInt(res.message.ts, 10) || Math.floor(Date.now() / 1000));
                var mm = node.querySelector('.msg-media'); if (mm) mm.classList.remove('uploading');
                var sp = node.querySelector('.up-spin'); if (sp) sp.remove();
                var ts = node.querySelector('.msg-time'); if (ts) ts.textContent = res.message.ago || 'now';
                miniLastId = Math.max(miniLastId, res.message.id || 0);   // poll must not re-add it
                if (isVid && mm) {
                  // DM video: the server is transcoding it now. Keep the sender's LOCAL copy on
                  // screen (and playable) instead of a spinner, flagged "processing" so the 4s poll
                  // swaps in the real player once the clip is ready (or the failed card).
                  var sv = String(res.message.media || '');
                  if (/data-dmv="processing"/.test(sv)) {
                    var lw = mm.querySelector('.msg-vid'); if (lw) lw.setAttribute('data-dmv', 'processing');
                    var lv = mm.querySelector('video'); if (lv) lv.controls = true;
                  } else if (sv) { mm.innerHTML = sv; }
                }
              }
            })
            .catch(function () { node.classList.add('failed'); var tf = node.querySelector('.msg-time'); if (tf) tf.textContent = 'Not sent, tap to retry'; });
          return;
        }

        // Text-only: the simple fast path. (The in-flight guard is up top, above cgifTake.)
        dmSending = true;
        var btn = wrap.querySelector('.cbtn.gold');
        var unbusy = busyStart(btn) || function () {};   // visible flight state; disabled was invisible
        var fd = new FormData(); fd.append('to', to); fd.append('body', sendBody);
        csrfSend(function (token) {
          return fetch('/messages', { method: 'POST', headers: { 'X-CSRF-Token': token, 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }, body: fd, credentials: 'same-origin' });
        })
          .then(function (r) { if (r.status === 419) { csrfStaleNotice(); throw new Error('reauth'); } if (r.status === 401) { window.location.reload(); throw new Error('reauth'); } return r.json(); })
          .then(function (res) {
            dmSending = false; unbusy();
            if (res && res.error) { pick.restore(); toast(res.error); return; }
            if (res && res.message) {
              if (t) {
                var em = t.querySelector('.empty'); if (em) em.remove();
                dmSepAppend(t, res.message, (miniTypingEl && miniTypingEl.parentNode) ? miniTypingEl : null);   // #589
                if (miniTypingEl && miniTypingEl.parentNode) t.insertBefore((function () { var f = document.createElement('div'); f.innerHTML = bubbleHTML(res.message); return f.firstChild; })(), miniTypingEl);
                else t.insertAdjacentHTML('beforeend', bubbleHTML(res.message));
                t.scrollTop = t.scrollHeight;
              }
              miniLastId = Math.max(miniLastId, res.message.id || 0);   // poll must not re-add it
              input.value = ''; input.focus();
              // This bar is a <div>, not a <form>: no submit event, and a programmatic value write fires
              // no input event, so nothing else drops the link card. Without this the PREVIEW card for the
              // message just sent stayed above an empty box (Rob 10-17). The photo path above already
              // did this; the text path never had it.
              if (window.__rovaClearComposePreview) window.__rovaClearComposePreview(input);
            }
          })
          .catch(function (err) {
            dmSending = false; unbusy(); pick.restore();
            if (!err || err.message !== 'reauth') toast('Couldn’t send, check your connection');   // text is still in the box
          });
      }
      dmPanel.addEventListener('click', function (e) {
        // stopPropagation on every handled click: opening a thread / going back
        // swaps out the panel's innerHTML, which detaches the clicked node, and a
        // detached node isn't inside .hdrop, so the document click-away handler
        // would otherwise fire closeAll() and the flyout would vanish.
        var row = e.target.closest('.notif[data-uid]');
        if (row && !dmPanel.classList.contains('threading')) {
          e.preventDefault(); e.stopPropagation();
          var av = row.querySelector('.notif-av');   // reuse the row's avatar in the thread header
          openThread(row.getAttribute('data-uid'), row.getAttribute('data-username'), row.getAttribute('data-name'), av ? av.innerHTML : '');
          return;
        }
        if (e.target.closest('.hdrop-close')) {   // explicit X: close the whole flyout (reuses the shield's closeAll + scroll unlock)
          e.preventDefault(); e.stopPropagation(); miniStopPoll();
          var sh = document.querySelector('.hdrop-backdrop'); if (sh) sh.click();
          return;
        }
        if (e.target.closest('.hdrop-back')) { e.preventDefault(); e.stopPropagation(); miniStopPoll(); load(dmDrop); return; }
        var att = e.target.closest('.hdrop-attach');
        if (att) { e.preventDefault(); e.stopPropagation(); var fi = att.closest('.hdrop-compose').querySelector('.hdrop-file'); if (fi) fi.click(); return; }
        var rx = e.target.closest('.dm-prev-x');
        if (rx) { e.preventDefault(); e.stopPropagation(); var wp = rx.closest('.hdrop-compose'); if (wp) clearMiniPreview(wp); return; }
        var sb = e.target.closest('.hdrop-compose .cbtn.gold');
        if (sb) { e.preventDefault(); e.stopPropagation(); var inp = sb.closest('.hdrop-compose').querySelector('input.input'); if (inp) sendDM(inp); }
      });
      dmPanel.addEventListener('change', function (e) {
        if (!e.target.matches || !e.target.matches('.hdrop-file')) return;
        var wrap = e.target.closest('.hdrop-compose'); if (!wrap) return;
        var pv = wrap.querySelector('.hdrop-attach-prev');
        var f = e.target.files && e.target.files[0];
        if (!f) { clearMiniPreview(wrap); return; }
        // photos AND videos (2026-09-30). Limits mirror the server: 25 MB photo (Upload::MAX_IMG),
        // 100 MB video (Messages::VIDEO_MAX_BYTES), so an oversize pick is refused before any upload.
        var fv = dmIsVideoFile(f);
        if (!fv && !/^image\//.test(f.type || '') && !/\.(heic|heif)$/i.test(f.name || '')) { toast('You can send photos or videos.'); clearMiniPreview(wrap); return; }
        if (fv && f.size > DM_VID_MAX) { toast('That video is too large (max 100MB).'); clearMiniPreview(wrap); return; }
        if (!fv && f.size > DM_IMG_MAX) { toast('That photo is too large (max 25MB).'); clearMiniPreview(wrap); return; }
        pv.innerHTML = (fv
            ? '<video src="' + URL.createObjectURL(f) + '" preload="metadata" muted playsinline></video>'
            : '<img src="' + URL.createObjectURL(f) + '" alt="">')
          + '<button type="button" class="dm-prev-x" aria-label="' + (fv ? 'Remove video' : 'Remove photo') + '">✕</button>';
        pv.hidden = false;
      });
      dmPanel.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && e.target.matches && e.target.matches('.hdrop-compose input')) { e.preventDefault(); sendDM(e.target); }
      });
      // typing heartbeat while composing (throttled) so the peer sees the dots
      dmPanel.addEventListener('input', function (e) {
        if (!miniWith || !e.target.matches || !e.target.matches('.hdrop-compose input')) return;
        var now = Date.now();
        if (now - miniLastPing < 2500) return;
        miniLastPing = now;
        fetch('/dm-typing', { method: 'POST', headers: { 'X-CSRF-Token': csrf, 'X-Requested-With': 'XMLHttpRequest' },
          body: new URLSearchParams({ with: miniWith }), credentials: 'same-origin' }).catch(function () {});
      });

      // shared: pop the Messages flyout open (bottom sheet on phones, panel on desktop)
      function openDmPanel() {
        var m = document.getElementById('menu-panel'); if (m) m.classList.remove('show');
        closeAll(null);
        dmDrop.classList.add('open');
        dmPanel.classList.add('open');
        place(dmDrop, dmPanel);
        syncShield();
      }
      // "Message" buttons anywhere (e.g. profiles) open the chat INLINE, no page load
      document.addEventListener('click', function (e) {
        var a = e.target.closest ? e.target.closest('.js-dm-inline') : null;
        if (!a) return;
        e.preventDefault();
        openDmPanel();
        var av = a.getAttribute('data-av') || '';
        var avHtml = (av !== '' && !/\.(mp4|webm)$/i.test(av))
          ? '<img class="avatar sm" src="' + escHtml(av) + '" alt="">' : '';
        openThread(a.getAttribute('data-uid'), a.getAttribute('data-username'), a.getAttribute('data-name'), avHtml);
      });
      // the avatar-menu "Messages" item opens the inbox flyout inline too
      document.addEventListener('click', function (e) {
        var a = e.target.closest ? e.target.closest('.js-dm-inbox') : null;
        if (!a) return;
        e.preventDefault();
        openDmPanel();
        miniStopPoll();   // viewing the inbox, not a thread: don't keep polling a peer
        load(dmDrop);
      });
      // The /messages PAGE's conversation rows open inline too. They are the same
      // views/_inbox_list.php partial the flyout renders, carrying the same data-uid /
      // data-username / data-name, so this is the flyout's own row handler pointed at the copy
      // that lives on the page. Rows INSIDE the panel never reach here (that handler
      // stopPropagation()s), but the guard makes it true by construction rather than by luck.
      document.addEventListener('click', function (e) {
        var row = e.target.closest ? e.target.closest('.notif[data-uid]') : null;
        if (!row || row.closest('.hdrop-panel')) return;
        e.preventDefault();
        openDmPanel();
        var av = row.querySelector('.notif-av');
        openThread(row.getAttribute('data-uid'), row.getAttribute('data-username'),
                   row.getAttribute('data-name'), av ? av.innerHTML : '');
      });
      // /messages?open=<handle> -- where every old /m/<handle> deep link (DM email, push,
      // hovercard, bookmark) now lands, since the fullscreen thread page was retired. The
      // server resolved and permission-checked the peer; open the very same inline thread a
      // tap would, so a member following a DM link reads and replies in one place.
      var autoOpen = document.getElementById('dm-autoopen');
      if (autoOpen) {
        openDmPanel();
        var oav = autoOpen.getAttribute('data-av') || '';
        openThread(autoOpen.getAttribute('data-uid'), autoOpen.getAttribute('data-username'),
                   autoOpen.getAttribute('data-name'),
                   (oav !== '' && !/\.(mp4|webm)$/i.test(oav))
                     ? '<img class="avatar sm" src="' + escHtml(oav) + '" alt="">' : '');
      }
    }
  })();

  /* ---- notification / DM sound chirp (Web Audio, no asset, CSP-safe) ---- */
  (function () {
    var ctx = null, lastAt = 0;
    // `new AudioContext()` spins up the OS audio subsystem and costs ~80-90ms. Creating it lazily inside
    // the FIRST click handler froze that first interaction (it was the single biggest cost in the tab-switch
    // CPU profile -- a first click that lands on a tab made the whole switch feel janky). Creating a context
    // is allowed anytime and starts SUSPENDED; only resume() must run inside a user gesture. So pre-create it
    // at idle (off any interaction) and let unlock() just resume() -- which is cheap.
    function ensureCtx() { if (!ctx) { try { ctx = new (window.AudioContext || window.webkitAudioContext)(); } catch (e) {} } return ctx; }
    (window.requestIdleCallback || function (f) { return setTimeout(f, 800); })(function () { ensureCtx(); });
    /* browsers gate audio until a user gesture; resume the (already-built) context on the first tap/key.
       2026-10-02 (the wake audit): the context then stayed RUNNING for the life of the page -- an open audio
       session rendering silence on every page after the first click, hidden tabs included. It is now resumed only
       to grant the gesture (once; WebKit lifts the context's gesture restriction for good on that resume, Blink keys
       on the page's sticky activation) and to play a chirp, and SUSPENDED again right after, and on hide. */
    var sT = 0;
    function rest(ms) {
      clearTimeout(sT);
      sT = setTimeout(function () { try { if (ctx && ctx.state === 'running') ctx.suspend(); } catch (e) {} }, ms);
    }
    function unlock() {
      document.removeEventListener('click', unlock);
      document.removeEventListener('keydown', unlock);
      try { ensureCtx(); if (ctx && ctx.state === 'suspended') { ctx.resume(); rest(400); } } catch (e) {}
    }
    document.addEventListener('click', unlock);
    document.addEventListener('keydown', unlock);
    document.addEventListener('visibilitychange', function () { if (document.hidden) rest(0); });
    window.__rovaChirp = function () {
      var t0 = Date.now(); if (t0 - lastAt < 1200) return; lastAt = t0;   // debounce bursts
      try {
        ensureCtx(); if (!ctx) return;
        if (ctx.state !== 'running') { var rp = ctx.resume(); if (rp && rp.then) { rp.then(function () { if (ctx.state === 'running') { lastAt = 0; window.__rovaChirp(); } }, function () {}); return; } }
        rest(700);
        var t = ctx.currentTime, o = ctx.createOscillator(), g = ctx.createGain();
        o.type = 'sine';
        o.frequency.setValueAtTime(880, t);
        o.frequency.exponentialRampToValueAtTime(1320, t + 0.09);   // soft upward chirp
        g.gain.setValueAtTime(0.0001, t);
        g.gain.exponentialRampToValueAtTime(0.14, t + 0.02);
        g.gain.exponentialRampToValueAtTime(0.0001, t + 0.22);
        o.connect(g); g.connect(ctx.destination);
        o.start(t); o.stop(t + 0.24);
      } catch (e) {}
    };
  })();

  /* ---- live count polling (bell + DMs) --------------------------------- */
  (function () {
    var bellBadge = document.getElementById('bell-badge');
    var dmBadge = document.getElementById('dm-badge');
    if (!bellBadge && !dmBadge) return; // logged out
    function setBadge(el, n) {
      if (!el) return;
      if (n > 0) { el.textContent = n > 9 ? '9+' : n; el.hidden = false; }
      else { el.hidden = true; }
    }
    var prevN = null, prevD = null;
    /* SLOW-LINK (2026-08-09). This poller had no in-flight guard, no deadline and no hidden-tab
       skip, and it is the most frequently-armed network timer on every authenticated page.
       MEASURED on the live site at 1.6Mbps/300ms RTT with the CPU at 4x: one /poll-counts took
       3629ms during a viewer fling. At a 15s period that is survivable; at the 60-120s a platform
       spends on a half-open socket it is not -- four, then eight, then sixteen identical requests
       stacked on a link that is already the bottleneck, each one competing with the media the
       reader is actually waiting to see. Two badge integers are worth none of that.
         busy   one at a time, cleared on BOTH paths (a flag cleared only in .then is a latch).
         8000   the standard read deadline; the abort also frees the socket, which is the point.
         hidden a backgrounded tab has no badge anybody can see. The visibilitychange handler
                below already polls the instant it comes back, so nothing is missed by skipping. */
    var cntBusy = false;
    function poll() {
      if (cntBusy || document.hidden) return;
      cntBusy = true;
      rfetch('/poll-counts', {
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        credentials: 'same-origin'
      }, 8000).then(function (r) { return r.json(); })
        .then(function (d) {
          var n = d.notif | 0, dm = d.dm | 0;
          // a new notification or DM arrived (once past the first baseline read): chirp
          if (prevN !== null && (n > prevN || dm > prevD) && window.__rovaChirp) window.__rovaChirp();
          prevN = n; prevD = dm;
          setBadge(bellBadge, n); setBadge(dmBadge, dm);
        })
        .catch(function () {})
        .then(function () { cntBusy = false; });
    }
    setInterval(poll, 15000);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) poll(); });
    // let the DM code refresh the badge the instant a thread is opened/read,
    // instead of waiting up to 15s for the next tick
    window.__rovaRefreshCounts = poll;
  })();

  /* ---- INBOX CONTROLS (WS-B 2026-10-22, Rob: "DM + notification menus far more interactive: filter by unread, select all,
     delete, mark read, mute/block certain notification types and live shares"; "DMs: Mark all read").
     The markup is server-rendered into BOTH header flyouts and the full /notifications + /messages pages (views/_nx_bar.php
     inside the .nx wrapper of _notif_list.php / _inbox_list.php), so everything here is DELEGATED and survives the flyout
     re-rendering its body. A chip re-fetches the whole .nx block (data-src + &f=); Select mode turns rows into checkable
     items (a CAPTURE click handler, so neither the row's link nor the DM flyout's open-thread handler ever sees the tap);
     the actions are POST /inbox/act (routes/inbox.php), which answers the fresh badges. ---- */
  (function () {
    /* THE PILL ROW OPENS SCROLLED FULLY LEFT (Rob 2026-10-22, batch item 21, phone web bell flyout: it "opens scrolled to the
       MIDDLE; it must open scrolled fully left with All visible"). A row whose chosen pill is the FIRST one (All) sits at
       scrollLeft 0; any other chosen pill is brought into view only when it is not already fully visible (12 px lead-in).
       Re-asserted on the next two frames and after the flyout's open motion (360 ms), because a horizontal scroller laid out
       while its panel is still animating in (and its scroll-snap) can settle somewhere else. Called by the flyout load()
       above, by a chip re-fetch below and once for the full /notifications + /messages pages. */
    function nxHome(root) {
      var rows = root ? (root.matches && root.matches('.nx-chips') ? [root] : root.querySelectorAll('.nx-chips')) : [];
      Array.prototype.forEach.call(rows, function (chips) {
        var place = function () {
          if (!chips.isConnected) return;
          var on = chips.querySelector('.nx-chip.on'), first = chips.querySelector('.nx-chip');
          if (!on || on === first) { chips.scrollLeft = 0; return; }
          var cr = chips.getBoundingClientRect(), r = on.getBoundingClientRect();
          if (r.left >= cr.left && r.right <= cr.right - 22) return;          // already fully visible (22 = the fade mask)
          chips.scrollLeft = Math.max(0, chips.scrollLeft + (r.left - cr.left) - 12);
        };
        place();
        if (window.requestAnimationFrame) { requestAnimationFrame(function () { place(); requestAnimationFrame(place); }); }
        setTimeout(place, 360);
      });
    }
    window.__rovaNxHome = nxHome;
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { nxHome(document); }); }
    else { nxHome(document); }
    function nxOf(el) { return (el && el.closest) ? el.closest('.nx[data-nx]') : null; }
    function nxRows(nx) { return Array.prototype.slice.call(nx.querySelectorAll('.notif-list > .notif')); }
    function nxIsDm(nx) { return nx.getAttribute('data-nx') === 'dm'; }
    function nxRowId(nx, row) { return String(row.getAttribute(nxIsDm(nx) ? 'data-uid' : 'data-nid') || ''); }
    function nxPost(data) {
      var mk = function () {
        var fd = new FormData();
        Object.keys(data).forEach(function (k) {
          var v = data[k];
          if (Array.isArray(v)) { v.forEach(function (x) { fd.append(k + '[]', x); }); } else { fd.append(k, v); }
        });
        return fd;
      };
      return csrfSend(function (token) {
        return fetch('/inbox/act', { method: 'POST', body: mk(), credentials: 'same-origin',
          headers: { 'X-CSRF-Token': token, 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' } });
      }).then(function (r) {
        if (r.status === 419) { csrfStaleNotice(); throw new Error('reauth'); }
        return r.json().then(function (d) {
          if (!r.ok || !d || d.ok === false) { var er = new Error((d && d.error) || 'failed'); er.data = d; er.status = r.status; throw er; }
          return d;
        });
      });
    }
    window.__rovaInboxAct = nxPost;   // the DM translate / live-mute handlers below ride the same door
    function nxBadges(d) {
      if (!d) return;
      var set = function (id, n) { var el = document.getElementById(id); if (!el || typeof n !== 'number') return; if (n > 0) { el.textContent = n > 9 ? '9+' : n; el.hidden = false; } else { el.hidden = true; } };
      set('bell-badge', d.notif); set('dm-badge', d.dm);
    }
    function nxCount(nx) {
      var rows = nxRows(nx), on = rows.filter(function (r) { return r.classList.contains('nx-on'); }).length;
      var c = nx.querySelector('.nx-count'); if (c) c.textContent = on + ' selected';
      var all = nx.querySelector('.nx-allbox');
      if (all) { all.checked = rows.length > 0 && on === rows.length; all.indeterminate = on > 0 && on < rows.length; }
      Array.prototype.forEach.call(nx.querySelectorAll('.nx-selbar [data-act]'), function (b) { b.disabled = on === 0; });
    }
    function nxSelect(nx, on) {
      nx.classList.toggle('selecting', !!on);
      var bar = nx.querySelector('.nx-selbar'); if (bar) bar.hidden = !on;
      nxRows(nx).forEach(function (r) {
        var ck = r.querySelector(':scope > .nx-ck');
        if (on && !ck) { r.insertAdjacentHTML('afterbegin', '<span class="nx-ck" aria-hidden="true"><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg></span>'); }
        if (!on) { if (ck) ck.remove(); r.classList.remove('nx-on'); r.removeAttribute('aria-selected'); }
        else { r.setAttribute('aria-selected', r.classList.contains('nx-on') ? 'true' : 'false'); }
      });
      nxCount(nx);
    }
    function nxLoad(nx, f) {
      var src = nx.getAttribute('data-src') || ''; if (!src) return;
      var panel = nx.closest('.hdrop-panel'); if (panel) panel.setAttribute('data-nxf', f);
      Array.prototype.forEach.call(nx.querySelectorAll('.nx-chip'), function (c) {
        var on = c.getAttribute('data-f') === f; c.classList.toggle('on', on); c.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      nx.classList.add('nx-busy');
      rfetch(src + (src.indexOf('?') >= 0 ? '&' : '?') + 'f=' + encodeURIComponent(f),
             { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', cache: 'no-store' }, 8000)
        .then(function (r) { return r.text().then(function (html) { return { r: r, html: html }; }); })
        .then(function (res) {
          if ((res.r.redirected && /\/login(\?|$)/.test(res.r.url || '')) || /^<!doctype/i.test((res.html || '').trim())) { window.location.href = '/login'; return; }
          var t = document.createElement('div'); t.innerHTML = res.html;
          var fresh = t.querySelector('.nx[data-nx]');
          if (!fresh || !nx.parentNode) { nx.classList.remove('nx-busy'); return; }
          nx.parentNode.replaceChild(fresh, nx);
          nxHome(fresh);
        })
        .catch(function () { nx.classList.remove('nx-busy'); toast('Couldn’t load, check your connection'); });
    }
    function nxMarkRead(row) {
      row.classList.remove('unread');
      var dot = row.querySelector('.notif-dot'); if (dot) dot.remove();
      var bb = row.querySelector('.bell-badge'); if (bb) bb.remove();
    }
    function nxAfter(nx, rows, removed) {
      // a row that left the filter (read under "Unread", or deleted) goes; an emptied list re-asks the server for its empty state
      var f = nx.getAttribute('data-f') || 'all';
      rows.forEach(function (r) { if (removed || f === 'unread') { dissolve(r, true); } });
      setTimeout(function () { if (nx.isConnected && !nxRows(nx).length) nxLoad(nx, f); else if (nx.isConnected) nxCount(nx); }, DISSOLVE_MS + 30);
    }
    function nxAct(nx, act, btn) {
      var all = /_all$/.test(act);
      var sel = all ? [] : nxRows(nx).filter(function (r) { return r.classList.contains('nx-on'); });
      var ids = sel.map(function (r) { return nxRowId(nx, r); }).filter(Boolean);
      if (!all && !ids.length) return;
      var destructive = act === 'notif_delete' || act === 'dm_clear';
      var go = function () {
        if (btn) btn.disabled = true;
        nxPost({ act: act, ids: ids }).then(function (d) {
          var rows = all ? nxRows(nx) : sel;
          if (!destructive) rows.forEach(nxMarkRead);
          nxBadges(d);
          if (window.__rovaRefreshCounts) window.__rovaRefreshCounts();
          nxSelect(nx, false);
          var n = all ? 0 : ids.length, dm = nxIsDm(nx);
          toast(destructive ? (dm ? (n === 1 ? 'Conversation deleted' : n + ' conversations deleted') : (n === 1 ? 'Notification deleted' : n + ' notifications deleted'))
                            : (all ? 'All marked as read' : 'Marked as read'));
          nxAfter(nx, destructive ? sel : (all ? rows.filter(function () { return true; }) : sel), destructive);
        }).catch(function (er) {
          if (er && er.message === 'reauth') return;
          toast((er && er.data && er.data.error) || 'Couldn’t do that, try again');
        }).then(function () { if (btn) btn.disabled = false; });
      };
      if (!destructive) { go(); return; }
      var n = ids.length, dm = nxIsDm(nx);
      var src = document.createElement('div');
      src.setAttribute('data-confirm-danger', '');
      src.setAttribute('data-confirm-label', 'Delete');
      src.setAttribute('data-confirm-body', dm
        ? 'They leave your inbox only. The other person keeps the conversation, and it comes back if they write again.'
        : 'They are removed from your notifications.');
      askConfirm(dm ? ('Delete ' + n + ' conversation' + (n === 1 ? '' : 's') + '?') : ('Delete ' + n + ' notification' + (n === 1 ? '' : 's') + '?'), src)
        .then(function (ok) { if (ok) go(); });
    }
    function nxCloseMenus(except) {
      Array.prototype.forEach.call(document.querySelectorAll('.nx-menu:not([hidden])'), function (m) {
        if (m === except) return;
        m.hidden = true; var b = m.parentNode && m.parentNode.querySelector('.nx-more'); if (b) b.setAttribute('aria-expanded', 'false');
      });
    }

    /* SELECT MODE OWNS THE ROW. Capture phase on the document, so this runs before the row's own link, the follow-back
       form, the DM flyout's open-thread handler and the /messages page's row handler -- none of them sees the tap. */
    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      var nx = e.target.closest('.nx.selecting'); if (!nx) return;
      var row = e.target.closest('.notif'); if (!row || !nx.contains(row) || !row.parentNode.classList.contains('notif-list')) return;
      e.preventDefault(); e.stopPropagation();
      var on = !row.classList.contains('nx-on');
      row.classList.toggle('nx-on', on); row.setAttribute('aria-selected', on ? 'true' : 'false');
      nxCount(nx);
    }, true);

    /* TAPPING AN UNREAD NOTIFICATION READS IT (the bell no longer marks everything read on open, db/0320): fire-and-forget,
       keepalive so it survives the navigation the same tap starts. Capture, so it is recorded even when the row's link
       navigates away first. */
    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      var row = e.target.closest('.nx[data-nx="notif"]:not(.selecting) .notif.unread[data-nid]'); if (!row) return;
      if (e.target.closest('.notif-follow')) return;   // Follow back is an action ON the row, not reading it
      var id = row.getAttribute('data-nid');
      nxMarkRead(row);
      try {
        var fd = new FormData(); fd.append('act', 'notif_read'); fd.append('ids[]', id);
        fetch('/inbox/act', { method: 'POST', body: fd, credentials: 'same-origin', keepalive: true,
          headers: { 'X-CSRF-Token': csrf, 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' } }).catch(function () {});
      } catch (_) {}
    }, true);

    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      var t = e.target;
      var chip = t.closest('.nx-chip');
      if (chip) { var nx0 = nxOf(chip); if (nx0) { e.preventDefault(); if (!chip.classList.contains('on') || nx0.classList.contains('nx-busy')) nxLoad(nx0, chip.getAttribute('data-f') || 'all'); } return; }
      var selb = t.closest('.nx-select');
      if (selb) { var nx1 = nxOf(selb); if (nx1) { e.preventDefault(); nxCloseMenus(null); nxSelect(nx1, true); } return; }
      var done = t.closest('.nx-done');
      if (done) { var nx2 = nxOf(done); if (nx2) { e.preventDefault(); nxSelect(nx2, false); } return; }
      var more = t.closest('.nx-more');
      if (more) {
        e.preventDefault();
        var m = more.parentNode.querySelector('.nx-menu');
        if (m) { var open = m.hidden; nxCloseMenus(m); m.hidden = !open; more.setAttribute('aria-expanded', open ? 'true' : 'false'); }
        return;
      }
      var ab = t.closest('.nx-selbar [data-act], .nx-menu [data-act]');
      if (ab) { var nx3 = nxOf(ab); if (nx3) { e.preventDefault(); nxCloseMenus(null); nxAct(nx3, ab.getAttribute('data-act'), ab); } return; }
      if (!t.closest('.nx-menu')) nxCloseMenus(null);
    });
    document.addEventListener('change', function (e) {
      var box = e.target;
      if (!box || !box.classList || !box.classList.contains('nx-allbox')) return;
      var nx = nxOf(box); if (!nx) return;
      nxRows(nx).forEach(function (r) { r.classList.toggle('nx-on', box.checked); r.setAttribute('aria-selected', box.checked ? 'true' : 'false'); });
      nxCount(nx);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var nx = document.querySelector('.nx.selecting'); if (nx) nxSelect(nx, false);
      nxCloseMenus(null);
    });
  })();

  /* ---- DM TRANSLATE + COPY + LIVE-INVITE MUTE (WS-B 2026-10-22) ----
     TRANSLATE (Rob item 8): the server detects the OTHER person's message language (m.lang); a small "Translate" sits under a
     bubble whose language differs from this reader's (navigator.language). The tap asks POST /inbox/act dm_translate (cached
     per message + language on the server, rate limited; never auto-translated) and swaps the bubble text, with "Show original"
     to swap back. COPY (Rob item 9): window.__rovaCopyText, used by the hold / right-click menu. */
  (function () {
    var reader = String(navigator.language || 'en').toLowerCase().split('-')[0] || 'en';
    window.__rovaDmCanTranslate = function (lang) {
      var l = String(lang || '').toLowerCase();
      return (l && l !== 'zxx' && l !== 'und' && l !== reader) ? l : '';
    };
    var NAMES = { es: 'Spanish', fr: 'French', de: 'German', pt: 'Portuguese', it: 'Italian', nl: 'Dutch', ru: 'Russian', ja: 'Japanese',
      ko: 'Korean', zh: 'Chinese', ar: 'Arabic', hi: 'Hindi', tr: 'Turkish', pl: 'Polish', vi: 'Vietnamese', th: 'Thai', id: 'Indonesian',
      uk: 'Ukrainian', sv: 'Swedish', tl: 'Tagalog', fa: 'Persian', he: 'Hebrew', el: 'Greek', ro: 'Romanian', en: 'English' };
    window.__rovaCopyText = function (s) {
      var ok = function () { toast('Copied'); };
      var legacy = function () {
        try {
          var ta = document.createElement('textarea'); ta.value = s; ta.setAttribute('readonly', '');
          ta.style.cssText = 'position:fixed;top:0;left:0;opacity:0;pointer-events:none';
          document.body.appendChild(ta); ta.select(); ta.setSelectionRange(0, ta.value.length);
          var done = document.execCommand && document.execCommand('copy'); ta.remove();
          if (done) ok(); else toast('Couldn’t copy');
        } catch (_) { toast('Couldn’t copy'); }
      };
      try { if (navigator.clipboard && window.isSecureContext) { navigator.clipboard.writeText(s).then(ok, legacy); return; } } catch (_) {}
      legacy();
    };
    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('.msg .msg-tr') : null;
      if (!b) return;
      e.preventDefault(); e.stopPropagation();   // never a tap toward the double-tap heart
      var msg = b.closest('.msg'), bub = msg ? msg.querySelector('.bubble') : null;
      if (!msg || !bub || b.getAttribute('data-busy') === '1') return;
      if (b.getAttribute('data-done') === '1') {   // toggle back and forth without asking again
        var showingTr = bub.getAttribute('data-tr-on') === '1';
        var keep = bub.innerHTML;
        bub.innerHTML = showingTr ? (bub._trOrig || keep) : (bub._trHtml || keep);
        bub.setAttribute('data-tr-on', showingTr ? '0' : '1');
        b.textContent = showingTr ? 'See translation' : 'Show original';
        return;
      }
      var mid = msg.getAttribute('data-mid'); if (!mid || +mid <= 0) return;
      b.setAttribute('data-busy', '1'); b.textContent = 'Translating…';
      window.__rovaInboxAct({ act: 'dm_translate', id: mid, lang: reader }).then(function (d) {
        if (!d.text) { b.remove(); toast(d.code === 'same_language' ? 'Already in your language' : 'Nothing to translate'); return; }
        bub._trOrig = bub.innerHTML;
        bub.setAttribute('data-orig-text', String(bub.innerText || bub.textContent || '').trim());
        bub._trHtml = escHtml(String(d.text)).replace(/\n/g, '<br>');
        bub.innerHTML = bub._trHtml; bub.setAttribute('data-tr-on', '1');
        b.setAttribute('data-done', '1');
        b.textContent = 'Show original';
        b.setAttribute('title', 'Translated from ' + (NAMES[d.lang] || String(d.lang || '').toUpperCase()));
      }).catch(function (er) {
        b.textContent = 'Translate';
        if (er && er.message !== 'reauth') toast((er.data && er.data.error) || 'Translation is unavailable right now.');
      }).then(function () { b.removeAttribute('data-busy'); });
    }, true);
    // "Mute live invites" in a DM thread's "..." menu (db/0320): that person's live shares + host invites stop reaching me
    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('.dm-live-mute') : null;
      if (!b) return;
      e.preventDefault();
      var uid = parseInt(b.getAttribute('data-with'), 10) || 0; if (!uid || !window.__rovaInboxAct) return;
      var on = b.getAttribute('data-on') !== '1', who = b.getAttribute('data-name') || 'them';
      var pp = b.closest('.dm-menu-pop'); if (pp) pp.hidden = true;
      window.__rovaInboxAct({ act: 'live_mute', user_id: uid, on: on ? 1 : 0 }).then(function (d) {
        var now = !!d.muted;
        b.setAttribute('data-on', now ? '1' : '0'); b.textContent = now ? 'Unmute live invites' : 'Mute live invites';
        toast(now ? ('Live invites from ' + who + ' are muted') : ('Live invites from ' + who + ' are back on'));
      }).catch(function (er) { if (er && er.message !== 'reauth') toast('Couldn’t change that, try again'); });
    });
  })();

  /* ---- confirm before destructive submits ------------------------------ */
  /* THE DISSOLVE, AND ITS UNDO.
     fadeRemove() below is one-way: it overwrites two inline properties and detaches the node.
     That is all a grid-hide or a mute sweep needs, because those only run once the server has
     already agreed. An OPTIMISTIC delete needs the other half -- the row leaves before anyone
     knows whether the server will take it, so a refusal has to put it back exactly where it was,
     with the styles it had. dissolve() records the anchor (parent + the node that FOLLOWED it,
     which is the only stable description of a position in a list that may shift underneath) and
     the element's whole `style` attribute, and hands back a restore().
     COLLAPSE IS A SEPARATE QUESTION FROM FADE, and the answer differs per surface:
       - a feed/profile CARD is a block in a column. Fading it to 0 leaves a full-height hole for
         190ms and then snaps the list shut when the node detaches -- two motions, the second one
         a jump. Its height (and the margins/padding that make up the rest of its box) animate to
         0 alongside the fade, so the list closes over it in one movement.
       - a GRID TILE is not. .pcell is a grid item; its track closes when the item is removed, and
         animating the tile's height first only squashes the photo inside it. Tiles pass false.
     The height has to be pinned to its measured pixel value and flushed before the transition is
     armed: a transition from `auto` animates nothing at all, which is how you get a fade with a
     hole in it that snaps. */
  var DISSOLVE_MS = 190;
  // v: post id -> ms it was removed; u: author uid -> ms their posts were hidden (the thumbs-down mute).
  // On window because the tab pager that reads it lives in a different function scope.
  var FEED_GONE = window.__rovaFeedGone = window.__rovaFeedGone || { v: {}, u: {} };
  /* d: post id -> ms it was DELETED (2026-10-09, Rob: "should be deleted in real time from the grid also").
     Kept apart from `v` on purpose: `v` also holds grid-HIDDEN posts (still live in feeds), so it can only
     police kept panels. `d` is the stronger fact, and every BUFFERED source of rows asks it before it
     inserts: a page fetched before the delete (the profile grid's read-ahead page, the card feeds'
     load-more, the idle-roll queue) and the home grid's own buffer, pool and bench (gridCycle). The dissolve
     only ever reaches nodes that are IN the document; a row sitting in one of those buffers came straight
     back on the next scroll -- reproduced live on /@handle?tab=grid. Written by ajaxDeletePost, un-written
     when a failed delete puts the rows back. */
  FEED_GONE.d = FEED_GONE.d || {};
  window.__rovaPostGone = function (el) {
    if (!el || !el.getAttribute) { return false; }
    var a = el.getAttribute('data-view'), b = el.getAttribute('data-id');
    return !!((a && FEED_GONE.d[a]) || (b && FEED_GONE.d[b]));
  };
  function dissolve(el, collapse) {
    if (!el || !el.parentNode) { return function () {}; }
    var parent = el.parentNode, next = el.nextSibling, prevStyle = el.getAttribute('style');
    /* THE FEED'S "GONE" LEDGER (2026-09-29, feed rows are never replaced without the member asking).
       The tab pager now KEEPS a tab's rows when the member leaves it (a snapshot, restored as-is on the
       way back -- see setupTabPager's PANEL CACHE), so a post removed here must also leave the copies
       that are not in the document right now. This is the one removal primitive every "this post is
       gone" path funnels through (delete, grid-hide, hide-author), so the post is recorded here with a
       timestamp and a restored panel drops it; the restore() below un-records it when a failed delete
       brings the card back. */
    var goneId = (el.getAttribute('data-view') || (el.classList && el.classList.contains('pcell') ? el.getAttribute('data-id') : '')) || '';
    if (goneId) { FEED_GONE.v[goneId] = Date.now(); }
    var tr = 'opacity .18s ease, transform .18s ease';
    if (collapse) {
      el.style.height = el.offsetHeight + 'px';
      el.style.overflow = 'hidden';
      void el.offsetHeight;                    // flush: the transition needs a start value, not `auto`
      tr += ', height .19s ease, margin .19s ease, padding .19s ease';
    }
    el.style.transition = tr;
    el.style.opacity = '0';
    el.style.transform = 'scale(.97)';
    if (collapse) {
      el.style.height = '0px';
      el.style.marginTop = '0px'; el.style.marginBottom = '0px';
      el.style.paddingTop = '0px'; el.style.paddingBottom = '0px';
    }
    var timer = setTimeout(function () { if (el.parentNode && !(window.__rovaGasHole && window.__rovaGasHole(el))) { el.parentNode.removeChild(el); } }, DISSOLVE_MS);   // GRID AUTHOR SPACING: a home-grid hole may be filled in place
    return function restore() {
      clearTimeout(timer);
      if (goneId) { delete FEED_GONE.v[goneId]; }
      if (el._gasFiller && el._gasFiller.parentNode === parent && !el.parentNode) { parent.replaceChild(el, el._gasFiller); }   // a filled hole: the post comes back where it was
      el._gasFiller = null;
      if (!el.parentNode) {
        // `next` may itself have been removed while we were away (another delete, a feed
        // refresh); falling back to the end of the same container beats not coming back.
        if (next && next.parentNode === parent) { parent.insertBefore(el, next); }
        else { parent.appendChild(el); }
      }
      if (prevStyle === null) { el.removeAttribute('style'); } else { el.setAttribute('style', prevStyle); }
    };
  }
  function fadeRemove(el, done) {
    if (!el) { if (done) done(); return; }
    dissolve(el, false);
    if (done) { setTimeout(done, DISSOLVE_MS); }
  }
  /* THE DESTRUCTIVE GATE IS OUR OWN SHEET, NOT window.confirm().
     web bug #51: a member deleted four posts in 18 seconds -- four native confirm() dialogs in a row --
     and from then on the Delete item was dead. Not slow, not erroring: nothing at all, no request in the
     access log, no console error (their beacon caught console_errors: []). That is precisely what a
     browser's repeated-dialog suppression looks like. Safari (and Chrome, and Firefox) offer "Don't show
     more alerts from this webpage" from the SECOND dialog onwards, and once it is on, confirm() returns
     FALSE instantly and forever for that page -- so the handler below took its "user said no" branch and
     silently swallowed every subsequent click. A burst of deletes is exactly the workflow that arms it,
     which is why the button worked four times and then never again.
     glassConfirm() is the site's own sheet (already used for unfollow): it cannot be suppressed, it can't
     be mistaken for the browser, and it gives the destructive action a real label. Being async, we must
     preventDefault FIRST and re-submit afterwards -- data-confirmed lets that second pass through, and
     requestSubmit(e.submitter) preserves the submitting button's name/value, so every other js-confirm
     form (admin, settings, moderation) keeps its exact previous full-page-POST behaviour. */
  /* `src` (optional) is the element carrying the question -- a .js-confirm form. Three more
     attributes ride beside data-confirm (2026-10-02, the CSP sweep that retired every inline
     onsubmit/onclick="return confirm(...)": script-src has no 'unsafe-inline' / 'unsafe-hashes',
     so those handlers never ran and the actions went through UNASKED):
       data-confirm-body    a second, quieter line under the question
       data-confirm-danger  the action button is the red one (destructive)
       data-confirm-label   the action button's text (else Delete / Remove / Confirm from the wording) */
  function askConfirm(msg, src) {
    var at = function (n) { return (src && src.getAttribute) ? (src.getAttribute(n) || '') : ''; };
    var body = at('data-confirm-body');
    var danger = !!(src && src.hasAttribute && src.hasAttribute('data-confirm-danger'));
    if (typeof glassConfirm !== 'function') { return Promise.resolve(!!window.confirm(body ? msg + '\n\n' + body : msg)); }
    var label = at('data-confirm-label') || (/\bdelete\b/i.test(msg) ? 'Delete' : (/\bremove\b/i.test(msg) ? 'Remove' : 'Confirm'));
    return glassConfirm({ title: msg, body: body || undefined, actions: [{ label: label, value: 'yes', style: danger ? 'danger' : 'primary' }] })
      .then(function (v) { return v === 'yes'; });
  }

  // Delete: do it over AJAX and drop the card immediately, instead of a full
  // page POST + reload (which felt slow / like it hadn't worked).
  function ajaxDeletePost(f) {
    if (f.getAttribute('data-deleting') === '1') return;
    f.setAttribute('data-deleting', '1');
    closePmenus();
    var card = f.closest('.post');
    var pid = ((f.querySelector('input[name="post_id"]') || {}).value) || (card && card.getAttribute('data-view')) || '';
    /* WHAT IS LEFT BEHIND US, counted on the PAGE ONLY (web bug #51, second cause).
       This used to be document.querySelectorAll('.post').length -- every card in the document,
       INCLUDING the immersive viewer's own copies. Delete from the viewer (the normal way to
       delete a photo: tap it, ⋯, Delete) and that count is always >1 because the overlay has a
       card per loaded post, so the "more posts on the page" branch always won: it faded the
       OVERLAY's copy and nothing else. The page's own card for the same post stayed fully
       visible behind the overlay -- so closing the viewer showed the post you had just deleted,
       and pressing Delete on it again got the honest "That post couldn't be deleted. It may
       already be gone" from the server. Verified live: profile card list AND a /p/<id> permalink,
       desktop and 420x912.
       So: count only the anchors a member would still see once THIS post's nodes go -- cards
       outside .pfeed plus grid cells -- and treat the overlay's cards as what they are, copies. */
    var others = 0;
    document.querySelectorAll('.post[data-view], .pcell[data-id]').forEach(function (n) {
      if (n.closest('.pfeed')) { return; }                                        // viewer copy, not the page
      var nid = n.getAttribute('data-view') || n.getAttribute('data-id') || '';
      if (pid && nid === String(pid)) { return; }                                 // about to be removed below
      others++;
    });
    /* THE ROW LEAVES NOW; THE SERVER IS TOLD IN THE BACKGROUND (owner, 2026-08-10: "it took a
       second to remove... maybe because it was waiting for confirmation from the server. The post
       should dissolve animate out immediately and the server delete can happen in the background").
       He is right about the mechanism -- everything below used to sit inside this request's .then --
       and about the size of it. Measured on this endpoint since MediaPurge landed on 2026-08-06:
       p50 345ms, p90 2127ms, worst 39943ms. That last one is a real member on /@grindhd on 08-10
       watching a post they had deleted sit on screen for forty seconds. The cost is inherent, not a
       regression to chase: Posts::delete() erases the media from disk AND from R2 before it answers,
       and those round trips are the wait. Nothing about that work needs a member watching it.
       Drop EVERY node that shows this post, not just the one that was tapped: the profile / home
       GRID cell(s), so returning to the grid (it sits behind the immersive viewer you deleted from)
       shows it gone, AND every other card for the same id -- the page's own copy when the delete
       came from the viewer on top of it, the viewer's copy when it came from the page, and every
       REPOST row, which lands here for free because _post.php gives a pure repost the ORIGINAL's
       id in data-view. One post, one id, all of it goes. */
    /* WHO COLLAPSES. Only a card that is a row in a COLUMN, which is what makes the gap-then-snap
       worth animating away. Two kinds of node here are not:
         - .pcell grid tiles, which are grid items whose track closes on removal (see dissolve);
         - any card inside .pfeed, the immersive viewer. That is a full-screen snap pager and its
           cards are SLIDES, not rows -- there is nothing above or below to close over the gap, so
           collapsing one only shrinks a slide in place before it goes. It fades, like a tile. */
    var canCollapse = function (n) { return !n.closest('.pfeed'); };
    var restores = [];
    if (pid) {
      document.querySelectorAll('.pcell[data-id="' + pid + '"]').forEach(function (c) { restores.push(dissolve(c, false)); });
      document.querySelectorAll('.post[data-view="' + pid + '"]').forEach(function (p) {
        if (p !== card) { restores.push(dissolve(p, canCollapse(p))); }
      });
    }
    // The tapped card collapses only if the page will still have something to show; when it is the
    // whole page (a permalink, or the last post) we are navigating away and a collapse is wasted.
    if (card) { restores.push(dissolve(card, others > 0 && canCollapse(card))); }
    /* TELL THE VIEWER AND THE PROFILE, which the node sweep above cannot reach.
       The dissolves take every card and tile that is ON THE PAGE. Two things holding this post are
       not nodes: the immersive viewer's own deck (an array of ids plus a two-minute HTML cache --
       see __rovaPfDrop, which is why that exists), and the profile photo's data-photo-album, the
       comma list this member's avatar tap re-opens the album from. Leave either alone and the id
       comes back the next time one of them is read: the deck on a swipe back up, the album on the
       very next tap of the profile picture.
       This runs on the OPTIMISTIC path, before the server has answered, exactly like the dissolves
       -- and unlike them it is not wound back on a failure. Deliberate: both are caches of an
       ordering, not the post itself. A restored card is still rendered from the server's own HTML,
       and the album attribute is re-emitted in full on the next profile load. Re-adding an id to a
       deck the member has already swiped past is worse than dropping one they can get back by
       reopening. */
    if (pid) {
      FEED_GONE.d[String(pid)] = Date.now();   // every buffered page / pool / bench now refuses it (see FEED_GONE.d)
      if (window.__rovaPfDrop) { try { window.__rovaPfDrop(pid); } catch (e) {} }
      document.querySelectorAll('.pf-avatar[data-photo-album]').forEach(function (pfa) {
        var ids = (pfa.getAttribute('data-photo-album') || '').split(',').filter(function (v) {
          return v && v !== String(pid);
        });
        pfa.setAttribute('data-photo-album', ids.join(','));
      });
    }

    deleteWithRetry(new FormData(f)).then(function (res) {
      // Nothing left to show on this page (a /p/<id> permalink, or the last card): the nodes have
      // already gone, so this is only about where to send them next.
      if (others > 0) { return; }
      if (res && res.redirect) { window.location = res.redirect; }
      else { window.location.reload(); }
    }).catch(function (err) {
      /* THE FAILURE PATH IS THE WHOLE RISK OF DOING THIS OPTIMISTICALLY. The post is still live and
         the member believes it is gone -- worse than the wait we just removed, because they will not
         find out until somebody replies to it. So: put every node back where it was, re-arm the
         button, and say plainly that the post is STILL THERE. Never silent, never left removed. */
      restores.forEach(function (r) { try { r(); } catch (e) {} });
      if (pid) { delete FEED_GONE.d[String(pid)]; }
      f.removeAttribute('data-deleting');
      if (err && err.message === 'reauth') { return; }   // csrfStaleNotice() / the reload already spoke
      toast((err && err.message) || 'Could not delete that post, it is still there.');
    });
  }

  /* THE NETWORK HALF. Bounded retry, because the request is now unattended: with a member watching a
     spinner, one failure could be handed straight back to them and they would tap again. Nobody is
     watching this one, and the flaky-signal case the app's api.js was built around ("my cell signal
     here is intermittent") applies just as much to a phone browser.
     WHAT IS WORTH RETRYING, and what is not:
       - a lost connection, a 5xx, a non-JSON error page: transient. postJson() rejects for all three
         (a 5xx from IIS is an HTML page, so it fails the content-type check at :1564). Up to three
         attempts, backing off, and DELETE is safe to repeat -- the second one finds the post already
         gone, which the endpoint now reports as success rather than as a refusal (handle_post_delete).
       - `reauth` (419/401): terminal. The page is already being put right by csrfSend/csrfStaleNotice
         and a retry would only spend another refused token.
       - the server's own ok:false: terminal, and it is the ANSWER, not a fault. Retrying a refusal
         cannot change it; its sentence is what the member is shown.
     THIS REPLACES `.catch(function () { f.submit(); })`. That fallback (a real full-page form POST,
     which does still delete) cannot survive the change above: the row is already gone from the DOM,
     so a navigation would either paint a fresh page over an optimistic state nobody can reconcile,
     or -- if the POST is what failed -- reload the member onto the post they think they deleted with
     no explanation. Three bounded attempts do the same job without leaving the page. */
  function deleteWithRetry(fd, attempt) {
    attempt = attempt || 0;
    return postJson('/post/delete', fd).then(function (res) {
      if (res && res.ok) { return res; }        // includes the idempotent `gone:true` success
      throw new Error((res && res.error) || 'That post could not be deleted.');
    }, function (e) {
      if (e && e.message === 'reauth') { throw e; }
      if (attempt < 2) {
        return new Promise(function (go) { setTimeout(go, 400 * (attempt + 1)); })
          .then(function () { return deleteWithRetry(fd, attempt + 1); });
      }
      throw new Error('Couldn’t reach the server. That post has NOT been deleted, try again.');
    });
  }

  /* "Hide from my profile grid" / "Show on my profile grid" (migration 0119).
     NOT modelled on ajaxDeletePost, and the difference is the whole point: a deleted post is gone
     everywhere, so that function strips every node carrying the id. A grid-hidden post is still live
     in feeds, search and on its permalink, so the ONLY nodes that may disappear are the ones that are
     the profile grid itself -- .pcell tiles, and the cards on a /@handle page. Fading a feed card here
     would tell the member their post had been withdrawn, which is not what they asked for and not what
     happened. No confirm sheet either: this is reversible from the same menu and from Settings. */
  function ajaxGridHide(f) {
    if (f.getAttribute('data-busy') === '1') return;
    f.setAttribute('data-busy', '1');
    // Spin the menu row for the flight and close the menu on SETTLE, not on tap: closing it
    // up front left a slow link with no cue at all between the tap and the toast. On a good
    // link the response lands in tens of ms, so the menu lingering is imperceptible.
    var rowBtn = f.querySelector('button');
    var unbusy = busyStart(rowBtn) || function () {};
    var actIn = f.querySelector('input[name="action"]');
    var restoring = actIn && actIn.value === 'restore';
    var pid = ((f.querySelector('input[name="post_id"]') || {}).value) || '';
    postJson('/post/grid-hide', new FormData(f), 15000).then(function (res) {
      f.removeAttribute('data-busy');
      unbusy();
      closePmenus();
      if (!res || !res.ok) { toast((res && res.error) || 'Could not update that post'); return; }
      // flip the control in place so reopening the menu offers the opposite action
      if (actIn) { actIn.value = restoring ? 'hide' : 'restore'; }
      var btn = f.querySelector('button');
      if (btn) { btn.textContent = restoring ? 'Hide from my profile grid' : 'Show on my profile grid'; }
      var onProfile = location.pathname.indexOf('/@') === 0;
      if (pid && !restoring) {
        document.querySelectorAll('.pcell[data-id="' + pid + '"]').forEach(function (c) { fadeRemove(c); });
        if (onProfile) {
          document.querySelectorAll('.post[data-view="' + pid + '"]').forEach(function (p) { fadeRemove(p); });
        }
      }
      toast(restoring
        ? 'Back on your profile grid'
        : 'Hidden from your grid. It\'s still in feeds and search. Restore it under your grid, or in Settings.');
      if (restoring && onProfile) { setTimeout(function () { window.location.reload(); }, 900); }
    }).catch(function () { unbusy(); f.submit(); });   // network hiccup -> normal submit (still works)
  }

  document.addEventListener('submit', function (e) {
    var gh = e.target;
    if (gh.classList && gh.classList.contains('js-gridhide')) {
      e.preventDefault();
      ajaxGridHide(gh);
      return;
    }
  }, true);

  /* PER-TILE GRID CURATION (0119, owner 2026-08-03: "allow people to hide media from the grid or unhide
     it"). The same POST /post/grid-hide the "..." menu and the Settings list already use -- no second
     endpoint -- driven from a small control on the tile itself (.pcell-gc, emitted by
     views/_profile_posts.php for the profile's OWNER on the grid tab only).

     OPTIMISTIC, per the site's convention that a tap never waits on the network. Hiding MOVES the real
     tile node into the "Hidden from your grid" strip below rather than deleting and re-rendering it: the
     thumb is already decoded, so it lands instantly, and the member sees exactly where the post went,
     which is what makes un-hiding findable at all. A failure moves it back to the position it came from.

     RESTORING RELOADS instead of moving the node back up. The server owns grid order -- manual grid
     ordering is coming and a restored tile's slot will not be "wherever it used to be" or "the top" -- so
     the client must not guess. The tile leaves the strip immediately (the tap is still not waiting) and
     the grid re-renders behind the toast. */
  function gcStripSync() {
    var strip = document.getElementById('grid-hidden');
    if (!strip) { return; }
    var n = strip.querySelectorAll('.ghidden-grid .pcell').length;
    var lab = strip.querySelector('.ghidden-n');
    if (lab) { lab.textContent = String(n); }
    if (n > 0) { strip.removeAttribute('hidden'); } else { strip.setAttribute('hidden', ''); }
  }

  function gcRun(ctrl) {
    if (ctrl.getAttribute('data-busy') === '1') { return; }
    var pid = ctrl.getAttribute('data-id') || '';
    var hiding = ctrl.getAttribute('data-act') !== 'restore';
    var cell = ctrl.closest ? ctrl.closest('.pcell') : null;
    if (!pid || !cell) { return; }
    ctrl.setAttribute('data-busy', '1');

    var strip = document.getElementById('grid-hidden');
    var bay = strip ? strip.querySelector('.ghidden-grid') : null;
    var home = cell.parentNode, after = cell.nextSibling;   // where to put it back if the server says no

    if (hiding && bay) {
      bay.insertBefore(cell, bay.firstChild);   // newest-hidden first, matching gridHiddenFor()'s order
      ctrl.setAttribute('data-act', 'restore');
      ctrl.classList.add('is-restore');
      ctrl.setAttribute('aria-label', 'Put back on your grid');
      ctrl.setAttribute('title', 'Put this back on your grid');
      gcStripSync();
    } else if (hiding) {
      fadeRemove(cell);                          // no strip on the page (should not happen): just let it go
    } else {
      fadeRemove(cell, gcStripSync);
    }

    postJson('/post/grid-hide', { post_id: pid, action: hiding ? 'hide' : 'restore' }).then(function (res) {
      ctrl.removeAttribute('data-busy');
      if (!res || !res.ok) {
        // put the world back the way it was, then say why
        if (hiding && home) {
          home.insertBefore(cell, after);
          ctrl.setAttribute('data-act', 'hide');
          ctrl.classList.remove('is-restore');
          ctrl.setAttribute('aria-label', 'Hide from your grid');
          gcStripSync();
          toast((res && res.error) || 'Could not hide that post');
        } else {
          toast((res && res.error) || 'Could not restore that post');
          setTimeout(function () { window.location.reload(); }, 600);
        }
        return;
      }
      if (hiding) {
        toast('Off your grid. It still goes out to your followers and can be found in search.');
      } else {
        toast('Back on your grid');
        setTimeout(function () { window.location.reload(); }, 900);
      }
    }).catch(function () {
      ctrl.removeAttribute('data-busy');
      toast('Network hiccup, nothing changed');
      setTimeout(function () { window.location.reload(); }, 600);
    });
  }

  /* The tile is an <a>, and on a multi-media post it is also a carousel that drags on pointerdown
     (.pcell[data-slides]). Swallow both here, in the CAPTURE phase, so the control can never open the
     post or start a swipe -- the same treatment the older .pcell-del badge got. */
  document.addEventListener('pointerdown', function (e) {
    if (e.target.closest && e.target.closest('.pcell-gc')) { e.preventDefault(); e.stopPropagation(); }
  }, true);

  document.addEventListener('click', function (e) {
    var ctrl = e.target.closest ? e.target.closest('.pcell-gc') : null;
    if (!ctrl) { return; }
    e.preventDefault(); e.stopPropagation();
    gcRun(ctrl);
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') { return; }
    var ctrl = e.target && e.target.closest ? e.target.closest('.pcell-gc') : null;
    if (!ctrl) { return; }
    e.preventDefault(); e.stopPropagation();
    gcRun(ctrl);
  }, true);

  /* ======================= ARRANGE YOUR GRID (migration 0129, the WEB half) =======================
   *
   * The owner asked for two different things on purpose: the app gets a hold-to-wiggle gesture like
   * iOS icons, and the web gets "another optimized modern way to rearrange IF THE USER WANTS".
   *
   * WHY THIS IS NOT A WIGGLE. A wiggle is a phone answer to phone constraints -- no keyboard, no
   * hover, no room for a toolbar -- and porting it here would throw away the three things a browser
   * actually has. So: an explicit mode with a toolbar, a NUMBER on every tile, a grab handle, an
   * INSERTION CARET drawn in the gutter where the tile will land, and a complete keyboard grab
   * (Space to pick up, arrows to move, Space to drop, Escape to put back).
   *
   * THE CARET IS THE API. The server's write is `after=<post id>` -- an ANCHOR, not an index -- so a
   * bar drawn between two tiles is a literal picture of the request about to be sent, and the request
   * is built by reading the moved tile's previousElementSibling. There is no index arithmetic on the
   * wire that could drift from what was on screen.
   *
   * THE SERVER OWNS ORDER. Every response carries the current order and it is applied, on success and
   * on failure alike. A 409 stale_anchor is not an error the member caused: it means another tab, the
   * app or a second device moved the grid underneath them, and the fix is to redraw from the array in
   * the response and say so -- never to retry, never to keep a local guess.
   *
   * OPT-IN AND REVERSIBLE. Nothing below runs until #garr-open is pressed, and Done reloads the plain
   * grid partial. views/profile.php emits the bar for the profile's OWNER on the GRID tab only. */

  var garrBar = null;          // #grid-arrange (null on every page that has no bar = every visitor)
  var garrGrid = null;         // the .pgrid currently in arrange mode, or null when the mode is off
  var garrLive = null;         // the visible + polite-live status line
  var garrHeld = null;         // the tile the KEYBOARD is holding, or null
  var garrHeldFrom = -1;       // the index it was picked up from, so Escape can put it back
  var garrBusy = false;        // an enter/exit fetch is in flight
  var garrSeq = 0;             // only the NEWEST save is allowed to redraw the grid (see garrSave)
  var garrDrag = null;         // the live pointer drag, or null
  var garrRaf = 0;             // the drag autoscroll ticker

  function garrCalm() { return !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches); }

  /* Direct children only. querySelectorAll would also find the tiles in the "Hidden from your grid"
     strip if the two ever shared a subtree, and those tiles are NOT on the grid -- gridOrder() does not
     return them, so the server would answer not_found for every one. */
  function garrTiles() {
    var out = [];
    if (!garrGrid) { return out; }
    var k = garrGrid.children;
    for (var i = 0; i < k.length; i++) {
      if (k[i].classList && k[i].classList.contains('pcell')) { out.push(k[i]); }
    }
    return out;
  }

  function garrSay(msg) { if (garrLive) { garrLive.textContent = msg || ''; } }

  /* aria-posinset/aria-setsize are what make a screen reader say "3 of 14" without us writing the
     sentence, and .garr-num is the same fact for eyes. Both are re-stamped after every single move,
     which is also the cheapest possible proof that a reorder actually landed. */
  function garrRenumber() {
    var tiles = garrTiles(), n = tiles.length;
    for (var i = 0; i < n; i++) {
      tiles[i].setAttribute('aria-posinset', String(i + 1));
      tiles[i].setAttribute('aria-setsize', String(n));
      var chip = tiles[i].querySelector('.garr-num');
      if (chip) { chip.textContent = String(i + 1); }
    }
  }

  function garrIndex(tile) {
    var tiles = garrTiles();
    for (var i = 0; i < tiles.length; i++) { if (tiles[i] === tile) { return i; } }
    return -1;
  }

  /* How many tiles share the first row's top edge. Measured rather than read off
     grid-template-columns, so a phone that ever drops to 2 columns still moves up/down by a real row.
     offsetTop, NOT getBoundingClientRect: a picked-up tile carries a scale, and a rect includes it, so
     a held tile in the FIRST ROW read ~4px higher than its neighbours and this counted 2 columns.
     ArrowDown then moved by 2 instead of a row. offsetTop is layout, and layout does not see transforms. */
  function garrCols() {
    var tiles = garrTiles();
    if (!tiles.length) { return 3; }
    var top = tiles[0].offsetTop, n = 0;
    for (var i = 0; i < tiles.length; i++) {
      if (Math.abs(tiles[i].offsetTop - top) > 2) { break; }
      n++;
    }
    return n || 3;
  }

  /* FLIP: measure, move, invert, play. Only the tiles near the viewport are animated (a 600-tile grid
     must not pay for 600 transitions to show a move nobody can see), and reduced motion skips the whole
     thing rather than animating to a zero-length transition. */
  function garrFlip(fn) {
    if (garrCalm()) { fn(); return; }
    var tiles = garrTiles(), first = [], vh = window.innerHeight || 800, i, r;
    for (i = 0; i < tiles.length; i++) {
      r = tiles[i].getBoundingClientRect();
      first.push((r.top > vh + 400 || r.bottom < -400) ? null : r);
    }
    fn();
    var moved = [], held = [];
    for (i = 0; i < tiles.length; i++) {
      // fn() may have REMOVED a tile (the resync drops one the server no longer lists). A detached node
      // measures 0,0 and would be handed a nonsense transform; it is gone, so there is nothing to play.
      if (!first[i] || !tiles[i].parentNode) { continue; }
      var r2 = tiles[i].getBoundingClientRect();
      var dx = first[i].left - r2.left, dy = first[i].top - r2.top;
      if (!dx && !dy) { continue; }
      // the keyboard-held tile keeps its lifted scale through the flight, or it would pop back to 1
      // for the length of the transition and pop out again at the end
      var hold = tiles[i] === garrHeld ? ' scale(1.04)' : '';
      tiles[i].style.transition = 'none';
      tiles[i].style.transform = 'translate(' + dx + 'px,' + dy + 'px)' + hold;
      moved.push(tiles[i]); held.push(hold);
    }
    if (!moved.length) { return; }
    requestAnimationFrame(function () {
      for (var j = 0; j < moved.length; j++) {
        moved[j].style.transition = '';
        moved[j].classList.add('garr-flip');
        moved[j].style.transform = held[j] ? held[j].trim() : '';
      }
      setTimeout(function () {
        for (var k = 0; k < moved.length; k++) {
          moved[k].classList.remove('garr-flip');
          moved[k].style.transform = '';
        }
      }, 240);
    });
  }

  /* Moving a node in the DOM BLURS it. Every reorder therefore has to hand focus back, or a keyboard
     member loses their place on the very first arrow press. */
  function garrKeepFocus(fn) {
    var was = document.activeElement;
    var inside = !!(was && garrGrid && garrGrid.contains(was));
    fn();
    if (inside && was && document.activeElement !== was) {
      try { was.focus({ preventScroll: true }); } catch (e) { try { was.focus(); } catch (e2) {} }
    }
  }

  /* Put the grid in exactly the order the SERVER just named, and in NO other order. This is the whole
     of the 409 resync: `order` rides along on a stale_anchor and it is the truth, so it is drawn as-is.
     A tile the server no longer lists (hidden or deleted on another device between the read and the
     move) is dropped here, which is why this can still redraw a grid that SHRANK underneath the member.
     It gives up, and only gives up, when the server names an id there is no tile for -- a post made
     somewhere else, whose picture this page has never seen. Nothing can be drawn from an id, so the
     caller refetches the whole fragment instead of rendering a convincing half-truth. */
  function garrApplyOrder(ids) {
    if (!garrGrid || !ids || !ids.length) { return false; }
    var tiles = garrTiles(), byId = {}, want = {}, i;
    for (i = 0; i < tiles.length; i++) { byId[String(tiles[i].getAttribute('data-id'))] = tiles[i]; }
    for (i = 0; i < ids.length; i++) {
      if (!byId[String(ids[i])]) { return false; }        // an id with no tile: cannot be drawn
      want[String(ids[i])] = 1;
    }
    var gone = [];
    for (i = 0; i < tiles.length; i++) {
      if (!want[String(tiles[i].getAttribute('data-id'))]) { gone.push(tiles[i]); }
    }
    var same = gone.length === 0 && ids.length === tiles.length;
    if (same) {
      for (i = 0; i < ids.length; i++) { if (tiles[i] !== byId[String(ids[i])]) { same = false; break; } }
    }
    if (!same) {
      // a tile about to be removed must not take the keyboard's place (or its grab) with it
      if (garrHeld && gone.indexOf(garrHeld) >= 0) {
        garrHeld.classList.remove('garr-held'); garrHeld = null; garrHeldFrom = -1;
      }
      var refocus = gone.indexOf(document.activeElement) >= 0;
      garrKeepFocus(function () {
        garrFlip(function () {
          for (var g = 0; g < gone.length; g++) { gone[g].parentNode.removeChild(gone[g]); }
          for (var j = 0; j < ids.length; j++) { garrGrid.appendChild(byId[String(ids[j])]); }
        });
      });
      if (refocus) { garrFocusTile(garrTiles()[0]); }
    }
    garrRenumber();
    return true;
  }

  /** Put one tile back at the index it was picked up from (a rollback, or Escape). */
  function garrHome(tile, idx) {
    if (!garrGrid || idx < 0) { garrRenumber(); return; }
    var tiles = garrTiles(), cur = garrIndex(tile);
    if (cur === idx) { garrRenumber(); return; }
    tiles.splice(cur, 1);
    var ref = tiles[idx] || null;
    garrKeepFocus(function () { garrFlip(function () { garrGrid.insertBefore(tile, ref); }); });
    garrRenumber();
  }

  /** Move one tile to an index (the keyboard's arrow keys, and a pointer drop). */
  function garrMoveTo(tile, idx) {
    if (!garrGrid) { return; }
    var tiles = garrTiles(), cur = garrIndex(tile);
    if (cur < 0 || idx < 0 || idx >= tiles.length || idx === cur) { return; }
    tiles.splice(cur, 1);
    var ref = tiles[idx] || null;
    garrKeepFocus(function () { garrFlip(function () { garrGrid.insertBefore(tile, ref); }); });
    garrRenumber();
  }

  /* THE WRITE. `after` is read off the tile's previous sibling, so it is whatever the member can
     actually see to the left of it -- 0 when it is first. -1 (the end) is never needed: a tile dropped
     last still has a sibling in front of it. */
  function garrSave(tile, homeIdx, spoken) {
    if (!garrGrid) { return; }
    var pid = tile.getAttribute('data-id') || '';
    var prev = tile.previousElementSibling;
    while (prev && !(prev.classList && prev.classList.contains('pcell'))) { prev = prev.previousElementSibling; }
    var after = prev ? (prev.getAttribute('data-id') || '0') : '0';
    var mine = ++garrSeq;
    garrSay(spoken + ' Saving.');
    postJson('/profile/grid-order', { op: 'move', post_id: pid, after: after }).then(function (res) {
      if (mine !== garrSeq) { return; }        // a later drag superseded this one; its answer is the truth
      if (res && res.ok) {
        garrApplyOrder(res.order);              // converge on the server even when we already agree
        garrManual(true);                       // a saved move IS a hand-made order: Reset fades in
        garrSay(spoken + ' Saved.');
        return;
      }
      /* 409. stale_anchor carries the CURRENT order, so redraw from it and hand the member the
         server's own sentence. This is the second-device case and it is not their mistake. */
      var msg = (res && res.error) || 'That could not be saved.';
      if (res && res.order && res.order.length && garrApplyOrder(res.order)) {
        garrSay(msg); toast(msg);
        return;
      }
      // not_found / too_many / 429 carry no order (or a set we cannot reconcile in place): put the tile
      // back where it started so nothing is left on a guess, then re-read the whole grid from truth.
      garrHome(tile, homeIdx);
      garrSay(msg); toast(msg);
      if (!res || res.code !== 'too_many') { garrLoad(); }
    }).catch(function () {
      if (mine !== garrSeq) { return; }
      garrHome(tile, homeIdx);
      garrSay('Could not save. The tile is back where it was.');
      toast('Network hiccup, nothing moved');
    });
  }

  /* ---- pointer drag (mouse, pen and touch through ONE Pointer Events path) --------------------
     TOUCH DRAGS START ON THE HANDLE, and that is a deliberate choice over long-press-then-drag. A long
     press is invisible, costs ~400ms before every move, and fights iOS's own long-press (the image
     callout, the selection magnifier) -- which can only be suppressed by preventing default on the
     touch stream, i.e. by breaking page scroll the moment the threshold is misjudged. The handle is
     visible, instant, and lets touch-action:none live on a 30px corner, so a finger anywhere else on
     the grid still scrolls the page natively. A MOUSE has no scroll to fight, so it may drag from
     anywhere on the tile and the handle is only a hint. */
  function garrPointerDown(e) {
    if (!garrGrid || garrDrag || garrHeld) { return; }
    if (e.button != null && e.button !== 0) { return; }
    if (!e.target.closest) { return; }
    var tile = e.target.closest('.pgrid.is-arranging > .pcell');
    if (!tile || !garrGrid.contains(tile)) { return; }
    var onHandle = !!e.target.closest('.garr-handle');
    if (!onHandle && e.pointerType === 'touch') { return; }   // let the finger scroll the page
    e.preventDefault(); e.stopPropagation();
    var sy = window.pageYOffset || 0, sx = window.pageXOffset || 0;
    garrDrag = {
      tile: tile, id: e.pointerId, home: garrIndex(tile), lifted: false,
      px: e.clientX + sx, py: e.clientY + sy, cy: e.clientY,
      to: -1, mark: null
    };
    document.addEventListener('pointermove', garrPointerMove, { passive: false });
    document.addEventListener('pointerup', garrPointerUp);
    document.addEventListener('pointercancel', garrPointerCancel);
  }

  /* The caret is ONE element parked in the grid, moved rather than re-created, and positioned from
     offsetLeft/offsetTop -- layout values, which are blind to the lifted tile's transform. */
  function garrCaret() {
    if (!garrGrid) { return null; }
    var c = garrGrid.querySelector('.garr-caret');
    if (!c) {
      c = document.createElement('span');
      c.className = 'garr-caret';
      c.setAttribute('aria-hidden', 'true');
      c.setAttribute('hidden', '');
      garrGrid.appendChild(c);
    }
    return c;
  }

  function garrClearMark() {
    var c = garrGrid ? garrGrid.querySelector('.garr-caret') : null;
    if (c) { c.setAttribute('hidden', ''); }
    if (garrDrag) { garrDrag.mark = null; }
  }

  function garrShowMark(tile, side) {
    var c = garrCaret(); if (!c) { return; }
    // straddle the 3px gutter: half the bar's width outside the tile edge it belongs to
    var x = side === 'before' ? tile.offsetLeft - 4 : tile.offsetLeft + tile.offsetWidth - 1;
    c.style.left = x + 'px';
    c.style.top = tile.offsetTop + 'px';
    c.style.height = tile.offsetHeight + 'px';
    // the anchor this caret stands for, named on the element itself: the same pair the request is
    // built from, so what is on screen and what goes on the wire can be compared without guessing
    c.setAttribute('data-anchor', tile.getAttribute('data-id') || '');
    c.setAttribute('data-side', side);
    c.removeAttribute('hidden');
    if (garrDrag) { garrDrag.mark = tile; }
  }

  /* The caret target: the tile whose CENTRE is nearest the pointer, then the side of that centre the
     pointer is on. Rects are read live rather than cached because the dragged tile keeps its SLOT in the
     grid (nothing reflows mid-drag), so this is a plain scan with no invalidation to get wrong.
     THE DRAGGED TILE IS SKIPPED, and it has to be: it is transformed to sit under the pointer, so its
     rect is always the nearest one going and it would win its own hit test forever -- a drag started
     anywhere near the middle of a tile could then never produce a target at all. Its own slot still
     comes back for free: barely moving makes the neighbour resolve to the slot it is already in, which
     is caught by `to === from` below and draws no caret. */
  function garrAim() {
    var d = garrDrag; if (!d) { return; }
    var tiles = garrTiles(), from = garrIndex(d.tile);
    var sx = window.pageXOffset || 0, sy = window.pageYOffset || 0;
    var best = null, bestD = Infinity, bi = -1, bcx = 0, i, r, cx, cy, dd;
    for (i = 0; i < tiles.length; i++) {
      if (tiles[i] === d.tile) { continue; }
      r = tiles[i].getBoundingClientRect();
      cx = r.left + sx + r.width / 2; cy = r.top + sy + r.height / 2;
      dd = (d.px - cx) * (d.px - cx) + (d.py - cy) * (d.py - cy);
      if (dd < bestD) { bestD = dd; best = tiles[i]; bi = i; bcx = cx; }
    }
    if (!best) { garrClearMark(); d.to = -1; return; }
    var side = d.px < bcx ? 'before' : 'after';
    var to = side === 'before' ? bi : bi + 1;
    if (to > from) { to--; }                       // the tile is lifted OUT before it goes back in
    if (to === from) { garrClearMark(); d.to = -1; return; }
    d.to = to;
    garrShowMark(best, side);
  }

  /* Drag near the top or bottom edge and the page comes with you -- the one thing a long grid needs
     that a wiggle grid on a phone gets from the OS for free. */
  function garrScrollTick() {
    if (!garrDrag) { garrRaf = 0; return; }
    var vh = window.innerHeight || 800, pad = 96, sp = 0, y = garrDrag.cy;
    if (y < pad) { sp = -Math.ceil((pad - y) / 5); }
    else if (y > vh - pad) { sp = Math.ceil((y - (vh - pad)) / 5); }
    if (sp) {
      var before = window.pageYOffset || 0;
      window.scrollBy(0, sp);
      var moved = (window.pageYOffset || 0) - before;
      if (moved) { garrDrag.py += moved; garrLiftTo(); garrAim(); }
    }
    garrRaf = requestAnimationFrame(garrScrollTick);
  }

  function garrLiftTo() {
    var d = garrDrag; if (!d || !d.lifted) { return; }
    var dx = d.px - d.sx0, dy = d.py - d.sy0;
    d.tile.style.transform = 'translate(' + dx + 'px,' + dy + 'px)' + (garrCalm() ? '' : ' scale(1.06)');
  }

  function garrPointerMove(e) {
    var d = garrDrag; if (!d || e.pointerId !== d.id) { return; }
    e.preventDefault();
    var sx = window.pageXOffset || 0, sy = window.pageYOffset || 0;
    if (!d.lifted) {
      var mx = e.clientX + sx - d.px, my = e.clientY + sy - d.py;
      if (mx * mx + my * my < 20) { return; }       // under ~4.5px: still a click, not a drag
      d.lifted = true; d.sx0 = d.px; d.sy0 = d.py;
      d.tile.classList.add('garr-lift');
      document.documentElement.classList.add('garr-dragging');
      if (!garrRaf) { garrRaf = requestAnimationFrame(garrScrollTick); }
    }
    d.px = e.clientX + sx; d.py = e.clientY + sy; d.cy = e.clientY;
    garrLiftTo();
    garrAim();
  }

  function garrDragTeardown() {
    document.removeEventListener('pointermove', garrPointerMove, { passive: false });
    document.removeEventListener('pointerup', garrPointerUp);
    document.removeEventListener('pointercancel', garrPointerCancel);
    if (garrRaf) { cancelAnimationFrame(garrRaf); garrRaf = 0; }
    document.documentElement.classList.remove('garr-dragging');
  }

  function garrPointerUp(e) {
    var d = garrDrag; if (!d || e.pointerId !== d.id) { return; }
    var to = d.to, tile = d.tile, home = d.home, lifted = d.lifted;
    garrClearMark();
    garrDragTeardown();
    garrDrag = null;
    if (!lifted) { return; }                        // a tap on a tile in arrange mode does nothing
    /* OPTIMISTIC: the tile lands NOW. The flight measures from where the finger left it (the lift
       transform is still on), so it flies from the pointer into its slot rather than snapping back
       first. Only then does the request go out. */
    if (to < 0) {
      tile.classList.remove('garr-lift');
      tile.style.transform = '';
      return;                                       // dropped where it started: nothing to save
    }
    var tiles = garrTiles(), cur = garrIndex(tile);
    tiles.splice(cur, 1);
    var ref = tiles[to] || null;
    garrFlip(function () {
      tile.classList.remove('garr-lift');
      tile.style.transform = '';
      garrGrid.insertBefore(tile, ref);
    });
    garrRenumber();
    garrSave(tile, home, 'Moved to position ' + (to + 1) + ' of ' + garrTiles().length + '.');
  }

  function garrPointerCancel(e) {
    var d = garrDrag; if (!d || e.pointerId !== d.id) { return; }
    garrClearMark();
    garrDragTeardown();
    d.tile.classList.remove('garr-lift');
    d.tile.style.transform = '';
    garrDrag = null;
  }

  /* ---- keyboard: focus, grab, move, drop, cancel ---------------------------------------------
     A drag-only reorder is not shippable, so this is the same feature with no pointer at all. The grid
     is a listbox with a roving tabindex; Space picks a tile up, the arrows move it (left/right by one,
     up/down by a whole row, Home/End to the ends), Space drops it and Escape puts it back. */
  function garrFocusTile(tile) {
    if (!tile) { return; }
    var tiles = garrTiles();
    for (var i = 0; i < tiles.length; i++) { tiles[i].setAttribute('tabindex', tiles[i] === tile ? '0' : '-1'); }
    try { tile.focus({ preventScroll: false }); } catch (e) { tile.focus(); }
  }

  function garrGrab(tile) {
    garrHeld = tile; garrHeldFrom = garrIndex(tile);
    tile.classList.add('garr-held');
    tile.setAttribute('aria-selected', 'true');
    garrSay('Picked up. Position ' + (garrHeldFrom + 1) + ' of ' + garrTiles().length
      + '. Arrow keys to move, Space to drop, Escape to put it back.');
  }

  function garrRelease(commit) {
    var tile = garrHeld; if (!tile) { return; }
    var from = garrHeldFrom, at = garrIndex(tile), n = garrTiles().length;
    garrHeld = null; garrHeldFrom = -1;
    tile.classList.remove('garr-held');
    tile.setAttribute('aria-selected', 'false');
    if (!commit) {
      garrHome(tile, from);
      garrSay('Put back at position ' + (from + 1) + ' of ' + n + '.');
      return;
    }
    if (at === from) { garrSay('Dropped at position ' + (at + 1) + ' of ' + n + '. Nothing changed.'); return; }
    garrSave(tile, from, 'Dropped at position ' + (at + 1) + ' of ' + n + '.');
  }

  function garrKey(e) {
    if (!garrGrid || !garrBar) { return; }
    if (e.altKey || e.ctrlKey || e.metaKey) { return; }
    var tile = e.target && e.target.closest ? e.target.closest('.pgrid.is-arranging > .pcell') : null;
    if (!tile) {
      // Escape from anywhere in the toolbar leaves the mode, so there is always a keyboard way out
      if (e.key === 'Escape' && garrBar.contains(e.target)) { e.preventDefault(); garrExit(); }
      return;
    }
    var tiles = garrTiles(), n = tiles.length, at = garrIndex(tile), cols = garrCols(), k = e.key, to = -1;

    if (k === 'Escape') {
      e.preventDefault();
      if (garrHeld) { garrRelease(false); } else { garrExit(); }
      return;
    }
    if (k === ' ' || k === 'Spacebar' || k === 'Enter') {
      e.preventDefault(); e.stopPropagation();
      if (garrHeld === tile) { garrRelease(true); }
      else if (!garrHeld) { garrGrab(tile); }
      return;
    }
    if (k === 'ArrowLeft')      { to = at - 1; }
    else if (k === 'ArrowRight'){ to = at + 1; }
    else if (k === 'ArrowUp')   { to = at - cols; }
    else if (k === 'ArrowDown') { to = at + cols; }
    else if (k === 'Home')      { to = 0; }
    else if (k === 'End')       { to = n - 1; }
    else { return; }
    e.preventDefault();
    // Up/Down off the end of a ragged last row still has somewhere sensible to go
    if (to < 0) { to = 0; }
    if (to > n - 1) { to = n - 1; }
    if (to === at) { return; }
    if (garrHeld === tile) {
      garrMoveTo(tile, to);
      garrFocusTile(tile);
      garrSay('Position ' + (to + 1) + ' of ' + n + '.');
    } else {
      garrFocusTile(tiles[to]);
      garrSay('Tile ' + (to + 1) + ' of ' + n + '. Press Space to pick it up.');
    }
  }

  /* Leaving the grid while still holding a tile DROPS it. The tile has visibly moved, so committing is
     what the member just watched happen; silently reverting would be the surprise. */
  function garrFocusOut(e) {
    if (!garrHeld || !garrGrid) { return; }
    var to = e.relatedTarget;
    if (to && garrGrid.contains(to)) { return; }
    setTimeout(function () {
      if (garrHeld && garrGrid && !garrGrid.contains(document.activeElement)) { garrRelease(true); }
    }, 0);
  }

  /* ---- entering, leaving, loading -------------------------------------------------------------- */

  var garrIcon = '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor"'
    + ' stroke-width="2" stroke-linecap="round" aria-hidden="true">'
    + '<path d="M8 6h.01M8 12h.01M8 18h.01M16 6h.01M16 12h.01M16 18h.01"/></svg>';

  function garrDecorate() {
    if (!garrGrid) { return; }
    garrGrid.classList.add('is-arranging');
    garrGrid.setAttribute('role', 'listbox');
    garrGrid.setAttribute('aria-label', 'Your grid, in order. Rearrange it.');
    var keys = garrBar ? garrBar.querySelector('.garr-keys') : null;
    if (keys) { keys.id = 'garr-keys'; garrGrid.setAttribute('aria-describedby', 'garr-keys'); }
    var tiles = garrTiles();
    for (var i = 0; i < tiles.length; i++) {
      var t = tiles[i];
      t.setAttribute('role', 'option');
      t.setAttribute('aria-selected', 'false');
      t.setAttribute('tabindex', i === 0 ? '0' : '-1');
      t.setAttribute('draggable', 'false');
      var img = t.querySelector('img'); if (img) { img.setAttribute('draggable', 'false'); }
      if (!t.querySelector('.garr-num')) {
        var num = document.createElement('span');
        num.className = 'garr-num'; num.setAttribute('aria-hidden', 'true');
        t.appendChild(num);
      }
      if (!t.querySelector('.garr-handle')) {
        var h = document.createElement('span');
        h.className = 'garr-handle'; h.setAttribute('aria-hidden', 'true');
        h.innerHTML = garrIcon;
        t.appendChild(h);
      }
    }
    garrRenumber();
  }

  function garrFetchGrid(arrange) {
    var base = garrBar ? (garrBar.getAttribute('data-base') || '') : '';
    var url = base + '?tab=grid&partial=posts' + (arrange ? '&arrange=1' : '');
    return rfetch(url, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', cache: 'no-store'
    }, 15000).then(function (r) { return r.text(); });
  }

  /** Re-read the WHOLE arrange grid from the server. The answer to any state we cannot reconcile. */
  function garrLoad() {
    if (!garrBar || !garrGrid) { return; }
    garrFetchGrid(true).then(function (html) {
      var host = document.getElementById('profile-posts');
      if (!host || !garrGrid) { return; }
      host.innerHTML = html;
      garrGrid = host.querySelector('.pgrid');
      if (!garrGrid) { garrExit(); return; }
      garrHeld = null; garrHeldFrom = -1;
      garrDecorate();
      garrSay('Refreshed from your grid as it is now. ' + garrTiles().length + ' tiles.');
    }).catch(function () { toast('Could not refresh your grid'); });
  }

  /* ONE ROW, CONTROLS FADE IN AT ITS RIGHT (2026-09-25, iOS parity). The app now arranges IN PLACE over
     the profile grid, and its Arrange row stays put while "Done" -- and "Reset", only when the order is a
     hand-made one -- fade in at the row's right edge. The web used to SWAP the Arrange row for a second
     row (Done first, "Newest first" always, a four-line keyboard hint), which moved the grid down ~100px
     at 390 the moment the mode opened. Now: the same row, Arrange reads as pressed (and a second press
     leaves, like Done), .garr-acts fades in over the helper text's slot (out of flow, so the row keeps
     its height), and .is-manual (data-manual from Posts::hasManualGrid, then every save's answer) decides
     whether Reset is offered. The legacy two-row markup is still honoured below, so a page rendered
     before this shipped keeps a working Done. */
  function garrRows(on) {
    if (!garrBar) { return; }
    var off = garrBar.querySelector('.garr-row-off'), onR = garrBar.querySelector('.garr-row-on');
    if (off) { if (on) { off.setAttribute('hidden', ''); } else { off.removeAttribute('hidden'); } }
    if (onR) { if (on) { onR.removeAttribute('hidden'); } else { onR.setAttribute('hidden', ''); } }
    // .is-on makes the toolbar sticky, so Done stays on screen while the member scrolls a grid taller
    // than their phone. Off again the instant the mode ends.
    garrBar.classList.toggle('is-on', !!on);
    var open = document.getElementById('garr-open');
    if (open) { open.setAttribute('aria-pressed', on ? 'true' : 'false'); }
  }
  // Reset is only offered when there IS a hand-made order to throw away (the app's rule).
  function garrManual(v) { if (garrBar) { garrBar.classList.toggle('is-manual', !!v); } }

  // the pager (#profile-more) and the hidden strip are about a different job; park them while arranging
  // and put each back exactly as it was, never unconditionally shown.
  var garrParked = [];
  function garrPark(on) {
    if (on) {
      garrParked = [];
      ['profile-more', 'grid-hidden'].forEach(function (id) {
        var el = document.getElementById(id);
        if (!el) { return; }
        garrParked.push([el, el.hasAttribute('hidden')]);
        el.setAttribute('hidden', '');
      });
    } else {
      garrParked.forEach(function (p) { if (!p[1]) { p[0].removeAttribute('hidden'); } });
      garrParked = [];
    }
  }

  function garrEnter() {
    if (garrBusy || garrGrid || !garrBar) { return; }
    garrBusy = true;
    var open = document.getElementById('garr-open');
    if (open) { open.setAttribute('disabled', ''); }
    garrFetchGrid(true).then(function (html) {
      var host = document.getElementById('profile-posts');
      if (!host) { throw new Error('no host'); }
      host.innerHTML = html;
      var g = host.querySelector('.pgrid');
      if (!g || g.querySelectorAll('.pcell').length < 2) {
        // nothing to arrange: put the plain grid back rather than leaving a one-tile "mode" on screen
        garrBusy = false;
        if (open) { open.removeAttribute('disabled'); }
        toast('You need at least two tiles to arrange your grid');
        garrFetchGrid(false).then(function (h2) { host.innerHTML = h2; }).catch(function () {});
        return;
      }
      garrGrid = g;
      garrDecorate();
      garrPark(true);
      garrRows(true);
      garrBusy = false;
      if (open) { open.removeAttribute('disabled'); }
      var n = garrTiles().length;
      garrSay('Arranging ' + n + ' tiles. Drag a tile by its handle, or press Space on one to pick it up.');
      garrFocusTile(garrTiles()[0]);
    }).catch(function () {
      garrBusy = false;
      if (open) { open.removeAttribute('disabled'); }
      toast('Could not open the arranger');
    });
  }

  function garrExit() {
    if (!garrGrid || garrBusy) { return; }
    if (garrHeld) { garrRelease(false); }
    if (garrDrag) { garrDragTeardown(); garrDrag.tile.classList.remove('garr-lift'); garrDrag.tile.style.transform = ''; garrDrag = null; }
    garrBusy = true;
    var host = document.getElementById('profile-posts');
    garrGrid = null;
    garrRows(false);
    garrSay('');
    garrFetchGrid(false).then(function (html) {
      if (host) {
        host.innerHTML = html;
        // the same signal a tab swap raises, so carousels/thumbs rehydrate down the normal path
        try { host.dispatchEvent(new CustomEvent('rova:paged')); } catch (e) {}
      }
      garrPark(false);
      garrBusy = false;
      var open = document.getElementById('garr-open');
      if (open) { try { open.focus({ preventScroll: true }); } catch (e) { open.focus(); } }
    }).catch(function () { garrBusy = false; window.location.reload(); });
  }

  function garrReset() {
    if (!garrGrid) { return; }
    glassConfirm({
      title: 'Back to newest first?',
      body: 'Your hand-arranged order is thrown away and your grid goes back to newest first. You can arrange it again any time.',
      actions: [{ label: 'Newest first', value: 'yes', style: 'primary' }]
    }).then(function (v) {
      if (v !== 'yes' || !garrGrid) { return; }
      var mine = ++garrSeq;
      garrSay('Putting your grid back to newest first.');
      busyUntil(document.getElementById('garr-reset'), postJson('/profile/grid-order', { op: 'reset' }, 15000).then(function (res) {
        if (mine !== garrSeq) { return; }
        if (res && res.ok) {
          if (!garrApplyOrder(res.order)) { garrLoad(); }
          garrManual(false);                    // nothing hand-made left to reset
          garrSay('Back to newest first.');
          toast('Your grid is back to newest first');
          return;
        }
        toast((res && res.error) || 'That could not be saved.');
        garrLoad();
      }).catch(function () { toast('Network hiccup, nothing changed'); }));
    });
  }

  /* Wiring. Everything is delegated off document so a grid replaced by a fetch keeps working, and every
     listener is a no-op the moment garrGrid is null -- which it is on every page except an owner's own
     grid tab with the mode switched on. */
  (function garrInit() {
    garrBar = document.getElementById('grid-arrange');
    if (!garrBar) { return; }
    garrLive = document.getElementById('garr-live');
    // reveal only once JS is running AND there is something worth ordering
    var cells = document.querySelectorAll('#profile-posts .pgrid .pcell').length;
    var more = document.getElementById('profile-more');
    var canGrow = !!(more && !more.hasAttribute('hidden'));
    if (cells < 2 && !canGrow) { return; }
    garrBar.removeAttribute('hidden');
    garrManual(garrBar.getAttribute('data-manual') === '1');

    var open = document.getElementById('garr-open');
    // Arrange is a toggle now that it stays on screen in the mode: a second press leaves, exactly like Done
    if (open) { open.addEventListener('click', function (e) { e.preventDefault(); if (garrGrid) { garrExit(); } else { garrEnter(); } }); }
    var done = document.getElementById('garr-done');
    if (done) { done.addEventListener('click', function (e) { e.preventDefault(); garrExit(); }); }
    var rst = document.getElementById('garr-reset');
    if (rst) { rst.addEventListener('click', function (e) { e.preventDefault(); garrReset(); }); }

    document.addEventListener('pointerdown', garrPointerDown, true);
    document.addEventListener('keydown', garrKey, true);
    document.addEventListener('focusout', garrFocusOut, true);
    // a tile is an <a href="/p/id">: in arrange mode a click must never navigate or fly the viewer open
    document.addEventListener('click', function (e) {
      if (!garrGrid || !e.target.closest) { return; }
      if (e.target.closest('.pgrid.is-arranging > .pcell')) { e.preventDefault(); e.stopPropagation(); }
    }, true);
    document.addEventListener('dragstart', function (e) {
      if (garrGrid && e.target.closest && e.target.closest('.pgrid.is-arranging')) { e.preventDefault(); }
    });
  })();

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.classList) return;
    /* A SUBMIT BUTTON MAY CARRY ITS OWN QUESTION: a form with several buttons where only one is
       destructive (admin_create's per-slide Up / Down / Re-burn / Remove). data-confirm on e.submitter
       wins over the form's; the button's data-confirm-* attributes style the sheet. */
    var asker = (e.submitter && e.submitter.hasAttribute && e.submitter.hasAttribute('data-confirm')) ? e.submitter : null;
    if (!asker && !f.classList.contains('js-confirm')) return;
    if (f.dataset.confirmed === '1') {           // our own re-submit: let it fly...
      delete f.dataset.confirmed;
      /* ...ONCE. A confirmed full-page POST takes a moment to navigate, and a second press in that
         window would post the same destructive action twice. Hold the form until the page goes.
         Released at once when something downstream turned this submit into an XHR (it called
         preventDefault, so no navigation is coming), after 10s so a stalled request can be retried,
         and on a back/forward-cache restore (pageshow below). */
      f.dataset.sending = '1';
      setTimeout(function () { if (e.defaultPrevented) { delete f.dataset.sending; } }, 0);
      setTimeout(function () { delete f.dataset.sending; }, 10000);
      return;
    }
    e.preventDefault();
    if (f.dataset.sending === '1') return;       // already confirmed and on its way
    if (f.dataset.asking === '1') return;        // sheet already up for this form
    f.dataset.asking = '1';
    var submitter = e.submitter || null;
    var src = asker || f;
    askConfirm(src.getAttribute('data-confirm') || 'Are you sure?', src).then(function (yes) {
      delete f.dataset.asking;
      if (!yes) return;
      var act = f.getAttribute('action') || '';
      if (act === '/post/delete') { ajaxDeletePost(f); return; }
      // "Remove profile photo" from a post's ⋯ menu (the profile-photo viewer). Same endpoint as
      // Settings, but a member who asked from their profile should land back on their profile with the
      // photo gone -- not be dumped into /settings by handle_avatar_delete's redirect.
      if (act === '/settings/avatar-delete' && f.closest('.pmenu-panel')) {
        closePmenus();
        postJson(act, new FormData(f))
          .then(function (res) {
            if (res && res.ok) { window.location.reload(); }
            else { toast('Could not remove your profile photo'); }
          })
          .catch(function () { f.submit(); });
        return;
      }
      f.dataset.confirmed = '1';
      if (f.requestSubmit) { f.requestSubmit(submitter || undefined); } else { f.submit(); }
    });
  });
  // Back/forward-cache restore: the page we navigated away from comes back with the form still held.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document.querySelectorAll('form[data-sending]').forEach(function (f) { delete f.dataset.sending; });
  });
  /* input[data-select-on-focus]: a read-only share link that selects itself when focused, ready to
     copy (was an inline onfocus="this.select()", which the CSP never ran). */
  document.addEventListener('focusin', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('input[data-select-on-focus]')) { try { t.select(); } catch (x) {} }
  });

  /* ---- per-post ⋯ menus ------------------------------------------------ */
  function closePmenus(except) {
    document.querySelectorAll('.pmenu-panel.show').forEach(function (p) {
      if (p !== except) {
        p.classList.remove('show');
        var po = p.closest('.post'); if (po) po.classList.remove('menu-open');
      }
    });
  }
  document.addEventListener('click', function (e) {
    var trig = e.target.closest ? e.target.closest('.pmenu-trigger') : null;
    if (trig) {
      e.stopPropagation();
      var panel = trig.parentNode.querySelector('.pmenu-panel');
      var open = panel.classList.contains('show');
      closePmenus(panel);
      panel.classList.toggle('show', !open);
      var post = trig.closest('.post');
      if (post) post.classList.toggle('menu-open', !open);
      if (!open && window.__rovaSlideDelSync) { try { window.__rovaSlideDelSync(panel); } catch (er) {} }
      return;
    }
    if (!e.target.closest || !e.target.closest('.pmenu-panel')) closePmenus(null);
  });

  /* ---- inline post-edit modal ------------------------------------------------------------------------
     A post WITH media opens the immersive viewer on tap, so its "Edit" (which linked to the permalink page)
     was buried BEHIND the viewer -- the owner couldn't reach it. Intercept the Edit menu item and open a
     small editor overlay ON TOP instead of navigating away. Text-only, mirrors /post/edit; saves over AJAX
     and swaps the new caption into every rendered copy (feed card + viewer card) with no reload. The link's
     href stays a graceful fallback if JS is off. ---------------------------------------------------------- */
  (function () {
    var modal = null, taEl = null, saveBtn = null, curId = null;

    /* ---- ATTACHMENTS (owner 2026-08-03: "when editing a post I want to be able to add attachments
       or remove them etc"). The editor grew a media strip: every current slide is a tile with its own
       remove control, and an Add button stages new files through the SAME /upload-stage endpoint the
       composer uses, so there is one upload path on the server and one claim-ticket format.

       NOTHING IS SENT UNTIL SAVE. Cutting a tile marks it (dimmed, struck, X becomes an undo) instead
       of firing a request, and picked files upload immediately but only become part of the post when
       Save posts their tickets. So the whole edit is one request that either lands or does not -- there
       is no half-applied state to explain, and Cancel really cancels.

       THE SERVER OWNS THE RESULT. When the media changed we do NOT rebuild the card here: a post's
       media box is a carousel, an aspect clamp, an NSFW veil, an HLS <video> and a poster, all decided
       server-side in views/_post.php. We re-fetch the rendered card from /post-cards (the same endpoint
       __rovaInsertFresh uses) and swap it in, then hydrate. If that round-trip fails for any reason we
       reload rather than leave a stale carousel on screen. */
    var peMed = null;   // { max, list: [tiles], strip, addBtn, input, note } while a modal is open
    /* ---- VIDEO: NO SEPARATE CAP HERE ANY MORE ------------------------------
       This used to be 190 MB, one megabyte under upload_max_filesize, because
       peStage() sent the whole file in a single XHR POST. The refusal even named
       its own fix -- "Post it on its own and it will upload in pieces" -- while
       the thing that uploads in pieces sat in the same file, in a scope this one
       could not reach.

       It can reach it now: peStage() calls upDrive(), the same engine the
       composer uses, so a clip here takes exactly the same road it takes there --
       browser compression first, then ~6 MB pieces through the SHARED congestion
       window, with resume, the progress-based stall watchdogs, and an instant
       stop on 401/402/403. There is therefore nothing left for a number here to
       mean that UP_PICK_VID_MAX / UP_POST_VID_MAX do not already mean better, and
       a second copy of them could only ever drift from the first.

       IMAGES keep their 25 MB, and keep it AT PICK TIME: there is no image
       compressor on this path, so nothing downstream can rescue an oversized
       photo and deferring the refusal would only delay the same answer. Same
       reasoning as the composer's, and the same number (UP_IMG_MAX). */

    function peCount() {
      if (!peMed) return 0;
      var n = 0;
      peMed.list.forEach(function (t) { if (!t.cut && !t.failed) n++; });
      return n;
    }
    function peSync() {
      if (!peMed) return;
      var n = peCount();
      peMed.note.textContent = n + ' of ' + peMed.max + (n === 1 ? ' attachment' : ' attachments');
      peMed.addBtn.disabled = n >= peMed.max;
      var busy = peMed.list.some(function (t) { return t.staging; });
      if (saveBtn) {
        saveBtn.disabled = busy;
        saveBtn.textContent = busy ? 'Uploading…' : 'Save changes';
      }
      peFitSync();   // the eligible-slide set is a function of exactly what just changed above
    }
    /* ---- HOW IT OPENS: the per-slide FIT OVERRIDE (migration 0144) ----------------------------
       Three states, and they are the column's three states exactly -- Automatic (NULL), Open whole
       ('contain'), Open zoomed ('cover'). Nothing here invents a fourth.

       WHY IT IS SELF-SERVE AT ALL. window.__rovaPhotoCovers is a SHAPE rule and cannot be anything
       else: a 3:4 article screenshot and a 3:4 portrait photograph are the same shape, so no
       threshold separates them and the screenshot's headline gets cropped away. lib/textimage.php
       narrows that gap by reading the pixels, but it is precision-biased ON PURPOSE and documents
       the classes it will never catch. Those misses are by design, so the answer to them cannot be
       a better threshold -- it has to be a human. Until now the only way to set one was hand SQL.

       WHY 'AUTOMATIC' IS A REAL BUTTON AND NOT THE ABSENCE OF ONE. Picking it WRITES NULL, which is
       how an author undoes an override -- their own, or a 'contain' the detector wrote at post
       time and got wrong. A control that could only ever add an opinion would be a one-way door.

       WHICH SLIDES GET A ROW, and why the other three kinds do not:
         - a NEW file (just added, not yet saved) has no stored path to name and no rendered post to
           judge; it gets the detector's answer on save and a row the next time the editor opens.
         - a CUT slide is about to stop existing, and naming it would earn the 409 that post_fit_apply
           correctly throws for a path the post no longer has.
         - a VIDEO used to be excluded here, on the argument that "its box is decided by an entirely
           different sizing path, so a hint on it would be a stored value nothing reads". That
           stopped being true on 2026-08-14: __rovaVideoCovers (and the app's videoCovers) consult
           the hint on the clip's three call sites exactly as the photo verdict does. Clips are the
           case that needs this control MOST, not least -- the detector is precision-biased and
           deliberately will not judge text laid over footage, which is most captioned video, so for
           a clip the human answer is the primary route rather than the fallback. Owner, /p/43060:
           "this video has text and shouldn't load fullscreen zoomed in."

       THE PICKER IS THE DEFAULT, NEVER THE CEILING. .vc-fit / tap-to-uncrop still INVERTS whatever
       verdict this produces, so a reader can always zoom a forced-whole screenshot in. Same rule
       the hint itself obeys server-side: it changes what the automatic answer RETURNS, and it never
       removes a control. */
    var PE_FIT_OPTS = [
      ['auto',    'Automatic',   'Let Rova decide from the shape of the picture.'],
      ['contain', 'Open whole',  'Always show the whole picture, even if that leaves bars at the edges.'],
      ['cover',   'Open zoomed', 'Always fill the screen, cropping the edges.'],
    ];
    function peFitEligible() {
      if (!peMed) return [];
      return peMed.list.filter(function (t) {
        // type is NOT tested: a clip gets a row too (see the doc-block above). Everything else is
        // unchanged -- a new file has no stored path to name, a cut slide would earn a 409.
        return !t.isNew && !t.cut && !t.failed && !!t.path;
      });
    }
    function peFitPaint(row, t) {
      var v = t.fit || 'auto';
      Array.prototype.forEach.call(row.querySelectorAll('.pe-fopt'), function (b) {
        var on = b.getAttribute('data-v') === v;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
        // roving tabindex: a radiogroup is ONE tab stop, and the arrows move within it
        b.tabIndex = on ? 0 : -1;
      });
    }
    /* Rebuild the rows only when the SET OF SLIDES changed -- peSync() is also the upload progress
       tick, so this runs many times a second while a file is staging, and blowing the list away on
       each one would fight the member for their own focus. The signature is the path list; a
       chosen value never enters it, because changing a value repaints one row and moves nothing. */
    function peFitSync() {
      if (!peMed || !peMed.fitWrap) return;
      var rows  = peFitEligible();
      var sig   = rows.map(function (t) { return t.path; }).join(' ');
      if (sig === peMed.fitSig) return;
      peMed.fitSig = sig;
      var multi = rows.length > 1;
      peMed.fitWrap.hidden = !rows.length;
      peMed.fitList.innerHTML = '';
      peMed.fitList.classList.toggle('is-multi', multi);
      // "item", not "photo": the list can hold clips now, and a post whose only media is a video
      // read "Each photo separately" over a row about a video.
      peMed.fitNote.textContent = multi ? 'Each item separately' : '';
      rows.forEach(function (t, i) {
        var label = multi ? ('Slide ' + (i + 1)) : (t.type === 'video' ? 'This video' : 'This photo');
        var row = document.createElement('div');
        row.className = 'pe-frow';
        var html = '';
        if (multi) {
          /* THE SLIDE NUMBER RIDES ON THE THUMB, NOT IN THE ROW. It used to be its own 48px
             column, and that column was eating the labels: at 381-429px -- 390 (iPhone 12/13/14),
             393 (Pixel), 402, 414, i.e. essentially every modern phone -- the three buttons fell to
             ~71-82px and ellipsis-clipped to "Open wh…" and "Open zo…". The truncation removed
             exactly the word that tells the two options apart, so both read as "Open …". A wider
             breakpoint would only have moved the cliff; a badge over the picture costs the row no
             width at all, so the labels now fit at EVERY width and the media query below is a
             small-font nicety rather than the thing holding the layout up. */
          html += '<span class="pe-fthumbw">'
               +  (t.thumb ? '<img class="pe-fthumb" src="' + escHtml(t.thumb) + '" alt="">'
                           : '<span class="pe-fthumb"></span>')
               +  '<span class="pe-fbadge" aria-hidden="true">' + (i + 1) + '</span>'
               +  '</span>';
        }
        html += '<span class="pe-fseg" role="radiogroup" aria-label="How ' + escHtml(label) + ' opens">';
        PE_FIT_OPTS.forEach(function (o) {
          html += '<button type="button" class="pe-fopt" role="radio" aria-checked="false" tabindex="-1"'
               +  ' data-v="' + o[0] + '" title="' + escHtml(o[2]) + '">' + escHtml(o[1]) + '</button>';
        });
        html += '</span>';
        row.innerHTML = html;
        row.addEventListener('click', function (e) {
          var b = e.target && e.target.closest ? e.target.closest('.pe-fopt') : null;
          if (!b) return;
          e.preventDefault();
          t.fit = b.getAttribute('data-v') || 'auto';
          peFitPaint(row, t);
        });
        // arrows move the selection, which is what a radiogroup promises a keyboard and a screen
        // reader; without it the role is a lie and Tab lands on three separate "radios".
        row.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight' && e.key !== 'ArrowUp' && e.key !== 'ArrowDown') return;
          var opts = Array.prototype.slice.call(row.querySelectorAll('.pe-fopt'));
          var cur  = opts.indexOf(document.activeElement);
          if (cur < 0) return;
          e.preventDefault();
          var step = (e.key === 'ArrowLeft' || e.key === 'ArrowUp') ? -1 : 1;
          var next = opts[(cur + step + opts.length) % opts.length];
          t.fit = next.getAttribute('data-v') || 'auto';
          peFitPaint(row, t);
          next.focus();
        });
        peMed.fitList.appendChild(row);
        t.fitRow = row;
        peFitPaint(row, t);
      });
    }

    function peTile(t) {
      var el = document.createElement('div');
      el.className = 'pe-tile' + (t.type === 'video' ? ' is-vid' : '');
      var pic = t.thumb
        ? '<img src="' + escHtml(t.thumb) + '" alt="">'
        : '<span class="pe-noimg" aria-hidden="true">' + (t.type === 'video' ? '&#9654;' : '&#9633;') + '</span>';
      el.innerHTML = pic
        + '<span class="pe-bar"><span class="pe-fill"></span></span>'
        + '<button class="pe-mx" type="button" aria-label="Remove this attachment"'
        + ' title="Remove this attachment">&times;</button>';
      el.querySelector('.pe-mx').addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        peToggleCut(t);
      });
      t.el = el;
      peTileDecorate(t, el);   // processing / failed state, move buttons, drag-to-reorder (the full editor)
      peCropDecorate(t, el);   // photo crop (2026-09-30)
      return el;
    }
    /* ---- PHOTO CROP (2026-09-30, db/0199, lib/postcrop.php) -------------------------------------------
       A "Crop" corner button on every croppable PHOTO tile (the server decides: /post-media's `croppable`
       -- never a video, a GIF, a linked image or a profile-photo post). It opens the SHARED cropper
       (openCropper, the avatar/banner component) in its post mode ABOVE this modal, always on the
       UNTOUCHED ORIGINAL (`original.url`), seeded with the stored crop. Done only records the rect on the
       tile and repaints the tile's preview from the original's thumb with CSS -- nothing is uploaded or
       written until Save, which sends crop_path[] + crop_rect[] ("x,y,w,h" normalised on the original,
       or "reset"). The server bakes a NEW file (immutable media URLs) and every surface follows. */
    var PE_CROP_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 2v14a2 2 0 0 0 2 2h14"/><path d="M18 22V8a2 2 0 0 0-2-2H2"/></svg>';
    function peCropSeed(t, m) {
      t.croppable = !!(m && m.croppable && m.original && m.original.url);
      t.orig = t.croppable ? m.original : null;
      var c = m && m.crop;
      t.crop0 = c ? [+c.x, +c.y, +c.w, +c.h] : null;
      t.crop = t.crop0 ? t.crop0.slice() : null;
      t.cropDirty = false;
      t.fitSeed = t.fit || 'auto';
    }
    function peCropSame(a, b) {
      if (!a || !b) return !a && !b;
      for (var i = 0; i < 4; i++) { if (Math.abs(a[i] - b[i]) > 0.0005) return false; }
      return true;
    }
    function peCropDecorate(t, el) {
      if (!t.croppable || t.isNew || t.type !== 'image') return;
      el.classList.add('pe-can-crop');
      el.insertAdjacentHTML('beforeend', '<button type="button" class="pe-crop" aria-label="Crop this photo" title="Crop">' + PE_CROP_SVG + '</button>');
      el.querySelector('.pe-crop').addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        if (t.cut) return;
        peCropOpen(t);
      });
      peCropPaint(t);
    }
    /* The tile previews the PENDING crop straight away, drawn from the original's thumb with CSS (no
       canvas, so no CORS question about the media CDN): the picture is sized so the cropped region
       cover-fills the square tile, then shifted so that region's centre sits at the tile's centre. */
    function peCropPaint(t) {
      var el = t.el; if (!el || !t.orig) return;
      var old = el.querySelector('.pe-cropv'); if (old) old.remove();
      var main = el.querySelector(':scope > img');
      el.classList.toggle('is-cropped', !!t.crop);
      el.classList.toggle('crop-dirty', !!t.cropDirty);
      if (!t.cropDirty) { if (main) main.style.visibility = ''; return; }
      if (main) main.style.visibility = 'hidden';
      var v = document.createElement('span');
      v.className = 'pe-cropv'; v.setAttribute('aria-hidden', 'true');
      var im = document.createElement('img');
      im.alt = ''; im.draggable = false; im.src = t.orig.thumb || t.orig.url;
      var W = +t.orig.w || 0, H = +t.orig.h || 0, r = t.crop;
      if (r && W > 0 && H > 0) {
        var mn = Math.min(r[2] * W, r[3] * H);
        im.style.width = (W / mn * 100) + '%';
        im.style.height = (H / mn * 100) + '%';
        im.style.left = (50 - (r[0] + r[2] / 2) * W / mn * 100) + '%';
        im.style.top = (50 - (r[1] + r[3] / 2) * H / mn * 100) + '%';
      } else {
        im.className = 'pe-cropv-full';
      }
      v.appendChild(im);
      el.insertBefore(v, el.firstChild);
    }
    function peCropOpen(t) {
      if (!t.orig) return;
      var esc = function (e) {
        if (e.key !== 'Escape') return;
        e.preventDefault(); e.stopPropagation();
        var c = document.querySelector('.cropper.show .crop-cancel'); if (c) c.click();
      };
      var done = function () { document.removeEventListener('keydown', esc, true); };
      document.addEventListener('keydown', esc, true);
      openCropper(null, {
        post: true, rect: true, aspect: 1, src: t.orig.url,
        initial: t.crop ? t.crop.slice() : null,
        title: 'Drag to move · pinch or scroll to zoom · drag the corners to resize',
        saveLabel: 'Done',
        onCancel: done,
        onDone: function (rect) {
          done();
          var full = rect[0] <= 0.002 && rect[1] <= 0.002 && rect[2] >= 0.998 && rect[3] >= 0.998;
          t.crop = full ? null : rect;
          t.cropDirty = !peCropSame(t.crop, t.crop0);
          peCropPaint(t);
          var b = t.el && t.el.querySelector('.pe-crop'); if (b) { try { b.focus({ preventScroll: true }); } catch (e) {} }
        }
      });
    }
    // Save: only tiles whose crop CHANGED, and never a tile that is being removed
    function peCropAppend(fd) {
      if (!peMed) return;
      peMed.list.forEach(function (t) {
        if (t.isNew || t.cut || !t.cropDirty || !t.path) return;
        fd.append('crop_path[]', t.path);
        fd.append('crop_rect[]', t.crop ? t.crop.join(',') : 'reset');
      });
    }
    function peToggleCut(t) {
      if (t.staging) { return; }                       // still uploading: let it finish or fail first
      if (t.isNew && !t.cut) {                         // a file just added: drop it outright, no undo needed
        t.cut = true;
        if (t.el && t.el.parentNode) { t.el.parentNode.removeChild(t.el); }
        peSync();
        return;
      }
      if (!t.cut && peCount() <= 1 && !peBodyHasText() && !peMed.hasPoll) {
        // the server refuses an empty post; say so HERE rather than after a round-trip
        toast('Add a caption first, or delete the post instead.');
        return;
      }
      t.cut = !t.cut;
      t.el.classList.toggle('is-cut', t.cut);
      var x = t.el.querySelector('.pe-mx');
      x.innerHTML = t.cut ? '&#8634;' : '&times;';
      x.setAttribute('aria-label', t.cut ? 'Keep this attachment' : 'Remove this attachment');
      x.setAttribute('title', t.cut ? 'Keep this attachment' : 'Remove this attachment');
      peSync();
    }
    function peBodyHasText() { return !!(taEl && taEl.value && taEl.value.trim().length); }

    /* The editor's own progress paint, and the ONE reason a paint hook exists on
       upDrive at all: a composer thumb and a .pe-tile are different markup, and
       neither should have to know about the other.

       MONOTONIC, for the same reason stagePaint is. itemFrac() rewinds when a
       chunk retries (it.sent goes back) and again when compression hands over to
       upload (the upload term restarts at zero); both are real, and both read as
       failure to someone watching a bar. NOTE the `|| 0` sits on the high-water
       mark, not on the result: `f >= undefined` is false for every f, so seeding
       the mark lazily inside the compare pins the bar at zero forever -- which is
       exactly what it did the first time the composer tried it. */
    function pePaint(t) {
      var wasBusy = t.staging;
      t.staging = !(t.done || t.failed);
      var f = itemFrac(t), m = t.pmax || 0;
      if (f > m) { t.pmax = f; } else { f = m; }
      if (t.el) {
        var fill = t.el.querySelector('.pe-fill');
        if (fill) fill.style.width = Math.round(f * 100) + '%';
        t.el.classList.toggle('is-up', !!t.staging);
        t.el.classList.toggle('is-done', !!t.done);
        t.el.classList.toggle('is-fail', !!t.failed);
        if (t.done && t.type === 'video') t.el.classList.add('is-vid');
      }
      // Save unlocks the instant the last upload lands -- but only ask peSync when
      // the busy flag actually flips, not on every progress tick.
      if (wasBusy !== t.staging) peSync();
    }

    function peNoteClear() {
      if (!peMed || !peMed.upnote) return;
      peMed.upnote.textContent = '';
      peMed.upnote.hidden = true;
    }
    /* THE HALF A TOAST CANNOT DO, brought over from the composer rather than left
       behind with it. An upload that runs out of road has something worth saying
       AND something worth offering: the server kept every piece that landed
       (Upload::chunkState), so "Resume" sends only what is missing. The composer
       learned this on 2026-08-07, after a member watched 98% for six and a half
       minutes with no error, no retry and no way out but a reload. A 1.8s toast
       over a red tile is that same dead end in a smaller box.

       The VERB MUST MATCH THE SITUATION -- there is nothing to "resume" when
       nothing landed, and nothing but a re-pick helps a file the browser can no
       longer read. `kind` decides it, exactly as it does in stageFailNote(). */
    function peNote(msg, kind) {
      if (!peMed || !peMed.upnote || !msg) return;
      var box = peMed.upnote;
      box.textContent = '';
      box.hidden = false;
      var span = document.createElement('span');
      span.textContent = msg;
      box.appendChild(span);
      function btn(label, fn) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'btn sm gold-ghost';
        b.textContent = label;
        b.addEventListener('click', fn);
        box.appendChild(b);
        return b;
      }
      // A permanent wall is not an upload problem and must not offer an upload
      // remedy. 403 is the verify-email one, so it gets the composer's resend
      // button; every other wall (401 session, 402 trial) gets the sentence alone,
      // because a button that cannot help is worse than no button.
      if (kind === 'block') {
        if (peMed.blockStatus === 403 && csrf) {
          btn('Resend link', function () {
            // a detached form on <body>: a <form> nested inside the edit sheet's own
            // form would be dropped by the parser and submit the wrong thing
            var f = document.createElement('form');
            f.method = 'post'; f.action = '/verify-email/resend'; f.hidden = true;
            f.innerHTML = '<input type="hidden" name="_csrf" value="' + escHtml(csrf) + '">'
              + '<input type="hidden" name="return" value="' + escHtml(location.pathname + location.search) + '">';
            document.body.appendChild(f);
            f.submit();
          });
        }
        return;
      }
      // Only a chunked stream carries a real retry (upId + it.got survive, so the
      // pieces already on the server are never re-sent). upDrive attaches it.retry
      // AFTER the size check, so a file refused for being too big has none -- which
      // is the correct discriminator for "re-pick is the only way on".
      var can = peMed.list.filter(function (x) { return x.failed && typeof x.retry === 'function'; });
      if (kind === 'repick' || !can.length) {
        btn('Choose the video again', function () {
          peNoteClear();
          if (!peMed) return;
          /* Drop the tiles that can only be REPLACED. In the composer a dead thumb is
             cosmetic; here a tile is an attachment, and leaving a broken one in the
             strip next to its replacement is an invitation to wonder which one Save
             is going to send. */
          peMed.list.slice().forEach(function (x) {
            if (!x.failed || typeof x.retry === 'function') return;
            var ix = peMed.list.indexOf(x);
            if (ix >= 0) peMed.list.splice(ix, 1);
            if (x.el && x.el.parentNode) x.el.parentNode.removeChild(x.el);
          });
          peSync();
          peMed.input.click();
        });
        return;
      }
      btn(kind === 'restart' ? 'Start upload again' : 'Resume upload', function () {
        peNoteClear();
        peMed.warned = false;          // a second attempt may have something new to say
        can.forEach(function (x) {
          x.failed = false; x.fatal = false; x.tries = 0; x.trouble = 0; x.reTokened = false;
          x.failMsg = ''; x.failKind = ''; x.pmax = 0;
          pePaint(x);
          x.retry();
        });
        peSync();
        toast('Picking up where it left off…');
      });
    }

    /* ---- THE POST EDITOR'S HALF OF THE UPLOAD ENGINE -----------------------
       upDrive() (see its header) owns the transport: browser compression, the ONE
       shared congestion window, the progress-based stall watchdogs, ~6 MB
       /upload-chunk pieces with resume, and the instant stop on 401/402/403. This
       object is every place the editor differs from the composer, which is three
       things and no more:
         - there is no draft to persist: tickets are held in the strip until Save
         - there is no raw-FileList fallback to keep in step: Save posts tickets or
           it posts nothing, so nothing needs to mirror the bytes
         - the failure notice lives in the sheet, not in the compose form
       If you add a hook to upDrive, the composer's ctx (in stageStart) needs an
       answer for it too. */
    var peCtx = {
      /* `!t.cut` matters as well as list membership: peToggleCut drops a just-added
         tile by MARKING it cut and removing its element, without splicing it out of
         the list (peCount already skips it). Membership alone would therefore keep a
         cancelled attachment's upload alive and holding a slot in the shared window.
         peSave's 409 path empties the list outright, which this also covers. */
      alive: function (t) { return !!peMed && !t.cut && peMed.list.indexOf(t) >= 0; },
      paint: pePaint,
      persist: function () {},
      adopted: function () {},
      blockMsg: function () { return peMed ? peMed.block : null; },
      setBlock: function (msg, status) {
        var m = msg || (peMed && peMed.block) || 'Please verify your email to post.';
        if (peMed) { peMed.block = m; peMed.blockStatus = status; }
        peNote(m, 'block');
        return m;
      },
      warnOnce: function (msg, ms) { if (!peMed || peMed.warned) return; peMed.warned = true; toast(msg, ms); },
      note: peNote
    };

    /* Stage ONE file through the composer's OWN engine -- the composer's endpoints,
       the composer's HMAC claim ticket. A ticket is still the only thing the edit
       endpoint accepts, which is what makes the membership + verified-email gates on
       new media inherited rather than re-implemented. What changed on 2026-08-09 is
       only the transport: this used to be one XHR POST of the whole file, which is
       why it had to refuse anything over upload_max_filesize and then tell the member
       to go and post it somewhere that uploads in pieces. */
    function peStage(t, file) {
      t.file = file;
      t.size = file.size || 1;
      t.sent = 0; t.tries = 0; t.pmax = 0;
      t.done = false; t.failed = false; t.staging = true;
      if (t.el) t.el.classList.add('is-up');
      upDrive(t, peCtx);
    }
    function pePick(files) {
      if (!peMed || !files || !files.length) return;
      peMed.warned = false;        // per pick BATCH: twelve failures say one sentence, not twelve
      peNoteClear();
      Array.prototype.slice.call(files).forEach(function (file) {
        if (peCount() >= peMed.max) {
          toast('A post can hold up to ' + peMed.max + ' photos or videos.');
          return;
        }
        var isVid = String(file.type || '').indexOf('video') === 0;
        /* ---- WHAT IS STILL REFUSED AT PICK TIME, AND WHY IT IS ONLY THIS ------
           A PHOTO, because there is no image compressor on this path: nothing
           downstream can rescue an oversized one, so deferring the refusal would
           only delay the same answer.

           A VIDEO, only if it is past UP_PICK_VID_MAX -- so large that compressing
           it is an ordeal rather than a rescue. Everything under that goes to the
           compressor and is judged on the bytes it PRODUCES, at upDrive's
           UP_POST_VID_MAX check. That is the composer's rule, reached by calling
           the composer's code, and it is why the old 190 MB sentence is gone: the
           thing it told people to go and do is what now happens here.

           Both numbers are read from the composer's constants rather than restated,
           because two caps that must agree by hand are the bug this whole file
           keeps re-learning (the picker's 20 against stageStart's literal 10). */
        if (file.size > (isVid ? UP_PICK_VID_MAX : UP_IMG_MAX)) {
          toast(isVid
            ? (upSizeWords(file.size) + ' is more than we can process in the browser. Export it at a smaller size (1080p is plenty) and try again.')
            : (file.name + ' is ' + Math.round(file.size / 1048576) + ' MB, over the '
               + Math.floor(UP_IMG_MAX / 1048576) + ' MB photo limit.'), 7000);
          return;
        }
        var t = { isNew: true, cut: false, type: isVid ? 'video' : 'image', thumb: '', token: '' };
        try { t.thumb = isVid ? '' : URL.createObjectURL(file); } catch (e) {}
        peMed.strip.insertBefore(peTile(t), peMed.addBtn);
        peMed.list.push(t);
        peStage(t, file);
      });
      peSync();
    }

    function peBuild(sheet) {
      var wrap = document.createElement('div');
      wrap.className = 'pe-media';
      wrap.innerHTML =
        '<div class="pe-mhead"><span class="pe-mlabel">Attachments</span><span class="pe-mnote"></span></div>' +
        '<div class="pe-strip">' +
          '<button type="button" class="pe-add" aria-label="Add photos or video">' +
            '<span aria-hidden="true">+</span><span class="pe-addt">Add</span></button>' +
        '</div>' +
        // the persistent failure notice: hidden until there is something to say, and
        // it carries the Resume / Choose-again button (see peNote)
        '<div class="pe-upnote" hidden></div>' +
        // the fit override (0144). Hidden until there is at least one photo to have an opinion
        // about -- a text post, a video-only post and a post whose only slides were just cut all
        // show nothing here rather than an empty labelled box.
        '<div class="pe-fit" hidden>' +
          '<div class="pe-mhead"><span class="pe-mlabel">How it opens</span><span class="pe-fnote"></span></div>' +
          '<div class="pe-flist"></div>' +
        '</div>' +
        '<input type="file" class="pe-file" accept="image/*,video/mp4,video/webm,video/quicktime" multiple hidden>';
      sheet.insertBefore(wrap, sheet.querySelector('.pe-actions'));
      peMed = {
        max: 10, list: [], hasPoll: false,
        block: null, blockStatus: 0, warned: false,
        strip: wrap.querySelector('.pe-strip'),
        addBtn: wrap.querySelector('.pe-add'),
        input: wrap.querySelector('.pe-file'),
        note: wrap.querySelector('.pe-mnote'),
        upnote: wrap.querySelector('.pe-upnote'),
        fitWrap: wrap.querySelector('.pe-fit'),
        fitList: wrap.querySelector('.pe-flist'),
        fitNote: wrap.querySelector('.pe-fnote'),
        fitSig: null,
      };
      peMed.addBtn.addEventListener('click', function () { peMed.input.click(); });
      peMed.input.addEventListener('change', function () { pePick(this.files); this.value = ''; });
      peSync();
      return wrap;
    }
    function peLoad(id) {
      fetch('/post-media?post_id=' + encodeURIComponent(id), {
        credentials: 'same-origin',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      }).then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
        if (!peMed || !d || !d.ok || String(curId) !== String(id)) return;
        peMed.max = d.max || 10;
        (d.media || []).forEach(function (m) {
          // `fit` is the post's REAL stored state ('contain' | 'cover' | null), so the picker opens
          // showing what is actually set -- including a detector 'contain' the author wants to argue
          // with, which is the whole reason the control exists.
          var t = { isNew: false, cut: false, path: m.path, type: m.type, thumb: m.thumb || '',
                    fit: (m.fit === 'contain' || m.fit === 'cover') ? m.fit : 'auto',
                    key: m.key || m.path, state: m.state || 'ready', rv: m.ready_v || '', rp: m.ready_p || '' };
          peCropSeed(t, m);   // photo crop: croppable / crop / original (before peTile draws the button)
          peMed.strip.insertBefore(peTile(t), peMed.addBtn);
          peMed.list.push(t);
        });
        // the order the server gave -- a save only sends media_order[] when the member changed it
        peMed.loaded = (d.media || []).map(function (m) { return m.path; });
        peSync();
        peMoveSync();
        peExtrasLoad(d);
      }).catch(function () {});
    }
    /* Replace every rendered copy of the post with the card the SERVER just rendered. */
    /* `land` (optional): the slide every copy should show afterwards (a one-slide delete lands on the next
       one). Absent, each copy KEEPS the slide it was on -- a save from the viewer returns to the same post
       AND the same slide, not to slide 1. */
    function peRepaint(id, land) {
      return fetch('/post-cards?feed=1&ids=' + encodeURIComponent(id), {
        credentials: 'same-origin', cache: 'no-store',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      }).then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
        var tmp = document.createElement('div');
        tmp.innerHTML = (d && d.html) || '';
        var fresh = tmp.querySelector('.post[data-id]');
        if (!fresh) return false;
        var olds = document.querySelectorAll('.post[data-view="' + id + '"]');
        if (!olds.length) return false;
        var n = 0;
        Array.prototype.forEach.call(olds, function (old) {
          var oc = old.querySelector('.media.carousel');
          var at = typeof land === 'number' ? land : ((oc && oc.__cidx) ? oc.__cidx() : 0);
          var node = n++ === 0 ? fresh : fresh.cloneNode(true);
          // A VIEWER card goes back through the viewer's own insert sequence (zoom/fit bar, folded actions,
          // clamp, containment, drift) -- a bare swap left a plain card inside the viewer (Rob, 2026-09-30).
          var inViewer = old.closest && old.closest('.pfeed') && window.__rovaPfeedReplace
            ? window.__rovaPfeedReplace(old, node) : null;
          if (!inViewer) {
            old.parentNode.replaceChild(node, old);
            try { initCarousels(node); } catch (e) {}
            try { initEmbeds(node); } catch (e) {}
            try { if (window.__rovaHydrate) window.__rovaHydrate(node); } catch (e) {}
          }
          var nc = node.querySelector('.media.carousel');
          if (nc && at > 0) {
            var cnt = nc.querySelectorAll('.cslide').length;
            var go = Math.min(at, Math.max(0, cnt - 1));
            // after the carousel has measured itself (initCarousels lays out on the next frame)
            requestAnimationFrame(function () { requestAnimationFrame(function () { try { if (nc.__cgo) nc.__cgo(go); } catch (e) {} }); });
          }
        });
        return true;
      }).catch(function () { return false; });
    }

    /* ==== THE FULL EDITOR (2026-09-30, Rob: "a user doesn't get the full editing menu") =====================
       The viewer and the feed card always opened THIS modal (one builder, one editor), and it only ever
       carried caption + attachments + "How it opens". The composer's tools were the gap. They are here now,
       each riding the composer's OWN machinery wherever it is shareable, so there is no second copy:
         - Photo or video  -> the attachment strip's own Add (peStage / upDrive, the composer's upload engine)
         - GIF             -> the shared .js-gif picker; the pick lands through form.__rovaOnGif as a NEW TILE
                              (a GIF is post media, exactly as on compose) and is sent as gif_add[]
         - Emoji           -> the shared .emoji-btn picker (it types into this form's first textarea)
         - Poll            -> poll_options[] / poll_duration / poll_remove (Polls, via post_extras_apply)
         - Place           -> the composer's /place-search picker (window.__rovaTripWire) -> trip_* fields
         - Music           -> the composer's "Add music" picker where the page has it (a pick is a LINK in the
                              body, exactly as on compose); a paste-a-link field where it does not
         - Co-author       -> collab_with / collab_remove (Collabs)
         - Keep off grid / Made with AI -> grid_hidden / ai_declared
       Threads and Schedule are deliberately absent: a published post is neither a thread nor unpublished.
       Every ADD is gated like posting (post_edit_add_gate); a lapsed member gets the same red note a Post tap
       does. Only CHANGED fields are sent, so re-saving an untouched editor writes nothing new. */
    var peX = null;
    var PE_GLYPH = {
      media: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7 6V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1"/><rect x="3" y="7" width="14" height="14" rx="2.5"/><path d="M8.6 11.1v5.8l4.9-2.9z" fill="currentColor"/></svg>',
      gif: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="1.5" y="6" width="21" height="12" rx="3.4" stroke="currentColor" stroke-width="1.5"/><text x="12" y="15.3" text-anchor="middle" font-size="9.6" font-weight="800" letter-spacing="-.4" fill="currentColor" font-family="-apple-system,BlinkMacSystemFont,Segoe UI,Arial,sans-serif">GIF</text></svg>',
      emoji: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M8 14s1.5 2 4 2 4-2 4-2"/><line x1="9" y1="9" x2="9.01" y2="9"/><line x1="15" y1="9" x2="15.01" y2="9"/></svg>',
      poll: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="6" y1="20" x2="6" y2="12"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="18" y1="20" x2="18" y2="9"/></svg>',
      trip: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/></svg>',
      music: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 18V5l12-2v13"/><circle cx="6" cy="18" r="3"/><circle cx="18" cy="16" r="3"/></svg>',
      collab: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>'
    };
    var PE_MUSIC_RE = /https?:\/\/(?:[a-z0-9-]+\.)*(?:spotify\.com|spotify\.link|soundcloud\.com|snd\.sc|youtube\.com|youtu\.be|youtube-nocookie\.com|music\.apple\.com)\/[^\s<]+/i;

    /* ONE "Processing / Couldn't process" tile, the JS twin of VideoJobs::stateTile() (lib/videojobs.php):
       same classes, same words, same spinner -- the feed card, the viewer, both grids and this editor read as
       one thing. A processing tile carries .gp-processing + data-v/data-p so the page's ONE /media-ready poller
       watches it; a caller that wants the answer itself sets el.__rovaOnReady (the poller calls it instead of
       swapping). A failed tile is never polled. */
    window.__rovaVideoStateTile = function (state, readyV, readyP) {
      if (state === 'failed') {
        return '<span class="vstate vstate-tile vfailed" role="status"><span class="vstate-ic" aria-hidden="true">'
          + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="9"/><path d="M12 7.5v5.5M12 16.5v.01"/></svg>'
          + '</span><span class="vstate-l">Couldn’t process</span></span>';
      }
      return '<span class="vstate vstate-tile' + (readyV ? ' gp-processing' : '') + '" role="status"'
        + (readyV ? ' data-v="' + escHtml(readyV) + '" data-p="' + escHtml(readyP || '') + '"' : '')
        + '><span class="vproc-spin" aria-hidden="true"></span><span class="vstate-l">Processing</span></span>';
    };

    function peNoteBlock(msg) {
      if (!peX || !peX.note) { toast(msg); return; }
      peX.note.textContent = msg; peX.note.hidden = false;
      try { peX.note.scrollIntoView({ block: 'nearest' }); } catch (e) {}
    }

    /* ---- tiles: state, move buttons, drag-to-reorder ------------------------------------------------- */
    function peTileDecorate(t, el) {
      var pic = el.querySelector('img, .pe-noimg');
      if (t.type === 'video' && (t.state === 'processing' || t.state === 'failed')) {
        if (pic) { pic.remove(); }
        el.insertAdjacentHTML('afterbegin', window.__rovaVideoStateTile(t.state, t.rv, t.rp));
        el.classList.add(t.state === 'failed' ? 'is-txfail' : 'is-proc');
        var st = el.querySelector('.gp-processing');
        if (st) { st.__rovaOnReady = function () { peRefreshItem(t); }; }
      }
      var img = el.querySelector('img'); if (img) { img.draggable = false; }
      el.insertAdjacentHTML('beforeend',
        '<span class="pe-mv"><button type="button" class="pe-ml" aria-label="Move earlier" title="Move earlier">'
        + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m14.5 6-6 6 6 6"/></svg></button>'
        + '<button type="button" class="pe-mr" aria-label="Move later" title="Move later">'
        + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9.5 6 6 6-6 6"/></svg></button></span>');
      el.querySelector('.pe-ml').addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); peMove(t, -1); });
      el.querySelector('.pe-mr').addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); peMove(t, 1); });
      el.addEventListener('pointerdown', function (e) { peDragStart(e, t, el); });
      el.addEventListener('contextmenu', function (e) { if (el.classList.contains('is-dragging') || el._peLp) e.preventDefault(); });
    }
    function peTiles() { return peMed ? Array.prototype.slice.call(peMed.strip.querySelectorAll('.pe-tile')) : []; }
    // the list follows the DOM: whatever order the strip shows is the order Save sends
    function peOrderFromDom() {
      if (!peMed) return;
      var byEl = new Map();
      peMed.list.forEach(function (t) { if (t.el) byEl.set(t.el, t); });
      var ordered = [];
      peTiles().forEach(function (el) { var t = byEl.get(el); if (t) ordered.push(t); });
      peMed.list.forEach(function (t) { if (ordered.indexOf(t) < 0) ordered.push(t); });   // cut-and-removed new tiles
      peMed.list.splice.apply(peMed.list, [0, peMed.list.length].concat(ordered));
      peMed.fitSig = null;          // the rows (and their slide numbers) follow the new order
      peSync();
      peMoveSync();
    }
    function peMoveSync() {
      var tiles = peTiles();
      tiles.forEach(function (el, i) {
        el.querySelector('.pe-ml').disabled = i === 0;
        el.querySelector('.pe-mr').disabled = i === tiles.length - 1;
      });
    }
    function peMove(t, d) {
      if (!peMed || !t.el) return;
      var tiles = peTiles(), i = tiles.indexOf(t.el), j = i + d;
      if (i < 0 || j < 0 || j >= tiles.length) return;
      if (d < 0) { peMed.strip.insertBefore(t.el, tiles[j]); } else { peMed.strip.insertBefore(t.el, tiles[j].nextSibling); }
      peOrderFromDom();
      var b = t.el.querySelector(d < 0 ? '.pe-ml' : '.pe-mr');
      if (b && b.disabled) { b = t.el.querySelector(d < 0 ? '.pe-mr' : '.pe-ml'); }
      try { b.focus({ preventScroll: true }); } catch (e) {}
    }
    /* DRAG. Mouse: a press that moves 5px. Touch/pen: a LONG PRESS (380ms, finger still) -- a plain swipe
       over the strip must keep scrolling the sheet, so the drag only exists once the press has been held.
       Once dragging, the tile follows the pointer (transform) and the strip re-orders LIVE under it; the
       non-passive touchmove on the sheet stops iOS scrolling for exactly that gesture. */
    var peDrag = null;
    function peDragStart(e, t, el) {
      if (!peMed || e.button > 0) return;
      if (e.target.closest && e.target.closest('button')) return;       // X / move buttons keep their taps
      var touch = e.pointerType !== 'mouse';
      var d = { t: t, el: el, id: e.pointerId, x0: e.clientX, y0: e.clientY, x: e.clientX, y: e.clientY,
                on: false, touch: touch, lp: 0 };
      peDrag = d;
      if (touch) {
        d.lp = setTimeout(function () { if (peDrag === d) { el._peLp = 1; peDragBegin(d); } }, 380);
      }
      document.addEventListener('pointermove', peDragMove, true);
      document.addEventListener('pointerup', peDragEnd, true);
      document.addEventListener('pointercancel', peDragEnd, true);
    }
    function peDragBegin(d) {
      d.on = true;
      var r = d.el.getBoundingClientRect();
      d.gx = d.x - r.left; d.gy = d.y - r.top;          // where on the tile it was grabbed
      d.el.classList.add('is-dragging');
      peMed.strip.classList.add('is-sorting');
      try { d.el.setPointerCapture(d.id); } catch (e) {}
      if (navigator.vibrate) { try { navigator.vibrate(8); } catch (e) {} }
      pePlace(d);
    }
    function pePlace(d) {
      d.el.style.transform = '';
      var r = d.el.getBoundingClientRect();
      d.el.style.transform = 'translate(' + Math.round(d.x - d.gx - r.left) + 'px,' + Math.round(d.y - d.gy - r.top) + 'px) scale(1.06)';
    }
    function peDragMove(e) {
      var d = peDrag; if (!d || e.pointerId !== d.id) return;
      d.x = e.clientX; d.y = e.clientY;
      if (!d.on) {
        var moved = Math.abs(d.x - d.x0) + Math.abs(d.y - d.y0);
        if (d.touch) { if (moved > 10) { clearTimeout(d.lp); peDragDrop(); } return; }   // a scroll, not a hold
        if (moved < 5) return;
        peDragBegin(d);
      }
      e.preventDefault();
      // which tile is under the pointer? (the dragged tile itself is pointer-events:none while sorting)
      var hit = document.elementFromPoint(d.x, d.y);
      var over = hit && hit.closest ? hit.closest('.pe-tile') : null;
      if (over && over !== d.el && over.parentNode === peMed.strip) {
        var r = over.getBoundingClientRect();
        var after = d.x > r.left + r.width / 2;
        peMed.strip.insertBefore(d.el, after ? over.nextSibling : over);
      }
      pePlace(d);
    }
    function peDragDrop() {
      document.removeEventListener('pointermove', peDragMove, true);
      document.removeEventListener('pointerup', peDragEnd, true);
      document.removeEventListener('pointercancel', peDragEnd, true);
      peDrag = null;
    }
    function peDragEnd(e) {
      var d = peDrag; if (!d || (e && e.pointerId !== d.id)) return;
      clearTimeout(d.lp);
      peDragDrop();
      if (!d.on) {
        d.el._peLp = 0;
        // a plain TAP picks the tile and shows its move arrows (the touch path that needs no drag)
        if (Math.abs(d.x - d.x0) + Math.abs(d.y - d.y0) < 10) {
          var was = d.el.classList.contains('is-picked');
          peTiles().forEach(function (x) { x.classList.remove('is-picked'); });
          d.el.classList.toggle('is-picked', !was);
        }
        return;
      }
      d.el.classList.remove('is-dragging');
      d.el.style.transform = '';
      if (peMed) { peMed.strip.classList.remove('is-sorting'); }
      setTimeout(function () { d.el._peLp = 0; }, 400);
      // a drag must not also read as a tap on whatever it was released over
      var swallow = function (ev) { ev.preventDefault(); ev.stopPropagation(); };
      document.addEventListener('click', swallow, true);
      setTimeout(function () { document.removeEventListener('click', swallow, true); }, 0);
      peOrderFromDom();
    }

    /* A clip that was processing when the editor opened has FINISHED: the worker also re-pointed the post
       row at the <stem>_w.mp4 output, so the editor's stored path is stale (a save naming the old .mov would
       409). Re-read the server's truth for that one item and swap the tile to its real poster, in place. */
    function peRefreshItem(t) {
      var id = curId; if (!id) return;
      fetch('/post-media?post_id=' + encodeURIComponent(id), { credentials: 'same-origin',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
          if (!d || !d.ok || !peMed || String(curId) !== String(id)) return;
          var stem = String(t.path || '').replace(/\.[A-Za-z0-9]+$/, '');
          var m = (d.media || []).filter(function (x) { return String(x.path).indexOf(stem) === 0; })[0];
          if (!m || m.state === 'processing') return;
          t.path = m.path; t.key = m.key || m.path; t.state = m.state; t.thumb = m.thumb || '';
          var st = t.el && t.el.querySelector('.vstate'); if (st) st.remove();
          if (t.el) {
            t.el.classList.remove('is-proc');
            if (m.state === 'failed') { t.el.insertAdjacentHTML('afterbegin', window.__rovaVideoStateTile('failed')); t.el.classList.add('is-txfail'); }
            else { t.el.insertAdjacentHTML('afterbegin', t.thumb ? '<img src="' + escHtml(t.thumb) + '" alt="" draggable="false">' : '<span class="pe-noimg" aria-hidden="true">&#9654;</span>'); }
          }
          peMed.fitSig = null; peSync();
        }).catch(function () {});
    }

    /* ---- the GIF tool: a pick becomes a NEW TILE (compose's gif_url, as media) ---------------------------- */
    function peAddGif(url, preview) {
      if (!peMed) return;
      if (peCount() >= peMed.max) { toast('A post can hold up to ' + peMed.max + ' photos or videos.'); return; }
      var t = { isNew: true, gif: url, cut: false, type: 'image', thumb: preview || url, token: '', done: true, state: 'ready' };
      peMed.strip.insertBefore(peTile(t), peMed.addBtn);
      t.el.classList.add('is-gif');
      peMed.list.push(t);
      peSync(); peMoveSync();
    }

    /* ---- music: a song is a LINK in the body, exactly as on compose ----------------------------------- */
    function peMusicOf(text) { var m = PE_MUSIC_RE.exec(String(text || '')); return m ? m[0].replace(/[.,;:!?)\]]+$/, '') : ''; }
    function peMusicPaint() {
      if (!peX || !taEl) return;
      var url = peMusicOf(taEl.value);
      if (url === peX.musicShown) return;
      peX.musicShown = url;
      var box = peX.musicCard;
      if (!url) { box.hidden = true; box.innerHTML = ''; return; }
      var host = ''; try { host = new URL(url).hostname.replace(/^www\./, ''); } catch (e) {}
      box.hidden = false;
      box.innerHTML = '<span class="pe-mus-ic" aria-hidden="true">' + PE_GLYPH.music + '</span>'
        + '<span class="pe-mus-t"><b>Song</b><span class="pe-mus-u"></span></span>'
        + '<button type="button" class="pe-mus-x" aria-label="Remove the song">&times;</button>';
      box.querySelector('.pe-mus-u').textContent = host;
      box.querySelector('.pe-mus-x').addEventListener('click', function () {
        var v = taEl.value, i = v.indexOf(url);
        if (i >= 0) { taEl.value = (v.slice(0, i) + v.slice(i + url.length)).replace(/ {2,}/g, ' ').replace(/\s+$/, ''); }
        taEl._musicPick = '';
        peX.musicChanged = true;
        taEl.dispatchEvent(new Event('input'));
      });
      // the song's own title, when the server already knows it (/link-preview is the composer's call)
      fetch('/link-preview?text=' + encodeURIComponent(url), { credentials: 'same-origin', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.ok ? r.json() : null; }).then(function (res) {
          if (!peX || peX.musicShown !== url || !res) return;
          var tmp = document.createElement('div'); tmp.innerHTML = res.embed || res.card || '';
          var ttl = tmp.querySelector('.am-title, .emb-title, .lc-title, [class*="title"]');
          var b = box.querySelector('.pe-mus-t b'); if (ttl && b) { b.textContent = ttl.textContent.trim().slice(0, 80) || 'Song'; }
        }).catch(function () {});
    }
    // THE PICKER'S DOOR INTO THIS EDITOR (the "Add music" picker's pick() hands over here for a .pe-form):
    // replace the previous pick, append the new link as its own token, respect the field's maxlength.
    window.__rovaPeAttachLink = function (ta, url, replace) {
      if (!ta || !url) return false;
      var v = ta.value;
      if (replace && replace !== url) {
        var i = v.indexOf(replace);
        if (i >= 0) { v = (v.slice(0, i) + v.slice(i + replace.length)).replace(/ {2,}/g, ' '); }
      } else {
        var old = peMusicOf(v);                       // one song per post: a new pick swaps the old one
        if (old && old !== url) { v = v.replace(old, '').replace(/ {2,}/g, ' '); }
      }
      if (v.indexOf(url) < 0) v = v + (v === '' || /\s$/.test(v) ? '' : ' ') + url;
      var ml = parseInt(ta.getAttribute('maxlength'), 10) || 0;
      if (ml && v.length > ml) return false;
      ta.value = v;
      if (peX) peX.musicChanged = true;
      ta.dispatchEvent(new Event('input'));
      return true;
    };

    /* ---- building the tools + panels ----------------------------------------------------------------- */
    function peToolsBuild(sheet) {
      var musicLive = typeof window.__rovaMusicPickBusy === 'function' && !!document.getElementById('music-pick');
      var wrap = document.createElement('div');
      wrap.className = 'pe-extras';
      wrap.innerHTML =
        '<div class="pe-tools" role="toolbar" aria-label="Add to your post">'
        + '<button type="button" class="ctool pe-t pe-t-media" data-add="1" title="Photo or video" aria-label="Photo or video">' + PE_GLYPH.media + '</button>'
        + '<button type="button" class="ctool pe-t js-gif" data-add="1" title="Add a GIF" aria-label="Add a GIF">' + PE_GLYPH.gif + '</button>'
        + '<button type="button" class="ctool pe-t emoji-btn" title="Emoji" aria-label="Add emoji">' + PE_GLYPH.emoji + '</button>'
        + '<button type="button" class="ctool pe-t pe-t-poll" data-add="1" title="Poll" aria-label="Poll" aria-expanded="false">' + PE_GLYPH.poll + '</button>'
        + '<button type="button" class="ctool pe-t pe-t-trip" data-add="1" title="Place or trip" aria-label="Place or trip" aria-expanded="false">' + PE_GLYPH.trip + '</button>'
        + '<button type="button" class="ctool pe-t pe-t-music' + (musicLive ? ' js-music' : '') + '" data-add="1" title="Add music" aria-label="Add music"'
        +   (musicLive ? ' aria-haspopup="dialog" aria-controls="music-pick"' : '') + ' aria-expanded="false">' + PE_GLYPH.music + '</button>'
        + '<button type="button" class="ctool pe-t pe-t-collab" data-add="1" title="Co-author" aria-label="Invite a co-author" aria-expanded="false" hidden>' + PE_GLYPH.collab + '</button>'
        + '</div>'
        + '<div class="pe-lock" role="status" hidden></div>'
        + '<div class="pe-mus" hidden></div>'
        + '<div class="pe-panel pe-muspaste" hidden><div class="pe-plab">Add music</div>'
        +   '<div class="pe-row"><input class="input pe-mus-in" type="url" inputmode="url" placeholder="Paste a Spotify, Apple Music, SoundCloud or YouTube link" aria-label="Song link">'
        +   '<button type="button" class="btn sm gold-ghost pe-mus-add">Add</button></div></div>'
        + '<div class="pe-panel pe-poll" hidden><div class="pe-plab">Poll <span class="pe-pnote muted"></span></div>'
        +   '<div class="pe-popts"></div>'
        +   '<div class="pe-row pe-pbar"><label class="poll-len">Closes <select class="input pe-pdur">'
        +     '<option value="">Keep as is</option><option value="0">No limit</option><option value="1">in 1 day</option>'
        +     '<option value="3">in 3 days</option><option value="7">in 1 week</option></select></label>'
        +   '<button type="button" class="btn sm gold-ghost pe-padd">+ Add option</button>'
        +   '<button type="button" class="btn sm pe-prm">Remove poll</button></div></div>'
        + '<div class="pe-panel pe-trip" hidden><div class="pe-plab">Place</div>'
        +   '<div class="trip-ed-row"><select class="input trip-ed-kind pe-tkind" aria-label="Trip type"><option value="travel">Traveling to</option><option value="checkin">Checking in at</option></select>'
        +   '<div class="trip-ed-field"><input class="input trip-ed-search pe-tto" maxlength="110" autocomplete="off" placeholder="Search a city or country" aria-label="Destination" role="combobox" aria-expanded="false" aria-autocomplete="list">'
        +   '<div class="trip-sugg pe-ttol" role="listbox" hidden></div></div></div>'
        +   '<div class="trip-ed-row trip-ed-from pe-tfromrow"><span class="trip-ed-lab muted">From</span><div class="trip-ed-field">'
        +   '<input class="input trip-ed-search pe-tfrom" maxlength="110" autocomplete="off" placeholder="Optional starting point" aria-label="Starting point" role="combobox" aria-expanded="false" aria-autocomplete="list">'
        +   '<div class="trip-sugg pe-tfroml" role="listbox" hidden></div></div></div>'
        +   '<input type="hidden" class="pe-ttoid"><input type="hidden" class="pe-ttotext"><input type="hidden" class="pe-tfromid">'
        +   '<div class="pe-row"><span class="muted trip-ed-hint">Shown at city level.</span><button type="button" class="btn sm pe-trm">Remove place</button></div></div>'
        + '<div class="pe-panel pe-collab" hidden><div class="pe-plab">Co-author</div>'
        +   '<div class="pe-ccur" hidden></div>'
        +   '<input class="input pe-cin" maxlength="31" autocomplete="off" placeholder="@handle (you must follow each other)" aria-label="Co-author handle">'
        +   '<span class="muted pe-hint">Co-posts show on both profiles once they accept.</span></div>'
        + '<label class="pe-chk pe-cgrid" hidden><input type="checkbox" class="pe-grid"><span>Keep this off my profile grid</span></label>'
        + '<label class="pe-chk pe-cai" hidden><input type="checkbox" class="pe-ai"><span>This post was made with AI</span></label>';
      taEl.insertAdjacentElement('afterend', wrap);
      var q = function (s) { return wrap.querySelector(s); };
      peX = { wrap: wrap, note: q('.pe-lock'), musicCard: q('.pe-mus'), canAdd: true, block: '', seed: null,
              musicChanged: false, musicShown: null, pollOn: false, pollRemoved: false, tripRemoved: false, collabRemoved: false };
      // GIF picks land here (the shared picker's selectGif asks the form first)
      sheet.__rovaOnGif = function (url, preview) { peAddGif(url, preview); };
      // every ADD tool meets the posting gate BEFORE its picker opens (capture: ahead of the shared delegates)
      wrap.addEventListener('click', function (e) {
        var b = e.target.closest ? e.target.closest('.pe-t[data-add]') : null;
        if (!b || !peX || peX.canAdd) return;
        e.preventDefault(); e.stopPropagation();
        peNoteBlock(peX.block || 'An active membership is needed to add to a post.');
      }, true);
      q('.pe-t-media').addEventListener('click', function () { if (peMed) peMed.input.click(); });
      var panel = function (btn, box, on) {
        box.hidden = !on; btn.classList.toggle('on', on); btn.setAttribute('aria-expanded', on ? 'true' : 'false');
      };
      // POLL
      var popts = q('.pe-popts');
      function pollRow(val) {
        var n = popts.querySelectorAll('input').length;
        if (n >= 4) return;
        var i = document.createElement('input');
        i.className = 'input poll-opt-input'; i.maxLength = 80; i.placeholder = 'Option ' + (n + 1); i.value = val || '';
        popts.appendChild(i);
      }
      peX.pollRow = pollRow;
      q('.pe-t-poll').addEventListener('click', function () {
        var on = q('.pe-poll').hidden;
        if (on && !popts.children.length) { pollRow(''); pollRow(''); }
        if (on) { peX.pollRemoved = false; }
        panel(this, q('.pe-poll'), on); peX.pollOn = !q('.pe-poll').hidden;
        if (on) { var f = popts.querySelector('input:not([disabled])'); if (f) f.focus(); }
      });
      q('.pe-padd').addEventListener('click', function () { pollRow(''); });
      q('.pe-prm').addEventListener('click', function () {
        popts.innerHTML = ''; q('.pe-pnote').textContent = ''; q('.pe-pdur').value = '';
        peX.pollRemoved = !!(peX.seed && peX.seed.poll); peX.pollOn = false;
        panel(q('.pe-t-poll'), q('.pe-poll'), false);
        if (peMed) peMed.hasPoll = false;
      });
      // PLACE (the composer's own /place-search picker)
      var tkind = q('.pe-tkind'), fromRow = q('.pe-tfromrow');
      var syncKind = function () { var c = tkind.value === 'checkin'; fromRow.hidden = c; q('.pe-tto').placeholder = c ? 'Search a place' : 'Search a city or country'; };
      tkind.addEventListener('change', syncKind);
      if (window.__rovaTripWire) {
        window.__rovaTripWire(q('.pe-tto'), q('.pe-ttol'), q('.pe-ttoid'), q('.pe-ttotext'));
        window.__rovaTripWire(q('.pe-tfrom'), q('.pe-tfroml'), q('.pe-tfromid'), null);
      }
      q('.pe-t-trip').addEventListener('click', function () {
        var on = q('.pe-trip').hidden; panel(this, q('.pe-trip'), on);
        if (on) { peX.tripRemoved = false; syncKind(); q('.pe-tto').focus(); }
      });
      q('.pe-trm').addEventListener('click', function () {
        ['.pe-tto', '.pe-tfrom', '.pe-ttoid', '.pe-ttotext', '.pe-tfromid'].forEach(function (s) { q(s).value = ''; });
        peX.tripRemoved = !!(peX.seed && peX.seed.trip);
        panel(q('.pe-t-trip'), q('.pe-trip'), false);
      });
      // MUSIC: the picker where the page has it; otherwise a paste field
      if (!musicLive) {
        q('.pe-t-music').addEventListener('click', function () {
          var on = q('.pe-muspaste').hidden; panel(this, q('.pe-muspaste'), on);
          if (on) q('.pe-mus-in').focus();
        });
        q('.pe-mus-add').addEventListener('click', function () {
          var u = peMusicOf(q('.pe-mus-in').value);
          if (!u) { toast('That link is not a song. Paste a Spotify, Apple Music, SoundCloud or YouTube link.'); return; }
          if (!window.__rovaPeAttachLink(taEl, u, '')) { toast('Your post is too long to add a song.'); return; }
          q('.pe-mus-in').value = ''; panel(q('.pe-t-music'), q('.pe-muspaste'), false);
        });
      }
      taEl.addEventListener('input', peMusicPaint);
      // CO-AUTHOR
      q('.pe-t-collab').addEventListener('click', function () {
        var on = q('.pe-collab').hidden; panel(this, q('.pe-collab'), on); if (on) q('.pe-cin').focus();
      });
      return wrap;
    }
    // seed every panel from the server's state (post_edit_state) -- the editor opens showing the TRUTH
    function peExtrasLoad(d) {
      if (!peX || !d) return;
      var q = function (s) { return (modal || peX.wrap).querySelector(s); };
      peX.seed = { poll: d.poll || null, trip: d.trip || null, collab: d.collab || null,
                   grid: !!d.grid_hidden, ai: d.ai || { marked: false } };
      peX.canAdd = d.can_add !== false; peX.block = d.add_block || '';
      var caps = d.caps || {};
      if (caps.collab) q('.pe-t-collab').hidden = false;
      if (caps.trip === false) q('.pe-t-trip').hidden = true;
      if (d.poll) {
        var popts = q('.pe-popts'); popts.innerHTML = '';
        d.poll.options.forEach(function (o) { peX.pollRow(o.text); });
        if (d.poll.locked) {
          Array.prototype.forEach.call(popts.querySelectorAll('input'), function (i) { i.disabled = true; });
          q('.pe-padd').hidden = true;
          q('.pe-pnote').textContent = '· ' + d.poll.total + (d.poll.total === 1 ? ' vote' : ' votes') + ', options locked';
        }
        q('.pe-poll').hidden = false; q('.pe-t-poll').classList.add('on'); peX.pollOn = true;
        if (peMed) peMed.hasPoll = true;
      }
      if (d.trip) {
        q('.pe-tkind').value = d.trip.kind === 'checkin' ? 'checkin' : 'travel';
        q('.pe-tto').value = d.trip.to || '';
        q('.pe-ttoid').value = d.trip.to_place_id ? String(d.trip.to_place_id) : '';
        q('.pe-ttotext').value = d.trip.to_place_id ? '' : (d.trip.to || '');
        q('.pe-tfrom').value = d.trip.from || '';
        q('.pe-tfromrow').hidden = d.trip.kind === 'checkin';
        q('.pe-trip').hidden = false; q('.pe-t-trip').classList.add('on');
      }
      if (d.collab) {
        var cur = q('.pe-ccur');
        cur.hidden = false;
        cur.innerHTML = '<span></span><button type="button" class="btn sm pe-crm">Remove</button>';
        cur.firstChild.textContent = '@' + d.collab.username + (d.collab.status === 'accepted' ? ' · co-author' : (d.collab.status === 'pending' ? ' · invited' : ' · ' + d.collab.status));
        q('.pe-cin').hidden = true;
        cur.querySelector('.pe-crm').addEventListener('click', function () {
          peX.collabRemoved = true; cur.hidden = true; q('.pe-cin').hidden = false;
        });
        q('.pe-collab').hidden = false; q('.pe-t-collab').classList.add('on');
      }
      // the two post-level switches sit under the attachments, the composer's own place for them
      var acts = modal && modal.querySelector('.pe-actions');
      if (acts) { acts.parentNode.insertBefore(q('.pe-cgrid'), acts); acts.parentNode.insertBefore(q('.pe-cai'), acts); }
      if (d.grid_hideable) { q('.pe-cgrid').hidden = false; q('.pe-grid').checked = !!d.grid_hidden; }
      if (caps.ai !== false && (d.media || []).length) {
        q('.pe-cai').hidden = false;
        if (d.ai && d.ai.marked) {
          q('.pe-ai').checked = true; q('.pe-ai').disabled = true;
          q('.pe-cai span').textContent = 'Marked as made with AI';
        }
      }
      peMusicPaint();
    }
    // append ONLY what changed -- an untouched editor sends exactly what it sent before this existed
    function peExtrasAppend(fd) {
      if (!peMed) return;
      // gifs + the slide order (stable keys: the stored path, or new:N over media_add ++ gif_add)
      var tokens = [], gifs = [], order = [], natural = [];
      peMed.list.forEach(function (t) { if (t.isNew && !t.cut && !t.failed && t.token && !t.gif) tokens.push(t); });
      peMed.list.forEach(function (t) { if (t.isNew && !t.cut && t.gif) gifs.push(t); });
      gifs.forEach(function (t) { fd.append('gif_add[]', t.gif); });
      peMed.list.forEach(function (t) {
        if (t.cut || t.failed) return;
        if (!t.isNew) { order.push(t.path); return; }
        var i = tokens.indexOf(t), j = gifs.indexOf(t);
        if (i >= 0) order.push('new:' + i); else if (j >= 0) order.push('new:' + (tokens.length + j));
      });
      (peMed.loaded || []).forEach(function (p) { if (order.indexOf(p) >= 0) natural.push(p); });
      tokens.forEach(function (t, i) { natural.push('new:' + i); });
      gifs.forEach(function (t, j) { natural.push('new:' + (tokens.length + j)); });
      if (order.join('\n') !== natural.join('\n')) { order.forEach(function (k) { fd.append('media_order[]', k); }); }
      if (!peX || !peX.seed) return;
      var q = function (s) { return (modal || peX.wrap).querySelector(s); };
      var S = peX.seed;
      // POLL
      if (peX.pollRemoved && S.poll) { fd.append('poll_remove', '1'); }
      else if (peX.pollOn) {
        var opts = Array.prototype.map.call(q('.pe-popts').querySelectorAll('input'), function (i) { return i.value.trim(); })
          .filter(function (v) { return v; });
        var was = S.poll ? S.poll.options.map(function (o) { return o.text; }) : [];
        if (opts.join('\n') !== was.join('\n') && !(S.poll && S.poll.locked)) {
          opts.forEach(function (o) { fd.append('poll_options[]', o); });
          if (opts.length === 1) { /* the server answers with the sentence */ }
        }
        if (q('.pe-pdur').value !== '') fd.append('poll_duration', q('.pe-pdur').value);
      }
      // PLACE
      if (peX.tripRemoved && S.trip) { fd.append('trip_remove', '1'); }
      else if (!q('.pe-trip').hidden) {
        var kind = q('.pe-tkind').value, toId = q('.pe-ttoid').value, toText = q('.pe-ttotext').value || (toId ? '' : q('.pe-tto').value.trim());
        var fromId = kind === 'travel' ? q('.pe-tfromid').value : '';
        var same = S.trip && S.trip.kind === kind && ((toId && String(S.trip.to_place_id || '') === toId) || (!toId && toText === S.trip.to))
          && ((q('.pe-tfrom').value.trim() || null) === (S.trip.from || null));
        if ((toId || toText) && !same) {
          fd.append('trip_kind', kind);
          if (toId) fd.append('trip_to', toId); else fd.append('trip_to_text', toText);
          if (fromId) fd.append('trip_from', fromId);
        }
      }
      // CO-AUTHOR
      if (peX.collabRemoved && S.collab) fd.append('collab_remove', '1');
      var h = q('.pe-cin').value.trim().replace(/^@/, '');
      if (h && !q('.pe-cin').hidden) fd.append('collab_with', h);
      // GRID + AI
      if (!q('.pe-cgrid').hidden && q('.pe-grid').checked !== S.grid) fd.append('grid_hidden', q('.pe-grid').checked ? '1' : '0');
      if (!q('.pe-cai').hidden && !q('.pe-ai').disabled && q('.pe-ai').checked) fd.append('ai_declared', '1');
    }

    /* ---- "Delete this photo / video": ONE slide of a carousel, from the post's own menu ----------------- */
    function peSlideOf(post) {
      var car = post && post.querySelector('.media.carousel');
      if (!car) return null;
      var slides = car.querySelectorAll('.carousel-track > .cslide, .cslide');
      var i = car.__cidx ? car.__cidx() : 0;
      var s = slides[i]; if (!s) return null;
      return { car: car, idx: i, n: slides.length, path: s.getAttribute('data-path') || '',
               kind: s.querySelector('video, .vprocessing, .vstate') ? 'video' : 'photo' };
    }
    window.__rovaSlideDelSync = function (panel) {
      var b = panel && panel.querySelector('.js-slide-del'); if (!b) return;
      var s = peSlideOf(panel.closest('.post'));
      if (!s || s.n < 2 || !s.path) { b.hidden = true; return; }
      b.hidden = false;
      b.setAttribute('data-path', s.path); b.setAttribute('data-kind', s.kind);
      b.textContent = 'Delete this ' + s.kind + (b.getAttribute('data-admin') === '1' ? ' (admin)' : '');
    };
    document.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('.js-slide-del') : null;
      if (!b) return;
      e.preventDefault(); e.stopPropagation();
      var post = b.closest('.post');
      var id = b.getAttribute('data-id') || (post && post.getAttribute('data-view'));
      var s = peSlideOf(post);
      var path = b.getAttribute('data-path') || (s && s.path) || '';
      var kind = b.getAttribute('data-kind') || (s && s.kind) || 'photo';
      var idx = s ? s.idx : 0, n = s ? s.n : 0;
      if (!id || !path) { toast('Could not find that ' + kind + '.'); return; }
      closePmenus(null);
      var ask = typeof glassConfirm === 'function'
        ? glassConfirm({ title: 'Delete this ' + kind + '?', body: 'It’ll be removed from the post. Likes and comments stay.',
                         actions: [{ label: 'Delete', value: 'yes', style: 'danger' }] }).then(function (v) { return v === 'yes'; })
        : Promise.resolve(window.confirm('Delete this ' + kind + '? It’ll be removed from the post. Likes and comments stay.'));
      ask.then(function (yes) {
        if (!yes) return;
        var fd = new FormData(); fd.append('post_id', id); fd.append('path', path);
        /* THE SLIDE GOES AWAY NOW, the server catches up (the request erases the bytes -- MediaPurge, origin
           AND R2 -- which measured 2-4s). Every copy's slide dims at once; the server's re-render replaces it
           on success, and the same re-render puts it back on a refusal. */
        var going = document.querySelectorAll('.post[data-view="' + id + '"] .cslide[data-path="' + (window.CSS && CSS.escape ? CSS.escape(path) : path) + '"]');
        Array.prototype.forEach.call(going, function (s) { s.classList.add('is-deleting'); });
        var undo = function () { Array.prototype.forEach.call(going, function (s) { s.classList.remove('is-deleting'); }); };
        postJson('/post/media-remove', fd).then(function (res) {
          if (!res || !res.ok) { undo(); toast((res && res.error) || ('Could not delete that ' + kind + '.')); return; }
          // land on the NEXT slide (same index), or the previous one when the last slide went
          var land = Math.max(0, Math.min(idx, (res.media_count || n - 1) - 1));
          peRepaint(id, land).then(function (ok) {
            peGridSync(id);
            toast(kind === 'video' ? 'Video deleted' : 'Photo deleted');
            if (!ok) { setTimeout(function () { window.location.reload(); }, 350); }
          });
        }).catch(function () { undo(); toast('Could not delete that ' + kind + '.'); });
      });
    });
    /* The profile/feed GRID tiles of this post follow the new cover (a removed slide 1, a reorder), in place. */
    function peGridSync(id) {
      var cells = document.querySelectorAll('.pcell[data-id="' + id + '"]');
      if (!cells.length) return;
      fetch('/post-media?post_id=' + encodeURIComponent(id), { credentials: 'same-origin',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
          var m = d && d.media && d.media[0]; if (!m || !m.thumb) return;
          Array.prototype.forEach.call(cells, function (c) {
            var img = c.querySelector('img'); if (!img) return;
            ['data-video-src', 'data-g3', 'data-g6', 'data-photo-dims', 'data-photo-src'].forEach(function (a) { img.removeAttribute(a); });
            img.setAttribute('data-full', m.thumb);
            img.src = m.thumb;
          });
        }).catch(function () {});
    }

    function close() {
      if (!modal) return;
      var m = modal; modal = null; taEl = null; saveBtn = null; curId = null;
      peX = null;
      document.documentElement.classList.remove('pe-open');
      if (peMed) {
        /* TEAR DOWN EVERYTHING upDrive MAY HAVE STARTED, not just the one XHR this
           used to know about. A chunked stream has several sockets open at once
           (it.xhrs), an encode may still be running on a worker (it.vcCancel), and
           the item's pump is registered in the PAGE-WIDE congestion window --
           leaving that behind would hand a dead stream a slot the composer could
           otherwise use. Aborting is enough for the slots themselves: every abort
           reaches the engine's settle(), which calls upWinRelease() exactly once.
           Deliberately NOT stageReset(): that clears the whole shared window, and
           the window is shared with a composer that may be mid-upload. */
        peMed.list.forEach(function (t) {
          if (t.vcCancel) { try { t.vcCancel(); } catch (e) {} }
          if (t.pumpReg) {
            var pi = upWin.pumps.indexOf(t.pumpReg);
            if (pi >= 0) upWin.pumps.splice(pi, 1);
            t.pumpReg = null;
          }
          if (t.staging) {
            if (t.xhr) { try { t.xhr.abort(); } catch (e) {} }
            if (t.xhrs) { t.xhrs.forEach(function (x) { try { x.abort(); } catch (e) {} }); }
          }
          if (t.isNew && t.thumb) { try { URL.revokeObjectURL(t.thumb); } catch (e) {} }
        });
        peMed = null;
      }
      m.classList.remove('show');
      document.removeEventListener('keydown', onKey, true);
      setTimeout(function () { if (m.parentNode) m.parentNode.removeChild(m); }, 200);
    }
    function onKey(e) {
      if (!modal) return;
      if (document.querySelector('.cropper.show')) return;   // the photo cropper is open above: its keys
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      else if ((e.metaKey || e.ctrlKey) && e.key === 'Enter') { e.preventDefault(); save(); }   // quick save
    }
    function autosize() {
      if (!taEl) return;
      taEl.style.height = 'auto';
      taEl.style.height = Math.min(taEl.scrollHeight, Math.round((window.innerHeight || 700) * 0.5)) + 'px';
    }
    // swap the caption in place across every copy of this post (feed card, viewer card). data-view is the
    // real post id (data-id can be a repost stream id), so match on that.
    function applyCaption(id, captionHtml, isEmpty) {
      Array.prototype.forEach.call(document.querySelectorAll('.post[data-view="' + id + '"]'), function (postEl) {
        var body = postEl.querySelector('.body');
        if (isEmpty || !captionHtml) {
          if (body) body.remove();
          var tb = postEl.querySelector('.post-translate, .js-translate'); if (tb) tb.remove();
          var tr = postEl.querySelector('.translation'); if (tr) tr.remove();
          return;
        }
        if (!body) {                                  // was captionless -> create a .body in a sensible spot
          body = document.createElement('div');
          // the card clamp's opt-in, exactly as _post.php emits it: every card but the viewer's and the permalink's
          body.className = 'body' + (postEl.closest('.pfeed, [data-pfeed-open]') ? '' : ' pf-clamp-card');
          var anchor = postEl.querySelector('.shadow-flag') || postEl.querySelector('.post-head');
          var main = postEl.querySelector('.post-main') || postEl;
          if (anchor && anchor.parentNode) { anchor.parentNode.insertBefore(body, anchor.nextSibling); }
          else { main.insertBefore(body, main.firstChild); }
        }
        body.innerHTML = captionHtml;
        // Rewriting innerHTML drops the pfeed clamp's inner clip span; without it the caption keeps the
        // pf-clamp class but stops clamping entirely. Rebuild it for any body that is still clamped.
        // These four lines USED to be repeated inline here, because the wrapper lived in a later
        // top-level IIFE and the identifier was not in scope (this file is five IIFEs, not one).
        // It is now shared through window.__rovaClipText -- one implementation, three callers (this,
        // the viewer's fitPfeedMedia, the post page's clamp), nothing left to keep "in step".
        // ?? guard: a caption edit can land before that module has run on a cold cache.
        // pf-open too, not just pf-clamp: an EXPANDED body edited in place still has to keep its
        // span, or collapsing it again would find nothing to clip.
        if ((body.classList.contains('pf-clamp') || body.classList.contains('pf-open'))
            && !body.querySelector(':scope > .pf-cliptext') && window.__rovaClipText) {
          window.__rovaClipText(body);
        }
        // THE TIMELINE CARD (2026-09-05, 8-line body clamp): its pill was decided on the OLD text. A
        // caption that grew past 8 lines needs a pill it never had, one that shrank needs its pill
        // gone, so start over -- drop the pill, the state classes and the measured-once latch,
        // rebuild the clip span (the CSS clamp needs it at first paint) and hand the body back to
        // the card observer (window.__rovaClampInit, the shared-clamp IIFE). Never the viewer's
        // copy of the same post (it carries the class too, and keeps the pfeed's own clamp state).
        if (body.classList.contains('pf-clamp-card') && !body.closest('.pfeed')
            && window.__rovaClipText && window.__rovaClampInit) {
          var oldPill = body.nextElementSibling;
          if (oldPill && oldPill.classList.contains('pf-more-feed')) { oldPill.remove(); }
          body.classList.remove('pf-clamp', 'pf-open');
          body._pfClamp = 0; body._pfWatch = 0; body._pfTries = 0;
          window.__rovaClipText(body);
          window.__rovaClampInit(body);
        }
      });
    }
    // the server says the post now carries the "Edited" label (grace window already
    // applied there) -- append it to every copy's timestamp, once
    function applyEditedLabel(id) {
      Array.prototype.forEach.call(document.querySelectorAll('.post[data-view="' + id + '"]'), function (postEl) {
        if (postEl.querySelector('.post-edited')) return;
        var time = postEl.querySelector('.post-head .meta .time-link');
        if (!time) return;
        var tag = document.createElement('span');
        tag.className = 'post-edited';
        tag.textContent = 'Edited';
        time.parentNode.insertBefore(document.createTextNode(' · '), time.nextSibling);
        time.parentNode.insertBefore(tag, time.nextSibling.nextSibling);
      });
    }
    function save() {
      if (!taEl || !curId || (saveBtn && saveBtn.disabled)) return;
      var body = taEl.value;
      var id = curId;
      var fd = new FormData();
      fd.append('post_id', id);
      fd.append('body', body);
      if (peMed) {
        peMed.list.forEach(function (t) {
          // a staged file that failed, or one the member added and then took back, is simply not sent
          if (t.isNew) { if (!t.cut && !t.failed && t.token) { fd.append('media_add[]', t.token); } }
          else if (t.cut) { fd.append('media_remove[]', t.path); }
        });
        /* THE FIT OVERRIDES, as two parallel arrays -- the one wire shape the app sends too, so
           post_fit_apply() reads both surfaces with no branch. Every eligible slide is sent, not
           just the ones that were touched: the server no-ops a value that already matches, and
           sending the whole set is what lets it catch a STALE editor (a path this post no longer
           has earns a 409 and a resync) instead of quietly writing a fit onto the wrong picture.
           peFitEligible() is the same filter that decided which rows to draw, so what is sent is
           exactly what the member was looking at -- cut slides and unsaved new files included out
           of both by construction. */
        peFitEligible().forEach(function (t) {
          // a slide being RE-CROPPED gets a fresh detector verdict on its new file: send its fit only
          // if the member actually changed it (else the seeded value would overwrite that verdict)
          if (t.cropDirty && (t.fit || 'auto') === (t.fitSeed || 'auto')) return;
          fd.append('fit_path[]', t.path);
          fd.append('fit_val[]', t.fit || 'auto');
        });
        peCropAppend(fd);   // photo crop: crop_path[] + crop_rect[] (changed tiles only)
      }
      var musicMoved = !!(peX && peX.musicChanged);
      peExtrasAppend(fd);   // the full editor: gifs, slide order, poll, place, co-author, grid, AI (changed only)
      if (saveBtn) { saveBtn.disabled = true; saveBtn.textContent = 'Saving…'; }
      postJson('/post/edit', fd).then(function (res) {
        if (res && res.ok) {
          // a song link added/removed changes the card's player, which only the server renders
          if (res.media || res.fit || res.extras || musicMoved) {
            if (res.media || res.extras) { peGridSync(id); }
            // The attachments moved, or a fit override changed. Either way the card's MARKUP is
            // stale, not just its text: the hint is baked in as views/_post.php's data-fit
            // attribute and read back by window.__rovaPhotoCovers, so patching the DOM here would
            // mean re-deriving a carousel, an aspect clamp and a fit verdict in JavaScript. Take
            // the card the server just rendered instead -- the server owns what a post looks like.
            peRepaint(id).then(function (done) {
              close();
              toast('Post updated');
              if (!done) { setTimeout(function () { window.location.reload(); }, 350); }
            });
            return;
          }
          applyCaption(res.id, res.caption, !!res.empty);
          if (res.edited) applyEditedLabel(res.id);
          close();
          toast('Post updated');
        } else {
          if (saveBtn) { saveBtn.disabled = false; saveBtn.textContent = 'Save changes'; }
          toast((res && res.error) || 'Could not save the edit.');
          // 409: the post moved under us (another tab / the app / a second device). The editor is
          // looking at a slide list that no longer exists, so reopen it from the server's truth.
          if (res && /changed somewhere else/i.test(res.error || '') && peMed) {
            peMed.list.splice(0, peMed.list.length);
            Array.prototype.forEach.call(peMed.strip.querySelectorAll('.pe-tile'), function (el) { el.remove(); });
            peLoad(id);
          }
        }
      }).catch(function () {
        if (saveBtn) { saveBtn.disabled = false; saveBtn.textContent = 'Save changes'; }
        toast('Could not save the edit.');
      });
    }
    function open(id, body) {
      close();
      curId = id;
      modal = document.createElement('div');
      modal.className = 'pe-modal';
      modal.setAttribute('role', 'dialog'); modal.setAttribute('aria-modal', 'true');
      modal.innerHTML =
        // A <form> (never submitted -- Save posts over fetch) so the SHARED pickers find this editor the way
        // they find every composer: the GIF and emoji delegates resolve btn.closest('form') and the music
        // picker reads that form's textarea[name="body"].
        '<form class="pe-sheet pe-form" role="document" novalidate>' +
          '<div class="pe-head"><h3>Edit post</h3><button type="button" class="pe-x" aria-label="Close">&times;</button></div>' +
          '<textarea class="input pe-body" name="body" maxlength="2000" aria-label="Post caption"></textarea>' +
          '<div class="pe-actions"><button type="button" class="btn pe-cancel">Cancel</button>' +
            '<button type="button" class="btn primary pe-save">Save changes</button></div>' +
        '</form>';
      document.body.appendChild(modal);
      document.documentElement.classList.add('pe-open');   // lifts the shared pickers above this sheet
      modal.querySelector('.pe-form').addEventListener('submit', function (e) { e.preventDefault(); });
      taEl = modal.querySelector('.pe-body');
      saveBtn = modal.querySelector('.pe-save');
      taEl.value = body || '';
      peToolsBuild(modal.querySelector('.pe-sheet'));
      peBuild(modal.querySelector('.pe-sheet'));
      // touch drag-to-reorder: once a tile is held, the sheet must not scroll under the finger
      modal.querySelector('.pe-sheet').addEventListener('touchmove', function (e) {
        if (peDrag && peDrag.on && e.cancelable) e.preventDefault();
      }, { passive: false });
      /* NOTHING THAT HAPPENS IN THE EDITOR REACHES THE VIEWER UNDER IT. The viewer pages on arrows / Space /
         wheel / swipes and closes on Escape from DOCUMENT-level listeners; with focus on one of this sheet's
         buttons (a tool, a tile's move arrow) an ArrowDown paged the viewer and Escape closed it along with
         the editor. Bubble-phase stops at the modal: the editor's own capture-phase Escape still runs, text
         fields keep their keys for the page's own helpers (the viewer ignores those anyway). */
      modal.addEventListener('keydown', function (e) {
        var tg = e.target && e.target.tagName;
        if (e.key === 'Escape' || !/^(INPUT|TEXTAREA|SELECT)$/.test(tg || '')) e.stopPropagation();
      });
      ['wheel', 'touchstart', 'touchmove', 'touchend'].forEach(function (ev) {
        modal.addEventListener(ev, function (e) { e.stopPropagation(); }, { passive: true });
      });
      // a poll makes a media-less post legitimate, same rule the server applies
      var live = document.querySelector('.post[data-view="' + id + '"]');
      if (peMed && live && live.querySelector('.poll')) { peMed.hasPoll = true; }
      peLoad(id);
      modal.querySelector('.pe-x').addEventListener('click', close);
      modal.querySelector('.pe-cancel').addEventListener('click', close);
      saveBtn.addEventListener('click', save);
      modal.addEventListener('click', function (e) { if (e.target === modal) close(); });   // tap backdrop
      taEl.addEventListener('input', autosize);
      document.addEventListener('keydown', onKey, true);
      requestAnimationFrame(function () {
        modal.classList.add('show'); autosize(); taEl.focus();
        try { taEl.setSelectionRange(taEl.value.length, taEl.value.length); } catch (e) {}   // caret at end
      });
    }
    document.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('.js-post-edit') : null;
      if (!a) return;
      e.preventDefault();
      closePmenus(null);   // drop the ⋯ menu that was behind
      open(a.getAttribute('data-id'), a.getAttribute('data-body') || '');
    });
  })();

  /* ---- tap a post card (not its interactive parts) -> open the inline comments -- */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    // leave clicks on anything interactive, media, or menus alone
    if (e.target.closest('a, button, form, input, textarea, label, select, .media, video, audio, ' +
        '.carousel, .embed, .poll, .pmenu, .lightbox, .comment-panel, [role="button"], [role="menu"]')) return;
    // let people select/copy text without doing anything
    if (window.getSelection && String(window.getSelection())) return;
    var post = e.target.closest('.post');
    if (!post) return;
    // blank space -> open the inline comment panel (same as tapping the comment button),
    // NOT the full post page. Falls back to the permalink if there's no comment button.
    var cbtn = post.querySelector('.js-comments');
    if (cbtn) { cbtn.click(); return; }
    var url = post.getAttribute('data-permalink');
    if (url && url !== location.pathname) window.location = url;
  });

  /* ---- inline comment panel (slides out of a post on the timeline) ------ */
  (function () {
    var openPanel = null;

    // Every call here carries a count the SERVER just returned -- panel open and the 8s in-panel
    // poll, both GET /comments, which ships the shadow-corrected $p['comment_count'] and so is safe
    // to paint. (The POST /comment answer is NOT: it is a raw COUNT(*), and the send path below
    // bumps locally instead. See engCommentPaint.)
    // Routed through the shared painter rather than at the clicked button: `btn` is whichever
    // .js-comments was tapped, and the collapsed .croller carries no .cnt at all, so opening the
    // panel from the roller never moved the card badge. Stamped so an older /engage-live batch
    // cannot land on top, and skipped outright while the reader's own comment is in flight -- a
    // poll that left first carries a snapshot with no comment in it.
    function setCount(btn, n) {
      var host = btn && btn.closest ? btn.closest('.post') : null;
      if (!host) {
        var c = btn && btn.querySelector('.cnt'); if (c) { c.textContent = fmtCount(n); c.hidden = !(+n); }
        return;
      }
      if (engBadgeHeld('comment', engIdFor(host))) return;
      engCommentPaint(host, +n || 0);
      engTouch(host);
    }

    // After the sheet closes, make the collapsed roller reflect the latest comments WITHOUT a
    // refresh -- above all the very FIRST comment on a post that had none (so no roller markup
    // existed yet): build it from the panel's rows and slot it in right after the action bar.
    function syncRoller(post, panel) {
      if (!post || !panel) return;
      if (post.closest('.pfeed')) return;                 // the immersive feed manages its own chrome
      var rows = panel.querySelectorAll('.cpanel-list .cx-row[data-comment]');
      if (!rows.length) return;
      var pid = panel._btn ? panel._btn.getAttribute('data-post') : '';
      crFillTrack(post, Array.prototype.slice.call(rows), pid);
    }

    /* ==== THE ROLLER GIF CHIP (2026-09-30, = iOS build 552) -- JS twin of Giphy::chip() (lib/giphy.php); keep them
       identical. A stored Giphy original (/media/<v1.cid>/<id>/giphy.gif) -> fixed_height_small (100px tall) as animated
       WEBP (the API ships the same Giphy size as 100.gif), 24px tall, width reserved from the intrinsic size clamped
       18..56 (unknown 32 until the image says otherwise); Reduce Motion = 100_s.gif, the first frame. */
    var CR_GIF_RE = /^(https:\/\/[a-z0-9.-]*\.giphy\.com\/media\/(?:[^\/?#]+\/)?[A-Za-z0-9]{5,64}\/)[A-Za-z0-9_.-]+\.(?:gif|webp|mp4)(?:\?[^#]*)?$/i;
    function crGifChip(url, w, h) {
      var m = CR_GIF_RE.exec(String(url || '').trim());
      if (!m) { return ''; }
      w = parseInt(w, 10) || 0; h = parseInt(h, 10) || 0;
      var cw = (w > 0 && h > 0 && w <= 65535 && h <= 65535) ? Math.round(24 * w / h) : 32;
      cw = Math.max(18, Math.min(56, cw));
      return '<picture class="cr-gif"><source media="(prefers-reduced-motion: reduce)" srcset="' + escHtml(m[1] + '100_s.gif') + '">'
        + '<img src="' + escHtml(m[1] + '100.webp') + '" width="' + cw + '" height="24" alt="sent a GIF" loading="lazy" decoding="async"></picture>';
    }

    /* Build or refresh the collapsed roller from a list of .cx-row elements. Split out of
       syncRoller() unchanged so the LIVE path below (a comment that arrived from someone else,
       which has no panel to read) can reach the identical markup instead of growing a second
       builder that drifts from this one. */
    function crFillTrack(post, rows, pid) {
      if (!post || !rows || !rows.length) return;
      var roller = post.querySelector('.croller'), track;
      if (roller) {
        track = roller.querySelector('.croller-track');
        if (track) track.innerHTML = '';
      } else {
        roller = document.createElement('button');
        roller.type = 'button';
        roller.className = 'croller js-comments';
        if (pid) roller.setAttribute('data-post', pid);
        track = document.createElement('span'); track.className = 'croller-track';
        roller.appendChild(track);
        var go = document.createElement('span'); go.className = 'cr-go'; go.setAttribute('aria-hidden', 'true');
        go.innerHTML = '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="m5 8.5 7 7 7-7"/></svg>';
        roller.appendChild(go);
        var bar = post.querySelector('.bar');
        if (bar) bar.insertAdjacentElement('afterend', roller);
        else (post.querySelector('.post-main') || post).appendChild(roller);
      }
      if (!track) return;
      // newest few, oldest-first (the shared ticker cycles them); the first is the visible line
      rows.slice(-5).forEach(function (row, i) {
        var av = row.querySelector('.cx-av'), name = row.querySelector('.cr-name');
        var text = row.querySelector('.cr-text');
        // the expanded row wears the verified badge ON the avatar; the collapsed roller now matches
        // (badge stays on the profile pic, no name-side tick) -- one badge, saves the line's space
        var avHtml = av ? '<span class="cr-av">' + av.innerHTML + '</span>' : '';
        // THE ROLLER GIF CHIP (2026-09-30, = iOS 552): the row's full-size .msg-gif never rides into the pill. A
        // GIF-ONLY comment becomes the same small chip the server draws (views/_croller.php; same URL rule, so the
        // image the pill already had is a cache hit); a comment WITH text shows its text only.
        var tHtml = text ? text.innerHTML : '', chip = '';
        var gi = text && text.querySelector('img.msg-gif');
        if (gi) {
          var tc = text.cloneNode(true);
          Array.prototype.forEach.call(tc.querySelectorAll('img.msg-gif'), function (n) { n.parentNode.removeChild(n); });
          if ((tc.textContent || '').trim()) { tHtml = tc.innerHTML.trim(); }
          else { chip = crGifChip(gi.getAttribute('src'), gi.getAttribute('width'), gi.getAttribute('height')); }
        }
        var item = document.createElement('span');
        item.className = 'croller-item' + (i === 0 ? ' on' : '') + (chip ? ' cr-hasgif' : '');
        item.innerHTML = avHtml
          // 2026-10-16: the SHORT name, same as the server-drawn roller (views/_croller.php short_name() = NameText::short)
          + '<b class="cr-name">' + escHtml(name ? (name.getAttribute('data-short') || name.textContent) : '') + '</b>'
          + (chip || '<span class="cr-text">' + tHtml + '</span>');
        track.appendChild(item);
      });
    }

    /* ================= THE ROLLER ARRIVING WHILE YOU WATCH =================================
       Owner 2026-08-10: "if one comes in realtime it should animate up while the comment scroller
       fades in with the new comment."

       THE TWO RULES THIS OBEYS, both of them scars:

       1. NEVER MOVE WHAT THE READER IS LOOKING AT. Adding a roller makes the card taller, and
          #feed-posts carries overflow-anchor:none (deliberately -- see rova.css; Safari has never
          implemented anchoring anyway), so a card growing ABOVE the fold pushes everything under
          the reader's finger. crGrow() measures the card before and after and hands the scroller
          back exactly what the growth took, the same correction insertTop(keepPlace) already makes
          when a live post lands on top of the timeline. A card that is off screen is grown with no
          animation at all: motion nobody can see is only a way to be wrong later.

       2. NOTHING IS WRITTEN INTO THE DOM THAT A RECYCLED CARD CAN STRAND. The feed virtualiser
          stashes p.outerHTML and destroys the node, so an inline style or a class left mid-flight
          is restored forever -- exactly how `.croller-item.out` once stranded an empty pill (see
          rova.css). Both motions are Web Animations, which live on the element object and are NOT
          serialised into outerHTML: a card recycled mid-animation is stashed clean, and the
          animation dies with the node it belonged to. fill is left at 'none' so the resting state
          is always the natural one -- the Reanimated trap in the app is the same shape: a style
          that stops writing a key does not restore it.

       WHAT IT DOES NOT DO: it never paints a count. /engage-live owns the badges, and the one time
       a client second-guessed it, it blanked all three (see engApply). This reads the number
       /engage-live already applied and only asks "did it go up?". */

    var CR_COOL = 45000;                 // per-post floor between live roller fetches
    var crAt = Object.create(null);      // post id -> last fetch, ms
    var crBusy = false;                  // one live roller fetch in flight at a time, page-wide

    function crReduced() {
      try { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); }
      catch (e) { return false; }
    }

    // The thing that actually scrolls behind this card. Almost always the page; a surface that
    // scrolls in its own box gets its own scrollTop corrected instead of the window's.
    function crScrollHost(el) {
      for (var n = el && el.parentNode; n && n.nodeType === 1; n = n.parentNode) {
        var ov = getComputedStyle(n).overflowY;
        if ((ov === 'auto' || ov === 'scroll') && n.scrollHeight > n.clientHeight + 1) return n;
      }
      return null;
    }

    /* Run `mutate` (which makes the card taller) and pay for the height it took.
       Returns nothing; safe to call on any card, including one with no bar. */
    function crGrow(post, mutate) {
      var bar = post && post.querySelector ? post.querySelector('.post-main > .bar') : null;
      // the immersive viewer manages its own chrome (its own bottom-aligned column, its own idle
      // fade), exactly as syncRoller() already refuses to touch it
      if (!post || !bar || post.closest('.pfeed')) { if (mutate) mutate(); return; }
      var vh = window.innerHeight || 800;
      var r0 = post.getBoundingClientRect();
      var b0 = bar.getBoundingClientRect().top;
      var onScreen = r0.bottom > 0 && r0.top < vh;
      var fullyAbove = r0.bottom <= 0;

      mutate();

      var r1 = post.getBoundingClientRect();
      var grew = r1.height - r0.height;
      if (fullyAbove && grew) {
        // everything on screen just moved down by `grew`; give it straight back
        var host = crScrollHost(post);
        if (host) host.scrollTop += grew;
        else window.scrollBy(0, grew);
        return;                                    // no motion: the reader cannot see this card
      }
      if (!onScreen || crReduced()) return;        // below the fold, or motion is unwelcome

      // FLIP the bar: it has already been laid out at its new home, so animate it FROM where the
      // reader last saw it. transform + opacity only -- no per-frame layout, no gBCR in a loop.
      var b1 = bar.getBoundingClientRect().top;
      var dy = b0 - b1;
      if (dy && bar.animate) {
        bar.animate([{ transform: 'translateY(' + dy + 'px)' }, { transform: 'none' }],
                    { duration: 300, easing: 'cubic-bezier(.2,.7,.2,1)' });
      }
      var roller = post.querySelector('.post-main > .croller');
      if (roller && roller.animate) {
        roller.animate([{ opacity: 0, transform: 'translateY(7px)' }, { opacity: 1, transform: 'none' }],
                       { duration: 320, easing: 'cubic-bezier(.2,.7,.2,1)', delay: dy ? 70 : 0, fill: 'backwards' });
      }
    }

    /* A live comment count went UP on a card the reader can see. Pull that post's thread once and
       let the roller show it. Bounded three ways: the post must be on this page and out of the
       pfeed, one fetch at a time page-wide, and a 45s floor per post -- a busy card cannot turn the
       8s /engage-live tick into an 8s /comments tick. */
    function crLive(post, pid) {
      if (!post || !pid || crBusy) return;
      if (post.closest('.pfeed')) return;                       // the viewer manages its own chrome
      if (post.querySelector('.comment-panel')) return;         // the panel is open: it polls already
      var now = Date.now();
      if (crAt[pid] && now - crAt[pid] < CR_COOL) return;
      var r = post.getBoundingClientRect();
      if (r.bottom <= 0 || r.top >= (window.innerHeight || 800)) {
        // off screen: no roller to build for nobody. The next /engage-live tick that finds it on
        // screen with a count it has not seen will do it then.
        return;
      }
      crAt[pid] = now;
      crBusy = true;
      var t0 = Date.now();   // THE COMMENT HEART SURVIVES A REOPEN: a reaction settled after this cannot be in the reply
      rfetch('/comments?post=' + encodeURIComponent(pid),
             { headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
               credentials: 'same-origin', cache: 'no-store' }, 8000)
        .then(function (r2) { return r2.json(); })
        .then(function (res) {
          if (res && res.comments) { cReactOverlay(res.comments, t0); crThreadPut(pid, res); }   // v5: THE THREAD CACHE (an open seeds from it)
          if (!res || !res.comments || !res.comments.length) return;
          // the card may have been recycled, destroyed or reused for another post while we waited
          if (!post.isConnected || String(post.getAttribute('data-view') || '') !== String(pid)) return;
          if (post.querySelector('.comment-panel')) return;
          var rows = flattenComments(res.comments).map(crollerRow);
          crGrow(post, function () { crFillTrack(post, rows, String(pid)); });
        })
        .catch(function () {})
        .then(function () { crBusy = false; });
    }

    /* Called by engApply() with the number it was already given. `was`/`now` are the badge's own
       before/after, never a guess, and a count that did not grow does nothing at all. */
    window.__rovaRollerBump = function (post, was, now) {
      if (!post || !(now > was) || !(now > 0)) return;
      var pid = post.getAttribute('data-view');
      if (pid) crLive(post, pid);
    };

    /* ================= THE THREAD CACHE + PREFETCH (v5, 2026-09-29) ===============================================
       Native (RovaComments, exact rule from the iOS session): the sheet's thread is seeded SYNCHRONOUSLY at open from
       a shared cache the card prefetched when it mounted -- so the whole thread is usually there at t=0 -- and the
       fresh fetch merges afterwards. The web had no such cache: every open waited on its own GET /comments
       (~400ms measured on the origin's own loopback, far more on a phone) before anything moved.
       NOW: once the page's scrolling has been quiet for CR_PF_IDLE, the first on-screen roller whose thread is not
       cached (or is older than CR_PF_TTL) is fetched -- ONE request in flight page-wide, CR_PF_CAP per page, never
       while hidden or under Save-Data -- and a PRESS on any comments control starts its fetch too (a head start on
       the click). An entry is the /comments JSON the server shaped for THIS viewer (my_reaction, del, canComment);
       it is page memory, never shared. The in-panel poll and crLive refresh it; a comment the member posts is
       spliced in (crThreadAdd); a delete/edit drops the entry (the next open fetches). */
    var CR_PF_TTL = 60000, CR_PF_IDLE = 350, CR_PF_CAP = 80, CR_SEED_MAX_AGE = 600000, CR_THREAD_MAX = 40;
    var crThreads = Object.create(null), crThreadKeys = [], crThreadWait = Object.create(null), crPfN = 0;
    function crThreadPut(pid, res) {
      if (!pid || !res || !res.comments) { return; }
      pid = String(pid);
      if (!crThreads[pid]) { crThreadKeys.push(pid); while (crThreadKeys.length > CR_THREAD_MAX) { delete crThreads[crThreadKeys.shift()]; } }
      crThreads[pid] = { res: res, at: Date.now() };
    }
    function crThreadGet(pid, maxAge) {
      var e = pid ? crThreads[String(pid)] : null;
      return e && Date.now() - e.at <= (maxAge || CR_SEED_MAX_AGE) ? e : null;
    }
    function crThreadDrop(pid) {
      pid = String(pid);
      if (!crThreads[pid]) { return; }
      delete crThreads[pid];
      var i = crThreadKeys.indexOf(pid); if (i >= 0) { crThreadKeys.splice(i, 1); }
    }
    // THE COMMENT HEART SURVIVES A REOPEN (2026-10-06; see cReactNote): a reaction made on this page patches every
    // cached thread at once, so the next open is seeded with the heart the reader actually left
    window.__rovaCrThreadReact = function () {
      for (var k in crThreads) { var e = crThreads[k]; if (e && e.res && e.res.comments) { cReactOverlay(e.res.comments, 0); } }
    };
    // ONE request per post at a time: the prefetch, the press, the open and the poll all share it
    // v7 LIVE THREAD (2026-09-30): `rev` = a poll / a seeded open. It sends the cached thread's revision as since_rev,
    // and when nothing changed the server answers {unchanged:true} from one Redis read (Comments::threadRev in PHP):
    // the cached entry is refreshed and the caller gets {unchanged, rev, cached} instead of rows
    function crThreadFetch(pid, low, rev) {
      pid = String(pid);
      if (crThreadWait[pid]) { return crThreadWait[pid]; }
      var opt = { headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', cache: 'no-store' };
      if (low) { opt.priority = 'low'; }
      var ce = rev ? crThreads[pid] : null, since = ce && ce.res && ce.res.rev ? ce.res.rev : 0;
      var t0 = Date.now();   // when this read STARTED: a reaction that settled later is laid over it (cReactOverlay)
      var p = rfetch('/comments?post=' + encodeURIComponent(pid) + (since ? '&since_rev=' + encodeURIComponent(since) : ''), opt, 8000)
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res && res.unchanged) {
            var hit = ce && crThreads[pid] === ce && ce.res.rev === res.rev;
            if (hit) { ce.at = Date.now(); }
            return { unchanged: true, rev: res.rev, cached: hit ? ce.res : null };
          }
          if (res && res.comments) { cReactOverlay(res.comments, t0); crThreadPut(pid, res); }
          return res;
        });
      crThreadWait[pid] = p;
      var clear = function () { if (crThreadWait[pid] === p) { delete crThreadWait[pid]; } };
      p.then(clear, clear);
      return p;
    }
    // the member's own new comment goes into the cached thread too, so the next open is seeded WITH it
    function crThreadAdd(pid, c) {
      var e = pid && c ? crThreads[String(pid)] : null;
      if (!e || !e.res || !e.res.comments) { return; }
      var put = false;
      if (c.parent_id) {
        (function walk(a) {
          for (var i = 0; i < a.length && !put; i++) {
            if (String(a[i].id) === String(c.parent_id)) { (a[i].replies = a[i].replies || []).push(c); put = true; }
            else if (a[i].replies && a[i].replies.length) { walk(a[i].replies); }
          }
        })(e.res.comments);
      }
      if (!put) { e.res.comments.push(c); }
    }
    // rigs only (scratchpad roller5/rig5.js): a cold open on demand; exposes no thread content
    window.__rovaCrThread = { clear: function () { crThreads = Object.create(null); crThreadKeys = []; crThreadWait = Object.create(null); }, has: function (id) { return !!crThreadGet(id, CR_PF_TTL); } };
    function crPfOff() {
      if (document.getElementById('comment-list')) { return true; }   // the permalink lists its thread already
      var cn = navigator.connection;
      return !!(cn && cn.saveData);
    }
    var crPfT = 0, crPfAt = 0, crPfBusy = false;
    function crPfSoon() { crPfAt = Date.now(); if (!crPfT) { crPfT = setTimeout(crPfScan, CR_PF_IDLE); } }
    function crPfScan() {
      crPfT = 0;
      var quiet = Date.now() - crPfAt;
      if (quiet < CR_PF_IDLE) { crPfT = setTimeout(crPfScan, CR_PF_IDLE - quiet + 10); return; }
      if (crPfBusy || document.hidden || crPfN >= CR_PF_CAP || crPfOff()) { return; }
      var vh = window.innerHeight || 800, els = document.querySelectorAll('.croller.js-comments[data-post]'), pid = null;
      for (var i = 0; i < els.length && !pid; i++) {
        var id = els[i].getAttribute('data-post');
        if (!id || crThreadWait[id] || crThreadGet(id, CR_PF_TTL) || els[i].closest('.cr-pillclone, .livefeed, .pfeed a.croller')) { continue; }   // a guest's viewer pill funnels to signup
        var r = els[i].getBoundingClientRect();
        if (r.width && r.bottom > 0 && r.top < vh) { pid = id; }
      }
      if (!pid) { return; }
      crPfBusy = true; crPfN++;
      crThreadFetch(pid, true).catch(function () {}).then(function () { crPfBusy = false; crPfT = crPfT || setTimeout(crPfScan, 60); });
    }
    document.addEventListener('scroll', crPfSoon, { capture: true, passive: true });   // any scroller: the feed, the viewer
    // the first screen: at load, or 2.5s in if 'load' is held up by a slow resource (the first scroll does it anyway)
    if (document.readyState === 'complete') { crPfSoon(); } else { window.addEventListener('load', crPfSoon); setTimeout(crPfSoon, 2500); }
    document.addEventListener('pointerdown', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('.js-comments[data-post]') : null;
      if (!b || b.closest('.livefeed') || (b.tagName === 'A' && b.closest('.pfeed')) || (!b.closest('.pfeed') && document.getElementById('comment-list'))) { return; }
      var id = b.getAttribute('data-post');
      if (id && !crThreadGet(id, CR_PF_TTL)) { crThreadFetch(id).catch(function () {}); }
    }, true);
    /* Merge a thread from the server into the sheet's rows WITHOUT rebuilding what did not change (a rebuilt row
       re-decodes its avatar under the reader's eye). Keyed by comment id; a row is rebuilt only when its content
       changed. Likes/reactions never REBUILD a row (they are not in its signature); since 2026-10-06 a kept row's
       heart is RECONCILED in place from the data instead (crSyncReact) -- the data has the page's own reactions laid
       over it (cReactOverlay), and a heart with a request in flight is left alone. Before that, "never overwritten"
       meant a row seeded from a pre-like cached thread showed the reader's like as gone (THE COMMENT HEART SURVIVES
       A REOPEN, at cReactNote). A row the member posted (_local) adopts the server's copy in place,
       and survives a thread that left before it did (< 20s); anything else the server no longer lists goes. */
    function crSyncReact(row, cm) {
      var b = row.querySelector('.clike');
      if (!b || b._rxBusy) { return; }
      var want = cm.my_reaction || '', n = Math.max(0, +cm.like_count || 0), fan = cm.fan || [];
      var sig = want + '|' + n + '|' + fan.join(',');
      if (b._rsig === sig) { return; }
      b._rsig = sig;
      var cntEl = b.querySelector('.cnt'), shown = cntEl && !cntEl.hidden ? cntEl.textContent : '';
      if ((b.getAttribute('data-reaction') || '') === want && shown === (n > 0 ? fmtCount(n) : '')) { return; }
      applyCReact(b, { reaction: want || null, count: n, fan: fan });
    }
    function crRowSig(c) {
      var o = {}, k;
      for (k in c) { if (k !== 'ago' && k !== 'replies' && k !== 'like_count' && k !== 'my_reaction' && k !== 'fan' && k !== '_reply') { o[k] = c[k]; } }
      return JSON.stringify(o);
    }
    function crMergeRows(list, comments) {
      var flat = flattenComments(comments || []), have = Object.create(null), want = [], keep = [], now = Date.now(), changed = false;
      Array.prototype.forEach.call(list.querySelectorAll('.cx-row[data-comment]'), function (r) { have[r.getAttribute('data-comment')] = r; });
      flat.forEach(function (cm) {
        var id = String(cm.id), sig = crRowSig(cm), r = have[id];
        if (r && (r._sig === sig || r._local)) { r._sig = sig; r._local = 0; delete have[id]; crSyncReact(r, cm); want.push(r); return; }
        var nr = crollerRow(cm); nr._sig = sig; changed = true;
        if (list._ro) { list._ro.observe(nr); }
        if (r) { delete have[id]; nr._old = r; }
        want.push(nr);
      });
      Object.keys(have).forEach(function (id) {
        var r = have[id];
        if (r._local && now - r._local < 20000) { keep.push(r); } else { changed = true; if (list._ro) { list._ro.unobserve(r); } if (r.parentNode) { r.parentNode.removeChild(r); } }
      });
      if (!want.length && !keep.length) {
        if (!list.querySelector('.cr-empty')) { list.innerHTML = '<div class="cpanel-note cr-empty">No comments yet. Be the first.</div>'; changed = true; }
        list.removeAttribute('aria-busy');
        return changed;
      }
      Array.prototype.slice.call(list.children).forEach(function (k) { if (!k.classList.contains('cx-row')) { list.removeChild(k); changed = true; } });
      list.removeAttribute('aria-busy');
      var cur = list.firstElementChild;
      want.forEach(function (node) {
        while (cur && keep.indexOf(cur) >= 0) { cur = cur.nextElementSibling; }   // a just-posted row keeps its place
        if (node._old) { var old = node._old; node._old = null; if (old === cur) { cur = cur.nextElementSibling; } if (list._ro) { list._ro.unobserve(old); } if (old.parentNode) { old.parentNode.removeChild(old); } }
        if (node === cur) { cur = cur.nextElementSibling; return; }
        list.insertBefore(node, cur); changed = true;
      });
      return changed;
    }
    // a cold open slower than CR_WAIT_MS opens on this (the rows replace it at the landing, the box re-targets)
    function crSkeleton(list) {
      if (list.querySelector('.cx-row')) { return; }
      var row = '<div class="cr-skel-row"><i class="cr-skel-av"></i><span><i></i><i></i></span></div>';
      list.innerHTML = '<div class="cr-skel" aria-hidden="true">' + row + row + row + '</div>';
      list.setAttribute('aria-busy', 'true');
    }

    /* ================= THE ROLLER <-> PANEL MORPH (2026-09-29; v3 = the NATIVE OPEN, an OVERLAY) =================
       History: v1 (iOS build 518 parity) replaced a max-height collapse that Rob called "a flash"; v2 (build 520)
       crossfades the content into the pill's own face on the close. v3 (Rob: "The iPhone native app opens the
       comment scroller beautifully and I want the web to match that") is RovaComments.swift's open, exactly:

       THE SHEET IS AN OVERLAY. Nothing under it moves -- not the card, not the cards below it, not the page.
       On a card the sheet is position:absolute inside its own .post (so every `post.querySelector('.comment-panel')`
       / `.closest('.post')` in this file still holds), placed by crPlace() = the native layoutSheet (the CR_SHEET_*
       block: centred on phones, pill top, re-anchors upward at the floor, keyboard floor, 46vh thread cap). The
       pill keeps its slot (visibility:hidden, never display:none) and the host card is lifted above its later
       siblings (rova.css). v4: like the native full-screen CLEAR backdrop, a transparent .cr-backdrop sits under
       the open card sheet (inside the host card's stacking context, over everything else): a TAP on it closes
       with the morph. v6 (2026-09-30, Rob): a SCROLL that starts outside the sheet scrolls the page like normal, in
       the same gesture, and folds the sheet away fast (crOutsideScroll -> closePanel 'swipe'); the thread still
       scrolls and never chains. (v4-v5c cancelled it, copying native's lock.) The handle's pull-down SCRUBS the close
       (crScrub). The docked sheet in the immersive viewer was always an overlay (absolute, bottom 0).

       THE OPEN: the sheet's final box is laid out in the first task and NEVER moves or reflows; a clip-path
       rect grows from the pill's own rect to it (corners pillHeight/2 -> 16) on ONE damped spring, sampled into
       keyframes (crSpring: a true unit step response, settled at the duration) --
         card    0.36s, damping 0.80 (peak ~1.5% past the rect: a ~5px overshoot on a 400px sheet)
         viewer  0.30s, damping 0.90
       The skin (.cr-bg, the sheet's background + border, a child at z -1) reaches CR_BG_GROW past the box while
       an open is running (.cr-grow), so the overshoot frames paint real background beyond the final rect instead
       of scaling the content. The content (handle, thread, composer) is at its final size and place from frame 0,
       revealed by the clip, all at once (no row stagger).
       v4 (Rob on the v3 strip: "blank when it opens, similar to the bug we fixed in the app" -- 36-108ms showed an
       EMPTY solid box: pill hidden at t=0, content waiting for 25%): the open CROSSFADES exactly as the close does.
       Frame 0 carries the pill's own FACE (crPillFace) over the pill's rect, so it IS the pill; over CR_XFADE_MS the
       face goes 1 -> 0 while the content goes 0 -> 1 on ONE curve (crXfadeIn), sum = 1 in every frame. The face stays
       ANCHORED where the pill is (the thread's first rows are right there) and is removed when it reaches 0.
       On a card the skin is opaque from frame 0 (the real pill is hidden under it); in the viewer
       the sheet starts in the pill's glass (the panel's own rgba(18,18,24,.66)) and the opaque skin fades in over
       it on the same curve. No pill on screen in the viewer: the sheet slides up from below instead
       (CR_SLIDE_*). A soft halo (.cr-halo: 0 -12px 34px rgba(23,23,28,.6), radius 16) is hidden during the
       motion, fades in over 150ms after the landing, and fades out at the start of a close.

       THE CLOSE is v2, unchanged in its timing, adapted to the overlay (which only made it simpler -- there is
       no layout to swap back any more, so there is no handoff relayout either):
         the clip shrinks into the pill's rect, 340ms cubic-bezier(.45,0,.2,1); the content fades out over the
         first 200ms while the pill's FACE (crPillFace) fades in on the same clock (sum = 1 every frame), then a
         140ms fade of the empty ghost hands over to the REAL pill, which has been sitting in its slot all along.
       All of it is paint/composite only (clip-path, opacity); every animation is precomputed keyframes on the
       element objects, fill:'forwards', cancelled in the SAME task as whatever class swap ends it, so no frame
       ever shows the in-between. Nothing is written into outerHTML a recycler could strand (recycleTick refuses
       any card holding a .comment-panel; the inline px die with the node). The finish is the morph's own
       `finish` (dismiss-lands-on-animationend), with a backstop timer, never a wall clock alone.
       INTERRUPTIBLE: a tap on the still-visible part of a closing sheet (its clip is its hit area; under an overlay
       lies the NEXT card, so it no longer falls through) or on the comments button REVERSES it from the openness
       it has reached right now -- same panel, same rows, no refetch -- and the face it was fading into crossfades
       back out from where it is (crReopen); a close started inside an open's crossfade keeps that open's face
       (sum = 1 through every reversal).
       Paths: chevron/handle, pull-down, outside tap, idle 30s and Escape morph; a scroll from outside fades
       (CR_SWIPE_MS, v6); scroll-away and anything off
       screen closes INSTANTLY (nothing to give back: the sheet never took any height); the immersive viewer's
       own teardown only fades the sheet out with it; prefers-reduced-motion is instant everywhere. */
    var CR_CLOSE_MS = 340, CR_FADE_MS = 200, CR_HAND_MS = 140;
    var CR_OPEN_MS = 360, CR_OPEN_ZETA = 0.80;            // on a feed card (RovaComments.swift)
    var CR_OPEN_DOCK_MS = 300, CR_OPEN_DOCK_ZETA = 0.90;  // the viewer's docked sheet
    // v4: the OPEN crossfades too (Rob: "blank when it opens, similar to the bug we fixed in the app"): the pill's
    // face 1 -> 0 while the content 0 -> 1, one 200ms curve (the time-mirror of the close's CR_FADE_OUT_EASE)
    var CR_XFADE_MS = 200, CR_XFADE_IN_EASE = 'cubic-bezier(0,0,.6,1)';
    var CR_SLIDE_MS = 280, CR_SLIDE_PX = 380;             // docked, no pill on screen: up from below
    var CR_HALO = 46, CR_HALO_MS = 150;                   // `0 -12px 34px` reaches 46px above the box
    var CR_BG_GROW = 24;                                  // how far the skin reaches past the box during an open
    /* THE CARD SHEET'S RECT = RovaComments.layoutSheet (numbers from the iOS session, 2026-09-29, build 530):
         phone (viewport < CR_SHEET_PHONE_MAX)  centred: side = clamp(vw - pill.right, 12, 40), width = vw - 2*side
         wider                                  the card's content box (.post-row), as before
         top     the pill's top; past the floor -> floor - h (RE-ANCHORS UPWARD), never above topFloor
         topFloor  the sticky header / stuck feed tabs + 8
         floor   keyboard up: the keyboard's top - 8; else the viewport bottom - 12 (the web has no phone tab bar)
         height  fixed parts (handle + reply chip + composer) + list, list = min(natural, 46% of the viewport,
                 room - fixed), room = max(160, floor - topFloor); the thread scrolls inside when capped */
    var CR_SHEET_PHONE_MAX = 768;
    var CR_SHEET_SIDE_MIN = 12, CR_SHEET_SIDE_MAX = 40;
    var CR_SHEET_TOP_GAP = 8;          // below the sticky header / tabs
    var CR_SHEET_FLOOR_GAP = 12;       // above the viewport bottom
    var CR_SHEET_KB_GAP = 8;           // above the keyboard
    var CR_SHEET_LIST_VH = 0.46;       // the thread's cap, a share of the viewport height
    var CR_SHEET_MIN_ROOM = 160;
    var CR_SHEET_NOPILL_GAP = 10;      // a card with no pill yet (no comments): the sheet starts this far under the post column
    var CR_FADE_OUT_EASE = 'cubic-bezier(.4,0,1,1)';   // the content's fade-out AND the pill face's fade-in (one crossfade)
    function crBez(x1, y1, x2, y2) {
      function at(t, a, b) { return ((1 - 3 * b + 3 * a) * t + (3 * b - 6 * a)) * t * t + 3 * a * t; }
      function dx(t) { return 3 * (1 - 3 * x2 + 3 * x1) * t * t + 2 * (3 * x2 - 6 * x1) * t + 3 * x1; }
      return function (x) {
        if (x <= 0) { return 0; }
        if (x >= 1) { return 1; }
        var t = x, i, d;
        for (i = 0; i < 8; i++) { d = dx(t); if (Math.abs(d) < 1e-6) { break; } t -= (at(t, x1, x2) - x) / d; }
        if (!(t >= 0 && t <= 1) || Math.abs(at(t, x1, x2) - x) > 1e-4) {
          var lo = 0, hi = 1; t = x;
          for (i = 0; i < 40; i++) { var v = at(t, x1, x2); if (Math.abs(v - x) < 1e-6) { break; } if (v < x) { lo = t; } else { hi = t; } t = (lo + hi) / 2; }
        }
        return at(t, y1, y2);
      };
    }
    /* A damped spring's unit step response (from rest, no initial velocity), time-scaled so its envelope has
       decayed to 0.1% exactly at t = 1 -- the way a duration-driven UIKit spring lands on its duration. The
       overshoot depends on the damping alone: exp(-zeta*pi/sqrt(1-zeta^2)) = 1.5% at 0.80, 0.15% at 0.90. */
    function crSpring(zeta) {
      var wn = Math.log(1000) / zeta, wd = wn * Math.sqrt(Math.max(1e-6, 1 - zeta * zeta));
      return function (t) {
        if (t <= 0) { return 0; }
        if (t >= 1) { return 1; }
        return 1 - Math.exp(-zeta * wn * t) * (Math.cos(wd * t) + (zeta * wn / wd) * Math.sin(wd * t));
      };
    }
    var CR_EASE_CLOSE = crBez(0.45, 0, 0.2, 1);
    var CR_EASE_DOCK = crSpring(CR_OPEN_DOCK_ZETA);
    var CR_EASE_OPEN = crSpring(CR_OPEN_ZETA);
    var CR_EASE_SLIDE = crBez(0.33, 1, 0.68, 1);
    function crPx(v) { return (Math.round(v * 100) / 100) + 'px'; }
    function crRect(el) { var r = el.getBoundingClientRect(); return { x: r.left, y: r.top, w: r.width, h: r.height }; }
    // the pill's LAYOUT box: never its :hover lift (translateY(-1px)) or its pressed :active scale -- the pointer is
    // on it, pressed, at the very moment it is tapped (measured: 37.4px tall instead of 38)
    function crPillRect(el) {
      var r = el.getBoundingClientRect(), w = el.offsetWidth || r.width, h = el.offsetHeight || r.height;
      var cx = r.left + r.width / 2, cy = r.top + r.height / 2;
      var m = /matrix\(([^)]+)\)/.exec(getComputedStyle(el).transform || '');
      if (m) { var v = m[1].split(',').map(parseFloat); cx -= v[4] || 0; cy -= v[5] || 0; }   // origin: its centre
      return { x: cx - w / 2, y: cy - h / 2, w: w, h: h };
    }
    function crRadii(el) {
      var s = getComputedStyle(el);
      return [s.borderTopLeftRadius, s.borderTopRightRadius, s.borderBottomRightRadius, s.borderBottomLeftRadius]
        .map(function (v) { return parseFloat(v) || 0; });
    }
    // the card's collapsed roller, if it is laid out (the viewer's pf-crlite cards hide it). It keeps its slot
    // (visibility:hidden) while the sheet is up, so this is also where the sheet was born and where it lands.
    function crPill(post) {
      var p = post && post.querySelector('.croller');
      return (p && p.closest('.post') === post && p.getClientRects().length) ? p : null;
    }
    function crOnScreen(el) {
      var r = el.getBoundingClientRect();
      return r.bottom > 0 && r.top < (window.innerHeight || 800) && r.width > 0;
    }
    // the sheet's own layers (skin, halo) and the face clone are not "content": they never fade with it
    function crKids(panel) {
      return Array.prototype.filter.call(panel.children, function (k) {
        return k.nodeType === 1 && !k.classList.contains('cr-pillclone') && !k.classList.contains('cr-bg') && !k.classList.contains('cr-halo');
      });
    }
    function crLayer(panel, cls) {
      for (var k = panel.firstElementChild; k; k = k.nextElementSibling) { if (k.classList.contains(cls)) { return k; } }
      return null;
    }
    // how far down the sticky/fixed page chrome reaches right now (the top bar, a stuck #feed-tabs)
    function crChromeBottom() {
      var y = 0, els = document.querySelectorAll('.topbar, #feed-tabs');
      for (var i = 0; i < els.length; i++) {
        var pos = getComputedStyle(els[i]).position;
        if (pos !== 'sticky' && pos !== 'fixed') { continue; }
        var r = els[i].getBoundingClientRect();
        if (r.height && r.top < 160 && r.bottom > 0) { y = Math.max(y, r.bottom); }
      }
      return y;
    }
    // the keyboard, if one is up: the layout-viewport y of its top edge (visualViewport's bottom), else null
    function crKeyboardTop() {
      var vv = window.visualViewport, ih = window.innerHeight || 0;
      if (!vv || !ih || !(vv.height < ih - 120)) { return null; }
      return (vv.offsetTop || 0) + vv.height;
    }
    /* THE CARD SHEET'S FINAL RECT (RovaComments.layoutSheet -- the CR_SHEET_* constants). Called in the open's
       first task with `.open` already on, again when the keyboard comes or goes and when the thread grows at
       rest; writes left/top/width + the height cap as inline px on the absolute sheet and touches nothing else,
       so the page's layout is unchanged by construction. `Q` = the pill's rect (null: no pill yet). */
    function crPlace(panel, post, Q, a) {
      // v5: the anchor is read BEFORE anything is written. The natural-height measurement below lays the list out
      // with nothing to scroll, which clamps its scrollTop to 0 in every engine: that was the thread jumping to its
      // OLDEST comment at every landing and every avatar/GIF load (Rob's recording, the rig on v4). crAnchorPut
      // at the end puts it back in the same task, so no frame ever shows it.
      crRtStop(panel);
      a = a || crAnchorGet(panel);
      var P = post.getBoundingClientRect(), ox = P.left + post.clientLeft, oy = P.top + post.clientTop;
      var vw = document.documentElement.clientWidth || window.innerWidth || 390, vh = window.innerHeight || 800;
      var row = post.querySelector('.post-row'), main = post.querySelector('.post-main');
      var span = row && row.closest('.post') === post ? row : post, S = span.getBoundingClientRect();
      var x, w;
      if (vw < CR_SHEET_PHONE_MAX) {
        var right = Q ? Q.x + Q.w : (main && main.closest('.post') === post ? main : span).getBoundingClientRect().right;
        var side = Math.max(CR_SHEET_SIDE_MIN, Math.min(CR_SHEET_SIDE_MAX, vw - right));
        x = side; w = vw - 2 * side;
      } else {
        x = span === post ? ox : S.left; w = span === post ? post.clientWidth : S.width;
      }
      var top0 = Q ? Q.y : ((main && main.closest('.post') === post ? main : span).getBoundingClientRect().bottom + CR_SHEET_NOPILL_GAP);
      panel.style.left = crPx(x - ox); panel.style.width = crPx(w);
      panel.style.height = ''; panel.style.maxHeight = 'none';
      var list = panel.querySelector('.cpanel-list');
      // natural, at that width -- FRACTIONAL (offsetHeight rounds, and a max-height a fraction short clips the composer)
      var N = panel.getBoundingClientRect().height, Ln = list ? list.getBoundingClientRect().height : 0, fixed = N - Ln;
      var kb = crKeyboardTop();
      var floor = kb != null ? kb - CR_SHEET_KB_GAP : vh - CR_SHEET_FLOOR_GAP;
      var topFloor = crChromeBottom() + CR_SHEET_TOP_GAP;
      var room = Math.max(CR_SHEET_MIN_ROOM, floor - topFloor);
      var L = Math.max(0, Math.min(Ln, vh * CR_SHEET_LIST_VH, room - fixed));
      var h = fixed + L;
      var top = top0;
      if (top + h > floor) { top = floor - h; }                   // near the bottom: RE-ANCHOR UPWARD
      top = Math.max(top, topFloor);
      panel.style.top = crPx(top - oy);
      panel.style.maxHeight = crPx(h);                            // a capped thread shrinks (flex column) and scrolls
      panel._cap = h;
      panel._place = { top0: top0, top: top, h: h, N: N, fixed: fixed, listNat: Ln, list: L, floor: floor, topFloor: topFloor, kb: kb, x: x, w: w, lifted: top < top0 - 0.5 };
      crAnchorPut(panel, a);
      crFootRoom();
    }
    function crPlaceNow(panel) {
      var post = panel._post, pl = post ? crPill(post) : null;
      if (post && !panel._docked) { crPlace(panel, post, pl ? crPillRect(pl) : null); }
    }
    /* THE FOOTER MAKES ROOM (2026-10-02, Rob, iPhone Safari: on a profile the LAST post's open sheet sat on top of
       the site footer -- "No comments yet" on the About/Blog/FAQ line, the Google Play badge over the composer).
       The card sheet is an overlay by design (v3: nothing under it moves), so on the last card of a list it reaches
       past the card into whatever follows -- and the page's footer is not a card: it is page chrome that must stay
       readable. So while a card sheet is up, footer.site is pushed down until it starts CR_FOOT_GAP below the
       sheet's bottom: real layout space, the document grows, nothing ABOVE the footer moves (the cards still never
       do). Only the footer's own margin changes -- set, then measured, because a collapsing margin on the block
       above can swallow part of it -- and it is undone when the last sheet is dropped (crDrop), never mid-close.
       Giving the room back never shortens the page under the reader: only the part of it that is below the screen
       goes at once; the rest follows as they scroll up (no scroll clamp, no jump). Called at the end of every
       crPlace (open, keyboard, thread growth) and from crDrop. (The other half of the bug -- the footer PAINTING
       over the sheet -- was the tab pager's leftover translateX(0) on #profile-posts / #feed-posts; see switchTab.) */
    var CR_FOOT_GAP = 14;
    var crFootWait = null, crFootOwed = false;
    function crFootRoom() {
      var f = document.querySelector('footer.site');
      if (!f || !f.isConnected) { return; }
      var sy = window.scrollY || window.pageYOffset || 0;
      var shift = f._crShift || 0, nat = f.getBoundingClientRect().top + sy - shift;   // its document top with no room
      var want = nat, ps = document.querySelectorAll('.post > .croller-panel');
      for (var i = 0; i < ps.length; i++) {
        var p = ps[i];
        if (p._docked || p.closest('.pfeed')) { continue; }
        if (!(p.classList.contains('open') || p.classList.contains('cr-closing') || p.classList.contains('cr-ghost'))) { continue; }
        var b = p.getBoundingClientRect();
        if (b.height) { want = Math.max(want, b.bottom + sy + CR_FOOT_GAP); }
      }
      var goal = Math.max(0, Math.ceil(want - nat)), to = goal;
      if (to < shift) {
        var slack = Math.max(0, Math.floor((document.documentElement.scrollHeight || 0) - (sy + (window.innerHeight || 0))));
        to = Math.max(to, shift - slack);
      }
      if (to !== shift) {
        if (!shift) { f._crMt0 = f.style.marginTop; f._crBase = parseFloat(getComputedStyle(f).marginTop) || 0; }
        if (!to) { f.style.marginTop = f._crMt0 || ''; }
        else {
          var m = f._crBase + to;
          f.style.marginTop = m + 'px';
          var got = f.getBoundingClientRect().top + sy - nat;
          if (Math.abs(got - to) > 0.5) { f.style.marginTop = (m + to - got) + 'px'; }
        }
        f._crShift = to;
      }
      // while the footer holds room, scrolling re-checks it: room still owed back (the reader was down in it) goes as
      // they scroll up, and a sheet that left without crDrop (its list re-rendered under it) cannot strand the room
      crFootOwed = to > goal;
      if (to > 0 && !crFootWait) {
        crFootWait = function () {
          if (crFootOwed || !document.querySelector('.post > .croller-panel:is(.open, .cr-closing, .cr-ghost)')) { crFootRoom(); }
        };
        window.addEventListener('scroll', crFootWait, { passive: true });
      } else if (!to && crFootWait) {
        window.removeEventListener('scroll', crFootWait);
        crFootWait = null;
      }
    }
    /* THE THREAD'S ANCHOR (v5; RovaComments' rule, from the iOS session). The thread is oldest -> newest, anchored to
       its BOTTOM: the newest row sits just above the composer. The open lays the sheet out at its final size and puts
       the list at its end BEFORE the morph starts (crAnchorOpen) -- no animated scroll, ever. Afterwards every
       re-layout (landing, a page arriving, an image, the keyboard, a send) keeps it: "stick" (the reader is within
       CR_STICK_PX of the end, recomputed on every scroll; true at open) -> back to the end; otherwise the first
       visible row keeps its offset, so a landing page never yanks a reader who scrolled up to read older comments.
       CR_ANCHOR is the one switch: 'end' (native) | 'seed' (also keep the comment the pill was showing in view). */
    var CR_ANCHOR = 'end', CR_STICK_PX = 30, CR_WAIT_MS = 250;
    var CR_RT_MS = 420, CR_EASE_RT = crSpring(0.86);     // native: the sheet re-targets its size, 0.42s damping 0.86
    // v7 LIVE THREAD (native 550): an open thread re-reads every CR_LIVE_MS (since_rev: an unchanged one costs one Redis
    // read); new rows the reader should see GLIDE into view over CR_GLIDE_MS (ease-out, never an overshoot)
    var CR_LIVE_MS = 4000, CR_GLIDE_MS = 420;
    function crGlideEase(k) { return 1 - Math.pow(1 - k, 3); }
    function crAnchorGet(panel) {
      if (panel._glideA && panel._glideA.glide) { return panel._glideA; }   // v7: a glide in flight IS the anchor
      var list = panel.querySelector('.cpanel-list'), a = { stick: panel._stick !== false, row: null, off: 0 };
      if (!list) { return a; }
      var lt = list.getBoundingClientRect().top, k = list.children;
      for (var i = 0; i < k.length; i++) { var q = k[i].getBoundingClientRect(); if (q.bottom > lt + 0.5) { a.row = k[i]; a.off = q.top - lt; break; } }
      return a;
    }
    /* v7 THE GLIDE (native 550: "it should stay open and on the bottom ... so the commenter can see it"). An anchor with
       .glide moves the list from where it stood (y0) to its target over CR_GLIDE_MS, by time, so every caller that puts
       it -- the height spring's frames, the ResizeObserver, crGlide's own frames -- agrees on one position. Target: the
       END (a top-level comment, or new rows for a reader who was at the end), or just enough to show .row (a reply,
       under its parent). It ends as a plain anchor: stuck at the end, or pinned on that row. */
    function crGlideAnchor(y0, row) { return { stick: false, row: null, off: 0, glide: { y0: y0, row: row || null, t0: performance.now() } }; }
    function crGlideTarget(list, G) {
      var max = Math.max(0, list.scrollHeight - list.clientHeight);
      if (!G.row) { return max; }
      if (G.row.parentNode !== list) { return Math.min(G.y0, max); }
      var L = list.getBoundingClientRect(), R = G.row.getBoundingClientRect(), pad = 8;
      var top = R.top - L.top + list.scrollTop, bot = top + R.height, t = G.y0;
      if (bot + pad > t + list.clientHeight) { t = bot + pad - list.clientHeight; }   // below the view: bring its bottom in
      if (top - pad < t) { t = top - pad; }                                          // (never past its top)
      return Math.max(0, Math.min(max, t));
    }
    function crGlide(panel, a) {
      if (!a || !a.glide) { return; }
      panel._glideA = a;
      var step = function () {
        if (panel._glideA !== a || !panel.isConnected) { return; }
        if (!panel._rt) { crAnchorPut(panel, a); }             // a running height spring puts this same anchor itself
        if (a.glide) { requestAnimationFrame(step); } else if (panel._glideA === a) { panel._glideA = null; }
      };
      requestAnimationFrame(step);
    }
    // the reader takes the list: the glide stops where it is (the shared anchor object becomes a plain one, in place)
    function crGlideStop(panel) {
      var a = panel._glideA;
      if (!a) { return; }
      panel._glideA = null;
      a.glide = null; a.stick = false;
      var s = crAnchorGet(panel); a.row = s.row; a.off = s.off;
    }
    function crAnchorPut(panel, a) {
      var list = panel.querySelector('.cpanel-list');
      if (!list || !a) { return; }
      if (a.glide) {
        var G = a.glide, k = crReduced() ? 1 : Math.min(1, (performance.now() - G.t0) / CR_GLIDE_MS), tg = crGlideTarget(list, G);
        list.scrollTop = G.y0 + (tg - G.y0) * crGlideEase(k);
        if (k >= 1) {
          a.glide = null;
          if (!G.row) { a.stick = true; panel._stick = true; }
          else if (G.row.parentNode === list) {
            a.row = G.row; a.off = G.row.getBoundingClientRect().top - list.getBoundingClientRect().top;
            panel._stick = list.scrollHeight - list.clientHeight - list.scrollTop <= CR_STICK_PX;
          }
          if (panel._glideA === a) { panel._glideA = null; }
        }
        return;
      }
      if (a.stick) { list.scrollTop = list.scrollHeight; return; }
      if (a.row && a.row.parentNode === list) {
        var d = a.row.getBoundingClientRect().top - list.getBoundingClientRect().top - a.off;
        if (Math.abs(d) >= 0.5) { list.scrollTop += d; }
        panel._aSnap = a;
      }
    }
    // the pill's current line (CR_ANCHOR 'seed' only): the roller items carry no comment id, so name + text
    function crSeedKey(post) {
      var it = post.querySelector('.croller .croller-item.on');
      if (!it) { return null; }
      var n = it.querySelector('.cr-name'), t = it.querySelector('.cr-text');
      return { name: n ? n.textContent.trim() : '', text: t ? t.textContent.trim().slice(0, 40) : '' };
    }
    function crAnchorOpen(panel) {
      var list = panel.querySelector('.cpanel-list');
      if (!list) { return; }
      list.scrollTop = list.scrollHeight;
      panel._stick = true;
      var k = CR_ANCHOR === 'seed' ? panel._seedKey : null, r = null, rows, i;
      if (!k || !k.name) { return; }
      rows = list.querySelectorAll('.cx-row');
      for (i = rows.length - 1; i >= 0 && !r; i--) {
        var n = rows[i].querySelector('.cr-name'), t = rows[i].querySelector('.cr-text');
        if (n && (n.textContent.trim() === k.name || (n.getAttribute('data-short') || '').trim() === k.name) && (!k.text || (t && t.textContent.trim().indexOf(k.text) === 0))) { r = rows[i]; }
      }
      if (!r) { return; }
      var d = r.getBoundingClientRect().top - list.getBoundingClientRect().top;
      if (d < 0) { list.scrollTop += d; panel._stick = list.scrollHeight - list.clientHeight - list.scrollTop <= CR_STICK_PX; }
    }
    // the card sheet's box right now: its top (inline, in the card's coordinates) and its laid-out height
    function crBoxNow(panel) { return { top: parseFloat(panel.style.top) || 0, h: panel.getBoundingClientRect().height }; }
    function crRtStop(panel) { if (panel._rt) { cancelAnimationFrame(panel._rt); panel._rt = 0; } }
    /* Re-place the card sheet (crPlace) and, if its rect changed, RE-TARGET to it on the native spring from where it is
       (r0) -- never a snap. The rows ride inside: the box's height/top are written per frame (one absolute box; no
       page layout moves) and the anchor is re-applied every frame. Interruptible: a later call starts from the
       current inline values. */
    function crPlaceSpring(panel, r0, a) {
      var post = panel._post, docked = !!panel._docked, h1, t1;
      if (!post || !panel.classList.contains('open')) { return; }
      crRtStop(panel);
      a = a || crAnchorGet(panel);
      r0 = r0 || crBoxNow(panel);
      if (docked) {
        // v5b: the viewer's sheet (bottom:0, natural height, its thread caps itself): the same spring, height only --
        // the bottom stays pinned, the top edge rides up/down with it
        panel.style.height = ''; panel.style.maxHeight = 'none';
        h1 = panel.getBoundingClientRect().height; t1 = r0.top;
        crAnchorPut(panel, a);
      } else {
        var pl = crPill(post);
        crPlace(panel, post, pl ? crPillRect(pl) : null, a);
        h1 = panel._place.h; t1 = parseFloat(panel.style.top) || 0;
      }
      // the same target as the re-target in flight (a burst of avatar loads): carry on along it, never restart it
      var S = panel._rtS;
      if (S && S.live && Math.abs(S.h1 - h1) < 0.5 && Math.abs(S.t1 - t1) < 0.5) { r0 = S.r0; } else { S = null; }
      panel._rtS = null;
      if (crReduced() || !window.requestAnimationFrame || (Math.abs(h1 - r0.h) < 0.5 && Math.abs(t1 - r0.top) < 0.5)) { return; }
      S = panel._rtS = { r0: r0, t1: t1, h1: h1, t0: S ? S.t0 : performance.now(), k: S ? S.k : 0, live: true };
      panel.style.maxHeight = 'none';
      var step = function () {
        if (panel._rtS !== S) { return; }
        // ONE clock: performance.now(), never the rAF timestamp (a frame's start time is EARLIER than a synchronous
        // step taken in the same frame -- measured: the box stepped backwards 12px on a continued re-target)
        var k = Math.min(1, Math.max(S.k || 0, (performance.now() - S.t0) / CR_RT_MS)), e = CR_EASE_RT(k);
        S.k = k;
        if (k < 1) {
          if (!docked) { panel.style.top = crPx(r0.top + (t1 - r0.top) * e); }
          panel.style.height = crPx(r0.h + (h1 - r0.h) * e);
          panel._rt = requestAnimationFrame(step);
        } else {
          panel._rt = 0; S.live = false;
          panel.style.height = '';
          if (docked) { panel.style.maxHeight = 'none'; } else { panel.style.top = crPx(t1); panel.style.maxHeight = crPx(h1); }
        }
        crAnchorPut(panel, a);
      };
      step();   // this frame: where the spring is now (r0 on a fresh one)
    }
    /* v5b: A PAGE LANDS MID-OPEN (native: the sheet re-targets its size on the spring "from wherever it is, even
       mid-open", rows carried inside). During an open the only thing moving is the clip, so: read the rect the clip
       shows RIGHT NOW (and its corner radius, and the viewer skin's glass->solid opacity), lay the sheet out at its
       NEW size with the new rows (anchor kept), and run a fresh clip from that exact rect to the new box on the
       re-target spring (CR_RT_MS / CR_EASE_RT). The pill's face stays on the pill (its offset follows the box move),
       the content/face crossfade keeps its own clock. Not for the viewer's slide-up (no clip: that one merges at its
       landing) nor a close. Returns false when it cannot run (the caller then merges at the landing). */
    function crCanRetarget(panel) {
      var m = panel._morph;
      return !!(m && panel._geo && !m.slide && m.to > m.from && panel._post && !panel.classList.contains('cr-closing') && !crReduced());
    }
    function crRetargetOpen(panel, a) {
      var g = panel._geo, post = panel._post;
      var o = crNow(panel), oc = Math.max(0, Math.min(1, o));
      var P0 = panel.getBoundingClientRect();
      var cur = { x: g.q.x * (1 - o), y: g.q.y * (1 - o), w: g.q.w + (g.W - g.q.w) * o, h: g.q.h + (g.H - g.q.h) * o };
      var rNow = g.rq + ((g.r1[0] || 0) - g.rq) * oc;
      var skin = g.glass ? crLayer(panel, 'cr-bg') : null, sOp = skin ? parseFloat(getComputedStyle(skin).opacity) : 0;
      crStop(panel);                                        // the old clip goes; this same task starts the new one
      if (panel._docked) { panel.style.height = ''; panel.style.maxHeight = 'none'; }
      else { var pl = crPill(post); crPlace(panel, post, pl ? crPillRect(pl) : null, a); }
      var g2 = crMeasure(panel, post), P1 = panel.getBoundingClientRect(), dx = P0.left - P1.left, dy = P0.top - P1.top;
      g2.q = { x: cur.x + dx, y: cur.y + dy, w: cur.w, h: cur.h };
      g2.rq = rNow; g2.glass = g.glass; g2.skinFrom = isNaN(sOp) ? 0 : sOp;
      var face = panel._face && panel._face.isConnected ? panel._face : null;
      if (face && (dx || dy)) { face.style.left = crPx((parseFloat(face.style.left) || 0) + dx); face.style.top = crPx((parseFloat(face.style.top) || 0) + dy); }
      g2.clone = face; g2.anchored = true; g2.faceAt = null;
      crLock(panel, g2);
      crAnchorPut(panel, a);
      crRun(panel, 0, 1, CR_RT_MS, CR_EASE_RT, function () { crLand(panel); });
      return true;
    }
    /* THE CLEAR BACKDROP (native: a full-screen clear view under the sheet). A transparent fixed layer inserted
       into the HOST CARD right under the sheet -- the card is the stacking context lifted over every other card
       (z 15), the layer is z 1 in it and the sheet z 2, so it covers the whole feed and the card itself, and stays
       under the sticky tabs/top bar. A TAP on it closes with the morph (the outside-tap rule, card branch). It
       goes the moment a close starts (the feed is live again under the folding sheet) and comes back with a
       reversal -- except that a finger which went down ON it keeps it as that touch's target until the finger
       lifts (it only stops taking new hits, .cr-bd-gone): iOS can drop a touch sequence whose target leaves the
       document mid-gesture, and that gesture is now the page's scroll (v6, below).

       v6 (2026-09-30, Rob on iPhone Safari: "I should be able to scroll the timeline outside the comment roller even
       when a comment roller is expanded. And/or if I try to, it should dismiss it/collapse it.") -- ROB'S RULE
       SUPERSEDES THE NATIVE SCROLL LOCK ON THE WEB (v4-v5c cancelled wheel/touchmove outside the sheet). Now a scroll
       gesture that starts OUTSIDE the sheet (and its GIF/emoji pickers) scrolls the page at once, natively, in the
       same gesture -- nothing is preventDefault'd, every listener here is passive, the backdrop is
       touch-action:manipulation -- and folds the sheet on its FIRST sign: a finger past CR_SWIPE_SLOP in any
       direction, a wheel/trackpad event, or a page-scroll key. The fold is closePanel(panel, 'swipe') = iOS build 549's
       quick FOLD (not the morph: the pill is moving with the page): whatever is running freezes where it stands and
       the whole sheet fades out while it scales to CR_SWIPE_SCALE about its centre over CR_SWIPE_MS, onto the pill,
       back in its slot under it from that frame. The sheet is an overlay inside its own card, so it rides the page while it
       fades, and the card never changed height, so nothing below it moves. Inside the sheet nothing changed: the
       thread scrolls and never chains (guardPanelScroll), the handle scrubs (crScrub).
       THE GESTURE THAT FOLDS A SHEET IS NOT A PULL: window.__rovaCrGesture() is true while a card sheet is up and
       for the rest of the gesture that folded it (the finger until it lifts; wheel/keys until CR_TAIL_MS of quiet).
       The feed's pull at the top (ptrForeignOrigin) and the ring's un-fold (ringGesture / its touchmove) stand
       down while it is. */
    var CR_SWIPE_SLOP = 6, CR_SWIPE_MS = 160, CR_SWIPE_SCALE = 0.96, CR_TAIL_MS = 400;   // = iOS build 549
    var crLockOn = null, crTail = null;
    var CR_SCROLL_KEY = /^(ArrowUp|ArrowDown|PageUp|PageDown|Home|End| |Spacebar)$/;
    function crTailOff() {
      var T = crTail;
      if (!T) { return; }
      crTail = null;
      clearTimeout(T.tm);
      T.ls.forEach(function (l) { document.removeEventListener(l[0], l[1], true); });
    }
    function crTailLive() {
      var T = crTail;
      if (!T) { return false; }
      if (T.finger || Date.now() < T.until) { return true; }
      crTailOff();
      return false;
    }
    // the rest of the gesture that folded a sheet: a finger until it lifts, a wheel/trackpad stream (momentum
    // included) or a held key until it has been quiet for CR_TAIL_MS
    function crTailArm(kind) {
      crTailOff();
      var T = crTail = { finger: kind === 'touch', until: 0, tm: 0, ls: [] };
      var bump = function () { T.until = Date.now() + CR_TAIL_MS; clearTimeout(T.tm); T.tm = setTimeout(crTailLive, CR_TAIL_MS + 50); };
      var up = function (e) { if (!e.touches || !e.touches.length) { T.finger = false; bump(); } };
      T.ls = [['wheel', bump], ['keydown', bump], ['touchend', up], ['touchcancel', up]];
      T.ls.forEach(function (l) { document.addEventListener(l[0], l[1], { capture: true, passive: true }); });
      bump();
    }
    window.__rovaCrGesture = function () { return !!crLockOn || crTailLive(); };
    var crTapOff = null;                                      // the outside-tap rule's pending click (card branch)
    function crSwipeFold(panel, kind) {
      crTailArm(kind);
      if (crTapOff) { crTapOff(); }                           // a scroll is not a tap: nothing waits for its click
      if (panel.classList.contains('open') && !panel._closed) { closePanel(panel, 'swipe'); }
    }
    function crOutsideScroll(panel, on) {
      if (on) {
        if (crLockOn) { if (crLockOn.panel === panel) { return; } crOutsideScroll(crLockOn.panel, false); }
        var L = { panel: panel, t: null, ls: null };
        var outside = function (t) { return !(t && t.closest && (t.closest('.croller-panel') === panel || t.closest(PANEL_POPOVERS))); };
        var fold = function (kind) { if (crLockOn === L) { crSwipeFold(panel, kind); } };
        var ts = function (e) {
          var p = e.touches && e.touches[0];
          L.t = (p && outside(e.target)) ? { x: p.clientX, y: p.clientY } : null;
          var bd = panel._backdrop;
          if (bd && e.target === bd) { bd._finger = true; }
        };
        var tm = function (e) {
          var p = e.touches && e.touches[0];
          if (!L.t || !p) { return; }
          if (Math.abs(p.clientX - L.t.x) > CR_SWIPE_SLOP || Math.abs(p.clientY - L.t.y) > CR_SWIPE_SLOP) { L.t = null; fold('touch'); }
        };
        var te = function (e) {
          if (e.touches && e.touches.length) { return; }
          L.t = null;
          if (panel._backdrop) { panel._backdrop._finger = false; }
        };
        var wh = function (e) {
          if (e.ctrlKey || (!e.deltaX && !e.deltaY) || !outside(e.target)) { return; }   // ctrl+wheel = zoom
          fold('wheel');
        };
        var kd = function (e) {
          if (e.defaultPrevented || e.ctrlKey || e.metaKey || e.altKey || !CR_SCROLL_KEY.test(e.key || '')) { return; }
          var t = e.target;
          if (!outside(t) || (t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName || '')))) { return; }
          if ((e.key === ' ' || e.key === 'Spacebar') && t && t.closest && t.closest('a[href], button, [role="button"], summary')) { return; }   // space presses it
          fold('key');
        };
        L.ls = [['touchstart', ts], ['touchmove', tm], ['touchend', te], ['touchcancel', te], ['wheel', wh], ['keydown', kd]];
        L.ls.forEach(function (l) { document.addEventListener(l[0], l[1], { capture: true, passive: true }); });
        crLockOn = L;
      } else if (crLockOn && crLockOn.panel === panel) {
        crLockOn.ls.forEach(function (l) { document.removeEventListener(l[0], l[1], true); });
        crLockOn = null;
      }
    }
    // a backdrop leaving: at once, unless a finger that went down on it is still down (then it stops taking hits and
    // goes when that finger lifts -- the touch keeps a live target, the page keeps scrolling under it)
    function crBackdropGone(b) {
      if (!b._finger || !b.parentNode) { if (b.parentNode) { b.parentNode.removeChild(b); } return; }
      b.classList.add('cr-bd-gone');
      var tm = 0;
      var rm = function (e) {
        if (e && e.touches && e.touches.length) { return; }
        window.removeEventListener('touchend', rm, true); window.removeEventListener('touchcancel', rm, true);
        clearTimeout(tm);
        if (b.parentNode) { b.parentNode.removeChild(b); }
      };
      window.addEventListener('touchend', rm, true); window.addEventListener('touchcancel', rm, true);
      tm = setTimeout(rm, 15000);                             // a lost touchend: never leave it behind for long
    }
    // the keyboard comes or goes: the sheet re-lays out to its floor (crPlace) -- the feed stays where it is
    function crWatchKeyboard(panel, on) {
      var vv = window.visualViewport;
      if (on) {
        if (!vv || panel._kbw) { return; }
        var f = function () { if (!panel._morph && panel.classList.contains('open')) { crPlaceNow(panel); } };
        panel._kbw = { vv: vv, f: f };
        vv.addEventListener('resize', f);
      } else if (panel._kbw) {
        panel._kbw.vv.removeEventListener('resize', panel._kbw.f);
        panel._kbw = null;
      }
    }
    function crBackdrop(panel, on) {
      if (on) {
        if (panel._docked || panel._backdrop || !panel._post || panel.parentNode !== panel._post) { return; }
        var b = document.createElement('div');
        b.className = 'cr-backdrop';
        b.setAttribute('aria-hidden', 'true');
        panel._post.insertBefore(b, panel);
        panel._backdrop = b;
        crOutsideScroll(panel, true);
        crWatchKeyboard(panel, true);
      } else {
        if (panel._backdrop) { crBackdropGone(panel._backdrop); panel._backdrop = null; }
        crOutsideScroll(panel, false);
        crWatchKeyboard(panel, false);
      }
    }

    /* PULL-DOWN SCRUBS THE CLOSE (native: the drag progress drives the same collapse). A downward drag on the
       handle past CR_SCRUB_SLOP STARTS the real close (closePanel: morph, content fade, face crossfade, halo) and
       freezes it; the finger then sets every one of those animations to the same clock, so the crossfade sum
       stays 1 at every position. Release past CR_SCRUB_COMMIT of the way (or flicked down) -> it plays on from
       there to the pill; otherwise it runs back open (crReopen, the same reversal a tap on a folding sheet gets).
       The click that follows a drag is swallowed (handle._scrubbed), so it never also toggles. */
    var CR_SCRUB_SLOP = 6, CR_SCRUB_COMMIT = 0.35, CR_SCRUB_FLICK = 0.6;   // px, share of the travel, px/ms
    // the flick is the finger's speed AT the release: a finger that stopped (no move for CR_SCRUB_STILL ms) has
    // none, whatever its last move was (09-29: pull fast, hold, let go under the commit line CLOSED on the stale v)
    var CR_SCRUB_STILL = 100;
    function crInvert(ease, p) {
      var lo = 0, hi = 1;
      for (var i = 0; i < 32; i++) { var mid = (lo + hi) / 2; if (ease(mid) < p) { lo = mid; } else { hi = mid; } }
      return (lo + hi) / 2;
    }
    function crScrub(panel, handle) {
      var s = null;
      handle.addEventListener('pointerdown', function (e) {
        s = null;
        // a new press starts clean: a TOUCH drag has no trailing click to consume the flag, so without this the
        // first chevron tap after a spring-back was swallowed (09-29; a mouse drag's click still eats it)
        handle._scrubbed = false;
        if ((e.button && e.button > 0) || !panel.classList.contains('open') || panel._morph || crReduced() || !panel.animate) { return; }
        s = { id: e.pointerId, y: e.clientY, on: false, p: 0, ly: e.clientY, lt: e.timeStamp || 0, v: 0 };
        try { handle.setPointerCapture(e.pointerId); } catch (x) {}
      });
      handle.addEventListener('pointermove', function (e) {
        if (!s || e.pointerId !== s.id) { return; }
        var dy = e.clientY - s.y, now = e.timeStamp || 0;
        if (now > s.lt) { s.v = (e.clientY - s.ly) / (now - s.lt); }
        s.ly = e.clientY; s.lt = now;
        if (!s.on) {
          if (dy < CR_SCRUB_SLOP) { return; }
          closePanel(panel);
          var m = panel._morph;
          if (!m || !panel.classList.contains('cr-closing')) { s = null; return; }
          clearTimeout(m.backstop);
          s.on = true; s.m = m;
          s.anims = m.anims.concat(panel._fades || []);
          s.anims.forEach(function (a) { try { a.pause(); } catch (x) {} });
          var g = panel._geo;
          s.D = Math.max(80, g.H - g.q.h);                    // the drag that folds it all the way
          handle._scrubbed = true;
        }
        s.p = Math.max(0, Math.min(1, (dy - CR_SCRUB_SLOP) / s.D));
        var ms = crInvert(s.m.ease, s.p) * s.m.ms;
        s.anims.forEach(function (a) { try { a.currentTime = Math.min(ms, a.effect.getComputedTiming().endTime); } catch (x) {} });
      });
      function end(e) {
        if (!s || e.pointerId !== s.id) { return; }
        var st = s; s = null;
        if (!st.on || panel._morph !== st.m) { return; }
        var v = ((e.timeStamp || 0) - st.lt) > CR_SCRUB_STILL ? 0 : st.v;
        if (st.p >= CR_SCRUB_COMMIT || v > CR_SCRUB_FLICK) {
          var at = st.m.anims[0] ? (st.m.anims[0].currentTime || 0) : 0;
          st.anims.forEach(function (a) { try { a.play(); } catch (x) {} });
          st.m.backstop = setTimeout(st.m.fin, Math.max(0, st.m.ms - at) + 250);
        } else {
          if (openPanel && openPanel !== panel) { closePanel(openPanel); }
          openPanel = crReopen(panel);
          engHold('comments', true, ENG_LONG, openPanel);
        }
      }
      handle.addEventListener('pointerup', end);
      handle.addEventListener('pointercancel', end);
    }
    /* Both rects, once per motion, with the sheet's FINAL box in force (it never moves while it morphs). */
    function crMeasure(panel, post) {
      var docked = !!panel._docked;
      var L = crRect(panel), pl = crPill(post);
      var Q = pl ? crPillRect(pl) : null;
      var q = Q ? { x: Q.x - L.x, y: Q.y - L.y, w: Q.w, h: Q.h }
                : (docked ? { x: 0, y: L.h, w: L.w, h: 0 } : { x: 0, y: 0, w: L.w, h: 0 });   // no pill: a seam
      return panel._geo = {
        docked: docked, post: post, W: L.w, H: L.h, q: q, pill: Q,
        rq: Math.min(pl ? crRadii(pl)[0] : 0, q.h / 2), r1: crRadii(panel), lit: false, clone: null
      };
    }
    // hold the sheet's box for the length of a motion: a late avatar/GIF load must not resize it under the clip
    function crLock(panel, g) { panel.style.height = crPx(g.H); panel.style.maxHeight = 'none'; }
    // the clip at openness o (0 = the pill, 1 = the sheet, >1 = the spring's overshoot past it, painted by the
    // grown skin); `halo` widens it on every side so the halo can fade out at the start of a close
    function crFrame(g, o, halo) {
      var q = g.q, W = g.W, H = g.H, oc = o < 0 ? 0 : (o < 1 ? o : 1);
      var x = q.x * (1 - o), y = q.y * (1 - o), w = q.w + (W - q.w) * o, h = q.h + (H - q.h) * o;
      var rr = g.r1.map(function (r) { return crPx(g.rq + (r - g.rq) * oc); }).join(' ');
      return 'inset(' + crPx(y - halo) + ' ' + crPx(W - x - w - halo) + ' ' + crPx(H - y - h - halo) + ' ' + crPx(x - halo) + ' round ' + rr + ')';
    }
    function crStop(panel) {
      crRtStop(panel);
      var m = panel._morph;
      if (!m) { return; }
      panel._morph = null;
      clearTimeout(m.backstop);
      m.anims.forEach(function (a) { try { a.cancel(); } catch (e) {} });
      panel.classList.remove('cr-morphing');
    }
    // openness right now (reads the running morph's own clock)
    function crNow(panel) {
      var m = panel._morph;
      if (!m) { return (panel.classList.contains('open') || panel.classList.contains('cr-closing')) ? 1 : 0; }
      var ct = m.anims[0] ? m.anims[0].currentTime : null;
      var t = ct == null ? 0 : Math.min(1, Math.max(0, ct / m.ms));
      return m.from + (m.to - m.from) * m.ease(t);
    }
    /* Run openness from -> to. `done` MUST end the motion (crLand, or the close's handoff) and crStop() in the
       same task (fill:'forwards' holds the last frame until it does). */
    function crRun(panel, from, to, ms, ease, done) {
      var g = panel._geo;
      crStop(panel);
      var n = Math.max(10, Math.round(ms / 8)), kP = [], kB = [], i;
      var closing = to < from;
      var skin = g.glass && !closing ? crLayer(panel, 'cr-bg') : null;
      for (i = 0; i <= n; i++) {
        var t = i / n, o = from + (to - from) * ease(t);
        // the halo lives OUTSIDE the box, where any clip cuts it: at the start of a close the clip still reaches
        // over it while it fades (CR_HALO_MS), then closes in on the shrinking rect
        var halo = (closing && g.lit && from >= 1) ? CR_HALO * Math.max(0, 1 - t * ms / CR_HALO_MS) : 0;
        kP.push({ offset: t, clipPath: crFrame(g, o, halo) });
        // the viewer's sheet: the pill's glass -> the opaque #17171c skin, on the same curve as the rect
        if (skin) { var sf = g.skinFrom || 0; kB.push({ offset: t, opacity: sf + (1 - sf) * Math.max(0, Math.min(1, o)) }); }   // v5b: skinFrom = a re-target's start
      }
      // the pill's own face (crPillFace), held at the pill's size and centred in the shrinking rect. Its
      // OPACITY is not here: it crossfades against the content on the content fade's own clock (closePanel)
      // v4: a face KEPT from an interrupted open (g.anchored) stays where it is and just rides home to the pill
      // (from its current offset g.faceAt to 0) -- the pill's rect lies inside every rect of the shrink
      var kX = [];
      if (g.clone && closing) {
        for (i = 0; i <= n; i++) {
          var tx = i / n, ox = Math.min(from + (to - from) * ease(tx), 1), q = g.q, cx, cy;
          if (g.anchored) {
            var left = from > 0 ? Math.max(0, Math.min(1, ox / Math.min(from, 1))) : 0;
            cx = (g.faceAt ? g.faceAt[0] : 0) * left; cy = (g.faceAt ? g.faceAt[1] : 0) * left;
          } else {
            cx = q.x * (1 - ox) + (q.w + (g.W - q.w) * ox) / 2 - (q.x + q.w / 2);
            cy = q.y * (1 - ox) + (q.h + (g.H - q.h) * ox) / 2 - (q.y + q.h / 2);
          }
          kX.push({ offset: tx, transform: 'translate(' + crPx(cx) + ',' + crPx(cy) + ')' });
        }
      }
      panel.classList.add('cr-morphing');
      var opt = { duration: ms, easing: 'linear', fill: 'forwards' };
      var anims = [panel.animate(kP, opt)];
      if (kX.length && g.clone.isConnected) { anims.push(g.clone.animate(kX, opt)); }
      if (skin) { anims.push(skin.animate(kB, opt)); }
      var m = panel._morph = { anims: anims, from: from, to: to, ms: ms, ease: ease, fired: false, backstop: 0, fin: null };
      var fin = function () {
        if (m.fired || panel._morph !== m) { return; }
        m.fired = true;
        clearTimeout(m.backstop);
        if (done) { done(); } else { crStop(panel); }
      };
      m.fin = fin;                                          // the pull-down scrub re-arms the backstop on release
      anims[0].onfinish = fin;
      m.backstop = setTimeout(fin, ms + 250);
    }
    // the rows/handle/composer fade -- from wherever they are now
    function crFade(panel, to, ms, delay, from) {
      var kids = crKids(panel);
      var cur = kids.map(function (k) { return parseFloat(getComputedStyle(k).opacity); });
      (panel._fades || []).forEach(function (a) { try { a.cancel(); } catch (e) {} });
      panel._fades = null;
      panel._fadeFrom = kids.length && !isNaN(cur[0]) ? cur[0] : 1;   // where the content starts (the face's crossfade)
      if (!(ms > 0) || !panel.animate) { return; }
      panel._fades = kids.map(function (k, i) {
        var f0 = from != null ? from : (isNaN(cur[i]) ? 1 : cur[i]);
        var a = k.animate([{ opacity: f0 }, { opacity: to }],
                          { duration: ms, delay: delay || 0, easing: to > 0 ? 'cubic-bezier(.2,.7,.2,1)' : CR_FADE_OUT_EASE, fill: 'both' });
        // faded IN = the natural state: let go of it, so nothing is held on the element afterwards
        if (to >= 1) { a.onfinish = function () { try { a.cancel(); } catch (e) {} }; }
        return a;
      });
    }
    /* THE OPEN'S CROSSFADE (v4, mirror of the close's app-520 crossfade): from wherever the content is (0 on a
       fresh open, c on a reversal) to 1, and the pill's face (panel._face, if any) from 1 - c to 0 -- same
       duration, same easing, same start, so content + face = 1 in every frame and no frame is an empty box.
       The face's fade is NOT one of the morph's animations (a reversal's morph can be shorter than 200ms and
       crLand must not snap it back); it removes the face when it reaches 0 (backstop: ms + 250). */
    function crXfadeIn(panel, ms, from) {
      var kids = crKids(panel), face = panel._face;
      // a fresh open passes 0 (the content sits at its natural 1 under a still-hidden sheet); a reversal reads it
      var c = from != null ? from : (kids.length ? parseFloat(getComputedStyle(kids[0]).opacity) : 1);
      if (isNaN(c)) { c = 0; }
      (panel._fades || []).forEach(function (a) { try { a.cancel(); } catch (e) {} });
      panel._fades = null;
      if (panel._faceFade) { try { panel._faceFade.cancel(); } catch (e) {} panel._faceFade = null; }
      if (!(ms > 0) || !panel.animate) { crDropFace(panel); return; }
      var opt = { duration: ms, easing: CR_XFADE_IN_EASE, fill: 'both' };
      panel._fades = kids.map(function (kd) {
        var a = kd.animate([{ opacity: c }, { opacity: 1 }], opt);
        a.onfinish = function () { try { a.cancel(); } catch (e) {} };   // faded in = natural: hold nothing
        return a;
      });
      if (face && face.isConnected) {
        var fa = panel._faceFade = face.animate([{ opacity: 1 - c }, { opacity: 0 }], opt);
        var gone = function () { if (panel._faceFade === fa) { crDropFace(panel); } };
        fa.onfinish = gone;
        panel._faceBackstop = setTimeout(gone, ms + 250);
      }
    }
    // THE HALO: after the landing, 150ms (none of it during the motion)
    function crLight(panel) {
      if (panel.classList.contains('cr-lit')) { return; }
      var h = crLayer(panel, 'cr-halo');
      panel.classList.add('cr-lit');
      if (h && h.animate && !crReduced()) {
        try { h.getAnimations().forEach(function (a) { a.cancel(); }); } catch (e) {}
        h.animate([{ opacity: 0 }, { opacity: 1 }], { duration: CR_HALO_MS, easing: 'ease-out' });
      }
    }
    /* AN OPEN HAS LANDED (or was never animated): let go of the motion in one task -- the clip and the skin's
       overshoot reach go together, the box is free to follow its content again (up to its cap) -- then the halo. */
    function crLand(panel) {
      // v5: the anchor and the held box are read FIRST (the re-layout below used to clamp the thread to its top), a
      // page that arrived during the motion (panel._pending) is merged in this same task, and a changed height
      // re-targets on the spring instead of snapping
      var a = crAnchorGet(panel), r0 = crBoxNow(panel);
      crStop(panel);
      panel.classList.remove('cr-grow');
      panel._sizeLate = false;
      var pd = panel._pending; panel._pending = null;
      if (pd && panel._fill) { panel._fill(pd.res, pd.fresh); }
      if (panel._size) { panel._size(r0, a); } else { panel.style.height = ''; }
      crLight(panel);
    }
    /* THE PILL'S FACE, INSIDE THE SHRINKING SHEET (2026-09-29, app build 519: "Instead of fading to blank, it
       should fade to the actual comment that it's going to land on, so the transition is seamless.")
       A copy of the collapsed roller exactly as it will look when it comes back -- taken AFTER syncRoller(),
       so it carries the line the real pill will show -- laid at the pill's own rect in the panel's
       coordinates, never scaled (the close is a clip, not a scale). crRun() centres it in the shrinking rect;
       its opacity CROSSFADES with the content (app build 520, Rob still saw a blank box mid-close when it only
       came up from 40%): the same 200ms, same easing, same start, face 0->1 while the content goes 1->0, so
       the two sum to 1 in every frame; from 200ms to 340ms it holds at 1 while the rect finishes shrinking.
       The collapse's final frames ARE the pill's pixels at the pill's place and the 140ms hand-off to the
       real one changes nothing. Inert, aria-hidden, pointer-events:none;
       its track is invisible to the roller ticker (`.croller-track:not(.cr-pillclone *)`); it has no
       js-comments / data-post / cr-lazy for any delegate to find; a video avatar becomes its poster. It dies
       with the panel (crDrop) or the moment a close is run back open (crReopen). */
    function crPillFace(panel, post, g) {
      var pill = crPill(post) || (function () { var p = post.querySelector('.croller'); return p && p.closest('.post') === post ? p : null; })();
      if (!pill || !g.q.h) { return null; }
      var face = pill.cloneNode(true);
      face.classList.remove('js-comments', 'cr-lazy', 'active', 'cr-wait');
      face.classList.add('cr-pclone');
      face.removeAttribute('data-post'); face.removeAttribute('href'); face.removeAttribute('id');
      face.removeAttribute('aria-label'); face.setAttribute('tabindex', '-1');
      Array.prototype.forEach.call(face.querySelectorAll('.cr-gif img'), function (im) { im.loading = 'eager'; });   // roller GIF chip
      Array.prototype.forEach.call(face.querySelectorAll('[id]'), function (n) { n.removeAttribute('id'); });
      Array.prototype.forEach.call(face.querySelectorAll('video'), function (v) {
        var im = document.createElement('img');
        im.className = v.className; im.alt = '';
        if (v.getAttribute('poster')) { im.src = v.getAttribute('poster'); }
        if (v.getAttribute('style')) { im.setAttribute('style', v.getAttribute('style')); }
        v.parentNode.replaceChild(im, v);
      });
      var wrap = document.createElement('div');
      wrap.className = 'cr-pillclone';
      wrap.setAttribute('aria-hidden', 'true');
      wrap.setAttribute('inert', '');
      wrap.style.left = crPx(g.q.x - panel.clientLeft); wrap.style.top = crPx(g.q.y - panel.clientTop);
      wrap.style.width = crPx(g.q.w); wrap.style.height = crPx(g.q.h);
      wrap.style.opacity = '0';                 // until its keyframes take over (same task)
      // The pill's skin is TRANSLUCENT (gold wash + --panel-2) and the real one sits on the card; laid on the
      // sheet -- which already wears that same skin, opaque -- it came out a wash too light (measured: mean
      // |diff| 15/255 vs the settled pill). So on a card the face gets the card's own floor under it: the
      // card's wash over the page base. The docked sheet's pill is glass over the media, which no floor can
      // copy; there it rides on the sheet and the 140ms hand-off carries the rest.
      if (!g.docked) {
        var cbg = getComputedStyle(post).backgroundColor;
        wrap.style.borderRadius = crPx(g.rq);
        wrap.style.background = (cbg && cbg !== 'rgba(0, 0, 0, 0)' && cbg !== 'transparent' ? 'linear-gradient(' + cbg + ',' + cbg + '), ' : '') + 'var(--app-bg-base)';
      }
      wrap.appendChild(face);
      panel.appendChild(wrap);
      panel._face = wrap;                       // ONE face per sheet: the open's, the close's, a reversal's
      return wrap;
    }
    // the face's CURRENT offset from the pill's rect (a close's centring keyframes, or one held inline)
    function crFaceAt(face) {
      var m = /matrix\(([^)]+)\)/.exec(face ? getComputedStyle(face).transform || '' : '');
      if (!m) { return [0, 0]; }
      var v = m[1].split(',').map(parseFloat);
      return [v[4] || 0, v[5] || 0];
    }
    function crDropFace(panel) {
      var f = panel._face;
      clearTimeout(panel._faceBackstop);
      if (panel._faceFade) { try { panel._faceFade.cancel(); } catch (e) {} panel._faceFade = null; }
      if (f) { try { f.getAnimations().forEach(function (a) { a.cancel(); }); } catch (e) {} if (f.parentNode) { f.parentNode.removeChild(f); } }
      panel._face = null;
      if (panel._geo) { panel._geo.clone = null; }
    }
    function crDrop(panel) {
      var dl = panel.querySelector('.cpanel-list');
      if (dl && dl._ro) { dl._ro.disconnect(); dl._ro = null; }   // v5
      crBackdrop(panel, false);
      crStop(panel);
      crDropFace(panel);
      if (panel._hand) { clearTimeout(panel._hand.backstop); try { panel._hand.anim.cancel(); } catch (e) {} panel._hand = null; }
      (panel._fades || []).forEach(function (a) { try { a.cancel(); } catch (e) {} });
      panel._fades = null;
      var placed = !!panel._place;
      if (panel.parentNode) { panel.parentNode.removeChild(panel); }
      if (placed) { crFootRoom(); }                             // the footer gives back the room it made for the sheet
    }

    function closePanel(panel, how) {
      if (!panel || panel._closed) return;
      panel._closed = true;
      how = how || '';
      engHold('comments', false);   // engage-hold: panel/roller closed = the engagement ended
      if (panel._idle) { clearTimeout(panel._idle); panel._idle = null; }
      if (panel._poll) { clearInterval(panel._poll); panel._poll = null; }
      clearTimeout(panel._waitT); panel._pending = null;   // v5: a cold open still waiting / a page for the landing
      var post = panel._post;
      var shown = panel.classList.contains('open') || !!panel._morph;
      var o = crNow(panel);                                   // before anything moves
      var vh = window.innerHeight || 800;
      // a caret inside a sheet that is going away would keep the keyboard up over a pointer-events:none ghost
      if (panel.contains(document.activeElement)) { try { document.activeElement.blur(); } catch (e) {} }
      panel.classList.remove('open');
      crBackdrop(panel, false);                               // the feed is live again under a folding sheet
      if (panel._btn) panel._btn.classList.remove('active', 'cr-wait');
      if (openPanel === panel) openPanel = null;
      // the card's player was held live while the sheet was open (embedHeldBySheet): park it now if
      // it is off screen, exactly as if the sheet had never been opened
      if (post && window.__rovaEmbedRecheck) { try { window.__rovaEmbedRecheck(post); } catch (e) {} }

      // never unfurled (closed before its comments arrived) or already detached: nothing to show
      if (!shown || !post || !panel.isConnected) { crDrop(panel); return; }

      // THE VIEWER IS TEARING ITSELF DOWN around the sheet (close / re-deck): its own transition carries
      // the sheet away; only fade with it, never morph against a flight
      if (how === 'quiet') {
        crStop(panel);
        panel.classList.add('cr-closing', 'cr-quiet');
        var qa = panel.animate ? panel.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 180, easing: 'ease-out', fill: 'forwards' }) : null;
        var qDone = function () { crDrop(panel); };
        if (qa) { qa.onfinish = qDone; }
        setTimeout(qDone, qa ? 430 : 0);
        return;
      }

      // v6 A SCROLL FROM OUTSIDE (crOutsideScroll): the page is already moving under the finger / wheel. Whatever is
      // running (an open's clip + crossfade, a height re-target) FREEZES where it stands and the whole sheet folds
      // (fade + scale CR_SWIPE_SCALE, CR_SWIPE_MS = iOS 549) onto the pill, back in its slot under it from this
      // frame (-.open; the ghost state keeps the host card lifted, cr-quiet takes no hits). Reduced motion / off
      // screen: the instant path below.
      if (how === 'swipe' && !panel._docked && !crReduced() && panel.animate) {
        var sr = panel.getBoundingClientRect();
        if (sr.bottom > 0 && sr.top < vh) {
          crRtStop(panel);
          var fz = (panel._morph ? panel._morph.anims : []).concat(panel._fades || [], panel._faceFade ? [panel._faceFade] : []);
          if (panel._morph) { clearTimeout(panel._morph.backstop); panel._morph.fired = true; }
          clearTimeout(panel._faceBackstop);
          fz.forEach(function (a) { try { a.pause(); } catch (e) {} });
          syncRoller(post, panel);                              // the line the pill comes back with
          panel.classList.add('cr-ghost', 'cr-quiet');
          panel.style.transformOrigin = '50% 50%';                // (cr-morphing's 0 0 is for the morph)
          var sa = panel.animate([{ opacity: 1, transform: 'scale(1)' }, { opacity: 0, transform: 'scale(' + CR_SWIPE_SCALE + ')' }],
                                 { duration: CR_SWIPE_MS, easing: 'ease-out', fill: 'forwards' });
          panel._swipe = sa;
          var sDone = function () { if (panel._swipe === sa) { panel._swipe = null; crDrop(panel); } };
          sa.onfinish = sDone;
          setTimeout(sDone, CR_SWIPE_MS + 250);
          return;
        }
      }

      crStop(panel);                                          // a running open: reverse it from where it is
      var R = crRect(panel);                                  // the sheet itself (the overlay: the card never changed)
      var reduced = crReduced() || !panel.animate;
      // SCROLLED AWAY / OFF SCREEN / REDUCED MOTION: instant. Reflect new comments in the roller FIRST
      // (it is hidden while the sheet is up, so this moves nothing), then drop the sheet. Nothing to give back.
      if (reduced || how === 'away' || !(R.y + R.h > 0 && R.y < vh)) {
        syncRoller(post, panel);
        crDrop(panel);
        return;
      }

      // ANIMATED: shrink into the pill
      panel.classList.add('cr-closing');
      syncRoller(post, panel);                                // BEFORE measuring: a first comment makes the pill
      var g = crMeasure(panel, post);
      crLock(panel, g);
      var halo = crLayer(panel, 'cr-halo');
      var h0 = halo ? (parseFloat(getComputedStyle(halo).opacity) || 0) : 0;
      if (halo) { try { halo.getAnimations().forEach(function (a) { a.cancel(); }); } catch (e) {} }
      panel.classList.remove('cr-lit');
      g.lit = h0 > 0.01;
      // fade to the comment it lands on (app 519). v4: a close INSIDE an open's (or a reversal's) crossfade KEEPS
      // that face -- it already stands at 1 - content, exactly where this crossfade starts -- and brings it home to
      // the pill from wherever it is; otherwise a fresh face at 0
      if (panel._face && panel._face.isConnected && panel._faceFade) {
        var fAt = crFaceAt(panel._face);
        clearTimeout(panel._faceBackstop);
        try { panel._faceFade.cancel(); } catch (e) {}
        panel._faceFade = null;
        g.clone = panel._face; g.anchored = true; g.faceAt = fAt;
      } else {
        crDropFace(panel);
        g.clone = crPillFace(panel, post, g);
      }
      var fadeMs = Math.max(60, Math.round(CR_FADE_MS * Math.min(1, o)));
      crFade(panel, 0, fadeMs, 0);
      crRun(panel, Math.min(o, 1.2), 0, Math.max(140, Math.round(CR_CLOSE_MS * Math.min(1, o))), CR_EASE_CLOSE, function () {
        // HANDOFF, one task: the sheet (which never moved) is pinned at the pill's rect by an inline clip, the
        // face at its last keyframe, the real pill comes back under both (-.cr-closing), and only then are the
        // morph's held frames released; the empty ghost then fades 140ms onto the pill
        panel.style.clipPath = crFrame(g, 0, 0);
        if (g.clone) { g.clone.style.opacity = '1'; g.clone.style.transform = 'none'; }   // = its last keyframe
        panel.classList.remove('cr-closing', 'cr-grow');
        panel.classList.add('cr-ghost');
        crStop(panel);
        var ha = panel.animate([{ opacity: 1 }, { opacity: 0 }], { duration: CR_HAND_MS, easing: 'ease-out', fill: 'forwards' });
        var h = panel._hand = { anim: ha, backstop: 0 };
        var hDone = function () { if (panel._hand === h) { crDrop(panel); } };
        ha.onfinish = hDone;
        h.backstop = setTimeout(hDone, CR_HAND_MS + 250);
      });
      // the halo fades out at the START of the close, while the clip still reaches over it (crRun's `halo`)
      if (halo && g.lit && panel._morph) {
        panel._morph.anims.push(halo.animate([{ opacity: h0 }, { opacity: 0 }], { duration: CR_HALO_MS, easing: 'ease-out', fill: 'forwards' }));
      }
      // THE CROSSFADE (app build 520): the face comes up on the content fade's exact clock -- same duration,
      // same easing, same start, from where the content isn't -- so content + face = 1 in every frame (never
      // a blank box between them), then holds at 1 to the end. One of the morph's animations: crStop cancels
      // it in the handoff task, which has already pinned the face at opacity 1.
      if (g.clone && g.clone.isConnected && panel._morph) {
        var f0 = panel._fadeFrom != null ? Math.max(0, Math.min(1, panel._fadeFrom)) : 1;
        panel._morph.anims.push(g.clone.animate([{ opacity: 1 - f0 }, { opacity: 1 }],
          { duration: fadeMs, easing: CR_FADE_OUT_EASE, fill: 'forwards' }));
      }
    }

    /* A tap on a closing sheet or on the comments button while it closes: run it back open from the openness it
       has reached, same panel, same place, no refetch. v4: the face it was fading INTO is not dropped (that was a
       one-frame hole: content c, face gone); it is held where it stands and crossfades back out (crXfadeIn). */
    function crReopen(panel) {
      var ghost = panel.classList.contains('cr-ghost');
      var o = ghost ? 0 : crNow(panel);
      var face = panel._face && panel._face.isConnected ? panel._face : null;
      var fAt = face ? crFaceAt(face) : null;                 // before crStop lets go of its centring keyframes
      if (panel._hand) { clearTimeout(panel._hand.backstop); try { panel._hand.anim.cancel(); } catch (e) {} panel._hand = null; }
      crStop(panel);
      if (face) {
        face.style.transform = (fAt[0] || fAt[1]) ? 'translate(' + crPx(fAt[0]) + ',' + crPx(fAt[1]) + ')' : 'none';
        if (panel._geo) { panel._geo.clone = face; panel._geo.anchored = true; }
      }
      panel._closed = false;
      panel.classList.remove('cr-ghost', 'cr-closing', 'cr-quiet');
      panel.style.clipPath = '';
      panel.classList.add('open');
      crBackdrop(panel, true);
      if (panel._btn) panel._btn.classList.add('active');
      openPanel = panel;
      if (panel._resume) { panel._resume(); }
      if (crReduced() || !panel.animate || !panel._geo) { crDropFace(panel); crFade(panel, 1, 0, 0); crLand(panel); return panel; }
      var g = panel._geo;
      g.lit = false; g.glass = false;                         // the skin is already opaque; no halo in a reversal
      crLock(panel, g);
      var ms = Math.max(160, Math.round((panel._docked ? CR_OPEN_DOCK_MS : CR_OPEN_MS) * (1 - Math.min(o, 1))));
      crXfadeIn(panel, CR_XFADE_MS);                          // face (1 - c) -> 0 while the content c -> 1
      panel.classList.add('cr-grow');
      crRun(panel, o, 1, ms, panel._docked ? CR_EASE_DOCK : CR_EASE_OPEN, function () { crLand(panel); });
      return panel;
    }
    // Escape folds the card's sheet (the viewer's Escape closes the whole viewer, which folds it too)
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !openPanel || !openPanel.classList.contains('open') || openPanel._docked) return;
      if (document.querySelector(PANEL_POPOVERS_OPEN)) return;   // the picker takes this Escape
      closePanel(openPanel);
    });

    /* Let the immersive viewer tear the sheet down properly when IT is dismissed.
     *
     * The pfeed's close() ends in clearPfeedList() -> list.innerHTML = '', which DETACHES an
     * expanded sheet without closePanel() ever running. `openPanel` was then left pointing at a
     * detached node that still carries `.open`, so the outside-tap rule below stayed armed for
     * the rest of the page's life and silently ate the FIRST tap anywhere afterwards (proved in
     * WebKit: 0 clicks reached the document after an Escape or a browser-Back dismissal). The
     * 30s idle timer and the 8s comment poll were leaked with it, and engHold('comments') was
     * never released, so the feed's auto-loads stayed suspended.
     * Returns whether a sheet was actually open, so a caller can tell the two cases apart. */
    window.__rovaCloseCommentPanel = function () {
      if (!openPanel) { return false; }
      var was = openPanel.classList.contains('open');
      closePanel(openPanel, 'quiet');   // the viewer's own dismissal carries it: fade with it, no morph
      return was;
    };

    // Tap OUTSIDE the expanded comments -> dismiss it (owner). Capture-phase, and the tap is SWALLOWED
    // (pointerdown + the trailing click): it only closes the sheet, never also pauses the video or trips
    // whatever sat under the finger. Taps on the roller/toggle keep their own open/close handling.
    // The sheet's OWN popovers (the GIF picker, the emoji picker) are rendered into document.body --
    // position:fixed, so they can escape the card's overflow -- which means a tap on one is
    // not a DESCENDANT of the sheet even though it belongs to it. Without this they read as "outside": the
    // tap was swallowed AND the sheet collapsed, so picking a GIF from the picker the sheet had just opened
    // closed the sheet and never inserted the GIF (owner: "tapping a GIF image is collapsing the expanded
    // comment scroller"). They only exist while shown, so exempting them costs the outside-tap rule nothing.
    // `.react-pop` was a third member until 2026-08-08. Dropping it changes NOTHING either way: the
    // carousel replaced that popover and nothing builds the element any more, so the clause could
    // never match. The carousel itself needs no exemption here -- .rxc is armed from the heart, which
    // is a CONTROL by the structural test below, and it commits on release without a document tap.
    var PANEL_POPOVERS = '.gif-pop, .emoji-pop';
    // The same two while they are actually UP. They are built once and toggle .show (that class IS their
    // visibility), so "exists" is not "open" -- see the idle clock in openFor, which asks this. Same idiom
    // the feed chrome already uses to stay put while a composer picker is open ('.emoji-pop.show, .gif-pop.show').
    var PANEL_POPOVERS_OPEN = '.gif-pop.show, .emoji-pop.show';
    /* WHERE THE OUTSIDE-TAP RULE STOPS: a CONTROL is not backdrop.
     *
     * Owner 2026-08-05, second report: "An expanded comment scroller is intercepting clicks, I
     * wanted to repost this so I clicked it but had to click it twice because the comment scroller
     * collapsed after my first click." The swallow below was written for the BACKDROP -- so a tap
     * that dismisses the sheet doesn't also pause the video underneath -- but it was applied to
     * every outside target, so it ate the first press on repost, like, share, mute, the per-post
     * menu and the bar's own controls too. The back chevron was fixed by name first; naming the
     * rest one at a time would be the same mistake repeated.
     *
     * So the test is STRUCTURAL, not a list of app classes: natively interactive or explicitly
     * focusable == a control (collapse AND let it act); anything else == backdrop (collapse only,
     * swallowed as before). Same shape as the player's CONTROLS constant, which already draws this
     * exact line for gesture ownership.
     *
     * Verified against the live DOM rather than assumed: every control the owner named is a real
     * <button> or <a href> (like .react-btn, repost's submit, .js-share, .js-hide, .pmenu-trigger,
     * .pfeed-menu, .pfeed-x, .pfeed-who, the .vc-* player buttons and seek inputs) -- there are no
     * div-with-a-handler controls in the row. And the MEDIA surface is inert: `div.media.pf-zoomable`
     * and its <img> carry no tabindex, no role and no wrapping anchor, and elementFromPoint at the
     * photo centre is a bare <img>. So the photo stays backdrop by construction, which is what keeps
     * tap-to-collapse and double-tap-to-like on the media working exactly as before. */
    var OUTSIDE_CONTROL = 'a[href], button, input, select, textarea, label, summary, ' +
        '[role="button"], [role="link"], [role="menuitem"], [role="tab"], [role="switch"], ' +
        '[contenteditable=""], [contenteditable="true"], [tabindex]:not([tabindex="-1"])';
    document.addEventListener('pointerdown', function (e) {
      if (!openPanel || !openPanel.classList.contains('open')) return;
      var t = e.target;
      if (t && t.closest && (t.closest('.croller-panel') || t.closest('.js-comments') || t.closest('.croller')
          || t.closest(PANEL_POPOVERS))) return;
      /* A CONTROL: collapse the sheet AND let the press do its job, in the one press. Nothing is
         preventDefault'd or stopped, and no trailing click is killed, so the control's own handler
         runs normally -- repost reposts, the heart likes, share opens the sheet, the ⋯ opens the
         menu, and the back chevron dismisses the whole viewer (which is the earlier fix, now falling
         out of the general rule instead of being special-cased by name).
         THE COLLAPSE IS DEFERRED UNTIL AFTER THE CLICK. Collapsing here, synchronously, would resize
         the sheet between pointerdown and pointerup; where the panel is in normal flow (the timeline
         card, which collapses UPWARD) that can slide the control out from under the finger, and a
         click whose down and up land on different elements is delivered to neither. In the pfeed the
         sheet is position:absolute and measured NOT to move the row (the repost button held at
         top=858 through the whole collapse), but the timeline shares this code, so the ordering is
         made safe for both rather than relying on the surface that happens to be safe.
         The capture listener fires before the control's own handlers, so the actual collapse is
         pushed to a task after the whole dispatch -- that also survives handlers that stopPropagation
         (.pfeed-menu does). The timer is the fallback for a press that never becomes a click at all
         (a drag off the control, a long-press): the sheet must still collapse. */
      if (t && t.closest && t.closest(OUTSIDE_CONTROL)) {
        var ctlPanel = openPanel, ctlTimer = 0;
        var ctlCollapse = function () {
          document.removeEventListener('click', ctlAfterClick, true);
          clearTimeout(ctlTimer);
          if (ctlPanel && ctlPanel.classList.contains('open')) { closePanel(ctlPanel); }
          ctlPanel = null;
        };
        var ctlAfterClick = function () { setTimeout(ctlCollapse, 0); };
        document.addEventListener('click', ctlAfterClick, true);
        ctlTimer = setTimeout(ctlCollapse, 700);
        return;
      }
      /* v4 CARD SHEET: the native clear backdrop closes on a TAP, not on a touch. The press is still swallowed; the
         close waits for the click that a tap (and only a tap) produces, and eats it. v6: a DRAG that starts outside
         scrolls the page and folds the sheet on its first move (crOutsideScroll), which drops this wait. */
      if (!openPanel._docked) {
        e.preventDefault(); e.stopPropagation();
        if (crTapOff) { crTapOff(); }
        var tapPanel = openPanel, tapT = 0;
        var tapOff = function () { document.removeEventListener('click', onTap, true); clearTimeout(tapT); if (crTapOff === tapOff) { crTapOff = null; } };
        var onTap = function (ce) {
          ce.stopPropagation(); ce.preventDefault();
          tapOff();
          if (tapPanel.classList.contains('open')) { closePanel(tapPanel); }
        };
        document.addEventListener('click', onTap, true);
        tapT = setTimeout(tapOff, 800);
        crTapOff = tapOff;
        return;
      }
      e.preventDefault(); e.stopPropagation();
      closePanel(openPanel);
      var kill = function (ce) { ce.stopPropagation(); ce.preventDefault(); document.removeEventListener('click', kill, true); };
      document.addEventListener('click', kill, true);                    // eat the click this tap generates
      setTimeout(function () { document.removeEventListener('click', kill, true); }, 500);
    }, true);

    function commentNode(c, bodyHtml, opts) {
      opts = opts || {};
      var node = document.createElement('div');
      node.className = 'comment' + (opts.isReply ? ' is-reply' : '');
      if (c.id) node.setAttribute('data-comment', c.id);
      node.innerHTML =
        '<a href="/@' + encodeURIComponent(c.username) + '">' + jsAvatar(c) + '</a>' +
        '<div class="cbody"><div class="chead">' +
          '<a class="name" href="/@' + encodeURIComponent(c.username) + '">' + escHtml(c.display_name) + '</a>' +
          '<span class="meta">@' + escHtml(c.username) + ' · ' + escHtml(c.ago) + (c.edited ? ' · <span class="cmt-edited">Edited</span>' : '') + '</span>' +
        '</div><div class="ctext">' + bodyHtml + '</div>' +
        (c.id && opts.canReact !== false ? commentActsHtml(c, !!opts.isReply, opts.canReply !== false) : '') +
        '</div>';
      return node;
    }
    function appendThread(list, c, opts) {
      list.appendChild(commentNode(c, c.body, opts));
      if (c.replies && c.replies.length) {
        var wrap = document.createElement('div');
        wrap.className = 'comment-replies';
        wrap.setAttribute('data-parent', c.id);
        c.replies.forEach(function (r) {
          wrap.appendChild(commentNode(r, r.body, { isReply: true, canReact: opts.canReact, canReply: opts.canReply }));
        });
        list.appendChild(wrap);
      }
    }

    // a compact comment row in the roller's own style (avatar + name + one-line text),
    // so the expanded panel reads as the roller growing rather than a different list
    function crollerRow(c) {
      var row = document.createElement('div');
      // a reply is indented under the comment it answered (like the main post page), so the thread
      // reads the same in the expanded roller
      row.className = 'croller-item cx-row' + ((c._reply || c.parent_id) ? ' cx-reply-row' : '');
      if (c.id) row.setAttribute('data-comment', c.id);
      var tick = c.verified ? vsealTick() : '';
      // a small heart per row (the shared .clike handler wires the tap/picker); the count
      // badge appears from the FIRST like, same rule as every other comment row
      var f = cFan(c.fan, c.my_reaction), lc = c.like_count || 0;
      var like = c.id ? '<button class="clike cx-like' + (c.my_reaction ? ' on' : '') + '" type="button"'
        + ' data-comment="' + c.id + '" data-reaction="' + escHtml(c.my_reaction || '') + '" aria-label="Like this comment">'
        + '<span class="react-ic' + (f.n > 1 ? ' fan' : '') + '">' + f.html + '</span>'
        + '<span class="cnt"' + (lc > 0 ? '' : ' hidden') + '>' + fmtCount(lc) + '</span></button>' : '';
      var time = c.ago ? '<span class="cr-time">' + escHtml(c.ago) + (c.edited ? ' · <span class="cmt-edited">Edited</span>' : '') + '</span>' : '';
      // Sherry (2026-07-25): a reply that shows only its own author reads like a
      // stray comment — say who it answers, right on the name line
      var replyTo = ((c._reply || c.parent_id) && c.parent_name)
        ? '<span class="cmt-replyto">↩ ' + escHtml(c.parent_name) + '</span>' : '';
      // reply reuses the panel's own composer (the shared .creply handler sets parent + focuses it)
      var reply = c.id ? '<button class="creply cx-reply" type="button" data-comment="' + c.id
        + '" data-name="' + escHtml(c.display_name || c.username) + '" aria-label="Reply">Reply</button>' : '';
      // edit: author or admin (same rule as the classic comment list); shared .js-cedit handler
      var edit = (c.id && (c.mine || isAdmin)) ? '<button class="cmod cx-edit js-cedit" type="button" data-comment="' + c.id + '" aria-label="Edit comment">Edit</button>' : '';
      // delete: author (c.mine, incl. a just-posted optimistic row), admin, or the post OWNER
      // (server sends c.del); shared .js-cdel handler
      var del = (c.id && (c.del || c.mine || isAdmin)) ? '<button class="cmod cx-del js-cdel" type="button" data-comment="' + c.id + '" aria-label="Delete comment">Delete</button>' : '';
      // report: signed-in, never your own; shared .js-report handler (the sheet, then POST /report)
      var rep = (c.id && !c.mine && !isGuest()) ? '<button class="cmod cx-rep js-report" type="button" data-type="comment" data-id="' + c.id + '" aria-label="Report comment">Report</button>' : '';
      var uhref = '/@' + encodeURIComponent(c.username);
      // GIF: the comments LIST endpoint sends `body` with the <img> already rendered server-side
      // (comment_gif_img), but the POST /comment echo sends the raw URL inside `body` plus the URL
      // again as `gif` -- index.php literally labels it "for a client that renders it separately".
      // This row never did, so a GIF you had just posted showed in the pfeed sheet as a bare URL
      // until the next load. Render it, and ONLY when the server hasn't already (the <img> test), or
      // the list path would show it twice.
      // 0133: POST /comment echoes gif_w/gif_h beside `gif`, so the row this builds by hand
      // reserves the same box the server-rendered one does.
      var bodyHtml = c.body || '';
      if (c.gif && bodyHtml.indexOf('<img') < 0) {
        bodyHtml = bodyHtml.split(c.gif).join('').trim();
        bodyHtml += (bodyHtml ? ' ' : '') + gifImgHtml(c.gif, c.gif_w, c.gif_h);
      }
      // chat-style layout: avatar (with the verified badge overlaid on it) | (name line /
      // comment on its OWN line / reply + delete), heart at right.
      row.innerHTML = '<a class="cx-av" href="' + uhref + '">' + jsAvatar(c) + tick + '</a>'
        + '<div class="cx-body">'
        // data-short (2026-10-16): the server's short_name (NameText::short) -- what the collapsed roller prints
        +   '<div class="cx-line"><a class="cr-name" href="' + uhref + '"' + (c.short_name ? ' data-short="' + escHtml(c.short_name) + '"' : '') + '>' + escHtml(c.display_name || c.username) + '</a>' + replyTo + time + '</div>'
        +   '<div class="cr-text">' + bodyHtml + '</div>'
        +   ((reply || edit || del || rep) ? '<div class="cx-actions">' + reply + edit + del + rep + '</div>' : '')
        + '</div>' + like;
      return row;
    }
    // flatten threaded comments (top-level + replies) into one chronological list; mark replies so
    // the roller can indent them under their parent
    function flattenComments(comments, out, isReply) {
      out = out || [];
      (comments || []).forEach(function (c) {
        if (isReply) { c._reply = true; }
        out.push(c);
        if (c.replies && c.replies.length) flattenComments(c.replies, out, true);
      });
      return out;
    }

    function openFor(post, postId, btn) {
      var panel = document.createElement('div');
      panel.className = 'comment-panel croller-panel';
      panel._post = post; panel._btn = btn;
      // pfeed = a bottom sheet you swipe DOWN to close (chevron points down).
      /* THE TIMELINE CHEVRON POINTS DOWN TOO (2026-09-25, iOS parity). The inline panel used to show an
         UP chevron ("it collapses upward"); the app's in-place sheet -- the same shape as this one: it
         pops out of the card's comment pill, at card width, no backdrop -- shows DOWN, and tapping it or
         pulling it down shrinks it back into the pill. The web already did both (click + the handle's
         46px pull-down below), so only the glyph differed. One glyph on every surface now. */
      var inPfeed = !!(post.closest && post.closest('.pfeed'));
      panel._docked = inPfeed;   // the viewer's sheet overlays the post (the morph's "docked" case)
      var chevD = 'm6 9 6 6 6-6';
      // .cr-bg = the sheet's skin (background + border, z -1: it can reach past the box while an open overshoots);
      // .cr-halo = its soft shadow, lit after the open lands (THE ROLLER <-> PANEL MORPH)
      panel.innerHTML =
        '<i class="cr-bg" aria-hidden="true"></i><i class="cr-halo" aria-hidden="true"></i>' +
        '<button class="cpanel-handle" type="button" aria-label="Close comments"><svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + chevD + '"/></svg></button>' +
        '<div class="cpanel-list"><div class="cpanel-note">Loading comments…</div></div>' +
        '<form class="cpanel-form"><input type="hidden" name="parent_id" value="" class="js-parent">' +
        '<div class="reply-chip" hidden><span class="reply-chip-txt"></span>' +
        '<button type="button" class="reply-chip-x" aria-label="Cancel reply">&times;</button></div>' +
        '<input class="input cpanel-input" type="text" name="body" maxlength="1000" ' +
        'placeholder="Add a comment…" autocomplete="off">' +
        // GIF picker: the shared .js-gif delegate opens the popover and appends the chosen
        // URL to input[name="body"]; the server lifts it into comments.gif_url (mig 0098).
        // NO hidden gif_url field here on purpose -- selectGif() branches on that field and
        // would take the POST-composer path, hunting a #gif-preview that doesn't exist.
        '<button type="button" class="ctool js-gif" title="Add a GIF" aria-label="Add a GIF">' +
        '<svg viewBox="0 0 24 24" fill="none"><rect x="1.5" y="6" width="21" height="12" rx="3.4" stroke="currentColor" stroke-width="1.5"/>' +
        '<text x="12" y="15.3" text-anchor="middle" font-size="9.6" font-weight="800" letter-spacing="-.4" fill="currentColor" font-family="-apple-system,BlinkMacSystemFont,Arial,sans-serif">GIF</text></svg></button>' +
        '<button class="cpanel-send" type="submit" aria-label="Post comment">' +
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M19.442 2.62c1.1-.5 2.3.7 1.8 1.8l-7.2 16.3c-.5 1.1-2.1 1-2.5-.1l-1.8-5.3a1.6 1.6 0 0 0-.9-.9L3.542 11.92c-1.2-.4-1.2-2 0-2.5z"/><path fill="#000" opacity=".18" d="M20.642 3.22 9.342 13.52c.3.2.5.5.6.8l1.8 5.3c.2.6 1 .7 1.3.1z"/></svg></button></form>';
      post.appendChild(panel);
      btn.classList.add('active');
      // grab handle at the top: press OR swipe down to dismiss (without leaving a comment)
      var handle = panel.querySelector('.cpanel-handle');
      if (handle) {
        // v4: a tap closes; a pull-down SCRUBS the close (crScrub) -- the click after a scrub is not a tap
        handle.addEventListener('click', function () { if (handle._scrubbed) { handle._scrubbed = false; return; } closePanel(panel); });
        crScrub(panel, handle);
      }
      // v3 (overlay): a tap on the part of a closing sheet still on screen (its clip-path is its hit area; nothing
      // inside it takes taps while it folds) runs it back open from where it is -- it used to fall through to the
      // card, but under an overlay sheet lies the NEXT card, which must never get a tap aimed at the sheet
      // Judged at the PRESS: the click that closed it (the chevron) must not also reopen it on its way up.
      function crFolding() { return (panel.classList.contains('cr-closing') || panel.classList.contains('cr-ghost')) && !panel.classList.contains('cr-quiet'); }
      panel.addEventListener('pointerdown', function () { panel._downFolding = crFolding(); }, true);
      panel.addEventListener('click', function (e) {
        var was = panel._downFolding; panel._downFolding = false;
        if (!was || !crFolding()) { return; }
        e.preventDefault(); e.stopPropagation();
        if (openPanel && openPanel !== panel) { closePanel(openPanel); }
        openPanel = crReopen(panel);
        engHold('comments', true, ENG_LONG, openPanel);
      });
      // PFEED: the panel must OWN its vertical gestures (owner: "I'm trying to scroll the comment box, not
      // swipe to another picture"). The list's scroll CHAINS into the pfeed's snap scroller at its ends --
      // and when the comments fit without overflow, EVERY swipe passed straight through and advanced the
      // post. Swallow any vertical gesture the list can't consume; let the list itself scroll natively.
      // Same discipline, one implementation: see guardPanelScroll() up by the scroll lock. It is
      // this guard, generalised (scrollable-region lookup + the iOS touchstart latch nudge) and now
      // shared with the header flyouts, which had the identical leak.
      // THE TIMELINE PANEL IS GUARDED TOO since 2026-08-18 (owner: swiping down inside the
      // expanded comments at the top of the feed armed pull-to-refresh and "loses the post") --
      // but TOUCH ONLY: `wheel:false` preserves the deliberate desktop choice documented in
      // rova.css ("hitting the list's end hands the scroll back to the timeline"). The guard's
      // stopPropagation plus the PTR's own origin check is what keeps a comment swipe from ever
      // becoming a feed refresh.
      // v4 (2026-09-29): the card sheet owns the WHEEL too now -- a wheel INSIDE the thread never hands its end
      // back to the timeline (v6: a wheel OUTSIDE the sheet scrolls the page and folds it, crOutsideScroll)
      guardPanelScroll(panel, '.cpanel-list');
      // sleek expand: animate max-height to the panel's ACTUAL content height (not a
      // fixed cap), so the easing curve maps to the real distance and it grows like the
      // roller unfurling. Re-measure whenever the content changes.
      // (2026-09-29) never re-measured mid-morph: the morph's keyframes were computed against the box it
      // had when it started, so a height change lands the moment the morph finishes instead
      // v3 (overlay): the CARD sheet is absolute with a natural height up to the cap crPlace() gave it, so it
      // follows its content by itself and moves nothing; the docked sheet just lifts the class cap
      function sizePanel(r0, a) {
        if (!panel.classList.contains('open')) { return; }
        if (panel._morph) { panel._sizeLate = true; return; }
        // v4 layoutSheet (a grown thread may re-anchor upward); v5: re-targets on a spring, anchor kept; v5b: the viewer's
        // docked sheet too (its thread caps itself at 46vh; height only, bottom pinned)
        crPlaceSpring(panel, r0, a);
      }
      // open ONCE, after the comments are in, so it unfurls straight to the full height in a
      // single smooth motion (no empty->loading->content stutter). The roller stays put
      // until then (CSS keys the hide on .open), so there's no gap.
      /* 2026-09-29: the unfurl is THE ROLLER <-> PANEL MORPH (see above closePanel). The layout goes to its
         final height in this one task -- sized synchronously, not a frame later -- and the pill grows into it
         from its own rect. The old max-height transition was a per-frame layout of the list and every card
         below it, and each avatar/GIF `load` (the listener below) re-set max-height mid-flight, restarting
         the transition from wherever it was: a hitch per image, on every roller opened. */
      /* v3 (2026-09-29): THE NATIVE OPEN, an overlay -- see THE ROLLER <-> PANEL MORPH. The sheet is placed
         (card: crPlace) and laid out at its final size in this one task, its content never moves again, and a
         clip grows it out of the pill on one spring. Nothing else on the page changes size or place. */
      function openPanelNow() {
        if (panel._closed || !panel.isConnected) { return; }
        if (panel.classList.contains('open')) { sizePanel(); return; }
        var anim = !crReduced() && !!panel.animate && crOnScreen(post);
        var pl = crPill(post), Q = pl ? crPillRect(pl) : null;   // it keeps its slot under the sheet
        panel.classList.add('open');
        if (!inPfeed) { crPlace(panel, post, Q); crBackdrop(panel, true); } else { panel.style.height = ''; panel.style.maxHeight = 'none'; }   // the docked sheet pins its max-height first
        crAnchorOpen(panel);                                // v5: the thread at its END (CR_ANCHOR) before the morph starts
        if (!anim) { crLand(panel); return; }
        var g = crMeasure(panel, post);
        crLock(panel, g);
        // the viewer with no pill on screen (pf-crlite hides it, or it sits off the bottom): up from below
        if (inPfeed && !(Q && Q.y + Q.h > 0 && Q.y < (window.innerHeight || 800))) {
          panel.classList.add('cr-morphing');
          var sa = panel.animate([{ transform: 'translateY(' + crPx(Math.max(CR_SLIDE_PX, g.H)) + ')' }, { transform: 'none' }],
                                 { duration: CR_SLIDE_MS, easing: 'cubic-bezier(.33,1,.68,1)', fill: 'forwards' });
          var sm = panel._morph = { anims: [sa], from: 0, to: 1, ms: CR_SLIDE_MS, ease: CR_EASE_SLIDE, fired: false, backstop: 0, slide: true };
          var sDone = function () { if (sm.fired || panel._morph !== sm) { return; } sm.fired = true; crLand(panel); };
          sa.onfinish = sDone;
          sm.backstop = setTimeout(sDone, CR_SLIDE_MS + 250);
          return;
        }
        var ms = inPfeed ? CR_OPEN_DOCK_MS : CR_OPEN_MS, ease = inPfeed ? CR_EASE_DOCK : CR_EASE_OPEN;
        g.glass = inPfeed;                                  // the viewer's sheet starts in the pill's glass
        panel.classList.add('cr-grow');
        // v4: frame 0 IS the pill -- its face, anchored on the pill's own rect -- crossfading into the thread
        // (face 1 -> 0, content 0 -> 1, one 200ms curve): never an empty box
        crDropFace(panel);
        if (crPillFace(panel, post, g)) { g.clone = panel._face; g.anchored = true; }
        crXfadeIn(panel, CR_XFADE_MS, 0);
        crRun(panel, 0, 1, ms, ease, function () { crLand(panel); });
      }
      panel._size = sizePanel;
      // A comment GIF carries no intrinsic size until the bytes land, so the measurement above is taken
      // against a SHORT sheet and the last ~90px -- the whole compose row -- ends up outside the
      // overflow:hidden box: with a GIF in the thread the "Add a comment…" field and the GIF button were
      // invisible AND not hit-testable. Re-measure as each image arrives. Capture phase: `load` on an <img>
      // does not bubble.
      panel.addEventListener('load', function (e) { if (e.target && e.target.tagName === 'IMG') sizePanel(); }, true);

      // auto-collapse after 30s of inactivity; any interaction resets the clock.
      /* web #52 ("gif doesn't work in full screen"; owner restated: "gif comments aren't working in the
         pfeed on desktop"). The four listeners below are bound to `panel`, but the sheet's OWN popovers --
         the GIF picker, the emoji picker, the reaction picker -- are rendered into document.body
         (position:fixed, so they can escape the card's overflow, the same reason the outside-tap rule above
         has to exempt them). A body child is not a descendant of the panel, so NOTHING done inside the
         picker -- opening it, typing a search, scrolling the results, clicking a tile -- ever reached this
         clock. Browsing Giphy is exactly the kind of thing that runs past 30 seconds, so the sheet was
         folding away UNDERNEATH the open picker mid-pick: the chosen URL then landed in a form that was
         already being torn down (selectGif still holds the detached node), and the send button was gone
         with it -- so the comment could never be sent. Traced in the access log, to the second: sheet
         opened 14:44:46 (GET /comments), picker opened 14:44:51, searches at 14:44:53, the sheet's 8s poll
         stopped after 14:45:10 = collapsed at 14:45:16, exactly 30.0s after it opened, with no POST
         /comment ever following. Not a desktop branch -- there isn't one -- but desktop is where a GIF
         hunt takes longest (typed searches, a big scrollable grid), which is why it bites there.
         Fix: while one of those popovers is up the member is plainly still composing, so re-arm instead of
         collapsing. Picking closes the popover and focuses the field (focusin -> resetIdle), so the normal
         30s window starts again from the pick, with the sheet and its send button still on screen. */
      function resetIdle() {
        if (panel._idle) clearTimeout(panel._idle);
        panel._idle = setTimeout(function () {
          if (document.querySelector(PANEL_POPOVERS_OPEN)) { resetIdle(); return; }   // picker open = not idle
          closePanel(panel);
        }, 30000);
      }
      panel.addEventListener('keydown', resetIdle, true);
      panel.addEventListener('input', resetIdle, true);
      panel.addEventListener('click', resetIdle, true);
      panel.addEventListener('focusin', resetIdle);
      resetIdle();
      // a close that is run back open (crReopen) restarts what closePanel stopped
      panel._resume = function () {
        resetIdle();
        if (panel._pollFn && !panel._poll) { panel._poll = setInterval(panel._pollFn, CR_LIVE_MS); }
      };

      var list = panel.querySelector('.cpanel-list');
      var form = panel.querySelector('.cpanel-form');
      var input = panel.querySelector('.cpanel-input');
      /* v7 (native 550: after a send the sheet stays open and the keyboard stays up). A press on Send must not take the
         focus from the field: on iOS a tap on a button blurs it (the keyboard drops), and the focus() after the round
         trip cannot raise the keyboard again (not a user gesture). */
      var sendKeep = form && form.querySelector('.cpanel-send');
      if (sendKeep && input) { sendKeep.addEventListener('mousedown', function (e) { if (document.activeElement === input) { e.preventDefault(); } }); }

      // once the panel has expanded and the comments are in, snap the card's
      // bottom edge to 16px above the screen edge, the same gutter it gets on
      // the sides, which parks the compose field at the bottom of the screen.
      // No autofocus: the person may just want to read, and a focus would pop
      // the keyboard on phones.
      function revealForm() {
        /* NOT ONCE THE FIELD HAS THE CARET (2026-09-25). This runs 360ms after the sheet opens; a member
           who taps "Add a comment…" inside that window already has a keyboard rising and iOS's own reveal
           in flight, and a smooth scroll to the SCREEN bottom (under the keys) on top of both is a third
           mover. The keyboard-landing block after this IIFE owns the position from the focus on. */
        if (panel.contains(document.activeElement)) return;
        if (panel._closed || !panel.classList.contains('open')) return;   // folded again inside the 360ms
        if (!inPfeed) return;   // v4: crPlace keeps the card sheet above its floor, and the feed never moves under it
        var over = post.getBoundingClientRect().bottom - (window.innerHeight - 16);
        if (over > 0) window.scrollBy({ top: over, behavior: 'smooth' });
      }

      /* SLOW-LINK (2026-08-10). The sheet's POLL below got rfetch + a deadline on 2026-08-09; this,
         the INITIAL read that decides whether the sheet opens at all, did not -- and it is the one
         the reader is actually waiting on. openPanelNow() is called only on the success path (and
         in the .catch), so with no deadline a stalled socket leaves the panel in its pre-open state,
         showing nothing and saying nothing, for as long as the platform holds the connection:
         60-120s on iOS. That is precisely the "spinner that never resolves" shape, minus the
         spinner. The .catch already renders "Couldn't load comments." and opens the sheet, so the
         only thing missing was something to make the failure HAPPEN in a human amount of time.
         8000 matches the poll immediately below and every other small JSON read in this file. */
      /* v5 (2026-09-29): THE THREAD IS THERE AT t=0 AND STAYS PUT. Rob (iPhone web): "Expanding the comment scroller
         has flicker and it should expand smoothly to the last comment ... the native app opens perfectly." His
         recording AND the rig on the v4 bundle (Chromium + WebKit, real time): the sheet opened at the thread's end,
         then at the landing (crLand -> sizePanel -> crPlace, which measures the natural height with max-height:none)
         the browser clamped the list's scrollTop to 0 and the thread JUMPED to its oldest comment ~360ms after the
         tap (every avatar/GIF load did it again); and the open itself waited on this GET /comments.
         NOW, as RovaComments does it: seeded SYNCHRONOUSLY from THE THREAD CACHE and opened in the tap's own task; no
         cache -> the pill waits (.cr-wait) up to CR_WAIT_MS for the fetch, then opens on a skeleton; the list is put
         at its END before the morph (crAnchorOpen); a page that lands mid-morph waits for the landing
         (panel._pending) and is merged row by row (crMergeRows); every re-layout keeps the anchor (THE THREAD'S
         ANCHOR) and a changed height re-targets on a spring (crPlaceSpring). The 8s poll merges the same way. */
      panel._stick = true;
      list.addEventListener('scroll', function () {
        panel._stick = list.scrollHeight - list.clientHeight - list.scrollTop <= CR_STICK_PX;
        panel._aSnap = panel._stick ? null : crAnchorGet(panel);
      }, { passive: true });
      // a row that changes size by itself (a lazy GIF with no reserved box, a link card's image) moves every row under
      // it: put the anchor back AFTER that layout and BEFORE the paint (a ResizeObserver runs exactly there; the
      // capture 'load' listener below only re-places the sheet)
      if (window.ResizeObserver) {
        list._ro = new ResizeObserver(function () {
          if (!panel.classList.contains('open') || panel._rt) { return; }
          crAnchorPut(panel, panel._glideA || (panel._stick !== false ? { stick: true } : panel._aSnap));
        });
      }
      // v7: a finger / wheel / press on the thread takes it -- a glide in flight stops where it is
      ['touchstart', 'wheel', 'pointerdown'].forEach(function (t) { list.addEventListener(t, function () { crGlideStop(panel); }, { passive: true }); });
      if (CR_ANCHOR === 'seed') { panel._seedKey = crSeedKey(post); }
      // a delete/edit inside the sheet makes the cached thread wrong: the next open fetches
      panel.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.js-cdel, .js-cedit')) { crThreadDrop(postId); } }, true);
      // rows + composer gate + caps: DOM only (the callers keep the anchor)
      function fill(res, fresh) {
        if (!res) { return; }
        if (res._bad) { if (!list.querySelector('.cx-row')) { list.innerHTML = res._bad; list.removeAttribute('aria-busy'); return true; } return false; }
        if (res.comments) { panel._caps = { canReact: res.canReact !== false, canReply: res.canReply !== false }; }
        var changed = crMergeRows(list, res.comments || []);   // body is server-escaped HTML
        if (fresh && typeof res.count === 'number') setCount(btn, res.count);
        if (res.canComment === false && !panel._gated) {
          panel._gated = true; changed = true;
          /* The fifth and last copy of "your free trial has ended" (2026-08-08). It was hard-coded
             here, so a past_due member who opened the comment panel was told about a trial they
             finished months before their card declined. The sentence and the destination come off
             <body data-membership-*>, straight from Billing::notice(), so this line can never
             disagree with the strip at the top of the page or with the server's own 402. The old
             text is kept only as the fallback for a shell rendered before that flag existed. */
          var cgB = document.body;
          var cgMsg = (cgB && cgB.getAttribute('data-membership-msg')) || 'Your free trial has ended. Subscribe to comment.';
          var cgHref = cgB && cgB.getAttribute('data-membership-cta');
          form.innerHTML = res.commentGate === 'subscribe'
            ? (cgHref ? '<a class="cpanel-signin" href="' + escHtml(cgHref) + '">' + escHtml(cgMsg) + '</a>'
                      : '<span class="cpanel-signin">' + escHtml(cgMsg) + '</span>')
            : '<a class="cpanel-signin" href="/login">Log in to join the conversation</a>';
        }
        return changed;
      }
      panel._fill = fill;
      function arrive(res, fresh) {
        if (panel._closed || !panel.isConnected) { return; }
        if (!panel.classList.contains('open')) { fill(res, fresh); return; }
        if (panel._morph) {
          // v5b: an OPEN in flight re-targets from the rect it shows now (crRetargetOpen); a page with the same rows
          // changes nothing; the viewer's slide-up (no clip) merges at its landing
          if (!crCanRetarget(panel)) { panel._pending = { res: res, fresh: fresh }; return; }
          var ma = crAnchorGet(panel);
          if (fill(res, fresh)) { crRetargetOpen(panel, ma); } else { crAnchorPut(panel, ma); }
          return;
        }
        var live = fresh === 'live', n0 = live ? crRowCount() : 0, y0 = list.scrollTop;
        var a = crAnchorGet(panel), r0 = crBoxNow(panel);
        var changed = fill(res, live ? false : fresh);
        if (live) {
          // v7: the badge moves by what actually arrived or left in THIS reader's thread (never the raw COUNT(*),
          // which counts rows this reader is not shown), and a reader who was at the end follows the new rows down
          var d = crRowCount() - n0;
          if (d) { engCommentApplied(post, d); }
          if (changed && a.stick && !a.glide) { panel._stick = true; a = crGlideAnchor(y0, null); }
          if (changed) { resetIdle(); }   // a live thread is activity: the 30s idle fold waits while comments arrive
        }
        sizePanel(r0, a);
        if (a.glide) { crGlide(panel, a); }
      }
      function crRowCount() { return list.querySelectorAll('.cx-row[data-comment]').length; }
      /* v7 LIVE THREAD: the poll stands down while the member is sending (the optimistic row + badge are in flight),
         editing a row (a merge would replace it under the editor), while anything moves (morph, height spring, glide),
         and whenever the sheet is not simply open; the tab-hidden check is the poll's own */
      function crLivePaused() {
        return !panel.classList.contains('open') || !!panel._morph || !!panel._rt || !!panel._glideA
          || busyIs(form.querySelector('.cpanel-send')) || !!list.querySelector('.cedit-box');
      }
      // live: pull any new comments (yours or others') every few seconds while open
      // SLOW-LINK (2026-08-09): busy-guarded, deadlined (rfetch 8000) and hidden-skipped. An 8s period with no
      // in-flight flag and no timeout is the tightest network timer on any browsing surface here, and comments
      // are read while the reader is STILL IN THE POST -- so on a stalled socket it stacked a fresh /comments
      // every 8 seconds against exactly the link the video underneath is trying to buffer.
      var cmBusy = false;
      function go() {
        clearTimeout(panel._waitT);
        btn.classList.remove('cr-wait');
        if (panel._closed || panel.classList.contains('open')) { return; }
        // content is in (AFTER the gate: it swaps the composer for a sentence that can be three lines tall, and the
        // morph measures the panel ONCE) -> unfurl to full height in one motion
        openPanelNow();
        setTimeout(revealForm, 360);                       // after the .36s expand settles
        if (panel._closed || panel._poll) { return; }      // folded again already
        panel._poll = setInterval(panel._pollFn = function () {
          if (cmBusy || document.hidden || crLivePaused()) return;
          cmBusy = true;
          crThreadFetch(postId, false, true).then(function (res2) {
            if (!res2 || !res2.comments) { return; }                     // unchanged (one Redis read) or a failure
            if (crLivePaused() || panel._closed) {                       // paused while it was in flight: the cache now
              var ce = crThreads[String(postId)];                        // holds its rev, so forget the rev and the next
              if (ce && ce.res === res2) { ce.res.rev = 0; }             // poll reads the thread in full again
              return;
            }
            arrive(res2, 'live');
          }).catch(function () {}).then(function () { cmBusy = false; });
        }, CR_LIVE_MS);
      }
      var seed = crThreadGet(postId);
      if (seed) {
        fill(seed.res, false);
        go();                                              // the tap's own task: the thread is there at t=0
      } else {
        btn.classList.add('cr-wait');
        panel._waitT = setTimeout(function () { crSkeleton(list); go(); }, CR_WAIT_MS);
      }
      /* SLOW-LINK (2026-08-10): the INITIAL read is deadlined (rfetch 8000, in crThreadFetch) -- with no deadline a
         stalled socket left the sheet unopened and silent for 60-120s on iOS. v5: it no longer decides WHEN the
         sheet opens (the cache or CR_WAIT_MS does), only what it shows. */
      crThreadFetch(postId, false, !!seed).then(function (res) {
        if (panel._closed) { return; }
        if (res && res.unchanged) { if (!panel.classList.contains('open')) { go(); } return; }   // v7: the seed IS the thread
        if (!panel.classList.contains('open')) { fill(res, true); go(); return; }
        arrive(res, true);
      }).catch(function () {
        if (panel._closed) { return; }
        arrive({ _bad: '<div class="cpanel-note">Couldn\'t load comments.</div>' }, false);   // the cache's rows, if any, stay
        go();
      });

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        // In flight: drop the tap BEFORE cgifTake (it consumes the staged GIF) -- the spinner on
        // the send button is the "it registered" answer, and nothing typed or picked is lost.
        var sendBtn = form.querySelector('.cpanel-send');
        if (busyIs(sendBtn)) return;
        var val = (input.value || '').trim();
        // a bare GIF is a real comment (Comments::add: text OR a gif), so don't bail on empty text
        var pick = cgifTake(form);
        if (!val && !pick.url) return;
        var parentInp = form.querySelector('.js-parent');
        var parentId = parentInp ? parentInp.value : '';
        // optimistic: clear the box now, keep typing; the text comes back
        // (with a toast) if the send dies
        input.value = '';
        // The badge moves NOW, like a like or a repost, and stays held until the write settles.
        // Local +1 rather than res.count: that one is a raw COUNT(*) and would jump on a thread
        // holding a shadowed comment. settle() runs on every exit path below.
        var settle = engCommentBump(postId, 1);
        // gif_w/gif_h ride WITH gif_url (migration 0133). This panel builds its own JSON body
        // instead of posting a FormData, so the hidden fields do not come along by themselves --
        // they have to be named here or the panel would be the one surface that still stores
        // dimensionless GIFs. 0 = the pick had no declared size; the server treats that as none.
        busyUntil(sendBtn, postJson('/comment', { post_id: postId, body: val, parent_id: parentId, gif_url: pick.url, gif_w: pick.w, gif_h: pick.h }, 15000).then(function (res) {
          if (res && res.error) { settle(false); if (!input.value) input.value = val; pick.restore(); toast(res.error); return; }   // e.g. "verify your email to comment"
          if (!res || !res.comment) { settle(false); if (!input.value) input.value = val; pick.restore(); return; }
          crGlideStop(panel);                                   // v7: a glide in flight stops where it is
          var ka = crAnchorGet(panel), kr0 = crBoxNow(panel);   // v5: before a row moves
          // Never show it twice: if a background poll already slotted this comment in (it races
          // our optimistic add), drop that copy first. Roller rows are .cx-row, NOT .comment -- the
          // old check used the wrong selector, so the poll's copy AND ours both showed.
          if (res.comment.id) {
            Array.prototype.forEach.call(
              list.querySelectorAll('.cx-row[data-comment="' + res.comment.id + '"]'),
              function (r) { r.remove(); });
          }
          var note = list.querySelector('.cpanel-note'); if (note) note.remove();
          var node = crollerRow(res.comment);
          node._local = Date.now();                                  // v5: the next merge adopts the server's copy in place
          if (list._ro) { list._ro.observe(node); }
          node.classList.add('fade-in');
          // A REPLY must slot in UNDER its parent (indented), not at the very bottom -- otherwise it
          // jumped to the end and only sorted itself out on a page refresh. Insert it right after the
          // parent's own last existing reply (the roller is a flat list where a comment's replies
          // immediately follow it). Top-level comments still append at the bottom.
          var pid = res.comment.parent_id;
          var parentRow = pid ? list.querySelector('.cx-row[data-comment="' + pid + '"]') : null;
          if (parentRow) {
            var after = parentRow, sib = parentRow.nextElementSibling;
            while (sib && sib.classList.contains('cx-reply-row')) { after = sib; sib = sib.nextElementSibling; }
            after.parentNode.insertBefore(node, after.nextSibling);
          } else {
            list.appendChild(node);   // top-level, or parent not loaded in this panel -> bottom
          }
          /* v7 (native 550): the view first stays exactly where it was (the rows it showed keep their place), then GLIDES:
             a top-level comment to the end (and stays stuck there); a reply just far enough to show it under its parent */
          crAnchorPut(panel, { stick: false, row: ka.row, off: ka.off });
          var ga = crGlideAnchor(list.scrollTop, parentRow ? node : null);
          panel._stick = !parentRow;
          sizePanel(kr0, ga);
          if (panel._morph) { crAnchorPut(panel, ga); }
          crGlide(panel, ga);
          crThreadAdd(postId, res.comment);
          setReplyState(form, 0, '');
          input.value = ''; input.focus();   // the GIF preview went with cgifTake, before the send
          settle(true);   // NOT setCount(btn, res.count): the add endpoint's count is uncorrected
        }).catch(function (err) {
          settle(false);
          if (err && err.message === 'reauth') return;
          if (!input.value) input.value = val;
          pick.restore();
          toast('Couldn’t post that comment, check your connection');
        }));
      });

      return panel;
    }

    // GUEST in the immersive viewer: the comment roller is a plain <a href="/p/..."> (members get a
    // .js-comments button). Tapping it used to leave the viewer for the permalink; funnel to the signup
    // modal instead (same a[href="/signup"] path the rest of the guest gate uses). Capture-phase so it
    // beats the link's own navigation. Members' roller is a <button>, so this never matches for them.
    document.addEventListener('click', function (e) {
      var roller = e.target.closest ? e.target.closest('.pfeed a.croller') : null;
      if (!roller) return;
      e.preventDefault(); e.stopPropagation();
      var s = document.createElement('a'); s.href = '/signup'; s.style.display = 'none';
      document.body.appendChild(s); s.click(); s.remove();
    }, true);

    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('.js-comments') : null;
      if (!btn) return;
      e.preventDefault();
      // on the permalink page the comments are already listed, just scroll to them -- but NOT when the
      // tap is inside the immersive viewer (it can be open OVER the permalink page): there the roller
      // must expand the pfeed's own comment panel, not scroll the page hidden behind it.
      if (!btn.closest('.pfeed') && document.getElementById('comment-list')) {
        var anchor = document.getElementById('comments');
        if (anchor) anchor.scrollIntoView({ behavior: 'smooth' });
        return;
      }
      var post = btn.closest('.post');
      // landing marquee (or no card) -> fall back to the permalink
      if (!post || btn.closest('.livefeed')) { var ch = btn.getAttribute('href'); if (ch) window.location = ch; return; }
      if (openPanel && openPanel._post === post) { closePanel(openPanel); return; }  // toggle
      if (openPanel) closePanel(openPanel);                                          // one at a time
      // this card's sheet is still folding away (or handing over to the pill): run it back open from
      // where it is -- the same rows, no refetch, no second panel stacked under the first
      var folding = null;
      Array.prototype.slice.call(post.querySelectorAll('.croller-panel.cr-quiet')).forEach(function (q) { if (q._swipe) { q._swipe = null; crDrop(q); } });   // v6
      for (var fc = post.lastElementChild; fc; fc = fc.previousElementSibling) {
        if (fc.classList && fc.classList.contains('croller-panel') && (fc.classList.contains('cr-closing') || fc.classList.contains('cr-ghost'))
            && !fc.classList.contains('cr-quiet')) { folding = fc; break; }
      }
      openPanel = folding ? crReopen(folding) : openFor(post, btn.getAttribute('data-post'), btn);
      engHold('comments', true, ENG_LONG, openPanel);   // engage-hold: reading comments suspends every auto-load
    });

    // auto-collapse once the post has scrolled out of view
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!openPanel || ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        if (!openPanel || !openPanel._post) return;
        var r = (openPanel._docked ? openPanel._post : openPanel).getBoundingClientRect();   // v3: the card sheet overlays past its card
        if (r.bottom < 48 || r.top > (window.innerHeight - 48)) closePanel(openPanel, 'away');   // leaving the screen: no motion
      });
    }, { passive: true });
  })();

  /* ---- THE COMMENT FIELD LANDS ON THE KEYBOARD IN ONE MOTION: PLACED BEFORE iOS LOOKS (2026-09-25, round 3) ----
     Rob, iPhone Safari: the sheet's "Add a comment…" field should rest right above the keyboard. Three rounds today:

     ROUND 1 (bundle app.806cb6d0c19a, PULLED): let iOS reveal the field, then correct once toward
     visualViewport.offsetTop + height - 10. His 60fps recording (iOS 26 Safari, 420x912 CSS, send-button centre
     tracked per frame) showed FIVE motions: iOS centred the field (609 -> 266, 230ms), our correction pushed it
     BEHIND Safari's floating chrome, iOS pulled it back (-> 424), our 56px "floating" re-align pushed it down
     again, iOS pulled it back again. Where our target put the row says visualViewport's bottom sat near screen
     y 646 -- BELOW the keyboard's top edge (~565): on iOS 26 the vv does not describe the band the reader can
     see, and the address pill ("rovasocial.com", top ~465) and the ^ v check pill (~507-554) float over the page
     above the keys where the page cannot see them. Any target computed from the vv AFTER the keyboard is up
     lands behind that chrome, and iOS fights it.
     ROUND 2 (app.5a9248d6e292): iOS alone. One motion, but it CENTRES the field in the band between the status
     bar and the address pill (measured: field centre 266 = the middle of 68..465), leaving ~165px -- "a whole
     post" -- between the field and the keyboard. Rob: "that's better ... but it does settle too high".

     ROUND 3, THIS: iOS only scrolls a field it cannot SEE when focus arrives (WebKit's focus reveal returns early
     when the element is already inside the unobscured rect). So the tap is taken over: on a clean tap on the
     unfocused field we cancel the native focus (touchend preventDefault -- the FastClick pattern), scroll the page
     INSTANTLY so the field's bottom sits where the keyboard's top chrome WILL begin, then focus() in the same
     task (a touchend is a user activation, so iOS raises the keyboard). iOS then finds the field visible and does
     not scroll at all. ONE motion, ours, at the tap, while the keys rise. Nothing moves after that: there is no
     settle-and-correct and no re-align, so there is nothing for iOS to fight. A field the keys later cover
     (emoji keyboard) is revealed by iOS itself, minimally -- that is what the recording's 424 landings were.

     ROUND 4 (same day). Rob: "still leaves this much space" -- his screenshot has the field centred again,
     centre 282 = the middle of 68..497 (the address pill COLLAPSED to a strip at ~497 this time). No code
     path autofocuses the field when the sheet opens (openFor says "No autofocus"; the only other focus()
     calls on it are after a send and in Reply), so the tap was his own and round 3's placement put the
     field's bottom 14px above the pill. WebKit's focus reveal only stands down for a field that is visible
     AND clear of the keyboard by a minimum distance -- ~50px, the "minimum distance from keyboard to trigger
     scroll" in its zoom-to-focus-rect code (from memory of the source, not read off this box). 14px is inside
     that, so iOS scrolled and centred exactly as before. The target now stops KBL_IOS_TRIGGER_PX short of the
     band, which leaves a small visible gap BY DESIGN: the price of it being one motion.

     THE TARGET is predicted from the vv BEFORE the keyboard exists (it reaches the screen bottom under the
     floating tab bar), in screen geometry measured off Rob's recording and screenshots (420x912):
        KBL_KEYBOARD_PX     347  screen bottom -> the keyboard's top edge (portrait)
        KBL_FLOAT_BARS_PX   100  keyboard top  -> top of Safari's EXPANDED address pill (~465; collapsed ~497)
        KBL_IOS_TRIGGER_PX   50  band bottom   -> the closest the focused field may sit without iOS scrolling
        KBL_GAP_PX            6  safety on top of that
     => field bottom 503 px above the screen bottom (screen y ~409 on his phone, ~56px above the expanded pill).
     TUNING FROM HIS FEEDBACK: iOS still re-centres (a second jump, field ends mid-screen) -> raise KBL_GAP_PX
     by 20. Lands still, but with more gap than he wants -> lower KBL_IOS_TRIGGER_PX in steps of 10 until iOS
     starts re-centring, then back off one step. Too HIGH is always safe; too LOW costs the re-centre. The
     kbl:tap trace below records what the phone did, so the next round is read, not guessed.

     SCOPE, AND THE ASSUMPTION: iPhone Safari 26+ only (UA: iPhone + "Version/26" or later + "Safari/", no
     CriOS/FxiOS/EdgiOS/OPiOS/GSA), portrait, the keyboard not already up. The floating compact layout is iOS
     26's default; the page cannot see Safari's layout setting, so a member on 26 who chose the Bottom/Top tab bar
     gets the same prediction -- at worst a few px of error in either direction. Everything else (older iOS,
     other iOS browsers, Android, desktop, landscape, a tap that moves, a focused field, programmatic focus such
     as Reply) keeps the native behaviour. The immersive viewer's sheet is excluded (the page under it is
     pinned). Fields: the timeline sheet's input (feed + profile cards) and the permalink composer (whose
     GIF/send row sits BELOW the textarea, so there the whole form is what is placed). */
  (function () {
    var ua = navigator.userAgent || '';
    var ver = ua.match(/Version\/(\d+)/);
    if (!/iPhone|iPod/.test(ua) || !ver || parseInt(ver[1], 10) < 26 || !/Safari\//.test(ua) ||
        /CriOS|FxiOS|EdgiOS|OPiOS|GSA\//.test(ua)) { return; }
    var vv = window.visualViewport;
    if (!vv) { return; }
    var KBL_KEYBOARD_PX = 347;
    var KBL_FLOAT_BARS_PX = 100;
    var KBL_IOS_TRIGGER_PX = 50;
    var KBL_GAP_PX = 6;
    var KBL_TRACE_MAX = 6;
    var KBL_MIN_MOVE_PX = 6;     // closer than this to the target already: leave the tap entirely native
    var KBL_TAP_SLOP_PX = 10;    // a finger that travels further is a scroll/selection, not a tap
    var KBL_TAP_MS = 700;        // a longer press is the native long-press (loupe, paste menu)
    var FIELD = '.croller-panel .cpanel-input, .comment-panel .cpanel-input, form.js-comment textarea';
    var tap = null;
    function locked() {
      return document.documentElement.classList.contains('scroll-locked') ||
             (document.body && document.body.classList.contains('scroll-locked'));
    }
    // the box that must clear the keyboard chrome: the sheet's input itself, or the permalink's whole form
    function anchorOf(field) {
      return field.classList.contains('cpanel-input') ? field : (field.closest('form') || field);
    }
    // ...and a visible "Replying to" chip rides WITH the sheet's field (2026-10-06): the placement and its header
    // floor clamp used the field alone, so the chip just above it could be parked under the sticky header/tabs
    function anchorRect(field) {
      var a = anchorOf(field).getBoundingClientRect();
      var chip = field.classList.contains('cpanel-input') && field.form ? field.form.querySelector('.reply-chip:not([hidden])') : null;
      var c = chip ? chip.getBoundingClientRect() : null;
      if (!c || !c.height || c.top >= a.top) { return a; }
      return { top: c.top, bottom: a.bottom, height: a.bottom - c.top };
    }
    // where the sticky/fixed chrome will END once the page has scrolled `by` more (2026-10-06): measured where it is
    // NOW, the feed tabs below the fold were not counted, the takeover scrolled them into their stuck place and they
    // landed on top of the field and its reply chip (rig: scratchpad momc/takeover.js on /feed?tab=following)
    function chromeBottom(by) {
      var y = 0, els = document.querySelectorAll('.topbar, #feed-tabs');
      for (var i = 0; i < els.length; i++) {
        var cs = getComputedStyle(els[i]), pos = cs.position;
        if (pos !== 'sticky' && pos !== 'fixed') { continue; }
        var r = els[i].getBoundingClientRect();
        if (!r.height) { continue; }
        var top = r.top;
        if (pos === 'sticky' && by) { var st = parseFloat(cs.top); top = isNaN(st) ? r.top - by : Math.max(st, r.top - by); }
        if (top < 160 && top + r.height > 0) { y = Math.max(y, top + r.height); }
      }
      return y;
    }
    document.addEventListener('touchstart', function (e) {
      tap = null;
      var t = e.target && e.target.closest ? e.target.closest(FIELD) : null;
      if (!t || e.touches.length !== 1 || document.activeElement === t) { return; }
      if (t.closest('.pfeed') || locked()) { return; }
      tap = { field: t, x: e.touches[0].clientX, y: e.touches[0].clientY, t: Date.now() };
    }, { capture: true, passive: true });
    document.addEventListener('touchmove', function (e) {
      if (!tap) { return; }
      var p = e.touches[0];
      if (Math.abs(p.clientX - tap.x) > KBL_TAP_SLOP_PX || Math.abs(p.clientY - tap.y) > KBL_TAP_SLOP_PX) { tap = null; }
    }, { capture: true, passive: true });
    document.addEventListener('touchcancel', function () { tap = null; }, { capture: true, passive: true });
    document.addEventListener('touchend', function (e) {
      var c = tap;
      tap = null;
      if (!c || e.touches.length || Date.now() - c.t > KBL_TAP_MS) { return; }
      var field = c.field;
      if (!field.isConnected || field.disabled || document.activeElement === field) { return; }
      var vw = window.innerWidth || 0, vh = vv.height || 0;
      if (!vh || vw > vh) { return; }                                  // landscape: native
      var full = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
      if (full && vh < full * 0.8) { return; }                         // a keyboard is already up: native
      var a = anchorRect(field), f = field.getBoundingClientRect();
      if (!a.height || !f.height) { return; }
      // B = the bottom of the band iOS will consider visible once the keys and its pills are up
      var band = (vv.offsetTop || 0) + vh - KBL_KEYBOARD_PX - KBL_FLOAT_BARS_PX;
      // the FOCUSED element must clear WebKit's reveal trigger; the permalink's send row just the band
      var by = Math.round(Math.max(f.bottom - (band - KBL_IOS_TRIGGER_PX - KBL_GAP_PX), a.bottom - (band - 8)));
      var floor = chromeBottom(by) + 8;                                // never park its top (or its reply chip) under the header
      if (a.top - by < floor) { by = Math.round(a.top - floor); }
      var info = { v: 4, took: 0, by: by, band: Math.round(band), fb0: Math.round(f.bottom), vh0: Math.round(vh),
                   vt0: Math.round(vv.offsetTop || 0), ih: window.innerHeight || 0, ch: document.documentElement.clientHeight || 0 };
      if (Math.abs(by) >= KBL_MIN_MOVE_PX) {
        e.preventDefault();                                            // no native focus, no native reveal
        try { window.scrollTo({ top: (window.pageYOffset || 0) + by, behavior: 'instant' }); }
        catch (e2) { window.scrollBy(0, by); }
        info.took = 1;
        try { field.focus({ preventScroll: true }); } catch (e3) { field.focus(); }
        try { var n = (field.value || '').length; field.setSelectionRange(n, n); } catch (e4) {}
      }
      report(field, info);
    }, { capture: true, passive: false });
    /* WHAT THE PHONE ACTUALLY DID, measured on the phone (2026-09-25). Rounds 1-3 were each argued from a
       model; this box cannot run iOS. So each takeover (or native tap that we let through) sends ONE
       compose-trace record ~1.3s later: did we move the page, did iOS move it AFTER the focus (iosMove),
       where the field ended, and what the visual viewport / innerHeight / ICB read with the keys up. Members
       only (the sink is session-authed and kill-switched); at most KBL_TRACE_MAX per page. grep
       C:\ProgramData\Rova\compose-trace.jsonl for "ev":"kbl:tap". */
    var kblSent = 0;
    function report(field, info) {
      if (kblSent >= KBL_TRACE_MAX) { return; }
      if (document.querySelector('meta[name="rova-guest"]')) { return; }
      var y0 = Math.round(window.pageYOffset || 0);
      setTimeout(function () {
        try {
          var f = field.getBoundingClientRect();
          info.focused = document.activeElement === field ? 1 : 0;
          info.iosMove = Math.round(window.pageYOffset || 0) - y0;
          info.ft1 = Math.round(f.top); info.fb1 = Math.round(f.bottom);
          info.vh1 = Math.round(vv.height); info.vt1 = Math.round(vv.offsetTop || 0);
          info.ih1 = window.innerHeight || 0; info.ch1 = document.documentElement.clientHeight || 0;
          info.path = location.pathname.slice(0, 40);
          var tok = (document.querySelector('meta[name="csrf-token"]') || {}).content || '';
          if (!tok) { return; }
          kblSent++;
          var body = '_csrf=' + encodeURIComponent(tok) + '&ev=kbl%3Atap&d=' + encodeURIComponent(JSON.stringify(info));
          if (navigator.sendBeacon && navigator.sendBeacon('/compose-trace', new Blob([body], { type: 'application/x-www-form-urlencoded' }))) { return; }
          fetch('/compose-trace', { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: body, keepalive: true, credentials: 'same-origin' }).catch(function () {});
        } catch (e) {}
      }, 1300);
    }
  })();

  /* ---- comment roller: cycle the recent comments on collapsed posts ----
     #35 (owner): each roller now runs on ITS OWN clock, timed to the comment
     currently on screen — 1 second per word, minimum 3s, maximum 10s — so a
     one-word "🔥" flips quickly while a long comment stays up long enough to
     read, instead of every roller flipping together on one fixed 3.8s beat.
     A single fine-grained interval drives per-track countdowns, so the rollers
     are decoupled without spinning up a timer per roller. Skips hidden tabs,
     offscreen posts, and reduced-motion users (they keep the newest line). */
  (function () {
    /* REDUCED MOTION no longer returns out of the whole block. It gates ROTATION only, because the
       heal pass below is a correctness guarantee, not an animation, and a reduced-motion reader is
       exactly as entitled to see a comment as anyone else. The per-tick cost is unchanged for them:
       one querySelectorAll plus a property compare, which is what a not-yet-due tick already cost. */
    var REDUCE = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
    /* THE ROLLER MUST NEVER SIT AS AN EMPTY PILL (owner 2026-08-07: "sometimes the comment roller
       loads in like this" -- a blank rounded bar over the media in the immersive viewer).
       .croller-item is opacity:0 by default and only `.on` lifts it, so a track with no `.on` renders
       as a pill with no comment in it. Two ways that happens, both PROVED in Chromium AND WebKit:
         - a track whose `.on` was lost stays blank for a FULL HOLD (measured 8.2-8.3s) before the
           rotation below re-adds it, and a ONE-item track never healed at all -- `items.length < 2`
           returned before anything could run;
         - `.out` is the exit class, cleared by a bare 520ms setTimeout bound to the live element. Any
           snapshot/restore of the card in that window (stubCard(), :20514, stashes p.outerHTML and
           then DESTROYS the element that owned the timer) strands `out` in the saved markup. When the
           rotation later turns that item on it carries `on out`, and `.croller-item.out` sits AFTER
           `.croller-item.on` in rova.css at identical (0,2,0) specificity -- measured opacity 0.
       ensureLine() is the answer to both: it is cheap (classList only, ZERO layout reads), it runs on
       first sight of every track and again before each rotation, and it is the reason no state can
       leave a reader looking at an empty bar. rova.css also stops `.out` applying to a line that is
       `.on`, so the two fixes are independent -- neither relies on the other. */
    function ensureLine(items) {
      var on = -1, i;
      for (i = 0; i < items.length; i++) { if (items[i].classList.contains('on')) { on = i; break; } }
      if (on < 0) {
        if (!items.length) return -1;
        items[0].classList.remove('out');       // a stranded exit class must not blank the line we are restoring
        items[0].classList.add('on');
        return 0;
      }
      if (items[on].classList.contains('out')) { items[on].classList.remove('out'); }
      return on;
    }
    // hold time for the line currently shown: 1s/word, clamped to [3s, 10s]
    function holdMs(item) {
      var tx = item && item.querySelector('.cr-text');
      var words = tx ? ((tx.textContent || '').trim().match(/\S+/g) || []).length : 0;
      return Math.max(3000, Math.min(10000, words * 1000));
    }
    /* PERF (2026-07-29 per-frame audit). This loop was the biggest source of the CONSTANT tax the RUM
       was reporting -- the one that made slow% flat across imgMB instead of scaling with it. It woke
       every 500ms forever, on every page with posts, scrolling or not, and called
       getBoundingClientRect() on EVERY .croller-track just to ask "are you on screen?": 728 forced
       layout reads in a 12s window, ~482ms of main thread, none of it gated on scrolling or on the
       rollers actually being visible.
       Visibility now comes from an IntersectionObserver (which the compositor answers for free), and
       a due-time short-circuit means the overwhelming majority of wake-ups are a single number
       compare. Zero layout reads remain in here. Minimum hold is 3s, so 500ms granularity is kept.
       Note: an IO reports nothing for a hidden tab -- which is fine, `document.hidden` already
       returns above -- and a freshly-observed track has _vis undefined for one frame, which costs at
       most one 500ms tick before that roller starts. */
    var trackIO = window.IntersectionObserver ? new IntersectionObserver(function (ents) {
      for (var i = 0; i < ents.length; i++) { ents[i].target._vis = ents[i].isIntersecting; }
    }, { rootMargin: '0px' }) : null;
    var nextDue = 0;                       // earliest _nextAt across all tracks; before it, there is nothing to do
    setInterval(function () {
      if (document.hidden) return;
      var now = Date.now();
      var tracks = document.querySelectorAll('.croller-track:not(.cr-pillclone *)');   // never the closing sheet's copy of a pill
      if (!tracks.length) return;
      // observe any track we haven't seen yet (cheap: a property check, no layout), and HEAL it in the
      // same pass. This is the branch a card RESTORED from a stub (restoreCard, :20518) arrives on --
      // a brand new element, so `_obs` is unset -- which is precisely where a stranded `out` or a
      // missing `on` would otherwise sit blank until a rotation happened to reach it, or forever on a
      // one-comment post. It runs BEFORE the due-time short-circuit deliberately: a blank pill must
      // not wait on another roller's clock.
      for (var q = 0; q < tracks.length; q++) {
        if (!tracks[q]._obs) {
          tracks[q]._obs = 1;
          if (trackIO) { try { trackIO.observe(tracks[q]); } catch (e) {} }
          ensureLine(tracks[q].querySelectorAll('.croller-item'));
        }
      }
      if (REDUCE) return;                     // reduced motion: healed above, never rotated
      if (nextDue && now < nextDue) return;   // nothing is due: the whole tick is one compare
      var due = 0;
      Array.prototype.forEach.call(tracks, function (t) {
        // offscreen (or not yet reported by the observer) -> skip before doing ANY DOM work, and
        // don't let it hold nextDue down. This is the check that used to be a getBoundingClientRect.
        if (trackIO && t._vis !== true) return;
        var items = t.querySelectorAll('.croller-item');
        if (!items.length) return;
        // Heal FIRST, rotate second. syncRoller() rebuilds a track in place, so `_obs` is still set on
        // it and the first-sight branch above never runs again for that element -- this is the only
        // pass a rebuilt track gets. It also covers the ONE-item roller, which the `< 2` guard below
        // used to skip entirely: nothing to cycle is not the same as nothing to show.
        var cur = ensureLine(items);
        if (items.length < 2) return;
        // (re)seed this track's clock on first sight or after syncRoller rebuilt it
        if (t._nextAt == null || t._itemCount !== items.length) {
          t._itemCount = items.length;
          t._nextAt = now + holdMs(items[cur > -1 ? cur : 0]);
          if (!due || t._nextAt < due) due = t._nextAt;
          return;
        }
        if (now < t._nextAt) { if (!due || t._nextAt < due) due = t._nextAt; return; }   // still holding this line
        var next = ((cur > -1 ? cur : -1) + 1) % items.length;
        if (cur > -1) {
          var el = items[cur];
          el.classList.remove('on');
          el.classList.add('out');
          setTimeout(function () { el.classList.remove('out'); }, 520);
        }
        items[next].classList.remove('out');   // never light a line that still carries the exit class
        items[next].classList.add('on');
        t._nextAt = now + holdMs(items[next]);             // schedule off the NEW line's length
        if (!due || t._nextAt < due) due = t._nextAt;
      });
      // Sleep until the earliest track is actually due. A track that was skipped for being offscreen
      // does NOT contribute, so scrolling it back into view is picked up by the next 500ms wake --
      // but only after `due` passes, so cap the sleep so a newly-visible roller can't wait minutes.
      nextDue = due ? Math.min(due, now + 3000) : 0;
    }, 500);
  })();

  /* ---- save / bookmark buttons ----------------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.js-save') : null;
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-id');
    if (window.__rovaOwnWrite) window.__rovaOwnWrite(id);   // batch item 44: a local save beats a stale own-state read
    var wasSaved = btn.getAttribute('data-saved') === '1';
    var paintSave = function (saved) {
      btn.textContent = saved ? 'Saved' : 'Save';
      if (saved) btn.setAttribute('data-saved', '1'); else btn.removeAttribute('data-saved');
    };
    // optimistic: flip + toast now, reconcile with the response, roll back if it dies
    paintSave(!wasSaved);
    closePmenus(null);
    toast(!wasSaved ? 'Saved' : 'Removed from saved');
    postJson('/bookmark', { post_id: id }).then(function (res) {
      if (window.__rovaOwnWrite) window.__rovaOwnWrite(id);   // settled: the write is in the database as of now
      if (res && typeof res.saved !== 'undefined' && !!res.saved === wasSaved) paintSave(!!res.saved);
    }).catch(function (err) {
      if (!err || err.message === 'reauth') return;
      paintSave(wasSaved);
      toast('Couldn’t update saved, check your connection');
    });
  });

  /* ---- admin / mod: toggle a post's EXPLICIT (NSFW) flag from its ⋯ menu -----------------------
     The button only renders for a user the server grants PERM_EXPLICIT; the endpoint re-checks, so a
     crafted request from anyone else gets a 403. Updates the label + data-nsfw in place, no reload. */

  /* The `.nsfw-veil` overlay, rebuilt in JS byte-for-byte from views/_post.php's $nsfwVeil.
     Only ever built for a signed-in moderator (nobody else can reach the toggle), which is the
     $canEngage = true branch of that closure -- hence the fixed copy. The eye-off path is the same
     one the embed frame and the profile grid bar use. */
  function nsfwVeilNode() {
    var v = document.createElement('div');
    v.className = 'nsfw-veil';
    v.setAttribute('role', 'group');
    v.setAttribute('aria-label', 'Sensitive content, hidden');
    v.innerHTML = '<span class="nsfw-veil-ic"><svg viewBox="0 0 24 24" width="26" height="26" fill="none" '
      + 'stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
      + '<path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 '
      + '9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>'
      + '<line x1="1" y1="1" x2="23" y2="23"/></svg></span>'
      + '<strong>Sensitive content</strong>'
      + '<span class="nsfw-veil-sub">Hidden by your nudity filter</span>'
      + '<button type="button" class="nsfw-veil-btn js-nsfw-reveal">Show anyway</button>';
    return v;
  }

  /* Repaint EVERY card on the page holding this post id (the feed can carry the same post twice --
     organically and as a repost -- and the profile grid draws it a third way).

     THE VEIL IS NOT DERIVABLE FROM THE FLAG, so the server sends `gate` and this only applies it:
     nsfw_should_gate() exempts an author from their own media, honours the rova_adult_ok cookie and
     the viewer's nudity-filter setting, and veils a CLEAN post on a profile-gated author. Painting
     the blur off `res.nsfw` would be wrong in three of those four cases.

     Owner 2026-08-05, reported on the app ("It said explicit flag cleared but it still has the blur")
     -- the web card had the identical gap: the label flipped and the blur sat there until a reload. */
  function paintExplicitGate(pid, gate) {
    if (!pid) return;
    document.querySelectorAll('article.post[data-view="' + pid + '"] .media').forEach(function (m) {
      var veil = m.querySelector(':scope > .nsfw-veil');
      if (gate) {
        m.classList.add('nsfw-gate');
        if (!veil) m.appendChild(nsfwVeilNode());
      } else {
        m.classList.remove('nsfw-gate');
        if (veil) veil.remove();
      }
    });
    document.querySelectorAll('.pgrid .pcell[data-id="' + pid + '"]').forEach(function (c) {
      c.classList.toggle('nsfw-cell', !!gate);
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.js-explicit') : null;
    if (!btn) return;
    e.preventDefault();
    var on = btn.getAttribute('data-nsfw') === '1' ? 0 : 1;    // toggle
    var pid = btn.getAttribute('data-id');
    if (busyIs(btn)) return;
    busyUntil(btn, postJson('/mod/explicit', { post_id: pid, on: String(on) }, 15000).then(function (res) {
      if (!res || !res.ok) { toast('Could not update the flag.'); return; }
      btn.setAttribute('data-nsfw', String(res.nsfw));
      btn.textContent = res.nsfw ? 'Clear explicit flag' : 'Mark explicit';
      /* `gate` is the server's veil decision for THIS viewer. Older servers don't send it; fall back
         to the flag rather than leaving a stale blur, which is the bug this is here to close. */
      paintExplicitGate(pid, typeof res.gate === 'undefined' ? !!res.nsfw : !!Number(res.gate));
      closePmenus(null);
      /* `media` (2026-09-30): a clear now unlocks the post's media server-side; a non-empty note
         names what it could not finish yet (the queue retries it). Older servers don't send it. */
      /* `msg` (2026-09-30 night): the server's own words -- "Flag cleared. Media is being restored…"
         while the /nsfw-run worker moves the media back (the clear no longer waits for it). */
      toast(res.msg || (res.nsfw ? 'Marked explicit' : ('Cleared explicit flag' + (res.media ? ', media unlock incomplete: ' + res.media : ''))));
    }).catch(function () { toast('Could not update the flag.'); }));
  });

  /* ---- pin / unpin a post to your profile ------------------------------- */

  /* Re-sort the profile's "All" list to match what the server would render for
     a given pin, and FLIP-animate every card that moves. Bug #42: painting the
     ribbon was not enough -- pinning a second post while one was already pinned
     left BOTH cards exactly where they were, so nothing visibly happened until a
     reload. Server order is: the pinned post first, then strict row-id DESC
     (views/_profile_posts.php + Posts::byUser "ORDER BY p.id DESC"), so the same
     order is reproducible on the client with no extra request. The old pin drops
     back into its id slot on the way. No-ops off the profile page (the feed and
     the single-post page have no list to reorder). */
  function reflowProfilePins(pinnedId, mutate) {
    var wrap = document.getElementById('profile-posts');
    var cards = wrap ? [].filter.call(wrap.children, function (n) {
      return n.classList && n.classList.contains('post') && n.getAttribute('data-id');
    }) : [];
    // grid tabs / feed / single post: nothing to sort, just repaint the ribbons
    if (cards.length < 2) { if (mutate) mutate(); return; }

    // measure BEFORE the ribbon repaint so the "Pinned" strip appearing and
    // disappearing rides the same animation instead of jumping the list
    var sy = window.pageYOffset || document.documentElement.scrollTop || 0;
    var seen = cards.map(function (n) { return n.getBoundingClientRect().top + sy; });   // document space
    if (mutate) mutate();

    var pin = pinnedId == null ? null : String(pinnedId);
    // data-id is the ROW id the server sorts on; data-view is the post the pin
    // points at (they differ only on reposts, which can never be pinned).
    var want = cards.slice().sort(function (a, b) {
      if (pin !== null) {
        if (a.getAttribute('data-view') === pin) return -1;
        if (b.getAttribute('data-view') === pin) return 1;
      }
      return parseInt(b.getAttribute('data-id'), 10) - parseInt(a.getAttribute('data-id'), 10);
    });
    var from = want.map(function (n) { return seen[cards.indexOf(n)]; });

    // reorder in place, keeping any non-card siblings (empty state, notices) put
    var mark = document.createComment('pinflip');
    wrap.insertBefore(mark, cards[0]);
    var frag = document.createDocumentFragment();
    want.forEach(function (n) { frag.appendChild(n); });
    wrap.insertBefore(frag, mark);
    wrap.removeChild(mark);

    var sy2 = window.pageYOffset || document.documentElement.scrollTop || 0;
    var to = want.map(function (n) { return n.getBoundingClientRect().top + sy2; });
    var quiet = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!quiet) {
      want.forEach(function (n, i) {
        var d = from[i] - to[i];
        if (!d) return;
        n.style.transition = 'none';
        n.style.transform = 'translateY(' + d + 'px)';
        n.style.willChange = 'transform';
      });
      requestAnimationFrame(function () { requestAnimationFrame(function () {
        want.forEach(function (n) {
          if (!n.style.transform) return;
          n.style.transition = 'transform 420ms cubic-bezier(.22,.61,.36,1)';
          n.style.transform = '';
        });
      }); });
      setTimeout(function () {
        want.forEach(function (n) { n.style.transition = ''; n.style.transform = ''; n.style.willChange = ''; });
      }, 620);
    }
    // the card just flew above the fold -- follow it up so the move is actually seen
    if (pin !== null) {
      var idx = want.findIndex ? want.findIndex(function (n) { return n.getAttribute('data-view') === pin; }) : -1;
      if (idx >= 0) {
        var dest = Math.max(0, to[idx] - 80);
        if (sy2 > dest + 4) {
          setTimeout(function () {
            try { window.scrollTo({ top: dest, behavior: quiet ? 'auto' : 'smooth' }); }
            catch (err) { window.scrollTo(0, dest); }
          }, quiet ? 0 : 380);
        }
      }
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.js-pin') : null;
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-id');
    var pinned = btn.getAttribute('data-pinned') === '1';
    var prevPinBtn = document.querySelector('.js-pin[data-pinned="1"]');
    var prevPinId = prevPinBtn ? prevPinBtn.getAttribute('data-id') : null;
    // a member has ONE pin: paint the whole page for "post X is the pin"
    // (null = no pin). Used for the instant flip, the reconcile AND the rollback.
    var paintTags = function (pinnedId) {
      document.querySelectorAll('.js-pin').forEach(function (b) {
        var on = pinnedId != null && b.getAttribute('data-id') === String(pinnedId);
        b.setAttribute('data-pinned', on ? '1' : '0');
        b.textContent = on ? 'Unpin from profile' : 'Pin to profile';
      });
      document.querySelectorAll('.post .pinned-tag').forEach(function (t) { t.remove(); });
      if (pinnedId != null) {
        document.querySelectorAll('.post[data-view="' + pinnedId + '"]').forEach(function (post) {
          if (post.querySelector('.pinned-tag')) return;
          var tag = document.createElement('div');
          tag.className = 'pinned-tag';
          tag.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="12" y1="17" x2="12" y2="22"/><path d="M9 4h6l-1 7 3 2v2H7v-2l3-2z"/></svg>Pinned';
          post.insertBefore(tag, post.firstChild);
        });
      }
    };
    // ribbons + menu labels AND the profile re-sort, as one measured FLIP
    var paintPin = function (pinnedId) {
      reflowProfilePins(pinnedId, function () { paintTags(pinnedId); });
    };
    // optimistic: pin/unpin now, reconcile with the response, roll back if it dies
    paintPin(pinned ? null : id);
    closePmenus(null);
    toast(pinned ? 'Unpinned' : 'Pinned to your profile');
    postJson('/pin', { post_id: id, action: pinned ? 'unpin' : 'pin' }).then(function (res) {
      if (!res || !res.ok) { paintPin(prevPinId); toast((res && res.error) || 'Could not update pin'); return; }
      if (!!res.pinned === pinned) paintPin(res.pinned ? id : null);   // server disagreed
    }).catch(function (err) {
      if (!err || err.message === 'reauth') return;
      paintPin(prevPinId);
      toast('Could not update pin');
    });
  });

  /* ---- comment search: find keywords / @users in a viral thread ---------- */
  (function () {
    var input = document.getElementById('csearch');
    if (!input) return;
    var post = input.getAttribute('data-post');
    var list = document.getElementById('comment-list');
    var results = document.getElementById('comment-search-results');
    if (!results) return;
    var t = null, lastQ = '';
    function restore() { results.hidden = true; results.innerHTML = ''; if (list) list.hidden = false; }
    function run(q) {
      fetch('/comment-search?ajax=1&post=' + encodeURIComponent(post) + '&q=' + encodeURIComponent(q), {
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
        credentials: 'same-origin'
      }).then(function (r) { return r.json(); }).then(function (res) {
        if (!res || !res.ok || input.value.trim() !== q) return;   // ignore stale / superseded
        results.innerHTML = '<div class="csearch-head">' + res.count + ' match' + (res.count === 1 ? '' : 'es') +
          ' · <button type="button" class="csearch-clear">Clear</button></div>' + res.html;
        results.hidden = false;
        if (list) list.hidden = true;
      }).catch(function () {});
    }
    input.addEventListener('input', function () {
      clearTimeout(t);
      var q = input.value.trim();
      if (q.length < 2) { lastQ = ''; restore(); return; }
      if (q === lastQ) return;
      lastQ = q;
      t = setTimeout(function () { run(q); }, 300);
    });
    results.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.csearch-clear')) {
        input.value = ''; lastQ = ''; restore(); input.focus();
      }
    });
  })();

  /* ---- muted words & tags (settings card) ------------------------------ */
  (function () {
    var form = document.getElementById('mterm-form');
    var list = document.getElementById('mterm-list');
    if (!form || !list) return;
    function findChip(term) {
      var hit = null;
      list.querySelectorAll('.mterm-chip').forEach(function (c) {
        if (c.getAttribute('data-term') === term) hit = c;
      });
      return hit;
    }
    function emptyNote() {
      var em = list.querySelector('.mterm-empty');
      if (em) em.hidden = !!list.querySelector('.mterm-chip');
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = document.getElementById('mterm-input');
      var dur = document.getElementById('mterm-dur');
      var term = (input.value || '').trim();
      if (!term) return;
      var btn = form.querySelector('button[type="submit"]');
      if (busyIs(btn)) return;
      busyUntil(btn, postJson('/mute-term', { term: term, dur: dur.value }, 15000).then(function (res) {
        if (!res || !res.ok) { toast((res && res.error) || 'Could not mute that'); return; }
        input.value = '';
        var chip = findChip(res.term);
        if (chip) {                                  // re-mute: just restart the clock
          chip.querySelector('.mterm-left').textContent = res.left || '';
        } else {
          chip = document.createElement('span');
          chip.className = 'mterm-chip';
          chip.setAttribute('data-term', res.term);
          var b = document.createElement('b'); b.textContent = res.term;
          var l = document.createElement('span'); l.className = 'mterm-left'; l.textContent = res.left || '';
          var xf = document.createElement('form');
          xf.className = 'mterm-xf'; xf.method = 'post'; xf.action = '/unmute-term';
          var cs = form.querySelector('input[type="hidden"][name*="csrf" i]');
          if (cs) xf.appendChild(cs.cloneNode(true));          // keep the no-JS fallback valid
          var ht = document.createElement('input'); ht.type = 'hidden'; ht.name = 'term'; ht.value = res.term;
          var x = document.createElement('button');
          x.className = 'mterm-x'; x.type = 'submit'; x.title = 'Unmute';
          x.setAttribute('aria-label', 'Unmute ' + res.term); x.innerHTML = '&times;';
          xf.appendChild(ht); xf.appendChild(x);
          chip.appendChild(b); chip.appendChild(l); chip.appendChild(xf);
          list.insertBefore(chip, list.querySelector('.mterm-empty'));
        }
        emptyNote();
        toast('Muted "' + res.term + '" ' + (res.label || ''));
      }).catch(function () { toast('Could not mute that'); }));
    });
    list.addEventListener('submit', function (e) {
      var xf = e.target.closest ? e.target.closest('.mterm-xf') : null;
      if (!xf) return;
      e.preventDefault();
      var chip = xf.closest('.mterm-chip');
      var term = chip ? chip.getAttribute('data-term') : '';
      var x = xf.querySelector('.mterm-x');
      if (busyIs(x)) return;
      busyUntil(x, postJson('/unmute-term', { term: term }, 15000).then(function () {
        if (chip) chip.remove();
        emptyNote();
        toast('Unmuted "' + term + '"');
      }).catch(function () { toast('Could not unmute'); }));
    });
  })();

  /* w23 ("button says Follow next to someone I already follow"): one member can
     have MANY follow controls alive on one long-lived page — the profile button,
     list rows, and every post card's ⋯ menu. Each handler used to update only
     its own kind, so a follow made in one place left the others stale. This
     flips EVERY control for that user id; both follow paths call it. */
  function syncFollowUi(uid, following, name) {
    document.querySelectorAll('.js-followtoggle[data-id="' + uid + '"]').forEach(function (b) {
      b.setAttribute('data-following', following ? '1' : '0');
      /* Most js-followtoggle controls are MENU ROWS, so their label states the ACTION ("Unfollow
         @handle"). The hover card's is a block button stating the RELATIONSHIP, sitting directly
         under a handle already printed twice on the same card, so the menu wording is both
         redundant and long enough to wrap. It paints itself, the same opt-out the icon buttons
         already get in the .js-follow loop below. */
      if (b.classList.contains('hcard-follow')) {
        b.textContent = following ? 'Following' : 'Follow';
        b.classList.toggle('primary', !following);
        return;
      }
      b.textContent = (following ? 'Unfollow' : 'Follow') + ' @' + (b.getAttribute('data-name') || name || '');
    });
    document.querySelectorAll('.js-follow').forEach(function (f) {
      var idInput = f.querySelector('input[name="user_id"]');
      if (!idInput || String(idInput.value) !== String(uid)) return;
      var act = f.querySelector('input[name="action"]');
      if (act) act.value = following ? 'unfollow' : 'follow';
      var btn = f.querySelector('button');
      if (!btn || btn.classList.contains('cbtn') || btn.querySelector('svg')) return;   // icon buttons paint themselves
      // respect the surface's own label styles ("Following" on lists, "Unfollow"
      // on feed rows) by only flipping between the known states
      var cur = (btn.textContent || '').trim();
      if (following && cur === 'Follow') btn.textContent = 'Following';
      else if (!following && (cur === 'Following' || cur === 'Unfollow')) btn.textContent = 'Follow';
      btn.classList.toggle('primary', !following);
      btn.classList.toggle('gold-ghost', following);
    });
  }

  /* ---- mute / report --------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var ft = e.target.closest ? e.target.closest('.js-followtoggle') : null;
    if (ft) {
      e.preventDefault();
      var ftId = ft.getAttribute('data-id');
      var ftName = ft.getAttribute('data-name') || '';
      if (!ftId) return;
      var wasFollowing = ft.getAttribute('data-following') === '1';
      // keep every matching control on the page in sync (menus + forms, w23)
      var paintFT = function (nowF) { syncFollowUi(ftId, nowF, ftName); };
      // optimistic: flip + toast now, reconcile with the response, roll back if it dies
      paintFT(!wasFollowing);
      closePmenus(null);
      toast(!wasFollowing ? 'Following @' + ftName : 'Unfollowed @' + ftName);
      postJson('/follow', { user_id: ftId, action: wasFollowing ? 'unfollow' : 'follow', return: '/feed' }).then(function (res) {
        if (res && res.notice) { toast(res.notice); }   // e.g. "verify your email to follow more"
        var nowFollowing = res && typeof res.following === 'boolean' ? res.following : !wasFollowing;
        if (nowFollowing === wasFollowing) paintFT(nowFollowing);   // server said no (e.g. verify cap)
        if (window.__rovaReachRefresh) window.__rovaReachRefresh();   // sidebar counts follow the action
        // if we're on a profile, refresh its growth card (only changes if this author IS the profile owner)
        if (window.__rovaGrowthPoll) window.__rovaGrowthPoll();
        // unfollow on the home timeline drops their posts; follow leaves the feed alone
        if (!nowFollowing && /^\/(feed)?$/.test(location.pathname)) {
          document.querySelectorAll('.post .js-followtoggle[data-id="' + ftId + '"]').forEach(function (b) {
            var card = b.closest('.post');
            if (card) fadeRemove(card);
          });
        }
      }).catch(function (err) {
        if (!err || err.message === 'reauth') return;
        paintFT(wasFollowing);
        toast('Couldn’t update follow, check your connection');
      });
      return;
    }
    var mute = e.target.closest ? e.target.closest('.js-mute') : null;
    if (mute) {
      e.preventDefault();
      var muted = mute.getAttribute('data-muted') === '1';
      var action = muted ? 'unmute' : 'mute';
      var name = mute.getAttribute('data-name') || '';
      var isIconMute = !!mute.querySelector('svg');   // decide BEFORE the repaint wipes the svg
      var paintMute = function (nowMuted) {
        mute.setAttribute('data-muted', nowMuted ? '1' : '0');
        if (isIconMute) {                           // icon button (profile)
          /* Mirror views/profile.php EXACTLY -- the server render is the first paint and this is every
             paint after it, and the two disagreeing is the same class of bug as having no state at all.
             Three signals, none of them colour on its own: the glyph (person-with-X = muted), the
             shared on-disc, and aria-pressed. */
          mute.innerHTML = nowMuted ? ICO.muteUser : ICO.mute;
          mute.classList.toggle('on', nowMuted);
          mute.setAttribute('aria-pressed', nowMuted ? 'true' : 'false');
          mute.title = nowMuted ? 'Muted, tap to unmute' : 'Mute';
          mute.setAttribute('aria-label', nowMuted ? 'Muted. Unmute this member' : 'Mute this member');
        } else if (mute.classList.contains('menu-item')) {
          mute.textContent = nowMuted ? 'Unmute @' + name : 'Mute @' + name;
        } else {
          mute.textContent = nowMuted ? 'Unmute' : 'Mute';
        }
      };
      // optimistic: flip + toast now, reconcile with the response, roll back if it dies
      paintMute(!muted);
      closePmenus(null);
      toast(!muted ? 'Muted, hidden from your feed' : 'Unmuted');
      postJson('/mute', { user_id: mute.getAttribute('data-id'), action: action }).then(function (res) {
        var nowMuted = !!(res && res.muted);
        if (nowMuted === muted) paintMute(nowMuted);   // server disagreed
      }).catch(function (err) {
        if (!err || err.message === 'reauth') return;
        paintMute(muted);
        toast('Couldn’t update mute, check your connection');
      });
      return;
    }
    /* ---- the post bell: "ping me the moment they post" ------------------- */
    var bell = e.target.closest ? e.target.closest('.js-alerts') : null;
    if (bell) {
      e.preventDefault();
      if (bell.disabled) return;
      var bellOn = bell.getAttribute('data-on') === '1';
      var bellName = bell.getAttribute('data-name') || '';
      var paintBell = function (nowOn) {
        bell.setAttribute('data-on', nowOn ? '1' : '0');
        bell.setAttribute('aria-pressed', nowOn ? 'true' : 'false');
        bell.classList.toggle('bell-on', nowOn);
        bell.innerHTML = nowOn ? ICO.bellOn : ICO.bell;
        bell.title = nowOn ? 'Post alerts on, tap to turn off' : 'Notify me when @' + bellName + ' posts';
      };
      // optimistic: ring + toast now, reconcile with the response, roll back if it dies
      paintBell(!bellOn);
      if (!bellOn) {
        // the flashy bit: swing the bell + fire a golden ring burst off the button
        bell.classList.remove('bell-ring'); void bell.offsetWidth; bell.classList.add('bell-ring');
        toast('🔔 On! You’ll be notified the moment @' + bellName + ' posts');
      } else {
        toast('Bell off for @' + bellName);
      }
      var bq = bell._rxq = (bell._rxq || 0) + 1;
      postJson('/alerts', { user_id: bell.getAttribute('data-id'), action: bellOn ? 'off' : 'on' }).then(function (res) {
        var nowOn = !!(res && res.on);
        if (bell._rxq === bq && nowOn === bellOn) paintBell(nowOn);   // server disagreed
      }).catch(function (err) {
        if (!err || err.message === 'reauth') return;
        if (bell._rxq === bq) { paintBell(bellOn); toast('Couldn’t update the bell, check your connection'); }
      });
      return;
    }
    // thumbs-down on a post: soft-block (mute) the author and fade their posts away
    var hide = e.target.closest ? e.target.closest('.js-hide') : null;
    if (hide) {
      e.preventDefault();
      var huid = hide.getAttribute('data-user');
      var hname = hide.getAttribute('data-name') || 'this account';
      if (!huid) return;
      if (busyIs(hide)) return;
      if (!window.confirm('Hide posts from ' + hname + '? You can undo this anytime in Settings.')) return;
      busyUntil(hide, postJson('/mute', { user_id: huid, action: 'mute' }, 15000).then(function (res) {
        if (!res || !res.muted) return;
        // a tab the member is not on right now keeps its rows (the pager's panel cache): tell it this
        // author's posts are gone too, so a restored panel drops them the same way this page does
        try { window.__rovaFeedGone.u[huid] = Date.now(); } catch (e0) {}
        var gone = [];
        document.querySelectorAll('.post').forEach(function (card) {
          if (card.querySelector('.js-hide[data-user="' + huid + '"]')) gone.push(card);
        });
        gone.forEach(function (card) { fadeRemove(card); });
        toast('Hidden. You won’t see posts from ' + hname);
      }).catch(function (err) { if (!err || err.message !== 'reauth') toast('Couldn’t hide. Try again'); }));
      return;
    }
    var blk = e.target.closest ? e.target.closest('.js-block') : null;
    if (blk) {
      e.preventDefault();
      if (busyIs(blk)) return;
      var isBlocked = blk.getAttribute('data-blocked') === '1';
      if (!isBlocked && !window.confirm('Block this person? You’ll no longer see each other or be able to message.')) return;
      // Block only ever showed its result via the reload; on a dead cell that was NOTHING, and the
      // empty catch made failure silent too. Spinner for the flight, and a real failure toast.
      busyUntil(blk, postJson('/block', { user_id: blk.getAttribute('data-id'), action: isBlocked ? 'unblock' : 'block' }, 15000)
        .then(function () { window.location.reload(); }).catch(function (err) {
          if (err && err.message === 'reauth') return;
          toast('Couldn’t ' + (isBlocked ? 'unblock' : 'block') + ', check your connection');
        }));
      return;
    }
    var rep = e.target.closest ? e.target.closest('.js-report') : null;
    if (rep) {
      e.preventDefault();
      closePmenus(null);
      openReportSheet(rep.getAttribute('data-type'), rep.getAttribute('data-id'));
    }
  });

  /* ---- report reason picker ---------------------------------------------
     A report needs a reason the moderators can act on. Instead of a bare prompt, pick from the common
     categories (single-select) plus an optional detail box; Report stays disabled until there's something
     to send. Anonymous to the reported person. The server also rejects an empty reason. */
  var REPORT_REASONS = ['Spam', 'Harassment or bullying', 'Nudity or sexual content', 'Violence or threats',
                        'Hate speech', 'Self-harm or suicide', 'Scam or fraud', 'Something else'];
  var repSheet = null;
  function closeReportSheet() {
    if (!repSheet) return;
    repSheet.classList.remove('show');
    var el = repSheet; repSheet = null;
    setTimeout(function () { if (el && el.parentNode) el.parentNode.removeChild(el); }, 220);
    if (window.__rovaUnlockScroll) window.__rovaUnlockScroll();
  }
  function openReportSheet(type, id) {
    if (repSheet) closeReportSheet();
    var isUser = type === 'user';
    var isComment = type === 'comment';
    /* Copy matches the app's CommentRow prompt word for word -- "Report this comment?" /
       "Our moderators will take a look." -- so a member who reports on the phone and then on
       the web is told the same thing twice, not two different things. The reason picker stays,
       because that is what the web's post and profile reports already do and moderators act on
       the category; the app sends no reason and the server accepts that. */
    var m = document.createElement('div');
    m.className = 'rep-modal';
    m.setAttribute('role', 'dialog'); m.setAttribute('aria-modal', 'true'); m.setAttribute('aria-label', 'Report');
    var chips = REPORT_REASONS.map(function (r) {
      return '<button type="button" class="rep-reason" data-r="' + r.replace(/"/g, '&quot;') + '">' + r + '</button>';
    }).join('');
    m.innerHTML =
      '<div class="rep-card" role="document">' +
        '<h3 class="rep-title">Report ' + (isUser ? 'this account' : isComment ? 'this comment' : 'this post') + '</h3>' +
        '<p class="rep-sub">' + (isComment
          ? 'Pick what’s wrong. Our moderators will take a look, and your report is anonymous to them.'
          : 'Pick what’s wrong. Your report is anonymous to them.') + '</p>' +
        '<div class="rep-reasons">' + chips + '</div>' +
        '<textarea class="rep-detail input" rows="2" maxlength="200" placeholder="Add any detail (optional)"></textarea>' +
        '<div class="rep-actions">' +
          '<button type="button" class="btn gold-ghost rep-cancel">Cancel</button>' +
          '<button type="button" class="btn primary rep-send" disabled>Report</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(m);
    if (window.__rovaLockScroll) window.__rovaLockScroll();
    repSheet = m;
    requestAnimationFrame(function () { m.classList.add('show'); });

    var picked = '';
    var detail = m.querySelector('.rep-detail');
    var send   = m.querySelector('.rep-send');
    function refresh() { send.disabled = !(picked || detail.value.trim()); }
    m.querySelectorAll('.rep-reason').forEach(function (b) {
      b.addEventListener('click', function () {
        var on = !b.classList.contains('on');
        m.querySelectorAll('.rep-reason').forEach(function (o) { o.classList.remove('on'); });
        if (on) { b.classList.add('on'); picked = b.getAttribute('data-r'); } else { picked = ''; }
        refresh();
      });
    });
    detail.addEventListener('input', refresh);
    m.querySelector('.rep-cancel').addEventListener('click', closeReportSheet);
    m.addEventListener('click', function (e) { if (e.target === m) closeReportSheet(); });   // backdrop
    document.addEventListener('keydown', function esc(ev) {
      if (ev.key === 'Escape') { closeReportSheet(); document.removeEventListener('keydown', esc); }
    });
    // The app's success alert is "This comment has been reported to our moderators." -- say the same.
    var doneMsg = isComment ? 'This comment has been reported to our moderators.' : 'Thanks, we’ll take a look.';
    send.addEventListener('click', function () {
      var reason = picked + (detail.value.trim() ? (picked ? ': ' : '') + detail.value.trim() : '');
      if (!reason) { refresh(); return; }
      if (busyIs(send)) return;
      // (no label swap: .btn-busy's spinner carries the meaning, and a label mutated here would
      // read stale if the watchdog is what restores the button)
      // A NETWORK failure used to close the sheet and show the SUCCESS message -- on a dead cell
      // the report never arrived and the member was told it had. Keep the sheet open with their
      // reason intact and say so instead; only a response (any response) counts as sent.
      busyUntil(send, fetch('/report', {
        method: 'POST',
        headers: { 'X-CSRF-Token': csrf, 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
        body: new URLSearchParams({ type: type, id: id, reason: reason }),
        credentials: 'same-origin'
      }).then(function () { closeReportSheet(); toast(doneMsg); })
        .catch(function () { toast('Couldn’t send that report, check your connection'); }));
    });
  }

  /* ---- copy-link buttons ----------------------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.js-copylink') : null;
    if (!btn) return;
    e.preventDefault();
    // read the slide BEFORE closePmenus(): closing the panel must not be able to change the answer
    var url = window.__rovaSlideUrl(btn.getAttribute('data-url'), window.__rovaSlideOf(btn));
    closePmenus(null);
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(function () { toast('Link copied'); }).catch(function () {});
    } else {
      window.prompt('Copy this link:', url);
    }
  });

  /* ---- copy-embed buttons (the <iframe> player snippet) ---------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.js-copyembed') : null;
    if (!btn) return;
    e.preventDefault();
    var si   = window.__rovaSlideOf(btn);
    var code = window.__rovaSlideEmbed(btn.getAttribute('data-embed'), btn, si);
    // the Preview action must open the same slide the snippet does, or the confirmation lies
    var prev = window.__rovaSlideUrl(btn.getAttribute('data-preview'), si);
    closePmenus(null);
    function done() {
      // offer a one-tap preview of the player alongside the confirmation
      toast('Embed code copied, paste it on any site', 5000, prev ? { label: 'Preview', href: prev, target: '_blank' } : null);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done).catch(function () { window.prompt('Copy this embed code:', code); });
    } else {
      window.prompt('Copy this embed code:', code);
    }
  });

  /* ---- DM thread: real-time (AJAX send + poll, typing + seen) ---------- */
  var dmThread = document.getElementById('dm-thread');
  if (dmThread) {
    dmThread.scrollTop = dmThread.scrollHeight;
    if (window.__rovaRefreshCounts) window.__rovaRefreshCounts();   // opening the thread read it: clear the badge now
    var withId = dmThread.getAttribute('data-with');
    var lastId = parseInt(dmThread.getAttribute('data-last') || '0', 10);
    var dmInput = document.querySelector('.js-dm input[name="body"]');
    var seenEl = document.getElementById('dm-seen');
    var typingEl = null;

    function bubble(m) {
      var d = document.createElement('div');
      d.className = 'msg ' + (m.mine ? 'me' : 'them') + ' fade-in';
      d.setAttribute('data-mid', m.id || 0);
      // #589: data-ts feeds the day separators, title restores the exact time on hover
      d.setAttribute('data-ts', parseInt(m.ts, 10) || 0);
      var tt = dmTitle(m.ts); if (tt) d.setAttribute('title', tt);
      var txt = (m.body == null ? '' : String(m.body)).trim();
      var link = m.embed || m.card || '';
      d.innerHTML = (txt ? '<div class="bubble">' + dmBodyHtml(m.body) + '</div>' : '') +
                    (m.media ? '<div class="msg-media">' + m.media + '</div>' : '') +
                    (link ? '<div class="msg-link">' + link + '</div>' : '') +
                    '<span class="msg-time">' + escHtml(m.ago) + '</span>';
      return d;
    }
    function atBottom() {
      return dmThread.scrollHeight - dmThread.scrollTop - dmThread.clientHeight < 70;
    }
    function showTyping(on) {
      if (on) {
        if (!typingEl) {
          typingEl = document.createElement('div');
          typingEl.className = 'bubble them typing';
          typingEl.innerHTML = '<span></span><span></span><span></span>';
        }
        if (typingEl.parentNode !== dmThread) { dmThread.appendChild(typingEl); if (atBottom()) dmThread.scrollTop = dmThread.scrollHeight; }
      } else if (typingEl && typingEl.parentNode) {
        typingEl.parentNode.removeChild(typingEl);
      }
    }
    function showSeen(on) { if (seenEl) seenEl.hidden = !on; }

    var dmForm = document.querySelector('.js-dm');
    if (dmForm) {
      var dmFile = dmForm.querySelector('.dm-file');
      var dmPrev = dmForm.querySelector('.dm-attach-prev');
      var dmAttachBtn = dmForm.querySelector('.dm-attach');
      function clearDmPreview() { if (dmFile) dmFile.value = ''; if (dmPrev) { dmPrev.hidden = true; dmPrev.innerHTML = ''; } }
      if (dmAttachBtn && dmFile) {
        dmAttachBtn.addEventListener('click', function () { dmFile.click(); });
        dmFile.addEventListener('change', function () {
          var f = dmFile.files && dmFile.files[0];
          if (!f) { clearDmPreview(); return; }
          if (!/^image\//.test(f.type)) { toast('You can only send photos for now.'); clearDmPreview(); return; }
          if (f.size > 25 * 1024 * 1024) { toast('That photo is too large (max 25MB).'); clearDmPreview(); return; }
          dmPrev.innerHTML = '<img src="' + URL.createObjectURL(f) + '" alt=""><button type="button" class="dm-prev-x" aria-label="Remove photo">✕</button>';
          dmPrev.hidden = false;
        });
        dmPrev.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.dm-prev-x')) clearDmPreview(); });
      }
      dmForm.addEventListener('submit', function (e) {
        e.preventDefault();
        // Sending a DM is gated (handle_message_send -> Billing::requireActive). Reading the
        // thread is not, so nothing here is hidden -- the send is simply answered before the
        // message is optimistically appended and the input cleared.
        if (membershipStop()) { return; }
        var val = ((dmInput && dmInput.value) || '').trim();
        var hasFile = dmFile && dmFile.files && dmFile.files.length;
        // DMs have NO gif_url column: views/messages_thread.php renders one by running
        // extract_gif() over the BODY, so the URL has to be folded back into the text we send.
        // Only the composer changes -- it stops parading the raw URL at the member. What lands
        // in the DB is byte-for-byte what the old append-to-the-input behaviour stored.
        var pick = cgifTake(dmForm);
        var sendBody = pick.url ? (val ? val + ' ' + pick.url : pick.url) : val;
        if (!val && !hasFile && !pick.url) return;

        // With a photo: show it INSTANTLY from the local file + spinner, send in the
        // background (as fast as a text send), then settle the bubble on the response.
        if (hasFile) {
          var file = dmFile.files[0];
          var localUrl = URL.createObjectURL(file);
          var node = document.createElement('div');
          node.className = 'msg me dm-optim';
          node.innerHTML =
            // dmBodyHtml already swaps a Giphy URL for an <img>, so the optimistic bubble shows
            // the GIF straight away -- the same shape a reload renders from the stored body.
            (sendBody ? '<div class="bubble">' + dmBodyHtml(sendBody) + '</div>' : '')
            + '<div class="msg-media uploading"><img src="' + localUrl + '" alt=""><span class="up-spin" aria-label="Uploading"></span></div>'
            + '<span class="msg-time">Sending…</span>';
          var em0 = dmThread.querySelector('.empty'); if (em0) em0.remove();
          showSeen(false);
          dmSepAppend(dmThread, { ts: Math.floor(Date.now() / 1000) },
                      (typingEl && typingEl.parentNode) ? typingEl : null);   // #589
          if (typingEl && typingEl.parentNode) dmThread.insertBefore(node, typingEl);
          else dmThread.appendChild(node);
          dmThread.scrollTop = dmThread.scrollHeight;
          var fdm = new FormData(dmForm);            // snapshot (body + file) before we clear
          fdm.set('body', sendBody);                 // carries the GIF the picker attached
          if (dmInput) dmInput.value = ''; clearDmPreview();
          // fdm is a snapshot of the <form>, so it carries that form's baked _csrf -- and the body
          // beats the header in requireCsrf(). Re-stamp it per attempt or the retry repeats the 419.
          csrfSend(function (token) {
            fdm.set('_csrf', token);
            return fetch('/messages', { method: 'POST', headers: { 'X-CSRF-Token': token, 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }, body: fdm, credentials: 'same-origin' });
          })
            .then(function (r) { if (r.status === 419) { csrfStaleNotice(); throw new Error('reauth'); } if (r.status === 401) { window.location.reload(); throw new Error('reauth'); } return r.json(); })
            .then(function (res) {
              if (res && res.error) { node.classList.add('failed'); var te = node.querySelector('.msg-time'); if (te) te.textContent = 'Not sent'; toast(res.error); return; }
              if (res && res.message) {
                node.setAttribute('data-mid', res.message.id || 0);
                node.setAttribute('data-ts', parseInt(res.message.ts, 10) || Math.floor(Date.now() / 1000));
                var mm = node.querySelector('.msg-media'); if (mm) mm.classList.remove('uploading');
                var sp = node.querySelector('.up-spin'); if (sp) sp.remove();
                var ts = node.querySelector('.msg-time'); if (ts) ts.textContent = res.message.ago || 'now';
                lastId = Math.max(lastId, res.message.id || 0);
              }
            })
            .catch(function () { node.classList.add('failed'); var tf = node.querySelector('.msg-time'); if (tf) tf.textContent = 'Not sent'; });
          return;
        }

        // Text-only: the simple path.
        var btn = dmForm.querySelector('button[type="submit"]');
        var unbusy = busyStart(btn) || function () {};   // spinner for the flight; disabled alone showed nothing
        var fdt = new FormData(dmForm);
        fdt.set('body', sendBody);                   // carries the GIF the picker attached
        csrfSend(function (token) {
          fdt.set('_csrf', token);              // form snapshot: the body's token is the one read
          return fetch('/messages', {
            method: 'POST',
            headers: { 'X-CSRF-Token': token, 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
            body: fdt, credentials: 'same-origin'
          });
        }).then(function (r) {
          if (r.status === 419) { csrfStaleNotice(); throw new Error('reauth'); }
          if (r.status === 401) { window.location.reload(); throw new Error('reauth'); }
          return r.json();
        }).then(function (res) {
          unbusy();
          if (res && res.error) { pick.restore(); toast(res.error); return; }
          if (res && res.message) {
            var empty = dmThread.querySelector('.empty'); if (empty) empty.remove();
            showSeen(false); // resets until they read it
            dmSepAppend(dmThread, res.message, (typingEl && typingEl.parentNode) ? typingEl : null);   // #589
            if (typingEl && typingEl.parentNode) dmThread.insertBefore(bubble(res.message), typingEl);
            else dmThread.appendChild(bubble(res.message));
            lastId = Math.max(lastId, res.message.id);
            if (dmInput) dmInput.value = '';
            // the submit-capture clear ran 60ms in; this is the belt for the emptied box (no input event)
            if (dmInput && window.__rovaClearComposePreview) window.__rovaClearComposePreview(dmInput);
            dmThread.scrollTop = dmThread.scrollHeight;
          }
        }).catch(function (err) {
          unbusy(); pick.restore();
          if (!err || err.message !== 'reauth') toast('Couldn’t send, check your connection');   // text stays in the box
        });
      });

      // scroll-up history: pull older pages only when the reader reaches the top
      var oldestId = parseInt(dmThread.getAttribute('data-oldest') || '0', 10);
      var hasOlder = dmThread.getAttribute('data-more') === '1';
      var olderEl = document.getElementById('dm-older');
      var loadingOlder = false;
      function loadOlder() {
        if (loadingOlder || !hasOlder || !oldestId) return;
        loadingOlder = true;
        fetch(location.pathname + '?partial=older&before=' + oldestId, {
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin'
        }).then(function (r) { return r.json(); }).then(function (res) {
          loadingOlder = false;
          var msgs = (res && res.messages) || [];
          if (!msgs.length) { hasOlder = false; if (olderEl) olderEl.remove(); return; }
          var prevH = dmThread.scrollHeight, prevTop = dmThread.scrollTop;
          var anchor = olderEl ? olderEl.nextSibling : dmThread.firstChild;
          // #589: the marker that used to OPEN the thread can become redundant once older
          // history is spliced in above it, so remember it and re-decide afterwards.
          var oldSep = (anchor && anchor.classList && anchor.classList.contains('dm-sep')) ? anchor : null;
          var firstMsg = dmThread.querySelector('.msg[data-ts]');
          var oldFirstTs = firstMsg ? (parseInt(firstMsg.getAttribute('data-ts'), 10) || 0) : 0;
          var prevTs = 0;
          msgs.forEach(function (m) {
            var sep = dmSepBetween(prevTs, m.ts);
            if (sep) {
              var f = document.createElement('div'); f.innerHTML = sep;
              dmThread.insertBefore(f.firstChild, anchor);
            }
            prevTs = parseInt(m.ts, 10) || prevTs;
            var node = bubble(m);
            dmThread.insertBefore(node, anchor);
            if (m.rx) dmPaintRx(node, m.rx);
          });
          if (oldSep && !dmSepBetween(prevTs, oldFirstTs)) { oldSep.remove(); }
          oldestId = msgs[0].id;
          hasOlder = !!(res && res.more);
          if (!hasOlder && olderEl) olderEl.remove();
          dmThread.scrollTop = prevTop + (dmThread.scrollHeight - prevH);   // hold the reader's place
        }).catch(function () { loadingOlder = false; });
      }
      dmThread.addEventListener('scroll', function () { if (dmThread.scrollTop < 60) loadOlder(); });
    }

    // typing heartbeat while the user types (throttled)
    var lastPing = 0;
    if (dmInput) {
      dmInput.addEventListener('input', function () {
        var now = Date.now();
        if (now - lastPing < 2500) return;
        lastPing = now;
        fetch('/dm-typing', {
          method: 'POST',
          headers: { 'X-CSRF-Token': csrf, 'X-Requested-With': 'XMLHttpRequest' },
          body: new URLSearchParams({ with: withId }), credentials: 'same-origin'
        }).catch(function () {});
      });
    }

    /* SLOW-LINK (2026-08-10). The last unguarded poller in this file, and the tightest: a fixed 4s
       setInterval with no in-flight flag, no deadline and no hidden-tab skip. The bell poller one
       screen up (/poll-counts) and the comment sheet's own poll (/comments) were both given this
       exact treatment on 2026-08-09 and this one was missed -- it is the same shape, on a shorter
       period, on a surface a reader sits inside for minutes.
       WHY IT MATTERS ON A DEAD CELL: fetch() with no AbortController lives for as long as the
       platform holds a half-open socket, which is 60-120s on iOS. At a 4s period that is 15-30
       concurrent /dm-poll requests stacked on a link the reader is already unable to use, each one
       competing with the very messages and media they are waiting for. The empty .catch means it
       never LATCHES -- it hammers, which on a bad connection is its own kind of dead.
         dmBusy  one at a time, cleared in a trailing .then so a rejection releases it too (a flag
                 cleared only on the success path is a latch, which is the bug this must not become).
         8000    the standard read deadline. The abort also frees the socket, which is the point.
         hidden  a backgrounded thread shows nobody anything; the visibilitychange handler below
                 already polls the instant it comes back, so nothing is missed by skipping.
       Behaviour on a good link is unchanged: the response lands in ~40ms and the flag is clear long
       before the next tick. */
    var dmBusy = false;
    function dmPoll() {
      if (!withId || dmBusy || document.hidden) return;
      dmBusy = true;
      rfetch('/dm-poll?with=' + encodeURIComponent(withId) + '&after=' + lastId, {
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        credentials: 'same-origin'
      }, 8000).then(function (r) { return r.json(); }).then(function (res) {
        if (!res) return;
        if (res.messages && res.messages.length) {
          var stick = atBottom(), incoming = false;
          var empty = dmThread.querySelector('.empty'); if (empty) empty.remove();
          res.messages.forEach(function (m) {
            if (m.id <= lastId) return;
            dmSepAppend(dmThread, m, (typingEl && typingEl.parentNode) ? typingEl : null);   // #589
            if (typingEl && typingEl.parentNode) dmThread.insertBefore(bubble(m), typingEl);
            else dmThread.appendChild(bubble(m));
            lastId = Math.max(lastId, m.id);
            if (!m.mine) incoming = true;
          });
          if (stick) dmThread.scrollTop = dmThread.scrollHeight;
          if (incoming && window.__rovaChirp) window.__rovaChirp();   // a message just arrived
          if (window.__rovaRefreshCounts) window.__rovaRefreshCounts();   // just read new messages: refresh the badge
        }
        showTyping(!!res.typing);
        showSeen(!!res.seen);
        // live reactions: repaint pills from the fresh map (absent key = cleared)
        if (res.rx && typeof res.rx === 'object') {
          Array.prototype.forEach.call(dmThread.querySelectorAll('.msg[data-mid]'), function (el) {
            dmPaintRx(el, res.rx[el.getAttribute('data-mid')] || null);
          });
        }
      }).catch(function () {}).then(function () { dmBusy = false; });
    }
    setInterval(dmPoll, 4000);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) dmPoll(); });
  }

  /* ---- comments: post without a reload --------------------------------- */
  function jsAvatar(c) {
    var handle = c.username || '?';
    if (c.avatar_path) {
      // data-ini: the letter the document-level avatarGiveUp() swaps in if this photo never loads
      // (edge AND origin miss) -- the same monogram the no-photo branch below draws, never a "?" box.
      return '<img class="avatar sm" src="' + escHtml(c.avatar_path) + '" alt="' + escHtml(handle) + '"'
           + ' data-ini="' + escHtml(c.ident_gated ? '' : nameInitial(c.display_name, c.username)) + '">';
    }
    // display_name -> username -> '?', the SAME ladder avatar_img() walks server-side. Every payload
    // that reaches here already carries display_name -- the markup beside each of these six call
    // sites prints it -- so this needed no API change: POST /comment, GET /comments, /reactions,
    // /reposters and /gallery-item all send `display_name => $x ?: $username`.
    //
    // ident_gated is avatar_img()'s one exception (a shadow-suppressed roster row draws a BLANK
    // disc, never a gold "R" -- a placeholder that stops looking like a placeholder). No JSON
    // payload carries that key today: roster_identity() is called only from views/founders.php,
    // views/invite.php and views/_founders_roster_block.php, all server-rendered. The test is here
    // anyway so the client's rule is the whole rule rather than a subset of it -- if a roster ever
    // starts feeding a JS list, it degrades to blank the way the server does instead of failing open.
    var ini = c.ident_gated ? '' : nameInitial(c.display_name, c.username);
    // overflow:hidden for the same reason avatar_img() carries it: this can now be an EMOJI (there
    // are photo-less members whose display name opens with one), and the monogram span inherits its
    // font-size from the surrounding row -- fine for "K", too wide for U+1F49E, which painted
    // outside the coloured disc. Clip the glyph to the circle.
    return '<span class="avatar sm" style="display:inline-flex;align-items:center;justify-content:center;'
         + 'overflow:hidden;background:var(--gold-grad);color:#1a1306;font-weight:800">' + escHtml(ini) + '</span>';
  }

  // Enter posts a comment; Shift+Enter adds a newline. (The main composer keeps Enter as newline.)
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || e.shiftKey || e.isComposing) return;
    var ta = e.target;
    if (!ta || ta.tagName !== 'TEXTAREA') return;
    var form = ta.closest ? ta.closest('form.js-comment') : null;
    if (!form) return;
    e.preventDefault();
    if (typeof form.requestSubmit === 'function') form.requestSubmit();
    else { var b = form.querySelector('button[type="submit"]'); if (b) b.click(); }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.classList || !form.classList.contains('js-comment')) return;
    e.preventDefault();
    /* Before the optimistic clear below. Posting a comment is gated; READING them is not, so the
       panel, the roller and the permalink list are all left alone -- only the send is answered.
       Editing your own comment is a different control (.js-cedit) and is deliberately untouched. */
    if (membershipStop()) { return; }
    // In flight already? Drop the tap and KEEP whatever is typed -- the busy spinner on the send
    // button is telling them the first tap registered. Checked before the optimistic clear below
    // so a re-tap can neither double-post nor swallow text typed mid-flight.
    var sendBtn = form.querySelector('button[type="submit"]');
    if (busyIs(sendBtn)) return;
    var ta = form.querySelector('textarea');
    var val = ((ta && ta.value) || '').trim();
    // a bare GIF is a real comment (Comments::add: text OR a gif), so don't bail on empty text
    if (!val && !cgifUrl(form)) return;
    // optimistic: capture the payload, clear the box now, keep it usable; the
    // text comes back (with a toast) if the send dies.
    // SNAPSHOT FIRST: this form posts itself, so the hidden gif_url has to still be in the
    // FormData when we take it -- cgifTake() empties that field.
    var payload = new FormData(form);
    var pick = cgifTake(form);
    if (ta) ta.value = '';
    var restoreCmt = function () { if (ta && !ta.value) ta.value = val; pick.restore(); };
    // The badge moves NOW, and on this page so does the "N Comments" section header -- they are two
    // views of one number and engCommentPaint writes both, so they cannot drift apart. Local +1,
    // never res.count: the add endpoint's count is an uncorrected COUNT(*). The post id comes off
    // the form's own hidden field (post_single.php renders it) rather than off the page, so a
    // .js-comment form anywhere else keeps working.
    var pidInp = form.querySelector('input[name="post_id"]');
    var settle = engCommentBump(pidInp ? pidInp.value : '', 1);
    // The send button spins for the whole flight (busyUntil), and the 15s deadline means a dead
    // cell reaches the .catch below -- text restored, "check your connection" -- instead of
    // pinning the spinner for the platform's 60-120s socket timeout.
    busyUntil(sendBtn, postJson('/comment', payload, 15000).then(function (res) {
      if (res && res.error) { settle(false); restoreCmt(); toast(res.error); return; }       // e.g. "verify your email to comment"
      if (!res || !res.comment) { settle(false); restoreCmt(); return; }
      var c = res.comment;
      // A double-submit (double-Enter / double-tap send) answers BOTH requests with the SAME comment --
      // the server de-dupes to one id -- so never render a second copy (it showed twice until reload).
      // The roller-panel and gallery appends already guard this way.
      if (c.id && document.querySelector('.comment[data-comment="' + c.id + '"]')) {
        settle(false);   // the server made ONE comment out of two sends: take this send's +1 back off
        setReplyState(form, 0, '');
        if (ta) ta.value = '';
        return;
      }
      var list = document.getElementById('comment-list');
      var none = document.getElementById('no-comments');
      if (none) none.remove();
      var node = document.createElement('div');
      node.className = 'comment fade-in' + (c.parent_id ? ' is-reply' : '');
      node.setAttribute('data-comment', c.id);
      node.innerHTML =
        '<a href="/@' + encodeURIComponent(c.username) + '">' + jsAvatar(c) + '</a>' +
        '<div class="cbody"><div class="chead">' +
          '<a class="name" href="/@' + encodeURIComponent(c.username) + '">' + escHtml(c.display_name) + '</a>' +
          '<span class="meta">@' + escHtml(c.username) + ' · ' + escHtml(c.ago) + (c.edited ? ' · <span class="cmt-edited">Edited</span>' : '') + '</span>' +
        // 0133: gif_w/gif_h come back with the echo, so this optimistic row reserves the GIF's
        // box the same way the server-rendered list does -- otherwise the one comment that would
        // still jump under the member's finger is the one they just wrote.
        '</div><div class="ctext">' + bodyWithGif(c.body, c.gif_w, c.gif_h) + '</div>' +
        commentActsHtml(c, !!c.parent_id, true) + '</div>';
      if (list) {
        if (c.parent_id) {
          var parent = list.querySelector('.comment[data-comment="' + c.parent_id + '"]');
          var wrap = list.querySelector('.comment-replies[data-parent="' + c.parent_id + '"]');
          if (!wrap && parent) {
            wrap = document.createElement('div');
            wrap.className = 'comment-replies';
            wrap.setAttribute('data-parent', c.parent_id);
            parent.parentNode.insertBefore(wrap, parent.nextSibling);
          }
          (wrap || list).appendChild(node);
        } else {
          list.appendChild(node);
        }
        // past 5 rendered rows the thread becomes a scroll region; keep the
        // freshly posted comment in view once it does
        if (list.querySelectorAll('.comment').length > 5) {
          list.classList.add('cl-scroll');
          // the moment it becomes a scroll region it needs the gesture guard (idempotent; the
          // boot-time call covered the server-rendered case)
          if (window.__rovaGuardThread) window.__rovaGuardThread();
          node.scrollIntoView({ block: 'nearest' });
        }
      }
      setReplyState(form, 0, '');
      // The header was written HERE and the card badge was left alone, which is how the permalink
      // came to show two different numbers. Both now moved by the bump above; nothing to do but
      // release the hold.
      settle(true);
    }).catch(function (err) {
      settle(false);
      if (err && err.message === 'reauth') return;
      restoreCmt();
      toast('Couldn’t post that comment, check your connection');
    }));
  });

  /* ---- permalink thread: open on the most recent comment --------------- */
  (function () {
    // ...unless the URL already names one. /p/123#c<id> is a notification tap at ONE comment
    // (the deep-link handler near the end of this file places and holds it); jamming the scroller
    // to the bottom first would fight it, and the browser's own native jump to that id, for the
    // ~60ms before that handler runs. A deep link is a more specific instruction than "newest".
    if (/^#c\d+$/.test(location.hash || '')) return;
    var cl = document.getElementById('comment-list');
    // comments render oldest-first, so the newest sits at the bottom; when the
    // list is a scroll region, land the reader on the most recent one
    if (!cl || !cl.classList.contains('cl-scroll')) return;
    cl.scrollTop = cl.scrollHeight;

    /* ...AND STAY THERE WHILE THE THREAD FINISHES LAYING OUT (owner, 2026-08-08).
       This ran once, at DOMContentLoaded, against a scrollHeight that had not stopped growing:
       a comment GIF is a bare <img class="msg-gif"> with no dimensions (comment_gif_img in
       lib/view.php, sized `max-width:220px;width:100%` and NO height in rova.css), so it is 0px
       tall until it decodes. Measured on /p/15141: scrollHeight 988 at this line, 1219 once the
       two GIFs above landed -- so "the bottom" was 231px short of the bottom and the newest
       comment, the one this line exists to show, was left below the fold of its own scroller.
       Same cause and same cure as the #c<id> deep link at the end of this file: re-pin as the
       media settles, and let the reader end it. Any wheel / touch / pointer / key event means
       they are reading, and re-pinning a moving list under a reader is its own bug. */
    var INPUT = ['wheel', 'touchstart', 'pointerdown', 'mousedown', 'keydown'];
    var ro = null, timer = null;
    function unpin() {
      if (ro) { try { ro.disconnect(); } catch (e) {} ro = null; }
      if (timer) { clearTimeout(timer); timer = null; }
      for (var i = 0; i < INPUT.length; i++) window.removeEventListener(INPUT[i], unpin, true);
    }
    for (var i = 0; i < INPUT.length; i++) window.addEventListener(INPUT[i], unpin, true);
    if (window.ResizeObserver) {
      try {
        ro = new ResizeObserver(function () { cl.scrollTop = cl.scrollHeight; });
        var media = cl.querySelectorAll('img, video, iframe');
        for (var j = 0; j < media.length; j++) ro.observe(media[j]);
      } catch (e) { ro = null; }
    }
    timer = setTimeout(unpin, 8000);
  })();

  /* ---- permalink "which post is this?" strip (Sherry, 2026-07-25) --------
     Notification links land at #comments with the post scrolled clean off the
     top — readers saw a bare comment list with no clue what it belonged to.
     While the post card is off-screen ABOVE, show the sticky context strip;
     tapping it rides back up to the post. */
  (function () {
    var strip = document.getElementById('post-context');
    if (!strip || !('IntersectionObserver' in window)) return;
    var card = document.querySelector('.layout-main > .post, [data-pfeed-open] > .post');
    if (!card) return;
    /* THE POST'S TOP EDGE, NOT THE CARD AT scrollTop 0. Owner, 2026-08-15: "the chevron button
       doesn't scroll all the way back to the top."

       Measured on /p/43494, chromium 1440x900 and 390x740: block:'start' put the card's top edge
       at viewport y=0, and .topbar is position:sticky, 65px tall, sitting at 0..65 -- so the
       author row the strip is showing a copy of landed BEHIND the header, and the page stopped
       73px short of the offset it was asked for (landed scrollY 79, the post's top wants 2).
       .post carries scroll-margin-top:0, so nothing held it clear of the header.

       THE CLEARANCE IS READ AT CLICK TIME, NEVER CACHED. The header is a live box -- the locale
       switcher adds a pill row, a banner can appear inside it -- and the ResizeObserver near the
       top of this file republishes --topbar-h when it genuinely measures something else, so a
       number captured at init is stale by the time a reader gets deep enough into the comments
       for this strip to exist. Same var, same +12 gap as onbScrollTo: one scroll rule for the
       whole site, and 65 is the :root fallback in rova.css.

       scroll-margin-top rather than a window.scrollTo, because the browser must keep picking the
       scroller: `card` is in the document flow on /p/<id>, but the selector above also matches a
       card inside an open pfeed, whose scroller is NOT the window. Honoured by scrollIntoView in
       both engines -- verified landing error 0px, chromium and webkit, 1440 and 390. */
    strip.addEventListener('click', function () {
      var head = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--topbar-h'), 10);
      if (!isFinite(head) || head <= 0) { head = 65; }
      var smooth = 'smooth';
      try {
        if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) { smooth = 'auto'; }
      } catch (e) {}
      try { card.style.scrollMarginTop = (head + 12) + 'px'; } catch (e) {}
      try { card.scrollIntoView({ behavior: smooth, block: 'start' }); } catch (e) { card.scrollIntoView(); }
    });

    /* ---- and the post's music player rides with it (owner, 2026-08-06) ----------------------
       "The little header that pops up should show a player here and if the user is play the
       player it should be synced."

       ONE PLAYER, PINNED -- NOT A SECOND ONE, AND NOT RE-PARENTED. `player` below is the post
       card's own .embed-music node. It is never removed from .post-main and never moved: pinning
       is a class that switches it to position:fixed under the strip, releasing is the class
       coming off. Two iframes would be two audio streams with no achievable sync, and MOVING an
       iframe in the DOM reloads it (the track restarts), so both were non-starters. Because it
       is the same element, "synced" is not a feature that can drift -- there is nothing to sync.
       A CSS position/height change does not reload a frame: measured, 0 load events across 8
       height changes on a live Spotify embed, same node identity throughout.

       WHENEVER THE STRIP IS UP, NOT ONLY WHILE PLAYING. Play state is unreadable here: Spotify
       and SoundCloud are cross-origin and their iframe APIs need a script our CSP blocks, and
       relaxing the CSP for a nicety is not on the table. The available proxy -- focus moving into
       the iframe -- is wrong in the direction that costs the most: it goes false as soon as the
       reader clicks anything else on the page, so a PLAYING player would unpin itself, which is
       precisely the bug being fixed. So it pins unconditionally, and the two costs of pinning a
       silent player are paid instead: it is compact (96px, measured -- see rova.css) and it is
       dismissible, sticky for the rest of the page visit. */
    var player = card.querySelector('.embed-music');
    var spacer = null, unpin = null, pinned = false, dismissed = !player, up = false;

    /* THE SCROLL MUST NOT MOVE WHEN THE PIN TOGGLES, AND ORDER IS THE WHOLE FIX.
       Owner, 2026-08-06: "swiping down is almost impossible, it just rapidly swipes back; if I
       swipe really fast it finally works."

       Measured cause, reproduced by running pin()'s old operation order at scrollTop 500 on
       /p/14799: the moment the player went position:fixed the document lost its 354px and
       scrollHeight fell 1505 -> 1151, so the browser CLAMPED scrollTop 500 -> 411; sizing the
       spacer afterwards put the height back but nothing puts the scroll back, and the net move
       was 257px. Every toggle teleported the page, which pulled the card back into view, which
       released, which grew the document, which pushed it out again -- once per frame. A fast
       fling outruns it, exactly as he described.

       A per-frame sampler reports scrollHeight as CONSTANT through all of this and is worthless
       here: the shrink and the restore both happen inside one task, so no rAF ever observes the
       intermediate value. Only bracketing the DOM writes themselves shows it.

       TWO RULES, AND BOTH ARE NEEDED.

       1. ORDER. The document may grow first and shrink back; it may never shrink first and grow
          back. Growing clamps nothing. So pin() turns the spacer on BEFORE the player leaves the
          flow, and release() returns the player BEFORE the spacer collapses. At no instant is the
          document shorter than it started, so there is no clamp to undo.

       2. THE SPACER IS EXACT BY CONSTRUCTION, NOT BY MEASUREMENT. Deriving its height from a
          card-height delta was 8px out and left scrollHeight varying by 8px per toggle, because
          the delta was measured with no spacer in the tree: inserting a block between the player
          and its next sibling STOPS their 10px margins collapsing, so the act of inserting it
          changes the height it is trying to compensate for. Copying the player's own margins onto
          the spacer sidesteps the circularity -- the spacer then occupies the player's box
          exactly, against the very same neighbours, and collapses exactly as the player did. */
    function fillSlot() {
      var cs = getComputedStyle(player);
      spacer.style.height = player.offsetHeight + 'px';   // read while still IN the flow
      spacer.style.marginTop = cs.marginTop;
      spacer.style.marginBottom = cs.marginBottom;
      spacer.classList.add('on');
    }
    function emptySlot() {
      spacer.classList.remove('on');
      spacer.style.height = '0px';
      spacer.style.marginTop = '0px';
      spacer.style.marginBottom = '0px';
    }

    // The dock lines up with the strip by MEASURING it, not by re-deriving its box: the two carry
    // the same left/right/max-width/margin rule, and a computed copy drifts the moment a scrollbar
    // changes clientWidth (seen at 768: computed 84px right, actual 76.5px).
    function dockVars() {
      var r = strip.getBoundingClientRect();
      var s = document.documentElement.style;
      // Both offsets are LEFT/TOP-based on purpose: `right` resolves against the initial
      // containing block, whose width is not the number any DOM read hands you (clientWidth vs
      // innerWidth disagree by the scrollbar), and a 15px error puts the control off the card.
      s.setProperty('--pctx-dock-top', Math.round(r.bottom + 6) + 'px');
      s.setProperty('--pctx-unpin-left', Math.round(r.right - 32) + 'px');
      return { top: r.bottom + 6, left: r.left };
    }

    function pin() {
      if (pinned || dismissed) return;
      // The immersive viewer is its own full-screen surface at z-index 205 with its own idle-fade
      // rules for .embed-music; a page-level dock underneath it is invisible at best.
      /* ...AND THE QUESTION IS "IS THE VIEWER UP", NOT "DOES THE ELEMENT EXIST"  (2026-08-17, round E).
         This read `document.querySelector('.pfeed')`, which is a different question and has been the
         wrong one all along: build() is idempotent (`if (box) return box`) and close() never removes
         the box, so from the reader's FIRST open onwards .pfeed is in the DOM for the life of the
         page -- and this dock then refused to pin for the rest of the session, viewer open or not.
         Latent until now because the only way to reach it was open-the-viewer-then-scroll-to-a-music
         embed. Round E's idle pre-build makes the shell exist from page load, which would have turned
         a latent bug into an every-page one, so it is fixed here rather than worked around there.
         .show is the class every other gate in this file already asks for (pfStillSync, hfLive,
         recyclePfeedMedia, _memGuard, the pump). */
      if (document.querySelector('.pfeed.show')) return;
      var want = dockVars();
      if (!spacer) {
        spacer = document.createElement('div');
        spacer.className = 'pctx-spacer';
        if (player.parentNode) player.parentNode.insertBefore(spacer, player.nextSibling);
      }
      // hold the player's place FIRST: the document grows by the player's box here and shrinks by
      // exactly the same box on the next two lines, so it never dips below where it started and
      // scrollTop is never clamped. Swapping these three statements IS the scroll bug.
      fillSlot();
      card.classList.add('pctx-pinhost');     // drops the backdrop-filter that was the containing block
      player.classList.add('pctx-pinned');
      // ASSERT THE ESCAPE. If some future ancestor rule re-establishes a containing block, the
      // player lands hundreds of px away and scrolls with the card; better to show no dock at all
      // than a stray player wandering the page. Never retried, so this costs one layout, once.
      // The tolerance absorbs the 8px dock-in animation, nothing more -- a contained player misses
      // by the card's whole scroll offset.
      var got = player.getBoundingClientRect();
      if (Math.abs(got.top - want.top) > 26 || Math.abs(got.left - want.left) > 26) {
        player.classList.remove('pctx-pinned');   // undo in the mirror order: grow, then shrink
        card.classList.remove('pctx-pinhost');
        emptySlot();
        dismissed = true;
        return;
      }
      if (!unpin) {
        unpin = document.createElement('button');
        unpin.type = 'button';
        unpin.className = 'pctx-unpin';
        unpin.setAttribute('aria-label', 'Hide the pinned player');
        // A GLYPH, NOT A CHARACTER. Owner, 2026-08-06: "the close x isn't symmetrically centered
        // in the circle." It was not: the painted ink sat 0.670px LOW (measured by centroid at
        // DPR 6; horizontally it was fine at 0.010px). `×` U+00D7 is text, and a flex box centres
        // the LINE BOX, not the ink -- the character rides a baseline with its own asymmetric side
        // bearings, so no line-height can centre it, and the error rides the font, not our CSS.
        // These two lines are symmetric about (12,12) in a square viewBox, and stroke-linecap
        // round grows both ends of both lines equally, so the ink centre IS the viewBox centre by
        // construction, at any size and in any font.
        unpin.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" '
          + 'stroke-width="2.6" stroke-linecap="round" aria-hidden="true">'
          + '<line x1="7" y1="7" x2="17" y2="17"/><line x1="17" y1="7" x2="7" y2="17"/></svg>';
        unpin.addEventListener('click', function (e) {
          e.stopPropagation();
          release();
          dismissed = true;                     // sticky for this page visit
        });
        document.body.appendChild(unpin);
      }
      unpin.hidden = false;
      pinned = true;
    }

    function release() {
      if (!pinned) return;
      pinned = false;
      // mirror of pin(): the player rejoins the flow (document grows) BEFORE the spacer collapses
      // (document shrinks back). Never shorter than it started, so never clamped.
      player.classList.remove('pctx-pinned');
      card.classList.remove('pctx-pinhost');
      if (spacer) emptySlot();
      if (unpin) unpin.hidden = true;
    }

    /* HYSTERESIS: TWO triggers, deliberately non-overlapping. One threshold cannot both pin and
       unpin -- at the boundary any residual layout noise re-crosses it and the two states chatter.
       The card must be a clear HYST px past the top before the dock engages, and must be fully
       back on screen before it lets go, so no scroll position satisfies both. rootMargin sets the
       root's top edge to -M, so "left via the top" means bottom < -M: M = HYST arms the pin, M = 0
       arms the release. The strip rides the same state as the player -- two surfaces that appear
       together must never disagree about when. */
    var HYST = 28;
    function apply(next) {
      if (next === up) return;
      up = next;
      strip.hidden = !up;
      if (up) pin(); else release();
    }
    new IntersectionObserver(function (es) {
      var en = es[0];
      if (en && !en.isIntersecting && en.boundingClientRect.bottom < 0) apply(true);
    }, { threshold: 0, rootMargin: HYST + 'px 0px 0px 0px' }).observe(card);
    new IntersectionObserver(function (es) {
      var en = es[0];
      if (en && en.isIntersecting) apply(false);
    }, { threshold: 0 }).observe(card);

    // the card reflows at a new width, so the slot it leaves behind is a different size; fillSlot()
    // reads the player's box, which is only its real box while it is IN the flow, so drop the pin
    // and retake it in this one task (nothing paints in between).
    window.addEventListener('resize', function () { if (pinned) { release(); pin(); } });
  })();

  /* ---- load more (popular timeline) ------------------------------------ */
  var moreBtn = document.getElementById('load-more');
  if (moreBtn) {
    moreBtn.addEventListener('click', function () {
      var offset = parseInt(moreBtn.getAttribute('data-offset'), 10) || 0;
      moreBtn.disabled = true;
      moreBtn.textContent = 'Loading…';
      // SLOW-LINK (2026-08-09): deadlined, so the button cannot sit dead on "Loading…" for the
      // 60-120s a platform spends on a half-open socket. The .catch below already restores it --
      // it just had no way to ever run. rfetch's non-2xx rejection reaches it too, where before a
      // 5xx HTML body only failed later, inside r.json(), by luck.
      rfetch('/partial-popular?offset=' + offset, {
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        credentials: 'same-origin'
      }, 8000).then(function (r) { return r.json(); }).then(function (data) {
        var tl = document.getElementById('timeline');
        if (data.html && tl) {
          var frag = document.createElement('div');
          frag.innerHTML = data.html;
          while (frag.firstChild) {
            if (frag.firstChild.nodeType === 1) frag.firstChild.classList.add('fade-in');
            tl.appendChild(frag.firstChild);
          }
          initCarousels(tl);
          initEmbeds(tl);
        }
        offset += 8;
        moreBtn.setAttribute('data-offset', String(offset));
        if (data.more) {
          moreBtn.disabled = false;
          moreBtn.textContent = 'Load more';
        } else {
          moreBtn.parentNode.removeChild(moreBtn);
        }
      }).catch(function () {
        moreBtn.disabled = false;
        moreBtn.textContent = 'Load more';
      });
    });
  }

  /* ---- invite friends (native share sheet + per-app links) ------------- */
  document.addEventListener('click', function (e) {
    var box = e.target.closest ? e.target.closest('.invite') : null;
    if (!box) return;
    var url = box.getAttribute('data-url');
    var text = box.getAttribute('data-text') || '';
    var fb = e.target.closest('.js-fb');
    if (fb) {
      // on mobile, open the Facebook app composer; desktop falls through to the web sharer
      if (/Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
        e.preventDefault();
        window.location.href = fb.getAttribute('data-fb');
      }
      return;
    }
    var ig = e.target.closest('.js-ig');
    if (ig) {
      e.preventDefault();
      // no web share-intent exists for Instagram (see the PHP-side note on this tile) -- copy the
      // link so it's ready to paste, then hand off to the Story camera on mobile. Desktop has no app
      // to open, so it copies only; the toast still tells them what to do with it.
      var mobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
      var afterCopy = function () {
        toast(mobile ? 'Link copied, paste it on the sticker' : 'Link copied. Paste it on Instagram');
        if (mobile) { window.location.href = ig.getAttribute('data-ig'); }
      };
      if (navigator.clipboard) { navigator.clipboard.writeText(url).then(afterCopy, afterCopy); }
      else { afterCopy(); }
      return;
    }
    if (e.target.closest('.js-invite-share')) {
      e.preventDefault();
      // native share sheet (iOS/Android Safari + Chrome) -> Messages, contacts, any app
      if (navigator.share) {
        navigator.share({ title: 'Rova', text: text, url: url }).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(text + ' ' + url).then(function () { toast('Invite link copied. Paste it anywhere'); });
      } else {
        window.prompt('Copy this link:', url);
      }
    } else if (e.target.closest('.js-invite-copy')) {
      e.preventDefault();
      if (navigator.clipboard) navigator.clipboard.writeText(url).then(function () { toast('Link copied'); });
      else window.prompt('Copy this link:', url);
    }
  });

  /* ---- fit a single-photo/video post to its own aspect (capped) so portraits
     show tall instead of being cropped to a landscape strip ----------------- */
  (function () {
    // 4:5 portrait .. 3:1 landscape. MUST STAY IN LOCKSTEP WITH views/_post.php's $arMin/$arMax: the PHP
    // stamps --ar server-side for the first paint and this sweep re-stamps it once the image decodes, so a
    // narrower cap here would just re-break the box a frame later. The landscape cap was 1.91 (the OG card
    // ratio), which made the box narrower than genuinely wide media and let object-fit:cover slice its left
    // and right edges off (report: a 2036x772 = 2.64 betting slip). See the PHP for the full reasoning.
    var AR_MIN = 0.8, AR_MAX = 3.0;
    /* REMOVED 2026-09-01: arBias(), BIAS_DIST=1.23 and a local aspectDist() used to sit here and toggle
       `media-top-bias` on `.media` from fit()/fitCarousel() below, which was the JS half of rova.css's
       `.post .media.media-top-bias img,video{object-position:50% 15%}` (owner, 2026-08-23, on a portrait
       feed post: "cutting off peoples heads"). The owner asked for a CENTRED crop twice the same day --
       the grid tile first, then "the same for timeline media" -- so the CSS rule went and the crop anchor
       is now a plain `object-position:50% 50%` on the two cover rules. That left this gate with no
       consumer at all (the class was never server-rendered and nothing else read it), so it was deleted
       rather than left computing a class nobody reads. See the tombstone in assets/rova.css for the full
       history, the measurements, and what a revert would need. Note the pfeed viewer has its OWN
       aspectDist() further down this file -- a separate copy in a different IIFE, deliberately untouched. */
    /* ATTRIBUTE FALLBACK, not a nicety. Since 2026-08-08 views/_post.php ships feed video as
       preload="none" whenever it has a poster AND stamped width/height, so el.videoWidth is 0
       until app.js decides to promote the clip -- and on iOS Safari it is 0 until the clip has
       actually PLAYED, which is why the PHP stamps --ar server-side in the first place. The
       stamped width/height attributes are the same intrinsic dimensions the poster carries, so
       read them when the element has nothing of its own. Same pattern as the sweeps at the
       carousel pin and the pfeed fit. */
    function arDim(el, a, live) {
      return live || parseInt(el.getAttribute(a), 10) || 0;
    }
    function arOf(el) {
      var w = arDim(el, 'width', el.naturalWidth || el.videoWidth), h = arDim(el, 'height', el.naturalHeight || el.videoHeight);
      if (!w || !h) return '';
      return Math.max(AR_MIN, Math.min(AR_MAX, w / h)).toFixed(4);
    }
    // past AR_MAX the box can't match the picture at all, so letterbox (contain) instead of cropping it.
    // ALSO (2026-10-11): a CLIP hinted data-fit="contain" that is taller than AR_MIN letterboxes -- a room /
    // co-host / battle replay must show every person (lib/live.php compositeReplayFit). Video only, exactly
    // as views/_post.php $mediaFit stamps it server-side; hinted photos keep the cover crop.
    function arFit(el, unit) {
      var w = arDim(el, 'width', el.naturalWidth || el.videoWidth), h = arDim(el, 'height', el.naturalHeight || el.videoHeight);
      if (!w || !h) return;
      var tallWhole = el.tagName === 'VIDEO' && el.getAttribute('data-fit') === 'contain' && w / h < AR_MIN - 0.0001;
      unit.classList.toggle('ar-fit', w / h > AR_MAX + 0.0001 || tallWhole);
    }
    function fit(el) {
      var media = el && el.closest ? el.closest('.post .media') : null;
      if (!media || media.classList.contains('carousel')) return;
      var ar = arOf(el); if (ar) media.style.setProperty('--ar', ar);
      arFit(el, media);
    }
    // A carousel takes ITS OWN aspect from the FIRST slide (Instagram-style: one box for the whole set),
    // so a portrait-led carousel shows TALL instead of cover-cropping every slide into a landscape strip.
    function fitCarousel(el) {
      var carousel = el && el.closest ? el.closest('.post .media.carousel') : null;
      var slide = el && el.closest ? el.closest('.cslide') : null;
      if (!carousel || !slide || slide !== carousel.querySelector('.cslide')) return;   // first slide only
      var ar = arOf(el); if (ar) carousel.style.setProperty('--ar', ar);
      arFit(el, carousel);
    }
    function fitAny(el) {
      var media = el && el.closest ? el.closest('.post .media') : null;
      if (!media) return;
      if (media.classList.contains('carousel')) fitCarousel(el); else fit(el);
    }
    // capture phase so it also catches media in posts injected later (poll / load-more)
    document.addEventListener('load', function (e) { if (e.target && e.target.tagName === 'IMG') fitAny(e.target); }, true);
    document.addEventListener('loadedmetadata', function (e) { if (e.target && e.target.tagName === 'VIDEO') fitAny(e.target); }, true);
    Array.prototype.forEach.call(document.querySelectorAll('.post .media:not(.carousel) img'), function (im) {
      if (im.complete && im.naturalWidth) fit(im);   // already-decoded on first paint
    });
    Array.prototype.forEach.call(document.querySelectorAll('.post .media.carousel .cslide:first-child img'), function (im) {
      if (im.complete && im.naturalWidth) fitCarousel(im);
    });
    // VIDEOS need the same first-paint sweep: a video's loadedmetadata can fire BEFORE this listener is
    // attached (fast/cached metadata), and unlike an image there was no catch-up pass -- so --ar stayed
    // unset and the portrait clip fell back to the landscape 3/2 default (cover-cropped to a wide strip).
    Array.prototype.forEach.call(document.querySelectorAll('.post .media:not(.carousel) video'), function (v) {
      if (v.videoWidth) fit(v);   // metadata already available on first paint
    });
    Array.prototype.forEach.call(document.querySelectorAll('.post .media.carousel .cslide:first-child video'), function (v) {
      if (v.videoWidth) fitCarousel(v);
    });
  })();

  /* ---- pan a tap-zoomed portrait photo (.pf-vscroll) by translating the IMAGE (--pf-pan), so the
     toolbar (which is absolute INSIDE the slide) stays put instead of scrolling away with the picture.
     Wheel + drag (mouse/touch); the pan is clamped to the image, and a wheel/swipe PAST an edge falls
     through so the immersive feed scrolls to the next post. Only ever active on a tapped-zoomed photo. -- */
  (function () {
    function unitAt(t) {
      var u = (t && t.closest) ? t.closest('.pf-vscroll') : null;
      return (u && u.closest('.pfeed')) ? u : null;
    }
    function panRange(u) {                                  // most-negative pan (image bottom flush); <= 0
      var im = u.querySelector('img'); if (!im) return 0;
      return Math.min(0, u.clientHeight - im.getBoundingClientRect().height);
    }
    function panGet(u) { return parseFloat(u.style.getPropertyValue('--pf-pan')) || 0; }
    function panSet(u, v) { var mn = panRange(u); v = Math.max(mn, Math.min(0, v)); u.style.setProperty('--pf-pan', v + 'px'); return v; }
    // dir>0 = revealing LOWER content (pan toward the most-negative bound); at that edge, hand off to the feed
    function atEdge(u, dir) { var mn = panRange(u), cur = panGet(u); return dir > 0 ? cur <= mn + 0.5 : cur >= -0.5; }
    document.addEventListener('wheel', function (e) {
      if (e.ctrlKey) return;                                // a trackpad pinch / page zoom, never a pan
      var u = unitAt(e.target); if (!u || panRange(u) >= 0) return;
      if (atEdge(u, e.deltaY)) return;                      // at the edge in this direction -> let the feed scroll
      e.preventDefault();
      panSet(u, panGet(u) - e.deltaY);
    }, { passive: false });
    // touch drag (drag DOWN reveals the TOP). Past an edge, drop the drag so a continued swipe advances the feed.
    var du = null, ty0 = 0, tp0 = 0;
    document.addEventListener('touchstart', function (e) {
      var u = unitAt(e.target); if (!u || panRange(u) >= 0) { du = null; return; }
      du = u; ty0 = e.touches[0].clientY; tp0 = panGet(u);
    }, { passive: true });
    document.addEventListener('touchmove', function (e) {
      if (!du) return;
      var dy = e.touches[0].clientY - ty0;
      if (atEdge(du, -dy)) { du = null; return; }           // past the edge: release to the feed's own scroll
      e.preventDefault();
      panSet(du, tp0 + dy);
    }, { passive: false });
    document.addEventListener('touchend', function () { du = null; }, { passive: true });
    // desktop click-drag
    var mu = null, my0 = 0, mp0 = 0;
    document.addEventListener('mousedown', function (e) {
      var u = unitAt(e.target); if (!u || panRange(u) >= 0) return;
      mu = u; my0 = e.clientY; mp0 = panGet(u); e.preventDefault();
    });
    document.addEventListener('mousemove', function (e) { if (mu) panSet(mu, mp0 + (e.clientY - my0)); });
    document.addEventListener('mouseup', function () { mu = null; });
  })();

  /* ---- pan a cover-zoomed PHOTO within its crop (--pf-panx sideways, --pf-pany up-down) -------------
     Web report #25 (a LANDSCAPE photo on a portrait phone "should be pannable left and right") and web
     report #50 (the owner, on a LANDSCAPE phone: "when this photo and photos like it are zoomed in they
     should be able to be panned up and down to see the top and bottom"). ONE panner; the axis is MEASURED,
     never assumed.

     WHICH AXIS ACTUALLY CROPS: a cover zoom matches one axis EXACTLY and crops the OTHER, and which one
     that is depends on the photo vs the viewport -- the SAME photo crops left/right on a portrait phone
     and top/bottom on a landscape one. #50's photo (/p/8480, 1440x1439) at 844x390 draws 844x843: 453px
     of picture hidden top+bottom and ZERO horizontal slack, while the same photo at 390x844 draws 845x844
     -- 455px hidden left+right and nothing vertical. The old code hard-coded the sideways case
     (`!portrait && !wideView`), so the vertical crop had no panner at all. over() now measures the drawn
     picture against the unit box and marks whichever axis genuinely overflows (pf-hpan / pf-ypan); since
     a cover fit can only crop one, at most one is ever on.

     WHY A TRANSLATE HERE, BUT object-position ON VIDEO (--pf-vpos/--pf-hpos, the panner above): the two
     fills are genuinely different mechanisms, so the same lever does not work for both. A pf-vfill CLIP is
     object-fit:COVER -- the <video> box IS the screen and the crop happens INSIDE it, so translating the
     box drags black in from the edge; object-position walks the crop window instead. A pf-zoomable PHOTO
     is object-fit:CONTAIN scaled up by --pf-cover, so its drawn picture really does OVERFLOW the unit and
     sliding it really does reveal more picture -- whereas object-position would only move the picture
     inside its own contain-fitted box, which has no slack on the cropped axis at all and so would do
     nothing. Measure the mechanism, not just the axis.

     CONTAINED IS NEVER PANNABLE: pf-uncrop (tap-to-zoom-out, and a portrait photo's default on a wide
     viewport) replaces the transform with scale(1) -- nothing is hidden, so over() reads 0 on both axes
     and the unit stays unmarked. pf-vscroll (the tap-zoom fit-width scroller) owns its own --pf-pan and
     is skipped here so the two panners can never fight over the same image.

     GESTURE ARBITRATION vs the pfeed's own vertical paging (the report #46 class of conflict):
       1. arm only over a unit that MEASURABLY crops on some axis right now (re-measured every gesture);
       2. claim the touch once, after 8px of travel, and only when the drag is clearly ALONG that axis
          (|along| > |across| * 1.2); anything else is released to the pager for the rest of the gesture;
       3. VERTICAL only -- if the picture is already parked at the bound the finger is pulling toward,
          release immediately so the swipe belongs to the pager (the same hand-off pf-vscroll and the
          video's pf-vpan use). Horizontal just clamps: there is no horizontal pager to hand back to, and
          releasing would strand the gesture so a reverse drag in the same swipe could not pan back;
       4. while we own it, preventDefault so the feed does not also scroll under the pan. -- */
  (function () {
    var SLACK = 6;   // under this the crop is a hairline; arming a pan there could only jitter
    // The on-screen box of the DRAWN PICTURE. The <img> is width/height:100% of the unit with
    // object-fit:contain and is then transform-scaled, so getBoundingClientRect gives the ELEMENT box and
    // the picture is a centred sub-rect of it. Deriving it this way stays correct whatever
    // transform-origin the tap-to-zoom left behind (it anchors the zoom on the tapped point, so the hidden
    // strip is NOT split evenly top/bottom) -- a "half the overflow on each side" shortcut is not.
    function picRect(u) {
      var im = u.querySelector('img:not(.pfv-img)'); if (!im) return null;
      var nw = im.naturalWidth, nh = im.naturalHeight;
      var bw = im.offsetWidth, bh = im.offsetHeight;
      if (!nw || !nh || !bw || !bh) return null;
      var r = im.getBoundingClientRect();
      var kx = r.width / bw, ky = r.height / bh;            // live scale (--pf-cover, or 1 under pf-uncrop)
      var cs = Math.min(bw / nw, bh / nh);                  // object-fit:contain inside the element box
      var pw = nw * cs, ph = nh * cs;
      return { left: r.left + (bw - pw) / 2 * kx, top: r.top + (bh - ph) / 2 * ky, w: pw * kx, h: ph * ky };
    }
    // SIGNED gaps between each unit edge and the picture: >0 = background would show there, <0 = that much
    // picture is hidden past it. Signed (not clamped at 0) so a pan left out of range by a resize/rotation
    // self-corrects on the next touch instead of sticking with a strip of background showing.
    function gaps(u) {
      var p = picRect(u); if (!p) return null;
      var r = u.getBoundingClientRect();
      return { top: p.top - r.top, bottom: (r.top + r.height) - (p.top + p.h),
               left: p.left - r.left, right: (r.left + r.width) - (p.left + p.w),
               x: Math.max(0, p.w - r.width), y: Math.max(0, p.h - r.height) };
    }
    var PROP = { 1: '--pf-pany', 2: '--pf-panx' };            // 1 vertical · 2 horizontal
    function panGet(u, ax) { return parseFloat(u.style.getPropertyValue(PROP[ax])) || 0; }
    // The legal move for this axis: shifting the picture by d must not open a gap at EITHER edge, i.e.
    // top+d <= 0 and bottom-d <= 0  =>  d in [bottom, -top]. Empty range = the picture is not bigger than
    // the unit on this axis, so there is nothing hidden and nothing to pan.
    function clampD(u, ax, d) {
      var g = gaps(u); if (!g) return 0;
      var lo = (ax === 1) ? g.bottom : g.right, hi = (ax === 1) ? -g.top : -g.left;
      if (lo > hi) return 0;
      return Math.max(lo, Math.min(hi, d));
    }
    function panBy(u, ax, d) {                                // returns the px actually moved
      d = clampD(u, ax, d);
      if (!d) return 0;
      u.style.setProperty(PROP[ax], (panGet(u, ax) + d) + 'px');
      return d;
    }
    // dir>0 = the drag is revealing content further DOWN / RIGHT (the picture slides up / left)
    function atEdge(u, ax, dir) {
      var g = gaps(u); if (!g) return true;
      if (ax === 1) { return dir > 0 ? g.bottom >= -0.5 : g.top >= -0.5; }
      return dir > 0 ? g.right >= -0.5 : g.left >= -0.5;
    }
    // The CSS hook AND the marker the pfeed pager + pull-to-dismiss read. Recomputed from the LIVE box
    // rather than stamped once at open, because pannability follows the fill state: tap-to-zoom flips
    // pf-uncrop, a rotation swaps which axis crops, and a late decode changes the numbers.
    window.__rovaPhotoPan = function (u) {
      if (!u || !u.classList) return 0;
      var live = u.classList.contains('pf-zoomable')
              && !u.classList.contains('pf-uncrop')           // contained: nothing hidden, never pannable
              && !u.classList.contains('pf-vscroll')          // the fit-width tap scroller owns --pf-pan
              && !!(u.closest && u.closest('.pfeed'));
      // EXACTLY ONE AXIS, the DOMINANT overflow. A cover zoom alone crops one axis and fits the other
      // exactly, but a pfeed photo also runs the Ken Burns drift (rova.css tlPan: scale up to 1.15 as an
      // individual property, stacking on our transform), which pushes the *fitting* axis a few percent
      // past the unit too -- enough to trip a bare "> SLACK" test and arm a second, meaningless panner
      // (measured on /p/8480 at 844x390: 474px hidden vertically vs 20px of pure drift horizontally).
      // Comparing the two overflows picks the axis the CROP owns and ignores the drift.
      var g = live ? gaps(u) : null;
      /* "CANNOT TELL YET" IS NOT "NOT PANNABLE"  (2026-08-17). gaps() returns null for two completely
         different reasons: the photo is genuinely un-pannable (contained / uncropped / vscroll -- `live`
         is false), or its box and natural size are not readable yet (a late decode, or -- since this
         round -- a card whose subtree is content-visibility SKIPPED, where every layout read is 0).
         Falling through with g === null treated both as "no pan": it toggled pf-ypan/pf-hpan OFF and
         DELETED --pf-pany/--pf-panx, i.e. it threw away the reader's pan offset and told the pfeed pager
         this photo has nothing hidden. And the pager reads that class on `scroller`'s touchstart, which
         bubbles BEFORE this re-mark runs on document -- so the first gesture on such a card went to the
         pager instead of the picture. When we cannot measure, change nothing and wait to be asked again
         (this runs on every fit, every rotation and every touchstart). */
      if (live && !g) { return u.classList.contains('pf-ypan') ? 1 : (u.classList.contains('pf-hpan') ? 2 : 0); }
      var vy = !!g && g.y > SLACK && g.y >= g.x;
      // sideways drags on a carousel SLIDE belong to the carousel, so horizontal pan is single-media only
      var vx = !!g && g.x > SLACK && g.x > g.y && !u.classList.contains('cslide');
      u.classList.toggle('pf-ypan', vy);
      u.classList.toggle('pf-hpan', vx);
      if (vy) { panBy(u, 1, 0); } else { u.style.removeProperty('--pf-pany'); }
      if (vx) { panBy(u, 2, 0); } else { u.style.removeProperty('--pf-panx'); }
      return vy ? 1 : (vx ? 2 : 0);                           // 0 none · 1 vertical · 2 horizontal
    };
    // "is this photo parked at its TOP edge?" -- the pull-to-dismiss asks before arming, so a downward
    // drag that still has picture hidden above means "show me the top", not "close the viewer".
    window.__rovaPhotoPanAtTop = function (u) { return !u ? true : atEdge(u, 1, -1); };
    function unitAt(t) {
      var u = (t && t.closest) ? t.closest('.pf-zoomable') : null;
      if (!u || !u.closest('.pfeed')) return null;
      var ax = window.__rovaPhotoPan(u);                      // re-marks live (rotation, tap-zoom, decode)
      return ax ? { u: u, ax: ax } : null;
    }
    function panning(u, on) {
      if (u) u.classList.toggle('pf-panning', !!on);
      if (on && u && window.__rovaPfKbPark) { try { window.__rovaPfKbPark(u); } catch (e) {} }   // a pan parks the drift
    }
    // touch drag
    var tu = null, tax = 0, ty0 = 0, tx0 = 0, tp0 = 0, tLock = 0, tMoved = false;   // 0 undecided · 1 ours · -1 released
    document.addEventListener('touchstart', function (e) {
      var hit = (e.touches.length === 1) ? unitAt(e.target) : null;
      panning(tu, false);
      tu = hit && hit.u; tax = hit ? hit.ax : 0; tLock = 0; tMoved = false;
      if (tu) { ty0 = e.touches[0].clientY; tx0 = e.touches[0].clientX; tp0 = panGet(tu, tax); }
    }, { passive: true });
    document.addEventListener('touchmove', function (e) {
      if (!tu || tLock === -1) return;
      var dy = e.touches[0].clientY - ty0, dx = e.touches[0].clientX - tx0;
      var along = (tax === 1) ? dy : dx, across = (tax === 1) ? dx : dy;
      if (!tLock) {                                           // decide intent once, after real movement
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        tLock = (Math.abs(along) > Math.abs(across) * 1.2) ? 1 : -1;
        if (tLock === -1) { panning(tu, false); tu = null; return; }
      }
      // VERTICAL: parked at the bound this drag is pulling toward -> drop it so the swipe pages the feed.
      if (tax === 1 && atEdge(tu, tax, -along)) { panning(tu, false); tu = null; return; }
      if (e.cancelable) e.preventDefault();                   // ours: don't also scroll the feed
      panning(tu, true);
      if (panBy(tu, tax, (tp0 + along) - panGet(tu, tax))) { tMoved = true; }
    }, { passive: false });
    document.addEventListener('touchend', function () { panning(tu, false); tu = null; tLock = 0; }, { passive: true });
    // A real pan must not also read as a tap: a preventDefault'd drag can still synthesize a click, and on
    // a pfeed photo that click toggles the zoom. Mirrors the video panner's tMoved suppressor.
    document.addEventListener('click', function (e) {
      if (!tMoved) return;
      tMoved = false;
      if (e.target.closest && e.target.closest('.pf-ypan, .pf-hpan')) { e.preventDefault(); e.stopPropagation(); }
    }, true);
    // desktop wheel + click-drag (a cover-zoomed photo crops on a desktop window too)
    var wT = null;
    document.addEventListener('wheel', function (e) {
      // ctrl+wheel is a TRACKPAD PINCH (and ctrl+mouse-wheel is page zoom): never a pan. This used to take
      // it, so a pinch over a cover-cropped photo slid the crop up/down and preventDefault'd the zoom.
      if (e.ctrlKey) return;
      var hit = unitAt(e.target); if (!hit) return;
      var vert = Math.abs(e.deltaY) > Math.abs(e.deltaX);
      if (vert !== (hit.ax === 1)) return;                    // wheel axis isn't the one this photo crops
      var d = vert ? e.deltaY : e.deltaX;
      if (hit.ax === 1 && atEdge(hit.u, hit.ax, d)) return;   // at that edge -> let the feed scroll
      e.preventDefault();
      panning(hit.u, true);
      panBy(hit.u, hit.ax, -d);
      var wu = hit.u;
      clearTimeout(wT); wT = setTimeout(function () { panning(wu, false); }, 260);
    }, { passive: false });
    var mu = null, mAx = 0, my0 = 0, mx0 = 0, mp0 = 0;
    document.addEventListener('mousedown', function (e) {
      var hit = unitAt(e.target); if (!hit) return;
      mu = hit.u; mAx = hit.ax; my0 = e.clientY; mx0 = e.clientX; mp0 = panGet(mu, mAx); e.preventDefault();
    });
    document.addEventListener('mousemove', function (e) {
      if (!mu) return;
      var along = (mAx === 1) ? (e.clientY - my0) : (e.clientX - mx0);
      panning(mu, true);
      if (panBy(mu, mAx, (mp0 + along) - panGet(mu, mAx))) { tMoved = true; }
    });
    document.addEventListener('mouseup', function () { panning(mu, false); mu = null; });
  })();

  /* ---- pan a cover-filled VIDEO within its crop (.pf-vpan/--pf-vpos up-down, .pf-hvpan/--pf-hpos
     left-right) -- web report #44: "portrait videos should be pannable up and down when zoomed in on the
     pfeed". The video twin of the two photo panners above, but it moves a different thing: those
     translate the ELEMENT, which only reveals more picture because a zoomable photo renders contain +
     scale(--pf-cover) so its box really does overflow the unit. A pf-vfill clip is object-fit:cover --
     the <video> box IS the screen and the crop happens INSIDE it -- so a translate there drags black in
     from the edge instead. We walk object-position (0-100%) instead, which addresses the crop WINDOW and
     can never expose a gap. Vertical keeps pf-vscroll's edge hand-off: panned to a bound, the drag is
     dropped so a continued swipe advances the feed. See __rovaVpan for why BOTH axes, not just the
     reported one. -- */
  (function () {
    function dims(v) {
      if (!v) return null;
      // videoWidth once metadata lands, else the width/height the server stamps from the poster -- the
      // same fallback the fit loop uses, so a clip is pannable on its FIRST paint, not a beat later.
      var w = v.videoWidth || parseInt(v.getAttribute('width'), 10) || 0;
      var h = v.videoHeight || parseInt(v.getAttribute('height'), 10) || 0;
      return (w > 0 && h > 0) ? { w: w, h: h } : null;
    }
    function over(u) {                                      // px of clip hidden per axis; 0 = nothing to pan
      var d = dims(u.querySelector('video')); if (!d) return null;
      var bw = u.clientWidth, bh = u.clientHeight; if (!bw || !bh) return null;
      var s = Math.max(bw / d.w, bh / d.h);                 // the cover scale, exactly what object-fit picks
      return { x: Math.max(0, d.w * s - bw), y: Math.max(0, d.h * s - bh) };
    }
    var SLACK = 6;   // under this the crop is a hairline; arming a pan there could only jitter
    // The CSS hook AND the marker the feed pager's skip list reads. Recomputed from the LIVE state rather
    // than stamped once at open, because pannability follows the fill mode: the vc-fit button flips
    // pf-vfill <-> pf-letterbox, and a letterboxed clip has no crop to pan at all.
    // WHICH AXIS: a cover fit matches one axis EXACTLY and crops the other, so at most one of these is
    // ever on. The report said "up and down", but measured on a 375x812 phone every portrait clip in the
    // reporter's own feed (720x1280, 720x874, 720x958, 1080x1920) had overY 0 and 82-294px hidden on the
    // SIDES -- a modern phone is taller-relative than the clips, so cover eats the sides. Vertical-only
    // would have been dead code on the very feed that asked for it; pf-vpan covers the case they meant
    // (a clip taller-relative than the screen, e.g. a 9:20 screen recording), pf-hvpan the one they have.
    window.__rovaVpan = function (u) {
      if (!u || !u.classList) return 0;
      var o = u.classList.contains('pf-vfill') ? over(u) : null;
      /* SAME SPLIT AS __rovaPhotoPan ABOVE (2026-08-17): pf-vfill on but over() null means the clip's
         metadata or its BOX is not readable yet -- a fresh <video>, or a card whose subtree is
         content-visibility skipped, where clientWidth/clientHeight are 0. That is "ask me again", not
         "nothing to pan", and the difference is destructive: the fall-through stripped pf-vpan/pf-hvpan
         and deleted --pf-vpos/--pf-hpos, which the pull-to-dismiss reads to decide whether a downward
         drag means "show me the top of the clip" or "close the viewer". pf-vfill OFF is the real
         negative (letterboxed / contained: there is no crop), and that still falls through. */
      if (!o && u.classList.contains('pf-vfill')) { return u.classList.contains('pf-vpan') ? 1 : (u.classList.contains('pf-hvpan') ? 2 : 0); }
      var vy = !!o && o.y > SLACK;
      // sideways drags on a carousel SLIDE belong to the carousel, so horizontal pan is single-media only
      var vx = !!o && o.x > SLACK && !u.classList.contains('cslide');
      u.classList.toggle('pf-vpan', vy);
      u.classList.toggle('pf-hvpan', vx);
      if (!vy) { u.style.removeProperty('--pf-vpos'); }
      if (!vx) { u.style.removeProperty('--pf-hpos'); }
      return vy ? 1 : (vx ? 2 : 0);                          // 0 none · 1 vertical · 2 horizontal
    };
    var PROP = { 1: '--pf-vpos', 2: '--pf-hpos' };
    function unitAt(t) {
      var u = (t && t.closest) ? t.closest('.pf-vfill') : null;
      if (!u || !u.closest('.pfeed')) return null;
      var ax = window.__rovaVpan(u);                         // re-marks live (rotation, vc-fit, late metadata)
      return ax ? { u: u, ax: ax } : null;
    }
    function posGet(u, ax) { var p = parseFloat(u.style.getPropertyValue(PROP[ax])); return isNaN(p) ? 50 : p; }
    function posSet(u, ax, p) { p = Math.max(0, Math.min(100, p)); u.style.setProperty(PROP[ax], p + '%'); return p; }
    function pctPerPx(u, ax) {                               // so the picture tracks the finger 1:1
      var o = over(u), d = o ? (ax === 1 ? o.y : o.x) : 0;
      return d > 0 ? 100 / d : 0;
    }
    // dir>0 = revealing content further DOWN / RIGHT (object-position walks toward 100%)
    function atEdge(u, ax, dir) { var p = posGet(u, ax); return dir > 0 ? p >= 99.9 : p <= 0.1; }
    // touch drag (drag DOWN reveals the TOP, i.e. object-position walks toward 0%)
    var vu = null, vax = 0, vy0 = 0, vx0 = 0, vp0 = 0, vLock = 0, vMoved = false;   // 0 undecided · 1 ours · -1 released
    document.addEventListener('touchstart', function (e) {
      var hit = (e.touches.length === 1) ? unitAt(e.target) : null;
      vu = hit && hit.u; vax = hit ? hit.ax : 0; vLock = 0; vMoved = false;
      if (vu) { vy0 = e.touches[0].clientY; vx0 = e.touches[0].clientX; vp0 = posGet(vu, vax); }
    }, { passive: true });
    document.addEventListener('touchmove', function (e) {
      if (!vu || vLock === -1) return;
      var dy = e.touches[0].clientY - vy0, dx = e.touches[0].clientX - vx0;
      var along = (vax === 1) ? dy : dx, across = (vax === 1) ? dx : dy;
      if (!vLock) {                                          // decide intent once, after real movement
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        // only a drag clearly ALONG our axis is ours; across it belongs to the feed's vertical snap
        vLock = (Math.abs(along) > Math.abs(across) * 1.2) ? 1 : -1;
        if (vLock === -1) { vu = null; return; }
      }
      // VERTICAL only: panned to a bound, drop the drag so a continued swipe advances the feed (the
      // pf-vscroll hand-off). Horizontal just clamps -- there is no horizontal feed to hand off to, and
      // releasing would strand the gesture so a reverse drag in the same swipe couldn't pan back.
      if (vax === 1 && atEdge(vu, vax, -along)) { vu = null; return; }
      if (e.cancelable) e.preventDefault();                  // ours: don't also scroll the feed
      vMoved = true;
      posSet(vu, vax, vp0 - along * pctPerPx(vu, vax));
    }, { passive: false });
    document.addEventListener('touchend', function () { vu = null; vLock = 0; }, { passive: true });
    // A real pan must not also read as a tap: iOS still synthesizes a click after a preventDefault'd drag,
    // and on a pfeed clip that click is play/pause. Mirrors the carousel track's tMoved suppressor.
    document.addEventListener('click', function (e) {
      if (!vMoved) return;
      vMoved = false;
      if (e.target.closest && e.target.closest('.pf-vpan, .pf-hvpan')) { e.preventDefault(); e.stopPropagation(); }
    }, true);
    // desktop wheel + click-drag (a portrait-narrow window fills too, so this is reachable there)
    document.addEventListener('wheel', function (e) {
      var hit = unitAt(e.target); if (!hit) return;
      var vert = Math.abs(e.deltaY) > Math.abs(e.deltaX);
      if (vert !== (hit.ax === 1)) return;                   // wheel axis isn't the one this clip crops
      var d = vert ? e.deltaY : e.deltaX;
      if (hit.ax === 1 && atEdge(hit.u, hit.ax, d)) return;  // at the edge this way -> let the feed scroll
      e.preventDefault();
      posSet(hit.u, hit.ax, posGet(hit.u, hit.ax) + d * pctPerPx(hit.u, hit.ax));
    }, { passive: false });
    var vm = null, vmax = 0, vmy0 = 0, vmx0 = 0, vmp0 = 0;
    document.addEventListener('mousedown', function (e) {
      var hit = unitAt(e.target); if (!hit) return;
      vm = hit.u; vmax = hit.ax; vmy0 = e.clientY; vmx0 = e.clientX; vmp0 = posGet(vm, vmax); e.preventDefault();
    });
    document.addEventListener('mousemove', function (e) {
      if (!vm) return;
      var along = (vmax === 1) ? (e.clientY - vmy0) : (e.clientX - vmx0);
      posSet(vm, vmax, vmp0 - along * pctPerPx(vm, vmax));
    });
    document.addEventListener('mouseup', function () { vm = null; });
  })();

  /* ---- owner: reorder a carousel post's slides (within the edit window) ------
     Opened from the post ⋯ menu ("Reorder slides"). Drag rows or use the up/down arrows; the top row
     becomes slide 1 (and the cover). Saves the new PATH order to /post/reorder-media, then reorders the
     live carousel in place -- no reload. Server re-checks ownership + the edit window. */
  (function () {
    var modal = null, curPost = null, curCarousel = null;
    function build() {
      modal = document.createElement('div');
      modal.className = 'reorder-modal';
      modal.innerHTML =
        '<div class="reorder-sheet" role="dialog" aria-label="Reorder slides">' +
          '<div class="reorder-head"><h3>Reorder slides</h3>' +
            '<button class="reorder-x" type="button" aria-label="Close">&times;</button></div>' +
          '<p class="reorder-hint">Drag, or use the arrows. The top slide becomes the cover.</p>' +
          '<div class="reorder-list"></div>' +
          '<div class="reorder-actions">' +
            '<button class="btn reorder-cancel" type="button">Cancel</button>' +
            '<button class="btn primary reorder-save" type="button">Save order</button>' +
          '</div>' +
        '</div>';
      document.body.appendChild(modal);
      modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
      modal.querySelector('.reorder-x').addEventListener('click', close);
      modal.querySelector('.reorder-cancel').addEventListener('click', close);
      modal.querySelector('.reorder-save').addEventListener('click', save);
    }
    function open(postId) {
      var post = document.querySelector('.post[data-id="' + postId + '"]');
      var carousel = post && post.querySelector('.media.carousel');
      if (!carousel) { toast('Could not find that post.'); return; }
      curPost = post; curCarousel = carousel;
      build();
      var list = modal.querySelector('.reorder-list');
      Array.prototype.forEach.call(carousel.querySelectorAll('.cslide'), function (slide) {
        var path = slide.getAttribute('data-path');
        if (!path) return;
        var img = slide.querySelector('img'), vid = slide.querySelector('video');
        var thumb = '<span class="reorder-vid">&#9654;</span>';
        if (img && img.getAttribute('src')) { thumb = '<img src="' + escAttr(img.getAttribute('src')) + '" alt="">'; }
        else if (vid && vid.getAttribute('poster')) { thumb = '<img src="' + escAttr(vid.getAttribute('poster')) + '" alt="">'; }
        var row = document.createElement('div');
        row.className = 'reorder-item';
        row.setAttribute('data-path', path);
        row.draggable = true;
        row.innerHTML =
          '<span class="reorder-num"></span>' +
          '<span class="reorder-thumb">' + thumb + '</span>' +
          '<span class="reorder-grip" aria-hidden="true">&#8942;&#8942;</span>' +
          '<span class="reorder-moves"><button class="reorder-up" type="button" aria-label="Move up">&#9650;</button>' +
          '<button class="reorder-down" type="button" aria-label="Move down">&#9660;</button></span>';
        list.appendChild(row);
      });
      wireList(list);
      renumber();
      if (window.__rovaLockScroll) window.__rovaLockScroll();
      requestAnimationFrame(function () { modal.classList.add('show'); });
    }
    function escAttr(s) { return String(s).replace(/"/g, '&quot;'); }
    function renumber() {
      var items = modal.querySelectorAll('.reorder-item');
      Array.prototype.forEach.call(items, function (it, i) {
        it.querySelector('.reorder-num').textContent = (i + 1);
        it.querySelector('.reorder-up').disabled = (i === 0);
        it.querySelector('.reorder-down').disabled = (i === items.length - 1);
      });
    }
    function wireList(list) {
      list.addEventListener('click', function (e) {
        var up = e.target.closest && e.target.closest('.reorder-up');
        var down = e.target.closest && e.target.closest('.reorder-down');
        if (!up && !down) return;
        var item = e.target.closest('.reorder-item'); if (!item) return;
        if (up && item.previousElementSibling) { list.insertBefore(item, item.previousElementSibling); }
        else if (down && item.nextElementSibling) { list.insertBefore(item.nextElementSibling, item); }
        renumber();
      });
      var dragEl = null;
      list.addEventListener('dragstart', function (e) { dragEl = e.target.closest('.reorder-item'); if (dragEl) dragEl.classList.add('dragging'); });
      list.addEventListener('dragend', function () { if (dragEl) dragEl.classList.remove('dragging'); dragEl = null; renumber(); });
      list.addEventListener('dragover', function (e) {
        e.preventDefault(); if (!dragEl) return;
        var after = null, items = list.querySelectorAll('.reorder-item:not(.dragging)');
        for (var i = 0; i < items.length; i++) {
          var r = items[i].getBoundingClientRect();
          if (e.clientY < r.top + r.height / 2) { after = items[i]; break; }
        }
        if (after) { list.insertBefore(dragEl, after); } else { list.appendChild(dragEl); }
      });
    }
    function save() {
      if (!modal || !curPost) return;
      var order = Array.prototype.map.call(modal.querySelectorAll('.reorder-item'), function (it) { return it.getAttribute('data-path'); });
      var btn = modal.querySelector('.reorder-save');
      btn.disabled = true; btn.textContent = 'Saving…';
      var pid = curPost.getAttribute('data-id'), car = curCarousel;
      postJson('/post/reorder-media', { post_id: pid, order: JSON.stringify(order) })
        .then(function (res) {
          if (!res || !res.ok) { btn.disabled = false; btn.textContent = 'Save order'; toast((res && res.error) || 'Could not reorder.'); return; }
          applyOrder(car, order);
          close();
          toast('Slide order saved.');
        })
        .catch(function () { btn.disabled = false; btn.textContent = 'Save order'; toast('Could not reorder.'); });
    }
    // reorder the live carousel DOM to match, without a reload
    function applyOrder(carousel, order) {
      if (!carousel) return;
      var track = carousel.querySelector('.carousel-track'); if (!track) return;
      var byPath = {};
      Array.prototype.forEach.call(track.querySelectorAll('.cslide'), function (s) { byPath[s.getAttribute('data-path')] = s; });
      order.forEach(function (p) { if (byPath[p]) track.appendChild(byPath[p]); });   // re-append in the new order
      if (carousel.__cgo) { carousel.__cgo(0); } else { track.style.transform = 'translateX(0)'; }
    }
    function close() {
      if (!modal) return;
      modal.classList.remove('show');
      if (window.__rovaUnlockScroll) window.__rovaUnlockScroll();
      var m = modal; modal = null; curPost = null; curCarousel = null;
      setTimeout(function () { if (m.parentNode) m.parentNode.removeChild(m); }, 200);
    }
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal) close(); });
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.js-reorder');
      if (!b) return;
      e.preventDefault();
      var op = b.closest('.post'); if (op) op.classList.remove('menu-open');    // close the ⋯ menu it lives in
      var pm = b.closest('.pmenu'); if (pm) pm.classList.remove('open', 'show');
      open(b.getAttribute('data-id'));
    });
  })();

  /* ---- live link preview: as you type a URL into the composer / a comment / a DM,
     show the embed or OG card (exactly as it will send) before you hit send ------- */
  (function () {
    var CACHE = {};
    function firstUrl(t) {
      var m = String(t == null ? '' : t).match(/https?:\/\/[^\s<]+/i);
      return m ? m[0].replace(/[.,;:!?)]+$/, '') : '';
    }
    function mountFor(input) {
      if (input._cpv) return input._cpv;
      var prev = document.createElement('div');
      prev.className = 'compose-preview'; prev.hidden = true;
      var dmBar = input.closest('.dm-compose, .hdrop-compose');
      if (dmBar && dmBar.parentNode) { prev.classList.add('above'); dmBar.parentNode.insertBefore(prev, dmBar); }
      else {
        var form = input.closest('form');
        var actions = form && form.querySelector('.actions');
        if (actions) actions.parentNode.insertBefore(prev, actions);           // composer: above the buttons
        else if (form && form.parentNode) form.parentNode.insertBefore(prev, form.nextSibling);  // comment: below the form
        else if (input.parentNode) input.parentNode.insertBefore(prev, input.nextSibling);
      }
      input._cpv = prev;
      return prev;
    }
    /* ---- HIDING the raw URL once its card resolves (owner, 2026-08-05) -------------------------------
       "When i type the link in and it embeds no need to show the ugly url in the composer anymore."
       The posted result never showed it: _post.php does str_replace($embed['url'], '', $body) at RENDER
       time, so the raw link only ever looked bad in the composer. That makes this a PURELY VISUAL fix,
       and the rule the whole design hangs off is:

           THE SUBMITTED BODY MUST STAY BYTE-IDENTICAL TO WHAT IT IS TODAY.

       Every server path (Embed::fromText, the str_replace strip, link cards, the API, seed tooling)
       keeps behaving exactly as it does now because it receives exactly the same bytes. So the URL is
       lifted out of the textarea's VISIBLE value only, remembered with its EXACT substring and its
       EXACT offset, and put straight back before anything serialises the form. Nothing is trimmed,
       tidied or re-spaced on the way out and back: a "helpful" whitespace collapse is precisely what
       would make the body differ from today's, and a differently-trimmed URL would make the server's
       str_replace silently miss and leave the raw link sitting in the posted caption.

       The only thing that is ALLOWED to change the body is the new X button, because removing the link
       is what the member just asked for.

       POST COMPOSER ONLY (.js-compose textarea[name="body"]). Not comments: a comment body is rendered
       with linkify() and nothing else -- no embed, no strip -- so the URL genuinely DOES appear in the
       posted comment, and hiding it in the box would be a lie about what is about to be sent. Not DMs
       or the gallery caption either: dm_extras() does strip, but a DM is a one-line <input> where the
       message often IS just the link, and blanking it leaves a box that looks empty. He asked about the
       composer; the composer is a multi-line textarea with a caption around the link, which is the one
       place where hiding reads as tidying rather than as losing your message. ------------------------ */
    var HIDE_SEL = '.js-compose textarea[name="body"]';
    /* ---- THE OFFSET IS NEVER TRUSTED, IT IS CHECKED (2026-08-05) ---------------------------------
       h.cut is a TRACKED INTEGER and a tracked integer drifts. shiftPoint() has to GUESS where the
       point went after an edit, and an edit made exactly AT the point is inherently ambiguous -- the
       everyday case is a member who pastes a link on its own, watches it vanish behind its card, and
       then types the caption, because the caret is left sitting on the point. Guess wrong and the URL
       is spliced into the middle of a word: a body the member never wrote, with a host like
       "moneyupperhttps" that is dead on DNS, and the same bytes go to /link-preview and to the POST.

       The rule the owner set: LOSING THE CARD IS FINE, CORRUPTING THE BODY IS NOT.

       So one predicate, boundaryOk(), guards both ends of the mechanism:
         - hideUrl() REFUSES to lift a URL out of a spot it could not put back cleanly, so a bad point
           can never be recorded in the first place;
         - every splice re-checks the recorded point against the text as it is NOW, and a point that
           has drifted off a boundary is repaired with a single separating space -- the smallest edit
           that still leaves the URL as a token of its own, so firstUrl() on the server matches exactly
           the URL and the str_replace strip still finds it;
         - and the input handler drops the hide outright the moment it drifts, which puts the URL back
           on screen and lets scan()'s existing self-heal re-anchor it from what is really there.

       BECAUSE HIDE AND SPLICE SHARE THE PREDICATE, A HIDE THAT WAS LEGAL WHEN IT WAS TAKEN NEEDS NO
       REPAIR WHEN IT IS PUT BACK: type-link-then-send still submits byte-for-byte what it sends today,
       which is the property the whole feature rests on. Padding only ever appears in a case that today
       corrupts. ------------------------------------------------------------------------------------ */
    var CPV_WS = /\s/;
    var CPV_OPEN = '([{"\'';          // may sit immediately before a URL
    var CPV_CLOSE = '.,;:!?)]}"\'';   // may sit immediately after one, if the token ends there
    /** Can the URL sit at index c of v as a token of ITS OWN? Left: the edge of the value, whitespace,
     *  or one opening bracket/quote that is itself preceded by edge-or-whitespace. Right: the edge,
     *  whitespace, or a run of sentence punctuation that reaches the edge/whitespace -- so a trailing
     *  "." passes and ".com/Pl" (the reported corruption) does not. */
    function boundaryOk(v, c) {
      if (!(c >= 0) || c > v.length) return false;
      if (c > 0) {
        var l = v.charAt(c - 1);
        if (!CPV_WS.test(l)) {
          if (CPV_OPEN.indexOf(l) < 0) return false;
          if (c > 1 && !CPV_WS.test(v.charAt(c - 2))) return false;
        }
      }
      var i = c;
      while (i < v.length && CPV_CLOSE.indexOf(v.charAt(i)) >= 0) i++;
      return i >= v.length || CPV_WS.test(v.charAt(i));
    }
    /** WHAT to put back and WHERE: { at, ins, ok }. ins is the bare URL whenever the recorded point is
     *  still a boundary -- the normal case, and the byte-identical one. A drifted point gets a space on
     *  whichever side would otherwise glue the URL to a neighbouring token. ok=false means the record
     *  can no longer be trusted and the caller should stop hiding. */
    function spliceIns(v, h) {
      var c = h.cut < 0 ? 0 : (h.cut > v.length ? v.length : h.cut);
      if (boundaryOk(v, c)) return { at: c, ins: h.url, ok: true };
      var pre = (c > 0 && !CPV_WS.test(v.charAt(c - 1))) ? ' ' : '';
      var post = (c < v.length && !CPV_WS.test(v.charAt(c))) ? ' ' : '';
      return { at: c, ins: pre + h.url + post, ok: false };
    }
    /** The FULL logical body: what the server must receive. Visible value with the hidden URL put back
     *  at its recorded offset. Everything in here reasons about THIS, never about input.value. */
    function fullValue(input) {
      if (!input) return '';
      var h = input._cpvHide, v = input.value;
      if (!h) return v;
      var s = spliceIns(v, h);
      return v.slice(0, s.at) + s.ins + v.slice(s.at);
    }
    // published so the char counter and the reload-draft can both count/save the REAL body, not the
    // shortened one the member can see (see draftSaveBody's call site and ccUpdate)
    window.__rovaComposeFullBody = fullValue;
    /** Write a new visible value + caret, and let the rest of the page react (char count, autosize,
     *  draft save) exactly as it would for a keystroke. _cpvSelf marks it as OURS so this IIFE's own
     *  input handler neither re-scans nor mistakes it for an edit it has to track. */
    function setVal(input, v, caret) {
      input.value = v;
      var n = caret == null ? v.length : Math.max(0, Math.min(caret, v.length));
      try { input.setSelectionRange(n, n); } catch (e) {}
      input._cpvVis = v;
      input._cpvSelf = true;
      try { input.dispatchEvent(new Event('input', { bubbles: true })); } catch (e) {}
      input._cpvSelf = false;
    }
    /** Drop the hide record WITHOUT putting the URL back (the X path, and any full reset). */
    function forget(input) {
      if (!input._cpvHide) return;
      input._cpvHide = null;
      if (input._cpvML != null) { input.setAttribute('maxlength', input._cpvML); input._cpvML = null; }
    }
    /** Lift the resolved URL out of view. Called only once its card is actually on screen, so text can
     *  never vanish with nothing to show for it. */
    function hideUrl(input) {
      if (!input.matches || !input.matches(HIDE_SEL)) return;
      if (input._cpvHide) return;
      var url = input._cpvUrl; if (!url) return;
      var f = input.closest ? input.closest('form') : null;
      if (f && f.getAttribute('data-posting') === '1') return;   // mid-send: never touch the value being serialised
      var v = input.value, i = v.indexOf(url); if (i < 0) return;
      // ONLY a spot the URL can be put back into cleanly may be taken away. The visible value this is
      // about to write is v minus the URL, so the point to judge is i in THAT string. Refusing here is
      // what makes a bad h.cut unrepresentable rather than merely unlikely; the cost is that a link
      // jammed against its neighbour ("see:https://x.com") simply stays visible, card and all.
      var nv = v.slice(0, i) + v.slice(i + url.length);
      if (!boundaryOk(nv, i)) return;
      // maxlength counts what you can TYPE, so shrink it by the characters now riding along invisibly --
      // otherwise a long Apple Music link buys itself ~90 extra characters of caption past the 2000 cap.
      var ml = input.getAttribute('maxlength');
      if (ml) { input._cpvML = ml; input.setAttribute('maxlength', String(Math.max(url.length, (parseInt(ml, 10) || 0) - url.length))); }
      input._cpvHide = { url: url, cut: i };
      var at = input.selectionStart == null ? v.length : input.selectionStart;
      setVal(input, nv, at > i + url.length ? at - url.length : (at > i ? i : at));
    }
    /** Put it back where it was -- or, if the point has drifted off a boundary, at the same point with
     *  a separating space, which is the whole of the repair. The caret rides the insertion so the member
     *  keeps typing where they were. */
    function unhide(input) {
      var h = input._cpvHide; if (!h) return;
      var v = input.value, s = spliceIns(v, h);
      var at = input.selectionStart == null ? v.length : input.selectionStart;
      forget(input);
      setVal(input, v.slice(0, s.at) + s.ins + v.slice(s.at), at >= s.at ? at + s.ins.length : at);
    }
    /** Follow the hidden URL's offset as the member keeps typing around it. Single-point edits (typing,
     *  pasting, deleting, select-and-replace) are found by the common prefix/suffix of old vs new, which
     *  is all a textarea can produce. An edit that STRADDLES the point lands the URL just after whatever
     *  was inserted. Getting this wrong can only move the URL within the body, never lose it: the strip
     *  is a str_replace, so it finds the link wherever it sits. */
    function shiftPoint(oldV, newV, at) {
      if (oldV === newV) return at;
      var p = 0, maxP = Math.min(oldV.length, newV.length);
      while (p < maxP && oldV.charCodeAt(p) === newV.charCodeAt(p)) p++;
      var s = 0, maxS = Math.min(oldV.length - p, newV.length - p);
      while (s < maxS && oldV.charCodeAt(oldV.length - 1 - s) === newV.charCodeAt(newV.length - 1 - s)) s++;
      var delEnd = oldV.length - s, insLen = newV.length - s - p;
      if (at <= p) return at;
      if (at >= delEnd) return at + (newV.length - oldV.length);
      return p + insLen;
    }
    function mountFor(input) {
      if (input._cpv) return input._cpv;
      var prev = document.createElement('div');
      prev.className = 'compose-preview'; prev.hidden = true;
      var dmBar = input.closest('.dm-compose, .hdrop-compose');
      if (dmBar && dmBar.parentNode) { prev.classList.add('above'); dmBar.parentNode.insertBefore(prev, dmBar); }
      else {
        var form = input.closest('form');
        var actions = form && form.querySelector('.actions');
        if (actions) actions.parentNode.insertBefore(prev, actions);           // composer: above the buttons
        else if (form && form.parentNode) form.parentNode.insertBefore(prev, form.nextSibling);  // comment: below the form
        else if (input.parentNode) input.parentNode.insertBefore(prev, input.nextSibling);
      }
      input._cpv = prev;
      prev._cpvInput = input;                 // the X needs to get back to the box it belongs to
      return prev;
    }
    function clear(input) {
      // a picked song that is autoplaying in this card stops with it (removed, X'd, posted, emptied)
      if (input._cpv && window.__rovaAmStopIn) { try { window.__rovaAmStopIn(input._cpv); } catch (e) {} }
      if (input._cpv) { input._cpv.hidden = true; input._cpv.innerHTML = ''; }
      input._cpvUrl = '';
      forget(input);                          // no card on screen -> nothing may be hidden behind it
      /* STALE CARD AFTER A DM SEND (Rob 10-17, desktop flyout: the PREVIEW card stayed up after the
         message went). A clear is FINAL for whatever was in flight: the generation bump makes a late
         /link-preview answer (or its 1.7s retry) for the cleared state drop itself in fetchPreview, and
         the input's pending 550ms re-scan is cancelled -- that timer could otherwise fire while a sent
         message's text was still in the box and paint the card straight back. */
      input._cpvGen = (input._cpvGen || 0) + 1;
      if (input._cpvTimer) { clearTimeout(input._cpvTimer); input._cpvTimer = null; }
    }
    window.__rovaClearComposePreview = clear;
    /* ---- THE "ADD MUSIC" PICKER ATTACHES THROUGH HERE (2026-09-27) ------------------------------------
       A pick is a paste. The picker hands over one url -- Apple's share link, or a Spotify / SoundCloud /
       YouTube / Apple Music link typed into its search box, untouched -- and it goes into the body exactly
       as if the member had pasted it: appended as its own token, then scan() resolves it through
       /link-preview, paints the card and hides the url behind it. Nothing new reaches the server; the POST
       is byte-for-byte what pasting that link sends.
       `replace` is the url the picker attached LAST time (a second pick swaps the song rather than piling
       a second link on: a post plays one). Only that exact substring is removed, and at most one of the
       two spaces it leaves behind -- never a whitespace tidy-up of the member's own text.
       Works on the FULL body: a url already hidden behind its card is put back first (unhide), so indexOf
       sees the truth; scan() re-hides once the card is up. Returns false (nothing changed) when the link
       would push the body past the textarea's own maxlength -- a url cut short by the server's truncation
       would post as a dead link. */
    window.__rovaComposeAttachLink = function (input, url, replace, autoplay) {
      if (!input || !url || !input.matches || !input.matches(HIDE_SEL)) return false;
      input._cpvAuto = autoplay ? url : '';           // paint() starts its card's preview once drawn
      if (input._cpvHide) unhide(input);
      var v = input.value;
      if (replace && replace !== url) {
        var i = v.indexOf(replace);
        if (i >= 0) {
          var a = v.slice(0, i), b = v.slice(i + replace.length);
          if (/ $/.test(a) && (b === '' || /^[ \n]/.test(b))) a = a.slice(0, -1);
          v = a + b;
        }
      }
      if (v.indexOf(url) < 0) v = v + (v === '' || /\s$/.test(v) ? '' : ' ') + url;
      var ml = parseInt(input.getAttribute('maxlength'), 10) || 0;
      if (ml && v.length > ml) return false;
      if (input._cpvNo) delete input._cpvNo[url];     // a deliberate pick earns its card even after an earlier X
      setVal(input, v, v.length);                     // char count, autosize and the reload draft follow as for a keystroke
      input._cpvFull = fullValue(input);
      scan(input);                                    // now, not after the 550ms typing debounce
      return true;
    };
    function paint(input, res, url) {
      if (firstUrl(fullValue(input)) !== url) return;
      var html = (res && (res.embed || res.card)) || '';
      if (!html) return;
      var prev = mountFor(input);
      // The X carries .thumb-x so it IS the same red disc the media thumbnails in this very composer
      // already use -- one action, one look. Only the post composer offers it (see HIDE_SEL above).
      var x = (input.matches && input.matches(HIDE_SEL))
        ? '<button type="button" class="thumb-x cpv-x" aria-label="Remove link preview" title="Remove link preview">&times;</button>'
        : '';
      if (window.__rovaAmStopIn) { try { window.__rovaAmStopIn(prev); } catch (e) {} }   // the song being replaced
      prev.innerHTML = '<div class="cpv-label">Preview</div><div class="cpv-body">' + html + x + '</div>';
      prev.hidden = false;
      hideUrl(input);                         // the card is up: now the raw link can go
      // a song picked in the "Add music" picker plays as soon as its card is up (iOS build 490 parity)
      if (input._cpvAuto && input._cpvAuto === url) {
        input._cpvAuto = '';
        var amc = prev.querySelector('.am-card[data-preview]');
        if (amc && window.__rovaAmComposeAuto) { try { window.__rovaAmComposeAuto(amc); } catch (e) {} }
      }
    }
    function fetchPreview(input, url, tries) {
      if (CACHE[url] && (CACHE[url].embed || CACHE[url].card)) { paint(input, CACHE[url], url); return; }
      var gen = input._cpvGen || 0;           // a clear() after this point makes the answer stale
      fetch('/link-preview?text=' + encodeURIComponent(url), { headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          CACHE[url] = res || {};
          if ((input._cpvGen || 0) !== gen || input._cpvUrl !== url) return;   // sent / emptied / moved on meanwhile
          if (res && (res.embed || res.card)) { paint(input, res, url); return; }
          if (tries > 0 && firstUrl(fullValue(input)) === url) {   // OG worker still fetching: retry
            setTimeout(function () { if ((input._cpvGen || 0) !== gen) return; delete CACHE[url]; fetchPreview(input, url, tries - 1); }, 1700);
          }
        }).catch(function () {});
    }
    function scan(input) {
      // ALWAYS the full body: once the first URL is hidden, reading input.value would make a SECOND
      // typed link look like the first one and hijack the card off the link that is already showing.
      var url = firstUrl(fullValue(input));
      if (!url) { clear(input); return; }
      if (input._cpvNo && input._cpvNo[url]) return;      // X'd: stays gone
      // Card already up for this URL. Still ask to hide: this is the SELF-HEAL. An edit that replaces
      // the whole caption in one go (select-all then paste, an undo) can put the URL back into the
      // visible value while the record still claims it is hidden, and without this the box would keep
      // showing the raw link with a card sitting under it -- the exact thing being fixed.
      if (input._cpvUrl === url && input._cpv && !input._cpv.hidden) { hideUrl(input); return; }
      input._cpvUrl = url;
      if (input._cpv) input._cpv.hidden = true;
      fetchPreview(input, url, 2);
    }
    /** The X: drop the card AND the link itself, because that is what "remove it before posting" means.
     *  The URL is already out of the visible value when it was hidden, so removing it is just forgetting
     *  the record; the un-hidden shapes still need the substring cut out. */
    function removeLink(input) {
      var url = input._cpvUrl || (input._cpvHide && input._cpvHide.url) || '';
      var v = input.value;
      var at = input.selectionStart == null ? v.length : input.selectionStart;
      if (input._cpvHide) { forget(input); }
      else if (url) {
        var i = v.indexOf(url);
        if (i >= 0) { v = v.slice(0, i) + v.slice(i + url.length); at = at > i + url.length ? at - url.length : (at > i ? i : at); }
      }
      if (url) { (input._cpvNo = input._cpvNo || {})[url] = 1; }
      clear(input);
      setVal(input, v, at);                   // fires input -> char count, autosize and the draft all resync
      input._cpvFull = fullValue(input);
      try { input.focus(); } catch (e) {}
    }
    document.addEventListener('click', function (e) {
      var x = e.target.closest ? e.target.closest('.cpv-x') : null;
      if (!x) return;
      e.preventDefault();
      e.stopPropagation();                    // an .am-card toggles play on click; the X must not also do that
      var prev = x.closest('.compose-preview');
      if (prev && prev._cpvInput) removeLink(prev._cpvInput);
    });
    var SEL = '.js-compose textarea[name="body"], .js-comment textarea, .js-comment input[name="body"], .gal-cinput, .dm-compose input[name="body"], .hdrop-compose input.input';
    document.addEventListener('input', function (e) {
      if (!e.target.matches || !e.target.matches(SEL)) return;
      var input = e.target;
      if (input._cpvSelf) return;             // our own hide/unhide write: not an edit, and not a re-scan trigger
      // keep the hidden URL's offset honest BEFORE anything reads the full body
      var vNow = input.value, vOld = input._cpvVis == null ? vNow : input._cpvVis;
      input._cpvVis = vNow;
      if (input._cpvHide && vOld !== vNow) {
        if (vNow === '') { forget(input); clear(input); }        // wiped the box: the link goes with it
        // The URL is VISIBLE again (select-all + paste, an undo, anything that rewrites the whole
        // caption at once). The record is stale and reinserting on top of it would send the link
        // twice -- drop it and let the scan below re-resolve and re-hide from what is really there.
        else if (vNow.indexOf(input._cpvHide.url) >= 0) { forget(input); }
        else {
          input._cpvHide.cut = shiftPoint(vOld, vNow, input._cpvHide.cut);
          // ...and the moment that guess stops landing on a token boundary, STOP TRUSTING IT. unhide()
          // puts the URL back on screen (repaired if it has to be), so the member can see exactly what
          // is about to be sent, and scan() below re-resolves and re-hides from the real text a tick
          // later -- re-anchoring the offset instead of carrying a drifted one forward. Losing the
          // hide for half a second is cosmetic; splicing into the middle of a word is data loss.
          if (!boundaryOk(vNow, input._cpvHide.cut)) { unhide(input); vNow = input.value; }
        }
      }
      // a URL that was X'd and is then deliberately typed/pasted BACK earns its card again
      var fNow = fullValue(input), fOld = input._cpvFull == null ? fNow : input._cpvFull;
      input._cpvFull = fNow;
      if (input._cpvNo) {
        for (var u in input._cpvNo) { if (fNow.indexOf(u) >= 0 && fOld.indexOf(u) < 0) delete input._cpvNo[u]; }
      }
      // The link this card (or its in-flight fetch) belongs to is no longer in the text: drop it NOW,
      // not 550ms later -- a card for a message that no longer says it is a lie about what will send.
      if (input._cpvUrl && fNow.indexOf(input._cpvUrl) < 0) clear(input);
      // per INPUT (was one shared timer: typing in one box cancelled another box's pending scan), and
      // owned by the input so clear() can cancel it
      if (input._cpvTimer) clearTimeout(input._cpvTimer);
      input._cpvTimer = setTimeout(function () { input._cpvTimer = null; scan(input); }, 550);
    });
    /* Put every hidden URL back BEFORE the form is serialised. Capture phase on document runs ahead of
       every bubble-phase submit handler -- including the composer's own AJAX one, whose FormData(form)
       can be built seconds later while staged uploads finish -- and ahead of a native no-JS submit. From
       here on the textarea holds the full body again, so the bytes on the wire are today's bytes. */
    document.addEventListener('submit', function (e) {
      var f = e.target; if (!f || !f.querySelectorAll) return;
      Array.prototype.forEach.call(f.querySelectorAll('textarea, input'), function (i) { if (i._cpvHide) unhide(i); });
      // A post can FAIL (trial cap, verify wall, network). The URL is safely back in the caption either
      // way -- it is never silently lost -- but re-resolving once the send settles puts the card and the
      // tidy caption back without making the member type a character to get them. data-posting is the
      // composer's own in-flight flag: '1' on send, '' again on failure or on a successful reset.
      if (!f.classList || !f.classList.contains('js-compose') || !window.MutationObserver) return;
      var ta = f.querySelector('textarea[name="body"]');
      if (!ta || ta._cpvPostWatch) return;
      ta._cpvPostWatch = 1;
      var mo = new MutationObserver(function () {
        if (f.getAttribute('data-posting') === '1') return;
        mo.disconnect(); ta._cpvPostWatch = 0;
        setTimeout(function () { scan(ta); }, 220);   // after the 60ms clear below; a no-op on an emptied box
      });
      mo.observe(f, { attributes: true, attributeFilter: ['data-posting'] });
      setTimeout(function () { if (ta._cpvPostWatch) { mo.disconnect(); ta._cpvPostWatch = 0; } }, 180000);
    }, true);
    // sending clears the input programmatically (no input event): drop the preview
    document.addEventListener('submit', function (e) {
      var f = e.target; if (!f || !f.querySelectorAll) return;
      setTimeout(function () { Array.prototype.forEach.call(f.querySelectorAll('textarea, input'), function (i) { if (i._cpv) clear(i); }); }, 60);
    }, true);
    /* A reload mid-compose. restoreDraft() has already put the FULL caption back, URL and all, because
       the draft stores the full body (see draftSaveBody's call site) -- the draft, not the screen, holds
       the truth, so a reload can never be the thing that loses someone's link. Re-resolve it here so the
       card comes back and the URL returns to hiding, exactly as if it had just been typed. */
    (function () {
      var ta = document.querySelector(HIDE_SEL);
      if (!ta || !ta.value || !firstUrl(ta.value)) return;
      ta._cpvVis = ta.value; ta._cpvFull = ta.value;
      scan(ta);
    })();
  })();

  /* ---- grid: play a LIVE preview of each VISIBLE video cell, at NATIVE 1x speed (touch AND desktop) --
     Was hover-only (so touch got nothing). Now an IntersectionObserver plays every on-screen video cell
     muted + looped at normal speed -- calm and glanceable (owner call: play nice and slow, no hyperlapse).
     To stop a long grid from piling up decoders (the same discipline that keeps the pfeed smooth), a cell
     RELEASES its video (drops the src, frees the decoder) the instant it scrolls off; the poster attribute
     keeps the frame visible, so a released cell looks identical to an un-upgraded one. A short settle before
     play means a fast fling flies past cells without churning a decoder for each. ------------------- */
  (function () {
    if (!('IntersectionObserver' in window)) return;
    /* HARD CAP on simultaneous grid decoders (2026-07-21 choppiness audit) ------------------------------
       The >=55%-visible rule below has no ceiling on how MANY cells qualify. A 3-column grid on an iPhone
       shows ~6 rows at once, so a video-heavy stretch can ask for a dozen simultaneous <video> elements,
       and releaseIO's +/-75% margin keeps a dozen more LOADED behind them. iOS Safari allows only a
       handful of live AVPlayer pipelines; past that it silently evicts and re-decodes, and that thrash is
       felt directly as scroll chop (it's the same failure mode RC3 already fixed for the pfeed overlay --
       this is the grid's own version of it, which was never capped).
       So: at most PLAY_CAP cells hold a decoder at any moment. When a new cell wants one and we're at the
       cap, the currently-live cell FURTHEST from the middle of the viewport gives its decoder up -- its
       poster <img> is still underneath, so it looks identical, exactly like a releaseIO release.

       ---- RAISED 2026-08-10 (owner: "only 3 videos are playing simultaneously, we can afford more ...
       increase the number as much as possible while keeping the operations buttery smooth") ------------
       3/6 -> 5/12, and the cap is no longer a bare constant. What the numbers are and why:

       WHAT THE ASK ACTUALLY IS. Measured on the live guest grid (@nojumper, tools/pw/vidcap-grid.js):
       at 390x844 ELEVEN video cells are >=55% visible and THREE play; at 1440x900 nine are visible and
       six play. So the gap is real and it is bigger than the screenshot suggested.

       WHY NOT SIMPLY "EVERYTHING VISIBLE". Because of what each tile decodes. A grid tile plays
       data-video-src, which is the delivered master `_w.mp4` -- 720x1280 on 190 of 384 video posts,
       1080x1920 on 41, 1280x2276 on 15 -- painted into a 120px CSS tile (360 device px at dpr 3). That
       is a 7.1x AREA over-serve at 390 and 13.6x at 1440. Decode cost is resolution x count, so the
       count that is affordable is a function of the resolution, and at today's resolution it is not 11.
       Measured in a controlled lab (tools/pw/vidcap-lab.js: same clip, same GOP, same tile size, only N
       and resolution vary; 3 runs per cell, medians; dropped frames from getVideoPlaybackQuality, which
       is the decoder's own untraced counter, NOT a traced profile and NOT headless raster ms):
           390x844, CPU 4x throttled -- dropped-frame % by simultaneous tiles
                        n=1   n=3   n=4   n=6   n=9   n=12
             360p        0     0     0     0     0     0
             720p        0     0     0     0    0.55  0.55  (first long tasks at 12: 58ms)
             1080p       0     0     0    0.56  1.66  5.44  (long tasks 974ms -- a cliff)
       So at TODAY's 720p the honest ceiling on a 4x-throttled desktop is around 6; at 360p even 12 is
       free. Nine small clips really are cheaper than three large ones -- but we do not have small ones
       on web (there is no sub-1080p MP4 rendition anywhere; the 360p rungs exist only as HLS .ts
       segments, and only for 76% of posts). Until a grid-sized variant exists, the resolution is fixed
       and the count is what we can move.

       WHY 5 ON TOUCH, and it is not a guess. The binding constraint on an iPhone is hardware decode
       pipes, and this box cannot reproduce that -- so the number comes from the owner's OWN device.
       The native app measured 340 pool dumps on ios/26.5.2 counting ADVANCING clips (play:true AND
       t>0, i.e. genuinely painting rather than merely claiming to): 4 advancing in 22.1% of dumps,
       5 in 35.6%, 6 in only 2.9%, 7 once ever (see hero.js MAX_LIVE_GRID_IDLE). Five is the saturation
       point, not a cliff. Web at 3 was therefore BELOW even what the app already allows itself (4), on
       the same hardware, while decoding four times the pixels. 5 brings web to the measured device
       ceiling and covers the owner's screenshot (4 tiles visible) with a slot to spare.
       Beyond 5 on touch is NOT available by raising a number -- it needs the resolution cut. Said
       plainly so nobody re-litigates it from the armchair.

       WHY 12 ON DESKTOP. Desktop is not decode-pipe bound and the line does not care: unthrottled at
       1440 the lab holds 0.00% drops at n=9 (see the table in the report). 12 covers a full screenful
       (nine visible on the measured profile) with headroom, and the valve below catches the rest.

       AND IT IS A BUDGET WITH A VALVE, NOT A CONSTANT. A fixed number is wrong on the two devices that
       matter most -- the weak phone it is too high for and the strong desktop it is too low for -- so
       playCap() backs off on evidence rather than on a guess:
         * a LOW-RAM device (deviceMemory <= 2) never exceeds 3, i.e. today's behaviour, unchanged.
         * the adaptive memory guard relieves it (__rovaGridRelieve, called from _memGuard) -- an
           existing, trusted, heap-keyed mechanism, not a new one.
         * DROPPED FRAMES would relieve it too, and the code is here and works -- but it is OFF by
           default. Read the next paragraph before turning it on.
       Relief floors at the PRE-CHANGE cap (3 touch / 6 desktop) for 20s, re-armed while the pressure
       lasts, so a struggling device degrades to exactly its old behaviour and never below it.

       ---- WHY THE DROPPED-FRAME TRIGGER SHIPS OFF (__rovaGridDropValve), AND WHAT WOULD TURN IT ON --
       This is the honest part. getVideoPlaybackQuality().droppedVideoFrames is the right signal in
       principle -- it is the decoder's own untraced admission that it is not keeping up -- and the
       sampler below is written, wired and proven to fire (tools/pw/vidcap-valve.js: cap 12 -> 3 within
       2.3s at CPU 8x, live tiles 9 -> 3, relief releasing cleanly afterwards).
       IT CANNOT BE CALIBRATED ON THIS BOX. Measured with tools/pw/vidcap-droprate.js on the live grid,
       an IDLE 32GB desktop, nothing throttled:
             1 tile  -> 56.3% of frames reported dropped (median of 8 samples)
             3 tiles -> 55.9%
             9 tiles -> 67.1%
       A single tile on an idle machine does not drop 56% of its frames. The counter is reading
       headless presentation -- there is no display and no vsync to present to -- so it is very nearly
       independent of the load it is supposed to measure. Any threshold picked against those numbers is
       picked against noise, and a valve calibrated on noise fires on healthy devices: with it enabled
       this change made DESKTOP WORSE, pinning it to 3 where it had been running 6 for months. That is
       the opposite of what was asked for, and it is why the floor above exists as well.
       TO TURN IT ON, someone has to read the same three numbers from a REAL browser on a REAL display
       -- ideally the owner's own iPhone, which is the device the touch cap is for. If a healthy device
       reads near 0% and a struggling one reads percent-scale, set the threshold above the healthy
       reading and set window.__rovaGridDropValve = true. Until then the raise stands on the two
       measurements that ARE trustworthy: the lab's resolution/count curve and the app's on-device
       advancing-clip census. Do not enable this on the strength of a headless run.

       NOTHING IS EVER REFUSED. This stays an admission-by-eviction cap exactly as it was -- a start is
       always granted and the furthest-from-centre holder gives way -- so none of the starvation or
       retry-storm failure modes of the feed's refusal-based attempt (see the VS_CAP scheduler note
       near attachHls) are reachable here. Only the number moves, and now the number can move down.
       The drop sampler is read inside enforceCap AND from one 3s module-level watch; see the long note
       on armValveWatch for why the lazy-only version was measurably a valve that never fired. */
    /* 10 ON TOUCH SINCE 2026-08-10, AND THE PARAGRAPHS ABOVE ARE NOW HISTORY -- READ THIS FIRST.
       Everything above explains why 5 was the ceiling: the tile decoded the DELIVERED MASTER
       (720p-1080p+) into a 120px cell, so the count was the only lever and the owner's device
       said 5. The rendition now exists -- views/_feed_grid.php and views/_profile_posts.php hand
       the tile `<stem>_w_grid480.mp4` via lib/view.php's grid_video_src(), 480 on the short side
       and no audio track -- and the measured decoded area per tile fell from a median 921,600 px
       (max 2.91 MP) to 230,400. The premise the 5 rested on is gone, so the number moves, at the
       owner's explicit direction ("up the cap to 10").

       DESKTOP STAYS AT 12. It was never decode-pipe bound -- unthrottled at 1440 the lab holds
       0.00% drops at n=9 -- and 12 already covers a full screenful with headroom. Raising a
       number that was not binding buys nothing and spends decoders; the guard below now protects
       it too, which is the actual improvement for desktop.

       ---- THE STARVATION CEILING: WHY 10 IS SAFE TO ASK FOR ------------------------------------
       The failure mode of overshooting is NOT stutter, it is FROZEN TILES. Browsers and phones
       have a hard limit on simultaneous hardware decodes, and past it an element does not error
       and does not fire anything -- it silently never starts. Ten still tiles look far worse than
       five moving ones, and that asymmetry is exactly why the app-side census stopped at 5.
       So the cap is asked for, not assumed: every tile we tell to play is stamped, and a tile that
       was told to play and NEVER ADVANCED is counted. That signal is available on every device and
       needs no calibration -- unlike droppedVideoFrames, which reads 56% for a SINGLE tile on an
       idle desktop here and is left OFF (__rovaGridDropValve) for exactly that reason. This is a
       different and better-founded trigger, not that one.

       READY-STATE GATED, so a slow line is not mistaken for a full decoder. A tile still
       downloading has readyState < 3 and is NOT counted: it has nothing to decode yet. Only a tile
       that HAS playable data and still has not moved after 2.5s is starved. Hidden tabs are
       excluded outright (everything is paused there, which would read as universal starvation).

       WHAT A 6-DECODE DEVICE DOES. It grants 10, six start, four sit at readyState>=3 with
       currentTime frozen. One census later starved=4 >= 2, the ceiling latches to the observed
       advancing count (6), enforceCap evicts down to 6, and the surface runs SIX SMOOTH TILES --
       not ten stuttering ones. It then probes back up by one every 30s while nothing starves, so a
       device that was briefly busy climbs back to 10 on its own and a genuinely 6-pipe device sits
       at 6 forever. The ceiling can never go below reliefFloor() (3 touch / 6 desktop), the same
       floor the memory valve uses, so the worst case of a wrong reading is the behaviour this grid
       shipped with for months. */
    var CAP_TOUCH = 10, CAP_DESKTOP = 12;
    var _relievedUntil = 0;                          // set by the drop sampler / the memory guard
    /* One sample per element, kept ON the element, so the ratio is a DELTA and not a lifetime average.
       A lifetime average is the wrong statistic here: a tile that dropped frames while it was starting
       would hold the cap down for the rest of the session long after it settled. */
    function dropPressure() {
      var tot = 0, drop = 0;
      for (var i = 0; i < live.length; i++) {
        var v = live[i].querySelector('video.pcell-video');
        if (!v || !v.getVideoPlaybackQuality) continue;
        var q; try { q = v.getVideoPlaybackQuality(); } catch (e) { continue; }
        /* THE FIRST SAMPLE OF AN ELEMENT IS A BASELINE, NEVER A MEASUREMENT. Without this the first
           delta for a clip is its whole lifetime, and a clip's lifetime STARTS with the startup
           transient -- first decode, first paint, the seek on a collapse-landing tile -- which is
           reliably the worst drop rate it will ever post. Counting that fired the valve on a healthy
           unthrottled desktop and pinned it at 3: measured, 3 runs of 3, playing=3 where the cap is
           12 and the machine was idle. A tile has to have been WATCHED for an interval before it is
           allowed to vote on whether the device is coping. */
        var first = !v._gqSeen; v._gqSeen = 1;
        var pt = v._gqT || 0, pd = v._gqD || 0;
        v._gqT = q.totalVideoFrames; v._gqD = q.droppedVideoFrames;
        if (first) { continue; }
        if (q.totalVideoFrames >= pt) { tot += q.totalVideoFrames - pt; drop += q.droppedVideoFrames - pd; }
      }
      return tot >= 120 ? drop / tot : 0;             // don't believe a ratio built from a tiny sample
    }
    /* RELIEF FLOORS AT THE OLD BEHAVIOUR, IT DOES NOT GO BELOW IT. 3 on touch and 6 on desktop are
       exactly what this grid did before 2026-08-10. Flooring here is what makes the whole valve safe
       to ship: if the trigger is ever wrong, the worst it can do is give back the raise, and the
       surface lands on the number it shipped with for months. A valve that can take a surface BELOW
       its own proven baseline is not a safety mechanism, it is a new failure mode -- and this one
       did exactly that in testing, pinning an idle 32GB desktop to 3 where it used to run 6. */
    function reliefFloor() { return (window.matchMedia && matchMedia('(hover:none)').matches) ? 3 : 6; }
    function baseCap() {
      var cap = (window.matchMedia && matchMedia('(hover:none)').matches) ? CAP_TOUCH : CAP_DESKTOP;
      /* THE LOW-RAM CLAMP IS A CHROME/ANDROID SIGNAL AND NOTHING ELSE, and this comment is here so
         nobody reads it as covering phones generally. navigator.deviceMemory is not implemented in
         WebKit, so it is `undefined` on every iPhone and iPad and this line has never once run for
         an iOS reader -- the same hole navigator.connection has, documented at __rovaNetSlow.
         DELIBERATELY NOT REPLACED WITH A GUESS. hardwareConcurrency is the usual substitute and it
         does not measure what this needs: iOS caps and rounds what it reports, and core count is not
         decoder count anyway -- the thing being clamped here is how many H.264 pipes the device can
         run at once. The honest iOS-viable signal is the one directly below: the STARVATION CEILING,
         which measures the pipe count by observation on any device, and which now survives a reload
         so a phone pays for that observation once instead of on every page load. So: kept where it
         works, and no pretence that it applies where it does not. */
      if (navigator.deviceMemory && navigator.deviceMemory <= 2) { cap = Math.min(cap, 3); }
      return cap;
    }
    /* THE OBSERVED DECODE CEILING. 0 = never seen one, i.e. this device has not yet failed to
       start a tile and gets the full budget. Sticky once set (a hardware pipe count does not
       fluctuate) but probed upward while nothing starves, so a device that was merely busy for a
       moment is not punished for the rest of the session. */
    var _decodeCeiling = 0, _ceilProbeAt = 0, _advHigh = 0, _lastCensus = { advancing: 0, starved: 0 };

    /* ---- ...AND IT IS REMEMBERED ACROSS LOADS (2026-08-11) ----------------------------------------
       The guard works on iOS Safari -- it reads currentTime, readyState and a rejected play(), all of
       which WebKit has -- but it was re-learning the device's ceiling from scratch on every single
       page load. Learning costs one 3s census at the full budget, so a 6-pipe phone opened ten tiles,
       stuttered, settled at six, and then did the whole thing again on the next navigation. The
       observation is about the HARDWARE; there is no reason to buy it twice.

       KEYED TO THE DEVICE, NOT JUST THE BROWSER. Screen metrics, DPR, the coarse-pointer answer and
       the core count together are enough to notice "this is not the machine that wrote this" -- a
       shared desktop profile, a phone that rotated into a desktop-width iPad layout, a browser moved
       to an external display. A key mismatch is treated as no reading at all.

       IT EXPIRES, AND THAT IS THE POINT. 12 hours. A pipe count is hardware, but the CONDITIONS that
       produce a low reading are not: Low Power Mode, a hot phone, a browser with forty tabs open. A
       reading that never expired would hold a device at 6 for the rest of its life because of one bad
       afternoon. Twelve hours re-learns by tomorrow morning and still covers a whole session.

       IT IS A STARTING POINT, NEVER A CAGE. The restored value goes in with _ceilProbeAt unset, so the
       existing +1-every-30s probe applies to it exactly as it applies to one learned live: a device
       that was merely busy yesterday climbs straight back to the full budget today, and reaching
       baseCap() clears the stored reading outright. It is also clamped into [reliefFloor(), baseCap())
       on the way in, so a corrupt or stale number can never take the grid below the behaviour it
       shipped with for months -- the same floor the live path is bound by.

       STORAGE CAN THROW (Safari private browsing, storage disabled, a full quota) and every access
       here is wrapped. A device that cannot remember simply behaves as it did before this existed. */
    var CEIL_KEY = 'rova.gridCeil', CEIL_TTL = 12 * 3600 * 1000;
    function deviceKey() {
      try {
        return [screen.width, screen.height, Math.round((window.devicePixelRatio || 1) * 100),
                (window.matchMedia && matchMedia('(hover:none)').matches) ? 't' : 'd',
                navigator.hardwareConcurrency || 0].join('x');
      } catch (e) { return '?'; }
    }
    function loadCeiling() {
      var raw; try { raw = localStorage.getItem(CEIL_KEY); } catch (e) { return 0; }
      if (!raw) { return 0; }
      var o; try { o = JSON.parse(raw); } catch (e) { return 0; }
      if (!o || o.k !== deviceKey() || !(o.at > 0) || Date.now() - o.at > CEIL_TTL) { return 0; }
      var v = parseInt(o.v, 10);
      if (!(v > 0) || v >= baseCap()) { return 0; }      // nonsense, or "unrestricted" -- take the full budget
      return Math.max(v, reliefFloor());
    }
    function saveCeiling(v) {
      try {
        if (!v) { localStorage.removeItem(CEIL_KEY); return; }
        localStorage.setItem(CEIL_KEY, JSON.stringify({ v: v, at: Date.now(), k: deviceKey() }));
      } catch (e) {}
    }
    _decodeCeiling = loadCeiling();
    var STARVE_MS = 2500;
    /* A tile is STARVED when it was told to play, HAS PLAYABLE DATA (readyState >= 3, so this is
       not a slow download), and its clock has still not moved 2.5s later. `_grAskAt` is cleared
       the moment a tile is seen advancing, so this only ever counts a FAILURE TO START -- the
       unambiguous symptom of a full decoder -- and never a tile that started and later stalled,
       which is dropped-frame territory this box cannot measure honestly. */
    function starvationCensus() {
      var advancing = 0, starved = 0, now = Date.now();
      for (var i = 0; i < live.length; i++) {
        var v = live[i].querySelector('video.pcell-video');
        if (!v) { continue; }
        if (!v._grAskAt) { if ((v.currentTime || 0) > 0.05) { advancing++; } continue; }
        if ((v.currentTime || 0) > (v._grAskT || 0) + 0.05) { v._grAskAt = 0; advancing++; continue; }
        if (v._grPlayRej || (v.readyState >= 3 && now - v._grAskAt > STARVE_MS)) { starved++; }
      }
      return { advancing: advancing, starved: starved };
    }
    function playCap() {
      if (typeof window.__rovaGridCap === 'number') { return window.__rovaGridCap; }   // A/B + harness override
      var cap = baseCap();
      if (Date.now() < _relievedUntil) { cap = Math.min(cap, reliefFloor()); }
      if (_decodeCeiling) { cap = Math.min(cap, _decodeCeiling); }
      return cap;
    }
    /* The safety valve, reachable from the adaptive memory guard (different IIFE scope). Deliberately
       does NOT tear anything down itself -- it lowers the budget and lets the ordinary eviction path
       do the work, so relief and a normal grant take exactly the same code path. */
    window.__rovaGridRelieve = function (ms) {
      _relievedUntil = Date.now() + (ms || 20000);
      try { enforceCap(null); } catch (e) {}
    };
    // The sustained-jank governor (__rovaJank) moves __rovaGridCap and needs the eviction to happen
    // NOW, not on the next start -- same path a normal grant takes, nothing new. No relief window.
    window.__rovaGridEnforce = function () { try { enforceCap(null); } catch (e) {} };
    window.__rovaGridCapStats = function () {
      return { cap: playCap(), base: baseCap(), touch: !!(window.matchMedia && matchMedia('(hover:none)').matches),
               live: live.length, relievedFor: Math.max(0, _relievedUntil - Date.now()),
               // the starvation ceiling, for a REAL device to report from: `ceiling` is 0 while the
               // device has never failed to start a tile, otherwise the count it actually manages.
               ceiling: _decodeCeiling, advHigh: _advHigh, census: starvationCensus(), lastCensus: _lastCensus,
               // what is on disk for this device right now, and the key it is filed under -- so a
               // reader reporting from a real phone can say whether the ceiling was REMEMBERED or
               // re-learned, which is the whole question this persistence answers.
               stored: loadCeiling(), deviceKey: deviceKey() };
    };
    /* ---- WHY THIS TIMER EXISTS, AND WHY IT IS NOT THE BUSY-LOOP THAT KILLED THE LAST ATTEMPT ---------
       The valve was FIRST written sampled only inside enforceCap, on the reasoning that a lazy check
       costs nothing and that the feed's refusal-based attempt died of a 220ms per-clip re-arm. That
       reasoning was half right and the result was a valve that never fired. MEASURED, not reasoned:
       tools/pw/vidcap-valve.js on the live desktop grid at CPU 8x sat at 9 live tiles and 63% dropped
       frames for 32 seconds with relievedFor stuck at 0.
       The hole: enforceCap runs only from ensureVideo, i.e. only when a NEW cell wants a slot. A grid
       that has settled -- every visible cell already live, nobody scrolling -- never calls it again.
       And that settled, struggling state is EXACTLY the one the valve exists for. A check that cannot
       run in the state it is designed for is decoration.
       So: one interval, for the whole module, that no-ops unless there is something to protect. The
       difference from the attempt that failed is not the presence of a timer, it is the shape:
         * ONE timer for the module, not one re-arm per clip. The feed attempt had forty refused clips
           each re-taking a whole-document census several times a second.
         * It takes no census and touches no DOM. dropPressure() reads a counter off elements already
           in `live` -- no querySelectorAll, no getBoundingClientRect.
         * It only runs while live.length > 3, i.e. only while the cap is raised above the old
           behaviour. At or below 3 this costs one comparison every 3s.
         * It STOPS ITSELF. Nothing re-arms it while the grid is idle, so a page with no grid, or a
           grid with nothing playing, carries no timer at all.
       3s, not 220ms: this is steering a budget, not gating a start. Nothing waits on it. */
    var _valveT = 0;
    function armValveWatch() {
      if (_valveT || live.length <= 1) { return; }
      _valveT = setInterval(function () {
        if (live.length <= 1) { clearInterval(_valveT); _valveT = 0; return; }   // nothing to protect: stand down
        // ...and never during an open/dismiss flight: starvationCensus() reads every live tile, and a tick
        // landing mid-collapse both steals the frame and votes on a grid that is being rebuilt anyway
        // (exactly the "this grid is busy" reading the settled-census rule exists to reject).
        if (window.__rovaFlightBusy && window.__rovaFlightBusy()) { return; }
        /* THE STARVATION CEILING RUNS UNCONDITIONALLY -- it is not the dropped-frame valve and is
           not gated on __rovaGridDropValve. See the long note by CAP_TOUCH: "was told to play and
           never advanced" needs no threshold calibration, so it is safe to ship armed, which is
           precisely what the dropped-frame signal is not. */
        if (document.visibilityState === 'visible') {
          var cen = _lastCensus = starvationCensus();
          /* THE HIGH-WATER MARK IS THE PIPE COUNT, NOT THE INSTANT READING. A device that has
             ever run six tiles at once can run six; a census that happens to catch it running
             two says nothing about its ceiling. This distinction is not theoretical -- it is
             the bug this guard shipped with for about an hour, caught by tools/pw/gridvar-cap.js
             simulating a 6-pipe device: mid-scroll the grid tears tiles down and rebuilds them,
             so a tick landed on advancing=2 with a couple still frozen, the ceiling ratcheted to
             the floor of 3, and the surface sat at 3 on a device that was comfortably managing
             six. A guard that fires when it should not is worse than no guard. */
          if (cen.advancing > _advHigh) { _advHigh = cen.advancing; }
          /* SETTLED CENSUSES ONLY. During a scroll a tile is legitimately neither advancing nor
             starved -- it is being built, or its data is still arriving -- and those ticks must
             not vote. Requiring almost every live tile to have RESOLVED one way or the other is
             what separates "this device is full" from "this grid is busy rebuilding". */
          var settled = (cen.advancing + cen.starved) >= (live.length - 1);
          if (cen.starved >= 2 && settled) {
            /* LATCH TO WHAT THE DEVICE HAS ACTUALLY MANAGED. Not cap-1, not a halving: the most
               tiles ever seen advancing at once IS the pipe count, and settling exactly there is
               what turns ten frozen tiles into six smooth ones. Only ever ratchets DOWN here;
               the probe below is the only way back up. */
            var obs = Math.max(_advHigh, reliefFloor());
            if (!_decodeCeiling || obs < _decodeCeiling) {
              _decodeCeiling = obs;
              _ceilProbeAt = Date.now();
              saveCeiling(_decodeCeiling);       // so the next load starts here instead of re-learning
              enforceCap(null);
            }
          } else if (_decodeCeiling && live.length >= _decodeCeiling && Date.now() - _ceilProbeAt > 30000) {
            // pressing against the ceiling with nothing starving for 30s: try one more.
            _ceilProbeAt = Date.now();
            _decodeCeiling = _decodeCeiling + 1;
            if (_decodeCeiling >= baseCap()) { _decodeCeiling = 0; }   // fully recovered -> unrestricted
            // Persist the probe too, in both directions: a device that climbed back to the full budget
            // must not be handed yesterday's low reading on the next load, so 0 CLEARS the entry.
            saveCeiling(_decodeCeiling);
          }
        }
        if (!window.__rovaGridDropValve) { return; }                            // OFF by default -- see below
        if (dropPressure() > 0.06) { _relievedUntil = Date.now() + 20000; enforceCap(null); }
      }, 3000);
    }
    var live = [];                                   // cells that currently hold a <video>
    function centerDist(cell) {
      var r; try { r = cell.getBoundingClientRect(); } catch (e) { return 1e9; }
      if (!r.height) return 1e9;                     // detached / display:none -> evict first
      var vh = window.innerHeight || 800;
      return Math.abs((r.top + r.bottom) / 2 - vh / 2);
    }
    function enforceCap(exempt) {
      live = live.filter(function (c) { return c.isConnected && c.querySelector('video.pcell-video'); });
      /* THE DROPPED-FRAME VALVE, same trigger as the watch below and OFF by the same flag -- see the
         calibration note in the header for why it is off and what would turn it on. 6% came from the
         lab table (the 720p arm sits at 0.55% where it is comfortable; the 1080p arm reaches 5.44% at
         the count that also produced ~1s of long tasks), and that threshold is only meaningful once
         the signal itself has been validated on a real display. */
      if (window.__rovaGridDropValve && live.length > 3 && dropPressure() > 0.06) {
        _relievedUntil = Date.now() + 20000;
      }
      armValveWatch();
      var cap = playCap();
      while (live.length > cap) {
        var worst = null, worstD = -1;
        for (var i = 0; i < live.length; i++) {
          if (live[i] === exempt) continue;
          var d = centerDist(live[i]);
          if (d > worstD) { worstD = d; worst = live[i]; }
        }
        if (!worst) break;
        clearTimeout(worst._grT);
        release(worst);                              // splices it out of `live`
      }
    }
    function ensureVideo(cell) {
      var v = cell.querySelector('video.pcell-video');
      if (v) return v;
      // Sustained-jank governor at its 0-decoder rung (__rovaJank rung 4): admission-by-eviction would
      // still grant the newcomer, so the ONE place a cap of 0 can mean zero is here -- decline to build.
      // The poster <img> stays up; play() returns on null exactly as it does for a parked cell.
      if (window.__rovaGridCap === 0) return null;
      // PARKED ON A PHOTO SLIDE: a photo dismiss re-pointed this cell's cover <img> at slide N's image
      // and stamped data-gr-slide=N (see __rovaGridStampPhoto). Overlaying the cover CLIP now would put
      // media 0 on screen under a claim that says N -- exactly the disagreement the stamp exists to
      // prevent -- so hold off while the park is genuinely still in place. __rovaGridStampRead drops the
      // park (and restores the cover src) the moment it stops being true, and this rebuilds as usual.
      var _pk = cell._grPark;
      if (_pk && _pk.img && _pk.img.isConnected && (_pk.img.getAttribute('src') || '') === _pk.src) { return null; }
      var holder = cell.querySelector('img.pcell-video[data-video-src]');   // POSTER img only (skip icon-only spans / still-optimizing)
      if (!holder) return null;
      var src = holder.getAttribute('data-video-src'); if (!src) return null;
      v = document.createElement('video');
      v.className = 'pcell-video';
      // CARRY THE FIT HINT (0144) OVER FROM THE POSTER. This element replaces the <img> as the
      // thing the grid-tap hero flies (heroExpand's isVideoHero branch), and that flight predicts
      // its landing box from __rovaVideoCovers -- which reads data-fit off the node it is given.
      // The attribute is stamped on the poster <img> by views/_feed_grid.php / _profile_posts.php;
      // if it did not travel here, a hinted clip would be predicted filled and then paint
      // contained, which is the ballooning open in clip form.
      var _fh = holder.getAttribute('data-fit');
      if (_fh === 'contain' || _fh === 'cover') { v.setAttribute('data-fit', _fh); }
      /* data-g3: TRAVELS FOR THE SAME REASON data-fit does, and it is stamped by the same two
         views (lib/view.php's grid_tile_video_attrs, which resolves the URL and this marker
         together so they cannot disagree). Its presence means this tile is playing the
         3-SECOND preview rendition rather than a full-length one, and its value is the
         master-time multiplier (VideoJobs::GRID3_SPEED, 1.0 today).
         WHY THE ELEMENT NEEDS IT AND NOT JUST THE CELL: the <video> outlives its cell context
         in the two places that matter most -- the open handler flies this element, and the
         close handler seeks it back -- so an element that cannot answer "what clock am I on"
         is one a future edit will get wrong. Copied here, it is self-describing anywhere. */
      var _g3 = holder.getAttribute('data-g3');
      if (_g3) { v.setAttribute('data-g3', _g3); }
      /* data-g6: TRAVELS FOR THE SAME REASON, and on this element it matters MORE than
         data-g3 does. It says this tile's file is a PALINDROME, so its position folds at the
         halfway mark instead of running straight. The landing dissolve reads the marker off
         the FLOWN ELEMENT -- by then the element has left its cell entirely and the cell may
         already be showing something else -- so an element that cannot answer "does my clock
         fold" is one that gets mapped linearly and lands the master up to a whole window
         away from the frame the reader tapped. */
      var _g6 = holder.getAttribute('data-g6');
      if (_g6) { v.setAttribute('data-g6', _g6); }
      /* data-master: TRAVELS FOR THE SAME REASON AGAIN, and it is the only one of the three
         that is about a DIFFERENT file. It is the master the pfeed will render (emitted by
         lib/view.php's grid_tile_video_attrs beside the `_grid6` URL, so the two can never
         disagree), and the lift-off round needs it at the last synchronous moment of the tap
         -- when the viewer's own <video> does not exist yet -- to start the one element that
         can actually make a sound. The tap handler is handed this ELEMENT, not the cell, and
         by then the element may already have left the cell (it is what heroExpand flies), so
         an element that cannot answer "what is my master" is one the audio arm silently
         skips. Copied here, the whole open is self-describing off the flown node. */
      var _gm = holder.getAttribute('data-master');
      if (_gm) { v.setAttribute('data-master', _gm); }
      // ORPHAN GUARD: a grid preview is the element the hero flies out of the page, so it is exactly the
      // kind of clip that can end up detached and still running. wire() never sees it (it is not
      // `.post .media video`), so register it here. See __rovaStopOrphanMedia.
      if (window.__rovaTrackMedia) { try { window.__rovaTrackMedia(v); } catch (e) {} }
      v.dataset.grSrc = src;                              // stash so we can drop + re-attach the src on scroll-off/on
      v.crossOrigin = 'anonymous';                        // CDN sends ACAO:* (verified live) -> lets the hero-zoom
      /* EVERY ATTRIBUTE THAT STEERS THE LOAD IS SET BEFORE THE SRC (2026-08-11). `preload` was
         assigned two lines BELOW `v.src` and was therefore dead: assigning src runs the media load
         algorithm immediately, so by the time the hint arrived the fetch had already been chosen and
         started. The element then pulled on its own default (`auto` in Chrome/Edge) instead of
         metadata -- a whole grid tile's clip where a header was asked for. `muted` moves up with it:
         an unmuted-at-load-time clip is the autoplay-eligibility check the platform makes against
         the state at load, and the same reasoning applies. Order is the entire fix; the values are
         unchanged. */
      v.muted = true; v.defaultMuted = true; v.setAttribute('muted', '');
      v.loop = true; v.playsInline = true; v.setAttribute('playsinline', '');
      v.preload = 'metadata';
      v.src = src;                                        // canvas-capture the EXACT current frame WITHOUT tainting
      // Keep the POSTER thumbnail (the <img>) as the visible backdrop and OVERLAY the video on top, HIDDEN,
      // until it has actually decoded a frame. Browsers (esp. mobile) paint a <video> BLACK before its first
      // frame -- that's the "black boxes while media loads" the owner saw. The poster stays up the whole time
      // the clip downloads, so the grid reads as fully loaded; the video fades in once it can really paint.
      v.style.cssText = 'position:absolute;inset:0;opacity:0;transition:opacity .18s ease';
      var reveal = function () { v.style.opacity = '1'; };
      // stash the ref so pfeed donor-adoption can REMOVE these before they set inline opacity 1 on the
      // clip mid-hero-flight (that inline value beat the html.hz-hold hide rule and painted the full
      // clip behind the small zooming still -- the /p/1174 "clip visible behind the still" report).
      v._grReveal = reveal;
      // (A LIVE collapse never reaches here for its landing tile -- play() reparents pv directly instead --
      // so no special-casing: fade the fresh clip in over the poster the moment it can paint, as always.)
      v.addEventListener('loadeddata', reveal, { once: true });
      v.addEventListener('playing', reveal, { once: true });
      if (v.readyState >= 2) { reveal(); }
      cell.appendChild(v);                                 // OVERLAY -- do NOT replace the poster <img>
      // This cell is back on its OWN cover clip (built from img.pcell-video[data-video-src]), so any
      // "I am parked on slide N" stamp left by a previous minimize is now a lie -- drop it, or the next
      // tap would open the deck on a slide this tile no longer shows. Paired with the close-side stamp.
      // Via gridUnpark so the JS-side proof (_grHold) dies with the attribute, never half of each.
      try { if (window.__rovaGridUnpark) { window.__rovaGridUnpark(cell, false); } else { cell.removeAttribute('data-gr-slide'); } } catch (e) {}
      if (live.indexOf(cell) < 0) { live.push(cell); }
      enforceCap(cell);                                    // this cell is the newcomer: never evict it
      return v;
    }
    function play(cell) {
      // LANDING TILE of a LIVE collapse: the flight REPARENTS its own still-playing <video> into this tile
      // (timeline-style direct land -- see the grid-dismiss close). Do NOT rebuild a second clip here; that
      // two-element handoff was the source of the rewind + black-flash glitches. Skip entirely; pv lands.
      if (cell._pfHandoff && (Date.now() - cell._pfHandoff) < 3000) { return; }
      var v = ensureVideo(cell); if (!v) return;
      /* A LANDED TILE MUST STILL COUNT AGAINST THE DECODER BUDGET. ensureVideo only registers a cell in
         `live` on the branch where IT built the element -- and the close's direct-land reparents a clip
         into the tile without ever going through that branch, so every dismissal produced a playing tile
         the cap could not see. On a phone that is how the simultaneous-<video> ceiling gets quietly
         exceeded, which is itself a source of the eviction stutter this whole flight is about. Registering
         is enough: enforceCap runs on the next build and will then be counting the truth. */
      if (live.indexOf(cell) < 0) { live.push(cell); }
      if (!v.getAttribute('src') && v.dataset.grSrc) { v.src = v.dataset.grSrc; }     // re-attach a released clip
      // LAND BACK ON FRAME (still-clone fallback path, readyState<2 collapse): the immersive viewer just
      // closed and collapsed into THIS tile, so resume its preview at the frame the viewer was on (stashed by
      // the pfeed close), not from 0. One-shot + id-matched; the mp4 is cached so the seek is quick.
      var gs = window.__rovaGridSeek;
      if (gs && (Date.now() - gs.at) < 4000 && cell.getAttribute && cell.getAttribute('data-id') === gs.id) {
        window.__rovaGridSeek = null;
        // ONLY resume-seek a tile that is genuinely BEHIND the target (freshly rebuilt at ~0, or paused).
        // A tile that has ALREADY played forward past it is a stale gs re-applied AFTER the handoff already
        // landed and the preview ran on -- seeking it back there is the "lands, plays, then rewinds ~1-2s
        // later" bug the flight log caught (seek 6.45 -> 4.49 @2465ms). Never yank a playing tile backward.
        var behind = v.paused || (v.currentTime || 0) < gs.t + 0.25;
        if (gs.t > 0.05 && behind) {
          // HOLD the overlay hidden until the seek lands. A freshly rebuilt <video> fires loadeddata on
          // frame 0 (-> reveal), and then this seek makes the now-VISIBLE element composite BLACK until
          // the target frame decodes -- that black tile mid-collapse was the "video lands, snaps to black
          // and rewinds" dismissal glitch. Keep the poster showing instead and reveal on 'seeked' (capped
          // so a stalled seek can never leave the overlay hidden forever).
          if (v._grReveal) { v.removeEventListener('loadeddata', v._grReveal); v.removeEventListener('playing', v._grReveal); }
          v.style.opacity = '0';
          var revealed = false;
          // vfMark hands the recorder this rebuilt clip: the log shows the exact clock the tile
          // revealed on vs the flight's target -- the timecode-consistency number for the landing
          var rev = function () { if (revealed) return; revealed = true; if (window.__rovaVfCross) { window.__rovaVfCross(v); } v.style.opacity = '1'; if (window.__rovaVfMark) { window.__rovaVfMark('tileReveal', v); } };
          v.addEventListener('seeked', rev, { once: true });
          setTimeout(rev, 900);
          var seekTo = function () { try { var d = v.duration || 0; if (d) { v.currentTime = Math.min(gs.t, d - 0.1); } else { rev(); } } catch (e) { rev(); } };
          if (v.readyState >= 1 && v.duration) { seekTo(); } else { v.addEventListener('loadedmetadata', seekTo, { once: true }); }
        }
      }
      // native 1x -- no playbackRate override, so the preview plays "nice and slow" at normal speed
      /* STAMP THE ASK. This is the input to the starvation census (see CAP_TOUCH): the clock we
         asked from, and when. The census clears _grAskAt the moment the tile is seen past it, so
         a stamp that survives is a tile that never started -- the symptom of a full decoder.
         A REJECTED play() IS THE SAME FACT, STATED FASTER, so it is recorded rather than
         swallowed: NotAllowedError is the autoplay policy (these clips are muted, so it should
         not happen) and AbortError is a pause/teardown racing the load -- neither is a decode
         failure and neither counts. Anything else means the element refused to start. */
      if (v.paused) {
        v._grAskAt = Date.now(); v._grAskT = v.currentTime || 0; v._grPlayRej = 0;
        var p = v.play();
        if (p && p.catch) {
          p.catch(function (e) {
            var n = (e && e.name) || '';
            if (n !== 'NotAllowedError' && n !== 'AbortError') { v._grPlayRej = 1; }
          });
        }
      }
    }
    function release(cell) {
      var li = live.indexOf(cell); if (li >= 0) { live.splice(li, 1); }
      var v = cell.querySelector('video.pcell-video'); if (!v) return;
      // The poster <img> was kept as the backdrop (see ensureVideo), so just DROP the overlay video: the
      // thumbnail underneath shows instantly (no black), and the decoder is freed for iOS's simultaneous-
      // video limit. ensureVideo() re-overlays a fresh clip when the cell scrolls back into view.
      // Drop the starvation stamp with the clip: a released element must not vote in the census,
      // and a re-attached one is a fresh ask, not a 20-second-old failure to start.
      v._grAskAt = 0; v._grAskT = 0; v._grPlayRej = 0;
      if (v._hls) { try { v._hls.destroy(); } catch (e) {} v._hls = null; v._hlsWired = 0; }   // a landed viewer clip on a ladder
      try { v.pause(); v.removeAttribute('src'); v.load(); } catch (e) {}
      if (v.parentNode) { v.parentNode.removeChild(v); }
    }
    // RC3 (iOS decoder-cap sluggishness): free EVERY grid tile decoder while the immersive viewer is open. The
    // grid is a static layer fully covered by the overlay, so its decoders are pure waste that stack on top of
    // the pfeed's own clips -> the simultaneous-<video> count blows past the iOS pipeline cap, forcing the OS to
    // evict + re-decode (the stutter). The poster <img> backdrop stays, so no black; _grWatch's play() rebuilds
    // each on close. Spare the DONOR cell (its clip is about to be adopted into the viewer) so we don't rip its
    // buffer out from under the handoff.
    /* IS THIS TILE ON THE 3-SECOND PREVIEW, AND AT WHAT MASTER-TIME RATE?
       Returns 0 when the tile plays a full-length rendition (`_grid480` or the master),
       otherwise the multiplier that converts TILE time to MASTER time.

       ONE READER, THREE CALLERS, and that is the point of hoisting it to a global: the
       open handler, the close handler and the tile's own resume seek all have to make the
       same judgement, and they live in three different IIFEs (this file is not one). A
       tile whose clock is 3 seconds long and a tile whose clock is the whole clip need
       opposite handling at every one of them, so the test must not be re-typed.

       ASKS THE ELEMENT FIRST, THEN THE CELL. ensureVideo copies the attribute onto the
       <video> (see there), but the poster <img> is where the views stamp it and is the
       only source before the upgrade has happened -- and play() has to know BEFORE it
       decides whether to honour a pending resume seek. */
    window.__rovaG3Speed = function (node) {
      if (!node) { return 0; }
      var a = null;
      if (node.tagName === 'VIDEO' || node.tagName === 'IMG') { a = node.getAttribute('data-g3'); }
      else if (node.querySelector) {
        /* A LIVE <video> IN THE CELL IS AUTHORITATIVE, AND THE POSTER IS ONLY A FALLBACK.
           The order matters and is not defensive noise. On the close path the viewer's own
           element -- carrying the FULL MASTER src -- is reparented into the tile and keeps
           the `pcell-video` class (the "direct land"). The poster <img> beside it still
           carries data-g3 from the server render, so asking the cell generally would report
           a 3-second clock for a tile that is really holding the whole clip, and the next
           tap would hand the viewer a position from the wrong timeline. Ask the element
           that is actually playing; only when none exists yet does the poster's stamp
           describe what ensureVideo is about to build. */
        var v0 = node.querySelector('video.pcell-video');
        if (v0) { a = v0.getAttribute('data-g3'); }
        else {
          var h = node.querySelector('[data-g3]');
          if (h) { a = h.getAttribute('data-g3'); }
        }
      }
      if (!a) { return 0; }
      var s = parseFloat(a);
      // A malformed or absurd attribute must read as "not a 3s tile" rather than as a
      // rate: a bad multiplier lands the open on an arbitrary frame, which is a far more
      // confusing failure than simply keeping today's restart behaviour.
      return (isFinite(s) && s > 0 && s <= 8) ? s : 0;
    };
    /* IS THIS TILE A PING-PONG (BOOMERANG) PREVIEW? -> 1 / 0.
       The `data-g6` twin of __rovaG3Speed, and it resolves the node EXACTLY the same way
       and for exactly the same reason: a live <video> in the cell is authoritative and the
       poster <img> is only a fallback, because the close path reparents the viewer's own
       full-master element into the tile and the stale poster stamp beside it would describe
       the wrong artefact. Re-typing that resolution order at each call site is how the two
       markers drift, so both readers share one shape. */
    window.__rovaG6 = function (node) {
      if (!node) { return 0; }
      var a = null;
      if (node.tagName === 'VIDEO' || node.tagName === 'IMG') { a = node.getAttribute('data-g6'); }
      else if (node.querySelector) {
        var v0 = node.querySelector('video.pcell-video');
        if (v0) { a = v0.getAttribute('data-g6'); }
        else {
          var h = node.querySelector('[data-g6]');
          if (h) { a = h.getAttribute('data-g6'); }
        }
      }
      return a === '1' ? 1 : 0;
    };
    /* ══ THE ONE PALINDROME TIME MAP ══════════════════════════════════════════════════════
       A `_grid6` preview is the clip's first W seconds played forward and then backward:

           file position p:  0 ........ W ........ 2W(=D)
           master time    m:  0 ........ W ........ 0

       so  m = (p <= W) ? p : D - p,  with W = D/2.

       WHY W IS DERIVED FROM THE MEDIA'S DURATION AND NEVER FROM 3.0. The forward half is
       L/fps where L is the index of its last frame -- 89/30 = 2.9667s on a 30fps clip, NOT
       3.0 -- and it moves with the frame rate, so it differs per clip. A hardcoded 3.0 puts
       the fold in the wrong place: it would report master time 3.0 at the bounce (which is
       past the end of the window) and be wrong by up to a frame everywhere in the reverse
       half. That reads as a seek bug, not a units bug, which is why the number is taken from
       the file. lib/videojobs.php's grid6SeamFault() is what makes D/2 exact -- it REFUSES
       any encode whose frame count is not exactly 2L, so D is always an even number of
       frames and the fold lands on a real frame.

       ONE HELPER, EVERY SITE. There are three consumers of this map (the tap, the landing
       dissolve in the hero's reveal(), and the inverse on the close path) and they run at
       different moments on different elements. The map was already got wrong once in this
       file by the most natural possible mistake -- using the tile's position AS the master
       time, which is right for the whole forward half and silently wrong for the whole
       reverse half -- so it exists once, here, and is unit-tested by
       window.__rovaG6SelfTest() below. */
    window.__rovaG6Master = function (pos, dur) {
      var p = +pos, d = +dur;
      if (!isFinite(p) || !isFinite(d) || d <= 0) { return 0; }
      // Wrap first: a looping element can report a position a hair past the duration, and
      // an unwrapped p there would fold to a small NEGATIVE master time.
      p = p % d; if (p < 0) { p += d; }
      var w = d / 2;
      var m = (p <= w) ? p : (d - p);
      // Clamp: floating point at the fold can put m a hair over w.
      return m < 0 ? 0 : (m > w ? w : m);
    };
    /* WHICH WAY IS THE TILE MOVING? +1 forward, -1 through the reverse half.
       The dissolve needs this, not just the position: the master always plays FORWARD, so on
       a tap taken mid-reverse the two surfaces move in opposite directions for the length of
       the crossfade. Knowing the sign is what lets the landing start the master half a fade
       early so the two agree at the crossover instead of drifting apart through it. */
    window.__rovaG6Dir = function (pos, dur) {
      var p = +pos, d = +dur;
      if (!isFinite(p) || !isFinite(d) || d <= 0) { return 1; }
      p = p % d; if (p < 0) { p += d; }
      return (p <= d / 2) ? 1 : -1;
    };
    /* THE INVERSE, for the close path: a tile position that shows master time m.
       Returns the FORWARD-half position, which is always m itself when m is inside the
       window, and -1 when m is past it (the caller must then drop the stash rather than
       land the tile on a frame the preview does not contain). Deliberately not "the nearest
       of the two positions that show m": the reverse-half answer (D - m) shows the same
       picture but is travelling backwards, and handing that to a tile that is about to be
       tapped again would flip the direction under the reader's finger. */
    window.__rovaG6Tile = function (master, dur) {
      var m = +master, d = +dur;
      if (!isFinite(m) || !isFinite(d) || d <= 0) { return -1; }
      var w = d / 2;
      if (m < 0) { return 0; }
      return (m <= w) ? m : -1;
    };
    /* ══ THE MIRROR: FOLD A TILE POSITION ONTO ITS OWN FORWARD PHASE ═══════════════════════
       (2026-08-17, the lift-off round. Owner: "It seems like the videos time codes are
        different because if they were the same I would truly not see the transition/fade.")

       HE NAMED THE ROOT CAUSE AND IT IS NOT THE FADE. The boom plays forward and then
       BACKWARD; the master only ever plays forward. A crossfade taken during the reverse
       phase therefore dissolves a backward-running picture into a forward-running one, and
       no fade length hides that -- the eye reads the two motions, not the two opacities.
       The old answer here (see the half-fade compensation this file used to apply at the
       landing) aligned the two CONTENT clocks at the crossover and left the two DIRECTIONS
       opposed, which is why it measured a drift of 0.0000s and still looked like a cut.

       THE TRICK IS THAT THE BOOM CONTAINS THE SAME CONTENT TWICE. `[f0..fL]` then
       `[fL-1..f1]`: every frame in the reverse half has an IDENTICAL twin in the forward
       half, at position m = D - p. So a tile sitting at p in the reverse half can be seeked
       to m and NOTHING CHANGES ON SCREEN -- same frame, same pixels -- except that it is now
       travelling forward. It is the tile's own file, fully buffered (~556 KB, it has been
       looping), so the seek is free and it happens under its own picture.

       AFTER THE MIRROR THERE IS NOTHING LEFT TO COMPENSATE, and that is the point: both
       surfaces are forward, at the same content time, at rate 1. They then stay locked with
       NO further seeks, because two clocks started together at the same rate do not drift.
       Applying the old `(dir-1)*F/2` rewind ON TOP of a mirror would inject exactly -F of
       real error on the reverse half -- the compensation is only correct while the surfaces
       oppose, and the mirror is what stops them opposing.

       THE FORWARD POSITION IS THE MASTER TIME. `__rovaG6Fwd` is therefore the same
       arithmetic as `__rovaG6Master` and is a NAMED alias rather than a copy: the number is
       one thing wearing two hats (where to seek the BOOM, and where to seek the MASTER), and
       a second body would be a second place for the fold to be got wrong. The self-test
       below asserts the identity in both directions rather than trusting the alias. */
    window.__rovaG6Fwd = function (pos, dur) { return window.__rovaG6Master(pos, dur); };
    /* HOW LONG THE LOCK CAN LAST, in seconds of wall clock -- the one number the deferred
       dissolve is scheduled against, and the honest bound on the owner's "2-3 seconds".
       The boom's shared content is only [0, W]. Locked at m and running forward at rate 1,
       the boom reaches W after W - m seconds and then BOUNCES, and from that instant the
       master (still climbing past W) has no twin frame anywhere in the file -- so the
       handover is content-exact for W - m seconds and can never be content-exact again.
       That makes the bounce a DEADLINE, not a failure: fading exactly there is the most
       invisible moment available, because the member is handed the master on the last
       forward frame and the reverse phase is simply never shown in fullscreen at all.
       The slop keeps the plan off the turning frame itself (same 0.15s the close path's
       landable test uses), so a fade never lands on the one frame where the direction
       changes underneath it. Never negative: 0 means "no runway, fade at the landing". */
    window.__rovaG6Runway = function (pos, dur, slop) {
      var d = +dur;
      if (!isFinite(d) || d <= 0) { return 0; }
      var s = isFinite(+slop) ? +slop : 0.15;
      var r = (d / 2) - window.__rovaG6Master(pos, d) - s;
      return r > 0 ? r : 0;
    };
    /* UNIT TEST, in the bundle on purpose. Returns '' when the map is sound, else a short
       reason. It is a few hundred bytes and it is the only executable statement of a
       contract that three call sites depend on and that no visual check can confirm -- a
       reverse-half mapping error looks exactly like "the video opened at a weird place".
       Run it from the console: __rovaG6SelfTest(). */
    window.__rovaG6SelfTest = function () {
      var M = window.__rovaG6Master, T = window.__rovaG6Tile, R = window.__rovaG6Dir;
      var D = 5.9333333, W = D / 2, out = [];
      var near = function (a, b, tol) { return Math.abs(a - b) <= (tol || 1e-6); };
      // The two ends and the fold: the three frames the whole family is about.
      if (!near(M(0, D), 0))        { out.push('p=0 should map to 0'); }
      if (!near(M(W, D), W))        { out.push('the fold should map to W'); }
      if (!near(M(D, D), 0))        { out.push('p=D should wrap to 0'); }
      // The reverse half -- the half that a naive linear map gets wrong.
      if (!near(M(W + 0.5, D), W - 0.5)) { out.push('reverse half should mirror'); }
      if (!near(M(D - 0.25, D), 0.25))   { out.push('just before the wrap should be near 0'); }
      // Symmetry across the fold, swept rather than sampled at one point.
      for (var k = 0.05; k < W; k += 0.13) {
        if (!near(M(W - k, D), M(W + k, D), 1e-6)) { out.push('asymmetric at k=' + k.toFixed(2)); break; }
      }
      // A position is NEVER mapped outside the window.
      for (var p = 0; p <= D + 0.4; p += 0.07) {
        var m = M(p, D);
        if (m < -1e-9 || m > W + 1e-9) { out.push('mapped outside [0,W] at p=' + p.toFixed(2)); break; }
      }
      // Direction.
      if (R(0.1, D) !== 1)  { out.push('early position should read forward'); }
      if (R(D - 0.1, D) !== -1) { out.push('late position should read reverse'); }
      // The inverse round-trips on the forward half and refuses past the window.
      if (!near(T(1.5, D), 1.5)) { out.push('inverse should round-trip in-window'); }
      if (T(W + 0.5, D) !== -1)  { out.push('inverse should refuse past the window'); }
      // Degenerate inputs must be inert, never NaN -- a NaN currentTime throws on assignment.
      if (M(1, 0) !== 0 || M(NaN, D) !== 0 || R(1, 0) !== 1) { out.push('degenerate input not handled'); }
      /* ══ THE MIRROR (2026-08-17) ═══════════════════════════════════════════════════════
         THREE PROPERTIES, and together they are the entire proof that the deferred dissolve
         cannot show a direction change. Asserted here rather than argued in a comment,
         because "the same frame" and "the same time" are exactly the pair a reader nods at
         and a reverse-half bug hides between.
           1. THE MIRROR SHOWS THE SAME FRAME. M(fwd(p)) === M(p) for every p, i.e. seeking
              the boom to its forward twin does not change one pixel on screen.
           2. THE MIRROR RUNS FORWARD. dir(fwd(p)) is +1 everywhere except the two boundary
              frames (0 and the fold itself, where forward and reverse meet by definition).
           3. THE MIRRORED POSITION IS THE MASTER TIME. fwd(p) === M(p), so ONE number seeks
              both surfaces and there is nothing left for a compensation to correct.
         Swept, not sampled: a fold error at one probe point is a coincidence, at forty it is
         a contract. */
      var F6 = window.__rovaG6Fwd, RW = window.__rovaG6Runway;
      for (var q = 0; q <= D + 0.3; q += 0.071) {
        var fq = F6(q, D);
        if (!near(M(fq, D), M(q, D), 1e-6)) { out.push('mirror changed the frame at p=' + q.toFixed(2)); break; }
        if (!near(fq, M(q, D), 1e-9))       { out.push('mirror is not the master time at p=' + q.toFixed(2)); break; }
        if (fq > 1e-6 && fq < W - 1e-6 && R(fq, D) !== 1) { out.push('mirror not forward at p=' + q.toFixed(2)); break; }
      }
      // ...and the mirror is IDEMPOTENT: a forward position is already its own twin, so a
      // second application must be a no-op (the lift may re-ask on a re-aimed landing).
      if (!near(F6(F6(W + 0.7, D), D), F6(W + 0.7, D))) { out.push('mirror is not idempotent'); }
      /* THE RUNWAY. It is W - m - slop, clamped at 0, and the two facts that matter are the
         SIGN of its gradient (a later tap has less runway, never more) and that it can be
         exactly 0 -- which is a legitimate answer meaning "fade at the landing", not an
         error. A runway that went negative would be scheduled as a timer in the past and
         read as an instant fade with no receipt saying why. */
      if (!near(RW(0, D, 0.15), W - 0.15))       { out.push('runway at p=0 should be W-slop'); }
      if (!(RW(W - 0.05, D, 0.15) === 0))        { out.push('runway must clamp to 0 near the fold'); }
      /* THE RUNWAY IS COMPUTED FROM THE MIRRORED POSITION, NOT THE RAW ONE, and this probe is the
         assertion that catches the natural mistake. At p = W + 0.5 the tile is 0.5s into its REVERSE
         phase, so its content time is W - 0.5 and the runway is W - (W - 0.5) - slop = 0.5 - slop.
         Reading the raw p instead would answer a NEGATIVE number here (W - (W + 0.5) - slop) and
         clamp to 0 -- i.e. "fade immediately", on every single reverse-half tap, which would read as
         the defer being broken rather than as a units bug. (This expectation was itself written
         wrong the first time, as W - 0.5 - slop, and the test is what said so.) */
      if (!near(RW(W + 0.5, D, 0.15), 0.5 - 0.15)) { out.push('runway must use the MIRRORED position'); }
      if (!(RW(1, 0, 0.15) === 0))               { out.push('runway on a bad duration must be 0'); }
      var rwPrev = Infinity;
      for (var rp = 0; rp < W; rp += 0.11) {
        var rv = RW(rp, D, 0.15);
        if (rv > rwPrev + 1e-9) { out.push('runway grew with a later tap at p=' + rp.toFixed(2)); break; }
        rwPrev = rv;
      }
      return out.join('; ');
    };
    window.__rovaGridReleaseCell = release;   // the idle cascade hands an outgoing cell's clip back through the SAME path playIO/enforceCap use (2026-09-02)
    window.__rovaReleaseGridVideos = function (exceptCell) {
      Array.prototype.forEach.call(document.querySelectorAll('.pgrid .pcell'), function (cell) {
        if (cell === exceptCell) { return; }
        try { clearTimeout(cell._grT); } catch (e) {}
        release(cell);
      });
    };
    // IMAGES FIRST (see calm() below): how many grid clips are downloading right now, and how many may.
    var VLOAD_TOUCH = 3, VLOAD_DESKTOP = 4, IMG_FIRST_MAX_MS = 1500;
    function vloadMax() { return (window.matchMedia && matchMedia('(hover:none)').matches) ? VLOAD_TOUCH : VLOAD_DESKTOP; }
    function clipsLoading() {
      var n = 0;
      for (var i = 0; i < live.length; i++) {
        var v = live[i].querySelector('video.pcell-video');
        if (v && v.getAttribute('src') && !v.error && v.networkState === 2 && v.readyState < 3) { n++; }
      }
      return n;
    }
    // PLAY only when the cell is substantially in the REAL viewport (>=55%); PAUSE it (keeping the clip LOADED,
    // its last frame shown) the moment it drops below that. No rootMargin, so a decoder never spins up for an
    // off-screen cell.
    var playIO = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        var cell = en.target;
        if (en.isIntersecting && en.intersectionRatio >= 0.55) {
          clearTimeout(cell._grT);
          /* ══ THE 120ms SETTLE IS A VELOCITY FILTER, AND SINCE 2026-08-17 IT IS THE WHOLE GUARD ══
             Owner, live report: "I'm noticing the grid on the web only starts playing videos when I
             stop scrolling." His spec is the opposite -- "when any thumbnail video enters the view at
             all it should be ping ponging" -- so the scroll-settle DEFER that used to sit here is
             gone. What it did: re-checked `__rovaScrollAt` and pushed itself out another 200ms for as
             long as any scroll tick was within 240ms, so a tile could not start until the reader
             stopped moving, at ANY speed. That is exactly the behaviour he is describing.

             WHAT STILL PROTECTS THE FLING, and why deleting the defer is not deleting the protection:
             this timer is per-cell and is CLEARED the moment the cell drops back under 55% (the else
             branch below). So a cell only ever starts if it holds >=55% visibility for 120ms
             CONTINUOUSLY, which is a filter on SCROLL VELOCITY rather than on scroll existing. On a
             218px cell: a ~2000px/s fling leaves it >=55% visible for only ~49ms, so it never starts
             and the decoder-spin-up burst the old comment worried about still cannot happen; a
             ~500px/s deliberate scroll -- the reader actually looking at the grid, which is his case
             -- clears 120ms easily and the tile plays on arrival, mid-scroll. The old defer added
             nothing to this except the "wait for a full stop" behaviour he reported.

             THE EVIDENCE, from the scroll RUM (33,081 real beacons, C:/ProgramData/Rova/scroll-log.jsonl)
             rather than from a headless harness, which memory records as noise for exactly this metric.
             Bucketing grid-bearing beacons by resident <video> count:
                   0 vids 1.67% jank | 3-5 2.67% | 6-9 3.25% | 10+ 5.11%   (Android 10+: 9.77%)
             So decoder RESIDENCY is what costs hitches, and it climbs to the "someone is having a bad
             time" line at the top of the range. But residency is governed by releaseIO's 75%-margin
             window and by playCap(), NOT by this timer -- this timer only decides WHEN a resident
             clip starts moving. Neither the cap (10 touch / 12 desktop), the starvation ceiling, nor
             the memory relief valve is touched here, so the steady state a scroll settles into is
             byte-for-byte the one those beacons already measured. Read /admin/scroll after this ships:
             a real regression would show as grid-surface jank% climbing against that baseline.

             THE TWO DEFERS THAT REMAIN ARE CORRECTNESS, NOT PERFORMANCE, which is why they stay:
             an overlay covering the grid means nobody can SEE these tiles, so starting them spends a
             decoder on picture no one is looking at; and a hero flight mid-air must not build and
             .load() a <video>, because that is the decoder burst the collapse's own staggered rebuild
             is built to avoid, landing on the one frame that must not stutter. */
          cell._grT = setTimeout(function calm() {
            if ((window.__rovaOverlayOpen && window.__rovaOverlayOpen())
                || (window.__rovaFlightBusy && window.__rovaFlightBusy())
                || document.hidden) { cell._grT = setTimeout(calm, 200); return; }   // hidden tab: same defer as an overlay (idle-cost audit, 2026-09-18)
            /* IMAGES FIRST (2026-10-03, the "I shouldn't see tiles loading" pass). Measured on the grid at
               1.75 screens/s: every video tile that held 55% for 120 ms started its ~556 KB _grid6 clip --
               ~4 MB of preview clips per screen (Chromium, 3953 KB/screen) against ~0.5 MB of thumbnails --
               and on an 8 Mbps line that pushed a 30 KB thumbnail to a 3.8 s median fetch and 6.5% of tiles
               painted on arrival (40% with clips held off entirely). So a clip that would START a download
               now waits, briefly, while (a) its own poster is still loading, (b) a picture the grid is BEHIND
               on is still on the wire (window.__rovaGridImgWait, the look-ahead loader's near set), or
               (c) VLOAD_* clips are already downloading. Capped at IMG_FIRST_MAX_MS: a clip is delayed,
               never denied. On a good line (a) and (b) are empty and this costs nothing; on a struggling one
               the tiles fill in first. A clip already buffered (resume after a pause) is never held. */
            var hv = cell.querySelector('video.pcell-video');
            if (!hv || !hv.getAttribute('src') || hv.readyState < 2) {
              if (!cell._grWaitAt) { cell._grWaitAt = Date.now(); }
              if (Date.now() - cell._grWaitAt < IMG_FIRST_MAX_MS
                  && ((window.__rovaGridImgWait && window.__rovaGridImgWait(cell)) || clipsLoading() >= vloadMax())) {
                cell._grT = setTimeout(calm, 100); return;
              }
            }
            cell._grWaitAt = 0;
            play(cell);
          }, 120);
        } else {
          clearTimeout(cell._grT); cell._grWaitAt = 0;
          var pv = cell.querySelector('video.pcell-video'); if (pv) { try { pv.pause(); } catch (e) {} }
        }
      });
    }, { threshold: [0, 0.55] });
    // RELEASE the decoder (revert to a poster <img>) ONLY when the cell is FAR off-screen. Keeping recently
    // scrolled-past videos LOADED (paused, last frame visible) makes scroll-back instant with no poster flicker
    // -- the "off-screen media unloading" the owner saw. The margin is bounded (~0.75 screen) so even a dense
    // grid can't blow past iOS's simultaneous-<video> limit.
    var releaseIO = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) { if (!en.isIntersecting) { clearTimeout(en.target._grT); release(en.target); } });
    }, { rootMargin: '75% 0px 75% 0px', threshold: 0 });
    function scan(root) {
      if (!root.querySelectorAll) return;
      var hs = Array.prototype.slice.call(root.querySelectorAll('.pgrid .pcell img.pcell-video[data-video-src]'));
      // querySelectorAll only sees DESCENDANTS -- when the added node IS the poster img itself (the
      // "Optimizing video..." tile swapping in place, round 140), test the node too or it never wires
      if (root.matches && root.matches('.pgrid .pcell img.pcell-video[data-video-src]')) { hs.push(root); }
      hs.forEach(function (h) {
        var cell = h.closest('.pcell');
        if (cell && !cell._grObs) { cell._grObs = 1; playIO.observe(cell); releaseIO.observe(cell); }
      });
    }
    // The idle cascade swaps a SLOT's post in place (2026-09-04: no node moves during a wave), so a cell this
    // block already observes never re-enters the viewport. Re-observe it: observe() fires the initial entry, so
    // a poster that just arrived starts exactly as an inserted cell would, and a photo stops being watched.
    (window.__rovaGridCellRewire = window.__rovaGridCellRewire || []).push(function (cell) {
      try { playIO.unobserve(cell); releaseIO.unobserve(cell); } catch (e) {}
      cell._grObs = 0; scan(cell);
    });
    scan(document);
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) { if (added[j].nodeType === 1) scan(added[j]); }
      }
    }).observe(document.body, { childList: true, subtree: true });
    /* A HIDDEN TAB HAS NO READER (idle-cost audit, 2026-09-18). The previews are governed by intersection
       and by the viewer's session, and neither changes when the tab is backgrounded: measured on the served
       bundle, three grid previews decoded ~60 frames/s each for the whole of a 12 s hidden window. iOS
       pauses them itself at lock; Chromium/Firefox do not for a muted clip. Pause exactly what is live,
       mark it, and on return resume ONLY what this handler paused and only where the reader can see it now
       (the cells never left the viewport, so playIO has no intersection change to act on -- the same reason
       the viewer's close walks the cells by hand below). An overlay up on return is left to that close. */
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        for (var i = 0; i < live.length; i++) {
          var hv = live[i].querySelector('video.pcell-video');
          if (hv && !hv.paused) { hv._grHidHeld = 1; clearTimeout(live[i]._grT); try { hv.pause(); } catch (e) {} }
        }
        return;
      }
      if (window.__rovaOverlayOpen && window.__rovaOverlayOpen()) return;
      var vh = window.innerHeight || 800;
      Array.prototype.forEach.call(document.querySelectorAll('.pgrid .pcell video.pcell-video'), function (v) {
        if (!v._grHidHeld) return;
        v._grHidHeld = 0;
        var cell = v.closest('.pcell'); if (!cell) return;
        var r = cell.getBoundingClientRect();
        if (r.bottom > 0 && r.top < vh && r.width > 4) { play(cell); }
      });
    });
    // The immersive viewer covers the grid, but the previews kept PLAYING behind it -- decode + GPU work that
    // competed with the pfeed's own video (choppy swipes on the feed page). Pause them all when the viewer
    // lands; when it closes, resume just the on-screen ones by hand (playIO can't do it: the cells never left
    // the viewport, so there's no intersection CHANGE for it to observe).
    document.addEventListener('rova:pfeedready', function () {
      // RELEASE (not just pause) every grid decoder for the duration of the open -- except the donor cell whose
      // clip the viewer is adopting. _grWatch below rebuilds the on-screen ones the instant the viewer closes.
      var donor = window.__rovaGridDonor && window.__rovaGridDonor.v;
      var donorCell = (donor && donor.closest) ? donor.closest('.pcell') : null;
      window.__rovaReleaseGridVideos(donorCell);
      var box = document.querySelector('.pfeed');
      if (box && !box._grWatch) {
        box._grWatch = new MutationObserver(function () {
          if (box.classList.contains('show')) return;                   // still open
          /* THE CENSUS ITSELF WAS ON THE COLLAPSE FRAME (2026-08-12). The rebuilds were already deferred to
             380ms+, but the work that DECIDES what to rebuild -- a document-wide querySelectorAll plus a
             getBoundingClientRect per grid cell (6-30 of them, a forced layout each) -- still ran inside
             this MutationObserver callback, which fires synchronously off classList.remove('show') on the
             first frame of the dismiss. That is in the 50-250ms rafWorst cluster (395 of 1,088 closes).
             Move the whole decision past the tween: the cells' rects are more accurate there anyway (a
             swipe-dismiss is still settling when the class flips), and nothing between here and there
             reads the result. */
          setTimeout(function () {
          if (box.classList.contains('show')) return;                   // reopened while we waited
          // Walk the CELLS (not just existing <video>s): play(cell) resumes a paused preview, re-attaches a
          // released one, AND rebuilds a cell whose element was DONATED to the pfeed (round 129 handoff) --
          // that cell has no <video> at all now, just its poster backdrop.
          // STAGGER the rebuild (flight-log finding: rafWorst 74-98ms every collapse). play() creates a
          // <video>, sets src + .load() -- doing that for all 6-9 on-screen cells synchronously in this
          // MutationObserver callback (which fires the instant the collapse tween starts) spun up every
          // decoder in one frame = the main-thread burst that dropped 3-6 animation frames. Rebuild the
          // LANDING tile immediately (the close handoff polls ~420ms for it), then spread the rest one per
          // frame-ish so no single frame creates more than one decoder. Posters stay up between = no black.
          var seekId = (window.__rovaGridSeek && window.__rovaGridSeek.id) || null;
          var cells = [];
          Array.prototype.forEach.call(document.querySelectorAll('.pgrid .pcell img.pcell-video[data-video-src]'), function (h) {
            var cell = h.closest('.pcell'); if (!cell) return;
            var r = cell.getBoundingClientRect();
            if (r.bottom > 0 && r.top < (window.innerHeight || 800) && r.width > 4) { cells.push(cell); }
          });
          // landing tile first (it feeds the frame-exact handoff), rest keep DOM order
          cells.sort(function (a, b) {
            var am = seekId && a.getAttribute('data-id') === seekId ? -1 : 0;
            var bm = seekId && b.getAttribute('data-id') === seekId ? -1 : 0;
            return am - bm;
          });
          // The LANDING tile no longer needs a rebuild at all -- the direct-land reparents pv straight into
          // it (play() early-returns for the _pfHandoff tile). The OTHER on-screen tiles each spin up a
          // decoder (createElement + .load()); flight-log finding (grid dismiss ~45fps vs timeline ~53fps,
          // rafWorst 300-400ms stalls AT the 340-435ms landing) showed that rebuild storm was stealing frames
          // from the collapse animation. DEFER it until AFTER the tween has fully landed (~360ms), then spread
          // one per ~50ms so no frame builds two decoders. Background tiles hold their poster till then (fine
          // -- they're peripheral); the animation gets a clean main thread.
          cells.forEach(function (cell, i) {
            if (i === 0) { if (!box.classList.contains('show')) play(cell); return; }   // we are already past the tween
            setTimeout(function () { if (!box.classList.contains('show')) play(cell); }, i * 50);
          });
          }, 420);
        });
        box._grWatch.observe(box, { attributes: true, attributeFilter: ['class'] });
      }
    });
  })();

  /* ---- desktop: drag a grid SLIDESHOW cell left/right to FAN through its media (owner request) -----------
     Cells for multi-media posts carry data-slides (pipe-joined thumb/poster URLs). A mouse/pen drag now
     scrubs LIVE through them: horizontal travel maps straight to slide position (a full drag across the
     cell fans through the whole set) by swapping the cover <img> src as the pointer moves, so it feels
     like fanning a deck instead of one stiff step per drag. A real drag suppresses the click so it doesn't
     ALSO open the immersive viewer. Touch is left alone (tap opens the viewer, which has its own carousel). */
  (function () {
    function slidesOf(cell) { var s = cell && cell.getAttribute('data-slides'); return s ? s.split('|') : null; }
    var down = false, moved = false, sx = 0, cell = null, slides = null, img = null, baseIdx = 0, lastIdx = 0, stepPx = 48, pid = 0;
    // KILL the browser's native image/link drag on a fan-able cell -- otherwise the first mouse-move starts a
    // ghost-drag that CANCELS the pointer stream (pointercancel fires, pointermove stops) and nothing swaps.
    // This is why a plain-mouse drag "did nothing". Scoped to grid slideshow cells so other drags are untouched.
    document.addEventListener('dragstart', function (e) {
      if (e.target && e.target.closest && e.target.closest('.pgrid .pcell[data-slides]')) e.preventDefault();
    });
    document.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;                         // desktop mouse / pen only
      if (e.button != null && e.button !== 0) return;                // primary button
      var c = e.target.closest ? e.target.closest('.pgrid .pcell[data-slides]') : null;
      var sl = slidesOf(c);
      if (!sl || sl.length < 2) return;
      img = c.querySelector('img'); if (!img) return;                // nothing to swap (bare-video cell): leave it
      down = true; moved = false; sx = e.clientX; cell = c; slides = sl; pid = e.pointerId;
      baseIdx = lastIdx = (parseInt(c.getAttribute('data-slide') || '0', 10) || 0);
      // a full drag across the cell fans through the whole set; floor 28px/slide so tiny cells stay controllable
      stepPx = Math.max(28, (c.getBoundingClientRect().width || 240) / slides.length);
      if (!c._slidesWarm) { c._slidesWarm = 1; slides.forEach(function (u) { var im = new Image(); im.src = u; }); }  // no flash on swap
    });
    document.addEventListener('pointermove', function (e) {
      if (!down || !cell || e.pointerType === 'touch') return;
      var dx = e.clientX - sx;
      if (!moved && Math.abs(dx) < 6) return;                        // too small to be a drag yet
      if (!moved) { moved = true; try { cell.setPointerCapture(pid); } catch (er) {} }  // keep the moves even if we slip off the cell
      e.preventDefault();                                            // belt-and-suspenders vs text/img selection
      // drag LEFT (dx<0) advances forward; map travel to an index and clamp to the set
      var idx = Math.max(0, Math.min(slides.length - 1, baseIdx + Math.round(-dx / stepPx)));
      if (idx !== lastIdx) { lastIdx = idx; img.src = slides[idx]; cell.setAttribute('data-slide', String(idx)); }
    });
    function end() {
      var wasMoved = moved, c = cell;
      if (c) { try { c.releasePointerCapture(pid); } catch (er) {} }
      down = false; cell = null; slides = null; img = null;
      if (wasMoved && c) { c._slideMoved = Date.now(); }             // swallow the click this drag synthesizes
    }
    document.addEventListener('pointerup', end);
    document.addEventListener('pointercancel', end);
    document.addEventListener('click', function (e) {
      var c = e.target.closest ? e.target.closest('.pgrid .pcell[data-slides]') : null;
      if (c && c._slideMoved && Date.now() - c._slideMoved < 400) { e.preventDefault(); e.stopPropagation(); }
    }, true);
  })();

  /* ---- grid: image decode-ahead PREFETCH (no unloading) ------------------------------------------------
     Force-decode thumbnails a few screens AHEAD of the viewport so a fling never paints a blank cell. There
     is NO JS unloading anymore (owner call, round 107): memory is bounded by content-visibility:auto instead
     -- offscreen cells skip paint, which lets the browser evict their decoded bitmaps on its own while the
     <img> src (and the HTTP-cached bytes) stay put, so scroll-back is an instant repaint, never a refetch. */
  (function () {
    // Grid image PREFETCH (no unloading). We do NOT free off-screen thumbnails anymore -- owner call: the
    // public grid is capped small (6 rows, index.php) and idle-cycles its content, so the decoded-bitmap pile
    // stays bounded by the cap, not by unloading. Unloading + reloading on scroll read as choppy on iPhone, so
    // every cell now just STAYS loaded once fetched. All this observer does is force each cell to decode a few
    // screens AHEAD of the viewport (img.decode(), high priority) so nothing is blank when it scrolls in --
    // covering BOTH the photo thumb AND the video-poster img (the poster had no prefetch before, so video
    // cells were the ones showing up black-till-loaded). Nodes are never touched; content-visibility:auto
    // still skips offscreen layout/paint on its own.
    if (!('IntersectionObserver' in window)) return;
    /* ---- LOOK-AHEAD LOADER (2026-10-03) -- THIS BLOCK NOW STARTS THE LOAD, NOT ONLY THE DECODE ----------
       Owner, Safari on iPhone and Mac: "Scrolling the grid I shouldn't have to wait for the tiles to load or
       see them loading ... and I'm not even scrolling that fast."
       MEASURED CAUSE (rigs in that session's scratchpad gridload/: lazyprobe.js + gridload.js, WebKit 2311
       and Chromium): every grid <img> after the first six is loading="lazy" (views/_feed_grid.php,
       _profile_posts.php) and .pcell is content-visibility:auto (rova.css). IN WEBKIT THOSE TWO COMPOSE
       BADLY: a lazy image inside a content-visibility:auto box that is still being SKIPPED is not started
       until the box becomes relevant -- i.e. until it is on screen. Static probe, 600 cells, stepwise scroll,
       furthest image requested below the viewport: WebKit plain lazy ~0.9 screens ahead, WebKit lazy INSIDE
       c-v:auto -0.1 (after it is already visible); Chromium 4.4 / 1.4. On the live grid (WebKit, 390 wide,
       1.75 screens/s) the request started a median 0.38 screens AFTER the tile was on screen, 2.6% of tiles
       had their picture when they appeared, p95 2.4 s of shimmer. Chromium, same page: 99.8%. That is the
       whole "Safari only" shape of the report. And the img.decode() below could not help: decode() does
       not start a deferred lazy load in WebKit, so this block was decoding nothing ahead on Safari.
       So distance is no longer left to the browser's lazy loader. promote() flips a cell's images to
       loading="eager" as the cell enters THIS observer's band (2.5 screens on touch, was 1.5; desktop 3,
       unchanged), and the bounded window's 4-screen band (winIO, below) promotes too during a FLING
       (>= 2 screens/s, travelling towards the cell) -- the velocity-adaptive half, at no extra observer
       cost. Both bands sit INSIDE winIO's 400% keep band, so nothing is released the moment it lands. The
       markup keeps loading="lazy": it is what stops 150 cells all fetching at page load, it is the no-JS
       fallback, and a detached cell waiting in gridCycle's buffer stays unfetched until it is inserted.
       DECODE BEFORE IT IS SEEN, as this block always meant to: once the bytes land, img.decode() (off the
       main thread), so the first paint on arrival is not WebKit's async decode of a bitmap it already had.
       fetchpriority=high ONLY when we are BEHIND -- the cell was already within a screen of the viewport
       when promoted (page load, a hard fling) -- and those same images hold a grid clip's START back
       (window.__rovaGridImgWait, read by the video governor's calm()): a tile's picture outranks somebody
       else's preview clip. Far promotions keep the default priority so they never outrank what is on screen.
       COST: no new observer (this one already watched every cell). Decode band on a phone 1.5 -> 2.5
       screens: ~+1 screen of decoded thumbs each way. Bytes: the same thumbnails a forward scroll fetches
       anyway, just earlier; the only extra is <= ~2.5 screens of thumbs past wherever a reader stops.
       Receipt: window.__rovaGridLookahead(). */
    var gl = { promoted: 0, near: 0, fling: 0, decoded: 0, decodeFail: 0 };
    var pendNear = [];                     // promoted-while-close images still on the wire (a screen or two of cells at most)
    function photoImg(cell) { return cell.querySelector('img:not(.pcell-video):not(.gp-casc-ovi)'); }
    function decodeImg(img) {
      if (!img || !img.getAttribute('src') || !img.decode || img._glDec) return;
      var go = function () {
        img._glDec = 0;
        if (!(img.naturalWidth > 0)) return;
        try { img.decode().then(function () { gl.decoded++; }, function () { gl.decodeFail++; }); } catch (e) {}
      };
      if (img.complete) { go(); } else { img._glDec = 1; img.addEventListener('load', go, { once: true }); img.addEventListener('error', function () { img._glDec = 0; }, { once: true }); }
    }
    function promote(cell, near, fling) {
      if (!cell || cell._glP) return;
      cell._glP = 1; gl.promoted++; if (near) { gl.near++; } if (fling) { gl.fling++; }
      var ims = cell.getElementsByTagName('img');
      for (var i = 0; i < ims.length; i++) {
        var im = ims[i];
        if (im.classList.contains('gp-casc-ovi')) continue;                       // the idle cascade's overlay manages itself
        // priority BEFORE the loading flip: the flip is what starts the request
        if (near) { try { im.fetchPriority = 'high'; } catch (e) {} im.setAttribute('fetchpriority', 'high'); }
        if (im.getAttribute('loading') === 'lazy') { im.setAttribute('loading', 'eager'); }
        if (near && im.getAttribute('src') && !im.complete) { pendNear.push(im); }
      }
      if (window.__rovaGridWatchLate) { window.__rovaGridWatchLate(cell); }
    }
    function prefetchCell(cell, near) {
      promote(cell, near, false);
      decodeImg(photoImg(cell));                                     // photo thumb: decode ahead (after its bytes land)
      decodeImg(cell.querySelector('img.pcell-video[src]'));         // video poster: decode ahead too
    }
    window.__rovaGridPromote = promote;
    // IMAGES FIRST, for the grid's preview clips (see calm() in the video governor). True while this cell's
    // own poster is still loading, or while any picture we were BEHIND on is still on the wire.
    window.__rovaGridImgWait = function (cell) {
      var h = cell && cell.querySelector('img.pcell-video');
      if (h && h.getAttribute('src') && !h.complete) return true;
      for (var i = pendNear.length - 1; i >= 0; i--) {
        var im = pendNear[i];
        if (!im.isConnected || im.complete || !im.getAttribute('src')) { pendNear.splice(i, 1); }
      }
      return pendNear.length > 0;
    };
    window.__rovaGridLookahead = function () {
      return { promoted: gl.promoted, near: gl.near, fling: gl.fling, decoded: gl.decoded, decodeFail: gl.decodeFail,
               pendNear: pendNear.length, ahead: AHEAD };
    };
    // How far ahead to force a decode. 300% (~3 screens EACH WAY on a 3-col grid = ~100 cells) is a
    // desktop budget: at 480x480x4 bytes per decoded thumb that's ~100MB of resident bitmap, which a
    // phone cannot hold on top of everything else. Phones get 150% -- still a full screen and a half of
    // "already decoded before you reach it", at roughly half the resident cost. The bounded window below
    // (400%) is deliberately wider than this, so a cell is never released by one observer while the other
    // is still trying to decode it ahead.
    // 2026-10-03: touch 150% -> 250%. This band now STARTS the loads (see the LOOK-AHEAD LOADER note above),
    // and at 1.5 screens a moderate 2 screens/s scroll left a CF MISS (~0.4-0.9 s) no head start at all.
    var AHEAD = (window.matchMedia && matchMedia('(hover:none)').matches) ? '250%' : '300%';
    var prefetchIO = new IntersectionObserver(function (ents) {
      var vh = window.innerHeight || 800;
      ents.forEach(function (en) {
        if (!en.isIntersecting) return;
        var r = en.boundingClientRect;
        prefetchCell(en.target, r.top < vh * 2 && r.bottom > -vh);   // within a screen of the viewport = we are BEHIND
      });
    }, { rootMargin: AHEAD + ' 0px ' + AHEAD + ' 0px' });
    function scan(root) {
      if (!root.querySelectorAll) return;
      /* THE ADDED NODE ITSELF (2026-10-03). gridCycle appends each new cell with its own appendChild, so the
         MutationObserver below hands this function the .pcell ITSELF -- and querySelectorAll only sees
         descendants. Every infinite-scroll cell (everything past the first page) was therefore never
         observed here at all: no decode-ahead since this block was written, and with the look-ahead loader
         it would have meant no early load either (measured: page-one tiles 100% painted on arrival,
         appended tiles 0-35%). Same test winIO's scan and the video governor's scan already make. */
      var cells = Array.prototype.slice.call(root.querySelectorAll('.pgrid .pcell'));
      if (root.matches && root.matches('.pgrid .pcell')) { cells.push(root); }
      cells.forEach(function (cell) {
        if (cell._gImgObs) return;
        cell._gImgObs = 1; prefetchIO.observe(cell);   // observe the CELL (keeps its box under content-visibility)
      });
    }
    scan(document);
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) { if (added[j].nodeType === 1) scan(added[j]); }
      }
    }).observe(document.body, { childList: true, subtree: true });
  })();

  /* ---- PROACTIVE MEDIA WARM (round 168, owner request): kill cold-cache opens ---------------------------
     The instant a feed/grid renders, download + DECODE the exact full image the immersive viewer will paint
     -- a grid cell's data-full display variant, or a post card's own display-variant src -- for everything
     within ~1.5 screens. So tapping a photo opens from RAM instantly instead of cold-loading (which, on
     flaky signal, is what let a loaded pic go blank). Throttled to a few at a time and SKIPPED on data-saver
     / 2g so it never hogs mobile data. (Videos stream on open; we only ever warm their poster, which the
     card already loads.) Complements the thumbnail decode-ahead above -- different URLs, same goal. */
  (function () {
    if (!('IntersectionObserver' in window)) return;
    var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection || {};
    if (conn.saveData) return;                                   // respect Data Saver
    // effectiveType is exactly one of slow-2g|2g|3g|4g. The old test was /2g/, which missed '3g' -- and
    // '3g' is what a CONGESTED LTE cell reports, i.e. the precise condition this guard was written for.
    if (conn.effectiveType && /^(slow-2g|2g|3g)$/.test(conn.effectiveType)) return;
    // ...and none of the three lines above run on an iPhone AT ALL: Safari does not implement
    // navigator.connection, so `conn` is {} and every one of them is a no-op for the whole iOS population
    // (scroll RUM: 14,617 of 19,655 samples / 1,396 uids report no `conn`). That is why the mobile data
    // discipline written here has never once applied on the device it was written for. netIsSlow()
    // (published by the HLS ladder picker) is the only bandwidth signal iOS has, but it is a MEASUREMENT
    // -- it answers false until a >=40KB transfer has been timed, so it can't replace the early-return
    // above; it has to be asked per job, at the moment the bytes would actually be spent. See pump().
    function slowNow() { try { return !!(window.__rovaNetSlow && window.__rovaNetSlow()); } catch (e) { return false; } }
    // MAXC: how many display variants download in parallel. Bumped 2 -> 4 (owner: be aggressive, modern
    // devices + HTTP/2 handle it) so the tap-prefetch window and the 5-screen ahead-warm fill fast; still
    // fetchPriority:low so it never fights the on-screen content for bandwidth.
    // MAXC on TOUCH is 2, not 4: on a phone these low-priority full-size warms share one modest radio and
    // one modest decoder with the thumbnails the grid is trying to paint right now, and four in flight
    // measurably starves the visible content. Desktop keeps 4.
    var _touchWarm = !!(window.matchMedia && matchMedia('(hover:none)').matches);
    var warmed = {}, queue = [], active = 0, MAXC = _touchWarm ? 2 : 4, warmPaused = 0, warmPauseT = null;
    // PRIORITISE THE TAP (owner: "move the tapped media to the front of the queue and PAUSE the other
    // simultaneous downloads while it finishes, then start the rest again in the background"). When a clip is
    // opened, its own <video> buffering should own the pipe; these low-priority image warms would otherwise
    // fight it. Pausing the pump (in-flight requests finish, no NEW ones start) hands the bandwidth to the
    // tapped clip, then it auto-resumes so everything else is ready by the time the user swipes on.
    window.__rovaWarmPause = function (ms) {
      warmPaused = 1;
      clearTimeout(warmPauseT);
      warmPauseT = setTimeout(function () { warmPaused = 0; pump(); }, Math.max(400, ms || 2500));
    };
    window.__rovaWarmResume = function () { clearTimeout(warmPauseT); warmPaused = 0; pump(); };
    function pump() {
      // NEVER start a new full-size warm mid-fling. Decoding a ~1440px image takes tens of milliseconds
      // on a phone and it lands on the main thread, so a warm that starts during a scroll is a dropped
      // frame you can feel. The queue is unbounded in time and everything in it is speculative, so
      // waiting out the fling costs nothing: re-pump once the scroll settles.
      if (Date.now() - (window.__rovaScrollAt || 0) < 250) {
        clearTimeout(pump._t); pump._t = setTimeout(pump, 260);
        return;
      }
      // MEASURED-SLOW LINE: hold the LOW-priority (speculative, ahead-of-the-reader) jobs. Each one is a
      // full-size photo nobody has opened, and on a struggling link it is competing with the thumbnails
      // the grid is trying to paint right now. HIGH-priority jobs still go: those are the cell the reader
      // stopped on / just touched, i.e. the picture they are about to look at, and starving that would be
      // a worse bug than the one this fixes. The jobs are HELD, not dropped -- they resume the moment the
      // measurement recovers. On a fast (or unmeasured) link slowNow() is false and this loop is byte-for-
      // byte what it was before.
      var slow = slowNow();
      while (!warmPaused && active < MAXC && queue.length) {
        if (slow && !queue[0].hi) { clearTimeout(pump._t); pump._t = setTimeout(pump, 4000); break; }
        // Per-job closure: `var im`/`var url` are function-scoped, so with MAXC>1 the second iteration
        // rebound them under the first iteration's still-pending onload/onerror -- which now matters,
        // because the error path has to know WHICH url to un-claim.
        (function (job) {
          active++;
          var im = new Image();
          try { im.fetchPriority = job.hi ? 'high' : 'low'; } catch (e) {}   // VISIBLE-cell warms outrank the ahead-warm; low never fights visible content
          try { im.setAttribute('fetchpriority', job.hi ? 'high' : 'low'); } catch (e) {}
          var next = function () { active--; setTimeout(pump, 0); };
          var failed = function () {
            // RELEASE THE CLAIM. `warmed` is a permanent once-per-session dedupe, so a photo that failed
            // during one bad moment was never warmed again for the life of the page -- one tunnel poisons
            // the warm layer. Un-claim it, and let whoever asked re-arm (hiIO re-observes its cell).
            delete warmed[job.url];
            if (job.fail) { try { job.fail(); } catch (e) {} }
            next();
          };
          im.onload = function () { if (im.decode) { try { im.decode().then(next, next); } catch (e) { next(); } } else next(); };
          im.onerror = failed;
          try { im.src = job.url; } catch (e) { failed(); }
        })(queue.shift());
      }
    }
    // hi: warm at HIGH priority AND jump the queue -- for what the user is looking at right now (likeliest tap).
    // fail: optional re-arm, invoked if the image never loads (see pump's failed()).
    function warm(url, hi, fail) {
      if (!url || warmed[url] || /giphy\.com/i.test(url)) return;
      warmed[url] = 1;
      var job = { url: url, hi: !!hi, fail: fail || null };
      if (hi) { queue.unshift(job); } else { queue.push(job); }
      pump();
    }
    // fail: passed through to warm(). The observers below hand in a re-observe, so a cell whose warm died
    // on a flaky link gets another chance the next time it crosses the threshold instead of being
    // permanently written off by the unobserve() that preceded the warm.
    function warmEl(el, hi, fail) {
      if (!el || (el.closest && el.closest('.pfeed'))) return;   // the viewer's own posts are already showing
      if (el.classList && el.classList.contains('pcell')) {
        var gi = el.querySelector('img[data-full]');             // grid cell: the display variant the pfeed paints
        if (gi) warm(gi.getAttribute('data-full'), hi, fail);
        return;
      }
      Array.prototype.forEach.call(el.querySelectorAll ? el.querySelectorAll('.media:not(.carousel) img') : [], function (m) {
        warm(m.getAttribute('src'), hi, fail);                   // post card: its own src IS the display variant
      });
    }
    // Exposed so the grid's double-buffer can warm a rotated-in cell's opener BEFORE it's inserted (see
    // gridCycle ensureBuf). Undefined on data-saver/2g (this IIFE returned early), so callers stay cost-safe.
    window.__rovaWarmMedia = warmEl;
    // VISIBLE cells are the likeliest next tap, so warm their opener at HIGH priority the moment they're actually
    // on screen -- so a photo the user has been LOOKING at is cached before they tap it (owner: "the page had
    // enough time to download a certain photo but it was still loading"). Jumps ahead of the low-priority
    // 5-screen ahead-warm below (dedupe means it only ever fetches each URL once, at whichever priority hit first).
    // ...but on a PHONE, "became visible" is not the same as "the user is looking at it". Scrolling a grid
    // makes hundreds of cells briefly visible, and warming each one's full-size opener as it flies past
    // measured (WebKit, iPhone 13 profile, 14 flings) at ~35MB of display variants and originals pulled
    // during a single scroll -- on cellular, for photos nobody opened. So touch devices warm on DWELL:
    // a cell must still be on screen DWELL_MS later, which is only true once the reader has slowed down
    // and is actually looking at that row. A tap also warms its own target on pointerdown, so the worst
    // case for a cell we skipped is the ordinary open path, not a regression.
    var TOUCH = !!(window.matchMedia && matchMedia('(hover:none)').matches);
    var DWELL_MS = 500;
    // GRID + TOUCH: no speculative warming at all (2026-07-22 audit). Measured on the live grid in WebKit
    // at an iPhone viewport, 14 flings: 68 non-thumb files / 8.27MB were pulled during a single scroll and
    // exactly ONE of them was ever rendered. The rest were display variants for cells nobody opened -- 58%
    // of the grid's bandwidth, and (worse) an im.decode() of a ~1440px image per file landing on the main
    // thread between flings, which is where the hitches the owner reported actually come from. ios/grid was
    // the only surface in the scroll RUM with a p95 worst frame over a second; ios/feed, which shows the
    // same photos without this, sat at 221ms.
    //
    // The dwell gate above was supposed to bound this and doesn't: on a grid, "stopped in the middle band
    // for 500ms" describes every row you scroll past at a normal reading pace, so it fires constantly.
    // Rather than tune the gate again, the grid opts out on touch entirely.
    //
    // This costs the AHEAD warm only, not the tap warm: .pcell pointerdown still warms its own data-full
    // (and its neighbours) the instant a finger lands, so an opened photo is still fetched before the
    // viewer paints. Desktop is untouched -- bandwidth is free there and the deep buffer is what makes an
    // open instant. Feed cards (.post) are untouched on every device; they were never the problem.
    function warmSkip(el) {
      return TOUCH && el && el.classList && el.classList.contains('pcell');
    }
    // A cell is unobserve()d the instant we decide to warm it -- a claim, taken BEFORE we know whether the
    // bytes arrive. If they don't, nothing ever looks at that cell again. reArm puts it back under
    // observation so the next threshold crossing retries it. (warm() releases its own url claim in
    // parallel; both have to let go or the retry is a no-op.) Capped at 2 tries per cell: observe() fires
    // straight away on an element that is already intersecting, so an unbounded re-arm would spin on a
    // URL that is simply gone.
    var hiIO = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        var el = en.target;
        var reArm = function () {
          if ((el._warmTry = (el._warmTry || 0) + 1) > 2) { return; }
          try { hiIO.observe(el); } catch (e) {}
        };
        if (!en.isIntersecting) { clearTimeout(el._warmT); return; }
        if (!TOUCH) { hiIO.unobserve(el); warmEl(el, true, reArm); return; }
        clearTimeout(el._warmT);
        var settled = function () {
          // still on screen, and the scroll has actually calmed -- otherwise wait it out
          if (Date.now() - (window.__rovaScrollAt || 0) < 200) { el._warmT = setTimeout(settled, 220); return; }
          // ...and only near the MIDDLE of the screen. A phone shows ~18 grid cells at once; warming all
          // of them to be ready for the one that might get tapped is a ~4MB bet at a ~5% hit rate. The
          // middle band is both the likeliest tap and small (~2 rows). Everything else is covered by the
          // tap handler, which warms the tapped cell plus its neighbours the instant a finger lands.
          var r; try { r = el.getBoundingClientRect(); } catch (e2) { return; }
          var vh = window.innerHeight || 800;
          if (Math.abs((r.top + r.bottom) / 2 - vh / 2) > vh * 0.35) { return; }   // stays observed: may re-qualify
          hiIO.unobserve(el); warmEl(el, true, reArm);
        };
        el._warmT = setTimeout(settled, DWELL_MS);
      });
    }, { rootMargin: '0px 0px 0px 0px' });
    // The 5-screens-ahead buffer is a DESKTOP-ONLY thing now. On a 3-column grid 500% means ~90 cells
    // whose ~1440px display variant is downloaded AND decoded, four at a time, continuously, while you
    // scroll -- and on a phone that is simply the wrong trade: it spends cellular data and main-thread
    // decode time on media the reader is flinging past, competing with the thumbnails actually being
    // painted. The dwell-gated hiIO above covers the phone case properly (warm what someone stopped to
    // look at). On desktop the bandwidth is free and the deep buffer is what keeps an open instant, so
    // nothing changes there.
    var io = TOUCH ? null : new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        if (!en.isIntersecting) return;
        var t = en.target;
        io.unobserve(t);
        warmEl(t, false, function () {                                           // failed warm -> re-observe (capped)
          if ((t._warmTry = (t._warmTry || 0) + 1) > 2) { return; }
          try { io.observe(t); } catch (e) {}
        });
      });
    }, { rootMargin: '500% 0px 500% 0px' });   // download buffer: warm the display variants ~5 screens out (was
    // 1.5) so scrolling never outruns the cache -- kept low-priority + deduped + skipped on data-saver/2g above,
    // and cheap now that display variants (~1/3 the bytes of the original) are backfilled.
    // BROAD, ancestor-free targets so it works on EVERY page that shows media (feed, profile, permalink,
    // search, explore, mentions, landing) -- and so an INJECTED card/cell (tab switch, load-more) is caught
    // whether the mutation hands us the node itself or a wrapper around it. (The old descendant selector
    // #feed-posts .post could never match an injected .post, since its #feed-posts ancestor is outside the
    // added subtree -- that's why grid worked but freshly-loaded normal posts didn't.)
    function consider(el) {
      if (!el || el.nodeType !== 1 || el._mWarm) return;
      if (el.matches && (el.matches('.pcell') || el.matches('.post')) && !(el.closest && el.closest('.pfeed'))) {
        if (warmSkip(el)) { el._mWarm = 1; return; }   // grid cell on touch: claim it so nothing else warms it, observe nothing
        el._mWarm = 1;
        if (io) { io.observe(el); }        // ahead-warm (low, desktop only)
        if (hiIO) { hiIO.observe(el); }    // on-screen warm (high; dwell-gated on touch)
      }
    }
    function scan(root) {
      consider(root);                                            // the added node itself may be a card/cell
      if (root.querySelectorAll) Array.prototype.forEach.call(root.querySelectorAll('.pcell, .post'), consider);
    }
    // FIRST-VIEWPORT WARM (owner request): the 700ms-delayed pass below front-loads what's just AHEAD of the
    // viewport, but a tap in the very first second on media ALREADY ON SCREEN would still cold-load its full
    // version. So the instant the page is ready, warm the display variants of the media in the FIRST viewport
    // -- the most-likely first tap -- so it opens from cache with zero wait. Bounded to the first screen + a
    // small cap, low priority, and already skipped on data-saver/2g above, so it's a handful of cheap requests,
    // not a data-cost blowout; the 1-year immutable cache makes every re-view free. Feed cards already load
    // their display variant inline (a no-op here); the real win is the grid, whose tiles are 480px thumbs that
    // would otherwise cold-open the 1440px version.
    function warmFirstViewport() {
      // Cap is halved on touch: on the grid, 12 full-size warms is ~2.7MB of speculative cellular data
      // fired during page load, right when the thumbnails the reader is waiting on need the pipe most.
      var vh = window.innerHeight || 800, cap = TOUCH ? 6 : 12, n = 0;
      var els = document.querySelectorAll('.pcell, .post');
      for (var i = 0; i < els.length && n < cap; i++) {
        var el = els[i], r;
        if (el._mWarm || (el.closest && el.closest('.pfeed'))) continue;
        if (warmSkip(el)) { el._mWarm = 1; continue; }   // see warmSkip: grid cells don't speculatively warm on touch
        try { r = el.getBoundingClientRect(); } catch (e) { continue; }
        if (!r.height || r.bottom <= 0 || r.top >= vh) continue;   // only what's actually in the first screen
        el._mWarm = 1;                                              // claim it so the observer below won't re-warm it
        warmEl(el, true); n++;                                      // first screen = on-screen = HIGH priority
      }
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', warmFirstViewport); }
    else { warmFirstViewport(); }
    // start ~700ms in, so the VISIBLE view finishes loading first, then we pre-warm what's just ahead.
    setTimeout(function () {
      scan(document);
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) { var a = muts[i].addedNodes; for (var j = 0; j < a.length; j++) scan(a[j]); }
      }).observe(document.body, { childList: true, subtree: true });
    }, 700);
    // a grid SLOT that changed post in place (idle cascade, 2026-09-04): its data-full is a different file now.
    // Touch never ahead-warms grid cells (warmSkip: the tap handler covers it); desktop re-observes so the
    // on-screen warm fires for the new post exactly as it would for an inserted cell.
    (window.__rovaGridCellRewire = window.__rovaGridCellRewire || []).push(function (cell) {
      if (warmSkip(cell)) return;
      cell._warmTry = 0;
      try { hiIO.unobserve(cell); hiIO.observe(cell); } catch (e) {}
    });
  })();

  /* ---- grid tab: loading shimmer for cells whose image hasn't arrived yet ------------------
     Used to also unload (clear <img src>) cells scrolled well out of range to bound memory, and
     restore them on approach. Dropped that: it meant scrolling back up could re-trigger a real
     reload (and a shimmer) on cells you'd already seen, which read as flaky/unreliable rather than
     fast. content-visibility:auto (rova.css, .pcell) already skips layout/paint for offscreen cells
     on its own, so once an image has loaded here, it just stays loaded for the rest of the session --
     simpler and more consistent, at the cost of not actively freeing that memory on a very long
     scroll. All this does now is mark a cell "pcell-loading" (rova.css shimmer) from when its image
     starts fetching until it actually finishes, so a cell that hasn't arrived yet (a fast flick
     outrunning the prefetch margin, a slow connection) reads as "loading" instead of "broken". */
  /* A LATE TILE DISSOLVES IN (2026-10-03). With the look-ahead loader (decode-ahead block above) a tile's
     picture is normally decoded before the tile is on screen, so the reader never sees this shimmer. When
     one is late anyway (a hard fling, a struggling line, a cold CDN object) the picture used to SNAP in over
     the shimmer. Now, if the cell was actually on screen while it shimmered, the picture fades in over
     160 ms (Web Animations on the img's OPACITY only -- the Ken Burns pans are CSS animations of
     scale/translate, so they are untouched). Visibility comes from a small observer that only ever holds
     cells whose picture is ON THE WIRE (observed when the look-ahead loader promotes them, dropped on load),
     never the whole grid. The cascade's
     overlay image and the landing teaser (which has its own .5 s CSS fade) are excluded. */
  var _glVisIO = ('IntersectionObserver' in window) ? new IntersectionObserver(function (ents) {
    ents.forEach(function (en) {
      var c = en.target;
      if (!c.classList.contains('pcell-loading')) { c._glVo = 0; c._glVis = false; try { _glVisIO.unobserve(c); } catch (e) {} return; }
      c._glVis = en.isIntersecting;
    });
  }, { threshold: 0 }) : null;
  function pcellMarkLoading(img) {
    var cell = img.closest('.pcell'); if (!cell) return;
    cell.classList.add('pcell-loading');
  }
  // Called by the look-ahead loader's promote() for a cell whose picture is now on the wire: only those
  // cells are ever watched, so the observed set is the handful in flight, not the grid.
  window.__rovaGridWatchLate = function (cell) {
    if (_glVisIO && cell && !cell._glVo && cell.classList.contains('pcell-loading')) { cell._glVo = 1; try { _glVisIO.observe(cell); } catch (e) {} }
  };
  function pcellMarkLoaded(img) {
    var cell = img.closest('.pcell'); if (!cell) return;
    var was = cell.classList.contains('pcell-loading');
    cell.classList.remove('pcell-loading');
    if (!cell._glVo || img.parentNode !== cell || img.classList.contains('gp-casc-ovi')) return;
    cell._glVo = 0; try { _glVisIO.unobserve(cell); } catch (e) {}
    var vis = cell._glVis; cell._glVis = false;
    if (was && vis) { window.__rovaGridLate = (window.__rovaGridLate || 0) + 1; }   // the RUM beacon's tLate (a tile the reader SAW loading)
    if (was && vis && img.naturalWidth > 0 && img.animate && !cell.classList.contains('gp-casc-hold') && !cell.closest('.landing-grid')) {
      try { img.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 160, easing: 'ease-out' }); } catch (e) {}
    }
  }
  (function () {
    function scan(root) {
      if (!root.querySelectorAll) return;
      Array.prototype.forEach.call(root.querySelectorAll('.pgrid .pcell img:not([data-gobs])'), function (img) {
        img.setAttribute('data-gobs', '1');
        if (img.complete && img.naturalWidth > 0) { pcellMarkLoaded(img); }
        else {
          pcellMarkLoading(img);
          img.addEventListener('load', function () { pcellMarkLoaded(img); });
          img.addEventListener('error', function () { pcellMarkLoaded(img); });   // broken image: stop shimmering forever
        }
      });
    }
    scan(document);
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1) scan(added[j]);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  })();

  /* ---- grid: BOUNDED DECODED-IMAGE WINDOW (2026-07-21 choppiness audit) --------------------------------
     The block above explains why per-cell unloading was dropped in round ~124: it made scroll-back
     re-fetch, which read as flaky. That reasoning held when the home grid was a CAPPED 6-row page. It is
     no longer true: gridCycle turned #feed-grid into an INFINITE scroll (18 cells appended forever), so
     "once loaded, stays loaded for the session" means a reader who scrolls a few hundred cells is holding
     a few hundred decoded bitmaps. A decoded bitmap costs width*height*4 bytes REGARDLESS of how small
     the file was -- iOS Safari's per-tab ceiling is a few hundred MB, so past a few hundred cells the OS
     starts evicting and re-decoding under the scroll. That eviction churn IS the choppiness: it gets
     worse the longer you browse, which is exactly what the owner reported ("browsing the grid after all
     the media has been uploaded").

     So the window is back -- but bounded generously and made cheap enough that the round-124 objection
     doesn't apply any more:
       * KEEP is ~4 screens each way, so ordinary scroll-back NEVER crosses it. You have to fling well
         past a cell before it's released.
       * A released cell keeps its exact <img> box and its LAST-KNOWN src in data-gsrc; restoring is a
         plain attribute write. The bytes come from the HTTP cache (immutable, 1-year), so there is no
         network round-trip and no shimmer -- we deliberately do NOT re-add .pcell-loading on a restore.
       * Grid thumbs are ~40KB / 480px since the photo-thumbs backfill, so a re-decode is sub-millisecond.
     Net effect: the resident bitmap pool is capped at roughly what's within 4 screens instead of growing
     without limit, and the deeper you scroll the more it saves. */
  (function () {
    if (!('IntersectionObserver' in window)) return;
    function unload(cell) {
      Array.prototype.forEach.call(cell.querySelectorAll('img'), function (im) {
        var s = im.getAttribute('src');
        if (!s) return;
        im.setAttribute('data-gsrc', s);
        im.removeAttribute('src');          // frees the decoded bitmap; the box + .pcell background stay
      });
    }
    function restore(cell) {
      Array.prototype.forEach.call(cell.querySelectorAll('img[data-gsrc]'), function (im) {
        if (!im.getAttribute('src')) { im.setAttribute('src', im.getAttribute('data-gsrc')); }
        im.removeAttribute('data-gsrc');
        // A restore of something already CACHED must never re-shimmer: the paint is immediate, and a flash
        // of "loading" on content you already scrolled past is precisely the flakiness round 124 objected
        // to. But a cell released before it ever finished loading (lazy, never reached) is genuinely still
        // loading, so leave its shimmer alone -- the load/error handlers wired in the scan below clear it.
        if (im.complete && im.naturalWidth > 0) {
          var c = im.closest('.pcell'); if (c) { c.classList.remove('pcell-loading'); }
        }
      });
    }
    // ~4 screens each way. Wide enough that a normal back-scroll never sees a release; narrow enough that
    // the resident pool stops growing with scroll depth.
    /* FLING LOOK-AHEAD (2026-10-03): this band is 4 screens; the decode-ahead block's is 2.5. While the reader
       is moving at >= FLING_SCR_S screens/s, a cell entering THIS band ahead of them is promoted to an eager
       load here, so a fast scroll gets the deeper head start and a slow one does not spend it. Bytes only --
       the decode still happens at 2.5 screens. See "LOOK-AHEAD LOADER" above. */
    var FLING_SCR_S = 2;
    function flingAhead(en) {
      if (Date.now() - (window.__rovaScrollAt || 0) > 300) return false;          // velocity is only fresh while scrolling
      var vh = window.innerHeight || 800;
      if ((window.__rovaScrollVel || 0) * 1000 / vh < FLING_SCR_S) return false;
      var r = en.boundingClientRect;
      return (window.__rovaScrollDir || 1) > 0 ? r.bottom > 0 : r.top < vh;      // ahead of the reader, never behind
    }
    var winIO = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        if (en.isIntersecting) {
          restore(en.target);
          if (window.__rovaGridPromote && !en.target._glP && flingAhead(en)) { window.__rovaGridPromote(en.target, false, true); }
        } else { unload(en.target); }
      });
    }, { rootMargin: '400% 0px 400% 0px', threshold: 0 });
    function scan(root) {
      if (!root.querySelectorAll) return;
      var cells = Array.prototype.slice.call(root.querySelectorAll('.pgrid .pcell'));
      if (root.matches && root.matches('.pgrid .pcell')) { cells.push(root); }
      cells.forEach(function (cell) {
        if (cell._gWin) return;
        cell._gWin = 1; winIO.observe(cell);
      });
    }
    // gridCycle BENCHES swapped-out cells (up to 90 of them, detached) for its forever-rotation. Detached
    // nodes leave the observer's viewport entirely but never fire a "left" entry, so their bitmaps would
    // sit resident with no cell on screen to justify them. Expose the unloader so the bench can drop them.
    window.__rovaGridUnloadCell = unload;
    window.__rovaGridRestoreCell = restore;
    window.__rovaGridWindowStats = function () {
      var cells = document.querySelectorAll('.pgrid .pcell');
      var loaded = 0;
      Array.prototype.forEach.call(cells, function (c) { if (c.querySelector('img[src]')) loaded++; });
      return { cells: cells.length, loaded: loaded, released: cells.length - loaded };
    };
    scan(document);
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) { if (added[j].nodeType === 1) scan(added[j]); }
      }
    }).observe(document.body, { childList: true, subtree: true });
  })();

  /* ---- SCROLL-PERFORMANCE RUM (2026-07-21) -------------------------------------------------------------
     "Is everyone's scrolling smooth?" should be a number, not a guess. The owner could only report their
     own iPhone; this measures every signed-in member's real device and reports it back, so a regression
     (or a device class we've never tested on) shows up on /admin/scroll instead of waiting for someone to
     complain. It is also how we'll know whether this audit's fixes actually worked in the field.

     How it measures: a requestAnimationFrame loop that runs ONLY while the page is actually being
     scrolled, timing the gap between frames. A gap over 32ms means we missed a 60fps beat; over 64ms is a
     hitch a human sees. It stops the moment scrolling settles, so an idle tab costs nothing -- this must
     never become the thing that makes the page slow.

     What it reports: the frame counts above, plus what the page was CARRYING at that moment -- cells in
     the DOM, estimated resident decoded-image megabytes, live <video> elements. That pairing is the whole
     point. Jank on its own tells you someone had a bad time; jank next to "and the page was holding 340
     cells / 280MB of bitmaps" tells you why, and lets /admin/scroll show whether smoothness degrades with
     load (see ScrollPerf::summary's byLoad bucket).

     Members only (guests have no session, and the endpoint is session-authed on purpose). Sends at most
     one small beacon per ~12s of ACTUAL scrolling, plus a final one on pagehide. */
  (function () {
    if (document.querySelector('meta[name="rova-guest"]')) return;    // guests: no session to attribute it to
    if (!window.requestAnimationFrame || !navigator.sendBeacon) return;
    if (!csrf) return;                                                // no token, no beacon (see handle_scroll_perf)

    var FLUSH_MS = 12000;      // report after this much accumulated scrolling
    var SLOW_MS  = 32;         // missed a 60fps beat
    var JANK_MS  = 64;         // a hitch you can actually see
    var IDLE_MS  = 400;        // scrolling is "over" after this long with no scroll event

    var s = null;              // the open session, or null when we aren't scrolling
    var running = false, lastFrame = 0, lastScroll = 0, pending = [];

    function fresh() {
      return { frames: 0, slow: 0, jank: 0, worst: 0, scrollMs: 0, px: 0, y: window.scrollY || 0,
               ltMs: 0, ltN: 0, ltMax: 0, ltFrame: 0, lagMs: 0, lagN: 0, n33: 0, n8: 0 };
    }

    /* WHY THESE EXTRA FIELDS (2026-07-29). The original beacon could tell us THAT frames were slow but
       never WHY, and the aggregate that mattered was hiding in plain sight: jank% scales with imgMB
       (decoded bitmaps -- chased twice) but slow% is FLAT across every imgMB bucket at 6-8%. A constant
       per-frame tax, independent of what the page holds, is a completely different animal from a
       memory-pressure problem, and nothing in the payload could distinguish them.
       Two cheap signals close that gap, and they are the ones to read together:
         ltMs  -- ms of LONG TASKS (>50ms of blocked main thread) inside the sample window.
                  slow% high + ltMs high  => main-thread JS is the problem (our code; fixable here).
                  slow% high + ltMs ~0    => raster / decode / compositing (NOT JS; do not tune JS).
         lagMs -- mean ms between a scroll event being created and our listener running. This is
                  queueing delay: how backed up the main thread already was when the scroll landed.
                  It is input latency, and it is what "sluggish" actually feels like.
       ltFrame splits the long-task total that the browser attributes to an IFRAME container (the
       Spotify/YouTube/SoundCloud embeds), so third-party player JS can never be misread as ours.
       longtask is unsupported on Safari, where these simply stay 0 -- the observer is feature-detected
       and every field is optional server-side. Cost is one PerformanceObserver that fires only when a
       task ALREADY blocked for >50ms, plus one subtraction per scroll event. */
    var ltObs = null;
    try {
      if (window.PerformanceObserver && (PerformanceObserver.supportedEntryTypes || []).indexOf('longtask') > -1) {
        ltObs = new PerformanceObserver(function (l) {
          if (!s) return;                                  // only count what lands inside an open session
          var es = l.getEntries();
          for (var i = 0; i < es.length; i++) {
            var d = es[i].duration || 0;
            s.ltMs += d; s.ltN++;
            if (d > s.ltMax) s.ltMax = d;
            var at = es[i].attribution && es[i].attribution[0];
            if (at && at.containerType && at.containerType !== 'window') { s.ltFrame += d; }
          }
        });
        ltObs.observe({ entryTypes: ['longtask'] });
      }
    } catch (e) { ltObs = null; }
    function plat() {
      var ua = navigator.userAgent || '';
      // iPadOS 13+ reports itself as a Mac, so the touch-point check is what separates them
      if (/iPhone|iPod/.test(ua)) return 'ios';
      if (/iPad/.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1)) return 'ipados';
      if (/Android/.test(ua)) return 'android';
      if (/Macintosh/.test(ua)) return 'mac';
      if (/Windows/.test(ua)) return 'win';
      return 'other';
    }
    function surface() {
      var pf = document.querySelector('.pfeed.show');
      if (pf) return 'pfeed';
      if (document.getElementById('feed-grid')) return 'grid';
      if (document.querySelector('.pgrid')) return 'profile-grid';
      if (document.getElementById('feed-posts')) return 'feed';
      return 'other';
    }
    // Estimated RESIDENT decoded-image bytes: naturalW * naturalH * 4, for every <img> that currently has
    // a src and has actually decoded. This is the number that matters on iOS -- a phone's tab ceiling is
    // measured in decoded bitmaps, not in transferred KB, and a 40KB thumbnail and a 3MB original of the
    // same pixel dimensions cost exactly the same here. Capped so the scan itself is never the slow thing.
    function imgMB() {
      var imgs = document.getElementsByTagName('img'), total = 0, n = Math.min(imgs.length, 1200);
      for (var i = 0; i < n; i++) {
        var im = imgs[i];
        if (im.getAttribute('src') && im.naturalWidth) { total += im.naturalWidth * im.naturalHeight * 4; }
      }
      return Math.round(total / 1048576);
    }
    function vidMix() {
      var a = 0, r = 0, m = 0, vs = document.getElementsByTagName('video');
      for (var i = 0; i < vs.length; i++) {
        var v = vs[i], u = v.getAttribute('src') || v.currentSrc || '';
        if (!u) continue;
        if (v.preload === 'auto') a++;
        if (v.readyState >= 2) r++;
        if (/cloudflarestream/i.test(u)) m++;
      }
      return [a, r, m];
    }
    function heapMB() {
      try {
        var m = window.performance && performance.memory;
        return m ? Math.round(m.usedJSHeapSize / 1048576) : 0;   // Chromium only; 0 elsewhere
      } catch (e) { return 0; }
    }

    var _lateSent = 0;
    function lateDelta() { var n = window.__rovaGridLate || 0, d = n - _lateSent; _lateSent = n; return d; }
    function snapshot(sess) {
      var conn = navigator.connection || {};
      var mix = vidMix();
      var live = 0;
      Array.prototype.forEach.call(document.querySelectorAll('video'), function (v) {
        if (v.getAttribute('src') || v.currentSrc) live++;
      });
      return {
        surface: surface(),
        frames: sess.frames, slow: sess.slow, jank: sess.jank, worst: Math.round(sess.worst),
        scrollMs: Math.round(sess.scrollMs), px: Math.round(sess.px),
        cells: document.querySelectorAll('.pcell').length,
        imgMB: imgMB(), vids: live, heapMB: heapMB(),
        // 2026-10-08: of those, how many are buffering (preload=auto), holding a decoded frame, and remote replays
        vauto: mix[0], vrs: mix[1], rem: mix[2],
        domNodes: document.getElementsByTagName('*').length,
        ua: (navigator.userAgent || '').slice(0, 180), plat: plat(),
        vw: window.innerWidth || 0, vh: window.innerHeight || 0,
        dpr: window.devicePixelRatio || 1,
        conn: (conn.effectiveType || ''), mem: navigator.deviceMemory || 0,
        // per-frame attribution -- see the block comment on fresh(). 0 where unsupported (Safari).
        ltMs: Math.round(sess.ltMs), ltN: sess.ltN, ltMax: Math.round(sess.ltMax),
        ltFrame: Math.round(sess.ltFrame),
        lagMs: sess.lagN ? Math.round(sess.lagMs / sess.lagN) : 0,
        // 30 = a 30Hz-capped session (>=70% of frames in the 31-36ms band: Low Power Mode, or a device
        // pinned at 30), 120 = a ProMotion cadence, else 60. Aggregate slow% WITHOUT the 30s.
        fps: (sess.frames && sess.n33 / sess.frames >= 0.7) ? 30 : ((sess.frames && sess.n8 / sess.frames >= 0.5) ? 120 : 60),
        // the sustained-jank governor's rung at flush (0 = nothing degraded) -- see __rovaJank below.
        // How often real members hit a rung is the number that says whether the ladder is tuned right.
        rung: (window.__rovaJank && window.__rovaJank.rung) || 0,
        // grid tiles the reader SAW still loading (shimmer on screen) since the last beacon -- 2026-10-03, the
        // "I shouldn't see tiles loading" pass. Counted in pcellMarkLoaded for cells the look-ahead loader put
        // on the wire; per screen travelled it is the field version of the lab's "% painted on arrival".
        tLate: lateDelta(),
        ts: new Date().toISOString()
      };
    }

    function send(finalFlush) {
      if (s && s.frames >= 20) { pending.push(snapshot(s)); }
      s = s ? fresh() : null;
      if (!pending.length) return;
      // Form-encoded, NOT JSON: sendBeacon can't set an X-CSRF-Token header, and form encoding fills
      // $_POST so the router's global CSRF gate passes with no exemption. See handle_scroll_perf.
      var body = new URLSearchParams();
      body.set('_csrf', csrf);
      body.set('samples', JSON.stringify(pending.slice(0, 12)));
      try {
        var ok = navigator.sendBeacon('/scroll-perf',
          new Blob([body.toString()], { type: 'application/x-www-form-urlencoded' }));
        if (ok || finalFlush) { pending = []; }   // on a final flush there's no next chance; don't hoard
      } catch (e) { /* telemetry never breaks the page */ }
    }

    function frame(now) {
      if (!running) return;
      if (Date.now() - lastScroll > IDLE_MS) {   // scrolling stopped: park the loop, keep the session open
        running = false; lastFrame = 0;
        return;
      }
      if (lastFrame) {
        var dt = now - lastFrame;
        // A pathological gap (>2s) is a backgrounded tab or a JS breakpoint, not a rendering problem.
        // Counting it would poison the worst-frame stat with something the user never saw.
        if (dt < 2000) {
          s.frames++;
          s.scrollMs += dt;
          if (dt > s.worst) s.worst = dt;
          if (dt > JANK_MS) s.jank++;
          else if (dt > SLOW_MS) s.slow++;
          /* REFRESH-RATE DISCRIMINATOR (2026-09-06). iOS Low Power Mode caps rAF at 30Hz, so every
             frame lands at ~33.3ms -- one hair over SLOW_MS -- and such a session reports ~100% slow
             whatever the page did. Read over the last 7 days, 22% of iOS beacons were exactly that
             shape (80-100% slow, worst ~36ms), and they carried the whole "iOS is 11% slow" headline:
             excluding them, iOS ran ~1-2.4% slow. Two band counts let the reader tell them apart --
             a 30Hz cap is a tight 31-36ms band, a genuinely struggling page is spread; n8 catches
             120Hz (ProMotion) displays, where a >16.7ms frame is already two dropped beats. Reported
             as one 'fps' field (see snapshot), never used to change what the page does. */
          if (dt >= 31 && dt <= 36) s.n33++;
          else if (dt <= 10) s.n8++;
        }
      }
      lastFrame = now;
      if (s.scrollMs >= FLUSH_MS) { send(false); }
      requestAnimationFrame(frame);
    }

    function onScroll(e) {
      lastScroll = Date.now();
      if (!s) s = fresh();
      // queueing delay: the event was created at e.timeStamp; we are running now. On an idle main
      // thread this is ~0. Anything else is time the page spent unable to answer the finger.
      if (e && e.timeStamp) {
        var lag = ((window.performance && performance.now) ? performance.now() : 0) - e.timeStamp;
        if (lag >= 0 && lag < 2000) { s.lagMs += lag; s.lagN++; }
      }
      var y = window.scrollY || 0;
      s.px += Math.abs(y - s.y); s.y = y;
      if (!running) { running = true; lastFrame = 0; requestAnimationFrame(frame); }
    }
    window.addEventListener('scroll', onScroll, { passive: true, capture: true });

    // pagehide (not unload) is the one iOS Safari actually fires when a tab is backgrounded or the app is
    // swiped away, and it's bfcache-safe. visibilitychange covers a tab switch that never unloads.
    window.addEventListener('pagehide', function () { send(true); });
    document.addEventListener('visibilitychange', function () { if (document.hidden) send(true); });

    /* ---- DID THE LAST PAGE IN THIS TAB DIE? (2026-10-08) ------------------------------------------------
       Rob, desktop Safari: "This webpage was reloaded because a problem occurred" -- WebKit discarded the
       tab's web content process and reloaded the URL. Nothing on the server could tell that from an
       ordinary reload: the new page is a normal GET with the same Referer, and the dead page just stops
       beaconing. The one thing a killed page can NOT do is fire pagehide, and sessionStorage outlives the
       content process (WebKit keeps it in the network process). So while the reader scrolls, a small
       snapshot of what the page is holding sits under one key marked c:0; pagehide marks it c:1. A page
       that finds c:0 left by the previous page of the SAME tab, at the SAME URL (a crash recovery reloads
       the URL it lost), knows that page never reached pagehide and files ONE 'died' row in scroll-log.jsonl
       with that last snapshot. A manual reload, a navigation, a tab close and a bfcache park all fire
       pagehide, so none of them reads as a death. `hid` says whether the page was in the background
       (a tab Safari evicted while you were elsewhere) and `nav` records the navigation type, unfiltered. */
    (function () {
      var KEY = 'rova_life', ss = null;
      try { ss = window.sessionStorage; ss.setItem(KEY + '_p', '1'); ss.removeItem(KEY + '_p'); } catch (e) { return; }
      var born = Date.now(), lastW = 0, wT = 0;
      var here = function () { return (location.pathname + location.search).slice(0, 80); };
      function snap() {
        var live = 0, vs = document.getElementsByTagName('video'), mix = vidMix();
        for (var i = 0; i < vs.length; i++) { if (vs[i].getAttribute('src') || vs[i].currentSrc) live++; }
        return { was: surface(), vids: live, vauto: mix[0], vrs: mix[1], rem: mix[2], imgMB: imgMB(), heapMB: heapMB(),
                 domNodes: document.getElementsByTagName('*').length, cells: document.querySelectorAll('.pcell').length,
                 upS: Math.round((Date.now() - born) / 1000), hid: document.hidden ? 1 : 0, path: here(), t: Date.now(), c: 0 };
      }
      function write() { wT = 0; lastW = Date.now(); try { ss.setItem(KEY, JSON.stringify(snap())); } catch (e) {} }
      function soon(ms) { if (!wT) { wT = setTimeout(write, ms); } }
      try {
        var prev = JSON.parse(ss.getItem(KEY) || 'null');
        if (prev && prev.c === 0 && prev.t && Date.now() - prev.t < 30 * 60000 && prev.path === here()) {
          var nav = ''; try { var ne = performance.getEntriesByType('navigation')[0]; nav = (ne && ne.type) || ''; } catch (e) {}
          var row = { surface: 'died', died: 1, frames: 0, was: prev.was, vids: prev.vids, vauto: prev.vauto, vrs: prev.vrs, rem: prev.rem,
                      imgMB: prev.imgMB, heapMB: prev.heapMB, domNodes: prev.domNodes, cells: prev.cells, upS: prev.upS, hid: prev.hid,
                      gapS: Math.round((Date.now() - prev.t) / 1000), nav: nav, path: prev.path,
                      ua: (navigator.userAgent || '').slice(0, 180), plat: plat(), vw: window.innerWidth || 0, vh: window.innerHeight || 0,
                      dpr: window.devicePixelRatio || 1, ts: new Date().toISOString() };
          var body = new URLSearchParams();
          body.set('_csrf', csrf);
          body.set('samples', JSON.stringify([row]));
          try { navigator.sendBeacon('/scroll-perf', new Blob([body.toString()], { type: 'application/x-www-form-urlencoded' })); } catch (e) {}
        }
      } catch (e) {}
      soon(3000);                                                     // this page is alive from now on
      window.addEventListener('scroll', function () { if (Date.now() - lastW > 4000) soon(300); }, { passive: true, capture: true });
      document.addEventListener('visibilitychange', function () { soon(0); });
      document.addEventListener('rova:paged', function () { soon(300); }, true);   // a tab swap moved the URL (pushState): re-key it
      window.addEventListener('pagehide', function () {
        clearTimeout(wT); wT = 0;
        try { var s = JSON.parse(ss.getItem(KEY) || 'null') || {}; s.c = 1; s.t = Date.now(); ss.setItem(KEY, JSON.stringify(s)); } catch (e) {}
      });
      window.addEventListener('pageshow', function (e) { if (e && e.persisted) soon(0); });   // back from bfcache: alive again
    })();
  })();

  /* ---- SUSTAINED-JANK GOVERNOR (2026-09-07) ---------------------------------------------------------
     Owner, from the native app on the Grid tab while AirPlay-mirroring to a TV (bug #706): "scrolling is
     getting way too choppy ... other apps like Instagram work fine." Mirroring doubles the compositor's
     work per frame; what tips a grid over is its CONTINUOUS ambient load -- the idle cascade's crossfades,
     the Ken Burns drifts, the live video tiles -- none of which Instagram runs. The app can see the
     external display; the web cannot, so the web degrades on the one thing it CAN measure: sustained
     slow frames. This is the web half of that parity.

     MEASURE. A rAF delta sampler that runs whenever the page is visible (the scroll-perf RUM above only
     runs while scrolling -- the load this exists to catch is there while the reader sits still). One
     push per frame, a rolling WIN_MS window, evaluated once a second. A frame over SLOW_MS is slow.
     LOW POWER MODE IS NOT JANK: iOS caps rAF at 30Hz there and every frame lands at ~33ms (22% of iOS
     beacons -- see the `fps` field above). If the window's MEDIAN sits in the 30-37ms band, that cadence
     is the baseline and "slow" becomes > LPM_MULT x baseline, so a 30Hz page never trips on its own.

     STEP DOWN one rung when >= TRIP_PCT of the window is slow for TRIP_SECS consecutive evaluations,
     never faster than HOLD_MS between steps; STEP UP one rung after CALM_MS with < CALM_PCT slow, one
     rung per CALM_MS. The rungs only OVERRIDE the existing knobs while active -- the cascade ladder, the
     Ken Burns band, the governor caps and their defaults are untouched:
       1  pause the feed through the reader's own pause latch (__rovaFeedPauseCtl, the same `paused`
          the tab-strip pill flips): the idle cascade, the live poll and the card feed's roll all read
          it, and the pill/latch show "Paused" so the UI tells the truth. NEVER THE READER'S OWN PAUSE:
          if they paused, rung 1 is a no-op and rung 1's release touches nothing; if we paused and
          they resumed by hand, the pill's click handler drops our ownership marker and we stand down.
       2  html.rova-kb0 -- every Ken Burns pan paused (the grid's count budget goes to 0; rova.css).
       3  video governor caps to 1: the grid's decoder cap (__rovaGridCap over CAP_TOUCH/CAP_DESKTOP)
          and the feed's start scheduler (__rovaVidCap over VS_CAP), enforced immediately.
       4  ...and to 0: no NEW grid decoders at all (ensureVideo declines), feed starts one at a time.
       5  html.rova-lite -- backdrop-filter dropped on every in-flow surface (rova.css).
     State on window.__rovaJank {rung, slowPct, baseline, since} for the HUD; `rung` rides the scroll-perf
     beacon. `rova:jank` fires on every step (harness receipt). Nothing here reads layout. */
  (function () {
    if (!window.requestAnimationFrame) return;
    var WIN_MS = 3000, SLOW_MS = 28, LPM_LO = 30, LPM_HI = 37, LPM_MULT = 1.7, LPM_FAST_MAX = 0.1, MIN_FRAMES = 6, GRACE_MS = 8000;
    var TRIP_PCT = 0.40, TRIP_SECS = 3, HOLD_MS = 5000, CALM_PCT = 0.10, CALM_MS = 20000, MAX_RUNG = 5;
    var FEED_KEY = 'rova_feed_paused', OWNER_KEY = 'rova_feed_paused_by';
    var buf = [], lastT = 0, lastEval = 0, rung = 0, since = Date.now(), hot = 0, calmSince = Date.now(), lastStep = 0;
    var slowPct = 0, baseline = 0, govPausedFeed = false, savedGridCap, savedVidCap, running = false, log = [], startedAt = 0;

    // A governor pause that outlived its page (navigated away before recovery) must not become the
    // reader's preference: the marker says it was ours, so clear it before the feed reads the key.
    try { if (localStorage.getItem(OWNER_KEY) === 'gov') { localStorage.setItem(FEED_KEY, '0'); localStorage.removeItem(OWNER_KEY); } } catch (e) {}

    function feedCtl() { return window.__rovaFeedPauseCtl || null; }
    function feedPaused() { var c = feedCtl(); if (c) return !!c.get(); try { return localStorage.getItem(FEED_KEY) === '1'; } catch (e) { return false; } }
    function setFeedPaused(on) { var c = feedCtl(); if (c) { c.set(on); return; } try { localStorage.setItem(FEED_KEY, on ? '1' : '0'); } catch (e) {} }
    function enforceCaps() {
      try { if (window.__rovaGridEnforce) window.__rovaGridEnforce(); } catch (e) {}
      try { if (window.__rovaVidEnforce) window.__rovaVidEnforce(); } catch (e) {}
    }
    function apply(r, on) {
      var html = document.documentElement;
      switch (r) {
        case 1:
          if (on) {
            // nothing to pause here (no grid, no feed transport): the rung passes through, the ladder still counts
            if (!document.getElementById('live-toggle') && !document.getElementById('feed-grid')) return;
            if (feedPaused()) return;                              // theirs. Never ours to resume.
            setFeedPaused(true); govPausedFeed = true;
            try { localStorage.setItem(OWNER_KEY, 'gov'); } catch (e) {}
          } else {
            if (!govPausedFeed) return;
            govPausedFeed = false;
            var mine = false; try { mine = localStorage.getItem(OWNER_KEY) === 'gov'; } catch (e) {}
            try { localStorage.removeItem(OWNER_KEY); } catch (e) {}
            if (mine && feedPaused()) setFeedPaused(false);       // restore ONLY what we changed
          }
          break;
        case 2: html.classList.toggle('rova-kb0', on); break;
        case 3:
          if (on) { savedGridCap = window.__rovaGridCap; savedVidCap = window.__rovaVidCap; window.__rovaGridCap = 1; window.__rovaVidCap = 1; }
          else { window.__rovaGridCap = savedGridCap; window.__rovaVidCap = savedVidCap; }
          enforceCaps();
          break;
        case 4:
          window.__rovaGridCap = on ? 0 : 1; window.__rovaVidCap = on ? 0 : 1;
          enforceCaps();
          break;
        case 5: html.classList.toggle('rova-lite', on); break;
      }
    }
    function publish() {
      window.__rovaJank = { rung: rung, slowPct: Math.round(slowPct * 1000) / 10, baseline: Math.round(baseline * 10) / 10, since: since, frames: buf.length, log: log };
    }
    function step(to) {
      var from = rung;
      try { if (to > from) apply(to, true); else apply(from, false); } catch (e) {}
      rung = to; since = Date.now(); lastStep = since;
      if (log.length > 40) log.shift();
      log.push({ t: since, from: from, to: to, slowPct: Math.round(slowPct * 1000) / 10, baseline: Math.round(baseline * 10) / 10 });
      publish();
      try { document.dispatchEvent(new CustomEvent('rova:jank', { detail: { rung: rung, from: from } })); } catch (e) {}
    }
    function evaluate(now) {
      var cut = now - WIN_MS, i = 0, k;
      while (i < buf.length && buf[i][0] < cut) i++;
      if (i) buf.splice(0, i);
      if (buf.length < MIN_FRAMES) { publish(); return; }             // just resumed, or hidden: no verdict
      var d = [];
      for (k = 0; k < buf.length; k++) d.push(buf[k][1]);
      d.sort(function (a, b) { return a - b; });
      baseline = d[d.length >> 1];
      /* A 30Hz CAP NEVER DELIVERS A FAST FRAME. Measured on the first proof run: a page under 6x CPU sat
         with a MEDIAN of exactly 33ms for several seconds (half its frames at 16-33, half at 50-180) and a
         median-only test read it as Low Power Mode, raising the bar to 56ms and holding the trip off for
         14s. What separates the two is the FLOOR, not the spread: a 30Hz vsync cannot present a frame in
         under ~33ms, whereas a struggling 60Hz page always still lands some 16.7ms frames between the long
         ones. (An in-band SHARE test was tried first and failed the other way: a genuine 30Hz page with a
         busy main thread at load pushes half its frames to 40-50ms, loses the band, and trips on itself.)
         So the baseline moves to the 30Hz cadence when the median is in band AND fewer than LPM_FAST_MAX
         of the window came in under LPM_LO. Sorted ascending, so the fast frames are the head. */
      var fast = 0;
      for (k = 0; k < d.length && d[k] < LPM_LO; k++) fast++;
      var lpm = (baseline >= LPM_LO && baseline <= LPM_HI) && (fast / d.length < LPM_FAST_MAX);
      var thr = lpm ? baseline * LPM_MULT : SLOW_MS;
      var slow = 0;
      for (k = d.length - 1; k >= 0 && d[k] > thr; k--) slow++;      // sorted: the slow ones are at the tail
      slowPct = slow / d.length;
      var wall = Date.now();
      // A page that is still LOADING is not a page that is janking: the grid decodes 150 thumbnails, warms
      // the first cascade and starts its tiles in the first few seconds, and that burst tripped rung 1 at
      // 4.7s on the proof rig. No verdict until GRACE_MS after the sampler started.
      if (wall - startedAt < GRACE_MS) { hot = 0; calmSince = wall; publish(); return; }
      if (slowPct >= TRIP_PCT) { hot++; calmSince = wall; }
      else { hot = 0; if (slowPct >= CALM_PCT) calmSince = wall; }
      if (hot >= TRIP_SECS && rung < MAX_RUNG && wall - lastStep >= HOLD_MS) { step(rung + 1); hot = 0; }
      else if (rung > 0 && wall - calmSince >= CALM_MS && wall - lastStep >= HOLD_MS) { step(rung - 1); calmSince = wall; }
      publish();
    }
    function frame(now) {
      if (lastT) {
        var dt = now - lastT;
        if (dt < 2000) buf.push([now, dt]);                          // >2s = a hidden tab / breakpoint, not a frame
      }
      lastT = now;
      if (now - lastEval >= 1000) { lastEval = now; evaluate(now); }
      requestAnimationFrame(frame);
    }
    document.addEventListener('visibilitychange', function () { lastT = 0; buf.length = 0; hot = 0; });
    // Only pages that carry something the rungs can act on get a sampler at all (a settings page has
    // no cascade, no pans, no tiles); re-checked lazily because grids arrive by AJAX tab swap.
    function armed() { return !!document.querySelector('.pcell, .post, .pfeed, video'); }
    function start() { if (running) return; running = true; startedAt = Date.now(); publish(); requestAnimationFrame(frame); }
    if (armed()) start();
    else { var poke = setInterval(function () { if (armed()) { clearInterval(poke); start(); } }, 5000); }
    publish();
    window.__rovaJankForce = function (to) { to = Math.max(0, Math.min(MAX_RUNG, to | 0)); while (rung < to) step(rung + 1); while (rung > to) step(rung - 1); return rung; };   // harness only
  })();

  /* ---- admin: add / remove shadow-ban phrases without a page reload ------ */
  adminPanel('spam', function () {
    var listBox = document.querySelector('.shadow-list');
    if (!listBox) return;
    function chipHTML(ph) {
      return '<form method="post" action="/admin/spam/shadow-remove" class="shadow-chip">'
        + '<input type="hidden" name="_csrf" value="' + escHtml(csrf) + '">'
        + '<input type="hidden" name="phrase" value="' + escHtml(ph) + '">'
        + '<span>' + escHtml(ph) + '</span><button type="submit" aria-label="Remove" title="Remove">&times;</button></form>';
    }
    function render(phrases) {
      listBox.innerHTML = (phrases && phrases.length)
        ? phrases.map(chipHTML).join('')
        : '<span class="muted" style="font-size:13px">None yet.</span>';
    }
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || !f.classList) return;
      var isAdd = f.classList.contains('shadow-add'), isRem = f.classList.contains('shadow-chip');
      if (!isAdd && !isRem) return;
      e.preventDefault();
      var btn = f.querySelector('button');
      if (busyIs(btn)) return;
      busyUntil(btn, fetch(f.getAttribute('action'), {
        method: 'POST',
        headers: { 'X-CSRF-Token': csrf, 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
        body: new FormData(f), credentials: 'same-origin'
      }).then(function (r) { return r.json().catch(function () { return {}; }); })
        .then(function (res) {
          if (res && res.ok) {
            render(res.phrases || []);
            if (isAdd) { var inp = f.querySelector('input[name="phrase"]'); if (inp) { inp.value = ''; inp.focus(); } }
          } else { toast((res && res.error) || 'Could not update phrases.'); }
        })
        .catch(function () { toast('Network error, please retry.'); }));
    });
  });

  /* ---- pinch to peek: zoom a timeline photo/video in place (2 fingers),
     then it springs back on release. Capture-phase + stopPropagation so it never
     trips the single-photo rubber-band or the multi-photo swipe pager. ---------- */
  (function () {
    if (!('ontouchstart' in window)) return;
    var media = null, node = null, active = false, startD = 0, midX = 0, midY = 0, suppress = false, baseTf = '';
    /* THE PINCH OWNS ITS WHOLE GESTURE, INCLUDING THE FINGER LEFT BEHIND (2026-09-30, iOS build 551
       parity pass: "pinch to zoom stops me from being able to swipe"). The web has no stuck lock -- this
       peek springs back on release and every lock below is cleared in end(), MEASURED with CDP two-finger
       pinches (1.03x, 2x + pan + back to 1x, either lift order, both fingers together): the next swipe
       paged every time. What it DID have was the opposite leak: the pager and the pull-to-dismiss saw the
       gesture's FIRST finger go down (the second one's touchstart is stopped here) and then, after one
       finger lifted and end() ran, saw the remaining finger move and lift -- and measured that finger
       against the OTHER finger's start point. A vertical pinch lifted bottom-finger-first moved the viewer
       to the next post (kbrig.js --scen=vert: STRAY 50116 -> 52643); at the top of a deck the same shape
       can read as a >70px pull and close the viewer. So: `tail` swallows the remaining finger's moves
       (preventDefault too, so it cannot native-scroll the snap list either), the final all-fingers-up
       touchend is let through so every handler's finger-up bookkeeping still runs (the pager's hfNavDown
       release), and __rovaPinchAt tells the pager + pull that this gesture was a pinch, not a swipe. */
    var tail = false;
    function dist(t) { return Math.hypot(t[0].clientX - t[1].clientX, t[0].clientY - t[1].clientY); }
    function end() {
      if (!active) return;
      active = false;
      if (node) {
        node.style.transition = 'transform .26s cubic-bezier(.2,.7,.2,1)';
        node.style.transform = '';
        var n = node;
        setTimeout(function () { n.style.transition = ''; n.style.willChange = ''; }, 300);
      }
      if (media) media.classList.remove('pinching');
      if (media && media._slide) { media._slide.classList.remove('pinch-cur'); media._slide = null; }
      if (media && media._pp) { media._pp.classList.remove('pinch-top'); media._pp = null; }
      media = null; node = null;
      suppress = true; setTimeout(function () { suppress = false; }, 450);   // eat the trailing click
    }
    document.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 2) return;
      var m = e.target.closest ? e.target.closest('.post .media') : null;
      if (!m) return;
      // In a carousel, zoom the media of the SLIDE under the fingers -- NOT m.querySelector (which
      // always returned the FIRST slide's element, so pinching the 2nd photo zoomed the 1st video).
      // Fall back to the touch's midpoint slide if the target itself sits on an overlay.
      var slide = e.target.closest ? e.target.closest('.cslide') : null;
      if (!slide && m.classList.contains('carousel')) {
        var mid = document.elementFromPoint(
          (e.touches[0].clientX + e.touches[1].clientX) / 2,
          (e.touches[0].clientY + e.touches[1].clientY) / 2);
        slide = mid && mid.closest ? mid.closest('.cslide') : null;
      }
      var n = slide ? slide.querySelector('img, video') : m.querySelector('img, video');
      if (!n) return;
      e.stopPropagation();                                  // keep it away from the swipe handlers
      media = m; node = n; active = true; tail = false;
      window.__rovaPinchAt = Date.now();                    // this gesture is a pinch (pager + pull read it)
      if (window.__rovaPfKbPark) { try { window.__rovaPfKbPark(m); } catch (er) {} }   // the viewer's drift parks
      startD = dist(e.touches) || 1;
      midX = (e.touches[0].clientX + e.touches[1].clientX) / 2;
      midY = (e.touches[0].clientY + e.touches[1].clientY) / 2;
      node.style.transition = 'none'; node.style.willChange = 'transform';
      /* KEEP THE FIT UNDER THE FINGERS (2026-09-11, owner: "zooming results in a black strip on the right").
         This handler was written for the timeline card, whose <img> has no transform of its own, so it
         could WRITE the inline transform outright. In the immersive viewer the photo's transform IS its
         fit: .pf-zoomable draws contain-fitted then scale(--pf-cover) with the --pf-panx/--pf-pany crop
         window on top. Overwriting that dropped the cover scale on the first pinch frame -- MEASURED
         (scratchpad pfgeo/pinch.js, 810x1440 photo on 420x912, cover 1.2214): the drawn picture went
         549 -> 472px wide at scale 1.05, a 50px black band opened at the top, and the right edge sat
         1.5px from black under a 15px finger drift (the Ken Burns pass parks the picture -2%, which is
         what made the RIGHT side the short one). Read the element's computed transform once at
         pinch-start and compose the pinch in front of it: the picture zooms from the fit it had, the
         timeline card composes with 'none' and behaves exactly as before, and end() still clears the
         whole inline transform so the CSS fit returns on release. */
      var _bt = '';
      try { var _cs = getComputedStyle(node).transform; if (_cs && _cs !== 'none') { _bt = ' ' + _cs; } } catch (er) { _bt = ''; }
      baseTf = _bt;
      media.classList.add('pinching');
      // carousel: reveal ONLY the touched slide (lift it, hide the off-screen siblings) so a neighbour
      // clip can't poke into view while its media is behind the one being zoomed
      if (slide) { slide.classList.add('pinch-cur'); media._slide = slide; }
      // lift the whole post into its own top stacking context so a neighbouring
      // video's compositing layer can't paint over the picture being zoomed
      media._pp = m.closest ? m.closest('.post') : null;
      if (media._pp) media._pp.classList.add('pinch-top');
    }, true);
    document.addEventListener('touchmove', function (e) {
      if (tail) { e.stopPropagation(); if (e.cancelable) e.preventDefault(); return; }   // the finger left behind
      if (!active || e.touches.length !== 2) return;
      e.stopPropagation();
      if (e.cancelable) e.preventDefault();                 // no page zoom / scroll under it
      var scale = Math.max(1, Math.min(3.4, dist(e.touches) / startD));
      var mx = (e.touches[0].clientX + e.touches[1].clientX) / 2;
      var my = (e.touches[0].clientY + e.touches[1].clientY) / 2;
      node.style.transform = 'translate(' + (mx - midX) + 'px,' + (my - midY) + 'px) scale(' + scale + ')' + baseTf;
    }, { capture: true, passive: false });
    document.addEventListener('touchend', function (e) {
      if (!active && !tail) return;
      var left = e.touches ? e.touches.length : 0;
      if (left > 0) { e.stopPropagation(); }                // fingers remain: still ours (see `tail`)
      if (active && left < 2) { end(); }
      tail = left > 0;
    }, true);
    document.addEventListener('touchcancel', function () { tail = false; if (active) end(); }, true);
    // swallow the click that fires right after a pinch so it doesn't open the slideshow
    document.addEventListener('click', function (e) {
      if (suppress && e.target.closest && e.target.closest('.post .media')) { e.preventDefault(); e.stopPropagation(); }
    }, true);
  })();

  /* ---- pull to refresh (feed) ------------------------------------------ */
  // true while a flyout / media overlay owns the screen: the page must not
  // pull-to-refresh or collapse chrome under it (that reload was closing DMs)
  function overlayOpen() {
    // .pfeed.show (the immersive viewer) MUST count: it locks the body at position:fixed, so
    // window.scrollY reads 0 and the feed's pull-to-refresh would otherwise arm under it -- a
    // swipe-down to dismiss/see-previous instead reloaded the timeline behind the overlay. The
    // profile page has no pull-to-refresh, which is why it already felt right; this makes the
    // timeline behave the same (all page-level gesture handlers stand down while the viewer is up).
    return !!document.querySelector('.pfeed.show, .hdrop-panel.open, .lightbox.show, .gal.show, .vtrim, .cropper, #auth-modal.show, #change-email-modal.show, #menu-panel.show');
  }
  window.__rovaOverlayOpen = overlayOpen;
  var ptr = document.getElementById('ptr');
  if (ptr && 'ontouchstart' in window) {
    /* ---- PULL TO REFRESH: an honest state instead of a ring that never resolves (2026-08-04) -----
       The commit below used to be `window.location.reload()`. On a link that is UP but too weak to
       carry the request -- one bar, connected, nothing loading -- a navigation neither commits nor
       fails for as long as the platform holds the socket (60-120s on iOS Safari), and nothing in
       this file could see that, cancel it, or say a word about it: `refreshing` is added here and
       removed NOWHERE in the file, so the gold ring at the top of the feed spun for as long as the
       phone allowed and then, if the load did finally fail, the browser's own error page replaced
       the feed. That is the screenshot.

       So the refresh is now a READ WE OWN instead of a navigation we hand away: rfetch the active
       tab's partial -- the same URL and the same innerHTML swap the tab pager has run in production
       since round 126 -- with a deadline, a failure path, and a background retry behind it. On a
       good link this is strictly CHEAPER than the reload it replaces (one ~15KB partial instead of a
       whole document plus every subresource) and it lands the fresh posts with no white flash.

       Spinner discipline, which is the actual ask: attempt ONE spins, bounded at 8s by rfetch, and
       that bound IS the owner's "after a while". Every attempt after it is SILENT -- the strip holds
       one static line and the retrying happens in the background.

       OFFLINE IS NOT THE ONLY WAY THIS FAILS, and saying it is would be a lie. rfetch rejects a
       non-2xx with err.status set; a network-layer failure (dropped socket, our own abort deadline)
       carries no status at all. A 5xx means the member's connection is fine and WE are down, so it
       gets its own sentence rather than sending someone to reboot a router that works. */
    // (the gesture's own state lives in THE PULL AT THE TOP IS OURS, below)
    var PTR_MSG_H = 34;
    var ptrMsg = document.createElement('div');
    ptrMsg.className = 'ptr-msg';
    ptrMsg.setAttribute('role', 'status');
    ptr.appendChild(ptrMsg);

    function ptrDown() { return ptr.classList.contains('ptr-down'); }
    // Collapse to nothing. If the strip has scrolled above the fold, take the height back out of
    // the scroll position too -- Safari has no scroll anchoring, so removing 34px above the reader
    // would otherwise walk the page up under them.
    function ptrIdle() {
      var above = false;
      try { above = ptr.getBoundingClientRect().bottom < 0; } catch (e) {}
      var h = ptr.offsetHeight || 0;
      ptr.classList.remove('refreshing', 'ready', 'ptr-down', 'ptr-float');
      ptr.style.height = '0';
      ptrMsg.textContent = '';
      if (above && h) { try { window.scrollBy(0, -h); } catch (e) {} }
      gapClose();                                        // the held gap closes over the landed list (THE SPINNER LIVES IN THE GAP)
    }
    function ptrFail(err) {
      var st = (err && err.status) || 0;
      ptr.classList.remove('refreshing', 'ready', 'ptr-float');
      ptr.classList.add('ptr-down');
      // His wording for a genuine connectivity failure; an honest, different sentence for ours.
      ptrMsg.textContent = st ? 'Rova is having trouble' : 'Offline mode';
      ptr.style.height = PTR_MSG_H + 'px';
      gapClose();
    }
    function ptrUrl() {
      var on = document.querySelector('#feed-tabs .js-tab.on') || document.querySelector('#feed-tabs .js-tab');
      var href = on ? on.getAttribute('href') : (location.pathname + location.search);
      /* &refresh=1 -- THIS REQUEST IS A PULL, and saying so is the only way the server can tell.
         The grid's six-hour refresh cycle (owner 2026-09-16) advances a stage on a pull and NOT on
         a tab swap, a load-more or a re-render, and every one of those arrives here as the same
         `?tab=grid&partial=posts`. A desktop browser has no pull gesture at all, so a full document
         render of /feed?tab=grid counts as the refresh there instead; this is the touch half.
         Harmless on every other tab -- handle_feed reads the flag only inside its grid branch, and
         a pull on Following/New/Trending/Discover behaves exactly as it did before.
         It is part of the STALENESS KEY too (`ptrUrl() !== want` below), which is why it belongs in
         this function rather than at the fetch: the two strings have to be built the same way.

         NOT FOR A GUEST, and that is a cache decision rather than a behavioural one. A logged-out
         visitor has no cycle -- GridCycle answers viewer 0 from memory with stage 0 and never even
         queries -- so the flag changes nothing about the body. But the /feed edge cache keys on the
         URL ALONE [[edge-cache]], so putting a parameter on a guest's URL that cannot change the
         answer would split one shared, cacheable page into two identical copies and buy an extra
         origin fill per TTL for nothing. The `rova-guest` meta is the same signal the guest browse
         gate reads. */
      var guest = !!document.querySelector('meta[name="rova-guest"]');
      return href + (href.indexOf('?') >= 0 ? '&' : '?') + 'partial=posts' + (guest ? '' : '&refresh=1');
    }
    /* WHO ASKED FOR THIS READ (2026-09-29, iOS build 532 parity -- Rob: "yes make the web do the same").
       THE RULE: a feed page that lands without the member asking NEVER replaces the rows on screen. The
       pull itself is the member asking, so the attempt the release fires (ptrAsked) may still swap the
       list, exactly as before. Every LATER attempt -- the backoff ladder's 2/4/8/15/30/60 s turns, and
       onReconnect's -- arrives on a timer or a radio event, minutes after the finger left, with the rows
       he has been reading since still on screen. Those no longer swap anything: the link being back is
       said by clearing the offline line, and his rows stay put (a list with NO rows is the one exception
       -- there is nothing on screen to protect). The next pull refreshes, as it always did.
       Judged when the read LANDS, not when it left: a pull that finds an attempt already on the wire
       (makeRetrier.now() leaves a live one alone) is answered by that attempt, so the question is "did
       he pull within the last read's deadline", PTR_ASK_MS = the 8 s rfetch deadline plus slack. */
    var ptrAskedAt = 0, PTR_ASK_MS = 10000;
    var ptrRetry = makeRetrier(function (settle) {
      var list = document.getElementById('feed-posts');
      if (!list) { ptrIdle(); settle(true); return; }
      var want = ptrUrl();
      var ptrFull = function () {
      rfetch(want, { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', cache: 'no-store' }, 8000)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          // The reader may have changed tabs while this was in flight. A stale partial must not
          // land on a tab it does not belong to -- clear the state and let the pager own the panel.
          if (ptrUrl() !== want) { ptrIdle(); settle(true); return; }
          // SILENT RECOVERY, with one condition. A pull can only ARM at the top, but a background
          // retry can succeed minutes later, by which time the reader may be six screens down --
          // and swapping the list out from under them there is exactly the ceremony we are removing.
          // So: near the top, do the refresh they asked for; otherwise just drop the offline state
          // (the link being back is the honest signal) and leave their scroll alone.
          var hasRows = !!list.querySelector('.post[data-id], .pcell[data-id]');
          var asked = Date.now() - ptrAskedAt < PTR_ASK_MS;   // the member's own pull, not a backoff turn
          if ((window.scrollY || 0) <= 200 && (asked || !hasRows)) {
            list.innerHTML = (html || '').trim();
            try { list.dispatchEvent(new CustomEvent('rova:paged')); } catch (e) {}   // the pager re-reads its more-flag
            try { hydrateChunked(list); } catch (e) {}
          }
          ptrIdle();
          settle(true);
        })
        .catch(function (err) {
          ptrFail(err);
          var st = (err && err.status) || 0;
          // A 4xx is not a connectivity problem and will not fix itself on a timer (a dead session,
          // a gate). Say it once and stop spending the origin's budget on it; the next pull, and a
          // real reconnect, still re-ask. 5xx and network failures keep the loop.
          settle(st >= 400 && st < 500);
        });
      };
      /* WS-C 2026-10-22 (Rob: "New tab = pure chronological ... pull-to-refresh just fetches newer posts"). On a pure New
         (#feed-posts[data-newpure="1"]) a pull asks the realtime stream for what is NEWER than the list's newest card and
         lands it on top (window.__rovaNewCatchUp, the realtime block); the rows already there stay. Only a gap too big for
         one catch-up (20) falls through to the page-one replace above. */
      var nc = (window.__rovaNewCatchUp && /[?&]tab=new(&|$)/.test(want) && list.querySelector('.post[data-id]')) ? window.__rovaNewCatchUp(true) : null;
      if (nc) {
        nc.then(function (res) {
          if (res === 'full') { ptrFull(); return; }
          ptrIdle(); settle(true);
        }, function (err) {
          ptrFail(err);
          var st0 = (err && err.status) || 0;
          settle(st0 >= 400 && st0 < 500);
        });
        return;
      }
      ptrFull();
    });
    /* OWNERSHIP BY ORIGIN (owner 2026-08-18: with a post's comment panel expanded near the top of
       the feed, "swiping up to see old comments" armed this refresh and the re-render "loses the
       post"). A touch that BEGINS inside a comment surface -- or inside ANY live inner scroll
       region -- belongs to that region for its whole life and must never arm a page-level
       refresh, whether or not the inner list can consume the travel (a panel too short to scroll
       is still the thing the reader is touching). The guarded panels stopPropagation their own
       touches already; this is the belt for the surfaces that deliberately do not (and for the
       like-control exemption those guards carry). The generic walk is the same
       ownership-by-origin rule the pager and the carousel follow, applied to the one gesture
       this file owns. */
    function ptrForeignOrigin(t) {
      if (!t || !t.closest) return false;
      // v6: a card's comment sheet is up (or this is the gesture that just folded one): that touch scrolls the page
      // and folds the sheet, never pulls (roller-panel-morph v6)
      if (window.__rovaCrGesture && window.__rovaCrGesture()) return true;
      if (t.closest('.comment-panel, .croller-panel, #comment-list')) return true;
      for (var n = t; n && n !== document.body; n = n.parentElement) {
        if (n.scrollHeight > n.clientHeight + 1) {
          var oy = '';
          try { oy = getComputedStyle(n).overflowY; } catch (err) {}
          if (oy === 'auto' || oy === 'scroll') return true;
        }
      }
      return false;
    }
    /* OWNERSHIP BY DIRECTION FOR A TOUCH BORN IN A HORIZONTAL SCROLLER (2026-09-18, the media ring).
       Rob, from the app: "I'm trying to swipe through the circles to see if I want to open one but it
       keeps auto collapsing." The web has no idle fold (that machinery was cut 2026-08-11) and the
       browser axis-locks the pan, so the page never scrolled -- but THIS pull did read the thumb: a
       horizontal browse of the ring starts at scrollY 0 on an element ptrForeignOrigin() does not
       exclude (it is a horizontal scroller, overflow-y hidden), so ptrPulling armed and every wobble of
       the thumb below its start line grew the strip by half the drift and pushed the ring and the tab
       row down under the finger, then snapped back on release. Measured with real CDP touch at 390
       (scratchpad ringpan/): a 200 px pan with 10 px of drift moved the row 4-5 px; 40 px of drift moved
       it 22 px, on every tab, both themes.
       The rule the carousel and the tab pager already follow: a gesture born on a strip is decided by
       DIRECTION, once, at PTR_DECIDE_PX of travel. Horizontal-dominant (|dx| >= |dy|) = a browse: the
       pull disowns the gesture for its whole life and the strip never moves. Vertical-dominant = a pull,
       exactly as before, so a genuine pull-down that happens to start on a circle still refreshes. A
       touch born anywhere else was decided from its first move until 2026-09-29; now EVERY touch is decided
       this way (THE PULL AT THE TOP IS OURS, below: a sideways tab swipe must never pull either). Not
       touch-action:pan-x on the strip: that would also take the genuine vertical scroll away from a
       finger that lands on a circle, and the browser's own axis lock already keeps the page still. */
    var PTR_DECIDE_PX = 8;   // the carousel pager's slop: past a tremor, well under one flick
    /* THE RING IS HORIZONTAL ONLY (2026-10-08, Rob on iPhone: "The media ring should only scroll horizontally (when swiping
       on the phone it's bouncing around vertically also)"). The track is touch-action:pan-x (the ring IIFE adds .mring-hx on
       touch devices), so the browser never pans the page from it, and a thumb's ARC no longer latches the page vertically.
       A touch born there is decided later and with a horizontal bias, the SAME rule the ring IIFE uses to hand a clearly
       vertical swipe to the page: RING_DECIDE_PX of travel, vertical only when |dy| > RING_AXIS * |dx| (within ~27 deg of
       vertical). Measured before (Chromium, real CDP touch, 390): a swipe whose first 10 px went down 10 / sideways 4 armed
       this pull and drew the list down 9 px for ~60 frames at scrollY 0, and at scrollY 40 scrolled the page 12 px with
       the ring not moving at all. */
    var RING_DECIDE_PX = 12, RING_AXIS = 2;
    function ptrRingOrigin(t) { return !!(t && t.closest && t.closest('.mring-track.mring-hx')); }
    /* ==== THE PULL AT THE TOP IS OURS, IN TWO STAGES (2026-09-29, Rob on iPhone Safari: "I don't really get to
       pull down to see the media ring because it's thinking I'm trying to pull down to refresh Safari the whole
       page") ============================================================================================
       1. THE BROWSER'S OWN PULL IS OFF ON THIS PAGE. html.pull-own (added right here, so only where this
          gesture exists -- the feed, on a touch device; every other page keeps the browser's own refresh, and
          so does a feed whose script never ran) puts overscroll-behavior-y:none on the root (rova.css "THE PULL
          AT THE TOP IS OURS"): no native pull-to-refresh and no top bounce. Chrome/Android honours it; so does
          iOS/iPadOS Safari from 16.0 (Apple's WebKit shipped the property in Safari 16). The notes in rova.css
          and guardPanelScroll saying overscroll-behavior "does not exist in WebKit" were measured on
          Playwright's WINDOWS WebKit build, which still compiles it out (CSS.supports false on 26.5, this box).
          BELT for iOS < 16 and any engine without it: once a touch is decided as OUR pull (vertical, downward,
          at the top) its touchmoves are preventDefault'ed while they are still cancelable -- a touch whose
          moves were cancelled before its pan began starts neither the bounce nor the native refresh. Never
          before the decision: a 2 px downward tremor that then scrolls the feed must stay a scroll.
       2. [RETIRED 2026-10-04 -- the ring never folds now (Rob: "Let's not auto collapse the media ring anymore"),
          so there is no 'ring' stage: every pull at the top is the refresh. The paragraph is kept for the record.]
          WHAT A PULL DOES DEPENDS ON THE RING, DECIDED ONCE PER GESTURE (at arm time):
          - ring FOLDED (the 5 s fold tucked it): the pull UN-FOLDS it. The ring slides out from under the
            chrome following the finger (RING_FOLLOW of the travel, rubber past its own height) and a release
            past a third of its height (~56 px of finger) keeps it; less slides it back. NO refresh, however
            far the finger goes: one pull, one action -- release and pull again to refresh. (Not both in one
            long pull: a refresh REPLACES the rows [[feed-rows-never-replaced]], and reaching for the ring is a
            look; a look must never cost the member the list they were reading.)
          - ring SHOWING (or no ring on the page): the pull is the refresh, as before -- ready at PTR_READY
            (56 px of stage travel = 112 px of finger, the old threshold), rubber past it; a release past it
            = the floating spinner + the partial read (unchanged); less = nothing.
       3. TRANSFORM ONLY. Nothing is laid out per frame: the stage (every #feed-wrap child after #ptr, or from
          the ring down) moves by the individual `translate` property (it composes with any transform someone
          else owns), the spinner rides the gap, and a release glides back via the Web Animations API (the
          cleanup lands on the animation's finish, never on a timer). The ring's un-fold costs ONE layout, at
          its first frame: the ring takes its open height inline (transitions off) and the stage is
          translated up by exactly that height, so nothing visibly moves; from there it is translate plus a
          clip-path that stops the ring painting above its own slot. Reduced motion: the finger is still
          followed (direct manipulation), releases land at once.
       4. ONLY A FINGER THAT IS DOWN AND PULLING. A fling that coasts to the top un-folds nothing and refreshes
          nothing (no touch events during momentum; the fold's own touch un-fold now stands down for this
          gesture, see window.__rovaPullOwn there). A finger that scrolled the page up to the top and KEEPS
          pulling becomes a pull the moment the page reaches 0 (the late latch). Desktop: no refresh by
          wheel; wheel-up at the top still un-folds the ring through the fold's ringGesture/settle.
       OWNERSHIP (unchanged rules, now for every touch): overlays (overlayOpen), a pinned body, a focused
       field (the keyboard's landing owns the page then), a touch born in an inner scroller or comment surface
       (ptrForeignOrigin) or inside a position:fixed sheet, and a sideways-dominant first PTR_DECIDE_PX (the
       tab swipe, the ring/carousel browse) are never a pull. Receipt: window.__rovaPull(). */
    var pullRoot = document.documentElement;
    pullRoot.classList.add('pull-own');
    window.__rovaPullOwn = true;
    var pullSup = false;
    try { pullSup = !!(window.CSS && CSS.supports && CSS.supports('overscroll-behavior-y', 'none')); } catch (e) {}
    var pullCalm = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    var PTR_READY = 60, PULL_EASE = 'cubic-bezier(.2,.8,.2,1)', PULL_BACK_MS = 320;
    /* ==== THE SPINNER LIVES IN THE GAP (2026-09-30, Rob: "I don't like how the pull to refresh loading circle overlaps
       the content on the web. Not like the app; the app pull to refresh thingy stays as it should be and doesn't
       overlap the header or anything.") SUPERSEDES the 2026-09-25 snap-back + floating disc (.ptr-float), which spun
       over whatever sat 6 px under the header (measured: over the membership notice / ring, 113 of 238 frames).
       Now the native refresh control's shape (UIRefreshControl; the app's iOS pull disc, gold C.gold arc):
       - THE STAGE IS THE LIST ONLY: #feed-posts and what follows it. The header, the chrome, the ring and the tabs
         never move and are never covered; the posts slide down (the `translate` property, iOS rubber band
         (1 - 1/(x*0.55/dim + 1)) * dim, dim = the viewport height) and the spinner is revealed in the gap between the
         tabs and the first post (.ptr-gap, a zero-height sibling inserted before #feed-posts: no layout, no shift).
         It is always fitted INSIDE the gap: centred on it, scaled to at most gap-6 px, fading/scaling in with the
         pull's progress, turning with the finger, spinning from the threshold (PTR_READY 60 = ~120 px of finger).
       - RELEASE PAST THE THRESHOLD: the list settles to a HELD gap (PTR_HOLD 60) with the spinner spinning while the
         read runs; when it lands (ptrIdle -- the rows replaced, as before) or fails (ptrFail), the gap closes in
         GAP_CLOSE_MS 250 ease and the list is back at 0 -- a transform, so no layout shift and scroll stays 0.
         Short of it: springs back, no read. A pull while a refresh is held starts from the held gap and returns to
         it (the read in flight answers it; no second read).
       - REDUCED MOTION: no follow, no rubber, no glides -- the gap is simply open at PTR_HOLD for the pull and the
         refresh, the spinner fades with progress, and it closes at once.
       - The ring's un-fold stage is untouched (a folded ring still only un-folds; a held refresh makes a pull 'ptr'). */
    var PTR_HOLD = 60, GAP_CLOSE_MS = 250, GAP_S = 24;
    var gap = document.createElement('div');
    gap.className = 'ptr-gap';
    gap.setAttribute('aria-hidden', 'true');
    var gapSpin = document.createElement('div');
    gapSpin.className = 'ptr-gap-spin';
    gap.appendChild(gapSpin);
    (function () {
      var fp = document.getElementById('feed-posts'), tb = document.getElementById('feed-tabs');
      if (fp && fp.parentNode) fp.parentNode.insertBefore(gap, fp);
      else if (tb && tb.parentNode) tb.parentNode.insertBefore(gap, tb.nextSibling);
      else ptr.parentNode.insertBefore(gap, ptr.nextSibling);
    })();
    var gapAt = 0, gapProg = 0;   // px the list is drawn down right now, and the reveal's progress (0..1)
    var gapHeld = 0;              // px it is HELD down while a refresh runs (0 = no refresh in flight)
    var gapStage = [];            // the elements carrying the translate
    var gapAnim = null;           // a hold/close glide in flight: { done }
    function gapGeom(d, prog) {   // the spinner fitted inside a gap of d px
      return { ty: d / 2 - GAP_S / 2, s: Math.max(0, Math.min(0.5 + 0.5 * prog, (d - 6) / GAP_S)), o: d < 8 ? 0 : Math.min(1, 0.15 + 0.85 * prog) };
    }
    function gapDraw(stage, d, prog, turn) {
      gapAt = d; gapProg = prog; gapStage = stage;
      gap.classList.add('on');
      var tr = d ? '0 ' + d.toFixed(2) + 'px' : '';
      for (var i = 0; i < stage.length; i++) stage[i].style.translate = tr;
      var g = gapGeom(d, prog);
      gapSpin.style.translate = '0 ' + g.ty.toFixed(2) + 'px';
      gapSpin.style.scale = g.s.toFixed(3);
      gapSpin.style.opacity = g.o.toFixed(3);
      if (turn != null) gapSpin.style.rotate = turn + 'deg';
    }
    function gapReset() {
      gapAt = 0; gapProg = 0; gapHeld = 0;
      for (var i = 0; i < gapStage.length; i++) gapStage[i].style.translate = '';
      gapStage = [];
      gap.classList.remove('on', 'ready', 'refreshing', 'ptr-gap-pull');
      gapSpin.style.translate = ''; gapSpin.style.scale = ''; gapSpin.style.opacity = ''; gapSpin.style.rotate = '';
    }
    function gapSettleNow() { if (gapAnim) { var a = gapAnim; gapAnim = null; a.done(); } }
    // glide the list from->to and the spinner g0->g1 (inline values are ALREADY the end state; no fill); `done` once
    function gapGlide(stage, from, to, g0, g1, done) {
      var anims = [], i, o = { duration: GAP_CLOSE_MS, easing: 'ease' };
      if (!(pullCalm && pullCalm.matches) && Math.abs(from - to) > 0.5) {
        for (i = 0; i < stage.length; i++) {
          if (!stage[i].animate) continue;
          try { anims.push(stage[i].animate([{ translate: '0 ' + from + 'px' }, { translate: '0 ' + to + 'px' }], o)); } catch (e) {}
        }
        if (gapSpin.animate) {
          try { anims.push(gapSpin.animate([{ translate: '0 ' + g0.ty + 'px', scale: String(g0.s) }, { translate: '0 ' + g1.ty + 'px', scale: String(g1.s) }], o)); } catch (e) {}
          // the fade runs ahead of the close, so a shrinking spinner is gone before the gap is too small for it
          try { anims.push(gapSpin.animate([{ opacity: g0.o }, { opacity: g1.o }], { duration: g1.o < g0.o ? GAP_CLOSE_MS * 0.6 : GAP_CLOSE_MS, easing: 'ease-out' })); } catch (e) {}
        }
      }
      var fired = false;
      function fin() {
        if (fired) return;
        fired = true;
        if (gapAnim && gapAnim.done === fin) gapAnim = null;
        done();
        for (var j = 0; j < anims.length; j++) { try { anims[j].cancel(); } catch (e) {} }
      }
      if (!anims.length) { fin(); return; }
      gapAnim = { done: fin };
      anims[0].onfinish = fin;
      anims[0].oncancel = fin;
    }
    function gapHold(stage) {                 // settle to the held gap, spinning, while the read runs
      gapSettleNow();
      var from = gapAt, g0 = gapGeom(from, gapProg);
      gapHeld = PTR_HOLD;
      gap.classList.add('ready', 'refreshing');
      gapDraw(stage, PTR_HOLD, 1, null);
      gapGlide(stage, from, PTR_HOLD, g0, gapGeom(PTR_HOLD, 1), function () {});
    }
    function gapClose() {                     // the gap closes; the list is back at 0
      gapHeld = 0;
      if (pull && pull.started && pull.mode === 'ptr') return;   // a finger is on it: its release decides (to 0 now)
      gapSettleNow();
      if (!gap.classList.contains('on')) return;
      var stage = stageFrom(gap.nextElementSibling), from = gapAt, g0 = gapGeom(from, gapProg);
      for (var i = 0; i < gapStage.length; i++) if (stage.indexOf(gapStage[i]) < 0) gapStage[i].style.translate = '';
      gapStage = stage;
      for (i = 0; i < stage.length; i++) stage[i].style.translate = '';
      gapSpin.style.opacity = '0';
      gapGlide(stage, from, 0, g0, { ty: -GAP_S / 2, s: 0, o: 0 }, gapReset);
    }
    var pull = null;        // the live gesture, armed at the top (pullArm)
    var pullTouch = null;   // the finger since touchstart, armed or not (the late latch reads it)
    var pullAnim = null;    // a release glide still in flight: { anims, done }
    var pullLog = [], pullN = { ring: 0, ringCommit: 0, ptr: 0, ptrCommit: 0, late: 0, prevented: 0 };
    function pullNote(o) { o.at = Date.now(); pullLog.push(o); if (pullLog.length > 20) pullLog.shift(); }
    function pullFixedOrigin(t) {
      for (var n = t; n && n.nodeType === 1 && n !== document.body; n = n.parentElement) {
        var pos = '';
        try { pos = getComputedStyle(n).position; } catch (err) {}
        if (pos === 'fixed') return true;
      }
      return false;
    }
    function pullBlocked(target) {
      if (overlayOpen()) return true;                                          // don't refresh out from under a flyout
      if (document.body.classList.contains('scroll-locked')) return true;     // body pinned under a sheet: scrollY reads 0
      var a = document.activeElement;
      if (a && a !== document.body && (a.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName || ''))) return true;
      return pullFixedOrigin(target);                                          // a fixed sheet is not the page
    }
    function stageFrom(first) {
      var out = [];
      for (var n = first; n; n = n.nextElementSibling) { if (!/^(SCRIPT|STYLE|TEMPLATE)$/.test(n.tagName)) out.push(n); }
      return out;
    }
    function rubber(x, dim) { return x <= 0 ? 0 : (x * dim * 0.55) / (dim + 0.55 * x); }
    function pullTravel(p) {                                   // finger travel -> stage travel, per mode
      var dy = Math.max(0, p.dy);
      var dim = Math.max(600, window.innerHeight || 0);            // the iOS scroll view's rubber band (THE SPINNER LIVES IN THE GAP)
      return dy <= 0 ? 0 : (1 - 1 / (dy * 0.55 / dim + 1)) * dim;
    }
    function pullSettleNow() { if (pullAnim) { var a = pullAnim; pullAnim = null; a.done(); } }
    function pullGlide(els, from, to, fill, extra) {
      var anims = [];
      if (pullCalm && pullCalm.matches) return anims;
      for (var i = 0; i < els.length; i++) {
        if (!els[i].animate) continue;
        try { anims.push(els[i].animate([{ translate: '0 ' + from + 'px' }, { translate: '0 ' + to + 'px' }], { duration: PULL_BACK_MS, easing: PULL_EASE, fill: fill })); } catch (e) {}
      }
      if (extra && extra.el && extra.el.animate) {
        try { anims.push(extra.el.animate(extra.frames, { duration: PULL_BACK_MS, easing: PULL_EASE, fill: fill })); } catch (e) {}
      }
      return anims;
    }
    // the glide's end: `done` exactly once, on the first animation's finish (or now, when nothing animates)
    function pullOnEnd(anims, done) {
      var fired = false;
      function fin() {
        if (fired) return;
        fired = true;
        if (pullAnim && pullAnim.done === fin) pullAnim = null;
        done();
        for (var i = 0; i < anims.length; i++) { try { anims[i].cancel(); } catch (e) {} }
      }
      if (!anims.length) { fin(); return; }
      pullAnim = { anims: anims, done: fin };
      anims[0].onfinish = fin;
      anims[0].oncancel = fin;
    }
    /* ONE STAGE (2026-10-04, Rob: "Let's not auto collapse the media ring anymore"): the ring never folds now, so the
       pull's 'ring' stage (un-fold the ring under the finger) is gone -- every pull at the top is the refresh. */
    function pullArm(t, late) {
      pull = { y0: t.clientY, x0: t.clientX, dy: 0, d: 0, decided: !!late, started: false, raf: 0, late: !!late,
               mode: 'ptr', prevented: false };
      if (late) pullN.late++;
    }
    function pullBegin(p) {                                    // the first frame of a decided pull
      pullSettleNow();                                         // a release glide still running lands now
      p.started = true;
      window.__rovaPullLive = true;
      gapSettleNow();                                          // a hold/close glide still running lands now
      p.stage = stageFrom(gap.nextElementSibling);             // the list only: header, chrome, ring and tabs stay put
      p.base = gapHeld;                                        // a pull during a held refresh starts from the held gap
      gap.classList.add('ptr-gap-pull');
    }
    function pullPaint() {
      var p = pull;
      if (!p) return;
      p.raf = 0;
      if (!p.started) pullBegin(p);
      var d = p.d;
      var calm = pullCalm && pullCalm.matches;
      p.show = calm ? PTR_HOLD : (p.base || 0) + d;            // reduced motion: a fixed gap, no follow, no rubber
      gapDraw(p.stage, p.show, p.base ? 1 : Math.min(1, d / PTR_READY), calm ? null : Math.round(d * 4));
      gap.classList.toggle('ready', !!p.base || d >= PTR_READY);
    }
    function pullEnd(cancelled) {
      var p = pull;
      pull = null;
      window.__rovaPullLive = false;
      if (!p) return;
      if (p.raf) { cancelAnimationFrame(p.raf); p.raf = 0; }
      if (!p.started) return;
      p.d = pullTravel(p);
      var i;
      var go = !cancelled && p.d >= PTR_READY && !gapHeld;   // a pull over a held refresh is answered by the read in flight
      pullN.ptr++; if (go) pullN.ptrCommit++;
      pullNote({ mode: 'ptr', d: Math.round(p.d), commit: go, late: p.late, prevented: p.prevented });
      gap.classList.remove('ptr-gap-pull');
      if (go) {
        /* THE HELD GAP (2026-09-30, THE SPINNER LIVES IN THE GAP; supersedes the 2026-09-25 snap-back + floating
           disc). The list settles to PTR_HOLD with the spinner spinning in the gap; ptrIdle / ptrFail close it. The
           failure line (ptrFail) is unchanged: that is a STATE the reader has to be told about. */
        ptr.classList.remove('ptr-down');
        ptrMsg.textContent = '';
        ptr.style.height = '0';
        gapHold(p.stage);
        ptrRetry.stop();                                   // a deliberate pull restarts the backoff at the top
        ptrAskedAt = Date.now();                           // the member asked: a read landing inside PTR_ASK_MS may replace
        ptrRetry.now();
        try { document.dispatchEvent(new CustomEvent('rova:pull')); } catch (e) {}   // the media ring re-reads on a pull too (2026-09-18)
      } else if (gapHeld) {
        gapHold(p.stage);                                  // back to the held gap: the refresh is still running
      } else {
        // An abandoned pull restores whatever was there before it -- the offline line does not get wiped by a
        // stray finger while the retries behind it are still running.
        ptr.style.height = ptrDown() ? (PTR_MSG_H + 'px') : '0';
        gapClose();                                        // spring back, no read
      }
    }
    window.addEventListener('touchstart', function (e) {
      if (pull) pullEnd(true);                                 // a second finger: whatever was pulling lets go
      var t = e.touches && e.touches[0];
      pullTouch = (t && e.touches.length === 1) ? { y: t.clientY, x: t.clientX, ly: t.clientY, target: e.target, foreign: ptrForeignOrigin(e.target), ring: ptrRingOrigin(e.target) } : null;
      if (!pullTouch || pullTouch.foreign) return;             // born inside an inner scroller: not ours
      if (window.scrollY <= 0 && !pullBlocked(e.target)) { pullArm(t, false); if (pull) pull.ring = pullTouch.ring; }
    }, { passive: true });
    window.addEventListener('touchmove', function (e) {
      var t = e.touches && e.touches[0];
      if (!t || e.touches.length !== 1) { if (pull) pullEnd(true); return; }
      if (!pull) {
        // THE LATE LATCH: the finger scrolled the page up to the top and is still pulling
        var pt = pullTouch;
        if (!pt || pt.foreign) return;
        var ly = pt.ly;
        pt.ly = t.clientY;
        if (window.scrollY > 0 || t.clientY - ly <= 0) return;
        if (t.clientY - pt.y < (pt.ring ? RING_DECIDE_PX : PTR_DECIDE_PX) || Math.abs(t.clientX - pt.x) * (pt.ring ? RING_AXIS : 1) > t.clientY - pt.y) return;
        if (pullBlocked(pt.target)) { pt.foreign = true; return; }
        pullArm(t, true);
        return;
      }
      var p = pull;
      p.dy = t.clientY - p.y0;
      if (!p.decided) {
        var ax = Math.abs(t.clientX - p.x0), ay = Math.abs(p.dy);
        if (Math.max(ax, ay) < (p.ring ? RING_DECIDE_PX : PTR_DECIDE_PX)) return;   // undecided: nothing moves yet
        p.decided = true;
        if ((p.ring ? ay <= ax * RING_AXIS : ax >= ay) || p.dy < 0) {   // a browse / a scroll away: disowned for this gesture
          pull = null;
          if (pullTouch) pullTouch.foreign = true;             // ...and no late latch for it either
          return;
        }
      }
      if (window.scrollY > 0) { pullEnd(true); return; }       // the page moved after all: it is a scroll
      if (p.dy > 0 && e.cancelable) { e.preventDefault(); if (!p.prevented) { p.prevented = true; pullN.prevented++; } }
      p.d = pullTravel(p);
      if (!p.raf) p.raf = requestAnimationFrame(pullPaint);
    }, { passive: false });
    window.addEventListener('touchend', function (e) {
      if (e.touches && e.touches.length) return;
      pullTouch = null;
      if (pull) pullEnd(false);
    }, { passive: true });
    window.addEventListener('touchcancel', function () { pullTouch = null; if (pull) pullEnd(true); }, { passive: true });
    window.__rovaPull = function () {   // receipt for the rigs
      var cs = '';
      try { cs = getComputedStyle(pullRoot).overscrollBehaviorY || ''; } catch (e) {}
      return { own: pullRoot.classList.contains('pull-own'), sup: pullSup, rootOverscrollY: cs,
               live: pull ? { mode: pull.mode, d: Math.round(pull.d), started: pull.started, late: pull.late, prevented: pull.prevented } : null,
               gliding: !!pullAnim, n: JSON.parse(JSON.stringify(pullN)), log: pullLog.slice(),
               gap: { at: Math.round(gapAt * 10) / 10, held: gapHeld, gliding: !!gapAnim, cls: gap.className } };
    };
    // The OS says the link is back: ask now instead of sitting out a 60s step. Only while we are
    // actually stuck -- `online` fires on every re-association and must not become a refresh trigger.
    onReconnect(function () { if (ptrDown()) ptrRetry.now(); });
  }

  /* ---- sliding gold tab indicator (+ the phone icon->label morph) ---------
     Port of the native FeedScreen tab row: ONE gold bar per row that measures the
     active tab and GLIDES to it, replacing the .tab.on::after that snapped. On the
     feed row at <=640px it also feeds the icon->word morph its --tw (see rova.css
     "MORPH MODE"); everything about the crossfade itself is CSS.
     Deliberately NOT part of setupTabPager: a logged-out feed row has tabs that
     aren't .js-tab at all (Following/New are /signup links) and the pager bails out
     on rows it can't page, but the indicator has to be right on every row. It also
     never touches .on itself — it OBSERVES it, so the click path, the swipe-commit
     path, popstate and the "Default feed tab" control all drive it for free.
     Native carries two bugs we do not: its slider only renders once all FIVE tab
     layouts are measured (so guests never saw it), and its filled-icon variant is
     dead code. */
  function setupTabSlider(row) {
    if (!row || row._rovaSlider) return;
    var bar = document.createElement('span');
    bar.className = 'tab-slider';
    bar.setAttribute('aria-hidden', 'true');
    row.appendChild(bar);
    row.classList.add('has-slider');   // retires the snapping .tab.on::after

    // Morph mode is FEED ONLY + PHONES ONLY. The profile row is text at every width,
    // so it only ever gets the bar.
    var isFeed  = row.id === 'feed-tabs';
    var mqMorph = window.matchMedia ? window.matchMedia('(max-width:640px)') : null;
    var mqCalm  = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    function morphing() { return isFeed && !!(mqMorph && mqMorph.matches); }

    // Cached geometry. Written ONLY by measure(), which runs on the events wired at
    // the bottom of this function -- never per scroll frame, never in a rAF loop.
    // GLYPH is the icon slot every collapsed feed cell is built around (rova.css
    // MORPH MODE keeps the cell's padding at (cell - GLYPH)/2 a side).
    var GLYPH = 19, CELL_MAX = 37, CELL_MIN = 31;
    var tabs = [], natural = [], base = 0, gap = 0;
    var dragging = false, dragTo = null, dragFrom = null, dragToEl = null, baseW = 1;
    var settleT = 0, pending = 0, handoffT = 0;
    /* flipping = the strip is mid-FLIP (the "Default feed tab" control hoists the chosen tab
       to the front and slides every tab to its new slot). While it is set, EVERY measuring
       path is held off, because a FLIP puts a transform on each tab and from that instant
       getBoundingClientRect reports where a tab is DRAWN, not where it lives. The bar is
       parked once up front, on the settled row, by reorder(). */
    var flipping = false;

    // the row's own children, minus everything that isn't a tab: .feed-tools,
    // .feed-settings, .tab-upload and the bar itself
    function readTabs() {
      tabs = Array.prototype.filter.call(row.children, function (el) {
        return el.classList && el.classList.contains('tab');
      });
    }
    // scan the cached row children, not a querySelector: the feed row's settings
    // panel hangs inside it and is full of its own .on toggles
    function activeTab() {
      for (var i = 0; i < tabs.length; i++) { if (tabs[i].classList.contains('on')) return tabs[i]; }
      return null;
    }

    function measure() {
      readTabs();
      var cs = getComputedStyle(row);
      gap = parseFloat(cs.columnGap || cs.gap) || 0;
      if (!morphing() || !tabs.length) { base = 0; row.style.removeProperty('--cell'); return; }
      var i;
      for (i = 0; i < tabs.length; i++) {
        var wEl = tabs[i].querySelector('.tab-word');
        // scrollWidth reports the CONTENT width even though the box is clamped to
        // max-width:0 + overflow:hidden -- the label can be measured without ever
        // being made visible. No mutation, no flicker, one read.
        natural[i] = wEl ? Math.ceil(wEl.scrollWidth) + 1 : 0;
      }
      // Everything in the row that ISN'T a tab (the Verified+Live+gear group, or the
      // profile row's Post button) plus the flex gaps: fixed costs the tabs share
      // what's left of.
      var inner = row.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0);
      var others = 0, n = 0;
      for (i = 0; i < row.children.length; i++) {
        var el = row.children[i];
        if (el === bar || el.classList.contains('feed-settings')) continue;   // out of flow
        n++;
        if (!el.classList.contains('tab')) { others += el.getBoundingClientRect().width; }
      }
      var fixed = others + gap * Math.max(0, n - 1) + 2;   // +2 = a hair of air so nothing ever touches
      /* CELL: a collapsed tab is `cell` wide; the selected one is cell + (label - GLYPH),
         because its padding is (cell - GLYPH)/2 a side and the label replaces the glyph
         slot. So the whole row costs  tabs*cell + (widest label - GLYPH) + fixed, and the
         biggest cell that still fits falls straight out of that. Sized off the WIDEST
         label so the pitch can't change with which tab is open. */
      var widest = 0;
      for (i = 0; i < tabs.length; i++) { if (natural[i] > widest) widest = natural[i]; }
      var cell = (inner - Math.max(0, widest - GLYPH) - fixed) / tabs.length;
      cell = Math.max(CELL_MIN, Math.min(CELL_MAX, Math.round(cell * 100) / 100));
      row.style.setProperty('--cell', cell + 'px');
      base = cell;
      // ...and if even CELL_MIN wasn't enough (a 320px phone), clamp the label itself to
      // whatever room is genuinely left. Native does the same with its label push.
      var room = Math.max(0, inner - tabs.length * cell - fixed) + GLYPH;
      for (i = 0; i < tabs.length; i++) {
        tabs[i].style.setProperty('--tw', Math.min(natural[i], room) + 'px');
      }
    }

    /* HOW LONG THE BAR IS. Two rules, because the two kinds of row are built
       differently -- and the first one is the whole reason the web bar read long
       (owner: "should be about 50% less longer to match the app").
       MORPH MODE: the app sizes its slider from tabLay[], captured by each cell's
         onLayout. That is the cell's PRE-TRANSFORM layout, and natively the label is
         position:'absolute' inside a fixed 22px glyph box while the push is a
         transform -- so tabLay[i].width is a CONSTANT 34 and the native bar is a
         constant 28, in every state, for every tab. It never grows with the label.
         Ours has to be the COLLAPSED cell for the same look: base - 6, whatever the
         label is doing. Left-anchored (+3) so it sits under the glyph slot, which is
         also where the word starts -- the label's transform-origin is left center.
       TEXT ROWS (desktop feed, profile at every width): no icon cell to borrow, so
         take half the tab. BAR_MIN stops a one-character tab -- the profile row's
         "@" -- collapsing to a stub, and it can never exceed the old full-inset
         width. */
    var BAR_HALF = 0.5, BAR_MIN = 24;
    function barW(tabW) {
      if (morphing() && base) return Math.max(0, base - 6);
      return Math.min(Math.max(BAR_MIN, tabW * BAR_HALF), Math.max(0, tabW - 6));
    }
    /* WHERE THE BAR STARTS -- one rule for every row and every width (owner: "the
       beginning of the gold bar should be parallel with the first letter of the word
       it's under"). The tab's CONTENT-BOX left edge is exactly where the word starts
       in every mode, and on the wordless tabs it is where the Grid glyph starts, so
       anchoring there lines the bar up with the first letter everywhere.
       Read per tab, never assumed: .tab is 15px, .tab-icon is 14px, and the phone
       block recomputes both off --cell ((cell - 19)/2, so ~7px at 390 and 9px at
       448+). This deliberately drops native's 3px lead -- the app parks its bar at
       tabLay.x + 3 while its label box starts at +6, so natively it sits slightly
       left of the letter. Match the letter, not the lead. */
    function padOf(el) { return parseFloat(getComputedStyle(el).paddingLeft) || 0; }
    // live geometry, in row coordinates (the bar's left:0 is the row's padding edge,
    // and .tabs has no left border, so getBoundingClientRect deltas line up 1:1)
    function liveGeom(el) {
      var rr = row.getBoundingClientRect(), tr = el.getBoundingClientRect();
      return { x: (tr.left - rr.left) + padOf(el), w: barW(tr.width) };
    }

    /* Where the bar belongs once `active` is the selected tab.
       Above 640 (and on the profile row) nothing reflows on a tab change, so the live
       geometry IS the answer. In morph mode it is NOT: the label grows over 170ms, so
       measuring at the instant .on flips reads the OLD row, and the bar would set off
       for a position the row is about to vacate. Compute the SETTLED row instead.
       Only the x needs computing: every tab BEFORE the active one is collapsed, so the
       run is a plain sum of `base + gap` off one anchor read (the tabs are the leading
       flex children -- .feed-tools/.tab-upload are pushed right by margin-left:auto).
       The WIDTH is the collapsed cell either way now, so the label's growth no longer
       enters this at all. */
    function target(active) {
      if (!morphing() || !base) { return liveGeom(active); }
      // anchor on where the FIRST tab actually is rather than on a cached padding-left:
      // watch mode re-pads the row without changing its content box, so a cached value
      // silently goes stale there (and the bar parks 23px left of the tab it belongs to)
      var x = tabs.length ? (tabs[0].getBoundingClientRect().left - row.getBoundingClientRect().left) : 0;
      for (var i = 0; i < tabs.length; i++) {
        // the accumulator steps whole CELLS (all `base` wide); the content-box inset
        // belongs to the active tab's returned x alone, not to the running sum
        if (tabs[i] === active) { return { x: x + padOf(tabs[i]), w: barW(base) }; }
        x += base + gap;   // only the OPEN cell is ever wider, and it is never behind itself
      }
      return liveGeom(active);
    }

    // animate:false = a GEOMETRY update (resize, the watch-mode fold, a font landing).
    // The bar has to track those EXACTLY, not lag .17s behind a row that is itself
    // moving -- and on the very first call it's what keeps the bar from sliding in
    // from x=0 under the server-rendered .on tab.
    function place(animate) {
      var on = activeTab();
      if (!on) { bar.style.width = '0px'; return; }
      if (animate && mqCalm && mqCalm.matches) { animate = false; }   // reduced motion: jump
      var g = target(on);
      clearTimeout(handoffT);
      if (!animate) {
        bar.style.transition = 'none';
        bar.style.width = g.w + 'px';
        bar.style.transform = 'translateX(' + g.x + 'px)';
      } else {
        /* TRANSFORM-ONLY glide: freeze the width where it is and carry the size change
           on scaleX. A width animation is layout work on the main thread, and a click
           swaps the whole posts panel a beat later -- measured on desktop, that swap
           ate most of the bar's frames and the glide arrived in two jumps. translateX +
           scaleX runs on the compositor and keeps presenting frames straight through it,
           the same reason the panel cross-dissolve uses opacity.
           Handed back to a real width once parked, on identical pixels. */
        var w0 = parseFloat(bar.style.width) || g.w || 1;
        bar.style.transition = '';
        bar.style.transform = 'translateX(' + g.x + 'px) scaleX(' + (g.w / w0) + ')';
        handoffT = setTimeout(function () { if (!dragging && !flipping) place(false); }, 230);
      }
      row.classList.add('slider-ready');
    }

    // .on is toggled on up to 5 tabs in one tick; coalesce to a single placement.
    // rAF (not a timer) so the bar sets off on the SAME frame the morph does.
    function soon() {
      if (pending || flipping) return;   // reorder() already parked the bar for the flight
      pending = requestAnimationFrame(function () {
        pending = 0;
        if (dragging || flipping) return;   // the finger owns the bar until settle()
        place(true);
      });
    }

    row._rovaSlider = {
      /* The swipe pager drives these: dragging the feed sideways pulls the bar toward
         the neighbour under your finger, like the app's slider riding the pager
         position. Transform-only -- translateX + scaleX off a FROZEN width -- so every
         drag frame is compositor work and nothing in this sticky row relayouts.
         `t` is |dx|/w, already clamped by the caller's edge checks. */
      drag: function (toEl, t) {
        if (!toEl || !activeTab()) return;
        if (!dragging || dragToEl !== toEl) {
          clearTimeout(settleT); clearTimeout(handoffT);
          dragFrom = liveGeom(activeTab());
          dragTo   = liveGeom(toEl);   // where it is NOW: the row hasn't reflowed yet
          dragToEl = toEl; dragging = true;
          baseW = dragFrom.w || 1;
          bar.style.transition = 'none';
          bar.style.width = baseW + 'px';   // frozen; scaleX carries the size from here
        }
        if (t < 0) { t = 0; } else if (t > 1) { t = 1; }
        var x = dragFrom.x + (dragTo.x - dragFrom.x) * t;
        var w = dragFrom.w + (dragTo.w - dragFrom.w) * t;
        bar.style.transform = 'translateX(' + x + 'px) scaleX(' + (w / baseW) + ')';
      },
      // toEl = the committed tab, or null for a snap-back. target() (not liveGeom)
      // because on a phone the row is reflowing under us for the next 170ms.
      settle: function (toEl) {
        if (!dragging) return;
        var g = toEl ? target(toEl) : dragFrom;
        var calm = !!(mqCalm && mqCalm.matches);
        bar.style.transition = calm ? 'none' : 'transform .24s cubic-bezier(.2,.7,.2,1)';
        bar.style.transform = 'translateX(' + g.x + 'px) scaleX(' + (g.w / baseW) + ')';
        clearTimeout(settleT);
        settleT = setTimeout(function () {
          dragging = false; dragToEl = null;
          // hand the scaleX drag back to the real width geometry on IDENTICAL pixels,
          // so the swap is invisible
          measure(); place(false);
        }, calm ? 0 : 270);
      },
      /* THE STRIP RE-ORDERED. The "Default feed tab" control moves the chosen tab to the
         front and FLIPs the rest into place; the bar has to end up under the right tab
         without ever measuring a transformed row.
         reorder() is called AFTER the DOM move and BEFORE the invert transforms go on, so
         the row it reads is the settled one -- it re-reads the tab list (order feeds the
         morph-mode cell sum in target()), parks the bar with one animated place(), and
         raises `flipping` so the MutationObserver/ResizeObserver paths stay quiet for the
         duration. reorderEnd() drops the flag once the transforms are off and re-parks on
         the real pixels. Deliberately the same measure()/place() every other path uses:
         a second copy of this geometry is exactly how the bar drifts. */
      reorder: function (animate) {
        if (dragging) return;
        if (pending) { cancelAnimationFrame(pending); pending = 0; }
        flipping = true;
        measure();
        place(animate);
      },
      reorderEnd: function () {
        flipping = false;
        if (dragging) return;
        measure(); place(false);   // clears place()'s own 230ms hand-off timer on the way in
      }
    };

    measure();
    place(false);   // first paint: already in position, no transition armed yet

    // .on changes: the click path, the swipe commit, popstate, and #fs-deftab (which
    // synthesizes a click) all land here. attributeFilter keeps the row's other
    // class-toggling children (the Verified orb, Live, the gear, the settings panel)
    // from costing anything.
    if (window.MutationObserver) {
      new MutationObserver(function (recs) {
        for (var i = 0; i < recs.length; i++) {
          var t = recs[i].target;
          if (t.classList && t.classList.contains('tab')) { soon(); return; }
        }
      }).observe(row, { subtree: true, attributes: true, attributeFilter: ['class'] });
    }

    /* Geometry changes. A ResizeObserver on the row is the robust answer because it
       catches all four cases at once: window resize, the 640px breakpoint crossing
       (which also changes the label font-size), and the watch-mode fold, where the row
       goes sticky + full-bleed and animates its margins/padding over .5s. RO callbacks
       run AFTER layout, so these reads aren't forced -- and they can't loop, because
       the only thing written is the bar, which isn't observed.
       BORDER-box, not the default content-box: the watch-mode fold trades margin for
       padding, so the row's CONTENT box comes out the same size and a content-box
       observation never fires at all. */
    if (window.ResizeObserver) {
      new ResizeObserver(function () { if (!dragging && !flipping) { measure(); place(false); } }).observe(row, { box: 'border-box' });
    } else {
      window.addEventListener('resize', function () { if (!dragging && !flipping) { measure(); place(false); } });
    }
    if (mqMorph && mqMorph.addEventListener) {
      mqMorph.addEventListener('change', function () { measure(); place(false); });
    }
    // a late webfont re-measures every label (and therefore the whole row)
    try { if (document.fonts && document.fonts.ready) { document.fonts.ready.then(function () { measure(); place(false); }); } } catch (e) {}
  }
  setupTabSlider(document.getElementById('profile-tabs'));
  setupTabSlider(document.getElementById('feed-tabs'));

  /* ---- swipeable tab pager (profile + feed): AJAX swap + finger-follow --- */
  function setupTabPager(tabsRow, grid) {
    if (!tabsRow || !grid) return;
    var pTabs = Array.prototype.slice.call(tabsRow.querySelectorAll('.js-tab'));
    if (!pTabs.length) return;
    var loading = false;

    /* pTabs is cached IN ORDER, and order is the whole meaning of "the neighbour under your
       finger" (the swipe pager) and of curIndex(). The "Default feed tab" control re-orders
       the strip in place, so it re-reads the list through here -- otherwise the next swipe
       would page to whichever tab USED to sit beside this one. */
    tabsRow._rovaPager = {
      resync: function () { pTabs = Array.prototype.slice.call(tabsRow.querySelectorAll('.js-tab')); },
      // A FILTER CHANGE (the Verified toggle) re-renders the tab on screen itself; every other tab's kept
      // rows were built under the old filter, so they are dropped and page one is fetched on the next visit.
      dropCache: function () { panelCache = {}; },
      cacheState: function () {   // receipt for the rigs
        var o = {}; for (var k in panelCache) { if (panelCache.hasOwnProperty(k)) { o[k] = { at: panelCache[k].at, bytes: panelCache[k].html.length, stubs: panelCache[k].stubs.length }; } }
        return o;
      }
    };

    /* ---- PANEL CACHE: A TAB'S ROWS ARE KEPT, NEVER RE-FETCHED ON RETURN (2026-09-29) ----------------
       Rob, from the iOS app (build 532): he swiped to Discover, a post he liked was on screen, and it
       DISAPPEARED -- the tab painted its cached rows, then the network page replaced them 0.7 s later.
       "Yes make the web do the same": THE RULE, on every feed/profile tab surface --
         a feed page that lands WITHOUT the member asking NEVER replaces the rows on screen. New rows
         arrive below (deduped by post id); fresh rows reach the TOP only through the idle roll (one card
         after the 5 s fold) or by REPLACING the list on an explicit refresh (pull-to-refresh, the grid's
         refresh orb, a reload) or a filter change (the Verified toggle).
       THE WEB'S VERSION OF THE BUG WAS WORSE THAN THE APP'S. This pager mounts ONE tab at a time and
       re-fetched PAGE ONE on EVERY switch (switchTab's grid.innerHTML = html, the swipe ghost's prime), so
       coming back to a tab never showed what the member had left: Discover's depth ladder advances on a
       page-one request, so the rows were a DIFFERENT page (and the ladder moved without a pull); the grid's
       idle cascade had turned its cells into other posts, and page one turned them back; a card tab that
       was 40 cards deep came back as 9 (the 2026-09-13 per-tab scroll note: "cannot be honoured").
       NOW: when a tab is LEFT, its panel is serialised (stash) -- the same outerHTML standard the card
       virtualiser (stubCard/restoreCard) has used in production since 2026-07-29, videos released first
       so the markup parses with zero media requests -- and when it is visited again that snapshot IS the
       tab's HTML: fetchTab() answers from it, so the click dissolve, the popstate path, the swipe ghost
       and the commit adoption all run exactly as they do for a fetched page, and landIncoming()'s post-id
       anchor lands the reader on the very card they left (deep card tabs included, now).
       NO REFETCH OF PAGE ONE ON RETURN, deliberately -- the brief's "drop it if the rows are already
       there". What a background page one could add is either already on screen (dedupe) or older/other
       than the rows on screen; on the chronological tabs it would land a NEWER post at the BOTTOM of a
       newest-first list, and on Discover it would spend a ladder rung the member did not pull for. New
       posts reach this tab through the idle roll, as they do on the app. THE CURSOR survives by
       construction: every pager on this surface reads its next page off the DOM (the LAST
       .feed-more-flag's data-tail / data-next, the grid's data-gc-off), and the snapshot carries it.
       COHERENCE -- a kept panel is not frozen in time for the things the member DID elsewhere:
         - a post removed anywhere (delete, grid-hide) or an author hidden (thumbs-down) since the stash is
           dropped from it (window.__rovaFeedGone, written by dissolve() and the hide handler);
         - the member's own reaction / comment / repost state: every card's .bar is recorded when its
           panel is left, and a newer .bar for the same post replaces the kept one (what /engage-live
           will not do -- it repaints counts, never the reader's own state; see fetchTab's header).
       Stubs stay stubs (their HTML rides beside the snapshot, not re-expanded into it), so a deep panel
       restores at the cost it had when it was left, not at the cost of every card it ever showed. */
    var panelCache = {};              // href -> { html, stubs[], at }
    var barSnap = {};                 // post view id -> { html: .bar outerHTML, at }
    var PANEL_MAX_BYTES = 6 * 1024 * 1024;   // a snapshot past this is not kept: that tab re-fetches (never seen in practice)
    var PCELL_KEEP = { 'pcell': 1, 'nsfw-cell': 1, 'text-heavy': 1, 'gal-cell': 1 };   // the server's own cell classes
    function stash(href) {
      if (!href) return;
      delete panelCache[href];
      if (!grid.firstChild) return;
      try {
        // videos first: retireVideo stashes each clip's URLs as ATTRIBUTES, then strips src -- the
        // virtualiser's exact order (stubCard), so the restored markup re-wires through wire() and
        // starts no download until a clip is on screen again
        if (window.__rovaReleaseVideos) { window.__rovaReleaseVideos(grid); }
        var now = Date.now(), i, n;
        // GRID CELLS carry client-side state the server never renders: the cascade's crossfade layer,
        // the governor's <video>, the hover bubble, Ken Burns / swap / loading classes, inline styles.
        // Their IDENTITY (href, data-*, the img's src) is what the member saw and is kept; the rest is
        // rebuilt by the same code that built it the first time.
        var cells = grid.querySelectorAll('.pcell');
        for (i = 0; i < cells.length; i++) {
          var c = cells[i];
          var junk = c.querySelectorAll('.gp-casc-ov, .pcell-eng, video');
          for (n = 0; n < junk.length; n++) { if (junk[n].parentNode) junk[n].parentNode.removeChild(junk[n]); }
          var keep = [], cl = c.classList;
          for (n = 0; n < cl.length; n++) { if (PCELL_KEEP[cl[n]]) keep.push(cl[n]); }
          c.className = keep.join(' ');
          c.removeAttribute('style');
          var ims = c.getElementsByTagName('img');
          for (n = 0; n < ims.length; n++) { ims[n].removeAttribute('style'); }
        }
        // CARDS: what canStub() refuses to fold is what must not be frozen -- an open comment panel or
        // edit box is live UI, not content, and the landing / menu states are transitions in flight.
        var live = grid.querySelectorAll('.comment-panel, .cpanel, .cedit-box');
        for (i = 0; i < live.length; i++) { if (live[i].parentNode) live[i].parentNode.removeChild(live[i]); }
        var cards = grid.querySelectorAll('.post');
        for (i = 0; i < cards.length; i++) {
          cards[i].classList.remove('stream-in', 'in', 'post-land', 'menu-open', 'pf-origin');
          var vid = cards[i].getAttribute('data-view');
          var bar = vid ? cards[i].querySelector('.bar') : null;
          if (bar) { barSnap[vid] = { html: bar.outerHTML, at: now }; }
        }
        var menus = grid.querySelectorAll('.pmenu-panel.show');
        for (i = 0; i < menus.length; i++) { menus[i].classList.remove('show'); }
        var parts = [], stubs = [];
        for (var el = grid.firstChild; el; el = el.nextSibling) {
          if (el.nodeType !== 1) continue;
          if (el.classList.contains('post-stub') && el._html) {
            parts.push('<div class="post-stub" style="height:' + (el.style.height || '0px') + '" data-sk="' + stubs.length + '"></div>');
            stubs.push(el._html);
            continue;
          }
          parts.push(el.outerHTML);
        }
        var html = parts.join('');
        if (html.length > PANEL_MAX_BYTES) return;
        panelCache[href] = { html: html, stubs: stubs, at: now };
      } catch (e) { delete panelCache[href]; }
    }
    // THE KEPT PANEL, BROUGHT UP TO DATE, in whichever element it was just parsed into (the live panel on
    // the click path, the ghost on the swipe path). Runs while that element is still invisible.
    function reconcile(root, href, html) {
      var ent = panelCache[href];
      if (!ent || ent.html !== html) return false;   // a fetched page, not a kept one: nothing to do
      try {
        var i, k, sk = root.querySelectorAll('.post-stub[data-sk]');
        for (i = 0; i < sk.length; i++) { sk[i]._html = ent.stubs[+sk[i].getAttribute('data-sk')] || ''; sk[i].removeAttribute('data-sk'); }
        var G = window.__rovaFeedGone || { v: {}, u: {} };
        var goneV = [], goneU = [];
        for (k in G.v) { if (G.v.hasOwnProperty(k) && G.v[k] > ent.at) goneV.push(k); }
        for (k in G.u) { if (G.u.hasOwnProperty(k) && G.u[k] > ent.at) goneU.push(k); }
        var drop = function (n) { if (n && n.parentNode && !(window.__rovaGasHole && n.classList && n.classList.contains('pcell') && window.__rovaGasHole(n))) n.parentNode.removeChild(n); };   // GRID AUTHOR SPACING: a home-grid hole may be filled in place
        goneV.forEach(function (v) {
          Array.prototype.forEach.call(root.querySelectorAll('.post[data-view="' + v + '"], .pcell[data-id="' + v + '"]'), drop);
          for (var s = 0; s < sk.length; s++) { if (sk[s]._html && sk[s]._html.indexOf('data-view="' + v + '"') >= 0) drop(sk[s]); }
        });
        goneU.forEach(function (u) {
          Array.prototype.forEach.call(root.querySelectorAll('.pcell[data-user="' + u + '"]'), drop);
          Array.prototype.forEach.call(root.querySelectorAll('.post'), function (p) { if (p.querySelector('.js-hide[data-user="' + u + '"]')) drop(p); });
          for (var s = 0; s < sk.length; s++) { if (sk[s]._html && sk[s]._html.indexOf('js-hide" type="button" data-user="' + u + '"') >= 0) drop(sk[s]); }
        });
        var cards = root.querySelectorAll('.post[data-view]');
        for (i = 0; i < cards.length; i++) {
          var snap = barSnap[cards[i].getAttribute('data-view')];
          if (!snap || snap.at <= ent.at) continue;
          var bar = cards[i].querySelector('.bar');
          if (!bar || bar.outerHTML === snap.html) continue;
          var tmp = document.createElement('div'); tmp.innerHTML = snap.html;
          if (tmp.firstElementChild) bar.parentNode.replaceChild(tmp.firstElementChild, bar);
        }
      } catch (e) {}
      return true;
    }
    function curHref() { var t = pTabs[curIndex()]; return t ? (t.getAttribute('href') || '') : ''; }

    function curIndex() {
      for (var i = 0; i < pTabs.length; i++) { if (pTabs[i].classList.contains('on')) return i; }
      return 0;
    }
    // Promote the grid to its own compositor layer + freeze the Ken Burns pans while a swipe/slide is live,
    // so the motion is composite-only and buttery. Depromote once it settles (a permanent will-change on a
    // tall scrolling list wastes memory).
    function paging(on) { grid.classList.toggle('tab-paging', on); }

    /* Prefetch a tab's HTML the instant a horizontal swipe is committed to, so the swap has NO network
       gap (the old path fetched only after the finger lifted -- that stall is what read as choppy/laggy).
       Cached by href, for the DURATION OF ONE GESTURE and no longer.

       THAT LIFETIME IS THE WHOLE POINT, and it used to be a lie. The comment here read "a fresh swipe
       re-primes it so content is at most a few hundred ms old" -- true of a swipe that COMMITS (both
       commit paths delete the entry after using it), and false of one that does not. makeGhost() primes
       the neighbour as soon as the finger crosses the 8px decision threshold; a drag that stops short of
       the 22%-of-width commit snaps back through killGhost(), which dropped the ghost ELEMENT and left
       the promise sitting in this map with nothing to expire it. Every later read of that tab -- a tap,
       a fresh drag toward it -- was then answered from HTML fetched at the moment of an abandoned
       gesture, with no request going out at all.

       That is the owner's "I liked a post then switched tabs and it doesn't show my like" (2026-08-05):
       like on tab A, tap tab B, and B is painted from bytes older than the like. The card lands in an
       incoherent state rather than a merely stale one -- /engage-live repaints the COUNT (it is
       deliberately allowed to move other people's numbers) but never the reader's own reaction, so the
       heart reads empty above a count of 1.

       TWO GUARDS, structural first:
         1. killGhost() now drops the entry it primed (see below). An entry therefore lives exactly as
            long as the ghost that has a use for it, and a gesture that is abandoned or re-aimed at the
            other neighbour leaves nothing behind.
         2. A bounded age, as a backstop only -- the same shape as ENG_HOLD_MAX_MS above, and for the
            same reason: a cache that can silently outlive its purpose is worse than one that refetches.
            30s is far longer than any prime->commit window (the commit fires 260ms after touchend) so
            it never fights a slow network, and far shorter than the minutes an orphan used to survive.
       Deliberately NOT an engagement-event invalidation: a like is only one of the viewer-dependent
       things in a feed partial (saved, reposted, follow state, counts, new and deleted posts all move
       too), and bounding the snapshot's life covers every one of them at once. */
    var PREFETCH_MAX_MS = 30000;
    var prefetch = {};
    function fetchTab(tab) {
      var href = tab.getAttribute('href');
      // A TAB THE MEMBER HAS ALREADY SEEN IN THIS PAGE VIEW ANSWERS FROM ITS KEPT ROWS (PANEL CACHE,
      // below) -- no request, no page one. The caller's reconcile() recognises the string and brings it
      // up to date before it is shown.
      if (panelCache[href]) return Promise.resolve(panelCache[href].html);
      var hit = prefetch[href];
      if (hit && Date.now() - hit.at > PREFETCH_MAX_MS) { delete prefetch[href]; hit = null; }   // self-heal
      if (hit) return hit.p;
      var url = href + (href.indexOf('?') >= 0 ? '&' : '?') + 'partial=posts';
      // rfetch: a 5xx used to come back as HTML and get written straight into grid.innerHTML by switchTab
      // -- the reader watched their feed turn into a Cloudflare error page. Rejecting instead sends it to
      // switchTab's existing .catch, which falls back to a real navigation.
      // 15s here, not the 8s the other reads use, precisely BECAUSE that fallback is a whole page load:
      // aborting a slow-but-working tab swap would cost far more than waiting for it. A tab partial is
      // 83KB / ~15KB on the wire and lands in ~1.1s on congested LTE, ~1.4s on slow 3G -- 15s is ~10x
      // that, and still an order of magnitude better than the 60-120s the platform would otherwise take
      // to give up on a dead socket, during which the whole tab row does nothing at all.
      var p = rfetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', cache: 'no-store' }, 15000)
        .then(function (r) { return r.text(); });
      p.catch(function () { delete prefetch[href]; });   // a failed prime can retry
      prefetch[href] = { p: p, at: Date.now() };
      return p;
    }

    /* ---- PER-TAB SCROLL MEMORY (2026-09-13) --------------------------------------------------
       Rob: "the tabs on the Web app are not independent of each other -- if I scroll down on the
       grid and then move to NEW it still keeps the scroll position across all tabs."

       He is right about the mechanism and right that it costs something. The pager swaps ONE
       panel's innerHTML, so only one tab is ever mounted -- but the WINDOW offset was never saved
       or reset, and the line below used to say so out loud ("deliberately no scrollTo, keep the
       reader's position"). MEASURED on this box (390pt, iPhone UA, CPU x4, member fixture,
       C:\tools\pw\tab-scroll-lab.js / tab-scroll-why.js), Grid at y=6077 of a 7054px document ->
       New, whose fresh panel is 2030px:
         - the engine CLAMPS the offset to the new document: y 6077 -> 1186, i.e. the reader lands
           at the BOTTOM of a tab they have never seen;
         - that is inside the pager's auto-load lead, so a 30-card page is fetched, parsed and
           hydrated that nobody asked for (+1158ms);
         - in CHROMIUM the document then grows past the old offset and the engine RE-APPLIES it
           (y 1186 -> 6301), which lands in the lead band again and fetches a SECOND page (+2914ms);
           WEBKIT -- the owner's iPhone -- does not re-apply, so he simply stays at the bottom.
       Cost of that, same build, same rig, switching from a deep scroll vs from the top:
         long-task ms per switch 2462-3711 vs 357-1182, worst frame 1116-2466ms vs 166-683ms,
         load-more pages 1-2 vs 0. So it is a UX bug whose SYMPTOM is a performance bug.

       WHAT IS REMEMBERED, and why it is not a pixel offset alone. The panel is re-fetched on every
       switch, so the incoming tab is page one again -- a remembered y is a promise the content
       cannot always keep. The anchor is therefore the POST ID at the top edge plus how far into it
       the reader was, exactly the standard feedScrollMemory already uses for a Back (restoring a
       raw offset into ranked, re-fetched content lands on a different card). The pixel offset is
       kept only as the fallback for a panel with no ids.

       IN MEMORY, DELIBERATELY NOT sessionStorage: a reload re-renders page one, so a persisted
       offset would be restored into content that no longer extends that far -- and the back/forward
       case is already covered, by content, by feedScrollMemory. A reload starting at the top is
       what a reader expects; a tab they left five minutes ago in the same page view is not. */
    var tabMem = {};                  // href -> { id, d, off }, this page view only
    function scrollLocked() { return document.body.classList.contains('scroll-locked'); }
    function panelTopDoc() { return (grid.getBoundingClientRect().top + (window.scrollY || 0)); }
    /* The first card still touching the top edge -- the same rule recycleTick and feedScrollMemory
       anchor on. BINARY, not a walk: a deep grid holds 150+ cells and this runs on every switch,
       so a linear scan would be 150 forced rects for one answer. Card tops are non-decreasing in
       document order (a grid row's cells share a bottom), which is all a bisect needs. */
    function firstVisibleCard() {
      var cards = grid.querySelectorAll('.post[data-id], .pcell[data-id]');
      var n = cards.length; if (!n) return null;
      var lo = 0, hi = n - 1, hit = -1;
      while (lo <= hi) {
        var mid = (lo + hi) >> 1;
        if (cards[mid].getBoundingClientRect().bottom > 0) { hit = mid; hi = mid - 1; } else { lo = mid + 1; }
      }
      if (hit < 0) return null;
      var r = cards[hit].getBoundingClientRect();
      return { id: cards[hit].getAttribute('data-id'), d: Math.round(r.top) };
    }
    // Save where the OUTGOING tab was. Called before anything moves, on every commit path.
    function rememberTab() {
      var t = pTabs[curIndex()]; if (!t) return;
      var href = t.getAttribute('href'); if (!href) return;
      // the viewer pins <body> at position:fixed while it is open, so window.scrollY reads 0 --
      // saving then would record a position the reader was never at. Keep the last honest one.
      if (scrollLocked()) return;
      var y = Math.round(window.scrollY || 0);
      var off = Math.max(0, Math.round(y - panelTopDoc()));
      // above the panel's top: no card to anchor on, but Back/Forward still owes the reader this exact y
      if (off <= 0) { tabMem[href] = { off: 0, id: null, d: 0, y: y }; return; }
      var a = firstVisibleCard();
      tabMem[href] = { off: off, id: a ? a.id : null, d: a ? a.d : 0, y: y };
    }

    /* ---- KEEP THE READER'S SCROLL ACROSS A TAB SWITCH (2026-10-11) -----------------------------
       Rob: "Changing tabs shouldn't scroll me back to the top of the screen; it should keep my same
       scroll" (/@kingrobgreen?tab=videos, iPhone Safari + desktop). MEASURED before this (scratchpad
       tabscroll/keep-rig.js, guest profile, Chromium AND WebKit at 390, identical): the bar mid-screen
       at y=358 -> tap All -> y=0; the bar just under the header at y=611 -> Grid -> y=0; deep in All
       (y=2238) and swipe -> y=0 (the swipe's half-screen cap on a short incoming tab). The cause was
       landIncoming(): a tab with no remembered place was sent to the TOP of the page -- the 2026-09-13
       answer to "the grid's deep offset was clamped into the bottom of New", which over-corrected.
       THE RULE NOW -- the Instagram/TikTok profile, and the app's alignForHeader:
         - the PIN is the scroll at which the tab row sits right under the pinned chrome (the sticky
           header; on the feed, the docked sticky tab row) with the panel's top straight below it;
         - above the pin (the profile header, or part of it, still on screen): the reader's scrollY is
           kept EXACTLY -- the tab row does not move, the new tab starts right under it;
         - past the pin (deep in the old tab): land AT the pin -- the new tab from its top, the row in
           its pinned place; never deep inside content the reader has never seen. A tab with a place of
           its own past the pin (its kept panel, PANEL CACHE) goes back to that place;
         - Back/Forward restores each tab's own scroll exactly (tabMem keeps y too now).
       A SHORTER incoming panel would make the engine clamp the offset (and the tab row would jump DOWN):
       holdFloor() props the panel with a min-height so the document is always tall enough for the
       landing; it is re-decided on every switch. */
    function chromeBottom() {
      var tb = document.querySelector('.topbar');
      if (!tb) return 0;
      var r = tb.getBoundingClientRect();
      return r.bottom > 0 ? r.bottom : 0;   // hidden / translated away: nothing pinned over the page
    }
    var gapMemo = -1;
    // Reads only. `k` = where the panel's top sits on screen at the pin; `pin` = that scroll, in doc px.
    function pinGeom() {
      var tr = tabsRow.getBoundingClientRect(), gr = grid.getBoundingClientRect();
      var cs = getComputedStyle(tabsRow), dock, gap;
      if (cs.position === 'sticky') {
        // the row docks at its own `top`; while it is still in flow the row->panel gap is measurable
        dock = parseFloat(cs.top); if (!(dock >= 0)) dock = chromeBottom();
        if (tr.top > dock + 1) gapMemo = gr.top - tr.bottom;
        gap = gapMemo >= 0 ? gapMemo : (parseFloat(cs.marginBottom) || 0);
      } else {
        dock = chromeBottom();
        gap = gr.top - tr.bottom;
      }
      var y = window.scrollY || 0, k = dock + tr.height + Math.max(0, gap);
      return { y: Math.round(y), k: k, pin: Math.max(0, Math.round(gr.top + y - k)) };
    }
    // Make the document tall enough that scrolling to `target` is not clamped. Run after the swap.
    function holdFloor(target) {
      grid.style.minHeight = '';
      var vh = window.innerHeight || 800;
      var deficit = Math.ceil(target + vh - (document.documentElement.scrollHeight || 0));
      if (deficit > 0) grid.style.minHeight = (grid.offsetHeight + deficit) + 'px';
    }
    /* Where the INCOMING tab should land, in document coordinates. Returns the anchor element to
       re-pin against one frame later (media above it can still settle), or null.
       Callers must run this AFTER the panel is mounted and its carousels pre-settled, and BEFORE
       the reveal -- restoring against a half-built panel is the classic restore-too-early bug. */
    function landIncoming(href, kept, g, restore) {
      var m = tabMem[href];
      var vh = window.innerHeight || 800;
      grid.style.minHeight = '';   // the last tab's floor is not this one's
      /* KEEP THE SCROLL (2026-10-11, see pinGeom). `g` was read BEFORE the swap, so its y is the reader's,
         not an engine clamp. Back/Forward (`restore`) returns to the tab's own place; a tap/swipe keeps
         the reader's y above the pin, lands at the pin past it, and only a tab with its own place past
         the pin goes back there. */
      if (g) {
        var deepM = !!(m && m.off > 0);
        if (restore && m && !deepM) { holdFloor(m.y); try { window.scrollTo(0, m.y); } catch (e) { } return null; }
        if (!deepM || (!restore && g.y < g.pin)) {
          var keepY = Math.min(g.y, g.pin);
          holdFloor(keepY);
          try { window.scrollTo(0, keepY); } catch (e) { }   // unconditional: discards the engine's pending offset
          return null;
        }
      }
      var max = Math.max(0, (document.documentElement.scrollHeight || 0) - vh);
      var target = 0, el = null;
      if (m) {
        el = m.id ? grid.querySelector('.post[data-id="' + m.id + '"], .pcell[data-id="' + m.id + '"]') : null;
        if (el) {
          target = (el.getBoundingClientRect().top + (window.scrollY || 0)) - m.d;
        } else {
          /* The card is gone -- this tab was rebuilt shorter than where the reader was (a deep grid
             comes back as page one). Landing at the clamped bottom is both meaningless and the
             expensive case above: it begs a load-more the reader never asked for. Start at the top,
             which is honest, unless the remembered offset still has half a screen of content under
             it, in which case it is a real place to be. */
          var t = panelTopDoc() + m.off;
          target = (t <= max - vh * 0.5) ? t : 0;
        }
      }
      /* NEVER LAND IN THE LAST HALF SCREEN of the rebuilt panel, on EITHER path. Found on desktop
         (1280, CPU x1) with the anchor path unguarded: New was left at y=1488 of a 6276px document
         and came back as page one (9 cards, max 1488), the anchor was still in it and sat at the
         very end, so the landing was the document's own bottom -- and from there the feed fetched
         two pages nobody asked for and the reader finished at y=12988 of 13016. The bottom is where
         the auto-loader's 2-screen lead lives; a restore is not allowed to stand on it. */
      var ceil = max - vh * 0.5, capped = false;
      /* ...EXCEPT ON A KEPT PANEL (PANEL CACHE, 2026-09-29). The cap exists because a re-fetched page one is
         SHORTER than what the reader left, so "their place" used to be the new document's bottom -- a place
         they had never been. A kept panel is the very document they left: if the anchor sits in its last
         half screen, that IS where they were, and moving them up half a screen would change the rows on
         screen (the one thing this pass forbids). The auto-loader appends below them, as it would have. */
      if (target > ceil && !(kept && el)) { target = ceil > 0 ? Math.round(ceil) : 0; capped = true; }
      // a tap with the row pinned never lands ABOVE the pin: that would pull the profile header back down
      if (g && !restore && target < g.pin) { target = g.pin; capped = true; holdFloor(target); max = Math.max(max, target); }
      target = Math.max(0, Math.min(Math.round(target), max));
      /* ALWAYS write the offset, even when it already reads as the target, and this is the subtle
         half of the same bug. When the incoming panel is SHORTER the engine clamps the outgoing
         offset itself -- and it keeps the original as a PENDING desired offset, which it re-applies
         the moment the document grows again (Chromium; measured 1186 -> 6301 on a load-more).
         An explicit programmatic scroll is what discards that pending value. Skipping the call
         because "we are already there" leaves it live, which is how the desktop run above ended up
         walking to the bottom in three steps. */
      try { window.scrollTo(0, target); } catch (e) { }
      // a capped landing is no longer AT the anchor, so re-pinning to it would undo the cap
      return (el && !capped) ? { el: el, d: m.d } : null;
    }
    // ONE correction, chained to the next frame (not a timer): anything above the anchor that was
    // still settling has settled by now. Bounded on purpose -- a re-pin loop fights the reader.
    function repin(pin) {
      if (!pin || !pin.el || !pin.el.isConnected) return;
      var dd = pin.el.getBoundingClientRect().top - pin.d;
      if (Math.abs(dd) > 2) { try { window.scrollBy(0, dd); } catch (e) { } }
    }

    // dir: 0 = instant (click), 1 = slide in from right, -1 = from left
    // noHist: a back/forward-driven switch — the history entry ALREADY moved
    function switchTab(tab, dir, noHist) {
      /* AT REST THE PANEL CARRIES NO TRANSFORM (2026-10-02, Rob: the open comment sheet on a profile's last post
         drew UNDER the site footer). Any transform -- translateX(0) included -- makes the panel a stacking context,
         and a stacking context with z-index auto is painted in tree order: everything after the panel (the
         load-more row, footer.site) then paints over anything inside it, whatever its z-index. That is what
         trapped the comment sheet's lifted card (z 15, sheet z 41) under the footer. So "home" is '' (the same
         place, and a transition from translateX(x) to none still animates), never a leftover translateX(0). */
      if (loading || !tab || tab.classList.contains('on')) { grid.style.transition = 'transform .22s ease'; grid.style.transform = loading ? 'translateX(0)' : ''; paging(false); return; }
      loading = true;
      rememberTab();          // where the tab being LEFT was, read before any class or panel moves
      var outHref = curHref();   // ...and WHICH tab that is, for the PANEL CACHE stash at the swap
      var href = tab.getAttribute('href');
      pTabs.forEach(function (t) { t.classList.toggle('on', t === tab); });
      if (dir !== 0) paging(true);
      fetchTab(tab).then(function (html) {
        delete prefetch[href];
        var w = grid.offsetWidth || window.innerWidth;

        if (dir !== 0) {
          // LEGACY slide-in path (kept for completeness; the click/back paths all use dir=0). Stage the new
          // panel off-screen, then slide it home after two frames so its layout/decode doesn't land on the
          // animation's opening frames.
          grid.style.transition = 'none';
          grid.style.transform = 'translateX(' + (dir > 0 ? w : -w) + 'px)';
          stash(outHref);                       // keep the outgoing tab's rows (PANEL CACHE)
          grid.innerHTML = html;
          reconcile(grid, href, html); delete panelCache[href];   // a kept panel is live again: it is re-stashed when left
          grid.style.opacity = '';
          if (!noHist) { try { history.pushState(null, '', href); } catch (e) {} }
          try { grid.dispatchEvent(new CustomEvent('rova:paged')); } catch (e) {}
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              grid.style.transition = 'transform .26s cubic-bezier(.2,.7,.2,1)';
              grid.style.transform = 'translateX(0)';
              var done = function () { grid.removeEventListener('transitionend', doneT); clearTimeout(safeT); grid.style.transition = ''; grid.style.transform = ''; paging(false); hydrateChunked(grid); };
              var doneT = function (ev) { if (ev.target === grid && ev.propertyName === 'transform') done(); };
              grid.addEventListener('transitionend', doneT);
              var safeT = setTimeout(done, 380);   // fallback if transitionend is missed
              loading = false;
            });
          });
          return;
        }

        // dir === 0 (click / tap / back-forward): CROSS-DISSOLVE. The swap is instant, but painting the new
        // panel still costs the GPU ~one heavy frame (Cause 2 residual: image/media raster). Fade the old
        // panel out, swap while it's invisible so that raster happens OFF-SCREEN, then fade the new panel in.
        // Opacity animates on the compositor (cheap) and keeps presenting frames, so instead of one frozen
        // raster frame you see a smooth dissolve -- the native app's tab-change feel.
        var applyNew = function () {
          grid.style.transition = 'none';
          var keepG = pinGeom();                // where the reader IS, read before the swap can clamp it (KEEP THE SCROLL)
          stash(outHref);                       // keep the outgoing tab's rows (PANEL CACHE) -- invisible now, safe to settle
          grid.innerHTML = html;                // still at opacity 0 from the fade-out -> new content invisible
          var kept = reconcile(grid, href, html); delete panelCache[href];   // a kept panel: bring it up to date, it is live again
          grid.style.transform = '';
          if (!noHist) { try { history.pushState(null, '', href); } catch (e) {} }
          try { grid.dispatchEvent(new CustomEvent('rova:paged')); } catch (e) {}
          /* PER-TAB SCROLL, AND IT GOES FIRST ON PURPOSE (2026-09-13). Land the incoming tab at ITS
             OWN position -- top on a first visit -- in this same JS turn, BEFORE the carousel settle
             and the lazy-IO hydration below, because both of those are decided by the VIEWPORT BAND.
             Run them at the outgoing tab's offset (which is what happened until now) and they settle
             and observe whatever the stale, about-to-be-corrected scroll happens to point at, then
             the reader is somewhere else entirely. Restoring first means the band they measure is
             the band the reader will actually see. Media reserves its box server-side (_post.php
             width/height + aspect-ratio, .pcell contain-intrinsic-size), so the height this is
             clamped against is already the real one; the only thing the settle below can still grow
             is a desktop wide-gallery break-out, which moves the ceiling UP -- the safe direction --
             and an anchored landing re-pins a frame later anyway.
             It all happens while the panel is at opacity:0, so the swap and the landing are ONE
             visual event rather than a jump after the dissolve. */
          var pin = landIncoming(href, kept, keepG, !!noHist);
          // SETTLE ON-SCREEN CAROUSELS *before* the reveal. Lazy IO hydration (below) runs applyLayout AFTER
          // the content is visible, and applyLayout resizes the carousel (esp. the desktop wide-gallery
          // break-out) -- so the panel visibly resized a beat AFTER the dissolve (owner: "the only glitchy
          // thing left"). Hydrating the carousels near the viewport NOW, while still opacity:0, moves that
          // resize into the invisible phase. Bounded to the visible band (stop at the first below the fold);
          // off-screen carousels stay on the lazy IO path, so the Cause-1 no-freeze win holds (this forced
          // layout is hidden by the fade, not a visible stall).
          try {
            var _cs = grid.querySelectorAll('.carousel'), _vh = window.innerHeight || 800;
            for (var _i = 0; _i < _cs.length; _i++) {
              var _r = _cs[_i].getBoundingClientRect();
              if (_r.top > _vh + 200) break;         // below the fold -> leave to lazy IO
              if (_r.bottom < -200) continue;         // scrolled above the viewport -> skip
              if (!_cs[_i]._inited) initCarousel(_cs[_i]);
            }
          } catch (e) {}
          hydrateChunked(grid);                 // lazy IO carousel/embed hydration for everything still off-screen
          requestAnimationFrame(function () {   // 2 frames: let the new panel raster while invisible...
            repin(pin);
            requestAnimationFrame(function () {
              grid.style.transition = 'opacity .11s ease';
              grid.style.opacity = '1';         // ...THEN fade it up
              var clr = function () { grid.removeEventListener('transitionend', ce); clearTimeout(ft); grid.style.transition = ''; grid.style.opacity = ''; };
              var ce = function (ev) { if (ev.propertyName === 'opacity') clr(); };
              grid.addEventListener('transitionend', ce);
              var ft = setTimeout(clr, 320);
              loading = false;
            });
          });
        };
        // reduced-motion: skip the dissolve, swap instantly
        if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          grid.style.transition = 'none'; grid.style.opacity = ''; applyNew(); return;
        }
        grid.style.transition = 'opacity .06s ease';
        grid.style.opacity = '0';               // fade the CURRENT panel out, then swap in applyNew
        var swapped = false, go = function () { if (swapped) return; swapped = true; grid.removeEventListener('transitionend', oe); clearTimeout(ot); applyNew(); };
        var oe = function (ev) { if (ev.propertyName === 'opacity' && ev.target === grid) go(); };
        grid.addEventListener('transitionend', oe);
        var ot = setTimeout(go, 150);           // fallback if transitionend is missed
        // The landing is applyNew's landIncoming() -- per-tab, not "keep the reader's position"
        // (which is what this line used to say, and what Rob reported on 2026-09-13).
      }).catch(function () { loading = false; paging(false); window.location = href; });
    }

    // click (desktop + tap), no scroll jump
    tabsRow.addEventListener('click', function (e) {
      var tab = e.target.closest('.js-tab');
      if (!tab) return;
      e.preventDefault();
      switchTab(tab, 0);
    });

    // the reader's last settled scroll, for the popstate guard below (one property read per scroll event;
    // the engine's history restore fires its own scroll event only AFTER popstate, so this is still the
    // pre-traversal value when popstate reads it)
    var lastY = window.scrollY || 0;
    window.addEventListener('scroll', function () { lastY = window.scrollY || 0; }, { passive: true });

    // web#19 companion: back/forward RESTORES the tab the URL names. The
    // pager's pushState entries used to pop silently — the URL walked back
    // through the tabs but the page never changed, which is what let the
    // still-open viewer "keep popping back up" swipe after swipe.
    /* WHICH TAB A HISTORY ENTRY NAMES (2026-10-11). The tab links carry only `?tab=`, but the entry the
       page was LOADED on can carry more or less: `?tab=all&app=1` in app-chrome mode, or a bare `/@handle`
       / `/feed` (the default tab, which the server puts first in the row). An exact match missed both, so
       Back to the first entry changed the URL and left the panel on the wrong tab (measured: ?app=1, Grid
       -> Back -> still Grid). `app=1` is dropped before comparing, and a URL with no `tab=` on this
       pager's own path is the first tab. */
    function popTabFor() {
      var q = (location.search || '').replace(/^\?/, '').split('&').filter(function (s) { return s && s !== 'app=1'; }).join('&');
      var here = location.pathname + (q ? '?' + q : '');
      for (var j = 0; j < pTabs.length; j++) { if (pTabs[j].getAttribute('href') === here) return j; }
      var h0 = (pTabs[0] && pTabs[0].getAttribute('href')) || '';
      if (!/(^|&)tab=/.test(q) && h0.split('?')[0] === location.pathname) return 0;
      return -1;
    }
    window.addEventListener('popstate', function () {
      if (loading) return;
      var hit = popTabFor();
      for (var i = 0; i < pTabs.length; i++) {
        if (i === hit) {
          if (!pTabs[i].classList.contains('on')) {
            /* THE ENGINE'S OWN HISTORY RESTORE MUST NOT LAND ON THE OUTGOING TAB (2026-10-11). Chromium, with
               scrollRestoration 'auto', applies the incoming entry's saved offset in a task AFTER popstate
               (probed: popstate y=653, microtask 653, setTimeout-0 1465, then the frame) -- i.e. to the page
               that is STILL SHOWING THE OUTGOING TAB: Back from Grid (y 617) to a deep All (3277) painted Grid
               scrolled to its clamped bottom (1535) first, then All. And it would also land AFTER a
               reduced-motion switch, which swaps synchronously, overriding the landing outright. So the
               switch runs one task later, after that restore, and first puts the page back where the reader
               was (lastY) -- before any frame paints, and so rememberTab() records the outgoing tab's real
               place. switchTab's landIncoming then restores the incoming tab's own place. WebKit applies no
               restore here; the deferral costs it nothing visible. */
            var popTab = pTabs[i];
            setTimeout(function () {
              if (loading || popTab.classList.contains('on')) return;
              if (!scrollLocked() && Math.abs((window.scrollY || 0) - lastY) > 1) { try { window.scrollTo(0, lastY); } catch (e) { } }
              switchTab(popTab, 0, true);
            }, 0);
          }
          return;
        }
      }
    });

    // real-time drag pager (touch): BOTH panels track the finger — the incoming
    // tab rides in beside the outgoing one, native-pager style (owner #369: the
    // old path slid the current list away over the bare page background, then
    // slid the new one in after the finger lifted — two moves + a blank gap =
    // "chippy"). The neighbor's HTML is primed at the decision point and lives
    // in a GHOST panel absolutely positioned over the grid's box; on commit the
    // pair animates home together and the grid adopts the ghost's content in
    // place — no second move, no gap.
    /* THE GATE USED TO BE `'ontouchstart' in window && ...` AND THAT IS THE WHOLE BUG the owner
       reported on 2026-08-05 ("I'm trying to do it with my magic mouse and it's not working like
       it does for other websites"). A Mac desktop reports `'ontouchstart' in window === false`
       and `navigator.maxTouchPoints === 0` -- measured, not assumed -- so on his machine this
       entire block never registered at all. And even where it did register it could not have
       helped him: a Magic Mouse / trackpad horizontal swipe emits NO touch events, it is a
       `wheel` stream carrying deltaX. So the gate is now just "is there more than one tab to
       page to", the touch listeners are unchanged and still only fire on touch, and the wheel
       pager at the bottom drives the SAME ghost/commit/abort machinery. */
    if (pTabs.length > 1) {
      var sx = 0, sy = 0, drag = false, decided = false, horiz = false, skip = false, w = 0, promoted = false;
      /* ---- FLING (2026-09-19) ---------------------------------------------------------
         Rob: "switching tabs with the stuttery swipes". MEASURED FIRST (tools/pw/
         swipeflick.js, 390pt, real CDP touch, member fixture, CPU x4, bundle
         app.f5cfaca2890d): the touch commit test was DISTANCE ONLY -- `|dx| > w * 0.22`,
         i.e. 81px on a 366px panel -- with no velocity term anywhere. So:
              40px/ 90ms  v=0.44 px/ms  -> snapped back
              60px/ 90ms  v=0.67        -> snapped back
              70px/120ms  v=0.58        -> snapped back
              80px/120ms  v=0.67        -> snapped back
              90px/150ms  v=0.60        -> TOOK
         A brisk, deliberate flick that travels less than 81px slides the panel out and
         snaps it straight back, and the reader swipes again. That is indistinguishable
         from a stutter from the outside, and no amount of frame work fixes it.
         The velocity is sampled from `e.timeStamp`, NEVER Date.now(): a blocked main
         thread delivers several queued touchmoves at once, and wall-clock deltas between
         them would read as an impossibly fast finger. Same rule the carousel's wheel lock
         settled on the same night.
         Thresholds separate the two populations measured above with room to spare -- real
         flicks ran 0.44-0.75 px/ms, deliberate slow drags 0.23-0.28. */
      var FLING_V = 0.4;      // px/ms at lift
      var FLING_MIN = 36;     // px travelled: a flick, never a wobble on a tap
      var FLING_STALE = 150;  // ms: a finger that stopped and HELD before lifting is not flinging
      var FLING_WIN = 100;    // ms of travel the speed is read over -- see below
      var vel = 0, vX0 = 0, vT0 = 0, vPX = 0, vPT = 0;
      var ghost = null, ghostFor = -1, ghostHref = '', ghostBase = 0, ghostShift = 0, ghostWant = 0, ghostKept = false, ghostPinned = false;
      // after the snap-back; and the snap-back's translateX(0) goes too -- at rest the panel is NO stacking context
      // (see switchTab: a leftover transform put the comment sheet under the footer)
      function depromoteAfter() {
        setTimeout(function () {
          if (loading) return;
          paging(false);
          if (!drag && /^translateX\(0(px)?\)$/.test(grid.style.transform)) { grid.style.transform = ''; }
        }, 260);
      }
      /* Tearing down the ghost also drops the HTML it primed. THE PROMISE HAS NO OTHER CONSUMER: the
         two commit paths (switchTab and the touchend settle) both delete their own entry the moment
         they use it, so anything still in `prefetch` under this ghost's href is by definition a
         gesture that was abandoned or re-aimed at the other neighbour -- and leaving it there is what
         served a reader their pre-like feed on the next tap (see the fetchTab header). Deleting an
         entry a commit has already taken is a harmless no-op, and deleting one whose request is still
         in flight only means the next reader pays for a fresh fetch, which is the safe direction. */
      function killGhost() {
        if (ghost && ghost.parentNode) ghost.parentNode.removeChild(ghost);
        if (ghostHref) delete prefetch[ghostHref];
        ghost = null; ghostFor = -1; ghostHref = ''; ghostShift = 0; ghostWant = 0; ghostKept = false;
        if (grid.parentNode) grid.parentNode.classList.remove('tab-paging-clip');
      }
      function makeGhost(nextIdx, base) {
        ghostBase = base;
        if (ghostFor === nextIdx) return;
        var pb = grid.parentNode; if (!pb) return;
        /* EVERY READ FIRST, ON A CLEAN TREE -- THEN EVERY WRITE. This function runs inside
           the FIRST horizontal touchmove, i.e. on the frame where the reader expects the
           panel to start moving, and it used to add `tab-paging-clip` (and, via the caller,
           `tab-paging`) and THEN read getBoundingClientRect / getComputedStyle / offsetWidth.
           Each of those reads has to resolve the style and layout the writes just invalidated,
           synchronously, over the whole panel -- and the trace showed exactly that: one 253ms
           touch EventDispatch containing TWO nested UpdateLayoutTree passes of 126.7ms and
           72.7ms (2026-09-19, 390pt, CPU x4, tools/pw/swipetrace.js).
           MEASURED as a mechanism, not a guess, on the real feed page with no pager code
           involved (tools/pw/swipethrash.js, 12 samples per arm, alternating, one page view):
             write-then-read  40.5ms median (20.0-61.8), style 58.2ms, 4 forced style passes
             read-then-write   7.4ms median ( 2.6-17.2), style 32.2ms, 3 forced style passes
           The ranges are DISJOINT. Nothing here is skipped or deferred -- the same reads and
           the same writes happen, in the order that costs one resolve instead of three.
           `killGhost()` moved below the reads for the same reason (it removes a node and a
           class). It is safe to read `pr` before `tab-paging-clip` lands: that rule adds
           `position:relative` with no offsets and `overflow:clip`, neither of which moves or
           resizes pb's own box or the grid's -- and the ghost-geometry assertion in
           tools/pw/tabswipe-verify.js re-proves the 2026-08-10 "same box as the live panel"
           rule on every run. */
        var pr = pb.getBoundingClientRect(), gr = grid.getBoundingClientRect();
        var pbs = getComputedStyle(pb);
        var bl = parseFloat(pbs.borderLeftWidth) || 0, bt = parseFloat(pbs.borderTopWidth) || 0;
        var gw = grid.offsetWidth;
        var pg = pinGeom();   // reads only, so it belongs up here too (KEEP THE SCROLL)
        killGhost();
        pb.classList.add('tab-paging-clip');   // position:relative + overflow clip while panels hang off-screen
        // deep-scrolled: the incoming tab previews from ITS top aligned to the
        // viewport (what a native pager shows), not 3000px into a list that
        // doesn't have 3000px yet. Remember the shift so the commit can keep
        // what the eye saw in place.
        /* 2026-10-11: the line is the PIN (pinGeom's k), not a flat 74 px -- so a deep swipe previews, and
           lands, exactly where a tap lands: the new tab's top right under the tab row's pinned place (on
           the feed the old 74 hid the panel's first ~40 px under the docked row). Above the pin the shift
           is 0 and the reader's scroll is kept as it is. */
        ghostShift = Math.max(0, Math.round(pg.k - gr.top));
        ghostPinned = pg.y >= pg.pin;
        ghost = document.createElement('div');
        ghost.className = grid.className.replace('tab-paging', '').trim() + ' tab-ghost';
        /* THE GHOST MUST BE THE SAME BOX AS THE LIVE PANEL. It used to be
           `left:0;right:0`, which spans the PADDING box of the positioned parent
           (.wrap#feed-wrap), while the in-flow grid spans its CONTENT box -- and .wrap
           carries a 12px gutter a side. Measured at 390: grid x=12 w=366, ghost x=0
           w=390. Three faults fell out of that one line, and together they are the
           owner's 2026-08-10 report ("it increases the width of the tab contents and
           then shrinks it", with a mid-swipe photo showing two overlapping panels at
           different sizes):
             1. the incoming panel laid its cards out 24px (6.6%) WIDER than the panel
                it replaces, so the tab visibly grew during the slide and snapped back
                narrower the moment the real panel was adopted;
             2. it started 12px left of the live panel, so the two OVERLAPPED by 12px
                for the whole gesture -- two feeds' content on screen at once;
             3. the callers park it at +/- grid.offsetWidth (366), which is 24px short
                of its own width, so 24px of the NEXT tab sat on screen before the
                finger had moved at all.
           Pinning left+width to the grid's own box fixes all three at once and makes
           the callers' `w` correct by construction. Border is subtracted because an
           absolute child is positioned from the parent's PADDING edge; .wrap has none
           today, but reading it costs nothing and stops this drifting again. */
        /* pbs / bl / bt / gw are read at the TOP of this function now, before any write --
           see the read-before-write note there. */
        ghost.style.cssText = 'position:absolute;left:' + ((gr.left - pr.left - bl)) +
          'px;width:' + gw + 'px;top:' + ((gr.top - pr.top - bt) + ghostShift) +
          'px;height:' + window.innerHeight + 'px;overflow:hidden;will-change:transform;';
        ghost.style.transform = 'translateX(' + base + 'px)';
        pb.appendChild(ghost);
        ghostFor = nextIdx;
        ghostHref = pTabs[nextIdx].getAttribute('href') || '';
        fetchTab(pTabs[nextIdx]).then(function (html) {
          if (!ghost || ghostFor !== nextIdx) return;
          ghost.innerHTML = html;
          ghostKept = reconcile(ghost, ghostHref, html);   // a KEPT panel previews as the member left it, brought up to date
          /* A kept panel can have been left at its very END, scrolled past the last card into the orb and the
             footer -- which live OUTSIDE the panel, so the ghost (overflow:hidden, one screen tall) could not
             scroll that far and its clamp previewed, and then landed, the reader up to a screen short of where
             they were. A screen of empty room after the last row lets the preview reach it; it is taken out
             again before the adoption (the commit's apply), so it never enters the live panel. */
          if (ghostKept) { var gpad = document.createElement('div'); gpad.className = 'tab-ghost-pad'; gpad.style.height = (window.innerHeight || 800) + 'px'; ghost.appendChild(gpad); }
          /* PER-TAB SCROLL, THE PREVIEW HALF. The ghost is what the eye follows in, so a tab the
             reader has a remembered place in must PREVIEW from that place -- otherwise the commit
             would have to jump after the slide, which is the one thing this pager has always
             refused to do ("the swap happens on identical pixels"). The ghost is overflow:hidden,
             so scrollTop still moves its content and the browser CLAMPS the assignment to what the
             panel actually has -- which is exactly the clamp the landing needs, for free.
             ghostWant then feeds apply()'s scroll below, where want=0 reduces to the original
             ghostShift landing line for line. */
          var m = tabMem[ghostHref];
          // KEEP THE SCROLL: only a tab with its own place PAST the pin, swiped to while the row is pinned
          // (at or past the pin, as a tap decides it), previews from that place; above the pin the
          // reader's own scroll is the landing
          if (!m || !(m.off > 0) || !ghostPinned) { ghostWant = 0; return; }
          try {
            ghost.scrollTop = 0;
            var el = m.id ? ghost.querySelector('.post[data-id="' + m.id + '"], .pcell[data-id="' + m.id + '"]') : null;
            /* m.d is the anchor card's distance from the VIEWPORT top when the tab was left, and the ghost
               does not start at the viewport top -- it hangs ghostShift below the panel, i.e. under the
               sticky chrome (~74 px down on a deep scroll). Subtracting the ghost's own top as well put the
               anchor that much LOWER than it was left, and the commit (which keeps the ghost's pixels) then
               landed the reader 74 px short (measured 2000 -> 1926 on a kept Discover panel, 2026-09-29).
               With scrollTop at 0, el's viewport top minus m.d is exactly the scroll that puts it back at m.d. */
            var want = el ? Math.round(el.getBoundingClientRect().top - m.d) : m.off;
            ghost.scrollTop = Math.max(0, want);
            ghostWant = ghost.scrollTop;          // read back: the engine has clamped it to this panel
          } catch (e) { ghostWant = 0; }
        }).catch(function () {});
      }

      /* ---- ONE commit, ONE abort -- shared by the finger and by the wheel ---------------
         Both gestures reach here having staged the SAME state: `w` measured, a ghost built
         for `next` (which is also what primed its HTML), the grid + ghost translated by the
         live offset, and the gold bar dragged toward the neighbour. The only thing that
         differs is how the gesture ENDED -- a finger lifts; a wheel stream crosses a
         threshold or falls silent -- so the ending is all that lives in the callers, and
         there is exactly one copy of the threshold semantics, the ghost adoption, the
         history push and the teardown.
         `dirSign` < 0 means the outgoing panel travels LEFT (paging toward a higher index). */
      function commitPage(next, dirSign) {
        // COMMIT: both panels animate home together; then the grid adopts the
        // ghost's content in place — the swap happens on identical pixels.
        loading = true;
        rememberTab();          // per-tab scroll: where the tab being LEFT was (see switchTab)
        var outHref = curHref();   // PANEL CACHE: stashed at the swap, once the outgoing panel is off screen
        var tab = pTabs[next], href = tab.getAttribute('href');
        pTabs.forEach(function (t2) { t2.classList.toggle('on', t2 === tab); });
        // the bar finishes the trip with the panels (and, on a phone, lands on the
        // row's SETTLED geometry -- the label it just uncovered is still growing)
        if (tabsRow._rovaSlider) tabsRow._rovaSlider.settle(tab);
        grid.style.transition = 'transform .24s cubic-bezier(.2,.7,.2,1)';
        if (ghost) ghost.style.transition = 'transform .24s cubic-bezier(.2,.7,.2,1)';
        grid.style.transform = 'translateX(' + (dirSign < 0 ? -w : w) + 'px)';
        ghost.style.transform = 'translateX(0)';
        var shift = ghostShift;
        /* ADOPT THE GHOST'S NODES -- do not re-parse the panel.
           The header above says "the grid adopts the ghost's content in place", and it
           did not: it called grid.innerHTML = html and parsed the SAME ~83KB partial a
           SECOND time, throwing away a DOM the browser had already built, styled, laid
           out and decoded every image for while the finger was still down.
           MEASURED (tools/pw/tm-landing.js, 3 runs each, 390pt, LTE wire, member session,
           Discover -> New: 10 cards / 43 images both sides; the old path is reproduced by
           rewriting this guard out of the served bundle, tm-lib.js `oldCommit`):
             adoption frame   re-parse 59.7/63.2/76.9ms  ->  adopt 67.7/35.0/44.9ms
             worst landing fr re-parse 159.6/125.6/107.6 ->  adopt 79.2/123.1/60.7
           The landing MEDIAN is unchanged (~22ms both ways) -- this takes the top off the
           worst frame, it does not raise the floor.
           DO NOT "optimise" the loop below into replaceChildren or a DocumentFragment:
           all three forms were benchmarked on a real panel and cost the SAME (medians
           26.5 / 26.6 / 24.5ms, tools/pw/tm-movebench.js). The cost is not the insertions,
           it is 10 cards and 43 images entering the live scroller -- ten insertions and
           one insertion price identically.
           innerHTML stays as the fallback for the one case the ghost cannot cover -- a
           commit whose HTML has not landed yet (slow network), where the ghost is still
           empty and there is nothing to adopt.

           THE NEXT STEP, AND WHY IT IS NOT TAKEN HERE. Not moving the children at all --
           PROMOTING the ghost to be the live panel (drop its position/width/height/
           overflow, give it the id, remove the old container) -- is genuinely cheaper:
           priced directly rather than guessed, it is 11.6ms vs 27.3ms on New and 15.7ms
           vs 25.2ms on Discover (tools/pw/tm-promote.js). That is ~10-16ms off ONE frame
           of ~35-49ms; it does not move the landing median and does not clear the 6-7
           frames over 33ms, which are image decode either way.
           It is not taken because the live panel's NODE is captured at boot in five
           places that would then be writing to a DETACHED element, silently:
             1. the realtime-feed IIFE (`var feed`, ~16 uses) -- new-posts pill + push
                band, reveal/trickle, pruneFarPosts, the adaptive memory guard, far-video
                pause, engRefresh's root, chrome-idle/watch mode;
             2. setupLoadMore's `var list` AND its 'rova:paged' listener;
             3. setupTabPager's own `grid` -- touchstart/touchmove/touchend/wheel live on
                it, so the pager would stop paging after the first swipe;
             4. the guest browse gate (`var feed` + a MutationObserver bound to it);
             5. the suggested-people interleave (`var feed` / `var container`).
           Every one of those fails without throwing. The prerequisite is a single
           accessor that resolves the panel per use (and delegation for the gesture
           listeners), shipped and verified on its own; after that the swap is a small
           diff. Staged deliberately -- see the 2026-08-10 report. */
        var settle = function () {
          var apply = function (html) {
            grid.style.transition = 'none';
            // the reader's y BEFORE the swap: emptying the panel below can clamp window.scrollY, and the old
            // landing read it after -- that is how a deep swipe onto a short tab landed at y=0 (KEEP THE SCROLL)
            var y0 = window.scrollY || 0;
            stash(outHref);                     // keep the outgoing tab's rows (PANEL CACHE); it has slid off screen
            var keptP = false;
            if (html === null) {
              keptP = ghostKept;
              grid.textContent = '';
              var gpads = ghost.querySelectorAll('.tab-ghost-pad');
              for (var gp = 0; gp < gpads.length; gp++) { if (gpads[gp].parentNode) gpads[gp].parentNode.removeChild(gpads[gp]); }
              while (ghost.firstChild) { grid.appendChild(ghost.firstChild); }   // already reconciled when primed
            } else {
              grid.innerHTML = html;
              keptP = reconcile(grid, href, html);
            }
            delete panelCache[href];            // live again: re-stashed when it is left
            grid.style.transform = '';
            try { history.pushState(null, '', href); } catch (e2) {}
            try { grid.dispatchEvent(new CustomEvent('rova:paged')); } catch (e2) {}
            /* Keep what the eye saw. `- shift` is the original line: the new tab's top stays where
               the ghost had it -- at the PIN now when the reader was past it (makeGhost), and exactly
               the reader's own y when they were not (shift 0). `+ want` is the per-tab landing
               (2026-09-13): the ghost previewed this tab from its remembered place, so the panel must
               settle there. Runs BEFORE the carousel settle below, as on the tap path, so the band
               that settle measures is the one the reader will actually see. */
            var want = ghostWant || 0;
            var vhC = window.innerHeight || 800;
            grid.style.minHeight = '';          // the last tab's floor is not this one's
            var ty = Math.round(y0 - shift + want);
            if (want > 0 && !keptP) {
              // a remembered place in a RE-FETCHED (shorter) panel: same bottom rule as landIncoming
              var maxY = Math.max(0, (document.documentElement.scrollHeight || 0) - vhC);
              var ceilC = maxY - vhC * 0.5;
              if (ty > ceilC) { ty = ceilC > 0 ? Math.round(ceilC) : 0; }
              ty = Math.min(ty, maxY);
            } else {
              holdFloor(ty);                    // a shorter tab must not clamp the landing (KEEP THE SCROLL)
            }
            ty = Math.max(0, ty);
            // unconditional, for the same reason landIncoming's is: the adopt can shrink the
            // document under the reader, and only an explicit scroll discards the engine's pending
            // offset. With shift=0 and want=0 this writes the offset the reader had -- a no-op to
            // the eye, and the thing that stops a later append walking the page to its end.
            try { window.scrollTo({ top: ty, behavior: 'auto' }); } catch (e2) { window.scrollTo(0, ty); }
            // web#21: settle the VISIBLE carousels in this same JS turn, before the
            // browser paints the adopted panel — lazy IO hydration ran applyLayout
            // after the swap was on screen, so media boxes visibly resized ("the
            // panel's width expands"). Same bounded band as the click path's
            // preSettle: stop at the first carousel below the fold.
            try {
              var _cs2 = grid.querySelectorAll('.carousel'), _vh2 = window.innerHeight || 800;
              for (var _j = 0; _j < _cs2.length; _j++) {
                var _r2 = _cs2[_j].getBoundingClientRect();
                if (_r2.top > _vh2 + 200) break;
                if (_r2.bottom < -200) continue;
                if (!_cs2[_j]._inited) initCarousel(_cs2[_j]);
              }
            } catch (e2) {}
            // hydrate AFTER the ghost is gone and the pair has settled -- the forced reflows can't stall the slide
            requestAnimationFrame(function () { killGhost(); paging(false); loading = false; hydrateChunked(grid); });
          };
          // the ghost has the panel already built: move it, don't rebuild it
          if (ghost && ghost.firstChild) { delete prefetch[href]; apply(null); return; }
          fetchTab(tab).then(function (html) { delete prefetch[href]; apply(html); })
            .catch(function () { loading = false; killGhost(); paging(false); window.location = href; });
        };
        setTimeout(settle, 260);   // just past the .24s slide
      }
      /* SNAP BACK. killGhost() on the 260ms tail is the load-bearing part: it is what DROPS
         THE PRIMED HTML. An abandoned or re-aimed gesture must not leave a snapshot in
         `prefetch` for a later tap to be painted from -- that is the stale-snapshot bug in
         the fetchTab header (owner: "I liked a post then switched tabs and it doesn't show
         my like"). EVERY abort goes through here: a finger that stopped short, a wheel
         stream that fell silent below the threshold, a wheel gesture re-aimed at the other
         neighbour, and an edge rubber-band. */
      function abortPage() {
        grid.style.transition = 'transform .24s cubic-bezier(.2,.7,.2,1)';
        if (ghost) ghost.style.transition = 'transform .24s cubic-bezier(.2,.7,.2,1)';
        grid.style.transform = 'translateX(0)';   // not far enough (or no ghost): snap back
        if (tabsRow._rovaSlider) tabsRow._rovaSlider.settle(null);
        if (ghost) ghost.style.transform = 'translateX(' + ghostBase + 'px)';
        setTimeout(killGhost, 260);
        depromoteAfter();
      }

      grid.addEventListener('touchstart', function (e) {
        var t = e.touches[0];
        sx = t.clientX; sy = t.clientY; drag = true; decided = false; horiz = false; promoted = false;
        vel = 0; vX0 = vPX = t.clientX; vT0 = vPT = e.timeStamp;   // fling tracking, see FLING_V above
        // .pgrid.is-arranging (0129): while the owner is arranging their grid, a horizontal finger drag
        // is a TILE being moved, not a tab change. Without this the pager would page to Videos halfway
        // through a drag and take the grid being arranged off the screen.
        /* .vctrl / .vc-sound (owner 2026-08-28: "I can't scrub the video because it's swiping
           between tabs"): a SINGLE-VIDEO post matches nothing else on this list -- js-solo-media
           is stamped only when the one media is NOT a video (views/_post.php, `$solo`), because
           that class belongs to the photo lightbox wiring, and a lone video has no .carousel
           either. So a scrub on its seek bar read as a tab swipe: the same claim-by-movement
           failure the carousel pager fixed on 2026-08-05, arriving on a third pager. Same remedy
           as the pfeed pager's pgSkip: a touch that STARTS in the control bar (or the corner
           mute, which lives outside it) belongs to the video, decided at touchstart by origin. */
        skip = !!(e.target.closest && (e.target.closest('.carousel') || e.target.closest('.lightbox') || e.target.closest('.js-solo-media') || e.target.closest('.sugg-carousel') || e.target.closest('.pgrid.is-arranging') || e.target.closest('.vctrl') || e.target.closest('.vc-sound')));
        w = grid.offsetWidth || window.innerWidth;
        grid.style.transition = 'none';
      }, { passive: true });
      grid.addEventListener('touchmove', function (e) {
        if (!drag || skip || loading) return;
        var t = e.touches[0], dx = t.clientX - sx, dy = t.clientY - sy;
        if (!decided) {
          if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
          horiz = Math.abs(dx) > Math.abs(dy) * 1.2;
          decided = true;
          if (!horiz) { drag = false; return; }
        }
        if (horiz) {
          e.preventDefault(); // lock to horizontal, stop vertical scroll
          /* Fling speed over a SLIDING ~100ms WINDOW, on the EVENT's own clock -- not a
             smoothed per-event delta, and this distinction decided real gestures.
             The browser COALESCES touchmoves: a 120ms flick that the OS sampled 12 times
             arrives as three events. An exponential average over those deltas is dragged
             down by the first one, whose interval starts back at touchstart and spans the
             finger's stationary moment -- measured, that read a genuine 0.51px/ms flick as
             0.445 and left it hovering either side of the threshold run to run (the
             acceptance suite caught it: the same 70px/120ms gesture committed in one arm
             and not the other). Total displacement over total elapsed time across a fixed
             window is immune to how the samples were grouped, because both halves of the
             quotient lose the same events. */
          if (e.timeStamp - vT0 > FLING_WIN) { vX0 = vPX; vT0 = vPT; }   // roll the window base forward
          vPX = t.clientX; vPT = e.timeStamp;
          vel = (vPT > vT0) ? (vPX - vX0) / (vPT - vT0) : 0;
          var cur = curIndex();
          var next = cur + (dx < 0 ? 1 : -1);
          var edge = (cur === 0 && dx > 0) || (cur === pTabs.length - 1 && dx < 0);
          if (!edge && next >= 0 && next < pTabs.length) {
            /* ...and the gold bar comes with you. Native drives its slider off the
               pager position, so the underline is under your finger the whole way;
               this is the same idea against dx/w. Transform-only inside the slider,
               so it adds no layout to a drag frame -- EXCEPT on its first call for a
               target, which reads liveGeom (two getBoundingClientRect + a
               getComputedStyle on the tab row). That is why it now runs BEFORE
               makeGhost rather than after: makeGhost appends the ghost, and a read
               after that append pays for resolving it. Same rule as the one inside
               makeGhost -- every read on a clean tree, then every write. */
            if (tabsRow._rovaSlider) tabsRow._rovaSlider.drag(pTabs[next], Math.abs(dx) / w);
            makeGhost(next, dx < 0 ? w : -w);   // primes the HTML too
          }
          /* ...and the promotion LAST. `tab-paging` carries will-change plus the
             `.pcell img/video` animation-pause rules, so adding it invalidates style for
             the panel's subtree; adding it FIRST (where it used to be) meant every
             geometry read in this handler had to resolve that invalidation synchronously
             before it could answer. Nothing about the promotion needs to happen before
             the reads -- the first painted frame of the drag is the one below. */
          if (!promoted) { promoted = true; paging(true); }   // GPU layer + freeze Ken Burns for a composite-only follow
          grid.style.transform = 'translateX(' + (dx * (edge ? 0.32 : 1)) + 'px)';
          if (ghost) ghost.style.transform = 'translateX(' + (ghostBase + dx) + 'px)';
        }
      }, { passive: false });
      grid.addEventListener('touchend', function (e) {
        if (!drag) return;
        drag = false;
        grid.style.transition = 'transform .24s cubic-bezier(.2,.7,.2,1)';
        if (ghost) ghost.style.transition = 'transform .24s cubic-bezier(.2,.7,.2,1)';
        // a TAP (or a vertical scroll) never moved the panel: leave it with no transform at all -- this line used to
        // stamp translateX(0) on every tap, so after the first touch the whole list was a stacking context
        if (skip || !horiz) { grid.style.transform = ''; killGhost(); depromoteAfter(); if (tabsRow._rovaSlider) tabsRow._rovaSlider.settle(null); return; }
        var dx = e.changedTouches[0].clientX - sx;
        var cur = curIndex(), next = cur + (dx < 0 ? 1 : -1);
        /* 22% of the panel width -- OR A FLING. The distance rule is untouched; this only
           ADDS a second way to commit, so nothing that used to page still snaps back.
           THREE guards, and each one is load-bearing:
             - direction agreement (`(vel < 0) === (dx < 0)`): a finger that ran one way and
               reversed before lifting has a velocity pointing at the OTHER neighbour, and
               the ghost that is built belongs to `next`. Without this a reversal could
               commit the tab the reader just pulled back from.
             - FLING_MIN: a tap with a few px of wobble can reach a high px/ms over a 6ms
               sample. A commit has to be a real movement as well as a fast one.
             - FLING_STALE: velocity is only meaningful if the finger was still MOVING when
               it left the glass. A drag that travelled 60px, stopped, and rested for a
               third of a second is a considered abort, and it must stay one.
           `ghost && ghostFor === next` still gates both paths: with no primed neighbour
           there is nothing to commit TO, fling or not. */
        var fling = Math.abs(vel) >= FLING_V && Math.abs(dx) >= FLING_MIN &&
                    (vel < 0) === (dx < 0) && (e.timeStamp - vPT) <= FLING_STALE;
        if ((Math.abs(dx) > w * 0.22 || fling) && next >= 0 && next < pTabs.length && ghost && ghostFor === next) {
          commitPage(next, dx < 0 ? -1 : 1);
        } else {
          abortPage();
        }
      }, { passive: true });

      /* ---- THE SAME PAGER FOR A MAGIC MOUSE / TRACKPAD (wheel) -------------------------
         A horizontal Magic Mouse or trackpad swipe emits no touch events whatsoever -- it
         is a `wheel` stream carrying deltaX -- so everything above is invisible to it. This
         drives the identical machinery: same ghost, same live preview, same gold-bar drag,
         same commitPage/abortPage, same killGhost teardown of the primed HTML.

         FOUR THINGS A WHEEL HAS TO GET RIGHT THAT A FINGER DOES NOT:

         1. THE BROWSER'S OWN HISTORY GESTURE. On macOS a two-finger horizontal swipe is
            back/forward in both Safari and Chrome, and losing the feed is worse than nothing
            happening. TWO guards, because neither engine is covered by the other's:
            `html,body{overscroll-behavior-x:none}` (rova.css, "No sideways scroll/overscroll
            anywhere") handles Chrome/Edge -- and DOES NOT EXIST IN WEBKIT, which rova.css
            already says out loud further down -- while a non-passive listener that calls
            preventDefault() is what Safari honours. The preventDefault fires on the FIRST
            horizontally-dominant event of the stream, BEFORE any threshold, because Safari
            decides whether to start its swipe from the opening events of the gesture: a
            preventDefault that waits to be sure would arrive after the page had already gone.

         2. MOMENTUM. There is no touchend here. The OS keeps firing wheel events with a
            DECAYING magnitude for up to a second after the hand has stopped, which is easily
            enough to page two or three tabs from one flick. So: commit ONCE, then LOCK, and
            follow the decaying tail. A genuinely new flick RE-ACCELERATES -- the magnitude
            climbs back above the tail -- which releases the lock at once, so two deliberate
            swipes still page twice while one flick pages once. 140ms of silence resets
            everything. This is deliberately the SAME rule the photo carousel already uses
            for its own horizontal wheel (initCarousel, "desktop trackpad"), so the two
            surfaces behave identically under the same hand.

         3. VERTICAL SCROLLING WITH X DRIFT. A Magic Mouse puts a few px of deltaX into
            almost every vertical scroll. The rule the touch side settled on -- decide
            ownership from INTENT, not from a bare movement threshold -- has a direct
            analogue: dominance alone is not enough, because at the END of a vertical inertia
            tail deltaY decays toward zero and a stray deltaX briefly "wins". So a
            vertical-dominant event does not merely get ignored, it ARMS a 220ms vertical
            lock that no horizontal event can page through. Vertical intent is never stolen.

         4. GENUINELY HORIZONTAL CHILDREN. If something under the pointer scrolls sideways by
            design, the wheel belongs to it. ownsWheelX() excludes two kinds: things that
            really scroll (the people rail .sugg-carousel-view, an admin table, a wide <pre>)
            -- detected from LIVE GEOMETRY rather than a class list, and only while they still
            have room to move IN THIS DIRECTION, so a rail parked at its end hands the gesture
            on instead of swallowing it -- and things that run their own horizontal wheel
            handler, above all .carousel, which pages its slideshow and does NOT
            stopPropagation, so without this one flick would page the slideshow AND the tab. */
      var WHEEL_ARM = 16;      // px of accumulated deltaX before the ghost is built (touch uses 8px of travel)
      /* WHEEL_COMMIT is deliberately NOT the touch path's 22%-of-width. A wheel swipe is a
         flick, not a drag across the panel: on a ~620px desktop column 22% would be 136px of
         accumulated deltaX, which is a shove. 90px is far above drift (which the ratio test
         and the vertical lock have already thrown out) and easy to reach in one flick, and
         the lock in (2) -- not the threshold -- is what stops a flick paging twice. */
      var WHEEL_COMMIT = 90;
      var wAcc = 0, wLive = false, wLock = false, wTail = 0, wIdle = null, wVertUntil = 0, wNext = -1;
      // Firefox can report lines (deltaMode 1) or pages (2); normalise to px so one
      // threshold means the same thing on every engine.
      function wDX(e) { return e.deltaMode === 1 ? e.deltaX * 16 : e.deltaMode === 2 ? e.deltaX * (grid.offsetWidth || 800) : e.deltaX; }
      function wDY(e) { return e.deltaMode === 1 ? e.deltaY * 16 : e.deltaMode === 2 ? e.deltaY * (window.innerHeight || 800) : e.deltaY; }
      function ownsWheelX(node, dx) {
        for (var el = node; el && el !== grid && el.nodeType === 1; el = el.parentNode) {
          var cl = el.classList;
          if (cl && (cl.contains('carousel') || cl.contains('lightbox') || cl.contains('sugg-carousel') ||
                     (cl.contains('pgrid') && cl.contains('is-arranging')))) return true;
          if (el.scrollWidth > el.clientWidth + 1) {
            var ox = getComputedStyle(el).overflowX;
            if (ox === 'auto' || ox === 'scroll') {
              var room = dx > 0 ? (el.scrollWidth - el.clientWidth - el.scrollLeft) : el.scrollLeft;
              if (room > 1) return true;   // it can still move THIS way -> the wheel is its
            }
          }
        }
        return false;
      }
      // End of a wheel gesture. Nothing here touches the idle timer: the timer is what
      // eventually clears the momentum lock, and it must outlive the commit.
      function wEnd(commitNext, dirSign) {
        if (!wLive) return;
        wLive = false; wAcc = 0; wNext = -1;
        if (commitNext >= 0) commitPage(commitNext, dirSign); else abortPage();
      }
      /* 5. A WHEEL HAS NO CAPTURE, AND THE PANEL MOVES OUT FROM UNDER THE CURSOR.
            This listener used to be on `grid`, and that is why the desktop swipe "worked
            sometimes": a wheel event hit-tests FRESH every time, and the whole point of
            this gesture is that the grid slides sideways. Once it had travelled past the
            cursor -- at progress 0.5 for a cursor in the middle of the panel, i.e. 45px
            into the 90px WHEEL_COMMIT -- the events stopped landing on the grid, this
            listener stopped being called at all, and 140ms later the idle timer fired
            abortPage() and binned the flick. MEASURED, before this fix, 1440x900:
              cursor at   8%  25%  50%  75%  92% of the panel
              swipe LEFT  ok   ok  STUCK STUCK STUCK
              swipe RIGHT STUCK STUCK STUCK  ok   ok
            -- the failing half MIRRORS with direction, because the ghost enters from the
            side you are paging away from. Only 4 of 10 cursor positions could page at all.
            A FINGER never had this problem, and not by luck: a touchmove is delivered to
            the node captured at touchstart, so it keeps reaching the grid however far the
            panel has slid. Touch's implicit capture is exactly what this has to imitate.
            THE HOST IS grid.parentNode -- the .wrap that makeGhost() already uses as the
            ghost's offset parent and as .tab-paging-clip. It is the one element that does
            NOT move during a page and that contains BOTH panels, so the stream keeps
            bubbling to it wherever the pair has slid to. window would also work and is
            worse: a non-passive wheel listener on window makes the compositor consult JS
            for every scroll on the page, which is a scroll-perf tax this site does not need.
            THE ENTRY GATE BELOW KEEPS THE OLD SCOPE EXACTLY. The .wrap also holds the tabs
            row and the composer, so "the gesture must START over the panel" is now stated
            explicitly (grid.contains) where it used to be implied by the binding. Once the
            gesture is LIVE it is ours to the end -- which is also why ownsWheelX is an
            entry-time question now: a carousel sliding under the cursor mid-flick must not
            steal a gesture that is already committed to paging, exactly as the touch path
            decides ownership once and never revisits it. */
      var wheelHost = grid.parentNode || grid;
      wheelHost.addEventListener('wheel', function (e) {
        var dx = wDX(e), dy = wDY(e), ax = Math.abs(dx), ay = Math.abs(dy);
        // (3) vertical intent owns the gesture, and keeps owning it through its own tail
        if (ax < 2 || ax <= ay * 1.2) { if (ay > ax) wVertUntil = Date.now() + 220; return; }
        if (Date.now() < wVertUntil) return;
        /* ENTRY ONLY -- see (5). `wLock` is in the test as well as `wLive` because the
           MOMENTUM TAIL has to keep reaching the swallowing logic below: right after a
           commit the grid is mid-slide and off-screen, so a tail event lands nowhere near
           it, and bailing here would leave the tail unswallowed and its idle timer
           un-refreshed -- one flick could then page a second time as soon as the panel
           settled back under the cursor. */
        if (!wLive && !wLock) {
          if (!grid.contains(e.target)) return;                // the gesture must START over the panel
          if (ownsWheelX(e.target, dx)) return;                // (4) something under the pointer wants it
        }
        e.preventDefault();                                    // (1) claim it before WebKit starts a history swipe
        clearTimeout(wIdle);
        // (2) 140ms of silence = the stream is over. A live-but-uncommitted gesture snaps
        // back through abortPage(), which is what drops the ghost's primed HTML.
        wIdle = setTimeout(function () { wIdle = null; wEnd(-1, 0); wLock = false; wTail = 0; wAcc = 0; }, 140);
        if (loading) wLock = true;                             // a swap is in flight: swallow the rest of the stream
        if (wLock) {
          if (!loading && ax > wTail + 8) { wLock = false; wAcc = 0; }   // re-acceleration = a genuinely new flick
          else { wTail = ax; return; }
        }
        wTail = ax;
        if (!wLive) { wLive = true; wAcc = 0; w = grid.offsetWidth || window.innerWidth; paging(true); }
        /* 5. THE TWO AXES POINT OPPOSITE WAYS FOR THE SAME PHYSICAL GESTURE, and getting this
              backwards is the owner's 2026-08-10 report ("left and right swipes need to be
              inverted for desktop, my magic mouse is doing the opposite of what it should").
                - A FINGER's dx is a POSITION delta: you drag the panel WITH your hand, so
                  swiping LEFT gives dx < 0, drags the panel left, and uncovers the tab on the
                  RIGHT. Hence the touch path's `dx < 0 ? 1 : -1` -- left = NEXT.
                - A WHEEL's deltaX is a SCROLL delta: positive means "move the viewport toward
                  the content on the right". The OS emits deltaX > 0 for that SAME leftward
                  swipe (macOS natural scrolling, and a Windows precision touchpad, both do).
              So deltaX and dx have OPPOSITE signs for one hand movement, and this line used to
              accumulate deltaX raw and then feed it to sign tests copied verbatim from the touch
              path -- every wheel gesture paged the wrong way, including the preview, the gold
              bar and the edge test, all of them consistently backwards.
              The fix is here and ONLY here: negate once, so `wAcc` carries FINGER-TRAVEL
              semantics -- the exact same quantity the touch handler's `dx` carries -- and every
              sign test below is then correct BY BEING IDENTICAL to its touch counterpart
              (next/edge/makeGhost/sgn/dirSign all line up line-for-line). Do not "fix" this by
              flipping one of those tests instead; that is how they drifted apart in the first
              place. NOTE ownsWheelX(e.target, dx) above deliberately still gets the RAW deltaX,
              because it compares against scrollLeft room, which is scroll-convention.
              The photo carousel's own horizontal wheel (initCarousel, "desktop trackpad") has
              always had this right -- `dir = wAcc > 0 ? 1 : -1  // deltaX>0 (swipe left) = next`
              -- so before this fix a single flick over a carousel paged the slideshow one way
              and the tab row the other. */
        wAcc -= dx;
        if (Math.abs(wAcc) < WHEEL_ARM) return;                // too small to mean anything yet: no ghost, no fetch
        var cur = curIndex();
        var next = cur + (wAcc < 0 ? 1 : -1);
        var edge = (cur === 0 && wAcc > 0) || (cur === pTabs.length - 1 && wAcc < 0);
        /* PROGRESS, not raw pixels. A finger's dx IS the panel's offset, so the touch path
           can translate by dx directly; a wheel's accumulated deltaX is not a panel offset,
           and translating by it would inch the panel 90px across a 620px column and then
           teleport the rest on commit. Drive BOTH panels and the gold bar off the same
           0..1 progress toward WHEEL_COMMIT instead, so the pair is exactly home at the
           moment commitPage() takes over and the hand-off is invisible. */
        var t = Math.min(1, Math.abs(wAcc) / WHEEL_COMMIT), sgn = wAcc < 0 ? -1 : 1;
        if (!edge && next >= 0 && next < pTabs.length) {
          makeGhost(next, wAcc < 0 ? w : -w);                  // primes the HTML too (and re-aiming kills the old prime)
          wNext = next;
          if (tabsRow._rovaSlider) tabsRow._rovaSlider.drag(pTabs[next], t);
        } else { wNext = -1; }
        var vis = edge ? sgn * Math.min(90, Math.abs(wAcc)) * 0.32 : sgn * t * w;
        grid.style.transition = 'none';
        grid.style.transform = 'translateX(' + vis + 'px)';
        if (ghost) ghost.style.transform = 'translateX(' + (ghostBase + vis) + 'px)';
        if (!edge && wNext >= 0 && Math.abs(wAcc) >= WHEEL_COMMIT && ghost && ghostFor === wNext) {
          wLock = true;                                        // one tab per flick; the tail is swallowed from here
          wEnd(wNext, wAcc < 0 ? -1 : 1);
        }
      }, { passive: false });
    }
  }
  setupTabPager(document.getElementById('profile-tabs'), document.getElementById('profile-posts'));
  setupTabPager(document.getElementById('feed-tabs'), document.getElementById('feed-posts'));

  /* ---- profile name: shrink to fit ONE line instead of truncating with "…" ---------- */
  (function () {
    var el = document.querySelector('.pf-name'); if (!el) return;
    var MIN = 15;   // never smaller than this; ellipsis (CSS) is the last resort past it
    function fit() {
      el.style.fontSize = '';                                   // back to the CSS size, then measure
      var size = parseFloat(getComputedStyle(el).fontSize) || 22, guard = 0;
      while (el.scrollWidth > el.clientWidth + 1 && size > MIN && guard++ < 40) {
        size -= 1; el.style.fontSize = size + 'px';
      }
    }
    fit();
    var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(fit, 120); }, { passive: true });
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(fit); }   // re-fit once the webfont lands
  })();

  /* ---- "Load more" pagination (feed = keyset by ?before, profile = ?offset) --- */
  function setupLoadMore(cfg) {
    var list = document.getElementById(cfg.listId);
    var wrap = document.getElementById(cfg.wrapId);
    if (!list || !wrap) return;
    var btn = wrap.querySelector('button');
    if (!btn) return;
    /* THE ORB'S BOB RUNS ONLY WHILE THE ORB IS ON SCREEN (idle-cost audit, 2026-09-18). `fm-bob` is an
       INFINITE compositor animation on an element that sits under the last card -- off screen for nearly
       the whole session -- and on a phone at rest (where the card pans are killed) it was the ONE thing
       still asking the compositor for a frame every vsync, forever. rova.css pauses it unless `fm-vis`
       is on; this observer is the only writer. content-visibility cannot do it: the animation is on the
       element itself, and paint containment would clip the orb's lift and shadow. */
    if ('IntersectionObserver' in window) {
      try { new IntersectionObserver(function (ents) { for (var q = 0; q < ents.length; q++) { ents[q].target.classList.toggle('fm-vis', ents[q].isIntersecting); } }).observe(wrap); } catch (e) { wrap.classList.add('fm-vis'); }
    } else { wrap.classList.add('fm-vis'); }
    var PAGE  = cfg.pageSize || 12;
    var COUNT = cfg.count || 0;       // per-load increment asked of the server (0 = server default)
    var AUTO_MAX = cfg.autoMax || 0;  // auto-load on scroll up to this many posts, THEN manual only
    // The FIRST page (initial render / after an AJAX tab swap) can be a different size than the
    // per-load increment. The home feed opens with FEED_PAGE (9) rows but auto-loads 10 at a time, so
    // reusing PAGE(=10) as the "is the first page full?" test wrongly hid the orb after a tab swap
    // (9 < 10) -> Following/New never auto-loaded. Read the real first-page size off the list
    // (data-page = FEED_PAGE) so it can't drift; fall back to PAGE.
    var FIRST = parseInt(list.getAttribute('data-page') || '', 10) || cfg.firstPage || PAGE;
    var loading = false, autoLoaded = 0;
    var autoTick = null;               // set below when AUTO_MAX > 0; re-checks "near the bottom?"

    function items()     { return list.querySelectorAll('.post, .pcell'); }
    function target()    { return list.querySelector('.pgrid') || list; }
    /* MEASURED AND REVERTED (2026-08-09). isGrid() is called twice per scroll frame and, on the card
       feed, each call walks the whole #feed-posts subtree without matching. Memoising it on
       list.childElementCount was correct and strictly less work -- and made NO measurable difference:
       A/B against the immediately preceding bundle, 3 alternating reps each, HTTP cache disabled,
       1.6Mbps/300ms/CPU 4x, scroll TBT median 10235ms old vs 10378ms new, dropped frames 84% vs 84%,
       worst frame 2967ms vs 2933ms. A caller-attributed profile then showed why: the 963ms of
       querySelector on this path was never this function at all, it was overlayOpen() firing from a
       touchmove listener (app.js ~25010). The memo is not kept -- an unmeasurable optimisation in the
       scroll path is just complexity the next reader has to verify. */
    function isGrid()    { return !!list.querySelector('.pgrid'); }
    function activeHref() {
      var tabs = cfg.tabsId ? document.getElementById(cfg.tabsId) : null;
      var on   = tabs && (tabs.querySelector('.js-tab.on') || tabs.querySelector('.js-tab'));
      return on ? on.getAttribute('href') : (location.pathname + location.search);
    }
    /* ---- THE END-OF-FEED CARD (owner 2026-09-19) --------------------------------------------------
       "I shouldn't run out of stuff to see." The paging bug that ended his Trending run early is fixed
       on the server; this is the SECOND, independent defect that report exposed. When a page came back
       with nothing, the entire client-side answer was `wrap.hidden = true` -- the orb quietly vanished
       and the page footer was what the reader met. That is a defect even when the feed is CORRECTLY
       out of posts, and the New tab, which genuinely ends at its 24-hour window most days, said nothing
       at all, every time.

       HOW THIS CANNOT BE MISCOUNTED AS CONTENT, which is the one thing it must not do. parsePage()
       counts `.post, .pcell` in the RESPONSE HTML, and index.php's load-more branch deliberately emits
       only a hidden <i> sentinel for exactly that reason. So the server sends no markup for this card
       either -- only two attributes on that same sentinel. The card is BUILT HERE, in the client, and
       appended AFTER applyPage() has already read `page.added` off the parsed fragment. It carries
       neither class and no data-id, so items(), the append de-dupe, pageUrl()'s cursor read and the
       recycler's `.post` walk all step straight over it. `added` is computed from bytes this element
       was never part of.

       IT IS ALWAYS THE LAST THING IN THE LIST: every append clears it first and re-shows it only if
       that append was itself empty, so a card can never end up stranded above real posts.

       WHY IT COMPLEMENTS `.feed-more.at-cap::after` ("Swipe up (or tap) for fresh posts") RATHER THAN
       REPLACING IT. That label is gated on `!wrap.hidden` -- it is the AUTO-LOAD BUDGET's message
       ("there is more, you just have to ask for it"), and it is specifically not shown at the real end.
       This card only ever appears when wrap.hidden is true. The two are mutually exclusive by
       construction and say opposite things, which is correct: one means "more", one means "no more".

       THE ACTION IS A PURE CLIENT-SIDE SCROLL. Anything that reloads or re-mints a feed run would
       ADVANCE the Trending/Discover rotation rung, which is what made the old dead-end self-feeding --
       a pull-up on a dead feed refreshed, advanced the rung and died again. This touches no cursor, no
       rung and no network. */
    var END_ID = cfg.wrapId + '-end';
    function endCard()  { return document.getElementById(END_ID); }
    function clearEnd() { var c = endCard(); if (c && c.parentNode) { c.parentNode.removeChild(c); } }
    function showEnd() {
      if (!cfg.endCard || endCard()) return;
      // Page one was empty: views/_feed_posts.php has already said so, per tab, in its own empty state.
      // Two messages about the same nothing is worse than one.
      if (!items().length) return;
      var flags = list.querySelectorAll('.feed-more-flag[data-end]');
      var flag  = flags.length ? flags[flags.length - 1] : null;
      var msg   = flag && flag.getAttribute('data-end');
      // NO SERVER COPY, NO CARD. A page rendered before this shipped (or any surface whose sentinel
      // carries no end copy) stays exactly as it is rather than having an English literal invented for
      // it here -- /feed is not in I18n::PAGES and the strings belong to the server either way.
      if (!msg) return;
      var cta = (flag.getAttribute('data-end-cta') || '').trim();
      var card = document.createElement('div');
      card.className = 'feed-end';
      card.id = END_ID;
      card.setAttribute('role', 'status');
      var mark = document.createElement('span');
      mark.className = 'feed-end-mark'; mark.setAttribute('aria-hidden', 'true');
      var title = document.createElement('p');
      title.className = 'feed-end-title'; title.textContent = msg;
      card.appendChild(mark); card.appendChild(title);
      if (cta) {
        var top = document.createElement('button');
        top.type = 'button'; top.className = 'feed-end-top'; top.textContent = cta;
        top.addEventListener('click', function (e) {
          e.preventDefault();
          var soft = !(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
          try { window.scrollTo({ top: 0, behavior: soft ? 'smooth' : 'auto' }); }
          catch (err) { window.scrollTo(0, 0); }
        });
        card.appendChild(top);
      }
      // list, never target(): on the Grid tab target() is the .pgrid itself, and a non-.pcell child
      // there would be laid out as a grid track. Appended to the list it sits under the whole wall.
      list.appendChild(card);
      try { document.dispatchEvent(new CustomEvent('rova:feedend', { detail: { id: END_ID } })); } catch (err) {}
    }
    // after a tab swap the list is fresh: reset the auto-load budget and show the button if there's more.
    // Prefer the server's .feed-more-flag (judged on the RAW, pre-screening fetch) over counting rendered
    // cards -- Moderation::screen can trim the first page below FIRST while more posts wait behind the
    // cursor, and reading a short page as "the end" dead-ended the feed (New tab "stuck at 8"). Fall back to
    // the old rendered-count test only when no flag is present (older cached HTML, grid tab).
    // The spent auto budget, carried IN the list so a kept panel (PANEL CACHE) brings it back; see reset().
    // A hidden, id-less, class-only marker: items(), the de-dupe, pageUrl() and the recycler all ignore it.
    function autoMark() {
      var am = list.querySelector(':scope > .feed-auto-mark');
      if (!am) { am = document.createElement('i'); am.className = 'feed-auto-mark'; am.hidden = true; list.insertBefore(am, list.firstChild); }
      am.setAttribute('data-n', String(autoLoaded));
    }
    function reset() {
      loading = false; autoLoaded = 0;
      // DROP THE READ-AHEAD ON A TAB SWAP. grid/photos/videos are three different result sets behind one
      // pager, so a page fetched for the tab you just left must never be inserted into the tab you just
      // arrived at. This is the first of three guards and the only one that runs on the swap itself; the
      // URL key in load() and the in-flight re-check in ensureGridBuf() cover a page that was already
      // built, or still arriving, when the swap happened.
      gBuf = null; gBufUrl = '';
      var flag = list.querySelector('.feed-more-flag');
      /* A KEPT PANEL (the tab pager's PANEL CACHE, 2026-09-29) comes back with the end card it was left
         with -- the one card this module only ever builds once a page came back EMPTY. That is the
         server's own "nothing behind the cursor" answer and it has not changed, so it stands: re-opening
         the orb would spend a request to be told the same thing. A fresh page never carries the card. */
      var ended = !!endCard() && list.contains(endCard());
      wrap.hidden = ended || (flag ? (flag.getAttribute('data-more') !== '1') : (items().length < FIRST));
      wrap.classList.remove('at-cap');
      /* ...and with the AUTO-LOAD BUDGET it had spent. A fresh page never carries the marker (autoMark(),
         below, writes it only when a scroll-driven page lands), so a first visit starts at 0 exactly as
         before; a kept panel resumes where it was, at-cap label included -- the reader left at the end of
         their budget comes back to the same orb and the same document height, and no page they did not
         ask for is fetched the instant they land. */
      var am = list.querySelector(':scope > .feed-auto-mark');
      var amN = am ? parseInt(am.getAttribute('data-n') || '0', 10) : 0;
      if (amN > 0) {
        autoLoaded = amN;
        if (cfg.reloadAtCap) wrap.classList.toggle('at-cap', !isGrid() && !wrap.hidden && AUTO_MAX > 0 && autoLoaded >= AUTO_MAX);
      }
      // A stale card from the tab we just left is dropped whatever the new tab says; the new tab gets
      // its own only when the SERVER has already said there is nothing behind the cursor. That is the
      // New tab's ordinary state -- one short page and done -- and it is the case that was silent even
      // though no "load more" ever ran.
      clearEnd();
      if (wrap.hidden) { showEnd(); }
      if (gridAuto()) { ensureGridBuf(); }   // start warming the new tab's next page straight away
    }
    /* still allowed to auto-load (on scroll): under the cap, more to come, not already loading. The card
       feed auto-loads with a lead, up to its cap.

       THE GRID EXCLUSION IS NOW OPT-IN (2026-08-09), and fixing it is why this pass exists. `!isGrid()`
       here was a blanket veto left over from TEST round 106 ("cap the grid at its first page and see
       whether a bounded grid scrolls buttery"). autoTick() returns immediately when !autoOK(), so the
       veto made the grid's OWN dwell-at-the-bottom branch further down unreachable dead code -- while
       the comment above it went on describing that branch as the live behaviour. The visible result:
       a profile grid shipped 30 tiles and never appended another, on any of the three media tabs, and
       the only way past 30 was a full page reload.
       Scoped by `cfg.gridAuto` rather than simply deleted, because the veto is still RIGHT for the home
       feed: #feed-posts' Grid tab is paged by gridCycle() (its own roll cursor, its own de-dup, its own
       double buffer), so letting this pager auto-append there too would run two independent appenders
       over one grid and double-insert. Only the profile opts in. */
    // engage-hold: engaged() gates the SCROLL-DRIVEN append only -- the orb and the bottom pull-up call load(false)
    // straight through, and a deliberate tap must always still work.
    function autoCap()  { return (isGrid() && cfg.gridAutoMax) ? cfg.gridAutoMax : AUTO_MAX; }
    function gridAuto() { return !!cfg.gridAuto && isGrid(); }
    function autoOK() { return AUTO_MAX > 0 && (gridAuto() || !isGrid()) && autoLoaded < autoCap() && !wrap.hidden && !loading && !engaged(); }

    function load(isAuto) {
      if (loading) return;
      var n = items().length;
      if (!n) { wrap.hidden = true; return; }
      var url = pageUrl(n);

      // BUFFERED PAGE: the exact page this call was about to ask for is already parsed and waiting, so
      // the append is a synchronous insert from memory and the reader never meets a network wait at the
      // bottom of the grid. Keyed on the FULL URL, which carries the active tab and the offset, so a
      // buffer built for another tab (or another offset) can never be spent here -- it simply misses and
      // this falls through to the fetch below. No 'loading' class on this path: it would paint the orb's
      // ellipsis for a single frame and then take it straight back off.
      if (gBuf && gBufUrl === url) {
        var page = gBuf; gBuf = null; gBufUrl = '';
        loading = true; btn.disabled = true;
        applyPage(page, isAuto);
        return;
      }

      loading = true; btn.disabled = true;
      wrap.classList.add('loading');            // orb morphs into the ellipsis dots

      // rfetch, not fetch: this .then() used to run on ANY response, including a Cloudflare 5xx error
      // page. That page parses fine, contains no .post/.pcell, `added` comes out 0 -- and the "genuinely
      // EMPTY page means no more" rule below then hides the pager PERMANENTLY on what was only a failed
      // request. rfetch rejects a non-2xx into the .catch, which leaves the pager up and retryable, so
      // `added === 0` once again means only what it says: the server answered, with nothing.
      rfetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', cache: 'no-store' }, 8000)
        .then(function (r) { return r.text(); })
        /* THE TAB MOVED WHILE THIS PAGE WAS ON THE WIRE (2026-09-29): it belongs to the list that was left,
           which is now a KEPT panel (the tab pager's PANEL CACHE) and will page itself from its own cursor
           when it comes back. Appending it here would put one tab's posts into another's list. reset() has
           already cleared `loading` for the new tab; nothing else to undo. Same guard as ensureGridBuf's. */
        .then(function (html) {
          if (url.indexOf(activeHref() + (activeHref().indexOf('?') >= 0 ? '&' : '?') + 'partial=posts&') !== 0) {
            if (!loading) { btn.disabled = false; wrap.classList.remove('loading'); }   // unless the new tab has its own page in flight
            return;
          }
          applyPage(parsePage(html), isAuto);
        })
        // FAILURE IS NOT AN ANSWER: clear the in-flight state so the very next scroll (or an orb tap) can
        // ask again, and deliberately do NOT touch wrap.hidden or the auto budget. Reached now by a 5xx
        // and by rfetch's deadline as well as by a dropped socket -- before, an 8s-plus hang left `loading`
        // pinned and the orb spinning for as long as the platform's own socket timeout (60-120s on iOS).
        .catch(function () { loading = false; btn.disabled = false; wrap.classList.remove('loading'); });
    }

    // The page URL this pager would ask for next, given `n` items already shown. Extracted so the
    // read-ahead buffer builds the SAME string load() will later look itself up by -- if these two ever
    // drifted the buffer would silently never hit, and the only symptom would be that the grid felt
    // slow again.
    function pageUrl(n) {
      var href = activeHref();
      var q;
      // Trending is engagement-ordered — no stable id cursor. Page it by OFFSET
      // (posts already shown), the same mode the profile grids use.
      if (cfg.mode === 'before' && href.indexOf('tab=trending') < 0) {
        // The cursor is the LAST card in the DOM, and it must stay that way: discover/new blend older
        // posts into a fresh page on purpose, so the last card is NOT the smallest id there, and paging
        // from the smallest would skip everything in between. The server keeps this trustworthy by
        // pinning each page's original tail when it reorders (Posts::pinTail).
        /* ...and the server states that tail itself now (data-tail on the .feed-more-flag sentinel),
           because the DOM's last card is the tail AFTER Moderation::screen and spreadSimilarCovers.
           On Discover those are not the same row: page one pins a CHRONOLOGICAL card last on
           purpose (Posts::pinTail) so this cursor is honest, but screening runs before the pin, so
           if that one card is screened out the last card left can be a woven "popular" row up to
           14 days older -- and this pager then asks for everything before THAT, skipping weeks.
           The DOM read stays as the fallback for a page rendered before this shipped. */
        var withId = list.querySelectorAll('.post[data-id], .pcell[data-id]');   // .pcell = the media Grid tab
        var last = withId[withId.length - 1];
        var tails = list.querySelectorAll('.feed-more-flag[data-tail]');
        var tl = tails.length ? parseInt(tails[tails.length - 1].getAttribute('data-tail'), 10) : NaN;
        q = 'before=' + encodeURIComponent((isFinite(tl) && tl > 0) ? tl : (last ? (last.getAttribute('data-id') || '0') : '0'));
      } else {
        /* OFFSET-PAGED (Trending): TAKE THE SERVER'S OFFSET, DO NOT COUNT THE CARDS.
           `n` is items().length, and it is wrong in both directions. It under-runs, because
           Moderation::screen drops cards out of the raw page the server offset by -- so the next
           request asks for an offset the reader is already past and the feed re-serves posts he
           has seen (measured 2026-08-23 against the owner's Trending: first repeat on page 22).
           And it over-runs, because the ambient roll appends its own .post cards into this very
           list -- so the next request skips as many posts as the roll happened to insert.
           The server now states where its next page starts, on the .feed-more-flag sentinel that
           rides every page (handle_feed's $feedNext = this page's offset + the RAW fetch size).
           Read the LAST one, since appended pages accumulate them. `n` stays as the fallback for
           a cached page rendered before this shipped. */
        var flags = list.querySelectorAll('.feed-more-flag[data-next]');
        var nx = flags.length ? parseInt(flags[flags.length - 1].getAttribute('data-next'), 10) : NaN;
        q = 'offset=' + ((isFinite(nx) && nx >= 0) ? nx : n);
      }
      if (COUNT) q += '&n=' + COUNT;
      return href + (href.indexOf('?') >= 0 ? '&' : '?') + 'partial=posts&' + q;
    }
    // Parse once, insert later. `added` is counted here, off the container, so it keeps the original
    // descendant-aware semantics rather than only counting top-level children.
    function parsePage(html) {
      var tmp = document.createElement('div');
      tmp.innerHTML = (html || '').trim();
      var added = tmp.querySelectorAll('.post, .pcell').length;
      var nodes = [];
      while (tmp.firstChild) { var node = tmp.firstChild; tmp.removeChild(node); nodes.push(node); }
      return { nodes: nodes, added: added };
    }
    /* ---- CHUNKED INSERT: BUILT AND REVERTED TWICE (2026-08-09) -------------------------------------
       Leaving this note because the win was real and the blocker is specific -- the next person to
       reach for this should know it works and exactly what it costs. It has now been built, measured
       and reverted twice, for the SAME reason both times; the second attempt is recorded at the end,
       along with the measurement that says what would actually have to be true for it to land.

       THE TARGET. A caller-attributed CPU profile, resolved through the sourcemap (Chromium,
       1.6Mbps/300ms RTT, CPU 4x, 26s fling), put the .then() that calls this function at a 2078ms
       subtree, 8% of the whole fling, landing as ONE ~2s long task: thirty cards appended and then
       initCarousels + initEmbeds run over every one of them inside a single uninterruptible block.

       WHAT WAS BUILT. Insert 3 cards per frame (grid cells 6, gridCycle's already-measured size),
       yielding between chunks; `loading` held across fetch AND insert so a sentinel hit mid-insert
       cannot queue a second page; an insert generation bumped by reset() so a tab swap abandons an
       insert still in flight; setTimeout instead of rAF while hidden so a backgrounded tab cannot
       strand the flag. Chunk size from measurement: ~69ms per card (2078/30), so 3 is ~207ms a yield.

       IT WORKED, on exactly the metrics it was meant to move (A/B, alternating arms, cache disabled,
       bundle identity asserted, medians of 3):
           worst single task   1340ms -> 823ms     (a dedicated run with 4 page inserts inside the
                                                    measured window: 2285ms -> 758ms)
           worst frame         2200ms -> 1283ms    (ranges 2133-2200 vs 1283-1300, non-overlapping)
           long tasks          94 -> 113           (more, shorter -- the intent)
           total long-task ms  15724 -> 15577      (chunking cost nothing in total work)
           TBT                 11024ms -> 10285ms
       Twenty-plus screens of recycling were clean too: 63 screens, stub/restore churn 139/148, zero
       sourceless cards, zero deferred avatars left on screen, zero duplicate ids across 13 page
       requests and zero overlapping page requests -- the busy flag spanning the insert held.

       WHY IT IS NOT HERE. It doubles PEAK CONCURRENTLY-LOADING BYTE-BEARING <video>. Measured over 63
       screens, A/B, alternating: peak 3 and 3 on the old bundle; 8 and 6 on the chunked one, p95 3 vs
       7. The cause is a batching assumption elsewhere: with one insert task the video wiring sees all
       thirty cards in a single MutationObserver batch and its start decisions are taken together; with
       ten chunks it sees ten batches and takes ten independent decisions, so the concurrent starts
       accumulate. That is the same class of hazard as everything else in this pass -- code that
       assumed a page arrives in ONE task -- and it is the one that bites.

       On a congested line more concurrent video is precisely the harm this whole effort exists to
       remove, so a faster main thread does not buy it. The fix belongs in the video start path (a cap
       on concurrent starts that is independent of how many batches the cards arrive in), NOT here, and
       that path is load-bearing enough -- mp4-first, __rovaBgHold, the data-video-src re-attach,
       preload="none" for origin capacity -- that it deserves its own pass with its own verification.
       Once concurrent starts are bounded batch-independently, this change can land as written.

       ================================================================================================
       SECOND ATTEMPT, 2026-08-09, SAME DAY. The scheduler at playIO WAS built (it is still there, and
       it is sound), the chunked insert was re-landed on top of it exactly as written above -- 3 cards
       per frame, 6 grid cells, `loading` held across fetch AND insert, an insert generation bumped by
       reset(), setTimeout instead of rAF while hidden, carousels/embeds initialised in the chunk that
       appends them -- and it is REVERTED AGAIN. The main-thread win reproduced in full:
           worst single task   3111ms -> 1149ms   (runs 4420/3111/2555 vs 1270/1149/1095: NO OVERLAP)
           worst frame         4250ms -> 1800ms   (5966/4250/3733 vs 1800/1967/1667: NO OVERLAP)
           long tasks          89 -> 115          (more, shorter -- the intent)
       Medians of 3, alternating arms, cache disabled, one control bundle asserted at 643807 bytes.

       WHY IT WENT BACK ANYWAY, and this is the part worth reading. The precondition was never "a
       scheduler exists", it was "the concurrent-video budget provably holds under chunked arrival".
       Measured on ONE chunked bundle with the scheduler switched on and off at runtime (3 runs per
       arm, 60-78 screens each):
           scheduler OFF   peak 5, 4, 7      p95 5, 4, 7      130/130/153 posts
           scheduler ON    peak 4, 4, 4      p95 4, 4, 4      130/159/159 posts
       which looks like the bound holding -- until you read the counter the module keeps for exactly
       this question: GRANTS 16-17 PER RUN, EVICTIONS ZERO. The cap was never reached, so the scheduler
       did not cause the difference between those two columns; it cannot have. Three runs of 4 against
       runs of 5, 4 and 7 is the SAME NOISE that made a single peak untestable in the first place, and
       shipping on it would be shipping a coincidence and calling it a guarantee. The chunked arm can
       still reach 7 against today's 4-5, and on a congested line that is the exact harm this whole
       effort exists to remove.

       WHAT WOULD ACTUALLY HAVE TO CHANGE (measured, not guessed). The scheduler holds a slot while
       readyState < 3 -- "a start in progress", which is the right definition of a start and is what
       the design asked for. The acceptance metric counts readyState < 4 && networkState === LOADING.
       Those are different populations, and a per-state census over a 63-screen fling says the metric
       is dominated by the half the slot definition deliberately excludes:
           post | rs3 | preload=auto     137 samples   (arrived, still filling -- holds no slot)
           post | rs0 | preload=metadata  71 samples   (wire()'s default tier -- not one of the five
                                                        enumerated start paths, and not owned)
           post | rs0-2 | preload=auto    ~90 samples  (genuine starts -- owned, counted)
       So a cap on STARTS cannot bound this metric however low it is set: at cap 3 the live count still
       peaks at 2. Bounding it needs one of two decisions, both bigger than a number change and neither
       of them mine to make on the way past:
         (a) widen what holds a slot to include post-arrival buffering (readyState < 4 while
             networkState is LOADING) -- which makes the slot a BANDWIDTH budget rather than a start
             budget, and reopens the exact "a parked-but-buffering clip pins the ceiling" trap the
             eviction design was built to avoid. It is survivable HERE, because eviction means the
             parked clip is the victim rather than the gate -- but it needs its own verification pass.
         (b) own wire()'s preload=metadata default as a sixth start path. Cheap, and it is genuinely a
             byte-bearing start, but it is the tier that makes posters and durations work, and
             preload="none" on server-rendered video is load-bearing for origin capacity -- so it wants
             deliberate thought, not a reflex.
       Until one of those is done and re-measured, the insert keeps arriving in one task. The scheduler
       stays: it is correct, it is provably free (phase 1 below), and it is the thing (a) or (b) would
       be built on. */
    function applyPage(page, isAuto) {
      var dest = target(), fresh = [];
      /* APPEND DE-DUPE, the same one the app has had since #456 ("I see the same post twice",
         FeedScreen's id filter on append). The web never got it, so every server-side paging defect
         landed on the reader's screen as a literally repeated card. It is a SAFETY NET and not a
         fix -- the causes belong on the server and are being fixed there -- but the reader should
         never see the same card twice while one of them is still in flight.
         Known cause it covers today: Discover weaves ~half of page one from a 14-day "popular" pool
         whose ids are OLDER than the chronological cursor, so every woven card is served again by a
         later page (measured: exactly floor(pageSize/2) repeats over a full walk).
         Scoped to .post/.pcell with a data-id, so the sentinel and the empty state pass through, and
         the ambient ROLL is untouched -- it inserts through the reveal queue, never here, and its
         content is allowed to re-surface by design (data-roll="1"). */
      var have = {};
      var known = list.querySelectorAll('.post[data-id], .pcell[data-id]');
      for (var k = 0; k < known.length; k++) { have[known[k].getAttribute('data-id')] = 1; }
      page.nodes.forEach(function (node) {
        if (node.nodeType === 1) {
          var el = node.matches && node.matches('.post[data-id], .pcell[data-id]') ? node : null;
          if (el) {
            var did = el.getAttribute('data-id');
            // Dropped from the DOM but DELIBERATELY still counted in page.added. `added` is the
            // "is there more behind the cursor" signal, and the answer to that is the server's --
            // a page that came back full is a full page whether or not this reader has already
            // seen its cards. Decrementing it would let a transient all-duplicate page hide the
            // pager permanently and end the feed early, which is the failure this is guarding.
            if (have[did]) { return; }   // already on screen
            // DELETED since this page was fetched (a read-ahead page, or a request in flight across the
            // delete): never insert it. Counted in page.added for the same reason as a duplicate.
            if (window.__rovaPostGone && window.__rovaPostGone(el)) { return; }
            have[did] = 1;
          }
          fresh.push(node);
        }
        dest.appendChild(node);
      });
      fresh.forEach(function (el) { initCarousels(el); initEmbeds(el); });
      loading = false; btn.disabled = false; wrap.classList.remove('loading');
      if (isAuto) { autoLoaded += page.added; autoMark(); }    // only scroll-driven loads spend the auto budget
      // Only a genuinely EMPTY page means "no more". We used to stop on a short page (fewer than
      // the requested batch), but Posts::trimToFullRows deliberately returns a multiple of 3 --
      // routinely fewer than requested -- so "short page" no longer means "last page"; treating it
      // that way dead-ended the grid after the first page. Keyset (before) and offset pagination
      // both keep advancing safely as long as something came back.
      if (page.added === 0) wrap.hidden = true;
      // ...and SAY SO. `added === 0` on a resolved rfetch is the server answering with nothing, which
      // is the one honest end-of-feed signal this pager has: a 5xx or a dead socket rejects into the
      // .catch above and never reaches here, a short page keeps paging, and a page whose cards were all
      // de-duped away still counts them (see the note in the append loop). Anything else and the card
      // goes away again -- it is only ever the tail of a feed that has genuinely stopped.
      if (page.added === 0) { showEnd(); } else { clearEnd(); }
      if (cfg.reloadAtCap) wrap.classList.toggle('at-cap', !isGrid() && !wrap.hidden && AUTO_MAX > 0 && autoLoaded >= AUTO_MAX);
      // The GRID loads exactly ONE page (30) per trip to the bottom -- no chaining ahead, so it
      // never loads mid-scroll. The card feed keeps chaining to fill a deep buffer for sit-back
      // playback. (autoTick's distance check also differs per surface -- see below.)
      if (isAuto && autoTick && !isGrid()) { requestAnimationFrame(autoTick); }
      // ...and start building the NEXT one, so the following trip to the bottom is free too.
      if (gridAuto()) { ensureGridBuf(); }
    }

    /* ---- GRID READ-AHEAD BUFFER (2026-08-09) -------------------------------------------------------
       Fetching when the reader reaches the bottom still STALLS at the bottom on a bad line -- the whole
       lesson of this session is that an interaction must never wait on a request. So the next page is
       fetched while the reader is still on their way down and held, parsed, in memory; arriving at the
       bottom then costs a DOM insert and nothing else. Same shape as gridCycle's ensureBuf() on the
       home grid, which was added for exactly this reason.

       WHY THIS COSTS NO MEDIA BANDWIDTH, which is the thing it could easily have got wrong. A detached
       <img> with an eager src DOES start downloading (gridCycle relies on that on purpose). But every
       cell in an APPENDED profile page is loading="lazy" -- views/_profile_posts.php sets
       $eagerLeft = $itemsOnly ? 0 : 6, and a load-more page is always $itemsOnly -- and a lazy image
       that is not in the document is not near any viewport, so it does not fetch until it is inserted
       AND scrolled to. And a grid video cell ships an <img class="pcell-video" data-video-src> rather
       than a <video> (views/_profile_posts.php:300; app.js upgrades it to a real element only on a
       mouse hover, never on touch), so a buffered page cannot start a video load at all. Measured
       below and confirmed: peak concurrently-loading byte-bearing <video> is unchanged.

       ONE PAGE AHEAD, never a queue: `gBuf` holds at most one page and is only refilled once it has
       been spent. Hidden tabs do not prefetch. A tab swap drops it (reset), the URL key stops a stale
       one being spent on the wrong tab, and the post-fetch re-check drops a page whose tab moved while
       it was in flight. */
    var gBuf = null, gBufUrl = '', gBufBusy = false;
    function ensureGridBuf() {
      if (!gridAuto() || gBuf || gBufBusy || document.hidden) return;
      if (!autoOK()) return;            // respects the cap, the engage hold and wrap.hidden alike
      var url = pageUrl(items().length);
      gBufBusy = true;
      rfetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', cache: 'no-store' }, 8000)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          // The tab (or the item count) moved while this was in flight: this page belongs to a list
          // that is no longer on screen. Dropping it is the whole cross-tab guard -- appending it would
          // put one tab's media into another's grid.
          if (url !== pageUrl(items().length)) return;
          gBuf = parsePage(html); gBufUrl = url;
        })
        .catch(function () {})          // a failed read-ahead just leaves load() to fetch for itself
        .then(function () { gBufBusy = false; });
    }

    // Auto-load the next page as the bottom nears -- driven by a throttled SCROLL listener, not an
    // IntersectionObserver. An observer with a big rootMargin only fires when the sentinel CROSSES the
    // margin edge; once the sentinel sat permanently inside the margin (which happens the moment the
    // rendered content is shorter than the margin) it never fired again, so the grid dead-ended after
    // the first page -- exactly what was happening (scrolling to the bottom loaded nothing). A scroll
    // check fires reliably on every frame you scroll and the `loading` guard keeps it to one page at a
    // time. The GRID never pages mid-scroll: it triggers only once you've REACHED the bottom (orb in view),
    // then inserts one 30-post page while you're stopped, so nothing renders during a scroll -- and it keeps
    // going a page at a time if you sit at the end. That page is normally already in memory (see the read-
    // ahead buffer above), so reaching the bottom does not wait on a request. The card feed keeps a ~2-screen lead
    // and chains (see the load() re-check above) so
    // sit-back playback never waits.
    if (AUTO_MAX > 0) {
      var pending = false, gBottomT = null;
      autoTick = function () {
        pending = false;
        if (!autoOK()) { if (gBottomT) { clearTimeout(gBottomT); gBottomT = null; } return; }
        var vh = window.innerHeight || document.documentElement.clientHeight || 800;
        var dist = wrap.getBoundingClientRect().top - vh;   // px from the viewport bottom down to the orb
        if (isGrid()) {
          // GRID: never page mid-scroll (that was the chop). Only once you've actually REACHED the bottom (the
          // orb is in view, dist < 0) does it load the next page -- so the render lands while you're stopped
          // at the end, then keeps going a page at a time if you sit there. Scroll back up before it fires
          // and it cancels. (The orb tap / pull-up still load immediately.)
          //
          // START THE READ-AHEAD ~2 SCREENS OUT, and let the dwell collapse once it lands. The 1s dwell was
          // there to keep a NETWORK FETCH off the scroll; with the page already parsed in memory there is no
          // fetch left to keep off, so waiting a further second at the bottom is a stall with nothing behind
          // it. Buffer ready -> 120ms (enough to tell "reached the end" from "flung straight past"); buffer
          // cold -> the original 1000ms, because that path still ends in a request.
          if (dist < vh * 2) { ensureGridBuf(); }
          if (dist < 0) {
            if (!gBottomT) gBottomT = setTimeout(function () {
              gBottomT = null;
              if (autoOK() && (wrap.getBoundingClientRect().top - (window.innerHeight || 800)) < 0) load(true);
            }, (gBuf && gBufUrl === pageUrl(items().length)) ? 120 : 1000);
          } else if (gBottomT) { clearTimeout(gBottomT); gBottomT = null; }
        } else if (dist < vh * 2) {
          load(true);                                       // card feed: keep a generous 2-screen lead
        }
      };
      // PERF: recycleTick() used to be called SYNCHRONOUSLY here, so its replaceChild writes landed in
      // the middle of the scroll dispatch and every listener registered after this one (chrome expand,
      // yank guard, grid pager, scroll-perf RUM) then forced a re-layout to read scrollY/scrollHeight.
      // Both jobs now share the ONE coalesced rAF, which runs after the whole listener chain.
      function autoFrame() { autoTick(); recycleTick(); }
      function onAutoScroll(e) { if (e && window.__rovaRingScroll(e)) return; if (!pending) { pending = true; requestAnimationFrame(autoFrame); } }
      // capture:true so a scroll on ANY container (not just window) still reaches us -- except the media ring's sideways
      // track (2026-10-12): it moves no card, so the autoplay + card-recycle pass had nothing to do on every frame of it
      window.addEventListener('scroll', onAutoScroll, { passive: true, capture: true });
      window.addEventListener('resize', onAutoScroll, { passive: true });
      requestAnimationFrame(autoTick);   // kick once, in case the first page doesn't fill the screen
    }

    // #9 (web bug): the card feed appends forever, so a deep swipe piles hundreds of heavy cards
    // (avatars, embeds, action rows) into the DOM and layout/compositing bogs down -- exactly the
    // reported "swiping too deep is laggy". The .media already evicts its bitmaps off-screen
    // (content-visibility), but the CARD nodes themselves are never bounded. So VIRTUALIZE: any card
    // more than ~6 screens off either edge is swapped for an equal-height stub (its current outerHTML
    // stashed on the stub), and restored the moment it scrolls back near. Equal height = zero layout
    // shift, and an anchor re-pin corrects any rounding so the viewport never jumps. Restore re-inits
    // carousels/embeds; videos re-wire via the global MutationObserver. Whole-card content-visibility
    // isn't an option here -- its paint containment clips the open "..." menu (a past regression). */
    var _recT = 0;
    function canStub(p) {
      // never fold away a card the reader is actively using or one mid-flight to the immersive viewer
      return !p.classList.contains('menu-open') && !p.classList.contains('pf-origin') &&
             !p.querySelector('.cpanel, .comment-panel, .cedit-box');
    }
    // `h` is the height ALREADY MEASURED by recycleTick's read phase. Reading p.offsetHeight here
    // instead would be a layout read in the middle of the write phase, which re-dirties layout and
    // forces a full re-flow for the very next card -- the thrash this whole pass exists to remove.
    function stubCard(p, h) {
      h = Math.round(h || 0) || p.offsetHeight; if (!h) return null;
      if (window.__rovaReleaseVideos) { try { window.__rovaReleaseVideos(p); } catch (e) {} }
      var s = document.createElement('div');
      s.className = 'post-stub';
      s.style.height = h + 'px';
      s._html = p.outerHTML;   // current state (likes/counts live in classes+text, so they survive)
      p.parentNode.replaceChild(s, p);
      return s;
    }
    function restoreCard(s) {
      var tmp = document.createElement('div');
      tmp.innerHTML = s._html || '';
      var p = tmp.firstElementChild;
      if (!p) { return; }
      s.parentNode.replaceChild(p, s);
      try { initCarousels(p); initEmbeds(p); } catch (e) {}   // videos re-wire via the body MutationObserver
    }
    /* PERF (2026-07-29 per-frame audit). This sweep was, by a wide margin, the single most expensive
       thing on the card feed: 1704ms of a 12s sustained scroll -- 13% of the ENTIRE main thread, 45%
       of all app.js time -- measured with tools/pw/perframe.js (mobile 390x844, CPU x4).
       TWO separate faults, both fixed here:

       (1) LAYOUT THRASH. The old loop read getBoundingClientRect() and then wrote (replaceChild) in
           the SAME pass. Every write invalidates layout, so the next card's rect forced a full
           re-flow: up to N forced layouts per tick instead of one. Reads are now hoisted into their
           own phase and nothing is written until every rect is in hand.
       (2) IT RAN SYNCHRONOUSLY INSIDE THE SCROLL EVENT. See onAutoScroll: the DOM writes landed
           mid-dispatch, so the FIVE scroll listeners registered after it each hit a dirtied layout
           when they read scrollY/scrollHeight. It runs in the rAF now, after every listener.
       Plus a cheap distance gate: with a 6-screen keep-window, nothing can cross the boundary until
       the page has moved ~half a screen, so a slow scroll (and a still page) no longer sweeps at 5Hz. */
    var _recY = -1e9, _recN = -1;
    function recycleTick() {
      if (!cfg.recycle || isGrid()) return;
      var now = Date.now();
      if (now - _recT < 200) return;   // O(n) sweep -> throttle, never per-frame during a fling
      _recT = now;
      var cards = list.querySelectorAll('.post, .post-stub');
      if (cards.length < 24) return;   // small feeds cost nothing -- leave them whole
      var vh = window.innerHeight || 800;
      // Nothing added/removed AND we haven't travelled half a screen since the last sweep: no card can
      // have crossed the +/-6-screen boundary, so the whole O(n) measure would be a no-op. Skip it.
      var sy = window.scrollY || 0;
      if (cards.length === _recN && Math.abs(sy - _recY) < vh * 0.5) return;
      _recY = sy; _recN = cards.length;
      var NEAR = vh * 6;               // keep ~6 screens rendered above & below the viewport
      // ---- PHASE 1: READ. One layout flush for the whole sweep. Never write inside this loop. ----
      var n = cards.length, tops = new Array(n), bots = new Array(n), hts = new Array(n);
      var anchor = null, aTop = 0;
      for (var k = 0; k < n; k++) {
        var rr = cards[k].getBoundingClientRect();
        tops[k] = rr.top; bots[k] = rr.bottom; hts[k] = rr.height;
        // anchor on the first card touching the viewport so above-edits can't shift what you're reading
        if (!anchor && rr.bottom > 0) { anchor = cards[k]; aTop = rr.top; }
      }
      // ---- PHASE 2: WRITE. No layout reads here -- stubCard takes the measured height. ----
      var changed = false;
      for (var i = 0; i < n; i++) {
        var el = cards[i];
        var far = bots[i] < -NEAR || tops[i] > vh + NEAR;
        if (el.classList.contains('post-stub')) { if (!far) { restoreCard(el); changed = true; } }
        else if (far && canStub(el)) { if (stubCard(el, hts[i])) changed = true; }
      }
      // ---- PHASE 3: one read + one write to re-pin. ----
      if (changed && anchor && anchor.isConnected) {
        var na = anchor.getBoundingClientRect().top;
        if (na !== aTop) { window.scrollBy(0, na - aTop); _recY = window.scrollY || 0; }   // re-pin: no visible jump from above-viewport swaps
      }
    }

    // The orb + bottom pull-up. CARD feed: a REFRESH (reload fresh from the top) once auto-load has spent its
    // budget or the feed ran dry. GRID (round 107): it ADVANCES the idle content cycle -- one step through the
    // engagement-ordered roll (the same loop the 15s auto-cycle walks), via __rovaGridCycleNext below.
    // (reloadAtCap feeds only; profile keeps click-to-load.)
    function atCap() { return !!cfg.reloadAtCap && (isGrid() || wrap.hidden || (AUTO_MAX > 0 && autoLoaded >= AUTO_MAX)); }
    function refreshFeed() { location.replace(location.pathname + location.search); }  // fresh, lands at top
    function labelOrb()  {
      // GRID (owner 2026-07-14): the bottom orb is a plain PAGE REFRESH -- refresh icon, not the chevron
      // (.grid-mode swaps the SVGs in CSS). The card feed keeps its load-more chevron.
      wrap.classList.toggle('grid-mode', isGrid());
      if (isGrid()) { btn.setAttribute('aria-label', 'Refresh'); btn.setAttribute('title', 'Refresh'); }
      else { btn.setAttribute('aria-label', 'Load more posts'); btn.setAttribute('title', 'Load more'); }
    }
    labelOrb();
    /* FIRST PAINT. views/feed.php renders #feed-more hidden when $moreLikely is false, i.e. the server
       already knows this first page is also the last one -- which is the New tab's ordinary state on a
       quiet day. Nothing here ever calls load(), so applyPage's branch above can never fire, and that
       is precisely the case the owner met: a feed that ends and says nothing. Say it on the way in. */
    if (wrap.hidden) { showEnd(); }
    /* THE HOME GRID'S OWN LATCH. The grid tab is not paged by this module at all -- gridCycle() owns it
       (its own roll cursor, its own de-dup, its own buffer), and its end is `done`: three consecutive
       pages that were entirely posts already on screen, i.e. the whole roll has been seen. It stopped
       appending and said nothing, the same silence, so it hands the card to the same builder here
       rather than growing a second one. The grid's sentinel carries the copy (views/_feed_grid.php). */
    list.addEventListener('rova:rollend', function () { if (isGrid()) { showEnd(); } });
    // Card feed: a manual orb tap ALWAYS loads more (load() ignores the auto-budget, so it keeps
    // appending past the cap). It used to refreshFeed() at cap, which location.replace-reloads to the
    // TOP -- the "tap scrolls to the top instead of loading more" report. A genuinely dry page hides
    // the orb (load() sets wrap.hidden when nothing comes back), so there's nothing to reload anyway.
    btn.addEventListener('click', function () { if (isGrid()) { refreshFeed(); return; } load(false); });
    list.addEventListener('rova:paged', function () { reset(); labelOrb(); }); // tab pager fires this after swapping the list
    // Bottom PULL-UP gesture -> GRID advances the cycle (same as the orb); card feed refreshes at cap. Stand
    // down while an overlay owns the screen (esp. the .pfeed viewer: it locks the body at position:fixed, so
    // pageBottom() reads true and an up-swipe INSIDE it would otherwise kick the reader out of the media).
    function pageBottom() { return (window.innerHeight + window.scrollY) >= (document.documentElement.scrollHeight - 6); }
    function ovOpen()     { return !!(window.__rovaOverlayOpen && window.__rovaOverlayOpen()); }
    function pullArmed()  { return atCap(); }
    var _by0 = null;
    window.addEventListener('touchstart', function (e) { _by0 = (pullArmed() && pageBottom() && !ovOpen()) ? e.touches[0].clientY : null; }, { passive: true });
    window.addEventListener('touchmove', function (e) {
      if (_by0 === null) return;
      if (!pullArmed() || !pageBottom() || ovOpen()) { _by0 = null; return; }
      if (_by0 - e.touches[0].clientY > 100) {                 // pulled UP past the bottom
        _by0 = null;
        if (isGrid()) { refreshFeed(); } else { load(false); } // grid: pull-up = page refresh (same as the orb); card feed loads more
      }
    }, { passive: true });
    window.addEventListener('touchend', function () { _by0 = null; }, { passive: true });

    /* ---- BACK-NAVIGATION RESTORE (owner 2026-08-14) --------------------------------------------
       "When you're scrolling through the feed and you click on someone's profile, when you click
       back to the feed it starts the feed back at the beginning, not where you left off."

       WHY THE BROWSER CANNOT DO THIS FOR US, and why the fix is not a one-line header change.
       Every member HTML render ends with `Cache-Control: private, no-store` (lib/view.php:108, on
       top of php.ini's session.cache_limiter=nocache). A no-store main document is excluded from
       the back/forward cache by BOTH engines -- Chromium refuses outright, WebKit excludes no-store
       over HTTPS, which is the owner's iOS Safari. So Back is a full re-navigation: PHP renders
       FEED_PAGE (9) cards, pages 2..N existed only as client-side appends, and the browser's own
       scroll restoration clamps the saved offset to a document a twentieth of the height it left.
       That clamp IS "it starts the feed back at the beginning". Measured on this box against the
       live site, signed in, iPhone viewport: left the feed at y=10850 on post 42632, came back to
       y=2950 on post 42794 -- page one. Chromium shows the same fault less loudly (it retries the
       restore as content grows, so it lands deep but on the WRONG post) which is why this reads as
       an iPhone bug and reproduces everywhere.
       Relaxing the header was the other candidate and is deliberately NOT taken: no-store is what
       keeps viewer-personalised HTML out of shared caches and off disk, and it is set for every
       member page on the site, not just this one. A scroll bug does not get to widen that.

       SO RESTORE BY CONTENT, NOT BY OFFSET. On the way out we remember the post the reader was
       actually looking at (the first card still touching the top edge) and how far into it they
       were; on the way back we page the feed forward until that post id is in the DOM again and
       land on it. Restoring a pixel offset would be wrong even when it worked: discover/trending
       are RANKED and new posts arrive, so the same y is a different card an hour later. The bar is
       "same content on screen", so the anchor is the post id.

       WHAT IT DELIBERATELY LEAVES ALONE:
         - pull-to-refresh and the grid orb still land at the top: both go through refreshFeed(),
           which is a location.replace -- a fresh 'navigate', never a 'back_forward', so this never
           arms for them. Saved state near the top is dropped rather than replayed for the same
           reason (nothing to restore above 400px).
         - TAB semantics are untouched: the state carries the tab it was saved on and refuses to
           restore into a different one, and the tab pager's own "keep the reader's place" swap
           (switchTab) is a pushState soft-nav that never re-runs this file.
         - the engage hold: every page here is load(false), the MANUAL path, which is the one the
           orb and the pull-up already use -- so it is never vetoed by engaged() and never spends
           the auto-scroll budget (applyPage only charges isAuto loads).
         - guests: skipped outright. The browse gate walls them at 15 posts (app.js ~8010) and it
           counts cards as they cross 40% visibility, so replaying pages under a guest would fire
           the wall mid-restore. Guests also have a bfcache-eligible feed (EdgeCache gives them
           `public, s-maxage=60`), so they never had this bug in the first place.
         - memory: the appended cards go through the SAME virtualiser as any other scroll -- far
           cards fold back into stubs on the first recycleTick, so a restored deep feed costs what
           a scrolled one costs. Restoring the reader's place is not the same as keeping every card
           alive, and the page budget below is the second bound. */
    if (cfg.restoreKey) (function feedScrollMemory() {
      var KEY      = 'rova_pos_' + cfg.restoreKey;
      var MAX_AGE  = 30 * 60 * 1000;   // older than half an hour and "where I was" is a different feed
      var MAX_PAGES = 8;               // 8 x 30 = 240 posts; past that this was not "just scrolling"
      var MAX_MS   = 8000;             // ...and never hold the restore open longer than this
      var MIN_Y    = 400;              // near the top there is nothing worth restoring

      function safe(fn, dflt) { try { return fn(); } catch (e) { return dflt; } }
      function isGuest() { return !!document.querySelector('meta[name="rova-guest"]'); }
      function gated()   { return document.documentElement.classList.contains('guest-gated'); }
      function pageKey() { return location.pathname + location.search; }
      function digits(v) { return String(v == null ? '' : v).replace(/[^0-9]/g, ''); }

      // The card the reader is READING: the first one whose bottom has not yet passed the top edge.
      // Same rule recycleTick anchors on, so the two cannot disagree about what "on screen" means.
      function anchorNow() {
        var cards = list.querySelectorAll('.post[data-id]');
        for (var i = 0; i < cards.length; i++) {
          var r = cards[i].getBoundingClientRect();
          if (r.bottom > 0) return { el: cards[i], top: r.top };
        }
        return null;
      }

      function save() {
        if (isGrid() || isGuest()) return;
        var y = window.scrollY || 0;
        var a = y >= MIN_Y ? anchorNow() : null;
        if (!a) { safe(function () { sessionStorage.removeItem(KEY); }); return; }
        safe(function () {
          sessionStorage.setItem(KEY, JSON.stringify({
            u: pageKey(),                       // same feed URL
            t: activeHref(),                    // ...and the same TAB
            a: a.el.getAttribute('data-id'),    // the post that was on screen
            d: Math.round(a.top),               // how far into it we were
            n: items().length,
            y: Math.round(y),
            ts: Date.now()
          }));
        });
      }

      /* THREE TRIGGERS, AND ALL THREE ARE EARNED -- save() is idempotent and costs one rect walk.
         `unload` is the one deliberately NOT used: it never fires reliably on iOS Safari, and an
         unload listener is itself a bfcache disqualifier, which would be a joke in this of all
         fixes. A bare beforeunload/pagehide listener disqualifies nothing in either engine (and
         app.js already carries a beforeunload for the nav spinner).

         WHY NOT pagehide ALONE, which is the one every article names. MEASURED on this box against
         the live site, member session, real link click, feed -> /@handle: Chromium fired pagehide
         and visibilitychange; WebKit fired NEITHER and only beforeunload reached us. Shipping the
         canonical event on its own would therefore have been a fix that verified green on the
         engine that did not have the bug and did nothing on the owner's iPhone -- so all three are
         bound and whichever the engine honours is the one that saves. */
      window.addEventListener('pagehide', save);
      window.addEventListener('beforeunload', save);
      document.addEventListener('visibilitychange', function () { if (document.hidden) save(); });

      function read() {
        var st = safe(function () { return JSON.parse(sessionStorage.getItem(KEY) || 'null'); }, null);
        if (!st || !digits(st.a)) return null;
        if (st.u !== pageKey() || st.t !== activeHref()) return null;
        if (!(st.ts > 0) || Date.now() - st.ts > MAX_AGE) return null;
        return st;
      }

      // A genuine history traversal, not a fresh visit and not a refresh.
      function cameBack() {
        var nav = safe(function () { return (performance.getEntriesByType('navigation') || [])[0]; }, null);
        if (nav && nav.type) return nav.type === 'back_forward';
        return safe(function () { return performance.navigation.type === 2; }, false);   // pre-L2 engines
      }

      if (isGrid() || isGuest() || gated() || !cameBack()) return;
      var st = read();
      if (!st) return;

      /* OURS NOW. Left on 'auto' the engine keeps its own restore in play against a document that
         is still being rebuilt -- Chromium in particular re-applies it as content grows, which
         would fight the landing below halfway through. */
      safe(function () { history.scrollRestoration = 'manual'; });

      var t0 = Date.now(), pages = 0, lastN = -1;
      function found() { return list.querySelector('.post[data-id="' + digits(st.a) + '"]'); }
      function land(el) {
        window.scrollTo(0, Math.max(0, el.getBoundingClientRect().top + (window.scrollY || 0) - st.d));
      }
      /* Media ABOVE the anchor is still decoding when we land, and each image that resolves
         re-flows the column under us. Re-pin a few times rather than leaving the reader a few
         hundred px adrift; each pass is one read and one write and they stop on their own. */
      function settle(el, n) {
        land(el);
        if (n > 0) setTimeout(function () { if (el.isConnected) settle(el, n - 1); }, 250);
      }
      function giveUp() {
        /* The anchor is genuinely gone (a ranked tab reshuffled under us, or the post was deleted).
           If we rebuilt at least as much feed as there was, the saved offset is approximately the
           right place and beats the top; otherwise leave the reader at the top, which is honest. */
        if (items().length >= (st.n || 0) && st.y > 0) {
          var max = Math.max(0, (document.documentElement.scrollHeight || 0) - (window.innerHeight || 0));
          window.scrollTo(0, Math.min(st.y, max));
        }
      }
      function step() {
        var el = found();
        if (el) { settle(el, 4); return; }
        if (loading) { setTimeout(step, 60); return; }        // a page is already on the wire
        var n = items().length;
        if (Date.now() - t0 > MAX_MS || pages >= MAX_PAGES || wrap.hidden || n === lastN) { giveUp(); return; }
        lastN = n; pages++;
        load(false);
        setTimeout(step, 60);
      }
      step();
    })();
  }
  // Feed: the CARD feed opens with FEED_PAGE (9) rows, auto-loads 30 at a time (autoMax 30), then the
  // orb/bottom-swipe REFRESHES with fresh posts from the top (reloadAtCap, card feed only). The GRID (round
  // 106/107) is capped at its first page (6 rows / 18 cells, index.php): no auto-load, no append -- it idle-
  // cycles instead (below), and the orb + pull-up advance that cycle. count stays 30 for the card feed's rows.
  // restoreKey: this pager (and only this one) remembers where the reader was when they left and
  // rebuilds to it on a Back -- see feedScrollMemory above. The profile pager is deliberately not
  // enrolled: a profile grid is shallow and its cells carry no id the reader would recognise.
  // endCard: the main feed is the ONE surface that must never just stop (owner 2026-09-19). The profile
  // pager is deliberately left out of this pass -- it is a bounded, named set of somebody's own posts,
  // where running out is self-evident rather than a dead end, and it has no server copy to draw on.
  setupLoadMore({ listId: 'feed-posts', wrapId: 'feed-more', tabsId: 'feed-tabs', mode: 'before', pageSize: 10, count: 30, autoMax: 30, reloadAtCap: true, recycle: true, restoreKey: 'feed', endCard: true });
  /* PROFILE: gridAuto opts the three media tabs (grid/photos/videos) into scroll-append -- see autoOK().
     gridAutoMax is a SEPARATE ceiling from autoMax on purpose. autoMax:30 is a CARD budget: cards are
     heavy (avatars, embeds, action rows), which is why the card feed also runs the recycler. With 30-cell
     pages it also happens to mean "exactly one auto page", which is the ceiling that made this whole
     feature moot even once the veto was lifted -- one append and then nothing, on a 400-post profile.
     Grid cells are the opposite of heavy: an <img> in a 1:1 box with content-visibility:auto and a
     contain-intrinsic-size (rova.css:1130), so an off-screen cell costs almost nothing to keep. 300 is
     ten pages, ~330 tiles -- far past any realistic scroll, while still BOUNDED, because the recycler
     deliberately skips grids (recycleTick returns early on isGrid) so nothing trims this list. Past it
     the orb is still there. Not infinite: an unbounded list with no recycler behind it is how the card
     feed earned its virtualiser. */
  setupLoadMore({ listId: 'profile-posts', wrapId: 'profile-more', tabsId: 'profile-tabs', mode: 'offset', pageSize: 12, count: 30, autoMax: 30, gridAuto: true, gridAutoMax: 300 });

  /* ---- home grid: INFINITE SCROLL (round 125, was the round-107 idle cycle) --------------------------------
     The public grid now GROWS as you scroll instead of cycling a fixed 18-cell window. Nearing the bottom
     appends the next batch from the engagement-ordered roll (Posts::roll, tab=grid = author-tier then
     engagement DESC -> high first, stepping down, then loops to the top), de-duplicated against what's already
     shown; 3 dup-only pages means you've seen everything and it stops. Each appended thumbnail fires the reach
     beacon (see .pcell in SEL above), so scrolling spreads real views across everyone. The orb + bottom pull-up
     load the next batch by hand (__rovaGridCycleNext); the header Live/Paused toggle stops the AUTOMATIC append
     (manual still works). Loading is seamless now (poster thumbnails stay up, round 124) and offscreen cells
     skip paint via content-visibility (rova.css), so a long grid stays smooth. */
  /* ---- GRID AUTHOR SPACING, THE CLIENT HALF (2026-10-23, Rob: "no exceptions") ---------------------------------
     The server orders every grid page so one author never sits within GAS.W consecutive cells of themself (3 columns
     x 3 = 9: never touching, two full cells between) and no near-identical cover does either (Posts::gridSpacePage /
     rollGrid). Everything the BROWSER does to the home grid's order afterwards answers to the same rule: the idle
     cascade's swaps (the slot, the far / stub partner that takes the outgoing post, the tail park), the infinite
     scroll's append, and the hole a removed cell would close up. A move that would break the rule takes a different
     post or does not happen. The window comes from the grid itself (data-gas, the server's k/v; "0" = the rule is
     off; absent = 9). Identities: data-user and data-ph (the cover's 64-bit dHash, same <= 4 bit test as
     ImageHash::sameImage). It is LINEAR on purpose, like the server's: k cells apart = floor(k / 3) rows apart, so it
     holds whatever column a cell lands in. window.__rovaGas is shared with the logged-out landing grid. */
  var GAS = window.__rovaGas = (function () {
    var POP = [0]; for (var pi = 1; pi < 256; pi++) { POP[pi] = (pi & 1) + POP[pi >> 1]; }
    function pop(x) { return POP[x & 255] + POP[(x >>> 8) & 255] + POP[(x >>> 16) & 255] + POP[(x >>> 24) & 255]; }
    function W(g) {
      var v = g && g.getAttribute ? g.getAttribute('data-gas') : null;
      if (v === null || v === '') { return 9; }
      var n = parseInt(v, 10); return (isFinite(n) && n > 1) ? n : 0;
    }
    function id(c) {
      var u = c.getAttribute('data-user') || '', h = c.getAttribute('data-ph') || '', k = u + '|' + h;
      if (c._gasK !== k) {
        c._gasK = k;
        c._gasId = { u: (u && u !== '0') ? u : '', h: /^[0-9a-f]{16}$/i.test(h) ? [parseInt(h.slice(0, 8), 16) | 0, parseInt(h.slice(8), 16) | 0] : null };
      }
      return c._gasId;
    }
    function clash(a, b) {
      if (!a || !b) { return false; }
      if (a.u && a.u === b.u) { return true; }
      return !!(a.h && b.h && pop(a.h[0] ^ b.h[0]) + pop(a.h[1] ^ b.h[1]) <= 4);
    }
    function seq(g) {                            // the grid's cells in order (hidden tail stubs included: they show later)
      var out = [], k = g.children, n = 0;
      for (var i = 0; i < k.length; i++) { var c = k[i]; if (c.classList && c.classList.contains('pcell')) { c._gasI = n++; out.push(c); } }
      return out;
    }
    /* may `who` stand at position i of s? alt: Map cell -> [identity, ...] for a cell that may hold either of several
       posts once a wave lands (its current post AND its planned one: a swap that fails or is cancelled must not
       leave a clash behind either). skip: a cell to leave out of the test. */
    function fits(s, i, who, w, alt, skip) {
      var lo = Math.max(0, i - w + 1), hi = Math.min(s.length - 1, i + w - 1);
      for (var j = lo; j <= hi; j++) {
        if (j === i) { continue; }
        var c = s[j]; if (!c || c === skip) { continue; }
        var ids = (alt && alt.get(c)) || c._gasAlt;   // _gasAlt: a swap is pending on this cell (buildPlan): it may hold either post
        if (ids) { for (var q = 0; q < ids.length; q++) { if (clash(who, ids[q])) { return false; } } }
        else if (clash(who, id(c))) { return false; }
      }
      return true;
    }
    // would the cells either side of position i close up into a clash if s[i] left? (pairs exactly w apart become w-1)
    function gapBreaks(s, i, w) {
      for (var a = Math.max(0, i - w + 1); a < i; a++) {
        var b = a + w; if (b >= s.length) { break; }
        var A = s[a]._gasAlt || [id(s[a])], B = s[b]._gasAlt || [id(s[b])];
        for (var x = 0; x < A.length; x++) { for (var y = 0; y < B.length; y++) { if (clash(A[x], B[y])) { return true; } } }
      }
      return false;
    }
    function tailFits(g, c, w) { var s = seq(g); s.push(c); return fits(s, s.length - 1, id(c), w); }
    return { W: W, id: id, clash: clash, seq: seq, fits: fits, gapBreaks: gapBreaks, tailFits: tailFits };
  })();
  (function gridCycle() {
    var BATCH = 18, NEAR = 3;                    // append when within ~3 screens of the bottom (fling headroom)
    var inflight = false, curGrid = null, rollOff = 0, dry = 0, done = false, seen = {}, buf = null;
    function markSeen(g) { Array.prototype.forEach.call(g.querySelectorAll('.pcell[data-id]'), function (c) { var v = c.getAttribute('data-id'); if (v) seen[v] = 1; }); }
    // DELETED by this member since the cell was fetched (FEED_GONE.d, ajaxDeletePost): the buffer, the far pool and the
    // detached bench all hold cells the delete's dissolve cannot reach, and each would put the post back on screen.
    function cellGone(c) { return !!(window.__rovaPostGone && window.__rovaPostGone(c)); }
    function ovOpen() { return !!(window.__rovaOverlayOpen && window.__rovaOverlayOpen()); }
    // the header Live/Paused toggle persists its state here: when PAUSED, the AUTOMATIC append stops. The orb /
    // bottom pull-up (a manual step) still works -- it's a deliberate user action.
    function paused() { try { return localStorage.getItem('rova_feed_paused') === '1'; } catch (e) { return false; } }
    // Resolve the HOME grid live each tick (it may be swapped in later by the AJAX tab pager). A freshly-
    // appeared grid restarts the pagination and seeds `seen` with whatever's already rendered so we never
    // re-append it.
    function gridEl() {
      var g = document.getElementById('feed-grid');
      if (g && !g.classList.contains('pgrid')) g = null;
      if (g !== curGrid) {
        curGrid = g; rollOff = 0; dry = 0; done = false; seen = {}; buf = null; bench.length = 0; gasHeld = [];
        if (g) {
          /* A KEPT GRID (the tab pager's PANEL CACHE, 2026-09-29) carries where its roll had got to, so the
             next batch follows the cells the member left instead of restarting the walk at 0 (which spent
             a rung and re-served the head). data-gc-off is the offset of the NEXT page this grid has not
             inserted -- the buffered one if a buffer was waiting -- so nothing is skipped and nothing is
             re-served; data-gc-done is the three-dry-pages latch. A fresh page one carries neither: 0. */
          var so = parseInt(g.getAttribute('data-gc-off') || '', 10);
          if (isFinite(so) && so >= 0) { rollOff = so; }
          if (g.getAttribute('data-gc-done') === '1') { done = true; }
          markSeen(g); reflowTail(g); ensureBuf(null);
        }
      }
      return g;
    }
    function gcMark(g) { if (g && g === curGrid) { try { g.setAttribute('data-gc-off', String(rollOff)); if (done) { g.setAttribute('data-gc-done', '1'); } } catch (e) {} } }
    // FAST-FLING HEADROOM (2026-08-11, prefetch/cache push). NEAR=3 screens was picked for an ordinary
    // scroll's fling distance; a genuinely hard fling can cover more ground than that between one
    // ensureBuf() firing and the next tick, which is exactly the "hard fling hit the floor and stalled on
    // the network" failure the round-126 double-buffer comment above describes -- double-buffering fixed
    // the STEADY-STATE case (append() does a synchronous insert from `buf`) but the ANTICIPATORY refetch
    // that refills `buf` still only starts once nearBottom() first goes true, so the first hard fling of a
    // session (or one right after `buf` was just consumed) can still outrun it.
    // window.__rovaScrollVel (px/ms, smoothed) is computed for free by the fast-fling-calm block further
    // down this file (grid: fast-fling calm, round 126) -- piggybacked on its existing scroll/touchmove
    // listener rather than adding a second one; both IIFEs run before any scroll event can ever fire, so
    // the definition order here is harmless. Ramps NEAR from 3 screens
    // (unchanged for an ordinary scroll: below ~1.2px/ms this is a no-op, so nothing about normal browsing
    // changes) up to a capped 5 screens by ~2.8px/ms (roughly a hard thumb fling) -- wider headroom starts
    // the next batch's fetch earlier, giving the network more real time to land before `buf` is actually
    // needed. Bounded on purpose: this only moves WHEN the existing fetch starts, never how much it fetches
    // (still one BATCH=18-cell page) or how many decoders/images it touches, so it does not interact with
    // the grid's decode cap or the adaptive memory guard.
    function nearBottom() {
      var vh = window.innerHeight || document.documentElement.clientHeight || 800;
      var vel = window.__rovaScrollVel || 0;
      var near = NEAR + Math.max(0, Math.min(2, (vel - 1.2) * 1.25));
      return (document.documentElement.scrollHeight - (window.scrollY + vh)) < vh * near;
    }
    // DOUBLE-BUFFERED appends (round 126): the next batch is fetched AHEAD into `buf`, so when the scroll nears
    // the bottom the append is a synchronous DOM insert from memory -- no network wait. Profiled (Playwright
    // WebKit, hard 4s fling): the round-125 fetch-on-demand pipeline couldn't keep up, so a hard fling hit the
    // floor and stalled on the network over and over (scroll made ~6k of 13k px). Buffering removes the stall.
    /* FAILED REQUEST != END OF CONTENT (2026-07-29). `done` below is a PERMANENT latch, and it used to be
       reachable by a network failure: this fetch resolved a 5xx into html='', which produced zero cells,
       which consume() counted as a "dry" page, and three dry pages set done -- forever, for the life of
       the page. Reproduced on the live grid at 1.5Mbps/300ms RTT: exactly 3 HTTP 502s to load-more froze
       it at 153 tiles, and after full connectivity returned plus six screens of scrolling it never loaded
       another one. The asymmetry is what gave the shape away -- a DROPPED SOCKET recovered fine (153 ->
       324 tiles), because the .catch below resets `inflight` and touches nothing else; only 5xx RESPONSES
       killed it. A congested link in front of an origin near its ~150 req/s ceiling produces 5xx.
       So a failure now lands in .catch and changes NOTHING: not `buf`, not `rollOff`, not `dry`. The next
       nearBottom() re-asks for the same page. Only a 200 that genuinely came back empty may still latch
       `done`. (The old path also reset rollOff to 0 on a 502 -- cells.length < BATCH -- silently rewinding
       the roll to the top, so even a recovery would have re-served content already seen.) */
    /* A reader who stalled AT the bottom of the page cannot scroll any further, so no scroll event will
       ever re-ask -- the request has to re-arm itself. This was 2s, 4s, 8s and then STOP, which on a
       link that stays bad is a feed that quietly gives up while the reader is still sitting at the end
       of it, with nothing on screen to say so. It now rides the shared retrier (2/4/8/15/30/60s,
       jittered, one at a time, paused while the tab is hidden): the same fast burst for a blip, then a
       slow heartbeat instead of silence. See makeRetrier for why 60s and why the jitter.
       Nothing about the FAILURE SEMANTICS changes: a failure still touches neither `buf`, `rollOff`,
       `dry` nor `done`, so only a 200 that genuinely came back empty can latch the end of the roll. */
    /* ...and a COOLDOWN, because the retrier is not the only thing that asks. Measured on the live
       grid (Playwright, 1.5Mbps/300ms/CPU x4, parked at the bottom, every roll request killed): the
       idle shuffle's 1.5s setInterval calls takeOne() -> ensureBuf() on every tick, so a failing link
       produced 105 REQUESTS IN 150 SECONDS from one idle reader -- a 0.67 req/s poll per phone into an
       origin whose ceiling is ~150 req/s and which is very likely already the reason the requests are
       failing. The scroll path had the same shape (one ask per coalesced scroll frame). So: while a
       failed ask is backing off, every AUTOMATIC caller is refused and only the retrier's own turn
       goes out. A deliberate action (the orb, the bottom pull-up) clears it -- see __rovaGridCycleNext.
       Same run also found the retrier being absorbed: when the shuffle already had a request in
       flight, ensureBuf's early return called `then`, which the retrier read as SUCCESS and reset the
       ladder on -- so nothing was left armed and the grid never recovered. The retrier now hears
       "refused" for that, and re-arms. */
    var coolUntil = 0;
    var HUNGRY_SCR_S = 0.8, pagerPairs = 0;
    function hungry() {
      var vh = window.innerHeight || 800;
      return Date.now() - (window.__rovaScrollAt || 0) < 400 && (window.__rovaScrollVel || 0) * 1000 / vh >= HUNGRY_SCR_S;
    }
    window.__rovaGridPagerStats = function () { return { pairs: pagerPairs, rollOff: rollOff, buffered: buf ? buf.length : 0, done: done }; };
    var gridRetry = makeRetrier(function (settle) {
      // Nothing to ask for (roll finished, grid gone, reader not at the bottom): report success so the
      // backoff resets rather than escalating against a surface that is simply idle.
      if (done || !gridEl() || !nearBottom()) { settle(true); return; }
      // force: the retrier OWNS the schedule, so its own turn is never refused by the cooldown. It is a
      // BYPASS, not a reset -- an early version cleared coolUntil instead, and on the turns where
      // ensureBuf bounced off `inflight` that left the window open for the 1.5s shuffle tick to fire a
      // second request 0.6s behind ours (visible as doublets in the measured timeline).
      ensureBuf(function () { settle(true); if (nearBottom()) { append(false); } },
                function () { settle(false); }, true);
    });
    function armRetry() { gridRetry.arm(); }
    function ensureBuf(then, onFail, force) {
      if (buf || done) { if (then) { then(); } return; }        // content in hand, or the roll really ended
      // Someone else is already asking. Unchanged for every existing caller (`then` still runs); the
      // retrier alone is told it was refused, so it re-arms instead of scoring a success it never got.
      if (inflight) { if (onFail) { onFail(); } else if (then) { then(); } return; }
      if (!force && Date.now() < coolUntil) { if (onFail) { onFail(); } return; }
      inflight = true;
      var off = rollOff, gAt = curGrid;
      /* TWO PAGES IN FLIGHT WHEN THE READER IS OUT-SCROLLING ONE (2026-10-03, "I shouldn't have to wait for
         the tiles"). One page is 18 cells = 6 rows = ~744 px on a phone, and a member roll page measured
         ~420-480 ms at the origin before any network -- so one-page-at-a-time tops out around one phone
         screen of new cells per ~0.6 s, which is exactly a moderate 1.5-2 screens/s scroll: the buffer never
         builds, cells are appended at the last moment, and the look-ahead loader has nothing to look ahead
         AT (measured, WebKit 390 @1.75 screens/s: page-one tiles 100% painted on arrival, appended tiles
         ~0-35%, and 1.5-5.9 s pinned at the bottom). So while the reader is moving at >= HUNGRY_SCR_S, the
         page AFTER this one (off + BATCH, the server's own next offset whenever a page comes back full) is
         asked for IN PARALLEL and kept only if this page's data-rollnext says it is exactly the next page;
         otherwise (a wrap, a short page) it is dropped and nothing changes. Never at offset 0 (a member's
         offset 0 opens a new sitting, so a concurrent offset-18 read could straddle two runs), never for the
         retrier's own turn (force), and never for the idle cascade (not scrolling): the request COUNT per
         cell shown is unchanged -- the same pages, two at a time. */
      var rq = function (o) {
        return rfetch('/feed?tab=grid&partial=posts&roll=' + o + '&n=' + BATCH, {
          headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'text/html' }, credentials: 'same-origin'
        }, 8000).then(function (r) { return r.text(); });
      };
      var p2 = (!force && off > 0 && hungry()) ? rq(off + BATCH).then(null, function () { return null; }) : null;
      rq(off).then(function (html) {
        return p2 ? p2.then(function (h2) { return [html, h2]; }) : [html, null];
      }).then(function (pair) {
        var html = pair[0];
        inflight = false;
        coolUntil = 0; gridRetry.stop();                                       // the link is answering again
        var tmp = document.createElement('div'); tmp.innerHTML = (html || '').trim();
        var cells = Array.prototype.slice.call(tmp.querySelectorAll('.pcell'));   // parse: inner .pcell-* would over-count
        // The server's own next-offset, off the RAW fetch (data-rollnext). cells.length is what
        // survived Moderation::screen, so one shadowed post in a batch of 18 read as "short page ->
        // wrap" and threw the idle cycle back to the top of the grid every 15s. Same sentinel the
        // feed's ambient roll and the pfeed cascade read; the || keeps an old cached bundle working.
        var grf = tmp.querySelector('.feed-roll-flag');
        rollOff = (grf && grf.getAttribute('data-rollnext') !== null)
          ? (parseInt(grf.getAttribute('data-rollnext'), 10) || 0)
          : ((cells.length < BATCH) ? 0 : off + BATCH);             // short page -> loop the roll back to the top
        buf = cells;
        // the speculative second page (see TWO PAGES IN FLIGHT above): only if it is exactly what comes next
        if (pair[1] && rollOff === off + BATCH) {
          var tmp2 = document.createElement('div'); tmp2.innerHTML = pair[1].trim();
          var grf2 = tmp2.querySelector('.feed-roll-flag');
          if (grf2 && grf2.getAttribute('data-rollnext') !== null) {
            cells = cells.concat(Array.prototype.slice.call(tmp2.querySelectorAll('.pcell')));
            buf = cells; pagerPairs++;
            rollOff = parseInt(grf2.getAttribute('data-rollnext'), 10) || 0;
          }
        }
        // the kept-grid cursor (gridEl): while this page waits in the buffer, the next page NOT yet on the
        // grid is this one, not rollOff
        if (curGrid && curGrid === gAt) { try { curGrid.setAttribute('data-gc-off', String(off)); } catch (e) {} }
        // AHEAD OF THE ROTATION: these cells get idle-shuffled / appended in LATER. Warm the display variant
        // each one opens to NOW (low-priority, deduped, data-saver-aware) so by the time it rotates into view --
        // and a tap could land on it -- the full image is already cached. Thumbs load on their own (the eager
        // <img> starts fetching the instant its src is parsed, even detached), so this covers the tap-open gap.
        // DESKTOP ONLY (2026-07-21 choppiness audit). This was the single biggest source of full-size
        // traffic on a phone: every appended batch is 18 cells, an infinite scroll appends batch after
        // batch, and each batch fired 18 downloads-and-decodes of ~1440px display variants for cells that
        // are not even in the document yet. Measured over one 14-fling WebKit scroll it dominated the
        // page's whole network budget. These cells still get their THUMBNAIL for free (the <img> src
        // starts fetching as soon as it's parsed, even detached), and if one is ever actually tapped the
        // tap handler warms it and its neighbours right then -- which is the moment the bytes are worth
        // spending. Desktop keeps the eager behaviour; there the bandwidth is free.
        if (window.__rovaWarmMedia && !(window.matchMedia && matchMedia('(hover:none)').matches)) {
          // Wrapped, not passed by reference: forEach hands the callback (cell, INDEX, array), so
          // __rovaWarmMedia(cell, hi, fail) was reading the index as `hi` -- every cell but the first was
          // queued high-priority and jumped the queue, which is the opposite of what an ahead-of-the-
          // reader batch warm should do -- and now would read the array as the failure callback too.
          cells.forEach(function (c) { window.__rovaWarmMedia(c); });
        }
        if (then) { then(); }
      }).catch(function () {
        // 5xx, dropped socket, or our own 8s deadline -- all the same thing here: no answer. `then` is NOT
        // called (it would consume() an absent buffer and score a dry page), `buf` stays null and `rollOff`
        // stays put, so the state is exactly what it was before we asked. Then nudge, so a reader stalled
        // at the very bottom -- who has no scroll left to trigger one -- still gets a retry.
        inflight = false;
        // onFail is set only when the RETRIER is the one asking: it owns the backoff for that attempt,
        // so reporting the failure back to it is the whole re-arm. Every other caller (a scroll, the
        // orb, a tab swap) still starts the loop the same way it always did.
        if (onFail) { onFail(); } else { armRetry(); }
        // Then hold every AUTOMATIC caller off until the retrier's OWN next turn, read AFTER it has
        // armed so both use the SAME jitter draw. Drawing a second, independent one let the shorter of
        // the two expire first, and the 1.5s idle shuffle slipped an extra request into that gap --
        // measured, twice in an 80s outage.
        coolUntil = Math.max(coolUntil, gridRetry.nextAt());
      });
    }
    // Insert the buffered batch (de-duplicated against everything shown); 3 dup-only pages in a row means the
    // whole roll has been seen -> stop. CHUNKED: 6 cells per frame across 3 frames -- profiled (Playwright
    // WebKit): a fling over the fully-built grid is nearly jank-free (4 frames >25ms), while the same fling
    // with 18-cell single-frame inserts landing mid-scroll janked 15-20 frames up to 65ms. Spreading the
    // style/layout/image-kickoff over 3 frames keeps every frame under budget. Parse already happened in
    // ensureBuf (the buffer holds detached, ready cells), so this is pure insert.
    // KEEP THE LAST ROW FULL, ALWAYS (round 128, tightened round 132): the grid is 3 columns, but a batch can
    // land a non-multiple-of-3 (Moderation drops some server-side, or the de-dup below trims dupes). We always
    // INSERT every cell -- nothing is ever lost -- and HIDE the trailing 1-2 cells of an incomplete last row
    // via .gp-stub, recomputed after every insert. The remainder stays hidden even at the TRUE bottom (the old
    // reveal timer surfaced it there -- and, firing 1.1s after every insert, could flash a ragged row mid-feed
    // too; owner call: an ending row must always be 3-up). Hidden is only ever TEMPORARY: appends absorb stubs
    // into full rows as the grid grows, and the idle shuffle surfaces them FIRST when rotating posts in (see
    // takeOne), so every post still gets seen. Only a tiny grid (<3 cells total) shows what it has.
    function reflowTail(g) {
      var cs = g.getElementsByClassName('pcell');
      // only the cells whose class actually changes are written: the idle cascade calls this once per wave,
      // and a classList write on every one of ~200 cells is ~200 attribute rewrites for a no-op
      var was = Array.prototype.slice.call(g.getElementsByClassName('gp-stub'));
      var rem = (cs.length < 3) ? 0 : cs.length % 3;                 // a near-empty grid shows everything
      var keep = {};
      for (var j = cs.length - rem; j < cs.length; j++) { keep[j] = 1; if (!cs[j].classList.contains('gp-stub')) { cs[j].classList.add('gp-stub'); } }
      for (var i = 0; i < was.length; i++) {
        var idx = Array.prototype.indexOf.call(cs, was[i]);
        if (!keep[idx]) { was[i].classList.remove('gp-stub'); }
      }
    }
    /* GRID AUTHOR SPACING: an appended cell that would land too close to one of the same author's (or a look-alike
       cover) at the grid's tail WAITS (gasHeld) and takes the first later slot that fits -- the server's own greedy,
       carried across batches. Never dropped: when the roll latches shut, the waiting cells join the cascade's bench,
       which only ever places a cell where it fits. */
    var gasHeld = [];
    function consume(g) {
      var cells = buf || []; buf = null;
      if (gasHeld.length) { cells = gasHeld.concat(cells); gasHeld = []; }
      var added = 0, offered = 0, i = 0, held = [], gw = GAS.W(g), tailSeq = null;
      function fitsTail(c) {
        if (gw <= 1) { return true; }
        if (!tailSeq) { tailSeq = GAS.seq(g); }
        tailSeq.push(c); var ok = GAS.fits(tailSeq, tailSeq.length - 1, GAS.id(c), gw); tailSeq.pop();
        return ok;
      }
      function put(c) { seen[c.getAttribute('data-id')] = 1; g.appendChild(c); added++; if (tailSeq) { c._gasI = tailSeq.length; tailSeq.push(c); } }
      (function chunk() {
        if (gridEl() !== g) { return; }                             // grid swapped mid-insert: drop the rest
        tailSeq = null;                                             // the cascade may have parked onto the tail between frames
        var end = Math.min(i + 6, cells.length);
        for (; i < end; i++) {
          var c = cells[i], v = c.getAttribute('data-id');
          if (!(v && !seen[v] && !cellGone(c))) { continue; }
          offered++;
          if (!fitsTail(c)) { held.push(c); continue; }
          put(c);
          for (var h = 0; h < held.length; h++) {                   // the waiting cells, oldest first, take the first slot that fits
            var hv = held[h].getAttribute('data-id');
            if (!hv || seen[hv] || cellGone(held[h])) { held.splice(h, 1); h = -1; continue; }
            if (fitsTail(held[h])) { put(held.splice(h, 1)[0]); h = -1; }
          }
        }
        if (i < cells.length) { requestAnimationFrame(chunk); return; }
        gasHeld = held;
        if (done && gasHeld.length) {                               // nothing more is coming: the cascade places them where they fit
          for (var hb = 0; hb < gasHeld.length; hb++) { bench.push(gasHeld[hb]); }
          while (bench.length > ROLL_BENCH_CAP) { bench.shift(); }
          gasHeld = [];
        }
        if (!offered) { added = 0; } else if (!added) { added = -1; }   // a batch that only WAITED is not a dry page
        // ...and when the roll genuinely latches shut, TELL THE READER (owner 2026-09-19). `done` only
        // stops the appends; the wall then just ended, with no orb and no message -- the same silence
        // the card feed had. The card itself belongs to setupLoadMore (one builder, one set of server
        // strings), so this only announces the latch. Dispatched on the LIST, not the grid: the grid
        // element is replaced on a tab swap, the list is the pager's own element and never is.
        if (added === 0) {
          if (++dry >= 3) {
            var wasDone = done; done = true;
            if (gasHeld.length) { for (var hb2 = 0; hb2 < gasHeld.length; hb2++) { bench.push(gasHeld[hb2]); } gasHeld = []; while (bench.length > ROLL_BENCH_CAP) { bench.shift(); } }
            if (!wasDone) { try { g.parentNode.dispatchEvent(new CustomEvent('rova:rollend', { bubbles: false })); } catch (e) {} }
          }
        } else { dry = 0; }
        gcMark(g);                                                  // the kept-grid cursor: the buffer is spent, rollOff is next
        reflowTail(g);                                              // keep the last visible row full
      })();
    }
    /* GRID AUTHOR SPACING: a cell leaving the home grid (a delete, a hide, a kept panel dropping a post gone since)
       closes up the cells behind it by one. If that would bring two of one author's cells (or two look-alike covers)
       inside the window, the hole is FILLED IN PLACE instead -- with a never-shown buffered cell, a benched one, or a
       cell from the very end of the grid more than a screen below the reader (moving that one closes up only the end)
       -- that itself fits there. Returns true when it replaced `el` (the caller then does not remove it). */
    window.__rovaGasHole = function (el) {
      try {
        var g = el && el.parentNode; if (!g || g.id !== 'feed-grid') { return false; }
        var w = GAS.W(g); if (w <= 1) { return false; }
        var s = GAS.seq(g), i = el._gasI;
        if (i === undefined || s[i] !== el || !GAS.gapBreaks(s, i, w)) { return false; }   // closing up is fine
        var me = el.getAttribute('data-id'), live = (g === curGrid), k;
        var fitsHere = function (c) {
          var v = c.getAttribute('data-id');
          if (!v || v === me || cellGone(c) || g.querySelector('.pcell[data-id="' + v + '"]')) { return false; }
          return GAS.fits(s, i, GAS.id(c), w, null, el);
        };
        var take = function (c) {
          c.classList.remove('gp-stub', 'gp-swap-out', 'gp-swap-in');
          g.replaceChild(c, el); el._gasFiller = c; seen[c.getAttribute('data-id')] = 1;
          if (live) { reflowTail(g); gcMark(g); }
          return true;
        };
        if (live) {
          var pools = [buf || [], gasHeld, bench];
          for (var pz = 0; pz < pools.length; pz++) {
            var P = pools[pz];
            for (k = 0; k < P.length; k++) {
              var c = P[k]; if (pz < 2 && seen[c.getAttribute('data-id')]) { continue; }
              if (c._cascPending) { continue; }
              if (fitsHere(c)) { P.splice(k, 1); if (pz === 0 && buf && !buf.length) { buf = null; } return take(c); }
            }
          }
        }
        /* Then ANOTHER CELL OF THIS GRID moves into the hole, one that fits there and whose own place closes up cleanly.
           BELOW the hole first, furthest first, and only a cell more than a screen below the reader: everything that
           shifts (the cells after it) is below it, so nothing on screen moves. Then ABOVE the hole, furthest first, only
           a cell more than a screen above. A detached grid (a kept panel being restored) has no screen: end of grid first. */
        var vh = window.innerHeight || 800, on = !!(g.isConnected);
        var away = function (t, below) {
          if (!on || t.classList.contains('gp-stub')) { return true; }
          var r = t.getBoundingClientRect();
          return below ? r.top > vh * 2 : r.bottom < -vh;
        };
        var tryAt = function (k, below) {
          var t = s[k];
          if (!t || t === el || t._cascPending || t._cascLay || !away(t, below)) { return false; }
          if (!GAS.fits(s, i, GAS.id(t), w, null, el)) { return false; }
          var s2 = s.slice(); s2[i] = t;
          return !GAS.gapBreaks(s2, k, w);
        };
        for (k = s.length - 1; k > i + w; k--) { if (tryAt(k, true)) { return take(s[k]); } }
        for (k = 0; k < i - w; k++) { if (tryAt(k, false)) { return take(s[k]); } }
        /* Last: a cell between the hole and the reader, more than a screen above him (he scrolled past it). The cells after
           it shift by one -- exactly what closing the hole would have shifted anyway -- and the rule still holds. */
        for (k = i + w + 1; k < s.length; k++) { if (tryAt(k, false)) { return take(s[k]); } }
      } catch (e) {}
      return false;
    };
    function append(manual) {
      var g = gridEl();
      if (!g || done || document.hidden || ovOpen()) return;
      if (!manual && (paused() || engaged())) return;   // engage-hold: automatic append only; manual still loads
      if (buf) {
        consume(g);
        ensureBuf(function () { if (nearBottom()) { append(false); } });   // refill ahead; chain if still short
      } else {
        ensureBuf(function () { if (buf && (manual || nearBottom())) { append(manual); } });   // consume when it lands
      }
    }
    var pending = false;
    function onScroll(e) { if (pending || (e && window.__rovaRingScroll(e))) return; pending = true; requestAnimationFrame(function () { pending = false; if (nearBottom()) append(false); }); }
    window.addEventListener('scroll', onScroll, { passive: true, capture: true });   // capture: catch scroll on any container (not the ring's sideways track)
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll();                                  // kick once (the first page may not fill the screen)
    // orb / bottom pull-up -> load the next batch. A DELIBERATE tap is not an automatic poll: it clears
    // the failure cooldown and restarts the ladder, so someone who taps during an outage is answered now.
    window.__rovaGridCycleNext = function () { coolUntil = 0; gridRetry.stop(); append(true); };
    // The link came back: forget the backoff and ask again if we're sitting at the bottom. `done` is not
    // cleared here on purpose -- by the time we get here it can only have been set by a real, successful,
    // empty page, which coming back online does not change.
    onReconnect(function () { gridRetry.stop(); if (nearBottom()) { append(false); } });

    /* ---- IDLE CASCADE (2026-09-02). Owner: "the feed loads 1 new post at a time when idle but I want more
       of a cascading looking feed -- this needs to look fire when they all change every couple of seconds."
       Replaces the round-128/131 idle shuffle (one LRU cell every 1.5s). While the reader is IDLE on the
       grid, every ROLL_CASCADE_MS a WAVE turns every ROW that is on screen, top to bottom, and swaps every
       one of their cells for a different post. Nothing off screen is ever animated.

       A ROW TURNS WHOLE OR NOT AT ALL, AND THE WAVE COMMITS TOGETHER (2026-09-08, ported from the iOS
       cascade's platform-neutral spec; every item there is something the app got wrong first and fixed by
       measurement). Three changes, in the order they matter:
         1. THE PLAN IS ROW-ATOMIC. buildPlan gives every cell of a row a decoded candidate or rolls the whole
            row back; a row is never turned in part. Rob rejected part-turned rows harder than anything else
            on iOS ("wasn't cascading from top to bottom, looked stuck and poorly coded" was six rows with
            five different column patterns). A SKIPPED row only reads as a shorter wave. Measured here before
            the change: 295 rows over 59 waves, 70 whole, 191 PART-turned, 34 skipped.
         2. COMMIT TOGETHER, SHOW IN ORDER. The old wave staggered the COMMIT by ROLL_STAGGER_MS, so the row
            the eye lands on first had the least head start on loading. Now every pair commits inside a few
            frames (ROLL_CASCADE_CONCURRENT per frame) and a SEPARATE BARRIER walks down the screen deciding
            how far the wave may APPEAR: it opens a row, waits for that row's pictures to actually be up (or
            ROLL_ROW_CEIL_MS, so one slow item delays the sweep rather than stopping it), then opens the next
            AT ONCE (ROLL_ROW_MIN_MS 0 -- the shipped iOS build has no minimum row step either, whatever its
            spec text says; set it to 150 to put the ~150 ms-per-row floor back). Sweep well under a second.
         3. DWELL. A clip that is actually playing gets a protected watch of ROLL_WATCH_MIN_MS..MAX_MS,
            jittered per post id (a flat number synchronises the churn it exists to prevent). Dwell may never
            hold a row in part: the row planner frees a row's watch holds -- longest-watched first -- to turn
            it whole, or skips the row entirely.
       The opening wave is its own case (see openingReady): it waits, with a ceiling, until the seed clips are
       playing and enough off-screen posts are decoded, and spends the wait warming.

       WHERE THE POSTS COME FROM, in order, and why the request rate does not move. A full cascade wants
       ~20 posts every 2.5s; the server hands out at most Posts::ROLL_MAX (18) per request, and the old
       shuffle spent one request per ~27s of idle (18 cells at 1 per 1.5s). Feeding a cascade from fresh
       fetches alone would be ~12x that rate per idle phone, into an origin with a ~150 req/s ceiling. So:
         1. FRESH cells off the same prefetch buffer the infinite scroll uses (`buf`, 18 per request), but
            metered at exactly the OLD rate -- a credit accrues every ROLL_FRESH_EVERY_MS, one batch banked
            at most -- so the roll endpoint sees the SAME requests per idle minute it saw before this.
         2. THE GRID'S OWN FAR CELLS. The page ships 150 cells and a phone shows ~20; everything more than a
            viewport away is a pool nobody is looking at. A visible cell and a far cell EXCHANGE places (same
            size, so no layout moves anywhere, and every post stays reachable by scrolling) -- never-shown
            cells first, drawn UNIFORMLY AT RANDOM among them (2026-09-05; it was farthest-first, which on a
            chronological page one is a sweep by date -- the "loading posts in order" the owner saw).
         3. THE BENCH, in random order within its soft tier, when the grid is capped or has no room below.
       Two hard rules and one soft one (owner, 2026-09-02: "a full-looking cascade beats strict no-repeat"):
       no post is on screen twice at once; nothing swapped out in the PREVIOUS cascade comes straight back;
       and beyond that the pool prefers cells not shown within the last ROLL_RECENT_WINDOW swaps but WILL
       reach back further (random within the tier) rather than leave a cell un-swapped. Repeats fade as the
       corpus grows because fresh cells keep arriving at the metered rate and the pool keeps growing.
       The fresh supply itself is trend-first and shuffled server-side (Posts::rollGrid, 2026-09-05).

       THE SWAP IS A CROSSFADE IN PLACE, AND THE CELL IS A SLOT (rebuilt 2026-09-04; owner's 60fps recording:
       "too much flicker during the grid cascade"). The first build moved the outgoing <img> over the incoming
       CELL as a ghost and exchanged the cell NODES mid-wave: a fresh <img> + ghost + transform pop = three new
       compositor layers per cell in the middle of an animation, the ghost going home 400ms later re-rasterised
       the cell a second time, and a far cell's own <img> still had to decode into its new layer at commit. The
       recording measured it: per-frame change ALTERNATING big / near-zero (paints landing every other frame),
       5 of 18 cells changing 2-3 times per wave, and single-frame hard cuts of 41-76. The RN port measured the
       same family (a view mounted at swap time missed a frame in 9 of 15 cells). So now:
         - NOTHING IS CREATED, MOVED OR REMOVED IN A VISIBLE CELL DURING A WAVE. Every on-screen cell carries
           ONE persistent overlay (overlayOf: a span with an <img> and the two badge shapes, opacity 0,
           will-change set once in CSS and never toggled), built between waves, kept for the life of the cell.
         - A swap = the overlay <img> takes the incoming URL (a cache hit: warmAhead decoded that exact URL),
           its decode() is awaited, two frames are painted at opacity 0, then ONE CSS transition takes the
           overlay 0 -> 1 (ROLL_SWAP_MS). One layer, one property. The outgoing picture's Ken Burns pan is
           paused under it (.gp-casc-hold) so nothing else composites.
         - On transitionend, UNDER the opaque overlay: the slot and its partner exchange IDENTITY --
           transferIdentity() swaps every attribute of the cell and of its primary <img>, the nsfw-cell class,
           the badge children and the cascade's own bookkeeping -- and the slot's own <img> loads the same URL
           (cache hit again; awaited, then decode()d). The slot's pan is re-armed from scale 1 (.gp-casc-new)
           so the picture under the overlay is pixel-identical to the overlay, then the overlay drops to 0 with
           NO transition. Consumers keyed on the element (the video governor, the reach dwell, the media warm,
           the guest gate) are told through window.__rovaGridCellRewire so they re-observe the slot as if a
           new cell had arrived. The partner cell never moves either: a far cell simply holds the old post
           where it stands; a fresh / benched partner is parked to the tail or bench off screen, unseen.
         - A cell fades EXACTLY once per wave (_cascPending until the overlay has dropped, _swapAt stamped on
           BOTH cells). Simultaneity is bounded by the ROW BARRIER rather than by a global count: one row's
           three cells fade together, and rows overlap only while a 300 ms fade outlives the 150 ms step.
       COST. Opacity only, on one persistent layer per on-screen cell (~20 on a phone), one layout read per
       cascade (the rect pass below, no writes interleaved) plus one forced style flush per settled cell for
       the pan re-arm, and the Ken Burns COUNT budget is untouched: a slot keeps its own centre-band
       observation, so at most the band's ~6 cells pan, whatever the cascade did.
       Videos: an outgoing cell hands its clip back through the governor's own release AND has every
       <video> inside it enumerated and torn down, whatever class it carries (the 2026-09-01 ghost lesson);
       incoming video cells are wired by the governor's MutationObserver and start only under its cap.
       Under prefers-reduced-motion the cycle is ROLL_RM_MULT slower, only ROLL_RM_FRAC of the cells turn,
       and the CSS is an opacity-only crossfade.

       THE IMAGE LOADER IS A STACK (2026-09-08): ROLL_WARM_MAX concurrent, LIFO (the newest ask is the cell
       somebody is looking at), the queue capped at ROLL_WARM_QUEUE_CAP with the OLDEST dropped -- and A
       DROPPED ASK STILL ANSWERS, on a short retry, because a request that is silently forgotten leaves a cell
       "not ready" forever with nothing scheduled to ask again, which is the black square.
       CLIP PRE-WARM WITH HEADROOM: the idle gap also warms the NEXT wave's clips, two at a time, as detached
       <video preload="metadata"> (a header fetch -- no decoder is claimed, so it can never evict a playing
       tile), and only while the video governor has ROLL_VWARM_SPARE slots free. buildPlan's picker PREFERS a
       candidate whose clip is already warm, otherwise the warming would be a coincidence.

       NO BLANK TILES (owner, 2026-09-02: "I'd rather it not show blank squares -- the media should be preloaded").
       A cell never swaps until its incoming image is DECODED: warmAhead() decodes the next cascade's worth of
       candidates during the idle gap (new Image() + decode(), the exact grid-variant URL the cell renders, at
       most ROLL_WARM_MAX in flight, a ROLL_WARM_TIMEOUT per image, nothing on save-data / 2g, paused while the
       tab is hidden or the reader moves); buildPlan() takes only ready() cells and would rather leave a cell
       as it is than turn it blank; and the swap itself keeps the OLD image on screen until the new one has
       loaded into the overlay AND painted under it -- so even a decode-cache miss cannot flash the background,
       and a picture that fails to load leaves the cell exactly as it was and blacklists that post for the
       session. The app must do the same (preload, then commit).
       GATING. Only when idle for IDLE_AFTER (no pointer/touch/key/wheel AND no scroll), tab visible, no
       overlay, not paused, no engagement/attention hold. Every step of the wave re-checks: ANY interaction
       stops the cascade at the next step (cells already fading finish their own swap, nothing new starts)
       and the idle clock restarts. A cell under the pointer (:hover/:active) is never picked.
       window.__rovaGridCascadeStats() reports the last plan for harnesses. */
    var ROLL_CASCADE_MS     = 2500;   // one cascade per cycle of idle (feed-speed gear scales it: cycleMs())
    var ROLL_STAGGER_MS     = 70;     // HISTORICAL (2026-09-08): the wave no longer staggers its commits. Rows land
                                      // ROLL_ROW_STEP_MS apart under the reveal barrier; this is kept only in the stats block
    var ROLL_CASCADE_FRAC   = 1.0;    // share of on-screen cells swapped per cascade (0.6 is one edit away if it reads as chaos)
    var ROLL_WAVE           = 'rows'; // FIXED at 'rows' since 2026-09-08: the unit of a wave is a ROW, so 'diag'/'ripple'
                                      // (which turn a row's three cells at three different times) are exactly the part-turned row
    var ROLL_SWAP_MS        = 300;    // one cell's crossfade: the incoming picture fades IN over the old one (rova.css .gp-casc-ov.on, .3s -- change both together)
    var ROLL_CASCADE_CONCURRENT = 6;  // commits STARTED per frame (2026-09-08: was a cap on simultaneous fades; the wave now commits
                                      // together and the ROW BARRIER decides what may appear, so this only paces the commit burst)
    var ROLL_ROW_STEP_MS    = 150;    // NOMINAL row step: still computed and still REPORTED (lastPlan.stagger, the instrument's
                                      // per-wave `stagger`) but at ROLL_ROW_MIN_MS 0 it SCHEDULES NOTHING -- see ROLL_ROW_MIN_MS
    var ROLL_ROW_MIN_MS     = 0;      // THE SWITCH (2026-09-08, second pass). Minimum ms between one row opening and the next.
                                      // 0 = the barrier advances the INSTANT a row has actually presented, which is what the iOS
                                      // build Rob approved actually does: its spec says "rows land ~150 ms apart", its own
                                      // measurement says row 0 -> row 5 in ~115 ms and its `stagger` value "is still computed and
                                      // still reported but schedules nothing". Rob's ask was that the web FEEL like the phone, not
                                      // like the document, so the floor is gone here too. **SET THIS TO 150 TO RESTORE THE SLOWER,
                                      // MORE LEGIBLE SWEEP** -- one edit, nothing else changes (the value is still compressed to
                                      // fit the cycle on a tall grid, exactly as before). Do NOT "fix" the 0 back: it is the point.
    var ROLL_ROW_CEIL_MS    = 260;    // ...and one row may hold the barrier no longer than this: a slow item DELAYS the sweep, never stops it
    var ROLL_WATCH_MIN_MS   = 12000;  // a clip that is actually PLAYING gets a protected watch of this ...
    var ROLL_WATCH_MAX_MS   = 18000;  // ... to this, JITTERED PER POST ID (a flat number synchronises the churn dwell exists to prevent)
    var ROLL_WARM_QUEUE_CAP = 60;     // decode asks waiting at once; the OLDEST is dropped, and a dropped ask still ANSWERS
    var ROLL_WARM_DROP_RETRY_MS = 1500;   // a drop is queue pressure, not a broken picture: retryable almost immediately
    var ROLL_PICK_LOOKAHEAD = 8;      // pool entries scanned for a candidate whose CLIP is already warm before settling for any decoded one
    var ROLL_VWARM_MAX      = 2;      // clip pre-warms in flight (small passes, several per cycle)
    var ROLL_VWARM_AHEAD    = 6;      // clips queued for pre-warm per idle gap
    var ROLL_VWARM_SPARE    = 3;      // HEADROOM: never warm into the last N slots of the video governor's budget
    var ROLL_OPEN_PRECACHE_MS = 12000;// the OPENING wave waits this long for enough decoded pictures ...
    var ROLL_OPEN_PLAY_MS   = 20000;  // ... and this long for the seed clips to actually be playing. Then it goes anyway.
    var ROLL_SETTLE_MAX_MS  = 1500;   // after the fade, how long a slot may wait for its own <img> to complete (a cache hit: normally 0) before the swap is abandoned
    var ROLL_WARM_AHEAD     = 14;     // decode this many candidates beyond the on-screen count before the next cascade (2026-09-08: was 6 --
                                      // a wave that must turn EVERY row needs a standing surplus of decoded candidates, not just enough for the median wave)
    var ROLL_WARM_MAX       = 6;      // image decodes in flight at once
    var ROLL_WARM_TIMEOUT   = 4000;   // a decode slower than this is marked not-ready (skipped, retried later)
    var ROLL_WARM_RETRY_MS  = 15000;  // ...retried no sooner than this
    var ROLL_VIS_MIN        = 0.6;    // a cell at least this visible is "on screen" and swappable
    var ROLL_FAR_SCREENS    = 1;      // a cell more than this many viewports outside the screen is pool
    var ROLL_RECENT_WINDOW  = 60;     // SOFT: prefer pool cells not shown within the last N swaps
    var ROLL_FRESH_EVERY_MS = 1500;   // fresh server cells are consumed at the OLD shuffle's rate (1 per 1.5s)
    var ROLL_FRESH_BURST    = 18;     // ...with at most one batch of credit banked
    var ROLL_GRID_CAP       = 360;    // outgoing cells re-park below the fold until the grid holds this many; then bench
    var ROLL_BENCH_CAP      = 90;     // detached swapped-out cells kept for rotation (oldest dropped)
    var ROLL_DWELL_MS       = 600;    // a cell that just arrived is left alone this long (must stay well under the cycle,
                                      // or the tail of one wave is excluded from the next; _cascPending covers in-flight cells)
    /* NETWORK TIERS (owner, 2026-09-02: "gated to Wi-Fi or slowed on cellular"). Measured on the cache-on phone
       rig the full cascade pulls ~6 MB/min of thumbnails while idle (mostly far cells being seen for the first
       time -- it decays towards the ~1 MB/min of fresh posts as the pool is exhausted), so on a metered link it
       is throttled by cadence and by how much of the screen turns, and on an explicitly frugal link it is off.
         full      Wi-Fi / ethernet / unknown (Safari has no navigator.connection): the cascade as tuned above.
         cellular  connection.type === 'cellular', or an effectiveType that is not '4g' (3g): cycle x
                   ROLL_NET_CELL_MULT, ROLL_NET_CELL_FRAC of the cells per cascade, warm-ahead sized to match.
         off       saveData, or effectiveType slow-2g / 2g: no cascade, no warming, nothing.
       Re-read on every tick and on connection 'change', so a phone leaving Wi-Fi slows down on the next cycle.
       The app mirrors these three tiers with NetInfo (see the parity spec). */
    var ROLL_NET_CELL_MULT  = 3;      // cellular: cycle x3 (15 s at Normal, 24 s at Slow -- composes with SPEED_MULT) ...
    var ROLL_NET_CELL_FRAC  = 0.5;    // ...and half the on-screen cells per cascade
    var ROLL_RM_MULT        = 3;      // prefers-reduced-motion: cycle x3 ...
    var ROLL_RM_FRAC        = 0.34;   // ...and about a third of the visible cells per cascade
    var SPEED_MULT = { slow: 3.2, normal: 2.0, fast: 1.4, faster: 1.0 };   // the feed gear (rova_feed_speed): 8.0 / 5.0 / 3.5 / 2.5 s per wave
                                      // (owner, 2026-09-04: "timeline feed speed is too fast, make each level slower" -- was 1.6/1/.8/.6, i.e.
                                      // 4.0/2.5/2.0/1.5 s; the new Faster equals the old Normal. The stagger below does NOT stretch with the
                                      // cycle -- it is pinned at ROLL_SWAP_MS/ROLL_CASCADE_CONCURRENT = 75 ms -- so a wave still sweeps in
                                      // ~1.4 s and the extra time is DWELL between waves. Slow x cellular (or reduced-motion) = 24 s.)

    var lastAct = Date.now();
    function act() { lastAct = Date.now(); }
    ['pointerdown', 'pointermove', 'keydown', 'wheel', 'touchstart'].forEach(function (ev) {
      window.addEventListener(ev, act, { passive: true, capture: true });
    });
    /* IDLE BEFORE THE FIRST SWAP (owner, 2026-09-18: "the feed/grid awaits 2.5 seconds before auto polls new
       posts -- we need to double that time, I need more time to see or read the post first"). Two clocks, both
       reset by the reader and both matching the app's new values (grid cascade idle 3 -> 6 s, plus its 7 s
       scroll-quiet): IDLE_AFTER is hands-off (no pointer / touch / key / wheel), IDLE_SCROLL_AFTER is since the
       last scroll event. The CADENCE between waves (ROLL_CASCADE_MS x SPEED_MULT, the gear) is deliberately NOT
       doubled -- it is the reader's own speed setting and must keep meaning what the panel says. The mid-wave
       abort (any interaction stops the cascade at the next step) is likewise untouched: a longer abort gate would
       make the grid LESS responsive, not more. */
    var IDLE_AFTER        = 5000;                // hands off this long -> ambient mode (3000 -> 6000 on 09-18 -> 5000 on 09-29: the owner's 5 s fold, iOS 529)
    var IDLE_SCROLL_AFTER = 5000;                // ...and no scroll event for this long (7000 -> 5000 on 09-29, same fold)
    function idle() { var now = Date.now(); return (now - lastAct > IDLE_AFTER) && (now - (window.__rovaScrollAt || 0) > IDLE_SCROLL_AFTER); }
    var bench = [];                              // swapped-out, detached cells, oldest first
    function reduced() { return !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches); }
    // NO-PREF DEFAULT = NORMAL (2026-09-18). This returned 1 (= the "Faster" rung, 2.5 s) when rova_feed_speed was unset,
    // while the gear panel paints "Normal" as selected and the card feed's no-pref REVEAL_MS is Normal (4400, fixed
    // 2026-09-04). So an untouched grid ran at the fastest rung the panel never showed -- the literal "2.5 seconds".
    // The ladder is unchanged; an unset member simply gets the rung the panel says. Revert = `|| 1` / `return 1`.
    function speedMult() { try { var s = localStorage.getItem('rova_feed_speed'); return (s && SPEED_MULT[s]) || SPEED_MULT.normal; } catch (e) { return SPEED_MULT.normal; } }
    function netTier() {
      var c = navigator.connection; if (!c) return 'full';                      // no API (Safari): full, bounded by the warm cap + timeout
      var et = String(c.effectiveType || '');
      if (c.saveData || et === 'slow-2g' || et === '2g') return 'off';
      if (c.type === 'cellular' || (et && et !== '4g')) return 'cellular';
      return 'full';
    }
    function fracNow() { var f = ROLL_CASCADE_FRAC; if (reduced()) { f = Math.min(f, ROLL_RM_FRAC); } if (netTier() === 'cellular') { f = Math.min(f, ROLL_NET_CELL_FRAC); } return f; }
    function cycleMs() { return Math.round(ROLL_CASCADE_MS * speedMult() * (reduced() ? ROLL_RM_MULT : 1) * (netTier() === 'cellular' ? ROLL_NET_CELL_MULT : 1)); }
    function allowed() {
      var g = gridEl();
      if (!g || document.hidden || ovOpen() || paused() || engaged() || engAttn() || !idle()) return null;   // engage-hold / attention hold: same gates the shuffle had
      if (netTier() === 'off') return null;                                     // save-data / 2g: nothing at all
      if (document.documentElement.classList.contains('guest-gated')) return null;   // the guest browse gate covers the grid: nobody can see a swap
      return g;
    }

    // fresh-cell credit: accrues at the old shuffle's consumption rate, one batch banked at most
    var freshCredit = ROLL_FRESH_BURST, creditAt = Date.now();
    function accrue() { var now = Date.now(); freshCredit = Math.min(ROLL_FRESH_BURST, freshCredit + (now - creditAt) / ROLL_FRESH_EVERY_MS); creditAt = now; }
    function takeFresh() {
      if (freshCredit < 1) return null;
      if (!buf) { if (!done) { ensureBuf(null); } return null; }
      var unseen = 0;
      for (var k = 0; k < buf.length; k++) {
        var c = buf[k], v = c.getAttribute('data-id');
        if (!v || seen[v] || broken[v] || cellGone(c)) continue;
        unseen++;
        if (!ready(c)) continue;                     // not decoded yet: warmAhead has it, take it next wave
        buf.splice(k, 1); if (!buf.length) { buf = null; }
        seen[v] = 1; dry = 0; freshCredit -= 1; if (!buf && !done) { ensureBuf(null); }
        return c;
      }
      if (!unseen) {                                 // the whole batch was already on the page: a dry page
        buf = null;
        if (++dry >= 3) { done = true; } else { ensureBuf(null); }
      }
      return null;
    }
    // the governor's own release first (it owns `live` and the poster backdrop), then EVERY <video> in the
    // cell whatever it is classed -- a clip the class selector cannot see is exactly the ghost that leaked
    function teardownVideos(cell) {
      try { clearTimeout(cell._grT); } catch (e) {}
      if (window.__rovaGridReleaseCell) { try { window.__rovaGridReleaseCell(cell); } catch (e) {} }
      var vs = cell.querySelectorAll('video');
      for (var i = 0; i < vs.length; i++) {
        var v = vs[i];
        if (v._hls) { try { v._hls.destroy(); } catch (e) {} v._hls = null; v._hlsWired = 0; }
        try { v.pause(); v.removeAttribute('src'); v.load(); } catch (e) {}
        if (v.parentNode) { v.parentNode.removeChild(v); }
      }
    }
    // ---- the slot machinery (2026-09-04): a visible cell is a SLOT that changes POST, never a node that moves ----
    var MULTI_SVG = '<svg viewBox="0 0 24 24" width="17" height="17" aria-hidden="true"><path d="M12 3h6a3 3 0 0 1 3 3v6" fill="none" stroke="#fff" stroke-width="1.7" stroke-linecap="round" opacity=".85"/><path d="M8 6h7a2.6 2.6 0 0 1 2.6 2.6v7" fill="none" stroke="#fff" stroke-width="1.7" stroke-linecap="round"/><rect x="3.4" y="9" width="12" height="12" rx="2.6" fill="#fff"/></svg>';
    function primaryImg(cell) {                  // the cell's own picture (the overlay's <img> is never it)
      var ims = cell.getElementsByTagName('img');
      for (var i = 0; i < ims.length; i++) { if (!ims[i].classList.contains('gp-casc-ovi')) return ims[i]; }
      return null;
    }
    // ONE persistent crossfade layer per cell, built BETWEEN waves (the tick that plans a wave builds any the
    // on-screen cells lack, at least two painted frames before the first fade starts) and never rebuilt: the
    // <img> that will show the incoming picture, plus the two badge shapes a cell can carry, all at opacity 0.
    // will-change lives in the CSS rule and is never toggled -- toggling it is itself a layer create/destroy.
    function overlayOf(cell) {
      if (cell._ov) return cell._ov;
      var ov = document.createElement('span'), im = document.createElement('img');
      ov.className = 'gp-casc-ov'; ov.setAttribute('aria-hidden', 'true');
      im.className = 'gp-casc-ovi'; im.alt = ''; im.draggable = false;
      im.setAttribute('data-gobs', '1');         // the shimmer scan must not adopt it as the cell's picture
      try { im.decoding = 'sync'; } catch (e) {}
      ov.appendChild(im);
      var bv = document.createElement('span'); bv.className = 'pcell-badge gp-ovb-v'; bv.textContent = '▶'; ov.appendChild(bv);
      var bm = document.createElement('span'); bm.className = 'pcell-badge pcell-multi gp-ovb-m'; bm.innerHTML = MULTI_SVG; ov.appendChild(bm);
      /* ...and the AI provenance ribbon (db/0175). It is a THIRD permanent shape for the same
         reason the other two are permanent: the overlay is built between waves and never rebuilt,
         so a badge created at swap time would be a node created while the picture is moving --
         the one thing this cascade is designed never to do. Its TEXT is copied off the incoming
         cell at swap time rather than hard-coded, because the label is localized on the server
         and this file has no catalog. Hidden by CSS until .ov-ai says otherwise. */
      var ba = document.createElement('span'); ba.className = 'ai-rib gp-ovb-a'; ov.appendChild(ba);
      cell.appendChild(ov); cell._ov = ov; ov._img = im; ov._ai = ba;
      return ov;
    }
    function ensureOverlays(vis) { for (var i = 0; i < vis.length; i++) { overlayOf(vis[i].c); } }
    // IDENTITY TRANSFER. Everything that says WHICH POST a cell is travels between the two cells; everything
    // that says WHICH ELEMENT it is (observed-by flags, kb-near, gp-stub, the shimmer class, the overlay, the
    // hover bubble, a governor <video>) stays put. Attributes: all of the cell's and all of its primary <img>'s
    // (href, data-id/-view/-user/-txt/-lk/-cm/-vw/-me/-slides, src/data-gsrc, data-full/-fit/-photo-*/
    // -video-src/-g3/-g6, class of the img (pcell-video)...), minus the element-state ones named in *_KEEP.
    // The cell's class attribute is NOT swapped wholesale (it carries slot state); only nsfw-cell crosses.
    var CELL_KEEP = { 'class': 1, 'style': 1 }, IMG_KEEP = { 'data-gobs': 1, 'style': 1 };
    var XFER = ['_warmImg', '_warmUrl', '_warmFail', '_warmRetryAt', '_vwUrl', '_outSeq', '_outCasc'];   // the cascade's own per-POST bookkeeping
    function swapAttrs(a, b, keep) {
      var i, n, am = {}, bm = {}, names = {};
      for (i = 0; i < a.attributes.length; i++) { n = a.attributes[i].name; if (!keep[n]) { am[n] = a.attributes[i].value; names[n] = 1; } }
      for (i = 0; i < b.attributes.length; i++) { n = b.attributes[i].name; if (!keep[n]) { bm[n] = b.attributes[i].value; names[n] = 1; } }
      for (n in names) {
        if (n in bm) { a.setAttribute(n, bm[n]); } else { a.removeAttribute(n); }
        if (n in am) { b.setAttribute(n, am[n]); } else { b.removeAttribute(n); }
      }
    }
    function moveKids(a, b) {                    // the post's own badges / fills change homes; overlay, <video>, hover bubble never do
      /* `ai-rib` (db/0175) is picked up here with the badges and the fills, and it has to be: the
         AI mark belongs to the POST, so it must travel with the identity transfer or it is left
         behind on whatever picture lands in this cell next -- i.e. a real member's photograph
         wearing somebody else's "made with AI" chip. It is deliberately NOT classed `pcell-badge`,
         because the ov-vid toggle in commit() reads `.pcell-badge:not(.pcell-multi)` to decide
         whether the incoming post is a VIDEO, and a ribbon matching that selector would light the
         play glyph on every marked photo. */
      function pick(c) { var out = [], k = c.children; for (var i = 0; i < k.length; i++) { if (k[i].classList.contains('pcell-badge') || k[i].classList.contains('pcell-fill') || k[i].classList.contains('ai-rib')) { out.push(k[i]); } } return out; }
      var ka = pick(a), kb = pick(b), i;
      for (i = 0; i < ka.length; i++) { b.insertBefore(ka[i], b._ov || null); }
      for (i = 0; i < kb.length; i++) { a.insertBefore(kb[i], a._ov || null); }
    }
    function transferIdentity(slot, partner) {
      swapAttrs(slot, partner, CELL_KEEP);
      var sn = slot.classList.contains('nsfw-cell'), pn = partner.classList.contains('nsfw-cell');
      slot.classList.toggle('nsfw-cell', pn); partner.classList.toggle('nsfw-cell', sn);
      var si = primaryImg(slot), pi = primaryImg(partner);
      if (si && pi) { swapAttrs(si, pi, IMG_KEEP); }
      moveKids(slot, partner);
      for (var i = 0; i < XFER.length; i++) { var k = XFER[i], t = slot[k]; slot[k] = partner[k]; partner[k] = t; }
    }
    // the consumers that observe CELLS (video governor, reach dwell, media warm, guest gate) each registered a
    // re-observe here: to them a slot that changed post must look exactly like a cell that just arrived
    function rewire(slot, wasId) {
      var hs = window.__rovaGridCellRewire || [];
      for (var i = 0; i < hs.length; i++) { try { hs[i](slot, wasId); } catch (e) {} }
    }
    // a pair that will not happen (bail, cancel, failure): both cells free again; a FRESH cell goes back to
    // the buffer with its credit unless the picture itself is what failed (then it is blacklisted, not retried)
    function unmark(p, dead) {
      p.old._cascPending = 0; p.inc._cascPending = 0; p.old._gasAlt = null; p.inc._gasAlt = null;
      if (p.src === 'fresh') {
        var id = p.inc.getAttribute('data-id');
        if (dead) { if (id) { seen[id] = 1; } freshCredit += 1; }
        else { (buf || (buf = [])).unshift(p.inc); if (id) { delete seen[id]; } freshCredit += 1; }
      }
    }

    // ---- warm-ahead: an incoming cell is usable only once its picture is decoded ----
    function cellMediaUrl(cell) { var im = cell.querySelector('img'); return im ? (im.getAttribute('src') || im.getAttribute('data-gsrc') || '') : ''; }
    function ready(cell) { var im = cell._warmImg; return !!(im && im.complete && im.naturalWidth > 0 && cell._warmUrl === cellMediaUrl(cell)); }
    function saveData() { return netTier() === 'off'; }
    /* THE IMAGE LOADER IS A STACK, NOT A QUEUE, AND IT IS BOUNDED (2026-09-08, from the iOS spec).
       Three properties, each of which was a measured defect over there:
         * LIFO. The newest ask is the cell that just arrived and is the one somebody is looking at; a queue
           makes the squares on screen wait behind a backlog nobody wants any more.
         * BOUNDED, oldest dropped. Unbounded concurrent fetches do not go faster, they FAIL.
         * A DROPPED ASK STILL ANSWERS. Silently forgetting it is the black square: the cell would sit
           "not ready" forever with nothing scheduled to ask again. A drop answers the same way a network
           error does, on a short retry (it is queue pressure, not a broken picture). */
    var warmQ = [], warmN = 0, warmStats = { started: 0, ok: 0, failed: 0, timedOut: 0, dropped: 0, answered: 0, qMax: 0 };
    function warmRetryOk(cell) { return !cell._warmRetryAt || Date.now() >= cell._warmRetryAt; }
    function warmAnswer(cell, why) {                 // the ONE place a warm ends unhappily, drops included
      cell._warmImg = null; cell._warmFail = Date.now();
      cell._warmRetryAt = Date.now() + (why === 'dropped' ? ROLL_WARM_DROP_RETRY_MS : ROLL_WARM_RETRY_MS);
      if (why === 'timeout') { warmStats.timedOut++; } else if (why === 'dropped') { warmStats.dropped++; warmStats.answered++; instDrop({ t: Date.now(), id: cell.getAttribute('data-id') || '', why: 'queue-cap', answered: 1, retryInMs: ROLL_WARM_DROP_RETRY_MS }); }
      else { warmStats.failed++; }
    }
    function warmPush(cell) {
      if (!cell || cell._warmBusy || ready(cell)) { return; }
      var i = warmQ.indexOf(cell); if (i >= 0) { warmQ.splice(i, 1); }
      warmQ.push(cell);                              // newest ask on TOP
      if (warmQ.length > warmStats.qMax) { warmStats.qMax = warmQ.length; }   // how close the bound ever comes to biting
      while (warmQ.length > ROLL_WARM_QUEUE_CAP) { warmAnswer(warmQ.shift(), 'dropped'); }
    }
    function warmPump() {
      while (warmN < ROLL_WARM_MAX && warmQ.length) {
        if (document.hidden || !idle() || saveData()) return;   // the same gates as the cascade: the stack simply waits
        var cell = warmQ.pop();                      // LIFO
        if (cell._warmBusy || ready(cell)) continue;
        if (!warmRetryOk(cell)) continue;
        var url = cellMediaUrl(cell); if (!url) continue;
        warmOne(cell, url);
      }
    }
    function warmOne(cell, url) {
      warmN++; cell._warmBusy = 1; warmStats.started++;
      var im = new Image(), settled = false, t = null;
      function done(ok, why) {
        if (settled) return; settled = true; warmN--; cell._warmBusy = 0; clearTimeout(t);
        if (ok && im.naturalWidth > 0) { cell._warmImg = im; cell._warmUrl = url; cell._warmFail = 0; cell._warmRetryAt = 0; warmStats.ok++; }
        else { warmAnswer(cell, why || 'fail'); }
        warmPump();
      }
      t = setTimeout(function () { done(false, 'timeout'); }, ROLL_WARM_TIMEOUT);
      try { im.decoding = 'async'; } catch (e) {}
      if (im.decode) { im.src = url; im.decode().then(function () { done(true); }, function () { done(false, 'fail'); }); }
      else { im.onload = function () { done(true); }; im.onerror = function () { done(false, 'fail'); }; im.src = url; }
    }
    // queue the next cascade's worth of candidates, in the order buildPlan will want them. The stack is NOT
    // wiped between waves any more: wiping it threw away every ask that had not started yet, which is why the
    // decode pipeline only ever produced about half a wave's worth of ready candidates per cycle.
    function warmAhead(g, sv) {
      if (saveData()) return;
      sv = sv || survey(g); if (!sv) return;
      ensureOverlays(sv.allVis);                 // the next wave's slots get their layer now, a whole cycle before they fade
      var want = sv.allVis.length + ROLL_WARM_AHEAD, list = [], i;   // a wave must cover EVERY row, so size to the whole screen plus a surplus
      if (buf) { for (i = 0; i < buf.length && list.length < want; i++) { var bid = buf[i].getAttribute('data-id'); if (bid && !seen[bid]) { list.push(buf[i]); } } }
      for (i = 0; i < sv.stubs.length && list.length < want; i++) { list.push(sv.stubs[i]); }
      for (i = 0; i < sv.farNew.length && list.length < want; i++) { list.push(sv.farNew[i].c); }
      for (i = 0; i < sv.older.length && list.length < want; i++) { list.push(sv.older[i]); }
      for (i = list.length - 1; i >= 0; i--) { warmPush(list[i]); }   // pushed in REVERSE so the most-wanted ends up on top of the stack
      warmPump();
      vwAhead(list);
    }
    /* ---- CLIP PRE-WARM, WITH HEADROOM (2026-09-08, iOS spec item 5's second half) -------------------------
       The web does not pool <video> elements -- the grid's governor BUILDS one per cell under a decoder
       budget (CAP_TOUCH 10 / CAP_DESKTOP 12) and evicts by distance. So the transferable half of the app's
       finding is the budget one: warming more clips than the SPARE slots evicts the clips that are playing.
       Here a warm is a DETACHED <video preload="metadata"> -- it primes the connection, the container and the
       moov atom, and it is never appended to the document, so it claims no decoder, cannot be counted in the
       governor's `live` and CANNOT evict a playing tile. It still refuses to run unless the governor has
       ROLL_VWARM_SPARE slots free, because that is the invariant the app measured, and because a device
       already at its ceiling should be spending its bandwidth on the clips it is showing.
       Two at a time, several passes per cycle, and buildPlan's picker PREFERS a post whose clip is warm --
       otherwise the warming is a coincidence. */
    var vwQ = [], vwN = 0, vwStats = { started: 0, ok: 0, failed: 0, headroomHold: 0 };
    function clipUrl(cell) { var h = cell.querySelector('img.pcell-video[data-video-src]'); return h ? (h.getAttribute('data-video-src') || '') : ''; }
    function clipWarm(cell) { var u = clipUrl(cell); return !u || cell._vwUrl === u; }   // a photo is trivially "warm"
    function vwHeadroom() {
      var st = null; try { st = window.__rovaGridCapStats && window.__rovaGridCapStats(); } catch (e) {}
      if (!st) { return 1; }
      return st.cap - st.live - ROLL_VWARM_SPARE;
    }
    function vwPump() {
      while (vwN < ROLL_VWARM_MAX && vwQ.length) {
        if (document.hidden || !idle() || netTier() !== 'full') { return; }
        if (vwHeadroom() <= 0) { vwStats.headroomHold++; return; }
        var cell = vwQ.pop(); if (!cell || cell._vwBusy || clipWarm(cell)) { continue; }
        vwOne(cell, clipUrl(cell));
      }
    }
    function vwOne(cell, url) {
      vwN++; cell._vwBusy = 1; vwStats.started++;
      var v = document.createElement('video'), settled = false, t = null;
      function done(ok) {
        if (settled) return; settled = true; vwN--; cell._vwBusy = 0; clearTimeout(t);
        if (ok) { cell._vwUrl = url; vwStats.ok++; } else { vwStats.failed++; }
        try { v.removeAttribute('src'); v.load(); } catch (e) {}
        vwPump();
      }
      t = setTimeout(function () { done(false); }, 6000);
      v.muted = true; v.defaultMuted = true; v.playsInline = true;
      v.preload = 'metadata';                    // HEADER ONLY: no decoder is claimed, so this can never evict a playing clip
      v.addEventListener('loadedmetadata', function () { done(true); }, { once: true });
      v.addEventListener('error', function () { done(false); }, { once: true });
      v.src = url;
    }
    function vwAhead(list) {
      if (netTier() !== 'full') { return; }
      var picked = 0, i;
      for (i = 0; i < list.length && picked < ROLL_VWARM_AHEAD; i++) {
        var c = list[i]; if (!clipUrl(c) || clipWarm(c) || c._vwBusy) { continue; }
        var k = vwQ.indexOf(c); if (k >= 0) { vwQ.splice(k, 1); }
        vwQ.push(c); picked++;
        while (vwQ.length > 30) { vwQ.shift(); }
      }
      vwPump();
    }

    /* ---- DWELL (2026-09-08) -----------------------------------------------------------------------------
       A clip that is actually PLAYING gets a protected watch of 12-18 s, JITTERED PER POST ID: a flat number
       expires on every tile at once and synchronises the exact churn the protection exists to prevent.
       But dwell may NEVER hold a row in part. The row planner below either frees a row's watch holds --
       longest-watched first, they have had the most of their watch -- and turns the row WHOLE, or it skips
       the row entirely. It never turns a row in part.
       (The watch clock starts the first time the cascade OBSERVES the clip playing, which is once per cycle,
       so it under-counts by up to one cycle. That direction is safe: it can only shorten a protection.) */
    function hash32(str) { var h = 2166136261, i; for (i = 0; i < str.length; i++) { h ^= str.charCodeAt(i); h = (h * 16777619) >>> 0; } return h >>> 0; }
    function watchMs(cell) {
      var id = cell.getAttribute('data-id') || '';
      var span = Math.max(1, ROLL_WATCH_MAX_MS - ROLL_WATCH_MIN_MS);
      return ROLL_WATCH_MIN_MS + (hash32(id) % span);
    }
    function playingClip(cell) {
      var v = cell.querySelector('video');
      return (v && !v.paused && v.readyState >= 2 && (v.currentTime || 0) > 0.02) ? v : null;
    }
    function watchedFor(cell) {                  // ms this slot's clip has been watched, or -1 if nothing is playing
      if (!playingClip(cell)) { cell._watchAt = 0; return -1; }
      if (!cell._watchAt) { cell._watchAt = Date.now(); }
      return Date.now() - cell._watchAt;
    }
    function dwellHeld(cell, now) {
      if ((cell._swapAt || 0) > now - ROLL_DWELL_MS) { return 'settling'; }   // HARD: a cell that just settled never turns again in the same breath
      var w = watchedFor(cell);
      if (w >= 0 && w < watchMs(cell)) { return 'watch'; }                    // SOFT: waivable to complete a row
      return '';
    }
    function rkey(c) { if (c._rk === undefined) { c._rk = Math.random(); } return c._rk; }   // a cell's draw order in the pool (see survey)
    var swapSeq = 0, cascN = 0, casc = null;     // casc = the wave in flight {n, pairs, i, t}
    var lastPlan = { at: 0, visible: 0, planned: 0, swapped: 0, fresh: 0, far: 0, bench: 0, stubs: 0, cancelled: false };
    function survey(g) {
      var vh = window.innerHeight || 800, now = Date.now();
      var farTop = -vh * ROLL_FAR_SCREENS, farBot = vh * (1 + ROLL_FAR_SCREENS);
      var cs = g.querySelectorAll('.pcell'), vis = [], allVis = [], farNew = [], farOld = [], stubs = [], onScreen = {}, last = null;
      var prevCasc = cascN - 1, i, c, r;
      for (i = 0; i < cs.length; i++) {         // ONE layout read, no writes interleaved
        c = cs[i];
        if (c.classList.contains('gp-stub')) { stubs.push(c); continue; }
        last = c;
        r = c.getBoundingClientRect();
        if (r.width < 4 || r.height < 4) continue;
        var f = (Math.min(r.bottom, vh) - Math.max(r.top, 0)) / r.height;
        if (f > 0) { var oid = c.getAttribute('data-id'); if (oid) { onScreen[oid] = 1; } }
        if (f >= ROLL_VIS_MIN) {
          /* allVis is EVERY on-screen cell, carrying the REASON a cell is not swappable. The plan below can
             only pick from `vis`, but "was this row turned whole?" is a question about the whole row, so the
             instrument (and, from 2026-09-08, the row planner) needs the cells the filters removed too. */
          var sk = '';
          if (c._cascPending || c._cascLay) { sk = 'fading'; }                 // mid-fade: never twice
          else if (!primaryImg(c)) { sk = 'nopic'; }   // a cell with no picture of its own (a still-transcoding tile) is not a slot
          else if (c.matches && (c.matches(':hover') || c.matches(':active'))) { sk = 'hover'; }
          else { sk = dwellHeld(c, now); }             // '' | 'settling' (hard) | 'watch' (waivable to complete a row)
          allVis.push({ c: c, r: r, skip: sk });
          if (sk) continue;
          vis.push({ c: c, r: r });
        } else if (r.bottom < farTop || r.top > farBot) {
          if (c._cascPending) continue;
          if (c._outSeq === undefined) { farNew.push({ c: c, d: r.top > vh ? r.top - vh : -r.bottom }); }
          else if (c._outCasc !== prevCasc) { farOld.push(c); }
        }
      }
      if (!allVis.length) return null;
      /* RANDOM, NOT A SWEEP (owner 2026-09-05: "the grid cascade is loading posts in order"). The far pool is
         page one, which is CHRONOLOGICAL, and "farthest first" walked it by date -- with fresh roll cells metered
         at ~3 per wave, ~80% of every wave was that walk. Now every never-shown far cell is drawn UNIFORMLY at
         random (rkey: one random key per cell, re-rolled when the cell changes post), and the shown pool keeps
         only its SOFT partition (not swapped within ROLL_RECENT_WINDOW first, as a fallback tier) and is random
         inside each tier. The key is per CELL and stable between the wave-end warmAhead() and the next tick's
         buildPlan(), so the pictures decoded ahead are exactly the ones the plan will take. */
      farNew.sort(function (a, b) { return rkey(a.c) - rkey(b.c); });
      var older = farOld.slice();
      for (i = 0; i < bench.length; i++) {
        var bc = bench[i], bid = bc.getAttribute('data-id');
        if (bc._outCasc === prevCasc || cellGone(bc) || (bid && (onScreen[bid] || g.querySelector('.pcell[data-id="' + bid + '"]')))) continue;
        older.push(bc);
      }
      older.sort(function (a, b) {
        var ra = (swapSeq - a._outSeq < ROLL_RECENT_WINDOW) ? 1 : 0, rb = (swapSeq - b._outSeq < ROLL_RECENT_WINDOW) ? 1 : 0;
        return ra !== rb ? ra - rb : rkey(a) - rkey(b);
      });
      // where an outgoing cell goes when its replacement did NOT come out of the grid: below the fold if
      // the grid already runs past the screen and is under the cap, otherwise the bench
      var tailFar = !!(last && last.getBoundingClientRect().top > vh + allVis[0].r.width && cs.length < ROLL_GRID_CAP);
      return { vis: vis, allVis: allVis, stubs: stubs, farNew: farNew, older: older, onScreen: onScreen, tailFar: tailFar, now: now };
    }
    /* ---- THE PLAN IS BUILT A ROW AT A TIME, AND A ROW TURNS WHOLE OR NOT AT ALL (2026-09-08) ------------
       This replaces a per-CELL fill that stopped as soon as the decoded supply ran out ("swap what can be
       covered"). Measured on the live grid before the change: of 295 rows across 59 waves, only 70 turned
       whole -- 191 turned in PART and 34 were skipped. A part-turned row is the single thing Rob rejected
       hardest on iOS ("wasn't cascading from top to bottom, looked stuck and poorly coded" was six rows with
       five different column patterns). A skipped row only reads as a shorter wave.
       So: rows are formed from the rects, and each row is either given a decoded candidate for EVERY one of
       its cells -- with dwell waived if that is what completes it -- or it is rolled back entirely and the
       candidates go back in the pool for the row below. Nothing is marked until the whole row is certain. */
    function buildPlan(g, sv) {
      sv = sv || survey(g); if (!sv) return null;
      var av = sv.allVis, stubs = sv.stubs, farNew = sv.farNew, older = sv.older, onScreen = sv.onScreen, tailFar = sv.tailFar, now = sv.now, i, j;
      if (!av.length) return null;
      // rows and columns off the rects (cells are 1:1 squares of one width)
      var minT = Infinity, minL = Infinity, cw = av[0].r.width || 1;
      for (i = 0; i < av.length; i++) { minT = Math.min(minT, av[i].r.top); minL = Math.min(minL, av[i].r.left); }
      var rows = {}, rowIdx = [];
      for (i = 0; i < av.length; i++) {
        var e = av[i];
        e.row = Math.round((e.r.top - minT) / cw); e.col = Math.round((e.r.left - minL) / cw);
        if (!rows[e.row]) { rows[e.row] = []; rowIdx.push(e.row); }
        rows[e.row].push(e);
      }
      rowIdx.sort(function (a, b) { return a - b; });
      for (i = 0; i < rowIdx.length; i++) { rows[rowIdx[i]].sort(function (a, b) { return a.col - b.col; }); }
      // the pool, in preference order: hidden tail stubs, never-shown far cells (random among them), then
      // shown cells -- far or benched -- not shown within the soft window first, random within each tier.
      // ONLY DECODED cells are taken (ready()); one that is not yet decoded is simply left where it is
      /* ONE pass over the pool, not one per cell. The row planner cannot consume the pool as it goes (it has
         to be able to roll a row back), so every ineligible entry would otherwise be re-tested -- with its
         ready() querySelector -- once per cell of every row. Screen the whole pool here instead: after this
         line `pool` holds only candidates that are decoded, unmarked, not already on screen and not broken. */
      var raw = stubs.slice();
      for (i = 0; i < farNew.length; i++) { raw.push(farNew[i].c); }
      raw = raw.concat(older);
      var pool = [];
      for (i = 0; i < raw.length; i++) {
        var rc = raw[i], rid = rc.getAttribute('data-id');
        if (rid && (onScreen[rid] || broken[rid])) continue;    // never two of one post on screen; never a post whose picture failed
        if (cellGone(rc)) continue;                             // deleted while it sat in the pool
        if (rc._cascPending || rc._cascLay) continue;           // already part of a fade
        if (!ready(rc)) continue;                               // not decoded yet: leave it for a later wave
        pool.push(rc);
      }
      accrue();
      /* WHICH ROWS turn. At the full tier that is all of them. The reduced-motion and cellular tiers turn a
         FRACTION -- and that fraction is now counted in ROWS, never in cells, so a throttled tier still never
         produces a part-turned row. Least-recently-turned rows go first, and a row holding a protected watch
         is deprioritised (that is where dwell actually earns its keep). */
      var frac = fracNow(), turn = rowIdx.slice();
      function rowAge(rr) { var l = rows[rr], m = Infinity; for (var k = 0; k < l.length; k++) { m = Math.min(m, l[k].c._swapAt || 0); } return m; }
      function rowHeld(rr) { var l = rows[rr], k, h = 0; for (k = 0; k < l.length; k++) { if (l[k].skip === 'watch') { h++; } } return h; }
      if (frac < 1) {
        var nrow = Math.max(1, Math.round(rowIdx.length * frac));
        turn = rowIdx.slice().sort(function (a, b) {
          var ha = rowHeld(a), hb = rowHeld(b);
          if (ha !== hb) { return ha - hb; }
          return rowAge(a) - rowAge(b);
        }).slice(0, nrow).sort(function (a, b) { return a - b; });
      }
      var used = {}, pairs = [], fresh = 0, far = 0, ben = 0, st = 0, skippedRows = [], freedWatch = 0;
      function takeCandidate() {
        var f = takeFresh(); if (f) { return { c: f, src: 'fresh' }; }
        /* PREFER A POST WHOSE CLIP IS ALREADY WARM (iOS spec item 5). A bounded look-ahead, not a sort:
           sorting warm-first would push every cold VIDEO behind every PHOTO and quietly change the media mix.
           Scan a window of the pool for a decoded candidate that is also clip-warm; take the first merely
           decoded one otherwise. */
        var scanned = 0, fallbackIx = -1, k;
        for (k = 0; k < pool.length && scanned < ROLL_PICK_LOOKAHEAD; k++) {
          var cand = pool[k], cid = cand.getAttribute('data-id');
          if (cid && used[cid]) continue;        // the pool was screened once above; only `used` grows during the wave
          scanned++;
          if (fallbackIx < 0) { fallbackIx = k; }
          if (clipWarm(cand)) { fallbackIx = k; break; }
        }
        if (fallbackIx < 0) { return null; }
        var inc = pool.splice(fallbackIx, 1)[0];
        return { c: inc, src: (inc.parentNode === g) ? (inc.classList.contains('gp-stub') ? 'stub' : 'far') : 'bench' };
      }
      function giveBack(taken) {                 // roll the row back: nothing was marked, nothing is consumed
        for (var k = taken.length - 1; k >= 0; k--) {
          var t = taken[k], id = t.c.getAttribute('data-id');
          if (id) { delete used[id]; }
          if (t.src === 'fresh') { (buf || (buf = [])).unshift(t.c); if (id) { delete seen[id]; } freshCredit += 1; }
          else { pool.unshift(t.c); }
        }
      }
      /* THREE INDEPENDENT DECISIONS, IN THIS ORDER. Doing them together is what broke the 09-05 ordering fix.
         (a) which rows COULD turn -- every one of their cells free. A 'watch' hold is waivable (dwell may
             never hold a row in PART, so a row that is otherwise ready frees its holds, longest-watched
             first); 'fading' / 'settling' / 'hover' / 'nopic' are not.
         (b) how many WHOLE rows the decoded supply covers. Candidates for the entire wave are drawn FIRST,
             then rows are kept top-down while the supply lasts and the surplus goes straight back. A row is
             never given a partial set.
         (c) WHICH post goes to WHICH slot -- a RANDOM permutation ACROSS THE WHOLE WAVE, not within a row.
             The fresh (roll) supply is metered at ~1.7 posts per wave and is materially OLDER than the
             far-cell exchange, so drawing per row put the old posts in the top rows and the new ones at the
             bottom: measured per-wave Spearman(position, created_at) +0.43 mean / +0.66 median, i.e. the
             2026-09-05 "the grid cascade is loading posts in order" report, straight back. Shuffled across
             the wave it is +0.0. */
      var eligible = [];
      for (j = 0; j < turn.length; j++) {
        var rr = turn[j], cells = rows[rr], okRow = true, holders = [];
        for (i = 0; i < cells.length; i++) {
          var sk2 = cells[i].skip;
          if (sk2 === 'watch') { holders.push(cells[i]); }
          else if (sk2) { okRow = false; break; }
        }
        if (okRow) { eligible.push({ row: rr, cells: cells, holders: holders }); }
        else { skippedRows.push(rr); }
      }
      var wantCells = 0;
      for (j = 0; j < eligible.length; j++) { wantCells += eligible[j].cells.length; }
      var taken = [];
      for (i = 0; i < wantCells; i++) {
        var got2 = takeCandidate(); if (!got2) break;
        var gid = got2.c.getAttribute('data-id'); if (gid) { used[gid] = 1; }
        taken.push(got2);
      }
      var keep = [], acc = 0;
      for (j = 0; j < eligible.length; j++) {
        if (acc + eligible[j].cells.length > taken.length) { break; }   // supply ran out: the rest of the wave is simply shorter
        acc += eligible[j].cells.length; keep.push(eligible[j]);
      }
      for (j = keep.length; j < eligible.length; j++) { skippedRows.push(eligible[j].row); }
      var surplus = taken.splice(acc);             // kept in hand (not given back yet): the spacing rule may need the choice
      for (i = taken.length - 1; i > 0; i--) { var q = Math.floor(Math.random() * (i + 1)); var tt = taken[i]; taken[i] = taken[q]; taken[q] = tt; }
      /* GRID AUTHOR SPACING (2026-10-23, Rob: "no exceptions"). The random permutation above is now a PREFERENCE
         order: each slot, top to bottom, takes the first candidate in hand that FITS -- its post clashes with nothing
         within the window around the slot, counting every swapped neighbour as BOTH its current and its planned post
         (a swap that fails or is cancelled must not leave a clash behind) -- and whose partner, if it is a far or stub
         cell that keeps its place, can take the OUTGOING post where it stands. Nothing in hand fits: up to
         GAS_PULL more are drawn from the pool. Still nothing: the row does not turn (a row turns whole or not at
         all), its picks go back in hand for the rows below. Whatever no slot took goes straight back, unmarked. */
      var GAS_PULL = 12, gw = GAS.W(g), gs = gw > 1 ? GAS.seq(g) : null, galt = gw > 1 ? new Map() : null, gasRows = 0, gasPulled = 0;
      var hand = taken.concat(surplus);
      function gasOk(slot, t) {
        if (!gs) { return true; }
        var c = t.c;
        if (!GAS.fits(gs, slot._gasI, GAS.id(c), gw, galt)) { return false; }
        if (c.parentNode === g && gs[c._gasI] === c && !GAS.fits(gs, c._gasI, GAS.id(slot), gw, galt, slot)) { return false; }
        return true;
      }
      for (j = 0; j < keep.length; j++) {
        var e2 = keep[j], rowPick = [], rowOk = true, setKeys = [];
        for (i = 0; i < e2.cells.length; i++) {
          var slot2 = e2.cells[i].c, pk = null, hk;
          for (hk = 0; hk < hand.length; hk++) { if (gasOk(slot2, hand[hk])) { pk = hand.splice(hk, 1)[0]; break; } }
          for (var dr = 0; !pk && gs && dr < GAS_PULL; dr++) {
            var more = takeCandidate(); if (!more) { break; }
            var mid = more.c.getAttribute('data-id'); if (mid) { used[mid] = 1; }
            gasPulled++;
            if (gasOk(slot2, more)) { pk = more; } else { hand.push(more); }
          }
          if (!pk) { rowOk = false; break; }
          rowPick.push(pk);
          if (gs) {
            galt.set(slot2, [GAS.id(slot2), GAS.id(pk.c)]); setKeys.push(slot2);
            if (pk.c.parentNode === g && gs[pk.c._gasI] === pk.c) { galt.set(pk.c, [GAS.id(pk.c), GAS.id(slot2)]); setKeys.push(pk.c); }
          }
        }
        if (!rowOk) {
          for (i = 0; i < setKeys.length; i++) { galt.delete(setKeys[i]); }
          for (i = rowPick.length - 1; i >= 0; i--) { hand.unshift(rowPick[i]); }
          skippedRows.push(e2.row); gasRows++;
          continue;
        }
        e2.holders.sort(function (a, b) { return watchedFor(b.c) - watchedFor(a.c); });
        freedWatch += e2.holders.length;
        for (i = 0; i < e2.cells.length; i++) {
          var slot3 = e2.cells[i].c, pick = rowPick[i], inc2 = pick.c, src2 = pick.src;
          inc2._cascPending = 1; slot3._cascPending = 1; slot3._watchAt = 0;
          if (src2 === 'fresh') { fresh++; } else if (src2 === 'bench') { ben++; } else if (src2 === 'stub') { st++; } else { far++; }
          pairs.push({ old: slot3, inc: inc2, src: src2, park: tailFar ? 'tail' : 'bench', key: e2.row * 64 + e2.cells[i].col, row: e2.row, col: e2.cells[i].col });
          // the wave is in flight for a while: every other mover (append, tail park, hole fill) must see both possible posts here
          slot3._gasAlt = [GAS.id(slot3), GAS.id(inc2)];
          if (inc2.parentNode === g) { inc2._gasAlt = [GAS.id(inc2), GAS.id(slot3)]; }
        }
      }
      giveBack(hand);                              // never marked: straight back to the buffer / pool
      pairs.sort(function (a, b) { return a.key - b.key; });   // the wave sweeps top to bottom, columns left to right
      var order2 = [];                           // for harnesses: the wave as planned (incoming id, row, col)
      for (i = 0; i < pairs.length; i++) { order2.push([pairs[i].inc.getAttribute('data-id'), pairs[i].row, pairs[i].col]); }
      lastPlan = { at: now, visible: av.length, planned: pairs.length, swapped: 0, fresh: fresh, far: far, bench: ben, stubs: st, cancelled: false,
                   wave: 'rows', cycleMs: cycleMs(), order: order2, rows: rowIdx.length, rowsTurned: turn.length - skippedRows.length,
                   rowsSkipped: skippedRows.length, watchFreed: freedWatch, gasRowsSkipped: gasRows, gasPulled: gasPulled, gasW: gw, warm: { queued: warmQ.length, inFlight: warmN } };
      instPlan(sv, pairs);
      return pairs;
    }
    var fading = 0, broken = {};                 // fades in flight (capped); post ids whose picture failed to load -- never picked again this session
    /* ONE SWAP, FRAME BY FRAME (p.old is the SLOT on screen, p.inc the PARTNER holding the incoming post):
         F0   commit: the slot's persistent overlay <img> takes the incoming URL (cache hit -- warmAhead decoded
              it); its badge shape / nsfw blur are switched at opacity 0. The partner's own <img> gets its src
              back (a far cell may have been unloaded) so it is complete long before it is needed.
         F0+  decode() resolves -> the slot's pan is paused (.gp-casc-hold) -> two rAFs (two painted frames with
              the overlay at 0: the layer is uploaded on a frame nobody sees) -> .on: opacity 0 -> 1 in
              ROLL_SWAP_MS. Nothing else in the cell changes for the whole fade.
         end  transitionend (timer fallback for a hidden tab): UNDER the opaque overlay, the slot's clip is torn
              down, slot and partner exchange identity, the slot's own <img> holds the new URL (awaited to
              complete, then decode()d), its pan is re-armed from scale 1, the observers are told, the partner
              is parked. Two more painted frames of the new picture under the overlay...
         lift ...then .on comes off: opacity 1 -> 0 with NO transition, onto an identical frame. Next frame the
              overlay <img> is emptied (invisible at 0) so it holds no bitmap between swaps.
       Failure at any point leaves the slot showing exactly what it showed. */
    function commit(p, g) {
      var slot = p.old, inc = p.inc, ov = slot._ov, pim = primaryImg(slot);
      if (slot.parentNode !== g || gridEl() !== g || !ready(inc) || !ov || !pim || slot._cascLay) { unmark(p); return; }   // bail BEFORE touching anything
      var url = cellMediaUrl(inc), iid = inc.getAttribute('data-id') || '', oi = ov._img;
      if (window.__rovaGridRestoreCell) { window.__rovaGridRestoreCell(inc); }
      ov.classList.toggle('nsfw', inc.classList.contains('nsfw-cell'));
      ov.classList.toggle('ov-vid', !!inc.querySelector('.pcell-badge:not(.pcell-multi)'));
      ov.classList.toggle('ov-multi', !!inc.querySelector('.pcell-badge.pcell-multi'));
      /* the AI mark crosses the fade too (db/0175). Copied off the incoming cell rather than
         rebuilt, so the localized label and the full aria-label/title come from the server's
         markup and this file needs no catalog of its own. */
      var incRib = inc.querySelector('.ai-rib');
      if (ov._ai) {
        ov._ai.className = 'ai-rib gp-ovb-a' + (incRib && incRib.classList.contains('ai-rib-edit') ? ' ai-rib-edit' : '');
        ov._ai.innerHTML = incRib ? incRib.innerHTML : '';
      }
      ov.classList.toggle('ov-ai', !!incRib);
      slot._cascLay = p; p.at = Date.now(); p.phase = 'load'; p.fb = 0; fading++;
      if (INST) { p.rec = { row: p.row, col: p.col, id: iid, wave: p.casc, step: p.step, cT: p.at - ((INST.curWave && INST.curWave.t0) || p.at), armMs: -1, liftMs: -1, ok: 0 }; if (INST.curWave) { INST.curWave.swaps.push(p.rec); } }
      var t = setTimeout(function () { fail('timeout'); }, ROLL_WARM_TIMEOUT);
      function fail(why) {                     // the overlay never rose: the slot is untouched, the post is out for the session
        if (p.phase !== 'load') return; p.phase = 'dead'; clearTimeout(t);
        ov.classList.remove('on', 'ov-vid', 'ov-multi', 'ov-ai', 'nsfw'); oi.removeAttribute('src');
        slot._cascLay = null; fading--;
        if (iid) { broken[iid] = 1; }
        inc._warmImg = null; inc._warmFail = Date.now(); warmStats.failed++;
        lastPlan.failed = (lastPlan.failed || 0) + 1; lastPlan.failWhy = why;
        p.fb = 2; if (INST) { if (p.rec) { p.rec.fail = why; } instFail({ wave: p.casc, step: p.step, row: p.row, col: p.col, id: iid, why: why, ms: Date.now() - p.at }); }
        unmark(p, true);
        cancelRow(p, 'sibling-failed');         // a row turns WHOLE or not at all: take the rest of it back
      }
      function start() {
        if (p.phase !== 'load') return; clearTimeout(t);
        if (oi.naturalWidth <= 0) { fail('empty'); return; }
        p.phase = 'fade'; p.decMs = Date.now() - p.at;
        /* THE DECODE IS DONE; WHETHER IT MAY BE SEEN IS THE BARRIER'S CALL. Commit and reveal are two
           different clocks (iOS spec item 1): every row starts loading at once so no row is handicapped by
           its position, and a SEPARATE barrier walks down the screen deciding how far the wave may appear.
           A row whose pictures arrive early simply waits its turn. */
        p.doArm = function () {
          if (p.phase !== 'fade' || p.armed) { return; } p.armed = 1;
          slot.classList.add('gp-casc-hold');
          var on = function () {
            if (p.phase === 'fade' && !ov.classList.contains('on')) {
              ov.classList.add('on'); p.shown = 1;
              if (p.rec && p.rec.armMs < 0) { p.rec.armMs = Date.now() - p.at; }
              rowCheck();                        // this row may now be complete: the barrier can move on
            }
          };
          requestAnimationFrame(function () { requestAnimationFrame(on); });
          p.armT = setTimeout(on, 120);          // a hidden tab has no rAF: the fade still starts
          var onEnd = function (e) { if (e && e.target !== ov) return; ov.removeEventListener('transitionend', onEnd); clearTimeout(p.endT); settle(p, g); };
          ov.addEventListener('transitionend', onEnd);
          p.endT = setTimeout(function () { ov.removeEventListener('transitionend', onEnd); settle(p, g); }, ROLL_SWAP_MS + 250);   // ...and still settles
        };
        if (p.gate) { p.doArm(); } else { rowCheck(); }
      }
      oi.src = url;
      if (oi.decode) { oi.decode().then(start, function () { fail('decode'); }); }
      else { oi.onload = start; oi.onerror = function () { fail('error'); }; }
    }
    function settle(p, g) {
      var slot = p.old, inc = p.inc, ov = slot._ov, oi = ov._img;
      if (p.phase !== 'fade') return; p.phase = 'settle';
      clearTimeout(p.armT);
      var lifted = false;
      function lift() {                         // the overlay drops to 0 instantly (no transition on the way down) and empties a frame later
        if (lifted) return; lifted = true;
        ov.classList.remove('on'); slot.classList.remove('gp-casc-hold'); slot._cascLay = null; fading--; p.phase = 'done';
        if (p.rec && p.rec.liftMs < 0) { p.rec.liftMs = Date.now() - p.at; }
        var empty = function () { oi.removeAttribute('src'); ov.classList.remove('ov-vid', 'ov-multi', 'ov-ai', 'nsfw'); };
        requestAnimationFrame(empty); setTimeout(empty, 100);
      }
      function abort(dead) {                    // the grid went away, the viewer covers it, or the slot's own <img> refused the picture
        lift(); inc._warmImg = null; unmark(p, !!dead);
        lastPlan.aborted = (lastPlan.aborted || 0) + 1;
      }
      if (slot.parentNode !== g || gridEl() !== g || ovOpen()) { abort(false); return; }
      var wasId = slot.getAttribute('data-id') || '';
      /* FILE THE OUTGOING GENERATION HERE  this line, and not one anywhere later, is where it ENDS.
         (The iOS instrument filed from a cleanup that ran after the next render and therefore described the
         INCOMING item at ~15 ms old; it lied for two builds. The clip is still attached and still playing on
         this line, so `playing` and the video clock are read from the thing that is actually leaving.) */
      if (INST) { instEnd(slot, 'replaced'); }
      teardownVideos(slot);                     // RELEASE FIRST (the old shuffle's lesson) -- under the opaque overlay, unseen
      transferIdentity(slot, inc);              // the slot IS the incoming post now; the partner holds the outgoing one
      if (INST) { instStart(slot, { row: p.row, col: p.col, origin: 'swap', t0: p.at, wave: p.casc, step: p.step, picMs: (p.decMs === undefined ? -1 : p.decMs), revealMs: (p.rec && p.rec.armMs >= 0) ? p.rec.armMs : -1, fb: p.fb }); }
      var pim = primaryImg(slot), t0 = Date.now();
      try { pim.decoding = 'sync'; pim.loading = 'eager'; } catch (e) {}
      (function waitImg() {                     // its own <img> has held this URL since the commit (restore) -- normally complete already
        var ok = pim.complete && pim.naturalWidth > 0;
        var bad = pim.complete && pim.naturalWidth === 0 && !!pim.getAttribute('src');
        if (!ok && !bad && Date.now() - t0 < ROLL_SETTLE_MAX_MS) { p.fb = Math.max(p.fb || 0, 1); if (slot._gn) { slot._gn.fb = p.fb; } setTimeout(waitImg, 30); return; }
        if (!ok) {                              // put the outgoing post back (still under the overlay), lift, blacklist
          if (INST) { instEnd(slot, 'reverted'); }
          transferIdentity(slot, inc);
          if (INST) { p.fb = 3; instStart(slot, { row: p.row, col: p.col, origin: 'revert', wave: p.casc, step: p.step, fb: 3 }); instFail({ wave: p.casc, step: p.step, row: p.row, col: p.col, id: inc.getAttribute('data-id') || '', why: 'settle-img', ms: Date.now() - p.at }); }
          var bid = inc.getAttribute('data-id'); if (bid) { broken[bid] = 1; }
          abort(true); return;
        }
        var go = function () { finish(); };
        if (pim.decode) { pim.decode().then(go, go); } else { go(); }
      })();
      function finish() {
        slot.classList.add('gp-casc-new');      // its pan restarts from scale 1 (rova.css), so the lift is pixel-exact even mid-band
        try { pim.style.animation = 'none'; void pim.offsetWidth; pim.style.animation = ''; } catch (e) {}
        slot.classList.remove('pcell-loading');
        // the partner's home: a far / stub cell never moved and simply holds the outgoing post where it stands;
        // a fresh / benched partner is parked to the tail or the bench, off screen either way
        var vh = window.innerHeight || 800;
        if (inc.parentNode !== g) {
          var bi = bench.indexOf(inc); if (bi >= 0) { bench.splice(bi, 1); }
          if (p.park === 'tail' && (GAS.W(g) <= 1 || GAS.tailFits(g, inc, GAS.W(g)))) { g.appendChild(inc); }   // GRID AUTHOR SPACING: else the bench
          else {
            if (window.__rovaGridUnloadCell) { window.__rovaGridUnloadCell(inc); }
            bench.push(inc);
            while (bench.length > ROLL_BENCH_CAP) { bench.shift(); }
          }
        }
        if (window.__rovaGridUnloadCell && (!inc.parentNode || inc.getBoundingClientRect().top > vh * 2 || inc.getBoundingClientRect().bottom < -vh)) { window.__rovaGridUnloadCell(inc); }
        var now = Date.now();
        inc._outSeq = ++swapSeq; inc._outCasc = p.casc; inc._swapAt = now; inc._cascPending = 0; inc._warmImg = null; inc._gasAlt = null; slot._gasAlt = null;
        slot._swapAt = now; slot._cascPending = 0; slot._warmImg = null;
        inc._rk = Math.random(); slot._rk = Math.random();   // both cells changed post: fresh draw positions in the pool
        inc._watchAt = 0; slot._watchAt = 0;                 // a protected watch belongs to a POST in a SLOT: both just changed
        rewire(slot, wasId);
        lastPlan.swapped++;
        if (p.rec) { p.rec.ok = 1; }
        var reveal = function () {
          if (lifted) return;
          lift();
          try { slot.dispatchEvent(new CustomEvent('rova:gridswap', { bubbles: true, detail: { id: slot.getAttribute('data-id'), was: wasId, n: p.casc, step: p.step, row: p.row, col: p.col } })); } catch (e) {}
        };
        requestAnimationFrame(function () { requestAnimationFrame(reveal); });   // two painted frames of the new picture under the overlay
        setTimeout(reveal, 400);                // hidden tab: rAF is frozen, the slot must not stay covered
      }
    }
    /* ---- COMMIT TOGETHER, SHOW IN ORDER (2026-09-08, iOS spec item 1) -----------------------------------
       The old wave staggered the COMMIT: cell k's media started loading 75 ms after cell k-1's, so the row
       the eye lands on first had the least head start. (24 of the app's 28 late reveals were in its top two
       rows, purely from this.) Now every pair is committed inside a few frames -- ROLL_CASCADE_CONCURRENT per
       frame so no single frame carries fifteen decodes -- and a SEPARATE BARRIER decides how far down the
       screen the wave may APPEAR. The barrier opens row 0, waits for that row's pictures to actually be up
       (or ROLL_ROW_CEIL_MS, so one slow item delays the sweep rather than stopping it), then opens the next row
       IMMEDIATELY. There is no minimum row step: ROLL_ROW_MIN_MS is 0, matching the shipped iOS build (whose spec
       text says 150 ms but whose barrier keeps no floor either). Set ROLL_ROW_MIN_MS to 150 to get the slower,
       more legible sweep back.
       INTERACTION still cancels: nothing NEW is revealed, un-revealed rows are rolled back whole, and cells
       already fading finish their own swap. */
    function cancelPair(p) {
      if (!p || p.phase === 'done' || p.phase === 'dead' || p.phase === 'cancel' || p.shown) { return false; }
      var slot = p.old, ov = slot._ov;
      clearTimeout(p.armT); clearTimeout(p.endT); clearTimeout(p.t);
      if (p.phase === 'load' || p.phase === 'fade') { fading--; slot._cascLay = null; }
      p.phase = 'cancel';
      if (ov) { ov.classList.remove('on', 'ov-vid', 'ov-multi', 'ov-ai', 'nsfw'); if (ov._img) { ov._img.removeAttribute('src'); } }
      slot.classList.remove('gp-casc-hold');
      unmark(p);
      return true;
    }
    function cancelRow(p, why) {
      var w = casc; if (!w || !p) { return; }
      var list = w.byRow[p.row] || [], k, hit = 0;
      for (k = 0; k < list.length; k++) { if (list[k] !== p && cancelPair(list[k])) { hit++; } }
      if (hit) { lastPlan.rowsCancelled = (lastPlan.rowsCancelled || 0) + 1; lastPlan.rowCancelWhy = why; }
      // the barrier must not wait for a row that is no longer coming
      if (w.barrier >= 0 && w.rowsOrder[w.barrier] === p.row) { rowAdvance('cancelled'); }
    }
    function commitBurst() {
      var w = casc; if (!w) return;
      var g = gridEl();
      if (!g || !allowed()) { waveEnd(true); return; }
      var k = 0;
      while (w.i < w.pairs.length && k < ROLL_CASCADE_CONCURRENT) {
        var p = w.pairs[w.i++];
        p.casc = w.n; p.step = w.i - 1;           // wave id + step on EVERY swap: "did it land in order" is arithmetic
        commit(p, g);                             // every row's media starts loading NOW; the barrier decides what appears
        k++;
      }
      if (w.i < w.pairs.length) { w.t = setTimeout(commitBurst, 16); return; }
      rowOpen(0);
    }
    /* THE ROW STEP IS REPORTED, NOT SCHEDULED (2026-09-08, second pass).
       rowStep() is the NOMINAL step the spec describes, compressed to fit the cycle on a tall grid (a desktop
       window can show 8-20 rows; at a flat 150 ms that sweep would outlast the cycle). It is still computed and
       still reported -- lastPlan.stagger, __rovaGridCascadeStats().last.stagger and the instrument's per-wave
       `stagger` all read it -- and with ROLL_ROW_MIN_MS at 0 it schedules NOTHING. That is deliberate, and it is
       exactly what the iOS build does: when it moved from "stagger the commit" to "commit together, reveal in
       order", its barrier began advancing the instant each row actually presented and no floor was kept under it;
       its own `stagger` is likewise still computed and still reported and schedules nothing.
       rowFloor() is the only thing that can DELAY the barrier, and it is 0 unless someone sets ROLL_ROW_MIN_MS
       (150 restores the pre-2026-09-08-pm sweep byte-for-byte in behaviour). The per-row CEILING
       (ROLL_ROW_CEIL_MS) is untouched -- that is the safety valve for a straggler, not a pacing device. */
    function rowStep(rows) {
      var room = cycleMs() - ROLL_SWAP_MS - 200;
      return Math.max(40, Math.min(ROLL_ROW_STEP_MS, Math.floor(room / Math.max(1, rows - 1))));
    }
    function rowFloor(rows) {
      if (!ROLL_ROW_MIN_MS) { return 0; }        // the barrier waits for the ROW, and for nothing else
      var room = cycleMs() - ROLL_SWAP_MS - 200;
      return Math.max(40, Math.min(ROLL_ROW_MIN_MS, Math.floor(room / Math.max(1, rows - 1))));
    }
    function rowOpen(ix) {
      var w = casc; if (!w) return;
      if (ix >= w.rowsOrder.length) { waveEnd(false); return; }
      if (!allowed()) { waveEnd(true); return; }  // the reader moved: no new row appears
      w.barrier = ix; w.rowOpenAt = Date.now();
      var list = w.byRow[w.rowsOrder[ix]] || [], i;
      for (i = 0; i < list.length; i++) { list[i].gate = 1; if (list[i].doArm) { list[i].doArm(); } }
      clearTimeout(w.rowT);
      w.rowT = setTimeout(function () { rowAdvance('ceiling'); }, ROLL_ROW_CEIL_MS);
      rowCheck();
    }
    function rowCheck() {                        // the barrier moves when the open row's pictures are actually up
      var w = casc; if (!w || w.barrier < 0) return;
      var list = w.byRow[w.rowsOrder[w.barrier]] || [], i, up = true;
      for (i = 0; i < list.length; i++) {
        var p = list[i];
        if (p.phase === 'dead' || p.phase === 'cancel') continue;
        if (!p.shown) { up = false; break; }
      }
      if (up) { rowAdvance('ready'); }
    }
    function rowAdvance(why) {
      var w = casc; if (!w || w.barrier < 0) return;
      clearTimeout(w.rowT);
      var nx = w.barrier + 1, wait = Math.max(0, (w.floor || 0) - (Date.now() - w.rowOpenAt));   // floor 0 => the next row opens now
      w.barrier = -1; w.lastAdvance = why;
      w.rowT = setTimeout(function () { if (casc === w) { rowOpen(nx); } }, wait);
    }
    function waveEnd(interrupted) {
      var w = casc; if (!w) return;
      clearTimeout(w.t); clearTimeout(w.rowT);
      if (interrupted) {
        lastPlan.cancelled = true;
        for (var k = 0; k < w.pairs.length; k++) { cancelPair(w.pairs[k]); }   // un-revealed pairs only; a fade in flight finishes
      }
      casc = null; openWave = false;
      var g = gridEl();
      if (g) { reflowTail(g); if (!interrupted) { warmAhead(g); } }   // keep the last row full; decode the next wave's pictures
    }
    /* ---- THE OPENING IS A SEPARATE CASE (2026-09-08, iOS spec) ------------------------------------------
       The first wave is the only one with nothing behind it, so it is the one guaranteed to reach for cold
       media and then block on it. It WAITS -- with a ceiling -- until the seed clips are actually playing and
       enough off-screen posts have a decoded picture (and, for clips, a warm player) to cover every square it
       is about to turn, and it spends the wait WARMING rather than idling. Rob: "take as much time as you
       need to precache the cascade animations."
       Ceilings: ROLL_OPEN_PRECACHE_MS on the pictures, ROLL_OPEN_PLAY_MS on the playback gate. Then it goes.
       openWave lasts exactly ONE WAVE (the app's equivalent budget was N seconds and was still skipping rows
       on wave two). */
    var openDone = false, openT0 = 0, openWave = false, openLog = null;
    function openingReady(g, sv) {
      if (openDone) { return true; }
      if (!openT0) { openT0 = Date.now(); }
      var waited = Date.now() - openT0, av = sv.allVis, i, clips = 0, playing = 0;
      for (i = 0; i < av.length; i++) { if (clipUrl(av[i].c)) { clips++; if (playingClip(av[i].c)) { playing++; } } }
      // "the seed clips are actually playing": every on-screen clip the decoder budget can afford at once
      var wantPlay = Math.min(clips, Math.max(1, vwCapNow()));
      var playOk = !clips || playing >= wantPlay;
      // "enough off-screen posts have a decoded picture and a warm player to cover the squares it will turn"
      var covered = 0, warmClips = 0;
      var list = [], k;
      if (buf) { for (k = 0; k < buf.length; k++) { var bid = buf[k].getAttribute('data-id'); if (bid && !seen[bid]) { list.push(buf[k]); } } }
      for (k = 0; k < sv.stubs.length; k++) { list.push(sv.stubs[k]); }
      for (k = 0; k < sv.farNew.length; k++) { list.push(sv.farNew[k].c); }
      for (k = 0; k < sv.older.length; k++) { list.push(sv.older[k]); }
      for (k = 0; k < list.length; k++) { if (ready(list[k])) { covered++; if (clipWarm(list[k])) { warmClips++; } } }
      var cacheOk = covered >= av.length;
      openLog = { waited: waited, clips: clips, playing: playing, wantPlay: wantPlay, covered: covered, need: av.length, warmClips: warmClips, playOk: playOk, cacheOk: cacheOk };
      if ((cacheOk || waited > ROLL_OPEN_PRECACHE_MS) && (playOk || waited > ROLL_OPEN_PLAY_MS)) {
        openDone = true; openWave = true; openLog.wentAt = waited; return true;
      }
      warmAhead(g, sv); vwPump();                // spend the wait WARMING, not idling
      return false;
    }
    function vwCapNow() { var st = null; try { st = window.__rovaGridCapStats && window.__rovaGridCapStats(); } catch (e) {} return st ? st.cap : 6; }
    function cascadeTick() {
      var g = allowed(); if (!g || casc) return;
      var sv = survey(g); if (!sv) return;
      ensureOverlays(sv.allVis);                 // between waves only: a layer built here paints (at 0) before its first fade
      if (!openingReady(g, sv)) { return; }
      var pairs = buildPlan(g, sv);
      if (!pairs || !pairs.length) { warmAhead(g, sv); return; }   // nothing decoded yet: warm, and try next cycle
      var byRow = {}, rowsOrder = [], i;
      for (i = 0; i < pairs.length; i++) { var rr = pairs[i].row; if (!byRow[rr]) { byRow[rr] = []; rowsOrder.push(rr); } byRow[rr].push(pairs[i]); }
      rowsOrder.sort(function (a, b) { return a - b; });
      var step = rowStep(rowsOrder.length), floor = rowFloor(rowsOrder.length);   // reported / scheduled
      casc = { n: ++cascN, pairs: pairs, i: 0, byRow: byRow, rowsOrder: rowsOrder, barrier: -1, rowOpenAt: 0, step: step, floor: floor, t: null, rowT: null, t0: Date.now() };
      lastPlan.stagger = step; lastPlan.rowFloor = floor; lastPlan.n = cascN; lastPlan.rowsInWave = rowsOrder.length;
      if (INST && INST.pending) { INST.pending.n = cascN; INST.pending.t0 = casc.t0; INST.pending.stagger = ROLL_ROW_STEP_MS; INST.curWave = INST.pending; INST.pending = null; INST.waves.push(INST.curWave); if (INST.waves.length > 400) { INST.waves.shift(); } }
      commitBurst();
    }
    var cascT = null;
    function armCascade(ms) {
      clearTimeout(cascT);
      cascT = setTimeout(function () {
        // a wave still sweeping (a slow device stretched it) -> look again shortly rather than skipping a
        // whole cycle; the cycle is measured from one cascade's START to the next
        if (casc) { armCascade(200); return; }
        // 0 -> cycleMs(); during the opening gate, look again soon. NO GRID ON THE PAGE (a card tab): there is no
        // opening gate to hurry, so the 400 ms look was 2.5 wake-ups/s on every timeline tab for the life of the
        // page (idle-cost audit, 2026-09-18) -- look slowly, and rova:paged below re-arms the instant a grid lands.
        cascadeTick(); armCascade(openDone ? 0 : (gridEl() ? 400 : 2000));
      }, ms || cycleMs());
    }
    armCascade();
    document.addEventListener('rova:paged', function () { armCascade(60); }, true);   // capture: the pager dispatches it non-bubbling on the list/grid
    document.addEventListener('rova:speed', function () { armCascade(); });   // the gear changed the cadence: re-arm on the new one
    try { if (navigator.connection && navigator.connection.addEventListener) { navigator.connection.addEventListener('change', function () { armCascade(); }); } } catch (e) {}   // left Wi-Fi: slow down on the next cycle
    /* ---- THE INSTRUMENT (2026-09-08)  ONE RECORD PER TILE PER GENERATION -------------------------------
       Ported from the iOS cascade spec, including both of the warnings it earned the hard way.
         * FILED WHERE THE GENERATION ENDS. instEnd() is called on the line in settle() where the slot stops
           being that post (before teardownVideos, so the clip is still attached and the clock still readable),
           and on every OTHER end too: a swap that reverted, a cell that left the screen, a page that went away.
           The app filed from a later cleanup and every row described the INCOMING item at ~15 ms old.
         * IT SPEAKS ON FAILURE. A decode that was refused, a swap that never started, a settle that put the
           old post back  each files a record whose `end` says which, plus a row in `fails`. An instrument
           that only reports success hid the app's pre-warm for four builds.
       And the playback-clock probe: the SAME TIMECODE TWICE IN A ROW while the element is not paused and has
       data (readyState>=3) is a stalled decoder. A frame counter and a state log both read perfect through
       81 seconds the owner called "horrible, flickery, looked stuck"; only a clock probe saw it.
       A record carries: row/col, video|photo, ms to the picture painting, ms to the video's first frame
       (-1 = never), whether it is actually playing, flashes, holes (a probe that found nothing paintable),
       stalls, how far down the fallback ladder the swap went (0 clean / 1 the slot's own <img> had to be
       waited for / 2 the incoming picture was refused / 3 the swap reverted), and the final opacity factors.
       OFF unless asked for: production pays one `if (INST)` per swap and nothing else. Turn on before load
       with window.__rovaCascInst = 1 (an init script), or at runtime with __rovaCascInstOn(). */
    var INST = null, instT = null;
    function instKind(cell) {
      if (cell.querySelector('video')) { return 'video'; }
      return cell.querySelector('img.pcell-video[data-video-src]') ? 'video' : 'photo';
    }
    function instStart(cell, o) {
      if (!INST || !cell) { return null; }
      o = o || {};
      var g = { gen: ++INST.seq, id: cell.getAttribute('data-id') || '', row: (o.row === undefined ? -1 : o.row),
                col: (o.col === undefined ? -1 : o.col), kind: instKind(cell), origin: o.origin || 'render',
                t0: o.t0 || Date.now(), wave: (o.wave === undefined ? -1 : o.wave), step: (o.step === undefined ? -1 : o.step),
                /* TWO CLOCKS, because commit and reveal are two different things now (2026-09-08).
                   picMs  = the picture was DECODED and ready to draw -- the number comparable to the app's
                            61 ms median and the event the clip dissolve chains to.
                   revealMs = when the row barrier actually let it appear. Before the barrier these were the
                            same number, so a record with no revealMs reads its picMs. */
                picMs: (o.picMs === undefined ? -1 : o.picMs), revealMs: (o.revealMs === undefined ? (o.picMs === undefined ? -1 : o.picMs) : o.revealMs),
                vidMs: -1, playing: 0, flashes: 0, holes: 0, clipT: -1,
                stalls: 0, samples: 0, fb: o.fb || 0, end: '', dur: 0, opa: null };
      cell._gn = g; return g;
    }
    function instSample(cell, fin) {
      var g = cell._gn; if (!g) { return; }
      var pim = primaryImg(cell), v = cell.querySelector('video'), ov = cell._ov, now = Date.now();
      var picOk = !!(pim && pim.complete && pim.naturalWidth > 0);
      g.samples++;
      if (picOk && g.picMs < 0) { g.picMs = now - g.t0; }
      if (v) {
        var t = v.currentTime || 0;
        if (g.vidMs < 0 && t > 0.02) { g.vidMs = now - g.t0; }
        if (g._vt !== undefined && t === g._vt && !v.paused && v.readyState >= 3) { g.stalls++; }
        g._vt = t;
        g.playing = (!v.paused && v.readyState >= 2 && t > 0.02) ? 1 : 0;
        g.clipT = t;                           // the outgoing clip's OWN clock at the instant this record is filed
      }
      var ovOn = !!(ov && ov.classList.contains('on'));
      var vidUp = !!(v && (v.currentTime || 0) > 0 && v.style.opacity !== '0');
      if (!picOk && !ovOn && !vidUp) { g.holes++; }        // nothing paintable in this slot at this instant
      if (fin) {
        try { g.opa = { ov: ov ? +getComputedStyle(ov).opacity : null, img: pim ? +getComputedStyle(pim).opacity : null, vid: v ? +getComputedStyle(v).opacity : null }; } catch (e) {}
      }
    }
    function instEnd(cell, why) {
      if (!INST || !cell || !cell._gn) { return; }
      instSample(cell, true);
      var g = cell._gn; cell._gn = null;
      g.end = why; g.dur = Date.now() - g.t0; delete g._vt;
      INST.gens.push(g); if (INST.gens.length > 8000) { INST.gens.shift(); }
    }
    function instFail(o) { if (INST) { INST.fails.push(o); if (INST.fails.length > 500) { INST.fails.shift(); } } }
    function instDrop(o) { if (INST) { INST.drops.push(o); if (INST.drops.length > 500) { INST.drops.shift(); } } }
    function instPlan(sv, pairs) {
      if (!INST || !sv || !sv.allVis || !sv.allVis.length) { return; }
      var av = sv.allVis, i, minT = Infinity, minL = Infinity, cw = av[0].r.width || 1;
      for (i = 0; i < av.length; i++) { minT = Math.min(minT, av[i].r.top); minL = Math.min(minL, av[i].r.left); }
      var planned = {}, rows = {}, cells = [];
      for (i = 0; i < pairs.length; i++) { var pc = pairs[i].old; planned[pc._cascUid || (pc._cascUid = ++INST.uid)] = pairs[i]; }
      for (i = 0; i < av.length; i++) {
        var c = av[i].c, rw = Math.round((av[i].r.top - minT) / cw), cl = Math.round((av[i].r.left - minL) / cw);
        var uid = c._cascUid || (c._cascUid = ++INST.uid), p = planned[uid] || null;
        if (p) { p.row = rw; p.col = cl; }
        rows[rw] = (rows[rw] || 0) + 1;
        cells.push({ row: rw, col: cl, id: c.getAttribute('data-id') || '', planned: !!p, skip: av[i].skip || '' });
        if (!c._gn) { instStart(c, { row: rw, col: cl, origin: 'render', t0: INST.t0 }); }
        else { c._gn.row = rw; c._gn.col = cl; }
      }
      INST.pending = { n: 0, t0: Date.now(), visible: av.length, planned: pairs.length, rows: rows, cells: cells, swaps: [] };
    }
    function instProbe() {
      if (!INST) { return; }
      var g = gridEl(); if (!g) { return; }
      INST.probes++;
      var cs = g.querySelectorAll('.pcell'), vh = window.innerHeight || 800, i, c, r;
      for (i = 0; i < cs.length; i++) {
        c = cs[i]; if (!c._gn) { continue; }
        r = c.getBoundingClientRect();
        if (r.bottom < -8 || r.top > vh + 8) { instEnd(c, 'offscreen'); continue; }
        instSample(c, false);
      }
    }
    function instFlushAll(why) {
      if (!INST) { return 0; }
      var g = gridEl(); if (!g) { return 0; }
      var cs = g.querySelectorAll('.pcell'), k = 0;
      for (var i = 0; i < cs.length; i++) { if (cs[i]._gn) { instEnd(cs[i], why); k++; } }
      return k;
    }
    window.__rovaCascInstOn = function (opts) {
      if (INST) { return true; }
      INST = { t0: Date.now(), seq: 0, uid: 0, gens: [], waves: [], fails: [], drops: [], probes: 0, curWave: null, pending: null };
      instT = setInterval(instProbe, (opts && opts.probeMs) || 150);
      try { window.addEventListener('pagehide', function () { instFlushAll('unmounted'); }); } catch (e) {}
      return true;
    };
    window.__rovaCascInstFlush = function (why) { return instFlushAll(why || 'flush'); };
    window.__rovaCascInstDump = function () {
      if (!INST) { return null; }
      var live = [], g = gridEl();
      if (g) { var cs = g.querySelectorAll('.pcell'); for (var i = 0; i < cs.length; i++) { if (cs[i]._gn) { live.push(cs[i]._gn); } } }
      return { t0: INST.t0, now: Date.now(), probes: INST.probes, gens: INST.gens, waves: INST.waves, fails: INST.fails, drops: INST.drops, live: live, warm: warmStats, plan: lastPlan };
    };
    try { if (window.__rovaCascInst) { window.__rovaCascInstOn(); } } catch (e) {}

    window.__rovaGridCascadeStats = function () {
      return { cascades: cascN, inFlight: !!casc, fading: fading, broken: Object.keys(broken).length, overlays: document.querySelectorAll('#feed-grid .gp-casc-ov').length, swapSeq: swapSeq, bench: bench.length, buf: buf ? buf.length : 0, freshCredit: +freshCredit.toFixed(2), warm: { queued: warmQ.length, inFlight: warmN, started: warmStats.started, ok: warmStats.ok, failed: warmStats.failed, timedOut: warmStats.timedOut, dropped: warmStats.dropped, answered: warmStats.answered, qMax: warmStats.qMax, queueCap: ROLL_WARM_QUEUE_CAP, saveData: saveData() },
               vwarm: { queued: vwQ.length, inFlight: vwN, started: vwStats.started, ok: vwStats.ok, failed: vwStats.failed, headroomHold: vwStats.headroomHold, headroom: vwHeadroom() },
               opening: { done: openDone, wave: openWave, log: openLog }, barrier: casc ? casc.barrier : -1,
               done: done, idle: idle(), cycleMs: cycleMs(), frac: fracNow(), tier: netTier(), last: lastPlan,
               k: { cascadeMs: ROLL_CASCADE_MS, idleAfterMs: IDLE_AFTER, idleScrollAfterMs: IDLE_SCROLL_AFTER, staggerMs: ROLL_STAGGER_MS, concurrent: ROLL_CASCADE_CONCURRENT, settleMaxMs: ROLL_SETTLE_MAX_MS,
                    rowStepMs: ROLL_ROW_STEP_MS, rowMinMs: ROLL_ROW_MIN_MS, rowCeilMs: ROLL_ROW_CEIL_MS, watchMinMs: ROLL_WATCH_MIN_MS, watchMaxMs: ROLL_WATCH_MAX_MS,
                    warmQueueCap: ROLL_WARM_QUEUE_CAP, pickLookahead: ROLL_PICK_LOOKAHEAD, vwarmMax: ROLL_VWARM_MAX, vwarmAhead: ROLL_VWARM_AHEAD, vwarmSpare: ROLL_VWARM_SPARE,
                    openPrecacheMs: ROLL_OPEN_PRECACHE_MS, openPlayMs: ROLL_OPEN_PLAY_MS, frac: ROLL_CASCADE_FRAC, wave: ROLL_WAVE, swapMs: ROLL_SWAP_MS, warmAhead: ROLL_WARM_AHEAD, warmMax: ROLL_WARM_MAX, warmTimeout: ROLL_WARM_TIMEOUT, recentWindow: ROLL_RECENT_WINDOW, freshEveryMs: ROLL_FRESH_EVERY_MS, freshBurst: ROLL_FRESH_BURST, gridCap: ROLL_GRID_CAP, benchCap: ROLL_BENCH_CAP, netCellMult: ROLL_NET_CELL_MULT, netCellFrac: ROLL_NET_CELL_FRAC, rmMult: ROLL_RM_MULT, rmFrac: ROLL_RM_FRAC } };
    };
  })();

  /* ---- guest landing: ALWAYS-ON post cascade (.pgrid.landing-grid) ------------------------------------------
     The logged-out landing shows a STATIC 15-cell media grid rendered WITHOUT id="feed-grid", so gridCycle
     (which owns #feed-grid) never touches it. This dedicated loop keeps that grid alive: every ~2s -- idle
     OR not -- one visible cell blooms out and a FRESH roll post blooms in, holding exactly 15 cells (no
     growth, no infinite scroll). Fresh posts come from the SAME guest-allowed roll endpoint gridCycle uses
     (/feed?tab=grid&partial=posts&roll=<off>&n=18, verified to serve cells to a logged-OUT request); when the
     roll runs dry a bench of swapped-out cells recycles so the cascade runs forever. Modeled on gridCycle's
     shuffleTick/takeOne + gp-swap-out/gp-swap-in mechanics, but NEVER idle-gated and it NEVER appends. Pauses
     only when the tab is hidden, the immersive .pfeed viewer is open, or the reader prefers reduced motion.
     Swapped-in cells work automatically: the tap handler reads .landing-grid's live .pcell list, and the
     global .pgrid .pcell img scan (MutationObserver) gives fresh cells the pcell-loading shimmer + fade-in. */
  (function landingCascade() {
    var grid = document.querySelector('.pgrid.landing-grid');
    if (!grid) { return; }                                   // members / non-landing pages: nothing to cascade
    var BATCH = 18, INTERVAL = 2000, DWELL = 8000;           // 15 cells kept; a fresh cell breathes ~8s before its turn
    var rollOff = 15;                                         // start past the initial 15 already on screen
    var inflight = false, buf = null, done = false, dry = 0, seen = {}, bench = [], seenUser = {};
    var TC_MAX = 45;   // skip text-WALL media (mostly-text video/image); mirrors Nudity::textCoverMax default
    // seed `seen` (post ids) + `seenUser` (authors currently on screen) so we never swap in a copy of a post
    // NOR a second tile from an author already visible -- no duplicate media OR same user at once.
    Array.prototype.forEach.call(grid.querySelectorAll('.pcell[data-id]'), function (c) {
      var v = c.getAttribute('data-id'); if (v) { seen[v] = 1; }
      var u = c.getAttribute('data-user'); if (u && u !== '0') { seenUser[u] = 1; }
    });
    function viewerOpen() { return !!document.querySelector('.pfeed.show'); }
    function reduced()    { return !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches); }
    // fetch the next roll batch into `buf` -- SAME URL / headers / parse as gridCycle.ensureBuf
    /* FAILURE COOLDOWN (2026-08-04). This is called from takeOne(), which the ALWAYS-ON 2s tick drives,
       so a link (or an origin) that keeps failing turned the busiest public page on the site into a
       0.5 req/s poll from EVERY guest sitting on it -- and the congestion that causes the failures is
       the same congestion that produces the origin's 5xx at its ~150 req/s ceiling. Same capped,
       jittered ladder the retrier uses (2/4/8/15/30/60s): the cascade still recovers on its own, it
       just stops leaning on a server that is already down. A success clears it completely. */
    var coolUntil = 0, failStep = 0;
    function ensureBuf(then) {
      if (buf || inflight || done) { if (then) { then(); } return; }
      if (Date.now() < coolUntil) { return; }   // the last ask failed and is still backing off
      inflight = true;
      var off = rollOff;
      // Same failure/terminal distinction as gridCycle.ensureBuf above, and for the same reason: takeOne()
      // latches `done` after 3 zero-cell rounds, and a 5xx used to resolve into html='' -> zero cells. On
      // the GUEST LANDING that meant a bad minute on a train left the marquee cascade permanently frozen
      // -- for a first-time visitor, on the page whose entire job is to look alive. rfetch rejects a
      // non-2xx (and deadlines the read), so the .catch leaves rollOff and dry untouched and the next
      // 2s tick simply asks again.
      rfetch('/feed?tab=grid&partial=posts&roll=' + off + '&n=' + BATCH, {
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'text/html' }, credentials: 'same-origin'
      }, 8000).then(function (r) { return r.text(); }).then(function (html) {
        inflight = false;
        coolUntil = 0; failStep = 0;                         // the link is answering again
        var tmp = document.createElement('div'); tmp.innerHTML = (html || '').trim();
        var cells = Array.prototype.slice.call(tmp.querySelectorAll('.pcell'));   // inner .pcell-* would over-count
        // data-rollnext, as in gridCycle above and for the same reason: cells.length is the screened
        // count, and a marquee that wraps early re-shows the same tiles to a first-time visitor.
        var mrf = tmp.querySelector('.feed-roll-flag');
        rollOff = (mrf && mrf.getAttribute('data-rollnext') !== null)
          ? (parseInt(mrf.getAttribute('data-rollnext'), 10) || 0)
          : ((cells.length < BATCH) ? 0 : off + BATCH);      // short page -> loop the roll back to the top
        buf = cells;
        if (then) { then(); }
      }).catch(function () {
        inflight = false;
        var base = RETRY_STEPS[Math.min(failStep, RETRY_STEPS.length - 1)];
        failStep++;
        coolUntil = Date.now() + Math.round(base * (0.8 + Math.random() * 0.4));
      });
    }
    // one fresh cell: an unseen post off the roll buffer while it lasts, then the oldest benched cell not
    // currently on screen -- so the cascade runs FOREVER even after the whole roll has been seen
    function landDupCover(c) {                               // the landing grid is one screen: no look-alike cover anywhere on it
      var G = window.__rovaGas; if (!G) { return false; }
      var me = G.id(c); if (!me.h) { return false; }
      var cs = grid.querySelectorAll('.pcell'), x = { u: '', h: me.h };
      for (var i = 0; i < cs.length; i++) { var o = G.id(cs[i]); if (cs[i] !== c && o.h && G.clash(x, { u: '', h: o.h })) { return true; } }
      return false;
    }
    function takeOne() {
      if (buf) {
        while (buf.length) {
          var c = buf.shift(), v = c.getAttribute('data-id');
          if (!v || seen[v]) { continue; }
          if (parseInt(c.getAttribute('data-txt') || '0', 10) > TC_MAX) { seen[v] = 1; continue; }   // text-wall media: never feature
          var cu = c.getAttribute('data-user');
          if (cu && cu !== '0' && seenUser[cu]) { continue; }   // that author is already on screen: skip (no dup user; a later roll re-offers it)
          if (landDupCover(c)) { continue; }                 // GRID AUTHOR SPACING: a look-alike of a cover already on screen: a later roll re-offers it
          seen[v] = 1; dry = 0; if (!buf.length) { buf = null; ensureBuf(null); } return c;
        }
        buf = null;
        if (++dry >= 3) { done = true; } else { ensureBuf(null); }
      } else if (!done) { ensureBuf(null); }
      if (!done) { return null; }                            // fresh content still in flight: wait, don't repeat old
      for (var bi = 0; bi < bench.length; bi++) {            // roll fully seen -> recycle the bench
        var b = bench[bi], id = b.getAttribute('data-id');
        if (id && grid.querySelector('.pcell[data-id="' + id + '"]')) { continue; }   // already on screen
        var bu = b.getAttribute('data-user');
        if (bu && bu !== '0' && seenUser[bu]) { continue; }  // its author is on screen: skip (no dup user)
        if (landDupCover(b)) { continue; }                   // GRID AUTHOR SPACING: a look-alike cover is on screen
        bench.splice(bi, 1);
        b.classList.remove('gp-swap-out', 'gp-swap-in');     // it left mid-fade; come back clean
        return b;
      }
      return null;
    }
    function tick() {
      if (document.hidden || viewerOpen() || reduced()) { return; }
      var vh = window.innerHeight || 800, cand = [];
      var cs = grid.querySelectorAll('.pcell');
      for (var i = 0; i < cs.length; i++) {
        var r = cs[i].getBoundingClientRect();
        if (r.width < 4 || r.height < 4) { continue; }
        var vis = (Math.min(r.bottom, vh) - Math.max(r.top, 0)) / r.height;
        if (vis < 0.6) { continue; }                         // mostly in view: the swap is watchable
        if ((cs[i]._swapAt || 0) > Date.now() - DWELL) { continue; }   // just arrived: let it breathe
        if (cs[i].matches && cs[i].matches(':hover')) { continue; }
        cand.push(cs[i]);
      }
      if (!cand.length) { ensureBuf(null); return; }         // nothing swappable now: keep the buffer warm
      var fresh = takeOne(); if (!fresh) { return; }
      // least-recently-swapped first (fresh page cells count as never-swapped), small jitter so it doesn't
      // read as a mechanical row-sweep
      cand.sort(function (a, b) { return (a._swapAt || 0) - (b._swapAt || 0); });
      var old = cand[Math.floor(Math.random() * Math.min(3, cand.length))];
      old._swapAt = Date.now();
      old.classList.add('gp-swap-out');                      // bloom out (330ms, CSS)...
      setTimeout(function () {
        // Release the outgoing clip BEFORE the "still attached?" early-out -- an already-detached cell
        // that keeps its decoder is an orphan nothing can reach. Same fix as the grid swap above.
        var ov = old.querySelector('video.pcell-video');
        if (ov) { try { ov.pause(); ov.removeAttribute('src'); ov.load(); } catch (e) {} if (ov.parentNode) { ov.parentNode.removeChild(ov); } }
        if (!old.parentNode) { return; }
        fresh.classList.add('gp-swap-in');                   // ...bloom the fresh one in (CSS gpSwapIn)
        fresh._swapAt = Date.now();                          // just arrived: back of the rotation
        var ou = old.getAttribute('data-user'), fu = fresh.getAttribute('data-user');
        if (ou && ou !== '0') { delete seenUser[ou]; }       // its author left the screen
        if (fu && fu !== '0') { seenUser[fu] = 1; }           // the fresh author is now on screen
        old.parentNode.replaceChild(fresh, old);
        old.classList.remove('gp-swap-out');
        bench.push(old);                                     // keep it: the forever-rotation pool
        if (bench.length > 90) { bench.shift(); }            // bounded; oldest ambience can drop
        setTimeout(function () { fresh.classList.remove('gp-swap-in'); }, 700);
      }, 330);
    }
    ensureBuf(null);                                         // warm the first batch
    setInterval(tick, INTERVAL);                             // ALWAYS-ON: one swap every ~2s, idle or not

    /* ---- full-width TRENDING rows: rotate their content too (independent, slower) ---------------------------
       The interleaved .landing-fullrow cards (text / link-embed posts + comment roller) rotate in fresh
       trending cards from a guest-allowed endpoint (/?partial=textrow, served from the same 1-hour cached
       pool). In-place swap keeps the net layout constant (one full row out, one in -- no growth, no effect
       on the media tiles or the .landing-grid pfeed-tap branch). The outgoing card fades up (gp-swap-out),
       the fresh one rises in via CSS (.landing-fullrow landingRise). Same pause gates as the tile cascade. */
    var fRollOff = 3;                                        // the initial page interleaved the first 3 pool cards
    var fInflight = false, fBuf = null, fDone = false, fDry = 0, fSeen = {}, fBench = [];
    Array.prototype.forEach.call(grid.querySelectorAll('.landing-fullrow[data-id]'), function (c) {
      var v = c.getAttribute('data-id'); if (v) { fSeen[v] = 1; }   // never swap a card in for one already shown
    });
    /* SLOW-LINK (2026-08-09). Its two siblings on this page -- gridCycle.ensureBuf and the cascade's
       ensureBuf directly above -- both got the deadline and the jittered failure ladder on 08-04;
       this one, driven by the same ALWAYS-ON 2s tick, was missed. Without a cooldown a failing link
       (or an origin already at its ~150 req/s ceiling, which is what CAUSES the failures) had every
       guest sitting on the landing page asking again every 2 seconds, forever. Without a deadline
       `fInflight` stayed pinned on a half-open socket and the trending rows simply stopped rotating.
       And `r.ok ? r.text() : ''` folded a 5xx into an empty page, which walks fRollOff back to 0 --
       a server error silently reset the pool cursor. rfetch rejects it instead, so the .catch backs
       off with every cursor untouched and the next tick asks again on the same ladder: 2/4/8/15/30/60s,
       jittered, cleared completely by one success. */
    var fCoolUntil = 0, fFailStep = 0;
    function fEnsureBuf(then) {
      if (fBuf || fInflight || fDone) { if (then) { then(); } return; }
      if (Date.now() < fCoolUntil) { return; }   // the last ask failed and is still backing off
      fInflight = true;
      var off = fRollOff;
      rfetch('/?partial=textrow&roll=' + off, {
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'text/html' }, credentials: 'same-origin'
      }, 8000).then(function (r) { return r.text(); }).then(function (html) {
        fInflight = false;
        fCoolUntil = 0; fFailStep = 0;                      // the link is answering again
        var tmp = document.createElement('div'); tmp.innerHTML = (html || '').trim();
        var cards = Array.prototype.slice.call(tmp.querySelectorAll('.landing-fullrow'));
        fRollOff = cards.length ? off + cards.length : 0;   // advance; empty -> loop the pool back to the top
        fBuf = cards;
        if (then) { then(); }
      }).catch(function () {
        fInflight = false;
        var fbase = RETRY_STEPS[Math.min(fFailStep, RETRY_STEPS.length - 1)];
        fFailStep++;
        fCoolUntil = Date.now() + Math.round(fbase * (0.8 + Math.random() * 0.4));
      });
    }
    // one fresh card: an unseen pool card while the pool lasts, then the oldest benched card not on screen
    function fTakeOne() {
      if (fBuf) {
        while (fBuf.length) {
          var c = fBuf.shift(), v = c.getAttribute('data-id');
          if (v && !fSeen[v]) { fSeen[v] = 1; fDry = 0; if (!fBuf.length) { fBuf = null; fEnsureBuf(null); } return c; }
        }
        fBuf = null;
        if (++fDry >= 3) { fDone = true; } else { fEnsureBuf(null); }
      } else if (!fDone) { fEnsureBuf(null); }
      if (!fDone) { return null; }
      while (fBench.length) {
        var b = fBench.shift(), id = b.getAttribute('data-id');
        if (id && !grid.querySelector('.landing-fullrow[data-id="' + id + '"]')) { b.classList.remove('gp-swap-out'); return b; }
      }
      return null;
    }
    function fTick() {
      if (document.hidden || viewerOpen() || reduced()) { return; }
      var vh = window.innerHeight || 800, cand = [];
      var cs = grid.querySelectorAll('.landing-fullrow');
      for (var i = 0; i < cs.length; i++) {
        var r = cs[i].getBoundingClientRect();
        if (r.width < 4 || r.height < 4) { continue; }
        var vis = (Math.min(r.bottom, vh) - Math.max(r.top, 0)) / r.height;
        if (vis < 0.5) { continue; }                        // at least half in view: the swap is watchable
        if ((cs[i]._swapAt || 0) > Date.now() - 6000) { continue; }   // the single post row rotates often (~6s dwell)
        if (cs[i].matches && cs[i].matches(':hover')) { continue; }
        cand.push(cs[i]);
      }
      if (!cand.length) { fEnsureBuf(null); return; }       // keep the buffer warm
      var fresh = fTakeOne(); if (!fresh) { return; }
      cand.sort(function (a, b) { return (a._swapAt || 0) - (b._swapAt || 0); });   // least-recently-swapped first
      var old = cand[Math.floor(Math.random() * Math.min(2, cand.length))];
      old._swapAt = Date.now();
      old.classList.add('gp-swap-out');                     // fade up and out (CSS)...
      setTimeout(function () {
        // Release before the "still attached?" early-out (same fix as the two grid swaps above): a card
        // detached during the 330ms wait would otherwise keep a running, unreachable decoder.
        Array.prototype.forEach.call(old.querySelectorAll('video'), function (ov) {
          try { ov.pause(); ov.removeAttribute('src'); ov.load(); } catch (e) {}
        });
        if (!old.parentNode) { return; }
        fresh._swapAt = Date.now();
        old.parentNode.replaceChild(fresh, old);            // ...the fresh card rises in via CSS landingRise
        old.classList.remove('gp-swap-out');
        fBench.push(old);                                   // keep it for the forever rotation
        if (fBench.length > 40) { fBench.shift(); }
      }, 330);
    }
    fEnsureBuf(null);                                       // warm the first trending batch
    setInterval(fTick, 2000);                               // check every 2s; the post row rotates after its ~6s dwell
  })();

  /* ---- grid: fast-fling calm (round 126) --------------------------------------------------------------------
     Two cheap levers that make a FAST swipe as smooth as a slow one:
     (1) .gp-scroll on #feed-grid while the user is actually scrolling (240ms settle) -- CSS pauses the Ken
         Burns pan for the duration, so the fling composites STATIC textures instead of re-animating a dozen
         thumbnails per frame (and fresh cells don't start animations mid-fling). __rovaScrollAt lets the video
         preview observer defer decoder spin-up until the fling calms too.
     (2) EXACT offscreen height: cells are 1:1, so height = the measured cell width. Stamp it on each .pgrid as
         --pcell-h; contain-intrinsic-size uses it (rova.css), so content-visibility's reserved height for a
         never-rendered cell is exact -- no page-height corrections jerking the scroll as fresh rows render. */
  (function () {
    var t = null;
    window.__rovaScrollAt = 0;
    // SCROLL VELOCITY (2026-08-11, prefetch/cache push), piggybacked on this handler rather than a new
    // listener -- this already fires on every scroll/touchmove tick at capture phase, so there is nothing
    // extra to bind. window.__rovaScrollVel is a smoothed px/ms reading gridCycle's nearBottom() (below)
    // uses to widen its fetch-ahead headroom on a hard fling -- see that comment for why. EMA'd (0.3 weight
    // on each new sample) so one noisy tick can't spike it; gaps over 500ms (a paused scroll, a tab-away
    // resume) are dropped rather than producing a bogus huge instantaneous "velocity".
    var _vy = window.scrollY || 0, _vt = Date.now();
    window.__rovaScrollVel = 0;
    /* SIGNED DIRECTION, on the same handler and for the same reason the velocity is (2026-09-09).
       The feed-video pre-roll may only start a clip the reader is travelling TOWARDS -- a card
       receding behind them must never spin a decoder, which is the whole difference between
       "already playing when it arrives" and the invisible-decoding complaint. +1 down, -1 up, and
       STICKY: it only flips on a move of more than 3px, so the sub-pixel jitter at the end of a
       fling (and iOS rubber-banding) cannot make a card behind the reader look like one ahead. */
    window.__rovaScrollDir = 1;
    function markVel() {
      var now = Date.now(), y = window.scrollY || 0, dt = now - _vt;
      if (dt > 0 && dt < 500) {
        var v = Math.abs(y - _vy) / dt;                       // px/ms this sample
        window.__rovaScrollVel = window.__rovaScrollVel * 0.7 + v * 0.3;
      }
      if (y - _vy > 3) { window.__rovaScrollDir = 1; }
      else if (y - _vy < -3) { window.__rovaScrollDir = -1; }
      _vy = y; _vt = now;
    }
    function mark() {
      markVel();
      window.__rovaScrollAt = Date.now();
      var g = document.getElementById('feed-grid');
      if (g && !g.classList.contains('gp-scroll')) { g.classList.add('gp-scroll'); }
      // html.tl-scroll: the pfeed chrome's blur drop, presence ripples etc. key off it (rova.css). It NO LONGER
      // pauses any Ken Burns (2026-10-01): the pans keep running through a scroll on the compositor.
      var de = document.documentElement;
      if (!de.classList.contains('tl-scroll')) { de.classList.add('tl-scroll'); }
      // PERF: this used to clearTimeout+setTimeout on EVERY scroll AND touchmove event -- ~120 timer
      // allocations a second during a fling, for a 240ms settle. One self-checking timer instead: it
      // re-arms itself for whatever is left, so a continuous scroll costs one timer per 240ms.
      if (!t) t = setTimeout(function settle() {
        var left = 240 - (Date.now() - window.__rovaScrollAt);
        if (left > 8) { t = setTimeout(settle, left); return; }
        t = null;
        var g2 = document.getElementById('feed-grid'); if (g2) g2.classList.remove('gp-scroll');
        document.documentElement.classList.remove('tl-scroll');
        // the timeline's playing card is re-decided at rest (sound closure, tlSlotDecide; 2026-09-26)
        if (window.__rovaTlSlotSoon) { try { window.__rovaTlSlotSoon(); } catch (e) {} }
      }, 240);
    }
    /* THE MEDIA RING IS NOT THE PAGE SCROLLING (2026-10-12, Rob on a Mac, Safari + Magic Mouse: swiping the ring
       "isn't smooth and stutters"). This listener is capture-phase, so the ring's SIDEWAYS track scroll reached it on
       every event: html.tl-scroll flipped on and off once per swipe (a whole-document style invalidation each way --
       it pauses every presence ripple / seen-by blink on the page) for a scroll that moves nothing vertical. The
       window's own scrolls, the viewer's and the grid's still mark; a finger on the ring that the ring hands to the
       page (its HORIZONTAL ONLY block) moves the window, which marks through the window's own scroll events. */
    function markOf(e) { if (!window.__rovaRingScroll(e)) mark(); }
    window.addEventListener('scroll', markOf, { passive: true, capture: true });
    window.addEventListener('touchmove', markOf, { passive: true, capture: true });
    function size() {
      Array.prototype.forEach.call(document.querySelectorAll('.pgrid'), function (g) {
        var c = g.querySelector('.pcell'); if (!c) return;
        var w = c.getBoundingClientRect().width;                      // first cell is at the top: always rendered
        if (w > 20) { g.style.setProperty('--pcell-h', w.toFixed(1) + 'px'); }
      });
      // html.grid-tab: "a media grid is what's on screen right now". Set here because this block already
      // re-runs on load, on resize and whenever a .pgrid is injected (the AJAX tab pager). CSS uses it to
      // drop chrome that only earns its cost over scrolling POST CARDS -- see the tabs scrim in rova.css.
      document.documentElement.classList.toggle('grid-tab', !!document.querySelector('.pgrid .pcell'));
    }
    size();
    var rT = null;
    window.addEventListener('resize', function () { clearTimeout(rT); rT = setTimeout(size, 150); }, { passive: true });
    new MutationObserver(function (muts) {                            // grids appear later via the AJAX tab pager
      for (var i = 0; i < muts.length; i++) {
        // REMOVED nodes matter too: swapping grid -> Discover tears the .pgrid out, and if we only
        // watched additions html.grid-tab would stay set on a page that no longer has a grid.
        var lists = [muts[i].addedNodes, muts[i].removedNodes];
        for (var k = 0; k < 2; k++) {
          var a = lists[k];
          for (var j = 0; j < a.length; j++) {
            var n = a[j];
            if (n.nodeType === 1 && ((n.matches && n.matches('.pgrid')) || (n.querySelector && n.querySelector('.pgrid')))) { size(); return; }
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  })();

  /* ---- grid: Ken Burns centre band on touch (owner: "photos should be kens burning on the grid") -------
     TOUCH ONLY, and it is a BUDGET, not a switch. rova.css (:993) kills the grid pan under
     @media (hover:none) and re-grants it to .pcell.kb-near; this stamps kb-near on the handful of cells
     crossing the middle of the viewport, so at most ~6 photos animate at once no matter how long the grid
     is. Desktop never runs this and keeps every cell drifting.
     WHY A COUNT BUDGET rather than the bounded one-shot that fixed the immersive viewer: measured on a
     populated grid (390x844, CPU 6x, ~20 cells on screen), long-frame rate went 26.4% at 6 animating,
     52.1% at 10, and 64-75% at 20 -- and the one-shot scored with the 20s, not the 6s, because a grid
     arms every cell at once as you scroll. On a grid the cost is the NUMBER of live compositor layers;
     bounding the duration bounds nothing. The viewer was different: one full-screen layer, so a single
     pass was the whole cost.
     A NEGATIVE rootMargin IS the band -- the browser computes it off the main thread, so there is no
     scroll listener, no getBoundingClientRect, and no forced layout during a fling. That matters here:
     this grid has a long history of scroll-perf regressions, and the .pcell-eng block below is written
     the same careful way for the same reason. */
  (function () {
    if (!('IntersectionObserver' in window)) { return; }
    if (!(window.matchMedia && matchMedia('(hover:none)').matches)) { return; }        // desktop keeps the full grid
    if (window.matchMedia && matchMedia('(prefers-reduced-motion:reduce)').matches) { return; }
    // -45% top and bottom leaves the middle ~10% of the viewport live (~84px of an 844px screen). At a
    // ~120px phone cell that is one row, two while a row straddles the band mid-scroll, i.e. 3-6 cells --
    // the budget the measurement picked. -42% was tried first and caught THREE rows (9 cells), which lands
    // nearer the 10-cell arm (52% long frames) than the 6-cell one (26%), so the band has to be this tight.
    /* LEAVING THE BAND HOLDS THE FRAME; ONLY A CELL WELL OFF SCREEN GOES BACK TO REST (2026-10-01).
       The pan now keeps running through a touch scroll and its momentum (rova.css dropped the gp-scroll /
       tl-scroll freeze: Rob, iPhone Safari, "the Ken Burns doesn't play when I'm in an active scroll"), so
       the band is crossed WHILE the reader watches -- and dropping kb-near used to mean animation:none, i.e.
       an on-screen tile snapping from mid-pan back to scale 1 (measured: up to 0.067 of scale in one 50ms
       step, 3-6 snaps per flick). Now a cell that leaves the band is stamped .kb-held (rova.css pauses it
       where it is: play-state, so it RESUMES from that frame if it comes back -- no restart from zero), and
       a second, small observer -- watching ONLY the held cells, so this is not another all-cells IO on top
       of the six the grid already pays for -- releases the hold once the cell is half a screen beyond either
       edge, where the reset to rest is invisible. The RUNNING count is unchanged: still only the band. */
    var far = new IntersectionObserver(function (ents) {
      for (var i = 0; i < ents.length; i++) {
        if (ents[i].isIntersecting) { continue; }
        var c = ents[i].target;
        c.classList.remove('kb-held');
        try { far.unobserve(c); } catch (e) {}
      }
    }, { rootMargin: '50% 0px 50% 0px', threshold: 0 });
    var io = new IntersectionObserver(function (ents) {
      for (var i = 0; i < ents.length; i++) {
        var c = ents[i].target;
        if (!c.classList) { continue; }
        if (ents[i].isIntersecting) {
          c.classList.add('kb-near');
          if (c.classList.contains('kb-held')) { c.classList.remove('kb-held'); try { far.unobserve(c); } catch (e) {} }
        } else if (c.classList.contains('kb-near')) {
          c.classList.add('kb-held');                              // BEFORE dropping kb-near: never one style pass with neither
          c.classList.remove('kb-near');
          try { far.observe(c); } catch (e) {}
        }
      }
    }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
    var seen = 'kbSeen';
    function scan() {
      var cells = document.querySelectorAll('.pgrid .pcell');
      for (var i = 0; i < cells.length; i++) {
        if (!cells[i].dataset[seen]) { cells[i].dataset[seen] = '1'; try { io.observe(cells[i]); } catch (e) {} }
      }
    }
    scan();
    // the grid paginates and the AJAX tab pager swaps whole .pgrids in, so fresh cells have to be picked
    // up the same way the sizing block above does it
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var a = muts[i].addedNodes;
        for (var j = 0; j < a.length; j++) {
          var n = a[j];
          if (n.nodeType === 1 && ((n.matches && n.matches('.pcell,.pgrid')) || (n.querySelector && n.querySelector('.pcell')))) { scan(); return; }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  })();

  /* ---- grid: hover engagement bubble (web bug #47) -----------------------------------------------------
     Desktop hover over a media tile fades in a small dark-glass pill showing that post's like, comment
     and view counts (rova.css .pcell-eng). Deliberately as close to free as this can be made, because this
     grid has a long history of scroll-perf regressions:
       - ONE delegated listener pair on the document (never per-cell), same shape as the .pcell tap handler.
       - ONE shared node for the whole page, re-parented into the hovered cell. Positioning is pure CSS
         (absolute inside the cell), so nothing here ever READS layout -- no getBoundingClientRect, no
         forced synchronous layout, on hover or during a fling. (Toggling the views group below is a style
         WRITE only; it never reads back.)
       - The counts are already on the cell as data-lk / data-cm / data-vw (views/_feed_grid.php,
         views/_profile_posts.php), so there is no per-hover network request and no extra query.
       - Mouse only: the whole block is skipped unless the pointer really hovers, and the CSS is
         display:none outside @media (hover:hover) and (pointer:fine) -- a phone can never latch it on. */
  (function () {
    if (!(window.matchMedia && matchMedia('(hover:hover) and (pointer:fine)').matches)) return;
    /* the SAME heart path as heart_svg() in lib/view.php (an SVG, not the emoji: system emoji fonts draw
       the heart very differently per browser) and the SAME 💬 glyph the post action bar uses.

       BOTH STATES, BOTH SHIPPED INTO THE PILL, SWAPPED BY ONE CLASS. Only the filled one existed, so the
       pill wore a solid red heart on every tile whether or not the reader had liked the post -- it was a
       LABEL meaning "likes", and it read as "you liked this" (owner 2026-08-05). The outline copy is
       heart_svg(false) verbatim: same path, fill:none, stroke:currentColor, which is the pill's white.
       Rendering both once and toggling `.mine` in CSS keeps the hover handler a pure style WRITE -- no
       innerHTML per hover, no re-parse, nothing read back -- which is the property the whole module is
       built around. */
    var HPATH = 'M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z';
    var HEART_F = '<svg class="hic pe-hf" viewBox="0 0 24 24" aria-hidden="true"><path d="' + HPATH + '" fill="#ff2b55"/></svg>';
    var HEART_O = '<svg class="hic hic-o pe-ho" viewBox="0 0 24 24" aria-hidden="true"><path d="' + HPATH + '" fill="none" stroke="currentColor" stroke-width="2"/></svg>';
    // views: the SAME stroked eye the post card's reach chip draws (views/_post.php .seenby) -- an SVG for
    // the same reason the heart is one. NOT an emoji: 👁 renders as a full-colour cartoon eye on some
    // platforms and a flat glyph on others, and it would not sit on the accent-tinted glass.
    var EYE = '<svg class="vic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>';
    // comments: the SAME stroked bubble the post bar draws, icon('comment-o') in lib/view.php, for the
    // SAME reason the heart and the eye above are SVGs. This was the U+1F4AC emoji, and it was the only
    // mark in the pill that could not take the pill's white -- an emoji carries its own colours -- so a
    // full-colour balloon sat between a currentColor heart and a currentColor eye. Apple draws it FILLED
    // and white, which is the divergence the owner reported in the post bar on 2026-08-09; the pill was
    // the same glyph on another surface. stroke-width 2.1 = the EYE beside it, not the bar's 2.5: this
    // pill paints at 12px, the bar at 16px, and the pen is what carries the weight down.
    var CMT = '<svg class="cic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 3.4h16a2 2 0 0 1 2 2v9.6a2 2 0 0 1-2 2h-9.4l-4.5 3.4A1 1 0 0 1 4.5 19.6l.3-2.6H4a2 2 0 0 1-2-2V5.4a2 2 0 0 1 2-2z"/><path d="M8 10.2h.01M12 10.2h.01M16 10.2h.01"/></svg>';
    var bub = null, nums = null, vwrap = null, cur = null, raf = 0;
    function node() {
      if (bub) return bub;
      bub = document.createElement('span');
      bub.className = 'pcell-eng';
      bub.setAttribute('aria-hidden', 'true');   // decorative: the counts are on the post itself
      bub.innerHTML = HEART_O + HEART_F + '<b class="pe-n"></b><span class="pe-c">' + CMT + '</span><b class="pe-n"></b>'
                    + '<span class="pe-v">' + EYE + '<b class="pe-n"></b></span>';
      nums  = bub.querySelectorAll('.pe-n');     // document order: likes, comments, views
      vwrap = bub.querySelector('.pe-v');
      return bub;
    }
    function hide() { if (bub) bub.classList.remove('on'); cur = null; }
    document.addEventListener('mouseover', function (e) {
      var cell = e.target && e.target.closest ? e.target.closest('.pgrid .pcell') : null;
      if (cell === cur) return;                                   // same cell (moved onto the img): nothing to do
      if (!cell || !cell.hasAttribute('data-lk')) { hide(); return; }   // e.g. the landing teaser grid: no counts
      cur = cell;
      var b = node();
      /* THE HEART IS THE READER'S, THE THREE NUMBERS ARE EVERYONE'S. data-me is written by
         views/_profile_posts.php + views/_feed_grid.php from the post row's `my_reaction` -- the same
         field views/_post.php draws its own heart from -- and is ABSENT for a reader who has not reacted,
         which includes every signed-out reader, so the pill lands neutral by default rather than
         inheriting whatever the last hover showed. Class toggle only: no layout read, no innerHTML. */
      b.classList.toggle('mine', cell.getAttribute('data-me') === '1');
      nums[0].textContent = fmtCount(cell.getAttribute('data-lk'));
      nums[1].textContent = fmtCount(cell.getAttribute('data-cm'));
      // ZERO VIEWS -> drop the stat entirely, exactly like the post card's reach chip (views/_post.php
      // only renders .seenby when $vc > 0). A brand-new post reads "0 views" as a failure; showing two
      // stats instead of three is the same thing the card already does. data-vw absent (a page rendered
      // by an older PHP build, still cached at the edge) takes the same branch, so this degrades cleanly.
      var vw = Math.max(0, Math.floor(+cell.getAttribute('data-vw') || 0));
      vwrap.style.display = vw > 0 ? '' : 'none';
      if (vw > 0) { nums[2].textContent = fmtCount(vw); }
      // re-parent WITHOUT the .on class so the pill's first computed style in its new cell is the hidden
      // one -- otherwise it would be inserted already-visible and snap instead of fading.
      if (b.parentNode !== cell) { b.classList.remove('on'); cell.appendChild(b); }
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { raf = 0; if (cur === cell) b.classList.add('on'); });
    }, { passive: true });
    document.addEventListener('mouseout', function (e) {
      if (!cur) return;
      var to = e.relatedTarget;
      // ignore the moves WITHIN the hovered cell (img -> cell -> badge); only a real exit hides it
      if (to && to.closest && to.closest('.pgrid .pcell') === cur) return;
      hide();
    }, { passive: true });
  })();

  /* ---- live engagement counts: one refresh, three surfaces ----------------
     Like / comment / repost badges are server-rendered once and then never move again when OTHER
     people engage, so a reader sitting on a page watches every count in front of them stay frozen
     (owner 2026-08-04). This is the shared half of the cure: pick the ids actually on screen, ask
     /engage-live for them in ONE batched request, paint the answer onto every copy of those cards.

     It lives HERE, at the top level of this IIFE beside engTouch() / fmtCount() / reactFan(), and
     not inside any one surface's module. The feed's realtime module, the permalink and the profile
     are three separate nested IIFEs; a helper defined inside one of them is invisible to the other
     two, which is exactly why the feed was the only surface that ever refreshed. Each surface owns
     only its root element and its cadence, and calls engRefresh().

     COST. One batched GET per tick carrying only the ids on screen, capped at ENG_MAX (the server
     caps at the same number). A reader who has scrolled past 200 posts asks about the handful in
     front of them, never the history. Hidden tab, guest, or a paused feed: nothing goes out.

     RECONCILING WITH THE OPTIMISTIC PATH is the whole difficulty, and it is done with a
     happens-before test rather than a flag. Every local write stamps the card via engTouch() (both
     on the instant paint and again when the server confirms), and every writer already does so:
     applyReactLocal, applyReactToPost, the repost paint, the comment panel's setCount and the
     comment-delete decrement. A response applies to a card only when that stamp is OLDER than the
     moment this request left the browser: the write had already settled, so the read the server
     took includes it. A card touched while the batch was in flight is skipped outright, so a tap
     can neither flicker back nor double-count. That test travels with engRefresh(), so it protects
     the permalink and the profile on exactly the terms it protects the feed.

     And nothing here writes the reader's OWN state. The payload deliberately carries no
     my-reaction / reposted-by-me; the pressed heart and the chosen emoji are read back out of the
     DOM. A refresh can move numbers and other people's emojis, and that is all it can do. */
  /* ---- THE THREE LIVE POLLERS, AND WHY THEY GET A DEADLINE (2026-08-07) -------------------------
     /engage-live (below), the feed's new-post poll and the ambient roll (both in the realtime-feed
     IIFE further down) were the last three reads in this file still on raw fetch(). Each guards
     itself with one in-flight boolean -- engBusy, polling, rollFetching -- set true before the
     request and cleared ONLY inside .then/.catch. A promise that never settles therefore leaves
     that surface dead for the rest of the session, with no spinner, no error and nothing to retry:
     the badges stop moving, no new post ever appears, and the timeline stops rolling, on a page
     that otherwise looks perfectly healthy.

     That is not hypothetical here. fetch() RESOLVES AT THE HEADERS, so a stalled BODY slips past
     anything a header-only check could do, and http.sys's own counters say stalled bodies are the
     live failure mode on this site: Timer_MinBytesPerSecond (the client cannot receive at 240 B/s)
     went 0/hr to 4-47/hr and Client_Reset 1-7/hr to 123-300/hr from 2026-08-05, peaking at 452
     Client_Reset in a single hour today. iOS Safari can sit on a half-open socket for 60-120s
     before it gives up, and nothing above re-arms when it finally does.

     TWO CHANGES, and the second exists because the first has a gap:

       1. rfetch(url, opts, 8000) instead of fetch(). It rejects a non-2xx into the .catch these
          three already have, and -- the part that matters for a stalled body -- it keeps its
          AbortController deadline armed THROUGH the body read. So the flag clears in 8s instead of
          never. Same 8s every other small read in this file uses.

       2. An AGE-BASED SELF-HEAL on the flag itself, checked where the flag is already tested.
          rfetch's deadline needs window.AbortController; where that is missing it degrades to a
          plain fetch with no deadline at all, which is exactly the old bug on exactly the old
          phones this plumbing was written for. So the guard does not trust the deadline: a flag
          that has been up longer than POLL_LATCH_MS is treated as abandoned and dropped.

     NO NEW TIMER AND NO NEW LISTENER, deliberately. All three are already driven by a repeating
     tick (setInterval for the poll pair, the self-rescheduling reveal timer for the roll) and all
     three already re-fire on visibilitychange -- so the retry is the next beat that was going to
     happen anyway, and a tab coming back to life re-tries at the moment somebody is looking. Adding
     a scheduler here would put a fresh burst on a CPU-bound origin at the exact moment a bad link
     is recovering, which is the thundering herd makeRetrier() jitters to avoid.

     AND NOTHING IS BLANKED ON FAILURE. A failed poll degrades to "stale but correct as of page
     load", which is the right end state: engApply() writes the exact server number into every
     badge, so painting a failure would hide all three of them at once (that is the /engage-live
     zero-row report) -- strictly worse than leaving the server's own correct render alone. rfetch
     rejecting a non-2xx is what guarantees it: a Cloudflare error page can no longer arrive as an
     empty parse and be applied as content.

     A generation counter travels with each request so a response the self-heal already gave up on
     cannot clear a flag a NEWER request now owns, or paint its stale snapshot over the new one. */
  var POLL_LATCH_MS = 20000; // an in-flight flag older than this is abandoned, not in flight
  var ENG_MAX = 30;          // ids per request; /engage-live enforces the same cap
  var engBusy = false;       // one batch in flight at a time, whichever surface asked for it
  var engBusyAt = 0;         // when engBusy went up (POLL_LATCH_MS self-heal)
  var engGen = 0;            // which batch owns engBusy right now
  var engIsMember = null;

  // MEMBERS ONLY, and this is a cost decision rather than a privacy one. A guest's feed, permalink
  // and profile pages are all rendered session-free so Cloudflare serves them from the edge and the
  // origin never sees them; hanging a non-cacheable poll off those pages would hand every guest and
  // every crawler a standing origin cost on a box that is already CPU-bound. It matters most on a
  // permalink, which is the page shares and search results actually land on. Nobody has complained
  // about a stale badge they cannot press.
  // Read LAZILY rather than into a var at load time: the callers are nested IIFEs in this same
  // scope, some of them ahead of this line, and a hoisted `var` reads `undefined` (falsy -> a silent
  // permanent opt-out) for anything that runs before the assignment. A function body runs when it
  // is called, so the answer is right no matter who asks first.
  function engMember() {
    if (engIsMember === null) engIsMember = !document.querySelector('meta[name="rova-guest"]');
    return engIsMember;
  }

  // The cards actually on screen, keyed by the post whose counts they show. data-id is the
  // feed-order row (a repost row has its own id); data-view is the post being rendered, which is
  // what the counts belong to -- and two cards (an original and a repost of it) can share one.
  function engVisibleIds(root) {
    var vh = window.innerHeight || document.documentElement.clientHeight || 800;
    var cards = (root || document).querySelectorAll('.post[data-view]');
    var ids = [], got = {};
    for (var i = 0; i < cards.length && ids.length < ENG_MAX; i++) {
      var r = cards[i].getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) continue;   // one screen of margin, nothing more
      var id = parseInt(cards[i].getAttribute('data-view'), 10) || 0;
      if (!id || got[id]) continue;
      got[id] = 1; ids.push(id);
    }
    return ids;
  }

  // Paint one card from a server row. Every badge is written to the EXACT server number, so an
  // unlike, a deleted comment or an undone repost brings it back down; a count of 0 hides the
  // label again exactly as the server render does.
  function engApply(post, d) {
    // Each badge is tested against its OWN in-flight hold, so one settling write never freezes the
    // rest of the card: a like still in the air stops the like badge and lets this same batch's
    // comments and reposts through. engBadgeHeld() is keyed on the post id, which is what every
    // writer holds on, and it self-heals a hold nobody released.
    var vid = engIdFor(post);
    // LIKE. The button is .react-btn for members; a guest card has a plain link to /signup that
    // still holds the same .react-ic + .cnt. Either way, my own reaction comes from the DOM.
    var likeBtn = post.querySelector('.react-btn');
    if (!likeBtn) {
      var ric = post.querySelector('.react-ic');
      likeBtn = (ric && ric.closest) ? ric.closest('.act') : null;
    }
    // The fan inside the button rides the like hold with the count, because it is read out of the
    // SAME snapshot: letting it through while the count is held would flicker the reader's own
    // emoji straight back off. (The separate .rx-cluster breakdown row this comment used to also
    // except is gone -- no template ever rendered it; removed 2026-08-10.)
    if (likeBtn && !engBadgeHeld('like', vid)) {
      likeBtn.setAttribute('data-optcount', String(+d.l || 0));   // keep optCount() exact for the next tap
      var ic = likeBtn.querySelector('.react-ic');
      if (ic && d.b) {
        var f = reactFan(d.b, likeBtn.getAttribute('data-reaction') || null);
        ic.innerHTML = f.html; ic.classList.toggle('fan', f.n > 1);
      }
      /* THE COUNT BADGE, GLYPH AND ALL, THROUGH ITS ONE WRITER -- and `d.b` is passed straight
         through rather than guarded at the call site. engagementMany always sends `b`, but if it
         ever does not, rxBadgePaint reads a null breakdown as "no news" and carries the glyph
         already on screen over verbatim while still writing the server's exact number. That is
         the shape this has to have: the old split (write .cnt.textContent here, patch the crowd
         on afterwards) meant a missing `b` silently wiped the glyph off a correct badge, which is
         the /engage-live zero-row bug wearing a different hat. The reader's own state is only
         READ here (.on off the DOM), never written -- the /engage-live contract. */
      rxBadgePaint(likeBtn, d.l, d.b);
      // ...and the profile-photo chip, when the card being refreshed IS the avatar post (the viewer
      // opened over the profile). COUNT ONLY: `reaction` is omitted, so the reader's own pressed
      // state is left exactly where their own tap left it, the same rule the card obeys above.
      engPhotoReact(vid, d.l);
    }
    // COMMENT. Through the shared painter (engCommentPaint) rather than straight at the badge, so
    // one refresh moves every view of this number: each copy of the card, the permalink's
    // "N Comments" section header and the gallery lightbox summary. The header previously had NO
    // writer but the page render, which is why a delete left it wrong until a reload -- this is
    // what heals it. Held while the reader's own comment is in flight: a batch that left before the
    // write committed carries a snapshot with no comment in it, and applying it would tick the
    // badge back down.
    // ...and when that number went UP on a card with no comment roller yet, the roller is what the
    // reader is actually owed: the action row slides up out of the roller's slot and the pill fades
    // in carrying the new comment. The count is still painted by the line above and ONLY by it --
    // this reads the before/after it just wrote and never repaints anything itself.
    if (!engBadgeHeld('comment', vid)) {
      var cWas = engCommentNow(post);
      engCommentPaint(post, +d.c || 0);
      if (window.__rovaRollerBump) window.__rovaRollerBump(post, cWas, +d.c || 0);
    }
    // REPOST. Members get a form, the author gets a static pill (no self-repost), guests a link.
    var rform = post.querySelector('form.js-repost');
    var repBtn = rform ? rform.querySelector('.act')
                       : (post.querySelector('.act-static') || post.querySelector('.act[title="Join Rova to repost"]'));
    if (repBtn && !engBadgeHeld('repost', vid)) {
      var rc2 = repBtn.querySelector('.cnt');
      if (rc2) { rc2.textContent = fmtCount(d.r); rc2.hidden = !d.r; }
      repBtn.setAttribute('data-optcount', String(+d.r || 0));
    }
  }

  // root:   the container whose on-screen cards decide what to ask about (#feed-posts,
  //         #profile-posts, the permalink wrap). Omitted = the whole document.
  // paused: the surface's own "hold everything" switch (the feed's pause). Other surfaces have none.
  function engRefresh(root, paused) {
    if (!engMember() || paused || document.hidden) return;
    // engBusy, but ABANDONED rather than in flight -> take it. See POLL_LATCH_MS above.
    if (engBusy && Date.now() - engBusyAt < POLL_LATCH_MS) return;
    var ids = engVisibleIds(root);
    if (!ids.length) return;              // a grid tab renders .pcell, not .post -- naturally a no-op
    engBusy = true;
    engBusyAt = Date.now();
    var gen = ++engGen;
    var sentAt = Date.now();
    rfetch('/engage-live?ids=' + ids.join(','),
          { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', cache: 'no-store' }, 8000)
      .then(function (r) { return r.json(); })
      .then(function (d) {
        // A batch the self-heal already wrote off must not clear a flag the newer batch owns, and
        // must not repaint the cards from its older snapshot.
        if (gen !== engGen) return;
        engBusy = false;
        var map = d && d.posts;
        if (!map) return;
        // ids come from the visible cards inside `root`, but paint EVERY copy in the document --
        // the immersive viewer's card and the card behind it share one data-view, and applyReact()
        // already keeps those copies in step for the reader's own taps. The same rule has to hold
        // for other people's. On a permalink this is what carries the answer into the viewer that
        // opened over the page.
        document.querySelectorAll('.post[data-view]').forEach(function (post) {
          var row = map[post.getAttribute('data-view')];
          if (!row) return;
          if (post.__engAt && post.__engAt > sentAt) return;   // a local write raced us: leave it alone
          engApply(post, row);
        });
      })
      // A non-2xx now lands HERE (rfetch rejects it) instead of arriving as a null row that could
      // walk into engApply. Nothing is repainted: the server's own render stays on screen and the
      // next tick tries again.
      .catch(function () { if (gen === engGen) engBusy = false; });
  }

  /* ---- THE VIEWER RE-ASKS THE READER'S OWN STATE (Rob 2026-10-22, batch item 44, iOS parity) -------------------
     "Full screen: like state not shown (already liked shows unliked)". /engage-live deliberately never writes the
     reader's own state (see above), so the full-screen viewer drew whatever HTML it was handed: the card cache's
     2-minute-old render (cardCache, CARD_TTL), a feed card rendered before a like made in the APP, a /post-cards
     page fetched before it. Now every ARRIVAL in the viewer (rova:pfpost -- the open's first settle and each later
     post) asks /engage-live?me=1 for the arrived post plus the next OWN_AHEAD cards and the one before, ONE batched
     GET per page of cards (ids already checked in this open are skipped; a fast swipe is debounced into one ask),
     and corrects the heart (+ super-like rim), repost, lit comment and Save on EVERY copy of that post -- but only
     where the DOM disagrees, so a correct card is never touched (no flicker).
     A LOCAL TAP WINS: a card is left alone when its like/repost/comment write is still in flight (engBadgeHeld), when
     a love burst is under the finger, or when this session wrote that post's own state within OWN_LOCAL_MS before the
     request or any time after it left (engOwnAt, stamped by engBadgeArm on arm + release and by the Save item).
     A corrected card is also dropped from the viewer's card cache, so the next open re-renders it. Members only. */
  var engOwnAt = Object.create(null);   // post id -> last local own-state write (ms)
  function engOwnNote(id) { id = String(id || ''); if (id) engOwnAt[id] = Date.now(); }
  window.__rovaOwnWrite = engOwnNote;
  (function () {
    var OWN_AHEAD = 4, OWN_BEHIND = 1, OWN_MAX = 12, OWN_DEBOUNCE = 250, OWN_LOCAL_MS = 10000;
    var asked = Object.create(null);    // id -> 1 once asked in THIS viewer open (cleared on close: a reopen re-checks)
    var want = [], ownT = 0, gen = 0, log = [];
    function idOf(p) { return p && p.getAttribute ? String(p.getAttribute('data-view') || '') : ''; }
    function sib(p, dir) {
      var n = p && (dir > 0 ? p.nextElementSibling : p.previousElementSibling);
      while (n && !(n.classList && n.classList.contains('post') && n.getAttribute('data-view') && !n.classList.contains('pf-end'))) {
        n = dir > 0 ? n.nextElementSibling : n.previousElementSibling;
      }
      return n;
    }
    function add(id) { if (/^\d+$/.test(id) && !asked[id] && want.indexOf(id) < 0) want.push(id); }
    function paintOwn(post, id, row, m, sentAt) {
      var did = [];
      var heldLocal = (engOwnAt[id] || 0) > sentAt - OWN_LOCAL_MS;   // (a copy's own __engAt is judged by the caller)
      if (heldLocal) return did;
      var btn = post.querySelector('.react-btn');
      var loveLive = engGrips.love && engGrips.love > Date.now();
      if (btn && !engBadgeHeld('like', id) && !loveLive) {
        var x = m.x || null, sl = x && (+m.v || 0) > 0;
        var onNow = btn.classList.contains('on'), rNow = btn.getAttribute('data-reaction') || null;
        if (onNow !== !!x || (x && rNow !== x) || btn.classList.contains('sl') !== !!sl) {
          applyReactToPost(post, { reaction: x, love: +m.v || 0, count: +row.l || 0, breakdown: row.b || {} });
          did.push('like:' + (x || 'none') + (sl ? '+sl' : ''));
        }
      }
      var rform = post.querySelector('form.js-repost'), rb = rform && rform.querySelector('.act');
      if (rb && !engBadgeHeld('repost', id) && rb.classList.contains('on') !== !!m.r) {
        rb.classList.toggle('on', !!m.r);
        rb.setAttribute('aria-pressed', m.r ? 'true' : 'false');
        rb.setAttribute('data-optcount', String(+row.r || 0));
        var rc = rb.querySelector('.cnt'); if (rc) { rc.textContent = fmtCount(+row.r || 0); rc.hidden = !(+row.r); }
        did.push('repost:' + (m.r ? 'on' : 'off'));
      }
      var cb = post.querySelector('.js-comments');
      if (cb && !engBadgeHeld('comment', id) && cb.classList.contains('on') !== !!m.c) {
        cb.classList.toggle('on', !!m.c); did.push('comment:' + (m.c ? 'on' : 'off'));
      }
      var sv = post.querySelector('.js-save');
      if (sv && (sv.getAttribute('data-saved') === '1') !== !!m.s) {
        sv.textContent = m.s ? 'Saved' : 'Save';
        if (m.s) sv.setAttribute('data-saved', '1'); else sv.removeAttribute('data-saved');
        did.push('save:' + (m.s ? 'on' : 'off'));
      }
      return did;
    }
    /* THE ANSWER IS KEPT FOR THE OPEN, AND RE-LAID ON LATE COPIES. The viewer places its deck a card per frame and can
       re-materialize a card (cache, loop lap, the permalink's page card cloned in) AFTER the answer landed -- measured: the
       first ask on a permalink open fixed the page card behind the viewer while the viewer's own copy did not exist yet.
       So each answer is remembered per id for this open (with the time its read left, for the local-tap test) and laid
       again over every copy on each arrival and on a short re-pass after it. No request: a known id is never re-asked. */
    var known = Object.create(null);    // id -> {row, m, sentAt}
    function applyKnown(id) {
      var k = known[id]; if (!k) return 0;
      var any = false;
      // decide EVERY copy before painting any: applyReactToPost's engTouch stamps all copies of the id, which would make
      // our own first paint read as a local write on the copies after it
      var copies = Array.prototype.slice.call(document.querySelectorAll('.post[data-view="' + id + '"]'));
      var held = copies.map(function (post) { return !!(post.__engAt && post.__engAt > k.sentAt); });
      copies.forEach(function (post, ci) {
        if (held[ci]) return;
        var did = paintOwn(post, id, k.row, k.m, k.sentAt);
        if (did.length) { any = true; log.push({ id: id, did: did, at: Date.now(), pf: !!(post.closest && post.closest('.pfeed')) }); }
      });
      if (any && window.__rovaPfCardDirty) window.__rovaPfCardDirty(id);
      if (log.length > 40) log.splice(0, log.length - 40);
      return any ? 1 : 0;
    }
    function send() {
      ownT = 0;
      if (!engMember() || document.hidden || !want.length) { want = []; return; }
      var ids = want.splice(0, OWN_MAX);
      ids.forEach(function (id) { asked[id] = 1; });
      var g = gen, sentAt = Date.now();
      rfetch('/engage-live?me=1&ids=' + ids.join(','),
            { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', cache: 'no-store' }, 8000)
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var map = d && d.posts; if (!map || g !== gen) return;
          var fixed = 0;
          ids.forEach(function (id) {
            var row = map[id], m = row && row.m;
            if (!m) return;
            known[id] = { row: row, m: m, sentAt: sentAt };
            fixed += applyKnown(id);
          });
          log.push({ ask: ids.length, fixed: fixed, ms: Date.now() - sentAt, gen: g });
          // copies the deck places in the next beats (see above)
          setTimeout(function () { if (g === gen) ids.forEach(applyKnown); }, 700);
        })
        // a failed ask leaves the card as drawn and lets a later arrival try again
        .catch(function () { ids.forEach(function (id) { if (g === gen) delete asked[id]; }); });
      if (want.length) ownT = setTimeout(send, OWN_DEBOUNCE);
    }
    function around(p) {
      var out = [idOf(p)], n = p, i;
      for (i = 0; i < OWN_AHEAD; i++) { n = sib(n, 1); if (!n) break; out.push(idOf(n)); }
      n = p;
      for (i = 0; i < OWN_BEHIND; i++) { n = sib(n, -1); if (!n) break; out.push(idOf(n)); }
      return out;
    }
    function visit(p, id) {
      var g = gen;
      var ids = around(p); if (id && ids.indexOf(id) < 0) ids.unshift(id);
      ids.forEach(function (x) { if (known[x]) applyKnown(x); else add(x); });
      if (want.length && !ownT) ownT = setTimeout(send, OWN_DEBOUNCE);
      return g;
    }
    // the deck parks its neighbours and places them a card per frame (and pages more in): one observer on the viewer's
    // list re-visits the arrived post when cards land, debounced, so late copies and late neighbours are covered
    var lastId = '', mo = null, moT = 0, moList = null;
    function revisit() {
      moT = 0;
      var here = lastId && document.querySelector('.pfeed.show .post[data-view="' + lastId + '"]');
      if (here) visit(here, lastId);
    }
    document.addEventListener('rova:pfpost', function (e) {
      var d = (e && e.detail) || {}, p = d.post, id = String(d.id || idOf(p));
      if (!p || !engMember()) return;
      lastId = id;
      visit(p, id);
      var listEl = p.parentNode;
      if (window.MutationObserver && listEl && listEl !== moList) {
        if (mo) mo.disconnect();
        moList = listEl;
        mo = new MutationObserver(function () { if (!moT) moT = setTimeout(revisit, 400); });
        mo.observe(listEl, { childList: true });
      }
    });
    document.addEventListener('rova:pfclose', function () {
      asked = Object.create(null); known = Object.create(null); want = []; gen++; lastId = '';
      if (ownT) { clearTimeout(ownT); ownT = 0; }
      if (moT) { clearTimeout(moT); moT = 0; }
      if (mo) { mo.disconnect(); mo = null; moList = null; }
    });
    window.__rovaOwnState = function () { return { asked: Object.keys(asked), known: Object.keys(known), log: log.slice(), ownAt: engOwnAt }; };
  })();

  /* ---- CLEAN VIEW: THE EYE (Rob 2026-10-22, batch item 23 + "23 FINAL") ------------------------------------------------
     An eye disc in the viewer's bottom-left control row (.vc-eye, after Pause and the fill toggle, built into BOTH bars: the
     video bar in buildControls and the photo bar in buildPhotoBar) slides every panel and button away -- top bar, More from,
     music card, caption, comment roller, action row, arrows, counter, dots, hands-free stack -- leaving only a small faded eye
     in the bottom-left corner (.pf-eye-back) that brings them back. The CSS is rova.css "CLEAN VIEW".
     RULES (Rob's FINAL): hidden stays through the SAME post -- the slideshow's auto-advance and swiping its slides do not
     announce a post (rova:pfpost fires on a post CHANGE only) -- and arriving on a DIFFERENT post (a swipe up/down, hands-free's
     own advance) brings everything back. Closing the viewer resets it. Nothing about the media's gestures changes: one tap still
     zooms, double-tap still likes, long-press still reacts (the hidden chrome takes no hits, so a tap where a button was reaches
     the picture). Hands-free keeps running: the eye is not engagement (ENG_ATTN_NOT, and its click never reaches the viewer's
     own engage-pause listener -- this one is a WINDOW capture listener, so it runs before every document / .pfeed listener).
     A wake tap re-targeted onto the in-row eye while the chrome was faded is honoured as a wake only (__rovaWakeRetarget).
     Receipt: window.__rovaCleanView(). */
  (function () {
    var EYE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12z"/><circle cx="12" cy="12" r="3"/></svg>';
    var cleanId = '', lastId = '', backBtn = null, outT = 0, log = [];
    function viewer() { return document.querySelector('.pfeed.show'); }
    function curId(box) {
      var p = box && box.querySelector('.post.pf-cvon');
      return (p && p.getAttribute('data-view')) || lastId || '';
    }
    function paint(on) {
      Array.prototype.forEach.call(document.querySelectorAll('.pfeed .vc-eye'), function (b) {
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.setAttribute('aria-label', on ? 'Show everything' : 'Hide everything');
      });
    }
    function corner(box) {
      if (!backBtn) {
        backBtn = document.createElement('button');
        backBtn.type = 'button'; backBtn.className = 'pf-eye-back';
        backBtn.setAttribute('aria-label', 'Show everything');
        backBtn.innerHTML = EYE;
      }
      if (backBtn.parentNode !== box) box.appendChild(backBtn);
    }
    function set(on, why) {
      var box = viewer() || document.querySelector('.pfeed.pf-clean');
      if (!box) { cleanId = ''; return; }
      if (on) {
        cleanId = curId(box);
        corner(box);
        clearTimeout(outT); box.classList.remove('pf-clean-out');
        box.classList.add('pf-clean');
        paint(true);
      } else {
        var was = box.classList.contains('pf-clean');
        cleanId = '';
        box.classList.remove('pf-clean');
        paint(false);
        if (!was) return;
        if (why !== 'close') {
          box.classList.add('pf-clean-out');
          clearTimeout(outT); outT = setTimeout(function () { box.classList.remove('pf-clean-out'); }, 420);
          if (window.__rovaPfWake) { try { window.__rovaPfWake(); } catch (e) {} }   // the chrome comes back awake, then idles as usual
        } else { box.classList.remove('pf-clean-out'); }
      }
      log.push({ on: !!on, why: why || '', id: cleanId || lastId, at: Date.now() });
      if (log.length > 20) log.shift();
    }
    window.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target.closest('.pfeed .vc-eye, .pf-eye-back') : null;
      if (!t) return;
      if (t.classList.contains('vc-eye') && window.__rovaWakeRetarget && window.__rovaWakeRetarget(e)) return;   // a wake, not a press
      e.preventDefault(); e.stopPropagation();
      var box = viewer();
      set(!(box && box.classList.contains('pf-clean')), t.classList.contains('pf-eye-back') ? 'corner' : 'eye');
    }, true);
    document.addEventListener('rova:pfpost', function (e) {
      var id = String((e && e.detail && e.detail.id) || '');
      if (id) lastId = id;
      if (cleanId && id && id !== cleanId) set(false, 'post');   // a DIFFERENT post brings everything back
    });
    document.addEventListener('rova:pfclose', function () { set(false, 'close'); lastId = ''; });
    window.__rovaCleanView = function () {
      var box = document.querySelector('.pfeed');
      return { on: !!(box && box.classList.contains('pf-clean')), post: cleanId, log: log.slice() };
    };
  })();

  /* ---- live engagement counts: the permalink and the profile --------------
     The feed folds its refresh into the new-post poll it was already paying for, so it added no
     timer and no extra cadence. Neither of these pages has a tick to fold into, so the cadence is
     a fresh decision rather than a copy of 8s, and the two answers differ because the pages do:

       PERMALINK (/p/<id>), 30s. One post, one set of numbers, and a leaf page: the reader arrived
       from a share, a notification or a search result to read this one thing. Nothing else on the
       page is live either -- the comment LIST here has no poll at all -- so a badge sprinting ahead
       of a static thread would be the odd one out. 30s is "it is right if you look up", which is
       what a permalink needs, at 2.0 requests/min per open member tab.

       PROFILE (?tab=all), 20s. This one IS scrolled: a stream of cards where the reader moves and
       the viewport keeps handing the batch a different 30 ids, so a stale badge is in front of them
       repeatedly rather than once. Still slower than the feed, which is the surface people sit on.
       3.0 requests/min per open member tab.

     Both also refresh on tab focus, which is the cheap half: the common shape is a tab left open
     and come back to, and that path costs one request at the moment someone is actually looking.
     Guests get NEITHER the requests nor the timer. */
  (function () {
    // The feed owns its own tick and calls engRefresh() from there; never let a second timer
    // double its cadence on the same page.
    if (document.getElementById('feed-posts')) return;
    var root = null, every = 0;
    var perma = document.querySelector('[data-pfeed-open]');       // views/post_single.php marks the wrap
    var prof  = document.getElementById('profile-posts');
    if (perma)     { root = perma; every = 30000; }
    else if (prof) { root = prof;  every = 20000; }
    else return;
    // Bail BEFORE arming anything. engRefresh() re-checks, so this is belt and braces, but it also
    // means a guest permalink -- the edge-cached page that shares and crawlers land on -- carries no
    // interval at all, not merely an interval that decides to send nothing.
    if (!engMember()) return;
    function tick() { engRefresh(root); }
    setTimeout(tick, 1500);          // first look shortly after load, once the cards have settled
    setInterval(tick, every);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) tick(); });
  })();

  /* ---- WS-C 2026-10-22: LIVE RELATIVE TIMES (Rob: "relative times update in real time") ----------------------------
     views/_post.php stamps a.time-link[data-ts] (unix); every 30 s while the page is visible, and on return to it, the
     plain-text label is re-derived with ago()'s own rules (s / m / h / d under 7 days; a date beyond that is left alone,
     and a <time class="js-lt"> is never touched). The device clock is corrected by #feed-posts[data-snow] (the server's
     clock at render), so a phone whose clock is off does not write "-3m". Feed only; text nodes only, no layout read. */
  (function () {
    var feed = document.getElementById('feed-posts');
    if (!feed) return;
    var snow = parseInt(feed.getAttribute('data-snow'), 10) || 0;
    var skew = snow > 0 ? snow * 1000 - Date.now() : 0;
    if (Math.abs(skew) < 2000) skew = 0;
    function label(d) {
      if (d < 60) return d + 's';
      if (d < 3600) return Math.floor(d / 60) + 'm';
      if (d < 86400) return Math.floor(d / 3600) + 'h';
      if (d < 604800) return Math.floor(d / 86400) + 'd';
      return '';
    }
    function tick() {
      if (document.hidden) return;
      var now = Math.floor((Date.now() + skew) / 1000);
      var els = feed.querySelectorAll('a.time-link[data-ts]');
      for (var i = 0; i < els.length; i++) {
        var a = els[i];
        if (a.childNodes.length !== 1 || a.firstChild.nodeType !== 3) continue;
        var ts = parseInt(a.getAttribute('data-ts'), 10) || 0;
        if (!ts) continue;
        var s = label(Math.max(0, now - ts));
        if (s && a.firstChild.nodeValue !== s) a.firstChild.nodeValue = s;
      }
    }
    setInterval(tick, 30000);
    setTimeout(tick, 4000);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) tick(); });
    window.__rovaTimesTick = tick;
  })();

  /* ---- WS-C 2026-10-22: THE TIMELINE PHOTO PAN IS SOFT AND ONLY ON THE SETTLED CARD (Rob, browser: "remove the rapid zoom
     of photos while scrolling the timeline") ------------------------------------------------------------------------------
     #feed-posts[data-tlkb="soft"] (k/v web_timeline_kb; 'off' = no pan, 'legacy' = the old 1.15 pan): rova.css gives
     timeline photos a 1 -> 1.035 drift that is PAUSED by default; this marks the ONE card under the reading line
     (.tl-kb-on) 450 ms after the page stops scrolling, and unmarks it the moment it moves again -- a paused animation holds
     its frame, so nothing jumps. One elementFromPoint per settle, no scroll-time layout reads. */
  (function () {
    var feed = document.getElementById('feed-posts');
    if (!feed || feed.getAttribute('data-tlkb') !== 'soft') return;
    var cur = null, t = 0;
    function pick() {
      t = 0;
      if (document.hidden) return;
      var el = null;
      try { el = document.elementFromPoint((window.innerWidth || 0) / 2, (window.innerHeight || 0) * 0.45); } catch (e) {}
      var post = el && el.closest ? el.closest('.post') : null;
      if (post && post.parentNode !== feed) post = null;
      if (post === cur) return;
      if (cur) cur.classList.remove('tl-kb-on');
      cur = post;
      if (cur) cur.classList.add('tl-kb-on');
    }
    window.addEventListener('scroll', function () {
      if (cur) { cur.classList.remove('tl-kb-on'); cur = null; }
      if (t) clearTimeout(t);
      t = setTimeout(pick, 450);
    }, { passive: true });
    setTimeout(pick, 1200);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) { if (t) clearTimeout(t); t = setTimeout(pick, 300); } });
  })();

  /* ---- realtime feed: trickle new posts in + collapse chrome when idle ----- */
  (function () {
    var wrap = document.getElementById('feed-wrap');
    var feed = document.getElementById('feed-posts');
    var tabs = document.getElementById('feed-tabs');
    if (!wrap || !feed) return;
    var topbar = document.querySelector('.topbar'); // header lives outside #feed-wrap
    if (topbar) topbar.style.transition = 'margin-bottom .55s cubic-bezier(.4,0,.2,1)'; // smooth even if CSS is stale
    // Expose the header height so the tabs can stick right below it. This was a
    // byte-identical SECOND copy of the site-wide writer near the top of this file
    // (same read off <body>, same conditional write to <html>, its own resize
    // listener); removed 2026-08-06 in favour of one source of truth. The site-wide
    // one owns the resize listener AND the ResizeObserver now, so all this needs is
    // a measurement at feed-init time -- which is what the local copy's own call
    // provided, and it is kept so nothing here depends on parse ORDER.
    if (window.__rovaSetTopbarH) window.__rovaSetTopbarH();

    var POLL_MS = 8000;    // ask the server for new posts this often (5-10s window)
    var REVEAL_MS = 2500;  // reveal at most one post this often, time to actually read it (= SPEEDS.normal below: the gear's default is "Normal"; 4400 -> 2500 on 2026-09-29, Rob: "2.5 for both")
    var TOP_GUARD = 260;   // only auto-reveal when the reader is near the top
    /* THE FOLD, 2026-09-29 (owner, iOS build 529 parity: "I only want 5 seconds of idle time 8 is too long").
       This line was `IDLE_MS = 4500`, dead since the 08-11 cut. It is the fold's clock again: FOLD_IDLE_MS of
       quiet at the top folds the chrome (an open composer/search tucks, guarded) and STARTS the roll -- a roll
       fetch now plus a reveal FOLD_PRIME_MS later, then the gear's cadence. See "THE 5 s FOLD" below. */
    var FOLD_IDLE_MS = 5000, FOLD_PRIME_MS = 600, DRAFT_HOLD_MS = 30000;
    /* IDLE BEFORE THE FEED MOVES BY ITSELF (owner, 2026-09-18: "I need more time to see or read the post first").
       Until today the timeline had NO idle-since-interaction gate at all: reveal() ran every REVEAL_MS from load
       and only the holds in feedBusy() (overlays, an unmuted clip, a resting pointer) could stop it -- a reader who
       had just scrolled back to the top, or nudged the pointer, got the next card on the very next beat. The app
       gates both halves on its idle clock, and its values were doubled today; these are the same two numbers so
       the platforms read side by side: a QUEUED reveal (a card inserted at the top) waits REVEAL_IDLE_MS since
       the last pointer / touch / key / wheel / scroll, and the watch-mode TOP-UP roll (the fetch that keeps the
       queue fed) waits ROLL_IDLE_MS. The CADENCE (REVEAL_MS, the gear) is deliberately NOT doubled: it is the
       reader's own speed setting and must keep meaning what the panel says. A reader who never touches the page
       sees exactly the cadence they chose; a reader who does gets this much quiet first. */
    var REVEAL_IDLE_MS = 2400;   // a queued card may take the top only after this much quiet (app: 1.2 -> 2.4 s)
    var ROLL_IDLE_MS   = FOLD_IDLE_MS;   // the ambient roll fetch waits this much quiet = the fold (2026-09-29: tied, 5 s; must never exceed it)
    var lastAct = Date.now();    // loading the page is the reader's own act: the first card they see is the one they came for
    ['pointerdown', 'pointermove', 'keydown', 'wheel', 'touchstart'].forEach(function (ev) {
      window.addEventListener(ev, function () { lastAct = Date.now(); }, { passive: true, capture: true });
    });
    // window.__rovaScrollAt is the site-wide scroll stamp (the grid cascade reads the same one). A scroll the
    // prepend itself caused (insertTop's place-keeping correction, inside its suppressScrollUntil window) is the
    // feed's own doing, not the reader's, and must not push the next reveal out.
    /* PAGE SCROLLS ONLY (2026-09-29). window.__rovaScrollAt is stamped by a CAPTURE-phase listener, so it
       also counts every ELEMENT scroll -- and the suggestion carousel (.sugg-carousel-view) auto-advances
       every 3.2 s on its own, so on Discover the quiet never reached 5 s and the roll NEVER started (measured:
       4 carousel scrolls in 14 s, 0 rolled cards). A reader's own element scroll always arrives with a
       pointer / touch / wheel / key, which lastAct already sees, so the page's own scroll is the only scroll
       this clock needs. Stamped from the one merged scroll listener at the foot of this block. */
    var pageScrollAt = 0;
    function idleFor(ms) {
      var now = Date.now();
      if (now - lastAct <= ms) return false;
      var sAt = pageScrollAt;
      var own = sAt && sAt <= suppressScrollUntil && sAt >= suppressScrollUntil - 350;
      return own || (now - sAt > ms);
    }
    /* THE MEDIA RING INSERTS ABOVE THIS TIMELINE FROM ITS OWN MODULE (the foot of this file), so it needs
       the same "that scroll was ours" stamp insertTop sets when it corrects the reader's place. Without it
       idleFor() above would read the ring's one-shot correction as the READER moving and push the next
       reveal out by REVEAL_IDLE_MS. One exported setter rather than a second copy of the variable. */
    window.__rovaFeedOwnScroll = function () { suppressScrollUntil = Date.now() + 350; };
    var MAX_QUEUE = 20;    // under a flood, hold only the newest N pending
    var MAX_DOM = 90;      // cap posts kept in the DOM (trim oldest off the bottom)
    var ROLL_LIMIT = 6;    // page size for the ambient "roll" walk

    var seen = {}, queue = [], cursor = 0, curTab = 'trending', polling = false, paused = false;   // site default tab, 2026-08-10
    var rollOffset = 0, rollFetching = false, rollCooldownUntil = 0, suppressScrollUntil = 0;
    // in-flight bookkeeping for the two pollers below: when the flag went up, and which request
    // owns it. Both exist so a stalled read cannot leave the feed dead for the session -- the whole
    // reasoning is on POLL_LATCH_MS, next to /engage-live above.
    var pollAt = 0, pollGen = 0, rollAt = 0, rollGen = 0;
    var holdRevealUntil = 0;   // just posted a video: freeze the roll so it doesn't scroll over the clip
    try { paused = localStorage.getItem('rova_feed_paused') === '1'; } catch (e) {}
    // user-chosen watch speed (Settings -> Timeline / feed gear): how fast content rolls in
    var SPEEDS = { slow: 7200, normal: 2500, fast: 2100, faster: 1170 };   // 2026-09-29 Rob: NORMAL = 2500 on web AND app ("2.5 for both"; was 4400); the rest unchanged. 2026-09-04 owner: "too fast, make each level slower" -- same ratios as the
                                                                           // grid cascade's SPEED_MULT (slow x2, normal x2, fast x1.75, faster x1.67; was 3600/2200/1200/700)
    try { var sp = localStorage.getItem('rova_feed_speed'); if (sp && SPEEDS[sp]) REVEAL_MS = SPEEDS[sp]; } catch (e) {}
    // the feed gear changes speed live, no reload needed: update REVEAL_MS AND reschedule
    // the reveal timer so the new cadence takes hold immediately (one tap, not two).
    document.addEventListener('rova:speed', function (e) {
      if (e.detail && SPEEDS[e.detail]) { REVEAL_MS = SPEEDS[e.detail]; scheduleReveal(); }
    });

    function tabFromDom() {
      var on = tabs && tabs.querySelector('.js-tab.on');
      var m = on && (on.getAttribute('href') || '').match(/tab=(\w+)/);
      return m ? m[1] : 'trending';   // site default tab since 2026-08-10 (was 'discover')
    }
    // Seed the dedup set + cursor from whatever's already rendered.
    function reindex() {
      seen = {}; cursor = 0;
      feed.querySelectorAll('.post[data-id]').forEach(function (el) {
        var id = parseInt(el.getAttribute('data-id'), 10) || 0;
        if (id) { seen[id] = true; if (id > cursor) cursor = id; }
      });
    }
    // The tab pager can swap #feed-posts out from under us, re-anchor on change.
    function syncTab() {
      var t = tabFromDom();
      if (t !== curTab) { curTab = t; queue = []; reindex(); if (typeof firstArm === 'function') firstArm('tab'); }   // a swiped tab change too (THE FIRST CARD'S GRACE)
    }
    curTab = tabFromDom();
    reindex();

    function poll() {
      if (paused || document.hidden) return;
      if (polling && Date.now() - pollAt < POLL_LATCH_MS) return;   // abandoned, not in flight
      if (engaged()) return;   // engage-hold: no fetching new posts while the reader is inside one
      syncTab();
      if (curTab === 'grid') return;   // the media grid is not a live-prepending stream
      /* NOR IS TRENDING (owner 2026-08-10). It is a 72h ranked feed; splicing chronological
         arrivals into the top of it makes its ordering mean two things at once -- and it was doing
         so with the wrong population besides, since Posts::since() has no 'trending' arm and fell
         through to Discover. The server refuses this now too; skipping it here just saves the trip.
         What is new on Trending is announced by the pill, which takes him to New to read it. */
      if (curTab === 'trending') return;
      if (cursor <= 0) return; // nothing to anchor to (e.g. an empty feed)
      polling = true;
      pollAt = Date.now();
      var gen = ++pollGen;
      rfetch('/feed?tab=' + encodeURIComponent(curTab) + '&partial=posts&since=' + cursor,
            { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', cache: 'no-store' }, 8000)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          if (gen !== pollGen) return;   // a newer poll owns the flag now
          polling = false;
          if (!html || !html.trim()) return;
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          // server returns newest-first; reverse so we reveal oldest-first and the
          // newest post always lands on top.
          var nodes = Array.prototype.slice.call(tmp.querySelectorAll('.post[data-id]')).reverse();
          nodes.forEach(function (node) {
            var id = parseInt(node.getAttribute('data-id'), 10) || 0;
            if (!id || seen[id]) return;
            seen[id] = true;
            if (id > cursor) cursor = id;
            queue.push(node);
          });
          if (queue.length > MAX_QUEUE) queue = queue.slice(queue.length - MAX_QUEUE);
        })
        // Nothing is queued or prepended on a failure -- the feed keeps exactly what the server
        // rendered and the next 8s tick asks again.
        .catch(function () { if (gen === pollGen) polling = false; });
    }

    /* ---- live engagement badges -------------------------------------------
       The refresh itself (engRefresh / engVisibleIds / engApply, and the happens-before test that
       keeps it off a card the reader just touched) is shared with the permalink and the profile --
       it lives at the top level of this file's main IIFE, above. Search for "one refresh, three
       surfaces" for the whole rationale.

       What is FEED-specific and stays here: the root (only the cards inside #feed-posts decide what
       to ask about) and the cadence. The cadence is the cheap part of this surface: the refresh
       folds into the SAME tick as the new-post poll -- no second timer, no extra request, because
       the browser was going to talk to the origin on that beat anyway -- and it inherits the post
       poll's own gates, the pause switch included. */
    function refreshCounts() { engRefresh(feed, paused); }

    // Sit-back watch mode: at the very top with the chrome faded away.
    function watching() {
      return window.scrollY <= 8 && wrap.classList.contains('chrome-idle')
          && !document.documentElement.classList.contains('fsrch-sheet');   // never roll under the search sheet
    }
    // The reader is actively interacting with / viewing content, hold the roll:
    // any overlay open (menu, lightbox, gallery, comment panel, pickers, modal,
    // search) or the pointer resting on a post.
    var CAN_HOVER = !(window.matchMedia && window.matchMedia('(hover: none)').matches);
    var busySndLeft = 0;   // set by feedBusy(): ms left on an AUTOMATIC sound hold when that is what held it
    function feedBusy() {
      if (engaged()) return true;   // engage-hold: a named engagement hold (tapped video, live embed, comments, share)
      if (engAttn()) return true;   // attention hold: they just engaged with a post -- nothing hides, nothing moves (see the ATTENTION block)
      // THE HAND (batch item 46): a finger / pointer down, an open sheet, or <= 1.5 s after either -- nothing moves under it.
      // A focused field is left to the fold's own composer holds (a stray focused search box must not stop the roll for good).
      var handWhy = engHandWhy();
      if (handWhy && handWhy !== 'type') return true;
      if (document.body.classList.contains('modal-open')) return true;
      /* THE IMMERSIVE VIEWER IS AN OVERLAY TOO, AND IT WAS THE ONE MISSING FROM THIS LIST (2026-09-18).
         Rob, from the app: "the feed keeps playing underneath the full-screen viewer when it is opened
         from the media-ring circles" -- the app team found their freeze hung off the tapped CARD's
         flight, not the viewer, so an origin-less open (the ring) never froze anything. The web was
         measured for the same shape (scratchpad ringfreeze/, Chromium + WebKit, 390 + desktop) and the
         gap here is GENERAL, not ring-specific: every other overlay below holds the ambient roll, but
         `.pfeed.show` did not, and reveal()'s own position guards cannot save it because the viewer's
         scroll lock pins <body> at position:fixed, so window.scrollY reads 0 for as long as it is up --
         TOP_GUARD passes, watching() passes, and the timeline rolled fresh cards in under the viewer
         on BOTH open paths (15 inserts + 15 trims in an 18 s open on Following, 10 roll fetches, their
         thumbnails downloaded, the top post changed, all behind an opaque overlay). The grid tab was
         already right: its cascade asks __rovaOverlayOpen() and its pans pause under html.pfv-on.
         So the timeline asks the same question the grid asks -- the viewer's OWN session state
         (`.show` is set by every opener and cleared by the one close()), never a flight or a tap -- and
         the resume is implicit: the class leaves with the viewer and the next reveal tick proceeds
         with the queue it kept, compensated by the true scrollY the unlock has restored by then.
         Badge-class pollers (/poll-counts, /engage-live, the newcount pill, the since-poll that only
         QUEUES) deliberately keep running: none of them moves a row. */
      if (document.querySelector('.comment-panel.open, .pmenu-panel.show, .lightbox.show, .gal.show, .rx-modal.show, .emoji-pop.show, .gif-pop.show, .search-results.show, .pfeed.show')) return true;
      // web#13: an UNMUTED video playing on screen = someone is actually watching --
      // folding the chrome (or rolling posts in) shifts the clip out from under
      // their eyes mid-watch. Muted autoplay is ambient and doesn't count, so
      // watch mode still engages on a quiet scroll.
      /* 2026-09-29 (Rob, iOS build 533): "only 'hold' until the video is over or either 5 seconds max then keep
         going unless the user intervenes". An AUTOMATICALLY audible clip (sound following the playing card)
         holds for sndAutoLeft() -- at most SND_AUTO_MS from when it became audible, less if its play ends
         first -- and then counts as ambient. A clip the member tapped / unmuted themselves (_userPlayed,
         _sndHand) holds until it is over, uncapped. See THE AUDIBLE CLIP'S HOLD HAS A LENGTH (by engVideo).
         busySndLeft tells the fold exactly when an automatic hold lapses (0 = not the reason). */
      busySndLeft = 0;
      var vids = feed.querySelectorAll('.post video');
      for (var i = 0; i < vids.length; i++) {
        var v = vids[i];
        if (v.paused || v.ended) continue;
        // engage-hold: a clip the reader TAPPED counts even while muted (they chose it). Ambient muted autoplay
        // still doesn't -- _userPlayed is stamped only by the tap handlers, never by autoplay-on-scroll.
        if (v.muted && !v._userPlayed) continue;
        var r = v.getBoundingClientRect();
        if (!(r.bottom > 0 && r.top < (window.innerHeight || 800))) continue;
        if (v._userPlayed || v._sndHand) return true;       // EXPLICIT: until it is over
        var sl = sndAutoLeft(v);                             // AUTOMATIC: a length, never a lock
        if (sl > 0) { busySndLeft = sl; return true; }
      }
      // Only a REAL resting pointer holds the roll. On TOUCH, :hover is sticky -- tapping a post's like
      // button leaves that .post stuck :hover until you tap elsewhere, which froze the timeline the moment
      // you liked something and never let it resume. Skip the hover check where hover isn't real.
      return CAN_HOVER && !!feed.querySelector('.post:hover');
    }
    // When watching and nothing new is queued, walk the whole platform, most
    // engaged first, unseen last, then loop, so content never stops rolling.
    function maybeRoll() {
      if (curTab === 'grid') return;   // grid: the roll is served through the immersive viewer, not prepended here
      if (curTab === 'new' && newPureOn()) return;   // WS-C 2026-10-22: pure New is reverse-chronological -- no ranked roll on top of it
      if (paused || !watching() || Date.now() < rollCooldownUntil) return;
      if (!idleFor(ROLL_IDLE_MS)) return;   // 2026-09-18: the top-up roll waits for the reader to have been still a while
      if (rollFetching && Date.now() - rollAt < POLL_LATCH_MS) return;   // abandoned, not in flight
      if (engaged()) return;   // engage-hold
      if (engAttn()) return;   // attention hold
      rollFetching = true;
      rollAt = Date.now();
      var gen = ++rollGen;
      // Roll ALL tabs when idle, but scoped to the current tab (the server filters Following to people
      // you follow, New to recent accounts, Discover to the public firehose) -- most-engaging first.
      rfetch('/feed?partial=posts&roll=' + rollOffset + '&tab=' + encodeURIComponent(curTab),
            { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', cache: 'no-store' }, 8000)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          if (gen !== rollGen) return;   // a newer roll owns the flag now
          rollFetching = false;
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var nodes = Array.prototype.slice.call(tmp.querySelectorAll('.post[data-id]'));
          if (!nodes.length) { rollOffset = 0; rollCooldownUntil = Date.now() + 20000; return; }
          // WHERE THE NEXT ROLL PAGE STARTS, off the server's sentinel and not off the cards we can
          // see. nodes.length is the RAW page minus whatever Moderation::screen took out of it, so
          // one shadow-phrase post in a page of six read as "short page -> wrapped" and restarted
          // the walk at 0 mid-scroll -- and when it did advance, it advanced by the screened count,
          // so the offset drifted BACKWARDS and re-served rows. Same fix api_feed's roll branch got.
          // The fallback keeps an old cached bundle working against a new server and vice versa.
          var rf = tmp.querySelector('.feed-roll-flag');
          if (rf && rf.getAttribute('data-rollnext') !== null) {
            rollOffset = parseInt(rf.getAttribute('data-rollnext'), 10) || 0;
          } else {
            rollOffset = (nodes.length < ROLL_LIMIT) ? 0 : rollOffset + nodes.length; // loop at the end
          }
          nodes.forEach(function (node) {
            if (!(parseInt(node.getAttribute('data-id'), 10) || 0)) return;
            node.setAttribute('data-roll', '1'); // roll content may re-surface, that's the "repeat"
            queue.push(node);
          });
          // SAME CAP AS poll(). This was the one producer of `queue` with no ceiling, which only
          // stopped mattering by accident (maybeRoll runs at queue.length <= 2). Now that the pill
          // exists, the queue's length IS a unit of work the reader can trigger with one tap, so both
          // producers have to bound it -- keep the newest, exactly like poll() does.
          if (queue.length > MAX_QUEUE) queue = queue.slice(queue.length - MAX_QUEUE);
          if (foldPrimeUntil) foldPrimeLanded();   // the fold's own roll came back: land it on the prime, not a full tick later
        })
        // rollOffset and rollCooldownUntil are deliberately UNTOUCHED here: only a 200 that genuinely
        // came back empty may reset the walk or start a cooldown. A failed read must not be able to
        // rewind the roll or stall it for 20s -- that is the latch this file already learned about
        // the hard way in ensureBuf's .catch.
        .catch(function () { if (gen === rollGen) rollFetching = false; });
    }

    /* ---- AN OPAQUE PLAYER IS THE ONE THING feedBusy() COULD ONLY GUESS AT ----------------------
       Owner 2026-08-07: "I pressed the play button on this player but a second later a new post
       loaded on the timeline, which stopped the post from playing and pushed it out of view...
       Auto loading of posts should only be for idle and it should pause when users interact."

       feedBusy() tests a <video> STRUCTURALLY, right above: .paused, .muted, _userPlayed, its rect.
       A third-party frame answers none of those -- it is cross-origin and tells us nothing -- so an
       embed was protected ONLY by engaged(), i.e. by engEmbed(), i.e. by two signals that both miss
       the tap that matters:
         - the document `pointerdown` handler needs e.target.closest('.embed'), and an event inside a
           cross-origin frame NEVER reaches this document (that handler's own comment says so). The
           green play button is inside the frame.
         - which leaves exactly one signal: window blur + document.activeElement being the IFRAME.
       MEASURED 2026-08-07 (tools/pw/embed-focus-primitive.js: a real cross-origin frame, a real CDP
       touch) -- that blur signal DOES fire, on Chromium and on desktop WebKit. It is still the wrong
       thing to bet someone's audio on: it is a FOCUS heuristic, it is the ONLY signal there is, and
       the engine it has to hold on is Mobile Safari, which is the one engine this box cannot run.
       That is [[engagement-attention-hold]]'s checkbox-`.value` trap exactly: assume the signal
       fires and the whole mechanism is silently dead in production.

       So the reveal asks the STRUCTURAL question instead, the same kind it already asks of video:
       is there a LOADED provider frame on the reader's screen? initEmbeds' observer parks every
       frame that leaves the viewport by 150px by REPLACING it with a src-less clone, so
       "has a src AND is on screen" IS "a live third-party document is in front of the reader" --
       and moving it is what destroys it (that replaceChild is what stopped his music: an iframe
       does not survive being pushed out of the keep-alive band, and the post does not have to leave
       the viewport for that to happen).
       This gates the MOVER only. poll() still fetches and the queue still fills; what was queued
       comes back through the "N new posts" pill below, so nothing is lost and the feed can never
       wedge into "no new content, no way to ask for it". */
    function liveEmbedOnScreen() {
      var vh = window.innerHeight || 800;
      // .embed iframe[src] = a provider document that is actually alive (a parked clone has no src
      // attribute, only data-src).
      /* 2026-10-03 (Rob: "it goes to 'Held' on the post for way too long ... should follow the same rules as all
         other posts"): our own Apple Music card is NO LONGER counted here. Its preview now repeats while the
         reader stays, so "a song is playing on screen" never ends -- the feed would stop moving for good. A song
         holds nothing by itself; a song the MEMBER started holds through engHold('amplay') (feedBusy -> engaged())
         while it plays, and the tap arms the attention hold like any other post interaction. An autoplayed song
         stops when the feed moves its card away (scrolling away pauses the song). */
      var els = feed.querySelectorAll('.embed iframe[src]');
      for (var i = 0; i < els.length; i++) {
        var r = els[i].getBoundingClientRect();
        if (r.bottom > 0 && r.top < vh) return true;
      }
      return false;
    }

    /* THE ONE PLACE A CARD IS PUT ON TOP OF THE TIMELINE. reveal() and the pill's flush both go
       through here so the "don't move the reader" rule cannot be true on one path and false on the
       other. `keepPlace` compensates the scroll by the MEASURED shift, so nothing below the
       insertion point moves a pixel -- see the note on #feed-posts{overflow-anchor:none} in
       rova.css: the browser's own anchoring is deliberately off here (and Safari has never
       implemented it at all), which is why this has to be done by hand rather than left to CSS.
       Returns false if the node was dropped rather than inserted. */
    function insertTop(node, keepPlace) {
      if (window.__rovaPostGone && window.__rovaPostGone(node)) { return false; }   // queued before it was deleted
      var id = parseInt(node.getAttribute('data-id'), 10) || 0;
      var existing = id ? feed.querySelector('.post[data-id="' + id + '"]') : null;
      if (existing) {
        // A fresh (real-time) post that's already shown -> drop it. Roll content is
        // allowed to REPEAT: pull the old copy and re-surface it at the top, but
        // only while sitting back watching, never yanking a post mid-interaction.
        if (!node.hasAttribute('data-roll') || !watching()) return false;
        if (existing.parentNode) existing.parentNode.removeChild(existing);
      }
      // Measure AFTER any removal above and BEFORE the insert, on a card that is certain to survive
      // both, so the correction is the real layout shift (margins included) rather than a guess at
      // the new card's height.
      var ref = keepPlace ? feed.querySelector('.post[data-id]') : null;
      var refTop = ref ? ref.getBoundingClientRect().top : 0;
      node.classList.add('stream-in');
      feed.insertBefore(node, feed.firstChild);
      suppressScrollUntil = Date.now() + 350; // ignore any scroll the prepend (or the correction) causes
      if (ref && ref.isConnected) {
        var d = Math.round(ref.getBoundingClientRect().top - refTop);
        if (d) {
          var se = document.scrollingElement || document.documentElement;
          se.scrollTop = se.scrollTop + d;   // instant, never smooth: this is a correction, not a move
        }
      }
      if (typeof initCarousels === 'function') initCarousels(node);
      if (typeof initEmbeds === 'function') initEmbeds(node);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { node.classList.add('in'); });
      });
      setTimeout(function () { node.classList.remove('stream-in', 'in'); }, 900);
      return true;
    }
    // trim the tail so the DOM can't grow forever under a long flood
    function trimTail() {
      var posts = feed.querySelectorAll('.post[data-id]');
      for (var i = posts.length - 1; i >= MAX_DOM; i--) {
        var pid = parseInt(posts[i].getAttribute('data-id'), 10) || 0;
        if (pid) delete seen[pid];
        if (posts[i].parentNode) posts[i].parentNode.removeChild(posts[i]);
      }
    }

    /* ---- "N new posts" ---------------------------------------------------------------------------
       OWNER, 2026-08-10: "it says 9 new posts and when i tap it it scrolls up and starts showing new
       posts in the trending tab. that's not ok, and it's telling me 9 new posts everytime i load the
       page and start to scroll even if i've seen them before ... make it scroll up AND go to the new
       tab if pressed and only show it if REAL new posts I haven't seen before have been posted since
       with the correct number of new posts."

       WHAT THIS PILL USED TO BE, and why both halves of his report were the same root cause.
       It counted `queue` -- the cards this page had FETCHED and was holding back -- and the queue was
       filled by poll(), anchored to `cursor`, and `cursor` was seeded by reindex() from the largest
       data-id CURRENTLY RENDERED. On a chronological tab that is roughly the newest post and the
       anchor behaves. On TRENDING, the site default since this morning, it is wrong by construction:
       the tab is ranked by trend_score over 72h, so the newest id it happens to render is not the
       newest id that EXISTS, and Posts::since() had no 'trending' arm besides -- it fell through to
       the DISCOVER firehose. So every load re-derived the same too-low anchor from the DOM, asked
       "what is newer than that", and got back the same nine posts it had got last time. Nothing was
       remembered between loads, so "I have seen these" was not a thing the page could even express.
       And tapping it spliced those chronological arrivals into a RANKED feed, which is the "starts
       showing new posts in the trending tab" half.

       WHAT IT IS NOW. The count comes from the server (/feed?partial=newcount -> new_posts_badge),
       measured against users.feed_seen_id, a DURABLE per-viewer high-water mark that survives
       reloads, tab switches and a change of device (db/0140). The server applies every visibility
       rule the feed itself applies -- blocks, mutes, silent suppression, the four NSFW category
       levels, still-encoding media, verified-only, muted terms, shadow phrases -- and excludes his
       own posts, so the number describes exactly what he would be shown. The mark advances when he
       is ACTUALLY SHOWN the newest posts: the New tab's first render (server-side), and a card the
       stream inserted at the top of his screen (the beacon below). Never merely on load, or the pill
       could never appear; never only on tap, or a reload re-announces.

       THE QUEUE IS NO LONGER WHAT THE PILL IS ABOUT. Held-back posts are still not lost -- reveal()
       drains them on its own the moment the hold lifts, exactly as before -- and the tap still
       flushes them when he is already on New. */
    var pill = null;
    /* THE STUCK PILL (owner 2026-08-10, second report: "It keeps saying 1 new post even though I
       click it and saw the new post already on the native app and web app").
       PERMANENT BY CONSTRUCTION, and the proof is one row. The count is measured over the whole
       public firehose (Posts::newSince), but the mark could only ever be advanced by two events:
       the New tab's page-one render, and a card the realtime stream inserted at the top. New is
       Posts::byNewUsers -- members who joined in the last 45 days, and it only falls through to the
       firehose when that windowed set cannot fill the page. On this platform it fills it easily.
       Measured on his account: the counted post was 41746 by @chef_no_boo, who joined 175 days ago;
       New's page one was [41742, 41728, 41726, 41725, 41721, 41714, 41710, 41708, 41704], all
       within the window, and its newest -- 41742 -- was already exactly his mark. So the post being
       announced could never appear on the tab the pill sends him to, the mark could never reach it,
       and no number of taps or reloads could ever clear it.
       THE FIX: the TAP advances the mark, to the `top` the server quoted with the count. Tapping is
       him asking for the announcement to be discharged, and it is the one event that is guaranteed
       to exist for every counted post, on every tab, on both surfaces -- so "counted" and "can be
       marked seen" are finally the same set. It clears exactly what was announced and not one row
       more: `top` is the newest SURVIVING arrival at the moment of the count, and the server takes
       a GREATEST, so posts that arrive between the count and the tap are still news afterwards.
       Deliberately NOT solved by advancing on some other render: that would zero the pill for posts
       he genuinely has not been shown, which is the opposite failure and the worse one. */
    var newN = 0, newTop = 0, newMore = false;          // last count RECEIVED from the server, never invented here
    var cntBusy = false, cntAt = 0, cntGen = 0;         // same in-flight bookkeeping as poll()/maybeRoll()
    var seenSent = 0;                                   // highest id already reported to /feed/seen

    /* IS THE PILL TURNED ON AT ALL? (NEW_POST_PILL in config.php -- read that block first.)
       Owner 2026-08-10: "I don't like the 1 new post thing hide it for now." The server already
       answers n = 0 while it is off, so the pill could not draw either way; this flag is what stops
       the page ASKING -- a hidden feature that still spends a request every 8s on a phone with one
       bar is worse than a visible one. lib/view.php emits <meta name="rova-newpill"> ONLY in the on
       state, so its absence is the off state and there is nothing in the DOM to hide. Read ONCE at
       boot, not per tick: it is a constant on the server, so it cannot change under a live page,
       and a querySelector on every 8s tick would be a pointless per-tick tax.
       TO TURN IT BACK ON: flip the constant. The next page load carries the meta and everything
       below wakes up -- no rebuild of this file, no OTA; the app half reads the same switch off
       /me. What stays running either way is the /feed/seen beacon (reportSeen, below): it is
       event-driven and de-duplicated, never a timer, and it is what keeps the high-water mark
       tracking reality so re-enabling announces news rather than a backlog. */
    var pillOn = !!document.querySelector('meta[name="rova-newpill"]');

    /* Ask the server how many genuinely-unseen posts exist. Rides the SAME 8s tick as the post poll
       and the badge refresh -- no third timer, no extra beat against an origin that tops out near
       150 req/s. Guests never ask: they have no high-water mark, so there is nothing to count. */
    function fetchNewCount() {
      if (!pillOn) return;   // hidden: no request, on any tick, from anywhere (NEW_POST_PILL)
      if (!engMember() || document.hidden) return;
      if (cntBusy && Date.now() - cntAt < POLL_LATCH_MS) return;   // abandoned, not in flight
      cntBusy = true;
      cntAt = Date.now();
      var gen = ++cntGen;
      rfetch('/feed?partial=newcount',
            { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', cache: 'no-store' }, 8000)
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (gen !== cntGen) return;   // a newer read owns the flag now
          cntBusy = false;
          /* DO NOT REPAINT A COUNT YOU DID NOT RECEIVE. /engage-live's incident was exactly this:
             correct server numbers overwritten by a client that had nothing to say. A malformed or
             empty body leaves the pill showing whatever the last good answer was. */
          if (!d || typeof d.n !== 'number') return;
          // `top` is not decoration: it is the ceiling a tap is allowed to mark seen. `mark` stays
          // diagnostic -- this page never computes the mark, it only ever quotes the server back.
          newN = d.n; newMore = !!d.more; newTop = d.top | 0;
          pillPaint();
        })
        .catch(function () { if (gen === cntGen) cntBusy = false; });   // a failed read changes nothing on screen
    }

    /* Tell the server he has now been shown everything up to $id. Fired ONLY from the reveal path,
       for a chronological arrival the feed actually put at the top of his screen -- never on load,
       never for ambient roll repeats, never speculatively. POST, because it moves a durable mark and
       a mutating GET is the mistake /u/{token} already taught this codebase. Monotonic on the server
       (GREATEST), and monotonic here too, so a re-fire is free. */
    function reportSeen(id) {
      id = id | 0;
      if (!id || id <= seenSent || !engMember()) return;
      var tok = (document.querySelector('meta[name="csrf-token"]') || {}).content || '';
      if (!tok) return;   // an edge-cached / session-free render has no token; nothing to report anyway
      seenSent = id;
      rfetch('/feed/seen', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' },
        credentials: 'same-origin',
        body: '_csrf=' + encodeURIComponent(tok) + '&id=' + id
      }, 8000).then(function () {
        // The mark moved, so the count is stale by definition -- re-read it rather than doing the
        // arithmetic locally and hoping the server agrees.
        newN = 0; pillPaint(); setTimeout(fetchNewCount, 600);
      }).catch(function () { seenSent = 0; });   // let the next reveal try again
    }

    /* CHUNKED, NEVER ONE SYNCHRONOUS DRAIN (2026-08-08, freeze audit).
       This was `while (queue.length) { insertTop(queue.shift(), false); }` -- the whole queue in ONE
       task, on a tap. insertTop() is not cheap per node: it runs initCarousels() and initEmbeds() on
       the card and takes a getBoundingClientRect() straddling the insert, i.e. a FORCED SYNCHRONOUS
       LAYOUT per post against a feed that already holds up to MAX_DOM cards. Measured on a 4x-throttled
       phone profile, inserting one roll page of 6 posts costs 800-1200ms of blocking (LoAF attribution
       on /p/15076 and /feed); the queue holds up to MAX_QUEUE = 20 plus whatever the roll added, so the
       old shape put a multi-second, un-interruptible freeze behind a single tap -- and the longer the
       reader stayed engaged (which is precisely when the pill appears at all), the longer the freeze.
       Batching across animation frames leaves the END STATE byte-for-byte identical -- same nodes, same
       order (insertTop always prepends, so shifting the oldest first still lands the newest on top),
       same trim, same scroll -- and gives the compositor a frame between batches, so the page keeps
       answering the reader while it lands. Re-entrant taps are absorbed by `flushing`: the queue is the
       shared cursor, so a second tap mid-flush is already being served by the pass in flight. */
    var flushing = false;
    function pillFlush() {
      if (pill) pill.hidden = true;
      holdRevealUntil = 0;
      if (flushing) return;                       // a pass is already draining this same queue
      flushing = true;
      // Deliberate: the reader ASKED for these, so they land at the top and the page goes with them.
      // keepPlace is false for the same reason -- holding their place would hide what they tapped for.
      // rAF is the right beat -- it paces the batches to what the compositor can actually show -- but it
      // does NOT run in a hidden tab, and a flush left half-drained with `flushing` still set would wedge
      // the pill until the reader came back. A backgrounded flush has nothing to pace against anyway, so
      // fall through to a macrotask there. Exactly one of the two is ever scheduled per batch.
      var next = function (fn) { if (document.hidden) { setTimeout(fn, 0); } else { requestAnimationFrame(fn); } };
      (function step() {
        for (var i = 0; i < 3 && queue.length; i++) { insertTop(queue.shift(), false); }
        if (queue.length) { next(step); return; }
        flushing = false;
        trimTail();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      })();
    }
    /* THE TAP: scroll to the top AND land on New (owner's words). The destination is ALWAYS New,
       from every tab, because New is the chronological tab and chronological arrivals are the only
       thing this count describes -- sending him anywhere else would show him a different set from
       the one the number promised. Already on New: there is nowhere to go, so it means "top of the
       feed, and give me what you were holding", i.e. the flush.
       The tab is addressed BY NAME (data-tab="new"), never by position. Nothing on this platform
       stores a tab index -- the strip re-orders per member around their default -- so a positional
       lookup here would land on a different tab for different people. */
    function pillTap() {
      if (pill) pill.hidden = true;
      /* DISCHARGE THE ANNOUNCEMENT FIRST, before anything can navigate or fail. This is the line
         that fixes the stuck pill (see the block header): it marks exactly the ids that were
         announced, whether or not the tab we are about to open happens to contain them. It runs on
         every path below -- already-on-New included -- because "he tapped it" means the same thing
         from every tab. */
      reportSeen(newTop);
      var toNew = tabs && tabs.querySelector('.js-tab[data-tab="new"]');
      if (curTab === 'new' || !toNew) {
        if (!toNew && curTab !== 'new') { window.location = '/feed?tab=new'; return; }  // no pager (shouldn't happen for a member)
        pillFlush();   // ends at the top of the feed itself
        return;
      }
      // Scroll first so the outgoing tab is already home when the pager swaps content in; the
      // pager itself deliberately never scrolls (it preserves the reader's place on a normal tab
      // change), which is exactly why this has to say so out loud.
      window.scrollTo({ top: 0, behavior: 'smooth' });
      toNew.click();
      /* Optimistic hide only -- NOT an optimistic number. reportSeen() moved the mark, so re-read
         the real count rather than decrementing anything here. */
      newN = 0;
      /* ...and ask the stream for the arrivals straight away rather than waiting out the 8s beat.
         Posts::since's 'new' arm is the plain firehose, so this is what actually PUTS the posts he
         was just told about on his screen -- New's own page one is the 45-day new-member window and
         may not contain them at all. syncTab needs the swapped fragment first (700ms, same as the
         tab handler), so this sits just behind it. */
      setTimeout(poll, 900);
      setTimeout(fetchNewCount, 1600);
    }

    /* The pill is a pure projection of the last count the SERVER sent. Zero means no pill at all,
       never "0 new posts". */
    function pillPaint() {
      /* HIDDEN (NEW_POST_PILL, config.php): return before the element can be CREATED, not after --
         the pill is built lazily right here and appended to <body>, so this is the line that makes
         "it never renders" true of the DOM rather than of a stylesheet. Nothing else in this file
         constructs it, and every caller of this function tolerates a no-op. */
      if (!pillOn) return;
      /* THE ENGAGEMENT / ATTENTION HOLD WINS. While he is inside a post -- a tapped clip, an open
         comment panel, a live embed, or the 120s quiet window after he engaged -- nothing on this
         surface is allowed to appear, change or vanish. The pill is position:fixed and takes part
         in no layout, so it cannot push a card, but it can still flicker in the corner of his eye
         mid-watch, and "nothing moves" has to mean nothing. Deferring is free: the 8s tick paints
         again the moment the hold lifts. */
      if (engaged() || engAttn()) return;
      if (!newN) { if (pill) pill.hidden = true; return; }
      if (!pill) {
        pill = document.createElement('button');
        pill.type = 'button';
        pill.className = 'newpost-pill';
        pill.addEventListener('click', pillTap);
        // <body>, not #feed-wrap: position:fixed is measured against the nearest ancestor that is a
        // containing block, and the feed's own tab-pager puts will-change/transform on elements in
        // that subtree while a swipe is live. Same reason the header panels are portalled out.
        document.body.appendChild(pill);
      }
      // A very large backlog is capped rather than spelled out: the server stops scanning at 100
      // (Posts::NEW_SCAN_CAP) and says so via `more`, so anything at or past the ceiling shows as
      // "99+" -- a number we can stand behind instead of one we would be guessing at.
      var label = (newMore || newN > 99) ? '99+ new posts' : (newN === 1 ? '1 new post' : newN + ' new posts');
      if (pill.textContent !== label) pill.textContent = label;
      pill.hidden = false;
    }

    /* ---- THE FIRST CARD'S GRACE, the feed roll's half (Rob 2026-10-22: "When I open the app and look at a post or swipe to
       another tab, the feed starts popping too fast; give me time to see, read and process the first post ... if it's a video let
       it finish first" -> "just don't do the hands-free that fast"). After the page OPENS, a feed-tab change, or a return to the
       browser tab, the roll may not put anything above the TOP card until that card has had its full dwell, counted from that
       moment: a photo FIRST_MIN_MS, a card with no media its reading time (words / FIRST_WPS per second, FIRST_MIN_MS..
       FIRST_TEXT_MAX_MS), a gallery its slideshow (slides x FIRST_SLIDE_MS = the card's own 4.2 s auto-swipe, <= FIRST_GAL_MAX_MS),
       a video ONE full pass (ended or a loop wrap; a clip that is not playing at all holds like a photo; <= FIRST_VIDEO_CAP_MS).
       Only the FIRST insertion waits; once released the gear's cadence runs as before. No fetch, pill or poll changes. The 5 s
       fold (openHold) still applies on top. Receipt: __rovaFeedFirst(). iOS: to-ios.md "## HANDS-FREE FIRST-CARD GRACE". */
    var FIRST_MIN_MS = 6000, FIRST_WPS = 3.5, FIRST_TEXT_MAX_MS = 30000, FIRST_SLIDE_MS = 4200, FIRST_GAL_MAX_MS = 60000,
        FIRST_VIDEO_CAP_MS = 180000, FIRST_STALL_MS = 8000;
    var first = { from: Date.now(), done: false, card: null, ms: 0, v: null, vb: 0, why: 'open', end: '' };
    function firstArm(why) { first = { from: Date.now(), done: false, card: null, ms: 0, v: null, vb: 0, why: why || 'tab', end: '' }; }
    function firstDwellMs(c) {
      var m = c.querySelector('.media');
      if (!m) {
        var b = c.querySelector('.body'), w = b ? ((b.textContent || '').trim().match(/\S+/g) || []).length : 0;
        return Math.max(FIRST_MIN_MS, Math.min(FIRST_TEXT_MAX_MS, Math.round(w / FIRST_WPS * 1000)));
      }
      if (m.classList.contains('carousel')) {
        var n = m.querySelectorAll('.cslide').length || 1;
        return Math.max(FIRST_MIN_MS, Math.min(FIRST_GAL_MAX_MS, n * FIRST_SLIDE_MS));
      }
      return FIRST_MIN_MS;
    }
    function firstWatch(v) {   // a pass counter on the clip: 'ended', or a loop wrap from within 1 s of the end
      if (v._fpW) return;
      v._fpW = 1; v._fpPass = 0; v._fpLast = 0; v._fpAt = 0;
      v.addEventListener('timeupdate', function () {
        var t = v.currentTime || 0, d = v.duration || 0;
        if (d && v._fpLast > d - 1 && t < v._fpLast - 0.25) { v._fpPass++; }
        if (t !== v._fpLast) { v._fpAt = Date.now(); }
        v._fpLast = t;
      });
      v.addEventListener('ended', function () { v._fpPass++; v._fpLast = 0; });
    }
    function firstHold() {
      if (first.done) return false;
      var c = feed.querySelector('.post[data-id]');
      if (!c) { first.done = true; first.end = 'empty'; return false; }
      if (c !== first.card) {
        first.card = c; first.ms = firstDwellMs(c);
        var m = c.querySelector('.media');
        first.v = (m && !m.classList.contains('carousel')) ? m.querySelector('video') : null;
        if (first.v) { firstWatch(first.v); first.vb = first.v._fpPass || 0; }
      }
      var now = Date.now(), v = first.v;
      if (v && v.isConnected) {
        if ((v._fpPass || 0) > first.vb) { first.done = true; first.end = 'video'; return false; }
        if (now - first.from > FIRST_VIDEO_CAP_MS) { first.done = true; first.end = 'cap'; return false; }
        if (now - Math.max(first.from, v._fpAt || 0) < FIRST_STALL_MS) return true;   // playing (or just started): let it finish
        // a clip that is not moving (autoplay refused, paused) holds like a photo, below
      }
      if (now - first.from < first.ms) return true;
      first.done = true; first.end = 'dwell';
      return false;
    }
    window.__rovaFeedFirst = function () {
      return { why: first.why, done: first.done, end: first.end, ms: first.ms, sinceMs: Date.now() - first.from,
               card: first.card ? first.card.getAttribute('data-id') : null, video: !!first.v, passes: first.v ? (first.v._fpPass || 0) - first.vb : 0 };
    };
    function reveal() {
      if (paused || document.hidden) return;
      if (openHold) return;   // opened / returned-to and untouched: nothing changes before the 5 s fold (THE 5 s FOLD)
      if (firstHold()) return;   // the top card has not had its full dwell yet (THE FIRST CARD'S GRACE)
      if (composeFoldHold()) return;   // an open composer in use (focus, fresh draft, picker, upload...) holds the top too -- the app's chromeHeld()
      // Scrolled away from the top, or holding after a fresh video post: hold them, don't drop them.
      if (window.scrollY > TOP_GUARD || Date.now() < holdRevealUntil) return;
      if (feed.querySelector('.pgrid')) return;   // GRID tab = media cells only; never prepend a card here

      // hold the feed while the reader is interacting/viewing -- and while a live third-party
      // player is on their screen, which feedBusy() cannot see (liveEmbedOnScreen, above)
      if (feedBusy() || liveEmbedOnScreen()) return;
      // 2026-09-18: nothing moves until the reader has been still for REVEAL_IDLE_MS (the roll's own,
      // longer gate is inside maybeRoll). The tick keeps its cadence; a held reveal is retried next beat.
      if (!idleFor(REVEAL_IDLE_MS)) return;
      if (!queue.length) { maybeRoll(); return; }
      // Parked at the very top = sit-back watch mode: the arrival IS what they are watching, so it
      // may take the top spot. Anywhere else they are reading something, and their place is kept.
      if (!insertTop(queue.shift(), window.scrollY > 4)) return;
      trimTail();
      /* HE HAS NOW BEEN SHOWN THE FRONT OF THE CHRONOLOGICAL STREAM -- report it, once the queue is
         empty so `cursor` really is the newest thing this page knows about, and only on New, whose
         stream is the same public firehose the count is measured over (Posts::since's 'new' arm).
         Following and Discover are subsets: a card from someone he follows says nothing about the
         posts between it and the mark, and advancing on it would swallow news he never saw. */
      if (curTab === 'new' && !queue.length) reportSeen(cursor);
      if (queue.length <= 2) maybeRoll(); // top up the roll before it runs dry
    }

    // ONE timer for all THREE halves of "live": pull the new posts, refresh the counts on the cards
    // already here, and read the unseen count behind the pill. Adding a second interval for the
    // badges (or a third for the pill) would multiply the cadence this feed costs the origin for no
    // gain -- they all want the same 8s window, and the browser was going to talk to it anyway.
    setInterval(function () { poll(); refreshCounts(); fetchNewCount(); }, POLL_MS);
    window.__rovaFeedLiveK = function () { return { revealIdleMs: REVEAL_IDLE_MS, rollIdleMs: ROLL_IDLE_MS, revealMs: REVEAL_MS, pollMs: POLL_MS, topGuard: TOP_GUARD }; };
    // reveal on a SELF-RESCHEDULING timer (not a fixed setInterval): a speed change from
    // the gear / Settings then takes effect on the very next reveal instead of only after
    // a reload (a fixed setInterval keeps its original period even when REVEAL_MS changes).
    var revealTimer = null;
    function scheduleReveal() {
      if (revealTimer) clearTimeout(revealTimer);
      revealTimer = setTimeout(function () { reveal(); scheduleReveal(); }, REVEAL_MS);
    }
    scheduleReveal();
    document.addEventListener('visibilitychange', function () { if (!document.hidden) { poll(); refreshCounts(); fetchNewCount(); } });
    /* ==== WS-C 2026-10-22: NEW IS PURE CHRONOLOGICAL ON THE WEB (Rob: "New tab = pure chronological, never hides
       seen/engaged posts; pull-to-refresh just fetches newer posts ... Swiping to New refreshes automatically") ====
       #feed-posts[data-newpure="1"] (k/v feed_new_pure). newCatchUp() asks ?since=<newest card on the list>&n=20 and lands
       every newer post on top at once (oldest first, so the newest ends on top), keeping the reader's place if they are
       scrolled down; the rows already there are never replaced. 20 back = a bigger gap than one catch-up: 'full', and
       the caller re-opens page one (only at the top). Fired when the New tab becomes active (click OR swipe: the observer
       watches the tab row's .on, not the click) and by a pull (window.__rovaNewCatchUp, the PTR block). The idle roll is
       off on New (maybeRoll). */
    function newPureOn() { return feed.getAttribute('data-newpure') === '1'; }
    var ncBusy = null;
    function newCatchUp(fromPull) {
      if (!newPureOn()) return null;
      if (tabFromDom() !== 'new') return null;
      if (ncBusy) return ncBusy;
      if (curTab !== 'new') { curTab = 'new'; queue = []; }
      reindex();   // anchor on what is on screen NOW (a kept panel was just restored)
      if (cursor <= 0) return null;
      var at = cursor;
      ncBusy = rfetch('/feed?tab=new&partial=posts&since=' + at + '&n=20',
            { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', cache: 'no-store' }, 8000)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          ncBusy = null;
          if (tabFromDom() !== 'new') return 0;
          var tmp = document.createElement('div');
          tmp.innerHTML = html || '';
          var nodes = Array.prototype.slice.call(tmp.querySelectorAll('.post[data-id]'));
          if (nodes.length >= 20) return 'full';
          var keep = (window.scrollY || 0) > 4, put = 0;
          nodes.reverse().forEach(function (node) {
            var id = parseInt(node.getAttribute('data-id'), 10) || 0;
            if (!id || id <= at || seen[id]) return;
            seen[id] = true; if (id > cursor) cursor = id;
            if (insertTop(node, keep)) put++;
          });
          if (put) { trimTail(); if ((window.scrollY || 0) <= TOP_GUARD) reportSeen(cursor); }
          return put;
        }, function (err) { ncBusy = null; throw err; });
      return ncBusy;
    }
    window.__rovaNewCatchUp = newCatchUp;
    if (tabs && window.MutationObserver) {
      var ncLast = tabFromDom(), ncT = 0;
      new MutationObserver(function () {
        var t = tabFromDom();
        if (t === ncLast) return;
        ncLast = t;
        if (t !== 'new' || !newPureOn()) return;
        if (ncT) clearTimeout(ncT);
        ncT = setTimeout(function () {   // after the pager has landed the panel (dissolve / swipe commit)
          ncT = 0;
          var p = newCatchUp(false);
          if (!p) return;
          p.then(function (res) {
            if (res !== 'full' || (window.scrollY || 0) > 200) return;
            return rfetch('/feed?tab=new&partial=posts', { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', cache: 'no-store' }, 8000)
              .then(function (r) { return r.text(); })
              .then(function (html) {
                if (tabFromDom() !== 'new' || (window.scrollY || 0) > 200) return;
                feed.innerHTML = (html || '').trim();
                try { feed.dispatchEvent(new CustomEvent('rova:paged')); } catch (e) {}
                try { hydrateChunked(feed); } catch (e) {}
                reindex();
              });
          }).catch(function () {});
        }, 800);
      }).observe(tabs, { subtree: true, attributes: true, attributeFilter: ['class'] });
    }

    if (tabs) tabs.addEventListener('click', function (e) {
      if (!e.target.closest('.js-tab')) return; // ignore the pause switch etc.
      // A tab change can move the mark (landing on New advances it server-side), so re-read the
      // count once the fragment has landed rather than carrying the old tab's number across.
      queue = []; firstArm(); setTimeout(syncTab, 700); setTimeout(fetchNewCount, 1400);
    });
    window.addEventListener('popstate', function () { setTimeout(syncTab, 700); setTimeout(fetchNewCount, 1400); });
    setTimeout(function () { poll(); refreshCounts(); fetchNewCount(); }, 1500); // first check shortly after load

    // Live-insert a JUST-POSTED post at the top of the feed, no page reload. The composer calls this so a
    // fresh post (from ANY tab) shows up immediately while the reader is watching, keeping their tab and
    // place. Fetches the rendered card (tab-agnostic), so it appears even where the tab's own live stream
    // would filter it (e.g. a text post on the photo-only Discover). Resolves false if it couldn't insert
    // (caller then falls back to a normal navigation).
    window.__rovaInsertFresh = function (id, ov) {
      id = parseInt(id, 10) || 0;
      if (!id) return Promise.resolve(false);
      // The GRID tab is a media-only cell grid, NOT a card stream. Prepending a fresh card here (a text
      // post especially) leaks it in ABOVE the thumbnails. Bail so the caller navigates instead (it lands
      // on Following, which shows the just-posted post correctly).
      if (feed.querySelector('.pgrid')) return Promise.resolve(false);
      if (feed.querySelector('.post[data-id="' + id + '"]')) { if (ov) hidePostOverlay(ov); window.scrollTo({ top: 0, behavior: 'smooth' }); return Promise.resolve(true); }
      // feed=1: this is a feed CARD (not the swipe viewer), so the server keeps GIF posts -- otherwise a
      // GIF post returns nothing here and we fall back to a full page reload (the choppy path).
      return fetch('/post-cards?feed=1&ids=' + id, { headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { return r.ok ? r.json() : null; })   // /post-cards returns {html:...}, not raw HTML
        .then(function (d) {
          var tmp = document.createElement('div'); tmp.innerHTML = (d && d.html) || '';
          var node = tmp.querySelector('.post[data-id]');
          if (!node) return false;
          seen[id] = true; if (id > cursor) cursor = id;
          // A: PRELOAD the card's first image so it reveals already painted -- no black media box that then
          // pops to the image. Race the decode against a short timeout so a slow/broken image never stalls
          // the reveal (the card still lands; the image just finishes loading in place).
          var mimg = node.querySelector('.media img');
          var src = mimg && (mimg.getAttribute('src') || mimg.currentSrc);
          var ready;
          if (src) {
            var decoded = mimg.decode ? mimg.decode().catch(function () {})
              : new Promise(function (r) { mimg.addEventListener('load', r, { once: true }); mimg.addEventListener('error', r, { once: true }); });
            ready = Promise.race([decoded, new Promise(function (r) { setTimeout(r, 650); })]);
          } else { ready = Promise.resolve(); }
          return ready.then(function () {
            // C: land the card as if launched from the composer -- .post-land springs it down from above
            // (translateY + slight scale, gentle overshoot) instead of the plain trickle-in fade.
            node.classList.add('stream-in', 'post-land');
            feed.insertBefore(node, feed.firstChild);
            // Hold your just-posted post at the very top for 30s before the live stream / ambient roll
            // start revealing new posts over it -- long enough to actually SEE what you posted.
            holdRevealUntil = Date.now() + 30000;
            // B: cross-fade -- as the card animates in, fade the overlay out on the same beat.
            requestAnimationFrame(function () {
              requestAnimationFrame(function () { node.classList.add('in'); if (ov) hidePostOverlay(ov); });
            });
            setTimeout(function () { node.classList.remove('stream-in', 'in', 'post-land'); }, 900);
            window.scrollTo({ top: 0, behavior: 'smooth' });
            try { if (typeof initCarousels === 'function') initCarousels(node); } catch (e) {}
            try { if (typeof initEmbeds === 'function') initEmbeds(node); } catch (e) {}
            try { if (window.__rovaHydrate) window.__rovaHydrate(feed); } catch (e) {}
            if (window.__rovaReachRefresh) window.__rovaReachRefresh();   // posts count just went up
            return true;
          });
        }).catch(function () { return false; });
    };

    /* search + composer: TWO INDEPENDENT collapse units (2026-08-11, owner default-behaviour
       change). Both start fully collapsed on every load, unconditionally -- see the
       forceCollapse() calls near the end of this block, which replaced the old
       "if (window.scrollY <= 8) expandChrome(); else collapseChrome();" line. From there, ONLY
       an explicit tap of the header's search icon (window.__rovaExpandSearchPanel, called from
       the separate .hdrop click handler) or the + button (focusComposer, below) may expand
       either one -- never scroll-to-top, an upward wheel, a touch pull-down, or focusin; those
       triggers existed in the old single-shared-chrome design and are deliberately gone now.
       Opening one panel never touches the other: each is its own makeChromePanel() instance
       with its own DOM box, its own grace window, and its own idle guard. */
    var searchBox = document.getElementById('feed-search-box');
    var composeBox = document.getElementById('feed-compose-box');
    var searchInner = searchBox && searchBox.querySelector('.feed-panel-inner');
    var search = document.getElementById('home-search');

    // A draft in progress: ANY text in ANY field inside THIS panel's own box (composer, poll
    // options… or the search input), or -- composer only -- media/gif/poll attached.
    /* .value IS NOT "WHAT THE READER TYPED" FOR EVERY INPUT KIND, and this loop used to assume it
       was. A checkbox's .value is its SUBMIT value, present in the markup and unchanged by
       clicking: views/_composer.php ships <input type="checkbox" name="grid_hidden" value="1">,
       so a naive `.value.trim() !== ''` test returned true on EVERY page load, forever, and the
       shared "in use" check that fed off it was permanently true as a result (fixed 2026-08-05;
       preserved here). The draft signal stays per KIND: .checked for a checkbox/radio,
       .files.length for a file input, and only then .value for the text-like rest. */
    function fieldsHaveContent(root) {
      var fields = root.querySelectorAll('input:not([type=hidden]), textarea');
      for (var i = 0; i < fields.length; i++) {
        var f = fields[i], t = (f.type || '').toLowerCase();
        if (t === 'checkbox' || t === 'radio') { if (f.checked) return true; continue; }
        if (t === 'file') { if (f.files && f.files.length) return true; continue; }
        if ((f.value || '').trim() !== '') return true;
      }
      return false;
    }
    // One "panel" per collapse unit: same idea the old single shared chrome used
    // (has-content / in-use / collapse guards), just scoped to its own box so nothing here can
    // ever read or write the OTHER panel's element.
    function makeChromePanel(box, opts) {
      opts = opts || {};
      var keepUntil = 0;
      function hasContent() {
        if (!box) return false;
        if (fieldsHaveContent(box)) return true;
        return !!(opts.extraContent && opts.extraContent());
      }
      /* ignoreFocus (2026-09-18): "is anything OTHER than the caret holding this panel open?".
         The auto-close needs that question because the + button focuses the textarea on every open
         (the iOS keyboard rule), so a focused field is the NORMAL state of a just-opened composer,
         not evidence of use -- asking the plain question would make the auto-close unreachable.
         Every other caller passes nothing and gets exactly the behaviour it always had. */
      function inUse(ignoreFocus) {
        if (!box) return false;
        var a = document.activeElement;
        if (!ignoreFocus && a && box.contains(a) && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName)) return true;
        if (opts.extraInUse && opts.extraInUse()) return true;
        var fs = document.getElementById('feed-settings');   // gear panel open: they're adjusting,
        if (fs && !fs.hidden) return true;                    // don't reflow the tabs under them
        if (Date.now() < keepUntil) return true;              // just tapped a tool inside this panel
        return hasContent();
      }
      function isIdle() { return !box || box.classList.contains('panel-idle'); }
      /* A GUEST NEVER SEES THE TABS GO IDLE-SIZED (owner 2026-09-22, screenshots: the sticky
         sub-header is shorter for a guest than a signed-in member). Root cause: a guest has
         neither box (#feed-search-box and #feed-compose-box are both member-only, absent from
         the DOM entirely), so BOTH panels are constructed with box=null. isIdle() already
         handles that fine (!box -> idle), but apply() used to return on `if (!box) return`
         BEFORE reaching syncChromeIdle() -- there was nothing to toggle .panel-idle on, so the
         whole function bailed, and syncChromeIdle() (the thing that actually adds .chrome-idle
         to #feed-wrap, which is what gives #feed-tabs .tab its 15px idle padding instead of the
         resting 10px) never ran even once for a guest. A member's page calls forceCollapse() on
         load same as this one does, hits a real box, and reaches syncChromeIdle() normally --
         the guest page called the exact same functions and silently skipped the one line that
         matters. Splitting the guard fixes it without changing behaviour for anyone with a real
         box: the toggle is still skipped when there is nothing to toggle, but the sync -- which
         never touched `box` in the first place -- always runs. */
      function apply(on) {
        if (box) { box.classList.toggle('panel-idle', on); }
        if (opts.onApply) opts.onApply(on);   // the search box's phone sheet (syncSearchSheet), same frame
        syncChromeIdle();
      }
      // Guarded: never yanks an in-use panel away, and honours the gear's "never auto-hide".
      function collapse() {
        if (isIdle() || inUse() || !feedPref('autohide', true)) return;
        apply(true);
      }
      function forceCollapse() { apply(true); }   // unguarded -- initial load and just-posted only
      function expand() { apply(false); }
      function hold(ms) { keepUntil = Date.now() + ms; }
      // Explicit tap of the SAME control that opens this panel (e.g. the header search icon)
      // toggles it shut again, same as the .hdrop flyouts elsewhere in the header already do --
      // an unconditional close (forceCollapse, not the guarded collapse()): a second tap of an
      // icon you're looking right at should always work, not silently refuse because the field
      // still has text in it. Returns the resulting open state.
      function toggle() {
        if (isIdle()) { expand(); return true; }
        forceCollapse();
        return false;
      }
      if (box) {
        // Tapping anything inside an OPEN panel counts as activity: hold IT open a while longer
        // so it can't fold away from under a finger mid-interaction. A collapsed panel is
        // pointer-events:none, so this can only ever fire on a panel that is already expanded --
        // it holds the grace window, it never itself reveals anything.
        box.addEventListener('pointerdown', function (e) {
          // opening the FILE PICKER blurs the page for as long as browsing takes; hold for
          // minutes, not seconds. Any other TOOL tap holds 30s; a bare panel tap gets a short grace.
          var pickerTap = e.target.closest && e.target.closest('label[for="compose-file"], #compose-file');
          var toolTap = e.target.closest && e.target.closest('button, label, select, input, textarea, a');
          hold(pickerTap ? 180000 : (toolTap ? 30000 : 6000));
        });
      }
      return { box: box, expand: expand, collapse: collapse, forceCollapse: forceCollapse,
               toggle: toggle, isIdle: isIdle, inUse: inUse, hold: hold,
               grace: function () { return Date.now() < keepUntil; } };   // the tool-tap / file-picker window alone (the 5 s fold)
    }
    /* THE PHONE SEARCH SHEET (2026-10-22, Rob on iPhone: "When I tap search it's overlapped horribly
       before it fixes"). Below the two-column layout an open search box is no longer an inline panel
       that grows 0 -> 1fr over .55s while fading in over .4s: that put the dropdown (a child) at
       partial opacity for its first ~400ms, WebKit drops backdrop-filter under an ancestor with
       opacity < 1, and the 72% --bar-bg let the ring, the tabs and a post card read straight through
       the Recent / Suggested rows. Now it is a FIXED, OPAQUE sheet from the header's bottom edge to the
       bottom of the VISUAL viewport, decided in the same frame as the tap (apply() -> onApply), so the
       first painted frame is the final one: nothing in the feed moves, nothing shows through, the feed
       behind is inert and the page does not scroll under it. The keyboard only moves the sheet's
       bottom edge (visualViewport height), never its top. rova.css: html.fsrch-sheet. */
    var sheetMq = window.matchMedia('(max-width: 899px)');
    var sheetVV = false;
    function sheetOn() { return document.documentElement.classList.contains('fsrch-sheet'); }
    function sheetVars() {
      if (!searchBox) return;
      var vv = window.visualViewport;
      var top = 0;
      if (topbar) { var tr = topbar.getBoundingClientRect(); top = Math.max(0, Math.round(tr.bottom)); }
      searchBox.style.setProperty('--fsrch-top', top + 'px');
      searchBox.style.setProperty('--fsrch-h', Math.round(vv ? vv.height : window.innerHeight) + 'px');
      searchBox.style.setProperty('--fsrch-y', Math.round(vv ? Math.max(0, vv.offsetTop) : 0) + 'px');
    }
    function syncSearchSheet() {
      var on = !!searchBox && !searchBox.classList.contains('panel-idle') && sheetMq.matches;
      if (on) sheetVars();
      document.documentElement.classList.toggle('fsrch-sheet', on);
      ['media-ring', 'feed-tabs', 'feed-posts', 'feed-notices'].forEach(function (id) {
        var el = document.getElementById(id);
        if (el) { if (on) el.setAttribute('inert', ''); else el.removeAttribute('inert'); }
      });
      if (on !== sheetVV) {
        sheetVV = on;
        var vv = window.visualViewport, m = on ? 'addEventListener' : 'removeEventListener';
        if (vv) { vv[m]('resize', sheetVars); vv[m]('scroll', sheetVars); }
        window[m]('resize', sheetVars);
      }
    }
    if (sheetMq.addEventListener) sheetMq.addEventListener('change', function () { syncSearchSheet(); });
    else if (sheetMq.addListener) sheetMq.addListener(function () { syncSearchSheet(); });
    var searchPanel = makeChromePanel(searchBox, {
      onApply: syncSearchSheet,
      extraInUse: sheetOn   // an open sheet never folds itself away (the 5 s fold, the landscape tuck)
    });
    if (searchBox && search) {
      // the sheet's own way out (the header's search icon and Escape still toggle it too)
      var sCancel = document.createElement('button');
      sCancel.type = 'button'; sCancel.className = 'fsrch-cancel'; sCancel.textContent = 'Cancel';
      search.insertAdjacentElement('afterend', sCancel);
      sCancel.addEventListener('click', function (e) {
        e.preventDefault();
        if (!searchPanel.isIdle()) { searchPanel.forceCollapse(); search.blur(); }
      });
    }
    var composePanel = makeChromePanel(composeBox, {
      extraContent: function () {
        var mp = document.getElementById('compose-preview'),
            gp = document.getElementById('gif-preview'),
            pe = document.getElementById('poll-editor'),
            te = document.getElementById('trip-editor'),
            /* 2026-09-18: the two editors this list had never covered. Harmless while the only
               readers were the landscape tuck and the tab reflow; now that an empty composer CLOSES
               ITSELF on scroll, "content" has to mean everything a member can have opened or typed
               -- an open co-author box or a thread/schedule block is work in progress even before a
               handle or a time is in it, exactly as an open poll or trip editor already was. */
            ce = document.getElementById('collab-editor'),
            th = document.getElementById('thread-editor');
        if ((mp && !mp.hidden) || (gp && !gp.hidden) || (pe && !pe.hidden) || (te && !te.hidden)) return true;
        if ((ce && !ce.hidden) || (th && !th.hidden)) return true;
        // a scheduled time is a decision in progress too (2026-09-28, the clock tool's chip)
        var sc = document.getElementById('sched-chip');
        if (sc && !sc.hidden) return true;
        /* ...and the things only the composer's own closure can see: staged media, a chosen video
           cover, an upload still on the wire, and the sessionStorage DRAFT. A draft is the one that
           matters most here -- it is restored into a COLLAPSED composer on load, so without this a
           reader who typed, reloaded and scrolled would have had their restored draft folded away
           by the auto-close. Absent bridge (older cached bundle) = fall through to the fields only,
           which is exactly the pre-2026-09-18 answer. */
        return !!(window.__rovaComposerHasWork && window.__rovaComposerHasWork());
      },
      extraInUse: function () {
        if (window.__rovaSchedPickOpen && window.__rovaSchedPickOpen()) return true;   // the schedule sheet
        return !!document.querySelector('.emoji-pop.show, .gif-pop.show');   // a composer picker is open
      }
    });
    // The header's search icon (a separate IIFE, ~line 17245) drives this one directly; it is a
    // no-op on any page without a search box (i.e. everywhere except /feed). TOGGLES, same as the
    // .hdrop flyouts elsewhere in the header do on their own trigger -- a second tap on an
    // already-open panel is how a member closes it (there was previously no way to close either
    // panel at all short of reloading or rotating to landscape). Blur on close so focus doesn't
    // sit stranded inside a now-invisible field.
    window.__rovaExpandSearchPanel = function () {
      // Self-contained toggle: deliberately NOT calling a panel.toggle() convenience method,
      // even if one exists on the object below -- isIdle()/expand()/forceCollapse() are the
      // stable primitives every version of makeChromePanel has carried, so this keeps working
      // regardless of whether a same-shaped toggle() helper is present.
      var opening = searchPanel.isIdle();
      if (opening) { searchPanel.expand(); } else { searchPanel.forceCollapse(); if (search) search.blur(); }
      return opening;
    };

    // Mirror BOTH panels' collapsed state onto #feed-wrap/<html> together. This is what the
    // pre-existing #feed-tabs sticky/compact CSS (rova.css, "#feed-wrap.chrome-idle #feed-tabs…")
    // and the ambient watch-mode roll (maybeRoll/watching(), above, which already gate on
    // .chrome-idle + scrollY) key off -- both keep working unchanged, they just now read a
    // combined state instead of a single shared toggle. Neither panel touches the other
    // directly; this is the only place that reads both.
    function syncChromeIdle() {
      // the phone search SHEET counts as idle here: it is fixed over the feed, so the header margin and
      // the tab strip under it must not move (Safari has no scroll anchoring: they slid 14px on close)
      var on = (searchPanel.isIdle() || document.documentElement.classList.contains('fsrch-sheet')) && composePanel.isIdle();
      wrap.classList.toggle('chrome-idle', on);
      // MEMBER-ONLY BELOW THIS LINE (owner 2026-09-23: a guest's search field sat flush under
      // the header, margin zeroed to 0). `chrome-idle` above stays unconditional -- #feed-tabs's
      // own idle padding is correctly wanted for everyone. But `feed-collapsed` on <html> exists
      // for ONE reason: `html.feed-collapsed .topbar{margin-bottom:0}` (rova.css) and this
      // function's own inline copy of the same zeroing below, both there so #feed-tabs tucks
      // flush under a collapsed MEMBER's search/composer chrome, with nothing else between them.
      // A guest has neither real panel: searchBox/composeBox are both null (member-only markup),
      // so isIdle() reads true off `!box` alone and `on` goes true on the very first paint,
      // despite nothing having actually collapsed. For a guest the search bar, the guest-bar and
      // the media ring all sit between the header and #feed-tabs, so zeroing the SAME margin
      // (the CSS class rule as much as the inline one) just erases the guest's only breathing
      // room under the header for a tab-tuck that was never going to happen there.
      var hasChrome = !!(searchBox || composeBox);
      document.documentElement.classList.toggle('feed-collapsed', on && hasChrome);
      // Zero the header's bottom margin so the tabs tuck right under it when collapsed,
      // but ONLY on mobile. On the desktop 2-col layout keep the margin so the feed
      // column's top still lines up with the sticky sidebar beside it.
      if (topbar) {
        var wide = window.matchMedia('(min-width:1040px)').matches;
        topbar.style.marginBottom = (on && !wide && hasChrome) ? '0px' : '';
      }
      // THE RE-COMPOSITE. Toggling chrome-idle is not a cosmetic class change: it flips
      // #feed-tabs between position:relative and position:sticky + full-bleed + opaque
      // (rova.css), i.e. it CREATES and DESTROYS a compositor layer, and it moves the header's
      // bottom margin so the sticky aside's geometry shifts with it. A layer built this long
      // after first paint is exactly the one that can come back blank -- "loaded without
      // subheader and sidebar in view, fixed by resizing the window". Every trigger the paint
      // guarantee has (parse, rAF, load, aside images) fired seconds ago, so re-run it here:
      // once on the frame the class lands, and again after the .55s margin/padding transition
      // settles into its final geometry.
      window.__rovaCollapsedAt = on ? Date.now() : 0;   // read by the resize signal
      var rp = window.__rovaChromeRepaint;
      if (rp) {
        if (typeof requestAnimationFrame === 'function') {
          requestAnimationFrame(function () { requestAnimationFrame(rp); });
        } else { rp(); }
        setTimeout(rp, 620);
      }
    }
    // just posted: boot with the inputs tucked away so the very first thing
    // under the tabs is their brand-new post (the gear's auto-hide=off still wins)
    try {
      if (sessionStorage.getItem('rova_posted') === '1') {
        sessionStorage.removeItem('rova_posted');
        searchPanel.forceCollapse();
        composePanel.forceCollapse();
        // Just posted a VIDEO: don't let the auto-feed roll new posts in over it. Freeze the
        // reveal until ~5s AFTER the clip paints its first frame (or ~5s from now if it's still
        // optimizing), so the poster gets to watch their own upload land before the feed moves on.
        var freshPost = feed.querySelector('.post[data-id]');
        var hasVid = freshPost && freshPost.querySelector('.media video, .vprocessing');
        if (hasVid) {
          holdRevealUntil = Date.now() + 5000;   // baseline hold
          var freshVid = freshPost.querySelector('.media video');
          if (freshVid) {
            /* BOUNDED. `loadeddata` used to be treated as "the clip renders in a moment", which was
               true while views/_post.php shipped preload="metadata": the element loaded itself and
               fired within a second or two. Since 2026-08-08 it ships preload="none" beside a poster
               + stamped width/height, so this clip does not load at all until something promotes it
               (playIO when it is in view and autoplay is on) -- and if the poster scrolls away and
               comes back, or leaves autoplay off and taps play a minute later, this one-shot fires a
               MINUTE later and freezes the auto-feed reveal for 5s out of nowhere. The baseline 5s
               hold above is already the correct answer for a clip that never paints, so keep the
               bump but only while it still means "it just landed". */
            var bumpAt = Date.now();
            var bumpHold = function () {
              try {
                freshVid.removeEventListener('loadeddata', bumpHold);
                freshVid.removeEventListener('playing', bumpHold);
              } catch (e) {}
              if (Date.now() - bumpAt > 20000) return;      // too late to be "their upload landing"
              holdRevealUntil = Date.now() + 5000;          // restart 5s once it renders
            };
            if (freshVid.readyState >= 2) { bumpHold(); }   // already has a frame
            else {
              freshVid.addEventListener('loadeddata', bumpHold);
              freshVid.addEventListener('playing', bumpHold);   // whichever the promotion produces first
              setTimeout(function () {                          // never leave a stale one-shot armed on the card
                try {
                  freshVid.removeEventListener('loadeddata', bumpHold);
                  freshVid.removeEventListener('playing', bumpHold);
                } catch (e) {}
              }, 20000);
            }
          }
        }
      }
    } catch (e) {}
    // IDLE-based auto-re-collapse (the old armIdle/trulyIdle machinery) is CUT, not ported
    // per-panel (2026-08-11 design call -- see the report for this change; the brief explicitly
    // allowed either). Reasons: (1) it was tightly coupled to the ambient "watch mode" roll
    // (poll()+maybeRoll() eagerly kicked off the moment collapse happened), and that roll now
    // engages on its own the instant the page loads, because BOTH panels start collapsed
    // immediately -- watching() only needs .chrome-idle + scrollY<=8, both true from the first
    // frame, so nothing here needs to eagerly trigger it any more; (2) correctly splitting the
    // idle timer per panel while keeping the single ambient-roll trigger correct (not double-
    // firing, not firing off only-one-panel-idle) was real added risk for a nice-to-have the
    // owner explicitly said was optional. A panel a member explicitly opens now simply stays
    // open until they navigate away, reload, or (composer/search) it naturally empties and they
    // tap elsewhere -- it does not silently re-collapse out from under them, which is arguably
    // the safer default anyway.
    // (SUPERSEDED 2026-09-29 by THE 5 s FOLD, right below: an idle fold is back, per the owner.)

    /* ---- THE 5 s FOLD (2026-09-29, owner via iOS build 529: "Make sure the web does what I want too") ----
       FOLD_IDLE_MS (5 s) of quiet -- no pointer / touch / key / wheel, no reader scroll, idleFor() -- while
       parked at the top (scrollY <= 8) is THE FOLD: an open search/composer tucks away (guarded, below) and
       the roll STARTS: a roll fetch now, a reveal FOLD_PRIME_MS (600 ms) later -- or the moment that fetch
       lands, if later -- then the gear's own cadence (REVEAL_MS). Before this the web had NO fold at all:
       (1) an OPEN composer stayed open until navigation, and since watching() needs .chrome-idle, an open
       composer -- even an empty, unfocused one -- stopped the roll for good; (2) the roll was only ever
       tried on a reveal tick, so the first card needed a tick after 5 s of quiet (8.8 s) plus one more to
       land (13.2 s measured 09-18). Sitting still now folds at 5.0 s and the first card lands ~0.6-1 s later.
       HOLDS (the fold waits, re-asking every FOLD_RETRY_MS): everything feedBusy() already holds the roll for
       -- an AUDIBLE / tapped video on screen (#571), an open comment panel or roller (engaged 'comments'),
       menus, sheets, modals, the lightbox, the viewer, the emoji/GIF pops, search results, the attention
       hold -- plus a live embed / playing song card, a pinned body (a sheet's scroll lock), and for the
       composer: focus inside it, an upload on the wire, the schedule / music / emoji / GIF pickers, the gear
       panel, the file-picker / tool-tap grace, and a DRAFT -- but a draft only if the member FOCUSED the
       composer in THIS page session and only for DRAFT_HOLD_MS (30 s) past the last edit. A draft restored
       on load never holds. The fold only TUCKS: the text, the staged media and the sessionStorage draft are
       untouched (forceCollapse toggles a class; nothing here reads or clears the draft). The gear's
       "auto-hide" OFF still wins, as it does in the app. A RETURN (tab visible again / bfcache restore) is
       treated like a load: the idle clock restarts, so the feed holds until you act or the next fold.
       THE OPEN HOLD (the app's: "a feed you open or return to doesn't change until you act"): reveal() puts
       nothing on top -- not even a queued live arrival -- from load / return until the reader's first input
       OR the fold, whichever comes first. The app's used to lift only on drag / pull / tab switch, so a
       reader who sat still never saw it roll; here the FOLD lifts it too (measured before: a queued card
       landed at 4.4 s on Discover, i.e. before the fold). */
    var FOLD_RETRY_MS = 1000;
    var foldT = null, foldDone = false, foldAt = 0, foldPrimeUntil = 0, foldInitAt = lastAct, foldLog = [];
    var openHold = true;
    var composeTouched = false, composeEditAt = 0;
    if (composeBox) {
      composeBox.addEventListener('focusin', function () { composeTouched = true; });
      // a real edit only: restoreDraft()'s own synthetic `input` (a load-time restore) is not the member typing
      var onEdit = function (e) { if (e.isTrusted) { composeTouched = true; composeEditAt = Date.now(); } };
      composeBox.addEventListener('input', onEdit, true);
      composeBox.addEventListener('change', onEdit, true);
    }
    function composeHasDraft() {
      if (!composeBox) return false;
      if (fieldsHaveContent(composeBox)) return true;
      try { return !!(window.__rovaComposerHasWork && window.__rovaComposerHasWork()); } catch (e) { return true; }
    }
    // Why an OPEN composer may not be tucked right now ('' = it may). Never asked of a collapsed one.
    function composeFoldHold() {
      if (!composeBox || composePanel.isIdle()) return '';
      var a = document.activeElement;
      if (a && composeBox.contains(a) && (/^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName) || a.isContentEditable)) return 'focus';
      if (window.__rovaUpBusy && window.__rovaUpBusy()) return 'upload';
      if (window.__rovaSchedPickOpen && window.__rovaSchedPickOpen()) return 'picker';
      if (window.__rovaMusicPickBusy && window.__rovaMusicPickBusy()) return 'picker';
      if (document.querySelector('.emoji-pop.show, .gif-pop.show')) return 'picker';
      var fs = document.getElementById('feed-settings');
      if (fs && !fs.hidden) return 'gear';
      if (composePanel.grace()) return 'grace';
      if (composeTouched && Date.now() - composeEditAt < DRAFT_HOLD_MS && composeHasDraft()) return 'draft';
      return '';
    }
    function foldHold() {
      if (feedBusy()) return 'busy';
      if (liveEmbedOnScreen()) return 'embed';
      if (document.body.classList.contains('scroll-locked')) return 'locked';
      var rh = ringHold(); if (rh) return rh;               // the reader is on the ring (hover / focus): the chrome stays
      if (window.__rovaPullLive) return 'pull';            // a finger mid-pull at the top (THE PULL AT THE TOP IS OURS)
      return composeFoldHold();
    }
    /* THE MEDIA RING FOLDS WITH THE CHROME (2026-09-29, iOS build 529 parity: the app's fold takes the whole
       chrome block up under the header -- the ring AND the composer -- and the roll starts). The ring
       (#media-ring, views/_media_ring.php; its own IIFE at the foot of this file) tucks at THE FOLD, in the
       same task as the composer, with the composer's own motion: height + margins over .55s on the same
       curve, opacity .4s (rova.css "THE RING FOLDS WITH THE CHROME"); reduced motion = instant.
       WHERE THE READER STANDS DECIDES HOW IT MOVES. The fold only happens at the top, where the ring's slot
       is in view, so the tuck GLIDES: the timeline rises into the space it leaves exactly as it does under
       the composer, the app's "whole pager rises with the fold". Anywhere the slot is NOT the reader's view
       (the ring above the viewport), the change is the composer auto-close's place-keeping correction
       instead: snap the whole stack (html.chrome-snap), give the measured delta back to scrollTop in the
       same task, stamp suppressScrollUntil -- nothing under the reader moves.
       [UN-FOLD NARROWED the same day (Rob, iOS build 535) -- see "UN-FOLD = THE MEMBER'S OWN PULL AT THE TOP" below;
       the paragraph that follows is the first cut, kept for the record.]
       UN-FOLD: the reader's first input (foldWake), or a page scroll the fold did not cause. A MOUSE move /
       click or a non-scrolling key glides it straight back (nothing is being dragged: the chrome returning,
       as the tuck left). A TOUCH, a WHEEL or a scrolling key waits for the gesture to SETTLE (RING_SETTLE_MS
       with no finger down and no page scroll -- scrollTop is never written under a live finger or fling):
       still at the top (a tap, a pull) = the glide back; scrolled away = back ABOVE the reader, place-kept,
       so nothing under the eye moves and scrolling to the top shows it (the app: "only pulling back up to
       the very top re-presents the chrome"). The reader's scrollY is never moved AT the top, so every
       top-keyed rule (watching(), TOP_GUARD, the next fold) reads exactly what it read before the ring folded.
       HOLDS: a resting pointer or focus inside the ring holds the whole fold (ringHold, above); the ring's
       viewer is already feedBusy()'s `.pfeed.show`. A tucked ring is `inert` + visibility:hidden (after
       the glide), its skeleton pulse stops, and its IIFE treats `.mring-tucked` like a cover: no tick, no
       re-read, no retry -- a signal only marks it dirty, and `rova:ringtuck` {tucked:false} re-reads it.
       ring_rev itself, the circles, the seen state and the viewer are untouched. */
    /* THE RING NO LONGER FOLDS (2026-10-04, Rob: "Let's not auto collapse the media ring anymore but don't make it sticky;
       all we need to remove is the auto collapse. I like how it moves when scrolling"). RETIRED here: ringSet/ringFold (the
       tuck at the 5 s fold), the went-live flash's bridge (__rovaRingLiveWake: un-fold + the ring-only re-fold), the touch
       pull's bridge (__rovaRingPull) and every un-fold gesture (ringPull / ringSettle / ringGesture, the wheel-up and
       scroll-key 'top' un-fold, the touch drag). The ring is an ordinary block at the top of the feed: it scrolls away with
       the page and is there again when the member scrolls back up. The composer / search fold, the roll's prime and the
       holds are unchanged; a pointer resting on (or focus inside) the ring still holds them ('ring'), as before. */
    var ringRow = document.getElementById('media-ring');
    function ringHold() {
      if (!ringRow || ringRow.hidden) return '';
      var a = document.activeElement;
      if (a && a !== document.body && ringRow.contains(a)) return 'ring';
      if (CAN_HOVER && ringRow.matches(':hover')) return 'ring';
      return '';
    }
    function armFold(ms) {
      if (foldT) clearTimeout(foldT);
      foldT = setTimeout(foldCheck, Math.max(30, ms == null ? FOLD_IDLE_MS : ms));
    }
    function foldCheck() {
      foldT = null;
      if (foldDone || document.hidden) return;             // re-armed by the next input / the return
      if (document.documentElement.classList.contains('fsrch-sheet')) return;   // the search sheet is up: no fold under it
      if (window.scrollY > 8) return;                      // only parked at the top; the next input re-arms
      if (!idleFor(FOLD_IDLE_MS)) {                        // not quiet yet: look again when it could be
        var now = Date.now(), sAt = pageScrollAt;
        var own = sAt && sAt <= suppressScrollUntil && sAt >= suppressScrollUntil - 350;
        var quiet = Math.min(now - lastAct, own ? Infinity : now - sAt);
        armFold(FOLD_IDLE_MS - quiet + 20);
        return;
      }
      var why = foldHold();
      if (why) {
        // a draft's hold ends on the clock, not on an event: look again exactly when it lapses
        // ...and so does an AUTOMATIC sound hold (feedBusy's busySndLeft: <= 5 s from when the clip became audible)
        var left = why === 'draft' ? (composeEditAt + DRAFT_HOLD_MS - Date.now() + 20)
                 : (why === 'busy' && busySndLeft) ? busySndLeft + 20 : FOLD_RETRY_MS;
        armFold(Math.min(FOLD_RETRY_MS, left));
        return;
      }
      if (feedPref('autohide', true)) {
        searchPanel.collapse();                            // its own guard: focus / typed query
        if (composeBox && !composePanel.isIdle()) { composePanel.forceCollapse(); dropComposeHash(); }
      }
      openHold = false;                                    // the fold moment lifts the open / return hold, tucked or not
      if (!wrap.classList.contains('chrome-idle')) return; // auto-hide OFF or a pinned search: no fold, as the app
      foldDone = true;
      foldAt = Date.now();
      foldLog.push({ at: foldAt, quietMs: foldAt - Math.max(lastAct, pageScrollAt) });
      if (foldLog.length > 20) foldLog.shift();
      if (paused) return;
      // THE PRIME (the app's #212): roll now, reveal FOLD_PRIME_MS later, then the cadence the gear set
      foldPrimeUntil = foldAt + 3000;
      if (!queue.length) maybeRoll();
      if (revealTimer) clearTimeout(revealTimer);
      revealTimer = setTimeout(function () { reveal(); scheduleReveal(); }, FOLD_PRIME_MS);
    }
    // maybeRoll()'s success path calls this while a prime is open: land the card at max(prime, fetch)
    function foldPrimeLanded() {
      if (!foldPrimeUntil) return;
      var now = Date.now();
      if (now > foldPrimeUntil) { foldPrimeUntil = 0; return; }
      if (now < foldAt + FOLD_PRIME_MS) return;            // the prime's own timer is still coming
      foldPrimeUntil = 0;
      if (revealTimer) clearTimeout(revealTimer);
      revealTimer = setTimeout(function () { reveal(); scheduleReveal(); }, 0);
    }
    function foldWake(e) { foldDone = false; openHold = false; if (!foldT) armFold(); }
    ['pointerdown', 'pointermove', 'keydown', 'wheel', 'touchstart'].forEach(function (ev) {
      window.addEventListener(ev, foldWake, { passive: true, capture: true });
    });
    function foldReturn() { lastAct = Date.now(); foldDone = false; openHold = true; firstArm('return'); armFold(); }
    /* THE AUDIBLE CLIP'S HOLD ENDS (2026-09-29, Rob, iOS build 533; the tracker is by engVideo). An AUTOMATIC
       clip's play reached its end inside its 5 s: look again now, not on the next 1 s retry. An EXPLICIT one
       (the member tapped / unmuted it) is over, muted or paused: that moment counts as their last act, so the
       fold comes FOLD_IDLE_MS after it ("after it ends, the fold follows 5 s later") -- never on the retry
       tick that happened to be pending. */
    document.addEventListener('rova:sndhold', function (e) {
      if (foldDone) return;
      if (e.detail && e.detail.hand) { lastAct = Date.now(); armFold(); }
      else armFold(30);
    });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) foldReturn(); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) foldReturn(); });
    armFold();
    window.__rovaFeedFold = function () {   // receipt for the rigs: the same numbers the code decides on
      return { initAt: foldInitAt, foldAt: foldAt, done: foldDone, armed: !!foldT, openHold: openHold, log: foldLog.slice(),
               ring: { present: !!ringRow, tucked: false, hold: ringHold() },
               hold: foldHold(), snd: { autoLeft: busySndLeft, handEndAt: sndHandEndAt, autoMs: SND_AUTO_MS }, compose: { open: !!composeBox && !composePanel.isIdle(), touched: composeTouched,
               editAgo: composeEditAt ? Date.now() - composeEditAt : -1, draft: composeHasDraft() },
               k: { foldIdleMs: FOLD_IDLE_MS, primeMs: FOLD_PRIME_MS, draftHoldMs: DRAFT_HOLD_MS, rollIdleMs: ROLL_IDLE_MS, revealMs: REVEAL_MS } };
    };
    // Apply the auto-hide gear setting LIVE, no reload/wait: turning it OFF is the legacy
    // "never hide it" request, honoured the same way it always was, by opening both right now.
    // Turning it back ON has nothing left to (re-)arm.
    document.addEventListener('rova:feedpref', function (e) {
      if (!e.detail || e.detail.key !== 'autohide') return;
      if (!e.detail.on) { searchPanel.expand(); composePanel.expand(); }   // OFF: show both now
    });

    // Landscape phones have almost no vertical room, so tuck both panels away when the
    // device turns sideways. Scoped to short landscape (phones/small tablets) so wide
    // desktop monitors, which are also "landscape", are never affected. Collapsing further is
    // harmless and each panel's own guard still protects an in-use one.
    var sideMq = window.matchMedia('(orientation: landscape) and (max-height: 560px)');
    function onSideways(e) { if (e.matches) { searchPanel.collapse(); composePanel.collapse(); } }
    if (sideMq.addEventListener) sideMq.addEventListener('change', onSideways);
    else if (sideMq.addListener) sideMq.addListener(onSideways);
    if (sideMq.matches) { searchPanel.collapse(); composePanel.collapse(); }   // already sideways on load

    // ---- embed scroll-yank guard ---------------------------------------------------------
    // Media-player iframes (Spotify/SoundCloud/YouTube) sometimes grab focus the instant they
    // finish loading, and the browser then rapidly scrolls the page down to them in ONE jump.
    // While you're sitting back watching the feed that both jerks the view AND trips the reveal
    // top-guard (scrollY > TOP_GUARD), so new posts stop rolling in. We can't observe the focus
    // (it moves INTO the cross-origin iframe), so we catch the jump itself: a single large scroll
    // step with no recent user gesture is involuntary -> snap back to where the reader was. Real
    // scrolling (and its momentum) always has a recent gesture and moves in small steps, so it's
    // never touched.
    var lastGestureAt = 0, stableY = window.scrollY, prevY = window.scrollY, lastScrollAt = 0;
    ['wheel', 'touchstart', 'touchmove', 'keydown', 'pointerdown', 'mousedown'].forEach(function (ev) {
      window.addEventListener(ev, function () { lastGestureAt = Date.now(); }, { passive: true, capture: true });
    });
    /* PERF (2026-07-29): this block used to register TWO separate window scroll listeners (chrome
       expand / idle re-arm, and the iframe yank guard) and each one independently read
       window.scrollY. A scrollY read after any DOM write in an earlier listener forces a
       re-layout, so two listeners meant two forced layouts per scroll event -- 280ms of a 12s
       scroll on the first one alone. Merged into one handler with a single read. The chrome
       expand/idle-re-arm half this note originally described was itself removed 2026-08-11 (see
       above); the single-read merge stays because a second listener reading scrollY again would
       reopen the exact forced-layout cost this note is about, for whatever gets added here next. */
    window.addEventListener('scroll', function () {
      var now = Date.now(), y = window.scrollY, dy = y - prevY;
      pageScrollAt = now;   // bubbling listener = the PAGE's scroll only (see idleFor); element scrolls never reach it
      // (chrome expand-at-top-of-scroll and the idle re-arm that used to live here were REMOVED
      // 2026-08-11: scrolling, however it ends, must never reveal either panel any more -- only
      // an explicit header tap does that. See makeChromePanel/syncChromeIdle, above.)
      // ---- iframe scroll-yank guard ----
      // A CONTIGUOUS scroll stream (events still firing every frame) is a live glide, not a yank. This is
      // the fix for the "fast fling restarts the scroll" bug on iOS Safari: iOS fires NO touch events during
      // momentum, so the 700ms gesture window went stale MID-FLING and the guard below snapped the page back
      // to where the window expired -- repeatedly, on every fast swipe. Momentum keeps the scroll events
      // coming, so a small gap since the last one proves the motion is the user's own. An iframe focus-yank,
      // by contrast, is a LONE jump after the page has been sitting still (a large gap), so it's still caught.
      var contiguous = (now - lastScrollAt) < 400;
      lastScrollAt = now;
      // an open, empty composer folds itself away once the reader has settled past it (see the
      // threshold note by composeAwayCheck). Cheap here by construction: this only re-arms a timer.
      composeAwayArm();
      if (paused || now - lastGestureAt < 700 || contiguous) { stableY = y; prevY = y; return; }   // user-driven: trust it
      // ONLY an iframe that actually HOLDS FOCUS can yank the page -- that's the entire attack this
      // guard exists for. Without this check, an iOS momentum fling whose scroll events stall >400ms
      // (main thread busy decoding incoming posts) read as "involuntary jump" and the guard snapped
      // the reader BACK UP the page (owner: "my scroll is reset to a higher position"). No focused
      // iframe = the motion is the user's own momentum: trust it.
      var af = document.activeElement;
      var iframeYank = af && af.tagName === 'IFRAME' && af.closest && af.closest('#feed-posts');
      if (dy > 120 && iframeYank) {                    // a big involuntary jump = an iframe yanking the page
        window.scrollTo(0, stableY);
        try { af.blur(); } catch (e) {}                // hand focus back off the iframe so it can't re-pull
        prevY = stableY;
      } else { stableY = y; prevY = y; }
    }, { passive: true });
    // (the touch pull-down-at-top reveal, the wrap-level focusin reveal, and the standalone
    // #feed-chrome pointerdown "hold it open" listener that used to live here were REMOVED /
    // absorbed 2026-08-11: pull-down and focusin are gone outright -- per-panel focusin must
    // never be what makes a panel visible from full collapse, only a header tap does that -- and
    // the pointerdown grace-window logic now lives INSIDE makeChromePanel, above, attached to
    // each box separately so a tap in one can never extend or touch the other's grace window.)
    // media picked (or picker canceled): extend the composer's own grace window a little more;
    // the attached preview (composePanel's extraContent, above) keeps it held from here.
    // Composer-only -- the picker lives inside #feed-compose-box, never the search box.
    var pickInput = document.getElementById('compose-file');
    if (pickInput) {
      pickInput.addEventListener('change', function () { composePanel.hold(6000); });
      pickInput.addEventListener('cancel', function () { composePanel.hold(6000); });
    }
    // keep the search dropdown from being clipped by the search panel's own collapse container
    if (search && searchInner) {
      search.addEventListener('focus', function () { searchInner.style.overflow = 'visible'; });
      // BLUR fires BETWEEN a tap's mousedown and mouseup on a result -- restoring overflow:hidden right
      // then made the dropdown's below-the-chrome rows unhittable mid-click (owner: "bottom results
      // don't follow through"). Only re-clip once the results box is actually gone; the box-dismiss
      // paths below also clean up, and the CSS :has rule keeps the shown box un-clipped regardless.
      search.addEventListener('blur', function () {
        var srBox = document.getElementById('search-results');
        if (!srBox || !srBox.classList.contains('show')) { searchInner.style.overflow = ''; }
      });
      // Keep the search box itself un-clipped while its results dropdown may run taller than
      // the collapsed-height box. SCOPED TO THE SEARCH BOX ONLY: this used to also toggle
      // .searching on #feed-chrome (the shared wrapper) to visually minimize the composer the
      // moment a query was typed -- a search KEYSTROKE reaching across and collapsing the
      // composer's box is exactly the cross-panel touch the independence requirement (2026-08-11)
      // rules out, and it left the two out of sync besides: composePanel's own panel-idle state
      // never changed, so JS still believed the composer was open while it sat visually
      // collapsed. Removed outright; searching now affects nothing but the search box itself.
      var syncSearching = function () {
        var has = search.value.trim() !== '';
        if (searchBox) searchBox.classList.toggle('searching', has);
        if (!has) { searchInner.style.overflow = ''; }   // query cleared: safe to re-clip
      };
      search.addEventListener('input', syncSearching);
    }
    // Both panels start COLLAPSED on every load, unconditionally -- regardless of scroll
    // position and regardless of any restored draft (restoreDraft() only repopulates the still-
    // collapsed composer's fields; it must never itself reveal it -- see its own code). This
    // replaces the old "if (window.scrollY <= 8) expandChrome(); else collapseChrome();" line.
    searchPanel.forceCollapse();
    composePanel.forceCollapse();

    /* the "Post" menu item lands here as /feed#compose, open + focus the composer.
       ONLY this and the header's + tap (same handler) may expand the composer from full
       collapse -- never the search panel. TOGGLES: a second tap (hash already #compose, see
       the click handler below web#17 already routes through here) closes it again -- there was
       previously no way to close either panel short of reloading or rotating to landscape. */
    // Strip a leftover #compose off the URL once the composer is actually closed, so the hash
    // only ever means "open right now" -- belt-and-suspenders alongside cameByReload() below:
    // without this a closed-then-reloaded tab is saved by the reload check, but a plain
    // copy-pasted URL (no reload involved) would still carry a hash that promises something the
    // page no longer shows.
    function dropComposeHash() {
      if (location.hash !== '#compose') return;
      try { history.replaceState(null, '', location.pathname + location.search); }
      catch (e) { location.hash = ''; }
    }
    /* ---- WHERE THE COMPOSER IS, AND WHETHER THE READER HAS LEFT IT -------------------------
       Owner, 2026-09-18: *"when I tap it and open the composer then if I don't add anything and
       swipe down then press the + button again it dismisses the composer above (I can't see this
       happen but I know it happens) ... most users will not know it's still open since they
       swiped down."* Two fixes, and the second is the safety net for the first:
         (1) an EMPTY composer closes itself once the reader has scrolled past it;
         (2) + is never a blind toggle -- it may only close a composer that is ON SCREEN. Open but
             out of view, it scrolls back to it and focuses it instead.
       (2) alone would satisfy the button; (1) is what he actually asked for, and (2) means a
       disagreement between his sense of "away" and this threshold can never cost him a tap.

       THE THRESHOLD, stated: the composer is "scrolled away" when its BOTTOM edge sits more than
       AWAY_PX below the bottom of the sticky header stack -- i.e. entirely out of view, plus 160px
       of feed scrolled past it -- AND the page has been quiet for QUIET_MS. Chosen over "past by
       more than its own height" because the composer's height varies 180-320px with the standing
       verify note, the tool row wrap and an attached preview, so that rule would mean a different
       gesture on different accounts; 160px is one fixed, generous nudge for everyone. It is more
       than iOS Safari's URL-bar collapse (~100px) and any rubber-band bounce, and well under one
       feed card, so an ordinary scroll into the feed closes it while a wobble never does.
       THE QUIET GATE is the same judgement the rest of this file makes before it acts on a reader
       who may still be moving (idleFor / the wheel lock's quiet release): decide on a SETTLED
       position, never mid-fling -- a fast flick that overshoots and springs back must not close
       anything. Nothing here closes a composer that inUse() protects: focus inside it, an open
       picker, the file-picker grace, any field with text, any open editor, staged media, a poster,
       an upload in flight, or a saved draft -- and the gear's "auto-hide composer" OFF still wins,
       because this goes through the guarded collapse(). */
    var COMPOSE_AWAY_PX = 160;    // how far past its bottom edge counts as "gone"
    var COMPOSE_QUIET_MS = 450;   // decide on a settled scroll, never during the fling
    var COMPOSE_SEEN_PX = 24;     // this much of it visible under the header = "he can see it"
    function chromeTopEdge() {
      // the bottom of whatever is pinned across the top right now (the header; the tabs are BELOW
      // the composer, so they never occlude it). Measured, not assumed -- .topbar is sticky at 0
      // on desktop and under the app bar on iOS.
      if (!topbar) return 0;
      var r = topbar.getBoundingClientRect();
      var pos = getComputedStyle(topbar).position;
      return (pos === 'sticky' || pos === 'fixed') ? Math.max(0, r.bottom) : 0;
    }
    function composeBoxRect() {
      if (!composeBox) return null;
      var r = composeBox.getBoundingClientRect();
      return r.height > 0 ? r : null;   // collapsed (0fr) = no box to be visible or away
    }
    // Can the reader actually SEE it? At least COMPOSE_SEEN_PX of the box below the sticky header
    // and above the fold. This is what makes + honest: closing something visible is a toggle,
    // closing something off-screen is the tap that "did nothing".
    function composeVisible() {
      var r = composeBoxRect();
      if (!r) return false;
      var top = Math.max(r.top, chromeTopEdge());
      return (Math.min(r.bottom, window.innerHeight) - top) >= COMPOSE_SEEN_PX;
    }
    function composeScrolledAway() {
      var r = composeBoxRect();
      if (!r) return false;
      return (chromeTopEdge() - r.bottom) > COMPOSE_AWAY_PX || (r.top - window.innerHeight) > COMPOSE_AWAY_PX;
    }
    var composeAwayT = null;
    function composeAwayCheck() {
      composeAwayT = null;
      /* NOT WHILE THE BODY IS PINNED. lockScroll() (the viewer, the auth/change-email modals, every
         sheet) sets body{position:fixed;top:-Y} + .scroll-locked, so scrollY reads 0 and every rect
         is measured against a page that is being held, not read. Deciding "he has scrolled away"
         from those numbers would fold the composer up behind an open overlay. Same skip, and the
         same reasoning, as rememberTab()'s in the per-tab scroll memory. */
      if (document.body.classList.contains('scroll-locked')) return;
      if (composePanel.isIdle() || !composeScrolledAway()) return;
      /* WHAT MAY HOLD IT OPEN, AND THE ONE THING THAT MAY NOT. inUse(true) asks the panel's own
         guard while IGNORING the caret: typed text, an open editor or picker, staged media, a
         video cover, an upload in flight, a saved draft, the file-picker grace -- any of those and
         we leave, at any scroll position. The caret is excluded deliberately, and this is the one
         place where "do not close a focused field" is narrowed: + FOCUSES the textarea on every
         open (the 09-14 iOS keyboard rule), so a focused empty composer is simply what a
         just-opened one looks like -- honouring focus here would mean this never fires at all.
         Focus still protects it everywhere that matters: nothing closes until the box is entirely
         out of view AND 160px further on, so "he scrolled a little and is about to type" is inside
         the margin and safe. Past that the caret is stale, and we BLUR before collapsing so iOS
         takes the keyboard down with it rather than leaving one up for an invisible field.
         The gear's "auto-hide composer" OFF still wins outright. */
      if (composePanel.inUse(true) || !feedPref('autohide', true)) return;
      var af = document.activeElement;
      if (af && composeBox && composeBox.contains(af) && typeof af.blur === 'function') { try { af.blur(); } catch (e) {} }
      /* THE READER MUST NOT SEE THE FEED MOVE. The composer being removed sits ABOVE the viewport,
         so collapsing it shortens the document above the reader and every card below jumps up by
         its height -- Chromium's scroll anchoring hides that, WebKit has none, and the owner is on
         an iPhone. So: SNAP the collapse (the .55s grid animation would drift the page for half a
         second, which no one-shot correction can cancel) and take the same pixels off the scroll
         offset in the same task, before a frame can paint. This is insertTop's place-keeping
         correction, verbatim -- measure a reference that survives the change, apply the delta to
         scrollTop, and stamp suppressScrollUntil so the feed's own idleFor() reads the correction
         as OUR scroll and not as the reader moving. */
      var ref = feed || document.getElementById('feed-posts');
      var refTop = ref ? ref.getBoundingClientRect().top : 0;
      // the whole top stack, not just the box: collapsing it also flips html.feed-collapsed, which
      // animates the header's bottom margin and the sticky tabs' padding (rova.css .chrome-snap)
      document.documentElement.classList.add('chrome-snap');
      composePanel.collapse();
      if (ref && ref.isConnected) {
        var d = Math.round(ref.getBoundingClientRect().top - refTop);   // forces the layout we need
        if (d) {
          suppressScrollUntil = Date.now() + 350;
          var se = document.scrollingElement || document.documentElement;
          se.scrollTop = se.scrollTop + d;   // instant, never smooth: a correction, not a move
        }
      }
      // give the transitions back on the next frame so a later TAP-driven open/close animates as always
      requestAnimationFrame(function () { document.documentElement.classList.remove('chrome-snap'); });
      if (composePanel.isIdle()) dropComposeHash();   // the hash may only ever mean "open right now"
    }
    // Armed from the ONE merged scroll listener below (a second listener reading scrollY would
    // re-open the forced-layout cost that merge exists to avoid). Per scroll event this is a
    // clearTimeout + setTimeout and nothing else -- every rect read happens once, on the settle.
    function composeAwayArm() {
      if (composePanel.isIdle()) return;
      if (composeAwayT) clearTimeout(composeAwayT);
      composeAwayT = setTimeout(composeAwayCheck, COMPOSE_QUIET_MS);
    }
    window.__rovaComposeAway = function () {   // harness: the same numbers the code decides on
      var r = composeBoxRect();
      return { open: !composePanel.isIdle(), visible: composeVisible(), away: composeScrolledAway(),
               inUse: composePanel.inUse(), work: !!(window.__rovaComposerHasWork && window.__rovaComposerHasWork()),
               chromeBottom: Math.round(chromeTopEdge()), rect: r ? { top: Math.round(r.top), bottom: Math.round(r.bottom), h: Math.round(r.height) } : null,
               k: { awayPx: COMPOSE_AWAY_PX, quietMs: COMPOSE_QUIET_MS, seenPx: COMPOSE_SEEN_PX } };
    };

    function focusComposer() {
      var ta = document.querySelector('#feed-compose-box .composer textarea');
      /* THE TOGGLE IS NOW CONDITIONAL ON BEING SEEN (2026-09-18, above). Open AND on screen: this
         is the deliberate second tap of a control the reader is looking at, so close it, exactly as
         before. Open but scrolled off: fall through and treat the tap as "take me to it" -- the
         invariant is that a + tap ALWAYS ends with the composer on screen and focused. */
      if (!composePanel.isIdle() && composeVisible()) {
        composePanel.forceCollapse(); dropComposeHash();
        // drop the keyboard with the panel: a focused field inside a 0fr/opacity:0 box is a
        // caret the reader cannot see (and on iOS a keyboard they cannot explain)
        if (ta && document.activeElement === ta) { try { ta.blur(); } catch (e) {} }
        return;
      }
      composePanel.expand();   // idempotent: a no-op on the already-open, scrolled-away case
      /* FOCUS FIRST, SYNCHRONOUSLY, INSIDE THE TAP (2026-09-18). iOS Safari raises the keyboard only for
         a focus() that runs in the gesture's own dispatch -- the old setTimeout(…, 320) after a smooth
         scroll opened the box with no keyboard, one more tap to start typing. The textarea is focusable
         right now even though its box is mid-transition (0fr rows, opacity 0 -- it still has a layout
         box), and the same-page click handler below now calls this directly in the click rather than
         via the asynchronous hashchange, which is the other half of "inside the gesture".
         preventScroll: the element's own scroll-into-view would be aimed at a box that is still 0px
         tall; the page scroll is ours, next line. */
      if (ta) { try { ta.focus({ preventScroll: true }); } catch (e) { try { ta.focus(); } catch (e2) {} } }
      /* THE COMPOSER IS THE FIRST PANEL UNDER THE HEADER (views/feed.php: the notice stack now renders
         under #feed-chrome), so "scroll it into view" is exactly "go to the top". Instant on a touch
         device: the keyboard is already rising and resizing the viewport, and a .5s smooth glide from
         deep in the feed fights it (the glide is cancelled by the resize on iOS, leaving the reader
         mid-page with the keyboard up). A mouse keeps the smooth glide it always had.
         2026-09-18: the glide a mouse keeps is now RE-ASSERTED, because the panel's own 550ms growth was
         cancelling it in WebKit and stranding the reader deep in the feed with the composer folding
         itself away behind them -- the whole mechanism, the measurements and the stand-down guard are
         written out once at __rovaScrollToTop (search this file for "TAKE ME TO THE TOP"). */
      if (window.__rovaScrollToTop) { window.__rovaScrollToTop(); }
      else { try { window.scrollTo({ top: 0, behavior: 'auto' }); } catch (e) { window.scrollTo(0, 0); } }
    }
    // A RELOAD (or back/forward) with #compose already sitting in the URL bar -- e.g. this
    // exact test: tap +, start a draft, hit refresh -- must NOT spring the composer back open;
    // "both collapsed on every fresh load" is unconditional, draft or no draft. Only a genuine
    // NEW navigation to /feed#compose (the Post menu item's link, or the same-page click handler
    // below) is the "explicit tap" that may open it. The Navigation Timing API is the only
    // reliable way to tell these apart -- location.hash reads identically in both cases.
    function cameByReload() {
      try {
        var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
        return !!nav && (nav.type === 'reload' || nav.type === 'back_forward');
      } catch (e) { return false; }
    }
    if (location.hash === '#compose' && !cameByReload()) focusComposer();
    window.addEventListener('hashchange', function () { if (location.hash === '#compose') focusComposer(); });
    // web#17: when the URL is ALREADY /feed#compose, clicking Post again fires no
    // hashchange — so scrolled-down taps did nothing. Drive it from the click.
    // ONLY when the hash isn't actually changing, though (2026-08-11 fix): setting an
    // already-different hash to '#compose' fires hashchange asynchronously, and the listener
    // above ALSO calls focusComposer() -- so a plain unconditional call here double-fired on
    // every ordinary first tap. That was harmless while focusComposer() only ever expanded
    // (idempotent), but now that it TOGGLES, two calls in a row expand then immediately
    // collapse again -- the button read as doing nothing. Call it directly only when
    // hashchange won't (hash already '#compose'); otherwise let the single hashchange own it.
    // 2026-09-18: the hash is written with pushState (which fires NO hashchange) and focusComposer()
    // is called RIGHT HERE, in the click -- so the textarea focus lands inside the user gesture and
    // iOS raises the keyboard (see focusComposer). Setting location.hash instead deferred the open
    // to the asynchronous hashchange, which is outside the gesture: box open, no keyboard. Same
    // history shape as before (one entry per open); the hashchange listener above still serves a
    // genuine hash navigation (a cross-page /feed#compose link lands on the load path anyway).
    document.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a[href$="#compose"]') : null;
      if (!a) return;
      /* 2026-10-12: "/" IS the feed too (handle_landing renders handle_feed in-process), so a /feed#compose link on "/" is
         also THIS page's composer -- before this, the header "+" and the ring's "Me" circle did a full page load to /feed there
         (Rob: tapping "Me" reloaded the page). Same page = same pathname, or a /feed link while the home composer is here. */
      var samePage = (a.pathname || '') === location.pathname || (a.pathname === '/feed' && !!composeBox && composeBox.isConnected);
      if (!samePage) return;
      e.preventDefault();
      if (location.hash !== '#compose') {
        try { history.pushState(null, '', location.pathname + location.search + '#compose'); }
        catch (err) { location.hash = '#compose'; return; }   // no History API: the hashchange path owns it
      }
      focusComposer();
    });

    // Escape closes whichever of ours is open. Each check is independent -- closing one never
    // depends on, or touches, the other's state -- matching the site-wide convention that
    // Escape dismisses whatever is currently open (the header flyouts, modals, popovers all do
    // the same, each keyed off its own state).
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (!searchPanel.isIdle()) { searchPanel.forceCollapse(); if (search) search.blur(); }
      if (!composePanel.isIdle()) { composePanel.forceCollapse(); dropComposeHash(); }
    });
    /* THE RED CLOSE X (2026-09-28, iOS parity; views/_composer.php .composer-x). The SAME close the
       + toggle and Escape perform -- forceCollapse, drop the #compose hash, blur so iOS takes the
       keyboard down with the panel -- and nothing more: the typed text, staged media, an open poll or
       trip, a scheduled time and the sessionStorage draft all stay exactly where they are, so the next
       + finds them. Closing is never discarding, which is why it needs no confirm. */
    if (composeBox) composeBox.addEventListener('click', function (e) {
      var x = e.target.closest ? e.target.closest('.composer-x') : null;
      if (!x || composePanel.isIdle()) return;
      e.preventDefault();
      var af = document.activeElement;
      if (af && composeBox.contains(af) && typeof af.blur === 'function') { try { af.blur(); } catch (er) {} }
      composePanel.forceCollapse();
      dropComposeHash();
    });
    // Click outside the search box (and its own header opener) closes it. The composer does NOT
    // get an outside-click closer: several of its legitimate targets -- the emoji/GIF pickers,
    // the embed-hint popover, the native file dialog -- are portaled straight onto <body>, well
    // outside #feed-compose-box, and a generic "outside" test would have to special-case every
    // one of them to avoid closing the composer out from under an in-progress pick. The search
    // box has no such portaled children (its dropdown lives inside #feed-search-box itself), so
    // the same rule is safe there. Composer close stays Escape + the + button's own toggle above.
    document.addEventListener('click', function (e) {
      if (!e.target.isConnected || searchPanel.isIdle()) return;
      if (e.target.closest && (e.target.closest('#feed-search-box') || e.target.closest('#search-drop'))) return;
      searchPanel.forceCollapse();
    });

    /* THE SESSION-WIDE SCREEN LOCK IS GONE (2026-09-03). What used to live here took a
       'screen' wake lock on load and re-took it on every pointerdown / touchstart / scroll /
       keydown / mousemove, for the life of the page, with no reference to whether anything was
       playing. So a reader parked on a static timeline held their phone's screen up
       indefinitely -- the exact never-return-to-idle pathology phone-heat-energy-evidence
       names as the dominant battery cost -- and it still did not answer the report that
       prompted the rewrite, because it is bound to this header IIFE while the complaint came
       from a clip playing on a permalink.
       The lock now belongs to the video engine, is taken ONLY while a clip is actually running
       and visible on a surface the reader opened to watch it (the immersive viewer or the
       permalink's own card -- muted or not, since he was WATCHING; grid tiles and feed
       previews never qualify), and is released on pause/end/scroll-away/hide/close. The
       Media Session is the half that still requires sound. See __rovaWakeLock (and the long
       comment above it) in the feed-video engine; nothing needs to be re-registered here. */

    /* ---- THE STATE LATCH (#ft-latch) ---------------------------------------------------
       The tab strip's three discs told the reader nothing about what a tap had just done, and
       nothing at all to a reader who ARRIVED with the verified filter already on (it is a
       year-long cookie). This is one absolutely-positioned text node under the cluster with two
       jobs kept deliberately separate:

         latchSay()   the TRANSIENT phrase -- "Verified only", "Feed paused" -- named for the
                      state the tap just produced. It says FEED, not "Live": members read "Live"
                      as broadcast (owner, 2026-09-04; same finding as the transport's own
                      comment in views/feed.php), and what actually stopped is the feed.
                      state the tap just produced, tinted to the control that spoke, ~1.2s.
         latchRest()  the PERMANENT latch -- "Verified", "Paused", "Verified · Paused", or, when
                      everything is default, the empty string and an invisible node.

       THE TWO HALVES MUST NEVER SHARE A CALL SITE, AND THAT IS THE WHOLE TRAP IN THIS FEATURE.
       renderLive() below is subscribed to `rova:attention` and `rova:enghold`. Those fire when
       the engagement hold ARMS AND WHEN IT LAPSES -- with no tap involved, while the reader is
       just scrolling. So renderLive() may call latchRest() (that is exactly what makes `Held`
       appear and disappear for free) and must NEVER call latchSay(), or the row flashes a
       sentence at somebody who did not touch anything. latchSay() is called from inside the two
       `click` listeners and from nowhere else. tools/latch-tap-only-check.js asserts it.

       latchRest() READS THE CLASSES renderLive() STAMPS rather than the `paused` variable and a
       liveHeld() it would have to reach across a scope for. Same reason the shared-cache bug was
       a bug: the honest question is "what is the control actually rendering", and that is the
       class list. It also means this needs no cross-scope plumbing to the block below.

       COPY COMES OFF THE ELEMENT, NOT OUT OF THIS FILE (data-* on #ft-latch, views/feed.php).
       There is no translation bridge reachable from a bundle -- assets/ has no t() -- so a string
       literal here is a string that can never be localized. The fallbacks are English and match
       the markup exactly, so a stale cached HTML/JS pair degrades to correct English, never to
       an empty caption. */
    var latchEl   = document.getElementById('ft-latch');
    var latchVf   = document.getElementById('verified-toggle');
    var latchLive = document.getElementById('live-toggle');
    var laySay = null, layOff = null;
    function latchTxt(k, dflt) {
      var v = latchEl && latchEl.getAttribute('data-' + k);
      return (typeof v === 'string' && v !== '') ? v : dflt;
    }
    /* THE PERMANENT HALF. Safe to call from any repaint, on any schedule, as often as you like.
       It reads state and writes text; it starts no timer and it can surprise nobody. */
    function latchRest() {
      if (!latchEl) return;
      var parts = [], gold = false;
      if (latchVf && latchVf.classList.contains('on')) parts.push(latchTxt('r-verified', 'Verified'));
      // `paused` (a preference) wins the wording over `held` (a condition) exactly as the glyph
      // rendering below does -- both stop the timeline, and saying "Held" over a feed the reader
      // deliberately paused would be a lie in the other direction.
      if (latchLive && latchLive.classList.contains('paused')) { parts.push(latchTxt('r-paused', 'Paused')); gold = true; }
      else if (latchLive && latchLive.classList.contains('held')) { parts.push(latchTxt('r-held', 'Held')); gold = true; }
      var txt = parts.join(' · ');
      latchEl.className = 'ft-latch rest'
        + (parts.length > 1 ? ' has-both' : (gold ? ' has-gold' : ''))
        + (txt ? ' show' : '');
      latchEl.textContent = txt;
    }
    /* THE TRANSIENT HALF. CALL ONLY FROM A REAL CLICK HANDLER -- see the note above.
       There is no per-control entrance DIRECTION and there was one for about an hour: a
       right-anchored node entering from the right starts outside the cluster, and at 360px that
       measured as six pixels of horizontal overflow inside #feed-tabs (see the note on the base
       transform in rova.css). Every entrance now comes from the left, into the row. */
    function latchSay(text, tone, holdMs) {
      if (!latchEl) return;
      clearTimeout(laySay); clearTimeout(layOff);          // a re-tap cannot accumulate
      latchEl.className = 'ft-latch say tone-' + tone;
      latchEl.textContent = text;
      void latchEl.offsetWidth;                            // restart the entrance on a re-tap
      latchEl.classList.add('show');
      laySay = setTimeout(function () {
        latchEl.classList.remove('show');
        layOff = setTimeout(latchRest, 190);               // crossfade into the resting latch
      }, holdMs || 1200);
    }
    /* A single ring that expands OUTWARD past the rim over 340ms and is then REMOVED from the
       document. Outward is the point: the press affordance is scale(.94) inward, so the opposite
       direction cannot be mistaken for a ripple. Nothing survives at rest -- no hidden node, no
       standing animation. Gated on reduced motion here as well as in CSS so the node is never
       even created for a reader who asked for stillness. */
    function discPulse(el, colour) {
      if (!el) return;
      try { if (matchMedia('(prefers-reduced-motion:reduce)').matches) return; } catch (e) {}
      var p = document.createElement('span');
      p.className = 'disc-pulse'; p.style.color = colour;
      el.appendChild(p);
      setTimeout(function () { if (p.parentNode) p.parentNode.removeChild(p); }, 360);
    }

    /* pause / resume switch on the tabs row */
    var liveBtn = latchLive;
    if (liveBtn) {
      var liveLabel = liveBtn.querySelector('.live-label');
      /* A CONTROL THAT SAYS "PLAYING" WHILE THE FEED HAS SECRETLY STOPPED IS A NEW BUG -- and that was
         already the state of this button before the attention hold existed: engaged() has suspended the
         poll, the reveal and the roll since the engage-hold shipped, and this pill went on showing the
         PAUSE glyph (= "running, tap to stop") throughout. HELD is the third rendering, and it is NOT a
         second copy of the paused state:
           paused  a PREFERENCE. Persisted in localStorage, only the reader sets it, survives reloads.
           held    a CONDITION. Nothing is persisted, nobody chose it, and it lapses on its own.
         Both stop the timeline, so both show the PLAY glyph -- the glyph is the action AVAILABLE, and in
         both cases that action is "start it again now". Tapping while held therefore RELEASES the hold
         rather than flipping the preference: the button always does the thing its own icon promises, and
         the reader keeps an explicit override over the two-minute wait. `paused` wins the rendering when
         both are true; releasing a hold under a paused feed would be a lie in the other direction. */
      var liveHeld = function () { return !paused && (engaged() || engAttn()); };
      var renderLive = function () {
        var held = liveHeld();
        liveBtn.classList.toggle('paused', paused);
        liveBtn.classList.toggle('held', held);
        liveBtn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        var lab = paused ? 'Resume feed'
                : (held ? 'Timeline held while you are engaging, resume it now' : 'Pause feed');
        liveBtn.setAttribute('aria-label', lab);
        liveBtn.title = lab;
        if (liveLabel) liveLabel.textContent = paused ? 'Paused' : (held ? 'Held' : 'Live');
        /* THE RESTING LATCH, AND ONLY THE RESTING LATCH. This is the repaint the two broadcasts
           below drive, so it fires with no tap involved -- which is precisely why latchSay() is
           not allowed here. It is also what makes `Held` latch and un-latch for free: the hold
           arming and the hold lapsing both come through this function already. */
        latchRest();
      };
      renderLive();
      // Repaint on the one broadcast rather than on a timer: engAttnSay() fires on arm AND at the exact
      // instant the hold lapses, and engHold() fires whenever a named hold opens or closes.
      document.addEventListener('rova:attention', renderLive);
      document.addEventListener('rova:enghold', renderLive);
      liveBtn.addEventListener('click', function () {
        if (liveHeld()) {                       // held, not paused: the icon says "play", so play.
          engAttnClear();
          engKeys().forEach(function (k) { engHold(k, false); });
          renderLive();
          // A TAP happened, so the phrase is earned. renderLive() above has already reset the
          // latch to rest; latchSay() overwrites it and hands it back at +1.39s.
          discPulse(liveBtn, '#f5c518'); latchSay(latchTxt('p-lplay', 'Feed resumed'), 'gold');
          poll(); refreshCounts();
          return;
        }
        paused = !paused;
        try { localStorage.setItem('rova_feed_paused', paused ? '1' : '0'); } catch (e) {}
        // A TAP IS THE READER'S DECISION, whichever way it went: if the sustained-jank governor had
        // paused the feed (rova_feed_paused_by = 'gov'), this drops its ownership so it never resumes
        // or re-pauses over a choice the reader made by hand. See __rovaJank.
        try { localStorage.removeItem('rova_feed_paused_by'); } catch (e) {}
        renderLive();
        discPulse(liveBtn, '#f5c518');
        latchSay(paused ? latchTxt('p-lpause', 'Feed paused') : latchTxt('p-lplay', 'Feed resumed'), 'gold');
        if (!paused) { poll(); refreshCounts(); } // resuming, catch up right away (new posts AND the badges)
      });
    }
    /* THE ONE PAUSE, REACHABLE FROM OUTSIDE (2026-09-07, for the sustained-jank governor -- __rovaJank).
       Same `paused`, same localStorage key the pill writes, same renderLive() repaint, so the cascade
       (which reads the key), the poll/reveal/roll (which read `paused`) and the pill + resting latch
       all agree. No latchSay() here on purpose: that phrase is reserved for a real tap (see the
       latch note above); the resting "Paused" is what a reader sees when the governor stepped in. */
    window.__rovaFeedPauseCtl = {
      get: function () { return paused; },
      set: function (on) {
        on = !!on;
        if (paused === on) return;
        paused = on;
        try { localStorage.setItem('rova_feed_paused', on ? '1' : '0'); } catch (e) {}
        if (typeof renderLive === 'function') renderLive();
        if (!on) { poll(); refreshCounts(); }
      }
    };

    // "Verified only" toggle: flip the per-device cookie (so the server also filters the live
    // stream + future loads), then AJAX-swap the CURRENT tab's posts in place -- no page reload.
    var vBtn = document.getElementById('verified-toggle');
    if (vBtn) {
      vBtn.addEventListener('click', function () {
        // Verified/admin only. Everyone else (trialing, free, guests) gets a red blink; guests are
        // also sent to sign up. The server ignores the cookie for them too, so this can't be faked.
        if (vBtn.getAttribute('data-eligible') !== '1') {
          vBtn.classList.remove('vf-deny'); void vBtn.offsetWidth; vBtn.classList.add('vf-deny');
          setTimeout(function () { vBtn.classList.remove('vf-deny'); }, 620);
          /* The blink says "no" in colour and the shake says it in motion; this says it in a
             WORD, which is the only one of the three a reader with a red/green deficiency can
             rely on. It is deliberately not the how-to -- that is 100 characters and it still
             goes where it always went, to the toast below / the signup modal. Held for the
             blink's own 620ms, then the latch hands itself back to whatever it was. */
          latchSay(latchTxt('p-deny', 'Not available'), 'deny', 620);
          if (vBtn.getAttribute('data-guest') === '1') {
            var s = document.createElement('a'); s.href = '/signup'; s.style.display = 'none';
            document.body.appendChild(s); s.click(); s.remove();   // opens the signup modal (or navigates)
          } else {
            // Signed-in but not yet verified. Don't reveal this is a verified-only feature -- frame it
            // as HOW to get verified: account older than 7 days + an active subscription (i.e. paying).
            toast('To be verified, your account must be older than 7 days and you must have an active subscription.', 4200);
          }
          return;
        }
        if (vBtn._busy) return;
        var next = vBtn.classList.contains('on') ? '0' : '1';
        document.cookie = 'rova_verified_only=' + next + ';path=/;max-age=31536000;samesite=lax'
          + (location.protocol === 'https:' ? ';secure' : '');
        vBtn.classList.toggle('on', next === '1');
        vBtn.setAttribute('aria-checked', next === '1' ? 'true' : 'false');
        /* SPEAKS ON THE OPTIMISTIC TOGGLE, NOT ON SETTLE. The swap below is deadlined at 8s and
           holds `_busy` + .is-loading for the whole of it on a slow link -- telling the reader
           what they turned on only once the network answered would be the wrong eight seconds of
           silence. If the request fails it location.reload()s and the latch re-initialises from
           the server's own state, which is the correct recovery either way. */
        discPulse(vBtn.querySelector('.vfilter-orb'), '#4f9bff');
        latchSay(next === '1' ? latchTxt('p-von', 'Verified only') : latchTxt('p-voff', 'All accounts'), 'blue');
        if (!feed) { location.reload(); return; }   // no feed container: fall back to a reload
        vBtn._busy = true; vBtn.classList.add('is-loading');
        syncTab();   // make sure curTab is current
        // SLOW-LINK (2026-08-09): deadlined. `_busy` is cleared only when this settles and the class
        // is what paints the spinner, so on a half-open socket the toggle sat lit and REFUSED every
        // further tap for the 60-120s the platform takes to give up -- a control the reader can see,
        // is looking straight at, and cannot use. rfetch also rejects a non-2xx, which lands on the
        // existing .catch and takes the same location.reload() recovery the null branch already did.
        rfetch('/feed?tab=' + encodeURIComponent(curTab) + '&partial=posts',
              { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', cache: 'no-store' }, 8000)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            if (html == null) { location.reload(); return; }
            feed.innerHTML = html;
            // a FILTER CHANGE is one of the two things allowed to replace a list: every other tab's kept
            // rows were built under the old filter, so the pager drops them (page one on the next visit)
            try { if (tabs && tabs._rovaPager && tabs._rovaPager.dropCache) tabs._rovaPager.dropCache(); } catch (e) {}
            if (window.__rovaHydrate) window.__rovaHydrate(feed);   // carousels/embeds (videos self-wire)
            queue = [];        // drop anything queued under the old filter
            reindex();         // re-anchor the live stream's dedup + cursor to the filtered set
            try { feed.dispatchEvent(new CustomEvent('rova:paged')); } catch (e) {}  // "Load more" re-evaluates
            window.scrollTo(0, 0);
          })
          .catch(function () { location.reload(); })
          .then(function () { vBtn._busy = false; vBtn.classList.remove('is-loading'); });
      });
    }
    /* Paint the resting latch once for the reader who ARRIVED with a filter already on -- the
       verified cookie is a year long, so "why is my feed so quiet" is a question somebody can
       land on without ever having tapped anything in this session. renderLive() has normally
       done this already; this is the path where the transport is absent, and it is idempotent. */
    latchRest();
  })();

  /* ---- timeline speed setting (Settings -> Timeline) --------------------- */
  (function () {
    var seg = document.getElementById('speed-seg');
    if (!seg) return;
    var opts = seg.querySelectorAll('.speed-opt');
    var cur = 'normal';
    try { cur = localStorage.getItem('rova_feed_speed') || 'normal'; } catch (e) {}
    function paint() {
      opts.forEach(function (b) { b.classList.toggle('on', b.getAttribute('data-speed') === cur); });
    }
    paint();
    seg.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('.speed-opt') : null;
      if (!b) return;
      cur = b.getAttribute('data-speed');
      try { localStorage.setItem('rova_feed_speed', cur); } catch (e) {}
      paint();
      if (typeof toast === 'function') toast('Timeline speed: ' + b.textContent.trim());
    });
  })();

  /* ---- settings: hidden (soft-blocked) accounts, unhide/block/clear AJAX -- */
  (function () {
    var box = document.getElementById('hidden-accounts');
    if (!box) return;
    function showEmpty() {
      var list = box.querySelector('.muted-list'); if (list) list.remove();
      var clr = box.querySelector('.js-clear-hidden'); if (clr) clr.remove();
      if (!box.querySelector('.muted-empty')) {
        var d = document.createElement('div');
        d.className = 'muted muted-empty';
        d.style.padding = '6px 2px';
        d.textContent = "You haven't hidden anyone.";
        box.appendChild(d);
      }
    }
    box.addEventListener('submit', function (e) {
      var form = e.target.closest ? e.target.closest('form') : null;
      if (!form) return;
      e.preventDefault();
      var conf = form.getAttribute('data-confirm');
      if (conf && !window.confirm(conf)) return;
      var fd = new FormData(form);
      var action = fd.get('action');
      postJson(form.getAttribute('action'), fd).then(function () {
        if (action === 'clear') { showEmpty(); return; }
        var row = form.closest('.muted-row');
        if (!row) return;
        row.style.transition = 'opacity .2s ease';
        row.style.opacity = '0';
        setTimeout(function () {
          row.remove();
          if (!box.querySelector('.muted-row')) showEmpty();
        }, 200);
      }).catch(function (err) { if (!err || err.message !== 'reauth') toast('Something went wrong. Try again'); });
    });
  })();

  /* ---- feed aside: dismiss a "Discover people" suggestion, fade in another - */
  (function () {
    var panel = document.getElementById('discover-people');
    if (!panel) return;
    var list = panel.querySelector('.sugg-list');
    if (!list) return;

    function shownIds() {
      return Array.prototype.map.call(list.querySelectorAll('.aside-person[data-id]'), function (el) {
        return el.getAttribute('data-id');
      });
    }
    // fade a row out and swap in a fresh suggestion IN PLACE. The replacement
    // is fetched BEFORE the old row leaves, so the panel never changes height
    // mid-swap (the old remove-then-refetch bounce read as a glitch).
    // persistHide=true records a dismissal (the × button); a follow just
    // consumes the row. slow=true is the ambient rotation's pace.
    function consume(row, persistHide, slow) {
      if (!row || row._consumed) return;
      row._consumed = true;
      if (persistHide) {
        var id = row.getAttribute('data-id');
        if (id) postJson('/suggest-hide', { user_id: id }).catch(function () {});
      }
      var ms = slow ? 850 : 280;
      // the goodbye starts NOW (instant feedback); the replacement is fetched
      // in parallel and swapped in once BOTH are done, so the farewell never
      // waits on the network and the panel never changes height
      row.style.transition = 'opacity ' + (ms / 1000) + 's ease, transform ' + (ms / 1000) + 's ease';
      row.style.opacity = '0';
      row.style.transform = 'translateY(-6px)';
      var faded = new Promise(function (res) { setTimeout(res, ms); });
      // server also excludes anyone this user has permanently dismissed
      // SLOW-LINK (2026-08-09): deadlined. The REJECTION path was already sound -- '' falls through
      // to row.remove() below, so the panel shrinks cleanly. A HANG was not: the row has already been
      // faded to opacity:0 by the lines above, `faded` resolves on its timer, and the .then that
      // either replaces or removes it never runs at all. The row stays in the layout, invisible,
      // forever -- and the ambient rotation blanks another one every 15-25s. The deadline routes a
      // stall into the same '' the server-refusal path already takes.
      rfetch('/suggest-people?n=1&exclude=' + encodeURIComponent(shownIds().join(',')),
            { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', cache: 'no-store' }, 8000)
        .then(function (r) { return r.text(); })
        .catch(function () { return ''; })
        .then(function (html) { return faded.then(function () { return html; }); })
        .then(function (html) {
          var fresh = null;
          if (html && html.trim()) {
            var tmp = document.createElement('div');
            tmp.innerHTML = html;
            fresh = tmp.querySelector('.aside-person');
          }
          if (fresh) {
            fresh.classList.add('sugg-in');
            if (slow) fresh.classList.add('sugg-slow');
            if (row.parentNode) { row.replaceWith(fresh); } else { list.appendChild(fresh); }
            requestAnimationFrame(function () { requestAnimationFrame(function () { fresh.classList.add('in'); }); });
            setTimeout(function () { fresh.classList.remove('sugg-in', 'sugg-slow', 'in'); }, slow ? 1000 : 500);
          } else {
            row.remove();   // nothing left to suggest: shrink once, no bounce back
          }
        });
    }

    // ---- ambient rotation: while the person sits on the timeline, gently swap
    // one suggestion for a fresh face every ~15-25s. Skips when the tab is
    // hidden or the aside is off-screen (mobile), and never yanks a row the
    // cursor is on or one that was just followed.
    (function rotate() {
      setTimeout(function () {
        rotate();
        if (document.hidden || !panel.offsetParent) return;
        var rows = list.querySelectorAll('.aside-person[data-id]');
        if (rows.length < 3) return;                       // keep the panel from thinning out
        var pick = rows[Math.floor(Math.random() * rows.length)];
        if (pick._consumed) return;
        if (pick.matches && pick.matches(':hover')) return;
        var act = pick.querySelector('input[name="action"]');
        if (act && act.value === 'unfollow') return;       // just followed, leave it be
        consume(pick, false, true);
      }, 15000 + Math.random() * 10000);
    })();

    panel.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('.js-sugg-hide') : null;
      if (!btn) return;
      e.preventDefault();
      consume(btn.closest('.aside-person'), true);
    });
    // a follow (handled by the global js-follow handler) fades the row + refills
    document.addEventListener('rova:suggestion-followed', function (e) {
      var row = e.detail && e.detail.row;
      if (row && list.contains(row)) setTimeout(function () { consume(row, false); }, 140); // a beat of "Following", then straight out
    });
  })();

  /* ---- "Suggested for you" carousels ---------------------------------------------------
     An auto-sliding strip of people to follow: slides one card left every few seconds
     (slot-machine rotation), recycling the first card to the end so it loops forever. Pauses
     the instant you touch it (so Follow/× are easy) then resumes. Following or dismissing a
     card drops it and pulls in a fresh face. These are INTERLEAVED into the feed after every
     10th post (a hidden <template id="sugg-seed"> holds the initial cards to clone). */
  (function () {
    var seed = document.getElementById('sugg-seed');
    var INTERVAL = 5;   // a single carousel, after the 5th post (Discover tab only)
    var authed = !!(seed && seed.getAttribute('data-authed') === '1');

    function globalShownIds() {
      return Array.prototype.map.call(document.querySelectorAll('.sugg-slide[data-id]'), function (el) { return el.getAttribute('data-id'); });
    }

    function initSuggCarousel(carousel) {
      if (!carousel || carousel._suggInit) return;
      var view = carousel.querySelector('.sugg-carousel-view');
      var track = carousel.querySelector('.sugg-track');
      if (!view || !track || track.children.length < 2) { carousel.style.display = 'none'; return; }
      carousel._suggInit = 1;
      var paused = false, resumeT = null;

      // PERF: this is 2-3 forced layout reads, and recycle() calls it inside the carousel's own scroll
      // settle while the PAGE is often still scrolling. The slide pitch only changes when the viewport
      // does, so measure once and invalidate on resize (and whenever it reads back as nonsense).
      var _cw = 0;
      onCarouselResize(carousel, function () { _cw = 0; });   // shared listener: never pin this element
      function cardW() {
        if (_cw > 0) return _cw;
        var a = track.children[0], b = track.children[1];
        if (!a) return 0;
        _cw = b ? (b.getBoundingClientRect().left - a.getBoundingClientRect().left) : a.getBoundingClientRect().width;
        return _cw;
      }
      // endless loop: recycle any card scrolled WELL off the left edge to the end and pull scrollLeft
      // back by the same amount, so there's always more ahead (manual OR auto). Don't yank cards while
      // the reader is touching it -- they may be swiping BACK to follow someone the auto-slide passed.
      // The back-buffer keeps a few just-passed cards a short swipe away; it now ADAPTS to the pool size
      // so a SMALL set (e.g. 5 people) still recycles instead of draining to the last card and jittering
      // there -- that was the "keeps sliding with no more results" bug (the old fixed threshold of 6+
      // cards never fired for a <=5 pool).
      var BACK_BUFFER = 4;
      function recycle() {
        if (paused) return;
        var w = cardW(), guard = 0;
        var bb = Math.max(1, Math.min(BACK_BUFFER, track.children.length - 3));
        while (w > 0 && view.scrollLeft >= w * (bb + 1) && track.children.length > (bb + 2) && guard++ < 12) {
          var first = track.children[0];
          track.appendChild(first);
          view.scrollLeft -= w;     // keep the visible cards exactly where they are
        }
      }
      var recyT = null;
      view.addEventListener('scroll', function () {
        clearTimeout(recyT);
        recyT = setTimeout(recycle, 140);
      }, { passive: true });
      // auto-advance one card (native smooth scroll, so it's the SAME motion as a manual swipe). Before
      // advancing we top up the pool + recycle to make room; if we're genuinely at the end (a pool too
      // small to keep cards ahead), wrap smoothly back to the start instead of scrolling against the wall.
      function step() {
        if (paused || document.hidden || !carousel.offsetParent) return;
        var w = cardW(); if (w <= 0) return;
        topUp();                                              // pull in more faces when running low
        recycle();                                            // make room ahead
        var maxLeft = view.scrollWidth - view.clientWidth;
        if (view.scrollLeft >= maxLeft - 2) {                 // no room even after recycling: loop to start
          try { view.scrollTo({ left: 0, behavior: 'smooth' }); } catch (e) { view.scrollLeft = 0; }
          return;
        }
        try { view.scrollBy({ left: w, behavior: 'smooth' }); } catch (e) { view.scrollLeft += w; }
      }

      function pause() { paused = true; if (resumeT) { clearTimeout(resumeT); resumeT = null; } }
      function resumeSoon() { if (resumeT) clearTimeout(resumeT); resumeT = setTimeout(function () { paused = false; }, 4000); }
      ['pointerdown', 'touchstart', 'mouseenter'].forEach(function (ev) { carousel.addEventListener(ev, pause, { passive: true }); });
      ['pointerup', 'touchend', 'mouseleave'].forEach(function (ev) { carousel.addEventListener(ev, resumeSoon, { passive: true }); });

      // Keep the pool STOCKED so the loop shows fresh faces instead of the same few going round. Throttled;
      // pulls people not already shown anywhere, and quietly no-ops (leaving the recycle/wrap loop to carry
      // on) once the server has no one new to add -- so it never spins on an empty result.
      var topUpAt = 0;
      /* SLOW-LINK (2026-08-09): busy flag + deadline. A TIME throttle is not an in-flight guard --
         when a request takes longer than the 8s window (routine on a congested cell; /engage-live
         was measured at 1999ms and /poll-counts at 3629ms here), the next tick of the 3.2s carousel
         timer walked straight past `Date.now() < topUpAt` and issued another, and another. These are
         faces in a suggestion rail nobody is waiting on, queued against the feed the reader IS
         waiting on. `sugBusy` holds it to one; the deadline stops a dead socket parking the flag. */
      var sugBusy = false;
      function topUp() {
        if (!authed || sugBusy || document.hidden) return;
        if (track.children.length >= 10) return;   // already plenty ahead
        if (Date.now() < topUpAt) return;
        topUpAt = Date.now() + 8000;               // at most once every 8s
        sugBusy = true;
        rfetch('/suggest-people?card=1&n=8&exclude=' + encodeURIComponent(globalShownIds().join(',')),
              { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', cache: 'no-store' }, 8000)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            if (!html || !html.trim()) return;
            var tmp = document.createElement('div'); tmp.innerHTML = html;
            var shown = {}; globalShownIds().forEach(function (id) { shown[id] = 1; });
            Array.prototype.forEach.call(tmp.querySelectorAll('.sugg-slide'), function (card) {
              var id = card.getAttribute('data-id');
              if (id && shown[id]) return;           // guard against a race dupe
              track.appendChild(card);
            });
          }).catch(function () {}).then(function () { sugBusy = false; });
      }
      // Same treatment, and here the fan-out was per DISMISSAL: N quick taps on the x = N concurrent
      // untimed requests. One at a time; a dropped refill just leaves the rail one card shorter,
      // which the recycle/wrap loop already handles.
      var refillBusy = false;
      function refill() {
        if (!authed || refillBusy) return;   // guests can't fetch (endpoint needs login); they just cycle the set
        refillBusy = true;
        rfetch('/suggest-people?card=1&n=1&exclude=' + encodeURIComponent(globalShownIds().join(',')),
              { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', cache: 'no-store' }, 8000)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            if (!html || !html.trim()) return;
            var tmp = document.createElement('div'); tmp.innerHTML = html;
            var card = tmp.querySelector('.sugg-slide');
            if (card) track.appendChild(card);
          }).catch(function () {}).then(function () { refillBusy = false; });
      }
      function drop(slide) {
        if (!slide || slide._gone) return; slide._gone = true;
        slide.style.transition = 'opacity .25s ease, transform .25s ease';
        slide.style.opacity = '0'; slide.style.transform = 'scale(.92)';
        setTimeout(function () { if (slide.parentNode) slide.remove(); refill(); }, 250);
      }
      carousel._suggDrop = drop;

      carousel.addEventListener('click', function (e) {
        var x = e.target.closest ? e.target.closest('.js-sugg-hide') : null;
        if (!x) return;
        e.preventDefault();
        var slide = x.closest('.sugg-slide'); if (!slide) return;
        var id = slide.getAttribute('data-id');
        if (id && authed) postJson('/suggest-hide', { user_id: id }).catch(function () {});
        drop(slide);
      });

      setInterval(step, 3200);
    }

    // one global follow-listener drops the followed card from whichever carousel holds it
    document.addEventListener('rova:suggestion-followed', function (e) {
      var row = e.detail && e.detail.row;
      if (!row || !row.classList || !row.classList.contains('sugg-slide')) return;
      var c = row.closest('.sugg-carousel');
      if (c && c._suggDrop) setTimeout(function () { c._suggDrop(row); }, 160);
    });

    // logged-in: swap the seed clone for DIFFERENT faces so carousels down the feed don't repeat
    function freshen(carousel) {
      if (!authed) return;
      var track = carousel.querySelector('.sugg-track');
      rfetch('/suggest-people?card=1&n=10&exclude=' + encodeURIComponent(globalShownIds().join(',')),
            { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', cache: 'no-store' }, 8000)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          if (!html || !html.trim()) return;
          var tmp = document.createElement('div'); tmp.innerHTML = html;
          var cards = tmp.querySelectorAll('.sugg-slide');
          if (cards.length >= 2) { track.innerHTML = ''; Array.prototype.forEach.call(cards, function (c) { track.appendChild(c); }); }
        }).catch(function () {});
    }

    function buildCarousel() {
      var c = document.createElement('div');
      c.className = 'sugg-carousel feed-sugg';
      c.innerHTML = '<div class="sugg-carousel-head"><h3 class="sugg-carousel-h">Suggested for you</h3>'
        + '<a class="sugg-carousel-more" href="/people">See all</a></div>'
        + '<div class="sugg-carousel-view"><div class="sugg-track">' + (seed ? seed.innerHTML : '') + '</div></div>';
      return c;
    }

    // interleave a carousel after every INTERVAL-th feed post (count-bounded, never removes,
    // so live prepends can't multiply or churn them)
    var feed = document.getElementById('feed-posts');
    if (!feed || !seed) return;
    var container = feed.querySelector('.pgrid') || feed;
    // exactly ONE carousel, after the 5th post, and only on the Discover tab
    function onDiscover() {
      var on = document.querySelector('#feed-tabs .js-tab.on');
      var m = on && (on.getAttribute('href') || '').match(/tab=(\w+)/);
      /* No .on tab in the row at all (a fragment rendered without the strip) used to mean
         "assume Discover", because a bare /feed opened on Discover. It opens on TRENDING since
         2026-08-10, so that assumption now shows the Discover-only carousel on the default tab.
         Answer FALSE instead: the strip is the only thing that can say which tab this is, and
         when it cannot, the safe reading is "not Discover" -- interleave() then removes any
         carousel rather than inventing one. */
      return m ? m[1] === 'discover' : false;
    }
    function interleave() {
      var host = feed.querySelector('.pgrid') || feed;
      var existing = host.querySelectorAll(':scope > .feed-sugg');
      if (!onDiscover()) {                                   // other tabs: never show it
        Array.prototype.forEach.call(existing, function (el) { el.remove(); });
        return;
      }
      // already have the single carousel. A KEPT Discover panel (the tab pager's PANEL CACHE) brings its
      // carousel back as markup: wake it where it stands rather than inserting a new one, which would push
      // every card below the 5th down under the reader (initSuggCarousel is idempotent on _suggInit).
      if (existing.length) { if (!existing[0]._suggInit) { initSuggCarousel(existing[0]); } return; }
      var posts = host.querySelectorAll(':scope > .post');
      if (posts.length < INTERVAL) return;                   // need at least 5 posts first
      var anchor = posts[INTERVAL - 1];                      // sits right after the 5th
      if (anchor.nextElementSibling && anchor.nextElementSibling.classList.contains('feed-sugg')) return;
      var c = buildCarousel();
      anchor.insertAdjacentElement('afterend', c);
      initSuggCarousel(c);
      freshen(c);   // logged-in: replace the seed clone with fresh faces
    }
    var t = null;
    try {
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(interleave, 220); })
        .observe(container, { childList: true });
    } catch (e) {}
    interleave();
  })();

  /* ---- "Optimizing video" placeholders: swap in the real file when ready --
     A pending transcode renders as a .vprocessing card. We ask the server
     (GET /media-ready) whether the optimized file is done and replace the card
     with the real player the moment it is, no refresh needed. Authoritative:
     it does NOT wait on the poster jpg (best-effort, sometimes never made), so
     the card can't spin forever after the video is actually ready.

     GUESTS RUN THIS TOO, AND ALWAYS DID -- the server was the half that was missing
     (2026-08-09). /media-ready used to 401 anyone signed out, so a logged-out reader
     watched the card sit there until they reloaded. There is deliberately NO fork here
     between members and guests: one code path, one URL shape, one cache key. Forking
     would have cost the very thing that makes the guest poll affordable -- the edge can
     only collapse requests that look identical.

     WHY THIS IS ALLOWED TO POLL AT ALL, given the origin tops out near 150 req/s. The
     answer is viewer-independent, so it is served from Cloudflare with a 5s s-maxage and
     nearly every one of these requests dies at the edge. That is the budget this block
     is spending, and the limits below are what keep it inside it:

       ON SCREEN ONLY  an IntersectionObserver decides who is polled. A feed can hold
                       cards far outside the viewport and the old code polled every one
                       of them; the reader cannot see those, so a swap can wait until
                       they scroll in. Cards just below the fold (200px margin) DO poll,
                       so the player is already there when they arrive.
       BATCHED         several visible cards ride ONE request (`vs`), sorted, so two
                       readers watching the same cards produce the same URL and share the
                       same edge key. A single card keeps the old `v` shape, which is both
                       the common case and the key every already-loaded client is warming.
       BACKED OFF      1.5s -> 20s over the first six beats. Fast at the start because an
                       edge-cached page can be up to 60s stale, so the clip is sometimes
                       ALREADY done at first paint; patient after, because a transcode
                       takes a minute or two.
       CAPPED          MAX_BEATS requests, then the card is retired for good (data-mr-off)
                       instead of polling forever. A transcode that never lands must stop
                       costing requests; the reader's next navigation re-renders it anyway.
       HIDDEN = STOP   the timer is dropped when the tab goes away, not merely skipped,
                       and visibilitychange restarts it on return.
       ONE IN FLIGHT   plus the 6s deadline, so a stalled read releases its socket instead
                       of holding it open across beats. */
  (function () {
    var SEL      = '.vprocessing:not([data-mr-off]), .gp-processing:not([data-mr-off])';
    var MAX_BATCH = 6;      // paths per request; matches the server's own cap
    var MAX_BEATS = 45;     // hard stop (~13 min with the ladder below)
    /* The backoff ladder, then 20s forever. Deliberately not exponential-from-zero: the
       first beat has to be quick (see "BACKED OFF" above) and the tail has to be slow. */
    var BEATS = [1500, 2500, 4000, 6000, 9000, 13000, 20000];
    var running = false, beat = 0, inflight = false, timer = null, io = null;
    function swap(card, rsrc, na) {
      var poster = card.getAttribute('data-p'), src = card.getAttribute('data-v');
      /* CLOUDFLARE STREAM UPLOADS (db/0246): a clip that plays from Cloudflare has NO file at data-v; /media-ready
         hands its playable URL as `src` (only ever our Stream host). No crossorigin: that MP4 302s without ACAO. */
      var remote = typeof rsrc === 'string' && /^https:\/\/customer-[a-z0-9]+\.cloudflarestream\.com\//.test(rsrc);
      if (remote) { src = rsrc; }
      var post = card.closest ? card.closest('.post') : null;
      var v = document.createElement('video');
      v.src = src;
      if (remote) { v.setAttribute('data-remote', '1'); }
      /* NO-AUDIO MARKER (/media-ready `na`, 2026-10-06): the page render stamps data-noaudio from the .silent sidecar;
         a clip swapped in here had none, so a silent clip showed the speaker instead of "No audio" until a reload.
         Set BEFORE the element is inserted: the feed player's MutationObserver builds the controls off it. */
      if (na) { v.setAttribute('data-noaudio', ''); }
      if (poster) v.poster = poster;      // decorative; if the jpg 404s the browser shows the first frame
      v.controls = true; v.muted = true; v.loop = true;
      v.setAttribute('playsinline', ''); v.preload = 'metadata';
      card.replaceWith(v);                // the feed player's MutationObserver wires autoplay on the new <video>
      // the post just went public with a fresh clock (server re-stamped it)
      if (post && !post.querySelector('.vprocessing')) {
        var t = post.querySelector('.time-link');
        if (t && /processing/.test(t.textContent)) t.textContent = 'now';
      }
    }
    // GRID cells mid-transcode (.gp-processing, round 140): swap the "Optimizing video..." tile for the
    // grid's normal poster-img markup the moment the files exist. The grid preview module's
    // MutationObserver wires the fresh img (playIO/releaseIO) automatically -- the preview just starts.
    /* $grid IS THE GRID RENDITION, WHEN THE SERVER SAID ONE EXISTS (2026-08-10).
       Every other grid cell on the page gets `<stem>_w_grid480.mp4` from lib/view.php's
       grid_video_src(), which gates on a local is_file(). This cell CANNOT be served that way:
       it was rendered while the clip was still transcoding, so at render time there was nothing
       to stat. GET /media-ready is the only thing asked AFTER the encode, so it now answers with
       the rendition path too -- gated on the same local is_file(), never a guessed name, because
       a 404 here negative-caches at the edge for hours with no purge token on this box.
       FALLS BACK TO data-v, always. An empty/absent `grid` is the honest answer in three real
       cases -- an older server that does not send the key, a poll that lands between the master
       finishing and the rendition being written, and a clip whose rendition failed -- and all
       three must produce a WORKING tile playing the master, which is exactly today's behaviour. */
    function swapCell(fill, grid, g3, g6) {
      var poster = fill.getAttribute('data-p'), src = fill.getAttribute('data-v');
      var img = document.createElement('img');
      img.className = 'pcell-video';
      img.alt = ''; img.loading = 'eager'; img.decoding = 'async';
      var useGrid = (typeof grid === 'string' && grid);
      img.setAttribute('data-video-src', useGrid ? grid : src);
      /* THE MARKER TRAVELS WITH THE URL, OR NOT AT ALL. `g3` is only ever non-zero when the
         server's `grid` answer IS the 3-second preview, so the two are stamped from the same
         branch -- a cell can never end up advertising a 3s clip while reading as full-length,
         which would hand the viewer a position from the wrong timeline on the next tap. This
         is the same invariant lib/view.php's grid_tile_video_attrs() enforces for a normal
         render; this endpoint is simply the other way a tile can be born. */
      if (useGrid && typeof g3 === 'number' && g3 > 0) { img.setAttribute('data-g3', String(g3)); }
      /* ...AND SO DOES THE SHAPE MARKER. Same branch, same invariant, one more fact: `g6` is
         only truthy when the server's `grid` answer is the PING-PONG preview, whose position
         folds at half its duration. A freshly-transcoded cell born without this marker would
         be the one tile on the page mapping a boomerang linearly -- right for the first half
         of every loop and wrong for the second -- until the reader reloaded. An older server
         (or an edge-cached body from before this deploy) simply sends no `g6` key, which reads
         as "not a boomerang" and is exactly right, because such a server has no `_grid6` to
         hand out either. */
      if (useGrid && g6) { img.setAttribute('data-g6', '1'); }
      if (poster) { img.src = poster; }
      img.onerror = function () { img.removeAttribute('src'); };   // poster jpg is best-effort; never show a broken image
      fill.replaceWith(img);
    }
    function cards() { return document.querySelectorAll(SEL); }
    function delayFor(n) { return BEATS[n < BEATS.length ? n : BEATS.length - 1]; }
    function apply(card, grid, g3, g6, rsrc, na) {
      if (!card.isConnected) return;
      if (typeof card.__rovaOnReady === 'function') { var f = card.__rovaOnReady; card.__rovaOnReady = null; card.setAttribute('data-mr-off', '1'); try { f(grid); } catch (e) {} return; }
      if (card.classList.contains('gp-processing')) { swapCell(card, grid, g3, g6); } else { swap(card, rsrc, na); }
    }

    /* WHO IS ON SCREEN. `__mrOn` is stamped on the element rather than kept in a Set so a card that
       gets recycled or replaced takes its own flag with it -- there is no side table left holding a
       reference to a node that is no longer in the document ([[stranded-recycled-standins-leak-animations]]
       is the same failure mode in the other direction). 200px of margin means a card just below the
       fold is already polling, so it has usually swapped by the time it is scrolled to.
       No IntersectionObserver (very old Safari) -> every card counts as on-screen, i.e. exactly the
       pre-2026-08-09 behaviour, which is the right way for this to degrade. */
    if (window.IntersectionObserver) {
      try {
        io = new IntersectionObserver(function (entries) {
          var wake = false;
          for (var i = 0; i < entries.length; i++) {
            entries[i].target.__mrOn = entries[i].isIntersecting;
            if (entries[i].isIntersecting) { wake = true; }
          }
          if (wake) { kick(); }   // scrolled into view: start polling it now, don't wait for a beat
        }, { rootMargin: '200px 0px' });
      } catch (e) { io = null; }
    }

    /* Observe anything new, and report whether there WAS anything new. A card we have never seen is
       fresh work (a streamed-in post, a "load more" page, the immersive viewer), and fresh work is
       entitled to a fresh attempt budget. Scrolling an OLD card back into view is not -- otherwise
       MAX_BEATS could be reset forever by a reader who simply keeps scrolling, which would leave us
       back at "polls a dead card until the tab closes". */
    function observeAll() {
      var list = cards(), fresh = false;
      for (var i = 0; i < list.length; i++) {
        if (list[i].__mrObs) { continue; }
        list[i].__mrObs = 1;
        fresh = true;
        if (io) { list[i].__mrOn = false; try { io.observe(list[i]); } catch (e) { list[i].__mrOn = true; } }
        else    { list[i].__mrOn = true; }
      }
      return fresh;
    }

    function probe() {
      timer = null;
      // HIDDEN = STOP, not "skip and reschedule". A background tab holds no timer at all; the
      // visibilitychange handler below is what brings it back, and it is the only thing that has to.
      if (document.hidden) { running = false; return; }
      var all = cards();
      if (!all.length) { running = false; beat = 0; return; }   // nothing pending: idle until a card appears
      if (beat >= MAX_BEATS) {
        // Retired for good. data-mr-off (not a class removal) so the card keeps its "Optimizing"
        // styling and stays exactly as it looks -- we stop asking, we don't change what he sees.
        for (var i = 0; i < all.length; i++) { all[i].setAttribute('data-mr-off', '1'); }
        running = false; beat = 0; return;
      }
      // ON SCREEN ONLY. If none are, stop: the IntersectionObserver above restarts us the moment
      // one scrolls in, so an idle loop is pure waste.
      var map = {}, paths = [];
      for (var k = 0; k < all.length && paths.length < MAX_BATCH; k++) {
        if (!all[k].__mrOn) { continue; }
        var v = all[k].getAttribute('data-v');
        if (!v) { continue; }
        if (!map[v]) { map[v] = []; paths.push(v); }
        map[v].push(all[k]);
      }
      if (!paths.length) { running = false; return; }
      if (inflight) { timer = setTimeout(probe, delayFor(beat)); return; }   // never two at once

      /* SORTED, ALWAYS. Cloudflare keys on the URL alone, so the batch is only as cacheable as it is
         canonical: two readers looking at the same two cards have to emit the same query string or
         they warm two keys and the edge absorbs half as much. Single card keeps the `v` shape both
         because it is the common case and because every already-loaded client is warming that key. */
      paths.sort();
      var url = paths.length === 1
        ? '/media-ready?v=' + encodeURIComponent(paths[0])
        : '/media-ready?vs=' + paths.map(encodeURIComponent).join(',');

      beat++;          // counted per REQUEST, so MAX_BEATS is a true cap on what we spend
      inflight = true;
      /* credentials:'omit' IS THE WHOLE EDGE WIN, and it is not a detail -- measured 2026-08-09.
         Cloudflare bypasses its cache for any request carrying rova_sess (proved: one warm key,
         cookieless -> HIT, rova_tz -> HIT, rova_sess -> DYNAMIC, i.e. straight to the origin).
         And a logged-out reader HAS rova_sess within about a second of landing, because the
         referral beacon /r/touch is uncached and boots a session by design -- so "guests are
         cookieless" is false in practice and the poll would have gone to the origin every time.
         Sending no cookie makes the request cache-shareable for members and guests alike, and it
         costs nothing precisely because this answer does not depend on who is asking: the server
         ignores $user (see handle_media_ready). It also means the origin, on the rare MISS, skips
         booting a session at all -- one less Redis round trip per poll on a shared instance
         ([[redis-shared-instance]]).
         Do NOT "restore" credentials here without re-reading that: it silently returns every
         poll to the origin while still looking like it works. */
      rfetch(url, { headers: { 'Accept': 'application/json' }, credentials: 'omit' }, 6000)
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var res = j && j.ready;
          /* The `grid` companion map, normalised through the same `v`-shape unwrap as `ready`
             so the two shapes stay in step. Absent on an older server -> {} -> every swap falls
             back to data-v, which is exactly the pre-2026-08-10 behaviour. */
          var gr = (j && j.grid) || null;
          /* The `g3` companion of the companion: present only when the path in `grid` is the
             3-SECOND preview, and carrying its master-time multiplier. Normalised through the
             same `v`-shape unwrap so all three maps stay in step. Absent on an older server ->
             {} -> no tile is ever marked, which degrades to the full-length behaviour rather
             than to a tile whose clock is misread. */
          var g3 = (j && j.g3) || null;
          /* The `g6` companion: 1 when the path in `grid` is the PING-PONG preview, whose
             position folds at half its duration instead of running straight. Normalised the
             same way so all four maps stay in step, and absent -> {} -> no tile is marked as
             a boomerang, which is right for an older server (it has none to serve) and right
             for an edge-cached body from before this deploy. */
          var g6 = (j && j.g6) || null;
          var sr = (j && j.src) || null;   // db/0246: Cloudflare-hosted clips' playable URL (absent on an older server)
          var na = (j && j.na) || null;    // 2026-10-06: 1 = the clip has no audio (absent on an older server -> speaker as before)
          if (res === true || res === false) {                                                  // `v` shape
            var one = {}; one[paths[0]] = res; res = one;
            var g1 = {}; if (typeof gr === 'string' && gr) { g1[paths[0]] = gr; } gr = g1;
            var h1 = {}; if (typeof g3 === 'number' && g3 > 0) { h1[paths[0]] = g3; } g3 = h1;
            var b1 = {}; if (g6) { b1[paths[0]] = 1; } g6 = b1;
            var s1 = {}; if (typeof sr === 'string' && sr) { s1[paths[0]] = sr; } sr = s1;
            var n1 = {}; if (na === 1) { n1[paths[0]] = 1; } na = n1;
          }
          if (!gr || typeof gr !== 'object') { gr = {}; }
          if (!g3 || typeof g3 !== 'object') { g3 = {}; }
          if (!g6 || typeof g6 !== 'object') { g6 = {}; }
          if (!sr || typeof sr !== 'object') { sr = {}; }
          if (!na || typeof na !== 'object') { na = {}; }
          if (!res || typeof res !== 'object') { return; }
          for (var p in res) {
            if (!res[p] || !Object.prototype.hasOwnProperty.call(map, p)) { continue; }
            (function (gsrc, gspd, gboom, rs, silent) { map[p].forEach(function (c) { apply(c, gsrc, gspd, gboom, rs, silent); }); })(
              Object.prototype.hasOwnProperty.call(gr, p) ? gr[p] : '',
              Object.prototype.hasOwnProperty.call(g3, p) ? g3[p] : 0,
              Object.prototype.hasOwnProperty.call(g6, p) ? 1 : 0,
              Object.prototype.hasOwnProperty.call(sr, p) ? sr[p] : '',
              Object.prototype.hasOwnProperty.call(na, p) ? 1 : 0);
          }
        })
        .catch(function () {})                              // transient hiccup (or a 429): next beat retries
        .then(function () { inflight = false; });           // .finally is too new for the phones that need this
      timer = setTimeout(probe, delayFor(beat));
    }

    // (re)start the loop whenever there's something to watch. Critical: cards can appear AFTER load --
    // a fresh post streamed into the feed, a "load more" page, or the immersive viewer -- so we don't
    // gate on their presence at load and never poll them (that left the card stuck on "Optimizing").
    function kick() {
      if (observeAll()) { beat = 0; }        // new card => fresh budget; see observeAll()
      if (running || !cards().length) { return; }
      running = true;
      if (timer) { clearTimeout(timer); }
      timer = setTimeout(probe, delayFor(beat));
    }
    kick();
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType === 1 && ((n.matches && n.matches(SEL)) || (n.querySelector && n.querySelector(SEL)))) { kick(); return; }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { if (timer) { clearTimeout(timer); timer = null; } running = false; }
      else { kick(); }
    });
  })();

  /* ---- on-demand "See translation": translate a post caption into the reader's browser language via
     the Claude API (server-cached per post+language). The button ships HIDDEN and we reveal it only when
     the caption looks like a DIFFERENT language than the reader's (a lightweight script + stop-word guess,
     so we don't clutter every post). Toggles to "See original". ------------------------------------- */
  (function () {
    // GUESTS NEVER GET THE BUTTON. /post/translate is require_login, and guest pages render
    // session-free so the edge can cache them, which means they carry no csrf-token meta at all
    // and the click comes back 419 before it ever reaches the login check. A button that always
    // errors is worse than no button; the guest wall catches them on other surfaces. The profile
    // BIO button is already server-gated on $viewer in views/profile.php, so this is the
    // post-caption twin of that gate. Returning here also skips the click handler, and the
    // buttons ship hidden, so nothing is revealed and nothing is bound.
    if (document.querySelector('meta[name="rova-guest"]')) { return; }
    var reader = (navigator.language || 'en').toLowerCase().split('-')[0];
    // reader language -> writing system; if the caption's script differs, it's clearly another language
    var R2S = { ru:'cyrl', uk:'cyrl', bg:'cyrl', sr:'cyrl', ar:'arab', fa:'arab', ur:'arab', he:'hebr',
                el:'grek', zh:'han', ja:'han', ko:'hang', th:'thai', hi:'deva', mr:'deva' };
    var readerScript = R2S[reader] || 'latn';
    // top function words per language: a handful of matches is a strong signal for Latin-script langs
    var STOP = {
      en:['the','and','to','of','a','in','is','it','you','that','for','on','with','this','are','my','me','we','just','not','have','so','do','does','did','what','here','there','how','when','where','why','who','your','they','them','was','were','been','but','can','will','would','get','got','know','like','out','about','because','now','then','all','if','or','be','at','up','he','she','him','her','his',
          // common English FUNCTION words that ALSO appear in Latin-script foreign
          // stop lists ('as'/'a' are Portuguese too, 'no' is es/pt/it) — without
          // these, plain English slang mis-scored as foreign and showed a bogus
          // "See translation" (owner /p/2080). Casual contraction forms included.
          'i','im','as','an','from','by','no','am','us','well','too','more','one','go',
          'u','ur','ya','yo','aint','gonna','wanna','tho','thee','jst','n'],
      es:['el','la','de','que','y','en','un','una','los','las','por','con','para','no','se','su','como','pero','mi','muy','más',
          // more high-frequency Spanish function words (owner /p/2233,2230): short
          // captions like "te lo agradesco" / "soy tu sello" only hit 0-1 of the old
          // set. All non-English, so they don't mis-score English text.
          'te','tu','lo','esto','eso','esta','este','esa','estoy','nada','porque','gracias','hola','uy',
          // Common Spanish CONTENT words, not just function words (owner /p/12400
          // "Saludos a todos"): that caption scored es 0 vs en 1, because 'a' is in
          // the English list on purpose and neither 'saludos' nor 'todos' was in any
          // list. Greetings, time words, family/feeling nouns and the top verb forms
          // are what short captions are actually made of. Words that are also
          // ordinary English (sin, favor, grande, hay, son, van, era, solo, soy,
          // persona, linda, tan) are deliberately LEFT OUT so English text cannot
          // score on them.
          'todo','todos','toda','todas','saludos','bien','bueno','buena','buenos','buenas','buen',
          'día','días','dias','noche','noches','mañana','tarde','hoy','ayer','año','años','vez',
          'feliz','cumpleaños','bendiciones','dios','vida','amor','amigo','amigos','familia',
          'hermano','hermana','gente','mundo','tiempo','trabajo','casa','cosa','cosas',
          'ahora','siempre','nunca','también','tambien','entonces','aquí','aqui','así','asi',
          'desde','hasta','entre','sobre','antes','después','despues','luego','todavía',
          'cuando','donde','quien','qué','cómo','tiene','tengo','tienes','puede','puedo','poder',
          'quiero','quiere','hacer','hace','saber','decir','estar','tener','vamos','somos','eres',
          'está','están','estás','estamos','encanta','gusta','gusto',
          'del','al','nos','ellos','nosotros','ustedes','usted','sus','mis','tus','unos','unas',
          'mucho','mucha','muchos','muchas','otro','otra','otros','otras','cada','algo','alguien',
          'nadie','mismo','misma','pues','claro','verdad','mejor','nuevo','nueva','primera',
          'señor','hermoso','hermosa','lindo','bonito','bonita','personas'],
      // fr/pt/tl were the same 15-to-21 word skeletons Spanish had before it was widened. Short real
      // captions ("Bom dia pessoal", "Salamat po sa lahat") hit 0-1 of them and stayed hidden. Same
      // recipe as the Spanish widening: greetings, time words, family/feeling nouns and the top verb
      // forms, with anything that is also ordinary English left out so English text cannot score on it.
      fr:['le','la','les','de','un','une','et','en','que','qui','dans','pour','pas','sur','avec','je','il','ce','mais','plus','est','tout','tous','toute','bonjour','bonsoir','merci','beaucoup','très','tres','bien','bonne','bon','moi','vous','nous','ma','mes','mon','ami','amis','monde','jour','journée','journee','soir','faire','fait','être','suis','sont','sans','chez','encore','toujours','jamais','même','aussi','alors','quand','parce','peut','veux','vraiment','belle','beau','vie','gens','temps','frère','soeur'],
      pt:['o','a','de','que','do','da','em','um','uma','os','as','para','com','nao','não','por','mais','mas','se','eu','você','meu','obrigado','obrigada','muito','muita','bom','boa','bons','boas','dia','dias','noite','tarde','hoje','tudo','todos','toda','todas','gente','vida','amor','amigo','amigos','família','familia','irmão','irmã','feliz','sempre','nunca','também','tambem','agora','aqui','assim','então','entao','depois','ainda','quando','onde','porque','pode','posso','quero','fazer','estou','está','estão','somos','são','isso','isto','nós','vocês','seu','sua','meus','minha','coisa','coisas','melhor','novo','nova','pessoas','saudade','beijos'],
      de:['der','die','das','und','ist','ich','nicht','mit','ein','eine','den','dem','auf','für','von','im','aber','sich','auch'],
      it:['il','la','di','che','un','una','per','con','non','come','ma','più','mi','ti','se','questo','sono','ho','anche','gli'],
      nl:['de','het','een','en','van','ik','je','niet','met','op','dat','die','voor','maar','ook','zijn','naar'],
      pl:['nie','się','jest','że','jak','ale','tego','czy','tylko','bardzo','dziękuję','oraz','przez','jego','już','żeby','może'],
      tr:['bir','bu','için','çok','ama','var','değil','gibi','daha','kadar','benim','şey','evet','teşekkür','nasıl','ile'],
      id:['yang','dan','ini','itu','dengan','untuk','tidak','saya','ada','aku','kamu','dari','akan','sudah','banget','juga'],
      vi:['của','là','có','không','được','các','một','những','cho','người','tôi','này','đã','rất','và','với','cũng'],
      ro:['și','este','nu','cu','pentru','ce','dar','mai','foarte','sunt','care','despre','când','să','sau','din'],
      sv:['och','att','det','som','är','för','med','jag','inte','den','till','har','ett','om','men','så','på'],
      tl:['ang','ng','sa','na','ako','mga','ko','yung','naman','hindi','siya','din','talaga','lang','kasi','ba','salamat','po','opo','maganda','magandang','umaga','hapon','gabi','araw','lahat','kayo','tayo','natin','namin','nila','niya','akin','iyo','ito','iyan','kumusta','mahal','buhay','tao','bagay','ganda','sobra','sana','pala','pero','kung','saan','bakit','paano','ngayon','bukas','kahapon','mabuti','masaya','kaibigan','pamilya','walang','meron','gusto','ayaw','pwede'],
      cs:['se','je','že','na','ale','jako','nebo','už','jsem','byl','které','tak','když','pro','moc','jsou']
    };
    function scriptOf(t) {
      if (/[一-鿿぀-ヿ]/.test(t)) return 'han';
      if (/[가-힯]/.test(t)) return 'hang';
      if (/[؀-ۿ]/.test(t)) return 'arab';
      if (/[Ѐ-ӿ]/.test(t)) return 'cyrl';
      if (/[֐-׿]/.test(t)) return 'hebr';
      if (/[Ͱ-Ͽ]/.test(t)) return 'grek';
      if (/[฀-๿]/.test(t)) return 'thai';
      if (/[ऀ-ॿ]/.test(t)) return 'deva';
      return 'latn';
    }
    /* DECORATIVE UNICODE -> plain ASCII, FOR DETECTION ONLY. Stylised text is everywhere on
       social ("ʟɪᴛ4ʟɪғᴇ", fullwidth, math bold, circled): a reader sees Latin letters, but the
       codepoints are not Latin ones. The sharp edge is that the popular small-caps generators
       borrow CYRILLIC lookalikes for a few letters -- small-cap 'f' is U+0493 and 's' is U+0455 --
       so ONE styled English word flipped scriptOf() to 'cyrl' and the caption was declared
       foreign before the stop-word logic ever ran (owner /p/13358 "Bruce Leroy Wit The
       Glow ✨ʟɪᴛ4ʟɪғᴇ", and the same member's bio). We fold the decoration back to the letters it
       imitates and detect on THAT. The caption itself is never rewritten: it renders exactly as
       the member typed it, and post_translations is keyed on (post_id, target_lang), never on the
       body, so no cached translation is disturbed. */
    var SMALLCAP = {
      'ᴀ':'a','ʙ':'b','ᴄ':'c','ᴅ':'d','ᴇ':'e','ɢ':'g','ʜ':'h','ɪ':'i','ᴊ':'j','ᴋ':'k','ʟ':'l','ᴍ':'m',
      'ɴ':'n','ᴏ':'o','ᴘ':'p','ǫ':'q','ʀ':'r','ꜱ':'s','ᴛ':'t','ᴜ':'u','ᴠ':'v','ᴡ':'w','ʏ':'y','ᴢ':'z',
      'ᴆ':'d','ᴌ':'l','ᴎ':'n','ᴐ':'o','ᴖ':'o','ᴗ':'o','ᴙ':'r','ᴚ':'r','ᴝ':'u','ᴞ':'u','ᴦ':'g','ᴧ':'l',
      'ᴨ':'p','ᴫ':'l','ɡ':'g','ɩ':'i','ɱ':'m','ɾ':'r','ʈ':'t','ʋ':'v','ɣ':'y','ʅ':'s'
    };
    /* Cyrillic and Greek letters that are drawn like Latin ones. Folded only when the text is
       NOT actually in one of those scripts -- see below. */
    var HOMOGLYPH = {
      'а':'a','е':'e','о':'o','р':'p','с':'c','у':'y','х':'x','ѕ':'s','і':'i','ј':'j','һ':'h','ѳ':'o',
      'ґ':'g','ғ':'f','ӏ':'l','А':'A','В':'B','Е':'E','К':'K','М':'M','Н':'H','О':'O','Р':'P','С':'C',
      'Т':'T','У':'Y','Х':'X','Ѕ':'S','І':'I','Ј':'J','Ӏ':'I',
      'α':'a','ο':'o','ρ':'p','ν':'v','κ':'k','ε':'e','ι':'i','τ':'t','γ':'y','υ':'u','χ':'x','σ':'o',
      'η':'n','μ':'u','ω':'w','Α':'A','Β':'B','Ε':'E','Ζ':'Z','Η':'H','Ι':'I','Κ':'K','Μ':'M','Ν':'N',
      'Ο':'O','Ρ':'P','Τ':'T','Υ':'Y','Χ':'X'
    };
    var HOMOGLYPH_CLASS = new RegExp('[' + Object.keys(HOMOGLYPH).join('') + ']', 'g');
    /* Emoji and pictographs carry no language. They are already not \p{L} so they never counted
       as letters, but they must not be mistaken for script evidence either, and dropping them
       keeps an emoji-heavy English caption from looking like anything but English. */
    var PICTO = /[\u{1F000}-\u{1FAFF}☀-➿←-⇿⬀-⯿\u{1F1E6}-\u{1F1FF}️‍⃣™©®]/gu;
    function foldForDetect(t) {
      t = String(t || '').replace(PICTO, ' ');
      /* NFKC folds fullwidth, mathematical alphanumerics, circled and letterlike forms to the
         plain letters they imitate. Crucially it leaves REAL accents intact (Spanish 'á' stays
         'á'), because the accent shortcut further down is what detects short Spanish, French,
         Portuguese and Swedish captions. Stripping diacritics here would re-break all of it. */
      try { t = t.normalize('NFKC'); } catch (e) {}
      t = t.replace(/[\s\S]/gu, function (ch) { return SMALLCAP[ch] !== undefined ? SMALLCAP[ch] : ch; });
      /* Fold Cyrillic/Greek lookalikes ONLY when nothing else in the text is Cyrillic or Greek.
         Real Bulgarian ("Да обичаш и да бъдеш обичан") is full of а/е/о/с, which all have Latin
         twins; folding those would shred a genuine Cyrillic caption into pseudo-Latin and hide a
         translation that is actually wanted. One unmistakable Cyrillic or Greek letter is proof
         the text belongs to that script, so we leave it alone. */
      if (!/[Ѐ-ӿͰ-Ͽ]/.test(t.replace(HOMOGLYPH_CLASS, ''))) {
        t = t.replace(/[\s\S]/gu, function (ch) { return HOMOGLYPH[ch] !== undefined ? HOMOGLYPH[ch] : ch; });
      }
      return t;
    }
    /* DECORATIVE DIACRITICS. The accent shortcut below assumes accents are SPARSE, the way real
       orthography uses them: measured across every foreign caption on the site, at most 11% of
       the Latin letters carry one. Stylised English sprays them over nearly every letter instead
       ("Wè áìñť máķè ìț" is 83%, "LĘȚŞ BŘĒÁĶ ȚĦÁ ŘUŁEŞ" is 76%), matches no English stop word
       because the words are unrecognisable, and so used to score foreign on the accent count
       alone. Past half the letters it is decoration, not orthography. */
    function decorativeAccents(t) {
      var latin = t.match(/\p{Script=Latin}/gu) || [];
      if (latin.length < 8) return false;
      var exotic = 0;
      for (var i = 0; i < latin.length; i++) { if (!/[A-Za-z]/.test(latin[i])) exotic++; }
      return (exotic / latin.length) >= 0.5;
    }
    // returns true if the caption is likely a DIFFERENT language than the reader
    function differs(text) {
      // Fold BEFORE the mention strip so a stylised #hashtag still looks like one to that regex.
      text = foldForDetect((text || '').replace(/https?:\/\/\S+/g, ' ')).replace(/[@#][\w-]+/g, ' ').trim();
      var letters = (text.match(/\p{L}/gu) || []).length;    // ALL Unicode letters (so CJK/Cyrillic count too)
      if (letters < 8) return false;                         // too little text to tell -> don't clutter
      var sc = scriptOf(text);
      if (sc !== 'latn') { return sc !== readerScript; }      // non-Latin script: differs unless reader shares it
      if (readerScript !== 'latn') { return true; }           // reader is non-Latin but the caption is Latin
      var words = (text.toLowerCase().match(/\p{L}+/gu) || []);   // Unicode letters, so accented words (é, ş, đ, ł) stay whole
      if (words.length < 2) return false;   // short foreign phrases ("Descansando uy") are common — allow 2 words
      var best = '', bestN = 0, readerN = 0;
      for (var lang in STOP) {
        var set = STOP[lang], seen = {}, n = 0;
        for (var i = 0; i < words.length; i++) {
          var w = words[i];
          if (!seen[w] && set.indexOf(w) >= 0) { seen[w] = 1; n++; }   // DISTINCT stop words: a repeated word
        }                                                              // (e.g. English "do ... do") can't inflate a foreign score
        if (lang === reader) readerN = n;
        if (n > bestN) { bestN = n; best = lang; }
      }
      // ACCENT SHORTCUT for English readers: short foreign phrases often hit only ONE stop word
      // ("Cualquier obstáculo tórnalo en oportunidad" matches just 'en'), which failed the >=2 rule
      // below and hid the button (owner /p/1802). English text essentially never carries 2+ accented
      // Latin letters while matching ZERO English stop words -- that combination IS foreign text.
      // Romance MORPHOLOGY as a second signal (owner /p/2232 "Descansando uy"): a
      // gerund/inflection ending (-ando/-endo/-ción/-ção/-mente/-aron/-amos) is
      // strong foreign evidence. Only counts for English readers with ZERO English
      // stop-word hits, and still needs TWO total foreign signals (stop hits +
      // inflected words), so a lone English "Orlando"/"commando" stays hidden.
      var infl = 0, iseen = {};
      for (var wi = 0; wi < words.length; wi++) {
        var wd = words[wi];
        if (!iseen[wd] && /(ando|endo|ción|ciones|ção|ções|mente|aron|amos|aban)$/.test(wd)) { iseen[wd] = 1; infl++; }
      }
      // The accent half of this test sits out on decorated text (see decorativeAccents); the
      // stop-word half still counts, so genuinely foreign text that happens to be stylised is
      // still offered a translation.
      var accents = (text.match(/[à-öø-ÿÀ-ÖØ-Þœšžğışćłńęą]/g) || []).length;
      if (reader === 'en' && readerN === 0
          && ((accents >= 2 && !decorativeAccents(text)) || (bestN + infl) >= 2)) { return true; }
      // Show ONLY when another language clearly out-matches the reader's own. best === reader (their
      // language is the strongest match) or a tie (readerN >= bestN) means it's already their language ->
      // hide, so we never offer a pointless translation of same-language text into identical text. Anything
      // that slips through is caught server-side ('same' -> "already in your language").
      if (bestN < 2 || best === reader || readerN >= bestN) return false;
      return true;
    }
    function scan(root) {
      var btns = (root || document).querySelectorAll('.js-translate');
      Array.prototype.forEach.call(btns, function (btn) {
        if (btn.__trChecked) return; btn.__trChecked = 1;
        var bio = btn.getAttribute('data-kind') === 'bio';                // post caption vs profile bio
        /* THE SERVER'S VERDICT WINS (2026-09-18). views/_post.php stamps data-lang with the post's
           language as lib/lang.php decided it -- the same value the API carries as `lang` -- so a
           post caption is shown the control iff that language is real ('zxx' = no text) and is not
           the reader's own. No body heuristic runs for it: differs() below stays ONLY for the bio
           button, which has no server verdict yet. The heuristic's ASCII-only hashtag strip is
           what let `#fypシ` read as Japanese on an English post (/p/52741). */
        var dl = btn.getAttribute('data-lang');
        if (dl) { btn.hidden = !(dl !== 'zxx' && dl !== 'und' && dl !== reader); return; }
        var container = bio ? btn.closest('.bio-block') : btn.closest('.post');
        var src = container && container.querySelector(bio ? '.bio-text' : '.body');
        if (src && differs(src.textContent)) { btn.hidden = false; }      // reveal only foreign-language text
      });
    }
    scan(document);
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var a = muts[i].addedNodes;
        for (var j = 0; j < a.length; j++) {
          var n = a[j];
          if (n.nodeType === 1 && (n.querySelector ? (n.matches && n.matches('.js-translate')) || n.querySelector('.js-translate') : false)) { scan(n.parentNode || document); }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });

    function label(btn) { return btn.querySelector('.tr-label') || btn; }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.js-translate');
      if (!btn) return;
      e.preventDefault();
      var bio = btn.getAttribute('data-kind') === 'bio';
      var container = bio ? btn.closest('.bio-block') : btn.closest('.post');
      var box = container && container.querySelector('.translation');
      var lab = label(btn);
      if (!box) return;
      if (btn.getAttribute('data-shown') === '1') {          // currently showing translation -> back to original
        box.hidden = true; lab.textContent = 'See translation'; btn.setAttribute('data-shown', '0'); return;
      }
      if (box.getAttribute('data-loaded') === '1') {         // already fetched this session -> just reveal
        box.hidden = false; lab.textContent = 'See original'; btn.setAttribute('data-shown', '1'); return;
      }
      btn.disabled = true; lab.textContent = 'Translating…';
      var url = bio ? '/profile/translate' : '/post/translate';
      var payload = bio
        ? { user_id: btn.getAttribute('data-user') || '', lang: navigator.language || 'en' }
        : { post_id: btn.getAttribute('data-id') || (container.getAttribute('data-view') || ''), lang: navigator.language || 'en' };
      postJson(url, payload)
        .then(function (res) {
          btn.disabled = false;
          if (res && res.ok && (res.same || res.code === 'same_language' || res.code === 'no_text')) {
            btn.remove();                                    // server: already the reader's language (or no text) -> retire the button
            toast('Already in your language');
            return;
          }
          if (!res || !res.ok || !res.text) { lab.textContent = 'See translation'; toast((res && res.error) || 'Could not translate that.'); return; }
          box.textContent = res.text;                        // plain text: never inject model output as HTML
          box.hidden = false; box.setAttribute('data-loaded', '1');
          lab.textContent = 'See original'; btn.setAttribute('data-shown', '1');
        })
        .catch(function () { btn.disabled = false; lab.textContent = 'See translation'; toast('Could not translate that.'); });
    });
  })();

  /* ---- the Rova Map: pin popovers ---------------------------------------- */
  /* ---- map perf (#301, app WebView "choppy scroll"): the pulse rings are
     compositor animations, but dozens of them still cost real GPU time on a
     phone — and they kept running while the reader was SCROLLED DOWN in the
     nearby list with the map entirely off screen. Pause them whenever the map
     is out of view or the page is actively scrolling; resume 180ms after the
     scroll settles. CSS does the pausing (rmap-anim-off), this just flips it. */
  (function () {
    var pinsBox = document.querySelector('.rmap-pins');
    if (!pinsBox) return;
    var root = document.documentElement;
    var mapVisible = true, scrollIdleT = null;
    /* #508/#509: the panel ships with .rmap-anim-hold so the rings and pulses do
       not exist as animations during the load — a live animation dirties its
       element on every style pass, and this page's forced recalc measured 196ms
       with them against 141ms without. Release once the load event is done and
       the thread is free; the motion then starts exactly as it always did. */
    (function () {
      var panel = document.getElementById('rova-map');
      if (!panel || !panel.classList.contains('rmap-anim-hold')) return;
      function release() { panel.classList.remove('rmap-anim-hold'); }
      function soon() {
        if (window.requestIdleCallback) { requestIdleCallback(release, { timeout: 1200 }); }
        else { setTimeout(release, 200); }
      }
      if (document.readyState === 'complete') { soon(); }
      else { window.addEventListener('load', soon, { once: true }); }
    })();
    function sync(scrolling) {
      root.classList.toggle('rmap-anim-off', !mapVisible || !!scrolling);
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        mapVisible = !!(entries[0] && entries[0].isIntersecting);
        sync(false);
      }, { threshold: 0.02 }).observe(pinsBox);
    }
    window.addEventListener('scroll', function () {
      sync(true);
      clearTimeout(scrollIdleT);
      scrollIdleT = setTimeout(function () { sync(false); }, 180);
    }, { passive: true });
  })();

  /* ---- video avatars: a profile photo must NEVER show a play button -------
     Owner report 2026-08-07 (iPhone Safari, /@thedonk23, battery 16% and yellow): the profile photo
     was a black circle with iOS's start-playback triangle instead of the boomerang loop.

     WHAT IS ACTUALLY HAPPENING. iOS blocks video autoplay OUTRIGHT in Low Power Mode and no web API
     can override it. Safari's per-site Auto-Play setting, Data Saver, an aborted media load and the
     simultaneous-decoder ceiling all land in the same state: a <video> that will not start, which
     WebKit then decorates with its own play control. rova.css has hidden
     ::-webkit-media-controls-start-playback-button since video avatars shipped, the owner's device
     was being served that exact CSS, and the badge appeared anyway -- those are legacy
     pseudo-elements that modern WebKit media controls do not expose. CSS cannot win this. The
     element has to stop being a <video>.

     SO WE GIVE UP AND SHOW THE STILL, and that is the correct outcome rather than a degradation: the
     platform is telling us the member is trying to save battery, and one looping <video> per avatar
     is exactly the per-frame tax that cooks a phone. Nothing here ever retries playback.

     THE SWAP KEEPS THE BOX AND THE GATE. The still replaces the <video> INSIDE the same .av-vid span,
     which is the element carrying `avatar`, the size class and -- load-bearing -- `nsfw-cell`. So a
     sensitive profile photo stays blurred through the fallback (twice over: view.php hands us the
     pre-blurred "_nb.jpg" for a gated avatar in the first place). Removing the <video> also hands
     its decoder back, which on a phone that just refused to start one is the point.

     THE SIGNAL IS play()'s PROMISE, not a timer: it rejects with NotAllowedError the moment the
     platform refuses. Everything else is a backstop for engines that neither reject nor start. Both
     paths converge on ONE decision -- "is it still paused a moment later?" -- because `paused` is set
     to false SYNCHRONOUSLY by play(), before a single byte arrives, so a slow network can never trip
     it. A video that is actually running is never touched. */
  (function () {
    var GRACE = 1800;      // never settled / no promise at all
    var AFTER_REJECT = 600;
    var AFTER_ERROR = 1200;  // long enough for the CDN-miss origin retry at the top of this file

    function stillOf(v) { return v.getAttribute('poster') || v.getAttribute('data-poster') || ''; }

    function fallback(v) {
      if (!v || v.__avStill || !v.paused) return;   // playing fine: nothing is wrong
      if (v.__avFarPaused) return;                  // WE stopped it because it is far off screen -- see avFar()
      if (document.hidden) return;                  // a backgrounded tab pauses media; that is not a refusal
      var box = v.parentNode, src = stillOf(v);
      // No still on disk (view.php resolved '') -- leave the element exactly as it is today rather
      // than blank the avatar. An avatar is never removed on Rova.
      if (!box || !src) return;
      v.__avStill = 1;
      var im = document.createElement('img');
      im.alt = '';
      im.decoding = 'async';
      im.src = src;
      box.replaceChild(im, v);
      try { v.pause(); v.removeAttribute('src'); v.load(); } catch (e) {}   // release the decoder
    }
    function arm(v, ms) { setTimeout(function () { fallback(v); }, ms); }

    /* ---- A VIDEO AVATAR FAR OFF SCREEN MUST NOT KEEP DECODING (2026-08-10) --------------------
       MEASURED on /feed -> immersive viewer, Edge (H.264, so the recycler's teardown paths really
       fire), 390x844, CPU x4, counting every <video> more than 1.5 viewports beyond the edge that
       is both unpaused and readyState > 0:

         after  4 swipes   5 far clips decoding   5 of 5 are av-vid avatars
         after  8 swipes  10                     10 of 10
         after 12 swipes   8                      8 of 8
         after 16 swipes  15                     15 of 15   (furthest: 13.9 viewports away)

       POST MEDIA WAS NEVER THE PROBLEM -- `farDecodingPost` was 0 at every sample, i.e. the
       recycler does its job perfectly on the clips it can reach. The entire residue is avatars,
       and it GROWS WITHOUT BOUND with swipe depth: nothing in this file has ever stopped one.

       WHY THE RECYCLER CANNOT REACH THEM. __rovaRecycleVideos walks `p.querySelectorAll('video')`
       on far posts and calls teardownVideo on each -- which reaches these elements and then bails
       on its FIRST guard, `if (!v._auto ...) return`. `_auto` is set by wire(), and wire() only
       ever runs on `.post .media video`; an avatar is deliberately not wired (it has no controls,
       no sound, no HLS ladder, no start-slot accounting). So the walk finds them, hands them to a
       function that is not allowed to touch them, and every one keeps looping. Measured on the
       elements above: readyState 4, paused false, up to fourteen screens from what is on screen.

       WHY NOT FIX IT IN teardownVideo. That would make an avatar take the POST-CLIP treatment --
       preload=none, poster stashed, src dropped, hls destroyed, re-observed on warmIO -- which is
       a hard release of an element whose whole job is to be a decorative 3-second loop that is
       never blank. It also would not cover the avatars that are not inside a far `.post` at all.
       This is the narrower thing that is true everywhere: STOP DECODING WHAT NOBODY CAN SEE.

       PAUSE ONLY -- the same discipline __rovaBgHold follows, for the same reason. No src change,
       no load(), no poster change, no preload change, and above all NO MUTE CHANGE. The bytes stay
       in hand, so coming back is a play() on a fully buffered element, not a refetch: the decoder
       is the entire cost being handed back and the entire cost being paid again.

       DELIBERATELY LAZY TO STOP, EAGER TO START. A 400ms settle before pausing means a fast fling
       straight past an avatar and back never stops it at all, while the resume runs synchronously
       in the observer callback -- so an avatar is running again a frame before it can be painted.
       root:null with a 150% margin mirrors the deferred-avatar observer directly above (an
       intersection rect is clipped by ancestor overflow, so one observer is correct both for the
       viewer's inner scroll box and for the page itself).

       IT ONLY EVER UNDOES ITS OWN PAUSE. __avFarPaused is the proof of ownership: an avatar that
       is paused for any OTHER reason -- autoplay refused, Low Power Mode, the reader's tab hidden,
       the still-fallback already swapped in -- is never marked, so this can never start something
       the platform or the member stopped. And fallback() above now declines to act on a clip
       carrying the mark, because otherwise the 1800ms grace timer guard() arms would read our own
       far-pause as "the platform refused to play this" and permanently replace a perfectly good
       video avatar with a still image, several screens away, where nobody could see it happen.
       A resume that is genuinely refused re-arms that fallback, which is the correct outcome. */
    var FAR_SETTLE = 400;
    function avNear(v) {
      if (v.__avFarT) { clearTimeout(v.__avFarT); v.__avFarT = 0; }
      if (!v.__avFarPaused) return;              // we never stopped this one: not ours to start
      /* ...AND NOT WHILE A FULL-SCREEN VIEWER IS OVER THE PAGE (2026-09-08). This resume was the
         single biggest source of decoding nobody could see: measured with tools/pw/bghold-probe.js,
         an avatar 1146px ABOVE the viewport started here at +8.3s of a 45s open and ran for 35 of
         those seconds, and across four 40s opens some avatar was decoding behind the overlay in
         26-62% of samples. The band this observer works in is 75% of the viewport (150% until the
         2026-09-18 idle-cost audit measured avatars decoding a screen and a half below the fold), so "near" here
         does not mean "visible" even before the overlay is considered.
         BOTH MARKS ARE KEPT, deliberately: __avFarPaused stays set so THIS observer still owns the
         element if it is out of band when the viewer closes, and _bgHeld is set so the background
         hold's own release restarts it at close if it is in band. Dropping either one is how an
         avatar ends up frozen for the rest of the page. */
      if (window.__rovaBgBuried && window.__rovaBgBuried(v)) { v._bgHeld = 'avatar'; return; }
      v.__avFarPaused = 0;
      if (v.__avStill || !v.isConnected || !v.paused) return;
      var p;
      try { p = v.play(); } catch (e) { arm(v, AFTER_REJECT); return; }
      if (p && typeof p.catch === 'function') { p.catch(function () { arm(v, AFTER_REJECT); }); }
    }
    function avFar(v) {
      if (v.__avFarPaused || v.__avFarT) return;
      v.__avFarT = setTimeout(function () {
        v.__avFarT = 0;
        if (drop(v)) return;
        // Re-read, do not trust the entry: it is 400ms old. Already stopped (refused / swapped /
        // never started) means there is no decoder to hand back and no pause of ours to undo.
        if (v.__avStill || v.paused) return;
        v.__avFarPaused = 1;
        try { v.pause(); } catch (e) {}
      }, FAR_SETTLE);
    }
    /* AN OBSERVER HOLDS ITS TARGETS STRONGLY, so this MUST let go or it becomes the exact
       detached-DOM leak retireVideo's playIO/warmIO unobserve pair exists to prevent -- and the
       card virtualiser detaches avatars constantly (stubCard serialises a far card and drops the
       live nodes). Detaching an element delivers a non-intersecting entry, so the far path is
       reached for every one of them: that is the hook. Checked in the settle timer too, because a
       node can be pulled out during those 400ms. */
    function drop(v) {
      if (v.isConnected) return false;
      if (v.__avFarT) { clearTimeout(v.__avFarT); v.__avFarT = 0; }
      if (farIO) { try { farIO.unobserve(v); } catch (e) {} }
      return true;
    }
    var farIO = ('IntersectionObserver' in window) ? new IntersectionObserver(function (ents) {
      for (var i = 0; i < ents.length; i++) {
        var t = ents[i].target;
        if (drop(t)) continue;
        if (ents[i].isIntersecting) avNear(t); else avFar(t);
      }
    }, { rootMargin: '75% 0px 75% 0px' }) : null;   // was 150% (idle-cost audit, 2026-09-18): a 22 px avatar decoding a screen and a half below the fold is a decoder for nobody; 75% = the grid's own release band, still 2.5x the 250 px load runway

    function guard(v) {
      if (!v || v.__avGuard) return;
      v.__avGuard = 1;
      // Every avatar that gets a source passes through here -- sweep() at load, fill() as a deferred
      // one scrolls in, and the capture-phase media events for anything injected later -- so this is
      // the one choke point where the far-off-screen watch can be armed for all of them, and it is
      // armed only for elements that actually have media to decode.
      if (farIO) { try { farIO.observe(v); } catch (e) {} }
      // The document-level CDN-miss retry (top of this file) consumes the FIRST error in the capture
      // phase, so this only ever sees a failure re-pointing at the origin could not fix.
      v.addEventListener('error', function () { arm(v, AFTER_ERROR); });
      var p;
      try { p = v.play(); } catch (e) { arm(v, AFTER_REJECT); return; }
      if (p && typeof p.catch === 'function') { p.catch(function () { arm(v, AFTER_REJECT); }); }
      arm(v, GRACE);
    }
    window.__rovaAvatarPlayGuard = guard;           // the av-defer swap below arms its own

    function sweep() {
      // `[src]` skips the deferred ones on purpose: they have no source yet and arming them would
      // start the very request #508/#509 removed. fill() arms each one as it scrolls in.
      if (document.hidden) return;                  // never judge a video the tab was never showing
      var vs = document.querySelectorAll('.av-vid video[src]');
      for (var i = 0; i < vs.length; i++) { guard(vs[i]); }
    }
    sweep();                                        // this file is `defer`, so the DOM is already parsed
    document.addEventListener('visibilitychange', function () { if (!document.hidden) sweep(); });
    /* A HIDDEN TAB HAS NO READER (idle-cost audit, 2026-09-18): the timeline clips and the grid previews now pause
       on hide; an avatar clip inside its 75% band kept decoding for the whole of a 12 s hidden window (measured on
       a desktop timeline: 359 frames, 54 px circle, nobody watching). Pause it and carry BOTH marks, exactly as
       __rovaBgHold does for an avatar: __avHidPaused says this handler owns the resume, __avFarPaused keeps
       fallback() from reading our own pause as "the platform refused this clip" and swapping in a still. On
       return, resume only what this paused and only what is not out of band / buried / already a still -- an
       avatar that is out of band keeps __avFarPaused and is farIO's to restart when it scrolls in. */
    document.addEventListener('visibilitychange', function () {
      var vs = document.querySelectorAll('.av-vid video[src]'), i, v;
      if (document.hidden) {
        for (i = 0; i < vs.length; i++) { v = vs[i]; if (!v.paused && !v.__avStill) { v.__avHidPaused = 1; v.__avFarPaused = 1; try { v.pause(); } catch (e) {} } }
        return;
      }
      for (i = 0; i < vs.length; i++) {
        v = vs[i]; if (!v.__avHidPaused) continue;
        v.__avHidPaused = 0;
        if (v.__avStill || !v.isConnected) continue;
        if (window.__rovaBgBuried && window.__rovaBgBuried(v)) { v._bgHeld = 'avatar'; continue; }   // a viewer is up: its close hands the avatar back
        var r = null; try { r = v.getBoundingClientRect(); } catch (e) {}
        if (!(r && r.width > 0 && r.bottom > -innerHeight * 0.75 && r.top < innerHeight * 1.75)) continue;   // out of band: farIO owns it (mark kept)
        v.__avFarPaused = 0;
        var p; try { p = v.play(); } catch (e) { continue; }
        if (p && typeof p.catch === 'function') { p.catch(function () {}); }
      }
    });
    // Avatars that arrive AFTER load -- /post-cards prefetch, restoreCard, any fragment carrying
    // server-rendered avatar HTML. Media events do not bubble, so these are capture-phase, exactly
    // like the CDN retry; that is one listener instead of a MutationObserver scanning a feed that
    // mutates constantly (see the 500ms comment-roller pump we deleted for being that kind of tax).
    ['loadedmetadata', 'loadeddata', 'canplay'].forEach(function (ev) {
      document.addEventListener(ev, function (e) {
        var t = e && e.target, p = t && t.parentNode;
        if (t && t.tagName === 'VIDEO' && p && p.classList && p.classList.contains('av-vid')) { guard(t); }
      }, true);
    });
  })();

  /* ---- map side list: deferred avatars (#508/#509) ------------------------
     "Beaming near you" renders 30 rows, but .rmap-list is its own 340px scroll
     box on a phone -- only about six are on screen. Those thirty 480x480 photos
     were ~975KB of a 1.6MB page (~890ms of a ~1.4s load), and because Chrome
     gives deferred scripts and images the SAME low fetch priority they were also
     what held app.js back to 2.6s. views/map_live.php now renders row 7 onward
     with data-src and no src (avatar_img($defer)); this fetches each one the
     moment it scrolls into the box. root:null is deliberate -- an intersection
     rect is clipped by ancestor overflow, so the same observer is correct both
     for the phone's inner scroll box and for the desktop layout where the page
     itself scrolls. Rows that are never scrolled to are never fetched, which is
     the whole point; nothing else about the row changes. */
  /* WIDENED 2026-07-28: this was scoped to `.rmap-list`, but avatar_img($defer) has always been a
     GENERAL contract ("app.js swaps it in when the row scrolls into view") and view.php documents it
     as such. The Founders referral roster is the second caller -- and had it shipped against the old
     map-only selector, every deferred avatar there would have stayed permanently blank. Now anything
     rendered with av-defer anywhere on the page is swapped, plus an idle backstop so a row that is
     never scrolled to (or an observer that never fires) can't leave a hole forever. */
  (function () {
    /* ---- WHY THERE IS NO SLOW-LINE STAND-DOWN HERE (TRIED AND REVERTED 2026-08-11) ----------------
       An attempt shipped and was withdrawn the same hour. Recording it so it is not re-attempted on
       the same reasoning.

       THE PREMISE WAS RIGHT AND THE SIZE OF IT WAS UNDERSTATED. netaudit slow4g (1.6Mbps / 150ms /
       CPU x4), 390x844, Edge, member session, cold browser cache, medians of 5, counting what the
       RADIO issued in the first 3s after the action -- measured with CDP encodedDataLength, because
       resource timing reports transferSize 0 for CDN media and reads as "free" when it means
       "unmeasurable from inside the page":

         viewer open (grid tap)   avatar imagery  41 req / 255KB
                                  post media      39 req /  79KB     <- what the reader tapped
         feed load                avatar imagery  28 req / 215KB
                                  post media      17 req / 152KB

       Three times more of the radio goes to decoration than to the tapped post, and the tapped post
       had not painted after ten seconds in 5 of 5 runs. Note WHAT the decoration is: the looping mp4
       avatars are 0-2 requests of it. It is almost entirely avatar STILLS, so standing the LOOPS down
       specifically would have moved almost none of it.

       WHAT WAS BUILT. Far-off-screen avatars (beyond 0.75 viewports, comfortably outside io's 250px
       runway) gave their src back and joined the deferred lane this module already runs. It worked as
       designed -- 12 to 13 avatars per viewer open, verified on the element.

       WHY IT WENT BACK. A/B'd inside a single session, alternating on/off over the same deck, same
       throttle, same cache state, four pairs: avatars ON 12 req / 67KB, OFF 11 req / 56KB. No gain,
       and the wrong sign. The reason is structural and applies to ANY client-side version of this:
         * on the initial load app.js is `defer`, so on a slow line the bundle that would stand the
           avatars down ARRIVES AFTER THEY DO -- by the time it runs, the decoration is paid for;
         * in injected markup the request is issued when the fragment is inserted, so a
           MutationObserver can only ABORT, which returns the round trip and little of the body.
       A mechanism that adds a way for an avatar to be blank has to buy something, and this bought
       nothing measurable.

       WHAT WOULD ACTUALLY WORK is prevention at the SERVER -- avatar_img($defer) for small avatars
       when the client has told us the link is slow -- and that is blocked by this module's own rule,
       written above: never defer anything visible on arrival, because the swap costs a round trip.
       Deferring every sm avatar would pay that round trip on the ones the reader is looking at. That
       trade needs a decision, not a patch. */
    function fill(el) {
      var s = el.getAttribute('data-src');
      if (!s) return;
      el.removeAttribute('data-src');
      el.classList.remove('av-defer');
      el.setAttribute('src', s);
      // a <video> that was parsed without a src needs an explicit load() before
      // autoplay will pick it up
      if (el.tagName === 'VIDEO') {
        el.preload = 'auto';
        try { el.load(); } catch (e) {}
        // Arm the play-guard only now that this row has a source, and only AFTER load() -- calling
        // load() on a pending play() rejects it with AbortError and we would fall back on a video
        // that was about to work. The still stays on data-poster: promoting it to a real `poster`
        // here would fetch an image for every deferred row that scrolls in, which is most of the
        // eager request #508/#509 removed, for a circle that is about to fill anyway.
        if (window.__rovaAvatarPlayGuard) { window.__rovaAvatarPlayGuard(el); }
      }
    }
    var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) { fill(entries[i].target); io.unobserve(entries[i].target); }
      }
    }, { rootMargin: '250px 0px' }) : null;              // a screen of runway, so scrolling never shows a hole
    function obs(el) {
      if (!el || el.__avDefObs) return;
      el.__avDefObs = 1;
      if (io) io.observe(el); else fill(el);             // no observer support: just load it
    }

    /* NOT A ONE-SHOT ANY MORE (2026-08-08). This used to be `var pending = querySelectorAll(...); if
       (!pending.length) return;` -- a snapshot taken once, at script load, with an early return that
       never even BUILT the observer when the first paint happened to defer nothing. Every deferred
       avatar that arrives later was therefore invisible to it: /post-cards fetches, feed load-more,
       pfeed appends, notification and hovercard fragments, the virtualiser's restored cards. On
       /feed the server defers nothing, so `pending.length` was 0 and the module returned before the
       IntersectionObserver was constructed -- measured: 0 observed, ever. views/_founders_roster_block.php
       had already been written around the hole ("never deferred ... would stay blank forever").
       The scan+observe now hangs off the ONE document-wide childList observer that already exists
       (the post-video wire observer, which calls __rovaAvatarDefer per matched element) -- no new
       observer, no second tree walk. */
    window.__rovaAvatarDefer = function (el) {
      if (!el || el.nodeType !== 1) return;
      /* HEAL A RELEASED AVATAR -> BACK TO DEFERRED, never to an eager re-attach.
         The card virtualiser stubs a far-off card by stashing p.outerHTML, and stubCard calls
         __rovaReleaseVideos(p) FIRST -- which walks EVERY <video> in the card, header avatars
         included, so retireVideo strips their src before the markup is serialised. retireVideo
         stashes the url on data-video-src, so the URL survives the round trip, but nothing re-attached
         it: wire() only covers `.post .media video`, and this module never saw the restored node.
         Measured on /feed at 390x844: 3 of 3 restored card-header avatars came back with neither src
         nor data-src -- a permanently empty circle, and an avatar is never blank on Rova.
         Putting the URL back on data-src (rather than on src) hands the element to the SAME deferral
         every fresh avatar gets: zero requests until it is within the observer's 250px runway, so a
         restored card 6 screens away costs nothing and the deliberate deferral is preserved instead
         of overridden. data-poster is re-seeded from the data-vposter retireVideo stashed so the
         play-guard's still fallback still has a frame to fall back TO (md/lg avatars carry a real
         `poster`, which retireVideo strips; sm ones carry data-poster, which it leaves alone). */
      if (el.tagName === 'VIDEO' && !el.getAttribute('src') && !el.getAttribute('data-src')) {
        var vs = el.getAttribute('data-video-src');
        if (vs) {
          el.setAttribute('data-src', vs);
          if (!el.getAttribute('poster') && !el.getAttribute('data-poster')) {
            var vp = el.getAttribute('data-vposter');
            if (vp) el.setAttribute('data-poster', vp);
          }
          el.classList.add('av-defer');
          el.preload = 'none';                           // nothing goes out until fill() sets the src
        }
      }
      if (el.classList.contains('av-defer') && el.getAttribute('data-src')) obs(el);
    };
    Array.prototype.forEach.call(document.querySelectorAll('.av-defer[data-src]'), obs);
    // No blanket "load everything at idle" backstop on purpose: that is exactly the 975KB the map
    // deferral was built to avoid (#508/#509). The observer's 250px runway is the whole mechanism --
    // a row that is never scrolled to is never fetched.
  })();
  /* ---- map page: my-beam switch (same endpoint as the settings toggle).
     The page renders my pin and my list row even while the beam is off
     (hidden), so flipping the switch just shows/hides them and adjusts the
     counters in place. No reload. ----------------------------------------- */
  (function () {
    var b = document.getElementById('rmap-beam');
    if (!b || b.tagName !== 'BUTTON') return;   // the "Set my beam" link needs no JS
    function paint(on) {
      b.classList.toggle('on', on);
      b.setAttribute('data-on', on ? '1' : '0');
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var t = document.getElementById('rmap-beam-t');
      if (t) t.textContent = 'My beam: ' + (on ? 'on' : 'off');
      var mine = document.getElementById('rmap-mine');
      if (!mine) return;                        // beaming from outside the map's view: nothing to flip
      mine.hidden = !on;
      var row = document.getElementById('rmap-me-row');
      if (row) row.hidden = !on;
      var h = document.getElementById('rmap-side-h');
      if (h) h.textContent = on ? 'Beaming near you' : 'Beaming now';
      ['rmap-n-beam', 'rmap-n-on'].forEach(function (id) {   // I'm online while tapping, so both move
        var el = document.getElementById(id);
        if (el) el.textContent = String(Math.max(0, (parseInt(el.textContent, 10) || 0) + (on ? 1 : -1)));
      });
    }
    b.addEventListener('click', function () {
      if (b.disabled || busyIs(b)) return;
      var turnOn = b.getAttribute('data-on') !== '1';
      busyUntil(b, postJson('/settings/location', { action: turnOn ? 'on' : 'off' }, 15000).then(function (res) {
        if (!res || !res.ok) { toast((res && res.message) || 'Could not save that'); return; }
        paint(turnOn);
        // "Most active near you" is scoped to your beam/location, so it changes when you toggle -- refresh
        // it live instead of making the reader reload the page.
        var wrap = document.getElementById('rmap-lead-wrap');
        if (wrap) {
          fetch('/map/leaders', { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', cache: 'no-store' })
            .then(function (r) { return r.ok ? r.text() : null; })
            .then(function (html) { if (html != null) wrap.innerHTML = html; })
            .catch(function () {});
        }
        toast(turnOn ? 'Your beam is live' : 'Beam off, you are hidden from the map');
      }).catch(function (err) {
        if (err && err.message === 'reauth') return;
        toast('Could not save that');
      }));
    });
  })();

  (function () {
    var map = document.getElementById('rova-map');
    if (!map) return;
    var guest = map.getAttribute('data-guest') === '1';   // guests: read-only, View only
    var pop = document.getElementById('rmap-pop');
    function closePop() { pop.hidden = true; }
    map.addEventListener('click', function (e) {
      var pin = e.target.closest ? e.target.closest('.rmap-pin') : null;
      if (!pin) { if (!e.target.closest('#rmap-pop')) closePop(); return; }
      var name = pin.getAttribute('data-name') || '';
      var u = pin.getAttribute('data-u') || '';
      var label = pin.getAttribute('data-label') || '';
      var mi = pin.getAttribute('data-mi');
      var av = pin.getAttribute('data-avatar') || '';
      var isMe = pin.getAttribute('data-me') === '1' || pin.classList.contains('mine');
      var traveling = pin.getAttribute('data-travel') === '1';
      document.getElementById('rmap-pop-name').textContent = name;
      document.getElementById('rmap-pop-sub').textContent =
        '@' + u + (label ? ' · ' + (traveling ? 'visiting ' : '') + label : '')
        + (mi && !pin.classList.contains('mine') ? ' · ~' + Number(mi).toLocaleString('en-US') + ' mi' : '');
      document.getElementById('rmap-pop-go').setAttribute('href', '/@' + encodeURIComponent(u));
      var plink = document.getElementById('rmap-pop-link');
      if (plink) plink.setAttribute('href', '/@' + encodeURIComponent(u));
      var wave = document.getElementById('rmap-pop-wave');
      if (wave) {
        wave.hidden = isMe || guest;
        wave.disabled = false;
        wave.setAttribute('data-id', pin.getAttribute('data-id') || '');
        wave.setAttribute('data-name', name);
      }
      var fol = document.getElementById('rmap-pop-follow');
      if (fol) {
        var following = pin.getAttribute('data-following') === '1';
        fol.hidden = isMe || guest;
        fol.disabled = false;
        fol.textContent = following ? 'Following' : 'Follow';
        fol.setAttribute('data-id', pin.getAttribute('data-id') || '');
        fol.setAttribute('data-following', following ? '1' : '0');
      }
      var img = document.getElementById('rmap-pop-av');
      var mono = document.getElementById('rmap-pop-mono');
      if (av) {
        img.src = av; img.hidden = false; mono.hidden = true;
      } else {
        mono.textContent = String(u).trim() ? nameInitial(u, '') : 'R'; mono.hidden = false; img.hidden = true;
      }
      // park the card near the pin, clamped inside the panel
      var pr = map.getBoundingClientRect();
      var r = pin.getBoundingClientRect();
      pop.hidden = false;
      var w = pop.offsetWidth, h = pop.offsetHeight;
      var x = r.left - pr.left + r.width / 2 - w / 2;
      var y = r.top - pr.top - h - 10;
      if (y < 8) y = r.top - pr.top + r.height + 10;      // no room above: flip below
      x = Math.max(8, Math.min(pr.width - w - 8, x));
      y = Math.max(8, Math.min(pr.height - h - 8, y));
      pop.style.left = Math.round(x) + 'px';
      pop.style.top = Math.round(y) + 'px';
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePop(); });

    // wave: one per pair per day; mutual within a week opens a DM
    document.addEventListener('click', function (e) {
      var w = e.target.closest ? e.target.closest('#rmap-pop-wave') : null;
      if (!w || w.disabled || busyIs(w)) return;
      var waved = false;
      busyUntil(w, postJson('/map/wave', { user_id: w.getAttribute('data-id') || 0 }, 15000).then(function (res) {
        waved = true;
        toast((res && res.message) || 'Wave sent');
      }).catch(function (err) {
        if (err && err.message === 'reauth') return;
        toast('Could not wave right now');
      })).then(function () { if (waved) w.disabled = true; });   // one per pair per day: stays spent (after the busy release)
    });

    // follow straight from the popover; the pin remembers the new state
    document.addEventListener('click', function (e) {
      var f = e.target.closest ? e.target.closest('#rmap-pop-follow') : null;
      if (!f || f.disabled || busyIs(f)) return;
      var doFollow = f.getAttribute('data-following') !== '1';
      busyUntil(f, postJson('/follow', { user_id: f.getAttribute('data-id') || 0, action: doFollow ? 'follow' : 'unfollow', return: '/map' }, 15000).then(function () {
        f.setAttribute('data-following', doFollow ? '1' : '0');
        f.textContent = doFollow ? 'Following' : 'Follow';
        var pin = document.querySelector('.rmap-pin[data-id="' + (f.getAttribute('data-id') || '') + '"]');
        if (pin) pin.setAttribute('data-following', doFollow ? '1' : '0');
        toast(doFollow ? 'Following' : 'Unfollowed');
      }).catch(function (err) {
        if (err && err.message === 'reauth') return;
        toast('Could not save that');
      }));
    });
  })();

  /* ---- map page: travel mode (temporary beam, auto-expires server-side) -- */
  (function () {
    var t = document.getElementById('rmap-travel');
    var pop = document.getElementById('rmap-travel-pop');
    if (!t || !pop) return;
    /* WHERE THE PLANNER GOES (2026-09-29, Rob on an iPhone Air: it opened ~170px off the left
       edge -- CSS right:0 to a chip that is the first pill of the wrapped row on a phone).
       < 640px: a bottom sheet, moved to <body> while open so no ancestor can become its
       containing block, over a backdrop (tap or Escape closes), kept above the iOS keyboard
       with visualViewport. >= 640px: anchored to the chip as before, then CLAMPED inside 16px
       gutters and flipped above when there is no room below. The fields, Start and End trip
       are untouched: only where the box sits changed. rova.css "travel mode chip". */
    var home = pop.parentNode;
    var motionMq = window.matchMedia('(prefers-reduced-motion: reduce)');
    var vv = window.visualViewport, bd = null, fadingBd = null, isOpen = false, closeTok = 0;
    // innerWidth, not a matchMedia: WebKit fires `resize` before the MQL has re-evaluated, so a
    // rotation/resize while open read the OLD mode (measured: a sheet left at opacity 0).
    function phone() { return window.innerWidth < 640; }
    pop.setAttribute('role', 'dialog');
    pop.setAttribute('aria-label', 'Travel mode');
    t.setAttribute('aria-haspopup', 'dialog');
    t.setAttribute('aria-controls', 'rmap-travel-pop');
    t.setAttribute('aria-expanded', 'false');
    function lift() {                     // the iOS keyboard shrinks the VISUAL viewport only
      if (!isOpen || !pop.classList.contains('rtp-sheet')) return;
      var kb = vv ? Math.max(0, Math.round(window.innerHeight - vv.height - vv.offsetTop)) : 0;
      pop.style.bottom = kb > 0 ? (kb + 8) + 'px' : '';
      pop.style.maxHeight = vv ? Math.max(160, Math.round(vv.height - 24)) + 'px' : '';
    }
    function anchor() {                   // desktop: under the chip, inside the viewport
      pop.classList.remove('rtp-up');
      pop.style.right = '';
      var vw = document.documentElement.clientWidth, r = pop.getBoundingClientRect(), dx = 0;
      if (r.right > vw - 16) dx = r.right - (vw - 16);          // too far right: pull left
      if (r.left - dx < 16) dx = r.left - 16;                    // too far left: push right (wins)
      if (dx) pop.style.right = Math.round(dx) + 'px';
      var tr = t.getBoundingClientRect();
      if (r.bottom > window.innerHeight - 16 && tr.top - r.height - 8 >= 16) pop.classList.add('rtp-up');
    }
    function place() {
      if (!isOpen) return;
      if (phone()) {
        if (pop.parentNode !== document.body) document.body.appendChild(pop);
        pop.style.right = '';
        pop.classList.remove('rtp-up');
        pop.classList.add('rtp-sheet');
        if (!bd) {
          bd = document.createElement('div');
          bd.className = 'rtp-backdrop';
          bd.setAttribute('aria-hidden', 'true');
          bd.addEventListener('click', function () { close(); });   // a direct listener: iOS does not
          document.body.insertBefore(bd, pop);                        // deliver delegated clicks to a bare div
        }
        lift();
        if (!pop.classList.contains('in')) {
          void pop.offsetWidth;           // commit the from-state so the slide runs
          pop.classList.add('in');
          bd.classList.add('in');
        }
      } else {
        if (bd) { bd.remove(); bd = null; }
        pop.classList.remove('rtp-sheet', 'in');
        pop.style.bottom = pop.style.maxHeight = '';
        if (pop.parentNode !== home) home.appendChild(pop);
        anchor();
      }
    }
    function open() {
      closeTok++;                         // cancels a close still animating out
      if (fadingBd) { fadingBd.remove(); fadingBd = null; }
      isOpen = true;
      pop.hidden = false;
      t.setAttribute('aria-expanded', 'true');
      place();
      window.addEventListener('resize', place);
      if (vv) { vv.addEventListener('resize', lift); vv.addEventListener('scroll', lift); }
    }
    function close(refocus) {
      if (!isOpen) return;
      isOpen = false;
      t.setAttribute('aria-expanded', 'false');
      window.removeEventListener('resize', place);
      if (vv) { vv.removeEventListener('resize', lift); vv.removeEventListener('scroll', lift); }
      var tok = ++closeTok, wasSheet = pop.classList.contains('rtp-sheet'), shade = bd;
      bd = null; fadingBd = shade;
      function done() {
        if (tok !== closeTok) return;
        pop.hidden = true;
        pop.classList.remove('rtp-sheet', 'in', 'rtp-up');
        pop.style.bottom = pop.style.maxHeight = pop.style.right = '';
        if (pop.parentNode !== home) home.appendChild(pop);
        if (shade) { shade.remove(); if (fadingBd === shade) fadingBd = null; }
      }
      if (refocus) t.focus();
      if (!wasSheet || motionMq.matches) { done(); return; }
      pop.classList.remove('in');
      if (shade) shade.classList.remove('in');
      // lands on the sheet's own transitionend; the backstop only covers a transition that never runs
      pop.addEventListener('transitionend', function te(e) {
        if (e.target !== pop) return;
        pop.removeEventListener('transitionend', te);
        done();
      });
      setTimeout(done, 520);
    }
    // an error toast would sit UNDER the sheet's buttons: lift it above the sheet while open
    function say(msg) {
      toast(msg);
      if (!isOpen || !pop.classList.contains('rtp-sheet')) return;
      var all = document.querySelectorAll('.toast'), el = all[all.length - 1];
      if (el) el.style.bottom = Math.max(26, Math.round(window.innerHeight - pop.getBoundingClientRect().top + 10)) + 'px';
    }
    t.addEventListener('click', function () { if (isOpen) close(); else open(); });
    document.addEventListener('click', function (e) {
      if (isOpen && !e.target.closest('#rmap-travel') && !e.target.closest('#rmap-travel-pop')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (isOpen && e.key === 'Escape') close(true);
    });
    function apply(on, res, days) {
      var mine = document.getElementById('rmap-mine');
      if (mine && res && res.x != null && res.y != null) {
        mine.style.left = res.x + '%';
        mine.style.top = res.y + '%';
        mine.classList.toggle('travel', on);
        mine.setAttribute('data-travel', on ? '1' : '0');
        if (res.label) mine.setAttribute('data-label', res.label);
      }
      t.classList.toggle('on', on);
      t.setAttribute('data-on', on ? '1' : '0');
      var tt = document.getElementById('rmap-travel-t');
      if (tt) tt.textContent = on ? (res.label || 'Traveling') : 'Travel';
      var onBox = document.getElementById('rtp-on'), offBox = document.getElementById('rtp-off');
      if (onBox) onBox.hidden = !on;
      if (offBox) offBox.hidden = on;
      if (on) {
        var wh = document.getElementById('rtp-where');
        if (wh) wh.textContent = res.label || 'your destination';
        var un = document.getElementById('rtp-until');
        if (un) un.textContent = days ? ' for the next ' + days + ' day' + (days === '1' ? '' : 's') : '';
      }
      close();
      toast(on ? ('Beaming from ' + (res.label || 'your destination')) : 'Back home, beam restored');
    }
    var go = document.getElementById('rmap-travel-go');
    if (go) go.addEventListener('click', function () {
      var q = (document.getElementById('rmap-travel-q').value || '').trim();
      if (!q) { say('Type a city, like "Miami, FL"'); return; }
      var days = document.getElementById('rmap-travel-days').value;
      if (busyIs(go)) return;
      busyUntil(go, postJson('/settings/location', { action: 'travel', q: q, days: days }, 15000).then(function (res) {
        if (!res || !res.ok) { say((res && res.message) || 'Could not place that'); return; }
        apply(true, res, days);
      }).catch(function (err) {
        if (err && err.message === 'reauth') return;
        say('Could not place that. Try "City, ST", like "Miami, FL"');
      }));
    });
    var end = document.getElementById('rmap-travel-end');
    if (end) end.addEventListener('click', function () {
      if (busyIs(end)) return;
      busyUntil(end, postJson('/settings/location', { action: 'travel_off' }, 15000).then(function (res) {
        if (!res || !res.ok) { say('Could not save that'); return; }
        apply(false, res);
      }).catch(function (err) {
        if (err && err.message === 'reauth') return;
        say('Could not save that');
      }));
    });
  })();

  /* ---- admin: LAZY PANELS -- run a panel's setup once its markup exists (2026-09-29) --------------
     /admin now renders ONE panel server-side; the rest are placeholder sections
     (<section class="admin-panel" data-panel="x" data-lazy="1">) that the nav fills from
     GET /admin/panel?p=x the first time it selects them (views/admin.php "LAZY PANELS"). Every admin
     block below that looks up its panel's elements at boot is registered through this instead of
     running as a bare IIFE: a panel rendered with the page runs it immediately, exactly as before; a
     lazy one runs it once, right after its markup lands (adminPanel.ready, called by the nav).
     Hoisted, so the shadow-phrase block far above can use it too. Blocks that delegate from document
     (founders tables, .js-ftree, backup-now, copy-promo, js-confirm) need no registration. */
  function adminPanel(name, fn) {
    var p = document.querySelector('.admin-panel[data-panel="' + name + '"]');
    if (!p) return;                                   // not /admin
    if (!p.hasAttribute('data-lazy')) { fn(p); return; }
    var q = adminPanel.q || (adminPanel.q = {});
    (q[name] || (q[name] = [])).push(fn);
  }
  adminPanel.ready = function (name, p) {
    var q = adminPanel.q || {}, fns = q[name] || [];
    q[name] = [];
    fns.forEach(function (fn) {
      try { fn(p); } catch (e) { if (window.console) console.error('admin panel ' + name + ':', e); }
    });
  };

  /* ---- admin: live RECONNECTING badges (db/0219, 2026-10-02) ------------------------------------------
     views/_admin_live.php gives every OPEN stream row a slot <span class="lv-rcslot" data-lvrc=<id> data-n=<reconnects>>;
     a HELD row's slot holds .lv-rc[data-ends=<UTC ISO>][data-now=<render clock>] + "dropped <admin_time>".
     TICK: once a second while a badge is on screen, "m:ss left" from data-ends, corrected by the server-vs-browser
     clock skew taken from data-now; at zero it reads "ending…" (the server's reconnectTick ends it within ~5 s).
     REFRESH: the Live panel has no reload of its own, so while it is the panel on screen, the tab is visible and it
     lists at least one open stream, GET /admin/panel?p=live (the fragment the lazy nav loads; read-only) every 5 s
     while a row is held (2 s after one reaches zero), else every 20 s, and swap EACH SLOT for its counterpart: a
     resume removes the badge, a new drop shows one, a stream gone from the open list says "ended". Only the slots
     change (a half-typed Kill reason is never wiped), and an unchanged slot is left alone (no blink restart). */
  adminPanel('live', function (p) {
    if (!p || p.__lvrc) return;
    p.__lvrc = 1;
    var skew = 0, timer = 0, ticker = 0, busy = false, due = false, fails = 0;
    function onScreen() { return p.classList.contains('on') && !document.hidden; }
    function openSlots() { return p.querySelectorAll('.lv-rcslot[data-lvrc]:not([data-gone])'); }
    function readSkew(root) {
      var b = root.querySelector('.lv-rc[data-now]'), n = b ? Date.parse(b.getAttribute('data-now')) : NaN;
      if (!isNaN(n)) skew = n - Date.now();
    }
    function sig(slot) {
      var b = slot.querySelector('.lv-rc[data-ends]');
      return (slot.getAttribute('data-n') || '0') + '|' + (b ? b.getAttribute('data-ends') : '');
    }
    function tick() {
      var bs = p.querySelectorAll('.lv-rc[data-ends]'), anyDue = false;
      for (var i = 0; i < bs.length; i++) {
        var e = Date.parse(bs[i].getAttribute('data-ends'));
        if (isNaN(e)) continue;
        var s = Math.max(0, Math.ceil((e - (Date.now() + skew)) / 1000));
        var t = s > 0 ? Math.floor(s / 60) + ':' + (s % 60 < 10 ? '0' : '') + (s % 60) + ' left' : 'ending…';
        var el = bs[i].querySelector('.lv-rc-left');
        if (el && el.textContent !== t) el.textContent = t;
        if (s <= 0) { anyDue = true; bs[i].classList.add('is-due'); }
      }
      if (anyDue && !due) { due = true; schedule(2000); }
      if (!anyDue) due = false;
      if (!bs.length && ticker) { clearInterval(ticker); ticker = 0; }
    }
    function ensureTicker() {
      if (!ticker && p.querySelector('.lv-rc[data-ends]')) ticker = setInterval(function () { if (onScreen()) tick(); }, 1000);
    }
    function schedule(ms) { clearTimeout(timer); timer = setTimeout(refresh, ms); }
    function refresh() {
      timer = 0;
      if (!openSlots().length) return;                        // nothing open on the panel: stop
      if (!onScreen() || busy) { schedule(5000); return; }
      busy = true;
      fetch('/admin/panel?p=live', { credentials: 'same-origin', headers: { 'Accept': 'text/html' } })
        .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html'), fresh = {};
          if (!doc.querySelector('.lv-rcslot, #live-requests')) throw new Error('not the live panel');
          readSkew(doc);
          var fs = doc.querySelectorAll('.lv-rcslot[data-lvrc]');
          for (var i = 0; i < fs.length; i++) { var k = fs[i].getAttribute('data-lvrc'); if (!fresh[k]) fresh[k] = fs[i]; }
          var ss = openSlots();
          for (var j = 0; j < ss.length; j++) {
            var f = fresh[ss[j].getAttribute('data-lvrc')];
            if (!f) {
              ss[j].setAttribute('data-gone', '1');
              ss[j].innerHTML = '<span class="lv-rc is-ended" title="No longer live. Reload the panel to see how it ended.">'
                + '<i class="lv-rc-dot" aria-hidden="true"></i>ended</span>';
            } else if (sig(f) !== sig(ss[j])) {
              ss[j].setAttribute('data-n', f.getAttribute('data-n') || '0');
              ss[j].innerHTML = f.innerHTML;
            }
          }
          fails = 0;
        })
        .catch(function () { fails++; })
        .then(function () {
          busy = false; due = false;
          tick(); ensureTicker();
          if (openSlots().length) schedule(fails ? Math.min(60000, 5000 * Math.pow(2, fails)) : (p.querySelector('.lv-rc[data-ends]') ? 5000 : 20000));
        });
    }
    readSkew(p); tick(); ensureTicker();
    if (openSlots().length) schedule(p.querySelector('.lv-rc[data-ends]') ? 5000 : 20000);
  });

  /* ---- admin: spam cockpit ---------------------------------------------- */
  adminPanel('spam', function () {
    var panel = document.querySelector('.admin-panel[data-panel="spam"]');
    if (!panel) return;
    function dialPaint(d) {
      Object.keys(d).forEach(function (k) {
        panel.querySelectorAll('[data-dial="' + k + '"]').forEach(function (el) {
          el.textContent = Number(d[k] || 0).toLocaleString();
        });
      });
      var g = document.getElementById('cp-needle');
      if (g) g.style.setProperty('--lvl', d.level || 0);
      var lamp = document.getElementById('cp-lamp');
      if (lamp) lamp.className = 'cp-lamp ' + (d.level >= 60 ? 'red' : d.level >= 25 ? 'amber' : 'green');
    }
    var rescan = document.getElementById('spam-rescan');
    if (rescan) rescan.addEventListener('click', function () {
      rescan.disabled = true;
      fetch('/admin/spam/data?ajax=1', { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          dialPaint((d && d.overview) || {});
          var st = document.getElementById('spam-stamp');
          if (st) st.textContent = 'signals swept just now';
          toast('Signals swept');
        })
        .catch(function () { toast('Sweep failed'); })
        .finally(function () { rescan.disabled = false; });
    });
    panel.addEventListener('click', function (e) {
      var cl = e.target.closest ? e.target.closest('.js-spam-clear') : null;
      if (cl) {
        if (busyIs(cl)) return;
        var cuid = cl.getAttribute('data-uid'), cname = cl.getAttribute('data-name');
        busyUntil(cl, postJson('/admin/spam/clear', { user_id: cuid }, 15000).then(function (res) {
          if (!res || !res.ok) { toast('Could not clear'); return; }
          var crow = cl.closest('.cp-threat');
          if (crow) {
            crow.style.transition = 'opacity .3s ease';
            crow.style.opacity = '0';
            setTimeout(function () { crow.remove(); }, 320);
          }
          toast(cname + ' cleared, resurfaces in 14 days if signals persist');
        }).catch(function () { toast('Could not clear'); }));
        return;
      }
      var nk = e.target.closest ? e.target.closest('.js-spam-nuke') : null;
      if (nk) {
        var uid = nk.getAttribute('data-uid'), name = nk.getAttribute('data-name');
        var alsoIp = e.shiftKey;   // shift-click = scorched earth, block the IP too
        if (busyIs(nk)) return;
        if (!window.confirm('Nuke ' + name + '? Deletes ALL their content and bans the account' + (alsoIp ? ', and blocks their signup IP' : '') + '.')) return;
        // destructive + previously unguarded: a second tap mid-flight re-confirmed and re-nuked
        busyUntil(nk, postJson('/admin/spam/nuke', { user_id: uid, block_ip: alsoIp ? 1 : '' }, 15000).then(function (res) {
          if (!res || !res.ok) { toast((res && res.error) || 'Nuke failed'); return; }
          var row = nk.closest('.cp-threat');
          if (row) { row.style.transition = 'opacity .3s ease'; row.style.opacity = '.3'; }
          var act = nk.closest('.cp-threat-act');
          if (act) act.innerHTML = '<span class="cp-chip red">nuked + banned</span>';
          toast(name + ' nuked');
        }).catch(function () { toast('Nuke failed'); }));
        return;
      }
      var bl = e.target.closest ? e.target.closest('.js-spam-blockip') : null;
      if (bl) {
        if (busyIs(bl)) return;
        var blocked = false;
        busyUntil(bl, postJson('/admin/spam/block-ip', { ip: bl.getAttribute('data-ip') }, 15000).then(function (res) {
          if (res && res.ok) { blocked = true; bl.textContent = 'Blocked'; toast('IP blocked'); }
          else { toast((res && res.error) || 'Could not block'); }
        }).catch(function () { toast('Could not block'); })).then(function () { if (blocked) bl.disabled = true; });
        return;
      }
      var ub = e.target.closest ? e.target.closest('.js-spam-unblockip') : null;
      if (ub) {
        if (busyIs(ub)) return;
        busyUntil(ub, postJson('/admin/spam/unblock-ip', { ip: ub.getAttribute('data-ip') }, 15000).then(function () {
          var row = ub.closest('.cp-row');
          if (row) row.remove();
          toast('IP unblocked');
        }).catch(function () { toast('Could not unblock'); }));
      }
    });
    var bf = document.getElementById('spam-block-form');
    if (bf) bf.addEventListener('submit', function (e) {
      e.preventDefault();
      var ip = document.getElementById('spam-block-ip').value.trim();
      if (!ip) return;
      var bfBtn = bf.querySelector('button[type="submit"], button:not([type])');
      if (busyIs(bfBtn)) return;
      busyUntil(bfBtn, postJson('/admin/spam/block-ip', { ip: ip, reason: document.getElementById('spam-block-reason').value.trim() }, 15000)
        .then(function (res) {
          if (res && res.ok) { toast('IP blocked'); setTimeout(function () { location.reload(); }, 500); }
          else { toast((res && res.error) || 'That does not look like a valid IP'); }
        }).catch(function () { toast('Could not block'); }));
    });
  });

  /* ---- admin: grouped section nav v3 (hash-routed) ----------------------- */
  /* 2026-09-29 (Rob: "outdated, overlaps, isn't optimal"). Markup + stacking contract: views/admin.php
     and rova.css "ADMIN NAV v3". >= 1024px it is a sidebar (collapsible to an icon rail, "/" or Ctrl/Cmd-K
     floats the full panel over the rail as a PEEK); below that a sticky BAR opens the same panel as a
     modal drawer (640-1023) or bottom sheet (< 640) with a scrim, the shared scroll lock, a focus trap,
     and close on scrim / Esc / pick / swipe. Routing is unchanged from v2: show(name) toggles
     .admin-panel.on (the lazy panels' MutationObservers key off that), #hash deep links, an in-card
     anchor (#disputes) opens its host panel, last tab in localStorage rova_admin_tab. Rail + closed
     groups persist per device in the rova_anav cookie so the SERVER renders the remembered shape. */
  (function () {
    var nav = document.getElementById('admin-nav');
    if (!nav) return;
    var shell = document.getElementById('admin-shell') || nav.parentNode;
    var sheet = document.getElementById('anav-panel');
    var bar = document.getElementById('anav-bar');
    var scrim = document.getElementById('anav-scrim');
    var q = document.getElementById('anav-q');
    var list = document.getElementById('anav-list');
    var empty = document.getElementById('anav-empty');
    var railBtn = document.getElementById('anav-collapse');
    var findBtn = document.getElementById('anav-search-btn');
    var closeBtn = document.getElementById('anav-close');
    var panels = document.querySelectorAll('.admin-panel');
    // in-card deep links (/admin#disputes) whose element lives in a panel that has not loaded yet
    var anchors = {};
    try { anchors = JSON.parse(shell.getAttribute('data-anchors') || '{}') || {}; } catch (e) {}
    var pendingAnchor = '';
    var items = nav.querySelectorAll('.anav-item');
    var groups = nav.querySelectorAll('.anav-group[data-group]');
    var each = function (l, fn) { Array.prototype.forEach.call(l, fn); };
    var mm = function (s) { return window.matchMedia ? window.matchMedia(s) : { matches: false }; };
    var mqDesk = mm('(min-width:1024px)'), mqSheet = mm('(max-width:639px)');
    var isOpen = false, returnFocus = null;
    // what the reader CHOSE to close (auto-opening the active item's group must never be remembered)
    var closedPref = {};
    each(groups, function (g) { if (g.classList.contains('is-closed')) closedPref[g.getAttribute('data-group')] = 1; });

    function modal() { return !mqDesk.matches; }
    function railed() { return mqDesk.matches && shell.classList.contains('anav-rail'); }
    function savePrefs() {
      var closed = [];
      each(groups, function (g) { var k = g.getAttribute('data-group'); if (closedPref[k]) closed.push(k); });
      var v = (shell.classList.contains('anav-rail') ? '1' : '0') + '_' + closed.join('.');
      try {
        document.cookie = 'rova_anav=' + v + ';path=/admin;max-age=31536000;samesite=Lax'
          + (location.protocol === 'https:' ? ';secure' : '');
      } catch (e) {}
    }
    function setGroup(g, closed) {
      g.classList.toggle('is-closed', closed);
      var h = g.querySelector('.anav-ghead');
      if (h) h.setAttribute('aria-expanded', closed ? 'false' : 'true');
    }
    function paintBar(name, item) {
      var nm = document.getElementById('anav-bar-name');
      var kk = document.getElementById('anav-bar-kicker');
      var ic = document.getElementById('anav-bar-ico');
      var label = name, group = 'Control panel', svg = null;
      if (item) {
        var l = item.querySelector('.anav-lbl'); if (l) label = l.textContent;
        var g = item.closest('.anav-group'), gn = g && g.querySelector('.anav-gname');
        if (gn) group = gn.textContent;
        svg = item.querySelector('.anav-ico svg');
      } else {
        // a panel with no nav row (#scrollperf): name it by its own heading
        var h2 = document.querySelector('.admin-panel[data-panel="' + name + '"] .apanel-head h2');
        if (h2) label = h2.textContent;
      }
      if (nm) nm.textContent = label;
      if (kk) kk.textContent = group;
      if (ic && svg) { ic.textContent = ''; ic.appendChild(svg.cloneNode(true)); }
    }
    function show(name) {
      // Two passes: an unknown name (e.g. an in-card anchor like #disputes riding
      // the hash) must leave the current panel alone, not blank every panel.
      var found = false;
      each(panels, function (p) { if (p.getAttribute('data-panel') === name) found = true; });
      if (!found) return false;
      each(panels, function (p) { p.classList.toggle('on', p.getAttribute('data-panel') === name); });
      var cur = null;
      each(items, function (b) {
        var on = b.getAttribute('data-panel') === name;
        b.classList.toggle('on', on);
        if (on) { b.setAttribute('aria-current', 'page'); cur = b; } else b.removeAttribute('aria-current');
      });
      if (cur) { var g = cur.closest('.anav-group[data-group]'); if (g && g.classList.contains('is-closed')) setGroup(g, false); }
      paintBar(name, cur);
      try { localStorage.setItem('rova_admin_tab', name); } catch (e) {}
      // the SERVER renders this panel with the page next time (a form POST's redirect back lands on it)
      try {
        document.cookie = 'rova_apanel=' + name + ';path=/admin;max-age=31536000;samesite=Lax'
          + (location.protocol === 'https:' ? ';secure' : '');
      } catch (e) {}
      each(panels, function (p) {
        if (p.getAttribute('data-panel') === name && p.hasAttribute('data-lazy')) loadPanel(p, name);
      });
      return true;
    }

    /* ---- lazy panels: fetch one panel's markup the first time it is shown ---- */
    function loadPanel(p, name) {
      var st = p.getAttribute('data-lazy');
      if (st === 'loading') return;
      p.setAttribute('data-lazy', 'loading');
      p.setAttribute('aria-busy', 'true');
      if (st === 'error') {
        p.innerHTML = '<div class="glass card apanel-lazy muted" role="status"><span class="apanel-spin" aria-hidden="true"></span>Loading&hellip;</div>';
      }
      // the page's own query (?fr=, ?fas=, ?tq=, ?tzoff=) is the panel's too: a full render would read it
      var qs = (location.search || '').replace(/^\?/, '').replace(/(^|&)p=[^&]*/g, '');
      fetch('/admin/panel?p=' + encodeURIComponent(name) + (qs ? '&' + qs.replace(/^&/, '') : ''),
            { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (html) {
          var t = document.createElement('template');
          t.innerHTML = html;
          var s = t.content.querySelector('section.admin-panel[data-panel="' + name + '"]');
          if (!s) throw new Error('no panel in the response');
          var on = p.classList.contains('on');
          Array.prototype.forEach.call(s.attributes, function (a) { if (a.name !== 'class') p.setAttribute(a.name, a.value); });
          p.className = s.className;
          if (on) p.classList.add('on');
          p.removeAttribute('data-lazy');
          p.removeAttribute('aria-busy');
          p.textContent = '';
          while (s.firstChild) p.appendChild(s.firstChild);
          adminPanel.ready(name, p);
          if (p.classList.contains('on')) {
            var it = null;
            each(items, function (b) { if (b.getAttribute('data-panel') === name) it = b; });
            paintBar(name, it);
          }
          if (pendingAnchor) {
            var el = document.getElementById(pendingAnchor);
            if (el && p.contains(el)) { pendingAnchor = ''; setTimeout(function () { el.scrollIntoView(); }, 0); }
          }
        })
        .catch(function () {
          p.setAttribute('data-lazy', 'error');
          p.removeAttribute('aria-busy');
          p.innerHTML = '<div class="glass card apanel-lazy" role="alert"><span>This section could not load.</span>'
            + '<button type="button" class="btn sm gold-ghost apanel-retry">Try again</button></div>';
        });
    }
    shell.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('.apanel-retry') : null;
      if (!b) return;
      var p = b.closest('.admin-panel');
      if (p) loadPanel(p, p.getAttribute('data-panel'));
    });
    // a hash that is not a panel: an element inside one (#disputes). Loaded -> open its panel and scroll;
    // not loaded yet -> the server's map names the panel, and the scroll happens when it lands.
    function goAnchor(h) {
      try {
        var target = document.getElementById(h);
        var host = target && target.closest ? target.closest('.admin-panel') : null;
        if (host && show(host.getAttribute('data-panel'))) {
          setTimeout(function () { target.scrollIntoView(); }, 0);
          return true;
        }
        if (!target && anchors[h]) { pendingAnchor = h; return show(anchors[h]); }
      } catch (e) {}
      return false;
    }

    /* ---- search ("Jump to...") ---- */
    function norm(s) { return String(s || '').toLowerCase().replace(/\s+/g, ' ').trim(); }
    function visibleItems() {
      return Array.prototype.filter.call(items, function (it) { return it.offsetParent !== null; });
    }
    function filter() {
      var v = norm(q && q.value), toks = v ? v.split(' ') : [], n = 0, hit = null, prefix = null;
      nav.classList.toggle('anav-searching', toks.length > 0);
      each(items, function (it) {
        var k = it.getAttribute('data-k') || '';
        var ok = toks.every(function (t) { return k.indexOf(t) !== -1; });
        it.parentNode.classList.toggle('anav-miss', !ok);
        it.classList.remove('is-hit');
        if (ok && toks.length) {
          n++; if (!hit) hit = it;
          var l = it.querySelector('.anav-lbl');
          if (!prefix && l && norm(l.textContent).indexOf(v) === 0) prefix = it;
        }
      });
      if (prefix) hit = prefix;
      if (hit) hit.classList.add('is-hit');
      each(nav.querySelectorAll('.anav-group'), function (g) {
        g.classList.toggle('anav-gmiss', toks.length > 0 && !g.querySelector('li:not(.anav-miss)'));
      });
      if (empty) empty.textContent = toks.length && !n ? 'No section matches “' + q.value.trim() + '”' : '';
    }
    function clearSearch() { if (q && q.value) { q.value = ''; filter(); } }

    /* ---- modal drawer / sheet (below 1024px) ---- */
    function setRole() {
      if (!sheet) return;
      if (modal()) { sheet.setAttribute('role', 'dialog'); sheet.setAttribute('aria-modal', 'true'); }
      else { sheet.removeAttribute('role'); sheet.removeAttribute('aria-modal'); }
    }
    function open(toSearch) {
      if (!modal() || !sheet) return;
      if (isOpen) { if (toSearch && q) q.focus(); return; }
      isOpen = true;
      returnFocus = document.activeElement;
      shell.classList.add('anav-open');
      if (bar) bar.setAttribute('aria-expanded', 'true');
      if (window.__rovaLockScroll) window.__rovaLockScroll();
      var on = list && list.querySelector('.anav-item.on');
      if (on) {   // centre the current section in the list
        list.scrollTop = 0;
        var lr = list.getBoundingClientRect(), or = on.getBoundingClientRect();
        var d = (or.top - lr.top) - (lr.height - or.height) / 2;
        if (d > 0) list.scrollTop = d;
      }
      // a TAP focuses the panel, not the field: the iPhone keyboard must not jump up over the list
      try { (toSearch && q ? q : sheet).focus({ preventScroll: true }); } catch (e) {}
    }
    function close(noFocus) {
      if (!isOpen) return;
      isOpen = false;
      shell.classList.remove('anav-open');
      if (bar) bar.setAttribute('aria-expanded', 'false');
      if (sheet) sheet.style.transform = '';
      if (scrim) scrim.style.opacity = '';
      if (window.__rovaUnlockScroll) window.__rovaUnlockScroll();
      clearSearch();
      var t = returnFocus;
      returnFocus = null;
      if (!noFocus) {
        if (!t || t === document.body || !document.contains(t) || (sheet && sheet.contains(t))) t = bar;
        try { t.focus({ preventScroll: true }); } catch (e) {}
      }
    }
    /* ---- desktop rail + peek ---- */
    function peek(on) {
      if (on && !railed()) return;
      shell.classList.toggle('anav-peek', !!on);
      if (on && q) { try { q.focus(); } catch (e) {} }
      if (!on) clearSearch();
    }
    function paintRail() {
      var r = railed();
      each(items, function (it) {
        var l = it.querySelector('.anav-lbl'), b = it.querySelector('.anav-badge');
        if (r && l) it.setAttribute('title', l.textContent + (b ? ' (' + b.textContent + ')' : ''));
        else it.removeAttribute('title');
      });
      each(nav.querySelectorAll('.anav-ghead'), function (h) { h.tabIndex = r ? -1 : 0; });
      if (findBtn) findBtn.tabIndex = r ? 0 : -1;
      if (railBtn) {
        var lab = shell.classList.contains('anav-rail') ? 'Expand sidebar' : 'Collapse sidebar';
        railBtn.setAttribute('aria-pressed', shell.classList.contains('anav-rail') ? 'true' : 'false');
        railBtn.setAttribute('aria-label', lab); railBtn.setAttribute('title', lab);
      }
    }
    function jump() {
      if (modal()) open(true);
      else if (railed()) peek(true);
      else if (q) { q.focus(); q.select(); }
    }
    function select(name) {
      if (!show(name)) return;
      try { history.replaceState(null, '', '#' + name); } catch (e) { location.hash = name; }
      if (isOpen) close();                 // unlock FIRST (it restores the old scroll), then go to the top
      if (shell.classList.contains('anav-peek')) peek(false);
      clearSearch();
      window.scrollTo(0, 0);
    }
    function activate(el) {
      if (!el) return;
      if (el.hasAttribute('data-panel')) select(el.getAttribute('data-panel'));
      else el.click();                     // Bug Fixer is a real link
    }

    /* ---- wiring ---- */
    if (bar) bar.addEventListener('click', function () { open(false); });
    if (scrim) scrim.addEventListener('click', function () { close(); });
    if (closeBtn) closeBtn.addEventListener('click', function () { close(); });
    if (findBtn) findBtn.addEventListener('click', function () { if (railed()) peek(true); else if (q) q.focus(); });
    if (railBtn) railBtn.addEventListener('click', function () {
      shell.classList.toggle('anav-rail');
      shell.classList.remove('anav-peek');
      clearSearch();
      paintRail(); savePrefs();
    });
    each(groups, function (g) {
      var h = g.querySelector('.anav-ghead');
      if (!h) return;
      h.addEventListener('click', function () {
        if (nav.classList.contains('anav-searching') || railed()) return;
        var closed = !g.classList.contains('is-closed');
        setGroup(g, closed);
        var k = g.getAttribute('data-group');
        if (closed) closedPref[k] = 1; else delete closedPref[k];
        savePrefs();
      });
    });
    if (list) list.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('.anav-item') : null;
      if (!b || !b.hasAttribute('data-panel')) return;   // links navigate normally
      e.preventDefault();
      select(b.getAttribute('data-panel'));
    });
    if (q) {
      q.addEventListener('input', filter);
      q.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') {
          var v = visibleItems(); if (!v.length) return;
          e.preventDefault();
          (list.querySelector('.anav-item.is-hit') || v[0]).focus();
        } else if (e.key === 'Enter') {
          e.preventDefault();
          var hit = list.querySelector('.anav-item.is-hit');
          if (hit) activate(hit);
        }
      });
    }
    // arrow keys walk the visible rows (group headers + sections); Up from the top returns to the field
    if (list) list.addEventListener('keydown', function (e) {
      var k = e.key;
      if (k !== 'ArrowDown' && k !== 'ArrowUp' && k !== 'Home' && k !== 'End') return;
      var rows = Array.prototype.filter.call(list.querySelectorAll('.anav-ghead, .anav-item'), function (el) {
        return el.offsetParent !== null && el.tabIndex !== -1 && getComputedStyle(el).pointerEvents !== 'none';
      });
      var i = rows.indexOf(document.activeElement);
      if (i < 0) return;
      e.preventDefault();
      var n = k === 'Home' ? 0 : k === 'End' ? rows.length - 1 : i + (k === 'ArrowDown' ? 1 : -1);
      if (n < 0) { if (q && q.offsetParent !== null) q.focus(); return; }
      rows[Math.min(n, rows.length - 1)].focus();
    });
    function focusables() {
      return Array.prototype.filter.call(sheet.querySelectorAll('button, input, a[href]'), function (el) {
        return !el.disabled && el.tabIndex !== -1 && el.offsetParent !== null;
      });
    }
    document.addEventListener('keydown', function (e) {
      var k = e.key;
      if ((k === 'k' || k === 'K') && (e.metaKey || e.ctrlKey) && !e.altKey && !e.shiftKey) { e.preventDefault(); jump(); return; }
      if (k === '/' && !e.metaKey && !e.ctrlKey && !e.altKey) {
        var t = e.target, tag = t && t.tagName;
        if (t && (t.isContentEditable || tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT')) return;
        e.preventDefault(); jump(); return;
      }
      if (k === 'Escape') {
        if (isOpen) { e.preventDefault(); if (q && q.value) { clearSearch(); q.focus(); } else close(); }
        else if (shell.classList.contains('anav-peek')) { e.preventDefault(); peek(false); if (findBtn) findBtn.focus(); }
        else if (q && document.activeElement === q) { clearSearch(); q.blur(); }
        return;
      }
      if (k === 'Tab' && isOpen && sheet) {      // focus trap
        var f = focusables(); if (!f.length) return;
        var a = document.activeElement, first = f[0], last = f[f.length - 1];
        if (e.shiftKey && (a === first || a === sheet || !sheet.contains(a))) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && (a === last || !sheet.contains(a))) { e.preventDefault(); first.focus(); }
      }
    });
    // a press anywhere outside closes (the header stays live ABOVE the scrim, so the avatar menu just works)
    document.addEventListener('pointerdown', function (e) {
      var t = e.target;
      if (isOpen && sheet && !sheet.contains(t) && t !== scrim && !(bar && bar.contains(t))) close(true);
      if (shell.classList.contains('anav-peek') && sheet && !sheet.contains(t)) peek(false);
    }, true);
    nav.addEventListener('focusout', function (e) {
      if (!shell.classList.contains('anav-peek')) return;
      var to = e.relatedTarget;
      if (to && sheet && !sheet.contains(to)) peek(false);
    });
    // swipe to dismiss: DOWN on the sheet (only from the list's top, so the list scrolls first), LEFT on the drawer
    var drag = null;
    if (sheet) {
      sheet.addEventListener('touchstart', function (e) {
        if (!isOpen || e.touches.length !== 1 || e.target === q) { drag = null; return; }
        var t = e.touches[0], sh = mqSheet.matches;
        if (sh && list && list.contains(e.target) && list.scrollTop > 0) { drag = null; return; }
        drag = { x: t.clientX, y: t.clientY, t: Date.now(), sh: sh, d: 0, live: false };
      }, { passive: true });
      sheet.addEventListener('touchmove', function (e) {
        if (!drag) return;
        var t = e.touches[0], dx = t.clientX - drag.x, dy = t.clientY - drag.y;
        var d = drag.sh ? dy : -dx, cross = Math.abs(drag.sh ? dx : dy);
        if (!drag.live) {
          if (Math.abs(d) < 8 && cross < 8) return;
          if (d <= 0 || cross > Math.abs(d)) { drag = null; return; }   // a scroll, not a dismiss
          drag.live = true; sheet.classList.add('anav-drag');
        }
        drag.d = Math.max(0, d);
        if (e.cancelable) e.preventDefault();
        sheet.style.transform = drag.sh ? 'translateY(' + drag.d + 'px)' : 'translateX(' + (-drag.d) + 'px)';
        if (scrim) scrim.style.opacity = String(Math.max(0, 1 - drag.d / Math.max(1, drag.sh ? sheet.offsetHeight : sheet.offsetWidth)));
      }, { passive: false });
      var endDrag = function () {
        var d = drag; drag = null;
        if (!d || !d.live) return;
        sheet.classList.remove('anav-drag');
        var size = d.sh ? sheet.offsetHeight : sheet.offsetWidth;
        var v = d.d / Math.max(1, Date.now() - d.t);
        if (d.d > Math.min(120, size * 0.3) || v > 0.6) close();
        else { sheet.style.transform = ''; if (scrim) scrim.style.opacity = ''; }
      };
      sheet.addEventListener('touchend', endDrag, { passive: true });
      sheet.addEventListener('touchcancel', endDrag, { passive: true });
    }
    var onMq = function () { if (!modal()) close(true); if (!railed()) shell.classList.remove('anav-peek'); setRole(); paintRail(); };
    if (mqDesk.addEventListener) mqDesk.addEventListener('change', onMq); else if (mqDesk.addListener) mqDesk.addListener(onMq);
    setRole(); paintRail();
    if (/Mac|iPhone|iPad/.test(navigator.platform || navigator.userAgent || '')) {
      each(nav.querySelectorAll('.anav-kmod'), function (k) { k.textContent = '⌘K'; });
    }

    window.addEventListener('hashchange', function () {
      var h = (location.hash || '').replace('#', '');
      if (h && !show(h)) goAnchor(h);
    });
    // initial tab: URL hash -> last used -> overview
    var hash = (location.hash || '').replace('#', '');
    var saved = '';
    try { saved = localStorage.getItem('rova_admin_tab') || ''; } catch (e) {}
    // Deep link to a card INSIDE a panel (e.g. /admin#disputes): the hash isn't a
    // panel name, so open the panel that contains that element, then scroll to it.
    if (!(hash && (show(hash) || goAnchor(hash))) && !(saved && show(saved))) show('overview');
  })();

  /* ---- admin: nudity filter test bench + threshold tuner ---------------- */
  adminPanel('safety', function () {
    var panel = document.getElementById('nudity-panel');
    if (!panel) return;
    var LEVELS = ['n/a', 'very unlikely', 'unlikely', 'possible', 'likely', 'very likely', 'off (allow all)'];
    try { LEVELS = JSON.parse(panel.getAttribute('data-levels') || '') || LEVELS; } catch (e) {}
    var configured = panel.getAttribute('data-configured') === '1';

    // ----- threshold sliders: live label + AJAX save -----
    function levelLabel(v) { return (LEVELS[v] || '').replace(/^\w/, function (c) { return c.toUpperCase(); }); }
    ['racy', 'adult'].forEach(function (key) {
      var slider = document.getElementById('nud-' + key);
      var out    = document.getElementById('nud-' + key + '-val');
      if (!slider || !out) return;
      var paint = function () { out.textContent = levelLabel(parseInt(slider.value, 10)); };
      paint();
      slider.addEventListener('input', paint);
    });
    var setForm = document.getElementById('nud-settings');
    var savedTag = document.getElementById('nud-saved');
    if (setForm) setForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var adult = (document.getElementById('nud-adult') || {}).value;
      var racy  = (document.getElementById('nud-racy')  || {}).value;
      var nsBtn = setForm.querySelector('button[type="submit"], button:not([type])');
      if (busyIs(nsBtn)) return;
      busyUntil(nsBtn, postJson('/admin/nudity/settings', { adult: adult, racy: racy }, 15000).then(function (res) {
        if (res && res.ok) {
          if (savedTag) { savedTag.hidden = false; setTimeout(function () { savedTag.hidden = true; }, 2200); }
          renderResult(lastGrade);   // re-grade the last test against the new cuts (if any)
        } else { toast('Could not save'); }
      }).catch(function () { toast('Could not save'); }));
    });

    // ----- file picker + drag/drop -----
    var drop   = document.getElementById('nud-drop');
    var file   = document.getElementById('nud-file');
    var empty  = document.getElementById('nud-drop-empty');
    var prev   = document.getElementById('nud-preview');
    var thumb  = document.getElementById('nud-thumb');
    var fname  = document.getElementById('nud-fname');
    var fkind  = document.getElementById('nud-fkind');
    var runBtn = document.getElementById('nud-run');
    var clrBtn = document.getElementById('nud-clear');
    var result = document.getElementById('nud-result');
    var errEl  = document.getElementById('nud-err');
    var chosen = null, lastObjUrl = null, lastGrade = null;

    function clearThumb() { if (lastObjUrl) { try { URL.revokeObjectURL(lastObjUrl); } catch (e) {} lastObjUrl = null; } }
    function reset() {
      chosen = null; lastGrade = null;
      clearThumb();
      if (file) file.value = '';
      if (prev) prev.hidden = true; if (empty) empty.hidden = false;
      if (thumb) { thumb.removeAttribute('src'); thumb.hidden = false; }
      if (runBtn) runBtn.disabled = true;
      if (clrBtn) clrBtn.hidden = true;
      if (result) result.hidden = true;
      if (errEl) errEl.hidden = true;
    }
    function pick(f) {
      if (!f) return;
      chosen = f;
      var isVid = /^video\//.test(f.type) || /\.(mp4|mov|webm|m4v|3gp|avi|mkv)$/i.test(f.name);
      clearThumb();
      if (empty) empty.hidden = true; if (prev) prev.hidden = false;
      if (fname) fname.textContent = f.name;
      if (fkind) fkind.textContent = isVid ? 'video · one frame is sampled' : 'image';
      if (thumb) {
        if (isVid) { thumb.hidden = true; }
        else { lastObjUrl = URL.createObjectURL(f); thumb.hidden = false; thumb.src = lastObjUrl; }
      }
      if (runBtn) runBtn.disabled = !configured;
      if (clrBtn) clrBtn.hidden = false;
      if (result) result.hidden = true;
      if (errEl) errEl.hidden = configured;
      if (errEl && !configured) errEl.textContent = 'Set GOOGLE_VISION_KEY to run a live scan.';
    }
    if (drop) {
      drop.addEventListener('click', function (e) { if (e.target.closest('.nud-preview') && chosen) return; if (file) file.click(); });
      drop.addEventListener('keydown', function (e) { if ((e.key === 'Enter' || e.key === ' ') && file) { e.preventDefault(); file.click(); } });
      ['dragover', 'dragenter'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('drag'); }); });
      ['dragleave', 'dragend', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function () { drop.classList.remove('drag'); }); });
      drop.addEventListener('drop', function (e) { e.preventDefault(); var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]; if (f) pick(f); });
    }
    if (file) file.addEventListener('change', function () { if (file.files && file.files[0]) pick(file.files[0]); });
    if (clrBtn) clrBtn.addEventListener('click', reset);

    // ----- run the scan -----
    if (runBtn) runBtn.addEventListener('click', function () {
      if (!chosen || runBtn.disabled) return;
      runBtn.disabled = true; runBtn.textContent = 'Scanning…';
      if (errEl) errEl.hidden = true;
      var fd = new FormData(); fd.append('file', chosen);
      fetch(ajaxUrl('/admin/nudity/test'), {
        method: 'POST',
        headers: { 'X-CSRF-Token': csrf, 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
        body: fd, credentials: 'same-origin'
      }).then(function (r) { return r.json(); }).then(function (res) {
        runBtn.disabled = false; runBtn.textContent = 'Scan it';
        if (!res || !res.ok) {
          if (errEl) { errEl.textContent = (res && res.error) || 'Scan failed, try again.'; errEl.hidden = false; }
          if (result) result.hidden = true;
          return;
        }
        lastGrade = res;
        renderResult(res);
      }).catch(function () {
        runBtn.disabled = false; runBtn.textContent = 'Scan it';
        if (errEl) { errEl.textContent = 'Scan failed (network or server error).'; errEl.hidden = false; }
      });
    });

    // ----- render the grade card. Re-reads the sliders so "what if" tuning updates the verdict live. -----
    var ORDER = ['racy', 'adult', 'medical', 'violence', 'spoof'];
    var NICE  = { racy: 'Racy / suggestive', adult: 'Explicit (adult)', medical: 'Medical', violence: 'Violence', spoof: 'Spoof / meme' };
    function renderResult(res) {
      if (!res || !res.levels || !result) return;
      var bars = document.getElementById('nud-bars');
      var verdictEl = document.getElementById('nud-verdict');
      var noteEl = document.getElementById('nud-note');
      // current slider positions (so saving isn't required to preview a threshold change)
      var tAdult = parseInt((document.getElementById('nud-adult') || {}).value, 10) || res.thresholds.adult;
      var tRacy  = parseInt((document.getElementById('nud-racy')  || {}).value, 10) || res.thresholds.racy;
      var lv = res.levels;
      var hidden = (lv.adult || 0) >= tAdult || (lv.racy || 0) >= tRacy;

      if (bars) {
        bars.innerHTML = ORDER.map(function (cat) {
          var val = lv[cat] || 0, pct = Math.round(val / 5 * 100);
          var tone = val >= 4 ? 'hot' : (val >= 3 ? 'warm' : 'cool');
          var cut = (cat === 'adult') ? tAdult : (cat === 'racy' ? tRacy : 0);
          var cutMark = (cut && cut <= 5) ? '<i class="nud-cut" style="left:' + Math.round((cut - 0.5) / 5 * 100) + '%" title="hide at ' + LEVELS[cut] + '"></i>' : '';   // Off (6): no cut, nothing hides
          return '<div class="nud-bar-row">' +
            '<span class="nud-bar-name">' + NICE[cat] + '</span>' +
            '<span class="nud-bar-track"><i class="nud-bar-fill ' + tone + '" style="width:' + pct + '%"></i>' + cutMark + '</span>' +
            '<span class="nud-bar-lvl">' + (LEVELS[val] || '') + '</span></div>';
        }).join('');
      }
      if (verdictEl) {
        verdictEl.className = 'nud-verdict ' + (hidden ? 'is-hidden' : 'is-ok');
        verdictEl.textContent = hidden ? 'Would be HIDDEN by your filter' : 'Would be ALLOWED through';
      }
      if (noteEl) {
        var why = [];
        if ((lv.adult || 0) >= tAdult) why.push('adult is ' + LEVELS[lv.adult] + ' (cut: ' + LEVELS[tAdult] + ')');
        if ((lv.racy  || 0) >= tRacy)  why.push('racy is ' + LEVELS[lv.racy] + ' (cut: ' + LEVELS[tRacy] + ')');
        noteEl.textContent = res.kind === 'video'
          ? 'Sampled one frame from the video. ' + (why.length ? 'Hidden because ' + why.join(' and ') + '.' : 'Under both cuts.')
          : (why.length ? 'Hidden because ' + why.join(' and ') + '.' : 'Under both cuts, it stays visible.');
      }
      result.hidden = false;
    }

    // live "what if": dragging a slider re-grades the last scan without re-uploading
    ['nud-adult', 'nud-racy'].forEach(function (id) {
      var s = document.getElementById(id);
      if (s) s.addEventListener('input', function () { if (lastGrade) renderResult(lastGrade); });
    });
  });

  /* ---- admin: live billing-activity poll -------------------------------- */
  adminPanel('billing', function () {
    var card = document.getElementById('billing-activity');
    if (!card) return;
    var url  = card.getAttribute('data-poll');
    var body = document.getElementById('billing-activity-body');
    var panel = document.querySelector('.admin-panel[data-panel="billing"]');
    if (!url || !body || !panel) return;
    var busy = false;
    // only fetch while the Billing panel is the visible one AND the tab is in the foreground
    function active() { return panel.classList.contains('on') && !document.hidden; }
    function poll() {
      if (busy || !active()) return;
      busy = true;
      fetch(url + (url.indexOf('?') === -1 ? '?' : '&') + 'ajax=1',
            { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (html == null) return;
          // the stat numbers are the "did real billing happen" signal; the log's relative times ("2m
          // ago") drift every poll, so compare only the stats to decide whether to flash.
          function stats() { var el = body.querySelector('.ap-stats'); return el ? el.textContent.replace(/\s+/g, '') : ''; }
          var before = stats();
          var logEl = body.querySelector('.ap-log'); var keepScroll = logEl ? logEl.scrollTop : 0;   // don't yank the log back to top mid-read
          body.innerHTML = html;                                // always refresh (keeps the log + times current)
          if (keepScroll) { var logEl2 = body.querySelector('.ap-log'); if (logEl2) logEl2.scrollTop = keepScroll; }
          if (before && stats() && stats() !== before) {
            card.classList.remove('ba-flash'); void card.offsetWidth; card.classList.add('ba-flash');
          }
        })
        .catch(function () {})
        .then(function () { busy = false; });
    }
    setInterval(poll, 20000);                                    // billing is webhook-driven, ~20s is plenty
    document.addEventListener('visibilitychange', function () { if (!document.hidden) poll(); });
    // refresh the moment the operator switches to the Billing panel
    try {
      new MutationObserver(function () { if (active()) poll(); })
        .observe(panel, { attributes: true, attributeFilter: ['class'] });
    } catch (e) {}
    if (active()) poll();
  });

  /* ---- admin: live Subscriptions poll (mirrors the billing-activity poll) ---- */
  adminPanel('billing', function () {
    var card  = document.getElementById('admin-subs');
    var body  = document.getElementById('admin-subs-body');
    var panel = document.querySelector('.admin-panel[data-panel="billing"]');
    if (!card || !body || !panel) return;
    var url = card.getAttribute('data-poll'); if (!url) return;
    var busy = false;
    function active() { return panel.classList.contains('on') && !document.hidden; }   // Billing panel visible + tab foreground
    function poll() {
      if (busy || !active()) return;
      busy = true;
      fetch(url + (url.indexOf('?') === -1 ? '?' : '&') + 'ajax=1',
            { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) { if (html != null) body.innerHTML = html; })
        .catch(function () {})
        .then(function () { busy = false; });
    }
    setInterval(poll, 20000);                                    // webhook-driven, ~20s is plenty
    document.addEventListener('visibilitychange', function () { if (!document.hidden) poll(); });
    try { new MutationObserver(function () { if (active()) poll(); }).observe(panel, { attributes: true, attributeFilter: ['class'] }); } catch (e) {}
    if (active()) poll();
  });

  /* ---- admin: referral analytics (live poll + referral-tree drill-down) -- */
  adminPanel('referrals', function () {
    var card = document.getElementById('referral-analytics');
    if (!card) return;
    var url   = card.getAttribute('data-poll');
    var body  = document.getElementById('referral-analytics-body');
    var panel = document.querySelector('.admin-panel[data-panel="referrals"]');
    if (!url || !body || !panel) return;
    var busy = false, topN = 25, histN = 40;   // page sizes, grown by "Load more"; the poll keeps the current size
    var topSort = 'subs', topQ = '', refocusQ = false;   // leaderboard sort + filter, threaded through the poll
    function active()   { return panel.classList.contains('on') && !document.hidden; }
    function treeOpen() { return !!body.querySelector('.rf-tree.open'); }   // never yank an expanded tree
    function qFocused() { var qi = document.getElementById('rf-top-q'); return !!(qi && document.activeElement === qi); }
    function poll(force) {
      // a background refresh must never yank an open tree, nor steal focus mid-filter-type
      if (busy || !active() || (!force && (treeOpen() || qFocused()))) return;
      busy = true;
      fetch(url + (url.indexOf('?') === -1 ? '?' : '&') + 'top=' + topN + '&history=' + histN +
              '&sort=' + encodeURIComponent(topSort) + '&q=' + encodeURIComponent(topQ) + '&ajax=1',
            { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (html == null) return;
          body.innerHTML = html;
          if (refocusQ) {   // filter-triggered refresh replaced the input -- put the cursor back at the end
            refocusQ = false;
            var qi = document.getElementById('rf-top-q');
            if (qi) { qi.focus(); var v = qi.value; qi.value = ''; qi.value = v; }
          }
        })
        .catch(function () {})
        .then(function () { busy = false; });
    }
    // referral numbers move on the scale of signups, not seconds; a gentle poll keeps them fresh
    setInterval(poll, 45000);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) poll(); });
    try {
      new MutationObserver(function () { if (active()) poll(); })
        .observe(panel, { attributes: true, attributeFilter: ['class'] });
    } catch (e) {}

    // Drill-down: tap a referrer row to load + toggle their referral tree inline. Delegated off the body
    // so it keeps working after a poll swaps the innerHTML. `.rf-ref` is a div[role=button] rather than a
    // real <button> because it now wraps a real <a class="rf-who"> (avatar + name) that navigates straight
    // to the admin member page -- an <a> is not valid content inside a <button>, and nesting one there
    // anyway makes the link unreachable to a screen reader and unreliable to click. So the toggle is
    // driven by hand for both mouse and keyboard, exactly the activation a native button would have given
    // us, and it steps aside whenever the actual target is the link.
    function refTreeToggle(row) {
      var id   = row.getAttribute('data-ref-id');
      var tree = document.getElementById('rf-tree-' + id);
      if (!tree) return;
      if (tree.classList.contains('open')) {                 // collapse
        tree.classList.remove('open'); tree.hidden = true; row.setAttribute('aria-expanded', 'false');
        return;
      }
      row.setAttribute('aria-expanded', 'true');
      tree.hidden = false; tree.classList.add('open');
      if (tree.getAttribute('data-loaded') === '1') return;  // fetched once, keep it
      tree.innerHTML = '<div class="rft-spin muted">Loading tree…</div>';
      fetch('/admin/referrals/tree?id=' + encodeURIComponent(id),
            { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (html != null) { tree.innerHTML = html; tree.setAttribute('data-loaded', '1'); }
          else { tree.innerHTML = '<div class="rft-spin muted">Couldn\'t load that tree.</div>'; }
        })
        .catch(function () { tree.innerHTML = '<div class="rft-spin muted">Couldn\'t load that tree.</div>'; });
    }
    body.addEventListener('click', function (e) {
      // sort the leaderboard: flip the active key and re-fetch (server-side, so it re-ranks EVERY
      // referrer, not just the loaded page).
      var sb = e.target.closest ? e.target.closest('.rf-sort') : null;
      if (sb && body.contains(sb)) {
        var k = sb.getAttribute('data-sort') || 'subs';
        if (k !== topSort) { topSort = k; poll(true); }
        return;
      }
      // "Load more": grow the requested page size and re-fetch (force past the tree guard -- an explicit
      // action). The poll then keeps rendering that many, so the longer list stays put on the next refresh.
      var more = e.target.closest ? e.target.closest('.rf-loadmore') : null;
      if (more && body.contains(more)) {
        if (more.getAttribute('data-kind') === 'top') { topN += 25; } else { histN += 40; }
        more.textContent = 'Loading…'; more.disabled = true;
        poll(true);
        return;
      }
      // tapped the avatar/name link (.rf-who): let it navigate to the admin member page, don't toggle
      if (e.target.closest && e.target.closest('.rf-who')) return;
      var row = e.target.closest ? e.target.closest('.rf-ref') : null;
      if (!row || !body.contains(row)) return;
      refTreeToggle(row);
    });
    // keyboard parity for the div[role=button] row: Enter/Space toggles, same as a real button would.
    body.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
      if (e.target.closest && e.target.closest('.rf-who')) return;   // the link handles its own Enter
      var row = e.target.closest ? e.target.closest('.rf-ref') : null;
      if (!row || !body.contains(row) || e.target !== row) return;   // only the row itself, not a child
      e.preventDefault();
      refTreeToggle(row);
    });

    // filter by name/@handle: debounce a bit so we search on pause, not on every keystroke
    var qDeb = null;
    body.addEventListener('input', function (e) {
      var qi = e.target && e.target.id === 'rf-top-q' ? e.target : null;
      if (!qi) return;
      topQ = qi.value.trim();
      if (qDeb) clearTimeout(qDeb);
      qDeb = setTimeout(function () { refocusQ = true; poll(true); }, 320);
    });

    if (active()) poll();
  });


  /* ---- admin Auto-grant Founder panel: sort + page WITHOUT a page load ------------------------
     /admin renders all 18 panels in one ~3.8MB, ~1.2s response, so refetching the lot to reorder a
     table is absurd (owner, 2026-09-14). This intercepts the two preset links, every column header and
     every pager link, fetches ONLY this panel's table from /admin/founders/autosignup, and swaps it in.

     THE SORT IS THE SERVER'S. An earlier cut ranked the rows in JavaScript. That was instant and, once
     the table started paging over 600+ grants, WRONG: a client can only reorder the rows it is holding,
     and those are 50 of 609, so "sorted by Brought in" meant "the best of this page". The server ranks
     the whole cohort and returns the page; the client's only job is to put it on screen without a
     navigation. That also leaves exactly ONE implementation of the ordering, the headers, the carets,
     aria-sort and the pager -- in views/_admin_founders_autosignup.php -- so nothing here can drift
     away from what a reload would render.

     PROGRESSIVE ENHANCEMENT, not replacement: every control is a real link to a real server-rendered
     URL. Every early return below, and every failure of the fetch, leaves the click alone so the
     navigation happens and the admin still gets the right answer.
     Delegated on document so it survives an AJAX panel swap, like .js-ftree below. ---- */
  (function () {
    var seq = 0;

    /** The pretty /admin URL a control points at -> the fragment URL that renders just that table. */
    function fragUrl(href) {
      var u;
      try { u = new URL(href, window.location.origin); } catch (e) { return null; }
      if (u.pathname !== '/admin') { return null; }
      var q = new URLSearchParams();
      ['fas', 'fasd', 'fasp'].forEach(function (k) {
        var v = u.searchParams.get(k);
        if (v !== null && v !== '') { q.set(k, v); }
      });
      var s = q.toString();
      return '/admin/founders/autosignup' + (s ? '?' + s : '');
    }

    /** Keep the address bar honest: same params the link carries, other params (tzoff) preserved. */
    function pushUrl(href) {
      try {
        if (!window.history || !history.replaceState) { return; }
        var from = new URL(href, window.location.origin);
        var to   = new URL(window.location.href);
        ['fas', 'fasd', 'fasp'].forEach(function (k) {
          var v = from.searchParams.get(k);
          if (v === null || v === '') { to.searchParams.delete(k); } else { to.searchParams.set(k, v); }
        });
        if (!to.hash) { to.hash = 'founders'; }
        history.replaceState(null, '', to.pathname + to.search + to.hash);
      } catch (err) { /* a URL we cannot rewrite is not a reason to leave the table unswapped */ }
    }

    function load(href) {
      var wrap = document.getElementById('fas-wrap');
      var url  = fragUrl(href);
      if (!wrap || !url || !window.fetch) { return false; }
      var mine = ++seq;
      wrap.setAttribute('aria-busy', 'true');
      wrap.style.opacity = '.55';
      fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' },
                   credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (mine !== seq) { return; }               // a later click already won; drop this answer
          wrap.setAttribute('aria-busy', 'false');
          wrap.style.opacity = '';
          if (html == null) { window.location.href = href; return; }   // fall back to the real link
          /* One assignment: the rows leave and arrive in a single layout pass, so there is no flash and
             no half-swapped paint. The sticky header and the scroll box come back with the fragment. */
          wrap.innerHTML = html;
          pushUrl(href);
          syncPreset();
        })
        .catch(function () {
          if (mine !== seq) { return; }
          wrap.setAttribute('aria-busy', 'false');
          wrap.style.opacity = '';
          window.location.href = href;                 // network died: let the browser do it properly
        });
      return true;
    }

    /* The preset control lives OUTSIDE the swapped fragment (it is a property of the cohort, not the
       page), so it has to be told what the new table is sorted by. It shows a preset as chosen only
       when the table really is in that ordering, and its third state says "neither" otherwise. */
    function syncPreset() {
      var box = document.getElementById('fas-sort');
      var th  = document.querySelector('#fas-wrap thead th[aria-sort]:not([aria-sort="none"])');
      if (!box) { return; }
      var col = th ? th.getAttribute('data-fascol') : 'natural';
      var dir = th ? (th.getAttribute('aria-sort') === 'ascending' ? 'asc' : 'desc') : 'asc';
      var mode = (col === 'brought' && dir === 'desc') ? 'active' : (!th ? 'newest' : 'other');
      var views = box.querySelectorAll('[data-fas-view]');
      for (var i = 0; i < views.length; i++) {
        views[i].style.display = (views[i].getAttribute('data-fas-view') === mode) ? '' : 'none';
      }
      box.setAttribute('data-fas-cur', mode);
      box.setAttribute('data-fas-col', col);
      box.setAttribute('data-fas-dir', dir);
      box.setAttribute('data-fas-page', String(currentPage()));
    }
    /** Which page is on screen. Read from the URL, which pushUrl() has already made match the table --
     *  never scraped from the pager's "Page N of M" text, which is copy and can change. */
    function currentPage() {
      try {
        var p = parseInt(new URL(window.location.href).searchParams.get('fasp') || '1', 10);
        return (isNaN(p) || p < 1) ? 1 : p;
      } catch (e) { return 1; }
    }

    function ctl(e) {
      return e.target && e.target.closest
        ? e.target.closest('.js-fassort-col, .js-fassort, .js-faspage') : null;
    }

    document.addEventListener('click', function (e) {
      var a = ctl(e); if (!a) { return; }
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button > 0) { return; }  // open-in-new-tab
      var href = a.getAttribute('href'); if (!href) { return; }
      if (load(href)) { e.preventDefault(); }   // only swallow the click if we took the work on
    });

    /* A link is Enter-activated natively but NOT Space; an admin driving this table from the keyboard
       expects both, and Space would otherwise scroll the page. */
    document.addEventListener('keydown', function (e) {
      if (e.key !== ' ' && e.key !== 'Spacebar' && e.keyCode !== 32) { return; }
      var a = ctl(e); if (!a) { return; }
      e.preventDefault();
      var href = a.getAttribute('href');
      if (href && !load(href)) { window.location.href = href; }
    });
  })();

  /* ---- admin Founders tab: expand a founder's referral family tree inline (reuses the referrals-tree
     endpoint). Delegated on document so it works inside the AJAX-swapped admin panels. ---- */
  (function () {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('.js-ftree') : null;
      if (!btn) return;
      e.preventDefault();
      var id = btn.getAttribute('data-uid'); if (!id) return;
      var tree = document.getElementById('ftree-' + id); if (!tree) return;
      if (tree.classList.contains('open')) {                 // collapse
        tree.classList.remove('open'); tree.hidden = true; btn.setAttribute('aria-expanded', 'false');
        return;
      }
      btn.setAttribute('aria-expanded', 'true');
      tree.hidden = false; tree.classList.add('open');
      if (tree.getAttribute('data-loaded') === '1') return;
      tree.innerHTML = '<div class="rft-spin muted">Loading tree…</div>';
      fetch('/admin/referrals/tree?id=' + encodeURIComponent(id),
            { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (html != null) { tree.innerHTML = html; tree.setAttribute('data-loaded', '1'); }
          else { tree.innerHTML = '<div class="rft-spin muted">Couldn\'t load that tree.</div>'; }
        })
        .catch(function () { tree.innerHTML = '<div class="rft-spin muted">Couldn\'t load that tree.</div>'; });
    });
  })();

  /* ---- admin "Enroll a Founder": live member typeahead so the handle is always exact ---- */
  adminPanel('founders', function () {
    var input = document.getElementById('fenroll-q');
    var box   = document.getElementById('fenroll-results');
    if (!input || !box) return;
    var timer = null, seq = 0, items = [], active = -1, lastQ = '';

    function close() {
      box.hidden = true; box.innerHTML = ''; items = []; active = -1;
      input.setAttribute('aria-expanded', 'false');
    }
    function pick(i) {
      var it = items[i]; if (!it) return;
      input.value = '@' + it.username;
      lastQ = input.value;                                  // don't immediately re-search what we just filled
      close(); input.focus();
    }
    function highlight() {
      Array.prototype.forEach.call(box.children, function (el, i) {
        el.classList.toggle('on', i === active);
        el.setAttribute('aria-selected', i === active ? 'true' : 'false');
      });
    }
    function render(users) {
      items = users || [];
      if (!items.length) {
        box.innerHTML = '<div class="fen-none muted">No members match that.</div>';
        box.hidden = false; input.setAttribute('aria-expanded', 'true'); active = -1;
        return;
      }
      box.innerHTML = items.map(function (u, i) {
        var av = u.avatar
          ? '<img class="fen-av" src="' + esc(u.avatar) + '" alt="" decoding="async">'
          // `u.name` is /admin/user-lookup's display name (already `display_name ?: username`), and
          // it is the name this very row prints two lines down -- so the monogram beside it has to
          // be ITS letter, not the handle's. Shared nameInitial(), the mirror of NameText::initial().
          : '<span class="fen-av fen-av-i">' + esc(nameInitial(u.name, u.username)) + '</span>';
        return '<div class="fen-row" role="option" aria-selected="false" data-i="' + i + '">' + av +
               '<span class="fen-body"><span class="fen-name">' + esc(u.name) +
               (u.founder ? ' <span class="fen-tag">founder</span>' : '') + '</span>' +
               '<span class="fen-sub muted">@' + esc(u.username) +
               (u.email ? ' · ' + esc(u.email) : '') + '</span></span></div>';
      }).join('');
      active = -1; box.hidden = false; input.setAttribute('aria-expanded', 'true');
    }
    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function search() {
      var q = input.value.trim().replace(/^@/, '');
      if (q.length < 2) { close(); return; }
      var mine = ++seq;
      fetch('/admin/user-lookup?q=' + encodeURIComponent(q),
            { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) { if (mine === seq && d) render(d.users); })
        .catch(function () { if (mine === seq) close(); });
    }

    input.addEventListener('input', function () {
      if (input.value === lastQ) return;
      lastQ = input.value;
      clearTimeout(timer); timer = setTimeout(search, 160);   // debounce: one request per pause, not per keystroke
    });
    input.addEventListener('keydown', function (e) {
      if (box.hidden || !items.length) return;
      if (e.key === 'ArrowDown')      { e.preventDefault(); active = (active + 1) % items.length; highlight(); }
      else if (e.key === 'ArrowUp')   { e.preventDefault(); active = (active - 1 + items.length) % items.length; highlight(); }
      else if (e.key === 'Enter' && active >= 0) { e.preventDefault(); pick(active); }
      else if (e.key === 'Escape')    { close(); }
    });
    // mousedown, not click: blur would close the list before a click could land on it
    box.addEventListener('mousedown', function (e) {
      var row = e.target.closest ? e.target.closest('.fen-row') : null;
      if (!row) return;
      e.preventDefault(); pick(parseInt(row.getAttribute('data-i'), 10));
    });
    input.addEventListener('blur', function () { setTimeout(close, 120); });
    input.addEventListener('focus', function () { if (input.value.trim().length >= 2 && !items.length) search(); });

    // the admin dashboard takes ~2s to render, so Enroll looks dead and gets clicked twice
    // (two real POSTs -> two identical flash messages). Lock the form after the first submit.
    var form = input.form, sending = false;
    if (form) {
      form.addEventListener('submit', function (e) {
        if (sending) { e.preventDefault(); return; }
        sending = true;
        var btn = form.querySelector('button[type=submit]');
        if (btn) { setTimeout(function () { btn.disabled = true; btn.textContent = 'Enrolling…'; }, 0); }
      });
    }
  });

  /* ---- admin Founders: TYPE-TO-SEARCH PICKERS (2026-09-29) --------------------------------------
     Replaced two <datalist>s that listed every Founder (~2,700 <option>s, ~49 KB of every Founders
     panel load). Any input[data-apick="founders|active"] asks GET /admin/user-lookup?scope=... as you
     type (2+ characters, @ optional; handle, display name or email). A pick writes the BARE handle into
     the input -- exactly the value a datalist option used to put there -- so the form posts the same
     `who` / `sponsor` it always did, and typing without picking still submits what was typed.
     Keyboard: ArrowDown/ArrowUp move (ArrowDown also opens), Enter picks the highlighted row (and only
     then stops the submit), Escape closes, Tab leaves. ARIA: combobox + listbox + aria-activedescendant. */
  adminPanel('founders', function () {
    Array.prototype.forEach.call(document.querySelectorAll('input[data-apick]'), function (input) {
      if (input.getAttribute('data-apick-on') === '1') return;          // bound once per element
      var box = document.getElementById(input.getAttribute('aria-controls') || '');
      if (!box) return;
      input.setAttribute('data-apick-on', '1');
      var scope = input.getAttribute('data-apick') || '';
      var timer = null, seq = 0, items = [], active = -1, lastQ = input.value;

      function esc(s) {
        return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
          return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
      }
      function close() {
        clearTimeout(timer); seq++;                                      // a late answer must not reopen it
        box.hidden = true; box.innerHTML = ''; items = []; active = -1;
        input.setAttribute('aria-expanded', 'false'); input.removeAttribute('aria-activedescendant');
      }
      function highlight() {
        Array.prototype.forEach.call(box.children, function (el, i) {
          el.classList.toggle('on', i === active);
          el.setAttribute('aria-selected', i === active ? 'true' : 'false');
        });
        var cur = active >= 0 ? box.children[active] : null;
        if (cur && cur.id) {
          input.setAttribute('aria-activedescendant', cur.id);
          if (cur.scrollIntoView) cur.scrollIntoView({ block: 'nearest' });
        } else { input.removeAttribute('aria-activedescendant'); }
      }
      function pick(i) {
        var it = items[i]; if (!it) return;
        input.value = it.username;                                       // bare handle: the datalist's value
        lastQ = input.value;
        close(); input.focus();
      }
      function render(users) {
        items = users || []; active = -1;
        if (!items.length) {
          box.innerHTML = '<div class="fen-none muted" role="option" aria-disabled="true">No ' +
            (scope === 'active' ? 'active Founder' : 'Founder') + ' matches that.</div>';
        } else {
          box.innerHTML = items.map(function (u, i) {
            var av = u.avatar
              ? '<img class="fen-av" src="' + esc(u.avatar) + '" alt="" decoding="async">'
              : '<span class="fen-av fen-av-i">' + esc(nameInitial(u.name, u.username)) + '</span>';
            return '<div class="fen-row" role="option" id="' + esc(box.id) + '-o' + i + '" aria-selected="false" data-i="' + i + '">' + av +
                   '<span class="fen-body"><span class="fen-name">' + esc(u.name) + '</span>' +
                   '<span class="fen-sub muted">@' + esc(u.username) + (u.email ? ' · ' + esc(u.email) : '') +
                   '</span></span></div>';
          }).join('');
        }
        box.hidden = false; input.setAttribute('aria-expanded', 'true'); input.removeAttribute('aria-activedescendant');
      }
      function search() {
        var q = input.value.trim().replace(/^@/, '');
        if (q.length < 2) { close(); return; }
        var mine = ++seq;
        fetch('/admin/user-lookup?scope=' + encodeURIComponent(scope) + '&q=' + encodeURIComponent(q),
              { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', cache: 'no-store' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (d) { if (mine === seq && d && document.activeElement === input) render(d.users); })
          .catch(function () { if (mine === seq) close(); });
      }
      input.addEventListener('input', function () {
        if (input.value === lastQ) return;
        lastQ = input.value;
        clearTimeout(timer); timer = setTimeout(search, 160);           // one request per pause
      });
      input.addEventListener('keydown', function (e) {
        var open = !box.hidden && items.length > 0;
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          if (!open) { search(); return; }
          active = (active + 1) % items.length; highlight();
        } else if (e.key === 'ArrowUp') {
          if (!open) return;
          e.preventDefault(); active = (active - 1 + items.length) % items.length; highlight();
        } else if (e.key === 'Enter') {
          if (open && active >= 0) { e.preventDefault(); pick(active); }   // otherwise the form submits
        } else if (e.key === 'Escape') {
          if (!box.hidden) { e.preventDefault(); close(); }
        } else if (e.key === 'Tab') { close(); }
      });
      // mousedown, not click: blur would close the list before a click could land on it
      box.addEventListener('mousedown', function (e) {
        var row = e.target.closest ? e.target.closest('.fen-row') : null;
        if (!row) return;
        e.preventDefault(); pick(parseInt(row.getAttribute('data-i'), 10));
      });
      input.addEventListener('blur', function () { setTimeout(function () { if (document.activeElement !== input) close(); }, 120); });
    });
  });

  /* ---- admin Founders: "SHOW MORE" under the link-joins and Finder-credits boxes (2026-09-29) ------
     Each box renders its first Founders::ADMIN_MORE_PER rows; the button (views/_admin_founders.php,
     $fMore) carries the next cursor (data-after = keyset ledger id, or data-off) and names its tbody in
     aria-controls. GET /admin/founders/more renders the next rows with the SAME row partial and says
     how many are still left over the WHOLE table. Rows are appended, never duplicated: a row whose
     profile link is already in the box is skipped. Delegated on document, so it survives a lazy panel
     load or a re-render. A failure leaves every row where it is and re-arms the button. */
  (function () {
    function rowKey(tr) {
      var a = tr.querySelector ? tr.querySelector('a[href^="/@"]') : null;
      return a ? a.getAttribute('href') : null;
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('.js-fmore') : null;
      if (!btn || btn.disabled) return;
      var tbody = document.getElementById(btn.getAttribute('aria-controls') || '');
      if (!tbody) return;
      e.preventDefault();
      var keyset = btn.hasAttribute('data-after');
      var cur = btn.getAttribute(keyset ? 'data-after' : 'data-off') || '0';
      var status = btn.parentNode ? btn.parentNode.querySelector('[data-fmore-left]') : null;
      var noun = btn.getAttribute('data-noun') || 'row';
      var label = btn.textContent;
      btn.disabled = true; btn.textContent = 'Loading…'; tbody.setAttribute('aria-busy', 'true');
      fetch('/admin/founders/more?t=' + encodeURIComponent(btn.getAttribute('data-part') || '') +
            (keyset ? '&after=' : '&off=') + encodeURIComponent(cur),
            { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (!d || typeof d.html !== 'string') throw new Error('fmore');
          var seen = {};
          Array.prototype.forEach.call(tbody.children, function (tr) { var k = rowKey(tr); if (k) seen[k] = 1; });
          var tmp = document.createElement('tbody');
          tmp.innerHTML = d.html;
          var first = null;
          Array.prototype.slice.call(tmp.children).forEach(function (tr) {
            var k = rowKey(tr);
            if (k && seen[k]) return;
            if (k) seen[k] = 1;
            tbody.appendChild(tr);
            if (!first) first = tr;
          });
          tbody.setAttribute('aria-busy', 'false');
          var left = Math.max(0, parseInt(d.left, 10) || 0);
          if (d.next == null || left === 0) {
            var wrap = btn.parentNode, hadFocus = document.activeElement === btn;
            btn.parentNode.removeChild(btn);
            if (status) status.textContent = 'All ' + Number(d.total || 0).toLocaleString() + ' ' + noun + (Number(d.total) === 1 ? '' : 's') + ' shown';
            if (hadFocus) { var a = first && first.querySelector('a'); if (a) a.focus(); else if (wrap) wrap.focus(); }
          } else {
            btn.setAttribute(keyset ? 'data-after' : 'data-off', String(d.next));
            btn.disabled = false; btn.textContent = label;
            if (status) status.textContent = left.toLocaleString() + ' more ' + noun + (left === 1 ? '' : 's') + ' not shown';
          }
        })
        .catch(function () {
          tbody.setAttribute('aria-busy', 'false');
          btn.disabled = false; btn.textContent = label;
          if (status) status.textContent = 'Couldn’t load more, try again.';
        });
    });
  })();

  /* ---- admin Founders roster: sort + page WITHOUT a page load -----------------------------------
     REPLACED THE CLIENT-SIDE SORTER, 2026-09-18. The roster used to render every Founder inline and
     this block reordered those rows in place. At 1,312 founders that table WAS /admin: 5.98 MB of a
     6.21 MB document and ~52,800 of its 65,664 DOM nodes, for a panel that is a hidden tab. A document
     that size makes every style+layout pass cost hundreds of milliseconds, which is why the owner's
     first click anywhere on the page -- opening the Add-member disclosure over in the MEMBERS panel --
     froze it in both Chrome and Safari. The table now pages at 50 server-side.

     AND THAT IS WHY THE SORT HAD TO MOVE TO THE SERVER. A client can only reorder the rows it is
     holding, so the moment the table pages, "sorted by Earned" would have meant "the best of this
     page" -- confidently wrong, and invisible. Identical reasoning to the auto-grant roster above.

     PROGRESSIVE ENHANCEMENT, not replacement: every header and pager control is a real link to a real
     server-rendered URL. Every early return here, and every failure of the fetch, leaves the click
     alone so the navigation happens and the admin still gets the right answer.
     Delegated on document so it survives an AJAX panel swap, like .js-ftree below. ---- */
  (function () {
    var seq = 0;

    /** The pretty /admin URL a control points at -> the fragment URL that renders just that table. */
    function fragUrl(href) {
      var u;
      try { u = new URL(href, window.location.origin); } catch (e) { return null; }
      if (u.pathname !== '/admin') { return null; }
      var q = new URLSearchParams();
      ['fr', 'frd', 'frp'].forEach(function (k) {
        var v = u.searchParams.get(k);
        if (v !== null && v !== '') { q.set(k, v); }
      });
      var s = q.toString();
      return '/admin/founders/roster' + (s ? '?' + s : '');
    }

    /** Keep the address bar honest: same params the link carries, other params (tzoff, fas*) kept. */
    function pushUrl(href) {
      try {
        if (!window.history || !history.replaceState) { return; }
        var from = new URL(href, window.location.origin);
        var to   = new URL(window.location.href);
        ['fr', 'frd', 'frp'].forEach(function (k) {
          var v = from.searchParams.get(k);
          if (v === null || v === '') { to.searchParams.delete(k); } else { to.searchParams.set(k, v); }
        });
        if (!to.hash) { to.hash = 'founders'; }
        history.replaceState(null, '', to.pathname + to.search + to.hash);
      } catch (err) { /* a URL we cannot rewrite is not a reason to leave the table unswapped */ }
    }

    function load(href) {
      var wrap = document.getElementById('froster-wrap');
      var url  = fragUrl(href);
      if (!wrap || !url || !window.fetch) { return false; }
      var mine = ++seq;
      wrap.setAttribute('aria-busy', 'true');
      wrap.style.opacity = '.55';
      fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' },
                   credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (mine !== seq) { return; }               // a later click already won; drop this answer
          wrap.setAttribute('aria-busy', 'false');
          wrap.style.opacity = '';
          if (html == null) { window.location.href = href; return; }   // fall back to the real link
          /* One assignment: the rows leave and arrive in a single layout pass, so there is no flash
             and no half-swapped paint. The sticky header and the scroll box come back with it. */
          wrap.innerHTML = html;
          pushUrl(href);
        })
        .catch(function () {
          if (mine !== seq) { return; }
          wrap.setAttribute('aria-busy', 'false');
          wrap.style.opacity = '';
          window.location.href = href;                 // network died: let the browser do it properly
        });
      return true;
    }

    function ctl(e) {
      return e.target && e.target.closest
        ? e.target.closest('.js-frsort-col, .js-frpage') : null;
    }

    document.addEventListener('click', function (e) {
      var a = ctl(e); if (!a) { return; }
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button > 0) { return; }  // open-in-new-tab
      var href = a.getAttribute('href'); if (!href) { return; }
      if (load(href)) { e.preventDefault(); }   // only swallow the click if we took the work on
    });

    /* A link is Enter-activated natively but NOT Space; an admin driving this table from the keyboard
       expects both, and Space would otherwise scroll the page. */
    document.addEventListener('keydown', function (e) {
      if (e.key !== ' ' && e.key !== 'Spacebar' && e.keyCode !== 32) { return; }
      var a = ctl(e); if (!a) { return; }
      e.preventDefault();
      var href = a.getAttribute('href');
      if (href && !load(href)) { window.location.href = href; }
    });
  })();

  /* ---- profile Growth card: live follower count + charts (no refresh) ---- */
  (function () {
    if (!document.querySelector('.growth-card[data-growth-poll]')) return;
    var busy = false;
    function poll() {
      if (busy || document.hidden) return;
      var card = document.querySelector('.growth-card[data-growth-poll]');   // re-query: we replace it each time
      if (!card) return;
      busy = true;
      fetch(card.getAttribute('data-growth-poll'),
            { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (html == null) return;
          var tmp = document.createElement('div'); tmp.innerHTML = html.trim();
          var fresh = tmp.querySelector('.growth-card');
          if (!fresh) return;
          // swap EVERY growth card on the page (desktop aside + the mobile block share the same data)
          //
          // ...but ONLY when the render actually changed. Followers and weekly engagement move
          // slowly, so the overwhelming majority of these 30s ticks used to re-insert a
          // byte-identical card for nothing. On a profile the desktop copy of this card lives
          // INSIDE the sticky, compositor-promoted #feed-aside, and it carries .gc-halo/.gc-dot --
          // two infinite transform+opacity animations. Re-inserting it therefore tears down and
          // rebuilds composited layers inside a promoted box, forever, on a timer, which is both
          // pointless work AND the thing that hands WebKit a blank raster ("no sidebar until I
          // resize the window"). The aside observer in the CHROME PAINT GUARANTEE block re-flushes
          // the paint when this swap does land; skipping the no-op ticks is what keeps that flush
          // from becoming per-tick cost. Serialisation is apples-to-apples: both sides are the
          // browser's own serialiser over parsed markup.
          var freshHTML = fresh.outerHTML;
          Array.prototype.forEach.call(document.querySelectorAll('.growth-card[data-growth-poll]'), function (old) {
            if (old.outerHTML === freshHTML) return;      // nothing moved since the last tick
            old.replaceWith(fresh.cloneNode(true));
          });
          // and keep the profile header's follower stat in sync (abbreviated like the server renders it)
          var fc = parseInt(fresh.getAttribute('data-followers') || '', 10);
          if (!isNaN(fc)) {
            Array.prototype.forEach.call(document.querySelectorAll('[data-follower-stat]'), function (el) {
              el.textContent = fmtCount(fc); el.setAttribute('title', fc.toLocaleString());
            });
          }
        })
        .catch(function () {})
        .then(function () { busy = false; });
    }
    // instant optimistic +/-1 on every growth card's headline number (the poll below confirms + redraws the
    // line/bars a beat later). Called by the follow/unfollow handlers so pressing Follow moves it right away.
    function bumpGrowth(delta) {
      Array.prototype.forEach.call(document.querySelectorAll('.growth-card[data-followers]'), function (card) {
        var n = Math.max(0, (parseInt(card.getAttribute('data-followers'), 10) || 0) + delta);
        card.setAttribute('data-followers', n);
        var num = card.querySelector('.gc-num'); if (num) num.textContent = fmtCount(n);
      });
    }
    window.__rovaGrowthPoll = function () { busy = false; poll(); };   // force an immediate refresh (bypass the interval gate)
    window.__rovaGrowthBump = bumpGrowth;
    setInterval(poll, 30000);   // followers/engagement move slowly; 30s keeps it fresh without churn
    document.addEventListener('visibilitychange', function () { if (!document.hidden) poll(); });
  })();

  /* ---- PROFILE GROWTH SHEET (phone/tablet, < 900px) ----------------------------------------------
     Rob, 2026-10-01: "Move the web profile growth card to the profile buttons as a popup modal, just
     like the app does, instead of at the end of the profile when on a mobile responsive layout. Leave
     it alone for desktop." views/profile.php renders .pf-growth-btn (the four insight bars) in the
     .profile-actions row iff $growth exists; rova.css hides it at >= 900px, where #feed-aside shows
     the card.
     RENDERED ONCE: the page carries exactly one .growth-card, inside #feed-aside (display:none down
     here). Opening MOVES that node into the sheet; closing moves it back to a comment placeholder in
     the aside. The 30s poll above replaces .growth-card nodes IN PLACE wherever they are, so a swap
     while the sheet is open lands in the sheet and is what gets moved back. Crossing to >= 900px
     closes the sheet at once, so the aside never paints without its card.
     Dialog contract: role=dialog + aria-modal on the panel, focus to the shared .xmark close, Tab is
     trapped, Esc / backdrop tap / X close, focus returns to the disc, page scroll held by the shared
     lock (zero drift), reduced motion = no slide (rova.css). */
  (function () {
    var WIDE = window.matchMedia ? window.matchMedia('(min-width: 900px)') : null;
    var RM = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    var sheet = null, slot = null, btn = null, isOpen = false, finishT = 0;
    var X_SVG = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.4"'
              + ' stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
    function focusables() {
      return Array.prototype.filter.call(
        sheet.querySelectorAll('button,[href],input,select,textarea,[tabindex]:not([tabindex="-1"])'),
        function (el) { return !el.disabled && el.offsetParent !== null; });
    }
    function onKey(e) {
      if (!isOpen) return;
      if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); e.stopPropagation(); close(); return; }
      if (e.key !== 'Tab') return;
      var f = focusables(); if (!f.length) { e.preventDefault(); return; }
      var first = f[0], last = f[f.length - 1], a = document.activeElement;
      if (e.shiftKey && (a === first || !sheet.contains(a))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (a === last || !sheet.contains(a))) { e.preventDefault(); first.focus(); }
    }
    function onFocusIn(e) {   // anything that steals focus out of the open sheet is pulled back to the close
      if (isOpen && sheet && !sheet.contains(e.target)) { var x = sheet.querySelector('.gsheet-x'); if (x) x.focus(); }
    }
    function finish() {   // put the card back where it lives and drop the sheet
      if (finishT) { clearTimeout(finishT); finishT = 0; }
      if (!sheet) return;
      var c = sheet.querySelector('.growth-card');
      if (c && slot && slot.parentNode) { slot.parentNode.insertBefore(c, slot); }
      if (slot && slot.parentNode) slot.parentNode.removeChild(slot);
      if (sheet.parentNode) sheet.parentNode.removeChild(sheet);
      sheet = null; slot = null;
    }
    function open(b) {
      if (isOpen || (WIDE && WIDE.matches)) return;
      if (sheet) finish();   // a close still sliding out: settle it first, then start clean
      var card = document.querySelector('#feed-aside .growth-card');
      if (!card) return;
      btn = b;
      sheet = document.createElement('div');
      sheet.className = 'gsheet';
      sheet.innerHTML =
        '<div class="gsheet-card" role="dialog" aria-modal="true" aria-label="Growth and engagement" tabindex="-1">'
        + '<span class="gsheet-grab" aria-hidden="true"></span>'
        + '<button type="button" class="gsheet-x rova-disc xmark" aria-label="Close">' + X_SVG + '</button>'
        + '</div>';
      slot = document.createComment('growth-card');
      card.parentNode.insertBefore(slot, card);
      sheet.firstChild.appendChild(card);
      sheet.addEventListener('click', function (e) {
        if (e.target === sheet || (e.target.closest && e.target.closest('.gsheet-x'))) close();
      });
      document.body.appendChild(sheet);
      isOpen = true;
      if (window.__rovaLockScroll) window.__rovaLockScroll();
      document.addEventListener('keydown', onKey, true);
      document.addEventListener('focusin', onFocusIn);
      if (btn) btn.setAttribute('aria-expanded', 'true');
      void sheet.offsetHeight;   // commit the closed state so the slide-up runs
      sheet.classList.add('show');
      try { sheet.querySelector('.gsheet-x').focus({ preventScroll: true }); } catch (_) { sheet.querySelector('.gsheet-x').focus(); }
    }
    function close(instant) {
      if (!isOpen) return;
      isOpen = false;
      document.removeEventListener('keydown', onKey, true);
      document.removeEventListener('focusin', onFocusIn);
      sheet.classList.remove('show');
      if (window.__rovaUnlockScroll) window.__rovaUnlockScroll();
      if (btn) {
        btn.setAttribute('aria-expanded', 'false');
        if (!instant) { try { btn.focus({ preventScroll: true }); } catch (_) {} }
      }
      if (instant || (RM && RM.matches)) finish(); else finishT = setTimeout(finish, 300);
    }
    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('.pf-growth-btn') : null;
      if (!b) return;
      e.preventDefault();
      open(b);
    });
    if (WIDE) {
      var onWide = function () { if (WIDE.matches) { close(true); finish(); } };
      if (WIDE.addEventListener) WIDE.addEventListener('change', onWide); else if (WIDE.addListener) WIDE.addListener(onWide);
    }
  })();

  /* ---- admin cockpit: live comment / message moderation streams --------- */
  (function () {
    // one stream per panel; each is set up when ITS panel's markup exists (lazy panels, 2026-09-29)
    ['comments', 'messages'].forEach(function (pn) {
      adminPanel(pn, function (sec) {
        Array.prototype.forEach.call(sec.querySelectorAll('.astream[data-endpoint][data-kind]'), setupStream);
      });
    });

    function setupStream(root) {
      var kind = root.getAttribute('data-kind');            // 'comment' | 'message'
      var endpoint = root.getAttribute('data-endpoint');
      var delUrl = root.getAttribute('data-del');
      var feed = root.querySelector('.astream-feed');
      var liveCb = root.querySelector('.js-astream-live');
      var selEl = root.querySelector('[data-sel-count]');
      var massBtn = root.querySelector('.js-astream-massdel');
      var moreBtn = root.querySelector('.js-astream-more');
      var qInput = root.querySelector('.js-astream-q');
      var hideSeedCb = root.querySelector('.js-astream-hideseed');
      var panel = root.closest('.admin-panel');
      var lastId = 0, firstId = 0, loaded = false, busy = false;

      function urlFor(mode) {
        var parts = [];
        if (mode === 'more') parts.push('before=' + firstId);
        else if (mode === 'live') parts.push('after=' + lastId);
        var qv = qInput ? qInput.value.trim() : '';
        if (qv) parts.push('q=' + encodeURIComponent(qv));
        if (hideSeedCb && hideSeedCb.checked) parts.push('hide_seed=1');
        return endpoint + (parts.length ? '?' + parts.join('&') : '');
      }

      function visible() { return panel && panel.classList.contains('on'); }
      function setDials(s) {
        if (!s) return;
        Array.prototype.forEach.call(root.querySelectorAll('[data-dial]'), function (el) {
          var k = el.getAttribute('data-dial'); if (s[k] != null) el.textContent = fmtCount(s[k]);
        });
      }
      function avatarHTML(it) {
        if (it.avatar) return '<img class="avatar sm" src="' + escHtml(it.avatar) + '" alt="">';
        // ONE function builds both cockpit streams, so the name pair is keyed by `kind` exactly the
        // way rowHTML() below keys it: the Comments stream sends name/username, the Messages stream
        // sends from/from_user (both already `display_name ?: username` server-side). The letter now
        // matches the name printed beside it, and the site's own avatar_img() for the same member.
        var nm = kind === 'comment' ? it.name : it.from;
        var h  = kind === 'comment' ? it.username : it.from_user;
        return '<span class="avatar sm astream-mono">' + escHtml(nameInitial(nm, h)) + '</span>';
      }
      function rowHTML(it) {
        var uid = kind === 'comment' ? it.user_id : it.from_id;
        var handle = kind === 'comment' ? it.username : it.from_user;
        var name = kind === 'comment' ? it.name : it.from;
        var tag = it.admin ? '<span class="astream-tag admin">admin</span>' : (it.seed ? '<span class="astream-tag seed">seed</span>' : '');
        // Blue check on the cockpit row, for BOTH streams (this one function builds the Comments and
        // the Messages cockpit alike). RENDER THE SERVER'S ANSWER, never re-derive it here: the
        // handlers already ran verified_is_on() over the three identity columns, so `it.verified`
        // has the seed rule baked in. 89 seed accounts carry a fake sub_status='active', so a
        // client-side "is it active?" test would mint 89 checks nobody granted -- and note that the
        // `seed` chip beside this badge means a row can legitimately show BOTH (@rosa is a seed an
        // admin genuinely verified). Same inline SVG the search typeahead uses.
        var tick = it.verified ? vsealTick() : '';
        var meta, extra;
        if (kind === 'comment') {
          meta = '@' + escHtml(handle) + ' · ' + escHtml(it.ago) + (it.is_reply ? ' · reply' : '');
          extra = '<a class="astream-act" href="/p/' + it.post_id + '" target="_blank" rel="noopener">post ↗</a>';
        } else {
          meta = '→ @' + escHtml(it.to_user) + ' · ' + escHtml(it.ago) + (it.read ? '' : ' · unread');
          extra = '<button class="astream-act danger js-astream-delthread" type="button">delete thread</button>';
        }
        return '<div class="astream-row" data-id="' + it.id + '" data-uid="' + uid + '" data-ip="' + escHtml(it.ip || '') + '">'
          + '<input type="checkbox" class="astream-check" aria-label="Select">'
          + avatarHTML(it)
          + '<div class="astream-copy">'
            // The tick sits OUTSIDE the <a>, immediately after it. .astream-metaline is a plain
            // wrapping block (no nowrap/ellipsis/line-clamp anywhere on it, .astream-copy, or
            // .astream-row), so the badge can never be laid out past a clip the way the settings
            // mute row's did -- a name long enough to fill the line just wraps and takes the tick
            // with it, still painted.
            + '<div class="astream-metaline"><a class="astream-name" href="/@' + encodeURIComponent(handle) + '" target="_blank" rel="noopener">' + escHtml(name) + '</a>' + tick + ' '
            + '<span class="muted">' + meta + '</span>' + tag + '</div>'
            + '<div class="astream-body">' + it.body + '</div>'
            + (it.media ? '<a class="astream-media" href="' + escHtml(it.media_href || it.media) + '" target="_blank" rel="noopener" title="Open attachment"><img src="' + escHtml(it.media) + '" alt="attachment" loading="lazy"></a>' : '')
            + '<div class="astream-acts">' + extra
              + '<button class="astream-act danger js-astream-del" type="button">delete</button>'
              + (uid ? '<button class="astream-act js-astream-ban" type="button">ban</button>' : '')
              + (it.ip ? '<button class="astream-act js-astream-ip" type="button">block IP</button>' : '')
            + '</div>'
          + '</div></div>';
      }
      function updateSel() {
        var n = feed.querySelectorAll('.astream-check:checked').length;
        if (selEl) selEl.textContent = n + ' selected';
        if (massBtn) massBtn.disabled = n === 0;
      }
      function makeRows(items) {
        var frag = document.createElement('div');
        frag.innerHTML = items.map(rowHTML).join('');
        return Array.prototype.slice.call(frag.children);
      }
      function load(mode) {
        if (busy) return; busy = true;
        fetch(urlFor(mode), { headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', cache: 'no-store' })
          .then(function (r) { return r.json(); })
          .then(function (d) {
            busy = false;
            if (!d || !d.ok) return;
            setDials(d.stats);
            var items = d.items || [];
            if (mode === 'live') {
              if (!items.length) return;
              var rows = makeRows(items);            // newest-first: insert so newest ends on top
              for (var i = rows.length - 1; i >= 0; i--) { rows[i].classList.add('astream-new'); feed.insertBefore(rows[i], feed.firstChild); }
              lastId = Math.max(lastId, items[0].id);
            } else if (mode === 'more') {
              makeRows(items).forEach(function (r2) { feed.appendChild(r2); });
              if (items.length) firstId = items[items.length - 1].id;
              if (moreBtn) moreBtn.style.display = items.length < 40 ? 'none' : '';
            } else {
              feed.innerHTML = '';
              if (!items.length) { feed.innerHTML = '<p class="muted astream-loading">Nothing here yet.</p>'; }
              else { makeRows(items).forEach(function (r2) { feed.appendChild(r2); }); lastId = items[0].id; firstId = items[items.length - 1].id; }
              loaded = true;
            }
            updateSel();
          })
          .catch(function () { busy = false; });
      }

      feed.addEventListener('change', function (e) { if (e.target.classList && e.target.classList.contains('astream-check')) updateSel(); });
      feed.addEventListener('click', function (e) {
        var row = e.target.closest ? e.target.closest('.astream-row') : null; if (!row) return;
        var id = row.getAttribute('data-id'), uid = row.getAttribute('data-uid'), ip = row.getAttribute('data-ip');
        var actBtn = e.target.closest ? e.target.closest('.astream-act') : null;
        if (actBtn && busyIs(actBtn)) return;   // destructive rows: one flight per button
        if (e.target.closest('.js-astream-delthread')) {
          if (!window.confirm('Permanently delete the ENTIRE conversation this message belongs to, for BOTH users?')) return;
          busyUntil(actBtn, postJson('/admin/messages/delete-thread', { id: id }, 15000).then(function (res) {
            row.remove(); updateSel();
            toast(res && res.ok ? ('Thread deleted (' + (res.deleted || 0) + ' messages)') : 'Could not delete thread');
          }).catch(function () { toast('Could not delete thread'); }));
        } else if (e.target.closest('.js-astream-del')) {
          busyUntil(actBtn, postJson(delUrl, { id: id }, 15000).then(function () { row.remove(); updateSel(); }).catch(function () { toast('Could not delete'); }));
        } else if (e.target.closest('.js-astream-ban')) {
          if (!uid || !window.confirm('Ban this user? They are signed out everywhere and can\'t log back in.')) return;
          busyUntil(actBtn, postJson('/admin/mod/ban', { user_id: uid }, 15000).then(function (res) { toast(res && res.ok ? ('Banned @' + res.username) : ((res && res.error) || 'Could not ban')); }).catch(function () { toast('Could not ban'); }));
        } else if (e.target.closest('.js-astream-ip')) {
          if (!ip || !window.confirm('Block ' + ip + '? Everyone on that IP is turned away.')) return;
          busyUntil(actBtn, postJson('/admin/spam/block-ip', { ip: ip }, 15000).then(function (res) { toast(res && res.ok ? ('Blocked ' + ip) : ((res && res.error) || 'Could not block')); }).catch(function () { toast('Could not block'); }));
        }
      });
      if (massBtn) massBtn.addEventListener('click', function () {
        if (busyIs(massBtn)) return;
        var checks = Array.prototype.slice.call(feed.querySelectorAll('.astream-check:checked'));
        if (!checks.length || !window.confirm('Delete ' + checks.length + ' selected?')) return;
        var fd = new FormData();
        checks.forEach(function (c) { var r2 = c.closest('.astream-row'); if (r2) fd.append('ids[]', r2.getAttribute('data-id')); });
        busyUntil(massBtn, postJson(delUrl, fd, 15000).then(function () { checks.forEach(function (c) { var r2 = c.closest('.astream-row'); if (r2) r2.remove(); }); updateSel(); }).catch(function () { toast('Could not delete'); }));
      });
      var refreshBtn = root.querySelector('.js-astream-refresh');
      if (refreshBtn) refreshBtn.addEventListener('click', function () { lastId = 0; firstId = 0; load(''); });
      // live search (debounced) + filters -> re-query from the top
      var qT = null;
      if (qInput) qInput.addEventListener('input', function () {
        clearTimeout(qT); qT = setTimeout(function () { lastId = 0; firstId = 0; load(''); }, 300);
      });
      if (hideSeedCb) hideSeedCb.addEventListener('change', function () { lastId = 0; firstId = 0; load(''); });
      if (moreBtn) moreBtn.addEventListener('click', function () { load('more'); });

      // load the first time the panel is revealed; then live-poll while visible + Live on
      function maybeInit() { if (!loaded && visible() && !busy) load(''); }
      maybeInit();
      document.addEventListener('click', function () { setTimeout(maybeInit, 0); });
      window.addEventListener('hashchange', function () { setTimeout(maybeInit, 0); });
      setInterval(function () { if (loaded && visible() && liveCb && liveCb.checked) load('live'); }, 5000);
    }
  })();

  /* ---- admin: timezone-heal + codes-panel field toggle. Moved here from an inline
     <script> in the admin view so the strict CSP (no unsafe-inline) can't block them. --- */
  adminPanel('overview', function () {   // charts bucket days at the admin's midnight; re-request if rendered in the wrong tz
    var host = document.getElementById('admin-charts');
    if (!host) return;                                     // admin overview page only
    var off = -new Date().getTimezoneOffset();             // minutes east of UTC
    try { document.cookie = 'tzoff=' + off + ';path=/;max-age=31536000;samesite=Lax'; } catch (e) {}
    var used = parseInt(host.getAttribute('data-tzoff') || '0', 10);
    if (used === off) return;                              // already rendered in my timezone
    var last = +(sessionStorage.getItem('tzoffRetryAt') || 0);
    if (Date.now() - last < 30000) return;                 // 30s guard against a reload loop
    try { sessionStorage.setItem('tzoffRetryAt', String(Date.now())); } catch (e) {}
    location.href = location.pathname + '?tzoff=' + off + location.hash;
  });
  adminPanel('codes', function () {   // Codes panel: show only the fields the selected code type uses
    var sel = document.getElementById('promo-kind');
    if (!sel) return;
    function sync() {
      var k = sel.value;
      Array.prototype.forEach.call(document.querySelectorAll('.promo-form [data-kinds]'), function (el) {
        el.hidden = el.getAttribute('data-kinds').split(' ').indexOf(k) === -1;
      });
    }
    sel.addEventListener('change', sync);
    sync();
  });

  /* ---- admin overview charts: hover tooltips + 7/30/90 range switch ------ */
  adminPanel('overview', function () {
    var host = document.getElementById('admin-charts');
    if (!host) return;
    var DATA = {};
    try { DATA = JSON.parse(host.getAttribute('data-charts') || '{}'); } catch (e) { return; }
    var charts = host.querySelectorAll('.achart');
    if (!charts.length) return;
    var range = 30;

    var tip = document.createElement('div');
    tip.className = 'achart-tip';
    document.body.appendChild(tip);
    function hideTip() {
      tip.style.display = 'none';
      host.querySelectorAll('rect.hot').forEach(function (r) { r.classList.remove('hot'); });
    }
    function label(d) {   // "2026-07-02" -> "Jul 2"
      var m = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
      var p = String(d).split('-');
      return p.length === 3 ? m[(+p[1] || 1) - 1] + ' ' + (+p[2]) : String(d);
    }
    function usd(v) { return '$' + (+v).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
    function fmt(v, money) { return money ? usd(v) : (+v).toLocaleString('en-US'); }

    function draw(el) {
      var pts = (DATA[el.getAttribute('data-key')] || []).slice(-range);
      var money = el.getAttribute('data-money') === '1';
      if (!pts.length) return;
      var max = 0, total = 0;
      pts.forEach(function (p) { max = Math.max(max, +p.c); total += +p.c; });
      max = max || 1;
      var bw = 100 / pts.length, s = '';
      pts.forEach(function (p, i) {
        var h = (+p.c / max) * 32;
        s += '<rect data-i="' + i + '" x="' + (i * bw + bw * 0.15).toFixed(2) + '" y="' + (34 - h).toFixed(2)
           + '" width="' + (bw * 0.7).toFixed(2) + '" height="' + Math.max(h, 0.4).toFixed(2) + '" rx="0.5"></rect>';
      });
      el.querySelector('svg').innerHTML = s;
      el._pts = pts; el._money = money;
      var tot = el.querySelector('.achart-total');
      if (tot) tot.textContent = (money ? usd(total) : Math.round(total).toLocaleString('en-US')) + ' · last ' + range + 'd';
      var x0 = el.querySelector('.achart-x0'), x1 = el.querySelector('.achart-x1');
      if (x0) x0.textContent = label(pts[0].d);
      if (x1) x1.textContent = 'today';
    }
    function drawAll() { Array.prototype.forEach.call(charts, draw); }
    drawAll();

    // hover (and tap) a bar for the exact day + value
    Array.prototype.forEach.call(charts, function (el) {
      function show(ev, target) {
        var r = target && target.closest ? target.closest('rect') : null;
        if (!r) { hideTip(); return; }
        var p = (el._pts || [])[+r.getAttribute('data-i')];
        if (!p) { hideTip(); return; }
        host.querySelectorAll('rect.hot').forEach(function (o) { o.classList.remove('hot'); });
        r.classList.add('hot');
        tip.textContent = label(p.d) + ' · ' + fmt(p.c, el._money);
        tip.style.display = 'block';
        var x = (ev.touches ? ev.touches[0].pageX : ev.pageX);
        var y = (ev.touches ? ev.touches[0].pageY : ev.pageY);
        tip.style.left = Math.min(x + 12, window.scrollX + window.innerWidth - tip.offsetWidth - 8) + 'px';
        tip.style.top = (y - 34) + 'px';
      }
      el.addEventListener('mousemove', function (ev) { show(ev, ev.target); });
      el.addEventListener('mouseleave', hideTip);
      el.addEventListener('touchstart', function (ev) { show(ev, ev.target); }, { passive: true });
    });
    document.addEventListener('touchstart', function (e) {
      if (!e.target.closest || !e.target.closest('.achart')) hideTip();
    }, { passive: true });

    var ranges = document.getElementById('chart-ranges');
    if (ranges) ranges.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('button[data-r]') : null;
      if (!b) return;
      range = +b.getAttribute('data-r') || 30;
      ranges.querySelectorAll('button').forEach(function (o) { o.classList.toggle('on', o === b); });
      hideTip();
      drawAll();
    });
  });

  /* ---- admin: members search + filter + load more ------------------------ */
  adminPanel('members', function () {
    var list = document.getElementById('member-list');
    if (!list) return;
    var filters = document.getElementById('member-filters');
    var moreBtn = document.getElementById('member-more');
    var qEl = document.getElementById('member-q');
    var PAGE = 20;
    var filter = 'all';
    var q = '';
    // count rows the same way render() does (each row is one .am-wrap containing an
    // .admin-member) -- matching both selectors here double-counts and makes the first
    // "Load more" skip a whole page.
    var offset = list.querySelectorAll('.am-wrap').length || list.querySelectorAll('.admin-member').length;
    var loading = false, qTimer = null, seq = 0;

    function render(html, reset) {
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      // rows arrive as .am-wrap (row + Manage tools); fall back for older markup
      var rows = tmp.querySelectorAll('.am-wrap');
      if (!rows.length) rows = tmp.querySelectorAll('.admin-member');
      if (reset) { list.innerHTML = ''; offset = 0; }
      // remember where the Load more button sits BEFORE the new rows take their space, so we can glide it
      // DOWN to its new spot (FLIP) instead of it jumping -- owner: "the button should animate down when
      // new members are loaded". Only for an append (a reset/search rebuilds the whole list).
      var btnTop = (moreBtn && !reset) ? moreBtn.getBoundingClientRect().top : 0;
      var firstNew = null;
      Array.prototype.forEach.call(rows, function (r, i) {
        if (r.classList) { r.classList.add('am-in'); r.style.setProperty('--i', Math.min(i, 10)); }   // stagger the rows sliding in (capped so a full page stays snappy)
        if (i === 0) firstNew = r;
        list.appendChild(r);
      });
      offset += rows.length;
      // owner: "Load more should scroll down the list so I can see the new people." An append leaves the
      // fresh rows below the fold (the button barely moved on screen), so glide the first new row up near
      // the top of the viewport. Only on append -- a reset/search should stay put at the top of the list.
      if (!reset && firstNew && firstNew.scrollIntoView) {
        requestAnimationFrame(function () {
          try { firstNew.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
          catch (e) { firstNew.scrollIntoView(); }
        });
      }
      if (reset && !rows.length) {
        list.innerHTML = '<div class="muted" style="padding:12px 2px">' +
          (q ? 'No members match that search.' : 'No members in this filter.') + '</div>';
      }
      if (moreBtn) moreBtn.style.display = rows.length < PAGE ? 'none' : '';
      if (moreBtn && !reset && rows.length && moreBtn.style.display !== 'none') {
        var dy = btnTop - moreBtn.getBoundingClientRect().top;   // it moved down by |dy|; invert then release
        if (dy) {
          moreBtn.style.transition = 'none';
          moreBtn.style.transform = 'translateY(' + dy + 'px)';
          requestAnimationFrame(function () {
            moreBtn.style.transition = 'transform .5s cubic-bezier(.22,.61,.36,1)';
            moreBtn.style.transform = '';
          });
        }
      }
    }

    function load(reset) {
      if (loading && !reset) return;   // searches/filter swaps may supersede an in-flight page
      loading = true;
      var mine = ++seq;
      if (moreBtn) { moreBtn.disabled = true; moreBtn.textContent = 'Loading…'; }
      /* SLOW-LINK (2026-08-10). The last surviving `r.ok ? r.text() : ''` in this file, and it is
         the exact anti-pattern rfetch was introduced to kill -- the same one that froze the home
         grid at 153 tiles until reload (see gridCycle.ensureBuf). Folding a 5xx into empty HTML
         makes render('') see rows.length === 0, and render then does two irreversible things:
           * `moreBtn.style.display = rows.length < PAGE ? 'none' : ''` -- ONE 502 hides "Load more"
             PERMANENTLY, on a page that has plenty more members;
           * on a reset (filter swap or search) it also paints "No members match that search",
             which is a FALSE EMPTY -- the server never said that, it errored.
         rfetch rejects a non-2xx into the .catch, so render() only ever runs on HTML the server
         actually meant, and `rows.length === 0` goes back to meaning exactly what it says. The
         trailing .then already clears `loading` and re-enables the button on both paths, so a
         failure now leaves the pager up and retryable, which is all it ever needed to do.
         Admin-only, so the blast radius is small -- but it is a real permanent latch. */
      rfetch('/admin/members?filter=' + encodeURIComponent(filter) + '&offset=' + (reset ? 0 : offset)
            + (q ? '&q=' + encodeURIComponent(q) : ''),
            { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', cache: 'no-store' }, 8000)
        .then(function (r) { return r.text(); })
        .then(function (html) { if (mine === seq) render(html, reset); })
        .catch(function () {})
        .then(function () {
          loading = false;
          if (moreBtn) { moreBtn.disabled = false; moreBtn.textContent = 'Load more'; }
        });
    }

    if (moreBtn) moreBtn.addEventListener('click', function () { load(false); });
    if (filters) filters.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('.mfilter') : null;
      if (!b) return;
      var f = b.getAttribute('data-filter');
      if (f === filter) return;
      filter = f;
      filters.querySelectorAll('.mfilter').forEach(function (x) { x.classList.toggle('on', x === b); });
      load(true);
    });
    if (qEl) qEl.addEventListener('input', function () {
      clearTimeout(qTimer);
      qTimer = setTimeout(function () {
        var v = qEl.value.trim();
        if (v === q) return;
        q = v;
        load(true);
      }, 260);
    });
    if (moreBtn && offset < PAGE) moreBtn.style.display = 'none'; // first page already fit
  });

  /* ---- admin: Add member, without leaving the page ----------------------------------------------
     2026-09-18, owner: "when I click 'New member details' the page freezes". Two separate costs were
     hiding behind that one sentence and both are fixed; this is the second one.

     Creating a member was an ordinary form POST: the handler redirected to /admin#members and the
     browser re-rendered the entire console to show one new row. That console was a 6.2 MB, 65,664-node
     document -- so the price of "add a member" was a full reload of it, in every engine. It now posts
     the same form by fetch and paints the returned row into the list above the panel.

     WHAT DID NOT CHANGE, deliberately: the form's action, method, field names, CSRF field and every
     default are untouched; the server does exactly the same work (same Users::create, same comp grant,
     same verified / skip-follows flags, same avatar attach, same audit rows, same wording). FormData
     carries the file input, so an attached profile photo still rides along. `ajax=1` is added HERE, as
     a POST field, so a no-JS submit is byte-for-byte the flow it always was.

     A FAILED FETCH IS NEVER RETRIED AUTOMATICALLY. If the network dies mid-POST we do not know whether
     the account was created, and re-submitting could make a second one; the panel says so and leaves
     the decision to the admin. ---- */
  adminPanel('members', function () {
    var form = document.getElementById('member-add-form');
    if (!form || !window.fetch || !window.FormData) { return; }   // no JS path = the old full POST
    var msg  = document.getElementById('member-add-msg');
    var list = document.getElementById('member-list');
    var busy = false;

    function say(text, bad) {
      if (!msg) { return; }
      msg.textContent = text;
      msg.hidden = false;
      msg.style.color = bad ? 'var(--accent-text, #e0245e)' : '';
    }

    form.addEventListener('submit', function (e) {
      if (busy) { e.preventDefault(); return; }
      e.preventDefault();
      var btn = form.querySelector('button[type=submit]');
      var fd;
      try { fd = new FormData(form); } catch (err) { form.submit(); return; }   // can't read it: let the browser
      fd.append('ajax', '1');
      busy = true;
      if (btn) { btn.disabled = true; btn.textContent = 'Creating…'; }
      say('Creating the account…', false);

      fetch(form.getAttribute('action') || '/admin/member/add', {
        method: 'POST', body: fd, credentials: 'same-origin', cache: 'no-store',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (!d) { say('The server refused that request. Nothing was created.', true); return; }
          if (!d.ok) { say(d.msg || 'Could not create that account.', true); return; }
          say(d.msg || 'Created.', false);
          /* Paint the new member at the top of the list -- the same partial GET /admin/members
             returns, so it is indistinguishable from a row that arrived in a page. */
          if (list && d.row) {
            var tmp = document.createElement('div');
            tmp.innerHTML = d.row;
            var row = tmp.firstElementChild;
            if (row) {
              if (row.classList) { row.classList.add('am-in'); row.style.setProperty('--i', '0'); }
              list.insertBefore(row, list.firstChild);
            }
          }
          /* Back to the server-rendered defaults (verified on, skip-follows on, email OFF, free
             forever, 1) so the next account starts from the same place a fresh page would. */
          form.reset();
        })
        .catch(function () {
          say('That did not complete, the connection dropped. Check the members list above before '
            + 'trying again: the account may already exist.', true);
        })
        .then(function () {
          busy = false;
          if (btn) { btn.disabled = false; btn.textContent = 'Create member'; }
        });
    });
  });

  /* ---- fullscreen media gallery (profile Photos/Videos/Songs grids) ----- */
  (function () {
    var gal = null, ids = [], idx = 0, loading = false, cache = {}, galLastTap = 0, caps = {};
    // slideshow (sit-back autoplay): photos advance on a timer, videos on 'ended'
    var playing = false, slideTimer = null, watched = 0;
    var SPEEDS = [3000, 5000, 8000];   // fast / normal / slow (ms a photo stays up)
    var speedIdx = 1;
    var PHOTO_MS = SPEEDS[speedIdx];   // current dwell; cycled by the speed button
    var idleHideT = null;
    var CHECK_EVERY = 20;    // after this many auto-advances, confirm the viewer's still there
    // repeat mode: loop the catalog, and after 10 full loops confirm the viewer
    // is still around; no answer within this window sends them back to the feed
    var repeatOn = false, loopsDone = 0, feedT = null;
    var REPEAT_LOOPS = 10, STILL_THERE_MS = 45000;
    function clearFeedT() { if (feedT) { clearTimeout(feedT); feedT = null; } }
    // same 1.5u correction as the video controls' `play` above: the triangle measured x[8,19] against
    // a PAUSE_ICON at x[6,18], so the gallery's transport jumped sideways on every toggle.
    var PLAY_ICON  = '<svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor" aria-hidden="true"><path d="M6.5 5v14l11-7z"/></svg>';
    var PAUSE_ICON = '<svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor" aria-hidden="true"><rect x="6" y="5" width="4" height="14" rx="1.2"/><rect x="14" y="5" width="4" height="14" rx="1.2"/></svg>';

    /* ---- pinch to zoom + pan the current slide (photo or video), mirroring the
       lightbox. Zoom disables swipe-nav / swipe-close until you pinch back out. ---- */
    var gzs = 1, gztx = 0, gzty = 0, gpinch = null, gpanLast = null;
    function gMedia() { return gal && gal.querySelector('.gal-media'); }
    function gApply(anim) {
      var m = gMedia(); if (!m) return;
      m.style.transition = anim ? 'transform .18s ease' : 'none';
      m.style.transform = gzs > 1 ? ('translate(' + gztx + 'px,' + gzty + 'px) scale(' + gzs + ')') : '';
      if (gal) gal.classList.toggle('zoomed', gzs > 1);
    }
    function gClamp() {
      var m = gMedia(); if (!m) return;
      var r = m.getBoundingClientRect();
      var mx = Math.max(0, (gzs - 1) * (r.width / gzs) / 2), my = Math.max(0, (gzs - 1) * (r.height / gzs) / 2);
      gztx = Math.max(-mx, Math.min(mx, gztx)); gzty = Math.max(-my, Math.min(my, gzty));
    }
    function gZoomAt(cx, cy, next) {
      var m = gMedia(); if (!m) return;
      var r = m.getBoundingClientRect();
      var ox = cx - (r.left + r.width / 2), oy = cy - (r.top + r.height / 2), k = next / gzs;
      gztx = ox - k * (ox - gztx); gzty = oy - k * (oy - gzty);
      gzs = next; gClamp(); gApply(false);
    }
    function gZoomed() { return gzs > 1.02 || gpinch !== null; }
    function gZoomReset(anim) { gzs = 1; gztx = gzty = 0; gpinch = gpanLast = null; gApply(anim); }

    function build() {
      if (gal) return gal;
      gal = document.createElement('div');
      gal.className = 'gal';
      gal.innerHTML =
        '<button class="gal-x" type="button" aria-label="Close">&times;</button>' +
        '<button class="gal-arrow prev" type="button" aria-label="Previous"><svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m15.5 5-7 7 7 7"/></svg></button>' +
        '<button class="gal-arrow next" type="button" aria-label="Next"><svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m8.5 5 7 7-7 7"/></svg></button>' +
        '<div class="gal-stage">' +
          '<div class="gal-mediabox"></div>' +
          '<div class="gal-vbar"></div>' +
          '<div class="gal-controls">' +
            '<button class="gal-cbtn gal-play" type="button" aria-label="Play slideshow" title="Play slideshow">' + PLAY_ICON + '</button>' +
            '<button class="gal-cbtn gal-cprev" type="button" aria-label="Previous"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m15.5 5-7 7 7 7"/></svg></button>' +
            '<button class="gal-cbtn gal-cnext" type="button" aria-label="Next"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m8.5 5 7 7-7 7"/></svg></button>' +
            '<button class="gal-cbtn gal-speed" type="button" aria-label="Slideshow speed" title="Slideshow speed">5s</button>' +
            '<button class="gal-cbtn gal-speed gal-repeat" type="button" aria-label="Repeat slideshow" title="Repeat 10 times">' +
              /* the loop arrows are icon('repost')'s geometry and this was a STALE COPY of them, left
                 behind when that path was corrected: at stroke-width 2 its ink measured y[0,24] --
                 flush with the viewBox on BOTH edges, so an inline SVG's default overflow:hidden was
                 shaving the arrow tips. The corrected path measures y[1.5,22.5], inside the box, and
                 centres on (12,12). Same shape, same meaning, no longer clipped. */
              '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M17 2.5 21 6.5 17 10.5"/><path d="M3 11.5v-1a4 4 0 0 1 4-4h14"/><path d="M7 21.5 3 17.5 7 13.5"/><path d="M21 12.5v1a4 4 0 0 1-4 4H3"/></svg>' +
            '</button>' +
            '<button class="gal-cbtn gal-toggle" type="button" aria-label="Toggle comments">' +
              /* icon('comment-o') -- the site's comment glyph. This drew the PLAIN bubble, which is
                 icon('message'): the header-inbox / DM shape, not the comments one. Same collision the
                 profile's Message button hit in July (see the 'dm' note in lib/view.php) only pointing
                 the other way -- a comments control wearing the messaging glyph. The three dots are
                 what separate the two, and the post bar now draws this exact path. */
              '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 3.4h16a2 2 0 0 1 2 2v9.6a2 2 0 0 1-2 2h-9.4l-4.5 3.4A1 1 0 0 1 4.5 19.6l.3-2.6H4a2 2 0 0 1-2-2V5.4a2 2 0 0 1 2-2z"/><path d="M8 10.2h.01M12 10.2h.01M16 10.2h.01"/></svg>' +
            '</button>' +
          '</div>' +
        '</div>' +
        '<aside class="gal-panel">' +
          '<div class="gal-head"></div>' +
          '<div class="gal-list"></div>' +
          '<form class="gal-cform"><input type="hidden" class="js-parent" value="">' +
          '<div class="reply-chip" hidden><span class="reply-chip-txt"></span><button type="button" class="reply-chip-x" aria-label="Cancel reply">&times;</button></div>' +
          '<input class="gal-cinput" name="body" placeholder="Add a comment…" maxlength="1000" autocomplete="off">' +
          // GIF picker -- see the .cpanel-form twin above (same no-hidden-gif_url rule).
          '<button type="button" class="ctool js-gif" title="Add a GIF" aria-label="Add a GIF">' +
          '<svg viewBox="0 0 24 24" fill="none"><rect x="1.5" y="6" width="21" height="12" rx="3.4" stroke="currentColor" stroke-width="1.5"/>' +
          '<text x="12" y="15.3" text-anchor="middle" font-size="9.6" font-weight="800" letter-spacing="-.4" fill="currentColor" font-family="-apple-system,BlinkMacSystemFont,Arial,sans-serif">GIF</text></svg></button>' +
          '<button class="gal-csend" type="submit" aria-label="Send">' +
          '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M19.442 2.62c1.1-.5 2.3.7 1.8 1.8l-7.2 16.3c-.5 1.1-2.1 1-2.5-.1l-1.8-5.3a1.6 1.6 0 0 0-.9-.9L3.542 11.92c-1.2-.4-1.2-2 0-2.5z"/><path fill="#000" opacity=".18" d="M20.642 3.22 9.342 13.52c.3.2.5.5.6.8l1.8 5.3c.2.6 1 .7 1.3.1z"/></svg></button></form>' +
        '</aside>';
      document.body.appendChild(gal);

      gal.querySelector('.gal-x').addEventListener('click', close);
      gal.querySelector('.gal-arrow.prev').addEventListener('click', function () { go(-1); });
      gal.querySelector('.gal-arrow.next').addEventListener('click', function () { go(1); });
      // the side panel is dismissible for a true full-screen view; the choice sticks
      var tgl = gal.querySelector('.gal-toggle');
      function paintToggle(mini) {
        tgl.setAttribute('title', mini ? 'Show comments' : 'Hide comments, view full screen');
        tgl.setAttribute('aria-label', mini ? 'Show comments' : 'Hide comments, view full screen');
      }
      try { if (localStorage.getItem('rova_galmini') === '1') gal.classList.add('mini'); } catch (e) {}
      paintToggle(gal.classList.contains('mini'));
      tgl.addEventListener('click', function () {
        var mini = gal.classList.toggle('mini');
        try { localStorage.setItem('rova_galmini', mini ? '1' : '0'); } catch (e) {}
        paintToggle(mini);
      });
      gal.querySelector('.gal-play').addEventListener('click', togglePlay);
      gal.querySelector('.gal-cprev').addEventListener('click', function () { go(-1); });
      gal.querySelector('.gal-cnext').addEventListener('click', function () { go(1); });
      gal.querySelector('.gal-speed').addEventListener('click', cycleSpeed);
      gal.querySelector('.gal-repeat').addEventListener('click', toggleRepeat);
      updateSpeedBtn();
      // auto-hide the floating chrome when idle; any move / tap wakes it
      gal.addEventListener('mousemove', galActive);
      gal.addEventListener('touchstart', galActive, { passive: true });
      gal.addEventListener('click', function (e) { if (e.target === gal) close(); });

      gal.querySelector('.gal-cform').addEventListener('submit', function (e) {
        e.preventDefault();
        var form = e.currentTarget;
        var input = gal.querySelector('.gal-cinput');
        // In flight: drop the tap BEFORE cgifTake (it consumes the staged GIF); the spinning send
        // button is the feedback, and the typed text stays in the box.
        var sendBtn = form.querySelector('.gal-csend');
        if (busyIs(sendBtn)) return;
        var val = (input.value || '').trim();
        // a bare GIF is a real comment (Comments::add: text OR a gif), so don't bail on empty text
        var pick = cgifTake(form);
        if (!val && !pick.url) return;
        var parentInp = form.querySelector('.js-parent');
        var parentId = parentInp ? parentInp.value : '';
        // optimistic: clear the box now, keep typing; the text comes back
        // (with a toast) if the send dies
        input.value = '';
        input.focus();
        // Same optimistic +1 as the feed and the permalink. In here the card is behind the
        // lightbox, so what the eye is actually on is the panel's own "N comments" summary --
        // engCommentPaint moves that too, via the .gal-ccount span and the data-gal-post marker.
        var settle = engCommentBump(ids[idx], 1);
        // gif_w/gif_h ride with gif_url (0133), same as the pfeed panel: this is a hand-built JSON
        // body, so the composer's hidden fields do not come along on their own.
        busyUntil(sendBtn, postJson('/comment', { post_id: ids[idx], body: val, parent_id: parentId, gif_url: pick.url, gif_w: pick.w, gif_h: pick.h }, 15000).then(function (res) {
          if (res && res.error) { settle(false); if (!input.value) input.value = val; pick.restore(); toast(res.error); return; }   // e.g. "verify your email to comment"
          if (res && res.comment) {
            // a double-submit answers both sends with the SAME comment: appendComment drops the
            // second copy, so the second +1 has to come back off too
            var dup = !!(res.comment.id && gal.querySelector('.gal-list .comment[data-comment="' + res.comment.id + '"]'));
            appendComment(res.comment); setReplyState(form, 0, '');
            settle(!dup);
          }
          else { settle(false); if (!input.value) input.value = val; pick.restore(); }
        }).catch(function (err) {
          settle(false);
          if (err && err.message === 'reauth') return;
          if (!input.value) input.value = val;
          pick.restore();
          toast('Couldn’t post that comment, check your connection');
        }));
      });

      // media stage: 2 fingers pinch-zoom; 1 finger pans while zoomed; otherwise
      // horizontal swipe = prev/next, down = close, tap x2 = like.
      var sx = 0, sy = 0, sw = false, stage = gal.querySelector('.gal-stage');
      stage.addEventListener('touchstart', function (e) {
        // touches on the glassy player (seek drag, buttons) must not arm swipe-nav
        if (e.target.closest && e.target.closest('.vctrl,.vc-sound,.vc-btn,.vc-seek')) { sw = false; return; }
        if (e.touches.length === 2) {
          var a = e.touches[0], b = e.touches[1];
          gpinch = { d: Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY) || 1, s: gzs };
          gpanLast = null; sw = false; return;
        }
        if (e.touches.length === 1 && gzs > 1) { gpanLast = { x: e.touches[0].clientX, y: e.touches[0].clientY }; sw = false; return; }
        sx = e.touches[0].clientX; sy = e.touches[0].clientY; sw = true;
      }, { passive: true });
      stage.addEventListener('touchmove', function (e) {
        if (e.touches.length === 2 && gpinch) {
          if (e.cancelable) e.preventDefault();
          var a = e.touches[0], b = e.touches[1], d = Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY);
          gZoomAt((a.clientX + b.clientX) / 2, (a.clientY + b.clientY) / 2, Math.max(1, Math.min(4, gpinch.s * (d / gpinch.d))));
          return;
        }
        if (e.touches.length === 1 && gpanLast && gzs > 1) {
          if (e.cancelable) e.preventDefault();
          var t = e.touches[0];
          gztx += t.clientX - gpanLast.x; gzty += t.clientY - gpanLast.y;
          gpanLast = { x: t.clientX, y: t.clientY }; gClamp(); gApply(false);
          return;
        }
        if (e.cancelable) e.preventDefault();   // swipe gesture: block native page scroll under the fixed overlay
      }, { passive: false });
      stage.addEventListener('touchend', function (e) {
        if (gpinch && e.touches.length < 2) { gpinch = null; if (gzs < 1.05) gZoomReset(true); }
        if (e.touches.length === 0) gpanLast = null;
        if (gZoomed()) { sw = false; return; }               // zoomed / panning: never swipe-nav or close
        if (!sw) return; sw = false;
        var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) < 20 && Math.abs(dy) < 20) {          // a tap, check for double-tap to like
          var vb = gal.querySelector('.gal-vbar');             // wake the glassy player bar on a tap
          if (vb && vb.__vcShow) vb.__vcShow();
          var now = Date.now();
          if (now - galLastTap < 300) { galLastTap = 0; galLike(); }
          else { galLastTap = now; }
          return;
        }
        if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? 1 : -1);
        else if (dy > 90 && Math.abs(dy) > Math.abs(dx)) close();
      }, { passive: true });
      // desktop: wheel zooms at the cursor while hovering the media
      stage.addEventListener('wheel', function (e) {
        if (!e.deltaY) return;
        e.preventDefault();
        gZoomAt(e.clientX, e.clientY, Math.max(1, Math.min(4, gzs * (e.deltaY < 0 ? 1.12 : 1 / 1.12))));
        if (gzs < 1.05) gZoomReset(true);
      }, { passive: false });
      // desktop: double-click the photo to like (same heart as the feed + lightbox)
      gal.querySelector('.gal-mediabox').addEventListener('dblclick', function (e) { e.preventDefault(); galLike(); });
      return gal;
    }

    function open(list, start) {
      build();
      ids = list; idx = start; cache = {};
      playing = false; watched = 0; stopTimer(); gal.classList.remove('playing'); updatePlayBtn();
      gal.classList.add('show');
      lockScroll();
      document.addEventListener('keydown', onKey);
      galActive();
      load();
    }
    function close() {
      if (!gal) return;
      stopSlideshow();
      gZoomReset(false);
      gal.classList.remove('show');
      unlockScroll();
      document.removeEventListener('keydown', onKey);
      Array.prototype.forEach.call(gal.querySelectorAll('.gal-stage video'), function (v) {
        try { v.pause(); } catch (e) {}
      });
      gal.querySelector('.gal-mediabox').innerHTML = '';   // keep the controls; only clear the media
      setupGalVideoBar(null);                              // strip the player bar too
      gal.classList.remove('idle');
      gal.removeAttribute('data-gal-post');   // closed: it is no longer a view of anyone's count
      if (idleHideT) { clearTimeout(idleHideT); idleHideT = null; }
    }
    function onKey(e) {
      if (e.key === 'Escape') { close(); return; }
      if (gal && gal.querySelector('.gal-still')) return; // checkpoint up -> ignore nav keys
      var t = e.target;
      if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.isContentEditable)) return; // typing a comment
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
    }
    function go(d) {
      var n = idx + d;
      if (n < 0 || n >= ids.length || loading) return;
      stopTimer(); watched = 0;   // manual nav: you're clearly here, reset the check counter
      gZoomReset(false);          // a new slide always starts un-zoomed
      galActive();
      idx = n; load();
    }
    function arrows() {
      gal.querySelector('.gal-arrow.prev').style.visibility = idx > 0 ? '' : 'hidden';
      gal.querySelector('.gal-arrow.next').style.visibility = idx < ids.length - 1 ? '' : 'hidden';
    }
    // double-tap / double-click the current photo to like it (idempotent heart,
    // never unlikes), with the same ♥ burst as the feed and lightbox
    function galLike() {
      var box = gal && gal.querySelector('.gal-mediabox');
      if (!box || ids[idx] == null) return;
      heartBurst(box);
      postJson('/like', { post_id: ids[idx], mode: 'like', reaction: 'heart' }).catch(function () {});
    }

    /* ---- slideshow: sit back and let photos/videos play through ---------- */
    function updatePlayBtn() {
      var b = gal && gal.querySelector('.gal-play');
      if (!b) return;
      b.innerHTML = playing ? PAUSE_ICON : PLAY_ICON;
      b.setAttribute('aria-label', playing ? 'Pause slideshow' : 'Play slideshow');
      b.title = playing ? 'Pause slideshow' : 'Play slideshow';
    }
    function stopTimer() { if (slideTimer) { clearTimeout(slideTimer); slideTimer = null; } }
    function updateSpeedBtn() {
      var b = gal && gal.querySelector('.gal-speed');
      if (b) b.textContent = Math.round(PHOTO_MS / 1000) + 's';
    }
    function cycleSpeed() {
      speedIdx = (speedIdx + 1) % SPEEDS.length;
      PHOTO_MS = SPEEDS[speedIdx];
      updateSpeedBtn();
      if (playing) scheduleNext();   // apply the new dwell to the current photo
    }
    // reveal the chrome and re-arm the idle-hide timer
    function galActive() {
      if (!gal) return;
      gal.classList.remove('idle');
      if (idleHideT) clearTimeout(idleHideT);
      idleHideT = setTimeout(function () { if (gal && !gal.querySelector('.gal-still')) gal.classList.add('idle'); }, 2800);
    }
    function togglePlay() {
      playing = !playing;
      gal.classList.toggle('playing', playing);
      updatePlayBtn();
      if (playing) { watched = 0; scheduleNext(); } else { stopTimer(); }
    }
    function stopSlideshow() {
      playing = false; stopTimer(); clearFeedT();
      if (gal) { gal.classList.remove('playing'); var ov = gal.querySelector('.gal-still'); if (ov) ov.remove(); }
      updatePlayBtn();
    }
    // queue the next advance once the current item is on screen
    function scheduleNext() {
      stopTimer();
      if (!playing || !gal) return;
      var v = gal.querySelector('.gal-stage video:not(.gal-out)');   // never the crossfading-out copy
      if (v) {                       // video: advance when it finishes
        v.loop = false;
        v.onended = advanceSlide;
        v.play().catch(function () {
          // unmuted play vetoed: retry silent before giving up on the clip
          v.dataset.sndProg = '1';
          v.muted = true;
          v.play().catch(function () { slideTimer = setTimeout(advanceSlide, PHOTO_MS); });
        });
      } else {                       // photo: advance after a beat
        slideTimer = setTimeout(advanceSlide, PHOTO_MS);
      }
    }
    function advanceSlide() {
      stopTimer();
      if (!playing) return;
      if (idx + 1 >= ids.length) {                             // end of the catalog
        if (repeatOn) {
          loopsDone++;
          if (loopsDone >= REPEAT_LOOPS) { promptStillRepeating(); return; }
          idx = 0; load(); return;                             // wrap around, keep rolling
        }
        endSlideshow(); return;
      }
      watched++;
      if (!repeatOn && watched % CHECK_EVERY === 0) { promptStillThere(); return; }
      idx++; load();
    }
    // an elegant centered card, primary "go" action + secondary "stop"
    function showOverlay(title, sub, goLabel, onGo, stopLabel, onStop) {
      var old = gal.querySelector('.gal-still'); if (old) old.remove();
      stopTimer();
      // wake the chrome and keep it awake while the checkpoint/end card is up, so its
      // buttons (and the X) are always live on the first tap
      gal.classList.remove('idle');
      if (idleHideT) { clearTimeout(idleHideT); idleHideT = null; }
      var ov = document.createElement('div'); ov.className = 'gal-still';
      ov.innerHTML = '<div class="gal-still-card"><div class="gal-still-title"></div>' +
        '<div class="gal-still-sub"></div><div class="gal-still-actions">' +
        '<button type="button" class="btn primary gal-still-go"></button>' +
        '<button type="button" class="btn gold-ghost gal-still-stop"></button></div></div>';
      ov.querySelector('.gal-still-title').textContent = title;
      ov.querySelector('.gal-still-sub').textContent = sub;
      var g = ov.querySelector('.gal-still-go'); g.textContent = goLabel;
      var s = ov.querySelector('.gal-still-stop'); s.textContent = stopLabel;
      g.addEventListener('click', function () { ov.remove(); onGo(); });
      s.addEventListener('click', function () { ov.remove(); onStop(); });
      gal.appendChild(ov);
      requestAnimationFrame(function () { ov.classList.add('in'); });
    }
    function promptStillThere() {
      showOverlay('Still watching?',
        'Take a breather, tap to keep the slideshow rolling.',
        'Keep going', function () { playing = true; gal.classList.add('playing'); updatePlayBtn(); idx++; load(); },
        'Pause',      function () { stopSlideshow(); });
    }
    function toggleRepeat() {
      repeatOn = !repeatOn; loopsDone = 0;
      var b = gal.querySelector('.gal-repeat');
      if (b) b.classList.toggle('on', repeatOn);
      if (repeatOn && !playing) togglePlay();      // arming repeat starts the show
    }
    function promptStillRepeating() {
      playing = false; stopTimer(); gal.classList.remove('playing'); updatePlayBtn();
      showOverlay('Still there?',
        'That was ' + REPEAT_LOOPS + ' loops. Keep it rolling?',
        'Keep repeating', function () { clearFeedT(); loopsDone = 0; playing = true; gal.classList.add('playing'); updatePlayBtn(); idx = 0; load(); },
        'Close',          function () { clearFeedT(); close(); });
      // nobody home: hand the screen back to the feed
      feedT = setTimeout(function () { window.location.href = '/feed'; }, STILL_THERE_MS);
    }
    function endSlideshow() {
      playing = false; stopTimer(); gal.classList.remove('playing'); updatePlayBtn();
      showOverlay('That’s everything ✨',
        'You’ve reached the end of the catalog.',
        'Watch again', function () { idx = 0; watched = 0; playing = true; gal.classList.add('playing'); updatePlayBtn(); load(); },
        'Close',       function () { close(); });
    }

    /* SLOW-LINK (2026-08-10). This was the last user-facing SPINNER in the file with no deadline:
       load() below puts up .gal-spin and then waits on this bare fetch, so on a stalled socket the
       gallery viewer spins for the platform's whole half-open timeout (60-120s on iOS) before the
       .catch can swap in "Failed to load." 8000 is the same read deadline every other small JSON
       read here uses; the existing .catch needs no change, it just gets to run in a human amount of
       time. A non-2xx now rejects too, so a 5xx error page stops being parsed as an item. */
    function fetchItem(pid) {
      if (cache[pid]) return Promise.resolve(cache[pid]);
      var t0 = Date.now();   // when this read STARTED: a comment reaction that settles later is laid over it (renderPanel)
      return rfetch('/gallery-item?ajax=1&post=' + encodeURIComponent(pid), {
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin'
      }, 8000).then(function (r) { return r.json(); }).then(function (d) {
        if (d && !d.error) { d._t0 = t0; cache[pid] = d; }
        return d;
      });
    }
    // warm the JSON cache + browser image cache for a neighbouring item
    function preload(i) {
      if (i < 0 || i >= ids.length) return;
      fetchItem(ids[i]).then(function (d) {
        var m = d && d.media && d.media[0];
        if (m && m.type === 'image') { var im = new Image(); im.src = m.path; }
      }).catch(function () {});
    }

    function load() {
      loading = true; arrows();
      var stage = gal.querySelector('.gal-mediabox');   // media renders here; controls sit outside it
      // keep the current photo on screen while the next loads (they crossfade);
      // the spinner only shows when there is nothing up yet (first open)
      if (!stage.querySelector('.gal-media')) stage.innerHTML = '<div class="gal-spin"></div>';
      var pid = ids[idx];
      fetchItem(pid).then(function (d) {
        // Clear the flag BEFORE the superseded-response bail. It used to sit below the early
        // return, so a response that arrived after the reader had already moved on left `loading`
        // pinned -- soft, because the newer load() re-sets it, but it is a latch in the same shape
        // as every other one this pass removed, and arrows() reads it.
        loading = false;
        if (ids[idx] !== pid) return;   // user already moved on
        if (!d || d.error) { stage.innerHTML = '<div class="gal-empty">Unavailable</div>'; return; }
        renderMedia(stage, d.media);
        renderPanel(d);
        preload(idx + 1);
        preload(idx - 1);
        scheduleNext();   // no-op unless the slideshow is playing
      }).catch(function () { loading = false; stage.innerHTML = '<div class="gal-empty">Failed to load.</div>'; });
    }

    // wire (or tear down) the full-width glassy player bar pinned to the stage bottom.
    // pass the video for a video slide, or null for a photo slide.
    function setupGalVideoBar(vid) {
      var bar = gal && gal.querySelector('.gal-vbar');
      if (!bar) return;
      if (vid && window.__rovaVCtrl) {
        window.__rovaVCtrl(vid, bar, { noFs: true });   // rebuilds against the new video
        gal.classList.add('gal-hasvid');
      } else {
        Array.prototype.forEach.call(bar.querySelectorAll('.vctrl,.vc-mini,.vc-sound,.vc-spin,.vc-pipmsg'),
          function (n) { n.remove(); });
        // The buffering ring hangs on .gal-stage, NOT in the bar (buildControls relocates it there so
        // it centres on the media instead of collapsing onto this zero-height rail), so the sweep
        // above cannot reach it. This branch is the photo-slide teardown AND the one close() calls,
        // so missing it would strand a ring on the stage across a close/reopen -- a spinner that
        // never stops, which is worse than the misplacement being fixed. Take the stage's rings too.
        var stageEl = bar.closest('.gal-stage');
        if (stageEl) Array.prototype.forEach.call(stageEl.querySelectorAll(':scope > .vc-spin'), function (n) { n.remove(); });
        bar._vctrl = null;
        bar.className = 'gal-vbar';                      // drop has-vctrl + vc-* state classes
        gal.classList.remove('gal-hasvid');
      }
    }

    function renderMedia(stage, media) {
      var m = (media && media[0]) || null;
      if (!m) { stage.innerHTML = '<div class="gal-empty">No media</div>'; return; }
      // stop the previous slide's video before it crossfades out (no lingering audio)
      Array.prototype.forEach.call(stage.querySelectorAll('video'), function (o) { try { o.pause(); } catch (e) {} });
      var spin = stage.querySelector('.gal-spin'); if (spin) spin.remove();
      var oldMore = stage.querySelector('.gal-more'); if (oldMore) oldMore.remove();
      var olds = stage.querySelectorAll('.gal-media');

      var el;
      if (m.type === 'video') {
        el = document.createElement('video');
        el.className = 'gal-vid';               // + gal-media below (shared sizing/crossfade)
        el.src = m.path; el.autoplay = true; el.playsInline = true; el.setAttribute('playsinline', '');
        el.muted = !sndPref();                  // sound carries over from the feed and back
        el.addEventListener('volumechange', function () {
          if (el.dataset.sndProg === '1') { delete el.dataset.sndProg; return; }
          sndRemember(!el.muted);               // touching the mute control IS the preference
        });
        // if the browser vetoes unmuted autoplay, fall back to muted so the
        // video still plays (the veto is the browser's choice, not the user's)
        el.addEventListener('loadeddata', function () {
          if (el.muted || !el.paused) return;
          var pr = el.play();
          if (pr && pr.catch) pr.catch(function () {
            el.dataset.sndProg = '1';
            el.muted = true;
            el.play().catch(function () {});
          });
        }, { once: true });
      } else {
        el = document.createElement('img');
        el.src = m.path; el.alt = '';
      }
      el.className = (el.className ? el.className + ' ' : '') + 'gal-media gal-xfade';
      stage.appendChild(el);
      // the glassy player lives in a FULL-WIDTH bar pinned to the stage bottom (not the
      // video box), so it reads as a real player and never collides with the slideshow
      // controls; photo slides tear the bar back down
      setupGalVideoBar(el.tagName === 'VIDEO' ? el : null);

      // CROSSFADE: the outgoing photo lifts to an absolute overlay (same spot)
      // and fades out while the incoming one fades in. Images wait until they
      // have pixels so we never fade to a blank frame.
      function reveal() {
        requestAnimationFrame(function () {
          el.classList.add('in');
          Array.prototype.forEach.call(olds, function (o) {
            o.classList.add('gal-out');
            requestAnimationFrame(function () { o.classList.add('hide'); });
          });
          setTimeout(function () {
            Array.prototype.forEach.call(olds, function (o) { if (o.parentNode) o.remove(); });
          }, 420);
        });
      }
      if (el.tagName === 'IMG' && !el.complete) { el.onload = reveal; el.onerror = reveal; }
      else { reveal(); }

      if (media.length > 1) {
        var more = document.createElement('div'); more.className = 'gal-more';
        more.textContent = '+' + (media.length - 1) + ' more';
        stage.appendChild(more);
      }
    }

    function renderPanel(d) {
      var a = d.author || {};
      gal.querySelector('.gal-head').innerHTML =
        '<a class="gal-author" href="/@' + escHtml(a.username) + '">' + jsAvatar(a) +
          '<span class="gal-name">' + escHtml(a.display_name) + '</span></a>' +
        '<div class="gal-sub"><span class="gal-ago">' + escHtml(d.ago) + '</span>' +
          (d.body ? ' <span class="gal-cap">' + d.body + '</span>' : '') + '</div>' +
        '<div class="gal-counts">' + fmtCount(d.like_count) + ' likes · '
          // the comment number gets its own span so the shared painter can move it on its own,
          // and data-gal-post below says WHICH post this lightbox is currently showing
          + '<span class="gal-ccount">' + fmtCount(d.comment_count) + '</span> comments</div>';
      gal.setAttribute('data-gal-post', String(ids[idx] || ''));
      caps = { canReact: d.canReact !== false, canReply: d.canReply !== false };
      var list = gal.querySelector('.gal-list');
      list.innerHTML = '';
      /* THE COMMENT HEART SURVIVES next/prev (2026-10-06, the sheet's thread-cache bug, gallery twin): `cache` keeps
         each item's /gallery-item JSON for the life of the viewer, so a heart tapped here, then one item along and
         back, was redrawn from the pre-like copy -- unlit, and the next tap sent state=on again. The page's own
         reactions (cReactNote) are laid over any copy whose read started before they settled. Rig: scratchpad
         momc2/rig.js. */
      if (d.comments && d.comments.length) { cReactOverlay(d.comments, d._t0 || 0); }
      if (d.comments && d.comments.length) {
        d.comments.forEach(function (c) { appendThread(list, c); });
      } else {
        list.innerHTML = '<div class="gal-nocom">No comments yet.</div>';
      }
      list.scrollTop = 0;
      setReplyState(gal.querySelector('.gal-cform'), 0, '');   // fresh post = not replying
      gal.querySelector('.gal-cform').style.display = csrf ? '' : 'none';   // only logged-in can comment
    }

    // rich comment: avatar + body + the shared like/reply actions (.clike/.creply
    // are wired by the global handlers). c.body is already safe HTML.
    function galCommentNode(c, isReply) {
      var n = document.createElement('div');
      n.className = 'comment' + (isReply ? ' is-reply' : '');
      if (c.id) n.setAttribute('data-comment', c.id);
      n.innerHTML =
        '<a href="/@' + encodeURIComponent(c.username) + '">' + jsAvatar(c) + '</a>' +
        '<div class="cbody"><div class="chead">' +
          '<a class="name" href="/@' + encodeURIComponent(c.username) + '">' + escHtml(c.display_name) + '</a>' +
          '<span class="meta">@' + escHtml(c.username) + (c.ago ? ' · ' + escHtml(c.ago) : '') + '</span>' +
        '</div><div class="ctext">' + (c.body || '') + '</div>' +
        (c.id && caps.canReact !== false ? commentActsHtml(c, !!isReply, caps.canReply !== false) : '') +
        '</div>';
      return n;
    }
    function appendThread(list, c) {
      list.appendChild(galCommentNode(c, false));
      if (c.replies && c.replies.length) {
        var wrap = document.createElement('div');
        wrap.className = 'comment-replies';
        wrap.setAttribute('data-parent', c.id);
        c.replies.forEach(function (r) { wrap.appendChild(galCommentNode(r, true)); });
        list.appendChild(wrap);
      }
    }
    function appendComment(c) {
      var list = gal.querySelector('.gal-list');
      // server de-dupes a double-submit to the SAME id; never render it twice
      if (c.id && list.querySelector('.comment[data-comment="' + c.id + '"]')) return;
      var noc = list.querySelector('.gal-nocom'); if (noc) noc.remove();
      var node = galCommentNode({
        id: c.id, username: c.username, display_name: c.display_name,
        avatar_path: c.avatar_path, body: bodyWithGif(c.body, c.gif_w, c.gif_h), ago: c.ago,   // 0133: reserve the GIF's box
        like_count: 0, my_reaction: null, fan: []
      }, !!c.parent_id);
      if (c.parent_id) {                                   // reply: tuck under its parent
        var parent = list.querySelector('.comment[data-comment="' + c.parent_id + '"]');
        var wrap = list.querySelector('.comment-replies[data-parent="' + c.parent_id + '"]');
        if (!wrap && parent) {
          wrap = document.createElement('div');
          wrap.className = 'comment-replies';
          wrap.setAttribute('data-parent', c.parent_id);
          parent.parentNode.insertBefore(wrap, parent.nextSibling);
        }
        (wrap || list).appendChild(node);
      } else {
        list.appendChild(node);
      }
      list.scrollTop = list.scrollHeight;
      delete cache[ids[idx]];   // drop cache so a re-visit re-fetches with the new comment threaded in
    }

    // Tapping a grid cell opens the Instagram-style vertical feed of this profile's
    // posts (full cards: our icons + comment roller + player), landing on the tapped
    // post. Same tab as the grid so the feed order matches; index = server offset.
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.pcell-del')) return;   // the delete badge has its own handler
      // the owner's hide/unhide badge (0119) likewise: it must never open the post it is sitting on.
      // Belt and braces -- gcRun's own capture-phase listener already stops this one being reached.
      if (e.target.closest && e.target.closest('.pcell-gc')) return;
      var cell = e.target.closest ? e.target.closest('.pgrid .pcell') : null;
      if (!cell || !cell.querySelector('img, video')) return;
      // GATED cell (nudity filter / adult profile): its thumb is only CSS-blurred and, unlike the feed
      // card, carries no pointer-events:none veil -- so an unchecked open would fly the RAW image up as
      // the hero (the blur "slips through" for the length of the zoom). Swallow the tap; the grid's
      // "Show anyway" bar (.nsfw-gridbar / js-nsfw-reveal) is the only way in, matching the feed veil.
      if (cell.classList.contains('nsfw-cell')) { e.preventDefault(); return; }
      e.preventDefault();
      var grid = cell.closest('.pgrid');
      var idm = (cell.getAttribute('href') || '').match(/\/p\/(\d+)/);
      var pid = (cell.getAttribute('data-id') || (idm ? idm[1] : '')) + '';
      // PREFETCH THE PFEED (owner request): the instant a grid cell is tapped (profile OR feed), warm the
      // display variant of the tapped post AND a window of its neighbours IN GRID ORDER -- these are exactly
      // the posts the immersive viewer will page through -- so swiping opens each one instantly instead of
      // cold-loading. Uses the shared warmer (low priority, deduped, skipped on data-saver/2g); a bounded
      // window (a few back, a big run forward) keeps it aggressive-but-sane, not a whole-grid download, and
      // its dedupe means the on-screen 5-screen warmer and this never double-fetch.
      if (window.__rovaWarmMedia && grid) {
        var gcells = grid.querySelectorAll('.pcell');
        var ti = Array.prototype.indexOf.call(gcells, cell);
        if (ti >= 0) {
          // DEFER the neighbour prefetch OFF the tap's critical path. Creating ~36 Image() objects synchronously
          // right here delayed the zoom START by a beat -- part of the "little hiccup right after click before it
          // zooms". This prefetch is for LATER swipes, not this open, so fire it just AFTER the hero + viewer are
          // kicked off this frame; the zoom then begins on the tap frame with nothing blocking it.
          setTimeout(function () {
            for (var wprei = Math.max(0, ti - 6), wpreEnd = Math.min(gcells.length, ti + 30); wprei < wpreEnd; wprei++) {
              window.__rovaWarmMedia(gcells[wprei]);
            }
          }, 0);
        }
      }
      // zoom the tapped thumbnail up as the immersive viewer loads behind it. A video cell keeps its poster
      // <img> backdrop with the live <video> overlaid; PREFER the video's exact current frame for the hero when
      // it has one, else fall back to the poster thumbnail.
      var cellV = cell.querySelector('video.pcell-video');
      /* SPEND THIS TAP ON SOUND, HERE, IN THE HANDLER (owner 2026-08-15: "if I tap on a media in the
         safari browser it should start with sound on"). This is the last synchronous moment of the
         gesture that opens the viewer -- everything below it is a hero flight and an async card
         fetch -- and WebKit's activation does not survive either. __rovaSoundArm unmutes + play()s
         this tile's clip and hands it straight back muted; the lift is what we came for, the sound is
         not (the tile plays the -an grid rendition, so there is nothing to hear here anyway). By the
         time pfSoundSoon reaches the viewer's own clip the page is unlocked and it opens WITH sound.
         It is a no-op when the reader's stored intent is muted -- the latch is the authority -- and a
         no-op on a photo tile. Same placement, same reason, as the __rovaAmArm call in the openers. */
      if (window.__rovaSoundArm && cellV) { try { window.__rovaSoundArm(cellV); } catch (e) {} }
      var zVid = (cellV && cellV.readyState >= 2) ? cellV : null;
      var zImg = zVid ? null : cell.querySelector('img');
      // If this cell is a LIVE grid-preview video, hand its playback position to the viewer so the clip
      // CONTINUES from the frame on screen instead of restarting at 0. Resume at the EXACT current time (no lead):
      // the hero is a STILL of that exact frame and holds until the viewer's clip is playing there, so a matching
      // resume time makes the cross-fade seamless (still T -> moving T) instead of a small forward jump.
      var gPrev = cell.querySelector('video.pcell-video');
      var gridT = (gPrev && !gPrev.paused && gPrev.currentTime > 0.05) ? gPrev.currentTime : 0;
      if (gridT && gPrev.duration) { gridT = Math.min(gridT, Math.max(0, gPrev.duration - 0.1)); }
      /* TILE CLOCK -> MASTER CLOCK. A 3-second preview is `_grid3`, which covers the first
         GRID3_WINDOW_SEC of SOURCE played at GRID3_SPEED, so master time is tile time times
         that rate. At the shipped 1.0 this is the identity and the line is a no-op -- it is
         here so that changing the constant server-side is the ONLY edit a hyperlapse needs.
         Applied before every downstream use, because gridT seeds the resume, the hero hold
         and the voice gate alike. */
      var g3Speed = (typeof window.__rovaG3Speed === 'function') ? window.__rovaG3Speed(cell) : 0;
      /* A PING-PONG TILE FOLDS INSTEAD OF SCALING (2026-08-17). `_grid6` is the same 3s
         window as `_grid3` but cut forward-then-reverse, so its position is NOT a master
         time even at speed 1.0: past the halfway fold the tile is running backwards and the
         master time is coming back DOWN. Left as a plain multiply, every tap taken in the
         second half of the loop would open the clip up to ~3s further in than the frame the
         reader was looking at -- correct for exactly the first half of every loop, which is
         the failure mode most likely to be dismissed as "sometimes it opens in the wrong
         place". The fold needs the tile's DURATION, so it is taken from the live element
         (the poster cannot answer it), and __rovaG6Master is inert on a bad duration -- so a
         tile whose metadata has not landed falls through to the linear path unchanged. */
      var g6 = (typeof window.__rovaG6 === 'function') ? window.__rovaG6(cell) : 0;
      var g6Dur = (g6 && gPrev && isFinite(gPrev.duration) && gPrev.duration > 0) ? gPrev.duration : 0;
      var g6Pos = gridT, g6Dir = 1;
      if (g6 && g6Dur && gridT) {
        g6Dir = window.__rovaG6Dir(gridT, g6Dur);
        gridT = window.__rovaG6Master(gridT, g6Dur);
      } else if (g3Speed && gridT) { gridT = gridT * g3Speed; }
      /* The receipt for this open, read and cleared by vfStart a few frames from now. Stamped
         HERE because this is the only place that knows every half at once.
         `p`/`d`/`r` ride along ONLY for a boomerang: p is the raw tile position, d its
         duration and r the direction, so a row proves WHICH half of the loop the tap came
         from. That is the one fact needed to tell a genuine mapping error from a clip that
         simply opens where it should -- without it, a correct forward-half open and a broken
         reverse-half open produce identical rows. */
      window.__rovaVfG3 = { s: g3Speed, t: Math.round(gridT * 100) / 100 };
      if (g6) {
        window.__rovaVfG3.g6 = 1;
        window.__rovaVfG3.p  = Math.round(g6Pos * 100) / 100;
        window.__rovaVfG3.d  = Math.round(g6Dur * 100) / 100;
        window.__rovaVfG3.r  = g6Dir;
      }
      // hold the still hero until the viewer's clip is PLAYING at the grid time (rova:pfresumed), so the
      // cross-fade is seamless with no restart-from-0 jump. BOTH viewers resume now: the feed viewer via
      // __rovaFeedView's startTime, the profile viewer via the gridT passed to __rovaProfileFeed below.
      var gHold = gridT > 0;
      // DONOR HANDOFF (round 129): this grid preview <video> holds buffered -- usually PLAYING -- media for
      // the SAME mp4 the pfeed card will render. Stash it; the viewer ADOPTS the element when the tapped card
      // lands (loadMore's positioned branch), so playback continues with ZERO re-download and zero seek. This
      // is "use the grid's player in the pfeed": the element IS the grid's player.
      window.__rovaGridDonor = (cellV && cellV.readyState >= 2) ? { id: pid, v: cellV, at: Date.now() } : null;
      /* THE OPEN RESTART (2026-08-16). Owner, amending his own resume-at-the-tile-frame spec:
         "It really shouldn't be a seamless continuation it should be the actual clip rising out
         the grid to keep it as smooth and fast as possible." A tile that has been looping in the
         grid for a minute is nowhere near its start, and opening it there reads as "it skipped
         the whole video" -- his was a 13.12s clip opening at 10.0s, eight opens running.
         So every TILE open now lands at 0. What does NOT change is the machinery above: the
         donor handoff, the live-video hero and the hold/cross-fade all still fly the REAL playing
         element, which is what makes the rise smooth. Only the frame it lands on moves.
         A ONE-SHOT FLAG, NOT A ZEROED gridT, and that distinction is the whole safety of this
         change. `gridT` is doing three jobs downstream -- it arms the hero hold (`gHold`), it
         seeds `resumeId`/`resumeTime`, and `pfVoiceHold(startTime > 0)` gates the SOUND handover
         on it. Zeroing it would silently disarm all three: the hero would release before the
         viewer's clip was positioned (the "wrong position then it snaps" jump this hold was
         written for) and the voice gate would open before the clip was resumed. So the position
         keeps flowing exactly as it did, and only the SEEK TARGET is overridden, at the two
         places that actually apply one.
         SCOPED TO THE TILE, BY ID. The other openers that carry a startTime are deliberate
         resumes and must keep resuming: the in-timeline FULLSCREEN BUTTON ("fullscreen =
         continue", :18307) and an embed's "Continue on Rova" (`resumeExact`, :38735). Neither
         goes through this handler, and the id + TTL make sure a stale arm can never reach one.

         ═══ AND IT IS NOW SKIPPED FOR A 3-SECOND TILE (2026-08-17) ══════════════════════
         Owner: "when the user taps it the video can lift up off the grid playing smoothly
         from within the first 3 seconds and continue playing smoothly as it rises into the
         full screen view."
         THIS IS NOT A REVERT OF THE RULE ABOVE -- it is that rule's own premise expiring.
         The complaint that produced the restart was POSITION, not continuation: a 13.12s
         clip opening at 10.0s "reads as if it skipped the whole video". A tile bound to
         `_grid3` cannot be anywhere but the first three seconds, because that is the entire
         file. So the position it hands over already satisfies "start at the beginning",
         and forcing a further seek to 0 now buys nothing and costs the one thing he asked
         for: the seek flushes the decode pipeline mid-flight, which is the flicker.
         Both branches that apply the override (the donor adoption in loadMore, and
         pfResume) key off this flag, so leaving it unset is the whole change -- gridT was
         already flowing to them untouched. A full-length tile keeps the 2026-08-16
         behaviour exactly, which is why the gate is on the RENDITION and not on a
         preference: the two tiles want opposite things for the same reason. */
      if (!g3Speed) { window.__rovaOpenRestart = { id: pid, at: Date.now() }; }
      else { window.__rovaOpenRestart = null; }
      if (zImg) {
        // OPEN via heroExpand -- the exact MIRROR of the (perfect) dismiss: box-resize the grid TILE up to the
        // viewer's real painted rect, object-fit:cover cropping the square out to the frame gradually (no guess,
        // no stretch). A real PHOTO flies its own image; a not-yet-ready VIDEO cell flies its poster still and
        // cross-fades to the clip once it plays.
        heroExpand(cell.getBoundingClientRect(), zImg.currentSrc || zImg.src, null, zImg);
      }
      else if (zVid) {
        // VIDEO OPEN -- start the zoom INSTANTLY on tap, never wait (owner: "kill the little flash right after
        // click before the zoom happens; it should just start zooming, lift the video off the page with the
        // least turbulence"). The fix is layering: the hero clone is z-index 210, ABOVE the viewer backdrop
        // (z 205), so as long as a clone exists on the tap frame there is NEVER a dark/blank gap. The FLIP path
        // had no clone -- it hid the media (hz-flip) and WAITED for the adopted clip to be playable before it
        // grew, so on that wait you saw the dark viewer open empty = the flash. So fly a hero clone of the cell's
        // and starts moving on the SAME frame as the tap. holdResume=true keeps the still up (never black,
        // never blank) until the pfeed's OWN clip -- the adopted grid donor -- is actually PLAYING and POSITIONED
        // (heroZoom's fw() now waits for _pfFitDone too), so the "wrong position then it snaps" jump happens
        // BEHIND the still and the cross-fade lands on a settled, playing frame.
        // HERO SOURCE = the clip's EXACT CURRENT FRAME (videoFrameSrc), NOT the poster. Owner's black-hero report
        // (@gracelin): those videos carry no poster_path, so the auto poster is the video's FIRST frame -- which
        // is BLACK on any clip that fades in from black -- and a poster hero came up pitch black. The live frame
        // shows what the user is actually looking at. Fall back to the poster only if the grab fails (a cross-
        // origin taint, or a GPU-black capture) so we still never fly nothing.
        var pImg = cell.querySelector('img.pcell-video');
        var vPoster = (pImg && (pImg.currentSrc || pImg.getAttribute('src'))) || zVid.getAttribute('poster') || '';
        // LIVE-VIDEO HERO (owner rewrite): if the grid preview is actually PLAYING, fly the REAL <video> element
        // as the hero. It's already rendering frames, so it NEVER shows black and keeps playing as it lifts; the
        // pfeed loads its OWN copy behind and heroZoom cross-fades to it (seeked to the same frame) once it's
        // playable + positioned -- no black ever, switch invisible. Fall back to a still frame (videoFrameSrc)
        // or the poster only when there's no playing preview to lift.
        // heroExpand mirrors the dismiss (box-resize the TILE up to the painted rect). A PLAYING preview flies
        // AS the hero (never black, keeps playing) and the pfeed loads its own copy behind for the cross-fade;
        // otherwise a still frame (videoFrameSrc, else poster) is used.
        var liveHero = zVid.readyState >= 2 && zVid.videoWidth > 0 && !zVid.paused && zVid.currentTime > 0.03;
        if (liveHero) {
          window.__rovaGridDonor = null;   // this element IS the hero now -> the pfeed loads its own copy, doesn't adopt it
          /* ...AND THE HERO RISES FROM THE START (2026-08-16, see the __rovaOpenRestart note above).
             On this branch the flown hero IS the tile's live <video>, so this one line is the whole
             of "the actual clip rising out the grid" -- it lifts off already at 0 and keeps playing
             there, no cover, no cross-fade to arrange, because the element never stops being the
             element. AFTER `liveHero` is computed, and that order is load-bearing: the test itself
             reads `currentTime > 0.03`, so rewinding first would fail it and drop this open onto the
             still-frame path.
             AFTER the sound arm too (`__rovaSoundArm` above, the last synchronous moment of the
             gesture): the arm's unmute+play must land on the element while WebKit still counts this
             as user activation, and a seek in front of it buys nothing and risks the activation.
             The seek is free here -- a grid tile plays the small `-an` `_grid480` rendition and it
             has been looping, so frame 0 is already in the buffer. */
          /* ...AND NOT AT ALL ON A 3-SECOND TILE (2026-08-17). Same reasoning as the
             __rovaOpenRestart gate above, but this one is the more urgent of the two,
             because THIS element is the hero: it is the surface the owner watches rise.
             Rewinding it here is a visible jump-cut on the tap frame -- the picture he
             just tapped is replaced by frame 0 as it starts to lift, which is precisely
             the "flicker" the order is about. On a `_grid3` tile there is nothing to
             correct for anyway: it is already within the first three seconds by
             construction, so the clip simply keeps playing as it rises, which is the
             literal ask ("lift up off the grid playing smoothly from within the first
             3 seconds and continue playing smoothly"). */
          if (!g3Speed) { try { if ((zVid.currentTime || 0) > 0.08) { zVid.currentTime = 0; } } catch (e) {} }
          heroExpand(cell.getBoundingClientRect(), '', zVid);
          /* ═══ THE BOOMERANG LIFT-OFF (2026-08-17) ═══════════════════════════════════════════
             Owner: "The audio should begin at finger lift off after tapping a video."
             THIS handler IS lift-off -- `click` is dispatched after `touchend`, and everything
             below it is a hero flight and an async card fetch, neither of which carries WebKit's
             activation. `__rovaBoomLift` does the three things that can only be done here:
               1. MIRRORS the boom onto its own forward phase, so the tile and the master run in
                  the SAME direction from the same content time (the owner's own diagnosis:
                  "if they were the same I would truly not see the transition"),
               2. BUILDS THE MASTER -- hidden, seeked to that mapped frame, playing, and unmuted
                  through the designated-voice arm -- because `_grid6` is `-an` and the master is
                  the only element in this open that has a sound to make, and it does not exist
                  on the page yet,
               3. hands that same element to the viewer as the donor, so ONE element carries the
                  voice from the tap to the settled viewer and nothing is ever audible twice.
             The full derivation, including why the picture handoff then waits 2-3s for the calm
             and what bounds that wait, is at __rovaBoomLift's definition.

             ONLY ON THE LIVE-HERO BRANCH, and that is the correct gate rather than a cautious
             one: this is the branch where the boom is genuinely flying as the picture, so it is
             the only branch that has a boom to keep locked. A tile that was not yet playing flies
             a still frame and the viewer uses its own clip -- there is no second direction to
             reconcile and nothing to defer, so that path stays exactly as it is.
             AFTER heroExpand, not before, for one concrete reason: the line above this branch
             nulls `__rovaGridDonor` (correctly -- on the old design this element WAS the donor),
             and the lift's own donor registration has to survive that. It is still the same
             synchronous gesture either way.
             AFTER __rovaSoundArm as well, which is further up this handler: the page-wide grant
             is taken on the tile first, so by the time the master's unmute runs the restriction
             is already lifted and the master's own play() is the one that must not be risked. */
          if (g6 && g6Dur && window.__rovaBoomLift) {
            try {
              window.__rovaBoomLift({ pid: pid, boom: zVid, pos: g6Pos, dur: g6Dur,
                master: zVid.getAttribute('data-master') || '' });
            } catch (e) {}
          }
        } else {
          heroExpand(cell.getBoundingClientRect(), videoFrameSrc(zVid) || vPoster, null);
        }
        /* BOTH OF THESE ARE ABOUT THE NEXT SECOND, NOT ABOUT THIS FRAME (2026-08-17, round D), so
           neither belongs in the gesture: the warmer pause yields bandwidth for a fill that has not
           started, and the sweep pauses OTHER tiles' decoders. Measured at ~10ms of the tap task
           (7ms of it inside pause() alone) and, more to the point, ~10ms in front of the hero's
           first painted frame. One post-paint hop; the tiles keep decoding for that one frame and
           nothing else changes. Deliberately NOT the same hop the openers' tail uses -- this fires
           whether or not an opener is reached (the landing/feed/profile branches below all return),
           so it cannot be a step of a viewer's tail. */
        (window.__rovaAfterPaint || function (f) { setTimeout(f, 0); })(function () {
          /* ...AND ONLY IF THERE IS STILL AN OPEN TO PAUSE FOR. Level-triggered, the pattern this file
             argues for elsewhere (see pfStillSync): a hero in the air OR the viewer up. A reader who
             taps and backs out inside this one hop gets nothing paused at all. */
          if (!document.documentElement.classList.contains('hz-hold')
              && !document.querySelector('.pfeed.show')) { return; }
          // Yield the pipe to the tapped clip's OWN buffering: pause the background image warmer for a moment
          // so it isn't competing for bandwidth while the clip the user just tapped fills for lightning playback.
          if (window.__rovaWarmPause) { window.__rovaWarmPause(3000); }
          // FEED GRID smoothness (owner: the feed grid, with far more posts than a profile, needs the most
          // help): the moment a clip is tapped, PAUSE every OTHER grid-preview <video> so their decoders and
          // bandwidth stop competing with the flip. They were only paused later, on rova:pfeedready (when the
          // card lands); on a busy feed grid that left a dozen clips decoding through the whole open. Keep the
          // tapped cell's own clip (cellV) running -- it IS the donor the pfeed adopts and the flip grows.
          var _paused = [];
          try {
            Array.prototype.forEach.call(document.querySelectorAll('.pgrid video.pcell-video'), function (pv) {
              if (pv !== cellV && !pv.paused) { try { pv.pause(); _paused.push(pv); } catch (e) {} }
            });
          } catch (e) {}
          /* ---- A PAUSE OWES A RESUME, AND THIS ONE HAD NONE  (2026-08-17, round E) -------------------
             MEASURED, on the SHIPPED bundle as well as this one, with tools	ail-abort-check.js: tap a
             tile and back out 60ms later and NINE OF NINE grid previews are still paused once everything
             has settled. The grid simply stops moving, and stays stopped until a scroll re-triggers
             ensureVideo or the page is reloaded. Nothing throws; there is no error to find.
             WHY IT HAD NONE: the resume lives in the rova:pfeedready handler, which attaches _grWatch to
             watch for .show being removed -- and rova:pfeedready only fires when the target card actually
             LANDS. An open abandoned before that never arms its own undo. That is the same shape as the
             pagination dead-end fixed earlier today (hz-hold paused both load-more triggers and nothing
             resumed them), which is what prompted looking here.
             THE PROMISED RESUME, bounded and level-triggered: wait out the flight, and if the viewer
             never came up, hand back exactly the elements this sweep stopped. It defers to _grWatch the
             moment the viewer IS up -- that path owns them from then on, so this can never double-play
             against it -- and it only touches elements it paused itself, which are still connected and
             still paused. 40 x 150ms caps it at 6s, comfortably past any flight. */
          if (!_paused.length) { return; }
          var _rTries = 0;
          (function _resumeWatch() {
            setTimeout(function () {
              if (document.querySelector('.pfeed.show')) { return; }   // the open landed: _grWatch owns them
              if (document.documentElement.classList.contains('hz-hold') && _rTries++ < 40) { _resumeWatch(); return; }
              _paused.forEach(function (pv) {
                if (!pv.isConnected || !pv.paused) { return; }
                try { var q = pv.play && pv.play(); if (q && q.catch) { q.catch(function () {}); } } catch (e) {}
              });
            }, 150);
          })();
        });
      }
      // WHICH SLIDE IS THIS TILE ACTUALLY SHOWING? (owner 2026-08-09: "minimize from the second slide,
      // tap it back to full screen, then swipe -- it doesn't go to the 1st slide and it only loops the
      // second video".) The dismiss DELIBERATELY leaves the tile playing the slide the reader was on: the
      // collapse REPARENTS the pfeed's current-slide <video> straight into the cell (see close()'s direct
      // land, tile.appendChild(pv)), which is the behaviour the owner asked for and likes. But every open
      // path then read the slide off the cell's STATIC href (#m<n>, emitted by views/_profile_posts.php as
      // "the first media matching the active tab") or hard-coded 0 -- so the reopen was told "this tile is
      // media 0" while the element sitting in it was media 1. The grid-tap hero flies that very element
      // (liveHero -> heroExpand(rect, '', zVid) below), so media 1 LANDED IN SLIDE 0 and slide 1's own clip
      // was evicted: the deck became [m1, m1, m2, ...]. Measured on /@grindhd 15076 -- and it PERSISTED for
      // the whole page session, because clearPfeedList() rebuilds the card markup fresh but the hero
      // overwrites slide 0 again on every subsequent open.
      // Nothing overwrote it because nothing ever RECORDED it: the tile's contents changed, its href did not.
      // So the close stamps data-gr-slide on the cell and every opener re-derives the landing slide from
      // THAT, falling back to the static href. Cleared the moment the cell rebuilds its own cover clip
      // (ensureVideo), so a tile showing its cover can never claim a slide it no longer holds.
      // Read it through the AGREEMENT TEST, against the element this open is actually flying
      // (zVid when the tile holds a playable clip, else zImg -- the same choice heroExpand was handed
      // a few lines above). The attribute alone is just a number; the test is what makes it true. A
      // released/rebuilt/re-pointed tile fails it and falls back to the href, so a stale claim can
      // never aim the hero at media it did not come from. Keeps the >= 0 test (slide 0 is a real,
      // representable answer -- the Photos/Videos tabs emit non-zero hrefs like #m1).
      var gridSlide = window.__rovaGridStampRead ? window.__rovaGridStampRead(cell, zVid || zImg) : -1;
      // LANDING teaser grid: open the immersive pfeed over the teaser's posts (guest funnel), the same
      // way the home feed grid does, landing on the tapped post. (This grid has no #feed-posts / no
      // /@user path, so without this it fell through to the old swipe gallery instead of the pfeed.)
      var landingGrid = cell.closest('.landing-grid');
      if (landingGrid && window.__rovaFeedView) {
        var lids = [];
        Array.prototype.forEach.call(landingGrid.querySelectorAll('.pcell[data-id]'), function (c) {
          var v = c.getAttribute('data-id'); if (v && lids.indexOf(v) < 0) { lids.push(v); }
        });
        if (lids.length && lids.indexOf(pid) >= 0) { window.__rovaFeedView(lids, pid, Math.max(0, gridSlide), gridT); return; }
      }
      // HOME feed grid (#feed-posts): open the immersive FEED viewer -> infinite scroll (chronological
      // loaded first, then Posts::roll('grid') high->low engagement). Not the profile viewer.
      var feedGrid = cell.closest('#feed-posts');
      if (feedGrid && window.__rovaFeedView) {
        var gids = [];
        Array.prototype.forEach.call(feedGrid.querySelectorAll('.pcell[data-id]'), function (c) {
          var v = c.getAttribute('data-id'); if (v && gids.indexOf(v) < 0) { gids.push(v); }
        });
        if (gids.length && gids.indexOf(pid) >= 0) { window.__rovaFeedView(gids, pid, Math.max(0, gridSlide), gridT); return; }
      }
      /* ---- SAVED GRID (/saved, 2026-09-29) -- BEGIN. views/saved.php marks its grid [data-svd-deck].
         A CLOSED deck: exactly the saved media on screen, in page order, under the active filter --
         a card filtered out (.svd-off) or just unsaved (.is-removed) is not in it, and neither is a
         quote card (no img/video; those are plain permalink links and never reach this handler).
         feedless=true is the profile-photo album's contract: no feed source and no loop fallback,
         so the last saved post is the end of the deck, never the discover roll. */
      var svdGrid = cell.closest('[data-svd-deck]');
      if (svdGrid && window.__rovaFeedView) {
        var sids = [];
        Array.prototype.forEach.call(svdGrid.querySelectorAll('.pcell[data-id]'), function (c) {
          var it = c.closest('.svd-item');
          if (c !== cell && it && (it.classList.contains('svd-off') || it.classList.contains('is-removed'))) return;
          if (c.classList.contains('nsfw-cell') || !c.querySelector('img, video')) return;
          var v = c.getAttribute('data-id'); if (v && sids.indexOf(v) < 0) { sids.push(v); }
        });
        if (sids.length && sids.indexOf(pid) >= 0) { window.__rovaFeedView(sids, pid, Math.max(0, gridSlide), gridT, true); return; }
      }
      /* ---- SAVED GRID -- END ---- */
      var um = location.pathname.match(/^\/@([^\/]+)/);
      var uname = um ? decodeURIComponent(um[1]) : '';
      var onTab = document.querySelector('#profile-tabs .js-tab.on');
      var tm = onTab && (onTab.getAttribute('href') || '').match(/[?&]tab=([a-z]+)/);
      var tab = tm ? tm[1] : '';
      // the Photos/Videos cell for a multi-media post carries #m<slide> so we open the exact media
      // tapped (e.g. the 2/2 photo), not the post's first slide (the 1/2 video)
      var slideM = (cell.getAttribute('href') || '').match(/#m(\d+)/);
      // data-gr-slide (what the tile is REALLY showing after a minimize) wins over the static href.
      var slideIdx = gridSlide >= 0 ? gridSlide : (slideM ? parseInt(slideM[1], 10) : 0);
      // Open the profile viewer AT the tapped post's page, not from the newest: the media grid is in the
      // same newest-first order as /profile-feed, so the cell's index IS its feed offset. (Deep-tapped posts
      // used to page from the top one fetch at a time -- that was the profile viewer's slow open.)
      var tapIdx = grid ? Array.prototype.indexOf.call(grid.querySelectorAll('.pcell'), cell) : -1;
      if (uname && window.__rovaProfileFeed) { window.__rovaProfileFeed(uname, tab, pid, slideIdx, tapIdx, gridT); return; }
      // fallback: the older horizontal swipe gallery
      var mediaCells = Array.prototype.slice.call(grid.querySelectorAll('.pcell'))
        .filter(function (c) { return c.querySelector('img, video'); });
      var list = [];
      mediaCells.forEach(function (c) { var mm = (c.getAttribute('href') || '').match(/\/p\/(\d+)/); if (mm) list.push(mm[1]); });
      if (list.length) open(list, Math.max(0, mediaCells.indexOf(cell)));
    });

    // owner: delete a post straight from the profile grid via its red-X badge
    document.addEventListener('click', function (e) {
      var del = e.target.closest ? e.target.closest('.pcell-del') : null;
      if (!del) return;
      e.preventDefault(); e.stopPropagation();
      if (busyIs(del)) return;
      if (!window.confirm('Delete this post? This can\'t be undone.')) return;
      var cell = del.closest('.pcell');
      busyUntil(del, postJson('/post/delete', { post_id: del.getAttribute('data-id') }, 15000).then(function (res) {
        if (res && (res.ok || res.id)) { if (cell) cell.remove(); if (window.__rovaReachRefresh) window.__rovaReachRefresh(); }
        else { toast('Could not delete'); }
      }).catch(function (err) {
        if (err && err.message === 'reauth') return;
        toast('Couldn’t delete, check your connection');
      }));
    });

    // let other surfaces (feed, timeline, permalink) open this rich viewer:
    // pass an ordered list of post ids + the index to start on
    window.__rovaGalleryOpen = function (list, start) {
      if (list && list.length) open(list, Math.max(0, Math.min(list.length - 1, start || 0)));
    };
  })();

  /* ═════════════════════════════════════════════════════════════════════════════════════════
     LIVE STREAMING -- THE WATCH PAGE + THE LIVE RING (2026-09-12). WEB IS WATCH-ONLY.
     ═════════════════════════════════════════════════════════════════════════════════════════
     Server: lib/live.php is THE primitive (every gate), index.php's handle_live_* are its web
     twins, views/live_watch.php is the watch page, views/live_index.php the "who is live" list.
     Nothing here decides who may watch -- the watch page only renders what Live::visibleTo allowed.

     THE WEB BROADCASTER (WHIP publish from /live/go) WAS RETIRED (Rob's decision, 2026-09-12):
     Cloudflare Stream produces no HLS playback or recording for a WHIP (WebRTC) ingested input, so a
     browser broadcast could connect but never be watched or recorded. Broadcasting is the Rova app
     over RTMP. What remains below is the LIVE RING (a live member's avatar links to their stream) and
     the WATCH PAGE (the site's own hls.js player). /live/go is now an inert "go live from the app"
     page. can_broadcast still rides /me + /api/v1/live for the APP's own broadcaster, untouched. */

  /* 0. GUESTS ON LIVE (2026-09-30, Rob: "Guests should be able to see the /live page without logging in but
        unable to actually watch a live without an account"). A GUEST's tap on anything that opens a stream --
        a /live directory card or face (a[href="/live/<id>"], carrying data-lgate="@name"), or a live ring
        (.av-live[data-live]) anywhere on the site -- opens THE GUEST GATE instead of the stream: the guest
        browse gate's own card (.guest-gate / .guest-gate-card, "Join free" / "Log in"), dismissible, saying
        "Create an account to watch @name live". Its two links are the ordinary /signup and /login links, so
        the auth modal's delegate opens the modal, and data-live-next carries the stream into the login.
        Registered BEFORE the ring delegate below and stops it (stopImmediatePropagation), in the capture
        phase so no anchor navigates first. Members never reach any of this (no rova-guest meta). Where there
        is no auth modal (the app's web view: ?app=1 renders none) nothing is intercepted: the link opens the
        /live/<id> gate page, which carries its own Log in. A modified click (new tab) is left alone too. */
  (function () {
    if (!document.querySelector('meta[name="rova-guest"]')) return;
    if (!document.getElementById('auth-modal')) return;
    var veil = null, lastFocus = null, lockedHere = false;
    function close() {
      if (!veil) return;
      var v = veil; veil = null;
      v.classList.remove('on');
      if (lockedHere && window.__rovaUnlockScroll) { window.__rovaUnlockScroll(); }
      lockedHere = false;
      setTimeout(function () { if (v.parentNode) v.parentNode.removeChild(v); }, 220);
      if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
    }
    function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    function show(id, who) {
      close();
      lastFocus = document.activeElement;
      var next = '/live/' + id;
      veil = document.createElement('div');
      veil.className = 'guest-gate lv-gsheet';
      veil.setAttribute('data-live', String(id));
      veil.innerHTML =
        '<div class="guest-gate-card glass" role="dialog" aria-modal="true" aria-labelledby="lv-gsheet-h">' +
          '<button type="button" class="lv-gsheet-x" data-lgs-close aria-label="Close">' +
            '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M6 6 18 18M18 6 6 18"/></svg></button>' +
          '<span class="lv-gsheet-ic" aria-hidden="true"><svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 10.5l5-3v9l-5-3"/><rect x="3" y="6.5" width="12" height="11" rx="2.5"/></svg></span>' +
          '<h2 id="lv-gsheet-h">' + (who ? 'Create an account to watch ' + esc(who) + ' live' : 'Create an account to watch this live') + '</h2>' +
          '<p>Live streams on Rova are for members. It’s free to join.</p>' +
          '<div class="guest-gate-acts">' +
            '<a class="btn primary" href="/signup" data-live-next="' + next + '">Sign up</a>' +
            '<a class="btn gold-ghost" href="/login" data-live-next="' + next + '">Log in</a>' +
          '</div>' +
        '</div>';
      veil.addEventListener('click', function (e) {
        if (e.target === veil || (e.target.closest && e.target.closest('[data-lgs-close]'))) { e.preventDefault(); close(); return; }
        if (e.target.closest && e.target.closest('a[href="/signup"], a[href="/login"]')) { close(); }   // the modal's delegate opens the modal
      });
      document.body.appendChild(veil);
      if (window.__rovaLockScroll) { window.__rovaLockScroll(); lockedHere = true; }
      requestAnimationFrame(function () { if (veil) veil.classList.add('on'); });
      var first = veil.querySelector('.btn.primary');
      if (first) setTimeout(function () { try { first.focus({ preventScroll: true }); } catch (e) {} }, 60);
    }
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && veil) close(); });
    document.addEventListener('click', function (e) {
      /* GUESTS WATCH (2026-10-13, Rob: "guests should be able to watch lives sure"): a guest's tap on a live now OPENS it -- the
         server answers /live/<id> with the read-only watch page, or with the gate page for a live a guest may not watch (veiled,
         a test room). This sheet only still opens for an element that asks for it (data-lgate-sheet; nothing renders one today). */
      if (!(e.target.closest && e.target.closest("[data-lgate-sheet]"))) return;
      if (!e.target.closest || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      if (veil && veil.contains(e.target)) return;
      var id = 0, who = '';
      var w = e.target.closest('.av-live[data-live]');
      if (w) { id = parseInt(w.getAttribute('data-live'), 10) || 0; }
      else {
        var a = e.target.closest('a[href]');
        var m = a ? /^\/live\/(\d{1,12})$/.exec(a.getAttribute('href') || '') : null;
        if (m) { id = parseInt(m[1], 10) || 0; who = a.getAttribute('data-lgate') || ''; }
      }
      if (!id) return;
      var gate = document.getElementById('live-gate');
      if (gate && parseInt(gate.getAttribute('data-id'), 10) === id) return;   // already on this stream's gate page
      if (!who) { var c = document.querySelector('[data-live="' + id + '"][data-lgate]'); if (c) who = c.getAttribute('data-lgate') || ''; }
      e.preventDefault();
      e.stopImmediatePropagation();
      show(id, who);
    }, true);
    window.__rovaLiveGuestGate = function () { return { open: !!veil, id: veil ? veil.getAttribute('data-live') : null }; };
  })();

  /* 1. THE LIVE RING (web twin of `is_live` on Api::userCard). avatar_img() wraps a live member's
        avatar in .av-live[data-live=<stream id>] everywhere it draws one -- profile, hover card,
        post author, follower rows, search. A tap on the ring goes to the stream, ahead of the
        profile link every avatar already sits in (capture phase, so the anchor never sees it).
        On that stream's own watch page the ring is inert and the profile link works as usual. */
  document.addEventListener('click', function (e) {
    var w = e.target.closest ? e.target.closest('.av-live[data-live]') : null;
    if (!w) return;
    var id = parseInt(w.getAttribute('data-live'), 10);
    if (!id) return;
    var here = document.getElementById('live-watch');
    if (here && parseInt(here.getAttribute('data-id'), 10) === id) return;
    e.preventDefault();
    e.stopPropagation();
    window.location.href = '/live/' + id;
  }, true);

  /* 2. THE BROADCASTER (/live/go) -- RETIRED 2026-09-12 (Rob's decision). The web is WATCH-ONLY;
        broadcasting is the Rova app over RTMP. Cloudflare Stream produces no HLS playback or a
        recording for a WHIP (WebRTC) ingested input, so a browser WHIP publish could connect but
        never be watched or recorded (that was stream #54). The getUserMedia + WHIP module was
        removed; views/live_go.php is now an inert "go live from the app" page and nothing on the web
        links to it. Watching stays fully on the web -- the live ring above, the watch page below. */

  /* 3. THE WATCH PAGE (/live/{id}). The site's own hls.js (lazy, same file the feed uses), the
        mute toggle, the report control (POST /live/{id}/report), the viewer count from the 5 s poll,
        the veil applied mid-stream when the poll says nsfw (gate markup #1, same as the server
        renders), and the two end states: status ended -> "This stream has ended" (+ replay when
        there is one), a 404 -> "This stream was ended" (killed). Either way the reader is returned
        to /live after a short countdown unless they touch anything. */
  /* MOUNTABLE (2026-10-04): runs once at load AND on `rova:live-mount` -- /live/studio moves its waiting screen into the
     creator's live room IN PLACE when the video is confirmed (assets/livestudio.js goLive) and asks for the room to be
     mounted. Each #live-watch element is mounted at most once (root.__lwMounted). */
  /* THE CALL, RE-TILED FOR A WIDE SCREEN (2026-10-08, Rob on @Fresh's guest page on a desktop: a portrait call composite (720x1280, two
     people stacked) cover-cropped into the wide box, "we can't see each person; they should be in 2 boxes left and right"). The SHARED
     GEOMETRY for both surfaces that do it: liveWatch (the signed-in player, canvases fed from the ONE <video>) and the guest gate (the
     dimmed still behind the sign-up card, <img> crops of the same /live/thumb frame). Given the composite's tiles (frame px, 2-4 people,
     stream.composite.layout.tiles = LiveRealtime::gridTiles) and the box to fill (W x H css px), one box per person, in tile order:
       2 people   left | right
       3 people   three columns, the HOST IN THE MIDDLE: guest 1 | host | guest 2 (the guests in their on-air order round the host;
                  Rob 2026-10-08: "I want the host in the middle")
       4 people   2 x 2, in the frame's own order
     Each box COVER-fits its tile's crop (a 2 frame-px inset hides the painter's separators); a tile cropped top/bottom keeps 40% of the
     cut above the face line (a camera's face sits a little high). -> [{l, t, w, h (css px), cx, cy, cw, ch (frame px), k (css px per
     frame px)}] | null. */
  /* ROOM BOX COUNT (2026-10-15): a ROOM picture's tiles = the host's seat 0 first + 1..5 seats (the host picks the count), so a room is
     "tile 0 carries seat 0" (grid tiles have no seat), never "six tiles" */
  function rovaRoomTiles(t) { return !!(t && t.length >= 2 && t.length <= 7 && t[0] && t[0].seat != null && +t[0].seat === 0); }   // SIX SEATS (2026-10-16): 1..6 seats
  window.__rovaRoomTiles = rovaRoomTiles;
  /* DESKTOP ROOM LAYOUT B (2026-10-16, Rob picked mock B: "the black bar for all the stuff ... so nothing blocks her screen except her
     name"): lay = 'b' -> a ROOM's host takes the LEFT HALF at full height, the seats fill the right half in rows of 2 (1 seat = the whole
     half; 2 = stacked, which crops a camera less than two slivers; an odd last seat spans its row), so 6 seats = 2 x 3. Used by liveWatch
     (lwRoomB: the viewer's re-tile) and liverealtime.js (a seated guest's own canvas). */
  function rovaRetilePlan(tiles, W, H, gap, lay, hi) {
    var room = rovaRoomTiles(tiles);   // OPEN ROOMS (db/0253) + ROOM BOX COUNT: the host + its 1..6 seats (6 = 3 x 2, even)
    var n = tiles ? Math.min(room || lay === 'b' ? 7 : 4, tiles.length) : 0;
    if (n < 2 || !(W > 0 && H > 0)) return null;
    var g = gap || 0, cands = [];
    function cols(k) { var w = (W - (k - 1) * g) / k, o = []; for (var i = 0; i < k; i++) o.push({ l: i * (w + g), t: 0, w: w, h: H }); return o; }
    if (room && lay === 'b') {
      var bns = n - 1, bhw = Math.round((W - g) / 2), brx = bhw + g, bRW = W - brx;
      for (var bnc = 1; bnc <= Math.min(2, bns); bnc++) {
        var bnr = Math.ceil(bns / bnc), brh = (H - (bnr - 1) * g) / bnr, bb = [{ l: 0, t: 0, w: bhw, h: H }];
        for (var bi = 0; bi < bns; bi++) {
          var brow = Math.floor(bi / bnc), bk = brow === bnr - 1 ? bns - brow * bnc : bnc, bcw = (bRW - (bk - 1) * g) / bk;
          bb.push({ l: brx + (bi % bnc) * (bcw + g), t: brow * (brh + g), w: bcw, h: brh });
        }
        cands.push(bb);
      }
    }
    /* GRID CALLS IN LAYOUT B (2026-10-16, Rob on @cognac's 4-person co-host call #2922 in desktop Safari: "look more like the TV"): a grid
       call's people fill the stage evenly -- 2 = side by side; 4 = 2 x 2; 3 = the host the left half + the two guests stacked on the
       right; 5..7 = the host the left half + the rest 2 to a row on the right (an odd last one spans its row). hi = the host's tile index
       (the band puts a 3-person host in the MIDDLE); the host always gets the first box (top-left: the stage's host pill sits on it). */
    else if (lay === 'b') {
      var gs = [], gw2 = (W - g) / 2, gh2 = (H - g) / 2;
      if (n === 2) gs = cols(2);
      else if (n === 4) gs = [{ l: 0, t: 0, w: gw2, h: gh2 }, { l: gw2 + g, t: 0, w: gw2, h: gh2 }, { l: 0, t: gh2 + g, w: gw2, h: gh2 }, { l: gw2 + g, t: gh2 + g, w: gw2, h: gh2 }];
      else {
        var gns = n - 1, gnc = gns === 2 ? 1 : 2, gnr = Math.ceil(gns / gnc), ghw = Math.round((W - g) / 2), grx = ghw + g, gRW = W - grx, grh = (H - (gnr - 1) * g) / gnr;
        gs = [{ l: 0, t: 0, w: ghw, h: H }];
        for (var gi = 0; gi < gns; gi++) {
          var grow = Math.floor(gi / gnc), gk = grow === gnr - 1 ? gns - grow * gnc : gnc, gcw = (gRW - (gk - 1) * g) / gk;
          gs.push({ l: grx + (gi % gnc) * (gcw + g), t: grow * (grh + g), w: gcw, h: grh });
        }
      }
      var gh = hi >= 0 && hi < n ? hi : 0, gb = [], gq = 1;
      for (var gj = 0; gj < n; gj++) gb.push(gj === gh ? gs[0] : gs[gq++]);
      cands.push(gb);
    }
    else if (room) {
      var ns = n - 1, nc = Math.min(3, ns), nr = Math.ceil(ns / nc);   // ROOM BOX COUNT: the seats in up to 3 columns (5 = 3 x 2, as before)
      var hw = Math.round(W * (ns === 1 ? 0.5 : 0.4)), rx = hw + g, cw = (W - rx - (nc - 1) * g) / nc, chh = (H - (nr - 1) * g) / nr, rb = [{ l: 0, t: 0, w: hw, h: H }];
      for (var si = 0; si < ns; si++) rb.push({ l: rx + (si % nc) * (cw + g), t: Math.floor(si / nc) * (chh + g), w: cw, h: chh });
      cands.push(rb);
    }
    else if (n === 2) cands.push(cols(2));
    else if (n === 3) { var c3 = cols(3); cands.push([c3[1], c3[0], c3[2]]); }   // tile 0 (the host) -> the middle column
    else {
      var qw = (W - g) / 2, qh = (H - g) / 2;
      cands.push([{ l: 0, t: 0, w: qw, h: qh }, { l: qw + g, t: 0, w: qw, h: qh }, { l: 0, t: qh + g, w: qw, h: qh }, { l: qw + g, t: qh + g, w: qw, h: qh }]);
    }
    var best = null, bs = -1;
    for (var c = 0; c < cands.length; c++) {
      var s = 0;
      for (var j = 0; j < n; j++) { var b = cands[c][j], ta = (+tiles[j].w || 1) / (+tiles[j].h || 1), ba = b.w / b.h; s += Math.min(ta, ba) / Math.max(ta, ba); }
      if (s > bs) { bs = s; best = cands[c]; }
    }
    var out = [];
    for (var i = 0; i < n; i++) {
      var t = tiles[i], B = best[i], x = +t.x + 2, y = +t.y + 2, w = Math.max(1, +t.w - 4), h = Math.max(1, +t.h - 4);
      var ar = B.w / B.h, cx = x, cy = y, cw = w, ch = h;
      if (w / h > ar) { cw = h * ar; cx = x + (w - cw) / 2; } else { ch = w / ar; cy = y + (h - ch) * (lay === 'b' ? 0.5 : 0.3); }   // 2026-10-12: object-position center 30% (heads stay in); LAYOUT B (Rob 10-16): centred -- a wide seat tile from a portrait camera showed the ceiling, not the face
      out.push({ l: Math.round(B.l), t: Math.round(B.t), w: Math.round(B.l + B.w) - Math.round(B.l), h: Math.round(B.t + B.h) - Math.round(B.t), cx: cx, cy: cy, cw: cw, ch: ch, k: B.w / cw });
    }
    return out;
  }
  window.__rovaRetilePlan = rovaRetilePlan;
  /* THE BUBBLE STAGE'S LAYOUT (2026-10-22, WS-D; Rob: "layout by number of people"; liveWatch bubPaint, liverealtime.js's host preview, the
     apps + Apple TV draw the same, to-ios.md "WS-D live visual system"). n people in a W x H region, g px apart; asp[i] = person i's
     picture shape (w / h; slot 0 = the HERO, the big box). Candidates by count, the best by how well each box fits its picture's shape
     (a portrait camera in a wide box loses its head) weighted by size, the hero's twice:
       1  the whole region
       2  side by side | stacked
       3  the hero the left half + 2 stacked on the right | the hero on top + 2 side by side under
       4  2 x 2
       5+ the hero the left half + the rest 2 to a row on the right (an odd last one spans its row) | the hero on top + a row (grid) under
     -> [{l, t, w, h}] in slot order (region px). */
  function rovaBubblePlan(n, W, H, g, asp) {
    if (!(n >= 1) || !(W > 0 && H > 0)) return null;
    g = g || 0; asp = asp || [];
    function A(i) { var a = +asp[i]; return a > 0.2 && a < 5 ? a : 0.75; }
    function rows(n2, x0, y0, w0, h0, per) {   // n2 boxes in rows of `per`, an odd last row's boxes widen to fill it
      var o = [], nr = Math.ceil(n2 / per), rh = (h0 - (nr - 1) * g) / nr;
      for (var i = 0; i < n2; i++) {
        var r = Math.floor(i / per), k = r === nr - 1 ? n2 - r * per : per, cw = (w0 - (k - 1) * g) / k;
        o.push({ l: x0 + (i % per) * (cw + g), t: y0 + r * (rh + g), w: cw, h: rh });
      }
      return o;
    }
    var C = [];
    if (n === 1) C.push([{ l: 0, t: 0, w: W, h: H }]);
    else if (n === 2) { C.push(rows(2, 0, 0, W, H, 2)); C.push(rows(2, 0, 0, W, H, 1)); }
    else if (n === 4) C.push(rows(4, 0, 0, W, H, 2));
    else {
      var hw = Math.round((W - g) / 2), rx = hw + g;
      if (!(W < 600 && W / H < 1.3)) C.push([{ l: 0, t: 0, w: hw, h: H }].concat(rows(n - 1, rx, 0, W - rx, H, n - 1 <= 2 ? 1 : 2)));
      var hh = Math.round((H - g) * (n <= 3 ? 0.58 : 0.55)), ry = hh + g;
      C.push([{ l: 0, t: 0, w: W, h: hh }].concat(rows(n - 1, 0, ry, W, H - ry, n - 1 <= 3 ? n - 1 : Math.ceil((n - 1) / 2))));
    }
    var best = null, bs = -1;
    for (var c = 0; c < C.length; c++) {
      var s = 0;
      for (var j = 0; j < n; j++) { var b = C[c][j], ba = b.w / b.h, ta = A(j); s += Math.min(b.w, b.h) * (0.5 + 0.5 * Math.min(ta, ba) / Math.max(ta, ba)) * (j === 0 ? 2 : 1); }   // BUBBLE POLISH (2026-10-22, Rob: faces must be visible on a phone): the short side
      if (s > bs + 0.001) { bs = s; best = C[c]; }
    }
    return best.map(function (b) { return { l: Math.round(b.l), t: Math.round(b.t), w: Math.round(b.l + b.w) - Math.round(b.l), h: Math.round(b.t + b.h) - Math.round(b.t) }; });
  }
  window.__rovaBubblePlan = rovaBubblePlan;
  window.__rovaLiveMountable = true;
  document.addEventListener('rova:live-mount', function () { liveWatch(); });
  liveWatch();
  function liveWatch() {
    var root = document.getElementById('live-watch');
    if (!root || root.__lwMounted) return;
    root.__lwMounted = true;
    var id = parseInt(root.getAttribute('data-id'), 10) || 0;
    var v = document.getElementById('live-player'), stage = document.getElementById('live-stage');
    var viewersEl = document.getElementById('live-viewers'), elapsedEl = document.getElementById('lw-elapsed'),
        muteBtn = document.getElementById('lw-mute'), endedBox = document.getElementById('lw-ended'),
        endedMsg = document.getElementById('lw-ended-msg'), replayA = document.getElementById('lw-replay'),
        endedSub = document.getElementById('lw-ended-sub'),
        countEl = document.getElementById('lw-count'), reportBtn = document.getElementById('lw-report'),
        endBtn = document.getElementById('lw-end'), visBtn = document.getElementById('lw-vis');   // db/0247: the host's Public / Private control
    var status = root.getAttribute('data-status') || '';
    var veiled = root.getAttribute('data-veiled') === '1';
    /* GUESTS WATCH (2026-10-13, Rob: "guests should be able to watch lives sure"): #live-watch[data-guest] = a signed-out viewer of a
       live a guest may watch (routes/live.php live_guest_watch). Their poll carries `gv` = this browser's own anonymous id
       (localStorage rova_gv, minted once; no cookie): the server counts it in the viewer count from Redis only (Live::guestPing) --
       never a member list, never Live Rewards. A live that turns explicit / veiled for them (stream.nsfw, or guest_watch false: the
       guest gate's answer) is LOCKED, never veiled: the player stops and unloads, the stage shows the sensitive-content card with
       Sign up / Log in (a guest is never age-verified, so there is no "Show anyway"). */
    var GUEST = root.getAttribute('data-guest') === '1', guestId = '', guestLocked = false;
    if (GUEST) {
      try { guestId = localStorage.getItem('rova_gv') || ''; } catch (e) { guestId = ''; }
      if (!/^[A-Za-z0-9_-]{16,64}$/.test(guestId)) {
        try { var ga = new Uint8Array(16); crypto.getRandomValues(ga); guestId = Array.prototype.map.call(ga, function (b) { return ('0' + b.toString(16)).slice(-2); }).join(''); }
        catch (e) { guestId = (Date.now().toString(36) + Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2)).slice(0, 32); }
        try { localStorage.setItem('rova_gv', guestId); } catch (e) {}
      }
    }
    /* THE GUEST MINUTE (2026-10-15, Rob: "limit guests to a minute of live watching to protect server costs"; routes/live.php
       live_guest_poll_answer). Every guest poll carries guest_watch_left_s (seconds of live watching this device has left today, across
       every live; null = no limit). In the last 15 s a small chip counts down ("Sign up to keep watching · 0:12", a sign-up door:
       guestChipPaint); at 0 the server answers guest_watch:false + reason "guest_time_up" and NO manifest -> guestTimeUp(): the player
       stops and unloads, the stage shows "Enjoying the live? Sign up free to keep watching." with Sign up / Log in (back to this live
       after auth). The HTML stays edge-cached and identical for every guest, so the per-guest part is here: localStorage rova_gtu = when
       the server said the minute comes back; a page opened before then HOLDS the player (guestHold) until its first poll (sent at once)
       says it may play, so a used-up guest never pulls a frame. */
    var guestEnd = 0, guestChip = null, guestChipT = null, guestZeroAsked = false, guestHold = false;
    if (GUEST && (status === 'live' || status === 'created')) {
      try { guestHold = +(localStorage.getItem('rova_gtu') || 0) > Date.now(); } catch (e) { guestHold = false; }
    }
    var startedAt = Date.parse(root.getAttribute('data-started') || '') || 0;
    // THE CAP (db/0209): data-ends / stream.ends_at reach the BROADCASTER (and staff) only. Re-based on every poll from
    // time_left_s (server truth), so a skewed device clock cannot move the countdown.
    var endsAt = Date.parse(root.getAttribute('data-ends') || '') || 0, leftEl = document.getElementById('lw-left');
    var pollT = null, tickT = null, done = false;
    var draining = false, drain = null, drainT = null;   // LET THE LAST SECONDS PLAY (2026-10-05): see endOrDrain()
    /* AN ENDED PAGE IS ALREADY DONE (2026-10-03, Rob: "BUG: Overlapping"). A page opened on an ended/killed stream is drawn
       with its end state by the server (views/live_watch.php fills #lw-ended). It used to start with done=false, so the
       tab-return handler below polled, learned "ended" and ran ended() over it: a second end card stacked on the server's
       "being prepared" line, plus a "Returning to Live" countdown nobody asked for. Nothing below may run on such a page. */
    if (status !== 'live' && status !== 'created') { done = true; }
    var nativeHls = !!(v && v.canPlayType && v.canPlayType('application/vnd.apple.mpegurl'));
    // LIVE DELAY (see llS below): a NON-Apple browser that also has native HLS (Chrome / Edge) plays with hls.js when the low-latency
    // player is on: Chromium's native HLS showed no frame on the ?protocol=llhls playlist (rig) and sits ~15 s behind on a plain one
    if (nativeHls && v && v.getAttribute('data-ll') && !/Apple/.test(navigator.vendor || '') && (window.MediaSource || window.ManagedMediaSource)) nativeHls = false;
    var srcHls = v ? (v.getAttribute('data-hls') || '') : '';
    /* LIVE DELAY (2026-10-16, Rob: "Mike Luie says he's not feeling the delay"). data-ll="<plain s> <parts s>" on #live-player
       (views/live_watch.php, k/v live_lowlat_web; absent / "0" = the old player) turns on the low-latency player:
         - hls.js (every non-Apple browser, Chrome / Edge included: see nativeHls above) loads the ?protocol=llhls manifest. An
           input born on Cloudflare's low-latency pipeline (CfStream::createLiveInput, k/v live_cf_lowlat) answers with 0.5 s parts:
           hls.js sits llP s behind the live edge (0.5 s parts, PART-HOLD-BACK 1.5). Any other input answers a PLAIN playlist from the
           same URL (proved on a real member input): hls.js sits max(llS, TARGETDURATION + 1.5) behind its end. Was 3 x
           TARGETDURATION (12-15 s) with no catch-up: the picture drifted 16 -> 23 s behind the camera. Safari keeps the plain URL.
         - a line that cannot keep up with parts drops to whole segments for the visit (llDegraded, below).
         - catch-up: hls.js's own 1.1x (maxLiveSyncPlaybackRate) for a few seconds late; it gives up past target + TARGETDURATION,
           so lwCatchUp() (health tick) jumps to liveSyncPosition beyond that (<= 1 per 15 s). Safari native: 1.08x while > 1.5 s
           behind its target, a jump past 8 s.
       MEASURED (scratchpad latency\, a burned-in wall clock vs the viewer's screen): Cloudflare lists a plain segment 2 GOPs +
       ~3.5 s after its first frame (10.3 s at our 3 s GOP), so the plain floor is ~12-14 s; parts ~3-5 s. dbg.ll. */
    var llS = 0, llP = 4, llJumpAt = 0, llParts = null, llDegraded = false, llStalls = [];
    (function () {
      var a = String((v && v.getAttribute('data-ll')) || '').split(/[\s,]+/);
      llS = Math.max(0, Math.min(20, parseFloat(a[0]) || 0)); llP = Math.max(1, Math.min(20, parseFloat(a[1]) || 4));
      // Safari's NATIVE player keeps the plain URL until LL-HLS on Cloudflare's beta is proven on a real Safari (this box cannot play WebKit video)
      // 2026-10-16: only an input that really is low-latency (data-llin, views/live_watch.php) is asked for ?protocol=llhls; a plain one keeps its URL
      if (llS && !nativeHls && v.getAttribute('data-llin') === '1' && srcHls && srcHls.indexOf('protocol=llhls') < 0) srcHls += (srcHls.indexOf('?') < 0 ? '?' : '&') + 'protocol=llhls';
    })();
    /* LIVE DELAY: a line that cannot keep up with 0.5 s parts drops to whole segments for the rest of the visit: >= 4 s spent stalled
       (over >= 2 stalls) or >= 6 stalls inside a minute on a parts playlist -> hls.lowLatencyMode = false + the plain target. Rig: a
       300 ms RTT / 2 Mbit/s line stalled 46 s in 8 min on parts; a good line's ~0.2 s micro-stalls never add up to it. */
    if (llS && v) {
      var llWaitAt = 0;
      v.addEventListener('waiting', function () { if (playbackStarted && llParts && !llDegraded && hls) llWaitAt = Date.now(); });
      v.addEventListener('playing', function () {
        if (!llWaitAt) return;
        var now = Date.now(), ms = 0; llStalls.push([now, now - llWaitAt]); llWaitAt = 0;
        llStalls = llStalls.filter(function (x) { return now - x[0] < 60000; });
        llStalls.forEach(function (x) { ms += x[1]; });
        if (llDegraded || !llParts || !hls || !((ms >= 4000 && llStalls.length >= 2) || llStalls.length >= 6)) return;
        llDegraded = true; llParts = false;
        try { hls.lowLatencyMode = false; hls.config.liveSyncDuration = Math.max(llS, (lwTD || 2) + 1.5); } catch (e) {}
      });
    }
    /* SIGNED LINKS, WEB RENEWAL (2026-10-15, window.__rovaCf at the top of this file): a token URL is renewed by THIS page's poll
       (stream.playback.hls, freshly minted on every poll). hls.js re-tokens every request itself; srcHls follows the freshest token
       (probes, re-joins); Safari's native player is re-sourced at the live edge ~20 s before its token expires (lwCfPlayback). */
    var cfLive = window.__rovaCf || null, cfUid = '';
    if (v && cfLive && srcHls) {
      v.__rvLive = true;
      var cfN0 = cfLive.note(srcHls); cfUid = cfN0 ? cfN0.uid : '';
      if (cfUid) cfLive.reg(cfUid, function () { return poll(true); });
    }
    var hls = null, playbackStarted = false, attempts = 0, retryT = null, watchT = null,
        probing = false, giveUp = false, loopStart = 0, waitEl = null, lastRecover = 0, prevStatus = status;
    var RETRY_MAX_MS = 60000;
    // BE RIGHT BACK (db/0219): the server holds a dropped live for its reconnect grace (stream.connection 'reconnecting').
    var brbEl = document.getElementById('lw-brb');
    var connection = root.getAttribute('data-connection') || (status === 'live' ? 'live' : '');
    var localWhy = '', lastCt = -1, ctMovedAt = Date.now(), lastFrames = -1, framesMovedAt = Date.now(), stallSince = 0,
        rejoinN = 0, rejoinAt = 0, resumeAt = 0, edgeSN = -1, edgeMovedAt = 0, levelAt = 0, healthT = null;
    // THE STALL WATCHDOG (2026-10-06, see health()): windowed progress, the paused-player rule, the resume fast path
    var ctHist = [], frAnchor = -1, pausedSince = 0, nudgeAt = 0, nudges = [], fastUntil = 0, lastRc = -1, edgeCheckAt = 0;
    // A PLANNED ORIENTATION SWITCH (db/0241): stream.switching + stream.orientation_switch {orientation, declared_at, measured, ...}
    var switching = false, swKey = '', swMeasuredAt = 0, swRejoined = false;
    var dbg = { status: status, veiled: veiled, viewers: 0, polls: 0, ended: false, endedMsg: '', hls: '', muted: true,
                attempts: 0, reattaches: 0, playing: false, giveUp: false, waiting: false, skippedHidden: 0,
                connection: connection, brb: false, brbWhy: '', rejoins: 0,
                wd: { nudges: 0, resumes: 0, lastResume: '', toEdge: 0, pausedFor: 0, fight: false, fast: false } };

    /* ---- A HIDDEN TAB IS NOT A VIEWER -- UNLESS IT IS A LISTENER (2026-09-19) --------------------
       `GET /live/{id}?ajax=1` is not a status read, IT IS THE VIEWER HEARTBEAT: handle_live_watch ->
       Live::viewerPing() upserts live_viewers.seen_at, "watching now" is COUNT(*) of rows seen inside
       VIEWER_WINDOW (30s), and live_streams.peak_viewers is ratcheted with GREATEST and never comes
       back down. So a poll from a tab nobody is looking at does not merely cost a request -- it
       publishes a claim about an audience, to the broadcaster and to every other viewer. MEASURED on
       the shipped bundle `app.d72c3a79c5cb`: 30s hidden = 6 polls, cadence unchanged, the viewer row's
       seen_at tracking the whole window. `viewer_key` is 'u<id>', so one person is one row however
       many tabs they open -- the count can never be MULTIPLIED by one person. What it could be is
       HELD: open a stream, background the tab, and you counted until the stream ended.

       THE DECISION, recorded because it is a decision and not an omission: A BACKGROUNDED LISTENER
       STILL COUNTS; A BACKGROUNDED SILENT TAB DOES NOT. Someone who unmutes a stream and switches
       away is genuinely in the audience -- the audio is exactly what they switched away to keep, and
       the video governor below deliberately leaves an UNMUTED clip running for that reason. (2026-10-02: it no
       longer does -- a hidden page pauses every clip incl. this player, so a backgrounded tab now drops out of the
       count like a silent one, and is counted again the moment it comes back. A lock-screen play still counts.) Dropping
       them would under-report as dishonestly as a dead tab over-reports. So the test is the one the
       wake-lock governor already uses for this same question (wlAudible, ~:21690): connected,
       unpaused, unended, unmuted, volume above zero. Everything else -- the default muted autoplay,
       a paused player, a player the hidden-tab video governor stopped -- falls out of the count
       within one VIEWER_WINDOW instead of holding a seat forever. Coming back polls at once, so the
       count returns immediately; and because the poll is SKIPPED rather than the interval cleared, a
       reader who unmutes while hidden starts counting again on the very next tick with no re-arm.
       Do NOT "simplify" this to `!document.hidden`: that rule is stricter and WRONG, for the reason
       above. It is also not a moderation hole -- the Phase 3 frame sampler self-chains for as long as
       any stream is live and is re-armed by the 5-minute worker tick; sync()'s kickSampler off a
       viewer poll is a bonus, never the schedule. */
    function lwAudible() {
      return !!(v && v.isConnected && !v.paused && !v.ended && !v.muted && v.volume > 0);
    }
    function lwCounts() { return !document.hidden || lwAudible(); }
    try { Object.defineProperty(window, '__rovaLiveWatch', { get: function () { return dbg; }, configurable: true }); } catch (e) {}
    var EYE = '<svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>';

    function hlsLib(cb) {
      if (window.Hls) { cb(); return; }
      var s = document.createElement('script'); s.src = '/assets/hls.min.js'; s.async = true;
      s.onload = cb; s.onerror = function () { dbg.hls = 'load-failed'; };
      document.head.appendChild(s);
    }
    // ---- BOUNDED MANIFEST-READY RETRY (2026-09-12) --------------------------------------------
    // A real live HLS manifest is 204/404 for the first several seconds while Cloudflare spins the
    // stream up (RTMPS push -> row `live` ~7s, master+segments ~8s); the old player set the source
    // ONCE and never recovered, so a viewer who opened in that window saw nothing forever. We now
    // PROBE data-hls on a 1s/2s/3s/…/4s backoff for up to ~60s, attaching only once the manifest is
    // really there, and re-attaching after a cold-start error -- but NEVER touching the source once
    // playback has begun (that would reset a live stream). Manifest-not-ready and stream-ended are
    // DIFFERENT conditions: the poll owns stream-ended (status leaves live / GET 404) via ended(),
    // and the retry loop stops the moment ended() runs, so the two never fight.
    function backoffDelay() { return Math.min(4000, Math.max(1000, attempts * 1000)); }
    function withinBudget() {
      // A stream that already played and is still LIVE (re-joining after a drop) is never given up on: the poll ends it.
      if (rejoinN > 0 && status === 'live') return true;
      if (loopStart && Date.now() - loopStart > RETRY_MAX_MS) { giveUp = true; dbg.giveUp = true; showWaiting(); return false; }
      return true;
    }
    function showWaiting() {
      dbg.waiting = true;
      if (!stage || done) return;
      if (!waitEl) { waitEl = document.createElement('div'); waitEl.className = 'lw-msg lw-wait'; waitEl.setAttribute('role', 'status'); stage.appendChild(waitEl); }
      waitEl.textContent = 'Waiting for the stream to start…';
    }
    function hideWaiting() { dbg.waiting = false; if (waitEl) { waitEl.remove(); waitEl = null; } }
    // Attach or re-attach the HLS source. Called ONLY while nothing is playing, so resetting the
    // native src / re-loading the manifest can never interrupt a live playback in progress.
    function attach() {
      if (!v || playbackStarted || done) return;
      dbg.reattaches++;
      if (nativeHls) {
        if (!v.getAttribute('src') || v.error || v.readyState === 0) { try { v.src = srcHls; v.load(); } catch (e) {} }
        lwPlay();   // SOUND ON ENTRY: unmuted first where the browser allows it (see lwPlay)
        dbg.hls = 'native';
      } else {
        hlsLib(function () {
          if (!(window.Hls && Hls.isSupported())) { dbg.hls = 'none'; return; }
          // backBufferLength: hls.js 1.5 defaults it to Infinity, so an hour on air kept the whole hour in the SourceBuffer.
          // Only the played part is trimmed; the forward buffer is bounded by the live edge and liveSync is untouched.
          if (!hls) { hls = new Hls(llS ? { lowLatencyMode: !llDegraded, liveSyncDuration: llS, maxLiveSyncPlaybackRate: 1.1, backBufferLength: 30 }   // LIVE DELAY: see llS
                                         : { lowLatencyMode: true, liveSyncDurationCount: 3, backBufferLength: 30 }); hls.attachMedia(v); wireHls(hls); dbg.hls = 'hls.js'; }
          try { hls.loadSource(srcHls); } catch (e) {}
          lwPlay();   // explicit (was the autoplay attribute): unmuted first where allowed, else muted + "Tap for sound"
        });
      }
    }
    function wireHls(h) {
      h.on(Hls.Events.FRAG_BUFFERED, onPlaying);
      // the live edge (db/0219): has the playlist grown since playback stuck? (a reload is also the loader's pulse)
      h.on(Hls.Events.LEVEL_UPDATED, function (evt, data) {
        levelAt = Date.now();
        if (data && data.details && data.details.targetduration > 0) lwTD = +data.details.targetduration;   // lwLatency's edge estimate
        try { var lfr = data.details.fragments, lsd = lfr && lfr.length ? +lfr[lfr.length - 1].duration : 0; if (lsd > 0.5 && lsd < 12) lwSeg = lsd; } catch (e) {}   // the newest segment's length (lwEdgeLag)
        // LIVE DELAY: parts (a low-latency input) -> llP behind the edge; a plain playlist -> max(llS, TARGETDURATION + 1.5)
        if (llS && data && data.details) {
          llParts = !!(data.details.partList && data.details.partList.length) && !llDegraded;
          try { h.config.liveSyncDuration = llParts ? llP : Math.max(llS, (+data.details.targetduration || 2) + 1.5); } catch (e) {}
        }
        var sn = data && data.details ? data.details.endSN : -1;
        if (typeof sn === 'number' && sn !== edgeSN) { edgeSN = sn; edgeMovedAt = Date.now(); }
        if (draining && data && data.details && data.details.live === false && dbg.drain) dbg.drain.endlist = true;   // #EXT-X-ENDLIST: 'ended' follows
      });
      h.on(Hls.Events.ERROR, function (evt, data) {
        if (!data || !data.fatal) return;
        dbg.hlsErr = data.details || data.type;
        if (playbackStarted) { gentle(data.type === Hls.ErrorTypes.MEDIA_ERROR ? 'media' : 'net'); return; }
        clearTimeout(watchT);
        // Cold start: a manifest/network fatal (incl. MANIFEST_LOAD_ERROR) goes back through the
        // probe; a media error before we ever played is recoverable in place.
        if (data.type === Hls.ErrorTypes.MEDIA_ERROR) { try { h.recoverMediaError(); } catch (e) {} armWatchdog(); }
        else { try { h.stopLoad(); } catch (e) {} scheduleRetry(); }
      });
    }
    // Probe data-hls. 204 / 404 / empty / not-a-manifest => not ready yet => back off and retry.
    // Manifest-only fetch, no speculative buffering -- there is nothing here for the slow-line gate
    // to bite on, and the <video> itself is the watched stream (deliberately allowed to load).
    function tryStart() {
      if (!v || done || giveUp || playbackStarted || probing) return;
      // Nobody can watch a stream come up in a tab they are not looking at, and the 60s budget is
      // wall-clock: a minute spent hidden would spend the whole of it on probes for no reader and
      // then give up just as they came back. The visibilitychange handler at the foot of this module
      // re-arms the SAME bounded loop on return, budget and all.
      if (document.hidden) return;
      if (!withinBudget()) return;
      attempts++; dbg.attempts = attempts;
      probing = true;
      rfetch(srcHls, { credentials: 'omit', cache: 'no-store', headers: { 'Accept': 'application/vnd.apple.mpegurl,application/x-mpegURL,*/*' } }, 6000)
        .then(function (r) { if (r.status === 204) throw new Error('204'); return r.text(); })
        .then(function (body) {
          probing = false;
          if (done || giveUp || playbackStarted) return;
          if (!body || body.indexOf('#EXTM3U') === -1) { scheduleRetry(); return; }
          attach(); armWatchdog();
        })
        .catch(function (err) {
          probing = false;
          // SIGNED LINKS: the CDN refused the token (Cloudflare says 401; 403 the same) -> re-read once via the poll, then retry
          if (err && (err.status === 401 || err.status === 403) && cfLive && cfUid) {
            dbg.cfAuth = (dbg.cfAuth || 0) + 1;
            cfLive.renew(cfUid).then(function () { srcHls = cfLive.fresh(srcHls); scheduleRetry(); }, function () { scheduleRetry(); });
            return;
          }
          scheduleRetry();
        });
    }
    /* SIGNED LINKS (2026-10-15): every poll answer carries a fresh token (stream.playback.hls). Remember it; follow it in srcHls; and
       re-source Safari's NATIVE player (it holds its URL) at the live edge once its own token is within 20 s of expiry. */
    function lwCfPlayback(s) {
      if (!cfLive || !s) return;
      // a battle's halves (assets/livebattle.js plays the opponent from stream.battle): their fresh tokens ride the same poll, so
      // every hls.js request of that player is re-tokened too (the Hls.DefaultConfig hook); a battle is far shorter than a web token
      try { ['left', 'right'].forEach(function (k) { var h = s.battle && s.battle[k] && s.battle[k].playback; if (h && h.hls) cfLive.note(h.hls); }); } catch (e) {}
      if (!s.playback || !s.playback.hls) return;
      var n = cfLive.note(s.playback.hls); if (!n) return;
      if (!cfUid) { cfUid = n.uid; cfLive.reg(cfUid, function () { return poll(true); }); }
      srcHls = cfLive.fresh(srcHls);
      if (!v || !nativeHls || done || draining) return;
      var cur = v.getAttribute('src') || '', ce = cfLive.expOf(cur);
      if (cur && ce && ce - Date.now() < 20000 && cfLive.fresh(cur) !== cur) {
        dbg.cfSwaps = (dbg.cfSwaps || 0) + 1;
        try { v.src = srcHls; v.load(); } catch (e) {}
        lwPlay();
      }
    }
    if (v && cfLive) {
      // a native-HLS error on an expired / refused token: renew once, then re-join at the edge with the fresh URL
      v.addEventListener('error', function () {
        if (!cfUid || done || draining || (v.getAttribute('src') || '').indexOf('cloudflarestream.com/') < 0) return;   // hls.js (blob:) renews in its loader
        cfLive.renew(cfUid).then(function () { srcHls = cfLive.fresh(srcHls); if (playbackStarted) rejoin('token'); else scheduleRetry(); }, function () {});
      });
    }
    function scheduleRetry() {
      if (!v || done || giveUp || playbackStarted || probing || retryT) return;
      if (document.hidden) return;   // ...and do not leave a timer behind either; the return re-arms
      if (!withinBudget()) return;
      var d = backoffDelay(); dbg.nextDelay = d;
      retryT = setTimeout(function () { retryT = null; tryStart(); }, d);
    }
    // Attached, manifest OK, but no frames after a grace window (segments lagging) -> re-probe.
    function armWatchdog() {
      clearTimeout(watchT);
      watchT = setTimeout(function () { if (playbackStarted || done || giveUp) return; scheduleRetry(); }, 6000);
    }
    function onPlaying() {
      if (playbackStarted) return;
      playbackStarted = true; dbg.playing = true;
      clearTimeout(retryT); retryT = null; clearTimeout(watchT); probing = false;
      hideWaiting();
    }
    // Mid-stream stall (a real network drop, not a cold start): ONE debounced nudge, never the loop.
    function gentle(kind) {
      if (draining) return;   // the stream has ended: play out what is buffered, never reload (endOrDrain)
      var now = Date.now(); if (now - lastRecover < 8000) return; lastRecover = now;
      dbg.recover = (dbg.recover || 0) + 1;
      try {
        if (nativeHls) { v.load(); lwPlay(); }
        else if (hls) { if (kind === 'media') hls.recoverMediaError(); else hls.startLoad(); lwPlay(); }   // recoverMediaError swaps the element's src: it comes back PAUSED (2026-10-06)
      } catch (e) {}
    }
    /* ---- RIDE THROUGH A DROP + "BE RIGHT BACK" (db/0219, 2026-10-02) --------------------------------
       A broadcaster's connection can drop (app backgrounded, network) and come back on the SAME Cloudflare input; the
       server holds the live meanwhile (stream.connection 'reconnecting', Live::RECONNECT_GRACE). Measured on real
       Cloudflare: through the gap the live manifest stays 200 and FROZEN (no ENDLIST), then grows again with the SAME
       media sequence; an encoder that sends audio but no video frames freezes the HLS the same way (no audio
       segments either). So the player is never torn down while the server says reconnecting (it keeps re-reading the
       playlist on its own, cheap), and the overlay shows when the server says so OR the picture stops locally:
         'stall'  currentTime frozen > 4 s while playing      'video'  frames frozen > 4 s while time advances
       Re-join (a hard re-attach to the live edge) only when stuck AND there is fresh media to reach -- the hls.js
       playlist grew, or our own edge probe (master -> first variant, the newest segment's path; every 5 s while stuck,
       every 2 s right after the server says the input is back, never while healthy or held) sees it move -- so a
       frozen playlist is never re-attached into a replay of its last seconds. Re-joins back off 3/6/12/20 s; 60 s
       stuck is the belt. The cold-start budget does not apply while the stream is live. */
    var probeBusy = false, probeAt = 0, stallEdge = null, lastEdge = null, edgeFresh = false;
    function edgeProbe() {
      if (probeBusy || !srcHls) return;
      probeBusy = true; probeAt = Date.now(); dbg.edgeProbes = (dbg.edgeProbes || 0) + 1;
      var opt = { credentials: 'omit', cache: 'no-store' };
      var txt = function (r) { return r && r.status === 200 ? r.text() : ''; };
      rfetch(srcHls, opt, 6000).then(txt).then(function (m) {
        var mm = /#EXT-X-STREAM-INF[^\n]*\n\s*([^\s#][^\n]*)/.exec(m || '');
        if (!mm) return m || '';
        return rfetch(new URL(mm[1].trim(), new URL(srcHls, location.href)).href, opt, 6000).then(txt);
      }).then(function (pl) {
        probeBusy = false;
        var lines = String(pl || '').split(/\r?\n/), edge = '';
        for (var i = lines.length - 1; i >= 0; i--) { var l = lines[i].trim(); if (l && l.charAt(0) !== '#') { edge = l.split('?')[0]; break; } }
        if (!edge) return;
        dbg.edge = edge.slice(-24);
        lastEdge = edge;
        if (stallEdge === null) stallEdge = edge; else if (edge !== stallEdge) { edgeFresh = true; dbg.edgeFresh = true; }
      }).catch(function () { probeBusy = false; });
    }
    function frameCount() {
      try { if (v.getVideoPlaybackQuality) return v.getVideoPlaybackQuality().totalVideoFrames; } catch (e) {}
      return typeof v.webkitDecodedFrameCount === 'number' ? v.webkitDecodedFrameCount : -1;
    }
    // The overlay is built here on first need (the watch view stays untouched): the broadcaster's avatar + name come
    // from the author bar under the stage. Over the player, under the chat/pills/mute (rova.css .lw-brb).
    function brbBuild() {
      if (brbEl || !stage || !v) return brbEl;
      // the author bar's own avatar node, cloned (an <img>, a video avatar's <video>, or the initial-letter disc)
      var src = root.querySelector('.lw-author .avatar');
      var nmEl = root.querySelector('.lw-nm'), nm = nmEl ? nmEl.textContent.trim() : '';
      brbEl = document.createElement('div');
      brbEl.className = 'lw-brb'; brbEl.id = 'lw-brb'; brbEl.hidden = true;
      brbEl.setAttribute('role', 'status'); brbEl.setAttribute('aria-live', 'polite');
      var av = document.createElement('span'); av.className = 'lw-brb-av';
      if (src) {
        var im = src.cloneNode(true);
        im.removeAttribute('id'); im.classList.remove('md', 'sm', 'lg'); im.setAttribute('aria-hidden', 'true');
        if (im.tagName === 'VIDEO') { im.muted = true; im.removeAttribute('autoplay'); }
        av.appendChild(im);
      }
      var t = document.createElement('strong'); t.className = 'lw-brb-t'; t.textContent = 'Be right back';
      var sub = document.createElement('span'); sub.className = 'lw-brb-sub'; sub.textContent = (nm || 'The broadcaster') + ' will be right back';
      var sp = document.createElement('span'); sp.className = 'lw-brb-spin'; sp.setAttribute('aria-hidden', 'true');
      brbEl.appendChild(av); brbEl.appendChild(t); brbEl.appendChild(sub); brbEl.appendChild(sp);
      stage.insertBefore(brbEl, v.nextSibling);
      return brbEl;
    }
    var hostAwayK = '';   // HOST AWAY (2026-10-08): the host-away state THIS picture has reached (lwHostAwayPaint); 'background' = Be right back
    /* HOST GONE (2026-10-15, stream.host_gone): the host's publish dropped; the chat (and the call's guests) go on. Be right back says so
       under "<host> will be right back": "N guests are still in the room · Chat is still live". */
    var lwHG = null, lwHGk = '', brbNoteEl = null;
    function brbNote() {
      var g = lwHG && connection === 'reconnecting' ? lwHG : null, n = g ? (+g.guests || 0) : 0;
      var txt = g ? (n > 0 ? (n === 1 ? '1 guest is' : n + ' guests are') + ' still in the room · ' : '') + 'Chat is still live' : '';
      if (!brbEl || (!txt && !brbNoteEl)) return;
      if (!brbNoteEl) {
        brbNoteEl = document.createElement('span'); brbNoteEl.className = 'lw-brb-sub lw-brb-note';
        brbEl.insertBefore(brbNoteEl, brbEl.querySelector('.lw-brb-spin'));
      }
      brbNoteEl.textContent = txt; brbNoteEl.hidden = !txt;
    }
    function paintBrb() {
      var why = done || draining || switching ? '' : (connection === 'reconnecting' ? 'server' : (localWhy || (hostAwayK === 'background' ? 'away' : '')));   // a stall at the very end is expected; a planned switch is not a drop (db/0241)
      dbg.brb = why !== ''; dbg.brbWhy = why;
      if (why) brbBuild();
      if (brbEl) { brbEl.hidden = why === ''; brbNote(); }
      root.classList.toggle('is-brb', why !== '');
    }
    function rejoin(why) {
      if (!v || done || draining) return;
      rejoinN++; rejoinAt = Date.now(); dbg.rejoins = (dbg.rejoins || 0) + 1; dbg.lastRejoin = why;
      ctHist = []; frAnchor = -1; pausedSince = 0; ctMovedAt = framesMovedAt = rejoinAt;   // a fresh element/timeline: its own grace
      edgeCheckAt = rejoinAt + 6000;   // once it plays: not left far behind the live edge (toEdge)
      edgeFresh = false; dbg.edgeFresh = false;
      if (lastEdge !== null) stallEdge = lastEdge;   // the NEXT re-join needs the edge to move past the one we joined at
      playbackStarted = false; dbg.playing = false; giveUp = false; dbg.giveUp = false; loopStart = Date.now(); hideWaiting();
      clearTimeout(retryT); retryT = null; clearTimeout(watchT);
      if (nativeHls) {
        dbg.reattaches++;
        try { v.src = srcHls; v.load(); } catch (e) {}
        lwPlay();
        armWatchdog();
      } else {
        if (hls) { try { hls.destroy(); } catch (e) {} hls = null; }
        attach(); armWatchdog();
      }
    }
    /* ---- THE STALL WATCHDOG (2026-10-06, #813: a desktop viewer stayed FROZEN after Rob's iOS input dropped for under a
       second and reconnected -- Cloudflare's connected/disconnected webhooks even arrived out of order, so the 5 s poll may
       never see 'reconnecting' at all). The player's OWN progress is the main signal; the server's connection is a fast path.
       Three holes the rig (scratchpad lwrc\rig.js: local segments + a mocked poll) proved in the old watchdog:
         1. a PAUSED player was "not our business" (`v.paused && !rejoinN` returned early, Be right back cleared): hls.js's
            recoverMediaError() and a native reload that runs to 'ended' both leave the element paused -> a frozen last
            frame + "Tap for sound", forever. Now: paused while it should play -> play() (every 4 s), still paused at 6 s
            (or 'ended' while the stream is live) -> re-join. Never against a guest call / its camera check (sndBusy: the
            stage's lrt-incall / lrt-gum / .lrt-pre / .lrt-bridge), and it stops after 3 resumes in a minute (so the
            reader's own pause from a context menu / picture-in-picture / a media key is not fought).
         2. hls.js's own stall NUDGES (+0.1..0.3 s seeks) counted as playback and reset the stall clock every few seconds,
            so a PTS restart without #EXT-X-DISCONTINUITY (a new encoder session) never reached a re-join. Now progress is
            WINDOWED: >= 1 s of currentTime over the last ~3 s (a fresh window after a seek / re-join counts as moving).
         3. 'video' (time runs, picture frozen: a forward PTS jump) showed Be right back forever and never re-joined. Media
            IS arriving there (time runs), so it re-joins after 4 s with no edge test.
       THE FAST PATH: the poll seeing connection reconnecting -> live, or stream.reconnects going up (server-side, additive,
       2026-10-06), opens a 30 s window: stuck after 2 s (not 4), edge probes every 2 s, a re-join 1 s after the edge moves;
       and once playing, a player left > 12 s behind the live edge jumps to it (toEdge; also after every re-join).
       Unchanged: Be right back only after 4 s (a short blip never flashes it), nothing re-attaches while the server HOLDS the
       live (connection 'reconnecting'), a frozen playlist is re-joined only once it moves (or the 60 s belt), and none of
       this runs while the end drain plays out (draining / done return first; rejoin() and toEdge() refuse too). */
    function inViewport() {
      try { var r = v.getBoundingClientRect(); return r.width > 0 && r.bottom > 0 && r.right > 0 && r.top < (window.innerHeight || 0) && r.left < (window.innerWidth || 0); } catch (e) { return true; }
    }
    function rejoinWait(now) { return rejoinN > 0 && now - rejoinAt < Math.min(20000, 3000 * Math.pow(2, rejoinN - 1)); }
    function toEdge() {
      if (!v || done || draining || v.paused) return;
      var e = 0; try { var sk = v.seekable; if (sk && sk.length) e = sk.end(sk.length - 1); } catch (x) {}
      var ct = v.currentTime, behind = e - ct;
      if (!(e > 0) || !isFinite(e) || behind <= (llS ? llTarget() + 6 : 12) || behind > 600) return;   // > 10 min = a timeline we cannot trust (a PTS restart)
      var t = e - (llS ? llTarget() : 3 * (lwTD || 2));
      try { var lp = hls && hls.liveSyncPosition; if (lp > ct && lp <= e) t = lp; } catch (x) {}
      if (t <= ct) return;
      try { v.currentTime = t; dbg.wd.toEdge++; dbg.wd.toEdgeFrom = Math.round(behind); ctHist = []; ctMovedAt = Date.now(); } catch (x) {}
    }
    /* LIVE DELAY (see llS): how far behind the playlist's end this player means to sit, and the healthy-tick catch-up. hls.js: its
       targetLatency (our liveSyncDuration + 1 s per stall it has seen); hls.js speeds up by itself while < target + TARGETDURATION
       late, so we only JUMP (to liveSyncPosition) past that, at most once per 15 s. Safari native: no library, target llS + 2 s
       from seekable's end, 1.08x while > 1.5 s behind it (forward only: currentTime never moves back), a jump past 8 s. */
    function llTarget() {
      var t = 0; try { t = hls ? +hls.targetLatency : 0; } catch (e) {}
      return t > 0 ? t : (llParts ? llP : Math.max(llS, (lwTD || 2) + 1.5));
    }
    function lwCatchUp(now) {
      if (!llS || !v || v.paused || done || draining || switching) return;
      var tgt = llTarget(), late = 0, e = 0;
      if (hls) {
        try { late = (+hls.latency || 0) - tgt; } catch (x) { late = 0; }
        dbg.ll = { s: llS, p: llP, parts: llParts, degraded: llDegraded, target: Math.round(tgt * 10) / 10, late: Math.round(late * 10) / 10, rate: v.playbackRate, jumps: dbg.ll ? dbg.ll.jumps : 0 };
        if (late > Math.min(tgt + (lwTD || 2), 6) - 0.5 && now - llJumpAt > 15000) {
          var lp = 0; try { lp = +hls.liveSyncPosition; } catch (x) {}
          if (lp > v.currentTime + 1) { llJumpAt = now; try { v.currentTime = lp; dbg.ll.jumps++; ctHist = []; ctMovedAt = now; } catch (x) {} }
        }
        return;
      }
      if (!nativeHls) return;
      try { var sk = v.seekable; if (sk && sk.length) e = sk.end(sk.length - 1); } catch (x) {}
      if (!(e > 0) || !isFinite(e)) return;
      tgt = llS + 2;   // Safari cannot tell us the TARGETDURATION: keep 2 s more than hls.js on a plain playlist (an LL one plays closer by itself)
      late = (e - v.currentTime) - tgt;
      dbg.ll = { s: llS, native: true, target: Math.round(tgt * 10) / 10, late: Math.round(late * 10) / 10, rate: v.playbackRate, jumps: dbg.ll ? dbg.ll.jumps : 0 };
      if (late > 8 && now - llJumpAt > 15000) { llJumpAt = now; try { v.currentTime = e - tgt; dbg.ll.jumps++; ctHist = []; ctMovedAt = now; } catch (x) {} return; }
      var want = late > 1.5 ? 1.08 : (late < 0.3 ? 1 : v.playbackRate);
      if (want !== v.playbackRate) { try { v.playbackRate = want; } catch (x) {} }
    }
    function signalResume(why) {
      var now = Date.now();
      resumeAt = now; fastUntil = now + 30000; edgeCheckAt = now + 2500;
      dbg.wd.resumes++; dbg.wd.lastResume = why;
      if (stallSince || pausedSince) { edgeFresh = false; dbg.edgeFresh = false; stallEdge = null; edgeProbe(); }
    }
    function health() {
      if (done || draining || !v || document.hidden) return;
      var now = Date.now(), ct = v.currentTime, fr = frameCount();
      // WINDOWED progress. A jump of > 5 s (hls.js skipping a hole, a timeline restart) starts a fresh window but is NOT itself
      // progress: after a PTS restart hls.js jumps ~9 s, decodes a burst and sticks again, every ~8 s (the rig's 'reset' case).
      // Our own re-join / tab return / toEdge() reset the clock where they happen.
      if (ctHist.length && Math.abs(ct - ctHist[ctHist.length - 1].ct) > 5) ctHist = [];
      ctHist.push({ t: now, ct: ct });
      while (ctHist.length > 1 && now - ctHist[0].t > 3200) ctHist.shift();
      var h0 = ctHist[0];
      if (now - h0.t < 2500 ? ctHist.length > 1 && ct > lastCt + 0.5 : ct - h0.ct >= 1) ctMovedAt = now;   // a fresh window: a real second's worth per tick (a 0.1-0.3 s nudge is not)
      lastCt = ct;
      // frames: >= 2 new since the anchor (hls.js's nudges decode a stray frame); only while the player is on screen (an
      // off-screen <video> may have its decoding suspended by the browser); a counter that restarts (a re-attach) re-anchors
      var onScreen = inViewport();
      if (fr >= 0 && (frAnchor < 0 || fr < frAnchor || !onScreen)) { frAnchor = fr; framesMovedAt = now; }
      else if (fr >= frAnchor + 2) { if (lastFrames > 0) dbg.framesCount = true; frAnchor = fr; framesMovedAt = now; }   // counted only once seen moving
      lastFrames = fr;
      var fast = now < fastUntil || switching; dbg.wd.fast = fast;   // a planned orientation switch: edge probes every 2 s, re-join as soon as the new publish's segments appear
      if (!playbackStarted && !rejoinN || status !== 'live') { localWhy = ''; stallSince = 0; pausedSince = 0; paintBrb(); return; }
      // db/0241: ONE re-join when the new shape was measured but this player still decodes the old one 8 s later (a player that
      // crossed the size change by itself skips it)
      if (swMeasuredAt && !swRejoined && v.videoWidth && v.videoHeight && now - swMeasuredAt > 8000) {
        if ((v.videoWidth > v.videoHeight) !== (orient === 'landscape')) { swRejoined = true; rejoin('reorient'); return; }
        swMeasuredAt = 0;
      }
      // (1) PAUSED while it should be playing
      if (v.paused) {
        localWhy = ''; stallSince = 0; paintBrb();
        if (sndBusy()) { pausedSince = 0; dbg.wd.pausedFor = 0; return; }   // a guest call / its camera check owns the player
        if (!pausedSince) pausedSince = now;
        var pf = now - pausedSince; dbg.wd.pausedFor = pf;
        // something keeps pausing it again (the reader's context menu / picture-in-picture / a media key, or another module):
        // 3 resumes in a minute and we stop fighting until that minute has passed
        while (nudges.length && now - nudges[0] > 60000) nudges.shift();
        dbg.wd.fight = nudges.length >= 3;
        if (dbg.wd.fight || rejoinWait(now)) return;
        if (v.ended) { if (pf >= 1000) { nudges.push(now); rejoin('ended'); } return; }   // a native HLS that thinks the live ended: reload, never play() from 0
        if (pf >= 1500 && now - nudgeAt >= 4000) { nudgeAt = now; nudges.push(now); dbg.wd.nudges++; lwPlay(); }
        if (pf >= 6000) rejoin('paused');
        return;
      }
      pausedSince = 0; dbg.wd.pausedFor = 0;
      var lim = fast ? 2000 : 4000;
      var timeStuck = now - ctMovedAt > lim;
      var picStuck = !!dbg.framesCount && onScreen && fr >= 0 && now - framesMovedAt > lim;
      // Be right back: only after 4 s whatever the window (a short blip never flashes it)
      localWhy = now - ctMovedAt > 4000 ? 'stall' : (picStuck && now - framesMovedAt > 4000 ? 'video' : '');
      if (timeStuck || picStuck) { if (!stallSince) stallSince = Math.min(ctMovedAt, picStuck ? framesMovedAt : now); }
      else {
        stallSince = 0; rejoinN = 0; dbg.stuckFor = 0; stallEdge = null; edgeFresh = false; dbg.edgeFresh = false;
        if (edgeCheckAt && now >= edgeCheckAt) { edgeCheckAt = 0; toEdge(); }   // after a resume / re-join: back to the live edge
        else lwCatchUp(now);   // LIVE DELAY: stay near the live edge while healthy
      }
      paintBrb();
      if (!(timeStuck || picStuck) || connection === 'reconnecting') return;   // held by the server: let the player wait on the frozen playlist
      dbg.stuckFor = now - stallSince;
      var since = Math.max(stallSince, rejoinAt);
      // picture frozen while time ADVANCES IN REAL TIME (>= 0.7 s per second over the full ~3 s window): media IS arriving,
      // the video path is wedged (a forward PTS jump) -- not merely the window's own lag as playback stops
      var timeRuns = now - h0.t >= 2500 && (ct - h0.ct) * 1000 >= 0.7 * (now - h0.t);
      // the server just saw the input come back (or the fast window): probe every 2 s (Cloudflare needs a few seconds to cut new segments)
      // ...and right after one of our own re-joins (a re-join that landed short of the new media needs the next one soon)
      if (!timeRuns && !edgeFresh && now - probeAt >= (fast || rejoinN > 0 || resumeAt > since ? 2000 : 5000)) edgeProbe();
      if (rejoinWait(now)) return;   // re-join backoff 3/6/12/20 s
      var why = '';
      if (timeRuns && now - since > 4000) why = 'video';
      else if (edgeFresh && now - since > (fast ? 1000 : 3000)) why = 'edge';                       // our probe saw the playlist move
      else if (hls && edgeMovedAt > since && now - edgeMovedAt > (fast ? 2000 : 4000)) why = 'edge';   // ...or hls.js's own reload did
      else if (now - since > 60000) why = 'belt';
      if (why) rejoin(why);
    }
    function startWatching() {
      if (!v) return;
      loopStart = Date.now(); giveUp = false; dbg.giveUp = false;
      v.addEventListener('playing', onPlaying);
      v.addEventListener('timeupdate', function () { if (v.currentTime > 0.1) onPlaying(); });
      v.addEventListener('error', function () {
        dbg.mediaErr = (v.error && v.error.code) || 1;
        if (draining) { drainDone('error'); return; }
        if (playbackStarted) { gentle('net'); return; }
        clearTimeout(watchT); scheduleRetry();
      });
      v.addEventListener('stalled', function () { if (!playbackStarted && v.readyState < 2) scheduleRetry(); });
      v.addEventListener('ended', function () { if (draining) drainDone('ended'); });
      tryStart();
    }
    /* ---- THE PLAYER'S FIT (2026-10-02, Rob: "her video doesn't fill the screen, I see black edges") ----------------
       @slay's 720x1280 stream in the ~0.68 phone stage was CONTAINED: ~8% black down each side. The app's live room fills
       the phone with a portrait stream, so the web now does the same: decide cover/contain from the video's OWN shape
       (videoWidth/videoHeight; a 9:16 phone guess until metadata) against the stage's REAL box (it is 0.68 on a phone
       with chat, 786x640 on desktop, 16:9 without chat):
         PORTRAIT (< 0.9)   cover while the aspects are within 1.5x (9:16 in 0.68 = 1.21 fills, a little off top/bottom);
                            further apart (a phone stream on a desktop/tablet stage) it stays whole -- a 9:16 cover-cropped
                            to a 786x640 band would lose more than half the picture
         otherwise          cover only within 1.12x of the stage (16:9 in 16:10); a landscape stream stays whole
       cover is the CSS default (rova.css .live-stage > video), so the common phone case never switches; only the
       stage's class moves (.lw-fit-contain), never its box, so chat, gift lanes, pills and Be right back stay where they
       are. Re-decided on loadedmetadata / the video's own resize (an encoder change or a rotated phone) / the stage's
       resize (rotation, window). */
    /* LANDSCAPE LIVES (db/0229, iOS 680 Portrait | Landscape): stream.orientation rides on the page (#live-watch
       data-orient, the server also starts a landscape player .lw-fit-contain) and on every poll, so the guess before
       metadata is the stream's own shape (16:9 / 9:16) and nothing re-fits when the first frame lands. lwFit also
       publishes the PICTURE's rect inside the stage (--lw-vt/--lw-vr, px) for the full-screen button, which sits on the
       picture's top-right corner and is shown only for a wide picture. */
    var orient = root.getAttribute('data-orient') === 'landscape' ? 'landscape' : 'portrait';
    dbg.orient = orient;
    var fsBtn = document.getElementById('lw-fs');
    /* LANDSCAPE = PICTURE ON TOP (2026-10-04, Rob; the app's build-700 geometry): with chat, a wide picture (>= 1.15) is docked
       full width under the stage's 56px top bar and the chat lives below it (livechat.css .lw-top; the view draws the class + --lw-ar from first paint). Not in full
       screen (the picture is the point there). The picture's rect is published as before for the full-screen button. */
    var lwSide = null;
    try { lwSide = window.matchMedia ? matchMedia('(orientation: landscape) and (max-height: 500px)') : null; } catch (e) { lwSide = null; }
    /* OPEN ROOMS, NEVER CUT AT THE SIDES (2026-10-12, Rob on a 390 px phone: "Why are 1, 2, 3 and 5 getting clipped? They should be evenly
       spaced in thirds for 3, 4, 5, and 1, 2 should match the width of 5"). The room picture (LiveRealtime::ROOM_FRAME: the host 0..480,
       seats 1-2 480..720, seats 3/4/5 in thirds) is exact thirds of its 720 frame; a COVER fit into a phone box narrower than 9:16 cut
       ~6% off BOTH sides, so seats 3 and 5 lost a slice, 4 did not, and 1-2's pills ran into the screen edge. While the ROOM picture is on
       this player (lwChips: the pills' own timed tiles are the six seats) and the box is narrower than the frame, the picture is fitted to
       the WIDTH and anchored to the TOP (.lw-fit-room: contain + object-position 50% 0); the room floor's dark (#0b0b0f) carries on below
       it under the chat. A box wider than the frame keeps the cover fit (it only trims the band / floor). Every surface does the same:
       the host's preview (liverealtime.js .lrt-roomfit), the guest's own stage (lrt-gview), the apps and the TV (API.md). */
    var lwRoomFit = false;
    /* SCREEN SHARE (2026-10-15, LIVE FEATURES; lib/livescreen.php): every poll carries stream.screen_share (bool) + screen_share_since_ms
       (ms AGO it last changed). While the host's picture is their SCREEN the stage is drawn FIT (contain, letterboxed, no crop: lwFit),
       and the server already reads a host_away 'background' as null (no Be right back over a screen). Timed to this player's own lag
       (lwLatency, like HOST AWAY): the fit flips when the change reaches THIS picture. Debug: __rovaLiveWatch.screenShare. */
    var lwSS = null, lwSSOn = false, lwSSt = 0, lwSSf = 0;
    /* THE TURN (2026-10-23, WS-D; LS891 = iOS 891, Rob: "Slay has her phone turned sideways so she can show the game ... the receivers should
       see that with their phone held in portrait" + "it should smoothly transition"). An app host held sideways keeps the PORTRAIT frame and
       draws the upright camera as a 16:9 BAND across the middle (720 x 405 at y 437 of 720 x 1280), pure black above and below. This player
       shows the band as THE WIDE BUBBLE (lwFit .lw-wbub: under the top row, 8 px in, rounded 22, the chat below), like a landscape-encoded
       live. When: the PICTURE says so (lwTurnPixels: the top + bottom 30 % black at 12 x 64 samples, the middle not; two reads in a row,
       every 150 ms while the server says a turn is in play, else not read at all) -- frame-timed; where the picture can't be read (Safari's native HLS when its canvas copy is black) the server's fact
       (stream.picture_turn + picture_turn_since_ms, lib/liveturn.php) timed to this player's lag. The change morphs (520 ms, the bubbles'
       spring) with the old picture cross-fading out (lwTurnFx). Calls / rooms / battles: never (their own pictures). Debug: __rovaLiveWatch.turn. */
    var lwTN = null, lwTNOn = false, lwTNi = 0, lwTNpx = { on: false, last: null, n: 0, ok: false, cv: null, cx: null };
    function lwTurnFeed(s) {
      if (!s || !('picture_turn' in s)) return;
      lwTN = { on: s.picture_turn === 'landscape', ms: typeof s.picture_turn_since_ms === 'number' ? s.picture_turn_since_ms : null, at: Date.now() };
      if (!lwTNi) lwTurnTick();
    }
    function lwTurnFlag() {
      if (!lwTN) return false;
      if (lwTN.ms == null) return lwTN.on;
      var lag = lwLatency() || (lwCC && +(llParts && lwCC.c.ll_hls_lag_ms || lwCC.c.hls_lag_ms)) || 15000;
      return lwTN.ms + (Date.now() - lwTN.at) >= lag ? lwTN.on : !lwTN.on;
    }
    function lwTurnPixels() {   // true | false | null (this browser can't read the picture)
      if (!v || v.readyState < 2 || !v.videoWidth || !v.videoHeight || v.videoWidth >= v.videoHeight) return false;
      if (nativeHls && /Apple/.test(navigator.vendor || '')) { var wk = lwWkRt(); if (wk !== 'ok') return null; }
      var P = lwTNpx;
      if (!P.cv) { P.cv = document.createElement('canvas'); P.cv.width = 12; P.cv.height = 64; P.cx = P.cv.getContext('2d', { willReadFrequently: true }); }
      var d;
      try { P.cx.drawImage(v, 0, 0, 12, 64); d = P.cx.getImageData(0, 0, 12, 64).data; } catch (e) { return null; }
      var bars = true, mid = 0, mn = 0;   // rows 0-19 + 44-63 = above / below the band (y 437..842 of 1280 = rows 21.9..42.1), 2 rows of margin
      for (var y = 0; y < 64 && bars; y++) for (var x = 0; x < 12; x++) {
        var o = (y * 12 + x) * 4, L = 0.299 * d[o] + 0.587 * d[o + 1] + 0.114 * d[o + 2];
        if (y <= 19 || y >= 44) { if (L > 26) { bars = false; break; } } else if (y >= 24 && y <= 40) { mid += L; mn++; }
      }
      return bars && mn > 0 && mid / mn > 18;
    }
    function lwTurnTick() {
      clearTimeout(lwTNi); lwTNi = 0;
      if (done || !v || !stage) return;
      var call = lwCC && lwCC.c && /^(grid|room|band)$/.test(String(lwCC.c.mode || '')), busy = call || stage.classList.contains('lbt-on') || lwSSOn;
      // the probe runs only while the server says sideways, or within 60 s of the last change (frame-timing both edges); else nothing is read
      var armed = !!lwTN && (lwTN.on || (lwTN.ms != null && lwTN.ms + (Date.now() - lwTN.at) < 60000));
      var px = busy || !armed ? false : lwTurnPixels(), P = lwTNpx;
      // one read flips when it agrees with what the host is doing now (the server's fact, untimed: the picture is the timing), two in a row otherwise
      var fl = lwTurnFlag();
      if (px !== null) { P.ok = true; if (px === P.last) P.n++; else { P.last = px; P.n = 1; } if (P.n >= 2 || (P.n >= 1 && px === (lwTN ? lwTN.on : fl))) P.on = px; }
      var want = busy ? false : (px !== null && P.ok ? P.on : fl);
      lwTNi = setTimeout(lwTurnTick, armed ? 150 : 600);   // fast while a turn is in play, idle otherwise (no read at all)
      dbg.turn = { on: want, px: px, pxOn: P.on, flag: lwTN ? lwTN.on : null, since: lwTN ? lwTN.ms : null };
      if (want === lwTNOn) return;
      lwTNOn = want; lwTurnFx(); lwFit();
    }
    /* THE MORPH (2026-10-23): the old picture (a snapshot, laid out exactly as the video was) cross-fades out over 360 ms while the video's
       box springs to the new shape (rova: .lw-tmorph, 520 ms); Safari's unreadable canvas = the morph alone. */
    var lwTNfxT = 0;
    function lwTurnFx() {
      if (!stage || !v) return;
      var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
      try {
        if (v.videoWidth && v.readyState >= 2 && !(nativeHls && /Apple/.test(navigator.vendor || '') && lwWkRt() !== 'ok')) {
          var cs = getComputedStyle(v), g = document.createElement('canvas'), k = Math.min(1, 480 / v.videoWidth);
          g.width = Math.round(v.videoWidth * k); g.height = Math.round(v.videoHeight * k); g.getContext('2d').drawImage(v, 0, 0, g.width, g.height);
          g.className = 'lw-tghost'; g.setAttribute('aria-hidden', 'true');
          g.style.cssText = 'position:absolute;pointer-events:none;z-index:1;left:' + v.offsetLeft + 'px;top:' + v.offsetTop + 'px;width:' + v.offsetWidth + 'px;height:' + v.offsetHeight + 'px;object-fit:' + cs.objectFit + ';object-position:' + cs.objectPosition + ';clip-path:' + cs.clipPath + ';transition:opacity ' + (reduce ? '.2s' : '.36s') + ' ease';
          v.parentNode.insertBefore(g, v.nextSibling);
          requestAnimationFrame(function () { requestAnimationFrame(function () { g.style.opacity = '0'; }); });
          setTimeout(function () { if (g.parentNode) g.parentNode.removeChild(g); }, 520);
        }
      } catch (e) {}
      if (!reduce) { stage.classList.remove('lw-tmorph'); void stage.offsetWidth; stage.classList.add('lw-tmorph'); clearTimeout(lwTNfxT); lwTNfxT = setTimeout(function () { if (stage) stage.classList.remove('lw-tmorph'); }, 600); }
    }
    function lwScreenShare(s) {
      if (!s || !('screen_share' in s)) return;   // a server from before 2026-10-15
      lwSS = { on: s.screen_share === true, ms: typeof s.screen_share_since_ms === 'number' ? s.screen_share_since_ms : null, at: Date.now() };
      lwScreenSharePaint();
    }
    function lwScreenSharePaint() {
      clearTimeout(lwSSt);
      var want = !!(lwSS && lwSS.on) && !done;
      if (lwSS && lwSS.ms != null && !done) {
        var lag = lwLatency() || (lwCC && +(llParts && lwCC.c.ll_hls_lag_ms || lwCC.c.hls_lag_ms)) || 15000, age = lwSS.ms + (Date.now() - lwSS.at), need = lwSS.on ? lag : Math.max(0, lag - 1000);
        if (age < need) { want = !lwSS.on; lwSSt = setTimeout(lwScreenSharePaint, Math.min(need - age + 60, 30000)); }
      }
      dbg.screenShare = { on: lwSS ? lwSS.on : false, since: lwSS ? lwSS.ms : null, shown: want };
      if (want === lwSSOn) return;
      lwSSOn = want;
      if (stage) {   // SCREEN SHARE IN / OUT (2026-10-22, WS-D): the fit flips -> a 0.5 s rise, never a hard jump (rova.css .lw-ss-flip)
        stage.classList.remove('lw-ss-flip'); void stage.offsetWidth; stage.classList.add('lw-ss-flip');
        clearTimeout(lwSSf); lwSSf = setTimeout(function () { if (stage) stage.classList.remove('lw-ss-flip'); }, 560);
      }
      if (stage) stage.classList.toggle('lw-screen', want);
      lwFit();
    }
    function lwFit() {
      if (!v || !stage) return;
      /* LIVE BATTLES (db/0233, assets/livebattle.js): a battle owns the stage geometry -- the split band docked under the top bar
         (.lw-top + its own --lw-ar), each half cover/contain-fitted by livebattle.css -- and the ambient backdrop is off. */
      if (stage.classList.contains('lbt-on')) { stage.classList.add('lw-top'); ambSync(false, stage.clientWidth, stage.clientHeight, 1); fsPaint(0); dbg.fit = 'battle'; lwChips(); return; }
      var mw = v.videoWidth || 0, mh = v.videoHeight || 0;
      var r = (mw > 0 && mh > 0) ? mw / mh : (orient === 'landscape' ? 16 / 9 : 9 / 16);
      var turn = lwTNOn && mw > 0 && mh > mw, bandH = turn ? Math.round(mw * 9 / 16) : 0;   // THE TURN: the band is the picture
      if (turn) r = mw / bandH;
      var lc = document.getElementById('livechat');
      var top = !!(lc && lc.parentNode === stage) && r >= 1.15 && !stage.classList.contains('lw-fs-on');
      stage.classList.toggle('lw-top', top);
      if (top && mw > 0 && mh > 0) stage.style.setProperty('--lw-ar', r.toFixed(4));
      var bw = stage.clientWidth, bh = stage.clientHeight;
      if (!bw || !bh) return;
      // a SHORT LANDSCAPE viewport (phone sideways) keeps .lw-top but lays out as a TV live: picture contain-fit, chat over it (livechat.css)
      if (top && lwSide && lwSide.matches) top = false;
      var b = bw / bh;
      var d = Math.max(r, b) / Math.min(r, b);
      // LIVE BATTLES PHASE 2 (db/0236, Rob 10-04 final): a CALL COMPOSITE is framed like any live -- cover (full-screen) on a phone, the
      // whole picture on a desktop (no crop); its name chips are DOM pills on the visible tiles (lwChips), never burned into the picture
      var cover = top ? false : (r < 0.9 ? d <= 1.5 : d <= 1.12);
      if (lwSSOn) cover = false;   // SCREEN SHARE (2026-10-15, lwScreenShare): the host's screen is drawn whole, never cropped
      if (stage.classList.contains('lw-rband')) cover = false;   // THE CHAT BAND (2026-10-15, lwRBand): the whole picture, centred, never cropped
      if (lwB) cover = false;   // DESKTOP ROOM LAYOUT B: under the re-tiled boxes (or, not re-tiled, the whole picture in the tiles' box)
      var roomFit = cover && lwRoomFit && r < 0.9 && b < r * 0.999;   // OPEN ROOMS: the whole width, top-anchored (lwRoomFit above)
      stage.classList.toggle('lw-fit-contain', !cover);
      stage.classList.toggle('lw-fit-room', roomFit);
      var vt = 0, vr = 0, ph = bh;
      if (top) { ph = v.clientHeight || Math.round(bw / r); vt = v.offsetTop || 0; vr = Math.max(0, Math.round((bw - Math.min(bw, ph * r)) / 2)); }   // under the 56px top bar
      /* THE WIDE BUBBLE (2026-10-23, WS-D; Rob: a landscape publisher on a phone = "a wide rounded bubble across the top, chat below"): the
         picture on top is 8 px in from the stage's sides, rounded 22, under the 56 px top row, capped like .lw-top (45 % of the phone stage;
         a wide stage: 100vh - 200); a BAND (THE TURN) = the portrait frame laid out at the bubble's width with everything but the band clipped
         away. Vars: --lw-tbx / --lw-tbw (the bubble), --lw-ph (its height, inline: the chat below follows), --lw-tfh / --lw-tvt / --lw-tby /
         --lw-tbb (the video's box and its clip). */
      var wb = top && mw > 0 && mh > 0;
      stage.classList.toggle('lw-wbub', wb); stage.classList.toggle('lw-turn', wb && turn);
      if (wb) {
        var cap = bw >= 600 ? Math.max(300, innerHeight - 200) : Math.min(innerHeight * 0.74, 640) * 0.45, tbw = bw - 16, tbh = tbw / r;
        if (tbh > cap) { tbh = cap; tbw = tbh * r; }
        tbw = Math.round(tbw); tbh = Math.round(tbh);
        var tbx = Math.round((bw - tbw) / 2), tfh = turn ? Math.round(tbw * mh / mw) : tbh, tby = turn ? Math.round(tfh * Math.floor((mh - bandH) / 2) / mh) : 0;
        var sp = function (k, x) { stage.style.setProperty(k, x + 'px'); };
        sp('--lw-tbx', tbx); sp('--lw-tbw', tbw); sp('--lw-ph', tbh); sp('--lw-tfh', tfh); sp('--lw-tvt', 56 - tby); sp('--lw-tby', tby); sp('--lw-tbb', Math.max(0, tfh - tby - tbh));
        ph = tbh; vt = 56; vr = tbx;
        dbg.wideBubble = { x: tbx, y: 56, w: tbw, h: tbh, turn: turn, frame: tfh };
      } else if (stage.style.getPropertyValue('--lw-tbw')) {
        ['--lw-tbx', '--lw-tbw', '--lw-ph', '--lw-tfh', '--lw-tvt', '--lw-tby', '--lw-tbb'].forEach(function (k) { stage.style.removeProperty(k); }); dbg.wideBubble = null;
      }
      else if (!cover) { if (r > b) vt = Math.max(0, Math.round((bh - bw / r) / 2)); else vr = Math.max(0, Math.round((bw - bh * r) / 2)); }
      stage.style.setProperty('--lw-vt', vt + 'px'); stage.style.setProperty('--lw-vr', vr + 'px');
      // the PICTURE's own box (2026-10-04, Rob: Be right back must stay on the video for a landscape stream): livechat.css confines
      // Be right back / the veil / the plain end box to it in the sideways layout (the stacked one uses the CSS geometry directly)
      var pH = top ? ph : roomFit ? Math.min(bh, Math.round(bw / r)) : Math.max(0, bh - 2 * vt);
      stage.style.setProperty('--lw-pt', vt + 'px'); stage.style.setProperty('--lw-pl', vr + 'px');
      stage.style.setProperty('--lw-pw', Math.max(0, bw - 2 * vr) + 'px'); stage.style.setProperty('--lw-pH', pH + 'px');
      stage.classList.toggle('lw-fs-top', vt < 48);   // the picture reaches the stage's top: the podium makes room (rova.css)
      dbg.fit = roomFit ? 'room' : cover ? 'cover' : 'contain'; dbg.fitVideo = mw && mh ? mw + 'x' + mh : ''; dbg.fitBox = bw + 'x' + bh; dbg.fitPic = { t: vt, r: vr, h: top ? ph : 0 }; dbg.fitTop = top;
      fsPaint(r);
      // a WIDE picture shown whole with real bands (on top: the chat area below it) -> the ambient backdrop fills them
      /* THE SOLO BUBBLE (2026-10-23, Rob on BigFknDeal's #2147480465, desktop LAYOUT B after her call: the name pill sat 4 px from the picture's
         edge and the picture's corners were square). One person under the B bar = ONE bubble, like the bubble stage's n = 1: the picture
         fitted whole (contain) inside the box under the bar with the bubbles' 8 px pad, rounded 22 px, and the host's name pill 12 px in from
         its top-left (the bubble rule's inset; rova.css .lw-rsolo). Only while no call / battle / re-tile owns the B stage. A change of size
         glides (the pill + the picture move on the bubbles' spring). Vars: --lw-sx / --lw-sy / --lw-sw / --lw-sh. */
      var rsolo = lwB && mw > 0 && mh > 0 && !stage.classList.contains('lw-bub-on') && !stage.classList.contains('lbt-on') && !stage.classList.contains('lw-bcrop') && !lwSSOn;
      if (rsolo) {
        var bx0 = 8, by0 = LW_B_BAR + 8, bw0 = Math.max(40, bw - 16), bh0 = Math.max(40, bh - LW_B_BAR - 16), pr = mw / mh;
        var pw0 = bw0, ph0 = bw0 / pr; if (ph0 > bh0) { ph0 = bh0; pw0 = bh0 * pr; }
        var sx0 = Math.round(bx0 + (bw0 - pw0) / 2), sy0 = Math.round(by0 + (bh0 - ph0) / 2);
        stage.style.setProperty('--lw-sx', sx0 + 'px'); stage.style.setProperty('--lw-sy', sy0 + 'px');
        stage.style.setProperty('--lw-sw', Math.round(pw0) + 'px'); stage.style.setProperty('--lw-sh', Math.round(ph0) + 'px');
        dbg.soloBubble = { x: sx0, y: sy0, w: Math.round(pw0), h: Math.round(ph0) };
      } else if (dbg.soloBubble) dbg.soloBubble = null;
      if (stage.classList.contains('lw-rsolo') !== !!rsolo) stage.classList.toggle('lw-rsolo', !!rsolo);
      /* THE DESKTOP SOLO BUBBLE (2026-10-23, Rob on #2147480465 alone after her call: a tall square-cornered strip, black both sides, the chat
         rows over her): a portrait picture shown whole on a wide stage (no B bar, no call / battle / share) = ONE rounded bubble: 8 px from
         the stage's top and bottom, rounded 22, moved right just far enough that the chat's column fits in the margin LEFT of it (the rows
         never cover her; a narrow stage narrows the rows instead), her name pill + Gold 12 px inside its top-left. Vars --lw-dx / --lw-dw /
         --lw-dh / --lw-dcw (the chat's width). Size changes glide on the bubbles' spring. */
      var lcIn = !!(document.getElementById('livechat') && document.getElementById('livechat').parentNode === stage);
      var callNow = !!(lwCC && lwCC.c && /^(grid|room|band)$/.test(String(lwCC.c.mode || '')));
      var dsolo = !lwB && !top && !cover && mw > 0 && mh > mw && bw >= 600 && !callNow && !lwSSOn && !stage.classList.contains('lw-bub-on') && !stage.classList.contains('lbt-on') && !stage.classList.contains('lw-fs-on') && !stage.classList.contains('lw-turn');
      if (dsolo) {
        /* CENTRED (2026-10-23, Rob on Cognac's #2147480470: pushed right for the chat = "all off center"): the bubble is ALWAYS centred and
           fills the height; the chat's column takes the margin left of it (300 px at most, 170 at least: a narrower margin = narrower rows,
           never a moved bubble); LIVE / viewers sit in the right margin when they fit, else 12 px inside the bubble's top-right. */
        var dh = Math.max(120, bh - 16), dw = Math.round(dh * mw / mh), dx = Math.max(8, Math.round((bw - dw) / 2)), dcw = Math.max(170, Math.min(300, dx - 16));
        /* THE COMPOSER STAYS USABLE (2026-10-23, Rob: the left margin's composer showed "You'r" + clock + emoji + Send): the composer needs 340 px
           (an input of ~200 + its buttons): a narrower margin = it stretches across the stage's bottom over the lower part of her bubble on a
           soft dark gradient (.lw-dsolo-cbot); the rows keep the margin's column while it is >= 170 px, else they ride the bottom band over the
           composer like a phone (.lw-dsolo-rbot). The bubble never moves (typing / the keyboard change nothing here). */
        var cbot = lcIn && dx - 16 < 340, rbot = lcIn && dx - 16 < 300;   // 2026-10-23 (Rob: "I also don't like the squished chat"): a chat column is >= 300 px or none: the rows ride the bottom band
        if (stage.classList.contains('lw-dsolo-cbot') !== cbot) stage.classList.toggle('lw-dsolo-cbot', cbot);
        if (stage.classList.contains('lw-dsolo-rbot') !== rbot) stage.classList.toggle('lw-dsolo-rbot', rbot);
        var dmr = Math.max(0, bw - dx - dw), tlE = stage.querySelector(':scope > .lw-tl'), tlW = tlE && tlE.offsetParent ? tlE.offsetWidth : 0;
        stage.style.setProperty('--lw-dmr', dmr + 'px');
        var tlIn = tlW > 0 && dmr < tlW + 24; if (stage.classList.contains('lw-dsolo-tlin') !== tlIn) stage.classList.toggle('lw-dsolo-tlin', tlIn);
        stage.style.setProperty('--lw-dx', dx + 'px'); stage.style.setProperty('--lw-dw', dw + 'px'); stage.style.setProperty('--lw-dh', dh + 'px'); stage.style.setProperty('--lw-dcw', dcw + 'px');
        dbg.deskSolo = { x: dx, y: 8, w: dw, h: dh, chatW: lcIn ? dcw : 0 };
      } else if (dbg.deskSolo) dbg.deskSolo = null;
      if (!dsolo) { stage.classList.remove('lw-dsolo-cbot'); stage.classList.remove('lw-dsolo-rbot'); }
      if (stage.classList.contains('lw-dsolo') !== dsolo) stage.classList.toggle('lw-dsolo', dsolo);
      ambSync((rsolo || dsolo) ? true : top ? bh - ph >= 8 : (!cover && r >= 1 && (vt >= 8 || vr >= 8)), bw, bh, r);
      lwChips();
    }
    dbg.refit = function () { lwFit(); };   // db/0233: livebattle.js re-fits when a battle starts / ends
    dbg.lag = function () { return lwLatency() || 0; };   // 2026-10-15: livebattle.js times the band by this player's own delay (0 = not measured)
    /* LIVE BATTLES PHASE 2 (db/0236, Rob 10-04 final): THE CALL'S NAME CHIPS. The composite carries NO burned-in names (a crop could never
       suit both a cover phone and an uncropped desktop); stream.composite.layout.tiles (frame coords, with each tile's user) says where the
       people are, and the names are DOM pills on the VISIBLE tile rects: 8 px from the visible tile edge and from the separator, the pill
       style (12 px / 900 / 24 tall / 12 sides / black 45%). ON FOR THE WHOLE CALL, timed to what the HLS shows: on once since_ms + elapsed >= hls_lag_ms; a layout
       change applies once tiles_since_ms + elapsed >= the lag (prev_tiles until then); after the composite ended, kept until ended_ms_ago
       + elapsed >= the lag. A timer re-decides at the exact moment (the poll is only every 5 s). Replays: no chips. 'band' = the battle's. */
    var lwCC = null, lwCCel = null, lwCCt = 0, lwTD = 0, lwLat = 0, lwLatAt = 0, lwCCk = null;
    /* ONE LAYOUT AT A TIME (2026-10-15, Rob on @cognac's #2814 / #2828: her Open Room became a co-host call, then a battle). The server's
       composite flips from 'room' to 'band' at once, but THIS player shows the room for one more delay. lwGone = the last room / grid layout
       this picture showed {tiles, L, mode, end (client wall ms when it left the server's picture; null = still on)}: lwChipState keeps
       answering it until that change reaches this screen, so the room's own host tile is known (the battle crops it into its half) and
       nothing jumps early. The pills themselves never draw over a battle (lwChips: the battle owns the stage). */
    var lwGone = null;
    function lwComposite(c) { lwCC = c ? { c: c, at: Date.now() } : null; lwCCPolled = true; if (!c) lwAl = null; lwChips(); }
    function lwChipAvErr() { if (this.parentNode) this.parentNode.removeChild(this); }   // a pill photo that won't load: its monogram disc shows
    /* THE HOST-MUTED MIC (2026-10-05, Rob: the glyph burned into the 1280x720 composite looked pixelated on a 4K TV and sat too high): no
       broadcaster burns it in any more; the viewer draws it at the END of the tile's name pill, on its row, from tile.muted, timed like the
       pills: muted_since_ms (ms ago the state changed) + the time since this poll against this player's lag -- a mute shows a beat after it
       reaches this picture (the pills' on edge), an unmute clears 1 s early (their off edge). Until then the tile shows the state before the
       change (a change always flips it). null muted_since_ms = no change on record: as it is. -> { on, wait (ms until it flips) } */
    var LW_MIC = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<line x1="2" y1="2" x2="22" y2="22"/><path d="M9 9v3a3 3 0 0 0 5.12 2.12M15 9.34V4a3 3 0 0 0-5.94-.6"/><path d="M17 16.95A7 7 0 0 1 5 12v-2m14 0v2a7 7 0 0 1-.11 1.23"/>' +
      '<line x1="12" y1="19" x2="12" y2="22.5"/></svg>';
    function lwMicState(t) {
      if (!t || t.muted == null) return { on: false };
      var on = !!t.muted, ms = t.muted_since_ms;
      if (ms == null || !lwCCk) return { on: on };
      var age = +ms + lwCCk.el, need = on ? lwCCk.lon : lwCCk.loff;
      return age >= need ? { on: on } : { on: !on, wait: need - age };
    }
    /* AWAY: "ON A PHONE CALL" (2026-10-06, Rob, live #813: a guest took a phone call and his tile froze). tile.away = "call" | "background"
       | null; the broadcaster paints that person's AVATAR tile (no text), and the viewer draws a pill under the avatar: a phone glyph +
       "On a phone call" (a moon + "Away" for background). Timed like the muted mic: away_since_ms (ms ago the state changed) + the time
       since this poll against this player's lag -- away shows at the pills' ON edge, back clears at their OFF edge; until then the tile
       shows away_prev (the state before the change). null away_since_ms = no change on record: as it is. -> { k, wait } */
    function lwAwayState(t) {
      if (!t || !('away' in t)) return { k: '' };
      var k = t.away === 'call' || t.away === 'background' ? t.away : '', ms = t.away_since_ms;
      if (ms == null || !lwCCk) return { k: k };
      var age = +ms + lwCCk.el, need = k ? lwCCk.lon : lwCCk.loff, pv = t.away_prev === 'call' || t.away_prev === 'background' ? t.away_prev : '';
      return age >= need ? { k: k } : { k: pv, wait: need - age };
    }
    var LW_AWAY = {
      call: '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M6.6 10.8a15.1 15.1 0 0 0 6.6 6.6l2.2-2.2a1 1 0 0 1 1-.25 11.4 11.4 0 0 0 3.6.57 1 1 0 0 1 1 1V20a1 1 0 0 1-1 1A17 17 0 0 1 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1c0 1.25.2 2.45.57 3.57a1 1 0 0 1-.25 1z"/></svg>',
      background: '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z"/></svg>'
    };
    /* where the away pill goes (= liverealtime.js awayPos, API.md AWAY): centred on the avatar circle (the tile's centre; frame R = max(18,
       min(0.11 w, 0.2 h)), its centre 0.25 R above the tile's middle), top 10 px under the circle, never closer than 6 px to the name pill
       below it, never outside the visible tile (8 px in). Screen px; k = screen px per frame px. -> {cx, top, max} | {compact: true} (no room
       under the avatar: a 24 px disc with the glyph on the name pill's row instead, after the mic) | null (too narrow for anything) */
    function lwAwayPos(tx, ty, tw, th, k, vx0, vy0, vx1, vy1, pillTop) {
      if (vx1 - vx0 < 64 || vy1 - vy0 < 40) return null;
      var fw = tw / k, fh = th / k, Rr = Math.max(18, Math.min(fw * 0.11, fh * 0.2)), cyF = fh / 2 - Rr * 0.25;
      var avC = ty + cyF * k, top = Math.max(ty + (cyF + Rr) * k + 10, vy0 + 8);
      var lim = (pillTop != null && pillTop > avC ? pillTop - 6 : vy1 - 8) - 24;
      if (top > lim) return { compact: true };
      var cx = tx + tw / 2, half = Math.min(cx - (vx0 + 8), (vx1 - 8) - cx);
      if (half < 40) { cx = (vx0 + vx1) / 2; half = (vx1 - vx0) / 2 - 8; }
      return { cx: cx, top: top, max: 2 * half };
    }
    /* THIS PLAYER'S MEASURED LATENCY (2026-10-05, Rob: after the host removed the guest the picture was already solo, but "Rova Test Guest"
       stayed on the right half for a while: "I'd rather it go away when he goes away"). The server's hls_lag_ms is ONE number (15 s);
       each player's real delay differs (hls.js on a desktop is shorter, Safari's native HLS ~20 s). ms between a moment at the
       broadcaster and this screen showing it, best source first:
         pdt         EXT-X-PROGRAM-DATE-TIME: hls.js playingDate / Safari's video.getStartDate() + currentTime -> now - that wall time
         edge        no PDT: how far behind the playlist's live edge we play + lwEdgeLag (camera -> the playlist's end). hls.js on plain
                     segments: hls.latency (its edge + the time since the playlist last ADVANCED - currentTime: exactly what the clock rig
                     measured against); else seekable end - currentTime + the time since hls.js loaded the playlist (Safari / native:
                     a quarter target duration)
       Smoothed (a 5 s glide), re-read on each decision; 0 = not measurable yet (not playing) -> hls_lag_ms. window.__rovaLatencyMs
       overrides it (rigs). dbg.latency = { ms, src }.
       2026-10-16 (Rob: "Host is on a phone call" ~2 s BEFORE the host's audio paused in the picture): Cloudflare's live playlists carry NO
       PROGRAM-DATE-TIME (checked on a plain and an llhls variant), so every web player was on 'edge', and its old allowance (1.5 target
       durations = 4.5 s on TARGETDURATION 3) was ~3 s short of the clock rig's truth: a plain segment is listed 7.3 s after its LAST
       frame on GOP 3 (5.4 s on GOP 2), and on screen = hls.latency + 7.5 s (13.0 s vs 5.47 s, plain GOP 3) -> lwEdgeLag = 2 x the
       newest segment's length + 2.0 s (hls.js; +0.5 s margin: late beats early), else the server's stream.hls_edge_lag_ms (8000 on
       GOP 3), on parts ll_hls_edge_lag_ms (600). Every lag-timed overlay (call pills, AWAY, the host-away pill / Be right back, screen
       share, the time-aligned seats) reads this one number. Offline rig: scratchpad 5f6112a7 hasync2\sim.cjs. */
    var lwSeg = 0, lwEdgeMs = 0, lwEdgeLlMs = 0;
    function lwEdgeLag(parts) {
      if (parts) return lwEdgeLlMs > 0 ? lwEdgeLlMs : 600;
      if (lwSeg > 0) return Math.round(lwSeg * 2000 + 2000);
      return lwEdgeMs > 0 ? lwEdgeMs : 8000;
    }
    function lwLatency() {
      if (typeof window.__rovaLatencyMs === 'number') { dbg.latency = { ms: window.__rovaLatencyMs, src: 'rig' }; return window.__rovaLatencyMs; }
      if (!v || v.readyState < 2 || v.paused) return lwLat && Date.now() - lwLatAt < 30000 ? lwLat : 0;
      var now = Date.now(), L = 0, src = '';
      try { var pd = hls && hls.playingDate; if (pd && pd.getTime() > 0) { L = now - pd.getTime(); src = 'pdt'; } } catch (e) {}
      if (!L && !hls && v.getStartDate) { try { var sd = v.getStartDate(), t0 = sd ? sd.getTime() : NaN; if (t0 > 0) { L = now - (t0 + v.currentTime * 1000); src = 'pdt'; } } catch (e) {} }
      if (!L) {
        var edge = 0; try { var sk = v.seekable; if (sk && sk.length) edge = sk.end(sk.length - 1); } catch (e) {}
        if (edge > 0 && edge >= v.currentTime) {
          var td = lwTD || 2;
          // LIVE DELAY (2026-10-16): on 0.5 s parts (llParts) the playlist's end IS ~0.5 s behind the camera and blocking reloads keep it
          // fresh: + 600 ms (clock rig: hls.js latency 4.96 s / 7.0 s vs 5.6 s / 7.4 s on screen). Plain segments: + lwEdgeLag (see above).
          var hl = 0; try { hl = hls && !llParts ? +hls.latency || 0 : 0; } catch (e) {}
          L = hls && llParts ? (edge - v.currentTime) * 1000 + lwEdgeLag(true)
            : hl > 0 && hl < 60 ? hl * 1000 + lwEdgeLag(false)
            : (edge - v.currentTime) * 1000 + (hls && levelAt ? Math.min(td * 2000, Math.max(0, now - levelAt)) : td * 250) + lwEdgeLag(false);
          src = 'edge';
        }
      }
      if (!(L >= 500 && L <= 120000)) return lwLat && now - lwLatAt < 30000 ? lwLat : 0;
      var dt = lwLatAt ? Math.min(1, (now - lwLatAt) / 5000) : 1;
      lwLat = lwLat ? lwLat + (L - lwLat) * dt : L; lwLatAt = now;
      dbg.latency = { ms: Math.round(lwLat), raw: Math.round(L), src: src };
      return lwLat;
    }
    /* TIME-ALIGNED OVERLAY (2026-10-12, Rob's room #2551: Dee moved from seat 1 to seat 3; this player's picture -- 10-20 s behind, and
       frozen while the host's app was in the background -- still showed her on seat 1, but the overlay, drawn from the LIVE seats, already
       put a "+" over her face and her pill over seat 3's grey wall). layout.tiles_history = the last 4 layouts [{since_ms, tiles}], newest
       first ([0] = tiles). The picture shows the layout that was on air D ms ago (D = lwLatency: PDT, else live edge - currentTime; plus the
       time this picture has stood still): the NEWEST entry whose since_ms >= D (lwPick). Three probes:
         Dnew  = loff (D - 1000)               a pill LEAVES early: gone once the newer estimate has nobody / someone else on that seat
         Dold  = lon  (D + 250)                a pill COMES late: only once the older estimate has them there too
         Dfree = lon + LW_FREE_SLACK           a "+" only once even that older estimate shows the seat empty
       A seat whose person differs between Dnew and Dold is changing inside this picture's window: no pill AND no "+" (_hold). An empty
       seat not yet empty at Dfree: no "+" (_noplus). A probe no entry covers (the player is further behind than the history) -> the LAST
       overlay shown stays, never a jump ahead (nothing shown yet: a room's frame with no pills, no "+").
       HOST AWAY (stream.host_away, or the host tile's away): the host's picture freezes when it goes away, so a probe that lands inside an
       away interval is held at the interval's START (no seat change shows until the host is back in THIS picture), and there is no "+"
       at all while the host is away (on the server now, or in this picture: lwAwP). A start nobody knows (away with no since_ms, or a
       return seen before the away was) = -Infinity: nothing new shows until the return reaches this picture.
       GRID calls: the same probes, the whole layout (fewer people -> Dnew, else Dold: the old prev_tiles rule). No tiles_history (an old
       server): tiles / prev_tiles as before. dbg.align = { on, off, free, still, jn, jo, jf, away, kept }. */
    var LW_FREE_SLACK = 1500, lwAl = null, lwAw = { h: null, t: null }, lwAwP = false, lwCTv = -1, lwCTat = 0;
    function lwAwNote(src, k, ms, at, prev) {   // an away source's interval in client wall ms -> true when it moved
      var a = lwAw[src], w = typeof ms === 'number' ? at - ms : null, was = a ? a.on + '|' + a.t0 + '|' + a.t1 : '';
      if (k) lwAw[src] = { on: true, t0: w != null ? w : (a && a.on ? a.t0 : -Infinity), t1: Infinity };
      else if (a && a.on) { a.on = false; a.t1 = w != null ? w : at; }
      else if (a) { if (w != null) a.t1 = w; }
      else if (prev && w != null) lwAw[src] = { on: false, t0: -Infinity, t1: w };
      a = lwAw[src];
      return (a ? a.on + '|' + a.t0 + '|' + a.t1 : '') !== was;
    }
    function lwAwHold(D, now) {   // a probe inside an away interval -> held at the interval's start
      for (var n = 0; n < 2; n++) for (var q in lwAw) { var a = lwAw[q]; if (a && now - D >= a.t0 && now - D < a.t1) D = now - a.t0; }
      return D;
    }
    function lwAwIn(D, now) { for (var q in lwAw) { var a = lwAw[q]; if (a && (a.on || (now - D >= a.t0 && now - D < a.t1))) return true; } return false; }
    function lwStill(now) {   // ms this picture has stood still while meant to play ('edge' latency can't see a stall; PDT can)
      if (!v || v.paused || !(dbg.latency && dbg.latency.src === 'edge')) { lwCTat = 0; return 0; }
      if (v.currentTime !== lwCTv || !lwCTat) { lwCTv = v.currentTime; lwCTat = now; return 0; }
      return now - lwCTat > 1500 ? Math.min(120000, now - lwCTat) : 0;
    }
    function lwHistOf(L, el) {
      var h = L.tiles_history, out = [];
      if (!h || !h.length) return null;
      for (var i = 0; i < h.length; i++) { var e = h[i]; if (!e || !e.tiles || !e.tiles.length || typeof e.since_ms !== 'number') break; out.push({ s: e.since_ms + el, tiles: e.tiles }); }
      return out.length ? out : null;
    }
    function lwPick(H, D) { for (var j = 0; j < H.length; j++) if (H[j].s >= D) return j; return -1; }
    function lwHoldT(t) { var o = {}; for (var q in t) o[q] = t[q]; o.user = null; o.user_id = null; o._hold = true; return o; }
    function lwNoPlusT(t) { var o = {}; for (var q in t) o[q] = t[q]; o._noplus = true; return o; }
    function lwAlign(c, L, H, lon, loff) {
      var now = Date.now(), room = c.mode === 'room', st = lwStill(now), key = c.mode + '|' + L.w + 'x' + L.h, T0 = H[0].tiles, ht = null;
      for (var i = 0; i < T0.length; i++) { var t = T0[i]; if (room ? +t.seat === 0 : !!lwHostUid && (+t.user_id === lwHostUid || !!(t.user && +t.user.id === lwHostUid))) { ht = t; break; } }
      if (!ht && !room) ht = T0[0];
      if (ht && 'away' in ht) { var K = function (x) { return x === 'call' || x === 'background' ? x : ''; }; lwAwNote('t', K(ht.away), ht.away_since_ms, lwCC.at, K(ht.away_prev)); }
      var Dn = lwAwHold(loff + st, now), Do = lwAwHold(lon + st, now), Df = lwAwHold(lon + st + LW_FREE_SLACK, now);
      var jn = lwPick(H, Dn), jo = lwPick(H, Do), jf = lwPick(H, Df), w = Infinity, P = [[Dn, jn], [Do, jo], [Df, jf]];
      for (var p = 0; p < 3; p++) { var j = P[p][1] < 0 ? H.length : P[p][1]; if (j > 0 && isFinite(P[p][0])) { var x = P[p][0] - H[j - 1].s; if (x > 0 && x < w) w = x; } }
      lwAwP = lwAwIn(loff + st, now);
      if (lwAwP || st || !isFinite(Dn) || !isFinite(Do)) w = Math.min(w, 1000);
      var R = function (x) { return isFinite(x) ? Math.round(x) : String(x); };
      var dl = dbg.align = { on: R(Do), off: R(Dn), free: R(Df), still: st, jn: jn, jo: jo, jf: jf, n: H.length, away: lwAwP, kept: false };
      if (jn < 0 || jo < 0) {   // further behind than the history: what is shown stays
        dl.kept = true;
        if (lwAl && lwAl.key === key) return { tiles: lwAl.tiles, L: L, wait: w < Infinity ? w : undefined };
        if (room) return { tiles: H[H.length - 1].tiles.map(lwHoldT), L: L, wait: w < Infinity ? w : undefined };   // the room's frame, nobody named
        return { wait: w < Infinity ? w : undefined };
      }
      var out;
      if (room) {
        var A = H[jn].tiles, B = H[jo].tiles, F = jf >= 0 ? H[jf].tiles : null; out = [];
        for (var k = 0; k < A.length; k++) {
          var a = A[k], ua = +a.user_id || 0, ub = B[k] ? +B[k].user_id || 0 : -1;
          if (ua !== ub || A.length !== B.length) out.push(lwHoldT(a));          // changing inside this picture's window (+ ROOM BOX COUNT: the frame itself)
          else if (ua) out.push(a);
          else out.push(F && F[k] && !(+F[k].user_id) ? a : lwNoPlusT(a));        // empty, but maybe not yet in the picture
        }
      } else out = H[jn === jo || H[jn].tiles.length < H[jo].tiles.length ? jn : jo].tiles;
      lwAl = { key: key, tiles: out };
      return { tiles: out, L: L, wait: w < Infinity ? w : undefined };
    }
    function lwChipState() {
      if (!lwCC) return null;
      /* ON FOR THE WHOLE CALL (Rob 10-04 late), TIMED BY THIS PLAYER (2026-10-05): the composite's server clocks (since_ms, tiles_since_ms,
         ended_ms_ago, + the time since this poll) against THIS player's measured latency (lwLatency; the server's hls_lag_ms only until it
         can be measured), so each change lands when this screen's picture changes. Pills come ON a beat after the picture (+250 ms); a pill
         that LEAVES (the call ends, a layout with fewer people) goes 1 s EARLY -- never on a solo picture, better gone early than late. */
      var c = lwCC.c, el = Date.now() - lwCC.at, lat = lwLatency(), lag = lat || +(llParts && c.ll_hls_lag_ms || c.hls_lag_ms) || 15000, L = c.layout || {};
      var lon = (lat ? lat : +c.chip_on_ms || lag) + 250, loff = Math.max(0, (lat ? lat : +c.chip_off_ms || lag) - 1000);
      dbg.chipLag = { on: Math.round(lon), off: Math.round(loff), measured: !!lat }; lwCCk = { lon: lon, loff: loff, el: el };
      if (c.mode !== 'grid' && c.mode !== 'room') {   // ONE LAYOUT AT A TIME (lwGone): a new picture kind replaced a call one delay ago at most
        if (lwGone) {
          if (lwGone.end == null && c.since_ms != null) lwGone.end = lwCC.at - +c.since_ms;
          var gAge = lwGone.end != null ? Date.now() - lwGone.end : Infinity;
          if (gAge < lag) return { tiles: lwGone.tiles, L: lwGone.L, mode: lwGone.mode, gone: true, wait: lag - gAge };
          lwGone = null;
        }
        return null;
      }
      if (!L.w || !L.h || !L.tiles || !L.tiles.length) return null;   // 'room': OPEN ROOMS
      if (c.since_ms != null) {
        var on = +c.since_ms + el; if (on < lon) return { wait: lon - on };
        var H = lwHistOf(L, el);   // TIME-ALIGNED (2026-10-12): the layout this picture shows (lwAlign)
        if (H) return lwAlign(c, L, H, lon, loff);
        lwAwP = false; for (var aq in lwAw) if (lwAw[aq] && lwAw[aq].on) lwAwP = true;   // an old server: still no "+" while the host is away
        var ts = L.tiles_since_ms != null ? +L.tiles_since_ms + el : Infinity;
        if (L.prev_tiles && L.prev_tiles.length) {
          var sw = L.tiles.length < L.prev_tiles.length ? loff : lon;   // someone left: early; someone joined: a beat late
          if (ts < sw) return { tiles: L.prev_tiles, L: L, wait: sw - ts };
        }
        return { tiles: L.tiles, L: L };
      }
      if (c.ended_ms_ago != null) { var e = +c.ended_ms_ago + el; if (e >= loff) { lwGone = null; return null; } return { tiles: L.tiles, L: L, wait: loff - e }; }
      return null;
    }
    /* ---- THE CALL, RE-TILED FOR A WIDE SCREEN (2026-10-08, Rob: on a desktop a portrait call composite shows two people stacked in a
       narrow strip -- "they should be in 2 boxes left and right, or something else, so we can actually see the people") -----------------
       While the picture is a GRID call composite (the pills' own timed tiles, lwChipState: prev_tiles until the layout change reaches this
       player, nothing before the call reaches it / after it left) and the stage box is WIDE (>= 1.05) while the frame is PORTRAIT, each
       person gets a box of their own across the stage (rovaRetilePlan: 2 = host | guest, 3 = guest 1 | host | guest 2, 4 = 2 x 2), drawn
       from the ONE playing <video> into one canvas per box (that tile's crop, cover-fitted; source rects scaled by videoWidth / layout.w,
       so any rendition works). The name pills sit on the boxes (top-left, 8 px in, under the stage's top chrome) and cap the chat as before.
       COST: a draw only when the video presents a NEW frame (requestVideoFrameCallback; else rAF + a currentTime check), so a paused /
       frozen / hidden player draws nothing; each canvas is at most the box's device pixels and never more than its source crop's.
       The <video> stays where it is, playing and visible to the browser (the boxes cover it), so nothing about playback, the watchdog or
       the sound changes. NOT ON: a phone's portrait box (the picture fills it, as before), a battle band, a landscape frame, a guest in the
       call (sndBusy), the veil, an ended page; Be right back / the end card hide it in CSS (with the pills). SAFARI's native HLS is never
       re-tiled (?retile=force does): WebKit may paint an HLS <video> into a canvas as BLACK and a cross-origin one can't be read to check
       (the ambient backdrop's rule). A readable canvas (hls.js) is probed 3 times; black every time -> the one picture again for the page.
       A tainted canvas elsewhere (Chromium's native HLS) still DISPLAYS correctly -- taint only blocks reading -- so it is kept.
       ?retile=off|force on the watch URL (device tests). __rovaLiveWatch.retile = { on, why, n, layout, draws, avg, max, probe }. */
    var RT_GAP = 4, RT_PROBE_AT = [3, 30, 90];
    var rtQ = /[?&]retile=(on|off|force)(?:&|#|$)/.exec(location.search || ''), rtMode = rtQ ? rtQ[1] : 'on';
    var rt = null, rtBlack = 0;
    var rtSt = { on: false, why: '', n: 0, layout: '', draws: 0, ms: 0, avg: 0, max: 0, probe: '', probes: 0, src: '' };
    dbg.retile = rtSt;
    /* ==== THE BUBBLE STAGE (2026-10-22, WS-D items 18-22; Rob: "Every person's box = rounded bubble with 3D shadow, glassy iOS look ...
       eliminate choppy changes: teardown, leave, join ... viewers never see the feed jump; hold layout until everyone's video is ready;
       FaceTime-like animated transitions; profile photo placeholder until video arrives; never empty boxes"). SUPERSEDES THE RE-TILE
       below for every call / Open Room picture on EVERY screen (phones too), the browser permitting (Safari: lwWkRt's probe). ----------
       Each PERSON (never a seat: an empty seat gets no box) is a rounded bubble (.lw-bub, radius 14-26 px, a soft drop shadow, a glass
       rim) laid out by COUNT (rovaBubblePlan: 1 = the whole stage, 2 = side by side, 3 = the hero + 2, 4 = 2 x 2, 5+ = the hero + a
       grid), the HERO (stream.composite.stage.hero, the host's choice; else the host) in the big box, the rest in stage.order (else the
       picture's own order). A bubble shows its person's tile CROPPED FROM THIS PLAYER'S PICTURE (one canvas per person: that tile's
       source pixels, CSS object-fit cover), keyed by the PERSON, so the bubbles can move without the picture having moved:
         - THE PICTURE'S CLOCK: the layout this picture shows D ms behind the server = bubP(D) over layout.tiles_history (the pills' own
           history, lwPick); a call that started / ended less than D ago = the 'solo' picture (the host's whole frame). Two probes around
           this player's measured delay (lwLatency + a still picture + host-away holds, like lwAlign): Dn = D - BUB_WIN, Do = D + BUB_WIN.
         - a person in both, in the same tile          'draw'    drawn from that tile every new video frame
         - a person in both, in a different tile        'freeze'  the bubble keeps its last frame while the picture switches (never a
                                                                   wrong crop: the picture changes somewhere inside that window)
         - a person only the server has (joining) or only the newer probe
                                                        'join'    their PROFILE PHOTO (blurred backdrop + the round photo + name, a soft
                                                                   pulse) until their video is surely in the picture, then a 320 ms fade
         - a person only the older probe has (leaving)  -> their bubble fades + shrinks out on its last frame (no box left behind)
       Every layout change animates (WAAPI on left / top / size / radius, 420 ms, cubic-bezier(.22,.9,.24,1); a new bubble scales in,
       a leaver scales out; prefers-reduced-motion = none); the name pills fade while the bubbles move (.lw-bub-moving). Behind the
       bubbles: the picture itself, tiny and blurred (.lw-bub-amb), never black. While the browser can't paint yet (no metadata, Safari's
       probe still looking) every bubble shows its photo; Safari's probe says black -> the one picture (as before). The SERVER draws the
       first frame (views/live_watch.php .lw-bub-ssr: the same bubbles, photos only, in CSS grid) and the page's composite rides in
       #lw-comp0, so a refresh never shows the portrait picture first (Rob, Dj Mike Luie's room: "I shouldn't see it flicker").
       Not here: battles (livebattle.js owns the stage), a landscape frame, a guest IN the call (liverealtime.js), the fallback (.lfb).
       Kill: ?bubbles=off on the watch URL, data-bubbles="0" (k/v live_bubbles_web = 0). Debug: __rovaLiveWatch.bub. */
    var BUB = true, BUB_STILL = rtMode === 'off' || /[?&]bubbles=off(?:&|#|$)/.test(location.search || '') || root.getAttribute('data-bubbles') === '0';   // 2026-10-23 (Rob: "The grid display is out"): the switch only stills the animations
    var BUB_GAP = 8, BUB_PAD = 8, BUB_TOP = 50, BUB_WIN = 1000, BUB_MS = 520, BUB_EASE = 'cubic-bezier(.22,.9,.24,1)', BUB_JOIN = 520, BUB_MOVE = 520, BUB_LEAVE = 360, BUB_SPRING = 'cubic-bezier(.34,1.32,.64,1)';
    var bub = null, bubT = 0, bubMvT = 0, bubRM = false;
    try { bubRM = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches); } catch (e) { bubRM = false; }
    dbg.bub = { on: false, n: 0, why: '', soft: '', modes: '', order: '', draws: 0, anims: 0, ssr: false, region: '' };
    // THE FIRST FRAME (#lw-comp0, views/live_watch.php): the composite the page was rendered with, until the first poll replaces it
    (function () {
      var j = document.getElementById('lw-comp0'); if (!j || lwCC) return;
      try { var c0 = JSON.parse(j.textContent || 'null'); if (c0 && c0.mode) lwCC = { c: c0, at: Math.round(performance.timeOrigin || Date.now()) }; } catch (e) {}
    })();
    function bubWhy() {
      if (rtSt.probe === 'black' || rtSt.probe === 'error') return rtSt.probe;
      if (!v || !stage || done || veiled || draining) return 'idle';
      // ONE GEOMETRY (2026-10-23, Dj Mike Luie #2147480467): the group-live fallback (lfb-on) no longer ends the bubbles -- its live
      // call videos are drawn INTO the same bubbles (bubDraw, window.__rovaLfb.videoOf); its old flat tile grid stays hidden under them
      if (bubInCall() || stage.classList.contains('lbt-on') || stage.classList.contains('nsfw-gate') || stage.classList.contains('lw-gtu-on')) return 'busy';
      var c = lwCC && lwCC.c;
      if (!c || (c.mode !== 'grid' && c.mode !== 'room')) return 'solo';
      var L = c.layout || {}; if (!(+L.w > 0 && +L.h > 0)) return 'frame';   // 2026-10-23: a LANDSCAPE composite is bubbles too
      if (nativeHls && /Apple/.test(navigator.vendor || '') && rtMode !== 'force') { var wk = lwWkRt(); if (wk === 'black') return 'webkit'; if (wk !== 'ok') return '~wkprobe'; }
      if (!v.videoWidth || !v.videoHeight || v.readyState < 2) return '~nometa';
      return '';
    }
    function bubInCall() { return !!(stage && (stage.classList.contains('lrt-incall') || stage.classList.contains('lrt-gum') || stage.querySelector(':scope > .lrt-pre, :scope > .lrt-bridge'))); }   // sndBusy() minus the fallback
    function bubLfbOn() { try { return !!(stage && stage.classList.contains('lfb-on') && window.__rovaLfb && window.__rovaLfb.videoOf); } catch (e) { return false; } }
    function bubUid(t) { return +((t && (t.user_id || (t.user && t.user.id))) || 0) || 0; }
    // the picture D ms behind the server: {tiles, W, H} | 'solo' | null (nothing known)
    function bubP(c, el, D) {
      var L = c.layout || {}, W = +L.w || 720, H = +L.h || 1280;
      if (c.since_ms != null) {
        if (+c.since_ms + el < D) return 'solo';
        var Hh = lwHistOf(L, el);
        if (Hh) { var j = lwPick(Hh, D); return { tiles: (j < 0 ? Hh[Hh.length - 1] : Hh[j]).tiles, W: W, H: H }; }
        if (L.prev_tiles && L.prev_tiles.length && L.tiles_since_ms != null && +L.tiles_since_ms + el < D) return { tiles: L.prev_tiles, W: W, H: H };
        return L.tiles && L.tiles.length ? { tiles: L.tiles, W: W, H: H } : null;
      }
      if (c.ended_ms_ago != null) return +c.ended_ms_ago + el >= D ? 'solo' : (L.tiles && L.tiles.length ? { tiles: L.tiles, W: W, H: H } : 'solo');
      return null;
    }
    function bubMap(P) {   // -> {o: uid -> {f: [x, y, w, h] fractions of the picture, t: tile}, k: uids in the picture's order} | null
      if (!P) return null;
      var o = {}, k = [];
      if (P === 'solo') { if (lwHostUid) { o[lwHostUid] = { f: [0, 0, 1, 1], t: null }; k.push(lwHostUid); } return { o: o, k: k, solo: true }; }
      for (var i = 0; i < P.tiles.length; i++) {
        var t = P.tiles[i], u = bubUid(t); if (!u || o[u] || !(+t.w > 0 && +t.h > 0)) continue;
        o[u] = { f: [+t.x / P.W, +t.y / P.H, +t.w / P.W, +t.h / P.H], t: t }; k.push(u);
      }
      return { o: o, k: k, W: P.W, H: P.H };
    }
    function bubSame(a, b) { for (var i = 0; i < 4; i++) if (Math.abs(a[i] - b[i]) > 0.004) return false; return true; }
    function bubState() {
      if (!lwCC || !lwCC.c) return null;
      var c = lwCC.c, now = Date.now(), el = now - lwCC.at, lat = lwLatency() || +(llParts && c.ll_hls_lag_ms || c.hls_lag_ms) || 15000, st = lwStill(now);
      /* NEVER THE WRONG PERSON (2026-10-22, Rob on Dealer's #2147480320: "cognac left the live and I briefly seen her in dealers bubble"). The picture's
         delay is an ESTIMATE (Cloudflare's playlists carry no PROGRAM-DATE-TIME; Safari's native player is the roughest), so a layout change is
         only trusted once it is outside a WIDE window: hls.js -2 s / +3 s, Safari's native HLS -4 s / +8 s. Inside it every moved person holds
         their last correct frame (or their photo); a leaver goes early, a joiner shows their photo until the window has passed. */
      var bwLo = nativeHls ? 4000 : 2000, bwHi = nativeHls ? 8000 : 3000;
      var Dn = lwAwHold(Math.max(0, lat - bwLo) + st, now), Do = lwAwHold(lat + bwHi + st, now);
      var Mn = bubMap(bubP(c, el, Dn)), Mo = bubMap(bubP(c, el, Do)), Mz = bubMap(bubP(c, el, 0));
      /* THE LAYOUT MARKER (2026-10-22, WS-D): the frame on screen says which layout it is (bubMarker; the server mix + the web host stamp it).
         Proven -> that layout is the picture, everyone in it draws at once; a marker no layout we know -> everyone holds (still / photo). */
      bubLidNow = -1; var mkHold = false;
      if (bubMk.id >= 0 && Date.now() - bubMk.at < 1500) {
        var MH = lwHistOf(c.layout || {}, el) || (c.layout && c.layout.tiles ? [{ s: 0, tiles: c.layout.tiles }] : []), mk = null;
        for (var mi = 0; mi < MH.length && !mk; mi++) if (bubLid(MH[mi].tiles) === bubMk.id) mk = MH[mi].tiles;
        var LL = c.layout || {}, Mk = mk ? bubMap({ tiles: mk, W: +LL.w || 720, H: +LL.h || 1280 }) : null;
        if (Mk) { Mn = Mo = Mk; bubLidNow = bubMk.id; bubMk.uk = 0; }
        else { if (!bubMk.uk) bubMk.uk = Date.now(); if (Date.now() - bubMk.uk < 4000) mkHold = true; }   // unknown: everyone holds (4 s at most, then the timing window)
      }
      /* THE COMPOSITE BLIP (2026-10-23, #2147480467): the host's composite clock restarted (one beat without it, a re-join) while its LAYOUT
         is older than that clock: the probes inside the restart read 'solo' and the host's bubble used to show the WHOLE frame (the raw
         stacked picture in a bubble). Now every bubble HOLDS (its last frame, else the photo) until the restart is out of this picture. */
      var Lbl = c.layout || {}, blip = false;
      if (c.since_ms != null && Lbl.tiles_since_ms != null && +Lbl.tiles_since_ms > +c.since_ms + 3000 && Mz && !Mz.solo && Mz.k.length >= 2) {
        if (Mn && Mn.solo) { Mn = Mz; blip = true; }
        if (Mo && Mo.solo) { Mo = Mz; blip = true; }
      }
      dbg.bub.blip = blip;
      if (!Mn && !Mz) return null;
      if ((!Mn || Mn.solo) && (!Mo || Mo.solo) && (!Mz || Mz.solo || Mz.k.length < 2)) return null;   // the solo picture on both sides: the one picture
      var keys = (Mn || Mz).k.slice(), list = [], trans = false;
      if (Mz) for (var z = 0; z < Mz.k.length; z++) if (keys.indexOf(Mz.k[z]) < 0) keys.push(Mz.k[z]);   // the server already has them: joining
      for (var i = 0; i < keys.length; i++) {
        var u = keys[i], a = Mn && Mn.o[u], b = Mo && Mo.o[u], zz = Mz && Mz.o[u], m;
        if (a && b) m = bubSame(a.f, b.f) ? 'draw' : 'freeze';
        else if (a && !Mo) m = 'draw';
        else m = 'join';
        if (mkHold && m === 'draw') m = 'freeze';   // THE LAYOUT MARKER: a frame we cannot place
        if (blip && m === 'draw') m = 'freeze';     // THE COMPOSITE BLIP: hold
        if (m !== 'draw') trans = true;
        var t = (a && a.t) || (zz && zz.t) || (b && b.t) || null, f = (a && b && m === 'draw') ? a.f : (b ? b.f : a ? a.f : null);
        var W0 = (Mn && Mn.W) || (Mz && Mz.W) || 720, H0 = (Mn && Mn.H) || (Mz && Mz.H) || 1280;
        var whole = !!(f && f[0] === 0 && f[1] === 0 && f[2] === 1 && f[3] === 1);
        var offK = !t ? '' : (t.audio_only || t.media === 'audio') ? 'audio' : (lwAwayState(t).k || (t.camera_off === true ? 'cam' : '') || (t.connecting === true ? 'conn' : ''));   // + connecting: their seat is not on air (a rejoin)
        // ONE NON-VIDEO BUBBLE (2026-10-22): the HOST's own state too (stream.host_away timed to this picture; Be right back = the host dropped)
        if (u === lwHostUid && m !== 'join') { if (root.classList.contains('is-brb')) offK = 'brb'; else if (!offK) { var hk = lwHostAwayState().k; if (hk === 'call' || hk === 'background') offK = hk; } }   // BUBBLE POLISH: the photo, never that frame
        list.push({ u: u, m: m, f: m === 'join' ? null : f, user: (t && t.user) || null, audio: !!offK, off: offK, foc: bubFocClean(t && t.focus), focS: bubFocClean(t && t.focus_src),
                    asp: !f ? 0.75 : whole ? (v.videoWidth || W0) / (v.videoHeight || H0) : (f[2] * W0) / (f[3] * H0) });
      }
      if (Mo && Mn) for (var q = 0; q < Mo.k.length && !trans; q++) if (!Mn.o[Mo.k[q]]) trans = true;   // someone leaving inside the window
      return { list: list, trans: trans, W: (Mn && Mn.W) || (Mz && Mz.W) || 720, H: (Mn && Mn.H) || (Mz && Mz.H) || 1280, ins: Math.max(2, 0.35 * (+(c.layout && c.layout.radius) || 0)) };
    }
    function bubOrder(L) {
      var sg = lwCC && lwCC.c && lwCC.c.stage, ord = sg && sg.order && sg.order.length ? sg.order.map(function (x) { return +x || 0; }) : [];
      var hero = sg && +sg.hero > 0 ? +sg.hero : 0;
      var out = L.map(function (p, i) { var k = ord.indexOf(p.u); return { p: p, r: k >= 0 ? k : (p.u === lwHostUid ? -1 : 100 + i) }; })
        .sort(function (a, b) { return a.r - b.r; }).map(function (x) { return x.p; });
      var hi = -1, j;
      for (j = 0; j < out.length && hi < 0; j++) if (hero && out[j].u === hero) hi = j;
      for (j = 0; j < out.length && hi < 0; j++) if (out[j].u === lwHostUid) hi = j;
      if (hi > 0) out.unshift(out.splice(hi, 1)[0]);
      return out;
    }
    function bubChatIn() {
      var lc = document.getElementById('livechat');
      return !!(lc && lc.parentNode === stage && !stage.classList.contains('lc-hid'));
    }
    // the box the bubbles share (stage px): the whole stage for one person; else under the top row (LIVE / viewers / the host's name) and
    // over the chat (BUB_FLOOR: ~5 rows + the composer) when the chat is in the stage; desktop LAYOUT B: under its bar
    function bubRegion(n, sw, sh) {
      if (lwB) return { l: BUB_PAD, t: LW_B_BAR + BUB_PAD, w: sw - 2 * BUB_PAD, h: sh - LW_B_BAR - 2 * BUB_PAD };   // THE SOLO BUBBLE (2026-10-23): one person under the B bar is a padded, rounded bubble too
      if (n <= 1) return { l: 0, t: 0, w: sw, h: sh };
      // THE HEADER IN THE BUBBLE (2026-10-22, Rob, the Apple TV's look): on a phone-wide stage (< 600) the header row (host chip, LIVE, viewers,
      // ghost) and the Gold / likes pills float INSIDE the top bubbles' top edge over a soft scrim (rova.css .lw-bub-hdin): the bubbles start
      // 8 px under the stage top instead of 50, and gain that height
      var top = sw < 600 ? BUB_PAD : BUB_TOP;
      var bot = bubChatIn() ? Math.round(Math.min(300, Math.max(230, sh * 0.36))) : BUB_PAD;
      if (sh - top - bot < 160) bot = Math.max(BUB_PAD, sh - top - 160);
      return { l: BUB_PAD, t: top, w: sw - 2 * BUB_PAD, h: Math.max(60, sh - top - bot) };
    }
    function bubEsc(x) { return String(x == null ? '' : x).replace(/[&<>"']/g, function (q) { return '&#' + q.charCodeAt(0) + ';'; }); }
    function bubPh(b, user) {   // the photo placeholder: blurred photo backdrop, the round photo (else the monogram), the name
      var u = user || b.user || {}, avs = typeof u.avatar_lg === 'string' && u.avatar_lg ? u.avatar_lg : u.avatar, av = typeof avs === 'string' && /^(https?:\/\/|\/)/.test(avs) ? avs : '', nmx = u.display_name || (u.username ? '@' + u.username : '');
      var k = av + '|' + nmx;
      if (b.phK === k && b.el.querySelector('.lw-bub-avw')) return;   // BUBBLE POLISH: an older first frame (no badge wrapper) is rebuilt once
      b.phK = k; b.user = u;
      var ph = b.el.querySelector('.lw-bub-ph');
      if (!ph) { ph = document.createElement('div'); ph.className = 'lw-bub-ph'; b.el.insertBefore(ph, b.el.firstChild); }
      ph.innerHTML = '<i class="lw-bub-bg"' + (av ? ' style="background-image:url(&quot;' + bubEsc(av) + '&quot;)"' : '') + '></i><span class="lw-bub-avw"><span class="lw-bub-av" data-ini="' + bubEsc(nameInitial(u.display_name, u.username)) + '">' +
        (av ? '<img src="' + bubEsc(av) + '" alt="" decoding="async">' : '') + '</span><i class="lw-bub-badge" aria-hidden="true"></i></span><span class="lw-bub-chip"></span><b class="lw-bub-nm">' + bubEsc(nmx) + '</b>';   // BUBBLE POLISH: the wrapper holds the status badge
      var im = ph.querySelector('img'); if (im) im.addEventListener('error', function () { if (im.parentNode) im.parentNode.removeChild(im); });
      b.offK = null; b.chK = null;   // BUBBLE POLISH: a rebuilt photo gets its badge + chip back (bubPaint)
    }
    function bubItem(p) {
      var el = document.createElement('div'); el.className = 'lw-bub'; el.setAttribute('data-u', String(p.u));
      var c = document.createElement('canvas'); el.appendChild(c);
      bub.el.appendChild(el);
      var b = { u: p.u, el: el, c: c, cx: null, r: null, rr: 0, drawn: false, m: p.m, f: p.f, phK: '', user: null, leaving: false, anim: null };
      bubPh(b, p.user);
      return b;
    }
    function bubFloatWatch(a) {   // FLOATING PILLS (item 20): a game / poll card going mini (or a Seats pill showing) re-lays the notices rows
      if (!a || a.__lwBubMo || !/(^| )(lg-card|lb-card|lx-modbtn)( |$)/.test(a.className || '')) return;
      a.__lwBubMo = new MutationObserver(function () { if (bub && !stage.__lwBubT) stage.__lwBubT = setTimeout(function () { stage.__lwBubT = 0; lwChips(); }, 60); });
      a.__lwBubMo.observe(a, { attributes: true, attributeFilter: ['class', 'hidden'] });
    }
    function bubMount() {
      var ssr = stage.querySelector(':scope > .lw-bub-ssr'), el = ssr || document.createElement('div');
      bub = { el: el, items: {}, key: '', vfc: 0, raf: 0, lastT: -1, amb: null, ambCx: null, ambAt: 0, on: false, soft: '', n: 0, W: 720, H: 1280, ins: 2 };
      bub.stT = setInterval(bubStallTick, 500);
      if (!ssr) { el.className = 'lw-rtile lw-bubs'; el.setAttribute('aria-hidden', 'true'); }
      // BUBBLE POLISH: a notice arriving (Tap for sound, Ask to join, the echo hold) re-lays the chat under the notices row at once
      try { if (window.MutationObserver && !stage.__lwBubMo) { stage.__lwBubMo = new MutationObserver(function (ms) { var hit = false; for (var i = 0; i < ms.length; i++) for (var j = 0; j < ms[i].addedNodes.length; j++) { var a = ms[i].addedNodes[j]; if (a.nodeType === 1 && /(^| )(lw-sndpill|lrt-ask|lw-echopill|lg-card|lb-card|lx-modbtn)( |$)/.test(a.className || '')) { bubFloatWatch(a); hit = true; } } if (hit && bub) setTimeout(lwChips, 0); }); stage.__lwBubMo.observe(stage, { childList: true }); var pre = stage.querySelectorAll(':scope > .lg-card, :scope > .lb-card, :scope > .lx-modbtn'); for (var pq = 0; pq < pre.length; pq++) bubFloatWatch(pre[pq]); } } catch (e) {}
      var amb = document.createElement('canvas'); amb.className = 'lw-bub-amb'; amb.width = 36; amb.height = 64; el.insertBefore(amb, el.firstChild); bub.amb = amb;
      if (ssr) {   // ADOPT the server's first frame: each bubble keeps the place it was painted in (the next paint animates from there)
        var sr = stage.getBoundingClientRect(), x0 = sr.left + stage.clientLeft, y0 = sr.top + stage.clientTop, kids = ssr.querySelectorAll('.lw-bub[data-u]'), got = [];
        for (var i = 0; i < kids.length; i++) { var q = kids[i].getBoundingClientRect(); got.push({ k: kids[i], r: { l: Math.round(q.left - x0), t: Math.round(q.top - y0), w: Math.round(q.width), h: Math.round(q.height) } }); }
        got.forEach(function (g) {
          var u = +g.k.getAttribute('data-u') || 0; if (!u) return;
          var c = document.createElement('canvas'); g.k.appendChild(c); el.appendChild(g.k);
          var rr = parseFloat(getComputedStyle(g.k).borderTopLeftRadius) || 22;
          var st = g.k.style; st.left = g.r.l + 'px'; st.top = g.r.t + 'px'; st.width = g.r.w + 'px'; st.height = g.r.h + 'px'; st.borderRadius = rr + 'px';
          bub.items[u] = { u: u, el: g.k, c: c, cx: null, r: g.r, rr: rr, drawn: false, m: 'join', f: null, phK: g.k.getAttribute('data-k') || 'ssr', user: null, leaving: false, anim: null };
        });
        var gw = ssr.querySelector(':scope > .lw-bub-grid'); if (gw && gw.parentNode) gw.parentNode.removeChild(gw);
        el.classList.remove('lw-bub-ssr'); dbg.bub.ssr = true;
      }
    }
    function bubCur(b) {   // where the bubble is on screen now (mid-animation too)
      if (!b.anim) return b.r;
      var cs = getComputedStyle(b.el);
      return { l: parseFloat(cs.left) || 0, t: parseFloat(cs.top) || 0, w: parseFloat(cs.width) || 0, h: parseFloat(cs.height) || 0, rr: parseFloat(cs.borderTopLeftRadius) || 0 };
    }
    function bubPlace(b, r, rr, fresh) {
      var from = b.r ? bubCur(b) : null, fr = from && from.rr != null ? from.rr : b.rr;
      if (b.anim) { try { b.anim.cancel(); } catch (e) {} b.anim = null; }
      b.r = r; b.rr = rr;
      var st = b.el.style; st.left = r.l + 'px'; st.top = r.t + 'px'; st.width = r.w + 'px'; st.height = r.h + 'px'; st.borderRadius = rr + 'px';
      if (BUB_STILL || !b.el.animate) return;
      try {
        if (bubRM) { if (fresh) b.anim = b.el.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 200, easing: 'ease' }); }
        else if (fresh) b.anim = b.el.animate([{ opacity: 0, transform: 'scale(.86)', easing: BUB_EASE }, { opacity: 1, transform: 'scale(1.04)', offset: 0.6, easing: BUB_EASE }, { opacity: 1, transform: 'scale(1)' }], { duration: BUB_JOIN });
        else if (from && (from.l !== r.l || from.t !== r.t || from.w !== r.w || from.h !== r.h)) {
          b.anim = b.el.animate([{ left: from.l + 'px', top: from.t + 'px', width: from.w + 'px', height: from.h + 'px', borderRadius: fr + 'px' },
                                 { left: r.l + 'px', top: r.t + 'px', width: r.w + 'px', height: r.h + 'px', borderRadius: rr + 'px' }], { duration: BUB_MOVE, easing: BUB_SPRING });
        }
        if (b.anim) { dbg.bub.anims++; var a = b.anim; a.onfinish = a.oncancel = function () { if (b.anim === a) b.anim = null; }; }
      } catch (e) { b.anim = null; }
    }
    function bubLeave(b) {
      if (b.leaving) return;
      b.leaving = true; b.m = 'gone';
      var fin = function () { if (!b.leaving) return; if (b.el.parentNode) b.el.parentNode.removeChild(b.el); if (bub && bub.items[b.u] === b) delete bub.items[b.u]; };
      if (b.anim) { try { b.anim.cancel(); } catch (e) {} b.anim = null; }
      if (BUB_STILL || !b.el.animate) { fin(); return; }
      b.el.classList.add('is-leave');   // a leaver shrinks to its photo (rova.css)
      try { b.anim = bubRM ? b.el.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 200, easing: 'ease', fill: 'forwards' })
        : b.el.animate([{ opacity: 1, transform: 'scale(1)', easing: 'cubic-bezier(.22,.9,.24,1)' }, { opacity: 1, transform: 'scale(1.06)', offset: 0.3, easing: 'cubic-bezier(.55,0,.75,.2)' }, { opacity: 0, transform: 'scale(.5)' }], { duration: BUB_LEAVE, fill: 'forwards' }); b.anim.onfinish = fin; }
      catch (e) { fin(); }
    }
    function bubMoving() {
      if (bubRM || BUB_STILL) return;
      stage.classList.add('lw-bub-moving'); clearTimeout(bubMvT);
      bubMvT = setTimeout(function () { if (stage) stage.classList.remove('lw-bub-moving'); }, BUB_MS + 40);
    }
    var LW_MIC_ON = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" d="M12 3a3 3 0 0 0-3 3v6a3 3 0 0 0 6 0V6a3 3 0 0 0-3-3zM19 11a7 7 0 0 1-14 0M12 18v3"/></svg>';
    var BUB_BADGE = { cam: '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" d="M2 2l20 20M10.5 6H14a2 2 0 0 1 2 2v1.5l5-3v11M16 16a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h1"/></svg>', call: LW_AWAY.call, background: LW_AWAY.background, audio: LW_MIC_ON };
    /* KEEP THE PICTURE (2026-10-23, Rob on #2147480467: "they look way too zoomed in"; the replay's rule, livereplay.js rtGroups): on a wide
       stage (>= 600 px) the bubbles' region shrinks (centred) until every bubble keeps >= BUB_KEEP of its person's picture (box shape vs the
       tile's shape), the biggest such region wins; none = the least cut. Phones keep the whole region. Memoised per stage size + shapes. */
    var BUB_KEEP = 0.8;
    function bubKeep(R, list, sw) {
      return R;   // WITHDRAWN 2026-10-23 (Rob on Cognac + Dealer, desktop: "bubbles should be large and fill the height"): the bubbles fill the region; SUBJECT FOCUS keeps the faces in
      var n = list.length; if (n < 2 || sw < 600) return R;   // desktop LAYOUT B too (Rob's view)
      var asp = list.map(function (p) { return p.asp > 0.2 && p.asp < 5 ? p.asp : 0.75; }), mk = [R.l, R.t, R.w, R.h].join(',') + '|' + asp.map(function (a) { return a.toFixed(3); }).join(',');
      if (bub && bub.keepK === mk) return bub.keepR;
      var best = null, alt = null, S = [1, 0.95, 0.9, 0.85, 0.8, 0.75, 0.7, 0.65, 0.6];
      for (var i = 0; i < S.length; i++) for (var j = 0; j < S.length; j++) {
        var w = Math.round(R.w * S[i]), h = Math.round(R.h * S[j]); if (w < 160 || h < 120) continue;
        var pl = window.__rovaBubblePlan(n, w, h, BUB_GAP, asp); if (!pl) continue;
        var area = 0, minK = 1, sc = 0;
        for (var q = 0; q < n; q++) { var a = pl[q].w / Math.max(1, pl[q].h), kp = Math.min(a / asp[q], asp[q] / a), ar = pl[q].w * pl[q].h * (q === 0 ? 1.5 : 1); area += ar; sc += ar * kp * kp; if (kp < minK) minK = kp; }
        if (minK >= BUB_KEEP && (!best || area > best.v * 1.01)) best = { v: area, w: w, h: h };
        if (!alt || sc > alt.v * 1.01) alt = { v: sc, w: w, h: h };
      }
      var B = best || alt, out = B ? { l: R.l + Math.round((R.w - B.w) / 2), t: R.t + Math.round((R.h - B.h) / 2), w: B.w, h: B.h } : R;
      if (bub) { bub.keepK = mk; bub.keepR = out; }
      dbg.bub.keep = B ? [B.w, B.h, best ? 'keep' : 'least'] : null;
      return out;
    }
    function bubFocClean(F) {
      if (!F || !(F.length >= 4)) return null;
      var o = []; for (var i = 0; i < 4; i++) { var x = +F[i]; if (!(x >= 0 && x <= 1)) return null; o.push(x); }
      return o[2] >= 0.04 && o[3] >= 0.04 ? o : null;
    }
    /* SUBJECT FOCUS (2026-10-23, Rob on Mike's bubble: "crop the part where Mike's face is instead of his forehead"; NO face data, ever): the
       cover crop leans toward the PERSON -- the publisher's person box (server tiles[].focus, from its own segmentation mask) or, with none, this
       page's own motion centroid (bubSample) -- clamped inside the picture, with a deadband and a slow CSS ease (no jitter). */
    function bubPos(b, cw, ch, kind) {
      if (!b.r || !b.r.w || !b.r.h || !bub || bub.n <= 1) { if (b.posK) { b.posK = ''; b.px = null; b.c.style.objectPosition = ''; } return; }
      var F = kind === 'nf' ? (b.focS || b.mfoc) : (b.foc || b.mfoc), ca = cw / ch, ba = b.r.w / b.r.h, px = 0.5, py = 0.3;
      if (F) {
        if (ca > ba * 1.01) { var vw2 = ba / ca; px = Math.min(1, Math.max(0, (F[0] + F[2] / 2 - vw2 / 2) / (1 - vw2))); }
        else if (ca < ba / 1.01) { var vh2 = ca / ba, top = F[3] <= vh2 * 0.9 ? F[1] + F[3] / 2 - vh2 / 2 : F[1] - vh2 * 0.06; py = Math.min(1, Math.max(0, top / (1 - vh2))); }
      }
      if (b.px != null && Math.abs(px - b.px) < 0.04 && Math.abs(py - b.py) < 0.04) return;   // the deadband
      b.px = px; b.py = py;
      var k = (px * 100).toFixed(1) + '% ' + (py * 100).toFixed(1) + '%'; if (b.posK === k) return; b.posK = k;
      if (!b.posT && !bubRM) { b.posT = 1; b.c.style.transition = 'opacity .32s ease, object-position 1.4s cubic-bezier(.25,.1,.25,1)'; }
      b.c.style.objectPosition = k;
    }
    /* 16 x 16 looks at what a bubble shows, every 400 ms: (1) THE OLD CARD -- a near-uniform dark, colourless picture (the 896 app's "Camera
       paused" / "Setting up your background..." card) twice in a row = the photo bubble, three normal looks = video again; (2) the motion
       centroid (SUBJECT FOCUS's fallback). A canvas this browser can't read (Safari's native HLS) = neither. */
    var bubCk = { cv: null, cx: null, nv: false, nf: false };
    function bubSample(b, src, sx, sy, sW, sH, kind) {
      if (bubCk[kind]) return;
      var now = performance.now(); if (now - (b.ckAt || 0) < 400) return; b.ckAt = now;
      var d;
      try {
        if (!bubCk.cv) { bubCk.cv = document.createElement('canvas'); bubCk.cv.width = 16; bubCk.cv.height = 16; bubCk.cx = bubCk.cv.getContext('2d', { willReadFrequently: true }); }
        bubCk.cx.drawImage(src, sx, sy, sW, sH, 0, 0, 16, 16);
        d = bubCk.cx.getImageData(0, 0, 16, 16).data;
      } catch (e) { bubCk[kind] = true; return; }
      var L = new Array(256), chs = 0, i, j;
      for (i = 0, j = 0; i < 256; i++, j += 4) { L[i] = 0.299 * d[j] + 0.587 * d[j + 1] + 0.114 * d[j + 2]; chs += Math.max(Math.abs(d[j] - d[j + 1]), Math.abs(d[j + 1] - d[j + 2])); }
      var srt = L.slice().sort(function (a, c) { return a - c; }), med = srt[128], k = 0;
      for (i = 0; i < 256; i++) if (Math.abs(L[i] - med) <= 9) k++;
      var look = med >= 6 && med <= 62 && k >= 226 && chs / 256 < 10, was = !!b.card;
      if (look) { b.ckN = (b.ckN || 0) + 1; b.ckM = 0; } else { b.ckM = (b.ckM || 0) + 1; b.ckN = 0; }
      if (!was && b.ckN >= 2) b.card = true; else if (was && b.ckM >= 3) b.card = false;
      if (was !== !!b.card) { dbg.bub.cards = (dbg.bub.cards || 0) + 1; setTimeout(lwChips, 0); }
      if (b.srcK !== kind || !b.prevL) { b.srcK = kind; b.prevL = L; b.mot = null; b.mfoc = null; b.stN = 0; b.mvN = 0; if (b.frz) { b.frz = false; setTimeout(lwChips, 0); } return; }
      var M = b.mot || (b.mot = L.map(function () { return 0; })), P = b.prevL, tot = 0, mxv = 0, raw = 0;
      for (i = 0; i < 256; i++) { var dd = Math.abs(L[i] - P[i]); if (dd > raw) raw = dd; }   // the LARGEST cell change: a live camera always moves somewhere
      // A FROZEN PICTURE (2026-10-23, the relay's held "last picture", a stuck call video): the same look for ~2.4 s = the photo; 2 moving looks = video
      if (raw < 0.6) { b.stN = (b.stN || 0) + 1; b.mvN = 0; } else { b.mvN = (b.mvN || 0) + 1; b.stN = 0; }
      var fz = !!b.frz; if (!fz && b.stN >= 6) b.frz = true; else if (fz && b.mvN >= 2) b.frz = false;
      if (fz !== !!b.frz) { dbg.bub.frozen = (dbg.bub.frozen || 0) + 1; setTimeout(lwChips, 0); }
      for (i = 0; i < 256; i++) { M[i] = M[i] * 0.8 + Math.abs(L[i] - P[i]); tot += M[i]; if (M[i] > mxv) mxv = M[i]; }
      b.prevL = L;
      if (b.card || tot / 256 < 4) return;
      var th = mxv * 0.35, w = 0, mx = 0, my = 0, vx = 0, vy = 0;
      for (i = 0; i < 256; i++) if (M[i] > th) { w += M[i]; mx += M[i] * ((i % 16) + 0.5) / 16; my += M[i] * (Math.floor(i / 16) + 0.5) / 16; }
      if (!w) return; mx /= w; my /= w;
      for (i = 0; i < 256; i++) if (M[i] > th) { var dx = ((i % 16) + 0.5) / 16 - mx, dy = (Math.floor(i / 16) + 0.5) / 16 - my; vx += M[i] * dx * dx; vy += M[i] * dy * dy; }
      var hx = Math.min(0.5, Math.max(0.12, 1.6 * Math.sqrt(vx / w))), hy = Math.min(0.5, Math.max(0.12, 1.6 * Math.sqrt(vy / w)));
      var x0 = Math.max(0, mx - hx), y0 = Math.max(0, my - hy), nf = [x0, y0, Math.min(1, mx + hx) - x0, Math.min(1, my + hy) - y0], o = b.mfoc;
      b.mfoc = o ? o.map(function (x, z) { return x + (nf[z] - x) * 0.25; }) : nf;
    }
    /* A STALLED PICTURE (2026-10-23): the HLS has not moved for 2 s while meant to play -> every bubble it feeds (no fallback call video
       for that person) shows the photo until it moves again. 500 ms timer while the bubbles are up (bubMount / bubOff). */
    function bubStallTick() {
      if (!bub || !v) return;
      var now = Date.now(), ct = v.currentTime;
      if (ct !== bub.ct || !bub.ctAt) { bub.ct = ct; bub.ctAt = now; }
      var stalled = !v.paused && !done && !draining && now - bub.ctAt > 2000, lf = bubLfbOn(), ch = false;
      for (var u in bub.items) {
        var b = bub.items[u], fv = null; if (lf) { try { fv = window.__rovaLfb.videoOf(+u); } catch (e) { fv = null; } }
        var z = stalled && !fv;
        if (!!b.frzH !== z) { b.frzH = z; ch = true; }
      }
      dbg.bub.stall = stalled;
      if (ch) lwChips();
    }
    function bubPaint(S, soft, pilled) {
      var sw = stage.clientWidth, sh = stage.clientHeight; if (!sw || !sh) return false;
      if (!bub) bubMount();
      if (bub.el.parentNode !== stage) stage.insertBefore(bub.el, v.nextSibling);
      var list = bubOrder(S.list), n = list.length, R = bubKeep(bubRegion(n, sw, sh), list, sw);
      var plan = window.__rovaBubblePlan(n, R.w, R.h, BUB_GAP, list.map(function (p) { return p.asp; }));
      if (!plan) return false;
      bub.W = S.W; bub.H = S.H; bub.ins = S.ins; bub.soft = soft; bub.n = n; bub.lid = bubLidNow;
      var key = sw + 'x' + sh + '|' + list.map(function (p) { return p.u; }).join(',') + '|' + [R.l, R.t, R.w, R.h].join(',');
      var moved = key !== bub.key, seen = {};
      bub.el.classList.toggle('n1', n === 1); stage.classList.toggle('lw-bub-n1', n === 1 && !!lwB);   // HER OWN ROOM AROUND HER: her chip on her bubble
      for (var i = 0; i < n; i++) {
        var p = list[i], P = plan[i], r = { l: R.l + P.l, t: R.t + P.t, w: P.w, h: P.h };
        if (n === 1 && lwB && p.asp > 0.2 && p.asp < 5) {   // HER OWN ROOM AROUND HER (2026-10-23): one person under the B bar = a bubble of the picture's own shape
          if (r.w / r.h > p.asp) { var nw1 = Math.round(r.h * p.asp); r.l += Math.round((r.w - nw1) / 2); r.w = nw1; }
          else { var nh1 = Math.round(r.w / p.asp); r.t += Math.round((r.h - nh1) / 2); r.h = nh1; }
          stage.style.setProperty('--lw-b1x', r.l + 'px'); stage.style.setProperty('--lw-b1y', r.t + 'px'); stage.style.setProperty('--lw-b1w', r.w + 'px'); stage.style.setProperty('--lw-b1h', r.h + 'px');
        }
        var rr = n === 1 ? (lwB ? 22 : 0) : Math.round(Math.min(28, Math.max(18, Math.min(r.w, r.h) * 0.11)));   // THE SOLO BUBBLE: rounded under the B bar
        var b = bub.items[p.u], fresh = !b;
        if (b && b.leaving) { b.leaving = false; if (b.anim) { try { b.anim.cancel(); } catch (e) {} b.anim = null; } b.el.style.opacity = ''; fresh = true; }
        if (!b) b = bub.items[p.u] = bubItem(p);
        seen[p.u] = true; b.m = p.m; b.audio = p.audio; if (p.f) b.f = p.f;
        b.foc = p.foc || null; b.focS = p.focS || null;   // SUBJECT FOCUS (2026-10-23): the person's box in this tile / in their own camera (server tiles[].focus / focus_src)
        if (p.user) bubPh(b, p.user);
        if (b.el.parentNode !== bub.el) bub.el.appendChild(b.el);
        // THE OLD CARD (2026-10-23, #2147480467): a picture that is a plain dark "Camera paused" / "Setting up..." card (bubSample) = the photo bubble
        var card = !p.off && !p.audio && !!(b.card || b.frz || b.frzH);   // + A FROZEN PICTURE (bubSample / bubStallTick): the photo after ~2 s
        b.el.classList.toggle('is-join', !b.drawn && !p.audio && !card);
        b.el.classList.toggle('is-audio', !!p.audio || card);
        if ((p.audio || card) && b.drawn) { b.drawn = false; b.el.classList.remove('is-live'); }
        var offK = p.off || (card ? (b.card ? 'card' : 'frz') : ''), offA = offK === 'card' ? 'cam' : offK; if (b.offK !== offK) { b.offK = offK; b.el.setAttribute('data-off', offA); var bg0 = b.el.querySelector('.lw-bub-badge'); if (bg0) bg0.innerHTML = offA ? (BUB_BADGE[offA] || (offA === 'brb' ? LW_AWAY.background : '')) : ''; }
        var chK = offK ? ({ cam: 'Camera off', card: 'Camera off', background: 'Away', call: 'On a call', brb: 'Be right back', conn: 'Connecting', audio: '' }[offK] || '') : (!b.drawn && p.m === 'join' ? 'Connecting' : '');   // ONE NON-VIDEO BUBBLE: the label chip
        if (b.chK !== chK) { b.chK = chK; var ch0 = b.el.querySelector('.lw-bub-chip'); if (ch0) { ch0.textContent = chK; ch0.hidden = !chK; } }   // BUBBLE POLISH
        b.el.classList.toggle('has-pill', !!(pilled && pilled[p.u] && (p.u !== lwHostUid || n > 1)));
        if (fresh || !b.r || b.r.l !== r.l || b.r.t !== r.t || b.r.w !== r.w || b.r.h !== r.h || b.rr !== rr) bubPlace(b, r, rr, fresh);
      }
      for (var u in bub.items) if (!seen[u]) bubLeave(bub.items[u]);
      if (moved) bubMoving();
      bub.key = key; bub.on = true;
      stage.classList.add('lw-rt-on'); stage.classList.add('lw-bub-on');
      // BUBBLE POLISH (2026-10-22): the host's pill on their bubble like everyone's (the stage's .lw-host goes); the notices (Tap for sound, the echo
      // hold, Ask to join) sit in the row UNDER the bubbles (--lw-bub-b), never on a face; a phone's stage grows to the screen (bubTall)
      stage.classList.toggle('lw-bub-hpill', n > 1); stage.classList.toggle('lw-bub-ntc', n > 1);
      stage.classList.toggle('lw-bub-hdin', n > 1 && !lwB && R.t < BUB_TOP);   // THE HEADER IN THE BUBBLE: the top scrim (rova.css)
      var bbv = Math.round(R.t + R.h) + 'px'; if (stage.__lwBubB !== bbv) { stage.__lwBubB = bbv; stage.style.setProperty('--lw-bub-b', bbv); }
      bubTall(n > 1);
      clearTimeout(bubT); if (S.trans || soft) bubT = setTimeout(function () { if (bub) lwChips(); }, soft ? 500 : 250);
      dbg.bub.on = true; dbg.bub.n = n; dbg.bub.why = ''; dbg.bub.soft = soft || '';
      dbg.bub.modes = list.map(function (p) { return p.u + ':' + p.m; }).join(' '); dbg.bub.order = list.map(function (p) { return p.u; }).join(',');
      dbg.bub.region = [R.l, R.t, R.w, R.h].join(',');
      bubKick(); if (!soft) bubDraw();
      return true;
    }
    function bubOff(why) {
      clearTimeout(bubT);
      if (stage) { stage.classList.remove('lw-bub-on'); stage.classList.remove('lw-bub-moving'); stage.classList.remove('lw-bub-hpill'); stage.classList.remove('lw-bub-ntc'); bubTall(false); }
      dbg.bub.on = false; if (why) dbg.bub.why = why;
      var B = bub, ssr = !B && stage ? stage.querySelector(':scope > .lw-bub-ssr') : null;
      if (!B && !ssr) return;
      bub = null;
      var el = B ? B.el : ssr;
      if (B) { if (B.vfc && v.cancelVideoFrameCallback) { try { v.cancelVideoFrameCallback(B.vfc); } catch (e) {} } if (B.raf) cancelAnimationFrame(B.raf); clearInterval(B.stT); }
      if (stage && !rt) stage.classList.remove('lw-rt-on');
      var gone = function () { if (el.parentNode) el.parentNode.removeChild(el); };
      if (bubRM || !el.animate || why === 'idle' || why === 'error') { gone(); return; }
      try { var a = el.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 300, easing: 'ease', fill: 'forwards' }); a.onfinish = gone; } catch (e) { gone(); }
    }
    function bubKick() {
      if (!bub) return;
      var lf = bubLfbOn();   // THE FALLBACK'S VIDEOS: a frame pump of their own (the HLS may be stalled: no video frame callbacks)
      if (lf && bub.vfc) { try { v.cancelVideoFrameCallback(bub.vfc); } catch (e) {} bub.vfc = 0; }
      if (bub.vfc || bub.raf) return;
      if (v.requestVideoFrameCallback && !lf) bub.vfc = v.requestVideoFrameCallback(bubOnFrame);
      else bub.raf = requestAnimationFrame(bubOnRaf);
    }
    function bubOnFrame() { if (!bub) return; bub.vfc = 0; bubDraw(); bubKick(); }
    function bubOnRaf() {
      if (!bub) return; bub.raf = 0;
      var pn = performance.now(), lf = bubLfbOn();
      if (v.currentTime !== bub.lastT || (lf && pn - (bub.lfAt || 0) >= 30)) { if (lf) bub.lfAt = pn; bubDraw(); }
      bubKick();
    }
    /* SPEAKING (BUBBLE POLISH, 2026-10-22): stream.composite.levels {step_ms, end_ms_ago, lv: {uid: digits 0..9}} (the host's call page samples
       everyone every 200 ms; lib/livestage.php) played back at THIS picture's delay, so the bounce lands with the voice: --lv (0..1) on each
       bubble + .is-talk (>= 0.3). Camera off: the photo's gold ring swells; camera on: a gold glow on the rim (rova.css). */
    var bubLvAt = 0;
    function bubLevels() {
      if (!bub || !lwCC || !lwCC.c) return;
      var pn = performance.now(); if (pn - bubLvAt < 60) return; bubLvAt = pn;
      var L = lwCC.c.levels, lat = lwLatency() || +(llParts && lwCC.c.ll_hls_lag_ms || lwCC.c.hls_lag_ms) || 15000, endWall = L ? lwCC.at - (+L.end_ms_ago || 0) : 0, T = Date.now() - lat, st0 = +(L && L.step_ms) || 200;
      for (var u in bub.items) {
        var b = bub.items[u], lv = 0;
        if (L && L.lv && typeof L.lv[u] === 'string') { var s0 = L.lv[u], ix = s0.length - 1 - Math.round((endWall - T) / st0); if (ix >= 0 && ix < s0.length) lv = (+s0.charAt(ix) || 0) / 9; }
        if (b.lv !== lv) { b.lv = lv; b.el.style.setProperty('--lv', lv.toFixed(2)); b.el.classList.toggle('is-talk', lv >= 0.3); }
      }
    }
    /* THE LAYOUT MARKER (2026-10-22, WS-D; Rob: "a bubble must NEVER show the wrong person"): a publisher that composites (the server mix,
       the web host) stamps the layout's id into each frame: 12 cells of 16 x 16 frame px at x 8, y H-24 (720-wide frame; scaled), cell 0
       light, cells 1..10 the id's bits (MSB first, light = 1), cell 11 dark. id = FNV-1a 32 of "g" + the tiles' user ids ("r" + the seats',
       0 = empty) joined by ",", & 1023 (bubLid). Read back here from this player's own frame where the browser lets it (hls.js; Safari's
       native HLS taints the canvas -> the timing window). Two equal reads in a row = proven. */
    var bubMk = { id: -1, at: 0, cv: null, cx: null, last: -2, no: false, reads: 0, uk: 0 }, bubLidNow = -1;
    function bubLid(tiles) {
      if (!tiles || !tiles.length) return -1;
      var room = tiles[0] && tiles[0].seat != null, str = (room ? 'r' : 'g') + tiles.map(function (t) { return +(t.user_id || (t.user && t.user.id) || 0) || 0; }).join(','), h = 2166136261;
      for (var i = 0; i < str.length; i++) { h ^= str.charCodeAt(i); h = Math.imul(h, 16777619) >>> 0; }
      return h & 1023;
    }
    function bubMarker() {
      if (bubMk.no) return;
      var vw = v.videoWidth, vh = v.videoHeight; if (!vw || !vh) return;
      var k = vw / 720, id = -1;
      try {
        if (!bubMk.cv) { bubMk.cv = document.createElement('canvas'); bubMk.cv.width = 96; bubMk.cv.height = 8; bubMk.cx = bubMk.cv.getContext('2d', { willReadFrequently: true }); }
        bubMk.cx.drawImage(v, 8 * k, vh - 24 * k, 192 * k, 16 * k, 0, 0, 96, 8);
        var d = bubMk.cx.getImageData(0, 4, 96, 1).data, b = [];
        for (var i = 0; i < 12; i++) { var o = (i * 8 + 4) * 4; b.push(0.299 * d[o] + 0.587 * d[o + 1] + 0.114 * d[o + 2] > 128 ? 1 : 0); }
        if (b[0] === 1 && b[11] === 0) { id = 0; for (var j = 1; j <= 10; j++) id = id * 2 + b[j]; }
      } catch (e) { bubMk.no = true; return; }   // a tainted canvas: no marker here
      bubMk.reads++;
      if (id >= 0 && id === bubMk.last) { if (bubMk.id !== id) { bubMk.id = id; bubMk.at = Date.now(); setTimeout(lwChips, 0); } else bubMk.at = Date.now(); }
      else if (id < 0 && bubMk.last < 0 && bubMk.id >= 0 && Date.now() - bubMk.at > 1500) { bubMk.id = -1; setTimeout(lwChips, 0); }
      bubMk.last = id; dbg.bub.marker = bubMk.id;
    }
    function bubDraw() {
      bubLevels();
      if (!bub) return;
      /* ONE GEOMETRY (2026-10-23, #2147480467): while the group-live fallback pulls the call (lfb-on), each person's LIVE call video is drawn
         into their own bubble (window.__rovaLfb.videoOf), the HLS crop for anyone it has no video for: the same bubbles, never its flat grid */
      var lf = bubLfbOn(), hok = !bub.soft && !bubNoVid && v.readyState >= 2;
      if (!hok && !lf) return;
      if (hok) bubMarker();
      if (hok && bub.lid >= 0 && bubMk.last !== bub.lid) hok = false;   // THE LAYOUT MARKER: this frame is not the layout the bubbles are cut for (yet): hold
      var vw = v.videoWidth, vh = v.videoHeight; if (!vw || !vh) hok = false;
      if (!hok && !lf) return;
      var t0 = performance.now(), ok = hok && Math.abs(vw / vh - bub.W / bub.H) <= 0.04 * (bub.W / bub.H), n = 0;
      try {
        for (var u in bub.items) {
          var b = bub.items[u]; if (b.leaving || b.audio || (b.offK && b.offK !== 'card' && b.offK !== 'frz')) continue;   // the old card / a frozen picture: still looked at, so it can come back
          var fv = null; if (lf) { try { fv = window.__rovaLfb.videoOf(+u); } catch (e0) { fv = null; } }
          var src, sx, sy, sW, sH, kind, cw, ch;
          if (fv && fv.videoWidth && fv.videoHeight && fv.readyState >= 2) {
            src = fv; sx = 0; sy = 0; sW = fv.videoWidth; sH = fv.videoHeight; kind = 'nf';
            var kz = Math.min(1, 720 / Math.max(sW, sH)); cw = Math.max(2, Math.round(sW * kz)); ch = Math.max(2, Math.round(sH * kz));
          } else {
            if (!hok || b.m !== 'draw' || !b.f) continue;
            var f = b.f, whole = f[0] === 0 && f[1] === 0 && f[2] === 1 && f[3] === 1;
            if (!whole && !ok) continue;   // the picture is not this layout's frame (yet): keep the last frame
            var ix = whole ? 0 : bub.ins / bub.W, iy = whole ? 0 : bub.ins / bub.H;
            src = v; kind = 'nv'; sx = (f[0] + ix) * vw; sy = (f[1] + iy) * vh; sW = Math.max(1, (f[2] - 2 * ix) * vw); sH = Math.max(1, (f[3] - 2 * iy) * vh);
            cw = Math.max(2, Math.round(sW)); ch = Math.max(2, Math.round(sH));
          }
          if (!b.cx) b.cx = b.c.getContext('2d', { alpha: false });
          if (b.c.width !== cw || b.c.height !== ch) { b.c.width = cw; b.c.height = ch; }
          if (kind === 'nf') { try { b.cx.drawImage(src, sx, sy, sW, sH, 0, 0, cw, ch); } catch (e1) { continue; } }
          else b.cx.drawImage(src, sx, sy, sW, sH, 0, 0, cw, ch);
          n++;
          bubSample(b, src, sx, sy, sW, sH, kind);
          if (b.card || b.frz || b.frzH) { if (b.drawn) { b.drawn = false; b.el.classList.remove('is-live'); } }
          else if (!b.drawn) { b.drawn = true; b.el.classList.add('is-live'); b.el.classList.remove('is-join'); }
          bubPos(b, cw, ch, kind);
        }
        var now = performance.now();
        if (hok && bub.amb && now - bub.ambAt > 600) {
          bub.ambAt = now; bub.ambCx = bub.ambCx || bub.amb.getContext('2d', { alpha: false });
          bub.ambCx.drawImage(v, 0, 0, vw, vh, 0, 0, 36, 64);
          if (!bub.el.classList.contains('amb-on')) bub.el.classList.add('amb-on');
        }
      } catch (e) { rtSt.probe = 'error'; bubOff('error'); lwChips(); return; }
      bub.lastT = v.currentTime;
      if (n) {
        var dt = performance.now() - t0; dbg.bub.draws++; rtSt.draws++; rtSt.ms += dt; if (dt > rtSt.max) rtSt.max = +dt.toFixed(2); rtSt.avg = +(rtSt.ms / rtSt.draws).toFixed(3);
        if (RT_PROBE_AT.indexOf(rtSt.draws) >= 0 && rtSt.probe !== 'tainted' && rtSt.probe !== 'ok') rtProbe();
      }
    }
    // the pills' plan entry for a timed tile on its person's bubble: the bubble's (final) box + the part of the tile it shows (cover, 30% heads)
    function bubPillPlan(b, t) {
      var r = b.r, tw = +t.w || 1, th = +t.h || 1, k = Math.max(r.w / tw, r.h / th), cw = r.w / k, ch = r.h / k;
      return { l: r.l, t: r.t, w: r.w, h: r.h, cx: +t.x + (tw - cw) / 2, cy: +t.y + (th - ch) * 0.3, cw: cw, ch: ch, k: k };
    }
    // the chat's cap: every bubble's bottom edge (the chat starts under the lowest one); none for one whole-stage person
    /* BUBBLE POLISH (2026-10-22, Rob on a phone: "the stage height is short"): with 2+ bubbles and the chat on a phone-width stage, the stage
       grows to the screen (the whole card still fits: the screen height minus what sits above the stage and the card's footer). Measured once
       per width (Safari's toolbar changing innerHeight while scrolling never moves the bubbles). */
    function bubTall(on) {
      if (!stage) return;
      on = !!on && !lwB && bubChatIn() && (window.innerWidth || 0) < 900;
      if (!on) { if (stage.classList.contains('lw-bub-tall')) stage.classList.remove('lw-bub-tall'); return; }
      var w = window.innerWidth || 0, r0 = stage.getBoundingClientRect(), top = r0.top + (window.pageYOffset || document.documentElement.scrollTop || 0);
      if (stage.__lwBubTw !== w || Math.abs((stage.__lwBubTt || 0) - top) > 20) {   // a new width, or the page above the stage settled (first paint)
        var vh = window.innerHeight || document.documentElement.clientHeight || 0; stage.__lwBubTt = top;
        var card = stage.closest ? stage.closest('.live-watch') : null, foot = card ? Math.max(0, card.getBoundingClientRect().bottom - r0.bottom) : 0;
        dbg.bub.tall = [vh, Math.round(top), Math.round(foot)]; stage.__lwBubTw = w; stage.__lwBubTh = Math.min(1000, Math.max(Math.round(Math.min(vh * 0.74, 640)), Math.floor(vh - top - foot - 10)));
        stage.style.setProperty('--lw-bub-h', stage.__lwBubTh + 'px');
      }
      if (!stage.classList.contains('lw-bub-tall')) stage.classList.add('lw-bub-tall');
    }
    function lwNoticeLive() {   // a SOLO live (2026-10-23, the 375x667 overlap): the chat under the notice pills; a notice arriving re-lays it
      if (stage && window.MutationObserver && !stage.__lwNtcMo) { try { stage.__lwNtcMo = new MutationObserver(function (ms) { for (var i = 0; i < ms.length; i++) for (var j = 0; j < ms[i].addedNodes.length; j++) { var a = ms[i].addedNodes[j]; if (a.nodeType === 1 && /(^| )(lw-sndpill|lrt-ask|lw-echopill)( |$)/.test(a.className || '')) { setTimeout(lwChips, 0); return; } } }); stage.__lwNtcMo.observe(stage, { childList: true }); } catch (e) {} }
      var o = lwNoticeBoxes(); return o.length ? o : null;
    }
    function lwNoticeBoxes() {   // the notice pills over the picture (Tap for sound, the echo hold, Ask to join): their own rects, stage px
      var o = []; if (!stage || lwB) return o;
      var sr = stage.getBoundingClientRect(), dx = sr.left + stage.clientLeft, dy = sr.top + stage.clientTop, ns = stage.querySelectorAll(':scope > .lw-sndpill, :scope > .lw-echopill:not(.lw-echopill-mini), :scope > .lrt-ask');
      for (var q = 0; q < ns.length; q++) { var ne = ns[q]; if (ne.hidden || !ne.offsetWidth || getComputedStyle(ne).display === 'none') continue; var nr = ne.getBoundingClientRect(); o.push({ l: nr.left - dx, r: nr.right - dx, t: nr.top - dy, b: nr.bottom - dy }); }
      return o;
    }
    function bubCapBoxes() {
      var o = []; if (!bub || !bub.on || bub.n <= 1) return o;
      for (var u in bub.items) { var b = bub.items[u]; if (b.leaving || !b.r) continue; o.push({ l: b.r.l, r: b.r.l + b.r.w, t: b.r.t + b.r.h - 1, b: b.r.t + b.r.h }); }
      if (!lwB && stage) {   // BUBBLE POLISH: the notices row under the bubbles (Tap for sound, the echo hold, Ask to join)
        var sr = stage.getBoundingClientRect(), dx = sr.left + stage.clientLeft, dy = sr.top + stage.clientTop, ns = stage.querySelectorAll(':scope > .lw-sndpill, :scope > .lw-echopill:not(.lw-echopill-mini), :scope > .lrt-ask'), row1 = 0, rowR = 0;
        for (var q = 0; q < ns.length; q++) { var ne = ns[q]; if (ne.hidden || !ne.offsetWidth || getComputedStyle(ne).display === 'none') continue; var nr = ne.getBoundingClientRect(); o.push({ l: -1e5, r: 1e5, t: nr.top - dy, b: nr.bottom - dy }); if (/(^| )lrt-ask( |$)/.test(ne.className)) { if (nr.height > rowR) rowR = nr.height; if (nr.left - dx < stage.clientWidth * 0.55 && nr.height > row1) row1 = nr.height; } else if (nr.height > row1) row1 = nr.height; }   // COGNAC BUGS 3: a wide Ask / waiting chip reaches the left half: the game / poll pills stack under it too
        // FLOATING PILLS (item 20): the minimized game / poll pills (left) and a moderator's Seats pill (right) stack under the notices row
        // (rova.css --lw-ntc-o / --lw-ntc-r = its height on the left / right), never on a face; the chat starts under them too
        var no = row1 ? Math.round(row1 + 6) + 'px' : '0px'; if (stage.style.getPropertyValue('--lw-ntc-o') !== no) stage.style.setProperty('--lw-ntc-o', no);
        var nR = rowR ? Math.round(rowR + 6) + 'px' : '0px'; if (stage.style.getPropertyValue('--lw-ntc-r') !== nR) stage.style.setProperty('--lw-ntc-r', nR);
        var fl = stage.querySelectorAll(':scope > .lg-card.lg-mini, :scope > .lb-card.lb-mini, :scope > .lx-modbtn');
        for (var q2 = 0; q2 < fl.length; q2++) { var fe = fl[q2]; if (fe.hidden || !fe.offsetWidth || getComputedStyle(fe).display === 'none') continue; var fr = fe.getBoundingClientRect(); o.push({ l: -1e5, r: 1e5, t: fr.top - dy, b: fr.bottom - dy }); }
      }
      return o;
    }
    var bubNoVid = false;   // THE PHOTO BUBBLES (2026-10-23): a picture this browser can't draw (a black / failed probe, Safari's black canvas) = every person's photo bubble, the sound live
    function bubRetile(s) {
      var why = bubWhy();
      bubNoVid = why === 'black' || why === 'error' || why === 'webkit'; if (bubNoVid) why = '';
      if (why && why.charAt(0) !== '~') {
        if (why === 'solo' && !lwCCPolled && stage && stage.querySelector(':scope > .lw-bub-ssr')) return null;   // the server's first frame stays until the first poll
        bubOff(why); rtSt.on = false; rtSt.why = why; return null;
      }
      var S = bubState();
      if (!S || !S.list.length) { bubOff('solo'); rtSt.on = false; rtSt.why = 'solo'; return null; }
      var pilled = {}; if (s && s.tiles) for (var pi0 = 0; pi0 < s.tiles.length; pi0++) { var pu0 = bubUid(s.tiles[pi0]); if (pu0) pilled[pu0] = true; }
      if (!bubPaint(S, why ? why.slice(1) : '', pilled)) return null;
      rtSt.on = true; rtSt.why = why ? why.slice(1) : ''; rtSt.n = S.list.length;
      var out = [];
      if (s && s.tiles) for (var i = 0; i < s.tiles.length; i++) { var u = bubUid(s.tiles[i]), b = u && bub.items[u]; out.push(b && !b.leaving && b.r ? bubPillPlan(b, s.tiles[i]) : undefined); }
      return out;
    }
    dbg.bubPlan = function (n, W, H) { return window.__rovaBubblePlan(n, W, H, BUB_GAP, []); };
    /* SHARED VIDEO ROW (2026-10-16, DJ Mike Luie on #2922; assets/liveshare.js rowLayout): while a shared video is on the stage, each
       person on air gets a box in a row under it, cropped from THIS player's picture. -> { el: the <video>, W, H (frame px), T: the timed
       tiles this picture shows (lwChips' lwChipState; a solo live = the whole frame), ids (null = an empty seat), names, draw: false where
       this browser can't paint its HLS into a canvas (Safari's native HLS until lwWkRt says ok; a black probe) -> the player itself
       goes in the row's box } or null (no picture). */
    var lwShT = null;
    dbg.shareSrc = function () {
      if (!v || done || !v.videoWidth || !v.videoHeight) return null;
      var apple = nativeHls && /Apple/.test(navigator.vendor || ''), draw = !(rtSt.probe === 'black' || rtSt.probe === 'error') && (!apple || rtMode === 'force' || lwWkRt() === 'ok');
      var c = lwShT, T = c ? c.tiles : [{ x: 0, y: 0, w: v.videoWidth, h: v.videoHeight }], W = c ? +c.L.w : v.videoWidth, H = c ? +c.L.h : v.videoHeight;
      return { el: v, W: W, H: H, T: T, draw: draw, src: c ? 'call' : 'solo',
        ids: T.map(function (t) { return c ? ('user_id' in t ? t.user_id : (t.user ? t.user.id : 0)) : 0; }),
        names: T.map(function (t) { var u = c && t.user; return u ? (u.display_name || (u.username ? '@' + u.username : '')) : ''; }) };
    };
    function rtWhy() { return bubWhy(); }
    function rtOff(why) {
      bubOff(why);   // THE BUBBLE STAGE (2026-10-22): a black / failed probe ends the bubbles too
      rtSt.why = why; rtSt.on = false;
      if (!rt) return;
      if (rt.vfc && v.cancelVideoFrameCallback) { try { v.cancelVideoFrameCallback(rt.vfc); } catch (e) {} }
      if (rt.raf) cancelAnimationFrame(rt.raf);
      if (rt.el.parentNode) rt.el.parentNode.removeChild(rt.el);
      stage.classList.remove('lw-rt-on');
      rt = null; rtSt.n = 0; rtSt.layout = '';
    }
    /* -> the plan (one entry per tile, rovaRetilePlan's) while re-tiled, else null (and the boxes are gone) */
    function lwRetile(s) { return bubRetile(s); }   // THE BUBBLE STAGE is the only picture (2026-10-23: the old flat re-tile is deleted)
    function rtKick() {}   // (the old re-tile's frame pump: deleted 2026-10-23)
    function rtOnFrame() {}
    function rtOnRaf() {}
    function rtDraw() {}
    /* A readable canvas (hls.js = a same-origin MediaSource): real pixels in the picture? Black at all three probes -> the one picture. Read
       from its OWN 16 px canvas (willReadFrequently), never from the boxes: a read-back can move a canvas off the GPU. */
    var rtPc = null;
    function rtProbe() {}
    /* the stage's top chrome (the host chip, LIVE / time / viewers, the gift total + likes, full screen) over [l, r]: the top row's pills sit
       under it, all on ONE line (the lowest of it across the stage) */
    function rtTop(l, r) {
      var y = 0, sr = stage.getBoundingClientRect(), els = stage.querySelectorAll(':scope > .lw-host, :scope > .lw-tl, :scope > .lw-fs, .lc-gtotal, .lc-likes');
      for (var i = 0; i < els.length; i++) {
        var e = els[i]; if (!e.offsetWidth || e.hidden) continue;
        var q = e.getBoundingClientRect(), t = q.top - sr.top - stage.clientTop, b = q.bottom - sr.top - stage.clientTop, x0 = q.left - sr.left, x1 = q.right - sr.left;
        if (t < 120 && x1 > l && x0 < r && b > y) y = b;
      }
      return y;
    }
    /* NAME PILLS AT THE BOTTOM-RIGHT (2026-10-12, Rob's rules for co-host calls + Open Rooms; liverealtime.js pillSpot is the twin on the
       host's preview + the guest's stage): the HOST's tile (the broadcaster, lwHostUid; else tile 0 / seat 0) gets NO name pill -- the
       header names them ("On a phone call" under their avatar still shows); every GUEST tile's pill sits at the BOTTOM-RIGHT corner of
       its VISIBLE tile, LW_PIN px in from the right and bottom edges, the same in every tile (the battle band's opponent chip keeps its
       own 10 px corner). The muted mic / phone disc go on the pill's LEFT, so the pill keeps the corner. The composer / gift buttons over
       that corner lift the line to LW_PIN above them; a lifted pill sits by the composer and never caps the chat. */
    var LW_PIN = 12;   // THE HEADER IN THE BUBBLE, ONE INSET (2026-10-23): the pills and the header share 12 px
    /* TAP A PERSON'S TILE = THEIR CARD (2026-10-15): the tiles lwChips laid out last (each one's VISIBLE rect on the stage: the server's
       rects through the current picture fit, the same mapping the pills use; empty / held seats out) -> livechat.js asks
       window.__rovaTileHit.viewer(x, y) on a tap on the picture. */
    var lwHitT = [];
    (window.__rovaTileHit = window.__rovaTileHit || {}).viewer = function (x, y) {
      if (!stage || !stage.isConnected || !lwHitT.length) return null;
      var sr = stage.getBoundingClientRect(), lx = x - sr.left - stage.clientLeft, ly = y - sr.top - stage.clientTop;
      for (var i = 0; i < lwHitT.length; i++) { var h = lwHitT[i]; if (lx >= h.l && lx < h.r && ly >= h.t && ly < h.b) return { uid: h.uid, user: h.user, seat: h.seat }; }
      return null;
    };
    function lwBotObs() {
      var out = []; if (!stage) return out;
      var sr = stage.getBoundingClientRect(), x0 = sr.left + stage.clientLeft, y0 = sr.top + stage.clientTop;
      var els = stage.querySelectorAll('.lc-bar:not(.lc-inline), .gs-giftbtn, .gs-quick, .lw-mute');   // + the sound button (2026-10-13: it sat on the pill's "+" on a desktop stage)
      for (var i = 0; i < els.length; i++) {
        var e = els[i]; if (e.hidden || !e.offsetWidth || !e.offsetHeight) continue;
        var q = e.getBoundingClientRect(); out.push({ l: q.left - x0, r: q.right - x0, t: q.top - y0, b: q.bottom - y0 });
      }
      return out;
    }
    function lwPillSpot(vx0, vy0, vx1, vy1, obs) {   // -> {r, b (the pill's right x + bottom y), lifted}
      var r = vx1 - LW_PIN, b = vy1 - LW_PIN, lifted = false, l = Math.max(vx0 + LW_PIN, r - 160);
      for (var pass = 0; pass < 3; pass++) {
        var moved = false;
        for (var i = 0; i < obs.length; i++) { var o = obs[i]; if (o.l < r && o.r > l && o.t < b && o.b > b - 24) { b = o.t - LW_PIN; lifted = true; moved = true; } }
        if (!moved) break;
      }
      return { r: r, b: b, lifted: lifted };
    }
    /* QB PHONE ROOM (2026-10-16): a narrow seat's pill name = the FIRST name ("Deladiea Smith" -> "Deladiea"); a short first word is a
       title and keeps the next one ("DJ Mike Luie" -> "DJ Mike"). liverealtime.js firstName() is its twin (the host's own preview).
       2026-10-16: "a title" = the short-name PREFIX list (NameText::NAME_PREFIXES; Dj/D.J., Dr, Lil, Big, King, Mc, St ...), not any
       <=3-letter word, and consecutive prefixes all stay ("Lil Big Mike Jones" -> "Lil Big Mike"). */
    function rovaFirstName(n) {
      var w = String(n || '').trim().split(/\s+/);
      if (w.length < 2 || /^@/.test(w[0])) return String(n || '');
      var k = 0;
      while (k < w.length - 1 && /^(dj|dr|mr|mrs|ms|miss|lil|big|yung|young|king|queen|prince|princess|mc|sir|lady|saint|st|coach|pastor|rev|uncle|auntie)$/.test(w[k].replace(/[.'’]/g, '').toLowerCase())) k++;
      return w.slice(0, k + 1).join(' ');
    }
    /* the host tile (stage px [l, t, r, b], null = none) as stage vars: .lw-h0 + --lw-h0l/t/r/b/w/h (livechat.css "QB PHONE ROOM"); a
       narrow host tile (< 210 px: six seats) stacks the podium + Carats under the left pills (.lw-h0s) */
    function lwH0Vars(st, r) {
      if (!st) return;
      var k = r ? [r[0], r[1], st.clientWidth - r[2], st.clientHeight - r[3], r[2] - r[0], r[3] - r[1]].map(function (x) { return Math.round(x); }).join(',') : '';
      if (st.__lwH0 === k) return;
      st.__lwH0 = k; st.classList.toggle('lw-h0', !!r); st.classList.toggle('lw-h0s', !!r && r[2] - r[0] < 210);
      var nm = ['l', 't', 'r', 'b', 'w', 'h'], v = k ? k.split(',') : [];
      nm.forEach(function (q, i) { if (r) st.style.setProperty('--lw-h0' + q, v[i] + 'px'); else st.style.removeProperty('--lw-h0' + q); });
    }
    function lwChips() {
      clearTimeout(lwCCt);
      var s = lwChipState();
      lwShT = s && s.tiles && s.tiles.length && s.L && +s.L.w > 0 ? { tiles: s.tiles, L: s.L } : null;   // SHARED VIDEO ROW (dbg.shareSrc)
      /* LIVE BATTLES (2026-10-15): the host's own tile in the picture THIS screen shows -> livebattle.js crops it into the left half (a room /
         grid composite on air during a battle, or for one delay after it). {x, y, w, h, W, H} frame px, or null = the whole picture. */
      if (s && s.tiles && !s.gone && lwCC && (lwCC.c.mode === 'room' || lwCC.c.mode === 'grid')) {
        var gRoom = lwCC.c.mode === 'room';
        lwGone = { tiles: gRoom ? s.tiles.map(function (t) { return t.user_id || t.user ? t : lwNoPlusT(t); }) : s.tiles, L: s.L, mode: lwCC.c.mode,
                   end: lwCC.c.ended_ms_ago != null ? lwCC.at - +lwCC.c.ended_ms_ago : null };
      }
      var pt = null;
      if (s && s.tiles && s.tiles.length && s.L && +s.L.w > 0 && +s.L.h > 0) {
        var pRoom = s.mode ? s.mode === 'room' : !!(lwCC && lwCC.c && lwCC.c.mode === 'room'), ph0 = null;
        for (var pi = 0; pi < s.tiles.length && !ph0; pi++) { var p0 = s.tiles[pi]; if (pRoom ? +p0.seat === 0 : !!lwHostUid && (+p0.user_id === lwHostUid || !!(p0.user && +p0.user.id === lwHostUid))) ph0 = p0; }
        if (!ph0 && !pRoom) ph0 = s.tiles[0];
        if (ph0 && +ph0.w > 0 && +ph0.h > 0) pt = { x: +ph0.x, y: +ph0.y, w: +ph0.w, h: +ph0.h, W: +s.L.w, H: +s.L.h };
      }
      /* BATTLE SIDES WITH GUESTS (2026-10-23): every PERSON in the picture this screen shows (timed like picTile), for livebattle.js's half bubbles */
      var pts = null;
      if (s && s.tiles && s.tiles.length && s.L && +s.L.w > 0 && +s.L.h > 0) {
        pts = [];
        for (var pj = 0; pj < s.tiles.length; pj++) { var q0 = s.tiles[pj], qu = +(q0.user_id || (q0.user && q0.user.id) || 0); if (!qu || !(+q0.w > 0 && +q0.h > 0)) continue;
          pts.push({ x: +q0.x, y: +q0.y, w: +q0.w, h: +q0.h, W: +s.L.w, H: +s.L.h, uid: qu, user: q0.user || null, off: !!q0.camera_off, host: qu === lwHostUid }); }
        if (!pts.length) pts = null;
      }
      dbg.picTiles = pts;
      var ptk = (pt ? [pt.x, pt.y, pt.w, pt.h, pt.W, pt.H].join(',') : '') + '|' + (pts ? pts.map(function (z) { return z.uid + ':' + z.x + ',' + z.y + ',' + z.w + ',' + z.h; }).join(';') : '');
      if (ptk !== (dbg.picTileK || '')) {
        dbg.picTileK = ptk; dbg.picTile = pt;
        setTimeout(function () { try { document.dispatchEvent(new CustomEvent('rova:live-pic', { detail: { tile: dbg.picTile } })); } catch (e) {} }, 0);
      }
      if (stage && stage.classList.contains('lbt-on')) { if (s && s.wait) lwCCt = setTimeout(lwChips, Math.min(s.wait + 60, 30000)); s = null; }   // the battle owns the stage: no call pills, seats, band or chat cap over it (the timer still re-decides picTile)
      if (s && s.wait) lwCCt = setTimeout(lwChips, Math.min(s.wait + 60, 30000));
      lwRoomBSet(lwRoomBWant(s));   // DESKTOP ROOM LAYOUT B (2026-10-16): before the re-tile (it sizes the stage)
      var rtp = lwRetile(s);   // the call re-tiled (a wide box, a portrait call): one box per person, or null = the one picture
      lwBCrop(s, rtp);   // GRID CALLS IN B (2026-10-16): not re-tiled (Safari) -> the people's box of the one picture fills the stage (CSS)
      // OPEN ROOMS (2026-10-12): the ROOM picture reached this player (its six seats are the timed tiles) or left it -> re-fit (lwFit runs this again)
      var rfOn = !!(s && rovaRoomTiles(s.tiles) && !rtp);   // ROOM BOX COUNT: any seat count
      if (rfOn !== lwRoomFit) { lwRoomFit = rfOn; lwFit(); return; }
      if (!s || !s.tiles || !v || !stage || !v.offsetWidth) { lwH0Vars(stage, null); lwHitT = []; lwSeatsPaint(''); if (lwCCel && lwCCel.__h) { lwCCel.innerHTML = ''; lwCCel.__h = ''; } dbg.callChips = 0; dbg.callMics = 0; dbg.callAways = 0; lwBand(null); lwCap(lwB ? null : lwNoticeLive()); lwCallOv(null); lwTileAway(false); lwRoomChat(null, 0, 0, 0); lwRBOff(); if (rtp && bub && bub.on) lwCap(bubCapBoxes()); return; }
      var hta = false;   // HOST AWAY: the broadcaster's own tile shows its "On a phone call" (then the stream-level pill stands down)
      if (!lwCCel || lwCCel.parentNode !== stage) { lwCCel = document.createElement('div'); lwCCel.className = 'lw-cchips'; stage.appendChild(lwCCel); lwCCel.addEventListener('click', lwSeatTap); }
      var room = s.mode ? s.mode === 'room' : !!(lwCC && lwCC.c && lwCC.c.mode === 'room'), seatHtml = '';   // OPEN ROOMS (db/0253): the seats (s.mode: a layout kept by lwGone)
      var rBot = 0; if (room) for (var rb0 = 0; rb0 < s.tiles.length; rb0++) rBot = Math.max(rBot, +s.tiles[rb0].y + +s.tiles[rb0].h);   // ROOM BOX COUNT: the lowest row's bottom
      var rMod = stage.classList.contains('lrt-room-mod');   // LIVE MODERATORS (db/0290): a mod may tap a locked seat (Unlock)
      var L = s.L, W = +L.w, H = +L.h, land = W > H, sw = stage.clientWidth, sh = stage.clientHeight;
      var bx = v.offsetLeft, by = v.offsetTop, bw = v.offsetWidth, bh = v.offsetHeight;
      var fit = rtp ? 'retile' : getComputedStyle(v).objectFit === 'contain' ? 'contain' : 'cover', k = fit === 'contain' ? Math.min(bw / W, bh / H) : Math.max(bw / W, bh / H);
      // ROOM CHAT AT THE BOTTOM (2026-10-15, lwRoomChat): a narrow box (a phone) -> the stage grows a floor under the seats for the chat.
      // THE CHAT BAND (2026-10-15 rev 2, lwRBand; Rob, desktop Safari: the room pushed right with an empty black column was "horrible"):
      // a desktop box -> the picture (a room, or a call shown as ONE picture) centred and top-anchored, scaled so a band of chat rows
      // fits UNDER every tile above the composer; the stage reaches down to the screen's bottom. (.lw-rcol is retired: rcx stays null.)
      var rcx = null, rcw = 0, rfl = false, rbk = 0, rbB = 0, rbT = H;
      if (!lwB && !rtp && !land && W > 0 && H > 0 && (room || s.tiles.length >= 2) && lwRBIn(room)) {   // LAYOUT B: no band (the chat is in the sidebar)
        for (var rb1 = 0; rb1 < s.tiles.length && rb1 < (room ? 6 : 5); rb1++) { rbB = Math.max(rbB, +s.tiles[rb1].y + +s.tiles[rb1].h); rbT = Math.min(rbT, +s.tiles[rb1].y); }
        if (rbB > 0 && lwRBWide(sw, W, H)) {
          lwRBStage(); sw = stage.clientWidth; sh = stage.clientHeight;
          rbk = Math.min(sw / W, sh / H, Math.max(0.12, (sh - 62 - 8 - LW_RB_LIST) / rbB));
          var rbx = lwRBLms((sw - W * rbk) / 2, rbT * rbk, (sw + W * rbk) / 2, rbB * rbk, sw);   // the Help pill: under LIVE / viewers, else the header row
          if (rbx > 0 && (2 * rbx - sw) / W < rbk) rbk = Math.max(0.12, (2 * rbx - sw) / W);   // ... else the picture ends left of it
          lwRBVideo(Math.floor(H * rbk), Math.max(0, Math.floor(sh - 62 - 8 - rbB * rbk - 8)), Math.max(0, Math.floor(H * rbk) - Math.ceil(rbB * rbk)), Math.round(rbB * rbk) + 28);   // Tap for sound: under the lowest tile, above the chat (2026-10-16, Rob: never on the host's face)
          bx = v.offsetLeft; by = v.offsetTop; bw = v.offsetWidth; bh = v.offsetHeight;
          fit = 'contain'; k = Math.min(bw / W, bh / H);
        } else if (room && lwRoomChatIn()) rfl = true;
      }
      if (!rbk) lwRBOff();
      var ox = bx + (rcx != null ? rcx : (bw - W * k) / 2), oy = by + (fit === 'contain' && stage.classList.contains('lw-fit-room') ? 0 : (bh - H * k) / 2);   // .lw-fit-room: top-anchored
      lwRoomChat(rcx, rcw, rfl ? Math.ceil(rBot * bw / W + LW_RF_BAND) : 0, rfl && rBot > 0 && (sh - 62) - (oy + rBot * k + 8) < LW_RF_MIN ? rBot : 0);
      // the VISIBLE picture = the frame ∩ the player box ∩ the stage
      var X0 = Math.max(0, bx, ox), X1 = Math.min(sw, bx + bw, ox + W * k), Y1 = Math.min(sh, by + bh, oy + H * k), html = '', n = 0, boxes = [], nm = 0, micWait = Infinity;
      var Y0 = Math.max(0, by, oy, lwB ? LW_B_BAR : 0), na = 0, lwTR = [], obs = lwB || (rtp && bub && bub.on) ? [] : lwBotObs(), hit = [];   // LAYOUT B: no composer / gift button / sound over the tiles (and nothing under the bar)
      /* QB PHONE ROOM (2026-10-16, Que Bee on iPhone Safari, #2959): h0 = the HOST tile's visible rect (lwH0Vars: the podium / Carats /
         hearts sit INSIDE it, never on a guest seat); a NARROW seat (< 150 px) names its person by the first name (rovaFirstName) without
         the photo, its muted mic inside the pill, so "Wolfgang" reads instead of "Wol...". */
      var h0 = null;
      var bubPill = !!(rtp && bub && bub.on);   // BUBBLE POLISH (2026-10-22): pills on bubbles
      for (var i = 0; i < s.tiles.length && i < (lwB ? 7 : room ? 6 : 5); i++) {   // 5: THE CALL BAND's 3 over 2 (2026-10-13; a grid call holds 4 today); B: up to 7 people
        var t = s.tiles[i], u = t.user || {}, name = u.display_name || (u.username ? '@' + u.username : '');
        var mu = lwMicState(t); if (mu.wait != null && mu.wait < micWait) micWait = mu.wait;
        var aw = lwAwayState(t); if (aw.wait != null && aw.wait < micWait) micWait = aw.wait;
        if (!name && !room) continue;
        var tx, ty, tw, th, tk = k, vx0, vx1, vy0, vy1;
        if (rtp) {
          // RE-TILED: the tile's box IS its visible picture
          var P = rtp[i]; if (!P) continue;
          tk = P.k; tx = P.l - (P.cx - t.x) * tk; ty = P.t - (P.cy - t.y) * tk; tw = t.w * tk; th = t.h * tk;
          vx0 = P.l; vx1 = P.l + P.w; vy0 = P.t; vy1 = P.t + P.h;
        } else {
          tx = ox + t.x * k; ty = oy + t.y * k; tw = t.w * k; th = t.h * k;
          vx0 = Math.max(X0, tx); vx1 = Math.min(X1, tx + tw); vy0 = Math.max(Y0, ty); vy1 = Math.min(Y1, ty + th);
        }
        lwTR.push([vx0, vy0, vx1, vy1]);   // COMPACT CALL CHAT: this tile's visible rect (lwCallOv)
        var hu = +u.id || +t.user_id || 0;   // TAP A PERSON'S TILE: a person (not an empty / held seat) with a tile big enough to tap
        if (hu > 0 && !t._hold && vx1 - vx0 >= 24 && vy1 - vy0 >= 24) hit.push({ l: vx0, t: vy0, r: vx1, b: vy1, uid: hu, user: t.user || null, seat: room ? +t.seat || 0 : 0 });
        var sp = lwPillSpot(vx0, vy0, vx1, vy1, obs), pb = sp.b;   // the pill's corner: its right x (sp.r), its bottom y (pb)
        if (!name) {
          /* OPEN ROOMS: an EMPTY seat -- a round "+" (a lock when locked) and its number, never burned into the picture. Tappable only while
             a tap can seat me (liverealtime.js puts .lrt-room-can on the stage from at.room.can_take); a tap -> rova:room-seat. */
          if (room && +t.seat > 0 && vx1 - vx0 >= 40 && vy1 - vy0 >= 40) {
            // TIME-ALIGNED (2026-10-12): no "+" where this picture may still show someone (_hold: the seat changes inside this player's
            // window; _noplus: not yet empty in the older estimate), and none while the host is away (lwAwP); a lock still shows
            if (t._hold || ((t._noplus || lwAwP) && !t.locked)) { if (+t.y + +t.h >= rBot - 1 && !sp.lifted) boxes.push({ l: vx0 + LW_PIN, r: vx1 - LW_PIN, t: pb - 24, b: pb }); continue; }
            seatHtml += '<button type="button" class="lw-seatb' + (t.locked ? ' is-locked' : '') + '" data-seat="' + (+t.seat) + '" style="left:' + vx0.toFixed(1) + 'px;top:' + vy0.toFixed(1) + 'px;width:' + (vx1 - vx0).toFixed(1) + 'px;height:' + (vy1 - vy0).toFixed(1) + 'px"' +
              ' aria-label="' + (t.locked ? 'Seat ' + (+t.seat) + ', locked' + (rMod ? '. Unlock' : '') : 'Take seat ' + (+t.seat)) + '"' + (t.locked && !rMod ? ' disabled' : '') + '><span class="lw-seatb-c">' + (t.locked ? LW_LOCK : LW_PLUS) + '</span><b class="lw-seatb-n">' + (+t.seat) + '</b></button>';
            if (+t.y + +t.h >= rBot - 1 && !sp.lifted && !lwRSkip) boxes.push({ l: vx0 + LW_PIN, r: vx1 - LW_PIN, t: pb - 24, b: pb });   // the bottom row's line caps the chat like a pill would (ROOM CHAT: not while the floor is short)
          }
          continue;
        }
        if (vx1 - vx0 < 48) continue;
        var isHost = lwHostUid ? (+u.id === lwHostUid || +t.user_id === lwHostUid) : (room ? +t.seat === 0 : i === 0);
        // the muted mic = a 24 px disc 4 px LEFT of the pill on its row: the pill's max width gives it the room (none on a sliver of a tile)
        var mic = !isHost && mu.on && vx1 - vx0 >= 48 + 28;
        // AWAY: the pill under the avatar (the broadcaster painted the avatar tile), or, no room there, a disc on the name pill's row
        if (bubPill && isHost && aw.k === 'call') hta = true;   // BUBBLE POLISH: the bubble says it (its badge)
        var ap = aw.k && !bubPill ? lwAwayPos(tx, ty, tw, th, tk, vx0, vy0, vx1, vy1, isHost ? null : pb - 24) : null;
        if (ap && !ap.compact) {
          html += '<span class="lw-cchip lw-caway" data-away="' + aw.k + '" style="left:' + ap.cx.toFixed(1) + 'px;top:' + ap.top.toFixed(1) + 'px;max-width:' + ap.max.toFixed(1) + 'px;transform:translateX(-50%)">' +
            LW_AWAY[aw.k] + '<span class="lw-cnm">' + (aw.k === 'call' ? 'On a phone call' : 'Away') + '</span></span>';
          na++;   // (never caps the chat: the chat stays where the name pills put it)
          if (isHost && aw.k === 'call') hta = true;
        }
        if (isHost && room && !rtp) h0 = [vx0, vy0, vx1, vy1];
        // HOST PILL ON ITS BUBBLE (2026-10-22, WS-D; Rob on Dealer's live: "put dealers thing in the bottom of his box like everyone else"): desktop
        // LAYOUT B with the bubbles draws the host's pill exactly like a guest's (bottom-left of the bubble) and hides the stage's .lw-host (rova.css)
        if (isHost && !(bubPill && bub.n > 1)) continue;   // the HOST's tile: no name pill (2026-10-12); a compact away leaves it to the stream-level pill (lwHostAway)
        var phn = !!(ap && ap.compact) && vx1 - vx0 >= 48 + (mic ? 56 : 28);
        var nar = ((room && !lwB && !rtp) || bubPill) && vx1 - vx0 < 150, micIn = nar && mic;   // QB PHONE ROOM: first name, no photo, the mic inside
        var mw = sp.r - (vx0 + LW_PIN) - (mic && !micIn ? 28 : 0) - (phn ? 28 : 0);
        if (pb - 24 < vy0 + 4 || mw < 36) continue;   // no room for the pill line in this tile
        // LAYOUT B (mock B): the pill at the tile's BOTTOM-LEFT, its mic / phone discs after it (rova.css's own spots)
        var pos = (lwB || bubPill ? 'left:' + (vx0 + LW_PIN).toFixed(1) : 'right:' + (sw - sp.r).toFixed(1)) + 'px;max-width:' + mw.toFixed(1) + 'px;top:' + (pb - 24).toFixed(1) + 'px';
        if (!sp.lifted) boxes.push({ l: sp.r - mw - (mic && !micIn ? 28 : 0) - (phn ? 28 : 0), r: sp.r, t: pb - 24, b: pb });   // the pill's widest extent (max-width + discs) x its 24 px line
        if (phn) na++;
        // THE PILL'S PHOTO (Rob 2026-10-05): a round avatar at the pill's left, then the name. tile.user.avatar is always a STILL image
        // (server: LiveRealtime::avatarStill, never a clip) or ''; the disc underneath is the site's no-photo monogram (gold, dark ink), so
        // a slow / missing / broken photo still reads as a face-shaped placeholder. A failed load drops the <img> (lwChipAvErr).
        var esc = function (x) { return String(x).replace(/[&<>"']/g, function (q) { return '&#' + q.charCodeAt(0) + ';'; }); };
        var avu = typeof u.avatar === 'string' && /^(https?:\/\/|\/)/.test(u.avatar) ? u.avatar : '';
        var ini = nameInitial(u.display_name, u.username);   // same IIFE (hoisted): code point, never charAt(0)
        // OPEN ROOMS: a seat's pill starts with its number and is a tap target (Report / View profile: liverealtime.js)
        var seatA = room ? ' data-seat="' + (+t.seat || 0) + '" data-un="' + esc(u.username || '') + '" data-nm="' + esc(name) + '"' : '';
        html += '<span class="lw-cchip' + (mic ? ' lw-cmut' : '') + (phn ? ' lw-cphn' : '') + (room ? ' lw-cseatp' : '') + (nar ? ' lw-cnarrow' : '') + '" data-uid="' + (+u.id || 0) + '"' + seatA + lwPillA(u, name, room, esc) + ' style="' + pos + '">' + (room && +t.seat > 0 ? '<b class="lw-cseat">' + (+t.seat) + '</b>' : '') + '<span class="lw-cav" data-ini="' + esc(ini) + '">' +
          (avu ? '<img src="' + esc(avu) + '" alt="" decoding="async">' : '') + '</span>' + (micIn ? '<span class="lw-cmic lw-cmic-in">' + LW_MIC + '</span>' : '') + '<span class="lw-cnm">' + esc(nar ? rovaFirstName(name) : name) + '</span>' + lwPillPlus(u, mw) +
          (mic && !micIn ? '<span class="lw-cmic"' + (lwB || bubPill ? '' : ' style="left:auto;right:calc(100% + 4px)"') + '>' + LW_MIC + '</span>' : '') + (phn ? '<span class="lw-cphone" data-away="' + aw.k + '" title="' + (aw.k === 'call' ? 'On a phone call' : 'Away') + '"' + (lwB || bubPill ? '' : ' style="left:auto;right:calc(100% + ' + (mic ? 32 : 4) + 'px)"') + '>' + LW_AWAY[aw.k] + '</span>' : '') + '</span>'; n++; if (mic) nm++;
      }
      // a mute / unmute still on its way to this picture: re-decide at that moment (sooner than the pills' own timer)
      if (micWait < Infinity && !(s.wait && s.wait <= micWait)) { clearTimeout(lwCCt); lwCCt = setTimeout(lwChips, Math.min(micWait + 60, 30000)); }
      lwHitT = hit; dbg.callHits = hit.length;
      dbg.callMics = nm; dbg.callAways = na;
      if (lwCCel.__h !== html) {
        lwCCel.innerHTML = html; lwCCel.__h = html;
        var ims = lwCCel.querySelectorAll('.lw-cav img');
        for (var j = 0; j < ims.length; j++) ims[j].addEventListener('error', lwChipAvErr);
      }
      dbg.callChips = n; dbg.callChipFit = fit;
      lwSeatsPaint(room ? seatHtml : '');
      lwBand(rtp || land || lwB ? null : s.tiles.slice(0, room ? 6 : 5), ox, oy, k, X0, X1, Y0, Y1, H, boxes);   // THE CALL BAND (2026-10-13)
      if (rcx != null) boxes.push({ l: 0, r: sw, t: 0, b: rtTop(0, 10 + rcw) });   // ROOM CHAT: the column's top = under the top chrome
      if (rbk) { var rbY = oy + rbB * k; boxes.push({ l: -1e5, r: 1e5, t: rbY - 1, b: rbY }); dbg.roomChat = { mode: 'band', k: +k.toFixed(4), h: sh, pic: Math.round(W * k) + 'x' + Math.round(H * k), rows: Math.max(0, Math.floor(sh - 62 - rbY - 8)) }; }   // THE CHAT BAND
      lwH0Vars(stage, room && !lwB && !rtp && sw < 600 ? h0 : null);   // QB PHONE ROOM: the host tile for the podium / Carats / hearts
      lwCap(lwB ? null : bub && bub.on ? boxes.concat(bubCapBoxes()) : boxes.concat(lwNoticeBoxes()));   // 2026-10-23 (a solo live on a short phone): the chat starts under Tap for sound / Join too   // THE BUBBLE STAGE: under the lowest bubble too. LAYOUT B: the chat is in the sidebar (nothing to cap, no compact chat)
      lwCallOv(dbg.band || rbk || lwB || (bub && bub.on) ? null : lwTR);   // THE BUBBLE STAGE: the bubbles never reach the chat   // THE CALL BAND / THE CHAT BAND: the chat is already under every tile (no compact chat)
      lwTileAway(hta);
      if (lwB) lwBBar();   // LAYOUT B: late arrivals (the likes pill, the podium) join the top bar
    }
    /* OPEN ROOMS (db/0253): the empty seats' overlays (.lw-seats > button.lw-seatb, rova.css) and a tap on a seat -> rova:room-seat
       {seat, empty, user_id, username, name} (assets/liverealtime.js viewer: the join sheet / Report). */
    var lwSeatsEl = null;
    var LW_PLUS = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"/></svg>';
    var LW_LOCK = '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="10.5" width="14" height="10" rx="2.2" fill="currentColor"/><path d="M8.5 10.5V8a3.5 3.5 0 0 1 7 0v2.5" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>';
    function lwSeatsPaint(h) {
      if (!h && !lwSeatsEl) return;
      if (!lwSeatsEl || lwSeatsEl.parentNode !== stage) { lwSeatsEl = document.createElement('div'); lwSeatsEl.className = 'lw-seats'; stage.appendChild(lwSeatsEl); lwSeatsEl.addEventListener('click', lwSeatTap); }
      if (lwSeatsEl.__h !== h) { lwSeatsEl.innerHTML = h; lwSeatsEl.__h = h; }
      dbg.roomSeats = h ? lwSeatsEl.children.length : 0;
    }
    function lwSeatTap(e) {
      var b = e.target && e.target.closest ? e.target.closest('[data-seat]') : null; if (!b) return;
      var empty = b.classList.contains('lw-seatb');
      if (empty && (b.disabled || !(stage.classList.contains('lrt-room-can') || stage.classList.contains('lrt-room-mod')))) return;   // + a moderator (db/0290)
      e.preventDefault(); e.stopPropagation();
      try { document.dispatchEvent(new CustomEvent('rova:room-seat', { detail: { seat: +b.getAttribute('data-seat') || 0, empty: empty,
        user_id: +b.getAttribute('data-uid') || 0, username: b.getAttribute('data-un') || '', name: b.getAttribute('data-nm') || '' } })); } catch (x) {}
    }
    /* EVERYONE ON SCREEN IS FOLLOWABLE (2026-10-13, Rob: "I tried to tap their pills to follow them but it just sends a like"): a guest's
       pill is a PERSON. livechat.js takes the tap (the live profile card) and the "+" (follow at once); here: the pill's button attributes
       (lwPillA; data-un for the card's handle) and the gold "+" while window.__rovaPillFollow says this viewer doesn't follow them yet
       (lwPillPlus; only on a pill that may be >= 120 px wide: a narrow seat on a phone keeps its name, the card has Follow); a follow state changing anywhere ('rova:live-follow') repaints the pills. */
    function lwPillA(u, name, room, esc) {
      var id = +(u && u.id) || 0; if (!(id > 0)) return '';
      return ' role="button" tabindex="0"' + (room ? '' : ' data-un="' + esc(u.username || '') + '"') + ' aria-label="' + esc(name) + ', open profile"';
    }
    function lwPillPlus(u, mw) {
      var id = +(u && u.id) || 0;
      return id > 0 && mw >= 120 && typeof window.__rovaPillFollow === 'function' && window.__rovaPillFollow(id) ? '<span class="lw-cfol" aria-hidden="true"></span>' : '';
    }
    document.addEventListener('rova:live-follow', function () { if (lwCCel && lwCCel.__h) lwChips(); });
    /* HOST AWAY: "THE HOST IS ON A PHONE CALL" (2026-10-08; @Kaine's SOLO live #867: a phone call took his mic, viewers heard silence and
       wrote "Can't hear you"). Every poll carries stream.host_away ("call" | "background" | null) + host_away_since_ms (ms AGO it last
       changed; null = no change on record) + host_away_prev (Live::hostAwayView; the host's client POSTs /live/{id}/host-state; API.md
       "Host away"). TIMED LIKE THE CALL PILLS (the muted mic / AWAY): this player's own lag (lwLatency; hls_lag_ms / 15 s until it can be
       measured) -- away shows once since_ms + the time since the poll reaches lag + 250 ms, back clears at lag - 1000 ms; until then the
       state before it (host_away_prev) shows; a timer re-decides at that moment.
         call        a small pill over the picture (.lw-haway): a phone glyph + "Host is on a phone call · audio paused". Not while the
                     call grid already draws the host's own tile pill "On a phone call" (lwChips -> lwTileAway): one label per fact.
         background  "Be right back" (paintBrb why 'away'), the reconnect overlay.
       Hidden on an ended page, under Be right back, a veil, and in the call stage (rova.css). Debug: __rovaLiveWatch.hostAway. */
    var lwHA = null, lwHAt = 0, lwHAel = null, lwHostUid = parseInt(root.getAttribute('data-uid') || '0', 10) || 0, lwHostTileAw = false;
    function lwHostAway(s) {
      if (!s) return;
      if (s.broadcaster && +s.broadcaster.id > 0) lwHostUid = +s.broadcaster.id;
      if (+s.hls_edge_lag_ms > 0) lwEdgeMs = +s.hls_edge_lag_ms;          // LIVE DELAY: camera -> playlist end (lwEdgeLag)
      if (+s.ll_hls_edge_lag_ms > 0) lwEdgeLlMs = +s.ll_hls_edge_lag_ms;
      if (!('host_away' in s)) return;   // a server from before 2026-10-08: nothing to say
      var K = function (x) { return x === 'call' || x === 'background' ? x : ''; };
      lwHA = { k: K(s.host_away), ms: typeof s.host_away_since_ms === 'number' ? s.host_away_since_ms : null, p: K(s.host_away_prev), at: Date.now() };
      var awMoved = lwAwNote('h', lwHA.k, lwHA.ms, lwHA.at, lwHA.p);   // TIME-ALIGNED OVERLAY: the host's away interval (lwAlign)
      lwHostAwayPaint();
      if (awMoved && lwCC) lwChips();
    }
    /* IN SYNC WITH THE PICTURE (2026-10-16, Rob: the pill came ~2 s before the host's audio paused in the video = lwLatency's 'edge'
       estimate ran ~3 s short; fixed there, lwEdgeLag). Not lag-timed (the server's state at once):
         rt      the picture is real time -- the group-live fallback pulls the guests from the SFU (stage .lfb-on, ~0.5 s) or this viewer
                 is IN the call (.lrt-incall)
         stall   this player's picture has stood still >= 4 s (localWhy 'stall' | 'video'): there is no frame to wait for; the stall's
                 own Be right back covers it; re-decided every second so the lag timing returns with the picture
       Lag-timed edges (2026-10-16): away ON at lag + 1000 ms (was + 250: "audio paused" over audio that still plays is the worse error;
       the estimate's own spread is ~+-0.7 s, hasync2\sim.cjs), back OFF at lag - 500 ms (was - 1000). */
    function lwHostAwayState() {
      if (!lwHA) return { k: '' };
      if (lwHA.ms == null) return { k: lwHA.k };
      if (stage && (stage.classList.contains('lfb-on') || stage.classList.contains('lrt-incall'))) return { k: lwHA.k, how: 'rt' };
      if (localWhy && status === 'live') return { k: lwHA.k, how: 'stall', wait: 1000 };
      var lat = lwLatency(), lag = lat || (lwCC && +(llParts && lwCC.c.ll_hls_lag_ms || lwCC.c.hls_lag_ms)) || 15000;
      var age = lwHA.ms + (Date.now() - lwHA.at), need = lwHA.k ? lag + 1000 : Math.max(0, lag - 500);
      return age >= need ? { k: lwHA.k, how: 'lag', lag: Math.round(lag) } : { k: lwHA.p, how: 'lag', lag: Math.round(lag), wait: need - age };
    }
    /* THE STATUS BANNER, CENTRED (2026-10-23, Rob): "Host is on a phone call · audio paused" sits in the exact centre of the stage (under the
       desktop B bar: of the box under it; rova.css .lw-haway), and if that centre would cover a person's photo ring, status chip or name
       pill it steps down (then up) in 8 px steps to the nearest clear spot -- with 2+ bubbles that is the gutter between them. */
    function lwBannerPlace(el) {
      if (!el || !stage) return;
      el.style.removeProperty('--lw-ban-dy');
      var sr = stage.getBoundingClientRect(), r0 = el.getBoundingClientRect(); if (!r0.width) return;
      var avoid = [].map.call(stage.querySelectorAll('.lw-bub:not(.is-live) .lw-bub-avw, .lw-bub:not(.is-live) .lw-bub-chip:not([hidden]), .lw-bub:not(.is-live) .lw-bub-nm, .lw-cchip'), function (e) { return e.getBoundingClientRect(); }).filter(function (r) { return r.width > 0 && r.height > 0; });
      function hits(dy) { for (var i = 0; i < avoid.length; i++) { var q = avoid[i]; if (r0.left < q.right + 6 && r0.right > q.left - 6 && r0.top + dy < q.bottom + 6 && r0.bottom + dy > q.top - 6) return true; } return false; }
      if (!hits(0)) return;
      for (var s = 8; s < sr.height / 2; s += 8) {
        if (r0.bottom + s < sr.bottom - 70 && !hits(s)) { el.style.setProperty('--lw-ban-dy', s + 'px'); return; }
        if (r0.top - s > sr.top + 56 && !hits(-s)) { el.style.setProperty('--lw-ban-dy', -s + 'px'); return; }
      }
    }
    function lwTileAway(b) { if (b !== lwHostTileAw) { lwHostTileAw = b; lwHostAwayPaint(); } }
    function lwHostAwayPaint() {
      clearTimeout(lwHAt);
      var st = done || draining ? { k: '' } : lwHostAwayState();
      if (st.wait != null) lwHAt = setTimeout(lwHostAwayPaint, Math.min(st.wait + 60, 30000));
      var call = st.k === 'call' && !lwHostTileAw;
      if (call && !lwHAel && stage) {
        lwHAel = document.createElement('div'); lwHAel.className = 'lw-haway'; lwHAel.setAttribute('role', 'status'); lwHAel.setAttribute('aria-live', 'polite'); lwHAel.hidden = true;
        lwHAel.innerHTML = LW_AWAY.call + '<span class="lw-haway-t">Host is on a phone call · audio paused</span>';
        stage.appendChild(lwHAel);
      }
      if (lwHAel) { lwHAel.hidden = !call; if (call) lwBannerPlace(lwHAel); }
      root.classList.toggle('is-host-away', call);
      dbg.hostAway = { k: lwHA ? lwHA.k : '', since: lwHA ? lwHA.ms : null, shown: st.k, wait: st.wait != null ? Math.round(st.wait) : null, pill: call, tile: lwHostTileAw, how: st.how || '', lag: st.lag != null ? st.lag : null };
      if (st.k !== hostAwayK) { hostAwayK = st.k; paintBrb(); }
    }
    /* ROOM CHAT AT THE BOTTOM (2026-10-15, Rob on Open Rooms: "it puts the chat on the right but I want it bottom"; on a phone a room showed
       ONE chat row: the 5-seat frame's bottom row ends at y 996 of 1280 and the composer sits in the floor). A ROOM picture whose chat is in
       the stage (never the sidebar for a room: livechat.js decide) is never re-tiled (rtWhy 'roomchat') and lays out ONE of two ways:
         .lw-rcol    a box wider than the picture (desktop, a tablet): the picture moves RIGHT (object-position --lw-rcx) just far
                     enough that the chat's column (--lw-rcw, <= 380 px, >= LW_RC_MIN) fits in the black margin LEFT of it, from the top
                     chrome down to the composer (livechat.css: up to 400 px of rows). Nobody is ever under the chat.
         .lw-rfloor  a narrow box (a phone): the picture stays width-fitted and top-anchored, and the STAGE grows a floor under the
                     seats: min-height = the seats' bottom + LW_RF_BAND (--lw-rf-want), never taller than the screen (100svh - 80 px,
                     livechat.css). The chat sits under every tile, as in a call band. Where the screen is still too short for
                     LW_RF_MIN of rows, an EMPTY seat in the bottom row (a "+" / lock, nobody in it) stops capping the chat (lwRSkip),
                     so the rows may rise over the placeholders; a seated person's tile always caps it; and the rows are a size
                     smaller (.lw-rtight, the compact chat's row size) so a 360 px phone still shows 5.
       Both show the stage's hide-chat button (.lc-hidebtn; .lc-hid hides the rows, livechat.css). Solo lives, calls and battles: unchanged.
       Debug: __rovaLiveWatch.roomChat = { mode: 'col' | 'floor', ... } or 0. */
    var LW_RC_W = 380, LW_RC_MIN = 200, LW_RF_BAND = 300, LW_RF_MIN = 185, lwRSkip = 0;
    /* ---- DESKTOP ROOM LAYOUT B (2026-10-16, Rob picked mock B, with one change: "then we can use the black bar for all the stuff like how
       much gold, how much hearts, and the top gifters so nothing blocks her screen except her name"). SUPERSEDES the chat band below for a
       desktop ROOM (phones, solo, battles, co-host calls: unchanged). While the picture this player shows is a ROOM (the timed tiles,
       rovaRoomTiles), the window is >= 900 px and the sidebar shows (#feed-aside), not a battle / veil / ended page: .lw-roomb on the stage --
         the stage reaches down to 16 px above the screen's bottom (--lw-rbh);
         a TOP BAR (.lw-rbar, LW_B_BAR px, above the tiles, never over them) holds everything: LIVE + the eye (+ the host's timer) | the
         Gold total, the likes, the top gifters | the Help / share pill (centre) | sound, full screen. The elements are MOVED into it
         (lwBPut remembers each one's home; lwBUnbar puts them back in reverse order, so the CSS sibling rules hold again);
         the tiles fill the rest: re-tiled (rovaRetilePlan lay 'b': the host the left half at full height, the seats 2 to a row on the
         right), cover-cropped, heads kept (30% of a vertical cut above);
         nothing over the host's picture but her name pill (.lw-host, livechat.css), the guests' pills at their tiles' bottom-left;
         livechat.js moves the chat (rows, composer, gift button, Join / a seated guest's controls) into the sidebar (decide() 'room').
       SAFARI (native HLS): the re-tile needs WebKit to paint the HLS <video> into a canvas, which a tainted canvas cannot prove. lwWkRt
       probes it ONCE per browser (3 days, localStorage rova_rt_wk): a hidden muted crossorigin copy of the stream plays a few seconds into
       a 16 px canvas; black every look -> 'black' = no re-tile here (the one picture, contain, in the tile box); anything else re-tiles.
       Debug: __rovaLiveWatch.roomB (bool), .wkProbe. ?retile=off still turns the re-tile off. */
    var lwB = false, LW_B_BAR = 52, lwBBarEl = null, lwBParked = [], lwWk = null, lwCCPolled = false;
    /* GRID CALLS IN LAYOUT B (2026-10-16, Rob watching @cognac's 4-person co-host call #2922 in desktop Safari: "This web Safari design
       needs to be fixed and look more like the TV"): every desktop multi-person live that is not a battle gets B -- a GRID co-host call
       (2..7 people, the composite's mode 'grid') too: the same top bar, the people filling the stage (rovaRetilePlan lay 'b' + hi = the
       host's tile), name pills on the tiles only, the chat + composer + Ask to join in the sidebar. NOT for a viewer who is IN the call
       (.lrt-incall: liverealtime.js draws a grid guest's own stage) -- only an open room's seated guest has a B stage of its own. */
    function lwGridHi(t) {
      if (!t || !t.length || rovaRoomTiles(t)) return 0;
      for (var i = 0; i < t.length; i++) if (t[i] && (t[i].host === true || (lwHostUid && (+t[i].user_id === lwHostUid || (t[i].user && +t[i].user.id === lwHostUid))))) return i;
      return 0;
    }
    function lwGridB(s) {
      if (!s || !s.tiles || s.tiles.length < 2 || s.tiles.length > 7 || rovaRoomTiles(s.tiles)) return false;
      if (stage.classList.contains('lrt-incall')) return false;
      return (s.mode ? s.mode : lwCC && lwCC.c ? lwCC.c.mode : '') === 'grid';
    }
    function lwRoomBWant(s) {
      if (!stage || !v || done || draining) return false;
      var c = stage.classList; if (c.contains('lbt-on') || c.contains('nsfw-gate')) return false;
      var as = document.getElementById('feed-aside');
      if ((window.innerWidth || 0) < 900 || !as || !as.offsetWidth || !document.getElementById('livechat')) return false;
      if (s && s.tiles) return (rovaRoomTiles(s.tiles) || lwGridB(s)) && !(s.L && +s.L.w > +s.L.h);
      if (!lwCCPolled) return !!lwB;   // FIRST PAINT (lwRoomBEarly): the server said "a room" / "a call"; nothing polled yet
      if (!lwCC || !lwCC.c || (lwCC.c.mode !== 'room' && lwCC.c.mode !== 'grid')) return false;   // the picture is no room / call any more (solo / battle)
      if (lwCC.c.mode === 'grid' && c.contains('lrt-incall')) return false;
      return !!lwB;   // a room / call whose picture has not reached this player yet: as it was
    }
    /* SAFARI WITHOUT THE RE-TILE (2026-10-16, GRID CALLS IN B): while B is on and the boxes are not drawn (Safari's probe says 'black' or
       is still looking, ?retile=off, the frame not yet this layout's), the ONE <video> is scaled and offset so the people's own box in
       the frame (the tiles' bounding box: the band's 2 x 2, side by side, 3 over 2) fills the stage under the bar -- plain CSS (no canvas,
       nothing to taint), contain with at most 12% cropped (the frame's empty floor and top band are clipped away). -> true while on. */
    function lwBCrop(s, rtp) {
      var on = false;
      if (lwB && !rtp && s && s.tiles && s.tiles.length >= 2 && s.L && +s.L.w > 0 && +s.L.h > 0 && v && stage && !stage.classList.contains('lfb-on')) {
        var W = +s.L.w, H = +s.L.h, x0 = W, y0 = H, x1 = 0, y1 = 0;
        for (var i = 0; i < s.tiles.length && i < 7; i++) { var t = s.tiles[i]; x0 = Math.min(x0, +t.x); y0 = Math.min(y0, +t.y); x1 = Math.max(x1, +t.x + +t.w); y1 = Math.max(y1, +t.y + +t.h); }
        var sw = stage.clientWidth, ah = stage.clientHeight - LW_B_BAR, bw = x1 - x0, bh = y1 - y0;
        if (sw > 0 && ah > 0 && bw > 0 && bh > 0) {
          var kc = Math.min(sw / bw, ah / bh), k = Math.min(Math.max(sw / bw, ah / bh), kc * 1.12);
          var vl = (sw - bw * k) / 2 - x0 * k, vt = LW_B_BAR + (ah - bh * k) / 2 - y0 * k, vw = W * k, vh = H * k;
          // the clip, in the video's own px: the people's box, never above the bar or outside the stage
          var ct = Math.max(y0 * k, LW_B_BAR - vt), cl = Math.max(x0 * k, -vl), cr = Math.max(vw - x1 * k, vl + vw - sw), cb = Math.max(vh - y1 * k, vt + vh - (LW_B_BAR + ah));
          var css = [vl, vt, vw, vh].map(function (x) { return x.toFixed(1) + 'px'; }).join(' ') + '|' + [ct, cr, cb, cl].map(function (x) { return Math.max(0, x).toFixed(1) + 'px'; }).join(' ');
          if (stage.__lwBc !== css) {
            stage.__lwBc = css;
            var p = css.split('|')[0].split(' ');
            stage.style.setProperty('--lw-bcx', p[0]); stage.style.setProperty('--lw-bcy', p[1]); stage.style.setProperty('--lw-bcw', p[2]); stage.style.setProperty('--lw-bch', p[3]);
            stage.style.setProperty('--lw-bcc', css.split('|')[1]);
          }
          // the host's name pill: on the HOST's tile of the picture (a 3 / 5-person band puts the host in the middle), not on a side band
          var ht = s.tiles[lwGridHi(s.tiles)] || s.tiles[0], hx = Math.max(0, vl + +ht.x * k), hy = Math.max(LW_B_BAR, vt + +ht.y * k);
          var hv = hx.toFixed(1) + 'px ' + hy.toFixed(1) + 'px';
          if (stage.__lwBh0 !== hv) { stage.__lwBh0 = hv; stage.style.setProperty('--lw-bhx', hx.toFixed(1) + 'px'); stage.style.setProperty('--lw-bhy', hy.toFixed(1) + 'px'); }
          on = true;
        }
      }
      if (on !== stage.classList.contains('lw-bcrop')) stage.classList.toggle('lw-bcrop', on);
      if (!on) stage.__lwBc = '';
      dbg.bCrop = on;
      return on;
    }
    function lwRoomBSize() {
      // the WHOLE card fits under the header (Rob 10-16, resizing: the title / Share / Report row went below the fold): the stage gets
      // the screen's height minus what sits above it and the card's footer row under it; the tiles shrink, never the footer
      var vh = window.innerHeight || document.documentElement.clientHeight || 0, sr0 = stage.getBoundingClientRect(), top = sr0.top + (window.pageYOffset || document.documentElement.scrollTop || 0);
      var card = stage.closest ? stage.closest('.live-watch') : null, foot = card ? Math.max(0, card.getBoundingClientRect().bottom - sr0.bottom) : 0;
      var h = Math.max(420, Math.floor(vh - top - foot - 16)) + 'px';
      if (stage.__lwBh !== h) { stage.__lwBh = h; stage.style.setProperty('--lw-rbh', h); }
    }
    function lwRoomBSet(on) {
      if (!stage) return;
      on = !!on;
      if (on) lwRoomBSize();
      if (on === !!lwB) return;
      lwB = on; dbg.roomB = on;
      if (!lwBParked) lwBParked = [];
      stage.classList.toggle('lw-roomb', on);
      if (on) lwBBar(); else lwBUnbar();
      setTimeout(lwFit, 0);   // the fit (contain under the bar) + the full-screen button
      try { document.dispatchEvent(new CustomEvent('rova:live-roomb', { detail: { on: on } })); } catch (e) {}
    }
    function lwBPut(el, box) {
      if (!el || !box || el.parentNode === box) return;
      if (lwBParked.indexOf(el) < 0) { el.__lwBHome = { p: el.parentNode, n: el.nextSibling }; lwBParked.push(el); }
      box.appendChild(el);
    }
    function lwBBar() {
      if (!stage) return;
      if (!lwBBarEl) {
        lwBBarEl = document.createElement('div'); lwBBarEl.className = 'lw-rbar';
        lwBBarEl.innerHTML = '<div class="lw-rbar-l"></div><div class="lw-rbar-c"></div><div class="lw-rbar-r"></div>';
      }
      if (lwBBarEl.parentNode !== stage) stage.insertBefore(lwBBarEl, stage.firstChild);
      var L = lwBBarEl.children[0], C = lwBBarEl.children[1], R = lwBBarEl.children[2];
      lwBPut(stage.querySelector('.lw-tl') || stage.querySelector('.lw-vc-solo'), L);
      lwBPut(stage.querySelector('.lc-gtotal'), L);
      lwBPut(stage.querySelector('.lc-likes'), L);
      lwBPut(stage.querySelector('#gs-podium') || stage.querySelector('.gs-podium'), L);
      lwBPut(stage.querySelector('#gs-earned'), L);
      lwBPut(stage.querySelector('.lms'), C);
      lwBPut(muteBtn, R); lwBPut(fsBtn, R);
    }
    function lwBUnbar() {
      for (var i = lwBParked.length - 1; i >= 0; i--) {
        var el = lwBParked[i], h = el.__lwBHome; el.__lwBHome = null;
        if (!h || !h.p || !h.p.isConnected) { stage.appendChild(el); continue; }
        if (h.n && h.n.parentNode === h.p) h.p.insertBefore(el, h.n); else h.p.appendChild(el);
      }
      lwBParked = [];
      if (lwBBarEl && lwBBarEl.parentNode) lwBBarEl.parentNode.removeChild(lwBBarEl);
    }
    function lwWkRt() {
      if (lwWk) return lwWk;
      var ua = navigator.userAgent || '', K = 'rova_rt_wk';
      try { var c0 = JSON.parse(localStorage.getItem(K) || 'null'); if (c0 && c0.ua === ua && Date.now() - c0.at < 3 * 864e5 && c0.v) { dbg.wkProbe = c0.v + ' (saved)'; return (lwWk = c0.v === 'black' ? 'black' : 'ok'); } } catch (e) {}
      if (!srcHls || !document.body) return 'probing';
      lwWk = 'probing'; dbg.wkProbe = 'probing';
      var fin1 = false, p = document.createElement('video'), cv = document.createElement('canvas'), cx = null, looks = 0, lastLook = 0, tm = 0;
      function fin(res) {
        if (fin1) return; fin1 = true; clearTimeout(tm);
        try { p.pause(); p.removeAttribute('src'); p.load(); } catch (e) {}
        if (p.parentNode) p.parentNode.removeChild(p);
        lwWk = res === 'black' ? 'black' : 'ok'; dbg.wkProbe = res;
        try { localStorage.setItem(K, JSON.stringify({ v: res, ua: ua, at: Date.now() })); } catch (e) {}
        lwChips();
      }
      function look() {
        var now = Date.now();
        if (fin1 || p.readyState < 2 || !(p.videoWidth > 0) || p.currentTime < 0.5 || now - lastLook < 250) return;
        lastLook = now; var d, mx = 0;
        try { cv.width = cv.height = 16; cx = cx || cv.getContext('2d', { willReadFrequently: true }); cx.drawImage(p, 0, 0, 16, 16); d = cx.getImageData(0, 0, 16, 16).data; }
        catch (e) { fin('tainted'); return; }   // CORS not honoured: unprovable -> drawn for display only, as Chromium's native HLS is
        for (var j = 0; j < d.length; j += 4) mx = Math.max(mx, d[j], d[j + 1], d[j + 2]);
        if (mx > 12) fin('ok'); else if (++looks >= 12) fin('black');
      }
      p.muted = true; p.playsInline = true; p.setAttribute('playsinline', ''); p.setAttribute('muted', ''); p.crossOrigin = 'anonymous'; p.preload = 'auto';
      p.setAttribute('aria-hidden', 'true'); p.style.cssText = 'position:fixed;left:-9999px;top:0;width:16px;height:16px;opacity:0;pointer-events:none';
      p.addEventListener('timeupdate', look); p.addEventListener('error', function () { fin('error'); });
      tm = setTimeout(function () { fin('timeout'); }, 15000);
      document.body.appendChild(p);
      p.src = srcHls; try { var pp = p.play(); if (pp && pp.catch) pp.catch(function () {}); } catch (e) {}
      return lwWk;
    }
    window.addEventListener('resize', function () { if (lwB || (lwCC && lwCC.c && (lwCC.c.mode === 'room' || lwCC.c.mode === 'grid'))) lwChips(); }, { passive: true });   // LAYOUT B: a window crossing 900 px / a new height
    /* FIRST PAINT (2026-10-16, Rob: a refresh painted the old layout, then switched): the server marks an open room's stage .lw-roomb-ssr
       (views/live_watch.php); B turns on HERE, as the page mounts (before livechat.js starts, so the chat starts in the sidebar), and the
       first poll confirms it (lwRoomBWant: a room that has ended since -> off). .lw-rbd = decided (livechat.css's pre-decision rules stop). */
    (function lwRoomBEarly() {
      if (!stage || !stage.classList.contains('lw-roomb-ssr')) return;
      var as = document.getElementById('feed-aside');
      if (!done && v && (window.innerWidth || 0) >= 900 && as && as.offsetWidth && document.getElementById('livechat') && !stage.classList.contains('nsfw-gate')) lwRoomBSet(true);
      stage.classList.add('lw-rbd');
      var late = function () { if (lwB) { lwBBar(); lwRoomBSize(); } };   // the likes pill / podium the later scripts draw join the bar
      document.addEventListener('DOMContentLoaded', late); window.addEventListener('load', late);
    })();
    /* THE CHAT BAND (2026-10-15 rev 2; Rob, desktop Safari, @cognac's Open Room: the picture pushed to the right half with an empty black
       column and one chat row, the Help pill over seat 1's number, Join on the chat button; "chat AT THE BOTTOM"). A desktop box (a
       window >= 900 px, or a box with >= 230 px to spare beside the picture) showing a ROOM, or a CALL shown as one picture (Safari never
       re-tiles; Chromium re-tiles a call into boxes and keeps the sidebar chat), with its chat in the stage (or in the sidebar panel: the
       band brings it back): .lw-rband on the stage --
         the stage reaches down to 12 px above the screen's bottom (--lw-rb-h, never under its own min(74vh, 640px)), so the composer is
         on screen without scrolling; the picture is centred, top-anchored and scaled (--lw-rb-vh = the <video>'s height, contain) so
         that LW_RB_LIST px of rows (~6) fit between the lowest tile and the composer; the rows are capped under that tile across the
         whole width (lwCap) and by --lw-rb-lmax (livechat.css), so a row never sits on a tile; never the compact or sidebar chat.
         The Help pill (.lms, liverewards.css: under LIVE / viewers) stays where it is when it clears every tile, else moves into the
         header row between the host's name and LIVE (.lw-lmshdr, --lw-lms-l), else the picture shrinks until it ends left of it.
       The right-hand controls (sound, hide chat, Join) stack 8 px apart in livechat.css. Phones keep the floor (.lw-rfloor).
       Debug: __rovaLiveWatch.roomChat = { mode: 'band', k, h, pic, rows }. */
    /* ROOM CHAT: 5 ROWS (2026-10-16, Rob, seated in @Que Bee's room #2839 on desktop: two rows over a black band, "We need 5 slots in the
       chat!"; then "about 25% taller" on desktop): LW_RB_LIST 270 -> 340 (~8 one-line rows; the picture shrinks to make room, never a row
       on a tile), and a SEATED GUEST of a room (.lrt-incall: liverealtime.js draws the call over the player's own box) gets the band / the
       phone floor too: lwRBIn(room) / lwRoomChatIn() no longer refuse a room's in-call stage. A grid call's in-call stage is unchanged. */
    var LW_RB_LIST = 340;
    function lwRBBase() { var h = window.innerHeight || document.documentElement.clientHeight || 0; return Math.min(h * 0.74, 640); }
    function lwRBWide(sw, W, H) { return (window.innerWidth || 0) >= 900 || sw - W * Math.min(sw / W, lwRBBase() / H) >= 230; }
    function lwRBIn(room) {
      var lc = document.getElementById('livechat');
      return !!(stage && lc && (lc.parentNode === stage || (lc.closest && lc.closest('.lc-aside')))) && (room || !stage.classList.contains('lrt-incall')) && !stage.classList.contains('lbt-on') && !stage.classList.contains('nsfw-gate');
    }
    function lwRBStage() {
      var vh = window.innerHeight || document.documentElement.clientHeight || 0, top = stage.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop || 0);
      var h = Math.max(Math.round(lwRBBase()), Math.floor(vh - top - 12)) + 'px';
      if (stage.__lwRbH !== h) { stage.__lwRbH = h; stage.style.setProperty('--lw-rb-h', h); }
      if (!stage.classList.contains('lw-rband')) stage.classList.add('lw-rband');
    }
    // the <video>'s height, the rows' max height, the floor under the tiles (clipped: the band is plain black), the tiles' middle (Tap for sound)
    function lwRBVideo(h, lmax, cb, mid) {
      var hv = h + 'px', lv = lmax + 'px', cv = cb + 'px', mv = mid + 'px';
      if (stage.__lwRbM !== mv) { stage.__lwRbM = mv; stage.style.setProperty('--lw-rb-mid', mv); }
      if (stage.__lwRbC !== cv) { stage.__lwRbC = cv; stage.style.setProperty('--lw-rb-cb', cv); }
      if (stage.__lwRbV !== hv) { stage.__lwRbV = hv; stage.style.setProperty('--lw-rb-vh', hv); }
      if (stage.__lwRbL !== lv) { stage.__lwRbL = lv; stage.style.setProperty('--lw-rb-lmax', lv); }
    }
    function lwRBOff() {
      if (!stage) return;
      if (stage.classList.contains('lw-rband')) stage.classList.remove('lw-rband');
      if (stage.classList.contains('lw-lmshdr')) stage.classList.remove('lw-lmshdr');
    }
    // the Help pill vs the picture (stage px: the tiles' box l, t, r, b) -> 0 = placed clear of every tile; else the x the picture must end left of
    function lwRBLms(l, t, r, b, sw) {
      var el = stage.querySelector(':scope > .lms'), hdr = stage.classList.contains('lw-lmshdr');
      if (!el || el.hidden || !el.offsetWidth || getComputedStyle(el).display === 'none') { if (hdr) stage.classList.remove('lw-lmshdr'); return 0; }
      if (hdr) stage.classList.remove('lw-lmshdr');
      var sr = stage.getBoundingClientRect(), x0 = sr.left + stage.clientLeft, y0 = sr.top + stage.clientTop, e = el.getBoundingClientRect();
      var L = e.left - x0, R = e.right - x0, T = e.top - y0, B = e.bottom - y0;
      if (!(R > l - 8 && L < r + 8 && B > t - 4 && T < b)) return 0;   // under LIVE / viewers, clear of the picture's people
      var hc = stage.querySelector(':scope > .lw-host'), tl = stage.querySelector(':scope > .lw-tl');
      var gl = hc && hc.offsetWidth ? hc.getBoundingClientRect().right - x0 + 12 : 10, gr = tl && tl.offsetWidth ? tl.getBoundingClientRect().left - x0 - 12 : sw - 10;
      stage.classList.add('lw-lmshdr');
      var w = el.offsetWidth, hh = el.offsetHeight;
      if (gr - gl >= w && 10 + hh <= t + 6) {   // the header row: clear of the seats' numbers (8 px into a tile)
        var lv = Math.round(Math.max(gl, Math.min(gr - w, (sw - w) / 2))) + 'px';
        if (stage.__lwLmsL !== lv) { stage.__lwLmsL = lv; stage.style.setProperty('--lw-lms-l', lv); }
        return 0;
      }
      stage.classList.remove('lw-lmshdr');
      return Math.max(1, Math.floor(L - 8));
    }
    function lwRoomChatIn() {
      var lc = document.getElementById('livechat');
      return !!(stage && lc && lc.parentNode === stage) && !stage.classList.contains('lbt-on') && !stage.classList.contains('nsfw-gate');   // a seated guest too (2026-10-16)
    }
    function lwREmpty(t) { return +t.seat > 0 && !(+t.user_id) && !t.user && !t._hold && !t._noplus && !lwAwP; }
    function lwRoomChat(x, w, want, skip) {
      lwRSkip = skip || 0;
      if (!stage) return;
      var col = x != null, fl = want > 0;
      if (stage.classList.contains('lw-rcol') !== col) stage.classList.toggle('lw-rcol', col);
      if (stage.classList.contains('lw-rfloor') !== fl) stage.classList.toggle('lw-rfloor', fl);
      var tg = fl && !!skip; if (stage.classList.contains('lw-rtight') !== tg) stage.classList.toggle('lw-rtight', tg);   // a short floor: smaller rows
      if (col) {
        var xv = x + 'px', wv = w + 'px';
        if (stage.__lwRcx !== xv) { stage.__lwRcx = xv; stage.style.setProperty('--lw-rcx', xv); }
        if (stage.__lwRcw !== wv) { stage.__lwRcw = wv; stage.style.setProperty('--lw-rcw', wv); }
      }
      if (fl) { var fv = want + 'px'; if (stage.__lwRfw !== fv) { stage.__lwRfw = fv; stage.style.setProperty('--lw-rf-want', fv); } }
      dbg.roomChat = col ? { mode: 'col', x: x, w: w } : fl ? { mode: 'floor', want: want, short: !!skip } : 0;
    }
    /* COMPACT CALL CHAT (2026-10-12, Rob, co-host call #2380: the chat covered the person on the bottom). .lw-callov on the stage while
       the call's people (each tile's VISIBLE rect, screen px; a room's empty seats too) reach the chat's corner: the bottom-left, the
       130 px above the composer (x 10 .. 10 + min(82%, 380), y sh - 192 .. sh - 62), by >= 48 x 16 px. A FIXED corner, never the list's
       own box (the compact list is shorter: no feedback loop). assets/livechat.js then shows the compact chat there (or moves it into the
       desktop sidebar). A layout that leaves that corner clear (2 people side by side above it) keeps the ordinary chat. The browser
       host's own page + an in-call guest: liverealtime.js callOv (.lrt-callov), the same rule. */
    function lwCallOv(trs) {
      var on = false;
      if (trs && trs.length && stage) {
        var sw = stage.clientWidth, sh = stage.clientHeight, L = 10, R = 10 + Math.min(sw * 0.82, 380), B = sh - 62, T = B - 130;
        for (var i = 0; i < trs.length && !on; i++) { var q = trs[i]; on = Math.min(q[2], R) - Math.max(q[0], L) >= 48 && Math.min(q[3], B) - Math.max(q[1], T) >= 16; }
      }
      if (stage && stage.classList.contains('lw-callov') !== on) stage.classList.toggle('lw-callov', on);
      dbg.callOv = on;
    }
    /* THE PILLS CAP THE CHAT (2026-10-05, Rob: "the chat shouldn't go that high so it doesn't overlap it"): while the pills show, the chat
       overlay's top edge stays 8 px below the lowest pill in the chat's COLUMN (the lower-left tile's, just under the grid's divider; 3 / 4
       people too). The room left above the list's bottom edge rides on the stage as --lw-ccap + .lw-ccap; livechat.css caps the list (and
       the pinned bar stacked on it) with it, 250 ms either way; off again with the pills (and wherever .lw-cchips is hidden, in CSS).
       A pill entirely below the list's bottom edge (a landscape grid's bottom row, by the composer) can't be covered by the list: ignored. */
    /* THE CALL BAND (2026-10-13, Rob on Dee's #2657: "we should be side by side so people can see the chat without covering the people"):
       while the picture this player shows is a call laid out as a BAND (a portrait grid whose every tile sits below the frame's top band:
       the server's call band, layout.grid 'band', or side2; never a stacked grid, a room, a landscape frame or a re-tiled wide box), the
       chat, the composer and the notices live UNDER it: every tile's visible bottom edge caps the chat like a pill would (the host's tile
       has no pill, so the pills alone left it open), and .lw-band + --lw-band-b (stage px: the band's visible bottom) move the centred
       notices (Tap for sound, the echo hold, Host is on a phone call) below it (rova.css). Timed like the pills (the tiles this player
       shows now). __rovaLiveWatch.band = the band's bottom (px) or 0. */
    function lwBand(tiles, ox, oy, k, X0, X1, Y0, Y1, H, boxes) {
      var b = 0;
      if (tiles && tiles.length >= 2 && boxes) {
        var ok = true;
        for (var i = 0; i < tiles.length; i++) if (!(+tiles[i].y >= 0.05 * H)) { ok = false; break; }
        if (ok) for (var j = 0; j < tiles.length; j++) {
          var t = tiles[j], x0 = Math.max(X0, ox + t.x * k), x1 = Math.min(X1, ox + (+t.x + +t.w) * k), y0 = Math.max(Y0, oy + t.y * k), y1 = Math.min(Y1, oy + (+t.y + +t.h) * k);
          if (x1 - x0 < 8 || y1 <= y0) continue;
          if (lwRSkip && lwREmpty(t) && +t.y + +t.h >= lwRSkip - 1) continue;   // ROOM CHAT: a "+" seat may sit under the chat
          boxes.push({ l: x0, r: x1, t: y1 - 1, b: y1 }); if (y1 > b) b = y1;
        }
      }
      var on = b > 0;
      if (stage) {
        if (stage.classList.contains('lw-band') !== on) stage.classList.toggle('lw-band', on);
        if (on) { var bv = Math.round(b) + 'px'; if (stage.__lwBandB !== bv) { stage.__lwBandB = bv; stage.style.setProperty('--lw-band-b', bv); } }
        // a notice shown under the band (the echo hold, Tap for sound) caps the chat too: it never sits on the first rows
        if (on) {
          var ns = stage.querySelectorAll(':scope > .lw-echopill:not(.lw-echopill-mini), :scope > .lw-sndpill'), sr = null;
          for (var q = 0; q < ns.length; q++) {
            var ne = ns[q]; if (ne.hidden || !ne.offsetWidth) continue;
            sr = sr || stage.getBoundingClientRect(); var nr = ne.getBoundingClientRect(), dx = sr.left + stage.clientLeft, dy = sr.top + stage.clientTop;
            boxes.push({ l: nr.left - dx, r: nr.right - dx, t: nr.top - dy, b: nr.bottom - dy });
          }
        }
      }
      dbg.band = on ? Math.round(b) : 0;
    }
    function lwCap(boxes) {
      var y = 0, B = 0;
      if (boxes && boxes.length && stage) {
        var sw = stage.clientWidth, sh = stage.clientHeight, L = 10, R = 10 + Math.min(sw * 0.82, 380); B = sh - 62;   // livechat.css .lc-list
        var lc = stage.querySelector('.lc-list');
        if (lc && lc.offsetWidth) {
          var sr = stage.getBoundingClientRect(), lr = lc.getBoundingClientRect(), x0 = sr.left + stage.clientLeft, y0 = sr.top + stage.clientTop;
          L = lr.left - x0; R = lr.right - x0; B = lr.bottom - y0;
        }
        for (var i = 0; i < boxes.length; i++) { var p = boxes[i]; if (p.r > L && p.l < R && p.t < B && p.b + 8 > y) y = p.b + 8; }
      }
      if (y > 0) { var cv = Math.max(0, Math.floor(B - y)) + 'px'; if (stage.__lwCcap !== cv) { stage.__lwCcap = cv; stage.style.setProperty('--lw-ccap', cv); } stage.classList.add('lw-ccap'); }
      else if (stage) stage.classList.remove('lw-ccap');
      dbg.chatCap = y > 0 ? { top: Math.ceil(y), room: Math.max(0, Math.floor(B - y)) } : 0;
    }
    /* FULL SCREEN (landscape only). Element full screen of the STAGE (chat, gifts and pills come along) where the browser
       has it, then a landscape orientation lock on a touch device (Android Chrome honours it in full screen; elsewhere the
       promise rejects quietly). An iPhone has no element full screen: Safari's own video full screen instead (it follows
       the phone's rotation). */
    function fsEl() { return document.fullscreenElement || document.webkitFullscreenElement || null; }
    function fsCan() { return !!(stage && (stage.requestFullscreen || stage.webkitRequestFullscreen)) || !!(v && v.webkitEnterFullscreen); }
    function fsPaint(r) {
      if (!fsBtn) return;
      var wide = (typeof r === 'number' ? r : 0) > 1.2, on = !!fsEl() && fsEl() === stage;
      var show = !done && fsCan() && (wide || on || !!lwB);   // + LAYOUT B: the room's top bar carries it
      fsBtn.hidden = !show;
      stage.classList.toggle('lw-fs-show', show);
      fsBtn.classList.toggle('on', on);
      fsBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
      fsBtn.setAttribute('aria-label', on ? 'Exit full screen' : 'Full screen'); fsBtn.title = on ? 'Exit full screen' : 'Full screen';
      dbg.fs = { show: show, on: on };
    }
    function fsLock() {
      try {
        if (screen.orientation && screen.orientation.lock && window.matchMedia && matchMedia('(pointer:coarse)').matches) {
          var p = screen.orientation.lock('landscape'); if (p && p.catch) p.catch(function () {});
        }
      } catch (e) {}
    }
    function fsToggle() {
      if (fsEl()) { var ex = document.exitFullscreen || document.webkitExitFullscreen; if (ex) { try { var q = ex.call(document); if (q && q.catch) q.catch(function () {}); } catch (e) {} } return; }
      var req = stage.requestFullscreen || stage.webkitRequestFullscreen;
      if (req) {
        var p = null; try { p = req.call(stage, { navigationUI: 'hide' }); } catch (e) { p = null; }
        if (p && p.then) p.then(fsLock, function () { if (v && v.webkitEnterFullscreen) { try { v.webkitEnterFullscreen(); } catch (e) {} } });
        else fsLock();
        return;
      }
      if (v && v.webkitEnterFullscreen) { try { v.webkitEnterFullscreen(); } catch (e) {} }
    }
    function fsChange() {
      var on = fsEl() === stage;
      stage.classList.toggle('lw-fs-on', on);
      if (!on) { try { if (screen.orientation && screen.orientation.unlock) screen.orientation.unlock(); } catch (e) {} }
      lwFit();
    }
    if (fsBtn && stage) {
      fsBtn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); fsToggle(); });
      document.addEventListener('fullscreenchange', fsChange);
      document.addEventListener('webkitfullscreenchange', fsChange);
    }
    /* ---- THE AMBIENT BACKDROP (2026-10-04, Rob: "Can we fill the black with some sort of blurred background matching the
       current landscape stream?") -----------------------------------------------------------------------------------------
       A wide picture is shown whole (contain) inside the unchanged stage box, so a phone shows big black bands above and
       below it. Behind the picture (rova.css .lw-amb, z-index -1 in the isolated stage, under every overlay) we paint a
       blurred, saturated, dimmed, zoomed copy of the SAME stream. Never a second <video> (a second decoder is the expensive
       thing on a phone). THE iOS LOOK (app build 697), value for value:
         sample   48 px on its long edge (48x27 for 16:9), 4 per second (250 ms)
         look     blur 1.6 px AT SAMPLE SIZE, saturation 1.15, 50% black (brightness .5), aspect-fill at 112% behind the video
         motion   300 ms cross-fade between samples; one still under reduced motion / Save-Data; off under the veil and once
                  the stream has ended
       HOW, cheaply: the sample is drawn into a tiny canvas with a 4-px clamped border (edge rows/columns stretched, so the
       blur never pulls in transparency = no dark rim), the CSS filter runs on that tiny canvas, and ONE transform scales it
       up to the 112% fill -- so "1.6 px at sample size" is literal and scales with the stage (about 41 px of screen blur on
       a 390-wide phone stage). Cross-fade = two canvases: the previous sample is copied underneath, the new one fades in on
       top (one 300 ms compositor opacity animation per sample, WAAPI, no style work).
       TWO SOURCES, chosen once per page:
         canvas  drawImage(the playing <video>). A cross-origin native-HLS video taints the canvas: drawing it for DISPLAY is
                 still allowed, we just never read it. Where the canvas is readable (hls.js = a same-origin MediaSource) three
                 spaced probes check it is not black; a canvas that stays black falls back to the stills.
         thumb   the stream's own snapshot (/live/thumb/<id>-<bucket>-<sig>.jpg, lib/livering.php: same origin, edge-cached
                 per 3 s bucket, one origin grab however many watch) drawn into the same canvas every 12 s. The DEFAULT under
                 Safari's native HLS: whether WebKit paints an HLS <video> into a canvas cannot be checked from a tainted
                 canvas (and some versions paint nothing), so Safari never risks a black backdrop. ?amb=canvas|thumb|off on the
                 watch URL overrides the choice (device testing).
       It runs ONLY while it is needed and seen: a wide picture with bands >= 8 px (portrait streams never), the player
       playing, the tab visible, no veil, not ended. Paused / hidden -> no timer (the last sample stays painted). A frozen
       picture (Be right back, a stall) repaints nothing. Measured per tick: __rovaLiveWatch.amb {draws, ms, avg, max ...}. */
    var AMB_LONG = 48, AMB_PAD = 4, AMB_MS = 250, AMB_FADE = 300, AMB_THUMB_MS = 12000, AMB_FILL = 1.12, AMB_PROBE_AT = [3, 10, 25];
    var ambTpl = (stage && stage.getAttribute('data-amb')) || '';
    var ambEvery = Math.max(1, parseInt((stage && stage.getAttribute('data-amb-every')) || '3', 10) || 3);
    var ambSkew = (function () { var n = parseInt((stage && stage.getAttribute('data-amb-now')) || '', 10); return n ? n - Date.now() / 1000 : 0; })();
    var ambStillOnly = false;
    try { ambStillOnly = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) || !!(navigator.connection && navigator.connection.saveData); } catch (e) {}
    var ambQ = /[?&]amb=(canvas|thumb|off)(?:&|#|$)/.exec(location.search || '');
    var ambMode = ambQ ? ambQ[1] : ((/Apple/.test(navigator.vendor || '') && nativeHls) ? 'thumb' : 'canvas');
    if (ambMode === 'thumb' && !ambTpl) ambMode = 'off';
    var amb = null, cvT = null, cvB = null, cxT = null, cxB = null, ambFadeA = null, ambT = null, ambWide = false, ambLastT = -1,
        ambB = -1, ambBusy = false, ambSW = AMB_LONG, ambSH = 27, ambHas = false, ambGeo = '';
    var ambSt = { mode: ambMode, still: ambStillOnly, on: false, running: false, draws: 0, ms: 0, max: 0, avg: 0, same: 0, probes: 0,
                  peak: -1, tainted: false, verified: false, thumbs: 0, thumbFails: 0, fallback: '', sample: '', scale: 0, blurPx: 0 };
    dbg.amb = ambSt;
    function ambRunOK() {
      return !!(amb && cxT && ambWide && ambMode !== 'off' && !done && !veiled && !document.hidden && v && !v.paused && !v.ended && !dbg.ambHold);
    }
    function ambCanvas() {
      var cv = document.createElement('canvas'), cx = null;
      try { cx = cv.getContext('2d', { alpha: false }); } catch (e) { cx = null; }
      return cx ? [cv, cx] : null;
    }
    function ambBuild() {
      amb = document.createElement('div'); amb.className = 'lw-amb'; amb.setAttribute('aria-hidden', 'true');
      var b = ambCanvas(), t = ambCanvas();
      if (!b || !t) { ambMode = ambSt.mode = 'off'; return; }
      cvB = b[0]; cxB = b[1]; cvT = t[0]; cxT = t[1];
      cvT.className = 'lw-amb-top';
      amb.appendChild(cvB); amb.appendChild(cvT);
      stage.insertBefore(amb, stage.firstChild);
    }
    /* The 112% aspect-fill, as ONE transform on each tiny canvas: s = screen px per sample px. Only on a geometry change. */
    function ambLayout(bw, bh, r) {
      if (!amb || !cvT || !(bw > 0 && bh > 0 && r > 0)) return;
      var sw = AMB_LONG, sh = Math.max(1, Math.round(AMB_LONG / r));
      var s = Math.max(bw / sw, bh / sh) * AMB_FILL;
      var x = (bw - sw * s) / 2 - AMB_PAD * s, y = (bh - sh * s) / 2 - AMB_PAD * s;
      var geo = sw + 'x' + sh + '@' + s.toFixed(3) + ':' + x.toFixed(1) + ',' + y.toFixed(1);
      if (geo === ambGeo) return;
      ambGeo = geo;
      if (sw !== ambSW || sh !== ambSH || cvT.width !== sw + 2 * AMB_PAD) {   // a new sample shape: resize (clears) both canvases
        ambSW = sw; ambSH = sh; ambHas = false; ambLastT = -1; ambB = -1;
        [cvT, cvB].forEach(function (c) { c.width = sw + 2 * AMB_PAD; c.height = sh + 2 * AMB_PAD; });
        amb.classList.remove('on');
      }
      var tf = 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px) scale(' + s.toFixed(4) + ')';
      cvT.style.transform = tf; cvB.style.transform = tf;
      ambSt.sample = sw + 'x' + sh; ambSt.scale = +s.toFixed(2); ambSt.blurPx = +(1.6 * s).toFixed(1);
    }
    function ambFallback(why) {
      ambSt.fallback = why;
      ambMode = ambSt.mode = ambTpl ? 'thumb' : 'off';
      ambLastT = -1; ambB = -1;
      if (ambMode === 'off' && amb) { amb.classList.remove('on'); stage.classList.remove('lw-amb-on'); }
    }
    function ambStop() { clearTimeout(ambT); ambT = null; ambSt.running = false; }
    function ambKick(delay) {
      if (ambT || !ambRunOK()) return;
      ambSt.running = true;
      ambT = setTimeout(ambTick, typeof delay === 'number' ? delay : (ambStillOnly ? 1500 : 0));
    }
    function ambTick() {
      ambT = null;
      if (!ambRunOK()) { ambSt.running = false; return; }
      var next = ambMode === 'canvas' ? ambDraw() : (ambMode === 'thumb' ? ambThumb() : 0);
      if (next > 0) ambT = setTimeout(ambTick, next); else ambSt.running = false;
    }
    /* One sample into the TOP canvas (the previous one copied underneath first, so the fade-in never shows black), its border
       clamped (the edge rows/columns stretched into the 4-px pad), then the 300 ms fade-in. Throws only on a refused draw. */
    function ambPaint(src) {
      var p = AMB_PAD, sw = ambSW, sh = ambSH, W = sw + 2 * p, H = sh + 2 * p;
      var fade = ambHas && !ambStillOnly;
      if (fade) cxB.drawImage(cvT, 0, 0);
      cxT.drawImage(src, p, p, sw, sh);
      cxT.drawImage(cvT, p, p, sw, 1, p, 0, sw, p);              // top edge row -> pad
      cxT.drawImage(cvT, p, p + sh - 1, sw, 1, p, p + sh, sw, p);  // bottom
      cxT.drawImage(cvT, p, 0, 1, H, 0, 0, p, H);                  // left column (corners too)
      cxT.drawImage(cvT, p + sw - 1, 0, 1, H, p + sw, 0, p, H);    // right
      if (fade && cvT.animate) {
        if (!ambFadeA) { try { ambFadeA = cvT.animate([{ opacity: 0 }, { opacity: 1 }], { duration: AMB_FADE, easing: 'linear' }); } catch (e) { ambFadeA = null; } }
        else { try { ambFadeA.currentTime = 0; ambFadeA.play(); } catch (e) {} }
      }
      ambHas = true;
      if (!amb.classList.contains('on')) amb.classList.add('on');
    }
    function ambDraw() {
      if (v.readyState < 2 || !v.videoWidth) return 500;            // no frame yet
      var ct = v.currentTime;
      if (ct === ambLastT) { ambSt.same++; return AMB_MS; }          // a frozen picture (Be right back, a stall): nothing new to paint
      var t0 = performance.now();
      try { ambPaint(v); }
      catch (e) { ambFallback('draw:' + ((e && e.name) || 'error')); return ambMode === 'thumb' ? 50 : 0; }
      var dt = performance.now() - t0;
      ambLastT = ct; ambSt.draws++; ambSt.ms += dt; if (dt > ambSt.max) ambSt.max = dt;
      ambSt.avg = +(ambSt.ms / ambSt.draws).toFixed(3);
      if (AMB_PROBE_AT.indexOf(ambSt.draws) >= 0 && !ambSt.verified && !ambSt.tainted) { ambProbe(); if (ambMode !== 'canvas') return 50; }
      return ambStillOnly ? 0 : AMB_MS;
    }
    // Readable canvases only (hls.js / same-origin): is the copy real pixels? A cross-origin tainted canvas throws -> trusted.
    function ambProbe() {
      ambSt.probes++;
      var d;
      try { d = cxT.getImageData(AMB_PAD, AMB_PAD, ambSW, ambSH).data; } catch (e) { ambSt.tainted = true; return; }
      var mx = 0;
      for (var i = 0; i < d.length; i += 4) { var m = Math.max(d[i], d[i + 1], d[i + 2]); if (m > mx) mx = m; }
      ambSt.peak = mx;
      if (mx > 12) { ambSt.verified = true; return; }
      if (ambSt.probes >= AMB_PROBE_AT.length) ambFallback('black');
    }
    function ambThumb() {
      if (ambStillOnly && ambSt.thumbs > 0) return 0;                  // reduced motion / Save-Data: one still, then nothing
      var again = ambStillOnly ? (ambSt.thumbFails < 3 ? 3000 : 0) : AMB_THUMB_MS;
      var b = Math.floor((Date.now() / 1000 + ambSkew) / ambEvery);
      if (ambBusy || b === ambB) return again;
      ambBusy = true;
      var pre = new Image();
      pre.decoding = 'async';
      pre.onload = function () {
        var set = function () {
          ambBusy = false; ambB = b;
          if (!amb || ambMode !== 'thumb' || done || veiled) return;
          var t0 = performance.now();
          try { ambPaint(pre); } catch (e) { ambSt.thumbFails++; return; }
          var dt = performance.now() - t0;
          ambSt.thumbs++; ambSt.draws++; ambSt.ms += dt; if (dt > ambSt.max) ambSt.max = dt; ambSt.avg = +(ambSt.ms / ambSt.draws).toFixed(3);
        };
        if (pre.decode) pre.decode().then(set, set); else set();
      };
      pre.onerror = function () { ambBusy = false; ambB = b; ambSt.thumbFails++; };   // not live yet / ended: the next turn tries again
      pre.src = ambTpl.replace('{b}', String(b));
      return again;
    }
    function ambSync(wide, bw, bh, r) {
      if (!v || !stage) return;
      ambWide = !!wide;
      var want = ambWide && ambMode !== 'off' && !done;
      if (want && !amb) ambBuild();
      want = want && ambMode !== 'off';
      if (amb) stage.classList.toggle('lw-amb-on', want);
      ambSt.on = want;
      if (want) { ambLayout(bw, bh, r); ambKick(); } else ambStop();
    }
    function ambOff() { ambStop(); ambWide = false; ambSt.on = false; if (stage) stage.classList.remove('lw-amb-on'); }
    if (v && stage) {
      v.addEventListener('playing', function () { ambKick(); });
      v.addEventListener('pause', ambStop);
      v.addEventListener('ended', ambStop);
      document.addEventListener('visibilitychange', function () { if (document.hidden) ambStop(); else ambKick(); });
      dbg.ambKick = function () { ambKick(0); };   // the rig's within-page ABAB: set dbg.ambHold, then kick
    }
    if (v && stage) {
      lwFit();
      v.addEventListener('loadedmetadata', lwFit);
      if (lwSide) { try { lwSide.addEventListener('change', lwFit); } catch (e) { try { lwSide.addListener(lwFit); } catch (e2) {} } }   // rotation, no reload
      v.addEventListener('resize', lwFit);
      if (window.ResizeObserver) { try { new ResizeObserver(function () { lwFit(); }).observe(stage); } catch (e) {} }
      else window.addEventListener('resize', lwFit);
    }
    /* ---- SOUND ON ENTRY (2026-10-04, Rob: "When entering a live on web Safari it starts muted") ------------------------
       The player used to be `autoplay muted` and stayed muted until the mute button. Now, like the feed
       (web-sound-default-on-playing-card: rova_sound ABSENT = ON, '0' = the reader pressed mute):
         1. every play() of this player goes through lwPlay(). Sound wanted -> unmute, THEN play(). Chromium allows it
            when the tap that opened this page carried activation across the same-origin navigation; WebKit never does
            on a fresh document (its grant is PER DOCUMENT and /live/{id} is a full navigation), so play() rejects
            NotAllowedError -> sndRefused(): muted play() + the "Tap for sound" pill + the room ARMED.
         2. armed = the FIRST trusted touchend / click / key ANYWHERE on the page (not only the pill) unmutes and calls
            play() INSIDE that gesture (WebKit then lets this element play unmuted for the rest of the page: rejoins,
            re-attaches and the hidden-tab resume). A touchend that ended a scroll is no activation (userActivation
            .isActive false) -> stays armed. The mute button is its own answer (never double-toggled).
         3. rova_sound '0' (or the broadcaster's own room: no echo of yourself) -> muted, no pill, nothing armed. The mute
            button writes the preference ('0' / '1') like the feed's corner speaker; a granted unmute remembers '1'.
         4. the button paints the REAL state (v.muted), plus "not yet audible" while an unmute is still being decided.
       ONE element, never a second one; volumechange from anything else (the hidden-tab governor muting a refused resume,
       Safari's own full-screen controls unmuting) re-syncs the state. dbg.snd on __rovaLiveWatch. */
    var sndPill = null;
    var snd = { state: 'off', tries: 0, refusals: 0, grants: 0, how: '', armed: false, seq: 0 };
    (function () {
      var pref = true; try { pref = localStorage.getItem('rova_sound') !== '0'; } catch (e) {}
      snd.pref = pref;
      if (v && pref && root.getAttribute('data-mine') !== '1') snd.state = 'idle';
      // MY OWN ROOM (2026-10-12, Rob watching his own battle on desktop Safari: "Shouldn't start the battle on mute"): still muted at
      // entry (no echo of my own phone's mic), but never SILENTLY: the "Tap for sound" pill is offered, and only the pill (or the mute
      // button) turns it on -- a stray tap elsewhere doesn't (lwPlay / sndGesture)
      snd.mine = !!(v && pref && root.getAttribute('data-mine') === '1');
    })();
    dbg.snd = snd;
    function sndRemember(on) { try { localStorage.setItem('rova_sound', on ? '1' : '0'); } catch (e) {} }
    /* A GUEST CALL OWNS THE ROOM'S SOUND (assets/liverealtime.js; Rob 10-04, desktop Safari as the web guest on #741: the pill sat
       over the call grid and a tap on it "didn't work"). From Join (the pre-join check, .lrt-pre) through the call (.live-stage
       .lrt-incall) and the leave bridge (video.lrt-bridge) the HLS player is muted + paused ON PURPOSE and the call's real-time audio
       plays. Then nothing here unmutes or plays it, and the pill is hidden (rova.css); after Leave it shows again if still needed.
       An outside mute of an audible player is 'held' (no pill, no play), never read as a refusal. */
    function sndBusy() { return !!(stage && (stage.classList.contains('lfb-on') || stage.classList.contains('lrt-incall') || stage.classList.contains('lrt-gum') || stage.querySelector(':scope > .lrt-pre, :scope > .lrt-bridge'))); }
    function sndPaint() {
      if (!muteBtn || !v) return;
      var lfb = stage && stage.classList.contains('lfb-on') && window.__rovaLfb;   // GROUP LIVE FALLBACK (2026-10-15): the guests' live sound
      var off = lfb ? !window.__rovaLfb.soundOn() : (v.muted || snd.state === 'trying');
      dbg.muted = v.muted;
      muteBtn.classList.toggle('on', !off);
      muteBtn.setAttribute('aria-pressed', off ? 'false' : 'true');
      muteBtn.setAttribute('aria-label', off ? 'Unmute' : 'Mute'); muteBtn.title = off ? 'Unmute' : 'Mute';
    }
    function sndPillShow(on) {
      if (on && !sndPill && stage && !done) {
        sndPill = document.createElement('button');
        sndPill.type = 'button'; sndPill.className = 'lw-sndpill'; sndPill.id = 'lw-sndpill';
        sndPill.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><line x1="23" y1="9" x2="17" y2="15"/><line x1="17" y1="9" x2="23" y2="15"/></svg><span>Tap for sound</span>';
        // ITS OWN CLICK = the mute button's unmute (2026-10-16): never only the armed document tap (sndGesture), so a layer or a
        // class on the stage can't swallow it. sndGesture may already have unmuted in this tap's capture phase: then just hide.
        sndPill.addEventListener('click', function (e) {
          if (e) e.stopPropagation();
          if (!v || done) { sndPillShow(false); return; }
          if (sndBusy()) { sndPaint(); return; }
          if (v.muted || snd.state === 'refused') sndUnmute('pill');
          sndRemember(true); sndPillShow(false);   // remembered like the mute button's unmute; a second refusal (sndRefused) brings the pill back
        });
        stage.appendChild(sndPill);
      } else if (!on && sndPill) { sndPill.remove(); sndPill = null; }
      dbg.sndPill = !!sndPill;
    }
    var SND_EV = ['touchend', 'click', 'keydown'];
    function sndArm(on) {
      if (on === snd.armed) return;
      snd.armed = on;
      SND_EV.forEach(function (t) { if (on) document.addEventListener(t, sndGesture, true); else document.removeEventListener(t, sndGesture, true); });
    }
    function sndGranted(how) {
      snd.state = 'on'; snd.grants++; if (how) snd.how = how;
      sndArm(false); sndPillShow(false); sndRemember(true); sndPaint();
    }
    function sndRefused() {
      snd.state = 'refused'; snd.refusals++;
      if (!v.muted) v.muted = true;
      if (v.paused && !done && !sndBusy()) { var q = v.play(); if (q && q.catch) q.catch(function () {}); }   // muted autoplay is always allowed
      if (!done) { sndArm(true); sndPillShow(true); }
      sndPaint();
    }
    // the outcome of one play() that asked for sound; only the NEWEST attempt decides
    function sndOutcome(p, how) {
      var my = ++snd.seq;
      if (!p || !p.then) { if (!v.muted && !v.paused) sndGranted(how); return; }
      p.then(function () {
        if (my !== snd.seq) return;
        if (!v.muted && (snd.state === 'trying' || snd.state === 'refused')) { sndGranted(how); return; }
        if (v.muted && snd.state === 'trying') snd.state = 'held';   // muted again by someone else before it started (a call)
        sndPaint();
      }, function (err) {
        if (my !== snd.seq) return;
        if (err && err.name === 'NotAllowedError') { if (!v.muted || snd.state === 'trying') sndRefused(); return; }
        if (snd.state === 'trying') snd.state = v.muted ? 'refused' : 'on';   // AbortError (a load() cut in): no verdict
        sndPaint();
      });
    }
    function lwPlay() {
      if (!v) return;
      if (snd.mine && snd.state === 'off' && !done && !sndBusy()) { sndRefused(); return; }   // MY OWN ROOM: muted + the pill (see snd.mine)
      if (stage && stage.classList.contains('mature-gate') && !done && !sndBusy()) { sndRefused(); return; }   // MATURE LIVES (db/0294): silent until "Tap to view"
      var ask = (snd.state === 'idle' || snd.state === 'on') && !done && !sndBusy();
      if (ask) { if (snd.state === 'idle') { snd.state = 'trying'; snd.tries++; } if (v.muted) v.muted = false; }
      var p; try { p = v.play(); } catch (e) { p = null; }
      if (ask) sndOutcome(p, 'load'); else if (p && p.catch) p.catch(function () {});
    }
    // inside a gesture: unmute + play() in the same turn
    function sndUnmute(how) {
      snd.state = 'trying'; snd.tries++;
      v.muted = false;
      var p; try { p = v.play(); } catch (e) { p = null; }
      sndOutcome(p, how);
      sndPaint();
    }
    function sndGesture(e) {
      if (!v || snd.state !== 'refused') return;
      if (done) { sndArm(false); sndPillShow(false); return; }
      if (e && e.isTrusted === false) return;
      var t = e && e.target, c = t && t.closest ? t : null;
      if (c && c.closest('#lw-mute')) return;   // the button toggles on its own click
      // a guest call (or its Ask / Join controls) owns the sound. NOT the stage itself (2026-10-16, Rob on an Open Room: "Tap for sound"
      // did nothing): liverealtime.js puts lrt-room / lrt-room-can / lrt-band on the STAGE, so every tap inside it -- the pill too -- matched
      var lrtC = c && c.closest('[class*="lrt-"]');
      if (sndBusy() || (lrtC && lrtC !== stage && !lrtC.contains(stage))) return;
      if (snd.mine && !(c && c.closest('#lw-sndpill'))) return;   // MY OWN ROOM: only the pill turns my sound on
      if (e.type === 'keydown' && (e.key === 'Tab' || e.key === 'Escape' || e.key === 'Shift' || e.metaKey || e.ctrlKey || e.altKey)) return;
      if (veiled && !(c && c.closest('.js-nsfw-reveal'))) return;   // not under the sensitive-content veil (Show anyway counts)
      if (stage && stage.classList.contains('mature-gate')) return;   // MATURE LIVES (db/0294): the "Tap to view" tap lifts the gate first (capture), then counts
      try { if (navigator.userActivation && !navigator.userActivation.isActive) return; } catch (x) {}
      sndUnmute(c && c.closest('#lw-sndpill') ? 'pill' : e.type);
    }
    if (v) {
      v.addEventListener('volumechange', function () {
        if (v.muted && snd.state === 'on') { snd.state = 'held'; sndPaint(); return; }   // muted by someone else (a guest call): no pill, no play
        if (!v.muted && snd.state === 'echo' && echo.on && !echo.userOk) { echo.userOk = true; echo.how = 'native'; echoPillShow(false); sndGranted('echo-native'); return; }   // ECHO: the browser's own controls = their choice
        if (!v.muted && (snd.state === 'refused' || snd.state === 'held') && !v.paused && !sndBusy()) { sndGranted('restored'); return; }   // Safari's own controls / the call's Leave
        sndPaint();
      });
      v.addEventListener('playing', function () {
        if (!v.muted && (snd.state === 'refused' || snd.state === 'held') && !sndBusy()) sndGranted('restored');   // the call's Leave plays it unmuted
      });
    }
    if (v && muteBtn) {
      muteBtn.addEventListener('click', function () {
        if (stage && stage.classList.contains('lfb-on') && window.__rovaLfb) { window.__rovaLfb.toggleSound(); sndPaint(); return; }   // GROUP LIVE FALLBACK (2026-10-15): the guests' live sound
        if (sndBusy()) { sndPaint(); return; }   // in a guest call the call's audio plays; the HLS stays muted
        if (echo.on && !echo.userOk) { echoUserOk('button'); sndRemember(true); return; }   // ECHO: unmuting here is their own choice
        if (v.muted || snd.state === 'trying') { sndUnmute('button'); sndRemember(true); return; }
        snd.seq++; snd.state = 'off'; v.muted = true;
        sndArm(false); sndPillShow(false); sndRemember(false); sndPaint();
      });
      sndPaint();
    }
    if (v && !muteBtn && snd.state === 'idle') snd.state = 'off';   // no control to show the state with: stay as before
    /* ---- YOU'RE IN THIS CALL (2026-10-12, the echo Dee heard) ------------------------------------------------------------
       Dee (host) heard his guest Rob twice, seconds apart: while Rob sat in the call from his phone, his Mac tab (this page), his
       Apple TV and his phone's own player were PLAYING Dee's live with sound. The broadcast carries the guest's voice, so the guest's
       mic picked up the ~15 s-late HLS and sent it back. The server now says so: stream.me_in_call (page: data-in-call="1") = this
       signed-in person is a JOINED member of the call this live carries (any device; never its own host). While it is true a page that
       is NOT the call client itself (sndBusy(): the guest stage on THIS page owns its sound and is left alone) holds this player MUTED
       and shows "You're in this call. Muted here to stop echo." Tapping the pill (or the mute button, or the browser's own controls)
       unmutes, as the person's own choice, for the rest of that hold. When a poll says they left, sound comes back only if it was on
       before the hold (a refused unmute -> the usual "Tap for sound"). Never writes rova_sound (a hold is not a preference).
       dbg.echo on __rovaLiveWatch. */
    var echo = { on: false, wasOn: false, prev: '', userOk: false, holds: 0, releases: 0, how: '' }, echoPill = null;
    dbg.echo = echo;
    function echoPillShow(on) {
      if (on && !echoPill && stage && !done) {
        echoPill = document.createElement('button');
        echoPill.type = 'button'; echoPill.className = 'lw-echopill'; echoPill.id = 'lw-echopill';
        echoPill.setAttribute('aria-label', 'Muted to stop echo: you\u2019re in this live on another device. Tap to unmute.');
        echoPill.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><line x1="23" y1="9" x2="17" y2="15"/><line x1="17" y1="9" x2="23" y2="15"/></svg><span>Muted to stop echo: you\u2019re in this live on another device.</span>';
        echoPill.addEventListener('click', function (e) { if (e) e.stopPropagation(); echoUserOk('pill'); });
        stage.appendChild(echoPill);
        var ep = echoPill; setTimeout(function () { if (ep === echoPill && ep.parentNode) { ep.classList.add('lw-echopill-mini'); try { lwChips(); } catch (e) {} } }, 8000);
      } else if (!on && echoPill) { echoPill.remove(); echoPill = null; }
      dbg.echoPill = !!echoPill;
    }
    function echoHold() {
      if (!v || echo.on || done) return;
      echo.on = true; echo.userOk = false; echo.holds++; echo.how = '';
      echo.wasOn = !v.muted || snd.state === 'idle' || snd.state === 'trying' || snd.state === 'on';
      echo.prev = snd.state;
      snd.seq++; snd.state = 'echo';   // neither 'on' nor 'refused': lwPlay plays muted, sndGesture stays out, volumechange only paints
      sndArm(false); sndPillShow(false);
      if (!v.muted) v.muted = true;
      echoPillShow(true); sndPaint();
    }
    // the person's own choice: sound on while in the call (a tap = a gesture, so WebKit lets it play unmuted)
    function echoUserOk(how) {
      if (!echo.on || echo.userOk) return;
      echo.userOk = true; echo.how = how; echoPillShow(false);
      if (v && !done && v.muted) sndUnmute('echo-' + how); else sndPaint();
    }
    // restore = they LEFT the call (else this page became the call client: the call owns the sound now, as on any guest page)
    function echoRelease(restore) {
      if (!echo.on) return;
      echo.on = false; echo.releases++; echoPillShow(false);
      if (echo.userOk) { echo.userOk = false; return; }   // they chose sound during the call: leave it as it is
      if (!v || done || snd.state !== 'echo') return;
      if (!restore) { snd.state = echo.wasOn ? 'held' : (echo.prev || 'off'); sndPaint(); return; }
      if (echo.wasOn) { sndUnmute('echo-restore'); return; }   // no gesture: a refusal -> sndRefused (muted + "Tap for sound")
      if (echo.prev === 'refused') { sndRefused(); return; }
      snd.state = echo.prev || 'off'; sndPaint();
    }
    function echoPoll(inCall) {
      dbg.meInCall = inCall;
      if (inCall && !sndBusy()) echoHold();
      else if (echo.on) echoRelease(!inCall);
    }
    if (v && root.getAttribute('data-in-call') === '1' && !sndBusy()) echoHold();   // the page's own data: muted before the first play()
    if (v && !guestHold) startWatching();   // THE GUEST MINUTE: a held guest page starts on its first poll's word (guestHold above)
    dbg.guestHold = guestHold;
    function fmt(s) { var h = Math.floor(s / 3600), m = Math.floor(s % 3600 / 60), x = s % 60; return (h ? h + ':' + (m < 10 ? '0' : '') : '') + m + ':' + (x < 10 ? '0' : '') + x; }
    // The clock is STATELESS -- it is a pure function of startedAt and the wall clock -- so a hidden
    // tab can simply skip it and one call on the way back restores the right number. (Same argument
    // as every other paint gated on `hidden` in this file; it is only here because it was missed.)
    // NO ELAPSED CLOCK FOR VIEWERS (2026-10-12, Rob: "Don't show the live time"): views/live_watch.php draws #lw-elapsed for the
    // broadcaster only, so a viewer has no elapsedEl -- but staff still get #lw-left ("Ends in"), so the countdown ticks without it.
    function tick() { if ((!elapsedEl && !leftEl) || !startedAt || document.hidden) return; if (elapsedEl) { elapsedEl.hidden = false; elapsedEl.textContent = fmt(Math.max(0, Math.floor((Date.now() - startedAt) / 1000))); } paintLeft(); }
    // "Ends in 9:59" -- only in the last 10 minutes before the cap, only where ends_at was given (the broadcaster)
    function paintLeft() {
      if (!leftEl) return;
      var left = endsAt ? Math.floor((endsAt - Date.now()) / 1000) : -1;
      if (done || left < 0 || left > 600) { leftEl.hidden = true; return; }
      leftEl.hidden = false; leftEl.textContent = 'Ends in ' + fmt(left);
      leftEl.classList.toggle('lw-left-last', left <= 60);
      dbg.timeLeft = left;
    }
    if ((elapsedEl || leftEl) && startedAt) { tick(); tickT = setInterval(tick, 1000); }
    function revealed() { return /(^|; )rova_adult_ok=/.test(document.cookie); }
    if (stage) stage.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.js-nsfw-reveal')) { veiled = false; dbg.veiled = false; setTimeout(function () { ambKick(); }, 0); } });
    /* GUESTS WATCH (2026-10-13): the guest's lock (see GUEST above). Explicit -> the locked card in place; any other "not for a guest any
       more" while still on air (the switch went off...) -> the gate page (?gate=1: its own edge-cache key). Never for an ended live (the
       end card handles it). The chat keeps reading (it is text; its own poll stops if the server refuses it). */
    function guestLock(explicit) {
      if (guestLocked) return;
      guestLocked = true; dbg.guestLocked = explicit ? 'nsfw' : 'gate';
      if (!explicit) { window.location.replace('/live/' + id + '?gate=1'); return; }
      done = true; veiled = true; dbg.veiled = true;
      clearInterval(pollT); clearInterval(healthT); clearTimeout(retryT); clearTimeout(watchT); hideWaiting();
      try { if (hls) { hls.destroy(); } } catch (e) {}
      hls = null;
      if (v) { try { v.pause(); v.removeAttribute('src'); v.load(); } catch (e) {} if (v.parentNode) v.parentNode.removeChild(v); }   // detached, never nulled: other timers still read it
      try { ambOff(); } catch (e) {}
      if (!stage) return;
      stage.classList.add('nsfw-gate', 'nsfw-locked');
      var d = document.createElement('div'); d.className = 'nsfw-veil nsfw-veil-locked'; d.setAttribute('role', 'group'); d.setAttribute('aria-label', 'Sensitive content, hidden');
      d.innerHTML = '<span class="nsfw-veil-ic">' + EYE + '</span><strong>Sensitive content</strong><span class="nsfw-veil-sub">Sign up or log in to view</span>' +
        '<a class="nsfw-veil-btn" href="/signup" data-live-next="/live/' + id + '">Sign up</a>';
      stage.appendChild(d);
    }
    /* THE GUEST MINUTE (see guestEnd above). guestLeft(n): the poll's guest_watch_left_s re-bases the local countdown (server truth;
       null = no limit). guestChipPaint: the chip, last 15 s only; at a local 0 it asks the server once at once (the next poll would
       anyway). guestDoor: the auth modal through the site's own delegate (a hidden data-auth-open link, livechat.js guestAsk's way). */
    function guestDoor(kind) {
      var a = document.createElement('a');
      a.href = kind === 'login' ? '/login' : '/signup'; a.hidden = true;
      a.setAttribute('data-auth-open', kind === 'login' ? 'login' : 'signup');
      if (kind !== 'login') a.setAttribute('data-auth-ctx', 'Sign up free to keep watching');
      a.setAttribute('data-live-next', '/live/' + id);
      document.body.appendChild(a);
      try { a.click(); } finally { a.remove(); }
    }
    function guestLeft(n) {
      dbg.guestLeft = n;
      guestEnd = typeof n === 'number' ? Date.now() + Math.max(0, n) * 1000 : 0;
      if (n === null || n > 15) guestZeroAsked = false;
      guestChipPaint();
      if (guestEnd && n <= 20 && !guestChipT) guestChipT = setInterval(guestChipPaint, 1000);
    }
    function guestChipPaint() {
      var left = guestEnd ? Math.max(0, Math.ceil((guestEnd - Date.now()) / 1000)) : -1;
      if (done || guestLocked || left < 0 || left > 15) {
        if (guestChip) guestChip.hidden = true;
        if (guestChipT && (done || guestLocked || left < 0 || left > 20)) { clearInterval(guestChipT); guestChipT = null; }
        return;
      }
      if (!guestChip && stage) {
        guestChip = document.createElement('button'); guestChip.type = 'button'; guestChip.className = 'lw-gtu-chip';
        guestChip.setAttribute('role', 'timer'); guestChip.setAttribute('aria-live', 'off');
        guestChip.innerHTML = '<span>Sign up to keep watching</span><span aria-hidden="true">·</span><b></b>';
        guestChip.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); guestDoor('signup'); });
        stage.appendChild(guestChip);
      }
      if (!guestChip) return;
      guestChip.hidden = false;
      guestChip.querySelector('b').textContent = fmt(left);
      dbg.guestChip = left;
      if (left === 0 && !guestZeroAsked) { guestZeroAsked = true; poll(); }
    }
    function guestTimeUp(s, resetS) {
      if (guestLocked) return;
      guestLocked = true; guestHold = false; dbg.guestLocked = 'time_up'; dbg.guestHold = false; dbg.playing = false;
      var back = Math.max(60, Math.min(86400, +resetS || 3600));
      try { localStorage.setItem('rova_gtu', String(Date.now() + back * 1000)); } catch (e) {}
      done = true;
      clearInterval(pollT); clearInterval(healthT); clearTimeout(retryT); clearTimeout(watchT); hideWaiting();
      if (guestChipT) { clearInterval(guestChipT); guestChipT = null; }
      if (guestChip) guestChip.hidden = true;
      try { if (hls) { hls.destroy(); } } catch (e) {}
      hls = null;
      if (v) { try { v.pause(); v.removeAttribute('src'); v.load(); } catch (e) {} if (v.parentNode) v.parentNode.removeChild(v); }   // detached, never nulled: other timers still read it
      try { ambOff(); } catch (e) {}
      if (!stage) return;
      stage.classList.add('lw-gtu-on');
      var d = document.createElement('div'); d.className = 'lw-gtu'; d.setAttribute('role', 'group'); d.setAttribute('aria-labelledby', 'lw-gtu-h');
      d.innerHTML = '<div class="lw-gtu-bg" aria-hidden="true"></div><div class="lw-gtu-card">' +
        '<span class="lw-gtu-ic" aria-hidden="true"><svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 10.5l5-3v9l-5-3"/><rect x="3" y="6.5" width="12" height="11" rx="2.5"/></svg></span>' +
        '<strong id="lw-gtu-h">Enjoying the live?</strong><span class="lw-gtu-sub">Sign up free to keep watching.</span>' +
        '<div class="lw-gtu-acts"><a class="btn primary" href="/signup" data-auth-open="signup" data-auth-ctx="Sign up free to keep watching" data-live-next="/live/' + id + '">Sign up</a>' +
        '<a class="btn gold-ghost" href="/login" data-auth-open="login" data-live-next="/live/' + id + '">Log in</a></div></div>';
      var th = s && s.thumb && s.thumb.url;   // the live's own still (snapshots only), blurred behind the card
      if (th && /^https?:\/\/[^"'()\s]+$/.test(th)) d.firstChild.style.backgroundImage = 'url("' + th + '")';
      stage.appendChild(d);
      try { document.dispatchEvent(new CustomEvent('rova:live-guest-time-up', { detail: { id: id } })); } catch (e) {}
      var first = d.querySelector('.btn.primary');
      if (first && !document.hidden) setTimeout(function () { try { first.focus({ preventScroll: true }); } catch (e) {} }, 60);
    }
    function veilNow() {
      if (GUEST) { guestLock(true); return; }   // GUESTS WATCH: a guest is locked out, never offered "Show anyway"
      if (veiled || !stage || revealed()) return;
      veiled = true; dbg.veiled = true; stage.classList.add('nsfw-gate');
      var d = document.createElement('div'); d.className = 'nsfw-veil'; d.setAttribute('role', 'group'); d.setAttribute('aria-label', 'Sensitive content, hidden');
      d.innerHTML = '<span class="nsfw-veil-ic">' + EYE + '</span><strong>Sensitive content</strong><span class="nsfw-veil-sub">Hidden by your nudity filter</span><button type="button" class="nsfw-veil-btn js-nsfw-reveal">Show anyway</button>';
      stage.appendChild(d);
    }
    function unveil() {
      if (!veiled || !stage) return;
      veiled = false; dbg.veiled = false; stage.classList.remove('nsfw-gate');
      var d = stage.querySelector('.nsfw-veil'); if (d) d.remove();
      ambKick();
    }
    /* ---- LET THE LAST SECONDS PLAY (2026-10-05, Rob: "I said 'peace out stream' then clicked End stream, but the viewers didn't
       see that, since they're probably delayed... make sure it's in sync so they hear it") ------------------------------------
       A viewer's HLS runs 5-20 s behind the broadcaster and the poll learns `ended` within ~5 s of the End tap, so swapping the
       player for the end card at once cut off the host's last seconds. THE RULE (API.md "Ending a live: let the last seconds
       play"; the app and the TV do the same): when status becomes `ended`, keep playing until the media ends, then show the card.
       The FIRST of:
         ended   the <video> 'ended' event (hls.js reached an #EXT-X-ENDLIST; Cloudflare's live playlist normally never gets one)
         stall   playback has not advanced for > 2 s and no new segment arrived (the playlist froze / went 204 after the stop and
                 the player ran out of media: the usual way it finishes)
         wall    the picture reached the broadcast's end: stream.ended_ms_ago (server clock, re-based on this poll's arrival) vs
                 this player's measured latency (lwLatency): now - latency >= the end + 2 s (PDT: the whole-second ended_at + ingest skew) / + 3 s (edge estimate)
                 -- for a playlist that keeps growing after the end; only on a MEASURED latency (pdt / edge), never the 15 s guess
         cap     measured latency + 5 s after we learned (seekable end - currentTime + ~4 s when lwLatency has nothing), max 30 s
         error   the player errored (a native-HLS reload of a dead playlist)
       While draining (.is-ending): picture + sound + chat carry on, the clock stops, the LIVE badge reads "Live ended" in grey,
       the gift buttons go, "Be right back" never shows, nothing re-joins / reloads, the poll stops. `rova:live-ending` fires at
       the start, `rova:live-ended` (chat, gifts, calls, the end card) only at the end.
       The card at ONCE (no drain): killed (moderation), a 404, the broadcaster's own page, the Gift Lab, a hidden tab, a guest in
       a call (their HLS is paused), a player that was not playing. window.__rovaNoDrain = true turns it off (rigs). dbg.drain. */
    function endOrDrain(msg, replayId, s) {
      if (done || draining) return;
      var can = !!(v && s && s.status === 'ended' && !s.is_mine && root.getAttribute('data-mine') !== '1' && root.getAttribute('data-lab') !== '1'
                   && playbackStarted && !v.paused && !v.ended && v.readyState >= 2 && !document.hidden && !sndBusy() && !window.__rovaNoDrain);
      if (!can) { ended(msg, replayId, s); return; }
      var now = Date.now(), lat = lwLatency(), src = (dbg.latency && dbg.latency.src) || '';
      if (!lat) {
        var ed = 0; try { var sk = v.seekable; if (sk && sk.length) ed = sk.end(sk.length - 1); } catch (e) {}
        if (ed > v.currentTime) { lat = (ed - v.currentTime) * 1000 + 4000; src = 'edge'; }
      }
      if (!(lat > 0)) { lat = 15000; src = 'default'; }
      var cap = Math.round(Math.min(30000, lat + 5000)), ago = typeof s.ended_ms_ago === 'number' ? s.ended_ms_ago : null;
      draining = true;
      drain = { msg: msg, replayId: replayId, s: s, at: now, cap: cap, src: src, endAt: ago !== null ? now - ago : 0,
                ct: v.currentTime, ctAt: now, sn: edgeSN, snAt: now };
      dbg.drain = { on: true, latency: Math.round(lat), src: src, cap: cap, endedMsAgo: ago, why: '', ms: 0, endlist: false };
      clearInterval(pollT); clearInterval(tickT); clearInterval(healthT); clearTimeout(retryT); clearTimeout(watchT);
      hideWaiting(); localWhy = ''; paintBrb();
      root.classList.add('is-ending');
      var bd = document.getElementById('lw-badge'); if (bd) { bd.hidden = false; bd.textContent = 'Live ended'; }
      if (leftEl) leftEl.hidden = true;
      try { document.dispatchEvent(new CustomEvent('rova:live-ending', { detail: { id: id, stream: s, cap_ms: cap } })); } catch (e) {}
      drainT = setInterval(drainCheck, 250);
      drainCheck();
    }
    function drainCheck() {
      var d = drain; if (!draining || !d || !v) return;
      var now = Date.now(), ct = v.currentTime;
      if (ct > d.ct + 0.04) { d.ct = ct; d.ctAt = now; }
      if (edgeSN !== d.sn) { d.sn = edgeSN; d.snAt = now; }   // the playlist still grew: give the new segment a chance
      if (v.ended) { drainDone('ended'); return; }
      if (now - Math.max(d.ctAt, d.snAt) > 2000) { drainDone('stall'); return; }
      var L = d.endAt ? (lwLatency() || (d.src !== 'default' ? dbg.drain.latency : 0)) : 0;   // never on a GUESSED latency
      if (L) {
        var pdt = dbg.latency && dbg.latency.src === 'pdt';
        dbg.drain.shownBehindEnd = Math.round(d.endAt - (now - L));
        if (now - L >= d.endAt + (pdt ? 2000 : 3000)) { drainDone('wall'); return; }
      }
      if (now - d.at >= d.cap) { drainDone('cap'); return; }
    }
    function drainDone(why) {
      var d = drain; if (!draining || !d) return;
      clearInterval(drainT); drainT = null; draining = false; drain = null;
      dbg.drain.on = false; dbg.drain.why = why; dbg.drain.ms = Date.now() - d.at;
      ended(d.msg, d.replayId, d.s);
    }
    // `s` (2026-10-01, the Gift Lab room + the end card): the stream body that ended it, when there is one (the poll or
    // the End answer). It rides on `rova:live-ended` so assets/livechat.js can draw the broadcaster's END CARD (stats).
    function ended(msg, replayId, s) {
      if (done) return;
      if (draining) { clearInterval(drainT); drainT = null; draining = false; drain = null; if (dbg.drain) { dbg.drain.on = false; dbg.drain.why = dbg.drain.why || 'cut'; } }
      root.classList.remove('is-ending');
      done = true; dbg.ended = true; dbg.endedMsg = msg;
      clearInterval(pollT); clearInterval(tickT); clearInterval(healthT);
      clearTimeout(retryT); clearTimeout(watchT); hideWaiting(); paintBrb();
      ambOff();    // the ambient backdrop goes with the stream (the iOS rule: off once it has ended)
      if (v) { try { v.pause(); } catch (e) {} }
      root.classList.add('is-ended');
      /* 2026-10-04 (Rob): the kicker row above the card is GONE (views/live_watch.php), so there is no "Your last live" / "This stream
         has ended" swap any more. The footer avatar's LIVE ring goes with .is-ended (rova.css). */
      if (fsBtn) fsBtn.hidden = true;   // db/0229: no full screen for an ended stream (the end card stays in the stage if already full screen)
      if (endedMsg) endedMsg.textContent = msg;
      if (replayA) { if (replayId) { replayA.href = '/p/' + replayId; replayA.hidden = false; } else { replayA.hidden = true; } }
      // ONE END STATE (2026-10-03): no replay to open yet but one is on its way -> say so in the same box (never a second block).
      // stream.replay (publish) reaches the broadcaster/staff only; for everyone else a pending recording reads as "on its way".
      var rec = s && s.recording, rp = s && s.replay;
      if (endedSub) endedSub.hidden = !(!replayId && s && s.status !== 'killed' && rec && (rec.state === 'pending' || rec.state === 'importing')
                                        && !(rp && rp.publish === false && !s.is_mine) && root.getAttribute('data-lab') !== '1');
      if (endedBox) endedBox.hidden = false;
      if (reportBtn) reportBtn.hidden = true;
      if (endBtn) endBtn.hidden = true;
      if (visBtn) visBtn.hidden = true;   // db/0247
      if (leftEl) leftEl.hidden = true;
      // LIVE GIFTING (gifts.js, testers only): the tray closes and its own poll stops with the stream.
      try { document.dispatchEvent(new CustomEvent('rova:live-ended', { detail: { id: id, stream: s || null } })); } catch (e) {}
      // AUTO-RETURN: back to the live list in a few seconds, unless the reader touches anything. Never for the
      // broadcaster reading their end card, and never in the Gift Lab room (its page is the lab, not /live).
      if (root.getAttribute('data-lab') === '1' || (s && s.is_mine)) { dbg.noReturn = true; return; }
      var n = 6, cancelled = false;
      var cancel = function () { cancelled = true; if (countEl) countEl.textContent = ''; };
      document.addEventListener('pointerdown', cancel, { once: true, capture: true });
      document.addEventListener('keydown', cancel, { once: true, capture: true });
      if (countEl) countEl.textContent = 'Returning to Live in ' + n + 's';
      var cd = setInterval(function () {
        if (cancelled) { clearInterval(cd); return; }
        n--; if (countEl) countEl.textContent = 'Returning to Live in ' + n + 's';
        if (n <= 0) { clearInterval(cd); window.location.href = '/live'; }
      }, 1000);
    }
    // LIVE GIFTING LATE MOUNT (2026-10-01, testers only): a page opened while the stream was 'created' carries
    // data-gift-ready="1" and gifts.js but no tray. Until gifts.js has mounted #gstage, the poll asks for the
    // payload (`gifting=1`); handle_live_watch answers it only once the stream is live and the gates pass. At most
    // 3 answered asks, so a gifts.js that never mounts cannot make every poll build the catalog forever.
    var giftAsks = 0;
    function wantGifts() { return giftAsks < 3 && root.getAttribute('data-gift-ready') === '1' && !document.getElementById('gstage'); }
    /* CALLS THAT OPEN MID-WATCH (2026-10-06): the server loads assets/liverealtime.js only when the host was ALREADY taking guests at
       page load (LiveRealtime::pageMode). A viewer of a live whose host COULD start taking guests gets #lrt-late instead (the client's
       #lrt-data + its asset URLs; LiveRealtime::lateViewer). This poll then asks `lrt=1` and its `lrt` (LiveRealtime::openState:
       0 no call, 1 a call, 2 the host takes guests; one Redis GET) loads the client on the first 2. A loaded viewer client hears every
       change through rova:live-poll (detail.lrt) and re-reads /rt at once, so "Ask to join" shows / hides within a poll. */
    var lrtLoaded = false;
    function lrtAsk() { return !!window.RTCPeerConnection && (!!document.getElementById('lrt-late') || !!(window.__rovaRT && window.__rovaRT.mode === 'viewer')); }
    function lrtLoad(n) {
      var lrtLate = document.getElementById('lrt-late');
      if (n !== 2 || !lrtLate || lrtLoaded || window.__rovaRT || document.getElementById('lrt-data')) return;
      var L = null; try { L = JSON.parse(lrtLate.textContent || 'null'); } catch (e) {}
      if (!L || !L.data || !L.js) return;
      lrtLoaded = true; dbg.lrtLoaded = Date.now();
      var d = document.createElement('script'); d.type = 'application/json'; d.id = 'lrt-data'; d.textContent = JSON.stringify(L.data);
      document.body.appendChild(d);
      var go = function () { if (go.ran) return; go.ran = 1; var sc = document.createElement('script'); sc.src = L.js; sc.async = true; document.body.appendChild(sc); };
      if (L.css) { var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = L.css; l.onload = l.onerror = go; document.head.appendChild(l); setTimeout(go, 3000); }
      else go();
    }
    function poll(force) {   // force (signed links renewal): ask even while hidden + silent; returns the request's promise
      if (done || draining) return Promise.resolve();
      if (!force && !lwCounts()) { dbg.skippedHidden++; return Promise.resolve(); }   // hidden AND silent: stop claiming a seat
      return rfetch('/live/' + id + '?ajax=1' + (echo.on && !echo.userOk ? '&echo_held=1' : '') + (wantGifts() ? '&gifting=1' : '') + (lrtAsk() ? '&lrt=1' : '') + (guestId ? '&gv=' + guestId : ''), { credentials: 'same-origin', headers: { 'Accept': 'application/json' } }, 8000)
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var s = j && j.stream; if (!s) return;
          try { lwCfPlayback(s); } catch (e) {}   // SIGNED LINKS (2026-10-15): the fresh token rides every poll
          /* SERVER-DRIVEN HEARTBEAT (capacity lane 2, 2026-10-15): stream.poll_ms is the cadence this room wants (5 s under
             300 viewers, longer in a big room; Live::hbPollMs). Re-arm the interval only when it changes; clamped client-side. */
          if (typeof s.poll_ms === 'number' && s.poll_ms >= 2000 && s.poll_ms <= 15000 && s.poll_ms !== hbMs && pollT && !done) {
            hbMs = s.poll_ms; dbg.pollMs = hbMs; clearInterval(pollT); pollT = setInterval(poll, hbMs);
          }
          if (GUEST) {   // THE GUEST MINUTE (guestEnd above): time up -> the card; else re-base the chip, and release a held player
            if (j.reason === 'guest_time_up') { guestTimeUp(s, j.guest_watch_reset_s); return; }
            guestLeft(typeof j.guest_watch_left_s === 'number' ? j.guest_watch_left_s : null);
            if (guestHold && j.guest_watch !== false) {
              guestHold = false; dbg.guestHold = false;
              try { localStorage.removeItem('rova_gtu'); } catch (e) {}
              if (v && !done) startWatching();
            }
          }
          // LIVE BATTLES (db/0233/0236): the battle layer (assets/livebattle.js) also reads stream.battle off this poll (no request of its own)
          try { document.dispatchEvent(new CustomEvent('rova:live-poll', { detail: { id: id, stream: s, lrt: j.lrt, lrt_rev: j.lrt_rev } })); } catch (e) {}
          if (typeof j.lrt === 'number') lrtLoad(j.lrt);   // CALLS THAT OPEN MID-WATCH (above)
          if (v && stage && !done) { try { lwComposite(s.composite || null); } catch (e) {} }   // db/0236: the call's name chips (lwChips)
          if (v && stage && !done) { try { lwHostAway(s); } catch (e) {} }   // 2026-10-08 HOST AWAY: "Host is on a phone call" (lwHostAwayPaint)
          if (v && stage && !done) { try { lwScreenShare(s); } catch (e) {} }
          if (v && stage && !done) { try { lwTurnFeed(s); } catch (e) {} }   // THE TURN (2026-10-23): a host held sideways = a 16:9 band   // 2026-10-15 SCREEN SHARE: the host's screen drawn whole (lwFit)
          if (v && !done) { try { echoPoll(s.me_in_call === true || s.self_echo_mute === true); } catch (e) {} }   // 2026-10-16 LIVE ECHO: self_echo_mute (host on another device too)   // 2026-10-12 ECHO: I'm in this call on another device / tab
          if (j.gifting) {
            giftAsks++; dbg.giftAsks = giftAsks;
            try { document.dispatchEvent(new CustomEvent('rova:live-gifting', { detail: { id: id, status: s.status, gifting: j.gifting } })); } catch (e) {}
          }
          dbg.polls++; dbg.status = s.status; dbg.viewers = s.viewers;
          if (viewersEl) viewersEl.textContent = s.viewers;
          // db/0247 PRIVATE LIVES: the host's control follows the server (the app may flip it too); gone when it may not toggle
          if (visBtn && !visBusy) { if (s.can_toggle_visibility === false) visBtn.hidden = true; else paintVis(s.visibility); }
          if (!visBtn) lwPrivPaint(s);   // ... and every VIEWER's "Private" pill beside LIVE (lwPrivPaint, below)
          lwDjPaint(s);   // DJ MODE (2026-10-17): the gold "DJ mode" pill beside LIVE while stream.music is on (lwDjPaint, below)
          // db/0229: the sampler may MEASURE the orientation after the page drew (an OBS canvas declares nothing)
          if ((s.orientation === 'landscape' || s.orientation === 'portrait') && s.orientation !== orient) {
            orient = s.orientation; dbg.orient = orient; root.setAttribute('data-orient', orient); lwFit();
          }
          // db/0241 A PLANNED ORIENTATION SWITCH: no stall Be right back while switching; a fresh stall clock when it ends; the
          // measured new shape arms health()'s one 're-orient' re-join
          var sw = s.switching === true;
          if (sw !== switching) { switching = sw; dbg.switching = sw; if (!sw) { ctMovedAt = framesMovedAt = Date.now(); ctHist = []; frAnchor = -1; } paintBrb(); }
          var osw = s.orientation_switch;
          if (osw && osw.measured && osw.declared_at && osw.declared_at !== swKey) { swKey = osw.declared_at; swMeasuredAt = Date.now(); swRejoined = false; }
          dbg.orientSwitch = osw || null;
          if (typeof s.time_left_s === 'number') { endsAt = Date.now() + s.time_left_s * 1000; paintLeft(); }   // db/0209 THE CAP
          // started_at: learned once for a stream opened while 'created'; RE-BASED if it ever moves (the Gift Lab's clock jump)
          if (s.started_at) { var st0 = Date.parse(s.started_at) || 0; if (st0 && st0 !== startedAt) { startedAt = st0; if (!tickT) { tickT = setInterval(tick, 1000); } tick(); } }
          // THE VEIL, honoured mid-stream: flagged -> the gate goes on (unless the reader already revealed,
          // the 2 h cookie); cleared by a reviewer -> it comes off again.
          if (GUEST && j.guest_watch === false && s.nsfw !== true && (s.status === 'live' || s.status === 'created')) { guestLock(false); return; }   // GUESTS WATCH: no longer a guest's live
          if (s.nsfw === true) veilNow(); else if (s.nsfw === false && veiled) unveil();
          // MATURE LIVES (db/0294): a live that turns mature while a non-follower watches gets the "Tap to view" screen (once per tab)
          if (s.viewer_gate === 'tap_to_view' && stage && !veiled && window.__rovaMatureGate && window.__rovaMatureGate(stage, 'live:' + id) && v) { try { v.muted = true; } catch (e) {} }
          // A stream that goes live AFTER the reader opened (or after the retry loop gave up while it
          // was still 'created') re-arms the manifest probe on the created->live edge -- a genuine new
          // signal, fired at most once per transition, so it never thrashes a 404-forever stream.
          if (s.status === 'live' && prevStatus !== 'live' && v && !playbackStarted && !done) {
            giveUp = false; dbg.giveUp = false; hideWaiting(); loopStart = Date.now();
            if (!probing && !retryT) tryStart();
          }
          prevStatus = s.status;
          status = s.status;
          // RECONNECTING (db/0219): the server is holding the live for the broadcaster's connection to come back
          var conn = s.connection || (s.status === 'live' ? 'live' : '');
          var rcN = typeof s.reconnects === 'number' ? s.reconnects : -1;   // 2026-10-06 additive: a drop the poll never saw is still a signal
          var rcUp = rcN >= 0 && lastRc >= 0 && rcN > lastRc;
          if (rcN >= 0) { lastRc = rcN; dbg.reconnects = rcN; }
          if (s.status === 'live' && (rcUp || (connection === 'reconnecting' && conn === 'live'))) signalResume(rcUp ? 'reconnects' : 'connection');
          if (conn !== connection) {
            connection = conn; dbg.connection = conn;
            if (conn) root.setAttribute('data-connection', conn); else root.removeAttribute('data-connection');
            paintBrb();
          }
          // HOST GONE (2026-10-15): repaint the Be right back note when the host_gone state (or its guest count) changes
          var hg = s.host_gone && typeof s.host_gone === 'object' ? s.host_gone : null, hgK = hg ? (hg.reason || '') + '|' + (+hg.guests || 0) : '';
          dbg.hostGone = hg;
          if (hgK !== lwHGk) { lwHGk = hgK; lwHG = hg; paintBrb(); }
          if (s.status !== 'live' && s.status !== 'created') {
            endOrDrain(s.status === 'killed' ? 'This stream was ended by moderation.'
                  : (s.end_reason === 'time_limit' ? 'This stream reached its time limit.'
                  : s.end_reason === 'disconnected' ? 'The host didn’t come back, so this live ended. Thanks for watching.' : 'This stream has ended.'), s.recording && s.recording.post_id, s);   // HOST GONE (2026-10-15)
          }
        })
        .catch(function (err) {
          dbg.polls++;
          /* PRIVATE LIVES (db/0247): 403 = the broadcaster made this live private and this viewer does not follow them. A clean
             end state, not an error: the player stops, rova:live-ended closes the chat, the gift tray and the call. */
          if (err && err.status === 403) { dbg.private = true; root.setAttribute('data-private', '1'); ended('This live is now private. Only the host\u2019s followers can watch.', 0); }
          else if (err && err.status === 404) ended('This stream was ended.', 0);
        });
    }
    var hbMs = 5000;   // the heartbeat cadence; the server may stretch it per room (stream.poll_ms, read in poll())
    if (status === 'live' || status === 'created') { pollT = setInterval(poll, hbMs); }
    if (v && (status === 'live' || status === 'created')) { healthT = setInterval(health, 1000); }
    // db/0219: the page itself does not say whether the live is being HELD, so the first poll comes early (1.5 s, not 5 s)
    // and a page opened during a drop shows "Be right back" at once.
    if (v && (status === 'live' || guestHold)) { setTimeout(poll, guestHold ? 0 : 1500); }   // THE GUEST MINUTE: a held page asks at once
    paintBrb();
    /* THE RETURN. Everything this module skips while hidden is picked up here, in one place:
         tick()      the clock is stateless, so one call is the whole catch-up;
         poll()      count me again AND learn anything the stream did while I was away (status, the
                     veil, an ended stream) -- the 5s interval was never cleared, this is just the
                     edge so the reader does not wait up to 5s to be counted;
         tryStart()  re-arm the bounded manifest probe with a fresh 60s budget, by the same three
                     lines the created->live edge uses. A hidden stretch is time that never happened
                     for this loop, which is why the budget is reset rather than resumed.
       `done` short-circuits all three so a finished stream cannot be revived by a tab switch. */
    document.addEventListener('visibilitychange', function () {
      if (done || draining || document.hidden) return;   // draining: never seek a finished live back to its edge
      ctMovedAt = framesMovedAt = Date.now(); stallSince = 0; ctHist = []; frAnchor = -1; pausedSince = 0;   // time spent hidden is not a stall (health() skips hidden)
      /* 2026-10-02: the hidden-tab governor now PAUSES this player while the page is hidden (nothing streams to
         nobody), and its resume path plays it from where it stopped -- minutes behind a live. Back to the edge. */
      try {
        if (v && playbackStarted && v.seekable && v.seekable.length) {
          var edgeT = v.seekable.end(v.seekable.length - 1);
          if (isFinite(edgeT) && edgeT - v.currentTime > 8) { v.currentTime = Math.max(0, edgeT - 3); }
        }
      } catch (e) {}
      tick();
      poll();
      if (v && !playbackStarted && !guestHold) {   // THE GUEST MINUTE: a held guest player waits for its poll's word
        giveUp = false; dbg.giveUp = false; hideWaiting(); loopStart = Date.now();
        if (!probing && !retryT) tryStart();
      }
    });
    if (reportBtn) {
      reportBtn.addEventListener('click', function () {
        if (busyIs(reportBtn)) return;
        if (!window.confirm('Report this live stream to moderation?')) return;
        busyUntil(reportBtn, postJson('/live/' + id + '/report', { reason: 'Reported from the live watch page' }, 15000).then(function (res) {
          if (res && res.ok) { toast('Thanks, the stream has been reported.'); reportBtn.classList.add('on'); }
          else { toast((res && res.message) || 'Could not report'); }
        }).catch(function (err) {
          if (err && err.message === 'reauth') return;
          toast('Couldn’t report, check your connection');
        }));
      });
    }
    /* PRIVATE LIVES (db/0247, Rob 2026-10-08: "Make my live private toggle while on live"): the host's Public / Private control
       (#lw-vis, views/live_watch.php: drawn only while the server says can_toggle_visibility -- /live/browser, /live/studio and the
       host's own /live/{id}). POST /live/{id}/visibility, never a reload (a browser live's encoder runs in this page); every poll
       keeps it in step. Viewers who may no longer watch get 403 `private` on their next poll (the catch above). */
    /* PRIVATE LIVES, THE VIEWER'S MARK (db/0247, 2026-10-08, the Apple TV's parity): a follower still watching a live its host made
       private sees a small "Private" pill (white lock) beside LIVE in the stage's top row (#lw-priv, views/live_watch.php draws it
       from the first paint, hidden while public). Every poll keeps it in step with stream.visibility -- on when it goes private,
       off when it goes public. Never for the host (their #lw-vis says it; the poll calls this only without one) and never on the
       no-chat stage, which has no pill row. A server without the key (no `visibility`) leaves it as drawn. */
    /* DJ MODE (2026-10-17, Rob via the Mac: room music mode is "DJ mode", the host's set plugged into the device; lib/livemusic.php):
       a gold "DJ mode" pill beside LIVE (after Private) while stream.music is true, for everyone on the watch page (viewers, guests, the
       host). Made on the first poll that says so, then shown / hidden in step; a server without the key (no music field) leaves it alone. */
    function lwDjPaint(s) {
      if (!s || typeof s.music !== 'boolean') return;
      var on = s.music && s.status !== 'ended', el = document.getElementById('lw-dj');
      dbg.djMark = on;
      if (!el) {
        if (!on) return;
        var tl = document.getElementById('lw-tl'), badge = document.getElementById('lw-badge');
        if (!tl || !badge || badge.parentNode !== tl) return;
        var after = document.getElementById('lw-priv'); after = after && after.parentNode === tl ? after : badge;
        el = document.createElement('span'); el.className = 'lw-dj'; el.id = 'lw-dj'; el.hidden = true; el.title = 'DJ mode: the host is playing a live set';
        el.innerHTML = '<svg class="lw-dj-ic" viewBox="0 0 24 24" width="11" height="11" aria-hidden="true"><path d="M9 18V6l11-2v12" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/><circle cx="6.5" cy="18" r="2.8" fill="currentColor"/><circle cx="17.5" cy="16" r="2.8" fill="currentColor"/></svg><span class="lw-dj-tx">DJ mode</span>';
        tl.insertBefore(el, after.nextSibling);
      }
      el.hidden = !on;
      root.classList.toggle('is-dj', on);
    }
    function lwPrivPaint(s) {
      if (!s || (s.visibility !== 'private' && s.visibility !== 'public')) return;
      if (s.is_mine || root.getAttribute('data-mine') === '1') return;
      var p = s.visibility === 'private', el = document.getElementById('lw-priv');
      dbg.privMark = p;
      if (!el) {
        var tl = document.getElementById('lw-tl'), badge = document.getElementById('lw-badge');
        if (!p || !tl || !badge || badge.parentNode !== tl) return;
        el = document.createElement('span'); el.className = 'lw-priv'; el.id = 'lw-priv'; el.hidden = true;
        el.title = 'Private live: only followers can watch';
        el.innerHTML = '<svg class="lw-priv-ic" viewBox="0 0 24 24" width="11" height="11" aria-hidden="true"><rect x="4.5" y="10.5" width="15" height="11" rx="2.4" fill="currentColor"/><path d="M8 10.5V7.5a4 4 0 0 1 8 0v3" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"/></svg><span class="lw-priv-tx">Private</span>';
        tl.insertBefore(el, badge.nextSibling);
      }
      if (el.hidden !== !p) el.hidden = !p;
    }
    var visBusy = false;
    function paintVis(vis) {
      if (!visBtn || (vis !== 'public' && vis !== 'private')) return;
      var p = vis === 'private';
      dbg.visibility = vis;
      visBtn.setAttribute('data-vis', vis);
      visBtn.setAttribute('aria-pressed', p ? 'true' : 'false');
      visBtn.classList.toggle('is-private', p);
      visBtn.title = p ? 'Private: only your followers can watch. Tap to make it public.' : 'Public: anyone can watch. Tap to make it private (followers only).';
      var ic = visBtn.querySelector('.lw-vis-ic'), tx = visBtn.querySelector('.lw-vis-tx');
      if (tx) tx.textContent = p ? 'Private' : 'Public';
      if (ic) ic.innerHTML = p ? '<rect x="4" y="11" width="16" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/>'
                               : '<circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18"/>';
    }
    if (visBtn) {
      visBtn.addEventListener('click', function () {
        if (visBusy || done) return;
        var next = visBtn.getAttribute('data-vis') === 'private' ? 'public' : 'private';
        visBusy = true; visBtn.disabled = true; dbg.visClicks = (dbg.visClicks || 0) + 1;
        postJson('/live/' + id + '/visibility', { visibility: next }, 15000).then(function (res) {
          if (res && res.ok) {
            paintVis(res.visibility || next);
            toast((res.visibility || next) === 'private' ? 'Your live is private. Only your followers can watch.' : 'Your live is public again.');
          } else { toast((res && res.message) || 'Could not change who can watch'); }
        }).catch(function (err) {
          if (err && err.message === 'reauth') return;
          toast('Couldn\u2019t change who can watch \u2014 check your connection');
        }).then(function () { visBusy = false; visBtn.disabled = false; });
      });
    }
    if (endBtn) {
      endBtn.addEventListener('click', function () {
        if (busyIs(endBtn)) return;
        if (!window.confirm('End your stream?')) return;
        busyUntil(endBtn, postJson('/live/' + id + '/stop', {}, 15000).then(function (res) {
          if (res && res.ok) ended('Your stream has ended.', res.stream && res.stream.recording && res.stream.recording.post_id, res.stream);
          else toast((res && res.message) || 'Could not end the stream');
        }).catch(function (err) {
          if (err && err.message === 'reauth') return;
          toast('Couldn’t end the stream, check your connection');
        }));
      });
    }
  }
})();

/* ---- THE ONE PHOTO FIT VERDICT: ONE rule, THREE call sites ---------------------------------
   "Does this photo COVER (fill the screen, cropping what overflows) or CONTAIN (open whole,
   with bars)?" is asked in three places that MUST agree, or the open flight lands on a box the
   viewer then repaints differently -- the owner's "cascading"/"zooms in then zooms out" open:
     1. heroZoom's fit prediction        (the grid/feed tap clone's landed box)
     2. pfeedLandRect                    (the same prediction for the immediate-start flight)
     3. fitPfeedMedia's `pf-uncrop`      (what the viewer ACTUALLY paints)
   All three used to write the rule out again in their own shape. This is the single body; the
   two prediction sites and the viewer now call it, so a fourth caller cannot drift either. It
   lives between the top-level IIFEs (this file is five of them, sharing nothing but `window`,
   see the SHARED LONG-BODY CLAMP below) so it exists before any of the three can RUN.

   ---- THE RULE, and why it is TWO aspect distances and not one --------------------------------
   Repo law is that fit is decided by ASPECT DISTANCE, never by orientation (a bare `h >= w` test
   reads a square as "portrait like the phone" and fills it). `aspectDist(a,b) >= 1` is exactly
   how far past "whole" a cover zoom pushes: at distance d you see 1/d of the cropped axis.

   OWNER 2026-08-13, seven links, all of which opened cover-zoomed and should not have:
   /p/42422 /p/42354 /p/42301 /p/42138 /p/42076 (640x640, exactly square) and /p/42273 both as
   posted and at ?slide=3 (a 14-slide carousel of 1320x1597 = 0.826 screenshots). Measured on a
   420x912 phone: the squares showed 44.2% of their width, the screenshots 53.6%.
     "As square photos these photos/media should load zoomed out in full screen mode... better
      load zoomed-in portraits correctly vs square or landscape media that don't look so good
      zoomed in."
   The line he is drawing is 'genuinely taller than square FILLS; square-ish and landscape open
   WHOLE'. That is the same line he drew for CLIPS in #490/#562 (see VIDEO_CONTAIN_SPLIT in the
   app's PostScreen.js), one notch tighter than the photo line has been on either surface.

   A SINGLE box-relative split CANNOT express it, which is why there are two terms. The shapes it
   has to separate are 4:5 = 0.800 (must COVER -- owner #503/#504, "a 4:5 photo must open
   full-bleed") and /p/42273 = 0.826 (must CONTAIN, today). They are 3.3% apart in aspect, so the
   distance-to-the-box window between them is 3.3% wide -- and the box itself moves more than that
   between real screens. Measured: the pfeed box is 405x912 (0.4441) in the headless rig, which
   has a scrollbar, and 420x912 (0.4605) on the owner's phone, which does not.
       box 0.4441 -> split must be in (1.801, 1.861)
       box 0.4605 -> split must be in (1.737, 1.795)
   Those two windows DO NOT OVERLAP. A scrollbar's worth of difference is enough to flip a shape,
   so a lone box-relative constant would satisfy him on one screen and not the other. The
   near-square half of the verdict is a MEDIA-shape question and has to be measured as one.

   So: distance from a SQUARE decides near-square, distance from the BOX decides the rest, and the
   media has to be off-square THE SAME WAY THE SCREEN IS -- which is his sentence transcribed,
   "zoomed-in portraits ... vs square or landscape media that don't look so good zoomed in":
     tall screen: covers = mediaAR <  1 / PF_SQUARISH  &&  aspectDist(mediaAR, boxAR) <= PF_SPLIT_TALL
     wide screen: covers = mediaAR >      PF_SQUARISH  &&  aspectDist(mediaAR, boxAR) <= PF_SPLIT_WIDE
   PF_SQUARISH = 1.23 is chosen for the GAP, not for a shape: 4:5 sits at 1.250 from square and
   /p/42273 at 1.210, and 1.23 is the midpoint, ~1.6% of headroom each way. It is viewport-
   independent by construction, which is the whole point -- measured over 3,189 photos, the phone
   verdict is IDENTICAL at 420x912, 405x912 and 360x800. A lone box-relative split is not.
   WHY THE SIGN TEST AND NOT A SYMMETRIC `aspectDist(mediaAR, 1) > PF_SQUARISH`. The symmetric form
   lets a shape cover a screen of the OPPOSITE orientation whenever the two happen to be aspect
   mirrors: on a 768x1024 portrait tablet a 4:3 landscape photo sits 1.778 from the box, inside
   PF_SPLIT_TALL, so 46 photos (1.4%) started filling a portrait tablet with 44% of their width
   cropped away -- precisely the "landscape media ... zoomed in" he is complaining about, just on a
   screen he did not happen to test. The sign test costs nothing and cannot produce that class of
   answer on any screen. It is NOT the old orientation rule coming back: orientation used to decide
   the whole verdict (and read a square as "portrait, so fill it"); here it only says which side of
   square is eligible, and PF_SQUARISH still holds squares and near-squares out on both sides.
   PF_SPLIT is the box-relative split and keeps its existing job -- rejecting shapes far from the
   screen's. TALL = 1.95 is the app's own owner-drawn clip number (PostScreen.js
   VIDEO_CONTAIN_SPLIT), and on a phone it only ever has to sit between 4:5 (1.74-1.86 across real
   phone shapes) and the tallest thing worth filling, which it does with room to spare. WIDE stays
   1.30, the number the 2026-07-30 wide-media fix landed: raising it there would put the 2.64
   bet-slip back on the cover side of a desktop (its distance is 1.876), which is all of #567.

   ON A PHONE the corpus lands like this (3,189 photos measured; identical at 420x912, 405x912 and
   360x800, which is the viewport-independence above doing its job):
     9:16 0.563 · 2:3 0.667 · 3:4 0.750 · 4:5 0.800            -> COVER   (26.8% of posts)
     0.82..0.99 near-square · 1:1 square 71.6% · all landscape -> CONTAIN (73.2% flip to whole)
   ON A 1280x900 DESKTOP every shape answers exactly as it did before EXCEPT mildly-landscape media
   (aspect 1.00..1.23 -- 4 posts, 0.13% of the corpus), which now opens whole instead of cropping
   ~20% of its width; on a 1440x900 desktop NOTHING changes at all.

   THE ONE THING THIS RULE GETS "WRONG", ON PURPOSE AND KNOWINGLY: /p/41968 is 1440x1713 = 0.841,
   and on 2026-08-12 the owner said of it "it should be zoomed in like the app". 0.841 is SQUARER
   than the 0.826 he is now asking to be zoomed OUT -- 1.8% apart, on opposite sides of what he
   has asked for. No threshold of any kind separates them, so this is not a tuning failure and
   re-tuning will not fix it: the two requests genuinely contradict. The seven links are the newer
   and much larger sample, so they win, and /p/41968 now opens whole. If he raises it again the
   answer is NOT to move PF_SQUARISH (it would take /p/42273 straight back with it) -- it is that
   near-square photos need a per-post or content-aware answer, not a shape one.

   Unknown dims -> COVER. That matches the app's photoCovers() and is the state every stage is in
   before its pixels land, so nothing flickers on the way in. */
(function () {
  'use strict';
  /* 1.23 -> 1.15 (Rob 2026-09-29, matching the iOS app's PHOTO_SQUARISH): portraits up to w/h ~0.87
     now FILL (cover) -- /p/54665 (0.824) and /p/41968 (0.841) open zoomed in, which settles the
     /p/41968 contradiction described in the header above in favour of cover. 0.87..0.99 near-squares,
     squares and landscapes still open whole on a phone. /p/42273 (0.826) stays whole ONLY because its
     slide carries fit:'contain' -- the hint short-circuit below, not the shape rule, now protects it.
     On a DESKTOP the wide side moves too: landscapes 1.15..1.23 become cover-eligible where they are
     also within PF_SPLIT_WIDE of the box (e.g. 1280x900; nothing on 1440x900). */
  var PF_SQUARISH   = 1.15;   // aspect distance from a SQUARE: inside this, never cover
  var PF_SPLIT_TALL = 1.95;   // aspect distance from a PORTRAIT viewport
  var PF_SPLIT_WIDE = 1.30;   // aspect distance from a LANDSCAPE / desktop viewport
  function aspectDist(a, b) { return a > b ? a / b : b / a; }
  /* THE FIT HINT (`hint`, migration 0144) IS CONSULTED FIRST, AND IT IS THE ONLY THING ABOVE THE
     SHAPE RULE. Owner, 2026-08-14, on an ESSENCE article screenshot that opened cover-zoomed with
     its headline sliced off: "if there's text in the image it shouldn't be zoomed in since it cuts
     off". Everything below this point is a SHAPE rule, and a 3:4 article screenshot and a 3:4
     portrait photograph are the same shape -- no threshold can separate them, which is why the
     header above concludes that near-square photos "need a per-post or content-aware answer, not a
     shape one". This is that answer, arriving as one string per media item.
       'contain' -> never cover (what lib/textimage.php writes for a text graphic)
       'cover'   -> always cover (hand-set per-post override; the detector never writes it)
       anything else, including undefined -> the shape rule below, BYTE-IDENTICAL to before.
     It is a 5th ARGUMENT, not a 5th global: this function is called from three scopes in this file
     that share nothing but `window`, and each of them already holds the <img> the hint hangs on.
     WHAT IT DELIBERATELY DOES NOT TOUCH: pf-uncrop is still a TOGGLE. fitPfeedMedia stamps the
     verdict, and a tap (or the .vc-fit button) still inverts it, so a reader who WANTS the
     screenshot zoomed in gets it in one tap. The hint changes the DEFAULT, never the control. */
  window.__rovaPhotoCovers = function (nw, nh, cw, ch, hint) {
    if (hint === 'contain') { return false; }
    if (hint === 'cover')   { return true; }
    if (!(nw > 0 && nh > 0 && cw > 0 && ch > 0)) { return true; }
    var mediaAR = nw / nh, boxAR = cw / ch;
    var offSquare = (cw > ch) ? (mediaAR > PF_SQUARISH) : (mediaAR < 1 / PF_SQUARISH);
    return offSquare
        && aspectDist(mediaAR, boxAR) <= (cw > ch ? PF_SPLIT_WIDE : PF_SPLIT_TALL);
  };
  /* ---- THE ONE VIDEO FIT VERDICT: the clip twin of the rule above -----------------------------
     Same problem, same three call sites, and until 2026-08-14 the same three hand-written copies:
       1. heroZoom's fit prediction   2. pfeedLandRect   3. fitPfeedMedia's `pf-vfill`
     all spelled `(nh >= nw) === (cw <= ch)` in their own shape. That is why this exists as a body
     rather than a comment telling three places to agree -- it is the identical argument the photo
     header makes above, and the photo verdict was ALREADY collapsed for exactly this reason.

     THE SHAPE RULE IS UNCHANGED, TO THE CHARACTER. `covers` is still "the clip and the screen are
     off-square THE SAME WAY" -- a portrait clip on a portrait phone fills, a landscape clip on a
     desktop fills, and either one crossed over contains. It is NOT the photo rule and must not
     drift into it: the two verdicts differ on purpose (a video has no PF_SQUARISH hold-out, so a
     square clip fills a phone where a square photo opens whole), and the native app draws the clip
     line differently again (PostScreen.js VIDEO_CONTAIN_SPLIT, an aspect distance). Nothing here
     touches any of that. The ONLY thing this function adds over the three lines it replaces is the
     hint short-circuit below.

     THE FIT HINT (migration 0144), OWNER 2026-08-14 on /p/43060: "this video has text and
     shouldn't load fullscreen zoomed in. Is there any way we can fix this without affecting other
     videos and photos without text from zooming in?" That post is a 4:5 clip whose top ~17% is a
     burnt-in yellow-on-black headline bar, and the orientation rule fills it and slices the bar --
     while a 4:5 concert clip of the identical shape SHOULD fill. No orientation test and no aspect
     distance can separate those two, for precisely the reason the photo header gives: they are the
     same SHAPE and differ only in CONTENT. So the clip verdict now takes the same content input
     the photo verdict does, read off the <video>'s (or the tapped grid tile's) data-fit.
       'contain' -> never fill      'cover' -> always fill      anything else -> the rule below,
     BYTE-IDENTICAL to what these three sites computed before.
     THE ⤢ / .vc-fit CONTROL IS UNTOUCHED and still INVERTS whatever this returns -- fitPfeedMedia
     stamps pf-vfill/pf-letterbox from it and the button flips those classes, so a reader who wants
     the headline clip zoomed in still gets it in one tap. */
  window.__rovaVideoCovers = function (nw, nh, cw, ch, hint) {
    if (hint === 'contain') { return false; }
    if (hint === 'cover')   { return true; }
    return (nh >= nw) === (cw <= ch);
  };
  /* ---- THE ONE CROP BIAS (PF_PANY_BIAS), PUBLISHED SO THE FLIGHT CAN LAND ON IT ---------------
     (2026-09-14. Owner, 60fps recording of opening and closing @L0v3ly's profile photo: "watch the
     opening land incorrectly before self healing, then the dismiss does the same thing".)

     A COVERING PHOTO IN THE VIEWER IS NOT CENTRED IN ITS CROP. fitPfeedMedia seeds `--pf-pany` so
     the crop starts biased toward the TOP -- the 2026-08-23 "cutting off peoples heads" fix, a 15/85
     split of the hidden strip reached by a TRANSLATE because a pf-zoomable photo is contain-fitted
     and scaled up, so object-position has no grip on it (see the long note at that seed, and the
     .pf-portrait note in rova.css). Until today the arithmetic lived ONLY at that seed, and the
     flight knew nothing about it: heroExpand's clone lands CENTRED, so the hand-off moved the
     picture by exactly this many pixels in a single frame.

     MEASURED, HIS OWN FRAMES AND HIS OWN RECEIPT, THE SAME MINUTE: the landing box was perfect
     (/vflight open-land at 13:53Z, uid 2467: p:0 f:0 dy:0 dh:0 a:0 post:0 vh:746) while the PICTURE
     sat 102 CSS px high for 8 frames and then snapped down in one. Scale 1.0000 throughout. The
     receipt could not see it because it compares paintedRectOf's BOXES, and a translate inside a
     cover window does not move the box -- [[narrow-select-makes-helpers-lie]], in geometry.
     Predicted here for that photo: 746 * (1.38427 - 1) * 0.35 = 100.3px. Harness reads 100.3.

     SO IT IS A BODY, NOT A COMMENT ASKING TWO PLACES TO AGREE -- the identical argument the two fit
     verdicts above are written as. Consumers: fitPfeedMedia's seed (which PAINTS it), heroExpand's
     landRect (which flies to it) and __rovaHeroCollapse (which flies FROM it). Returns px, 0 when
     no bias applies, which is every non-covering photo, every video and every sideways-cropping
     shot -- so a surface that does not bias is byte-identical to before.
     `covers` is passed IN rather than re-decided: the caller has already asked __rovaPhotoCovers
     (or, in the viewer, already toggled pf-uncrop off it), and a second verdict here could drift
     from the first -- which is the whole disease this file keeps curing. */
  var PF_PANY_BIAS = 0.35;    // fraction of the hidden strip moved DOWN: leaves 15% above, 85% below
  /* The bias gate is the app's PostCard.js BIAS_DIST (1.23), which USED to equal PF_SQUARISH. It was
     split off on 2026-09-29 when PF_SQUARISH went to 1.15, so the crop bias stays value-identical to
     the app's coverBiasY instead of silently moving with the fit verdict. */
  var PF_BIAS_DIST = 1.23;
  window.__rovaPfPanyBias = function (nw, nh, cw, ch, covers) {
    if (!covers) { return 0; }
    if (!(nw > 0 && nh > 0 && cw > 0 && ch > 0)) { return 0; }
    var mediaAr = nw / nh, boxAr = cw / ch;
    // only a genuinely TOP/BOTTOM-cropping shot, and only past the same 1.23 (PF_BIAS_DIST) the app's
    // PostCard.js coverBiasY uses -- copied, not re-derived, so the biased surfaces agree.
    if (!(mediaAr < boxAr) || !((boxAr / mediaAr) > PF_BIAS_DIST)) { return 0; }
    var s = Math.max(cw / nw, ch / nh) / Math.min(cw / nw, ch / nh);   // cover-scale over contain-scale
    return ch * (s - 1) * PF_PANY_BIAS;
  };
  /* Read the hint off whatever element a caller happens to hold. Every photo call site in this
     file has the source <img> in hand (the pfeed slide, the tapped feed card, the grid tile), and
     all three carry data-fit from PHP, so the hint never needs its own plumbing. Anything that is
     not one of the two known words reads as "no opinion".
     VIDEO CALL SITES PASS A <video> (the pfeed clip, the live grid preview) and it works the same
     way -- views/_post.php stamps data-fit on the <video> and the grid's ensureVideo() copies it
     off the poster <img> it builds the element from, so whichever node a flight happens to be
     holding answers the same. Falls through the list until something has an opinion, so a caller
     with both a hero node and a source tile can hand over both without an `||` chain of its own. */
  window.__rovaFitHint = function (el) {
    for (var i = 0; i < arguments.length; i++) {
      var e = arguments[i];
      var v = (e && e.getAttribute) ? e.getAttribute('data-fit') : null;
      if (v === 'contain' || v === 'cover') { return v; }
    }
    return null;
  };
})();

/* ---- SHARED LONG-BODY CLAMP: ONE implementation, TWO surfaces -------------------------------
   The immersive viewer has clamped its caption to 4 lines behind a more/less pill since
   2026-08-03. The post page (/p/<id>) did not, so a long caption pushed the media AND the whole
   like / comment / repost / share row roughly TWO screens down (owner, 2026-08-08, on /p/15396:
   "This post is too long and should show a more button so the whole post can fit on my screen.
   See how the full screen viewer works with the more button to expand the text add this to the
   main post page also so I can see the like comment etc before the fold").

   THIS IS THE VIEWER'S OWN LOGIC LIFTED OUT, NOT A COPY OF IT. fitPfeedMedia (further down, a
   separate top-level IIFE) now calls __rovaClampBody and adds only its pfeed-specific gesture
   handlers on top; applyCaption (further UP, also a separate IIFE) now calls __rovaClipText
   instead of repeating its four lines inline, which is the exact drift the comment there used to
   apologise for. window.* is how these three scopes reach each other -- this file is five
   top-level IIFEs, not one, and they share nothing but `window`. It is defined HERE, between the
   main IIFE and the pfeed IIFE, so it exists before either caller can run.

   THREE LINES ON THIS SURFACE, FOUR IN THE VIEWER -- MEASURED, NOT GUESSED, AND NOT A STYLE CHOICE.
   The success criterion is the owner's: .bar visible without scrolling on a phone. Measured live on
   /p/<id> in Chromium AND WebKit at the two viewports he uses, with the height mobile Safari's
   chrome actually leaves -- its bars are in his screenshots -- 390x844 -> 659 visible CSS px,
   420x912 -> 712. The viewer's caption is an overlay pinned to the BOTTOM of the screen with
   nothing below it, so 4 lines costs it nothing; here the caption sits ABOVE the media, and the
   media plus the engagement row have to fit in what is left. At 390x844, on the media height that
   dominates the corpus (368px -- the media box is 368px wide at this viewport and 96.2% of image
   posts are square):
       .body top 118 + N x 23.25 + 27px pill + 6px + 8px gap + 368px media + 12px + 34px .bar
     N=4 -> 676 (Chromium) / 677 (WebKit).  The fold is 659. It MISSES, on the commonest post there is.
     N=3 -> 644 / 645.  15px of headroom in both engines.
   Sampled over 40 random posts with a 260+ char body: at N=4, 21 of the 37 that clamped were still
   below the fold, every one at exactly 676. N=3 clears all of them. The owner's own post (/p/15396,
   a wide video carousel) lands at 474, 185px clear.
   THE HONEST LIMIT, so nobody re-measures this from scratch: a genuinely PORTRAIT media box (aspect
   under ~0.96) is over 383px tall and crosses the fold BY ITSELF -- at the server-side tall bound of
   0.8 it is 460px, leaving 47px for the header, the caption and the pill together. No caption clamp
   reaches that, and going to 2 lines buys only 23px. It is a media-height decision, not this one.
   Neither number is in this file. Both live in rova.css as --rv-clamp, set per surface.

   THE CLAMP IS VISUAL ONLY. Nothing is truncated server-side: /p/<id> is crawled and has og/oembed
   consumers, so the full text has to stay in the document. The clip span is a WRAPPER, never a
   rewrite -- hashtag and mention links, the line breaks (the body is white-space:pre-wrap, so they
   are real newlines and not <br>), emoji and the "Edited" marker all survive untouched, and a
   reader with no JS sees the post exactly as before. */
(function () {
  'use strict';

  var uid = 0;

  /* The clamp clips on this inner span rather than on .body itself.
     WHY (owner 2026-08-03, "caption bubble still trimming some text here"): -webkit-line-clamp
     sizes the content box to N line boxes and puts the ellipsis on line N, but lines N+1.. stay in
     layout -- overflow is what hides them, and overflow clips at the PADDING box. The viewer's
     caption bubble has 8px of padding-bottom, so the clip sat 8px below the last kept line and the
     top 8px of line 5 painted into the padding, past the rounded border: a row of text sliced
     through the middle of the glyphs. A span with no padding has its padding box equal to its
     content box, so the clip lands exactly on the line boundary. overflow:clip +
     overflow-clip-margin fixes it in Chromium and is IGNORED by WebKit, so it is useless on iPhone.
     The post-page .body happens to have no padding today -- the span is used there anyway, because
     the rule is a property of the MECHANISM and one shared span is what keeps the surfaces in step.
     Idempotent, and returns the span either way, so callers can just use the result. */
  function clipText(bd) {
    var ct = bd.querySelector(':scope > .pf-cliptext');
    if (ct) { return ct; }
    ct = document.createElement('span');
    ct.className = 'pf-cliptext';
    while (bd.firstChild) { ct.appendChild(bd.firstChild); }
    bd.appendChild(ct);
    return ct;
  }

  /* Clamp one .body and, ONLY if it actually overflows, give it a more/less pill.
     opts.cls    extra class for the pill (the post page passes 'pf-more-card' for the card skin)
     opts.anchor keep the body pinned under the reader's eye across a toggle (page-scrolling
                 surfaces; the viewer's expanded caption scrolls INSIDE itself, so it passes nothing)
     opts.after  fn(bd, pill, toggle) -- surface-specific wiring, run once the pill exists
     opts.noBodyTap  leave the body itself alone. On the timeline a tap on a card's blank space --
                 its body included -- already means "open the comments" (the document-level
                 card-tap handler in the main IIFE), and a body listener that stopPropagation()s
                 would silently take that away from long posts only. There the pill is the ONLY
                 toggle.  */
  /* The pill's behaviour, in one place, so a pill can be wired TWICE in its life: once when it is
     created below, and again when a card comes back from the timeline virtualiser (recycleTick's
     stubCard/restoreCard, main IIFE) as a RE-PARSED COPY of its own outerHTML. That copy keeps the
     pill, the body id and the state classes -- markup survives serialisation -- but not one listener
     and not the _pfClamp latch, so the first build of the card clamp measured the copy afresh and
     gave it a SECOND pill (seen live on Discover, 2026-09-05: two "more" buttons both controlling
     pbody-1). */
  function wirePill(bd, mb, opts) {
    var tgl = function (e) {
      if (e) { e.preventDefault(); e.stopPropagation(); }
      // EXPAND/COLLAPSE IN PLACE. Collapsing removes height from ABOVE the reader's eye on a
      // page-scrolling surface, which yanks everything below it upward; re-read the body's
      // viewport-relative top after the class flip and give the delta back. getBoundingClientRect
      // forces layout, so the second read is the post-flip truth, not the pre-flip one.
      var y0 = opts.anchor ? bd.getBoundingClientRect().top : 0;
      var open = bd.classList.toggle('pf-open');
      bd.classList.toggle('pf-clamp', !open);
      mb.textContent = open ? 'less' : 'more';
      mb.setAttribute('aria-expanded', open ? 'true' : 'false');
      mb.setAttribute('aria-label', open ? 'less, show less of this post'
                                         : 'more, show the full post');
      if (opts.anchor) {
        var dy = bd.getBoundingClientRect().top - y0;
        if (dy) { window.scrollBy(0, dy); }
      }
      return open;
    };
    mb.addEventListener('click', tgl);
    if (!opts.noBodyTap) bd.addEventListener('click', function (e) {   // tapping the body itself toggles too
      if (e.target.closest && e.target.closest('a,button')) { return; }
      // Someone highlighting the text is READING it, not tapping it -- the same guard the
      // card-tap handler in the main IIFE uses. Without it a drag-select collapses the post.
      if (window.getSelection && String(window.getSelection())) { return; }
      tgl(e);
    });
    if (opts.after) { opts.after(bd, mb, tgl); }
  }

  function clampBody(bd, opts) {
    if (!bd || bd._pfClamp) { return; }
    bd._pfClamp = 1;
    opts = opts || {};
    var ct = clipText(bd);
    // A PILL THAT IS ALREADY THERE AND NAMES THIS BODY is a restored copy (see wirePill). The decision
    // ("it overflows") and the state (open or clamped) both survived; only the wiring did not. Re-wire,
    // re-assert the classes from the state the pill shows, and never measure or build a second pill.
    // The id test is what keeps this from ever matching a neighbour's pill: ids are unique per page
    // and a body only has one once it has been clamped.
    var had = bd.nextElementSibling;
    if (had && had.classList && had.classList.contains('pf-more') && bd.id && had.getAttribute('aria-controls') === bd.id) {
      var isOpen = bd.classList.contains('pf-open');
      bd.classList.toggle('pf-clamp', !isOpen);
      wirePill(bd, had, opts);
      return;
    }
    bd.classList.add('pf-clamp');
    requestAnimationFrame(function () {
      if (!bd.isConnected) { return; }
      /* AN UNMEASURABLE CAPTION IS NOT A SHORT ONE  (2026-08-17). clientHeight 0 on the clip span means
         this body has no layout box right now: an ancestor is display:none, it has not been laid out yet,
         or -- new this round -- it sits in a .pfeed card whose subtree content-visibility is SKIPPING.
         Every one of those satisfies the "fits" test below, which then removes .pf-clamp; and because
         _pfClamp was latched to 1 before this rAF and is reset nowhere, a caption measured once in that
         state would lose its "more" pill for the rest of the session. UN-LATCH and leave: the caller re-
         enters when the thing becomes measurable (fitPfeedMedia's containment re-arm, or the next
         hydration pass), and this way the shared clamp is safe on BOTH surfaces rather than only where a
         caller happened to remember to guard it. Cheap and honest -- the pill it declines to draw is a
         pill nobody can see yet either way. */
      if (!ct.clientHeight) { bd._pfClamp = 0; bd.classList.remove('pf-clamp'); return; }
      // Measure the CLIPPING element, not the body: the body now sizes to its clamped child, so its
      // own scrollHeight and clientHeight always agree and would report "fits" for any length.
      // A SHORT POST MUST COME OUT EXACTLY AS IT WENT IN -- no pill, no clamp class, no cursor change.
      if (ct.scrollHeight <= ct.clientHeight + 6) { bd.classList.remove('pf-clamp'); return; }
      if (!bd.id) { bd.id = 'pbody-' + (++uid); }
      var mb = document.createElement('button');
      mb.type = 'button';
      mb.className = 'pf-more' + (opts.cls ? ' ' + opts.cls : '');
      mb.textContent = 'more';
      // A REAL button (focusable, Enter/Space, in the tab order) carrying the state it controls.
      // aria-label CONTAINS the visible word on purpose (label-in-name): a voice-control user who
      // says "more" must hit the same control a sighted reader is looking at.
      mb.setAttribute('aria-expanded', 'false');
      mb.setAttribute('aria-controls', bd.id);
      mb.setAttribute('aria-label', 'more, show the full post');
      bd.insertAdjacentElement('afterend', mb);
      wirePill(bd, mb, opts);
    });
  }

  window.__rovaClipText  = clipText;
  window.__rovaClampBody = clampBody;

  /* THE POST PAGE, and only its own card. `[data-pfeed-open] > .post` is the selector this file
     already uses for "the permalink's own post" (the auto-open block, the comment-badge writers):
     views/post_single.php marks the wrap, and thread parts / quoted cards are nested deeper, so
     they are never touched. A /p/<id> WITH media auto-opens the viewer over this page -- clamping
     underneath costs nothing, and it is what the reader lands on when they close the viewer, which
     is the state in the owner's screenshot.
     NOT the feed timeline: he asked for the post page. The same .body renderer drives the feed
     card and it has the same overflow, but that is one extra call away and turning it on would
     change every card on /feed at once -- reported, not shipped. */
  function wirePostPage() {
    var card = document.querySelector('[data-pfeed-open] > .post');
    var bd   = card && card.querySelector('.post-main > .body');
    if (bd) { clampBody(bd, { cls: 'pf-more-card', anchor: 1 }); }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', wirePostPage); }
  else { wirePostPage(); }

  /* THE CARD TIMELINES, the third surface (owner 2026-09-05, a screenshot of a ~30-line text post
     by @BeOfficialMG running the whole screen on Trending: "This post should have a more button
     since it's so long"). The "one extra call away" the note above declined to make, made -- for
     EVERY .post card timeline (home feed, profile, channel, group, tag, search, saved, explore,
     mentions, the guest landing card: one emitter, views/_post.php) -- with the three things a
     scrolling list of hundreds of cards needs that a single post page did not:

     1. THE CLAMP IS ALREADY ON when this runs. views/_post.php emits `.pf-clamp-card` + the
        .pf-cliptext span on every body but the permalink's, and rova.css clamps
        `.post .body.pf-clamp-card` to 8 lines (`--rv-clamp:8`, the ONE place the number lives; the
        app's parity gate reads it from there) at first paint, so a long post never flashes
        full-height and then snaps. This code only MEASURES (does it overflow 8 lines?) and adds
        the pill. A short body comes out untouched.
     2. MEASURED NEAR THE VIEWPORT, NOT ON INSERTION. clampBody's rAF reads scrollHeight and then
        writes (a pill, or a class removal); nine of those in one frame at load-more time is nine
        forced layouts of a page holding every card the idle roll has ever appended, during a
        scroll. An IntersectionObserver hands each body over as it comes within a screen or two,
        so the work is spread along the scroll and never lands in one frame. It also means a card
        that measures 0 (a hidden tab pane, a subtree the browser skipped) is simply re-observed
        rather than latched "fits" forever -- clampBody un-latches on that case since 2026-08-17.
     3. THE PILL IS THE ONLY TOGGLE (noBodyTap). On this surface a tap on the card's blank space is
        "open the comments", for every card; a body listener would take that away from long posts.

     SCROLL STABILITY. `anchor:1` keeps the body's own top where it was across a toggle, which on
     "more" is already a no-op (the card grows BELOW the reader's eye) and on "less" gives back
     whatever the collapse took from above. One case is left: the reader read to the END of a long
     post and taps "less" there -- the body's top is a screen above, the pill they tapped lands off
     the top of the viewport, and they are looking at the next card. `after` scrolls the collapsed
     card's head back under the sticky top bar in that one case, instantly (no smooth scroll:
     reduced-motion readers get the same thing everyone does).

     Every insertion path is covered by ONE body-level MutationObserver, the idiom the rest of this
     file uses for late-arriving cards: the first render, a tab swap (the pager replaces the list's
     children), load-more, the "N new posts" prepend, the idle roll and the profile tabs all land
     as .post nodes. Never the viewer (its cards carry the class too -- same partial -- so it is
     excluded HERE, by ancestor, and rova.css keeps it at 4 lines), never the permalink card
     (post_single.php sets $isPermalink, so its body carries no .pf-clamp-card, and [data-pfeed-open]
     is excluded by ancestor besides), never quoted cards (_quoted.php has no .body), never the
     composer (it previews nothing through .post .body).
     window.__rovaClampInit is for the caption editor (applyCaption, main IIFE): an edited body is
     re-measured from scratch, pill and all. */
  var FEED_BODY = '.post .body.pf-clamp-card';
  var feedIO = null;
  function stickyTop() {
    // whatever is pinned across the top of THIS page right now: the site bar, and on the home feed
    // its chrome. Computed, not assumed -- profile/channel/search pages have no #feed-chrome.
    var off = 0;
    Array.prototype.forEach.call(document.querySelectorAll('.topbar, #feed-chrome, #feed-tabs'), function (el) {
      var pos = getComputedStyle(el).position;
      if (pos !== 'sticky' && pos !== 'fixed') { return; }
      var r = el.getBoundingClientRect();
      if (r.top < 0 || r.bottom <= 0) { return; }
      if (r.bottom > off) { off = r.bottom; }
    });
    return off;
  }
  function feedClamp(bd) {
    if (bd._pfClamp || !bd.isConnected) { return; }
    if (bd.closest('.pfeed, [data-pfeed-open]')) { return; }
    clampBody(bd, { cls: 'pf-more-card pf-more-feed', anchor: 1, noBodyTap: 1, after: function (bd, mb) {
      mb.addEventListener('click', function () {          // runs AFTER tgl (registered first)
        if (mb.getAttribute('aria-expanded') === 'true') { return; }
        if (mb.getBoundingClientRect().top >= 0) { return; }
        var card = bd.closest('.post') || bd;
        window.scrollBy(0, card.getBoundingClientRect().top - stickyTop() - 8);
      });
    } });
    // clampBody measures in a rAF and un-latches (_pfClamp = 0) on a body with no layout box.
    // Re-observe such a body so it is measured again when it next comes into range; a few tries
    // only, so a body that can never be laid out does not keep the observer busy forever.
    requestAnimationFrame(function () { requestAnimationFrame(function () {
      if (bd._pfClamp || !bd.isConnected || !feedIO) { return; }
      bd._pfTries = (bd._pfTries || 0) + 1;
      if (bd._pfTries <= 3) { bd._pfWatch = 0; feedWatch(bd); }
    }); });
  }
  function feedWatch(bd) {
    if (bd._pfWatch || bd._pfClamp) { return; }
    // decided ONCE, before the observer ever sees it: the viewer's cards (same partial, same class)
    // arrive constantly and are never this surface's business; nor is the permalink's own card.
    if (bd.closest('.pfeed, [data-pfeed-open]')) { bd._pfWatch = 1; return; }
    bd._pfWatch = 1;
    if (!('IntersectionObserver' in window)) { feedClamp(bd); return; }
    if (!feedIO) {
      feedIO = new IntersectionObserver(function (ents) {
        ents.forEach(function (en) {
          // a card the pager or the roll's pruner dropped: let go of it (it reports non-intersecting)
          if (!en.target.isConnected) { feedIO.unobserve(en.target); return; }
          if (!en.isIntersecting) { return; }
          feedIO.unobserve(en.target);
          feedClamp(en.target);
        });
      }, { rootMargin: '100% 0px 200% 0px' });
    }
    feedIO.observe(bd);
  }
  function feedScan(root) {
    if (!root || !root.querySelectorAll) { return; }
    if (root.matches && root.matches(FEED_BODY)) { feedWatch(root); return; }
    Array.prototype.forEach.call(root.querySelectorAll(FEED_BODY), feedWatch);
  }
  window.__rovaClampInit = feedScan;
  function wireFeed() {
    // No page gate: a profile that renders with an empty tab still fills its list by AJAX, and the
    // observer is the cheap half (it only ever LOOKS for the class; the measuring waits for the IO).
    feedScan(document);
    try {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var added = muts[i].addedNodes;
          for (var j = 0; j < added.length; j++) { if (added[j].nodeType === 1) { feedScan(added[j]); } }
        }
      }).observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', wireFeed); }
  else { wireFeed(); }
})();

/* ---- THE TRIP CARD STARTS MINIMIZED IN THE IMMERSIVE VIEWER --------------------
   Owner, 2026-08-18: "The city thing is too large and should start minimized or
   something." Collapsed it is the pin line alone -- "📍 Atlanta, Georgia" as one
   pill; expanded it is the card exactly as it renders today, map and all.

   IT SITS HERE, BESIDE THE CAPTION CLAMP, BECAUSE IT IS THE SAME AFFORDANCE. The
   viewer has precisely one expand control -- clampBody's more/less pill above --
   and this copies its contract rather than inventing a second one:
     * collapsed is the DEFAULT and open is a CLASS (.trip-open :: .pf-open), so the
       server renders one markup and CSS decides the state per surface,
     * a real <button> with aria-expanded + aria-controls, whose aria-label CONTAINS
       what it does (label-in-name, same as the pill's "more, show the full post"),
     * the whole collapsed row toggles too, exactly as .body.pf-clamp does beside
       its pill, with the same two guards: never swallow a link, and never collapse
       under someone who is selecting text,
     * TAP AGAIN TO CLOSE, and nothing else closes it. No outside-tap, no timeout.
       The caption does not auto-collapse and neither should this: a reader who
       opened the map is looking at the map. "Get out of my way" is ALREADY solved
       one layer down -- .trip is in the .pfeed-idle fade list (rova.css), which
       takes the card to opacity 0 + pointer-events:none whenever nobody is
       touching the screen, and inherits the 120s engagement hold for free. A
       timeout here would be a second, conflicting owner of the same intent.

   NO PER-CARD WIRING, ONE DELEGATED LISTENER. Viewer cards are AJAX-injected
   _post.php output and are pruned and rebuilt as the reader swipes, so a listener
   bound at load time would miss every card but the first; delegation is what the
   rest of the pfeed's server-rendered interactions already use. It also means the
   state is per ELEMENT: swiping away and back keeps a card open, and a card the
   pruner rebuilds comes back collapsed, which is the same lifetime .pf-open has.

   SCOPED TO .pfeed, HARD. Outside the viewer .trip-body is always visible and
   .trip-toggle is display:none, so there is nothing to toggle -- and, more to the
   point, in the FEED a click on the card must keep reaching the card-tap handler
   that opens the viewer. The .pfeed test is what guarantees that; the stopPropagation
   below only ever runs on a surface where the card is the thing being read. */
(function () {
  function tripSet(trip, open) {
    /* THE MAP IS FETCHED ON THE FIRST OPEN, never before (2026-09-30). views/_trip.php
       ships the /tmap/ PNG as data-src with NO src, on every surface, because every
       surface now renders the card collapsed. Hydrated BEFORE the class flips so the
       request starts in the same task as the tap. The box is reserved by .trip-map's
       aspect-ratio, so the image landing moves nothing. */
    if (open) {
      var im = trip.querySelector('.trip-map img[data-src]');
      if (im) { im.src = im.getAttribute('data-src'); im.removeAttribute('data-src'); }
    }
    trip.classList.toggle('trip-open', open);
    var b = trip.querySelector('.trip-head > .trip-toggle');
    if (b) {
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      b.setAttribute('aria-label', open ? 'Hide the map and place details'
                                        : 'Show the map and place details');
    }
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) { return; }
    var head = t.closest('.trip-head');
    if (!head) { return; }
    var trip = head.closest('.trip');
    if (!trip || !trip.closest('.pfeed')) { return; }   // the viewer, and only the viewer
    /* NOTHING TO OPEN, NOTHING TO TOGGLE (2026-08-31). A check-in with no map, no
       facts and no country is now a HEAD ROW AND NOTHING ELSE -- views/_trip.php
       omits the .trip-body and the chevron together, because a control that opens
       an empty box is worse than no control. Without this guard a tap on such a
       card would still add .trip-open, which would swap the bare pill for the full
       glass skin wrapped around the one row that was already there. */
    if (!trip.querySelector('.trip-body')) { return; }
    if (t.closest('a')) { return; }                     // a link in the head stays a link
    // Someone highlighting the place name is READING it, not tapping it -- the same
    // guard clampBody's body-tap handler carries, for the same reason.
    if (window.getSelection && String(window.getSelection())) { return; }
    e.preventDefault();
    // The pfeed's own card/pager click handling must not also fire. Note this stops
    // CLICK only: wake() listens on pointerdown/touchstart/pointermove, so a tap on a
    // faded card still wakes the chrome exactly as it does anywhere else -- and while
    // the chrome IS faded the card is pointer-events:none, so this handler cannot run
    // at all and the first tap can only ever be a wake.
    e.stopPropagation();
    tripSet(trip, !trip.classList.contains('trip-open'));
  });

  /* ---- THE TIMELINE CARD STARTS MINIMIZED TOO (owner, 2026-09-30) --------------
     "The web shows the place expanded in a default form, but it should be minimized
     in its default form like the app." The feed card and the permalink card are now
     the app's feed pill: pin, name, PLACE, chevron; one tap opens the map, the member
     line and the globe button in place (grid-rows 0fr -> 1fr, rova.css "TIMELINE
     PILL"), and a tap again closes it. Nothing is remembered: server-rendered closed.
     CAPTURE PHASE ON DOCUMENT, and that is load-bearing. The feed's card-tap handler
     (main IIFE, "tap a post card ... open the inline comments") is a BUBBLE listener
     on document registered long before this one, so a stopPropagation in bubble
     would run AFTER it had already opened the comment panel. Stopping the click in
     capture means the pill tap never reaches the card at all -- the pill is a
     control, not card body. Every OTHER tap on the card (media, caption, map, facts)
     is untouched and keeps doing what it did. The viewer keeps its own bubble handler
     above (its hands-free engage pause listens in capture on the viewer box, which a
     document-capture stop would starve). */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) { return; }
    var head = t.closest('.trip-head');
    if (!head) { return; }
    var trip = head.closest('.trip');
    if (!trip || trip.closest('.pfeed')) { return; }     // the viewer is handled above
    if (!trip.querySelector('.trip-body')) { return; }   // nothing to open: stays card body
    if (t.closest('a')) { return; }
    if (window.getSelection && String(window.getSelection())) { return; }
    e.preventDefault();
    e.stopPropagation();
    tripSet(trip, !trip.classList.contains('trip-open'));
  }, true);
})();

/* ---- Instagram-style vertical profile feed (grid tap -> full post cards) ----------
   A full-screen overlay that AJAX-loads a profile's posts as our normal feed cards
   (avatar, media, like/comment/repost icons, the rolling comment row, custom video
   player) starting at the tapped post, with infinite scroll for the rest. Reuses the
   server's _post.php, so every interaction is wired by the existing delegated handlers
   and the document.body MutationObservers (videos/carousels self-wire). */
(function () {
  var box = null, scroller = null, list = null, sentinel = null, io = null;
  var cur = null;   // { user, tab, offset, more, loading }
  var pfLastArrive = '';   // the last post id updateFeedBar announced as an arrival (rova:pfpost); reset per open
  var idleT = null;
  // rfetch (deadline + reject on non-2xx) is defined in the MAIN IIFE at the top of this file. This is a
  // separate top-level IIFE and shares nothing with it but `window`, so alias it back in. The fallback
  // matters: the main IIFE returns early on the canonical-host redirect and never publishes, and this
  // viewer must not throw in that window. See the block next to rfetch's definition for why any of it
  // exists at all.
  function rfetch(u, o, ms) { return window.__rovaFetch ? window.__rovaFetch(u, o, ms) : fetch(u, o); }
  // How far below the fold the sentinel observer looks (px). loadMore() keeps the rendered buffer at
  // least this deep, which also keeps the sentinel pushed out to the margin edge so the observer can
  // re-arm on scroll -- the two MUST stay coupled, or a warm-up-sized buffer leaves the sentinel stuck
  // permanently inside the margin and the observer never re-fires (see loadMore()'s buffer chain).
  var PFEED_SENTINEL_MARGIN = 9000;
  var PFEED_BUFFER_AHEAD    = PFEED_SENTINEL_MARGIN;
  // Warm the NEXT TWO / previous two photos ahead of the swipe. Videos get this via warmIO (~2 posts lead);
  // photos had NOTHING -- a pfeed <img loading="lazy"> only starts loading once it's about in view, and
  // iOS/WebKit honours lazy far more strictly (smaller preload margin) than desktop, so on iPhone swiping
  // to the next photo showed a blank that only THEN began fetching a ~0.5-1MB original ("instant on
  // computer, slow on iPhone"). This forces the fetch + an off-main-thread decode() ahead so the
  // bitmap is ready to paint the instant it scrolls in.
  //   200% (~2 posts) is deliberately CLAMPED to the live-recycle window (KEEP=2, owner: "the next 2 posts
  //   at LEAST cached, downloaded and ready -- the top of the next post drags up already painted"). The old
  //   300% pre-decoded photos PAST the keep window that recyclePfeedMedia then unloaded -- a warm<->unload
  //   CHURN that also held extra multi-MB bitmaps in memory. Matching the warm lead to the keep window means
  //   only the current +/-2 photos are ever decoded. Videos (warmIO) are clamped the same way.
  // LAZY + rooted AT THE SCROLLER (ensurePfWarmIOs, called by build()): a viewport-rooted rootMargin does NOT
  // pierce the .pfeed-scroll overflow clip, so these margins never fired for anything scrolled below the
  // viewer's visible box -- the photo lookahead only "worked at the beginning" (the pre-layout stack at open).
  var pfImgWarmIO = null, pfBytesIO = null;
  function ensurePfWarmIOs() {
    if (pfImgWarmIO || !('IntersectionObserver' in window) || !scroller) return;
    pfImgWarmIO = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        if (!en.isIntersecting) return;
        var img = en.target;
        pfImgWarmIO.unobserve(img);
        // unobserve is a CLAIM taken before we know the bytes arrive. If this photo fails (and on a flaky
        // link it will), nothing ever looks at it again and it is blank for the rest of the session --
        // even though it is a post the reader is about to swipe onto. Re-observe once, on error.
        // CAPPED at 2: observe() on an element that is already intersecting fires the callback again
        // immediately, so an unbounded re-arm against a permanently-dead URL is a tight retry loop.
        if (!img._pfReArm) {
          img._pfReArm = 1;
          img.addEventListener('error', function () {
            if ((img._pfTry = (img._pfTry || 0) + 1) > 2) { return; }
            try { pfImgWarmIO.observe(img); } catch (e) {}
          });
        }
        if (img.dataset && img.dataset.pfSrc) { pfRestoreImg(img); }   // a recycled-away photo coming back: reload it
        /* SAY IT IS URGENT, not just un-deferred (2026-08-12). This observer's whole margin is the
           +/-PF_LA keep window -- a photo reaching it is one or two swipes from being looked at --
           yet all `loading = 'eager'` does is stop the browser DEFERRING the fetch; it still joins
           the queue as an ordinary image behind whatever speculation is already on the wire. On a
           fling that queue is long: measured 306 requests behind a 12-post burst at 1.6Mbps, and
           9.7 SECONDS from the last swipe to the landed post's own photo being decoded and shown --
           the owner's "it takes a few seconds to catch up", nearly all of it spent waiting in line.
           Set before `loading`, because the fetch starts the moment the deferral is lifted and a
           priority set afterwards is a hint about a request that has already gone out.
           Ignored where unsupported (Safari today), which is why it is stated unconditionally: it
           can only reorder a queue, never add a request or change which bytes are asked for. */
        try { if ('fetchPriority' in img) { img.fetchPriority = 'high'; } } catch (e) {}
        if (img.getAttribute('loading') === 'lazy') { img.loading = 'eager'; }   // kick the deferred fetch now
        try { if (img.decode) { img.decode().catch(function () {}); } } catch (e) {}   // pre-decode for instant paint
      });
    }, { root: scroller, rootMargin: ((window.__rovaPfLA || 2) * 100) + '% 0px ' + ((window.__rovaPfLA || 2) * 100) + '% 0px' });   // lead = PF_LA posts, matched to KEEP (no warm<->unload churn)
  // BYTE-PREFETCH (owner: "immediately start downloading potential swiped-to posts... keeping memory optimal to
  // prevent the browser from crashing"). This is deliberately SEPARATE from pfImgWarmIO: that one FETCHES +
  // DECODES only +/-1 post so RAM stays bounded (decoded ~1080px bitmaps are several MB each -- unbounded
  // decoding is what crashes the tab). This one only pulls the display-variant BYTES into the HTTP cache
  // several posts ahead -- disk-backed, so it costs ~zero RAM and can look much further out. When you swipe
  // there the <img> loads instantly from cache and only THEN decodes (still gated to +/-1 by pfImgWarmIO +
  // recyclePfeedMedia). fetch(no-cors) warms the cache without ever holding a bitmap; low priority so it never
  // fights the post you're on. So: buttery swiping AND bounded memory.
    pfBytesIO = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        if (!en.isIntersecting) { return; }
        // SLOW-LINK GATE (2026-07-29). Every other speculative prefetcher in this file is gated -- the
        // grid ahead-warm is desktop-only, the display-variant pump holds low-priority jobs, the HLS
        // pre-warm now checks the line -- and this one, the widest of the lot (~6 posts of FULL-SIZE
        // images at 600% rootMargin, unqueued and uncapped), was simply missed. On a measured-slow line
        // that is megabytes of photos nobody has reached yet, taken straight out of the budget of the
        // post being looked at right now. Skip WITHOUT unobserving, so it is a no-op for this crossing
        // and retries naturally when the photo leaves and re-enters the margin on a better link -- no
        // timer, no re-fire loop. The ±PF_LA decode warm above is untouched, so the next couple of posts
        // still load ahead; it is only the deep 6-post byte buffer that stands down.
        if (window.__rovaNetSlow && window.__rovaNetSlow()) { return; }
        /* CALM GATE (2026-08-12) -- the owner's "swiping fast or too far makes the site unusable and
           it takes a few seconds to catch up".
           MEASURED, 20-post fling on the nojumper grid at 4x CPU / 1.6Mbps / 300ms: 263 requests
           started inside a 20-second burst, 188 of them images -- and 118 of those images plus 72
           video ranges were ABANDONED, i.e. ~73% of the media on the wire was for posts the reader
           had already flown past. 1378 request-seconds of media, on a link that can carry about 20.
           The content pages the reader is actually BLOCKED on (the next batch of post cards) queue
           behind all of it, so the viewer dead-ends at the bottom of the rendered list: measured 6
           posts in the DOM and scrollTop pinned at the floor for TWENTY seconds while ten more
           swipes did nothing at all. That is the "few seconds to catch up", and it is a bandwidth
           queue, not a memory or decoder problem (heap peaked at 19MB).
           This observer is where the fling's cost is decided: at 600% it arms ~6 posts ahead for
           EVERY post crossed, so the deeper the fling the more of the link goes to photos nobody
           will look at. Standing it down until the swipe settles costs nothing real -- the photos it
           would have warmed are, by construction, ones the reader is flying past -- and hands the
           whole line to the post being landed on and to the next page of cards.
           The re-check TIMER, not the bare `return` the slow-link gate above uses: that gate relies
           on the photo leaving and re-entering the margin, and at 600% a flown-past photo may never
           do either, so a bare return here would drop the warm for good. Same shape as calmWarm and
           the grid's `settled` -- re-checked against __rovaScrollAt, one timer per image, and the
           observer claim is not taken until the work actually runs. */
        var img = en.target;
        if (img._pfBT) { return; }                     // already waiting for calm: one timer per image
        var run = function () {
          img._pfBT = 0;
          if (!img.isConnected) { return; }
          if (Date.now() - (window.__rovaScrollAt || 0) < 220) { img._pfBT = setTimeout(run, 240); return; }
          if (window.__rovaNetSlow && window.__rovaNetSlow()) { return; }   // re-ask: the line may have turned over while we waited
          /* DID IT FLY PAST WHILE WE WAITED? Deferring is only half the win. Without this the whole
             fling's worth of deferred warms fire together the moment it settles -- at exactly the
             moment the post the reader LANDED on wants the link -- so the contention is moved rather
             than removed. A photo now well behind the reader is not one they are about to swipe to,
             so it is dropped. Same judgement calmWarm makes at its own re-check, one viewport-and-a-
             half of slack for a back-swipe.
             NO unobserve and NO observe on this path, deliberately: the entry stays observed exactly
             as it is, so it re-fires on its next real CROSSING if the reader comes back -- whereas
             calling observe() on a still-intersecting element re-fires the callback immediately,
             which against a 600% margin would be a timer/skip/re-arm spin. */
          var rb = img.getBoundingClientRect();
          var bvh = (scroller && scroller.clientHeight) || window.innerHeight || 800;
          if (rb.bottom < -(bvh * 1.5)) { return; }
          pfBytesIO.unobserve(img);
          var url = img.getAttribute('src') || (img.dataset && img.dataset.pfSrc) || '';
          if (!url || /giphy\.com/i.test(url)) { return; }
          // Re-observe if the warm fails: the unobserve above is a claim, and this is the one prefetch
          // that covers photos the reader has NOT reached, so silently writing one off leaves a post
          // several swipes ahead to load from cold at the worst possible moment. Capped at 2 -- observe()
          // re-fires immediately on a still-intersecting element, so an unbounded re-arm would spin.
          /* ABORTABLE (2026-08-12), the same shape vsYield uses on the video head-start fetch: this is
             the one media request with no <img>/<video> of its own for the browser to cancel when the
             post is recycled away, so before this it ran to completion on the reader's link however
             far behind them the post had fallen. pfUnloadImg -- which recyclePfeedMedia already calls
             on everything past the keep window -- aborts it now. */
          var ac = null; try { ac = new AbortController(); img._pfBAb = ac; } catch (e) {}
          try { fetch(url, { priority: 'low', mode: 'no-cors', credentials: 'same-origin', signal: ac ? ac.signal : undefined })
                  .then(function () { if (img._pfBAb === ac) { img._pfBAb = null; } })
                  .catch(function () {
                    if (img._pfBAb === ac) { img._pfBAb = null; }
                    if (ac && ac.signal.aborted) { return; }        // WE cancelled it: not a failure to retry
                    if ((img._pfBTry = (img._pfBTry || 0) + 1) > 2) { return; }
                    try { pfBytesIO.observe(img); } catch (e) {}
                  }); } catch (e) {}
        };
        img._pfBT = setTimeout(run, 240);
      });
    }, { root: scroller, rootMargin: '600% 0px 600% 0px' });   // ~6 posts of DISK byte-prefetch ahead (zero RAM); decode stays +/-PF_LA
  }
  // Ken Burns "ease in from REST on view": the pfeed photo pan (rova.css tlPan) is an INFINITE wall-clock
  // animation, so a photo prefetched several posts ahead reaches the viewport already MID-cycle -- it appears
  // to pan FAST the instant it loads (owner: "some photos have a rapid pan after they load, scrolling the
  // pfeed"). Restart the pan from 0% (scale 1, zero velocity) when the photo actually becomes visible, so
  // every one eases in gently from rest instead of snapping straight to cruising speed. Single photos only
  // (carousel slides run the slideshow's own kb-run). While a hero is in flight the pan is frozen paused by
  // html.hz-hold, so a restart here just re-arms it at 0% and can't disturb the hero landing.
  /* IS A BOUNDED PAN ALREADY PART-WAY THROUGH ITS ONE AND ONLY PASS?
     Everything above is written for tlPan, which is INFINITE: re-arming it at 0% costs nothing, because
     it was going to keep looping either way. On TOUCH the opened photo runs pfSettle instead (rova.css),
     a SINGLE 12s pass that already starts from rest -- so a re-arm does not "ease it in from rest", it
     throws away the pass in progress and plays the whole thing again. That is the owner's report:
     "it launched and starts Ken burnsing then stops and restarts Ken burnsing". Measured on the live
     viewer: the reset below snapped scale 1.03586 -> 1.00081 mid-pan.
     Asked via the Web Animations API rather than by sniffing the animation NAME, so it stays true if the
     keyframes are ever renamed: iterations === Infinity means the legacy wall-clock pan, which keeps the
     old behaviour untouched (desktop is unaffected by any of this). A bounded pan is protected only while
     it is genuinely mid-pass -- once it has FINISHED, a re-arm is allowed again, which is what keeps
     kbIO's original job working: a photo whose pass ran out while it was still offscreen gets a fresh one
     when you actually reach it. */
  window.__rovaKbMidPass = function (im) {
    try {
      var as = im.getAnimations ? im.getAnimations() : [];
      for (var i = 0; i < as.length; i++) {
        var a = as[i], t = (a.effect && a.effect.getTiming) ? a.effect.getTiming() : null;
        if (!t || t.iterations === Infinity) { continue; }        // infinite pan: re-arm as before
        if (a.playState !== 'finished' && a.currentTime > 16) { return true; }   // past the first frame
      }
    } catch (e) {}
    return false;
  };
  var kbIO = ('IntersectionObserver' in window) ? new IntersectionObserver(function (ents) {
    ents.forEach(function (en) {
      if (!en.isIntersecting || en.intersectionRatio < 0.55) { return; }
      var img = en.target;
      if (!img.closest || !img.closest('.pfeed') || img.closest('.carousel')) { return; }
      if (window.__rovaKbMidPass(img)) { return; }             // bounded pass in flight: never interrupt it
      var now = Date.now();
      if (img._kbAt && (now - img._kbAt) < 700) { return; }   // don't thrash if it hovers at the threshold
      img._kbAt = now;
      img.style.animation = 'none';
      void img.offsetWidth;                                    // flush the reset so the keyframes restart at 0%
      img.style.animation = '';
    });
  }, { threshold: [0, 0.55] }) : null;

  /* ---- THE VIEWER'S PHOTO DRIFT, ON THE NATIVE RULE  (2026-09-30, iOS build 551 parity) -----------------
     The native viewer (RovaPhotoView.updateDrift) restored the old JS viewer's Ken Burns (#592) with ONE
     rule, and this is that rule, constant for constant, so the two clients drift the same picture the same
     way:
       from identity -> scale(1.15) translate(tx,ty) in the SCALED space, i.e. the picture's centre ends
       1.15 * (tx,ty) from rest. Default tx = -0.034 * W, ty = +0.026 * H over 11s; alt tx = +0.032 * W,
       ty = -0.024 * H over 13s (W/H = the media stage, which is the screen on a phone). FIRST LEG (rest ->
       pose) ease-OUT cubic-bezier(0,0,.58,1), then pose <-> rest ease-in-out cubic-bezier(.42,0,.58,1),
       alternate, infinite (2026-09-30, Rob "start sooner": ease-in-out left the far corner sub-pixel for
       ~800ms after the hold; ease-out moves it >1px inside ~100ms; iOS asked to match). Held at identity for 0.4s after the page becomes active (fill backwards; was 1.0s,
       iOS build 0.4s 09-30 -- Rob: "started ken burning faster"). Not before the flight lands: kbPick waits on it,
       event-driven (kbWatch), and the hold counts from the landing (startTime = now): 405-415ms measured.
       PARKS on touch / pan / pinch for the rest of that page, or when a rule stops applying: from the
       CURRENT frame back to identity, ease-out, 220ms (160ms for a rule change).
       RULES: the ACTIVE page only (.pf-cvon), a solo photo, not zoomed (tap-zoom scroller / a pinch),
       not contained (pf-uncrop), not veiled (nsfw-gate), not text_heavy, not under a flight (hz-hold /
       hz-flip / pfv-fly), not reduced-motion. Paused while the tab is hidden.
     WHAT IT REPLACES, AND WHY NOT KEYFRAMES IN rova.css: the pfeed photo ran CSS tlPan (desktop, infinite,
     started on RENDER and drifted contained photos too) and pfSettle on touch -- a 12s one-shot to 1.07
     that, MEASURED 2026-09-30, never ran at all on ODD post ids: `.post.kb-odd ... {animation-play-state:
     paused}` is (0,6,1) and out-specified the (0,5,1) `.pf-cvon ... running` grant, so half of all photos
     sat still on every phone. A CSS animation also cannot do the two things this rule needs: start 0.4s after
     ARRIVAL (not on render, which is 1-2 posts early -- the 2026-09-11 "moves left after each post"
     report) and park FROM WHATEVER FRAME IT IS ON. One Web Animation on the individual scale/translate
     properties (compositor-driven; they compose OUTSIDE the element's own transform, which is the
     --pf-cover fit + the --pf-pany crop window, so the fit is never touched) does both, and there is only
     ever ONE (`kb.cur`) -- the count budget from grid-ken-burns: the leaving page's short park is the only
     other thing that can be animating.
     THE CLOSE: close() freezes the drift where it is (kbFreeze) and __rovaHeroCollapse starts the flight
     from that frame (flyCrop `kbFull`), so the dismiss has no jump. An OPEN resets everything first
     (kbReset in __rovaFeedView) so a frozen frame can never reach the hero's landing measurement.
     The old re-arm sites (heroZoom, kbIO, hfManualNav: style.animation none -> '') are inert here: they
     touch CSS animations only, and this photo no longer has one. */
  /* 2026-10-22 (Rob, batch item 24: "Ken Burns in full screen ... each slide picking a pleasing direction based on the subject
     ... stops while the user pinches/zooms or holds"). FOUR CHANGES to the rule above, the constants below are the new spec
     (to-ios.md "## VIEWER KEN BURNS"):
       1. GALLERIES DRIFT TOO: the slide on screen in a viewer carousel is a drift candidate exactly like a solo photo (the old
          CSS kb-run only moved a slide while the slideshow PLAYED; it is off inside .pfeed now). alt = (post id + slide index) odd.
       2. A GENTLER ZOOM, AIMED AT THE SUBJECT: S 1.15 -> 1.12. The pose zooms toward a SUBJECT POINT and lets it drift PULL of the
          way toward the centre: t = -d * (S - 1 + PULL), d = the point's offset from the stage centre in painted px. The point is
          the img's data-kbf "x,y" (0..1, a server face hint -- not stamped yet) else, for a PORTRAIT picture (h > 1.05 w), the
          upper third (0.5, PORTRAIT_Y) where faces and people sit; a centred subject still gets a SIDE lateral drift
          (alternating). Anything else (landscape / square, no hint) keeps the old alternating diagonal. Every pose is clamped
          inside 0.9 x (S-1)/2 of the stage on each axis, so the cover never shows an edge.
       3. PARKED PER PICTURE, not per post: a tap parks the slide it hit, the next slide drifts again.
       4. A HOLD PAUSES: a finger / mouse resting still on the picture for HOLD_MS pauses the drift where it is; the release
          resumes it from that frame. (A swipe never pauses or parks -- the 2026-10-01 rule below stands.) */
  var PFKB = { S: 1.12, TX: -0.034, TY: 0.026, DUR: 11000, TXA: 0.032, TYA: -0.024, DURA: 13000,
               PULL: 0.25, PORTRAIT_Y: 0.36, SIDE: 0.018, HOLD_MS: 350, HOLD_SLOP: 10, SC: 1.06,
               DELAY: 400, PARK: 220, PARK_RULE: 160, EASE: 'cubic-bezier(.42,0,.58,1)', EASE0: 'cubic-bezier(0,0,.58,1)', PARK_EASE: 'ease-out' };
  var kb = { cur: null, parkedUnit: null, retryT: 0, tries: 0, frozen: false, mo: null, moOn: false, held: false, holdT: 0, hx: 0, hy: 0 };
  /* EVENT-DRIVEN ARM (2026-09-30, replaces a 150ms kbSync poll that added 0-220ms, so the drift began
     0.44-0.73s after landing instead of a flat 0.4s -- Rob: "sooner and consistently"). A pick that has
     to WAIT (flight / fit / pinch) is decided entirely by CLASS attributes: the flight by html.hz-hold /
     hz-flip / pfv-fly (lifted by heroRelease at the landing, __rovaHeroReset, unflip, pfStillSync), the
     fit by .media.pf-zoomable, the pinch by .media.pinching. So while waiting, ONE MutationObserver
     watches <html>'s class and the active page's subtree (class + childList: a re-rendered img/media)
     and re-runs kbSync in the microtask right after the release -- the 0.4s hold is armed at the exact
     landing, whichever path lifts it. Off again on every kbSync / kbFreeze / kbReset. No MO: old poll. */
  function kbWatchOff() {
    if (kb.moOn) { kb.moOn = false; try { kb.mo.disconnect(); } catch (e) {} }
  }
  function kbWatch(p) {
    if (typeof MutationObserver !== 'function') {
      if (kb.tries++ < 40) { kb.retryT = setTimeout(kbSync, 150); }
      return;
    }
    if (!kb.mo) { kb.mo = new MutationObserver(function () { if (kb.moOn) { kbSync(); } }); }
    try {
      kb.mo.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
      kb.mo.observe(p, { attributes: true, attributeFilter: ['class'], subtree: true, childList: true });
      kb.moOn = true;
    } catch (e) { kbWatchOff(); }
  }
  var kbMq = null;   // ONE MediaQueryList: kbSync runs on every pfCvOn pass, so no per-call matchMedia()
  try { kbMq = window.matchMedia ? matchMedia('(prefers-reduced-motion: reduce)') : null; } catch (e) { kbMq = null; }
  function kbReduced() { return !!(kbMq && kbMq.matches); }
  function kbFlight() {
    var c = document.documentElement.classList;
    return c.contains('hz-hold') || c.contains('hz-flip') || c.contains('pfv-fly');
  }
  // the active page's drift candidate: { u, im } when every rule holds; else { why } (transient -> retried)
  function kbPick(p) {
    if (!p) { return { why: 'nopage' }; }
    var m = p.querySelector('.media'); if (!m) { return { why: 'notphoto' }; }
    var u = m, im = null;
    if (m.classList.contains('carousel')) {
      // a gallery: the slide ON SCREEN is the candidate (batch item 24); a clip slide owns its own frame
      var sl = m.querySelectorAll('.cslide:not(.pf-xghost)'), ci = m.__cidx ? m.__cidx() : 0;
      u = sl[ci] || null;
      if (!u || u.querySelector('video')) { return { why: 'notphoto' }; }
      im = u.querySelector('img:not(.pfv-img)');
    } else {
      im = m.querySelector(':scope > img:not(.pfv-img)');
    }
    if (!im) { return { why: 'notphoto' }; }
    if (im.classList.contains('text-heavy')) { return { why: 'text' }; }
    if (m.classList.contains('nsfw-gate') || u.classList.contains('nsfw-gate')) { return { why: 'veiled' }; }
    if (kbReduced()) { return { why: 'reduced' }; }
    if (m.classList.contains('pinching') || u.classList.contains('pinching')) { return { why: 'zoomed', wait: 1 }; }
    if (kbFlight()) { return { why: 'flight', wait: 1 }; }
    if (!u.classList.contains('pf-zoomable')) { return { why: 'unfitted', wait: 1 }; }   // fit lands async
    /* CONTAINED PHOTOS DRIFT TOO, GENTLER (batch item 24, "photos should do a Ken Burns move in full screen"): a whole-frame photo
       (pf-uncrop -- every portrait on desktop, squares and landscapes on a phone) used to sit still, so on a desktop no viewer
       photo ever moved. It now zooms to SC with the diagonal measured on the PAINTED picture, not the stage; the letterbox is
       already showing, so there is no edge to protect. Text-heavy photos stay still (above). */
    var contained = u.classList.contains('pf-uncrop');
    if (u.classList.contains('pf-vscroll')) { return { why: 'zoomed' }; }
    return { u: u, im: im, contained: contained };
  }
  // THE PARK: from the frame on screen back to identity. Reads the computed pair BEFORE cancelling (the
  // cancel would drop it), then plays a short fill-less tween whose end state IS the element's base style.
  // TWO ANIMATIONS, ONE DRIFT: c.a0 = the first leg, c.a = the loop (kbStart). These treat them as one.
  function kbAnims(c) { var l = []; if (c) { if (c.a0) { l.push(c.a0); } if (c.a) { l.push(c.a); } } return l; }
  function kbPause(c) { kbAnims(c).forEach(function (a) { try { a.pause(); } catch (e) {} }); }
  function kbResume(c) {   // both back on ONE start time, so the leg-1 -> loop hand-off stays seamless
    var l = kbAnims(c), ct = null;
    try { ct = l.length ? l[0].currentTime : null; } catch (e) {}
    l.forEach(function (a) {
      try { if (ct != null && performance.now) { a.startTime = performance.now() - ct; } else { a.play(); } } catch (e) { try { a.play(); } catch (e2) {} }
    });
  }
  function kbParkTo(c, ms) {
    if (!c) { return; }
    var l = kbAnims(c); c.a = null; c.a0 = null;
    if (!l.length) { return; }
    var sc = 'none', tr = 'none';   // the COMPOSITED frame: leg 1, the loop, or the hand-off -- whichever is on screen
    try { var cs = getComputedStyle(c.im); sc = cs.scale; tr = cs.translate; } catch (e) {}
    l.forEach(function (a) { try { a.cancel(); } catch (e) {} });
    var still = (!sc || sc === 'none' || Math.abs(parseFloat(sc) - 1) < 1e-4) && (!tr || tr === 'none' || !/[1-9]/.test(tr));
    if (still || !c.im.isConnected || kbReduced() || document.hidden) { return; }
    try {
      c.pk = c.im.animate([{ scale: sc === 'none' ? '1' : sc, translate: tr === 'none' ? '0px 0px' : tr },
                           { scale: '1', translate: '0px 0px' }], { duration: ms, easing: PFKB.PARK_EASE });
      c.pk.id = 'pfKbPark';
    } catch (e) {}
  }
  // THE SUBJECT POINT (0..1 of the picture): a server hint, else the upper third of a portrait; null = no subject known
  function kbSubject(im) {
    var h = im.getAttribute('data-kbf');
    if (h) {
      var q = h.split(','), x = parseFloat(q[0]), y = parseFloat(q[1]);
      if (isFinite(x) && isFinite(y)) { return { x: Math.max(0, Math.min(1, x)), y: Math.max(0, Math.min(1, y)), src: 'hint' }; }
    }
    // the stamped width/height (views/_post.php) answer before the bitmap decodes -- a slide reached early has no natural size yet
    var nw = im.naturalWidth || (+im.getAttribute('width') || 0), nh = im.naturalHeight || (+im.getAttribute('height') || 0);
    if (nw > 0 && nh > nw * 1.05) { return { x: 0.5, y: PFKB.PORTRAIT_Y, src: 'portrait', nw: nw, nh: nh }; }
    return null;
  }
  // THE POSE: where the drift ends (px, the translate that composes with scale S around the picture's centre)
  function kbPose(im, W, H, alt, contained) {
    var S = PFKB.S, lim = (S - 1) / 2 * 0.9, sj = kbSubject(im), tx, ty, src = 'alt';
    if (contained) {
      // the PAINTED picture inside the stage: object-fit contain
      var cw = im.naturalWidth || (+im.getAttribute('width') || W), ch = im.naturalHeight || (+im.getAttribute('height') || H);
      var k = Math.min(W / cw, H / ch), pw = cw * k, ph = ch * k;
      S = PFKB.SC;
      tx = (alt ? PFKB.TXA : PFKB.TX) * pw * S; ty = (alt ? PFKB.TYA : PFKB.TY) * ph * S;
      return { tx: tx, ty: ty, src: 'contained', S: S };
    }
    if (sj) {
      var nw = sj.nw || im.naturalWidth || (+im.getAttribute('width') || W), nh = sj.nh || im.naturalHeight || (+im.getAttribute('height') || H);
      var sc = Math.max(W / nw, H / nh);
      var dx = Math.max(-W / 2, Math.min(W / 2, (sj.x - 0.5) * nw * sc));
      var dy = Math.max(-H / 2, Math.min(H / 2, (sj.y - 0.5) * nh * sc));
      tx = -dx * (S - 1 + PFKB.PULL); ty = -dy * (S - 1 + PFKB.PULL);
      if (Math.abs(tx) < 0.01 * W) { tx = (alt ? 1 : -1) * PFKB.SIDE * W; }   // a centred subject still drifts a little sideways
      src = sj.src;
    } else {
      tx = (alt ? PFKB.TXA : PFKB.TX) * W * S; ty = (alt ? PFKB.TYA : PFKB.TY) * H * S;
    }
    tx = Math.max(-lim * W, Math.min(lim * W, tx)); ty = Math.max(-lim * H, Math.min(lim * H, ty));
    return { tx: tx, ty: ty, src: src, S: S };
  }
  function kbStart(p, u, im, contained) {
    var W = u.clientWidth || window.innerWidth, H = u.clientHeight || window.innerHeight;
    // alt = (POST ID + slide index) odd, the iOS rule; a single photo is slide 0 (carousel slides: kenBurns).
    // Post id, not page index: stable under loadBefore prepends / pruning (see the kb-odd note in fitPfeedMedia)
    var si = 0;
    if (u.classList.contains('cslide') && u.parentNode) { si = Math.max(0, Array.prototype.indexOf.call(u.parentNode.querySelectorAll(':scope > .cslide'), u)); }
    var alt = (((parseInt(p.getAttribute('data-view'), 10) || 0) + si) % 2) === 1;
    var pose = kbPose(im, W, H, alt, contained), tx = pose.tx, ty = pose.ty, S = pose.S;
    var c = { p: p, u: u, im: im, a0: null, a: null, pk: null, src: pose.src }, d = alt ? PFKB.DURA : PFKB.DUR;
    var K = [{ scale: '1', translate: '0px 0px' },
             { scale: String(S), translate: tx.toFixed(2) + 'px ' + ty.toFixed(2) + 'px' }];
    /* FIRST LEG EASES OUT (2026-09-30). Leg 1 = rest -> pose, ease-OUT, after the hold (fill both: identity
       through the hold, the pose after it). The loop = pose -> rest -> pose ..., ease-in-out, created SECOND
       so it composites ON TOP, with delay = hold + d and fill none: invisible until the exact instant leg 1
       ends, then it owns the frame from the pose (alternate-reverse starts at the last keyframe). Both ride
       ONE start time, so the hand-off needs no event and cannot gap; leg 1's finish just cancels it (only
       one animation lives after that). Both velocities are 0 at the pose: no kink at the seam. */
    try {
      c.a0 = im.animate(K, { duration: d, delay: PFKB.DELAY, easing: PFKB.EASE0, fill: 'both' });
      c.a0.id = 'pfKb';
      c.a = im.animate(K, { duration: d, delay: PFKB.DELAY + d, iterations: Infinity,
                            direction: 'alternate-reverse', easing: PFKB.EASE, fill: 'none' });
      c.a.id = 'pfKb';
    } catch (e) { kbAnims(c).forEach(function (a) { try { a.cancel(); } catch (e2) {} }); return; }   // no WAAPI / individual transforms: no drift
    // THE HOLD COUNTS FROM NOW, not from whenever the busy open next commits a frame (a pending play
    // resolves its start time at the next frame, which during an open is 40-140ms away).
    try { if (document.timeline && performance.now) { var t0 = performance.now(); c.a0.startTime = t0; c.a.startTime = t0; } } catch (e) {}
    var a0 = c.a0;
    a0.onfinish = function () { if (c.a0 === a0) { c.a0 = null; try { a0.cancel(); } catch (e) {} } };
    kb.cur = c;
  }
  function kbSync() {
    clearTimeout(kb.retryT); kb.retryT = 0; kbWatchOff();
    if (!box || !list || !box.classList.contains('show') || pfPhase === 'closing' || kb.frozen) { return; }
    if (kb.cur && !kb.cur.im.isConnected) { kb.cur = null; }
    var p = list.querySelector('.post.pf-cvon');
    var t = kbPick(p);
    // parked PER PICTURE (batch item 24): leaving the post, or landing on another slide of it, lifts the park
    if (kb.parkedUnit && (!p || !p.contains(kb.parkedUnit) || (t.u && t.u !== kb.parkedUnit))) { kb.parkedUnit = null; }
    if (kb.cur) {
      if (kb.cur.p === p && t.im === kb.cur.im) {                    // same page, rules hold: keep drifting
        if (kb.cur.a) { try { if (document.hidden) { kbPause(kb.cur); } else if (kb.cur.a.playState === 'paused') { kbResume(kb.cur); } } catch (e) {} }
        return;
      }
      kbParkTo(kb.cur, PFKB.PARK_RULE);                              // page changed, or a rule stopped applying
      kb.cur = null;
    }
    if (!p || (t.u && kb.parkedUnit === t.u)) { return; }
    if (!t.im) {
      if (t.wait) { kbWatch(p); }                                    // flight / fit / pinch: re-run on its release
      return;
    }
    kb.tries = 0;
    if (document.hidden) { return; }                                 // visibilitychange re-syncs
    kbStart(p, t.u, t.im, !!t.contained);
  }
  // touch / pan / pinch on the active page: park for the rest of that page
  function kbPark(el) {
    if (!box || !box.classList.contains('show') || pfPhase === 'closing' || kb.frozen) { return; }
    var p = list && list.querySelector('.post.pf-cvon');
    if (!p || !el || !p.contains(el)) { return; }
    var u = p.querySelector('.media');
    if (!u || !(u === el || u.contains(el))) { return; }            // the picture, not the caption / chrome
    kb.parkedUnit = (kb.cur && kb.cur.p === p) ? kb.cur.u : (kbPick(p).u || u);
    if (kb.cur && kb.cur.p === p) { kbParkTo(kb.cur, PFKB.PARK); kb.cur = null; }
  }
  window.__rovaPfKbPark = kbPark;
  function kbFreeze() {                                              // close(): hold the frame the flight starts from
    kb.frozen = true; clearTimeout(kb.retryT); kb.retryT = 0; kbWatchOff();
    var c = kb.cur;
    if (!c) { return; }
    kbPause(c);
    try { if (c.pk && c.pk.playState === 'running') { c.pk.pause(); } } catch (e) {}
  }
  function kbReset() {                                               // open / finalize: nothing survives into a new viewer
    clearTimeout(kb.retryT); kb.retryT = 0; kb.tries = 0; kbWatchOff();
    var c = kb.cur; kb.cur = null; kb.parkedUnit = null; kb.frozen = false; kb.held = false; clearTimeout(kb.holdT);
    if (c) {
      kbAnims(c).forEach(function (a) { try { a.cancel(); } catch (e) {} });
      try { if (c.pk) { c.pk.cancel(); } } catch (e) {}
    }
  }
  window.__rovaPfKbSync = kbSync;
  window.__rovaPfKbState = function () {   // rig/debug read-out
    var c = kb.cur;
    return { post: c ? c.p.getAttribute('data-view') : null, state: c && c.a ? c.a.playState : null, leg1: !!(c && c.a0),
             parked: kb.parkedUnit ? ((kb.parkedUnit.closest('.post') || kb.parkedUnit).getAttribute('data-view')) : null, frozen: kb.frozen, K: PFKB,
             unit: c ? (c.u.classList.contains('cslide') ? 'slide' : 'solo') : null, src: c ? c.src : null, held: kb.held };
  };
  /* A SWIPE NEVER PARKS THE DRIFT; A TAP STILL DOES (2026-10-01, Rob on iPhone Safari: "my swipes/scrolls stop
     the Ken Burns"). This used to park on TOUCHSTART / MOUSEDOWN anywhere on the picture -- i.e. at the first
     contact of EVERY gesture, so the pager swipe that springs back, a sideways drag, and the first half of a
     swipe to the next post all froze the photo back to rest for the rest of that page. MEASURED before
     (scratchpad kbscroll/kbrig.js, Chromium 393 touch, CDP finger drags): during a 40px hold-drag the drift
     eased to identity in ~220ms and the animation clock never ran again on that page (0% of 50ms steps
     advanced in the 1.2s after release; same in WebKit). The gestures that really are INSPECTION park
     themselves at the moment they engage, so the generic contact park was only ever catching swipes:
       pinch      -> the pinch-to-peek touchstart (2 fingers) calls __rovaPfKbPark
       crop pan   -> panning(u, true) calls __rovaPfKbPark once the drag LOCKS to the photo's crop axis
       tap        -> this click listener (a click is only synthesised for a contact that did not travel, so
                     a swipe never produces one; that also covers the tap-zoom toggle, which is a click)
       trackpad pinch -> the ctrl-wheel line below
     So the drift composites straight through a pager drag on the compositor, and the page change itself is
     still handled by kbSync (the leaving page parks off-screen on the rule change, the arriving one starts). */
  document.addEventListener('click', function (e) { kbPark(e.target); }, true);
  document.addEventListener('wheel', function (e) { if (e.ctrlKey) { kbPark(e.target); } }, { capture: true, passive: true });   // trackpad pinch
  /* A HOLD PAUSES (batch item 24: "stops while the user ... holds"). A pointer that comes down ON the drifting picture and stays
     within HOLD_SLOP px for HOLD_MS pauses the drift on its current frame (play-state, nothing is cancelled); lifting it resumes
     from that frame. A pointer that travels first is a swipe and changes nothing (the 2026-10-01 rule). */
  function kbHoldEnd() {
    clearTimeout(kb.holdT); kb.holdT = 0;
    if (kb.held) { kb.held = false; if (kb.cur && !kb.frozen && !document.hidden) { kbResume(kb.cur); } }
  }
  document.addEventListener('pointerdown', function (e) {
    var c = kb.cur;
    clearTimeout(kb.holdT); kb.holdT = 0;
    if (!c || !c.u || !e.target || !c.u.contains(e.target) || (e.button != null && e.button > 0)) { return; }
    kb.hx = e.clientX; kb.hy = e.clientY;
    kb.holdT = setTimeout(function () { kb.holdT = 0; if (kb.cur === c && (c.a || c.a0)) { kb.held = true; kbPause(c); } }, PFKB.HOLD_MS);
  }, { capture: true, passive: true });
  document.addEventListener('pointermove', function (e) {
    if (!kb.holdT) { return; }
    if (Math.abs(e.clientX - kb.hx) > PFKB.HOLD_SLOP || Math.abs(e.clientY - kb.hy) > PFKB.HOLD_SLOP) { clearTimeout(kb.holdT); kb.holdT = 0; }
  }, { capture: true, passive: true });
  ['pointerup', 'pointercancel'].forEach(function (ev) { document.addEventListener(ev, kbHoldEnd, { capture: true, passive: true }); });
  document.addEventListener('touchend', function (e) { if (!e.touches || !e.touches.length) { kbHoldEnd(); } }, { capture: true, passive: true });
  document.addEventListener('visibilitychange', function () {
    var c = kb.cur;
    if (document.hidden) { kbPause(c); return; }
    if (kb.frozen) { return; }
    kbSync();
  });
  try {
    if (kbMq) { var _kbOn = function () { kbSync(); }; if (kbMq.addEventListener) { kbMq.addEventListener('change', _kbOn); } else if (kbMq.addListener) { kbMq.addListener(_kbOn); } }
  } catch (e) {}
  var _kbRzT = 0;
  window.addEventListener('resize', function () { clearTimeout(_kbRzT); _kbRzT = setTimeout(kbSync, 250); }, { passive: true });
  // Free / restore a far-offscreen pfeed photo's decoded bitmap. A full-screen _disp image (~1080px)
  // decodes to several MB; on iOS they accumulate until the tab is memory-starved and the viewer goes
  // unresponsive. Clearing src releases the bitmap; the stash lets us put it back instantly on approach.
  function pfUnloadImg(img) {
    /* GIVE THE LINK BACK FIRST (2026-08-12). Two speculative claims can be outstanding on a photo the
       recycle has just decided is too far away to keep: the pending calm timer from pfBytesIO, and its
       in-flight low-priority byte fetch. Neither is attached to anything the browser will cancel on
       its own -- a plain fetch() has no element to release -- so before this they carried on
       downloading a photo the reader had already flown past, on the same line the post they landed on
       is trying to load over. Dropping them here rather than in a new sweep is deliberate: this
       function is ALREADY the one thing every far-media path funnels through (recyclePfeedMedia's
       else-branch, the memory guard, pruneFarPosts by way of them), so there is one owner, not two.
       Neither drop is destructive -- pfImgWarmIO re-observes below and pfBytesIO re-arms on the next
       crossing, so a photo that comes back is warmed by the ordinary route. */
    if (img._pfBT) { try { clearTimeout(img._pfBT); } catch (e) {} img._pfBT = 0; }
    if (img._pfBAb) { try { img._pfBAb.abort(); } catch (e) {} img._pfBAb = null; }
    if (img._pfUnloaded || !img.getAttribute('src')) return;
    lqipImg(img);                                  // make sure the media's thumb placeholder is in place FIRST
    img.dataset.pfSrc = img.getAttribute('src');
    img.removeAttribute('src');
    img._pfUnloaded = 1;
    // Do NOT paint the empty img black (the old code did, "it's offscreen anyway"): a fast swipe under load
    // lands on a just-unloaded post BEFORE pfRestoreImg re-loads it, and a black img masked the LQIP thumb on
    // the media behind it -- the black flash the stress test caught (round 170). Transparent reveals the thumb.
    img.style.background = 'transparent';
    if (pfImgWarmIO) { try { pfImgWarmIO.observe(img); } catch (e) {} }   // restore as it nears the viewport again
  }
  function pfRestoreImg(img) {
    if (!img.dataset || !img.dataset.pfSrc) return;
    img.setAttribute('src', img.dataset.pfSrc);
    delete img.dataset.pfSrc;
    img._pfUnloaded = 0;
    img.style.background = '';
  }
  // Lock the page behind the overlay while it's open. Without this, a vertical swipe on a
  // single-screen post (e.g. a slideshow, where .pfeed-scroll has nothing to scroll) leaks
  // through to the timeline behind it. The shared helper preserves + restores scroll position.
  var pfLocked = false;
  /* THE VIEWER NO LONGER OWNS A WAKE LOCK (2026-09-03). It used to take its own sentinel here,
     keyed on "the overlay is open" -- which is the wrong question in both directions: it held the
     screen up over a silent PHOTO for as long as the reader lingered, and it dropped the screen the
     instant a clip that was still audible was dismissed into the timeline behind it. Two sentinels
     in two closures also meant two owners for one physical lock, and the pfeed's copy had no idea
     the header IIFE was holding one too.
     Open and close are still the right moments to RE-ASK -- they are the chokepoint every open and
     every close passes through -- so they now poke the one governor in the video engine and let it
     decide. It answers from the elements: a lock is held while, and only while, some <video> in the
     document is running and on screen inside this viewer (or on a permalink's own card) -- muted or
     not, since the reader is WATCHING. Its own visibilitychange handler covers the return to the
     foreground, so the listener that used to live here is gone with the sentinel. */
  function pfWakeOn()  { if (window.__rovaWakeSync) { try { window.__rovaWakeSync(); } catch (e) {} } }
  function pfWakeOff() { if (window.__rovaWakeTick) { try { window.__rovaWakeTick(); } catch (e) {} } }
  /* HAND THE PAGE BEHIND US A PAUSE (2026-08-09). Both openers call pfLock() and the closer calls
     pfUnlock(), so this is the one chokepoint that sees every open and every close. See __rovaBgHold in
     the video engine for the measurement: on a permalink the post-page card kept decoding the same clip
     in lockstep behind the overlay for the whole session, because the viewer is position:fixed over a
     locked body and playIO therefore never fires for the buried card.
     DEFERRED, not immediate: the hero flight re-parents and lands a clip over the first few hundred ms
     of an open, and pausing anything mid-liftoff is how a dismiss-zoom composites black. 1500ms clears
     the .3s fade and the flight with room to spare, and the leak it removes ran for the whole session,
     so the delay costs nothing measurable. Cancelled if the viewer closes first, and _bgHeld makes both
     directions idempotent, so an open/close/open burst can neither strand a pause nor double-resume. */
  var _bgHoldT = null;
  /* THE READER'S OWN PAUSES SURVIVE A VIEWER SESSION (2026-09-18). Stamped at the open chokepoint, BEFORE
     the scroll lock reflows the page (see playIO's "scrolled away" note), and re-asserted by close()'s
     resume sweep: a page clip that was paused by the reader when the viewer opened is paused -- and still
     marked as theirs -- when it closes, whatever any governor inferred from the layout churn in between.
     Enumerated, never class-selected ([[ghost-video-invisible-to-both-governors]]). */
  function pfRememberUserPauses() {
    var vids = document.getElementsByTagName('video');
    for (var i = 0; i < vids.length; i++) {
      var v = vids[i];
      if (v._userPaused && v.paused && !(v.closest && v.closest('.pfeed'))) { v._rovaUserPausedAtOpen = 1; }
    }
  }
  function pfLock()   { if (!pfLocked) { pfLocked = true;  pfRememberUserPauses(); if (window.__rovaLockScroll)   window.__rovaLockScroll(); } pfWakeOn();
                        clearTimeout(_bgHoldT);
                        _bgHoldT = setTimeout(function () { if (pfLocked && window.__rovaBgHold) window.__rovaBgHold(true); }, 1500); }
  /* THE PAGE-LAYOUT HALF OF THE UNLOCK, SEPARABLE ON PURPOSE (2026-09-13).
     THE SCROLL LOCK MOVES THE PAGE, so any rect measured while it is on is NOT the rect that
     element will occupy once the viewer is gone. `body.scroll-locked` is position:fixed, and
     rova.css's `@media(max-width:640px){body.scroll-locked .topbar{position:fixed}}` (shipped
     2026-09-12 17:11 for the header-flyout "weird blank row") takes the sticky topbar OUT OF FLOW
     for the duration -- so every in-flow box on the page rides UP by the header's flow height:
     measured 79px at 420 CSS px (.feed-layout y 79 -> 0, the avatar ring y 185.33 -> 106.33).
     close() measures its collapse destination (the grid tile, the timeline card, the profile
     avatar) while that is still true, which is why the dismiss landed 79px HIGH on every journey.
     So the close releases the page lock BEFORE it measures anything, and pfUnlock() below keeps
     the rest (wake lock, background-hold) exactly where it was. The release is invisible: the
     viewer is still .show and covers the screen, and `.pfeed` is position:fixed so nothing inside
     it moves. `pfLocked` makes the second call a no-op, so no path unlocks twice. */
  function pfUnlockPage() { if (pfLocked) { pfLocked = false; if (window.__rovaUnlockScroll) window.__rovaUnlockScroll(); } }
  function pfUnlock() { pfUnlockPage(); pfWakeOff();
                        clearTimeout(_bgHoldT);
                        if (window.__rovaBgHold) window.__rovaBgHold(false); }

  /* ======================================================================================
     THE WAKE TAP MUST ONLY WAKE (owner 2026-08-09). ONE GUARD FOR THE WHOLE VIEWER.
     ======================================================================================
     THE TRAP. wake() is bound to the whole .pfeed surface and fires on TOUCHSTART, while a
     browser resolves a tap's CLICK TARGET with a FRESH HIT TEST AFTER THE TOUCH HAS ENDED. So:

       touchstart on a faded screen -> wake() drops .pfeed-idle -> the control under the finger
       is opacity 1 / visibility visible / pointer-events auto again WITHIN THE SAME GESTURE ->
       touchend hit-tests the point -> the click is delivered to the control.

     CSS CANNOT FIX THIS, and that is the thing to understand before touching it. Every control
     below already computes `pointer-events:none` (or visibility:hidden, which is the same thing
     to a hit test) at rest -- and every one of them still actuated, because wake() undoes that
     before the click is resolved. Measured under real CDP touch at 390x844 on a fixture post,
     BEFORE this guard, one tap where each control sits while the chrome was faded:

       .pfeed-x      THE VIEWER CLOSED               .pfeed-who   NAVIGATED OFF to the profile
       .pfeed-menu   the per-post ... menu opened    .vc-play     the running slideshow stopped
       .vc-fit       fill/letterbox toggled          .pf-act#2    A REPOST WAS WRITTEN (0 -> 1)
       .pf-act#1     the comment panel opened        .pf-act#0    a LIKE was written to the DB
       .cnav.prev/next  the deck paged
       ...and every one of them armed the 120s attention hold, so the chrome then refused to
       re-idle for two minutes.

     THE TEST IS THE PRESS, NOT A TIMER. If the pointerdown that began this gesture did NOT land
     on one of these controls, then a click that lands on one is a re-target the wake caused, and
     it is dropped. A press that genuinely starts on a control (chrome awake, or a second tap
     after the wake) sets the flag and passes straight through, so nothing about normal use
     changes and there is no window to tune. It is also ORDER-INDEPENDENT: at pointerdown time
     the control is still un-hit-testable, so the press target is the media behind it whether
     this listener runs before or after wake().
       e.detail    keyboard/programmatic activation (Enter, Space, el.click()) produces a click
                   with detail 0 and no pointerdown at all. Only pointer clicks are ever guarded.
       starts true a browser that never fires pointerdown fails OPEN, to today's behaviour,
                   rather than silently swallowing every click in the viewer.
       .pfeed test  the selector below names classes that also exist on FEED cards (.body, .poll,
                   .linkcard, .croller), so the predicate is scoped to an open viewer twice over:
                   .show on the box, and a .pfeed ancestor on the target.

     THIS REPLACES the hands-free-only copy that used to live in hfBuild() (HF_CTL_SEL /
     hfPressOnCtl). There is one mechanism now, not two: the three discs are simply members of
     the list below. HF_CTL_SEL itself is deleted: it turned out this guard was its ONLY reader --
     the engagement guard and the speed popover's outside-press close both spell the same four
     classes out as literals. See the note where it used to be declared.

     THE LIST IS MEASURED, NOT ASSUMED. It is every control the idle rules in rova.css take to
     opacity 0 / visibility hidden while it still occupies a box -- enumerated in the live viewer
     at all four viewports rather than read off the stylesheet. .cdot is deliberately NOT here:
     the pagination dots stay fully VISIBLE at idle, so a tap on one is something the reader can
     see themselves doing. (A tap in the dots' band that lands on the hidden bar BEHIND them is
     covered, because that click's target is inside .vctrl.) */
  var PF_WAKE_SEL =
    // the top bar: back, identity, the per-post ... menu
    '.pfeed-bar, ' +
    // the bottom control bar in all three shapes it takes -- .media.pf-vfeed .vctrl (single
    // photo / single video), .vctrl.ph-ctrl, and the carousel's pinned .pf-cbar > .vctrl -- and
    // everything they carry: .vc-btn (play/pause, fit, fullscreen, PiP), .vc-seek, .vc-sound and
    // the four .pf-act. .pf-act is named as well as .vctrl because pfMoveActs can park those
    // four back in the post's own .bar between rebuilds.
    '.vctrl, .pf-act, ' +
    // the carousel arrows and the slide counter
    '.cnav, .ccount, ' +
    // hands-free's own stack + its speed popover (this was HF_CTL_SEL, absorbed)
    '.pf-hf-rep, .pf-hf-dock, .pf-hf-rate, .pf-hf-speeds, ' +
    // the overlaid post chrome that rides the same fade. The link card matters most: it is an
    // <a>, so an invisible one left live does not merely misfire, it NAVIGATES OFF THE SITE.
    '.post .body, .pf-more, .croller, .linkcard, .post-translate, .translation, .poll, ' +
    '.embed-music, .am-card, ' +
    // the gallery pill under the caption (2026-10-01): an <a> to the gallery page, same hazard as
    // the link card -- a wake tap re-targeted onto it would navigate away
    '.post-gallery';
  var pfPressOnCtl = true;      // did THIS gesture's pointerdown land on one? starts true = fail open
  function pfWakeRetarget(e) {
    if (pfPressOnCtl) return false;                            // a real press on a real control
    if (!e || !e.detail) return false;                         // keyboard / programmatic: never guarded
    if (!box || !box.classList.contains('show')) return false;  // no open viewer, no wake to mis-fire
    var t = e.target;
    if (!t || !t.closest) return false;
    return !!(t.closest('.pfeed') && t.closest(PF_WAKE_SEL));
  }
  /* Published on window because the two listeners that MUST also honour it live in a different
     closure of this file and run EARLIER: both are document-level CAPTURE click listeners, so
     they fire before any listener on .pfeed can stop the event. Without this the click itself
     would be dropped but the 120s attention hold would still be armed -- which is the second
     half of the damage, not a detail. See engAttendFrom's listener and the outbound-link hold. */
  window.__rovaWakeRetarget = pfWakeRetarget;

  /* ======================================================================================
     A MOUSE THAT IS SITTING STILL IS NOT A MOUSE THAT IS MOVING (owner 2026-08-14, of desktop
     Chrome: "it isn't fading out after clicking on desktop -- works fine on mobile web and the
     native app"). THE CHROME NEVER FADED FOR HIM AT ALL.
     ======================================================================================
     THE MECHANISM, MEASURED. wake() is bound to `pointermove` on the whole .pfeed surface. On a
     phone that listener only ever fires during a real finger gesture, so the 3200ms dwell runs to
     completion the moment the finger lifts -- which is why every touch surface was reported fine.
     On a DESKTOP the pointer does not leave when the reader stops: it RESTS over the media, and a
     resting mouse is not silent. An optical sensor emits 1px twitches, a trackpad emits them under
     a resting hand, and the engine itself re-delivers a move when content shifts under the cursor.
     Every one of those re-entered wake(), dropped .pfeed-idle and re-armed the full 3200ms clock.
     Reproduced against the live origin at 1440x900 with the cursor parked over the clip and fed a
     ONE-PIXEL move every 1.5s: the box never carried .pfeed-idle once in 15s (11 pointermoves, 11
     wakes) -- all chrome up, permanently, exactly the screenshot. With the same fixture and NO
     twitches it idles at 3.36s. That is the whole difference between the two platforms; nothing in
     the CSS is involved (verified separately: at idle, with a live :hover on .media, every chrome
     element in the viewer computes opacity 0 / visibility hidden and an element-by-element sweep of
     everything still painted inside .pfeed comes back empty on both Chromium and Firefox).
     THE TEST IS DISPLACEMENT FROM AN ANCHOR, NOT movementX/movementY. A synthesized move reports
     movement 0 but so does the first real move after a jump, and a 1px sensor twitch reports
     movement 1 -- neither number separates "the reader reached for the mouse" from "the mouse is
     lying on the desk". Distance from the last position we accepted does: jitter oscillates inside
     a few pixels forever and never crosses the threshold, while a deliberate move crosses it within
     one or two frames of the reader touching the mouse (a slow drag arrives as many small moves,
     each measured against the SAME anchor, so it accumulates). PF_MOVE_MIN is 5px, which is under
     the 8-10px every touch-slop and drag threshold in this file uses, so nothing a human does reads
     as a rest.
     ONLY MOUSE POINTERMOVES ARE FILTERED. pointerType touch/pen wakes on the first event and re-arms
     the anchor: a finger only produces pointermove while it is actually on the glass, so filtering it
     could only ever break the surfaces that work today. pointerdown, touchstart, keydown and the
     capture scroll listener are untouched -- a click, a key or a swipe wakes on the first event as it
     always has, and each of those re-anchors so the move test starts fresh from wherever the pointer
     then is. This is exactly a video player's rule: the controls go away while the pointer sits, and
     the smallest real movement brings them back. */
  var PF_MOVE_MIN = 5, pfMoveAt = null;
  function pfAnchorMove(e) {
    pfMoveAt = (e && typeof e.clientX === 'number') ? [e.clientX, e.clientY] : null;
  }
  function pfMoveIsReal(e) {
    if (!e || e.type !== 'pointermove') return true;                  // not a move at all
    if (e.pointerType && e.pointerType !== 'mouse') { pfAnchorMove(e); return true; }   // finger / pen
    if (typeof e.clientX !== 'number') return true;                   // nothing to measure: fail OPEN
    if (!pfMoveAt) { pfMoveAt = [e.clientX, e.clientY]; return false; }
    var dx = e.clientX - pfMoveAt[0], dy = e.clientY - pfMoveAt[1];
    if (dx * dx + dy * dy < PF_MOVE_MIN * PF_MOVE_MIN) return false;  // the mouse is resting, not moving
    pfMoveAt = [e.clientX, e.clientY];
    return true;
  }

  // fade the chrome (header + overlaid caption/actions/roller) after a few idle seconds so
  // the content plays large; any real move/tap/scroll wakes it
  function wake(e) {
    if (!box || !box.classList.contains('show')) return;
    if (!pfMoveIsReal(e)) return;      // a resting mouse must not hold the chrome up -- see above
    if (e && e.type !== 'pointermove') pfAnchorMove(e);   // a press/key re-anchors from where we are now
    // A tap ON the profile link (the "rovasocial.com/@handle" shown while idle) should NAVIGATE, not
    // wake -- if we un-idle here the label collapses out from under the finger and iOS can drop the
    // click. Leave idle as-is so the link stays put and its own click handler opens the profile.
    if (e && e.target && e.target.closest && e.target.closest('.pfeed-who')) return;
    /* THE HANDS-FREE INVITE USED TO BE DOCKED FROM HERE (2026-08-08: it no longer exists).
       The whole floating "Play the feed" card is gone -- the play control is a permanent member of
       the right-hand stack now -- so there is nothing left for a wake to get out of the way of, and
       the placement arithmetic that made this branch necessary (a bottom-anchored card measured
       against chrome it assumed was faded) went with it. Nothing replaces it: the three discs are
       absolutely positioned on the viewer, clear of every band the card had to dodge. */
    box.classList.remove('pfeed-idle');
    clearTimeout(idleT);
    /* ATTENTION HOLD (owner 2026-08-05: "if I tap a heart... don't auto hide it"). pfeed-idle fades the
       identity, the caption, the comment roller, the carousel arrows AND the control bar that carries
       the engagement row -- so on this surface it IS the auto-hide being complained about. It is not
       cancelled, only postponed: the chrome must still be able to get out of the way once the reader has
       genuinely stopped, which is the whole point of the immersive viewer. Re-checked on a 1s beat so
       the fade lands within a second of the hold lapsing, on the same .35s transition as always. */
    idleT = setTimeout(function goIdle() {
      if (!box.classList.contains('show')) return;
      // ...only a hold armed INSIDE this viewer since it opened (a feed heart before the open is the feed's -- see
      // engAttnViewer in the ATTENTION block, Rob 2026-10-17 on /p/57241)
      try { if (window.__rovaAttentionViewer && window.__rovaAttentionViewer()) { idleT = setTimeout(goIdle, 1000); return; } } catch (e) {}
      // A SCRUB IN PROGRESS KEEPS THE BAR UP (2026-09-29): a drag held still past the dwell, and the
      // two-finger trackpad scrub, which sends no pointermove at all. The scrub's release calls
      // __rovaPfWake, so the dwell restarts from the release rather than firing at the next poll.
      try { if (window.__rovaScrubLive && window.__rovaScrubLive()) { idleT = setTimeout(goIdle, 500); return; } } catch (e) {}
      box.classList.add('pfeed-idle');
    }, 3200);
  }

  /* ARM the idle clock for a FRESH OPEN. wake() cannot do this from the openers: both of them call it in
     the same turn as `requestAnimationFrame(... box.classList.add('show'))`, so at that instant .show is
     not on the box yet, wake()'s first guard returns, and no timer is ever set. Open the viewer and touch
     nothing and the chrome never faded at all; the clock only started at the reader's FIRST interaction.
     That was an ordering accident, not a "let them orient" decision: hfOpen() sits two lines below the
     same dead wake() call and had to carry an explicit note that it was deliberately NOT routed through
     the (now deleted) hfTouch() for exactly this rAF race, so the hands-free clock armed on open by
     design while the chrome clock silently did not.
     TWO conditions, both load-bearing:
       .show          the viewer is actually up. The same thing wake() itself asks.
       !pf-settling   the entry animation is OVER and the chrome has been REVEALED. pf-settling is added
                      synchronously on open and dropped by the rova:pfeedready hook only once the centred
                      media has painted AND the hero clone has landed (hz-hold cleared), with a 4000ms
                      backstop -- i.e. it can outlast the 3200ms dwell. Arming at open would therefore let
                      the dwell expire mid-flight on a slow open and hand the reader a viewer whose
                      controls faded out without ever having faded in.
     It then just calls wake(), so the very first fade runs on the SAME 3200ms delay and the SAME .35s
     transitions as every later one. There is deliberately no separate first-fade path that could drift.
     Generation-guarded on pfGen (bumped by both openers AND by close) and deadlined, so a close or a
     rapid re-open can never leave a stray poll arming the clock behind a viewer that has moved on. */
  function pfArmIdle() {
    var mine = pfGen, start = Date.now();
    window.__rovaPfOpenAt = start;                 // the attention hold the chrome fade honours starts here (engAttnViewer)
    pfMoveAt = null;                               // fresh open: re-anchor the move test from wherever the pointer lands
    if (box) box.classList.remove('pfeed-idle');   // clean baseline: a previous session's idle must not linger
    (function tick() {
      if (mine !== pfGen || !box) return;                     // a newer open, or a close, owns the clock now
      if (Date.now() - start > 6000) return;                  // the 4000ms backstop should have fired long ago
      if (!box.classList.contains('show') || box.classList.contains('pf-settling')) { setTimeout(tick, 60); return; }
      wake();
    })();
  }

  /* ======================================================================================
     THE ONE PIECE OF CHROME THE IDLE FADE COULD NOT REACH, AND IT IS THE BROWSER'S OWN.
     ======================================================================================
     Owner 2026-08-13, of Firefox: "the chrome wasn't auto-disappearing". Everything in this
     file DOES fade there -- measured in Firefox 151 against Chromium on the same post, same
     viewport, same second: .pfeed-idle lands on the box on time and every element the idle
     rules name computes opacity 0 / visibility hidden in BOTH engines, and an element-by-
     element diff of everything still painting inside .pfeed at idle came back empty. What is
     left on the screen in Firefox is not ours: Gecko floats its own "Pop out this video"
     picture-in-picture toggle over any <video> the pointer is over, and that toggle answers
     to no page style -- it lives in the UA widget, so it does not appear in the DOM at all
     and no CSS of ours can touch it. In this viewer the clip fills the screen, so the pointer
     is ALWAYS over it: the toggle simply sits there, permanently, over a video the reader
     asked to watch full-bleed. Blink has no equivalent, which is why only Firefox was
     reported. (Screenshots: pip-firefox-before-*.png vs the Chromium pair.)
     `disablepictureinpicture` IS THE ONLY HOOK, AND IT IS READ EXACTLY ONCE -- WHEN THE CLIP IS
     BOUND INTO THE DOCUMENT. That timing is the whole reason this is a function called on a
     DETACHED fragment rather than the obvious MutationObserver on .pfeed-list. Measured in
     Firefox 151 on the same 77s clip, three <video>s side by side (piptiming-*.png):
       attribute in the parsed markup .............. NO toggle
       no attribute ................................ toggle
       attribute assigned by JS AFTER insertion,
         on a clip never yet hovered ............... toggle STILL SHOWN
     An observer necessarily runs after the node is in the tree -- one microtask too late -- so
     the version of this that watched the list set the attribute on every clip in the deck
     (verified: disablePictureInPicture true on all three) and changed nothing on screen. Gecko
     re-reads it only if the element is re-bound, which for a playing clip means a reload.
     IT COSTS NOTHING TO SET, on either engine. This surface already refuses PiP: rova.css hides
     .vc-pip on every pfeed toolbar (single video, photo bar, and each carousel slide) under
     "fullscreen + PiP are redundant inside the already-immersive viewer", so the attribute only
     states in the DOM what the stylesheet already decided. And it is gated on
     document.pictureInPictureEnabled being ABSENT/false -- i.e. only where the browser offers us
     no PiP API to lose in the first place, which is precisely Firefox's case (Gecko implements
     the toggle but not the API). Blink keeps its API and its button untouched.
     NOT CLEARED ON THE WAY OUT, deliberately: the attribute is inert wherever the API is absent,
     and a clip handed back to the pool is re-bound before it is seen again, so nothing carries a
     stale refusal into a surface that does offer PiP. */
  var PF_NO_PIP = !(('pictureInPictureEnabled' in document) && document.pictureInPictureEnabled);
  /* FEED 720 (2026-10-06). A Cloudflare-processed upload's FEED card plays `<hex>_w_720.mp4` from our CDN (crossorigin,
     ~1/4 of the bytes of Cloudflare's source-size default.mp4) and carries the full file in data-src-full
     (views/_post.php). The immersive viewer is where the full file belongs, so every card entering it is pointed back
     at data-src-full HERE -- on the detached fragment, before the clip is bound, at preload="none", so it costs no
     request and no load restart. The 720 URL stays on the element as data-src-feed: the grid tap's lift-off master
     IS that file (data-master), and loadMore's donor adoption matches against it, so a clip opened from the grid
     keeps playing the element the reader is already hearing (the warm start). Same attribute set the server emits
     for a remote clip without a feed copy: data-remote, no crossorigin (Cloudflare's MP4 302s without ACAO). */
  function pfFullSrc(root) {
    if (!root || !root.querySelectorAll) return;
    var vids = root.querySelectorAll('video[data-src-full]');
    for (var i = 0; i < vids.length; i++) {
      try {
        var v = vids[i], full = v.getAttribute('data-src-full') || '', cur = v.getAttribute('src') || '';
        if (!full || full === cur) continue;
        v.setAttribute('data-src-feed', cur);
        v.removeAttribute('crossorigin');
        v.setAttribute('data-remote', '1');
        v.setAttribute('src', full);
      } catch (e) {}
    }
  }
  function pfNoPip(root) {
    pfFullSrc(root);   // FEED 720: same moment (before the bind), same four call sites -- see pfFullSrc
    if (!PF_NO_PIP || !root || !root.querySelectorAll) return;
    var vids = root.querySelectorAll('video');
    for (var i = 0; i < vids.length; i++) {
      try { vids[i].setAttribute('disablepictureinpicture', ''); } catch (e) {}
    }
  }

  function build() {
    if (box) return box;
    box = document.createElement('div');
    box.className = 'pfeed';
    /* THE BAR LIVES INSIDE THE SCROLLER, and it is there for the pan chain, not for layout.
       It is `position:absolute` and .pfeed-scroll is `position:static`, so its containing block is
       still .pfeed and it overlays the media at exactly the rect it always did -- but as a SIBLING of
       the scroller it had the defect the hands-free stack had: a touch starting on it had no
       scrollable ancestor, so a vertical swipe anywhere in the top 58px of the screen -- the full
       width of it -- moved the feed by nothing. Measured on the live site with real CDP touch
       (Input.synthesizeScrollGesture, 'touch'): control from plain media 0 -> 844 (390x844) and
       0 -> 900 (1440x900), the identical gesture from the bar left scrollTop and the centred post
       unchanged at both. That is the largest of the three dead zones by area.
       AND IT RETIRES THE iOS TRAP RATHER THAN RE-OPENING IT, which is the reason this is safe to do
       to THIS element in particular. The note on .pfeed-scroll in rova.css records that
       -webkit-overflow-scrolling:touch once promoted the scroller to its own stacking context, which
       confined the per-post .pmenu-panel inside it to the scroller's level while .pfeed-bar -- a
       sibling at z-index 12 -- painted over the open menu. That failure is a CROSS-CONTEXT
       comparison, and it is only possible while the bar is outside. With the bar inside, bar and
       panel are in the SAME context whatever that context turns out to be, so they compare 12
       against 50 directly and the panel wins either way.
       MEASURED BEFORE MOVING IT, both engines, all four viewports (zz-bar-stacking.js): every
       stacking-context-inducing computed property on .pfeed-scroll is inert -- position static,
       z-index auto, transform/filter/backdrop-filter/clip-path/mask none, opacity 1,
       isolation auto, will-change auto, contain none, content-visibility visible,
       container-type normal, -webkit-overflow-scrolling unset -- at rest AND with settleTo()'s
       inline `overflow-y:hidden; scroll-snap-type:none` applied, which is the only inline style our
       own code ever writes to it. And with the bar moved in, elementFromPoint inside a ~5,900px^2
       panel/bar overlap returned .pmenu-panel at every viewport in Chromium AND WebKit.
       ORDER: the bar stays FIRST so the back button is still the first thing in tab order. Paint
       order does not depend on it -- z-index 12 against the list's `auto` decides that. */
    box.innerHTML =
      '<div class="pfeed-scroll">' +
        '<div class="pfeed-bar">' +
          '<button class="pfeed-x" type="button" aria-label="Back">' +
            '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m14 5-7 7 7 7"/></svg>' +
          '</button>' +
          '<a class="pfeed-who" href="#"><span class="pfeed-av"></span><span class="pfeed-name"><span class="pfeed-host"></span><span class="pfeed-title"></span></span></a>' +
          '<span class="pfeed-flex"></span>' +
          '<button class="pfeed-menu" type="button" aria-label="More">' +
            '<svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor" aria-hidden="true"><circle cx="5" cy="12" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="19" cy="12" r="2"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="pfeed-list"></div>' +
        '<div class="pfeed-more"><div class="gal-spin"></div></div></div>';
    document.body.appendChild(box);
    scroller = box.querySelector('.pfeed-scroll');
    ensurePfWarmIOs();   // the photo warm/byte-prefetch observers root AT this scroller (see their comment)
    list     = box.querySelector('.pfeed-list');
    sentinel = box.querySelector('.pfeed-more');
    // Stamp the LQIP thumb the MOMENT any post enters the list. fitPfeedMedia() also does it, but a fast swipe
    // under load can reach a freshly inserted post (via loadMore / loadBefore) BEFORE that runs -- which left it
    // showing the black backdrop (round-170 stress finding). MutationObserver callbacks run before paint, so the
    // placeholder is in place for the post's very first frame no matter which code path inserted it.
    applyPfLqip(list);
    if (!list._lqipObs) {
      list._lqipObs = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var a = muts[i].addedNodes;
          for (var j = 0; j < a.length; j++) { applyPfLqip(a[j]); }
        }
      });
      list._lqipObs.observe(list, { childList: true, subtree: true });
    }
    box.querySelector('.pfeed-x').addEventListener('click', close);
    // The identity (avatar + @handle, shown as rovasocial.com/@handle when idle) is a link to the
    // profile. Navigate explicitly so a tap opens it from ANY state -- including the idle state, where
    // a bare anchor tap would otherwise just wake the controls. Do NOT close() first: closing played a
    // 280ms dismiss back to the grid and only THEN started loading the profile (a visible dismiss ->
    // pause -> navigate, the "takes a second" report). Navigating immediately keeps the viewer on
    // screen while the browser fetches the profile in the background, then swaps pages -- instant feel.
    box.querySelector('.pfeed-who').addEventListener('click', function (e) {
      var href = this.getAttribute('href');
      e.preventDefault();
      if (!href || href === '#') return;   // no profile resolved yet: do nothing (don't jump to top)
      window.location.href = href;
    });
    ['pointermove', 'pointerdown', 'touchstart', 'keydown'].forEach(function (ev) { box.addEventListener(ev, wake, { passive: true }); });
    // the video scrub (buildControls) wakes the chrome for a gesture that has no pointermove -- the trackpad
    window.__rovaPfWake = function () { wake(); };
    box.addEventListener('scroll', wake, { passive: true, capture: true });
    /* THE WAKE-TAP GUARD, bound here beside the wake listeners it exists to correct. See the long
       comment on PF_WAKE_SEL above for the mechanism and for the measured list of what actuated
       before it. Two listeners, both CAPTURE:
         pointerdown  on DOCUMENT, so the flag is refreshed by EVERY gesture and can never go
                      stale between a press outside the viewer and a click inside it. Passive:
                      it only reads.
         click        on the BOX, so a dropped click never reaches any handler inside the viewer
                      -- the .pfeed-x close listener, hfWireHandle's own listener, or the
                      delegated `submit` that carries like and repost (preventDefault on the
                      click stops the form's implicit submission, so no submit event is ever
                      raised and nothing is written).
       No stopImmediatePropagation: capture-phase stopPropagation at .pfeed already prevents the
       event reaching anything below it, and the two document-level listeners that run BEFORE
       this one consult pfWakeRetarget directly. */
    document.addEventListener('pointerdown', function (e) {
      pfPressOnCtl = !!(e.target && e.target.closest && e.target.closest(PF_WAKE_SEL));
    }, true);
    box.addEventListener('click', function (e) {
      if (!pfWakeRetarget(e)) return;
      e.preventDefault(); e.stopPropagation();
    }, true);
    var _sndRaf = 0, _sndLast = 0, _recycleT = 0, _lastRecycle = 0, _fbRaf = 0, _fbLast = 0;
    scroller.addEventListener('scroll', function () {
      var nowT = (window.performance && performance.now) ? performance.now() : Date.now();   // one clock read for the throttles below
      // Update the top bar's author. It calls currentPost() (a getBoundingClientRect on EVERY rendered
      // post = a forced reflow, now cached per scroll event), and the old code scheduled a FRESH rAF per
      // scroll event, so several ran per frame -> layout thrash. That was the main reason the home-feed
      // pfeed stuttered while the profile one stayed buttery. Now coalesced to one rAF and throttled to
      // ~10x/sec (the bar author doesn't need per-frame precision; the settle sets the final state).
      // EVERY MODE, NOT `cur.mode === 'feed'` (owner 2026-09-03, desktop + Magic Mouse: two different
      // posts both headed "@thailand_jay"). The gate was written when a profile viewer held ONE author,
      // and updateFeedBar itself has said for weeks that it "runs in BOTH feed and profile mode" because
      // the profile roll flows into the rec-roll -- OTHER people's posts. Every route that decides a
      // post change already hands the bar its target (settleTo's handover + commit for a finger,
      // step()'s crossover for the keys and hands-free), so those were never wrong. The one route that
      // cannot know its target is a NATIVE scroll -- a wheel / trackpad / Magic Mouse swipe, PageDown --
      // and in profile mode that route reached NEITHER this throttle NOR the trailing settle below: the
      // media changed and the identity did not, for as long as the reader kept wheeling. Reproduced on
      // /@steve's viewer, 1440x900 guest: a phased wheel gesture landed @thailand_jay's post with the
      // bar still reading @brandeye at +350ms and at +1500ms; ArrowDown between the same two posts was
      // correct. The profile-only cost is one cached currentPost() per 100ms of scrolling.
      if (cur && !_fbRaf) {
        var tb = (window.performance && performance.now) ? performance.now() : Date.now();
        if (tb - _fbLast > 100) { _fbLast = tb; _fbRaf = requestAnimationFrame(function () { _fbRaf = 0; updateFeedBar(); }); }
      }
      // near the top: pull in the items ABOVE the one we opened on (we started mid-list at the tap)
      if (cur && cur.mode === 'feed' && scroller.scrollTop < scroller.clientHeight) loadBefore();
      // re-hand sound to whichever clip is now centered (mid-swipe the observer can leave it wrong)
      /* THROTTLED TO ~8/s WITH A TRAILING CALL (scroll-smooth audit, 2026-09-06). This used to run
         applySound() on EVERY scroll frame: it is an O(posts + videos) getBoundingClientRect scan
         (activeVideo) plus a mute write per clip, and on the viewer it measured as the largest rAF cost
         of a swipe -- 3.4s of a 30s scroll at CPU x4 (1,145 forced layout reads), ~5ms of every 16.7ms
         frame at x1. Sound does not need per-frame precision: settleTo already hands the bar and the
         voice over at the glide midpoint, and the trailing call in the settle timeout below re-syncs
         once the swipe has stopped, so the audible hand-over lands within ~120ms instead of ~16ms and
         the frame budget gets ~5ms back. */
      if (!_sndRaf && (nowT - _sndLast) > 120) { _sndLast = nowT; _sndRaf = requestAnimationFrame(function () { _sndRaf = 0; if (window.__rovaSyncSound) window.__rovaSyncSound(); }); }
      // Tear down far media THROUGHOUT the fling, not only after it settles. A fast 15-20 swipe burst
      // never lets a settle-only recycle fire, so every post the warm observers touched kept its decoded
      // photo / HLS buffer and memory climbed until the phone killed the tab (fine on desktop RAM). A
      // throttled pass (>=250ms) keeps the live media set bounded to ~9 posts mid-swipe. It does media
      // ONLY (no scrollTop change, so momentum is untouched); DOM pruning waits for the settle pass below.
      if (nowT - _lastRecycle > 250) { _lastRecycle = nowT; recyclePfeedMedia(false); }
      // trailing settle pass: media recycle + DOM node pruning (the latter adjusts scrollTop, so it only
      // runs once the swipe has stopped and there's no momentum to disturb)
      clearTimeout(_recycleT);
      _recycleT = setTimeout(function () {
        pfRestFlush(false);   // never left resting BETWEEN two posts -- see pfRestFlush
        recyclePfeedMedia(true);
        // trailing edge for SOUND too (2026-09-06): the ~120ms throttle above can swallow a fling's last
        // frames, so re-hand the voice once the swipe has stopped. One activeVideo() scan per settle.
        if (window.__rovaSyncSound) { try { window.__rovaSyncSound(); } catch (e) {} }
        // TRAILING EDGE for the bar. The ~100ms throttle above has no trailing call, so when a fling's
        // LAST scroll event lands inside the throttle window the bar is never updated for the post it
        // actually settled on -- it keeps the previous author's @handle until the next gesture. One
        // update once the scrolling has stopped costs a single currentPost() and closes that hole.
        // Every mode, for the reason given at the throttle above: this settle is the COMMIT for a
        // native scroll, the one navigation route that has no target to hand over.
        if (cur && !pgAnim) updateFeedBar();
        // #634 the scope-clearing check, on the settle and nowhere near a frame. It returns on its
        // first property read unless repeat is actually armed, so the feature costs a parked feed
        // one boolean per settle; armed, it costs one currentPost() per settle and nothing else.
        // The common case never even gets here -- a swipe re-attributes through updateFeedBar, which
        // already holds the handle, so the pager path pays nothing at all.
        rpSettle();
      }, 220);
    }, { passive: true });
    // the bar's ⋯ opens the CURRENT post's options menu (the per-post ⋯ is hidden)
    box.querySelector('.pfeed-menu').addEventListener('click', function (e) {
      e.stopPropagation();
      var p = currentPost();
      var trig = p && p.querySelector('.pmenu-trigger');
      if (trig) trig.click();
    });
    // keyboard: Esc OR Space closes, Up/Down page to the prev/next post (snap), Left/Right page the
    // current post's carousel (multi-media posts only)
    document.addEventListener('keydown', function (e) {
      if (!box.classList.contains('show')) return;
      // Typing a comment / caption? Let every key through -- SPACE must insert a space, not dismiss the viewer
      // (owner: "spacebar dismisses the pfeed while typing a comment"); arrows must move the caret, not page.
      var a = document.activeElement;
      if (a && (/^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName) || a.isContentEditable)) { return; }
      // the hands-free speed chooser is a popover on top of the viewer: Escape must dismiss IT first,
      // exactly like every other popover, instead of tearing the whole viewer down underneath it
      if (e.key === 'Escape' && hfSpeedsOpen()) { e.preventDefault(); hfSpeedsShow(false); return; }
      if (e.key === 'Escape' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); close(); return; }
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); step(e.key === 'ArrowDown' ? 1 : -1); }
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
        var cp = currentPost();
        var car = cp && cp.querySelector('.carousel');
        if (car && car.__cstep) { e.preventDefault(); car.__cstep(e.key === 'ArrowRight' ? 1 : -1); }
        else {
          // a single VIDEO: Left/Right seek 5s, one precise seek per press through the bar's own scrub (2026-09-29)
          var vh = cp && cp.querySelector('.media.has-vctrl'), va = vh && vh.__vcScrub;
          if (va && vh._vctrl === va.v) { e.preventDefault(); va.nudge(e.key === 'ArrowRight' ? 5 : -5); }
        }
      }
    });
    /* ---- ONE WHEEL GESTURE = ONE POST (owner 2026-09-28, desktop Safari full screen, Magic Mouse: "A fast
       swipe on my magic mouse ... is swiping too fast too far it should only let one media at a time").
       THERE WAS NO VERTICAL WHEEL LOCK AT ALL. The "wheel lock" of 2026-09-03/09-19 lives in initCarousel
       and is HORIZONTAL only (it returns on every vertical-dominant event: "let the feed scroll"). Every
       vertical wheel / trackpad / Magic Mouse event in the viewer went to the browser's NATIVE scroll, and
       .pfeed-scroll is `scroll-snap-type:y mandatory` with no scroll-snap-stop, so snap only chooses where
       the scroll RESTS -- a Magic Mouse flick's ~1s momentum tail (hundreds of px per frame at its peak)
       carried the scroller straight through two, three, four posts before snap got a say. The touch
       pager never had this problem because it kills the fling on touchend (settleTo); a wheel has no
       touchend, so nothing ever took the gesture over.
       THE RULE (the carousel's, learned the hard way twice): ONE gesture commits ONE step; the gesture's
       whole tail is swallowed; the lock releases on QUIET or on evidence of a NEW gesture, never on a
       plain magnitude bump. Release paths, all on e.timeStamp (the INPUT clock -- a busy main thread that
       delivers queued events late cannot fake a hole):
         1. QUIET: nothing for PFW_QUIET_MS. The timer is the guaranteed release.
         2. A HOLE of PFW_GAP_MS inside the stream. Momentum runs at the display cadence and has no holes;
            a finger landing back on the mouse CANCELS the momentum, so a second swipe always follows one.
            BUT a janky main thread makes the engine COALESCE queued wheel events into one event stamped
            with the LAST time -- a fake hole whose delta is the sum of everything it swallowed. So a hole
            only counts when what lands after it is NOT such a blob: its px-per-ms must be well under the
            pace the stream was running at before the hole (a real new swipe starts from rest).
         3. REVERSAL: the delta changes sign. No tail does that on its own.
         4. A FRESH RISE, and only once the tail has visibly DECAYED (a floor under half its peak): measured
            as a RATE (px/ms), two events in a row well above the slowest rate of the last 200ms (the
            second >= 5x it and >= PFW_RISE_PX per 16ms frame, the one before >= 2.5x). Not "bigger than
            the one before" -- the 09-03 carousel lock died on exactly that (tails read 51, 98, 90, 42, 78
            under coalescing); a rate is immune to coalescing, and a SUSTAINED 5x rise over the recent
            FLOOR is a finger, where a lone spike is jitter.
       OWNERSHIP IS DECIDED ONCE, at a gesture's first event, exactly like the touch paths (see
       touch-pager-claims-scrub...): horizontal -> the carousel's / nobody's; a cover-zoomed photo or clip
       that panned it (the document-level panners preventDefault) -> theirs, and when they hit their edge
       the rest of THAT gesture is swallowed rather than chained into the feed (the next gesture pages);
       an expanded caption / any inner overflow box with room that way -> native, untouched; anything
       else -> the pager. ctrlKey (pinch-zoom) is never looked at. Touch never produces wheel events, so
       the phone pager is untouched by construction.
       TWO LISTENERS, because of propagation order: the pager's DECISION needs to know whether a
       document-level panner took the event, so it runs on WINDOW bubble (after them); the tail SWALLOW
       must beat the carousel and the panners, so it runs on the scroller in CAPTURE and stops the event
       there. A notched mouse wheel (deltaMode 1/2, or 100px notches) commits on its first event; notches
       arriving faster than PFW_GAP_MS are one gesture (one post), slower ones are one post each. */
    var PFW_STEP_PX = 24, PFW_QUIET_MS = 200, PFW_GAP_MS = 90, PFW_STREAM_MS = 40, PFW_RISE_PX = 40;
    var pfw = { own: null, acc: 0, dir: 0, t: 0, gap: 1e9, mag: 0, peak: 0, recent: [], quietT: 0, pend: 0, pendT: 0 };
    function pfwPx(d, e) { return e.deltaMode === 1 ? d * 16 : e.deltaMode === 2 ? d * (scroller.clientHeight || 800) : d; }
    function pfwEnd() {
      clearTimeout(pfw.quietT); pfw.quietT = 0;
      pfw.own = null; pfw.acc = 0; pfw.dir = 0; pfw.t = 0; pfw.gap = 1e9; pfw.mag = 0; pfw.peak = 0; pfw.recent.length = 0;
    }
    // an inner overflow box under the pointer that can still scroll this way (expanded caption, a panel)
    function pfwInner(t, dy) {
      for (var el = t; el && el !== scroller && el !== box; el = el.parentElement) {
        if (el.scrollHeight <= el.clientHeight + 1) continue;
        var oy = getComputedStyle(el).overflowY;
        if (oy !== 'auto' && oy !== 'scroll') continue;
        if (dy > 0 ? el.scrollTop + el.clientHeight < el.scrollHeight - 1 : el.scrollTop > 1) return true;
      }
      return false;
    }
    // step() tweens scrollTop for 320ms with snap suspended (and settleTo glides a transform); a second
    // step started under either would compute its target from a half-moved scroller. Queue it instead:
    // two genuine flicks in quick succession still move exactly two posts.
    // _cpDirty: currentPost() caches until the next SCROLL EVENT, which lands a frame after a scrollTop
    // write -- so a step fired right behind an INSTANT one (reduced motion jumps, no tween) read the post
    // it had just left and "stepped" onto itself. Force the one fresh scan per committed gesture.
    function pfwBusy() { return pgAnim || scroller.style.scrollSnapType === 'none'; }
    function pfwStep(dir) {
      if (!pfwBusy()) { _cpDirty = 1; step(dir); return; }
      pfw.pend = (pfw.pend && (pfw.pend > 0) === (dir > 0)) ? Math.max(-2, Math.min(2, pfw.pend + dir)) : dir;
      if (pfw.pendT) return;
      var tries = 0;
      (function wait() {
        pfw.pendT = setTimeout(function () {
          pfw.pendT = 0;
          if (!box.classList.contains('show')) { pfw.pend = 0; return; }
          if (pfwBusy() && ++tries < 40) { wait(); return; }
          var d = pfw.pend; pfw.pend = 0;
          if (d) { _cpDirty = 1; step(d > 0 ? 1 : -1); if (Math.abs(d) > 1) pfwStep(d > 0 ? 1 : -1); }
        }, 30);
      })();
    }
    scroller.addEventListener('wheel', function (e) {       // CAPTURE: segment the stream, swallow a locked tail
      if (e.ctrlKey || !box.classList.contains('show')) return;
      var dx = pfwPx(e.deltaX, e), dy = pfwPx(e.deltaY, e), ay = Math.abs(dy);
      var vert = ay > Math.abs(dx), m = Math.max(ay, Math.abs(dx));
      var now = e.timeStamp || Date.now();
      if (pfw.own) {
        var gap = now - pfw.t, fresh = false;
        var blob = pfw.gap < PFW_STREAM_MS && pfw.mag > 0
                   && (m / Math.max(gap, 8)) >= 0.5 * (pfw.mag / Math.max(pfw.gap, 8));
        if (gap >= PFW_GAP_MS && !blob) { fresh = true; }                                   // 1 + 2
        else if (vert && pfw.dir && (dy > 0 ? 1 : -1) !== pfw.dir && ay >= 3) { fresh = true; }  // 3
        else if (vert && pfw.own === 'lock' && gap < PFW_STREAM_MS && pfw.recent.length >= 3) {
          var r = ay / Math.max(gap, 12), floor = Infinity, prevR = pfw.recent[pfw.recent.length - 1].r;
          for (var i = 0; i < pfw.recent.length; i++) { if (now - pfw.recent[i].t <= 200 && pfw.recent[i].r < floor) floor = pfw.recent[i].r; }
          if (floor <= pfw.peak * 0.5 && r >= PFW_RISE_PX / 16 && r >= floor * 5 && prevR >= floor * 2.5) { fresh = true; }  // 4
        }
        if (fresh) { pfwEnd(); }
        else { pfw.gap = gap; }
      }
      // rise tracking is in px per ms, never per event: an engine that COALESCES two queued events hands us
      // one event with twice the delta over twice the gap -- the same rate, where a per-event size doubles.
      if (vert && pfw.t && now - pfw.t < PFW_STREAM_MS) {
        var rr = ay / Math.max(now - pfw.t, 12);
        if (rr >= pfw.peak) { pfw.peak = rr; pfw.recent.length = 0; }
        else { pfw.recent.push({ t: now, r: rr }); if (pfw.recent.length > 24) pfw.recent.shift(); }
      }
      pfw.t = now; pfw.mag = m;
      clearTimeout(pfw.quietT); pfw.quietT = setTimeout(pfwEnd, PFW_QUIET_MS);           // 1
      if (pfw.own === 'lock') { if (e.cancelable) e.preventDefault(); e.stopPropagation(); }
    }, { capture: true, passive: false });
    window.addEventListener('wheel', function (e) {          // BUBBLE: decide ownership, commit the step
      if (e.ctrlKey || !box.classList.contains('show') || !e.target || !scroller.contains(e.target)) return;
      var dx = pfwPx(e.deltaX, e), dy = pfwPx(e.deltaY, e), vert = Math.abs(dy) > Math.abs(dx);
      if (!pfw.own) {
        pfw.own = !vert ? 'x' : e.defaultPrevented ? 'inner' : pfwInner(e.target, dy) ? 'native' : 'pager';
        pfw.dir = vert ? (dy > 0 ? 1 : -1) : 0;
      }
      if (pfw.own === 'native' || pfw.own === 'lock') return;
      if (pfw.own !== 'pager') { if (vert && !e.defaultPrevented && e.cancelable) e.preventDefault(); return; }
      if (!vert) return;
      if (!e.cancelable) return;               // the engine already let this sequence scroll natively: don't move twice
      e.preventDefault();
      pfw.acc += dy;
      if (e.deltaMode === 0 && Math.abs(pfw.acc) < PFW_STEP_PX) return;
      var dir = pfw.acc > 0 ? 1 : -1;
      pfw.own = 'lock'; pfw.dir = dir; pfw.acc = 0;
      pfwStep(dir);
    }, { passive: false });
    // Dismiss is a deliberate DOWNWARD pull only:
    //  - at the very TOP (the newest clip), pull DOWN to close (return to where you tapped).
    // Swiping UP is always "next" -- at the last clip it BOUNCES, it never closes. Auto-closing on an
    // up-swipe surprised people opening a SHORT gallery (e.g. a 2-photo profile): they'd tap the first
    // photo, swipe up expecting the next, and get kicked out at the end instead of just stopping. Close
    // from the bottom via the back arrow (always in the bar) or by scrolling back up and pulling down.
    // The 2px tolerances absorb scroll-snap resting at a sub-pixel offset.
    var startY = 0, startT = 0, pulling = false, dir = 0;   // dir: +1 pull down at top, -1 pull up at bottom
    var sTop0 = 0, scrolled = false;   // scrollTop at gesture start; did the feed actually scroll this gesture
    // the TRUE top of the feed: scrolled to 0 AND nothing left to prepend above. If we opened mid-feed
    // and earlier media is still to load (headIdx > 0), a swipe-DOWN must scroll UP to it, never dismiss.
    var atTop = function () {
      if (scroller.scrollTop > 2) return false;
      if (cur && cur.mode === 'feed' && cur.headIdx > 0) return false;
      // a zoomed portrait photo scrolls WITHIN its post (.pf-vscroll); don't arm the pull-to-dismiss
      // until that inner image is also at its top, or a downward drag to see the photo's top would
      // start dismissing the viewer instead of scrolling the image.
      var p = currentPost && currentPost();
      var vs = p && p.querySelector('.media.pf-vscroll');
      if (vs && vs.scrollTop > 2) return false;
      // #44, same rule for a cover-filled clip that still has cropped rows ABOVE the window: a downward
      // drag there means "show me the top of the video", not "dismiss". Only once the crop window is
      // parked at the clip's top (--pf-vpos 0%) does a further pull belong to the dismiss.
      // (|| 50 would be a bug here: "0%" parses to 0, which is falsy, so the parked-at-top case -- the
      // one state that SHOULD allow the dismiss -- would read as 50 and block it forever.)
      var vp = p && p.querySelector('.pf-vpan');
      var vpos = vp ? parseFloat(vp.style.getPropertyValue('--pf-vpos')) : NaN;
      if (vp && (isNaN(vpos) ? 50 : vpos) > 0.1) return false;
      // #50, the same rule for a cover-zoomed PHOTO with picture still hidden ABOVE the window: a
      // downward drag there means "show me the top of the photo", not "dismiss the viewer". Only once
      // the pan is parked at the picture's top does a further pull belong to the dismiss.
      var yp = p && p.querySelector('.pf-ypan');
      if (yp && window.__rovaPhotoPanAtTop && !window.__rovaPhotoPanAtTop(yp)) return false;
      return true;
    };
    scroller.addEventListener('touchstart', function (e) {
      startY = e.touches[0].clientY; startT = Date.now(); pulling = false; dir = 0;
      sTop0 = scroller.scrollTop; scrolled = false;
      if (atTop()) { pulling = true; dir = 1; }   // only the TOP edge arms a pull; swipe-up never closes
    }, { passive: true });
    scroller.addEventListener('touchmove', function (e) {
      // A tap / double-tap-to-like on the media just happened: its small downward drift must NOT arm the
      // pull-to-dismiss (that was closing the viewer on a double-tap). Stand down for this gesture.
      // ...and the same stand-down for an open reaction carousel: a drag across the emoji strip is
      // not a pull-to-dismiss. Stamped for the whole press + 350ms, exactly like the tap token.
      if (Date.now() - (window.__rovaMediaTapAt || 0) < 350
          || Date.now() - (window.__rovaRxAt || 0) < 350) { if (pulling) { pulling = false; box.style.transform = ''; } return; }
      var y = e.touches[0].clientY, d0 = y - startY;
      // If the feed actually scrolled DOWN into its content this gesture, it's a scroll (advancing to the
      // next clip), not a pull-to-dismiss -- so cancel the pull. This is the "opened on the first clip,
      // swipe UP to the next" case on a SHORT list (e.g. a 2-post gallery): scroll-snap carries the finger
      // to the next clip in one motion and must land there, never close. Rubber-band PAST the top (scrollTop
      // < 0) is not "into content", so a genuine pull-DOWN at the top still dismisses.
      if (!scrolled && dir >= 0 && scroller.scrollTop > 6) { scrolled = true; pulling = false; box.style.transform = ''; }
      if (scrolled) { return; }
      if (!pulling) {
        // reached the top edge mid-swipe (e.g. scrolled up to the newest clip): begin the pull from here
        if (d0 > 0 && atTop()) { pulling = true; dir = 1; startY = y; startT = Date.now(); }
        else { return; }
      }
      var dy = y - startY;
      if (dir > 0 && dy > 0 && atTop()) {
        box.style.transition = 'none'; box.style.transform = 'translateY(' + Math.min(dy * 0.45, 140) + 'px)';
      } else {
        pulling = false; box.style.transform = '';
      }
    }, { passive: true });
    scroller.addEventListener('touchend', function (e) {
      if (Date.now() - (window.__rovaMediaTapAt || 0) < 350
          || Date.now() - (window.__rovaRxAt || 0) < 350) { pulling = false; box.style.transform = ''; return; }   // double-tap-to-like / reaction hold, not a dismiss
      if (scrolled || !pulling) { pulling = false; box.style.transform = ''; return; }
      // a PINCH that began after this pull armed is a pinch: its last finger up is never a dismiss
      if ((window.__rovaPinchAt || 0) >= startT) { pulling = false; box.style.transform = ''; return; }
      pulling = false;
      var dy = e.changedTouches[0].clientY - startY;
      var vy = dy / Math.max(1, Date.now() - startT);   // px/ms; a natural flick clears ~0.45
      box.style.transition = 'transform .2s ease';
      // close on a deliberate DOWNWARD pull at the top: a clear DRAG (>70px) or a quick flick. Swipe-up
      // is never a close (dir is only ever +1 now), so advancing through media can't kick you out.
      var goTop = dir > 0 && atTop() && (dy > 70 || (dy > 22 && vy > 0.45));
      if (goTop) { close(); }
      else { box.style.transform = ''; }
    }, { passive: true });

    /* ---- hard scroll trap: never let a swipe chain out to the page behind ---------------------
       The body IS pinned (position:fixed) while the viewer is open, and overscroll-behavior:none is set
       (rova.css), but iOS Safari doesn't always honour that for an inner scroller -- an overscroll past
       the top/bottom edge can still rubber-band the page underneath. This blocks the ONLY moves that
       chain: a drag PAST the top (when already at the top) or PAST the bottom. In-bounds scrolling is
       untouched, and the pull-to-dismiss (a separate handler that drives its own transform) still works.
       Non-passive on purpose so preventDefault can actually stop the native chain. */
    var _pfEdgeY = 0;
    scroller.addEventListener('touchstart', function (e) { _pfEdgeY = e.touches[0].clientY; }, { passive: true });
    scroller.addEventListener('touchmove', function (e) {
      if (e.touches.length > 1) return;
      var y = e.touches[0].clientY, dy = y - _pfEdgeY; _pfEdgeY = y;
      var atTop = scroller.scrollTop <= 0;
      var atBot = scroller.scrollTop + scroller.clientHeight >= scroller.scrollHeight - 1;
      if (((atTop && dy > 0) || (atBot && dy < 0)) && e.cancelable) { e.preventDefault(); }   // overscroll -> would leak, block it (a non-cancelable move is already scrolling: the call only logs an intervention)
    }, { passive: false });

    /* ---- fast landing: take over the snap the moment the finger lifts -------------------------
       Native scroll-snap rides the browser's own momentum curve down -- close to a full second of
       "braking" after a swipe, during which the media is drifting and everything feels laggy. So on
       touchend we kill the native momentum outright (overflow:hidden is the one reliable way to stop
       iOS's fling) and drive the landing ourselves: a ~200ms ease-out straight to the target post.
       One motion, quick landing -- and since the drift window basically disappears, a double-tap right
       after a swipe hits settled media almost immediately. A new touch cancels the animation instantly
       and hands control back to the native scroller, so it never fights the finger. */
    // pgLive: this gesture's touchSTART actually reached the pager. Any inner panel that owns its own
    // vertical gestures (the expanded caption, the comment roller) stops the start from bubbling -- and
    // without this token the pager still ran on touchEND, measuring the finger against the coordinates of
    // a much older gesture and "settling" to the next post. That was #46. Never page a gesture we did not
    // see begin.
    var pgAnim = false, pgY0 = 0, pgX0 = 0, pgT0 = 0, pgStart = null, pgSkip = false, pgSafeT = 0, pgLive = false;
    // Bar hand-over timer. The glide below animates a TRANSFORM, so scrollTop never moves and NO scroll
    // events fire for its whole duration -- the scroll listener's bar update simply never runs. The bar
    // therefore kept the PREVIOUS author's @handle until the glide ended: measured 367ms with no update,
    // of which ~160ms had the wrong name sitting over the incoming post while it covered 56-78% of the
    // screen. That is the "other people's names on other people's posts" report. Hand the bar over at the
    // glide's MIDPOINT, which is the same crossover a native drag uses (currentPost() picks the post
    // nearest the top, i.e. it flips at 50%), so dragging and flicking now agree.
    var pgBarT = 0;
    function pagerReset() {
      pgAnim = false;
      clearTimeout(pgSafeT);
      clearTimeout(pgBarT);
      list.removeEventListener('transitionend', _pgOnEnd);
      list.style.transition = ''; list.style.transform = ''; list.style.willChange = '';
      scroller.style.overflowY = '';
      scroller.style.scrollSnapType = '';
    }
    box._pagerReset = pagerReset;   // close() restores the scroller even mid-animation
    var _pgFinish = null, _pgOnEnd = null;
    function settleTo(post) {
      // Animate a GPU-composited TRANSFORM on the list, not scrollTop. A JS scrollTop tween runs on the
      // main thread, so on iOS it stutters whenever the video being decoded competes for it -- that was
      // the "not smooth" swipe. translateY is composited off the main thread, so the slide stays buttery
      // even mid-decode. When it finishes we atomically commit the equivalent scrollTop and drop the
      // transform (same pixel, in one synchronous block, so no paint lands in between -> no flash).
      if (pgAnim) { pagerReset(); }
      var delta = post.getBoundingClientRect().top - scroller.getBoundingClientRect().top;
      if (Math.abs(delta) < 1) { updateFeedBar(post); if (window.__rovaSyncSound) window.__rovaSyncSound(); return; }
      pgAnim = true;
      scroller.style.overflowY = 'hidden';      // stop the native fling dead
      scroller.style.scrollSnapType = 'none';   // native snap would fight the slide
      list.style.willChange = 'transform';
      list.style.transition = 'none';
      list.style.transform = 'translateY(0px)';
      void list.offsetHeight;                   // flush, so the transition runs from 0
      list.style.transition = 'transform .26s cubic-bezier(.22,.61,.36,1)';   // fast, gentle glide, firm stop
      list.style.transform = 'translateY(' + (-delta) + 'px)';
      // hand the identity over halfway through the .26s glide -- the moment the incoming post becomes the
      // one you are actually looking at. `post` is already known, so this costs no layout read at all.
      clearTimeout(pgBarT);
      pgBarT = setTimeout(function () { updateFeedBar(post); }, 130);
      _pgFinish = function () {
        if (!pgAnim) return;
        pgAnim = false;
        clearTimeout(pgSafeT);
        clearTimeout(pgBarT);
        list.removeEventListener('transitionend', _pgOnEnd);
        // commit: scrollTop += delta AND transform back to 0, together -> net visual position unchanged
        list.style.transition = 'none';
        list.style.transform = '';
        list.style.willChange = '';
        /* RE-MEASURED, NOT THE DELTA TAKEN AT THE GLIDE'S START (2026-10-08, Rob's replay "two videos
           stacked"): a card loadBefore / pfFlushPark / pruneFarPosts inserted or removed ABOVE during the
           260ms moved the post, and the stale delta then landed a card (or a fraction of one) off it.
           The transform is already cleared, so this is the post's true distance; == delta when nothing moved. */
        scroller.scrollTop += post.isConnected ? (post.getBoundingClientRect().top - scroller.getBoundingClientRect().top) : delta;
        scroller.style.overflowY = '';
        scroller.style.scrollSnapType = '';
        updateFeedBar(post);   // known target: no currentPost() scan needed
        if (window.__rovaSyncSound) window.__rovaSyncSound();
      };
      _pgOnEnd = function (e) { if (e.target === list && e.propertyName === 'transform') _pgFinish(); };
      list.addEventListener('transitionend', _pgOnEnd);
      pgSafeT = setTimeout(_pgFinish, 420);     // safety net if transitionend is missed
    }
    scroller.addEventListener('touchstart', function (e) {
      if (pgAnim && _pgFinish) { _pgFinish(); }  // a new finger mid-slide: commit the post, then hand off
      /* HANDS-FREE STANDS DOWN FOR THE WHOLE GESTURE (owner 2026-08-29: swiping back up, "it
         immediately kicks me back to the next post over and over"). The outgoing post's live dwell
         used to keep running under the finger and could expire MID-DRAG or mid-glide, advancing a
         post the reader was in the act of leaving -- or re-taking the one they had just left. The
         flag holds hfAdvance (see hfNavHold); the dwell itself is re-dealt in full at the settle. */
      hfNavDown = true;
      pgY0 = e.touches[0].clientY; pgX0 = e.touches[0].clientX; pgT0 = Date.now();
      pgStart = currentPost(); pgLive = true;
      // inner scrollers own their swipes: a zoomed photo pans (pf-vscroll, and #50's pf-ypan), the comment
      // roller scrolls its own box -- paging the whole feed under those would hijack the gesture. At a pan
      // limit the panner stops calling preventDefault, so the feed's own snap scrolling takes the swipe.
      // .vctrl joins that list for the same reason, and on the same ORIGIN basis: a gesture that begins
      // on the glassy player (a scrub, a button) belongs to the player, so the pager must not measure it
      // and settle a post out from under it. The touchend test below only rejects a gesture whose FINAL
      // |dx| > |dy|; a slow scrub that wanders vertically can fail that test while still being a scrub.
      pgSkip = e.touches.length > 1
        || !!(e.target.closest && e.target.closest('.media.pf-vscroll, .pf-vpan, .pf-ypan, .croller, .vctrl, .vc-sound'));
    }, { passive: true });
    scroller.addEventListener('touchend', function (e) {
      // the finger is up: trade the hard hold for the short tail (HF_NAV_TAIL_MS covers the glide +
      // its 420ms safety commit), BEFORE the early returns below -- a gesture the pager declines to
      // measure still ends, and a stuck hfNavDown would defer the reel forever.
      if (!e.touches || e.touches.length === 0) { hfNavDown = false; hfNavAt = Date.now(); }
      var live = pgLive; pgLive = false;
      if (!live) { return; }                                                   // start was owned by an inner panel
      if ((window.__rovaPinchAt || 0) >= pgT0) { return; }                     // a pinch, not a swipe (see the pinch-to-peek `tail`)
      if (pgSkip || !box.classList.contains('show') || !pgStart) { return; }   // dismissed / inner gesture
      // A reaction carousel was open under this finger: the gesture was a pick, not a swipe, so the
      // pager must not measure it and settle a different post out from under the reader.
      if (Date.now() - (window.__rovaRxAt || 0) < 350) { return; }
      var t = e.changedTouches[0];
      var dy = t.clientY - pgY0, dx = t.clientX - pgX0;
      if (Math.abs(dx) > Math.abs(dy)) { return; }                             // horizontal: the carousel's
      var posts = list.querySelectorAll('.post');
      if (!posts.length) { return; }
      // where are we NOW (nearest post), and where did the gesture START?
      var sTop = scroller.getBoundingClientRect().top;
      var nearI = 0, nearD = Infinity, startI = 0;
      Array.prototype.forEach.call(posts, function (p, i) {
        var d = Math.abs(p.getBoundingClientRect().top - sTop);
        if (d < nearD) { nearD = d; nearI = i; }
        if (p === pgStart) { startI = i; }
      });
      var vy = dy / Math.max(1, Date.now() - pgT0);
      // Require a REAL swipe to change posts: a deliberate DRAG of ~18% of the screen, OR a genuine fast
      // FLICK (>= ~0.5 px/ms) that also travelled a bit (>= ~10%). A small nudge, a hesitation, or nudging
      // the media a few px just settles back to the NEAREST post -- no auto-advance. This is the owner's
      // "I barely moved my finger and it jumped to the next post" fix. Still exactly one post per gesture
      // (clamped to startI +/- 1 below), so a hard flick can't skip ahead.
      var vh = scroller.clientHeight || window.innerHeight || 800;
      var far = vh * 0.18, flick = Math.abs(vy) >= 0.5 && Math.abs(dy) >= vh * 0.10;
      var ti;
      if (dy <= -far || (flick && dy < 0))      { ti = startI + 1; }   // up-swipe far/fast: next
      else if (dy >= far || (flick && dy > 0))  { ti = startI - 1; }   // down-swipe far/fast: previous
      else                                       { ti = nearI; }        // not far/fast enough: settle to nearest
      ti = Math.max(startI - 1, Math.min(startI + 1, ti));   // hard cap: never more than one post
      ti = Math.max(0, Math.min(posts.length - 1, ti));      // and inside the list
      if (ti === nearI && nearD < 3) { return; }     // already resting on the target: leave it be (taps)
      settleTo(posts[ti]);
    }, { passive: true });
    // RELIABILITY (tap-to-zoom): any pfeed touch that actually MOVES -- a swipe, however slight -- wipes the
    // shared single/double-tap latch (lastEl/lastTime) and cancels a pending single-tap action, so the NEXT
    // tap on a photo is always read as a clean single tap and tap-to-zoom can't get stuck "dead" after a
    // swipe. Safe because the click a real tap synthesizes fires AFTER this touchend and re-establishes its
    // own state -- and a stationary tap (< the tap slop) never triggers the reset at all. These live in the
    // outer scope (the single-vs-double click handler up top). pgX0/pgY0 are this gesture's start point.
    scroller.addEventListener('touchend', function (e) {
      var t = e.changedTouches && e.changedTouches[0]; if (!t) return;
      if (Math.abs(t.clientX - pgX0) > 10 || Math.abs(t.clientY - pgY0) > 10) {
        if (window.__rovaTapReset) { window.__rovaTapReset(); }   // outer-scope latch reset (see __rovaTapReset)
      }
    }, { passive: true });
    // iOS hands a hijacked gesture (system edge swipe, an alert) touchcancel, never touchend. Without
    // this the hands-free nav hold (hfNavDown, armed on touchstart above) would stay up with no finger
    // on the glass and defer every auto-advance forever -- a stalled reel, the opposite failure of the
    // owner's "kicks me back to the next post over and over" report this hold exists to fix.
    scroller.addEventListener('touchcancel', function (e) {
      if (!e.touches || e.touches.length === 0) { pgLive = false; hfNavDown = false; hfNavAt = Date.now(); }
    }, { passive: true });
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (ents) {
        /* hz-hold: a hero is in the air. With only the target card rendered the sentinel sits right
           under it, well inside the 9000px margin, so this would fire immediately and pull page 2
           into the middle of the flight. Defer rather than drop -- the landing re-enters via
           pfFlushPark, and a genuine scroll-driven load re-triggers this observer anyway. */
        ents.forEach(function (en) {
          if (!en.isIntersecting) return;
          if (!window.__rovaNoPhase && document.documentElement.classList.contains('hz-hold')) return;
          loadMore();
        });
      }, { root: scroller, rootMargin: PFEED_SENTINEL_MARGIN + 'px 0px' });   // must stay ahead of warmIO's
      // 1200% video-buffer margin, or the DOM simply has nothing rendered that far out for warmIO to warm.
      io.observe(sentinel);
    }
    hfBuild();   // hands-free: the idle invite card + the docked handle (see the HANDS-FREE block)
    return box;
  }

  // PHASE OWNERSHIP (RC2): the viewer box is a permanent singleton, so an open/close cycle that starts before
  // the previous one's deferred teardown fires used to (a) let a stale setTimeout(finish) blank the FRESH
  // viewer mid-open, and (b) re-run collapse and spawn duplicate clones. pfGen bumps on every phase change so
  // stale async continuations bail; pfFinalize() hard-completes any in-progress teardown before a new open.
  var pfGen = 0, pfPhase = 'idle', pfCloseTimer = null, pfCloseOnEnd = null, pfPendingFinish = null;
  // Called at the TOP of an opener to hard-complete the PREVIOUS cycle's deferred teardown before this open.
  // NOTE: the grid tap starts THIS open's hero (heroExpand -> a live '.pf-hero' clone) BEFORE calling the
  // opener, so pfFinalize must NEVER call __rovaHeroReset or touch '.pf-hero' -- that would cancel the open we
  // are mid-launching. It only reaps the pending CLOSE (timer/listener/finish) and any leftover '.pf-hero-collapse'
  // dismiss clone (spared by reset, otherwise cleaned only by its 352ms drop timer). Stale OPEN clones are
  // already gone -- close() ran __rovaHeroReset before this.
  function pfFinalize() {
    try { if (pfCloseTimer) { clearTimeout(pfCloseTimer); pfCloseTimer = null; } } catch (e) {}
    try { if (pfCloseOnEnd && box) { box.removeEventListener('transitionend', pfCloseOnEnd); pfCloseOnEnd = null; } } catch (e) {}
    /* RUN THE PENDING TEARDOWN NOW -- ALL OF IT. The close's teardown is a two-step chain since the wipe
       was deferred off the collapse frame (finish() -> wipeNow()), and finish() re-arms pfPendingFinish
       with the second step. Draining one step would leave a wipe armed to fire ~620ms INTO this open,
       which is the stale-finish-blanks-a-fresh-viewer bug this function exists to prevent. Bounded loop,
       so a future step that re-arms itself can't spin. */
    try {
      for (var _pfi = 0; pfPendingFinish && _pfi < 4; _pfi++) { var f = pfPendingFinish; pfPendingFinish = null; f(); }
    } catch (e) {}
    Array.prototype.forEach.call(document.querySelectorAll('.pf-hero-collapse'), function (el) {
      try { if (window.__rovaHeroReleaseVideo) window.__rovaHeroReleaseVideo(el); } catch (e) {}   // bare <video> or flyCrop wrapper
      try { if (el._flightCss && el._flightCss.parentNode) el._flightCss.parentNode.removeChild(el._flightCss); } catch (e) {}
      try { if (el.parentNode) el.parentNode.removeChild(el); } catch (e) {}
    });
    try { if (window.__rovaPfStillSync) window.__rovaPfStillSync(); } catch (e) {}
    // Do NOT null __rovaGridDonor/__rovaGridSeek/__rovaFsBorrow here: the grid tap sets the donor BEFORE calling
    // the opener, so clearing it would break THIS open's adoption. Stale ones are already rejected downstream by
    // their id + `at` timestamp guards.
    kbReset();   // a frozen close-frame photo drift must never reach the next open's landing measurement
    pfPhase = 'idle';
  }
  window.__rovaPfFinalize = pfFinalize;

  // web#19: the viewer owns ONE history entry so the iOS edge-swipe (browser
  // back) dismisses it like a native screen. Without it, back popped the TAB
  // pager's same-document entries under the still-open viewer — the page never
  // changed, so "the same video keeps popping back up" on every swipe.
  var pfHist = 0;        // 1 = we pushed the viewer's entry and haven't consumed it
  var pfPopClose = 0;    // this close() came FROM popstate: the entry is already gone
  window.addEventListener('popstate', function () {
    if (!pfHist) return;               // not our entry (or already consumed)
    pfHist = 0;
    if (box && box.classList.contains('show') && pfPhase !== 'closing') {
      pfPopClose = 1; try { close(); } finally { pfPopClose = 0; }
    }
  });
  function pfHistPush() {
    try { history.pushState({ rovaPfeed: 1 }, '', location.href); pfHist = 1; } catch (e) { pfHist = 0; }
  }

  /* ---- THE TAP TASK ENDS AT THE FLIGHT, NOT AT THE END OF THE OPEN  (2026-08-17, round D) ------
     MEASURED, and it is the fourth round's whole result. The three before it each removed a real
     cost from the open -- duplicated write->read pairs, five `body:has()` rules that invalidated
     every <img> in the document twelve times, a dead `innerHeight` read -- and every one of them
     left the owner's complaint ("a noticeable hang opening videos into full screen") exactly where
     it was. The profile said why: the tap task is ~40 app functions of 5-30ms plus ~230ms of forced
     style+layout, and NONE of it is deletable. Traced on the live grid at 390x844 / 4x CPU: one
     727ms task, no frame painted between 101ms and 937ms after the tap, and the hero -- already
     built, already carrying its composited @keyframes since heroExpand ran ~400ms earlier -- sat
     still for the whole of it. The hang is not any one function. It is that they all run before
     the browser is allowed to draw a frame.

     So the opener now ends at the two things that genuinely cannot move:
       - the WebKit user activation (the sound arm, the boomerang master's unmute+play, __rovaAmArm),
         which does not survive a yield of any kind, and
       - loadMore(), the round-trip the whole open is blocked on,
     plus the DOM the loadMore .then() may land on in the very next microtask checkpoint (build(),
     clearPfeedList(), `cur`, the bar text). Everything else is handed to pfOpenTail below.

     ONE STEP PER FRAME, NOT ONE DEFERRED BLOB. A single setTimeout would move the 400ms rather
     than remove it -- a second 400ms task one frame later is the same hang with a later start.
     Each step therefore gets its own task with a paint in between, and the steps are ordered so
     that the two expensive ones (pfLock's document-wide flush; the fade baseline's) never share a
     frame with each other or with the .show flip.

     AFTER THE PAINT, NOT AT THE TOP OF THE FRAME. A bare requestAnimationFrame callback runs
     BEFORE that frame's style/layout/paint, so scheduling the tail on rAF alone would simply move
     the block in front of the very frame it exists to free. rAF -> setTimeout(0) is the hop that
     lands after the frame has been committed. The bare 48ms timer behind it is not redundant: rAF
     does not run in a backgrounded tab, and a viewer opened and immediately backgrounded must
     still get its scroll lock, its .show and its history entry.

     GENERATION-GUARDED, WHICH IS WHAT MAKES A DEFERRED OPEN SAFE TO ABANDON. close() bumps pfGen,
     so a tap-then-straight-back-out stops the tail wherever it is: no lock is taken after the
     unlock has run, and no history entry is pushed behind a viewer that is already gone (pfHist
     would have been left set with nothing to consume it -- back would then have needed two
     presses). A newer open bumps pfGen too, so a stale tail can never flip .show on the viewer
     that replaced it. */
  function pfAfterPaint(fn) {
    var ran = false;
    function go() { if (ran) { return; } ran = true; try { fn(); } catch (e) {} }
    setTimeout(go, 48);   // always armed: the rAF racer is dead in a background tab
    if (window.requestAnimationFrame) { requestAnimationFrame(function () { setTimeout(go, 0); }); }
    else { setTimeout(go, 0); }
  }
  window.__rovaAfterPaint = pfAfterPaint;   // the grid tap handler lives in its own closure
  function pfOpenTail(steps) {
    var gen = pfGen, i = 0;
    function next() {
      if (gen !== pfGen) { return; }        // a close / a newer open owns the viewer now
      var fn = steps[i++];
      if (!fn) { return; }
      try { fn(); } catch (e) {}
      if (i < steps.length) { pfAfterPaint(next); }
    }
    pfAfterPaint(next);
  }
  /* WHAT IS NOT IN THE TAIL, AND WHY -- MEASURED, because the first cut of this round put it there.
     `void box.offsetWidth` and the rAF that adds .show stay exactly where they were, in the tap's
     own task and the frame straight after it. Deferring them worked (the receipt says so) and cost
     the thing the round is for: with the viewer's own .show three post-paint hops behind a busy
     main thread, tapToPfeedShow went 1002ms -> 1864ms on the same tap, and what the reader sees in
     that window is the GRID behind a rising hero instead of the viewer's dark ground fading up
     under it. The hero flies at z-index 210 over the backdrop's 205, so the backdrop is not what
     the eye is following -- but it is not nothing either, and no measurement in this round asked
     for it to move. The fade baseline (see the note at the offsetWidth) is therefore untouched:
     same statement, same task, same rAF one frame later.
     The steps below are the ones with no frame of their own to be late for. */
  /* ---- pfHistPush BEFORE pfLock, IN ONE TASK, AND IT IS NOT A PREFERENCE  (2026-08-17, round E) ---
     history.pushState SNAPSHOTS THE DOCUMENT'S CURRENT SCROLL OFFSET into the entry it creates, and
     pfLock() writes position:fixed + top:-<scrollY>px onto <body>, after which window.scrollY reads
     0. Run the lock first and the viewer's history entry is recorded at scroll 0 -- so close()'s own
     history.back() (the branch that consumes that entry) restores the page BEHIND the viewer to the
     top instead of to where the reader was.
     MEASURED, and this is the defect that failed the first cut of the tail: tap a tile at scrollY 424,
     dismiss, and the grid came back at scrollY 0 -- the tile the reader had just been looking at was
     now 362px below the fold. The shipped order has always had pfHistPush ahead of pfLock in the tap
     task, so this is not a new rule, it is that rule surviving the move off the task. They share ONE
     step rather than two frames precisely so no future re-ordering can separate them again, and
     tools/tail-abort-check.js asserts the restored scroll offset directly. */
  function pfTailLock() { pfHistPush(); pfLock(); }
  function pfTailIdle() { pfResume(); pfSoundSoon(); }

  /* ---- A DISMISS LANDS WHEN ITS OWN ANIMATION DOES, NOT WHEN A TIMER GUESSES IT HAS  (2026-09-24) ---
     Rob, on a feed-card video opened with the player's fullscreen button: "opening this video in full
     screen is smooth as butter, but closing it or dismissing it back flashes to black a couple times
     and looks very choppy, not a smooth landing animation to mirror the smooth opening animation".
     Both live-clip dismissals (the feed-card `liveDone` and the grid `gridLiveDone`) flew the playing
     <video> home in a flyCrop crop-window and then moved it into its card on `setTimeout(.., 352)` --
     a WALL-CLOCK promise that the 340ms tween was over. The tween's clock does not start at close():
     a CSS animation starts PENDING and gets its start time on the first frame after the task that
     created it, and close() is the heaviest task in the viewer (Rob's own flight rows for this very
     post, 53809 at 19:17 today: rafWorst 91-182ms at 125-233ms into every close-feed). MEASURED,
     headless 900x700 + 1710x1100, animation.currentTime read at the moment the wrapper was disposed:
     133 / 233 / 250 of 340 -- the clip was yanked out of the air with 30-60% of its path still to
     fly, 10-60px short of the card, and appeared in the card on the next frame. That is the choppy,
     "not a smooth landing". The open never had it: heroExpand's reveal re-measures and glides any
     remaining distance (flyRetarget) before it swaps.
     So the hand-off now waits for the flight's own `animationend` -- the frame on which the wrapper
     sits exactly on the card, where moving the clip in is a zero-pixel change -- with a backstop for
     the one case the event cannot come (an animation that never ran: a hidden tab, a stripped style).
     The backstop is well inside finish()'s 620ms wipe window, so nothing downstream moves. */
  function pfOnFlightLanded(wrap, ms, fn) {
    var fired = false, bt = null;
    function go() {
      if (fired) { return; }
      fired = true;
      if (bt) { clearTimeout(bt); bt = null; }
      try { wrap.removeEventListener('animationend', onEnd); } catch (e) {}
      fn();
    }
    // the INNER media carries its own keyframes and its animationend bubbles here too -- same duration,
    // but only the wrapper's own event is the statement "the crop-window is on the card"
    function onEnd(e) { if (e.target === wrap) { go(); } }
    try { wrap.addEventListener('animationend', onEnd); } catch (e) {}
    bt = setTimeout(go, ms + 480);
  }
  // .pf-landed on a dismiss's destination card until the pointer genuinely moves (see the call in close()).
  // The first mousemove only records where the pointer is -- a synthetic hover update reports the same
  // spot -- and a later one more than 2px away releases it. Touch never hovers, so a stale class is inert.
  function pfHoldHover(media) {
    try {
      if (media._pfHoverOff) { media._pfHoverOff(); }
      media.classList.add('pf-landed');
      var x0 = null, y0 = 0;
      var off = function () {
        media._pfHoverOff = null;
        document.removeEventListener('mousemove', mv, true);
        try { media.classList.remove('pf-landed'); } catch (e) {}
      };
      var mv = function (e) {
        if (x0 === null) { x0 = e.clientX; y0 = e.clientY; return; }
        if (Math.abs(e.clientX - x0) > 2 || Math.abs(e.clientY - y0) > 2) { off(); }
      };
      media._pfHoverOff = off;
      document.addEventListener('mousemove', mv, { capture: true, passive: true });
    } catch (e) {}
  }

  function close() {
    if (!box) return;
    if (pfPhase === 'closing') return;   // re-entrancy guard: a double back-tap / back+swipe must not run collapse twice (duplicate clones)
    pfPhase = 'closing'; pfGen++;
    kbFreeze();   // the photo drift holds its frame: the dismiss flight starts from it (see THE VIEWER'S PHOTO DRIFT)
    // The viewer is going away, by any route (chevron, Escape, pull-down, back). The media ring
    // flushes its seen beacon and re-orders its circles off this; nothing else listens today.
    // (Since 2026-10-09 the ring HOLDS that re-order until the dismissal has landed in its circle --
    // __rovaRingLanded below -- so the circle is still where the reader left it when the copy arrives.)
    var _wasRing = !!(cur && cur.ring);
    try { document.dispatchEvent(new CustomEvent('rova:pfclose', { detail: { ring: _wasRing } })); } catch (e) {}
    /* A CLOSE ENDS THE OPEN'S HOLD. An open that is dismissed before it settles (tap, then straight
       back out) would otherwise leave the page's own clips muted until the hold's expiry ran down --
       a mute nobody asked for, which is the exact failure the expiry exists to prevent. pfGen has
       just moved, so pfVoiceReady is already retired for that open; this is the other end of it. */
    if (window.__rovaSoundRelease) { try { window.__rovaSoundRelease(); } catch (e) {} }
    /* CLAIM THE MAIN THREAD FOR THE COLLAPSE (2026-08-12). The dismissal runs for ~550ms (340ms crop-flight
       + the 352ms handoff + the clone's 150ms cross-fade) and every background poller in this file was free
       to fire inside it. Measured over 1,088 logged closes: rafWorst p50 407ms in the last three days, with
       the gaps clustered at 50-250ms and a sharp spike at 400-450ms. Stamp the deadline FIRST, before any of
       the teardown below runs, so even the synchronous work in this function is inside the window. */
    if (window.__rovaFlightHold) { window.__rovaFlightHold(950); }
    hfClose();   // kill every hands-free timer + the one-pass listeners BEFORE the teardown starts
    // An expanded comment sheet lives INSIDE a post in the list, so the teardown's
    // clearPfeedList() would just detach it -- leaving the comment module holding a detached
    // "still open" panel, which arms its outside-tap rule over the whole page and leaks the
    // sheet's idle timer, its 8s poll and the engage-hold. Close it properly first, while the
    // post is still attached. Runs for EVERY dismissal route (chevron, Escape, pull-down,
    // browser back), so they all end in the same clean state. No-op when nothing is open.
    try { if (window.__rovaCloseCommentPanel) { window.__rovaCloseCommentPanel(); } } catch (e) {}
    // closed via X / pull-down: consume the viewer's history entry ourselves so
    // back afterwards doesn't need an extra press. The resulting popstate is a
    // no-op above because pfHist is already 0.
    if (pfHist) { pfHist = 0; try { history.back(); } catch (e) {} }
    var _closeGen = pfGen;   // a later open/close bumps pfGen -> this close's deferred collapse handoffs bail
    // Clear any hero left mid-flight by a fast open->close BEFORE the collapse snapshots the media: otherwise
    // an interrupted open-hero keeps html.hz-hold on (freezing every media on the page) and a clone stuck on
    // screen, which read as "the site is frozen, reload to recover".
    if (window.__rovaHeroReset) { window.__rovaHeroReset(); }
    /* MEASURE THE DESTINATION IN THE LAYOUT IT WILL LAND IN, NOT THE ONE THE LOCK IMPOSES
       (2026-09-13, owner: "dismissing a profile photo doesn't land correctly"). Every rect the
       block below reads -- the grid tile, the timeline card's .media, the profile avatar ring --
       is a LIVE getBoundingClientRect, re-read at dismiss time exactly as it should be. It was
       still the wrong number, because the page is 79px higher WHILE THE SCROLL LOCK IS ON (see
       pfUnlockPage): the copy flew to where the ring was during the viewer, the lock came off
       behind it, and the ring ended up a full diameter below the landed circle -- two circles,
       one above the other, measured dTop -79 at 420 CSS px on the avatar and -82 on a feed photo.
       Releasing the page lock HERE, one statement before the measurement, is the whole fix: the
       flight itself is unchanged, one continuous transform, no re-aim, no delay, nothing added.
       It must stay ahead of the measurement and behind the history.back() above (which snapshots
       the scroll the unlock then restores). */
    pfUnlockPage();
    // REVERSE HERO collapse: shrink the current slide back into the grid tile it flew out of (mirror of
    // heroZoom). Do this FIRST, while the viewer is still shown and the media is painted, so the clone
    // snapshots the live rect; then the normal teardown fades the viewer out behind it. Origin tile =
    // the current post's grid cell if that grid is still in the DOM and on screen (grid-tap case), else
    // null -> the helper shrinks toward centre (permalink / pruned-cell fallback). Honours reduced-motion.
    try {
      var cpost = currentPost();
      var pvid = cpost && cpost.getAttribute('data-view');
      var tile = pvid && document.querySelector('.pgrid .pcell[data-id="' + pvid + '"]');
      // originRadius rides with originRect: the destination's TRUE rounding, read through
      // __rovaDestRadius (owner 2026-08-29 screenshot, "trying to crop it back to a circle but not
      // quite" -- parseFloat on a computed '50%' border-radius reads as 50 PIXELS, so it is never
      // parsed here directly). A px number or a '%' string, as flyCrop understands them.
      var originRect = null, originRadius = 0, originIsAvatar = false, originEl = null;   // originEl: what originRect was read off (kbTo, below)
      /* A RING SESSION GOES HOME TO ITS CIRCLE (2026-10-09, Rob: "when it flies back it's a square ... the
         crop should land as a circle"). Opened from the media ring, the viewer used to resolve no origin
         at all (the deck's posts are rarely a grid tile or a card on screen), so the copy shrank toward the
         screen centre and faded -- a rectangle that never went anywhere -- while the ring had ALREADY moved
         the watched circle to the back of the row (settle() ran inside the rova:pfclose above), i.e. the
         one place it could have landed was gone too. Now: the ring names the circle of the person whose
         post is on screen (__rovaRingLandTarget: on screen, fully inside the row, painted), measured HERE,
         after pfUnlockPage, and the ring holds its re-order until __rovaRingLanded. It lands through the
         avatar path (originLive): the circle is already painted and decoded underneath, the copy's
         corners morph to the circle's own 50% on the way down and it dissolves into the circle inside the
         tween -- no swap, no second element to reveal. */
      var ringIm = null, _ringDone = false;
      var ringLanded = function () { if (_ringDone) { return; } _ringDone = true; if (window.__rovaRingLanded) { try { window.__rovaRingLanded(); } catch (e3) {} } };
      if (_wasRing && pvid && window.__rovaRingLandTarget) {
        try { ringIm = window.__rovaRingLandTarget(pvid); } catch (e3) { ringIm = null; }
        if (ringIm) {
          originRect = ringIm.getBoundingClientRect();
          originRadius = window.__rovaDestRadius ? window.__rovaDestRadius(ringIm) : '50%';
          originIsAvatar = true;   // painted + unmoving: the dissolve-inside-the-tween landing, and never a tile hand-off
        }
      }
      if (_wasRing && !ringIm) { ringLanded(); }   // nothing to land in: the row re-orders now, as it always did
      if (tile && !originRect) {
        var trc = tile.getBoundingClientRect();
        if (trc.width > 4 && trc.height > 4 && trc.bottom > 0 && trc.top < window.innerHeight
            && trc.right > 0 && trc.left < window.innerWidth) {
          originRect = trc; originEl = tile;
          originRadius = window.__rovaDestRadius ? window.__rovaDestRadius(tile) : 0;
        }
      }
      // Opened from the TIMELINE (e.g. the player's fullscreen button) rather than the grid: collapse back
      // into that post's inline media, exactly like a grid open collapses to its tile. On-screen real
      // timeline post only, never a copy inside the viewer.
      if (!originRect && pvid) {
        var tmedia = null;
        Array.prototype.forEach.call(document.querySelectorAll('.post[data-view="' + pvid + '"] .media'), function (mm) {
          if (tmedia || (mm.closest && mm.closest('.pfeed'))) { return; }
          tmedia = mm;
        });
        if (tmedia) {
          var mrc = tmedia.getBoundingClientRect();
          if (mrc.width > 4 && mrc.height > 4 && mrc.bottom > 0 && mrc.top < window.innerHeight
              && mrc.right > 0 && mrc.left < window.innerWidth) {
            originRect = mrc; originEl = tmedia;
            originRadius = window.__rovaDestRadius ? window.__rovaDestRadius(tmedia) : 0;
          }
        }
      }
      /* PROFILE-PHOTO album (owner 2026-08-29 screenshot: dismissing the avatar photo landed "a
         slightly-rounded rectangle over the circular avatar... trying to crop it back to a circle
         but not quite"). The avatar post is hidden from every feed and usually has no on-screen
         grid cell, so BOTH resolvers above miss, originRect stayed null, and the photo shrank
         toward the viewport centre -- a translucent rectangle drifting over the profile header.
         The origin this viewer actually flew out of is the profile picture itself: land the
         collapse back in the on-screen .pf-avatar whose album owns this post, with its TRUE
         rounding ('50%' -> flyCrop morphs the copy into a circle as it shrinks; parseFloat would
         have read that as 50px -- see __rovaDestRadius). Album membership, not just the current
         photo: dismissing from an OLDER photo of the slideshow still returns to the avatar,
         which is where the album opened from. */
      if (!originRect && pvid) {
        var pfaO = document.querySelector('.pf-avatar[data-photo-post]');
        var albO = pfaO ? (pfaO.getAttribute('data-photo-album') || pfaO.getAttribute('data-photo-post') || '') : '';
        if ((',' + albO + ',').indexOf(',' + pvid + ',') > -1) {
          // same element ladder the open uses (avatarMedia): photo avatars fly to the <img>, video
          // avatars to the .av-vid crop wrapper (its <video> is pointer-events:none inside it)
          var avO = pfaO.querySelector('img.avatar') || pfaO.querySelector('.av-vid') || pfaO.querySelector('video.avatar');
          var arcO = avO && avO.getBoundingClientRect();
          if (arcO && arcO.width > 4 && arcO.height > 4 && arcO.bottom > 0 && arcO.top < window.innerHeight
              && arcO.right > 0 && arcO.left < window.innerWidth) {
            originRect = arcO;
            originRadius = window.__rovaDestRadius ? window.__rovaDestRadius(avO) : 0;
            originIsAvatar = true;   // the grid live-clip handoff below must NOT treat this as a tile landing
          }
        }
      }
      // PARK THE TILE ON THE SLIDE THE READER LEFT, for PHOTOS. A video dismiss records this further
      // down, implicitly, by reparenting slide N's live <video> into the cell; a photo dismiss
      // reparents nothing, so without this the tile reverts to its cover and the reopen falls back to
      // the static #m<n> href (measured on 15805: swipe to 3, minimize, reopen -> slide 0, while the
      // app returns you to 3). Runs HERE -- before any flight, unconditionally -- because remembering
      // the slide is behaviour, not animation: reduced-motion readers and an off-screen tile (no
      // originRect) get it too. No-op for a video slide and for single-media posts.
      if (window.__rovaGridStampPhoto) { try { window.__rovaGridStampPhoto(box, tile); } catch (e3) {} }
      /* THE CARD ARRIVED UNDER THE POINTER; THE POINTER DID NOT ARRIVE ON THE CARD (2026-10-01, the second
         half of Rob's /p/54692 "it lands wrong but it fixes it"). `.post .media:hover img` zooms the photo
         4.5% over .45s, held off by html.pfv-on/pfv-fly while the viewer and the flight are up. On desktop
         the pointer that was over the viewer's photo is very often over the card it lands in (a permalink
         card sits under the screen centre), so the moment the clone left, the browser's synthetic hover
         update grew the landed picture by 23 x 31px -- measured in Chromium, starting ~250ms after the
         hand-off: a second post-landing motion. The hover is an answer to the pointer ENTERING the card,
         so hold it (.pf-landed, rova.css) until the pointer actually moves; a stationary pointer's
         synthetic events report the same position and never release it. */
      if (originEl && !originIsAvatar && originEl.classList && originEl.classList.contains('media')) { pfHoldHover(originEl); }
      // LAND BACK ON THE SAME FRAME (owner): stash the time the viewer's clip is on (e.g. 0:03) so the grid
      // preview RESUMES there when it collapses back into the tile, instead of restarting at 0 -- then the frame
      // the collapse lands on matches the frame we were watching. See the grid play() consumer.
      var seekV = null;
      if (cpost) { Array.prototype.forEach.call(cpost.querySelectorAll('video'), function (v) { if (!seekV && v.currentTime > 0.05) { seekV = v; } }); }
      /* ...BUT A 3-SECOND TILE USUALLY HAS NO SUCH FRAME TO LAND ON (2026-08-17), and this
         is the one place the `_grid3` rendition can BREAK a behaviour rather than improve it.
         The stash above is the viewer's ABSOLUTE time. The consumer in play() clamps it with
         `Math.min(gs.t, d - 0.1)`, so handing a 47s position to a tile whose whole clip is 3s
         does not error -- it silently pins every dismissal to the last frame of the loop and
         holds the tile there, hidden, until the seek settles. That is a frozen tile where
         there used to be a moving one, and it would have looked like a decode bug.
         The honest rule: the tile can only land on the frame the reader left if that frame is
         INSIDE the preview window. Convert master time back to tile time and keep the stash
         only when it lands in range; otherwise stash nothing and let the tile keep looping,
         which is both correct and what the reader already sees behind the closing viewer. */
      /* ASK THE POSTER, NOT THE TILE'S CURRENT <video>, and this is the one place those two
         answers can legitimately differ. This stash is only ever consumed by play() on a
         REBUILT tile (the direct-land branch below discards it outright at :35370), and a
         rebuilt tile is always constructed by ensureVideo from the poster <img> -- so the
         question here is "what will this tile BE", not "what is it now". They diverge after
         an earlier direct land has left the viewer's full-length master sitting in the cell:
         asking the element would answer 0, we would stash an absolute time, and the clip
         ensureVideo then rebuilds from the poster is the 3-second one, which pins to the end
         of its loop -- the exact freeze the block above exists to prevent, reached by the
         one path that looks like it is safe. */
      var g3Poster = tile && tile.querySelector('img.pcell-video[data-g3]');
      var g3c = (g3Poster && typeof window.__rovaG3Speed === 'function') ? window.__rovaG3Speed(g3Poster) : 0;
      // A boomerang poster carries BOTH markers (lib/view.php emits data-g3 beside data-g6
      // precisely so this query and every other "is this a short preview" test keep working),
      // so the selector above still finds it and this only adds which SHAPE it is.
      var g6c = (g3Poster && typeof window.__rovaG6 === 'function') ? window.__rovaG6(g3Poster) : 0;
      var seekT = seekV ? seekV.currentTime : 0;
      var seekOk = !!seekV;
      if (seekOk && g3c) {
        var tileT = seekT / g3c;
        var tileV = tile && tile.querySelector('video.pcell-video');
        var tileD = (tileV && tileV.duration > 0) ? tileV.duration : 0;
        /* THE LANDABLE WINDOW, and a boomerang's is HALF ITS FILE (2026-08-17).
           For a straight `_grid3` tile every position in the file is a distinct master time,
           so the whole duration is landable. For a `_grid6` tile only the FORWARD half is:
           a position in the reverse half shows the same picture but is travelling BACKWARDS,
           so landing the tile there would resume the loop running the wrong way under a
           reader who is about to tap it again -- and, worse, the naive arithmetic would put
           it at the wrong frame entirely (position 4.5 in a 5.93s palindrome shows master
           1.43, not 4.50). __rovaG6Tile is the documented inverse and returns -1 for a master
           time the forward half does not contain; the flat 2.85 fallback below covers the case
           where the tile's duration is not yet known, and is conservative for BOTH shapes
           because a boomerang's forward window is ~2.97s.
           0.15s of margin off the end either way: a seek that lands on the final frame is
           indistinguishable from the freeze this guard exists to prevent. */
        if (g6c && tileD > 0) {
          var tp = window.__rovaG6Tile(tileT, tileD);
          if (tp < 0 || tp > (tileD / 2) - 0.15) { seekOk = false; }
          else { seekT = tp; }
        }
        else if (tileD > 0 ? tileT > tileD - 0.15 : tileT > 2.85) { seekOk = false; }
        else { seekT = tileT; }
      }
      window.__rovaGridSeek = (tile && pvid && seekOk) ? { id: pvid, t: seekT, at: Date.now() } : null;
      var borrow = window.__rovaFsBorrow; window.__rovaFsBorrow = null;
      // FULLSCREEN dismiss: FLY THE LIVE, STILL-PLAYING <video> down to the post's media so it VISIBLY keeps
      // playing through the collapse -- exactly like the grid open/close flies the live clip. heroCollapse's
      // static still read as "paused" here (this collapse is a small move, so the frozen frame just sat there;
      // the grid's big shrink hid it). Moving a PLAYING <video> to body doesn't pause it (same op the open uses).
      var liveDone = false;
      var gridLiveDone = false;
      // The TRUE PAINTED extent of a pfeed clip, never its element box: the viewer's <video> element
      // fills the whole media box with object-fit:contain drawing the clip as a SMALLER band inside
      // it (and pf-vfill transform-scales that band up to cover). Starting the dismissal flight from
      // the element rect -- even clipped to the box -- materialized a FULL-SCREEN clone for a frame on
      // letterboxed clips ("briefly fills the entire screen, bigger than the video even is"). The
      // hero scope's paintedRectOf computes the drawn band from videoWidth/Height and intersects it
      // with the clip box -- the same math that has always kept PHOTO dismissals seamless.
      function visibleRectOf(el) {
        var clip = (el.closest && (el.closest('.cslide') || el.closest('.media'))) || el.parentNode;
        if (clip && window.__rovaPaintedRect) {
          var p = window.__rovaPaintedRect(el, clip);
          if (p && p.width > 4 && p.height > 4) { return p; }
        }
        return el.getBoundingClientRect();
      }
      /* ...AND ONLY WHILE THE READER IS STILL ON THAT CLIP (2026-09-24). originRect is the CURRENT post's
         card; the borrowed element is the clip the viewer was OPENED on. After a swipe to another post
         they are different things, and nothing here checked: when the new post's card happened to be on
         screen this flew the opened clip -- from wherever it sat in the scrolled-away deck -- into the
         OTHER post's card, then teleported it home at the hand-off. A swiped-away borrow goes home
         quietly through the return below instead, and the post on screen takes the still collapse. */
      var borrowHere = !!(borrow && borrow.video && cpost && cpost.contains(borrow.video));
      if (borrowHere && borrow.video.isConnected && borrow.video.tagName === 'VIDEO'
          && originRect && borrow.media && borrow.media.isConnected && !borrow.media.querySelector('video')
          && !(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)) {
        var vv = borrow.video, pr = visibleRectOf(vv);
        if (pr.width > 4 && pr.height > 4) {
          liveDone = true;
          // flight-sync telemetry: the FEED/timeline dismiss path (video opened from the scrolling feed
          // flies its live <video> back into the post). Was UN-instrumented -- the grid path recorded clean
          // but the owner still saw a rewind, so capture this path's clock too (any backward step lands as
          // the `rewind` field). Same element flies + lands, so a clean flight is strictly monotonic.
          if (window.__rovaVfStart) { window.__rovaVfStart('close-feed', pvid || 0, vv, vv.currentSrc || vv.src); }
          /* THE VIEWER HANDS ITS SOUND BACK TO THE CARD, AT THE LANDING (Rob 2026-09-26; the iOS app's
             build-474 rule: closing onto a timeline card -- not the grid, not the ring -- gives that card
             the viewer's sound state, audible 12ms after the landing). This muted the clip for the whole
             flight and __rovaPlayNow muted it again on landing, and the card waited for the next playIO
             crossing to speak: measured ~1s of silence on every close. An AUDIBLE viewer clip is now the
             designated voice (soundVoiceArm) and flies home still speaking; the landing claims the card's
             slot and releases the voice onto the same element (below). A clip muted in the viewer carries
             back muted: no voice, and the old engine mute. */
          var _closeVoice = false;
          if (!vv.muted && window.__rovaSoundVoiceArm) { try { _closeVoice = !!window.__rovaSoundVoiceArm(vv); } catch (e3) { _closeVoice = false; } }
          if (!_closeVoice) { vv._progMuteAt = Date.now(); vv.muted = true; }   // programmatic mute -> the sound engine must NOT read it as the user muting
          try { var _pl = vv.play(); if (_pl && _pl.catch) { _pl.catch(function () {}); } } catch (e3) {}
          // __rovaDestRadius, never parseFloat (owner 2026-08-29 screenshot, "trying to crop it back
          // to a circle but not quite"): parseFloat('50%') = 50 -- fifty px -- so a %-rounded
          // destination must go through the helper's fraction path; px values come back unchanged.
          var _rad = 0; try { _rad = window.__rovaDestRadius ? window.__rovaDestRadius(borrow.media) : 0; } catch (e3) {}
          vv.className = '';
          // COMPOSITED crop-flight down to the inline media (park at the big start rect: crisp raster,
          // transforms only -- no per-frame layout). The wrapper carries the collapse class for reset/gates.
          /* deferMove (2026-09-27, Rob's bug.mov): the clip stays in the viewer card for the first two frames
             of the dismiss while its snapshot twin flies -- see flyCrop. _pfHoming keeps the viewer-silencing
             sweep below from pausing it while it is still in the box (cleared by the landing). */
          vv._pfHoming = 1;
          var wrapV = window.__rovaFlyCrop(vv, pr, originRect, {
            ms: 340, cls: 'pf-hero pf-hero-collapse', z: 220, bg: '#000', park: 'from', radiusTo: _rad, deferMove: true
          });
          // on the flight's own landing frame, never a wall-clock guess at it -- see pfOnFlightLanded
          pfOnFlightLanded(wrapV, 340, function () {
            try { borrow.media.classList.remove('fs-away'); } catch (e3) {}   // every exit below ends the empty-slot state
            // the voice this close designated (if any) ends here on every exit, never on a timer
            var _voiceOff = function () { if (_closeVoice && window.__rovaSoundRelease) { try { window.__rovaSoundRelease(); } catch (e3) {} } };
            if (_closeGen !== pfGen) { vv._pfHoming = 0; try { window.__rovaHeroReleaseVideo(vv); } catch (e3) {} window.__rovaDisposeFlight(wrapV); _voiceOff(); return; }   // superseded cycle -> drop, don't touch the new viewer
            var host = borrow.media;
            if (host && host.isConnected && !host.querySelector('video')) {   // land it back into the post, keep playing
              /* THE LANDING IS TWO-PHASE TOO (2026-09-27). Phase 1, now: the clip's picture is pinned over it
                 IN THE WRAPPER, exactly where it sits (animation off, its landed transform copied). Phase 2,
                 two frames later: the clip moves into the card and the same canvas moves with it (frameCoverAt)
                 before the wrapper goes. A stall after the move can then only show that canvas -- the frame
                 the reader was already looking at -- never the card's #000. */
              var _snapL = window.__rovaFrameSnap ? window.__rovaFrameSnap(vv) : null;
              if (_snapL) {
                try { _snapL.style.cssText = vv.style.cssText + ';animation:none;transform:' + getComputedStyle(vv).transform + ';pointer-events:none;'; wrapV.appendChild(_snapL); } catch (e3) { _snapL = null; }
              }
              var _landed = false;
              var _land2 = function () {
                if (_landed) { return; } _landed = true;
                vv._pfHoming = 0;
                if (_closeGen !== pfGen || !host.isConnected || host.querySelector('video')) {   // superseded, or its home moved on
                  if (vv.parentNode === wrapV || !vv.closest('.post')) { try { window.__rovaHeroReleaseVideo(vv); } catch (e3) {} }
                  window.__rovaDisposeFlight(wrapV); _voiceOff(); return;
                }
              vv.className = borrow.cls;
              if (borrow.styleText) { vv.setAttribute('style', borrow.styleText); } else { vv.removeAttribute('style'); }
              host.insertBefore(vv, host.firstChild);   // moves vv OUT of the flight wrapper
              if (_snapL && window.__rovaFrameCoverAt) { try { window.__rovaFrameCoverAt(vv, _snapL); } catch (e3) {} }   // the pinned canvas follows it
              window.__rovaDisposeFlight(wrapV);
              if (window.__rovaVCtrl)   { try { window.__rovaVCtrl(vv); } catch (e3) {} }
              if (window.__rovaPlayNow) { try { window.__rovaPlayNow(vv); } catch (e3) {} }   // leaves the voice unmuted (see __rovaPlayNow)
              // the card it landed in becomes the timeline's playing card, then the voice is released onto
              // it through the ordinary rule -- same element, so there is nothing to unmute and no gap
              if (_closeVoice && window.__rovaTlClaim) { try { window.__rovaTlClaim(vv); } catch (e3) {} }
              _voiceOff();
              };
              if (_snapL) { requestAnimationFrame(function () { requestAnimationFrame(_land2); }); setTimeout(_land2, 90); }
              else { _land2(); }
            } else {
              vv._pfHoming = 0;
              try { window.__rovaHeroReleaseVideo(vv); } catch (e3) {} window.__rovaDisposeFlight(wrapV);   // RC5: free decoder+hls, not a bare detach
              _voiceOff();
            }
          });
        }
      }
      // GRID dismiss (owner): the tile we flew out of ALREADY has this exact clip loaded and playing behind the
      // viewer, so don't snapshot a still (its canvas grab taints on the cross-origin CDN video -> returned '' ->
      // no clone -> the paused pfeed video composited BLACK across the whole viewer) and don't rebuild anything.
      // Instead FLY THE LIVE pfeed <video> down onto the tile (it keeps painting -> no black), then HAND OFF to the
      // tile's own already-loaded clip synced to the exact frame -> it just keeps playing, no jerk. Zooming back
      // out into the clip that's already there is the whole trick.
      var reduceM = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
      // !originIsAvatar: when the origin is the profile AVATAR (photo-album dismiss with the post's
      // grid cell off-screen), originRect is NOT the tile's rect -- this branch would fly the live
      // clip to the avatar and then hand it to the TILE. Avatar landings take __rovaHeroCollapse.
      if (!liveDone && !reduceM && originRect && !originIsAvatar && tile) {
        var cvx = window.innerWidth / 2, cvy = window.innerHeight / 2, cslides = box.querySelectorAll('.post .media'), pv = null, pbox = null;
        for (var ci = 0; ci < cslides.length; ci++) {
          var cb = cslides[ci].getBoundingClientRect();
          if (cb.width > 4 && cb.height > 4 && cvx >= cb.left && cvx <= cb.right && cvy >= cb.top && cvy <= cb.bottom) {
            // THE SLIDE ON SCREEN, not querySelector('.cslide') -- that always returned SLIDE 1, so dismissing
            // a slideshow from slide 2/3 flew slide 1's clip home (owner: "the first picture/video from the
            // post flew back into the grid tile"). Worse, this branch takes precedence over __rovaHeroCollapse,
            // whose own copy of the hit-test was fixed long ago -- so the fixed path never even ran. And because
            // the track is translateX'd, slide 1 sits a whole viewport (or several) OFF-SCREEN LEFT: measured on
            // /@krystal 13696 at slide 3/6 in Safari, slide 1's painted rect was left:-780 while the viewport is
            // 390 wide, so the clone swept in horizontally from off-screen instead of dropping down into the tile.
            // ONE wrong element caused BOTH symptoms. No local re-implementation here: share the helper.
            // Helper missing (can't happen in one bundle) + a real carousel -> leave pv null so the correct
            // __rovaHeroCollapse path below handles it, rather than falling back to the first-slide grab.
            var chost = cslides[ci];
            var cs = window.__rovaCenteredSlide ? window.__rovaCenteredSlide(chost)
                                                : (chost.querySelector('.cslide') ? null : chost);
            if (!cs) break;
            pv = cs.querySelector('video'); pbox = cs; break;
          }
        }
        if (pv && pv.tagName === 'VIDEO' && pv.readyState >= 2) {
          // START the flight from the video's TRUE VISIBLE box (see visibleRectOf above): the raw
          // getBoundingClientRect of a pf-vfill cover-scaled clip is the UNCLIPPED extent -- bigger
          // than the screen -- which flashed a full-bleed clone before the shrink. The clipped window
          // is exactly where the user sees the clip, so frame 1 matches pixel-for-pixel.
          var pr2 = visibleRectOf(pv);
          if (pr2 && pr2.width > 4 && pr2.height > 4) {
            gridLiveDone = true;
            // OWN THE LANDING TILE'S REVEAL (owner: "it still randomly rewinds"). _grWatch rebuilds this
            // tile the instant the viewer closes -- BEFORE this handoff's setTimeout runs -- and ensureVideo
            // reveals a cached clip synchronously at whatever frame __rovaGridSeek.t held (often a stale
            // near-start time = the visible rewind). Flag the tile so the grid rebuild leaves it HIDDEN and
            // this flight becomes its sole revealer, seeking to the clip's EXACT current frame first.
            try { tile._pfHandoff = Date.now(); } catch (e3) {}
            // __rovaDestRadius, never parseFloat (owner 2026-08-29 screenshot, "trying to crop it
            // back to a circle but not quite"): parseFloat('50%') = 50 -- fifty px -- so a %-rounded
            // destination goes through the helper's fraction path; px tile radii come back unchanged.
            var tRad = 0; try { tRad = window.__rovaDestRadius ? window.__rovaDestRadius(tile) : 0; } catch (e3) {}
            pv._progMuteAt = Date.now();   // programmatic mute -> not a user mute (keeps rova_sound/pfLatch intact)
            pv.muted = true; try { var _pp = pv.play(); if (_pp && _pp.catch) { _pp.catch(function () {}); } } catch (e3) {}
            pv.className = '';
            // COMPOSITED crop-flight down to the tile (park at the big start rect; transforms only, the same
            // gradual portrait->square cover-morph the box-resize gave, now 60fps on the compositor).
            // flight-sync telemetry: record the live clip's clock/buffer through the collapse + tile handoff
            if (window.__rovaVfStart) { window.__rovaVfStart('close', pvid, pv, pv.currentSrc || pv.src); }
            var wrapG = window.__rovaFlyCrop(pv, pr2, originRect, {
              ms: 340, cls: 'pf-hero pf-hero-collapse', z: 220, bg: '#000', park: 'from', radiusTo: tRad
            });
            // flyCrop just reparented pv into the flight wrapper, which EXPOSES the slide's leftover
            // full-screen poster backdrop for the whole .28s viewer fade -- the "another thumbnail
            // behind the video shrinking" in the owner's recording. Hide the emptied slide so only the
            // flat viewer background fades over the grid. (The viewer wipes/rebuilds its list on the
            // next open, so the inline style never leaks into a future cycle.)
            try { pbox.style.visibility = 'hidden'; } catch (e3) {}
            // on the flight's own landing frame, never a wall-clock guess at it -- see pfOnFlightLanded
            pfOnFlightLanded(wrapG, 340, function () {
              if (_closeGen !== pfGen) { try { window.__rovaHeroReleaseVideo(pv); } catch (e3) {} window.__rovaDisposeFlight(wrapG); return; }   // superseded cycle -> drop, don't touch the new viewer
              // HAND OFF to the tile's own preview: the grid rebuilds the cell's <video> on close (_grWatch ->
              // play()), so point __rovaGridSeek at the EXACT frame this flight is on so it resumes there (no jerk),
              // then keep the flying clip covering the tile until that rebuilt clip has actually SEEKED to the frame
              // -- only then drop the clone. So the swap-over is frame-exact and never shows a poster/frame-0 pop.
              if (window.__rovaVfMark) { window.__rovaVfMark('flightLand', pv); }
              // LAND pv DIRECTLY INTO THE TILE -- the exact move the timeline/fullscreen dismiss uses (and that
              // the owner called "perfect"): one continuous, still-playing <video> flies down and is REPARENTED
              // into its destination (timeline: host.insertBefore(vv); here: tile.appendChild(pv)). NO rebuild,
              // NO handoff to a separately-rebuilt tile clip, NO re-seek, NO reveal -- so NONE of the two-element
              // swap glitches (the residual black flash / stale-poster blend). pv is already painting the exact
              // live frame, and moving a playing <video> in the DOM never pauses or blanks it.
              /* THE FLYING CLIP WINS THE TILE (2026-08-12). This used to refuse to land whenever the tile
                 already held a video.pcell-video, and the else-branch below RETIRES pv -- src stripped,
                 readyState 0, clock 0. In the flight log that is the `flightLand` with no `cloneLand`:
                 the element the reader was watching is thrown away and whatever the tile happened to
                 rebuild (or never released, when this cell was the spared donor) stays, at ITS clock, not
                 the frame on screen. That is the visible restart/rewind.
                 The OPEN has always resolved this the other way -- heroExpand's single-element handoff
                 does `fv0.parentNode.replaceChild(el, fv0)` and retires the evicted placeholder -- and the
                 close is the mirror image, so it evicts the same way. pv is the element carrying the exact
                 frame, the warm buffer and the live decoder; the tile's copy is the disposable one. */
              var _tv0 = (tile && tile.isConnected) ? tile.querySelector('video.pcell-video') : null;
              if (tile && tile.isConnected && _tv0 !== pv) {
                pv.className = 'pcell-video';
                pv.dataset.grSrc = (function (u) { return (u.slice(0, 5) === 'blob:' || /\.m3u8/i.test(u)) ? '' : u; })(pv.currentSrc || pv.getAttribute('src') || '');   // scroll-off release + re-attach still works
                // RECORD WHICH SLIDE THIS TILE NOW HOLDS. This reparent is what makes the grid "keep playing
                // the second video" after a minimize -- the behaviour the owner explicitly likes -- but it
                // silently breaks the cell's standing promise that it represents its cover media. The cell's
                // href still says #m0, so without this stamp the next tap tells the viewer to land on slide 0
                // and the hero flies THIS element (media N) into it, evicting slide 0's own clip. Stamp the
                // truth here, at the one place the swap happens; the grid-tap opener re-derives from it and
                // ensureVideo clears it the moment the cell rebuilds its own cover clip.
                try {
                  var _lsHost = pbox && pbox.classList && pbox.classList.contains('cslide') ? pbox : null;
                  var _lsIdx = _lsHost && _lsHost.parentNode
                    ? Array.prototype.indexOf.call(_lsHost.parentNode.querySelectorAll('.cslide'), _lsHost) : -1;
                  // >= 0, NOT > 0: slide 0 has to be representable. On the Photos/Videos tabs the cell's
                  // static href is #m<first media matching the tab> -- e.g. 15786 is #m1 on ?tab=videos --
                  // so "no stamp" does NOT mean "slide 0" there. A tile parked on slide 0 must say so, or
                  // it would fall back to the href and reopen on the wrong slide.
                  // Through __rovaGridParkVideo so the claim carries its PROOF (_grHold = this very
                  // element): the opener re-checks that the clip it is about to fly is still this one,
                  // so a tile whose clip was released (__rovaReleaseGridVideos on every open, or the
                  // far-off-screen releaseIO) can no longer hand the hero a stale slide number and fly
                  // its cover poster into it. It also clears any photo park underneath.
                  if (_lsIdx >= 0 && window.__rovaGridParkVideo) { window.__rovaGridParkVideo(tile, _lsIdx, pv); }
                  else if (_lsIdx >= 0) { tile.setAttribute('data-gr-slide', String(_lsIdx)); }
                  else if (window.__rovaGridUnpark) { window.__rovaGridUnpark(tile, true); }
                  else { tile.removeAttribute('data-gr-slide'); }
                } catch (e3) { try { tile.removeAttribute('data-gr-slide'); } catch (e4) {} }
                pv.loop = true; pv.muted = true; pv.playsInline = true; pv.setAttribute('playsinline', '');
                pv.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:cover;opacity:1';   // frames identically to the flight
                // moves pv OUT of the flight wrapper INTO the tile, still playing. replaceChild when the
                // tile rebuilt one behind our back -- and retire the evicted element, because a detached
                // <video> keeps playing where no DOM query can reach it (see __rovaStopOrphanMedia).
                if (_tv0) { _tv0.parentNode.replaceChild(pv, _tv0); if (window.__rovaRetireVideo) { try { window.__rovaRetireVideo(_tv0); } catch (e3) {} } }
                else { tile.appendChild(pv); }
                window.__rovaDisposeFlight(wrapG);                 // remove the now-empty wrapper
                try { var _gp = pv.play(); if (_gp && _gp.catch) { _gp.catch(function () {}); } } catch (e3) {}
                if (window.__rovaVfMark) { window.__rovaVfMark('cloneLand', pv); }
              } else {
                // tile gone or already re-populated -> free the decoder+hls, don't orphan it
                try { window.__rovaHeroReleaseVideo(pv); } catch (e3) {} window.__rovaDisposeFlight(wrapG);
              }
              try { tile._pfHandoff = 0; } catch (e3) {}
              if (window.__rovaGridSeek && window.__rovaGridSeek.id === pvid) { window.__rovaGridSeek = null; }
            });
          }
        }
      }
      if (!liveDone && !gridLiveDone) {
        // GRID (and any fullscreen fallback): the shared still-clone collapse, then rebuild the inline clip over
        // a poster backdrop (grid's ensureVideo technique) so a re-parented <video>'s 1-frame black never shows.
        /* WHY ARE WE HERE? (2026-08-12) 349 of 1,088 logged closes -- 32% -- took this fallback, and 69.6% of
           them recorded the clip resetting to 0 and never recovering, because this path RELEASES the viewer's
           <video> (the deferred wipe retires it) and lets the tile build a fresh element instead. A fresh
           <video> starts at currentTime 0: that IS the measured symptom. The record could not say which of the
           four gates sent it here, so stamp the reason -- vfStart inside __rovaHeroCollapse picks it up. */
        window.__rovaVfWhy = reduceM ? 'reduced-motion' : (!originRect ? 'no-origin' : (!tile ? 'no-tile' : 'no-live-clip'));
        /* 4th arg (2026-09-14): the destination is the on-screen profile AVATAR -- already painted,
           already decoded, and nothing rebuilds it on close -- so the collapse may finish its
           hand-off BEFORE the box lands instead of after. A grid tile cannot: it is rebuilding its
           own preview behind the clone, which is what the +380ms hold is for. Same flag the live-clip
           branch above already uses to refuse a tile landing on this path. */
        var _colOk = false;
        if (window.__rovaHeroCollapse) { _colOk = window.__rovaHeroCollapse(box, originRect, originRadius, originIsAvatar, originIsAvatar ? null : originEl, ringIm ? ringLanded : null); }
        if (ringIm && !_colOk) { ringLanded(); }   // reduced motion / nothing to fly: release the row at once
        /* ...AND STILL BRING THE CLIP HOME. The still-clone above is only the ANIMATION; it says nothing
           about where the live element ends up, and until now the answer was "nowhere -- retired". Mirror
           the open's single-element handoff (heroExpand's `fv0.parentNode.replaceChild(el, fv0)`) on the
           way back: hand the tile the element the reader was actually watching, at the exact frame, behind
           the collapsing still. No rebuild, no seek, no frame-0 pop.
           GUARDS, all of them load-bearing:
             - only with a real grid tile to land in (no tile = nothing to hand it to);
             - only a clip that can PAINT at land time (readyState >= 2). This branch is often taken
               BECAUSE the clip was not decode-ready, and a <video> with no frame composites BLACK -- so a
               not-yet-ready element must stay unlanded and let the tile rebuild over its poster, exactly
               as today. 352ms of extra loading often flips it ready, which is why the test is at LAND
               time, not here;
             - never into a tile that has drifted off screen or been recycled. */
        var _fbTile = tile, _fbV = null, _fbSlide = null;
        if (_fbTile && !reduceM) {
          try {
            var _fbC = box.querySelectorAll('.post .media'), _fx = window.innerWidth / 2, _fy = window.innerHeight / 2;
            for (var _fi = 0; _fi < _fbC.length; _fi++) {
              var _fb = _fbC[_fi].getBoundingClientRect();
              if (_fb.width > 4 && _fb.height > 4 && _fx >= _fb.left && _fx <= _fb.right && _fy >= _fb.top && _fy <= _fb.bottom) {
                var _fs = window.__rovaCenteredSlide ? window.__rovaCenteredSlide(_fbC[_fi]) : _fbC[_fi];
                _fbV = _fs && _fs.querySelector ? _fs.querySelector('video') : null;
                _fbSlide = (_fs && _fs.classList && _fs.classList.contains('cslide')) ? _fs : null;
                break;
              }
            }
          } catch (e3) { _fbV = null; }
        }
        if (_fbV && _fbV.tagName === 'VIDEO') {
          _fbV._pfHoming = 1;   // the blanket pause below must not stop a clip that is on its way home
          setTimeout(function () {
            _fbV._pfHoming = 0;
            if (_closeGen !== pfGen) { return; }                     // superseded cycle -> the new viewer owns everything
            if (!_fbV.isConnected || _fbV.readyState < 2) { return; }  // can't paint -> leave it; the tile rebuilds over its poster
            /* SOMEBODY ELSE ALREADY CLAIMED IT. The borrow branch immediately below runs synchronously and
               moves this very element back into a TIMELINE post when the viewer was opened from the feed's
               fullscreen button -- and a page can carry both a timeline post and a grid cell for the same
               id (a profile), so without this the 356ms timer would rip a clip back out of the post it was
               just returned to. "Still in the viewer" is the honest test of "still mine to move". */
            if (!box.contains(_fbV)) { return; }
            if (!_fbTile.isConnected) { return; }
            var _tr = _fbTile.getBoundingClientRect();
            if (!(_tr.width > 4 && _tr.bottom > 0 && _tr.top < window.innerHeight)) { return; }
            try {
              var _old = _fbTile.querySelector('video.pcell-video');
              if (_old === _fbV) { return; }
              _fbV.className = 'pcell-video';
              _fbV.dataset.grSrc = (function (u) { return (u.slice(0, 5) === 'blob:' || /\.m3u8/i.test(u)) ? '' : u; })(_fbV.currentSrc || _fbV.getAttribute('src') || '');
              _fbV.loop = true; _fbV.muted = true; _fbV.playsInline = true; _fbV.setAttribute('playsinline', '');
              _fbV.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:cover;opacity:1';
              if (_old) { _old.parentNode.replaceChild(_fbV, _old); if (window.__rovaRetireVideo) { window.__rovaRetireVideo(_old); } }
              else { _fbTile.appendChild(_fbV); }
              /* RECORD WHICH SLIDE THE TILE NOW HOLDS -- the same claim+proof the live-move land makes. A
                 tile showing media N while its href still says #m0 sends the next tap to the wrong slide;
                 __rovaGridParkVideo stamps the index AND pins _grHold to this very element, so a later
                 release invalidates the claim instead of leaving a lie behind. */
              try {
                var _fbIdx = (_fbSlide && _fbSlide.parentNode)
                  ? Array.prototype.indexOf.call(_fbSlide.parentNode.querySelectorAll('.cslide'), _fbSlide) : -1;
                if (_fbIdx >= 0 && window.__rovaGridParkVideo) { window.__rovaGridParkVideo(_fbTile, _fbIdx, _fbV); }
                else if (_fbIdx >= 0) { _fbTile.setAttribute('data-gr-slide', String(_fbIdx)); }
                else if (window.__rovaGridUnpark) { window.__rovaGridUnpark(_fbTile, true); }
              } catch (e4) {}
              var _fp = _fbV.play(); if (_fp && _fp.catch) { _fp.catch(function () {}); }
              // the tile now holds the exact frame -- a resume-seek would only yank it backward
              if (window.__rovaGridSeek && window.__rovaGridSeek.id === pvid) { window.__rovaGridSeek = null; }
              if (window.__rovaVfMark) { window.__rovaVfMark('fallbackLand', _fbV); }
            } catch (e3) {}
          }, 356);
        }
        /* THE BORROWED CLIP GOES HOME AS IT IS (2026-09-24). Rob: open a feed video full screen, swipe to
           another post, dismiss -- "the video has a small flicker, instead of smooth buttery appearance or
           resumed playback". This return used to HIDE the clip (opacity 0) over a freshly created poster
           <img> (.fs-repost) and fade it back on its first `timeupdate`, with a 450ms backstop -- a cover
           for "the 1-frame black a re-parented <video> can flash". It was the flash. MEASURED, headless
           1710x1100 on a never-black synthetic clip (so every near-black pixel is an artefact): the
           .fs-repost <img> was gone from the card by +275ms while the clip still sat at opacity 0 until the
           backstop, and the card painted 99.5% BLACK on two consecutive captured frames before the clip
           faded back in at a different picture from the poster that preceded it. A cover withdrawn on a
           timer, over an <img> that had never been decoded, in front of an element that was already
           painting.
           The move itself is not what needs covering, and the geometry says why: this runs synchronously
           inside close(), while the viewer is still fully opaque over the card, and the viewer then takes
           .28s to fade -- any frame the re-parent could cost is spent under it. So a clip that CAN paint
           (a frame decoded, src intact) is simply put back and resumed at its own clock. One that cannot
           (the deck recycled it: src stripped, readyState 0) raises the card's OWN cover -- the decoded
           poster ::before that tlShow drops on a genuinely presented frame -- which is the timeline's one
           tested answer to "this clip has nothing to draw", instead of a second, undecoded stand-in. */
        if (borrow && borrow.media && borrow.media.isConnected && borrow.video && borrow.video.isConnected && !borrow.media.querySelector('video')) {
          var host = borrow.media, vv2 = borrow.video;
          var vv2Paints = vv2.readyState >= 2 && !vv2._recycled && !vv2._released && !!vv2.getAttribute('src');
          vv2.className = borrow.cls;
          if (borrow.styleText) { vv2.setAttribute('style', borrow.styleText); } else { vv2.removeAttribute('style'); }
          vv2._progMuteAt = Date.now();   // programmatic mute -> the sound engine must NOT read it as the user muting
          vv2.muted = true; vv2.loop = true;
          var _snapR = (vv2Paints && window.__rovaFrameSnap) ? window.__rovaFrameSnap(vv2) : null;
          host.insertBefore(vv2, host.firstChild);
          if (!vv2Paints && window.__rovaTlHold) { window.__rovaTlHold(vv2); }
          if (window.__rovaVCtrl)   { try { window.__rovaVCtrl(vv2); } catch (e3) {} }
          if (_snapR && window.__rovaFrameCoverAt) { try { window.__rovaFrameCoverAt(vv2, _snapR); } catch (e3) {} }
          if (window.__rovaPlayNow) { try { window.__rovaPlayNow(vv2); } catch (e3) {} }
        }
      }
      // Only the live flight home still owes the card its clip; every other route has either put it back
      // above or cannot, and either way the box stops being the borrowed slot now (rova.css .fs-away).
      if (!liveDone && borrow && borrow.media) { try { borrow.media.classList.remove('fs-away'); } catch (e3) {} }
    } catch (e) {}
    if (box._pagerReset) { box._pagerReset(); }   // cancel a mid-landing animation + restore the scroller styles
    /* SILENCE THE VIEWER -- EXCEPT WHAT IS ON ITS WAY HOME (2026-08-12). This sweep is unconditional and
       runs milliseconds into the dismiss, so it used to pause the very element the fallback land is about
       to hand to the grid tile: the tile then received a PAUSED clip and had to be restarted, which is the
       pl=false at ms 100 in the flight log. The live-move paths are already out of the box by now (flyCrop
       reparents to <body>); _pfHoming covers the one that is still sitting in the list waiting for 356ms.
       It is cleared by the land itself, so nothing can leave a clip permanently exempt. */
    Array.prototype.forEach.call(box.querySelectorAll('video'), function (v) { try { if (!v._pfHoming) { v.pause(); } } catch (e) {} });
    /* ...AND THE MUSIC (owner 2026-08-09: "when i exit this viewer or close the media the player should
       stop, currently it keeps playing"). The line above is why it survived: it silences every <video>
       IN THE BOX, and the Apple Music preview is not in the box -- it is not in the DOM at all. It plays
       through a detached `new Audio()` in the embed block's closure, so the only way to reach it is to
       ask. This is the ONE dismissal chokepoint (close X, the back chevron, Escape/space, the swipe-away,
       and browser back via the popstate handler above all end here), which is the same argument
       __rovaBgHold hangs off pfLock/pfUnlock two hundred lines down. Navigating AWAY to another page is
       covered separately, by amHalt on pagehide, because that never reaches close() at all. */
    if (window.__rovaAmStop) { try { window.__rovaAmStop(); } catch (e) {} }
    /* HAND THE BACKGROUND BACK -- AFTER THE FLIGHT, NOT DURING IT. Only the clip(s) __rovaFeedView paused
       on the way in -- never a video that was already paused, and never anything the reader touched while
       the viewer was up.
       DEFERRED (2026-08-12): this is a whole-document querySelectorAll plus a __rovaPlayNow per hit, and
       play() on a paused clip spins its decoder back up -- several of them, synchronously, on the frame
       the collapse tween starts. It was inside the 50-250ms rafWorst cluster (395 of 1,088 closes). Nothing
       is watching these clips yet: they sit BEHIND a viewer that is still fading out for another 280ms and
       under a collapse clone that covers the landing tile until ~550ms. Resuming them a third of a second
       later is invisible; stealing frames from the dismiss is not. */
    setTimeout(function () {
      Array.prototype.forEach.call(document.querySelectorAll('video'), function (v) {
        // the reader's pause outranks everything the open or the close did (pfRememberUserPauses)
        if (v._rovaUserPausedAtOpen) {
          v._rovaUserPausedAtOpen = 0; v._userPaused = true;
          if (!v.paused) { try { v.pause(); } catch (e) {} }
          return;
        }
        if (!v._rovaBgPaused) return;
        v._rovaBgPaused = 0;
        if (window.__rovaPlayNow) { try { window.__rovaPlayNow(v); } catch (e) {} }
      });
    }, 400);
    pfUnlock();
    clearTimeout(idleT);
    cur = null;   // in-flight fetches (loadMore etc.) check `cur` and bail as soon as this changes
    // Explicit transition (not just whatever rova.css's .pfeed/.pfeed.show already declares) so this
    // always animates the same way regardless of how we got here -- including right after the
    // swipe-to-dismiss drag, which sets its own inline transform/transition moments before calling
    // close(); this line takes over and covers both properties together.
    // Keep `visibility` visible for the whole fade (delay the flip to hidden until the end), MATCHING the base
    // .pfeed rule. Without the visibility clause the inline transition dropped it, so `visibility` snapped to
    // hidden on the first frame -- the viewer vanished instantly and the grid behind flashed for a frame before
    // the collapse clone took over (owner video: "clears out the whole photo exposing the grid in one frame").
    box.style.transition = 'opacity .28s cubic-bezier(.22,.61,.36,1), transform .28s cubic-bezier(.22,.61,.36,1), visibility 0s linear .28s';
    box.classList.remove('show', 'pfeed-idle');
    try { if (window.__rovaPfStillSync) window.__rovaPfStillSync(); } catch (e) {}   // .show just left -> html.pfv-on off
    // Don't wipe the content until the fade-out actually finishes, or the viewer goes visibly blank
    // mid-animation. transitionend is the real signal; the timeout is just a safety net in case
    // nothing was actually different enough to fire one (e.g. already mid-transition).
    var done = false;
    /* THE WIPE IS THE HEAVIEST THING IN THE DISMISS, AND IT WAS LANDING ON THE HANDOFF FRAME (2026-08-12).
       finish() fires on transitionend (~280ms) or the 350ms safety timer, and clearPfeedList() then does,
       synchronously: __rovaReleaseVideos over every clip in the list (each one pause + hls.destroy +
       removeAttribute('src') + load()), a querySelectorAll('img') unobserved from THREE IntersectionObservers,
       list.innerHTML = '' tearing down the whole subtree, and stopOrphans() walking the media registry.
       The crop-flight's handoff -- the reparent that carries the clip home -- is at 352ms. The two were
       fighting for the same frame, and the flight log shows it exactly: a sharp isolated spike of 87 records
       whose worst frame gap lands in the 400-450ms bucket, on top of a 340ms tween that is otherwise pure
       compositor work.
       So: keep finish()'s cheap, ORDER-SENSITIVE parts on the transition (phase, inline styles, listener
       teardown) and push only the wipe past the landing. 620ms clears the 352ms handoff, the 356ms fallback
       land and the collapse clone's 380-550ms cross-fade, so by the time the list is torn down nothing on
       screen is reading from it. The clips in it were already paused at the top of close().
       IT IS STILL EXACTLY ONE WIPE, still reachable the same way: pfPendingFinish keeps pointing at the
       remaining work, so pfFinalize() hard-completes it before any new open, and a reopen inside the window
       cancels it (the .show re-check) precisely as before. */
    var wipeT = null;
    function wipeNow() {
      if (wipeT) { clearTimeout(wipeT); wipeT = null; }
      pfPendingFinish = null;
      if (box.classList.contains('show')) { return; }   // reopened inside the window: the fresh viewer owns the list
      clearPfeedList();   // release the clips/images before detaching them (else the observers pin them: leak)
    }
    function finish() {
      if (done) return; done = true;
      box.removeEventListener('transitionend', onEnd);
      pfCloseTimer = null; pfCloseOnEnd = null;
      // REOPENED within the fade (rapid open->close->open): the new open re-added .show. NEVER wipe it -- that
      // stale-finish clearPfeedList() is exactly what blanked the fresh viewer and fed the retap/overlap.
      if (box.classList.contains('show')) { pfPendingFinish = null; return; }
      box.style.transform = ''; box.style.transition = '';
      pfPhase = 'idle';
      pfPendingFinish = wipeNow;
      wipeT = setTimeout(wipeNow, 620);
    }
    function onEnd(e) { if (e.target === box) finish(); }
    pfPendingFinish = finish; pfCloseOnEnd = onEnd;
    box.addEventListener('transitionend', onEnd);
    pfCloseTimer = setTimeout(finish, 350);
  }

  /* the post nearest the top of the scroll viewport.
     MEMOISED ON THE SCROLL POSITION, and EARLY-EXITING (2026-08-12). This is a getBoundingClientRect
     on EVERY rendered post, and one settle pass asks for the answer four or five times over --
     recyclePfeedMedia, then pruneFarPosts inside it, then updateFeedBar, then rpSettle, then
     hfOnScroll -- all inside the same task, all against the same scroll position. MEASURED on a
     20-post fling (nojumper grid, 4x CPU, 1.6Mbps) at 18 posts in the DOM: ~530ms across the burst,
     19ms per call, because each call ran after something else had dirtied layout.
     THE KEY IS scrollTop, NOT A TIMESTAMP. A cache with a time window would hand back the wrong post
     mid-fling, which is the whole class of bug [[transform-glide-fires-no-scroll-events]] is about --
     the answer must be wrong ONLY if the scroll position is unchanged, in which case it isn't wrong.
     `posts.length` joins the key because loadMore/loadBefore/pruneFarPosts can change which node sits
     at a given offset without the reader moving. Reading scrollTop is itself one forced layout, so
     the repeat calls go from N+1 reads to 1.
     THE EARLY EXIT is free and independent: a vertical list's post tops are monotonically increasing,
     so once the distance starts GROWING again every later post is further still. That turns the
     first (uncached) call from N rects into ci+2 -- and the reader is usually near the top of what is
     rendered ahead of them, which is exactly where the scan now stops.

     ---- A CACHE HIT NOW COSTS NO LAYOUT READ AT ALL  (2026-08-17) --------------------------------
     The block above says "Reading scrollTop is itself one forced layout, so the repeat calls go from
     N+1 reads to 1". The first half was true and the conclusion was not: keying ON scrollTop means
     every call still READS scrollTop, so N+1 reads became N reads -- the rect LOOP was removed and the
     flush was not. MEASURED on one 4x-CPU open by pairing Blink's own
     `Blink.ForcedStyleAndLayout.UpdateTime` events against the read that preceded each: 19 scrollTop
     reads from this line, 373ms of forced style+layout, the largest single one 228ms. Seven of them
     landed inside a single 20ms window, from seven independent consumers (pfCurrentVideo, pfSound,
     pfVoiceReady, updateFeedBar, recyclePfeedMedia, hfTick, the settle resolver) all asking the same
     question at the same scroll position.

     WHY 228ms FOR ONE READ. It is never this function's own work. heroRelease takes `hz-hold` OFF
     <html> at the landing, which invalidates style document-wide (rova.css 4354-4377 are descendant
     rules), and whichever poller reads geometry next pays the whole recalculation synchronously --
     and then the frame's own rendering update does it again. Serving that call from cache does not
     make the recalculation cheaper; it makes it happen ONCE, at the rendering update, where it is
     pipelined instead of blocking a task.

     THE KEY IS NOW AN EVENT, AND THAT IS STRICTLY STRONGER THAN THE scrollTop IT REPLACES -- not
     weaker, which is the thing to check. The contract the header states is "the answer may be reused
     only while the scroll position is unchanged". A `scroll` event is DISPATCHED FOR EVERY CHANGE OF
     SCROLL POSITION, user or programmatic (setting scrollTop performs a scroll, which queues the
     event), and the scroll steps run during update-the-rendering, i.e. BEFORE that frame's rAF
     callbacks and before any settle handler -- so no consumer can be handed a stale answer across a
     real scroll. It also catches the one thing the scrollTop key could not: a compositor scroll that
     lands on the same integer offset is a no-op for both, and a change of position always fires.
     `posts.length` stays in the key for the same reason it was added (loadMore / loadBefore /
     pruneFarPosts can move which node sits at an offset without the reader moving), and it is not a
     layout read. NOT a time window: that is the failure [[transform-glide-fires-no-scroll-events]]
     is about, and the whole point here is that the invalidation is causal rather than temporal.

     AND THAT NOTE NAMES THE ONE CASE WORTH CHECKING BY HAND, so here it is checked: settleTo() pages
     the deck by animating translateY on the LIST and fires no scroll event for 260ms, then commits
     `scroller.scrollTop += delta` in one synchronous block at the end. During the glide the scroll
     POSITION is genuinely unchanged, so the old scrollTop key was a cache HIT there too and handed back
     the pre-glide post exactly as this does -- and the commit both changes scrollTop and queues a scroll
     event, so the two keys invalidate on the same statement. Same answers, same instant, one fewer
     forced layout: the event is not a weaker proxy for the position, it is the position's own signal. */
  var _cpEl = null, _cpN = -1, _cpDirty = 1, _cpBound = null;
  function currentPost() {
    // NO VIEWER BUILT YET (list is null until build()): pages without a feed, e.g. /live/browser, still reach this
    // through window.__rovaPfCurrentVideo from the resume governor's visibilitychange/pageshow path. Nothing is current.
    if (!list || !scroller) { return null; }
    var posts = list.querySelectorAll('.post');
    if (!posts.length) { _cpEl = null; _cpN = -1; _cpDirty = 1; return null; }
    if (_cpBound !== scroller && scroller) {
      /* build() is `if (box) return box`, so the scroller is created once and outlives every open --
         this is one listener for the life of the page and there is nothing to tear down (clearPfeedList
         wipes the LIST, not the scroller). The guard keys on the ELEMENT rather than a boolean anyway,
         so if that ever stopped being true the listener would follow the new scroller instead of
         silently pinning the cache to a detached one. Capture is not needed: the target is the
         scroller itself, and a scroll on it does not bubble past it usefully. */
      _cpBound = scroller;
      scroller.addEventListener('scroll', function () { _cpDirty = 1; }, { passive: true });
    }
    if (!_cpDirty && _cpEl && _cpN === posts.length && _cpEl.isConnected) { return _cpEl; }
    var top = scroller.getBoundingClientRect().top, cur = posts[0], best = Infinity;
    for (var i = 0; i < posts.length; i++) {
      var d = Math.abs(posts[i].getBoundingClientRect().top - top);
      if (d < best) { best = d; cur = posts[i]; }
      else if (best !== Infinity) { break; }   // tops only increase: past the nearest, everything is further
    }
    _cpEl = cur; _cpN = posts.length; _cpDirty = 0;
    return cur;
  }

  // Empty the pfeed list PROPERLY: release every clip (unobserve from playIO/warmIO + free its decoder) and
  // unobserve every image from pfImgWarmIO BEFORE detaching the nodes -- otherwise a plain `list.innerHTML=''`
  // (on close, or the reset when a new viewer opens) leaves all those elements pinned by the observers as a
  // detached-DOM leak. Use this everywhere the whole list is wiped.
  function clearPfeedList() {
    if (!list) return;
    if (window.__rovaReleaseVideos) { window.__rovaReleaseVideos(list); }
    // STOP any playing carousel slideshow (RC6): its _ssT self-reschedules on the DETACHED subtree after
    // innerHTML='' and pins the whole thing -- __cstop clears the timer + disconnects _ssIO deterministically.
    Array.prototype.forEach.call(list.querySelectorAll('.carousel.carousel-playing'), function (c) { try { if (c.__cstop) c.__cstop(); } catch (e) {} });
    // Unobserve every image from ALL THREE singleton observers (RC4). Wiping innerHTML with any of these still
    // observing leaves the detached <img>s strongly referenced = a per-open/close detached-DOM leak. pfImgWarmIO
    // was already handled; pfBytesIO + kbIO were the forgotten siblings (kbIO never self-unobserves).
    Array.prototype.forEach.call(list.querySelectorAll('img'), function (im) {
      try { if (pfImgWarmIO) pfImgWarmIO.unobserve(im); } catch (e) {}
      try { if (pfBytesIO)  pfBytesIO.unobserve(im); } catch (e) {}
      try { if (kbIO)       kbIO.unobserve(im); } catch (e) {}
    });
    list.innerHTML = '';
    // BACKSTOP: anything the viewer stranded OUTSIDE this list (a clip a handoff swapped out, a flight
    // that lost its element) is not reachable by the query above and would keep playing until reload.
    // Silence it now, while we are already tearing the viewer down. See __rovaStopOrphanMedia.
    if (window.__rovaStopOrphanMedia) { try { window.__rovaStopOrphanMedia(); } catch (e) {} }
    /* AND THE LOCK SCREEN GOES WITH THEM (2026-09-03). The clips this list held have just left the
       document, so any MediaMetadata naming one of them is now describing something that cannot be
       resumed. This is the honest moment to say so -- pfUnlock() ran BEFORE the fade, while every
       clip was still attached and merely paused, and a Media Session deliberately survives a pause
       (that is how a reader gets back from an iOS screen lock). The governor re-reads the elements
       and clears itself when its clip is gone; if a permalink's own card resumes behind the viewer,
       its next `playing` re-arms the session for that clip on the ordinary path.
       SYNCHRONOUS, NOT COALESCED: this whole function is the teardown, and the 3s sweep is a
       backstop, not a schedule to hand a user-visible surface to. */
    if (window.__rovaWakeTick) { try { window.__rovaWakeTick(); } catch (e) {} }
  }

  // Bound the pfeed's live media: tear down videos more than a few posts from the one in view (the
  // video controller owns teardownVideo; this just tells it which post is current). Without this an
  // endless scroll accumulates HLS decoders + buffers until the phone locks up.
  // ---- adaptive memory guard ---------------------------------------------------------------------------
  // memPressure(): used JS heap / heap limit in [0..1], or -1 when the browser won't tell us (Safari/Firefox
  // have no performance.memory). Chromium's number is coarse + same-origin-throttled but plenty to steer
  // pruning by. _lowRAM: a coarse "this is a small device" flag (Chromium-only navigator.deviceMemory).
  var _lowRAM = !!(navigator.deviceMemory && navigator.deviceMemory <= 2);
  function memPressure() {
    try {
      var m = window.performance && performance.memory;
      if (m && m.jsHeapSizeLimit > 0) { return m.usedJSHeapSize / m.jsHeapSizeLimit; }
    } catch (e) {}
    return -1;
  }
  // performance.memory (Chromium only, and coarse) counts the JS heap but NOT decoded image bitmaps -- and
  // those multi-MB ~1080px decodes are the REAL tab-killer on phones. So we also estimate the resident
  // decoded-image pool directly (naturalW*naturalH*4 per still-loaded pfeed img). Works in EVERY browser and
  // targets the actual crash cause; budget scales with the device's RAM (deviceMemory hint), clamped sane.
  function pfImageBytes() {
    var total = 0;
    if (!list) return 0;
    Array.prototype.forEach.call(list.querySelectorAll('.media img, .cslide img'), function (im) {
      if (im.getAttribute('src') && im.naturalWidth) { total += im.naturalWidth * im.naturalHeight * 4; }
    });
    return total;
  }
  var _imgBudget = Math.max(60, Math.min(400, (navigator.deviceMemory || 4) * 60)) * 1048576;   // ~60MB/GB, 60..400MB
  // Visibility for the owner: what the running browser actually gives us + where we sit right now.
  window.__rovaMemStats = function () {
    var m = null; try { m = window.performance && performance.memory; } catch (e) {}
    var mb = function (b) { return b ? Math.round(b / 1048576) : null; };
    return {
      supported: !!m, deviceMemoryGB: navigator.deviceMemory || null, lowRAM: _lowRAM,
      usedMB: m ? mb(m.usedJSHeapSize) : null, limitMB: m ? mb(m.jsHeapSizeLimit) : null,
      pressure: m ? +(m.usedJSHeapSize / m.jsHeapSizeLimit).toFixed(3) : null,
      decodedImageMB: mb(pfImageBytes()), imageBudgetMB: mb(_imgBudget),
      postsInDom: (list ? list.querySelectorAll('.post').length : 0)
    };
  };
  // Even if the reader sits still on a heavy post (many decoded bitmaps already resident), keep checking the
  // pressure on a timer and trim toward the target so we never park near the ceiling. Cheap: it no-ops unless
  // the viewer is open AND we're actually reading a real number over the line.
  var _memGuard = setInterval(function () {
    if (!box || !box.classList.contains('show')) return;
    // never inside a flight: pfImageBytes() walks every pfeed img and recyclePfeedMedia()/
    // __rovaReleaseGridVideos() tear down decoders -- a 4s tick has no business landing on the one frame
    // an open or a dismiss is animating. It will trim 4s later, on a clean thread.
    if (window.__rovaFlightBusy && window.__rovaFlightBusy()) return;
    if (memPressure() >= 0.85 || pfImageBytes() > _imgBudget) {
      recyclePfeedMedia(true);   // unload +/-1 and prune far nodes NOW
      if (window.__rovaReleaseGridVideos) { window.__rovaReleaseGridVideos(); }   // RC3: relieve grid decoders under pressure too, not just pfeed media
      /* ...and hold the grid's raised budget DOWN for a while afterwards (2026-08-10). Releasing the
         decoders without lowering the cap just means the grid rebuilds straight back up to 5/12 the
         moment the viewer closes, into the same pressure that triggered this. Extends the existing
         guard rather than adding a second, competing mechanism. */
      if (window.__rovaGridRelieve) { window.__rovaGridRelieve(); }
    }
  }, 4000);

  function recyclePfeedMedia(settled) {
    if (!list || !box || !box.classList.contains('show')) return;
    // keep the current clip + 2 each side live (owner: "the next 2 posts at LEAST should be cached,
    // downloaded and ready for the swipe -- I should see the top of the next post dragging up with it"):
    // 5 posts total. The 2 BEHIND are "recents" for a back-swipe, the 2 AHEAD stay buffered + painted for
    // forward swipes. Anything past that has BOTH its video torn down (decoders/buffers) AND its photos
    // unloaded (decoded bitmaps) so a long scroll can't pile either up until iOS starves the tab. Must be
    // >= warmIO's lead (now ~2 posts) or a warm would immediately rebuild what this just released. Runs
    // THROUGHOUT a fling (see the scroll handler), not only on settle. The adaptive memory guard still
    // tightens everything under real pressure (_memGuard / pruneFarPosts hot mode).
    var KEEP = window.__rovaPfLA || 2;   // adaptive: 2 mobile, 3 high-RAM desktop (see PF_LA)
    var cp = currentPost();
    /* CONTAINMENT FOLLOWS THE READER (2026-08-17). This pass already runs throughout a fling and again on
       settle, already has `cp`, and already early-returns when the viewer is not up -- so it is the pass
       that owns "which card is exempt from content-visibility" too, rather than a second observer with its
       own root, rootMargin and two teardown paths to be unobserved from. See pfCvOn().
       ...BUT WHILE A FLUSH IS PENDING THE EXEMPTION IS PINNED TO THE TARGET, and that is not a detail.
       TRACED on a live open: as pfFlushPark prepends the cards that belong ABOVE the reader, each
       insertBefore + scrollTop fix-up fires a scroll, and currentPost() answered with the card that had
       just been spliced in -- so the exemption walked 43079 -> 43049 -> 42651 in 900ms and laid every one
       of them out IN FULL, which is precisely the per-card cost this round exists to stop paying. For as
       long as the flush is running there is exactly ONE card the reader can see: the one they tapped. */
    pfCvOn((pfPark && pfPark.tgt && pfPark.tgt.isConnected) ? pfPark.tgt : cp);
    /* ...AND IT IS THE EVENT-FREE HALF OF THE CLAMP RE-ARM. fitPfeedMedia defers a card it finds
       containment-skipped and flags it _pfCvPend; contentvisibilityautostatechange normally brings it
       back, but that event is Chromium-only, so any scroll that leaves a flagged card renderable
       re-enters the (idempotent) fit here. One class test per card, no layout read.
       ...BUT ONLY FOR THE CARDS THAT CAN HAVE BECOME RENDERABLE (scroll-smooth audit, 2026-09-06).
       The old sweep asked "is ANY card pending?" -- and a far card is pending for as long as it is far,
       because containment keeps skipping it. So on a long list `pend` was true on EVERY 250ms pass of a
       fling, and fitPfeedMedia re-asked pfCvSkipped() of EVERY card each time. That check is two
       checkVisibility() calls per card, and a geometry/visibility query on a content-visibility:auto
       subtree FORCES that subtree to style+layout -- i.e. the pass un-skipped every parked card, four
       times a second, for the whole swipe. Measured (raw bundle, phone viewport, CPU x4, 15s of swipes):
       checkVisibility was the single largest JS self-time on the viewer, 2.5s of a 15s window.
       Now the pend test runs over the KEEP window around the current post only (the same window the
       media recycle below keeps live), and the fit is scoped to those cards. A far card keeps its flag
       and is fitted on the pass that brings it near, exactly as before -- one pass later than the
       Chromium event would, which the fallback was always designed to tolerate. */
    var _pendPosts = list ? list.querySelectorAll('.post') : [], _pendCi = Array.prototype.indexOf.call(_pendPosts, cp);
    if (_pendCi >= 0) {
      var pendNear = [];
      for (var _pi = Math.max(0, _pendCi - KEEP - 1); _pi < _pendPosts.length && _pi <= _pendCi + KEEP + 1; _pi++) {
        if (_pendPosts[_pi]._pfCvPend) { pendNear.push(_pendPosts[_pi]); }
      }
      if (pendNear.length) { fitPfeedMedia(pendNear); }
    }
    if (window.__rovaRecycleVideos) { window.__rovaRecycleVideos(cp, KEEP); }
    // SLIDESHOW: once settled, auto-play the CURRENT post's multi-media carousel (opened or swiped to) and
    // stop any carousel that's no longer current. Video slides included now -- __cplay dwells on a playing
    // clip instead of skipping it. The carousel's own observer also stops it when it scrolls away.
    // HANDS-FREE OWNS THE CURRENT CAROUSEL while the reel is running: it starts the very same __cplay in
    // `once` mode (stop at the last slide + call back so the POST advances) instead of this wrapping one,
    // and two starters would fight over the same _ssT. Stopping a carousel that is no longer current is
    // still correct in both modes, so only the START is gated.
    if (settled && list) {
      Array.prototype.forEach.call(list.querySelectorAll('.carousel'), function (c) {
        var isCur = !!(cp && (c === cp || cp.contains(c)));
        if (isCur && c.__cplay && !c.__cplaying && !hfRunning()) { c.__cplay(); if (typeof toast === 'function') { toast('Slideshow started'); } }   // videos too: __cplay now dwells on a playing clip instead of skipping it
        else if (!isCur && c.__cplaying && c.__cstop) { c.__cstop(); }
      });
    }
    var posts = list.querySelectorAll('.post');
    var ci = Array.prototype.indexOf.call(posts, cp);
    if (ci < 0) return;
    Array.prototype.forEach.call(posts, function (p, i) {
      var imgs = p.querySelectorAll('.media img, .cslide img');
      if (!imgs.length) return;
      if (Math.abs(i - ci) <= KEEP) {
        Array.prototype.forEach.call(imgs, function (img) { if (img.dataset && img.dataset.pfSrc) pfRestoreImg(img); });
      } else {
        Array.prototype.forEach.call(imgs, pfUnloadImg);
      }
    });
    // Node pruning changes scrollTop, so only do it once the swipe has SETTLED -- doing it mid-fling
    // could interrupt iOS momentum scrolling. Media teardown above (no scroll change) runs every pass.
    if (settled) { pruneFarPosts(); }
  }

  // Cap the pfeed DOM. An infinite forward scroll appends post cards forever; even with their media
  // unloaded, the bare nodes (+ listeners, observer entries, avatar bitmaps) pile up until a phone runs
  // out of memory. Drop the far-BEHIND cards (keep the last few as "recents" for a back-swipe), pinning
  // the current post visually via its measured position (robust to any card height), and bump headIdx so
  // loadBefore re-materializes them if you swipe back up. Feed mode only (loadBefore rebuilds from
  // cur.ids); the AHEAD side is already bounded by the buffer-ahead logic.
  /* #634 ...AND A REPEAT SCOPE, which is the one non-feed pager that genuinely needs this.
     The rule above ("feed mode only, because loadBefore rebuilds from cur.ids") was written for the
     PROFILE pager, which walks an author's set once and stops. A repeat scope does the opposite by
     design: it wraps at the end and appends the same handful of cards again, for as long as the
     reader sits there. Measured under the wrap on an author with 4 grid posts, ten forced pages took
     the list to 27 laps -- ~148 nodes and climbing with nothing to trim them, since live MEDIA is
     bounded by recyclePfeedMedia but bare cards are not. So the scope opts in.
     WITHOUT the headIdx bump, deliberately. headIdx is an index into cur.ids, and most of what gets
     pruned here is not in cur.ids at all -- it is the scope's own repeats. Leaving it alone means the
     feed history that was pruned along with them is exactly what loadBefore re-prepends if repeat is
     switched back off, which is the state the reader would expect to come back to. */
  function pruneFarPosts() {
    if (!cur || !list) return;
    if (cur.mode !== 'feed' && !cur.rpUser) return;
    var posts = list.querySelectorAll('.post');
    // Prune in BATCHES, not on every deep swipe. The old code trimmed the one post that fell past the keep
    // window each settle -- so almost every landing did a node-removal + scrollTop fix-up, a small repeated
    // hitch the smooth (never-pruned) profile pfeed doesn't have. Only kick in once the DOM has genuinely
    // grown; media is already bounded to +/-4 by the live recycle, so a slightly bigger node set is free.
    // ADAPTIVE to real memory pressure (owner: "destroy old memory near ~85% so it's efficient forever, no
    // crashes"). Browsers vary hugely in how much a tab may hold before the OS kills it -- desktop Chrome has
    // GBs of JS heap, a low-end phone a few hundred MB, and Safari/Firefox don't even expose the number. Where
    // we CAN read it (Chromium performance.memory), the closer used/limit climbs to the ceiling the SOONER and
    // HARDER we prune; where we can't, deviceMemory <=2GB keeps us tight and everyone else keeps the tested
    // windows. So the tab trims itself down as it approaches its own device's limit instead of climbing into a
    // crash. See memPressure()/__rovaMemStats.
    var pr = memPressure();
    var hot = pr >= 0.85 || pfImageBytes() > _imgBudget || (pr < 0 && _lowRAM && posts.length > 40);   // >=85% heap, over the decoded-image budget, or small-RAM gone long
    var trigger = hot ? 12 : (_lowRAM ? 20 : 30);
    if (posts.length <= trigger) return;
    var KEEP_BEHIND = hot ? 3 : (_lowRAM ? 5 : 8);   // > media KEEP(1): only nodes whose media is already unloaded go
    var cp = currentPost();
    var ci = Array.prototype.indexOf.call(posts, cp);
    if (ci <= KEEP_BEHIND) return;             // not enough behind to bother
    var cut = ci - KEEP_BEHIND, doomed = [];
    for (var i = 0; i < cut; i++) { if (posts[i] && posts[i] !== cp) doomed.push(posts[i]); }
    if (!doomed.length) return;
    var beforeTop = cp.getBoundingClientRect().top;                 // anchor's viewport position now
    doomed.forEach(function (p) {
      if (window.__rovaReleaseVideos) { window.__rovaReleaseVideos(p); }   // unobserve + free the clip (the detached-node leak fix)
      Array.prototype.forEach.call(p.querySelectorAll('.carousel.carousel-playing'), function (c) { try { if (c.__cstop) c.__cstop(); } catch (e) {} });   // RC6
      Array.prototype.forEach.call(p.querySelectorAll('img'), function (im) {   // RC4: all three observers, not just pfImgWarmIO
        try { if (pfImgWarmIO) pfImgWarmIO.unobserve(im); } catch (e) {}
        try { if (pfBytesIO)  pfBytesIO.unobserve(im); } catch (e) {}
        try { if (kbIO)       kbIO.unobserve(im); } catch (e) {}
      });
      if (p.parentNode) { p.parentNode.removeChild(p); }
    });
    var afterTop = cp.getBoundingClientRect().top;                  // shifted up after removing above
    scroller.scrollTop += (afterTop - beforeTop);                   // put the current post back where it was
    // feed mode only: headIdx is an index into cur.ids and a repeat scope's cards are not in it (see above)
    if (cur.mode === 'feed') { cur.headIdx = (cur.headIdx || 0) + doomed.length; }   // loadBefore re-prepends these on a back-swipe
  }

  /* page to the prev/next post (dir -1/+1). We move scrollTop OURSELVES, frame by frame, rather than
     handing the browser a `scrollIntoView`/`scrollTo({behavior:'smooth'})` call, because the native
     smooth-scroll implementation fights scroll-snap:mandatory on this container (it snaps back mid-
     glide) -- that was the whole reason this used to be a single instant scrollTop write. A manual rAF
     tween sidesteps that failure mode entirely: it never invokes the browser's own smooth-scroll
     machinery, it only ever writes the plain (non-animated) `scrollTop` property, once per frame, which
     is exactly the write scroll-snap already tolerates from the old instant version -- just spread over
     several frames instead of one.
     owner 2026-08-12: "I should see the media swipe up into view instead of just appear" (hands-free
     auto-advance specifically -- hfNext() is step()'s main caller, see below; the ArrowDown/ArrowUp
     handler in build() is the other, and the claim that there is "exactly one" was already stale when
     the identity handover below was written against it). 'scroll' is
     deliberately NOT in the engagement-attention renewal set (see ENG_QUIET above) and hfOnScroll's own
     re-arm check is debounced 180ms behind the LAST scroll event, so a tween that keeps firing scroll
     events every frame for ~300ms is invisible to both of those systems until it settles -- nothing here
     needed to change for many scrollTop writes to be as safe as the one it replaces.
     ABORTS CLEANLY if hands-free stops mid-glide (paused, closed, or superseded by another advance):
     genGuard is the same stale-callback pattern every timer in this block already uses. Reduced-motion
     keeps the instant jump -- a tween is still motion. */
  /* ---- THE VIEWER NEVER RESTS BETWEEN TWO POSTS (2026-10-08, Rob, desktop Safari: a live replay opened
     from the feed showed "a strip of a different video above a full-width video of me") ------------------
     That picture is the PAGER resting part-way between two cards: the bottom ~195px of the portrait replay
     above it (a 633px-wide 9:16 picture, centred) over the landscape one. Reproduced on the live bundle:
     scroll-snap was OFF and a programmatic scroll had stopped mid-way. Three holes, all in this block:
       a. step() SAVED AND "RESTORED" scroll-snap-type. A step started while another step's tween (or
          settleTo's glide) had snap suspended saved 'none' -- and restored 'none' at its end, so snap was
          off for every later open too (the box is built once and reused). Two quick ArrowDowns did it;
          so does a hands-free advance landing on a wheel/key step.
       b. its tween wrote ABSOLUTE scrollTop values measured at the start, so a card loadBefore/pfFlushPark
          inserted above mid-tween (the open's own first prepend, ~0.5s in) sent it to the wrong post
          (measured: ArrowDown 700ms after an open landed FIVE posts back);
       c. an abort (hands-free paused/stopped mid-tween) left the scroller wherever the tween was.
     With snap off, (c) or any native scroll that slipped through rests between posts for good. So: one
     tween owns the scroller at a time (pfStepTok), it steers by the target's LIVE position each frame, the
     restore always goes back to the stylesheet's mandatory snap, an abort lands on the nearest post, and
     the scroller's trailing settle re-checks the rest position (pfRestFlush). */
  var pfStepTok = 0, pfStepOn = 0, pfFingers = 0;
  document.addEventListener('touchstart', function (e) { pfFingers = (e.touches && e.touches.length) || 1; }, { passive: true, capture: true });
  document.addEventListener('touchend', function (e) { pfFingers = (e.touches && e.touches.length) || 0; }, { passive: true, capture: true });
  document.addEventListener('touchcancel', function () { pfFingers = 0; }, { passive: true, capture: true });
  function pfRestFlush(force) {
    if (!box || !list || !scroller || !box.classList.contains('show') || pfPhase === 'closing') return;
    if (pfFingers > 0) return;                                                   // a finger is still on it
    var ae = document.activeElement;                                             // typing: the field's own landing may offset it
    if (ae && (/^(INPUT|TEXTAREA|SELECT)$/.test(ae.tagName) || ae.isContentEditable)) return;
    if (scroller.style.overflowY === 'hidden' || list.style.transform) return;   // settleTo's glide owns it
    if (!force && (pfStepOn || document.documentElement.classList.contains('hz-hold'))) return;
    if (!pfStepOn && scroller.style.scrollSnapType === 'none') { scroller.style.scrollSnapType = ''; }
    var top = scroller.getBoundingClientRect().top, ps = list.children, d = Infinity;
    for (var i = 0; i < ps.length; i++) {
      if (!ps[i].classList || !ps[i].classList.contains('post')) continue;
      var dd = ps[i].getBoundingClientRect().top - top;
      if (Math.abs(dd) < Math.abs(d)) { d = dd; }
    }
    if (Math.abs(d) > 1 && Math.abs(d) < scroller.clientHeight) { scroller.scrollTop += d; }
  }
  function step(dir) {
    var posts = Array.prototype.slice.call(list.querySelectorAll('.post'));
    var cur = currentPost();
    var curi = posts.indexOf(cur);
    if (curi < 0) return;
    var t = curi + dir;
    if (t < 0 || t >= posts.length) return;
    var target = posts[t];
    /* THE CHROME MUST BE THERE ALREADY (owner 2026-08-14: "the chrome fades in too late, it should
       be there already. I've noticed the laggy late chrome fades in on both the web and app").
       NOTHING DROPPED .pfeed-idle FOR A PROGRAMMATIC ADVANCE. The only thing that ever did was the
       capture-phase 'scroll' listener bound in build(), and that cannot fire until the tween below
       has actually written scrollTop -- one rAF later, with the scroll event itself dispatched in
       the rendering steps of the frame AFTER that. So the new post started landing with the chrome
       still at opacity 0 and only THEN began its .35s ease fade-in (rova.css: `.pfeed .post .body,
       ... .pfeed-x,.pfeed-menu{transition:opacity .35s ease}`). Worse in the hfReduced()/|delta|<2
       branch two lines down, where the post lands in THIS frame and the fade has not even started.
       AND IT FIRED ON EVERY ADVANCE, because the chrome is always idle by the time hfNext() runs:
       HF_PHOTO_MS is 5000 against the 3200ms idle dwell, and a video advances on a full pass.
       Waking HERE -- the moment the target is known, before a single pixel moves -- gives the fade
       the whole 320ms tween to run in, so the chrome is fully present as the post arrives.
       wake() AND NOT A BARE classList.remove: it also re-arms the SAME 3200ms idle clock on the
       SAME terms a finger does, so a hands-free reel still rests between advances and there is no
       second fade path that can drift from the first. Called with no event, which wake() accepts.
       A FINGER SWIPE NEEDS NOTHING HERE: wake() has already fired on pointerdown/touchstart long
       before settleTo() glides, which is why that path was never the complaint. */
    wake();
    /* THE IDENTITY MAY NOT LEAD THE MEDIA (owner 2026-09-01: "Sitting here watching the auto pfeed
       sometimes shows an invalid username/chrome that doesn't match the current media").
       wake() STAYS ABOVE -- it is the 2026-08-14 fix and it is about the idle FADE, which carries no
       identity and must have the whole tween to run in. What could not stay with it is
       updateFeedBar(target), which was called on the very next line, before a single pixel moved.
       That call writes the @handle, the avatar, the online dot and the blue tick -- and .pfeed-title
       is the ONLY identity on screen, because the card's own .post-head .name is display:none in the
       viewer. So for the first stretch of every advance the bar named the INCOMING author while the
       OUTGOING post still filled the screen. Same defect as the 159ms wrong-name window of
       2026-08-05 (transform-glide-fires-no-scroll-events), with the sign flipped: there the bar
       LAGGED the media, here it LEADS it. That one was closed for the finger (settleTo's handover);
       this is the path it did not cover, and it has TWO callers, not the one the note above claims
       -- hfNext()'s auto-advance and the ArrowUp/ArrowDown handler in build().
       MEASURED on the live feed reel, desktop 1440x900, guest: at t=31430ms the bar read
       @BILAL_SHAHEED_MUHAMMAD while @SpaceCowBoy's post 48610 still covered 100% of the viewport --
       78ms and 3 consecutive frames, and the AVATAR was wrong with it (one statement writes both).
       It happened on every advance that used this tween, because it is structural, not a race.
       THE HANDOVER IS GEOMETRIC, NOT A TIMER, and that distinction is the whole of getting it right.
       Copying settleTo()'s 130ms constant would have been wrong here: this tween is ease-OUT cubic
       (e = 1-(1-p)^3), so it is fast at the start and the incoming post owns half the viewport at
       p=0.206 -- t=66ms of 320 -- while the TEMPORAL midpoint (160ms) is already 87.5% of the way
       there. A midpoint timer would simply have traded 66ms of the bar leading for ~94ms of it
       lagging. Handing over inside the tick on `e >= 0.5` is the exact frame the incoming post
       becomes the majority of the screen, it needs no constant, and it cannot drift if `dur` or the
       easing is ever retuned -- the two are read from the same expression.
       THE INSTANT BRANCH KEEPS THE IMMEDIATE CALL: there is no tween to cross, the post lands in
       this frame, so the bar must land in it too. */
    var delta = target.getBoundingClientRect().top - scroller.getBoundingClientRect().top;
    var from = scroller.scrollTop, to = from + delta;
    if (hfReduced() || Math.abs(delta) < 2) { scroller.scrollTop = to; updateFeedBar(target); return; }
    /* SUSPEND SNAP FOR THE TWEEN (owner 2026-08-12: "an actual fast swipe up motion ... instead of just
       popping up with no animations"). .pfeed-scroll is scroll-snap-type:y mandatory (rova.css), and
       iOS Safari doesn't wait for a scroll GESTURE to end before enforcing it -- it re-snaps to
       whichever post edge is nearer on every single scrollTop write, not just the final one. Every
       intermediate frame below (p=0.1, 0.2, ...) is off a snap point until the write that lands exactly
       on `to`, so each one got silently corrected back to `from` (still nearer) until the tween crossed
       the 50% mark, then to `to` -- a hard cut at the midpoint dressed up as a smooth per-frame write.
       Turning snap off for the tween's duration and restoring it once `to` is actually reached removes
       the thing correcting every frame; the restore always runs, abort included, so a manual swipe
       mid-tween is never left without snap. */
    var tok = ++pfStepTok; pfStepOn = tok;   // a newer step() supersedes this tween (see pfRestFlush's note)
    scroller.style.scrollSnapType = 'none';
    var restoreSnap = function () {
      if (pfStepOn === tok) { pfStepOn = 0; }
      if (tok === pfStepTok && scroller.style.overflowY !== 'hidden') { scroller.style.scrollSnapType = ''; }   // the stylesheet's, never a saved 'none'
    };
    var genGuard = hfGen, dur = 320, t0 = null, handed = false;
    /* Once, at the crossover or at the landing, whichever comes first -- and on an ABORT too. An
       abort (a new advance, a stop, a close under us) may happen before the crossover, and leaving
       the bar on the outgoing post would be the 2026-08-05 bug restored. It is the one case where
       the target is NOT the answer, because we did not get there: ask with no argument and let
       currentPost() report where the viewer actually is. Aborts are rare, so the O(n) scan that
       `known` exists to avoid is not a cost on any normal advance. */
    var hand = function (known) { if (handed) return; handed = true; updateFeedBar(known); };
    function tick(now) {
      if (tok !== pfStepTok) { return; }                 // superseded: the newer step owns the scroller and its snap
      if (genGuard !== hfGen || !target.isConnected) {   // hands-free moved on (or stopped) under us
        restoreSnap(); pfRestFlush(true); hand(); return;   // ...on a post, never left mid-air
      }
      if (t0 === null) t0 = now;
      var p = Math.min(1, (now - t0) / dur);
      var e = 1 - Math.pow(1 - p, 3);                  // ease-out cubic: fast start, soft landing
      // steered by the target's LIVE position: a card inserted/removed above mid-tween cannot redirect it
      scroller.scrollTop += (target.getBoundingClientRect().top - scroller.getBoundingClientRect().top) - delta * (1 - e);
      // THE CROSSOVER: the first frame on which the incoming post owns more than half the viewport.
      if (e >= 0.5) { hand(target); }
      if (p < 1) { requestAnimationFrame(tick); } else { restoreSnap(); hand(target); }   // e = 1: the write above landed it flush
    }
    requestAnimationFrame(tick);
  }
  /* THE LOCK SCREEN'S next/prev COME THROUGH HERE, and through nothing else (2026-09-03).
     navigator.mediaSession's nexttrack/previoustrack handlers are registered in the video engine
     (a different closure), so they reach the viewer by this one door. It is deliberately a thin
     wrapper over step() rather than a second paging implementation: step() is what wakes the
     chrome before a pixel moves, suspends scroll-snap for its tween, and hands updateFeedBar()
     the target AT THE GEOMETRIC CROSSOVER -- the fix for the bar naming the incoming author while
     the outgoing post still filled the screen. A lock-screen advance that wrote scrollTop itself
     would be a second identity schedule, which is exactly the defect that fix closed.
     Returns whether it had a viewer to page. The `show` test is the guard: a media session can
     outlive an open (it survives a pause on purpose, so the reader can resume from the lock
     screen), so a press can genuinely arrive with no viewer on screen. */
  window.__rovaPfStep = function (dir) {
    if (!box || !box.classList.contains('show')) return false;
    try { step(dir > 0 ? 1 : -1); } catch (e) { return false; }
    return true;
  };

  /* ---- HANDS-FREE: sit back and let the pfeed play itself ---------------------------------------------------
     Owner: "if the user is idle for over 5 seconds present a transparent overlay with a button to start the
     auto scrolling process... If they don't tap it then have it animate to the closest edge of the screen with
     a handle to pull out if they ever do want to start... slideshows, make sure you get to the end of them
     before swiping automatically to the next media post... like an auto thing like Instagram stories, so they
     can just sit back and watch the pfeed swipe by automatically, and stop it if they want to engage with
     something, or swipe next if they want also."

     THE INVITE IS GONE (owner 2026-08-08: "Let's not wait to show the play the feed button, let's just
     already have it -- part of the like the other buttons, make them 3 circular buttons matching the style
     of the bottom buttons").
     There is no idle clock, no floating card, no flight and no docking. The play control is a PERMANENT
     member of the right-hand stack from the moment the viewer opens, beside the repeat toggle and the
     dwell chooser, and all three are the site's standard disc (docs/circle-button-spec.md) at the same
     `sm` 34px step the bottom engagement row uses. Everything the offer needed -- HF_IDLE_MS,
     HF_INVITE_MS, hfShowInvite/hfPlace/hfFly/hfDockIt/hfTouch, the .pf-hf layer with its card, and the
     whole left/right side question -- was DELETED rather than left inert, because a permanently present
     control cannot have an entry state.
     AUTOPLAY POLICY IS UNAFFECTED. The invite's tap was a user gesture; a tap on the permanent play disc
     is the same gesture, arriving through the same hfStart() chokepoint, so hfPlayCurrent() still starts
     a paused clip under the browser's rules and still mutes only on a REFUSAL, through the stamped
     __rovaEngineMute path.

     TWO states now, one at a time:
       PARKED   the stack sits on the right edge for the whole viewer session, above the .cnav arrow band
                and clear of the .pfeed-bar. Right and never left: iOS paints its volume HUD on the left
                (#621). Never top/bottom: the top edge is the .pfeed-bar and the bottom edge is the .vctrl
                player plus the .pf-act engagement row (see pfMoveActs).
       RUNNING  One item at a time advances ITSELF -- there is no clock ticking over the top of the feed:
                  photo     dwell HF_PHOTO_MS, then step(1)
                  video     ONE complete pass via __rovaVideoOnePass (pfeed clips carry loop=true, so 'ended'
                            never fires -- see that helper), then step(1). A clip is never cut off mid-play.
                  carousel  hand the per-SLIDE dwell to the carousel's OWN slideshow scheduler in `once` mode
                            (initCarousel's __cplay). It applies the same two rules slide by slide and calls
                            back only after the LAST slide -> then step(1). We do not run a second per-slide
                            scheduler; the carousel already had one and it now simply knows how to stop.

     Three things it deliberately does NOT do:
       - It never UNMUTES. applySound() in the main IIFE is the sole authority on which clip is audible, and
         it only unmutes when sndPref()/pfLatch say the reader already asked for sound. A sit-back mode that
         started making noise on its own is a far worse version of the bug fixed earlier today.
         (hfPlayCurrent, below, does now PLAY the current clip on entry -- 2026-08-08, and it has to: a
         paused clip never wraps, so __rovaVideoOnePass would hold the reel on it for the full 90s cap. It
         plays the element exactly as it is and only ever mutes on a REFUSAL, through __rovaEngineMute so
         the stamped-mute contract is kept and the saved preference cannot be flipped.)
       - It never scroll-animates. step() sets scrollTop directly, for the reason written above it: smooth
         scrolling fights scroll-snap:mandatory and snaps back.
       - It never runs a timer in a hidden tab and never walks the reader through the guest signup wall.
  */
  /* HF_IDLE_MS (5000) and HF_INVITE_MS (4500) are DELETED with the invite they timed. Nothing waits any
     more, so there is no interval left to tune -- and the native build's HF_OFFER_MS (6000, in
     src/screens/PostScreen.js) has no web twin to be reconciled against; see the APP PARITY note at the
     end of this block. */
  var HF_PHOTO_MS     = 5000;    // DEFAULT photo dwell (owner: start at 5s). The live value is hfDwell().
  var HF_VIDEO_CAP_MS = 90000;   // ceiling for a clip whose end we cannot detect (unknown / live duration)
  var HF_SETTLE_MS    = 700;     // after an advance, let the snap land before the new item's dwell is armed
  var HF_WATCH_MS     = 2000;    // watchdog cadence while the carousel owns the dwell (its own IO can stop it under us)
  var HF_RETRY_MS     = 2500;    // load-more brought nothing back: 2.5s / 5s / 10s, then hand it to the reader
  /* MUSIC HOLDS THE REEL, exactly the way a clip does (owner, 2026-08-14: "If a post has music
     let the music finish playing before advancing to the next post/media in hands-free mode").
     Shipped on both surfaces in the same pass -- the app half is HF_MUSIC_TICK_MS in
     src/screens/PostScreen.js and the rule is identical: a PLAYING track owns the dwell, and
     the speed setting still only ever sizes a still frame.
     WHAT IS OBSERVED IS THE ONE PLAYER WE REALLY OWN: the Apple preview card, whose audio is
     our own detached <audio> (amAudio above) and whose 'ended' / 'pause' listeners strip
     .am-playing the instant it stops. That makes the class a true edge, not a guess.
     Spotify / SoundCloud / YouTube play inside cross-origin iframes that tell this document
     nothing at all, so they are deliberately NOT held: a hold we cannot release is a reel that
     simply stops, which is worse than the cut it would prevent. (The app has the same split
     for the same reason -- there it can at least hold on mount, because a native WebView's
     lifetime is observable; a DOM iframe's playback is not.)
     BOUNDED ANYWAY. The preview is 30s and ends itself, but a wedged element must not be able
     to park the reel forever, so the hold expires. */
  var HF_MUSIC_MS     = 1000;    // re-ask this often while a track is running
  var HF_MUSIC_CAP_MS = 120000;  // ...and never hold longer than this on one post

  var hfState = 'off';           // 'off' | 'on' | 'paused'
  var hfWhy = '';                // why we left 'on' -- decides the handle's look and whether it self-resumes
  var hfT = null, hfScrollT = null, hfPass = null;
  var hfGen = 0;                 // bumped on every state change: stale timers and pass callbacks bail on it
  var hfPost = null;             // the post the live dwell belongs to (settling on a DIFFERENT one re-arms)
  var hfMusicAt = 0;             // when the current post's track started holding (0 = not holding), for HF_MUSIC_CAP_MS
  var hfPumping = false, hfFail = 0;
  var hfHandle = null, hfRate = null, hfSpeeds = null;
  /* ---- MANUAL NAVIGATION vs THE REEL (owner 2026-08-29, recording: swiping back up to the previous
     post with hands-free on, "it immediately kicks me back to the next post over and over") ----------
     WHERE THE KICK LIVED. The dwell reset of 2026-08-14 (updateFeedBar's hfArm at the settle) only
     lands when a post CHANGE is committed -- settleTo's 130ms handover at the earliest. Nothing told
     hfAdvance that a FINGER was mid-gesture, so the outgoing post's live dwell (hfT on a photo, hfPass
     on a clip about to wrap, a once-mode deck's onend) could expire DURING the drag or the glide and
     call hfNext() against a mid-gesture currentPost() -- which, during settleTo's transform glide, is a
     cache HIT on the PRE-glide post (transform-glide-fires-no-scroll-events). Swipe back near the end
     of a dwell and the expired timer advances you straight forward again, every single time.
     THE RULE (owner's chosen design, 2026-08-29): manual navigation never pauses hands-free -- it hands
     the arrived post a FULL FRESH interval, restarts its media (a backward-arrived clip from 0, a
     photo's pan re-eased from rest), and an auto-advance may NEVER fire in, or immediately after, the
     same gesture. Same shape as the engagement grip one block up: a HOLD, not a state. */
  /* ---- THE FIRST CARD'S GRACE (Rob 2026-10-22, app + web: "give me time to see, read and process the first post ... if it's a
     video let it finish first"; then "just don't do the hands-free that fast"). After the viewer OPENS, or the browser tab
     comes back (the hidden pause resuming), the card on screen is never advanced off quickly: a photo dwells at least
     HF_FIRST_MIN_MS whatever the speed setting; a card with no media dwells its READING TIME (words / HF_FIRST_WPS words per
     second, at least HF_FIRST_MIN_MS, at most HF_FIRST_TEXT_MAX_MS); a gallery plays its slideshow (the existing once-mode
     show, every slide); a video plays its one full pass (it always did -- __rovaVideoOnePass). Touches already re-deal the
     dwell in full (THE ENGAGEMENT GRIP / THE HAND). Spent on the first advance or any manual move; nothing else changes.
     iOS: to-ios.md "## HANDS-FREE FIRST-CARD GRACE". */
  var HF_FIRST_MIN_MS = 6000, HF_FIRST_WPS = 3.5, HF_FIRST_TEXT_MAX_MS = 30000;
  var hfFirst = false;
  function hfFirstMs(p) {
    var base = Math.max(hfDwell(), HF_FIRST_MIN_MS);
    if (p && !p.querySelector('.media')) {
      var b = p.querySelector('.body'), w = b ? ((b.textContent || '').trim().match(/\S+/g) || []).length : 0;
      if (w) { base = Math.max(base, Math.min(HF_FIRST_TEXT_MAX_MS, Math.round(w / HF_FIRST_WPS * 1000))); }
    }
    return base;
  }
  var HF_NAV_TAIL_MS = 1500;     // covers settleTo's glide + 420ms safety commit; 900 -> 1500 (batch item 46: nothing moves within ~1.5 s of a scroll / drag, = the hand's HAND_TAIL_MS)
  var hfNavDown = false;         // a finger is on the pager right now (scroller touchstart..touchend)
  var hfNavAt = 0;               // when the last manual gesture ended / manual arrival landed
  var hfNavMediaP = null, hfNavMediaAt = 0;   // dedupe: the settle path reports one arrival 2-3 times
  function hfNavHold() { return hfNavDown || (Date.now() - hfNavAt < HF_NAV_TAIL_MS); }
  /* One chokepoint for EVERY manual arrival there is -- settleTo's handover and commit, step()'s
     keyboard callers, and hfOnScroll's native-scroll cover all funnel through the two `p !== hfPost`
     tests that call this. hfNext() claims hfPost = target BEFORE it moves, so the reel's own advance
     can never enter here -- the invariant those two tests have always relied on. */
  function hfManualNav(p) {
    hfFirst = false;   // the reader moved by hand: this card gets the normal fresh dwell
    hfDue = false;               // a completion earned by the post the reader just LEFT must not advance the one they arrived on
    hfNavAt = Date.now();
    // media restart, once per arrival (the handover, the commit and the scroll debounce all report it)
    if (p && (hfNavMediaP !== p || Date.now() - hfNavMediaAt > HF_NAV_TAIL_MS)) {
      hfNavMediaP = p; hfNavMediaAt = Date.now();
      // BACKWARD arrival: the clip plays from its beginning again, not from wherever its last pass left
      // it -- an already-spent clip resuming near the wrap point completed a "pass" almost instantly.
      // (hfArm below cancels hfPass, and hfTick arms a FRESH one-pass watcher with last=-1, so the
      // restarted clip's completion is re-armed, never re-fired for an already-ended element.)
      var from = hfPost, back = false;
      try { back = !!(from && from !== p && p.compareDocumentPosition && (p.compareDocumentPosition(from) & 4)); } catch (e) {}
      if (back) {
        Array.prototype.forEach.call(p.querySelectorAll('video'), function (v) {
          try { if ((v.currentTime || 0) > 0.05 && !(v._scrubbing && Date.now() - v._scrubbing < 600)) { v.currentTime = 0; } } catch (e) {}
        });
      }
      // ...and a single photo's Ken Burns pan re-eases from rest, exactly kbIO's own reset (same _kbAt
      // stamp, so the observer doesn't immediately re-arm it a second time). Carousel slides are NOT
      // touched here: hfTick's once-mode retake runs kenBurns(true) on the slide it lands on.
      if (!p.querySelector('.media.carousel')) {
        Array.prototype.forEach.call(p.querySelectorAll('.media img'), function (im) {
          try {
            if (im._kbAt && (Date.now() - im._kbAt) < 700) return;
            im._kbAt = Date.now();
            im.style.animation = 'none';
            void im.offsetWidth;
            im.style.animation = '';
          } catch (e) {}
        });
      }
    }
    /* CLAIM THE ARRIVAL NOW, not at the next hfTick. A fast forward-and-back flip (leave a post and
       return to it inside ~1s -- exactly the owner's "over and over" rhythm) round-trips BEFORE the
       deferred hfTick can claim the intermediate post, so the return used to read p === hfPost and
       skip this whole reset, restart included. The reel's own advance still pre-claims in hfNext();
       both callers guard p !== hfPost, so this never fires on the reel's own move. The music budget
       resets with the claim, exactly as hfTick's own `p !== hfPost` branch would have. */
    hfMusicAt = 0;
    hfPost = p;
    hfArm(HF_SETTLE_MS);         // clears hfT AND hfPass; hfTick then deals the arrived post a FULL fresh dwell
  }
  /* HF_CTL_SEL IS DELETED, and it is worth saying why rather than leaving a dangling name.
     It was introduced as "EVERY control this module owns, in one place... three call sites read
     it", but only ONE ever did -- hfBuild's own wake-tap guard. The other two named the same four
     classes as literals and still do: the engagement guard below ('.pf-hf-dock, .pf-hf-rate,
     .pf-hf-speeds, .pf-hf-rep' -- these are not "engagement with a post") and the speed popover's
     outside-press close ('.pf-hf-speeds, .pf-hf-rate, .pf-hf-dock'), plus ENG_ATTN_NOT at the top
     of the file. So with the wake-tap guard generalised into PF_WAKE_SEL / pfWakeRetarget up in
     the viewer -- where these four are now members of a much longer list -- the variable had zero
     readers. A "single source of truth" that nothing reads is worse than no variable at all: the
     next person to widen it would believe they had changed three behaviours and would have
     changed none. (hfPressOnCtl went with the guard for the same reason.) */

  /* ---- SPEED (owner: "it needs a settings or a way to increase the speed") -------------------------------
     PROVISIONAL step set, to be reconciled with the native build's. The multiplier moves the PHOTO and
     CAROUSEL-SLIDE dwell only. A VIDEO still plays to its natural end at every setting -- the owner was
     explicit that a slideshow has to finish before the reel moves on, and cutting clips short to hit a
     speed target contradicts that. (If a cap at "Fastest" is ever wanted it belongs in __rovaVideoOnePass
     as a shorter capMs; it is NOT here, and it is not shipped.)
     Stored as the DWELL IN MS, not an index, so a later change to the step list can't silently re-map an
     existing choice -- an unrecognised stored value just snaps to the nearest step. */
  var HF_SPEED_KEY = 'rova_hf_ms';   // NB not rova_ss_ms: that is the reader-driven carousel slideshow's own speed
  /* ---- THE MEMBER'S ON/OFF CHOICE PERSISTS (Rob 2026-09-30: "if I turn hands free off it still turns
     back on next time I enter a full screen, and it shouldn't") -------------------------------------
     Before this, NOTHING stored the on/off state: hfOpen() unconditionally auto-started on every open
     (the 2026-08-12 default-on), so an explicit OFF lived exactly as long as that one viewer session.
     localStorage `rova_hf_on`: '0' = the member switched it OFF, '1' = switched it ON, absent = never
     touched = today's default (ON). Written ONLY by the disc's own click (hfWireHandle) -- never by
     the automatic pauses (engage / hidden / retry / busy / gate) or stops (end / closed), because
     those are not the member's choice. Read FRESH in every hfOpen(), so it holds across every opener
     (feed, profile, grid, search, More-from, ring, deep link, deck swap) and across reloads. Device-
     local, like rova_hf_ms and rova_feed_speed (no server feed pref exists to sync with). The app's
     twin is `hfOn` in AsyncStorage `rova_feed_prefs` (same three-state meaning). */
  var HF_ON_KEY = 'rova_hf_on';
  function hfWantOn() { try { return localStorage.getItem(HF_ON_KEY) !== '0'; } catch (e) { return true; } }
  function hfRemember(on) { try { localStorage.setItem(HF_ON_KEY, on ? '1' : '0'); } catch (e) {} }
  var HF_SPEEDS = [
    { ms: 8000, label: 'Slow' },
    { ms: 5000, label: 'Normal' },   // the default -- nothing changes for someone who never touches this
    { ms: 3000, label: 'Fast' },
    { ms: 2000, label: 'Fastest' }
  ];
  var hfMs = HF_PHOTO_MS;
  function hfDwell() { return hfMs; }
  function hfLoadSpeed() {
    try {
      var v = parseInt(localStorage.getItem(HF_SPEED_KEY), 10);
      if (v > 0) {
        hfMs = HF_SPEEDS.reduce(function (best, s) {
          return Math.abs(s.ms - v) < Math.abs(best - v) ? s.ms : best;   // snap to the nearest known step
        }, HF_PHOTO_MS);
      }
    } catch (e) { /* private mode */ }
  }
  function hfSetSpeed(ms) {
    if (!(ms > 0)) return;
    hfMs = ms;
    try { localStorage.setItem(HF_SPEED_KEY, String(ms)); } catch (e) {}
    // TAKES EFFECT ON THE NEXT ITEM, never the current one. There is deliberately no hfArm() here: re-arming
    // would either restart a dwell the reader is already halfway through or land a second advance on top of
    // the one already scheduled. A carousel mid-run picks the new rate up for its REMAINING slides via
    // __cspeed, which leaves the slide currently on screen holding its original timer for the same reason.
    var p = currentPost(), car = p && p.querySelector('.media.carousel');
    if (car && car.__cspeed && car.__cplaying) { car.__cspeed(ms); }
    hfPaint();
  }
  // the rounded triangle measured x[8,19.325] -- centre 13.66, 1.66u right -- against an HF_PAUSE at
  // x[6.5,17.5] which is exact. Shifted by its OWN measured offset (1.66, not the flat 1.5 the sharp
  // triangles take: the rounded nose reaches further right), so it now centres on 12.00.
  var HF_PLAY = '<svg viewBox="0 0 24 24" width="17" height="17" fill="currentColor" aria-hidden="true"><path d="M6.34 5.2c0-.9 1-1.5 1.8-1l9 6.8c.7.5.7 1.5 0 2l-9 6.8c-.8.5-1.8-.1-1.8-1z"/></svg>';
  var HF_PAUSE = '<svg viewBox="0 0 24 24" width="17" height="17" fill="currentColor" aria-hidden="true"><rect x="6.5" y="4.5" width="4" height="15" rx="1.4"/><rect x="13.5" y="4.5" width="4" height="15" rx="1.4"/></svg>';

  function hfRunning() { return hfState === 'on'; }
  window.__rovaHfRunning = function () { return hfRunning() && hfLive(); };   // the wake governor's lean-back window
  function hfLive()    { return !!(box && box.classList.contains('show')); }
  function hfReduced() { return !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches); }

  // Everything that must take the reel off the road. 'gate' is TERMINAL -- the guest signup wall is not
  // something to wait out, and hands-free walking a guest past it is exactly what it exists to stop.
  // 'hidden' self-resumes when the tab comes back. Everything else needs a deliberate tap on the handle.
  function hfBlocked() {
    if (document.hidden) return 'hidden';
    if (document.documentElement.classList.contains('guest-gated') || document.querySelector('.guest-gate')) return 'gate';
    if (document.body.classList.contains('modal-open')) return 'busy';
    if (document.querySelector('.comment-panel.open, .pmenu-panel.show, .lightbox.show, .gal.show, .rx-modal.show, .emoji-pop.show, .gif-pop.show, #auth-modal.show, .cropper')) return 'busy';
    if (box && box.querySelector('.pf-panning')) return 'busy';   // mid pinch / pan of a photo
    return '';
  }
  function hfClear() {
    if (hfT) { clearTimeout(hfT); hfT = null; }
    if (hfPass) { try { hfPass(); } catch (e) {} hfPass = null; }
  }
  /* IS THIS POST'S TRACK STILL PLAYING? One predicate, two callers (hfTick decides what drives
     the item; hfAdvance guards the callbacks that come back from a finished carousel or clip),
     because a hold that only one of them honoured would be a hold that a deck's last slide
     walks straight through. Also OWNS the clock: the first true starts the budget, and any
     false clears it, so a member who pauses and restarts the track gets a fresh one instead of
     inheriting a spent one. */
  /* 2026-10-03 (Rob: "it goes to 'Held' on the post for way too long ... Should follow the same rules as all other
     posts"; the app's build 683 rule). The song now REPEATS while the reader stays, so "let the music finish"
     (2026-08-14) never finished: every song post sat out the whole HF_MUSIC_CAP_MS. ONLY A SONG THE MEMBER STARTED
     (a tap on the card or the clip's song-mode speaker -- __rovaAmUserSong) holds the reel now, still bounded by
     HF_MUSIC_CAP_MS. An autoplayed song holds nothing: the post advances on exactly the schedule of the same post
     without a song, and __rovaAmLeave stops the song when the reel lands on the next post. */
  function hfMusicHold(p) {
    var us = null;
    try { us = window.__rovaAmUserSong ? window.__rovaAmUserSong() : null; } catch (e) {}
    if (!p || !us || !p.contains(us)) { hfMusicAt = 0; return false; }
    if (!hfMusicAt) { hfMusicAt = Date.now(); }
    return Date.now() - hfMusicAt < HF_MUSIC_CAP_MS;
  }
  /* ---- THE ENGAGEMENT GRIP, hands-free's half (owner 2026-08-16) -------------------------------
     "When tapping to hold a like and the heart animation happens, the auto timeline feed should
     pause until the user is done interacting with posts so it doesn't move out of their view
     while they're engaging."

     THIS IS A HOLD, NOT A PAUSE, and the distinction is the whole round. hfPause() is a STATE:
     the disc flips to PLAY, the reader is told, and only the 120-second attention lapse or a
     deliberate tap brings it back. That is right for a modal taking the screen. It is wrong for a
     two-second press: the reel would go off for two minutes because the reader loved something,
     which is the opposite of what loving something says about whether they are still watching.
     So a grip never touches hfState. The reel stays 'on', the handle keeps telling the truth, and
     the dwell is simply RE-ARMED instead of fired -- the exact shape hfMusicHold already uses one
     function down, and for the same reason.

     THE RELEASE IS A FULL DWELL, BY CONSTRUCTION. Nothing here decrements or resumes a part-spent
     timer: while gripped the reel re-asks every HF_GRIP_MS, and the first ask after the release
     falls through to hfTick, which schedules hfDwell() from the top. So a reader who holds a heart
     four seconds into a five-second photo is handed a fresh five, never the 0.9s that were left.

     ...EXCEPT THAT A FINISHED CLIP MUST NOT BE MADE TO PLAY AGAIN, which is what `hfDue` is for
     and why hfAdvance takes `earned`. A video hands its dwell to __rovaVideoOnePass and that
     watcher completes ONCE, on a real wrap. If a clip finished under the reader's finger and we
     simply re-decided on release, hfTick would arm a SECOND one-pass watcher on the same clip and
     the reader would sit through the whole thing twice -- losing the pass they had already
     watched, which is precisely what the app-side meter refuses to do (see the hold scenario in
     tools/hf-pass-check.js). So an advance that was EARNED by a real completion is latched and
     honoured after the release; an advance that was merely a photo's timer expiring is not
     latched, and that item gets its full window again. Both halves match the app exactly. */
  var HF_GRIP_MS = 250;         // how often a held reel re-asks; imperceptible against a 5s dwell
  var HF_GRIP_TAIL_MS = 900;    // the beat an EARNED advance waits after the release, so the burst lands
  var hfDue = false;            // a real completion came due while a hand was on the post
  function hfGripped() {
    try { return !!(window.__rovaGripped && window.__rovaGripped()); } catch (e) { return false; }
  }
  /* The advance a FINISHED item asks for. It is hfNext() plus the music gate: a clip or a photo
     deck can run out while the post's song is still going, and "let the music finish before
     advancing to the next post/media" covers that hand-off too.
     `earned` says this advance was bought by an item actually FINISHING (a clip's one pass, a
     once-mode deck reaching its last slide) rather than by a photo's dwell expiring. Only an
     earned advance survives a grip -- see the block above. */
  function hfAdvance(earned) {
    if (!hfRunning()) return;
    /* THE NAV HOLD, ahead of everything (owner 2026-08-29: swiping back up, "it immediately kicks
       me back to the next post over and over"). An auto-advance may NEVER fire during, or in the
       tail right after, a manual gesture -- the expired dwell that reaches here mid-swipe belongs
       to a post the reader is leaving, and hfNext() would measure a mid-gesture currentPost() and
       throw them forward. Same two-part shape as the grip below it: an EARNED completion (a clip's
       real pass, a deck's last slide) is latched, never replayed -- but if a manual arrival lands,
       hfManualNav drops the latch, because that completion was bought by the post the reader left. */
    if (hfNavHold()) { if (earned) hfDue = true; hfArm(HF_SETTLE_MS); return; }
    if (hfGripped()) { if (earned) hfDue = true; hfArm(HF_GRIP_MS); return; }
    if (hfMusicHold(hfPost)) { hfArm(HF_MUSIC_MS); return; }
    hfNext();
  }
  function hfArm(ms)  { hfClear(); if (!hfRunning()) return; var g = hfGen; hfT = setTimeout(function () { if (g === hfGen) hfTick(); }, ms); }
  /* hfAdvance, not hfNext, since 2026-08-14: a track the reader starts DURING a photo's dwell
     must still hold the advance, and this timer is what that dwell is. The three load-more
     call sites below are unaffected in every way that matters -- they re-enter through the
     same gate, which on a post with no playing card is hfNext() with one predicate in front. */
  /* `earned` is forwarded so a DEFERRED completion stays earned across the tail it waits out: if
     the reader grips again during that beat, the advance must still be the one the clip already
     bought, not a fresh decision that would arm a second pass on it. */
  function hfSoon(ms, earned) { hfClear(); if (!hfRunning()) return; var g = hfGen; hfT = setTimeout(function () { if (g === hfGen) hfAdvance(earned); }, ms); }
  // Only ever stop OUR one-pass runs. A reader who started a slideshow themselves (the photo bar's play
  // button) owns that carousel, and pausing hands-free must not reach in and stop it.
  function hfStopCarousels() {
    if (!list) return;
    Array.prototype.forEach.call(list.querySelectorAll('.carousel.carousel-playing'), function (c) {
      if (c.__ssOnce && c.__cstop) { try { c.__cstop(); } catch (e) {} }
    });
  }

  /* START THE CLIP THE READER IS LOOKING AT (owner 2026-08-08: "the play the feed button should start
     the video if it's paused").
     This is not decoration bolted onto the button -- it is the missing half of the RUNNING state. A
     video item hands its dwell to __rovaVideoOnePass, and that helper only WATCHES: it completes on a
     wrap or a real 'ended' and never plays anything. So on a PAUSED clip nothing ever wraps, and the
     reel sat on that one post until the HF_VIDEO_CAP_MS backstop (90 SECONDS) finally fired. "Play the
     feed" on the permalink the owner was looking at therefore did engage -- the handle repainted, the
     state went 'on' -- and then visibly did nothing at all. So this belongs in hfStart(), the single
     chokepoint every entry point already goes through (a tap on the disc, the label's own start, and
     the two self-resumes), not on the button: a reel that only plays the clip when it
     was started one particular way is the same bug wearing a smaller hat.
     IT STILL OWNS NO SOUND POLICY. The block comment above says hands-free never touches mute, and that
     stays true in the only direction that matters -- it never makes noise on its own. play() is called
     on the element AS IT IS: if applySound already left it muted it plays muted, and if the reader had
     sound on and the browser allows it (the invite button and the handle are real gestures, which is
     exactly the moment autoplay policy is satisfiable) it keeps their sound. Only a REFUSAL mutes, and
     only through the STAMPED engine path -- an unstamped mute here would fire volumechange, be read as
     the reader reaching for the mute button, and flip soundOn + the saved rova_sound preference for the
     whole site ([[intent-not-inversion]], and the same trap wire() and playIO carry the stamp for). */
  function hfPlayCurrent() {
    var v = pfCurrentVideo();
    if (!v || !v.paused) return;
    // An explicit "play the feed" outranks an earlier manual pause -- otherwise playIO would pause it
    // straight back down on the next crossing and the reel would stall on the same post again.
    v._userPaused = false;
    var muteAndRetry = function () {
      if (window.__rovaEngineMute) { window.__rovaEngineMute(v, true); } else { v.muted = true; }
      var p2 = v.play(); if (p2 && p2.catch) { p2.catch(function () {}); }
    };
    var p;
    try { p = v.play(); } catch (e) { muteAndRetry(); return; }
    if (p && p.catch) { p.catch(muteAndRetry); }
  }
  /* SAY WHAT THE MIDDLE DISC JUST DID (owner 2026-08-09: "the same way the repeat and 2s button have
     little bubbles that say what they are doing the play/pause button should also present something").
     THIS IS NOT A SECOND BUBBLE. It is rpSay() -- the repeat chip's own tag, .pf-hf-rep-tag, one
     element, one timer, one role="status" region -- asked to centre on the DOCK's row instead of the
     repeat disc's. Everything the owner is pointing at (the pill's shape, its 40px offboard face, the
     2.2s retire, the idle fade, the reduced-motion split, the aria-live announcement) is inherited by
     construction rather than re-declared, and because there is only ever ONE tag the two labels
     physically cannot stack: the later speaker replaces the earlier and the bubble moves to the disc
     that spoke. See rpSay() for the row argument and rova.css `.pf-hf-rep-tag.at-dock` for the row.
     THE COPY IS "Hands-free", AND "AUTO-PLAY" IS A TRAP, not merely a second-best. `#fs-autoplay` in
     views/feed.php is a DIFFERENT, UNRELATED preference -- "Auto-play videos (muted)", the feed gear's
     toggle for muted in-feed video, mirrored in the app's Settings as "Autoplay videos". A bubble
     reading "Auto-play off" on this disc would name a setting the reader can go and find, has never
     touched, and did not just change. It has to be a word that means THIS reel and nothing else.
     "Hands-free" is that word and it is already the one on the control: the disc's own accessible
     name is "Start hands-free" / "Stop hands-free", and the whole module is hfXxx. The app has shipped
     "Hands-free on" / "Hands-free off" for the same disc, so the two surfaces now say the same thing.
     The register is the repeat tag's -- mode then state, sentence case, and an em-dash reason when
     there is one ("Repeat off, new profile").
     THE WHOLE STACK NOW AGREES WITH THIS BUBBLE (2026-08-09). The four labels that still said
     "auto-play" when this bubble shipped -- the handle's ON-state name and title, the rate disc's
     "Auto-play speed: ..." and "Change auto-play speed", and the chooser's "Auto-play speed" -- were
     swept in one pass onto the app's exact wording (PostScreen.js: 'Stop hands-free' / 'Start
     hands-free', 'Hands-free speed: <label>, <n> seconds per photo', chooser header "Hands-free
     speed"). There is no third name for this feature anywhere: `#fs-autoplay` is a different
     preference and keeps its own correct copy.
     OFF vs PAUSED IS A REAL DISTINCTION AND IS NOT COSMETIC. "off" is only ever said when the reader
     themselves stopped it (or the feed genuinely ran out); everything the reel does to ITSELF -- an
     engagement, a modal, a failed top-up -- says "paused", because those resume, some on their own
     (see the rova:attention handler below). Telling a reader they switched something off when they
     did not is the same class of lie as [[intent-not-inversion]].
     'hidden' says NOTHING: the tab is in the background, there is nobody to read it, and the resume on
     the way back announces the state that is actually true then. 'closed' and 'gate' say nothing
     either -- the viewer is being torn down / the signup wall is taking the screen. */
  function hfSay(msg, ms) { rpSay(msg, ms, 'dock'); }
  function hfStart(auto) {
    if (!hfLive()) return;
    if (hfBlocked() === 'gate') { hfStop('gate'); return; }
    // (this used to call hfDockIt() first, because starting straight from the invite also had to park
    //  the handle. The stack is already on screen at every entry point now, so there is nothing to park.)
    // ANNOUNCE OFF THE STATE CHANGE, NEVER OFF THE TAP. This is the chokepoint every entry point goes
    // through -- the disc, the visibilitychange resume, the attention-lapse resume --
    // so a reel that starts by any route says so, and a call that finds it already running says nothing.
    // EXCEPT the auto-start on open (owner 2026-08-12: "I don't need to see the text appear 'Hands
    // free on' ... Save that for future presses"): hfOpen()'s own wake passes auto=true. Every OTHER
    // caller (the disc tap, the visibilitychange resume, the attention-lapse resume) calls this with
    // no argument, so `auto` is undefined/falsy there and the announcement is exactly as before.
    var was = hfState;
    hfGen++; hfState = 'on'; hfWhy = ''; hfFail = 0; hfPost = null; hfDue = false;
    box.classList.add('pf-hf-on');
    hfPaint();
    hfPlayCurrent();                      // ...and a paused clip is what the reel is waiting on
    hfArm(120);
    if (was !== 'on' && !auto) hfSay('Hands-free on');
  }
  function hfPause(why) {
    if (hfState !== 'on') return;         // ...so a tap that changes nothing announces nothing
    hfGen++; hfState = 'paused'; hfWhy = why || 'user'; hfDue = false;
    hfClear(); hfStopCarousels();
    if (box) box.classList.remove('pf-hf-on', 'pf-hf-wait');
    hfPaint();
    if (hfWhy !== 'hidden') { hfSay(hfWhy === 'user' ? 'Hands-free off' : 'Hands-free paused'); }
  }
  function hfStop(why) {
    var was = hfState;
    hfGen++; hfState = 'off'; hfWhy = why || ''; hfDue = false;
    hfClear(); hfStopCarousels();
    if (box) box.classList.remove('pf-hf-on', 'pf-hf-wait');
    hfPaint();
    // 'end' is the ONE stop a reader is owed words for: a finite album ran out under a reel they
    // started, and the disc going back to PLAY on its own otherwise reads as a fault. 'gate' and
    // 'closed' are silent -- see the block above hfStart().
    if (was === 'on' && hfWhy === 'end') { hfSay('Hands-free off, end of feed'); }
  }

  // Decide what drives the CURRENT item, then get out of the way and let it call back.
  function hfTick() {
    if (!hfRunning()) return;
    if (!hfLive()) { hfStop('closed'); return; }
    var b = hfBlocked();
    if (b === 'gate') { hfStop('gate'); return; }
    if (b) { hfPause(b); return; }
    /* THE GRIP, ahead of every branch below (full derivation at hfAdvance). Placed before
       currentPost() so that a held reel decides NOTHING: no carousel is retaken in once-mode, no
       one-pass watcher is armed, no dwell is scheduled. There is therefore no partially-committed
       state to unwind on release -- hfTick simply runs again from the top and the item gets its
       whole window. */
    if (hfGripped()) { hfArm(HF_GRIP_MS); return; }
    /* A PAGER FINGER HOLDS DECISIONS EXACTLY LIKE A GRIP (owner 2026-08-29: swiping back up, "it
       immediately kicks me back to the next post over and over"). Mid-swipe, currentPost() is a
       cache hit on the post being LEFT (transform-glide-fires-no-scroll-events), so deciding now
       would claim hfPost / arm a watcher / retake a deck for the wrong card. Re-ask on the same
       cadence; the settle's hfManualNav then deals the ARRIVED post its full fresh interval. */
    if (hfNavDown) { hfArm(HF_GRIP_MS); return; }
    /* ...and the release drains a deferred completion. A clip that genuinely finished under the
       reader's finger has had its one pass and must not be made to play a second time; it just
       waits a beat for the burst to land. A photo's expired dwell was never latched, so it falls
       through to the branches below and is re-dwelled in full. */
    if (hfDue) { hfDue = false; hfSoon(HF_GRIP_TAIL_MS, true); return; }
    var p = currentPost();
    if (!p) { hfArm(500); return; }
    if (p.classList.contains('pf-end')) { hfStop('ringend'); return; }   // the ring's end card: the reel rests here (2026-09-18)
    if (p !== hfPost) { hfMusicAt = 0; }         // a new post starts with a fresh music budget
    hfPost = p;
    /* MUSIC FIRST, ahead of the carousel and the video branches (see HF_MUSIC_MS). "Advance to
       the next post/media" is ONE decision, so a running track holds the whole item: taking
       this branch means the carousel's own once-mode show is never started either, and a photo
       deck therefore stops sliding under its own song instead of racing it.
       Nothing is started or stopped here -- this only declines to SCHEDULE an advance while the
       card says it is playing, and asks again a second later. */
    if (hfMusicHold(p)) { hfArm(HF_MUSIC_MS); return; }
    var car = p.querySelector('.media.carousel');
    if (car && car.__cplay && car.__ccount && car.__ccount() > 1) {
      // recyclePfeedMedia auto-starts a plain WRAPPING slideshow on whatever post is current; retake it in
      // once-mode so the show ends at the last slide instead of looping the post forever.
      if (car.__cplaying && !car.__ssOnce) { try { car.__cstop(); } catch (e) {} }
      if (!car.__cplaying) {
        var g0 = hfGen;
        // hfAdvance, not hfNext: the deck can run out while the post's track is still playing
        // EARNED: a once-mode deck reaching its last slide really did finish. If a grip is up it
        // is latched and honoured on release, rather than restarting the whole deck.
        car.__cplay(hfDwell(), { once: true, onend: function () { if (g0 === hfGen && hfRunning()) hfAdvance(true); } });
      }
      // WATCHDOG, not a second scheduler: the carousel's own _ssIO stops the show the moment it drops below
      // 50% visible, which a mid-swipe wobble can trip -- and it stops without calling onend. Re-deciding
      // every couple of seconds is idempotent (this same branch just re-arms while the show is healthy) and
      // means a killed slideshow costs at most HF_WATCH_MS, not the session.
      if (car.__cplaying) { hfArm(HF_WATCH_MS); return; }
    }
    var v = pfCurrentVideo();
    if (v) {
      var g1 = hfGen;
      // EARNED: the one-pass watcher completes only on a real wrap or a real 'ended', so this
      // clip has been watched through. A grip defers it; it never buys a second play-through.
      hfPass = window.__rovaVideoOnePass(v, function () {
        hfPass = null; if (g1 === hfGen && hfRunning()) hfAdvance(true);
      }, HF_VIDEO_CAP_MS);
      /* FOLLOW THE ELEMENT, NOT THE FIRST ONE WE SAW (2026-10-03, Rob: "the post I'm watching has made my
         entire feed stop moving"). The one-pass watcher is bound to a <video> ELEMENT, and the post's clip
         can be swapped for another element after this decision: the card's fullscreen button (.vc-fs)
         flies the timeline's own live clip in and heroExpand's adoption replaceChild()s the viewer's fresh
         placeholder with it, then retires the placeholder. hfStart's 120ms first tick lands BEFORE that
         swap, so the watcher sat on a detached element that never plays (duration NaN, ct 0) while the
         adopted clip looped on screen, and the reel only moved when HF_VIDEO_CAP_MS (90 s) fired.
         Measured on 54366 (Edge, rovasmoke): bound to rs0/NaN, the visible clip wrapped twice, 44 s+ held.
         The grid donor and the close/re-open landings swap elements the same way. So while the clip owns
         the dwell, re-ask every HF_WATCH_MS which clip IS current; a different element re-decides the
         item from the top (hfArm -> hfTick binds the pass to the clip actually playing, from wherever it
         is, so it still plays out once and is never cut off). This is a watchdog, not a second clock: it
         never advances anything itself. Same post only: a post CHANGE is hfOnScroll / hfManualNav's to
         handle (the full fresh interval + nav tail), so the watchdog never claims an arrival for them.
         NO CURRENT CLIP AT ALL counts as gone too: a gallery paged from this clip onto a PHOTO slide leaves
         `v` connected but off to the side, and following it would hold the post for a pass nobody is
         watching. Re-deciding a beat later (the slide has landed) hands the post to its normal dwell. */
      var hfWatch = function () {
        if (g1 !== hfGen || !hfRunning() || !hfPass) return;
        var nv = pfCurrentVideo();
        if (currentPost() === p && nv !== v) { hfArm(nv ? 0 : HF_SETTLE_MS); return; }
        hfT = setTimeout(hfWatch, HF_WATCH_MS);
      };
      hfT = setTimeout(hfWatch, HF_WATCH_MS);
      return;                                   // the clip owns the dwell: it plays out, we never cut it off
    }
    hfSoon(hfFirst ? hfFirstMs(p) : hfDwell());   // a photo (or a card with no media at all): a fixed beat, then on
  }

  function hfNext() {
    if (!hfRunning()) return;
    hfFirst = false;   // the reel moved on: the first card's grace is spent
    hfClear();
    if (!hfLive()) { hfStop('closed'); return; }
    var b = hfBlocked();
    if (b === 'gate') { hfStop('gate'); return; }
    if (b) { hfPause(b); return; }
    var posts = list.querySelectorAll('.post');
    var i = Array.prototype.indexOf.call(posts, currentPost());
    if (i < 0) { hfArm(500); return; }
    if (i + 1 >= posts.length) { hfPump(posts.length); return; }
    hfFail = 0;
    // A completion belongs to the post that earned it and to no other. Cleared on the way out so
    // a latch that somehow outlived its drain can never advance the post we are landing on.
    hfDue = false;
    hfPost = posts[i + 1];                      // claim the target BEFORE moving, so hfOnScroll doesn't re-arm on our own advance
    step(1);
    hfArm(HF_SETTLE_MS);
  }

  // Hands-free reaches the end of the rendered set far faster than any thumb, so it has to drive the SAME
  // pagination the sentinel observer does rather than dead-ending. loadMore() swallows its own failures --
  // it has to, a 5xx must never latch "no more content" (see the armRetry note on the grid) -- so the only
  // honest success signal available here is whether the list actually grew. If it didn't, back off on that
  // same curve (2.5s / 5s / 10s) and only then park in a RESUMABLE paused state, so a flaky minute costs a
  // tap on the handle rather than the whole session.
  function hfPump(had) {
    if (!cur) { hfPause('retry'); return; }
    if (cur.feedless && !cur.more) { hfStop('end'); return; }   // a finite album (the profile-photo slideshow) genuinely ends
    // THE RING'S END CARD is on screen (or is the next card): hands-free stops there, silently -- the
    // card itself says "End of media"; hfStop's 'end' toast is for the album case above.
    if (cur.ring && cur.ringEnded) { hfStop('ringend'); return; }
    if (hfPumping || cur.loading) { hfSoon(400); return; }      // someone else's page is already in flight; don't score it as a failure
    hfPumping = true;
    box.classList.add('pf-hf-wait');
    var g = hfGen;
    var settle = function () {
      hfPumping = false;
      if (box) box.classList.remove('pf-hf-wait');
      if (g !== hfGen || !hfRunning()) return;
      if (list.querySelectorAll('.post').length > had) { hfFail = 0; hfSoon(160); return; }
      if (hfFail++ < 3) { hfSoon(HF_RETRY_MS * Math.pow(2, hfFail - 1)); return; }
      hfPause('retry');
    };
    try { loadMore().then(settle, settle); } catch (e) { settle(); }
  }

  // A MANUAL swipe is not a reason to stop -- the owner asked for the opposite ("swipe next if they want
  // also"). Whenever the settled post isn't the one the live dwell belongs to, just re-arm for the new one.
  // Debounced off the scroller so a fling costs one re-arm, not one per frame.
  function hfOnScroll() {
    /* The 180ms re-placement of the invite card used to live here: its position was derived from THIS
       post's furniture (the control row's height, whether a "Tap for sound" pill is painted, how high
       the caption under it pushes that pill), so a card that outlived a page change held numbers that
       belonged to the post it was no longer over. The stack that replaced it is positioned from the
       VIEWER's own box and from nothing inside a post, so a page change cannot invalidate it and there
       is nothing to re-measure on a scroll. */
    if (!hfRunning()) return;
    // ANY scroll motion stamps the nav tail: a wheel / PageDown scroll has no touchstart to raise
    // hfNavDown, and without this an expired dwell could still advance mid-wheel (the same "kicks me
    // back to the next post" shape, desktop edition). Our own step() tween lands here too, harmlessly:
    // the reel's next decision after an advance is a full dwell away, far outside HF_NAV_TAIL_MS.
    hfNavAt = Date.now();
    clearTimeout(hfScrollT);
    hfScrollT = setTimeout(function () {
      if (!hfRunning()) return;
      var p = currentPost();
      // hfManualNav, not a bare hfArm (owner 2026-08-29 "kicks me back to the next post over and
      // over"): this is the wheel / PageDown cover, and a manual arrival by ANY route gets the same
      // full fresh interval, media restart and nav-tail stamp as the touch pager's settle.
      if (p && p !== hfPost) { hfManualNav(p); }
    }, 180);
  }

  /* ---- the permanent control stack ------------------------------------------------------------------
     THERE IS NO SIDE QUESTION LEFT, so hfSide() is deleted rather than kept as a function that can only
     return one string. Right, always: iOS paints its own volume HUD against the LEFT bezel at about this
     height (owner 2026-08-07, "never collapse it to the left side ... that overlaps the iOS volume
     overlay"), and on the app the same column is dead anyway (st.edgeBack,
     [[invisible-edge-strip-eats-taps]]). The `left` / `fly-left` CSS family was already gone; the side
     CLASSES ('right' as an entry-slide hook) go with this round, because three permanently present discs
     have no entry to animate and a class that only ever takes one value is a decision nobody can read.
     WHERE THE STACK SITS IS ENTIRELY IN CSS, and deliberately so. It is anchored to the viewer's own box
     and to the .cnav arrow band, both of which the stylesheet can see; nothing in it depends on a POST's
     furniture, which is what forced the old invite card to be placed from JS on every settle. See the
     --pf-hf-top derivation in rova.css: three `sm` 34px discs, 2px gaps, bottom edge 12px above the arrow
     band, floored at 60px so it cannot climb into the .pfeed-bar. */
  /* SHOW THE STACK. One call, from hfOpen(), and it is the ONLY thing that reveals these three
     buttons -- there is no offer to answer and no deadline to beat, so the old hfDockIt/hfShowInvite/
     hfPlace/hfFly quartet (and hfVis/hfOnScreen/HF_TAIL/HF_ROW_GAP/HF_FLOOR_GAP/HF_FLY_SCALE, which
     existed only to place and fly the card) are deleted outright.
     `hidden` is still the off state rather than "always in the DOM and visible", because the viewer
     itself is torn down and re-opened and hfReset() has to be able to put every one of these back to
     a known state; the one-frame `in` is what fades them up with the rest of the chrome. */
  function hfStackShow() {
    var show = function (el) {
      if (!el) return;
      el.hidden = false;
      requestAnimationFrame(function () { if (el) el.classList.add('in'); });
    };
    show(rpBtn); show(hfHandle); show(hfRate);   // top to bottom, the order they stand in
    hfPaint();
  }
  function hfPaint() {
    if (!hfHandle) return;
    var on = hfRunning();
    hfHandle.classList.toggle('on', on);
    hfHandle.classList.toggle('retry', hfState === 'paused' && hfWhy === 'retry');
    var ic = hfHandle.querySelector('.pf-hf-ic');
    if (ic) ic.innerHTML = on ? HF_PAUSE : HF_PLAY;
    /* ONE NAME FOR ONE BUTTON, and it is the APP's name (PostScreen.js HandsFreeDock, the play/pause
       HfDisc: `running ? 'Stop hands-free' : 'Start hands-free'`). These two lines used to read
       'Stop auto-play' / 'Play the feed hands-free' -- three problems in two strings: the pair
       disagreed with ITSELF (a reader who heard "Play the feed hands-free" was told the way back out
       was "auto-play"), it collided with `#fs-autoplay` in views/feed.php ("Auto-play videos (muted)",
       a DIFFERENT and unrelated preference -- see the copy note in hfSay's block above), and it was a
       third wording next to the app's. Same string on aria-label and title so the tooltip and the
       accessible name cannot drift again. */
    hfHandle.setAttribute('aria-label', on ? 'Stop hands-free' : 'Start hands-free');
    hfHandle.setAttribute('title', on ? 'Stop hands-free' : 'Start hands-free');
    hfHandle.setAttribute('aria-pressed', on ? 'true' : 'false');
    if (hfRate) {
      var lab = hfSpeedLabel(hfMs);
      // a VISIBLE number is the affordance: tap it to change it. It goes INSIDE the shared .pf-hf-ic
      // span rather than straight into the button, because that span is what carries the horizontal
      // hit target (rova.css) -- a bare text node would leave this one disc a 34px target while the
      // other two were 44. textContent still reads back "5s" through it.
      var ic = hfRate.querySelector('.pf-hf-ic');
      if (!ic) { hfRate.innerHTML = '<span class="pf-hf-ic"></span>'; ic = hfRate.querySelector('.pf-hf-ic'); }
      ic.textContent = Math.round(hfMs / 1000) + 's';
      // "Hands-free speed: <label>, <n> seconds per photo" is the app's own dwell-disc label verbatim
      // (PostScreen.js HandsFreeDock, the rate HfDisc). The trailing "Change speed" is the web's alone
      // and stays: RN carries that in accessibilityHint, and a bare <button> here has nowhere else to
      // say what tapping it does.
      hfRate.setAttribute('aria-label', 'Hands-free speed: ' + lab + ', ' + Math.round(hfMs / 1000) + ' seconds per photo. Change speed');
      // the hover tooltip names the same thing the accessible name does, for the same reason the
      // handle's two names were merged above: "Speed:" alone did not say WHOSE speed.
      hfRate.setAttribute('title', 'Hands-free speed: ' + lab + ', tap to change');
      hfRate.hidden = hfHandle.hidden;
      if (!hfHandle.hidden) { hfRate.classList.add('in'); } else { hfRate.classList.remove('in'); }
    }
    if (hfSpeeds) {
      Array.prototype.forEach.call(hfSpeeds.querySelectorAll('.pf-hf-sp'), function (b) {
        var sel = parseInt(b.getAttribute('data-ms'), 10) === hfMs;
        b.classList.toggle('on', sel);
        b.setAttribute('aria-checked', sel ? 'true' : 'false');
      });
    }
    rpPaint();   // #634: one repaint path for the whole stack, so the chip can never lag the dock
  }
  function hfSpeedLabel(ms) {
    for (var i = 0; i < HF_SPEEDS.length; i++) { if (HF_SPEEDS[i].ms === ms) return HF_SPEEDS[i].label; }
    return Math.round(ms / 1000) + 's';
  }
  function hfSpeedsShow(on) {
    if (!hfSpeeds || !hfHandle) return;
    if (on) {
      hfSpeeds.hidden = false;                   // it opens beside the stack; the right edge is unconditional in CSS
      requestAnimationFrame(function () { if (hfSpeeds) hfSpeeds.classList.add('in'); });
    } else {
      hfSpeeds.classList.remove('in');
      hfSpeeds.hidden = true;
    }
    hfPaint();
  }
  function hfSpeedsOpen() { return !!(hfSpeeds && !hfSpeeds.hidden); }
  /* TAP THE DISC TO START / STOP. That is the whole gesture, and the INWARD PULL that used to sit
     beside it is DELETED (2026-08-09) rather than repaired.
     IT WAS WRITTEN FOR A CONTROL THAT NO LONGER EXISTS. The pull dates from the docked HANDLE you
     pulled out of the bezel (owner: "a handle to pull out if they ever do want to start"), with a
     .pf-hf-grip hairline under the glyph saying so. The offer card, the docking flight, the idle wait,
     the side plumbing and the grip have all been deleted; this is now one of three permanently visible
     34px discs, and the thing the pull reached for is the PLAY/PAUSE BUTTON UNDER THE FINGER. A disc
     has no direction, so there is nothing left for a reader to read the gesture off -- and the pull was
     ONE-WAY (it only ever called hfStart()), so there was never a state it could produce that a single
     tap could not. It was a hidden alias for a visible button.
     AND IT HAD NEVER ONCE FIRED, on either input type, for its entire life. Measured on the live site
     with real CDP input, and identical on the pre-change bundle, so this is not a regression anyone
     introduced -- it shipped dead:
       TOUCH (390x844): the disc declares no `touch-action`, so Chromium claims the horizontal drag for
         panning and pointercancels it. Stream on .pf-hf-dock: pointerdown x=362, pointermove 356, 350,
         344, pointercancel. Furthest travel the handler ever saw: 18px. The test wanted more than 22.
       MOUSE (1440x900): there was no setPointerCapture(), so moves stopped being delivered the instant
         the cursor left the element -- and the real hit box is the 44px .pf-hf-ic span (the negative
         margins that buy the 44px target), i.e. exactly 22px from centre, against a STRICT `-d > 22`.
         Furthest travel seen: 20px.
     i.e. the threshold had been set to precisely the distance at which the element stops receiving
     events, from both sides at once. The honest repair is setPointerCapture plus a `touch-action` --
     two mechanisms and a hit-testing change to the viewer chrome, bought for a second way to press a
     button that is already on screen and labelled. Lowering the threshold under the accidental limit
     is the same bug with a smaller number.
     (A `touch-action` here would NOT have cost the feed its vertical swipe, and it was worth writing
     down why, because the opposite was assumed. THE READING WAS RIGHT AND THE FEED HAD ALREADY LOST
     IT, for a reason that had nothing to do with `touch-action`: these three discs were emitted by
     hfBuild() into `box`, i.e. as SIBLINGS of .pfeed-scroll, so a touch beginning on one had no
     scrollable ancestor to pan and moved nothing -- verified against a control at 390x844 /
     1440x900 / 844x390, where the same gesture from plain media paged the viewer and from the play
     disc AND the repeat disc moved nothing. .pf-hf-rep carries no pointer code at all, which is what
     proved the cause was structural rather than anything in here.
     FIXED 2026-08-09 by emitting the stack INTO the scroller instead -- see hfBuild() below for the
     measurement and for why the geometry is untouched. So the claim this paragraph opens with is
     still true, and is now true of a control whose pan actually works.)
     ONE MORE REASON IT SHOULD NOT COME BACK IN THAT SHAPE: the pull called hfStart() straight out of
     `pointermove`, and the wake-tap guard (PF_WAKE_SEL / pfWakeRetarget) drops the CLICK. A working
     pull would therefore have been a start path the guard cannot see; only the idle rule's
     `pointer-events:none` on these three discs stops that today. Any future re-entry route has to go
     through a click, or answer the guard itself. */
  function hfWireHandle() {
    if (!hfHandle) return;
    var x0 = 0, y0 = 0, down = false, holdT = null, held = false;
    hfHandle.addEventListener('pointerdown', function (e) {
      down = true; held = false; x0 = e.clientX; y0 = e.clientY;
      // LONG-PRESS is a SECOND way into the speed chooser, for anyone who reaches for the handle rather
      // than the rate pill under it. The plain tap is untouched -- it still only ever means start/stop.
      clearTimeout(holdT);
      holdT = setTimeout(function () { if (down) { held = true; down = false; hfSpeedsShow(true); } }, 480);
    });
    /* A DRAG IS NOT A HOLD. This listener OUTLIVES the pull because that job was never the pull's: on
       a mouse there is no pointercancel to fall back on, so a press-and-drag off the disc would
       otherwise open the speed chooser 480ms later, over media the reader is dragging on.
       IT NOW WATCHES BOTH AXES, and that is a FIX, not tidying. It used to read `clientX` alone --
       it was written next to the pull, which was horizontal, and it inherited the pull's axis. So a
       VERTICAL drag beginning on this disc never cancelled anything: `down` stayed true through the
       480ms and the speed chooser opened under a thumb that was trying to swipe the feed. Measured
       on the live site, real CDP touch, 390x844: a 0.75-screen pan starting on the disc came back
       `speedOpen: true`, and the reader's NEXT tap on the disc was then spent closing that chooser
       instead of starting the reel (the `hfSpeedsOpen()` branch below) -- so it cost them a swipe
       AND a tap. Pre-existing, and nothing to do with the pull: the axis was simply never revisited
       when the control stopped being a horizontal handle. */
    hfHandle.addEventListener('pointermove', function (e) {
      if (!down) return;
      if (Math.abs(e.clientX - x0) > 8 || Math.abs(e.clientY - y0) > 8) { clearTimeout(holdT); }
    });
    var up = function () { down = false; clearTimeout(holdT); };
    hfHandle.addEventListener('pointerup', up);
    hfHandle.addEventListener('pointercancel', up);
    hfHandle.addEventListener('contextmenu', function (e) { e.preventDefault(); hfSpeedsShow(true); });   // desktop right-click
    hfHandle.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      if (held) { held = false; return; }         // the long-press opened the chooser; don't also toggle
      if (hfSpeedsOpen()) { hfSpeedsShow(false); return; }
      // the ONE place the member's choice is written (see HF_ON_KEY): a deliberate tap on the disc
      if (hfRunning()) { hfPause('user'); hfRemember(false); } else { hfStart(); hfRemember(true); }
    });
    // The rate pill: a visible "5s" sitting under the handle. Tapping a number to change it needs no
    // teaching, which is why the speed control is here and not only behind a long-press -- and why it is
    // in the VIEWER at all rather than on the feed's settings gear: the viewer is a full-screen overlay,
    // so a control on the page behind it would mean leaving, hunting, and coming back mid-reel.
    if (hfRate) {
      hfRate.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        hfSpeedsShow(!hfSpeedsOpen());
      });
    }
    if (hfSpeeds) {
      hfSpeeds.addEventListener('click', function (e) {
        var b = e.target.closest && e.target.closest('.pf-hf-sp');
        e.preventDefault(); e.stopPropagation();
        if (!b) return;
        hfSetSpeed(parseInt(b.getAttribute('data-ms'), 10));
        hfSpeedsShow(false);
      });
    }
  }
  // Called by both openers right after pfLock(). hfStackShow() is safe here even though .show is added in
  // a rAF: nothing in it asks hfLive(), because the stack no longer has to wait for anything.
  function hfOpen() {
    hfGen++; hfState = 'off'; hfWhy = '';
    hfPumping = false; hfFail = 0; hfPost = null;
    hfFirst = true;   // THE FIRST CARD GETS ITS FULL DWELL (see HF_FIRST_MIN_MS)
    // #634 the SCOPE is per viewer session, the ARMED flag is not. Dropping rpUser here (and only
    // here) is what lets a still-lit chip re-bind to whoever this open landed on -- see rpReArm.
    rpUser = '';
    hfReset();
    hfLoadSpeed();   // re-read per open: a speed chosen in another tab lands on this open, not the next reload
    hfStackShow();   // ...and the three controls are on screen from this instant, every open
    // THE MEMBER SAID OFF (HF_ON_KEY): open in 'off' with the PLAY disc showing, and no auto-start.
    // Nothing else changes -- the stack is up, the disc still starts it, the speed pill still works.
    if (!hfWantOn()) return;
    /* AUTO-START (owner 2026-08-12: "even on the web app... it still starts out paused" -- the web
       twin of the native app's own hands-free-on-by-default change from the same day). hfStart()
       already gates everything that matters (hfBlocked()==='gate' stops it dead on the guest wall,
       hfLive() no-ops it on anything but a genuinely open viewer), so this does not duplicate any of
       that -- the only reason it cannot just be called here, synchronously, is timing: .show lands in
       a SEPARATE rAF the opener schedules (see the rova:pfwake note above pump(), a few thousand
       lines up), so hfLive() would read false this instant even on a real open. Reuse the same
       rova:pfwake / rAF / timeout racer trio pump() trusts for that exact race.
       RETRY UNTIL hfLive(), NOT fire-once (owner: "the first time it works perfect but after closing
       it and opening another media it loads up paused"). The first cut removed the listener and
       called hfStart() on whichever racer fired FIRST, trusting it to already be live -- true on a
       cold first open (nothing else competing for the frame), false on a warm second one (a faster
       layout can win the race against the SAME rAF that adds .show), so hfStart() silently no-opped
       via its own `if (!hfLive()) return` and hands-free just never started. pump() survives this by
       re-polling on its own schedule; this does the same, bounded to 20 tries (~500ms of 25ms ticks)
       so a session that never opens cannot retry forever. hfGen-guarded throughout so a close (or a
       second open) invalidates every in-flight retry, not just the first check. */
    var wakeGen = hfGen, tries = 0, fired = false;
    var hfWake = function () {
      if (fired || wakeGen !== hfGen) { document.removeEventListener('rova:pfwake', hfWake); return; }
      if (!hfLive()) { if (++tries < 20) { setTimeout(hfWake, 25); } return; }
      fired = true;
      document.removeEventListener('rova:pfwake', hfWake);
      hfStart(true);   // true = auto -- no "Hands-free on" announcement for the default-on open
    };
    document.addEventListener('rova:pfwake', hfWake);
    if (window.requestAnimationFrame) { requestAnimationFrame(hfWake); }
    setTimeout(hfWake, 50);
  }
  function hfClose() {
    hfStop('closed');
    clearTimeout(hfScrollT);
    clearTimeout(rpTagT);
    hfPumping = false;
    // the nav hold dies with the viewer: a close mid-touch never gets its touchend, and a flag that
    // survived into the next open would defer that session's reel forever (see the touchcancel note).
    hfNavDown = false; hfNavAt = 0; hfNavMediaP = null; hfNavMediaAt = 0;
    rpUser = '';        // #634 the scope dies with the viewer; rpOn (sessionStorage) does not
    hfReset();
    rpPaint();
  }
  // No side classes in these lists any more: the stack has one edge and no entry slide, so 'right' /
  // 'left' / 'fly-*' cannot be produced by anything and rova.css has no rule for any of them.
  function hfReset() {
    if (hfHandle) { hfHandle.hidden = true; hfHandle.classList.remove('in', 'on', 'retry'); }
    if (hfRate)   { hfRate.hidden = true;   hfRate.classList.remove('in'); }
    if (hfSpeeds) { hfSpeeds.hidden = true; hfSpeeds.classList.remove('in'); }
    if (rpBtn)    { rpBtn.hidden = true;    rpBtn.classList.remove('in'); }
    // 'at-dock' goes back with 'in': the row is state on a SHARED element, so a viewer re-opened after
    // the dock spoke last must not put the next "Repeating @x" on the play disc's row.
    // THE TEXT GOES TOO, and that is the aria half of the same close. Tapping .pfeed-x while the reel
    // runs raises "Hands-free paused" through the engagement guard one statement before the viewer is
    // torn down; `hidden` alone leaves that string sitting in a role=status region as it goes, which is
    // a spoken announcement for a state nobody is in any more. Emptying it cannot itself announce --
    // a live region says nothing about text being REMOVED -- and it is done while already hidden.
    if (rpTagEl)  { clearTimeout(rpTagT); rpTagEl.hidden = true; rpTagEl.textContent = ''; rpTagEl.classList.remove('in', 'at-dock'); }
    if (box) box.classList.remove('pf-hf-on', 'pf-hf-wait');
  }
  // Built by build(), once, alongside the rest of the viewer chrome.
  function hfBuild() {
    /* THE STACK, top to bottom: repeat / play-pause / dwell. Three buttons of ONE kind -- the site's
       disc (docs/circle-button-spec.md) at the `sm` 34px step, which is the diameter the bottom
       engagement row already uses, so the two clusters are the same object at two ends of the screen.
       They are emitted as SIBLINGS of each other with no wrapper, exactly as before, so they share a
       parent, a stacking context and one show/hide path (hfStackShow / hfReset).
       NO .pf-hf-grip any more. It was the app's "pull me" hairline UNDER the glyph, which only reads
       on a 32x58 vertical pill; inside a 34px disc it is a smudge and it is not a thing the bottom row
       has. The two states that used it are re-expressed on the glyph itself in rova.css (`pf-hf-wait`
       breathes .pf-hf-ic, `retry` inks it with --danger), so no signal is lost with the element. */
    /* INTO THE SCROLLER, NOT INTO `box` -- and that one word is a BUG FIX, not tidying.
       These five used to be emitted into `box` (.pfeed), i.e. as SIBLINGS of .pfeed-scroll. A touch
       therefore had no scrollable ancestor to pan, so a vertical swipe that STARTED on any of the
       three discs moved the feed by exactly nothing -- measured on the live site with real CDP touch
       (Input.synthesizeScrollGesture, gestureSourceType 'touch') at 390x844 / 768x1024 / 1440x900 /
       844x390: the identical gesture from plain media paged the viewer (scrollTop 0 -> 844, centred
       post 15697 -> 15666) and from every disc left scrollTop, first-post top and centred post all
       unchanged. It was STRUCTURAL, not a handler: .pf-hf-rep carries no pointer code of any kind and
       was equally dead. The stack sits on the right edge near the vertical middle with a 44px-wide hit
       box, which is exactly where a right thumb rests -- so the reader got a swipe that silently did
       nothing.
       ONE WORD IS THE WHOLE FIX AND NOTHING MOVES. The geometry is untouched because the CONTAINING
       BLOCK is untouched: .pfeed-scroll is `position:static`, so `position:absolute` on these five
       still resolves against .pfeed (position:fixed) exactly as before. Measured after the move --
       .pf-hf-rep/dock/rate border boxes identical to the pixel at all four viewports, offsetParent
       still .pfeed, and they do NOT scroll with the content (an escaped abs-pos box is neither
       scrolled nor clipped by an ancestor that is not on its containing-block chain).
       WHAT CHANGED IS ONLY THE PAN CHAIN, and it had to be measured rather than assumed: Chromium
       walks the BOX-TREE ancestry for scroll chaining, not the containing-block chain, so being a
       DOM descendant of .pfeed-scroll is sufficient and neither a wrapper, a sticky layer nor a
       `touch-action` is needed. Two heavier candidates were prototyped at runtime and measured
       side by side (a position:sticky full-height layer inside the scroller; the same layer at
       height 0 with a 50dvh basis) -- both worked and NEITHER did anything this does not, so the
       one that changes no CSS at all wins.
       `touch-action` is still the wrong tool here and is deliberately not used: see the note in the
       deleted-pull block above for what it cost this control last time.
       The pager now sees these gestures, which is the point: its touchstart records pgStart/pgLive
       and its touchend settles a post. A TAP is unaffected -- dy/dx are ~0, so it resolves to
       `nearI` and returns on the `nearD < 3` guard without paging. */
    scroller.insertAdjacentHTML('beforeend',
      '<button class="pf-hf-rep" type="button" hidden aria-pressed="false" aria-label="Repeat this profile only"><span class="pf-hf-ic">' + RP_ICON + '</span></button>' +
      /* The three accessible names below are the OFF-state ones hfPaint() then keeps in sync; they are
         written once here so a screen reader that reaches the stack before the first paint hears the
         same words. "Start hands-free" / "Change hands-free speed" / "Hands-free speed" match the app
         (PostScreen.js HandsFreeDock and its speed chooser header) -- see hfPaint(). */
      '<button class="pf-hf-dock" type="button" hidden aria-pressed="false" aria-label="Start hands-free">' +
        '<span class="pf-hf-ic">' + HF_PLAY + '</span>' +
      '</button>' +
      '<button class="pf-hf-rate" type="button" hidden aria-label="Change hands-free speed"><span class="pf-hf-ic">5s</span></button>' +
      '<div class="pf-hf-rep-tag" hidden role="status" aria-live="polite"></div>' +
      '<div class="pf-hf-speeds" hidden role="radiogroup" aria-label="Hands-free speed">' +
        HF_SPEEDS.map(function (s) {
          return '<button class="pf-hf-sp" type="button" role="radio" aria-checked="false" data-ms="' + s.ms + '">' +
                 '<span class="pf-hf-sp-lab">' + s.label + '</span>' +
                 '<span class="pf-hf-sp-ms">' + Math.round(s.ms / 1000) + 's</span></button>';
        }).join('') +
        '<span class="pf-hf-sp-note">Videos always play in full</span>' +
      '</div>');
    hfHandle = box.querySelector('.pf-hf-dock');
    hfRate   = box.querySelector('.pf-hf-rate');
    hfSpeeds = box.querySelector('.pf-hf-speeds');
    rpBtn    = box.querySelector('.pf-hf-rep');
    rpTagEl  = box.querySelector('.pf-hf-rep-tag');
    hfLoadSpeed();
    rpLoad(); rpWire();
    hfWireHandle();
    /* THE PRESS THAT STARTS THE REEL. This used to be an anti-dedupe pair on the invite's own button,
       because .pf-hf-card MOVED (hfDockIt put `fly-right` on it: translate + scale(.42) + opacity 0)
       and a browser resolves a TAP's click target with a FRESH hit test AFTER the touch has ended --
       so a card that began its flight between finger-down and click delivered that click to the
       caption behind it (measured on /p/15485 under real CDP touch). The permanent disc cannot have
       that failure: it never moves, so `click` alone is correct for it and hfWireHandle's own
       listener is the whole story. The 700ms `goAt` dedupe that paired the two, and the second
       `goAt` window in the engagement guard below (which existed only because that click landed on
       the CAPTION behind the flown card), are both deleted with the card -- a click on the disc is
       delivered to the disc, and the engagement guard's own `.pf-hf-dock` test already excuses it. */
    // Paint the STORED speed onto the disc the moment it is built. The markup ships a literal "5s",
    // so a reader who had chosen 2s saw the wrong number on their own control until something else
    // happened to repaint it.
    hfPaint();
    // The speed chooser is a POPOVER, not a mode: a pointer anywhere that is not the chooser or the two
    // controls that open it closes it. Capture, no preventDefault, no stopPropagation -- the post
    // underneath still receives the event and still does whatever it was going to do.
    box.addEventListener('pointerdown', function (e) {
      if (hfSpeedsOpen() && !(e.target && e.target.closest && e.target.closest('.pf-hf-speeds, .pf-hf-rate, .pf-hf-dock'))) { hfSpeedsShow(false); }
    }, true);
    /* THE WAKE-TAP GUARD THAT USED TO LIVE HERE IS GONE, AND IS NOT LOST.
       It was `.pf-hf-*`-only: a capture pointerdown recorded whether the press landed on one of
       these three discs, and a capture click dropped a click on them when it had not. That was
       correct, and it turned out to be the FIRST INSTANCE of a bug the whole viewer had -- the
       identical re-target actuates .pfeed-x, .pfeed-menu, .pfeed-who, every .vc-btn, the seek
       bar, the sound button and all four .pf-act, i.e. LIKE and REPOST. So the mechanism has
       been generalised rather than copied: see PF_WAKE_SEL / pfWakeRetarget in the viewer block,
       which lists these three discs and the speed popover among everything else it covers.
       Nothing about the discs' behaviour changes; there is simply one guard now instead of two,
       and the discs cannot drift out of step with the rest of the chrome. */
    // DELIBERATE ENGAGEMENT pauses the reel: any control, link or form inside the viewer, the comment sheet,
    // the per-post menu, or a tap-to-zoom on a pannable photo. A plain vertical swipe is NOT engagement -- it
    // goes through hfOnScroll and keeps hands-free running, which is what the owner asked for.
    box.addEventListener('click', function (e) {
      if (!hfRunning() || !e.target || !e.target.closest) return;
      if (e.target.closest('.pf-hf-dock, .pf-hf-rate, .pf-hf-speeds, .pf-hf-rep')) return;   // our own controls are not "engagement"
      if (e.target.closest('a, button, form, input, textarea, .vctrl, .croller, .comment-panel, .pmenu, .cdot, .cnav') ||
          e.target.closest('.media.pf-zoomable, .media.pf-vscroll, .cslide.pf-zoomable, .cslide.pf-vscroll')) {
        hfPause('engage');
      }
    }, true);
    box.addEventListener('touchstart', function (e) {
      if (hfRunning() && e.touches && e.touches.length > 1) hfPause('engage');   // pinch to zoom / pan
    }, { passive: true });
    box.addEventListener('wheel', function (e) { if (hfRunning() && e.ctrlKey) hfPause('engage'); }, { passive: true });
    scroller.addEventListener('scroll', hfOnScroll, { passive: true });
    // Never advance a feed nobody is looking at, and never leave a timer alive in a background tab. It
    // RESUMES on return: the two stated reasons for the rule (nothing advanced, nothing ticked) are both
    // fully satisfied by pausing, and a reel that dies because a notification stole focus for three seconds
    // is not "sit back and watch". Change the else-branch to hfPaint() if it should stay stopped instead.
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { if (hfRunning()) hfPause('hidden'); }
      else if (hfState === 'paused' && hfWhy === 'hidden') { hfFirst = true; hfStart(); }   // back on the tab: the card on screen gets its full dwell again
    });
    /* WHEN DOES THE REEL COME BACK after an engagement stopped it? (owner, 2026-08-05.)
       Not 'never': the reader deliberately ASKED for hands-free, and a sit-back mode you have to
       re-request after every heart is not sit-back -- it also makes engagement a HARDER stop than the
       tab going hidden, which already self-resumes two lines up. Not 'after a few seconds' either:
       coming back while they are still reading is the complaint restated.
       It comes back when the ATTENTION hold lapses -- two minutes with no human input at all, renewed
       by every touch, wheel and key. Same shape and the same number as presence
       ([[presence-heartbeat-api-chokepoint]]), so there is ONE rule on this site for "the reader is
       still here", not two. A manual swipe renews it, so browsing by hand for ten minutes after a like
       never hands the wheel back mid-scroll; putting the phone down does.
       The handle never lies through any of it: hfPause() repaints it to PLAY the moment we stop, and a
       tap on it is always available as the explicit override. */
    document.addEventListener('rova:attention', function (e) {
      if (e && e.detail && e.detail.on) return;                       // just armed -- nothing to resume
      if (hfState !== 'paused' || hfWhy !== 'engage') return;          // only OUR pause, and only this reason
      if (!hfLive() || hfBlocked()) return;                            // still inside something: stay put
      hfStart();
    });
    /* #634 RE-BIND A STILL-ARMED REPEAT to whatever this open landed on. pfeedready is the one signal
       that says the target is POSITIONED -- before it, rpArm's truncation + pager repoint would orphan
       the very request the seek is riding on and leave cur.positioned false with the pf-settling mask
       still up. The extra beat after it lets the open's buffer-ahead chain and loadBefore finish, so
       the arm costs one discarded page at most rather than fighting the whole open. Registered once,
       with the layer, so it cannot accumulate; it is a no-op unless the chip is lit. */
    document.addEventListener('rova:pfeedready', function () {
      if (!rpOn || rpUser) return;
      setTimeout(rpReArm, 700);
    });
  }
  // Observability, same shape as __rovaMemStats: what state the reel is in and what is driving it.
  window.__rovaHF = function () {
    /* `side` / `sideRule` are GONE with the side machinery -- there is no class to observe and no
       function to compare it against, so a probe reporting them would be asserting a question that no
       longer exists. `docked` / `invite` / `idleMs` / `inviteMs` go the same way: the stack is on
       screen from the open, so `docked` would be a constant true and the other three describe a card
       that is not built. `stack` replaces them with the thing that IS worth observing -- whether the
       three controls are actually shown. */
    /* THE GRIP IS REPORTED SEPARATELY FROM THE STATE, and has to be: it is the one thing that can
       stop the reel advancing WITHOUT moving hfState off 'on', so a probe that read `state` alone
       would show a running reel that never moves and call it healthy. `grip` is whether a hand is
       on a post right now; `due` is a completion waiting out that grip. Together they are the
       whole receipt for the 2026-08-16 hold -- what is holding it, and what it owes when released.
       (window.__rovaGrips() names the individual keys, as __rovaEngaged does for the holds.) */
    return { state: hfState, why: hfWhy, fails: hfFail,
             grip: hfGripped(), due: hfDue, gripMs: HF_GRIP_MS, gripTailMs: HF_GRIP_TAIL_MS,
             stack: !!(hfHandle && !hfHandle.hidden && rpBtn && !rpBtn.hidden && hfRate && !hfRate.hidden),
             photoMs: hfMs, defaultMs: HF_PHOTO_MS,
             speedOpen: hfSpeedsOpen(), speedKey: HF_SPEED_KEY,
             speeds: HF_SPEEDS.map(function (s) { return s.ms; }),
             /* #634. Report the OBSERVED state and the INTENDED one separately so a test can
                compare them. `repeat` is the armed flag the
                chip paints from, `scope` is what the PAGER is actually pointed at -- they are two
                different variables and the whole feature is the claim that they agree. `laps`
                counts wraps, so "it loops back to their first item" is a number rather than a
                story, and `dry` is the guard that stops a scope with nothing in it from spinning. */
             repeat: rpOn, repeatUser: rpUser,
             scope: (cur && cur.rpUser) || '', scopeMode: (cur && cur.mode) || '',
             scopeTab: (cur && cur.rpUser) ? cur.tab : '', offset: (cur && cur.offset) || 0,
             laps: (cur && cur.rpLaps) || 0, dry: (cur && cur.rpDry) || 0,
             looping: !!(cur && cur.looping) };
  };

  /* ---- REPEAT THIS AUTHOR (#634) --------------------------------------------------------------------
     Owner: "While watching the feed on auto play I realized I need a feature to repeat the current
     profiles content. Since sometimes I want to watch the users content only, I love the default
     setting of how it just keeps going to other media so just add a small repeat button above the
     horizontal auto play feed collapsed pill on the right side of the full screen viewer that will
     only loop the current users media only."

     "I LOVE THE DEFAULT" IS THE DESIGN CONSTRAINT, not a compliment to be filed away. Everything
     below is reachable only from a deliberate tap on one new chip, and OFF restores the pager it
     replaced field by field (rpPrev) rather than approximating it -- so a reader who never touches
     the chip cannot tell this shipped.

     HOW THE SCOPE IS ENFORCED, and why it is not a filter in hfNext(). The reel does not "skip
     posts by other people": there ARE no other people below the current post once repeat is armed.
     Arming truncates the list under the post in view and REPOINTS THE PAGER at that author's own
     profile feed, so every later page -- hands-free's, the sentinel's, a thumb's -- is theirs by
     construction. Two things fall out of that which a filter would not have given:
       - hfNext/hfTick/hfPump are untouched. The reel advances one card at a time exactly as before
         and pages through hfPump -> loadMore() exactly as before; it simply finds a different feed
         underneath. Nothing in the hands-free state machine knows this feature exists.
       - a MANUAL swipe obeys the scope too, which is what "I want to watch the users content only"
         asks for. A filter would have left the thumb walking through everyone else's media.

     WHERE THE MEDIA COMES FROM, and why no new query was written. /profile-feed is the endpoint the
     profile viewer has always paged (__rovaProfileFeed), and handle_profile_feed() is the primitive
     that owns the gates: both directions of block, the private-account follow test, Moderation::screen
     for mutes and shadow-suppression, and Posts::byUser -> readyClause + the NSFW category levels.
     Asking it with tab=grid is asking the site's OWN definition of "this member's media" -- the same
     gridEligibleSql() the profile grid renders from -- rather than inventing a second one here.
     [[nsfw-category-levels-are-live-gate-inputs]] and [[api-has-no-global-gates]] are both about the
     same failure: a hand-copied check that rots. There is no check to copy. The client sends a
     username and an offset and renders what comes back.
     The WRAP is the same endpoint at offset 0 again, so a member blocked, muted or gone private
     between two laps drops out of the second lap on its own. A cached id list would not have.

     STATE. rpOn (armed at all) lives in sessionStorage and survives a viewer close, a page navigation
     and a reload within the tab -- the owner's steer, so he is not re-arming it every time he opens
     something. rpUser (WHICH author) is per viewer session and is re-bound on the first settle of a
     new open. Landing on somebody else's post with the chip still lit therefore locks onto THEM,
     which is the only reading of "repeat the current profile's content" that survives being closed
     and reopened.
     IT CLEARS ITSELF ON A CHANGE OF AUTHOR, by any route: swiping back up into the posts above the
     arming point, the rec-roll, a permalink, anything that settles a post whose @handle differs from
     the scope. Clearing DISARMS (rpOn goes false and is persisted), it does not silently re-scope --
     otherwise the two rules fight and every swipe up would re-arm onto whoever you landed on. */
  var RP_KEY = 'rova_hf_repeat';   // sessionStorage: the ARMED flag only, never the author
  var rpOn = false;                // has the reader asked for author-only? (survives a viewer close)
  var rpUser = '';                 // WHO, for this viewer session. '' = not currently scoped
  var rpBtn = null, rpTagEl = null, rpTagT = null;
  var RP_TAB = 'grid';             // the site's media predicate (Posts::byUser gridEligibleSql) -- see above
  /* THE GLYPH IS A RING, NOT A RACETRACK (owner 2026-08-08: "the first icon should be a more
     symmetrically circle recycle icon").
     The old glyph was the Ionicons repeat: two straight bars joined by two 5-unit corner radii, i.e.
     a stadium, with its two arrowheads on the NE and SW corners. It was already exactly centred --
     every path in it maps to itself under (x,y) -> (24-x, 24-y) -- so "asymmetric" was not about its
     BOX. It was about where the ink sits inside a CIRCLE: a stadium's ink runs from close to the
     middle right out to the rim, and it is heaviest on one diagonal, which is exactly the direction a
     circular button has least room in.
     SO THE SHAPE IS DERIVED FROM THE BUTTON IT LIVES IN: two 158-degree arcs of ONE circle, r=7 about
     (12,12), with 22-degree gaps at 12 and 6 o'clock and a chevron head at each arc's end. It is
     generated as a half and its own 180-degree rotation, which is what makes the centring exact
     rather than eyeballed -- the rotation is about (12,12), so the union's bbox centre IS (12,12) by
     construction, no matter how the arc or the head is later tuned.
     MEASURED, painted, on a real 34px disc at 16x device scale (the method in [[badge-icon-centring]]
     -- geometry is asserted off pixels, never off the path string), old vs new:
       ink bbox centre        (0.000, 0.000)      ->  (0.000, 0.000)      both exact
       ink centroid offset    (-0.0024, -0.0016)  ->  (-0.0008, +0.0008)  CSS px from the disc centre
       radial sigma of ink    1.077px             ->  0.573px             -47%: how tightly the ink
                              follows ONE circle. This is the number the owner is describing.
       angular unevenness     0.504               ->  0.357               -29%: ink mass per 10-degree
                              bin, coefficient of variation. The diagonal loading is what goes.
       ink annulus            r 2.64..7.53        ->  r 3.32..6.70        a band, not a blob
     The bbox is 10.75 x 12.00 rather than square, and that is not a miss: two arrowheads standing at
     12 and 6 o'clock are the glyph, and squaring it would mean shrinking them until the loop stops
     reading as a repeat. Roundness is the annulus, not the bounding box. */
  var RP_ICON = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M13.34 5.13A7 7 0 0 1 13.34 18.87"/><path d="M16.25 19.93 13.34 18.87l2.3-2.07"/><path d="M10.66 18.87A7 7 0 0 1 10.66 5.13"/><path d="M7.75 4.07 10.66 5.13 8.36 7.2"/></svg>';
  // ON: the same loop with the "1" of repeat-one standing inside it. A different SILHOUETTE, so the
  // state survives being seen in peripheral vision or in a screenshot with the colour washed out.
  // The "1" is centred on (12,12) too (bbox x 11.3..12.7, y 9.4..14.6) so it cannot pull the glyph
  // off the axis the rest of this was built to hold.
  var RP_ICON_ON = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M13.34 5.13A7 7 0 0 1 13.34 18.87"/><path d="M16.25 19.93 13.34 18.87l2.3-2.07"/><path d="M10.66 18.87A7 7 0 0 1 10.66 5.13"/><path d="M7.75 4.07 10.66 5.13 8.36 7.2"/><path d="M11.3 14.6h1.4M12.7 14.6V9.4M12.7 9.4l-1.3.8" stroke-width="1.9"/></svg>';

  function rpLoad() { try { rpOn = sessionStorage.getItem(RP_KEY) === '1'; } catch (e) { rpOn = false; } }
  function rpSave() { try { if (rpOn) sessionStorage.setItem(RP_KEY, '1'); else sessionStorage.removeItem(RP_KEY); } catch (e) {} }

  /* The @handle of a post CARD, read the one way this viewer already reads it -- off .post-av's
     /@user href, which is what updateFeedBar() has always used to re-attribute the top bar. One
     source for "whose post is this", so the chip and the bar can never disagree about the author. */
  function pfPostUser(p) {
    var link = p && p.querySelector && p.querySelector('.post-av');
    var m = link && (link.getAttribute('href') || '').match(/\/@([^\/?#]+)/);
    if (!m) return '';
    try { return decodeURIComponent(m[1]); } catch (e) { return m[1]; }
  }

  /* Drop every card BELOW the anchor, releasing its media first. Same recipe as pruneFarPosts()
     (the clip off playIO/warmIO and its decoder freed, the carousel's self-rescheduling slideshow
     stopped, the images off all three image observers) -- a bare removeChild leaves every one of
     those holding the detached node, which is the leak those call sites exist to prevent.
     NO scrollTop fix-up, and that is not an omission: pruneFarPosts removes cards ABOVE its anchor,
     which slides the anchor up under the reader, whereas everything here is below a post that is
     snapped to the top of the scroller, so nothing the reader can see moves. */
  /* ONE CARD'S TEARDOWN, lifted out of the loop below so the disarm hand-off can drop a RUN of
     cards rather than a suffix and still release exactly what arming releases. Extracting it is
     the whole point: two call sites that free media by two recipes is how one of them ends up
     leaking a detached node onto an observer, which is the failure this recipe exists to prevent. */
  function rpRelease(p) {
    if (!p) return;
    if (window.__rovaReleaseVideos) { try { window.__rovaReleaseVideos(p); } catch (e) {} }
    Array.prototype.forEach.call(p.querySelectorAll('.carousel.carousel-playing'), function (c) { try { if (c.__cstop) c.__cstop(); } catch (e) {} });
    Array.prototype.forEach.call(p.querySelectorAll('img'), function (im) {
      try { if (pfImgWarmIO) pfImgWarmIO.unobserve(im); } catch (e) {}
      try { if (pfBytesIO)  pfBytesIO.unobserve(im); } catch (e) {}
      try { if (kbIO)       kbIO.unobserve(im); } catch (e) {}
    });
    if (p.parentNode) { p.parentNode.removeChild(p); }
  }
  function rpDropAfter(anchor) {
    if (!list || !anchor) return 0;
    var posts = list.querySelectorAll('.post');
    var i = Array.prototype.indexOf.call(posts, anchor);
    if (i < 0) return 0;
    var n = 0;
    for (var k = i + 1; k < posts.length; k++) { rpRelease(posts[k]); n++; }
    return n;
  }

  // A page fetched BEFORE the scope changed must not land after it. cur is the same OBJECT across an
  // arm/disarm (we repoint it in place rather than replacing it), so the existing `cur !== mine` guard
  // in loadMore/loopMore cannot see this: rpGen is what it compares instead. Bumping it here orphans
  // every request already in flight, and rpArm/rpDisarm clear cur.loading themselves so the orphaned
  // handler is completely inert -- it must not clear a flag its successor now owns.
  function rpBump() { if (cur) { cur.rpGen = (cur.rpGen || 0) + 1; cur.loading = false; sentinel.classList.remove('on'); } }

  function rpArm(u) {
    if (!u || !cur || !list) return false;
    var anchor = currentPost();
    if (!anchor) return false;
    // Stash the pager WHOLE. Switching repeat off has to put the reader back on the feed they were
    // watching, and "roughly back" is how a viewer starts repeating posts it already showed: cur.idx
    // and cur.seen are the two that decide that, and neither can be re-derived after the fact.
    if (!cur.rpPrev) {
      cur.rpPrev = { mode: cur.mode, user: cur.user, tab: cur.tab, offset: cur.offset, more: cur.more,
                     rec: cur.rec, seen: cur.seen, authorSet: cur.authorSet, feedless: cur.feedless,
                     looping: cur.looping, loopIds: cur.loopIds, loopPtr: cur.loopPtr };
    }
    rpBump();
    rpDropAfter(anchor);
    cur.rpUser = u; cur.rpDry = 0; cur.rpLaps = 0; cur.rpLapAdd = 0;
    // 'author', not 'feed': every `cur.mode === 'feed'` branch in loadMore is the id-list pager and
    // would page cur.ids; every `!== 'feed'` branch is the offset pager that /profile-feed speaks,
    // including the d.count stepping that walks OVER a screened-out row and the seen[] de-dup. This
    // also parks loadBefore() and pruneFarPosts(), both of which rebuild from cur.ids and have nothing
    // to say about a profile -- exactly the state the profile viewer runs in today.
    cur.mode = 'author'; cur.user = u; cur.tab = RP_TAB; cur.offset = 0;
    cur.rec = false; cur.looping = false; cur.loopIds = null; cur.loopPtr = 0;
    // A profile-photo ALBUM is the one feed that is allowed to END (hfPump reads this and stops the
    // reel on it). A repeat scope is a live, pageable profile feed and must not inherit that verdict;
    // rpPrev carries the flag back untouched the moment repeat is switched off.
    cur.feedless = false;
    // null, not {}: re-derived from what is LEFT on screen, so page 1 -- which is this author's newest
    // media and therefore almost always contains the post being watched -- does not append that post
    // directly underneath itself. rpWrap() sets {} instead, for the opposite reason.
    cur.seen = null;
    cur.authorSet = false;            // let page 1's author card re-point the bar's avatar + blue check
    cur.more = true;
    sentinel.style.display = '';
    rpUser = u; rpOn = true; rpSave();
    rpPaint();
    rpSay('Repeating @' + u, 2600);
    loadMore();
    return true;
  }

  /* ===== #634 THE HAND-OFF: SWITCHING IT OFF IS A STATEMENT ABOUT WHAT COMES NEXT =====
     Owner, 2026-08-09: "When I turn off repeat for a user during full screen media view it takes
     a while before I start to see other people's slides. I want the very next slide to be someone
     else. Since if they're turning it off they're most likely done watching that user."

     THE SCOPE SWITCH WAS NEVER THE SLOW PART -- rpDisarm re-points the pager on the tap. What
     lagged was the LIST. rpArm truncates at the anchor and from then on rpWrap/loadMore are the
     only things that append, so every card queued in front of the reader is the scoped author's by
     construction. Restoring the pager widened the SOURCE and left that queue standing: up to
     RP_AHEAD more cards of the person he had just said he was done with.

     WHAT IT DOES: drop the LEADING RUN of that author's cards below the post he is watching, and
     stop at the first card belonging to somebody else. Only the leading run -- a card of theirs
     further down is the underlying feed's own ordering and removing it would be editing his feed
     rather than answering his tap.

     TWO TIERS, and the second exists because empty is worse than wrong.
       instant  something of somebody else's is ALREADY behind the run (the reader scrolled back
                above the arming anchor, so the feed's own cards are still down there). Drop the
                run and the next card is his feed, with no network at all.
       cushion  nothing is behind the run -- the usual shape. The run STAYS UP while loadMore()
                fetches into the space after it, and the swap happens only once a card has actually
                landed. Dropping first and fetching into the hole would trade a wait-for-the-right-
                content for a wait-for-any-content, which is the worse bargain.
     The fetch is cheap and it is not a restart: cur.idx is never written by a scope (which is why
     rpPrev does not carry it), so a restored feed pager asks /post-cards for the exact ids that
     were next when he armed, and cachedBatch() can answer some of those with no request at all.

     NOTHING THE READER CAN SEE MOVES. Every card touched is below a post snapped to the top of the
     scroller, which is the same reason rpDropAfter needs no scrollTop fix-up.

     DEAD END STAYS GRACEFUL, and that is the `grew` test: if the load appends nothing -- the feed
     is dry, or this author is genuinely all that is left -- the cushion is kept and the reel ends
     exactly the way it ends today. Nothing here can leave him on a list that cannot advance.

     IDEMPOTENT BY CONSTRUCTION rather than by a flag: if the next card is already somebody else's,
     the run is empty and this returns having done nothing. A second disarm, or a disarm that was
     never armed (rpDisarm's own `cur.rpUser` gate), cannot reach a second fetch. */
  function rpHandOff(scoped) {
    if (!cur || !list || !scoped) return 'no-scope';
    var anchor = currentPost(); if (!anchor) return 'no-anchor';
    var posts = list.querySelectorAll('.post');
    var i = Array.prototype.indexOf.call(posts, anchor);
    if (i < 0) return 'no-anchor';
    var stale = [];
    for (var k = i + 1; k < posts.length; k++) {
      if (pfPostUser(posts[k]) !== scoped) break;
      stale.push(posts[k]);
    }
    if (!stale.length) return 'already-someone-else';
    if (i + 1 + stale.length < posts.length) { stale.forEach(rpRelease); return 'instant'; }
    var mine = cur, g = cur.rpGen || 0, pr;
    try { pr = loadMore(); } catch (e) { return 'fetch-failed'; }
    if (!pr || !pr.then) return 'fetch-failed';
    pr.then(function () {
      // re-armed, session changed, or another disarm has already owned this: stand down. cur is
      // repointed IN PLACE across an arm/disarm, so identity alone cannot see it -- rpGen can.
      if (cur !== mine || (cur.rpGen || 0) !== g || cur.rpUser) return;
      var last = stale[stale.length - 1];
      if (!last || !last.parentNode) return;              // pruned under us; nothing to swap
      var grew = false, n = last.nextElementSibling;
      while (n) { if (n.classList && n.classList.contains('post')) { grew = true; break; } n = n.nextElementSibling; }
      if (!grew) return;                                   // dead end -- keep the cushion
      stale.forEach(rpRelease);
    });
    return 'cushion';
  }

  function rpDisarm(why) {
    var had = rpUser;
    var scoped = (cur && cur.rpUser) || '';
    rpOn = false; rpUser = ''; rpSave();
    if (cur && cur.rpUser) {
      rpBump();
      cur.rpUser = ''; cur.rpDry = 0; cur.rpLapAdd = 0;
      var pv = cur.rpPrev;
      if (pv) {
        cur.mode = pv.mode; cur.user = pv.user; cur.tab = pv.tab; cur.offset = pv.offset;
        cur.rec = pv.rec; cur.seen = pv.seen; cur.authorSet = pv.authorSet; cur.feedless = pv.feedless;
        cur.looping = pv.looping; cur.loopIds = pv.loopIds; cur.loopPtr = pv.loopPtr;
        // cur.more is restored FAITHFULLY rather than forced true. A feed that was already exhausted
        // when repeat was armed comes back with looping:true + its loopIds, i.e. the endless loop it
        // was already in; forcing more:true would instead have it re-fetch a source known to be dry.
        cur.more = pv.more;
        cur.rpPrev = null;
        sentinel.style.display = cur.more ? '' : 'none';
      }
    }
    // ...and now the LIST, which is the half the reader can see. Strictly after the pager has been
    // handed back its own mode/offset/seen above: the hand-off's cushion tier calls loadMore(), and
    // a load issued before that restore would page the SCOPE it is standing down from.
    if (scoped) { rpHandOff(scoped); }
    rpPaint();
    if (had) { rpSay(why === 'author' ? 'Repeat off, new profile' : 'Repeat off', 1800); }
  }

  /* THE WRAP. "Looping: when the author's media is exhausted, wrap to their first item."
     Offset back to 0 on the same endpoint, so the second lap is FETCHED rather than replayed from a
     remembered id list -- an author who blocked the reader, went private or had a post pulled between
     the laps simply does not come back, and one who posted does. seen={} (empty, never null) is the
     whole of "start the lap over": null would re-derive the set from the cards already rendered and
     de-dup the entire author away, which is the same page-returns-nothing shape the profile pager's
     own comment warns about.
     rpDry is the only thing standing between a wrap and a spin: a scope that renders NOTHING twice in
     a row (every post grid-hidden, every post screened) would otherwise wrap forever at fetch speed.
     Two dry laps hands over to a scoped loop of whatever of theirs is still on screen, which cannot be
     empty -- the post being watched is one of them. */
  function rpWrap() {
    if (!cur) return Promise.resolve();
    // DRY is counted per LAP THAT ACTUALLY FETCHED, not per call: with the ceiling below, rpWrap is
    // entered plenty of times without loading anything, and counting those would strand a healthy
    // scope in the degenerate fallback after two quiet settles.
    if ((cur.rpLapAdd || 0) > 0) { cur.rpDry = 0; } else { cur.rpDry = (cur.rpDry || 0) + 1; }
    if (cur.rpDry >= 2) { return rpScopedLoop(); }
    cur.rpLaps = (cur.rpLaps || 0) + 1;   // observability: __rovaHF().laps -- see the probe
    cur.rpLapAdd = 0;
    cur.offset = 0; cur.seen = {}; cur.more = true;
    sentinel.style.display = '';
    /* THE CEILING, and why a pixel budget cannot be the thing that stops this.
       loadMore's buffer chain re-enters itself until 9000px (PFEED_BUFFER_AHEAD) of cards sit below
       the fold. That works because every other source is rate-limited by having to FETCH SOMETHING
       NEW: the ids run out, the profile's offset walks to its end. A wrapped scope is neither -- it
       is an infinite source of the same handful of cards -- and a freshly appended .post measures
       almost nothing until its media lands, so `ahead` under-reads and the chain keeps asking. On
       @grindhd, who has TWO grid posts, that measured 118 post nodes / 119,755 DOM nodes / 9,211
       listeners and a network that never went quiet in 30s, against 25 / 14,392 / 1,439 on the same
       gestures unarmed. It is not a leak; it is the chain doing exactly what it was told with a
       source that can always say yes.
       So a scope is bounded by COUNT instead. Six cards below the reader is more than hands-free can
       consume in a dwell and more than a thumb reaches between settles, and repeating the same two
       posts sixty times to satisfy a pixel budget buys nothing that six does not.
       IT CANNOT DEAD-END, which is the one thing the pixel chain was protecting (a sentinel left
       inside its own margin never re-fires). Stopping here leaves cur.more true, the sentinel shown
       and the offset already rewound, and rpSettle() tops the buffer back up on the very next scroll
       settle -- an event-driven trigger the IntersectionObserver's re-arm is not needed for. */
    if (rpBelow() >= RP_AHEAD) { return Promise.resolve(); }
    return loadMore();
  }
  var RP_AHEAD = 6;                        // cards of the scope kept below the reader
  function rpBelow(p) {
    if (!list) return 0;
    var posts = list.querySelectorAll('.post');
    var i = Array.prototype.indexOf.call(posts, p || currentPost());
    return i < 0 ? 0 : (posts.length - 1 - i);
  }

  /* Degenerate fallback only (see rpWrap): cycle the author's OWN cards already in the list, through
     the viewer's existing endless-loop machinery. /post-cards re-checks visibility per id on every
     lap, so even this path cannot outlive a gate change. */
  function rpScopedLoop() {
    if (!cur || !list) return Promise.resolve();
    var ids = [];
    Array.prototype.forEach.call(list.querySelectorAll('.post'), function (p) {
      if (pfPostUser(p) !== cur.rpUser) return;
      var v = p.getAttribute('data-view') || p.getAttribute('data-id');
      if (v && ids.indexOf(v) < 0) { ids.push(v); }
    });
    if (!ids.length) { cur.more = false; sentinel.style.display = 'none'; return Promise.resolve(); }
    cur.loopIds = ids; cur.loopPtr = 0; cur.looping = true; cur.more = true;
    sentinel.style.display = '';
    return loopMore();
  }

  function rpPaint() {
    if (!rpBtn) return;
    var on = !!rpUser;
    rpBtn.classList.toggle('on', on);
    // wrapped in .pf-hf-ic for the same reason the dwell label is: that span is the horizontal hit
    // target all three discs share (rova.css). The svg itself is unchanged.
    rpBtn.innerHTML = '<span class="pf-hf-ic">' + (on ? RP_ICON_ON : RP_ICON) + '</span>';
    rpBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
    var lab = on ? ('Repeating @' + rpUser + ' only. Turn off to play the whole feed')
                 : 'Repeat this profile only';
    rpBtn.setAttribute('aria-label', lab);
    rpBtn.setAttribute('title', on ? ('Repeating @' + rpUser + ' only') : 'Repeat this profile only');
  }

  /* Say it in words for a beat. One timer, opacity only, and role=status so a screen reader is told
     the same thing the chip's colour says. Never a permanent label: this edge is 3 chips deep already.
     IT IS THE STACK'S ANNOUNCER NOW, NOT THE REPEAT CHIP'S ALONE. `row` names which disc is speaking
     ('dock' = the play/pause disc, anything else = the repeat disc it was built for, so every existing
     call site keeps its behaviour by omission). The class is what moves it; the ROW IS PART OF THE
     MESSAGE, so it is set in the same statement as the text and the two can never disagree.
     ONE ELEMENT AND ONE TIMER IS ALSO THE COLLISION RULE, and it is enforced by construction rather
     than by a policy somebody has to remember: two labels cannot stack in the same row because there
     is only one label. A second announcement inside the first's window replaces it outright, restarts
     the full dwell, and slides the pill to the disc that spoke -- which is the correct behaviour for a
     single aria-live region too (a queued stale state is worse than a superseded one).
     NEWEST-WINS IS UNCONDITIONAL HERE, and that is a fact about this file rather than a preference.
     The app's version needs one exception -- when repeat and hands-free change in the SAME update, the
     repeat line carries the REASON and hands-free only the CONSEQUENCE, so hands-free stands down.
     There is no web instance of that to stand down from: rpArm / rpDisarm are reached only from
     rpWire's own click, rpSeen's author-change settle and rpReArm, and not one of them touches
     hfStart / hfPause / hfStop; in the other direction the hands-free machine reaches rpPaint() (paint
     only, it cannot speak) and hfClose(), which clears rpUser WITHOUT a line. The two state machines
     are disjoint, so no single update can produce two messages and there is nothing to arbitrate.
     What newest-wins DOES have to get right is the reader who taps repeat and then play half a second
     later: both are real, separate changes and both must be heard. A time-window rule would have
     swallowed the second one; replacing on every call cannot. */
  function rpSay(msg, ms, row) {
    if (!rpTagEl) return;
    clearTimeout(rpTagT);
    rpTagEl.classList.toggle('at-dock', row === 'dock');
    rpTagEl.textContent = msg;
    rpTagEl.hidden = false;
    // `!hidden` IS THE RE-CHECK, and it is not theoretical. Closing the viewer while the reel runs
    // fires the engagement guard's hfPause() -- .pfeed-x is a <button> -- so a label is raised and
    // hfReset() hides it again inside the SAME click dispatch, i.e. before this frame. Without the
    // test the rAF then re-lit `.in` on an element that is display:none, and the class survived the
    // close: the NEXT label found itself already `.in` and popped in with no fade at all.
    requestAnimationFrame(function () { if (rpTagEl && !rpTagEl.hidden) rpTagEl.classList.add('in'); });
    rpTagT = setTimeout(function () {
      if (!rpTagEl) return;
      rpTagEl.classList.remove('in');
      rpTagT = setTimeout(function () { if (rpTagEl) rpTagEl.hidden = true; }, hfReduced() ? 0 : 220);
    }, ms || 2200);
  }

  /* THE AUTHOR OF THE POST THAT JUST SETTLED. Called from the scroller's existing 220ms trailing
     settle and from updateFeedBar(), which already has the handle in hand -- so a swipe costs this
     feature NOTHING, and the settle path costs one currentPost() only while it is armed. There is no
     per-frame work and no per-card listener anywhere in this block.
     ARMING is deliberately not done here on a plain settle: it re-binds only where the scope is
     genuinely absent (a fresh viewer open with the chip still lit), and even then only after
     rova:pfeedready, because truncating the list under an open that has not positioned its target yet
     would strand cur.positioned false and the pf-settling mask with it. */
  function rpSeen(u) {
    if (!rpUser || !u) return;
    if (u !== rpUser) { rpDisarm('author'); }
  }
  function rpSettle() {
    if (!rpOn && !rpUser) return;                         // idle: one property read per settle
    if (!box || !box.classList.contains('show')) return;
    if (!rpUser) {
      // Fallback re-arm for an open that never dispatched pfeedready -- it fires only on the
      // TARGET landing, so a viewer opened without one would otherwise never re-bind a lit chip.
      // Gated on the open's own mask having lifted, so this can never truncate a list mid-seek.
      if (!box.classList.contains('pf-settling')) { rpReArm(); }
      return;
    }
    var p = currentPost(); if (!p) return;
    rpSeen(pfPostUser(p));
    // ...and top the scope's buffer back up if the reader has eaten into it. This is the other half
    // of rpWrap's count ceiling: the ceiling stops the chain, this restarts it, and between them the
    // scope keeps ~RP_AHEAD cards below the reader forever without ever appending sixty copies of a
    // two-post profile. One list query on a settle that is already doing a currentPost() scan.
    if (rpUser && cur && cur.rpUser && cur.more && !cur.loading && rpBelow(p) < RP_AHEAD) { loadMore(); }
  }

  // A viewer OPEN with the chip still lit: re-bind the scope to whoever was just opened, once the
  // target has landed (rova:pfeedready) and the open's own paging has had a beat to settle. Any page
  // still in flight at that point is orphaned by rpBump, which is safe here and only here -- the
  // target is already positioned, so nothing is waiting on that request to reveal the viewer.
  function rpReArm() {
    if (!rpOn || rpUser || !hfLive()) return;
    var p = currentPost(); if (!p) return;
    var u = pfPostUser(p); if (!u) return;
    rpArm(u);
  }

  function rpWire() {
    if (!rpBtn) return;
    rpBtn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      if (rpUser) { rpDisarm('user'); return; }
      var p = currentPost(), u = p && pfPostUser(p);
      // No @handle on the card = nothing to scope to. Say so rather than lighting a chip that
      // silently governs nothing -- an ON state that does not hold is the complaint this feature
      // is already carrying four affordances to avoid.
      if (!u) { rpSay('No profile on this post', 1800); return; }
      rpArm(u);
    });
  }

  // The viewer HIDES each post's own head (.pfeed .post .post-head .name/.vtick are display:none --
  // the top bar IS the identity), so a verified author lost their blue check the moment you opened the
  // immersive viewer (owner report: "this page should show the verified check by their name"). Mirror
  // the tick into the bar: the post card already carries the server-rendered <svg class="vtick">, so
  // clone that -- no extra request.
  //
  // WHERE THAT TICK LIVES CHANGED ON 2026-08-17 and this reader had to move with it. It used to be
  // the element right after the FIRST .name in .post-head; the check now rides the author's PHOTO
  // (views/_post.php emits `class="post-av vav"` with the tick inside). The old "first .name's next
  // sibling" test therefore matched nothing and the bar silently dropped the badge on every verified
  // author -- caught at 390px on /p/44237, where the card drew a check and the bar above it did not.
  //
  // `.post-av > .vtick` is a DIRECT-CHILD read and that is load-bearing for the same reason the old
  // sibling test was: a co-post also carries `.collab-av > .vtick` for the CO-AUTHOR, and a loose
  // descendant selector inside the card would let a verified collaborator tick an unverified author.
  // The clone lands in .pfeed-name, which is not a corner wrapper, so it picks up the base inline
  // .vtick styling exactly as the old clone did -- the markup verified_tick() emits is identical.
  function pfBarTick(post) {
    var nameWrap = box && box.querySelector('.pfeed-name'); if (!nameWrap) return;
    var src = post && post.querySelector('.post-av > .vtick');
    pfSetBarTick(src ? src.outerHTML : '');
  }
  // Set/clear the bar tick from raw markup (profile mode gets it straight off the JSON author card,
  // so the check is right on the first frame instead of waiting for a post to settle).
  function pfSetBarTick(html) {
    var nameWrap = box && box.querySelector('.pfeed-name'); if (!nameWrap) return;
    var have = nameWrap.querySelector('.vtick');
    if (!html) { if (have) have.parentNode.removeChild(have); return; }
    if (have) return;   // already ticked -- don't re-parse identical markup on every settle
    nameWrap.insertAdjacentHTML('beforeend', html);
  }

  // feed mode: swap the bar's avatar/@handle to whichever post is currently in view
  function updateFeedBar(known) {
    // Runs in BOTH feed and profile mode: from a profile, swiping past the owner's own posts into the
    // engagement rec-roll lands on OTHER authors' posts, and the top bar must re-attribute to whoever's
    // post is on screen -- else the profile owner's @name stuck on everyone else's media (owner report).
    if (!cur) return;
    // `known` = the post we ALREADY know we are landing on (the pager knows its target before the
    // glide starts). Passing it skips currentPost(), which is a getBoundingClientRect on EVERY
    // rendered post -- 290 forced layouts per swipe, 72% of all layout reads in the swipe path.
    var p = known || currentPost(); if (!p) return;
    /* THE ARRIVAL, SAID OUT LOUD (owner 2026-09-17, the media ring). This is the one place every
       route that lands a post -- the open's first settle, settleTo's handover and commit, step()'s
       advance, the scroll settle -- already reports to, so it is the honest definition of "the
       reader is now ON this post". Announced once per post change (a bar refresh on the same post
       is not an arrival); `ring` says whether this session is the ring's deck, so the listener can
       ignore every other viewer. The ring marks its circles seen off this and off nothing else:
       what was actually reached, never the queue. */
    var pfArrId = p.getAttribute('data-view') || '';
    if (pfArrId && pfArrId !== pfLastArrive) {
      pfLastArrive = pfArrId;
      try { document.dispatchEvent(new CustomEvent('rova:pfpost', { detail: { id: pfArrId, post: p, ring: !!(cur && cur.ring) } })); } catch (e) {}
    }
    /* A MANUAL PAGE RESETS THE DWELL (owner 2026-08-14: "The hands free speed timer should reset if
       the user swipes to another media manually"). hfOnScroll already re-arms on exactly this test --
       but only off a SCROLL EVENT, and the two manual routes that matter do not dispatch one in time.
       settleTo() glides a composited TRANSFORM and writes scrollTop ONCE, at the commit
       (transform-glide-fires-no-scroll-events), so the re-arm landed ~440ms after the finger lifted
       (600ms on the pgSafeT net); step()'s 320ms tween plus hfOnScroll's own 180ms debounce puts the
       keyboard at ~500ms. In that window the OUTGOING post's live dwell -- hfT, or hfPass on a clip
       about to wrap, which is exactly when a reader swipes away -- still fires, and advances the post
       that just arrived before it has been looked at at all. At "Fastest" (2000ms) that is a quarter
       of the whole dwell; on a video it is a near-guaranteed double-skip.
       THIS IS THE EARLIEST HONEST PLACE: the bar is the one thing already TOLD a post change has
       landed, by every manual route there is (settleTo's 130ms handover and its commit, step()'s
       advance, the scroll settle) -- so the reset no longer waits on a scroll event to exist.
       IT CANNOT DISTURB THE REEL'S OWN ADVANCE: hfNext() claims hfPost = the target BEFORE calling
       step(), precisely so this test reads false on our own move -- the same invariant hfOnScroll's
       identical check has always relied on. hfOnScroll STAYS: it is the only cover for a native wheel
       or PageDown scroll in profile mode, where the 100ms bar throttle is feed-mode-only.
       Idempotent and free: hfTick() sets hfPost = p, so every later call for the same post is one
       reference compare, and the null test keeps hfStart()'s 120ms kick (hfPost = null) intact.
       hfManualNav SINCE 2026-08-29 (owner, recording: swiping back up, "it immediately kicks me back
       to the next post over and over"): the same test, but the arrival now also drops a stale earned
       latch, stamps the nav tail that holds hfAdvance, restarts a BACKWARD-arrived clip from 0 and
       re-eases a photo's pan from rest -- a manually-reached post gets a FULL fresh interval, by the
       owner's chosen design (manual navigation never pauses hands-free). */
    if (hfRunning() && hfPost && p !== hfPost) { hfManualNav(p); }
    var link = p.querySelector('.post-av'), avImg = p.querySelector('.post-av .avatar');
    var uname = ''; var m = link && (link.getAttribute('href') || '').match(/\/@([^\/?#]+)/); if (m) uname = decodeURIComponent(m[1]);
    var barAv = box.querySelector('.pfeed-av'), barTitle = box.querySelector('.pfeed-title'), who = box.querySelector('.pfeed-who');
    /* THE GREEN ONLINE DOT COMES WITH THE AVATAR, in the same assignment, on purpose (owner
       2026-08-14: "@Kaine shows the dot on their profile but not in the full-screen viewer").
       avatar_img() wraps an online member's avatar in <span class="av-on"> and hangs the
       <i class="online-dot" data-t data-ttl> off that wrapper -- the .post-av inside every card is
       rendered by the SAME helper the profile header uses (views/_post.php:174), and the viewer
       merely hides that head (.pfeed .post .post-avwrap{display:none}), it does not strip it. So
       the dot is already sitting in this post's DOM; cloning the bare .avatar was simply dropping
       it on the floor.
       WHY THE WRAPPER AND NOT A FLAG. This bar is RECYCLED across every post the reader swipes
       through, and the repo has already been bitten by a shared bar re-attributing on a different
       schedule than the media (the 159ms wrong-name window during a transform glide). A separate
       "is this author online" lookup would be a second schedule by construction. Taking the
       wrapper's outerHTML means the dot is written by the same statement, from the same post
       element, behind the same data-u guard as the photo it rides on: there is no interval in
       which the bar can hold author B's avatar and author A's presence, because they are one
       string. The @handle two lines below and the tick below that are set from the same `p`
       within this same call.
       NO NEW REQUEST AND NO NEW DISCLOSURE. data-t/data-ttl are carried through verbatim, so the
       cloned dot is dated from when the SERVER rendered that card, not from when it was copied
       into the bar -- which is what keeps it honest on /p/<id>, a route that is edge-cached for
       guests for up to 60s (EdgeCache::pathAllowed). presenceSweep() walks the whole document, so
       the copy in the bar expires on exactly the terms the card's own dot does, and a card whose
       dot has ALREADY been swept clones as offline. Nothing here can create a dot. */
    // The IMMEDIATE parent, never closest('.av-on'): avatar_img() always wraps the .avatar element
    // directly (img, monogram span, or the .av-vid span around a video avatar), so this is exact,
    // costs one class test, and cannot climb out of .post-av looking for an unrelated wrapper.
    var avPar = avImg && avImg.parentNode;
    var avSrc = (avPar && avPar.classList && avPar.classList.contains('av-on')) ? avPar : avImg;
    if (avImg && barAv && barAv.getAttribute('data-u') !== uname) { barAv.innerHTML = avSrc.outerHTML; barAv.setAttribute('data-u', uname); }
    if (uname) { if (barTitle) barTitle.textContent = '@' + uname; var bh = box.querySelector('.pfeed-host'); if (bh) bh.textContent = 'rovasocial.com/'; if (who) who.href = '/@' + encodeURIComponent(uname); }
    pfBarTick(p);   // re-attribute the blue check with the handle (both modes -- the rec-roll changes author)
    // #634: the bar has just decided whose post this is, so hand repeat the SAME answer rather than
    // letting it re-derive one. Free (uname is already in hand) and it means the chip can never
    // disagree with the @handle printed above it. Clears the scope only; arming is rpReArm's job.
    rpSeen(uname);
    /* THE POST IN VIEW HAS CHANGED, so a music preview belonging to a post that is no longer on screen is
       audio with no visible source and no reachable control -- the same complaint the close path fixes,
       one swipe instead of one dismissal. This is the cheapest correct place for it: the bar is the one
       thing that already knows which post has landed, and the hook returns on a single property read
       whenever nothing is playing. It only ever stops a card INSIDE the viewer -- the timeline's pinned
       player is deliberately allowed to play on as the page scrolls. */
    if (window.__rovaAmLeave) { try { window.__rovaAmLeave(p); } catch (e) {} }
    /* ...AND NO CLIP AUDIO CARRIES OVER EITHER (owner 2026-08-14: "I shouldn't keep hearing a clip
       if I've swiped to another media, no overlap at all"). Exactly the argument the music-preview
       hook above already makes, applied to the thing that is far more audible.
       WHERE THE OVERLAP LIVED. settleTo() glides a composited TRANSFORM on `list`, not scrollTop, so
       the scroller's per-rAF __rovaSyncSound never runs for the length of the slide: the OUTGOING
       clip stayed audible for the whole 260ms glide -- 420ms on the pgSafeT safety net -- with the
       incoming post already covering the screen for the last third of it. step()'s tween does write
       scrollTop and so does fire scroll events, but applySound() only re-hands the sound once the
       VIEWPORT CENTRE crosses the post boundary (activeVideo's curP test), i.e. halfway through the
       320ms tween; and its hfReduced()/|delta|<2 branch lands the post with no sound sync at all.
       ONLY WHEN `known` WAS PASSED, and that is the whole point: a post CHANGE has actually been
       decided by the caller (step()'s advance, settleTo's 130ms handover and its commit). Sweeping
       on every throttled scroll tick instead would fight applySound(), which resolves the audible
       clip from the viewport CENTRE while currentPost() resolves from the scroller TOP -- the two
       disagree by one post mid-swipe, and a clip would flap muted/unmuted once per frame.
       MUTE ONLY, NEVER UNMUTE. applySound() stays the sole authority on which clip is AUDIBLE and
       re-hands the sound to the incoming clip a beat later (settleTo's __rovaSyncSound at the
       commit, and the scroller's own rAF listener), so this can silence a departing clip and can
       never make noise on its own -- the rule hands-free already states three ways. Nothing is
       PAUSED either: pausing would fight __rovaVideoOnePass and the crop-flight's homing clip, and
       silence is what was asked for.
       STAMPED through __rovaEngineMute, never a bare v.muted assignment, or the volumechange
       handler reads it as the reader reaching for the mute button and flips soundOn plus the saved
       rova_sound preference for the whole site. PiP is exempt for the same reason applySound
       exempts it: a popped-out clip keeps its own sound. */
    if (known) {
      var _pip = document.pictureInPictureElement;
      Array.prototype.forEach.call(box.querySelectorAll('video'), function (v) {
        if (v === _pip || v.muted) return;
        if (v.closest && v.closest('.post') === p) return;   // the post that has LANDED keeps its sound
        if (window.__rovaEngineMute) { window.__rovaEngineMute(v, true); }
        else { v._engineSetAt = Date.now(); v.muted = true; }
      });
      /* ...AND THE OTHER HALF: SOMETHING HAS TO RE-ASK. The sweep above is MUTE-ONLY by design, so on
         its own it can only ever leave the viewer quieter than it found it -- and the two windows the
         block's own comment names (settleTo's transform glide, which fires NO scroll events, and
         step()'s hfReduced()/|delta|<2 branch, which lands the post with no sound sync at all) end with
         nobody having handed the sound to the clip that ARRIVED. applySound() is the sole authority on
         which clip is audible, so call it -- but ONE FRAME LATER, deliberately. Synchronously here it
         would be worse than useless at settleTo's 130ms handover: the viewport centre is still inside
         the OUTGOING post at that moment, so activeVideo() would resolve to the clip this sweep has just
         silenced and hand it the sound straight back. A frame's deferral lets the caller's commit land
         first. Idempotent and cheap by the same rule the rest of this closure leans on -- engineMute()
         skips no-op sets -- so on every path that WAS already synced this costs one query and nothing
         else, and it can never make noise the pill/pref doesn't already allow (applySound gates on
         soundOn/pfLatch AND userActivated()). */
      requestAnimationFrame(function () {
        if (window.__rovaSyncSound) { try { window.__rovaSyncSound(); } catch (e) {} }
      });
    }
    /* THE LOCK SCREEN IS PART OF THE CHROME (2026-09-03). navigator.mediaSession's title, @handle
       and artwork name an author exactly the way .pfeed-title does, so they belong on the SAME
       schedule as the bar rather than on a schedule of their own -- that is the whole lesson of the
       two wrong-name windows this function's comments record, and a lock screen the reader glances
       at is no more forgiving than the bar. This is a coalesced poke, not a metadata write: the
       governor in the video engine re-reads the audible clip on the next frame and only rebuilds
       MediaMetadata when the POST id has actually changed, so an advance to the same post costs
       nothing and an advance between posts cannot leave author A's artwork over author B's clip. */
    if (window.__rovaWakeSync) { try { window.__rovaWakeSync(); } catch (e) {} }
  }

  // portrait media (taller than wide) fills the screen (cover); landscape stays contain
  // LQIP thumbnail background REMOVED (owner: no photo background behind pfeed photos, plain black is fine).
  // The blurry-thumb fill read as noise; instead the OPEN never shows black because the hero-zoom now HOLDS
  // until the photo is fully decoded (see the fw() never-blank handoff, which waits for im.complete). On a
  // SWIPE the media simply shows its black backdrop (.pfeed .post .media background:#000) until the next photo
  // loads. Kept as a no-op so the existing call sites (fitPfeedMedia, the list observer, pfUnloadImg) stay
  // valid without change. data-thumb attributes are left on the imgs (harmless) in case we ever bring it back.
  function lqipImg(el) { /* no-op: pfeed photos have no thumbnail background, just black */ }
  // Apply LQIP to every data-thumb image in a freshly added subtree (or a bare img node).
  function applyPfLqip(root) {
    if (!root || root.nodeType !== 1) return;
    if (root.tagName === 'IMG') { lqipImg(root); return; }
    if (root.querySelectorAll) { Array.prototype.forEach.call(root.querySelectorAll('img[data-thumb]'), lqipImg); }
  }

  // Full-bleed poster STAND-IN for a pfeed clip that has no decodable frame yet (owner's low-signal
  // report: the native <video> poster painted small, floating in black, with zero feedback while the
  // clip buffered). A real <img> paints reliably everywhere (the grid proves it), so until the video
  // has an actual frame we cover the slide with the poster, sized exactly like the video will be
  // (cover under pf-vfill, contain otherwise -- CSS keys off the same classes, so there's no jump
  // when the video takes over), plus a spinner that only fades in after ~1s so fast loads never see
  // it. Dropped on the first decoded frame. Opaque background so no odd native poster paint shows.
  function pfPosterLayer(v, unit) {
    if (v._pfPl || v.readyState >= 2 || !unit) return;
    var pu = v.getAttribute('poster') || v._posterStash || '';
    if (!pu) return;
    v._pfPl = 1;
    var w = document.createElement('div');
    w.className = 'pf-vposter';
    var im = document.createElement('img');
    im.alt = ''; im.decoding = 'async'; im.className = 'pfv-img'; im.src = pu;
    var sp = document.createElement('span');
    sp.className = 'pfv-spin'; sp.setAttribute('aria-hidden', 'true');
    w.appendChild(im); w.appendChild(sp);
    v.insertAdjacentElement('afterend', w);   // above the video (z 1), below every control (z 4+)
    var gone = false;
    // Judge the CURRENT clip in the slide, not just the captured `v`: the grid->pfeed donor handoff
    // SWAPS the slide's <video> for the tile's already-playing element, so `v`'s events never fire
    // while audio plays behind a stuck stand-in (web #30). The poll below is the safety net for that
    // swap (and any other element churn); the `v` listeners stay for the instant common-case drop.
    // The same mp4's stem from a src / currentSrc / hls manifest URL, for matching a clip across the
    // elements that can carry it (card copy on the mp4, donor on HLS, etc).
    function clipStem(x) {
      var s = (x.currentSrc || x.getAttribute('src') || (x.dataset && x.dataset.hls) || '');
      var sm = s.match(/([A-Za-z0-9]+_w)(?:\.mp4|_hls\/)/);
      return sm ? sm[1] : s;
    }
    function ready() {
      var cur = unit.querySelector('video');
      if (!unit.isConnected || !cur) { return true; }   // slide torn down / video churned away: never strand a stray still
      if (cur.readyState >= 2 || cur.currentTime > 0.01) { return true; }
      // A clip the virtualiser has RECYCLED (_recycled, teardownVideo) or PRUNED (_released,
      // __rovaReleaseVideos) has had its src stripped, so it can NEVER reach readyState 2 while it sits
      // out of view -- the 300ms poll below therefore never dropped this stand-in, and its spinner kept
      // `vc-spin .8s linear infinite` running forever on an off-screen post. Measured on a 10-swipe
      // session: 14 stranded stand-ins, ALL of them off-screen, all still animating, ~1 more per swipe.
      // An infinite animation costs a style recalc every frame (and a compositor layer) whether or not
      // anything can see it -- the same bug as the .pcell-loading shimmer. Drop it here; warmIO re-attaches
      // the src as the clip comes back into range and a fresh stand-in is built then (drop() clears _pfPl).
      if (cur._recycled || cur._released) { return true; }
      // web #30 follow-up (owner: "I can HEAR it playing"): the SAME clip audibly playing on some
      // OTHER element in the viewer (a handoff element that never landed in this unit) means this
      // stand-in is lying on top of a live clip -- kill it rather than trust the unit's copy.
      var stem = clipStem(cur), vs = document.querySelectorAll('video');   // whole page: flight clones + grid tiles live OUTSIDE .pfeed
      for (var i = 0; i < vs.length; i++) {
        var o = vs[i];
        if (o !== cur && !o.paused && o.currentTime > 0.05 && stem && clipStem(o) === stem) { return true; }
      }
      return false;
    }
    /* THE BEAT IS FOR THE FLIGHT, AND ONLY FOR THE FLIGHT (2026-08-30).
       It was written for web #29: an instantly-visible stand-in painted a full-screen still behind the
       rising hero clone on fast lines. That is an OPEN. On a SWIPE there is no clone, nothing is rising,
       and 500ms of "wait and see" is 500ms of the black the stand-in exists to prevent -- the owner's
       "swiping to a video and it flashes to black". Measured on the live site under LTE: a settled video
       slide sat 2.2s with readyState 0 and no stand-in at all.
       So the beat is now conditional on a flight actually being up (html.hz-hold, the class heroExpand
       holds for the length of a flight and heroRelease clears). Open: unchanged, 500ms. Swipe: the next
       frame, which is the earliest moment a picture can replace black. ready() is still consulted first
       in both cases, so a clip that already has a frame never shows a stand-in either way. */
    var beat = 0;
    try { beat = document.documentElement.classList.contains('hz-hold') ? 500 : 0; } catch (e) { beat = 500; }
    setTimeout(function () {
      if (gone) return;
      if (ready()) { drop(); return; }
      // no flight -> appear instantly: the .3s fade-in is 300ms more of the black this layer is for.
      // .snap is scoped to .on in rova.css, so drop()'s fade-OUT keeps its cross-fade.
      if (!beat) { w.classList.add('snap'); }
      w.classList.add('on');
    }, beat);
    var iv = setInterval(function () {
      if (gone || !w.isConnected) { clearInterval(iv); return; }
      if (ready()) { drop(); }
    }, 300);
    function drop() {
      if (gone) return; gone = true;
      clearInterval(iv);
      w.classList.remove('on');
      w.classList.add('off');
      setTimeout(function () { if (w.parentNode) w.parentNode.removeChild(w); }, 400);
      v.removeEventListener('loadeddata', drop);
      v.removeEventListener('playing', drop);
      v.removeEventListener('timeupdate', tick);
      // Release the once-only guard so a clip that comes BACK into range can show a stand-in again.
      // Safe against re-entry: pfPosterLayer needs a poster attribute (a recycled clip's is stashed
      // away) and bails at readyState >= 2, so neither the recycled nor the loaded case can loop.
      try { v._pfPl = 0; } catch (e) {}
    }
    function tick() { if (ready()) drop(); }
    v.addEventListener('loadeddata', drop);
    v.addEventListener('playing', drop);
    v.addEventListener('timeupdate', tick);
  }

  /* ---- ARM THE STAND-IN ON APPROACH, NOT ONCE PER ELEMENT (2026-08-30) --------------------------
     Owner: "swiping to a video on web and it flashes to black."

     A pfeed clip is server-rendered as a live <video> and is never "promoted" from an <img> -- so the
     only thing between the reader and an opaque black rectangle is a picture: the clip's own first
     frame, the native poster bitmap, or this stand-in. Both of the first two can be absent at the
     instant the card paints, and the third was effectively never there:

       pfPosterLayer had exactly ONE call site (fitPfeedMedia), behind `if (el._pfFit) return;` --
       a guard that is set once and cleared NOWHERE in this file. So the stand-in was built at most
       once per element, at FIRST FIT, which happens when the card is appended to the list, several
       posts before the reader reaches it. drop() politely releases its own `_pfPl` guard "so a clip
       that comes BACK into range can show a stand-in again", but nothing ever called it again.

     Measured on the live site (headless iPhone context, LTE throttle, 8 swipes): settled video slides
     with readyState 0 and `standin: false` for 2.2s each. The cover was designed, built, and then not
     wired to the moment it was for.

     armPfPoster is that wiring: idempotent (pfPosterLayer bails on `_pfPl` and on readyState >= 2, and
     returns immediately with no poster to show), cheap, and safe to call from anywhere that knows a
     clip is about to be looked at. Two callers below: the slide-change hook, and -- through the window
     export, since the warm tier lives in another IIFE -- the same neighbour warm that already prefetches
     the poster bytes two posts ahead. Arming there is what gives the stand-in's <img> time to decode,
     so landing on the card shows a picture rather than starting one. */
  function armPfPoster(post) {
    if (!post || !post.querySelectorAll) { return; }
    try {
      Array.prototype.forEach.call(post.querySelectorAll('video'), function (v) {
        var unit = v.closest('.cslide') || v.closest('.media');
        if (unit) { pfPosterLayer(v, unit); }
      });
    } catch (e) {}
  }
  window.__rovaArmPfPoster = armPfPoster;

  /* The caption clamp's inner clip span. The implementation moved out to __rovaClampBody's module
     (search "SHARED LONG-BODY CLAMP") on 2026-08-08, when the post page started clamping through
     the same code; the long WHY-a-span note lives with it now. This stays as the local name the
     rest of this IIFE calls, and falls back to its own copy if that module ever fails to run --
     the clamp is cosmetic and must never be the thing that throws in here. */
  function pfClipText(bd) {
    if (window.__rovaClipText) { return window.__rovaClipText(bd); }
    var ct = bd.querySelector(':scope > .pf-cliptext');
    if (ct) { return ct; }
    ct = document.createElement('span');
    ct.className = 'pf-cliptext';
    while (bd.firstChild) { ct.appendChild(bd.firstChild); }
    bd.appendChild(ct);
    return ct;
  }

  /* THE VIEWER'S OWN BOX, READ ONCE PER RESIZE -- not once per media element (2026-08-12).
     apply() below needs the pfeed viewport to work out its cover scale, and it used to read
     `list.clientWidth` / `scroller.clientHeight` inline. Both are INVARIANT across the loop -- they
     are the overlay's own full-screen box, and nothing apply() does to a single <img> can change
     them -- but apply() also WRITES (classList.toggle('pf-portrait'), style.setProperty('--pf-cover'))
     immediately before reading, so every element in the loop paid a fresh forced synchronous layout
     of the entire pfeed list. MEASURED on a 20-post fling (nojumper grid, 4x CPU, 1.6Mbps): 12
     clientWidth reads, 345ms -- 29ms EACH, the single most expensive main-thread item in the burst.
     The classic write/read/write thrash, and the fix is the classic one: read the invariant once.
     INVALIDATED ONLY BY A REAL RESIZE, and by nothing else on purpose. A scroll cannot change the
     overlay's box (it is position:fixed, full-screen), and neither can appending posts, so a
     scroll-keyed or per-pass cache would just be the same read wearing a hat. visualViewport is
     included because iOS Safari changes the usable height when its toolbars collapse without ever
     firing a window 'resize'. The zero-guard matters: a read taken while the overlay is display:none
     (built but not yet shown) returns 0, and caching THAT would pin every cover scale at the
     window fallback for the rest of the session -- so a zero is never stored. */
  var _pfVpW = 0, _pfVpH = 0, _pfVpBound = 0, _pfVpTask = null;
  function pfViewport() {
    if (!_pfVpBound) {
      _pfVpBound = 1;
      var drop = function () { _pfVpW = 0; _pfVpH = 0; _pfVpTask = null; };
      window.addEventListener('resize', drop, { passive: true });
      try { if (window.visualViewport) { window.visualViewport.addEventListener('resize', drop, { passive: true }); } } catch (e) {}
    }
    if (!_pfVpW || !_pfVpH) {
      /* THE ZERO-GUARD ABOVE IS RIGHT AND IT HAD NO MEMO, so the ONE case it exists for -- the overlay
         built but not yet laid out -- re-read clientWidth AND clientHeight for EVERY media element in
         the fit pass, each one after apply() had just written `pf-portrait` on the unit before it.
         MEASURED on one 4x-CPU open: 15 forced style+layout events attributed to these two lines,
         107ms, the first of them 67ms. The long-lived cache could not help, because the whole point is
         that this answer must NOT be kept.
         SO MEMOISE THE REFUSAL FOR ONE TASK, which is exactly as long as it is provably still true: an
         unmeasurable box cannot become measurable without JS writing and then flushing, and no pass in
         this file does that between two apply() calls. The microtask drain is the boundary -- a real
         one, not a timer -- so the very next task retries from scratch and a viewer that has just been
         laid out is picked up on the following pass exactly as before. */
      if (_pfVpTask) { return _pfVpTask; }
      var w = (list && list.clientWidth) || 0;
      var h = (scroller && scroller.clientHeight) || 0;
      if (w && h) { _pfVpW = w; _pfVpH = h; }                 // never cache a pre-layout zero
      else {
        /* The local is what gets returned, NEVER the field: the drain below can null the field (and the
           catch does so deliberately on an engine with no Promise, degrading to the old read-every-time
           behaviour), and returning the field there would hand the caller a null to dereference. */
        var miss = { w: w, h: h, cached: false };
        _pfVpTask = miss;
        try { Promise.resolve().then(function () { if (_pfVpTask === miss) { _pfVpTask = null; } }); }
        catch (e) { _pfVpTask = null; }
        return miss;
      }
    }
    return { w: _pfVpW, h: _pfVpH, cached: true };
  }

  /* ---- CONTAINMENT: IS THIS CARD BEING SKIPPED RIGHT NOW?  (2026-08-17) ----------------------------
     .pfeed-list .post carries content-visibility:auto (rova.css), so an off-screen card's subtree is
     SKIPPED: no style recalc, no layout, no shaping, no paint. That is the point -- it is what took the
     ~150ms-per-card floor off the parked remainder of the first page. The bill it comes with is that
     EVERY LAYOUT READ INSIDE A SKIPPED CARD RETURNS 0, and a zero read is not "small", it is "unknown".

     Two consumers had to learn the difference: __rovaPhotoPan / __rovaVpan (fixed at their own sites --
     they used to strip the pan classes on an unreadable box) and the caption clamp below, which is worse
     because it LATCHES. clampBody sets bd._pfClamp = 1 before it measures and nothing ever resets it, so
     one measurement taken while the card was skipped removes .pf-clamp and the "more" pill permanently
     for the session. That is character-for-character the failure the .pf-lite guard beneath this was
     written for (a display:none caption also measures zero) -- same trap, second door.

     WHY A DIRECT CHECK AND NOT AN OBSERVER. checkVisibility() answers about THIS FRAME, which is exactly
     the question, and it needs no root, no rootMargin and no unobserve in the two teardown paths
     (clearPfeedList / pruneFarPosts) that every other observer on this surface has to be wired into.
     The two-call form is deliberate: checkVisibility() alone is false for a card in a viewer that is
     built but not yet shown, and treating THAT as "skipped" would defer a clamp that no
     contentvisibilityautostatechange is ever going to come back for. Skipped means "would be visible,
     except that containment is holding it" -- visible without the flag, not visible with it.
     Engines with no content-visibility support (and no checkVisibility) answer false and behave exactly
     as they did before this round.

     ASK A DESCENDANT, NOT THE CARD  (2026-08-17, caught by tools\pfeed-contain-check.js reporting 0/5
     skipped on a list that was visibly saving the work). content-visibility:auto skips an element's
     CONTENTS; the element itself is still rendered and still has its box -- that is the entire reason the
     scroll position holds. So checkVisibility({contentVisibilityAuto:true}) on the card answers TRUE even
     while everything inside it is skipped, and the guard silently never fired. .post-row is the card's
     one structural child (position:absolute;inset:0), so it is inside the skipped subtree and answers the
     question that was actually being asked. */
  function pfCvSkipped(p) {
    if (!p) return false;
    var inner = p.querySelector('.post-row') || p.firstElementChild;
    if (!inner) return false;
    if (typeof inner.checkVisibility === 'function') {
      try { return inner.checkVisibility() && !inner.checkVisibility({ contentVisibilityAuto: true }); }
      catch (e) {}
    }
    /* No checkVisibility: ask the BOX instead. The card's own height is explicit (100dvh) so it is
       non-zero either way, while .post-row has no layout box at all inside a skipped subtree -- one
       forced read, and only on engines old enough to need it. */
    return !!p.clientHeight && !inner.clientHeight;
  }
  /* Re-ask when the browser un-skips the card. The event is the precise signal, but it is Chromium-only,
     so it is a fast path and never the guarantee: _pfCvPend is the flag recyclePfeedMedia sweeps on every
     scroll pass, which is what makes this correct in an engine that has content-visibility and not the
     event. Both routes converge on the same idempotent fitPfeedMedia(). */
  function pfCvRearm(p) {
    p._pfCvPend = 1;
    if (p._pfCvArmed) return;
    p._pfCvArmed = 1;
    var h = function (e) {
      if (e && e.skipped) return;                 // it went the other way; stay armed
      p.removeEventListener('contentvisibilityautostatechange', h);
      p._pfCvArmed = 0; p._pfCvPend = 0;
      fitPfeedMedia();
    };
    try { p.addEventListener('contentvisibilityautostatechange', h); } catch (e) { p._pfCvArmed = 0; }
  }
  /* .pf-cvon -- THE ONE CARD CONTAINMENT MAY NOT TOUCH (rova.css).
     Two reasons, and the second is the load-bearing one:
       PERF/CORRECTNESS OF THE FLIGHT. content-visibility relevance is resolved during the rendering
       update, so a card inserted ON SCREEN can be skipped for its first frame -- and that first frame is
       exactly when pfCenteredMedia gates the hero pump and centeredSlideOf picks the slide to measure.
       Both of those recover by retrying, but "the open costs an extra poll cycle" is not a trade worth
       making for a card we already know is the one the reader is looking at.
       THE ⋯ MENU. Containment makes the card a stacking context, which caps .post-head (z 40) and its
       ⋯ panel (z 50) BELOW .pfeed-bar (z 12) -- the exact bug the `backdrop-filter:none` override at
       rova.css:2040 exists to prevent, arriving through a different property. Menus and comment sheets
       only ever open on the CURRENT card, so exempting it is what keeps that fixed; the CSS also exempts
       .menu-open and any card holding a panel, so the invariant is stated twice rather than assumed.
     CURRENT CARD ONLY, not current +/-1: a neighbour that is exempt is a neighbour laid out in full, and
     six cards each costing ~150ms is the bill this round exists to stop paying. The neighbours come in
     on the browser's own relevance margin as they scroll toward the viewport, which is the mechanism
     content-visibility:auto was designed around. */
  /* RETINA UPGRADE FOR THE PHOTO ON SCREEN (2026-10-03, Rob on /p/56164: "This uploaded photo should be
     WAY higher quality"). Every surface paints the 1440px _disp, which is right for a feed card and wrong
     full screen: a 3x phone cover-fills a 3:4 photo at ~1900x2530 device px, so the _disp was upscaled
     1.76x (1.25x on a 2x Mac). views/_post.php now stamps data-hi = the master (<= 2560, q90 since today)
     on every photo that has a _disp, and THIS swaps it in for the photo the reader has SETTLED on:
       - only when the screen paints it at >= 1.15x the _disp's own pixels (rect already carries
         --pf-cover and the drift scale), so a 1x desktop never pays for it;
       - never on Save-Data / 2G / 3G, never under an NSFW veil, never while a hero is in the air;
       - after a dwell (PF_HI_DWELL), so a fling through the viewer fetches nothing extra;
       - decoded OFF-DOM first and swapped in one step, so there is no blank frame and no re-fit (same
         aspect -- fitPfeedMedia only ever reads the ratio);
       - and DROPPED back to the _disp when the reader leaves the card, so at most one card's masters are
         ever decoded (pfUnloadImg's stash is repointed too). Same URL as the R2 master: immutable, cached. */
  var PF_HI_DWELL = 450, PF_HI_MIN = 1.15;
  var pfHi = { t: 0, on: [] };
  function pfHiSlow() {
    try {
      var c = navigator.connection;
      if (c && (c.saveData || /(^|-)2g$|^3g$/.test(String(c.effectiveType || '')))) { return true; }
    } catch (e) {}
    return false;
  }
  function pfHiDrop(keep) {
    pfHi.on = pfHi.on.filter(function (im) {
      if (keep && im.isConnected && keep.contains(im)) { return true; }
      var lo = im.getAttribute('data-lo'), hi = im.getAttribute('data-hi'), hm = im.getAttribute('data-hi-max');
      if (lo) {
        if (im.dataset && im.dataset.pfSrc) { if (im.dataset.pfSrc === hi || (hm && im.dataset.pfSrc === hm)) { im.dataset.pfSrc = lo; } }
        else if (im.getAttribute('src') === hi || (hm && im.getAttribute('src') === hm)) { im.setAttribute('src', lo); }
      }
      im._pfHi = 0;
      return false;
    });
  }
  function pfHiArm(cp, ms) {
    clearTimeout(pfHi.t);
    pfHi.t = setTimeout(function () { pfHiTry(cp); }, ms);
  }
  function pfHiTry(cp) {
    if (!cp || !cp.isConnected || !box || !box.classList.contains('show') || pfPhase === 'closing') { return; }
    if (!cp.classList.contains('pf-cvon')) { return; }
    if (document.documentElement.classList.contains('hz-hold')) { pfHiArm(cp, 300); return; }   // flight still landing
    if (document.hidden || pfHiSlow()) { return; }
    var dpr = Math.min(window.devicePixelRatio || 1, 3), vw = window.innerWidth, vh = window.innerHeight;
    Array.prototype.forEach.call(cp.querySelectorAll('.media img[data-hi]'), function (im) {
      if (im._pfHi || im._pfUnloaded || (im.closest && im.closest('.nsfw-gate, .nsfw-locked'))) { return; }
      var lo = im.getAttribute('src'), hi = im.getAttribute('data-hi');
      if (!lo || !hi || lo === hi) { return; }
      if (!im.complete || !(im.naturalWidth > 0)) {   // the _disp itself is not in yet: ask again when it is
        if (!im._pfHiW) { im._pfHiW = 1; im.addEventListener('load', function () { im._pfHiW = 0; pfHiArm(cp, 120); }, { once: true }); }
        return;
      }
      var r = im.getBoundingClientRect();
      if (r.width < 2 || r.right <= 0 || r.left >= vw || r.bottom <= 0 || r.top >= vh) { return; }   // a slide parked to the side
      /* The rect is the ELEMENT box (already scaled by --pf-cover / the drift); the picture inside it is
         object-fit'ed, so the painted scale is the contain fit (min) unless the box crops (cover: max). */
      var ofc = ''; try { ofc = getComputedStyle(im).objectFit; } catch (e) {}
      var sx = r.width * dpr / im.naturalWidth, sy = r.height * dpr / im.naturalHeight;
      var need = ofc === 'cover' ? Math.max(sx, sy) : Math.min(sx, sy);
      if (need < PF_HI_MIN) { return; }
      /* ITEM 50 (2026-10-22): data-hi is the <= 2048 VIEW RUNG when the server built one (data-hi-max = the master beside
         it). The rung carries ~2048/1440 of the _disp's pixels, so climb to the master only when even the rung would be
         upscaled past PF_HI_MIN (a 3x phone cover-filling a portrait); a 2x desktop settles on the far lighter rung. */
      var hm = im.getAttribute('data-hi-max');
      if (hm && need >= PF_HI_MIN * (2048 / 1440)) { hi = hm; }
      im._pfHi = 1;
      var pre = new Image();
      pre.decoding = 'async';
      pre.onload = function () {
        var go = function () {
          // still the card, still the _disp, still on the page: otherwise leave it exactly as it is
          if (!im.isConnected || im._pfUnloaded || im.getAttribute('src') !== lo || !cp.classList.contains('pf-cvon')) { im._pfHi = 0; return; }
          im.setAttribute('data-lo', lo);
          im.setAttribute('src', hi);
          pfHi.on.push(im);
        };
        if (pre.decode) { pre.decode().then(go, go); } else { go(); }
      };
      pre.onerror = function () {};   // keep _pfHi set: never retry a URL that just failed
      pre.src = hi;
    });
  }
  // a carousel slide change inside the current card (the track moves by transform, so no scroll event)
  document.addEventListener('transitionend', function (e) {
    var t = e.target;
    if (!t || !t.classList || !t.classList.contains('carousel-track') || !list || !list.contains(t)) { return; }
    var cp = t.closest('.post');
    if (cp && cp.classList.contains('pf-cvon')) { pfHiArm(cp, 150); }
  }, true);

  function pfCvOn(cp) {
    if (!list) return;
    Array.prototype.forEach.call(list.querySelectorAll('.post'), function (p) {
      p.classList.toggle('pf-cvon', p === cp);
    });
    pfHiDrop(cp);                         // masters off every card the reader left
    if (cp) { pfHiArm(cp, PF_HI_DWELL); }  // ...and onto this one once they settle on it
    kbSync();   // the active page changed (or was re-affirmed): the photo drift follows it
    /* THE LAST-RESORT ARM (2026-08-30). This runs on every slide change, so it catches the clip the
       neighbour warm never reached: a card appended just in time by loadMore, or one the reader
       outran by swiping faster than the warm tier's calm-defer. Its NEIGHBOURS too -- arming the card
       you are about to land on is the only arm that can be early enough to be free, and this is the
       one place that knows which card that is. See armPfPoster for why the stand-in was missing. */
    if (cp) {
      armPfPoster(cp);
      armPfPoster(cp.previousElementSibling);
      armPfPoster(cp.nextElementSibling);
    }
  }

  /* `only` (2026-09-06, scroll-smooth audit): an optional array of cards to confine the CARD loop to.
     recyclePfeedMedia's 250ms re-arm pass hands in the pending cards around the current post so the
     pass no longer re-queries (and so un-skips) every parked card on the list -- see the note there.
     Every other caller passes nothing and gets the full pass exactly as before. The MEDIA loop below
     is untouched: it is guarded per element (_pfFit) and does no per-card visibility query. */
  /* THE POST EDITOR'S DOOR INTO THE VIEWER (2026-09-30, Rob: after Save the viewer's card came back as a
     plain card -- no zoom button, a different chrome). The editor re-renders a post from the server after a
     media / fit / extras change, and a viewer card is not just markup: everything the viewer adds on insert
     (pfNoPip, hydrate -> the carousel + the photo/video bars with the zoom/fit control, the fit + caption
     clamp, the folded action row, containment + the drift) has to run on the fresh node exactly as it does
     when loadMore appends a page. This is that sequence, for ONE card, in the same order. Returns the node,
     or null when `old` is not a viewer card (the caller then does the plain feed-card swap). */
  window.__rovaPfeedReplace = function (old, fresh) {
    if (!old || !fresh || !list || !list.contains(old)) return null;
    var wasCur = old.classList.contains('pf-cvon');
    try { pfNoPip(fresh); } catch (e) {}          // BEFORE the clips are bound into the document
    old.parentNode.replaceChild(fresh, old);
    if (wasCur) { fresh.classList.add('pf-cvon'); }
    if (window.__rovaHydrate) { try { window.__rovaHydrate(fresh); } catch (e) {} }
    fitPfeedMedia([fresh]);
    try { recyclePfeedMedia(true); } catch (e) {}
    try { kbSync(); } catch (e) {}
    return fresh;
  };
  function fitPfeedMedia(only) {
    if (!list) return;
    /* READ FIRST, WRITE AFTER -- for the whole pass, not per element (2026-08-17). Everything below
       writes: `kb-odd`, clampBody's `pf-clamp`, then apply()'s `pf-portrait` / `--pf-cover` on every
       unit. apply() is also the only consumer of pfViewport, so the pass used to take its first
       viewport measurement AFTER the clamp loop had already dirtied style -- i.e. it paid a forced
       flush for its own earlier writes. One call here takes that measurement while the tree is as the
       last rendering update left it, and every apply() below is then a cache hit.
       Deliberately ignoring the return value: this primes, it does not decide. */
    pfViewport();
    // Ken Burns variant by POST ID parity (stable), not :nth-child (shifts when loadBefore prepends
    // or pruneFarPosts removes nodes above; a parity flip renamed the running animation, restarting
    // the pan mid-drift in the opposite direction right after the hero handoff). See rova.css kb-odd.
    Array.prototype.forEach.call(only || list.querySelectorAll('.post[data-view]'), function (p) {
      if (!p._kbPar) {
        p._kbPar = 1;
        if ((parseInt(p.getAttribute('data-view'), 10) || 0) % 2) { p.classList.add('kb-odd'); }
      }
      /* .pf-lite = the target card mid-flight, with its caption display:none (see the append in
         loadMore). The clamp below MEASURES the caption, and a display:none caption is zero lines
         high, so running it here would latch "no clamp needed" on a caption that needs one. The
         parity class above is unaffected by visibility and stays one-shot; the clamp is retried when
         pfFlushPark removes .pf-lite and calls this again. */
      if (p.classList.contains('pf-lite')) { return; }
      /* ...AND THE SAME TRAP THROUGH THE OTHER DOOR: a card whose subtree content-visibility is
         SKIPPING measures zero exactly like a display:none one, and clampBody latches on its first
         measurement (see pfCvSkipped above for the whole argument). Defer the card entirely -- the
         media fit is idempotent and cheap to repeat, and skipping it here is a saving rather than a
         cost, since a card the browser is not laying out has nothing to fit yet either. */
      if (pfCvSkipped(p)) { pfCvRearm(p); return; }
      p._pfCvPend = 0;
      // LONG-CAPTION CLAMP (owner: a caption + hashtag wall buried the media): clamp to 4 lines with a
      // more/less pill. The clamp, the clip span, the pill and the toggle are SHARED with the post page
      // as of 2026-08-08 -- they are this block's own former contents, lifted out to
      // window.__rovaClampBody (search "SHARED LONG-BODY CLAMP") so the two surfaces cannot drift.
      // Still measured in a rAF (needs layout); a short caption still drops the clamp with no pill.
      // No `cls` and no `anchor` on purpose: the viewer keeps the overlay pill skin
      // (.pfeed .post .pf-more), and an expanded caption here scrolls INSIDE itself (.pf-open =
      // max-height + overscroll contained, see rova.css) rather than growing the page, so there is no
      // reflow and no scroll position to hand back.
      // What is left in this block is the only part that was ever genuinely the viewer's: an expanded
      // caption has to win its vertical gestures back from the pager.
      var bd = p.querySelector('.post-main > .body');
      if (bd && !bd._pfClamp && window.__rovaClampBody) {
        window.__rovaClampBody(bd, { after: function (bd) {
          // The EXPANDED caption owns its vertical gestures (owner: "I'm trying to read the caption, not
          // swipe to the next image").
          // #46: the old guard swallowed touchstart + touchmove but NOT touchend -- and the pfeed's pager
          // decides on touchEND (scroller.touchend -> settleTo). With its touchstart swallowed the pager
          // kept the coordinates of the PREVIOUS gesture, so lifting a finger after scrolling the caption
          // measured a phantom several-hundred-px swipe and jumped to the next slide. Now: decide ONCE per
          // gesture on the first real move. If the caption can consume it (scrollable, and not already at
          // that end) the caption claims the whole gesture, touchend included, and the pfeed never sees it.
          // If it can't -- nothing to scroll, or the finger is pushing past an end -- the gesture is handed
          // to the pfeed untouched, which is the only way it should ever advance a slide from in here.
          var cy0 = 0, cOwn = 0;                    // 0 undecided, 1 = caption's gesture, -1 = the pfeed's
          var capCan = function (dy) {
            if (bd.scrollHeight <= bd.clientHeight + 1) { return false; }              // nothing to scroll
            if (dy > 0) { return bd.scrollTop > 0; }                                   // dragging back up
            return bd.scrollTop + bd.clientHeight < bd.scrollHeight - 1;               // reading downward
          };
          bd.addEventListener('touchstart', function (e) {
            cOwn = 0;
            if (!bd.classList.contains('pf-open')) { return; }
            cy0 = e.touches[0].clientY;
          }, { passive: true });
          bd.addEventListener('touchmove', function (e) {
            if (!bd.classList.contains('pf-open')) { return; }
            var dy = e.touches[0].clientY - cy0;
            if (!cOwn && Math.abs(dy) > 2) { cOwn = capCan(dy) ? 1 : -1; }             // decide once
            if (cOwn !== 1) { return; }                                                // at an end: the pfeed's
            e.stopPropagation();            // ours: no pager, no pull-to-dismiss, no edge trap
            // ran out of caption mid-drag: eat the rest so it can't chain out of the panel
            if (e.cancelable
                && ((dy > 0 && bd.scrollTop <= 0)
                    || (dy < 0 && bd.scrollTop + bd.clientHeight >= bd.scrollHeight - 1))) { e.preventDefault(); }
          }, { passive: false });
          bd.addEventListener('touchend', function (e) {
            if (cOwn === 1) { e.stopPropagation(); }   // the pager must not settle on a gesture we consumed
            cOwn = 0;
          }, { passive: true });
          bd.addEventListener('wheel', function (e) {
            if (!bd.classList.contains('pf-open')) { return; }
            e.stopPropagation();
            var can = bd.scrollHeight > bd.clientHeight + 1;
            if (!can
                || (e.deltaY < 0 && bd.scrollTop <= 0)
                || (e.deltaY > 0 && bd.scrollTop + bd.clientHeight >= bd.scrollHeight - 1)) { e.preventDefault(); }
          }, { passive: false });
        } });
      }
    });
    // Size single media (.media:not(.carousel)) AND each carousel SLIDE (.cslide) from its own aspect,
    // so multi-media posts fill the pfeed like single ones instead of letterboxing. The unit that gets
    // pf-portrait / pf-zoomable is the slide inside a carousel, else the whole .media.
    // :not(.pfv-img): the poster stand-in's own <img> (pfPosterLayer) must NEVER join this fit loop --
    // treating it as a photo slide stamped pf-zoomable onto VIDEO slides and re-fit the overlay itself.
    Array.prototype.forEach.call(list.querySelectorAll('.media:not(.carousel) img:not(.pfv-img), .media:not(.carousel) video, .cslide img:not(.pfv-img), .cslide video'), function (el) {
      // warm upcoming photos ahead of the swipe (see pfImgWarmIO) -- do this BEFORE the _pfFit guard so
      // it runs for every image, independent of the one-time fit sizing below
      if (el.tagName === 'IMG' && pfImgWarmIO && !el._pfWarm) { el._pfWarm = 1; pfImgWarmIO.observe(el); }
      if (el.tagName === 'IMG' && pfBytesIO && !el._pfBytes) { el._pfBytes = 1; pfBytesIO.observe(el); }   // cache bytes ~4 posts ahead
      // ease the Ken Burns in from rest when this single photo enters view (see kbIO) -- kills the rapid mid-cycle pan
      if (el.tagName === 'IMG' && kbIO && !el._kbObs && !el.closest('.carousel')) { el._kbObs = 1; kbIO.observe(el); }

      lqipImg(el);   // paint the thumb placeholder behind this media (see lqipImg / the pfeed-list observer)
      if (el._pfFit) { return; } el._pfFit = 1;
      var apply = function () {
        // Prefer the real decoded size, but fall back to the width/height ATTRIBUTES the server stamps on
        // a <video> (from its poster dimensions). That lets us cover-fill (--pf-cover) on the FIRST paint
        // instead of waiting for the clip's metadata to load -- which is what made a portrait video open
        // small (letterboxed) and then visibly ZOOM to full once metadata arrived.
        /* A CLIP IS FITTED FROM ITS DECLARED SIZE FIRST (2026-09-29, /p/54662 -- a 1280x720 clip the
           iOS viewer opened portrait-filled and then snapped to landscape when its metadata arrived).
           The server's width/height are now the CLIP's own size (lib/view.php video_dims: the ffprobe
           `.dims` sidecar, else the auto poster frame -- the same numbers the API's w/h carry), so the
           verdict is decided at t=0 and can never flip on `loadedmetadata`. videoWidth only speaks for
           an element with no declaration (a grid donor tile, a legacy clip); a declaration the decoded
           clip DISAGREES with is corrected once, below, and logged -- never silently trusted. */
        /* A PHOTO IS FITTED FROM ITS DECLARED SIZE AT t=0 TOO (2026-09-29). views/_post.php stamps the
           <img>'s width/height from the SAME file the src serves (Upload::orientedSize: EXIF orientation
           applied -- the very numbers the API now sends the app as the image item's w/h/ar), so an
           undecoded photo gets its cover/contain verdict and --pf-cover on the first paint instead of
           waiting for the bytes. (The line above this used to read naturalWidth || videoWidth ||
           width-attribute for both tags; the clip change earlier today made the attribute VIDEO-only,
           which silently dropped the photo's t=0 fallback -- restored here.) Once decoded, the
           natural size speaks (it is the same file, so it agrees); a declaration it does NOT agree
           with is corrected once, on load, below -- the photo twin of vetDecl. */
        var dW = parseInt(el.getAttribute('width'), 10) || 0;
        var dH = parseInt(el.getAttribute('height'), 10) || 0;
        var w, h;
        if (el.tagName === 'VIDEO') {
          w = (dW && dH) ? dW : (el.videoWidth || 0);
          h = (dW && dH) ? dH : (el.videoHeight || 0);
        } else {
          w = (el.naturalWidth && el.naturalHeight) ? el.naturalWidth : dW;
          h = (el.naturalWidth && el.naturalHeight) ? el.naturalHeight : dH;
        }
        if (!w || !h) { return false; }
        var m = el.closest('.cslide') || el.closest('.media'); if (!m) { return false; }
        var portrait = h >= w;
        m.classList.toggle('pf-portrait', portrait);
        // Fill the screen by rendering the media CONTAINED then scaling it up to cover (--pf-cover).
        // Photos and videos both use this. It matters MOST for video: iOS Safari ignores
        // object-fit:cover on a <video>, so a portrait clip letterboxed on the phone (it worked on
        // desktop, which honors object-fit) -- doing cover as contain + transform:scale fixes mobile.
        // Measure against the STABLE pfeed viewport (scroll area / list), NOT the element's own box: a
        // just-tapped item is cached, so apply() can run before the post gets its full-screen layout.
        var _vp = pfViewport();                              // cached; see pfViewport for why this is not a per-element read
        var cw = _vp.w || m.clientWidth || window.innerWidth;
        var ch = _vp.h || m.clientHeight || window.innerHeight;
        if (cw && ch) {
          var s = Math.max(cw / w, ch / h) / Math.min(cw / w, ch / h);   // cover-scale over contain-scale
          // FIRST fit SNAPS to the cover scale (no transition): the CSS animates transform .4s for the tap
          // -> uncrop toggle, but on OPEN that same transition played as a visible zoom-up UNDER the hero
          // (part of the "cascading" open). Suppress it for the initial application only.
          if (!el._pfCoverSet) {
            el._pfCoverSet = 1;
            el.style.transition = 'none';
            el.style.setProperty('--pf-cover', s.toFixed(4));
            requestAnimationFrame(function () { requestAnimationFrame(function () { el.style.transition = ''; }); });
          } else {
            el.style.setProperty('--pf-cover', s.toFixed(4));
          }
          var wideView = cw > ch;   // landscape / desktop viewport
          if (el.tagName === 'IMG') {
            m.classList.add('pf-zoomable');
            // A PORTRAIT photo NEVER becomes a pan-scroller here. It already fills the phone screen, and
            // letting it pan (a) felt wrong and (b) slid the caption + comment roller UP under the toolbar
            // (the overlap in the screenshots). To see a cover-cropped portrait whole, TAP -> pf-uncrop.
            // Only a LANDSCAPE photo zoomed PAST the screen height should pan up/down on a portrait phone,
            // and that needs the pinch-zoom viewer (separate feature) -- this fit-width scroller can't make
            // a landscape overflow vertically anyway -- so keep pf-vscroll OFF for now.
            m.classList.remove('pf-vscroll');
            // A PORTRAIT photo on a LANDSCAPE / desktop viewport opens WHOLE (contain, big & centered,
            // dimmed sides); a tap zooms IN to cover. A portrait phone opens covered (fills the screen).
            //
            // A LANDSCAPE photo now opens WHOLE too whenever its shape is FAR from the screen's, by the
            // native app's ASPECT-DISTANCE rule (ratio = the aspects' ratio, >= 1; > 1.3 => contain).
            // WHY: the cover fill above is `contain, then scale up by --pf-cover`, and for a wide photo on
            // a tall phone that scale is enormous -- a 2036x772 shot on a 420x912 screen is scaled 5.7x, so
            // it opened as a ~17%-wide crop of itself. That is the owner's "when I click it here it loads
            // zoomed in so I can't really see it". Contained, the whole frame shows with bars top & bottom,
            // and a TAP still zooms it in to fill (pf-uncrop is a toggle, same contract as portrait-on-
            // desktop and as the .vc-fit button's isFilling()).
            // THE VERDICT NO LONGER LIVES HERE. It is __rovaPhotoCovers (search "THE ONE PHOTO FIT
            // VERDICT"), shared with heroZoom's fit prediction and pfeedLandRect so the flight can no
            // longer land on a box this then repaints differently. The long why -- including why it
            // takes TWO aspect distances rather than one box-relative split, and which single owner
            // report it knowingly contradicts -- is all in that header.
            // OWNER 2026-08-13, seven links: squares and near-square screenshots must open WHOLE on a
            // phone. Before this they showed 44.2% (square) / 53.6% (0.826) of their width.
            // PROFILE PHOTOS STILL GET NO SPECIAL CASE (owner 2026-08-12, /p/41968): the 2026-08-07 rule
            // that forced EVERY avatar post uncropped unconditionally is gone for good, and avatar posts
            // go through the same shape rule as every other photo -- five of the seven links above ARE
            // avatar posts, and they land whole because of their SHAPE, not because of their kind.
            // pf-uncrop stays a TOGGLE, so a tap still zooms in either way.
            // OWNER 2026-08-14, the ESSENCE article screenshot: `data-fit` on this very <img> is
            // the per-media FIT HINT (migration 0144) and it OUTRANKS the shape rule, because a
            // screenshot and a portrait photograph of the same aspect are the same shape and no
            // threshold can tell them apart. lib/textimage.php decides it once, at write time.
            var covers = window.__rovaPhotoCovers
              ? window.__rovaPhotoCovers(w, h, cw, ch, window.__rovaFitHint(el)) : true;
            m.classList.toggle('pf-uncrop', !covers);
            /* PF_PANY_BIAS: top-biased crop start, not centred (owner, 2026-08-23, "cutting off peoples
               heads" -- the report that got PostCard.js fixed on the app the same night). This unit is
               CONTAIN + transform:scale(--pf-cover), not object-fit:cover, so object-position (what the
               .pcell / .post .media rules use) has no grip on it at all -- see rova.css's note
               at the .pf-portrait rule (~:2170) for why. The crop window here is the --pf-pany TRANSLATE
               __rovaPhotoPan reads below, so the fix seeds THAT before it runs.
               Only when actually covering (pf-uncrop photos are whole -- nothing to bias) and only with
               real vertical overflow (mediaAr < boxAr; a wider-than-box shot crops sideways, untouched)
               past the SAME BIAS_DIST=1.23 the native app uses (PostCard.js coverBiasY / PostScreen.js
               PHOTO_SQUARISH) -- copied, not re-derived, so the surfaces that are still biased agree on
               where bias kicks in. (The web feed card used to share it too; centred 2026-09-01.) __rovaPhotoCovers's own shape rule already keeps this bounded: covers
               only fires when the photo and the screen are off-square the SAME way and within
               PF_SPLIT_TALL=1.95 of each other, so aspectDist here never exceeds that.
               THE MATH: at rest (translate 0,0, the state right now) the scale-up is centred, so the
               hidden strip splits evenly, top gap == bottom gap == O/2 where O is the total vertical
               overflow in real px. For THIS branch (mediaAr<boxAr, i.e. the width-matching scale is the
               larger of the two candidates) O reduces to ch*(s-1) -- s is the cover/contain ratio just
               computed above, so no extra trig, just algebra: s = (cw/w)/(ch/h) here, and ch*(s-1) =
               h*cw/w - ch = O. Shifting the picture DOWN by 0.35*O (panBy's `d`, "reveal more of the top"
               direction -- see __rovaPhotoPan's sign convention) leaves exactly 0.15*O hidden above and
               0.85*O below: the 15/85 split .pcell USED to get from object-position:50% 15%, just reached
               by a translate instead of a crop-window move. NOTE (2026-09-01): BOTH web crop surfaces that
               used to share that split are now CENTRED -- the grid tile first, then the feed card, whose
               gate was deleted outright -- so neither is a living reference for this constant any more.
               THIS SEED AND assets/invite.js's cropOffset() ARE THE LAST TWO WEB SITES STILL BIASED; both
               were left alone deliberately, because the owner asked for the timeline only. If he ever asks
               for the viewer too, the 0.35 in panBy below is the number to move, not a CSS value.
               WHY THIS SURVIVES __rovaPhotoPan RIGHT BELOW rather than getting stomped: for a genuinely
               vertical-cropping unit (vy true) it calls panBy(u,1,0) -- a ZERO-delta move, which clampD
               clamps against the box this seed already shifted, finds 0 still in range, and short-
               circuits (`if (!d) return 0`) without touching the property. For anything it decides is
               NOT pannable on this axis (uncropped, near-matched, SLACK<=6px) it explicitly
               removeProperty()s instead -- which is exactly the "don't bother" case BIAS_DIST already
               gated out above, so the two guards agree rather than fight. Never fires for video: the
               `else` branch below (video) has its own mechanism (--pf-vpos, default 50%, user-pannable)
               that this does not touch -- see the rova.css note; changing that default risks the
               pull-to-dismiss "parked at top" detection it feeds (app.js ~line 37903) and is out of
               scope here. */
            /* THE ARITHMETIC MOVED OUT (2026-09-14), unchanged to the character -- same inputs,
               same expression, same toFixed(1). It is now __rovaPfPanyBias so the FLIGHT can land
               on the same crop this paints: heroExpand's clone used to arrive centred and the
               hand-off snapped the picture by exactly this many px in one frame (owner's 09-14
               recording; the bias for that photo is 100.3px and he measured 102). See the body's
               header for the measurement. Missing helper (impossible in one bundle) -> no bias,
               which is the pre-2026-08-23 behaviour, not a crash. */
            var _pb = window.__rovaPfPanyBias ? window.__rovaPfPanyBias(w, h, cw, ch, covers) : 0;
            if (_pb) { m.style.setProperty('--pf-pany', _pb.toFixed(1) + 'px'); }
            // #25 + #50: a cover zoom always crops ONE axis -- left/right when the photo is wider-relative
            // than the screen, otherwise top/bottom. Mark whichever it actually is (pf-hpan / pf-ypan) so
            // the hidden strip is reachable by dragging, exactly like the video twin above. The helper
            // decides from the LIVE box, so it is a no-op for a contained (pf-uncrop) or exactly-fitting
            // photo; it must run AFTER the pf-uncrop toggle, and re-runs on every fit and every gesture.
            if (window.__rovaPhotoPan) { window.__rovaPhotoPan(m); }
            // give the photo the same glassy control bar as a video (fullscreen / fit / slideshow-play)
            if (window.__rovaPhotoBar) { window.__rovaPhotoBar(m); }
          } else {
            // VIDEO: FILL when the clip and the screen share orientation -- a portrait clip on a portrait
            // phone, OR a landscape clip on a landscape / desktop viewport (owner: a landscape video opened on
            // a laptop should zoom to FILL, not sit letterboxed). Both fill via contain + scale-to-cover
            // (iOS-safe; Chrome honors object-fit:cover on <video>, Safari ignores it, so we use the transform
            // path). CROSS-orientation stays safe: a PORTRAIT clip on a WIDE viewport letterboxes (cover would
            // crop it to a thin band), and a LANDSCAPE clip on a PORTRAIT phone stays contained (neither
            // class) rather than cropping away most of the frame. The vc-fit button still toggles fill<->box.
            // THE VERDICT NO LONGER LIVES HERE EITHER (2026-08-14). It is __rovaVideoCovers, the
            // clip twin of __rovaPhotoCovers above, shared with heroZoom's prediction and
            // pfeedLandRect for the same reason: three copies of `portrait === !wideView` is three
            // chances for a flight to land on a box this then repaints differently. The shape rule
            // inside it is character-for-character the one that was here; what it adds is that
            // `data-fit` on this <video> (the per-media FIT HINT, migration 0144) now outranks it.
            // OWNER 2026-08-14, /p/43060: a 4:5 clip with a burnt-in headline bar was cover-filled
            // and the headline sliced off, while a 4:5 concert clip of the same shape must still
            // fill -- same shape, different content, so only a content input can separate them.
            var vcovers = window.__rovaVideoCovers
              ? window.__rovaVideoCovers(w, h, cw, ch, window.__rovaFitHint(el)) : (portrait === !wideView);
            m.classList.toggle('pf-vfill', vcovers);
            // pf-letterbox IS "contained, and portrait" -- it was written as `portrait && wideView`
            // because those were the same set while the verdict was pure orientation. They are NOT
            // the same set once a hint can force a portrait clip on a portrait PHONE to contain,
            // and the difference is not cosmetic: .vc-fit's isFilling() falls back to
            // `classList.contains('pf-portrait')` when neither class is present, so a hinted clip
            // would have reported itself as FILLING while painting contained -- the ⤢ button's
            // first tap would then have added pf-letterbox and done visibly nothing. Derived from
            // the verdict instead, this is provably the same set whenever the hint is absent:
            // portrait -> !(true === !wide) = wide (the old term); landscape -> false either way.
            m.classList.toggle('pf-letterbox', !vcovers && portrait);
            // #44: a cover fill always crops ONE axis -- top/bottom when the clip is taller-relative than
            // the screen, otherwise left/right. Mark whichever it is (pf-vpan / pf-hvpan) so the hidden
            // strip is reachable by dragging, the video twin of the photo's pf-hpan. The helper decides
            // from the live box, so it is a no-op for a letterboxed or exactly-fitting clip; re-runs here
            // on every fit (metadata arriving, a rotation).
            if (window.__rovaVpan) { window.__rovaVpan(m); }
            pfPosterLayer(el, m);   // full-bleed poster + late spinner until the clip has a real frame
          }
          // fit committed: heroZoom's landing loop refuses to measure a photo before this stamp,
          // so it can never glide onto the pre-fit contained layout (which then snapped to the
          // cover-zoomed opening state under the cross-fade).
          el._pfFitDone = 1;
          /* TELL THE HERO PUMP, don't make it poll (2026-08-05). heroExpand's pump gates the photo
             flight on exactly this stamp and used to re-read it on a 50ms timer, so the flight sat
             idle for up to a tick after the thing it was waiting for had already happened. This is
             a notification only: it grants nothing and skips nothing, and a pump that is not waiting
             ignores it. heroExpand is in a different top-level IIFE (a direct call would work
             unminified and break in the minified bundle), so the channel is a document event, the
             same way rova:pfeedready and rova:pfresumed cross that boundary. */
          try { document.dispatchEvent(new CustomEvent('rova:pfwake')); } catch (e) {}
        }
        return true;
      };
      if (el.tagName === 'IMG') {
        if (!apply()) {                                        // dimensions not ready yet
          el.addEventListener('load', apply, { once: true });
          // A cached image can be .complete with naturalWidth 0 (not yet decoded) and never fire
          // 'load' again -- so retry across a few frames, otherwise that one photo stays letterboxed.
          var tries = 0;
          (function retry() { if (apply() || tries++ > 24) { return; } requestAnimationFrame(retry); })();
        } else if (!(el.naturalWidth > 0)) {
          /* FITTED FROM THE DECLARATION, before a byte decoded: check it ONCE against the decoded
             photo. Aspect within 2% = agree and NOTHING moves (no second apply, so no --pf-cover
             rewrite and no class toggle -- the "no jump on decode" guarantee). A real disagreement
             adopts the decoded size, re-fits, and says so, exactly like the clip's vetDecl. */
          var vetImg = function () {
            var nw = el.naturalWidth, nh = el.naturalHeight;
            var aw = parseInt(el.getAttribute('width'), 10) || 0, ah = parseInt(el.getAttribute('height'), 10) || 0;
            if (!(nw > 0 && nh > 0 && aw > 0 && ah > 0)) { return; }
            if (Math.abs((nw / nh) / (aw / ah) - 1) <= 0.02) { return; }
            try { console.warn('[fitdecl] declared ' + aw + 'x' + ah + ' but the photo decodes ' + nw + 'x' + nh + ' -- refitting', el.currentSrc || el.getAttribute('src') || ''); } catch (e) {}
            el.setAttribute('width', nw); el.setAttribute('height', nh);
            apply();
          };
          el.addEventListener('load', vetImg, { once: true });
        }
      } else {
        if (!apply()) { el.addEventListener('loadedmetadata', apply, { once: true }); }
        else {
          /* THE DECLARATION IS CHECKED, ONCE, AGAINST THE DECODED CLIP. Aspect within 2% = agree (the
             auto poster is a scaled frame: 960x540 for a 1280x720 clip), and nothing moves. A real
             disagreement adopts the clip's size and re-fits -- the verdict classes toggle once, the
             --pf-cover scale eases on the existing .4s transform transition -- and is logged so a
             bad sidecar/poster is visible instead of silently wrong. */
          var vetDecl = function () {
            var vw = el.videoWidth, vh = el.videoHeight;
            var aw = parseInt(el.getAttribute('width'), 10) || 0, ah = parseInt(el.getAttribute('height'), 10) || 0;
            if (!(vw > 0 && vh > 0 && aw > 0 && ah > 0)) { return; }
            if (Math.abs((vw / vh) / (aw / ah) - 1) <= 0.02) { return; }
            try { console.warn('[fitdecl] declared ' + aw + 'x' + ah + ' but the clip decodes ' + vw + 'x' + vh + ' -- refitting', el.currentSrc || el.getAttribute('src') || ''); } catch (e) {}
            el.setAttribute('width', vw); el.setAttribute('height', vh);
            apply();
          };
          if (el.videoWidth > 0) { vetDecl(); } else { el.addEventListener('loadedmetadata', vetDecl, { once: true }); }
        }
      }
    });
  }

  // feed mode was opened from the homepage feed: capture where the feed left off so the viewer
  // can keep pulling MORE posts (the same keyset the feed's "load more" uses) and swipe forever
  // Content cascade: once the tab a pfeed opened from runs dry, don't dead-end into re-looping a
  // handful of posts -- fall through to more engaging sources first. Following is server-rendered
  // ONLY for logged-in members (guests get a /signup link instead), so its presence in the tab bar
  // doubles as a free "is this a member" check with no extra request.
  function feedTiers(tab) {
    var loggedIn = !!document.querySelector('#feed-tabs a.js-tab[href*="tab=following"]');
    var t = [tab];
    if (loggedIn && t.indexOf('following') < 0) { t.push('following'); }
    if (t.indexOf('grid') < 0) { t.push('grid'); }   // the site-wide media pool: the deepest well, tried last
    return t;
  }
  function feedCtx() {
    var fp = document.getElementById('feed-posts');
    // Opened somewhere WITHOUT the homepage feed (a profile or a permalink)? Still keep feeding NEW
    // content: fall into the same whole-site ambient ROLL the watch-feed uses, so after the page's own
    // media the viewer flows through the rest of the site's posts. Only once the ENTIRE site is exhausted
    // does the loop fallback (startLoop) kick in -- we never loop a handful of posts early.
    if (!fp) return { tab: 'discover', before: '', roll: 0, tiers: feedTiers('discover'), tierIdx: 0 };
    // media GRID tab: the cells ARE the media list. Cursor = min loaded id; keep pulling media
    // (chronological via /feed?tab=grid&before, then the high->low engagement roll).
    var grid = fp.querySelector('.pgrid');
    if (grid) {
      var cells = grid.querySelectorAll('.pcell[data-id]');
      if (!cells.length) return null;
      var minG = 0;
      Array.prototype.forEach.call(cells, function (c) {
        var g = parseInt(c.getAttribute('data-id'), 10) || 0;
        if (g && (minG === 0 || g < minG)) minG = g;
      });
      return { tab: 'grid', before: minG ? String(minG) : '', roll: -1, grid: true, tiers: feedTiers('grid'), tierIdx: 0 };
    }
    // :not([data-rd]) -- a REDISCOVER row (older real-member media woven into Discover, 2026-09-28) is
    // older than the page around it by design; taking the minimum over it would skip weeks of posts.
    var withId = fp.querySelectorAll('.post[data-id]:not([data-rd])');
    if (!withId.length) return null;
    // Cursor = the MINIMUM loaded id, not the last DOM post: the home feed's order mixes the
    // ambient roll + live prepends, so "last in the DOM" isn't the oldest and paginating before it
    // re-fetches posts we already have. Before the minimum id, everything is genuinely new.
    var minId = 0;
    Array.prototype.forEach.call(withId, function (p) {
      var n = parseInt(p.getAttribute('data-id'), 10) || 0;
      if (n && (minId === 0 || n < minId)) minId = n;
    });
    var tab = 'discover', on = document.querySelector('#feed-tabs .js-tab.on');
    var h = (on && on.getAttribute('href')) || ''; var m = h.match(/tab=([a-z]+)/); if (m) { tab = m[1]; }
    // roll < 0 = "before" mode, >= 0 = roll mode
    return { tab: tab, before: minId ? String(minId) : '', roll: -1, tiers: feedTiers(tab), tierIdx: 0 };
  }
  // Advance to the next tier in the cascade (e.g. Following -> the site-wide media grid) once the
  // current one is confirmed dry. Resets to a fresh chronological cursor on the new source, same as
  // opening that tab from scratch. Returns false once every tier has been tried.
  function advanceFeedTier(f) {
    if (!f || !f.tiers || f.tierIdx >= f.tiers.length - 1) return false;
    f.tierIdx++;
    f.tab   = f.tiers[f.tierIdx];
    f.grid  = (f.tab === 'grid');
    f.before = '';
    f.roll   = -1;
    return true;
  }
  // Pull the next page of feed media into the swipe list and keep it flowing: paginate OLDER posts
  // (keyset `before`), skip pages that hold no new media, and when the tab runs dry fall back to the
  // ambient ROLL endpoint (the same infinite, most-engaged-first walk the watch-mode feed uses) so
  // the viewer never dead-ends at the last pre-loaded clip. Resolves true if it added anything.
  function loadMoreFeedIds() {
    if (!cur || !cur.feed || cur.feedLoading) return Promise.resolve(false);
    if (cur.feed.holdUntil > Date.now()) return Promise.resolve(false);   // a ring's dry Discover walk is holding (ringFeedScore)
    cur.feedLoading = true;
    var mine = cur;
    function ingest(html) {
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var grid = mine.feed && mine.feed.grid;
      var nodes = tmp.querySelectorAll(grid ? '.pcell[data-id]' : '.post[data-id]');
      var added = 0, lastId = 0;
      Array.prototype.forEach.call(nodes, function (p) {
        var did = parseInt(p.getAttribute('data-id'), 10) || 0; if (did) { lastId = did; }
        if (grid) {                                                     // grid cells are already media-only
          var vg = String(did);
          if (did && mine.ids.indexOf(vg) < 0) { mine.ids.push(vg); added++; }
          return;
        }
        if (!p.querySelector('.media img, .media video')) { return; }   // media-only, like the viewer
        if (postIsGiphy(p)) { return; }                                 // gifs never go full-screen
        var v = p.getAttribute('data-view');
        if (v && mine.ids.indexOf(v) < 0) { mine.ids.push(v); added++; }
      });
      // rollNext: the server's own "where does the next roll page start", off the RAW fetch. null
      // when the response carries no sentinel (an old cached bundle against a new server, or the
      // other way round), in which case the caller falls back to counting cards -- see below.
      var rf = tmp.querySelector('.feed-roll-flag');
      var rn = (rf && rf.getAttribute('data-rollnext') !== null) ? (parseInt(rf.getAttribute('data-rollnext'), 10) || 0) : null;
      return { count: nodes.length, added: added, lastId: lastId, rollNext: rn };
    }
    function pull(tries) {
      var f = mine.feed;
      if (!f || cur !== mine) return Promise.resolve(false);
      // The pfeed is a MEDIA viewer, so ask the server for media-only posts on EVERY card tier (discover/
      // new/following). The old code only did this for 'following' and relied on ingest()'s client-side
      // media filter for discover/new -- but when a roll page came back ALL text (very common: discover's
      // engagement roll surfaces text posts too), every post was filtered out, added=0, and it fell into
      // startLoop() re-showing the SAME post forever. That was the "opened from a post -> swipe up just
      // repeats it / random+repeated content" bug. grid is already media-only (ingests .pcell), so it opts out.
      var mediaFlag = ((f.tab === 'grid') ? '' : '&media=1')
        // deck=1: this is the VIEWER's continuation, not the tab -- the server may weave rediscover picks
        // (older low-engagement real-member media) in at a modest rate on the discover/trending/grid tiers.
        + '&deck=1';
      var url = f.roll >= 0
        ? '/feed?partial=posts&roll=' + f.roll + '&tab=' + encodeURIComponent(f.tab) + mediaFlag
        : '/feed?tab=' + encodeURIComponent(f.tab) + '&partial=posts&before=' + encodeURIComponent(f.before) + mediaFlag;
      // rfetch: the old r.ok check turned a 5xx into an empty string, which fell through as a legitimate
      // "this page had no new media" -- so a network failure spent one of the 6 retries, then walked the
      // roll cursor, then eventually called advanceFeedTier() and CASCADED THE VIEWER OFF THIS TIER. A bad
      // moment on the train quietly demoted someone from Following to the site-wide grid. Rejecting sends
      // it to the .catch below (return false) with every cursor untouched, so the tier is retried intact.
      return rfetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', cache: 'no-store' }, 8000)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          if (cur !== mine) return false;
          var res = (html && html.trim()) ? ingest(html) : { count: 0, added: 0, lastId: 0, rollNext: null };
          if (f.roll >= 0) {
            // roll mode: an endless walk; loop back to the top when the walk genuinely wraps.
            // res.count is the SCREENED card count, so it under-reports a page that had a shadowed
            // or muted post trimmed out of it -- which read as "short page -> wrap" and restarted
            // the walk at 0, and otherwise advanced the offset by less than the page it consumed.
            // data-rollnext is the same arithmetic on the RAW fetch, from the side that knows.
            f.roll = (res.rollNext !== null) ? res.rollNext : ((res.count >= 6) ? f.roll + res.count : 0);
          } else if (!res.count || !res.lastId || res.lastId >= (parseInt(f.before, 10) || 0)) {
            f.roll = 0; f.before = '';                 // chronological tail reached -> switch to the roll
          } else {
            f.before = String(res.lastId);
          }
          if (res.added > 0) { return true; }
          if (tries > 0 && mine.feed) { return pull(tries - 1); }   // page had no NEW media: keep pulling
          // this source is dry -- cascade to the next content tier (e.g. Following -> the site-wide
          // media grid) BEFORE ever falling back to re-looping the handful of posts already shown
          if (advanceFeedTier(mine.feed)) { return pull(6); }
          return false;
        })
        .catch(function () { return false; });
    }
    return pull(6).then(function (got) {
      if (cur === mine) { cur.feedLoading = false; }
      if (mine.ring) { ringFeedScore(mine, got); }   // a ring's Discover hand-off (2026-10-09): dry answers hold the walk
      return got;
    });
  }

  // INFINITE LOOP: once every REAL source is exhausted (a single profile's posts, a permalink's page,
  // or a still-small network), keep the scroll alive by cycling the media we've already shown -- forever.
  // Optimized for someone who'll scroll all day: they never hit a dead end. As the network grows, fresh
  // pages keep arriving first, so real posts get served long before we ever fall back to looping.
  /* ---- THE MEDIA RING'S CONTINUATION (owner 2026-09-18) ---------------------------------------------
     A ring session (cur.ring, opened by the media-ring IIFE at the foot of this file) used to preset
     loopIds and wrap forever. Now its deck is ONE LAP -- row order from the tapped circle, round to the
     circle before it, ending exactly where the starting person's newest post would repeat -- and once
     the lap's ids are spent the viewer pages GET /ring-next: `trending` (the engine's variety ranking
     over real media, minus the deck), then `random` (every eligible media post with no genuine view,
     one permutation per session, no repeats), then `end`. ONE server sequence, shared with the app's
     GET /api/v1/feed/ring/next, so both surfaces play the same posts in the same order.
       ringTopUp   asks for the next page while RING_AHEAD ids are still unplayed, so the reel never
                   waits at a stage boundary (the app does the same at 2); the ids land in cur.ids and
                   loadMore's ordinary /post-cards batches render them -- no second renderer.
       ringDrain   loadMore's batch-empty branch for a ring: a page in flight -> wait a beat; none and
                   not done -> fetch one then continue; done -> the end card.
       ringEnd     appends the "End of media" card (a .post so the pager, hands-free and the prune all
                   treat it as one more unit) with a Start over button, closes the pager (cur.more =
                   false) and hides the sentinel. Hands-free rests on it (hfTick/hfPump). Start over is
                   the ring IIFE's: it closes the viewer (which settles the row -- seen circles behind,
                   i.e. after a full lap the order it was watched in) and re-taps circle 1.
     A 5xx or a dead line does NOT end the session: ringMore resolves false, the retry curve in hfPump /
     the sentinel asks again, and only a server `exhausted` (or `end`) sets ringDone.
     ENDLESS (owner 2026-10-09, browsing as a guest: "it should not ever get to end of media, there's way
     to much media on the platform to go through"). Three things changed, and each one alone ended a ring:
       1. GUESTS ASK /ring-next. They used to open with ringDone = true (the lap, then the card), so a guest
          saw "End of media" after the ~27-post lap with ~1,200 eligible posts unplayed. The server gives a
          guest trending, then a random walk over the guest-visible grid pool (lib/posts.php ringRandomIds).
       2. A RING NEVER LOOKS "DRY" BETWEEN PAGES. cur.more used to be `idx < ids.length`, so the batch that
          spent the last id of a page closed the pager while the next /ring-next was still in flight, and
          the !cur.more tail drew the card -- a member's ring ended at the trending->random seam (measured:
          59 posts, the random page never asked). cur.more now stays true until ringEnded, and the tail
          drains (ringDrain) instead of ending.
       3. THE TRUE END HANDS OFF TO DISCOVER (ringFeed). When /ring-next is exhausted the session becomes an
          ordinary feed-backed viewer on the Discover ROLL (the same endless walk a profile/permalink viewer
          falls into, deduped against everything already played); "End of media" is drawn only if that is
          dry too. The guest browse gate is untouched: it still covers the viewer at its 90 s / 15 posts. */
  var RING_AHEAD = 8;
  function ringTopUp() {
    if (!cur || !cur.ring || cur.ringLoading || cur.ringDone || cur.ringEnded) return;
    if ((cur.ids.length - cur.idx) > RING_AHEAD) return;
    ringMore();
  }
  function ringMore() {
    if (!cur || !cur.ring || cur.ringLoading || cur.ringDone) return Promise.resolve(false);
    var mine = cur, mineRp = cur.rpGen;
    cur.ringLoading = true;
    var url = '/ring-next?n=8';
    if (mine.ringCursor) { url += '&cursor=' + encodeURIComponent(mine.ringCursor); }
    else if (mine.ringDeck && mine.ringDeck.length) { url += '&exclude=' + mine.ringDeck.slice(0, 300).join(','); }
    return rfetch(url, { headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', cache: 'no-store' }, 8000)
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (cur !== mine || cur.rpGen !== mineRp) return false;
        cur.ringLoading = false;
        if (!d || !d.ok) return false;
        cur.ringAnswered = true;   // a real answer (vs. a failed fetch): ringDrain may ask again at once if it was all repeats
        var added = 0;
        (d.ids || []).forEach(function (id) {
          var v = String(id);
          if (v && mine.ids.indexOf(v) < 0 && mine.ringDeck.indexOf(v) < 0) { mine.ids.push(v); added++; }
        });
        cur.ringStage  = d.stage || cur.ringStage;
        cur.ringCursor = d.next_cursor || null;
        if (d.exhausted || d.stage === 'end' || !d.next_cursor) { cur.ringDone = true; }
        try { document.dispatchEvent(new CustomEvent('rova:ringnext', { detail: { stage: d.stage, added: added, exhausted: !!d.exhausted, cursor: d.next_cursor || null } })); } catch (e) {}
        return added > 0;
      })
      .catch(function () { if (cur === mine) { cur.ringLoading = false; } return false; });
  }
  function ringDrain() {
    if (!cur || !cur.ring) return Promise.resolve();
    var mine = cur;
    if (cur.ringLoading) {
      return new Promise(function (res) { setTimeout(res, 250); }).then(function () { if (cur === mine) { return loadMore(); } });
    }
    if (cur.feedLoading) {   // the Discover hand-off's page is in flight
      return new Promise(function (res) { setTimeout(res, 250); }).then(function () { if (cur === mine) { return loadMore(); } });
    }
    if (!cur.ringDone) {
      cur.ringAnswered = false;
      return ringMore().then(function (got) {
        if (cur !== mine) return;
        if (got) { cur.more = true; return loadMore(); }
        if (cur.ringDone) { return ringFeed(); }
        if (cur.ringAnswered) { return ringDrain(); }   // a page of repeats only: the cursor moved, take the next one now
        return undefined;   // a failed fetch: the sentinel / hfPump retry curve asks again; nothing is latched
      });
    }
    return ringFeed();
  }
  /* THE TRUE END IS A HAND-OFF, NOT A DEAD END (2026-10-09). The continuation is spent: become a
     feed-backed viewer on the Discover roll (feedCtx()'s no-feed shape: roll mode, the same endless
     most-engaged-first walk, media only, deck=1) and let loadMoreFeedIds() feed cur.ids from here on --
     its low-water top-up in loadMore runs off cur.feed by itself. Deduped by loadMoreFeedIds' own
     `mine.ids` test, so nothing the lap or the continuation played comes back. Ring seen-marking is
     unaffected (the ring IIFE only marks deck ids). Only a Discover walk that is ALSO dry (every tier
     tried, three dry answers in a row) draws "End of media"; until then the retry curve asks again. */
  function ringFeed() {
    if (!cur || !cur.ring || cur.ringEnded) return Promise.resolve();
    var mine = cur;
    if (!cur.feed) {
      if (cur.ringFed) { return ringEnd(); }
      cur.ringFed = true; cur.ringStage = 'discover'; cur.ringFeedMiss = 0;
      cur.feed = { tab: 'discover', before: '', roll: 0, tiers: feedTiers('discover'), tierIdx: 0 };
      try { document.dispatchEvent(new CustomEvent('rova:ringnext', { detail: { stage: 'discover', added: 0, exhausted: false, cursor: null } })); } catch (e) {}
    }
    if (cur.ringFeedMiss >= 3) { cur.feed = null; return ringEnd(); }
    if (cur.feedLoading) {   // a pull (often loadMore's low-water top-up) is in flight: never score "busy" as "dry"
      return new Promise(function (res) { setTimeout(res, 250); }).then(function () { if (cur === mine) { return loadMore(); } });
    }
    // a dry answer HOLDS the walk (ringFeedScore): one timer asks again when the hold lapses -- nothing else
    // would, a reader resting on the last post fires no sentinel -- and nothing spins while it waits
    var wait = (cur.feed.holdUntil || 0) - Date.now();
    if (wait > 0) {
      if (!cur.ringHoldT) {
        cur.ringHoldT = setTimeout(function () { mine.ringHoldT = 0; if (cur === mine && !mine.ringEnded) { loadMore(); } }, wait + 20);
      }
      return Promise.resolve();
    }
    return loadMoreFeedIds().then(function (got) {
      if (cur !== mine) return;
      if (got) { cur.more = true; return loadMore(); }
      if (cur.ringFeedMiss >= 3) { cur.feed = null; return ringEnd(); }
      if (cur.feed && cur.feed.holdUntil > Date.now()) { return ringFeed(); }   // dry: arm the one retry
      return undefined;   // failed before the cascade finished: the ordinary retry curve asks again
    });
  }
  /* Scores every Discover pull a RING session makes (loadMoreFeedIds calls it, so loadMore's low-water top-up
     counts too). A pull that comes back empty with every tier tried (each pulled up to 7 times) is a DRY
     answer: hold the walk 2 s, then 4 s (loadMoreFeedIds refuses while held, so the top-up cannot spin),
     and the third dry answer in a row lets ringFeed draw the card. Anything that adds resets it. */
  function ringFeedScore(m, got) {
    var f = m && m.feed;
    if (!f) return;
    if (got) { m.ringFeedMiss = 0; f.holdUntil = 0; return; }
    if (f.tierIdx < f.tiers.length - 1) return;   // failed mid-cascade (network): not a dry answer
    m.ringFeedMiss = (m.ringFeedMiss || 0) + 1;
    f.holdUntil = Date.now() + 2000 * m.ringFeedMiss;
  }
  function ringEnd() {
    if (!cur || !cur.ring) return Promise.resolve();
    if (cur.ringEnded) return Promise.resolve();
    cur.ringEnded = true; cur.ringDone = true; cur.more = false; cur.looping = false;
    sentinel.style.display = 'none';
    var row = document.getElementById('media-ring');
    var tEnd = (row && row.getAttribute('data-p-end')) || 'End of media';
    var tAgain = (row && row.getAttribute('data-p-again')) || 'Start over';
    var card = document.createElement('div');
    card.className = 'post pf-end';
    card.setAttribute('role', 'group');
    card.setAttribute('aria-label', tEnd);
    var inner = document.createElement('div'); inner.className = 'pf-end-in';
    var mark = document.createElement('span'); mark.className = 'pf-end-mark'; mark.setAttribute('aria-hidden', 'true');
    var title = document.createElement('p'); title.className = 'pf-end-title'; title.textContent = tEnd;
    var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'pf-end-again'; btn.textContent = tAgain;
    btn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      if (window.__rovaRingStartOver) { window.__rovaRingStartOver(); }
      else { var x = box && box.querySelector('.pfeed-x'); if (x) x.click(); }
    });
    inner.appendChild(mark); inner.appendChild(title); inner.appendChild(btn);
    card.appendChild(inner);
    list.appendChild(card);
    try { document.dispatchEvent(new CustomEvent('rova:ringend', { detail: { stage: cur.ringStage } })); } catch (e) {}
    return Promise.resolve();
  }

  function startLoop() {
    if (!cur) return Promise.resolve();
    // ...EXCEPT a self-contained album (the profile-photo slideshow). It is a FINITE set -- the member's
    // current photo plus their previous ones -- and almost every album is a single photo, so looping it
    // re-rendered the SAME picture down the whole viewer (web#43: "it swipes to the same photo over and
    // over"). One card per photo, then the slideshow ends. [[avatar-engagement]]
    if (cur.feedless) { cur.more = false; sentinel.style.display = 'none'; return Promise.resolve(); }
    if (!cur.loopIds) {                     // snapshot the ordered ids we've shown, once
      var ids = [];
      Array.prototype.forEach.call(list.querySelectorAll('.post[data-view]'), function (p) {
        var v = p.getAttribute('data-view'); if (v && ids.indexOf(v) < 0) ids.push(v);
      });
      if (!ids.length) {
        Array.prototype.forEach.call(list.querySelectorAll('.post[data-id]'), function (p) {
          var v = p.getAttribute('data-id'); if (v && ids.indexOf(v) < 0) ids.push(v);
        });
      }
      cur.loopIds = ids; cur.loopPtr = 0;
    }
    cur.looping = true;
    if (!cur.loopIds.length) { cur.more = false; sentinel.style.display = 'none'; return Promise.resolve(); }
    cur.more = true; sentinel.style.display = '';
    return loopMore();
  }
  function loopMore() {
    if (!cur || cur.loading || !cur.looping || !cur.loopIds || !cur.loopIds.length) return Promise.resolve();
    var mine = cur, mineRp = cur.rpGen, n = cur.loopIds.length, batch = [];
    for (var i = 0; i < 6; i++) { batch.push(cur.loopIds[cur.loopPtr % n]); cur.loopPtr++; }
    cur.loading = true; sentinel.classList.add('on');
    // SLOW-LINK (2026-08-09): this was the last loader in this IIFE still on bare fetch() -- every
    // sibling (pull/loadMore/loadBefore/the prefetchers) already goes through rfetch. It sets
    // cur.loading, and cur.loading is cleared only when this settles, so a half-open socket froze the
    // viewer's infinite scroll -- spinner on, every further swipe refused -- for however long the
    // platform took to give up (60-120s on iOS Safari). That is the "swipe up and it just stops" shape.
    //
    // And take the network off the path entirely where we can: loopMore re-renders ids ALREADY SHOWN
    // in this viewer, so the idle cardCache usually holds every one of them. cachedBatch() is
    // all-or-nothing and TTL-bounded, exactly as loadMore() uses it a few lines below; a miss just
    // falls through to the deadlined fetch. A loop lap that hits the cache costs zero round-trips,
    // which is the whole point on a bad line -- the reader has run out of real content and the one
    // thing left keeping the scroll alive must not be the thing that stalls it.
    var loopCached = cachedBatch(batch);
    return (loopCached !== null ? Promise.resolve({ html: loopCached })
      : rfetch('/post-cards?ids=' + batch.join(','), {
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', cache: 'no-store'
        }, 8000).then(function (r) { return r.json(); })
    ).then(function (d) {
      if (cur !== mine) return;
      if (cur.rpGen !== mineRp) return;   // #634: the scope changed under this lap -- orphan it (see rpBump)
      cur.loading = false; sentinel.classList.remove('on');
      if (d && d.html) {
        var tmp = document.createElement('div'); tmp.innerHTML = d.html;
        pfNoPip(tmp);   // BEFORE the clips are bound into the document -- see the note on pfNoPip
        while (tmp.firstChild) list.appendChild(tmp.firstChild);
        if (window.__rovaHydrate) window.__rovaHydrate(list);
        fitPfeedMedia();
      }
      cur.more = true; sentinel.style.display = '';   // a loop never dead-ends
    }).catch(function () { if (cur === mine && cur.rpGen === mineRp) { cur.loading = false; sentinel.classList.remove('on'); } });
  }

  /* ---- tap-to-media latency killers (round 129b) ------------------------------------------------------------
     The grid's thumbnails are instant but a tap still had to WAIT on a network round-trip for the post-card
     HTML (/post-cards | /profile-feed) before any media element even existed -- that's the "takes a second"
     the owner flagged. Three layers take the network off the tap path:
       1. cardCache: while you browse the HOME grid, an idle prefetcher quietly fetches the visible cells'
          post-cards ONE BATCH AT A TIME and stores them PER ID. When you tap, loadMore/loadBefore assemble
          the page straight from the cache -- zero network, the card (and its donor video) is up immediately.
       2. pfPre: profile grids page by offset (can't be cached per id), so a POINTERDOWN on a profile cell
          starts fetching the EXACT first-page URL the viewer will request ~100-300ms before the click lands.
       3. data-full warm (views): pointerdown on a PHOTO cell kicks the original image into the HTTP cache,
          so the full-res paint doesn't wait behind the thumb-upscaled hero. */
  var cardCache = {}, CARD_TTL = 120000;   // id -> {html, at}; 2min is fresh enough for like/comment counts
  function cacheCards(html) {
    var tmp = document.createElement('div'); tmp.innerHTML = html || '';
    var now = Date.now();
    Array.prototype.forEach.call(tmp.children, function (p) {
      var id = p.getAttribute && (p.getAttribute('data-view') || p.getAttribute('data-id'));
      if (id) { cardCache[id] = { html: p.outerHTML, at: now }; }
    });
    // bound the cache: drop the oldest entries past ~90 (each is a few KB of HTML string)
    var keys = Object.keys(cardCache);
    if (keys.length > 90) {
      keys.sort(function (a, b) { return cardCache[a].at - cardCache[b].at; })
          .slice(0, keys.length - 90).forEach(function (k) { delete cardCache[k]; });
    }
  }
  function cachedBatch(ids) {          // whole batch cached + fresh -> joined HTML, else null (fetch instead)
    var now = Date.now(), out = [];
    for (var i = 0; i < ids.length; i++) {
      var c = cardCache[ids[i]];
      if (!c || now - c.at > CARD_TTL) return null;
      out.push(c.html);
    }
    return out.join('');
  }
  /* THE READER'S OWN WRITE MAKES THE CACHED CARD A LIE (owner 2026-08-21: "the comment lightened
     up feature ... took a page refresh to see it"). The lit comment button (and the count, and a
     like/repost state) is baked into the HTML this cache holds -- so commenting in the viewer,
     closing it and reopening the same post inside the 2-minute TTL re-materialized the card from
     HTML fetched BEFORE the comment: the button arrived unlit and only a page refresh (a fresh
     server render carrying commented_by_me) showed the truth. Proved live by
     C:\tools\pw\comment-lit-verify.js `reopen` before this hook existed.
     Same shape as __rovaPfDrop below (a delete is just the harshest own-write): the fix is to
     FORGET the entry, not to patch the string -- the next open refetches a render the server
     personalises with the write already in it. Called from engBadgeArm (like/comment/repost, at
     arm AND at release, so a prefetch batch that raced the write is also thrown away) and from
     engCommentApplied (comment delete). Deleting is idempotent and costs one warm open. */
  window.__rovaPfCardDirty = function (id) {
    var sid = String(id || '');
    if (sid && cardCache[sid]) { delete cardCache[sid]; }
  };
  var pfPre = null;                    // {url, at, p} -- pointerdown-prefetched profile first page
  // idle prefetcher: keep the HOME grid's visible cells' cards cached ahead of any tap
  var cardBusy = false;
  function prefetchGridCards() {
    if (cardBusy || document.hidden) return;
    if (box && box.classList.contains('show')) return;             // viewer open: it does its own loading
    // MID-DISMISS: the viewer just dropped .show, so the guard above stops covering us at exactly the
    // moment the collapse tween needs the thread. The census below is a querySelectorAll plus a rect per
    // cell (forced layout), and this fires every 3s -- so on a long dismiss it lands inside one. Nothing
    // waits on the card cache; the next tick is 3s away.
    if (window.__rovaFlightBusy && window.__rovaFlightBusy()) return;
    var grid = document.getElementById('feed-grid'); if (!grid) return;
    if (Date.now() - (window.__rovaScrollAt || 0) < 300) return;   // mid-scroll: wait for calm
    var vh = window.innerHeight || 800, now = Date.now(), want = [];
    var cells = grid.querySelectorAll('.pcell[data-id]');
    for (var i = 0; i < cells.length && want.length < 15; i++) {   // 15 covers a full phone screen + the row below
      var r = cells[i].getBoundingClientRect();
      if (r.bottom < -vh || r.top > vh * 2) continue;              // ~a screen around the viewport
      var id = cells[i].getAttribute('data-id');
      var c = cardCache[id];
      if (!c || now - c.at > CARD_TTL * 0.8) { want.push(id); }
    }
    if (!want.length) return;
    cardBusy = true;
    // Deadlined: cardBusy is only cleared when this settles, and this runs on a 3s interval -- a hung
    // socket meant the whole idle card-prefetch (the thing that makes a grid tap open with no network on
    // the tap path at all) was off for as long as the platform took to notice.
    rfetch('/post-cards?ids=' + want.join(','), {
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin'
    }, 8000).then(function (r) { return r.json(); })
      // PERF: cacheCards() innerHTML-parses ~15 full post cards. Measured at 159ms of a 12s grid scroll
      // (CPU x4) -- a ~40ms synchronous main-thread block landing every 3s, which is squarely in
      // dropped-frame territory if the reader is still moving. Nothing waits on it (it only fills a
      // tap-ahead cache), so hand it to idle time; the 1500ms deadline keeps it prompt on a busy page.
      .then(function (d) {
        if (!(d && d.html)) return;
        if (window.requestIdleCallback) { requestIdleCallback(function () { cacheCards(d.html); }, { timeout: 1500 }); }
        else { setTimeout(function () { cacheCards(d.html); }, 0); }
      })
      .catch(function () {})
      .then(function () { cardBusy = false; });
  }
  setTimeout(prefetchGridCards, 1200);           // first fill right after the grid paints
  setInterval(prefetchGridCards, 3000);          // then track the viewport as it moves (no-op when covered)
  // pointerdown = intent: start the expensive bits before the click even fires
  document.addEventListener('pointerdown', function (e) {
    var cell = e.target.closest ? e.target.closest('.pgrid .pcell') : null;
    if (!cell) return;
    // (a) photo cell -> warm the ORIGINAL image (data-full) the pfeed will paint
    var im = cell.querySelector('img[data-full]');
    // _fullWarm is a once-per-element claim, so it has to be released if the warm dies -- otherwise the
    // first tap during a bad moment permanently disables the tap-warm for that cell and every later tap
    // opens it cold.
    if (im && !im._fullWarm) {
      im._fullWarm = 1;
      var w = new Image();
      w.onerror = function () { im._fullWarm = 0; };
      w.src = im.getAttribute('data-full');
      /* REGISTER THE WARM IN THE ONE SLOT heroExpand READS (2026-08-30). A tile that declares its
         landing (data-photo-dims/data-photo-src -- an avatar post, whose tile bitmap is the square
         crop) now flies the DESTINATION's pixels, and heroExpand decides between "swap the file in
         now" and "fly the square and swap when it decodes" by asking __rovaPfaWarm whether that file
         is already decoded. Without this the grid's warm was invisible to it and every grid open took
         the second branch -- correct, but the content sharpens mid-flight instead of being right from
         frame one. data-full and data-photo-src resolve through the same Upload::landedPhoto(), so
         the file this warms IS the file that flies.
         MUTATED, NEVER REPLACED: the avatar tap owns the object and updates it in place, so assigning
         a new one to window would silently orphan that path's warm. One slot, two writers, and only
         one open can be in flight at a time. */
      var _pw = window.__rovaPfaWarm, _ps = im.getAttribute('data-photo-src') || '';
      // the ATTRIBUTE string, not w.src: heroExpand compares against predDims.src, which is this exact
      // string, and w.src comes back URL-normalised. Both views emit one media_url() for both attributes.
      if (_pw && _ps && _ps === im.getAttribute('data-full')) { _pw.src = _ps; _pw.img = w; }
    }
    // (b) profile grid -> prefetch the exact /profile-feed first page after a short stillness beat
    //     (a scroll gesture also starts with pointerdown; 90ms of no movement filters those out)
    if (cell.closest('#feed-posts')) return;     // home grid: cardCache covers it
    var um = location.pathname.match(/^\/@([^\/]+)/); if (!um) return;
    var sx = e.clientX, sy = e.clientY, t = null, moved = false, fired = false;
    var onMove = function (ev) { if (Math.abs(ev.clientX - sx) > 6 || Math.abs(ev.clientY - sy) > 6) { moved = true; cleanup(); } };
    var cleanup = function () {
      clearTimeout(t);
      document.removeEventListener('pointermove', onMove);
      document.removeEventListener('pointercancel', cleanup);
      document.removeEventListener('pointerup', onUp);
    };
    /* A POINTERUP IS A BETTER TAP SIGNAL THAN 90ms OF STILLNESS, and the old code only had the latter.
       MEASURED (2026-08-09, live site, Chromium, 1.6Mbps/300ms RTT): a tap held 60ms -- an ordinary
       quick tap; human tap durations cluster around 50-100ms -- released BEFORE this timer fired, so
       the click committed first, the viewer opened, loadMore() found pfPre still null and issued its
       own /profile-feed. The 90ms timer then fired anyway (nothing had moved, so `moved` was false)
       and put a SECOND, byte-identical request for the very same page onto the wire behind it. Both
       requests were logged: offset=1 twice, 340ms and 1754ms. At 90/140/220ms hold there was exactly
       one. So the fast tap -- the confident one, the one that most wants to feel instant -- was the
       only tap that got no prefetch at all AND paid for a duplicate, and on a congested link that
       duplicate competes for the same narrow pipe as the request the viewer is actually waiting on.

       So: fire on pointerup as well. A pointerup that has not moved past the 6px slop IS the tap, and
       it arrives BEFORE the click, so pfPre is populated in time for loadMore() to adopt it -- the
       round-trip stops being wasted and starts being the one the open path uses. `fired` keeps the two
       triggers to one request between them; the 90ms timer still covers a slow/held tap exactly as
       before, so nothing that worked already changes. */
    var onUp = function () { cleanup(); fire(); };
    document.addEventListener('pointermove', onMove, { passive: true });
    document.addEventListener('pointercancel', cleanup, { passive: true });
    document.addEventListener('pointerup', onUp, { passive: true });
    t = setTimeout(function () { cleanup(); fire(); }, 90);
    function fire() {
      if (fired || moved) return;
      fired = true;
      // Nothing to warm once the overlay is already up -- it owns its own paging from here, and a
      // stray prime would only take bandwidth off the page it is currently fetching.
      if (box && box.classList.contains('show')) return;
      // build the SAME url __rovaProfileFeed + loadMore will: user, active tab, offset from the cell's index
      var onTab = document.querySelector('#profile-tabs .js-tab.on');
      var tm = onTab && (onTab.getAttribute('href') || '').match(/[?&]tab=([a-z]+)/);
      var tab = tm ? tm[1] : '';
      var grid = cell.closest('.pgrid');
      var idx = grid ? Array.prototype.indexOf.call(grid.querySelectorAll('.pcell'), cell) : -1;
      var off = (idx > 3) ? (idx - 3) : 0;
      /* &cr=<tapped id>: the comment-roller phase (views/_croller.php). It has to be built HERE as well as
         in loadMore, byte-identical, because loadMore adopts this prefetch by exact URL match -- a url that
         differs by one param is a prefetch thrown away and a round-trip put back on the tap path, which
         would cost far more than the 14KB the phase saves. `cell`'s data-id IS the id the tap passes as
         targetId (see the grid tap handler: `pid` is read off this same attribute), so the two agree. */
      var crId = cell.getAttribute('data-id') || '';
      var url = '/profile-feed?user=' + encodeURIComponent(decodeURIComponent(um[1])) + '&tab=' + encodeURIComponent(tab) + '&offset=' + off
              + (crId ? '&cr=' + encodeURIComponent(crId) : '');
      if (pfPre && pfPre.url === url && Date.now() - pfPre.at < 10000) return;   // already warming
      // Deadlined + non-2xx rejected, and the claim is DROPPED when it fails: loadMore() adopts this
      // promise as `ready` if the tap lands within 10s, so a poisoned one used to be handed straight into
      // the open path -- the viewer opened onto a rejected prefetch instead of just fetching for itself.
      var mineP = { url: url, at: Date.now(), p: null };
      mineP.p = rfetch(url, {
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', cache: 'no-store'
      }, 8000).then(function (r) { return r.json(); });
      mineP.p.catch(function () { if (pfPre === mineP) { pfPre = null; } });   // failed prime: let the tap fetch for real
      pfPre = mineP;
    }
  }, { passive: true });

  /* 4. VERTICAL FEED tap-ahead (the surface layers 1-3 never covered).
     Every layer above is keyed to a GRID -- cardCache scans #feed-grid, pfPre and the data-full warm
     want a .pgrid .pcell -- so a tap on a photo in the VERTICAL feed (#feed-posts), which is the
     surface the owner actually reported as slow to open, still paid a full /post-cards round-trip
     AFTER the open had already committed, with nothing warming it. Measured on the live site,
     unthrottled, tap -> first painted frame of the hero flight was 660-793ms, and ~340-390ms of that
     was the viewer sitting at .show with no <img> of its own yet because that HTML had not landed.
     Warm EXACTLY the batch loadMore() will request: cachedBatch() is all-or-nothing, so warming any
     other set buys nothing. That batch is the tapped id plus the next two in page order -- the
     `cur.warmed ? 8 : 3` first page, and a fresh open is never warmed.
     WARM, NEVER FLY: this only fills an existing bounded cache. It shows nothing, moves nothing and
     measures nothing, so a warm that turns out to be a swipe, a double-tap-to-like or a long press is
     abandoned for the cost of one small JSON body. No visible step is moved earlier, deliberately --
     an entry animation that lifts off before its destination has mounted is the black-flash/wrong-photo
     race, and nothing here touches the order the viewer mounts or the flight starts. */
  document.addEventListener('pointerdown', function (e) {
    if (!e.target.closest) return;
    var media = e.target.closest('.post .media');
    if (!media || media.closest('.pfeed') || media.closest('.pgrid')) return;   // the viewer/grid have their own paths
    if (box && box.classList.contains('show')) return;
    var postEl = media.closest('.post');
    var pid = postEl && postEl.getAttribute('data-view');
    if (!pid || !window.__rovaPageMediaIds) return;
    var sx = e.clientX, sy = e.clientY, t = null, moved = false, fired = false;
    var onMove = function (ev) { if (Math.abs(ev.clientX - sx) > 6 || Math.abs(ev.clientY - sy) > 6) { moved = true; cleanup(); } };
    var cleanup = function () {
      clearTimeout(t);
      document.removeEventListener('pointermove', onMove);
      document.removeEventListener('pointercancel', cleanup);
      document.removeEventListener('pointerup', onUp);
    };
    var onUp = function () { cleanup(); fire(); };
    document.addEventListener('pointermove', onMove, { passive: true });
    document.addEventListener('pointercancel', cleanup, { passive: true });
    document.addEventListener('pointerup', onUp, { passive: true });
    // Same 90ms stillness filter the profile-cell warm uses: a scroll gesture also starts with a
    // pointerdown, and a fling must not fire a fetch for every post it passes under.
    // ...plus the pointerup trigger, for the same measured reason as the profile-cell warm above: a
    // 60ms tap released before this timer, so the open committed with cardCache still cold, loadMore()
    // fetched the batch itself, and the timer THEN fired a second request for the same ids behind it.
    // A pointerup inside the 6px slop is the tap, and it precedes the click, so the warm lands where it
    // was meant to -- in front of the open rather than alongside it. `fired` keeps them to one request.
    t = setTimeout(function () { cleanup(); fire(); }, 90);
    function fire() {
      if (fired || moved) return;
      fired = true;
      if (box && box.classList.contains('show')) return;
      var ids = window.__rovaPageMediaIds() || [];
      var i = ids.indexOf(String(pid)); if (i < 0) return;      // not one of the ids the viewer will page
      var now = Date.now();
      var want = ids.slice(i, i + 3).map(String).filter(function (id) {
        var c = cardCache[id]; return !(c && now - c.at < CARD_TTL);
      });
      if (!want.length) return;                                  // already warm -> the tap costs no network
      rfetch('/post-cards?ids=' + want.join(','), {
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin'
      }, 8000).then(function (r) { return r.json(); })
        .then(function (d) { if (d && d.html) { cacheCards(d.html); } })   // 3 cards, not 15: a few ms, not the idle pass's ~40
        .catch(function () {});                                  // a failed warm just leaves the tap to fetch as before
    }
  }, { passive: true });

  /* ---- FAILURE RE-ARM (2026-08-09) --------------------------------------------------------------
     MEASURED, with a control, on the live site: black-hole and 5xx outages driven through
     ctx.route while the reader keeps swiping. Control run (no outage): the viewer asks for content
     1x and gains 5 new posts. After EITHER outage, with the link fully restored and six more
     flings: 0 content requests, 0 new posts. The viewer was dead and stayed dead.

     Nothing here is stuck in a wrong STATE -- the .catch below already clears cur.loading and the
     spinner, and cur.more is deliberately left alone on a failure. The problem is that nothing ever
     ASKS AGAIN. This loader has exactly two triggers, and an outage disarms both:
       * the sentinel's IntersectionObserver fires only when the sentinel CROSSES its 9000px margin
         edge (see the note above the buffer top-up below). A failed page appends nothing, so the
         sentinel never moves, never re-crosses, and never fires again.
       * the self-chaining `return loadMore()` that normally keeps the buffer ahead lives on the
         SUCCESS path only.
     So the last failure of the outage is the last thing that ever happens. This is the same shape as
     the documented "three 502s froze the grid at 153 tiles" -- fixed there in 2026-07-29 by rfetch
     plus a re-arm, and the pfeed viewer never got the re-arm half. A deadline alone cannot fix it:
     it frees the flag, and then nobody uses it.

     A bounded, jittered ladder, cleared completely by one success -- the same idiom already used by
     gridCycle.ensureBuf and the landing cascade. Prompter than theirs (1.5s first step, not 2s)
     because a reader is actively swiping in this surface, and capped at 30s so a genuinely down
     origin is not leaned on. One pending re-arm at a time; it drops itself if the viewer closed,
     the scope changed, or something else already started loading. */
  var PF_RETRY = [1500, 3000, 6000, 12000, 20000, 30000];
  var pfFailStep = 0, pfRetryT = null;
  function pfReArm(mine) {
    if (pfRetryT) return;                                  // one pending re-arm at a time
    var base = PF_RETRY[Math.min(pfFailStep, PF_RETRY.length - 1)];
    pfFailStep++;
    pfRetryT = setTimeout(function () {
      pfRetryT = null;
      if (cur !== mine) return;                            // viewer closed, or reopened on another scope
      if (!box || !box.classList.contains('show')) return;
      if (cur.loading || !cur.more || cur.looping) return; // somebody else already owns the next page
      loadMore();
    }, Math.round(base * (0.8 + Math.random() * 0.4)));
  }
  /* ---- THE PARKED REMAINDER OF THE FIRST PAGE -------------------------------------------------
     Holds the cards loadMore() deferred so the hero flight could have the main thread (see the block
     comment at the append). Two DETACHED fragments: nodes that belong above the target and nodes that
     belong below it. Detached is the whole point -- nodes in a fragment cost no style resolution, no
     layout and no image/video decode, so parking is genuinely free rather than merely later.
     Generation-stamped: a second open (or a close) while a flush is pending must drop these on the
     floor rather than splice a dead page into the live list. */
  var pfPark = null;
  /* ═══ THE CHROME ARRIVES WITH THE PICTURE  (2026-09-24, owner: "the chrome needs to load faster so it
     lands with the media on top of it") ════════════════════════════════════════════════════════════
     `.pf-chrome-in` lifts the pf-settling chrome mask (rova.css) while pf-settling itself stays on --
     so everything else that reads pf-settling as "the open has not come to rest" (the remainder flush,
     the comment-sheet auto-open, drop()'s sound / voice / music hand-over) is untouched, and still
     fires at the landing. Only the PAINT of the chrome moves.
     ALLOWED ONLY UNDER A FLIGHT IN THE VIEWER: a `.pf-hero` wrapper INSIDE `.pfeed` at z 1, below the
     chrome (heroExpand's "THE FLIGHT FLIES UNDER THE CHROME"). A flight on <body> at 210 would paint
     over chrome revealed early -- the 2026-08-09 music-card flicker -- so there is no early reveal for
     one; it waits for the landing as it always has.
     ...AND ONLY ONCE THE TARGET IS LAID OUT (.pf-lite / .pf-crlite off), for the reason the ready()
     gate below spells out: a display:none -> block change cannot fade, so revealing before the
     caption and roller have boxes brings them in one and two frames late with no transition. */
  /* ROUND 2 (owner: "it should be instantly attached with the media zooming loading behind it"): the
     fade is no longer stretched to the landing. It is a fixed PF_CHROME_IN_MS, just long enough not to
     read as a pop, and it starts the moment the target card is laid out -- all of the chrome in one
     frame, the picture still zooming underneath. */
  var PF_CHROME_IN_MS = 120;
  function pfChromeIn() {
    try {
      if (!box || !list || !box.classList.contains('pf-settling') || box.classList.contains('pf-chrome-in')) { return; }
      if (!box.querySelector('.pf-hero:not(.pf-hero-collapse)')) { return; }
      if (pfPark && (pfPark.lite || pfPark.crlite)) { return; }
      var tg = (cur && cur.targetId) ? list.querySelector('.post[data-view="' + cur.targetId + '"]') : list.querySelector('.post');
      if (!tg || tg.classList.contains('pf-lite') || tg.classList.contains('pf-crlite')) { return; }
      box.style.setProperty('--pf-chrome-ms', PF_CHROME_IN_MS + 'ms');
      box.classList.add('pf-chrome-in');
    } catch (e) {}
  }
  // the hero scope announces a sunk flight; a target already laid out by then reveals on this event
  document.addEventListener('rova:heroflight', function () { pfChromeIn(); if (pfPark) { pfFlushPark(); } });
  function pfParkRest(pre, post, lite) {
    /* Both sides stay ARRAYS, not fragments: the flush places ONE card per frame (see below), and a
       fragment can only be spliced in whole. `pre` is popped from its END so a,b,c inserted before the
       target still read a,b,c. */
    /* `tgt` is the same node as `lite`, kept separately because `lite` is CONSUMED at step 1 and the
       containment exemption has to outlive it -- see pfCvOn's caller in recyclePfeedMedia. */
    pfPark = { gen: pfGen, pre: pre.slice(), post: post.slice(), lite: lite || null, crlite: lite || null,
               tgt: lite || null, unlite: [], n: pre.length + post.length, tries: 0 };
    pfFlushPark();
  }
  /* ONE STEP PER FRAME (2026-08-17, measured). The flush used to append the whole remainder, hydrate and
     fit it in a single statement run, and that was ONE 764-918ms main-thread task landing on the landing
     -- 415ms of style+layout, 321ms of it inside the scrollHeight anchor read (the read was not slow; it
     was flushing the layout the insertion had just dirtied). A post card costs ~150ms at 4x CPU: ~125
     layout objects, and text shaping -- caption, engagement counts, the five-comment roller -- is most
     of it. A single card's layout cannot be split, so the pass is chunked around the card instead:

       step 1   the target card gets its caption, engagement row and header back  (.pf-lite off)
       step 2   ...and then its comment roller                                    (.pf-crlite off)
       step 3+  one card inserted per frame, BOTH lite classes still on, so an insertion costs its
                media and nothing else. post cards (below the reader, no anchor needed) go first
                because they are the swipe-forward direction; pre cards follow, each with its own
                scrollHeight anchor -- per-card anchoring is free, since the layout it flushes is the
                one that card just dirtied either way.
       last     the inserted cards are un-lited one per frame, nearest-first, so the text cost lands
                after every card's MEDIA is already in place.

     Everything after step 2 is OFF SCREEN, which is why arriving over several frames is invisible
     rather than staged, and why a reader who swipes immediately meets a card with its media. */
  function pfFlushStep() {
    var tok = pfPark, hit = false;
    var go = function () { if (hit || pfPark !== tok) { return; } hit = true; pfFlushPark(); };
    /* DOUBLE rAF, AND THAT IS THE WHOLE POINT OF THE CHUNKING  (2026-08-17, measured -- the single rAF
       this replaces did not actually chunk anything).
       A frame runs: rAF callbacks -> style -> layout -> paint. So a single requestAnimationFrame put the
       NEXT step's mutations into the very frame that was about to lay out the PREVIOUS step's -- and the
       browser then did both in one pass, inside one task. TRACED on a live open at 4x CPU: .pf-lite came
       off the target at 2328ms and .pf-crlite came off at 2547ms, and BOTH sat inside a single 428ms task
       @2343 -- exactly the one unsplit task the chunking existed to break in half.
       An inner rAF registered from inside a rAF callback runs at the NEXT frame's callback phase, i.e.
       AFTER this frame's layout has been done and painted. That is the only scheduling primitive that
       puts a rendering update between two steps.
       The timer stays as the backstop for a backgrounded tab (where rAF never fires at all), and it is
       raised to 200ms so it does not routinely beat two frames on a throttled phone and quietly restore
       the old behaviour. Still far inside the 2.4s cap that guarantees the remainder lands. */
    if (window.requestAnimationFrame) { requestAnimationFrame(function () { requestAnimationFrame(go); }); }
    setTimeout(go, 200);   // rAF is dead in a backgrounded tab, and the remainder must still land
  }
  function pfFlushPark() {
    var p = pfPark;
    if (!p) return;
    if (p.gen !== pfGen || !list || !box || !box.classList.contains('show')) { pfPark = null; return; }
    /* WAIT OUT THE FLIGHT, exactly as loadBefore() does. hz-hold is set by heroExpand for the whole
       flight and cleared by heroRelease at the landing, so this is the same signal the rest of the
       viewer already uses to mean "something is flying, keep off the main thread". The cap matters:
       if a flight never releases (a cancelled open, a generation bump), the remainder must still land
       or the reader is left with a one-card viewer that cannot be swiped. */
    /* ...EXCEPT THE TARGET'S OWN TWO STEPS UNDER A SUNK FLIGHT (2026-09-24). A flight born inside the
       viewer card (heroExpand's "THE FLIGHT FLIES UNDER THE CHROME") is a composited transform on its
       own layer: laying out the target's caption, header and roller costs the main thread, not the
       flight. And those two steps are exactly what the chrome is waiting on to reveal DURING the
       flight (pfChromeIn), so holding them to the landing would hold the chrome to the landing -- the
       owner's complaint. Steps 3+ (the off-screen remainder) still wait out the flight, unchanged. */
    var sunkFly = !!(box && box.querySelector('.pf-hero:not(.pf-hero-collapse)'));
    if (document.documentElement.classList.contains('hz-hold') && !(sunkFly && (p.lite || p.crlite)) && p.tries++ < 40) {
      setTimeout(pfFlushPark, 60);   // 40 x 60ms = 2.4s backstop, well past any flight
      return;
    }
    try {
      /* THE TARGET'S OWN CHROME IS NOT PART OF "THE REMAINDER" ANY MORE  (2026-09-01, owner: "it
         needs to be a more stable looking open where everything lands syncronously instead of the
         current loading system").
         THE GATE THAT USED TO SIT HERE COVERED ALL FIVE STEPS, and that is what staged the open.
         .pf-lite display:none's the target's caption, engagement row and header; .pf-crlite its
         comment roller. Both were removed only AFTER pf-settling dropped, one flush step apart --
         so the reveal fired with the caption and the roller not in the box tree at all, and they
         then POPPED in one and two frames behind everything else, with no fade, because a
         display:none -> display transition does not animate. Measured on the live site, desktop
         1440x900, five opens: topbar and scrubber at a median 938ms, caption 976ms, roller 1055ms.
         That 117ms tail, plus the link card arriving 270ms EARLY (see the pf-settling list in
         rova.css), is the whole of the "everything lands on its own schedule" complaint.
         INVERTED: steps 1 and 2 now run WHILE pf-settling is still on -- i.e. while the chrome is
         invisible anyway -- and the reveal waits for them instead (see the ready() gate in the
         rova:pfeedready handler). The caption and the roller are therefore already laid out when
         pf-settling comes off, and they fade in on the SAME .35s curve, in the same frame, as the
         bar and the player. Nothing is revealed sooner or later than anything else.
         IT COSTS THE CHROME ONLY, NEVER THE MEDIA. The media's own arrival is not gated on any of
         this: it is released by pf-hasmedia and the hero landing, neither of which this touches, so
         the picture appears at exactly the same moment it did before. What moves is the moment the
         CONTROLS appear, and only by the two un-lite layouts -- which the open was paying anyway,
         one frame later, on the other side of the reveal.
         STEPS 3+ KEEP THE OLD GATE, one block down, unchanged: those are the five OFF-SCREEN cards,
         they are not part of the arrival the reader sees, and the reason they yield to the reveal
         (two ~450ms halves must not land in one task) is untouched by any of the above. */
      if (p.lite) {
        var lite = p.lite; p.lite = null;
        lite.classList.remove('pf-lite');
        /* UNDER A FLIGHT IN THE VIEWER the roller comes off in the SAME pass: the chrome is revealed the
           moment the target is laid out (pfChromeIn), and a roller one step behind would arrive two frames
           after the rest of it -- the staged "loading system" look of 2026-09-01. */
        if (sunkFly && p.crlite) { p.crlite.classList.remove('pf-crlite'); p.crlite = null; }
        if (window.__rovaHydrate) { window.__rovaHydrate(lite); }
        fitPfeedMedia();   // now that the caption has a box, it gets its clamp measurement
        pfChromeIn();
        pfFlushStep();
        return;
      }
      if (p.crlite) {
        var cr = p.crlite; p.crlite = null;
        cr.classList.remove('pf-crlite');
        pfChromeIn();   // the target is laid out: under a sunk flight the chrome may arrive with it
        pfFlushStep();
        return;
      }
      /* ...AND THEN LET THE CHROME REVEAL HAVE ITS OWN FRAME. Both this pass and the reveal (drop()
         in the rova:pfeedready handler, which takes .pf-settling off) are released by the SAME
         event -- the landing -- and traced landing on the same frame they produced one 0.8-1.3s
         task out of two ~450ms halves. The reveal wins the frame because it is the half the reader
         is looking at. Short, BOUNDED wait (8 x 60ms): a viewer that cannot be swiped is worse than
         a long task, so if the reveal is stuck behind slow media the remainder lands anyway.
         MOVED BELOW THE TWO TARGET STEPS on 2026-09-01 and otherwise unchanged -- see the block at
         the top of this try. It now guards only the OFF-SCREEN remainder, which is the only part of
         the flush that was ever competing with the reveal for a frame; the target's own caption and
         roller are on the reader's side of that line and must be laid out BEFORE the reveal, not
         after it. The reveal is still pending when this is first reached (ready() and this pass are
         both released by the landing, and drop() runs from an rAF tick), so the 60ms poll still
         buys the reveal its own frame exactly as it did before. */
      if (box.classList.contains('pf-settling') && (p.stries = (p.stries || 0) + 1) <= 8) {
        setTimeout(pfFlushPark, 60);
        return;
      }
      var node = null;
      if (p.post.length) { node = p.post.shift(); list.appendChild(node); }
      else if (p.pre.length) {
        node = p.pre.pop();
        /* loadBefore()'s anchor, and for the same reason: inserting above the reader's card grows the
           scroller, and scrollTop is measured from the top, so without the delta the target slides down
           by the height of what was prepended.

           RECT-ANCHORED, NOT scrollHeight-DELTA (2026-09-01, owner: "every time I click on a media on
           that profile grid page it switches media"). The height-delta form ASSUMED it was the only
           thing moving scrollTop across the insert. It is not: .pfeed-scroll is `scroll-snap-type:y
           mandatory` (rova.css :2047), and a mandatory snap container RE-TARGETS itself when content
           is inserted above the snapped box -- keeping that box put entirely on its own. That is a
           DIFFERENT browser mechanism from scroll anchoring, and the `overflow-anchor:none` sitting on
           the same rule does NOT disable it. So the browser paid the delta, then this line paid it
           again: scrollTop ended at exactly TWICE the target's offsetTop, i.e. one whole card forward
           per post prepended -- and since the opener seeds `off = tapIdx - 3`, EVERY tile except the
           first few had 1-3 posts prepended above it and opened that many posts late. Measured on the
           live site before the fix: tile 1 -> scrollTop 1688 for offsetTop 844, tile 2 -> 3376 for
           1688; with snap forced off, 844 and 1688, and every tile landed on the post it tapped.

           A rect anchor is self-correcting and needs to know nothing about who else moved the scroll:
           hold the post that was FIRST before the insert, and give back only the distance it actually
           travelled. Where the browser has already re-snapped perfectly the delta is 0 and this is a
           no-op; where it does nothing (no snapped box yet, or an engine that re-snaps differently)
           it is the full prepended height, exactly as the old line intended. Same idiom, same reason,
           as the realtime feed prepend at :33117. */
        var anchor = list.firstChild;
        var aTop = (anchor && anchor.getBoundingClientRect) ? anchor.getBoundingClientRect().top : null;
        list.insertBefore(node, list.firstChild);
        if (aTop !== null) { scroller.scrollTop += (anchor.getBoundingClientRect().top - aTop); }
      }
      if (node) {
        p.unlite.push(node);
        if (window.__rovaHydrate) { window.__rovaHydrate(node); }
        fitPfeedMedia();   // idempotent per node (_pfFit / _pfClamp): this touches only what just arrived
        pfFlushStep();
        return;
      }
      if (p.unlite.length) {
        var u = p.unlite.shift();
        u.classList.remove('pf-lite');
        u.classList.remove('pf-crlite');
        fitPfeedMedia();   // the clamp measurement these cards were held back from
        pfFlushStep();
        return;
      }
      pfPark = null;
      sentinel.style.display = (cur && cur.more) ? '' : 'none';
      pfHydrateRollers();   // the flush is drained: fill in the rollers the first page shipped as shells
    } catch (e) { pfPark = null; }
  }

  /* ---- THE OTHER HALF OF THE &cr PHASE  (2026-08-17) ---------------------------------------------------
     loadMore asked for the first page with the roller on the tapped card only; this fills the shells on the
     rest. It runs when the park flush has DRAINED -- i.e. after the landing, after the chrome reveal, after
     every parked card's media is in -- and then only in idle time, at low priority. The reader can only see
     one card, and the shells it fills are on cards they have not swiped to yet.
     ROLLER-ONLY, NOT CARDS. /post-cards?crpart=1 re-enters that endpoint's existing per-id loop (Posts::byId
     + the private-post refusal + Moderation::screen) and renders views/_croller.php alone: measured 19,796
     bytes for 8 ids against 83,123 for the full cards. It adds no gate of its own, which is the point --
     a fresh endpoint for comment HTML is exactly the shape that fails open [[api-has-no-global-gates]].
     ONE PASS PER OPEN, generation-stamped: a close or a second open mid-flight must not splice a dead
     page's comments into the live list. Every failure mode is a no-op -- a shell that is never filled is a
     comment strip that reads empty, which is what it looked like a beat earlier anyway. */
  var _crHydGen = -1;
  function pfHydrateRollers() {
    if (!list || !box || !box.classList.contains('show')) return;
    if (_crHydGen === pfGen) return;
    var shells = list.querySelectorAll('.croller.cr-lazy');
    if (!shells.length) return;
    _crHydGen = pfGen;
    var ids = [], seen = {};
    Array.prototype.forEach.call(shells, function (s) {
      var id = s.getAttribute('data-post');
      if (id && !seen[id]) { seen[id] = 1; ids.push(id); }   // a repeat lap shows the same id twice; ask once
    });
    if (!ids.length) return;
    if (ids.length > 24) { ids = ids.slice(0, 24); }         // handle_post_cards caps at 24 anyway
    var gen = pfGen;
    var run = function () {
      if (gen !== pfGen || !box || !box.classList.contains('show')) return;
      rfetch('/post-cards?crpart=1&ids=' + ids.join(','), {
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        credentials: 'same-origin', cache: 'no-store', priority: 'low'
      }, 8000).then(function (r) { return r.json(); }).then(function (d) {
        if (gen !== pfGen || !list || !d || !d.html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = d.html;
        var src = {};
        Array.prototype.forEach.call(tmp.querySelectorAll('.croller'), function (c) {
          var id = c.getAttribute('data-post');
          var tr = c.querySelector('.croller-track');
          if (id && tr) { src[id] = tr; }
        });
        Array.prototype.forEach.call(list.querySelectorAll('.croller.cr-lazy'), function (s) {
          var id = s.getAttribute('data-post');
          var tr = id && src[id], dst = s.querySelector('.croller-track');
          if (!tr || !dst || dst.children.length) return;
          // CLONE, never move: two shells can share one id on a repeat lap, and moving would leave the
          // second one empty. Cloning a 5-item strip is a few hundred nodes at idle, not a cost.
          Array.prototype.forEach.call(tr.children, function (n) { dst.appendChild(n.cloneNode(true)); });
          s.classList.remove('cr-lazy');
        });
        // the avatars inside are avatar_img($defer) placeholders; the observer only knows about nodes it
        // has been shown, exactly as it is for every other fragment that arrives after load
        if (window.__rovaHydrate) { window.__rovaHydrate(list); }
      }).catch(function () {});
    };
    if (window.requestIdleCallback) { requestIdleCallback(run, { timeout: 1500 }); }
    else { setTimeout(run, 150); }
  }

  /* ---- RESUME THE BUFFER CHAIN AFTER THE FLIGHT  (2026-08-17) ------------------------------------
     The look-ahead chain below and the sentinel's IntersectionObserver are BOTH refused while hz-hold
     is set, and BOTH notes say the landing re-enters. Nothing did. pfFlushPark ends by showing the
     sentinel and hydrating rollers -- it never asks for another page -- and the observer, with only the
     warm-up page rendered, sits permanently INSIDE its own 9000px margin: it spent its one firing
     DURING the flight (where it returns early) and never crossed the edge again. So the first page was
     the last page.
     MEASURED on the shipped bundle (guest, /feed, 390x844, iPhone UA): open renders 3 cards, then eight
     swipes produce ZERO content requests and the count never leaves 3 -- the owner's "only lets me
     swipe up to 2 more posts and then it doesn't let me swipe anymore" (2026-08-17). The same run with
     __rovaNoPhase=1 reaches 12 cards at open and keeps paging (16, 21, ...), which is what isolates it
     to the phasing rather than to the pager.
     The deferred re-entry the notes promise is written here, as its own bounded poll. It waits out the
     flight AND the park flush -- chaining mid-drain would put the page the phasing moved off the
     flight straight back onto the frames the flush is placing cards in -- and then asks ONCE. One
     pending poll at a time; it drops itself if the viewer closed, the scope changed, or something else
     already owns the next page, because a successful load runs the chain itself. */
  var pfChainT = null;
  function pfChainAfterFlight(mine) {
    if (pfChainT) return;                                  // one pending re-entry at a time
    var tries = 0;
    (function again() {
      pfChainT = setTimeout(function () {
        pfChainT = null;
        if (cur !== mine || !box || !box.classList.contains('show')) return;   // closed, or another scope
        // 50 x 120ms = 6s, comfortably past pfFlushPark's own 2.4s cap, so a flight that never releases
        // still ends with the chain asking rather than with a three-card viewer.
        if (tries++ < 50 && (document.documentElement.classList.contains('hz-hold') || pfPark)) { again(); return; }
        if (cur.loading || !cur.more || cur.looping) return;
        loadMore();
      }, 120);
    })();
  }

  function loadMore() {
    if (!cur || cur.loading) return Promise.resolve();
    if (cur.looping) return loopMore();
    if (!cur.more) return Promise.resolve();
    // #634: cur is repointed IN PLACE when repeat is armed or cleared, so `cur !== mine` below cannot
    // see a scope change -- this generation can. A page fetched under the old scope must not append
    // under the new one, and must not clear the loading flag its successor now owns (see rpBump).
    var mine = cur, mineRp = cur.rpGen, url, batch;
    if (cur.mode === 'feed') {
      // First fetch of a session stays tiny (3) so the tapped post's media starts loading and playing as
      // fast as possible instead of waiting on a big HTML response (and everything IT drags in) before
      // anything shows. After that, load in SMALL pages (6) -- the SAME size the profile-feed pfeed uses,
      // which stays buttery on iPhone. A big 24-post batch overshot the look-ahead buffer to ~35 rendered
      // posts of media at once, and that pile-up (decoded photos + HLS buffers) is what made ONLY the home
      // feed grid choppy while profiles were smooth. Six keeps a tight rolling cache: the buffer-ahead
      // chain + the sentinel top it up just past the fold, and round-72's recycle/prune trims behind, so
      // the live set stays small no matter how far you scroll.
      // 8 per fetch on capable devices (was 6): a fast fling that outruns the 9000px buffer then
      // serializes round-trips, and each extra trip is ~300ms of "slow to load" on mobile. Media
      // stays bounded by the +/-2 recycle either way, so the bigger page is bare HTML, not bitmaps;
      // low-RAM phones keep 6.
      batch = cur.ids.slice(cur.idx, cur.idx + (cur.warmed ? (_lowRAM ? 6 : 8) : 3));
      // top up the underlying id POOL well before it's drained -- a fast swiper can burn through a
      // batch in seconds, faster than a fetch (+ tier cascade) round-trip, so refill it in the
      // background instead of waiting for batch.length to hit zero and the swipe to stall
      if (cur.feed && !cur.feedLoading && (cur.ids.length - cur.idx) < 48) { loadMoreFeedIds(); }
      if (cur.ring) { ringTopUp(); }   // the ring's continuation: ask for the next page while RING_AHEAD ids remain
      if (!batch.length) {
        // exhausted the current ids: pull the next feed page, then keep going (infinite scroll)
        if (cur.ring) { return ringDrain(); }              // the ring: continuation page, or the end card -- never the loop
        if (cur.feed && cur.feedLoading) {
          // A fresh-ids pull is ALREADY in flight -- the low-water top-up fires on the very first page
          // whenever the viewer opens with a tiny id list (a PERMALINK has exactly one). Treating
          // "busy" as "dry" here fell through to startLoop, which with one id rendered the SAME post
          // forever (owner report: /p/376 repeated down the whole pfeed). Wait a beat and re-enter.
          var mineW = cur;
          return new Promise(function (res) { setTimeout(res, 250); })
            .then(function () { if (cur === mineW) { return loadMore(); } });
        }
        if (cur.feed) {
          return loadMoreFeedIds().then(function (got) {
            if (cur !== mine) return;
            if (got) { cur.more = true; return loadMore(); }
            return startLoop();                        // network dry -> loop what we've got, forever
          });
        }
        return startLoop();                            // no live feed source (profile/permalink) -> loop
      }
    }
    /* ---- &cr: THE FIRST PAGE'S COMMENT ROLLERS, FOR THE TAPPED CARD ONLY  (2026-08-17, measured) ----
       MEASURED on a live /post-cards batch of 8 cards at 390x844 as a guest: 83,123 bytes, of which the
       eight rollers are 21,618 (26%), carrying 2,196 of the page's 4,019 text characters -- 55% of every
       glyph. `tmp.innerHTML = d.html` below was 117ms for 64.6KB, and it is the ONE cost .pf-crlite could
       not touch: display:none defers shaping, never parsing. Verified over HTTP: the same batch with
       &cr=<one id> is 69,039 bytes (-17%), 7 shells + 1 real roller.
       FIRST PAGE ONLY, which is what !cur.positioned means -- the target is still being sought, so this is
       the page the tap is blocked on. Every later page arrives OFF SCREEN, where a roller now costs nothing
       at all (content-visibility), so trimming those would buy nothing and cost a hydration round trip.
       THE SHELL IS THE SAME BOX (see views/_croller.php): .croller-track is a fixed height:24px with every
       item position:absolute inside it, so filling it later cannot move the caption above it by a pixel. */
    var crQ = (!cur.positioned && cur.targetId) ? ('&cr=' + encodeURIComponent(cur.targetId)) : '';
    if (cur.mode === 'feed') {
      url = '/post-cards?ids=' + batch.join(',') + crQ;
    } else {
      url = '/profile-feed?user=' + encodeURIComponent(cur.user) + '&tab=' + encodeURIComponent(cur.tab) + '&offset=' + cur.offset + (cur.rec ? '&rec=1' : '') + crQ;
    }
    // NETWORK OFF THE TAP PATH (round 129b): serve this page from what's already on the device when we can --
    // the idle cardCache (home grid, per id) or the pointerdown prefetch (profile, exact-URL promise). Either
    // way the .then() below runs unchanged; it just doesn't wait on a round-trip first.
    var ready = null;
    if (cur.mode === 'feed') {
      var ch = cachedBatch(batch);
      if (ch !== null) { ready = Promise.resolve({ html: ch }); }
    } else if (pfPre && pfPre.url === url && Date.now() - pfPre.at < 10000) {
      ready = pfPre.p; pfPre = null;
    }
    /* ...AND A LOCAL HIT MUST NOT LAND IN THE TAP'S OWN TASK (2026-08-17, measured). A resolved promise's
       .then runs in the microtask checkpoint AT THE END OF THE CURRENT TASK, so on a cache/prefetch hit
       -- the common case, and the whole point of the two caches above -- the append below executed inside
       the click handler's task. Traced: a 452ms tap task became 740-768ms, one unbroken block of tap
       handler + HTML parse + first-card layout, and NOTHING was painted for its whole length. The hero is
       already built and positioned by heroExpand inside that task, so ending the task is what puts the
       first frame of the open on screen. One rAF hop does that and costs nothing real: the card still
       cannot be laid out before the next frame either way. */
    if (ready) {
      ready = ready.then(function (d) {
        return new Promise(function (res) {
          if (window.requestAnimationFrame) { requestAnimationFrame(function () { res(d); }); }
          else { setTimeout(function () { res(d); }, 0); }
        });
      });
    }
    cur.loading = true;
    sentinel.classList.add('on');
    // rfetch: r.json() on a Cloudflare 5xx HTML page throws anyway, so the .catch at the end already
    // caught THAT -- but only by accident, and only after the parse. Rejecting on status is explicit, and
    // the deadline is the real gain: cur.loading is cleared only when this settles, and while it is set
    // every sentinel hit, every swipe-driven top-up and loadBefore() are refused. That is exactly the
    // "swipe up and the viewer just stops" shape, for as long as the platform holds a dead socket open.
    /* priority:'high' (2026-08-12). Every speculative prefetcher on this surface already declares
       itself LOW -- the 600% photo byte-warm, the 1MB video head-start, the display-variant pump --
       and this, the one request the reader is genuinely BLOCKED on, declared nothing, so it queued
       as an ordinary fetch alongside them. MEASURED on a 20-post fling at 1.6Mbps/300ms: 263
       requests inside a 20-second burst, ~73% of them media for posts already flown past, and the
       viewer dead-ended with six posts rendered and the scroller pinned at its floor for twenty
       seconds while the next page of cards waited its turn. This page is what UNBLOCKS the swipe;
       it is a few KB of JSON against megabytes of speculation, and it should go first.
       A hint, not a guarantee -- unsupported browsers ignore the key and behave exactly as before,
       which is why it is safe to state unconditionally. */
    return (ready || rfetch(url, {
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', cache: 'no-store', priority: 'high'
    }, 8000).then(function (r) { return r.json(); }).then(function (d) {
      /* ...BUT NEVER CACHE A PHASED PAGE. crQ means this response carries roller SHELLS, and the cache is
         read back by loadBefore and by later loadMore batches, where nothing would ever hydrate them --
         a card restored from cache would keep an empty comment strip for the rest of the session. The
         phase is a property of THIS request, not of the cards. */
      if (d && d.html && mine.mode === 'feed' && !crQ) { cacheCards(d.html); }   // every real fetch feeds the cache
      return d;
    })).then(function (d) {
      if (cur !== mine) return;   // overlay was closed / reopened mid-flight
      if (cur.rpGen !== mineRp) return;   // #634: repeat was armed/cleared under this page -- orphan it
      cur.loading = false;
      pfFailStep = 0;                     // the link is answering again: reset the re-arm ladder
      sentinel.classList.remove('on');
      var added = 0;
      if (d && d.html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = d.html;
        pfNoPip(tmp);   // BEFORE the clips are bound into the document -- see the note on pfNoPip
        // DEDUP (profile mode): a post already shown -- classically the profile's OWN posts resurfacing once
        // the viewer switches to the engagement rec-roll -- must not reappear, or the feed reads as "looping
        // the same few". Feed mode already pages a de-duplicated id-list, so it needs none of this.
        if (cur.mode !== 'feed') {
          if (!cur.seen) { cur.seen = {}; Array.prototype.forEach.call(list.querySelectorAll('.post[data-view],.post[data-id]'), function (p) { var s0 = p.getAttribute('data-view') || p.getAttribute('data-id'); if (s0) cur.seen[s0] = 1; }); }
          Array.prototype.slice.call(tmp.children).forEach(function (elp) {
            var sid = elp.getAttribute && (elp.getAttribute('data-view') || elp.getAttribute('data-id'));
            if (sid && cur.seen[sid]) { if (elp.parentNode) elp.parentNode.removeChild(elp); }   // drop the dup
            else if (sid) { cur.seen[sid] = 1; }
          });
        }
        added = tmp.children.length;
        /* ---- THE FIRST PAGE IS PHASED AROUND THE HERO FLIGHT (2026-08-17, measured) --------------
           MEASURED, on the live grid at 390x844 with 4x CPU throttling (tools\vopen-perf.js):
           appending a whole page here cost ONE 2458ms main-thread task -- 1039ms RecalcStyle + 762ms
           Layout over the ~15 <video> elements a profile page carries -- and it landed squarely inside
           the 340ms flight. Tap to first visible hero motion was 3819ms; 6 of the 7 frames rendered in
           the whole open were dropped; the worst single gap was 2804ms. THAT is the "noticeable hang".
           The tween itself was never the problem. It is transform-only and it flies against
           pfeedLandRect's PREDICTION, which reads the pfeed shell and nothing else -- it does not need a
           card to exist. The flight was simply starved of the main thread by work that belongs after it.
           So only the TARGET card goes in now. Everything the landing depends on is satisfied by that
           one card: landingRect() looks for the box under the viewport centre (with one card it is the
           only candidate, and phase A's fitPfeedMedia has already stamped its _pfFitDone), pfResume()
           polls for the target by id, and every rova:pfeedready listener keys off the target or
           currentPost(). The rest is parked in a DETACHED fragment -- costing no style, no layout and no
           decode -- and flushed when hz-hold clears. That is not a new mechanism: it is the same gate,
           with the same 240ms re-try, that loadBefore() has always used to keep itself out of a flight.
           ORDER SURVIVES THE PARK. Profile opens start ~3 posts above the target (see `off` in the
           opener), so the page usually has cards on BOTH sides of it. Those before it are prepended on
           flush with loadBefore()'s own scrollHeight-delta anchor so the target does not visually move;
           those after it are appended, which cannot shift anything above them. */
        /* __rovaNoPhase: a runtime kill switch for the phasing, so a harness (or a bug report) can A/B it
           on the SHIPPED bundle without a rebuild, and so one regression here never requires reverting
           the whole open. Off means "behave exactly as the un-phased build did". */
        var tgtEl = (!window.__rovaNoPhase && document.documentElement.classList.contains('hz-hold') && !cur.positioned && cur.targetId)
          ? tmp.querySelector('.post[data-view="' + cur.targetId + '"]') : null;
        if (tgtEl && tmp.children.length > 1) {
          var pre = [], post = [], seenTgt = false;
          Array.prototype.slice.call(tmp.children).forEach(function (n) {
            if (n === tgtEl) { seenTgt = true; return; }
            (seenTgt ? post : pre).push(n);
          });
          /* ...AND THE ONE CARD THAT DOES GO IN ARRIVES WITHOUT ITS CHROME (2026-08-17, measured).
             Parking the other cards took the page's cost out of the flight, but the target's own
             insertion was still a 958ms task, and a trace named it: 510ms of style+layout over 125
             dirty objects, 459ms of that inside InlineNode::ShapeTextIncludingFirstLine. It is TEXT
             SHAPING, and none of the text is the flight's: the flight needs this card's .media box
             and nothing else. .pf-lite (rova.css) display:none's the caption, the engagement row, the
             translate affordance and the five-comment roller for the length of the flight; A/B on the
             live grid, same tap, same throttle: 958ms -> 582ms on the insert task.
             GEOMETRY CANNOT MOVE, which is what makes this safe next to the landing prediction:
             .pfeed .post .media is position:absolute;inset:0 against .post-main, so the hidden nodes
             are flex siblings that never contributed to the media's box in the first place. The
             flush's first step removes the class and re-runs the fit, which is also when the caption
             clamp gets its measurement (see the .pf-lite guard in fitPfeedMedia -- a display:none
             caption measures zero and would latch "no clamp needed" forever). */
          tgtEl.classList.add('pf-lite');
          tgtEl.classList.add('pf-crlite');
          /* ...AND IT IS THE ONE CARD CONTAINMENT MAY NOT SKIP. Every OTHER card of this page is going to
             be inserted off screen under content-visibility:auto and cost nothing (rova.css, and pfCvOn);
             this one is on screen, is what the hero is flying at, and is what pfCenteredMedia gates the
             pump on -- and cv:auto resolves relevance during the rendering update, so a freshly inserted
             on-screen card can be SKIPPED for its first frame. Stamped here rather than left to the first
             recyclePfeedMedia pass because that pass is 260ms away and the pump is not. */
          tgtEl.classList.add('pf-cvon');
          /* The parked cards go in lite TOO (pfFlushPark un-lites them one per frame, after every
             card's media is in): the reader cannot see them yet, so their text is the last thing that
             should be competing for the main thread with the cards they are behind. */
          pre.concat(post).forEach(function (n) { n.classList.add('pf-lite'); n.classList.add('pf-crlite'); });
          list.appendChild(tgtEl);
          pfParkRest(pre, post, tgtEl);
        } else {
          while (tmp.firstChild) list.appendChild(tmp.firstChild);
          /* The un-phased path (a single-card page -- a permalink -- or __rovaNoPhase). Same reason as the
             stamp above: whichever card the flight is aiming at must not be containment-skipped for its
             first frame. Here there is no `pre`/`post` split to hang it off, so ask for the target by id;
             it is a no-op when this page does not contain it (a later page, a loop lap). */
          /* ...WHILE THE TARGET IS STILL BEING SOUGHT, AND NOT AFTER (2026-08-17). This is an ADD, not
             pfCvOn's exclusive toggle, so on a LATER page it stamps a SECOND exemption: the reader's
             card already moved on (recyclePfeedMedia toggles the exemption onto whatever is centred),
             and this put the old target back. Harmless until the loader could actually deliver a page
             while the reader sat still -- which is exactly what fixing the dead-end restored -- and
             then tools\pfeed-contain-check.js caught it: 2 exempt cards, the stale one two screens
             back, which also mis-aimed that harness's menu hit-test at an off-screen card. `positioned`
             is the flight's own signal and it is false for exactly the page this stamp is written for. */
          if (cur.targetId && !cur.positioned) {
            var t0 = list.querySelector('.post[data-view="' + cur.targetId + '"]');
            if (t0) { t0.classList.add('pf-cvon'); }
          }
        }
        if (cur.mode === 'feed') { cur.idx += batch.length; cur.warmed = true; }
        if (window.__rovaHydrate) window.__rovaHydrate(list);
        fitPfeedMedia();
        /* THE DRIFT ARMS HERE, NOT 260ms LATER (2026-09-30). The target card's pf-cvon above is a direct
           stamp, not pfCvOn, so nothing told the drift the active page existed until the first
           recyclePfeedMedia pass -- that pass, not the flight, was the 0.2-0.3s of slop in "0.4s after
           landing". kbSync now sees the card at insertion: no flight -> the hold starts now; a flight in
           the air -> it waits on the class release (kbWatch) and starts at the landing. Idempotent. */
        kbSync();
      }
      if (cur.mode === 'feed') {
        // keep the sentinel live so more pages pull in; a ring is never "dry" until it has ENDED (its next
        // /ring-next page may still be in flight -- 2026-10-09, see THE MEDIA RING'S CONTINUATION)
        cur.more = cur.idx < cur.ids.length || !!cur.feed || !!(cur.ring && !cur.ringEnded);
        updateFeedBar();
      } else {
        // advance by the RAW rows the server consumed (d.count), NOT the rendered count -- a screened-out or
        // de-duplicated post must still be STEPPED OVER, else the next page re-fetches it (the overlap that
        // fed the loop) or, for a fully-screened page, the offset never moves at all.
        cur.offset += (d && typeof d.count === 'number' ? d.count : added);
        // #634: what THIS lap has rendered so far. rpWrap reads it to tell a healthy lap from a
        // scope that has genuinely nothing left, without counting its own no-op calls as failures.
        if (cur.rpUser && added > 0) { cur.rpLapAdd = (cur.rpLapAdd || 0) + added; cur.rpDry = 0; }
        if (d && d.author && !cur.authorSet) { var av = box.querySelector('.pfeed-av'); if (av) { av.innerHTML = d.author.avatar || ''; } pfSetBarTick(d.author.tick || ''); cur.authorSet = true; }
        cur.more = !!(d && d.more);
      }
      sentinel.style.display = cur.more ? '' : 'none';
      if (!list.children.length) { list.innerHTML = '<div class="pfeed-empty">Nothing here yet.</div>'; }
      // seek: keep pulling pages from the top until the tapped post is in view, then land
      // on it - so the whole set is swipeable both directions.
      if (!cur.positioned && cur.targetId) {
        var t = list.querySelector('.post[data-view="' + cur.targetId + '"]');
        if (t) {
          cur.positioned = true;
          try { document.dispatchEvent(new CustomEvent('rova:pfeedready')); } catch (e) {}   // release the hero-zoom mask
          pfChromeIn();   // an un-parked target is laid out already: under a flight in the viewer, the chrome comes now
          try { t.scrollIntoView({ block: 'start' }); } catch (e) {}
          /* Land the carousel on the exact media that was tapped (e.g. the photo, not the video slide).
             UNCONDITIONAL, AND THAT IS THE FIX -- not a tidy-up (owner 2026-08-14: "a carousel whose
             slide 1 is a video opens MUTED; slide 2 is fine").
             targetSlide is stored as `slideIdx > 0 ? slideIdx : 0` (see the two cur = {...} literals),
             so THE ENTRY SLIDE IS 0, which is FALSY, and this whole block was skipped for it. Everything
             the sound depends on hangs off that call: __cgo -> go() -> slideMedia() -> __rovaPlayNow +
             handSound(), and handSound is the only path that hands a carousel slide the sound WITH the
             WebKit stop-repair behind the unmute. Nothing else covers the entry slide: the immediate
             play kick below queries `.media:not(.carousel) video` (single-video posts only, on purpose),
             and initCarousel's own play observer is gated `!carInPfeed`. So slide 1's audio was left to
             whatever ambient applySound() pass happened to run -- and one that runs before the track has
             been laid out resolves activeVideo() to null (a zero-width rect is rejected), engine-mutes
             every clip, and NOTHING IS SCHEDULED TO RE-ASK. Slide 2 always worked because reaching it is
             itself a go().
             __cgo(0) is a visual no-op on an already-landed track: go()'s rewind is gated on
             `idx !== _was`, the transform is already translateX(0), and __cgo suppresses the transition
             for the duration either way. It is _navSilent, so it arms no attention hold, and slideMedia()
             is idempotent (__rovaPlayNow no-ops on a clip already running, engineMute skips no-op sets).
             What it costs is the same 7s auto-advance courtesy every OTHER landing already pays -- which
             is the point: the entry slide now sits on exactly the authority path as every other slide. */
          var car = t.querySelector('.carousel');
          if (car && car.__cgo) { car.__cgo(cur.targetSlide || 0); }
          // ARM THE OPENED POST'S SLIDESHOW. recyclePfeedMedia(settled) is what starts the current post's
          // carousel -- its own comment says "opened or swiped to" -- but the only thing that ever calls it
          // with settled=true is the scroller's 220ms trailing scroll handler. A permalink open (/p/<id>)
          // lands the target at scrollTop 0, so the scrollIntoView above moves nothing, no scroll event
          // fires, no settle runs, and the post that was OPENED never starts its show: on a multi-media post
          // that means no slide advance and no photo Ken Burns at all until the reader happens to swipe.
          // Measured on /p/12714 and /p/12732: __cplaying stayed false for 30s after the open. One settle
          // pass here; it is the same idempotent call the scroll path makes (__cplay no-ops if already on).
          setTimeout(function () { if (box && box.classList.contains('show')) { recyclePfeedMedia(true); } }, 260);
          /* BACKSTOP for the roller phase. pfFlushPark's drain is the normal trigger, but the un-phased
             append (a permalink, or __rovaNoPhase) never parks anything and would leave the shells empty.
             Idempotent and generation-stamped -- it no-ops when there is nothing to fill. */
          setTimeout(pfHydrateRollers, 900);
          // ADOPT the grid's live preview <video> (round 129): same mp4, already buffered and playing at the
          // tapped frame. Swapping the ELEMENT in -- buffers, decoder, position and all -- starts the clip
          // instantly, with no re-download and no seek-to-resume. The fresh <video> in this card hasn't been
          // wired yet (the wiring MutationObserver delivers after this task), so the donor inserted here is
          // what gets wired: controls, playIO/warmIO, sound. _instant keeps warmIO's load() from resetting it.
          var don = window.__rovaGridDonor; window.__rovaGridDonor = null;
          /* ═══ THE readyState GATE IS ABOUT A GRID TILE, AND A LIFT MASTER IS NOT ONE ═══════════
             (2026-08-17.) `readyState >= 2` is the right question for the round-129 donor: that
             element is the GRID's preview, "already buffered and playing at the tapped frame", and a
             cold one would be a worse clip than the card's own -- so a cold donor is correctly
             refused. The lift-off master inverts every clause of that. It is the SAME file the card
             would render, it is already fetching (it was created and played inside the tap), it is
             the element the member is already hearing, and the card's own <video> is `preload="none"`
             whenever it has a poster + dimensions -- so refusing it does not fall back to a better
             clip, it falls back to a SECOND clip on the same file, which is the CD-skip shape.
             MEASURED, and this is why the clause exists rather than being tidy: at 4x CPU on a 27 MB
             master the lift element reaches readyState 1 at ~1.9s and 2 at ~2.2s, while the card
             lands at ~0.7s. The gate was therefore refusing the adoption on EVERY throttled open,
             the anti-double-voice watchdog was retiring the master 3.6s later, and the whole round
             silently degraded to the old path -- with the receipt (`why:noadopt`) as the only sign.
             Bypassed ONLY for an element the lift itself built and still owns; every other donor
             keeps the gate to the character. */
          var donLift = !!(don && don.v && window.__rovaBoomIsMaster && window.__rovaBoomIsMaster(don.v));
          if (don && don.v && String(don.id) === String(cur.targetId)
              && (donLift || don.v.readyState >= 2) && (Date.now() - don.at) < 15000) {
            var fv0 = t.querySelector('.media:not(.carousel) video'), same = false;
            if (fv0 && fv0 !== don.v) {
              try {   // adopt ONLY when both point at the same mp4 (they do: media_url($path) both sides)
                var donHref = new URL(don.v.dataset.grSrc || don.v.getAttribute('src') || '', location.href).href;
                same = new URL(fv0.getAttribute('src') || '', location.href).href === donHref
                    /* FEED 720: pfFullSrc pointed this viewer card at Cloudflare's full file and kept the feed copy in
                       data-src-feed -- the very file the grid's lift-off master (data-master) is playing. Same clip,
                       same timeline, so the lift element is adopted (the warm start) rather than retired. */
                    || (!!fv0.getAttribute('data-src-feed') && new URL(fv0.getAttribute('data-src-feed'), location.href).href === donHref);
              } catch (e) {}
            }
            if (same) {
              var dv = don.v;
              dv._instant = 1;                              // warmIO/attachHls: hands off the live mp4
              dv.className = fv0.className;                 // pfeed styling; drops the grid's .pcell-video
              dv.style.cssText = '';                        // clear the grid overlay's absolute/opacity inline styles
              // DROP the grid's reveal-on-play listeners (ensureVideo): they set inline opacity 1 the moment
              // dv.play() below fires 'playing', which OVERRODE the html.hz-hold hero-flight hide and showed
              // the full clip behind the still (the /p/1174 report). heroZoom's fade() is now the single owner
              // of this clip's opacity -- it stays hidden by hz-hold through the flight and is revealed only at
              // the coordinated handoff (still landed + rova:pfresumed). Nothing else touches its opacity.
              if (dv._grReveal) {
                dv.removeEventListener('loadeddata', dv._grReveal);
                dv.removeEventListener('playing', dv._grReveal);
                dv._grReveal = null;
              }
              // data-hls-lo rides along (2026-07-29). This is the GRID-TAP -> viewer donor path, i.e. the
              // main way media gets opened at all, and it copied data-hls while silently dropping its
              // slow-line twin -- so every clip opened from the grid permanently lost the _lo master and
              // attachHls fell back to the sharp one no matter how bad the line was. It is emitted
              // (views/_post.php:267) and read (attachHls) but was never carried across a handoff.
              // 166 of 241 masters (69%) open on a rung needing >2Mbps against a 1.6Mbps slow threshold.
              ['poster', 'width', 'height', 'data-hls', 'data-hls-lo', 'data-noaudio', 'controls'].forEach(function (a) {
                if (fv0.hasAttribute(a)) { dv.setAttribute(a, fv0.getAttribute(a)); }
              });
              dv.loop = true;
              fv0.parentNode.replaceChild(dv, fv0);
              // Same rule as the hero handoff: fv0 is DETACHED now, and a detached <video> keeps playing
              // where nothing in the DOM-querying stop paths can ever reach it again (see
              // __rovaStopOrphanMedia). Retire it explicitly rather than trusting it to have been idle.
              if (window.__rovaRetireVideo) { try { window.__rovaRetireVideo(fv0); } catch (e) {} }
              // Land the donor on the SAME frame the hero froze on. The donor kept PLAYING through the loadMore
              // fetch, so it drifted PAST cur.resumeTime (the gridT the hero JPEG was captured at); resuming as-is
              // snapped the still hero FORWARD to the drifted frame (the video "frame jump"). Seek it back to
              // resumeTime BEFORE play(), so whenever pfSignalResumed releases the hero the donor is already on
              // the hero's exact frame. The backward seek is invisible (hz-hold hides the donor until then), and
              // the buffer is loaded so it's instant. Guard the loop wrap like pfResume (near the end -> 0).
              /* ...AND SINCE 2026-08-16 THAT FRAME IS 0 (see __rovaOpenRestart at the grid tap).
                 Everything the paragraph above says about WHY the seek happens here still holds
                 exactly -- it happens BEFORE play(), behind hz-hold, on a buffered clip, so it is
                 invisible and instant, and pfSignalResumed below still releases the hero only once
                 the donor is sitting on the frame the viewer is about to show. The one thing that
                 moved is the target: the tile's drifted position was the right answer while the
                 rule was "continue where the thumbnail is", and it is the wrong answer now that the
                 rule is "start the clip". Note the ordering that makes this safe: the rewind is
                 applied, THEN play(), THEN pfSignalResumed -- so the hero cannot lift off a frame
                 the clip is not on, which is the same "the cover must not retire before the clock
                 is at the target" rule the app half enforces with its poster. */
              var rstOpen = window.__rovaOpenRestart;
              var rstMine = !!(rstOpen && String(rstOpen.id) === String(cur.targetId)
                               /* 8s, not the donor's 15s: this arm has to outlive the slowest
                                  path that reads it (pfResume's grid-tap retry budget, 25 x 140ms
                                  = 3.5s) and NOTHING more. Every extra second is a window in which
                                  a deliberate resume of the SAME post -- its timeline fullscreen
                                  button -- could match this id and be restarted against its will. */
                               && (Date.now() - rstOpen.at) < 8000);
              /* ═══ THE LIFT-OFF MASTER IS NOT SEEKED, AND IT IS NOT A DONOR TILE (2026-08-17) ══
                 On a boomerang open this donor is not the grid's preview element at all -- it is
                 the MASTER, built in the tap handler, started at the mapped forward frame, unmuted
                 and AUDIBLE since lift-off (see __rovaBoomLift). Everything the paragraphs above
                 arrange is therefore already true of it, arranged better: it did not "drift PAST
                 cur.resumeTime through the loadMore fetch", it ADVANCED on its own timeline exactly
                 as playback does, which is what the transition compensation elsewhere in this file
                 is trying to approximate. Applying `rt` here would rewind the clip by the whole
                 length of the open -- an audible restart on a clip the member is already listening
                 to, and the end of the forward lock the invisible dissolve depends on. So the seek
                 is skipped and ONLY the seek: the play() below, the resume signal, the attribute
                 copy and the retire above all still run, because those are about the element being
                 the card's clip and it is.
                 CLAIMED, not merely detected: __rovaBoomAdopted marks the record so the lift's
                 anti-double-voice watchdog stands down (an unclaimed master is retired rather than
                 left to become a second voice on the same file). */
              var bAdopt = window.__rovaBoomAdopted ? window.__rovaBoomAdopted(dv) : null;
              if (cur.resumeId && !bAdopt) {
                var rt = rstMine ? 0 : (cur.resumeTime || 0), dur = dv.duration || 0;
                if (dur && rt >= dur - 0.3) { rt = 0; }
                if (rstMine) {
                  if ((dv.currentTime || 0) > 0.08) { try { dv.currentTime = 0; } catch (e) {} }
                } else if (rt > 0.02 && Math.abs((dv.currentTime || 0) - rt) > 0.08) {
                  try { dv.currentTime = rt; } catch (e) {}
                }
              }
              // the rova:pfeedready dispatch above just PAUSED all grid previews (donor included) -- resume it
              var dp = dv.play(); if (dp && dp.catch) { dp.catch(function () {}); }
              if (cur.resumeId) {
                cur.resumeId = ''; cur.resumeTime = 0;
                pfSignalResumed(dv);                        // release the hero hold once the donor is on that frame
              }
            }
          }
          /* ═══ AN UNCLAIMED MASTER LOSES THE VOICE HERE, NOT AT THE FADE ════════════════════════
             (2026-09-01, the second half of "I hear two audio tracks at times".)

             This block is the ONLY place the lift's master can be claimed, so falling out of it
             without a claim is the moment it becomes provably certain that this open will have TWO
             elements on one file: the body-level master, unmuted since lift-off, and the card's own
             clip, which pfSound/applySound is about to make audible. Everything after this point --
             the drift lock, the calm floor, the crossfade -- is the DISSOLVE's business and takes
             1.5-3s, and the master stayed audible for all of it. MEASURED on the live site in
             Chrome after the boomReleaseMaster fix: the ghost no longer survives the open, but posts
             48502 / 48357 / 47743 still held two unmuted playing copies for 894-1057ms each, from
             ~1.8s after the tap until the fade collected the master.

             Why the fall-through happens at all, and why it is not rare: the claim requires
             `t.querySelector('.media:not(.carousel) video')` to find the card's clip, and a GALLERY
             post renders as `.media.carousel`, so it finds nothing and `same` stays false. On the
             owner's own grid that is 3 of the first 7 video tiles.

             MUTE, DO NOT RETIRE. The dissolve still needs this element PLAYING -- boomDecoding()
             gates on `!paused`, and boomTake aligns the boom to the master's clock -- so pausing it
             here would collapse the handoff to `nolock`/`nodecode` and put back the visible frame
             jump that whole round exists to remove. Muting costs the dissolve nothing: not one of
             its four conditions reads volume.
             AND IT COSTS THE READER NOTHING EITHER. The master's voice only ever bought the ~1.1s
             between lift-off and the card's own clip becoming audible, and it could only KEEP that
             voice by becoming the card's clip. Unclaimed, it cannot -- so silencing it here lands
             this open on exactly the sound timing a grid open had before the boomerang round
             existed (pfSoundSoon on the card's clip), which is not a regression against anything.
             Stamped through __rovaEngineMute for the usual reason: a bare `muted = true` is read by
             the volumechange handler as the READER muting, which writes rova_sound=0 and silences
             the whole site until they find the control again. */
          if (donLift && don && don.v && window.__rovaBoomIsMaster && window.__rovaBoomIsMaster(don.v)
              && !(don.v._boomLift && don.v._boomLift.adopted) && !don.v.muted) {
            if (window.__rovaEngineMute) { window.__rovaEngineMute(don.v, true); }
            else { don.v._engineSetAt = Date.now(); don.v.muted = true; }
          }
          // Start the tapped clip playing IMMEDIATELY -- don't wait for playIO's async observer (which
          // fires a frame or two out, then attachHls's fetch adds more). Kicking it here means the video
          // is already running as the open scale-in settles, instead of showing the cover-scaled poster
          // (the "zoomed thumbnail") through the whole animation. Skipped when resuming a specific time
          // (fullscreen-button open) so pfResume can seek first without a visible 0 -> resumeTime jump.
          if (!cur.resumeId && window.__rovaPlayNow) {
            var tv0 = t.querySelector('.media:not(.carousel) video');   // single-video post (or the adopted donor)
            if (tv0) { window.__rovaPlayNow(tv0); }
          }
          updateFeedBar();
          // We opened MID-feed on the tapped item, so the media ABOVE it isn't loaded yet -- the tapped
          // clip sits at scrollTop 0. Pull the earlier items in NOW (loadBefore shifts scrollTop to keep
          // the current clip put) so a swipe-DOWN scrolls smoothly up to the previous media instead of
          // sitting at 0, which the pull-to-dismiss reads as "top of feed" and dismisses the viewer.
          loadBefore();
        }
        else if (cur.more && (cur.mode === 'feed' || cur.offset < 400)) { return loadMore(); }
      }
      // Keep the render buffer ahead of the reader. The sentinel's IntersectionObserver (9000px
      // margin, below) only re-fires when the sentinel CROSSES that margin edge -- a small warm-up
      // batch (3) leaves the sentinel permanently INSIDE the margin, so it fires exactly once at open
      // and never again, dead-ending the viewer at the first batch (the bug this fixes). So don't rely
      // on the observer to continue: keep loading until there's a full margin's worth of media buffered
      // below the fold, which both fills the look-ahead AND pushes the sentinel back out to the edge so
      // the observer re-arms for later scroll-driven loads. Gated on added>0 so a dry/empty page can't
      // spin this (it falls through to the pool top-up / loop instead), and only once we've landed on
      // the tapped post (seek does its own chaining above).
      /* NOT WHILE A HERO IS FLYING. This chain exists to deepen the look-ahead buffer, which means
         fetching AND rendering more pages -- and with the first page now phased around the flight
         (see the append), letting the buffer chain run here would simply put the work it was moved
         out of straight back into the same 340ms. Nothing is lost by waiting: pfFlushPark() re-enters
         on the landing, and the sentinel's own observer picks up from there.
         MEASURED as the bigger half of the win: this gate alone is what stops page 2 landing in the
         middle of the flight, and it is what took the worst single main-thread task from 2406ms to
         960ms. It is under the same __rovaNoPhase switch as the append so the whole open reverts as
         one thing. */
      // ...AND IT IS DEFERRED, NEVER DROPPED: pfChainAfterFlight re-enters once the flight has landed
      // and the parked remainder is in. Without it this branch was the end of the feed (see its note).
      var pfFlying = !window.__rovaNoPhase && document.documentElement.classList.contains('hz-hold');
      if (pfFlying && cur.more && !cur.looping && (cur.positioned || !cur.targetId)) { pfChainAfterFlight(mine); }
      if (cur.more && !cur.looping && (cur.positioned || !cur.targetId) && !pfFlying) {
        // Normal: top the buffer up when it's low. PLUS (profile mode only): if a page rendered NOTHING (all
        // screened out / all duplicates) step to the next page anyway -- profile mode already advanced its
        // offset past them (by d.count), so an empty page must not stall the scroll or trip the "exhausted ->
        // loop" branch below; it's bounded, walking to real content or the true end. Feed mode advances cur.idx
        // ONLY when html arrives, so it must NOT auto-retry an empty batch (that would refetch the same ids forever).
        var ahead = scroller.scrollHeight - scroller.scrollTop - scroller.clientHeight;
        /* ...BUT NOT PAST WHAT NOTHING WILL TRIM (2026-08-12). The 9000px target assumes the other
           half of the design is running: pruneFarPosts trimming the cards behind the reader. On a
           PROFILE/grid-opened viewer it is not -- pruneFarPosts returns on its second line for any
           scope that is neither `feed` nor a repeat, because loadBefore (the thing that puts pruned
           cards back on a swipe-up) is feed-only, so trimming there would lose history for good.
           That gate was harmless while the loader could not keep up. Once it could, it stopped being
           harmless: MEASURED on a fixed 12-post fling, the same burst that used to leave 18 posts
           rendered now left 30, and live <video> elements went 38 -> 67, with post-burst main-thread
           block time up with them. Unbounded on the exact surface the owner reported, and 67 clips
           is the iOS tab-kill this viewer has been pulled back from twice already.
           So the buffer stops chaining once the list is big enough that the reader has ~2 screens of
           slack in hand. NOTHING IS LOST AND NOTHING DEAD-ENDS: cur.more is untouched, the sentinel
           stays live, and the next scroll re-enters this same loader -- the pages arrive as they are
           approached instead of all at once. The cap is on the CHAIN, not on the feed.
           Feed and repeat scopes are excluded because pruneFarPosts DOES run for them; they keep the
           full 9000px look-ahead they were tuned with. The right long-term answer for profile scopes
           is to give them a loadBefore so they can be pruned like the feed -- that is a behaviour
           change (how far back a swipe-up can reach) and wants the owner, so it is written down here
           rather than taken quietly. */
        var prunes = (cur.mode === 'feed' || cur.rpUser);
        /* 18, NOT 24. Measured: at 24 the chain still ran one more 6-card page and landed at 30 --
           the ceiling has to sit a page BELOW where the list is allowed to end up. 18 holds the
           rendered set at the size the control arm reached on its own, so the fixes above buy the
           reader a loader that keeps up WITHOUT buying them a bigger DOM than before.
           This is a cap on BULK PRE-LOADING, not on content: `ahead > 2 screens` means it only ever
           declines while the reader still has two screens in hand, so approaching the end drops it
           straight back through to loadMore. Demand-driven past this point instead of bulk. */
        var PF_MAX_UNPRUNED = _lowRAM ? 12 : 18;               // cards, when nothing behind gets trimmed
        var tooMany = !prunes && list.querySelectorAll('.post').length >= PF_MAX_UNPRUNED
                      && ahead > (scroller.clientHeight * 2);  // and the reader is not about to run out
        if (!tooMany && ((added === 0 && cur.mode !== 'feed') || (added > 0 && ahead < PFEED_BUFFER_AHEAD))) { return loadMore(); }
      }
      // ran out of real posts (a profile's whole set, or a single permalink) -> switch to the endless loop
      // so a scroll-all-day user never dead-ends. Home-feed exhaustion loops via the batch-empty branch.
      if (!cur.more && !cur.looping) {
        // A PROFILE that exhausted its OWN posts keeps flowing with engagement-ranked RECOMMENDED media
        // (the "up next" firehose) before it ever loops. Once THAT roll is dry too (cur.rec already set),
        // fall through to the loop. Feed mode + permalinks aren't profiles, so they loop as before.
        /* #634 REPEAT WRAPS INSTEAD, and it is placed ABOVE the rec-roll on purpose. The rec-roll is
           the one escape hatch that would quietly break the promise: it is engagement-ranked media by
           OTHER people, and falling into it is exactly "it stopped showing me only them". So an armed
           scope never reaches it, and never reaches startLoop's snapshot of the whole rendered list
           either -- that list still holds the posts above the arming point, which are not theirs. */
        if (cur.rpUser) { return rpWrap(); }
        if (cur.ring) { return ringDrain(); }              // a ring drains (continuation -> Discover hand-off -> card); it never loops
        if (cur.mode !== 'feed' && cur.user && !cur.rec) {
          cur.rec = true; cur.offset = 0; cur.more = true;
          return loadMore();
        }
        return startLoop();
      }
    }).catch(function () {
      if (cur === mine && cur.rpGen === mineRp) {
        cur.loading = false;
        sentinel.classList.remove('on');
        pfReArm(mine);        // ...and make sure something asks again; see the note on pfReArm
      }
    });
  }

  // Prepend the items ABOVE the one we opened on (feed mode only), so scroll-UP still walks the
  // earlier media even though we started mid-list. Restores scrollTop after the prepend so the clip
  // you're on doesn't jump.
  function loadBefore() {
    if (!cur || cur.mode !== 'feed' || !cur.positioned || cur.beforeLoading || !cur.headIdx || cur.headIdx <= 0) return;
    // a hero-zoom is mid-flight: the prepend + re-pin below shift the scroller, which would move
    // the landed photo out from under the cross-fading clone. Wait for the handoff to finish.
    if (document.documentElement.classList.contains('hz-hold')) {
      if (!loadBefore._hz) { loadBefore._hz = setTimeout(function () { loadBefore._hz = 0; loadBefore(); }, 240); }
      return;
    }
    var start = Math.max(0, cur.headIdx - 6);
    var batch = cur.ids.slice(start, cur.headIdx);
    if (!batch.length) { cur.headIdx = 0; return; }
    cur.beforeLoading = true; var mine = cur;
    var readyB = null;                                   // cardCache: a back-swipe re-materializes instantly too
    var chB = cachedBatch(batch);
    if (chB !== null) { readyB = Promise.resolve({ html: chB }); }
    // Same treatment as loadMore: cur.beforeLoading gates every later prepend, so an undeadlined read
    // here freezes scroll-UP through the viewer for the platform's whole socket timeout.
    (readyB || rfetch('/post-cards?ids=' + batch.join(','), {
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', cache: 'no-store'
    }, 8000).then(function (r) { return r.json(); }).then(function (d) {
      if (d && d.html) { cacheCards(d.html); }
      return d;
    })).then(function (d) {
      if (cur !== mine) return;
      cur.beforeLoading = false;
      if (d && d.html) {
        var tmp = document.createElement('div'); tmp.innerHTML = d.html;
        pfNoPip(tmp);   // BEFORE the clips are bound into the document -- see the note on pfNoPip
        var frag = document.createDocumentFragment();
        while (tmp.firstChild) { frag.appendChild(tmp.firstChild); }
        // RECT-ANCHORED, not a scrollHeight delta -- the snap container pays the same delta itself and
        // the two used to add up to a card of forward drift per prepend. Full reasoning at pfFlushPark's
        // prepend (:42943); this is the same insert with the same anchor, one fragment instead of one node.
        var anchorB = list.firstChild;
        var aTopB = (anchorB && anchorB.getBoundingClientRect) ? anchorB.getBoundingClientRect().top : null;
        list.insertBefore(frag, list.firstChild);              // earlier posts go on top, in order
        if (aTopB !== null) { scroller.scrollTop += (anchorB.getBoundingClientRect().top - aTopB); }
        cur.headIdx = start;
        // After the FIRST preload of earlier posts (right after opening), re-pin the TAPPED post to the
        // top. The incremental scrollTop restore above can drift a post or two under scroll-snap / a
        // quick reopen -- which landed you on the wrong post. Do it once; later scroll-up prepends keep
        // their smooth restore.
        if (!cur.anchored) {
          cur.anchored = true;
          var tpin = cur.targetId && list.querySelector('.post[data-view="' + cur.targetId + '"]');
          if (tpin) { try { tpin.scrollIntoView({ block: 'start' }); } catch (e) {} }
        }
        if (window.__rovaHydrate) window.__rovaHydrate(list);
        fitPfeedMedia();
      }
    }).catch(function () { if (cur === mine) { cur.beforeLoading = false; } });
  }

  // TikTok-style sound: the centered video plays WITH SOUND when the feed opens (opening it
  // was a user gesture), so the phone's volume rocker controls it right away instead of the
  // clip sitting muted. If the browser vetoes unmuted playback, we fall back to muted so it
  // still plays. Unmuting fires the global volumechange handler -> soundOn=true, so as you
  // scroll the sound follows the top video from there.
  // The video actually IN VIEW in the current post. For a single-video post that's just its <video>; for a
  // mixed / multi carousel it's the video on the slide currently paged into view (null if that slide is a
  // PHOTO) -- picking the post's FIRST <video> blindly would unmute + play an off-screen video slide while
  // the viewer is looking at a photo (the "both photos and videos confuse the player" bug).
  function pfCurrentVideo() {
    var p = currentPost(); if (!p) return null;
    // POST MEDIA ONLY. This used to be p.querySelectorAll('video'), which also matched the author's VIDEO
    // AVATAR (lib/view.php emits a <video autoplay muted loop> for an mp4 avatar_path, and the pfeed post
    // card carries one in its head). On a PHOTO post by an author with a video avatar that was the post's
    // ONLY <video>, so the `length <= 1` shortcut handed the avatar back as "the current clip" -- and
    // pfSound() then actively UNMUTED a decorative 3-second boomerang loop. That is the same shape as the
    // decorative-video-grabs-the-audio-session bug fixed earlier today, except here we were doing the
    // unmuting ourselves. It also mattered for hands-free, which asks this question to decide whether the
    // current item is a clip to play out or a photo to dwell on. `.media` is the post's own media box (and
    // contains .cslide for carousels), so this is exactly the set applySound's SEL already works over.
    var vids = p.querySelectorAll('.media video');
    if (vids.length <= 1) { return vids[0] || null; }
    var vw = window.innerWidth || 0, best = null, bestD = Infinity;
    Array.prototype.forEach.call(vids, function (v) {
      var r = v.getBoundingClientRect();
      if (!r.width || r.right <= 1 || r.left >= vw - 1) return;   // a slide paged off to the side
      var d = Math.abs((r.left + r.right) / 2 - vw / 2);
      if (d < bestD) { bestD = d; best = v; }
    });
    return best;
  }
  window.__rovaPfCurrentVideo = pfCurrentVideo;   // the landing-autoplay pump below asks the same question
  /* THE OPEN'S OWN GESTURE, SPENT ON SOUND (owner 2026-08-15, second pass).
     Both openers run SYNCHRONOUSLY inside the tap's click handler -- that is stated one line above,
     where __rovaAmArm takes the same moment for the music preview -- and it is the last instant a
     WebKit activation exists. The viewer's clip is still a fetch away, so the arm is taken on the
     card the reader actually tapped, which is on screen right now: the timeline post, or the
     permalink's own card. __rovaSoundArm unmutes + play()s it and hands it straight back muted, so
     nothing is audible from the surface being left behind; what survives is the page's permission,
     and pfSound() below then opens the viewer WITH sound instead of with a pill.
     The GRID has no such card and arms its tile directly in the grid tap handler.
     A no-op when the reader's stored intent is muted, and a no-op on a photo post. */
  function pfArmSound(targetId) {
    if (!window.__rovaSoundArm) { return; }
    try {
      var id = String(targetId || '').replace(/[^0-9]/g, '');
      var v = id ? document.querySelector('.post[data-view="' + id + '"] .media video') : null;
      if (!v && !document.querySelector('.pfeed.show')) {
        var pv = document.querySelector('[data-pfeed-open] > .post .media video');   // the permalink's own card
        if (pv) { v = pv; }
      }
      if (v) { window.__rovaSoundArm(v); }
    } catch (e) {}
  }
  function pfSound() {
    var v = pfCurrentVideo(); if (!v) return;
    // NO GESTURE, NO UNMUTE (2026-08-08). The comment below is right that the browser vetoes the unmuted
    // play -- but on WebKit the veto arrives as a PAUSED ELEMENT, not only as a rejected promise, and the
    // muted re-play underneath then races the pause. So on a direct load (a shared /p/<id> opened from a
    // message, the case the owner recorded) don't attempt the unmute at all: just make sure the clip is
    // PLAYING, muted, and let the "Tap for sound" pill collect the gesture that legitimises sound.
    // __rovaUserActivated is the main IIFE's single answer to "has this document been activated"; it is
    // navigator.userActivation where the engine has it.
    /* TWO QUESTIONS, NOT ONE (2026-08-15). "Has this document been activated" is necessary and was
       never sufficient: this runs from pfSoundSoon's poll, up to ~1.8s after the open, so it is not
       inside the opener's gesture and WebKit will refuse the unmute -- leaving the clip silent with
       muted=false, which is precisely the state the owner reported on /p/43603. __rovaSoundUnlocked()
       is the engine's own answer, set only when an in-gesture unmute has actually taken (see the
       sound closure). It is already true by the time this runs on the ordinary tap-to-open path,
       because promoteSound spends that same tap on the card's clip; on a cold permalink it is false,
       and the muted play + "Tap for sound" below is the honest result. */
    /* THREE QUESTIONS NOW, AND THE THIRD IS TIMING. pfSoundSoon starts polling from the opener, so
       this can run while the open is still choosing which element keeps the clip -- which is how the
       viewer's own copy came to be unmuted at 0 while the card played the same file at 9.5 (the
       owner's "CD skip"). A hold is not a refusal: the muted play below still happens, and
       pfVoiceReady calls this again the instant the viewer has settled and resumed. */
    var act = (!window.__rovaUserActivated || window.__rovaUserActivated())
           && (!window.__rovaSoundUnlocked || window.__rovaSoundUnlocked())
           && !(window.__rovaSoundHeld && window.__rovaSoundHeld());
    if (!act) {
      if (v.paused) { if (window.__rovaEngineMute) { window.__rovaEngineMute(v, true); } var p0 = v.play(); if (p0 && p0.catch) p0.catch(function () {}); }
      return;
    }
    if (!v.muted) return;
    v.muted = false;
    var pr = v.play && v.play();
    // Unmuted autoplay is only allowed after a real user gesture. On a DIRECT load (typed URL / shared
    // link) there is none, so the browser vetoes it -- fall back to MUTED and PLAY AGAIN so the clip
    // still autoplays (silent; a tap unmutes). Before we reverted to muted but never re-played, so the
    // video sat PAUSED = "doesn't autoplay".
    // ...AND THE FALLBACK MUTES THE ENGINE WAY. This was a bare `v.muted = true` -- a mute nobody
    // asked for, arriving whenever the engine got round to refusing, i.e. always outside every
    // timestamp guard the volumechange handler had. That is the exact write measured writing
    // rova_sound=0 on 2026-08-14. The declared-mute rule in that handler now makes any undeclared
    // mute harmless, but this one is genuinely engine work and should say so at the source too.
    if (pr && pr.catch) pr.catch(function () {
      if (window.__rovaEngineMute) { window.__rovaEngineMute(v, true); } else { v.muted = true; }
      var p2 = v.play(); if (p2 && p2.catch) p2.catch(function () {});
    });
    /* ...AND THE REFUSAL THAT IS NOT A REJECTED PROMISE. This unmute is the open-with-sound one, and
       it runs from pfSoundSoon's poll rather than the tap, so it meets the WebKit rule head on: a
       clip unmuted out of the muted-autoplay allowance is silently PAUSED, with nothing for the
       .catch above to see. soundRepair is the one owner of that repair on this site -- it resumes the
       clip UNMUTED and only a genuine refusal mutes it, through the stamped engine path. Adding it
       here is what makes "the arm worked" and "the arm did not work" both end somewhere honest. */
    if (window.__rovaSoundRepair) { try { window.__rovaSoundRepair(v); } catch (er) {} }
  }
  function pfSoundSoon() {
    var tries = 0;
    (function go() {
      var v = pfCurrentVideo();
      if (v && v.readyState >= 1) { pfSound(); return; }   // the in-view slide's clip is present with metadata
      if (tries++ < 8) setTimeout(go, 220);
    })();
  }

  // Reveal the overlaid chrome ONCE, only after the content is truly on screen. rova:pfeedready means the
  // target is POSITIONED, not that its media has LOADED -- firing on it alone pulled the controls back in
  // ~180ms before the media painted (traced: ready@223ms, media loaded@608ms) = the "controls flash before
  // content loads". So on pfeedready we now WAIT for two things: the centred media to actually load, AND the
  // hero clone to finish landing (hz-hold cleared), then fade the chrome in. Capped so slow media can't
  // strand the controls forever.
  document.addEventListener('rova:pfeedready', function () {
    var pf = document.querySelector('.pfeed.pf-settling');
    if (!pf) return;
    var mine = pfGen, start = Date.now();
    var post = null, media = null;
    function resolve() {
      post = (typeof currentPost === 'function' && currentPost()) || pf.querySelector('.pfeed-list .post');
      media = post && post.querySelector('.media img, .media video');
    }
    resolve();
    function ready() {
      /* NEVER HOLD THE SUBJECT ACROSS TICKS -- IT GETS SWAPPED OUT FROM UNDER US, AND HOLDING IT COST
         THE OWNER A 2.4-SECOND WAIT ON EVERY VIDEO FULLSCREEN OPEN (2026-08-07: "it shows the media
         playing full screen alone then it loads the stuff"). heroExpand's single-element handoff
         replaceChild()s this card's placeholder <video> out for the live flying clip and then
         __rovaRetireVideo()s the evicted one -- so the element captured here is DETACHED and pinned at
         readyState 0 for the rest of time. `ld` could therefore never become true and the poll ran to
         its cap on EVERY live-video open (measured: media + header + engagement row all populated at
         315ms, hero landed at 693ms, chrome revealed at 2975ms = the 2600ms cap, to the frame).
         Re-resolving costs nothing on the normal path (two isConnected reads) because currentPost() --
         a getBoundingClientRect on every rendered card -- is only re-run when the subject has actually
         gone away. */
      if (!media || !media.isConnected || (post && !post.isConnected)) resolve();
      if (media) {
        var ld = media.tagName === 'VIDEO' ? (media.readyState >= 2) : (media.complete && media.naturalWidth > 0);
        if (!ld) return false;                                                     // content not painted yet -> keep chrome hidden
      }
      if (document.documentElement.classList.contains('hz-hold')) return false;    // hero clone still flying -> wait for it to land
      /* ...AND THE TARGET'S OWN CHROME MUST BE IN THE BOX TREE (2026-09-01). .pf-lite / .pf-crlite
         display:none the caption, the engagement row, the header and the comment roller, and until
         2026-09-01 they were dropped one and two flush steps AFTER this reveal -- so the caption and
         the roller popped in 38ms and 117ms behind the bar and the scrubber, with no fade (a
         display:none -> display change cannot transition). Waiting for them here is what makes the
         arrival single: everything pf-settling hides is laid out before pf-settling comes off, so it
         all fades in on the one .35s curve. Full reasoning at the top of pfFlushPark's try block.
         GATED ON pfPark, NOT ON THE CLASSES ALONE, and that is the difference between a wait and a
         hang. The classes are only ever added together with a park (app.js: the phased branch adds
         .pf-lite/.pf-crlite and then calls pfParkRest on the next line; the un-phased permalink
         branch adds neither), and pfFlushPark clears pfPark on any bail -- a generation bump, a
         closed viewer, a thrown step. So `pfPark` is exactly "a flush is still coming that will
         remove these". If it has gone and the classes somehow remain, there is nothing left to wait
         for and this must not hold the chrome hostage; the 2600ms cap above would eventually fire,
         but a reveal that slow is a bug, not a backstop. */
      if (pfPark) {
        var tp = post || pf.querySelector('.pfeed-list .post');
        if (tp && (tp.classList.contains('pf-lite') || tp.classList.contains('pf-crlite'))) return false;
      }
      return true;
    }
    function drop() {
      if (mine !== pfGen) return;                        // a newer open / a close owns the viewer now
      if (!pf.classList.contains('pf-settling')) return; // already revealed (drop() is idempotent)
      clearTimeout(capT);
      pf.classList.remove('pf-settling');
      pf.classList.remove('pf-chrome-in');   // the mask it lifted is gone with pf-settling; back to the plain state
      /* RE-ASSERT "ONLY THE POST IN VIEW MAKES SOUND", once, at the moment the open has come to rest.
         Until here the viewer is still moving: the hero handoff unmutes whichever card was centred when
         it revealed, a stray tap can unmute another, and the engine's own soundfollow sweep does not run
         for either (both are programmatic, and the volumechange guard deliberately ignores engine mutes).
         That is how a grid double tap ended up with TWO clips unmuted at once (owner 2026-08-06,
         reproduced with real touch in WebKit). applySound already knows the right answer -- it resolves
         the current post and mutes everything else -- it was simply never asked again after the open
         settled. One call, idempotent, and it costs nothing when there is only one clip. */
      if (window.__rovaSyncSound) { try { window.__rovaSyncSound(); } catch (e) {} }
      /* ...AND THIS IS THE MOMENT THE OPEN HAS PICKED ITS ELEMENT, so it is the moment the voice may
         be handed over (the other half being the resume seek; see pfVoiceHold). It goes AFTER the
         re-assert above deliberately: applySound has just made "only the post in view makes sound"
         true again, and pfVoiceReady then lifts the hold and re-runs exactly that rule. */
      pfVoiceReady('settled');
      /* ...AND START THE POST'S MUSIC, on the same line as the reveal (owner 2026-08-09: "when tapping a
         post with music the music should start playing... it should fade in with everything else and it
         should be playing"). This is deliberately the SAME statement that reveals the chrome, not a timer
         near it: the player is faded in by pf-settling coming off one line above, so "playing" and
         "visible" cannot drift apart, and there is no second timeline to keep in sync. Once per open --
         drop() is idempotent and generation-guarded -- so paging the viewer never starts anything.
         `post` is whatever ready() last resolved (re-resolved across ticks, never held), so it is the post
         that actually landed. It refuses to interrupt anything already playing; see __rovaAmAuto.
         POST, NEVER THE VIEWER, as the root. The feed viewer has several posts rendered around the target,
         so handing this `pf` as a fallback would let a card belonging to a post three swipes down start
         playing over a post that has no music at all. No resolved post = nothing plays. */
      if (post && window.__rovaAmAuto) { try { window.__rovaAmAuto(post); } catch (e) {} }
    }
    // Last resort, and it must be a TIMER not a poll deadline: rAF is frozen in a background tab, so a
    // viewer opened and backgrounded would otherwise never reach the cap at all. (The openers' own
    // 4000ms backstop still sits behind this one.)
    var capT = setTimeout(drop, 2600);
    /* rAF, not setTimeout(60): the gate above is now satisfied in the same tick heroRelease() lifts
       hz-hold, and a 60ms poll spent up to four more frames sitting on a viewer that was already
       finished. Bounded by the same 2600ms and generation-guarded, so a stale open can never keep a
       frame callback alive behind a viewer that has moved on. */
    /* SCRIM RELEASE (b) -- see .pfeed.pf-settling:not(.pf-hasmedia) in rova.css. ANY painted source
       on the centred card ends the translucent window: full-res is deliberately NOT required (that is
       ready()'s ld gate, which stays the CHROME's gate). A video's poster stand-in (pfPosterLayer's
       .pf-vposter img) or first decodable frame counts; a photo has only its full-res src (the LQIP
       background is a no-op, see lqipImg), so for photos this fires with ld -- the hero-landing stamp
       (release (a), in reveal()/heroRelease) is what beats it there. */
    function painted() {
      if (!media || !media.isConnected) resolve();
      if (!media) return false;
      if (media.tagName === 'VIDEO') {
        if (media.readyState >= 2 || media.currentTime > 0.01) return true;
        var ps = media.parentNode && media.parentNode.querySelector && media.parentNode.querySelector('.pf-vposter .pfv-img');
        return !!(ps && ps.complete && ps.naturalWidth > 0);
      }
      return !!(media.complete && media.naturalWidth > 0);
    }
    (function tick() {
      if (mine !== pfGen) return;
      if (!pf.classList.contains('pf-settling')) return;
      if (!pf.classList.contains('pf-hasmedia') && painted()) { pf.classList.add('pf-hasmedia'); }
      if (Date.now() - start > 2600) { drop(); return; }
      if (!ready()) { requestAnimationFrame(tick); return; }
      drop();
    })();
  });

  // Launched from the profile-photo COMMENT badge (cur.openComments = the avatar post id): once the target
  // has SETTLED (hero landed + chrome revealed, so the sheet doesn't unfurl mid-flight), click that post's
  // comment button to auto-expand the comment scroller. One-shot per open, and abandoned if the viewer is
  // closed or replaced before it settles.
  document.addEventListener('rova:pfeedready', function () {
    if (!cur || !cur.openComments) return;
    var mine = cur, want = cur.openComments;
    cur.openComments = '';                                   // consume: never re-fire on a later ready
    var start = Date.now();
    (function go() {
      if (cur !== mine || !box || !box.classList.contains('show')) return;   // a new viewer / a close replaced us
      if (box.classList.contains('pf-settling') && Date.now() - start < 2600) { setTimeout(go, 60); return; }
      var post = list.querySelector('.post[data-view="' + want + '"]') || currentPost();
      if (!post) { if (Date.now() - start < 2600) setTimeout(go, 80); return; }
      // the action-bar comment button always exists for members; fall back to the recent-comments roller
      var cbtn = post.querySelector('.act.js-comments') || post.querySelector('.js-comments');
      if (cbtn) cbtn.click();
    })();
  });

  /* ---- THE SHELL IS BUILT BEFORE THE TAP, NOT INSIDE IT  (2026-08-17, round E) -----------------
     MEASURED, and this is the whole of the gap between a first open and a second one. vopen-perf
     --reopen (added in round D for exactly this question) takes the SAME tap on the SAME tile twice
     in one session; build() carries `if (box) return box`, so the second tap does not construct the
     viewer. Six paired ordering-balanced runs of each at 390x844 / 4x CPU:
         tap -> hero on screen   765ms [679-882] first    491ms [404-510] second   RANGES DISJOINT
         tap -> hero landed     1251ms [1199-1303]        949ms [892-1006]         RANGES DISJOINT
         the opener's own sync   184-247ms                 91-132ms                RANGES DISJOINT
     and a V8 profile of each names the difference as construction, not as warm caches:
         LocalFrameView::performLayout            50.5ms -> 0
         InlineNode::ShapeTextIncludingFirstLine  29.4ms -> 0
         Document::rebuildLayoutTree              12.1ms -> 0
         ParseHTML                                 7.5ms -> 0
         appendChild (self)                       29.1ms -> 7.1ms
     Four of those going to EXACTLY zero is the shell not being built. A warm HTTP cache cannot
     remove text shaping. So the first open pays for the viewer's chrome -- the bar, the hands-free
     dock, the scroller -- inside the tap's own task, and every open after it does not.

     AT IDLE, AFTER LOAD, AND NEVER IN FRONT OF THE FEED. requestIdleCallback with a timeout so a
     busy page still gets it, behind the load event so it cannot compete with the initial render,
     and a plain timer where rIC does not exist (Safari shipped it late). If the reader taps first,
     build() runs in the tap task exactly as it does today -- this can only ever be a head start,
     never a new dependency.

     ONLY ON A SURFACE THAT CAN OPEN IT. A settings page has no tile to tap, and a full-viewport
     fixed element it will never use is not free.

     THE ONE THING TO CHECK BEFORE TOUCHING THIS: .pfeed is position:fixed;inset:0 and merely
     visibility:hidden until .show, so a pre-built shell has a FULL-VIEWPORT RECT AT ALL TIMES. Any
     code that reads its existence or its geometry as "an open is in progress" is wrong from page
     load instead of from the first open. The sweep found two, and both are handled: pin()'s dock
     gate above (fixed to ask .show), and vopen-perf's own firstFsFrame, which measured the rect and
     had to be taught to demand .show. Everything else already asks for .pfeed.show -- pfStillSync,
     hfLive, recyclePfeedMedia, _memGuard, the flight pump, pfNoteSettledVh -- or uses .pfeed only as
     an ANCESTOR (closest('.pfeed'), `img:not(.pfeed *)`), which an empty shell cannot satisfy.
     The sentinel's IntersectionObserver does fire once against the empty scroller; loadMore()'s
     first statement is `if (!cur ...) return`, and cur is null until an opener sets it. */
  function pfPrebuild() {
    try {
      if (box) { return; }
      if (!document.querySelector('.pgrid .pcell, #feed-posts .pcell, .landing-grid .pcell, .post .media')) { return; }
      build();
    } catch (e) {}
  }
  (function () {
    var go = function () {
      if (window.requestIdleCallback) { requestIdleCallback(pfPrebuild, { timeout: 3000 }); }
      else { setTimeout(pfPrebuild, 1200); }
    };
    if (document.readyState === 'complete') { setTimeout(go, 400); }
    else { window.addEventListener('load', function () { setTimeout(go, 400); }); }
  })();

  // open the vertical feed for @user on `tab`, landing on tapped post `targetId`
  window.__rovaProfileFeed = function (user, tab, targetId, slideIdx, startIndex, startTime) {
    /* FIRST STATEMENT OF THE OPEN, AND THAT IS THE WHOLE POINT: both openers are called synchronously
       from the tap's own click handler, so this is the last moment in the gesture. It unlocks the shared
       <audio> for the deferred start that happens when the chrome is revealed ~600ms later, and it is a
       no-op on any page with no music card on it. See amArm() in the Apple Music block. */
    if (window.__rovaAmArm) { try { window.__rovaAmArm(targetId); } catch (e) {} }
    pfArmSound(targetId);   // ...and the VIDEO's, on the card this tap lifted off (see pfArmSound)
    build();
    pfFinalize();   // hard-complete any previous close's teardown BEFORE this open (no stale finish wipes us)
    pfGen++; pfPhase = 'opening';
    // ONE VOICE: silence the surface being left behind (this runs in the tap's own task, so nothing is
    // rendered between the promote that unmuted it and this) and keep everything muted until the deck
    // has settled AND the grid resume has landed. See pfVoiceHold.
    pfVoiceHold(startTime > 0 && !!targetId);
    window.__rovaPfTargetSlide = (slideIdx > 0 ? slideIdx : 0);   // the hero flight measures THIS slide, never slide 1
    // Start a few posts ABOVE the tapped one so its page loads FIRST (no paging from the newest) while
    // leaving swipe-up headroom. We start below the target (never past it) because profile mode can't page
    // backward; if the index is short, the seek loop just pages forward to land on it.
    var off = (typeof startIndex === 'number' && startIndex > 3) ? (startIndex - 3) : 0;
    cur = { user: user, tab: tab || '', offset: off, more: true, loading: false,
            targetId: targetId ? String(targetId) : '', targetSlide: (slideIdx > 0 ? slideIdx : 0), positioned: false,
            // tapped a mid-playing grid VIDEO -> RESUME the clip at that time so it CONTINUES instead of
            // restarting at 0 when the hero cross-fades (mirrors the feed viewer). pfResume() seeks it below.
            resumeId: (startTime > 0 && targetId ? String(targetId) : ''), resumeTime: (startTime > 0 ? startTime : 0), resumeAt: Date.now() };
    box.querySelector('.pfeed-title').textContent = '@' + user;
    pfSetBarTick('');   // drop the previous author's check; the page-1 author card re-adds it if verified
    box.querySelector('.pfeed-host').textContent = 'rovasocial.com/';   // shown only on idle -> reads rovasocial.com/@user
    box.querySelector('.pfeed-who').href = '/@' + encodeURIComponent(user);   // tap avatar/@ -> profile
    clearPfeedList();   // release any clips left from a prior/interrupted viewer before this one loads
    sentinel.style.display = '';
    // Hide the overlaid chrome from the FIRST frame (removed on rova:pfeedready when the post settles), so
    // the controls never flash in before the media lands. Safety-cleared in case pfeedready never fires.
    box.classList.remove('pf-hasmedia');   // fresh open: the settling scrim starts translucent again (rova.css :not(.pf-hasmedia))
    box.classList.remove('pf-chrome-in');   // a fresh open earns its own early reveal (pfChromeIn)
    box.classList.add('pf-settling');
    setTimeout(function () { box.classList.remove('pf-settling'); }, 4000);   // backstop only if pfeedready never fires
    /* SCRIM RELEASE (c), backstop: opaque by ~800ms even if nothing has painted (no hero flew, media
       still fetching). The genuinely-empty window keeps the dim scrim -- the pre-scrim bug was a cut
       to black + spinner (owner: "the whole screen going black is horrible") -- but capped here at a
       beat, not riding the full 4s chrome backstop above: on a slow line the dim reads as the open's
       first phase, then fades to the dark stage while the spinner carries on. Generation-guarded so a
       rapid re-open's stale timer can't darken the NEW open's scrim early. Chrome timing untouched. */
    (function (g) { setTimeout(function () {
      if (g === pfGen && box.classList.contains('pf-settling')) { box.classList.add('pf-hasmedia'); }
    }, 800); })(pfGen);
    box.style.transform = ''; box.style.transition = '';
    /* ---- THE TAP TASK, AND WHERE IT NOW ENDS (2026-08-17, rounds C+D) --------------------------
       loadMore() is the LAST statement of the gesture, and it is the only one whose cost is not
       ours: it opens the round-trip the whole open is blocked on (the hero flight cannot hand off
       until the target card is in the DOM and laid out; see the pump's pfCenteredMedia gate in
       heroExpand). Every ms it spends waiting behind local work is a ms of "nothing is happening".
       It needs `cur`, `list` and `sentinel`, all set above, and it appends nothing synchronously.

       EVERYTHING BELOW IT USED TO RUN HERE TOO, and that is what round D moved -- see pfOpenTail.
       The bar text, the settling class and clearPfeedList stay synchronous because a warm prefetch
       resolves loadMore in the very next microtask checkpoint: a deferred pfSetBarTick('') would
       wipe a check the page-1 author card had already added, and a deferred .pf-settling would let
       the card's own rova:pfeedready fire against a viewer that is not settling yet, which strands
       the chrome hidden. Neither costs anything measurable (round B priced both invalidations
       together at 2 events / 6ms for the whole open). */
    loadMore();
    pfOpenTail([
      pfTailLock,                // the history entry, then the document-wide flush -- in that order
      function () { scroller.scrollTop = 0; pfTailIdle(); },
      function () { pfArmIdle(); hfOpen(); }   // chrome-fade + hands-free clocks
    ]);
    /* WAKE ANY HERO FLIGHT IN THE SAME FRAME. heroExpand runs BEFORE this opener, so its pump has
       already registered a rAF and that rAF fires BEFORE this one -- the pump looked for .pfeed.show
       a frame too early and then waited a whole frame to look again (~64ms at CPU x4). Telling it
       here costs nothing and grants nothing: the pump re-reads the SAME gates and still refuses to
       fly until the centred media is fitted. See the pump in heroExpand. */
    requestAnimationFrame(function () {
      box.classList.add('show');
      /* .show is what rova.css keyed html.pfv-on off (was body:has(.pfeed.show) -- see pfStillSync):
         recompute it in the SAME task the class lands, so the grid pan freezes on the same frame it
         always did rather than one frame late. */
      try { if (window.__rovaPfStillSync) window.__rovaPfStillSync(); } catch (e) {}
      try { document.dispatchEvent(new CustomEvent('rova:pfwake')); } catch (e) {}
    });
    // COMMIT the reset opacity:0/visibility:hidden as the transition baseline BEFORE flipping to .show.
    // A lone rAF wasn't enough on the FIRST open: the box is freshly built + inserted this frame, so its
    // opacity:0 was never painted, and adding .show in the rAF (before any paint) let the browser coalesce
    // straight to opacity:1 with NO fade -- the viewer snapped to its dark background = the "first click
    // flashes to black" the owner saw. Forcing layout here paints the 0 baseline so the .3s fade always runs.
    void box.offsetWidth;
    if (window.__rovaMfPrefetch && targetId) { try { window.__rovaMfPrefetch(targetId); } catch (e) {} }   // the target's "More from" row, ready by the landing
  };

  /* A POST DELETED WHILE THE VIEWER IS OPEN -- forget it, don't merely stop painting it.
     ajaxDeletePost lives in an earlier IIFE (hence the window hop) and already dissolves every node
     carrying the id, the viewer's own slide included, so the deck LOOKS right the moment it lands.
     What it cannot reach from out there is this scope's two memories of the post:
       - cur.ids, the ordered deck. loadBefore() rebuilds the slides ABOVE the one you opened on
         straight out of it, so swiping back up re-requests an id that is gone. /post-cards renders
         nothing for a deleted row, so no dead slide appears -- but the phantom entry keeps headIdx
         and the index arithmetic disagreeing with what is actually on screen.
       - cardCache, which holds the post's rendered HTML for two minutes. THAT one can genuinely
         bring it back: reopen inside the TTL and cachedBatch() answers from memory without asking
         the server at all, so the photo just deleted is in the deck again.
     The profile-photo album is why this is here (owner 2026-08-12, deleting an OLDER profile photo
     from the album you get by tapping an avatar). It is a closed deck of two or three slides where
     swiping back up is the ordinary gesture rather than a rarity, and where reopening seconds later
     -- tap the avatar again to check it worked -- is exactly what a member does.
     Bookkeeping only: everything after the removed slot shifts down one, so idx and headIdx follow
     it and both stay clamped at 0. The DOM belongs to the dissolve; this never touches it. */
  window.__rovaPfDrop = function (id) {
    var sid = String(id || '');
    if (!sid) { return; }
    if (cardCache[sid]) { delete cardCache[sid]; }
    if (!cur || !cur.ids) { return; }
    var at = cur.ids.indexOf(sid);
    if (at < 0) { return; }
    cur.ids.splice(at, 1);
    if (cur.idx > at) { cur.idx = Math.max(0, cur.idx - 1); }
    if (cur.headIdx > at) { cur.headIdx = Math.max(0, cur.headIdx - 1); }
  };

  // open the immersive TikTok viewer over an explicit ordered list of post ids (the feed's
  // media), landing on `targetId`. The bar tracks whichever post is in view; back = close.
  // exactTime: `startTime` is a FROZEN position (a paused embed's "Continue on Rova"), not a
  // snapshot of a clip that is still running -- so pfResume must NOT add the open-transition
  // compensation, which would skip the member forward by however long this page took to load.
  window.__rovaFeedView = function (ids, targetId, slideIdx, startTime, feedless, openComments, exactTime, opts) {
    if (!ids || !ids.length) return;
    pfLastArrive = '';   // a fresh open: the first settle announces itself (rova:pfpost) even if it is the same post as last time
    if (window.__rovaAmArm) { try { window.__rovaAmArm(targetId); } catch (e) {} }   // unlock the preview inside the tap's gesture (see __rovaProfileFeed)
    pfArmSound(targetId);   // ...and the VIDEO's, on the card this tap lifted off (see pfArmSound)
    // STOP THE PAGE BEHIND THIS OVERLAY (owner 2026-08-12: "the [legacy] post loads/plays behind it,
    // makes everything sluggish" -- Esc/back still shows that page, so it's never removed, but nothing
    // ever told ITS media to stop once this fixed, opaque overlay covered it. A permalink's own post
    // card (views/post_single.php) autoplays exactly like any feed card, and opening .pfeed doesn't
    // move it out of the viewport -- its IntersectionObserver never fires again, so it just keeps
    // decoding (audio included) for as long as the viewer stays open, competing with the viewer's own
    // media for the same decoder/CPU/network budget. Pause only what's ACTUALLY playing right now (a
    // paused clip was already a user/policy choice, not ours to touch) and tag it so close() below can
    // hand it back -- never touching the viewer's own .pfeed videos, which run their own lifecycle.
    Array.prototype.forEach.call(document.querySelectorAll('video'), function (v) {
      if (v.paused || (v.closest && v.closest('.pfeed'))) return;
      if (v._liftDeferred) return;   // the fullscreen clip still waiting to join its flight (flyCrop deferMove): it IS the open
      v._rovaBgPaused = 1;
      try { v.pause(); } catch (e) {}
    });
    build();
    pfFinalize();   // hard-complete any previous close's teardown BEFORE this open (no stale finish wipes us)
    pfGen++; pfPhase = 'opening';
    // ONE VOICE: the card this tap lifted off goes quiet in the tap's own task, and nothing speaks
    // again until the deck has settled AND the full-screen hand-off position has landed. The sweep
    // above pauses the page's clips; this is the sound half, and it covers the element that is being
    // FLOWN (still playing, by design) as well as the ones that were paused. See pfVoiceHold.
    pfVoiceHold(startTime > 0);
    window.__rovaPfTargetSlide = (slideIdx > 0 ? slideIdx : 0);   // the hero flight measures THIS slide, never slide 1
    var arr = ids.map(String), tgt = targetId ? String(targetId) : '';
    // START loading AT the tapped item so it shows IMMEDIATELY. Loading forward from index 0 rendered
    // (and flashed) every earlier item at the top first, then scrolled down to the tapped one -- the
    // deeper you tapped, the longer that flash. headIdx tracks the first loaded item; the earlier ones
    // are prepended lazily on scroll-up (loadBefore).
    var startIdx = tgt ? arr.indexOf(tgt) : 0; if (startIdx < 0) startIdx = 0;
    cur = { mode: 'feed', ids: arr, idx: startIdx, headIdx: startIdx, more: true, loading: false,
            // feedless (profile-photo album): NO feed source AND no loop fallback -- the album is exactly the
            // member's profile photos (current first, then previous), each shown ONCE, and then it ends. It
            // never flows into the discover roll and never re-cycles itself (see startLoop).
            targetId: tgt, targetSlide: (slideIdx > 0 ? slideIdx : 0), positioned: false, feed: feedless ? null : feedCtx(),
            feedless: !!feedless,
            // opened via a video's fullscreen button -> resume THAT clip where it left off
            resumeId: (startTime > 0 ? tgt : ''), resumeTime: (startTime > 0 ? startTime : 0), resumeAt: Date.now(),
            resumeExact: !!exactTime,
            // opened via the profile-photo COMMENT badge -> auto-expand the comment sheet on the target
            // once it settles (see the rova:pfeedready hook below). Holds the target id, one-shot.
            openComments: (openComments && tgt) ? tgt : '' };
    /* THE MEDIA RING'S DECK (owner 2026-09-17, the media-ring IIFE at the foot of this file). The
       row's tap hands over the WHOLE ring in row order starting at the tapped circle -- that person's
       posts newest-first, then the next circle's, to the end and round -- and asks for three things
       the ordinary feed open does not give: NO page-feed drain (the deck is exactly the ring, never
       the tab behind it), NO finite end (a finished ring "should just repeat the order again"), and
       a mark on the session so the arrival hook can tell the ring's posts from anyone else's.
       Opened feedless so feedCtx() is never consulted, then feedless is cleared HERE so loadMore's
       dry branch falls through to startLoop() -- the same infinite loop a profile or permalink deck
       already takes -- and loopIds is pre-set to the full deck rather than snapshotted off the DOM,
       because pruneFarPosts will have thinned the head by the time the tail runs dry. Hands-free is
       not asked for because hfOpen() already starts it on every open (2026-08-12, default on) --
       UNLESS the member switched it off (rova_hf_on='0', 2026-09-30): then the ring opens off too. */
    /* ...SINCE 2026-09-18 THE RING DOES NOT LOOP (owner: "not enough posts in the last 24 hours ...
       after the end of the full screen posts ... trending media posts, and if those run out then
       just random unseen ... then end of media with start over button"). The deck the tap hands
       over IS the lap: row order from the tapped circle, wrapping, so it ends exactly where the
       starting person's newest post would play a second time. When cur.ids is spent the batch-
       empty branch below goes to ringDrain() -- a server-fed continuation (GET /ring-next: trending
       media, then random unseen, paged by an opaque cursor) -- and when THAT is exhausted, to
       ringEnd(): the "End of media" card with Start over. loopIds is deliberately NOT preset any
       more: startLoop() must never see a ring session (ringDrain/ringEnd own every dry branch). */
    if (opts && opts.ring) {
      cur.feed = null; cur.feedless = false; cur.ring = true;
      cur.ringDeck = arr.slice(); cur.ringCursor = null; cur.ringStage = 'ring';
      // guests too (2026-10-09): ringDone no longer starts true for a guest -- they get the continuation
      cur.ringLoading = false; cur.ringDone = false; cur.ringEnded = false; cur.ringFed = false;
    }
    box.querySelector('.pfeed-title').textContent = '';
    pfSetBarTick('');   // updateFeedBar re-adds it for whichever post lands
    box.querySelector('.pfeed-who').removeAttribute('href');
    var av0 = box.querySelector('.pfeed-av'); if (av0) { av0.innerHTML = ''; av0.removeAttribute('data-u'); }
    clearPfeedList();   // release any clips left from a prior/interrupted viewer before this one loads
    sentinel.style.display = '';
    // Hide the overlaid chrome from the FIRST frame (removed on rova:pfeedready when the post settles), so
    // the controls never flash in before the media lands. Safety-cleared in case pfeedready never fires.
    box.classList.remove('pf-hasmedia');   // fresh open: the settling scrim starts translucent again (rova.css :not(.pf-hasmedia))
    box.classList.remove('pf-chrome-in');   // a fresh open earns its own early reveal (pfChromeIn)
    box.classList.add('pf-settling');
    setTimeout(function () { box.classList.remove('pf-settling'); }, 4000);   // backstop only if pfeedready never fires
    /* SCRIM RELEASE (c), backstop: opaque by ~800ms even if nothing has painted (no hero flew, media
       still fetching). The genuinely-empty window keeps the dim scrim -- the pre-scrim bug was a cut
       to black + spinner (owner: "the whole screen going black is horrible") -- but capped here at a
       beat, not riding the full 4s chrome backstop above: on a slow line the dim reads as the open's
       first phase, then fades to the dark stage while the spinner carries on. Generation-guarded so a
       rapid re-open's stale timer can't darken the NEW open's scrim early. Chrome timing untouched. */
    (function (g) { setTimeout(function () {
      if (g === pfGen && box.classList.contains('pf-settling')) { box.classList.add('pf-hasmedia'); }
    }, 800); })(pfGen);
    box.style.transform = ''; box.style.transition = '';
    /* SAME TAIL AS __rovaProfileFeed, for the same measured reasons -- see the block comment there
       and at pfOpenTail: the round-trip the flight is blocked on opens last in the gesture, and
       everything that does not need the tap's activation runs one step per frame after it. */
    loadMore();
    pfOpenTail([
      pfTailLock,
      function () { scroller.scrollTop = 0; pfTailIdle(); },
      function () { pfArmIdle(); hfOpen(); }
    ]);
    requestAnimationFrame(function () {
      box.classList.add('show');
      try { if (window.__rovaPfStillSync) window.__rovaPfStillSync(); } catch (e) {}
      try { document.dispatchEvent(new CustomEvent('rova:pfwake')); } catch (e) {}
    });
    void box.offsetWidth;   // the .3s fade's opacity:0 baseline -- see the note in __rovaProfileFeed
    if (window.__rovaMfPrefetch && tgt) { try { window.__rovaMfPrefetch(tgt); } catch (e) {} }   // the target's "More from" row, ready by the landing
  };

  /* ---- A NEW DECK INSIDE THE OPEN VIEWER (Rob 2026-09-28, desktop + iOS Safari: "Choosing some media
     from the 'more from @username' ... starts the next clip muted, which is making me press tap for
     sound every time") ----------------------------------------------------------------------------------
     THE CAUSE WAS A PAGE LOAD. A "More from" tile is a plain <a href="/p/<id>">, and nothing handled it
     (the strip's wrap even stops the click reaching the document's bubble handlers), so every tap was a
     full navigation: a NEW document, and WebKit's audio permission belongs to the document. The
     reader's sound intent survived (rova_sound) but the engine's grant did not, so the fresh /p/ page
     opened its viewer on pfSound()'s honest cold-load branch -- muted, "Tap for sound" -- every time.
     Measured (Playwright WebKit, before): tile tap -> document request /p/13284, window state gone,
     landed clip muted=true.
     So the tap now stays in this document and re-decks the viewer that is already up: the same
     bookkeeping as __rovaFeedView (cur, the list, the chrome mask, the voice hold, the tail) MINUS the
     three things an open does only once -- the history entry (back must still close the viewer in one
     press), the scroll lock (already held; re-taking it would record scrollY 0 as the page's place) and
     the .show fade (the viewer is already opaque; pf-hasmedia stays on so the page behind never shows
     through the settling scrim). The voice is then handed over exactly as on a swipe: pfVoiceHold ->
     settled -> pfSound(), and pfSound only unmutes once sndUnlocked says the engine agreed.
     IN THE GESTURE, BEFORE ANY OF THAT: if this document has not been granted sound yet (a cold /p/ the
     reader never tapped for sound on), the tap is spent on the clip still on screen (__rovaSoundArm:
     unmute + play + stamped re-mute, a no-op when the stored intent is muted or the grant already
     exists) -- the same placement the grid tile and the openers use, for the same WebKit reason.
     Returns false (the caller then lets the link navigate) when there is no open viewer to re-deck. */
  window.__rovaPfJump = function (ids, targetId) {
    if (!box || !list || !box.classList.contains('show') || pfPhase === 'closing' || !ids || !ids.length) { return false; }
    var arr = [], seen = {};
    ids.forEach(function (x) { x = String(x || ''); if (/^\d+$/.test(x) && !seen[x]) { seen[x] = 1; arr.push(x); } });
    var tgt = String(targetId || '');
    if (!arr.length || !/^\d+$/.test(tgt)) { return false; }
    if (arr.indexOf(tgt) < 0) { arr.unshift(tgt); }
    if (window.__rovaSoundArm && !(window.__rovaSoundUnlocked && window.__rovaSoundUnlocked())) {
      try { var av = pfCurrentVideo() || list.querySelector('.post .media video'); if (av) { window.__rovaSoundArm(av); } } catch (e) {}
    }
    if (window.__rovaAmArm) { try { window.__rovaAmArm(tgt); } catch (e) {} }
    window.__rovaPfJumpedAt = Date.now();   // debug receipt for rigs: the tile tap stayed in this document
    pfLastArrive = '';
    hfClose();   // the old deck's hands-free timers must not advance the new one; hfOpen() re-arms in the tail
    try { if (window.__rovaCloseCommentPanel) { window.__rovaCloseCommentPanel(); } } catch (e) {}
    pfFinalize();
    pfGen++; pfPhase = 'opening';
    pfVoiceHold(false);
    window.__rovaPfTargetSlide = 0;
    var startIdx = arr.indexOf(tgt);
    cur = { mode: 'feed', ids: arr, idx: startIdx, headIdx: startIdx, more: true, loading: false,
            targetId: tgt, targetSlide: 0, positioned: false, feed: feedCtx(), feedless: false,
            resumeId: '', resumeTime: 0, resumeAt: Date.now(), resumeExact: false, openComments: '' };
    box.querySelector('.pfeed-title').textContent = '';
    pfSetBarTick('');
    box.querySelector('.pfeed-who').removeAttribute('href');
    var av1 = box.querySelector('.pfeed-av'); if (av1) { av1.innerHTML = ''; av1.removeAttribute('data-u'); }
    clearPfeedList();
    sentinel.style.display = '';
    box.classList.remove('pf-chrome-in', 'pfeed-idle');
    box.classList.add('pf-settling', 'pf-hasmedia');
    setTimeout(function () { box.classList.remove('pf-settling'); }, 4000);   // same backstop as an open
    loadMore();
    pfOpenTail([
      function () { scroller.scrollTop = 0; pfTailIdle(); },
      function () { pfArmIdle(); hfOpen(); }
    ]);
    if (window.__rovaMfPrefetch) { try { window.__rovaMfPrefetch(tgt); } catch (e) {} }
    return true;
  };

  /* ---- THE OPEN'S VOICE, HANDED OVER ONCE (owner 2026-08-15, third pass: the "CD skip") -----------
     An open touches up to four elements for the SAME clip -- the card or tile the reader lifted off,
     the hero flying above it, the viewer's freshly rendered <video>, and on a donor/live-hero open the
     adopted element that is all three at once. Until sound-on-open landed this morning they were all
     muted, so their overlap was inaudible; the trace of the first bundle that opened with sound has
     two of them unmuted 300ms apart playing the same file, which is what the owner hears as the audio
     looping twice. (The full measurement is written up at soundHold() in the sound closure.)

     So the openers HOLD sound in the gesture, and the voice is handed to exactly one element here,
     when the viewer has both:
       SETTLED -- the deck is positioned, the hero has landed and the chrome is revealing (drop()), and
       RESUMED -- any grid / full-screen resume seek has actually been APPLIED (pfSignalResumed), or
                  there was never one to apply.
     The second half is the grid's own half of the bug: unmuting before the seek lands plays the
     opening of the clip under a hero showing a frame seven seconds in. One-shot and generation-
     guarded, so a stale open cannot speak over the one that replaced it, and the hold's own expiry is
     the backstop -- a missing signal costs a slightly later unmute, never a silent viewer. */
  var pfVoice = { gen: -1, settled: false, resumed: false };
  function pfVoiceHold(hasResume) {
    pfVoice = { gen: pfGen, settled: false, resumed: !hasResume };
    if (window.__rovaSoundHold) { try { window.__rovaSoundHold(2200); } catch (e) {} }
  }
  function pfVoiceReady(which) {
    if (!pfVoice || pfVoice.gen !== pfGen) { return; }
    pfVoice[which] = true;
    if (!pfVoice.settled || !pfVoice.resumed) { return; }
    pfVoice.gen = -1;                                    // one-shot: the handover happens once per open
    if (window.__rovaSoundRelease) { try { window.__rovaSoundRelease(); } catch (e) {} }
    pfSound();                                           // ...and the viewer opens WITH sound, on the element that stayed
  }
  // Once the resumed clip has been seeked, tell the hero-zoom mask it can cross-fade: the viewer's video
  // is (about to be) painting a moving frame at that position, so the still -> video handoff has no gap.
  function pfSignalResumed(v) {
    var fired = false;
    function fire() {
      if (fired) return; fired = true;
      try { v.removeEventListener('playing', fire); } catch (e) {}
      try { v.removeEventListener('seeked', fire); } catch (e) {}
      window.__rovaPfResumedAt = Date.now();   // level-trigger: heroZoom checks this if the event beats its landing
      try { document.dispatchEvent(new CustomEvent('rova:pfresumed')); } catch (e) {}
      pfVoiceReady('resumed');                 // the clip is AT the position it opened for: it may now speak
    }
    try { v.addEventListener('playing', fire); } catch (e) {}   // ideal: the clip is actually moving
    try { v.addEventListener('seeked', fire); } catch (e) {}    // or at least the correct frame is up
    setTimeout(fire, 500);                                      // fallback: never wait on a missing event
  }
  // Seek the target clip to where it was playing inline (opened via its fullscreen button OR a grid-preview
  // tap), so it CONTINUES instead of restarting. Retries until the freshly-rendered <video> has metadata.
  // 2026-08-16: a GRID-TILE open no longer continues -- it starts the clip (see __rovaOpenRestart, and the
  // target override below). The fullscreen button and "Continue on Rova" still resume, which is why the
  // override is scoped by post id rather than applied to this whole function.
  function pfResume() {
    var mine = cur;
    // NOTHING TO RESUME IS A RESUME, for the voice gate above: this open lands at 0 and can speak as
    // soon as it has settled. (Said here rather than at the call sites so the two can never drift.)
    if (!mine || !mine.resumeId || !(mine.resumeTime > 0)) { pfVoiceReady('resumed'); return; }
    var tries = 0;
    // 25 x 140ms = 3.5s is plenty for a grid tap (that clip is already decoded and on screen), but an
    // embed's "Continue on Rova" is a COLD page load: on a congested line the viewer's <video> has no
    // metadata yet at 3.5s, the retry gave up, and the member landed back at 0 -- the exact thing they
    // clicked to avoid. Only the exact/embed path waits longer; the tuned grid-tap budget is untouched.
    // Seeking late is safe: the loop aborts if this open was replaced, and a clip the member has since
    // swiped past is off-screen and paused, so a late seek on it is invisible.
    var maxTries = mine.resumeExact ? 85 : 25;
    (function go() {
      if (cur !== mine || !mine.resumeId) return;
      var p = list.querySelector('.post[data-view="' + mine.resumeId + '"]');
      /* POST MEDIA ONLY -- the same trap pfCurrentVideo() documents above. This was
         p.querySelector('video'), which on a post by an author with an mp4 avatar matches the
         AVATAR (lib/view.php emits one in the card head, and the head is before .media in the
         markup): the resume then set currentTime on a decorative 3-second boomerang, cleared its
         own one-shot, and the clip the member actually opened was never seeked at all. `.media`
         is the post's own media box and contains .cslide, so this is the set applySound and
         pfCurrentVideo already work over. */
      var v = p && p.querySelector('.media video');
      /* PROMOTE THE ONE CLIP WE ARE WAITING ON. Since 2026-08-08 views/_post.php emits feed/pfeed
         video with preload="none" whenever it has a poster AND server-stamped width/height (the
         origin-saturation fix: 25 clips / 226 MB in 20s, all armed at HTML-parse time before app.js
         exists). A preload="none" element NEVER loads by itself, so `readyState >= 1` below is a
         condition that can be false forever -- and this open is the one that deliberately skips
         __rovaPlayNow (see the `!cur.resumeId` guard in loadMore) so it can seek BEFORE playing.
         MEASURED on /p/15454 with the fullscreen button pressed on a PAUSED clip (still-hero branch,
         so the loaded inline element is not flown in): with the gear's autoplay OFF nothing ever
         called play() on the fresh card, readyState stayed 0 for the whole 15s window, the poll
         expired and the member landed at 0:00 instead of 12.8s. Same outcome with autoplay ON on a
         cold, slow line (120kbps): playIO's single attempt spent itself before the element had data.
         THIS DOES NOT RAISE THE CONCURRENCY CEILING, and the gallery test is how it stays that way.
         It is one element, promoted at most once (_pfResumeKick), and ONLY on a post whose media is
         a single clip -- which is the whole clip the member opened full-screen and is looking at.
         A GALLERY IS DELIBERATELY EXCLUDED: on a carousel the preload tiers belong to primeNext's
         +/-1 window (current auto, backward neighbour metadata, everything else none), and the
         element this poll happens to hold is the post's FIRST video, which on a fullscreen open
         from slide 3 is not the slide anyone is looking at. Promoting it would be a second growing
         buffer that primeNext had just demoted, for a clip nobody asked for -- exactly the ratchet
         the +/-1 window exists to prevent. A gallery therefore keeps today's behaviour here
         unchanged. MEASURED, resume open vs the same open with startTime 0: peak concurrent
         byte-bearing media requests on the wire 2 and 2, identical.
         AND IT NEVER RESTARTS A FETCH THAT IS ALREADY RUNNING. v.load() runs the whole media load
         algorithm, which ABORTS whatever is in flight and starts again -- and playIO's play() does
         start a fetch WITHOUT touching preload, so "preload is still none" is NOT the same question
         as "nothing is downloading". Caught in the throttled run: the promotion fired a second after
         playIO's play() and the wire showed the clip's mp4 opened, killed and re-opened, which on a
         congested line is the one thing that makes the wait longer instead of shorter. networkState
         2 (NETWORK_LOADING) is the engine's own answer; in that state the preload raise alone is
         enough -- it lets the buffer grow past metadata without disturbing the request. */
      /* ...AND IT NEVER RELOADS A CLIP THAT ALREADY HAS DATA (2026-09-26). On the fullscreen-button open
         the element this poll finds IS the adopted live clip -- the timeline card's own <video>, flown in
         still playing, still carrying the markup's preload="none", and fully buffered, so networkState is
         IDLE and `loading` above reads false. load() then ran the whole media load algorithm on it:
         emptied, currentTime 0, paused (with no 'pause' event), a re-fetch, and the seek below to put it
         back -- MEASURED ~370ms of a stopped, silent clip right after the landing (the last beat of Rob's
         "audio cut out for a second"; the mute used to hide it). readyState >= 1 means there is nothing
         for a kick to promote. */
      if (v && !v._pfResumeKick && v.preload === 'none' && v.getAttribute('src') && v.readyState === 0
          && p.querySelectorAll('.media video').length === 1) {
        v._pfResumeKick = 1;
        var loading = (v.networkState === 2);   // NETWORK_LOADING: a fetch is already open on this element
        v.preload = 'auto';
        if (!loading) { try { v.load(); } catch (e) {} }   // the same explicit kick primeNext uses -- preload alone is not reliable on WebKit
      }
      if (v && v.readyState >= 1) {
        // COMPENSATE for the open transition: resumeTime is the TAP-time snapshot, but the grid preview the
        // user was WATCHING kept playing through the flight -- landing on the snapshot reads as a rewind of
        // exactly the transition duration. Seek to where the clip WOULD be now.
        // resumeExact (an embed's "Continue on Rova"): the source clip is PAUSED, so its position is
        // frozen -- compensating would fast-forward the member by the page's load time.
        var t = mine.resumeTime + ((mine.resumeExact || !mine.resumeAt) ? 0
                : Math.min(3, (Date.now() - mine.resumeAt) / 1000));
        /* ...UNLESS THIS OPEN CAME OFF A TILE (2026-08-16, see __rovaOpenRestart at the grid tap).
           A tile open now starts the clip rather than continuing it, so both the snapshot AND the
           transition compensation above are moot -- the target is 0 and the compensation exists
           only to chase a moving position. SCOPED BY ID + TTL, because this same function serves
           the two openers that must still resume: the in-timeline fullscreen button (":18307,
           fullscreen = continue") and an embed's "Continue on Rova" (`resumeExact`), neither of
           which ever sets this flag. It is read, never consumed, here: the donor branch above may
           legitimately have read it first on the same open, and both are aiming at the same 0. */
        var rstO = window.__rovaOpenRestart;
        if (rstO && String(rstO.id) === String(mine.targetId) && (Date.now() - rstO.at) < 8000) { t = 0; }
        if (!isFinite(t) || t < 0) { t = 0; }                 // never hand the element a bad currentTime
        if (v.duration && t >= v.duration - 0.3) { t = 0; }   // left off at the very end (or past it) -> start over
        // NEVER seek a clip that's already playing NEAR/PAST the target: on the donor/live-hero opens the
        // card video IS the grid element that kept playing through the whole transition -- it's already at
        // tapTime+flightTime, and seeking it (even a micro-seek) is a visible hitch/rewind (owner: "rewinds
        // for a hot milli second, then plays from that part"). Only a clip genuinely BEHIND (a fresh load
        // starting at 0, or paused) gets the resume seek -- now aimed at the COMPENSATED time above.
        if (!(t > 0 && !v.paused && v.currentTime >= t - 0.35)) {
          try { v.currentTime = t; } catch (e) {}
        }
        mine.resumeId = ''; mine.resumeTime = 0;              // one-shot
        pfSignalResumed(v);                                   // release the hero mask when it's painting
        return;
      }
      if (tries++ < maxTries) { setTimeout(go, 140); return; }
      pfVoiceReady('resumed');   // the poll gave up: land where we are, but never stay silent for it
    })();
  }

  // a pure Giphy GIF post (a looping gif, no real photo or uploaded video) never belongs in the
  // full-screen swipe feed -- a tiny gif blown up edge-to-edge looks broken
  function postIsGiphy(p) {
    if (!p || p.querySelector('.media video')) { return false; }
    var imgs = p.querySelectorAll('.media img');
    if (!imgs.length) { return false; }
    for (var i = 0; i < imgs.length; i++) {
      if (!/giphy\.com/i.test(imgs[i].currentSrc || imgs[i].getAttribute('src') || '')) { return false; }
    }
    return true;
  }

  // the media post ids on the current page, in order (feeds the viewer above)
  window.__rovaPageMediaIds = function () {
    var ids = [];
    Array.prototype.forEach.call(document.querySelectorAll('.post[data-view]'), function (p) {
      if (p.closest('.pfeed')) { return; }                     // skip the overlay's own cards
      if (!p.querySelector('.media img, .media video')) { return; }
      if (postIsGiphy(p)) { return; }                          // gifs never go full-screen
      var v = p.getAttribute('data-view'); if (v && ids.indexOf(v) < 0) { ids.push(v); }
    });
    return ids;
  };

  /* ---- LANDING ON A VIDEO PERMALINK MUST PLAY IT (owner 2026-08-08) ---------------------------------
     "landing on this link should play the video ... and paused: /p/15076".
     Nothing here starts a clip that the ordinary paths would refuse to start -- it is a PUMP, not a
     second policy. Everything it can do goes through __rovaPlayNow, which already owns the rules (the
     autoplay gear setting, _userPaused, PiP, re-attaching a released src, and the STAMPED mute that
     keeps the saved sound preference safe). The reason it is needed at all is that a direct load is the
     one open with no tap behind it and the most moving parts in front of it: the opener's own kick at
     __rovaFeedView is scoped to `.media:not(.carousel)` so a multi-clip post (this post: 5 videos) never
     gets one, and playIO's crossing can land before the element has any data, spend its single attempt,
     and leave the clip sitting at 0:00 forever. So re-ask, on a slow beat, until it is genuinely playing.
     AND IT ADMITS DEFEAT OUT LOUD. A refusal is a real outcome on the surface the owner recorded from --
     an in-app browser sheet opened from iMessage, plus iOS Low Power Mode, which throttles media hard
     and is invisible to script. When the clip has data (readyState >= 2 = there is a frame to paint) and
     is STILL paused after several attempts, that is a veto and not a slow network, so stop pretending:
     .pf-tapplay puts one honest full-screen affordance up (rova.css) whose tap is the gesture the
     browser was holding out for. It removes itself the moment anything starts playing. */
  function pfLandingAutoplay() {
    var t0 = Date.now(), tries = 0, shown = false;
    var pump = function () {
      var pf = document.querySelector('.pfeed.show');
      if (!pf) { if (Date.now() - t0 < 12000) setTimeout(pump, 200); return; }
      var v = window.__rovaPfCurrentVideo && window.__rovaPfCurrentVideo();
      if (!v) {                                     // a photo post, or the current slide is a photo
        if (Date.now() - t0 < 12000) setTimeout(pump, 300);
        return;
      }
      if (!v.paused) { pfTapPlay(pf, false); return; }        // playing: done, and clear any affordance
      if (v._userPaused) return;                              // they pressed pause: their call, stop asking
      if (window.__rovaPlayNow) { try { window.__rovaPlayNow(v); tries++; } catch (e) {} }
      // readyState >= 2 means the engine HAS a frame, so a still-paused element is a policy veto rather
      // than a stall. Two further beats of grace, then say so.
      if (!shown && tries >= 3 && v.readyState >= 2 && Date.now() - t0 > 1500) { shown = true; pfTapPlay(pf, true); }
      if (Date.now() - t0 < 12000) setTimeout(pump, 350);
    };
    setTimeout(pump, 250);
  }
  // The affordance itself. One control, centred over the viewer, removed by the first thing that plays.
  // The LAYER eats nothing (rova.css .pf-tapplay is pointer-events:none, only the disc and label are
  // targets); "tap anywhere" is delivered by the capture listener below, which retries the play and then
  // gets out of the way rather than by a full-screen button sitting on top of the caption and the roller.
  /* ONE DISMISSAL PATH, so the element and both of its listeners can never come apart. The capture
     `pointerdown` used to detach ITSELF on its first fire, which was only correct while the element
     also went on that first fire. Now that the affordance can survive a refusal, a self-detaching
     listener would leave a visible "Tap to play" whose "tap anywhere" half had already retired -- so
     the listeners are owned here, with the element, and go when it goes. */
  function pfTapPlayDrop(el) {
    if (!el || !el._pf) { if (el) el.remove(); return; }
    var pf = el._pf;
    if (el._any) pf.removeEventListener('pointerdown', el._any, true);
    if (el._playing) pf.removeEventListener('playing', el._playing, true);
    el._any = null; el._playing = null; el._pf = null;
    el.remove();
  }
  /* DISMISS ON THE PLAY RESOLVING, NEVER ON THE ATTEMPT.
     This used to call v.play() and then `el.remove()` unconditionally, on the next line, which is two
     bugs at once:
       1. THE READER LOST THE ONLY CONTROL THEY WERE OFFERED. A refused play removed the affordance
          anyway, and pfLandingAutoplay's `shown` latch means pfTapPlay is never asked again -- so one
          tap that the browser declined left a paused clip and nothing on screen to start it with.
          That is the worse half, and it has nothing to do with gestures.
       2. it removed the node the touch had hit, mid-gesture, which aborts the compositor scroll that
          was starting on it -- so a vertical swipe from the affordance moved the feed by nothing even
          after the element was moved into .pfeed-scroll. Measured on /p/15076, 390x844 and 1440x900,
          play() forced to reject: removal ALLOWED 0 -> 0, removal NEUTERED 0 -> 844 (centred
          15076 -> 11739), control 0 -> 844.
     So: on a REFUSAL the affordance stays visible and stays tappable, and a second tap is a fresh
     attempt. On success it goes -- via the play promise here, and independently via a real `playing`
     event (see below), which is the one signal that is true no matter WHAT started the clip.
     THE START IT DELIVERS IS UNMUTED (owner 2026-08-21, of the /p/<id> permalink: "I rather if i
     click the post it starts unmuted"). This used to touch nothing about mute, for two stated
     reasons, and both are answered rather than ignored:
       - "an unstamped mute change ... flipping soundOn and the saved preference": that is now the
         POINT. The tap-anywhere-for-sound branch in the main IIFE (search "SOUND FIRST") already
         unmutes a muted viewer clip with a deliberately UNSTAMPED write -- "this IS the reader" --
         and this tap is the same reader asking for the same playback one veto earlier. A tap on
         "Tap to play" is a request to WATCH, and on this site watching comes with sound.
       - "on WebKit, muted=false on a clip playing under the muted-autoplay allowance silently
         pauses it": the guard below only unmutes a clip that is PAUSED AND MUTED, i.e. exactly the
         vetoed-autoplay state this affordance exists for, so that trap cannot fire -- the unmute
         and the play() land together inside the reader's gesture, which is soundArm's own shape
         (spend the gesture synchronously; the sound closure documents that out-of-gesture unmutes
         are refused). A clip that is already unmuted, or already playing, starts exactly as before.
     _sndPromotedAt is stamped for the same reason promoteSound stamps it: the "tap anywhere" half
     of this control runs on POINTERDOWN, and WebKit does not grant activation until the up edge --
     so on iOS this attempt can be refused and the CLICK under the same finger then falls through to
     the media tap handler. The stamp tells that handler "this gesture was already about sound", so
     its promoted branch finishes the start (unmute is a no-op, play() runs in the click's real
     activation) instead of treating the tap as play/pause.
     THE GRANT IS TAKEN OFF THE PROMISE, never the attempt, exactly as armSettle rules: recording
     __rovaSoundGranted on a refused play would let applySound start unmuting out-of-gesture on a
     page the engine still has locked (the lying-glyph bug). An AbortError is our own teardown, not
     a veto, so it counts. The grant matters here because applySound's steady-state sweep MUTES
     every clip while the page is locked -- without it, the sweep would silently take back the very
     sound this tap just started. soundRepair is the honesty net on the other side: if the unmute
     turns out to make no audio, it re-mutes through the stamped engine path and the pill returns. */
  function pfTapPlayGo(el) {
    var v = window.__rovaPfCurrentVideo && window.__rovaPfCurrentVideo();
    // no clip to start: the affordance is describing something that is not there, so retire it
    if (!v) { pfTapPlayDrop(el); return; }
    v._userPaused = false;
    var unmuted = false;
    if (v.paused && v.muted) {                 // the vetoed-autoplay state, and ONLY that state
      v.muted = false;                         // in-gesture: the one write WebKit honours (soundArm's shape)
      v._sndPromotedAt = Date.now();           // the click edge under this tap is about SOUND, not play/pause
      unmuted = true;
    }
    var granted = function () {
      if (!unmuted) { return; }
      if (window.__rovaSoundGranted) { try { window.__rovaSoundGranted(); } catch (eg) {} }
      if (window.__rovaSoundRepair) { try { window.__rovaSoundRepair(v); } catch (er2) {} }
    };
    var p;
    try { p = v.play(); } catch (e) { p = null; }
    if (p && p.then) {
      p.then(function () { granted(); pfTapPlayDrop(el); }, function (er) {
        // refused: the affordance STAYS. An abort is our own teardown, not a veto (armSettle's rule).
        var n = er && (er.name || '');
        if (n === 'AbortError' || (er && er.code === 20)) { granted(); }
      });
    } else if (!v.paused) {
      granted();
      pfTapPlayDrop(el);   // an engine with no play() promise, already running
    }
  }
  /* THE SAME AFFORDANCE, REACHABLE FROM THE VIDEO ENGINE. The app-switch resume ladder (search
     __rovaVidResume) ends on exactly this control when a play() is refused -- Low Power Mode is the
     case it was written for, and it is the same platform veto pfLandingAutoplay reports here. Wiring
     it as a hook rather than copying the element is the point: one "Tap to play" on this site, one
     set of dismissal rules (pfTapPlayDrop, plus the capture `playing` listener that takes it down
     whatever started the clip). It is a no-op when the viewer is not open, so the caller does not
     have to know which surface it is on. */
  window.__rovaPfTapPlay = function (on) {
    var pf = document.querySelector('.pfeed.show');
    if (pf) { pfTapPlay(pf, !!on); }
  };
  function pfTapPlay(pf, on) {
    var el = pf.querySelector('.pf-tapplay');
    if (!on) { pfTapPlayDrop(el); return; }
    if (el) return;
    el = document.createElement('div');
    el.className = 'pf-tapplay';
    el.innerHTML = '<button type="button" class="pf-tapplay-ic" aria-label="Play video">'
                 + '<svg viewBox="0 0 24 24" width="34" height="34" fill="currentColor" aria-hidden="true">'
                 + '<path d="M8 5.2c0-.9 1-1.5 1.8-1l9 6.8c.7.5.7 1.5 0 2l-9 6.8c-.8.5-1.8-.1-1.8-1z"/></svg></button>'
                 + '<span class="pf-tapplay-lab">Tap to play</span>';
    el.querySelector('.pf-tapplay-ic').addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      pfTapPlayGo(el);
    });
    // ANY tap inside the viewer is the gesture the browser was waiting for, so spend it. Capture, no
    // preventDefault and no stopPropagation: whatever the reader actually touched still does its own job.
    // It no longer detaches itself -- pfTapPlayDrop owns that, so "tap anywhere" stays true for as long
    // as the affordance is on screen rather than for exactly one refused attempt.
    el._pf = pf;
    var any = function () { pfTapPlayGo(el); };
    el._any = any;
    pf.addEventListener('pointerdown', any, true);
    /* THE OTHER WAY OUT, and the authoritative one: the clip actually PLAYING. The play promise above
       only reports on the attempt THIS control made, so it cannot see a clip started by anything else
       -- pfLandingAutoplay's own pump keeps calling __rovaPlayNow every 350ms, playIO can hand the
       post its play, and a reader can hit the player's own control. Any of those must take the
       affordance down, or it sits over a running video.
       CAPTURE, because `playing` does not bubble: a non-bubbling event still propagates to ancestors
       in the capture phase, so one listener on the viewer covers every <video> under it, including
       ones that do not exist yet. That is also why this is not attached to a particular element --
       the "current" clip changes with every slide and every swipe.
       ...AND IT MUST ASK WHICH CLIP SPOKE. A bare listener here is wrong, and measurably so: the
       carousel's next-slide primer (primeNext) deliberately STARTS an off-slide clip, muted, to warm
       its decoder, so a `playing` from a neighbour would take the affordance down while the clip the
       reader is looking at is still frozen -- the exact failure this control exists to report. Caught
       in verification: the affordance cleared with __rovaPfCurrentVideo() still `paused: true`. So the
       event only counts when it comes from the CURRENT clip, which is the same element pfTapPlayGo
       plays and the same one pfLandingAutoplay watches. */
    var onPlaying = function (e) {
      var v = window.__rovaPfCurrentVideo && window.__rovaPfCurrentVideo();
      if (v && e.target !== v) return;      // a primed neighbour, not the clip this affordance is about
      pfTapPlayDrop(el);
    };
    el._playing = onPlaying;
    pf.addEventListener('playing', onPlaying, true);
    /* INTO THE SCROLLER, for the reason hfBuild() records at length: a box appended to .pfeed is a
       SIBLING of .pfeed-scroll, so a touch that starts on it has no scrollable ancestor and a vertical
       swipe from it moves the feed by nothing. The LAYER is pointer-events:none so it never had the
       defect, but .pf-tapplay-ic and .pf-tapplay-lab are pointer-events:auto and they sit in the DEAD
       CENTRE of the screen -- a 76px disc plus its label, on the one screen a reader is most likely to
       swipe past, because the clip in front of them is refusing to play. Same one-word fix, same
       reason it costs nothing: .pfeed-scroll is position:static, so `position:absolute;inset:0` here
       still resolves against .pfeed and the layer covers exactly the same rect it did before.
       The `|| pf` is not defensive padding -- pfTapPlay is called with whatever `.pfeed.show` returns,
       and this must never throw on a viewer that has not built its scroller yet.

       THE PARENTAGE WAS ONLY HALF OF IT, and the other half is fixed in pfTapPlayGo above rather than
       here: the capture `pointerdown` used to remove `el` UNCONDITIONALLY on the first touch of the
       gesture, and detaching the node the touch hit aborts the compositor scroll starting on it. Both
       halves were measured separately on /p/15076 at 390x844 and 1440x900 with real CDP touch, the
       veto forced by making HTMLMediaElement.play() reject -- the browser flag does not block MUTED
       autoplay in the headless shell, so --autoplay-policy reads as a false negative here (the clip
       played to 7.97s under document-user-activation-required); see C:\tools\pw\zz-tapplay-pan.js:
         removal ALLOWED    scrollTop 0 -> 0     (dead)
         removal NEUTERED   scrollTop 0 -> 844   centred 15076 -> 11739
         layer pre-deleted, same origin, touch lands on the media: 0 -> 844   (the control)
       The neutered run is what proves the move on this line IS correct and IS sufficient for the pan
       chain; the removal was a second, independent defect and is now conditioned on the play actually
       resolving. */
    (pf.querySelector('.pfeed-scroll') || pf).appendChild(el);
  }

  // A shared permalink (/p/123) that carries real media opens STRAIGHT into the immersive viewer;
  // a text-only post stays on the permalink page. The server marks the wrap (data-pfeed-open); a GIF
  // or a link post never goes full-screen. Crawlers run no JS, so they still index the full page.
  (function () {
    var opened = false;
    function open(noWait) {
      if (opened) return;
      if (!document.querySelector('[data-pfeed-open]')) return;
      // A comment notification lands here as /p/123#c<id>: keep the page (comments visible) so we can
      // scroll to that comment, instead of covering it with the full-screen media viewer.
      if (/^#c\d+$/.test(location.hash || '')) return;
      var post = document.querySelector('.post[data-view]');   // the permalink's own post (first card)
      if (!post || !post.querySelector('.media img, .media video') || postIsGiphy(post)) return;
      var pid = post.getAttribute('data-view'); if (!pid) return;
      /* WHICH SLIDE THIS LINK IS FOR. Three sources, most-trusted first; the first one that answers
         wins, and nothing below re-derives what one above already decided.
           1. data-open-slide -- the SERVER'S 0-based, already-clamped answer to ?slide=<n>
              (views/post_single.php). PREFERRED, because it is the same number the first-paint stage
              behind this overlay is ALREADY painting: taking it verbatim is what makes it impossible
              for the stage to show 3/6 while the viewer lands on slide 1, which is the whole point.
           2. ?slide=<n>      -- 1-based. The fallback for a document that reached us without the
              attribute (an old edge-cached body, a partial re-render). Clamped below.
           3. #m<n>           -- 0-based, the profile-grid deep link. Kept working forever: those URLs
              are already shared and already indexed.
         A URL with none of them is si = 0, i.e. today's behaviour, unchanged. */
      var pfWrap = document.querySelector('[data-pfeed-open]');
      var osAttr = pfWrap ? pfWrap.getAttribute('data-open-slide') : null;
      var si = (osAttr !== null && osAttr !== '') ? parseInt(osAttr, 10) : -1;
      if (!(si >= 0)) {
        var qm = (location.search || '').match(/[?&]slide=(\d+)/);
        if (qm) { si = parseInt(qm[1], 10) - 1; }
      }
      if (!(si >= 0)) {
        var sm = (location.hash || '').match(/#m(\d+)/);       // /p/123#m1 opens on that slide
        si = sm ? parseInt(sm[1], 10) : 0;
      }
      if (!(si >= 0)) { si = 0; }
      // /p/123#t=12.4 -- an embed's "Continue on Rova": resume the video where the embed left off.
      // A FRAGMENT, never ?t=: it never reaches the origin, so it can't fragment the edge cache and
      // can't disturb the ?ref= referral credit sitting in the query string next to it.
      // Anyone can hand-edit a fragment, so treat it as hostile: only a plain non-negative decimal
      // is read at all, an absurd value is dropped, and the real clamp to the clip's duration happens
      // in pfResume (t past the end restarts at 0). Anything else falls through to startTime 0 =
      // today's behaviour, so a bogus value can only ever mean "start from the beginning".
      var tm = (location.hash || '').match(/^#t=(\d+(?:\.\d+)?)$/);
      var st = tm ? parseFloat(tm[1]) : 0;
      if (!isFinite(st) || st <= 0 || st > 86400) { st = 0; }
      // Hero-zoom the on-page photo up into the viewer -- the SAME zoom a tap on it gets (see the
      // feed click path) -- so the open reads as the photo growing into place, not the overlay
      // fading in over a photo that then re-paints at a different size. Photos only (a video paints
      // fresh in the viewer anyway), only the slide the viewer will land on, and never a gated one.
      var media = post.querySelector('.media');
      var slides = media ? media.querySelectorAll('.cslide') : [];
      // OUT OF RANGE -> THE LAST REAL SLIDE. A slide index is not stable across edits: the author can
      // delete or reorder slides long after the link was shared, and a link that pointed near the end
      // is best answered by the end. Never an error, never an empty stage, never slides[undefined].
      si = slides.length ? Math.min(si, slides.length - 1) : 0;
      var hzHost = slides.length ? slides[si] : media;
      var hzImg = (hzHost && !hzHost.querySelector('video')) ? hzHost.querySelector('img') : null;
      // FIRST-PAINT STAGE (views/post_single.php, rova.css .perma-stage): the server has been painting
      // this post's first slide full-screen since first contentful paint, so by the time we get here the
      // reader has NOT been looking at the post page -- they have been looking at the still, at the size
      // the viewer is about to land on. That changes two things below, and both are about not showing
      // motion the reader has no reason to expect.
      var pstage = document.getElementById('pstage');
      if (pstage) { hzImg = null; }
      if (hzImg && !(hzImg.complete && hzImg.naturalWidth > 0) && !noWait) {
        // the photo often finishes a beat AFTER DOMContentLoaded: give it a short grace so the
        // open can still zoom it up, capped so a slow network never stalls the viewer (past the
        // cap the photo hasn't painted on the page either, so there is nothing to zoom from).
        var go = function () { open(true); };
        hzImg.addEventListener('load', go, { once: true });
        setTimeout(go, 400);
        return;
      }
      opened = true;
      if (hzImg && hzImg.complete && hzImg.naturalWidth > 0 && window.__rovaHeroZoom
          && !hzImg.closest('.nsfw-gate')) {
        window.__rovaHeroZoom(hzImg.getBoundingClientRect(), hzImg.currentSrc || hzImg.src,
                              hzImg.naturalWidth, hzImg.naturalHeight, false, true,
                              (hzImg.closest('.cslide') || media).getBoundingClientRect());
      }
      window.__rovaFeedView([pid], pid, si, st, false, false, true);
      // RETIRE THE STAGE, on the DESTINATION's own first frame -- never on a timer and never on
      // ".pfeed exists". Measured before this landed: the viewer became opaque at ~4.5s while its own
      // first slide had no decodable frame until ~7-9s, so releasing on the class just moved the black
      // gap later instead of removing it. Same law the hero flights learned (hz-hold / awaitStageReady):
      // a covering still is released by the thing it is covering FOR.
      //   - a photo slide is ready when the image has decoded;
      //   - a video slide is ready at readyState >= 2 (HAVE_CURRENT_DATA = there is a frame to paint),
      //     or as soon as the viewer's own poster stand-in has painted, which is the same picture;
      //   - a PAGE releases it immediately: the stage shows slide 1, so the instant the reader moves off
      //     it a held still would be showing the wrong slide. Gestures already pass through it
      //     (pointer-events:none once .pfeed.show, see rova.css).
      //     A PAGE, not a TOUCH (2026-08-08). This used to fire on the first touchstart/pointerdown
      //     anywhere in the document, which is the "black again, header only" state in the owner's
      //     recording: the viewer becomes opaque ~1s (4x CPU: ~3s) before it has a single decodable
      //     frame, so any stray tap in that window tore the covering still off and handed him the raw
      //     black overlay with nothing but the top bar on it. And a tap is not a stale picture -- the
      //     still is still exactly what the viewer is about to show. So a touch now only releases the
      //     stage once the viewer has something of its own to paint; if the reader actually PAGES, the
      //     scroller says so and the release is immediate regardless.
      //   - the 6s cap is the honest floor. Past it we are hiding a stall rather than covering a
      //     hand-off, and the viewer's own spinner is the truthful thing to show.
      if (pstage) {
        var psT0 = Date.now();
        // ONE definition of "the viewer has something of its own to paint", read by all three release
        // paths below, so a touch and the poll can never disagree about whether the hand-off is safe.
        var psPixels = function () {
          var pf = document.querySelector('.pfeed.show'); if (!pf) return false;
          var mv = pf.querySelector('.post .media video, .post .cslide video');
          var mi = pf.querySelector('.post .media img:not(.pfv-img), .post .cslide img:not(.pfv-img)');
          var ps = pf.querySelector('.pfv-img');
          return !!((mv && mv.readyState >= 2)
                 || (mi && mi.complete && mi.naturalWidth > 0)
                 || (ps && ps.complete && ps.naturalWidth > 0));
        };
        var psTouch = function () { if (psPixels()) psGo(); };
        // an ACTUAL page is the case the touch release was written for, and it is answerable directly
        // instead of by proxy: the viewer's own scroller has moved off the post the stage is a still of
        var psScroll = function (e) {
          var t = e && e.target;
          if (t && t.classList && t.classList.contains('pfeed-scroll') && t.scrollTop > 4) psGo();
        };
        // PASSIVE, and capture only so a viewer handler that stops propagation cannot hide the gesture
        // from us. A non-passive touchstart listener on the document makes the compositor wait on the
        // main thread for every single touch -- exactly the per-gesture tax this file spends pages
        // avoiding -- and all three of these listeners are removed the moment the stage is released.
        var PSOPT = { capture: true, passive: true }, PSOFF = { capture: true };
        var psGo = function () {
          document.removeEventListener('touchstart', psTouch, PSOFF);
          document.removeEventListener('pointerdown', psTouch, PSOFF);
          document.removeEventListener('scroll', psScroll, PSOFF);
          if (!pstage.isConnected) return;
          pstage.classList.add('ps-done');
          setTimeout(function () { if (pstage.parentNode) pstage.parentNode.removeChild(pstage); }, 260);
        };
        document.addEventListener('touchstart', psTouch, PSOPT);
        document.addEventListener('pointerdown', psTouch, PSOPT);
        document.addEventListener('scroll', psScroll, PSOPT);
        (function drop() {
          if (!pstage.isConnected) return;
          if (psPixels()) { psGo(); return; }
          if (Date.now() - psT0 > 6000) { psGo(); return; }
          setTimeout(drop, 80);
        })();
      }
      pfLandingAutoplay();
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { open(false); }); }
    else { open(false); }
  })();

  /* Deep-link to a specific comment (/p/123#c<id>, from a comment notification): scroll it into view
     and flash a highlight so it's obvious which one. Runs after layout so the comment is measurable.

     ONE PLACE FOR EVERY NOTIFICATION TYPE. The server decides which rows point at a comment --
     Notifications::commentTarget(), asked by the web bell (views/_notif_list.php), the emails
     (EmailNotify) and push (Push) alike -- and every one of them says so with the SAME
     "/p/<post>#c<id>" shape. So `comment`, `reply`, `clike`, `mention` and `also` all arrive here,
     and there is no per-type branch to keep in step.

     THE SCROLL WAS NEVER WRONG -- IT WAS OVERTAKEN (owner, 2026-08-08: "brought me to the page but
     didn't scroll to the comment... her water comment wasn't on screen when i clicked it").
     Measured on his own thread (/p/15141#c25038, headless iPhone profile, comment GIFs delayed to
     cellular speed): the scroll below ran at t=678ms and was EXACTLY right -- the target sat at
     y=294.8 with all 73.8px of it on screen. At t=1700ms and t=1721ms the two GIF comments ABOVE it
     finished decoding. comment_gif_img() (lib/view.php) emits a bare <img class="msg-gif"> and
     rova.css sizes it `max-width:220px;width:100%` with NO height, so each one is 0px tall until it
     decodes and its natural height after: #comment-list's scrollHeight went 988 -> 1219 and the
     target was pushed 230px down, straight out of the bottom of that 480px .cl-scroll window
     (visible height 73.8px -> 0px). It came back only when he scrolled. Chrome's scroll anchoring
     only softened it (231px of growth still moved him 101px); iOS Safari has no scroll anchoring at
     all, which is why he saw the full displacement.

     SO HOLD THE TARGET WHILE THE THINGS ABOVE IT SETTLE. Placing once is not a landing, it is a
     guess about a layout that has not happened yet.

     THE SHIFT ITSELF IS FIXED NOW -- KEEP THIS ANYWAY (migration 0133, 2026-08-08). comments
     carries gif_w/gif_h, the picker stores the Giphy rendition's own pixel size, all 78 existing
     rows were backfilled, and comment_gif_img() emits width/height so the box is reserved before
     the bytes arrive. Re-measured on /p/15141#c25038 with giphy delayed 1500ms: #comment-list
     scrollHeight is now 1498 at first paint and 1498 seven seconds later -- zero growth, where the
     same page without the attributes still moves 1223 -> 1498.

     This is BELT AND BRACES, not redundancy. The reservation only exists when a row HAS a pair,
     and three ordinary situations leave it without one: a Giphy asset that no longer resolves (the
     backfill leaves those NULL on purpose, because a wrong box never settles while an absent one
     ends up correct), a client that posts a GIF without sending dimensions, and any unsized image
     a future comment feature adds. Deliberately unchanged, too: this handler derives what it waits
     on by MEASUREMENT -- an image that has not arrived AND reserves no height -- so a sized GIF
     simply drops out of `pending` and the hold releases sooner, with no edit here. Verified after
     0133 landed: the fixed page still places, flashes and holds, and the stripped-attribute page
     (i.e. a NULL row) is still rescued by it with the target never leaving the window.

     THE HOLD IS CANCELLED BY THE READER, INSTANTLY. Re-scrolling someone who has started reading is
     its own bug, so the first wheel / touch / pointer / key event ends the hold for good -- and it
     is registered in the CAPTURE phase so nothing on the page can swallow it first.

     HOW LONG IT HOLDS IS DECIDED BY THE MEDIA, NOT BY A CONSTANT. A fixed window is a bet on the
     network: the same measurement above, re-run against the fix, held the target through the first
     GIF and then lost it to the second one, which did not decode until t=4.9s. So the hold ends
     when the media above the target has actually SETTLED (every one of them `complete`), and
     HOLD_MS is only the floor -- it stretches, in small steps, up to a hard MAX_HOLD_MS ceiling so
     a dead image can never hold the page open. And because a straggler is the failure mode, the
     images above the target stop being `loading="lazy"` the moment a deep link is in play: they are
     the layout this landing depends on, so they are fetched now rather than when something happens
     to scroll near them. Nothing below the target is touched -- that is still lazy, as it should
     be. */
  (function () {
    var m = (location.hash || '').match(/^#c(\d+)$/);
    if (!m) return;
    var HOLD_MS = 3200;         // floor: hold at least this long
    var MAX_HOLD_MS = 8000;     // ceiling: a stuck image never holds the page past this
    var STEP_MS = 250;          // how often the floor is re-checked once media is still in flight
    var INPUT = ['wheel', 'touchstart', 'pointerdown', 'mousedown', 'keydown'];
    var el = null, ro = null, timer = null, flashT = null, live = false, placedAt = 0, sizedAt = 0;
    var watch = [], pending = [], t0 = 0, lastFlash = 0;

    function place() {
      if (!el || !live) return;
      try { el.scrollIntoView({ block: 'center' }); } catch (e) { try { el.scrollIntoView(); } catch (e2) {} }
    }
    function flash() {
      if (!el) return;
      // never re-trigger fast enough to read as a blink
      var now = Date.now();
      if (lastFlash && now - lastFlash < 700) return;
      lastFlash = now;
      el.classList.remove('comment-flash');
      void el.offsetWidth;              // restart the 2.2s pulse from the top
      el.classList.add('comment-flash');
      if (flashT) clearTimeout(flashT);
      flashT = setTimeout(function () { if (el) el.classList.remove('comment-flash'); }, 2200);
    }
    function moved() {
      if (!el || !live) return;
      var r = el.getBoundingClientRect();
      // TOP *or* HEIGHT. Media ABOVE the target pushes its top down; media INSIDE it (a GIF
      // comment is very often the one being linked to) leaves the top alone and grows the box
      // out through the bottom of the .cl-scroll window instead. Both are "no longer placed".
      if (Math.abs(r.top - placedAt) < 1 && Math.abs(r.height - sizedAt) < 1) return;
      place();
      r = el.getBoundingClientRect();
      placedAt = r.top; sizedAt = r.height;
      // the highlight is what tells them WHICH comment they were sent to, and a 2.2s pulse that
      // started before the reflow is over by the time the comment arrives -- so it rides with it.
      flash();
    }
    /** Every image that can still CHANGE SIZE has finished (or failed). Only the unsized ones are
     *  asked about: an avatar in its fixed 40px box, or a link-card thumb in its 54px one, occupies
     *  its space whether it has arrived or not, so a slow one of those is not a reason to keep
     *  holding -- and waiting on all 40-odd avatars in a thread would let one dead request run the
     *  hold to its ceiling every time. */
    function settled() {
      for (var i = 0; i < pending.length; i++) {
        if (!pending[i].complete) return false;
      }
      return true;
    }
    function maybeRelease() {
      timer = null;
      if (!live) return;
      var age = Date.now() - t0;
      if (settled() || age >= MAX_HOLD_MS) { release(); return; }
      timer = setTimeout(maybeRelease, STEP_MS);   // still in flight: keep holding, in small steps
    }
    function onLoad(e) {
      var t = e.target;
      if (!t || !t.tagName || !/^(IMG|VIDEO|IFRAME)$/.test(t.tagName)) return;
      if (!el) return;
      // media ABOVE the target pushes it down; media INSIDE it grows it out of the window
      if (!el.contains(t) && !(el.compareDocumentPosition(t) & 2 /* DOCUMENT_POSITION_PRECEDING */)) return;
      moved();
    }
    function release() {
      live = false;
      if (ro) { try { ro.disconnect(); } catch (e) {} ro = null; }
      if (timer) { clearTimeout(timer); timer = null; }
      document.removeEventListener('load', onLoad, true);
      for (var i = 0; i < INPUT.length; i++) window.removeEventListener(INPUT[i], release, true);
      /* W#58 (owner 2026-08-11: dragging a video scrubber "scrolls down to the end of the page").
         The landing is DONE -- either the media above it settled or the reader took over -- but the
         URL still says #c<id>, and Safari's deferred fragment re-anchor is allowed to fire again
         long after load (a late layout pass can re-run the fragment scroll), yanking the page back
         to the comment mid-read. Strip the fragment so there is nothing left to re-anchor to.
         replaceState: no new history entry, no scroll of its own, Back behaves exactly as before.
         Guarded on the hash still being OURS -- if something else already rewrote it (the composer's
         #compose, a viewer deep link), it is not this handler's to erase. */
      if ((location.hash || '') === '#c' + m[1]) {
        try { history.replaceState(null, '', location.pathname + location.search); } catch (e) {}
      }
    }
    function go() {
      el = document.querySelector('.comment[data-comment="' + m[1] + '"]')
        || document.querySelector('[data-comment="' + m[1] + '"]');
      if (!el) return;                  // deleted between the notification and the tap: stay put
      live = true;
      t0 = Date.now();
      place();
      var r0 = el.getBoundingClientRect();
      placedAt = r0.top; sizedAt = r0.height;
      flash();

      for (var i = 0; i < INPUT.length; i++) window.addEventListener(INPUT[i], release, true);
      document.addEventListener('load', onLoad, true);

      // Everything that can unseat this landing: media ABOVE the target (pushes it down) and media
      // INSIDE it (grows it out through the bottom). Collected once, from the thread it lives in.
      var scope = (el.closest && el.closest('#comment-list')) || el.parentNode || null;
      var media = scope && scope.querySelectorAll ? scope.querySelectorAll('img, video, iframe') : [];
      for (var j = 0; j < media.length; j++) {
        if (el.contains(media[j]) || (el.compareDocumentPosition(media[j]) & 2)) watch.push(media[j]);
      }
      /* Of those, the ones that can actually MOVE anything: an image that has not arrived AND has
         no reserved height. Deriving the set by MEASUREMENT rather than by class is what makes
         this survive the permanent fix: since 0133 a .msg-gif with stored dimensions reserves its
         box from the attributes and measures its full height before a byte arrives, so it drops
         out of this set on its own and the hold releases sooner -- while a row whose dimensions
         could not be resolved is still `max-width:220px;width:100%` with no height, measures 0
         until it decodes, and is still caught. An avatar (fixed 40px box) and a link-card thumb
         (fixed 54px) occupy their space either way and cannot shift a thing. Same expression,
         and a future unsized image in a comment is covered the day it ships.
         Then stop them straggling: an image this landing depends on must not wait on a lazy-load
         heuristic. Only these, and only on a deep link -- everything else on the page stays lazy,
         which matters on a CPU-bound origin. */
      for (var k = 0; k < watch.length; k++) {
        var n = watch[k];
        if (n.tagName !== 'IMG' || n.complete) continue;
        if (n.getBoundingClientRect().height >= 4) continue;   // already holds its own space
        pending.push(n);
        try { n.loading = 'eager'; } catch (e) {}
        try { n.fetchPriority = 'high'; } catch (e) {}
      }
      // Watch them for a size change. A ResizeObserver fires only when a box actually resizes, so
      // this costs nothing per frame -- the wrong shape here would be an rAF poll (see the
      // per-frame-tax notes).
      if (window.ResizeObserver) {
        try {
          ro = new ResizeObserver(function () { moved(); });
          for (var q = 0; q < watch.length; q++) ro.observe(watch[q]);
        } catch (e) { ro = null; }
      }
      timer = setTimeout(maybeRelease, HOLD_MS);
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { setTimeout(go, 60); }); }
    else { setTimeout(go, 60); }
  })();
})();

/* ===================== HERO-OPEN TRACE (diagnostic, round 166) =========================
   Load ANY page with ?hztrace (e.g. rovasocial.com/@you?hztrace), then tap a photo. ~3s after
   the zoom starts, a green panel shows the frame-by-frame geometry of the zoom CLONE vs the real
   PHOTO -- the OBJECT-FIT-aware VISIBLE rect (where the pixels actually draw), on YOUR device.
   It prints the biggest hero-vs-photo mismatch during the cross-fade (HANDOFF JUMP) and how far
   the photo drifts after the clone is gone (PHOTO DRIFT). Screenshot the panel + send it; tap it
   to dismiss; works for repeated taps. Delete this block once we've found it. */
(function () {
  try { if (!/hztrace/.test(location.search + location.hash)) return; } catch (e) { return; }
  function vis(el) {
    if (!el) return null;
    var r = el.getBoundingClientRect(); var nw = el.naturalWidth || el.videoWidth, nh = el.naturalHeight || el.videoHeight;
    if (!nw || !nh || !r.width) return { l: Math.round(r.left), t: Math.round(r.top), w: Math.round(r.width), h: Math.round(r.height) };
    var of = 'cover'; try { of = getComputedStyle(el).objectFit || 'cover'; } catch (e) {}
    var na = nw / nh, ea = r.width / r.height, w, h;
    if (of === 'cover') { if (na > ea) { h = r.height; w = h * na; } else { w = r.width; h = w / na; } }
    else { if (na > ea) { w = r.width; h = w / na; } else { h = r.height; w = h * na; } }
    return { l: Math.round(r.left + (r.width - w) / 2), t: Math.round(r.top + (r.height - h) / 2), w: Math.round(w), h: Math.round(h) };
  }
  function centeredMedia() {
    var cx = innerWidth / 2, cy = innerHeight / 2, ms = document.querySelectorAll('.pfeed.show .post .media:not(.carousel)');
    for (var i = 0; i < ms.length; i++) { var b = ms[i].getBoundingClientRect(); if (b.width > 4 && cx >= b.left && cx <= b.right && cy >= b.top && cy <= b.bottom) return ms[i].querySelector('img'); }
    return null;
  }
  var recording = false, rec, heroAt, stopT;
  function arm() { (function w() { if (recording) return; if (document.querySelector('.pf-hero')) { start(); return; } requestAnimationFrame(w); })(); }
  function start() {
    recording = true; rec = []; heroAt = Date.now(); stopT = heroAt + 3000;
    (function loop() {
      if (!recording) return;
      var hero = document.querySelector('.pf-hero'), mi = centeredMedia();
      rec.push({ t: Date.now() - heroAt, op: hero ? +(+getComputedStyle(hero).opacity).toFixed(2) : null, hv: vis(hero), mv: vis(mi), hz: document.documentElement.classList.contains('hz-hold') ? 1 : 0 });
      if (Date.now() > stopT) { recording = false; render(); arm(); return; }
      requestAnimationFrame(loop);
    })();
  }
  function render() {
    var jump = -1, jumpAt = -1, jd = '';
    for (var i = 0; i < rec.length; i++) { var f = rec[i]; if (f.hv && f.mv && f.op != null && f.op < 1) { var s = Math.abs(f.mv.w - f.hv.w) + Math.abs(f.mv.h - f.hv.h) + Math.abs(f.mv.l - f.hv.l) + Math.abs(f.mv.t - f.hv.t); if (s > jump) { jump = s; jumpAt = f.t; jd = 'w' + (f.mv.w - f.hv.w) + ' h' + (f.mv.h - f.hv.h) + ' l' + (f.mv.l - f.hv.l) + ' t' + (f.mv.t - f.hv.t); } } }
    var first = null, last = null;
    for (var j = 0; j < rec.length; j++) { if (!rec[j].hv && rec[j].mv) { if (!first) first = rec[j].mv; last = rec[j].mv; } }
    var drift = first && last ? ('w' + (last.w - first.w) + ' h' + (last.h - first.h) + ' l' + (last.l - first.l) + ' t' + (last.t - first.t)) : 'n/a';
    var L = ['HERO-OPEN TRACE  frames=' + rec.length,
      '>> HANDOFF JUMP (photo - clone): ' + jd + '  @' + jumpAt + 'ms',
      '>> PHOTO DRIFT after clone gone: ' + drift,
      't|op|clone[l,t,w,h]|photo[l,t,w,h]|hz'];
    for (var k = 0; k < rec.length; k++) { var r2 = rec[k]; L.push(r2.t + '|' + (r2.op == null ? '-' : r2.op) + '|' + (r2.hv ? r2.hv.l + ',' + r2.hv.t + ',' + r2.hv.w + ',' + r2.hv.h : '-') + '|' + (r2.mv ? r2.mv.l + ',' + r2.mv.t + ',' + r2.mv.w + ',' + r2.mv.h : '-') + '|' + r2.hz); }
    var pre = document.createElement('pre');
    pre.textContent = L.join('\n');
    pre.style.cssText = 'position:fixed;inset:8px;z-index:2147483647;overflow:auto;margin:0;padding:10px;background:rgba(0,0,0,.92);color:#0f0;font:10px/1.35 monospace;white-space:pre;border:2px solid #0f0;border-radius:8px;-webkit-overflow-scrolling:touch';
    pre.addEventListener('click', function () { pre.remove(); });
    document.body.appendChild(pre);
  }
  arm();
})();

/* ---- @-MENTION AUTOCOMPLETE (web parity with the app, owner 2026-07-31) --------------------
   The app has had this since #291: type '@' in a caption and matches appear, tap one and it
   swaps the half-typed handle for the real one. The web had the SERVER half only -- posting
   "@rob" from the web already notifies him via notify_mentions() -- but nothing while typing,
   so you had to know the handle exactly.

   ITS OWN IIFE, ON PURPOSE. The file header is explicit that this is one ~21,000-line top-level
   IIFE and that an uncaught throw at its top level aborts the entire script, silently deleting
   every subsystem registered after it. A late feature has no business inside that blast radius
   in either direction, so this sits after it and wraps its own body in try/catch.

   Fields: [name="body"], TEXTAREA or INPUT -- composer, comment, edit, quote, and the one-line
   reply boxes. That is exactly the set whose content runs through notify_mentions() server-side,
   so the affordance appears precisely where a mention would actually do something. Delegated from
   document, so comment boxes that appear later are covered without re-binding.

   IT WAS TEXTAREA-ONLY UNTIL 2026-08-03, and that was a bug, not a policy. The one-line reply on
   the notifications rows (views/_at_items.php, `<input class="input" name="body">`) posts a real
   comment through the same reply endpoint and the same notify_mentions(), but was excluded purely
   by TAG NAME, so typing "@sher" there populated nothing. Reported by the owner with a screenshot.
   Everything below already works on an INPUT unchanged: selectionStart/End, setSelectionRange and
   .value are shared with TEXTAREA, and the Enter handler is on the CAPTURE phase and calls both
   preventDefault and stopPropagation, so picking a handle cannot submit the surrounding form.

   DM BOXES ARE STILL EXCLUDED, deliberately. A DM carries no mention fan-out, so an autocomplete
   there would offer an affordance that does nothing on send. That is the same rule as before,
   applied by what the field DOES rather than by which element it happens to be.

   The token rule is COPIED from the app (src/components/InlineComposer.js MENTION_RE) rather
   than re-invented: an '@' at a word boundary followed by up to 30 handle characters, anchored
   to the caret. Two surfaces disagreeing about what counts as a mention is its own bug. */
(function () {
  'use strict';
  try {
    var RE = /(^|[\s\n([{])@([A-Za-z0-9_.]{1,30})$/;
    var MIN = 2;        // /search returns [] under 2 chars -- don't fire a request that cannot match
    var box = null, rows = [], sel = -1, field = null, tok = null, timer = null, seq = 0;

    function close() {
      if (box && box.parentNode) box.parentNode.removeChild(box);
      box = null; rows = []; sel = -1; tok = null; field = null;
      clearTimeout(timer);
    }
    var DM_SEL = '.js-dm, .dm-compose, .hdrop-compose';   // no mention fan-out on a DM
    function isTarget(el) {
      if (!el || el.getAttribute('name') !== 'body') return false;
      var tag = el.tagName;
      if (tag !== 'TEXTAREA' && tag !== 'INPUT') return false;
      // an INPUT that cannot hold free text (checkbox, file, hidden) is not a writing surface
      if (tag === 'INPUT') {
        var t = (el.getAttribute('type') || 'text').toLowerCase();
        if (t !== 'text' && t !== 'search') return false;
        if (el.closest && el.closest(DM_SEL)) return false;
      }
      return true;
    }
    /* The '@...' being typed right now, or null. Caret only: a selection is not a token. */
    function tokenAt(el) {
      if (el.selectionStart == null || el.selectionStart !== el.selectionEnd) return null;
      var caret = el.selectionStart;
      var m = RE.exec(String(el.value).slice(0, caret));
      if (!m) return null;
      return { q: m[2], start: m.index + m[1].length, end: caret };
    }
    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
      });
    }
    function place() {
      if (!box || !field) return;
      var r = field.getBoundingClientRect();
      var h = box.offsetHeight || 0;
      var below = window.innerHeight - r.bottom;
      box.style.left = Math.round(Math.max(8, Math.min(r.left, window.innerWidth - 300))) + 'px';
      box.style.width = Math.round(Math.max(220, Math.min(320, r.width))) + 'px';
      // flip above when the field sits near the bottom (comment boxes usually do)
      box.style.top = (below < h + 12 && r.top > h + 12)
        ? Math.round(r.top - h - 6) + 'px'
        : Math.round(r.bottom + 6) + 'px';
    }
    function highlight() {
      for (var i = 0; i < rows.length; i++) rows[i].el.classList.toggle('on', i === sel);
      if (rows[sel] && rows[sel].el.scrollIntoView) rows[sel].el.scrollIntoView({ block: 'nearest' });
    }
    function pick(u) {
      if (!field || !tok) return;
      var v = field.value, before = v.slice(0, tok.start), after = v.slice(tok.end);
      var ins = '@' + u.username + ' ';
      var f = field;                       // close() clears `field`
      f.value = before + ins + after;
      var pos = before.length + ins.length;
      try { f.setSelectionRange(pos, pos); } catch (e) {}
      close();
      // let the page's own counters / autosize / draft-savers react to the change
      try { f.dispatchEvent(new Event('input', { bubbles: true })); } catch (e) {}
      f.focus();
    }
    function render(users) {
      if (box && box.parentNode) box.parentNode.removeChild(box);
      box = document.createElement('div');
      box.className = 'mention-ac';
      box.setAttribute('role', 'listbox');
      rows = []; sel = 0;
      users.slice(0, 8).forEach(function (u, i) {
        var row = document.createElement('button');
        row.type = 'button';
        row.className = 'mention-ac-row' + (i === 0 ? ' on' : '');
        row.setAttribute('role', 'option');
        var av = u.avatar
          ? '<img src="' + esc(u.avatar) + '" alt="" width="26" height="26">'
          : '<span class="mention-ac-ph">' + esc(u.initial || '?') + '</span>';
        // the check moves OUTSIDE .mention-ac-nm: that span is the clip box (max-width:45% +
        // ellipsis), and a badge inside a truncating box is laid out past the clip and never paints.
        //
        // IT IS THE SITE'S .vtick, NOT A TICK CHARACTER. This row used to draw a bare
        // '&#10003;' in --accent-text, i.e. a GOLD text tick -- the only surface on the site
        // where "verified" rendered in a different colour and a different shape from the blue
        // disc every other name-side badge uses (owner, 2026-08-10, on the app's twin of this
        // bug: "replace it with an official badge like everywhere else"). Markup is a copy of
        // lib/view.php verified_tick(); `u.verified` is already verified_is_on()'s answer
        // (index.php handle_search()), so nothing about WHO gets a badge changes here.
        row.innerHTML = av
          + '<span class="mention-ac-nm">' + esc(u.display_name) + '</span>'
          + (u.verified
              ? window.RovaVSealTick()   // the seal, defined once in the first IIFE (search "VSEAL")
              : '')
          + '<span class="mention-ac-at">@' + esc(u.username) + '</span>';
        // mousedown, not click: click fires after blur, and blur closes the box
        row.addEventListener('mousedown', function (ev) { ev.preventDefault(); pick(u); });
        box.appendChild(row);
        rows.push({ el: row, u: u });
      });
      document.body.appendChild(box);
      place();
    }
    function query() {
      if (!tok || tok.q.length < MIN) { if (box) close(); return; }
      var mine = ++seq;
      fetch('/search?q=' + encodeURIComponent(tok.q), {
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        credentials: 'same-origin'
      }).then(function (r) { return r.json(); }).then(function (d) {
        if (seq !== mine || !field) return;               // a newer keystroke already answered
        var users = (d && d.users) || [];
        if (!users.length) { close(); return; }
        render(users);
      }).catch(function () {});
    }

    document.addEventListener('input', function (e) {
      var el = e.target;
      if (!isTarget(el)) return;
      field = el;
      tok = tokenAt(el);
      clearTimeout(timer);
      if (!tok) { close(); return; }
      timer = setTimeout(query, 180);
    }, true);

    /* Capture phase: Enter must pick a handle before any form or submit handler sees it. */
    document.addEventListener('keydown', function (e) {
      if (!box || !isTarget(e.target)) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); sel = (sel + 1) % rows.length; highlight(); return; }
      if (e.key === 'ArrowUp') { e.preventDefault(); sel = (sel - 1 + rows.length) % rows.length; highlight(); return; }
      if (e.key === 'Enter' || e.key === 'Tab') {
        if (rows[sel]) { e.preventDefault(); e.stopPropagation(); pick(rows[sel].u); }
        return;
      }
      if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); close(); }
    }, true);

    document.addEventListener('click', function (e) {
      if (box && !box.contains(e.target) && e.target !== field) close();
    });
    document.addEventListener('focusout', function (e) {
      if (isTarget(e.target)) setTimeout(function () { if (box && document.activeElement !== field) close(); }, 120);
    });
    window.addEventListener('resize', place);
    window.addEventListener('scroll', function () { if (box) place(); }, true);
  } catch (e) { /* never take the page down for an autocomplete */ }
})();

/* ==== @handle HOVER CARD ====================================================================
   Hover any link to a profile and get a preview: avatar, bio, counts, three recent posts, follow
   and message. Instagram's card is the reference; the differences below are the deliberate part.

   POINTER-AWARE, NOT MOUSE-ASSUMING. Gated on (hover:hover) and (pointer:fine). A touch device
   fires a synthetic mouseover on tap, so without this the card would pop over the very thing the
   finger was aiming at and swallow the navigation. Phones get nothing and lose nothing.

   INTENT, NOT ENTRY. Opens only after OPEN_MS of continuous hover, so dragging the cursor across a
   thread full of @mentions never strobes cards. Closing gets a grace window rather than firing on
   mouseout, because the gap between the link and the card IS a mouseout -- closing there is
   exactly what makes a hover card feel broken. The card keeps the timer alive itself, so you can
   walk the cursor into it and press Follow.

   ONE NODE, ONE FETCH PER HANDLE. A single element is reused and moved; responses are memoised per
   handle for the life of the page, so re-hovering a handle you have already seen is instant and
   silent. A `seq` token means a slow response for a handle you left can never paint over a newer
   one.

   IT IS NOT MOUSE-ONLY. focusin opens it for keyboard users and Escape dismisses; it carries
   aria-hidden while closed so a screen reader never meets a stale card.

   Everything actionable inside is a hook that already exists: .js-followtoggle syncs by data-id,
   so following from the card updates the profile page, the feed row and the suggestion strip
   behind it in the same tick, with no code here. */
(function () {
  try {
    if (!window.matchMedia || !matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    if (!window.fetch) return;

    /* CLOSE_MS was 220 and that is measurably too short. The card sits 10px under the link, so the
       traverse itself is instant, but the timer starts the moment the pointer leaves the link and a
       reader who pauses in that gap to aim has already spent it. Measured with a hesitation sweep
       (0/200/400/800/1500ms parked in the gap): at 220 only a 0ms hesitation survived, i.e. only a
       cursor that never stops. 500 covers a real glance between the link and the card and still
       reads as prompt when you move away. */
    var OPEN_MS = 380, CLOSE_MS = 500, MAXW = 320;
    /* How far the PAGE may drift under an open card before we call it the reader scrolling and
       dismiss. One wheel notch is ~100px, so a deliberate scroll still crosses this on the first or
       second notch. A recycler re-pin (a few px), a trackpad inertia tail, or a lazy image settling
       never do -- and those are the ones that were killing cards the reader was still reading. */
    var SCROLL_SLACK = 120;
    var box = null, anchor = null, openT = 0, closeT = 0, cache = {}, seq = 0, openY = 0;

    function hcHit(el) {
      var a = el && el.closest ? el.closest('a[href]') : null;
      if (!a || a.closest('.hcard')) return null;   // links inside the card never spawn another
      var m = (a.getAttribute('href') || '').match(/^\/@([A-Za-z0-9_]{3,30})(?:[/?#]|$)/);
      if (!m) return null;
      /* ALREADY LOOKING AT THEM. A region that carries data-hc-self="<handle>" IS that member's
         page -- today the profile column, header card, tab row and every post row under it -- so a
         preview of the same avatar, name, handle, counts and thumbs is a copy of what the reader can
         already see, printed on top of the tabs and the grid (owner: "if I'm already on this
         person's page I don't need to see the hover card"). Suppressed here rather than
         server-side: only the page knows whose profile it is, /hovercard is a separate request that
         cannot, and refusing early means no request goes out at all.
         MATCHED ON THE HANDLE, never on the region, which is what keeps the rest intact: a
         commenter, a reposter or collaborator credit, an @mention in a bio, and every row of the
         profile's @ tab (whose items belong to OTHER people) all still get their card, as does every
         card on the feed, in search, in a follower list and in a thread. A permalink hovering its
         own author keeps its card too, deliberately: that page shows a name and an avatar, not the
         bio, counts and thumbnails the card adds. */
      var self = a.closest('[data-hc-self]');
      if (self && (self.getAttribute('data-hc-self') || '').toLowerCase() === m[1].toLowerCase()) return null;
      return { a: a, u: m[1] };
    }

    function ensureBox() {
      if (box) return box;
      box = document.createElement('div');
      box.className = 'hcard';
      box.setAttribute('role', 'dialog');
      box.setAttribute('aria-label', 'Profile preview');
      box.setAttribute('aria-hidden', 'true');
      box.addEventListener('mouseenter', function () { clearTimeout(closeT); });
      box.addEventListener('mouseleave', scheduleClose);
      document.body.appendChild(box);
      return box;
    }

    /* Under the link, flipped above when the viewport runs out below, clamped to both edges.
       position:fixed on purpose: the feed is full of transformed and clipping ancestors, and an
       absolutely positioned card gets swallowed by them. */
    function place() {
      if (!box || !anchor) return;
      var r = anchor.getBoundingClientRect();
      var w = box.offsetWidth || MAXW, h = box.offsetHeight || 260;
      var left = Math.round(r.left + r.width / 2 - w / 2);
      left = Math.max(10, Math.min(left, window.innerWidth - w - 10));
      var flip = (window.innerHeight - r.bottom) < (h + 20) && r.top > (h + 20);
      box.classList.toggle('hcard-up', flip);
      box.style.left = left + 'px';
      box.style.top  = Math.round(flip ? (r.top - h - 10) : (r.bottom + 10)) + 'px';
    }

    function show(hit) {
      var el = ensureBox(), mine = ++seq;
      anchor = hit.a;
      openY = window.scrollY || window.pageYOffset || 0;   // the page position this card was aimed at
      var paint = function (html) {
        if (mine !== seq) return;                   // a later hover already won
        el.innerHTML = html;
        el.classList.add('is-open');
        el.removeAttribute('aria-hidden');
        place();
        requestAnimationFrame(place);               // thumbs can change the height
      };
      if (cache[hit.u] === 0) { return; }                 // known to have no card: never ask again
      if (cache[hit.u]) { paint(cache[hit.u]); return; }
      fetch('/hovercard?u=' + encodeURIComponent(hit.u), { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          /* A 404 is a real answer, not a failure: your OWN handle, a blocked pair, a deleted
             account. Remember it as 0 so hovering your own name across a feed of your own posts
             does not refire the request every single time. */
          if (!j || !j.html) { cache[hit.u] = 0; return; }
          cache[hit.u] = j.html;
          paint(j.html);
        })
        .catch(function () {});
    }

    function close() {
      if (!box) return;
      box.classList.remove('is-open');
      box.setAttribute('aria-hidden', 'true');
      anchor = null;
      seq++;                                        // cancel anything still in flight
    }
    function scheduleClose() { clearTimeout(closeT); closeT = setTimeout(close, CLOSE_MS); }

    document.addEventListener('mouseover', function (e) {
      var hit = hcHit(e.target);
      if (!hit) return;
      clearTimeout(closeT); clearTimeout(openT);
      if (anchor === hit.a && box && box.classList.contains('is-open')) return;
      openT = setTimeout(function () { show(hit); }, OPEN_MS);
    });
    document.addEventListener('mouseout', function (e) {
      if (!hcHit(e.target)) return;
      clearTimeout(openT);
      scheduleClose();
    });
    document.addEventListener('focusin', function (e) {
      var hit = hcHit(e.target);
      if (hit) { clearTimeout(closeT); show(hit); }
      else if (!(e.target.closest && e.target.closest('.hcard'))) { scheduleClose(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { clearTimeout(openT); close(); }
    });
    /* SCROLL: CHASE THE ANCHOR, DISMISS ONLY WHEN THE READER IS REALLY MOVING.
       This listener used to be `close()` on any scroll at all, with capture:true on window -- and
       capture:true on window means it hears the scroll of EVERY scrollable element in the document,
       not just the page. The feed's suggestion carousel auto-advances itself every 3.2s
       (setInterval(step, 3200), native smooth scrollBy on .sugg-carousel-view), so on a feed with a
       reader sitting perfectly still, hand off the mouse, that one timer was firing ~26 scroll
       events a minute and every single one closed the card. Measured before the fix: a card opened
       over an idle feed died after 2,716ms, killed by a scroll whose target was .sugg-carousel-view
       while window.scrollY never moved off 0. That is the "it dismisses randomly" report, and it
       was not random -- it was a 3.2s timer. Every other nested scroller in the app (the DM thread,
       the GIF grid, the mini-thread, the admin log) had the same power.

       So: a scroller that does not CONTAIN the anchor cannot have moved the anchor, and is ignored
       outright. A scroll that can move it re-measures instead of guessing. The old comment said
       "cheaper to dismiss than to chase it" -- true, and the wrong trade: chasing is what the
       reader wants, and place() is one getBoundingClientRect on an event that already happened. */
    function anchorGone() {
      if (!anchor || !anchor.isConnected) return true;
      var r = anchor.getBoundingClientRect();
      if (!r.width && !r.height) return true;                    // display:none, recycled into a stub
      return r.bottom < 0 || r.top > (window.innerHeight || 0);  // genuinely scrolled off screen
    }
    function onScroll(e) {
      if (!box || !box.classList.contains('is-open') || !anchor) return;
      var t = e && e.target;
      var page = (!t || t === document || t === window ||
                  t === document.documentElement || t === document.body);
      // not the page, and not an ancestor of the anchor: it cannot have moved the anchor one pixel
      if (!page && !(t.nodeType === 1 && t.contains && t.contains(anchor))) return;
      if (anchorGone()) { close(); return; }
      // A real wheel notch is ~100px, so a reader who means to scroll away crosses SCROLL_SLACK on
      // the first or second one and the card goes, promptly. What does NOT cross it: the recycler's
      // few-pixel re-pin after stubbing a card above the viewport, an inertia tail, a lazy image
      // settling. Those are the page moving under a reader who is not moving.
      if (page && Math.abs((window.scrollY || window.pageYOffset || 0) - openY) > SCROLL_SLACK) { close(); return; }
      place();
    }
    window.addEventListener('scroll', onScroll, true);
    // resize: same deal. Re-place rather than dismiss, and only give up if the anchor really left.
    window.addEventListener('resize', function () {
      if (!box || !box.classList.contains('is-open')) return;
      if (anchorGone()) { close(); return; }
      place();
    });

    /* MENTION, the hover card's second action. DMs need a mutual follow, so the card only offers
       the DM shortcut to mutual pairs (see _hovercard.php) and everyone else gets this, which
       needs no permission at all.

       It prefills the composer ON THIS PAGE rather than navigating: the reader is already looking
       at the feed, and a page load to write one @mention is the kind of thing that makes people
       not bother. The synthetic `input` event is not decoration -- the autogrow and the draft
       saver both listen for it, so without it the box would not resize and the mention would be
       lost on reload. Falls back to a real navigation when the page has no composer (a profile,
       a permalink), which is why the server also honours ?mention= on arrival. */
    document.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('.js-hc-mention') : null;
      if (!b) return;
      e.preventDefault();
      var u = b.getAttribute('data-u') || '';
      if (!u) return;
      close();
      var ta = document.querySelector('.js-compose textarea[name="body"]');
      if (!ta) { location.href = '/?mention=' + encodeURIComponent(u); return; }
      var pre = (ta.value || '').replace(/\s+$/, '');
      if (pre.indexOf('@' + u) === -1) { ta.value = (pre ? pre + ' ' : '') + '@' + u + ' '; }
      try { ta.focus(); ta.setSelectionRange(ta.value.length, ta.value.length); } catch (err) {}
      try { ta.dispatchEvent(new Event('input', { bubbles: true })); } catch (err) {}
      try { ta.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (err) {}
    });
    // the navigation fallback lands here with ?mention=<handle>
    (function () {
      var m = (location.search || '').match(/[?&]mention=([A-Za-z0-9_]{3,30})/);
      if (!m) return;
      var run = function () {
        var ta = document.querySelector('.js-compose textarea[name="body"]');
        if (!ta) return;
        if ((ta.value || '').indexOf('@' + m[1]) === -1) {
          ta.value = ((ta.value || '').replace(/\s+$/, '') + ' @' + m[1] + ' ').replace(/^\s+/, '');
        }
        try { ta.focus(); ta.setSelectionRange(ta.value.length, ta.value.length); } catch (e2) {}
        try { ta.dispatchEvent(new Event('input', { bubbles: true })); } catch (e2) {}
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
      else run();
    })();
  } catch (e) { /* a preview is never worth breaking the page for */ }
})();

/* ==========================================================================
   CREATOR BROADCAST CHANNELS (db/0141, views/channel.php, lib/channels.php).

   ITS OWN TRAILING IIFE, on purpose. The main bundle is one ~31k-line IIFE and
   an uncaught throw at its top level kills every statement below it. A new
   subsystem that nothing else depends on belongs out here, where the worst it
   can do is break itself.

   The server renders every message (channel_msg_html), including the ones this
   file appends live, so a message that arrived through the poller and one that
   arrived through a reload cannot drift apart.
   ========================================================================== */
(function () {
  'use strict';
  var wrap = document.querySelector('.chwrap');
  if (!wrap) return;

  var CID    = parseInt(wrap.getAttribute('data-channel') || '0', 10);
  var JOINED = wrap.getAttribute('data-joined') === '1';
  var last   = parseInt(wrap.getAttribute('data-last') || '0', 10);
  var stream = document.getElementById('chstream');
  var csrf   = (document.querySelector('meta[name="csrf-token"]') || {}).content || '';
  // shared in-flight button state (defined in the main IIFE; see busyStart there)
  var BZ = window.__rovaBusy || { is: function () { return false; }, start: function () { return null; }, until: function (b, p) { return p; } };

  function post(url, data) {
    var body = new URLSearchParams(data || {});
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded',
                 'X-CSRF-Token': csrf, 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
      body: body, credentials: 'same-origin'
    }).then(function (r) { return r.json().catch(function () { return {}; }); });
  }

  /* ---- reactions ------------------------------------------------------- */
  var RX  = ['heart', 'fire', 'haha', 'wow', 'clap', 'sad'];
  var EMO = { heart: "❤️", fire: "🔥", haha: "😂",
              wow: "😮", clap: "👏", sad: "😢" };

  /* SURGERY, NOT A REBUILD. The pill row now carries things that are not reaction state
     -- the reply-count pill, the emoji picker button, "Reply privately", Delete/Report --
     because that is where Instagram puts them and where the server (channel_msg_html)
     emits them. Blowing the row's innerHTML away, which is what this did while the row
     held nothing but reactions, would delete every one of those controls the first time a
     member tapped a heart, and only for that message: a bug that survives a reload and so
     never gets reported as a reaction bug at all. Only [data-rx] pills are reaction state;
     they are replaced in place, ahead of the picker button. */
  function repaintPills(mid, counts, mine) {
    /* iMESSAGE TAPBACKS (2026-10-15): the reactions live in .chtap on the bubble's top corner,
       which holds NOTHING but reaction state, so it is rebuilt whole. Same order and markup as
       routes/channels.php channel_tap_inner (most-picked first, a count only above one). The row
       fallback below only serves a message rendered before that change. */
    var tap = document.querySelector('.chmsg[data-mid="' + mid + '"] .chtap');
    if (tap) {
      var list = [];
      RX.forEach(function (code, i) {
        var c = (counts && +counts[code]) || 0;
        if (!c && mine !== code) return;
        list.push({ n: Math.max(1, c), i: i, code: code });
      });
      list.sort(function (a, b) { return (b.n - a.n) || (a.i - b.i); });
      tap.innerHTML = list.map(function (r) {
        return '<button type="button" class="chpill' + (mine === r.code ? ' on' : '') + (r.n > 1 ? ' n' : '') +
               '" data-mid="' + mid + '" data-rx="' + r.code + '" aria-label="' + r.code + ' ' + r.n + '">' +
               EMO[r.code] + (r.n > 1 ? '<b>' + r.n + '</b>' : '') + '</button>';
      }).join('');
      var row = tap.closest('.chmsg');
      if (row) { row.classList.toggle('rx-on', list.length > 0); row.style.setProperty('--rxn', String(list.length || 1)); }   // bubble min-width (rova.css)
      return;
    }
    var host = document.querySelector('.chmsg[data-mid="' + mid + '"] .chmsg-rx');
    if (!host) return;
    var old = host.querySelectorAll('.chpill[data-rx]');
    for (var i = 0; i < old.length; i++) { old[i].remove(); }
    var html = '';
    RX.forEach(function (code) {
      var n  = (counts && counts[code]) || 0;
      var on = mine === code;
      if (!n && !on) return;
      html += '<button type="button" class="chpill' + (on ? ' on' : '') + '" data-mid="' + mid +
              '" data-rx="' + code + '">' + EMO[code] + '<span>' + n + '</span></button>';
    });
    if (!html) return;
    var anchor = host.querySelector('.chpill-add');
    if (anchor) { anchor.insertAdjacentHTML('beforebegin', html); }
    else { host.insertAdjacentHTML('beforeend', html); }
  }

  function react(mid, code, btn) {
    // pills repaint only on the answer, so the tapped pill spins for the flight (slow-link feedback)
    BZ.until(btn, post('/channel/react', { mid: mid, reaction: code }).then(function (d) {
      if (d && typeof d.counts !== 'undefined') { repaintPills(mid, d.counts || {}, d.reaction || null); }
    }).catch(function () {}));
  }

  var picker = null;
  function closePicker() { if (picker) { picker.remove(); picker = null; } }
  function openPicker(btn, mid) {
    closePicker();
    picker = document.createElement('div');
    picker.className = 'chpicker';
    RX.forEach(function (code) {
      var b = document.createElement('button');
      b.type = 'button';
      b.textContent = EMO[code];
      b.addEventListener('click', function () { closePicker(); react(mid, code); });
      picker.appendChild(b);
    });
    btn.parentNode.appendChild(picker);
  }
  document.addEventListener('click', function (e) {
    if (picker && !picker.contains(e.target)) { closePicker(); }
  }, true);

  /* ---- one delegated listener for the whole page ----------------------- */
  wrap.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('button') : null;
    if (!b) return;

    if (b.classList.contains('chpill-add')) {
      e.preventDefault(); openPicker(b, b.getAttribute('data-mid')); return;
    }
    /* data-rx, NOT the .chpill class. Every control on the row is a .chpill now -- reply
       count, "Reply privately", Delete, Report -- so testing the class alone would fire a
       reaction with reaction=null on all of them and swallow the click before the real
       handler below ever ran. The reaction pills are the ones carrying an emoji code. */
    if (b.classList.contains('chpill') && b.hasAttribute('data-rx')) {
      e.preventDefault();
      if (BZ.is(b)) return;
      react(b.getAttribute('data-mid'), b.getAttribute('data-rx'), b); return;
    }
    if (b.classList.contains('chtop-more')) {
      e.preventDefault();
      var panel = document.getElementById('chctl');
      if (panel) {
        panel.hidden = !panel.hidden;
        b.setAttribute('aria-expanded', panel.hidden ? 'false' : 'true');
      }
      return;
    }
    if (b.classList.contains('chcopy')) {
      e.preventDefault();
      var v = b.getAttribute('data-copy') || '';
      try {
        navigator.clipboard.writeText(v);
        /* A CLASS, not textContent. The button ships both labels stacked in one grid cell
           (.copy-swap, views/channel.php + rova.css), so the confirmation costs zero layout --
           writing textContent here would collapse the pair and let "Copied" widen the button
           mid-tap, which is the reflow the referral pill was fixed for on 2026-08-15. */
        b.classList.add('is-copied');
        setTimeout(function () { b.classList.remove('is-copied'); }, 1400);
      } catch (err) {
        var i = document.querySelector('.chinvite'); if (i) { i.select(); }
      }
      return;
    }
    if (b.classList.contains('chmsg-del')) {
      e.preventDefault();
      if (BZ.is(b)) return;
      if (!confirm('Delete this post?')) return;
      var dmid = b.getAttribute('data-mid');
      BZ.until(b, post('/channel/delete', { mid: dmid }).then(function (d) {
        if (d && d.ok) { var n = document.querySelector('.chmsg[data-mid="' + dmid + '"]'); if (n) { n.remove(); } }
        else { flash('Could not delete that.'); }
      }).catch(function () { flash('Could not delete that.'); }));
      return;
    }
    if (b.classList.contains('chmsg-report')) {
      e.preventDefault();
      if (BZ.is(b)) return;
      var why = prompt('What is wrong with this post?');
      if (why === null) return;
      BZ.until(b, post('/channel/report', { mid: b.getAttribute('data-mid'), reason: why })
        .then(function () { b.textContent = "✓"; }).catch(function () { flash('Could not send that report.'); }));
      return;
    }
    if (b.classList.contains('chwhisper-btn')) {
      e.preventDefault(); openWhisper(b.getAttribute('data-mid')); return;
    }
    if (b.classList.contains('chpill-reply')) {
      e.preventDefault(); loadWhispers(b.getAttribute('data-mid')); return;
    }
    if (b.classList.contains('chwinbox')) { e.preventDefault(); loadWhispers(0); return; }
    if (b.classList.contains('chwbox-x')) {
      e.preventDefault();
      var wb = document.getElementById('chwbox'); if (wb) { wb.hidden = true; }
      return;
    }
    if (b.classList.contains('chw-feature')) {
      e.preventDefault();
      if (BZ.is(b)) return;
      var featured = false;
      BZ.until(b, post('/channel/feature', { wid: b.getAttribute('data-wid') }).then(function (d) {
        if (d && d.ok) { featured = true; b.textContent = 'Featured'; tick(); }
      }).catch(function () {})).then(function () { if (featured) b.disabled = true; });   // spent stays spent, after the busy release
      return;
    }
    if (b.classList.contains('chw-hide')) {
      e.preventDefault();
      if (BZ.is(b)) return;
      var row = b.closest('.chw');
      BZ.until(b, post('/channel/hide-whisper', { wid: b.getAttribute('data-wid') }).then(function (d) {
        if (d && d.ok && row) { row.remove(); }
      }).catch(function () {}));
      return;
    }
    if (b.classList.contains('chwhisper-cancel')) {
      e.preventDefault();
      var dock = document.getElementById('chwhisper-dock'); if (dock) { dock.hidden = true; }
      floor();
      return;
    }
  });

  /* ---- whispers: the fan's private reply ------------------------------- */
  function openWhisper(mid) {
    var dock = document.getElementById('chwhisper-dock');
    if (!dock) return;
    dock.hidden = false;
    floor();   // the dock is the tallest thing this member's page ever shows
    var f = document.getElementById('chwhisper-form');
    if (f) {
      f.querySelector('input[name="mid"]').value = mid;
      f.querySelector('input[name="body"]').focus();
    }
  }

  var wf = document.getElementById('chwhisper-form');
  if (wf) {
    wf.addEventListener('submit', function (e) {
      e.preventDefault();
      var wbtn = wf.querySelector('button[type="submit"], button:not([type])');
      if (BZ.is(wbtn)) return;   // in flight: keep the typed reply, drop the tap
      var body = wf.querySelector('input[name="body"]').value || '';
      if (!body.trim()) return;
      BZ.until(wbtn, post('/channel/whisper', { mid: wf.querySelector('input[name="mid"]').value, body: body })
        .then(function (d) {
          var dock = document.getElementById('chwhisper-dock');
          if (d && d.ok) {
            wf.querySelector('input[name="body"]').value = '';
            if (dock) { dock.hidden = true; }
            flash('Sent to the creator.');
          } else {
            flash('That reply could not be sent.');   // text stays in the box
          }
        }).catch(function () { flash('That reply could not be sent.'); }));
    });
  }

  function loadWhispers(mid) {
    var box = document.getElementById('chwbox');
    if (!box) return;   // members have no inbox panel; their own replies ride the dock
    box.hidden = false;
    var body = box.querySelector('.chwbox-body');
    body.innerHTML = '<div class="hdrop-spin"></div>';
    fetch('/channel-whispers?id=' + CID + (mid ? '&message_id=' + mid : ''),
      { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var rows = (d && d.whispers) || [];
        if (!rows.length) { body.innerHTML = '<div class="empty">No replies yet.</div>'; return; }
        body.innerHTML = rows.map(function (w) {
          return '<div class="chw">' +
            '<span class="chw-av">' + w.avatar + '</span>' +
            '<div class="chw-main">' +
            '<a class="chw-who" href="/@' + w.username + '">' + w.name + '</a>' +
            '<div class="chw-body">' + w.body + '</div>' +
            '<div class="chw-meta">' + w.ago +
            (w.can_feature
              ? ' <button type="button" class="chlink chw-feature" data-wid="' + w.id + '">Feature in channel</button>' +
                ' <button type="button" class="chlink chw-hide" data-wid="' + w.id + '">Dismiss</button>'
              : (w.featured ? ' · featured' : '')) +
            '</div></div></div>';
        }).join('');
      })
      .catch(function () { body.innerHTML = '<div class="empty">Could not load replies.</div>'; });
  }

  function flash(msg) {
    var n = document.querySelector('.chcompose-note') || document.querySelector('.chwhisper-to');
    if (n) { n.textContent = msg; setTimeout(function () { n.textContent = ''; }, 2500); }
  }

  /* ---- appending a message, with its date rule ---------------------------
     The server owns the LABEL ("SAT 9:57 PM") and sends it with every message as `sep`,
     alongside the plain `day` key it belongs to -- so the client never carries a second
     copy of the "today / yesterday / weekday / date" rules that would drift from
     channel_day_label() the first time either side changed. All this decides is WHETHER
     a rule is needed, by comparing the arriving day with the last bubble already in the
     DOM. An empty stream has no last bubble, so the first message of a fresh channel
     gets its rule too. */
  function appendMsg(m) {
    if (!stream || !m || !m.html) return;
    if (document.querySelector('.chmsg[data-mid="' + m.id + '"]')) return;
    var blank = stream.querySelector('.chempty');
    if (blank) { blank.remove(); }
    var msgs = stream.querySelectorAll('.chmsg');
    var prev = msgs.length ? msgs[msgs.length - 1].getAttribute('data-day') : '';
    if (m.day && m.sep && m.day !== prev) {
      stream.insertAdjacentHTML('beforeend',
        '<div class="chday"><span>' + String(m.sep).replace(/[<>&]/g, '') + '</span></div>');
    }
    stream.insertAdjacentHTML('beforeend', m.html);
  }

  /* ---- notification mode ----------------------------------------------- */
  var sel = document.querySelector('.chnotify');
  if (sel) {
    // same shape as the groups notify select: disabled for the flight, re-enabled on settle
    sel.addEventListener('change', function () {
      sel.disabled = true;
      post('/channel/notify', { id: CID, mode: sel.value })
        .catch(function () {})
        .then(function () { sel.disabled = false; });
    });
  }

  /* ---- the creator's composer ------------------------------------------ */
  var comp = document.getElementById('chcompose');
  if (comp) {
    /* ONE ROW THAT GROWS, the shape every chat composer on the site already has. The
       textarea ships with rows="1" so an empty channel opens with a single line rather
       than a two-row block, and the max is the CSS max-height (132px) -- read from the
       computed style rather than typed here, so the two cannot drift apart. */
    var cta = comp.querySelector('textarea[name="body"]');
    if (cta) {
      var grow = function () {
        var cap = parseFloat(getComputedStyle(cta).maxHeight) || 132;
        cta.style.height = 'auto';
        cta.style.height = Math.min(cta.scrollHeight, cap) + 'px';
      };
      cta.addEventListener('input', grow);
    }
    var fileIn = comp.querySelector('.chcompose-photo input[type="file"]');
    if (fileIn) {
      fileIn.addEventListener('change', function () {
        var f = fileIn.files && fileIn.files[0];
        if (!f) return;
        flash('Uploading...');
        var fd = new FormData();
        fd.append('media', f);
        fetch('/upload-stage', {
          method: 'POST', body: fd, credentials: 'same-origin',
          headers: { 'X-CSRF-Token': csrf, 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }
        }).then(function (r) { return r.json(); }).then(function (d) {
          if (d && d.token) {
            comp.querySelector('input[name="media"]').value = d.token;
            flash('Photo ready. Add a note and post.');
          } else {
            flash((d && d.error) || 'That upload failed.');
          }
        }).catch(function () { flash('That upload failed.'); });
      });
    }
    comp.addEventListener('submit', function (e) {
      e.preventDefault();
      // the one composer on the site that could genuinely double-post: no flag, no disabled,
      // textarea cleared only on the answer. Busy on the send button = feedback + dedupe.
      var pbtn = comp.querySelector('button[type="submit"], button:not([type])');
      if (BZ.is(pbtn)) return;   // in flight: the text stays put, the tap is dropped
      var fd = new FormData(comp);
      var data = {};
      fd.forEach(function (v, k) { data[k] = v; });
      BZ.until(pbtn, post('/channel/post', data).then(function (d) {
        if (d && d.ok) {
          if (d.html && stream) {
            appendMsg(d);
            last = Math.max(last, d.id || 0);
          }
          var ta = comp.querySelector('textarea[name="body"]');
          ta.value = '';
          ta.style.height = '';
          comp.querySelector('input[name="media"]').value = '';
          var hi = comp.querySelector('input[name="highlight"]');
          if (hi) { hi.checked = false; }
          flash('');
          window.scrollTo(0, document.body.scrollHeight);
        } else {
          flash((d && d.error) === 'empty' ? 'Say something, or add a photo.' : 'That did not post.');
        }
      }).catch(function () { flash('That did not post, check your connection.'); }));
    });
  }

  /* ---- floor clearance for the fixed bottom bar --------------------------
     Exactly ONE of the join bar, the composer and the whisper dock is fixed to the
     bottom of the column at a time, and each is a different height -- the join bar runs
     to three lines of explainer on a phone, the composer is one row. A typed
     padding-bottom is therefore wrong for two of the three states: too small and the bar
     covers the newest message (the one the reader came for), too large and a short
     channel floats in dead space. Measure the bar that is actually there.

     Re-measured on resize because the explainer rewraps, and after the dock is raised,
     which is the one state that appears mid-session. */
  function floor() {
    var bar = wrap.querySelector('.chjoin, #chcompose, .chwhisper-dock:not([hidden])');
    wrap.style.paddingBottom = (bar ? bar.offsetHeight + 24 : 32) + 'px';
  }
  floor();
  window.addEventListener('resize', floor);

  /* ---- the live tick ---------------------------------------------------- */
  /* GATED ON THE STREAM EXISTING (db/0146). The broadcast stream is one TAB of the
     creator page now, so a subscriber sitting on Posts or About has no #chstream to
     append to -- and without this guard would still have spent a request every 12s
     forever, on an origin that is CPU-bound at ~150 req/s, to throw the answer away. */
  var timer = null;
  function tick() {
    if (!JOINED || !stream || document.hidden) return;
    /* PENDING VIDEOS (2026-10-02): a clip still transcoding, or not yet NSFW-screened, carries
       data-vpend. Its id rides this same poll (max 10) and the server answers upd:{id: html}.
       Replaced ONLY when its data-vstate changed (processing -> ready, ready-locked -> ready...),
       so an author already watching their own clip is never interrupted by a no-op re-render. */
    var pend = [];
    var pendEls = stream.querySelectorAll('.chmsg[data-vpend]');
    for (var pi = 0; pi < pendEls.length && pend.length < 10; pi++) { pend.push(pendEls[pi].getAttribute('data-mid')); }
    fetch('/channel-poll?id=' + CID + '&after=' + last + (pend.length ? '&pend=' + pend.join(',') : ''),
      { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var upd = (d && d.upd) || {};
        Object.keys(upd).forEach(function (id) {
          var el = stream && stream.querySelector('.chmsg[data-mid="' + id + '"]');
          var html = upd[id];
          if (!el || !html) return;
          var vs = /data-vstate="([^"]*)"/.exec(html);
          if (vs && vs[1] === el.getAttribute('data-vstate')) {
            if (!/data-vpend=/.test(html)) { el.removeAttribute('data-vpend'); }
            return;
          }
          el.outerHTML = html;
        });
        var msgs = (d && d.messages) || [];
        if (!msgs.length || !stream) return;
        msgs.forEach(function (m) {
          appendMsg(m);
          last = Math.max(last, m.id);
        });
      })
      .catch(function () { /* a poll is never worth an error */ });
  }
  if (JOINED && stream) {
    timer = setInterval(tick, 12000);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) { tick(); } });
    window.addEventListener('pagehide', function () { if (timer) { clearInterval(timer); } });
  }
})();

/* ==========================================================================
   GROUPS (db/0145, views/group.php, lib/groups.php).

   ITS OWN TRAILING IIFE, on purpose and for the same reason the channels block
   above is one: the main bundle is a single ~31k-line IIFE and an uncaught throw
   at its top level kills every statement below it. A new subsystem that nothing
   else depends on belongs out here, where the worst it can do is break itself.

   Everything here is PROGRESSIVE ENHANCEMENT. Join, leave, approve, decline,
   remove, role, post-delete and settings are all real <form method="post">
   elements in the view and work with JavaScript switched off; this file only
   upgrades the three controls that would otherwise need a page round-trip for a
   one-field change (the details fold, the notify select, copy-link) and adds the
   report prompt, which has nowhere to live in markup.
   ========================================================================== */
(function () {
  'use strict';
  var page = document.querySelector('.grpage');
  if (!page) return;                                  // page-scoped, zero cost elsewhere
  var GID  = parseInt(page.getAttribute('data-group') || '0', 10);
  var csrf = (document.querySelector('meta[name="csrf-token"]') || {}).content || '';

  function post(url, data) {
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-CSRF-Token': csrf,
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      },
      body: new URLSearchParams(data || {}),
      credentials: 'same-origin'
    }).then(function (r) { return r.json().catch(function () { return {}; }); });
  }

  /* The details fold, the DM thread's arrangement. */
  var more = page.querySelector('.grtop-more');
  var ctl  = page.querySelector('#grctl');
  if (more && ctl) {
    more.addEventListener('click', function () {
      var open = ctl.hasAttribute('hidden');
      if (open) { ctl.removeAttribute('hidden'); } else { ctl.setAttribute('hidden', ''); }
      more.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* Notification mode. Saved on change; the server is the authority on what it
     ended up as (setNotify clamps an unknown mode to 'digest'), so the select is
     corrected FROM the response rather than assumed to have won. */
  var sel = page.querySelector('.grnotify');
  if (sel) {
    sel.addEventListener('change', function () {
      var want = sel.value;
      sel.disabled = true;
      post('/group/notify', { id: GID, mode: want })
        .then(function (d) { if (d && d.notify) { sel.value = d.notify; } })
        .catch(function () { /* leave the control where the member put it */ })
        .then(function () { sel.disabled = false; });
    });
  }

  /* Copy the invite link. */
  var copy = page.querySelector('.grcopy');
  if (copy) {
    copy.addEventListener('click', function () {
      var url = copy.getAttribute('data-copy') || '';
      /* .copy-swap: both labels are already in the button, stacked in one grid cell, so this only
         cross-fades them. See views/group.php and the .copy-swap block in rova.css -- swapping
         textContent instead would widen the button and reflow the row it shares with the input. */
      var done = function () {
        copy.classList.add('is-copied');
        setTimeout(function () { copy.classList.remove('is-copied'); }, 1400);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done).catch(function () {});
      } else {
        var i = page.querySelector('.grinvite');
        if (i) { i.select(); try { document.execCommand('copy'); done(); } catch (e) {} }
      }
    });
  }

  /* Report the group, into the same moderation queue as every other report. */
  var rep = page.querySelector('.grreport');
  if (rep) {
    rep.addEventListener('click', function () {
      var BZ = window.__rovaBusy;
      if (rep.disabled || (BZ && BZ.is(rep))) return;
      var why = window.prompt('What is wrong with this group?');
      if (why === null) return;                        // cancelled, not an empty report
      var sent = false;
      var p = post('/group/report', { id: GID, reason: why })
        .then(function () { sent = true; rep.textContent = 'Reported'; })
        .catch(function () {});
      (BZ ? BZ.until(rep, p) : p).then(function () { if (sent) rep.disabled = true; });
    });
  }
})();

/* ==========================================================================
   CHANNEL PAGES (db/0146, views/channels.php, views/channel.php).

   ITS OWN TRAILING IIFE, for the same reason the channels and groups blocks
   above it are: the main bundle is one ~31k-line IIFE and an uncaught throw at
   its top level kills every statement below it. This subsystem is the last one
   loaded and the worst it can do is break itself.

   EVERYTHING HERE IS PROGRESSIVE ENHANCEMENT. Create, subscribe, unsubscribe,
   feature/unfeature, and all four About forms are real <form method="post">
   elements in the views and work with JavaScript switched off. The category
   pickers ship with EVERY subcategory of EVERY category in the DOM, and
   Channels::normalizeCategory() drops any pairing that does not belong
   together -- so with JS off a mismatched submit yields a category and no
   subcategory, never a wrong subcategory. What this file adds is the filtering
   that makes the picker usable, and one prompt-based report.
   ========================================================================== */
(function () {
  'use strict';

  var csrf = (document.querySelector('meta[name="csrf-token"]') || {}).content || '';

  function post(url, data) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded',
                 'X-CSRF-Token': csrf, 'X-Requested-With': 'XMLHttpRequest',
                 'Accept': 'application/json' },
      body: new URLSearchParams(data || {}),
      credentials: 'same-origin'
    }).then(function (r) { return r.json().catch(function () { return {}; }); });
  }

  /* ---- category -> subcategory ----------------------------------------
     The sub select is built once from the options the server already sent, so
     there is no second copy of the 27-category taxonomy in this file to drift
     from lib/channels.php. Options are DETACHED and re-attached rather than
     hidden: `display:none` on an <option> is ignored by several mobile
     browsers' native pickers, which would show the whole list back again on
     exactly the devices that need the filter most. */
  function wirePicker(catSel) {
    var form = catSel.form;
    if (!form) return;
    var subSel = form.querySelector('.chsub-pick');
    if (!subSel) return;

    var all = [];
    var opts = subSel.querySelectorAll('option[data-cat]');
    for (var i = 0; i < opts.length; i++) {
      all.push({ cat: opts[i].getAttribute('data-cat') || '', el: opts[i] });
    }
    var placeholder = subSel.querySelector('option:not([data-cat])');

    function apply(keepValue) {
      var want = catSel.value || '';
      var had  = keepValue ? subSel.value : '';
      subSel.innerHTML = '';
      if (placeholder) { subSel.appendChild(placeholder); }
      var kept = false;
      for (var j = 0; j < all.length; j++) {
        if (all[j].cat !== want) continue;
        subSel.appendChild(all[j].el);
        if (had && all[j].el.value === had) { kept = true; }
      }
      subSel.disabled = !want;
      subSel.value = kept ? had : '';
    }

    apply(true);
    catSel.addEventListener('change', function () { apply(false); });
  }

  var pickers = document.querySelectorAll('.chcat-pick');
  for (var p = 0; p < pickers.length; p++) { wirePicker(pickers[p]); }

  /* ---- report a channel ------------------------------------------------
     window.prompt returns null when CANCELLED and '' when submitted empty.
     Those are different things and only the first is "never mind", which is
     why this tests for null rather than for falsiness. */
  var page = document.querySelector('.chpage-v2');
  if (page) {
    var CID = parseInt(page.getAttribute('data-channel') || '0', 10);
    page.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('.chreport') : null;
      if (!b) return;
      e.preventDefault();
      var BZ = window.__rovaBusy;
      if (BZ && BZ.is(b)) return;
      var why = window.prompt('What is wrong with this channel?');
      if (why === null) return;
      var reported = false;
      var p = post('/channel/report', { id: CID, reason: why }).then(function () {
        reported = true;
        b.textContent = 'Reported';
      }).catch(function () {});
      (BZ ? BZ.until(b, p) : p).then(function () { if (reported) b.disabled = true; });
    });
  }
})();

/* =============================================================================
   INLINE PAGERS, SITE-WIDE (owner, 2026-08-21: "Pressing the older button
   shouldn't trigger a whole page refresh here and anywhere else on the website
   it should load cleanly instantly inline.")

   ONE delegated mechanism, no per-page copies. A pager opts in by markup only:

     <div id="my-panel" data-inline-panel [data-inline-partial="partial=1"]>
       ...rows...
       <div class="..." data-inline-pager="#my-panel"> <a href="?page=2">...</a> </div>
     </div>

   Click on any <a> inside a [data-inline-pager] container:
     - fetch the link's URL (a GET -- every pager on this site is plain links,
       there are no POST pagers), same-origin only;
     - data-inline-partial="k=v": append that param and use the whole response
       body as the panel's new innerHTML (the groups A-Z rail rides
       /groups?...&partial=1, which handle_groups_index answers with exactly
       the panel's contents). Otherwise parse the full page and extract the
       SAME id -- heavier on bytes, works on any server-rendered page with no
       server changes (founders roster, follow lists, blog);
     - swap innerHTML in place (no scroll jump; min-height pinned during the
       fetch so the page can't collapse under the reader), then pushState the
       link's clean URL so refresh / bookmark / back all keep working.

   Back/forward: the FIRST swap tags the entry it is leaving via replaceState,
   every swap pushes a tagged entry, and popstate on a tagged entry re-fetches
   location.href and swaps the same panel -- so the back button walks pages, it
   never strands the URL away from the content (same lesson as the profile tab
   pager at web#19).

   FAILURE IS NAVIGATION, never a dead button: any fetch/extract error falls
   back to location.href = link (and popstate errors reload). Double-fires are
   swallowed per-panel while a fetch is in flight, and the panel itself is
   pointer-events:none + dimmed for the duration -- that IS the loading state,
   deliberately subtle (owner: no spinner takeovers). Hardened 2026-08-21 after
   the founders fpage pager was reported dead: a SYNC throw out of fetch() and a
   fetch that never settles both used to strand the in-flight latch with
   preventDefault already called -- a permanently dead pager. Both now end in
   fail(): see swap()'s try/catch + 10s abort deadline, and the click handler's
   own try/catch.

   ZERO SCROLL (owner, 2026-08-21): a swap moves NOTHING -- no scrollIntoView,
   the panel's min-height pin is held (never released, ratchets up only), and
   repinPager() pushes a shorter page's pager row back to where the reader's
   thumb already is. The viewport position and the buttons' screen position are
   both invariants of paging.

   The referrals roster on /founders keeps its own richer machinery
   (founders-dash.js: live search + filter chips + JSON partial). Its clicks
   call preventDefault() first, and this handler bails on defaultPrevented, so
   the two can never both act. Its pager markup carries data-ref-page, NOT
   data-inline-pager.

   Guest/edge-cached pages: these are all GETs with no CSRF token involved, so
   the cached-page beacon trap (csrf-beacon-on-edge-cached-page) does not
   apply; an edge-cached body extracted by id is the same body a navigation
   would have shown.
   ========================================================================== */
(function () {
  'use strict';
  if (!('fetch' in window) || !window.history || !history.pushState || !('DOMParser' in window)) return;

  var inflight = {};   // panel id -> true while a fetch owns it

  function panelFor(sel) {
    if (!sel) return null;
    try { return document.querySelector(sel); } catch (e) { return null; }
  }

  function setBusy(panel, on) {
    if (on) {
      // Pin the height so a shorter incoming page can't collapse the document
      // under the reader mid-fetch (the no-scroll-jump half of the ask).
      // THE PIN IS NEVER RELEASED (owner, 2026-08-21, zero-scroll ruling: "content swaps in
      // place, the pager buttons stay exactly under his thumb"): releasing it after swapping in
      // a shorter final page let everything below the panel jump up. Held as a floor -- at most
      // the tallest page seen -- it costs a little trailing whitespace on the short page and
      // buys a layout that never moves. Only ratchet UP: a taller page raises it, a shorter one
      // must not lower it, or the floor is no floor.
      var pin = parseFloat(panel.style.minHeight) || 0;
      if (panel.offsetHeight > pin) { panel.style.minHeight = panel.offsetHeight + 'px'; }
      panel.style.transition = 'opacity .15s ease';
      panel.style.opacity = '0.55';
      panel.style.pointerEvents = 'none';
      panel.setAttribute('aria-busy', 'true');
    } else {
      panel.style.opacity = '';
      panel.style.pointerEvents = '';
      panel.setAttribute('aria-busy', 'false');
    }
  }

  /* Zero-scroll, part two: min-height keeps content BELOW the panel still, but a shorter last
     page still lifts the pager row itself (fewer rows above it) -- and the pager is what is
     under the reader's thumb. Measure the pager box's offset inside the panel before the swap
     and, if the fresh page put it higher, push it back down with a margin so the buttons do not
     move. Ratchets like the min-height: pages bumped once stay at the tall-page geometry. */
  function pagerTopIn(panel) {
    var box = panel.querySelector('[data-inline-pager]');
    return box ? (box.getBoundingClientRect().top - panel.getBoundingClientRect().top) : -1;
  }
  function repinPager(panel, topBefore) {
    if (topBefore < 0) return;
    var box = panel.querySelector('[data-inline-pager]');
    if (!box) return;
    var d = topBefore - (box.getBoundingClientRect().top - panel.getBoundingClientRect().top);
    if (d > 1) {
      box.style.marginTop = ((parseFloat(getComputedStyle(box).marginTop) || 0) + d) + 'px';
    }
  }

  /* Fetch url and swap it into panel. ok(title|null) on success, fail() on any
     error. Partial mode trusts the response body whole; extract mode requires
     the response to contain the panel's own id. */
  function swap(panel, url, ok, fail) {
    var part = panel.getAttribute('data-inline-partial');
    var fetchUrl = url;
    if (part) {
      var bare = url.split('#')[0];
      fetchUrl = bare + (bare.indexOf('?') !== -1 ? '&' : '?') + part;
    }
    /* HARDENED 2026-08-21 (dead-Older-button hunt). Two paths used to strand the inflight latch
       with preventDefault already called, which is a PERMANENTLY dead pager -- the exact bug class
       the navigation fallback exists to forbid:
         1. a synchronous throw out of fetch() itself is not caught by a .catch() on its promise,
            so it escaped this function entirely and neither ok nor fail ever ran;
         2. a fetch that never settles (radio drop, stalled origin) resolved nothing, rejected
            nothing, and held the latch forever with no timeout anywhere.
       Now: the sync path is try/caught into fail(), and a 10s AbortController deadline turns a
       hung fetch into a rejection, which is already fail() -> real navigation. */
    var ctrl = ('AbortController' in window) ? new AbortController() : null;
    var deadline = ctrl ? setTimeout(function () { try { ctrl.abort(); } catch (e) {} }, 10000) : 0;
    var done = function (fn, arg) { if (deadline) { clearTimeout(deadline); deadline = 0; } fn(arg); };
    var p;
    try {
      p = fetch(fetchUrl, {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        cache: 'no-store',
        signal: ctrl ? ctrl.signal : undefined
      });
    } catch (e) { done(fail); return; }
    p.then(function (r) {
      if (!r.ok) throw new Error('http ' + r.status);
      return r.text();
    }).then(function (html) {
      if (part) { panel.innerHTML = html; done(ok, null); return; }
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.getElementById(panel.id);
      if (!fresh) throw new Error('no #' + panel.id + ' in response');
      panel.innerHTML = fresh.innerHTML;
      done(ok, doc.title || null);
    }).catch(function () { done(fail); });
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented) return;                       // someone else owns this click
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a || a.target || a.hasAttribute('download')) return;
    var box = a.closest('[data-inline-pager]');
    if (!box) return;
    var sel = box.getAttribute('data-inline-pager');
    var panel = panelFor(sel);
    if (!panel || !panel.id) return;                      // no panel on this page -> real navigation
    var u;
    try { u = new URL(a.getAttribute('href') || '', location.href); } catch (err) { return; }
    if (u.origin !== location.origin) return;             // never fetch cross-origin
    e.preventDefault();
    if (inflight[panel.id]) return;                       // double-click during load: swallowed
    var dest = u.href;
    /* Everything after preventDefault must be unable to dead-end the click: a synchronous throw
       from here on used to leave a swallowed tap AND, once the latch was set, a pager that
       ignored every later tap. Same rule as swap()'s hardening: any failure is a navigation. */
    try {
      inflight[panel.id] = true;
      var pagerTop = pagerTopIn(panel);                   // zero-scroll: where the buttons sit now
      setBusy(panel, true);
      swap(panel, dest, function (title) {
        inflight[panel.id] = false;
        setBusy(panel, false);
        repinPager(panel, pagerTop);                      // keep the buttons under the thumb
        try {
          if (!history.state || !history.state.rovaPager) {
            // Tag the entry we are LEAVING so popping back to it re-renders the panel.
            var keep = {};
            if (history.state) { for (var k in history.state) keep[k] = history.state[k]; }
            keep.rovaPager = sel;
            history.replaceState(keep, '', location.href);
          }
          history.pushState({ rovaPager: sel }, '', dest);
        } catch (err) {}
        if (title) document.title = title;
        /* NO scrollIntoView here any more (owner, 2026-08-21: "ZERO scroll movement -- content
           swaps in place, the pager buttons stay exactly under his thumb"). The shorter-last-page
           case it existed for is covered by the held min-height + repinPager above, which keep the
           geometry still instead of moving the viewport to chase it. */
      }, function () {
        inflight[panel.id] = false;
        setBusy(panel, false);
        window.location.href = dest;                      // fallback: never a dead button
      });
    } catch (err) {
      inflight[panel.id] = false;
      window.location.href = dest;                        // same rule, sync edition
    }
  });

  window.addEventListener('popstate', function (e) {
    var st = e.state;
    if (!st || !st.rovaPager) return;                     // not one of ours (pfeed etc. keep theirs)
    var panel = panelFor(st.rovaPager);
    if (!panel || !panel.id) { location.reload(); return; }
    if (inflight[panel.id]) return;
    inflight[panel.id] = true;
    var pagerTop = pagerTopIn(panel);                     // same zero-scroll contract as a click
    setBusy(panel, true);
    swap(panel, location.href, function (title) {
      inflight[panel.id] = false;
      setBusy(panel, false);
      repinPager(panel, pagerTop);
      if (title) document.title = title;
    }, function () { location.reload(); });
  });
})();

/* ==========================================================================
   DOOR TABS (2026-10-03, Rob on /groups, iPhone Safari: "Changing these group tabs shouldn't
   need a full page reload and should be smooth like the app.")

   Markup only, like the inline pagers above:
     <nav data-door-tabs="#panel"> <a data-door="k" href="/groups?view=k">...</a> ... </nav>
     <div id="panel" data-door-panel data-door-partial="partial=door"> ...open door... </div>
   The server answers <door href>&partial=door with EXACTLY the panel's body (views/_groups_door.php
   is included by both the page and the partial), so a fetched door and a refreshed one are the same
   bytes.

   - TAP: the door lights at once (the class flip is the feedback), the panel fades out (60 ms), the
     body swaps while invisible, then fades in (110 ms) -- switchTab's cross-dissolve, same timings,
     same reason (the new panel's raster lands off-screen). Reduce Motion: instant swap, no fade.
   - CACHE: the outgoing door's NODES are kept, detached, keyed by URL -- switching back re-attaches
     them: instant, no request, and a half-typed Create form or a scrolled rail is exactly as left.
     Their listeners come with them, so only a FRESHLY fetched body is re-bound
     (window.__rovaDxKit(panel); everything else on these panels is delegated: js-confirm, imgFallback,
     plain forms whose CSRF field is the session's own token). Hovering / touching a door prefetches.
   - URL: pushState the door's own href, so refresh, a shared link and back/forward all land on that
     door; popstate on one of our entries swaps back (from the cache) and restores that entry's y.
   - SCROLL: a tap moves NOTHING (the doors stay under the thumb). A shorter incoming door would let
     the document clamp the offset, so the panel gets exactly the min-height that keeps the current
     offset valid -- re-decided on every swap, never a ratchet. A swap started from a link INSIDE the
     panel (an empty state's "Discover", Create's Cancel) with the doors scrolled away brings the doors
     back into view instead of landing mid-door.
   - FAILURE IS NAVIGATION: a fetch error, a non-2xx, a redirect (expired session -> /login) or a body
     that is a whole page -> location.href = the door (popstate: reload). JS off: plain links.
   ========================================================================== */
(function () {
  'use strict';
  var doc = document;
  var nav = doc.querySelector('[data-door-tabs]');
  if (!nav || !('fetch' in window) || !window.history || !history.pushState || !('URL' in window)) return;
  var panel;
  try { panel = doc.querySelector(nav.getAttribute('data-door-tabs') || ''); } catch (e) { panel = null; }
  if (!panel || !panel.id || !panel.hasAttribute('data-door-panel')) return;
  var part = panel.getAttribute('data-door-partial') || 'partial=door';
  var BASE = location.pathname;
  var doors = Array.prototype.slice.call(nav.querySelectorAll('a[data-door]'));
  var reduce = function () { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); };

  /* The cache key of a URL on this page: path + query, minus our own partial flag and the default
     view, so /groups and /groups?view=discover are one door. */
  function keyOf(u) {
    var sp = new URLSearchParams(u.search);
    sp.delete('partial');
    if ((sp.get('view') || '').toLowerCase() === 'discover') sp.delete('view');
    var qs = sp.toString();
    return u.pathname + (qs ? '?' + qs : '');
  }
  function parse(href) { try { return new URL(href, location.href); } catch (e) { return null; } }
  /* Which door lights for a URL -- handle_groups_index's own rule: a search or category is Discover. */
  function doorOf(key) {
    var sp = new URLSearchParams((key.split('?')[1] || ''));
    var v = (sp.get('view') || '').toLowerCase();
    if ((v === 'mine' || v === 'create') && !sp.get('q') && !sp.get('cat')) return v;
    return 'discover';
  }
  var doorKeys = {};
  doors.forEach(function (a) { var u = parse(a.getAttribute('href') || ''); if (u) doorKeys[keyOf(u)] = a; });

  var cur = keyOf(location);
  var mem = {};        // key -> { frag: DocumentFragment|null, html: string|null, y: number }
  var inflight = {};   // key -> Promise<string>
  var seq = 0;         // the latest swap wins; an older one finishing late is dropped
  function slot(k) { return mem[k] || (mem[k] = { frag: null, html: null, y: 0 }); }

  function light(key) {
    var d = doorOf(key);
    doors.forEach(function (a) {
      var on = a.getAttribute('data-door') === d;
      a.classList.toggle('on', on);
      if (on) a.setAttribute('aria-current', 'page'); else a.removeAttribute('aria-current');
    });
  }

  function load(key) {
    var s = slot(key);
    if (s.frag || s.html !== null) return Promise.resolve(null);
    if (inflight[key]) return inflight[key];
    var url = key + (key.indexOf('?') !== -1 ? '&' : '?') + part;
    var ctrl = ('AbortController' in window) ? new AbortController() : null;
    var dl = ctrl ? setTimeout(function () { try { ctrl.abort(); } catch (e) {} }, 10000) : 0;
    var p;
    try {
      p = fetch(url, { credentials: 'same-origin', cache: 'no-store', headers: { 'X-Requested-With': 'XMLHttpRequest' },
                       signal: ctrl ? ctrl.signal : undefined });
    } catch (e) { p = Promise.reject(e); }
    p = p.then(function (r) {
      if (!r.ok) throw new Error('http ' + r.status);
      if (r.redirected && parse(r.url) && parse(r.url).pathname !== BASE) throw new Error('redirected');
      return r.text();
    }).then(function (html) {
      if (/<html[\s>]|<body[\s>]/i.test(html.slice(0, 4000))) throw new Error('not a panel');
      if (dl) clearTimeout(dl);
      delete inflight[key];
      if (!slot(key).frag) slot(key).html = html;
      return html;
    }, function (err) { if (dl) clearTimeout(dl); delete inflight[key]; throw err; });
    inflight[key] = p;
    return p;
  }

  function wait(ms) { return new Promise(function (res) { setTimeout(res, ms); }); }
  function fadeOut() {
    if (reduce()) return Promise.resolve();
    panel.style.transition = 'opacity .06s ease';
    panel.style.opacity = '0';
    return new Promise(function (res) {
      var done = false;
      var go = function () { if (done) return; done = true; panel.removeEventListener('transitionend', te); res(); };
      var te = function (ev) { if (ev.target === panel && ev.propertyName === 'opacity') go(); };
      panel.addEventListener('transitionend', te);
      setTimeout(go, 150);                                     // transitionend can be missed
    });
  }
  function fadeIn() {
    if (reduce()) { panel.style.transition = ''; panel.style.opacity = ''; return; }
    requestAnimationFrame(function () {                       // 2 frames: let the new body raster while invisible
      requestAnimationFrame(function () {
        panel.style.transition = 'opacity .11s ease';
        panel.style.opacity = '1';
        var clr = function () { panel.removeEventListener('transitionend', ce); clearTimeout(ft); panel.style.transition = ''; panel.style.opacity = ''; };
        var ce = function (ev) { if (ev.target === panel && ev.propertyName === 'opacity') clr(); };
        panel.addEventListener('transitionend', ce);
        var ft = setTimeout(clr, 320);
      });
    });
  }

  /* opts: { push: bool, y: number|null (restore this offset), fromPanel: bool } */
  function go(key, opts) {
    if (key === cur) return;
    var my = ++seq;
    var from = cur;
    slot(from).y = window.scrollY || window.pageYOffset || 0;
    light(key);
    panel.setAttribute('aria-busy', 'true');
    Promise.all([load(key), fadeOut()]).then(function () {
      if (my !== seq) return;                                  // a later tap took over
      var s = slot(key);
      // Everything on the page except the panel: what the panel's height must make up for so the
      // offset we keep (or restore) is still a valid one after the swap.
      var y = opts.y != null ? opts.y : (window.scrollY || window.pageYOffset || 0);
      var rest = doc.documentElement.scrollHeight - panel.offsetHeight;
      var keep = doc.createDocumentFragment();
      while (panel.firstChild) keep.appendChild(panel.firstChild);
      var old = slot(from); old.frag = keep; old.html = null;
      panel.style.minHeight = '';
      var fresh = false;
      if (s.frag) { panel.appendChild(s.frag); s.frag = null; }
      else { panel.innerHTML = s.html || ''; s.html = null; fresh = true; }
      cur = key;
      var need = Math.ceil(y + window.innerHeight - rest);
      if (need > panel.offsetHeight) panel.style.minHeight = need + 'px';
      if (fresh) {
        try { if (window.__rovaDxKit) window.__rovaDxKit(panel); } catch (e) {}
      }
      try { doc.dispatchEvent(new CustomEvent('rova:doorswap', { detail: { key: key, fresh: fresh } })); } catch (e) {}
      if (opts.push) {
        try {
          var st = history.state;
          if (!st || !st.rovaDoor) {
            var tag = {};
            if (st && typeof st === 'object') { for (var k in st) tag[k] = st[k]; }
            tag.rovaDoor = from;
            history.replaceState(tag, '', location.href);          // tag the entry we are LEAVING
          }
          history.pushState({ rovaDoor: key }, '', key);
        } catch (e) {}
      }
      // ALWAYS write the offset, even when unchanged: it discards any pending clamp the engine kept
      // (tab-switch-hydration-perf: the WebKit/Chromium pending-offset trap).
      var top = y;
      if (opts.fromPanel) {
        var nr = nav.getBoundingClientRect();
        if (nr.bottom < 0) top = Math.max(0, y + nr.top - 80);   // doors scrolled away: bring them back
      }
      window.scrollTo(0, top);
      panel.setAttribute('aria-busy', 'false');
      fadeIn();
    }).catch(function () {
      if (my !== seq) return;
      panel.style.transition = ''; panel.style.opacity = '';
      if (opts.push) window.location.href = key; else window.location.reload();
    });
  }

  function intercept(e, a, fromPanel) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (a.target || a.hasAttribute('download')) return;
    var u = parse(a.getAttribute('href') || '');
    if (!u || u.origin !== location.origin || u.pathname !== BASE || u.hash) return;
    var key = keyOf(u);
    if (!doorKeys[key]) return;                                // only the doors themselves swap in place
    e.preventDefault();
    if (key === cur) return;
    try { go(key, { push: true, y: null, fromPanel: fromPanel }); }
    catch (err) { window.location.href = key; }               // never a dead tap
  }
  nav.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (a) intercept(e, a, false);
  });
  panel.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (a && !a.closest('[data-inline-pager]')) intercept(e, a, true);
  });
  // Prefetch on intent: a mouse hover or the start of a touch on a door that is not open.
  var warm = function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[data-door]') : null;
    if (!a) return;
    var u = parse(a.getAttribute('href') || '');
    if (!u) return;
    var k = keyOf(u);
    if (k !== cur) load(k).catch(function () {});
  };
  nav.addEventListener('pointerover', warm, { passive: true });
  nav.addEventListener('touchstart', warm, { passive: true });
  nav.addEventListener('focusin', warm);

  window.addEventListener('popstate', function (e) {
    var st = e.state;
    if (!st || !st.rovaDoor) return;                          // not one of ours
    if (location.pathname !== BASE) return;
    var key = keyOf(location);
    if (key === cur) return;
    var s = mem[key];
    go(key, { push: false, y: s ? s.y : 0, fromPanel: false });
  });
  // bfcache restore: the page comes back exactly as left, cache included; nothing to do. A plain
  // reload re-renders the URL's door server-side.
})();

/* ==========================================================================
   STALE-BUNDLE SELF-REFRESH

   WHY (owner filed THREE bug reports on 2026-08-29 that were really this):
   app.js / rova.css ship as content-hashed immutable files
   (/assets/dist/app.<hash>.min.js) linked from the HTML, and an iOS Safari
   tab is effectively immortal -- it never navigates, never reloads, and
   comes back from days of suspension running whatever bundle it loaded last
   week. Every fix shipped since then is invisible to that tab, and what the
   owner then reports is last week's bug, again. So the page has to notice
   that the bundle it is RUNNING is no longer the one the server LINKS, and
   reload itself -- at a safe moment, never over the user's head.

   DETECTION: /assets/dist/manifest.json is already the build's atomic
   statement of "what should the site link right now" (tools/build-assets.mjs
   commits it write-tmp-then-rename; lib/view.php renders from it). We poll
   that -- at most once per 10 minutes, plus on returning to the tab -- with a
   ?t=<now> cache-buster. Cloudflare keys its cache on the FULL URL and
   /assets carries a 365-day immutable header, so a unique query is the one
   approach that skips every cache layer with zero header/config changes.
   Cost: ~1.5 KB, at most once per 10 min per open tab.

   RELOAD POLICY -- never interrupt. Reload only when ALL of:
     * the tab is visible, AND it either JUST became visible (the natural
       "coming back to a stale tab" moment) or the user has been idle >= 60s;
     * no full-screen overlay is up (the shared scroll lock covers the
       immersive viewer, lightbox, crop sheet -- anything modal);
     * nothing is typed anywhere (composer, comment box, DM, search) --
       post drafts do rehydrate from sessionStorage, but comment/DM text
       does not, and a reload must never eat words;
     * no unmuted media is playing;
     * no upload is in flight (window.__rovaUpBusy, exported by the upload
       engine above).
   Otherwise keep the pending flag and try again at the next tick/return.

   EDGE-CACHED HTML: a guest page comes from Cloudflare and may keep linking
   the OLD hash for its TTL, so a reload can land right back on a stale page.
   The sessionStorage guard makes it ONE attempt per distinct target hash --
   a mismatch that survives its own reload is left alone until the build
   moves again. (Logged-in HTML -- the owner -- always bypasses the edge, so
   his tab converges on the first attempt.)
   ======================================================================== */
(function () {
  'use strict';
  if (!window.fetch || !window.sessionStorage || !window.URL) return; // old browser: skip the feature, never break the page

  var GAP_MS   = 10 * 60 * 1000; // min gap between manifest fetches
  var IDLE_MS  = 60 * 1000;      // "user has walked away" threshold
  var VIS_MS   = 3000;           // "tab JUST became visible" window
  var GUARD_KEY = 'rova:stale-reloaded';

  /* What is this page actually RUNNING? Read the tags the server emitted.
     Captured once at load: the DOM's script/link src IS the running code's
     identity, no probing needed. dist = hashed bundle; raw = the ?v=<mtime>
     fallback view.php serves while a build is pending. */
  function runningRef(sel, distPrefix, rawPath) {
    var els = document.querySelectorAll(sel);
    for (var i = 0; i < els.length; i++) {
      var u;
      try { u = new URL(els[i].getAttribute('src') || els[i].getAttribute('href') || '', location.href); }
      catch (e) { continue; }
      if (u.origin !== location.origin) continue;
      if (u.pathname.indexOf(distPrefix) === 0) return { dist: true, path: u.pathname };
      if (u.pathname === rawPath) return { dist: false, path: u.pathname, v: parseInt(u.searchParams.get('v') || '0', 10) || 0 };
    }
    return null;
  }
  var runApp = runningRef('script[src]', '/assets/dist/app.', '/assets/app.js');
  var runCss = runningRef('link[rel="stylesheet"][href]', '/assets/dist/rova.', '/assets/rova.css');
  if (!runApp) return; // can't identify ourselves -> never guess, never reload

  /* Idle clock: any real input renews it. Capture-phase so nothing that
     stopPropagation()s (the pfeed pager does) can hide activity from us. */
  var lastInput = Date.now(), shownAt = 0;
  function poke() { lastInput = Date.now(); }
  ['pointerdown', 'keydown', 'wheel', 'touchstart', 'scroll'].forEach(function (t) {
    window.addEventListener(t, poke, { passive: true, capture: true });
  });

  /* Words in progress anywhere = hands off. Prefilled settings forms match
     too, which is fine: someone parked on a form page is exactly who a
     surprise reload would hurt. */
  function typedSomewhere() {
    var els = document.querySelectorAll('textarea, [contenteditable="true"], input[type="text"], input[type="search"], input[type="url"], input[type="email"], input[type="password"]');
    for (var i = 0; i < els.length; i++) {
      var v = (els[i].tagName === 'TEXTAREA' || els[i].tagName === 'INPUT') ? els[i].value : els[i].textContent;
      if (v && String(v).trim()) return true;
    }
    return false;
  }
  function soundPlaying() {
    var ms = document.querySelectorAll('video, audio');
    for (var i = 0; i < ms.length; i++) {
      if (!ms[i].paused && !ms[i].ended && !ms[i].muted && ms[i].volume > 0) return true;
    }
    return false;
  }

  /* null = safe to reload NOW; otherwise the (first) reason we must wait.
     The reason string is what the debug hook and the console line report. */
  function unsafeWhy() {
    if (document.hidden) return 'hidden';
    var now = Date.now();
    if (now - shownAt > VIS_MS && now - lastInput < IDLE_MS) return 'active';
    if (document.documentElement.classList.contains('scroll-locked')) return 'overlay'; // viewer/lightbox/modal via the shared scroll lock
    if (document.fullscreenElement || document.webkitFullscreenElement) return 'fullscreen';
    if (soundPlaying()) return 'sound';
    if (typeof window.__rovaUpBusy === 'function' && window.__rovaUpBusy()) return 'uploading';
    if (typedSomewhere()) return 'typing';
    return null;
  }

  /* Compare what we RUN against what the manifest LINKS. Returns a target
     signature when stale, else null. Raw-mode pages (build pending) only
     count as stale once a NEWER build exists (srcMtime > our ?v=), because
     until then a reload would fetch the very same raw file. */
  function staleSig(mf) {
    var a = mf && mf['/assets/app.js'], c = mf && mf['/assets/rova.css'];
    if (!a || !a.url) return null;
    var stale = false;
    if (runApp.dist) { stale = runApp.path !== a.url; }
    else if (runApp.v && a.srcMtime > runApp.v) { stale = true; }
    if (!stale && runCss && c && c.url) {
      if (runCss.dist) { stale = runCss.path !== c.url; }
      else if (runCss.v && c.srcMtime > runCss.v) { stale = true; }
    }
    return stale ? a.url + '|' + ((c && c.url) || '') : null;
  }

  var lastFetch = Date.now(); // a page that just rendered is fresh by definition; first poll ~10 min out
  var pending = null;         // stale target awaiting a safe moment
  var checking = false;

  function attempt() {
    if (!pending) return;
    var why = unsafeWhy();
    if (why) return; // keep pending; the next tick / tab-return retries
    var sig = pending;
    pending = null;
    try { sessionStorage.setItem(GUARD_KEY, sig); } catch (e) {} // guard FIRST: even a reload race must not loop
    try { console.log('[rova] stale bundle: running ' + runApp.path + ', server links ' + sig + ' -- reloading'); } catch (e) {}
    location.reload();
  }

  function doCheck(force) {
    var now = Date.now();
    if (checking || (!force && now - lastFetch < GAP_MS)) return;
    checking = true;
    lastFetch = now;
    fetch('/assets/dist/manifest.json?t=' + now, { cache: 'no-store', credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (mf) {
        checking = false;
        var sig = staleSig(mf);
        if (!sig) { pending = null; return; }
        var done = '';
        try { done = sessionStorage.getItem(GUARD_KEY) || ''; } catch (e) {}
        if (done === sig) { pending = null; return; } // already reloaded for this exact target once (edge-cached HTML) -- do not loop
        pending = sig;
        attempt();
      })
      .catch(function () { checking = false; }); // offline/blip: silently try again next round
  }

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) return;
    shownAt = Date.now(); // opens the "just became visible" reload window
    attempt();            // a pending reload fires NOW, before the user re-engages
    doCheck(false);
  });
  setInterval(function () {
    if (document.hidden) return; // a hidden tab burns nothing; the return visit checks
    attempt();
    doCheck(false);
  }, 60000);

  /* Debug/rig hooks, same spirit as __rovaAttentionStatus: check(true)
     bypasses the 10-min gap (the Playwright verification drives this),
     why() answers "what is blocking the reload", state() is forensics. */
  window.__rovaStaleDebug = {
    check: function () { doCheck(true); },
    why: unsafeWhy,
    state: function () { return { pending: pending, lastFetch: lastFetch, runApp: runApp, runCss: runCss }; }
  };
})();

/* ============================================================================
   a[data-back] -- "the back button should just take them to their PREVIOUS
   SCREEN"  (owner ruling, 2026-09-09)
   ============================================================================

   WHAT THIS IS FOR. The back-control sweep of 2026-09-09 ([[telling-web-from-app-
   screenshots]]) fixed /@handle/followers and /@handle/following with a plain
   `<a class="rova-disc pg-back" href="/@handle">` -- a link to the page's PARENT.
   The owner then set the rule for the last page without one (the public gallery
   /g/{id}, whose parent is genuinely ambiguous: it is reached from a post card,
   from /gallery-manage, and from shared links): "the back button should just take
   them to their previous screen."

   THE MECHANISM, AND WHY IT IS SHAPED LIKE THIS. The control stays a REAL LINK
   with a REAL href -- the sensible parent -- and this handler upgrades it to
   history.back() only when it can prove there is a same-site screen to go back
   to. That ordering is deliberate and is the whole no-JS story: with the bundle
   blocked, still loading, or thrown, the element is an ordinary anchor and the
   member lands on the fallback. A `<button onclick=history.back()>` would be
   INERT without JS and dead on a cold open, which is the exact bug the sweep was
   sent to fix. (It also could not be middle-clicked or opened in a new tab.)

   THE TWO PROOFS REQUIRED BEFORE PREVENTING THE NAVIGATION, both necessary:

     1. `history.length > 1`. A tab opened straight onto this URL -- a shared
        link, a pasted URL, cmd-click / "open in new tab" from a post card -- has
        exactly one entry. history.back() there does NOTHING: no error, no event,
        a back button that visibly does not work. That is a dead end, so we never
        call it.
     2. A SAME-ORIGIN document.referrer that is not this same page. length > 1 is
        true for a tab that arrived here from Google, or from an app's in-app
        browser, or from a DM in another site; going "back" then throws the member
        off Rova entirely, which is worse than any fallback. No Referrer-Policy is
        set anywhere in this codebase, so same-origin navigations carry the full
        URL under every browser's default (strict-origin-when-cross-origin), and a
        cross-origin one degrades to a bare origin -- which fails the test, as it
        should. The "not this same path+query" clause catches a reload and a
        same-page POST-redirect, where back() would land right back here.

   Both fail -> we do not touch the event and the href navigates. There is no
   third state and no state in which the control does nothing.

   THE WATCHDOG. Even with both proofs, history.back() can be a no-op (an entry
   replaced out from under us, an odd embedded webview). So the click arms a
   600ms timer to the fallback, disarmed by EITHER `pagehide` (a real cross-
   document navigation, bfcache included) OR `popstate`. popstate matters: on
   /@handle/followers the inline pager ([data-inline-pager]) pushes SAME-document
   entries, so back() there correctly returns to page 1 of the list without
   unloading anything -- which is the previous screen, and must not then be
   stomped by the fallback 600ms later.

   Modified clicks and target/download links are left entirely alone so
   cmd-click, middle-click and "open in new tab" keep working on the href. */
(function () {
  'use strict';
  if (!window.history || !window.addEventListener) { return; }

  function cameFromThisSite() {
    var r = document.referrer || '';
    if (!r) { return false; }
    var u;
    try { u = new URL(r, location.href); } catch (e) { return false; }
    if (u.origin !== location.origin) { return false; }
    if (u.pathname === location.pathname && u.search === location.search) { return false; }
    return true;
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented) { return; }
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) { return; }
    // a[data-bm-back] = the header brand in its BACK state (logo -> back morph, item 22, 2026-10-22): same rules
    var a = e.target && e.target.closest ? e.target.closest('a[data-back],a[data-bm-back]') : null;
    if (!a || a.target || a.hasAttribute('download')) { return; }
    // the header brand's Back goes through the progress-guaranteed navigator below (never cycles)
    if (a.hasAttribute('data-bm-back') && typeof window.__rovaNavBack === 'function') {
      e.preventDefault();
      window.__rovaNavBrandBack(a);
      return;
    }

    var fallback = a.getAttribute('href') || '/';
    if (history.length <= 1) { return; }        // nothing behind us -> let the href run
    if (!cameFromThisSite()) { return; }        // cold / external -> let the href run

    e.preventDefault();

    var armed = true;
    var disarm = function () {
      armed = false;
      window.removeEventListener('pagehide', disarm, false);
      window.removeEventListener('popstate', disarm, false);
      window.removeEventListener('beforeunload', disarm, false);
    };
    window.addEventListener('pagehide', disarm, false);
    window.addEventListener('popstate', disarm, false);
    /* beforeunload = the cross-document traversal has STARTED (fires before the fetch), so a slow previous page
       (> 600 ms to commit) is not stomped by the fallback halfway through going back to it. */
    window.addEventListener('beforeunload', disarm, false);

    try { history.back(); } catch (err) { disarm(); location.href = fallback; return; }

    window.setTimeout(function () {
      if (!armed) { return; }
      disarm();
      if (!document.hidden) { location.href = fallback; }
    }, 600);
  }, false);

  /* Rig hook: the Playwright proof asserts the DECISION (back vs href) as well as
     the landing page, so a run that happens to be right for the wrong reason is
     visible. Same spirit as __rovaStaleDebug above. */
  window.__rovaBackDebug = function () {
    var a = document.querySelector('a[data-back]');
    return {
      present: !!a,
      href: a ? a.getAttribute('href') : null,
      label: a ? a.getAttribute('aria-label') : null,
      historyLength: history.length,
      referrer: document.referrer || '',
      wouldGoBack: !!a && history.length > 1 && cameFromThisSite()
    };
  };
})();

/* ============================================================================
   THE BRAND BACK NAVIGATOR: BACK ALWAYS MAKES PROGRESS  (Rob 2026-10-22, /admin:
   "The back button is looping me, it should eventually take me back to the home page.")
   ============================================================================
   The plain a[data-back] rule (history.back() when the referrer is ours) loops on pages that add
   SAME-DOCUMENT history entries (hash sections like /admin#people, ?tab= pickers, pushState viewers):
   back() only pops that entry, popstate disarms the watchdog, and the member is still on the same page.
   So the header brand keeps its OWN per-tab stack of the Rova DOCUMENTS visited (sessionStorage
   rova_nav, newest last, path+query, compared by PATH: a hash/query-only change is not a page):
     record   on every load: navigate = push (a same-path reload/redirect just updates the top; arriving
              from an external site / cold = a fresh stack), back_forward or our own Back = truncate to
              that page's last occurrence, bfcache restore = the same;
     Back     target = the newest stack entry whose path is not this page; none -> the server's parent
              (the href, View::brandBackTo). history.back() only when nothing same-document was pushed
              here and the referrer IS that target (keeps bfcache + scroll); otherwise location.assign().
              A back() that pops to the SAME path (same-document entry) is followed at once by assign().
     guard    a second Back tap on the same path within 20 s goes to the parent href, whatever the stack says.
   Every tap therefore lands on a different path that is strictly lower in the stack, and the stack is
   finite, so it always ends on a top-level page (logo again). Spec: mailbox to-ios.md. */
(function () {
  'use strict';
  var SK = 'rova_nav', PK = 'rova_nav_pop', GK = 'rova_nav_bk', MAX = 40;
  var dirty = false;                     // this document created same-document history entries
  var docPath = location.pathname;       // the path this DOCUMENT was loaded at
  function pathOf(u) { var i = String(u).search(/[?#]/); return i < 0 ? String(u) : String(u).slice(0, i); }
  function load() {
    try {
      var v = JSON.parse(sessionStorage.getItem(SK) || '[]');
      return Array.isArray(v) ? v.filter(function (x) { return typeof x === 'string' && x.charAt(0) === '/' && x.charAt(1) !== '/'; }) : [];
    } catch (e) { return []; }
  }
  function save(s) { try { sessionStorage.setItem(SK, JSON.stringify(s.slice(-MAX))); } catch (e) {} }
  function sget(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function sset(k, v) { try { if (v === null) { sessionStorage.removeItem(k); } else { sessionStorage.setItem(k, v); } } catch (e) {} }
  function refOurs() {
    try { var r = document.referrer ? new URL(document.referrer) : null; return !!r && r.origin === location.origin; } catch (e) { return false; }
  }
  function record(type) {
    var s = load(), cur = location.pathname + location.search, i;
    docPath = location.pathname;
    var pop = sget(PK); sset(PK, null);
    if (pop !== null && pathOf(pop) === docPath) { type = 'back_forward'; }   // our own Back brought us here
    if (type === 'back_forward') {
      for (i = s.length - 1; i >= 0; i--) { if (pathOf(s[i]) === docPath) { break; } }
      s = i >= 0 ? s.slice(0, i) : [];
    } else if (type === 'navigate' && !refOurs()) {
      s = [];                                                              // cold / from another site
    }
    if (s.length && pathOf(s[s.length - 1]) === docPath) { s[s.length - 1] = cur; } else { s.push(cur); }
    save(s);
  }
  try {
    var hp = history.pushState;
    history.pushState = function () { dirty = true; return hp.apply(this, arguments); };
  } catch (e) {}
  window.addEventListener('hashchange', function () { dirty = true; }, false);
  var nt = 'navigate';
  try { var ne = performance.getEntriesByType('navigation')[0]; if (ne && ne.type) { nt = ne.type; } } catch (e) {}
  record(nt);
  window.addEventListener('pageshow', function (e) { if (e.persisted) { dirty = false; record('back_forward'); } }, false);

  // NEVER TWO BACKS (2026-10-22): on a page whose header shows Back, the page's own in-page back ([data-pg-back], hidden
  // by rova.css under body[data-bm-back]) hands its target to the header: a data-back control = previous screen else its
  // href (the normal rule below, href as the parent); a plain link = straight to its href (force), as that page intended.
  function inPageBack() {
    var el = document.querySelector('body[data-bm-back] [data-pg-back]');
    var l = el ? (el.matches('a[href]') ? el : el.querySelector('a[href]')) : null;
    return l && l.getAttribute('href') ? { href: l.getAttribute('href'), hist: l.hasAttribute('data-back') } : null;
  }
  (function () {
    // the Back LINK, not the brand box: since 2026-10-23 a back-state brand is a span holding Back + "Rova" (home) links
    var ip = inPageBack(), br = document.querySelector('.topbar a[data-bm-back]');
    if (ip && br) { br.setAttribute('href', ip.href); }
  })();
  window.__rovaNavBrandBack = function (a) {
    var ip = inPageBack();
    if (ip) { window.__rovaNavBack(ip.href, !ip.hist); } else { window.__rovaNavBack(a.getAttribute('href') || '/feed'); }
  };
  window.__rovaNavBack = function (fallback, force) {
    if (typeof window.__rovaBackGuard === 'function') { try { if (window.__rovaBackGuard()) return; } catch (e) {} }   // a live's open card / sheet closes first (livechat.js)
    var here = location.pathname, s = load(), now = Date.now(), g = null;
    try { g = JSON.parse(sget(GK) || 'null'); } catch (e) {}
    var n = (g && g.p === here && now - g.t < 20000) ? g.n + 1 : 1;
    sset(GK, JSON.stringify({ p: here, n: n, t: now }));
    while (s.length && (pathOf(s[s.length - 1]) === docPath || pathOf(s[s.length - 1]) === here)) { s.pop(); }
    var target = s.length ? s[s.length - 1] : '';
    if (!target || n >= 2 || force) {
      // no known previous screen, or this page already failed to let go once: the parent
      target = fallback || '/feed';
      var j;
      for (j = s.length - 1; j >= 0; j--) { if (pathOf(s[j]) === pathOf(target)) { break; } }
      s = j >= 0 ? s.slice(0, j + 1) : s.concat([target]);
    }
    save(s);
    sset(PK, target);
    var r = '';
    try { r = document.referrer ? new URL(document.referrer) : null; r = r && r.origin === location.origin ? r.pathname + r.search : ''; } catch (e) { r = ''; }
    if (dirty || force || history.length <= 1 || !r || pathOf(r) !== pathOf(target) || n >= 2) { location.assign(target); return; }
    var armed = true, t = 0;
    var off = function () {
      armed = false; clearTimeout(t);
      window.removeEventListener('popstate', onPop, false);
      window.removeEventListener('pagehide', off, false);
      window.removeEventListener('beforeunload', off, false);
    };
    var onPop = function () {
      if (!armed) { return; }
      off();
      if (location.pathname === here || location.pathname === docPath) { location.assign(target); }   // a same-page entry: keep going
    };
    window.addEventListener('popstate', onPop, false);
    window.addEventListener('pagehide', off, false);
    window.addEventListener('beforeunload', off, false);
    try { history.back(); } catch (err) { off(); location.assign(target); return; }
    t = setTimeout(function () { if (armed && !document.hidden) { off(); location.assign(target); } }, 700);
  };
  window.__rovaNavDebug = function () { return { stack: load(), docPath: docPath, dirty: dirty }; };
})();

/* ============================================================================
   HEADER LOGO -> BACK MORPH  (Rob, rob-batch-20261022 item 22)
   ============================================================================
   The brand (.topbar .brand.bm, members only, lib/view.php) is rendered by the server in its FINAL state:
   `.bm-back` + data-bm-back + aria-label "Back" on any page with somewhere to go back to, the plain logo on
   the top-level pages (View::brandBackTo). Since 2026-10-23 (Rob: the "Rova" text goes home) a back-state brand is
   a <span class="brand bm bm-back"> with two links: a.bm-bk[data-bm-back] (the chevron; taps go through the
   a[data-back] handler above) and a.bm-home ("Rova", a plain link to /). This module only
   owns the MORPH between pages:
     pagehide  BRAND_BOOT (hashed inline, lib/view.php) remembers this page's state in sessionStorage
               rova_bm = "b|l:<ms>" (per tab, like history);
     the next page's BRAND_BOOT reads it before first paint and stamps
               html.bm-from-back / html.bm-from-logo, which rova.css animates ONLY when it differs from the
               page's own state (logo -> chevron, or chevron -> logo; same -> nothing plays);
     settle    clears the class when the morph ends (animationend, 1.2 s timer fallback), so the nav-loading
               R spin and hover work normally afterwards;
     pageshow  (bfcache restore) replays the morph, since a restored page never re-runs BRAND_BOOT.
   Nothing here moves layout (transform + opacity only); one short timer per page load. */
(function () {
  'use strict';
  var root = document.documentElement;
  var KEY = 'rova_bm';
  var timer = 0;
  function brand() { return document.querySelector('.topbar .brand.bm'); }
  function clearFrom() { root.classList.remove('bm-from-logo'); root.classList.remove('bm-from-back'); }
  // clear on the morph's own animationend (the 250 ms "in" leg), with a timer for a morph that already ended
  // before this deferred bundle ran (no event will come) or never started (reduced motion)
  function settle() {
    clearTimeout(timer);
    timer = setTimeout(clearFrom, 1200);
    var b = brand();
    if (!b) { return; }
    var done = function (e) {
      if (!/^bm-(r|chev)-in$/.test(e.animationName || '')) { return; }
      b.removeEventListener('animationend', done, false);
      clearTimeout(timer);
      clearFrom();
    };
    b.addEventListener('animationend', done, false);
  }
  // the rova_bm WRITE lives in BRAND_BOOT's own pagehide listener (works before this deferred bundle has run);
  // here we only drop the class so a bfcache snapshot never carries a half-played morph
  window.addEventListener('pagehide', clearFrom, false);
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) { return; }
    var b = brand();
    if (!b) { return; }
    var m = null;
    try { m = /^([bl]):(\d+)$/.exec(sessionStorage.getItem(KEY) || ''); } catch (x) {}
    if (!m || Date.now() - (+m[2]) > 30000) { return; }
    clearFrom();
    void b.offsetWidth;                       // restart the keyframes on a restored document
    root.classList.add(m[1] === 'b' ? 'bm-from-back' : 'bm-from-logo');
    settle();
  }, false);
  if (root.classList.contains('bm-from-logo') || root.classList.contains('bm-from-back')) { settle(); }
})();

/* ====================================================================================================
   THE MEDIA RING  (owner 2026-09-17) -- the row of gold-ringed circles above the feed tabs
   ====================================================================================================
   "when someone clicks it is to open in our full screen viewer with hands free mode on and should
   proceed in the order of the circles ... Once viewed the circle moves to the end of the queue for the
   day ... when they reach the end of the days posts it should just repeat the order again."

   WHAT THIS MODULE OWNS, and nothing more:
     the TAP     builds the deck from the row's own data-ids in ROW ORDER starting at the tapped circle
                 (that person's posts newest-first, then the next circle's ... to the end, then the
                 circles before it), flies the thumbnail exactly as a grid tile flies, and opens the
                 one full-screen viewer with `{ ring: true }` -- no page-feed drain, wraps forever,
                 hands-free on (the viewer's own default-on open, hfOpen()). There is no second viewer
                 and no second slideshow here.
     the MARK    listens to the viewer's ARRIVAL announcement (rova:pfpost, updateFeedBar) for the
                 ring's session only, and records per PERSON the highest post id the reader actually
                 settled on. Batched: a short debounce while the reel runs, a keepalive flush on close
                 and on pagehide. Closing mid-way therefore records exactly what was reached.
     the SETTLE  on close, the circles viewed in this session move to the END of the row in the order
                 they were viewed, the ring muted, and the track scrolls back to the first unseen one
                 -- the same shape the server will render on the next load (MediaRing::circles), so a
                 reload changes nothing the reader can see.
   Guests have no memory: the tap and the deck work, nothing is sent, nothing moves. */
(function () {
  var row = document.getElementById('media-ring');
  if (!row) return;
  var track = row.querySelector('.mring-track');
  if (!track) return;
  var guest = row.getAttribute('data-guest') === '1';
  /* THE AVATAR BADGE'S FALLBACK (2026-09-24, owner via the app session: web parity with the app's avatar badge). The
     badge's gold initial sits UNDER its <img>; a photo that never arrives must leave that disc showing, not Chrome's
     broken-image glyph (which it draws for a sized <img> even with alt=""). The document-level CDN retry (top of this
     file) consumes the FIRST error in the capture phase and stops it, so an error that reaches this row is FINAL: drop
     the <img>. Plus one sweep for any that failed before this script ran (no retry was listening then: give it the
     origin retry now, or drop it when there is none). Removing, not `hidden` -- .mring-av-img's display:block wins.
     2026-09-24: removal is ALSO what brings the letter back -- rova.css hides it while `.mring-av:has(.mring-av-img)`
     (Rob saw the initial flash before every photo), so the gold initial now appears ONLY once the <img> is gone. */
  function avGone(t) { if (t && t.classList && t.classList.contains('mring-av-img') && t.parentNode) t.parentNode.removeChild(t); }
  row.addEventListener('error', function (e) { avGone(e.target); }, true);
  Array.prototype.forEach.call(row.querySelectorAll('.mring-av-img'), function (im) {
    if (im.complete && !im.naturalWidth && !(window.__rovaCdnRetry && window.__rovaCdnRetry(im))) avGone(im);
  });
  var rfetch = window.__rovaFetch || function (u, o) { return fetch(u, o); };
  var active = false;        // a ring session is open in the viewer
  var ownerOf = {};          // post id -> author id, for the deck of the open session
  var high = {};             // author id -> highest post id settled on (this page's memory, survives sessions)
  var order = [];            // authors settled on in THIS session, in first-arrival order
  var pending = [];          // "author:post" pairs not yet sent
  var flushT = null;

  function items() { return Array.prototype.slice.call(track.querySelectorAll('.mring-item')); }
  function live() { return items().filter(function (it) { return !it.classList.contains('mring-out'); }); }   // minus the circles on their way out
  function isSelf(it) { return !!it && it.getAttribute('data-self') === '1'; }   // the viewer's own circle (2026-10-12): pinned first
  var startedSelf = false;   // the open ring session started on the viewer's own circle (Start over re-taps it)
  /* THE STATUS LINE (Rob's "Option A", 2026-10-04): views/_media_ring.php / _ring_live.php draw a second line under the name
     -- "3 new" (an unseen circle with 2+ posts not yet reached), the newest post's age ("2h", carried in data-ago), "● Live · N"
     or "Go live". stPatch copies a re-read's line onto a KEPT circle (media or live; the node is patched, never replaced);
     stLocal recomputes a media circle's line after the reader watched part or all of that person's deck -- no request.
     REVISED SAME DAY (Rob): only LIVE circles draw the line now ("● Live · N"); stLocal is a no-op on a circle without
     an is-new line, so it stays as the inert half of the contract should media status ever come back. */
  function stPatch(it, n) {
    var st = it.querySelector('.mring-st'), ns = n.querySelector('.mring-st');
    if (!ns) return false;
    if (!st) { var nm = it.querySelector('.mring-name'); it.insertBefore(ns.cloneNode(true), nm ? nm.nextSibling : null); return true; }
    if (st.className === ns.className && st.innerHTML === ns.innerHTML && st.getAttribute('data-ago') === ns.getAttribute('data-ago')) return false;
    st.className = ns.className; st.innerHTML = ns.innerHTML;
    if (ns.hasAttribute('data-ago')) st.setAttribute('data-ago', ns.getAttribute('data-ago')); else st.removeAttribute('data-ago');
    return true;
  }
  function stLocal(it, u) {
    var st = it.querySelector('.mring-st');
    if (!st || !st.classList.contains('is-new')) return;
    var hi = high[u] || 0, n = 0;
    (it.getAttribute('data-ids') || '').split(',').forEach(function (s) { if ((parseInt(s, 10) || 0) > hi) n++; });
    if (!it.classList.contains('seen') && n >= 2) { st.textContent = (row.getAttribute('data-p-new') || '%s new').replace('%s', String(n)); return; }
    st.classList.remove('is-new'); st.textContent = st.getAttribute('data-ago') || '';
  }
  function csrf() { var m = document.querySelector('meta[name="csrf-token"]'); return (m && m.content) || ''; }
  function send(pairs, keep) {
    if (guest || !pairs.length) return;
    var body = new URLSearchParams();
    body.set('_csrf', csrf()); body.set('pairs', pairs.join(','));
    try {
      fetch('/ring-seen', { method: 'POST', body: body, credentials: 'same-origin', keepalive: !!keep,
        headers: { 'X-CSRF-Token': csrf(), 'X-Requested-With': 'XMLHttpRequest' } }).catch(function () {});
    } catch (e) {}
  }
  function flush(keep) {
    clearTimeout(flushT); flushT = null;
    if (!pending.length) return;
    var p = pending; pending = [];
    send(p, keep);
  }
  function onPost(e) {
    var d = e && e.detail;
    if (!active || !d || !d.ring) return;
    var id = String(d.id || ''), u = ownerOf[id];
    if (!u) return;                                  // not one of this deck's posts: never mark blind
    if (order.indexOf(u) < 0) order.push(u);
    var n = parseInt(id, 10) || 0;
    if (n > (high[u] || 0)) {
      high[u] = n;
      pending.push(u + ':' + n);
      clearTimeout(flushT);
      flushT = setTimeout(function () { flush(false); }, 1200);
    }
  }
  /* THE RE-ORDER IS ANIMATED, AND IT WAITS FOR THE LANDING (2026-10-09, Rob, iPhone: "when it flies back it's a
     square and has flicker just disappears seems like it lands then flies to the end of the media ring but doesn't
     look smooth"). settle(true) runs AFTER the dismissal has landed in the circle (close() -> __rovaRingLanded; a
     900 ms backstop below) and moves the row as one motion instead of a cut:
       - the circle the copy just landed in leaves IN PLACE: a clone of it, laid over its old spot inside the row
         (.mring is position:relative + contain:layout, so it is the clone's containing block), fades and shrinks;
       - every circle that stays SLIDES from where it was drawn to where it now sits (FLIP, the `translate`
         property, so the circles' own transforms -- hover scale, .mring-in -- are untouched);
       - the moved circles appear at the back with the row's own .mring-in shape (fade + scale up);
       - track.scrollLeft goes to 0 IN THE SAME TASK as the appends (the snap trap in the FRESHNESS notes: a moved
         element is what Chromium re-snaps to), and the FLIP deltas are measured across that change, so a row the
         reader had scrolled slides home instead of jumping.
     Reduced motion, a hidden tab, or no Web Animations: the old instant move. */
  var RING_MOVE_MS = 320;
  function settle(anim) {
    var its = live(), byU = {};
    its.forEach(function (it) { byU[it.getAttribute('data-u')] = it; });
    var go = !!anim && !calm() && !document.hidden && typeof track.animate === 'function';
    var x0 = null, ghost = null, movedU = {};
    if (go) {
      x0 = its.map(function (it) { return it.getBoundingClientRect().left; });
      var lu = order.length ? order[order.length - 1] : '';   // the person on screen at the close = the circle it landed in
      var li = lu ? byU[lu] : null;
      if (landedU && byU[landedU]) { li = byU[landedU]; }
      if (isSelf(li)) { li = null; }                 // your own circle stays where it is: nothing leaves, no ghost
      if (li) {
        try {
          var rr = row.getBoundingClientRect(), ir = li.getBoundingClientRect();
          if (ir.right > rr.left && ir.left < rr.right) {
            ghost = li.cloneNode(true);
            ghost.classList.remove('mring-in', 'mring-grow', 'mring-out', 'mring-shrink');
            ghost.classList.add('mring-ghost');
            ghost.removeAttribute('href'); ghost.removeAttribute('id'); ghost.setAttribute('aria-hidden', 'true'); ghost.setAttribute('tabindex', '-1');
            ghost.style.cssText = 'position:absolute;margin:0;pointer-events:none;z-index:2;left:' + (ir.left - rr.left).toFixed(2) + 'px;top:' + (ir.top - rr.top).toFixed(2) + 'px';
          }
        } catch (e) { ghost = null; }
      }
    }
    var moved = 0;
    order.forEach(function (u) {
      var it = byU[u]; if (!it) return;
      var newest = parseInt(it.getAttribute('data-newest'), 10) || 0;
      if ((high[u] || 0) >= newest) { it.classList.add('seen'); it.setAttribute('data-seen', '1'); }
      stLocal(it, u);
      if (isSelf(it)) return;                        // YOUR OWN CIRCLE never queues: it stays first, only its ring quietens
      track.appendChild(it);                         // to the end of the line, in the order it was viewed
      movedU[u] = 1;
      moved++;
    });
    order = []; landedU = '';
    if (!moved) { return; }
    if (!go) { try { track.scrollTo({ left: 0, behavior: 'smooth' }); } catch (e) { track.scrollLeft = 0; } return; }
    track.scrollLeft = 0;
    var ease = 'cubic-bezier(.2,.7,.2,1)';
    its.forEach(function (it, k) {
      try {
        if (movedU[it.getAttribute('data-u')]) {
          it.animate([{ opacity: 0, scale: '.6' }, { opacity: 1, scale: '1' }], { duration: 260, delay: 120, easing: ease, fill: 'backwards' });
          return;
        }
        var dx = x0[k] - it.getBoundingClientRect().left;
        if (Math.abs(dx) > 0.5) { it.animate([{ translate: dx.toFixed(2) + 'px 0' }, { translate: '0 0' }], { duration: RING_MOVE_MS, easing: ease }); }
      } catch (e) {}
    });
    if (ghost) {
      row.appendChild(ghost);
      var gone = function () { if (ghost && ghost.parentNode) { ghost.parentNode.removeChild(ghost); } ghost = null; };
      try {
        var ga = ghost.animate([{ opacity: 1, scale: '1' }, { opacity: 0, scale: '.6' }], { duration: 220, easing: 'ease-in', fill: 'forwards' });
        ga.onfinish = gone;
      } catch (e) { gone(); }
      setTimeout(gone, 700);                         // backstop: never strand the clone
    }
  }
  /* close() asks which circle to fly home to (the person whose post is on screen) and tells us when it has landed. */
  var settleArmed = false, settleT = null, landedU = '';
  function landTarget(pid) {
    var u = ownerOf[String(pid)];
    if (!u || row.hidden || row.classList.contains('mring-tucked')) return null;
    var it = null;
    live().forEach(function (x) { if (!it && x.getAttribute('data-u') === u) it = x; });
    var im = it && it.querySelector('img.mring-img');
    if (!im || !im.complete || !im.naturalWidth) return null;   // nothing painted to dissolve into
    var tr = track.getBoundingClientRect(), r = im.getBoundingClientRect();
    if (r.width < 4) return null;
    // partly scrolled out of the row: bring it fully in first (under the still-shown viewer, so unseen)
    var pad = 4, dx = 0;
    if (r.left < tr.left + pad) dx = r.left - tr.left - pad;
    else if (r.right > tr.right - pad) dx = r.right - tr.right + pad;
    if (dx) { track.scrollLeft += dx; r = im.getBoundingClientRect(); }
    if (r.left < tr.left - 1 || r.right > tr.right + 1) return null;
    var hb = document.querySelector('.topbar'), top = 0;
    if (hb) { var hr = hb.getBoundingClientRect(); if (hr.bottom > 0 && getComputedStyle(hb).position !== 'static') top = hr.bottom; }
    if (r.top < top - 1 || r.bottom > window.innerHeight) return null;   // under the header or off screen: no home to fly to
    landedU = u;
    return im;
  }
  function landed() {
    if (!settleArmed) return;
    settleArmed = false; clearTimeout(settleT); settleT = null;
    settle(true);
    /* THE ROW MAY HAVE MOVED WHILE THE VIEWER WAS UP. A freshness signal that arrived under the cover
       only set `dirty` (nothing reorders a row under a cover); re-read once the close's collapse and the
       keepalive beacon above have both landed, so the row that comes back already carries the seen
       state this session wrote and the local settle is confirmed, never fought. */
    if (dirty) { setTimeout(function () { if (dirty && !active && !settleArmed) { var d = dirty; dirty = null; reread(d); } }, 1500); }
  }
  window.__rovaRingLandTarget = landTarget;
  window.__rovaRingLanded = landed;
  function onClose() {
    if (!active) return;
    active = false;
    flush(true);
    if (!restart) {
      settleArmed = true; landedU = '';
      clearTimeout(settleT); settleT = setTimeout(landed, 900);   // backstop: the flight's own landing calls landed() first
      return;
    }
    settleArmed = false; clearTimeout(settleT); settleT = null;
    settle();
    /* START OVER (owner 2026-09-18: "end of media with start over button"). The viewer's end card asked
       for it; the viewer has just closed (this handler), the row has just settled -- seen circles to the
       back in the order they were watched, which after a full lap is every circle, i.e. the row AS IT IS
       NOW is the order the lap was watched in -- so circle 1 is the one to re-tap: a fresh session, a
       fresh lap, the server's per-person seen state untouched (the beacon already flushed above). The
       re-tap waits out the close's collapse (~550 ms) rather than opening over it. */
    if (restart) {
      restart = false;
      // circle 1 of the row as it is now -- your own circle only if the lap started there (it is pinned first, not queued)
      setTimeout(function () { var lv = live().filter(function (x) { return !x.classList.contains('mring-me0'); }); var it = lv.filter(function (x) { return startedSelf || !isSelf(x); })[0] || lv[0]; if (it) { try { it.click(); } catch (e) {} } }, 800);
    }
  }
  var restart = false;
  window.__rovaRingStartOver = function () {
    if (!active) return false;
    restart = true;
    var x = document.querySelector('.pfeed .pfeed-x');
    if (x) { x.click(); } else { restart = false; return false; }
    return true;
  };

  track.addEventListener('click', function (e) {
    var it = e.target && e.target.closest ? e.target.closest('.mring-item') : null;
    /* "ME" WITH NOTHING IN 24 H (Rob 2026-10-12): `.mring-me0` = your profile photo + a "+" badge, href /feed#compose. It is not
       a story: the tap is the composer's own toggle -- the feed IIFE's document-level a[href$="#compose"] handler (pushState +
       focusComposer() inside the click, so iOS raises the keyboard) opens it, a second tap closes it. Off /feed the href goes
       to the composer like the header's "+". So this handler leaves it alone: no preventDefault, no deck. */
    if (it && it.classList.contains('mring-me0')) return;
    if (!it || !window.__rovaFeedView) return;     // no viewer: the href (the person's newest post) is the fallback
    if (it.classList.contains('mring-out')) { e.preventDefault(); return; }   // a circle on its way out is not a door
    e.preventDefault();
    if (settleArmed) { landed(); }                 // re-opened inside the last close's landing: settle the row first
    var its = live(), i = its.indexOf(it);
    if (i < 0) return;
    var ordered = its.slice(i).concat(its.slice(0, i));   // row order, starting HERE, round to the circle before
    /* YOUR OWN CIRCLE (Rob 2026-10-12, MediaRing::selfCircle; first .mring-item, data-self="1"): a tap on it plays
       your posts and then carries on through the row like any circle; a lap that starts on anyone ELSE never
       wraps round into your own posts. */
    startedSelf = isSelf(it);
    if (!startedSelf) ordered = ordered.filter(function (x) { return !isSelf(x); });
    var ids = [], own = {};
    ordered.forEach(function (x) {
      var u = x.getAttribute('data-u') || '';
      (x.getAttribute('data-ids') || '').split(',').forEach(function (id) { if (id && !own[id]) { ids.push(id); own[id] = u; } });
    });
    if (!ids.length) return;
    ownerOf = own; order = []; active = true;
    var img = it.querySelector('img');
    // the thumbnail lifts off the circle exactly as a grid tile does (the composited crop-flight)
    try { if (window.__rovaHeroExpand && img) { window.__rovaHeroExpand(img.getBoundingClientRect(), img.currentSrc || img.src, null, img); } } catch (e2) {}
    // guest or member: the lap, then the continuation (/ring-next), then the Discover roll (2026-10-09: guests no longer stop at the lap)
    window.__rovaFeedView(ids, ids[0], 0, 0, /*feedless*/ true, false, false, { ring: true, guest: guest });
  });
  /* THE "+" ON "ME" FOLLOWS THE COMPOSER (Rob 2026-10-12: "a Plus sign rotating to an X, which expands/collapses the
     composer"). The ONE truth is #feed-compose-box's .panel-idle (the feed IIFE's composePanel), so every way the composer
     opens or closes -- this circle, the header "+", its red X, Escape, the scroll-away auto-close, a post landing -- turns
     the "+" with it: `.mring-cmp-open` on the row (rova.css rotates the glyph 45deg into an "x"), aria-expanded on the
     circle. No composer on the page (guests) = nothing to follow. */
  var cmpBox = document.getElementById('feed-compose-box');
  function cmpSync() {
    if (!cmpBox) return;
    var open = !cmpBox.classList.contains('panel-idle');
    if (row.classList.contains('mring-cmp-open') !== open) row.classList.toggle('mring-cmp-open', open);
    // the header "+" (#post-link) turns with it (Rob 10-12): ONE class on <html>, ONE rova.css rule for both glyphs
    if (document.documentElement.classList.contains('cmp-open') !== open) document.documentElement.classList.toggle('cmp-open', open);
    var pl = document.getElementById('post-link');
    if (pl && pl.getAttribute('aria-expanded') !== (open ? 'true' : 'false')) pl.setAttribute('aria-expanded', open ? 'true' : 'false');
    var me = track.querySelector('.mring-me0');
    if (me && me.getAttribute('aria-expanded') !== (open ? 'true' : 'false')) me.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  if (cmpBox && typeof MutationObserver === 'function') {
    try { new MutationObserver(cmpSync).observe(cmpBox, { attributes: true, attributeFilter: ['class'] }); } catch (e) {}
    cmpSync();
  }
  document.addEventListener('rova:pfpost', onPost);
  document.addEventListener('rova:pfclose', onClose);
  window.addEventListener('pagehide', function () { flush(true); });

  /* ====================================================================================================
     FRESHNESS  (Rob 2026-09-18, on the app: "I had to force close the app to see Slay's new post in the
     media ring. Should have loaded in smoothly animated or automatically or at least a pull to refresh
     should have shown it.")  The app (build 327) re-reads its row on a pull, on a rise in the 8 s poll's
     count, on the return to the foreground and every 90 s; this is the web twin, with the truer signal.

     WHEN THE ROW RE-READS (GET /feed?partial=ring, the same MediaRing::circles() a reload would draw):
       rev      X-Rova-Ring-Rev moved. The header rides every fragment this page already fetches (the
                since-poll, the roll, the pager, a tab swap, /engage-live) -- rfetch() lifts it off each
                response and fires rova:ringrev; it is MediaRing::rev(), which changes iff this viewer's
                row would render differently (membership, order, a person's newest post, a seen flag)
                and ignores counts, text posts and strangers' posts. No request is ever made for it.
       pull     the pull-to-refresh committed (rova:pull), on any tab.
       visible  the tab came back (visibilitychange -> visible).
       tick     every TICK_MS, while the document is visible AND focused.
     NEVER hidden, NEVER under the viewer (`.pfeed.show` / html.pfv-on, or this module's own ring session)
     and never while a finger is on the track: yesterday's rule -- nothing that inserts or reorders rows
     runs under a cover. A signal that arrives then sets `dirty`; the way out (close, unhide, finger up)
     re-reads once. Guests get no header (their fragments are viewer-free and session-less); pull /
     visible / tick still re-read the shared guest row.

     WHAT A RE-READ DOES: diffs the fragment into the live row by data-u. A circle new to the row fades and
     scales in over 260 ms (.mring-in), one that left the window fades and scales out (.mring-out), the
     rest are updated in place (thumbnail, deck, seen) and moved to the order the server gave; reduced
     motion = instant. The reader's place in the row is kept: the first visible circle keeps its exact x
     across the diff (a circle before it lands or leaves at full size and the scroll is corrected in the
     same task; one at or after it grows / shrinks so only the circles to its right slide). With the first
     circle in view the row simply grows from its head, so a new first circle is the one thing that moves
     into view.
     The 92 px slot is fixed in CSS and an empty row collapses (hidden) exactly as the server renders it,
     so the tab switcher never moves. Per-tab scroll memory and the seen state above are untouched.
     ==================================================================================================== */
  var TICK_MS = 90000;
  var rev = row.getAttribute('data-rev') || '';
  var reading = false, again = null, dirty = null, touching = false, seenRev = '';
  var reads = [], ticks = { fired: 0, skipped: { hidden: 0, unfocused: 0, viewer: 0, session: 0, finger: 0 } };
  var mqCalm = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function calm() { return !!(mqCalm && mqCalm.matches); }
  function covered() {
    if (active || settleArmed) return 'session';   // settleArmed: the close's flight is still landing in its circle
    if (document.documentElement.classList.contains('pfv-on') || document.querySelector('.pfeed.show')) return 'viewer';
    return '';
  }
  function blocked() {
    if (document.hidden) return 'hidden';
    var c = covered(); if (c) return c;
    if (touching) return 'finger';
    if (row.classList.contains('mring-tucked')) return 'tucked';   // folded away with the chrome (THE MEDIA RING FOLDS, feed IIFE): no reads until it is back
    return '';
  }
  function reread(reason) {
    var b = blocked();
    if (b) { dirty = reason; return false; }
    if (reading) { if (reason === 'rev' || reason === 'pull') again = reason; return false; }
    reading = true; dirty = null;
    var t0 = Date.now();
    rfetch('/feed?partial=ring', { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', cache: 'no-store' }, 8000)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        reading = false;
        if (blocked()) { dirty = reason; return; }   // went under a cover while in flight: the fragment is dropped, re-read on the way out
        // a fragment that is not the row, or the row the server FAILED to build (data-fail, MediaRing::failed()),
        // is a failed read -- never applied: a transient server fault must not wipe a good row off the page
        if (html.indexOf('id="media-ring"') < 0 || /<nav[^>]*\sdata-fail="1"/.test(html)) { readFailed('srv'); return; }
        readOk();
        apply(html, reason, Date.now() - t0);
        if (again === 'rev' && seenRev === rev) again = null;   // the header that queued it is the value just applied: nothing to ask
        if (again) { var a = again; again = null; setTimeout(function () { reread(a); }, 60); }
      })
      .catch(function (err) {   // nothing on screen changes on a failed read (bar the offline door below); the retry asks again
        reading = false; again = null;
        readFailed((err && err.status) ? 'srv' : 'net');   // a status = our server answered; none = no answer at all
      });
    return true;
  }
  /* ====================================================================================================
     LOADING AND OFFLINE  (2026-09-25, iOS parity -- the app's ring shows shimmering placeholder discs on a
     slow link and, when no answer comes after its retries, "Offline / Tap to retry", retrying on its own at
     8 s, 20 s, then every 45 s.)
     The web row is SERVER-RENDERED, so the app's first-paint skeleton has no web twin: the circles arrive
     with the document. What the web does have is the two ways a row can have nothing to show:
       - the server FAILED to build it (MediaRing::circles() fails soft to []): the view now keeps the fixed
         92 px slot with placeholder discs (.mring-fail + .mring-skel, views/_media_ring.php) instead of
         rendering nothing, and this module re-reads AT ONCE. Success fills the slot in place (nothing below
         moves); failure shows the door (.mring-offline) with the honest headline -- Offline for no answer,
         the trouble line when our server answered with a failure -- and the retry ladder runs.
       - a RE-READ fails while the row has circles: the circles stay (they are still true and still open
         the viewer) and the ladder runs SILENTLY; no door is painted over a working row. Before this a
         failed re-read waited for the next 90 s tick, and a failed-soft fragment (an empty data-fail row)
         would have been APPLIED -- every circle animated out and the row collapsed.
     A genuinely empty row (hidden, no data-fail) stays hidden, as the owner's 2026-09-17 spec says. */
  var RETRY_MS = [8000, 20000, 45000];   // the app's ladder: 8 s, 20 s, then every 45 s
  var failN = 0, retryT = null, retries = 0;
  var skel = row.querySelector('.mring-skel'), door = row.querySelector('.mring-retry');
  function failing() { return row.classList.contains('mring-fail'); }
  function readFailed(kind) {
    if (failing() && door) {
      var h = door.querySelector('.mring-retry-h');
      if (h) h.textContent = door.getAttribute(kind === 'srv' ? 'data-p-srv' : 'data-p-net') || (kind === 'srv' ? 'Rova is having trouble' : 'Offline');
      row.classList.add('mring-offline');
    }
    clearTimeout(retryT);
    retryT = setTimeout(function () { retryT = null; retries++; reread('retry'); }, RETRY_MS[Math.min(failN, RETRY_MS.length - 1)]);
    failN++;
  }
  function readOk() {
    failN = 0; clearTimeout(retryT); retryT = null;
    if (!failing()) return;
    row.classList.remove('mring-fail', 'mring-offline');
    row.removeAttribute('data-fail');
    if (skel && skel.parentNode) skel.parentNode.removeChild(skel);
    skel = door = null;
  }
  row.addEventListener('click', function (e) {
    if (!door || !e.target || !e.target.closest || !e.target.closest('.mring-retry')) return;
    e.preventDefault();
    failN = 0; clearTimeout(retryT); retryT = null;   // a deliberate tap restarts the ladder at the bottom
    row.classList.remove('mring-offline');            // back to the placeholders while it asks
    reread('tap');
  });
  // the OS says the link is back: ask now instead of sitting out the rest of a step
  window.addEventListener('online', function () { if (retryT) { clearTimeout(retryT); retryT = null; reread('online'); } });
  if (failing()) { setTimeout(function () { reread('boot'); }, 0); }
  function firstVisible(its) {
    var sl = track.scrollLeft;
    for (var i = 0; i < its.length; i++) { if (its[i].offsetLeft + its[i].offsetWidth > sl) return its[i]; }
    return null;
  }
  function lisSet(a) {   // the values of a longest increasing subsequence of a (<= 40 items: the quadratic walk is nothing)
    var n = a.length, len = [], prev = [], best = 0, bi = -1, s = {};
    for (var i = 0; i < n; i++) {
      len[i] = 1; prev[i] = -1;
      for (var j = 0; j < i; j++) { if (a[j] < a[i] && len[j] + 1 > len[i]) { len[i] = len[j] + 1; prev[i] = j; } }
      if (len[i] > best) { best = len[i]; bi = i; }
    }
    for (var k = bi; k >= 0; k = prev[k]) s[a[k]] = true;
    return s;
  }
  /* ====================================================================================================
     THE ROW APPEARING OR DISAPPEARING MUST NOT MOVE THE FEED  (2026-09-18)
     ====================================================================================================
     `.mring` is height:92px + margin:2px 0 4px = a **98px** change ABOVE the reader, and it happens twice:
     when an empty row gains its first circle, and when its last circle leaves. apply() corrected only
     `track.scrollLeft` -- the row's horizontal place -- and nothing at all vertically, so the whole
     timeline jumped 98px under the reader. MEASURED on the live feed, mid-document, on BOTH engines:
     scrollY unchanged, #feed-posts shifted exactly 98px, and the card at the top edge became a different
     card (53710 -> 53711 -> 53710). Not an engine quirk to wait out either: `#feed-posts` carries
     `overflow-anchor:none` ON PURPOSE (rova.css) -- the browser's own anchoring is deliberately off here
     and Safari has never implemented it at all, which is exactly why every other insertion above this
     timeline corrects the scroll BY HAND (insertTop's place-keeping; the composer's auto-collapse). The
     ring was the one insertion above the reader that never got one. This is the shape that produces "the
     feed jumped" reports nobody can reproduce.

     SAME IDIOM AS insertTop, deliberately: measure a reference that survives the change, make the change,
     re-measure, give the delta straight back to scrollTop (instant -- this is a correction, not a move),
     and stamp the feed's own suppressScrollUntil through __rovaFeedOwnScroll so its idleFor() reads the
     correction as OUR scroll rather than as the reader moving.

     AT THE TOP WE DELIBERATELY DO NOT CORRECT. A first circle arriving while the reader is at the head of
     the feed must REVEAL itself -- compensating there would push the row straight back off screen and hide
     the very thing that just arrived, which is the opposite of what the freshness work is for. */
  function keepPlace(flip) {
    var se = document.scrollingElement || document.documentElement;
    var ref = document.getElementById('feed-posts');
    if (!ref || se.scrollTop <= 1) { flip(); return 0; }
    var refTop = ref.getBoundingClientRect().top;
    flip();
    if (!ref.isConnected) return 0;
    var d = Math.round(ref.getBoundingClientRect().top - refTop);   // forces the layout we need
    if (d) {
      if (window.__rovaFeedOwnScroll) { try { window.__rovaFeedOwnScroll(); } catch (e) {} }
      se.scrollTop = se.scrollTop + d;
    }
    return d;
  }
  function leave(it, animate) {
    if (!animate) { if (it.parentNode) it.parentNode.removeChild(it); return; }
    it.classList.add('mring-out', 'mring-shrink');
    var done = false;
    function gone() { if (done) return; done = true; if (it.parentNode) it.parentNode.removeChild(it); }
    it.addEventListener('animationend', gone);
    setTimeout(gone, 420);
  }
  function apply(html, reason, ms) {
    var tmp = document.createElement('div');
    tmp.innerHTML = (html || '').trim();
    var nav = tmp.querySelector('#media-ring');
    if (!nav) return;                                  // not the fragment (a wall, an error page): keep what we have
    var newRev = nav.getAttribute('data-rev') || '';
    var incoming = Array.prototype.slice.call(nav.querySelectorAll('.mring-item'));
    var cur = live(), byU = {};
    cur.forEach(function (it) { byU[it.getAttribute('data-u')] = it; });
    var sl0 = track.scrollLeft, pre = {};
    cur.forEach(function (it) { pre[it.getAttribute('data-u')] = it.offsetLeft; });   // where everything was, before anything moves
    var anchor = row.hidden ? null : firstVisible(cur);
    // AT THE HEAD = the first circle is wholly in view. Not `scrollLeft === 0`: the track snaps (scroll-snap-align:
    // start on a padded track), so a row that has never been scrolled rests at scrollLeft 10, its padding.
    var atHead = !anchor || (anchor === cur[0] && pre[cur[0].getAttribute('data-u')] >= sl0 - 1);
    // LIVE AT THE FRONT (2026-09-30): with live circles ahead of the media circles, "at the head" also means the
    // track itself is unscrolled -- otherwise a reader looking at media circle 1 with the live ones scrolled
    // off would be yanked back to the Go live circle by the scrollLeft = 0 below.
    if (atHead && track.querySelector('.mring-lv') && sl0 > 12) atHead = false;
    var added = [], removed = [], moved = 0, changed = 0, keep = {}, prev = null, fresh = [], movedSet = {};
    /* LEAVERS FIRST. A circle that is not in the fragment stays in the DOM until its exit animation ends, so the
       placement pass below must step over it -- otherwise every circle that stays gets moved in front of it and
       the leaver drifts to the end of the row, dragging the reader's place with it. */
    var stayU = {};
    incoming.forEach(function (n) { stayU[n.getAttribute('data-u')] = true; });
    var leavers = cur.filter(function (it) { return !stayU[it.getAttribute('data-u')]; });
    leavers.forEach(function (it) { it.__mrLeaving = true; removed.push(it.getAttribute('data-u')); });
    /* MOVE THE FEWEST CIRCLES. The circles already in the row that are in the right relative order (the longest
       increasing subsequence of their DOM positions, in the fragment's order) stay put; only the others move. One
       circle out of place -- a seen circle the server put at the back -- is ONE move, never "every other circle
       moved in front of it", which is what a naive front-to-back walk does and what would make every circle count
       as moved (and leave the reader's place with nothing to stand on). Walked in REVERSE so each node is placed
       before the already-settled node behind it. */
    var domIdx = {};
    cur.forEach(function (it, i) { domIdx[it.getAttribute('data-u')] = i; });
    var keptSeq = [];
    incoming.forEach(function (n) { var u = n.getAttribute('data-u'); if (byU[u]) keptSeq.push(domIdx[u]); });
    var stays = lisSet(keptSeq);
    var nextStable = null;
    for (var ii = incoming.length - 1; ii >= 0; ii--) {
      var n = incoming[ii], u = n.getAttribute('data-u'), it = byU[u];
      /* "ME" WITH NOTHING IN 24 H (`.mring-me0`, 2026-10-12) is not a story circle: when either side is one (you just posted
         your first media of the day, or your last one aged out), the incoming node simply takes its place -- one node, no
         seen state, nothing to patch. It keeps its slot (data-u is yours both ways); flagged moved so it is never the
         circle the reader's place is held on. */
      if (it && (it.classList.contains('mring-me0') || n.classList.contains('mring-me0'))) {
        if (it.outerHTML !== n.outerHTML) { track.replaceChild(n, it); it = n; changed++; movedSet[u] = true; }
        if (!stays[domIdx[u]]) { track.insertBefore(it, nextStable); moved++; movedSet[u] = true; }
      } else if (it) {
        ['data-ids', 'data-newest', 'href', 'aria-label', 'title'].forEach(function (a) {
          var v = n.getAttribute(a);
          if (v !== null && it.getAttribute(a) !== v) { it.setAttribute(a, v); changed++; }
        });
        if (it.classList.contains('is-video') !== n.classList.contains('is-video')) { it.classList.toggle('is-video'); changed++; }
        var img = it.querySelector('.mring-img'), nimg = n.querySelector('.mring-img');
        // srcset/sizes travel with src (2026-10-12, the ring's small pictures): a stale srcset would outrank a new src
        if (img && nimg && (img.getAttribute('src') !== nimg.getAttribute('src') || img.getAttribute('srcset') !== nimg.getAttribute('srcset'))) {
          ['srcset', 'sizes'].forEach(function (a) { var v = nimg.getAttribute(a); if (v === null) img.removeAttribute(a); else img.setAttribute(a, v); });
          img.setAttribute('src', nimg.getAttribute('src'));
          if (nimg.hasAttribute('data-video')) img.setAttribute('data-video', '1'); else img.removeAttribute('data-video');
          changed++;
        }
        /* THE AVATAR BADGE (2026-09-24, owner via the app session: web parity with the app's avatar badge). A kept
           circle is patched, never replaced, so a new face or initial has to be carried across here -- and a circle
           painted before the badge shipped (no .mring-av at all) gains one on its next re-read. Compared on data-av
           (the server's URL, which nothing on the page rewrites -- the CDN retry rewrites `src`) + the letter. */
        var av = it.querySelector('.mring-av'), nav2 = n.querySelector('.mring-av'), ring = it.querySelector('.mring-ring');
        if (nav2 && ring && (!av || av.getAttribute('data-av') !== nav2.getAttribute('data-av') || av.textContent !== nav2.textContent)) {
          if (av) ring.replaceChild(nav2, av); else ring.appendChild(nav2);
          changed++;
        }
        var nm = it.querySelector('.mring-name'), nnm = n.querySelector('.mring-name');
        if (nm && nnm && nm.textContent !== nnm.textContent) { nm.textContent = nnm.textContent; changed++; }
        if (stPatch(it, n)) changed++;   // the status line ("3 new" / "2h", Option A)
        // the seen state is the server's -- unless this page has already reached the person's newest post
        // (its beacon may still be in flight): the row never un-sees what the reader just watched
        var seen = n.classList.contains('seen') || ((high[u] || 0) >= (parseInt(n.getAttribute('data-newest'), 10) || 0));
        if (it.classList.contains('seen') !== seen) { it.classList.toggle('seen', seen); it.setAttribute('data-seen', seen ? '1' : '0'); changed++; }
        if (seen || high[u]) stLocal(it, u);   // the server's line may predate this page's own beacon
        if (!stays[domIdx[u]]) { track.insertBefore(it, nextStable); moved++; movedSet[u] = true; }
      } else { it = n; added.push(u); fresh.push(it); track.insertBefore(it, nextStable); }
      keep[u] = true; nextStable = it;
    }
    // the row coming back from empty: +98px above the reader, kept still (keepPlace, above)
    if (incoming.length && row.hidden) { keepPlace(function () { row.hidden = false; row.classList.remove('mring-empty'); }); }
    var anim = !calm();
    /* WHERE THE READER STANDS: the first visible circle that kept its place (a circle that itself moved -- to the
       back after being seen, say -- cannot be the thing held still, or the row would follow it there). */
    var stand = null, standU = '';
    if (!atHead) {
      for (var i = 0; i < cur.length; i++) {
        var c = cur[i], cu = c.getAttribute('data-u');
        if (!keep[cu] || movedSet[cu]) continue;
        if (pre[cu] + c.offsetWidth > sl0) { stand = c; standU = cu; break; }
      }
    }
    var ax = stand ? stand.offsetLeft : -1;   // ONE layout read after the mutations, everything still at full size
    fresh.forEach(function (it) {
      if (!anim) return;
      it.classList.add('mring-in');
      if (atHead || ax < 0 || it.offsetLeft >= ax) it.classList.add('mring-grow');
      it.addEventListener('animationend', function done() { it.classList.remove('mring-in', 'mring-grow'); it.removeEventListener('animationend', done); });
    });
    leavers.forEach(function (it) { leave(it, anim && (atHead || ax < 0 || it.offsetLeft >= ax)); });
    /* ALWAYS WRITE THE OFFSET, in the same task as the mutation. The track is a snap container and the engine
       tracks the element it last snapped to: move that element (a seen circle to the back) and the engine re-snaps
       the track onto it -- to the far end -- unless a programmatic scroll re-targets it first. So: at the head the
       row goes (back) to its head, elsewhere the circle the reader stands on keeps its exact x. */
    track.scrollLeft = atHead ? 0 : (stand ? stand.offsetLeft - (pre[standU] - sl0) : sl0);
    cmpSync();   // a "Me" circle that arrived in this read takes the composer's current state (aria-expanded)
    if (!incoming.length) {
      // the last circle gone: -98px above the reader, kept still the same way
      // ...unless the live group still has circles (Go live / followed lives, 2026-09-30): the row stays
      var hide = function () { if (!live().length && !track.querySelector('.mring-lv:not(.mring-out)')) { keepPlace(function () { row.hidden = true; row.classList.add('mring-empty'); }); } };
      if (anim && leavers.length) setTimeout(hide, 320); else hide();
    }
    rev = newRev;
    var rec = { reason: reason, at: Date.now(), ms: ms, rev: newRev, n: incoming.length, added: added, removed: removed, moved: moved, changed: changed, sl0: sl0, sl1: track.scrollLeft };
    reads.push(rec); if (reads.length > 60) reads.shift();
    try { document.dispatchEvent(new CustomEvent('rova:ringread', { detail: rec })); } catch (e) {}
  }

  document.addEventListener('rova:ringrev', function (e) {
    var v = e && e.detail && e.detail.rev;
    if (!v || guest) return;
    seenRev = v;
    if (v === rev) return;
    reread('rev');
  });
  document.addEventListener('rova:pull', function () { reread('pull'); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) reread('visible'); });
  setInterval(function () {
    if (document.hidden) { ticks.skipped.hidden++; return; }
    if (!document.hasFocus()) { ticks.skipped.unfocused++; return; }
    var c = covered(); if (c) { ticks.skipped[c]++; return; }
    if (touching) { ticks.skipped.finger++; return; }
    if (row.classList.contains('mring-tucked')) { ticks.skipped.tucked = (ticks.skipped.tucked || 0) + 1; return; }
    ticks.fired++; reread('tick');
  }, TICK_MS);
  // back from the fold: anything that arrived while it was tucked re-reads once, after the .55 s glide
  document.addEventListener('rova:ringtuck', function (e) {
    if (!e.detail || e.detail.tucked || !dirty) return;
    setTimeout(function () { if (dirty && !row.classList.contains('mring-tucked')) { var d = dirty; dirty = null; reread(d); } }, 600);
  });
  track.addEventListener('touchstart', function () { touching = true; }, { passive: true });
  function lift() { if (!touching) return; touching = false; if (dirty) { var d = dirty; dirty = null; setTimeout(function () { reread(d); }, 250); } }
  track.addEventListener('touchend', lift, { passive: true });
  track.addEventListener('touchcancel', lift, { passive: true });
  /* HORIZONTAL ONLY (2026-10-08, Rob on iPhone: "The media ring should only scroll horizontally (when swiping on the phone
     it's bouncing around vertically also)"). CAUSE (measured, Chromium real CDP touch, 390): the browser latches a pan's
     axis from its FIRST few px, and a thumb's sideways swipe usually starts with an arc -- 10 px down, 4 sideways -- so
     the page scrolled vertically (12 px at scrollY 40) while the ring did not move at all, and at the top the pull drew
     the list down 9 px. iOS rubber-bands the same way. FIX: on a touch device the track is touch-action:pan-x
     (.mring-hx, rova.css): the browser only ever pans the ring sideways from here, so no arc can latch the page and the
     ring itself can never move vertically. BUT pan-x alone would also take the genuine vertical scroll away from a thumb
     that lands on a circle (measured: a 300 px swipe up from the ring moved the page 0 px), so a clearly VERTICAL swipe is
     handed to the page here: decided once at DECIDE px of travel, vertical only when |dy| > AXIS * |dx| (the pull uses the
     same rule: RING_DECIDE_PX / RING_AXIS in THE PULL AT THE TOP IS OURS), the page follows the finger 1:1 from that
     point and a release coasts on with UIScrollView's normal deceleration (0.998 per ms). Any new touch or wheel stops
     the coast. Down at the very top is still the pull to refresh (the pull's own handler; scrollTo cannot go above 0).
     A swipe handed to the page never opens a circle (its click is eaten). Mouse / no touch: nothing changes. */
  (function () {
    if (!('ontouchstart' in window)) return;
    var DECIDE = 12, AXIS = 2, K = 0.002, VMAX = 6;   // K: e^(-K t) = 0.998 per ms
    track.classList.add('mring-hx');
    var g = null, fl = 0, eatUntil = 0;
    function flStop() { if (fl) { cancelAnimationFrame(fl); fl = 0; } }
    function hxBlocked() { return document.documentElement.classList.contains('pfv-on') || document.body.classList.contains('scroll-locked') || !!document.querySelector('.pfeed.show'); }
    window.addEventListener('touchstart', flStop, { capture: true, passive: true });
    window.addEventListener('wheel', flStop, { capture: true, passive: true });
    track.addEventListener('touchstart', function (e) {
      var t = e.touches[0];
      g = (t && e.touches.length === 1 && !hxBlocked()) ? { x0: t.clientX, y0: t.clientY, dir: '', s: [] } : null;
    }, { passive: true });
    track.addEventListener('touchmove', function (e) {
      if (!g || g.dir === 'x') return;
      if (e.touches.length !== 1) { g = null; return; }
      var t = e.touches[0], now = performance.now();
      if (!g.dir) {
        var ax = Math.abs(t.clientX - g.x0), ay = Math.abs(t.clientY - g.y0);
        if (Math.max(ax, ay) < DECIDE) return;
        if (ay <= ax * AXIS) { g.dir = 'x'; return; }   // a browse: the ring's own (native, pan-x) scroll, the page stays
        g.dir = 'y'; g.y0 = t.clientY; g.sy0 = window.scrollY;   // follow from here: no jump by the decision's travel
      }
      window.scrollTo(window.scrollX, g.sy0 - (t.clientY - g.y0));
      g.s.push([now, t.clientY]);
      while (g.s.length > 2 && now - g.s[0][0] > 100) g.s.shift();
    }, { passive: true });
    track.addEventListener('touchcancel', function () { g = null; }, { passive: true });
    track.addEventListener('touchend', function () {
      var gg = g; g = null;
      if (!gg || gg.dir !== 'y') return;
      eatUntil = Date.now() + 450;
      var s = gg.s, now = performance.now();
      if (s.length < 2) return;
      var a0 = s[0], z = s[s.length - 1], dt = z[0] - a0[0];
      if (dt <= 0 || now - z[0] > 70) return;            // the finger had stopped: no coast
      var v = Math.max(-VMAX, Math.min(VMAX, -(z[1] - a0[1]) / dt));   // px/ms, + = down the page
      if (Math.abs(v) < 0.15) return;
      var y0 = window.scrollY, t0 = now, last = y0;
      flStop();
      (function step() {
        fl = 0;
        if (hxBlocked() || document.hidden) return;
        var el = performance.now() - t0, e1 = Math.exp(-K * el), vNow = v * e1;
        window.scrollTo(window.scrollX, y0 + v / K * (1 - e1));
        var y = window.scrollY;
        if (Math.abs(vNow) < 0.02) return;                 // came to rest
        if (el > 40 && Math.abs(vNow) * 16 >= 1 && Math.abs(y - last) < 0.5) return;   // hit the top / the end of the page
        last = y;
        fl = requestAnimationFrame(step);
      })();
    }, { passive: true });
    // a swipe handed to the page is never a tap on a circle
    track.addEventListener('click', function (e) { if (Date.now() < eatUntil) { e.preventDefault(); e.stopImmediatePropagation(); } }, true);
    window.__rovaRingHx = function () { return { on: track.classList.contains('mring-hx'), coasting: !!fl, ta: getComputedStyle(track).touchAction }; };
  })();

  /* ====================================================================================================
     LIVE AT THE FRONT  (owner 2026-09-30: Go live is the ring's FIRST circle; people you follow who go live
     appear right after it in REALTIME, as a live thumbnail with a red ring and a LIVE badge, and leave when
     the stream ends.) Markup views/_ring_live.php (#mring-lives, `.mring-lv` -- never `.mring-item`, so
     nothing above ever builds a deck from, marks or reorders a live circle).
     WHEN IT RE-READS: the LIVE PULSE module below polls GET /live/pulse (one Redis read, sessionless) and
     fires `rova:livepulse` when the box-wide who-is-live rev moves; only then is GET /feed?partial=ringlive
     fetched. Same cover rules as the row: never hidden / under the viewer / under a finger / tucked --
     a pulse then only sets `ldirty`, re-read on the way out (visible, close, finger up, un-tuck).
     WHAT A RE-READ DOES: diffs by data-k (go | l<stream id>). A new live circle fades + scales in (and grows
     its slot when the row is at its head, so it slides into view); an ended one fades + shrinks out; kept
     ones keep their node, so their thumbnail never blinks. Off the head, the reader's place is kept: the
     first media circle keeps its x. An empty row that gains a live circle un-hides (+98 px kept still,
     keepPlace); a row whose only circles were live ones hides when they go.
     ==================================================================================================== */
  var lgroup = track.querySelector('#mring-lives');
  var lrev = lgroup ? (lgroup.getAttribute('data-lrev') || '0') : '0';
  var lreading = false, ldirty = false, lreads = [];
  /* GUESTS (Rob 2026-09-30, later: signed-out guests see live creators' circles; a tap is the sign-up gate). A guest's
     group is the PUBLIC lives (LiveRing::guestRing). A guest row with nobody live has NO #mring-lives at all (its HTML
     is byte-identical to before), so the first live read GROWS the group at the track's front. The guest read is
     `?partial=ringlive&lrev=<the pulse rev>` with NO X-Requested-With: that makes it the edge-cacheable guest render
     (sessionless, public for LiveRing::GUEST_EDGE_TTL s, keyed by the rev) -- one origin render per PoP answers every
     guest feed that saw the same pulse. ?app=1 rides along (the circle's href keeps it: the log-in-only gate page). */
  var lwant = lrev;
  var appChrome = document.body && document.body.classList.contains('app-embed');
  function liveUrl() {
    if (!guest) return '/feed?partial=ringlive';
    return '/feed?partial=ringlive&lrev=' + encodeURIComponent(lwant || '0') + (appChrome ? '&app=1' : '')
      + (tpWantSig ? '&tsig=' + encodeURIComponent(tpWantSig) : '');   // TOP LIVES (2026-10-12): a moved ranking = a new edge key
  }
  /* A FOLDED RING STILL HEARS ITS LIVES (2026-10-02, THE WENT-LIVE FLASH below): for a MEMBER the live group re-reads
     while the row is tucked -- the read is how the ring learns that someone they follow went live, which is the one
     thing allowed to bring it back. Every other cover (hidden, the viewer, a finger on the track) still defers it.
     Guests keep the old rule (no flash for them; their tucked read would only be edge traffic for nothing). */
  function lblocked() { var b = blocked(); return (b === 'tucked' && !guest) ? '' : b; }
  function liveRead(reason) {
    if (!lgroup && !guest) return false;
    if (lblocked()) { ldirty = true; return false; }
    if (lreading) { ldirty = true; return false; }
    lreading = true; ldirty = false;
    var t0 = Date.now();
    rfetch(liveUrl(), guest ? { credentials: 'same-origin', cache: 'default' }
                            : { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', cache: 'no-store' }, 8000)
      .then(function (r) { if (!r.ok) throw r; return r.text(); })
      .then(function (html) {
        lreading = false; lfail = 0;
        if (html.indexOf('id="mring-lives"') < 0) return;
        if (lblocked()) { ldirty = true; return; }
        liveApply(html, reason, Date.now() - t0);
        if (ldirty) { ldirty = false; setTimeout(function () { liveRead('again'); }, 60); }
      })
      .catch(function () { lreading = false; liveRetry(reason); });
    return true;
  }
  /* A LIVE RE-READ THAT FAILED IS RETRIED (2026-10-08). It used to be dropped: the pulse had already moved its rev, so
     nothing asked again until the NEXT live started or ended, and an ended circle sat in the row (its snapshot 404ing)
     for as long as that took. Up to 4 tries, 3 / 6 / 9 / 12 s apart; a cover still defers it (liveRead sets ldirty). */
  var lfail = 0, lretryT = null;
  function liveRetry(reason) {
    if (lretryT || lfail >= 4) return;
    lfail++;
    lretryT = setTimeout(function () { lretryT = null; liveRead('retry:' + String(reason).replace(/^retry:/, '')); }, 3000 * lfail);
  }
  /* THE KEPT CIRCLE'S SNAPSHOT (2026-10-08). A kept circle keeps its node, so its .mring-lthumb kept the snapshot URL it
     was drawn with -- a stream re-signed by a privacy flip (db/0247's epoch) 404ed on the old URL for as long as it stayed
     live. The re-read's template is copied on; a snapshot the thumbnail module had given up on (two 404s) is revived,
     because the server just said this live is still on (window.__rovaLiveThumbRevive: after a growing hold). */
  function thPatch(el, n) {
    var th = el.querySelector('.mring-lthumb'), nt = n.querySelector('.mring-lthumb');
    if (!th || !nt) return;
    var t = nt.getAttribute('data-lthumb') || '';
    if (t && th.getAttribute('data-lthumb') !== t) th.setAttribute('data-lthumb', t);
    // MOVING PREVIEWS (2026-10-17): the loop template follows the re-read too (gained / lost / re-signed); the thumbnail module acts on it
    var lp = nt.getAttribute('data-lloop') || '';
    if (lp) { if (th.getAttribute('data-lloop') !== lp) th.setAttribute('data-lloop', lp); th.setAttribute('data-lloop-every', nt.getAttribute('data-lloop-every') || '30'); }
    else if (th.hasAttribute('data-lloop')) th.removeAttribute('data-lloop');
    if (nt.getAttribute('data-photo') === '1') th.setAttribute('data-photo', '1'); else if (th.hasAttribute('data-photo')) th.removeAttribute('data-photo');   // THE PHOTO RING (2026-10-23)
    if (window.__rovaLiveThumbRevive) window.__rovaLiveThumbRevive(th);
  }
  /* ROOM FACES (Rob 2026-10-16: the people on stage with a host, in a circle on the host's live ring; views/_room_faces.php, rova.css
     "ROOM FACES"). A kept circle's `.lrf` is patched FACE BY FACE from the re-read (data-rf = the drawn set, data-u per face): a kept
     face only changes its slot class, so it glides along the circle (a transform transition) and its image is never reloaded; a new
     face pops in (.lrf-in, 320 ms); a leaver pops out (.lrf-out) and is removed after 280 ms. Kept nodes are never re-inserted (a moved
     node loses its transition). Reduced motion: swaps at once. Nothing per frame, nothing laid out. */
  function rfPatch(it, n) {
    var ring = it.querySelector('.mring-ring'); if (!ring) return;
    var cur = ring.querySelector('.lrf'), nw = n.querySelector('.lrf');
    var cs = cur ? cur.getAttribute('data-rf') : null, ns = nw ? nw.getAttribute('data-rf') : null;
    if (cs === ns) return;
    var anim = !calm();
    var gone = function (f) {
      if (!anim) { f.remove(); return; }
      f.classList.remove('lrf-in'); f.classList.add('lrf-out');
      setTimeout(function () { f.remove(); }, 280);
    };
    if (!nw) {   // everyone left the stage: the layer goes with its last faces
      cur.setAttribute('data-rf', '');
      Array.prototype.slice.call(cur.children).forEach(function (f) { if (!f.classList.contains('lrf-out')) gone(f); });
      setTimeout(function () { if (cur.isConnected && !cur.getAttribute('data-rf') && !cur.children.length) cur.remove(); }, anim ? 320 : 0);
      return;
    }
    if (!cur) { cur = nw.cloneNode(false); ring.insertBefore(cur, ring.querySelector('.mring-av, .mring-vs, .mring-rank')); }
    cur.setAttribute('data-rf', ns);
    var old = {}, keep = {};
    Array.prototype.forEach.call(cur.children, function (f) { if (!f.classList.contains('lrf-out')) old[f.getAttribute('data-u')] = f; });
    Array.prototype.slice.call(nw.children).forEach(function (f) {
      var u = f.getAttribute('data-u'), o = old[u];
      if (o) {
        keep[u] = 1;
        var cls = f.className + (o.classList.contains('lrf-in') ? ' lrf-in' : '');
        if (o.className !== cls) o.className = cls;   // a slot change: the transform transition carries it along the circle
        var oi = o.querySelector('img'), fi = f.querySelector('img');
        if (u === 'more' || !fi || !oi || oi.getAttribute('src') !== fi.getAttribute('src')) { if (o.innerHTML !== f.innerHTML) o.innerHTML = f.innerHTML; }
        return;
      }
      if (anim) {
        f.classList.add('lrf-in');
        f.addEventListener('animationend', function done() { f.classList.remove('lrf-in'); f.removeEventListener('animationend', done); });
      }
      cur.appendChild(f);
    });
    Object.keys(old).forEach(function (u) { if (!keep[u]) gone(old[u]); });
  }
  function liveApply(html, reason, ms) {
    var tmp = document.createElement('div');
    tmp.innerHTML = (html || '').trim();
    var ng = tmp.querySelector('#mring-lives');
    if (!ng) return;
    if (!lgroup) {
      if (!guest) return;
      // a guest row rendered with nobody live: grow the (empty) group at the front, then diff into it as usual
      lgroup = ng.cloneNode(false);
      track.insertBefore(lgroup, track.firstChild);
    }
    lrev = ng.getAttribute('data-lrev') || lrev;
    lgroup.setAttribute('data-lrev', lrev);
    if (ng.getAttribute('data-now')) lgroup.setAttribute('data-now', ng.getAttribute('data-now'));
    if (ng.hasAttribute('data-tsig')) lgroup.setAttribute('data-tsig', ng.getAttribute('data-tsig'));   // TOP LIVES: the ranking this read was cut from
    var cur = {}, keepK = {}, added = [], removed = [], addedEls = [];
    Array.prototype.forEach.call(lgroup.children, function (el) { if (!el.classList.contains('mring-out')) cur[el.getAttribute('data-k')] = el; });
    var inc = Array.prototype.slice.call(ng.children);
    var anim = !calm() && !row.classList.contains('mring-tucked');   // a folded row is invisible: no enter/leave motion nobody sees
    var sl0 = track.scrollLeft, head = sl0 <= 12;
    // the reference is the first media circle AFTER the lives -- your own circle (2026-10-12) sits ahead of them (rova.css order)
    var ref = items().filter(function (x) { return !isSelf(x); })[0] || null, x0 = ref ? ref.offsetLeft : 0;
    var prevEl = null;
    inc.forEach(function (n) {
      var k = n.getAttribute('data-k'); keepK[k] = true;
      var el = cur[k];
      if (el) {
        ['href', 'aria-label', 'title'].forEach(function (a) { var v = n.getAttribute(a); if (v !== null && el.getAttribute(a) !== v) el.setAttribute(a, v); });
        /* ONE BUBBLE PER BATTLE (2026-10-15): a kept battle bubble (keyed by its PAIR) may change its main live (the tap target)
           or its next round's battle id; names follow too */
        if (n.hasAttribute('data-live2')) {
          ['data-live', 'data-live2', 'data-u', 'data-u2', 'data-battle'].forEach(function (a) { var v = n.getAttribute(a); if (v !== null && el.getAttribute(a) !== v) el.setAttribute(a, v); });
          var bn = el.querySelector('.mring-name'), nbn = n.querySelector('.mring-name');
          if (bn && nbn && bn.innerHTML !== nbn.innerHTML) bn.innerHTML = nbn.innerHTML;
          // a co-host link's next round (linked <-> battle) keeps the node: its "VS" / "&" badge and its class follow the read
          var bv = el.querySelector('.mring-vs'), nbv = n.querySelector('.mring-vs');
          if (bv && nbv && bv.textContent !== nbv.textContent) bv.textContent = nbv.textContent;
          el.classList.toggle('is-cohost', n.classList.contains('is-cohost'));
        }
        stPatch(el, n);   // "● Live · N": the viewer count as of this read (Option A)
        thPatch(el, n);   // its snapshot URL as of this read (a re-signed stream), and a given-up snapshot revived
        tpPatch(el, n);   // TOP LIVES: its rank badge + likes / milestone data as of this read
        rfPatch(el, n);   // ROOM FACES (2026-10-16): who is on stage with the host, face by face
      } else {
        el = n; added.push(k); addedEls.push(el);
        if (anim) {
          el.classList.add('mring-in'); if (head) el.classList.add('mring-grow');
          el.addEventListener('animationend', function done() { el.classList.remove('mring-in', 'mring-grow'); el.removeEventListener('animationend', done); });
        }
      }
      var at = prevEl ? prevEl.nextSibling : lgroup.firstChild;
      if (el !== at) lgroup.insertBefore(el, at);
      prevEl = el;
    });
    Object.keys(cur).forEach(function (k) { if (!keepK[k]) { removed.push(k); leave(cur[k], anim && head); } });
    /* THE LIVE LINE'S ROOM (Rob 2026-10-04): the row is 104 (name + "● Live · N") only while a live circle is in it, else 92.
       The first live arriving / the last one ending animates it over 250 ms -- only when the row is open and the reader is
       at the top of the page; a hidden or folded row, or one above a scrolled reader, flips at once, place-kept. */
    // 2026-10-12: your OWN live ("Live", first circle) draws no status line, so it alone does not need the taller row
    var lvh = inc.some(function (n) { return n.classList.contains('mring-live') && !n.classList.contains('is-self'); });
    if (lvh !== row.classList.contains('mring-lvh')) {
      var se0 = document.scrollingElement || document.documentElement;
      if (row.hidden || row.classList.contains('mring-tucked') || !anim || se0.scrollTop > 1) {
        keepPlace(function () { row.classList.toggle('mring-lvh', lvh); });
      } else {
        row.classList.add('mring-lvh-anim');
        row.classList.toggle('mring-lvh', lvh);
        clearTimeout(row.__lvhT); row.__lvhT = setTimeout(function () { row.classList.remove('mring-lvh-anim'); }, 320);
      }
    }
    if (inc.length && row.hidden) { keepPlace(function () { row.hidden = false; row.classList.remove('mring-empty'); }); }
    if (!head && ref && ref.isConnected) { track.scrollLeft = sl0 + (ref.offsetLeft - x0); }   // off the head: the reader's circles stay put
    else if (head) { track.scrollLeft = 0; }
    if (!inc.length && !live().length) {
      var hideL = function () { if (!live().length && !track.querySelector('.mring-lv:not(.mring-out)')) { keepPlace(function () { row.hidden = true; row.classList.add('mring-empty'); }); } };
      if (anim && removed.length) setTimeout(hideL, 320); else hideL();
    }
    var rec = { reason: reason, at: Date.now(), ms: ms, rev: lrev, n: inc.length, added: added, removed: removed };
    lreads.push(rec); if (lreads.length > 40) lreads.shift();
    try { document.dispatchEvent(new CustomEvent('rova:livering', { detail: rec })); } catch (e) {}
    if (addedEls.length) flashArrived(addedEls);
  }
  document.addEventListener('rova:livepulse', function (e) {
    var v = e && e.detail && e.detail.rev;
    if ((!lgroup && !guest) || !v) return;
    lwant = v;
    if (v === lrev) return;
    // a jitter, so one broadcaster going live does not land every open feed on the origin in the same second
    setTimeout(function () { liveRead('pulse'); }, Math.floor(Math.random() * 1200));
  });
  /* A CIRCLE WHOSE SNAPSHOT DIED (2026-10-08: live #866's circle polled /live/thumb/866-* into 404s every 3 s for minutes).
     The thumbnail module stops polling a snapshot after two 404s in a row and asks the pulse at once (rova:livethumbdead).
     A rev that moved re-reads this group as always; but the rev may ALREADY have been taken (by this row or by the pulse's
     own earlier ask) while the circle stayed -- a dropped read, a read under a cover, a stale render -- and then nothing
     would ever re-read. So, once the pulse has had its beat: if the circle is still here, this group re-reads itself; the
     server's answer removes an ended live (the diff below) or keeps a live one (thPatch revives its snapshot). */
  document.addEventListener('rova:livethumbdead', function (e) {
    var im = e && e.detail && e.detail.img;
    if (!lgroup || !im || !lgroup.contains(im)) return;
    var el = im.closest ? im.closest('.mring-lv') : null;
    if (!el) return;
    setTimeout(function () {
      if (!el.isConnected || el.classList.contains('mring-out') || !lgroup.contains(el)) return;   // the rev's re-read already took it
      liveRead('thumb404');
    }, 2500);
  });
  // the way out of every cover: a pulse that arrived under it re-reads once
  function liveOut() { if (ldirty && !lblocked()) { ldirty = false; liveRead('dirty'); } }
  document.addEventListener('visibilitychange', function () { if (!document.hidden) setTimeout(liveOut, 300); });
  document.addEventListener('rova:pfclose', function () { setTimeout(liveOut, 1600); });
  document.addEventListener('rova:ringtuck', function (e) { if (e.detail && !e.detail.tucked) setTimeout(liveOut, 650); });
  track.addEventListener('touchend', function () { setTimeout(liveOut, 300); }, { passive: true });

  /* ====================================================================================================
     THE WENT-LIVE FLASH  (Rob 2026-10-02: "If I'm sitting on the feed on my phone or on web and someone I follow
     goes live, the media ring should expand and kinda flash so I see someone I followed went live.")
     ====================================================================================================
     THE SIGNAL IS THE ONE THAT ALREADY EXISTS -- no new request, no new server work per beat. The LIVE PULSE
     (GET /live/pulse every 6 s while the tab is visible: one sessionless Redis read, stopped while hidden) moves
     its box-wide rev when anyone goes live; this group then re-reads GET /feed?partial=ringlive (LiveRing::ringFor:
     the FOLLOWED lives this member may watch -- blocks, suppression, private-not-followed, mutes, killed and
     veiled streams already gone, their own live in `self`, never in the list). A circle that read ADDS is a
     followed member who just went live. The only change upstream: a MEMBER's folded ring now takes that read
     (lblocked above) instead of deferring it, because the read is what may bring the ring back.
     WHAT HAPPENS TO A NEW CIRCLE (`.mring-live`, never `.is-self` / Go live):
       folded at the top  -> the ring un-folds with its own glide (__rovaRingLiveWake.unfold: the pull's ringSet,
                             scrollY never written; never under a finger, a pull, an overlay or the viewer);
       folded, scrolled down -> nothing moves under the reader; the flash waits, and when the page comes back to
                             the top (settled, no finger) the ring un-folds and flashes then. A pull of their own
                             that brings the ring back plays it too;
       open               -> inserted (the enter animation above), the track brought back to its head if the
                             reader is not on it (hover / focus / finger), and flashed;
       off screen (open, scrolled away) -> flashed the moment it is 60% in view (one IntersectionObserver, only
                             while a flash is pending).
     THE FLASH (rova.css "THE WENT-LIVE FLASH"): FLASH_PULSES 3 x 600 ms of the red LIVE glow (a ring of --live
     around the circle, opacity 0 -> 1 -> 0 while it swells .94 -> 1.12) plus a scale bump of the circle (1 -> 1.08
     -> 1) on each pulse, cubic-bezier(.4,0,.2,1); several circles flash STAGGERED by 250 ms; then the circle is its
     ordinary live self. Transform/opacity only, on one small element per circle, removed at animationend.
     Reduced motion: no pulse, no scale -- the glow simply ON for 2 s.
     ONCE PER STREAM PER VIEWER: localStorage `rova:lvflash` {stream id: ms} (24 h, <= 200 ids; plus this page's
     memory when storage throws). FIRST LOAD: a circle the page was RENDERED with flashes only if it went live in
     the last FLASH_FRESH_S (60 s: you opened the feed as they went live); an older one is recorded as known and
     never flashes. A circle that ARRIVES on a re-read always may (it is new to this page).
     THE FOLD: [RETIRED 2026-10-04 -- the ring never folds now; the two "folded" rows above and the feed IIFE's bridge
     (un-fold / hold / re-tuck) are gone. A flash plays when the circle is 60% in view.] Guests: never (they follow nobody).
     Receipt: window.__rovaLiveFlash(). */
  var FLASH_KEY = 'rova:lvflash', FLASH_FRESH_S = 60, FLASH_PULSE_MS = 600, FLASH_PULSES = 3, FLASH_MS = FLASH_PULSE_MS * FLASH_PULSES,
      FLASH_CALM_MS = 2000, FLASH_STAGGER_MS = 250, FLASH_KEEP_MS = 86400000, FLASH_ENTER_MS = 280;
  var fq = [], fdone = {}, fio = null, fArrT = null, fArrOnF = false, fRetryT = null, fNextAt = 0, flog = [];
  function fstore() {
    try { var m = JSON.parse(localStorage.getItem(FLASH_KEY) || '{}'); return (m && typeof m === 'object') ? m : {}; } catch (e) { return {}; }
  }
  function fmark(id) {
    fdone[id] = 1;
    try {
      var m = fstore(), now = Date.now();
      Object.keys(m).forEach(function (k) { if (!(now - m[k] < FLASH_KEEP_MS)) delete m[k]; });
      m[id] = now;
      var ks = Object.keys(m);
      if (ks.length > 200) ks.sort(function (a, b) { return m[a] - m[b]; }).slice(0, ks.length - 200).forEach(function (k) { delete m[k]; });
      localStorage.setItem(FLASH_KEY, JSON.stringify(m));
    } catch (e) {}
  }
  function fid(el) { return (el && el.getAttribute && el.getAttribute('data-live')) || ''; }
  function flashable(el) {
    return !!el && el.isConnected && el.classList.contains('mring-live') && !el.classList.contains('is-self')
        && !el.classList.contains('mring-out') && !!fid(el)
        // TOP LIVES (2026-10-12): a top circle is not "someone you follow went live" unless you DO follow them
        && (!el.hasAttribute('data-top') || el.getAttribute('data-fol') === '1');
  }
  function known(id) { return !!fdone[id] || !!fstore()[id]; }
  function flashQueue(els) {
    els.forEach(function (el) { if (fq.indexOf(el) < 0) fq.push(el); });
    flashRun();
  }
  function flashArrived(els) {
    if (guest) return;
    var list = els.filter(function (el) { return flashable(el) && !known(fid(el)); });
    list.forEach(function (el) { if (el.classList.contains('mring-in')) el.__lvfDelay = FLASH_ENTER_MS; });   // after its enter animation
    if (list.length) flashQueue(list);
  }
  function flashBoot() {
    if (guest || !lgroup) return;
    var now = parseInt(lgroup.getAttribute('data-now'), 10) || 0, list = [];
    Array.prototype.forEach.call(lgroup.querySelectorAll('.mring-live'), function (el) {
      if (!flashable(el)) return;
      var id = fid(el);
      if (known(id)) return;
      var st = parseInt(el.getAttribute('data-started'), 10) || 0;
      if (now && st && now - st <= FLASH_FRESH_S) list.push(el);
      else fmark(id);                                   // already live when the page came: known, never flashed later
    });
    if (list.length) flashQueue(list);
  }
  function onArrive() {
    clearTimeout(fArrT); fArrT = null;
    if (window.scrollY <= 8) fArrT = setTimeout(flashRun, 350);   // came back to the top: once the scroll settles
  }
  function fArr(on) {
    if (on === fArrOnF) return;
    fArrOnF = on;
    if (on) window.addEventListener('scroll', onArrive, { passive: true });
    else { window.removeEventListener('scroll', onArrive); clearTimeout(fArrT); fArrT = null; }
  }
  function toHead() {
    if (track.scrollLeft <= 12 || touching) return;
    var a = document.activeElement;
    if ((a && a !== document.body && row.contains(a)) || (window.matchMedia && window.matchMedia('(hover:hover)').matches && row.matches(':hover'))) return;
    try { track.scrollTo({ left: 0, behavior: calm() ? 'auto' : 'smooth' }); } catch (e) { track.scrollLeft = 0; }
  }
  function fObserve(el) {
    if (el.__lvfObs) return;
    if (!('IntersectionObserver' in window)) { flashStart(el); return; }
    if (!fio) {
      fio = new IntersectionObserver(function (ents) {
        ents.forEach(function (en) {
          if (!en.isIntersecting || en.intersectionRatio < 0.6) return;
          fio.unobserve(en.target); en.target.__lvfObs = 0;
          flashStart(en.target);
        });
      }, { threshold: [0.6] });
    }
    el.__lvfObs = 1; fio.observe(el);
  }
  function flashRun() {
    clearTimeout(fRetryT); fRetryT = null;
    fq = fq.filter(function (el) { return flashable(el) && !fdone[fid(el)]; });
    if (!fq.length) { fArr(false); return; }
    if (document.hidden || covered()) return;          // visibilitychange / rova:pfclose run it again
    // (the "folded" branch -- un-fold through __rovaRingLiveWake, or wait for the top -- retired 2026-10-04: the ring never folds)
    fArr(false);
    toHead();
    fq.forEach(fObserve);                              // each flashes as it comes 60% into view (the glide reveals it)
  }
  function flashStart(el) {
    if (!flashable(el) || fdone[fid(el)]) { fq = fq.filter(function (x) { return x !== el; }); return; }
    if (document.hidden || covered() || row.classList.contains('mring-tucked')) return;   // stays queued; the way out re-observes it
    var id = fid(el);
    fmark(id);
    fq = fq.filter(function (x) { return x !== el; });
    var c = calm(), dur = c ? FLASH_CALM_MS : FLASH_MS, now = Date.now();
    var at = Math.max(now + (el.__lvfDelay || 0), fNextAt);
    el.__lvfDelay = 0;
    fNextAt = at + FLASH_STAGGER_MS;
    var go = function () {
      var ringEl = el.querySelector('.mring-ring');
      if (!ringEl || !el.isConnected) return;
      var g = document.createElement('i');
      g.className = 'mring-lv-flash'; g.setAttribute('aria-hidden', 'true');
      ringEl.appendChild(g);
      el.classList.add('lv-flash');
      var rec = { id: id, at: Date.now(), calm: c, ms: dur };
      flog.push(rec); if (flog.length > 40) flog.shift();
      var done = false;
      var end = function () {
        if (done) return; done = true;
        el.classList.remove('lv-flash');
        if (g.parentNode) g.parentNode.removeChild(g);
        rec.end = Date.now();
      };
      g.addEventListener('animationend', function (e) { if (e.target === g) end(); });
      setTimeout(end, c ? dur : dur + 250);            // reduced motion has no animation to end: the timer IS the end
      try { document.dispatchEvent(new CustomEvent('rova:liveflash', { detail: rec })); } catch (e) {}
    };
    if (at > now) setTimeout(go, at - now); else go();
  }
  // the ways back to a flash that is waiting: the ring is back (their own pull, our glide), the tab, the viewer, a finger
  document.addEventListener('visibilitychange', function () { if (fq.length && !document.hidden) setTimeout(flashRun, 300); });
  document.addEventListener('rova:pfclose', function () { if (fq.length) setTimeout(flashRun, 1700); });
  track.addEventListener('touchend', function () { if (fq.length) setTimeout(flashRun, 300); }, { passive: true });
  window.__rovaLiveFlash = function () {
    return { queue: fq.map(fid), done: Object.keys(fdone), store: fstore(), log: flog.slice(), waitingForTop: fArrOnF,
             k: { freshS: FLASH_FRESH_S, pulseMs: FLASH_PULSE_MS, pulses: FLASH_PULSES, calmMs: FLASH_CALM_MS, staggerMs: FLASH_STAGGER_MS } };
  };
  flashBoot();

  /* ====================================================================================================
     TOP LIVES + LIKE MILESTONES  (Rob 2026-10-12: "The media ring should show the top 3 live users and show cool heart
     burst animations once they reach certain likes: 100, 1,000, 2,000 etc.")
     ====================================================================================================
     THE CIRCLES are server-rendered (views/_ring_live.php, LiveRing::topFor): the viewer's top three lives right after Go Live
     / Me, `.mring-live.is-top[data-top=rank]`, keyed "t<id>"; the live group's re-read (liveApply above) diffs them like any
     live circle and tpPatch() keeps a kept circle's rank badge and data current.
     THE POLL: GET /live/top (LiveRing::topBody: the box-wide ranking + likes + milestone_hit; the same body for everyone, asked
     with credentials:'omit' so members share the edge copy too) every `every` s (12), ONLY while the row is on screen (one IO
     on the row), the tab is visible, nothing covers the feed (the viewer) -- and only when somebody is live (the pulse rev is
     not '0', or a top circle is drawn). Its answer:
       sig moved   -> the ranking moved: the live group re-reads (liveRead 'top'; a guest's URL carries &tsig= so the edge
                      cannot answer with the old order). One ask per new sig.
       counts      -> each live circle on the page whose id is in the body gets its "● Live · N" count patched (no request).
       likes       -> a TOP circle whose likes crossed a milestone since the last poll (or the render: data-likes) bursts for
                      the highest one crossed. On a circle's FIRST sighting (load, or arriving on a re-read) the server's
                      milestone_hit decides instead: a burst only if it was hit within fresh_s (15 s) -- "a viewer who arrives
                      just after still sees one". Once per milestone per live per tab: sessionStorage `rova:lvms` {id: m}.
     THE BURST (rova.css "TOP LIVES + THE LIKE-MILESTONE HEART BURST"): ONE pooled node (10 hearts, a gold glow ring, the chip
     "1.0k ♥" in THE count format, window.__rovaFmtCount) moved into the circle's .mring-ring and animated with WAAPI --
     transform + opacity only, ~1.6 s, removed at the end (the node is kept for the next one). Bursts queue one at a time.
     Never starts hidden, under the viewer, mid-swipe (`.mring-moving`) or off screen (waits, via one IO, until the circle is
     60% in view; dropped after 30 s); a swipe that starts DURING one pauses it until the row is still again. Reduced motion:
     no hearts, no glow, no bump -- the chip alone fades in and out.
     Receipt: window.__rovaRingTop(). Rig: window.__rovaRingBurst(id, m) plays one on demand (no storage write). */
  var TOP_URL = '/live/top';
  var tpEvery = Math.max(8, parseInt(lgroup && lgroup.getAttribute('data-top-every'), 10) || 12) * 1000;
  var msFresh = parseInt(lgroup && lgroup.getAttribute('data-ms-fresh'), 10) || 15;
  var msList = ((lgroup && lgroup.getAttribute('data-ms-list')) || '100,200,300,400,500,600,700,800,900,1000,2000,3000,4000,5000,6000,7000,8000,9000,10000,25000,50000,100000,250000,500000,1000000')   // = LiveRing::LIKE_MILESTONES (2026-10-13)
    .split(',').map(function (x) { return parseInt(x, 10) || 0; }).filter(function (x) { return x > 0; });
  var tpT = null, tpBusy = false, tpLast = 0, tpInView = false, tpWantSig = '', tpAsked = '', tpSeen = {}, tpLog = [];
  var MS_KEY = 'rova:lvms';
  function tpFmt(n) { return window.__rovaFmtCount ? window.__rovaFmtCount(n) : String(n); }
  function tops() { return lgroup ? Array.prototype.slice.call(lgroup.querySelectorAll('.mring-live[data-top]:not(.mring-out)')) : []; }
  function tpWanted() { return !!lgroup && (lrev !== '0' || tops().length > 0); }
  function tpCan() { return tpInView && !document.hidden && !covered(); }
  function tpSchedule(ms) {
    clearTimeout(tpT); tpT = null;
    if (!tpWanted() || !tpCan()) return;           // restarted by the IO / visibilitychange / pfclose / a live re-read
    tpT = setTimeout(tpPoll, Math.max(0, ms));
  }
  function tpKick() { tpSchedule(Math.max(250, tpEvery - (Date.now() - tpLast))); }
  function tpPoll() {
    tpT = null;
    if (!tpWanted() || !tpCan() || tpBusy) return;
    tpBusy = true;
    var t0 = Date.now();
    fetch(TOP_URL, { credentials: 'omit', cache: 'default' })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function (b) {
        tpBusy = false; tpLast = Date.now();
        if (b && b.every) tpEvery = Math.max(8000, Math.min(60000, b.every * 1000));
        if (b && b.fresh_s) msFresh = b.fresh_s;
        if (b && b.milestones && b.milestones.length) msList = b.milestones;
        tpApply(b || {}, Date.now() - t0);
        tpSchedule(tpEvery + Math.floor(Math.random() * 1500));
      })
      .catch(function () { tpBusy = false; tpLast = Date.now(); tpSchedule(tpEvery * 2); });
  }
  function tpViewers(el, n) {
    var st = el.querySelector('.mring-st');
    var tx = st && st.lastChild;
    if (!tx || tx.nodeType !== 3) return;
    var v = tx.nodeValue.replace(/[^\s·]+\s*$/, tpFmt(n));
    if (v !== tx.nodeValue) tx.nodeValue = v;
  }
  function tpApply(b, ms) {
    var list = b.top || [], by = {}, rec = { at: Date.now(), ms: ms, sig: b.sig, n: list.length, reread: false, fired: [] };
    list.forEach(function (e) { by[String(e.id)] = e; });
    var mine = lgroup ? (lgroup.getAttribute('data-tsig') || '') : '';
    if (typeof b.sig === 'string' && b.sig !== mine && b.sig !== tpAsked) {
      tpAsked = b.sig; tpWantSig = b.sig; rec.reread = true;
      liveRead('top');
    }
    var now = b.now || Math.floor(Date.now() / 1000);
    if (lgroup) Array.prototype.forEach.call(lgroup.querySelectorAll('.mring-live:not(.is-self):not(.mring-out)'), function (el) {
      var e = by[el.getAttribute('data-live') || ''];
      /* ONE BUBBLE PER BATTLE (2026-10-15): a battle bubble's "Battle · N watching" is BOTH lives' viewers -- patched only when
         this poll knows both (a partner outside the public ranking keeps the count the last re-read drew) */
      if (el.hasAttribute('data-live2')) {
        var e2 = by[el.getAttribute('data-live2') || ''], sn = el.querySelector('.mring-st-n');
        if (e && e2 && sn) { var bv = tpFmt((+e.viewers || 0) + (+e2.viewers || 0)); if (sn.textContent !== bv) sn.textContent = bv; }
      } else if (e) tpViewers(el, +e.viewers || 0);
      if (!e) return;
      if (el.hasAttribute('data-top')) { var m = tpLikes(el, +e.likes || 0, e.milestone_hit, now); if (m) rec.fired.push([el.getAttribute('data-live'), m]); }
    });
    tpLog.push(rec); if (tpLog.length > 40) tpLog.shift();
  }
  function crossed(a, b) { var m = 0; msList.forEach(function (x) { if (a < x && b >= x) m = x; }); return m; }
  function tpLikes(el, likes, hit, now) {
    var id = el.getAttribute('data-live') || '';
    if (!id) return 0;
    var prev = tpSeen[id], m = 0;
    tpSeen[id] = Math.max(prev || 0, likes);
    el.setAttribute('data-likes', String(likes));
    if (prev != null) m = crossed(prev, likes);
    else if (hit && hit.at && now - hit.at <= msFresh) m = +hit.likes || 0;
    return m ? burst(el, id, m) : 0;
  }
  /* A circle's FIRST sighting (the render, or arriving on a re-read): its server likes become the baseline, and a milestone the
     server saw hit within fresh_s plays once. */
  function tpAdopt(el) {
    var id = el.getAttribute('data-live') || '';
    if (!id || tpSeen[id] != null) return;
    tpSeen[id] = parseInt(el.getAttribute('data-likes'), 10) || 0;
    var now = parseInt(lgroup && lgroup.getAttribute('data-now'), 10) || 0, at = parseInt(el.getAttribute('data-ms-at'), 10) || 0,
        m = parseInt(el.getAttribute('data-ms'), 10) || 0;
    if (m && at && now && now - at <= msFresh) burst(el, id, m);
  }
  function tpPatch(el, n) {
    if (!n.hasAttribute('data-top')) return;
    ['data-top', 'data-likes', 'data-ms', 'data-ms-at', 'data-fol'].forEach(function (a) {
      var v = n.getAttribute(a);
      if (v === null) { if (el.hasAttribute(a)) el.removeAttribute(a); }
      else if (el.getAttribute(a) !== v) el.setAttribute(a, v);
    });
    var rb = el.querySelector('.mring-rank'), nb = n.querySelector('.mring-rank');
    if (rb && nb && rb.textContent !== nb.textContent) rb.textContent = nb.textContent;
    // a kept circle's server likes may be AHEAD of this page's poll memory: the next poll compares against the higher one, so a
    // milestone crossed in between still bursts (crossed(prev, likes) with prev = what this page last SAW, never the patch)
  }
  function msStore() { try { var m = JSON.parse(sessionStorage.getItem(MS_KEY) || '{}'); return (m && typeof m === 'object') ? m : {}; } catch (e) { return tpMsMem; } }
  var tpMsMem = {};
  function msSave(m) { tpMsMem = m; try { sessionStorage.setItem(MS_KEY, JSON.stringify(m)); } catch (e) {} }
  // THE BURST QUEUE
  var bq = [], bBusy = false, bT = null, bNode = null, bIo = null, bLog = [];
  var HEARTS = [   // angle (deg, -90 = up), reach, size, delay ms, colour -- the hearts fan UP and out; none passes the row's top edge
    [-90, 30, 14, 0, 0], [-60, 34, 13, 30, 1], [-120, 34, 13, 50, 2], [-30, 46, 12, 80, 0], [-150, 46, 12, 100, 1],
    [-8, 54, 11, 140, 2], [-172, 54, 11, 160, 0], [18, 50, 10, 110, 1], [162, 50, 10, 130, 2], [-75, 26, 10, 190, 1]];
  var HCOL = ['var(--live,#e5484d)', '#f5c518', '#ff7a93'];
  var HEART = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 21.2l-1.4-1.3C5.4 15.2 2 12.1 2 8.4 2 5.4 4.4 3 7.4 3c1.7 0 3.4.8 4.6 2.1C13.1 3.8 14.8 3 16.6 3 19.6 3 22 5.4 22 8.4c0 3.7-3.4 6.8-8.6 11.5L12 21.2z"/></svg>';
  function bPool() {
    if (bNode) return bNode;
    var n = document.createElement('span');
    n.className = 'mring-burst'; n.setAttribute('aria-hidden', 'true');
    var h = '<b class="mring-bglow"></b>';
    HEARTS.forEach(function (p) {
      h += '<i class="mring-bh" style="width:' + p[2] + 'px;height:' + p[2] + 'px;margin:' + (-p[2] / 2) + 'px 0 0 ' + (-p[2] / 2) + 'px;color:' + HCOL[p[4]] + '">' + HEART + '</i>';
    });
    h += '<span class="mring-bchip"><b class="mring-bchip-n"></b>' + HEART + '</span>';
    n.innerHTML = h;
    return (bNode = n);
  }
  function burst(el, id, m) {
    var st = msStore();
    if ((+st[id] || 0) >= m) return 0;
    st[id] = m; msSave(st);
    bq.push({ el: el, id: id, m: m, at: Date.now() });
    bRun();
    return m;
  }
  function bFind(q) {
    if (q.el && q.el.isConnected && !q.el.classList.contains('mring-out')) return q.el;
    return lgroup ? lgroup.querySelector('.mring-live[data-top][data-live="' + q.id + '"]:not(.mring-out)') : null;
  }
  function bWatch(el) {
    if (!('IntersectionObserver' in window)) { el.__bVis = true; return; }
    if (!bIo) bIo = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) { en.target.__bVis = en.isIntersecting && en.intersectionRatio >= 0.6; });
      if (bq.length) bRun();
    }, { threshold: [0, 0.6, 1] });
    if (!el.__bObs) { el.__bObs = 1; bIo.observe(el); }
  }
  function bRun() {
    clearTimeout(bT); bT = null;
    bq = bq.filter(function (q) { return Date.now() - q.at < 30000; });
    if (!bq.length || bBusy) return;
    if (document.hidden || covered()) return;                                 // visibilitychange / rova:pfclose run it again
    if (row.classList.contains('mring-moving')) { bT = setTimeout(bRun, 300); return; }   // never STARTS mid-swipe
    var q = bq[0], el = bFind(q);
    if (!el) { bq.shift(); bRun(); return; }
    if (el.__bVis !== true) { bWatch(el); bT = setTimeout(bRun, 1000); return; }   // waits until it is 60% in view
    bq.shift();
    bPlay(el, q.m, false);
  }
  function bPlay(el, m, rig) {
    var ring = el.querySelector('.mring-ring');
    if (!ring) { bRun(); return; }
    var n = bPool(), c = calm(), anims = [], done = false, t0 = Date.now();
    n.querySelector('.mring-bchip-n').textContent = tpFmt(m);
    n.classList.remove('mring-burst-static');
    ring.appendChild(n);
    el.classList.add('mring-bursting');
    bBusy = true;
    var chip = n.querySelector('.mring-bchip');
    var can = typeof chip.animate === 'function';
    function A(node, kf, o) { try { var a = node.animate(kf, o); anims.push(a); } catch (e) {} }
    if (!can) {
      n.classList.add('mring-burst-static');
    } else if (c) {
      A(chip, [{ opacity: 0 }, { opacity: 1, offset: 0.15 }, { opacity: 1, offset: 0.8 }, { opacity: 0 }], { duration: 1600, fill: 'both' });
    } else {
      Array.prototype.forEach.call(n.querySelectorAll('.mring-bh'), function (h, i) {
        var p = HEARTS[i], rad = p[0] * Math.PI / 180, cx = Math.cos(rad), cy = Math.sin(rad);
        var x0 = cx * 22, y0 = cy * 22, x1 = cx * p[1], y1 = cy * p[1] - 6 * Math.abs(cx), rot = (cx >= 0 ? 1 : -1) * (12 + i * 3);
        A(h, [{ transform: 'translate(' + x0 + 'px,' + y0 + 'px) scale(.5) rotate(0deg)', opacity: 0, easing: 'cubic-bezier(.2,.7,.3,1)' },
              { transform: 'translate(' + (x0 + (x1 - x0) * 0.45) + 'px,' + (y0 + (y1 - y0) * 0.45) + 'px) scale(1.05) rotate(' + (rot / 2) + 'deg)', opacity: 1, offset: 0.3, easing: 'cubic-bezier(.3,.2,.6,1)' },
              { transform: 'translate(' + x1 + 'px,' + y1 + 'px) scale(.8) rotate(' + rot + 'deg)', opacity: 0 }],
          { duration: 1050 + (i % 3) * 120, delay: p[3], fill: 'both' });   // easing per keyframe (an effect curve reaches 30% too early)
      });
      A(n.querySelector('.mring-bglow'), [{ transform: 'scale(.92)', opacity: 0 }, { transform: 'scale(1.02)', opacity: 1, offset: 0.3 }, { transform: 'scale(1.16)', opacity: 0 }],
        { duration: 750, easing: 'cubic-bezier(.4,0,.2,1)', fill: 'both' });
      A(ring, [{ scale: '1' }, { scale: '1.08', offset: 0.3 }, { scale: '1' }], { duration: 520, easing: 'cubic-bezier(.4,0,.2,1)' });
      A(chip, [{ opacity: 0, transform: 'translate(-50%,6px) scale(.6)', easing: 'cubic-bezier(.2,.7,.2,1)' }, { opacity: 1, transform: 'translate(-50%,0) scale(1.08)', offset: 0.16 },
               { opacity: 1, transform: 'translate(-50%,0) scale(1)', offset: 0.28 }, { opacity: 1, transform: 'translate(-50%,-1px) scale(1)', offset: 0.82 },
               { opacity: 0, transform: 'translate(-50%,-6px) scale(.96)' }],
        { duration: 1600, delay: 60, fill: 'both' });   // easing PER KEYFRAME (the pop): an effect-level curve would warp the offsets and fade the chip by ~550 ms
    }
    // THE SLIDE RULE: a swipe that starts during the burst holds it (WAAPI ignores animation-play-state), the rest resumes it
    var mo = null, held = false;
    function hold() {
      var mv = row.classList.contains('mring-moving');
      if (mv === held) return;
      held = mv;
      anims.forEach(function (a) { try { if (mv) a.pause(); else a.play(); } catch (e) {} });
    }
    if (anims.length && 'MutationObserver' in window) { mo = new MutationObserver(hold); mo.observe(row, { attributes: true, attributeFilter: ['class'] }); hold(); }
    var rec = { id: el.getAttribute('data-live'), m: m, label: tpFmt(m), calm: c, waapi: can, rig: !!rig, at: t0 };
    function end() {
      if (done) return; done = true;
      if (mo) mo.disconnect();
      anims.forEach(function (a) { try { a.cancel(); } catch (e) {} });
      if (n.parentNode) n.parentNode.removeChild(n);
      n.classList.remove('mring-burst-static');
      el.classList.remove('mring-bursting');
      bBusy = false;
      rec.ms = Date.now() - t0;
      bLog.push(rec); if (bLog.length > 40) bLog.shift();
      try { document.dispatchEvent(new CustomEvent('rova:ringburst', { detail: rec })); } catch (e) {}
      setTimeout(bRun, 250);
    }
    if (anims.length && window.Promise) {
      Promise.all(anims.map(function (a) { return a.finished; })).then(end, end);
      setTimeout(end, 9000);                                                    // a belt: a swipe held for ages still ends it
    } else { setTimeout(end, 1700); }
  }
  // the ways back to a waiting burst / a stopped poll
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (ents) {
      tpInView = ents.some(function (en) { return en.isIntersecting; });
      if (tpInView) tpKick(); else { clearTimeout(tpT); tpT = null; }
    }).observe(row);
  } else { tpInView = true; }
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) { clearTimeout(tpT); tpT = null; return; }
    setTimeout(function () { tpKick(); if (bq.length) bRun(); }, 300);
  });
  document.addEventListener('rova:pfclose', function () { setTimeout(function () { tpKick(); if (bq.length) bRun(); }, 1700); });
  document.addEventListener('rova:livering', function () {   // a live re-read landed: adopt arriving top circles, (re)start the poll
    tops().forEach(tpAdopt);
    if (!tpT && !tpBusy) tpKick();
  });
  tops().forEach(tpAdopt);
  window.__rovaRingTop = function () {
    return { every: tpEvery, inView: tpInView, wanted: tpWanted(), timer: !!tpT, busy: tpBusy, last: tpLast, sig: lgroup ? lgroup.getAttribute('data-tsig') : null,
             asked: tpAsked, seen: JSON.parse(JSON.stringify(tpSeen)), polls: tpLog.slice(), queue: bq.map(function (q) { return [q.id, q.m]; }),
             bursts: bLog.slice(), store: msStore(), milestones: msList.slice(), freshS: msFresh,
             tops: tops().map(function (el) { return { id: el.getAttribute('data-live'), rank: el.getAttribute('data-top'), likes: el.getAttribute('data-likes'), k: el.getAttribute('data-k') }; }) };
  };
  window.__rovaRingBurst = function (id, m) {   // rig: play one burst on a drawn top circle now (bypasses the queue's storage)
    var el = lgroup && lgroup.querySelector('.mring-live[data-live="' + id + '"]');
    if (!el || bBusy) return false;
    bPlay(el, +m || 1000, true);
    return true;
  };
  window.__rovaRingTopPoll = function () { clearTimeout(tpT); tpT = null; tpLast = 0; tpPoll(); return tpCan(); };   // rig: the next poll now

  window.__rovaRingLive = function () {
    return { rev: lrev, want: lwant, guest: guest, url: liveUrl(), dirty: ldirty, reading: lreading, reads: lreads.slice(),
             circles: lgroup ? Array.prototype.map.call(lgroup.children, function (el) {
               var th = el.querySelector('.mring-lthumb');
               return { k: el.getAttribute('data-k'), live: el.getAttribute('data-live'), out: el.classList.contains('mring-out'),
                        thumb: th ? (th.getAttribute('src') || '') : null, thumbOn: th ? th.classList.contains('on') : null };
             }) : [] };
  };

  /* Rig hooks: the proof asserts the deck the tap built, what was marked, and every re-read's reason,
     cost and diff -- not just the pixels. */
  window.__rovaRingReread = reread;
  window.__rovaRingDebug = function () {
    return { active: active, high: high, order: order.slice(), pending: pending.slice(), rev: rev, dirty: dirty, reading: reading,
             tickMs: TICK_MS, ticks: JSON.parse(JSON.stringify(ticks)), reads: reads.slice(), hidden: !!row.hidden, scrollLeft: track.scrollLeft,
             failN: failN, retryPending: !!retryT, retries: retries, failing: failing(), offline: row.classList.contains('mring-offline'),
             leaving: items().length - live().length,
             items: live().map(function (it) { return { u: it.getAttribute('data-u'), seen: it.classList.contains('seen'), ids: it.getAttribute('data-ids'), newest: it.getAttribute('data-newest'), entering: it.classList.contains('mring-in') }; }) };
  };
})();

/* LIVE STILLS' FIT (2026-10-02) -- the watch player's rule (liveWatch lwFit) for every still of a live: the /live
   directory's live frames (.lv-thumb, swapped by the block below, which calls this before each swap) and replay covers
   (.lv-rec), the guest gate's frame (.lvg-thumb), the watch sidebar's replay thumbs (.ls-th). A PORTRAIT still keeps
   cover (the cards were designed around it); a LANDSCAPE or square-ish one covers only within 1.12x of its box, else
   it stays whole (.lv-fit-contain, rova.css). Static images are decided on load (capture listener) or at once if
   already decoded. The ring's circles are discs and always cover; they are not matched. */
(function () {
  'use strict';
  function fit(im, w, h) {
    if (!im || !w || !h) return;
    var box = im.parentNode, bw = box && box.clientWidth, bh = box && box.clientHeight;
    if (!bw || !bh) return;
    var r = w / h, b = bw / bh, d = Math.max(r, b) / Math.min(r, b);
    im.classList.toggle('lv-fit-contain', !(r < 0.9 || d <= 1.12));
  }
  window.__rovaLiveThumbFit = fit;
  var SEL = '.lv-rec .lv-cover img, img.lvg-thumb, .ls-th img';
  function onLoad(e) {
    var im = e.target;
    if (im && im.tagName === 'IMG' && im.matches && im.matches(SEL)) fit(im, im.naturalWidth, im.naturalHeight);
  }
  document.addEventListener('load', onLoad, true);
  function sweep() {
    Array.prototype.forEach.call(document.querySelectorAll(SEL), function (im) {
      if (im.complete && im.naturalWidth) fit(im, im.naturalWidth, im.naturalHeight);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sweep); else sweep();
})();

/* THE GUEST GATE'S CALL, RE-TILED (2026-10-08, Rob on @Fresh's /live page as a guest on a desktop: the snapshot behind "Create an account
   to watch" was a two-person portrait call cover-cropped into the 16:9 stage -- "we can't see each person; they should be in 2 boxes").
   views/live_gate.php puts the call's geometry on the stage while one is on air (data-comp = stream.composite with tiles as {x, y, w, h}
   only: no names or photos for a guest; routes/live.php live_guest_composite). While the stage is WIDE (>= 1.05) and the snapshot is that
   PORTRAIT frame (its own aspect within 4% of the layout's: a fallback avatar / placeholder never re-tiles), each person gets a box
   (window.__rovaRetilePlan: the watch page's geometry), each an <img> crop of the SAME snapshot URL (no canvas, nothing to taint; the
   live-thumbnail module above keeps swapping the frame every 3 s and a MutationObserver follows it, each box swapped once its copy has
   decoded). Dimmed like the frame, under the sign-up card. Timing: the snapshot is grabbed from the HLS live edge, ahead of a player, so
   the call's clocks are judged against THUMB_LAG (hls_lag_ms - 5 s, >= 4 s): the boxes come once the call is surely in the snapshot,
   prev_tiles until a layout change is, and leave with the call. The page re-reads the composite (GET /live/{id}?ajax=1, the guest JSON)
   every 8 s while one is on and the tab is visible -- never on a gate without a call. A phone's gate (390 wide = a near-square stage)
   keeps the one picture. __rovaGateRetile() = { on, why, n, polls }. */
(function () {
  'use strict';
  var gate = document.getElementById('live-gate'), stage = gate && gate.querySelector('.lvg-stage[data-comp]');
  var im = stage && stage.querySelector('img.lvg-thumb');
  if (!stage || !im || stage.classList.contains('is-veiled')) return;
  var comp = null, at = Date.now();
  try { comp = JSON.parse(stage.getAttribute('data-comp') || 'null'); } catch (e) { comp = null; }
  var id = parseInt(gate.getAttribute('data-id'), 10) || 0;
  var box = null, cur = '', timer = 0, pollT = 0, polls = 0, st = { on: false, why: '', n: 0 };
  window.__rovaGateRetile = function () { return { on: st.on, why: st.why, n: st.n, polls: polls, comp: comp }; };
  function lag() { return Math.max(4000, (+(comp && comp.hls_lag_ms) || 15000) - 5000); }
  function state() {
    var c = comp, L = c && c.layout, el = Date.now() - at, g = lag();
    if (!c || (c.mode !== 'grid' && c.mode !== 'room') || !L || !L.w || !L.h || !L.tiles || !L.tiles.length) return null;   // THE GATE IN BUBBLES: rooms too
    if (c.since_ms != null) {
      var on = +c.since_ms + el; if (on < g) return { wait: g - on };
      var ts = L.tiles_since_ms != null ? +L.tiles_since_ms + el : Infinity;
      if (L.prev_tiles && L.prev_tiles.length && ts < g) return { tiles: L.prev_tiles, L: L, wait: g - ts };
      return { tiles: L.tiles, L: L };
    }
    if (c.ended_ms_ago != null) { var e = +c.ended_ms_ago + el; return e >= g ? null : { tiles: L.tiles, L: L, wait: g - e }; }
    return null;
  }
  function off(why) {
    st.on = false; st.why = why; st.n = 0;
    if (box && box.parentNode) box.parentNode.removeChild(box);
    box = null; cur = ''; stage.classList.remove('lvg-rt-on');
  }
  function paint() {
    clearTimeout(timer); timer = 0;
    var s = state();
    if (s && s.wait) timer = setTimeout(paint, Math.min(s.wait + 60, 30000));
    if (!s || !s.tiles || s.tiles.length < 2 || !window.__rovaBubblePlan) { off('solo'); return; }
    var W = +s.L.w, H = +s.L.h, nw = im.naturalWidth, nh = im.naturalHeight, src = im.getAttribute('src') || '';
    if (!src || !nw || !nh || !im.classList.contains('on')) { off('nothumb'); return; }
    if (Math.abs(nw / nh - W / H) > 0.04 * (W / H)) { off('shape'); return; }
    var bw = stage.clientWidth, bh = stage.clientHeight;
    if (!bw || !bh) { off('box'); return; }
    // THE GATE IN BUBBLES (2026-10-23, Rob: "The grid display is out"): every person a rounded bubble, the viewers' layout (8 px pad / gap), any stage shape
    var TT = s.tiles.slice(0, 7), bp = window.__rovaBubblePlan(TT.length, bw - 16, bh - 16, 8, TT.map(function (t) { return +t.w / +t.h; }));
    if (!bp) { off('plan'); return; }
    var plan = bp.map(function (b0, i0) { var t = TT[i0], k = Math.max(b0.w / t.w, b0.h / t.h); return { l: b0.l + 8, t: b0.t + 8, w: b0.w, h: b0.h, k: k, cx: t.x - (b0.w / k - t.w) / 2, cy: t.y - (b0.h / k - t.h) * 0.3 }; });
    if (!box) { box = document.createElement('div'); box.className = 'lvg-rtile'; box.setAttribute('aria-hidden', 'true'); }
    if (box.parentNode !== stage) stage.insertBefore(box, im.nextSibling);
    while (box.children.length > plan.length) box.removeChild(box.lastChild);
    for (var i = 0; i < plan.length; i++) {
      var P = plan[i], cell = box.children[i];
      if (!cell) { cell = document.createElement('span'); cell.appendChild(document.createElement('img')); box.appendChild(cell); cell.firstChild.alt = ''; }
      cell.style.cssText = 'left:' + P.l + 'px;top:' + P.t + 'px;width:' + P.w + 'px;height:' + P.h + 'px;border-radius:' + Math.round(Math.max(16, Math.min(26, Math.min(P.w, P.h) * 0.09))) + 'px';
      cell.firstChild.style.cssText = 'left:' + (-P.cx * P.k).toFixed(1) + 'px;top:' + (-P.cy * P.k).toFixed(1) + 'px;width:' + (W * P.k).toFixed(1) + 'px;height:' + (H * P.k).toFixed(1) + 'px';
    }
    swap(src);
    stage.classList.add('lvg-rt-on');
    st.on = true; st.why = ''; st.n = plan.length;
  }
  // the crops follow the frame: each copy is swapped in only once decoded (the module above preloaded it, so this is the cache)
  function swap(src) {
    if (!box || src === cur) return;
    cur = src;
    var imgs = box.querySelectorAll('img');
    Array.prototype.forEach.call(imgs, function (c) {
      if (c.getAttribute('src') === src) return;
      var pre = new Image(); pre.decoding = 'async';
      var set = function () { if (cur === src) c.src = src; };
      pre.onload = function () { if (pre.decode) pre.decode().then(set, set); else set(); };
      pre.src = src;
    });
  }
  function poll() {
    clearTimeout(pollT); pollT = 0;
    if (document.hidden || !id || !comp) return;
    polls++;
    fetch('/live/' + id + '?ajax=1', { credentials: 'same-origin', cache: 'no-store', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function (j) {
        var s = j && j.stream;
        if (!s || s.status !== 'live') { comp = null; paint(); return; }
        comp = s.composite || null; at = Date.now(); paint();
      })
      .catch(function () {})
      .then(function () { if (comp && !document.hidden) pollT = setTimeout(poll, 8000); });
  }
  if (window.MutationObserver) new MutationObserver(function () { paint(); }).observe(im, { attributes: true, attributeFilter: ['src', 'class'] });
  im.addEventListener('load', paint);   // a new src's size is known only once it has loaded
  if (window.ResizeObserver) { try { new ResizeObserver(function () { paint(); }).observe(stage); } catch (e) {} } else window.addEventListener('resize', paint);
  document.addEventListener('visibilitychange', function () { if (!document.hidden && comp && !pollT) poll(); });
  paint();
  if (comp) pollT = setTimeout(poll, 8000);
})();

/* ====================================================================================================
   LIVE THUMBNAILS + THE LIVE PULSE  (owner 2026-09-30) -- the ring's live circles and the /live directory
   ====================================================================================================
   THUMBNAILS. Every <img data-lthumb="…/live/thumb/<id>-{b}-<sig>.jpg"> shows the stream's CURRENT frame,
   refreshed every THUMB_EVERY (3) s: {b} = floor(server_now / 3), so every viewer asks for the same URL in
   the same bucket and Cloudflare's edge serves them all from one origin grab (lib/livering.php). A new frame
   is preloaded off-DOM and swapped in only once it has decoded (no blank frame, no flicker); the first one
   fades in over the broadcaster's face (.on). Only images ON SCREEN (IntersectionObserver) are refreshed,
   and nothing runs while the tab is hidden, the ring is tucked, or the full-screen viewer covers the feed.
   One timer, aligned to the bucket boundary -- no per-image timers, no per-frame work.
   THE PULSE. While a live surface is on the page (the ring's #mring-lives for members, /live's #lv-list),
   GET /live/pulse every PULSE_EVERY (6) s while visible: {rev, now}. `now` keeps the bucket clock honest
   (skew); a rev that moved fires `rova:livepulse` (the ring re-reads its live group) and re-reads the
   directory's sections (GET /live?partial=list). A thumbnail that fails twice (its stream ended: 404) asks
   the pulse at once, so an ended circle leaves within a beat rather than a poll.
   TWO 404s IN A ROW = DEAD (2026-10-08, live #866: a guest gate tab polled /live/thumb/866-* into a 404 every 3 s, and
   /live/pulse with it, for 32 minutes after the live ended -- the gate never learned the stream had ended, and a pulse
   whose rev had not moved told nobody anything). Now the snapshot STOPS (im.__lvDead), the pulse is asked once, and
   rova:livethumbdead {id, img} tells the surface that owns it to ask the server itself: the ring re-reads its live group,
   the directory its list, the gate page its stream (ended / private -> the page reloads once into its ended state).
   A snapshot the server says is still live is revived after a growing hold (__rovaLiveThumbRevive); a new snapshot URL
   (data-lthumb changed) always starts clean. The pulse only keeps beating where a live surface is on the page. */
(function () {
  'use strict';
  var doc = document;
  var group = doc.getElementById('mring-lives');
  var list = doc.getElementById('lv-list');
  /* A GUEST's media ring (Rob 2026-09-30, later): the pulse runs there even when nobody is live (no #mring-lives in
     the HTML -- a guest row with nobody live is byte-identical to before), so the first live circle can arrive. */
  var ringEl = doc.getElementById('media-ring');
  var gring = !!(ringEl && ringEl.getAttribute('data-guest') === '1' && ringEl.querySelector('.mring-track'));
  if (!group && !list && !gring && !doc.querySelector('img[data-lthumb]')) return;
  // the guest browse gate (html.guest-gated, 15 posts / 90 s) covers the feed for good: no pulse, no swaps under it
  function gated() { return !list && doc.documentElement.classList.contains('guest-gated'); }
  var rfetch = window.__rovaFetch || function (u, o) { return fetch(u, o); };
  var src0 = group || (list && list.querySelector('.lv-sections'));
  var EVERY = Math.max(2, parseInt((group && group.getAttribute('data-every')) || '3', 10) || 3);
  var PULSE = Math.max(4, parseInt((group && group.getAttribute('data-pulse')) || '6', 10) || 6);
  var skew = 0;   // server clock - client clock, seconds
  (function () { var n = parseInt(src0 && src0.getAttribute('data-now'), 10); if (n) skew = n - Date.now() / 1000; })();
  function bucket() { return Math.floor((Date.now() / 1000 + skew) / EVERY); }
  var stats = { swaps: 0, fails: 0, dead: 0, revives: 0, pulses: 0, revs: 0, listReads: 0, loopSwaps: 0, loopFails: 0, skipped: { hidden: 0, covered: 0 } };
  function surface() { return !!(group || list || gring); }   // a live surface the pulse serves (the gate page has none)
  function show(im) { refresh(im); loop(im); }   // the snapshot, then (a ring bubble with data-lloop) its moving preview

  /* A live circle swiped back INTO the ring (2026-10-12, Rob: the ring stutters swiping back toward Go Live) used to
     fetch + decode + swap its frame in the middle of the swipe (its bucket went stale while it was off screen). Now an
     arrival while the track is moving waits for the rest (__rovaRingScrollAt, the head of this file); one timer. */
  var ioLater = null;
  function ioRest() {
    var left = 300 - (Date.now() - (window.__rovaRingScrollAt || 0));
    if (left > 8) { ioLater = setTimeout(ioRest, left); return; }
    ioLater = null;
    Array.prototype.forEach.call(doc.querySelectorAll('img[data-lthumb]'), function (im) { if (im.__lvIn && !covered(im)) show(im); });
  }
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (ents) {
    ents.forEach(function (en) {
      en.target.__lvIn = en.isIntersecting;
      if (!en.isIntersecting) { loopPause(en.target); return; }   // a moving preview plays only while its bubble is on screen
      if (Date.now() - (window.__rovaRingScrollAt || 0) < 300 && en.target.closest && en.target.closest('.mring-track')) { if (!ioLater) ioLater = setTimeout(ioRest, 300); return; }
      show(en.target);
    });
  }, { rootMargin: '120px' }) : null;
  function watch() {
    Array.prototype.forEach.call(doc.querySelectorAll('img[data-lthumb]'), function (im) {
      if (im.__lvW) return;
      im.__lvW = 1;
      if (io) io.observe(im); else { im.__lvIn = true; show(im); }
    });
  }
  function covered(im) {
    if (doc.documentElement.classList.contains('pfv-on')) return true;          // the full-screen viewer is up
    if (gated()) return true;                                                   // the guest browse gate is up
    var r = im.closest && im.closest('.mring');
    return !!(r && (r.classList.contains('mring-tucked') || r.hidden));          // the ring is folded away
  }
  /* THE FRAME'S FIT (2026-10-02, the player's rule -- liveWatch lwFit -- for the stills): a PORTRAIT frame fills its
     card/gate stage (cover, as before); a LANDSCAPE or square-ish frame covers only within 1.12x of the box, else it
     stays whole (.lv-fit-contain, rova.css; the blurred face / dark stage shows round it). Decided from the decoded
     preload BEFORE the src swap, so a frame never paints in the wrong fit. The ring's circles always cover (a disc). */
  function thumbFit(im, w, h) {
    if (im.classList && im.classList.contains('mring-lthumb')) return;
    if (window.__rovaLiveThumbFit) window.__rovaLiveThumbFit(im, w, h);   // the block just above this IIFE
  }
  function refresh(im) {
    if (!im.isConnected || im.__lvBusy || doc.hidden) return;
    var tpl = im.getAttribute('data-lthumb') || '';
    if (!tpl) return;
    if (im.__lvTpl !== tpl) { im.__lvTpl = tpl; im.__lvFail = 0; im.__lvDead = 0; im.__lvHold = 0; }   // a new snapshot URL starts clean
    if (im.__lvDead || (im.__lvHold && Date.now() < im.__lvHold)) return;                              // given up on / held after a revive
    var b = bucket();
    if (im.__lvB === b) return;
    if (im.__ll && im.__ll.on && im.__lvB && b - im.__lvB < LSTILL) return;   // its moving preview is playing: the poster only every LSTILL buckets
    var url = tpl.replace('{b}', String(b));
    im.__lvBusy = 1;
    var pre = new Image();
    pre.decoding = 'async';
    pre.onload = function () {
      im.__lvBusy = 0; im.__lvB = b; im.__lvFail = 0;
      var set = function () { thumbFit(im, pre.naturalWidth, pre.naturalHeight); im.src = url; if (!im.classList.contains('on')) im.classList.add('on'); stats.swaps++; };
      if (pre.decode) { pre.decode().then(set, set); } else { set(); }
    };
    pre.onerror = function () {
      im.__lvBusy = 0; im.__lvB = b; stats.fails++;
      if (im.__lvTpl !== tpl) return;          // its URL changed while this one was in flight: that one starts clean
      im.__lvFail = (im.__lvFail || 0) + 1;
      if (im.__lvFail >= 2 && !im.__lvDead) {  // 404 twice in a row = most likely ended: stop asking, learn it now
        im.__lvDead = 1; stats.dead++;
        askNow(true);
        var m = /\/live\/thumb\/(\d+)-/.exec(tpl);
        try { doc.dispatchEvent(new CustomEvent('rova:livethumbdead', { detail: { id: m ? +m[1] : 0, img: im } })); } catch (e) {}
      }
    };
    pre.src = url;
  }
  /* MOVING PREVIEWS (2026-10-17, Rob's "option 2"; lib/liveloop.php). A ring bubble whose snapshot <img> carries data-lloop (the
     server attached `preview_loop`) plays a ~2 s muted 160 px H.264 loop of the live in a <video class="mring-lloop"> laid over the
     snapshot (rova.css: same 60 box, scale .85, a disc; absolute, so nothing moves). {v} = floor(server_now / every): every viewer in
     the same 30 s window asks for the SAME URL (one edge-cached object). The snapshot stays the poster and the fallback: the video is
     invisible until it fires 'playing', and a new version is loaded beside it and faded in on top, then the old one is dropped.
     Plays ONLY while the bubble is on screen (the IntersectionObserver above), the tab is visible, nothing covers the ring; never
     under Save-Data, a 2g/3g connection or prefers-reduced-motion (re-checked every tick: a change stops it at once), nor where
     the browser cannot play baseline H.264. Three failed versions in a row (404: no fresh clip, the live paused) = back to the
     still. While a loop plays, the snapshot refreshes once per LSTILL buckets instead of every bucket. */
  var LSTILL = 10;
  var LCAN = (function () { try { var v = doc.createElement('video'); return !!(v.canPlayType && v.canPlayType('video/mp4; codecs="avc1.42E01E"')); } catch (e) { return false; } })();
  function loopOk() {
    if (!LCAN || doc.hidden) return false;
    try {
      var c = navigator.connection;
      if (c && (c.saveData || /^(slow-2g|2g|3g)$/.test(c.effectiveType || ''))) return false;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
    } catch (e) {}
    return true;
  }
  function loopOff(im) {
    var l = im.__ll; if (!l) return;
    im.__ll = null;
    [l.el, l.nx].forEach(function (v) { if (v) { try { v.pause(); } catch (e) {} if (v.parentNode) v.parentNode.removeChild(v); } });
  }
  function loopPause(im) { var l = im && im.__ll; if (l && l.el && !l.el.paused) { try { l.el.pause(); } catch (e) {} } }
  function loop(im) {
    var tpl = im.getAttribute('data-lloop') || '', l = im.__ll;
    if (!tpl) { loopOff(im); return; }
    if (!loopOk() || !im.isConnected || !im.parentNode) { loopPause(im); return; }
    if (l && l.tpl !== tpl) { loopOff(im); l = null; }
    var v = Math.floor((Date.now() / 1000 + skew) / (parseInt(im.getAttribute('data-lloop-every'), 10) || 30));
    if (l && l.el && l.el.paused) { var pp = l.el.play(); if (pp && pp.catch) pp.catch(function () {}); }
    if (l && (l.v === v || l.nx)) return;   // this window's version is up (or loading)
    if (!l) l = im.__ll = { tpl: tpl, v: 0, el: null, nx: null, miss: 0, on: false };
    l.v = v;
    var el = doc.createElement('video'), done = false;
    el.className = 'mring-lloop';
    el.muted = true; el.defaultMuted = true; el.loop = true; el.playsInline = true; el.preload = 'auto';
    ['muted', 'playsinline', 'disablepictureinpicture', 'disableremoteplayback'].forEach(function (a) { el.setAttribute(a, ''); });
    el.setAttribute('aria-hidden', 'true');
    l.nx = el;
    var to = setTimeout(function () { fin(false); }, 8000);
    function fin(ok) {
      if (done) return; done = true; clearTimeout(to);
      el.removeEventListener('playing', onOk); el.removeEventListener('error', onNo);
      if (im.__ll !== l || l.nx !== el) { if (el.parentNode) el.parentNode.removeChild(el); return; }   // superseded meanwhile
      l.nx = null;
      if (!ok) { try { el.pause(); } catch (e) {} if (el.parentNode) el.parentNode.removeChild(el); stats.loopFails++; if (++l.miss >= 3) loopOff(im); return; }
      var old = l.el; l.el = el; l.miss = 0; l.on = true; stats.loopSwaps++;
      el.classList.add('on');
      if (old) setTimeout(function () { try { old.pause(); } catch (e) {} if (old.parentNode) old.parentNode.removeChild(old); }, 450);
    }
    function onOk() { fin(true); }
    function onNo() { fin(false); }
    el.addEventListener('playing', onOk); el.addEventListener('error', onNo);
    el.src = l.tpl.replace('{v}', String(v));
    var ref = (l.el && l.el.parentNode === im.parentNode) ? l.el : im;
    im.parentNode.insertBefore(el, ref.nextSibling);   // on top of the snapshot (and of the playing version), invisible until it plays
    var p = el.play(); if (p && p.catch) p.catch(function () { fin(false); });
  }
  var tT = null;
  function tick() {
    clearTimeout(tT); tT = null;
    if (doc.hidden) { stats.skipped.hidden++; return; }   // resumed by visibilitychange
    Array.prototype.forEach.call(doc.querySelectorAll('img[data-lthumb]'), function (im) {
      if (!im.__lvIn) { loopPause(im); return; }
      if (covered(im)) { stats.skipped.covered++; loopPause(im); return; }
      if (Date.now() - (window.__rovaRingScrollAt || 0) < 300 && im.closest && im.closest('.mring-track')) { if (!ioLater) ioLater = setTimeout(ioRest, 300); return; }   // mid-swipe: at the rest
      show(im);
    });
    var per = EVERY * 1000, now = Date.now() + skew * 1000;
    tT = setTimeout(tick, per - (now % per) + 150);   // just after the next bucket boundary
  }

  /* ---- the pulse ---- */
  var rev = (group && group.getAttribute('data-lrev')) || (list && list.querySelector('.lv-sections') && list.querySelector('.lv-sections').getAttribute('data-lrev')) || (gring ? '0' : '');
  var pT = null, pInFlight = false, lastAsk = 0;
  function pulse() {
    clearTimeout(pT); pT = null;
    if (doc.hidden) return;                                  // resumed by visibilitychange
    if (gated()) return;                                     // under the guest gate: stop for good
    if (pInFlight) return;
    pInFlight = true; lastAsk = Date.now(); stats.pulses++;
    rfetch('/live/pulse', { credentials: 'omit', cache: 'no-store' }, 6000)
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function (j) {
        if (j && j.now) skew = j.now - Date.now() / 1000;
        if (j && j.rev && j.rev !== rev) { rev = j.rev; stats.revs++; onRev(j.rev); }
      })
      .catch(function () {})
      .then(function () { pInFlight = false; if (!doc.hidden && surface()) pT = setTimeout(pulse, PULSE * 1000); });
  }
  function askNow(force) { if (force || Date.now() - lastAsk > 2000) pulse(); }
  var listReading = false;
  function onRev(v) {
    try { doc.dispatchEvent(new CustomEvent('rova:livepulse', { detail: { rev: v } })); } catch (e) {}
    listRead(v);
  }
  function listRead(v) {
    if (list && !listReading) {
      listReading = true;
      setTimeout(function () {
        /* LIVES BY PLACE (2026-10-16): #lv-list's data-lpulse names the picked place (assets/liveplaces.js rewrites it on an
           in-place pick); a read that comes back after the place changed is dropped, never painted over the new list */
        var lurl = list.getAttribute('data-lpulse') || '/live?partial=list';
        rfetch(lurl, { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', cache: 'no-store' }, 8000)
          .then(function (r) { if (!r.ok) throw r; return r.text(); })
          .then(function (html) {
            listReading = false;
            if (html.indexOf('lv-sections') < 0) return;
            if ((list.getAttribute('data-lpulse') || '/live?partial=list') !== lurl || list.classList.contains('lvp-busy')) return;
            list.innerHTML = html; stats.listReads++;
            watch();
            try { doc.dispatchEvent(new CustomEvent('rova:livelist', { detail: { rev: v } })); } catch (e) {}
          })
          .catch(function () { listReading = false; });
      }, Math.floor(Math.random() * 800));
    }
  }
  doc.addEventListener('visibilitychange', function () {
    if (doc.hidden) {
      clearTimeout(tT); tT = null; clearTimeout(pT); pT = null;
      Array.prototype.forEach.call(doc.querySelectorAll('img[data-lloop]'), loopPause);   // a hidden tab plays nothing (tick() resumes them)
      return;
    }
    tick();
    if (group || list || gring) pulse();
  });
  doc.addEventListener('rova:livering', function () { watch(); tick(); });   // the ring swapped its live group in
  /* REVIVE: the owner's server read says this live is still on -- poll its snapshot again after a hold that doubles per
     revive (15 s, 30 s, 60 s, 120 s cap), so a stream whose snapshot keeps 404ing costs a read a couple of times a minute
     at most, never a request every 3 s. */
  function revive(im) {
    if (!im || !im.__lvDead) return;
    im.__lvRevives = (im.__lvRevives || 0) + 1; stats.revives++;
    im.__lvDead = 0; im.__lvFail = 0;
    im.__lvHold = Date.now() + Math.min(120000, 15000 * Math.pow(2, im.__lvRevives - 1));
  }
  window.__rovaLiveThumbRevive = revive;
  /* THE DIRECTORY (/live): a dead card re-reads the list once the pulse has had its beat (at most once a minute per
     stream), whether or not the rev moved. */
  var listForced = {};
  /* THE GUEST GATE (/live/<id> signed out, views/live_gate.php): its one snapshot is the only live surface on the page, so
     nobody else would ever notice the end. Ask the stream itself (the gate's own JSON, GET /live/<id>?ajax=1): still
     live -> revive; ended / gone / private -> reload ONCE into the server's ended (or private) page -- no frame, the
     replay link when there is one; a second time for the same live in this tab (a stale render?) ends the page in place. */
  var gate = doc.getElementById('live-gate');
  function gateEndInPlace() {
    gate.setAttribute('data-status', 'ended');
    var stg = gate.querySelector('.lvg-stage'); if (stg) stg.classList.add('is-ended');
    Array.prototype.forEach.call(gate.querySelectorAll('img.lvg-thumb, .lv-pill, .lv-eye, .lvg-tag, .lvg-rtile'), function (x) { if (x.parentNode) x.parentNode.removeChild(x); });
    var av = gate.querySelector('.lvg-av.is-live'); if (av) { av.classList.remove('is-live'); av.classList.add('is-ended'); }
  }
  function gateCheck(im) {
    var id = parseInt(gate.getAttribute('data-id'), 10) || 0;
    if (!id) return;
    var ended = function () {
      var k = 'rova:lvg-end:' + id, once = false;
      try { once = sessionStorage.getItem(k) === '1'; if (!once) sessionStorage.setItem(k, '1'); } catch (e) { once = true; }
      if (!once) { location.reload(); return; }
      gateEndInPlace();
    };
    // rfetch REJECTS a non-2xx with err.status: 404 (ended by moderation / gone) and 403 (made private) are answers, not blips
    rfetch('/live/' + id + '?ajax=1', { credentials: 'same-origin', cache: 'no-store', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' } }, 8000)
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var st = j && j.stream && j.stream.status;
        if (!st || st === 'live') { revive(im); return; }           // still on air (or an answer we cannot read): the frame may come back
        ended();
      }, function (e) {
        var c = e && e.status;
        if (c === 403 || c === 404 || c === 410) ended(); else revive(im);   // offline / timeout / 5xx: not evidence of an end
      });
  }
  doc.addEventListener('rova:livethumbdead', function (e) {
    var im = e && e.detail && e.detail.img, id = (e && e.detail && e.detail.id) || 0;
    if (!im) return;
    if (gate && gate.contains(im)) { gateCheck(im); return; }
    if (list && list.contains(im)) {
      if (listForced[id] && Date.now() - listForced[id] < 60000) return;
      listForced[id] = Date.now();
      setTimeout(function () { if (im.isConnected) listRead(rev); }, 2500);   // the rev's list re-read (if any) went first
    }
  });
  watch();
  tick();
  if (group || list || gring) pT = setTimeout(pulse, 1500);   // first ask shortly after load (the page was rendered with a fresh rev)
  window.__rovaLiveThumbs = function () {
    return { every: EVERY, pulseEvery: PULSE, skew: skew, bucket: bucket(), rev: rev, loopOk: loopOk(), stats: JSON.parse(JSON.stringify(stats)),
             imgs: Array.prototype.map.call(doc.querySelectorAll('img[data-lthumb]'), function (im) {
               return { src: im.getAttribute('src') || '', on: im.classList.contains('on'), inView: !!im.__lvIn, b: im.__lvB || 0, fails: im.__lvFail || 0,
                        dead: !!im.__lvDead, hold: Math.max(0, (im.__lvHold || 0) - Date.now()), revives: im.__lvRevives || 0,
                        loop: im.__ll ? { v: im.__ll.v, on: im.__ll.on, miss: im.__ll.miss, loading: !!im.__ll.nx,
                                          playing: !!(im.__ll.el && !im.__ll.el.paused), src: im.__ll.el ? im.__ll.el.getAttribute('src') : null } : null };
             }) };
  };
})();

/* ---- THE DIRECTORY KIT (2026-09-28): /channels, /groups, /galleries --------------------------------
   Markup views/_dircards.php, styles rova.css "THE DIRECTORY KIT". Three small jobs, all event-driven
   (zero timers, zero per-frame work, nothing runs on a page without the markup):
     1. THE CREATE ROW. Toggle .is-open + aria-expanded. The open/closed choice is remembered per viewer
        in localStorage AND in the rova_dxcta_<kind> cookie -- the cookie is what the SERVER reads, so
        the next page renders at its final height on the first paint (CSP forbids the inline script a
        localStorage-only design would need before paint, and reading it after paint would be a layout
        shift). If the cookie is gone but storage still remembers, the cookie is restored for the NEXT
        render only; this one is never re-laid-out.
     2. RAIL ARROWS on hover-capable screens: scrollBy + two IntersectionObservers for the end states.
     3. THE STICKY CATEGORY BAR draws its edge only while stuck (one IO on a 1px sentinel).
   2026-10-03: RE-RUNNABLE. /groups now swaps its door panel in place (DOOR TABS, above), so a panel
   fetched after load carries fresh rails / a filter bar / create rows. kit(root) binds whatever under
   root is not bound yet (an __dxk flag per element), and DOOR TABS calls window.__rovaDxKit(panel)
   after each fetched swap. A KEPT panel re-attached from the door cache is already bound. */
(function () {
  'use strict';
  var doc = document;
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var touch = !!(window.matchMedia && window.matchMedia('(hover: none)').matches);
  var LS = 'rova.dxcta.';

  function writeCookie(kind, v) {
    try { doc.cookie = 'rova_dxcta_' + kind + '=' + v + '; path=/; max-age=31536000; samesite=lax; secure'; } catch (e) {}
  }
  function remember(kind, open) {
    try { localStorage.setItem(LS + kind, open ? '1' : '0'); } catch (e) {}
    writeCookie(kind, open ? '1' : '0');
  }
  function setOpen(sec, open, persist) {
    var head = sec.querySelector('.dx-cta-head');
    sec.classList.toggle('is-open', open);
    if (head) head.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (!open) sec.classList.remove('dx-tried');
    if (persist) remember(sec.getAttribute('data-dxcta') || '', open);
  }
  /* Focus the NAME field once the row has opened -- on a mouse/keyboard screen only: on a phone a
     programmatic focus throws the keyboard up over the form the member has not read yet. */
  function focusFirst(sec) {
    if (touch) return;
    var f = sec.querySelector('.dx-cta-in input[name="name"], .dx-cta-in input[name="title"], .dx-cta-in input:not([type="hidden"])');
    if (!f) return;
    setTimeout(function () { try { f.focus({ preventScroll: true }); } catch (e) {} }, reduce ? 0 : 220);
  }

  var openBound = false;
  function kit(root) {
  root = root || doc;
  var ctas = root.querySelectorAll('[data-dxcta]');
  var navs = root.querySelectorAll('[data-dxrail]');
  var filt = root.querySelector('.dx-filter');
  Array.prototype.forEach.call(ctas, function (sec) {
    if (sec.__dxk) return;
    sec.__dxk = 1;
    var kind = sec.getAttribute('data-dxcta') || '';
    var head = sec.querySelector('.dx-cta-head');
    if (!head) return;
    try {
      var ls = localStorage.getItem(LS + kind);
      if ((ls === '1' || ls === '0') && doc.cookie.indexOf('rova_dxcta_' + kind + '=') === -1) writeCookie(kind, ls);
    } catch (e) {}
    head.addEventListener('click', function () {
      var open = !sec.classList.contains('is-open');
      setOpen(sec, open, true);
      if (open) focusFirst(sec);
    });
    sec.addEventListener('click', function (e) {
      var c = e.target && e.target.closest ? e.target.closest('[data-dxcta-close]') : null;
      if (!c) return;
      e.preventDefault();
      setOpen(sec, false, true);
      try { head.focus({ preventScroll: true }); } catch (err) {}
    });
    /* The browser's own `required` check still decides; this only rings the fields it refused. */
    var form = sec.querySelector('form');
    if (form) form.addEventListener('invalid', function () { sec.classList.add('dx-tried'); }, true);
  });

  if (ctas.length && !openBound) {
    openBound = true;
    /* Any "start one" link elsewhere on the page (an empty state) opens the row in place instead of
       reloading into ?new=1 -- which is still its href, so it works with JS off. */
    doc.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('[data-dxcta-open]') : null;
      if (!b) return;
      var sec = doc.querySelector('[data-dxcta="' + b.getAttribute('data-dxcta-open') + '"]');
      if (!sec) return;
      e.preventDefault();
      setOpen(sec, true, true);
      try { sec.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); } catch (err) { sec.scrollIntoView(); }
      focusFirst(sec);
    });
  }

  Array.prototype.forEach.call(navs, function (nav) {
    if (nav.__dxk) return;
    nav.__dxk = 1;
    var rail = doc.getElementById(nav.getAttribute('data-dxrail') || '');
    if (!rail || !rail.children.length) { nav.classList.add('is-idle'); return; }
    var prev = nav.querySelector('[data-dir="-1"]');
    var next = nav.querySelector('[data-dir="1"]');
    nav.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('.dx-navb') : null;
      if (!b || b.disabled) return;
      rail.scrollBy({ left: (b.getAttribute('data-dir') === '1' ? 1 : -1) * rail.clientWidth * 0.85, behavior: reduce ? 'auto' : 'smooth' });
    });
    if (!('IntersectionObserver' in window) || !prev || !next) return;
    var first = rail.children[0];
    var last = rail.children[rail.children.length - 1];
    var io = new IntersectionObserver(function (ents) {
      for (var i = 0; i < ents.length; i++) {
        var full = ents[i].intersectionRatio >= 0.95;
        if (ents[i].target === first) prev.disabled = full;
        if (ents[i].target === last) next.disabled = full;
      }
      nav.classList.toggle('is-idle', prev.disabled && next.disabled);
    }, { root: rail, threshold: [0, 0.95] });
    io.observe(first);
    if (last !== first) io.observe(last); else next.disabled = true;
  });

  if (filt && !filt.__dxk && 'IntersectionObserver' in window) {
    filt.__dxk = 1;
    var sent = filt.previousElementSibling;
    if (sent && sent.classList.contains('dx-sentinel')) {
      var top = parseFloat(getComputedStyle(filt).top) || 65;
      new IntersectionObserver(function (ents) {
        var en = ents[0];
        filt.classList.toggle('is-stuck', !en.isIntersecting && en.boundingClientRect.top < top + 2);
      }, { rootMargin: '-' + Math.round(top + 1) + 'px 0px 0px 0px', threshold: 0 }).observe(sent);
    }
  }
  }
  window.__rovaDxKit = kit;
  kit(doc);
})();

/* ---- DETAIL HEADER PROXIES (2026-09-28): /gr, /ch, /g -----------------------------------------------
   The redesigned header (views/_dircards.php) re-uses the page's EXISTING controls instead of
   duplicating them: [data-dx-click="<sel>"] clicks the existing control (the Settings pill -> the
   .grtop-more / .chtop-more fold, Replies -> .chwinbox), so every handler, endpoint and gate stays the
   one it always was. [data-dx-focus="<sel>"] takes the member to a block on the page (the header's
   Join pill -> the sticky join card, where the questions / 18+ tick / note live) without submitting
   anything. One delegated listener, bound only when the markup is there. */
(function () {
  'use strict';
  var doc = document;
  if (!doc.querySelector('[data-dx-click], [data-dx-focus]')) return;
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var touch = !!(window.matchMedia && window.matchMedia('(hover: none)').matches);
  doc.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-dx-click], [data-dx-focus]') : null;
    if (!t) return;
    var sel = t.getAttribute('data-dx-click');
    if (sel) {
      var el = doc.querySelector(sel);
      if (!el) return;
      e.preventDefault();
      el.click();
      return;
    }
    var box = doc.querySelector(t.getAttribute('data-dx-focus') || '');
    if (!box) return;
    e.preventDefault();
    try { box.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'end' }); } catch (err) { box.scrollIntoView(false); }
    var f = touch ? box.querySelector('button[type="submit"]')
                  : (box.querySelector('input[type="text"], textarea') || box.querySelector('button[type="submit"]'));
    if (f) setTimeout(function () { try { f.focus({ preventScroll: true }); } catch (err) {} }, reduce ? 0 : 320);
  });
})();

/* ---- REDISCOVER, piece 4 (owner 2026-09-28): "More from @creator" in the full-screen viewer ---------
   GET /more-from?post=<id> answers that creator's other photos/videos (server order: the ones he has not
   genuinely viewed with little real engagement first, oldest first; views/_more_from.php), and the card
   gets a small "More from @x" chip above its caption. The strip itself stays folded until the chip is
   tapped, so nothing covers the media unasked. Empty answer = no chip. Taps inside never reach the
   viewer's own tap handler. Rides the viewer's idle fade in CSS (.pfeed.pfeed-idle .post .mf-wrap).

   ROUND 2 (Rob, same day): "Is it possible for the 'More from @username' to load in faster (meaning
   instantly with the rest of the chrome) or if not smoother/slow transition in so it's not so rapid".
   It used to wait for the ARRIVAL (rova:pfpost), then 900ms of dwell, then the request: measured on
   Playwright WebKit 390x844, the chip landed 892ms after the chrome on a grid open and 1282ms after
   the arrival on a swipe, as a hard pop. Now:
     - WARM BEFORE IT IS NEEDED. Every opener (__rovaFeedView, __rovaProfileFeed, __rovaPfJump) calls
       __rovaMfPrefetch(target) in the tap's own task, so the row is fetched while the hero is still in
       the air; and every arrival prefetches the NEXT card in the deck and mounts the row into it while
       it is still off screen, so a swipe brings the chip in WITH its card.
     - MOUNTED UNDER THE CHROME MASK. The wrap joins rova.css's pf-settling chrome list, so a row mounted
       during an open is hidden with the caption and fades in on the SAME pf-chrome-in clock -- one
       reveal, not two.
     - A LATE ROW (cold line, a card reached before its fetch returned) ENTERS instead of popping: a
       300ms fade + 8px rise (.mf-enter, transform/opacity only, one-shot, removed on animationend so
       the idle fade keeps working), none under reduced motion. It sits in a bottom-anchored column
       ABOVE the caption, so nothing below it moves.
     - Tile thumbnails are fetched and decoded when the row mounts (they were loading=lazy inside a
       hidden strip, so they only started loading on the chip tap), and the tiles stagger in (~30ms,
       capped) when the strip opens.
   Cached per post id for 5 minutes (the row is per-viewer and cheap, ~150ms server). One request in
   flight per id.

   AND A TILE TAP NO LONGER LEAVES THE PAGE (Rob: "starts the next clip muted, which is making me press
   tap for sound every time"). See __rovaPfJump in the pfeed IIFE for the cause (a full navigation lost
   WebKit's per-document audio grant). The click handler below keeps it in this document: inside the
   viewer it re-decks the open viewer at the tapped post (the post the reader came from first, then the
   whole row, so swiping back up returns there); on the /p/ page's own row (views/_more_from.php 'perma')
   it opens the viewer in place, lifted off the tile like a media-ring circle. A quoted card WITH media
   inside the viewer takes the same door. Modified clicks (new tab/window) are left to the browser. */
(function () {
  var got = {};                          // post id -> { html, at } ('' html = nothing to show)
  var busy = {};                         // post id -> [callbacks] while its request is in flight
  var TTL = 5 * 60 * 1000;
  var last = '';                         // the post the reader is on now (the latest arrival)
  var want = '';                         // the latest opener's target: mounted the moment its card exists
  var REDUCE = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  var CHEV = '<svg class="mf-chev" width="12" height="12" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 9l6 6 6-6" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  function okId(id) { return /^\d+$/.test(id); }
  function fresh(id) { var g = got[id]; return !!(g && (Date.now() - g.at) < TTL); }
  function fetchRow(id, cb) {
    if (!okId(id)) { return; }
    if (fresh(id)) { if (cb) { cb(); } return; }
    if (busy[id]) { if (cb) { busy[id].push(cb); } return; }
    busy[id] = cb ? [cb] : [];
    fetch('/more-from?post=' + id, { credentials: 'same-origin', cache: 'no-store', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (h) {
        got[id] = { html: (h || '').trim(), at: Date.now() };
        var cbs = busy[id] || []; delete busy[id];
        cbs.forEach(function (f) { try { f(); } catch (e) {} });
      })
      .catch(function () { delete busy[id]; });
  }
  function cardFor(id) { return document.querySelector('.pfeed .pfeed-list .post[data-view="' + id + '"]'); }
  // is the viewer's chrome on screen right now? (not masked by an open's settle, not faded idle)
  function chromeShown() {
    var b = document.querySelector('.pfeed.show');
    if (!b || b.classList.contains('pfeed-idle')) { return false; }
    return !(b.classList.contains('pf-settling') && !b.classList.contains('pf-chrome-in'));
  }
  function warmThumbs(strip) {
    Array.prototype.forEach.call(strip.querySelectorAll('img'), function (im) {
      try { im.loading = 'eager'; im.removeAttribute('loading'); } catch (e) {}
      try { if (im.decode) { im.decode().catch(function () {}); } } catch (e) {}
    });
  }
  /* THE ROW OPENS AND CLOSES, it does not pop (Rob 2026-09-30: "Tapping more from @user doesn't have any
     opening or closing animation, it just appears"). Measured before (Chromium 390, /p/54665): the strip was
     IN FLOW under the chip and went display:none -> block in one frame, so the chip jumped 90px up the
     bottom-anchored column; a close dropped it 90px back with the strip simply gone (only the chevron and
     a 280ms tile fade moved). Now it is iOS build 563's animation, exactly:
       - the strip is an OVERLAY floating 8px above the chip (rova.css: absolute, bottom:100%), so nothing in
         the caption stack ever moves -- no layout at all on open or close;
       - OPEN: each tile fades in and rises 10px, 260ms ease-out (cubic-bezier(0,0,.58,1)), 30ms stagger
         left to right, capped at 8 tiles (tile 8+ shares the 210ms delay); the chevron turns 180deg on the
         same 260ms ease-out (CSS);
       - CLOSE: the reverse -- 200ms ease-in (cubic-bezier(.42,0,1,1)), fading + sinking 10px from the FAR
         end back toward the chip (reverse 30ms stagger over the tiles actually on screen, same 8-tile cap),
         and the strip is hidden on the last tile's own finish, never on a timer (the timer is a backstop);
         the chevron turns back on 200ms ease-in;
       - a tap mid-flight reverses from where each tile is; reduced motion = instant.
     WAAPI, not CSS classes, so a reversal can start from the live values. */
  var MF_OPEN_MS = 260, MF_CLOSE_MS = 200, MF_STEP = 30, MF_CAP = 7, MF_RISE = 10;
  var MF_EASE_OUT = 'cubic-bezier(0,0,.58,1)', MF_EASE_IN = 'cubic-bezier(.42,0,1,1)';
  function mfTy(el) {
    var tr = getComputedStyle(el).transform, m = tr && tr.match(/^matrix\(([^)]+)\)$/);
    if (m) { var v = m[1].split(','); return parseFloat(v[5]) || 0; }
    return 0;
  }
  function mfSlide(strip, open) {
    var cells = Array.prototype.slice.call(strip.querySelectorAll('.morefrom-cell'));
    var run = strip._mfRun, now = null;
    if (run) {                           // reverse from wherever each tile is right now
      now = cells.map(function (c) { var o = parseFloat(getComputedStyle(c).opacity); return { o: o >= 0 ? o : 1, y: mfTy(c) }; });
      run.anims.forEach(function (a) { try { a.cancel(); } catch (e) {} });
      clearTimeout(run.guard); strip._mfRun = null;
    }
    if (REDUCE || !strip.animate) { strip.hidden = !open; return; }
    var anims = [], seq = { anims: anims };
    if (open) {
      var cold = strip.hidden;
      strip.hidden = false;
      cells.forEach(function (c, i) {
        var f = (now && !cold) ? now[i] : { o: 0, y: MF_RISE };
        if (f.o >= 1 && !f.y) { return; }
        anims.push(c.animate([{ opacity: f.o, transform: 'translateY(' + f.y + 'px)' }, { opacity: 1, transform: 'translateY(0px)' }],
          { duration: MF_OPEN_MS, delay: (now && !cold) ? 0 : Math.min(i, MF_CAP) * MF_STEP, easing: MF_EASE_OUT, fill: 'backwards' }));
      });
      strip._mfRun = seq;
      Promise.all(anims.map(function (a) { return a.finished; })).then(function () { if (strip._mfRun === seq) { strip._mfRun = null; } }, function () {});
      return;
    }
    if (strip.hidden) { return; }
    // the tiles on screen, left to right: the far end fades first, the tile at the chip last
    var tr = strip.querySelector('.morefrom-track') || strip, R = tr.getBoundingClientRect();
    var vis = cells.filter(function (c) { var r = c.getBoundingClientRect(); return r.right > R.left + 1 && r.left < R.right - 1; });
    var K = Math.min(Math.max(vis.length - 1, 0), MF_CAP), last = 0;
    cells.forEach(function (c, i) {
      var j = vis.indexOf(c), delay = (now || j < 0) ? 0 : (K - Math.min(j, MF_CAP)) * MF_STEP;
      var f = now ? now[i] : { o: 1, y: 0 };
      last = Math.max(last, delay);
      anims.push(c.animate([{ opacity: f.o, transform: 'translateY(' + f.y + 'px)' }, { opacity: 0, transform: 'translateY(' + MF_RISE + 'px)' }],
        { duration: MF_CLOSE_MS, delay: delay, easing: MF_EASE_IN, fill: 'both' }));
    });
    strip._mfRun = seq;
    var land = function () {
      if (strip._mfRun !== seq) { return; }
      strip._mfRun = null; clearTimeout(seq.guard);
      strip.hidden = true;               // same task as the cancel: the hide and the fill drop share a frame
      anims.forEach(function (a) { try { a.cancel(); } catch (e) {} });
    };
    Promise.all(anims.map(function (a) { return a.finished; })).then(land, function () {});
    seq.guard = setTimeout(land, last + MF_CLOSE_MS + 300);   // backstop only (a hidden tab never ticks the animation)
  }
  function mount(p, id, animate) {
    var g = got[id], html = g && g.html;
    if (!html || !p || !p.isConnected || p.querySelector('.mf-wrap') || p.classList.contains('pf-end')) { return; }
    var main = p.querySelector('.post-main'); if (!main) { return; }
    var tmp = document.createElement('div'); tmp.innerHTML = html;
    var strip = tmp.querySelector('.morefrom'); if (!strip) { return; }
    var who = strip.getAttribute('data-u') || '';
    var wrap = document.createElement('div'); wrap.className = 'mf-wrap';
    var chip = document.createElement('button'); chip.type = 'button'; chip.className = 'mf-chip';
    chip.setAttribute('aria-expanded', 'false');
    var sid = 'mf-' + id; strip.id = sid; chip.setAttribute('aria-controls', sid);
    var lab = document.createElement('span'); lab.textContent = 'More from @' + who;
    chip.appendChild(lab); chip.insertAdjacentHTML('beforeend', CHEV);
    strip.hidden = true;
    wrap.appendChild(chip); wrap.appendChild(strip);
    ['click', 'pointerdown', 'touchstart', 'dblclick'].forEach(function (t) {
      wrap.addEventListener(t, function (e) { e.stopPropagation(); }, { passive: true });
    });
    chip.addEventListener('click', function (e) {
      e.preventDefault();
      var open = chip.getAttribute('aria-expanded') !== 'true';
      chip.setAttribute('aria-expanded', open ? 'true' : 'false');
      mfSlide(strip, open);
    });
    // a LATE row enters (fade + rise); one mounted under the open's chrome mask, or off screen in the
    // next card, just appears with its chrome
    if (animate && !REDUCE && chromeShown()) {
      wrap.classList.add('mf-enter');
      var done = function (e) { if (e && e.target !== wrap) { return; } wrap.classList.remove('mf-enter'); wrap.removeEventListener('animationend', done); };
      wrap.addEventListener('animationend', done);
      setTimeout(done, 700);
    }
    /* THE CHIP HEADS THE CAPTION STACK, ALWAYS (2026-10-02, Rob on /p/45306: 'More from is overlapping the
       album'). It used to go in before .body and fall back to the END of .post-main when there was no
       caption -- and a post whose whole caption is a link has none (the URL is lifted out into its card).
       Appended last, the wrap (order 0) sat BELOW the order-0 link card, so the strip, which opens upward
       as an overlay (bottom:100%), opened straight over the card. Every in-flow child of the stack is
       order >= 0 and every one that precedes .body in the DOM is absolute (.post-head), so DOM-first =
       the top of the stack on every post: with a caption this is exactly where it always was; without
       one the strip now opens over the media, above the card / music player / trip / gallery pill. */
    main.insertBefore(wrap, main.firstChild);
    warmThumbs(strip);
  }
  // mount the opener's target as soon as BOTH its row and its card exist (the card may land after the row)
  function mountWant(id) {
    var tries = 0;
    (function go() {
      if (want !== id && last !== id) { return; }
      var p = cardFor(id);
      if (p) { mount(p, id, true); return; }
      if (++tries < 40) { setTimeout(go, 100); }
    })();
  }
  window.__rovaMfPrefetch = function (id) {
    id = String(id || '');
    if (!okId(id)) { return; }
    want = id;
    fetchRow(id, function () { mountWant(id); });
  };
  document.addEventListener('rova:pfeedready', function () { if (want && fresh(want)) { var p = cardFor(want); if (p) { mount(p, want, true); } } });
  document.addEventListener('rova:pfclose', function () { want = ''; last = ''; });
  function nextCard(p) {
    var n = p.nextElementSibling;
    while (n && !(n.classList && n.classList.contains('post') && n.getAttribute('data-view'))) { n = n.nextElementSibling; }
    return n;
  }
  document.addEventListener('rova:pfpost', function (e) {
    var d = (e && e.detail) || {};
    var p = d.post, id = String(d.id || '');
    if (!p || !okId(id) || p.classList.contains('pf-end')) { return; }
    last = id;
    if (fresh(id)) { mount(p, id, true); }
    else {
      // the cold path (the neighbour prefetch below normally got here first): a short dwell so a fast
      // swipe past does not spend a request on every card it crosses
      setTimeout(function () {
        if (last !== id) { return; }
        fetchRow(id, function () { if (last === id) { mount(cardFor(id) || p, id, true); } });
      }, 200);
    }
    // THE NEXT CARD, fetched and mounted while it is still below the fold, so it arrives with its row.
    // Re-read by id each try: an open parks the rest of the deck and places it a card per frame, so the
    // neighbour may not exist yet at the first look (WebKit, measured), and the arrival's node can be
    // replaced by then.
    var tries = 0;
    (function nextSoon() {
      setTimeout(function () {
        if (last !== id) { return; }
        var here = cardFor(id), nx = here ? nextCard(here) : null;
        var nid = nx ? String(nx.getAttribute('data-view') || '') : '';
        if (!okId(nid)) { if (++tries < 8) { nextSoon(); } return; }
        if (nx.classList.contains('pf-end')) { return; }
        fetchRow(nid, function () { var c = cardFor(nid); if (c) { mount(c, nid, last === nid); } });
      }, tries ? 400 : 450);
    })();
  });
  // the tile / quoted-card tap: stay in this document (see the note above)
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) { return; }
    var t = e.target && e.target.closest ? e.target : null; if (!t) { return; }
    var a = t.closest('a.morefrom-cell[data-id]');
    var q = a ? null : t.closest('.pfeed a.quoted[href]');
    if (!a && !q) { return; }
    var id = '', ids = [];
    if (a) {
      id = String(a.getAttribute('data-id') || '');
      var row = a.closest('.morefrom');
      if (row) { Array.prototype.forEach.call(row.querySelectorAll('.morefrom-cell[data-id]'), function (c) { ids.push(String(c.getAttribute('data-id') || '')); }); }
    } else {
      if (!q.querySelector('.quoted-media img, .quoted-media video')) { return; }   // text-only quote: the permalink is the right door
      var qm = (q.getAttribute('href') || '').match(/^\/p\/(\d+)(?:[#?]|$)/);
      id = qm ? qm[1] : '';
      ids = [id];
    }
    if (!okId(id)) { return; }
    var inViewer = !!t.closest('.pfeed');
    if (inViewer) {
      var from = t.closest('.post[data-view]'), fromId = from ? String(from.getAttribute('data-view') || '') : '';
      if (okId(fromId) && fromId !== id) { ids.unshift(fromId); }
      if (window.__rovaPfJump && window.__rovaPfJump(ids, id)) { e.preventDefault(); e.stopPropagation(); }
      return;
    }
    // the /p/ page's own row, viewer closed: open it here, lifted off the tile
    if (!window.__rovaFeedView || document.querySelector('.pfeed.show')) { return; }
    e.preventDefault();
    var img = a && a.querySelector('img');
    try {
      if (img && img.complete && img.naturalWidth > 0 && window.__rovaHeroExpand) {
        window.__rovaHeroExpand(img.getBoundingClientRect(), img.currentSrc || img.src, null, img);
      }
    } catch (e2) {}
    window.__rovaFeedView(ids.length ? ids : [id], id, 0, 0);
  }, true);
})();

/* ==== SAVED PAGE (/saved, 2026-09-29) -- BEGIN ======================================================
   Markup views/saved.php, styles rova.css "SAVED PAGE". The media covers open the immersive viewer
   through the grid tap handler's [data-svd-deck] branch (not here). This block does two small,
   event-driven jobs and nothing else (no timers, no per-frame work, returns at once on any other page):
     1. THE FILTER CHIPS (All / Photos / Videos / Posts / Music). Each chip is a real ?show= link the
        server honours, so it works with JS off; with JS it filters in place (a class per card) and
        rewrites the URL with replaceState, keeping ?app= and anything else in the query.
     2. THE ONE-TAP UNSAVE + UNDO. Optimistic, and every write is an END STATE (`saved=0|1` on
        POST /bookmark), never the legacy toggle, so a double tap or a quick Undo cannot land the
        wrong way round. Taps while a write is in flight only move the WANTED state; the sender
        converges on it one request at a time and rolls the card back if the network fails.
        Counts in the hero and on the chips follow the cards. */
(function () {
  'use strict';
  var doc = document;
  var grid = doc.getElementById('svd-grid');
  if (!grid) return;
  var items = Array.prototype.slice.call(grid.querySelectorAll('.svd-item'));
  var chips = Array.prototype.slice.call(doc.querySelectorAll('[data-svd-show]'));
  var S = {
    unsave: grid.getAttribute('data-s-unsave') || 'Remove from saved',
    resave: grid.getAttribute('data-s-resave') || 'Save again',
    fail: grid.getAttribute('data-s-fail') || 'Couldn’t update saved. Check your connection.'
  };

  function kindsOf(it) { return ' ' + (it.getAttribute('data-k') || '') + ' '; }
  // the house count rule (memory count-format-rule): exact to 999, then 1.0k / 12.3k / 1.0m
  function fc(n) {
    n = Math.max(0, Math.floor(n));
    if (n < 1000) return String(n);
    var units = ['k', 'm', 'b'], div = 100, u = 0, t;
    for (;;) {
      t = Math.floor((n + div / 2) / div);
      if (t < 10000 || u === units.length - 1) break;
      div *= 1000; u++;
    }
    return Math.floor(t / 10) + '.' + (t % 10) + units[u];
  }
  function recount() {
    var n = { all: 0, photo: 0, video: 0, text: 0, music: 0 };
    items.forEach(function (it) {
      if (it.classList.contains('is-removed')) return;
      n.all++;
      var k = kindsOf(it);
      ['photo', 'video', 'text', 'music'].forEach(function (x) { if (k.indexOf(' ' + x + ' ') >= 0) n[x]++; });
    });
    Array.prototype.forEach.call(doc.querySelectorAll('[data-svd-n]'), function (el) {
      var key = el.getAttribute('data-svd-n');
      if (Object.prototype.hasOwnProperty.call(n, key)) el.textContent = fc(n[key]);
    });
  }

  /* ---- 1. filter ---- */
  function show(kind) {
    items.forEach(function (it) {
      it.classList.toggle('svd-off', kind !== 'all' && kindsOf(it).indexOf(' ' + kind + ' ') < 0);
    });
    chips.forEach(function (c) {
      var on = c.getAttribute('data-svd-show') === kind;
      c.classList.toggle('on', on);
      if (on) c.setAttribute('aria-current', 'true'); else c.removeAttribute('aria-current');
    });
    try {
      var u = new URL(location.href);
      if (kind === 'all') u.searchParams.delete('show'); else u.searchParams.set('show', kind);
      history.replaceState(history.state, '', u.pathname + u.search + u.hash);
    } catch (e) {}
  }
  chips.forEach(function (c) {
    c.addEventListener('click', function (e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button > 0) return;   // new tab: let the link work
      e.preventDefault();
      show(c.getAttribute('data-svd-show') || 'all');
    });
  });

  /* ---- 2. unsave / undo ---- */
  function paint(it, removed) {
    it.classList.toggle('is-removed', removed);
    var b = it.querySelector('.svd-unsave');
    if (b) {
      b.setAttribute('aria-pressed', removed ? 'false' : 'true');
      b.setAttribute('aria-label', removed ? S.resave : S.unsave);
      b.setAttribute('title', removed ? S.resave : S.unsave);
    }
    var g = it.querySelector('.svd-gone');
    if (g) g.hidden = !removed;
    recount();
  }
  function post(id, saved) {
    var C = window.__rovaCsrf;
    var send = function (tok) {
      return fetch('/bookmark', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-CSRF-Token': tok || '',
                   'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
        body: 'post_id=' + encodeURIComponent(id) + '&saved=' + (saved ? '1' : '0') + '&_csrf=' + encodeURIComponent(tok || '')
      });
    };
    var p = (C && C.send) ? C.send(send) : send((doc.querySelector('meta[name="csrf-token"]') || {}).content || '');
    return p.then(function (r) { return r && r.ok ? r.json() : null; })
      .then(function (d) { return !!(d && typeof d.saved !== 'undefined' && !!d.saved === saved); });
  }
  function pump(it) {
    if (it._svdBusy) return;
    var want = !it.classList.contains('is-removed');   // saved?
    if (want === it._svdSaved) return;
    it._svdBusy = true;
    var btn = it.querySelector('.svd-unsave');
    post(btn ? btn.getAttribute('data-id') : '', want).then(function (ok) {
      it._svdBusy = false;
      if (ok) { it._svdSaved = want; pump(it); return; }
      fail(it);
    }, function () { it._svdBusy = false; fail(it); });
  }
  function fail(it) {
    paint(it, !it._svdSaved);   // back to what the server last confirmed
    // say so on the card itself, in its "Saved 3d ago" line, for a few seconds
    var w = it.querySelector('.svd-when');
    if (!w) return;
    if (w._svdWas == null) w._svdWas = w.textContent;
    w.textContent = S.fail;
    w.classList.add('svd-err');
    clearTimeout(w._svdT);
    w._svdT = setTimeout(function () { w.textContent = w._svdWas; w._svdWas = null; w.classList.remove('svd-err'); }, 4000);
  }
  items.forEach(function (it) { it._svdSaved = true; });
  grid.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('.svd-unsave, .svd-undo') : null;
    if (!b || !grid.contains(b)) return;
    e.preventDefault();
    e.stopPropagation();
    var it = b.closest('.svd-item');
    if (!it) return;
    var removing = b.classList.contains('svd-unsave') ? !it.classList.contains('is-removed') : false;
    paint(it, removing);
    if (removing) { var u = it.querySelector('.svd-undo'); if (u) { try { u.focus({ preventScroll: true }); } catch (err) {} } }
    else { try { it.querySelector('.svd-unsave').focus({ preventScroll: true }); } catch (err) {} }
    pump(it);
  });
})();
/* ==== SAVED PAGE -- END ============================================================================ */

/* ==== GOLD: CONVERT CARATS TO GOLD (2026-10-03, db/0224) =============================================
   The /gold "Convert to Gold" sheet (views/gold.php #gd-convert, a native popover). Keeps the number input and the slider
   in step, fills the 25% / 50% / Max presets and the live "N Carats -> N Gold" line. The form posts as is without JS. */
(function () {
  var f = document.querySelector('form.gd-cvf');
  if (!f) return;
  var rate = +f.getAttribute('data-rate') || 2, min = +f.getAttribute('data-min') || 0, max = +f.getAttribute('data-max') || 0;
  var num = f.querySelector('.gd-cv-in'), rng = f.querySelector('.gd-cv-range'), out = f.querySelector('.gd-cv-out output');
  var fmt = function (n) { try { return n.toLocaleString('en-US'); } catch (e) { return String(n); } };
  function set(v, from) {
    v = Math.floor(+v || 0);
    if (from !== 'num') { v = Math.max(min, Math.min(max, v)); num.value = v; }
    if (from !== 'rng') { rng.value = Math.max(min, Math.min(max, v)); }
    var ok = v >= min && v <= max;
    out.textContent = ok ? fmt(v * rate) + ' Carats → ' + fmt(v) + ' Gold' : 'Choose ' + fmt(min) + ' to ' + fmt(max) + ' Gold';
  }
  num.addEventListener('input', function () { set(num.value, 'num'); });
  rng.addEventListener('input', function () { set(rng.value, 'rng'); });
  Array.prototype.forEach.call(f.querySelectorAll('.gd-cv-pre button'), function (b) {
    b.addEventListener('click', function () { set(Math.max(min, Math.floor(max * (+b.getAttribute('data-p') || 100) / 100)), 'pre'); });
  });
  f.addEventListener('submit', function () { var s = f.querySelector('button[type=submit]'); if (s) { s.disabled = true; s.textContent = 'Converting…'; } });
  set(num.value, 'pre');
})();
/* ==== GOLD CONVERT -- END ============================================================================ */

/* ==== FOUNDERS INVITE BAR: the x (2026-10-05, views/_founders_invite_bar.php) ========================
   Hides the bar for THIS BROWSER SESSION only: a session cookie (no expiry) that views/feed.php reads,
   so a reload keeps it hidden and a new browser session shows it again. The invite itself stays stored
   server-side and still applies at signup/login -- this is purely the banner. For a guest the generic
   "browsing as a guest" bar was rendered hidden beside it, so it takes the slot back with no reload. */
(function () {
  document.addEventListener('click', function (e) {
    var x = e.target && e.target.closest ? e.target.closest('.js-finv-x') : null;
    if (!x) return;
    e.preventDefault();
    try {
      document.cookie = 'rova_finv_x=1; path=/; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : '');
    } catch (_) {}
    var bar = x.closest('.finv');
    if (!bar) return;
    var next = bar.nextElementSibling;
    if (next && next.classList.contains('guest-bar') && next.hasAttribute('hidden')) next.removeAttribute('hidden');
    bar.parentNode && bar.parentNode.removeChild(bar);
  });
})();

/* MATURE LIVES (db/0294, 2026-10-16, lib/livemod.php): "Mature content, tap to view". The server draws `.mature-gate` +
   `.mature-veil.js-mature-reveal` on a mature live's watch stage (views/live_watch.php) and on its replay card
   (views/_post.php) for a viewer who is not the host / a follower / staff (guests always). ONE tap lifts it: in the CAPTURE
   phase, before the card's own tap handlers (the viewer flight, the grid) can treat the tap as "open", and before liveWatch's
   sound gesture (registered later on the same node), which then turns the sound on in the same tap. Remembered for this tab
   (sessionStorage), so a reload or the pfeed viewer re-render does not ask twice. window.__rovaMatureGate(el, key) = put the
   gate on mid-live (liveWatch's poll: stream.viewer_gate); returns true when it did. */
(function () {
  var SS = 'rova:mature:ok';
  function seen() { try { return JSON.parse(sessionStorage.getItem(SS) || '{}') || {}; } catch (e) { return {}; } }
  function remember(k) { if (!k) return; try { var o = seen(); o[k] = 1; sessionStorage.setItem(SS, JSON.stringify(o)); } catch (e) {} }
  function keyOf(box) {
    var lw = box.closest('#live-watch'); if (lw) return 'live:' + (lw.getAttribute('data-id') || '');
    var card = box.closest('[data-id]'); return card ? 'post:' + card.getAttribute('data-id') : '';
  }
  function lift(box) {
    if (!box) return;
    box.classList.remove('mature-gate');
    var v = box.querySelector(':scope > .mature-veil'); if (v) v.remove();
  }
  // a gate the reader already passed in this tab never comes back (reload, a re-rendered card)
  function sweep(root) {
    var ok = seen();
    (root || document).querySelectorAll('.mature-gate').forEach(function (b) { var k = keyOf(b); if (k && ok[k]) lift(b); });
  }
  // the observer exists only once this tab has passed a gate (nothing to re-lift before that), and coalesces to one sweep per frame
  var mo = null, moQ = false;
  function watch() {
    if (mo || !Object.keys(seen()).length) return;
    try {
      mo = new MutationObserver(function () { if (moQ) return; moQ = true; requestAnimationFrame(function () { moQ = false; sweep(); }); });
      mo.observe(document.body || document.documentElement, { childList: true, subtree: true });
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { sweep(); watch(); }); else { sweep(); watch(); }
  function onTap(e) {
    var t = e.target && e.target.closest ? e.target.closest('.js-mature-reveal') : null;
    if (!t) return;
    if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
    var box = t.closest('.mature-gate');
    e.preventDefault(); e.stopPropagation();
    remember(box ? keyOf(box) : '');
    lift(box);
    watch();
    // a replay card: start its video now that it may be watched (muted autoplay rules unchanged)
    var vid = box && box.querySelector('video');
    if (vid && vid.paused && !box.closest('#live-watch')) { try { var p = vid.play(); if (p && p.catch) p.catch(function () {}); } catch (x) {} }
  }
  document.addEventListener('click', onTap, true);
  document.addEventListener('keydown', onTap, true);
  window.__rovaMatureGate = function (box, key) {
    if (!box || box.classList.contains('mature-gate') || (key && seen()[key])) return false;
    box.classList.add('mature-gate');
    var d = document.createElement('div');
    d.className = 'mature-veil js-mature-reveal'; d.setAttribute('role', 'button'); d.setAttribute('tabindex', '0');
    d.setAttribute('aria-label', 'Mature content. Tap to view');
    d.innerHTML = '<strong>Mature content</strong><span class="mature-veil-sub">This live may show smoking, drinking or strong language.</span><span class="mature-veil-btn">Tap to view</span>';
    box.appendChild(d);
    return true;
  };
})();

/* ---- CO-AUTHOR PICKER (2026-10-22 WS-J, @cognac: "I can't @ ppl in post, it doesn't load the people and won't let me save it").
   The co-author fields (#collab-with in the composer, .pe-cin in the edit sheet) were bare text boxes: no people list, so members
   typed guesses (@yohann, @djmikeluie -- real handle djmikeluie_mv) or several names at once, and the save 422'd ("No member named
   @yohann @djmikeluie."). Now typing shows matching members from the search typeahead (GET /search, JSON); picking one fills
   "@handle". One co-author per post: a second name gets a note. The server still enforces mutual follows + one co-author. */
(function () {
  var SEL = '#collab-with, .pe-cin';
  var seq = 0, timer = 0, box = null, cur = null, items = [], hi = -1;
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function tokens(v) { return String(v || '').trim().split(/[\s,]+/).filter(Boolean); }
  function hide() { if (box) { box.hidden = true; box.innerHTML = ''; } items = []; hi = -1; if (cur) { cur.setAttribute('aria-expanded', 'false'); } }
  function ensure(inp) {
    // never re-parent the input (moving a focused field blurs it mid-typing): the list hangs off the field's own parent
    var host = inp.parentNode;
    if (!inp.__collabOn) {
      inp.__collabOn = true;
      if (getComputedStyle(host).position === 'static') { host.style.position = 'relative'; }
      inp.setAttribute('role', 'combobox'); inp.setAttribute('aria-autocomplete', 'list'); inp.setAttribute('aria-expanded', 'false');
    }
    if (!box) {
      box = document.createElement('div');
      box.className = 'trip-sugg collab-sugg'; box.setAttribute('role', 'listbox'); box.hidden = true;
      box.addEventListener('pointerdown', function (e) { e.preventDefault(); });   // keep the input focused
      box.addEventListener('click', function (e) {
        var b = e.target.closest ? e.target.closest('[data-u]') : null;
        if (b) { pick(b.getAttribute('data-u')); }
      });
    }
    if (box.parentNode !== host || box.previousSibling !== inp) { host.insertBefore(box, inp.nextSibling); }
    box.style.top = (inp.offsetTop + inp.offsetHeight + 4) + 'px';
    cur = inp;
  }
  function pick(u) {
    if (!cur || !u) { return; }
    cur.value = '@' + u;
    try { cur.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
    hide(); cur.focus();
  }
  function paint(list, many) {
    items = list; hi = list.length ? 0 : -1;
    var h = many ? '<div class="trip-sugg-item" style="cursor:default;color:var(--muted);font-size:12.5px">One co-author per post. Pick one person.</div>' : '';
    h += list.map(function (u, i) {
      var av = u.avatar ? '<img src="' + esc(u.avatar) + '" alt="" width="28" height="28" style="width:28px;height:28px;border-radius:50%;object-fit:cover;flex:0 0 auto">'
                        : '<span style="width:28px;height:28px;border-radius:50%;flex:0 0 auto;display:inline-flex;align-items:center;justify-content:center;background:var(--panel-2);font-weight:700">' + esc(u.initial || '?') + '</span>';
      return '<button type="button" role="option" class="trip-sugg-item' + (i === 0 ? ' on' : '') + '" data-u="' + esc(u.username) + '" style="align-items:center;justify-content:flex-start">' + av +
        '<span class="trip-sugg-name"><b>' + esc(u.display_name || u.username) + '</b> <span style="color:var(--muted)">@' + esc(u.username) + '</span></span></button>';
    }).join('');
    if (!h) { hide(); return; }
    box.style.top = (cur.offsetTop + cur.offsetHeight + 4) + 'px';
    box.innerHTML = h; box.hidden = false; cur.setAttribute('aria-expanded', 'true');
  }
  function lookup(inp) {
    var t = tokens(inp.value), many = t.length > 1;
    var q = (t.length ? t[t.length - 1] : '').replace(/^@+/, '');
    if (q.length < 2) { if (many) { paint([], true); } else { hide(); } return; }
    var my = ++seq;
    fetch('/search?q=' + encodeURIComponent(q), { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (my !== seq || cur !== inp || document.activeElement !== inp) { return; }
        paint(((j && j.users) || []).slice(0, 6), many);
      })
      .catch(function () {});
  }
  document.addEventListener('input', function (e) {
    var inp = e.target; if (!inp || !inp.matches || !inp.matches(SEL)) { return; }
    ensure(inp); clearTimeout(timer); timer = setTimeout(function () { lookup(inp); }, 180);
  }, true);
  document.addEventListener('keydown', function (e) {
    var inp = e.target; if (!inp || !inp.matches || !inp.matches(SEL) || !box || box.hidden || cur !== inp) { return; }
    var opts = box.querySelectorAll('[data-u]');
    if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); hide(); return; }
    if (!opts.length) { return; }
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault(); hi = (hi + (e.key === 'ArrowDown' ? 1 : -1) + opts.length) % opts.length;
      Array.prototype.forEach.call(opts, function (o, i) { o.classList.toggle('on', i === hi); });
    } else if (e.key === 'Enter' && hi >= 0 && opts[hi]) { e.preventDefault(); pick(opts[hi].getAttribute('data-u')); }
  }, true);
  document.addEventListener('focusout', function (e) {
    if (e.target === cur) { setTimeout(function () { if (cur && document.activeElement !== cur) { hide(); } }, 150); }
  }, true);
  window.__rovaCollabPick = { lookup: function (inp) { ensure(inp); lookup(inp); }, hide: hide };
})();

/* NAME WORD CHECK (Rob 2026-10-22, lib/namecheck.php): as-you-type check of a handle / display name against
   GET /api/v1/name-check, so the field turns red with "That username isn't allowed. Try another." (or "That name isn't
   allowed. Try another.") before submit. Wired by data-namecheck="username|name" (views/signup.php, views/settings.php);
   data-namecheck-current = the value the member already has (never flagged). Only the WORD verdict paints here: format,
   taken and the rest stay the submit's job exactly as before. Advice only, the server refuses on submit regardless. */
(function () {
  var SEL = 'input[data-namecheck]', T = {}, SEQ = {};
  function box(inp) {
    var b = inp.parentNode ? inp.parentNode.querySelector('[data-nc-msg]') : null;
    if (!b && inp.parentNode) {
      if (!inp.id) { inp.id = 'nc' + Math.random().toString(36).slice(2, 8); }
      b = document.createElement('div');
      b.className = 'flash err field-err';
      b.setAttribute('data-nc-msg', '');
      b.setAttribute('role', 'status');
      b.id = inp.id + '-nc';
      b.hidden = true;
      inp.parentNode.insertBefore(b, inp.nextSibling);
      var d = inp.getAttribute('aria-describedby') || '';
      if (d.split(/\s+/).indexOf(b.id) < 0) { inp.setAttribute('aria-describedby', (d + ' ' + b.id).replace(/^\s+/, '')); }
    }
    return b;
  }
  function paint(inp, msg) {
    var b = box(inp); if (!b) { return; }
    if (msg) {
      b.textContent = msg; b.hidden = false;
      inp.setAttribute('aria-invalid', 'true'); inp.setAttribute('data-nc-bad', '1');
    } else {
      b.textContent = ''; b.hidden = true;
      if (inp.getAttribute('data-nc-bad')) { inp.removeAttribute('aria-invalid'); inp.removeAttribute('data-nc-bad'); }
    }
  }
  function check(inp) {
    var kind = inp.getAttribute('data-namecheck') === 'username' ? 'username' : 'name';
    var v = String(inp.value || '').trim();
    if (kind === 'username') { v = v.replace(/^@+/, ''); }
    var cur = inp.getAttribute('data-namecheck-current');
    cur = cur === null ? null : String(cur).trim();
    if (v === '' || (cur !== null && (kind === 'username' ? v.toLowerCase() === cur.toLowerCase() : v === cur))
        || (kind === 'username' && !/^[A-Za-z0-9_]{3,30}$/.test(v))) { paint(inp, ''); return; }
    var k = inp.id || inp.name || kind, my = (SEQ[k] = (SEQ[k] || 0) + 1);
    var q = (kind === 'username' ? 'username=' : 'display_name=') + encodeURIComponent(v);
    fetch('/api/v1/name-check?' + q, { credentials: 'omit', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j || SEQ[k] !== my) { return; }
        var h = kind === 'username' ? j.username : j.display_name;
        paint(inp, (h && h.allowed === false) ? String(h.message || '') : '');
      })
      .catch(function () {});
  }
  document.addEventListener('input', function (e) {
    var inp = e.target; if (!inp || !inp.matches || !inp.matches(SEL)) { return; }
    var k = inp.id || inp.name || 'nc'; clearTimeout(T[k]);
    T[k] = setTimeout(function () { check(inp); }, 400);
  }, true);
})();

/* ADMIN GHOST WATCH, THE ROUND BUTTON (2026-10-22, Rob item 9; the app's 885 design): the live header's ghost is an icon-only round button
   (views/live_watch.php .lw-ghost, livechat.css). A tap posts the form (on/off, back to this live); a HOLD (550 ms) opens the full ghost
   options (GET /me/ghost); the label says the state for screen readers. Admins only (the server draws it for nobody else). */
(function () {
  var t = 0, held = false, sx = 0, sy = 0;
  function lab() { var bs = document.querySelectorAll('.lw-ghost'); for (var i = 0; i < bs.length; i++) { var on = bs[i].classList.contains('on'); bs[i].setAttribute('aria-label', on ? 'Ghost watch on. Tap to turn off, hold for options' : 'Ghost watch off. Tap to watch unseen, hold for options'); } }
  function clr() { if (t) { clearTimeout(t); t = 0; } }
  function up() { clr(); var bs = document.querySelectorAll('.lw-ghost.is-press'); for (var i = 0; i < bs.length; i++) bs[i].classList.remove('is-press'); }
  document.addEventListener('pointerdown', function (e) {
    var b = e.target && e.target.closest && e.target.closest('.lw-ghost'); if (!b || (e.button && e.button !== 0)) return;
    held = false; sx = e.clientX; sy = e.clientY; clr(); b.classList.add('is-press');
    t = setTimeout(function () { t = 0; held = true; b.classList.remove('is-press'); try { if (navigator.vibrate) navigator.vibrate(12); } catch (x) {} location.href = '/me/ghost'; }, 550);
  }, true);
  document.addEventListener('pointerup', up, true); document.addEventListener('pointercancel', up, true);
  document.addEventListener('pointermove', function (e) { if (t && (Math.abs(e.clientX - sx) > 10 || Math.abs(e.clientY - sy) > 10)) up(); }, true);
  document.addEventListener('click', function (e) { if (held && e.target && e.target.closest && e.target.closest('.lw-ghost')) { e.preventDefault(); e.stopPropagation(); held = false; } }, true);
  document.addEventListener('contextmenu', function (e) { if (e.target && e.target.closest && e.target.closest('.lw-ghost')) e.preventDefault(); }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', lab); else lab();
})();

/* THE HOST'S ACTION ROW, REACHABLE (2026-10-23, URGENT -- Rob on phone Safari, his OBS studio live "Las Vegas": the row under the
   picture (Fan Club, Share, Globe, Guests, Games, Court, ...) ran off the card's right edge and could not be scrolled: "can't move the
   menu to end the live or choose other options"). The HOST's own bar (.lw-ctl holding #lw-end: /live/studio, /live/browser, their own
   /live/{id}) now WRAPS onto as many rows as it needs (rova.css), End stream is a solid red button that always shows (the row's end on
   its own line on a phone), and a "More" button opens a sheet listing EVERY option in the row with its label (a tap = that button).
   The sheet: scrim / X / Escape / Back close it. Debug: window.__rovaHostMore. */
(function () {
  'use strict';
  var tries = 0;
  function labelOf(b) {
    var t = (b.getAttribute('aria-label') || b.getAttribute('title') || b.textContent || '').replace(/\s+/g, ' ').trim();
    t = t.split(/: | — | - /)[0].trim();   // 'Games: trivia, ratings, ...' -> 'Games' (the sheet row's own label)
    return t.length > 32 ? t.slice(0, 30) + '…' : t;
  }
  function items(ctl) {
    var out = [];
    [].forEach.call(ctl.querySelectorAll('button, a.btn, a.cbtn'), function (b) {
      if (b.id === 'lw-end' || b.classList.contains('lw-more') || b.hidden || b.disabled) return;
      if (b.closest('[hidden]')) return;
      var cs = getComputedStyle(b); if (cs.display === 'none' || cs.visibility === 'hidden') return;
      var l = labelOf(b); if (!l) return;
      out.push({ b: b, l: l, ic: b.querySelector('svg') ? b.querySelector('svg').outerHTML : '' });
    });
    return out;
  }
  var sheet = null, scrim = null, lastFocus = null, pushed = false;
  function close(fromPop) {
    if (!sheet) return;
    var s = sheet, k = scrim; sheet = null; scrim = null;
    s.classList.remove('in'); if (k) k.classList.remove('in');
    setTimeout(function () { if (s.parentNode) s.parentNode.removeChild(s); if (k && k.parentNode) k.parentNode.removeChild(k); }, 220);
    document.removeEventListener('keydown', onKey, true);
    if (pushed && !fromPop) { pushed = false; try { if (history.state && history.state.rovaHostMore) history.back(); } catch (e) {} }
    pushed = false;
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }
  function onKey(e) { if (e.key === 'Escape') { e.preventDefault(); close(); } }
  window.addEventListener('popstate', function () { if (sheet) close(true); });
  function open(ctl, btn) {
    if (sheet) { close(); return; }
    lastFocus = btn;
    var list = items(ctl), end = document.getElementById('lw-end');
    scrim = document.createElement('div'); scrim.className = 'lw-more-scrim';
    sheet = document.createElement('div'); sheet.className = 'lw-more-sheet'; sheet.setAttribute('role', 'dialog'); sheet.setAttribute('aria-label', 'Live options'); sheet.tabIndex = -1;
    var h = '<div class="lw-more-head"><strong>Live options</strong><button type="button" class="lw-more-x" aria-label="Close"><svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg></button></div><div class="lw-more-list">';
    list.forEach(function (it, i) { h += '<button type="button" class="lw-more-it" data-i="' + i + '"><span class="lw-more-ic" aria-hidden="true">' + it.ic + '</span><span class="lw-more-l"></span></button>'; });
    h += '</div>' + (end ? '<button type="button" class="lw-more-end">' + (end.textContent || 'End stream').trim() + '</button>' : '');
    sheet.innerHTML = h;
    [].forEach.call(sheet.querySelectorAll('.lw-more-it'), function (el, i) { el.querySelector('.lw-more-l').textContent = list[i].l; });
    document.body.appendChild(scrim); document.body.appendChild(sheet);
    scrim.addEventListener('click', function () { close(); });
    sheet.querySelector('.lw-more-x').addEventListener('click', function () { close(); });
    sheet.addEventListener('click', function (e) {
      var it = e.target.closest('.lw-more-it'), en = e.target.closest('.lw-more-end');
      if (it) { var b = list[+it.getAttribute('data-i')].b; close(); setTimeout(function () { try { b.click(); } catch (x) {} }, 30); }
      else if (en && end) { close(); setTimeout(function () { end.click(); }, 30); }
    });
    // a swipe down closes it (a phone's sheet)
    var y0 = null; sheet.addEventListener('touchstart', function (e) { y0 = sheet.scrollTop <= 0 && e.touches.length === 1 ? e.touches[0].clientY : null; }, { passive: true });
    sheet.addEventListener('touchend', function (e) { if (y0 != null && e.changedTouches[0].clientY - y0 > 80) close(); y0 = null; });
    document.addEventListener('keydown', onKey, true);
    try { history.pushState({ rovaHostMore: 1 }, '', location.href); pushed = true; } catch (e) { pushed = false; }
    requestAnimationFrame(function () { requestAnimationFrame(function () { if (sheet) { sheet.classList.add('in'); scrim.classList.add('in'); try { sheet.focus({ preventScroll: true }); } catch (e) {} } }); });
    window.__rovaHostMore.open = true; window.__rovaHostMore.items = list.map(function (x) { return x.l; });
  }
  function setup() {
    var end = document.getElementById('lw-end'), ctl = end && end.closest('.lw-ctl');
    if (!ctl) { if (++tries < 40) setTimeout(setup, 500); return; }
    if (ctl.querySelector('.lw-more')) return;
    ctl.classList.add('lw-ctl-host');
    var m = document.createElement('button'); m.type = 'button'; m.className = 'btn sm lw-more'; m.setAttribute('aria-haspopup', 'dialog'); m.setAttribute('aria-label', 'More live options');
    m.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><circle cx="5" cy="12" r="2" fill="currentColor"/><circle cx="12" cy="12" r="2" fill="currentColor"/><circle cx="19" cy="12" r="2" fill="currentColor"/></svg><span>More</span>';
    m.addEventListener('click', function () { open(ctl, m); });
    ctl.insertBefore(m, end);
    // the row's other buttons arrive later (Fan Club, Games, Court, Tools ...): More stays right before End stream
    // (2026-10-23 HANG FIX: liverealtime.js askPlace keeps its Requests chip .lrt-askwrap right before End stream with its own observer; two
    //  observers each wanting "right before End stream" moved their buttons back and forth forever = the host page froze. More now sits
    //  right before that chip when it is there, so both are satisfied and neither moves again.)
    try { new MutationObserver(function () {
      if (m.parentNode !== ctl || end.parentNode !== ctl) return;
      var at = end; while (at.previousElementSibling && at.previousElementSibling !== m && at.previousElementSibling.classList.contains('lrt-askwrap')) at = at.previousElementSibling;
      if (m.nextElementSibling !== at) ctl.insertBefore(m, at);
    }).observe(ctl, { childList: true }); } catch (e) {}
    window.__rovaHostMore = { ready: true, open: false, items: null, close: function () { close(); } };
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
})();

/* ONE HEADER ROW (2026-10-23, Rob, the app's rule on the web too): in the BUBBLE stage the host's own bubble carries their name pill (a tap
   = their card, Follow there), so the stage's host chip is a duplicate and stays hidden (rova.css .lw-bub-hpill; the chip shows only when
   the host has no bubble of their own), and the likes pill moves UP into the top row right after Gold (8 px gap) instead of a second row
   under it -- whenever it fits before the LIVE / viewers group on that row (else it keeps the row under, 8 px gap). .lw-row1 + --lw-lkx /
   --lw-lky on the stage (rova.css). Debug: window.__rovaRow1. */
(function () {
  'use strict';
  var st = null, ro = null, mo = null, raf = 0;
  function vis(e) { return !!e && !e.hidden && e.offsetParent !== null && e.offsetWidth > 0; }
  function place() {
    raf = 0; if (!st || !st.isConnected) return;
    var g = st.querySelector(':scope > .lc-gtotal'), l = st.querySelector(':scope > .lc-likes'), tl = st.querySelector(':scope > .lw-tl');
    var bub = st.classList.contains('lw-bub-on') && (st.classList.contains('lw-bub-hdin') || st.classList.contains('lw-bub-hpill'));
    var ok = false, x = 0, y = 0;
    if (bub && vis(g) && vis(l)) {
      x = g.offsetLeft + g.offsetWidth + 8; y = g.offsetTop;
      var lim = st.clientWidth - 12;
      if (vis(tl) && Math.abs(tl.offsetTop - y) < 24 && tl.offsetLeft > g.offsetLeft) lim = tl.offsetLeft - 8;
      ok = x + l.offsetWidth <= lim;
    }
    if (ok) { st.style.setProperty('--lw-lkx', x + 'px'); st.style.setProperty('--lw-lky', y + 'px'); }
    if (st.classList.contains('lw-row1') !== ok) st.classList.toggle('lw-row1', ok);
    window.__rovaRow1 = { on: ok, x: x, y: y };
  }
  function kick() { if (!raf) raf = requestAnimationFrame(place); }
  function setup(n) {
    st = document.getElementById('live-stage'); if (!st || !document.getElementById('live-watch')) { if ((n || 0) < 20) setTimeout(function () { setup((n || 0) + 1); }, 500); return; }
    try { ro = new ResizeObserver(kick); ro.observe(st); } catch (e) {}
    try { mo = new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) { var t = ms[i].target; if (t === st || (t.classList && (t.classList.contains('lc-gtotal') || t.classList.contains('lc-likes') || t.classList.contains('lw-tl')))) { kick(); return; } }
      }).observe(st, { attributes: true, attributeFilter: ['class', 'hidden'], subtree: true, childList: true, characterData: false }); } catch (e) {}
    setInterval(kick, 2000);   // a pill's number grows (120 -> 1.2k): its width; cheap (no layout unless the row is shown)
    kick();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setup(0); }); else setup(0);
})();

/* THE TITLE GETS PRIORITY (2026-10-23, Rob on a narrow window: "MAKEUP TUTORIAL !!" squeezed to "MAKEUP TUTORI..." by Share / Report / Seats /
   Mod tools). The live card's footer row (.lw-bar: the title + .lw-ctl) on every page (viewer, the host's own, a seated guest), re-decided on
   every size change and whenever a button arrives: (1) all on one row as before when the title fits (never cut); (2) else the text buttons
   go icon-only (Seats = the hand, Mod tools / Tools = the sliders, More = the dots; aria-label + tooltip keep the words) = .lw-bar-ico;
   (3) still cut = the title takes its own full-width line (2 lines at most, balanced) and the buttons the row under it, right-aligned, with
   their words back = .lw-bar-wrap. A title still cut after that (very long) = a tap opens it whole. Debug: window.__rovaTitleFit. */
(function () {
  'use strict';
  var TXT = '.lw-ctl > :is(.lx-modbtn,.lt-btn,.lw-more)';
  function cut(t) { return !!t && (t.scrollHeight > t.clientHeight + 1 || t.scrollWidth > t.clientWidth + 1); }
  function over(bar, ctl) {   // a button past the card's edge (the row could not hold them)
    var br = bar.getBoundingClientRect(), pr = parseFloat(getComputedStyle(bar).paddingRight) || 0, lim = br.right - pr + 1;
    return [].some.call(ctl.children, function (b) { return b.offsetParent && b.getBoundingClientRect().right > lim; });
  }
  function words(bar, on) {
    [].forEach.call(bar.querySelectorAll(TXT), function (b) {
      var s = [].filter.call(b.querySelectorAll(':scope > span'), function (x) { return x.getAttribute('aria-hidden') !== 'true'; })[0], w = s ? s.textContent.trim() : '';
      if (on && w) { if (!b.getAttribute('aria-label')) { b.setAttribute('aria-label', w); b.__rovaTfA = 1; } if (!b.title) { b.title = w; b.__rovaTfT = 1; } }
      if (!on) { if (b.__rovaTfA) { b.removeAttribute('aria-label'); b.__rovaTfA = 0; } if (b.__rovaTfT) { b.removeAttribute('title'); b.__rovaTfT = 0; } }
    });
  }
  function fit(bar) {
    var au = bar.querySelector(':scope > .lw-author'), ctl = bar.querySelector(':scope > .lw-ctl'), ti = au && au.querySelector('.lw-title');
    if (!au || !ctl || !ti || !ti.textContent.trim()) { bar.classList.remove('lw-bar-ico', 'lw-bar-wrap'); return 'none'; }
    var st = 'one';
    bar.classList.remove('lw-bar-ico', 'lw-bar-wrap'); words(bar, false);
    if (cut(ti) || over(bar, ctl)) { st = 'ico'; bar.classList.add('lw-bar-ico'); words(bar, true); }
    if (cut(ti) || over(bar, ctl)) { st = 'wrap'; bar.classList.remove('lw-bar-ico'); words(bar, false); bar.classList.add('lw-bar-wrap'); }
    var still = cut(ti); ti.classList.toggle('lw-title-cut', still);
    if (still) { ti.setAttribute('role', 'button'); ti.tabIndex = 0; ti.setAttribute('aria-label', 'Title: ' + ti.textContent.trim() + '. Show it all'); }
    else if (ti.getAttribute('role') === 'button') { ti.removeAttribute('role'); ti.removeAttribute('tabindex'); ti.removeAttribute('aria-label'); }
    window.__rovaTitleFit = { state: st, cut: still, w: bar.clientWidth };
    return st;
  }
  function sheet(text) {
    var k = document.createElement('div'); k.className = 'lw-more-scrim';
    var s = document.createElement('div'); s.className = 'lw-more-sheet'; s.setAttribute('role', 'dialog'); s.setAttribute('aria-label', 'Live title'); s.tabIndex = -1;
    s.innerHTML = '<div class="lw-more-head"><strong>This live</strong><button type="button" class="lw-more-x" aria-label="Close"><svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg></button></div><p class="lw-title-full"></p>';
    s.querySelector('.lw-title-full').textContent = text;
    document.body.appendChild(k); document.body.appendChild(s);
    function close() { s.classList.remove('in'); k.classList.remove('in'); document.removeEventListener('keydown', esc, true); setTimeout(function () { if (s.parentNode) s.parentNode.removeChild(s); if (k.parentNode) k.parentNode.removeChild(k); }, 220); }
    function esc(e) { if (e.key === 'Escape') { e.preventDefault(); close(); } }
    k.addEventListener('click', close); s.querySelector('.lw-more-x').addEventListener('click', close); document.addEventListener('keydown', esc, true);
    requestAnimationFrame(function () { requestAnimationFrame(function () { s.classList.add('in'); k.classList.add('in'); try { s.focus({ preventScroll: true }); } catch (e) {} }); });
  }
  function setup(n) {
    var bars = document.querySelectorAll('.live-watch .lw-bar');
    if (!bars.length) { if ((n || 0) < 20) setTimeout(function () { setup((n || 0) + 1); }, 500); return; }
    [].forEach.call(bars, function (bar) {
      if (bar.__rovaTf) return; bar.__rovaTf = 1;
      var raf = 0, kick = function () { if (!raf) raf = requestAnimationFrame(function () { raf = 0; fit(bar); }); };
      try { new ResizeObserver(kick).observe(bar); } catch (e) { window.addEventListener('resize', kick); }
      var ctl = bar.querySelector(':scope > .lw-ctl'); if (ctl) { try { new MutationObserver(kick).observe(ctl, { childList: true, subtree: true, characterData: true }); } catch (e) {} }
      bar.addEventListener('click', function (e) { var t = e.target.closest && e.target.closest('.lw-title.lw-title-cut'); if (t) { e.preventDefault(); e.stopPropagation(); sheet(t.textContent.trim()); } }, true);
      bar.addEventListener('keydown', function (e) { var t = e.target.closest && e.target.closest('.lw-title.lw-title-cut'); if (t && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); sheet(t.textContent.trim()); } });
      kick();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setup(0); }); else setup(0);
})();

/* ONE BOTTOM ROW (2026-10-23): the gifts' row at the stage's bottom-right (.gs-bottom: the quick-gift chip + the gift button) -> its width on the
   stage as --lw-gsw, kept current as the chip comes and goes / its count grows, so the bottom-band composer always ends 8 px before it. */
(function () {
  'use strict';
  function setup(n) {
    var st = document.getElementById('live-stage'), gb = st && st.querySelector('.gs-bottom');
    if (!gb) { if ((n || 0) < 40) setTimeout(function () { setup((n || 0) + 1); }, 500); return; }
    var put = function () {
      var vis = [].filter.call(gb.children, function (e) { return !e.hidden && e.offsetWidth > 0; }), w = 0;
      if (vis.length) { var r0 = vis[0].getBoundingClientRect(), r1 = vis[vis.length - 1].getBoundingClientRect(); w = Math.round(r1.right - r0.left); }
      var v = w + 'px'; if (st.__lwGsw !== v) { st.__lwGsw = v; st.style.setProperty('--lw-gsw', v); }
    };
    try { new ResizeObserver(put).observe(gb); } catch (e) {}
    try { new MutationObserver(put).observe(gb, { attributes: true, subtree: true, attributeFilter: ['hidden', 'class'], childList: true, characterData: true }); } catch (e) {}
    put();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setup(0); }); else setup(0);
})();

/* THE PHOTO CARD = THE APP'S (2026-10-23, the fallback test: the name sat over the bottom of the ring). A bubble showing its photo card
   (camera off / away / frozen / connecting / audio: .lw-bub without .is-live) shows ring -> status chip -> NAME in one centred column, scaled
   to the bubble (rova.css), and that person's bottom-left name pill steps aside while it does (.lw-cchip-card), so the name is never twice. */
(function () {
  'use strict';
  var st = null, raf = 0;
  function sync() {
    raf = 0; if (!st) return;
    [].forEach.call(st.querySelectorAll('.lw-bub[data-u]'), function (b) {
      var u = b.getAttribute('data-u'), card = !b.classList.contains('is-live') && !b.classList.contains('is-leave');
      [].forEach.call(st.querySelectorAll('.lw-cchip[data-uid="' + u + '"]'), function (p) { if (p.classList.contains('lw-cchip-card') !== card) p.classList.toggle('lw-cchip-card', card); });
    });
  }
  function kick() { if (!raf) raf = requestAnimationFrame(sync); }
  function setup(n) {
    st = document.getElementById('live-stage'); if (!st || !document.getElementById('live-watch')) { if ((n || 0) < 20) setTimeout(function () { setup((n || 0) + 1); }, 500); return; }
    try { new MutationObserver(function (ms) { for (var i = 0; i < ms.length; i++) { var t = ms[i].target; if (ms[i].type === 'childList' || (t.classList && (t.classList.contains('lw-bub') || t.classList.contains('lw-cchips')))) { kick(); return; } } })
      .observe(st, { subtree: true, attributes: true, attributeFilter: ['class'], childList: true }); } catch (e) {}
    kick();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setup(0); }); else setup(0);
})();
